import React__default__default__default__default, { useRef, useState, createElement, useEffect, Fragment as Fragment$2 } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import isEqual from 'lodash/isEqual';
import keyBy from 'lodash/keyBy';
import _, { isNull, isNaN as isNaN$1 } from 'lodash';
import { TextField as TextField$1, Box, IconButton as IconButton$1, FormHelperText as FormHelperText$1, FormControl as FormControl$1, FormLabel, RadioGroup, FormControlLabel as FormControlLabel$1, Radio } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Button$2 from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import Divider from '@material-ui/core/Divider';
import NativeSelect from '@material-ui/core/NativeSelect';
import withStyles$1 from '@material-ui/core/styles/withStyles';
import MenuItem from '@material-ui/core/MenuItem';
import RootRef from '@material-ui/core/RootRef';
import i18n from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TablePagination from '@material-ui/core/TablePagination';
import { FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage } from '@material-ui/icons';
import ChartsEmbedSDK from '@mongodb-js/charts-embed-dom';
import DatePicker, { registerLocale } from 'react-datepicker';
import { endOfDay, sub, startOfYear, startOfMonth, endOfMonth, startOfISOWeek, endOfISOWeek, startOfDay, lightFormat, isToday, isYesterday } from 'date-fns';
import es$2$1$1$1$1 from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import Typography from '@material-ui/core/Typography';
import icon$2 from './icon~NTcFjzip.svg';
import clearIcon from './close~HPDVQtfM.svg';
import loader from './loader~iUbjUwPu.svg';

var IRPF = "IRPF";
var IVA = "IVA";
var NIF = "NIF";
var betweenMinAndMaxKilometers = "Entre {{min}} y {{max}} kilómetros";
var metricUnits = {
	u: "km",
	up: "kms",
	U: "Km",
	Up: "Kms",
	unit: "kilómetro",
	units: "kilómetros",
	Unit: "Kilómetro",
	Units: "Kilómetros",
	unitSpecialCase1: "Kms",
	unitSpecialCase2: "KM",
	ad: "el",
	adp: "los",
	uFranquise: "km franquicia",
	UpFranquise: "Kms franquicia",
	maxUnits: "Kilómetros max.",
	betweenMinAndMaxunits: "Entre {{min}} y {{max}} kilómetros",
	km: "km",
	kms: "kms",
	kilometer: "Kilómetro",
	maxKilometers: "Kilómetros max.",
	"rates-concepts": {
		km: "Tarifa por km"
	},
	searchTools: "nothing"
};
var imperialUnits = {
	u: "mi",
	up: "mi",
	U: "Mi",
	Up: "Mi",
	unit: "milla",
	units: "millas",
	Unit: "Milla",
	Units: "Millas",
	unitSpecialCase1: "Millas",
	unitSpecialCase2: "MILLA",
	ad: "la",
	adp: "las",
	uFranquise: "mi franquicia",
	UpFranquise: "Mi franquicia",
	maxUnits: "Millas max.",
	betweenMinAndMaxunits: "Entre {{min}} y {{max}} millas",
	"rates-concepts": {
		km: "Tarifa por milla"
	},
	searchTools: "nothing",
	providerEditRateHeaderText: "Completa la información de las millas de la franquicia, las geocercas y las tarifas por medio, de cada depósito."
};
var A = "A";
var accept = "Aceptar";
var accepted = "Aceptado";
var acceptUpdate = "Aceptar actualización";
var accessToTheViews = "Acceso a las vistas";
var accessWithMicrosoft = "Acceder con Microsoft";
var activateGuardMode = "Activar modo guardia";
var activateGuardModeWarningText = "¿Seguro que deseas activar el modo guardia?";
var activateGuardModeWarningAditionalText = "Al hacerlo, pasarás a operar como un proveedor automático y las compañías enviarán los servicios directamente a los recursos.";
var active = "Activo";
var activity = "Actividad";
var accumulateNightAndHolidaySurcharge = "Acumular recargo nocturno y festivo";
var add = "Añadir";
var addAuxService = "Añadir servicio auxiliar";
var addCapability = "Añadir prestación";
var addCollective = "Añadir colectivo";
var addCost = "Añadir costo";
var addCostType = "Añadir tipo de costo";
var addedCollective = "Colectivo añadido";
var addFault = "Añadir avería";
var addedFault = "Avería añadida";
var additionalInformation = "Información adicional";
var additionalPrice = "Precio adicionales";
var additionalPriceAbbrev = "Precio resto";
var addNote = "Añadir nota";
var address = "Dirección";
var addressNotLocated = "Dirección no localizada";
var addUserProfile = "Añadir perfil de usuario";
var admin = "Administrador";
var advancedConfiguration = "Configuración avanzada";
var aheadServices = "Servicios por delante";
var alert = "Alerta";
var alerts = "Alertas";
var alertStart = "Inicio alerta";
var all_f = "Todas";
var all_m = "Todos";
var allowAccess = "Permitir acceso";
var allowCalls = "Permite llamadas";
var allowCalls_addService = "Permitir llamadas";
var allowGuardErrorTitle = "No se puede activar el Modo guardia";
var allowGuardErrorText = "No se puede si hay servicios pendientes de aceptación o asignación.";
var allowSMS = "Permite SMS";
var allProvidersAutomatic = "Todos los proveedores (Automático)";
var anErrorHasOccurred = "Ha ocurrido un error";
var applyCosts = "Aplicar gastos";
var approve = "Aprobar";
var assign = "Asignar";
var assignTechnician = "Asignar técnico";
var assistance = "Asistencia";
var assistanceWithoutTransfer = "Asistencia sin traslado";
var assistanceWithoutTransferWarning = "No has seleccionado ningún traslado.";
var assistanceWithoutTransferWarningQuestion = "¿Deseas continuar con el servicio de asistencia, sin traslado a personas?";
var assisted = "Asistido";
var assistedInsuredAbbrev = "Asistido/Aseg.";
var assistedDestinationAddress = "Dirección de destino del asistido";
var associatedDocuments = "Documentos asociados";
var at_time = "a las {{time}} h";
var assigned = "Agendado";
var ASSIGNED = "Agendado";
var attachADocument = "Adjuntar un documento";
var attachment = "Adjuntar";
var attachments = "Adjuntos";
var auction = "Subastar";
var auctionConfiguration = "Configuración subastas";
var auctioned = "En subasta";
var AUCTIONED = "En subasta";
var auctioning = "En subasta";
var AUCTIONING = "En subasta";
var auctionInPriority = "En subasta";
var auctionInPriority1 = "Subasta en prioridad 1";
var auctionInPriority2 = "Subasta en prioridad 2";
var auctionInPriority3 = "Subasta en prioridad 3";
var auctionInPriority4 = "Subasta en prioridad Global";
var auctions = "Subastas";
var auctionService = "Subastar servicio";
var auto = "Vehículo";
var automatic = "Automático";
var automaticProvider = "Proveedor automático";
var auxiliary = "Auxiliar";
var auxiliarySettings = "Ajustes de auxiliares";
var auxiliaries = "Auxiliares";
var auxiliariesRates = "Tarifas auxiliares";
var auxServiceList = {
	auxServiceWithCount: "{{count}} Servicio auxiliar",
	auxServiceWithCount_plural: "{{count}} Servicios auxiliares"
};
var auxService = "Servicio auxiliar";
var auxServices = "Servicios auxiliares";
var available = "Disponible";
var available_plural = "Disponibles";
var availableProvidersAbbrev = "Prov. disponibles";
var availableResources = "Recursos disponibles";
var availableResourcesWithCount = "{{count}} Recurso disponible";
var availableResourcesWithCount_plural = "{{count}} Recursos disponibles";
var average = "Tipo medio";
var averageRating = "Valoración media";
var B = "B";
var base = "Base";
var baseAmount = "Importe base";
var billed = "Facturada";
var billing = "Facturación";
var brand = "Marca";
var browse = "Examinar";
var budgetWarningNoBaseFound = "Este proveedor no tiene configurada una base. Se ha utilizado la ubicación del recurso para calcular la tarifa.";
var businessIntelligence = "Business Intelligence";
var byAmount = "Por precio";
var byBrand = "Por marca";
var byPositionOnQueue = "Por posición en espera";
var byScore = "por puntuación";
var byTime = "Por tiempo";
var C = "C";
var calculateAllServicesAsSuburban = "Calcular todos los servicios como carreteros";
var calendar = {
	today: "Hoy",
	yesterday: "Ayer",
	thisWeek: "Esta semana",
	last7Days: "Últimos 7 días",
	pastWeek: "Semana pasada",
	thisMonth: "Este mes",
	last30Days: "Últimos 30 días",
	pastMonth: "Mes pasado",
	thisYear: "Este año",
	lastYear: "Último año"
};
var cancel = "Cancelar";
var cancel_2 = "Anular";
var outputCancellationPercentageAbbrev = "% Salida anulado";
var cancelAmount = "Importe anulación";
var cancelRatePercentage = "% Salida anulación";
var cancelRateAmount = "Importe anulación";
var cancelReason = "Motivo de anulación";
var cancelService = "Anular servicio";
var cancelServiceFinished = "Anular servicio finalizado";
var cancelTransferPeople = "Anular traslado";
var cancelTransferPeopleWarning = "En función del estado de ejecución, anular el traslado podría conllevar gastos. ¿Desea continuar?";
var capabilityList = {
	capabilityWithCount: "{{count}} Prestación",
	capabilityWithCount_plural: "{{count}} Prestaciones"
};
var capability = "Prestación";
var capabilityCollectiveAbbrev = "Prestación/Colec.";
var capabilities = "Prestaciones";
var center = "Centro";
var centerName = "Nombre del centro";
var centerNotFound = "No se ha encontrado el centro";
var change = "Cambiar";
var changePassword = "Cambiar contraseña";
var charge = "Cargo";
var chargeWithCount = "{{count}} Cargo";
var chargeWithCount_plural = "{{count}} Cargos";
var check = "Revisar";
var childProfile = "Perfil hijo";
var chosenDriver = "Conductor elegido";
var cif = "CIF";
var city = "Ciudad";
var clone = "Clonar";
var cloneService = "Clonar servicio";
var close = "Cerrar";
var closeDispute = "Cerrar disputa";
var code = "Código";
var collectDate = "Fecha de cobro";
var collected = "Cobrada";
var collectInvoice = "Cobrar factura";
var collective = "Colectivo";
var collectives = "Colectivos";
var collectiveWithCount = "{{count}} Colectivo";
var collectiveWithCount_plural = "{{count}} Colectivos";
var collectiveProviderAbbrev = "Colectivo/Prov.";
var comment = "Comentario";
var commentAboutCapability = "Comentario sobre prestación";
var companies = "Compañías";
var company = "Compañía";
var companyName = "Nombre de la compañía";
var companyProfile = "Perfil de compañía";
var completed = "Completado";
var configuration = "Configuración";
var consultList = "Consultar lista";
var costName = "Nombre del costo";
var costs = "Costos";
var costSearch = "Búsqueda de costo";
var costsWithCount = "{{count}} Costo";
var costsWithCount_plural = "{{count}} Costos";
var costSheets = "Hojas de costos";
var costSheetStatus = {
	PENDING: "P.imputación",
	IMPUTED: "P. aprobación",
	APPROVED: "Aprobado",
	REJECTED: "Rechazado"
};
var costType = "Tipo de costo";
var costTypeName = "Nombre del tipo de costo";
var costTypes = "Tipos de costo";
var costTypesWithCount = "{{count}} Tipo de costo";
var costTypesWithCount_plural = "{{count}} Tipos de costo";
var craneService = "Servicio de grúa";
var create = "Crear";
var currentPassword = "Contraseña actual";
var custodyDays = "Días custodia";
var customer = "Cliente";
var D = "D";
var dashboard = "Dashboard";
var date = "Fecha";
var dateRangeExceeded = "Excedido el rango de fechas";
var dayAndTime = "Día y hora";
var deadLine = "Fecha límite";
var concessionaire = "Concesionaria";
var deferred = "Programado";
var deferredService = "Servicio programado";
var deferredShort = "Programad";
var deferredShorter = "Progra.";
var deleteCost = "Eliminar costo";
var deletePath = "Borrar trazado";
var deleteRequest = "Eliminar solicitud";
var deposits = "Depósitos";
var description = "Descripción";
var detail = "Detalle";
var disconnect = "Desconectar";
var disputeReason = "Motivo de la disputa";
var documentation = "Documentación";
var documentationProfile = "Perfil documentación";
var documentNumberAbbrev = "Nº del documento";
var documentProfile = "Perfil de documento";
var documentProfiles = "Perfil de documentos";
var documentAdded = "Documento añadido";
var documentType = "Tipo de documento";
var documentTypes = "Tipo de documentos";
var doNotAssociate = "No asociar";
var dragData = "Arrastrar datos";
var driver = "Conductor";
var drivers = "Conductores";
var duplicate = "Duplicar";
var duplicateService = "Duplicar servicio";
var E = "E";
var edit = "Editar";
var editAuxService = "Editar servicio auxiliar";
var editCapability = "Editar prestación";
var editCollective = "Editar colectivo";
var editCost = "Editar costo";
var editCostType = "Editar tipo de costo";
var editFault = "Editar avería";
var editSupportTeam = "Editar equipo de soporte";
var editUserProfile = "Editar perfil de usuario";
var email = "Email";
var endService = "Finalizar servicio";
var entry = "Entrada";
var entryDateAbbrev = "F. de entrada";
var error = "Error";
var errorAddingDocument = "Error al añadir documento";
var estimatedTime = "Hora estimada";
var execution = "Ejecución";
var executionProfile = "Perfil de ejecución";
var expense = "Gastos";
var expiredCode = "Código caducado";
var expires = "Caduca";
var events = "Eventos";
var excessOfTimeForOutService = "Exceso de tiempo para realizar servicio carretero";
var excessOfTimeForUrbanService = "Exceso de tiempo para realizar servicio local";
var excessOfTimeInCurrentStatus = "Exceso de tiempo en el estado actual";
var excessOfTimeToCompleteService = "Exceso de tiempo para realizar el servicio";
var excessOfTimeToStartScheduledService = "Exceso de tiempo para iniciar un servicio programado";
var F = "F";
var fault = "Avería";
var faults = "Averías";
var faultCollectiveAbbrev = "Avería/Colec.";
var faultWithCount = "{{count}} Avería";
var faultWithCount_plural = "{{count}} Averías";
var fee = "Salida";
var fieldRequired = "Requerido";
var file = "Archivo";
var filterByDriverStatus = "Filtrar por estado conductor";
var filterByVehicleType = "Filtrar por tipo vehículo";
var financial = "Financiero";
var financialBreakdown = "Desglose financiero";
var finish = "Finalizar";
var finishedServices = "Servicios finalizados";
var firstPrice = "Precio primera";
var firstUnitPriceAbbrev = "Precio 1ª ud.";
var fixed = "Fijo";
var formError = "Error en formulario";
var franchise = "Franquicia";
var franchises = "Franquicias";
var freeCranesBefore1Hour = "Grúas libres antes de 1h";
var fromUntil = "Desde - Hasta";
var fullAddress = "Dirección completa";
var fullScreenAbbrev = "P. completa";
var G = "G";
var generalInformationAbbrev = "Inf. General";
var generate = "Generar";
var generated = "Generada";
var geofence = "Geocerca";
var geofence_plural = "Geocercas";
var geofenceWithCount = "{{count}} Geocerca";
var geofenceWithCount_plural = "{{count}} Geocercas";
var geoJson = "GeoJson";
var globalAuction = "Subasta global";
var graceDays = "Días de gracia";
var grecaptchaNote = "Sitio protegido por reCAPTCHA. Se aplica la <a href=\"https://policies.google.com/privacy\">Política de privacidad</a> y <a href=\"https://policies.google.com/terms\">Términos de servicio</a> de Google.";
var guardMode = "Modo guardia";
var H = "H";
var help = "Ayuda";
var hide = "Ocultar";
var holder = "Titular";
var holidays = "Festivos";
var home = "Hogar";
var hour = "Hora";
var hours = "Horas";
var I = "I";
var IBAN = "IBAN";
var icon = "Icono";
var iconUrl = "URL del icono";
var identificationIcon = "Icono identificativo";
var image = "Imagen";
var immediate = "Inmediato";
var immediate_plural = "Inmediatos";
var immediateService = "Servicio inmediato";
var incorrectLocationFormat = "Localización en formato incorrecto";
var infoWindowIcon = "Icono del InfoWindow";
var inParking = "En parking";
var inRis = "En reparación";
var inris = "En reparación";
var inServiceResourcesWithCount = "{{count}} Recurso en servicio";
var inServiceResourcesWithCount_plural = "{{count}} Recursos en servicio";
var instant = "Inmediato";
var insurancePolicyInfo = "Información de la póliza";
var insured = "Asegurado";
var insured_autoType = "Vehículo";
var insured_homeType = "Inmueble";
var insuredAutoType = "Vehículo";
var insuredHomeType = "Inmueble";
var insuredObjectAbbrev = "Bien aseg.";
var insuredProperty = "Bien asegurado";
var integrationProfile = "Perfil de integración";
var integrationProfileAbbrev = "Perfil integración";
var internalCode = "Código interno";
var internalNote = "Nota interna";
var internalNotes = "Notas internas";
var interrupted = "Interrumpida";
var intervention = "Intervención";
var interventionAbbrev = "Int.";
var interventions = "Intervenciones";
var inUrbanArea = "En zona local";
var invalidNexusFilecase = "Expediente de Nexus no válido";
var invalidText = "Texto no válido";
var invoice = "Factura";
var invoiceNumberAbbrev = "Nº de factura";
var forTheDay = "Para el día";
var isNotValid = "Es inválido";
var issuedInvoices = "Facturas emitidas";
var itAlreadyExists = "Ya existe";
var J = "J";
var K = "K";
var L = "L";
var label = "Rotulación";
var labeled = "Rotulaciones";
var labels = "Rotulaciones";
var lastActivity = "Ult. actividad";
var lastActivity2 = "Última actividad";
var legal = "Legal";
var legalId = "NIF/CIF";
var list = "Listado";
var listEntryMax24H = "Entrada en lista (max. 24h)";
var loaded = "Cargado";
var loadTimeInMinutes = "Tiempo de carga (min)";
var located = "Localizado";
var location = "Ubicación";
var locked = "Bloqueado";
var lockedByNexus = "Bloqueado";
var login = "Iniciar sesión";
var logo = "Logotipo";
var logout = "Cerrar sesión";
var M = "M";
var managed = "Gestionado";
var managedProvider = "Proveedor gestionado";
var manual = "Manual";
var manualProvider = "Proveedor manual";
var map = "Mapa";
var mapIcon = "Icono del mapa";
var mapOfGoingServices = "Mapa de servicios en curso";
var mapOfResources = "Mapa de recursos";
var mapOfTracking = "Mapa de seguimiento";
var mapView = "Vista mapa";
var max = "Max.";
var maxAllowedTimeInMinutes = "Tiempo máx. permitido: {{minutes}} min";
var maxDistance = "Distancia máxima";
var maxDistanceToCrane = "Distancia de la grúa";
var maxHours = "Horas máximo";
var maxRadius = "Radio máximo";
var maxTime = "Tiempo máximo";
var maxTimeOnList = "Permanencia en lista";
var medium = "Medio";
var mediumNotFound = "No se ha encontrado el medio";
var mediumType = "Tipo de medio";
var mediumTypes = "Tipo de medios";
var mediumTypes2 = "Tipos de medio";
var minute = "Minuto";
var minutes = "Minutos";
var modeAndName = "Modo y nombre";
var model = "Modelo";
var modifiedCollective = "Colectivo modificado";
var modifiedFault = "Avería modificada";
var myTickets = "Mis tickets";
var N = "N";
var name = "Nombre";
var nameSurname = "Nombre y apellidos";
var new_female = "Nueva";
var new_plural = "Nuevos";
var newAuxService = "Nuevo servicio";
var newAuxiliaryService = "Nuevo servicio auxiliar";
var newDayAndTime = "Nuevo día y hora";
var newPassword = "Nueva contraseña";
var newService = "Nuevo servicio";
var newSupportTeam = "Nuevo equipo de soporte";
var newVehicleAssistance = "Nueva asistencia de vehículos";
var newVialService = "Nuevo servicio vial";
var nexusMapServiceError = "Error en el servicio de mapas de Nexus";
var nick = "Nick";
var no = "No";
var noProvidersAvailable = "No hay proveedores disponibles";
var notApplyCosts = "No aplicar gastos";
var notParticipating = "No participa";
var noCovered = "No cubierto";
var noDocumentsAssociatedToService = "No hay documentos asociados";
var noResourcesAvailableMsg = "No hay recursos disponibles, pero puedes enviar el servicio a una lista de espera para que Nexus lo gestione.";
var noSubscribe = "No suscribirme";
var note = "Nota";
var notes = "Notas";
var notesAssociatedWithTheService = "Notas asociadas al servicio";
var noTicketsAssociatedToService = "No hay tickets asociados al servicio";
var noTicketsAssociatedToTransfer = "No hay tickets asociados al traslado";
var noNotesAssociatedToService = "No hay notas asociadas al servicio";
var notifications = "Notificaciones";
var noTransfersAvailable = "No hay traslados disponibles";
var noValid = "No válido";
var numberAbbrev = "Nº";
var numberOfPeopleAbbrev = "Nº de personas";
var numberOfReviewsAbbrev = "Nº Reseñas";
var O = "O";
var office = "Oficina";
var ongoing = "En curso";
var onQueue = "En espera";
var openDispute = "Abrir disputa";
var operational = "Operativos";
var operationTypes = "Tipo de intervención";
var origin = "Origen";
var originalServiceData = "Datos del servicio original";
var originDeposit = "Origen depósito";
var otherSettings = "Otros ajustes";
var orYouCan = "O puedes";
var outlay = "Suplidos";
var outlays = "Gastos adicionales";
var P = "P";
var paid = "Pagada";
var passengers = "Pasajeros";
var passengersWithCount = "{{count}} Pasajero";
var passengersWithCount_plural = "{{count}} Pasajeros";
var password = "Contraseña";
var passwordsNotMatch = "Las contraseñas no coinciden";
var paymentsToProviders = "Pagos a proveedores";
var pdf = "Pdf";
var pending = "Pendiente";
var pendings = "Pendientes";
var PENDING = "Pendiente";
var pending_assign = "Pendiente asignación";
var PENDING_ASSIGN = "Pendiente asignación";
var PENDINGASSIGN = "Pendiente asignación";
var pendingDocumentation = "Documentación pendiente";
var pendingDocuments = "Documentos pendientes";
var pendingPassword = "Pendiente registro";
var pendingProfile = "Pendiente perfil";
var peopleTransferActivity = "Traslados";
var pleaseTryAgainLater = "Por favor inténtalo de nuevo mas tarde";
var phone = "Teléfono";
var phoneNumberAbbrev = "Nº de teléfono";
var photoWithCount = "{{count}} foto";
var photoWithCount_plural = "{{count}} fotos";
var photos = "Fotos";
var planned = "Planificado";
var PLANNED = "Planificado";
var plannedService = "Servicio planificado";
var plate = "Matrícula";
var plateDoesNotCorrespondToTheFilecase = "Matrícula no corresponde al expediente";
var policy = "Póliza";
var policyCoverageLimit = "Excedida la cobertura de la póliza";
var policyCoverageLimit2 = "Posible exceso de la cobertura de la póliza";
var policyInformation = "Información de póliza";
var policyLimitExceeded = {
	number1: "Se ha solicitado 1 servicio, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al proveedor.",
	number2: "Se han solicitado {{previousServices}} servicios, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al proveedor.",
	number3: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza es 1. El asistido deberá abonar el coste total del servicio al proveedor.",
	number4: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza son {{policyServicesLimit}}. El asistido deberá abonar el coste total del servicio al proveedor.",
	amount1: "El importe del servicio es de {{serviceTotalAmount}}, y el importe máximo que incluye la póliza es {{policyAmountLimit}}. El asistido deberá abonar la diferencia de {{amountDifference}} al proveedor.",
	amount2: "El importe del servicio es de {{serviceTotalAmount}}, y quedan {{availableAmount}} del importe máximo que incluye la póliza. El asistido deberá abonar la diferencia de {{amountDifference}} al proveedor.",
	amount3: "El importe del servicio es de {{serviceTotalAmount}}, y ya se ha gastado el importe máximo que incluye la póliza. El asistido deberá abonar la totalidad del servicio al proveedor.",
	amount4: "El importe de alguno de los recursos seleccionados supera el límite de la póliza de {{policyAmountLimit}}. El asistido deberá abonar la diferencia al proveedor en el caso de que estos recursos acepten el servicio.",
	amount5: "El importe de alguno de los recursos seleccionados supera el límite de la póliza de {{policyAmountLimit}}, y quedan {{availableAmount}} del importe máximo de cobertura. El asistido deberá abonar la diferencia al proveedor en el caso de que estos recursos acepten el servicio.",
	amount6: "El importe de todos los recursos seleccionados supera el límite de la póliza de {{policyAmountLimit}}, y ya se ha gastado el importe máximo de cobertura. El asistido deberá abonar la totalidad del servicio al proveedor en el caso de que estos recursos acepten el servicio.",
	amount4b: "El importe del recurso seleccionado supera el límite de la póliza de {{policyAmountLimit}}. El asistido deberá abonar la diferencia al proveedor en el caso de que este recurso acepte el servicio.",
	amount5b: "El importe del recurso seleccionado supera el límite de la póliza de {{policyAmountLimit}}, y quedan {{availableAmount}} del importe máximo de cobertura. El asistido deberá abonar la diferencia al proveedor en el caso de que este recurso acepte el servicio.",
	amount6b: "El importe del recurso seleccionado supera el límite de la póliza de {{policyAmountLimit}}, y ya se ha gastado el importe máximo de cobertura. El asistido deberá abonar la totalidad del servicio al proveedor en el caso de que este recurso acepte el servicio.",
	amount7: "El importe estimado del servicio es de {{serviceTotalAmount}}, y el importe máximo que incluye la póliza es {{policyAmountLimit}}. El asistido deberá abonar la diferencia aproximada de {{amountDifference}} al proveedor.",
	amount8: "El importe estimado del servicio es de {{serviceTotalAmount}}, y quedan {{availableAmount}} del importe máximo que incluye la póliza. El asistido deberá abonar la diferencia aproximada de {{amountDifference}} al proveedor.",
	amount9: "El importe estimado del servicio es de {{serviceTotalAmount}}, y ya se ha gastado el importe máximo que incluye la póliza. El asistido deberá abonar la totalidad del servicio al proveedor."
};
var policyLimitExceededAux = {
	number1: "Se ha solicitado 1 servicio, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al técnico.",
	number2: "Se han solicitado {{previousServices}} servicios, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al técnico.",
	number3: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza es 1. El asistido deberá abonar el coste total del servicio al técnico.",
	number4: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza son {{policyServicesLimit}}. El asistido deberá abonar el coste total del servicio al técnico.",
	amount1: "El importe del servicio es de {{serviceTotalAmount}}, y el importe máximo que incluye la póliza es {{policyAmountLimit}}. El asistido deberá abonar la diferencia de {{amountDifference}} al técnico.",
	amount2: "El importe del servicio supera el límite de la póliza de {{serviceTotalAmount}}, y quedan {{availableAmount}} del importe máximo de cobertura. El asistido deberá abonar la diferencia de {{amountDifference}} al técnico.",
	amount3: "El importe del servicio supera el límite de la póliza de {{serviceTotalAmount}}, y ya se ha gastado el importe máximo de cobertura. El asistido deberá abonar la totalidad del servicio al técnico."
};
var policyNumberAbbrev = "Nº de póliza";
var policySearch = "Búsqueda de póliza";
var positionAbbrev = "P.";
var priority = "Prioritario";
var priority1Providers = "Proveedores de prioridad 1";
var priority2Providers = "Proveedores de prioridad 2";
var priority3Providers = "Proveedores de prioridad 3";
var priorityAllProviders = "Todos los proveedores";
var priorityProvider = "Proveedor prioritario";
var process$1 = "Procesar";
var profile = "Perfil";
var profileNotFound = "No se ha encontrado el perfil";
var profiles = "Perfiles";
var proposals = "Propuestas";
var provider = "Proveedor";
var providersInZone = "Proveedores en la zona";
var providersOutZone = "Resto de proveedores";
var providerTechnician = "Proveedor / técnico";
var providerVialSettings = "Ajustes de viales de {{providerName}}";
var providerEditVialSettingsHeaderText = "Completa la información necesaria correspondiente a los servicios viales.";
var providerAuxiliariesSettings = "Ajustes de auxiliares de {{providerName}}";
var providerEditAuxiliariesSettingsHeaderText = "Completa la información necesaria correspondiente a los servicios auxiliares.";
var providers = "Proveedores";
var provider_pending = "Pendiente proveedor";
var PROVIDER_PENDING = "Pendiente proveedor";
var PROVIDERPENDING = "Pendiente proveedor";
var provider_accepted = "Aceptado proveedor";
var PROVIDER_ACCEPTED = "Aceptado proveedor";
var PROVIDERACCEPTED = "Aceptado proveedor";
var provider_accept = "Aceptado proveedor";
var PROVIDER_ACCEPT = "Aceptado proveedor";
var PROVIDERACCEPT = "Aceptado proveedor";
var providersSelection = "Selección de proveedores";
var providerList = {
	providerWithCount: "{{count}} Proveedor",
	providerWithCount_plural: "{{count}} Proveedores"
};
var providersMap = "Mapa de proveedores";
var providerType = "Tipo de proveedor";
var providerTypeVial = "Tipo de vial";
var providerTypeAux = "Tipo de auxiliar";
var providerWithoutDefinedDeposit = "Proveedor sin depósito configurado";
var province = "Provincia";
var Q = "Q";
var queueEntryDate = "Fecha de entrada en la lista";
var queued = "En espera";
var QUEUED = "En espera";
var queuedService = "Servicio en espera";
var R = "R";
var rates = "Tarifas";
var rating = "Valoración";
var ratings = "Valoraciones";
var ratingsUserName = "Valoraciones de {{userName}}";
var ratingsWithCount = "{{count}} Valoración";
var ratingsWithCount_plural = "{{count}} Valoraciones";
var ready = "Disponible";
var reAssign = "Reasignar";
var reAssignProvider = "Reasignar proveedor";
var reAskForResetEmail = "Vuelve a pedir email de restablecer";
var received = "Recibido";
var receivedInvoices = "Facturas recibidas";
var recoverRequest = "Recuperar solicitud";
var recoverYourPassword = "Recupera tu contraseña";
var region = "Región";
var registrationInformationOnInvoices = "Información registral en facturas";
var reject = "Rechazar";
var rejectCosts = "Rechazar costos";
var rejectionReason = "Motivo de rechazo";
var rejectionReasons = "Motivos de rechazo";
var rejectionType = "Tipo de rechazo";
var release = "Liberar";
var removeFromDashboard = "Eliminar del Dashboard";
var repeated = "Repetido";
var repeatPassword = "Repetir contraseña";
var requestCapability = "Prestación solicitada";
var requestInfo = "Inf. solicitud";
var requestLocationByWhatsApp = "Solicitar ubicación por WhatsApp";
var requestMediumAbbrev = "M.Solicitado";
var requestProcessedCorrectly = "Solicitud procesada de forma correcta";
var requestWithoutIAssociatedPolicy = "Solicitud sin póliza asociada";
var required = "Obligatorio";
var reschedule = "Reprogramar";
var RESCHEDULED = "Reprogramado";
var rescheduleComment = "Comentario de la reprogramación";
var rescheduleReason = "Motivo de reprogramación";
var rescheduleService = "Reprogramar servicio";
var rescheduleServiceDeferredTextModal = "Introduce un nuevo día y hora para cambiar la programación del servicio actual";
var rescheduleServicePlannedText1Modal = "Los servicios planificados tienen un recurso asignado. Al cambiar la fecha y hora, el servicio volverá al estado programado, y estará pendiente de planificación";
var rescheduleServicePlannedText2Modal = "Introduce la nueva fecha del servicio programado";
var resetPassword = "Contraseña restablecida";
var resetYourPassword = "Restablece tu contraseña";
var resources = "Recursos";
var resourcesMap = "Mapa de recursos";
var restore = "Restablecer";
var result = "Resultado";
var ris = "RIS";
var risService = "Servicio de RIS";
var S = "S";
var save = "Guardar";
var saveChanges = "Guardar cambios";
var savedRequests = "Solicitudes guardadas";
var saveRequest = "Guardar solicitud";
var schedule = "Agendar";
var scheduled = "Programado";
var SCHEDULED = "Programado";
var scheduled_plural = "Programados";
var scheduledAbbrev = "Program.";
var scheduledDateInvalidErrorText = "La fecha y hora programada no es válida";
var scheduleDriver = "Agendar conductor";
var scheduledServiceNotFound = "El servicio programado no ha sido localizado";
var scheduledFor = "Programado para";
var searchResourceOrTechnician = "Busca recurso o técnico";
var searchResources = "Busca recursos";
var searchAResource = "Buscar un recurso";
var searchAService = "Buscar un servicio";
var searchByAssistedOrFilecase = "Asistido o Exp";
var searchByAssistedFilecaseOrPlate = "Asistido, Aseg, Exp. o Matrícula";
var searchByAssistedFilecaseOrProvider = "Asistido, Exp. o Proveedor";
var searchByCodeOrName = "Busca por Código o Nombre";
var searchByCodeNameOrCostType = "Busca por Código, Nombre o Tipo de costo";
var searchByCodeNameOrMediumType = "Busca por Código, Nombre o Tipo de medio";
var searchByCustomer = "Busca por Cliente";
var searchByCustomerOrFilecase = "Cliente o Exp";
var searchByCustomerFilecaseOrPlate = "Cliente, Exp. o Matrícula";
var searchByFileCase = "Busca por Expediente";
var searchByIdForOrFilecaseNumber = "Busca por ID, Para o Nº Expediente";
var searchByInvoiceNumber = "Busca por Nº Factura";
var searchByName = "Busca por Nombre";
var searchByNameCIFOrAddress = "Busca por Nombre, CIF o Dirección";
var searchByNameOrAddress = "Busca por Nombre o Dirección";
var searchByNameOrCode = "Busca por Nombre o Código";
var searchByNamePlateOrCode = "Busca por Nombre, Matrícula o Código";
var searchByNameSurnameUserOrNick = "Busca por Nombre, Apellidos, Usuario o Nick";
var searchByProviderOrName = "Busca por Proveedor o Nombre";
var searchByTerm = "Busca por término";
var searchInsurancePolicy = "Buscar póliza";
var seeAverages = "Ver medias";
var breakdown = "Desglose";
var seeCapabilityComment = "Ver comentario de prestación";
var seeComment = "Ver comentario";
var seeContactAndComment = "Ver contacto y comentario";
var seeDescription = "Ver descripción";
var seeService = "Ver servicio";
var selfValidated = "Autovalidado";
var send = "Enviar";
var sendComments = "Enviar comentarios";
var sended = "Enviado";
var sendEmail = "Enviar correo";
var sendForReview = "Enviar a revisión";
var sendTo = "Enviar a";
var sendToList = "Enviar a la lista";
var serverConnectionError = "¡Error de conexión con el servidor!";
var service = "servicio";
var serviceExecution = "Ejecución del servicio";
var serviceInAuction = "Servicio en subasta";
var serviceLevels = "Niveles de servicio";
var serviceMap = "Mapa de viales";
var serviceNotFound = "No se ha encontrado el servicio";
var serviceRequestAndTracking = "Solicitud y seguimiento del servicio";
var services = "Servicios";
var serviceSentToAuction = "Servicio enviado a subasta";
var serviceStatus = {
	auctioning: "En subasta",
	auctioningAvatar: "S",
	pending_assign: "Pendiente asignación",
	pendingAssign: "Pendiente asignación",
	pending_assignAvatar: "PA",
	provider_pending: "Pendiente proveedor",
	providerPending: "Pendiente proveedor",
	provider_pendingAvatar: "PP",
	provider_accepted: "Aceptado proveedor",
	providerAccepted: "Aceptado proveedor",
	providerAccept: "Aceptado proveedor",
	provider_acceptedAvatar: "AP",
	queued: "En espera",
	queuedAvatar: "E",
	scheduled: "Programado",
	scheduledAvatar: "PR",
	pending: "Pendiente",
	pendingAvatar: "PE",
	assigned: "Agendado",
	assignedAvatar: "AG",
	planned: "Planificado",
	plannedAvatar: "PL",
	accepted: "Aceptado",
	acceptedAvatar: "AC",
	started: "Iniciado",
	startedAvatar: "I",
	located: "Localizado",
	locatedAvatar: "L",
	inris: "En reparación",
	inrisAvatar: "RP",
	loaded: "Cargado",
	loadedAvatar: "CA",
	completed: "Completado",
	completedAvatar: "CO",
	finished: "Finalizado",
	finishedAvatar: "F",
	rejected: "Rechazado",
	rejectedAvatar: "RC",
	canceled: "Anulado",
	canceledAvatar: "AN"
};
var settings = "Ajustes";
var settingsUpdated = "Ajustes actualizados";
var sharedCode = "Código compartido";
var sharedNote = "Nota compartida";
var sharedNotes = "Notas compartidas";
var shipments = "Remesas";
var shipmentStatusValues = {
	collecting: "Interrumpida",
	pending: "Generada",
	billed: "Facturada",
	collected: "Cobrada",
	payed: "Pagada"
};
var showAllMediums = "Mostrar todos los medios";
var showSolicitedMedium = "Mostrar medio solicitado";
var situation = "Situación";
var solicitedMedium = "Medio solicitado";
var sortCriteria = "Criterio ordenación";
var soundActivated = "Sonido activado";
var soundOff = "Sonido desactivado";
var start = "Inicio";
var started = "Iniciado";
var status = "Estado";
var statuses = "Estados";
var subject = "Asunto";
var subscribe = "Suscribirme";
var subtotal = "Subtotal";
var suburb = "Carretero";
var suburbService = "Servicio carretero";
var summary = "Resumen";
var supportCenter = "Centro de soporte";
var supportTeam = "Equipo de soporte";
var survey = "Encuesta";
var surveys = "Encuestas";
var T = "T";
var taxes = "Impuestos";
var team = "Equipo";
var teamName = "Nombre del equipo";
var technician = "Técnico";
var technicians = "Técnicos";
var theField = "El campo";
var ticket = "Ticket";
var tickets = "Tickets";
var ticketStatus = {
	"new": "Nuevo",
	newAvatar: "N",
	open: "Abierto",
	openAvatar: "A",
	closed: "Cerrado",
	closedAvatar: "C"
};
var time = "Tiempo";
var timeInAlert = "Tiempo en alerta";
var timeline = "Línea de tiempo";
var title = "Título";
var toastErrorDuplicateAddressPickupDeliveryTitle = "Error en las direcciones";
var toastErrorDuplicateAddressPickupDeliveryText = "La dirección de recogida y entrega deben ser diferentes.";
var toastErrorDuplicateAddressPickupDestinationTitle = "Error en las direcciones";
var toastErrorDuplicateAddressPickupDestinationText = "La dirección de recogida y destino del asistido deben ser diferentes.";
var toastErrorTextDefault = "No ha sido posible realizar la operación.";
var toastErrorTitleDefault = "Error en la operación";
var toastErrorTransferPeopleBudget = {
	expiredEstimate: {
		title: "Error",
		text: "La estimación de tarifa seleccionada ha expirado."
	},
	invalidEstimate: {
		title: "Error",
		text: ""
	},
	productNotFound: {
		title: "Error",
		text: "El recurso seleccionado no ha sido localizado."
	},
	cabifyIntegrationProblem: {
		title: "Error",
		text: "No se ha podido solicitar el traslado."
	},
	profileWithoutResources: {
		title: "Error",
		text: "Perfil sin recursos"
	}
};
var toastErrorTitle_downloadFile = "Error";
var toastErrorText_downloadFile = "No ha sido posible descargar el fichero.";
var toastSuccessTextDefault = "La operación se ha realizado correctamente.";
var toastSuccessTitleDefault = "Operación realizada con éxito";
var today = "Hoy";
var toDefine = "Por definir";
var total = "Total";
var totals = "Totales";
var toTheClient = "Al cliente";
var toTheProvider = "Al proveedor";
var town = "Localidad";
var tracking = "Seguimiento";
var trackingMessage = "Mensaje de seguimiento";
var transfer = "Traslado";
var transferHasBeenCancelled = "El traslado ha sido anulado.";
var transferPeople = "Traslado de personas";
var transferPeopleBudget = "Propuesta de traslado";
var transferPeopleRequest = "Solicitud de traslado";
var transferPeopleRequestType = {
	immediate: "Servicio inmediato",
	deferred: "Servicio programado"
};
var transferPeopleRequiredValidPhoneNumber = "Para los traslados es necesario facilitar un teléfono de contacto.";
var transfers = "Traslados";
var transfersAvailable = "Traslados disponibles";
var transferTheAssisted = "Trasladar al asistido";
var type = "Tipo";
var typeAndName = "Tipo y nombre";
var typeless = "Sin tipo";
var typeOfService = "Tipo de servicio";
var types = "Tipos";
var U = "U";
var udWithCount = "{{count}} ud.";
var udWithCount_plural = "{{count}} uds.";
var unAssign = "Liberar";
var unAssignTechnician = "Liberar técnico";
var unAssignTechnicianModalText = "¿Estás seguro que deseas liberar el técnico?";
var unAssignTechnicianModalAditionalText = "Al hacerlo, el servicio pasará a estado Aceptado proveedor y podrás asignar un técnico nuevo.";
var unAssignDriver = "Liberar conductor";
var unAssignDriverModalText = "¿Estás seguro que deseas liberar el conductor?";
var unAssignDriverModalAditionalText = "Al hacerlo, el servicio pasará a estado Aceptado proveedor y podrás asignar un conductor nuevo.";
var unavailable = "No disponible";
var units = "Unidades";
var unitAbbrev = "ud.";
var unitsAbbrev = "uds.";
var unselected = "Sin selección";
var unsubscribe = "Anular suscripción";
var urban = "Local";
var urbanFee = "Local";
var urbanService = "Servicio local";
var user = "Usuario";
var userProfiles = "Perfiles de usuario";
var userProfilesWithCount = "{{count}} Perfil de usuario";
var userProfilesWithCount_plural = "{{count}} Perfiles de usuario";
var users = "Usuarios";
var userType = "Tipo de usuario";
var V = "V";
var validFrom = "Válido desde";
var validUntil = "Válido hasta";
var variable = "Variable";
var vehicleAssistance = "Asistencia de vehículos";
var vehicleTypes = "Tipo de vehículos";
var version = "Versión";
var vial = "Vial";
var vials = "Viales";
var vialRates = "Tarifas viales";
var vialServices = "Servicios viales";
var vialSettings = "Ajustes de viales";
var view = "Vista";
var viewAssistedRating = "Ver valoración del asistido";
var viewContact = "Ver contacto";
var viewContactandComment = "Ver contacto y comentario";
var viewRoute = "Ver ruta";
var views = "Vistas";
var vin = "VIN";
var virtualSwitchboard = "Centralita virtual";
var W = "W";
var waitingList = "Lista de espera";
var web = "Web";
var webAddress = "Dirección web";
var wholeWordSearch = "Búsqueda de palabras completas";
var wholeWordSearch3Charts = "Busca palabras completas (min 3 carac.)";
var withAlert = "Con alerta";
var withholdings = "Retenciones";
var withPriority1 = "Con prioridad 1";
var withPriority2 = "Con prioridad 2";
var withPriority3 = "Con prioridad 3";
var writeANote = "Escribir una nota";
var wrongUser = "Usuario incorrecto";
var wrongUsernameOrPassword = "Usuario o contraseña incorrectos";
var X = "X";
var Y = "Y";
var year = "Año";
var yes = "Sí";
var yesterday = "Ayer";
var youHaveExceededTheNumberOfAtempsts = "Has excedido el número de intentos";
var Z = "Z";
var maxMinutes = "Minutos max.";
var maxPhotos = "Fotos max.";
var between0And5Minutes = "Entre 0 y 5 minutos";
var between0And10Minutes = "Entre 0 y 10 minutos";
var between0And240Minutes = "Entre 0 y 240 minutos";
var between1And7Minutes = "Entre 1 y 7 minutos";
var between2And5Minutes = "Entre 2 y 5 minutos";
var between2And10Minutes = "Entre 2 y 10 minutos";
var between0And10Photos = "Entre 0 y 10 fotos";
var between1And10Characters = "Entre 1 y 10 caracteres";
var between0And120Minutes = "Entre 0 y 120 minutos";
var ACCEPTED = "Aceptado";
var add_company_description = "Completa los datos de la compañía a dar de alta, indicando si se trata de un cliente o de un proveedor.";
var add_company = "Añadir compañía";
var addChartText = "Pulsa el botón de añadir para incorporar gráficos al Business Intelligence.";
var addChartTitle = "Añadir gráfico";
var all_female = "Todas";
var all_male = "Todos";
var amount = "Importe";
var apply = "Aplicar";
var assignProvider = "Asignar proveedor";
var assignedToMe = "Asignados a mí";
var assignItToMe = "Asignármelo";
var AVAILABLE = "Disponible";
var blocked = "Bloqueado";
var budgetToastSuccessText = "El servicio se ha añadido al listado.";
var budgetToastSuccessTitle = "Propuesta aceptada";
var scheduledBudgetToastSuccessText = "El servicio programado se ha añadido al listado.";
var scheduledBudgetToastSuccessTitle = "Propuesta aceptada";
var transferPeopleBudgetToastSuccessText = "El traslado se ha añadido al listado.";
var transferPeopleBudgetToastSuccessTitle = "Propuesta aceptada";
var budgetToastSuccessQueueText = "El servicio ha sido añadido a la lista de espera.";
var budgetToastSuccessQueueTitle = "Operación realizada con éxito";
var bussy = "ocupado";
var CANCELED = "Anulado";
var centerNum = "Nº Centros";
var centers = "Centros";
var closed = "Cerrado";
var codeAlreadyAssigned = "Código ya asignado";
var color = "Color";
var companyPendingDocumentation = "Pendiente documentación compañía";
var companyProviderCode = "Nuevo ID";
var COMPLETED = "Completado";
var custodyRate = "Precio día extra";
var damageReport = "Parte de daños";
var damageRequired = "Parte obligatorio";
var day = "Día";
var days = "Días";
var del = "Eliminar";
var delivery = "Entrega";
var deliveryAddressRequired = "Dirección de entrega obligatoria";
var destination = "Destino";
var documents = "Documentos";
var exit = "Salir";
var expired = "Caducado";
var EXTRA_CHARGES = "GASTOS EXTRA";
var extraCharges = "Gastos";
var festive = "Festivo";
var fieldsRequired = "Los campos con (*) son obligatorios.";
var files = "Archivos";
var filters = "Filtros";
var FINISHED = "Finalizado";
var free = "libre";
var from = "De";
var fromDate = "Desde";
var generalInfo = "Inf. General";
var groupName = "Nombre de la compañía";
var id = "Id";
var IN_SERVICE = "En servicio";
var information = "Información";
var INRIS = "En reparación";
var integrated = "Integrado";
var invite = "Invitar";
var invoiceDate = "Fecha fact.";
var lastAct = "Última act.";
var left = "Quedan";
var LOADED = "Cargado";
var LOCATED = "Localizado";
var locations = "Localizaciones";
var mediums = "Medios";
var MEDIUMS = "MEDIOS";
var modify = "Modificar";
var newRates = "Nuevas tarifas";
var nexus = "Nexus";
var nexusFee = "Fee Nexus";
var nFilecase = "Nº Expediente";
var nFilecaseAbbrev = "Nº Exp.";
var nickName = "Nick";
var nightlyEnd = "Fin horario noct.";
var nightlyStart = "Inicio horario noct.";
var nightly = "Nocturno";
var nigthly = "Nocturno";
var nightlyFestive = "Festivo nocturno";
var nInvoice = "Nº Factura";
var nInvoices = "Nº Facturas";
var none = "Ninguno";
var NOT_IN_NEXUS = "Fuera de Nexus";
var not = "No";
var nNexus = "Nº Nexus";
var nPayments = "Nº Pagos";
var nServices = "Nº Servicios";
var numberOfInvoices = "Número de facturas";
var of = "de";
var open = "Abierto";
var outOfService = "fuera de servicio";
var ownFilecaseNumber = "Nº expediente propio";
var ownFilecaseNumberAbbrev = "Nº expediente";
var partialPrice = "Precio parcial";
var participants = "Participantes";
var participation = "Participación";
var payed = "Pagada";
var payments = "Pagos";
var pendingAbbrev = "Pdte.";
var photosNumber = "Nº de fotos";
var pickup = "Recogida";
var pickupAddress = "Lugar recogida";
var pictures = "Fotos";
var processDate = "Fecha de procesamiento";
var processed = "Procesado";
var providerAlreadyMapped = "Proveedor ya mapeado";
var REJECTED = "Rechazado";
var rejection = "Rechazados";
var request = "Solicitar";
var requester = "Solicitante";
var resource = "Recurso";
var resourceActivity = "Recursos";
var resourceDistance = "Está a";
var resourceRoute = "Recorrido";
var resourceTime = "Llega en";
var responsable = "Responsable";
var responseNumberAbbrev = "Nº respuestas";
var RISEND = "Fin RIS";
var RISSTART = "Inicio RIS";
var rowsPerPage = "Filas por página";
var saveView = "Guardar vista";
var sendSMSTracking = "Enviar SMS seguimiento";
var sendSurvey = "Enviar encuesta";
var serviceActivity = "Servicios";
var serviceBudget = "Propuesta de servicio";
var serviceRequest = "Solicitud de servicio";
var serviceType = "Tipo servicio";
var shared = "Compartido";
var shipmentDate = "Fecha remesa";
var sign = "Firmas";
var sta = "Es.";
var STARTED = "Iniciado";
var supportTeamAbbrev = "Equipo Sop.";
var surchargeRate = "% Recargo noct.";
var surname = "Apellidos";
var teamMembers = "Miembros del equipo";
var teamTickets = "Los del equipo";
var totalPrice = "Precio total";
var UNAVAILABLE = "No disponible";
var userProfile = "Perfil";
var validate = "Validar";
var validated = "validado";
var vehicle = "Vehículo";
var weekend = "Fin de semana";
var category = {
	car: "Coche",
	ind: "Industrial",
	moto: "Moto",
	ptf: "Plataforma"
};
var collective2 = {
	toastColectiveDeactivateErrorTitle: "ERROR",
	toastColectiveDeactivateErrorTextDefault: "En estos momentos no es posible desactivar el colectivo. Por favor, vuelve a intentarlo en unos minutos."
};
var companyList = {
	companyWithCount: "{{count}} Companía",
	companyWithCount_plural: "{{count}} Companías"
};
var depositList = {
	depositWithCount: "{{count}} Depósito",
	depositWithCount_plural: "{{count}} Depósitos"
};
var format = {
	currency: "€ ",
	decimalSeparator: ",",
	thousandSeparator: "."
};
var invoiceList = {
	invoiceWithCount: "{{count}} Factura",
	invoiceWithCount_plural: "{{count}} Facturas"
};
var mediumList = {
	mediumWithCount: "{{count}} Medio",
	mediumWithCount_plural: "{{count}} Medios"
};
var mediumTypesList = {
	mediumTypesWithCount: "{{count}} Tipo de medio",
	mediumTypesWithCount_plural: "{{count}} Tipos de medios"
};
var modals = {
	addService: {
		linkServices: "Vincular servicios",
		linkServicesInfo: "El último servicio Nexus de este vehículo indica que está en un depósito.",
		linkServicesQuestion: "¿Deseas asociar el expediente Nexus y vincular los servicios?"
	},
	budget: {
		timeOut: "Tiempo agotado",
		timeOutInfo: "Se ha agotado el tiempo máximo para aceptar la propuesta. Inténtalo de nuevo."
	},
	ticketDetail: {
		closeTicket: "Cerrar ticket",
		closeTicketQuestion: "¿Estás seguro que deseas cerrar el ticket? Si lo cierras, se dará por resuelto y no podrás enviar más mensajes."
	}
};
var operationTypesList = {
	operationTypesWithCount: "{{count}} Tipo de intervención",
	operationTypesWithCount_plural: "{{count}} Tipos de intervención"
};
var paymentList = {
	paymentWithCount: "{{count}} Pago a proveedores",
	paymentWithCount_plural: "{{count}} Pagos a proveedores",
	processPaymentTitle: "Procesar pagos",
	processPaymentText: "Indica la fecha en la que el fichero ha sido procesado por el banco.",
	generatePaymentsTitle: "Generar pagos",
	generatePaymentsText: "Se van a generar todos los pagos hasta la fecha indicada. El fichero N34-14 se enviará por email.",
	toastGeneratePaymentsSuccessTitle: "Pago generado correctamente",
	toastGeneratePaymentsSuccessText: "El pago se ha generado y se ha enviado el fichero.",
	toastProcessPaymentSuccessTitle: "Pago procesado correctamente",
	toastProcessPaymentSuccessText: "El pago se ha procesado con la fecha indicada.",
	toastGeneratePaymentsWarningTitle: "No ha podido generarse",
	toastGeneratePaymentsWarningText: "No hay facturas pendientes hasta esa fecha."
};
var searchTools = {
	title: "Herramientas de búsqueda",
	byRoadKmTitle: "Busca por carretera y kilómetro",
	byRoadKm_1: "1. Introduce el nombre de la carretera y el punto kilométrico. Ejemplo: E-15/15",
	byRoadKm_2: "2. Pulsa \"Validar\" para validar la ubicación",
	roadKilometer: "Carretera / Kilómetro",
	byCoordsTitle: "Busca por coordenadas",
	byCoords_1: "Pulsa el botón del mapa y localiza la ubicación que necesitas.",
	byCoords_2: "Pulsa el botón derecho y copia las coordenadas que te ofrece Google.",
	byCoords_3: "Pégalas debajo y pulsa \"Validar\" para validar la ubicación.",
	coordsLatitudeLongitude: "Coordenadas (latitud, longitud)"
};
var serviceList = {
	serviceWithCount: "{{count}} Servicio",
	serviceWithCount_plural: "{{count}} Servicios"
};
var servicesError = {
	cancelServiceErrorTitle: "Error al solicitar la anulación",
	notCancelableService: "El servicio no se puede anular en su estado actual.",
	invalidService: "No ha sido posible solicitar la anulación del servicio.",
	cancelServiceUnknownError: "En estos momentos no es posible solicitar la anulación del servicio. Vuelva a intentarlo en unos minutos.",
	openDisputeErrorTitle: "Error al solicitar apertura de disputa",
	openDisputeUnknownError: "En estos momentos no es posible abrir una disputa para el servicio. Vuelva a intentarlo en unos minutos.",
	closeDisputeErrorTitle: "Error al solicitar cierre de disputa",
	closeDisputeUnknownError: "En estos momentos no es posible cerrar la disputa del servicio. Vuelva a intentarlo en unos minutos."
};
var transferPeopleError = {
	cancelTransferPeopleErrorTitle: "Error al solicitar la anulación",
	notCancelableService: "El traslado no se puede anular en su estado actual.",
	invalidTransferPeople: "No ha sido posible solicitar la anulación del traslado.",
	cancelServiceUnknownError: "En estos momentos no es posible solicitar la anulación del traslado. Vuelva a intentarlo en unos minutos."
};
var transferPeopleList = {
	transferPeopleWithCount: "{{count}} Traslado",
	transferPeopleWithCount_plural: "{{count}} Traslados"
};
var shipment = {
	collecting: "Interrumpida",
	pending: "Generada",
	billed: "Facturada",
	collected: "Cobrada",
	payed: "Pagada"
};
var ticketDetail = {
	toastSendMessageSuccessTitle: "Mensaje enviado correctamente",
	toastSendMessageSuccessText: "El mensaje ha sido enviado y añadido a la lista.",
	toastSendMessageErrorTitle: "Error al enviar mensaje",
	toastSendMessageErrorText: "Ha ocurrido un error en el envío del mensaje.",
	toastCloseMessageSuccessTitle: "Ticket cerrado correctamente",
	toastCloseMessageSuccessText: "El ticket ha sido cerrado y actualizado en la lista.",
	toastCloseMessageErrorTitle: "Error al cerrar ticket",
	toastCloseMessageErrorText: "Ha ocurrido un error al cerrar el ticket."
};
var ticketList = {
	ticketWithCount: "{{count}} Ticket",
	ticketWithCount_plural: "{{count}} Tickets"
};
var user2 = {
	toastUserDeactivateErrorTitle: "ERROR",
	toastUserDeactivateErrorTextDefault: "En estos momentos no es posible desactivar al usuario. Por favor, vuelve a intentarlo en unos minutos.",
	toastUserDeactivateErrorText: "El usuario activo no puede desactivarse a sí mismo.",
	toastUserInServiceDeactivateErrorText: "No es posible desactivar a un usuario que se encuentra actualmente realizando un servicio.",
	toastUserNotificationSuccessTitle: "Notificación enviada",
	toastUserNotificationSuccessText: "Hemos enviado una notificación al usuario con las instrucciones.",
	toastUserNotificationErrorTitle: "Ha ocurrido un error",
	toastUserNotificationErrorText: "No hemos podido enviar la notificación al usuario."
};
var userList = {
	userWithCount: "{{count}} Usuario",
	userWithCount_plural: "{{count}} Usuarios"
};
var validation = {
	fieldRequired: "Campo obligatorio",
	invalidCurrencyAmount: "No válido",
	invalidTimeFormat: "Formato de hora no válido"
};
var loginYourAccount = "Accede a tu cuenta";
var checkYourEmail = "Comprueba tu correo";
var updatedUser = "Usuario actualizado";
var errorCreatingCompany = "Error al crear compañía";
var min = "min";
var distance = "Distancia";
var es = {
	"********** BEGIN CHECKED WORDS **********": "**********",
	"% IRPF": "% IRPF",
	"% IVA": "% IVA",
	IRPF: IRPF,
	IVA: IVA,
	NIF: NIF,
	"NIF/CIF": "NIF/CIF",
	"NIF/SS": "NIF/SS",
	"NIF/CIF/SS": "NIF/CIF/SS",
	"#": "#",
	"1st": "1º",
	"2nd": "2º",
	"3rd": "3º",
	"4th": "4º",
	"5th": "5º",
	"6th": "6º",
	"7th": "7º",
	"8th": "8º",
	"9th": "9º",
	"10th": "10º",
	betweenMinAndMaxKilometers: betweenMinAndMaxKilometers,
	metricUnits: metricUnits,
	imperialUnits: imperialUnits,
	A: A,
	accept: accept,
	accepted: accepted,
	acceptUpdate: acceptUpdate,
	accessToTheViews: accessToTheViews,
	accessWithMicrosoft: accessWithMicrosoft,
	activateGuardMode: activateGuardMode,
	activateGuardModeWarningText: activateGuardModeWarningText,
	activateGuardModeWarningAditionalText: activateGuardModeWarningAditionalText,
	active: active,
	activity: activity,
	accumulateNightAndHolidaySurcharge: accumulateNightAndHolidaySurcharge,
	add: add,
	addAuxService: addAuxService,
	addCapability: addCapability,
	addCollective: addCollective,
	addCost: addCost,
	addCostType: addCostType,
	addedCollective: addedCollective,
	addFault: addFault,
	addedFault: addedFault,
	additionalInformation: additionalInformation,
	additionalPrice: additionalPrice,
	additionalPriceAbbrev: additionalPriceAbbrev,
	addNote: addNote,
	address: address,
	addressNotLocated: addressNotLocated,
	addUserProfile: addUserProfile,
	admin: admin,
	advancedConfiguration: advancedConfiguration,
	aheadServices: aheadServices,
	alert: alert,
	alerts: alerts,
	alertStart: alertStart,
	all_f: all_f,
	all_m: all_m,
	allowAccess: allowAccess,
	allowCalls: allowCalls,
	allowCalls_addService: allowCalls_addService,
	allowGuardErrorTitle: allowGuardErrorTitle,
	allowGuardErrorText: allowGuardErrorText,
	allowSMS: allowSMS,
	allProvidersAutomatic: allProvidersAutomatic,
	anErrorHasOccurred: anErrorHasOccurred,
	applyCosts: applyCosts,
	approve: approve,
	assign: assign,
	"assignment/lastActivityAbbrev": "Asig / ult. ac",
	assignTechnician: assignTechnician,
	assistance: assistance,
	assistanceWithoutTransfer: assistanceWithoutTransfer,
	assistanceWithoutTransferWarning: assistanceWithoutTransferWarning,
	assistanceWithoutTransferWarningQuestion: assistanceWithoutTransferWarningQuestion,
	assisted: assisted,
	assistedInsuredAbbrev: assistedInsuredAbbrev,
	assistedDestinationAddress: assistedDestinationAddress,
	associatedDocuments: associatedDocuments,
	at_time: at_time,
	assigned: assigned,
	ASSIGNED: ASSIGNED,
	attachADocument: attachADocument,
	"attach the following documents": "Adjunta los siguientes documentos",
	attachment: attachment,
	attachments: attachments,
	auction: auction,
	auctionConfiguration: auctionConfiguration,
	auctioned: auctioned,
	AUCTIONED: AUCTIONED,
	auctioning: auctioning,
	AUCTIONING: AUCTIONING,
	auctionInPriority: auctionInPriority,
	auctionInPriority1: auctionInPriority1,
	auctionInPriority2: auctionInPriority2,
	auctionInPriority3: auctionInPriority3,
	auctionInPriority4: auctionInPriority4,
	auctions: auctions,
	auctionService: auctionService,
	auto: auto,
	automatic: automatic,
	automaticProvider: automaticProvider,
	auxiliary: auxiliary,
	auxiliarySettings: auxiliarySettings,
	auxiliaries: auxiliaries,
	auxiliariesRates: auxiliariesRates,
	auxServiceList: auxServiceList,
	auxService: auxService,
	auxServices: auxServices,
	available: available,
	available_plural: available_plural,
	availableProvidersAbbrev: availableProvidersAbbrev,
	availableResources: availableResources,
	availableResourcesWithCount: availableResourcesWithCount,
	availableResourcesWithCount_plural: availableResourcesWithCount_plural,
	average: average,
	averageRating: averageRating,
	B: B,
	base: base,
	baseAmount: baseAmount,
	billed: billed,
	billing: billing,
	brand: brand,
	browse: browse,
	budgetWarningNoBaseFound: budgetWarningNoBaseFound,
	businessIntelligence: businessIntelligence,
	byAmount: byAmount,
	byBrand: byBrand,
	byPositionOnQueue: byPositionOnQueue,
	byScore: byScore,
	byTime: byTime,
	C: C,
	calculateAllServicesAsSuburban: calculateAllServicesAsSuburban,
	calendar: calendar,
	cancel: cancel,
	cancel_2: cancel_2,
	outputCancellationPercentageAbbrev: outputCancellationPercentageAbbrev,
	cancelAmount: cancelAmount,
	cancelRatePercentage: cancelRatePercentage,
	cancelRateAmount: cancelRateAmount,
	cancelReason: cancelReason,
	cancelService: cancelService,
	cancelServiceFinished: cancelServiceFinished,
	cancelTransferPeople: cancelTransferPeople,
	cancelTransferPeopleWarning: cancelTransferPeopleWarning,
	"Cannot send service to this provider because it has not defined any deposit (base)": "No se puede enviar el servicio a este proveedor porque no ha definido ningún depósito (base)",
	capabilityList: capabilityList,
	capability: capability,
	capabilityCollectiveAbbrev: capabilityCollectiveAbbrev,
	capabilities: capabilities,
	center: center,
	centerName: centerName,
	centerNotFound: centerNotFound,
	change: change,
	changePassword: changePassword,
	charge: charge,
	chargeWithCount: chargeWithCount,
	chargeWithCount_plural: chargeWithCount_plural,
	check: check,
	childProfile: childProfile,
	chosenDriver: chosenDriver,
	cif: cif,
	city: city,
	"class": "Clase",
	clone: clone,
	cloneService: cloneService,
	close: close,
	closeDispute: closeDispute,
	code: code,
	collectDate: collectDate,
	collected: collected,
	collectInvoice: collectInvoice,
	collective: collective,
	collectives: collectives,
	collectiveWithCount: collectiveWithCount,
	collectiveWithCount_plural: collectiveWithCount_plural,
	collectiveProviderAbbrev: collectiveProviderAbbrev,
	comment: comment,
	commentAboutCapability: commentAboutCapability,
	companies: companies,
	"companies-opt": {
	listWithCount: "{{count}} Compañía",
	listWithCount_plural: "{{count}} Compañías"
},
	company: company,
	companyName: companyName,
	companyProfile: companyProfile,
	completed: completed,
	configuration: configuration,
	consultList: consultList,
	"continue": "Continuar",
	costName: costName,
	costs: costs,
	costSearch: costSearch,
	costsWithCount: costsWithCount,
	costsWithCount_plural: costsWithCount_plural,
	costSheets: costSheets,
	costSheetStatus: costSheetStatus,
	costType: costType,
	costTypeName: costTypeName,
	costTypes: costTypes,
	costTypesWithCount: costTypesWithCount,
	costTypesWithCount_plural: costTypesWithCount_plural,
	craneService: craneService,
	create: create,
	currentPassword: currentPassword,
	custodyDays: custodyDays,
	customer: customer,
	"customer/capability": "Cliente / prestación",
	"customer/exp": "Cliente / Exp.",
	D: D,
	dashboard: dashboard,
	date: date,
	"Date scheduled service": "Fecha servicio programado",
	dateRangeExceeded: dateRangeExceeded,
	dayAndTime: dayAndTime,
	deadLine: deadLine,
	concessionaire: concessionaire,
	deferred: deferred,
	deferredService: deferredService,
	deferredShort: deferredShort,
	deferredShorter: deferredShorter,
	deleteCost: deleteCost,
	deletePath: deletePath,
	deleteRequest: deleteRequest,
	deposits: deposits,
	description: description,
	detail: detail,
	disconnect: disconnect,
	disputeReason: disputeReason,
	documentation: documentation,
	documentationProfile: documentationProfile,
	documentNumberAbbrev: documentNumberAbbrev,
	documentProfile: documentProfile,
	documentProfiles: documentProfiles,
	"documentProfiles-opt": {
	listWithCount: "{{count}} Perfil de documento",
	listWithCount_plural: "{{count}} Perfiles de documentos"
},
	"documents-status": {
	pending: "Pendiente de verificación",
	validated: "Válido",
	rejected: "Rechazado el",
	rejectReason: "Motivo de rechazo",
	expired: "Caducó el",
	current: "Vigente hasta el"
},
	documentAdded: documentAdded,
	documentType: documentType,
	documentTypes: documentTypes,
	"documentTypes-opt": {
	listWithCount: "{{count}} Tipo de documento",
	listWithCount_plural: "{{count}} Tipos de documentos"
},
	doNotAssociate: doNotAssociate,
	dragData: dragData,
	driver: driver,
	drivers: drivers,
	"driver/medium": "Conductor / Medio",
	duplicate: duplicate,
	duplicateService: duplicateService,
	E: E,
	edit: edit,
	editAuxService: editAuxService,
	editCapability: editCapability,
	editCollective: editCollective,
	editCost: editCost,
	editCostType: editCostType,
	editFault: editFault,
	editSupportTeam: editSupportTeam,
	editUserProfile: editUserProfile,
	email: email,
	endService: endService,
	entry: entry,
	entryDateAbbrev: entryDateAbbrev,
	error: error,
	errorAddingDocument: errorAddingDocument,
	estimatedTime: estimatedTime,
	execution: execution,
	executionProfile: executionProfile,
	expense: expense,
	expiredCode: expiredCode,
	expires: expires,
	events: events,
	excessOfTimeForOutService: excessOfTimeForOutService,
	excessOfTimeForUrbanService: excessOfTimeForUrbanService,
	excessOfTimeInCurrentStatus: excessOfTimeInCurrentStatus,
	excessOfTimeToCompleteService: excessOfTimeToCompleteService,
	excessOfTimeToStartScheduledService: excessOfTimeToStartScheduledService,
	F: F,
	fault: fault,
	faults: faults,
	faultCollectiveAbbrev: faultCollectiveAbbrev,
	faultWithCount: faultWithCount,
	faultWithCount_plural: faultWithCount_plural,
	fee: fee,
	fieldRequired: fieldRequired,
	"fields with an asterisk are required": "Los campos con (*) son obligatorios.",
	file: file,
	"filecase/assistedAbbrev": "Exp. / asistido",
	"filecase/interventionAbbrev": "Exp./Int.",
	filterByDriverStatus: filterByDriverStatus,
	filterByVehicleType: filterByVehicleType,
	financial: financial,
	financialBreakdown: financialBreakdown,
	finish: finish,
	finishedServices: finishedServices,
	firstPrice: firstPrice,
	firstUnitPriceAbbrev: firstUnitPriceAbbrev,
	fixed: fixed,
	"for": "Para",
	"forgotPassword?": "¿Olvidaste la contraseña?",
	formError: formError,
	franchise: franchise,
	franchises: franchises,
	freeCranesBefore1Hour: freeCranesBefore1Hour,
	fromUntil: fromUntil,
	fullAddress: fullAddress,
	fullScreenAbbrev: fullScreenAbbrev,
	G: G,
	generalInformationAbbrev: generalInformationAbbrev,
	generate: generate,
	generated: generated,
	geofence: geofence,
	geofence_plural: geofence_plural,
	geofenceWithCount: geofenceWithCount,
	geofenceWithCount_plural: geofenceWithCount_plural,
	geoJson: geoJson,
	globalAuction: globalAuction,
	graceDays: graceDays,
	grecaptchaNote: grecaptchaNote,
	guardMode: guardMode,
	H: H,
	help: help,
	hide: hide,
	holder: holder,
	holidays: holidays,
	home: home,
	hour: hour,
	hours: hours,
	I: I,
	IBAN: IBAN,
	icon: icon,
	iconUrl: iconUrl,
	identificationIcon: identificationIcon,
	"If you finish the service you will no longer be able to edit or reschedule it Do you wish to continue?": "Si finalizas el servicio, ya no podrás editarlo o reprogramarlo. ¿Deseas continuar?",
	"If you recover the saved request you will lose the data you have entered in the form do you wish to continue?": "Si recuperas la solicitud guardada, perderás los datos que has introducido en el formulario, ¿deseas continuar?",
	"If you delete the request the saved data will be deleted Do you wish to continue?": "Si eliminas la solicitud, se borrarán los datos guardados, ¿deseas continuar?",
	"If you prefer, you can send the service to a waiting list": "Si lo prefieres, puedes enviar el servicio a una lista de espera",
	image: image,
	immediate: immediate,
	immediate_plural: immediate_plural,
	immediateService: immediateService,
	"import": "Importar",
	incorrectLocationFormat: incorrectLocationFormat,
	infoWindowIcon: infoWindowIcon,
	inParking: inParking,
	inRis: inRis,
	inris: inris,
	inServiceResourcesWithCount: inServiceResourcesWithCount,
	inServiceResourcesWithCount_plural: inServiceResourcesWithCount_plural,
	instant: instant,
	insurancePolicyInfo: insurancePolicyInfo,
	insured: insured,
	insured_autoType: insured_autoType,
	insured_homeType: insured_homeType,
	insuredAutoType: insuredAutoType,
	insuredHomeType: insuredHomeType,
	insuredObjectAbbrev: insuredObjectAbbrev,
	insuredProperty: insuredProperty,
	integrationProfile: integrationProfile,
	integrationProfileAbbrev: integrationProfileAbbrev,
	internalCode: internalCode,
	internalNote: internalNote,
	internalNotes: internalNotes,
	interrupted: interrupted,
	intervention: intervention,
	interventionAbbrev: interventionAbbrev,
	interventions: interventions,
	inUrbanArea: inUrbanArea,
	invalidNexusFilecase: invalidNexusFilecase,
	invalidText: invalidText,
	invoice: invoice,
	"invoice (services - base)": "Factura (servicios - base)",
	"invoice-status": {
	pending: "Pendiente",
	billed: "Facturada",
	collected: "Cobrada",
	payed: "Pagada"
},
	invoiceNumberAbbrev: invoiceNumberAbbrev,
	forTheDay: forTheDay,
	isNotValid: isNotValid,
	issuedInvoices: issuedInvoices,
	itAlreadyExists: itAlreadyExists,
	J: J,
	K: K,
	L: L,
	label: label,
	labeled: labeled,
	"labeled-opt": {
	listWithCount: "{{count}} Rotulación",
	listWithCount_plural: "{{count}} Rotulaciones"
},
	labels: labels,
	lastActivity: lastActivity,
	lastActivity2: lastActivity2,
	legal: legal,
	legalId: legalId,
	list: list,
	listEntryMax24H: listEntryMax24H,
	loaded: loaded,
	loadTimeInMinutes: loadTimeInMinutes,
	located: located,
	location: location,
	locked: locked,
	lockedByNexus: lockedByNexus,
	login: login,
	logo: logo,
	logout: logout,
	M: M,
	managed: managed,
	managedProvider: managedProvider,
	manual: manual,
	manualProvider: manualProvider,
	map: map,
	mapIcon: mapIcon,
	mapOfGoingServices: mapOfGoingServices,
	mapOfResources: mapOfResources,
	mapOfTracking: mapOfTracking,
	mapView: mapView,
	max: max,
	maxAllowedTimeInMinutes: maxAllowedTimeInMinutes,
	maxDistance: maxDistance,
	maxDistanceToCrane: maxDistanceToCrane,
	maxHours: maxHours,
	maxRadius: maxRadius,
	maxTime: maxTime,
	maxTimeOnList: maxTimeOnList,
	medium: medium,
	mediumNotFound: mediumNotFound,
	mediumType: mediumType,
	mediumTypes: mediumTypes,
	mediumTypes2: mediumTypes2,
	"mediumTypes-opt": {
	listWithCount: "{{count}} Tipo de medio",
	listWithCount_plural: "{{count}} Tipos de medios"
},
	minute: minute,
	minutes: minutes,
	modeAndName: modeAndName,
	model: model,
	modifiedCollective: modifiedCollective,
	modifiedFault: modifiedFault,
	myTickets: myTickets,
	N: N,
	name: name,
	nameSurname: nameSurname,
	"new": "Nuevo",
	new_female: new_female,
	new_plural: new_plural,
	newAuxService: newAuxService,
	newAuxiliaryService: newAuxiliaryService,
	newDayAndTime: newDayAndTime,
	newPassword: newPassword,
	newService: newService,
	newSupportTeam: newSupportTeam,
	newVehicleAssistance: newVehicleAssistance,
	newVialService: newVialService,
	nexusMapServiceError: nexusMapServiceError,
	nick: nick,
	no: no,
	noProvidersAvailable: noProvidersAvailable,
	notApplyCosts: notApplyCosts,
	notParticipating: notParticipating,
	noCovered: noCovered,
	noDocumentsAssociatedToService: noDocumentsAssociatedToService,
	noResourcesAvailableMsg: noResourcesAvailableMsg,
	noSubscribe: noSubscribe,
	note: note,
	notes: notes,
	notesAssociatedWithTheService: notesAssociatedWithTheService,
	noTicketsAssociatedToService: noTicketsAssociatedToService,
	noTicketsAssociatedToTransfer: noTicketsAssociatedToTransfer,
	noNotesAssociatedToService: noNotesAssociatedToService,
	notifications: notifications,
	noTransfersAvailable: noTransfersAvailable,
	noValid: noValid,
	numberAbbrev: numberAbbrev,
	numberOfPeopleAbbrev: numberOfPeopleAbbrev,
	numberOfReviewsAbbrev: numberOfReviewsAbbrev,
	O: O,
	office: office,
	ongoing: ongoing,
	onQueue: onQueue,
	openDispute: openDispute,
	operational: operational,
	operationTypes: operationTypes,
	"operationTypes-opt": {
	listWithCount: "{{count}} Tipo de intervención",
	listWithCount_plural: "{{count}} Tipos de intervención"
},
	origin: origin,
	originalServiceData: originalServiceData,
	originDeposit: originDeposit,
	otherSettings: otherSettings,
	orYouCan: orYouCan,
	outlay: outlay,
	outlays: outlays,
	"outlays-opt": {
	listWithCount: "{{count}} Gasto adicional",
	listWithCount_plural: "{{count}} Gastos adicionales"
},
	P: P,
	paid: paid,
	passengers: passengers,
	passengersWithCount: passengersWithCount,
	passengersWithCount_plural: passengersWithCount_plural,
	password: password,
	passwordsNotMatch: passwordsNotMatch,
	paymentsToProviders: paymentsToProviders,
	"paymentsToProviders-opt": {
	listWithCount: "{{count}} Pago a proveedor",
	listWithCount_plural: "{{count}} Pagos a proveedores"
},
	pdf: pdf,
	pending: pending,
	pendings: pendings,
	PENDING: PENDING,
	pending_assign: pending_assign,
	PENDING_ASSIGN: PENDING_ASSIGN,
	PENDINGASSIGN: PENDINGASSIGN,
	pendingDocumentation: pendingDocumentation,
	pendingDocuments: pendingDocuments,
	"pendingDocuments-opt": {
	listWithCount: "{{count}} Documento pendiente",
	listWithCount_plural: "{{count}} Documentos pendientes"
},
	pendingPassword: pendingPassword,
	pendingProfile: pendingProfile,
	peopleTransferActivity: peopleTransferActivity,
	pleaseTryAgainLater: pleaseTryAgainLater,
	"Please indicate the reason for cancelling the service and enter the charges if necessary": "Por favor, indica el motivo por el que anulas el servicio, e introduce los gastos si es necesario.",
	phone: phone,
	phoneNumberAbbrev: phoneNumberAbbrev,
	photoWithCount: photoWithCount,
	photoWithCount_plural: photoWithCount_plural,
	photos: photos,
	planned: planned,
	PLANNED: PLANNED,
	plannedService: plannedService,
	plate: plate,
	plateDoesNotCorrespondToTheFilecase: plateDoesNotCorrespondToTheFilecase,
	policy: policy,
	policyCoverageLimit: policyCoverageLimit,
	policyCoverageLimit2: policyCoverageLimit2,
	policyInformation: policyInformation,
	policyLimitExceeded: policyLimitExceeded,
	policyLimitExceededAux: policyLimitExceededAux,
	policyNumberAbbrev: policyNumberAbbrev,
	policySearch: policySearch,
	positionAbbrev: positionAbbrev,
	"price(approx)": "Precio (aprox.)",
	priority: priority,
	priority1Providers: priority1Providers,
	priority2Providers: priority2Providers,
	priority3Providers: priority3Providers,
	priorityAllProviders: priorityAllProviders,
	priorityProvider: priorityProvider,
	process: process$1,
	profile: profile,
	profileNotFound: profileNotFound,
	profiles: profiles,
	"profiles-opt": {
	listWithCount: "{{count}} Perfil",
	listWithCount_plural: "{{count}} Perfiles",
	addTitle: "Añadir perfil",
	addText: "Completa los datos del perfil para añadirlo.",
	toastAddSuccessTitle: "Perfil creado correctamente",
	toastAddSuccessText: "El perfil ha sido creado y añadido a la lista."
},
	proposals: proposals,
	provider: provider,
	providersInZone: providersInZone,
	providersOutZone: providersOutZone,
	providerTechnician: providerTechnician,
	providerVialSettings: providerVialSettings,
	providerEditVialSettingsHeaderText: providerEditVialSettingsHeaderText,
	providerAuxiliariesSettings: providerAuxiliariesSettings,
	providerEditAuxiliariesSettingsHeaderText: providerEditAuxiliariesSettingsHeaderText,
	"provider/driverAbbrev": "Prov / conductor",
	providers: providers,
	provider_pending: provider_pending,
	PROVIDER_PENDING: PROVIDER_PENDING,
	PROVIDERPENDING: PROVIDERPENDING,
	provider_accepted: provider_accepted,
	PROVIDER_ACCEPTED: PROVIDER_ACCEPTED,
	PROVIDERACCEPTED: PROVIDERACCEPTED,
	provider_accept: provider_accept,
	PROVIDER_ACCEPT: PROVIDER_ACCEPT,
	PROVIDERACCEPT: PROVIDERACCEPT,
	providersSelection: providersSelection,
	providerList: providerList,
	providersMap: providersMap,
	providerType: providerType,
	providerTypeVial: providerTypeVial,
	providerTypeAux: providerTypeAux,
	providerWithoutDefinedDeposit: providerWithoutDefinedDeposit,
	province: province,
	Q: Q,
	queueEntryDate: queueEntryDate,
	queued: queued,
	QUEUED: QUEUED,
	queuedService: queuedService,
	R: R,
	rates: rates,
	rating: rating,
	ratings: ratings,
	ratingsUserName: ratingsUserName,
	ratingsWithCount: ratingsWithCount,
	ratingsWithCount_plural: ratingsWithCount_plural,
	ready: ready,
	reAssign: reAssign,
	reAssignProvider: reAssignProvider,
	reAskForResetEmail: reAskForResetEmail,
	received: received,
	receivedInvoices: receivedInvoices,
	recoverRequest: recoverRequest,
	recoverYourPassword: recoverYourPassword,
	region: region,
	registrationInformationOnInvoices: registrationInformationOnInvoices,
	reject: reject,
	rejectCosts: rejectCosts,
	rejectionReason: rejectionReason,
	rejectionReasons: rejectionReasons,
	"rejectionReasons-opt": {
	listWithCount: "{{count}} Motivo de rechazo",
	listWithCount_plural: "{{count}} Motivos de rechazo"
},
	rejectionType: rejectionType,
	release: release,
	removeFromDashboard: removeFromDashboard,
	repeated: repeated,
	repeatPassword: repeatPassword,
	requestCapability: requestCapability,
	requestInfo: requestInfo,
	requestLocationByWhatsApp: requestLocationByWhatsApp,
	requestMediumAbbrev: requestMediumAbbrev,
	requestProcessedCorrectly: requestProcessedCorrectly,
	requestWithoutIAssociatedPolicy: requestWithoutIAssociatedPolicy,
	required: required,
	reschedule: reschedule,
	RESCHEDULED: RESCHEDULED,
	rescheduleComment: rescheduleComment,
	rescheduleReason: rescheduleReason,
	rescheduleService: rescheduleService,
	rescheduleServiceDeferredTextModal: rescheduleServiceDeferredTextModal,
	rescheduleServicePlannedText1Modal: rescheduleServicePlannedText1Modal,
	rescheduleServicePlannedText2Modal: rescheduleServicePlannedText2Modal,
	resetPassword: resetPassword,
	resetYourPassword: resetYourPassword,
	resources: resources,
	resourcesMap: resourcesMap,
	restore: restore,
	result: result,
	"return": "Volver",
	ris: ris,
	risService: risService,
	S: S,
	save: save,
	saveChanges: saveChanges,
	savedRequests: savedRequests,
	saveRequest: saveRequest,
	"Saving your request for later retrieval will delete the form data Do you wish to continue?": "Guardando la solicitud para recuperarla más tarde, se borrarán los datos del formulario, ¿deseas continuar?",
	schedule: schedule,
	scheduled: scheduled,
	SCHEDULED: SCHEDULED,
	scheduled_plural: scheduled_plural,
	scheduledAbbrev: scheduledAbbrev,
	scheduledDateInvalidErrorText: scheduledDateInvalidErrorText,
	scheduleDriver: scheduleDriver,
	scheduledServiceNotFound: scheduledServiceNotFound,
	scheduledFor: scheduledFor,
	searchResourceOrTechnician: searchResourceOrTechnician,
	searchResources: searchResources,
	searchAResource: searchAResource,
	searchAService: searchAService,
	searchByAssistedOrFilecase: searchByAssistedOrFilecase,
	searchByAssistedFilecaseOrPlate: searchByAssistedFilecaseOrPlate,
	searchByAssistedFilecaseOrProvider: searchByAssistedFilecaseOrProvider,
	searchByCodeOrName: searchByCodeOrName,
	searchByCodeNameOrCostType: searchByCodeNameOrCostType,
	searchByCodeNameOrMediumType: searchByCodeNameOrMediumType,
	searchByCustomer: searchByCustomer,
	searchByCustomerOrFilecase: searchByCustomerOrFilecase,
	searchByCustomerFilecaseOrPlate: searchByCustomerFilecaseOrPlate,
	searchByFileCase: searchByFileCase,
	searchByIdForOrFilecaseNumber: searchByIdForOrFilecaseNumber,
	searchByInvoiceNumber: searchByInvoiceNumber,
	searchByName: searchByName,
	searchByNameCIFOrAddress: searchByNameCIFOrAddress,
	searchByNameOrAddress: searchByNameOrAddress,
	searchByNameOrCode: searchByNameOrCode,
	searchByNamePlateOrCode: searchByNamePlateOrCode,
	searchByNameSurnameUserOrNick: searchByNameSurnameUserOrNick,
	searchByProviderOrName: searchByProviderOrName,
	searchByTerm: searchByTerm,
	searchInsurancePolicy: searchInsurancePolicy,
	seeAverages: seeAverages,
	breakdown: breakdown,
	seeCapabilityComment: seeCapabilityComment,
	seeComment: seeComment,
	seeContactAndComment: seeContactAndComment,
	seeDescription: seeDescription,
	seeService: seeService,
	"Select a transfer associated with the service": "Selecciona un traslado asociado al servicio",
	selfValidated: selfValidated,
	send: send,
	sendComments: sendComments,
	sended: sended,
	sendEmail: sendEmail,
	sendForReview: sendForReview,
	sendTo: sendTo,
	sendToList: sendToList,
	serverConnectionError: serverConnectionError,
	service: service,
	serviceExecution: serviceExecution,
	serviceInAuction: serviceInAuction,
	serviceLevels: serviceLevels,
	serviceMap: serviceMap,
	serviceNotFound: serviceNotFound,
	serviceRequestAndTracking: serviceRequestAndTracking,
	services: services,
	serviceSentToAuction: serviceSentToAuction,
	serviceStatus: serviceStatus,
	settings: settings,
	settingsUpdated: settingsUpdated,
	sharedCode: sharedCode,
	sharedNote: sharedNote,
	sharedNotes: sharedNotes,
	"shipment (services - base)": "Remesa (servicios - base)",
	shipments: shipments,
	shipmentStatusValues: shipmentStatusValues,
	showAllMediums: showAllMediums,
	showSolicitedMedium: showSolicitedMedium,
	situation: situation,
	solicitedMedium: solicitedMedium,
	sortCriteria: sortCriteria,
	soundActivated: soundActivated,
	soundOff: soundOff,
	start: start,
	started: started,
	status: status,
	statuses: statuses,
	subject: subject,
	subscribe: subscribe,
	subtotal: subtotal,
	suburb: suburb,
	suburbService: suburbService,
	summary: summary,
	supportCenter: supportCenter,
	supportTeam: supportTeam,
	survey: survey,
	surveys: surveys,
	T: T,
	taxes: taxes,
	team: team,
	teamName: teamName,
	technician: technician,
	technicians: technicians,
	"The maximum date range allowed is 45 days": "El rango de fechas máximo permitido es de 45 días",
	"The request could not be made Try again": "No se ha podido realizar la solicitud. Inténtalo de nuevo.",
	"The proposal could not be retrieved because the collective does not exist": "No se ha podido recuperar la solicitud porque el colectivo no existe",
	"The service has been sent successfully": "El servicio se ha enviado correctamente.",
	"The service rejection could not be completed": "El rechazo del servicio no ha podido completarse.",
	"The service will be sent after completing the request process": "El servicio se enviará tras completar el proceso de solicitud",
	theField: theField,
	ticket: ticket,
	tickets: tickets,
	ticketStatus: ticketStatus,
	time: time,
	"time(approx)": "Tiempo (aprox.)",
	timeInAlert: timeInAlert,
	timeline: timeline,
	title: title,
	toastErrorDuplicateAddressPickupDeliveryTitle: toastErrorDuplicateAddressPickupDeliveryTitle,
	toastErrorDuplicateAddressPickupDeliveryText: toastErrorDuplicateAddressPickupDeliveryText,
	toastErrorDuplicateAddressPickupDestinationTitle: toastErrorDuplicateAddressPickupDestinationTitle,
	toastErrorDuplicateAddressPickupDestinationText: toastErrorDuplicateAddressPickupDestinationText,
	toastErrorTextDefault: toastErrorTextDefault,
	toastErrorTitleDefault: toastErrorTitleDefault,
	toastErrorTransferPeopleBudget: toastErrorTransferPeopleBudget,
	toastErrorTitle_downloadFile: toastErrorTitle_downloadFile,
	toastErrorText_downloadFile: toastErrorText_downloadFile,
	toastSuccessTextDefault: toastSuccessTextDefault,
	toastSuccessTitleDefault: toastSuccessTitleDefault,
	today: today,
	toDefine: toDefine,
	total: total,
	totals: totals,
	toTheClient: toTheClient,
	toTheProvider: toTheProvider,
	town: town,
	tracking: tracking,
	trackingMessage: trackingMessage,
	transfer: transfer,
	transferHasBeenCancelled: transferHasBeenCancelled,
	transferPeople: transferPeople,
	transferPeopleBudget: transferPeopleBudget,
	transferPeopleRequest: transferPeopleRequest,
	transferPeopleRequestType: transferPeopleRequestType,
	transferPeopleRequiredValidPhoneNumber: transferPeopleRequiredValidPhoneNumber,
	transfers: transfers,
	transfersAvailable: transfersAvailable,
	transferTheAssisted: transferTheAssisted,
	type: type,
	typeAndName: typeAndName,
	"type/capability": "Tipo/prestación",
	typeless: typeless,
	typeOfService: typeOfService,
	types: types,
	U: U,
	"undefined": "Sin definir",
	udWithCount: udWithCount,
	udWithCount_plural: udWithCount_plural,
	unAssign: unAssign,
	unAssignTechnician: unAssignTechnician,
	unAssignTechnicianModalText: unAssignTechnicianModalText,
	unAssignTechnicianModalAditionalText: unAssignTechnicianModalAditionalText,
	unAssignDriver: unAssignDriver,
	unAssignDriverModalText: unAssignDriverModalText,
	unAssignDriverModalAditionalText: unAssignDriverModalAditionalText,
	unavailable: unavailable,
	units: units,
	unitAbbrev: unitAbbrev,
	unitsAbbrev: unitsAbbrev,
	unselected: unselected,
	unsubscribe: unsubscribe,
	urban: urban,
	urbanFee: urbanFee,
	urbanService: urbanService,
	user: user,
	userProfiles: userProfiles,
	userProfilesWithCount: userProfilesWithCount,
	userProfilesWithCount_plural: userProfilesWithCount_plural,
	users: users,
	"users-opt": {
	listWithCount: "{{count}} Usuario",
	listWithCount_plural: "{{count}} Usuarios"
},
	userType: userType,
	V: V,
	validFrom: validFrom,
	validUntil: validUntil,
	variable: variable,
	vehicleAssistance: vehicleAssistance,
	vehicleTypes: vehicleTypes,
	"vehicleTypes-opt": {
	listWithCount: "{{count}} Tipo de vehículo",
	listWithCount_plural: "{{count}} Tipos de vehículos"
},
	"vehicle/fault": "Vehículo / Avería",
	version: version,
	vial: vial,
	vials: vials,
	vialRates: vialRates,
	vialServices: vialServices,
	vialSettings: vialSettings,
	view: view,
	viewAssistedRating: viewAssistedRating,
	viewContact: viewContact,
	viewContactandComment: viewContactandComment,
	viewRoute: viewRoute,
	views: views,
	vin: vin,
	virtualSwitchboard: virtualSwitchboard,
	W: W,
	waitingList: waitingList,
	web: web,
	webAddress: webAddress,
	wholeWordSearch: wholeWordSearch,
	wholeWordSearch3Charts: wholeWordSearch3Charts,
	withAlert: withAlert,
	withholdings: withholdings,
	withPriority1: withPriority1,
	withPriority2: withPriority2,
	withPriority3: withPriority3,
	writeANote: writeANote,
	wrongUser: wrongUser,
	wrongUsernameOrPassword: wrongUsernameOrPassword,
	X: X,
	Y: Y,
	year: year,
	yes: yes,
	yesterday: yesterday,
	youHaveExceededTheNumberOfAtempsts: youHaveExceededTheNumberOfAtempsts,
	Z: Z,
	"A dispute has been opened for this service": "Se ha abierto una disputa para este servicio.",
	"Add the following cost data": "Añade los siguientes datos del costo.",
	"Add the following cost type data": "Añade los siguientes datos del tipo de costo.",
	"Allow assigning rate in service request": "Asignar la tarifa en la solicitud de servicio",
	"Allow opening internal tickets": "Permitir abrir tickets internos",
	"An error has occurred in the creation of the collective": "Ha ocurrido un error en la creación del colectivo.",
	"An error has occurred in the creation of the fault": "Ha ocurrido un error en la creación de la avería.",
	"An error occurred while trying to upload the file": "Ha ocurrido un error al intentar subir el archivo.",
	"Approve costs": "Aprobar costos",
	"Are you sure you want to approve the cost sheet? Once approved you will not be able to request changes": "¿Seguro que deseas aprobar la hoja de costos? Una vez aprobada, no podrás solicitar cambios.",
	"Are you sure you want to send the cost sheet for review? Once it has been sent you will not be able to edit it again": "¿Seguro que deseas enviar la hoja de costos a revisión? Una vez enviada, no podrás editarla de nuevo.",
	"Assistance has arrived at pickup": "La asistencia ha llegado a la recogida",
	"Assistance is on the way": "La asistencia está en camino",
	"Assistance reached its destination": "La asistencia llegó a su destino",
	"At this time it is not possible to access the service": "En estos momentos no es posible acceder al servicio",
	"Attention a new service will be requested without any associated policy": "Atención, se va a solicitar un nuevo servicio sin ninguna póliza asociada.",
	"Capability created successfully": "Prestación creada correctamente",
	"Capability has been created and added to the list": "La prestación ha sido creada y añadida a la lista.",
	"Capability has been updated successfully": "La prestación ha sido actualizada correctamente.",
	"Capability updated": "Prestación actualizada",
	"Complete the data of the auxiliar service to add it": "Completa los datos del servicio auxiliar para añadirlo.",
	"Complete the data of the auxiliar service to edit it": "Completa los datos del servicio auxiliar para editarlo.",
	"Complete the data of the capability to add it": "Completa los datos de la prestación para añadirla.",
	"Complete the data of the capability to edit it": "Completa los datos de la prestación para editarla.",
	"Complete the data of the collective to add it": "Completa los datos del colectivo para añadirlo.",
	"Complete the data of the fault to add it": "Completa los datos de la avería para añadirla.",
	"Contact your insurer for more information": "Contacta con tu aseguradora para más información",
	"Costs approved successfully": "Costos aprobados correctamente",
	"Costs could not be approved": "No ha sido posible aprobar los costos",
	"Costs could not be rejected": "No ha sido posible rechazar los costos",
	"Cost created successfully": "Costo creado correctamente",
	"Costs rejected successfully": "Costos rechazados correctamente",
	"Costs sheet approved": "Hoja de costos aprobada",
	"Cost sheet could not be saved": "No ha sido posible guardar la hoja de costos",
	"Cost sheet could not be sent for review": "No ha sido posible enviar a revisión la hoja de costos",
	"Cost sheet rejected": "Hoja de costos rechazada",
	"Costs sheet saved successfully": "Hoja de costos guardada con éxito",
	"Costs sheet sent for review": "Hoja de costos enviada a revisión",
	"CostType created successfully": "Tipo de costo creado correctamente",
	"Cost has been created and added to the list": "El costo ha sido creado y añadido a la lista",
	"CostType has been created and added to the list": "El tipo de costo ha sido creado y añadido a la lista",
	"Cost has been updated successfully": "El costo ha sido actualizado correctamente.",
	"CostType has been updated successfully": "El tipo de costo ha sido actualizado correctamente.",
	"Cost updated": "Costo actualizado",
	"CostType updated": "Tipo de costo actualizado",
	"Data has been saved successfully": "Los datos se han guardado correctamente",
	"Do not allow the assistant to call the driver from the tracking widget": "No permitir al asistido llamar al chofer desde el widget de seguimiento",
	"Do not allow technician to create notes": "No permitir al técnico crear notas",
	"Do not allow the operator to select providers": "No permitir al operador seleccionar proveedores",
	"Do not allow the technician to reschedule the service": "No permitir al técnico reprogramar el servicio",
	"Do not show the technician the assisted person phone number": "No mostrar al técnico el teléfono del asistido",
	"Do not take into account the first section for the calculation of the rate": "No tener en cuenta el primer tramo para el cálculo de la tarifa",
	"Do you want to send the request": "¿Deseas enviar la solicitud?",
	"Edit the data you need for the following cost": "Edita los datos que necesites del siguiente costo.",
	"Edit the data you need for the following type cost": "Edita los datos que necesites del siguiente tipo de costo.",
	"Edit the data you need from the following collective": "Edita los datos que necesites del siguiente colectivo.",
	"Edit the data you need from the following fault": "Edita los datos que necesites de la siguiente avería.",
	"Edit the details you need for the following user profile": "Edita los datos que necesites del siguiente perfil de usuario.",
	"Error creating capability": "Error al crear prestación",
	"Error creating cost": "Error al crear costo",
	"Error creating costType": "Error al crear tipo de costo",
	"Error creating user profile": "Error al crear perfil de usuario",
	"Error has ocurred while creating the capability": "Ha ocurrido un error en la creación de la prestación.",
	"Error has ocurred while creating the cost": "Ha ocurrido un error durante la creación del costo.",
	"Error has ocurred while creating the costType": "Ha ocurrido un error durante la creación del tipo de costo.",
	"Error has ocurred while creating the user profile": "Ha ocurrido un error durante la creación del perfil de usuario.",
	"Error has ocurred while updating the capability": "Ha ocurrido un error durante la actualización de la prestación.",
	"Error has ocurred while updating the cost": "Ha ocurrido un error durante la actualización del costo.",
	"Error has ocurred while updating the costType": "Ha ocurrido un error durante la actualización del tipo de costo.",
	"Error has ocurred while updating the user profile": "Ha ocurrido un error durante la actualización del perfil de usuario.",
	"Error updating capability": "Error al actualizar prestación",
	"Error updating cost": "Error al actualizar costo",
	"Error updating costType": "Error al actualizar tipo de costo",
	"Error updating user profile": "Error al actualizar perfil de usuario",
	"Fill in the details of the user profile to add it": "Completa los datos del perfil del usuario para añadirlo.",
	"Follow your roadside assistance service in real time by clicking on the continue button": "Sigue en tiempo real tu servicio de asistencia en carretera, pulsando en el botón de continuar",
	"Follow your assistance service in real time by clicking on the continue button": "Sigue en tiempo real tu servicio de asistencia, pulsando en el botón de continuar",
	"Hide middle phone in tracking widget": "Ocultar el teléfono del medio en el widget de seguimiento",
	"It is not possible to access": "No es posible acceder",
	"It has not been possible to add the new note to the service": "No ha sido posible añadir al servicio la nueva nota.",
	"It has not been possible to consult the events associated with the service": "No ha sido posible consultar los eventos asociados al servicio.",
	"It has not been possible to modify the collective data": "No ha sido posible modificar los datos del colectivo.",
	"It has not been possible to modify the fault data": "No ha sido posible modificar los datos de la avería.",
	"It has not been possible to update the information": "No ha sido posible actualizar la información",
	"It was not possible to finish the service": "No ha sido posible finalizar el servicio.",
	"It was not possible to obtain the survey data": "No ha sido posible obtener los datos de la encuesta.",
	"It was not possible to recover the integration profiles": "No ha sido posible recuperar los perfiles de integración.",
	"Manage the documents necessary to work with Nexus": "Gestiona los documentos necesarios para trabajar con Nexus",
	"No auction providers found at the service location": "No se han encontrado proveedores de subasta en la ubicación del servicio",
	"No changes have been made to the service": "No se han realizado cambios en el servicio.",
	"Please indicate the reason why you wish to reject the costs associated with the service": "Por favor, indica el motivo por el que deseas rechazar los costos que están asociados al servicio.",
	"Please retry in a few minutes": "Vuelve a intentarlo en unos minutos.",
	"Plot the geofence on the map, complete the information and press the save button": "Define la geocerca en el mapa, completa la información y pulsa el botón guardar",
	"__providerName settings have been updated": "Los ajustes de {{providerName}} han sido actualizados",
	"Reload the page or contact your company": "Recarga la página o contacta con tu compañía",
	"Request processed correctly": "Solicitud procesada de forma correcta",
	"Select a provider to assign to the service": "Selecciona un proveedor para asignar al servicio.",
	"Select the providers that will participate in the auction": "Selecciona los proveedores que participarán en la subasta",
	"Send costs for review": "Enviar costos a revisión",
	"Service acceptance could not be completed": "La aceptación del servicio no ha podido completarse.",
	"Service assignment could not be completed": "La asignación del servicio no ha podido completarse.",
	"Service requested from the widget": "Servicio solicitado desde el widget",
	"Sorry attendance has been canceled": "Lo sentimos, la asistencia ha sido cancelada",
	"Spoofing the assisted phone number": "Suplantación del nº de teléfono del asistido",
	"Successfully sent, under review": "Enviada correctamente, está en revisión",
	"Support has ended": "La asistencia ha finalizado",
	"Thank you very much for your confidence": "Muchas gracias por tu confianza",
	"The collective has been created and added to the list": "El colectivo ha sido creado y añadido a la lista.",
	"The cost could not be modified": "El costo no ha podido ser modificado",
	"The dispute for this service has been closed": "Se ha cerrado la disputa para este servicio.",
	"The document has been attached to the service": "El documento se ha adjuntado al servicio.",
	"The fault has been created and added to the list": "La avería ha sido creada y añadida a la lista.",
	"The file must be pdf jpg or png": "El archivo tiene que ser: pdf, jpg o png.",
	"The service has been canceled": "El servicio ha sido anulado.",
	"The service has been created and added to the list": "El servicio ha sido creado y añadido a la lista.",
	"The service has been rescheduled": "El servicio ha sido reprogramado.",
	"The service has been scheduled for the day": "El servicio ha sido programado para el día",
	"There is no assigned provider": "No hay proveedor asignado",
	"There are no documents associated": "No hay documentos asociados",
	"There are no events associated with the service": "No hay eventos asociados al servicio.",
	"This service is in finished status As an administrator you can cancel it": "Este servicio está en estado finalizado. Como administrador, puedes anularlo.",
	"User profile created successfully": "Perfil de usuario creado correctamente",
	"User profile has been created and added to the list": "El perfil de usuario ha sido creado y añadido a la lista.",
	"User profile has been updated successfully": "El perfil de usuario ha sido actualizado correctamente.",
	"User profile updated": "Perfil de usuario actualizado",
	"We are at your disposal whenever you need it": "Estamos a tu disposición siempre que lo necesites",
	"We are sorry It has not been possible to show the tracking of your service": "Lo sentimos. No ha sido posible mostrar el seguimiento de tu servicio.",
	"We are trying to repair your vehicle": "Estamos tratando de reparar tu vehículo",
	"We have not been able to connect you to our network": "No hemos podido conectarte a nuestra red",
	"We have updated the information of the collective": "La información del colectivo se ha actualizado correctamente.",
	"We have updated the information of the fault": "La información de la avería se ha actualizado correctamente.",
	"Welcome to the __companyName tracking platform": "Bienvenido a la plataforma de seguimiento de {{companyName}}",
	"Your company does not have integration defined with Azure": "",
	"Your user is blocked by Nexus": "Tu usuario está bloquedado por Nexus",
	"Your vehicle is being moved": "Tu vehículo está siendo trasladado",
	"********** END CHECKED WORDS **********": "",
	"********** BEGIN PHRASES **********": "**********",
	"No services performed since the renewal date": "No hay servicios realizados desde la fecha de renovación",
	"********** BEGIN COMPANY PROFILE SETTINGS **********": "**********",
	"Assignment algorithm": "Algoritmo de asignación",
	"Service request": "Solicitud del servicio",
	"SMS messages": "Mensajes SMS",
	"Maximum time given to a resource to accept or reject a service": "Tiempo máximo que se le otorga a un recurso para aceptar o rechazar un servicio",
	"Maximum time given to a provider to accept or reject a service": "Tiempo máximo que se le otorga a un proveedor para aceptar o rechazar un servicio",
	"Maximum time in which a service request can be accepted": "Tiempo máximo en el que se puede aceptar una solicitud de servicio",
	"Maximum time for all providers": "Tiempo máximo para todos los proveedores",
	"Maximum time for providers with priority": "Tiempo máximo para proveedores con prioridad {{priority}}",
	"Maximum radial distance to search for resources in a service request": "Distancia máxima radial para buscar recursos en una solicitud de servicio",
	"Default distance when sending a to assign a waiting service to a resource": "Distancia por defecto al enviar un servicio a la lista de espera",
	"Maximum total distance of a service route": "Distancia máxima total de la ruta de un servicio",
	"Origin location for calculating the rate in automatic services": "Ubicación de origen para el cálculo de la tarifa en servicios automáticos",
	"From deposit": "Desde depósito",
	"From resource": "Desde recurso",
	"Show option to cancel services at no cost": "Mostrar opción de anular servicios sin coste",
	"Show policy information in the service file": "Mostrar datos de póliza en la ficha del servicio",
	"Block editing of the fault": "Bloquear la edición de la avería",
	"Show the clone services button": "Mostrar el botón de clonar servicios",
	"Show the mandatory damage report by default": "Mostrar el parte de daños obligatorio por defecto",
	"Maximum number of photos that can be requested in a service": "Máximo nº de fotos que se pueden solicitar en un servicio",
	"Number of mandatory photos by default": "Número de fotos obligatorias por defecto",
	"Message sender": "Remitente de los mensajes",
	maxMinutes: maxMinutes,
	maxPhotos: maxPhotos,
	between0And5Minutes: between0And5Minutes,
	between0And10Minutes: between0And10Minutes,
	between0And240Minutes: between0And240Minutes,
	between1And7Minutes: between1And7Minutes,
	between2And5Minutes: between2And5Minutes,
	between2And10Minutes: between2And10Minutes,
	between0And10Photos: between0And10Photos,
	between1And10Characters: between1And10Characters,
	"Fault by medium type": "Avería por tipo de medio",
	"********** END COMPANY PROFILE SETTINGS **********": "**********",
	"********** BEGIN COMPANY PROFILE SERVICE LEVELS **********": "**********",
	between0And120Minutes: between0And120Minutes,
	"Maximum times in vial services": "Tiempos máximos en servicios viales",
	"Time for the provider to accept the service": "Tiempo para que el proveedor acepte el servicio",
	"Time for the provider to assign the service to a resource": "Tiempo para que el proveedor asigne el servicio a un recurso",
	"Time to start the service after the resource accepts it": "Tiempo para iniciar el servicio después de que el recurso lo acepte",
	"Time to locate the pick-up location in urban services": "Tiempo para localizar el lugar de recogida en servicios locales",
	"Time to locate the pick-up location in suburban services": "Tiempo para localizar el lugar de recogida en servicios carreteros",
	"Time to carry out an on-site repair": "Tiempo de realización de una reparación in situ",
	"Time to reach the delivery location": "Tiempo para llegar al lugar de entrega",
	"Time to carry out an urban service": "Tiempo de realización de un servicio local",
	"Time to carry out an suburban service": "Tiempo de realización de un servicio carretero",
	"Maximum times in auxiliary services": "Tiempos máximos en servicios auxiliares",
	"Time that the service can be in completed status": "Tiempo que puede estar el servicio en estado completado",
	"Time to assign an urban service to a technician": "Tiempo de asignación de un servicio local a un técnico",
	"Time to assign an suburban service to a technician": "Tiempo de asignación de un servicio carretero a un técnico",
	"Time to locate the location from the start of the service": "Tiempo para localizar la ubicación desde que se inicia el servicio",
	"Waiting time before starting a scheduled service": "Tiempo de espera antes de iniciar un servicio programado",
	"********** END COMPANY PROFILE SERVICE LEVELS **********": "**********",
	"*** ERRORS ***": "",
	"Date not in valid range": "La fecha está fuera de rango",
	"Hours not in valid range": "La hora está fuera de rango",
	"Distance not in valid range": "La distancia está fuera de rango",
	"Mandatory request body not found": "La información obligatoria de la petición es incorrecta",
	"Selected budget already confirmed": "El presupuesto seleccionado ha sido confirmado previamente",
	"Selected budget expired": "El presupuesto seleccionado ha expirado",
	"Selected budget not found": "El presupuesto seleccionado no ha podido ser localizado",
	"The token is invalid": "El token no es válido",
	"*** ERRORS - END ***": "",
	"An error occurred while approving this document": "Ha ocurrido un error al aprobar este documento",
	"An error occurred while rejecting this document": "Ha ocurrido un error al rechazar este documento",
	"Are you sure you want to accept the update? By doing so, you allow Nexus to send you services under the terms of this rate": "",
	"Are you sure you want to delete the cost?": "¿Seguro que deseas eliminar el costo?",
	"Are you sure you want finish the service?": "¿Seguro que deseas finalizar el servicio?",
	"Complete the fields to change your access password": "Completa los campos para cambiar tu contraseña de acceso",
	"Error approving the document": "Error al aprobar el documento",
	"Error rejecting the document": "Error al rechazar el documento",
	"It's necessary to change the access password to continue with the registration": "Es necesario cambiar la contraseña de acceso, para continuar con el registro",
	"Manage subscriptions to rates": "Gestiona las suscripciones a las tarifas",
	"Now you can use it when you login": "Ya puedes utilizarla al iniciar sesión",
	"There are unsaved changes": "Hay cambios sin guardar",
	"********** BEGIN PENDING WORDS **********": "",
	ACCEPTED: ACCEPTED,
	add_company_description: add_company_description,
	add_company: add_company,
	addChartText: addChartText,
	addChartTitle: addChartTitle,
	all_female: all_female,
	all_male: all_male,
	amount: amount,
	"Amount outside of policy coverage Payment of the assisted to the provider": "Importe fuera de cobertura de póliza (pago del asistido al proveedor)",
	apply: apply,
	assignProvider: assignProvider,
	assignedToMe: assignedToMe,
	assignItToMe: assignItToMe,
	AVAILABLE: AVAILABLE,
	blocked: blocked,
	budgetToastSuccessText: budgetToastSuccessText,
	budgetToastSuccessTitle: budgetToastSuccessTitle,
	scheduledBudgetToastSuccessText: scheduledBudgetToastSuccessText,
	scheduledBudgetToastSuccessTitle: scheduledBudgetToastSuccessTitle,
	transferPeopleBudgetToastSuccessText: transferPeopleBudgetToastSuccessText,
	transferPeopleBudgetToastSuccessTitle: transferPeopleBudgetToastSuccessTitle,
	budgetToastSuccessQueueText: budgetToastSuccessQueueText,
	budgetToastSuccessQueueTitle: budgetToastSuccessQueueTitle,
	bussy: bussy,
	CANCELED: CANCELED,
	centerNum: centerNum,
	centers: centers,
	closed: closed,
	codeAlreadyAssigned: codeAlreadyAssigned,
	color: color,
	companyPendingDocumentation: companyPendingDocumentation,
	companyProviderCode: companyProviderCode,
	COMPLETED: COMPLETED,
	custodyRate: custodyRate,
	damageReport: damageReport,
	damageRequired: damageRequired,
	day: day,
	days: days,
	del: del,
	delivery: delivery,
	deliveryAddressRequired: deliveryAddressRequired,
	destination: destination,
	documents: documents,
	exit: exit,
	expired: expired,
	EXTRA_CHARGES: EXTRA_CHARGES,
	extraCharges: extraCharges,
	festive: festive,
	fieldsRequired: fieldsRequired,
	files: files,
	filters: filters,
	FINISHED: FINISHED,
	free: free,
	from: from,
	fromDate: fromDate,
	generalInfo: generalInfo,
	groupName: groupName,
	id: id,
	IN_SERVICE: IN_SERVICE,
	information: information,
	INRIS: INRIS,
	integrated: integrated,
	invite: invite,
	invoiceDate: invoiceDate,
	lastAct: lastAct,
	left: left,
	LOADED: LOADED,
	LOCATED: LOCATED,
	locations: locations,
	mediums: mediums,
	MEDIUMS: MEDIUMS,
	modify: modify,
	newRates: newRates,
	nexus: nexus,
	nexusFee: nexusFee,
	nFilecase: nFilecase,
	nFilecaseAbbrev: nFilecaseAbbrev,
	nickName: nickName,
	nightlyEnd: nightlyEnd,
	nightlyStart: nightlyStart,
	nightly: nightly,
	nigthly: nigthly,
	nightlyFestive: nightlyFestive,
	nInvoice: nInvoice,
	nInvoices: nInvoices,
	none: none,
	NOT_IN_NEXUS: NOT_IN_NEXUS,
	not: not,
	nNexus: nNexus,
	nPayments: nPayments,
	nServices: nServices,
	numberOfInvoices: numberOfInvoices,
	of: of,
	open: open,
	outOfService: outOfService,
	ownFilecaseNumber: ownFilecaseNumber,
	ownFilecaseNumberAbbrev: ownFilecaseNumberAbbrev,
	partialPrice: partialPrice,
	participants: participants,
	participation: participation,
	payed: payed,
	payments: payments,
	pendingAbbrev: pendingAbbrev,
	photosNumber: photosNumber,
	pickup: pickup,
	"pickup/delivery": "Recogida / entrega",
	pickupAddress: pickupAddress,
	pictures: pictures,
	"private": "Privado",
	processDate: processDate,
	processed: processed,
	providerAlreadyMapped: providerAlreadyMapped,
	"public": "Público",
	REJECTED: REJECTED,
	rejection: rejection,
	request: request,
	requester: requester,
	resource: resource,
	resourceActivity: resourceActivity,
	resourceDistance: resourceDistance,
	resourceRoute: resourceRoute,
	resourceTime: resourceTime,
	responsable: responsable,
	responseNumberAbbrev: responseNumberAbbrev,
	RISEND: RISEND,
	RISSTART: RISSTART,
	rowsPerPage: rowsPerPage,
	saveView: saveView,
	sendSMSTracking: sendSMSTracking,
	sendSurvey: sendSurvey,
	serviceActivity: serviceActivity,
	serviceBudget: serviceBudget,
	serviceRequest: serviceRequest,
	serviceType: serviceType,
	shared: shared,
	shipmentDate: shipmentDate,
	sign: sign,
	sta: sta,
	STARTED: STARTED,
	supportTeamAbbrev: supportTeamAbbrev,
	surchargeRate: surchargeRate,
	surname: surname,
	teamMembers: teamMembers,
	teamTickets: teamTickets,
	totalPrice: totalPrice,
	UNAVAILABLE: UNAVAILABLE,
	userProfile: userProfile,
	validate: validate,
	validated: validated,
	vehicle: vehicle,
	weekend: weekend,
	"***** STRUCTURES *****": "*****",
	category: category,
	collective2: collective2,
	companyList: companyList,
	depositList: depositList,
	format: format,
	invoiceList: invoiceList,
	mediumList: mediumList,
	"mediums-toast": {
	toastErrorDeactivateMediumTitle: "ERROR",
	toastErrorDeactivateMediumText: "En estos momentos no es posible desactivar el medio. Por favor, vuelve a intentarlo en unos minutos.",
	toastErrorDeactivateMediumInServideTitle: "ERROR",
	toastErrorDeactivateMediumInServiceText: "No es posible desactivar un medio que se encuentra actualmente realizando un servicio."
},
	mediumTypesList: mediumTypesList,
	modals: modals,
	operationTypesList: operationTypesList,
	paymentList: paymentList,
	"rates-concepts": {
	startupFee: "Tarifa de salida",
	scheduledFee: "Tarifa programado",
	nexusFee: "Tarifa de Nexus",
	km: "Tarifa por km",
	mi: "Tarifa por mi",
	minute: "Tarifa por minuto",
	loadTime: "Tiempo de carga",
	surchargeRate: "Recargo",
	cancelRate: "Anulación",
	cancelAmount: "Importe anulación",
	surchargeType: "Tipo de recargo",
	freeCustodyDays: "Custodia gratuita",
	custodyRate: "Custodia",
	urban: "Local",
	urbanFee: "Tarifa local",
	franchise: "Franquicia"
},
	searchTools: searchTools,
	serviceList: serviceList,
	servicesError: servicesError,
	transferPeopleError: transferPeopleError,
	transferPeopleList: transferPeopleList,
	shipment: shipment,
	"shipments-opt": {
	listWithCount: "{{count}} Remesa",
	listWithCount_plural: "{{count}} Remesas",
	collectInvoiceErrorTitle: "Error al solicitar el cobro de la factura",
	collectInvoiceUnknownError: "En estos momentos no es posible realizar la operación. Vuelva a intentarlo en unos minutos."
},
	"shipments-opt2": {
	collectInvoiceErrorTitle: "Error al solicitar el cobro de la factura",
	collectInvoiceUnknownError: "En estos momentos no es posible realizar la operación. Vuelva a intentarlo en unos minutos."
},
	ticketDetail: ticketDetail,
	ticketList: ticketList,
	user2: user2,
	userList: userList,
	validation: validation,
	loginYourAccount: loginYourAccount,
	checkYourEmail: checkYourEmail,
	updatedUser: updatedUser,
	errorCreatingCompany: errorCreatingCompany,
	min: min,
	distance: distance,
	"---": "---"
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var TextInput = function TextInput(props) {
  var handleChange = function handleChange(a, b, c, d) {
    props.onChange(a, b, c, d);
    props.handleChange && props.handleChange(a);
  };
  var handleBlur = function handleBlur(a, b, c, d) {
    props.onBlur(a, b, c, d);
    props.handleBlur && props.handleBlur(a);
  };
  var handleFocus = function handleFocus(a, b, c, d) {
    props.onFocus && props.onFocus(a, b, c, d);
    props.handleFocus && props.handleFocus(a);
  };
  return /*#__PURE__*/React__default__default__default__default.createElement(TextField, _extends({}, props, {
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus
  }));
};
var Input = function Input(props) {
  var label = props.label,
    name = props.name,
    errorobj = props.errorobj;
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var isError = false;
  var errorMessage = "";
  if (errorobj && errorobj.hasOwnProperty(name)) {
    isError = true;
    errorMessage = errorobj[name].message || "Obligatorio";
  }
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "Input"
  }, /*#__PURE__*/React__default__default__default__default.createElement(Controller, _extends({
    as: TextInput,
    name: name,
    control: control,
    defaultValue: "",
    label: label,
    variant: "outlined",
    error: isError,
    helperText: errorMessage
  }, props)));
};

var Button = function Button(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    onClick = _ref.onClick,
    children = _ref.children,
    disabled = _ref.disabled,
    variant = _ref.variant,
    prefixIcon = _ref.prefixIcon;
  return /*#__PURE__*/React__default__default__default__default.createElement("button", {
    type: "button",
    className: "Button " + (variant ? "Button--" + variant : "") + " " + (className ? className : ""),
    onClick: onClick,
    disabled: disabled
  }, prefixIcon && /*#__PURE__*/React__default__default__default__default.createElement("img", {
    src: "/assets/icons/" + prefixIcon + ".svg",
    className: "Button__prefixIcon",
    alt: "icon"
  }), children);
};

var CustomCheckbox = withStyles({
  root: {
    "&$checked": {
      color: "#ec754a"
    }
  },
  checked: {}
})(function (props) {
  return /*#__PURE__*/React__default__default__default__default.createElement(Checkbox, _extends({
    color: "default"
  }, props));
});
var CheckboxInput = function CheckboxInput(_ref) {
  var label = _ref.label,
    name = _ref.name,
    onChange = _ref.onChange,
    checked = _ref.checked;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "CheckboxInput"
  }, /*#__PURE__*/React__default__default__default__default.createElement(FormControlLabel, {
    control: /*#__PURE__*/React__default__default__default__default.createElement(CustomCheckbox, {
      name: name
    }),
    label: label,
    onChange: onChange,
    checked: checked
  }));
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var b = "function" === typeof Symbol && Symbol["for"],
  c = b ? Symbol["for"]("react.element") : 60103,
  d = b ? Symbol["for"]("react.portal") : 60106,
  e = b ? Symbol["for"]("react.fragment") : 60107,
  f = b ? Symbol["for"]("react.strict_mode") : 60108,
  g = b ? Symbol["for"]("react.profiler") : 60114,
  h = b ? Symbol["for"]("react.provider") : 60109,
  k = b ? Symbol["for"]("react.context") : 60110,
  l = b ? Symbol["for"]("react.async_mode") : 60111,
  m = b ? Symbol["for"]("react.concurrent_mode") : 60111,
  n = b ? Symbol["for"]("react.forward_ref") : 60112,
  p = b ? Symbol["for"]("react.suspense") : 60113,
  q = b ? Symbol["for"]("react.suspense_list") : 60120,
  r = b ? Symbol["for"]("react.memo") : 60115,
  t = b ? Symbol["for"]("react.lazy") : 60116,
  v = b ? Symbol["for"]("react.block") : 60121,
  w = b ? Symbol["for"]("react.fundamental") : 60117,
  x = b ? Symbol["for"]("react.responder") : 60118,
  y = b ? Symbol["for"]("react.scope") : 60119;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A$1(a) {
  return z(a) === m;
}
var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;
var isAsyncMode = function isAsyncMode(a) {
  return A$1(a) || z(a) === l;
};
var isConcurrentMode = A$1;
var isContextConsumer = function isContextConsumer(a) {
  return z(a) === k;
};
var isContextProvider = function isContextProvider(a) {
  return z(a) === h;
};
var isElement = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};
var isForwardRef = function isForwardRef(a) {
  return z(a) === n;
};
var isFragment = function isFragment(a) {
  return z(a) === e;
};
var isLazy = function isLazy(a) {
  return z(a) === t;
};
var isMemo = function isMemo(a) {
  return z(a) === r;
};
var isPortal = function isPortal(a) {
  return z(a) === d;
};
var isProfiler = function isProfiler(a) {
  return z(a) === g;
};
var isStrictMode = function isStrictMode(a) {
  return z(a) === f;
};
var isSuspense = function isSuspense(a) {
  return z(a) === p;
};
var isValidElementType = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {

  if (process.env.NODE_ENV !== "production") {
    (function () {
      var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});

var reactIs = createCommonjsModule(function (module) {

  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String('abc');
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;
  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        try {
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes;

var printWarning$1 = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  var ANONYMOUS = '<<anonymous>>';
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  function is(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  }
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    if (propType === 'symbol') {
      return true;
    }
    if (!propValue) {
      return false;
    }
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs;
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    module.exports = factoryWithThrowingShims();
  }
});

var moment = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
     module.exports = factory() ;
  })(commonjsGlobal, function () {

    var hookCallback;
    function hooks() {
      return hookCallback.apply(null, arguments);
    }
    function setHookCallback(callback) {
      hookCallback = callback;
    }
    function isArray(input) {
      return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
      return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
      if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
      } else {
        var k;
        for (k in obj) {
          if (hasOwnProp(obj, k)) {
            return false;
          }
        }
        return true;
      }
    }
    function isUndefined(input) {
      return input === void 0;
    }
    function isNumber(input) {
      return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
      return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
      var res = [],
        i,
        arrLen = arr.length;
      for (i = 0; i < arrLen; ++i) {
        res.push(fn(arr[i], i));
      }
      return res;
    }
    function extend(a, b) {
      for (var i in b) {
        if (hasOwnProp(b, i)) {
          a[i] = b[i];
        }
      }
      if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
      }
      if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
      }
      return a;
    }
    function createUTC(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
      return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false
      };
    }
    function getParsingFlags(m) {
      if (m._pf == null) {
        m._pf = defaultParsingFlags();
      }
      return m._pf;
    }
    var some;
    if (Array.prototype.some) {
      some = Array.prototype.some;
    } else {
      some = function some(fun) {
        var t = Object(this),
          len = t.length >>> 0,
          i;
        for (i = 0; i < len; i++) {
          if (i in t && fun.call(this, t[i], i, t)) {
            return true;
          }
        }
        return false;
      };
    }
    function isValid(m) {
      if (m._isValid == null) {
        var flags = getParsingFlags(m),
          parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
          }),
          isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
        if (m._strict) {
          isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
          m._isValid = isNowValid;
        } else {
          return isNowValid;
        }
      }
      return m._isValid;
    }
    function createInvalid(flags) {
      var m = createUTC(NaN);
      if (flags != null) {
        extend(getParsingFlags(m), flags);
      } else {
        getParsingFlags(m).userInvalidated = true;
      }
      return m;
    }
    var momentProperties = hooks.momentProperties = [],
      updateInProgress = false;
    function copyConfig(to, from) {
      var i,
        prop,
        val,
        momentPropertiesLen = momentProperties.length;
      if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
      }
      if (!isUndefined(from._i)) {
        to._i = from._i;
      }
      if (!isUndefined(from._f)) {
        to._f = from._f;
      }
      if (!isUndefined(from._l)) {
        to._l = from._l;
      }
      if (!isUndefined(from._strict)) {
        to._strict = from._strict;
      }
      if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
      }
      if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
      }
      if (!isUndefined(from._offset)) {
        to._offset = from._offset;
      }
      if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
      }
      if (!isUndefined(from._locale)) {
        to._locale = from._locale;
      }
      if (momentPropertiesLen > 0) {
        for (i = 0; i < momentPropertiesLen; i++) {
          prop = momentProperties[i];
          val = from[prop];
          if (!isUndefined(val)) {
            to[prop] = val;
          }
        }
      }
      return to;
    }
    function Moment(config) {
      copyConfig(this, config);
      this._d = new Date(config._d != null ? config._d.getTime() : NaN);
      if (!this.isValid()) {
        this._d = new Date(NaN);
      }
      if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
      }
    }
    function isMoment(obj) {
      return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
      if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
        console.warn('Deprecation warning: ' + msg);
      }
    }
    function deprecate(msg, fn) {
      var firstTime = true;
      return extend(function () {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
          var args = [],
            arg,
            i,
            key,
            argLen = arguments.length;
          for (i = 0; i < argLen; i++) {
            arg = '';
            if (typeof arguments[i] === 'object') {
              arg += '\n[' + i + '] ';
              for (key in arguments[0]) {
                if (hasOwnProp(arguments[0], key)) {
                  arg += key + ': ' + arguments[0][key] + ', ';
                }
              }
              arg = arg.slice(0, -2);
            } else {
              arg = arguments[i];
            }
            args.push(arg);
          }
          warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
          firstTime = false;
        }
        return fn.apply(this, arguments);
      }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
      }
      if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
      }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
      return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
      var prop, i;
      for (i in config) {
        if (hasOwnProp(config, i)) {
          prop = config[i];
          if (isFunction(prop)) {
            this[i] = prop;
          } else {
            this['_' + i] = prop;
          }
        }
      }
      this._config = config;
      this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
      var res = extend({}, parentConfig),
        prop;
      for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
          if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
            res[prop] = {};
            extend(res[prop], parentConfig[prop]);
            extend(res[prop], childConfig[prop]);
          } else if (childConfig[prop] != null) {
            res[prop] = childConfig[prop];
          } else {
            delete res[prop];
          }
        }
      }
      for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
          res[prop] = extend({}, res[prop]);
        }
      }
      return res;
    }
    function Locale(config) {
      if (config != null) {
        this.set(config);
      }
    }
    var keys;
    if (Object.keys) {
      keys = Object.keys;
    } else {
      keys = function keys(obj) {
        var i,
          res = [];
        for (i in obj) {
          if (hasOwnProp(obj, i)) {
            res.push(i);
          }
        }
        return res;
      };
    }
    var defaultCalendar = {
      sameDay: '[Today at] LT',
      nextDay: '[Tomorrow at] LT',
      nextWeek: 'dddd [at] LT',
      lastDay: '[Yesterday at] LT',
      lastWeek: '[Last] dddd [at] LT',
      sameElse: 'L'
    };
    function calendar(key, mom, now) {
      var output = this._calendar[key] || this._calendar['sameElse'];
      return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
      var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
      return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
      localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
      formatFunctions = {},
      formatTokenFunctions = {};
    function addFormatToken(token, padded, ordinal, callback) {
      var func = callback;
      if (typeof callback === 'string') {
        func = function func() {
          return this[callback]();
        };
      }
      if (token) {
        formatTokenFunctions[token] = func;
      }
      if (padded) {
        formatTokenFunctions[padded[0]] = function () {
          return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
      }
      if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
          return this.localeData().ordinal(func.apply(this, arguments), token);
        };
      }
    }
    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
      }
      return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
      var array = format.match(formattingTokens),
        i,
        length;
      for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
          array[i] = formatTokenFunctions[array[i]];
        } else {
          array[i] = removeFormattingTokens(array[i]);
        }
      }
      return function (mom) {
        var output = '',
          i;
        for (i = 0; i < length; i++) {
          output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
      };
    }
    function formatMoment(m, format) {
      if (!m.isValid()) {
        return m.localeData().invalidDate();
      }
      format = expandFormat(format, m.localeData());
      formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
      return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
      var i = 5;
      function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
      }
      localFormattingTokens.lastIndex = 0;
      while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
      }
      return format;
    }
    var defaultLongDateFormat = {
      LTS: 'h:mm:ss A',
      LT: 'h:mm A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
      var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];
      if (format || !formatUpper) {
        return format;
      }
      this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function (tok) {
        if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') {
          return tok.slice(1);
        }
        return tok;
      }).join('');
      return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
      return this._invalidDate;
    }
    var defaultOrdinal = '%d',
      defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
      return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      ss: '%d seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      w: 'a week',
      ww: '%d weeks',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
      var output = this._relativeTime[string];
      return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
      var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
      return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
      var lowerCase = unit.toLowerCase();
      aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
      return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
      var normalizedInput = {},
        normalizedProp,
        prop;
      for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
          normalizedProp = normalizeUnits(prop);
          if (normalizedProp) {
            normalizedInput[normalizedProp] = inputObject[prop];
          }
        }
      }
      return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
      priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
      var units = [],
        u;
      for (u in unitsObj) {
        if (hasOwnProp(unitsObj, u)) {
          units.push({
            unit: u,
            priority: priorities[u]
          });
        }
      }
      units.sort(function (a, b) {
        return a.priority - b.priority;
      });
      return units;
    }
    function isLeapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
      if (number < 0) {
        return Math.ceil(number) || 0;
      } else {
        return Math.floor(number);
      }
    }
    function toInt(argumentForCoercion) {
      var coercedNumber = +argumentForCoercion,
        value = 0;
      if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
      }
      return value;
    }
    function makeGetSet(unit, keepTime) {
      return function (value) {
        if (value != null) {
          set$1(this, unit, value);
          hooks.updateOffset(this, keepTime);
          return this;
        } else {
          return get(this, unit);
        }
      };
    }
    function get(mom, unit) {
      return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
      if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
          value = toInt(value);
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        } else {
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
      }
    }
    function stringGet(units) {
      units = normalizeUnits(units);
      if (isFunction(this[units])) {
        return this[units]();
      }
      return this;
    }
    function stringSet(units, value) {
      if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units),
          i,
          prioritizedLen = prioritized.length;
        for (i = 0; i < prioritizedLen; i++) {
          this[prioritized[i].unit](units[prioritized[i].unit]);
        }
      } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
          return this[units](value);
        }
      }
      return this;
    }
    var match1 = /\d/,
      match2 = /\d\d/,
      match3 = /\d{3}/,
      match4 = /\d{4}/,
      match6 = /[+-]?\d{6}/,
      match1to2 = /\d\d?/,
      match3to4 = /\d\d\d\d?/,
      match5to6 = /\d\d\d\d\d\d?/,
      match1to3 = /\d{1,3}/,
      match1to4 = /\d{1,4}/,
      match1to6 = /[+-]?\d{1,6}/,
      matchUnsigned = /\d+/,
      matchSigned = /[+-]?\d+/,
      matchOffset = /Z|[+-]\d\d:?\d\d/gi,
      matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
      matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
      matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
      regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
      regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return isStrict && strictRegex ? strictRegex : regex;
      };
    }
    function getParseRegexForToken(token, config) {
      if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
      }
      return regexes[token](config._strict, config._locale);
    }
    function unescapeFormat(s) {
      return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
      }));
    }
    function regexEscape(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    var tokens = {};
    function addParseToken(token, callback) {
      var i,
        func = callback,
        tokenLen;
      if (typeof token === 'string') {
        token = [token];
      }
      if (isNumber(callback)) {
        func = function func(input, array) {
          array[callback] = toInt(input);
        };
      }
      tokenLen = token.length;
      for (i = 0; i < tokenLen; i++) {
        tokens[token[i]] = func;
      }
    }
    function addWeekParseToken(token, callback) {
      addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
      });
    }
    function addTimeToArrayFromToken(token, input, config) {
      if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
      }
    }
    var YEAR = 0,
      MONTH = 1,
      DATE = 2,
      HOUR = 3,
      MINUTE = 4,
      SECOND = 5,
      MILLISECOND = 6,
      WEEK = 7,
      WEEKDAY = 8;
    function mod(n, x) {
      return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) {
      indexOf = Array.prototype.indexOf;
    } else {
      indexOf = function indexOf(o) {
        var i;
        for (i = 0; i < this.length; ++i) {
          if (this[i] === o) {
            return i;
          }
        }
        return -1;
      };
    }
    function daysInMonth(year, month) {
      if (isNaN(year) || isNaN(month)) {
        return NaN;
      }
      var modMonth = mod(month, 12);
      year += (month - modMonth) / 12;
      return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    addFormatToken('M', ['MM', 2], 'Mo', function () {
      return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function (format) {
      return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function (format) {
      return this.localeData().months(this, format);
    });
    addUnitAlias('month', 'M');
    addUnitPriority('month', 8);
    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
      return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
      return locale.monthsRegex(isStrict);
    });
    addParseToken(['M', 'MM'], function (input, array) {
      array[MONTH] = toInt(input) - 1;
    });
    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
      var month = config._locale.monthsParse(input, token, config._strict);
      if (month != null) {
        array[MONTH] = month;
      } else {
        getParsingFlags(config).invalidMonth = input;
      }
    });
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
      defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
      defaultMonthsShortRegex = matchWord,
      defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
      if (!m) {
        return isArray(this._months) ? this._months : this._months['standalone'];
      }
      return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
      if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
      }
      return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
      var i,
        ii,
        mom,
        llc = monthName.toLocaleLowerCase();
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
          mom = createUTC([2000, i]);
          this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
          this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeMonthsParse(monthName, format, strict) {
      var i, mom, regex;
      if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
      }
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
      }
      for (i = 0; i < 12; i++) {
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
          this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
          this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
          regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
          this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
          return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
          return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
          return i;
        }
      }
    }
    function setMonth(mom, value) {
      var dayOfMonth;
      if (!mom.isValid()) {
        return mom;
      }
      if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
          value = toInt(value);
        } else {
          value = mom.localeData().monthsParse(value);
          if (!isNumber(value)) {
            return mom;
          }
        }
      }
      dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
      mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
      return mom;
    }
    function getSetMonth(value) {
      if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
      } else {
        return get(this, 'Month');
      }
    }
    function getDaysInMonth() {
      return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsShortStrictRegex;
        } else {
          return this._monthsShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
          this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
      }
    }
    function monthsRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsStrictRegex;
        } else {
          return this._monthsRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
          this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
      }
    }
    function computeMonthsParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom;
      for (i = 0; i < 12; i++) {
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
      }
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
      }
      for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
      }
      this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._monthsShortRegex = this._monthsRegex;
      this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    addFormatToken('Y', 0, 0, function () {
      var y = this.year();
      return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, ['YY', 2], 0, function () {
      return this.year() % 100;
    });
    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
    addUnitAlias('year', 'y');
    addUnitPriority('year', 1);
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
      array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
      array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
      array[YEAR] = parseInt(input, 10);
    });
    function daysInYear(year) {
      return isLeapYear(year) ? 366 : 365;
    }
    hooks.parseTwoDigitYear = function (input) {
      return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
      return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
      var date;
      if (y < 100 && y >= 0) {
        date = new Date(y + 400, m, d, h, M, s, ms);
        if (isFinite(date.getFullYear())) {
          date.setFullYear(y);
        }
      } else {
        date = new Date(y, m, d, h, M, s, ms);
      }
      return date;
    }
    function createUTCDate(y) {
      var date, args;
      if (y < 100 && y >= 0) {
        args = Array.prototype.slice.call(arguments);
        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));
        if (isFinite(date.getUTCFullYear())) {
          date.setUTCFullYear(y);
        }
      } else {
        date = new Date(Date.UTC.apply(null, arguments));
      }
      return date;
    }
    function firstWeekOffset(year, dow, doy) {
      var fwd = 7 + dow - doy,
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
      return -fwdlw + fwd - 1;
    }
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
      var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear,
        resDayOfYear;
      if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
      } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
      } else {
        resYear = year;
        resDayOfYear = dayOfYear;
      }
      return {
        year: resYear,
        dayOfYear: resDayOfYear
      };
    }
    function weekOfYear(mom, dow, doy) {
      var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek,
        resYear;
      if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
      } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
      } else {
        resYear = mom.year();
        resWeek = week;
      }
      return {
        week: resWeek,
        year: resYear
      };
    }
    function weeksInYear(year, dow, doy) {
      var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
      return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');
    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);
    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
      week[token.substr(0, 1)] = toInt(input);
    });
    function localeWeek(mom) {
      return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
      dow: 0,
      doy: 6
    };
    function localeFirstDayOfWeek() {
      return this._week.dow;
    }
    function localeFirstDayOfYear() {
      return this._week.doy;
    }
    function getSetWeek(input) {
      var week = this.localeData().week(this);
      return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
      var week = weekOfYear(this, 1, 4).week;
      return input == null ? week : this.add((input - week) * 7, 'd');
    }
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function (format) {
      return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function (format) {
      return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function (format) {
      return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
      return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
      return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
      return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
      var weekday = config._locale.weekdaysParse(input, token, config._strict);
      if (weekday != null) {
        week.d = weekday;
      } else {
        getParsingFlags(config).invalidWeekday = input;
      }
    });
    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
      week[token] = toInt(input);
    });
    function parseWeekday(input, locale) {
      if (typeof input !== 'string') {
        return input;
      }
      if (!isNaN(input)) {
        return parseInt(input, 10);
      }
      input = locale.weekdaysParse(input);
      if (typeof input === 'number') {
        return input;
      }
      return null;
    }
    function parseIsoWeekday(input, locale) {
      if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
      }
      return isNaN(input) ? null : input;
    }
    function shiftWeekdays(ws, n) {
      return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      defaultWeekdaysRegex = matchWord,
      defaultWeekdaysShortRegex = matchWord,
      defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
      var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
      return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
      return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
      return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
      var i,
        ii,
        mom,
        llc = weekdayName.toLocaleLowerCase();
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];
        for (i = 0; i < 7; ++i) {
          mom = createUTC([2000, 1]).day(i);
          this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
          this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
          this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
      var i, mom, regex;
      if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
      }
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
      }
      for (i = 0; i < 7; i++) {
        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
          this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
          this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
          this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
          regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
          this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
          return i;
        }
      }
    }
    function getSetDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
      if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
      } else {
        return day;
      }
    }
    function getSetLocaleDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
      } else {
        return this.day() || 7;
      }
    }
    function weekdaysRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysStrictRegex;
        } else {
          return this._weekdaysRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
      }
    }
    function weekdaysShortRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysShortStrictRegex;
        } else {
          return this._weekdaysShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
          this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
      }
    }
    function weekdaysMinRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysMinStrictRegex;
        } else {
          return this._weekdaysMinRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
          this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
      }
    }
    function computeWeekdaysParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var minPieces = [],
        shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        minp,
        shortp,
        longp;
      for (i = 0; i < 7; i++) {
        mom = createUTC([2000, 1]).day(i);
        minp = regexEscape(this.weekdaysMin(mom, ''));
        shortp = regexEscape(this.weekdaysShort(mom, ''));
        longp = regexEscape(this.weekdays(mom, ''));
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
      }
      minPieces.sort(cmpLenRev);
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._weekdaysShortRegex = this._weekdaysRegex;
      this._weekdaysMinRegex = this._weekdaysRegex;
      this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
      this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    function hFormat() {
      return this.hours() % 12 || 12;
    }
    function kFormat() {
      return this.hours() || 24;
    }
    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);
    addFormatToken('hmm', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
      addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
      });
    }
    meridiem('a', true);
    meridiem('A', false);
    addUnitAlias('hour', 'h');
    addUnitPriority('hour', 13);
    function matchMeridiem(isStrict, locale) {
      return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
      var kInput = toInt(input);
      array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
      config._isPm = config._locale.isPM(input);
      config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
      array[HOUR] = toInt(input);
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
    });
    function localeIsPM(input) {
      return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
      getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? 'pm' : 'PM';
      } else {
        return isLower ? 'am' : 'AM';
      }
    }
    var baseConfig = {
      calendar: defaultCalendar,
      longDateFormat: defaultLongDateFormat,
      invalidDate: defaultInvalidDate,
      ordinal: defaultOrdinal,
      dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
      relativeTime: defaultRelativeTime,
      months: defaultLocaleMonths,
      monthsShort: defaultLocaleMonthsShort,
      week: defaultLocaleWeek,
      weekdays: defaultLocaleWeekdays,
      weekdaysMin: defaultLocaleWeekdaysMin,
      weekdaysShort: defaultLocaleWeekdaysShort,
      meridiemParse: defaultLocaleMeridiemParse
    };
    var locales = {},
      localeFamilies = {},
      globalLocale;
    function commonPrefix(arr1, arr2) {
      var i,
        minl = Math.min(arr1.length, arr2.length);
      for (i = 0; i < minl; i += 1) {
        if (arr1[i] !== arr2[i]) {
          return i;
        }
      }
      return minl;
    }
    function normalizeLocale(key) {
      return key ? key.toLowerCase().replace('_', '-') : key;
    }
    function chooseLocale(names) {
      var i = 0,
        j,
        next,
        locale,
        split;
      while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
          locale = loadLocale(split.slice(0, j).join('-'));
          if (locale) {
            return locale;
          }
          if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
            break;
          }
          j--;
        }
        i++;
      }
      return globalLocale;
    }
    function isLocaleNameSane(name) {
      return name.match('^[^/\\\\]*$') != null;
    }
    function loadLocale(name) {
      var oldLocale = null,
        aliasedRequire;
      if (locales[name] === undefined && 'object' !== 'undefined' && module && module.exports && isLocaleNameSane(name)) {
        try {
          oldLocale = globalLocale._abbr;
          aliasedRequire = commonjsRequire;
          aliasedRequire('./locale/' + name);
          getSetGlobalLocale(oldLocale);
        } catch (e) {
          locales[name] = null;
        }
      }
      return locales[name];
    }
    function getSetGlobalLocale(key, values) {
      var data;
      if (key) {
        if (isUndefined(values)) {
          data = getLocale(key);
        } else {
          data = defineLocale(key, values);
        }
        if (data) {
          globalLocale = data;
        } else {
          if (typeof console !== 'undefined' && console.warn) {
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
          }
        }
      }
      return globalLocale._abbr;
    }
    function defineLocale(name, config) {
      if (config !== null) {
        var locale,
          parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
          deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
          parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
          if (locales[config.parentLocale] != null) {
            parentConfig = locales[config.parentLocale]._config;
          } else {
            locale = loadLocale(config.parentLocale);
            if (locale != null) {
              parentConfig = locale._config;
            } else {
              if (!localeFamilies[config.parentLocale]) {
                localeFamilies[config.parentLocale] = [];
              }
              localeFamilies[config.parentLocale].push({
                name: name,
                config: config
              });
              return null;
            }
          }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));
        if (localeFamilies[name]) {
          localeFamilies[name].forEach(function (x) {
            defineLocale(x.name, x.config);
          });
        }
        getSetGlobalLocale(name);
        return locales[name];
      } else {
        delete locales[name];
        return null;
      }
    }
    function updateLocale(name, config) {
      if (config != null) {
        var locale,
          tmpLocale,
          parentConfig = baseConfig;
        if (locales[name] != null && locales[name].parentLocale != null) {
          locales[name].set(mergeConfigs(locales[name]._config, config));
        } else {
          tmpLocale = loadLocale(name);
          if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
          }
          config = mergeConfigs(parentConfig, config);
          if (tmpLocale == null) {
            config.abbr = name;
          }
          locale = new Locale(config);
          locale.parentLocale = locales[name];
          locales[name] = locale;
        }
        getSetGlobalLocale(name);
      } else {
        if (locales[name] != null) {
          if (locales[name].parentLocale != null) {
            locales[name] = locales[name].parentLocale;
            if (name === getSetGlobalLocale()) {
              getSetGlobalLocale(name);
            }
          } else if (locales[name] != null) {
            delete locales[name];
          }
        }
      }
      return locales[name];
    }
    function getLocale(key) {
      var locale;
      if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
      }
      if (!key) {
        return globalLocale;
      }
      if (!isArray(key)) {
        locale = loadLocale(key);
        if (locale) {
          return locale;
        }
        key = [key];
      }
      return chooseLocale(key);
    }
    function listLocales() {
      return keys(locales);
    }
    function checkOverflow(m) {
      var overflow,
        a = m._a;
      if (a && getParsingFlags(m).overflow === -2) {
        overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
          overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
          overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
          overflow = WEEKDAY;
        }
        getParsingFlags(m).overflow = overflow;
      }
      return m;
    }
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
      isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/], ['YYYYMM', /\d{6}/, false], ['YYYY', /\d{4}/, false]],
      isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]],
      aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
      rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
      obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
      };
    function configFromISO(config) {
      var i,
        l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime,
        dateFormat,
        timeFormat,
        tzFormat,
        isoDatesLen = isoDates.length,
        isoTimesLen = isoTimes.length;
      if (match) {
        getParsingFlags(config).iso = true;
        for (i = 0, l = isoDatesLen; i < l; i++) {
          if (isoDates[i][1].exec(match[1])) {
            dateFormat = isoDates[i][0];
            allowTime = isoDates[i][2] !== false;
            break;
          }
        }
        if (dateFormat == null) {
          config._isValid = false;
          return;
        }
        if (match[3]) {
          for (i = 0, l = isoTimesLen; i < l; i++) {
            if (isoTimes[i][1].exec(match[3])) {
              timeFormat = (match[2] || ' ') + isoTimes[i][0];
              break;
            }
          }
          if (timeFormat == null) {
            config._isValid = false;
            return;
          }
        }
        if (!allowTime && timeFormat != null) {
          config._isValid = false;
          return;
        }
        if (match[4]) {
          if (tzRegex.exec(match[4])) {
            tzFormat = 'Z';
          } else {
            config._isValid = false;
            return;
          }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
      } else {
        config._isValid = false;
      }
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
      var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];
      if (secondStr) {
        result.push(parseInt(secondStr, 10));
      }
      return result;
    }
    function untruncateYear(yearStr) {
      var year = parseInt(yearStr, 10);
      if (year <= 49) {
        return 2000 + year;
      } else if (year <= 999) {
        return 1900 + year;
      }
      return year;
    }
    function preprocessRFC2822(s) {
      return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
      if (weekdayStr) {
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
          weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
          getParsingFlags(config).weekdayMismatch = true;
          config._isValid = false;
          return false;
        }
      }
      return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
      if (obsOffset) {
        return obsOffsets[obsOffset];
      } else if (militaryOffset) {
        return 0;
      } else {
        var hm = parseInt(numOffset, 10),
          m = hm % 100,
          h = (hm - m) / 100;
        return h * 60 + m;
      }
    }
    function configFromRFC2822(config) {
      var match = rfc2822.exec(preprocessRFC2822(config._i)),
        parsedArray;
      if (match) {
        parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
          return;
        }
        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);
        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        getParsingFlags(config).rfc2822 = true;
      } else {
        config._isValid = false;
      }
    }
    function configFromString(config) {
      var matched = aspNetJsonRegex.exec(config._i);
      if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
      }
      configFromISO(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      configFromRFC2822(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      if (config._strict) {
        config._isValid = false;
      } else {
        hooks.createFromInputFallback(config);
      }
    }
    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
      config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    function defaults(a, b, c) {
      if (a != null) {
        return a;
      }
      if (b != null) {
        return b;
      }
      return c;
    }
    function currentDateArray(config) {
      var nowValue = new Date(hooks.now());
      if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
      }
      return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }
    function configFromArray(config) {
      var i,
        date,
        input = [],
        currentDate,
        expectedWeekday,
        yearToUse;
      if (config._d) {
        return;
      }
      currentDate = currentDateArray(config);
      if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
      }
      if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
          getParsingFlags(config)._overflowDayOfYear = true;
        }
        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
      }
      for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
      }
      for (; i < 7; i++) {
        config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
      }
      if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
      }
      config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
      expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
      if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
      }
      if (config._nextDay) {
        config._a[HOUR] = 24;
      }
      if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
      }
    }
    function dayOfYearFromWeekInfo(config) {
      var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
      w = config._w;
      if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
          weekdayOverflow = true;
        }
      } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;
        curWeek = weekOfYear(createLocal(), dow, doy);
        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
        week = defaults(w.w, curWeek.week);
        if (w.d != null) {
          weekday = w.d;
          if (weekday < 0 || weekday > 6) {
            weekdayOverflow = true;
          }
        } else if (w.e != null) {
          weekday = w.e + dow;
          if (w.e < 0 || w.e > 6) {
            weekdayOverflow = true;
          }
        } else {
          weekday = dow;
        }
      }
      if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
      } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
      } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
      }
    }
    hooks.ISO_8601 = function () {};
    hooks.RFC_2822 = function () {};
    function configFromStringAndFormat(config) {
      if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
      }
      if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
      }
      config._a = [];
      getParsingFlags(config).empty = true;
      var string = '' + config._i,
        i,
        parsedInput,
        tokens,
        token,
        skipped,
        stringLength = string.length,
        totalParsedInputLength = 0,
        era,
        tokenLen;
      tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
      tokenLen = tokens.length;
      for (i = 0; i < tokenLen; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        if (parsedInput) {
          skipped = string.substr(0, string.indexOf(parsedInput));
          if (skipped.length > 0) {
            getParsingFlags(config).unusedInput.push(skipped);
          }
          string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
          totalParsedInputLength += parsedInput.length;
        }
        if (formatTokenFunctions[token]) {
          if (parsedInput) {
            getParsingFlags(config).empty = false;
          } else {
            getParsingFlags(config).unusedTokens.push(token);
          }
          addTimeToArrayFromToken(token, parsedInput, config);
        } else if (config._strict && !parsedInput) {
          getParsingFlags(config).unusedTokens.push(token);
        }
      }
      getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
      if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
      }
      if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
      }
      getParsingFlags(config).parsedDateParts = config._a.slice(0);
      getParsingFlags(config).meridiem = config._meridiem;
      config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
      era = getParsingFlags(config).era;
      if (era !== null) {
        config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
      }
      configFromArray(config);
      checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
      var isPm;
      if (meridiem == null) {
        return hour;
      }
      if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
      } else if (locale.isPM != null) {
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
          hour += 12;
        }
        if (!isPm && hour === 12) {
          hour = 0;
        }
        return hour;
      } else {
        return hour;
      }
    }
    function configFromStringAndArray(config) {
      var tempConfig,
        bestMoment,
        scoreToBeat,
        i,
        currentScore,
        validFormatFound,
        bestFormatIsValid = false,
        configfLen = config._f.length;
      if (configfLen === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
      }
      for (i = 0; i < configfLen; i++) {
        currentScore = 0;
        validFormatFound = false;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
          tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);
        if (isValid(tempConfig)) {
          validFormatFound = true;
        }
        currentScore += getParsingFlags(tempConfig).charsLeftOver;
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
        getParsingFlags(tempConfig).score = currentScore;
        if (!bestFormatIsValid) {
          if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
            if (validFormatFound) {
              bestFormatIsValid = true;
            }
          }
        } else {
          if (currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
          }
        }
      }
      extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
      if (config._d) {
        return;
      }
      var i = normalizeObjectUnits(config._i),
        dayOrDate = i.day === undefined ? i.date : i.day;
      config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
      });
      configFromArray(config);
    }
    function createFromConfig(config) {
      var res = new Moment(checkOverflow(prepareConfig(config)));
      if (res._nextDay) {
        res.add(1, 'd');
        res._nextDay = undefined;
      }
      return res;
    }
    function prepareConfig(config) {
      var input = config._i,
        format = config._f;
      config._locale = config._locale || getLocale(config._l);
      if (input === null || format === undefined && input === '') {
        return createInvalid({
          nullInput: true
        });
      }
      if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
      }
      if (isMoment(input)) {
        return new Moment(checkOverflow(input));
      } else if (isDate(input)) {
        config._d = input;
      } else if (isArray(format)) {
        configFromStringAndArray(config);
      } else if (format) {
        configFromStringAndFormat(config);
      } else {
        configFromInput(config);
      }
      if (!isValid(config)) {
        config._d = null;
      }
      return config;
    }
    function configFromInput(config) {
      var input = config._i;
      if (isUndefined(input)) {
        config._d = new Date(hooks.now());
      } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
      } else if (typeof input === 'string') {
        configFromString(config);
      } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
          return parseInt(obj, 10);
        });
        configFromArray(config);
      } else if (isObject(input)) {
        configFromObject(config);
      } else if (isNumber(input)) {
        config._d = new Date(input);
      } else {
        hooks.createFromInputFallback(config);
      }
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
      var c = {};
      if (format === true || format === false) {
        strict = format;
        format = undefined;
      }
      if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
      }
      if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
        input = undefined;
      }
      c._isAMomentObject = true;
      c._useUTC = c._isUTC = isUTC;
      c._l = locale;
      c._i = input;
      c._f = format;
      c._strict = strict;
      return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other < this ? this : other;
        } else {
          return createInvalid();
        }
      }),
      prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other > this ? this : other;
        } else {
          return createInvalid();
        }
      });
    function pickBy(fn, moments) {
      var res, i;
      if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
      }
      if (!moments.length) {
        return createLocal();
      }
      res = moments[0];
      for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
          res = moments[i];
        }
      }
      return res;
    }
    function min() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isBefore', args);
    }
    function max() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isAfter', args);
    }
    var now = function now() {
      return Date.now ? Date.now() : +new Date();
    };
    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
    function isDurationValid(m) {
      var key,
        unitHasDecimal = false,
        i,
        orderLen = ordering.length;
      for (key in m) {
        if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
          return false;
        }
      }
      for (i = 0; i < orderLen; ++i) {
        if (m[ordering[i]]) {
          if (unitHasDecimal) {
            return false;
          }
          if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
            unitHasDecimal = true;
          }
        }
      }
      return true;
    }
    function isValid$1() {
      return this._isValid;
    }
    function createInvalid$1() {
      return createDuration(NaN);
    }
    function Duration(duration) {
      var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;
      this._isValid = isDurationValid(normalizedInput);
      this._milliseconds = +milliseconds + seconds * 1e3 + minutes * 6e4 + hours * 1000 * 60 * 60;
      this._days = +days + weeks * 7;
      this._months = +months + quarters * 3 + years * 12;
      this._data = {};
      this._locale = getLocale();
      this._bubble();
    }
    function isDuration(obj) {
      return obj instanceof Duration;
    }
    function absRound(number) {
      if (number < 0) {
        return Math.round(-1 * number) * -1;
      } else {
        return Math.round(number);
      }
    }
    function compareArrays(array1, array2, dontConvert) {
      var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
      for (i = 0; i < len; i++) {
        if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
          diffs++;
        }
      }
      return diffs + lengthDiff;
    }
    function offset(token, separator) {
      addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset(),
          sign = '+';
        if (offset < 0) {
          offset = -offset;
          sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
      });
    }
    offset('Z', ':');
    offset('ZZ', '');
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
      config._useUTC = true;
      config._tzm = offsetFromString(matchShortOffset, input);
    });
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
      var matches = (string || '').match(matcher),
        chunk,
        parts,
        minutes;
      if (matches === null) {
        return null;
      }
      chunk = matches[matches.length - 1] || [];
      parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
      minutes = +(parts[1] * 60) + toInt(parts[2]);
      return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    function cloneWithOffset(input, model) {
      var res, diff;
      if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
      } else {
        return createLocal(input).local();
      }
    }
    function getDateOffset(m) {
      return -Math.round(m._d.getTimezoneOffset());
    }
    hooks.updateOffset = function () {};
    function getSetOffset(input, keepLocalTime, keepMinutes) {
      var offset = this._offset || 0,
        localAdjust;
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        if (typeof input === 'string') {
          input = offsetFromString(matchShortOffset, input);
          if (input === null) {
            return this;
          }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
          input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
          localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
          this.add(localAdjust, 'm');
        }
        if (offset !== input) {
          if (!keepLocalTime || this._changeInProgress) {
            addSubtract(this, createDuration(input - offset, 'm'), 1, false);
          } else if (!this._changeInProgress) {
            this._changeInProgress = true;
            hooks.updateOffset(this, true);
            this._changeInProgress = null;
          }
        }
        return this;
      } else {
        return this._isUTC ? offset : getDateOffset(this);
      }
    }
    function getSetZone(input, keepLocalTime) {
      if (input != null) {
        if (typeof input !== 'string') {
          input = -input;
        }
        this.utcOffset(input, keepLocalTime);
        return this;
      } else {
        return -this.utcOffset();
      }
    }
    function setOffsetToUTC(keepLocalTime) {
      return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
      if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;
        if (keepLocalTime) {
          this.subtract(getDateOffset(this), 'm');
        }
      }
      return this;
    }
    function setOffsetToParsedOffset() {
      if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
      } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
          this.utcOffset(tZone);
        } else {
          this.utcOffset(0, true);
        }
      }
      return this;
    }
    function hasAlignedHourOffset(input) {
      if (!this.isValid()) {
        return false;
      }
      input = input ? createLocal(input).utcOffset() : 0;
      return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
      return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
      if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
      }
      var c = {},
        other;
      copyConfig(c, this);
      c = prepareConfig(c);
      if (c._a) {
        other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
      } else {
        this._isDSTShifted = false;
      }
      return this._isDSTShifted;
    }
    function isLocal() {
      return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
      return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
      isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
      var duration = input,
        match = null,
        sign,
        ret,
        diffRes;
      if (isDuration(input)) {
        duration = {
          ms: input._milliseconds,
          d: input._days,
          M: input._months
        };
      } else if (isNumber(input) || !isNaN(+input)) {
        duration = {};
        if (key) {
          duration[key] = +input;
        } else {
          duration.milliseconds = +input;
        }
      } else if (match = aspNetRegex.exec(input)) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: 0,
          d: toInt(match[DATE]) * sign,
          h: toInt(match[HOUR]) * sign,
          m: toInt(match[MINUTE]) * sign,
          s: toInt(match[SECOND]) * sign,
          ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
        };
      } else if (match = isoRegex.exec(input)) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: parseIso(match[2], sign),
          M: parseIso(match[3], sign),
          w: parseIso(match[4], sign),
          d: parseIso(match[5], sign),
          h: parseIso(match[6], sign),
          m: parseIso(match[7], sign),
          s: parseIso(match[8], sign)
        };
      } else if (duration == null) {
        duration = {};
      } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
      }
      ret = new Duration(duration);
      if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
      }
      if (isDuration(input) && hasOwnProp(input, '_isValid')) {
        ret._isValid = input._isValid;
      }
      return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
      var res = inp && parseFloat(inp.replace(',', '.'));
      return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
      var res = {};
      res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
      if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
      }
      res.milliseconds = +other - +base.clone().add(res.months, 'M');
      return res;
    }
    function momentsDifference(base, other) {
      var res;
      if (!(base.isValid() && other.isValid())) {
        return {
          milliseconds: 0,
          months: 0
        };
      }
      other = cloneWithOffset(other, base);
      if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
      } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
      }
      return res;
    }
    function createAdder(direction, name) {
      return function (val, period) {
        var dur, tmp;
        if (period !== null && !isNaN(+period)) {
          deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
          tmp = val;
          val = period;
          period = tmp;
        }
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
      };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
      var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);
      if (!mom.isValid()) {
        return;
      }
      updateOffset = updateOffset == null ? true : updateOffset;
      if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
      }
      if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
      }
      if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
      }
      if (updateOffset) {
        hooks.updateOffset(mom, days || months);
      }
    }
    var add = createAdder(1, 'add'),
      subtract = createAdder(-1, 'subtract');
    function isString(input) {
      return typeof input === 'string' || input instanceof String;
    }
    function isMomentInput(input) {
      return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['years', 'year', 'y', 'months', 'month', 'M', 'days', 'day', 'd', 'dates', 'date', 'D', 'hours', 'hour', 'h', 'minutes', 'minute', 'm', 'seconds', 'second', 's', 'milliseconds', 'millisecond', 'ms'],
        i,
        property,
        propertyLen = properties.length;
      for (i = 0; i < propertyLen; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
      var arrayTest = isArray(input),
        dataTypeTest = false;
      if (arrayTest) {
        dataTypeTest = input.filter(function (item) {
          return !isNumber(item) && isString(input);
        }).length === 0;
      }
      return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'],
        i,
        property;
      for (i = 0; i < properties.length; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
      var diff = myMoment.diff(now, 'days', true);
      return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
      if (arguments.length === 1) {
        if (!arguments[0]) {
          time = undefined;
          formats = undefined;
        } else if (isMomentInput(arguments[0])) {
          time = arguments[0];
          formats = undefined;
        } else if (isCalendarSpec(arguments[0])) {
          formats = arguments[0];
          time = undefined;
        }
      }
      var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse',
        output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
      return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
      return new Moment(this);
    }
    function isAfter(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
      } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
      }
    }
    function isBefore(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
      } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
      }
    }
    function isBetween(from, to, units, inclusivity) {
      var localFrom = isMoment(from) ? from : createLocal(from),
        localTo = isMoment(to) ? to : createLocal(to);
      if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
      }
      inclusivity = inclusivity || '()';
      return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
      } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
      }
    }
    function isSameOrAfter(input, units) {
      return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
      return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
      var that, zoneDelta, output;
      if (!this.isValid()) {
        return NaN;
      }
      that = cloneWithOffset(input, this);
      if (!that.isValid()) {
        return NaN;
      }
      zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
      units = normalizeUnits(units);
      switch (units) {
        case 'year':
          output = monthDiff(this, that) / 12;
          break;
        case 'month':
          output = monthDiff(this, that);
          break;
        case 'quarter':
          output = monthDiff(this, that) / 3;
          break;
        case 'second':
          output = (this - that) / 1e3;
          break;
        case 'minute':
          output = (this - that) / 6e4;
          break;
        case 'hour':
          output = (this - that) / 36e5;
          break;
        case 'day':
          output = (this - that - zoneDelta) / 864e5;
          break;
        case 'week':
          output = (this - that - zoneDelta) / 6048e5;
          break;
        default:
          output = this - that;
      }
      return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
      if (a.date() < b.date()) {
        return -monthDiff(b, a);
      }
      var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2,
        adjust;
      if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        adjust = (b - anchor) / (anchor - anchor2);
      } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        adjust = (b - anchor) / (anchor2 - anchor);
      }
      return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
      return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
      if (!this.isValid()) {
        return null;
      }
      var utc = keepOffset !== true,
        m = utc ? this.clone().utc() : this;
      if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
      }
      if (isFunction(Date.prototype.toISOString)) {
        if (utc) {
          return this.toDate().toISOString();
        } else {
          return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
      }
      return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    function inspect() {
      if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
      }
      var func = 'moment',
        zone = '',
        prefix,
        year,
        datetime,
        suffix;
      if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
      }
      prefix = '[' + func + '("]';
      year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
      datetime = '-MM-DD[T]HH:mm:ss.SSS';
      suffix = zone + '[")]';
      return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
      if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
      }
      var output = formatMoment(this, inputString);
      return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          to: this,
          from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function fromNow(withoutSuffix) {
      return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          from: this,
          to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function toNow(withoutSuffix) {
      return this.to(createLocal(), withoutSuffix);
    }
    function locale(key) {
      var newLocaleData;
      if (key === undefined) {
        return this._locale._abbr;
      } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
          this._locale = newLocaleData;
        }
        return this;
      }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
      if (key === undefined) {
        return this.localeData();
      } else {
        return this.locale(key);
      }
    });
    function localeData() {
      return this._locale;
    }
    var MS_PER_SECOND = 1000,
      MS_PER_MINUTE = 60 * MS_PER_SECOND,
      MS_PER_HOUR = 60 * MS_PER_MINUTE,
      MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
    function mod$1(dividend, divisor) {
      return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return new Date(y, m, d).valueOf();
      }
    }
    function utcStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return Date.UTC(y, m, d);
      }
    }
    function startOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case 'year':
          time = startOfDate(this.year(), 0, 1);
          break;
        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
          break;
        case 'month':
          time = startOfDate(this.year(), this.month(), 1);
          break;
        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
          break;
        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
          break;
        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date());
          break;
        case 'hour':
          time = this._d.valueOf();
          time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
          break;
        case 'minute':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_MINUTE);
          break;
        case 'second':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_SECOND);
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function endOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case 'year':
          time = startOfDate(this.year() + 1, 0, 1) - 1;
          break;
        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
          break;
        case 'month':
          time = startOfDate(this.year(), this.month() + 1, 1) - 1;
          break;
        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
          break;
        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
          break;
        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
          break;
        case 'hour':
          time = this._d.valueOf();
          time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
          break;
        case 'minute':
          time = this._d.valueOf();
          time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
          break;
        case 'second':
          time = this._d.valueOf();
          time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function valueOf() {
      return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
      return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
      return new Date(this.valueOf());
    }
    function toArray() {
      var m = this;
      return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }
    function toObject() {
      var m = this;
      return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
      };
    }
    function toJSON() {
      return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
      return isValid(this);
    }
    function parsingFlags() {
      return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
      return getParsingFlags(this).overflow;
    }
    function creationData() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (input, array, config, token) {
      var era = config._locale.erasParse(input, token, config._strict);
      if (era) {
        getParsingFlags(config).era = era;
      } else {
        getParsingFlags(config).invalidEra = input;
      }
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
      var match;
      if (config._locale._eraYearOrdinalRegex) {
        match = input.match(config._locale._eraYearOrdinalRegex);
      }
      if (config._locale.eraYearOrdinalParse) {
        array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
      } else {
        array[YEAR] = parseInt(input, 10);
      }
    });
    function localeEras(m, format) {
      var i,
        l,
        date,
        eras = this._eras || getLocale('en')._eras;
      for (i = 0, l = eras.length; i < l; ++i) {
        switch (typeof eras[i].since) {
          case 'string':
            date = hooks(eras[i].since).startOf('day');
            eras[i].since = date.valueOf();
            break;
        }
        switch (typeof eras[i].until) {
          case 'undefined':
            eras[i].until = +Infinity;
            break;
          case 'string':
            date = hooks(eras[i].until).startOf('day').valueOf();
            eras[i].until = date.valueOf();
            break;
        }
      }
      return eras;
    }
    function localeErasParse(eraName, format, strict) {
      var i,
        l,
        eras = this.eras(),
        name,
        abbr,
        narrow;
      eraName = eraName.toUpperCase();
      for (i = 0, l = eras.length; i < l; ++i) {
        name = eras[i].name.toUpperCase();
        abbr = eras[i].abbr.toUpperCase();
        narrow = eras[i].narrow.toUpperCase();
        if (strict) {
          switch (format) {
            case 'N':
            case 'NN':
            case 'NNN':
              if (abbr === eraName) {
                return eras[i];
              }
              break;
            case 'NNNN':
              if (name === eraName) {
                return eras[i];
              }
              break;
            case 'NNNNN':
              if (narrow === eraName) {
                return eras[i];
              }
              break;
          }
        } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
          return eras[i];
        }
      }
    }
    function localeErasConvertYear(era, year) {
      var dir = era.since <= era.until ? +1 : -1;
      if (year === undefined) {
        return hooks(era.since).year();
      } else {
        return hooks(era.since).year() + (year - era.offset) * dir;
      }
    }
    function getEraName() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].name;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].name;
        }
      }
      return '';
    }
    function getEraNarrow() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].narrow;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].narrow;
        }
      }
      return '';
    }
    function getEraAbbr() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].abbr;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].abbr;
        }
      }
      return '';
    }
    function getEraYear() {
      var i,
        l,
        dir,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        dir = eras[i].since <= eras[i].until ? +1 : -1;
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
          return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
      }
      return this.year();
    }
    function erasNameRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNameRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
      if (!hasOwnProp(this, '_erasAbbrRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNarrowRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
      return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
      return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
      return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
      return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
      var abbrPieces = [],
        namePieces = [],
        narrowPieces = [],
        mixedPieces = [],
        i,
        l,
        eras = this.eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        namePieces.push(regexEscape(eras[i].name));
        abbrPieces.push(regexEscape(eras[i].abbr));
        narrowPieces.push(regexEscape(eras[i].narrow));
        mixedPieces.push(regexEscape(eras[i].name));
        mixedPieces.push(regexEscape(eras[i].abbr));
        mixedPieces.push(regexEscape(eras[i].narrow));
      }
      this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
      this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
      this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    addFormatToken(0, ['gg', 2], 0, function () {
      return this.weekYear() % 100;
    });
    addFormatToken(0, ['GG', 2], 0, function () {
      return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
      addFormatToken(0, [token, token.length], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');
    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
      week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
      week[token] = hooks.parseTwoDigitYear(input);
    });
    function getSetWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
      return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
      return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
      var weeksTarget;
      if (input == null) {
        return weekOfYear(this, dow, doy).year;
      } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
          week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
      }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
      var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
      this.year(date.getUTCFullYear());
      this.month(date.getUTCMonth());
      this.date(date.getUTCDate());
      return this;
    }
    addFormatToken('Q', 0, 'Qo', 'quarter');
    addUnitAlias('quarter', 'Q');
    addUnitPriority('quarter', 7);
    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
      array[MONTH] = (toInt(input) - 1) * 3;
    });
    function getSetQuarter(input) {
      return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    addFormatToken('D', ['DD', 2], 'Do', 'date');
    addUnitAlias('date', 'D');
    addUnitPriority('date', 9);
    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
      return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
      array[DATE] = toInt(input.match(match1to2)[0]);
    });
    var getSetDayOfMonth = makeGetSet('Date', true);
    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
    addUnitAlias('dayOfYear', 'DDD');
    addUnitPriority('dayOfYear', 4);
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
      config._dayOfYear = toInt(input);
    });
    function getSetDayOfYear(input) {
      var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
      return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    addFormatToken('m', ['mm', 2], 0, 'minute');
    addUnitAlias('minute', 'm');
    addUnitPriority('minute', 14);
    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);
    var getSetMinute = makeGetSet('Minutes', false);
    addFormatToken('s', ['ss', 2], 0, 'second');
    addUnitAlias('second', 's');
    addUnitPriority('second', 15);
    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);
    var getSetSecond = makeGetSet('Seconds', false);
    addFormatToken('S', 0, 0, function () {
      return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, ['SS', 2], 0, function () {
      return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
      return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
      return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
      return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
      return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
      return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
      return this.millisecond() * 1000000;
    });
    addUnitAlias('millisecond', 'ms');
    addUnitPriority('millisecond', 16);
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
      addRegexToken(token, matchUnsigned);
    }
    function parseMs(input, array) {
      array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for (token = 'S'; token.length <= 9; token += 'S') {
      addParseToken(token, parseMs);
    }
    getSetMillisecond = makeGetSet('Milliseconds', false);
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    function getZoneAbbr() {
      return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
      return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol["for"] != null) {
      proto[Symbol["for"]('nodejs.util.inspect.custom')] = function () {
        return 'Moment<' + this.format() + '>';
      };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
      return createLocal(input * 1000);
    }
    function createInZone() {
      return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
      return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
      var locale = getLocale(),
        utc = createUTC().set(setter, index);
      return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }
      format = format || '';
      if (index != null) {
        return get$1(format, index, field, 'month');
      }
      var i,
        out = [];
      for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
      }
      return out;
    }
    function listWeekdaysImpl(localeSorted, format, index, field) {
      if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }
        format = format || '';
      } else {
        format = localeSorted;
        index = format;
        localeSorted = false;
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }
        format = format || '';
      }
      var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0,
        i,
        out = [];
      if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
      }
      for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
      }
      return out;
    }
    function listMonths(format, index) {
      return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
      return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
      eras: [{
        since: '0001-01-01',
        until: +Infinity,
        offset: 1,
        name: 'Anno Domini',
        narrow: 'AD',
        abbr: 'AD'
      }, {
        since: '0000-12-31',
        until: -Infinity,
        offset: 1,
        name: 'Before Christ',
        narrow: 'BC',
        abbr: 'BC'
      }],
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function ordinal(number) {
        var b = number % 10,
          output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        return number + output;
      }
    });
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
      var data = this._data;
      this._milliseconds = mathAbs(this._milliseconds);
      this._days = mathAbs(this._days);
      this._months = mathAbs(this._months);
      data.milliseconds = mathAbs(data.milliseconds);
      data.seconds = mathAbs(data.seconds);
      data.minutes = mathAbs(data.minutes);
      data.hours = mathAbs(data.hours);
      data.months = mathAbs(data.months);
      data.years = mathAbs(data.years);
      return this;
    }
    function addSubtract$1(duration, input, value, direction) {
      var other = createDuration(input, value);
      duration._milliseconds += direction * other._milliseconds;
      duration._days += direction * other._days;
      duration._months += direction * other._months;
      return duration._bubble();
    }
    function add$1(input, value) {
      return addSubtract$1(this, input, value, 1);
    }
    function subtract$1(input, value) {
      return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
      if (number < 0) {
        return Math.floor(number);
      } else {
        return Math.ceil(number);
      }
    }
    function bubble() {
      var milliseconds = this._milliseconds,
        days = this._days,
        months = this._months,
        data = this._data,
        seconds,
        minutes,
        hours,
        years,
        monthsFromDays;
      if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
      }
      data.milliseconds = milliseconds % 1000;
      seconds = absFloor(milliseconds / 1000);
      data.seconds = seconds % 60;
      minutes = absFloor(seconds / 60);
      data.minutes = minutes % 60;
      hours = absFloor(minutes / 60);
      data.hours = hours % 24;
      days += absFloor(hours / 24);
      monthsFromDays = absFloor(daysToMonths(days));
      months += monthsFromDays;
      days -= absCeil(monthsToDays(monthsFromDays));
      years = absFloor(months / 12);
      months %= 12;
      data.days = days;
      data.months = months;
      data.years = years;
      return this;
    }
    function daysToMonths(days) {
      return days * 4800 / 146097;
    }
    function monthsToDays(months) {
      return months * 146097 / 4800;
    }
    function as(units) {
      if (!this.isValid()) {
        return NaN;
      }
      var days,
        months,
        milliseconds = this._milliseconds;
      units = normalizeUnits(units);
      if (units === 'month' || units === 'quarter' || units === 'year') {
        days = this._days + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        switch (units) {
          case 'month':
            return months;
          case 'quarter':
            return months / 3;
          case 'year':
            return months / 12;
        }
      } else {
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
          case 'week':
            return days / 7 + milliseconds / 6048e5;
          case 'day':
            return days + milliseconds / 864e5;
          case 'hour':
            return days * 24 + milliseconds / 36e5;
          case 'minute':
            return days * 1440 + milliseconds / 6e4;
          case 'second':
            return days * 86400 + milliseconds / 1000;
          case 'millisecond':
            return Math.floor(days * 864e5) + milliseconds;
          default:
            throw new Error('Unknown unit ' + units);
        }
      }
    }
    function valueOf$1() {
      if (!this.isValid()) {
        return NaN;
      }
      return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
      return function () {
        return this.as(alias);
      };
    }
    var asMilliseconds = makeAs('ms'),
      asSeconds = makeAs('s'),
      asMinutes = makeAs('m'),
      asHours = makeAs('h'),
      asDays = makeAs('d'),
      asWeeks = makeAs('w'),
      asMonths = makeAs('M'),
      asQuarters = makeAs('Q'),
      asYears = makeAs('y');
    function clone$1() {
      return createDuration(this);
    }
    function get$2(units) {
      units = normalizeUnits(units);
      return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
      return function () {
        return this.isValid() ? this._data[name] : NaN;
      };
    }
    var milliseconds = makeGetter('milliseconds'),
      seconds = makeGetter('seconds'),
      minutes = makeGetter('minutes'),
      hours = makeGetter('hours'),
      days = makeGetter('days'),
      months = makeGetter('months'),
      years = makeGetter('years');
    function weeks() {
      return absFloor(this.days() / 7);
    }
    var round = Math.round,
      thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
      };
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
      return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
      var duration = createDuration(posNegDuration).abs(),
        seconds = round(duration.as('s')),
        minutes = round(duration.as('m')),
        hours = round(duration.as('h')),
        days = round(duration.as('d')),
        months = round(duration.as('M')),
        weeks = round(duration.as('w')),
        years = round(duration.as('y')),
        a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days];
      if (thresholds.w != null) {
        a = a || weeks <= 1 && ['w'] || weeks < thresholds.w && ['ww', weeks];
      }
      a = a || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
      a[2] = withoutSuffix;
      a[3] = +posNegDuration > 0;
      a[4] = locale;
      return substituteTimeAgo.apply(null, a);
    }
    function getSetRelativeTimeRounding(roundingFunction) {
      if (roundingFunction === undefined) {
        return round;
      }
      if (typeof roundingFunction === 'function') {
        round = roundingFunction;
        return true;
      }
      return false;
    }
    function getSetRelativeTimeThreshold(threshold, limit) {
      if (thresholds[threshold] === undefined) {
        return false;
      }
      if (limit === undefined) {
        return thresholds[threshold];
      }
      thresholds[threshold] = limit;
      if (threshold === 's') {
        thresholds.ss = limit - 1;
      }
      return true;
    }
    function humanize(argWithSuffix, argThresholds) {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var withSuffix = false,
        th = thresholds,
        locale,
        output;
      if (typeof argWithSuffix === 'object') {
        argThresholds = argWithSuffix;
        argWithSuffix = false;
      }
      if (typeof argWithSuffix === 'boolean') {
        withSuffix = argWithSuffix;
      }
      if (typeof argThresholds === 'object') {
        th = Object.assign({}, thresholds, argThresholds);
        if (argThresholds.s != null && argThresholds.ss == null) {
          th.ss = argThresholds.s - 1;
        }
      }
      locale = this.localeData();
      output = relativeTime$1(this, !withSuffix, th, locale);
      if (withSuffix) {
        output = locale.pastFuture(+this, output);
      }
      return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
      return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var seconds = abs$1(this._milliseconds) / 1000,
        days = abs$1(this._days),
        months = abs$1(this._months),
        minutes,
        hours,
        years,
        s,
        total = this.asSeconds(),
        totalSign,
        ymSign,
        daysSign,
        hmsSign;
      if (!total) {
        return 'P0D';
      }
      minutes = absFloor(seconds / 60);
      hours = absFloor(minutes / 60);
      seconds %= 60;
      minutes %= 60;
      years = absFloor(months / 12);
      months %= 12;
      s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
      totalSign = total < 0 ? '-' : '';
      ymSign = sign(this._months) !== sign(total) ? '-' : '';
      daysSign = sign(this._days) !== sign(total) ? '-' : '';
      hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
      return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
      config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
      config._d = new Date(toInt(input));
    });
    hooks.version = '2.29.4';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    hooks.HTML5_FMT = {
      DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
      DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
      DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
      DATE: 'YYYY-MM-DD',
      TIME: 'HH:mm',
      TIME_SECONDS: 'HH:mm:ss',
      TIME_MS: 'HH:mm:ss.SSS',
      WEEK: 'GGGG-[W]WW',
      MONTH: 'YYYY-MM'
    };
    return hooks;
  });
});

var Chart = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
     module.exports = factory(function () {
      try {
        return moment;
      } catch (e) {}
    }()) ;
  })(commonjsGlobal, function (moment) {

    moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
    function createCommonjsModule(fn, module) {
      return module = {
        exports: {}
      }, fn(module, module.exports), module.exports;
    }
    function getCjsExportFromNamespace(n) {
      return n && n['default'] || n;
    }
    var colorName = {
      "aliceblue": [240, 248, 255],
      "antiquewhite": [250, 235, 215],
      "aqua": [0, 255, 255],
      "aquamarine": [127, 255, 212],
      "azure": [240, 255, 255],
      "beige": [245, 245, 220],
      "bisque": [255, 228, 196],
      "black": [0, 0, 0],
      "blanchedalmond": [255, 235, 205],
      "blue": [0, 0, 255],
      "blueviolet": [138, 43, 226],
      "brown": [165, 42, 42],
      "burlywood": [222, 184, 135],
      "cadetblue": [95, 158, 160],
      "chartreuse": [127, 255, 0],
      "chocolate": [210, 105, 30],
      "coral": [255, 127, 80],
      "cornflowerblue": [100, 149, 237],
      "cornsilk": [255, 248, 220],
      "crimson": [220, 20, 60],
      "cyan": [0, 255, 255],
      "darkblue": [0, 0, 139],
      "darkcyan": [0, 139, 139],
      "darkgoldenrod": [184, 134, 11],
      "darkgray": [169, 169, 169],
      "darkgreen": [0, 100, 0],
      "darkgrey": [169, 169, 169],
      "darkkhaki": [189, 183, 107],
      "darkmagenta": [139, 0, 139],
      "darkolivegreen": [85, 107, 47],
      "darkorange": [255, 140, 0],
      "darkorchid": [153, 50, 204],
      "darkred": [139, 0, 0],
      "darksalmon": [233, 150, 122],
      "darkseagreen": [143, 188, 143],
      "darkslateblue": [72, 61, 139],
      "darkslategray": [47, 79, 79],
      "darkslategrey": [47, 79, 79],
      "darkturquoise": [0, 206, 209],
      "darkviolet": [148, 0, 211],
      "deeppink": [255, 20, 147],
      "deepskyblue": [0, 191, 255],
      "dimgray": [105, 105, 105],
      "dimgrey": [105, 105, 105],
      "dodgerblue": [30, 144, 255],
      "firebrick": [178, 34, 34],
      "floralwhite": [255, 250, 240],
      "forestgreen": [34, 139, 34],
      "fuchsia": [255, 0, 255],
      "gainsboro": [220, 220, 220],
      "ghostwhite": [248, 248, 255],
      "gold": [255, 215, 0],
      "goldenrod": [218, 165, 32],
      "gray": [128, 128, 128],
      "green": [0, 128, 0],
      "greenyellow": [173, 255, 47],
      "grey": [128, 128, 128],
      "honeydew": [240, 255, 240],
      "hotpink": [255, 105, 180],
      "indianred": [205, 92, 92],
      "indigo": [75, 0, 130],
      "ivory": [255, 255, 240],
      "khaki": [240, 230, 140],
      "lavender": [230, 230, 250],
      "lavenderblush": [255, 240, 245],
      "lawngreen": [124, 252, 0],
      "lemonchiffon": [255, 250, 205],
      "lightblue": [173, 216, 230],
      "lightcoral": [240, 128, 128],
      "lightcyan": [224, 255, 255],
      "lightgoldenrodyellow": [250, 250, 210],
      "lightgray": [211, 211, 211],
      "lightgreen": [144, 238, 144],
      "lightgrey": [211, 211, 211],
      "lightpink": [255, 182, 193],
      "lightsalmon": [255, 160, 122],
      "lightseagreen": [32, 178, 170],
      "lightskyblue": [135, 206, 250],
      "lightslategray": [119, 136, 153],
      "lightslategrey": [119, 136, 153],
      "lightsteelblue": [176, 196, 222],
      "lightyellow": [255, 255, 224],
      "lime": [0, 255, 0],
      "limegreen": [50, 205, 50],
      "linen": [250, 240, 230],
      "magenta": [255, 0, 255],
      "maroon": [128, 0, 0],
      "mediumaquamarine": [102, 205, 170],
      "mediumblue": [0, 0, 205],
      "mediumorchid": [186, 85, 211],
      "mediumpurple": [147, 112, 219],
      "mediumseagreen": [60, 179, 113],
      "mediumslateblue": [123, 104, 238],
      "mediumspringgreen": [0, 250, 154],
      "mediumturquoise": [72, 209, 204],
      "mediumvioletred": [199, 21, 133],
      "midnightblue": [25, 25, 112],
      "mintcream": [245, 255, 250],
      "mistyrose": [255, 228, 225],
      "moccasin": [255, 228, 181],
      "navajowhite": [255, 222, 173],
      "navy": [0, 0, 128],
      "oldlace": [253, 245, 230],
      "olive": [128, 128, 0],
      "olivedrab": [107, 142, 35],
      "orange": [255, 165, 0],
      "orangered": [255, 69, 0],
      "orchid": [218, 112, 214],
      "palegoldenrod": [238, 232, 170],
      "palegreen": [152, 251, 152],
      "paleturquoise": [175, 238, 238],
      "palevioletred": [219, 112, 147],
      "papayawhip": [255, 239, 213],
      "peachpuff": [255, 218, 185],
      "peru": [205, 133, 63],
      "pink": [255, 192, 203],
      "plum": [221, 160, 221],
      "powderblue": [176, 224, 230],
      "purple": [128, 0, 128],
      "rebeccapurple": [102, 51, 153],
      "red": [255, 0, 0],
      "rosybrown": [188, 143, 143],
      "royalblue": [65, 105, 225],
      "saddlebrown": [139, 69, 19],
      "salmon": [250, 128, 114],
      "sandybrown": [244, 164, 96],
      "seagreen": [46, 139, 87],
      "seashell": [255, 245, 238],
      "sienna": [160, 82, 45],
      "silver": [192, 192, 192],
      "skyblue": [135, 206, 235],
      "slateblue": [106, 90, 205],
      "slategray": [112, 128, 144],
      "slategrey": [112, 128, 144],
      "snow": [255, 250, 250],
      "springgreen": [0, 255, 127],
      "steelblue": [70, 130, 180],
      "tan": [210, 180, 140],
      "teal": [0, 128, 128],
      "thistle": [216, 191, 216],
      "tomato": [255, 99, 71],
      "turquoise": [64, 224, 208],
      "violet": [238, 130, 238],
      "wheat": [245, 222, 179],
      "white": [255, 255, 255],
      "whitesmoke": [245, 245, 245],
      "yellow": [255, 255, 0],
      "yellowgreen": [154, 205, 50]
    };
    var conversions = createCommonjsModule(function (module) {
      var reverseKeywords = {};
      for (var key in colorName) {
        if (colorName.hasOwnProperty(key)) {
          reverseKeywords[colorName[key]] = key;
        }
      }
      var convert = module.exports = {
        rgb: {
          channels: 3,
          labels: 'rgb'
        },
        hsl: {
          channels: 3,
          labels: 'hsl'
        },
        hsv: {
          channels: 3,
          labels: 'hsv'
        },
        hwb: {
          channels: 3,
          labels: 'hwb'
        },
        cmyk: {
          channels: 4,
          labels: 'cmyk'
        },
        xyz: {
          channels: 3,
          labels: 'xyz'
        },
        lab: {
          channels: 3,
          labels: 'lab'
        },
        lch: {
          channels: 3,
          labels: 'lch'
        },
        hex: {
          channels: 1,
          labels: ['hex']
        },
        keyword: {
          channels: 1,
          labels: ['keyword']
        },
        ansi16: {
          channels: 1,
          labels: ['ansi16']
        },
        ansi256: {
          channels: 1,
          labels: ['ansi256']
        },
        hcg: {
          channels: 3,
          labels: ['h', 'c', 'g']
        },
        apple: {
          channels: 3,
          labels: ['r16', 'g16', 'b16']
        },
        gray: {
          channels: 1,
          labels: ['gray']
        }
      };
      for (var model in convert) {
        if (convert.hasOwnProperty(model)) {
          if (!('channels' in convert[model])) {
            throw new Error('missing channels property: ' + model);
          }
          if (!('labels' in convert[model])) {
            throw new Error('missing channel labels property: ' + model);
          }
          if (convert[model].labels.length !== convert[model].channels) {
            throw new Error('channel and label counts mismatch: ' + model);
          }
          var channels = convert[model].channels;
          var labels = convert[model].labels;
          delete convert[model].channels;
          delete convert[model].labels;
          Object.defineProperty(convert[model], 'channels', {
            value: channels
          });
          Object.defineProperty(convert[model], 'labels', {
            value: labels
          });
        }
      }
      convert.rgb.hsl = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var delta = max - min;
        var h;
        var s;
        var l;
        if (max === min) {
          h = 0;
        } else if (r === max) {
          h = (g - b) / delta;
        } else if (g === max) {
          h = 2 + (b - r) / delta;
        } else if (b === max) {
          h = 4 + (r - g) / delta;
        }
        h = Math.min(h * 60, 360);
        if (h < 0) {
          h += 360;
        }
        l = (min + max) / 2;
        if (max === min) {
          s = 0;
        } else if (l <= 0.5) {
          s = delta / (max + min);
        } else {
          s = delta / (2 - max - min);
        }
        return [h, s * 100, l * 100];
      };
      convert.rgb.hsv = function (rgb) {
        var rdif;
        var gdif;
        var bdif;
        var h;
        var s;
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var v = Math.max(r, g, b);
        var diff = v - Math.min(r, g, b);
        var diffc = function diffc(c) {
          return (v - c) / 6 / diff + 1 / 2;
        };
        if (diff === 0) {
          h = s = 0;
        } else {
          s = diff / v;
          rdif = diffc(r);
          gdif = diffc(g);
          bdif = diffc(b);
          if (r === v) {
            h = bdif - gdif;
          } else if (g === v) {
            h = 1 / 3 + rdif - bdif;
          } else if (b === v) {
            h = 2 / 3 + gdif - rdif;
          }
          if (h < 0) {
            h += 1;
          } else if (h > 1) {
            h -= 1;
          }
        }
        return [h * 360, s * 100, v * 100];
      };
      convert.rgb.hwb = function (rgb) {
        var r = rgb[0];
        var g = rgb[1];
        var b = rgb[2];
        var h = convert.rgb.hsl(rgb)[0];
        var w = 1 / 255 * Math.min(r, Math.min(g, b));
        b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
        return [h, w * 100, b * 100];
      };
      convert.rgb.cmyk = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var c;
        var m;
        var y;
        var k;
        k = Math.min(1 - r, 1 - g, 1 - b);
        c = (1 - r - k) / (1 - k) || 0;
        m = (1 - g - k) / (1 - k) || 0;
        y = (1 - b - k) / (1 - k) || 0;
        return [c * 100, m * 100, y * 100, k * 100];
      };
      function comparativeDistance(x, y) {
        return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
      }
      convert.rgb.keyword = function (rgb) {
        var reversed = reverseKeywords[rgb];
        if (reversed) {
          return reversed;
        }
        var currentClosestDistance = Infinity;
        var currentClosestKeyword;
        for (var keyword in colorName) {
          if (colorName.hasOwnProperty(keyword)) {
            var value = colorName[keyword];
            var distance = comparativeDistance(rgb, value);
            if (distance < currentClosestDistance) {
              currentClosestDistance = distance;
              currentClosestKeyword = keyword;
            }
          }
        }
        return currentClosestKeyword;
      };
      convert.keyword.rgb = function (keyword) {
        return colorName[keyword];
      };
      convert.rgb.xyz = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
        g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
        b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
        var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
        var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
        var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
        return [x * 100, y * 100, z * 100];
      };
      convert.rgb.lab = function (rgb) {
        var xyz = convert.rgb.xyz(rgb);
        var x = xyz[0];
        var y = xyz[1];
        var z = xyz[2];
        var l;
        var a;
        var b;
        x /= 95.047;
        y /= 100;
        z /= 108.883;
        x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
        l = 116 * y - 16;
        a = 500 * (x - y);
        b = 200 * (y - z);
        return [l, a, b];
      };
      convert.hsl.rgb = function (hsl) {
        var h = hsl[0] / 360;
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var t1;
        var t2;
        var t3;
        var rgb;
        var val;
        if (s === 0) {
          val = l * 255;
          return [val, val, val];
        }
        if (l < 0.5) {
          t2 = l * (1 + s);
        } else {
          t2 = l + s - l * s;
        }
        t1 = 2 * l - t2;
        rgb = [0, 0, 0];
        for (var i = 0; i < 3; i++) {
          t3 = h + 1 / 3 * -(i - 1);
          if (t3 < 0) {
            t3++;
          }
          if (t3 > 1) {
            t3--;
          }
          if (6 * t3 < 1) {
            val = t1 + (t2 - t1) * 6 * t3;
          } else if (2 * t3 < 1) {
            val = t2;
          } else if (3 * t3 < 2) {
            val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
          } else {
            val = t1;
          }
          rgb[i] = val * 255;
        }
        return rgb;
      };
      convert.hsl.hsv = function (hsl) {
        var h = hsl[0];
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var smin = s;
        var lmin = Math.max(l, 0.01);
        var sv;
        var v;
        l *= 2;
        s *= l <= 1 ? l : 2 - l;
        smin *= lmin <= 1 ? lmin : 2 - lmin;
        v = (l + s) / 2;
        sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
        return [h, sv * 100, v * 100];
      };
      convert.hsv.rgb = function (hsv) {
        var h = hsv[0] / 60;
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var hi = Math.floor(h) % 6;
        var f = h - Math.floor(h);
        var p = 255 * v * (1 - s);
        var q = 255 * v * (1 - s * f);
        var t = 255 * v * (1 - s * (1 - f));
        v *= 255;
        switch (hi) {
          case 0:
            return [v, t, p];
          case 1:
            return [q, v, p];
          case 2:
            return [p, v, t];
          case 3:
            return [p, q, v];
          case 4:
            return [t, p, v];
          case 5:
            return [v, p, q];
        }
      };
      convert.hsv.hsl = function (hsv) {
        var h = hsv[0];
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var vmin = Math.max(v, 0.01);
        var lmin;
        var sl;
        var l;
        l = (2 - s) * v;
        lmin = (2 - s) * vmin;
        sl = s * vmin;
        sl /= lmin <= 1 ? lmin : 2 - lmin;
        sl = sl || 0;
        l /= 2;
        return [h, sl * 100, l * 100];
      };
      convert.hwb.rgb = function (hwb) {
        var h = hwb[0] / 360;
        var wh = hwb[1] / 100;
        var bl = hwb[2] / 100;
        var ratio = wh + bl;
        var i;
        var v;
        var f;
        var n;
        if (ratio > 1) {
          wh /= ratio;
          bl /= ratio;
        }
        i = Math.floor(6 * h);
        v = 1 - bl;
        f = 6 * h - i;
        if ((i & 0x01) !== 0) {
          f = 1 - f;
        }
        n = wh + f * (v - wh);
        var r;
        var g;
        var b;
        switch (i) {
          default:
          case 6:
          case 0:
            r = v;
            g = n;
            b = wh;
            break;
          case 1:
            r = n;
            g = v;
            b = wh;
            break;
          case 2:
            r = wh;
            g = v;
            b = n;
            break;
          case 3:
            r = wh;
            g = n;
            b = v;
            break;
          case 4:
            r = n;
            g = wh;
            b = v;
            break;
          case 5:
            r = v;
            g = wh;
            b = n;
            break;
        }
        return [r * 255, g * 255, b * 255];
      };
      convert.cmyk.rgb = function (cmyk) {
        var c = cmyk[0] / 100;
        var m = cmyk[1] / 100;
        var y = cmyk[2] / 100;
        var k = cmyk[3] / 100;
        var r;
        var g;
        var b;
        r = 1 - Math.min(1, c * (1 - k) + k);
        g = 1 - Math.min(1, m * (1 - k) + k);
        b = 1 - Math.min(1, y * (1 - k) + k);
        return [r * 255, g * 255, b * 255];
      };
      convert.xyz.rgb = function (xyz) {
        var x = xyz[0] / 100;
        var y = xyz[1] / 100;
        var z = xyz[2] / 100;
        var r;
        var g;
        var b;
        r = x * 3.2406 + y * -1.5372 + z * -0.4986;
        g = x * -0.9689 + y * 1.8758 + z * 0.0415;
        b = x * 0.0557 + y * -0.2040 + z * 1.0570;
        r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
        g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
        b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
        r = Math.min(Math.max(0, r), 1);
        g = Math.min(Math.max(0, g), 1);
        b = Math.min(Math.max(0, b), 1);
        return [r * 255, g * 255, b * 255];
      };
      convert.xyz.lab = function (xyz) {
        var x = xyz[0];
        var y = xyz[1];
        var z = xyz[2];
        var l;
        var a;
        var b;
        x /= 95.047;
        y /= 100;
        z /= 108.883;
        x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
        l = 116 * y - 16;
        a = 500 * (x - y);
        b = 200 * (y - z);
        return [l, a, b];
      };
      convert.lab.xyz = function (lab) {
        var l = lab[0];
        var a = lab[1];
        var b = lab[2];
        var x;
        var y;
        var z;
        y = (l + 16) / 116;
        x = a / 500 + y;
        z = y - b / 200;
        var y2 = Math.pow(y, 3);
        var x2 = Math.pow(x, 3);
        var z2 = Math.pow(z, 3);
        y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
        x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
        z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
        x *= 95.047;
        y *= 100;
        z *= 108.883;
        return [x, y, z];
      };
      convert.lab.lch = function (lab) {
        var l = lab[0];
        var a = lab[1];
        var b = lab[2];
        var hr;
        var h;
        var c;
        hr = Math.atan2(b, a);
        h = hr * 360 / 2 / Math.PI;
        if (h < 0) {
          h += 360;
        }
        c = Math.sqrt(a * a + b * b);
        return [l, c, h];
      };
      convert.lch.lab = function (lch) {
        var l = lch[0];
        var c = lch[1];
        var h = lch[2];
        var a;
        var b;
        var hr;
        hr = h / 360 * 2 * Math.PI;
        a = c * Math.cos(hr);
        b = c * Math.sin(hr);
        return [l, a, b];
      };
      convert.rgb.ansi16 = function (args) {
        var r = args[0];
        var g = args[1];
        var b = args[2];
        var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2];
        value = Math.round(value / 50);
        if (value === 0) {
          return 30;
        }
        var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
        if (value === 2) {
          ansi += 60;
        }
        return ansi;
      };
      convert.hsv.ansi16 = function (args) {
        return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
      };
      convert.rgb.ansi256 = function (args) {
        var r = args[0];
        var g = args[1];
        var b = args[2];
        if (r === g && g === b) {
          if (r < 8) {
            return 16;
          }
          if (r > 248) {
            return 231;
          }
          return Math.round((r - 8) / 247 * 24) + 232;
        }
        var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
        return ansi;
      };
      convert.ansi16.rgb = function (args) {
        var color = args % 10;
        if (color === 0 || color === 7) {
          if (args > 50) {
            color += 3.5;
          }
          color = color / 10.5 * 255;
          return [color, color, color];
        }
        var mult = (~~(args > 50) + 1) * 0.5;
        var r = (color & 1) * mult * 255;
        var g = (color >> 1 & 1) * mult * 255;
        var b = (color >> 2 & 1) * mult * 255;
        return [r, g, b];
      };
      convert.ansi256.rgb = function (args) {
        if (args >= 232) {
          var c = (args - 232) * 10 + 8;
          return [c, c, c];
        }
        args -= 16;
        var rem;
        var r = Math.floor(args / 36) / 5 * 255;
        var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
        var b = rem % 6 / 5 * 255;
        return [r, g, b];
      };
      convert.rgb.hex = function (args) {
        var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
        var string = integer.toString(16).toUpperCase();
        return '000000'.substring(string.length) + string;
      };
      convert.hex.rgb = function (args) {
        var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
        if (!match) {
          return [0, 0, 0];
        }
        var colorString = match[0];
        if (match[0].length === 3) {
          colorString = colorString.split('').map(function (_char) {
            return _char + _char;
          }).join('');
        }
        var integer = parseInt(colorString, 16);
        var r = integer >> 16 & 0xFF;
        var g = integer >> 8 & 0xFF;
        var b = integer & 0xFF;
        return [r, g, b];
      };
      convert.rgb.hcg = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var max = Math.max(Math.max(r, g), b);
        var min = Math.min(Math.min(r, g), b);
        var chroma = max - min;
        var grayscale;
        var hue;
        if (chroma < 1) {
          grayscale = min / (1 - chroma);
        } else {
          grayscale = 0;
        }
        if (chroma <= 0) {
          hue = 0;
        } else if (max === r) {
          hue = (g - b) / chroma % 6;
        } else if (max === g) {
          hue = 2 + (b - r) / chroma;
        } else {
          hue = 4 + (r - g) / chroma + 4;
        }
        hue /= 6;
        hue %= 1;
        return [hue * 360, chroma * 100, grayscale * 100];
      };
      convert.hsl.hcg = function (hsl) {
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var c = 1;
        var f = 0;
        if (l < 0.5) {
          c = 2.0 * s * l;
        } else {
          c = 2.0 * s * (1.0 - l);
        }
        if (c < 1.0) {
          f = (l - 0.5 * c) / (1.0 - c);
        }
        return [hsl[0], c * 100, f * 100];
      };
      convert.hsv.hcg = function (hsv) {
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var c = s * v;
        var f = 0;
        if (c < 1.0) {
          f = (v - c) / (1 - c);
        }
        return [hsv[0], c * 100, f * 100];
      };
      convert.hcg.rgb = function (hcg) {
        var h = hcg[0] / 360;
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        if (c === 0.0) {
          return [g * 255, g * 255, g * 255];
        }
        var pure = [0, 0, 0];
        var hi = h % 1 * 6;
        var v = hi % 1;
        var w = 1 - v;
        var mg = 0;
        switch (Math.floor(hi)) {
          case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
          case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
          case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
          case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
          case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
          default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
        }
        mg = (1.0 - c) * g;
        return [(c * pure[0] + mg) * 255, (c * pure[1] + mg) * 255, (c * pure[2] + mg) * 255];
      };
      convert.hcg.hsv = function (hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var v = c + g * (1.0 - c);
        var f = 0;
        if (v > 0.0) {
          f = c / v;
        }
        return [hcg[0], f * 100, v * 100];
      };
      convert.hcg.hsl = function (hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var l = g * (1.0 - c) + 0.5 * c;
        var s = 0;
        if (l > 0.0 && l < 0.5) {
          s = c / (2 * l);
        } else if (l >= 0.5 && l < 1.0) {
          s = c / (2 * (1 - l));
        }
        return [hcg[0], s * 100, l * 100];
      };
      convert.hcg.hwb = function (hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var v = c + g * (1.0 - c);
        return [hcg[0], (v - c) * 100, (1 - v) * 100];
      };
      convert.hwb.hcg = function (hwb) {
        var w = hwb[1] / 100;
        var b = hwb[2] / 100;
        var v = 1 - b;
        var c = v - w;
        var g = 0;
        if (c < 1) {
          g = (v - c) / (1 - c);
        }
        return [hwb[0], c * 100, g * 100];
      };
      convert.apple.rgb = function (apple) {
        return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
      };
      convert.rgb.apple = function (rgb) {
        return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
      };
      convert.gray.rgb = function (args) {
        return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
      };
      convert.gray.hsl = convert.gray.hsv = function (args) {
        return [0, 0, args[0]];
      };
      convert.gray.hwb = function (gray) {
        return [0, 100, gray[0]];
      };
      convert.gray.cmyk = function (gray) {
        return [0, 0, 0, gray[0]];
      };
      convert.gray.lab = function (gray) {
        return [gray[0], 0, 0];
      };
      convert.gray.hex = function (gray) {
        var val = Math.round(gray[0] / 100 * 255) & 0xFF;
        var integer = (val << 16) + (val << 8) + val;
        var string = integer.toString(16).toUpperCase();
        return '000000'.substring(string.length) + string;
      };
      convert.rgb.gray = function (rgb) {
        var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
        return [val / 255 * 100];
      };
    });
    function buildGraph() {
      var graph = {};
      var models = Object.keys(conversions);
      for (var len = models.length, i = 0; i < len; i++) {
        graph[models[i]] = {
          distance: -1,
          parent: null
        };
      }
      return graph;
    }
    function deriveBFS(fromModel) {
      var graph = buildGraph();
      var queue = [fromModel];
      graph[fromModel].distance = 0;
      while (queue.length) {
        var current = queue.pop();
        var adjacents = Object.keys(conversions[current]);
        for (var len = adjacents.length, i = 0; i < len; i++) {
          var adjacent = adjacents[i];
          var node = graph[adjacent];
          if (node.distance === -1) {
            node.distance = graph[current].distance + 1;
            node.parent = current;
            queue.unshift(adjacent);
          }
        }
      }
      return graph;
    }
    function link(from, to) {
      return function (args) {
        return to(from(args));
      };
    }
    function wrapConversion(toModel, graph) {
      var path = [graph[toModel].parent, toModel];
      var fn = conversions[graph[toModel].parent][toModel];
      var cur = graph[toModel].parent;
      while (graph[cur].parent) {
        path.unshift(graph[cur].parent);
        fn = link(conversions[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
      }
      fn.conversion = path;
      return fn;
    }
    var route = function route(fromModel) {
      var graph = deriveBFS(fromModel);
      var conversion = {};
      var models = Object.keys(graph);
      for (var len = models.length, i = 0; i < len; i++) {
        var toModel = models[i];
        var node = graph[toModel];
        if (node.parent === null) {
          continue;
        }
        conversion[toModel] = wrapConversion(toModel, graph);
      }
      return conversion;
    };
    var convert = {};
    var models = Object.keys(conversions);
    function wrapRaw(fn) {
      var wrappedFn = function wrappedFn(args) {
        if (args === undefined || args === null) {
          return args;
        }
        if (arguments.length > 1) {
          args = Array.prototype.slice.call(arguments);
        }
        return fn(args);
      };
      if ('conversion' in fn) {
        wrappedFn.conversion = fn.conversion;
      }
      return wrappedFn;
    }
    function wrapRounded(fn) {
      var wrappedFn = function wrappedFn(args) {
        if (args === undefined || args === null) {
          return args;
        }
        if (arguments.length > 1) {
          args = Array.prototype.slice.call(arguments);
        }
        var result = fn(args);
        if (typeof result === 'object') {
          for (var len = result.length, i = 0; i < len; i++) {
            result[i] = Math.round(result[i]);
          }
        }
        return result;
      };
      if ('conversion' in fn) {
        wrappedFn.conversion = fn.conversion;
      }
      return wrappedFn;
    }
    models.forEach(function (fromModel) {
      convert[fromModel] = {};
      Object.defineProperty(convert[fromModel], 'channels', {
        value: conversions[fromModel].channels
      });
      Object.defineProperty(convert[fromModel], 'labels', {
        value: conversions[fromModel].labels
      });
      var routes = route(fromModel);
      var routeModels = Object.keys(routes);
      routeModels.forEach(function (toModel) {
        var fn = routes[toModel];
        convert[fromModel][toModel] = wrapRounded(fn);
        convert[fromModel][toModel].raw = wrapRaw(fn);
      });
    });
    var colorConvert = convert;
    var colorName$1 = {
      "aliceblue": [240, 248, 255],
      "antiquewhite": [250, 235, 215],
      "aqua": [0, 255, 255],
      "aquamarine": [127, 255, 212],
      "azure": [240, 255, 255],
      "beige": [245, 245, 220],
      "bisque": [255, 228, 196],
      "black": [0, 0, 0],
      "blanchedalmond": [255, 235, 205],
      "blue": [0, 0, 255],
      "blueviolet": [138, 43, 226],
      "brown": [165, 42, 42],
      "burlywood": [222, 184, 135],
      "cadetblue": [95, 158, 160],
      "chartreuse": [127, 255, 0],
      "chocolate": [210, 105, 30],
      "coral": [255, 127, 80],
      "cornflowerblue": [100, 149, 237],
      "cornsilk": [255, 248, 220],
      "crimson": [220, 20, 60],
      "cyan": [0, 255, 255],
      "darkblue": [0, 0, 139],
      "darkcyan": [0, 139, 139],
      "darkgoldenrod": [184, 134, 11],
      "darkgray": [169, 169, 169],
      "darkgreen": [0, 100, 0],
      "darkgrey": [169, 169, 169],
      "darkkhaki": [189, 183, 107],
      "darkmagenta": [139, 0, 139],
      "darkolivegreen": [85, 107, 47],
      "darkorange": [255, 140, 0],
      "darkorchid": [153, 50, 204],
      "darkred": [139, 0, 0],
      "darksalmon": [233, 150, 122],
      "darkseagreen": [143, 188, 143],
      "darkslateblue": [72, 61, 139],
      "darkslategray": [47, 79, 79],
      "darkslategrey": [47, 79, 79],
      "darkturquoise": [0, 206, 209],
      "darkviolet": [148, 0, 211],
      "deeppink": [255, 20, 147],
      "deepskyblue": [0, 191, 255],
      "dimgray": [105, 105, 105],
      "dimgrey": [105, 105, 105],
      "dodgerblue": [30, 144, 255],
      "firebrick": [178, 34, 34],
      "floralwhite": [255, 250, 240],
      "forestgreen": [34, 139, 34],
      "fuchsia": [255, 0, 255],
      "gainsboro": [220, 220, 220],
      "ghostwhite": [248, 248, 255],
      "gold": [255, 215, 0],
      "goldenrod": [218, 165, 32],
      "gray": [128, 128, 128],
      "green": [0, 128, 0],
      "greenyellow": [173, 255, 47],
      "grey": [128, 128, 128],
      "honeydew": [240, 255, 240],
      "hotpink": [255, 105, 180],
      "indianred": [205, 92, 92],
      "indigo": [75, 0, 130],
      "ivory": [255, 255, 240],
      "khaki": [240, 230, 140],
      "lavender": [230, 230, 250],
      "lavenderblush": [255, 240, 245],
      "lawngreen": [124, 252, 0],
      "lemonchiffon": [255, 250, 205],
      "lightblue": [173, 216, 230],
      "lightcoral": [240, 128, 128],
      "lightcyan": [224, 255, 255],
      "lightgoldenrodyellow": [250, 250, 210],
      "lightgray": [211, 211, 211],
      "lightgreen": [144, 238, 144],
      "lightgrey": [211, 211, 211],
      "lightpink": [255, 182, 193],
      "lightsalmon": [255, 160, 122],
      "lightseagreen": [32, 178, 170],
      "lightskyblue": [135, 206, 250],
      "lightslategray": [119, 136, 153],
      "lightslategrey": [119, 136, 153],
      "lightsteelblue": [176, 196, 222],
      "lightyellow": [255, 255, 224],
      "lime": [0, 255, 0],
      "limegreen": [50, 205, 50],
      "linen": [250, 240, 230],
      "magenta": [255, 0, 255],
      "maroon": [128, 0, 0],
      "mediumaquamarine": [102, 205, 170],
      "mediumblue": [0, 0, 205],
      "mediumorchid": [186, 85, 211],
      "mediumpurple": [147, 112, 219],
      "mediumseagreen": [60, 179, 113],
      "mediumslateblue": [123, 104, 238],
      "mediumspringgreen": [0, 250, 154],
      "mediumturquoise": [72, 209, 204],
      "mediumvioletred": [199, 21, 133],
      "midnightblue": [25, 25, 112],
      "mintcream": [245, 255, 250],
      "mistyrose": [255, 228, 225],
      "moccasin": [255, 228, 181],
      "navajowhite": [255, 222, 173],
      "navy": [0, 0, 128],
      "oldlace": [253, 245, 230],
      "olive": [128, 128, 0],
      "olivedrab": [107, 142, 35],
      "orange": [255, 165, 0],
      "orangered": [255, 69, 0],
      "orchid": [218, 112, 214],
      "palegoldenrod": [238, 232, 170],
      "palegreen": [152, 251, 152],
      "paleturquoise": [175, 238, 238],
      "palevioletred": [219, 112, 147],
      "papayawhip": [255, 239, 213],
      "peachpuff": [255, 218, 185],
      "peru": [205, 133, 63],
      "pink": [255, 192, 203],
      "plum": [221, 160, 221],
      "powderblue": [176, 224, 230],
      "purple": [128, 0, 128],
      "rebeccapurple": [102, 51, 153],
      "red": [255, 0, 0],
      "rosybrown": [188, 143, 143],
      "royalblue": [65, 105, 225],
      "saddlebrown": [139, 69, 19],
      "salmon": [250, 128, 114],
      "sandybrown": [244, 164, 96],
      "seagreen": [46, 139, 87],
      "seashell": [255, 245, 238],
      "sienna": [160, 82, 45],
      "silver": [192, 192, 192],
      "skyblue": [135, 206, 235],
      "slateblue": [106, 90, 205],
      "slategray": [112, 128, 144],
      "slategrey": [112, 128, 144],
      "snow": [255, 250, 250],
      "springgreen": [0, 255, 127],
      "steelblue": [70, 130, 180],
      "tan": [210, 180, 140],
      "teal": [0, 128, 128],
      "thistle": [216, 191, 216],
      "tomato": [255, 99, 71],
      "turquoise": [64, 224, 208],
      "violet": [238, 130, 238],
      "wheat": [245, 222, 179],
      "white": [255, 255, 255],
      "whitesmoke": [245, 245, 245],
      "yellow": [255, 255, 0],
      "yellowgreen": [154, 205, 50]
    };
    var colorString = {
      getRgba: getRgba,
      getHsla: getHsla,
      getRgb: getRgb,
      getHsl: getHsl,
      getHwb: getHwb,
      getAlpha: getAlpha,
      hexString: hexString,
      rgbString: rgbString,
      rgbaString: rgbaString,
      percentString: percentString,
      percentaString: percentaString,
      hslString: hslString,
      hslaString: hslaString,
      hwbString: hwbString,
      keyword: keyword
    };
    function getRgba(string) {
      if (!string) {
        return;
      }
      var abbr = /^#([a-fA-F0-9]{3,4})$/i,
        hex = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
        rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
        per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
        keyword = /(\w+)/;
      var rgb = [0, 0, 0],
        a = 1,
        match = string.match(abbr),
        hexAlpha = "";
      if (match) {
        match = match[1];
        hexAlpha = match[3];
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = parseInt(match[i] + match[i], 16);
        }
        if (hexAlpha) {
          a = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
        }
      } else if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
        }
        if (hexAlpha) {
          a = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
        }
      } else if (match = string.match(rgba)) {
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = parseInt(match[i + 1]);
        }
        a = parseFloat(match[4]);
      } else if (match = string.match(per)) {
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        }
        a = parseFloat(match[4]);
      } else if (match = string.match(keyword)) {
        if (match[1] == "transparent") {
          return [0, 0, 0, 0];
        }
        rgb = colorName$1[match[1]];
        if (!rgb) {
          return;
        }
      }
      for (var i = 0; i < rgb.length; i++) {
        rgb[i] = scale(rgb[i], 0, 255);
      }
      if (!a && a != 0) {
        a = 1;
      } else {
        a = scale(a, 0, 1);
      }
      rgb[3] = a;
      return rgb;
    }
    function getHsla(string) {
      if (!string) {
        return;
      }
      var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
      var match = string.match(hsl);
      if (match) {
        var alpha = parseFloat(match[4]);
        var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [h, s, l, a];
      }
    }
    function getHwb(string) {
      if (!string) {
        return;
      }
      var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
      var match = string.match(hwb);
      if (match) {
        var alpha = parseFloat(match[4]);
        var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [h, w, b, a];
      }
    }
    function getRgb(string) {
      var rgba = getRgba(string);
      return rgba && rgba.slice(0, 3);
    }
    function getHsl(string) {
      var hsla = getHsla(string);
      return hsla && hsla.slice(0, 3);
    }
    function getAlpha(string) {
      var vals = getRgba(string);
      if (vals) {
        return vals[3];
      } else if (vals = getHsla(string)) {
        return vals[3];
      } else if (vals = getHwb(string)) {
        return vals[3];
      }
    }
    function hexString(rgba, a) {
      var a = a !== undefined && rgba.length === 3 ? a : rgba[3];
      return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (a >= 0 && a < 1 ? hexDouble(Math.round(a * 255)) : "");
    }
    function rgbString(rgba, alpha) {
      if (alpha < 1 || rgba[3] && rgba[3] < 1) {
        return rgbaString(rgba, alpha);
      }
      return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
    }
    function rgbaString(rgba, alpha) {
      if (alpha === undefined) {
        alpha = rgba[3] !== undefined ? rgba[3] : 1;
      }
      return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
    }
    function percentString(rgba, alpha) {
      if (alpha < 1 || rgba[3] && rgba[3] < 1) {
        return percentaString(rgba, alpha);
      }
      var r = Math.round(rgba[0] / 255 * 100),
        g = Math.round(rgba[1] / 255 * 100),
        b = Math.round(rgba[2] / 255 * 100);
      return "rgb(" + r + "%, " + g + "%, " + b + "%)";
    }
    function percentaString(rgba, alpha) {
      var r = Math.round(rgba[0] / 255 * 100),
        g = Math.round(rgba[1] / 255 * 100),
        b = Math.round(rgba[2] / 255 * 100);
      return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
    }
    function hslString(hsla, alpha) {
      if (alpha < 1 || hsla[3] && hsla[3] < 1) {
        return hslaString(hsla, alpha);
      }
      return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
    }
    function hslaString(hsla, alpha) {
      if (alpha === undefined) {
        alpha = hsla[3] !== undefined ? hsla[3] : 1;
      }
      return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
    }
    function hwbString(hwb, alpha) {
      if (alpha === undefined) {
        alpha = hwb[3] !== undefined ? hwb[3] : 1;
      }
      return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
    }
    function keyword(rgb) {
      return reverseNames[rgb.slice(0, 3)];
    }
    function scale(num, min, max) {
      return Math.min(Math.max(min, num), max);
    }
    function hexDouble(num) {
      var str = num.toString(16).toUpperCase();
      return str.length < 2 ? "0" + str : str;
    }
    var reverseNames = {};
    for (var name in colorName$1) {
      reverseNames[colorName$1[name]] = name;
    }
    var Color = function Color(obj) {
      if (obj instanceof Color) {
        return obj;
      }
      if (!(this instanceof Color)) {
        return new Color(obj);
      }
      this.valid = false;
      this.values = {
        rgb: [0, 0, 0],
        hsl: [0, 0, 0],
        hsv: [0, 0, 0],
        hwb: [0, 0, 0],
        cmyk: [0, 0, 0, 0],
        alpha: 1
      };
      var vals;
      if (typeof obj === 'string') {
        vals = colorString.getRgba(obj);
        if (vals) {
          this.setValues('rgb', vals);
        } else if (vals = colorString.getHsla(obj)) {
          this.setValues('hsl', vals);
        } else if (vals = colorString.getHwb(obj)) {
          this.setValues('hwb', vals);
        }
      } else if (typeof obj === 'object') {
        vals = obj;
        if (vals.r !== undefined || vals.red !== undefined) {
          this.setValues('rgb', vals);
        } else if (vals.l !== undefined || vals.lightness !== undefined) {
          this.setValues('hsl', vals);
        } else if (vals.v !== undefined || vals.value !== undefined) {
          this.setValues('hsv', vals);
        } else if (vals.w !== undefined || vals.whiteness !== undefined) {
          this.setValues('hwb', vals);
        } else if (vals.c !== undefined || vals.cyan !== undefined) {
          this.setValues('cmyk', vals);
        }
      }
    };
    Color.prototype = {
      isValid: function isValid() {
        return this.valid;
      },
      rgb: function rgb() {
        return this.setSpace('rgb', arguments);
      },
      hsl: function hsl() {
        return this.setSpace('hsl', arguments);
      },
      hsv: function hsv() {
        return this.setSpace('hsv', arguments);
      },
      hwb: function hwb() {
        return this.setSpace('hwb', arguments);
      },
      cmyk: function cmyk() {
        return this.setSpace('cmyk', arguments);
      },
      rgbArray: function rgbArray() {
        return this.values.rgb;
      },
      hslArray: function hslArray() {
        return this.values.hsl;
      },
      hsvArray: function hsvArray() {
        return this.values.hsv;
      },
      hwbArray: function hwbArray() {
        var values = this.values;
        if (values.alpha !== 1) {
          return values.hwb.concat([values.alpha]);
        }
        return values.hwb;
      },
      cmykArray: function cmykArray() {
        return this.values.cmyk;
      },
      rgbaArray: function rgbaArray() {
        var values = this.values;
        return values.rgb.concat([values.alpha]);
      },
      hslaArray: function hslaArray() {
        var values = this.values;
        return values.hsl.concat([values.alpha]);
      },
      alpha: function alpha(val) {
        if (val === undefined) {
          return this.values.alpha;
        }
        this.setValues('alpha', val);
        return this;
      },
      red: function red(val) {
        return this.setChannel('rgb', 0, val);
      },
      green: function green(val) {
        return this.setChannel('rgb', 1, val);
      },
      blue: function blue(val) {
        return this.setChannel('rgb', 2, val);
      },
      hue: function hue(val) {
        if (val) {
          val %= 360;
          val = val < 0 ? 360 + val : val;
        }
        return this.setChannel('hsl', 0, val);
      },
      saturation: function saturation(val) {
        return this.setChannel('hsl', 1, val);
      },
      lightness: function lightness(val) {
        return this.setChannel('hsl', 2, val);
      },
      saturationv: function saturationv(val) {
        return this.setChannel('hsv', 1, val);
      },
      whiteness: function whiteness(val) {
        return this.setChannel('hwb', 1, val);
      },
      blackness: function blackness(val) {
        return this.setChannel('hwb', 2, val);
      },
      value: function value(val) {
        return this.setChannel('hsv', 2, val);
      },
      cyan: function cyan(val) {
        return this.setChannel('cmyk', 0, val);
      },
      magenta: function magenta(val) {
        return this.setChannel('cmyk', 1, val);
      },
      yellow: function yellow(val) {
        return this.setChannel('cmyk', 2, val);
      },
      black: function black(val) {
        return this.setChannel('cmyk', 3, val);
      },
      hexString: function hexString() {
        return colorString.hexString(this.values.rgb);
      },
      rgbString: function rgbString() {
        return colorString.rgbString(this.values.rgb, this.values.alpha);
      },
      rgbaString: function rgbaString() {
        return colorString.rgbaString(this.values.rgb, this.values.alpha);
      },
      percentString: function percentString() {
        return colorString.percentString(this.values.rgb, this.values.alpha);
      },
      hslString: function hslString() {
        return colorString.hslString(this.values.hsl, this.values.alpha);
      },
      hslaString: function hslaString() {
        return colorString.hslaString(this.values.hsl, this.values.alpha);
      },
      hwbString: function hwbString() {
        return colorString.hwbString(this.values.hwb, this.values.alpha);
      },
      keyword: function keyword() {
        return colorString.keyword(this.values.rgb, this.values.alpha);
      },
      rgbNumber: function rgbNumber() {
        var rgb = this.values.rgb;
        return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
      },
      luminosity: function luminosity() {
        var rgb = this.values.rgb;
        var lum = [];
        for (var i = 0; i < rgb.length; i++) {
          var chan = rgb[i] / 255;
          lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
      },
      contrast: function contrast(color2) {
        var lum1 = this.luminosity();
        var lum2 = color2.luminosity();
        if (lum1 > lum2) {
          return (lum1 + 0.05) / (lum2 + 0.05);
        }
        return (lum2 + 0.05) / (lum1 + 0.05);
      },
      level: function level(color2) {
        var contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7.1) {
          return 'AAA';
        }
        return contrastRatio >= 4.5 ? 'AA' : '';
      },
      dark: function dark() {
        var rgb = this.values.rgb;
        var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return yiq < 128;
      },
      light: function light() {
        return !this.dark();
      },
      negate: function negate() {
        var rgb = [];
        for (var i = 0; i < 3; i++) {
          rgb[i] = 255 - this.values.rgb[i];
        }
        this.setValues('rgb', rgb);
        return this;
      },
      lighten: function lighten(ratio) {
        var hsl = this.values.hsl;
        hsl[2] += hsl[2] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      darken: function darken(ratio) {
        var hsl = this.values.hsl;
        hsl[2] -= hsl[2] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      saturate: function saturate(ratio) {
        var hsl = this.values.hsl;
        hsl[1] += hsl[1] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      desaturate: function desaturate(ratio) {
        var hsl = this.values.hsl;
        hsl[1] -= hsl[1] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      whiten: function whiten(ratio) {
        var hwb = this.values.hwb;
        hwb[1] += hwb[1] * ratio;
        this.setValues('hwb', hwb);
        return this;
      },
      blacken: function blacken(ratio) {
        var hwb = this.values.hwb;
        hwb[2] += hwb[2] * ratio;
        this.setValues('hwb', hwb);
        return this;
      },
      greyscale: function greyscale() {
        var rgb = this.values.rgb;
        var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        this.setValues('rgb', [val, val, val]);
        return this;
      },
      clearer: function clearer(ratio) {
        var alpha = this.values.alpha;
        this.setValues('alpha', alpha - alpha * ratio);
        return this;
      },
      opaquer: function opaquer(ratio) {
        var alpha = this.values.alpha;
        this.setValues('alpha', alpha + alpha * ratio);
        return this;
      },
      rotate: function rotate(degrees) {
        var hsl = this.values.hsl;
        var hue = (hsl[0] + degrees) % 360;
        hsl[0] = hue < 0 ? 360 + hue : hue;
        this.setValues('hsl', hsl);
        return this;
      },
      mix: function mix(mixinColor, weight) {
        var color1 = this;
        var color2 = mixinColor;
        var p = weight === undefined ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = color1.alpha() - color2.alpha();
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
        var w2 = 1 - w1;
        return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
      },
      toJSON: function toJSON() {
        return this.rgb();
      },
      clone: function clone() {
        var result = new Color();
        var source = this.values;
        var target = result.values;
        var value, type;
        for (var prop in source) {
          if (source.hasOwnProperty(prop)) {
            value = source[prop];
            type = {}.toString.call(value);
            if (type === '[object Array]') {
              target[prop] = value.slice(0);
            } else if (type === '[object Number]') {
              target[prop] = value;
            } else {
              console.error('unexpected color value:', value);
            }
          }
        }
        return result;
      }
    };
    Color.prototype.spaces = {
      rgb: ['red', 'green', 'blue'],
      hsl: ['hue', 'saturation', 'lightness'],
      hsv: ['hue', 'saturation', 'value'],
      hwb: ['hue', 'whiteness', 'blackness'],
      cmyk: ['cyan', 'magenta', 'yellow', 'black']
    };
    Color.prototype.maxes = {
      rgb: [255, 255, 255],
      hsl: [360, 100, 100],
      hsv: [360, 100, 100],
      hwb: [360, 100, 100],
      cmyk: [100, 100, 100, 100]
    };
    Color.prototype.getValues = function (space) {
      var values = this.values;
      var vals = {};
      for (var i = 0; i < space.length; i++) {
        vals[space.charAt(i)] = values[space][i];
      }
      if (values.alpha !== 1) {
        vals.a = values.alpha;
      }
      return vals;
    };
    Color.prototype.setValues = function (space, vals) {
      var values = this.values;
      var spaces = this.spaces;
      var maxes = this.maxes;
      var alpha = 1;
      var i;
      this.valid = true;
      if (space === 'alpha') {
        alpha = vals;
      } else if (vals.length) {
        values[space] = vals.slice(0, space.length);
        alpha = vals[space.length];
      } else if (vals[space.charAt(0)] !== undefined) {
        for (i = 0; i < space.length; i++) {
          values[space][i] = vals[space.charAt(i)];
        }
        alpha = vals.a;
      } else if (vals[spaces[space][0]] !== undefined) {
        var chans = spaces[space];
        for (i = 0; i < space.length; i++) {
          values[space][i] = vals[chans[i]];
        }
        alpha = vals.alpha;
      }
      values.alpha = Math.max(0, Math.min(1, alpha === undefined ? values.alpha : alpha));
      if (space === 'alpha') {
        return false;
      }
      var capped;
      for (i = 0; i < space.length; i++) {
        capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
        values[space][i] = Math.round(capped);
      }
      for (var sname in spaces) {
        if (sname !== space) {
          values[sname] = colorConvert[space][sname](values[space]);
        }
      }
      return true;
    };
    Color.prototype.setSpace = function (space, args) {
      var vals = args[0];
      if (vals === undefined) {
        return this.getValues(space);
      }
      if (typeof vals === 'number') {
        vals = Array.prototype.slice.call(args);
      }
      this.setValues(space, vals);
      return this;
    };
    Color.prototype.setChannel = function (space, index, val) {
      var svalues = this.values[space];
      if (val === undefined) {
        return svalues[index];
      } else if (val === svalues[index]) {
        return this;
      }
      svalues[index] = val;
      this.setValues(space, svalues);
      return this;
    };
    if (typeof window !== 'undefined') {
      window.Color = Color;
    }
    var chartjsColor = Color;
    function isValidKey(key) {
      return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
    }
    var helpers = {
      noop: function noop() {},
      uid: function () {
        var id = 0;
        return function () {
          return id++;
        };
      }(),
      isNullOrUndef: function isNullOrUndef(value) {
        return value === null || typeof value === 'undefined';
      },
      isArray: function isArray(value) {
        if (Array.isArray && Array.isArray(value)) {
          return true;
        }
        var type = Object.prototype.toString.call(value);
        if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
          return true;
        }
        return false;
      },
      isObject: function isObject(value) {
        return value !== null && Object.prototype.toString.call(value) === '[object Object]';
      },
      isFinite: function (_isFinite) {
        function isFinite(_x) {
          return _isFinite.apply(this, arguments);
        }
        isFinite.toString = function () {
          return _isFinite.toString();
        };
        return isFinite;
      }(function (value) {
        return (typeof value === 'number' || value instanceof Number) && isFinite(value);
      }),
      valueOrDefault: function valueOrDefault(value, defaultValue) {
        return typeof value === 'undefined' ? defaultValue : value;
      },
      valueAtIndexOrDefault: function valueAtIndexOrDefault(value, index, defaultValue) {
        return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
      },
      callback: function callback(fn, args, thisArg) {
        if (fn && typeof fn.call === 'function') {
          return fn.apply(thisArg, args);
        }
      },
      each: function each(loopable, fn, thisArg, reverse) {
        var i, len, keys;
        if (helpers.isArray(loopable)) {
          len = loopable.length;
          if (reverse) {
            for (i = len - 1; i >= 0; i--) {
              fn.call(thisArg, loopable[i], i);
            }
          } else {
            for (i = 0; i < len; i++) {
              fn.call(thisArg, loopable[i], i);
            }
          }
        } else if (helpers.isObject(loopable)) {
          keys = Object.keys(loopable);
          len = keys.length;
          for (i = 0; i < len; i++) {
            fn.call(thisArg, loopable[keys[i]], keys[i]);
          }
        }
      },
      arrayEquals: function arrayEquals(a0, a1) {
        var i, ilen, v0, v1;
        if (!a0 || !a1 || a0.length !== a1.length) {
          return false;
        }
        for (i = 0, ilen = a0.length; i < ilen; ++i) {
          v0 = a0[i];
          v1 = a1[i];
          if (v0 instanceof Array && v1 instanceof Array) {
            if (!helpers.arrayEquals(v0, v1)) {
              return false;
            }
          } else if (v0 !== v1) {
            return false;
          }
        }
        return true;
      },
      clone: function clone(source) {
        if (helpers.isArray(source)) {
          return source.map(helpers.clone);
        }
        if (helpers.isObject(source)) {
          var target = Object.create(source);
          var keys = Object.keys(source);
          var klen = keys.length;
          var k = 0;
          for (; k < klen; ++k) {
            target[keys[k]] = helpers.clone(source[keys[k]]);
          }
          return target;
        }
        return source;
      },
      _merger: function _merger(key, target, source, options) {
        if (!isValidKey(key)) {
          return;
        }
        var tval = target[key];
        var sval = source[key];
        if (helpers.isObject(tval) && helpers.isObject(sval)) {
          helpers.merge(tval, sval, options);
        } else {
          target[key] = helpers.clone(sval);
        }
      },
      _mergerIf: function _mergerIf(key, target, source) {
        if (!isValidKey(key)) {
          return;
        }
        var tval = target[key];
        var sval = source[key];
        if (helpers.isObject(tval) && helpers.isObject(sval)) {
          helpers.mergeIf(tval, sval);
        } else if (!target.hasOwnProperty(key)) {
          target[key] = helpers.clone(sval);
        }
      },
      merge: function merge(target, source, options) {
        var sources = helpers.isArray(source) ? source : [source];
        var ilen = sources.length;
        var merge, i, keys, klen, k;
        if (!helpers.isObject(target)) {
          return target;
        }
        options = options || {};
        merge = options.merger || helpers._merger;
        for (i = 0; i < ilen; ++i) {
          source = sources[i];
          if (!helpers.isObject(source)) {
            continue;
          }
          keys = Object.keys(source);
          for (k = 0, klen = keys.length; k < klen; ++k) {
            merge(keys[k], target, source, options);
          }
        }
        return target;
      },
      mergeIf: function mergeIf(target, source) {
        return helpers.merge(target, source, {
          merger: helpers._mergerIf
        });
      },
      extend: Object.assign || function (target) {
        return helpers.merge(target, [].slice.call(arguments, 1), {
          merger: function merger(key, dst, src) {
            dst[key] = src[key];
          }
        });
      },
      inherits: function inherits(extensions) {
        var me = this;
        var ChartElement = extensions && extensions.hasOwnProperty('constructor') ? extensions.constructor : function () {
          return me.apply(this, arguments);
        };
        var Surrogate = function Surrogate() {
          this.constructor = ChartElement;
        };
        Surrogate.prototype = me.prototype;
        ChartElement.prototype = new Surrogate();
        ChartElement.extend = helpers.inherits;
        if (extensions) {
          helpers.extend(ChartElement.prototype, extensions);
        }
        ChartElement.__super__ = me.prototype;
        return ChartElement;
      },
      _deprecated: function _deprecated(scope, value, previous, current) {
        if (value !== undefined) {
          console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
        }
      }
    };
    var helpers_core = helpers;
    helpers.callCallback = helpers.callback;
    helpers.indexOf = function (array, item, fromIndex) {
      return Array.prototype.indexOf.call(array, item, fromIndex);
    };
    helpers.getValueOrDefault = helpers.valueOrDefault;
    helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
    var effects = {
      linear: function linear(t) {
        return t;
      },
      easeInQuad: function easeInQuad(t) {
        return t * t;
      },
      easeOutQuad: function easeOutQuad(t) {
        return -t * (t - 2);
      },
      easeInOutQuad: function easeInOutQuad(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t;
        }
        return -0.5 * (--t * (t - 2) - 1);
      },
      easeInCubic: function easeInCubic(t) {
        return t * t * t;
      },
      easeOutCubic: function easeOutCubic(t) {
        return (t = t - 1) * t * t + 1;
      },
      easeInOutCubic: function easeInOutCubic(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t * t;
        }
        return 0.5 * ((t -= 2) * t * t + 2);
      },
      easeInQuart: function easeInQuart(t) {
        return t * t * t * t;
      },
      easeOutQuart: function easeOutQuart(t) {
        return -((t = t - 1) * t * t * t - 1);
      },
      easeInOutQuart: function easeInOutQuart(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t * t * t;
        }
        return -0.5 * ((t -= 2) * t * t * t - 2);
      },
      easeInQuint: function easeInQuint(t) {
        return t * t * t * t * t;
      },
      easeOutQuint: function easeOutQuint(t) {
        return (t = t - 1) * t * t * t * t + 1;
      },
      easeInOutQuint: function easeInOutQuint(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t * t * t * t;
        }
        return 0.5 * ((t -= 2) * t * t * t * t + 2);
      },
      easeInSine: function easeInSine(t) {
        return -Math.cos(t * (Math.PI / 2)) + 1;
      },
      easeOutSine: function easeOutSine(t) {
        return Math.sin(t * (Math.PI / 2));
      },
      easeInOutSine: function easeInOutSine(t) {
        return -0.5 * (Math.cos(Math.PI * t) - 1);
      },
      easeInExpo: function easeInExpo(t) {
        return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
      },
      easeOutExpo: function easeOutExpo(t) {
        return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
      },
      easeInOutExpo: function easeInOutExpo(t) {
        if (t === 0) {
          return 0;
        }
        if (t === 1) {
          return 1;
        }
        if ((t /= 0.5) < 1) {
          return 0.5 * Math.pow(2, 10 * (t - 1));
        }
        return 0.5 * (-Math.pow(2, -10 * --t) + 2);
      },
      easeInCirc: function easeInCirc(t) {
        if (t >= 1) {
          return t;
        }
        return -(Math.sqrt(1 - t * t) - 1);
      },
      easeOutCirc: function easeOutCirc(t) {
        return Math.sqrt(1 - (t = t - 1) * t);
      },
      easeInOutCirc: function easeInOutCirc(t) {
        if ((t /= 0.5) < 1) {
          return -0.5 * (Math.sqrt(1 - t * t) - 1);
        }
        return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
      },
      easeInElastic: function easeInElastic(t) {
        var s = 1.70158;
        var p = 0;
        var a = 1;
        if (t === 0) {
          return 0;
        }
        if (t === 1) {
          return 1;
        }
        if (!p) {
          p = 0.3;
        }
        {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
      },
      easeOutElastic: function easeOutElastic(t) {
        var s = 1.70158;
        var p = 0;
        var a = 1;
        if (t === 0) {
          return 0;
        }
        if (t === 1) {
          return 1;
        }
        if (!p) {
          p = 0.3;
        }
        {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
      },
      easeInOutElastic: function easeInOutElastic(t) {
        var s = 1.70158;
        var p = 0;
        var a = 1;
        if (t === 0) {
          return 0;
        }
        if ((t /= 0.5) === 2) {
          return 1;
        }
        if (!p) {
          p = 0.45;
        }
        {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        if (t < 1) {
          return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
        }
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
      },
      easeInBack: function easeInBack(t) {
        var s = 1.70158;
        return t * t * ((s + 1) * t - s);
      },
      easeOutBack: function easeOutBack(t) {
        var s = 1.70158;
        return (t = t - 1) * t * ((s + 1) * t + s) + 1;
      },
      easeInOutBack: function easeInOutBack(t) {
        var s = 1.70158;
        if ((t /= 0.5) < 1) {
          return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        }
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
      },
      easeInBounce: function easeInBounce(t) {
        return 1 - effects.easeOutBounce(1 - t);
      },
      easeOutBounce: function easeOutBounce(t) {
        if (t < 1 / 2.75) {
          return 7.5625 * t * t;
        }
        if (t < 2 / 2.75) {
          return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
        }
        if (t < 2.5 / 2.75) {
          return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
        }
        return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
      },
      easeInOutBounce: function easeInOutBounce(t) {
        if (t < 0.5) {
          return effects.easeInBounce(t * 2) * 0.5;
        }
        return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
      }
    };
    var helpers_easing = {
      effects: effects
    };
    helpers_core.easingEffects = effects;
    var PI = Math.PI;
    var RAD_PER_DEG = PI / 180;
    var DOUBLE_PI = PI * 2;
    var HALF_PI = PI / 2;
    var QUARTER_PI = PI / 4;
    var TWO_THIRDS_PI = PI * 2 / 3;
    var exports$1 = {
      clear: function clear(chart) {
        chart.ctx.clearRect(0, 0, chart.width, chart.height);
      },
      roundedRect: function roundedRect(ctx, x, y, width, height, radius) {
        if (radius) {
          var r = Math.min(radius, height / 2, width / 2);
          var left = x + r;
          var top = y + r;
          var right = x + width - r;
          var bottom = y + height - r;
          ctx.moveTo(x, top);
          if (left < right && top < bottom) {
            ctx.arc(left, top, r, -PI, -HALF_PI);
            ctx.arc(right, top, r, -HALF_PI, 0);
            ctx.arc(right, bottom, r, 0, HALF_PI);
            ctx.arc(left, bottom, r, HALF_PI, PI);
          } else if (left < right) {
            ctx.moveTo(left, y);
            ctx.arc(right, top, r, -HALF_PI, HALF_PI);
            ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
          } else if (top < bottom) {
            ctx.arc(left, top, r, -PI, 0);
            ctx.arc(left, bottom, r, 0, PI);
          } else {
            ctx.arc(left, top, r, -PI, PI);
          }
          ctx.closePath();
          ctx.moveTo(x, y);
        } else {
          ctx.rect(x, y, width, height);
        }
      },
      drawPoint: function drawPoint(ctx, style, radius, x, y, rotation) {
        var type, xOffset, yOffset, size, cornerRadius;
        var rad = (rotation || 0) * RAD_PER_DEG;
        if (style && typeof style === 'object') {
          type = style.toString();
          if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
          }
        }
        if (isNaN(radius) || radius <= 0) {
          return;
        }
        ctx.beginPath();
        switch (style) {
          default:
            ctx.arc(x, y, radius, 0, DOUBLE_PI);
            ctx.closePath();
            break;
          case 'triangle':
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
          case 'rectRounded':
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + QUARTER_PI) * size;
            yOffset = Math.sin(rad + QUARTER_PI) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
            ctx.closePath();
            break;
          case 'rect':
            if (!rotation) {
              size = Math.SQRT1_2 * radius;
              ctx.rect(x - size, y - size, 2 * size, 2 * size);
              break;
            }
            rad += QUARTER_PI;
          case 'rectRot':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
          case 'crossRot':
            rad += QUARTER_PI;
          case 'cross':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
          case 'star':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += QUARTER_PI;
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
          case 'line':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
          case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
        }
        ctx.fill();
        ctx.stroke();
      },
      _isPointInArea: function _isPointInArea(point, area) {
        var epsilon = 1e-6;
        return point.x > area.left - epsilon && point.x < area.right + epsilon && point.y > area.top - epsilon && point.y < area.bottom + epsilon;
      },
      clipArea: function clipArea(ctx, area) {
        ctx.save();
        ctx.beginPath();
        ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
        ctx.clip();
      },
      unclipArea: function unclipArea(ctx) {
        ctx.restore();
      },
      lineTo: function lineTo(ctx, previous, target, flip) {
        var stepped = target.steppedLine;
        if (stepped) {
          if (stepped === 'middle') {
            var midpoint = (previous.x + target.x) / 2.0;
            ctx.lineTo(midpoint, flip ? target.y : previous.y);
            ctx.lineTo(midpoint, flip ? previous.y : target.y);
          } else if (stepped === 'after' && !flip || stepped !== 'after' && flip) {
            ctx.lineTo(previous.x, target.y);
          } else {
            ctx.lineTo(target.x, previous.y);
          }
          ctx.lineTo(target.x, target.y);
          return;
        }
        if (!target.tension) {
          ctx.lineTo(target.x, target.y);
          return;
        }
        ctx.bezierCurveTo(flip ? previous.controlPointPreviousX : previous.controlPointNextX, flip ? previous.controlPointPreviousY : previous.controlPointNextY, flip ? target.controlPointNextX : target.controlPointPreviousX, flip ? target.controlPointNextY : target.controlPointPreviousY, target.x, target.y);
      }
    };
    var helpers_canvas = exports$1;
    helpers_core.clear = exports$1.clear;
    helpers_core.drawRoundedRectangle = function (ctx) {
      ctx.beginPath();
      exports$1.roundedRect.apply(exports$1, arguments);
    };
    var defaults = {
      _set: function _set(scope, values) {
        return helpers_core.merge(this[scope] || (this[scope] = {}), values);
      }
    };
    defaults._set('global', {
      defaultColor: 'rgba(0,0,0,0.1)',
      defaultFontColor: '#666',
      defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      defaultFontSize: 12,
      defaultFontStyle: 'normal',
      defaultLineHeight: 1.2,
      showLines: true
    });
    var core_defaults = defaults;
    var valueOrDefault = helpers_core.valueOrDefault;
    function toFontString(font) {
      if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
        return null;
      }
      return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
    }
    var helpers_options = {
      toLineHeight: function toLineHeight(value, size) {
        var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
        if (!matches || matches[1] === 'normal') {
          return size * 1.2;
        }
        value = +matches[2];
        switch (matches[3]) {
          case 'px':
            return value;
          case '%':
            value /= 100;
            break;
        }
        return size * value;
      },
      toPadding: function toPadding(value) {
        var t, r, b, l;
        if (helpers_core.isObject(value)) {
          t = +value.top || 0;
          r = +value.right || 0;
          b = +value.bottom || 0;
          l = +value.left || 0;
        } else {
          t = r = b = l = +value || 0;
        }
        return {
          top: t,
          right: r,
          bottom: b,
          left: l,
          height: t + b,
          width: l + r
        };
      },
      _parseFont: function _parseFont(options) {
        var globalDefaults = core_defaults.global;
        var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
        var font = {
          family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
          lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
          size: size,
          style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
          weight: null,
          string: ''
        };
        font.string = toFontString(font);
        return font;
      },
      resolve: function resolve(inputs, context, index, info) {
        var cacheable = true;
        var i, ilen, value;
        for (i = 0, ilen = inputs.length; i < ilen; ++i) {
          value = inputs[i];
          if (value === undefined) {
            continue;
          }
          if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
          }
          if (index !== undefined && helpers_core.isArray(value)) {
            value = value[index];
            cacheable = false;
          }
          if (value !== undefined) {
            if (info && !cacheable) {
              info.cacheable = false;
            }
            return value;
          }
        }
      }
    };
    var exports$2 = {
      _factorize: function _factorize(value) {
        var result = [];
        var sqrt = Math.sqrt(value);
        var i;
        for (i = 1; i < sqrt; i++) {
          if (value % i === 0) {
            result.push(i);
            result.push(value / i);
          }
        }
        if (sqrt === (sqrt | 0)) {
          result.push(sqrt);
        }
        result.sort(function (a, b) {
          return a - b;
        }).pop();
        return result;
      },
      log10: Math.log10 || function (x) {
        var exponent = Math.log(x) * Math.LOG10E;
        var powerOf10 = Math.round(exponent);
        var isPowerOf10 = x === Math.pow(10, powerOf10);
        return isPowerOf10 ? powerOf10 : exponent;
      }
    };
    var helpers_math = exports$2;
    helpers_core.log10 = exports$2.log10;
    var getRtlAdapter = function getRtlAdapter(rectX, width) {
      return {
        x: function x(_x2) {
          return rectX + rectX + width - _x2;
        },
        setWidth: function setWidth(w) {
          width = w;
        },
        textAlign: function textAlign(align) {
          if (align === 'center') {
            return align;
          }
          return align === 'right' ? 'left' : 'right';
        },
        xPlus: function xPlus(x, value) {
          return x - value;
        },
        leftForLtr: function leftForLtr(x, itemWidth) {
          return x - itemWidth;
        }
      };
    };
    var getLtrAdapter = function getLtrAdapter() {
      return {
        x: function x(_x3) {
          return _x3;
        },
        setWidth: function setWidth(w) {},
        textAlign: function textAlign(align) {
          return align;
        },
        xPlus: function xPlus(x, value) {
          return x + value;
        },
        leftForLtr: function leftForLtr(x, _itemWidth) {
          return x;
        }
      };
    };
    var getAdapter = function getAdapter(rtl, rectX, width) {
      return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
    };
    var overrideTextDirection = function overrideTextDirection(ctx, direction) {
      var style, original;
      if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [style.getPropertyValue('direction'), style.getPropertyPriority('direction')];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
      }
    };
    var restoreTextDirection = function restoreTextDirection(ctx) {
      var original = ctx.prevTextDirection;
      if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
      }
    };
    var helpers_rtl = {
      getRtlAdapter: getAdapter,
      overrideTextDirection: overrideTextDirection,
      restoreTextDirection: restoreTextDirection
    };
    var helpers$1 = helpers_core;
    var easing = helpers_easing;
    var canvas = helpers_canvas;
    var options = helpers_options;
    var math = helpers_math;
    var rtl = helpers_rtl;
    helpers$1.easing = easing;
    helpers$1.canvas = canvas;
    helpers$1.options = options;
    helpers$1.math = math;
    helpers$1.rtl = rtl;
    function interpolate(start, view, model, ease) {
      var keys = Object.keys(model);
      var i, ilen, key, actual, origin, target, type, c0, c1;
      for (i = 0, ilen = keys.length; i < ilen; ++i) {
        key = keys[i];
        target = model[key];
        if (!view.hasOwnProperty(key)) {
          view[key] = target;
        }
        actual = view[key];
        if (actual === target || key[0] === '_') {
          continue;
        }
        if (!start.hasOwnProperty(key)) {
          start[key] = actual;
        }
        origin = start[key];
        type = typeof target;
        if (type === typeof origin) {
          if (type === 'string') {
            c0 = chartjsColor(origin);
            if (c0.valid) {
              c1 = chartjsColor(target);
              if (c1.valid) {
                view[key] = c1.mix(c0, ease).rgbString();
                continue;
              }
            }
          } else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
            view[key] = origin + (target - origin) * ease;
            continue;
          }
        }
        view[key] = target;
      }
    }
    var Element = function Element(configuration) {
      helpers$1.extend(this, configuration);
      this.initialize.apply(this, arguments);
    };
    helpers$1.extend(Element.prototype, {
      _type: undefined,
      initialize: function initialize() {
        this.hidden = false;
      },
      pivot: function pivot() {
        var me = this;
        if (!me._view) {
          me._view = helpers$1.extend({}, me._model);
        }
        me._start = {};
        return me;
      },
      transition: function transition(ease) {
        var me = this;
        var model = me._model;
        var start = me._start;
        var view = me._view;
        if (!model || ease === 1) {
          me._view = helpers$1.extend({}, model);
          me._start = null;
          return me;
        }
        if (!view) {
          view = me._view = {};
        }
        if (!start) {
          start = me._start = {};
        }
        interpolate(start, view, model, ease);
        return me;
      },
      tooltipPosition: function tooltipPosition() {
        return {
          x: this._model.x,
          y: this._model.y
        };
      },
      hasValue: function hasValue() {
        return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
      }
    });
    Element.extend = helpers$1.inherits;
    var core_element = Element;
    var exports$3 = core_element.extend({
      chart: null,
      currentStep: 0,
      numSteps: 60,
      easing: '',
      render: null,
      onAnimationProgress: null,
      onAnimationComplete: null
    });
    var core_animation = exports$3;
    Object.defineProperty(exports$3.prototype, 'animationObject', {
      get: function get() {
        return this;
      }
    });
    Object.defineProperty(exports$3.prototype, 'chartInstance', {
      get: function get() {
        return this.chart;
      },
      set: function set(value) {
        this.chart = value;
      }
    });
    core_defaults._set('global', {
      animation: {
        duration: 1000,
        easing: 'easeOutQuart',
        onProgress: helpers$1.noop,
        onComplete: helpers$1.noop
      }
    });
    var core_animations = {
      animations: [],
      request: null,
      addAnimation: function addAnimation(chart, animation, duration, lazy) {
        var animations = this.animations;
        var i, ilen;
        animation.chart = chart;
        animation.startTime = Date.now();
        animation.duration = duration;
        if (!lazy) {
          chart.animating = true;
        }
        for (i = 0, ilen = animations.length; i < ilen; ++i) {
          if (animations[i].chart === chart) {
            animations[i] = animation;
            return;
          }
        }
        animations.push(animation);
        if (animations.length === 1) {
          this.requestAnimationFrame();
        }
      },
      cancelAnimation: function cancelAnimation(chart) {
        var index = helpers$1.findIndex(this.animations, function (animation) {
          return animation.chart === chart;
        });
        if (index !== -1) {
          this.animations.splice(index, 1);
          chart.animating = false;
        }
      },
      requestAnimationFrame: function requestAnimationFrame() {
        var me = this;
        if (me.request === null) {
          me.request = helpers$1.requestAnimFrame.call(window, function () {
            me.request = null;
            me.startDigest();
          });
        }
      },
      startDigest: function startDigest() {
        var me = this;
        me.advance();
        if (me.animations.length > 0) {
          me.requestAnimationFrame();
        }
      },
      advance: function advance() {
        var animations = this.animations;
        var animation, chart, numSteps, nextStep;
        var i = 0;
        while (i < animations.length) {
          animation = animations[i];
          chart = animation.chart;
          numSteps = animation.numSteps;
          nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
          animation.currentStep = Math.min(nextStep, numSteps);
          helpers$1.callback(animation.render, [chart, animation], chart);
          helpers$1.callback(animation.onAnimationProgress, [animation], chart);
          if (animation.currentStep >= numSteps) {
            helpers$1.callback(animation.onAnimationComplete, [animation], chart);
            chart.animating = false;
            animations.splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    };
    var resolve = helpers$1.options.resolve;
    var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
    function listenArrayEvents(array, listener) {
      if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
      }
      Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
          listeners: [listener]
        }
      });
      arrayEvents.forEach(function (key) {
        var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
        var base = array[key];
        Object.defineProperty(array, key, {
          configurable: true,
          enumerable: false,
          value: function value() {
            var args = Array.prototype.slice.call(arguments);
            var res = base.apply(this, args);
            helpers$1.each(array._chartjs.listeners, function (object) {
              if (typeof object[method] === 'function') {
                object[method].apply(object, args);
              }
            });
            return res;
          }
        });
      });
    }
    function unlistenArrayEvents(array, listener) {
      var stub = array._chartjs;
      if (!stub) {
        return;
      }
      var listeners = stub.listeners;
      var index = listeners.indexOf(listener);
      if (index !== -1) {
        listeners.splice(index, 1);
      }
      if (listeners.length > 0) {
        return;
      }
      arrayEvents.forEach(function (key) {
        delete array[key];
      });
      delete array._chartjs;
    }
    var DatasetController = function DatasetController(chart, datasetIndex) {
      this.initialize(chart, datasetIndex);
    };
    helpers$1.extend(DatasetController.prototype, {
      datasetElementType: null,
      dataElementType: null,
      _datasetElementOptions: ['backgroundColor', 'borderCapStyle', 'borderColor', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'borderWidth'],
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'pointStyle'],
      initialize: function initialize(chart, datasetIndex) {
        var me = this;
        me.chart = chart;
        me.index = datasetIndex;
        me.linkScales();
        me.addElements();
        me._type = me.getMeta().type;
      },
      updateIndex: function updateIndex(datasetIndex) {
        this.index = datasetIndex;
      },
      linkScales: function linkScales() {
        var me = this;
        var meta = me.getMeta();
        var chart = me.chart;
        var scales = chart.scales;
        var dataset = me.getDataset();
        var scalesOpts = chart.options.scales;
        if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
          meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
        }
        if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
          meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
        }
      },
      getDataset: function getDataset() {
        return this.chart.data.datasets[this.index];
      },
      getMeta: function getMeta() {
        return this.chart.getDatasetMeta(this.index);
      },
      getScaleForId: function getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
      },
      _getValueScaleId: function _getValueScaleId() {
        return this.getMeta().yAxisID;
      },
      _getIndexScaleId: function _getIndexScaleId() {
        return this.getMeta().xAxisID;
      },
      _getValueScale: function _getValueScale() {
        return this.getScaleForId(this._getValueScaleId());
      },
      _getIndexScale: function _getIndexScale() {
        return this.getScaleForId(this._getIndexScaleId());
      },
      reset: function reset() {
        this._update(true);
      },
      destroy: function destroy() {
        if (this._data) {
          unlistenArrayEvents(this._data, this);
        }
      },
      createMetaDataset: function createMetaDataset() {
        var me = this;
        var type = me.datasetElementType;
        return type && new type({
          _chart: me.chart,
          _datasetIndex: me.index
        });
      },
      createMetaData: function createMetaData(index) {
        var me = this;
        var type = me.dataElementType;
        return type && new type({
          _chart: me.chart,
          _datasetIndex: me.index,
          _index: index
        });
      },
      addElements: function addElements() {
        var me = this;
        var meta = me.getMeta();
        var data = me.getDataset().data || [];
        var metaData = meta.data;
        var i, ilen;
        for (i = 0, ilen = data.length; i < ilen; ++i) {
          metaData[i] = metaData[i] || me.createMetaData(i);
        }
        meta.dataset = meta.dataset || me.createMetaDataset();
      },
      addElementAndReset: function addElementAndReset(index) {
        var element = this.createMetaData(index);
        this.getMeta().data.splice(index, 0, element);
        this.updateElement(element, index, true);
      },
      buildOrUpdateElements: function buildOrUpdateElements() {
        var me = this;
        var dataset = me.getDataset();
        var data = dataset.data || (dataset.data = []);
        if (me._data !== data) {
          if (me._data) {
            unlistenArrayEvents(me._data, me);
          }
          if (data && Object.isExtensible(data)) {
            listenArrayEvents(data, me);
          }
          me._data = data;
        }
        me.resyncElements();
      },
      _configure: function _configure() {
        var me = this;
        me._config = helpers$1.merge(Object.create(null), [me.chart.options.datasets[me._type], me.getDataset()], {
          merger: function merger(key, target, source) {
            if (key !== '_meta' && key !== 'data') {
              helpers$1._merger(key, target, source);
            }
          }
        });
      },
      _update: function _update(reset) {
        var me = this;
        me._configure();
        me._cachedDataOpts = null;
        me.update(reset);
      },
      update: helpers$1.noop,
      transition: function transition(easingValue) {
        var meta = this.getMeta();
        var elements = meta.data || [];
        var ilen = elements.length;
        var i = 0;
        for (; i < ilen; ++i) {
          elements[i].transition(easingValue);
        }
        if (meta.dataset) {
          meta.dataset.transition(easingValue);
        }
      },
      draw: function draw() {
        var meta = this.getMeta();
        var elements = meta.data || [];
        var ilen = elements.length;
        var i = 0;
        if (meta.dataset) {
          meta.dataset.draw();
        }
        for (; i < ilen; ++i) {
          elements[i].draw();
        }
      },
      getStyle: function getStyle(index) {
        var me = this;
        var meta = me.getMeta();
        var dataset = meta.dataset;
        var style;
        me._configure();
        if (dataset && index === undefined) {
          style = me._resolveDatasetElementOptions(dataset || {});
        } else {
          index = index || 0;
          style = me._resolveDataElementOptions(meta.data[index] || {}, index);
        }
        if (style.fill === false || style.fill === null) {
          style.backgroundColor = style.borderColor;
        }
        return style;
      },
      _resolveDatasetElementOptions: function _resolveDatasetElementOptions(element, hover) {
        var me = this;
        var chart = me.chart;
        var datasetOpts = me._config;
        var custom = element.custom || {};
        var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
        var elementOptions = me._datasetElementOptions;
        var values = {};
        var i, ilen, key, readKey;
        var context = {
          chart: chart,
          dataset: me.getDataset(),
          datasetIndex: me.index,
          hover: hover
        };
        for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
          key = elementOptions[i];
          readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
          values[key] = resolve([custom[readKey], datasetOpts[readKey], options[readKey]], context);
        }
        return values;
      },
      _resolveDataElementOptions: function _resolveDataElementOptions(element, index) {
        var me = this;
        var custom = element && element.custom;
        var cached = me._cachedDataOpts;
        if (cached && !custom) {
          return cached;
        }
        var chart = me.chart;
        var datasetOpts = me._config;
        var options = chart.options.elements[me.dataElementType.prototype._type] || {};
        var elementOptions = me._dataElementOptions;
        var values = {};
        var context = {
          chart: chart,
          dataIndex: index,
          dataset: me.getDataset(),
          datasetIndex: me.index
        };
        var info = {
          cacheable: !custom
        };
        var keys, i, ilen, key;
        custom = custom || {};
        if (helpers$1.isArray(elementOptions)) {
          for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
            key = elementOptions[i];
            values[key] = resolve([custom[key], datasetOpts[key], options[key]], context, index, info);
          }
        } else {
          keys = Object.keys(elementOptions);
          for (i = 0, ilen = keys.length; i < ilen; ++i) {
            key = keys[i];
            values[key] = resolve([custom[key], datasetOpts[elementOptions[key]], datasetOpts[key], options[key]], context, index, info);
          }
        }
        if (info.cacheable) {
          me._cachedDataOpts = Object.freeze(values);
        }
        return values;
      },
      removeHoverStyle: function removeHoverStyle(element) {
        helpers$1.merge(element._model, element.$previousStyle || {});
        delete element.$previousStyle;
      },
      setHoverStyle: function setHoverStyle(element) {
        var dataset = this.chart.data.datasets[element._datasetIndex];
        var index = element._index;
        var custom = element.custom || {};
        var model = element._model;
        var getHoverColor = helpers$1.getHoverColor;
        element.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth
        };
        model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
        model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
        model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
      },
      _removeDatasetHoverStyle: function _removeDatasetHoverStyle() {
        var element = this.getMeta().dataset;
        if (element) {
          this.removeHoverStyle(element);
        }
      },
      _setDatasetHoverStyle: function _setDatasetHoverStyle() {
        var element = this.getMeta().dataset;
        var prev = {};
        var i, ilen, key, keys, hoverOptions, model;
        if (!element) {
          return;
        }
        model = element._model;
        hoverOptions = this._resolveDatasetElementOptions(element, true);
        keys = Object.keys(hoverOptions);
        for (i = 0, ilen = keys.length; i < ilen; ++i) {
          key = keys[i];
          prev[key] = model[key];
          model[key] = hoverOptions[key];
        }
        element.$previousStyle = prev;
      },
      resyncElements: function resyncElements() {
        var me = this;
        var meta = me.getMeta();
        var data = me.getDataset().data;
        var numMeta = meta.data.length;
        var numData = data.length;
        if (numData < numMeta) {
          meta.data.splice(numData, numMeta - numData);
        } else if (numData > numMeta) {
          me.insertElements(numMeta, numData - numMeta);
        }
      },
      insertElements: function insertElements(start, count) {
        for (var i = 0; i < count; ++i) {
          this.addElementAndReset(start + i);
        }
      },
      onDataPush: function onDataPush() {
        var count = arguments.length;
        this.insertElements(this.getDataset().data.length - count, count);
      },
      onDataPop: function onDataPop() {
        this.getMeta().data.pop();
      },
      onDataShift: function onDataShift() {
        this.getMeta().data.shift();
      },
      onDataSplice: function onDataSplice(start, count) {
        this.getMeta().data.splice(start, count);
        this.insertElements(start, arguments.length - 2);
      },
      onDataUnshift: function onDataUnshift() {
        this.insertElements(0, arguments.length);
      }
    });
    DatasetController.extend = helpers$1.inherits;
    var core_datasetController = DatasetController;
    var TAU = Math.PI * 2;
    core_defaults._set('global', {
      elements: {
        arc: {
          backgroundColor: core_defaults.global.defaultColor,
          borderColor: '#fff',
          borderWidth: 2,
          borderAlign: 'center'
        }
      }
    });
    function clipArc(ctx, arc) {
      var startAngle = arc.startAngle;
      var endAngle = arc.endAngle;
      var pixelMargin = arc.pixelMargin;
      var angleMargin = pixelMargin / arc.outerRadius;
      var x = arc.x;
      var y = arc.y;
      ctx.beginPath();
      ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
      if (arc.innerRadius > pixelMargin) {
        angleMargin = pixelMargin / arc.innerRadius;
        ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
      } else {
        ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
      }
      ctx.closePath();
      ctx.clip();
    }
    function drawFullCircleBorders(ctx, vm, arc, inner) {
      var endAngle = arc.endAngle;
      var i;
      if (inner) {
        arc.endAngle = arc.startAngle + TAU;
        clipArc(ctx, arc);
        arc.endAngle = endAngle;
        if (arc.endAngle === arc.startAngle && arc.fullCircles) {
          arc.endAngle += TAU;
          arc.fullCircles--;
        }
      }
      ctx.beginPath();
      ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
      for (i = 0; i < arc.fullCircles; ++i) {
        ctx.stroke();
      }
      ctx.beginPath();
      ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
      for (i = 0; i < arc.fullCircles; ++i) {
        ctx.stroke();
      }
    }
    function drawBorder(ctx, vm, arc) {
      var inner = vm.borderAlign === 'inner';
      if (inner) {
        ctx.lineWidth = vm.borderWidth * 2;
        ctx.lineJoin = 'round';
      } else {
        ctx.lineWidth = vm.borderWidth;
        ctx.lineJoin = 'bevel';
      }
      if (arc.fullCircles) {
        drawFullCircleBorders(ctx, vm, arc, inner);
      }
      if (inner) {
        clipArc(ctx, arc);
      }
      ctx.beginPath();
      ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
      ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
      ctx.closePath();
      ctx.stroke();
    }
    var element_arc = core_element.extend({
      _type: 'arc',
      inLabelRange: function inLabelRange(mouseX) {
        var vm = this._view;
        if (vm) {
          return Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2);
        }
        return false;
      },
      inRange: function inRange(chartX, chartY) {
        var vm = this._view;
        if (vm) {
          var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {
            x: chartX,
            y: chartY
          });
          var angle = pointRelativePosition.angle;
          var distance = pointRelativePosition.distance;
          var startAngle = vm.startAngle;
          var endAngle = vm.endAngle;
          while (endAngle < startAngle) {
            endAngle += TAU;
          }
          while (angle > endAngle) {
            angle -= TAU;
          }
          while (angle < startAngle) {
            angle += TAU;
          }
          var betweenAngles = angle >= startAngle && angle <= endAngle;
          var withinRadius = distance >= vm.innerRadius && distance <= vm.outerRadius;
          return betweenAngles && withinRadius;
        }
        return false;
      },
      getCenterPoint: function getCenterPoint() {
        var vm = this._view;
        var halfAngle = (vm.startAngle + vm.endAngle) / 2;
        var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
        return {
          x: vm.x + Math.cos(halfAngle) * halfRadius,
          y: vm.y + Math.sin(halfAngle) * halfRadius
        };
      },
      getArea: function getArea() {
        var vm = this._view;
        return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
      },
      tooltipPosition: function tooltipPosition() {
        var vm = this._view;
        var centreAngle = vm.startAngle + (vm.endAngle - vm.startAngle) / 2;
        var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
        return {
          x: vm.x + Math.cos(centreAngle) * rangeFromCentre,
          y: vm.y + Math.sin(centreAngle) * rangeFromCentre
        };
      },
      draw: function draw() {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var pixelMargin = vm.borderAlign === 'inner' ? 0.33 : 0;
        var arc = {
          x: vm.x,
          y: vm.y,
          innerRadius: vm.innerRadius,
          outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
          pixelMargin: pixelMargin,
          startAngle: vm.startAngle,
          endAngle: vm.endAngle,
          fullCircles: Math.floor(vm.circumference / TAU)
        };
        var i;
        ctx.save();
        ctx.fillStyle = vm.backgroundColor;
        ctx.strokeStyle = vm.borderColor;
        if (arc.fullCircles) {
          arc.endAngle = arc.startAngle + TAU;
          ctx.beginPath();
          ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
          ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
          ctx.closePath();
          for (i = 0; i < arc.fullCircles; ++i) {
            ctx.fill();
          }
          arc.endAngle = arc.startAngle + vm.circumference % TAU;
        }
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
        ctx.closePath();
        ctx.fill();
        if (vm.borderWidth) {
          drawBorder(ctx, vm, arc);
        }
        ctx.restore();
      }
    });
    var valueOrDefault$1 = helpers$1.valueOrDefault;
    var defaultColor = core_defaults.global.defaultColor;
    core_defaults._set('global', {
      elements: {
        line: {
          tension: 0.4,
          backgroundColor: defaultColor,
          borderWidth: 3,
          borderColor: defaultColor,
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          capBezierPoints: true,
          fill: true
        }
      }
    });
    var element_line = core_element.extend({
      _type: 'line',
      draw: function draw() {
        var me = this;
        var vm = me._view;
        var ctx = me._chart.ctx;
        var spanGaps = vm.spanGaps;
        var points = me._children.slice();
        var globalDefaults = core_defaults.global;
        var globalOptionLineElements = globalDefaults.elements.line;
        var lastDrawnIndex = -1;
        var closePath = me._loop;
        var index, previous, currentVM;
        if (!points.length) {
          return;
        }
        if (me._loop) {
          for (index = 0; index < points.length; ++index) {
            previous = helpers$1.previousItem(points, index);
            if (!points[index]._view.skip && previous._view.skip) {
              points = points.slice(index).concat(points.slice(0, index));
              closePath = spanGaps;
              break;
            }
          }
          if (closePath) {
            points.push(points[0]);
          }
        }
        ctx.save();
        ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
        if (ctx.setLineDash) {
          ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
        }
        ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
        ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
        ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
        ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
        ctx.beginPath();
        currentVM = points[0]._view;
        if (!currentVM.skip) {
          ctx.moveTo(currentVM.x, currentVM.y);
          lastDrawnIndex = 0;
        }
        for (index = 1; index < points.length; ++index) {
          currentVM = points[index]._view;
          previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
          if (!currentVM.skip) {
            if (lastDrawnIndex !== index - 1 && !spanGaps || lastDrawnIndex === -1) {
              ctx.moveTo(currentVM.x, currentVM.y);
            } else {
              helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
            }
            lastDrawnIndex = index;
          }
        }
        if (closePath) {
          ctx.closePath();
        }
        ctx.stroke();
        ctx.restore();
      }
    });
    var valueOrDefault$2 = helpers$1.valueOrDefault;
    var defaultColor$1 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
      elements: {
        point: {
          radius: 3,
          pointStyle: 'circle',
          backgroundColor: defaultColor$1,
          borderColor: defaultColor$1,
          borderWidth: 1,
          hitRadius: 1,
          hoverRadius: 4,
          hoverBorderWidth: 1
        }
      }
    });
    function xRange(mouseX) {
      var vm = this._view;
      return vm ? Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius : false;
    }
    function yRange(mouseY) {
      var vm = this._view;
      return vm ? Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius : false;
    }
    var element_point = core_element.extend({
      _type: 'point',
      inRange: function inRange(mouseX, mouseY) {
        var vm = this._view;
        return vm ? Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2) < Math.pow(vm.hitRadius + vm.radius, 2) : false;
      },
      inLabelRange: xRange,
      inXRange: xRange,
      inYRange: yRange,
      getCenterPoint: function getCenterPoint() {
        var vm = this._view;
        return {
          x: vm.x,
          y: vm.y
        };
      },
      getArea: function getArea() {
        return Math.PI * Math.pow(this._view.radius, 2);
      },
      tooltipPosition: function tooltipPosition() {
        var vm = this._view;
        return {
          x: vm.x,
          y: vm.y,
          padding: vm.radius + vm.borderWidth
        };
      },
      draw: function draw(chartArea) {
        var vm = this._view;
        var ctx = this._chart.ctx;
        var pointStyle = vm.pointStyle;
        var rotation = vm.rotation;
        var radius = vm.radius;
        var x = vm.x;
        var y = vm.y;
        var globalDefaults = core_defaults.global;
        var defaultColor = globalDefaults.defaultColor;
        if (vm.skip) {
          return;
        }
        if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
          ctx.strokeStyle = vm.borderColor || defaultColor;
          ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
          ctx.fillStyle = vm.backgroundColor || defaultColor;
          helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
        }
      }
    });
    var defaultColor$2 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
      elements: {
        rectangle: {
          backgroundColor: defaultColor$2,
          borderColor: defaultColor$2,
          borderSkipped: 'bottom',
          borderWidth: 0
        }
      }
    });
    function isVertical(vm) {
      return vm && vm.width !== undefined;
    }
    function getBarBounds(vm) {
      var x1, x2, y1, y2, half;
      if (isVertical(vm)) {
        half = vm.width / 2;
        x1 = vm.x - half;
        x2 = vm.x + half;
        y1 = Math.min(vm.y, vm.base);
        y2 = Math.max(vm.y, vm.base);
      } else {
        half = vm.height / 2;
        x1 = Math.min(vm.x, vm.base);
        x2 = Math.max(vm.x, vm.base);
        y1 = vm.y - half;
        y2 = vm.y + half;
      }
      return {
        left: x1,
        top: y1,
        right: x2,
        bottom: y2
      };
    }
    function swap(orig, v1, v2) {
      return orig === v1 ? v2 : orig === v2 ? v1 : orig;
    }
    function parseBorderSkipped(vm) {
      var edge = vm.borderSkipped;
      var res = {};
      if (!edge) {
        return res;
      }
      if (vm.horizontal) {
        if (vm.base > vm.x) {
          edge = swap(edge, 'left', 'right');
        }
      } else if (vm.base < vm.y) {
        edge = swap(edge, 'bottom', 'top');
      }
      res[edge] = true;
      return res;
    }
    function parseBorderWidth(vm, maxW, maxH) {
      var value = vm.borderWidth;
      var skip = parseBorderSkipped(vm);
      var t, r, b, l;
      if (helpers$1.isObject(value)) {
        t = +value.top || 0;
        r = +value.right || 0;
        b = +value.bottom || 0;
        l = +value.left || 0;
      } else {
        t = r = b = l = +value || 0;
      }
      return {
        t: skip.top || t < 0 ? 0 : t > maxH ? maxH : t,
        r: skip.right || r < 0 ? 0 : r > maxW ? maxW : r,
        b: skip.bottom || b < 0 ? 0 : b > maxH ? maxH : b,
        l: skip.left || l < 0 ? 0 : l > maxW ? maxW : l
      };
    }
    function boundingRects(vm) {
      var bounds = getBarBounds(vm);
      var width = bounds.right - bounds.left;
      var height = bounds.bottom - bounds.top;
      var border = parseBorderWidth(vm, width / 2, height / 2);
      return {
        outer: {
          x: bounds.left,
          y: bounds.top,
          w: width,
          h: height
        },
        inner: {
          x: bounds.left + border.l,
          y: bounds.top + border.t,
          w: width - border.l - border.r,
          h: height - border.t - border.b
        }
      };
    }
    function _inRange(vm, x, y) {
      var skipX = x === null;
      var skipY = y === null;
      var bounds = !vm || skipX && skipY ? false : getBarBounds(vm);
      return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
    }
    var element_rectangle = core_element.extend({
      _type: 'rectangle',
      draw: function draw() {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var rects = boundingRects(vm);
        var outer = rects.outer;
        var inner = rects.inner;
        ctx.fillStyle = vm.backgroundColor;
        ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
        if (outer.w === inner.w && outer.h === inner.h) {
          return;
        }
        ctx.save();
        ctx.beginPath();
        ctx.rect(outer.x, outer.y, outer.w, outer.h);
        ctx.clip();
        ctx.fillStyle = vm.borderColor;
        ctx.rect(inner.x, inner.y, inner.w, inner.h);
        ctx.fill('evenodd');
        ctx.restore();
      },
      height: function height() {
        var vm = this._view;
        return vm.base - vm.y;
      },
      inRange: function inRange(mouseX, mouseY) {
        return _inRange(this._view, mouseX, mouseY);
      },
      inLabelRange: function inLabelRange(mouseX, mouseY) {
        var vm = this._view;
        return isVertical(vm) ? _inRange(vm, mouseX, null) : _inRange(vm, null, mouseY);
      },
      inXRange: function inXRange(mouseX) {
        return _inRange(this._view, mouseX, null);
      },
      inYRange: function inYRange(mouseY) {
        return _inRange(this._view, null, mouseY);
      },
      getCenterPoint: function getCenterPoint() {
        var vm = this._view;
        var x, y;
        if (isVertical(vm)) {
          x = vm.x;
          y = (vm.y + vm.base) / 2;
        } else {
          x = (vm.x + vm.base) / 2;
          y = vm.y;
        }
        return {
          x: x,
          y: y
        };
      },
      getArea: function getArea() {
        var vm = this._view;
        return isVertical(vm) ? vm.width * Math.abs(vm.y - vm.base) : vm.height * Math.abs(vm.x - vm.base);
      },
      tooltipPosition: function tooltipPosition() {
        var vm = this._view;
        return {
          x: vm.x,
          y: vm.y
        };
      }
    });
    var elements = {};
    var Arc = element_arc;
    var Line = element_line;
    var Point = element_point;
    var Rectangle = element_rectangle;
    elements.Arc = Arc;
    elements.Line = Line;
    elements.Point = Point;
    elements.Rectangle = Rectangle;
    var deprecated = helpers$1._deprecated;
    var valueOrDefault$3 = helpers$1.valueOrDefault;
    core_defaults._set('bar', {
      hover: {
        mode: 'label'
      },
      scales: {
        xAxes: [{
          type: 'category',
          offset: true,
          gridLines: {
            offsetGridLines: true
          }
        }],
        yAxes: [{
          type: 'linear'
        }]
      }
    });
    core_defaults._set('global', {
      datasets: {
        bar: {
          categoryPercentage: 0.8,
          barPercentage: 0.9
        }
      }
    });
    function computeMinSampleSize(scale, pixels) {
      var min = scale._length;
      var prev, curr, i, ilen;
      for (i = 1, ilen = pixels.length; i < ilen; ++i) {
        min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
      }
      for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
        curr = scale.getPixelForTick(i);
        min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
        prev = curr;
      }
      return min;
    }
    function computeFitCategoryTraits(index, ruler, options) {
      var thickness = options.barThickness;
      var count = ruler.stackCount;
      var curr = ruler.pixels[index];
      var min = helpers$1.isNullOrUndef(thickness) ? computeMinSampleSize(ruler.scale, ruler.pixels) : -1;
      var size, ratio;
      if (helpers$1.isNullOrUndef(thickness)) {
        size = min * options.categoryPercentage;
        ratio = options.barPercentage;
      } else {
        size = thickness * count;
        ratio = 1;
      }
      return {
        chunk: size / count,
        ratio: ratio,
        start: curr - size / 2
      };
    }
    function computeFlexCategoryTraits(index, ruler, options) {
      var pixels = ruler.pixels;
      var curr = pixels[index];
      var prev = index > 0 ? pixels[index - 1] : null;
      var next = index < pixels.length - 1 ? pixels[index + 1] : null;
      var percent = options.categoryPercentage;
      var start, size;
      if (prev === null) {
        prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
      }
      if (next === null) {
        next = curr + curr - prev;
      }
      start = curr - (curr - Math.min(prev, next)) / 2 * percent;
      size = Math.abs(next - prev) / 2 * percent;
      return {
        chunk: size / ruler.stackCount,
        ratio: options.barPercentage,
        start: start
      };
    }
    var controller_bar = core_datasetController.extend({
      dataElementType: elements.Rectangle,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderSkipped', 'borderWidth', 'barPercentage', 'barThickness', 'categoryPercentage', 'maxBarThickness', 'minBarLength'],
      initialize: function initialize() {
        var me = this;
        var meta, scaleOpts;
        core_datasetController.prototype.initialize.apply(me, arguments);
        meta = me.getMeta();
        meta.stack = me.getDataset().stack;
        meta.bar = true;
        scaleOpts = me._getIndexScale().options;
        deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
        deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
        deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
        deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
        deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
      },
      update: function update(reset) {
        var me = this;
        var rects = me.getMeta().data;
        var i, ilen;
        me._ruler = me.getRuler();
        for (i = 0, ilen = rects.length; i < ilen; ++i) {
          me.updateElement(rects[i], i, reset);
        }
      },
      updateElement: function updateElement(rectangle, index, reset) {
        var me = this;
        var meta = me.getMeta();
        var dataset = me.getDataset();
        var options = me._resolveDataElementOptions(rectangle, index);
        rectangle._xScale = me.getScaleForId(meta.xAxisID);
        rectangle._yScale = me.getScaleForId(meta.yAxisID);
        rectangle._datasetIndex = me.index;
        rectangle._index = index;
        rectangle._model = {
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderSkipped: options.borderSkipped,
          borderWidth: options.borderWidth,
          datasetLabel: dataset.label,
          label: me.chart.data.labels[index]
        };
        if (helpers$1.isArray(dataset.data[index])) {
          rectangle._model.borderSkipped = null;
        }
        me._updateElementGeometry(rectangle, index, reset, options);
        rectangle.pivot();
      },
      _updateElementGeometry: function _updateElementGeometry(rectangle, index, reset, options) {
        var me = this;
        var model = rectangle._model;
        var vscale = me._getValueScale();
        var base = vscale.getBasePixel();
        var horizontal = vscale.isHorizontal();
        var ruler = me._ruler || me.getRuler();
        var vpixels = me.calculateBarValuePixels(me.index, index, options);
        var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
        model.horizontal = horizontal;
        model.base = reset ? base : vpixels.base;
        model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
        model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
        model.height = horizontal ? ipixels.size : undefined;
        model.width = horizontal ? undefined : ipixels.size;
      },
      _getStacks: function _getStacks(last) {
        var me = this;
        var scale = me._getIndexScale();
        var metasets = scale._getMatchingVisibleMetas(me._type);
        var stacked = scale.options.stacked;
        var ilen = metasets.length;
        var stacks = [];
        var i, meta;
        for (i = 0; i < ilen; ++i) {
          meta = metasets[i];
          if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) {
            stacks.push(meta.stack);
          }
          if (meta.index === last) {
            break;
          }
        }
        return stacks;
      },
      getStackCount: function getStackCount() {
        return this._getStacks().length;
      },
      getStackIndex: function getStackIndex(datasetIndex, name) {
        var stacks = this._getStacks(datasetIndex);
        var index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
      },
      getRuler: function getRuler() {
        var me = this;
        var scale = me._getIndexScale();
        var pixels = [];
        var i, ilen;
        for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
          pixels.push(scale.getPixelForValue(null, i, me.index));
        }
        return {
          pixels: pixels,
          start: scale._startPixel,
          end: scale._endPixel,
          stackCount: me.getStackCount(),
          scale: scale
        };
      },
      calculateBarValuePixels: function calculateBarValuePixels(datasetIndex, index, options) {
        var me = this;
        var chart = me.chart;
        var scale = me._getValueScale();
        var isHorizontal = scale.isHorizontal();
        var datasets = chart.data.datasets;
        var metasets = scale._getMatchingVisibleMetas(me._type);
        var value = scale._parseValue(datasets[datasetIndex].data[index]);
        var minBarLength = options.minBarLength;
        var stacked = scale.options.stacked;
        var stack = me.getMeta().stack;
        var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
        var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
        var ilen = metasets.length;
        var i, imeta, ivalue, base, head, size, stackLength;
        if (stacked || stacked === undefined && stack !== undefined) {
          for (i = 0; i < ilen; ++i) {
            imeta = metasets[i];
            if (imeta.index === datasetIndex) {
              break;
            }
            if (imeta.stack === stack) {
              stackLength = scale._parseValue(datasets[imeta.index].data[index]);
              ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
              if (value.min < 0 && ivalue < 0 || value.max >= 0 && ivalue > 0) {
                start += ivalue;
              }
            }
          }
        }
        base = scale.getPixelForValue(start);
        head = scale.getPixelForValue(start + length);
        size = head - base;
        if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
          size = minBarLength;
          if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
            head = base - minBarLength;
          } else {
            head = base + minBarLength;
          }
        }
        return {
          size: size,
          base: base,
          head: head,
          center: head + size / 2
        };
      },
      calculateBarIndexPixels: function calculateBarIndexPixels(datasetIndex, index, ruler, options) {
        var me = this;
        var range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options) : computeFitCategoryTraits(index, ruler, options);
        var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
        var center = range.start + range.chunk * stackIndex + range.chunk / 2;
        var size = Math.min(valueOrDefault$3(options.maxBarThickness, Infinity), range.chunk * range.ratio);
        return {
          base: center - size / 2,
          head: center + size / 2,
          center: center,
          size: size
        };
      },
      draw: function draw() {
        var me = this;
        var chart = me.chart;
        var scale = me._getValueScale();
        var rects = me.getMeta().data;
        var dataset = me.getDataset();
        var ilen = rects.length;
        var i = 0;
        helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
        for (; i < ilen; ++i) {
          var val = scale._parseValue(dataset.data[i]);
          if (!isNaN(val.min) && !isNaN(val.max)) {
            rects[i].draw();
          }
        }
        helpers$1.canvas.unclipArea(chart.ctx);
      },
      _resolveDataElementOptions: function _resolveDataElementOptions() {
        var me = this;
        var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
        var indexOpts = me._getIndexScale().options;
        var valueOpts = me._getValueScale().options;
        values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
        values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
        values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
        values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
        values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
        return values;
      }
    });
    var valueOrDefault$4 = helpers$1.valueOrDefault;
    var resolve$1 = helpers$1.options.resolve;
    core_defaults._set('bubble', {
      hover: {
        mode: 'single'
      },
      scales: {
        xAxes: [{
          type: 'linear',
          position: 'bottom',
          id: 'x-axis-0'
        }],
        yAxes: [{
          type: 'linear',
          position: 'left',
          id: 'y-axis-0'
        }]
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(item, data) {
            var datasetLabel = data.datasets[item.datasetIndex].label || '';
            var dataPoint = data.datasets[item.datasetIndex].data[item.index];
            return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
          }
        }
      }
    });
    var controller_bubble = core_datasetController.extend({
      dataElementType: elements.Point,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth', 'hoverRadius', 'hitRadius', 'pointStyle', 'rotation'],
      update: function update(reset) {
        var me = this;
        var meta = me.getMeta();
        var points = meta.data;
        helpers$1.each(points, function (point, index) {
          me.updateElement(point, index, reset);
        });
      },
      updateElement: function updateElement(point, index, reset) {
        var me = this;
        var meta = me.getMeta();
        var custom = point.custom || {};
        var xScale = me.getScaleForId(meta.xAxisID);
        var yScale = me.getScaleForId(meta.yAxisID);
        var options = me._resolveDataElementOptions(point, index);
        var data = me.getDataset().data[index];
        var dsIndex = me.index;
        var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
        var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
        point._xScale = xScale;
        point._yScale = yScale;
        point._options = options;
        point._datasetIndex = dsIndex;
        point._index = index;
        point._model = {
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderWidth: options.borderWidth,
          hitRadius: options.hitRadius,
          pointStyle: options.pointStyle,
          rotation: options.rotation,
          radius: reset ? 0 : options.radius,
          skip: custom.skip || isNaN(x) || isNaN(y),
          x: x,
          y: y
        };
        point.pivot();
      },
      setHoverStyle: function setHoverStyle(point) {
        var model = point._model;
        var options = point._options;
        var getHoverColor = helpers$1.getHoverColor;
        point.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth,
          radius: model.radius
        };
        model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
        model.radius = options.radius + options.hoverRadius;
      },
      _resolveDataElementOptions: function _resolveDataElementOptions(point, index) {
        var me = this;
        var chart = me.chart;
        var dataset = me.getDataset();
        var custom = point.custom || {};
        var data = dataset.data[index] || {};
        var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
        var context = {
          chart: chart,
          dataIndex: index,
          dataset: dataset,
          datasetIndex: me.index
        };
        if (me._cachedDataOpts === values) {
          values = helpers$1.extend({}, values);
        }
        values.radius = resolve$1([custom.radius, data.r, me._config.radius, chart.options.elements.point.radius], context, index);
        return values;
      }
    });
    var valueOrDefault$5 = helpers$1.valueOrDefault;
    var PI$1 = Math.PI;
    var DOUBLE_PI$1 = PI$1 * 2;
    var HALF_PI$1 = PI$1 / 2;
    core_defaults._set('doughnut', {
      animation: {
        animateRotate: true,
        animateScale: false
      },
      hover: {
        mode: 'single'
      },
      legendCallback: function legendCallback(chart) {
        var list = document.createElement('ul');
        var data = chart.data;
        var datasets = data.datasets;
        var labels = data.labels;
        var i, ilen, listItem, listItemSpan;
        list.setAttribute('class', chart.id + '-legend');
        if (datasets.length) {
          for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
            listItem = list.appendChild(document.createElement('li'));
            listItemSpan = listItem.appendChild(document.createElement('span'));
            listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
            if (labels[i]) {
              listItem.appendChild(document.createTextNode(labels[i]));
            }
          }
        }
        return list.outerHTML;
      },
      legend: {
        labels: {
          generateLabels: function generateLabels(chart) {
            var data = chart.data;
            if (data.labels.length && data.datasets.length) {
              return data.labels.map(function (label, i) {
                var meta = chart.getDatasetMeta(0);
                var style = meta.controller.getStyle(i);
                return {
                  text: label,
                  fillStyle: style.backgroundColor,
                  strokeStyle: style.borderColor,
                  lineWidth: style.borderWidth,
                  hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                  index: i
                };
              });
            }
            return [];
          }
        },
        onClick: function onClick(e, legendItem) {
          var index = legendItem.index;
          var chart = this.chart;
          var i, ilen, meta;
          for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
            meta = chart.getDatasetMeta(i);
            if (meta.data[index]) {
              meta.data[index].hidden = !meta.data[index].hidden;
            }
          }
          chart.update();
        }
      },
      cutoutPercentage: 50,
      rotation: -HALF_PI$1,
      circumference: DOUBLE_PI$1,
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(tooltipItem, data) {
            var dataLabel = data.labels[tooltipItem.index];
            var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            if (helpers$1.isArray(dataLabel)) {
              dataLabel = dataLabel.slice();
              dataLabel[0] += value;
            } else {
              dataLabel += value;
            }
            return dataLabel;
          }
        }
      }
    });
    var controller_doughnut = core_datasetController.extend({
      dataElementType: elements.Arc,
      linkScales: helpers$1.noop,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'borderAlign', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth'],
      getRingIndex: function getRingIndex(datasetIndex) {
        var ringIndex = 0;
        for (var j = 0; j < datasetIndex; ++j) {
          if (this.chart.isDatasetVisible(j)) {
            ++ringIndex;
          }
        }
        return ringIndex;
      },
      update: function update(reset) {
        var me = this;
        var chart = me.chart;
        var chartArea = chart.chartArea;
        var opts = chart.options;
        var ratioX = 1;
        var ratioY = 1;
        var offsetX = 0;
        var offsetY = 0;
        var meta = me.getMeta();
        var arcs = meta.data;
        var cutout = opts.cutoutPercentage / 100 || 0;
        var circumference = opts.circumference;
        var chartWeight = me._getRingWeight(me.index);
        var maxWidth, maxHeight, i, ilen;
        if (circumference < DOUBLE_PI$1) {
          var startAngle = opts.rotation % DOUBLE_PI$1;
          startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
          var endAngle = startAngle + circumference;
          var startX = Math.cos(startAngle);
          var startY = Math.sin(startAngle);
          var endX = Math.cos(endAngle);
          var endY = Math.sin(endAngle);
          var contains0 = startAngle <= 0 && endAngle >= 0 || endAngle >= DOUBLE_PI$1;
          var contains90 = startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1 || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
          var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
          var contains270 = startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1 || endAngle >= PI$1 + HALF_PI$1;
          var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
          var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
          var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
          var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
          ratioX = (maxX - minX) / 2;
          ratioY = (maxY - minY) / 2;
          offsetX = -(maxX + minX) / 2;
          offsetY = -(maxY + minY) / 2;
        }
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
        }
        chart.borderWidth = me.getMaxBorderWidth();
        maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
        maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
        chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
        chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
        chart.offsetX = offsetX * chart.outerRadius;
        chart.offsetY = offsetY * chart.outerRadius;
        meta.total = me.calculateTotal();
        me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
        me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          me.updateElement(arcs[i], i, reset);
        }
      },
      updateElement: function updateElement(arc, index, reset) {
        var me = this;
        var chart = me.chart;
        var chartArea = chart.chartArea;
        var opts = chart.options;
        var animationOpts = opts.animation;
        var centerX = (chartArea.left + chartArea.right) / 2;
        var centerY = (chartArea.top + chartArea.bottom) / 2;
        var startAngle = opts.rotation;
        var endAngle = opts.rotation;
        var dataset = me.getDataset();
        var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
        var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
        var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
        var options = arc._options || {};
        helpers$1.extend(arc, {
          _datasetIndex: me.index,
          _index: index,
          _model: {
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: options.borderWidth,
            borderAlign: options.borderAlign,
            x: centerX + chart.offsetX,
            y: centerY + chart.offsetY,
            startAngle: startAngle,
            endAngle: endAngle,
            circumference: circumference,
            outerRadius: outerRadius,
            innerRadius: innerRadius,
            label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
          }
        });
        var model = arc._model;
        if (!reset || !animationOpts.animateRotate) {
          if (index === 0) {
            model.startAngle = opts.rotation;
          } else {
            model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
          }
          model.endAngle = model.startAngle + model.circumference;
        }
        arc.pivot();
      },
      calculateTotal: function calculateTotal() {
        var dataset = this.getDataset();
        var meta = this.getMeta();
        var total = 0;
        var value;
        helpers$1.each(meta.data, function (element, index) {
          value = dataset.data[index];
          if (!isNaN(value) && !element.hidden) {
            total += Math.abs(value);
          }
        });
        return total;
      },
      calculateCircumference: function calculateCircumference(value) {
        var total = this.getMeta().total;
        if (total > 0 && !isNaN(value)) {
          return DOUBLE_PI$1 * (Math.abs(value) / total);
        }
        return 0;
      },
      getMaxBorderWidth: function getMaxBorderWidth(arcs) {
        var me = this;
        var max = 0;
        var chart = me.chart;
        var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
        if (!arcs) {
          for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
            if (chart.isDatasetVisible(i)) {
              meta = chart.getDatasetMeta(i);
              arcs = meta.data;
              if (i !== me.index) {
                controller = meta.controller;
              }
              break;
            }
          }
        }
        if (!arcs) {
          return 0;
        }
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          arc = arcs[i];
          if (controller) {
            controller._configure();
            options = controller._resolveDataElementOptions(arc, i);
          } else {
            options = arc._options;
          }
          if (options.borderAlign !== 'inner') {
            borderWidth = options.borderWidth;
            hoverWidth = options.hoverBorderWidth;
            max = borderWidth > max ? borderWidth : max;
            max = hoverWidth > max ? hoverWidth : max;
          }
        }
        return max;
      },
      setHoverStyle: function setHoverStyle(arc) {
        var model = arc._model;
        var options = arc._options;
        var getHoverColor = helpers$1.getHoverColor;
        arc.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth
        };
        model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
      },
      _getRingWeightOffset: function _getRingWeightOffset(datasetIndex) {
        var ringWeightOffset = 0;
        for (var i = 0; i < datasetIndex; ++i) {
          if (this.chart.isDatasetVisible(i)) {
            ringWeightOffset += this._getRingWeight(i);
          }
        }
        return ringWeightOffset;
      },
      _getRingWeight: function _getRingWeight(dataSetIndex) {
        return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
      },
      _getVisibleDatasetWeightTotal: function _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length);
      }
    });
    core_defaults._set('horizontalBar', {
      hover: {
        mode: 'index',
        axis: 'y'
      },
      scales: {
        xAxes: [{
          type: 'linear',
          position: 'bottom'
        }],
        yAxes: [{
          type: 'category',
          position: 'left',
          offset: true,
          gridLines: {
            offsetGridLines: true
          }
        }]
      },
      elements: {
        rectangle: {
          borderSkipped: 'left'
        }
      },
      tooltips: {
        mode: 'index',
        axis: 'y'
      }
    });
    core_defaults._set('global', {
      datasets: {
        horizontalBar: {
          categoryPercentage: 0.8,
          barPercentage: 0.9
        }
      }
    });
    var controller_horizontalBar = controller_bar.extend({
      _getValueScaleId: function _getValueScaleId() {
        return this.getMeta().xAxisID;
      },
      _getIndexScaleId: function _getIndexScaleId() {
        return this.getMeta().yAxisID;
      }
    });
    var valueOrDefault$6 = helpers$1.valueOrDefault;
    var resolve$2 = helpers$1.options.resolve;
    var isPointInArea = helpers$1.canvas._isPointInArea;
    core_defaults._set('line', {
      showLines: true,
      spanGaps: false,
      hover: {
        mode: 'label'
      },
      scales: {
        xAxes: [{
          type: 'category',
          id: 'x-axis-0'
        }],
        yAxes: [{
          type: 'linear',
          id: 'y-axis-0'
        }]
      }
    });
    function scaleClip(scale, halfBorderWidth) {
      var tickOpts = scale && scale.options.ticks || {};
      var reverse = tickOpts.reverse;
      var min = tickOpts.min === undefined ? halfBorderWidth : 0;
      var max = tickOpts.max === undefined ? halfBorderWidth : 0;
      return {
        start: reverse ? max : min,
        end: reverse ? min : max
      };
    }
    function defaultClip(xScale, yScale, borderWidth) {
      var halfBorderWidth = borderWidth / 2;
      var x = scaleClip(xScale, halfBorderWidth);
      var y = scaleClip(yScale, halfBorderWidth);
      return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
      };
    }
    function toClip(value) {
      var t, r, b, l;
      if (helpers$1.isObject(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
      } else {
        t = r = b = l = value;
      }
      return {
        top: t,
        right: r,
        bottom: b,
        left: l
      };
    }
    var controller_line = core_datasetController.extend({
      datasetElementType: elements.Line,
      dataElementType: elements.Point,
      _datasetElementOptions: ['backgroundColor', 'borderCapStyle', 'borderColor', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'borderWidth', 'cubicInterpolationMode', 'fill'],
      _dataElementOptions: {
        backgroundColor: 'pointBackgroundColor',
        borderColor: 'pointBorderColor',
        borderWidth: 'pointBorderWidth',
        hitRadius: 'pointHitRadius',
        hoverBackgroundColor: 'pointHoverBackgroundColor',
        hoverBorderColor: 'pointHoverBorderColor',
        hoverBorderWidth: 'pointHoverBorderWidth',
        hoverRadius: 'pointHoverRadius',
        pointStyle: 'pointStyle',
        radius: 'pointRadius',
        rotation: 'pointRotation'
      },
      update: function update(reset) {
        var me = this;
        var meta = me.getMeta();
        var line = meta.dataset;
        var points = meta.data || [];
        var options = me.chart.options;
        var config = me._config;
        var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
        var i, ilen;
        me._xScale = me.getScaleForId(meta.xAxisID);
        me._yScale = me.getScaleForId(meta.yAxisID);
        if (showLine) {
          if (config.tension !== undefined && config.lineTension === undefined) {
            config.lineTension = config.tension;
          }
          line._scale = me._yScale;
          line._datasetIndex = me.index;
          line._children = points;
          line._model = me._resolveDatasetElementOptions(line);
          line.pivot();
        }
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          me.updateElement(points[i], i, reset);
        }
        if (showLine && line._model.tension !== 0) {
          me.updateBezierControlPoints();
        }
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          points[i].pivot();
        }
      },
      updateElement: function updateElement(point, index, reset) {
        var me = this;
        var meta = me.getMeta();
        var custom = point.custom || {};
        var dataset = me.getDataset();
        var datasetIndex = me.index;
        var value = dataset.data[index];
        var xScale = me._xScale;
        var yScale = me._yScale;
        var lineModel = meta.dataset._model;
        var x, y;
        var options = me._resolveDataElementOptions(point, index);
        x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
        y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
        point._xScale = xScale;
        point._yScale = yScale;
        point._options = options;
        point._datasetIndex = datasetIndex;
        point._index = index;
        point._model = {
          x: x,
          y: y,
          skip: custom.skip || isNaN(x) || isNaN(y),
          radius: options.radius,
          pointStyle: options.pointStyle,
          rotation: options.rotation,
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderWidth: options.borderWidth,
          tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
          steppedLine: lineModel ? lineModel.steppedLine : false,
          hitRadius: options.hitRadius
        };
      },
      _resolveDatasetElementOptions: function _resolveDatasetElementOptions(element) {
        var me = this;
        var config = me._config;
        var custom = element.custom || {};
        var options = me.chart.options;
        var lineOptions = options.elements.line;
        var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
        values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
        values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
        values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
        values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
        return values;
      },
      calculatePointY: function calculatePointY(value, index, datasetIndex) {
        var me = this;
        var chart = me.chart;
        var yScale = me._yScale;
        var sumPos = 0;
        var sumNeg = 0;
        var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
        if (yScale.options.stacked) {
          rightValue = +yScale.getRightValue(value);
          metasets = chart._getSortedVisibleDatasetMetas();
          ilen = metasets.length;
          for (i = 0; i < ilen; ++i) {
            dsMeta = metasets[i];
            if (dsMeta.index === datasetIndex) {
              break;
            }
            ds = chart.data.datasets[dsMeta.index];
            if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
              stackedRightValue = +yScale.getRightValue(ds.data[index]);
              if (stackedRightValue < 0) {
                sumNeg += stackedRightValue || 0;
              } else {
                sumPos += stackedRightValue || 0;
              }
            }
          }
          if (rightValue < 0) {
            return yScale.getPixelForValue(sumNeg + rightValue);
          }
          return yScale.getPixelForValue(sumPos + rightValue);
        }
        return yScale.getPixelForValue(value);
      },
      updateBezierControlPoints: function updateBezierControlPoints() {
        var me = this;
        var chart = me.chart;
        var meta = me.getMeta();
        var lineModel = meta.dataset._model;
        var area = chart.chartArea;
        var points = meta.data || [];
        var i, ilen, model, controlPoints;
        if (lineModel.spanGaps) {
          points = points.filter(function (pt) {
            return !pt._model.skip;
          });
        }
        function capControlPoint(pt, min, max) {
          return Math.max(Math.min(pt, max), min);
        }
        if (lineModel.cubicInterpolationMode === 'monotone') {
          helpers$1.splineCurveMonotone(points);
        } else {
          for (i = 0, ilen = points.length; i < ilen; ++i) {
            model = points[i]._model;
            controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i)._model, model, helpers$1.nextItem(points, i)._model, lineModel.tension);
            model.controlPointPreviousX = controlPoints.previous.x;
            model.controlPointPreviousY = controlPoints.previous.y;
            model.controlPointNextX = controlPoints.next.x;
            model.controlPointNextY = controlPoints.next.y;
          }
        }
        if (chart.options.elements.line.capBezierPoints) {
          for (i = 0, ilen = points.length; i < ilen; ++i) {
            model = points[i]._model;
            if (isPointInArea(model, area)) {
              if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
                model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
                model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
              }
              if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
                model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
                model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
              }
            }
          }
        }
      },
      draw: function draw() {
        var me = this;
        var chart = me.chart;
        var meta = me.getMeta();
        var points = meta.data || [];
        var area = chart.chartArea;
        var canvas = chart.canvas;
        var i = 0;
        var ilen = points.length;
        var clip;
        if (me._showLine) {
          clip = meta.dataset._model.clip;
          helpers$1.canvas.clipArea(chart.ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? canvas.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
          });
          meta.dataset.draw();
          helpers$1.canvas.unclipArea(chart.ctx);
        }
        for (; i < ilen; ++i) {
          points[i].draw(area);
        }
      },
      setHoverStyle: function setHoverStyle(point) {
        var model = point._model;
        var options = point._options;
        var getHoverColor = helpers$1.getHoverColor;
        point.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth,
          radius: model.radius
        };
        model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
        model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
      }
    });
    var resolve$3 = helpers$1.options.resolve;
    core_defaults._set('polarArea', {
      scale: {
        type: 'radialLinear',
        angleLines: {
          display: false
        },
        gridLines: {
          circular: true
        },
        pointLabels: {
          display: false
        },
        ticks: {
          beginAtZero: true
        }
      },
      animation: {
        animateRotate: true,
        animateScale: true
      },
      startAngle: -0.5 * Math.PI,
      legendCallback: function legendCallback(chart) {
        var list = document.createElement('ul');
        var data = chart.data;
        var datasets = data.datasets;
        var labels = data.labels;
        var i, ilen, listItem, listItemSpan;
        list.setAttribute('class', chart.id + '-legend');
        if (datasets.length) {
          for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
            listItem = list.appendChild(document.createElement('li'));
            listItemSpan = listItem.appendChild(document.createElement('span'));
            listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
            if (labels[i]) {
              listItem.appendChild(document.createTextNode(labels[i]));
            }
          }
        }
        return list.outerHTML;
      },
      legend: {
        labels: {
          generateLabels: function generateLabels(chart) {
            var data = chart.data;
            if (data.labels.length && data.datasets.length) {
              return data.labels.map(function (label, i) {
                var meta = chart.getDatasetMeta(0);
                var style = meta.controller.getStyle(i);
                return {
                  text: label,
                  fillStyle: style.backgroundColor,
                  strokeStyle: style.borderColor,
                  lineWidth: style.borderWidth,
                  hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                  index: i
                };
              });
            }
            return [];
          }
        },
        onClick: function onClick(e, legendItem) {
          var index = legendItem.index;
          var chart = this.chart;
          var i, ilen, meta;
          for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
            meta = chart.getDatasetMeta(i);
            meta.data[index].hidden = !meta.data[index].hidden;
          }
          chart.update();
        }
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(item, data) {
            return data.labels[item.index] + ': ' + item.yLabel;
          }
        }
      }
    });
    var controller_polarArea = core_datasetController.extend({
      dataElementType: elements.Arc,
      linkScales: helpers$1.noop,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'borderAlign', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth'],
      _getIndexScaleId: function _getIndexScaleId() {
        return this.chart.scale.id;
      },
      _getValueScaleId: function _getValueScaleId() {
        return this.chart.scale.id;
      },
      update: function update(reset) {
        var me = this;
        var dataset = me.getDataset();
        var meta = me.getMeta();
        var start = me.chart.options.startAngle || 0;
        var starts = me._starts = [];
        var angles = me._angles = [];
        var arcs = meta.data;
        var i, ilen, angle;
        me._updateRadius();
        meta.count = me.countVisibleElements();
        for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
          starts[i] = start;
          angle = me._computeAngle(i);
          angles[i] = angle;
          start += angle;
        }
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
          me.updateElement(arcs[i], i, reset);
        }
      },
      _updateRadius: function _updateRadius() {
        var me = this;
        var chart = me.chart;
        var chartArea = chart.chartArea;
        var opts = chart.options;
        var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        chart.outerRadius = Math.max(minSize / 2, 0);
        chart.innerRadius = Math.max(opts.cutoutPercentage ? chart.outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
        me.outerRadius = chart.outerRadius - chart.radiusLength * me.index;
        me.innerRadius = me.outerRadius - chart.radiusLength;
      },
      updateElement: function updateElement(arc, index, reset) {
        var me = this;
        var chart = me.chart;
        var dataset = me.getDataset();
        var opts = chart.options;
        var animationOpts = opts.animation;
        var scale = chart.scale;
        var labels = chart.data.labels;
        var centerX = scale.xCenter;
        var centerY = scale.yCenter;
        var datasetStartAngle = opts.startAngle;
        var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
        var startAngle = me._starts[index];
        var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
        var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
        var options = arc._options || {};
        helpers$1.extend(arc, {
          _datasetIndex: me.index,
          _index: index,
          _scale: scale,
          _model: {
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: options.borderWidth,
            borderAlign: options.borderAlign,
            x: centerX,
            y: centerY,
            innerRadius: 0,
            outerRadius: reset ? resetRadius : distance,
            startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
            endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
            label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
          }
        });
        arc.pivot();
      },
      countVisibleElements: function countVisibleElements() {
        var dataset = this.getDataset();
        var meta = this.getMeta();
        var count = 0;
        helpers$1.each(meta.data, function (element, index) {
          if (!isNaN(dataset.data[index]) && !element.hidden) {
            count++;
          }
        });
        return count;
      },
      setHoverStyle: function setHoverStyle(arc) {
        var model = arc._model;
        var options = arc._options;
        var getHoverColor = helpers$1.getHoverColor;
        var valueOrDefault = helpers$1.valueOrDefault;
        arc.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth
        };
        model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
      },
      _computeAngle: function _computeAngle(index) {
        var me = this;
        var count = this.getMeta().count;
        var dataset = me.getDataset();
        var meta = me.getMeta();
        if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
          return 0;
        }
        var context = {
          chart: me.chart,
          dataIndex: index,
          dataset: dataset,
          datasetIndex: me.index
        };
        return resolve$3([me.chart.options.elements.arc.angle, 2 * Math.PI / count], context, index);
      }
    });
    core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
    core_defaults._set('pie', {
      cutoutPercentage: 0
    });
    var controller_pie = controller_doughnut;
    var valueOrDefault$7 = helpers$1.valueOrDefault;
    core_defaults._set('radar', {
      spanGaps: false,
      scale: {
        type: 'radialLinear'
      },
      elements: {
        line: {
          fill: 'start',
          tension: 0
        }
      }
    });
    var controller_radar = core_datasetController.extend({
      datasetElementType: elements.Line,
      dataElementType: elements.Point,
      linkScales: helpers$1.noop,
      _datasetElementOptions: ['backgroundColor', 'borderWidth', 'borderColor', 'borderCapStyle', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'fill'],
      _dataElementOptions: {
        backgroundColor: 'pointBackgroundColor',
        borderColor: 'pointBorderColor',
        borderWidth: 'pointBorderWidth',
        hitRadius: 'pointHitRadius',
        hoverBackgroundColor: 'pointHoverBackgroundColor',
        hoverBorderColor: 'pointHoverBorderColor',
        hoverBorderWidth: 'pointHoverBorderWidth',
        hoverRadius: 'pointHoverRadius',
        pointStyle: 'pointStyle',
        radius: 'pointRadius',
        rotation: 'pointRotation'
      },
      _getIndexScaleId: function _getIndexScaleId() {
        return this.chart.scale.id;
      },
      _getValueScaleId: function _getValueScaleId() {
        return this.chart.scale.id;
      },
      update: function update(reset) {
        var me = this;
        var meta = me.getMeta();
        var line = meta.dataset;
        var points = meta.data || [];
        var scale = me.chart.scale;
        var config = me._config;
        var i, ilen;
        if (config.tension !== undefined && config.lineTension === undefined) {
          config.lineTension = config.tension;
        }
        line._scale = scale;
        line._datasetIndex = me.index;
        line._children = points;
        line._loop = true;
        line._model = me._resolveDatasetElementOptions(line);
        line.pivot();
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          me.updateElement(points[i], i, reset);
        }
        me.updateBezierControlPoints();
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          points[i].pivot();
        }
      },
      updateElement: function updateElement(point, index, reset) {
        var me = this;
        var custom = point.custom || {};
        var dataset = me.getDataset();
        var scale = me.chart.scale;
        var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
        var options = me._resolveDataElementOptions(point, index);
        var lineModel = me.getMeta().dataset._model;
        var x = reset ? scale.xCenter : pointPosition.x;
        var y = reset ? scale.yCenter : pointPosition.y;
        point._scale = scale;
        point._options = options;
        point._datasetIndex = me.index;
        point._index = index;
        point._model = {
          x: x,
          y: y,
          skip: custom.skip || isNaN(x) || isNaN(y),
          radius: options.radius,
          pointStyle: options.pointStyle,
          rotation: options.rotation,
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderWidth: options.borderWidth,
          tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
          hitRadius: options.hitRadius
        };
      },
      _resolveDatasetElementOptions: function _resolveDatasetElementOptions() {
        var me = this;
        var config = me._config;
        var options = me.chart.options;
        var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
        values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
        values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
        return values;
      },
      updateBezierControlPoints: function updateBezierControlPoints() {
        var me = this;
        var meta = me.getMeta();
        var area = me.chart.chartArea;
        var points = meta.data || [];
        var i, ilen, model, controlPoints;
        if (meta.dataset._model.spanGaps) {
          points = points.filter(function (pt) {
            return !pt._model.skip;
          });
        }
        function capControlPoint(pt, min, max) {
          return Math.max(Math.min(pt, max), min);
        }
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          model = points[i]._model;
          controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i, true)._model, model, helpers$1.nextItem(points, i, true)._model, model.tension);
          model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
          model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
          model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
          model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
        }
      },
      setHoverStyle: function setHoverStyle(point) {
        var model = point._model;
        var options = point._options;
        var getHoverColor = helpers$1.getHoverColor;
        point.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth,
          radius: model.radius
        };
        model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
        model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
      }
    });
    core_defaults._set('scatter', {
      hover: {
        mode: 'single'
      },
      scales: {
        xAxes: [{
          id: 'x-axis-1',
          type: 'linear',
          position: 'bottom'
        }],
        yAxes: [{
          id: 'y-axis-1',
          type: 'linear',
          position: 'left'
        }]
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(item) {
            return '(' + item.xLabel + ', ' + item.yLabel + ')';
          }
        }
      }
    });
    core_defaults._set('global', {
      datasets: {
        scatter: {
          showLine: false
        }
      }
    });
    var controller_scatter = controller_line;
    var controllers = {
      bar: controller_bar,
      bubble: controller_bubble,
      doughnut: controller_doughnut,
      horizontalBar: controller_horizontalBar,
      line: controller_line,
      polarArea: controller_polarArea,
      pie: controller_pie,
      radar: controller_radar,
      scatter: controller_scatter
    };
    function getRelativePosition(e, chart) {
      if (e["native"]) {
        return {
          x: e.x,
          y: e.y
        };
      }
      return helpers$1.getRelativePosition(e, chart);
    }
    function parseVisibleItems(chart, handler) {
      var metasets = chart._getSortedVisibleDatasetMetas();
      var metadata, i, j, ilen, jlen, element;
      for (i = 0, ilen = metasets.length; i < ilen; ++i) {
        metadata = metasets[i].data;
        for (j = 0, jlen = metadata.length; j < jlen; ++j) {
          element = metadata[j];
          if (!element._view.skip) {
            handler(element);
          }
        }
      }
    }
    function getIntersectItems(chart, position) {
      var elements = [];
      parseVisibleItems(chart, function (element) {
        if (element.inRange(position.x, position.y)) {
          elements.push(element);
        }
      });
      return elements;
    }
    function getNearestItems(chart, position, intersect, distanceMetric) {
      var minDistance = Number.POSITIVE_INFINITY;
      var nearestItems = [];
      parseVisibleItems(chart, function (element) {
        if (intersect && !element.inRange(position.x, position.y)) {
          return;
        }
        var center = element.getCenterPoint();
        var distance = distanceMetric(position, center);
        if (distance < minDistance) {
          nearestItems = [element];
          minDistance = distance;
        } else if (distance === minDistance) {
          nearestItems.push(element);
        }
      });
      return nearestItems;
    }
    function getDistanceMetricForAxis(axis) {
      var useX = axis.indexOf('x') !== -1;
      var useY = axis.indexOf('y') !== -1;
      return function (pt1, pt2) {
        var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
      };
    }
    function indexMode(chart, e, options) {
      var position = getRelativePosition(e, chart);
      options.axis = options.axis || 'x';
      var distanceMetric = getDistanceMetricForAxis(options.axis);
      var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
      var elements = [];
      if (!items.length) {
        return [];
      }
      chart._getSortedVisibleDatasetMetas().forEach(function (meta) {
        var element = meta.data[items[0]._index];
        if (element && !element._view.skip) {
          elements.push(element);
        }
      });
      return elements;
    }
    var core_interaction = {
      modes: {
        single: function single(chart, e) {
          var position = getRelativePosition(e, chart);
          var elements = [];
          parseVisibleItems(chart, function (element) {
            if (element.inRange(position.x, position.y)) {
              elements.push(element);
              return elements;
            }
          });
          return elements.slice(0, 1);
        },
        label: indexMode,
        index: indexMode,
        dataset: function dataset(chart, e, options) {
          var position = getRelativePosition(e, chart);
          options.axis = options.axis || 'xy';
          var distanceMetric = getDistanceMetricForAxis(options.axis);
          var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
          if (items.length > 0) {
            items = chart.getDatasetMeta(items[0]._datasetIndex).data;
          }
          return items;
        },
        'x-axis': function xAxis(chart, e) {
          return indexMode(chart, e, {
            intersect: false
          });
        },
        point: function point(chart, e) {
          var position = getRelativePosition(e, chart);
          return getIntersectItems(chart, position);
        },
        nearest: function nearest(chart, e, options) {
          var position = getRelativePosition(e, chart);
          options.axis = options.axis || 'xy';
          var distanceMetric = getDistanceMetricForAxis(options.axis);
          return getNearestItems(chart, position, options.intersect, distanceMetric);
        },
        x: function x(chart, e, options) {
          var position = getRelativePosition(e, chart);
          var items = [];
          var intersectsItem = false;
          parseVisibleItems(chart, function (element) {
            if (element.inXRange(position.x)) {
              items.push(element);
            }
            if (element.inRange(position.x, position.y)) {
              intersectsItem = true;
            }
          });
          if (options.intersect && !intersectsItem) {
            items = [];
          }
          return items;
        },
        y: function y(chart, e, options) {
          var position = getRelativePosition(e, chart);
          var items = [];
          var intersectsItem = false;
          parseVisibleItems(chart, function (element) {
            if (element.inYRange(position.y)) {
              items.push(element);
            }
            if (element.inRange(position.x, position.y)) {
              intersectsItem = true;
            }
          });
          if (options.intersect && !intersectsItem) {
            items = [];
          }
          return items;
        }
      }
    };
    var extend = helpers$1.extend;
    function filterByPosition(array, position) {
      return helpers$1.where(array, function (v) {
        return v.pos === position;
      });
    }
    function sortByWeight(array, reverse) {
      return array.sort(function (a, b) {
        var v0 = reverse ? b : a;
        var v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
      });
    }
    function wrapBoxes(boxes) {
      var layoutBoxes = [];
      var i, ilen, box;
      for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
        box = boxes[i];
        layoutBoxes.push({
          index: i,
          box: box,
          pos: box.position,
          horizontal: box.isHorizontal(),
          weight: box.weight
        });
      }
      return layoutBoxes;
    }
    function setLayoutDims(layouts, params) {
      var i, ilen, layout;
      for (i = 0, ilen = layouts.length; i < ilen; ++i) {
        layout = layouts[i];
        layout.width = layout.horizontal ? layout.box.fullWidth && params.availableWidth : params.vBoxMaxWidth;
        layout.height = layout.horizontal && params.hBoxMaxHeight;
      }
    }
    function buildLayoutBoxes(boxes) {
      var layoutBoxes = wrapBoxes(boxes);
      var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
      var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
      var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
      var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
      return {
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(bottom),
        chartArea: filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right),
        horizontal: top.concat(bottom)
      };
    }
    function getCombinedMax(maxPadding, chartArea, a, b) {
      return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
    }
    function updateDims(chartArea, params, layout) {
      var box = layout.box;
      var maxPadding = chartArea.maxPadding;
      var newWidth, newHeight;
      if (layout.size) {
        chartArea[layout.pos] -= layout.size;
      }
      layout.size = layout.horizontal ? box.height : box.width;
      chartArea[layout.pos] += layout.size;
      if (box.getPadding) {
        var boxPadding = box.getPadding();
        maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
        maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
        maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
        maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
      }
      newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
      newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
      if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
        chartArea.w = newWidth;
        chartArea.h = newHeight;
        var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
        return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
      }
    }
    function handleMaxPadding(chartArea) {
      var maxPadding = chartArea.maxPadding;
      function updatePos(pos) {
        var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
      }
      chartArea.y += updatePos('top');
      chartArea.x += updatePos('left');
      updatePos('right');
      updatePos('bottom');
    }
    function getMargins(horizontal, chartArea) {
      var maxPadding = chartArea.maxPadding;
      function marginForPositions(positions) {
        var margin = {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        };
        positions.forEach(function (pos) {
          margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
      }
      return horizontal ? marginForPositions(['left', 'right']) : marginForPositions(['top', 'bottom']);
    }
    function fitBoxes(boxes, chartArea, params) {
      var refitBoxes = [];
      var i, ilen, layout, box, refit, changed;
      for (i = 0, ilen = boxes.length; i < ilen; ++i) {
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
        if (updateDims(chartArea, params, layout)) {
          changed = true;
          if (refitBoxes.length) {
            refit = true;
          }
        }
        if (!box.fullWidth) {
          refitBoxes.push(layout);
        }
      }
      return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
    }
    function placeBoxes(boxes, chartArea, params) {
      var userPadding = params.padding;
      var x = chartArea.x;
      var y = chartArea.y;
      var i, ilen, layout, box;
      for (i = 0, ilen = boxes.length; i < ilen; ++i) {
        layout = boxes[i];
        box = layout.box;
        if (layout.horizontal) {
          box.left = box.fullWidth ? userPadding.left : chartArea.left;
          box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
          box.top = y;
          box.bottom = y + box.height;
          box.width = box.right - box.left;
          y = box.bottom;
        } else {
          box.left = x;
          box.right = x + box.width;
          box.top = chartArea.top;
          box.bottom = chartArea.top + chartArea.h;
          box.height = box.bottom - box.top;
          x = box.right;
        }
      }
      chartArea.x = x;
      chartArea.y = y;
    }
    core_defaults._set('global', {
      layout: {
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      }
    });
    var core_layouts = {
      defaults: {},
      addBox: function addBox(chart, item) {
        if (!chart.boxes) {
          chart.boxes = [];
        }
        item.fullWidth = item.fullWidth || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function () {
          return [{
            z: 0,
            draw: function draw() {
              item.draw.apply(item, arguments);
            }
          }];
        };
        chart.boxes.push(item);
      },
      removeBox: function removeBox(chart, layoutItem) {
        var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) {
          chart.boxes.splice(index, 1);
        }
      },
      configure: function configure(chart, item, options) {
        var props = ['fullWidth', 'position', 'weight'];
        var ilen = props.length;
        var i = 0;
        var prop;
        for (; i < ilen; ++i) {
          prop = props[i];
          if (options.hasOwnProperty(prop)) {
            item[prop] = options[prop];
          }
        }
      },
      update: function update(chart, width, height) {
        if (!chart) {
          return;
        }
        var layoutOptions = chart.options.layout || {};
        var padding = helpers$1.options.toPadding(layoutOptions.padding);
        var availableWidth = width - padding.width;
        var availableHeight = height - padding.height;
        var boxes = buildLayoutBoxes(chart.boxes);
        var verticalBoxes = boxes.vertical;
        var horizontalBoxes = boxes.horizontal;
        var params = Object.freeze({
          outerWidth: width,
          outerHeight: height,
          padding: padding,
          availableWidth: availableWidth,
          vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
          hBoxMaxHeight: availableHeight / 2
        });
        var chartArea = extend({
          maxPadding: extend({}, padding),
          w: availableWidth,
          h: availableHeight,
          x: padding.left,
          y: padding.top
        }, padding);
        setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        fitBoxes(verticalBoxes, chartArea, params);
        if (fitBoxes(horizontalBoxes, chartArea, params)) {
          fitBoxes(verticalBoxes, chartArea, params);
        }
        handleMaxPadding(chartArea);
        placeBoxes(boxes.leftAndTop, chartArea, params);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        placeBoxes(boxes.rightAndBottom, chartArea, params);
        chart.chartArea = {
          left: chartArea.left,
          top: chartArea.top,
          right: chartArea.left + chartArea.w,
          bottom: chartArea.top + chartArea.h
        };
        helpers$1.each(boxes.chartArea, function (layout) {
          var box = layout.box;
          extend(box, chart.chartArea);
          box.update(chartArea.w, chartArea.h);
        });
      }
    };
    var platform_basic = {
      acquireContext: function acquireContext(item) {
        if (item && item.canvas) {
          item = item.canvas;
        }
        return item && item.getContext('2d') || null;
      }
    };
    var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";
    var platform_dom$1 = /*#__PURE__*/Object.freeze({
      __proto__: null,
      'default': platform_dom
    });
    var stylesheet = getCjsExportFromNamespace(platform_dom$1);
    var EXPANDO_KEY = '$chartjs';
    var CSS_PREFIX = 'chartjs-';
    var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
    var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
    var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
    var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];
    var EVENT_TYPES = {
      touchstart: 'mousedown',
      touchmove: 'mousemove',
      touchend: 'mouseup',
      pointerenter: 'mouseenter',
      pointerdown: 'mousedown',
      pointermove: 'mousemove',
      pointerup: 'mouseup',
      pointerleave: 'mouseout',
      pointerout: 'mouseout'
    };
    function readUsedSize(element, property) {
      var value = helpers$1.getStyle(element, property);
      var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
      return matches ? Number(matches[1]) : undefined;
    }
    function initCanvas(canvas, config) {
      var style = canvas.style;
      var renderHeight = canvas.getAttribute('height');
      var renderWidth = canvas.getAttribute('width');
      canvas[EXPANDO_KEY] = {
        initial: {
          height: renderHeight,
          width: renderWidth,
          style: {
            display: style.display,
            height: style.height,
            width: style.width
          }
        }
      };
      style.display = style.display || 'block';
      if (renderWidth === null || renderWidth === '') {
        var displayWidth = readUsedSize(canvas, 'width');
        if (displayWidth !== undefined) {
          canvas.width = displayWidth;
        }
      }
      if (renderHeight === null || renderHeight === '') {
        if (canvas.style.height === '') {
          canvas.height = canvas.width / (config.options.aspectRatio || 2);
        } else {
          var displayHeight = readUsedSize(canvas, 'height');
          if (displayWidth !== undefined) {
            canvas.height = displayHeight;
          }
        }
      }
      return canvas;
    }
    var supportsEventListenerOptions = function () {
      var supports = false;
      try {
        var options = Object.defineProperty({}, 'passive', {
          get: function get() {
            supports = true;
          }
        });
        window.addEventListener('e', null, options);
      } catch (e) {}
      return supports;
    }();
    var eventListenerOptions = supportsEventListenerOptions ? {
      passive: true
    } : false;
    function addListener(node, type, listener) {
      node.addEventListener(type, listener, eventListenerOptions);
    }
    function removeListener(node, type, listener) {
      node.removeEventListener(type, listener, eventListenerOptions);
    }
    function createEvent(type, chart, x, y, nativeEvent) {
      return {
        type: type,
        chart: chart,
        "native": nativeEvent || null,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
      };
    }
    function fromNativeEvent(event, chart) {
      var type = EVENT_TYPES[event.type] || event.type;
      var pos = helpers$1.getRelativePosition(event, chart);
      return createEvent(type, chart, pos.x, pos.y, event);
    }
    function throttled(fn, thisArg) {
      var ticking = false;
      var args = [];
      return function () {
        args = Array.prototype.slice.call(arguments);
        thisArg = thisArg || this;
        if (!ticking) {
          ticking = true;
          helpers$1.requestAnimFrame.call(window, function () {
            ticking = false;
            fn.apply(thisArg, args);
          });
        }
      };
    }
    function createDiv(cls) {
      var el = document.createElement('div');
      el.className = cls || '';
      return el;
    }
    function createResizer(handler) {
      var maxSize = 1000000;
      var resizer = createDiv(CSS_SIZE_MONITOR);
      var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
      var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
      expand.appendChild(createDiv());
      shrink.appendChild(createDiv());
      resizer.appendChild(expand);
      resizer.appendChild(shrink);
      resizer._reset = function () {
        expand.scrollLeft = maxSize;
        expand.scrollTop = maxSize;
        shrink.scrollLeft = maxSize;
        shrink.scrollTop = maxSize;
      };
      var onScroll = function onScroll() {
        resizer._reset();
        handler();
      };
      addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
      addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
      return resizer;
    }
    function watchForRender(node, handler) {
      var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
      var proxy = expando.renderProxy = function (e) {
        if (e.animationName === CSS_RENDER_ANIMATION) {
          handler();
        }
      };
      helpers$1.each(ANIMATION_START_EVENTS, function (type) {
        addListener(node, type, proxy);
      });
      expando.reflow = !!node.offsetParent;
      node.classList.add(CSS_RENDER_MONITOR);
    }
    function unwatchForRender(node) {
      var expando = node[EXPANDO_KEY] || {};
      var proxy = expando.renderProxy;
      if (proxy) {
        helpers$1.each(ANIMATION_START_EVENTS, function (type) {
          removeListener(node, type, proxy);
        });
        delete expando.renderProxy;
      }
      node.classList.remove(CSS_RENDER_MONITOR);
    }
    function addResizeListener(node, listener, chart) {
      var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
      var resizer = expando.resizer = createResizer(throttled(function () {
        if (expando.resizer) {
          var container = chart.options.maintainAspectRatio && node.parentNode;
          var w = container ? container.clientWidth : 0;
          listener(createEvent('resize', chart));
          if (container && container.clientWidth < w && chart.canvas) {
            listener(createEvent('resize', chart));
          }
        }
      }));
      watchForRender(node, function () {
        if (expando.resizer) {
          var container = node.parentNode;
          if (container && container !== resizer.parentNode) {
            container.insertBefore(resizer, container.firstChild);
          }
          resizer._reset();
        }
      });
    }
    function removeResizeListener(node) {
      var expando = node[EXPANDO_KEY] || {};
      var resizer = expando.resizer;
      delete expando.resizer;
      unwatchForRender(node);
      if (resizer && resizer.parentNode) {
        resizer.parentNode.removeChild(resizer);
      }
    }
    function injectCSS(rootNode, css) {
      var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
      if (!expando.containsStyles) {
        expando.containsStyles = true;
        css = '/* Chart.js */\n' + css;
        var style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        style.appendChild(document.createTextNode(css));
        rootNode.appendChild(style);
      }
    }
    var platform_dom$2 = {
      disableCSSInjection: false,
      _enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
      _ensureLoaded: function _ensureLoaded(canvas) {
        if (!this.disableCSSInjection) {
          var root = canvas.getRootNode ? canvas.getRootNode() : document;
          var targetNode = root.host ? root : document.head;
          injectCSS(targetNode, stylesheet);
        }
      },
      acquireContext: function acquireContext(item, config) {
        if (typeof item === 'string') {
          item = document.getElementById(item);
        } else if (item.length) {
          item = item[0];
        }
        if (item && item.canvas) {
          item = item.canvas;
        }
        var context = item && item.getContext && item.getContext('2d');
        if (context && context.canvas === item) {
          this._ensureLoaded(item);
          initCanvas(item, config);
          return context;
        }
        return null;
      },
      releaseContext: function releaseContext(context) {
        var canvas = context.canvas;
        if (!canvas[EXPANDO_KEY]) {
          return;
        }
        var initial = canvas[EXPANDO_KEY].initial;
        ['height', 'width'].forEach(function (prop) {
          var value = initial[prop];
          if (helpers$1.isNullOrUndef(value)) {
            canvas.removeAttribute(prop);
          } else {
            canvas.setAttribute(prop, value);
          }
        });
        helpers$1.each(initial.style || {}, function (value, key) {
          canvas.style[key] = value;
        });
        canvas.width = canvas.width;
        delete canvas[EXPANDO_KEY];
      },
      addEventListener: function addEventListener(chart, type, listener) {
        var canvas = chart.canvas;
        if (type === 'resize') {
          addResizeListener(canvas, listener, chart);
          return;
        }
        var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
        var proxies = expando.proxies || (expando.proxies = {});
        var proxy = proxies[chart.id + '_' + type] = function (event) {
          listener(fromNativeEvent(event, chart));
        };
        addListener(canvas, type, proxy);
      },
      removeEventListener: function removeEventListener(chart, type, listener) {
        var canvas = chart.canvas;
        if (type === 'resize') {
          removeResizeListener(canvas);
          return;
        }
        var expando = listener[EXPANDO_KEY] || {};
        var proxies = expando.proxies || {};
        var proxy = proxies[chart.id + '_' + type];
        if (!proxy) {
          return;
        }
        removeListener(canvas, type, proxy);
      }
    };
    helpers$1.addEvent = addListener;
    helpers$1.removeEvent = removeListener;
    var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
    var platform = helpers$1.extend({
      initialize: function initialize() {},
      acquireContext: function acquireContext() {},
      releaseContext: function releaseContext() {},
      addEventListener: function addEventListener() {},
      removeEventListener: function removeEventListener() {}
    }, implementation);
    core_defaults._set('global', {
      plugins: {}
    });
    var core_plugins = {
      _plugins: [],
      _cacheId: 0,
      register: function register(plugins) {
        var p = this._plugins;
        [].concat(plugins).forEach(function (plugin) {
          if (p.indexOf(plugin) === -1) {
            p.push(plugin);
          }
        });
        this._cacheId++;
      },
      unregister: function unregister(plugins) {
        var p = this._plugins;
        [].concat(plugins).forEach(function (plugin) {
          var idx = p.indexOf(plugin);
          if (idx !== -1) {
            p.splice(idx, 1);
          }
        });
        this._cacheId++;
      },
      clear: function clear() {
        this._plugins = [];
        this._cacheId++;
      },
      count: function count() {
        return this._plugins.length;
      },
      getAll: function getAll() {
        return this._plugins;
      },
      notify: function notify(chart, hook, args) {
        var descriptors = this.descriptors(chart);
        var ilen = descriptors.length;
        var i, descriptor, plugin, params, method;
        for (i = 0; i < ilen; ++i) {
          descriptor = descriptors[i];
          plugin = descriptor.plugin;
          method = plugin[hook];
          if (typeof method === 'function') {
            params = [chart].concat(args || []);
            params.push(descriptor.options);
            if (method.apply(plugin, params) === false) {
              return false;
            }
          }
        }
        return true;
      },
      descriptors: function descriptors(chart) {
        var cache = chart.$plugins || (chart.$plugins = {});
        if (cache.id === this._cacheId) {
          return cache.descriptors;
        }
        var plugins = [];
        var descriptors = [];
        var config = chart && chart.config || {};
        var options = config.options && config.options.plugins || {};
        this._plugins.concat(config.plugins || []).forEach(function (plugin) {
          var idx = plugins.indexOf(plugin);
          if (idx !== -1) {
            return;
          }
          var id = plugin.id;
          var opts = options[id];
          if (opts === false) {
            return;
          }
          if (opts === true) {
            opts = helpers$1.clone(core_defaults.global.plugins[id]);
          }
          plugins.push(plugin);
          descriptors.push({
            plugin: plugin,
            options: opts || {}
          });
        });
        cache.descriptors = descriptors;
        cache.id = this._cacheId;
        return descriptors;
      },
      _invalidate: function _invalidate(chart) {
        delete chart.$plugins;
      }
    };
    var core_scaleService = {
      constructors: {},
      defaults: {},
      registerScaleType: function registerScaleType(type, scaleConstructor, scaleDefaults) {
        this.constructors[type] = scaleConstructor;
        this.defaults[type] = helpers$1.clone(scaleDefaults);
      },
      getScaleConstructor: function getScaleConstructor(type) {
        return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
      },
      getScaleDefaults: function getScaleDefaults(type) {
        return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
      },
      updateScaleDefaults: function updateScaleDefaults(type, additions) {
        var me = this;
        if (me.defaults.hasOwnProperty(type)) {
          me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
        }
      },
      addScalesToLayout: function addScalesToLayout(chart) {
        helpers$1.each(chart.scales, function (scale) {
          scale.fullWidth = scale.options.fullWidth;
          scale.position = scale.options.position;
          scale.weight = scale.options.weight;
          core_layouts.addBox(chart, scale);
        });
      }
    };
    var valueOrDefault$8 = helpers$1.valueOrDefault;
    var getRtlHelper = helpers$1.rtl.getRtlAdapter;
    core_defaults._set('global', {
      tooltips: {
        enabled: true,
        custom: null,
        mode: 'nearest',
        position: 'average',
        intersect: true,
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleFontStyle: 'bold',
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleFontColor: '#fff',
        titleAlign: 'left',
        bodySpacing: 2,
        bodyFontColor: '#fff',
        bodyAlign: 'left',
        footerFontStyle: 'bold',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFontColor: '#fff',
        footerAlign: 'left',
        yPadding: 6,
        xPadding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        multiKeyBackground: '#fff',
        displayColors: true,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        callbacks: {
          beforeTitle: helpers$1.noop,
          title: function title(tooltipItems, data) {
            var title = '';
            var labels = data.labels;
            var labelCount = labels ? labels.length : 0;
            if (tooltipItems.length > 0) {
              var item = tooltipItems[0];
              if (item.label) {
                title = item.label;
              } else if (item.xLabel) {
                title = item.xLabel;
              } else if (labelCount > 0 && item.index < labelCount) {
                title = labels[item.index];
              }
            }
            return title;
          },
          afterTitle: helpers$1.noop,
          beforeBody: helpers$1.noop,
          beforeLabel: helpers$1.noop,
          label: function label(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label || '';
            if (label) {
              label += ': ';
            }
            if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
              label += tooltipItem.value;
            } else {
              label += tooltipItem.yLabel;
            }
            return label;
          },
          labelColor: function labelColor(tooltipItem, chart) {
            var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
            var activeElement = meta.data[tooltipItem.index];
            var view = activeElement._view;
            return {
              borderColor: view.borderColor,
              backgroundColor: view.backgroundColor
            };
          },
          labelTextColor: function labelTextColor() {
            return this._options.bodyFontColor;
          },
          afterLabel: helpers$1.noop,
          afterBody: helpers$1.noop,
          beforeFooter: helpers$1.noop,
          footer: helpers$1.noop,
          afterFooter: helpers$1.noop
        }
      }
    });
    var positioners = {
      average: function average(elements) {
        if (!elements.length) {
          return false;
        }
        var i, len;
        var x = 0;
        var y = 0;
        var count = 0;
        for (i = 0, len = elements.length; i < len; ++i) {
          var el = elements[i];
          if (el && el.hasValue()) {
            var pos = el.tooltipPosition();
            x += pos.x;
            y += pos.y;
            ++count;
          }
        }
        return {
          x: x / count,
          y: y / count
        };
      },
      nearest: function nearest(elements, eventPosition) {
        var x = eventPosition.x;
        var y = eventPosition.y;
        var minDistance = Number.POSITIVE_INFINITY;
        var i, len, nearestElement;
        for (i = 0, len = elements.length; i < len; ++i) {
          var el = elements[i];
          if (el && el.hasValue()) {
            var center = el.getCenterPoint();
            var d = helpers$1.distanceBetweenPoints(eventPosition, center);
            if (d < minDistance) {
              minDistance = d;
              nearestElement = el;
            }
          }
        }
        if (nearestElement) {
          var tp = nearestElement.tooltipPosition();
          x = tp.x;
          y = tp.y;
        }
        return {
          x: x,
          y: y
        };
      }
    };
    function pushOrConcat(base, toPush) {
      if (toPush) {
        if (helpers$1.isArray(toPush)) {
          Array.prototype.push.apply(base, toPush);
        } else {
          base.push(toPush);
        }
      }
      return base;
    }
    function splitNewlines(str) {
      if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
        return str.split('\n');
      }
      return str;
    }
    function createTooltipItem(element) {
      var xScale = element._xScale;
      var yScale = element._yScale || element._scale;
      var index = element._index;
      var datasetIndex = element._datasetIndex;
      var controller = element._chart.getDatasetMeta(datasetIndex).controller;
      var indexScale = controller._getIndexScale();
      var valueScale = controller._getValueScale();
      return {
        xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
        yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
        label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
        value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
        index: index,
        datasetIndex: datasetIndex,
        x: element._model.x,
        y: element._model.y
      };
    }
    function getBaseModel(tooltipOpts) {
      var globalDefaults = core_defaults.global;
      return {
        xPadding: tooltipOpts.xPadding,
        yPadding: tooltipOpts.yPadding,
        xAlign: tooltipOpts.xAlign,
        yAlign: tooltipOpts.yAlign,
        rtl: tooltipOpts.rtl,
        textDirection: tooltipOpts.textDirection,
        bodyFontColor: tooltipOpts.bodyFontColor,
        _bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
        _bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
        _bodyAlign: tooltipOpts.bodyAlign,
        bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
        bodySpacing: tooltipOpts.bodySpacing,
        titleFontColor: tooltipOpts.titleFontColor,
        _titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
        _titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
        titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
        _titleAlign: tooltipOpts.titleAlign,
        titleSpacing: tooltipOpts.titleSpacing,
        titleMarginBottom: tooltipOpts.titleMarginBottom,
        footerFontColor: tooltipOpts.footerFontColor,
        _footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
        _footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
        footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
        _footerAlign: tooltipOpts.footerAlign,
        footerSpacing: tooltipOpts.footerSpacing,
        footerMarginTop: tooltipOpts.footerMarginTop,
        caretSize: tooltipOpts.caretSize,
        cornerRadius: tooltipOpts.cornerRadius,
        backgroundColor: tooltipOpts.backgroundColor,
        opacity: 0,
        legendColorBackground: tooltipOpts.multiKeyBackground,
        displayColors: tooltipOpts.displayColors,
        borderColor: tooltipOpts.borderColor,
        borderWidth: tooltipOpts.borderWidth
      };
    }
    function getTooltipSize(tooltip, model) {
      var ctx = tooltip._chart.ctx;
      var height = model.yPadding * 2;
      var width = 0;
      var body = model.body;
      var combinedBodyLength = body.reduce(function (count, bodyItem) {
        return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
      }, 0);
      combinedBodyLength += model.beforeBody.length + model.afterBody.length;
      var titleLineCount = model.title.length;
      var footerLineCount = model.footer.length;
      var titleFontSize = model.titleFontSize;
      var bodyFontSize = model.bodyFontSize;
      var footerFontSize = model.footerFontSize;
      height += titleLineCount * titleFontSize;
      height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0;
      height += titleLineCount ? model.titleMarginBottom : 0;
      height += combinedBodyLength * bodyFontSize;
      height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0;
      height += footerLineCount ? model.footerMarginTop : 0;
      height += footerLineCount * footerFontSize;
      height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0;
      var widthPadding = 0;
      var maxLineWidth = function maxLineWidth(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
      };
      ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
      helpers$1.each(model.title, maxLineWidth);
      ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
      helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
      widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
      helpers$1.each(body, function (bodyItem) {
        helpers$1.each(bodyItem.before, maxLineWidth);
        helpers$1.each(bodyItem.lines, maxLineWidth);
        helpers$1.each(bodyItem.after, maxLineWidth);
      });
      widthPadding = 0;
      ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
      helpers$1.each(model.footer, maxLineWidth);
      width += 2 * model.xPadding;
      return {
        width: width,
        height: height
      };
    }
    function determineAlignment(tooltip, size) {
      var model = tooltip._model;
      var chart = tooltip._chart;
      var chartArea = tooltip._chart.chartArea;
      var xAlign = 'center';
      var yAlign = 'center';
      if (model.y < size.height) {
        yAlign = 'top';
      } else if (model.y > chart.height - size.height) {
        yAlign = 'bottom';
      }
      var lf, rf;
      var olf, orf;
      var yf;
      var midX = (chartArea.left + chartArea.right) / 2;
      var midY = (chartArea.top + chartArea.bottom) / 2;
      if (yAlign === 'center') {
        lf = function lf(x) {
          return x <= midX;
        };
        rf = function rf(x) {
          return x > midX;
        };
      } else {
        lf = function lf(x) {
          return x <= size.width / 2;
        };
        rf = function rf(x) {
          return x >= chart.width - size.width / 2;
        };
      }
      olf = function olf(x) {
        return x + size.width + model.caretSize + model.caretPadding > chart.width;
      };
      orf = function orf(x) {
        return x - size.width - model.caretSize - model.caretPadding < 0;
      };
      yf = function yf(y) {
        return y <= midY ? 'top' : 'bottom';
      };
      if (lf(model.x)) {
        xAlign = 'left';
        if (olf(model.x)) {
          xAlign = 'center';
          yAlign = yf(model.y);
        }
      } else if (rf(model.x)) {
        xAlign = 'right';
        if (orf(model.x)) {
          xAlign = 'center';
          yAlign = yf(model.y);
        }
      }
      var opts = tooltip._options;
      return {
        xAlign: opts.xAlign ? opts.xAlign : xAlign,
        yAlign: opts.yAlign ? opts.yAlign : yAlign
      };
    }
    function getBackgroundPoint(vm, size, alignment, chart) {
      var x = vm.x;
      var y = vm.y;
      var caretSize = vm.caretSize;
      var caretPadding = vm.caretPadding;
      var cornerRadius = vm.cornerRadius;
      var xAlign = alignment.xAlign;
      var yAlign = alignment.yAlign;
      var paddingAndSize = caretSize + caretPadding;
      var radiusAndPadding = cornerRadius + caretPadding;
      if (xAlign === 'right') {
        x -= size.width;
      } else if (xAlign === 'center') {
        x -= size.width / 2;
        if (x + size.width > chart.width) {
          x = chart.width - size.width;
        }
        if (x < 0) {
          x = 0;
        }
      }
      if (yAlign === 'top') {
        y += paddingAndSize;
      } else if (yAlign === 'bottom') {
        y -= size.height + paddingAndSize;
      } else {
        y -= size.height / 2;
      }
      if (yAlign === 'center') {
        if (xAlign === 'left') {
          x += paddingAndSize;
        } else if (xAlign === 'right') {
          x -= paddingAndSize;
        }
      } else if (xAlign === 'left') {
        x -= radiusAndPadding;
      } else if (xAlign === 'right') {
        x += radiusAndPadding;
      }
      return {
        x: x,
        y: y
      };
    }
    function getAlignedX(vm, align) {
      return align === 'center' ? vm.x + vm.width / 2 : align === 'right' ? vm.x + vm.width - vm.xPadding : vm.x + vm.xPadding;
    }
    function getBeforeAfterBodyLines(callback) {
      return pushOrConcat([], splitNewlines(callback));
    }
    var exports$4 = core_element.extend({
      initialize: function initialize() {
        this._model = getBaseModel(this._options);
        this._lastActive = [];
      },
      getTitle: function getTitle() {
        var me = this;
        var opts = me._options;
        var callbacks = opts.callbacks;
        var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
        var title = callbacks.title.apply(me, arguments);
        var afterTitle = callbacks.afterTitle.apply(me, arguments);
        var lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeTitle));
        lines = pushOrConcat(lines, splitNewlines(title));
        lines = pushOrConcat(lines, splitNewlines(afterTitle));
        return lines;
      },
      getBeforeBody: function getBeforeBody() {
        return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
      },
      getBody: function getBody(tooltipItems, data) {
        var me = this;
        var callbacks = me._options.callbacks;
        var bodyItems = [];
        helpers$1.each(tooltipItems, function (tooltipItem) {
          var bodyItem = {
            before: [],
            lines: [],
            after: []
          };
          pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
          pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
          pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
          bodyItems.push(bodyItem);
        });
        return bodyItems;
      },
      getAfterBody: function getAfterBody() {
        return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
      },
      getFooter: function getFooter() {
        var me = this;
        var callbacks = me._options.callbacks;
        var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
        var footer = callbacks.footer.apply(me, arguments);
        var afterFooter = callbacks.afterFooter.apply(me, arguments);
        var lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeFooter));
        lines = pushOrConcat(lines, splitNewlines(footer));
        lines = pushOrConcat(lines, splitNewlines(afterFooter));
        return lines;
      },
      update: function update(changed) {
        var me = this;
        var opts = me._options;
        var existingModel = me._model;
        var model = me._model = getBaseModel(opts);
        var active = me._active;
        var data = me._data;
        var alignment = {
          xAlign: existingModel.xAlign,
          yAlign: existingModel.yAlign
        };
        var backgroundPoint = {
          x: existingModel.x,
          y: existingModel.y
        };
        var tooltipSize = {
          width: existingModel.width,
          height: existingModel.height
        };
        var tooltipPosition = {
          x: existingModel.caretX,
          y: existingModel.caretY
        };
        var i, len;
        if (active.length) {
          model.opacity = 1;
          var labelColors = [];
          var labelTextColors = [];
          tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
          var tooltipItems = [];
          for (i = 0, len = active.length; i < len; ++i) {
            tooltipItems.push(createTooltipItem(active[i]));
          }
          if (opts.filter) {
            tooltipItems = tooltipItems.filter(function (a) {
              return opts.filter(a, data);
            });
          }
          if (opts.itemSort) {
            tooltipItems = tooltipItems.sort(function (a, b) {
              return opts.itemSort(a, b, data);
            });
          }
          helpers$1.each(tooltipItems, function (tooltipItem) {
            labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
            labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
          });
          model.title = me.getTitle(tooltipItems, data);
          model.beforeBody = me.getBeforeBody(tooltipItems, data);
          model.body = me.getBody(tooltipItems, data);
          model.afterBody = me.getAfterBody(tooltipItems, data);
          model.footer = me.getFooter(tooltipItems, data);
          model.x = tooltipPosition.x;
          model.y = tooltipPosition.y;
          model.caretPadding = opts.caretPadding;
          model.labelColors = labelColors;
          model.labelTextColors = labelTextColors;
          model.dataPoints = tooltipItems;
          tooltipSize = getTooltipSize(this, model);
          alignment = determineAlignment(this, tooltipSize);
          backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
        } else {
          model.opacity = 0;
        }
        model.xAlign = alignment.xAlign;
        model.yAlign = alignment.yAlign;
        model.x = backgroundPoint.x;
        model.y = backgroundPoint.y;
        model.width = tooltipSize.width;
        model.height = tooltipSize.height;
        model.caretX = tooltipPosition.x;
        model.caretY = tooltipPosition.y;
        me._model = model;
        if (changed && opts.custom) {
          opts.custom.call(me, model);
        }
        return me;
      },
      drawCaret: function drawCaret(tooltipPoint, size) {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
      },
      getCaretPosition: function getCaretPosition(tooltipPoint, size, vm) {
        var x1, x2, x3, y1, y2, y3;
        var caretSize = vm.caretSize;
        var cornerRadius = vm.cornerRadius;
        var xAlign = vm.xAlign;
        var yAlign = vm.yAlign;
        var ptX = tooltipPoint.x;
        var ptY = tooltipPoint.y;
        var width = size.width;
        var height = size.height;
        if (yAlign === 'center') {
          y2 = ptY + height / 2;
          if (xAlign === 'left') {
            x1 = ptX;
            x2 = x1 - caretSize;
            x3 = x1;
            y1 = y2 + caretSize;
            y3 = y2 - caretSize;
          } else {
            x1 = ptX + width;
            x2 = x1 + caretSize;
            x3 = x1;
            y1 = y2 - caretSize;
            y3 = y2 + caretSize;
          }
        } else {
          if (xAlign === 'left') {
            x2 = ptX + cornerRadius + caretSize;
            x1 = x2 - caretSize;
            x3 = x2 + caretSize;
          } else if (xAlign === 'right') {
            x2 = ptX + width - cornerRadius - caretSize;
            x1 = x2 - caretSize;
            x3 = x2 + caretSize;
          } else {
            x2 = vm.caretX;
            x1 = x2 - caretSize;
            x3 = x2 + caretSize;
          }
          if (yAlign === 'top') {
            y1 = ptY;
            y2 = y1 - caretSize;
            y3 = y1;
          } else {
            y1 = ptY + height;
            y2 = y1 + caretSize;
            y3 = y1;
            var tmp = x3;
            x3 = x1;
            x1 = tmp;
          }
        }
        return {
          x1: x1,
          x2: x2,
          x3: x3,
          y1: y1,
          y2: y2,
          y3: y3
        };
      },
      drawTitle: function drawTitle(pt, vm, ctx) {
        var title = vm.title;
        var length = title.length;
        var titleFontSize, titleSpacing, i;
        if (length) {
          var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
          pt.x = getAlignedX(vm, vm._titleAlign);
          ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
          ctx.textBaseline = 'middle';
          titleFontSize = vm.titleFontSize;
          titleSpacing = vm.titleSpacing;
          ctx.fillStyle = vm.titleFontColor;
          ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
          for (i = 0; i < length; ++i) {
            ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
            pt.y += titleFontSize + titleSpacing;
            if (i + 1 === length) {
              pt.y += vm.titleMarginBottom - titleSpacing;
            }
          }
        }
      },
      drawBody: function drawBody(pt, vm, ctx) {
        var bodyFontSize = vm.bodyFontSize;
        var bodySpacing = vm.bodySpacing;
        var bodyAlign = vm._bodyAlign;
        var body = vm.body;
        var drawColorBoxes = vm.displayColors;
        var xLinePadding = 0;
        var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
        var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
        var fillLineOfText = function fillLineOfText(line) {
          ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
          pt.y += bodyFontSize + bodySpacing;
        };
        var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
        var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
        pt.x = getAlignedX(vm, bodyAlignForCalculation);
        ctx.fillStyle = vm.bodyFontColor;
        helpers$1.each(vm.beforeBody, fillLineOfText);
        xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? bodyFontSize / 2 + 1 : bodyFontSize + 2 : 0;
        for (i = 0, ilen = body.length; i < ilen; ++i) {
          bodyItem = body[i];
          textColor = vm.labelTextColors[i];
          labelColors = vm.labelColors[i];
          ctx.fillStyle = textColor;
          helpers$1.each(bodyItem.before, fillLineOfText);
          lines = bodyItem.lines;
          for (j = 0, jlen = lines.length; j < jlen; ++j) {
            if (drawColorBoxes) {
              var rtlColorX = rtlHelper.x(colorX);
              ctx.fillStyle = vm.legendColorBackground;
              ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
              ctx.lineWidth = 1;
              ctx.strokeStyle = labelColors.borderColor;
              ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
              ctx.fillStyle = labelColors.backgroundColor;
              ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
              ctx.fillStyle = textColor;
            }
            fillLineOfText(lines[j]);
          }
          helpers$1.each(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        helpers$1.each(vm.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
      },
      drawFooter: function drawFooter(pt, vm, ctx) {
        var footer = vm.footer;
        var length = footer.length;
        var footerFontSize, i;
        if (length) {
          var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
          pt.x = getAlignedX(vm, vm._footerAlign);
          pt.y += vm.footerMarginTop;
          ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
          ctx.textBaseline = 'middle';
          footerFontSize = vm.footerFontSize;
          ctx.fillStyle = vm.footerFontColor;
          ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
          for (i = 0; i < length; ++i) {
            ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
            pt.y += footerFontSize + vm.footerSpacing;
          }
        }
      },
      drawBackground: function drawBackground(pt, vm, ctx, tooltipSize) {
        ctx.fillStyle = vm.backgroundColor;
        ctx.strokeStyle = vm.borderColor;
        ctx.lineWidth = vm.borderWidth;
        var xAlign = vm.xAlign;
        var yAlign = vm.yAlign;
        var x = pt.x;
        var y = pt.y;
        var width = tooltipSize.width;
        var height = tooltipSize.height;
        var radius = vm.cornerRadius;
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        if (yAlign === 'top') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        if (yAlign === 'center' && xAlign === 'right') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        if (yAlign === 'bottom') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        if (yAlign === 'center' && xAlign === 'left') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
        ctx.fill();
        if (vm.borderWidth > 0) {
          ctx.stroke();
        }
      },
      draw: function draw() {
        var ctx = this._chart.ctx;
        var vm = this._view;
        if (vm.opacity === 0) {
          return;
        }
        var tooltipSize = {
          width: vm.width,
          height: vm.height
        };
        var pt = {
          x: vm.x,
          y: vm.y
        };
        var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
        var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
        if (this._options.enabled && hasTooltipContent) {
          ctx.save();
          ctx.globalAlpha = opacity;
          this.drawBackground(pt, vm, ctx, tooltipSize);
          pt.y += vm.yPadding;
          helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
          this.drawTitle(pt, vm, ctx);
          this.drawBody(pt, vm, ctx);
          this.drawFooter(pt, vm, ctx);
          helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
          ctx.restore();
        }
      },
      handleEvent: function handleEvent(e) {
        var me = this;
        var options = me._options;
        var changed = false;
        me._lastActive = me._lastActive || [];
        if (e.type === 'mouseout') {
          me._active = [];
        } else {
          me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
          if (options.reverse) {
            me._active.reverse();
          }
        }
        changed = !helpers$1.arrayEquals(me._active, me._lastActive);
        if (changed) {
          me._lastActive = me._active;
          if (options.enabled || options.custom) {
            me._eventPosition = {
              x: e.x,
              y: e.y
            };
            me.update(true);
            me.pivot();
          }
        }
        return changed;
      }
    });
    var positioners_1 = positioners;
    var core_tooltip = exports$4;
    core_tooltip.positioners = positioners_1;
    var valueOrDefault$9 = helpers$1.valueOrDefault;
    core_defaults._set('global', {
      elements: {},
      events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
      hover: {
        onHover: null,
        mode: 'nearest',
        intersect: true,
        animationDuration: 400
      },
      onClick: null,
      maintainAspectRatio: true,
      responsive: true,
      responsiveAnimationDuration: 0
    });
    function mergeScaleConfig() {
      return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
        merger: function merger(key, target, source, options) {
          if (key === 'xAxes' || key === 'yAxes') {
            var slen = source[key].length;
            var i, type, scale;
            if (!target[key]) {
              target[key] = [];
            }
            for (i = 0; i < slen; ++i) {
              scale = source[key][i];
              type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
              if (i >= target[key].length) {
                target[key].push({});
              }
              if (!target[key][i].type || scale.type && scale.type !== target[key][i].type) {
                helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
              } else {
                helpers$1.merge(target[key][i], scale);
              }
            }
          } else {
            helpers$1._merger(key, target, source, options);
          }
        }
      });
    }
    function mergeConfig() {
      return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
        merger: function merger(key, target, source, options) {
          var tval = target[key] || Object.create(null);
          var sval = source[key];
          if (key === 'scales') {
            target[key] = mergeScaleConfig(tval, sval);
          } else if (key === 'scale') {
            target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
          } else {
            helpers$1._merger(key, target, source, options);
          }
        }
      });
    }
    function initConfig(config) {
      config = config || Object.create(null);
      var data = config.data = config.data || {};
      data.datasets = data.datasets || [];
      data.labels = data.labels || [];
      config.options = mergeConfig(core_defaults.global, core_defaults[config.type], config.options || {});
      return config;
    }
    function updateConfig(chart) {
      var newOptions = chart.options;
      helpers$1.each(chart.scales, function (scale) {
        core_layouts.removeBox(chart, scale);
      });
      newOptions = mergeConfig(core_defaults.global, core_defaults[chart.config.type], newOptions);
      chart.options = chart.config.options = newOptions;
      chart.ensureScalesHaveIDs();
      chart.buildOrUpdateScales();
      chart.tooltip._options = newOptions.tooltips;
      chart.tooltip.initialize();
    }
    function nextAvailableScaleId(axesOpts, prefix, index) {
      var id;
      var hasId = function hasId(obj) {
        return obj.id === id;
      };
      do {
        id = prefix + index++;
      } while (helpers$1.findIndex(axesOpts, hasId) >= 0);
      return id;
    }
    function positionIsHorizontal(position) {
      return position === 'top' || position === 'bottom';
    }
    function compare2Level(l1, l2) {
      return function (a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
      };
    }
    var Chart = function Chart(item, config) {
      this.construct(item, config);
      return this;
    };
    helpers$1.extend(Chart.prototype, {
      construct: function construct(item, config) {
        var me = this;
        config = initConfig(config);
        var context = platform.acquireContext(item, config);
        var canvas = context && context.canvas;
        var height = canvas && canvas.height;
        var width = canvas && canvas.width;
        me.id = helpers$1.uid();
        me.ctx = context;
        me.canvas = canvas;
        me.config = config;
        me.width = width;
        me.height = height;
        me.aspectRatio = height ? width / height : null;
        me.options = config.options;
        me._bufferedRender = false;
        me._layers = [];
        me.chart = me;
        me.controller = me;
        Chart.instances[me.id] = me;
        Object.defineProperty(me, 'data', {
          get: function get() {
            return me.config.data;
          },
          set: function set(value) {
            me.config.data = value;
          }
        });
        if (!context || !canvas) {
          console.error("Failed to create chart: can't acquire context from the given item");
          return;
        }
        me.initialize();
        me.update();
      },
      initialize: function initialize() {
        var me = this;
        core_plugins.notify(me, 'beforeInit');
        helpers$1.retinaScale(me, me.options.devicePixelRatio);
        me.bindEvents();
        if (me.options.responsive) {
          me.resize(true);
        }
        me.initToolTip();
        core_plugins.notify(me, 'afterInit');
        return me;
      },
      clear: function clear() {
        helpers$1.canvas.clear(this);
        return this;
      },
      stop: function stop() {
        core_animations.cancelAnimation(this);
        return this;
      },
      resize: function resize(silent) {
        var me = this;
        var options = me.options;
        var canvas = me.canvas;
        var aspectRatio = options.maintainAspectRatio && me.aspectRatio || null;
        var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
        var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
        if (me.width === newWidth && me.height === newHeight) {
          return;
        }
        canvas.width = me.width = newWidth;
        canvas.height = me.height = newHeight;
        canvas.style.width = newWidth + 'px';
        canvas.style.height = newHeight + 'px';
        helpers$1.retinaScale(me, options.devicePixelRatio);
        if (!silent) {
          var newSize = {
            width: newWidth,
            height: newHeight
          };
          core_plugins.notify(me, 'resize', [newSize]);
          if (options.onResize) {
            options.onResize(me, newSize);
          }
          me.stop();
          me.update({
            duration: options.responsiveAnimationDuration
          });
        }
      },
      ensureScalesHaveIDs: function ensureScalesHaveIDs() {
        var options = this.options;
        var scalesOptions = options.scales || {};
        var scaleOptions = options.scale;
        helpers$1.each(scalesOptions.xAxes, function (xAxisOptions, index) {
          if (!xAxisOptions.id) {
            xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
          }
        });
        helpers$1.each(scalesOptions.yAxes, function (yAxisOptions, index) {
          if (!yAxisOptions.id) {
            yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
          }
        });
        if (scaleOptions) {
          scaleOptions.id = scaleOptions.id || 'scale';
        }
      },
      buildOrUpdateScales: function buildOrUpdateScales() {
        var me = this;
        var options = me.options;
        var scales = me.scales || {};
        var items = [];
        var updated = Object.keys(scales).reduce(function (obj, id) {
          obj[id] = false;
          return obj;
        }, {});
        if (options.scales) {
          items = items.concat((options.scales.xAxes || []).map(function (xAxisOptions) {
            return {
              options: xAxisOptions,
              dtype: 'category',
              dposition: 'bottom'
            };
          }), (options.scales.yAxes || []).map(function (yAxisOptions) {
            return {
              options: yAxisOptions,
              dtype: 'linear',
              dposition: 'left'
            };
          }));
        }
        if (options.scale) {
          items.push({
            options: options.scale,
            dtype: 'radialLinear',
            isDefault: true,
            dposition: 'chartArea'
          });
        }
        helpers$1.each(items, function (item) {
          var scaleOptions = item.options;
          var id = scaleOptions.id;
          var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
          if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
            scaleOptions.position = item.dposition;
          }
          updated[id] = true;
          var scale = null;
          if (id in scales && scales[id].type === scaleType) {
            scale = scales[id];
            scale.options = scaleOptions;
            scale.ctx = me.ctx;
            scale.chart = me;
          } else {
            var scaleClass = core_scaleService.getScaleConstructor(scaleType);
            if (!scaleClass) {
              return;
            }
            scale = new scaleClass({
              id: id,
              type: scaleType,
              options: scaleOptions,
              ctx: me.ctx,
              chart: me
            });
            scales[scale.id] = scale;
          }
          scale.mergeTicksOptions();
          if (item.isDefault) {
            me.scale = scale;
          }
        });
        helpers$1.each(updated, function (hasUpdated, id) {
          if (!hasUpdated) {
            delete scales[id];
          }
        });
        me.scales = scales;
        core_scaleService.addScalesToLayout(this);
      },
      buildOrUpdateControllers: function buildOrUpdateControllers() {
        var me = this;
        var newControllers = [];
        var datasets = me.data.datasets;
        var i, ilen;
        for (i = 0, ilen = datasets.length; i < ilen; i++) {
          var dataset = datasets[i];
          var meta = me.getDatasetMeta(i);
          var type = dataset.type || me.config.type;
          if (meta.type && meta.type !== type) {
            me.destroyDatasetMeta(i);
            meta = me.getDatasetMeta(i);
          }
          meta.type = type;
          meta.order = dataset.order || 0;
          meta.index = i;
          if (meta.controller) {
            meta.controller.updateIndex(i);
            meta.controller.linkScales();
          } else {
            var ControllerClass = controllers[meta.type];
            if (ControllerClass === undefined) {
              throw new Error('"' + meta.type + '" is not a chart type.');
            }
            meta.controller = new ControllerClass(me, i);
            newControllers.push(meta.controller);
          }
        }
        return newControllers;
      },
      resetElements: function resetElements() {
        var me = this;
        helpers$1.each(me.data.datasets, function (dataset, datasetIndex) {
          me.getDatasetMeta(datasetIndex).controller.reset();
        }, me);
      },
      reset: function reset() {
        this.resetElements();
        this.tooltip.initialize();
      },
      update: function update(config) {
        var me = this;
        var i, ilen;
        if (!config || typeof config !== 'object') {
          config = {
            duration: config,
            lazy: arguments[1]
          };
        }
        updateConfig(me);
        core_plugins._invalidate(me);
        if (core_plugins.notify(me, 'beforeUpdate') === false) {
          return;
        }
        me.tooltip._data = me.data;
        var newControllers = me.buildOrUpdateControllers();
        for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
          me.getDatasetMeta(i).controller.buildOrUpdateElements();
        }
        me.updateLayout();
        if (me.options.animation && me.options.animation.duration) {
          helpers$1.each(newControllers, function (controller) {
            controller.reset();
          });
        }
        me.updateDatasets();
        me.tooltip.initialize();
        me.lastActive = [];
        core_plugins.notify(me, 'afterUpdate');
        me._layers.sort(compare2Level('z', '_idx'));
        if (me._bufferedRender) {
          me._bufferedRequest = {
            duration: config.duration,
            easing: config.easing,
            lazy: config.lazy
          };
        } else {
          me.render(config);
        }
      },
      updateLayout: function updateLayout() {
        var me = this;
        if (core_plugins.notify(me, 'beforeLayout') === false) {
          return;
        }
        core_layouts.update(this, this.width, this.height);
        me._layers = [];
        helpers$1.each(me.boxes, function (box) {
          if (box._configure) {
            box._configure();
          }
          me._layers.push.apply(me._layers, box._layers());
        }, me);
        me._layers.forEach(function (item, index) {
          item._idx = index;
        });
        core_plugins.notify(me, 'afterScaleUpdate');
        core_plugins.notify(me, 'afterLayout');
      },
      updateDatasets: function updateDatasets() {
        var me = this;
        if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
          return;
        }
        for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
          me.updateDataset(i);
        }
        core_plugins.notify(me, 'afterDatasetsUpdate');
      },
      updateDataset: function updateDataset(index) {
        var me = this;
        var meta = me.getDatasetMeta(index);
        var args = {
          meta: meta,
          index: index
        };
        if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
          return;
        }
        meta.controller._update();
        core_plugins.notify(me, 'afterDatasetUpdate', [args]);
      },
      render: function render(config) {
        var me = this;
        if (!config || typeof config !== 'object') {
          config = {
            duration: config,
            lazy: arguments[1]
          };
        }
        var animationOptions = me.options.animation;
        var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
        var lazy = config.lazy;
        if (core_plugins.notify(me, 'beforeRender') === false) {
          return;
        }
        var onComplete = function onComplete(animation) {
          core_plugins.notify(me, 'afterRender');
          helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
        };
        if (animationOptions && duration) {
          var animation = new core_animation({
            numSteps: duration / 16.66,
            easing: config.easing || animationOptions.easing,
            render: function render(chart, animationObject) {
              var easingFunction = helpers$1.easing.effects[animationObject.easing];
              var currentStep = animationObject.currentStep;
              var stepDecimal = currentStep / animationObject.numSteps;
              chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
            },
            onAnimationProgress: animationOptions.onProgress,
            onAnimationComplete: onComplete
          });
          core_animations.addAnimation(me, animation, duration, lazy);
        } else {
          me.draw();
          onComplete(new core_animation({
            numSteps: 0,
            chart: me
          }));
        }
        return me;
      },
      draw: function draw(easingValue) {
        var me = this;
        var i, layers;
        me.clear();
        if (helpers$1.isNullOrUndef(easingValue)) {
          easingValue = 1;
        }
        me.transition(easingValue);
        if (me.width <= 0 || me.height <= 0) {
          return;
        }
        if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
          return;
        }
        layers = me._layers;
        for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
          layers[i].draw(me.chartArea);
        }
        me.drawDatasets(easingValue);
        for (; i < layers.length; ++i) {
          layers[i].draw(me.chartArea);
        }
        me._drawTooltip(easingValue);
        core_plugins.notify(me, 'afterDraw', [easingValue]);
      },
      transition: function transition(easingValue) {
        var me = this;
        for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
          if (me.isDatasetVisible(i)) {
            me.getDatasetMeta(i).controller.transition(easingValue);
          }
        }
        me.tooltip.transition(easingValue);
      },
      _getSortedDatasetMetas: function _getSortedDatasetMetas(filterVisible) {
        var me = this;
        var datasets = me.data.datasets || [];
        var result = [];
        var i, ilen;
        for (i = 0, ilen = datasets.length; i < ilen; ++i) {
          if (!filterVisible || me.isDatasetVisible(i)) {
            result.push(me.getDatasetMeta(i));
          }
        }
        result.sort(compare2Level('order', 'index'));
        return result;
      },
      _getSortedVisibleDatasetMetas: function _getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
      },
      drawDatasets: function drawDatasets(easingValue) {
        var me = this;
        var metasets, i;
        if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
          return;
        }
        metasets = me._getSortedVisibleDatasetMetas();
        for (i = metasets.length - 1; i >= 0; --i) {
          me.drawDataset(metasets[i], easingValue);
        }
        core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
      },
      drawDataset: function drawDataset(meta, easingValue) {
        var me = this;
        var args = {
          meta: meta,
          index: meta.index,
          easingValue: easingValue
        };
        if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
          return;
        }
        meta.controller.draw(easingValue);
        core_plugins.notify(me, 'afterDatasetDraw', [args]);
      },
      _drawTooltip: function _drawTooltip(easingValue) {
        var me = this;
        var tooltip = me.tooltip;
        var args = {
          tooltip: tooltip,
          easingValue: easingValue
        };
        if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
          return;
        }
        tooltip.draw();
        core_plugins.notify(me, 'afterTooltipDraw', [args]);
      },
      getElementAtEvent: function getElementAtEvent(e) {
        return core_interaction.modes.single(this, e);
      },
      getElementsAtEvent: function getElementsAtEvent(e) {
        return core_interaction.modes.label(this, e, {
          intersect: true
        });
      },
      getElementsAtXAxis: function getElementsAtXAxis(e) {
        return core_interaction.modes['x-axis'](this, e, {
          intersect: true
        });
      },
      getElementsAtEventForMode: function getElementsAtEventForMode(e, mode, options) {
        var method = core_interaction.modes[mode];
        if (typeof method === 'function') {
          return method(this, e, options);
        }
        return [];
      },
      getDatasetAtEvent: function getDatasetAtEvent(e) {
        return core_interaction.modes.dataset(this, e, {
          intersect: true
        });
      },
      getDatasetMeta: function getDatasetMeta(datasetIndex) {
        var me = this;
        var dataset = me.data.datasets[datasetIndex];
        if (!dataset._meta) {
          dataset._meta = {};
        }
        var meta = dataset._meta[me.id];
        if (!meta) {
          meta = dataset._meta[me.id] = {
            type: null,
            data: [],
            dataset: null,
            controller: null,
            hidden: null,
            xAxisID: null,
            yAxisID: null,
            order: dataset.order || 0,
            index: datasetIndex
          };
        }
        return meta;
      },
      getVisibleDatasetCount: function getVisibleDatasetCount() {
        var count = 0;
        for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
          if (this.isDatasetVisible(i)) {
            count++;
          }
        }
        return count;
      },
      isDatasetVisible: function isDatasetVisible(datasetIndex) {
        var meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
      },
      generateLegend: function generateLegend() {
        return this.options.legendCallback(this);
      },
      destroyDatasetMeta: function destroyDatasetMeta(datasetIndex) {
        var id = this.id;
        var dataset = this.data.datasets[datasetIndex];
        var meta = dataset._meta && dataset._meta[id];
        if (meta) {
          meta.controller.destroy();
          delete dataset._meta[id];
        }
      },
      destroy: function destroy() {
        var me = this;
        var canvas = me.canvas;
        var i, ilen;
        me.stop();
        for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
          me.destroyDatasetMeta(i);
        }
        if (canvas) {
          me.unbindEvents();
          helpers$1.canvas.clear(me);
          platform.releaseContext(me.ctx);
          me.canvas = null;
          me.ctx = null;
        }
        core_plugins.notify(me, 'destroy');
        delete Chart.instances[me.id];
      },
      toBase64Image: function toBase64Image() {
        return this.canvas.toDataURL.apply(this.canvas, arguments);
      },
      initToolTip: function initToolTip() {
        var me = this;
        me.tooltip = new core_tooltip({
          _chart: me,
          _chartInstance: me,
          _data: me.data,
          _options: me.options.tooltips
        }, me);
      },
      bindEvents: function bindEvents() {
        var me = this;
        var listeners = me._listeners = {};
        var listener = function listener() {
          me.eventHandler.apply(me, arguments);
        };
        helpers$1.each(me.options.events, function (type) {
          platform.addEventListener(me, type, listener);
          listeners[type] = listener;
        });
        if (me.options.responsive) {
          listener = function listener() {
            me.resize();
          };
          platform.addEventListener(me, 'resize', listener);
          listeners.resize = listener;
        }
      },
      unbindEvents: function unbindEvents() {
        var me = this;
        var listeners = me._listeners;
        if (!listeners) {
          return;
        }
        delete me._listeners;
        helpers$1.each(listeners, function (listener, type) {
          platform.removeEventListener(me, type, listener);
        });
      },
      updateHoverStyle: function updateHoverStyle(elements, mode, enabled) {
        var prefix = enabled ? 'set' : 'remove';
        var element, i, ilen;
        for (i = 0, ilen = elements.length; i < ilen; ++i) {
          element = elements[i];
          if (element) {
            this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
          }
        }
        if (mode === 'dataset') {
          this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
        }
      },
      eventHandler: function eventHandler(e) {
        var me = this;
        var tooltip = me.tooltip;
        if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
          return;
        }
        me._bufferedRender = true;
        me._bufferedRequest = null;
        var changed = me.handleEvent(e);
        if (tooltip) {
          changed = tooltip._start ? tooltip.handleEvent(e) : changed | tooltip.handleEvent(e);
        }
        core_plugins.notify(me, 'afterEvent', [e]);
        var bufferedRequest = me._bufferedRequest;
        if (bufferedRequest) {
          me.render(bufferedRequest);
        } else if (changed && !me.animating) {
          me.stop();
          me.render({
            duration: me.options.hover.animationDuration,
            lazy: true
          });
        }
        me._bufferedRender = false;
        me._bufferedRequest = null;
        return me;
      },
      handleEvent: function handleEvent(e) {
        var me = this;
        var options = me.options || {};
        var hoverOptions = options.hover;
        var changed = false;
        me.lastActive = me.lastActive || [];
        if (e.type === 'mouseout') {
          me.active = [];
        } else {
          me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
        }
        helpers$1.callback(options.onHover || options.hover.onHover, [e["native"], me.active], me);
        if (e.type === 'mouseup' || e.type === 'click') {
          if (options.onClick) {
            options.onClick.call(me, e["native"], me.active);
          }
        }
        if (me.lastActive.length) {
          me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
        }
        if (me.active.length && hoverOptions.mode) {
          me.updateHoverStyle(me.active, hoverOptions.mode, true);
        }
        changed = !helpers$1.arrayEquals(me.active, me.lastActive);
        me.lastActive = me.active;
        return changed;
      }
    });
    Chart.instances = {};
    var core_controller = Chart;
    Chart.Controller = Chart;
    Chart.types = {};
    helpers$1.configMerge = mergeConfig;
    helpers$1.scaleMerge = mergeScaleConfig;
    var core_helpers = function core_helpers() {
      helpers$1.where = function (collection, filterCallback) {
        if (helpers$1.isArray(collection) && Array.prototype.filter) {
          return collection.filter(filterCallback);
        }
        var filtered = [];
        helpers$1.each(collection, function (item) {
          if (filterCallback(item)) {
            filtered.push(item);
          }
        });
        return filtered;
      };
      helpers$1.findIndex = Array.prototype.findIndex ? function (array, callback, scope) {
        return array.findIndex(callback, scope);
      } : function (array, callback, scope) {
        scope = scope === undefined ? array : scope;
        for (var i = 0, ilen = array.length; i < ilen; ++i) {
          if (callback.call(scope, array[i], i, array)) {
            return i;
          }
        }
        return -1;
      };
      helpers$1.findNextWhere = function (arrayToSearch, filterCallback, startIndex) {
        if (helpers$1.isNullOrUndef(startIndex)) {
          startIndex = -1;
        }
        for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
          var currentItem = arrayToSearch[i];
          if (filterCallback(currentItem)) {
            return currentItem;
          }
        }
      };
      helpers$1.findPreviousWhere = function (arrayToSearch, filterCallback, startIndex) {
        if (helpers$1.isNullOrUndef(startIndex)) {
          startIndex = arrayToSearch.length;
        }
        for (var i = startIndex - 1; i >= 0; i--) {
          var currentItem = arrayToSearch[i];
          if (filterCallback(currentItem)) {
            return currentItem;
          }
        }
      };
      helpers$1.isNumber = function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
      };
      helpers$1.almostEquals = function (x, y, epsilon) {
        return Math.abs(x - y) < epsilon;
      };
      helpers$1.almostWhole = function (x, epsilon) {
        var rounded = Math.round(x);
        return rounded - epsilon <= x && rounded + epsilon >= x;
      };
      helpers$1.max = function (array) {
        return array.reduce(function (max, value) {
          if (!isNaN(value)) {
            return Math.max(max, value);
          }
          return max;
        }, Number.NEGATIVE_INFINITY);
      };
      helpers$1.min = function (array) {
        return array.reduce(function (min, value) {
          if (!isNaN(value)) {
            return Math.min(min, value);
          }
          return min;
        }, Number.POSITIVE_INFINITY);
      };
      helpers$1.sign = Math.sign ? function (x) {
        return Math.sign(x);
      } : function (x) {
        x = +x;
        if (x === 0 || isNaN(x)) {
          return x;
        }
        return x > 0 ? 1 : -1;
      };
      helpers$1.toRadians = function (degrees) {
        return degrees * (Math.PI / 180);
      };
      helpers$1.toDegrees = function (radians) {
        return radians * (180 / Math.PI);
      };
      helpers$1._decimalPlaces = function (x) {
        if (!helpers$1.isFinite(x)) {
          return;
        }
        var e = 1;
        var p = 0;
        while (Math.round(x * e) / e !== x) {
          e *= 10;
          p++;
        }
        return p;
      };
      helpers$1.getAngleFromPoint = function (centrePoint, anglePoint) {
        var distanceFromXCenter = anglePoint.x - centrePoint.x;
        var distanceFromYCenter = anglePoint.y - centrePoint.y;
        var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
        var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
        if (angle < -0.5 * Math.PI) {
          angle += 2.0 * Math.PI;
        }
        return {
          angle: angle,
          distance: radialDistanceFromCenter
        };
      };
      helpers$1.distanceBetweenPoints = function (pt1, pt2) {
        return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
      };
      helpers$1.aliasPixel = function (pixelWidth) {
        return pixelWidth % 2 === 0 ? 0 : 0.5;
      };
      helpers$1._alignPixel = function (chart, pixel, width) {
        var devicePixelRatio = chart.currentDevicePixelRatio;
        var halfWidth = width / 2;
        return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
      };
      helpers$1.splineCurve = function (firstPoint, middlePoint, afterPoint, t) {
        var previous = firstPoint.skip ? middlePoint : firstPoint;
        var current = middlePoint;
        var next = afterPoint.skip ? middlePoint : afterPoint;
        var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
        var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
        var s01 = d01 / (d01 + d12);
        var s12 = d12 / (d01 + d12);
        s01 = isNaN(s01) ? 0 : s01;
        s12 = isNaN(s12) ? 0 : s12;
        var fa = t * s01;
        var fb = t * s12;
        return {
          previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
          },
          next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
          }
        };
      };
      helpers$1.EPSILON = Number.EPSILON || 1e-14;
      helpers$1.splineCurveMonotone = function (points) {
        var pointsWithTangents = (points || []).map(function (point) {
          return {
            model: point._model,
            deltaK: 0,
            mK: 0
          };
        });
        var pointsLen = pointsWithTangents.length;
        var i, pointBefore, pointCurrent, pointAfter;
        for (i = 0; i < pointsLen; ++i) {
          pointCurrent = pointsWithTangents[i];
          if (pointCurrent.model.skip) {
            continue;
          }
          pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
          pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
          if (pointAfter && !pointAfter.model.skip) {
            var slopeDeltaX = pointAfter.model.x - pointCurrent.model.x;
            pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
          }
          if (!pointBefore || pointBefore.model.skip) {
            pointCurrent.mK = pointCurrent.deltaK;
          } else if (!pointAfter || pointAfter.model.skip) {
            pointCurrent.mK = pointBefore.deltaK;
          } else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
            pointCurrent.mK = 0;
          } else {
            pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
          }
        }
        var alphaK, betaK, tauK, squaredMagnitude;
        for (i = 0; i < pointsLen - 1; ++i) {
          pointCurrent = pointsWithTangents[i];
          pointAfter = pointsWithTangents[i + 1];
          if (pointCurrent.model.skip || pointAfter.model.skip) {
            continue;
          }
          if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
            pointCurrent.mK = pointAfter.mK = 0;
            continue;
          }
          alphaK = pointCurrent.mK / pointCurrent.deltaK;
          betaK = pointAfter.mK / pointCurrent.deltaK;
          squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
          if (squaredMagnitude <= 9) {
            continue;
          }
          tauK = 3 / Math.sqrt(squaredMagnitude);
          pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
          pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
        }
        var deltaX;
        for (i = 0; i < pointsLen; ++i) {
          pointCurrent = pointsWithTangents[i];
          if (pointCurrent.model.skip) {
            continue;
          }
          pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
          pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
          if (pointBefore && !pointBefore.model.skip) {
            deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
            pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
            pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
          }
          if (pointAfter && !pointAfter.model.skip) {
            deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
            pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
            pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
          }
        }
      };
      helpers$1.nextItem = function (collection, index, loop) {
        if (loop) {
          return index >= collection.length - 1 ? collection[0] : collection[index + 1];
        }
        return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
      };
      helpers$1.previousItem = function (collection, index, loop) {
        if (loop) {
          return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
        }
        return index <= 0 ? collection[0] : collection[index - 1];
      };
      helpers$1.niceNum = function (range, round) {
        var exponent = Math.floor(helpers$1.log10(range));
        var fraction = range / Math.pow(10, exponent);
        var niceFraction;
        if (round) {
          if (fraction < 1.5) {
            niceFraction = 1;
          } else if (fraction < 3) {
            niceFraction = 2;
          } else if (fraction < 7) {
            niceFraction = 5;
          } else {
            niceFraction = 10;
          }
        } else if (fraction <= 1.0) {
          niceFraction = 1;
        } else if (fraction <= 2) {
          niceFraction = 2;
        } else if (fraction <= 5) {
          niceFraction = 5;
        } else {
          niceFraction = 10;
        }
        return niceFraction * Math.pow(10, exponent);
      };
      helpers$1.requestAnimFrame = function () {
        if (typeof window === 'undefined') {
          return function (callback) {
            callback();
          };
        }
        return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
          return window.setTimeout(callback, 1000 / 60);
        };
      }();
      helpers$1.getRelativePosition = function (evt, chart) {
        var mouseX, mouseY;
        var e = evt.originalEvent || evt;
        var canvas = evt.target || evt.srcElement;
        var boundingRect = canvas.getBoundingClientRect();
        var touches = e.touches;
        if (touches && touches.length > 0) {
          mouseX = touches[0].clientX;
          mouseY = touches[0].clientY;
        } else {
          mouseX = e.clientX;
          mouseY = e.clientY;
        }
        var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
        var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
        var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
        var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
        var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
        var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
        mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / width * canvas.width / chart.currentDevicePixelRatio);
        mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / height * canvas.height / chart.currentDevicePixelRatio);
        return {
          x: mouseX,
          y: mouseY
        };
      };
      function parseMaxStyle(styleValue, node, parentProperty) {
        var valueInPixels;
        if (typeof styleValue === 'string') {
          valueInPixels = parseInt(styleValue, 10);
          if (styleValue.indexOf('%') !== -1) {
            valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
          }
        } else {
          valueInPixels = styleValue;
        }
        return valueInPixels;
      }
      function isConstrainedValue(value) {
        return value !== undefined && value !== null && value !== 'none';
      }
      function getConstraintDimension(domNode, maxStyle, percentageProperty) {
        var view = document.defaultView;
        var parentNode = helpers$1._getParentNode(domNode);
        var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
        var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
        var hasCNode = isConstrainedValue(constrainedNode);
        var hasCContainer = isConstrainedValue(constrainedContainer);
        var infinity = Number.POSITIVE_INFINITY;
        if (hasCNode || hasCContainer) {
          return Math.min(hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity, hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
        }
        return 'none';
      }
      helpers$1.getConstraintWidth = function (domNode) {
        return getConstraintDimension(domNode, 'max-width', 'clientWidth');
      };
      helpers$1.getConstraintHeight = function (domNode) {
        return getConstraintDimension(domNode, 'max-height', 'clientHeight');
      };
      helpers$1._calculatePadding = function (container, padding, parentDimension) {
        padding = helpers$1.getStyle(container, padding);
        return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
      };
      helpers$1._getParentNode = function (domNode) {
        var parent = domNode.parentNode;
        if (parent && parent.toString() === '[object ShadowRoot]') {
          parent = parent.host;
        }
        return parent;
      };
      helpers$1.getMaximumWidth = function (domNode) {
        var container = helpers$1._getParentNode(domNode);
        if (!container) {
          return domNode.clientWidth;
        }
        var clientWidth = container.clientWidth;
        var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
        var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
        var w = clientWidth - paddingLeft - paddingRight;
        var cw = helpers$1.getConstraintWidth(domNode);
        return isNaN(cw) ? w : Math.min(w, cw);
      };
      helpers$1.getMaximumHeight = function (domNode) {
        var container = helpers$1._getParentNode(domNode);
        if (!container) {
          return domNode.clientHeight;
        }
        var clientHeight = container.clientHeight;
        var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
        var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
        var h = clientHeight - paddingTop - paddingBottom;
        var ch = helpers$1.getConstraintHeight(domNode);
        return isNaN(ch) ? h : Math.min(h, ch);
      };
      helpers$1.getStyle = function (el, property) {
        return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
      };
      helpers$1.retinaScale = function (chart, forceRatio) {
        var pixelRatio = chart.currentDevicePixelRatio = forceRatio || typeof window !== 'undefined' && window.devicePixelRatio || 1;
        if (pixelRatio === 1) {
          return;
        }
        var canvas = chart.canvas;
        var height = chart.height;
        var width = chart.width;
        canvas.height = height * pixelRatio;
        canvas.width = width * pixelRatio;
        chart.ctx.scale(pixelRatio, pixelRatio);
        if (!canvas.style.height && !canvas.style.width) {
          canvas.style.height = height + 'px';
          canvas.style.width = width + 'px';
        }
      };
      helpers$1.fontString = function (pixelSize, fontStyle, fontFamily) {
        return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
      };
      helpers$1.longestText = function (ctx, font, arrayOfThings, cache) {
        cache = cache || {};
        var data = cache.data = cache.data || {};
        var gc = cache.garbageCollect = cache.garbageCollect || [];
        if (cache.font !== font) {
          data = cache.data = {};
          gc = cache.garbageCollect = [];
          cache.font = font;
        }
        ctx.font = font;
        var longest = 0;
        var ilen = arrayOfThings.length;
        var i, j, jlen, thing, nestedThing;
        for (i = 0; i < ilen; i++) {
          thing = arrayOfThings[i];
          if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
            longest = helpers$1.measureText(ctx, data, gc, longest, thing);
          } else if (helpers$1.isArray(thing)) {
            for (j = 0, jlen = thing.length; j < jlen; j++) {
              nestedThing = thing[j];
              if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
                longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
              }
            }
          }
        }
        var gcLen = gc.length / 2;
        if (gcLen > arrayOfThings.length) {
          for (i = 0; i < gcLen; i++) {
            delete data[gc[i]];
          }
          gc.splice(0, gcLen);
        }
        return longest;
      };
      helpers$1.measureText = function (ctx, data, gc, longest, string) {
        var textWidth = data[string];
        if (!textWidth) {
          textWidth = data[string] = ctx.measureText(string).width;
          gc.push(string);
        }
        if (textWidth > longest) {
          longest = textWidth;
        }
        return longest;
      };
      helpers$1.numberOfLabelLines = function (arrayOfThings) {
        var numberOfLines = 1;
        helpers$1.each(arrayOfThings, function (thing) {
          if (helpers$1.isArray(thing)) {
            if (thing.length > numberOfLines) {
              numberOfLines = thing.length;
            }
          }
        });
        return numberOfLines;
      };
      helpers$1.color = !chartjsColor ? function (value) {
        console.error('Color.js not found!');
        return value;
      } : function (value) {
        if (value instanceof CanvasGradient) {
          value = core_defaults.global.defaultColor;
        }
        return chartjsColor(value);
      };
      helpers$1.getHoverColor = function (colorValue) {
        return colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient ? colorValue : helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
      };
    };
    function _abstract() {
      throw new Error('This method is not implemented: either no adapter can ' + 'be found or an incomplete integration was provided.');
    }
    function DateAdapter(options) {
      this.options = options || {};
    }
    helpers$1.extend(DateAdapter.prototype, {
      formats: _abstract,
      parse: _abstract,
      format: _abstract,
      add: _abstract,
      diff: _abstract,
      startOf: _abstract,
      endOf: _abstract,
      _create: function _create(value) {
        return value;
      }
    });
    DateAdapter.override = function (members) {
      helpers$1.extend(DateAdapter.prototype, members);
    };
    var _date = DateAdapter;
    var core_adapters = {
      _date: _date
    };
    var core_ticks = {
      formatters: {
        values: function values(value) {
          return helpers$1.isArray(value) ? value : '' + value;
        },
        linear: function linear(tickValue, index, ticks) {
          var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
          if (Math.abs(delta) > 1) {
            if (tickValue !== Math.floor(tickValue)) {
              delta = tickValue - Math.floor(tickValue);
            }
          }
          var logDelta = helpers$1.log10(Math.abs(delta));
          var tickString = '';
          if (tickValue !== 0) {
            var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
            if (maxTick < 1e-4) {
              var logTick = helpers$1.log10(Math.abs(tickValue));
              var numExponential = Math.floor(logTick) - Math.floor(logDelta);
              numExponential = Math.max(Math.min(numExponential, 20), 0);
              tickString = tickValue.toExponential(numExponential);
            } else {
              var numDecimal = -1 * Math.floor(logDelta);
              numDecimal = Math.max(Math.min(numDecimal, 20), 0);
              tickString = tickValue.toFixed(numDecimal);
            }
          } else {
            tickString = '0';
          }
          return tickString;
        },
        logarithmic: function logarithmic(tickValue, index, ticks) {
          var remain = tickValue / Math.pow(10, Math.floor(helpers$1.log10(tickValue)));
          if (tickValue === 0) {
            return '0';
          } else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
            return tickValue.toExponential();
          }
          return '';
        }
      }
    };
    var isArray = helpers$1.isArray;
    var isNullOrUndef = helpers$1.isNullOrUndef;
    var valueOrDefault$a = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
    core_defaults._set('scale', {
      display: true,
      position: 'left',
      offset: false,
      gridLines: {
        display: true,
        color: 'rgba(0,0,0,0.1)',
        lineWidth: 1,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true,
        tickMarkLength: 10,
        zeroLineWidth: 1,
        zeroLineColor: 'rgba(0,0,0,0.25)',
        zeroLineBorderDash: [],
        zeroLineBorderDashOffset: 0.0,
        offsetGridLines: false,
        borderDash: [],
        borderDashOffset: 0.0
      },
      scaleLabel: {
        display: false,
        labelString: '',
        padding: {
          top: 4,
          bottom: 4
        }
      },
      ticks: {
        beginAtZero: false,
        minRotation: 0,
        maxRotation: 50,
        mirror: false,
        padding: 0,
        reverse: false,
        display: true,
        autoSkip: true,
        autoSkipPadding: 0,
        labelOffset: 0,
        callback: core_ticks.formatters.values,
        minor: {},
        major: {}
      }
    });
    function sample(arr, numItems) {
      var result = [];
      var increment = arr.length / numItems;
      var i = 0;
      var len = arr.length;
      for (; i < len; i += increment) {
        result.push(arr[Math.floor(i)]);
      }
      return result;
    }
    function getPixelForGridLine(scale, index, offsetGridLines) {
      var length = scale.getTicks().length;
      var validIndex = Math.min(index, length - 1);
      var lineValue = scale.getPixelForTick(validIndex);
      var start = scale._startPixel;
      var end = scale._endPixel;
      var epsilon = 1e-6;
      var offset;
      if (offsetGridLines) {
        if (length === 1) {
          offset = Math.max(lineValue - start, end - lineValue);
        } else if (index === 0) {
          offset = (scale.getPixelForTick(1) - lineValue) / 2;
        } else {
          offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        }
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) {
          return;
        }
      }
      return lineValue;
    }
    function garbageCollect(caches, length) {
      helpers$1.each(caches, function (cache) {
        var gc = cache.gc;
        var gcLen = gc.length / 2;
        var i;
        if (gcLen > length) {
          for (i = 0; i < gcLen; ++i) {
            delete cache.data[gc[i]];
          }
          gc.splice(0, gcLen);
        }
      });
    }
    function computeLabelSizes(ctx, tickFonts, ticks, caches) {
      var length = ticks.length;
      var widths = [];
      var heights = [];
      var offsets = [];
      var widestLabelSize = 0;
      var highestLabelSize = 0;
      var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
      for (i = 0; i < length; ++i) {
        label = ticks[i].label;
        tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
        ctx.font = fontString = tickFont.string;
        cache = caches[fontString] = caches[fontString] || {
          data: {},
          gc: []
        };
        lineHeight = tickFont.lineHeight;
        width = height = 0;
        if (!isNullOrUndef(label) && !isArray(label)) {
          width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
          height = lineHeight;
        } else if (isArray(label)) {
          for (j = 0, jlen = label.length; j < jlen; ++j) {
            nestedLabel = label[j];
            if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
              width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
              height += lineHeight;
            }
          }
        }
        widths.push(width);
        heights.push(height);
        offsets.push(lineHeight / 2);
        widestLabelSize = Math.max(width, widestLabelSize);
        highestLabelSize = Math.max(height, highestLabelSize);
      }
      garbageCollect(caches, length);
      widest = widths.indexOf(widestLabelSize);
      highest = heights.indexOf(highestLabelSize);
      function valueAt(idx) {
        return {
          width: widths[idx] || 0,
          height: heights[idx] || 0,
          offset: offsets[idx] || 0
        };
      }
      return {
        first: valueAt(0),
        last: valueAt(length - 1),
        widest: valueAt(widest),
        highest: valueAt(highest)
      };
    }
    function getTickMarkLength(options) {
      return options.drawTicks ? options.tickMarkLength : 0;
    }
    function getScaleLabelHeight(options) {
      var font, padding;
      if (!options.display) {
        return 0;
      }
      font = helpers$1.options._parseFont(options);
      padding = helpers$1.options.toPadding(options.padding);
      return font.lineHeight + padding.height;
    }
    function parseFontOptions(options, nestedOpts) {
      return helpers$1.extend(helpers$1.options._parseFont({
        fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
        fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
        fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
        lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
      }), {
        color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
      });
    }
    function parseTickFontOptions(options) {
      var minor = parseFontOptions(options, options.minor);
      var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
      return {
        minor: minor,
        major: major
      };
    }
    function nonSkipped(ticksToFilter) {
      var filtered = [];
      var item, index, len;
      for (index = 0, len = ticksToFilter.length; index < len; ++index) {
        item = ticksToFilter[index];
        if (typeof item._index !== 'undefined') {
          filtered.push(item);
        }
      }
      return filtered;
    }
    function getEvenSpacing(arr) {
      var len = arr.length;
      var i, diff;
      if (len < 2) {
        return false;
      }
      for (diff = arr[0], i = 1; i < len; ++i) {
        if (arr[i] - arr[i - 1] !== diff) {
          return false;
        }
      }
      return diff;
    }
    function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
      var evenMajorSpacing = getEvenSpacing(majorIndices);
      var spacing = (ticks.length - 1) / ticksLimit;
      var factors, factor, i, ilen;
      if (!evenMajorSpacing) {
        return Math.max(spacing, 1);
      }
      factors = helpers$1.math._factorize(evenMajorSpacing);
      for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
        factor = factors[i];
        if (factor > spacing) {
          return factor;
        }
      }
      return Math.max(spacing, 1);
    }
    function getMajorIndices(ticks) {
      var result = [];
      var i, ilen;
      for (i = 0, ilen = ticks.length; i < ilen; i++) {
        if (ticks[i].major) {
          result.push(i);
        }
      }
      return result;
    }
    function skipMajors(ticks, majorIndices, spacing) {
      var count = 0;
      var next = majorIndices[0];
      var i, tick;
      spacing = Math.ceil(spacing);
      for (i = 0; i < ticks.length; i++) {
        tick = ticks[i];
        if (i === next) {
          tick._index = i;
          count++;
          next = majorIndices[count * spacing];
        } else {
          delete tick.label;
        }
      }
    }
    function skip(ticks, spacing, majorStart, majorEnd) {
      var start = valueOrDefault$a(majorStart, 0);
      var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
      var count = 0;
      var length, i, tick, next;
      spacing = Math.ceil(spacing);
      if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
      }
      next = start;
      while (next < 0) {
        count++;
        next = Math.round(start + count * spacing);
      }
      for (i = Math.max(start, 0); i < end; i++) {
        tick = ticks[i];
        if (i === next) {
          tick._index = i;
          count++;
          next = Math.round(start + count * spacing);
        } else {
          delete tick.label;
        }
      }
    }
    var Scale = core_element.extend({
      zeroLineIndex: 0,
      getPadding: function getPadding() {
        var me = this;
        return {
          left: me.paddingLeft || 0,
          top: me.paddingTop || 0,
          right: me.paddingRight || 0,
          bottom: me.paddingBottom || 0
        };
      },
      getTicks: function getTicks() {
        return this._ticks;
      },
      _getLabels: function _getLabels() {
        var data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
      },
      mergeTicksOptions: function mergeTicksOptions() {},
      beforeUpdate: function beforeUpdate() {
        helpers$1.callback(this.options.beforeUpdate, [this]);
      },
      update: function update(maxWidth, maxHeight, margins) {
        var me = this;
        var tickOpts = me.options.ticks;
        var sampleSize = tickOpts.sampleSize;
        var i, ilen, labels, ticks, samplingEnabled;
        me.beforeUpdate();
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me.margins = helpers$1.extend({
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }, margins);
        me._ticks = null;
        me.ticks = null;
        me._labelSizes = null;
        me._maxLabelLines = 0;
        me.longestLabelWidth = 0;
        me.longestTextCache = me.longestTextCache || {};
        me._gridLineItems = null;
        me._labelItems = null;
        me.beforeSetDimensions();
        me.setDimensions();
        me.afterSetDimensions();
        me.beforeDataLimits();
        me.determineDataLimits();
        me.afterDataLimits();
        me.beforeBuildTicks();
        ticks = me.buildTicks() || [];
        ticks = me.afterBuildTicks(ticks) || ticks;
        if ((!ticks || !ticks.length) && me.ticks) {
          ticks = [];
          for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
            ticks.push({
              value: me.ticks[i],
              major: false
            });
          }
        }
        me._ticks = ticks;
        samplingEnabled = sampleSize < ticks.length;
        labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
        me._configure();
        me.beforeCalculateTickRotation();
        me.calculateTickRotation();
        me.afterCalculateTickRotation();
        me.beforeFit();
        me.fit();
        me.afterFit();
        me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
        if (samplingEnabled) {
          labels = me._convertTicksToLabels(me._ticksToDraw);
        }
        me.ticks = labels;
        me.afterUpdate();
        return me.minSize;
      },
      _configure: function _configure() {
        var me = this;
        var reversePixels = me.options.ticks.reverse;
        var startPixel, endPixel;
        if (me.isHorizontal()) {
          startPixel = me.left;
          endPixel = me.right;
        } else {
          startPixel = me.top;
          endPixel = me.bottom;
          reversePixels = !reversePixels;
        }
        me._startPixel = startPixel;
        me._endPixel = endPixel;
        me._reversePixels = reversePixels;
        me._length = endPixel - startPixel;
      },
      afterUpdate: function afterUpdate() {
        helpers$1.callback(this.options.afterUpdate, [this]);
      },
      beforeSetDimensions: function beforeSetDimensions() {
        helpers$1.callback(this.options.beforeSetDimensions, [this]);
      },
      setDimensions: function setDimensions() {
        var me = this;
        if (me.isHorizontal()) {
          me.width = me.maxWidth;
          me.left = 0;
          me.right = me.width;
        } else {
          me.height = me.maxHeight;
          me.top = 0;
          me.bottom = me.height;
        }
        me.paddingLeft = 0;
        me.paddingTop = 0;
        me.paddingRight = 0;
        me.paddingBottom = 0;
      },
      afterSetDimensions: function afterSetDimensions() {
        helpers$1.callback(this.options.afterSetDimensions, [this]);
      },
      beforeDataLimits: function beforeDataLimits() {
        helpers$1.callback(this.options.beforeDataLimits, [this]);
      },
      determineDataLimits: helpers$1.noop,
      afterDataLimits: function afterDataLimits() {
        helpers$1.callback(this.options.afterDataLimits, [this]);
      },
      beforeBuildTicks: function beforeBuildTicks() {
        helpers$1.callback(this.options.beforeBuildTicks, [this]);
      },
      buildTicks: helpers$1.noop,
      afterBuildTicks: function afterBuildTicks(ticks) {
        var me = this;
        if (isArray(ticks) && ticks.length) {
          return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
        }
        me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
        return ticks;
      },
      beforeTickToLabelConversion: function beforeTickToLabelConversion() {
        helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
      },
      convertTicksToLabels: function convertTicksToLabels() {
        var me = this;
        var tickOpts = me.options.ticks;
        me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
      },
      afterTickToLabelConversion: function afterTickToLabelConversion() {
        helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
      },
      beforeCalculateTickRotation: function beforeCalculateTickRotation() {
        helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
      },
      calculateTickRotation: function calculateTickRotation() {
        var me = this;
        var options = me.options;
        var tickOpts = options.ticks;
        var numTicks = me.getTicks().length;
        var minRotation = tickOpts.minRotation || 0;
        var maxRotation = tickOpts.maxRotation;
        var labelRotation = minRotation;
        var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
        if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
          me.labelRotation = minRotation;
          return;
        }
        labelSizes = me._getLabelSizes();
        maxLabelWidth = labelSizes.widest.width;
        maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
        maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
        tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
          tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
          maxHeight = me.maxHeight - getTickMarkLength(options.gridLines) - tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
          maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
          labelRotation = helpers$1.toDegrees(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
          labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        me.labelRotation = labelRotation;
      },
      afterCalculateTickRotation: function afterCalculateTickRotation() {
        helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
      },
      beforeFit: function beforeFit() {
        helpers$1.callback(this.options.beforeFit, [this]);
      },
      fit: function fit() {
        var me = this;
        var minSize = me.minSize = {
          width: 0,
          height: 0
        };
        var chart = me.chart;
        var opts = me.options;
        var tickOpts = opts.ticks;
        var scaleLabelOpts = opts.scaleLabel;
        var gridLineOpts = opts.gridLines;
        var display = me._isVisible();
        var isBottom = opts.position === 'bottom';
        var isHorizontal = me.isHorizontal();
        if (isHorizontal) {
          minSize.width = me.maxWidth;
        } else if (display) {
          minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
        }
        if (!isHorizontal) {
          minSize.height = me.maxHeight;
        } else if (display) {
          minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
        }
        if (tickOpts.display && display) {
          var tickFonts = parseTickFontOptions(tickOpts);
          var labelSizes = me._getLabelSizes();
          var firstLabelSize = labelSizes.first;
          var lastLabelSize = labelSizes.last;
          var widestLabelSize = labelSizes.widest;
          var highestLabelSize = labelSizes.highest;
          var lineSpace = tickFonts.minor.lineHeight * 0.4;
          var tickPadding = tickOpts.padding;
          if (isHorizontal) {
            var isRotated = me.labelRotation !== 0;
            var angleRadians = helpers$1.toRadians(me.labelRotation);
            var cosRotation = Math.cos(angleRadians);
            var sinRotation = Math.sin(angleRadians);
            var labelHeight = sinRotation * widestLabelSize.width + cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0)) + (isRotated ? 0 : lineSpace);
            minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
            var offsetLeft = me.getPixelForTick(0) - me.left;
            var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
            var paddingLeft, paddingRight;
            if (isRotated) {
              paddingLeft = isBottom ? cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset : sinRotation * (firstLabelSize.height - firstLabelSize.offset);
              paddingRight = isBottom ? sinRotation * (lastLabelSize.height - lastLabelSize.offset) : cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
            } else {
              paddingLeft = firstLabelSize.width / 2;
              paddingRight = lastLabelSize.width / 2;
            }
            me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
            me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
          } else {
            var labelWidth = tickOpts.mirror ? 0 : widestLabelSize.width + tickPadding + lineSpace;
            minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
            me.paddingTop = firstLabelSize.height / 2;
            me.paddingBottom = lastLabelSize.height / 2;
          }
        }
        me.handleMargins();
        if (isHorizontal) {
          me.width = me._length = chart.width - me.margins.left - me.margins.right;
          me.height = minSize.height;
        } else {
          me.width = minSize.width;
          me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
        }
      },
      handleMargins: function handleMargins() {
        var me = this;
        if (me.margins) {
          me.margins.left = Math.max(me.paddingLeft, me.margins.left);
          me.margins.top = Math.max(me.paddingTop, me.margins.top);
          me.margins.right = Math.max(me.paddingRight, me.margins.right);
          me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
        }
      },
      afterFit: function afterFit() {
        helpers$1.callback(this.options.afterFit, [this]);
      },
      isHorizontal: function isHorizontal() {
        var pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
      },
      isFullWidth: function isFullWidth() {
        return this.options.fullWidth;
      },
      getRightValue: function getRightValue(rawValue) {
        if (isNullOrUndef(rawValue)) {
          return NaN;
        }
        if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
          return NaN;
        }
        if (rawValue) {
          if (this.isHorizontal()) {
            if (rawValue.x !== undefined) {
              return this.getRightValue(rawValue.x);
            }
          } else if (rawValue.y !== undefined) {
            return this.getRightValue(rawValue.y);
          }
        }
        return rawValue;
      },
      _convertTicksToLabels: function _convertTicksToLabels(ticks) {
        var me = this;
        var labels, i, ilen;
        me.ticks = ticks.map(function (tick) {
          return tick.value;
        });
        me.beforeTickToLabelConversion();
        labels = me.convertTicksToLabels(ticks) || me.ticks;
        me.afterTickToLabelConversion();
        for (i = 0, ilen = ticks.length; i < ilen; ++i) {
          ticks[i].label = labels[i];
        }
        return labels;
      },
      _getLabelSizes: function _getLabelSizes() {
        var me = this;
        var labelSizes = me._labelSizes;
        if (!labelSizes) {
          me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
          me.longestLabelWidth = labelSizes.widest.width;
        }
        return labelSizes;
      },
      _parseValue: function _parseValue(value) {
        var start, end, min, max;
        if (isArray(value)) {
          start = +this.getRightValue(value[0]);
          end = +this.getRightValue(value[1]);
          min = Math.min(start, end);
          max = Math.max(start, end);
        } else {
          value = +this.getRightValue(value);
          start = undefined;
          end = value;
          min = value;
          max = value;
        }
        return {
          min: min,
          max: max,
          start: start,
          end: end
        };
      },
      _getScaleLabel: function _getScaleLabel(rawValue) {
        var v = this._parseValue(rawValue);
        if (v.start !== undefined) {
          return '[' + v.start + ', ' + v.end + ']';
        }
        return +this.getRightValue(rawValue);
      },
      getLabelForIndex: helpers$1.noop,
      getPixelForValue: helpers$1.noop,
      getValueForPixel: helpers$1.noop,
      getPixelForTick: function getPixelForTick(index) {
        var me = this;
        var offset = me.options.offset;
        var numTicks = me._ticks.length;
        var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
        return index < 0 || index > numTicks - 1 ? null : me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
      },
      getPixelForDecimal: function getPixelForDecimal(decimal) {
        var me = this;
        if (me._reversePixels) {
          decimal = 1 - decimal;
        }
        return me._startPixel + decimal * me._length;
      },
      getDecimalForPixel: function getDecimalForPixel(pixel) {
        var decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
      },
      getBasePixel: function getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
      },
      getBaseValue: function getBaseValue() {
        var me = this;
        var min = me.min;
        var max = me.max;
        return me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
      },
      _autoSkip: function _autoSkip(ticks) {
        var me = this;
        var tickOpts = me.options.ticks;
        var axisLength = me._length;
        var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
        var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
        var numMajorIndices = majorIndices.length;
        var first = majorIndices[0];
        var last = majorIndices[numMajorIndices - 1];
        var i, ilen, spacing, avgMajorSpacing;
        if (numMajorIndices > ticksLimit) {
          skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
          return nonSkipped(ticks);
        }
        spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
        if (numMajorIndices > 0) {
          for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
            skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
          }
          avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
          skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
          skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
          return nonSkipped(ticks);
        }
        skip(ticks, spacing);
        return nonSkipped(ticks);
      },
      _tickSize: function _tickSize() {
        var me = this;
        var optionTicks = me.options.ticks;
        var rot = helpers$1.toRadians(me.labelRotation);
        var cos = Math.abs(Math.cos(rot));
        var sin = Math.abs(Math.sin(rot));
        var labelSizes = me._getLabelSizes();
        var padding = optionTicks.autoSkipPadding || 0;
        var w = labelSizes ? labelSizes.widest.width + padding : 0;
        var h = labelSizes ? labelSizes.highest.height + padding : 0;
        return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
      },
      _isVisible: function _isVisible() {
        var me = this;
        var chart = me.chart;
        var display = me.options.display;
        var i, ilen, meta;
        if (display !== 'auto') {
          return !!display;
        }
        for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
          if (chart.isDatasetVisible(i)) {
            meta = chart.getDatasetMeta(i);
            if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
              return true;
            }
          }
        }
        return false;
      },
      _computeGridLineItems: function _computeGridLineItems(chartArea) {
        var me = this;
        var chart = me.chart;
        var options = me.options;
        var gridLines = options.gridLines;
        var position = options.position;
        var offsetGridLines = gridLines.offsetGridLines;
        var isHorizontal = me.isHorizontal();
        var ticks = me._ticksToDraw;
        var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
        var tl = getTickMarkLength(gridLines);
        var items = [];
        var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
        var axisHalfWidth = axisWidth / 2;
        var alignPixel = helpers$1._alignPixel;
        var alignBorderValue = function alignBorderValue(pixel) {
          return alignPixel(chart, pixel, axisWidth);
        };
        var borderValue, i, tick, lineValue, alignedLineValue;
        var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
        if (position === 'top') {
          borderValue = alignBorderValue(me.bottom);
          ty1 = me.bottom - tl;
          ty2 = borderValue - axisHalfWidth;
          y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
          y2 = chartArea.bottom;
        } else if (position === 'bottom') {
          borderValue = alignBorderValue(me.top);
          y1 = chartArea.top;
          y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
          ty1 = borderValue + axisHalfWidth;
          ty2 = me.top + tl;
        } else if (position === 'left') {
          borderValue = alignBorderValue(me.right);
          tx1 = me.right - tl;
          tx2 = borderValue - axisHalfWidth;
          x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
          x2 = chartArea.right;
        } else {
          borderValue = alignBorderValue(me.left);
          x1 = chartArea.left;
          x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
          tx1 = borderValue + axisHalfWidth;
          tx2 = me.left + tl;
        }
        for (i = 0; i < ticksLength; ++i) {
          tick = ticks[i] || {};
          if (isNullOrUndef(tick.label) && i < ticks.length) {
            continue;
          }
          if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
            lineWidth = gridLines.zeroLineWidth;
            lineColor = gridLines.zeroLineColor;
            borderDash = gridLines.zeroLineBorderDash || [];
            borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
          } else {
            lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
            lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
            borderDash = gridLines.borderDash || [];
            borderDashOffset = gridLines.borderDashOffset || 0.0;
          }
          lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
          if (lineValue === undefined) {
            continue;
          }
          alignedLineValue = alignPixel(chart, lineValue, lineWidth);
          if (isHorizontal) {
            tx1 = tx2 = x1 = x2 = alignedLineValue;
          } else {
            ty1 = ty2 = y1 = y2 = alignedLineValue;
          }
          items.push({
            tx1: tx1,
            ty1: ty1,
            tx2: tx2,
            ty2: ty2,
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            width: lineWidth,
            color: lineColor,
            borderDash: borderDash,
            borderDashOffset: borderDashOffset
          });
        }
        items.ticksLength = ticksLength;
        items.borderValue = borderValue;
        return items;
      },
      _computeLabelItems: function _computeLabelItems() {
        var me = this;
        var options = me.options;
        var optionTicks = options.ticks;
        var position = options.position;
        var isMirrored = optionTicks.mirror;
        var isHorizontal = me.isHorizontal();
        var ticks = me._ticksToDraw;
        var fonts = parseTickFontOptions(optionTicks);
        var tickPadding = optionTicks.padding;
        var tl = getTickMarkLength(options.gridLines);
        var rotation = -helpers$1.toRadians(me.labelRotation);
        var items = [];
        var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        if (position === 'top') {
          y = me.bottom - tl - tickPadding;
          textAlign = !rotation ? 'center' : 'left';
        } else if (position === 'bottom') {
          y = me.top + tl + tickPadding;
          textAlign = !rotation ? 'center' : 'right';
        } else if (position === 'left') {
          x = me.right - (isMirrored ? 0 : tl) - tickPadding;
          textAlign = isMirrored ? 'left' : 'right';
        } else {
          x = me.left + (isMirrored ? 0 : tl) + tickPadding;
          textAlign = isMirrored ? 'right' : 'left';
        }
        for (i = 0, ilen = ticks.length; i < ilen; ++i) {
          tick = ticks[i];
          label = tick.label;
          if (isNullOrUndef(label)) {
            continue;
          }
          pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
          font = tick.major ? fonts.major : fonts.minor;
          lineHeight = font.lineHeight;
          lineCount = isArray(label) ? label.length : 1;
          if (isHorizontal) {
            x = pixel;
            textOffset = position === 'top' ? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight : (!rotation ? 0.5 : 0) * lineHeight;
          } else {
            y = pixel;
            textOffset = (1 - lineCount) * lineHeight / 2;
          }
          items.push({
            x: x,
            y: y,
            rotation: rotation,
            label: label,
            font: font,
            textOffset: textOffset,
            textAlign: textAlign
          });
        }
        return items;
      },
      _drawGrid: function _drawGrid(chartArea) {
        var me = this;
        var gridLines = me.options.gridLines;
        if (!gridLines.display) {
          return;
        }
        var ctx = me.ctx;
        var chart = me.chart;
        var alignPixel = helpers$1._alignPixel;
        var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
        var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
        var width, color, i, ilen, item;
        for (i = 0, ilen = items.length; i < ilen; ++i) {
          item = items[i];
          width = item.width;
          color = item.color;
          if (width && color) {
            ctx.save();
            ctx.lineWidth = width;
            ctx.strokeStyle = color;
            if (ctx.setLineDash) {
              ctx.setLineDash(item.borderDash);
              ctx.lineDashOffset = item.borderDashOffset;
            }
            ctx.beginPath();
            if (gridLines.drawTicks) {
              ctx.moveTo(item.tx1, item.ty1);
              ctx.lineTo(item.tx2, item.ty2);
            }
            if (gridLines.drawOnChartArea) {
              ctx.moveTo(item.x1, item.y1);
              ctx.lineTo(item.x2, item.y2);
            }
            ctx.stroke();
            ctx.restore();
          }
        }
        if (axisWidth) {
          var firstLineWidth = axisWidth;
          var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
          var borderValue = items.borderValue;
          var x1, x2, y1, y2;
          if (me.isHorizontal()) {
            x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
            x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
          } else {
            y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
            y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
          }
          ctx.lineWidth = axisWidth;
          ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
          ctx.beginPath();
          ctx.moveTo(x1, y1);
          ctx.lineTo(x2, y2);
          ctx.stroke();
        }
      },
      _drawLabels: function _drawLabels() {
        var me = this;
        var optionTicks = me.options.ticks;
        if (!optionTicks.display) {
          return;
        }
        var ctx = me.ctx;
        var items = me._labelItems || (me._labelItems = me._computeLabelItems());
        var i, j, ilen, jlen, item, tickFont, label, y;
        for (i = 0, ilen = items.length; i < ilen; ++i) {
          item = items[i];
          tickFont = item.font;
          ctx.save();
          ctx.translate(item.x, item.y);
          ctx.rotate(item.rotation);
          ctx.font = tickFont.string;
          ctx.fillStyle = tickFont.color;
          ctx.textBaseline = 'middle';
          ctx.textAlign = item.textAlign;
          label = item.label;
          y = item.textOffset;
          if (isArray(label)) {
            for (j = 0, jlen = label.length; j < jlen; ++j) {
              ctx.fillText('' + label[j], 0, y);
              y += tickFont.lineHeight;
            }
          } else {
            ctx.fillText(label, 0, y);
          }
          ctx.restore();
        }
      },
      _drawTitle: function _drawTitle() {
        var me = this;
        var ctx = me.ctx;
        var options = me.options;
        var scaleLabel = options.scaleLabel;
        if (!scaleLabel.display) {
          return;
        }
        var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
        var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
        var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
        var halfLineHeight = scaleLabelFont.lineHeight / 2;
        var position = options.position;
        var rotation = 0;
        var scaleLabelX, scaleLabelY;
        if (me.isHorizontal()) {
          scaleLabelX = me.left + me.width / 2;
          scaleLabelY = position === 'bottom' ? me.bottom - halfLineHeight - scaleLabelPadding.bottom : me.top + halfLineHeight + scaleLabelPadding.top;
        } else {
          var isLeft = position === 'left';
          scaleLabelX = isLeft ? me.left + halfLineHeight + scaleLabelPadding.top : me.right - halfLineHeight - scaleLabelPadding.top;
          scaleLabelY = me.top + me.height / 2;
          rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
        }
        ctx.save();
        ctx.translate(scaleLabelX, scaleLabelY);
        ctx.rotate(rotation);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = scaleLabelFontColor;
        ctx.font = scaleLabelFont.string;
        ctx.fillText(scaleLabel.labelString, 0, 0);
        ctx.restore();
      },
      draw: function draw(chartArea) {
        var me = this;
        if (!me._isVisible()) {
          return;
        }
        me._drawGrid(chartArea);
        me._drawTitle();
        me._drawLabels();
      },
      _layers: function _layers() {
        var me = this;
        var opts = me.options;
        var tz = opts.ticks && opts.ticks.z || 0;
        var gz = opts.gridLines && opts.gridLines.z || 0;
        if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
          return [{
            z: tz,
            draw: function draw() {
              me.draw.apply(me, arguments);
            }
          }];
        }
        return [{
          z: gz,
          draw: function draw() {
            me._drawGrid.apply(me, arguments);
            me._drawTitle.apply(me, arguments);
          }
        }, {
          z: tz,
          draw: function draw() {
            me._drawLabels.apply(me, arguments);
          }
        }];
      },
      _getMatchingVisibleMetas: function _getMatchingVisibleMetas(type) {
        var me = this;
        var isHorizontal = me.isHorizontal();
        return me.chart._getSortedVisibleDatasetMetas().filter(function (meta) {
          return (!type || meta.type === type) && (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
        });
      }
    });
    Scale.prototype._draw = Scale.prototype.draw;
    var core_scale = Scale;
    var isNullOrUndef$1 = helpers$1.isNullOrUndef;
    var defaultConfig = {
      position: 'bottom'
    };
    var scale_category = core_scale.extend({
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var labels = me._getLabels();
        var ticksOpts = me.options.ticks;
        var min = ticksOpts.min;
        var max = ticksOpts.max;
        var minIndex = 0;
        var maxIndex = labels.length - 1;
        var findIndex;
        if (min !== undefined) {
          findIndex = labels.indexOf(min);
          if (findIndex >= 0) {
            minIndex = findIndex;
          }
        }
        if (max !== undefined) {
          findIndex = labels.indexOf(max);
          if (findIndex >= 0) {
            maxIndex = findIndex;
          }
        }
        me.minIndex = minIndex;
        me.maxIndex = maxIndex;
        me.min = labels[minIndex];
        me.max = labels[maxIndex];
      },
      buildTicks: function buildTicks() {
        var me = this;
        var labels = me._getLabels();
        var minIndex = me.minIndex;
        var maxIndex = me.maxIndex;
        me.ticks = minIndex === 0 && maxIndex === labels.length - 1 ? labels : labels.slice(minIndex, maxIndex + 1);
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        var me = this;
        var chart = me.chart;
        if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
          return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
        }
        return me._getLabels()[index];
      },
      _configure: function _configure() {
        var me = this;
        var offset = me.options.offset;
        var ticks = me.ticks;
        core_scale.prototype._configure.call(me);
        if (!me.isHorizontal()) {
          me._reversePixels = !me._reversePixels;
        }
        if (!ticks) {
          return;
        }
        me._startValue = me.minIndex - (offset ? 0.5 : 0);
        me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
      },
      getPixelForValue: function getPixelForValue(value, index, datasetIndex) {
        var me = this;
        var valueCategory, labels, idx;
        if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
          value = me.chart.data.datasets[datasetIndex].data[index];
        }
        if (!isNullOrUndef$1(value)) {
          valueCategory = me.isHorizontal() ? value.x : value.y;
        }
        if (valueCategory !== undefined || value !== undefined && isNaN(index)) {
          labels = me._getLabels();
          value = helpers$1.valueOrDefault(valueCategory, value);
          idx = labels.indexOf(value);
          index = idx !== -1 ? idx : index;
          if (isNaN(index)) {
            index = value;
          }
        }
        return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.ticks;
        return index < 0 || index > ticks.length - 1 ? null : this.getPixelForValue(ticks[index], index + this.minIndex);
      },
      getValueForPixel: function getValueForPixel(pixel) {
        var me = this;
        var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
        return Math.min(Math.max(value, 0), me.ticks.length - 1);
      },
      getBasePixel: function getBasePixel() {
        return this.bottom;
      }
    });
    var _defaults = defaultConfig;
    scale_category._defaults = _defaults;
    var noop = helpers$1.noop;
    var isNullOrUndef$2 = helpers$1.isNullOrUndef;
    function generateTicks(generationOptions, dataRange) {
      var ticks = [];
      var MIN_SPACING = 1e-14;
      var stepSize = generationOptions.stepSize;
      var unit = stepSize || 1;
      var maxNumSpaces = generationOptions.maxTicks - 1;
      var min = generationOptions.min;
      var max = generationOptions.max;
      var precision = generationOptions.precision;
      var rmin = dataRange.min;
      var rmax = dataRange.max;
      var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
      var factor, niceMin, niceMax, numSpaces;
      if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
        return [rmin, rmax];
      }
      numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
      if (numSpaces > maxNumSpaces) {
        spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
      }
      if (stepSize || isNullOrUndef$2(precision)) {
        factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
      } else {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
      }
      niceMin = Math.floor(rmin / spacing) * spacing;
      niceMax = Math.ceil(rmax / spacing) * spacing;
      if (stepSize) {
        if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
          niceMin = min;
        }
        if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
          niceMax = max;
        }
      }
      numSpaces = (niceMax - niceMin) / spacing;
      if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
        numSpaces = Math.round(numSpaces);
      } else {
        numSpaces = Math.ceil(numSpaces);
      }
      niceMin = Math.round(niceMin * factor) / factor;
      niceMax = Math.round(niceMax * factor) / factor;
      ticks.push(isNullOrUndef$2(min) ? niceMin : min);
      for (var j = 1; j < numSpaces; ++j) {
        ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
      }
      ticks.push(isNullOrUndef$2(max) ? niceMax : max);
      return ticks;
    }
    var scale_linearbase = core_scale.extend({
      getRightValue: function getRightValue(value) {
        if (typeof value === 'string') {
          return +value;
        }
        return core_scale.prototype.getRightValue.call(this, value);
      },
      handleTickRangeOptions: function handleTickRangeOptions() {
        var me = this;
        var opts = me.options;
        var tickOpts = opts.ticks;
        if (tickOpts.beginAtZero) {
          var minSign = helpers$1.sign(me.min);
          var maxSign = helpers$1.sign(me.max);
          if (minSign < 0 && maxSign < 0) {
            me.max = 0;
          } else if (minSign > 0 && maxSign > 0) {
            me.min = 0;
          }
        }
        var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
        var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
        if (tickOpts.min !== undefined) {
          me.min = tickOpts.min;
        } else if (tickOpts.suggestedMin !== undefined) {
          if (me.min === null) {
            me.min = tickOpts.suggestedMin;
          } else {
            me.min = Math.min(me.min, tickOpts.suggestedMin);
          }
        }
        if (tickOpts.max !== undefined) {
          me.max = tickOpts.max;
        } else if (tickOpts.suggestedMax !== undefined) {
          if (me.max === null) {
            me.max = tickOpts.suggestedMax;
          } else {
            me.max = Math.max(me.max, tickOpts.suggestedMax);
          }
        }
        if (setMin !== setMax) {
          if (me.min >= me.max) {
            if (setMin) {
              me.max = me.min + 1;
            } else {
              me.min = me.max - 1;
            }
          }
        }
        if (me.min === me.max) {
          me.max++;
          if (!tickOpts.beginAtZero) {
            me.min--;
          }
        }
      },
      getTickLimit: function getTickLimit() {
        var me = this;
        var tickOpts = me.options.ticks;
        var stepSize = tickOpts.stepSize;
        var maxTicksLimit = tickOpts.maxTicksLimit;
        var maxTicks;
        if (stepSize) {
          maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
        } else {
          maxTicks = me._computeTickLimit();
          maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) {
          maxTicks = Math.min(maxTicksLimit, maxTicks);
        }
        return maxTicks;
      },
      _computeTickLimit: function _computeTickLimit() {
        return Number.POSITIVE_INFINITY;
      },
      handleDirectionalChanges: noop,
      buildTicks: function buildTicks() {
        var me = this;
        var opts = me.options;
        var tickOpts = opts.ticks;
        var maxTicks = me.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        var numericGeneratorOptions = {
          maxTicks: maxTicks,
          min: tickOpts.min,
          max: tickOpts.max,
          precision: tickOpts.precision,
          stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
        };
        var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
        me.handleDirectionalChanges();
        me.max = helpers$1.max(ticks);
        me.min = helpers$1.min(ticks);
        if (tickOpts.reverse) {
          ticks.reverse();
          me.start = me.max;
          me.end = me.min;
        } else {
          me.start = me.min;
          me.end = me.max;
        }
      },
      convertTicksToLabels: function convertTicksToLabels() {
        var me = this;
        me.ticksAsNumbers = me.ticks.slice();
        me.zeroLineIndex = me.ticks.indexOf(0);
        core_scale.prototype.convertTicksToLabels.call(me);
      },
      _configure: function _configure() {
        var me = this;
        var ticks = me.getTicks();
        var start = me.min;
        var end = me.max;
        var offset;
        core_scale.prototype._configure.call(me);
        if (me.options.offset && ticks.length) {
          offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
          start -= offset;
          end += offset;
        }
        me._startValue = start;
        me._endValue = end;
        me._valueRange = end - start;
      }
    });
    var defaultConfig$1 = {
      position: 'left',
      ticks: {
        callback: core_ticks.formatters.linear
      }
    };
    var DEFAULT_MIN = 0;
    var DEFAULT_MAX = 1;
    function getOrCreateStack(stacks, stacked, meta) {
      var key = [meta.type, stacked === undefined && meta.stack === undefined ? meta.index : '', meta.stack].join('.');
      if (stacks[key] === undefined) {
        stacks[key] = {
          pos: [],
          neg: []
        };
      }
      return stacks[key];
    }
    function stackData(scale, stacks, meta, data) {
      var opts = scale.options;
      var stacked = opts.stacked;
      var stack = getOrCreateStack(stacks, stacked, meta);
      var pos = stack.pos;
      var neg = stack.neg;
      var ilen = data.length;
      var i, value;
      for (i = 0; i < ilen; ++i) {
        value = scale._parseValue(data[i]);
        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
          continue;
        }
        pos[i] = pos[i] || 0;
        neg[i] = neg[i] || 0;
        if (opts.relativePoints) {
          pos[i] = 100;
        } else if (value.min < 0 || value.max < 0) {
          neg[i] += value.min;
        } else {
          pos[i] += value.max;
        }
      }
    }
    function updateMinMax(scale, meta, data) {
      var ilen = data.length;
      var i, value;
      for (i = 0; i < ilen; ++i) {
        value = scale._parseValue(data[i]);
        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
          continue;
        }
        scale.min = Math.min(scale.min, value.min);
        scale.max = Math.max(scale.max, value.max);
      }
    }
    var scale_linear = scale_linearbase.extend({
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var opts = me.options;
        var chart = me.chart;
        var datasets = chart.data.datasets;
        var metasets = me._getMatchingVisibleMetas();
        var hasStacks = opts.stacked;
        var stacks = {};
        var ilen = metasets.length;
        var i, meta, data, values;
        me.min = Number.POSITIVE_INFINITY;
        me.max = Number.NEGATIVE_INFINITY;
        if (hasStacks === undefined) {
          for (i = 0; !hasStacks && i < ilen; ++i) {
            meta = metasets[i];
            hasStacks = meta.stack !== undefined;
          }
        }
        for (i = 0; i < ilen; ++i) {
          meta = metasets[i];
          data = datasets[meta.index].data;
          if (hasStacks) {
            stackData(me, stacks, meta, data);
          } else {
            updateMinMax(me, meta, data);
          }
        }
        helpers$1.each(stacks, function (stackValues) {
          values = stackValues.pos.concat(stackValues.neg);
          me.min = Math.min(me.min, helpers$1.min(values));
          me.max = Math.max(me.max, helpers$1.max(values));
        });
        me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
        me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
        me.handleTickRangeOptions();
      },
      _computeTickLimit: function _computeTickLimit() {
        var me = this;
        var tickFont;
        if (me.isHorizontal()) {
          return Math.ceil(me.width / 40);
        }
        tickFont = helpers$1.options._parseFont(me.options.ticks);
        return Math.ceil(me.height / tickFont.lineHeight);
      },
      handleDirectionalChanges: function handleDirectionalChanges() {
        if (!this.isHorizontal()) {
          this.ticks.reverse();
        }
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
      },
      getPixelForValue: function getPixelForValue(value) {
        var me = this;
        return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
      },
      getValueForPixel: function getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.ticksAsNumbers;
        if (index < 0 || index > ticks.length - 1) {
          return null;
        }
        return this.getPixelForValue(ticks[index]);
      }
    });
    var _defaults$1 = defaultConfig$1;
    scale_linear._defaults = _defaults$1;
    var valueOrDefault$b = helpers$1.valueOrDefault;
    var log10 = helpers$1.math.log10;
    function generateTicks$1(generationOptions, dataRange) {
      var ticks = [];
      var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
      var endExp = Math.floor(log10(dataRange.max));
      var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
      var exp, significand;
      if (tickVal === 0) {
        exp = Math.floor(log10(dataRange.minNotZero));
        significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
        ticks.push(tickVal);
        tickVal = significand * Math.pow(10, exp);
      } else {
        exp = Math.floor(log10(tickVal));
        significand = Math.floor(tickVal / Math.pow(10, exp));
      }
      var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
      do {
        ticks.push(tickVal);
        ++significand;
        if (significand === 10) {
          significand = 1;
          ++exp;
          precision = exp >= 0 ? 1 : precision;
        }
        tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
      } while (exp < endExp || exp === endExp && significand < endSignificand);
      var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
      ticks.push(lastTick);
      return ticks;
    }
    var defaultConfig$2 = {
      position: 'left',
      ticks: {
        callback: core_ticks.formatters.logarithmic
      }
    };
    function nonNegativeOrDefault(value, defaultValue) {
      return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
    }
    var scale_logarithmic = core_scale.extend({
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var opts = me.options;
        var chart = me.chart;
        var datasets = chart.data.datasets;
        var isHorizontal = me.isHorizontal();
        function IDMatches(meta) {
          return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
        }
        var datasetIndex, meta, value, data, i, ilen;
        me.min = Number.POSITIVE_INFINITY;
        me.max = Number.NEGATIVE_INFINITY;
        me.minNotZero = Number.POSITIVE_INFINITY;
        var hasStacks = opts.stacked;
        if (hasStacks === undefined) {
          for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
            meta = chart.getDatasetMeta(datasetIndex);
            if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
              hasStacks = true;
              break;
            }
          }
        }
        if (opts.stacked || hasStacks) {
          var valuesPerStack = {};
          for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
            meta = chart.getDatasetMeta(datasetIndex);
            var key = [meta.type, opts.stacked === undefined && meta.stack === undefined ? datasetIndex : '', meta.stack].join('.');
            if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
              if (valuesPerStack[key] === undefined) {
                valuesPerStack[key] = [];
              }
              data = datasets[datasetIndex].data;
              for (i = 0, ilen = data.length; i < ilen; i++) {
                var values = valuesPerStack[key];
                value = me._parseValue(data[i]);
                if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
                  continue;
                }
                values[i] = values[i] || 0;
                values[i] += value.max;
              }
            }
          }
          helpers$1.each(valuesPerStack, function (valuesForType) {
            if (valuesForType.length > 0) {
              var minVal = helpers$1.min(valuesForType);
              var maxVal = helpers$1.max(valuesForType);
              me.min = Math.min(me.min, minVal);
              me.max = Math.max(me.max, maxVal);
            }
          });
        } else {
          for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
            meta = chart.getDatasetMeta(datasetIndex);
            if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
              data = datasets[datasetIndex].data;
              for (i = 0, ilen = data.length; i < ilen; i++) {
                value = me._parseValue(data[i]);
                if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
                  continue;
                }
                me.min = Math.min(value.min, me.min);
                me.max = Math.max(value.max, me.max);
                if (value.min !== 0) {
                  me.minNotZero = Math.min(value.min, me.minNotZero);
                }
              }
            }
          }
        }
        me.min = helpers$1.isFinite(me.min) ? me.min : null;
        me.max = helpers$1.isFinite(me.max) ? me.max : null;
        me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
        this.handleTickRangeOptions();
      },
      handleTickRangeOptions: function handleTickRangeOptions() {
        var me = this;
        var tickOpts = me.options.ticks;
        var DEFAULT_MIN = 1;
        var DEFAULT_MAX = 10;
        me.min = nonNegativeOrDefault(tickOpts.min, me.min);
        me.max = nonNegativeOrDefault(tickOpts.max, me.max);
        if (me.min === me.max) {
          if (me.min !== 0 && me.min !== null) {
            me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
            me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
          } else {
            me.min = DEFAULT_MIN;
            me.max = DEFAULT_MAX;
          }
        }
        if (me.min === null) {
          me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
        }
        if (me.max === null) {
          me.max = me.min !== 0 ? Math.pow(10, Math.floor(log10(me.min)) + 1) : DEFAULT_MAX;
        }
        if (me.minNotZero === null) {
          if (me.min > 0) {
            me.minNotZero = me.min;
          } else if (me.max < 1) {
            me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
          } else {
            me.minNotZero = DEFAULT_MIN;
          }
        }
      },
      buildTicks: function buildTicks() {
        var me = this;
        var tickOpts = me.options.ticks;
        var reverse = !me.isHorizontal();
        var generationOptions = {
          min: nonNegativeOrDefault(tickOpts.min),
          max: nonNegativeOrDefault(tickOpts.max)
        };
        var ticks = me.ticks = generateTicks$1(generationOptions, me);
        me.max = helpers$1.max(ticks);
        me.min = helpers$1.min(ticks);
        if (tickOpts.reverse) {
          reverse = !reverse;
          me.start = me.max;
          me.end = me.min;
        } else {
          me.start = me.min;
          me.end = me.max;
        }
        if (reverse) {
          ticks.reverse();
        }
      },
      convertTicksToLabels: function convertTicksToLabels() {
        this.tickValues = this.ticks.slice();
        core_scale.prototype.convertTicksToLabels.call(this);
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.tickValues;
        if (index < 0 || index > ticks.length - 1) {
          return null;
        }
        return this.getPixelForValue(ticks[index]);
      },
      _getFirstTickValue: function _getFirstTickValue(value) {
        var exp = Math.floor(log10(value));
        var significand = Math.floor(value / Math.pow(10, exp));
        return significand * Math.pow(10, exp);
      },
      _configure: function _configure() {
        var me = this;
        var start = me.min;
        var offset = 0;
        core_scale.prototype._configure.call(me);
        if (start === 0) {
          start = me._getFirstTickValue(me.minNotZero);
          offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
        }
        me._startValue = log10(start);
        me._valueOffset = offset;
        me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
      },
      getPixelForValue: function getPixelForValue(value) {
        var me = this;
        var decimal = 0;
        value = +me.getRightValue(value);
        if (value > me.min && value > 0) {
          decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
        }
        return me.getPixelForDecimal(decimal);
      },
      getValueForPixel: function getValueForPixel(pixel) {
        var me = this;
        var decimal = me.getDecimalForPixel(pixel);
        return decimal === 0 && me.min === 0 ? 0 : Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
      }
    });
    var _defaults$2 = defaultConfig$2;
    scale_logarithmic._defaults = _defaults$2;
    var valueOrDefault$c = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
    var resolve$4 = helpers$1.options.resolve;
    var defaultConfig$3 = {
      display: true,
      animate: true,
      position: 'chartArea',
      angleLines: {
        display: true,
        color: 'rgba(0,0,0,0.1)',
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
      },
      gridLines: {
        circular: false
      },
      ticks: {
        showLabelBackdrop: true,
        backdropColor: 'rgba(255,255,255,0.75)',
        backdropPaddingY: 2,
        backdropPaddingX: 2,
        callback: core_ticks.formatters.linear
      },
      pointLabels: {
        display: true,
        fontSize: 10,
        callback: function callback(label) {
          return label;
        }
      }
    };
    function getTickBackdropHeight(opts) {
      var tickOpts = opts.ticks;
      if (tickOpts.display && opts.display) {
        return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
      }
      return 0;
    }
    function measureLabelSize(ctx, lineHeight, label) {
      if (helpers$1.isArray(label)) {
        return {
          w: helpers$1.longestText(ctx, ctx.font, label),
          h: label.length * lineHeight
        };
      }
      return {
        w: ctx.measureText(label).width,
        h: lineHeight
      };
    }
    function determineLimits(angle, pos, size, min, max) {
      if (angle === min || angle === max) {
        return {
          start: pos - size / 2,
          end: pos + size / 2
        };
      } else if (angle < min || angle > max) {
        return {
          start: pos - size,
          end: pos
        };
      }
      return {
        start: pos,
        end: pos + size
      };
    }
    function fitWithPointLabels(scale) {
      var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
      var furthestLimits = {
        l: 0,
        r: scale.width,
        t: 0,
        b: scale.height - scale.paddingTop
      };
      var furthestAngles = {};
      var i, textSize, pointPosition;
      scale.ctx.font = plFont.string;
      scale._pointLabelSizes = [];
      var valueCount = scale.chart.data.labels.length;
      for (i = 0; i < valueCount; i++) {
        pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
        textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
        scale._pointLabelSizes[i] = textSize;
        var angleRadians = scale.getIndexAngle(i);
        var angle = helpers$1.toDegrees(angleRadians) % 360;
        var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        if (hLimits.start < furthestLimits.l) {
          furthestLimits.l = hLimits.start;
          furthestAngles.l = angleRadians;
        }
        if (hLimits.end > furthestLimits.r) {
          furthestLimits.r = hLimits.end;
          furthestAngles.r = angleRadians;
        }
        if (vLimits.start < furthestLimits.t) {
          furthestLimits.t = vLimits.start;
          furthestAngles.t = angleRadians;
        }
        if (vLimits.end > furthestLimits.b) {
          furthestLimits.b = vLimits.end;
          furthestAngles.b = angleRadians;
        }
      }
      scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
    }
    function getTextAlignForAngle(angle) {
      if (angle === 0 || angle === 180) {
        return 'center';
      } else if (angle < 180) {
        return 'left';
      }
      return 'right';
    }
    function fillText(ctx, text, position, lineHeight) {
      var y = position.y + lineHeight / 2;
      var i, ilen;
      if (helpers$1.isArray(text)) {
        for (i = 0, ilen = text.length; i < ilen; ++i) {
          ctx.fillText(text[i], position.x, y);
          y += lineHeight;
        }
      } else {
        ctx.fillText(text, position.x, y);
      }
    }
    function adjustPointPositionForLabelHeight(angle, textSize, position) {
      if (angle === 90 || angle === 270) {
        position.y -= textSize.h / 2;
      } else if (angle > 270 || angle < 90) {
        position.y -= textSize.h;
      }
    }
    function drawPointLabels(scale) {
      var ctx = scale.ctx;
      var opts = scale.options;
      var pointLabelOpts = opts.pointLabels;
      var tickBackdropHeight = getTickBackdropHeight(opts);
      var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
      var plFont = helpers$1.options._parseFont(pointLabelOpts);
      ctx.save();
      ctx.font = plFont.string;
      ctx.textBaseline = 'middle';
      for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
        var extra = i === 0 ? tickBackdropHeight / 2 : 0;
        var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
        var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
        ctx.fillStyle = pointLabelFontColor;
        var angleRadians = scale.getIndexAngle(i);
        var angle = helpers$1.toDegrees(angleRadians);
        ctx.textAlign = getTextAlignForAngle(angle);
        adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
        fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
      }
      ctx.restore();
    }
    function drawRadiusLine(scale, gridLineOpts, radius, index) {
      var ctx = scale.ctx;
      var circular = gridLineOpts.circular;
      var valueCount = scale.chart.data.labels.length;
      var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
      var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
      var pointPosition;
      if (!circular && !valueCount || !lineColor || !lineWidth) {
        return;
      }
      ctx.save();
      ctx.strokeStyle = lineColor;
      ctx.lineWidth = lineWidth;
      if (ctx.setLineDash) {
        ctx.setLineDash(gridLineOpts.borderDash || []);
        ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
      }
      ctx.beginPath();
      if (circular) {
        ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
      } else {
        pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for (var i = 1; i < valueCount; i++) {
          pointPosition = scale.getPointPosition(i, radius);
          ctx.lineTo(pointPosition.x, pointPosition.y);
        }
      }
      ctx.closePath();
      ctx.stroke();
      ctx.restore();
    }
    function numberOrZero(param) {
      return helpers$1.isNumber(param) ? param : 0;
    }
    var scale_radialLinear = scale_linearbase.extend({
      setDimensions: function setDimensions() {
        var me = this;
        me.width = me.maxWidth;
        me.height = me.maxHeight;
        me.paddingTop = getTickBackdropHeight(me.options) / 2;
        me.xCenter = Math.floor(me.width / 2);
        me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
        me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
      },
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var chart = me.chart;
        var min = Number.POSITIVE_INFINITY;
        var max = Number.NEGATIVE_INFINITY;
        helpers$1.each(chart.data.datasets, function (dataset, datasetIndex) {
          if (chart.isDatasetVisible(datasetIndex)) {
            var meta = chart.getDatasetMeta(datasetIndex);
            helpers$1.each(dataset.data, function (rawValue, index) {
              var value = +me.getRightValue(rawValue);
              if (isNaN(value) || meta.data[index].hidden) {
                return;
              }
              min = Math.min(value, min);
              max = Math.max(value, max);
            });
          }
        });
        me.min = min === Number.POSITIVE_INFINITY ? 0 : min;
        me.max = max === Number.NEGATIVE_INFINITY ? 0 : max;
        me.handleTickRangeOptions();
      },
      _computeTickLimit: function _computeTickLimit() {
        return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
      },
      convertTicksToLabels: function convertTicksToLabels() {
        var me = this;
        scale_linearbase.prototype.convertTicksToLabels.call(me);
        me.pointLabels = me.chart.data.labels.map(function () {
          var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
          return label || label === 0 ? label : '';
        });
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
      },
      fit: function fit() {
        var me = this;
        var opts = me.options;
        if (opts.display && opts.pointLabels.display) {
          fitWithPointLabels(me);
        } else {
          me.setCenterPoint(0, 0, 0, 0);
        }
      },
      setReductions: function setReductions(largestPossibleRadius, furthestLimits, furthestAngles) {
        var me = this;
        var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
        var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
        var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
        var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
        radiusReductionLeft = numberOrZero(radiusReductionLeft);
        radiusReductionRight = numberOrZero(radiusReductionRight);
        radiusReductionTop = numberOrZero(radiusReductionTop);
        radiusReductionBottom = numberOrZero(radiusReductionBottom);
        me.drawingArea = Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
        me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
      },
      setCenterPoint: function setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        var me = this;
        var maxRight = me.width - rightMovement - me.drawingArea;
        var maxLeft = leftMovement + me.drawingArea;
        var maxTop = topMovement + me.drawingArea;
        var maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;
        me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
        me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
      },
      getIndexAngle: function getIndexAngle(index) {
        var chart = this.chart;
        var angleMultiplier = 360 / chart.data.labels.length;
        var options = chart.options || {};
        var startAngle = options.startAngle || 0;
        var angle = (index * angleMultiplier + startAngle) % 360;
        return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
      },
      getDistanceFromCenterForValue: function getDistanceFromCenterForValue(value) {
        var me = this;
        if (helpers$1.isNullOrUndef(value)) {
          return NaN;
        }
        var scalingFactor = me.drawingArea / (me.max - me.min);
        if (me.options.ticks.reverse) {
          return (me.max - value) * scalingFactor;
        }
        return (value - me.min) * scalingFactor;
      },
      getPointPosition: function getPointPosition(index, distanceFromCenter) {
        var me = this;
        var thisAngle = me.getIndexAngle(index) - Math.PI / 2;
        return {
          x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
          y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
        };
      },
      getPointPositionForValue: function getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
      },
      getBasePosition: function getBasePosition(index) {
        var me = this;
        var min = me.min;
        var max = me.max;
        return me.getPointPositionForValue(index || 0, me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0);
      },
      _drawGrid: function _drawGrid() {
        var me = this;
        var ctx = me.ctx;
        var opts = me.options;
        var gridLineOpts = opts.gridLines;
        var angleLineOpts = opts.angleLines;
        var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
        var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
        var i, offset, position;
        if (opts.pointLabels.display) {
          drawPointLabels(me);
        }
        if (gridLineOpts.display) {
          helpers$1.each(me.ticks, function (label, index) {
            if (index !== 0) {
              offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
              drawRadiusLine(me, gridLineOpts, offset, index);
            }
          });
        }
        if (angleLineOpts.display && lineWidth && lineColor) {
          ctx.save();
          ctx.lineWidth = lineWidth;
          ctx.strokeStyle = lineColor;
          if (ctx.setLineDash) {
            ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
            ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
          }
          for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
            offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
            position = me.getPointPosition(i, offset);
            ctx.beginPath();
            ctx.moveTo(me.xCenter, me.yCenter);
            ctx.lineTo(position.x, position.y);
            ctx.stroke();
          }
          ctx.restore();
        }
      },
      _drawLabels: function _drawLabels() {
        var me = this;
        var ctx = me.ctx;
        var opts = me.options;
        var tickOpts = opts.ticks;
        if (!tickOpts.display) {
          return;
        }
        var startAngle = me.getIndexAngle(0);
        var tickFont = helpers$1.options._parseFont(tickOpts);
        var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
        var offset, width;
        ctx.save();
        ctx.font = tickFont.string;
        ctx.translate(me.xCenter, me.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        helpers$1.each(me.ticks, function (label, index) {
          if (index === 0 && !tickOpts.reverse) {
            return;
          }
          offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
          if (tickOpts.showLabelBackdrop) {
            width = ctx.measureText(label).width;
            ctx.fillStyle = tickOpts.backdropColor;
            ctx.fillRect(-width / 2 - tickOpts.backdropPaddingX, -offset - tickFont.size / 2 - tickOpts.backdropPaddingY, width + tickOpts.backdropPaddingX * 2, tickFont.size + tickOpts.backdropPaddingY * 2);
          }
          ctx.fillStyle = tickFontColor;
          ctx.fillText(label, 0, -offset);
        });
        ctx.restore();
      },
      _drawTitle: helpers$1.noop
    });
    var _defaults$3 = defaultConfig$3;
    scale_radialLinear._defaults = _defaults$3;
    var deprecated$1 = helpers$1._deprecated;
    var resolve$5 = helpers$1.options.resolve;
    var valueOrDefault$d = helpers$1.valueOrDefault;
    var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
    var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
    var INTERVALS = {
      millisecond: {
        common: true,
        size: 1,
        steps: 1000
      },
      second: {
        common: true,
        size: 1000,
        steps: 60
      },
      minute: {
        common: true,
        size: 60000,
        steps: 60
      },
      hour: {
        common: true,
        size: 3600000,
        steps: 24
      },
      day: {
        common: true,
        size: 86400000,
        steps: 30
      },
      week: {
        common: false,
        size: 604800000,
        steps: 4
      },
      month: {
        common: true,
        size: 2.628e9,
        steps: 12
      },
      quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
      },
      year: {
        common: true,
        size: 3.154e10
      }
    };
    var UNITS = Object.keys(INTERVALS);
    function sorter(a, b) {
      return a - b;
    }
    function arrayUnique(items) {
      var hash = {};
      var out = [];
      var i, ilen, item;
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        item = items[i];
        if (!hash[item]) {
          hash[item] = true;
          out.push(item);
        }
      }
      return out;
    }
    function getMin(options) {
      return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
    }
    function getMax(options) {
      return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
    }
    function buildLookupTable(timestamps, min, max, distribution) {
      if (distribution === 'linear' || !timestamps.length) {
        return [{
          time: min,
          pos: 0
        }, {
          time: max,
          pos: 1
        }];
      }
      var table = [];
      var items = [min];
      var i, ilen, prev, curr, next;
      for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
        curr = timestamps[i];
        if (curr > min && curr < max) {
          items.push(curr);
        }
      }
      items.push(max);
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        next = items[i + 1];
        prev = items[i - 1];
        curr = items[i];
        if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
          table.push({
            time: curr,
            pos: i / (ilen - 1)
          });
        }
      }
      return table;
    }
    function lookup(table, key, value) {
      var lo = 0;
      var hi = table.length - 1;
      var mid, i0, i1;
      while (lo >= 0 && lo <= hi) {
        mid = lo + hi >> 1;
        i0 = table[mid - 1] || null;
        i1 = table[mid];
        if (!i0) {
          return {
            lo: null,
            hi: i1
          };
        } else if (i1[key] < value) {
          lo = mid + 1;
        } else if (i0[key] > value) {
          hi = mid - 1;
        } else {
          return {
            lo: i0,
            hi: i1
          };
        }
      }
      return {
        lo: i1,
        hi: null
      };
    }
    function interpolate$1(table, skey, sval, tkey) {
      var range = lookup(table, skey, sval);
      var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
      var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
      var span = next[skey] - prev[skey];
      var ratio = span ? (sval - prev[skey]) / span : 0;
      var offset = (next[tkey] - prev[tkey]) * ratio;
      return prev[tkey] + offset;
    }
    function toTimestamp(scale, input) {
      var adapter = scale._adapter;
      var options = scale.options.time;
      var parser = options.parser;
      var format = parser || options.format;
      var value = input;
      if (typeof parser === 'function') {
        value = parser(value);
      }
      if (!helpers$1.isFinite(value)) {
        value = typeof format === 'string' ? adapter.parse(value, format) : adapter.parse(value);
      }
      if (value !== null) {
        return +value;
      }
      if (!parser && typeof format === 'function') {
        value = format(input);
        if (!helpers$1.isFinite(value)) {
          value = adapter.parse(value);
        }
      }
      return value;
    }
    function parse(scale, input) {
      if (helpers$1.isNullOrUndef(input)) {
        return null;
      }
      var options = scale.options.time;
      var value = toTimestamp(scale, scale.getRightValue(input));
      if (value === null) {
        return value;
      }
      if (options.round) {
        value = +scale._adapter.startOf(value, options.round);
      }
      return value;
    }
    function determineUnitForAutoTicks(minUnit, min, max, capacity) {
      var ilen = UNITS.length;
      var i, interval, factor;
      for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
        interval = INTERVALS[UNITS[i]];
        factor = interval.steps ? interval.steps : MAX_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
          return UNITS[i];
        }
      }
      return UNITS[ilen - 1];
    }
    function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
      var i, unit;
      for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
        unit = UNITS[i];
        if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
          return unit;
        }
      }
      return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
    }
    function determineMajorUnit(unit) {
      for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
        if (INTERVALS[UNITS[i]].common) {
          return UNITS[i];
        }
      }
    }
    function generate(scale, min, max, capacity) {
      var adapter = scale._adapter;
      var options = scale.options;
      var timeOpts = options.time;
      var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
      var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
      var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
      var first = min;
      var ticks = [];
      var time;
      if (weekday) {
        first = +adapter.startOf(first, 'isoWeek', weekday);
      }
      first = +adapter.startOf(first, weekday ? 'day' : minor);
      if (adapter.diff(max, min, minor) > 100000 * stepSize) {
        throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
      }
      for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
        ticks.push(time);
      }
      if (time === max || options.bounds === 'ticks') {
        ticks.push(time);
      }
      return ticks;
    }
    function computeOffsets(table, ticks, min, max, options) {
      var start = 0;
      var end = 0;
      var first, last;
      if (options.offset && ticks.length) {
        first = interpolate$1(table, 'time', ticks[0], 'pos');
        if (ticks.length === 1) {
          start = 1 - first;
        } else {
          start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
        }
        last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
        if (ticks.length === 1) {
          end = last;
        } else {
          end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
        }
      }
      return {
        start: start,
        end: end,
        factor: 1 / (start + 1 + end)
      };
    }
    function setMajorTicks(scale, ticks, map, majorUnit) {
      var adapter = scale._adapter;
      var first = +adapter.startOf(ticks[0].value, majorUnit);
      var last = ticks[ticks.length - 1].value;
      var major, index;
      for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
        index = map[major];
        if (index >= 0) {
          ticks[index].major = true;
        }
      }
      return ticks;
    }
    function ticksFromTimestamps(scale, values, majorUnit) {
      var ticks = [];
      var map = {};
      var ilen = values.length;
      var i, value;
      for (i = 0; i < ilen; ++i) {
        value = values[i];
        map[value] = i;
        ticks.push({
          value: value,
          major: false
        });
      }
      return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
    }
    var defaultConfig$4 = {
      position: 'bottom',
      distribution: 'linear',
      bounds: 'data',
      adapters: {},
      time: {
        parser: false,
        unit: false,
        round: false,
        displayFormat: false,
        isoWeekday: false,
        minUnit: 'millisecond',
        displayFormats: {}
      },
      ticks: {
        autoSkip: false,
        source: 'auto',
        major: {
          enabled: false
        }
      }
    };
    var scale_time = core_scale.extend({
      initialize: function initialize() {
        this.mergeTicksOptions();
        core_scale.prototype.initialize.call(this);
      },
      update: function update() {
        var me = this;
        var options = me.options;
        var time = options.time || (options.time = {});
        var adapter = me._adapter = new core_adapters._date(options.adapters.date);
        deprecated$1('time scale', time.format, 'time.format', 'time.parser');
        deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
        deprecated$1('time scale', time.max, 'time.max', 'ticks.max');
        helpers$1.mergeIf(time.displayFormats, adapter.formats());
        return core_scale.prototype.update.apply(me, arguments);
      },
      getRightValue: function getRightValue(rawValue) {
        if (rawValue && rawValue.t !== undefined) {
          rawValue = rawValue.t;
        }
        return core_scale.prototype.getRightValue.call(this, rawValue);
      },
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var chart = me.chart;
        var adapter = me._adapter;
        var options = me.options;
        var unit = options.time.unit || 'day';
        var min = MAX_INTEGER;
        var max = MIN_INTEGER;
        var timestamps = [];
        var datasets = [];
        var labels = [];
        var i, j, ilen, jlen, data, timestamp, labelsAdded;
        var dataLabels = me._getLabels();
        for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
          labels.push(parse(me, dataLabels[i]));
        }
        for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
          if (chart.isDatasetVisible(i)) {
            data = chart.data.datasets[i].data;
            if (helpers$1.isObject(data[0])) {
              datasets[i] = [];
              for (j = 0, jlen = data.length; j < jlen; ++j) {
                timestamp = parse(me, data[j]);
                timestamps.push(timestamp);
                datasets[i][j] = timestamp;
              }
            } else {
              datasets[i] = labels.slice(0);
              if (!labelsAdded) {
                timestamps = timestamps.concat(labels);
                labelsAdded = true;
              }
            }
          } else {
            datasets[i] = [];
          }
        }
        if (labels.length) {
          min = Math.min(min, labels[0]);
          max = Math.max(max, labels[labels.length - 1]);
        }
        if (timestamps.length) {
          timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
          min = Math.min(min, timestamps[0]);
          max = Math.max(max, timestamps[timestamps.length - 1]);
        }
        min = parse(me, getMin(options)) || min;
        max = parse(me, getMax(options)) || max;
        min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
        max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
        me.min = Math.min(min, max);
        me.max = Math.max(min + 1, max);
        me._table = [];
        me._timestamps = {
          data: timestamps,
          datasets: datasets,
          labels: labels
        };
      },
      buildTicks: function buildTicks() {
        var me = this;
        var min = me.min;
        var max = me.max;
        var options = me.options;
        var tickOpts = options.ticks;
        var timeOpts = options.time;
        var timestamps = me._timestamps;
        var ticks = [];
        var capacity = me.getLabelCapacity(min);
        var source = tickOpts.source;
        var distribution = options.distribution;
        var i, ilen, timestamp;
        if (source === 'data' || source === 'auto' && distribution === 'series') {
          timestamps = timestamps.data;
        } else if (source === 'labels') {
          timestamps = timestamps.labels;
        } else {
          timestamps = generate(me, min, max, capacity);
        }
        if (options.bounds === 'ticks' && timestamps.length) {
          min = timestamps[0];
          max = timestamps[timestamps.length - 1];
        }
        min = parse(me, getMin(options)) || min;
        max = parse(me, getMax(options)) || max;
        for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
          timestamp = timestamps[i];
          if (timestamp >= min && timestamp <= max) {
            ticks.push(timestamp);
          }
        }
        me.min = min;
        me.max = max;
        me._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity) : determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
        me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined : determineMajorUnit(me._unit);
        me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
        me._offsets = computeOffsets(me._table, ticks, min, max, options);
        if (tickOpts.reverse) {
          ticks.reverse();
        }
        return ticksFromTimestamps(me, ticks, me._majorUnit);
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        var me = this;
        var adapter = me._adapter;
        var data = me.chart.data;
        var timeOpts = me.options.time;
        var label = data.labels && index < data.labels.length ? data.labels[index] : '';
        var value = data.datasets[datasetIndex].data[index];
        if (helpers$1.isObject(value)) {
          label = me.getRightValue(value);
        }
        if (timeOpts.tooltipFormat) {
          return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
        }
        if (typeof label === 'string') {
          return label;
        }
        return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
      },
      tickFormatFunction: function tickFormatFunction(time, index, ticks, format) {
        var me = this;
        var adapter = me._adapter;
        var options = me.options;
        var formats = options.time.displayFormats;
        var minorFormat = formats[me._unit];
        var majorUnit = me._majorUnit;
        var majorFormat = formats[majorUnit];
        var tick = ticks[index];
        var tickOpts = options.ticks;
        var major = majorUnit && majorFormat && tick && tick.major;
        var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
        var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
        var formatter = resolve$5([nestedTickOpts.callback, nestedTickOpts.userCallback, tickOpts.callback, tickOpts.userCallback]);
        return formatter ? formatter(label, index, ticks) : label;
      },
      convertTicksToLabels: function convertTicksToLabels(ticks) {
        var labels = [];
        var i, ilen;
        for (i = 0, ilen = ticks.length; i < ilen; ++i) {
          labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
        }
        return labels;
      },
      getPixelForOffset: function getPixelForOffset(time) {
        var me = this;
        var offsets = me._offsets;
        var pos = interpolate$1(me._table, 'time', time, 'pos');
        return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
      },
      getPixelForValue: function getPixelForValue(value, index, datasetIndex) {
        var me = this;
        var time = null;
        if (index !== undefined && datasetIndex !== undefined) {
          time = me._timestamps.datasets[datasetIndex][index];
        }
        if (time === null) {
          time = parse(me, value);
        }
        if (time !== null) {
          return me.getPixelForOffset(time);
        }
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.getTicks();
        return index >= 0 && index < ticks.length ? this.getPixelForOffset(ticks[index].value) : null;
      },
      getValueForPixel: function getValueForPixel(pixel) {
        var me = this;
        var offsets = me._offsets;
        var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        var time = interpolate$1(me._table, 'pos', pos, 'time');
        return me._adapter._create(time);
      },
      _getLabelSize: function _getLabelSize(label) {
        var me = this;
        var ticksOpts = me.options.ticks;
        var tickLabelWidth = me.ctx.measureText(label).width;
        var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        var cosRotation = Math.cos(angle);
        var sinRotation = Math.sin(angle);
        var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
        return {
          w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
          h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
      },
      getLabelWidth: function getLabelWidth(label) {
        return this._getLabelSize(label).w;
      },
      getLabelCapacity: function getLabelCapacity(exampleTime) {
        var me = this;
        var timeOpts = me.options.time;
        var displayFormats = timeOpts.displayFormats;
        var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
        var size = me._getLabelSize(exampleLabel);
        var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
        if (me.options.offset) {
          capacity--;
        }
        return capacity > 0 ? capacity : 1;
      }
    });
    var _defaults$4 = defaultConfig$4;
    scale_time._defaults = _defaults$4;
    var scales = {
      category: scale_category,
      linear: scale_linear,
      logarithmic: scale_logarithmic,
      radialLinear: scale_radialLinear,
      time: scale_time
    };
    var FORMATS = {
      datetime: 'MMM D, YYYY, h:mm:ss a',
      millisecond: 'h:mm:ss.SSS a',
      second: 'h:mm:ss a',
      minute: 'h:mm a',
      hour: 'hA',
      day: 'MMM D',
      week: 'll',
      month: 'MMM YYYY',
      quarter: '[Q]Q - YYYY',
      year: 'YYYY'
    };
    core_adapters._date.override(typeof moment === 'function' ? {
      _id: 'moment',
      formats: function formats() {
        return FORMATS;
      },
      parse: function parse(value, format) {
        if (typeof value === 'string' && typeof format === 'string') {
          value = moment(value, format);
        } else if (!(value instanceof moment)) {
          value = moment(value);
        }
        return value.isValid() ? value.valueOf() : null;
      },
      format: function format(time, _format) {
        return moment(time).format(_format);
      },
      add: function add(time, amount, unit) {
        return moment(time).add(amount, unit).valueOf();
      },
      diff: function diff(max, min, unit) {
        return moment(max).diff(moment(min), unit);
      },
      startOf: function startOf(time, unit, weekday) {
        time = moment(time);
        if (unit === 'isoWeek') {
          return time.isoWeekday(weekday).valueOf();
        }
        return time.startOf(unit).valueOf();
      },
      endOf: function endOf(time, unit) {
        return moment(time).endOf(unit).valueOf();
      },
      _create: function _create(time) {
        return moment(time);
      }
    } : {});
    core_defaults._set('global', {
      plugins: {
        filler: {
          propagate: true
        }
      }
    });
    var mappers = {
      dataset: function dataset(source) {
        var index = source.fill;
        var chart = source.chart;
        var meta = chart.getDatasetMeta(index);
        var visible = meta && chart.isDatasetVisible(index);
        var points = visible && meta.dataset._children || [];
        var length = points.length || 0;
        return !length ? null : function (point, i) {
          return i < length && points[i]._view || null;
        };
      },
      boundary: function boundary(source) {
        var boundary = source.boundary;
        var x = boundary ? boundary.x : null;
        var y = boundary ? boundary.y : null;
        if (helpers$1.isArray(boundary)) {
          return function (point, i) {
            return boundary[i];
          };
        }
        return function (point) {
          return {
            x: x === null ? point.x : x,
            y: y === null ? point.y : y
          };
        };
      }
    };
    function decodeFill(el, index, count) {
      var model = el._model || {};
      var fill = model.fill;
      var target;
      if (fill === undefined) {
        fill = !!model.backgroundColor;
      }
      if (fill === false || fill === null) {
        return false;
      }
      if (fill === true) {
        return 'origin';
      }
      target = parseFloat(fill, 10);
      if (isFinite(target) && Math.floor(target) === target) {
        if (fill[0] === '-' || fill[0] === '+') {
          target = index + target;
        }
        if (target === index || target < 0 || target >= count) {
          return false;
        }
        return target;
      }
      switch (fill) {
        case 'bottom':
          return 'start';
        case 'top':
          return 'end';
        case 'zero':
          return 'origin';
        case 'origin':
        case 'start':
        case 'end':
          return fill;
        default:
          return false;
      }
    }
    function computeLinearBoundary(source) {
      var model = source.el._model || {};
      var scale = source.el._scale || {};
      var fill = source.fill;
      var target = null;
      var horizontal;
      if (isFinite(fill)) {
        return null;
      }
      if (fill === 'start') {
        target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
      } else if (fill === 'end') {
        target = model.scaleTop === undefined ? scale.top : model.scaleTop;
      } else if (model.scaleZero !== undefined) {
        target = model.scaleZero;
      } else if (scale.getBasePixel) {
        target = scale.getBasePixel();
      }
      if (target !== undefined && target !== null) {
        if (target.x !== undefined && target.y !== undefined) {
          return target;
        }
        if (helpers$1.isFinite(target)) {
          horizontal = scale.isHorizontal();
          return {
            x: horizontal ? target : null,
            y: horizontal ? null : target
          };
        }
      }
      return null;
    }
    function computeCircularBoundary(source) {
      var scale = source.el._scale;
      var options = scale.options;
      var length = scale.chart.data.labels.length;
      var fill = source.fill;
      var target = [];
      var start, end, center, i, point;
      if (!length) {
        return null;
      }
      start = options.ticks.reverse ? scale.max : scale.min;
      end = options.ticks.reverse ? scale.min : scale.max;
      center = scale.getPointPositionForValue(0, start);
      for (i = 0; i < length; ++i) {
        point = fill === 'start' || fill === 'end' ? scale.getPointPositionForValue(i, fill === 'start' ? start : end) : scale.getBasePosition(i);
        if (options.gridLines.circular) {
          point.cx = center.x;
          point.cy = center.y;
          point.angle = scale.getIndexAngle(i) - Math.PI / 2;
        }
        target.push(point);
      }
      return target;
    }
    function computeBoundary(source) {
      var scale = source.el._scale || {};
      if (scale.getPointPositionForValue) {
        return computeCircularBoundary(source);
      }
      return computeLinearBoundary(source);
    }
    function resolveTarget(sources, index, propagate) {
      var source = sources[index];
      var fill = source.fill;
      var visited = [index];
      var target;
      if (!propagate) {
        return fill;
      }
      while (fill !== false && visited.indexOf(fill) === -1) {
        if (!isFinite(fill)) {
          return fill;
        }
        target = sources[fill];
        if (!target) {
          return false;
        }
        if (target.visible) {
          return fill;
        }
        visited.push(fill);
        fill = target.fill;
      }
      return false;
    }
    function createMapper(source) {
      var fill = source.fill;
      var type = 'dataset';
      if (fill === false) {
        return null;
      }
      if (!isFinite(fill)) {
        type = 'boundary';
      }
      return mappers[type](source);
    }
    function isDrawable(point) {
      return point && !point.skip;
    }
    function drawArea(ctx, curve0, curve1, len0, len1) {
      var i, cx, cy, r;
      if (!len0 || !len1) {
        return;
      }
      ctx.moveTo(curve0[0].x, curve0[0].y);
      for (i = 1; i < len0; ++i) {
        helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
      }
      if (curve1[0].angle !== undefined) {
        cx = curve1[0].cx;
        cy = curve1[0].cy;
        r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
        for (i = len1 - 1; i > 0; --i) {
          ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
        }
        return;
      }
      ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
      for (i = len1 - 1; i > 0; --i) {
        helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
      }
    }
    function doFill(ctx, points, mapper, view, color, loop) {
      var count = points.length;
      var span = view.spanGaps;
      var curve0 = [];
      var curve1 = [];
      var len0 = 0;
      var len1 = 0;
      var i, ilen, index, p0, p1, d0, d1, loopOffset;
      ctx.beginPath();
      for (i = 0, ilen = count; i < ilen; ++i) {
        index = i % count;
        p0 = points[index]._view;
        p1 = mapper(p0, index, view);
        d0 = isDrawable(p0);
        d1 = isDrawable(p1);
        if (loop && loopOffset === undefined && d0) {
          loopOffset = i + 1;
          ilen = count + loopOffset;
        }
        if (d0 && d1) {
          len0 = curve0.push(p0);
          len1 = curve1.push(p1);
        } else if (len0 && len1) {
          if (!span) {
            drawArea(ctx, curve0, curve1, len0, len1);
            len0 = len1 = 0;
            curve0 = [];
            curve1 = [];
          } else {
            if (d0) {
              curve0.push(p0);
            }
            if (d1) {
              curve1.push(p1);
            }
          }
        }
      }
      drawArea(ctx, curve0, curve1, len0, len1);
      ctx.closePath();
      ctx.fillStyle = color;
      ctx.fill();
    }
    var plugin_filler = {
      id: 'filler',
      afterDatasetsUpdate: function afterDatasetsUpdate(chart, options) {
        var count = (chart.data.datasets || []).length;
        var propagate = options.propagate;
        var sources = [];
        var meta, i, el, source;
        for (i = 0; i < count; ++i) {
          meta = chart.getDatasetMeta(i);
          el = meta.dataset;
          source = null;
          if (el && el._model && el instanceof elements.Line) {
            source = {
              visible: chart.isDatasetVisible(i),
              fill: decodeFill(el, i, count),
              chart: chart,
              el: el
            };
          }
          meta.$filler = source;
          sources.push(source);
        }
        for (i = 0; i < count; ++i) {
          source = sources[i];
          if (!source) {
            continue;
          }
          source.fill = resolveTarget(sources, i, propagate);
          source.boundary = computeBoundary(source);
          source.mapper = createMapper(source);
        }
      },
      beforeDatasetsDraw: function beforeDatasetsDraw(chart) {
        var metasets = chart._getSortedVisibleDatasetMetas();
        var ctx = chart.ctx;
        var meta, i, el, view, points, mapper, color;
        for (i = metasets.length - 1; i >= 0; --i) {
          meta = metasets[i].$filler;
          if (!meta || !meta.visible) {
            continue;
          }
          el = meta.el;
          view = el._view;
          points = el._children || [];
          mapper = meta.mapper;
          color = view.backgroundColor || core_defaults.global.defaultColor;
          if (mapper && color && points.length) {
            helpers$1.canvas.clipArea(ctx, chart.chartArea);
            doFill(ctx, points, mapper, view, color, el._loop);
            helpers$1.canvas.unclipArea(ctx);
          }
        }
      }
    };
    var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
    var noop$1 = helpers$1.noop;
    var valueOrDefault$e = helpers$1.valueOrDefault;
    core_defaults._set('global', {
      legend: {
        display: true,
        position: 'top',
        align: 'center',
        fullWidth: true,
        reverse: false,
        weight: 1000,
        onClick: function onClick(e, legendItem) {
          var index = legendItem.datasetIndex;
          var ci = this.chart;
          var meta = ci.getDatasetMeta(index);
          meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
          ci.update();
        },
        onHover: null,
        onLeave: null,
        labels: {
          boxWidth: 40,
          padding: 10,
          generateLabels: function generateLabels(chart) {
            var datasets = chart.data.datasets;
            var options = chart.options.legend || {};
            var usePointStyle = options.labels && options.labels.usePointStyle;
            return chart._getSortedDatasetMetas().map(function (meta) {
              var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
              return {
                text: datasets[meta.index].label,
                fillStyle: style.backgroundColor,
                hidden: !chart.isDatasetVisible(meta.index),
                lineCap: style.borderCapStyle,
                lineDash: style.borderDash,
                lineDashOffset: style.borderDashOffset,
                lineJoin: style.borderJoinStyle,
                lineWidth: style.borderWidth,
                strokeStyle: style.borderColor,
                pointStyle: style.pointStyle,
                rotation: style.rotation,
                datasetIndex: meta.index
              };
            }, this);
          }
        }
      },
      legendCallback: function legendCallback(chart) {
        var list = document.createElement('ul');
        var datasets = chart.data.datasets;
        var i, ilen, listItem, listItemSpan;
        list.setAttribute('class', chart.id + '-legend');
        for (i = 0, ilen = datasets.length; i < ilen; i++) {
          listItem = list.appendChild(document.createElement('li'));
          listItemSpan = listItem.appendChild(document.createElement('span'));
          listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
          if (datasets[i].label) {
            listItem.appendChild(document.createTextNode(datasets[i].label));
          }
        }
        return list.outerHTML;
      }
    });
    function getBoxWidth(labelOpts, fontSize) {
      return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ? fontSize : labelOpts.boxWidth;
    }
    var Legend = core_element.extend({
      initialize: function initialize(config) {
        var me = this;
        helpers$1.extend(me, config);
        me.legendHitBoxes = [];
        me._hoveredItem = null;
        me.doughnutMode = false;
      },
      beforeUpdate: noop$1,
      update: function update(maxWidth, maxHeight, margins) {
        var me = this;
        me.beforeUpdate();
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me.margins = margins;
        me.beforeSetDimensions();
        me.setDimensions();
        me.afterSetDimensions();
        me.beforeBuildLabels();
        me.buildLabels();
        me.afterBuildLabels();
        me.beforeFit();
        me.fit();
        me.afterFit();
        me.afterUpdate();
        return me.minSize;
      },
      afterUpdate: noop$1,
      beforeSetDimensions: noop$1,
      setDimensions: function setDimensions() {
        var me = this;
        if (me.isHorizontal()) {
          me.width = me.maxWidth;
          me.left = 0;
          me.right = me.width;
        } else {
          me.height = me.maxHeight;
          me.top = 0;
          me.bottom = me.height;
        }
        me.paddingLeft = 0;
        me.paddingTop = 0;
        me.paddingRight = 0;
        me.paddingBottom = 0;
        me.minSize = {
          width: 0,
          height: 0
        };
      },
      afterSetDimensions: noop$1,
      beforeBuildLabels: noop$1,
      buildLabels: function buildLabels() {
        var me = this;
        var labelOpts = me.options.labels || {};
        var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];
        if (labelOpts.filter) {
          legendItems = legendItems.filter(function (item) {
            return labelOpts.filter(item, me.chart.data);
          });
        }
        if (me.options.reverse) {
          legendItems.reverse();
        }
        me.legendItems = legendItems;
      },
      afterBuildLabels: noop$1,
      beforeFit: noop$1,
      fit: function fit() {
        var me = this;
        var opts = me.options;
        var labelOpts = opts.labels;
        var display = opts.display;
        var ctx = me.ctx;
        var labelFont = helpers$1.options._parseFont(labelOpts);
        var fontSize = labelFont.size;
        var hitboxes = me.legendHitBoxes = [];
        var minSize = me.minSize;
        var isHorizontal = me.isHorizontal();
        if (isHorizontal) {
          minSize.width = me.maxWidth;
          minSize.height = display ? 10 : 0;
        } else {
          minSize.width = display ? 10 : 0;
          minSize.height = me.maxHeight;
        }
        if (!display) {
          me.width = minSize.width = me.height = minSize.height = 0;
          return;
        }
        ctx.font = labelFont.string;
        if (isHorizontal) {
          var lineWidths = me.lineWidths = [0];
          var totalHeight = 0;
          ctx.textAlign = 'left';
          ctx.textBaseline = 'middle';
          helpers$1.each(me.legendItems, function (legendItem, i) {
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var width = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
              totalHeight += fontSize + labelOpts.padding;
              lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
            }
            hitboxes[i] = {
              left: 0,
              top: 0,
              width: width,
              height: fontSize
            };
            lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
          });
          minSize.height += totalHeight;
        } else {
          var vPadding = labelOpts.padding;
          var columnWidths = me.columnWidths = [];
          var columnHeights = me.columnHeights = [];
          var totalWidth = labelOpts.padding;
          var currentColWidth = 0;
          var currentColHeight = 0;
          helpers$1.each(me.legendItems, function (legendItem, i) {
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
              totalWidth += currentColWidth + labelOpts.padding;
              columnWidths.push(currentColWidth);
              columnHeights.push(currentColHeight);
              currentColWidth = 0;
              currentColHeight = 0;
            }
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += fontSize + vPadding;
            hitboxes[i] = {
              left: 0,
              top: 0,
              width: itemWidth,
              height: fontSize
            };
          });
          totalWidth += currentColWidth;
          columnWidths.push(currentColWidth);
          columnHeights.push(currentColHeight);
          minSize.width += totalWidth;
        }
        me.width = minSize.width;
        me.height = minSize.height;
      },
      afterFit: noop$1,
      isHorizontal: function isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
      },
      draw: function draw() {
        var me = this;
        var opts = me.options;
        var labelOpts = opts.labels;
        var globalDefaults = core_defaults.global;
        var defaultColor = globalDefaults.defaultColor;
        var lineDefault = globalDefaults.elements.line;
        var legendHeight = me.height;
        var columnHeights = me.columnHeights;
        var legendWidth = me.width;
        var lineWidths = me.lineWidths;
        if (!opts.display) {
          return;
        }
        var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
        var ctx = me.ctx;
        var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
        var labelFont = helpers$1.options._parseFont(labelOpts);
        var fontSize = labelFont.size;
        var cursor;
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.strokeStyle = fontColor;
        ctx.fillStyle = fontColor;
        ctx.font = labelFont.string;
        var boxWidth = getBoxWidth(labelOpts, fontSize);
        var hitboxes = me.legendHitBoxes;
        var drawLegendBox = function drawLegendBox(x, y, legendItem) {
          if (isNaN(boxWidth) || boxWidth <= 0) {
            return;
          }
          ctx.save();
          var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
          ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
          ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
          ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
          ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
          ctx.lineWidth = lineWidth;
          ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
          if (ctx.setLineDash) {
            ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
          }
          if (labelOpts && labelOpts.usePointStyle) {
            var radius = boxWidth * Math.SQRT2 / 2;
            var centerX = rtlHelper.xPlus(x, boxWidth / 2);
            var centerY = y + fontSize / 2;
            helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
          } else {
            ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
            if (lineWidth !== 0) {
              ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
            }
          }
          ctx.restore();
        };
        var fillText = function fillText(x, y, legendItem, textWidth) {
          var halfFontSize = fontSize / 2;
          var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
          var yMiddle = y + halfFontSize;
          ctx.fillText(legendItem.text, xLeft, yMiddle);
          if (legendItem.hidden) {
            ctx.beginPath();
            ctx.lineWidth = 2;
            ctx.moveTo(xLeft, yMiddle);
            ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
            ctx.stroke();
          }
        };
        var alignmentOffset = function alignmentOffset(dimension, blockSize) {
          switch (opts.align) {
            case 'start':
              return labelOpts.padding;
            case 'end':
              return dimension - blockSize;
            default:
              return (dimension - blockSize + labelOpts.padding) / 2;
          }
        };
        var isHorizontal = me.isHorizontal();
        if (isHorizontal) {
          cursor = {
            x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
            y: me.top + labelOpts.padding,
            line: 0
          };
        } else {
          cursor = {
            x: me.left + labelOpts.padding,
            y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
            line: 0
          };
        }
        helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
        var itemHeight = fontSize + labelOpts.padding;
        helpers$1.each(me.legendItems, function (legendItem, i) {
          var textWidth = ctx.measureText(legendItem.text).width;
          var width = boxWidth + fontSize / 2 + textWidth;
          var x = cursor.x;
          var y = cursor.y;
          rtlHelper.setWidth(me.minSize.width);
          if (isHorizontal) {
            if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
              y = cursor.y += itemHeight;
              cursor.line++;
              x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
            }
          } else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
            x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
            cursor.line++;
            y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
          }
          var realX = rtlHelper.x(x);
          drawLegendBox(realX, y, legendItem);
          hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
          hitboxes[i].top = y;
          fillText(realX, y, legendItem, textWidth);
          if (isHorizontal) {
            cursor.x += width + labelOpts.padding;
          } else {
            cursor.y += itemHeight;
          }
        });
        helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
      },
      _getLegendItemAt: function _getLegendItemAt(x, y) {
        var me = this;
        var i, hitBox, lh;
        if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
          lh = me.legendHitBoxes;
          for (i = 0; i < lh.length; ++i) {
            hitBox = lh[i];
            if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
              return me.legendItems[i];
            }
          }
        }
        return null;
      },
      handleEvent: function handleEvent(e) {
        var me = this;
        var opts = me.options;
        var type = e.type === 'mouseup' ? 'click' : e.type;
        var hoveredItem;
        if (type === 'mousemove') {
          if (!opts.onHover && !opts.onLeave) {
            return;
          }
        } else if (type === 'click') {
          if (!opts.onClick) {
            return;
          }
        } else {
          return;
        }
        hoveredItem = me._getLegendItemAt(e.x, e.y);
        if (type === 'click') {
          if (hoveredItem && opts.onClick) {
            opts.onClick.call(me, e["native"], hoveredItem);
          }
        } else {
          if (opts.onLeave && hoveredItem !== me._hoveredItem) {
            if (me._hoveredItem) {
              opts.onLeave.call(me, e["native"], me._hoveredItem);
            }
            me._hoveredItem = hoveredItem;
          }
          if (opts.onHover && hoveredItem) {
            opts.onHover.call(me, e["native"], hoveredItem);
          }
        }
      }
    });
    function createNewLegendAndAttach(chart, legendOpts) {
      var legend = new Legend({
        ctx: chart.ctx,
        options: legendOpts,
        chart: chart
      });
      core_layouts.configure(chart, legend, legendOpts);
      core_layouts.addBox(chart, legend);
      chart.legend = legend;
    }
    var plugin_legend = {
      id: 'legend',
      _element: Legend,
      beforeInit: function beforeInit(chart) {
        var legendOpts = chart.options.legend;
        if (legendOpts) {
          createNewLegendAndAttach(chart, legendOpts);
        }
      },
      beforeUpdate: function beforeUpdate(chart) {
        var legendOpts = chart.options.legend;
        var legend = chart.legend;
        if (legendOpts) {
          helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
          if (legend) {
            core_layouts.configure(chart, legend, legendOpts);
            legend.options = legendOpts;
          } else {
            createNewLegendAndAttach(chart, legendOpts);
          }
        } else if (legend) {
          core_layouts.removeBox(chart, legend);
          delete chart.legend;
        }
      },
      afterEvent: function afterEvent(chart, e) {
        var legend = chart.legend;
        if (legend) {
          legend.handleEvent(e);
        }
      }
    };
    var noop$2 = helpers$1.noop;
    core_defaults._set('global', {
      title: {
        display: false,
        fontStyle: 'bold',
        fullWidth: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
      }
    });
    var Title = core_element.extend({
      initialize: function initialize(config) {
        var me = this;
        helpers$1.extend(me, config);
        me.legendHitBoxes = [];
      },
      beforeUpdate: noop$2,
      update: function update(maxWidth, maxHeight, margins) {
        var me = this;
        me.beforeUpdate();
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me.margins = margins;
        me.beforeSetDimensions();
        me.setDimensions();
        me.afterSetDimensions();
        me.beforeBuildLabels();
        me.buildLabels();
        me.afterBuildLabels();
        me.beforeFit();
        me.fit();
        me.afterFit();
        me.afterUpdate();
        return me.minSize;
      },
      afterUpdate: noop$2,
      beforeSetDimensions: noop$2,
      setDimensions: function setDimensions() {
        var me = this;
        if (me.isHorizontal()) {
          me.width = me.maxWidth;
          me.left = 0;
          me.right = me.width;
        } else {
          me.height = me.maxHeight;
          me.top = 0;
          me.bottom = me.height;
        }
        me.paddingLeft = 0;
        me.paddingTop = 0;
        me.paddingRight = 0;
        me.paddingBottom = 0;
        me.minSize = {
          width: 0,
          height: 0
        };
      },
      afterSetDimensions: noop$2,
      beforeBuildLabels: noop$2,
      buildLabels: noop$2,
      afterBuildLabels: noop$2,
      beforeFit: noop$2,
      fit: function fit() {
        var me = this;
        var opts = me.options;
        var minSize = me.minSize = {};
        var isHorizontal = me.isHorizontal();
        var lineCount, textSize;
        if (!opts.display) {
          me.width = minSize.width = me.height = minSize.height = 0;
          return;
        }
        lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
        textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
        me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
        me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
      },
      afterFit: noop$2,
      isHorizontal: function isHorizontal() {
        var pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
      },
      draw: function draw() {
        var me = this;
        var ctx = me.ctx;
        var opts = me.options;
        if (!opts.display) {
          return;
        }
        var fontOpts = helpers$1.options._parseFont(opts);
        var lineHeight = fontOpts.lineHeight;
        var offset = lineHeight / 2 + opts.padding;
        var rotation = 0;
        var top = me.top;
        var left = me.left;
        var bottom = me.bottom;
        var right = me.right;
        var maxWidth, titleX, titleY;
        ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor);
        ctx.font = fontOpts.string;
        if (me.isHorizontal()) {
          titleX = left + (right - left) / 2;
          titleY = top + offset;
          maxWidth = right - left;
        } else {
          titleX = opts.position === 'left' ? left + offset : right - offset;
          titleY = top + (bottom - top) / 2;
          maxWidth = bottom - top;
          rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
        }
        ctx.save();
        ctx.translate(titleX, titleY);
        ctx.rotate(rotation);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        var text = opts.text;
        if (helpers$1.isArray(text)) {
          var y = 0;
          for (var i = 0; i < text.length; ++i) {
            ctx.fillText(text[i], 0, y, maxWidth);
            y += lineHeight;
          }
        } else {
          ctx.fillText(text, 0, 0, maxWidth);
        }
        ctx.restore();
      }
    });
    function createNewTitleBlockAndAttach(chart, titleOpts) {
      var title = new Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
      });
      core_layouts.configure(chart, title, titleOpts);
      core_layouts.addBox(chart, title);
      chart.titleBlock = title;
    }
    var plugin_title = {
      id: 'title',
      _element: Title,
      beforeInit: function beforeInit(chart) {
        var titleOpts = chart.options.title;
        if (titleOpts) {
          createNewTitleBlockAndAttach(chart, titleOpts);
        }
      },
      beforeUpdate: function beforeUpdate(chart) {
        var titleOpts = chart.options.title;
        var titleBlock = chart.titleBlock;
        if (titleOpts) {
          helpers$1.mergeIf(titleOpts, core_defaults.global.title);
          if (titleBlock) {
            core_layouts.configure(chart, titleBlock, titleOpts);
            titleBlock.options = titleOpts;
          } else {
            createNewTitleBlockAndAttach(chart, titleOpts);
          }
        } else if (titleBlock) {
          core_layouts.removeBox(chart, titleBlock);
          delete chart.titleBlock;
        }
      }
    };
    var plugins = {};
    var filler = plugin_filler;
    var legend = plugin_legend;
    var title = plugin_title;
    plugins.filler = filler;
    plugins.legend = legend;
    plugins.title = title;
    core_controller.helpers = helpers$1;
    core_helpers();
    core_controller._adapters = core_adapters;
    core_controller.Animation = core_animation;
    core_controller.animationService = core_animations;
    core_controller.controllers = controllers;
    core_controller.DatasetController = core_datasetController;
    core_controller.defaults = core_defaults;
    core_controller.Element = core_element;
    core_controller.elements = elements;
    core_controller.Interaction = core_interaction;
    core_controller.layouts = core_layouts;
    core_controller.platform = platform;
    core_controller.plugins = core_plugins;
    core_controller.Scale = core_scale;
    core_controller.scaleService = core_scaleService;
    core_controller.Ticks = core_ticks;
    core_controller.Tooltip = core_tooltip;
    core_controller.helpers.each(scales, function (scale, type) {
      core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
    });
    for (var k in plugins) {
      if (plugins.hasOwnProperty(k)) {
        core_controller.plugins.register(plugins[k]);
      }
    }
    core_controller.platform.initialize();
    var src = core_controller;
    if (typeof window !== 'undefined') {
      window.Chart = core_controller;
    }
    core_controller.Chart = core_controller;
    core_controller.Legend = plugins.legend._element;
    core_controller.Title = plugins.title._element;
    core_controller.pluginService = core_controller.plugins;
    core_controller.PluginBase = core_controller.Element.extend({});
    core_controller.canvasHelpers = core_controller.helpers.canvas;
    core_controller.layoutService = core_controller.layouts;
    core_controller.LinearScaleBase = scale_linearbase;
    core_controller.helpers.each(['Bar', 'Bubble', 'Doughnut', 'Line', 'PolarArea', 'Radar', 'Scatter'], function (klass) {
      core_controller[klass] = function (ctx, cfg) {
        return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
          type: klass.charAt(0).toLowerCase() + klass.slice(1)
        }));
      };
    });
    return src;
  });
});

var es$1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "Chart", {
    enumerable: true,
    get: function get() {
      return _chart["default"];
    }
  });
  exports.defaults = exports.Scatter = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = exports["default"] = void 0;
  var _react = _interopRequireDefault(React__default__default__default__default);
  var _propTypes = _interopRequireDefault(propTypes);
  var _chart = _interopRequireDefault(Chart);
  var _isEqual = _interopRequireDefault(isEqual);
  var _keyBy = _interopRequireDefault(keyBy);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }
    return _typeof(obj);
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var NODE_ENV = typeof process !== 'undefined' && process.env && process.env.NODE_ENV;
  var ChartComponent = /*#__PURE__*/function (_React$Component) {
    _inherits(ChartComponent, _React$Component);
    var _super = _createSuper(ChartComponent);
    function ChartComponent() {
      var _this;
      _classCallCheck(this, ChartComponent);
      _this = _super.call(this);
      _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
        var instance = _this.chartInstance;
        var _this$props = _this.props,
          getDatasetAtEvent = _this$props.getDatasetAtEvent,
          getElementAtEvent = _this$props.getElementAtEvent,
          getElementsAtEvent = _this$props.getElementsAtEvent,
          onElementsClick = _this$props.onElementsClick;
        getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
        getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
        getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
        onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event);
      });
      _defineProperty(_assertThisInitialized(_this), "ref", function (element) {
        _this.element = element;
      });
      _this.chartInstance = undefined;
      return _this;
    }
    _createClass(ChartComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.renderChart();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        if (this.props.redraw) {
          this.destroyChart();
          this.renderChart();
          return;
        }
        this.updateChart();
      }
    }, {
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps) {
        var _this$props2 = this.props,
          type = _this$props2.type,
          options = _this$props2.options,
          plugins = _this$props2.plugins,
          legend = _this$props2.legend,
          height = _this$props2.height,
          width = _this$props2.width;
        if (nextProps.redraw === true) {
          return true;
        }
        if (height !== nextProps.height || width !== nextProps.width) {
          return true;
        }
        if (type !== nextProps.type) {
          return true;
        }
        if (!(0, _isEqual["default"])(legend, nextProps.legend)) {
          return true;
        }
        if (!(0, _isEqual["default"])(options, nextProps.options)) {
          return true;
        }
        var nextData = this.transformDataProp(nextProps);
        if (!(0, _isEqual["default"])(this.shadowDataProp, nextData)) {
          return true;
        }
        return !(0, _isEqual["default"])(plugins, nextProps.plugins);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.destroyChart();
      }
    }, {
      key: "transformDataProp",
      value: function transformDataProp(props) {
        var data = props.data;
        if (typeof data == 'function') {
          var node = this.element;
          return data(node);
        } else {
          return data;
        }
      }
    }, {
      key: "memoizeDataProps",
      value: function memoizeDataProps() {
        if (!this.props.data) {
          return;
        }
        var data = this.transformDataProp(this.props);
        this.shadowDataProp = _objectSpread(_objectSpread({}, data), {}, {
          datasets: data.datasets && data.datasets.map(function (set) {
            return _objectSpread({}, set);
          })
        });
        this.saveCurrentDatasets();
        return data;
      }
    }, {
      key: "checkDatasets",
      value: function checkDatasets(datasets) {
        var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
        var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
        var multipleDatasets = datasets.length > 1;
        if (isDev && multipleDatasets && !usingCustomKeyProvider) {
          var shouldWarn = false;
          datasets.forEach(function (dataset) {
            if (!dataset.label) {
              shouldWarn = true;
            }
          });
          if (shouldWarn) {
            console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
          }
        }
      }
    }, {
      key: "getCurrentDatasets",
      value: function getCurrentDatasets() {
        return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
      }
    }, {
      key: "saveCurrentDatasets",
      value: function saveCurrentDatasets() {
        var _this2 = this;
        this.datasets = this.datasets || {};
        var currentDatasets = this.getCurrentDatasets();
        currentDatasets.forEach(function (d) {
          _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
        });
      }
    }, {
      key: "updateChart",
      value: function updateChart() {
        var _this3 = this;
        var options = this.props.options;
        var data = this.memoizeDataProps(this.props);
        if (!this.chartInstance) return;
        if (options) {
          this.chartInstance.options = _chart["default"].helpers.configMerge(this.chartInstance.options, options);
        }
        var currentDatasets = this.getCurrentDatasets();
        var nextDatasets = data.datasets || [];
        this.checkDatasets(currentDatasets);
        var currentDatasetsIndexed = (0, _keyBy["default"])(currentDatasets, this.props.datasetKeyProvider);
        this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
          var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];
          if (current && current.type === next.type && next.data) {
            current.data.splice(next.data.length);
            next.data.forEach(function (point, pid) {
              current.data[pid] = next.data[pid];
            });
            var otherProps = _objectWithoutProperties(next, ["data"]);
            return _objectSpread(_objectSpread({}, current), otherProps);
          } else {
            return next;
          }
        });
        var rest = _objectWithoutProperties(data, ["datasets"]);
        this.chartInstance.config.data = _objectSpread(_objectSpread({}, this.chartInstance.config.data), rest);
        this.chartInstance.update();
      }
    }, {
      key: "renderChart",
      value: function renderChart() {
        var _this$props3 = this.props,
          options = _this$props3.options,
          legend = _this$props3.legend,
          type = _this$props3.type,
          plugins = _this$props3.plugins;
        var node = this.element;
        var data = this.memoizeDataProps();
        if (typeof legend !== 'undefined' && !(0, _isEqual["default"])(ChartComponent.defaultProps.legend, legend)) {
          options.legend = legend;
        }
        this.chartInstance = new _chart["default"](node, {
          type: type,
          data: data,
          options: options,
          plugins: plugins
        });
      }
    }, {
      key: "destroyChart",
      value: function destroyChart() {
        if (!this.chartInstance) {
          return;
        }
        this.saveCurrentDatasets();
        var datasets = Object.values(this.datasets);
        this.chartInstance.config.data.datasets = datasets;
        this.chartInstance.destroy();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props4 = this.props,
          height = _this$props4.height,
          width = _this$props4.width,
          id = _this$props4.id;
        return /*#__PURE__*/_react["default"].createElement("canvas", {
          ref: this.ref,
          height: height,
          width: width,
          id: id,
          onClick: this.handleOnClick
        });
      }
    }]);
    return ChartComponent;
  }(_react["default"].Component);
  _defineProperty(ChartComponent, "getLabelAsKey", function (d) {
    return d.label;
  });
  _defineProperty(ChartComponent, "propTypes", {
    data: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]).isRequired,
    getDatasetAtEvent: _propTypes["default"].func,
    getElementAtEvent: _propTypes["default"].func,
    getElementsAtEvent: _propTypes["default"].func,
    height: _propTypes["default"].number,
    legend: _propTypes["default"].object,
    onElementsClick: _propTypes["default"].func,
    options: _propTypes["default"].object,
    plugins: _propTypes["default"].arrayOf(_propTypes["default"].object),
    redraw: _propTypes["default"].bool,
    type: function type(props, propName, componentName) {
      if (!_chart["default"].controllers[props[propName]]) {
        return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
      }
    },
    width: _propTypes["default"].number,
    datasetKeyProvider: _propTypes["default"].func
  });
  _defineProperty(ChartComponent, "defaultProps", {
    legend: {
      display: true,
      position: 'bottom'
    },
    type: 'doughnut',
    height: 150,
    width: 300,
    redraw: false,
    options: {},
    datasetKeyProvider: ChartComponent.getLabelAsKey
  });
  var _default = ChartComponent;
  exports["default"] = _default;
  var Doughnut = /*#__PURE__*/function (_React$Component2) {
    _inherits(Doughnut, _React$Component2);
    var _super2 = _createSuper(Doughnut);
    function Doughnut() {
      _classCallCheck(this, Doughnut);
      return _super2.apply(this, arguments);
    }
    _createClass(Doughnut, [{
      key: "render",
      value: function render() {
        var _this4 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref) {
            return _this4.chartInstance = _ref && _ref.chartInstance;
          },
          type: "doughnut"
        }));
      }
    }]);
    return Doughnut;
  }(_react["default"].Component);
  exports.Doughnut = Doughnut;
  var Pie = /*#__PURE__*/function (_React$Component3) {
    _inherits(Pie, _React$Component3);
    var _super3 = _createSuper(Pie);
    function Pie() {
      _classCallCheck(this, Pie);
      return _super3.apply(this, arguments);
    }
    _createClass(Pie, [{
      key: "render",
      value: function render() {
        var _this5 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref2) {
            return _this5.chartInstance = _ref2 && _ref2.chartInstance;
          },
          type: "pie"
        }));
      }
    }]);
    return Pie;
  }(_react["default"].Component);
  exports.Pie = Pie;
  var Line = /*#__PURE__*/function (_React$Component4) {
    _inherits(Line, _React$Component4);
    var _super4 = _createSuper(Line);
    function Line() {
      _classCallCheck(this, Line);
      return _super4.apply(this, arguments);
    }
    _createClass(Line, [{
      key: "render",
      value: function render() {
        var _this6 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref3) {
            return _this6.chartInstance = _ref3 && _ref3.chartInstance;
          },
          type: "line"
        }));
      }
    }]);
    return Line;
  }(_react["default"].Component);
  exports.Line = Line;
  var Bar = /*#__PURE__*/function (_React$Component5) {
    _inherits(Bar, _React$Component5);
    var _super5 = _createSuper(Bar);
    function Bar() {
      _classCallCheck(this, Bar);
      return _super5.apply(this, arguments);
    }
    _createClass(Bar, [{
      key: "render",
      value: function render() {
        var _this7 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref4) {
            return _this7.chartInstance = _ref4 && _ref4.chartInstance;
          },
          type: "bar"
        }));
      }
    }]);
    return Bar;
  }(_react["default"].Component);
  exports.Bar = Bar;
  var HorizontalBar = /*#__PURE__*/function (_React$Component6) {
    _inherits(HorizontalBar, _React$Component6);
    var _super6 = _createSuper(HorizontalBar);
    function HorizontalBar() {
      _classCallCheck(this, HorizontalBar);
      return _super6.apply(this, arguments);
    }
    _createClass(HorizontalBar, [{
      key: "render",
      value: function render() {
        var _this8 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref5) {
            return _this8.chartInstance = _ref5 && _ref5.chartInstance;
          },
          type: "horizontalBar"
        }));
      }
    }]);
    return HorizontalBar;
  }(_react["default"].Component);
  exports.HorizontalBar = HorizontalBar;
  var Radar = /*#__PURE__*/function (_React$Component7) {
    _inherits(Radar, _React$Component7);
    var _super7 = _createSuper(Radar);
    function Radar() {
      _classCallCheck(this, Radar);
      return _super7.apply(this, arguments);
    }
    _createClass(Radar, [{
      key: "render",
      value: function render() {
        var _this9 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref6) {
            return _this9.chartInstance = _ref6 && _ref6.chartInstance;
          },
          type: "radar"
        }));
      }
    }]);
    return Radar;
  }(_react["default"].Component);
  exports.Radar = Radar;
  var Polar = /*#__PURE__*/function (_React$Component8) {
    _inherits(Polar, _React$Component8);
    var _super8 = _createSuper(Polar);
    function Polar() {
      _classCallCheck(this, Polar);
      return _super8.apply(this, arguments);
    }
    _createClass(Polar, [{
      key: "render",
      value: function render() {
        var _this10 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref7) {
            return _this10.chartInstance = _ref7 && _ref7.chartInstance;
          },
          type: "polarArea"
        }));
      }
    }]);
    return Polar;
  }(_react["default"].Component);
  exports.Polar = Polar;
  var Bubble = /*#__PURE__*/function (_React$Component9) {
    _inherits(Bubble, _React$Component9);
    var _super9 = _createSuper(Bubble);
    function Bubble() {
      _classCallCheck(this, Bubble);
      return _super9.apply(this, arguments);
    }
    _createClass(Bubble, [{
      key: "render",
      value: function render() {
        var _this11 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref8) {
            return _this11.chartInstance = _ref8 && _ref8.chartInstance;
          },
          type: "bubble"
        }));
      }
    }]);
    return Bubble;
  }(_react["default"].Component);
  exports.Bubble = Bubble;
  var Scatter = /*#__PURE__*/function (_React$Component10) {
    _inherits(Scatter, _React$Component10);
    var _super10 = _createSuper(Scatter);
    function Scatter() {
      _classCallCheck(this, Scatter);
      return _super10.apply(this, arguments);
    }
    _createClass(Scatter, [{
      key: "render",
      value: function render() {
        var _this12 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref9) {
            return _this12.chartInstance = _ref9 && _ref9.chartInstance;
          },
          type: "scatter"
        }));
      }
    }]);
    return Scatter;
  }(_react["default"].Component);
  exports.Scatter = Scatter;
  var defaults = _chart["default"].defaults;
  exports.defaults = defaults;
});
unwrapExports(es$1);
var es_8 = es$1.Bar;
var es_11 = es$1.Doughnut;

var CircleChart = function CircleChart(_ref) {
  var dataset = _ref.dataset,
    label = _ref.label,
    number = _ref.number,
    sublabel = _ref.sublabel,
    _ref$border = _ref.border,
    border = _ref$border === void 0 ? true : _ref$border;
  var noData = _.isNull(dataset.data);
  var data = {
    datasets: [{
      borderWidth: noData ? 0 : 4,
      borderColor: "white",
      hoverBorderColor: "white",
      data: noData ? [100] : [].concat(dataset.data),
      backgroundColor: noData ? ["#b3b3b3"] : [].concat(dataset.backgroundColor)
    }]
  };
  var options = {
    cutoutPercentage: noData ? 86 : 80,
    layout: {
      padding: noData ? 4 : 0
    },
    legend: {
      display: false
    },
    maintainAspectRatio: false,
    responsive: true
  };
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "CircleChart"
  }, border && /*#__PURE__*/React__default__default__default__default.createElement(es_11, {
    data: data,
    options: options,
    width: "136px"
  }), /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "CircleChart__data flex v-center h-center column"
  }, /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "CircleChart__data__title"
  }, number), /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "CircleChart__data__description"
  }, /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "bold"
  }, label), sublabel)));
};

var NumberInput = function NumberInput(_ref) {
  var label = _ref.label,
    name = _ref.name,
    defaultValue = _ref.defaultValue,
    min = _ref.min,
    max = _ref.max,
    required = _ref.required,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus;
  var _useFormContext = useFormContext(),
    errors = _useFormContext.errors,
    control = _useFormContext.control;
  var minNumber = min;
  var maxNumber = max;
  return /*#__PURE__*/React__default__default__default__default.createElement(Controller, {
    defaultValue: defaultValue,
    name: name,
    control: control,
    rules: {
      required: {
        value: required
      },
      min: {
        value: minNumber
      },
      max: {
        value: maxNumber
      }
    },
    render: function render(_ref2) {
      var _onChange = _ref2.onChange,
        _onBlur = _ref2.onBlur,
        value = _ref2.value,
        ref = _ref2.ref;
      return /*#__PURE__*/React__default__default__default__default.createElement(TextField$1, {
        label: label,
        autoFocus: autoFocus,
        onChange: function onChange(e) {
          _onChange(e.target.value);
        },
        onBlur: function onBlur(e) {
          var currentValue = Number(e.target.value);
          if (currentValue < minNumber || !currentValue) {
            _onChange(String(minNumber));
          } else if (currentValue > maxNumber) {
            _onChange(String(maxNumber));
          } else {
            _onChange(e.target.value);
          }
          _onBlur();
        },
        onFocus: function onFocus(event) {
          event.target.select();
        },
        onKeyDown: function onKeyDown(evnt) {
          var allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Tab"];
          if (!/[0-9]/.test(evnt.key) && !allowedKeys.includes(evnt.key)) {
            evnt.preventDefault();
          }
        },
        inputRef: ref,
        value: value || "",
        error: errors[name] ? true : false,
        role: "textbox",
        variant: "outlined",
        type: "number",
        inputProps: {
          min: minNumber,
          max: maxNumber
        }
      });
    }
  });
};

var FileInput = function FileInput(_ref) {
  var trigger = _ref.trigger,
    onChange = _ref.onChange,
    _ref$accept = _ref.accept,
    accept = _ref$accept === void 0 ? "image/*" : _ref$accept;
  var fileRef = useRef();
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "FileInput"
  }, /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "FileInput__trigger",
    onClick: function onClick() {
      return fileRef.current.click();
    }
  }, trigger), /*#__PURE__*/React__default__default__default__default.createElement("input", {
    type: "file",
    ref: fileRef,
    hidden: true,
    onChange: onChange,
    accept: accept
  }));
};

var _excluded = ["label", "error", "helperText"];
var Input$1 = function Input(_ref) {
  var label = _ref.label,
    error = _ref.error,
    helperText = _ref.helperText,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useState = useState(false),
    showPassword = _useState[0],
    setShowPassword = _useState[1];
  var handleClickShowPassword = function handleClickShowPassword() {
    setShowPassword(!showPassword);
  };
  var handleMouseDownPassword = function handleMouseDownPassword(event) {
    event.preventDefault();
  };
  return /*#__PURE__*/React__default__default__default__default.createElement(FormControl, {
    variant: "outlined",
    error: error
  }, /*#__PURE__*/React__default__default__default__default.createElement(InputLabel, {
    htmlFor: "outlined-adornment-password"
  }, label), /*#__PURE__*/React__default__default__default__default.createElement(OutlinedInput, _extends({
    id: "outlined-adornment-password",
    type: showPassword ? "text" : "password"
  }, props, {
    endAdornment: /*#__PURE__*/React__default__default__default__default.createElement(InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React__default__default__default__default.createElement(IconButton, {
      "aria-label": "toggle password visibility",
      onClick: handleClickShowPassword,
      onMouseDown: handleMouseDownPassword,
      edge: "end"
    }, showPassword ? /*#__PURE__*/React__default__default__default__default.createElement(Visibility, null) : /*#__PURE__*/React__default__default__default__default.createElement(VisibilityOff, null))),
    labelWidth: 70
  })), error && /*#__PURE__*/React__default__default__default__default.createElement(FormHelperText, {
    id: "component-error-text"
  }, helperText));
};
var Password = function Password(props) {
  var label = props.label,
    name = props.name,
    errorobj = props.errorobj;
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var isError = false;
  var errorMessage = "";
  if (errorobj && errorobj.hasOwnProperty(name)) {
    isError = true;
    errorMessage = errorobj[name].message || "Campo requerido";
  }
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "Input"
  }, /*#__PURE__*/React__default__default__default__default.createElement(Controller, _extends({
    as: Input$1,
    name: name,
    control: control,
    defaultValue: "",
    label: label,
    variant: "outlined",
    required: true,
    rules: {
      required: true
    },
    error: isError,
    helperText: errorMessage
  }, props)));
};

function r$1(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r$1(e[t])) && (n && (n += " "), n += f);else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) (e = arguments[f++]) && (t = r$1(e)) && (n && (n += " "), n += t);
  return n;
}

var clsx_m = {
  __proto__: null,
  clsx: clsx,
  'default': clsx
};

var require$$1 = getCjsExportFromNamespace(clsx_m);

var dist = createCommonjsModule(function (module) {
  module.exports = function (n) {
    var e = {};
    function t(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return n[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }
    return t.m = n, t.c = e, t.d = function (n, e, r) {
      t.o(n, e) || Object.defineProperty(n, e, {
        enumerable: !0,
        get: r
      });
    }, t.r = function (n) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(n, "__esModule", {
        value: !0
      });
    }, t.t = function (n, e) {
      if (1 & e && (n = t(n)), 8 & e) return n;
      if (4 & e && "object" == typeof n && n && n.__esModule) return n;
      var r = Object.create(null);
      if (t.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: n
      }), 2 & e && "string" != typeof n) for (var o in n) t.d(r, o, function (e) {
        return n[e];
      }.bind(null, o));
      return r;
    }, t.n = function (n) {
      var e = n && n.__esModule ? function () {
        return n["default"];
      } : function () {
        return n;
      };
      return t.d(e, "a", e), e;
    }, t.o = function (n, e) {
      return Object.prototype.hasOwnProperty.call(n, e);
    }, t.p = "", t(t.s = 182);
  }([function (n, e, t) {
    n.exports = t(174)();
  }, function (n, e) {
    n.exports = React__default__default__default__default;
  }, function (n, e) {
    var t = Array.isArray;
    n.exports = t;
  }, function (n, e, t) {
    var r = t(40),
      o = "object" == typeof self && self && self.Object === Object && self,
      a = r || o || Function("return this")();
    n.exports = a;
  }, function (n, e, t) {
    var r = t(78),
      o = t(25),
      a = t(27),
      i = t(28);
    n.exports = function (n, e, t) {
      return n = i(n), t = null == t ? 0 : r(a(t), 0, n.length), e = o(e), n.slice(t, t + e.length) == e;
    };
  }, function (n, e, t) {
    var r = t(171)(t(23));
    n.exports = r;
  }, function (n, e, t) {
    var r = t(14),
      o = t(76),
      a = t(77),
      i = "[object Null]",
      u = "[object Undefined]",
      c = r ? r.toStringTag : void 0;
    n.exports = function (n) {
      return null == n ? void 0 === n ? u : i : c && c in Object(n) ? o(n) : a(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return null != n && "object" == typeof n;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = typeof n;
      return null != n && ("object" == e || "function" == e);
    };
  }, function (n, e, t) {
    var r = t(92),
      o = t(95);
    n.exports = function (n, e) {
      var t = o(n, e);
      return r(t) ? t : void 0;
    };
  }, function (n, e, t) {
    var r = t(111),
      o = t(150),
      a = t(157),
      i = t(2),
      u = t(158);
    n.exports = function (n) {
      return "function" == typeof n ? n : null == n ? a : "object" == typeof n ? i(n) ? o(n[0], n[1]) : r(n) : u(n);
    };
  }, function (n, e, t) {
    var r = t(44),
      o = t(34);
    n.exports = function (n) {
      return null != n && o(n.length) && !r(n);
    };
  }, function (n, e, t) {
    var r = t(133),
      o = t(140),
      a = t(11);
    n.exports = function (n) {
      return a(n) ? r(n) : o(n);
    };
  }, function (n, e, t) {
    var r = t(26),
      o = t(10),
      a = t(168),
      i = t(2);
    n.exports = function (n, e) {
      return (i(n) ? r : a)(n, o(e, 3));
    };
  }, function (n, e, t) {
    var r = t(3).Symbol;
    n.exports = r;
  }, function (n, e, t) {
    var r = t(6),
      o = t(7),
      a = "[object Symbol]";
    n.exports = function (n) {
      return "symbol" == typeof n || o(n) && r(n) == a;
    };
  }, function (n, e, t) {
    var r = t(9)(Object, "create");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(100),
      o = t(101),
      a = t(102),
      i = t(103),
      u = t(104);
    function c(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }
    c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e, t) {
    var r = t(31);
    n.exports = function (n, e) {
      for (var t = n.length; t--;) if (r(n[t][0], e)) return t;
      return -1;
    };
  }, function (n, e, t) {
    var r = t(106);
    n.exports = function (n, e) {
      var t = n.__data__;
      return r(e) ? t["string" == typeof e ? "string" : "hash"] : t.map;
    };
  }, function (n, e, t) {
    var r = t(15),
      o = 1 / 0;
    n.exports = function (n) {
      if ("string" == typeof n || r(n)) return n;
      var e = n + "";
      return "0" == e && 1 / n == -o ? "-0" : e;
    };
  }, function (n, e, t) {
    var r = t(164),
      o = t(167)(r);
    n.exports = o;
  }, function (n, e, t) {
    var r = t(30),
      o = "Expected a function";
    function a(n, e) {
      if ("function" != typeof n || null != e && "function" != typeof e) throw new TypeError(o);
      var t = function t() {
        var r = arguments,
          o = e ? e.apply(this, r) : r[0],
          a = t.cache;
        if (a.has(o)) return a.get(o);
        var i = n.apply(this, r);
        return t.cache = a.set(o, i) || a, i;
      };
      return t.cache = new (a.Cache || r)(), t;
    }
    a.Cache = r, n.exports = a;
  }, function (n, e, t) {
    var r = t(43),
      o = t(10),
      a = t(27),
      i = Math.max;
    n.exports = function (n, e, t) {
      var u = null == n ? 0 : n.length;
      if (!u) return -1;
      var c = null == t ? 0 : a(t);
      return c < 0 && (c = i(u + c, 0)), r(n, o(e, 3), c);
    };
  }, function (n, e, t) {
    var r = t(50),
      o = t(163),
      a = t(10),
      i = t(2);
    n.exports = function (n, e) {
      return (i(n) ? r : o)(n, a(e, 3));
    };
  }, function (n, e, t) {
    var r = t(14),
      o = t(26),
      a = t(2),
      i = t(15),
      u = 1 / 0,
      c = r ? r.prototype : void 0,
      s = c ? c.toString : void 0;
    n.exports = function n(e) {
      if ("string" == typeof e) return e;
      if (a(e)) return o(e, n) + "";
      if (i(e)) return s ? s.call(e) : "";
      var t = e + "";
      return "0" == t && 1 / e == -u ? "-0" : t;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length, o = Array(r); ++t < r;) o[t] = e(n[t], t, n);
      return o;
    };
  }, function (n, e, t) {
    var r = t(79);
    n.exports = function (n) {
      var e = r(n),
        t = e % 1;
      return e == e ? t ? e - t : e : 0;
    };
  }, function (n, e, t) {
    var r = t(25);
    n.exports = function (n) {
      return null == n ? "" : r(n);
    };
  }, function (n, e, t) {
    var r = t(43),
      o = t(82),
      a = t(83);
    n.exports = function (n, e, t) {
      return e == e ? a(n, e, t) : r(n, o, t);
    };
  }, function (n, e, t) {
    var r = t(89),
      o = t(105),
      a = t(107),
      i = t(108),
      u = t(109);
    function c(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }
    c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e) {
    n.exports = function (n, e) {
      return n === e || n != n && e != e;
    };
  }, function (n, e, t) {
    var r = t(9)(t(3), "Map");
    n.exports = r;
  }, function (n, e) {
    var t = 9007199254740991,
      r = /^(?:0|[1-9]\d*)$/;
    n.exports = function (n, e) {
      var o = typeof n;
      return !!(e = null == e ? t : e) && ("number" == o || "symbol" != o && r.test(n)) && n > -1 && n % 1 == 0 && n < e;
    };
  }, function (n, e) {
    var t = 9007199254740991;
    n.exports = function (n) {
      return "number" == typeof n && n > -1 && n % 1 == 0 && n <= t;
    };
  }, function (n, e, t) {
    var r = t(2),
      o = t(15),
      a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      i = /^\w*$/;
    n.exports = function (n, e) {
      if (r(n)) return !1;
      var t = typeof n;
      return !("number" != t && "symbol" != t && "boolean" != t && null != n && !o(n)) || i.test(n) || !a.test(n) || null != e && n in Object(e);
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(2),
      a = t(7),
      i = "[object String]";
    n.exports = function (n) {
      return "string" == typeof n || !o(n) && a(n) && r(n) == i;
    };
  }, function (n, e, t) {
    var r = t(169),
      o = t(21),
      a = t(10),
      i = t(170),
      u = t(2);
    n.exports = function (n, e, t) {
      var c = u(n) ? r : i,
        s = arguments.length < 3;
      return c(n, a(e, 4), t, s, o);
    };
  }, function (n, e, t) {
    var r = t(49),
      o = t(10),
      a = t(172),
      i = t(2),
      u = t(173);
    n.exports = function (n, e, t) {
      var c = i(n) ? r : a;
      return t && u(n, e, t) && (e = void 0), c(n, o(e, 3));
    };
  }, function (n, e) {
    var t;
    function r(n, e) {
      var t = Object.keys(n);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(n);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        })), t.push.apply(t, r);
      }
      return t;
    }
    function o(n, e, t) {
      return e in n ? Object.defineProperty(n, e, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[e] = t, n;
    }
    function a(n, e) {
      return function (n) {
        if (Array.isArray(n)) return n;
      }(n) || function (n, e) {
        if (!(Symbol.iterator in Object(n) || "[object Arguments]" === Object.prototype.toString.call(n))) return;
        var t = [],
          r = !0,
          o = !1,
          a = void 0;
        try {
          for (var i, u = n[Symbol.iterator](); !(r = (i = u.next()).done) && (t.push(i.value), !e || t.length !== e); r = !0);
        } catch (n) {
          o = !0, a = n;
        } finally {
          try {
            r || null == u["return"] || u["return"]();
          } finally {
            if (o) throw a;
          }
        }
        return t;
      }(n, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }
    var i = {};
    function u(n, e, t) {
      e in i || (i[e] = []);
      var r = t || 0;
      i[e][r] = n;
    }
    var c,
      s = (t = []).concat.apply(t, function (n) {
        if (Array.isArray(n)) {
          for (var e = 0, t = new Array(n.length); e < n.length; e++) t[e] = n[e];
          return t;
        }
      }(c = [["Afghanistan", ["asia"], "af", "93"], ["Albania", ["europe"], "al", "355"], ["Algeria", ["africa", "north-africa"], "dz", "213"], ["American Samoa", ["oceania"], "as", "1684"], ["Andorra", ["europe"], "ad", "376"], ["Angola", ["africa"], "ao", "244"], ["Anguilla", ["america", "carribean"], "ai", "1264"], ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"], ["Argentina", ["america", "south-america"], "ar", "54", "+.. (..) ........"], ["Armenia", ["asia", "ex-ussr"], "am", "374"], ["Aruba", ["america", "carribean"], "aw", "297"], ["Australia", ["oceania"], "au", "61", "+.. ... ... ..."], ["Austria", ["europe", "european-union"], "at", "43"], ["Azerbaijan", ["asia", "ex-ussr"], "az", "994"], ["Bahamas", ["america", "carribean"], "bs", "1242"], ["Bahrain", ["middle-east"], "bh", "973"], ["Bangladesh", ["asia"], "bd", "880"], ["Barbados", ["america", "carribean"], "bb", "1246"], ["Belarus", ["europe", "ex-ussr"], "by", "375", "+... (..) ... .. .."], ["Belgium", ["europe", "european-union"], "be", "32", "+.. ... .. .. .."], ["Belize", ["america", "central-america"], "bz", "501"], ["Benin", ["africa"], "bj", "229"], ["Bermuda", ["america", "north-america"], "bm", "1441"], ["Bhutan", ["asia"], "bt", "975"], ["Bolivia", ["america", "south-america"], "bo", "591"], ["Bosnia and Herzegovina", ["europe"], "ba", "387"], ["Botswana", ["africa"], "bw", "267"], ["Brazil", ["america", "south-america"], "br", "55", "+.. (..) ........."], ["British Indian Ocean Territory", ["asia"], "io", "246"], ["British Virgin Islands", ["america", "carribean"], "vg", "1284"], ["Brunei", ["asia"], "bn", "673"], ["Bulgaria", ["europe", "european-union"], "bg", "359"], ["Burkina Faso", ["africa"], "bf", "226"], ["Burundi", ["africa"], "bi", "257"], ["Cambodia", ["asia"], "kh", "855"], ["Cameroon", ["africa"], "cm", "237"], ["Canada", ["america", "north-america"], "ca", "1", "+. (...) ...-....", 1, ["204", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde", ["africa"], "cv", "238"], ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1], ["Cayman Islands", ["america", "carribean"], "ky", "1345"], ["Central African Republic", ["africa"], "cf", "236"], ["Chad", ["africa"], "td", "235"], ["Chile", ["america", "south-america"], "cl", "56"], ["China", ["asia"], "cn", "86", "+.. ..-........."], ["Colombia", ["america", "south-america"], "co", "57"], ["Comoros", ["africa"], "km", "269"], ["Congo", ["africa"], "cd", "243"], ["Congo", ["africa"], "cg", "242"], ["Cook Islands", ["oceania"], "ck", "682"], ["Costa Rica", ["america", "central-america"], "cr", "506", "+... ....-...."], ["Côte d’Ivoire", ["africa"], "ci", "225"], ["Croatia", ["europe", "european-union"], "hr", "385"], ["Cuba", ["america", "carribean"], "cu", "53"], ["Curaçao", ["america", "carribean"], "cw", "599", "", 0], ["Cyprus", ["europe", "european-union"], "cy", "357", "+... .. ......"], ["Czech Republic", ["europe", "european-union"], "cz", "420"], ["Denmark", ["europe", "european-union"], "dk", "45", "+.. .. .. .. .."], ["Djibouti", ["africa"], "dj", "253"], ["Dominica", ["america", "carribean"], "dm", "1767"], ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2, ["809", "829", "849"]], ["Ecuador", ["america", "south-america"], "ec", "593"], ["Egypt", ["africa", "north-africa"], "eg", "20"], ["El Salvador", ["america", "central-america"], "sv", "503", "+... ....-...."], ["Equatorial Guinea", ["africa"], "gq", "240"], ["Eritrea", ["africa"], "er", "291"], ["Estonia", ["europe", "european-union", "ex-ussr"], "ee", "372", "+... .... ......"], ["Ethiopia", ["africa"], "et", "251"], ["Falkland Islands", ["america", "south-america"], "fk", "500"], ["Faroe Islands", ["europe"], "fo", "298"], ["Fiji", ["oceania"], "fj", "679"], ["Finland", ["europe", "european-union"], "fi", "358", "+... .. ... .. .."], ["France", ["europe", "european-union"], "fr", "33", "+.. . .. .. .. .."], ["French Guiana", ["america", "south-america"], "gf", "594"], ["French Polynesia", ["oceania"], "pf", "689"], ["Gabon", ["africa"], "ga", "241"], ["Gambia", ["africa"], "gm", "220"], ["Georgia", ["asia", "ex-ussr"], "ge", "995"], ["Germany", ["europe", "european-union"], "de", "49", "+.. .... ........"], ["Ghana", ["africa"], "gh", "233"], ["Gibraltar", ["europe"], "gi", "350"], ["Greece", ["europe", "european-union"], "gr", "30"], ["Greenland", ["america"], "gl", "299"], ["Grenada", ["america", "carribean"], "gd", "1473"], ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0], ["Guam", ["oceania"], "gu", "1671"], ["Guatemala", ["america", "central-america"], "gt", "502", "+... ....-...."], ["Guinea", ["africa"], "gn", "224"], ["Guinea-Bissau", ["africa"], "gw", "245"], ["Guyana", ["america", "south-america"], "gy", "592"], ["Haiti", ["america", "carribean"], "ht", "509", "+... ....-...."], ["Honduras", ["america", "central-america"], "hn", "504"], ["Hong Kong", ["asia"], "hk", "852", "+... .... ...."], ["Hungary", ["europe", "european-union"], "hu", "36"], ["Iceland", ["europe"], "is", "354", "+... ... ...."], ["India", ["asia"], "in", "91", "+.. .....-....."], ["Indonesia", ["asia"], "id", "62"], ["Iran", ["middle-east"], "ir", "98"], ["Iraq", ["middle-east"], "iq", "964"], ["Ireland", ["europe", "european-union"], "ie", "353", "+... .. ......."], ["Israel", ["middle-east"], "il", "972", "+... ... ... ...."], ["Italy", ["europe", "european-union"], "it", "39", "+.. ... .......", 0], ["Jamaica", ["america", "carribean"], "jm", "1876"], ["Japan", ["asia"], "jp", "81", "+.. .. .... ...."], ["Jordan", ["middle-east"], "jo", "962"], ["Kazakhstan", ["asia", "ex-ussr"], "kz", "7", "+. ... ...-..-..", 1, ["313", "327", "7172", "312", "73622", "321", "324", "336", "318", "315", "325", "311", "326", "310"]], ["Kenya", ["africa"], "ke", "254"], ["Kiribati", ["oceania"], "ki", "686"], ["Kuwait", ["middle-east"], "kw", "965"], ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996"], ["Laos", ["asia"], "la", "856"], ["Latvia", ["europe", "european-union", "ex-ussr"], "lv", "371"], ["Lebanon", ["middle-east"], "lb", "961"], ["Lesotho", ["africa"], "ls", "266"], ["Liberia", ["africa"], "lr", "231"], ["Libya", ["africa", "north-africa"], "ly", "218"], ["Liechtenstein", ["europe"], "li", "423"], ["Lithuania", ["europe", "european-union", "ex-ussr"], "lt", "370"], ["Luxembourg", ["europe", "european-union"], "lu", "352"], ["Macau", ["asia"], "mo", "853"], ["Macedonia", ["europe"], "mk", "389"], ["Madagascar", ["africa"], "mg", "261"], ["Malawi", ["africa"], "mw", "265"], ["Malaysia", ["asia"], "my", "60", "+.. ..-....-...."], ["Maldives", ["asia"], "mv", "960"], ["Mali", ["africa"], "ml", "223"], ["Malta", ["europe", "european-union"], "mt", "356"], ["Marshall Islands", ["oceania"], "mh", "692"], ["Martinique", ["america", "carribean"], "mq", "596"], ["Mauritania", ["africa"], "mr", "222"], ["Mauritius", ["africa"], "mu", "230"], ["Mexico", ["america", "central-america"], "mx", "52"], ["Micronesia", ["oceania"], "fm", "691"], ["Moldova", ["europe"], "md", "373", "+... (..) ..-..-.."], ["Monaco", ["europe"], "mc", "377"], ["Mongolia", ["asia"], "mn", "976"], ["Montenegro", ["europe"], "me", "382"], ["Montserrat", ["america", "carribean"], "ms", "1664"], ["Morocco", ["africa", "north-africa"], "ma", "212"], ["Mozambique", ["africa"], "mz", "258"], ["Myanmar", ["asia"], "mm", "95"], ["Namibia", ["africa"], "na", "264"], ["Nauru", ["africa"], "nr", "674"], ["Nepal", ["asia"], "np", "977"], ["Netherlands", ["europe", "european-union"], "nl", "31", "+.. .. ........"], ["New Caledonia", ["oceania"], "nc", "687"], ["New Zealand", ["oceania"], "nz", "64", "+.. ...-...-...."], ["Nicaragua", ["america", "central-america"], "ni", "505"], ["Niger", ["africa"], "ne", "227"], ["Nigeria", ["africa"], "ng", "234"], ["Niue", ["asia"], "nu", "683"], ["Norfolk Island", ["oceania"], "nf", "672"], ["North Korea", ["asia"], "kp", "850"], ["Northern Mariana Islands", ["oceania"], "mp", "1670"], ["Norway", ["europe"], "no", "47", "+.. ... .. ..."], ["Oman", ["middle-east"], "om", "968"], ["Pakistan", ["asia"], "pk", "92", "+.. ...-......."], ["Palau", ["oceania"], "pw", "680"], ["Palestine", ["middle-east"], "ps", "970"], ["Panama", ["america", "central-america"], "pa", "507"], ["Papua New Guinea", ["oceania"], "pg", "675"], ["Paraguay", ["america", "south-america"], "py", "595"], ["Peru", ["america", "south-america"], "pe", "51"], ["Philippines", ["asia"], "ph", "63", "+.. .... ......."], ["Poland", ["europe", "european-union"], "pl", "48", "+.. ...-...-..."], ["Portugal", ["europe", "european-union"], "pt", "351"], ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3, ["787", "939"]], ["Qatar", ["middle-east"], "qa", "974"], ["Réunion", ["africa"], "re", "262"], ["Romania", ["europe", "european-union"], "ro", "40"], ["Russia", ["europe", "asia", "ex-ussr"], "ru", "7", "+. (...) ...-..-..", 0], ["Rwanda", ["africa"], "rw", "250"], ["Saint Barthélemy", ["america", "carribean"], "bl", "590", "", 1], ["Saint Helena", ["africa"], "sh", "290"], ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"], ["Saint Lucia", ["america", "carribean"], "lc", "1758"], ["Saint Martin", ["america", "carribean"], "mf", "590", "", 2], ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"], ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"], ["Samoa", ["oceania"], "ws", "685"], ["San Marino", ["europe"], "sm", "378"], ["São Tomé and Príncipe", ["africa"], "st", "239"], ["Saudi Arabia", ["middle-east"], "sa", "966"], ["Senegal", ["africa"], "sn", "221"], ["Serbia", ["europe"], "rs", "381"], ["Seychelles", ["africa"], "sc", "248"], ["Sierra Leone", ["africa"], "sl", "232"], ["Singapore", ["asia"], "sg", "65", "+.. ....-...."], ["Sint Maarten", ["america", "carribean"], "sx", "1721"], ["Slovakia", ["europe", "european-union"], "sk", "421"], ["Slovenia", ["europe", "european-union"], "si", "386"], ["Solomon Islands", ["oceania"], "sb", "677"], ["Somalia", ["africa"], "so", "252"], ["South Africa", ["africa"], "za", "27"], ["South Korea", ["asia"], "kr", "82", "+.. ... .... ...."], ["South Sudan", ["africa", "north-africa"], "ss", "211"], ["Spain", ["europe", "european-union"], "es", "34", "+.. ... ... ..."], ["Sri Lanka", ["asia"], "lk", "94"], ["Sudan", ["africa"], "sd", "249"], ["Suriname", ["america", "south-america"], "sr", "597"], ["Swaziland", ["africa"], "sz", "268"], ["Sweden", ["europe", "european-union"], "se", "46", "+.. (..) ...-..-.."], ["Switzerland", ["europe"], "ch", "41", "+.. .. ... .. .."], ["Syria", ["middle-east"], "sy", "963"], ["Taiwan", ["asia"], "tw", "886"], ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"], ["Tanzania", ["africa"], "tz", "255"], ["Thailand", ["asia"], "th", "66"], ["Timor-Leste", ["asia"], "tl", "670"], ["Togo", ["africa"], "tg", "228"], ["Tokelau", ["oceania"], "tk", "690"], ["Tonga", ["oceania"], "to", "676"], ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"], ["Tunisia", ["africa", "north-africa"], "tn", "216"], ["Turkey", ["europe"], "tr", "90", "+.. ... ... .. .."], ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"], ["Turks and Caicos Islands", ["america", "carribean"], "tc", "1649"], ["Tuvalu", ["asia"], "tv", "688"], ["U.S. Virgin Islands", ["america", "carribean"], "vi", "1340"], ["Uganda", ["africa"], "ug", "256"], ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "+... (..) ... .. .."], ["United Arab Emirates", ["middle-east"], "ae", "971"], ["United Kingdom", ["europe", "european-union"], "gb", "44", "+.. .... ......"], ["United States", ["america", "north-america"], "us", "1", "+. (...) ...-....", 0, ["907", "205", "251", "256", "334", "479", "501", "870", "480", "520", "602", "623", "928", "209", "213", "310", "323", "408", "415", "510", "530", "559", "562", "619", "626", "650", "661", "707", "714", "760", "805", "818", "831", "858", "909", "916", "925", "949", "951", "303", "719", "970", "203", "860", "202", "302", "239", "305", "321", "352", "386", "407", "561", "727", "772", "813", "850", "863", "904", "941", "954", "229", "404", "478", "706", "770", "912", "808", "319", "515", "563", "641", "712", "208", "217", "309", "312", "618", "630", "708", "773", "815", "847", "219", "260", "317", "574", "765", "812", "316", "620", "785", "913", "270", "502", "606", "859", "225", "318", "337", "504", "985", "413", "508", "617", "781", "978", "301", "410", "207", "231", "248", "269", "313", "517", "586", "616", "734", "810", "906", "989", "218", "320", "507", "612", "651", "763", "952", "314", "417", "573", "636", "660", "816", "228", "601", "662", "406", "252", "336", "704", "828", "910", "919", "701", "308", "402", "603", "201", "609", "732", "856", "908", "973", "505", "575", "702", "775", "212", "315", "516", "518", "585", "607", "631", "716", "718", "845", "914", "216", "330", "419", "440", "513", "614", "740", "937", "405", "580", "918", "503", "541", "215", "412", "570", "610", "717", "724", "814", "401", "803", "843", "864", "605", "423", "615", "731", "865", "901", "931", "210", "214", "254", "281", "325", "361", "409", "432", "512", "713", "806", "817", "830", "903", "915", "936", "940", "956", "972", "979", "435", "801", "276", "434", "540", "703", "757", "804", "802", "206", "253", "360", "425", "509", "262", "414", "608", "715", "920", "304", "307"]], ["Uruguay", ["america", "south-america"], "uy", "598"], ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998"], ["Vanuatu", ["oceania"], "vu", "678"], ["Vatican City", ["europe"], "va", "39", "+.. .. .... ....", 1], ["Venezuela", ["america", "south-america"], "ve", "58"], ["Vietnam", ["asia"], "vn", "84"], ["Wallis and Futuna", ["oceania"], "wf", "681"], ["Yemen", ["middle-east"], "ye", "967"], ["Zambia", ["africa"], "zm", "260"], ["Zimbabwe", ["africa"], "zw", "263"]].map(function (n) {
        var e = a(n, 7),
          t = e[0],
          i = e[1],
          c = e[2],
          s = e[3],
          p = e[4],
          f = e[5],
          l = e[6],
          g = {
            name: t,
            regions: i,
            iso2: c,
            dialCode: s,
            priority: f,
            format: p || void 0,
            hasAreaCodes: l
          },
          d = [];
        return g.hasAreaCodes && l.forEach(function (n) {
          var e = function (n) {
            for (var e = 1; e < arguments.length; e++) {
              var t = null != arguments[e] ? arguments[e] : {};
              e % 2 ? r(t, !0).forEach(function (e) {
                o(n, e, t[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : r(t).forEach(function (e) {
                Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(t, e));
              });
            }
            return n;
          }({}, g, {
            regions: i,
            dialCode: "".concat(s).concat(n),
            isAreaCode: !0
          });
          d.push(e), u(c, e.dialCode);
        }), u(g.iso2, g.dialCode, g.hasAreaCodes), d.length > 0 ? [g].concat(d) : [g];
      })) || function (n) {
        if (Symbol.iterator in Object(n) || "[object Arguments]" === Object.prototype.toString.call(n)) return Array.from(n);
      }(c) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }());
    n.exports = {
      allCountries: s,
      allCountryCodes: i
    };
  }, function (n, e, t) {
    (function (e) {
      var t = "object" == typeof e && e && e.Object === Object && e;
      n.exports = t;
    }).call(this, t(75));
  }, function (n, e, t) {
    var r = t(8),
      o = t(15),
      a = NaN,
      i = /^\s+|\s+$/g,
      u = /^[-+]0x[0-9a-f]+$/i,
      c = /^0b[01]+$/i,
      s = /^0o[0-7]+$/i,
      p = parseInt;
    n.exports = function (n) {
      if ("number" == typeof n) return n;
      if (o(n)) return a;
      if (r(n)) {
        var e = "function" == typeof n.valueOf ? n.valueOf() : n;
        n = r(e) ? e + "" : e;
      }
      if ("string" != typeof n) return 0 === n ? n : +n;
      n = n.replace(i, "");
      var t = c.test(n);
      return t || s.test(n) ? p(n.slice(2), t ? 2 : 8) : u.test(n) ? a : +n;
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      var r = -1,
        o = n.length;
      e < 0 && (e = -e > o ? 0 : o + e), (t = t > o ? o : t) < 0 && (t += o), o = e > t ? 0 : t - e >>> 0, e >>>= 0;
      for (var a = Array(o); ++r < o;) a[r] = n[r + e];
      return a;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r) {
      for (var o = n.length, a = t + (r ? 1 : -1); r ? a-- : ++a < o;) if (e(n[a], a, n)) return a;
      return -1;
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(8),
      a = "[object AsyncFunction]",
      i = "[object Function]",
      u = "[object GeneratorFunction]",
      c = "[object Proxy]";
    n.exports = function (n) {
      if (!o(n)) return !1;
      var e = r(n);
      return e == i || e == u || e == a || e == c;
    };
  }, function (n, e) {
    var t = Function.prototype.toString;
    n.exports = function (n) {
      if (null != n) {
        try {
          return t.call(n);
        } catch (n) {}
        try {
          return n + "";
        } catch (n) {}
      }
      return "";
    };
  }, function (n, e, t) {
    var r = t(17),
      o = t(113),
      a = t(114),
      i = t(115),
      u = t(116),
      c = t(117);
    function s(n) {
      var e = this.__data__ = new r(n);
      this.size = e.size;
    }
    s.prototype.clear = o, s.prototype["delete"] = a, s.prototype.get = i, s.prototype.has = u, s.prototype.set = c, n.exports = s;
  }, function (n, e, t) {
    var r = t(118),
      o = t(7);
    n.exports = function n(e, t, a, i, u) {
      return e === t || (null == e || null == t || !o(e) && !o(t) ? e != e && t != t : r(e, t, a, i, n, u));
    };
  }, function (n, e, t) {
    var r = t(119),
      o = t(49),
      a = t(122),
      i = 1,
      u = 2;
    n.exports = function (n, e, t, c, s, p) {
      var f = t & i,
        l = n.length,
        g = e.length;
      if (l != g && !(f && g > l)) return !1;
      var d = p.get(n);
      if (d && p.get(e)) return d == e;
      var b = -1,
        x = !0,
        A = t & u ? new r() : void 0;
      for (p.set(n, e), p.set(e, n); ++b < l;) {
        var v = n[b],
          h = e[b];
        if (c) var m = f ? c(h, v, b, e, n, p) : c(v, h, b, n, e, p);
        if (void 0 !== m) {
          if (m) continue;
          x = !1;
          break;
        }
        if (A) {
          if (!o(e, function (n, e) {
            if (!a(A, e) && (v === n || s(v, n, t, c, p))) return A.push(e);
          })) {
            x = !1;
            break;
          }
        } else if (v !== h && !s(v, h, t, c, p)) {
          x = !1;
          break;
        }
      }
      return p["delete"](n), p["delete"](e), x;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length; ++t < r;) if (e(n[t], t, n)) return !0;
      return !1;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length, o = 0, a = []; ++t < r;) {
        var i = n[t];
        e(i, t, n) && (a[o++] = i);
      }
      return a;
    };
  }, function (n, e, t) {
    var r = t(135),
      o = t(7),
      a = Object.prototype,
      i = a.hasOwnProperty,
      u = a.propertyIsEnumerable,
      c = r(function () {
        return arguments;
      }()) ? r : function (n) {
        return o(n) && i.call(n, "callee") && !u.call(n, "callee");
      };
    n.exports = c;
  }, function (n, e, t) {
    (function (n) {
      var r = t(3),
        o = t(136),
        a = e && !e.nodeType && e,
        i = a && "object" == typeof n && n && !n.nodeType && n,
        u = i && i.exports === a ? r.Buffer : void 0,
        c = (u ? u.isBuffer : void 0) || o;
      n.exports = c;
    }).call(this, t(53)(n));
  }, function (n, e) {
    n.exports = function (n) {
      return n.webpackPolyfill || (n.deprecate = function () {}, n.paths = [], n.children || (n.children = []), Object.defineProperty(n, "loaded", {
        enumerable: !0,
        get: function get() {
          return n.l;
        }
      }), Object.defineProperty(n, "id", {
        enumerable: !0,
        get: function get() {
          return n.i;
        }
      }), n.webpackPolyfill = 1), n;
    };
  }, function (n, e, t) {
    var r = t(137),
      o = t(138),
      a = t(139),
      i = a && a.isTypedArray,
      u = i ? o(i) : r;
    n.exports = u;
  }, function (n, e, t) {
    var r = t(8);
    n.exports = function (n) {
      return n == n && !r(n);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return function (t) {
        return null != t && t[n] === e && (void 0 !== e || n in Object(t));
      };
    };
  }, function (n, e, t) {
    var r = t(58),
      o = t(20);
    n.exports = function (n, e) {
      for (var t = 0, a = (e = r(e, n)).length; null != n && t < a;) n = n[o(e[t++])];
      return t && t == a ? n : void 0;
    };
  }, function (n, e, t) {
    var r = t(2),
      o = t(35),
      a = t(152),
      i = t(28);
    n.exports = function (n, e) {
      return r(n) ? n : o(n, e) ? [n] : a(i(n));
    };
  }, function (n, e) {
    n.exports = "data:image/png;base64,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";
  }, function (n, e, t) {
    var r = t(25),
      o = t(80),
      a = t(81),
      i = t(84),
      u = t(85),
      c = t(28),
      s = /^\s+|\s+$/g;
    n.exports = function (n, e, t) {
      if ((n = c(n)) && (t || void 0 === e)) return n.replace(s, "");
      if (!n || !(e = r(e))) return n;
      var p = u(n),
        f = u(e),
        l = i(p, f),
        g = a(p, f) + 1;
      return o(p, l, g).join("");
    };
  }, function (n, e, t) {
    var r = t(8),
      o = t(110),
      a = t(41),
      i = "Expected a function",
      u = Math.max,
      c = Math.min;
    n.exports = function (n, e, t) {
      var s,
        p,
        f,
        l,
        g,
        d,
        b = 0,
        x = !1,
        A = !1,
        v = !0;
      if ("function" != typeof n) throw new TypeError(i);
      function h(e) {
        var t = s,
          r = p;
        return s = p = void 0, b = e, l = n.apply(r, t);
      }
      function m(n) {
        var t = n - d;
        return void 0 === d || t >= e || t < 0 || A && n - b >= f;
      }
      function y() {
        var n = o();
        if (m(n)) return C(n);
        g = setTimeout(y, function (n) {
          var t = e - (n - d);
          return A ? c(t, f - (n - b)) : t;
        }(n));
      }
      function C(n) {
        return g = void 0, v && s ? h(n) : (s = p = void 0, l);
      }
      function k() {
        var n = o(),
          t = m(n);
        if (s = arguments, p = this, d = n, t) {
          if (void 0 === g) return function (n) {
            return b = n, g = setTimeout(y, e), x ? h(n) : l;
          }(d);
          if (A) return clearTimeout(g), g = setTimeout(y, e), h(d);
        }
        return void 0 === g && (g = setTimeout(y, e)), l;
      }
      return e = a(e) || 0, r(t) && (x = !!t.leading, f = (A = "maxWait" in t) ? u(a(t.maxWait) || 0, e) : f, v = "trailing" in t ? !!t.trailing : v), k.cancel = function () {
        void 0 !== g && clearTimeout(g), b = 0, s = d = p = g = void 0;
      }, k.flush = function () {
        return void 0 === g ? l : C(o());
      }, k;
    };
  }, function (n, e, t) {
    var r = t(42);
    n.exports = function (n) {
      var e = null == n ? 0 : n.length;
      return e ? r(n, 1, e) : [];
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n && n.length ? n[0] : void 0;
    };
  }, function (n, e, t) {
    var r = t(29),
      o = t(11),
      a = t(36),
      i = t(27),
      u = t(161),
      c = Math.max;
    n.exports = function (n, e, t, s) {
      n = o(n) ? n : u(n), t = t && !s ? i(t) : 0;
      var p = n.length;
      return t < 0 && (t = c(p + t, 0)), a(n) ? t <= p && n.indexOf(e, t) > -1 : !!p && r(n, e, t) > -1;
    };
  }, function (n, e) {
    n.exports = require$$1;
  }, function (n, e) {
    n.exports = TextField;
  }, function (n, e) {
    n.exports = InputAdornment;
  }, function (n, e) {
    n.exports = Button$2;
  }, function (n, e) {
    n.exports = Menu;
  }, function (n, e) {
    n.exports = Divider;
  }, function (n, e) {
    n.exports = NativeSelect;
  }, function (n, e) {
    n.exports = withStyles$1;
  }, function (n, e) {
    n.exports = MenuItem;
  }, function (n, e) {
    n.exports = RootRef;
  }, function (n, e) {
    var t;
    t = function () {
      return this;
    }();
    try {
      t = t || new Function("return this")();
    } catch (n) {
      "object" == typeof window && (t = window);
    }
    n.exports = t;
  }, function (n, e, t) {
    var r = t(14),
      o = Object.prototype,
      a = o.hasOwnProperty,
      i = o.toString,
      u = r ? r.toStringTag : void 0;
    n.exports = function (n) {
      var e = a.call(n, u),
        t = n[u];
      try {
        n[u] = void 0;
        var r = !0;
      } catch (n) {}
      var o = i.call(n);
      return r && (e ? n[u] = t : delete n[u]), o;
    };
  }, function (n, e) {
    var t = Object.prototype.toString;
    n.exports = function (n) {
      return t.call(n);
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      return n == n && (void 0 !== t && (n = n <= t ? n : t), void 0 !== e && (n = n >= e ? n : e)), n;
    };
  }, function (n, e, t) {
    var r = t(41),
      o = 1 / 0,
      a = 17976931348623157e292;
    n.exports = function (n) {
      return n ? (n = r(n)) === o || n === -o ? (n < 0 ? -1 : 1) * a : n == n ? n : 0 : 0 === n ? n : 0;
    };
  }, function (n, e, t) {
    var r = t(42);
    n.exports = function (n, e, t) {
      var o = n.length;
      return t = void 0 === t ? o : t, !e && t >= o ? n : r(n, e, t);
    };
  }, function (n, e, t) {
    var r = t(29);
    n.exports = function (n, e) {
      for (var t = n.length; t-- && r(e, n[t], 0) > -1;);
      return t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n != n;
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      for (var r = t - 1, o = n.length; ++r < o;) if (n[r] === e) return r;
      return -1;
    };
  }, function (n, e, t) {
    var r = t(29);
    n.exports = function (n, e) {
      for (var t = -1, o = n.length; ++t < o && r(e, n[t], 0) > -1;);
      return t;
    };
  }, function (n, e, t) {
    var r = t(86),
      o = t(87),
      a = t(88);
    n.exports = function (n) {
      return o(n) ? a(n) : r(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n.split("");
    };
  }, function (n, e) {
    var t = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
    n.exports = function (n) {
      return t.test(n);
    };
  }, function (n, e) {
    var t = "[\\ud800-\\udfff]",
      r = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
      o = "\\ud83c[\\udffb-\\udfff]",
      a = "[^\\ud800-\\udfff]",
      i = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      u = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      c = "(?:" + r + "|" + o + ")" + "?",
      s = "[\\ufe0e\\ufe0f]?" + c + ("(?:\\u200d(?:" + [a, i, u].join("|") + ")[\\ufe0e\\ufe0f]?" + c + ")*"),
      p = "(?:" + [a + r + "?", r, i, u, t].join("|") + ")",
      f = RegExp(o + "(?=" + o + ")|" + p + s, "g");
    n.exports = function (n) {
      return n.match(f) || [];
    };
  }, function (n, e, t) {
    var r = t(90),
      o = t(17),
      a = t(32);
    n.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new r(),
        map: new (a || o)(),
        string: new r()
      };
    };
  }, function (n, e, t) {
    var r = t(91),
      o = t(96),
      a = t(97),
      i = t(98),
      u = t(99);
    function c(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }
    c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e, t) {
    var r = t(16);
    n.exports = function () {
      this.__data__ = r ? r(null) : {}, this.size = 0;
    };
  }, function (n, e, t) {
    var r = t(44),
      o = t(93),
      a = t(8),
      i = t(45),
      u = /^\[object .+?Constructor\]$/,
      c = Function.prototype,
      s = Object.prototype,
      p = c.toString,
      f = s.hasOwnProperty,
      l = RegExp("^" + p.call(f).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    n.exports = function (n) {
      return !(!a(n) || o(n)) && (r(n) ? l : u).test(i(n));
    };
  }, function (n, e, t) {
    var r,
      o = t(94),
      a = (r = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";
    n.exports = function (n) {
      return !!a && a in n;
    };
  }, function (n, e, t) {
    var r = t(3)["__core-js_shared__"];
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n, e) {
      return null == n ? void 0 : n[e];
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = this.has(n) && delete this.__data__[n];
      return this.size -= e ? 1 : 0, e;
    };
  }, function (n, e, t) {
    var r = t(16),
      o = "__lodash_hash_undefined__",
      a = Object.prototype.hasOwnProperty;
    n.exports = function (n) {
      var e = this.__data__;
      if (r) {
        var t = e[n];
        return t === o ? void 0 : t;
      }
      return a.call(e, n) ? e[n] : void 0;
    };
  }, function (n, e, t) {
    var r = t(16),
      o = Object.prototype.hasOwnProperty;
    n.exports = function (n) {
      var e = this.__data__;
      return r ? void 0 !== e[n] : o.call(e, n);
    };
  }, function (n, e, t) {
    var r = t(16),
      o = "__lodash_hash_undefined__";
    n.exports = function (n, e) {
      var t = this.__data__;
      return this.size += this.has(n) ? 0 : 1, t[n] = r && void 0 === e ? o : e, this;
    };
  }, function (n, e) {
    n.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (n, e, t) {
    var r = t(18),
      o = Array.prototype.splice;
    n.exports = function (n) {
      var e = this.__data__,
        t = r(e, n);
      return !(t < 0) && (t == e.length - 1 ? e.pop() : o.call(e, t, 1), --this.size, !0);
    };
  }, function (n, e, t) {
    var r = t(18);
    n.exports = function (n) {
      var e = this.__data__,
        t = r(e, n);
      return t < 0 ? void 0 : e[t][1];
    };
  }, function (n, e, t) {
    var r = t(18);
    n.exports = function (n) {
      return r(this.__data__, n) > -1;
    };
  }, function (n, e, t) {
    var r = t(18);
    n.exports = function (n, e) {
      var t = this.__data__,
        o = r(t, n);
      return o < 0 ? (++this.size, t.push([n, e])) : t[o][1] = e, this;
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n) {
      var e = r(this, n)["delete"](n);
      return this.size -= e ? 1 : 0, e;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = typeof n;
      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== n : null === n;
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n) {
      return r(this, n).get(n);
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n) {
      return r(this, n).has(n);
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n, e) {
      var t = r(this, n),
        o = t.size;
      return t.set(n, e), this.size += t.size == o ? 0 : 1, this;
    };
  }, function (n, e, t) {
    var r = t(3);
    n.exports = function () {
      return r.Date.now();
    };
  }, function (n, e, t) {
    var r = t(112),
      o = t(149),
      a = t(56);
    n.exports = function (n) {
      var e = o(n);
      return 1 == e.length && e[0][2] ? a(e[0][0], e[0][1]) : function (t) {
        return t === n || r(t, n, e);
      };
    };
  }, function (n, e, t) {
    var r = t(46),
      o = t(47),
      a = 1,
      i = 2;
    n.exports = function (n, e, t, u) {
      var c = t.length,
        s = c,
        p = !u;
      if (null == n) return !s;
      for (n = Object(n); c--;) {
        var f = t[c];
        if (p && f[2] ? f[1] !== n[f[0]] : !(f[0] in n)) return !1;
      }
      for (; ++c < s;) {
        var l = (f = t[c])[0],
          g = n[l],
          d = f[1];
        if (p && f[2]) {
          if (void 0 === g && !(l in n)) return !1;
        } else {
          var b = new r();
          if (u) var x = u(g, d, l, n, e, b);
          if (!(void 0 === x ? o(d, g, a | i, u, b) : x)) return !1;
        }
      }
      return !0;
    };
  }, function (n, e, t) {
    var r = t(17);
    n.exports = function () {
      this.__data__ = new r(), this.size = 0;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = this.__data__,
        t = e["delete"](n);
      return this.size = e.size, t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.get(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.has(n);
    };
  }, function (n, e, t) {
    var r = t(17),
      o = t(32),
      a = t(30),
      i = 200;
    n.exports = function (n, e) {
      var t = this.__data__;
      if (t instanceof r) {
        var u = t.__data__;
        if (!o || u.length < i - 1) return u.push([n, e]), this.size = ++t.size, this;
        t = this.__data__ = new a(u);
      }
      return t.set(n, e), this.size = t.size, this;
    };
  }, function (n, e, t) {
    var r = t(46),
      o = t(48),
      a = t(123),
      i = t(127),
      u = t(144),
      c = t(2),
      s = t(52),
      p = t(54),
      f = 1,
      l = "[object Arguments]",
      g = "[object Array]",
      d = "[object Object]",
      b = Object.prototype.hasOwnProperty;
    n.exports = function (n, e, t, x, A, v) {
      var h = c(n),
        m = c(e),
        y = h ? g : u(n),
        C = m ? g : u(e),
        k = (y = y == l ? d : y) == d,
        w = (C = C == l ? d : C) == d,
        B = y == C;
      if (B && s(n)) {
        if (!s(e)) return !1;
        h = !0, k = !1;
      }
      if (B && !k) return v || (v = new r()), h || p(n) ? o(n, e, t, x, A, v) : a(n, e, y, t, x, A, v);
      if (!(t & f)) {
        var j = k && b.call(n, "__wrapped__"),
          P = w && b.call(e, "__wrapped__");
        if (j || P) {
          var O = j ? n.value() : n,
            E = P ? e.value() : e;
          return v || (v = new r()), A(O, E, t, x, v);
        }
      }
      return !!B && (v || (v = new r()), i(n, e, t, x, A, v));
    };
  }, function (n, e, t) {
    var r = t(30),
      o = t(120),
      a = t(121);
    function i(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.__data__ = new r(); ++e < t;) this.add(n[e]);
    }
    i.prototype.add = i.prototype.push = o, i.prototype.has = a, n.exports = i;
  }, function (n, e) {
    var t = "__lodash_hash_undefined__";
    n.exports = function (n) {
      return this.__data__.set(n, t), this;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.has(n);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return n.has(e);
    };
  }, function (n, e, t) {
    var r = t(14),
      o = t(124),
      a = t(31),
      i = t(48),
      u = t(125),
      c = t(126),
      s = 1,
      p = 2,
      f = "[object Boolean]",
      l = "[object Date]",
      g = "[object Error]",
      d = "[object Map]",
      b = "[object Number]",
      x = "[object RegExp]",
      A = "[object Set]",
      v = "[object String]",
      h = "[object Symbol]",
      m = "[object ArrayBuffer]",
      y = "[object DataView]",
      C = r ? r.prototype : void 0,
      k = C ? C.valueOf : void 0;
    n.exports = function (n, e, t, r, C, w, B) {
      switch (t) {
        case y:
          if (n.byteLength != e.byteLength || n.byteOffset != e.byteOffset) return !1;
          n = n.buffer, e = e.buffer;
        case m:
          return !(n.byteLength != e.byteLength || !w(new o(n), new o(e)));
        case f:
        case l:
        case b:
          return a(+n, +e);
        case g:
          return n.name == e.name && n.message == e.message;
        case x:
        case v:
          return n == e + "";
        case d:
          var j = u;
        case A:
          var P = r & s;
          if (j || (j = c), n.size != e.size && !P) return !1;
          var O = B.get(n);
          if (O) return O == e;
          r |= p, B.set(n, e);
          var E = i(j(n), j(e), r, C, w, B);
          return B["delete"](n), E;
        case h:
          if (k) return k.call(n) == k.call(e);
      }
      return !1;
    };
  }, function (n, e, t) {
    var r = t(3).Uint8Array;
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n) {
      var e = -1,
        t = Array(n.size);
      return n.forEach(function (n, r) {
        t[++e] = [r, n];
      }), t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = -1,
        t = Array(n.size);
      return n.forEach(function (n) {
        t[++e] = n;
      }), t;
    };
  }, function (n, e, t) {
    var r = t(128),
      o = 1,
      a = Object.prototype.hasOwnProperty;
    n.exports = function (n, e, t, i, u, c) {
      var s = t & o,
        p = r(n),
        f = p.length;
      if (f != r(e).length && !s) return !1;
      for (var l = f; l--;) {
        var g = p[l];
        if (!(s ? g in e : a.call(e, g))) return !1;
      }
      var d = c.get(n);
      if (d && c.get(e)) return d == e;
      var b = !0;
      c.set(n, e), c.set(e, n);
      for (var x = s; ++l < f;) {
        var A = n[g = p[l]],
          v = e[g];
        if (i) var h = s ? i(v, A, g, e, n, c) : i(A, v, g, n, e, c);
        if (!(void 0 === h ? A === v || u(A, v, t, i, c) : h)) {
          b = !1;
          break;
        }
        x || (x = "constructor" == g);
      }
      if (b && !x) {
        var m = n.constructor,
          y = e.constructor;
        m != y && "constructor" in n && "constructor" in e && !("function" == typeof m && m instanceof m && "function" == typeof y && y instanceof y) && (b = !1);
      }
      return c["delete"](n), c["delete"](e), b;
    };
  }, function (n, e, t) {
    var r = t(129),
      o = t(131),
      a = t(12);
    n.exports = function (n) {
      return r(n, a, o);
    };
  }, function (n, e, t) {
    var r = t(130),
      o = t(2);
    n.exports = function (n, e, t) {
      var a = e(n);
      return o(n) ? a : r(a, t(n));
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = e.length, o = n.length; ++t < r;) n[o + t] = e[t];
      return n;
    };
  }, function (n, e, t) {
    var r = t(50),
      o = t(132),
      a = Object.prototype.propertyIsEnumerable,
      i = Object.getOwnPropertySymbols,
      u = i ? function (n) {
        return null == n ? [] : (n = Object(n), r(i(n), function (e) {
          return a.call(n, e);
        }));
      } : o;
    n.exports = u;
  }, function (n, e) {
    n.exports = function () {
      return [];
    };
  }, function (n, e, t) {
    var r = t(134),
      o = t(51),
      a = t(2),
      i = t(52),
      u = t(33),
      c = t(54),
      s = Object.prototype.hasOwnProperty;
    n.exports = function (n, e) {
      var t = a(n),
        p = !t && o(n),
        f = !t && !p && i(n),
        l = !t && !p && !f && c(n),
        g = t || p || f || l,
        d = g ? r(n.length, String) : [],
        b = d.length;
      for (var x in n) !e && !s.call(n, x) || g && ("length" == x || f && ("offset" == x || "parent" == x) || l && ("buffer" == x || "byteLength" == x || "byteOffset" == x) || u(x, b)) || d.push(x);
      return d;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = Array(n); ++t < n;) r[t] = e(t);
      return r;
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(7),
      a = "[object Arguments]";
    n.exports = function (n) {
      return o(n) && r(n) == a;
    };
  }, function (n, e) {
    n.exports = function () {
      return !1;
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(34),
      a = t(7),
      i = {};
    i["[object Float32Array]"] = i["[object Float64Array]"] = i["[object Int8Array]"] = i["[object Int16Array]"] = i["[object Int32Array]"] = i["[object Uint8Array]"] = i["[object Uint8ClampedArray]"] = i["[object Uint16Array]"] = i["[object Uint32Array]"] = !0, i["[object Arguments]"] = i["[object Array]"] = i["[object ArrayBuffer]"] = i["[object Boolean]"] = i["[object DataView]"] = i["[object Date]"] = i["[object Error]"] = i["[object Function]"] = i["[object Map]"] = i["[object Number]"] = i["[object Object]"] = i["[object RegExp]"] = i["[object Set]"] = i["[object String]"] = i["[object WeakMap]"] = !1, n.exports = function (n) {
      return a(n) && o(n.length) && !!i[r(n)];
    };
  }, function (n, e) {
    n.exports = function (n) {
      return function (e) {
        return n(e);
      };
    };
  }, function (n, e, t) {
    (function (n) {
      var r = t(40),
        o = e && !e.nodeType && e,
        a = o && "object" == typeof n && n && !n.nodeType && n,
        i = a && a.exports === o && r.process,
        u = function () {
          try {
            var n = a && a.require && a.require("util").types;
            return n || i && i.binding && i.binding("util");
          } catch (n) {}
        }();
      n.exports = u;
    }).call(this, t(53)(n));
  }, function (n, e, t) {
    var r = t(141),
      o = t(142),
      a = Object.prototype.hasOwnProperty;
    n.exports = function (n) {
      if (!r(n)) return o(n);
      var e = [];
      for (var t in Object(n)) a.call(n, t) && "constructor" != t && e.push(t);
      return e;
    };
  }, function (n, e) {
    var t = Object.prototype;
    n.exports = function (n) {
      var e = n && n.constructor;
      return n === ("function" == typeof e && e.prototype || t);
    };
  }, function (n, e, t) {
    var r = t(143)(Object.keys, Object);
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n, e) {
      return function (t) {
        return n(e(t));
      };
    };
  }, function (n, e, t) {
    var r = t(145),
      o = t(32),
      a = t(146),
      i = t(147),
      u = t(148),
      c = t(6),
      s = t(45),
      p = s(r),
      f = s(o),
      l = s(a),
      g = s(i),
      d = s(u),
      b = c;
    (r && "[object DataView]" != b(new r(new ArrayBuffer(1))) || o && "[object Map]" != b(new o()) || a && "[object Promise]" != b(a.resolve()) || i && "[object Set]" != b(new i()) || u && "[object WeakMap]" != b(new u())) && (b = function b(n) {
      var e = c(n),
        t = "[object Object]" == e ? n.constructor : void 0,
        r = t ? s(t) : "";
      if (r) switch (r) {
        case p:
          return "[object DataView]";
        case f:
          return "[object Map]";
        case l:
          return "[object Promise]";
        case g:
          return "[object Set]";
        case d:
          return "[object WeakMap]";
      }
      return e;
    }), n.exports = b;
  }, function (n, e, t) {
    var r = t(9)(t(3), "DataView");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "Promise");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "Set");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "WeakMap");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(55),
      o = t(12);
    n.exports = function (n) {
      for (var e = o(n), t = e.length; t--;) {
        var a = e[t],
          i = n[a];
        e[t] = [a, i, r(i)];
      }
      return e;
    };
  }, function (n, e, t) {
    var r = t(47),
      o = t(151),
      a = t(154),
      i = t(35),
      u = t(55),
      c = t(56),
      s = t(20),
      p = 1,
      f = 2;
    n.exports = function (n, e) {
      return i(n) && u(e) ? c(s(n), e) : function (t) {
        var i = o(t, n);
        return void 0 === i && i === e ? a(t, n) : r(e, i, p | f);
      };
    };
  }, function (n, e, t) {
    var r = t(57);
    n.exports = function (n, e, t) {
      var o = null == n ? void 0 : r(n, e);
      return void 0 === o ? t : o;
    };
  }, function (n, e, t) {
    var r = t(153),
      o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      a = /\\(\\)?/g,
      i = r(function (n) {
        var e = [];
        return 46 === n.charCodeAt(0) && e.push(""), n.replace(o, function (n, t, r, o) {
          e.push(r ? o.replace(a, "$1") : t || n);
        }), e;
      });
    n.exports = i;
  }, function (n, e, t) {
    var r = t(22),
      o = 500;
    n.exports = function (n) {
      var e = r(n, function (n) {
          return t.size === o && t.clear(), n;
        }),
        t = e.cache;
      return e;
    };
  }, function (n, e, t) {
    var r = t(155),
      o = t(156);
    n.exports = function (n, e) {
      return null != n && o(n, e, r);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return null != n && e in Object(n);
    };
  }, function (n, e, t) {
    var r = t(58),
      o = t(51),
      a = t(2),
      i = t(33),
      u = t(34),
      c = t(20);
    n.exports = function (n, e, t) {
      for (var s = -1, p = (e = r(e, n)).length, f = !1; ++s < p;) {
        var l = c(e[s]);
        if (!(f = null != n && t(n, l))) break;
        n = n[l];
      }
      return f || ++s != p ? f : !!(p = null == n ? 0 : n.length) && u(p) && i(l, p) && (a(n) || o(n));
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n;
    };
  }, function (n, e, t) {
    var r = t(159),
      o = t(160),
      a = t(35),
      i = t(20);
    n.exports = function (n) {
      return a(n) ? r(i(n)) : o(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return function (e) {
        return null == e ? void 0 : e[n];
      };
    };
  }, function (n, e, t) {
    var r = t(57);
    n.exports = function (n) {
      return function (e) {
        return r(e, n);
      };
    };
  }, function (n, e, t) {
    var r = t(162),
      o = t(12);
    n.exports = function (n) {
      return null == n ? [] : r(n, o(n));
    };
  }, function (n, e, t) {
    var r = t(26);
    n.exports = function (n, e) {
      return r(e, function (e) {
        return n[e];
      });
    };
  }, function (n, e, t) {
    var r = t(21);
    n.exports = function (n, e) {
      var t = [];
      return r(n, function (n, r, o) {
        e(n, r, o) && t.push(n);
      }), t;
    };
  }, function (n, e, t) {
    var r = t(165),
      o = t(12);
    n.exports = function (n, e) {
      return n && r(n, e, o);
    };
  }, function (n, e, t) {
    var r = t(166)();
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n) {
      return function (e, t, r) {
        for (var o = -1, a = Object(e), i = r(e), u = i.length; u--;) {
          var c = i[n ? u : ++o];
          if (!1 === t(a[c], c, a)) break;
        }
        return e;
      };
    };
  }, function (n, e, t) {
    var r = t(11);
    n.exports = function (n, e) {
      return function (t, o) {
        if (null == t) return t;
        if (!r(t)) return n(t, o);
        for (var a = t.length, i = e ? a : -1, u = Object(t); (e ? i-- : ++i < a) && !1 !== o(u[i], i, u););
        return t;
      };
    };
  }, function (n, e, t) {
    var r = t(21),
      o = t(11);
    n.exports = function (n, e) {
      var t = -1,
        a = o(n) ? Array(n.length) : [];
      return r(n, function (n, r, o) {
        a[++t] = e(n, r, o);
      }), a;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r) {
      var o = -1,
        a = null == n ? 0 : n.length;
      for (r && a && (t = n[++o]); ++o < a;) t = e(t, n[o], o, n);
      return t;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r, o) {
      return o(n, function (n, o, a) {
        t = r ? (r = !1, n) : e(t, n, o, a);
      }), t;
    };
  }, function (n, e, t) {
    var r = t(10),
      o = t(11),
      a = t(12);
    n.exports = function (n) {
      return function (e, t, i) {
        var u = Object(e);
        if (!o(e)) {
          var c = r(t, 3);
          e = a(e), t = function t(n) {
            return c(u[n], n, u);
          };
        }
        var s = n(e, t, i);
        return s > -1 ? u[c ? e[s] : s] : void 0;
      };
    };
  }, function (n, e, t) {
    var r = t(21);
    n.exports = function (n, e) {
      var t;
      return r(n, function (n, r, o) {
        return !(t = e(n, r, o));
      }), !!t;
    };
  }, function (n, e, t) {
    var r = t(31),
      o = t(11),
      a = t(33),
      i = t(8);
    n.exports = function (n, e, t) {
      if (!i(t)) return !1;
      var u = typeof e;
      return !!("number" == u ? o(t) && a(e, t.length) : "string" == u && e in t) && r(t[e], n);
    };
  }, function (n, e, t) {

    var r = t(175);
    function o() {}
    function a() {}
    a.resetWarningCache = o, n.exports = function () {
      function n(n, e, t, o, a, i) {
        if (i !== r) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }
      function e() {
        return n;
      }
      n.isRequired = n;
      var t = {
        array: n,
        bool: n,
        func: n,
        number: n,
        object: n,
        string: n,
        symbol: n,
        any: n,
        arrayOf: e,
        element: n,
        elementType: n,
        instanceOf: e,
        node: n,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: a,
        resetWarningCache: o
      };
      return t.PropTypes = t, t;
    };
  }, function (n, e, t) {

    n.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (n, e, t) {
    var r = t(177);
    "string" == typeof r && (r = [[n.i, r, ""]]);
    var o = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    t(180)(r, o);
    r.locals && (n.exports = r.locals);
  }, function (n, e, t) {
    e = n.exports = t(178)(!1);
    var r = t(179)(t(59));
    e.push([n.i, ".flag {\n  width: 16px;\n  height: 11px;\n  background-image: url(" + r + ") !important;\n}\n.flag.margin {\n  margin-right: 8px;\n}\n.flag.ad {\n  background-position: -16px 0;\n}\n.flag.ae {\n  background-position: -32px 0;\n}\n.flag.af {\n  background-position: -48px 0;\n}\n.flag.ag {\n  background-position: -64px 0;\n}\n.flag.ai {\n  background-position: -80px 0;\n}\n.flag.al {\n  background-position: -96px 0;\n}\n.flag.am {\n  background-position: -112px 0;\n}\n.flag.ao {\n  background-position: -128px 0;\n}\n.flag.ar {\n  background-position: -144px 0;\n}\n.flag.as {\n  background-position: -160px 0;\n}\n.flag.at {\n  background-position: -176px 0;\n}\n.flag.au {\n  background-position: -192px 0;\n}\n.flag.aw {\n  background-position: -208px 0;\n}\n.flag.az {\n  background-position: -224px 0;\n}\n.flag.ba {\n  background-position: -240px 0;\n}\n.flag.bb {\n  background-position: 0 -11px;\n}\n.flag.bd {\n  background-position: -16px -11px;\n}\n.flag.be {\n  background-position: -32px -11px;\n}\n.flag.bf {\n  background-position: -48px -11px;\n}\n.flag.bg {\n  background-position: -64px -11px;\n}\n.flag.bh {\n  background-position: -80px -11px;\n}\n.flag.bi {\n  background-position: -96px -11px;\n}\n.flag.bj {\n  background-position: -112px -11px;\n}\n.flag.bm {\n  background-position: -128px -11px;\n}\n.flag.bn {\n  background-position: -144px -11px;\n}\n.flag.bo {\n  background-position: -160px -11px;\n}\n.flag.br {\n  background-position: -176px -11px;\n}\n.flag.bs {\n  background-position: -192px -11px;\n}\n.flag.bt {\n  background-position: -208px -11px;\n}\n.flag.bw {\n  background-position: -224px -11px;\n}\n.flag.by {\n  background-position: -240px -11px;\n}\n.flag.bz {\n  background-position: 0 -22px;\n}\n.flag.ca {\n  background-position: -16px -22px;\n}\n.flag.cd {\n  background-position: -32px -22px;\n}\n.flag.cf {\n  background-position: -48px -22px;\n}\n.flag.cg {\n  background-position: -64px -22px;\n}\n.flag.ch {\n  background-position: -80px -22px;\n}\n.flag.ci {\n  background-position: -96px -22px;\n}\n.flag.ck {\n  background-position: -112px -22px;\n}\n.flag.cl {\n  background-position: -128px -22px;\n}\n.flag.cm {\n  background-position: -144px -22px;\n}\n.flag.cn {\n  background-position: -160px -22px;\n}\n.flag.co {\n  background-position: -176px -22px;\n}\n.flag.cr {\n  background-position: -192px -22px;\n}\n.flag.cu {\n  background-position: -208px -22px;\n}\n.flag.cv {\n  background-position: -224px -22px;\n}\n.flag.cw {\n  background-position: -240px -22px;\n}\n.flag.cy {\n  background-position: 0 -33px;\n}\n.flag.cz {\n  background-position: -16px -33px;\n}\n.flag.de {\n  background-position: -32px -33px;\n}\n.flag.dj {\n  background-position: -48px -33px;\n}\n.flag.dk {\n  background-position: -64px -33px;\n}\n.flag.dm {\n  background-position: -80px -33px;\n}\n.flag.do {\n  background-position: -96px -33px;\n}\n.flag.dz {\n  background-position: -112px -33px;\n}\n.flag.ec {\n  background-position: -128px -33px;\n}\n.flag.ee {\n  background-position: -144px -33px;\n}\n.flag.eg {\n  background-position: -160px -33px;\n}\n.flag.er {\n  background-position: -176px -33px;\n}\n.flag.es {\n  background-position: -192px -33px;\n}\n.flag.et {\n  background-position: -208px -33px;\n}\n.flag.fi {\n  background-position: -224px -33px;\n}\n.flag.fj {\n  background-position: -240px -33px;\n}\n.flag.fk {\n  background-position: 0 -44px;\n}\n.flag.fm {\n  background-position: -16px -44px;\n}\n.flag.fo {\n  background-position: -32px -44px;\n}\n.flag.fr,\n.flag.bl,\n.flag.mf {\n  background-position: -48px -44px;\n}\n.flag.ga {\n  background-position: -64px -44px;\n}\n.flag.gb {\n  background-position: -80px -44px;\n}\n.flag.gd {\n  background-position: -96px -44px;\n}\n.flag.ge {\n  background-position: -112px -44px;\n}\n.flag.gf {\n  background-position: -128px -44px;\n}\n.flag.gh {\n  background-position: -144px -44px;\n}\n.flag.gi {\n  background-position: -160px -44px;\n}\n.flag.gl {\n  background-position: -176px -44px;\n}\n.flag.gm {\n  background-position: -192px -44px;\n}\n.flag.gn {\n  background-position: -208px -44px;\n}\n.flag.gp {\n  background-position: -224px -44px;\n}\n.flag.gq {\n  background-position: -240px -44px;\n}\n.flag.gr {\n  background-position: 0 -55px;\n}\n.flag.gt {\n  background-position: -16px -55px;\n}\n.flag.gu {\n  background-position: -32px -55px;\n}\n.flag.gw {\n  background-position: -48px -55px;\n}\n.flag.gy {\n  background-position: -64px -55px;\n}\n.flag.hk {\n  background-position: -80px -55px;\n}\n.flag.hn {\n  background-position: -96px -55px;\n}\n.flag.hr {\n  background-position: -112px -55px;\n}\n.flag.ht {\n  background-position: -128px -55px;\n}\n.flag.hu {\n  background-position: -144px -55px;\n}\n.flag.id {\n  background-position: -160px -55px;\n}\n.flag.ie {\n  background-position: -176px -55px;\n}\n.flag.il {\n  background-position: -192px -55px;\n}\n.flag.in {\n  background-position: -208px -55px;\n}\n.flag.io {\n  background-position: -224px -55px;\n}\n.flag.iq {\n  background-position: -240px -55px;\n}\n.flag.ir {\n  background-position: 0 -66px;\n}\n.flag.is {\n  background-position: -16px -66px;\n}\n.flag.it {\n  background-position: -32px -66px;\n}\n.flag.jm {\n  background-position: -48px -66px;\n}\n.flag.jo {\n  background-position: -64px -66px;\n}\n.flag.jp {\n  background-position: -80px -66px;\n}\n.flag.ke {\n  background-position: -96px -66px;\n}\n.flag.kg {\n  background-position: -112px -66px;\n}\n.flag.kh {\n  background-position: -128px -66px;\n}\n.flag.ki {\n  background-position: -144px -66px;\n}\n.flag.km {\n  background-position: -160px -66px;\n}\n.flag.kn {\n  background-position: -176px -66px;\n}\n.flag.kp {\n  background-position: -192px -66px;\n}\n.flag.kr {\n  background-position: -208px -66px;\n}\n.flag.kw {\n  background-position: -224px -66px;\n}\n.flag.ky {\n  background-position: -240px -66px;\n}\n.flag.kz {\n  background-position: 0 -77px;\n}\n.flag.la {\n  background-position: -16px -77px;\n}\n.flag.lb {\n  background-position: -32px -77px;\n}\n.flag.lc {\n  background-position: -48px -77px;\n}\n.flag.li {\n  background-position: -64px -77px;\n}\n.flag.lk {\n  background-position: -80px -77px;\n}\n.flag.lr {\n  background-position: -96px -77px;\n}\n.flag.ls {\n  background-position: -112px -77px;\n}\n.flag.lt {\n  background-position: -128px -77px;\n}\n.flag.lu {\n  background-position: -144px -77px;\n}\n.flag.lv {\n  background-position: -160px -77px;\n}\n.flag.ly {\n  background-position: -176px -77px;\n}\n.flag.ma {\n  background-position: -192px -77px;\n}\n.flag.mc {\n  background-position: -208px -77px;\n}\n.flag.md {\n  background-position: -224px -77px;\n}\n.flag.me {\n  background-position: -112px -154px;\n  height: 12px;\n}\n.flag.mg {\n  background-position: 0 -88px;\n}\n.flag.mh {\n  background-position: -16px -88px;\n}\n.flag.mk {\n  background-position: -32px -88px;\n}\n.flag.ml {\n  background-position: -48px -88px;\n}\n.flag.mm {\n  background-position: -64px -88px;\n}\n.flag.mn {\n  background-position: -80px -88px;\n}\n.flag.mo {\n  background-position: -96px -88px;\n}\n.flag.mp {\n  background-position: -112px -88px;\n}\n.flag.mq {\n  background-position: -128px -88px;\n}\n.flag.mr {\n  background-position: -144px -88px;\n}\n.flag.ms {\n  background-position: -160px -88px;\n}\n.flag.mt {\n  background-position: -176px -88px;\n}\n.flag.mu {\n  background-position: -192px -88px;\n}\n.flag.mv {\n  background-position: -208px -88px;\n}\n.flag.mw {\n  background-position: -224px -88px;\n}\n.flag.mx {\n  background-position: -240px -88px;\n}\n.flag.my {\n  background-position: 0 -99px;\n}\n.flag.mz {\n  background-position: -16px -99px;\n}\n.flag.na {\n  background-position: -32px -99px;\n}\n.flag.nc {\n  background-position: -48px -99px;\n}\n.flag.ne {\n  background-position: -64px -99px;\n}\n.flag.nf {\n  background-position: -80px -99px;\n}\n.flag.ng {\n  background-position: -96px -99px;\n}\n.flag.ni {\n  background-position: -112px -99px;\n}\n.flag.nl,\n.flag.bq {\n  background-position: -128px -99px;\n}\n.flag.no {\n  background-position: -144px -99px;\n}\n.flag.np {\n  background-position: -160px -99px;\n}\n.flag.nr {\n  background-position: -176px -99px;\n}\n.flag.nu {\n  background-position: -192px -99px;\n}\n.flag.nz {\n  background-position: -208px -99px;\n}\n.flag.om {\n  background-position: -224px -99px;\n}\n.flag.pa {\n  background-position: -240px -99px;\n}\n.flag.pe {\n  background-position: 0 -110px;\n}\n.flag.pf {\n  background-position: -16px -110px;\n}\n.flag.pg {\n  background-position: -32px -110px;\n}\n.flag.ph {\n  background-position: -48px -110px;\n}\n.flag.pk {\n  background-position: -64px -110px;\n}\n.flag.pl {\n  background-position: -80px -110px;\n}\n.flag.pm {\n  background-position: -96px -110px;\n}\n.flag.pr {\n  background-position: -112px -110px;\n}\n.flag.ps {\n  background-position: -128px -110px;\n}\n.flag.pt {\n  background-position: -144px -110px;\n}\n.flag.pw {\n  background-position: -160px -110px;\n}\n.flag.py {\n  background-position: -176px -110px;\n}\n.flag.qa {\n  background-position: -192px -110px;\n}\n.flag.re {\n  background-position: -208px -110px;\n}\n.flag.ro {\n  background-position: -224px -110px;\n}\n.flag.rs {\n  background-position: -240px -110px;\n}\n.flag.ru {\n  background-position: 0 -121px;\n}\n.flag.rw {\n  background-position: -16px -121px;\n}\n.flag.sa {\n  background-position: -32px -121px;\n}\n.flag.sb {\n  background-position: -48px -121px;\n}\n.flag.sc {\n  background-position: -64px -121px;\n}\n.flag.sd {\n  background-position: -80px -121px;\n}\n.flag.se {\n  background-position: -96px -121px;\n}\n.flag.sg {\n  background-position: -112px -121px;\n}\n.flag.sh {\n  background-position: -128px -121px;\n}\n.flag.si {\n  background-position: -144px -121px;\n}\n.flag.sk {\n  background-position: -160px -121px;\n}\n.flag.sl {\n  background-position: -176px -121px;\n}\n.flag.sm {\n  background-position: -192px -121px;\n}\n.flag.sn {\n  background-position: -208px -121px;\n}\n.flag.so {\n  background-position: -224px -121px;\n}\n.flag.sr {\n  background-position: -240px -121px;\n}\n.flag.ss {\n  background-position: 0 -132px;\n}\n.flag.st {\n  background-position: -16px -132px;\n}\n.flag.sv {\n  background-position: -32px -132px;\n}\n.flag.sx {\n  background-position: -48px -132px;\n}\n.flag.sy {\n  background-position: -64px -132px;\n}\n.flag.sz {\n  background-position: -80px -132px;\n}\n.flag.tc {\n  background-position: -96px -132px;\n}\n.flag.td {\n  background-position: -112px -132px;\n}\n.flag.tg {\n  background-position: -128px -132px;\n}\n.flag.th {\n  background-position: -144px -132px;\n}\n.flag.tj {\n  background-position: -160px -132px;\n}\n.flag.tk {\n  background-position: -176px -132px;\n}\n.flag.tl {\n  background-position: -192px -132px;\n}\n.flag.tm {\n  background-position: -208px -132px;\n}\n.flag.tn {\n  background-position: -224px -132px;\n}\n.flag.to {\n  background-position: -240px -132px;\n}\n.flag.tr {\n  background-position: 0 -143px;\n}\n.flag.tt {\n  background-position: -16px -143px;\n}\n.flag.tv {\n  background-position: -32px -143px;\n}\n.flag.tw {\n  background-position: -48px -143px;\n}\n.flag.tz {\n  background-position: -64px -143px;\n}\n.flag.ua {\n  background-position: -80px -143px;\n}\n.flag.ug {\n  background-position: -96px -143px;\n}\n.flag.us {\n  background-position: -112px -143px;\n}\n.flag.uy {\n  background-position: -128px -143px;\n}\n.flag.uz {\n  background-position: -144px -143px;\n}\n.flag.va {\n  background-position: -160px -143px;\n}\n.flag.vc {\n  background-position: -176px -143px;\n}\n.flag.ve {\n  background-position: -192px -143px;\n}\n.flag.vg {\n  background-position: -208px -143px;\n}\n.flag.vi {\n  background-position: -224px -143px;\n}\n.flag.vn {\n  background-position: -240px -143px;\n}\n.flag.vu {\n  background-position: 0 -154px;\n}\n.flag.wf {\n  background-position: -16px -154px;\n}\n.flag.ws {\n  background-position: -32px -154px;\n}\n.flag.ye {\n  background-position: -48px -154px;\n}\n.flag.za {\n  background-position: -64px -154px;\n}\n.flag.zm {\n  background-position: -80px -154px;\n}\n.flag.zw {\n  background-position: -96px -154px;\n}\n", ""]);
  }, function (n, e, t) {

    n.exports = function (n) {
      var e = [];
      return e.toString = function () {
        return this.map(function (e) {
          var t = function (n, e) {
            var t = n[1] || "",
              r = n[3];
            if (!r) return t;
            if (e && "function" == typeof btoa) {
              var o = (i = r, u = btoa(unescape(encodeURIComponent(JSON.stringify(i)))), c = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(u), "/*# ".concat(c, " */")),
                a = r.sources.map(function (n) {
                  return "/*# sourceURL=".concat(r.sourceRoot).concat(n, " */");
                });
              return [t].concat(a).concat([o]).join("\n");
            }
            var i, u, c;
            return [t].join("\n");
          }(e, n);
          return e[2] ? "@media ".concat(e[2], "{").concat(t, "}") : t;
        }).join("");
      }, e.i = function (n, t) {
        "string" == typeof n && (n = [[null, n, ""]]);
        for (var r = {}, o = 0; o < this.length; o++) {
          var a = this[o][0];
          null != a && (r[a] = !0);
        }
        for (var i = 0; i < n.length; i++) {
          var u = n[i];
          null != u[0] && r[u[0]] || (t && !u[2] ? u[2] = t : t && (u[2] = "(".concat(u[2], ") and (").concat(t, ")")), e.push(u));
        }
      }, e;
    };
  }, function (n, e, t) {

    n.exports = function (n, e) {
      return "string" != typeof (n = n.__esModule ? n["default"] : n) ? n : (/^['"].*['"]$/.test(n) && (n = n.slice(1, -1)), /["'() \t\n]/.test(n) || e ? '"'.concat(n.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : n);
    };
  }, function (n, e, t) {
    var r,
      o,
      a = {},
      i = (r = function r() {
        return window && document && document.all && !window.atob;
      }, function () {
        return void 0 === o && (o = r.apply(this, arguments)), o;
      }),
      u = function u(n, e) {
        return e ? e.querySelector(n) : document.querySelector(n);
      },
      c = function (n) {
        var e = {};
        return function (n, t) {
          if ("function" == typeof n) return n();
          if (void 0 === e[n]) {
            var r = u.call(this, n, t);
            if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
              r = r.contentDocument.head;
            } catch (n) {
              r = null;
            }
            e[n] = r;
          }
          return e[n];
        };
      }(),
      s = null,
      p = 0,
      f = [],
      l = t(181);
    function g(n, e) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t],
          o = a[r.id];
        if (o) {
          o.refs++;
          for (var i = 0; i < o.parts.length; i++) o.parts[i](r.parts[i]);
          for (; i < r.parts.length; i++) o.parts.push(h(r.parts[i], e));
        } else {
          var u = [];
          for (i = 0; i < r.parts.length; i++) u.push(h(r.parts[i], e));
          a[r.id] = {
            id: r.id,
            refs: 1,
            parts: u
          };
        }
      }
    }
    function d(n, e) {
      for (var t = [], r = {}, o = 0; o < n.length; o++) {
        var a = n[o],
          i = e.base ? a[0] + e.base : a[0],
          u = {
            css: a[1],
            media: a[2],
            sourceMap: a[3]
          };
        r[i] ? r[i].parts.push(u) : t.push(r[i] = {
          id: i,
          parts: [u]
        });
      }
      return t;
    }
    function b(n, e) {
      var t = c(n.insertInto);
      if (!t) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = f[f.length - 1];
      if ("top" === n.insertAt) r ? r.nextSibling ? t.insertBefore(e, r.nextSibling) : t.appendChild(e) : t.insertBefore(e, t.firstChild), f.push(e);else if ("bottom" === n.insertAt) t.appendChild(e);else {
        if ("object" != typeof n.insertAt || !n.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o = c(n.insertAt.before, t);
        t.insertBefore(e, o);
      }
    }
    function x(n) {
      if (null === n.parentNode) return !1;
      n.parentNode.removeChild(n);
      var e = f.indexOf(n);
      e >= 0 && f.splice(e, 1);
    }
    function A(n) {
      var e = document.createElement("style");
      if (void 0 === n.attrs.type && (n.attrs.type = "text/css"), void 0 === n.attrs.nonce) {
        var r = function () {
          return t.nc;
        }();
        r && (n.attrs.nonce = r);
      }
      return v(e, n.attrs), b(n, e), e;
    }
    function v(n, e) {
      Object.keys(e).forEach(function (t) {
        n.setAttribute(t, e[t]);
      });
    }
    function h(n, e) {
      var t, r, o, a;
      if (e.transform && n.css) {
        if (!(a = "function" == typeof e.transform ? e.transform(n.css) : e.transform["default"](n.css))) return function () {};
        n.css = a;
      }
      if (e.singleton) {
        var i = p++;
        t = s || (s = A(e)), r = C.bind(null, t, i, !1), o = C.bind(null, t, i, !0);
      } else n.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (t = function (n) {
        var e = document.createElement("link");
        return void 0 === n.attrs.type && (n.attrs.type = "text/css"), n.attrs.rel = "stylesheet", v(e, n.attrs), b(n, e), e;
      }(e), r = w.bind(null, t, e), o = function o() {
        x(t), t.href && URL.revokeObjectURL(t.href);
      }) : (t = A(e), r = k.bind(null, t), o = function o() {
        x(t);
      });
      return r(n), function (e) {
        if (e) {
          if (e.css === n.css && e.media === n.media && e.sourceMap === n.sourceMap) return;
          r(n = e);
        } else o();
      };
    }
    n.exports = function (n, e) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (e = e || {}).attrs = "object" == typeof e.attrs ? e.attrs : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = i()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
      var t = d(n, e);
      return g(t, e), function (n) {
        for (var r = [], o = 0; o < t.length; o++) {
          var i = t[o];
          (u = a[i.id]).refs--, r.push(u);
        }
        n && g(d(n, e), e);
        for (o = 0; o < r.length; o++) {
          var u;
          if (0 === (u = r[o]).refs) {
            for (var c = 0; c < u.parts.length; c++) u.parts[c]();
            delete a[u.id];
          }
        }
      };
    };
    var m,
      y = (m = [], function (n, e) {
        return m[n] = e, m.filter(Boolean).join("\n");
      });
    function C(n, e, t, r) {
      var o = t ? "" : r.css;
      if (n.styleSheet) n.styleSheet.cssText = y(e, o);else {
        var a = document.createTextNode(o),
          i = n.childNodes;
        i[e] && n.removeChild(i[e]), i.length ? n.insertBefore(a, i[e]) : n.appendChild(a);
      }
    }
    function k(n, e) {
      var t = e.css,
        r = e.media;
      if (r && n.setAttribute("media", r), n.styleSheet) n.styleSheet.cssText = t;else {
        for (; n.firstChild;) n.removeChild(n.firstChild);
        n.appendChild(document.createTextNode(t));
      }
    }
    function w(n, e, t) {
      var r = t.css,
        o = t.sourceMap,
        a = void 0 === e.convertToAbsoluteUrls && o;
      (e.convertToAbsoluteUrls || a) && (r = l(r)), o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
      var i = new Blob([r], {
          type: "text/css"
        }),
        u = n.href;
      n.href = URL.createObjectURL(i), u && URL.revokeObjectURL(u);
    }
  }, function (n, e) {
    n.exports = function (n) {
      var e = "undefined" != typeof window && window.location;
      if (!e) throw new Error("fixUrls requires window.location");
      if (!n || "string" != typeof n) return n;
      var t = e.protocol + "//" + e.host,
        r = t + e.pathname.replace(/\/[^\/]*$/, "/");
      return n.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (n, e) {
        var o,
          a = e.trim().replace(/^"(.*)"$/, function (n, e) {
            return e;
          }).replace(/^'(.*)'$/, function (n, e) {
            return e;
          });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(a) ? n : (o = 0 === a.indexOf("//") ? a : 0 === a.indexOf("/") ? t + a : r + a.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
      });
    };
  }, function (n, e, t) {

    t.r(e);
    var r = t(36),
      o = t.n(r),
      a = t(4),
      i = t.n(a),
      u = t(60),
      c = t.n(u),
      s = t(22),
      p = t.n(s),
      f = t(61),
      l = t.n(f),
      g = t(62),
      d = t.n(g),
      b = t(63),
      x = t.n(b),
      A = t(23),
      v = t.n(A),
      h = t(64),
      m = t.n(h),
      y = t(24),
      C = t.n(y),
      k = t(13),
      w = t.n(k),
      B = t(37),
      j = t.n(B),
      P = t(5),
      O = t.n(P),
      E = t(38),
      I = t.n(E),
      D = t(1),
      Q = t.n(D),
      S = t(0),
      T = t.n(S),
      M = t(65),
      R = t.n(M),
      F = t(66),
      U = t.n(F),
      L = t(67),
      N = t.n(L),
      z = t(68),
      K = t.n(z),
      G = t(69),
      H = t.n(G),
      q = t(70),
      Y = t.n(q),
      V = t(71),
      J = t.n(V),
      X = t(72),
      Z = t.n(X),
      W = t(39),
      _ = t.n(W),
      $ = t(73),
      nn = t.n($),
      en = t(74),
      tn = t.n(en);
    function rn(n) {
      return (rn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
        return typeof n;
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      })(n);
    }
    function on() {
      return (on = Object.assign || function (n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
      }).apply(this, arguments);
    }
    function an(n, e) {
      if (null == n) return {};
      var t,
        r,
        o = function (n, e) {
          if (null == n) return {};
          var t,
            r,
            o = {},
            a = Object.keys(n);
          for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || (o[t] = n[t]);
          return o;
        }(n, e);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(n);
        for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]);
      }
      return o;
    }
    function un(n, e) {
      for (var t = 0; t < e.length; t++) {
        var r = e[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
      }
    }
    function cn(n, e) {
      return !e || "object" !== rn(e) && "function" != typeof e ? function (n) {
        if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return n;
      }(n) : e;
    }
    function sn(n) {
      return (sn = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      })(n);
    }
    function pn(n, e) {
      return (pn = Object.setPrototypeOf || function (n, e) {
        return n.__proto__ = e, n;
      })(n, e);
    }
    var fn = function (n) {
      function e() {
        return function (n, e) {
          if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), cn(this, sn(e).apply(this, arguments));
      }
      var t, r;
      return function (n, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        n.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: n,
            writable: !0,
            configurable: !0
          }
        }), e && pn(n, e);
      }(e, n), t = e, (r = [{
        key: "render",
        value: function value() {
          var n = this.props,
            e = n.name,
            t = n.iso2,
            r = n.dialCode,
            o = n.localization,
            a = n.itemRef,
            i = n["native"],
            u = an(n, ["name", "iso2", "dialCode", "localization", "itemRef", "native"]);
          return i ? Q.a.createElement("option", on({
            className: "country",
            "data-dial-code": "1",
            "data-country-code": t,
            value: t
          }, u), o || e, " ", "+".concat(r)) : Q.a.createElement(tn.a, {
            rootRef: function rootRef(n) {
              return a(n);
            }
          }, Q.a.createElement(nn.a, on({
            className: "country",
            "data-dial-code": "1",
            "data-country-code": t
          }, u), Q.a.createElement("div", {
            className: "flag ".concat(t, " margin")
          }), Q.a.createElement("span", {
            className: "country-name"
          }, o || e), Q.a.createElement("span", {
            className: "dial-code"
          }, "+".concat(r))));
        }
      }]) && un(t.prototype, r), e;
    }(Q.a.PureComponent);
    fn.propTypes = {
      name: T.a.string.isRequired,
      iso2: T.a.string.isRequired,
      dialCode: T.a.string.isRequired,
      itemRef: T.a.func.isRequired,
      localization: T.a.string,
      "native": T.a.bool
    }, fn.defaultProps = {
      localization: null,
      "native": !1
    };
    var ln = fn;
    t(176), t(59);
    function gn(n) {
      return (gn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
        return typeof n;
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      })(n);
    }
    function dn() {
      return (dn = Object.assign || function (n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
      }).apply(this, arguments);
    }
    function bn(n, e) {
      var t = Object.keys(n);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(n);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        })), t.push.apply(t, r);
      }
      return t;
    }
    function xn(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = null != arguments[e] ? arguments[e] : {};
        e % 2 ? bn(t, !0).forEach(function (e) {
          Cn(n, e, t[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : bn(t).forEach(function (e) {
          Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(t, e));
        });
      }
      return n;
    }
    function An(n, e) {
      if (null == n) return {};
      var t,
        r,
        o = function (n, e) {
          if (null == n) return {};
          var t,
            r,
            o = {},
            a = Object.keys(n);
          for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || (o[t] = n[t]);
          return o;
        }(n, e);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(n);
        for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]);
      }
      return o;
    }
    function vn(n, e) {
      for (var t = 0; t < e.length; t++) {
        var r = e[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
      }
    }
    function hn(n) {
      return (hn = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      })(n);
    }
    function mn(n) {
      if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return n;
    }
    function yn(n, e) {
      return (yn = Object.setPrototypeOf || function (n, e) {
        return n.__proto__ = e, n;
      })(n, e);
    }
    function Cn(n, e, t) {
      return e in n ? Object.defineProperty(n, e, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[e] = t, n;
    }
    var kn = function (n) {
      function e(n) {
        var t;
        !function (n, e) {
          if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), t = function (n, e) {
          return !e || "object" !== gn(e) && "function" != typeof e ? mn(n) : e;
        }(this, hn(e).call(this, n)), Cn(mn(t), "flags", {}), Cn(mn(t), "guessSelectedCountry", p()(function (n, e, r) {
          var o = O()(e, {
            iso2: r
          }) || {};
          if ("" === c()(n)) return o;
          var a = j()(e, function (e, t) {
            if (i()(n, t.dialCode)) {
              if (t.dialCode.length > e.dialCode.length) return t;
              if (t.dialCode.length === e.dialCode.length && t.priority < e.priority) return t;
            }
            return e;
          }, {
            dialCode: "",
            priority: 10001
          }, mn(t));
          return a.name ? a : o;
        })), Cn(mn(t), "getProbableCandidate", p()(function (n) {
          if (!n || 0 === n.length) return null;
          var e = t.state.onlyCountries;
          return C()(e, function (e) {
            return i()(e.name.toLowerCase(), n.toLowerCase());
          }, mn(t))[0];
        })), Cn(mn(t), "getOnlyCountries", function (n, e) {
          return 0 === n.length ? e : e.filter(function (e) {
            return n.some(function (n) {
              return n === e.iso2;
            });
          });
        }), Cn(mn(t), "excludeCountries", function (n, e) {
          return 0 === e.length ? n : C()(n, function (n) {
            return !m()(e, n.iso2);
          });
        }), Cn(mn(t), "filterRegions", function (n, e) {
          if ("string" == typeof n) {
            var t = n;
            return e.filter(function (n) {
              return n.regions.some(function (n) {
                return n === t;
              });
            });
          }
          return e.filter(function (e) {
            return n.map(function (n) {
              return e.regions.some(function (e) {
                return e === n;
              });
            }).some(function (n) {
              return n;
            });
          });
        }), Cn(mn(t), "deleteAreaCodes", function (n) {
          return n.filter(function (n) {
            return !0 !== n.isAreaCode;
          });
        }), Cn(mn(t), "updateDefaultCountry", function (n) {
          var e = t.state.onlyCountries,
            r = t.props.disableCountryCode,
            o = O()(e, {
              iso2: n
            });
          t.setState({
            defaultCountry: n,
            selectedCountry: o,
            formattedNumber: r ? "" : "+".concat(o.dialCode)
          });
        }), Cn(mn(t), "scrollTo", function (n) {
          if (n) {
            var e = t.dropdownContainerRef;
            e && document.body && (e.scrollTop = n.offsetTop);
          }
        }), Cn(mn(t), "formatNumber", function (n, e) {
          var r,
            o = t.props,
            a = o.disableCountryCode,
            i = o.enableLongNumbers,
            u = o.autoFormat;
          if (a && e ? ((r = e.split(" ")).shift(), r = r.join(" ")) : r = e, !n || 0 === n.length) return a ? "" : "+";
          if (n && n.length < 2 || !r || !u) return a ? n : "+".concat(n);
          var c,
            s = j()(r, function (n, e) {
              return 0 === n.remainingText.length ? n : "." !== e ? {
                formattedText: n.formattedText + e,
                remainingText: n.remainingText
              } : {
                formattedText: n.formattedText + x()(n.remainingText),
                remainingText: d()(n.remainingText)
              };
            }, {
              formattedText: "",
              remainingText: n.split("")
            });
          return (c = i ? s.formattedText + s.remainingText.join("") : s.formattedText).includes("(") && !c.includes(")") && (c += ")"), c;
        }), Cn(mn(t), "cursorToEnd", function () {
          var n = t.props.isModernBrowser,
            e = t.inputRef;
          if (e.focus(), n) {
            var r = e.value.length;
            e.setSelectionRange(r, r);
          }
        }), Cn(mn(t), "getElement", function (n) {
          return t.flags["flag_no_".concat(n)];
        }), Cn(mn(t), "getCountryData", function () {
          var n = t.state.selectedCountry;
          return n ? {
            name: n.name || "",
            dialCode: n.dialCode || "",
            countryCode: n.iso2 || ""
          } : {};
        }), Cn(mn(t), "handleInput", function (n) {
          var e = t.state,
            r = e.selectedCountry,
            o = e.freezeSelection,
            a = t.state,
            i = a.selectedCountry,
            u = a.formattedNumber,
            c = a.onlyCountries,
            s = a.defaultCountry,
            p = t.props,
            f = p.disableCountryCode,
            l = p.countryCodeEditable,
            g = p.isModernBrowser,
            d = p.onChange,
            b = f ? "" : "+";
          if (!l) {
            var x = "+".concat(r.dialCode);
            if (n.target.value.length < x.length) return;
          }
          if (!(n.target.value.replace(/\D/g, "").length > 15) && n.target.value !== u) {
            if (n.preventDefault ? n.preventDefault() : n.returnValue = !1, n.target.value.length > 0) {
              var A = n.target.value.replace(/\D/g, "");
              (!o || i.dialCode.length > A.length) && (r = t.guessSelectedCountry(A.substring(0, 6), c, s), o = !1), b = t.formatNumber(A, r.format);
            }
            var v = n.target.selectionStart,
              h = b.length - u.length;
            t.setState({
              formattedNumber: b,
              freezeSelection: o,
              selectedCountry: r.dialCode ? r : i
            }, function () {
              g && (h > 0 && (v -= h), ")" === b.charAt(b.length - 1) ? t.inputRef.setSelectionRange(b.length - 1, b.length - 1) : v > 0 && u.length >= b.length && t.inputRef.setSelectionRange(v, v));
              d && d(b, t.getCountryData());
            });
          }
        }), Cn(mn(t), "handleRefInput", function (n) {
          var e,
            r = t.props,
            o = r.inputRef,
            a = r.InputProps;
          t.inputRef = n, o ? e = o : a && a.ref && (e = a.ref), e && ("function" == typeof e ? e(n) : e.current = n);
        }), Cn(mn(t), "handleInputClick", function (n) {
          var e = t.props.onClick;
          e && e(n, t.getCountryData());
        }), Cn(mn(t), "handleFlagItemClick", function (n) {
          var e = t.state,
            r = e.formattedNumber,
            a = e.selectedCountry,
            i = e.onlyCountries,
            u = t.props.onChange,
            c = a,
            s = o()(n) ? O()(i, function (e) {
              return e.iso2 === n;
            }) : O()(i, n),
            p = r.replace(" ", "").replace("(", "").replace(")", "").replace("-", ""),
            f = p.length > 1 ? p.replace(c.dialCode, s.dialCode) : s.dialCode,
            l = t.formatNumber(f.replace(/\D/g, ""), s.format);
          t.setState({
            anchorEl: null,
            selectedCountry: s,
            freezeSelection: !0,
            formattedNumber: l
          }, function () {
            t.cursorToEnd(), u && u(l, t.getCountryData());
          });
        }), Cn(mn(t), "handleInputFocus", function (n) {
          var e = t.state.selectedCountry,
            r = t.props,
            o = r.disableCountryCode,
            a = r.onFocus;
          t.inputRef && "+" === t.inputRef.value && e && !o && t.setState({
            formattedNumber: "+".concat(e.dialCode)
          }, function () {
            return setTimeout(t.cursorToEnd, 10);
          }), t.setState({
            placeholder: ""
          }), a && a(n, t.getCountryData()), setTimeout(t.cursorToEnd, 10);
        }), Cn(mn(t), "handleInputBlur", function (n) {
          var e = t.props,
            r = e.placeholder,
            o = e.onBlur;
          n.target.value || t.setState({
            placeholder: r
          }), o && o(n, t.getCountryData());
        }), Cn(mn(t), "getHighlightCountryIndex", function (n) {
          var e = t.state,
            r = e.highlightCountryIndex,
            o = e.onlyCountries,
            a = e.preferredCountries,
            i = r + n;
          return i < 0 || i >= o.length + a.length ? i - n : i;
        }), Cn(mn(t), "searchCountry", function () {
          var n = t.state,
            e = n.queryString,
            r = n.onlyCountries,
            o = n.preferredCountries,
            a = t.getProbableCandidate(e) || r[0],
            i = v()(r, a) + o.length;
          t.scrollTo(t.getElement(i), !0), t.setState({
            queryString: "",
            highlightCountryIndex: i
          });
        }), Cn(mn(t), "handleKeydown", function (n) {
          var e = t.state,
            r = e.anchorEl,
            o = e.highlightCountryIndex,
            a = e.preferredCountries,
            i = e.onlyCountries,
            u = e.queryString,
            c = e.debouncedQueryStingSearcher,
            s = t.props,
            p = s.keys,
            f = s.disabled;
          if (r && !f) {
            n.preventDefault ? n.preventDefault() : n.returnValue = !1;
            var l = function l(n) {
              t.setState({
                highlightCountryIndex: t.getHighlightCountryIndex(n)
              }, function () {
                t.scrollTo(t.getElement(o + a.length), !0);
              });
            };
            switch (n.which) {
              case p.DOWN:
                l(1);
                break;
              case p.UP:
                l(-1);
                break;
              case p.ENTER:
                t.handleFlagItemClick(i[o], n);
                break;
              case p.ESC:
                t.setState({
                  anchorEl: null
                }, t.cursorToEnd);
                break;
              default:
                (n.which >= p.A && n.which <= p.Z || n.which === p.SPACE) && t.setState({
                  queryString: u + String.fromCharCode(n.which)
                }, c);
            }
          }
        }), Cn(mn(t), "handleInputKeyDown", function (n) {
          var e = t.props,
            r = e.keys,
            o = e.onEnterKeyPress,
            a = e.onKeyDown;
          n.which === r.ENTER && o && o(n), a && a(n);
        }), Cn(mn(t), "checkIfValid", function () {
          var n = t.state.formattedNumber;
          return (0, t.props.isValid)(n.replace(/\D/g, ""));
        }), Cn(mn(t), "updateFormattedNumber", function (n) {
          var e,
            r = t.state,
            o = r.onlyCountries,
            a = r.defaultCountry,
            u = t.props.disableCountryCode,
            c = n,
            s = n;
          if (c.startsWith("+")) c = c.replace(/\D/g, ""), e = t.guessSelectedCountry(c.substring(0, 6), o, a), s = t.formatNumber(c, e.format);else {
            var p = (e = O()(o, {
              iso2: a
            })) && !i()(c.replace(/\D/g, ""), e.dialCode) ? e.dialCode : "";
            s = t.formatNumber((u ? "" : p) + c.replace(/\D/g, ""), e ? e.format : void 0);
          }
          t.setState({
            selectedCountry: e,
            formattedNumber: s
          });
        }), Cn(mn(t), "getDropdownProps", function () {
          var n = t.state,
            e = n.selectedCountry,
            r = n.anchorEl,
            o = n.preferredCountries,
            a = n.onlyCountries,
            i = t.props,
            u = i.classes,
            c = i.dropdownClass,
            s = i.localization,
            p = i.disableDropdown,
            f = i["native"],
            l = "flag ".concat(e.iso2),
            g = function g(n) {
              return Boolean(e && e.dialCode === n.dialCode);
            };
          return p ? {} : {
            startAdornment: Q.a.createElement(N.a, {
              className: u.positionStart,
              position: "start"
            }, f ? Q.a.createElement(Q.a.Fragment, null, Q.a.createElement(J.a, {
              id: "country-menu",
              open: Boolean(r),
              onClose: function onClose() {
                return t.setState({
                  anchorEl: null
                });
              },
              className: u["native"],
              classes: {
                root: R()(u.nativeRoot, "native", l),
                select: u.nativeSelect
              },
              onChange: function onChange(n) {
                return t.handleFlagItemClick(n.target.value);
              },
              disableUnderline: !0
            }, !!o.length && w()(o, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name],
                "native": !0
              });
            }), w()(a, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name],
                "native": !0
              });
            }))) : Q.a.createElement(Q.a.Fragment, null, Q.a.createElement(K.a, {
              className: u.flagButton,
              "aria-owns": r ? "country-menu" : null,
              "aria-label": "Select country",
              onClick: function onClick(n) {
                return t.setState({
                  anchorEl: n.currentTarget
                });
              },
              "aria-haspopup": !0
            }, Q.a.createElement("div", {
              className: l
            })), Q.a.createElement(H.a, {
              className: c,
              id: "country-menu",
              anchorEl: r,
              open: Boolean(r),
              onClose: function onClose() {
                return t.setState({
                  anchorEl: null
                });
              }
            }, !!o.length && w()(o, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                selected: g(n),
                onClick: function onClick() {
                  return t.handleFlagItemClick(n);
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name]
              });
            }), !!o.length && Q.a.createElement(Y.a, null), w()(a, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                selected: g(n),
                onClick: function onClick() {
                  return t.handleFlagItemClick(n);
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name]
              });
            }))))
          };
        });
        var r = _.a.allCountries;
        n.disableAreaCodes && (r = t.deleteAreaCodes(r)), n.regions && (r = t.filterRegions(n.regions, r));
        var a,
          u = t.excludeCountries(t.getOnlyCountries(n.onlyCountries, r), n.excludeCountries),
          s = C()(r, function (e) {
            return I()(n.preferredCountries, function (n) {
              return n === e.iso2;
            });
          }),
          f = n.value || "";
        a = f.length > 1 ? t.guessSelectedCountry(f.replace(/\D/g, "").substring(0, 6), u, n.defaultCountry) || 0 : n.defaultCountry && O()(u, {
          iso2: n.defaultCountry
        }) || 0;
        var g = v()(t.allCountries, a),
          b = f.length < 2 && a && !i()(f.replace(/\D/g, ""), a.dialCode) ? a.dialCode : "",
          A = "" === f && 0 === a ? "" : t.formatNumber((n.disableCountryCode ? "" : b) + f.replace(/\D/g, ""), a.name ? a.format : void 0);
        return t.state = {
          formattedNumber: A,
          placeholder: n.placeholder,
          onlyCountries: u,
          preferredCountries: s,
          defaultCountry: n.defaultCountry,
          selectedCountry: a,
          highlightCountryIndex: g,
          queryString: "",
          freezeSelection: !1,
          debouncedQueryStingSearcher: l()(t.searchCountry, 100),
          anchorEl: null
        }, t;
      }
      var t, r;
      return function (n, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        n.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: n,
            writable: !0,
            configurable: !0
          }
        }), e && yn(n, e);
      }(e, n), t = e, (r = [{
        key: "componentDidMount",
        value: function value() {
          document.addEventListener && document.addEventListener("keydown", this.handleKeydown);
        }
      }, {
        key: "componentDidUpdate",
        value: function value(n) {
          var e = n.value,
            t = this.state,
            r = t.defaultCountry,
            o = t.formattedNumber,
            a = this.props,
            i = a.defaultCountry,
            u = a.value;
          i && i !== r && this.updateDefaultCountry(i), "string" == typeof u && u !== e && u !== o && this.updateFormattedNumber(u);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          document.removeEventListener && document.removeEventListener("keydown", this.handleKeydown);
        }
      }, {
        key: "render",
        value: function value() {
          var n = this.state,
            e = n.formattedNumber,
            t = n.placeholder,
            r = this.props,
            o = (r.inputClass),
            a = r.error,
            i = r.InputProps,
            u = An(r, ["native", "defaultCountry", "excludeCountries", "onlyCountries", "preferredCountries", "dropdownClass", "autoFormat", "disableAreaCodes", "isValid", "disableCountryCode", "disableDropdown", "enableLongNumbers", "countryCodeEditable", "onEnterKeyPress", "isModernBrowser", "classes", "keys", "localization", "placeholder", "regions", "onChange", "value", "inputClass", "error", "InputProps"]),
            c = this.getDropdownProps();
          return Q.a.createElement(U.a, dn({
            placeholder: t,
            value: e,
            className: o,
            inputRef: this.handleRefInput,
            error: a || !this.checkIfValid(),
            onChange: this.handleInput,
            onClick: this.handleInputClick,
            onFocus: this.handleInputFocus,
            onBlur: this.handleInputBlur,
            onKeyDown: this.handleInputKeyDown,
            type: "tel",
            InputProps: xn({}, c, {}, i)
          }, u));
        }
      }]) && vn(t.prototype, r), e;
    }(Q.a.Component);
    kn.propTypes = {
      classes: T.a.object,
      excludeCountries: T.a.arrayOf(T.a.string),
      onlyCountries: T.a.arrayOf(T.a.string),
      preferredCountries: T.a.arrayOf(T.a.string),
      defaultCountry: T.a.string,
      value: T.a.string,
      placeholder: T.a.string,
      disabled: T.a.bool,
      error: T.a.bool,
      variant: T.a.string,
      "native": T.a.bool,
      inputClass: T.a.string,
      dropdownClass: T.a.string,
      InputProps: T.a.object,
      inputProps: T.a.object,
      inputRef: T.a.func,
      autoFormat: T.a.bool,
      disableAreaCodes: T.a.bool,
      disableCountryCode: T.a.bool,
      disableDropdown: T.a.bool,
      enableLongNumbers: T.a.bool,
      countryCodeEditable: T.a.bool,
      regions: T.a.oneOfType([T.a.string, T.a.arrayOf(T.a.string)]),
      localization: T.a.object,
      onChange: T.a.func,
      onFocus: T.a.func,
      onBlur: T.a.func,
      onClick: T.a.func,
      onKeyDown: T.a.func,
      isValid: T.a.func,
      isModernBrowser: T.a.func,
      onEnterKeyPress: T.a.func,
      keys: T.a.object
    }, kn.defaultProps = {
      excludeCountries: [],
      onlyCountries: [],
      preferredCountries: [],
      defaultCountry: "",
      placeholder: "+1 (702) 123-4567",
      disabled: !1,
      error: !1,
      variant: "standard",
      "native": !1,
      inputClass: "",
      dropdownClass: "",
      autoFormat: !0,
      disableAreaCodes: !1,
      isValid: function isValid(n) {
        return I()(_.a.allCountries, function (e) {
          return i()(n, e.dialCode) || i()(e.dialCode, n);
        });
      },
      disableCountryCode: !1,
      disableDropdown: !1,
      enableLongNumbers: !1,
      countryCodeEditable: !0,
      regions: "",
      localization: {},
      onEnterKeyPress: function onEnterKeyPress() {},
      onChange: function onChange() {},
      isModernBrowser: function isModernBrowser() {
        return !!document.createElement && Boolean(document.createElement("input").setSelectionRange);
      },
      keys: {
        UP: 38,
        DOWN: 40,
        RIGHT: 39,
        LEFT: 37,
        ENTER: 13,
        ESC: 27,
        PLUS: 43,
        A: 65,
        Z: 90,
        SPACE: 32
      }
    }, kn.displayName = "MuiPhoneNumber";
    var wn = Z()(function () {
      return {
        flagButton: {
          minWidth: 30,
          padding: 0,
          height: 30
        },
        "native": {
          width: 30,
          height: 30,
          padding: 8
        },
        nativeRoot: {
          padding: 0,
          "& + svg": {
            display: "none"
          }
        },
        nativeSelect: {
          padding: 0,
          lineHeight: 0,
          height: 11
        },
        positionStart: {
          position: "relative"
        }
      };
    })(kn);
    e["default"] = wn;
  }]);
});
var MuiPhoneNumber = unwrapExports(dist);

var Input$2 = function Input(props) {
  return /*#__PURE__*/React__default__default__default__default.createElement(MuiPhoneNumber, _extends({
    defaultCountry: "es",
    countryCodeEditable: true,
    autoFormat: false,
    regions: ["america", "europe"]
  }, props));
};
var PhoneInput = function PhoneInput(props) {
  var label = props.label,
    name = props.name,
    errorobj = props.errorobj;
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var isError = false;
  var errorMessage = "";
  if (errorobj && errorobj.hasOwnProperty(name)) {
    isError = true;
    errorMessage = errorobj[name].message || "Campo requerido";
  }
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "PhoneInput"
  }, /*#__PURE__*/React__default__default__default__default.createElement(Controller, _extends({
    as: Input$2,
    name: name,
    control: control,
    defaultValue: "",
    label: label,
    variant: "outlined",
    error: isError,
    helperText: errorMessage
  }, props)));
};

var IRPF$1 = "IRPF";
var IVA$1 = "IVA";
var NIF$1 = "NIF";
var betweenMinAndMaxKilometers$1 = "Entre {{min}} y {{max}} kilómetros";
var metricUnits$1 = {
  u: "km",
  up: "kms",
  U: "Km",
  Up: "Kms",
  unit: "kilómetro",
  units: "kilómetros",
  Unit: "Kilómetro",
  Units: "Kilómetros",
  unitSpecialCase1: "Kms",
  unitSpecialCase2: "KM",
  ad: "el",
  adp: "los",
  uFranquise: "km franquicia",
  UpFranquise: "Kms franquicia",
  maxUnits: "Kilómetros max.",
  betweenMinAndMaxunits: "Entre {{min}} y {{max}} kilómetros",
  km: "km",
  kms: "kms",
  kilometer: "Kilómetro",
  maxKilometers: "Kilómetros max.",
  "rates-concepts": {
    km: "Tarifa por km"
  },
  searchTools: "nothing"
};
var imperialUnits$1 = {
  u: "mi",
  up: "mi",
  U: "Mi",
  Up: "Mi",
  unit: "milla",
  units: "millas",
  Unit: "Milla",
  Units: "Millas",
  unitSpecialCase1: "Millas",
  unitSpecialCase2: "MILLA",
  ad: "la",
  adp: "las",
  uFranquise: "mi franquicia",
  UpFranquise: "Mi franquicia",
  maxUnits: "Millas max.",
  betweenMinAndMaxunits: "Entre {{min}} y {{max}} millas",
  "rates-concepts": {
    km: "Tarifa por milla"
  },
  searchTools: "nothing",
  providerEditRateHeaderText: "Completa la información de las millas de la franquicia, las geocercas y las tarifas por medio, de cada depósito."
};
var A$2 = "A";
var accept$1 = "Aceptar";
var accepted$1 = "Aceptado";
var acceptUpdate$1 = "Aceptar actualización";
var accessToTheViews$1 = "Acceso a las vistas";
var accessWithMicrosoft$1 = "Acceder con Microsoft";
var activateGuardMode$1 = "Activar modo guardia";
var activateGuardModeWarningText$1 = "¿Seguro que deseas activar el modo guardia?";
var activateGuardModeWarningAditionalText$1 = "Al hacerlo, pasarás a operar como un proveedor automático y las compañías enviarán los servicios directamente a los recursos.";
var active$1 = "Activo";
var activity$1 = "Actividad";
var accumulateNightAndHolidaySurcharge$1 = "Acumular recargo nocturno y festivo";
var add$1 = "Añadir";
var addAuxService$1 = "Añadir servicio auxiliar";
var addCapability$1 = "Añadir prestación";
var addCollective$1 = "Añadir colectivo";
var addCost$1 = "Añadir costo";
var addCostType$1 = "Añadir tipo de costo";
var addedCollective$1 = "Colectivo añadido";
var addFault$1 = "Añadir avería";
var addedFault$1 = "Avería añadida";
var additionalInformation$1 = "Información adicional";
var additionalPrice$1 = "Precio adicionales";
var additionalPriceAbbrev$1 = "Precio resto";
var addNote$1 = "Añadir nota";
var address$1 = "Dirección";
var addressNotLocated$1 = "Dirección no localizada";
var addUserProfile$1 = "Añadir perfil de usuario";
var admin$1 = "Administrador";
var advancedConfiguration$1 = "Configuración avanzada";
var aheadServices$1 = "Servicios por delante";
var alert$1 = "Alerta";
var alerts$1 = "Alertas";
var alertStart$1 = "Inicio alerta";
var all_f$1 = "Todas";
var all_m$1 = "Todos";
var allowAccess$1 = "Permitir acceso";
var allowCalls$1 = "Permite llamadas";
var allowCalls_addService$1 = "Permitir llamadas";
var allowGuardErrorTitle$1 = "No se puede activar el Modo guardia";
var allowGuardErrorText$1 = "No se puede si hay servicios pendientes de aceptación o asignación.";
var allowSMS$1 = "Permite SMS";
var allProvidersAutomatic$1 = "Todos los proveedores (Automático)";
var anErrorHasOccurred$1 = "Ha ocurrido un error";
var applyCosts$1 = "Aplicar gastos";
var approve$1 = "Aprobar";
var assign$1 = "Asignar";
var assignTechnician$1 = "Asignar técnico";
var assistance$1 = "Asistencia";
var assistanceWithoutTransfer$1 = "Asistencia sin traslado";
var assistanceWithoutTransferWarning$1 = "No has seleccionado ningún traslado.";
var assistanceWithoutTransferWarningQuestion$1 = "¿Deseas continuar con el servicio de asistencia, sin traslado a personas?";
var assisted$1 = "Asistido";
var assistedInsuredAbbrev$1 = "Asistido/Aseg.";
var assistedDestinationAddress$1 = "Dirección de destino del asistido";
var associatedDocuments$1 = "Documentos asociados";
var at_time$1 = "a las {{time}} h";
var assigned$1 = "Agendado";
var ASSIGNED$1 = "Agendado";
var attachADocument$1 = "Adjuntar un documento";
var attachment$1 = "Adjuntar";
var attachments$1 = "Adjuntos";
var auction$1 = "Subastar";
var auctionConfiguration$1 = "Configuración subastas";
var auctioned$1 = "En subasta";
var AUCTIONED$1 = "En subasta";
var auctioning$1 = "En subasta";
var AUCTIONING$1 = "En subasta";
var auctionInPriority$1 = "En subasta";
var auctionInPriority1$1 = "Subasta en prioridad 1";
var auctionInPriority2$1 = "Subasta en prioridad 2";
var auctionInPriority3$1 = "Subasta en prioridad 3";
var auctionInPriority4$1 = "Subasta en prioridad Global";
var auctions$1 = "Subastas";
var auctionService$1 = "Subastar servicio";
var auto$1 = "Vehículo";
var automatic$1 = "Automático";
var automaticProvider$1 = "Proveedor automático";
var auxiliary$1 = "Auxiliar";
var auxiliarySettings$1 = "Ajustes de auxiliares";
var auxiliaries$1 = "Auxiliares";
var auxiliariesRates$1 = "Tarifas auxiliares";
var auxServiceList$1 = {
  auxServiceWithCount: "{{count}} Servicio auxiliar",
  auxServiceWithCount_plural: "{{count}} Servicios auxiliares"
};
var auxService$1 = "Servicio auxiliar";
var auxServices$1 = "Servicios auxiliares";
var available$1 = "Disponible";
var available_plural$1 = "Disponibles";
var availableProvidersAbbrev$1 = "Prov. disponibles";
var availableResources$1 = "Recursos disponibles";
var availableResourcesWithCount$1 = "{{count}} Recurso disponible";
var availableResourcesWithCount_plural$1 = "{{count}} Recursos disponibles";
var average$1 = "Tipo medio";
var averageRating$1 = "Valoración media";
var B$1 = "B";
var base$1 = "Base";
var baseAmount$1 = "Importe base";
var billed$1 = "Facturada";
var billing$1 = "Facturación";
var brand$1 = "Marca";
var browse$1 = "Examinar";
var budgetWarningNoBaseFound$1 = "Este proveedor no tiene configurada una base. Se ha utilizado la ubicación del recurso para calcular la tarifa.";
var businessIntelligence$1 = "Business Intelligence";
var byAmount$1 = "Por precio";
var byBrand$1 = "Por marca";
var byPositionOnQueue$1 = "Por posición en espera";
var byScore$1 = "por puntuación";
var byTime$1 = "Por tiempo";
var C$1 = "C";
var calculateAllServicesAsSuburban$1 = "Calcular todos los servicios como carreteros";
var calendar$1 = {
  today: "Hoy",
  yesterday: "Ayer",
  thisWeek: "Esta semana",
  last7Days: "Últimos 7 días",
  pastWeek: "Semana pasada",
  thisMonth: "Este mes",
  last30Days: "Últimos 30 días",
  pastMonth: "Mes pasado",
  thisYear: "Este año",
  lastYear: "Último año"
};
var cancel$1 = "Cancelar";
var cancel_2$1 = "Anular";
var outputCancellationPercentageAbbrev$1 = "% Salida anulado";
var cancelAmount$1 = "Importe anulación";
var cancelRatePercentage$1 = "% Salida anulación";
var cancelRateAmount$1 = "Importe anulación";
var cancelReason$1 = "Motivo de anulación";
var cancelService$1 = "Anular servicio";
var cancelServiceFinished$1 = "Anular servicio finalizado";
var cancelTransferPeople$1 = "Anular traslado";
var cancelTransferPeopleWarning$1 = "En función del estado de ejecución, anular el traslado podría conllevar gastos. ¿Desea continuar?";
var capabilityList$1 = {
  capabilityWithCount: "{{count}} Prestación",
  capabilityWithCount_plural: "{{count}} Prestaciones"
};
var capability$1 = "Prestación";
var capabilityCollectiveAbbrev$1 = "Prestación/Colec.";
var capabilities$1 = "Prestaciones";
var center$1 = "Centro";
var centerName$1 = "Nombre del centro";
var centerNotFound$1 = "No se ha encontrado el centro";
var change$1 = "Cambiar";
var changePassword$1 = "Cambiar contraseña";
var charge$1 = "Cargo";
var chargeWithCount$1 = "{{count}} Cargo";
var chargeWithCount_plural$1 = "{{count}} Cargos";
var check$1 = "Revisar";
var childProfile$1 = "Perfil hijo";
var chosenDriver$1 = "Conductor elegido";
var cif$1 = "CIF";
var city$1 = "Ciudad";
var clone$1 = "Clonar";
var cloneService$1 = "Clonar servicio";
var close$1 = "Cerrar";
var closeDispute$1 = "Cerrar disputa";
var code$1 = "Código";
var collectDate$1 = "Fecha de cobro";
var collected$1 = "Cobrada";
var collectInvoice$1 = "Cobrar factura";
var collective$1 = "Colectivo";
var collectives$1 = "Colectivos";
var collectiveWithCount$1 = "{{count}} Colectivo";
var collectiveWithCount_plural$1 = "{{count}} Colectivos";
var collectiveProviderAbbrev$1 = "Colectivo/Prov.";
var comment$1 = "Comentario";
var commentAboutCapability$1 = "Comentario sobre prestación";
var companies$1 = "Compañías";
var company$1 = "Compañía";
var companyName$1 = "Nombre de la compañía";
var companyProfile$1 = "Perfil de compañía";
var completed$1 = "Completado";
var configuration$1 = "Configuración";
var consultList$1 = "Consultar lista";
var costName$1 = "Nombre del costo";
var costs$1 = "Costos";
var costSearch$1 = "Búsqueda de costo";
var costsWithCount$1 = "{{count}} Costo";
var costsWithCount_plural$1 = "{{count}} Costos";
var costSheets$1 = "Hojas de costos";
var costSheetStatus$1 = {
  PENDING: "P.imputación",
  IMPUTED: "P. aprobación",
  APPROVED: "Aprobado",
  REJECTED: "Rechazado"
};
var costType$1 = "Tipo de costo";
var costTypeName$1 = "Nombre del tipo de costo";
var costTypes$1 = "Tipos de costo";
var costTypesWithCount$1 = "{{count}} Tipo de costo";
var costTypesWithCount_plural$1 = "{{count}} Tipos de costo";
var craneService$1 = "Servicio de grúa";
var create$1 = "Crear";
var currentPassword$1 = "Contraseña actual";
var custodyDays$1 = "Días custodia";
var customer$1 = "Cliente";
var D$1 = "D";
var dashboard$1 = "Dashboard";
var date$1 = "Fecha";
var dateRangeExceeded$1 = "Excedido el rango de fechas";
var dayAndTime$1 = "Día y hora";
var deadLine$1 = "Fecha límite";
var concessionaire$1 = "Concesionaria";
var deferred$1 = "Programado";
var deferredService$1 = "Servicio programado";
var deferredShort$1 = "Programad";
var deferredShorter$1 = "Progra.";
var deleteCost$1 = "Eliminar costo";
var deletePath$1 = "Borrar trazado";
var deleteRequest$1 = "Eliminar solicitud";
var deposits$1 = "Depósitos";
var description$1 = "Descripción";
var detail$1 = "Detalle";
var disconnect$1 = "Desconectar";
var disputeReason$1 = "Motivo de la disputa";
var documentation$1 = "Documentación";
var documentationProfile$1 = "Perfil documentación";
var documentNumberAbbrev$1 = "Nº del documento";
var documentProfile$1 = "Perfil de documento";
var documentProfiles$1 = "Perfil de documentos";
var documentAdded$1 = "Documento añadido";
var documentType$1 = "Tipo de documento";
var documentTypes$1 = "Tipo de documentos";
var doNotAssociate$1 = "No asociar";
var dragData$1 = "Arrastrar datos";
var driver$1 = "Conductor";
var drivers$1 = "Conductores";
var duplicate$1 = "Duplicar";
var duplicateService$1 = "Duplicar servicio";
var E$1 = "E";
var edit$1 = "Editar";
var editAuxService$1 = "Editar servicio auxiliar";
var editCapability$1 = "Editar prestación";
var editCollective$1 = "Editar colectivo";
var editCost$1 = "Editar costo";
var editCostType$1 = "Editar tipo de costo";
var editFault$1 = "Editar avería";
var editSupportTeam$1 = "Editar equipo de soporte";
var editUserProfile$1 = "Editar perfil de usuario";
var email$1 = "Email";
var endService$1 = "Finalizar servicio";
var entry$1 = "Entrada";
var entryDateAbbrev$1 = "F. de entrada";
var error$1 = "Error";
var errorAddingDocument$1 = "Error al añadir documento";
var estimatedTime$1 = "Hora estimada";
var execution$1 = "Ejecución";
var executionProfile$1 = "Perfil de ejecución";
var expense$1 = "Gastos";
var expiredCode$1 = "Código caducado";
var expires$1 = "Caduca";
var events$1 = "Eventos";
var excessOfTimeForOutService$1 = "Exceso de tiempo para realizar servicio carretero";
var excessOfTimeForUrbanService$1 = "Exceso de tiempo para realizar servicio local";
var excessOfTimeInCurrentStatus$1 = "Exceso de tiempo en el estado actual";
var excessOfTimeToCompleteService$1 = "Exceso de tiempo para realizar el servicio";
var excessOfTimeToStartScheduledService$1 = "Exceso de tiempo para iniciar un servicio programado";
var F$1 = "F";
var fault$1 = "Avería";
var faults$1 = "Averías";
var faultCollectiveAbbrev$1 = "Avería/Colec.";
var faultWithCount$1 = "{{count}} Avería";
var faultWithCount_plural$1 = "{{count}} Averías";
var fee$1 = "Salida";
var fieldRequired$1 = "Requerido";
var file$1 = "Archivo";
var filterByDriverStatus$1 = "Filtrar por estado conductor";
var filterByVehicleType$1 = "Filtrar por tipo vehículo";
var financial$1 = "Financiero";
var financialBreakdown$1 = "Desglose financiero";
var finish$1 = "Finalizar";
var finishedServices$1 = "Servicios finalizados";
var firstPrice$1 = "Precio primera";
var firstUnitPriceAbbrev$1 = "Precio 1ª ud.";
var fixed$1 = "Fijo";
var formError$1 = "Error en formulario";
var franchise$1 = "Franquicia";
var franchises$1 = "Franquicias";
var freeCranesBefore1Hour$1 = "Grúas libres antes de 1h";
var fromUntil$1 = "Desde - Hasta";
var fullAddress$1 = "Dirección completa";
var fullScreenAbbrev$1 = "P. completa";
var G$1 = "G";
var generalInformationAbbrev$1 = "Inf. General";
var generate$1 = "Generar";
var generated$1 = "Generada";
var geofence$1 = "Geocerca";
var geofence_plural$1 = "Geocercas";
var geofenceWithCount$1 = "{{count}} Geocerca";
var geofenceWithCount_plural$1 = "{{count}} Geocercas";
var geoJson$1 = "GeoJson";
var globalAuction$1 = "Subasta global";
var graceDays$1 = "Días de gracia";
var grecaptchaNote$1 = "Sitio protegido por reCAPTCHA. Se aplica la <a href=\"https://policies.google.com/privacy\">Política de privacidad</a> y <a href=\"https://policies.google.com/terms\">Términos de servicio</a> de Google.";
var guardMode$1 = "Modo guardia";
var H$1 = "H";
var help$1 = "Ayuda";
var hide$1 = "Ocultar";
var holder$1 = "Titular";
var holidays$1 = "Festivos";
var home$1 = "Hogar";
var hour$1 = "Hora";
var hours$1 = "Horas";
var I$1 = "I";
var IBAN$1 = "IBAN";
var icon$1 = "Icono";
var iconUrl$1 = "URL del icono";
var identificationIcon$1 = "Icono identificativo";
var image$1 = "Imagen";
var immediate$1 = "Inmediato";
var immediate_plural$1 = "Inmediatos";
var immediateService$1 = "Servicio inmediato";
var incorrectLocationFormat$1 = "Localización en formato incorrecto";
var infoWindowIcon$1 = "Icono del InfoWindow";
var inParking$1 = "En parking";
var inRis$1 = "En reparación";
var inris$1 = "En reparación";
var inServiceResourcesWithCount$1 = "{{count}} Recurso en servicio";
var inServiceResourcesWithCount_plural$1 = "{{count}} Recursos en servicio";
var instant$1 = "Inmediato";
var insurancePolicyInfo$1 = "Información de la póliza";
var insured$1 = "Asegurado";
var insured_autoType$1 = "Vehículo";
var insured_homeType$1 = "Inmueble";
var insuredAutoType$1 = "Vehículo";
var insuredHomeType$1 = "Inmueble";
var insuredObjectAbbrev$1 = "Bien aseg.";
var insuredProperty$1 = "Bien asegurado";
var integrationProfile$1 = "Perfil de integración";
var integrationProfileAbbrev$1 = "Perfil integración";
var internalCode$1 = "Código interno";
var internalNote$1 = "Nota interna";
var internalNotes$1 = "Notas internas";
var interrupted$1 = "Interrumpida";
var intervention$1 = "Intervención";
var interventionAbbrev$1 = "Int.";
var interventions$1 = "Intervenciones";
var inUrbanArea$1 = "En zona local";
var invalidNexusFilecase$1 = "Expediente de Nexus no válido";
var invalidText$1 = "Texto no válido";
var invoice$1 = "Factura";
var invoiceNumberAbbrev$1 = "Nº de factura";
var forTheDay$1 = "Para el día";
var isNotValid$1 = "Es inválido";
var issuedInvoices$1 = "Facturas emitidas";
var itAlreadyExists$1 = "Ya existe";
var J$1 = "J";
var K$1 = "K";
var L$1 = "L";
var label$1 = "Rotulación";
var labeled$1 = "Rotulaciones";
var labels$1 = "Rotulaciones";
var lastActivity$1 = "Ult. actividad";
var lastActivity2$1 = "Última actividad";
var legal$1 = "Legal";
var legalId$1 = "NIF/CIF";
var list$1 = "Listado";
var listEntryMax24H$1 = "Entrada en lista (max. 24h)";
var loaded$1 = "Cargado";
var loadTimeInMinutes$1 = "Tiempo de carga (min)";
var located$1 = "Localizado";
var location$1 = "Ubicación";
var locked$1 = "Bloqueado";
var lockedByNexus$1 = "Bloqueado";
var login$1 = "Iniciar sesión";
var logo$1 = "Logotipo";
var logout$1 = "Cerrar sesión";
var M$1 = "M";
var managed$1 = "Gestionado";
var managedProvider$1 = "Proveedor gestionado";
var manual$1 = "Manual";
var manualProvider$1 = "Proveedor manual";
var map$1 = "Mapa";
var mapIcon$1 = "Icono del mapa";
var mapOfGoingServices$1 = "Mapa de servicios en curso";
var mapOfResources$1 = "Mapa de recursos";
var mapOfTracking$1 = "Mapa de seguimiento";
var mapView$1 = "Vista mapa";
var max$1 = "Max.";
var maxAllowedTimeInMinutes$1 = "Tiempo máx. permitido: {{minutes}} min";
var maxDistance$1 = "Distancia máxima";
var maxDistanceToCrane$1 = "Distancia de la grúa";
var maxHours$1 = "Horas máximo";
var maxRadius$1 = "Radio máximo";
var maxTime$1 = "Tiempo máximo";
var maxTimeOnList$1 = "Permanencia en lista";
var medium$1 = "Medio";
var mediumNotFound$1 = "No se ha encontrado el medio";
var mediumType$1 = "Tipo de medio";
var mediumTypes$1 = "Tipo de medios";
var mediumTypes2$1 = "Tipos de medio";
var minute$1 = "Minuto";
var minutes$1 = "Minutos";
var modeAndName$1 = "Modo y nombre";
var model$1 = "Modelo";
var modifiedCollective$1 = "Colectivo modificado";
var modifiedFault$1 = "Avería modificada";
var myTickets$1 = "Mis tickets";
var N$1 = "N";
var name$1 = "Nombre";
var nameSurname$1 = "Nombre y apellidos";
var new_female$1 = "Nueva";
var new_plural$1 = "Nuevos";
var newAuxService$1 = "Nuevo servicio";
var newAuxiliaryService$1 = "Nuevo servicio auxiliar";
var newDayAndTime$1 = "Nuevo día y hora";
var newPassword$1 = "Nueva contraseña";
var newService$1 = "Nuevo servicio";
var newSupportTeam$1 = "Nuevo equipo de soporte";
var newVehicleAssistance$1 = "Nueva asistencia de vehículos";
var newVialService$1 = "Nuevo servicio vial";
var nexusMapServiceError$1 = "Error en el servicio de mapas de Nexus";
var nick$1 = "Nick";
var no$1 = "No";
var noProvidersAvailable$1 = "No hay proveedores disponibles";
var notApplyCosts$1 = "No aplicar gastos";
var notParticipating$1 = "No participa";
var noCovered$1 = "No cubierto";
var noDocumentsAssociatedToService$1 = "No hay documentos asociados";
var noResourcesAvailableMsg$1 = "No hay recursos disponibles, pero puedes enviar el servicio a una lista de espera para que Nexus lo gestione.";
var noSubscribe$1 = "No suscribirme";
var note$1 = "Nota";
var notes$1 = "Notas";
var notesAssociatedWithTheService$1 = "Notas asociadas al servicio";
var noTicketsAssociatedToService$1 = "No hay tickets asociados al servicio";
var noTicketsAssociatedToTransfer$1 = "No hay tickets asociados al traslado";
var noNotesAssociatedToService$1 = "No hay notas asociadas al servicio";
var notifications$1 = "Notificaciones";
var noTransfersAvailable$1 = "No hay traslados disponibles";
var noValid$1 = "No válido";
var numberAbbrev$1 = "Nº";
var numberOfPeopleAbbrev$1 = "Nº de personas";
var numberOfReviewsAbbrev$1 = "Nº Reseñas";
var O$1 = "O";
var office$1 = "Oficina";
var ongoing$1 = "En curso";
var onQueue$1 = "En espera";
var openDispute$1 = "Abrir disputa";
var operational$1 = "Operativos";
var operationTypes$1 = "Tipo de intervención";
var origin$1 = "Origen";
var originalServiceData$1 = "Datos del servicio original";
var originDeposit$1 = "Origen depósito";
var otherSettings$1 = "Otros ajustes";
var orYouCan$1 = "O puedes";
var outlay$1 = "Suplidos";
var outlays$1 = "Gastos adicionales";
var P$1 = "P";
var paid$1 = "Pagada";
var passengers$1 = "Pasajeros";
var passengersWithCount$1 = "{{count}} Pasajero";
var passengersWithCount_plural$1 = "{{count}} Pasajeros";
var password$1 = "Contraseña";
var passwordsNotMatch$1 = "Las contraseñas no coinciden";
var paymentsToProviders$1 = "Pagos a proveedores";
var pdf$1 = "Pdf";
var pending$1 = "Pendiente";
var pendings$1 = "Pendientes";
var PENDING$1 = "Pendiente";
var pending_assign$1 = "Pendiente asignación";
var PENDING_ASSIGN$1 = "Pendiente asignación";
var PENDINGASSIGN$1 = "Pendiente asignación";
var pendingDocumentation$1 = "Documentación pendiente";
var pendingDocuments$1 = "Documentos pendientes";
var pendingPassword$1 = "Pendiente registro";
var pendingProfile$1 = "Pendiente perfil";
var peopleTransferActivity$1 = "Traslados";
var pleaseTryAgainLater$1 = "Por favor inténtalo de nuevo mas tarde";
var phone$1 = "Teléfono";
var phoneNumberAbbrev$1 = "Nº de teléfono";
var photoWithCount$1 = "{{count}} foto";
var photoWithCount_plural$1 = "{{count}} fotos";
var photos$1 = "Fotos";
var planned$1 = "Planificado";
var PLANNED$1 = "Planificado";
var plannedService$1 = "Servicio planificado";
var plate$1 = "Matrícula";
var plateDoesNotCorrespondToTheFilecase$1 = "Matrícula no corresponde al expediente";
var policy$1 = "Póliza";
var policyCoverageLimit$1 = "Excedida la cobertura de la póliza";
var policyCoverageLimit2$1 = "Posible exceso de la cobertura de la póliza";
var policyInformation$1 = "Información de póliza";
var policyLimitExceeded$1 = {
  number1: "Se ha solicitado 1 servicio, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al proveedor.",
  number2: "Se han solicitado {{previousServices}} servicios, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al proveedor.",
  number3: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza es 1. El asistido deberá abonar el coste total del servicio al proveedor.",
  number4: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza son {{policyServicesLimit}}. El asistido deberá abonar el coste total del servicio al proveedor.",
  amount1: "El importe del servicio es de {{serviceTotalAmount}}, y el importe máximo que incluye la póliza es {{policyAmountLimit}}. El asistido deberá abonar la diferencia de {{amountDifference}} al proveedor.",
  amount2: "El importe del servicio es de {{serviceTotalAmount}}, y quedan {{availableAmount}} del importe máximo que incluye la póliza. El asistido deberá abonar la diferencia de {{amountDifference}} al proveedor.",
  amount3: "El importe del servicio es de {{serviceTotalAmount}}, y ya se ha gastado el importe máximo que incluye la póliza. El asistido deberá abonar la totalidad del servicio al proveedor.",
  amount4: "El importe de alguno de los recursos seleccionados supera el límite de la póliza de {{policyAmountLimit}}. El asistido deberá abonar la diferencia al proveedor en el caso de que estos recursos acepten el servicio.",
  amount5: "El importe de alguno de los recursos seleccionados supera el límite de la póliza de {{policyAmountLimit}}, y quedan {{availableAmount}} del importe máximo de cobertura. El asistido deberá abonar la diferencia al proveedor en el caso de que estos recursos acepten el servicio.",
  amount6: "El importe de todos los recursos seleccionados supera el límite de la póliza de {{policyAmountLimit}}, y ya se ha gastado el importe máximo de cobertura. El asistido deberá abonar la totalidad del servicio al proveedor en el caso de que estos recursos acepten el servicio.",
  amount4b: "El importe del recurso seleccionado supera el límite de la póliza de {{policyAmountLimit}}. El asistido deberá abonar la diferencia al proveedor en el caso de que este recurso acepte el servicio.",
  amount5b: "El importe del recurso seleccionado supera el límite de la póliza de {{policyAmountLimit}}, y quedan {{availableAmount}} del importe máximo de cobertura. El asistido deberá abonar la diferencia al proveedor en el caso de que este recurso acepte el servicio.",
  amount6b: "El importe del recurso seleccionado supera el límite de la póliza de {{policyAmountLimit}}, y ya se ha gastado el importe máximo de cobertura. El asistido deberá abonar la totalidad del servicio al proveedor en el caso de que este recurso acepte el servicio.",
  amount7: "El importe estimado del servicio es de {{serviceTotalAmount}}, y el importe máximo que incluye la póliza es {{policyAmountLimit}}. El asistido deberá abonar la diferencia aproximada de {{amountDifference}} al proveedor.",
  amount8: "El importe estimado del servicio es de {{serviceTotalAmount}}, y quedan {{availableAmount}} del importe máximo que incluye la póliza. El asistido deberá abonar la diferencia aproximada de {{amountDifference}} al proveedor.",
  amount9: "El importe estimado del servicio es de {{serviceTotalAmount}}, y ya se ha gastado el importe máximo que incluye la póliza. El asistido deberá abonar la totalidad del servicio al proveedor."
};
var policyLimitExceededAux$1 = {
  number1: "Se ha solicitado 1 servicio, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al técnico.",
  number2: "Se han solicitado {{previousServices}} servicios, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al técnico.",
  number3: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza es 1. El asistido deberá abonar el coste total del servicio al técnico.",
  number4: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza son {{policyServicesLimit}}. El asistido deberá abonar el coste total del servicio al técnico.",
  amount1: "El importe del servicio es de {{serviceTotalAmount}}, y el importe máximo que incluye la póliza es {{policyAmountLimit}}. El asistido deberá abonar la diferencia de {{amountDifference}} al técnico.",
  amount2: "El importe del servicio supera el límite de la póliza de {{serviceTotalAmount}}, y quedan {{availableAmount}} del importe máximo de cobertura. El asistido deberá abonar la diferencia de {{amountDifference}} al técnico.",
  amount3: "El importe del servicio supera el límite de la póliza de {{serviceTotalAmount}}, y ya se ha gastado el importe máximo de cobertura. El asistido deberá abonar la totalidad del servicio al técnico."
};
var policyNumberAbbrev$1 = "Nº de póliza";
var policySearch$1 = "Búsqueda de póliza";
var positionAbbrev$1 = "P.";
var priority$1 = "Prioritario";
var priority1Providers$1 = "Proveedores de prioridad 1";
var priority2Providers$1 = "Proveedores de prioridad 2";
var priority3Providers$1 = "Proveedores de prioridad 3";
var priorityAllProviders$1 = "Todos los proveedores";
var priorityProvider$1 = "Proveedor prioritario";
var process$1$1 = "Procesar";
var profile$1 = "Perfil";
var profileNotFound$1 = "No se ha encontrado el perfil";
var profiles$1 = "Perfiles";
var proposals$1 = "Propuestas";
var provider$1 = "Proveedor";
var providersInZone$1 = "Proveedores en la zona";
var providersOutZone$1 = "Resto de proveedores";
var providerTechnician$1 = "Proveedor / técnico";
var providerVialSettings$1 = "Ajustes de viales de {{providerName}}";
var providerEditVialSettingsHeaderText$1 = "Completa la información necesaria correspondiente a los servicios viales.";
var providerAuxiliariesSettings$1 = "Ajustes de auxiliares de {{providerName}}";
var providerEditAuxiliariesSettingsHeaderText$1 = "Completa la información necesaria correspondiente a los servicios auxiliares.";
var providers$1 = "Proveedores";
var provider_pending$1 = "Pendiente proveedor";
var PROVIDER_PENDING$1 = "Pendiente proveedor";
var PROVIDERPENDING$1 = "Pendiente proveedor";
var provider_accepted$1 = "Aceptado proveedor";
var PROVIDER_ACCEPTED$1 = "Aceptado proveedor";
var PROVIDERACCEPTED$1 = "Aceptado proveedor";
var provider_accept$1 = "Aceptado proveedor";
var PROVIDER_ACCEPT$1 = "Aceptado proveedor";
var PROVIDERACCEPT$1 = "Aceptado proveedor";
var providersSelection$1 = "Selección de proveedores";
var providerList$1 = {
  providerWithCount: "{{count}} Proveedor",
  providerWithCount_plural: "{{count}} Proveedores"
};
var providersMap$1 = "Mapa de proveedores";
var providerType$1 = "Tipo de proveedor";
var providerTypeVial$1 = "Tipo de vial";
var providerTypeAux$1 = "Tipo de auxiliar";
var providerWithoutDefinedDeposit$1 = "Proveedor sin depósito configurado";
var province$1 = "Provincia";
var Q$1 = "Q";
var queueEntryDate$1 = "Fecha de entrada en la lista";
var queued$1 = "En espera";
var QUEUED$1 = "En espera";
var queuedService$1 = "Servicio en espera";
var R$1 = "R";
var rates$1 = "Tarifas";
var rating$1 = "Valoración";
var ratings$1 = "Valoraciones";
var ratingsUserName$1 = "Valoraciones de {{userName}}";
var ratingsWithCount$1 = "{{count}} Valoración";
var ratingsWithCount_plural$1 = "{{count}} Valoraciones";
var ready$1 = "Disponible";
var reAssign$1 = "Reasignar";
var reAssignProvider$1 = "Reasignar proveedor";
var reAskForResetEmail$1 = "Vuelve a pedir email de restablecer";
var received$1 = "Recibido";
var receivedInvoices$1 = "Facturas recibidas";
var recoverRequest$1 = "Recuperar solicitud";
var recoverYourPassword$1 = "Recupera tu contraseña";
var region$1 = "Región";
var registrationInformationOnInvoices$1 = "Información registral en facturas";
var reject$1 = "Rechazar";
var rejectCosts$1 = "Rechazar costos";
var rejectionReason$1 = "Motivo de rechazo";
var rejectionReasons$1 = "Motivos de rechazo";
var rejectionType$1 = "Tipo de rechazo";
var release$1 = "Liberar";
var removeFromDashboard$1 = "Eliminar del Dashboard";
var repeated$1 = "Repetido";
var repeatPassword$1 = "Repetir contraseña";
var requestCapability$1 = "Prestación solicitada";
var requestInfo$1 = "Inf. solicitud";
var requestLocationByWhatsApp$1 = "Solicitar ubicación por WhatsApp";
var requestMediumAbbrev$1 = "M.Solicitado";
var requestProcessedCorrectly$1 = "Solicitud procesada de forma correcta";
var requestWithoutIAssociatedPolicy$1 = "Solicitud sin póliza asociada";
var required$1 = "Obligatorio";
var reschedule$1 = "Reprogramar";
var RESCHEDULED$1 = "Reprogramado";
var rescheduleComment$1 = "Comentario de la reprogramación";
var rescheduleReason$1 = "Motivo de reprogramación";
var rescheduleService$1 = "Reprogramar servicio";
var rescheduleServiceDeferredTextModal$1 = "Introduce un nuevo día y hora para cambiar la programación del servicio actual";
var rescheduleServicePlannedText1Modal$1 = "Los servicios planificados tienen un recurso asignado. Al cambiar la fecha y hora, el servicio volverá al estado programado, y estará pendiente de planificación";
var rescheduleServicePlannedText2Modal$1 = "Introduce la nueva fecha del servicio programado";
var resetPassword$1 = "Contraseña restablecida";
var resetYourPassword$1 = "Restablece tu contraseña";
var resources$1 = "Recursos";
var resourcesMap$1 = "Mapa de recursos";
var restore$1 = "Restablecer";
var result$1 = "Resultado";
var ris$1 = "RIS";
var risService$1 = "Servicio de RIS";
var S$1 = "S";
var save$1 = "Guardar";
var saveChanges$1 = "Guardar cambios";
var savedRequests$1 = "Solicitudes guardadas";
var saveRequest$1 = "Guardar solicitud";
var schedule$1 = "Agendar";
var scheduled$1 = "Programado";
var SCHEDULED$1 = "Programado";
var scheduled_plural$1 = "Programados";
var scheduledAbbrev$1 = "Program.";
var scheduledDateInvalidErrorText$1 = "La fecha y hora programada no es válida";
var scheduleDriver$1 = "Agendar conductor";
var scheduledServiceNotFound$1 = "El servicio programado no ha sido localizado";
var scheduledFor$1 = "Programado para";
var searchResourceOrTechnician$1 = "Busca recurso o técnico";
var searchResources$1 = "Busca recursos";
var searchAResource$1 = "Buscar un recurso";
var searchAService$1 = "Buscar un servicio";
var searchByAssistedOrFilecase$1 = "Asistido o Exp";
var searchByAssistedFilecaseOrPlate$1 = "Asistido, Aseg, Exp. o Matrícula";
var searchByAssistedFilecaseOrProvider$1 = "Asistido, Exp. o Proveedor";
var searchByCodeOrName$1 = "Busca por Código o Nombre";
var searchByCodeNameOrCostType$1 = "Busca por Código, Nombre o Tipo de costo";
var searchByCodeNameOrMediumType$1 = "Busca por Código, Nombre o Tipo de medio";
var searchByCustomer$1 = "Busca por Cliente";
var searchByCustomerOrFilecase$1 = "Cliente o Exp";
var searchByCustomerFilecaseOrPlate$1 = "Cliente, Exp. o Matrícula";
var searchByFileCase$1 = "Busca por Expediente";
var searchByIdForOrFilecaseNumber$1 = "Busca por ID, Para o Nº Expediente";
var searchByInvoiceNumber$1 = "Busca por Nº Factura";
var searchByName$1 = "Busca por Nombre";
var searchByNameCIFOrAddress$1 = "Busca por Nombre, CIF o Dirección";
var searchByNameOrAddress$1 = "Busca por Nombre o Dirección";
var searchByNameOrCode$1 = "Busca por Nombre o Código";
var searchByNamePlateOrCode$1 = "Busca por Nombre, Matrícula o Código";
var searchByNameSurnameUserOrNick$1 = "Busca por Nombre, Apellidos, Usuario o Nick";
var searchByProviderOrName$1 = "Busca por Proveedor o Nombre";
var searchByTerm$1 = "Busca por término";
var searchInsurancePolicy$1 = "Buscar póliza";
var seeAverages$1 = "Ver medias";
var breakdown$1 = "Desglose";
var seeCapabilityComment$1 = "Ver comentario de prestación";
var seeComment$1 = "Ver comentario";
var seeContactAndComment$1 = "Ver contacto y comentario";
var seeDescription$1 = "Ver descripción";
var seeService$1 = "Ver servicio";
var selfValidated$1 = "Autovalidado";
var send$1 = "Enviar";
var sendComments$1 = "Enviar comentarios";
var sended$1 = "Enviado";
var sendEmail$1 = "Enviar correo";
var sendForReview$1 = "Enviar a revisión";
var sendTo$1 = "Enviar a";
var sendToList$1 = "Enviar a la lista";
var serverConnectionError$1 = "¡Error de conexión con el servidor!";
var service$1 = "servicio";
var serviceExecution$1 = "Ejecución del servicio";
var serviceInAuction$1 = "Servicio en subasta";
var serviceLevels$1 = "Niveles de servicio";
var serviceMap$1 = "Mapa de viales";
var serviceNotFound$1 = "No se ha encontrado el servicio";
var serviceRequestAndTracking$1 = "Solicitud y seguimiento del servicio";
var services$1 = "Servicios";
var serviceSentToAuction$1 = "Servicio enviado a subasta";
var serviceStatus$1 = {
  auctioning: "En subasta",
  auctioningAvatar: "S",
  pending_assign: "Pendiente asignación",
  pendingAssign: "Pendiente asignación",
  pending_assignAvatar: "PA",
  provider_pending: "Pendiente proveedor",
  providerPending: "Pendiente proveedor",
  provider_pendingAvatar: "PP",
  provider_accepted: "Aceptado proveedor",
  providerAccepted: "Aceptado proveedor",
  providerAccept: "Aceptado proveedor",
  provider_acceptedAvatar: "AP",
  queued: "En espera",
  queuedAvatar: "E",
  scheduled: "Programado",
  scheduledAvatar: "PR",
  pending: "Pendiente",
  pendingAvatar: "PE",
  assigned: "Agendado",
  assignedAvatar: "AG",
  planned: "Planificado",
  plannedAvatar: "PL",
  accepted: "Aceptado",
  acceptedAvatar: "AC",
  started: "Iniciado",
  startedAvatar: "I",
  located: "Localizado",
  locatedAvatar: "L",
  inris: "En reparación",
  inrisAvatar: "RP",
  loaded: "Cargado",
  loadedAvatar: "CA",
  completed: "Completado",
  completedAvatar: "CO",
  finished: "Finalizado",
  finishedAvatar: "F",
  rejected: "Rechazado",
  rejectedAvatar: "RC",
  canceled: "Anulado",
  canceledAvatar: "AN"
};
var settings$1 = "Ajustes";
var settingsUpdated$1 = "Ajustes actualizados";
var sharedCode$1 = "Código compartido";
var sharedNote$1 = "Nota compartida";
var sharedNotes$1 = "Notas compartidas";
var shipments$1 = "Remesas";
var shipmentStatusValues$1 = {
  collecting: "Interrumpida",
  pending: "Generada",
  billed: "Facturada",
  collected: "Cobrada",
  payed: "Pagada"
};
var showAllMediums$1 = "Mostrar todos los medios";
var showSolicitedMedium$1 = "Mostrar medio solicitado";
var situation$1 = "Situación";
var solicitedMedium$1 = "Medio solicitado";
var sortCriteria$1 = "Criterio ordenación";
var soundActivated$1 = "Sonido activado";
var soundOff$1 = "Sonido desactivado";
var start$1 = "Inicio";
var started$1 = "Iniciado";
var status$1 = "Estado";
var statuses$1 = "Estados";
var subject$1 = "Asunto";
var subscribe$1 = "Suscribirme";
var subtotal$1 = "Subtotal";
var suburb$1 = "Carretero";
var suburbService$1 = "Servicio carretero";
var summary$1 = "Resumen";
var supportCenter$1 = "Centro de soporte";
var supportTeam$1 = "Equipo de soporte";
var survey$1 = "Encuesta";
var surveys$1 = "Encuestas";
var T$1 = "T";
var taxes$1 = "Impuestos";
var team$1 = "Equipo";
var teamName$1 = "Nombre del equipo";
var technician$1 = "Técnico";
var technicians$1 = "Técnicos";
var theField$1 = "El campo";
var ticket$1 = "Ticket";
var tickets$1 = "Tickets";
var ticketStatus$1 = {
  "new": "Nuevo",
  newAvatar: "N",
  open: "Abierto",
  openAvatar: "A",
  closed: "Cerrado",
  closedAvatar: "C"
};
var time$1 = "Tiempo";
var timeInAlert$1 = "Tiempo en alerta";
var timeline$1 = "Línea de tiempo";
var title$1 = "Título";
var toastErrorDuplicateAddressPickupDeliveryTitle$1 = "Error en las direcciones";
var toastErrorDuplicateAddressPickupDeliveryText$1 = "La dirección de recogida y entrega deben ser diferentes.";
var toastErrorDuplicateAddressPickupDestinationTitle$1 = "Error en las direcciones";
var toastErrorDuplicateAddressPickupDestinationText$1 = "La dirección de recogida y destino del asistido deben ser diferentes.";
var toastErrorTextDefault$1 = "No ha sido posible realizar la operación.";
var toastErrorTitleDefault$1 = "Error en la operación";
var toastErrorTransferPeopleBudget$1 = {
  expiredEstimate: {
    title: "Error",
    text: "La estimación de tarifa seleccionada ha expirado."
  },
  invalidEstimate: {
    title: "Error",
    text: ""
  },
  productNotFound: {
    title: "Error",
    text: "El recurso seleccionado no ha sido localizado."
  },
  cabifyIntegrationProblem: {
    title: "Error",
    text: "No se ha podido solicitar el traslado."
  },
  profileWithoutResources: {
    title: "Error",
    text: "Perfil sin recursos"
  }
};
var toastErrorTitle_downloadFile$1 = "Error";
var toastErrorText_downloadFile$1 = "No ha sido posible descargar el fichero.";
var toastSuccessTextDefault$1 = "La operación se ha realizado correctamente.";
var toastSuccessTitleDefault$1 = "Operación realizada con éxito";
var today$1 = "Hoy";
var toDefine$1 = "Por definir";
var total$1 = "Total";
var totals$1 = "Totales";
var toTheClient$1 = "Al cliente";
var toTheProvider$1 = "Al proveedor";
var town$1 = "Localidad";
var tracking$1 = "Seguimiento";
var trackingMessage$1 = "Mensaje de seguimiento";
var transfer$1 = "Traslado";
var transferHasBeenCancelled$1 = "El traslado ha sido anulado.";
var transferPeople$1 = "Traslado de personas";
var transferPeopleBudget$1 = "Propuesta de traslado";
var transferPeopleRequest$1 = "Solicitud de traslado";
var transferPeopleRequestType$1 = {
  immediate: "Servicio inmediato",
  deferred: "Servicio programado"
};
var transferPeopleRequiredValidPhoneNumber$1 = "Para los traslados es necesario facilitar un teléfono de contacto.";
var transfers$1 = "Traslados";
var transfersAvailable$1 = "Traslados disponibles";
var transferTheAssisted$1 = "Trasladar al asistido";
var type$1 = "Tipo";
var typeAndName$1 = "Tipo y nombre";
var typeless$1 = "Sin tipo";
var typeOfService$1 = "Tipo de servicio";
var types$1 = "Tipos";
var U$1 = "U";
var udWithCount$1 = "{{count}} ud.";
var udWithCount_plural$1 = "{{count}} uds.";
var unAssign$1 = "Liberar";
var unAssignTechnician$1 = "Liberar técnico";
var unAssignTechnicianModalText$1 = "¿Estás seguro que deseas liberar el técnico?";
var unAssignTechnicianModalAditionalText$1 = "Al hacerlo, el servicio pasará a estado Aceptado proveedor y podrás asignar un técnico nuevo.";
var unAssignDriver$1 = "Liberar conductor";
var unAssignDriverModalText$1 = "¿Estás seguro que deseas liberar el conductor?";
var unAssignDriverModalAditionalText$1 = "Al hacerlo, el servicio pasará a estado Aceptado proveedor y podrás asignar un conductor nuevo.";
var unavailable$1 = "No disponible";
var units$1 = "Unidades";
var unitAbbrev$1 = "ud.";
var unitsAbbrev$1 = "uds.";
var unselected$1 = "Sin selección";
var unsubscribe$1 = "Anular suscripción";
var urban$1 = "Local";
var urbanFee$1 = "Local";
var urbanService$1 = "Servicio local";
var user$1 = "Usuario";
var userProfiles$1 = "Perfiles de usuario";
var userProfilesWithCount$1 = "{{count}} Perfil de usuario";
var userProfilesWithCount_plural$1 = "{{count}} Perfiles de usuario";
var users$1 = "Usuarios";
var userType$1 = "Tipo de usuario";
var V$1 = "V";
var validFrom$1 = "Válido desde";
var validUntil$1 = "Válido hasta";
var variable$1 = "Variable";
var vehicleAssistance$1 = "Asistencia de vehículos";
var vehicleTypes$1 = "Tipo de vehículos";
var version$1 = "Versión";
var vial$1 = "Vial";
var vials$1 = "Viales";
var vialRates$1 = "Tarifas viales";
var vialServices$1 = "Servicios viales";
var vialSettings$1 = "Ajustes de viales";
var view$1 = "Vista";
var viewAssistedRating$1 = "Ver valoración del asistido";
var viewContact$1 = "Ver contacto";
var viewContactandComment$1 = "Ver contacto y comentario";
var viewRoute$1 = "Ver ruta";
var views$1 = "Vistas";
var vin$1 = "VIN";
var virtualSwitchboard$1 = "Centralita virtual";
var W$1 = "W";
var waitingList$1 = "Lista de espera";
var web$1 = "Web";
var webAddress$1 = "Dirección web";
var wholeWordSearch$1 = "Búsqueda de palabras completas";
var wholeWordSearch3Charts$1 = "Busca palabras completas (min 3 carac.)";
var withAlert$1 = "Con alerta";
var withholdings$1 = "Retenciones";
var withPriority1$1 = "Con prioridad 1";
var withPriority2$1 = "Con prioridad 2";
var withPriority3$1 = "Con prioridad 3";
var writeANote$1 = "Escribir una nota";
var wrongUser$1 = "Usuario incorrecto";
var wrongUsernameOrPassword$1 = "Usuario o contraseña incorrectos";
var X$1 = "X";
var Y$1 = "Y";
var year$1 = "Año";
var yes$1 = "Sí";
var yesterday$1 = "Ayer";
var youHaveExceededTheNumberOfAtempsts$1 = "Has excedido el número de intentos";
var Z$1 = "Z";
var maxMinutes$1 = "Minutos max.";
var maxPhotos$1 = "Fotos max.";
var between0And5Minutes$1 = "Entre 0 y 5 minutos";
var between0And10Minutes$1 = "Entre 0 y 10 minutos";
var between0And240Minutes$1 = "Entre 0 y 240 minutos";
var between1And7Minutes$1 = "Entre 1 y 7 minutos";
var between2And5Minutes$1 = "Entre 2 y 5 minutos";
var between2And10Minutes$1 = "Entre 2 y 10 minutos";
var between0And10Photos$1 = "Entre 0 y 10 fotos";
var between1And10Characters$1 = "Entre 1 y 10 caracteres";
var between0And120Minutes$1 = "Entre 0 y 120 minutos";
var ACCEPTED$1 = "Aceptado";
var add_company_description$1 = "Completa los datos de la compañía a dar de alta, indicando si se trata de un cliente o de un proveedor.";
var add_company$1 = "Añadir compañía";
var addChartText$1 = "Pulsa el botón de añadir para incorporar gráficos al Business Intelligence.";
var addChartTitle$1 = "Añadir gráfico";
var all_female$1 = "Todas";
var all_male$1 = "Todos";
var amount$1 = "Importe";
var apply$1 = "Aplicar";
var assignProvider$1 = "Asignar proveedor";
var assignedToMe$1 = "Asignados a mí";
var assignItToMe$1 = "Asignármelo";
var AVAILABLE$1 = "Disponible";
var blocked$1 = "Bloqueado";
var budgetToastSuccessText$1 = "El servicio se ha añadido al listado.";
var budgetToastSuccessTitle$1 = "Presupuesto aceptado";
var scheduledBudgetToastSuccessText$1 = "El servicio programado se ha añadido al listado.";
var scheduledBudgetToastSuccessTitle$1 = "Presupuesto aceptado";
var transferPeopleBudgetToastSuccessText$1 = "El traslado se ha añadido al listado.";
var transferPeopleBudgetToastSuccessTitle$1 = "Presupuesto aceptado";
var budgetToastSuccessQueueText$1 = "El servicio ha sido añadido a la lista de espera.";
var budgetToastSuccessQueueTitle$1 = "Operación realizada con éxito";
var bussy$1 = "ocupado";
var CANCELED$1 = "Anulado";
var centerNum$1 = "Nº Centros";
var centers$1 = "Centros";
var closed$1 = "Cerrado";
var codeAlreadyAssigned$1 = "Código ya asignado";
var color$1 = "Color";
var companyPendingDocumentation$1 = "Pendiente documentación compañía";
var companyProviderCode$1 = "Nuevo ID";
var COMPLETED$1 = "Completado";
var custodyRate$1 = "Precio día extra";
var damageReport$1 = "Parte de daños";
var damageRequired$1 = "Parte obligatorio";
var day$1 = "Día";
var days$1 = "Días";
var del$1 = "Eliminar";
var delivery$1 = "Entrega";
var deliveryAddressRequired$1 = "Dirección de entrega obligatoria";
var destination$1 = "Destino";
var documents$1 = "Documentos";
var exit$1 = "Salir";
var expired$1 = "Caducado";
var EXTRA_CHARGES$1 = "GASTOS EXTRA";
var extraCharges$1 = "Gastos";
var festive$1 = "Festivo";
var fieldsRequired$1 = "Los campos con (*) son obligatorios.";
var files$1 = "Archivos";
var filters$1 = "Filtros";
var FINISHED$1 = "Finalizado";
var free$1 = "libre";
var from$1 = "De";
var fromDate$1 = "Desde";
var generalInfo$1 = "Inf. General";
var groupName$1 = "Nombre de la compañía";
var id$1 = "Id";
var IN_SERVICE$1 = "En servicio";
var information$1 = "Información";
var INRIS$1 = "En reparación";
var integrated$1 = "Integrado";
var invite$1 = "Invitar";
var invoiceDate$1 = "Fecha fact.";
var lastAct$1 = "Última act.";
var left$1 = "Quedan";
var LOADED$1 = "Cargado";
var LOCATED$1 = "Localizado";
var locations$1 = "Localizaciones";
var mediums$1 = "Medios";
var MEDIUMS$1 = "MEDIOS";
var modify$1 = "Modificar";
var newRates$1 = "Nuevas tarifas";
var nexus$1 = "Nexus";
var nexusFee$1 = "Fee Nexus";
var nFilecase$1 = "Nº Expediente";
var nFilecaseAbbrev$1 = "Nº Exp.";
var nickName$1 = "Nick";
var nightlyEnd$1 = "Fin horario noct.";
var nightlyStart$1 = "Inicio horario noct.";
var nightly$1 = "Nocturno";
var nigthly$1 = "Nocturno";
var nightlyFestive$1 = "Festivo nocturno";
var nInvoice$1 = "Nº Factura";
var nInvoices$1 = "Nº Facturas";
var none$1 = "Ninguno";
var NOT_IN_NEXUS$1 = "Fuera de Nexus";
var not$1 = "No";
var nNexus$1 = "Nº Nexus";
var nPayments$1 = "Nº Pagos";
var nServices$1 = "Nº Servicios";
var numberOfInvoices$1 = "Número de facturas";
var of$1 = "de";
var open$1 = "Abierto";
var outOfService$1 = "fuera de servicio";
var ownFilecaseNumber$1 = "Nº expediente propio";
var ownFilecaseNumberAbbrev$1 = "Nº expediente";
var partialPrice$1 = "Precio parcial";
var participants$1 = "Participantes";
var participation$1 = "Participación";
var payed$1 = "Pagada";
var payments$1 = "Pagos";
var pendingAbbrev$1 = "Pdte.";
var photosNumber$1 = "Nº de fotos";
var pickup$1 = "Recogida";
var pickupAddress$1 = "Lugar recogida";
var pictures$1 = "Fotos";
var processDate$1 = "Fecha de procesamiento";
var processed$1 = "Procesado";
var providerAlreadyMapped$1 = "Proveedor ya mapeado";
var REJECTED$1 = "Rechazado";
var rejection$1 = "Rechazados";
var request$1 = "Solicitar";
var requester$1 = "Solicitante";
var resource$1 = "Recurso";
var resourceActivity$1 = "Recursos";
var resourceDistance$1 = "Está a";
var resourceRoute$1 = "Recorrido";
var resourceTime$1 = "Llega en";
var responsable$1 = "Responsable";
var responseNumberAbbrev$1 = "Nº respuestas";
var RISEND$1 = "Fin RIS";
var RISSTART$1 = "Inicio RIS";
var rowsPerPage$1 = "Filas por página";
var saveView$1 = "Guardar vista";
var sendSMSTracking$1 = "Enviar SMS seguimiento";
var sendSurvey$1 = "Enviar encuesta";
var serviceActivity$1 = "Servicios";
var serviceBudget$1 = "Propuesta de servicio";
var serviceRequest$1 = "Solicitud de servicio";
var serviceType$1 = "Tipo servicio";
var shared$1 = "Compartido";
var shipmentDate$1 = "Fecha remesa";
var sign$1 = "Firmas";
var sta$1 = "Es.";
var STARTED$1 = "Iniciado";
var supportTeamAbbrev$1 = "Equipo Sop.";
var surchargeRate$1 = "% Recargo noct.";
var surname$1 = "Apellidos";
var teamMembers$1 = "Miembros del equipo";
var teamTickets$1 = "Los del equipo";
var totalPrice$1 = "Precio total";
var UNAVAILABLE$1 = "No disponible";
var userProfile$1 = "Perfil";
var validate$1 = "Validar";
var validated$1 = "validado";
var vehicle$1 = "Vehículo";
var weekend$1 = "Fin de semana";
var category$1 = {
  car: "Coche",
  ind: "Industrial",
  moto: "Moto",
  ptf: "Plataforma"
};
var collective2$1 = {
  toastColectiveDeactivateErrorTitle: "ERROR",
  toastColectiveDeactivateErrorTextDefault: "En estos momentos no es posible desactivar el colectivo. Por favor, vuelve a intentarlo en unos minutos."
};
var companyList$1 = {
  companyWithCount: "{{count}} Companía",
  companyWithCount_plural: "{{count}} Companías"
};
var depositList$1 = {
  depositWithCount: "{{count}} Depósito",
  depositWithCount_plural: "{{count}} Depósitos"
};
var format$1 = {
  currency: "€ ",
  decimalSeparator: ",",
  thousandSeparator: "."
};
var invoiceList$1 = {
  invoiceWithCount: "{{count}} Factura",
  invoiceWithCount_plural: "{{count}} Facturas"
};
var mediumList$1 = {
  mediumWithCount: "{{count}} Medio",
  mediumWithCount_plural: "{{count}} Medios"
};
var mediumTypesList$1 = {
  mediumTypesWithCount: "{{count}} Tipo de medio",
  mediumTypesWithCount_plural: "{{count}} Tipos de medios"
};
var modals$1 = {
  addService: {
    linkServices: "Vincular servicios",
    linkServicesInfo: "El último servicio Nexus de este vehículo indica que está en un depósito.",
    linkServicesQuestion: "¿Deseas asociar el expediente Nexus y vincular los servicios?"
  },
  budget: {
    timeOut: "Tiempo agotado",
    timeOutInfo: "Se ha agotado el tiempo máximo para aceptar la propuesta. Inténtalo de nuevo."
  },
  ticketDetail: {
    closeTicket: "Cerrar ticket",
    closeTicketQuestion: "¿Estás seguro que deseas cerrar el ticket? Si lo cierras, se dará por resuelto y no podrás enviar más mensajes."
  }
};
var operationTypesList$1 = {
  operationTypesWithCount: "{{count}} Tipo de intervención",
  operationTypesWithCount_plural: "{{count}} Tipos de intervención"
};
var paymentList$1 = {
  paymentWithCount: "{{count}} Pago a proveedores",
  paymentWithCount_plural: "{{count}} Pagos a proveedores",
  processPaymentTitle: "Procesar pagos",
  processPaymentText: "Indica la fecha en la que el fichero ha sido procesado por el banco.",
  generatePaymentsTitle: "Generar pagos",
  generatePaymentsText: "Se van a generar todos los pagos hasta la fecha indicada. El fichero N34-14 se enviará por email.",
  toastGeneratePaymentsSuccessTitle: "Pago generado correctamente",
  toastGeneratePaymentsSuccessText: "El pago se ha generado y se ha enviado el fichero.",
  toastProcessPaymentSuccessTitle: "Pago procesado correctamente",
  toastProcessPaymentSuccessText: "El pago se ha procesado con la fecha indicada.",
  toastGeneratePaymentsWarningTitle: "No ha podido generarse",
  toastGeneratePaymentsWarningText: "No hay facturas pendientes hasta esa fecha."
};
var searchTools$1 = {
  title: "Herramientas de búsqueda",
  byRoadKmTitle: "Busca por carretera y kilómetro",
  byRoadKm_1: "1. Introduce el nombre de la carretera y el punto kilométrico. Ejemplo: E-15/15",
  byRoadKm_2: "2. Pulsa \"Validar\" para validar la ubicación",
  roadKilometer: "Carretera / Kilómetro",
  byCoordsTitle: "Busca por coordenadas",
  byCoords_1: "Pulsa el botón del mapa y localiza la ubicación que necesitas.",
  byCoords_2: "Pulsa el botón derecho y copia las coordenadas que te ofrece Google.",
  byCoords_3: "Pégalas debajo y pulsa \"Validar\" para validar la ubicación.",
  coordsLatitudeLongitude: "Coordenadas (latitud, longitud)"
};
var serviceList$1 = {
  serviceWithCount: "{{count}} Servicio",
  serviceWithCount_plural: "{{count}} Servicios"
};
var servicesError$1 = {
  cancelServiceErrorTitle: "Error al solicitar la anulación",
  notCancelableService: "El servicio no se puede anular en su estado actual.",
  invalidService: "No ha sido posible solicitar la anulación del servicio.",
  cancelServiceUnknownError: "En estos momentos no es posible solicitar la anulación del servicio. Vuelva a intentarlo en unos minutos.",
  openDisputeErrorTitle: "Error al solicitar apertura de disputa",
  openDisputeUnknownError: "En estos momentos no es posible abrir una disputa para el servicio. Vuelva a intentarlo en unos minutos.",
  closeDisputeErrorTitle: "Error al solicitar cierre de disputa",
  closeDisputeUnknownError: "En estos momentos no es posible cerrar la disputa del servicio. Vuelva a intentarlo en unos minutos."
};
var transferPeopleError$1 = {
  cancelTransferPeopleErrorTitle: "Error al solicitar la anulación",
  notCancelableService: "El traslado no se puede anular en su estado actual.",
  invalidTransferPeople: "No ha sido posible solicitar la anulación del traslado.",
  cancelServiceUnknownError: "En estos momentos no es posible solicitar la anulación del traslado. Vuelva a intentarlo en unos minutos."
};
var transferPeopleList$1 = {
  transferPeopleWithCount: "{{count}} Traslado",
  transferPeopleWithCount_plural: "{{count}} Traslados"
};
var shipment$1 = {
  collecting: "Interrumpida",
  pending: "Generada",
  billed: "Facturada",
  collected: "Cobrada",
  payed: "Pagada"
};
var ticketDetail$1 = {
  toastSendMessageSuccessTitle: "Mensaje enviado correctamente",
  toastSendMessageSuccessText: "El mensaje ha sido enviado y añadido a la lista.",
  toastSendMessageErrorTitle: "Error al enviar mensaje",
  toastSendMessageErrorText: "Ha ocurrido un error en el envío del mensaje.",
  toastCloseMessageSuccessTitle: "Ticket cerrado correctamente",
  toastCloseMessageSuccessText: "El ticket ha sido cerrado y actualizado en la lista.",
  toastCloseMessageErrorTitle: "Error al cerrar ticket",
  toastCloseMessageErrorText: "Ha ocurrido un error al cerrar el ticket."
};
var ticketList$1 = {
  ticketWithCount: "{{count}} Ticket",
  ticketWithCount_plural: "{{count}} Tickets"
};
var user2$1 = {
  toastUserDeactivateErrorTitle: "ERROR",
  toastUserDeactivateErrorTextDefault: "En estos momentos no es posible desactivar al usuario. Por favor, vuelve a intentarlo en unos minutos.",
  toastUserDeactivateErrorText: "El usuario activo no puede desactivarse a sí mismo.",
  toastUserInServiceDeactivateErrorText: "No es posible desactivar a un usuario que se encuentra actualmente realizando un servicio.",
  toastUserNotificationSuccessTitle: "Notificación enviada",
  toastUserNotificationSuccessText: "Hemos enviado una notificación al usuario con las instrucciones.",
  toastUserNotificationErrorTitle: "Ha ocurrido un error",
  toastUserNotificationErrorText: "No hemos podido enviar la notificación al usuario."
};
var userList$1 = {
  userWithCount: "{{count}} Usuario",
  userWithCount_plural: "{{count}} Usuarios"
};
var validation$1 = {
  fieldRequired: "Campo obligatorio",
  invalidCurrencyAmount: "No válido",
  invalidTimeFormat: "Formato de hora no válido"
};
var loginYourAccount$1 = "Accede a tu cuenta";
var checkYourEmail$1 = "Comprueba tu correo";
var updatedUser$1 = "Usuario actualizado";
var errorCreatingCompany$1 = "Error al crear compañía";
var min$1 = "min";
var distance$1 = "Distancia";
var es$2 = {
  "********** BEGIN CHECKED WORDS **********": "**********",
  "% IRPF": "% IRPF",
  "% IVA": "% IVA",
  IRPF: IRPF$1,
  IVA: IVA$1,
  NIF: NIF$1,
  "NIF/CIF": "NIF/CIF",
  "NIF/SS": "NIF/SS",
  "NIF/CIF/SS": "NIF/CIF/SS",
  "#": "#",
  "1st": "1º",
  "2nd": "2º",
  "3rd": "3º",
  "4th": "4º",
  "5th": "5º",
  "6th": "6º",
  "7th": "7º",
  "8th": "8º",
  "9th": "9º",
  "10th": "10º",
  betweenMinAndMaxKilometers: betweenMinAndMaxKilometers$1,
  metricUnits: metricUnits$1,
  imperialUnits: imperialUnits$1,
  A: A$2,
  accept: accept$1,
  accepted: accepted$1,
  acceptUpdate: acceptUpdate$1,
  accessToTheViews: accessToTheViews$1,
  accessWithMicrosoft: accessWithMicrosoft$1,
  activateGuardMode: activateGuardMode$1,
  activateGuardModeWarningText: activateGuardModeWarningText$1,
  activateGuardModeWarningAditionalText: activateGuardModeWarningAditionalText$1,
  active: active$1,
  activity: activity$1,
  accumulateNightAndHolidaySurcharge: accumulateNightAndHolidaySurcharge$1,
  add: add$1,
  addAuxService: addAuxService$1,
  addCapability: addCapability$1,
  addCollective: addCollective$1,
  addCost: addCost$1,
  addCostType: addCostType$1,
  addedCollective: addedCollective$1,
  addFault: addFault$1,
  addedFault: addedFault$1,
  additionalInformation: additionalInformation$1,
  additionalPrice: additionalPrice$1,
  additionalPriceAbbrev: additionalPriceAbbrev$1,
  addNote: addNote$1,
  address: address$1,
  addressNotLocated: addressNotLocated$1,
  addUserProfile: addUserProfile$1,
  admin: admin$1,
  advancedConfiguration: advancedConfiguration$1,
  aheadServices: aheadServices$1,
  alert: alert$1,
  alerts: alerts$1,
  alertStart: alertStart$1,
  all_f: all_f$1,
  all_m: all_m$1,
  allowAccess: allowAccess$1,
  allowCalls: allowCalls$1,
  allowCalls_addService: allowCalls_addService$1,
  allowGuardErrorTitle: allowGuardErrorTitle$1,
  allowGuardErrorText: allowGuardErrorText$1,
  allowSMS: allowSMS$1,
  allProvidersAutomatic: allProvidersAutomatic$1,
  anErrorHasOccurred: anErrorHasOccurred$1,
  applyCosts: applyCosts$1,
  approve: approve$1,
  assign: assign$1,
  "assignment/lastActivityAbbrev": "Asig / ult. ac",
  assignTechnician: assignTechnician$1,
  assistance: assistance$1,
  assistanceWithoutTransfer: assistanceWithoutTransfer$1,
  assistanceWithoutTransferWarning: assistanceWithoutTransferWarning$1,
  assistanceWithoutTransferWarningQuestion: assistanceWithoutTransferWarningQuestion$1,
  assisted: assisted$1,
  assistedInsuredAbbrev: assistedInsuredAbbrev$1,
  assistedDestinationAddress: assistedDestinationAddress$1,
  associatedDocuments: associatedDocuments$1,
  at_time: at_time$1,
  assigned: assigned$1,
  ASSIGNED: ASSIGNED$1,
  attachADocument: attachADocument$1,
  "attach the following documents": "Adjunta los siguientes documentos",
  attachment: attachment$1,
  attachments: attachments$1,
  auction: auction$1,
  auctionConfiguration: auctionConfiguration$1,
  auctioned: auctioned$1,
  AUCTIONED: AUCTIONED$1,
  auctioning: auctioning$1,
  AUCTIONING: AUCTIONING$1,
  auctionInPriority: auctionInPriority$1,
  auctionInPriority1: auctionInPriority1$1,
  auctionInPriority2: auctionInPriority2$1,
  auctionInPriority3: auctionInPriority3$1,
  auctionInPriority4: auctionInPriority4$1,
  auctions: auctions$1,
  auctionService: auctionService$1,
  auto: auto$1,
  automatic: automatic$1,
  automaticProvider: automaticProvider$1,
  auxiliary: auxiliary$1,
  auxiliarySettings: auxiliarySettings$1,
  auxiliaries: auxiliaries$1,
  auxiliariesRates: auxiliariesRates$1,
  auxServiceList: auxServiceList$1,
  auxService: auxService$1,
  auxServices: auxServices$1,
  available: available$1,
  available_plural: available_plural$1,
  availableProvidersAbbrev: availableProvidersAbbrev$1,
  availableResources: availableResources$1,
  availableResourcesWithCount: availableResourcesWithCount$1,
  availableResourcesWithCount_plural: availableResourcesWithCount_plural$1,
  average: average$1,
  averageRating: averageRating$1,
  B: B$1,
  base: base$1,
  baseAmount: baseAmount$1,
  billed: billed$1,
  billing: billing$1,
  brand: brand$1,
  browse: browse$1,
  budgetWarningNoBaseFound: budgetWarningNoBaseFound$1,
  businessIntelligence: businessIntelligence$1,
  byAmount: byAmount$1,
  byBrand: byBrand$1,
  byPositionOnQueue: byPositionOnQueue$1,
  byScore: byScore$1,
  byTime: byTime$1,
  C: C$1,
  calculateAllServicesAsSuburban: calculateAllServicesAsSuburban$1,
  calendar: calendar$1,
  cancel: cancel$1,
  cancel_2: cancel_2$1,
  outputCancellationPercentageAbbrev: outputCancellationPercentageAbbrev$1,
  cancelAmount: cancelAmount$1,
  cancelRatePercentage: cancelRatePercentage$1,
  cancelRateAmount: cancelRateAmount$1,
  cancelReason: cancelReason$1,
  cancelService: cancelService$1,
  cancelServiceFinished: cancelServiceFinished$1,
  cancelTransferPeople: cancelTransferPeople$1,
  cancelTransferPeopleWarning: cancelTransferPeopleWarning$1,
  "Cannot send service to this provider because it has not defined any deposit (base)": "No se puede enviar el servicio a este proveedor porque no ha definido ningún depósito (base)",
  capabilityList: capabilityList$1,
  capability: capability$1,
  capabilityCollectiveAbbrev: capabilityCollectiveAbbrev$1,
  capabilities: capabilities$1,
  center: center$1,
  centerName: centerName$1,
  centerNotFound: centerNotFound$1,
  change: change$1,
  changePassword: changePassword$1,
  charge: charge$1,
  chargeWithCount: chargeWithCount$1,
  chargeWithCount_plural: chargeWithCount_plural$1,
  check: check$1,
  childProfile: childProfile$1,
  chosenDriver: chosenDriver$1,
  cif: cif$1,
  city: city$1,
  "class": "Clase",
  clone: clone$1,
  cloneService: cloneService$1,
  close: close$1,
  closeDispute: closeDispute$1,
  code: code$1,
  collectDate: collectDate$1,
  collected: collected$1,
  collectInvoice: collectInvoice$1,
  collective: collective$1,
  collectives: collectives$1,
  collectiveWithCount: collectiveWithCount$1,
  collectiveWithCount_plural: collectiveWithCount_plural$1,
  collectiveProviderAbbrev: collectiveProviderAbbrev$1,
  comment: comment$1,
  commentAboutCapability: commentAboutCapability$1,
  companies: companies$1,
  "companies-opt": {
    listWithCount: "{{count}} Compañía",
    listWithCount_plural: "{{count}} Compañías"
  },
  company: company$1,
  companyName: companyName$1,
  companyProfile: companyProfile$1,
  completed: completed$1,
  configuration: configuration$1,
  consultList: consultList$1,
  "continue": "Continuar",
  costName: costName$1,
  costs: costs$1,
  costSearch: costSearch$1,
  costsWithCount: costsWithCount$1,
  costsWithCount_plural: costsWithCount_plural$1,
  costSheets: costSheets$1,
  costSheetStatus: costSheetStatus$1,
  costType: costType$1,
  costTypeName: costTypeName$1,
  costTypes: costTypes$1,
  costTypesWithCount: costTypesWithCount$1,
  costTypesWithCount_plural: costTypesWithCount_plural$1,
  craneService: craneService$1,
  create: create$1,
  currentPassword: currentPassword$1,
  custodyDays: custodyDays$1,
  customer: customer$1,
  "customer/capability": "Cliente / prestación",
  "customer/exp": "Cliente / Exp.",
  D: D$1,
  dashboard: dashboard$1,
  date: date$1,
  "Date scheduled service": "Fecha servicio programado",
  dateRangeExceeded: dateRangeExceeded$1,
  dayAndTime: dayAndTime$1,
  deadLine: deadLine$1,
  concessionaire: concessionaire$1,
  deferred: deferred$1,
  deferredService: deferredService$1,
  deferredShort: deferredShort$1,
  deferredShorter: deferredShorter$1,
  deleteCost: deleteCost$1,
  deletePath: deletePath$1,
  deleteRequest: deleteRequest$1,
  deposits: deposits$1,
  description: description$1,
  detail: detail$1,
  disconnect: disconnect$1,
  disputeReason: disputeReason$1,
  documentation: documentation$1,
  documentationProfile: documentationProfile$1,
  documentNumberAbbrev: documentNumberAbbrev$1,
  documentProfile: documentProfile$1,
  documentProfiles: documentProfiles$1,
  "documentProfiles-opt": {
    listWithCount: "{{count}} Perfil de documento",
    listWithCount_plural: "{{count}} Perfiles de documentos"
  },
  "documents-status": {
    pending: "Pendiente de verificación",
    validated: "Válido",
    rejected: "Rechazado el",
    rejectReason: "Motivo de rechazo",
    expired: "Caducó el",
    current: "Vigente hasta el"
  },
  documentAdded: documentAdded$1,
  documentType: documentType$1,
  documentTypes: documentTypes$1,
  "documentTypes-opt": {
    listWithCount: "{{count}} Tipo de documento",
    listWithCount_plural: "{{count}} Tipos de documentos"
  },
  doNotAssociate: doNotAssociate$1,
  dragData: dragData$1,
  driver: driver$1,
  drivers: drivers$1,
  "driver/medium": "Conductor / Medio",
  duplicate: duplicate$1,
  duplicateService: duplicateService$1,
  E: E$1,
  edit: edit$1,
  editAuxService: editAuxService$1,
  editCapability: editCapability$1,
  editCollective: editCollective$1,
  editCost: editCost$1,
  editCostType: editCostType$1,
  editFault: editFault$1,
  editSupportTeam: editSupportTeam$1,
  editUserProfile: editUserProfile$1,
  email: email$1,
  endService: endService$1,
  entry: entry$1,
  entryDateAbbrev: entryDateAbbrev$1,
  error: error$1,
  errorAddingDocument: errorAddingDocument$1,
  estimatedTime: estimatedTime$1,
  execution: execution$1,
  executionProfile: executionProfile$1,
  expense: expense$1,
  expiredCode: expiredCode$1,
  expires: expires$1,
  events: events$1,
  excessOfTimeForOutService: excessOfTimeForOutService$1,
  excessOfTimeForUrbanService: excessOfTimeForUrbanService$1,
  excessOfTimeInCurrentStatus: excessOfTimeInCurrentStatus$1,
  excessOfTimeToCompleteService: excessOfTimeToCompleteService$1,
  excessOfTimeToStartScheduledService: excessOfTimeToStartScheduledService$1,
  F: F$1,
  fault: fault$1,
  faults: faults$1,
  faultCollectiveAbbrev: faultCollectiveAbbrev$1,
  faultWithCount: faultWithCount$1,
  faultWithCount_plural: faultWithCount_plural$1,
  fee: fee$1,
  fieldRequired: fieldRequired$1,
  "fields with an asterisk are required": "Los campos con (*) son obligatorios.",
  file: file$1,
  "filecase/assistedAbbrev": "Exp. / asistido",
  "filecase/interventionAbbrev": "Exp./Int.",
  filterByDriverStatus: filterByDriverStatus$1,
  filterByVehicleType: filterByVehicleType$1,
  financial: financial$1,
  financialBreakdown: financialBreakdown$1,
  finish: finish$1,
  finishedServices: finishedServices$1,
  firstPrice: firstPrice$1,
  firstUnitPriceAbbrev: firstUnitPriceAbbrev$1,
  fixed: fixed$1,
  "for": "Para",
  "forgotPassword?": "¿Olvidaste la contraseña?",
  formError: formError$1,
  franchise: franchise$1,
  franchises: franchises$1,
  freeCranesBefore1Hour: freeCranesBefore1Hour$1,
  fromUntil: fromUntil$1,
  fullAddress: fullAddress$1,
  fullScreenAbbrev: fullScreenAbbrev$1,
  G: G$1,
  generalInformationAbbrev: generalInformationAbbrev$1,
  generate: generate$1,
  generated: generated$1,
  geofence: geofence$1,
  geofence_plural: geofence_plural$1,
  geofenceWithCount: geofenceWithCount$1,
  geofenceWithCount_plural: geofenceWithCount_plural$1,
  geoJson: geoJson$1,
  globalAuction: globalAuction$1,
  graceDays: graceDays$1,
  grecaptchaNote: grecaptchaNote$1,
  guardMode: guardMode$1,
  H: H$1,
  help: help$1,
  hide: hide$1,
  holder: holder$1,
  holidays: holidays$1,
  home: home$1,
  hour: hour$1,
  hours: hours$1,
  I: I$1,
  IBAN: IBAN$1,
  icon: icon$1,
  iconUrl: iconUrl$1,
  identificationIcon: identificationIcon$1,
  "If you finish the service you will no longer be able to edit or reschedule it Do you wish to continue?": "Si finalizas el servicio, ya no podrás editarlo o reprogramarlo. ¿Deseas continuar?",
  "If you recover the saved request you will lose the data you have entered in the form do you wish to continue?": "Si recuperas la solicitud guardada, perderás los datos que has introducido en el formulario, ¿deseas continuar?",
  "If you delete the request the saved data will be deleted Do you wish to continue?": "Si eliminas la solicitud, se borrarán los datos guardados, ¿deseas continuar?",
  "If you prefer, you can send the service to a waiting list": "Si lo prefieres, puedes enviar el servicio a una lista de espera",
  image: image$1,
  immediate: immediate$1,
  immediate_plural: immediate_plural$1,
  immediateService: immediateService$1,
  "import": "Importar",
  incorrectLocationFormat: incorrectLocationFormat$1,
  infoWindowIcon: infoWindowIcon$1,
  inParking: inParking$1,
  inRis: inRis$1,
  inris: inris$1,
  inServiceResourcesWithCount: inServiceResourcesWithCount$1,
  inServiceResourcesWithCount_plural: inServiceResourcesWithCount_plural$1,
  instant: instant$1,
  insurancePolicyInfo: insurancePolicyInfo$1,
  insured: insured$1,
  insured_autoType: insured_autoType$1,
  insured_homeType: insured_homeType$1,
  insuredAutoType: insuredAutoType$1,
  insuredHomeType: insuredHomeType$1,
  insuredObjectAbbrev: insuredObjectAbbrev$1,
  insuredProperty: insuredProperty$1,
  integrationProfile: integrationProfile$1,
  integrationProfileAbbrev: integrationProfileAbbrev$1,
  internalCode: internalCode$1,
  internalNote: internalNote$1,
  internalNotes: internalNotes$1,
  interrupted: interrupted$1,
  intervention: intervention$1,
  interventionAbbrev: interventionAbbrev$1,
  interventions: interventions$1,
  inUrbanArea: inUrbanArea$1,
  invalidNexusFilecase: invalidNexusFilecase$1,
  invalidText: invalidText$1,
  invoice: invoice$1,
  "invoice (services - base)": "Factura (servicios - base)",
  "invoice-status": {
    pending: "Pendiente",
    billed: "Facturada",
    collected: "Cobrada",
    payed: "Pagada"
  },
  invoiceNumberAbbrev: invoiceNumberAbbrev$1,
  forTheDay: forTheDay$1,
  isNotValid: isNotValid$1,
  issuedInvoices: issuedInvoices$1,
  itAlreadyExists: itAlreadyExists$1,
  J: J$1,
  K: K$1,
  L: L$1,
  label: label$1,
  labeled: labeled$1,
  "labeled-opt": {
    listWithCount: "{{count}} Rotulación",
    listWithCount_plural: "{{count}} Rotulaciones"
  },
  labels: labels$1,
  lastActivity: lastActivity$1,
  lastActivity2: lastActivity2$1,
  legal: legal$1,
  legalId: legalId$1,
  list: list$1,
  listEntryMax24H: listEntryMax24H$1,
  loaded: loaded$1,
  loadTimeInMinutes: loadTimeInMinutes$1,
  located: located$1,
  location: location$1,
  locked: locked$1,
  lockedByNexus: lockedByNexus$1,
  login: login$1,
  logo: logo$1,
  logout: logout$1,
  M: M$1,
  managed: managed$1,
  managedProvider: managedProvider$1,
  manual: manual$1,
  manualProvider: manualProvider$1,
  map: map$1,
  mapIcon: mapIcon$1,
  mapOfGoingServices: mapOfGoingServices$1,
  mapOfResources: mapOfResources$1,
  mapOfTracking: mapOfTracking$1,
  mapView: mapView$1,
  max: max$1,
  maxAllowedTimeInMinutes: maxAllowedTimeInMinutes$1,
  maxDistance: maxDistance$1,
  maxDistanceToCrane: maxDistanceToCrane$1,
  maxHours: maxHours$1,
  maxRadius: maxRadius$1,
  maxTime: maxTime$1,
  maxTimeOnList: maxTimeOnList$1,
  medium: medium$1,
  mediumNotFound: mediumNotFound$1,
  mediumType: mediumType$1,
  mediumTypes: mediumTypes$1,
  mediumTypes2: mediumTypes2$1,
  "mediumTypes-opt": {
    listWithCount: "{{count}} Tipo de medio",
    listWithCount_plural: "{{count}} Tipos de medios"
  },
  minute: minute$1,
  minutes: minutes$1,
  modeAndName: modeAndName$1,
  model: model$1,
  modifiedCollective: modifiedCollective$1,
  modifiedFault: modifiedFault$1,
  myTickets: myTickets$1,
  N: N$1,
  name: name$1,
  nameSurname: nameSurname$1,
  "new": "Nuevo",
  new_female: new_female$1,
  new_plural: new_plural$1,
  newAuxService: newAuxService$1,
  newAuxiliaryService: newAuxiliaryService$1,
  newDayAndTime: newDayAndTime$1,
  newPassword: newPassword$1,
  newService: newService$1,
  newSupportTeam: newSupportTeam$1,
  newVehicleAssistance: newVehicleAssistance$1,
  newVialService: newVialService$1,
  nexusMapServiceError: nexusMapServiceError$1,
  nick: nick$1,
  no: no$1,
  noProvidersAvailable: noProvidersAvailable$1,
  notApplyCosts: notApplyCosts$1,
  notParticipating: notParticipating$1,
  noCovered: noCovered$1,
  noDocumentsAssociatedToService: noDocumentsAssociatedToService$1,
  noResourcesAvailableMsg: noResourcesAvailableMsg$1,
  noSubscribe: noSubscribe$1,
  note: note$1,
  notes: notes$1,
  notesAssociatedWithTheService: notesAssociatedWithTheService$1,
  noTicketsAssociatedToService: noTicketsAssociatedToService$1,
  noTicketsAssociatedToTransfer: noTicketsAssociatedToTransfer$1,
  noNotesAssociatedToService: noNotesAssociatedToService$1,
  notifications: notifications$1,
  noTransfersAvailable: noTransfersAvailable$1,
  noValid: noValid$1,
  numberAbbrev: numberAbbrev$1,
  numberOfPeopleAbbrev: numberOfPeopleAbbrev$1,
  numberOfReviewsAbbrev: numberOfReviewsAbbrev$1,
  O: O$1,
  office: office$1,
  ongoing: ongoing$1,
  onQueue: onQueue$1,
  openDispute: openDispute$1,
  operational: operational$1,
  operationTypes: operationTypes$1,
  "operationTypes-opt": {
    listWithCount: "{{count}} Tipo de intervención",
    listWithCount_plural: "{{count}} Tipos de intervención"
  },
  origin: origin$1,
  originalServiceData: originalServiceData$1,
  originDeposit: originDeposit$1,
  otherSettings: otherSettings$1,
  orYouCan: orYouCan$1,
  outlay: outlay$1,
  outlays: outlays$1,
  "outlays-opt": {
    listWithCount: "{{count}} Gasto adicional",
    listWithCount_plural: "{{count}} Gastos adicionales"
  },
  P: P$1,
  paid: paid$1,
  passengers: passengers$1,
  passengersWithCount: passengersWithCount$1,
  passengersWithCount_plural: passengersWithCount_plural$1,
  password: password$1,
  passwordsNotMatch: passwordsNotMatch$1,
  paymentsToProviders: paymentsToProviders$1,
  "paymentsToProviders-opt": {
    listWithCount: "{{count}} Pago a proveedor",
    listWithCount_plural: "{{count}} Pagos a proveedores"
  },
  pdf: pdf$1,
  pending: pending$1,
  pendings: pendings$1,
  PENDING: PENDING$1,
  pending_assign: pending_assign$1,
  PENDING_ASSIGN: PENDING_ASSIGN$1,
  PENDINGASSIGN: PENDINGASSIGN$1,
  pendingDocumentation: pendingDocumentation$1,
  pendingDocuments: pendingDocuments$1,
  "pendingDocuments-opt": {
    listWithCount: "{{count}} Documento pendiente",
    listWithCount_plural: "{{count}} Documentos pendientes"
  },
  pendingPassword: pendingPassword$1,
  pendingProfile: pendingProfile$1,
  peopleTransferActivity: peopleTransferActivity$1,
  pleaseTryAgainLater: pleaseTryAgainLater$1,
  "Please indicate the reason for cancelling the service and enter the charges if necessary": "Por favor, indica el motivo por el que anulas el servicio, e introduce los gastos si es necesario.",
  phone: phone$1,
  phoneNumberAbbrev: phoneNumberAbbrev$1,
  photoWithCount: photoWithCount$1,
  photoWithCount_plural: photoWithCount_plural$1,
  photos: photos$1,
  planned: planned$1,
  PLANNED: PLANNED$1,
  plannedService: plannedService$1,
  plate: plate$1,
  plateDoesNotCorrespondToTheFilecase: plateDoesNotCorrespondToTheFilecase$1,
  policy: policy$1,
  policyCoverageLimit: policyCoverageLimit$1,
  policyCoverageLimit2: policyCoverageLimit2$1,
  policyInformation: policyInformation$1,
  policyLimitExceeded: policyLimitExceeded$1,
  policyLimitExceededAux: policyLimitExceededAux$1,
  policyNumberAbbrev: policyNumberAbbrev$1,
  policySearch: policySearch$1,
  positionAbbrev: positionAbbrev$1,
  "price(approx)": "Precio (aprox.)",
  priority: priority$1,
  priority1Providers: priority1Providers$1,
  priority2Providers: priority2Providers$1,
  priority3Providers: priority3Providers$1,
  priorityAllProviders: priorityAllProviders$1,
  priorityProvider: priorityProvider$1,
  process: process$1$1,
  profile: profile$1,
  profileNotFound: profileNotFound$1,
  profiles: profiles$1,
  "profiles-opt": {
    listWithCount: "{{count}} Perfil",
    listWithCount_plural: "{{count}} Perfiles",
    addTitle: "Añadir perfil",
    addText: "Completa los datos del perfil para añadirlo.",
    toastAddSuccessTitle: "Perfil creado correctamente",
    toastAddSuccessText: "El perfil ha sido creado y añadido a la lista."
  },
  proposals: proposals$1,
  provider: provider$1,
  providersInZone: providersInZone$1,
  providersOutZone: providersOutZone$1,
  providerTechnician: providerTechnician$1,
  providerVialSettings: providerVialSettings$1,
  providerEditVialSettingsHeaderText: providerEditVialSettingsHeaderText$1,
  providerAuxiliariesSettings: providerAuxiliariesSettings$1,
  providerEditAuxiliariesSettingsHeaderText: providerEditAuxiliariesSettingsHeaderText$1,
  "provider/driverAbbrev": "Prov / conductor",
  providers: providers$1,
  provider_pending: provider_pending$1,
  PROVIDER_PENDING: PROVIDER_PENDING$1,
  PROVIDERPENDING: PROVIDERPENDING$1,
  provider_accepted: provider_accepted$1,
  PROVIDER_ACCEPTED: PROVIDER_ACCEPTED$1,
  PROVIDERACCEPTED: PROVIDERACCEPTED$1,
  provider_accept: provider_accept$1,
  PROVIDER_ACCEPT: PROVIDER_ACCEPT$1,
  PROVIDERACCEPT: PROVIDERACCEPT$1,
  providersSelection: providersSelection$1,
  providerList: providerList$1,
  providersMap: providersMap$1,
  providerType: providerType$1,
  providerTypeVial: providerTypeVial$1,
  providerTypeAux: providerTypeAux$1,
  providerWithoutDefinedDeposit: providerWithoutDefinedDeposit$1,
  province: province$1,
  Q: Q$1,
  queueEntryDate: queueEntryDate$1,
  queued: queued$1,
  QUEUED: QUEUED$1,
  queuedService: queuedService$1,
  R: R$1,
  rates: rates$1,
  rating: rating$1,
  ratings: ratings$1,
  ratingsUserName: ratingsUserName$1,
  ratingsWithCount: ratingsWithCount$1,
  ratingsWithCount_plural: ratingsWithCount_plural$1,
  ready: ready$1,
  reAssign: reAssign$1,
  reAssignProvider: reAssignProvider$1,
  reAskForResetEmail: reAskForResetEmail$1,
  received: received$1,
  receivedInvoices: receivedInvoices$1,
  recoverRequest: recoverRequest$1,
  recoverYourPassword: recoverYourPassword$1,
  region: region$1,
  registrationInformationOnInvoices: registrationInformationOnInvoices$1,
  reject: reject$1,
  rejectCosts: rejectCosts$1,
  rejectionReason: rejectionReason$1,
  rejectionReasons: rejectionReasons$1,
  "rejectionReasons-opt": {
    listWithCount: "{{count}} Motivo de rechazo",
    listWithCount_plural: "{{count}} Motivos de rechazo"
  },
  rejectionType: rejectionType$1,
  release: release$1,
  removeFromDashboard: removeFromDashboard$1,
  repeated: repeated$1,
  repeatPassword: repeatPassword$1,
  requestCapability: requestCapability$1,
  requestInfo: requestInfo$1,
  requestLocationByWhatsApp: requestLocationByWhatsApp$1,
  requestMediumAbbrev: requestMediumAbbrev$1,
  requestProcessedCorrectly: requestProcessedCorrectly$1,
  requestWithoutIAssociatedPolicy: requestWithoutIAssociatedPolicy$1,
  required: required$1,
  reschedule: reschedule$1,
  RESCHEDULED: RESCHEDULED$1,
  rescheduleComment: rescheduleComment$1,
  rescheduleReason: rescheduleReason$1,
  rescheduleService: rescheduleService$1,
  rescheduleServiceDeferredTextModal: rescheduleServiceDeferredTextModal$1,
  rescheduleServicePlannedText1Modal: rescheduleServicePlannedText1Modal$1,
  rescheduleServicePlannedText2Modal: rescheduleServicePlannedText2Modal$1,
  resetPassword: resetPassword$1,
  resetYourPassword: resetYourPassword$1,
  resources: resources$1,
  resourcesMap: resourcesMap$1,
  restore: restore$1,
  result: result$1,
  "return": "Volver",
  ris: ris$1,
  risService: risService$1,
  S: S$1,
  save: save$1,
  saveChanges: saveChanges$1,
  savedRequests: savedRequests$1,
  saveRequest: saveRequest$1,
  "Saving your request for later retrieval will delete the form data Do you wish to continue?": "Guardando la solicitud para recuperarla más tarde, se borrarán los datos del formulario, ¿deseas continuar?",
  schedule: schedule$1,
  scheduled: scheduled$1,
  SCHEDULED: SCHEDULED$1,
  scheduled_plural: scheduled_plural$1,
  scheduledAbbrev: scheduledAbbrev$1,
  scheduledDateInvalidErrorText: scheduledDateInvalidErrorText$1,
  scheduleDriver: scheduleDriver$1,
  scheduledServiceNotFound: scheduledServiceNotFound$1,
  scheduledFor: scheduledFor$1,
  searchResourceOrTechnician: searchResourceOrTechnician$1,
  searchResources: searchResources$1,
  searchAResource: searchAResource$1,
  searchAService: searchAService$1,
  searchByAssistedOrFilecase: searchByAssistedOrFilecase$1,
  searchByAssistedFilecaseOrPlate: searchByAssistedFilecaseOrPlate$1,
  searchByAssistedFilecaseOrProvider: searchByAssistedFilecaseOrProvider$1,
  searchByCodeOrName: searchByCodeOrName$1,
  searchByCodeNameOrCostType: searchByCodeNameOrCostType$1,
  searchByCodeNameOrMediumType: searchByCodeNameOrMediumType$1,
  searchByCustomer: searchByCustomer$1,
  searchByCustomerOrFilecase: searchByCustomerOrFilecase$1,
  searchByCustomerFilecaseOrPlate: searchByCustomerFilecaseOrPlate$1,
  searchByFileCase: searchByFileCase$1,
  searchByIdForOrFilecaseNumber: searchByIdForOrFilecaseNumber$1,
  searchByInvoiceNumber: searchByInvoiceNumber$1,
  searchByName: searchByName$1,
  searchByNameCIFOrAddress: searchByNameCIFOrAddress$1,
  searchByNameOrAddress: searchByNameOrAddress$1,
  searchByNameOrCode: searchByNameOrCode$1,
  searchByNamePlateOrCode: searchByNamePlateOrCode$1,
  searchByNameSurnameUserOrNick: searchByNameSurnameUserOrNick$1,
  searchByProviderOrName: searchByProviderOrName$1,
  searchByTerm: searchByTerm$1,
  searchInsurancePolicy: searchInsurancePolicy$1,
  seeAverages: seeAverages$1,
  breakdown: breakdown$1,
  seeCapabilityComment: seeCapabilityComment$1,
  seeComment: seeComment$1,
  seeContactAndComment: seeContactAndComment$1,
  seeDescription: seeDescription$1,
  seeService: seeService$1,
  "Select a transfer associated with the service": "Selecciona un traslado asociado al servicio",
  selfValidated: selfValidated$1,
  send: send$1,
  sendComments: sendComments$1,
  sended: sended$1,
  sendEmail: sendEmail$1,
  sendForReview: sendForReview$1,
  sendTo: sendTo$1,
  sendToList: sendToList$1,
  serverConnectionError: serverConnectionError$1,
  service: service$1,
  serviceExecution: serviceExecution$1,
  serviceInAuction: serviceInAuction$1,
  serviceLevels: serviceLevels$1,
  serviceMap: serviceMap$1,
  serviceNotFound: serviceNotFound$1,
  serviceRequestAndTracking: serviceRequestAndTracking$1,
  services: services$1,
  serviceSentToAuction: serviceSentToAuction$1,
  serviceStatus: serviceStatus$1,
  settings: settings$1,
  settingsUpdated: settingsUpdated$1,
  sharedCode: sharedCode$1,
  sharedNote: sharedNote$1,
  sharedNotes: sharedNotes$1,
  "shipment (services - base)": "Remesa (servicios - base)",
  shipments: shipments$1,
  shipmentStatusValues: shipmentStatusValues$1,
  showAllMediums: showAllMediums$1,
  showSolicitedMedium: showSolicitedMedium$1,
  situation: situation$1,
  solicitedMedium: solicitedMedium$1,
  sortCriteria: sortCriteria$1,
  soundActivated: soundActivated$1,
  soundOff: soundOff$1,
  start: start$1,
  started: started$1,
  status: status$1,
  statuses: statuses$1,
  subject: subject$1,
  subscribe: subscribe$1,
  subtotal: subtotal$1,
  suburb: suburb$1,
  suburbService: suburbService$1,
  summary: summary$1,
  supportCenter: supportCenter$1,
  supportTeam: supportTeam$1,
  survey: survey$1,
  surveys: surveys$1,
  T: T$1,
  taxes: taxes$1,
  team: team$1,
  teamName: teamName$1,
  technician: technician$1,
  technicians: technicians$1,
  "The maximum date range allowed is 45 days": "El rango de fechas máximo permitido es de 45 días",
  "The request could not be made Try again": "No se ha podido realizar la solicitud. Inténtalo de nuevo.",
  "The proposal could not be retrieved because the collective does not exist": "No se ha podido recuperar la solicitud porque el colectivo no existe",
  "The service has been sent successfully": "El servicio se ha enviado correctamente.",
  "The service rejection could not be completed": "El rechazo del servicio no ha podido completarse.",
  "The service will be sent after completing the request process": "El servicio se enviará tras completar el proceso de solicitud",
  theField: theField$1,
  ticket: ticket$1,
  tickets: tickets$1,
  ticketStatus: ticketStatus$1,
  time: time$1,
  "time(approx)": "Tiempo (aprox.)",
  timeInAlert: timeInAlert$1,
  timeline: timeline$1,
  title: title$1,
  toastErrorDuplicateAddressPickupDeliveryTitle: toastErrorDuplicateAddressPickupDeliveryTitle$1,
  toastErrorDuplicateAddressPickupDeliveryText: toastErrorDuplicateAddressPickupDeliveryText$1,
  toastErrorDuplicateAddressPickupDestinationTitle: toastErrorDuplicateAddressPickupDestinationTitle$1,
  toastErrorDuplicateAddressPickupDestinationText: toastErrorDuplicateAddressPickupDestinationText$1,
  toastErrorTextDefault: toastErrorTextDefault$1,
  toastErrorTitleDefault: toastErrorTitleDefault$1,
  toastErrorTransferPeopleBudget: toastErrorTransferPeopleBudget$1,
  toastErrorTitle_downloadFile: toastErrorTitle_downloadFile$1,
  toastErrorText_downloadFile: toastErrorText_downloadFile$1,
  toastSuccessTextDefault: toastSuccessTextDefault$1,
  toastSuccessTitleDefault: toastSuccessTitleDefault$1,
  today: today$1,
  toDefine: toDefine$1,
  total: total$1,
  totals: totals$1,
  toTheClient: toTheClient$1,
  toTheProvider: toTheProvider$1,
  town: town$1,
  tracking: tracking$1,
  trackingMessage: trackingMessage$1,
  transfer: transfer$1,
  transferHasBeenCancelled: transferHasBeenCancelled$1,
  transferPeople: transferPeople$1,
  transferPeopleBudget: transferPeopleBudget$1,
  transferPeopleRequest: transferPeopleRequest$1,
  transferPeopleRequestType: transferPeopleRequestType$1,
  transferPeopleRequiredValidPhoneNumber: transferPeopleRequiredValidPhoneNumber$1,
  transfers: transfers$1,
  transfersAvailable: transfersAvailable$1,
  transferTheAssisted: transferTheAssisted$1,
  type: type$1,
  typeAndName: typeAndName$1,
  "type/capability": "Tipo/prestación",
  typeless: typeless$1,
  typeOfService: typeOfService$1,
  types: types$1,
  U: U$1,
  "undefined": "Sin definir",
  udWithCount: udWithCount$1,
  udWithCount_plural: udWithCount_plural$1,
  unAssign: unAssign$1,
  unAssignTechnician: unAssignTechnician$1,
  unAssignTechnicianModalText: unAssignTechnicianModalText$1,
  unAssignTechnicianModalAditionalText: unAssignTechnicianModalAditionalText$1,
  unAssignDriver: unAssignDriver$1,
  unAssignDriverModalText: unAssignDriverModalText$1,
  unAssignDriverModalAditionalText: unAssignDriverModalAditionalText$1,
  unavailable: unavailable$1,
  units: units$1,
  unitAbbrev: unitAbbrev$1,
  unitsAbbrev: unitsAbbrev$1,
  unselected: unselected$1,
  unsubscribe: unsubscribe$1,
  urban: urban$1,
  urbanFee: urbanFee$1,
  urbanService: urbanService$1,
  user: user$1,
  userProfiles: userProfiles$1,
  userProfilesWithCount: userProfilesWithCount$1,
  userProfilesWithCount_plural: userProfilesWithCount_plural$1,
  users: users$1,
  "users-opt": {
    listWithCount: "{{count}} Usuario",
    listWithCount_plural: "{{count}} Usuarios"
  },
  userType: userType$1,
  V: V$1,
  validFrom: validFrom$1,
  validUntil: validUntil$1,
  variable: variable$1,
  vehicleAssistance: vehicleAssistance$1,
  vehicleTypes: vehicleTypes$1,
  "vehicleTypes-opt": {
    listWithCount: "{{count}} Tipo de vehículo",
    listWithCount_plural: "{{count}} Tipos de vehículos"
  },
  "vehicle/fault": "Vehículo / Avería",
  version: version$1,
  vial: vial$1,
  vials: vials$1,
  vialRates: vialRates$1,
  vialServices: vialServices$1,
  vialSettings: vialSettings$1,
  view: view$1,
  viewAssistedRating: viewAssistedRating$1,
  viewContact: viewContact$1,
  viewContactandComment: viewContactandComment$1,
  viewRoute: viewRoute$1,
  views: views$1,
  vin: vin$1,
  virtualSwitchboard: virtualSwitchboard$1,
  W: W$1,
  waitingList: waitingList$1,
  web: web$1,
  webAddress: webAddress$1,
  wholeWordSearch: wholeWordSearch$1,
  wholeWordSearch3Charts: wholeWordSearch3Charts$1,
  withAlert: withAlert$1,
  withholdings: withholdings$1,
  withPriority1: withPriority1$1,
  withPriority2: withPriority2$1,
  withPriority3: withPriority3$1,
  writeANote: writeANote$1,
  wrongUser: wrongUser$1,
  wrongUsernameOrPassword: wrongUsernameOrPassword$1,
  X: X$1,
  Y: Y$1,
  year: year$1,
  yes: yes$1,
  yesterday: yesterday$1,
  youHaveExceededTheNumberOfAtempsts: youHaveExceededTheNumberOfAtempsts$1,
  Z: Z$1,
  "A dispute has been opened for this service": "Se ha abierto una disputa para este servicio.",
  "Add the following cost data": "Añade los siguientes datos del costo.",
  "Add the following cost type data": "Añade los siguientes datos del tipo de costo.",
  "Allow assigning rate in service request": "Asignar la tarifa en la solicitud de servicio",
  "Allow opening internal tickets": "Permitir abrir tickets internos",
  "An error has occurred in the creation of the collective": "Ha ocurrido un error en la creación del colectivo.",
  "An error has occurred in the creation of the fault": "Ha ocurrido un error en la creación de la avería.",
  "An error occurred while trying to upload the file": "Ha ocurrido un error al intentar subir el archivo.",
  "Approve costs": "Aprobar costos",
  "Are you sure you want to approve the cost sheet? Once approved you will not be able to request changes": "¿Seguro que deseas aprobar la hoja de costos? Una vez aprobada, no podrás solicitar cambios.",
  "Are you sure you want to send the cost sheet for review? Once it has been sent you will not be able to edit it again": "¿Seguro que deseas enviar la hoja de costos a revisión? Una vez enviada, no podrás editarla de nuevo.",
  "Assistance has arrived at pickup": "La asistencia ha llegado a la recogida",
  "Assistance is on the way": "La asistencia está en camino",
  "Assistance reached its destination": "La asistencia llegó a su destino",
  "At this time it is not possible to access the service": "En estos momentos no es posible acceder al servicio",
  "Attention a new service will be requested without any associated policy": "Atención, se va a solicitar un nuevo servicio sin ninguna póliza asociada.",
  "Capability created successfully": "Prestación creada correctamente",
  "Capability has been created and added to the list": "La prestación ha sido creada y añadida a la lista.",
  "Capability has been updated successfully": "La prestación ha sido actualizada correctamente.",
  "Capability updated": "Prestación actualizada",
  "Complete the data of the auxiliar service to add it": "Completa los datos del servicio auxiliar para añadirlo.",
  "Complete the data of the auxiliar service to edit it": "Completa los datos del servicio auxiliar para editarlo.",
  "Complete the data of the capability to add it": "Completa los datos de la prestación para añadirla.",
  "Complete the data of the capability to edit it": "Completa los datos de la prestación para editarla.",
  "Complete the data of the collective to add it": "Completa los datos del colectivo para añadirlo.",
  "Complete the data of the fault to add it": "Completa los datos de la avería para añadirla.",
  "Contact your insurer for more information": "Contacta con tu aseguradora para más información",
  "Costs approved successfully": "Costos aprobados correctamente",
  "Costs could not be approved": "No ha sido posible aprobar los costos",
  "Costs could not be rejected": "No ha sido posible rechazar los costos",
  "Cost created successfully": "Costo creado correctamente",
  "Costs rejected successfully": "Costos rechazados correctamente",
  "Costs sheet approved": "Hoja de costos aprobada",
  "Cost sheet could not be saved": "No ha sido posible guardar la hoja de costos",
  "Cost sheet could not be sent for review": "No ha sido posible enviar a revisión la hoja de costos",
  "Cost sheet rejected": "Hoja de costos rechazada",
  "Costs sheet saved successfully": "Hoja de costos guardada con éxito",
  "Costs sheet sent for review": "Hoja de costos enviada a revisión",
  "CostType created successfully": "Tipo de costo creado correctamente",
  "Cost has been created and added to the list": "El costo ha sido creado y añadido a la lista",
  "CostType has been created and added to the list": "El tipo de costo ha sido creado y añadido a la lista",
  "Cost has been updated successfully": "El costo ha sido actualizado correctamente.",
  "CostType has been updated successfully": "El tipo de costo ha sido actualizado correctamente.",
  "Cost updated": "Costo actualizado",
  "CostType updated": "Tipo de costo actualizado",
  "Data has been saved successfully": "Los datos se han guardado correctamente",
  "Do not allow the assistant to call the driver from the tracking widget": "No permitir al asistido llamar al chofer desde el widget de seguimiento",
  "Do not allow technician to create notes": "No permitir al técnico crear notas",
  "Do not allow the operator to select providers": "No permitir al operador seleccionar proveedores",
  "Do not allow the technician to reschedule the service": "No permitir al técnico reprogramar el servicio",
  "Do not show the technician the assisted person phone number": "No mostrar al técnico el teléfono del asistido",
  "Do not take into account the first section for the calculation of the rate": "No tener en cuenta el primer tramo para el cálculo de la tarifa",
  "Do you want to send the request": "¿Deseas enviar la solicitud?",
  "Edit the data you need for the following cost": "Edita los datos que necesites del siguiente costo.",
  "Edit the data you need for the following type cost": "Edita los datos que necesites del siguiente tipo de costo.",
  "Edit the data you need from the following collective": "Edita los datos que necesites del siguiente colectivo.",
  "Edit the data you need from the following fault": "Edita los datos que necesites de la siguiente avería.",
  "Edit the details you need for the following user profile": "Edita los datos que necesites del siguiente perfil de usuario.",
  "Error creating capability": "Error al crear prestación",
  "Error creating cost": "Error al crear costo",
  "Error creating costType": "Error al crear tipo de costo",
  "Error creating user profile": "Error al crear perfil de usuario",
  "Error has ocurred while creating the capability": "Ha ocurrido un error en la creación de la prestación.",
  "Error has ocurred while creating the cost": "Ha ocurrido un error durante la creación del costo.",
  "Error has ocurred while creating the costType": "Ha ocurrido un error durante la creación del tipo de costo.",
  "Error has ocurred while creating the user profile": "Ha ocurrido un error durante la creación del perfil de usuario.",
  "Error has ocurred while updating the capability": "Ha ocurrido un error durante la actualización de la prestación.",
  "Error has ocurred while updating the cost": "Ha ocurrido un error durante la actualización del costo.",
  "Error has ocurred while updating the costType": "Ha ocurrido un error durante la actualización del tipo de costo.",
  "Error has ocurred while updating the user profile": "Ha ocurrido un error durante la actualización del perfil de usuario.",
  "Error updating capability": "Error al actualizar prestación",
  "Error updating cost": "Error al actualizar costo",
  "Error updating costType": "Error al actualizar tipo de costo",
  "Error updating user profile": "Error al actualizar perfil de usuario",
  "Fill in the details of the user profile to add it": "Completa los datos del perfil del usuario para añadirlo.",
  "Follow your roadside assistance service in real time by clicking on the continue button": "Sigue en tiempo real tu servicio de asistencia en carretera, pulsando en el botón de continuar",
  "Follow your assistance service in real time by clicking on the continue button": "Sigue en tiempo real tu servicio de asistencia, pulsando en el botón de continuar",
  "Hide middle phone in tracking widget": "Ocultar el teléfono del medio en el widget de seguimiento",
  "It is not possible to access": "No es posible acceder",
  "It has not been possible to add the new note to the service": "No ha sido posible añadir al servicio la nueva nota.",
  "It has not been possible to consult the events associated with the service": "No ha sido posible consultar los eventos asociados al servicio.",
  "It has not been possible to modify the collective data": "No ha sido posible modificar los datos del colectivo.",
  "It has not been possible to modify the fault data": "No ha sido posible modificar los datos de la avería.",
  "It has not been possible to update the information": "No ha sido posible actualizar la información",
  "It was not possible to finish the service": "No ha sido posible finalizar el servicio.",
  "It was not possible to obtain the survey data": "No ha sido posible obtener los datos de la encuesta.",
  "It was not possible to recover the integration profiles": "No ha sido posible recuperar los perfiles de integración.",
  "Manage the documents necessary to work with Nexus": "Gestiona los documentos necesarios para trabajar con Nexus",
  "No auction providers found at the service location": "No se han encontrado proveedores de subasta en la ubicación del servicio",
  "No changes have been made to the service": "No se han realizado cambios en el servicio.",
  "Please indicate the reason why you wish to reject the costs associated with the service": "Por favor, indica el motivo por el que deseas rechazar los costos que están asociados al servicio.",
  "Please retry in a few minutes": "Vuelve a intentarlo en unos minutos.",
  "Plot the geofence on the map, complete the information and press the save button": "Define la geocerca en el mapa, completa la información y pulsa el botón guardar",
  "__providerName settings have been updated": "Los ajustes de {{providerName}} han sido actualizados",
  "Reload the page or contact your company": "Recarga la página o contacta con tu compañía",
  "Request processed correctly": "Solicitud procesada de forma correcta",
  "Select a provider to assign to the service": "Selecciona un proveedor para asignar al servicio.",
  "Select the providers that will participate in the auction": "Selecciona los proveedores que participarán en la subasta",
  "Send costs for review": "Enviar costos a revisión",
  "Service acceptance could not be completed": "La aceptación del servicio no ha podido completarse.",
  "Service assignment could not be completed": "La asignación del servicio no ha podido completarse.",
  "Service requested from the widget": "Servicio solicitado desde el widget",
  "Sorry attendance has been canceled": "Lo sentimos, la asistencia ha sido cancelada",
  "Spoofing the assisted phone number": "Suplantación del nº de teléfono del asistido",
  "Successfully sent, under review": "Enviada correctamente, está en revisión",
  "Support has ended": "La asistencia ha finalizado",
  "Thank you very much for your confidence": "Muchas gracias por tu confianza",
  "The collective has been created and added to the list": "El colectivo ha sido creado y añadido a la lista.",
  "The cost could not be modified": "El costo no ha podido ser modificado",
  "The dispute for this service has been closed": "Se ha cerrado la disputa para este servicio.",
  "The document has been attached to the service": "El documento se ha adjuntado al servicio.",
  "The fault has been created and added to the list": "La avería ha sido creada y añadida a la lista.",
  "The file must be pdf jpg or png": "El archivo tiene que ser: pdf, jpg o png.",
  "The service has been canceled": "El servicio ha sido anulado.",
  "The service has been created and added to the list": "El servicio ha sido creado y añadido a la lista.",
  "The service has been rescheduled": "El servicio ha sido reprogramado.",
  "The service has been scheduled for the day": "El servicio ha sido programado para el día",
  "There is no assigned provider": "No hay proveedor asignado",
  "There are no documents associated": "No hay documentos asociados",
  "There are no events associated with the service": "No hay eventos asociados al servicio.",
  "This service is in finished status As an administrator you can cancel it": "Este servicio está en estado finalizado. Como administrador, puedes anularlo.",
  "User profile created successfully": "Perfil de usuario creado correctamente",
  "User profile has been created and added to the list": "El perfil de usuario ha sido creado y añadido a la lista.",
  "User profile has been updated successfully": "El perfil de usuario ha sido actualizado correctamente.",
  "User profile updated": "Perfil de usuario actualizado",
  "We are at your disposal whenever you need it": "Estamos a tu disposición siempre que lo necesites",
  "We are sorry It has not been possible to show the tracking of your service": "Lo sentimos. No ha sido posible mostrar el seguimiento de tu servicio.",
  "We are trying to repair your vehicle": "Estamos tratando de reparar tu vehículo",
  "We have not been able to connect you to our network": "No hemos podido conectarte a nuestra red",
  "We have updated the information of the collective": "La información del colectivo se ha actualizado correctamente.",
  "We have updated the information of the fault": "La información de la avería se ha actualizado correctamente.",
  "Welcome to the __companyName tracking platform": "Bienvenido a la plataforma de seguimiento de {{companyName}}",
  "Your company does not have integration defined with Azure": "",
  "Your user is blocked by Nexus": "Tu usuario está bloquedado por Nexus",
  "Your vehicle is being moved": "Tu vehículo está siendo trasladado",
  "********** END CHECKED WORDS **********": "",
  "********** BEGIN PHRASES **********": "**********",
  "No services performed since the renewal date": "No hay servicios realizados desde la fecha de renovación",
  "********** BEGIN COMPANY PROFILE SETTINGS **********": "**********",
  "Assignment algorithm": "Algoritmo de asignación",
  "Service request": "Solicitud del servicio",
  "SMS messages": "Mensajes SMS",
  "Maximum time given to a resource to accept or reject a service": "Tiempo máximo que se le otorga a un recurso para aceptar o rechazar un servicio",
  "Maximum time given to a provider to accept or reject a service": "Tiempo máximo que se le otorga a un proveedor para aceptar o rechazar un servicio",
  "Maximum time in which a service request can be accepted": "Tiempo máximo en el que se puede aceptar una solicitud de servicio",
  "Maximum time for all providers": "Tiempo máximo para todos los proveedores",
  "Maximum time for providers with priority": "Tiempo máximo para proveedores con prioridad {{priority}}",
  "Maximum radial distance to search for resources in a service request": "Distancia máxima radial para buscar recursos en una solicitud de servicio",
  "Default distance when sending a to assign a waiting service to a resource": "Distancia por defecto al enviar un servicio a la lista de espera",
  "Maximum total distance of a service route": "Distancia máxima total de la ruta de un servicio",
  "Origin location for calculating the rate in automatic services": "Ubicación de origen para el cálculo de la tarifa en servicios automáticos",
  "From deposit": "Desde depósito",
  "From resource": "Desde recurso",
  "Show option to cancel services at no cost": "Mostrar opción de anular servicios sin coste",
  "Show policy information in the service file": "Mostrar datos de póliza en la ficha del servicio",
  "Block editing of the fault": "Bloquear la edición de la avería",
  "Show the clone services button": "Mostrar el botón de clonar servicios",
  "Show the mandatory damage report by default": "Mostrar el parte de daños obligatorio por defecto",
  "Maximum number of photos that can be requested in a service": "Máximo nº de fotos que se pueden solicitar en un servicio",
  "Number of mandatory photos by default": "Número de fotos obligatorias por defecto",
  "Message sender": "Remitente de los mensajes",
  maxMinutes: maxMinutes$1,
  maxPhotos: maxPhotos$1,
  between0And5Minutes: between0And5Minutes$1,
  between0And10Minutes: between0And10Minutes$1,
  between0And240Minutes: between0And240Minutes$1,
  between1And7Minutes: between1And7Minutes$1,
  between2And5Minutes: between2And5Minutes$1,
  between2And10Minutes: between2And10Minutes$1,
  between0And10Photos: between0And10Photos$1,
  between1And10Characters: between1And10Characters$1,
  "Fault by medium type": "Avería por tipo de medio",
  "********** END COMPANY PROFILE SETTINGS **********": "**********",
  "********** BEGIN COMPANY PROFILE SERVICE LEVELS **********": "**********",
  between0And120Minutes: between0And120Minutes$1,
  "Maximum times in vial services": "Tiempos máximos en servicios viales",
  "Time for the provider to accept the service": "Tiempo para que el proveedor acepte el servicio",
  "Time for the provider to assign the service to a resource": "Tiempo para que el proveedor asigne el servicio a un recurso",
  "Time to start the service after the resource accepts it": "Tiempo para iniciar el servicio después de que el recurso lo acepte",
  "Time to locate the pick-up location in urban services": "Tiempo para localizar el lugar de recogida en servicios locales",
  "Time to locate the pick-up location in suburban services": "Tiempo para localizar el lugar de recogida en servicios carreteros",
  "Time to carry out an on-site repair": "Tiempo de realización de una reparación in situ",
  "Time to reach the delivery location": "Tiempo para llegar al lugar de entrega",
  "Time to carry out an urban service": "Tiempo de realización de un servicio local",
  "Time to carry out an suburban service": "Tiempo de realización de un servicio carretero",
  "Maximum times in auxiliary services": "Tiempos máximos en servicios auxiliares",
  "Time that the service can be in completed status": "Tiempo que puede estar el servicio en estado completado",
  "Time to assign an urban service to a technician": "Tiempo de asignación de un servicio local a un técnico",
  "Time to assign an suburban service to a technician": "Tiempo de asignación de un servicio carretero a un técnico",
  "Time to locate the location from the start of the service": "Tiempo para localizar la ubicación desde que se inicia el servicio",
  "Waiting time before starting a scheduled service": "Tiempo de espera antes de iniciar un servicio programado",
  "********** END COMPANY PROFILE SERVICE LEVELS **********": "**********",
  "*** ERRORS ***": "",
  "Date not in valid range": "La fecha está fuera de rango",
  "Hours not in valid range": "La hora está fuera de rango",
  "Distance not in valid range": "La distancia está fuera de rango",
  "Mandatory request body not found": "La información obligatoria de la petición es incorrecta",
  "Selected budget already confirmed": "El presupuesto seleccionado ha sido confirmado previamente",
  "Selected budget expired": "El presupuesto seleccionado ha expirado",
  "Selected budget not found": "El presupuesto seleccionado no ha podido ser localizado",
  "The token is invalid": "El token no es válido",
  "*** ERRORS - END ***": "",
  "An error occurred while approving this document": "Ha ocurrido un error al aprobar este documento",
  "An error occurred while rejecting this document": "Ha ocurrido un error al rechazar este documento",
  "Are you sure you want to accept the update? By doing so, you allow Nexus to send you services under the terms of this rate": "",
  "Are you sure you want to delete the cost?": "¿Seguro que deseas eliminar el costo?",
  "Are you sure you want finish the service?": "¿Seguro que deseas finalizar el servicio?",
  "Complete the fields to change your access password": "Completa los campos para cambiar tu contraseña de acceso",
  "Error approving the document": "Error al aprobar el documento",
  "Error rejecting the document": "Error al rechazar el documento",
  "It's necessary to change the access password to continue with the registration": "Es necesario cambiar la contraseña de acceso, para continuar con el registro",
  "Manage subscriptions to rates": "Gestiona las suscripciones a las tarifas",
  "Now you can use it when you login": "Ya puedes utilizarla al iniciar sesión",
  "There are unsaved changes": "Hay cambios sin guardar",
  "********** BEGIN PENDING WORDS **********": "",
  ACCEPTED: ACCEPTED$1,
  add_company_description: add_company_description$1,
  add_company: add_company$1,
  addChartText: addChartText$1,
  addChartTitle: addChartTitle$1,
  all_female: all_female$1,
  all_male: all_male$1,
  amount: amount$1,
  "Amount outside of policy coverage Payment of the assisted to the provider": "Importe fuera de cobertura de póliza (pago del asistido al proveedor)",
  apply: apply$1,
  assignProvider: assignProvider$1,
  assignedToMe: assignedToMe$1,
  assignItToMe: assignItToMe$1,
  AVAILABLE: AVAILABLE$1,
  blocked: blocked$1,
  budgetToastSuccessText: budgetToastSuccessText$1,
  budgetToastSuccessTitle: budgetToastSuccessTitle$1,
  scheduledBudgetToastSuccessText: scheduledBudgetToastSuccessText$1,
  scheduledBudgetToastSuccessTitle: scheduledBudgetToastSuccessTitle$1,
  transferPeopleBudgetToastSuccessText: transferPeopleBudgetToastSuccessText$1,
  transferPeopleBudgetToastSuccessTitle: transferPeopleBudgetToastSuccessTitle$1,
  budgetToastSuccessQueueText: budgetToastSuccessQueueText$1,
  budgetToastSuccessQueueTitle: budgetToastSuccessQueueTitle$1,
  bussy: bussy$1,
  CANCELED: CANCELED$1,
  centerNum: centerNum$1,
  centers: centers$1,
  closed: closed$1,
  codeAlreadyAssigned: codeAlreadyAssigned$1,
  color: color$1,
  companyPendingDocumentation: companyPendingDocumentation$1,
  companyProviderCode: companyProviderCode$1,
  COMPLETED: COMPLETED$1,
  custodyRate: custodyRate$1,
  damageReport: damageReport$1,
  damageRequired: damageRequired$1,
  day: day$1,
  days: days$1,
  del: del$1,
  delivery: delivery$1,
  deliveryAddressRequired: deliveryAddressRequired$1,
  destination: destination$1,
  documents: documents$1,
  exit: exit$1,
  expired: expired$1,
  EXTRA_CHARGES: EXTRA_CHARGES$1,
  extraCharges: extraCharges$1,
  festive: festive$1,
  fieldsRequired: fieldsRequired$1,
  files: files$1,
  filters: filters$1,
  FINISHED: FINISHED$1,
  free: free$1,
  from: from$1,
  fromDate: fromDate$1,
  generalInfo: generalInfo$1,
  groupName: groupName$1,
  id: id$1,
  IN_SERVICE: IN_SERVICE$1,
  information: information$1,
  INRIS: INRIS$1,
  integrated: integrated$1,
  invite: invite$1,
  invoiceDate: invoiceDate$1,
  lastAct: lastAct$1,
  left: left$1,
  LOADED: LOADED$1,
  LOCATED: LOCATED$1,
  locations: locations$1,
  mediums: mediums$1,
  MEDIUMS: MEDIUMS$1,
  modify: modify$1,
  newRates: newRates$1,
  nexus: nexus$1,
  nexusFee: nexusFee$1,
  nFilecase: nFilecase$1,
  nFilecaseAbbrev: nFilecaseAbbrev$1,
  nickName: nickName$1,
  nightlyEnd: nightlyEnd$1,
  nightlyStart: nightlyStart$1,
  nightly: nightly$1,
  nigthly: nigthly$1,
  nightlyFestive: nightlyFestive$1,
  nInvoice: nInvoice$1,
  nInvoices: nInvoices$1,
  none: none$1,
  NOT_IN_NEXUS: NOT_IN_NEXUS$1,
  not: not$1,
  nNexus: nNexus$1,
  nPayments: nPayments$1,
  nServices: nServices$1,
  numberOfInvoices: numberOfInvoices$1,
  of: of$1,
  open: open$1,
  outOfService: outOfService$1,
  ownFilecaseNumber: ownFilecaseNumber$1,
  ownFilecaseNumberAbbrev: ownFilecaseNumberAbbrev$1,
  partialPrice: partialPrice$1,
  participants: participants$1,
  participation: participation$1,
  payed: payed$1,
  payments: payments$1,
  pendingAbbrev: pendingAbbrev$1,
  photosNumber: photosNumber$1,
  pickup: pickup$1,
  "pickup/delivery": "Recogida / entrega",
  pickupAddress: pickupAddress$1,
  pictures: pictures$1,
  "private": "Privado",
  processDate: processDate$1,
  processed: processed$1,
  providerAlreadyMapped: providerAlreadyMapped$1,
  "public": "Público",
  REJECTED: REJECTED$1,
  rejection: rejection$1,
  request: request$1,
  requester: requester$1,
  resource: resource$1,
  resourceActivity: resourceActivity$1,
  resourceDistance: resourceDistance$1,
  resourceRoute: resourceRoute$1,
  resourceTime: resourceTime$1,
  responsable: responsable$1,
  responseNumberAbbrev: responseNumberAbbrev$1,
  RISEND: RISEND$1,
  RISSTART: RISSTART$1,
  rowsPerPage: rowsPerPage$1,
  saveView: saveView$1,
  sendSMSTracking: sendSMSTracking$1,
  sendSurvey: sendSurvey$1,
  serviceActivity: serviceActivity$1,
  serviceBudget: serviceBudget$1,
  serviceRequest: serviceRequest$1,
  serviceType: serviceType$1,
  shared: shared$1,
  shipmentDate: shipmentDate$1,
  sign: sign$1,
  sta: sta$1,
  STARTED: STARTED$1,
  supportTeamAbbrev: supportTeamAbbrev$1,
  surchargeRate: surchargeRate$1,
  surname: surname$1,
  teamMembers: teamMembers$1,
  teamTickets: teamTickets$1,
  totalPrice: totalPrice$1,
  UNAVAILABLE: UNAVAILABLE$1,
  userProfile: userProfile$1,
  validate: validate$1,
  validated: validated$1,
  vehicle: vehicle$1,
  weekend: weekend$1,
  "***** STRUCTURES *****": "*****",
  category: category$1,
  collective2: collective2$1,
  companyList: companyList$1,
  depositList: depositList$1,
  format: format$1,
  invoiceList: invoiceList$1,
  mediumList: mediumList$1,
  "mediums-toast": {
    toastErrorDeactivateMediumTitle: "ERROR",
    toastErrorDeactivateMediumText: "En estos momentos no es posible desactivar el medio. Por favor, vuelve a intentarlo en unos minutos.",
    toastErrorDeactivateMediumInServideTitle: "ERROR",
    toastErrorDeactivateMediumInServiceText: "No es posible desactivar un medio que se encuentra actualmente realizando un servicio."
  },
  mediumTypesList: mediumTypesList$1,
  modals: modals$1,
  operationTypesList: operationTypesList$1,
  paymentList: paymentList$1,
  "rates-concepts": {
    startupFee: "Tarifa de salida",
    scheduledFee: "Tarifa programado",
    nexusFee: "Tarifa de Nexus",
    km: "Tarifa por km",
    mi: "Tarifa por mi",
    minute: "Tarifa por minuto",
    loadTime: "Tiempo de carga",
    surchargeRate: "Recargo",
    cancelRate: "Anulación",
    cancelAmount: "Importe anulación",
    surchargeType: "Tipo de recargo",
    freeCustodyDays: "Custodia gratuita",
    custodyRate: "Custodia",
    urban: "Local",
    urbanFee: "Tarifa local",
    franchise: "Franquicia"
  },
  searchTools: searchTools$1,
  serviceList: serviceList$1,
  servicesError: servicesError$1,
  transferPeopleError: transferPeopleError$1,
  transferPeopleList: transferPeopleList$1,
  shipment: shipment$1,
  "shipments-opt": {
    listWithCount: "{{count}} Remesa",
    listWithCount_plural: "{{count}} Remesas",
    collectInvoiceErrorTitle: "Error al solicitar el cobro de la factura",
    collectInvoiceUnknownError: "En estos momentos no es posible realizar la operación. Vuelva a intentarlo en unos minutos."
  },
  "shipments-opt2": {
    collectInvoiceErrorTitle: "Error al solicitar el cobro de la factura",
    collectInvoiceUnknownError: "En estos momentos no es posible realizar la operación. Vuelva a intentarlo en unos minutos."
  },
  ticketDetail: ticketDetail$1,
  ticketList: ticketList$1,
  user2: user2$1,
  userList: userList$1,
  validation: validation$1,
  loginYourAccount: loginYourAccount$1,
  checkYourEmail: checkYourEmail$1,
  updatedUser: updatedUser$1,
  errorCreatingCompany: errorCreatingCompany$1,
  min: min$1,
  distance: distance$1,
  "---": "---"
};
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var TextInput$1 = function TextInput(props) {
  var handleChange = function handleChange(a, b, c, d) {
    props.onChange(a, b, c, d);
    props.handleChange && props.handleChange(a);
  };
  var handleBlur = function handleBlur(a, b, c, d) {
    props.onBlur(a, b, c, d);
    props.handleBlur && props.handleBlur(a);
  };
  var handleFocus = function handleFocus(a, b, c, d) {
    props.onFocus && props.onFocus(a, b, c, d);
    props.handleFocus && props.handleFocus(a);
  };
  return /*#__PURE__*/React__default__default__default__default.createElement(TextField, _extends$1({}, props, {
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus
  }));
};
var Input$3 = function Input(props) {
  var label = props.label,
    name = props.name,
    errorobj = props.errorobj;
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var isError = false;
  var errorMessage = "";
  if (errorobj && errorobj.hasOwnProperty(name)) {
    isError = true;
    errorMessage = errorobj[name].message || "Obligatorio";
  }
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "Input"
  }, /*#__PURE__*/React__default__default__default__default.createElement(Controller, _extends$1({
    as: TextInput$1,
    name: name,
    control: control,
    defaultValue: "",
    label: label,
    variant: "outlined",
    error: isError,
    helperText: errorMessage
  }, props)));
};
var Button$1 = function Button(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    onClick = _ref.onClick,
    children = _ref.children,
    disabled = _ref.disabled,
    variant = _ref.variant,
    prefixIcon = _ref.prefixIcon;
  return /*#__PURE__*/React__default__default__default__default.createElement("button", {
    type: "button",
    className: "Button " + (variant ? "Button--" + variant : "") + " " + (className ? className : ""),
    onClick: onClick,
    disabled: disabled
  }, prefixIcon && /*#__PURE__*/React__default__default__default__default.createElement("img", {
    src: "/assets/icons/" + prefixIcon + ".svg",
    className: "Button__prefixIcon",
    alt: "icon"
  }), children);
};
var CustomCheckbox$1 = withStyles({
  root: {
    "&$checked": {
      color: "#ec754a"
    }
  },
  checked: {}
})(function (props) {
  return /*#__PURE__*/React__default__default__default__default.createElement(Checkbox, _extends$1({
    color: "default"
  }, props));
});
var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function unwrapExports$1(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function createCommonjsModule$1(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
function getCjsExportFromNamespace$1(n) {
  return n && n['default'] || n;
}
function commonjsRequire$1() {
  throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}
var b$1 = "function" === typeof Symbol && Symbol["for"],
  c$1 = b$1 ? Symbol["for"]("react.element") : 60103,
  d$1 = b$1 ? Symbol["for"]("react.portal") : 60106,
  e$1 = b$1 ? Symbol["for"]("react.fragment") : 60107,
  f$1 = b$1 ? Symbol["for"]("react.strict_mode") : 60108,
  g$1 = b$1 ? Symbol["for"]("react.profiler") : 60114,
  h$1 = b$1 ? Symbol["for"]("react.provider") : 60109,
  k$1 = b$1 ? Symbol["for"]("react.context") : 60110,
  l$1 = b$1 ? Symbol["for"]("react.async_mode") : 60111,
  m$1 = b$1 ? Symbol["for"]("react.concurrent_mode") : 60111,
  n$1 = b$1 ? Symbol["for"]("react.forward_ref") : 60112,
  p$1 = b$1 ? Symbol["for"]("react.suspense") : 60113,
  q$1 = b$1 ? Symbol["for"]("react.suspense_list") : 60120,
  r$2 = b$1 ? Symbol["for"]("react.memo") : 60115,
  t$1 = b$1 ? Symbol["for"]("react.lazy") : 60116,
  v$1 = b$1 ? Symbol["for"]("react.block") : 60121,
  w$1 = b$1 ? Symbol["for"]("react.fundamental") : 60117,
  x$1 = b$1 ? Symbol["for"]("react.responder") : 60118,
  y$1 = b$1 ? Symbol["for"]("react.scope") : 60119;
function z$1(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c$1:
        switch (a = a.type, a) {
          case l$1:
          case m$1:
          case e$1:
          case g$1:
          case f$1:
          case p$1:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k$1:
              case n$1:
              case t$1:
              case r$2:
              case h$1:
                return a;
              default:
                return u;
            }
        }
      case d$1:
        return u;
    }
  }
}
function A$1$1(a) {
  return z$1(a) === m$1;
}
var AsyncMode$1 = l$1;
var ConcurrentMode$1 = m$1;
var ContextConsumer$1 = k$1;
var ContextProvider$1 = h$1;
var Element$1 = c$1;
var ForwardRef$1 = n$1;
var Fragment$1 = e$1;
var Lazy$1 = t$1;
var Memo$1 = r$2;
var Portal$1 = d$1;
var Profiler$1 = g$1;
var StrictMode$1 = f$1;
var Suspense$1 = p$1;
var isAsyncMode$1 = function isAsyncMode(a) {
  return A$1$1(a) || z$1(a) === l$1;
};
var isConcurrentMode$1 = A$1$1;
var isContextConsumer$1 = function isContextConsumer(a) {
  return z$1(a) === k$1;
};
var isContextProvider$1 = function isContextProvider(a) {
  return z$1(a) === h$1;
};
var isElement$1 = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c$1;
};
var isForwardRef$1 = function isForwardRef(a) {
  return z$1(a) === n$1;
};
var isFragment$1 = function isFragment(a) {
  return z$1(a) === e$1;
};
var isLazy$1 = function isLazy(a) {
  return z$1(a) === t$1;
};
var isMemo$1 = function isMemo(a) {
  return z$1(a) === r$2;
};
var isPortal$1 = function isPortal(a) {
  return z$1(a) === d$1;
};
var isProfiler$1 = function isProfiler(a) {
  return z$1(a) === g$1;
};
var isStrictMode$1 = function isStrictMode(a) {
  return z$1(a) === f$1;
};
var isSuspense$1 = function isSuspense(a) {
  return z$1(a) === p$1;
};
var isValidElementType$1 = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e$1 || a === m$1 || a === g$1 || a === f$1 || a === p$1 || a === q$1 || "object" === typeof a && null !== a && (a.$$typeof === t$1 || a.$$typeof === r$2 || a.$$typeof === h$1 || a.$$typeof === k$1 || a.$$typeof === n$1 || a.$$typeof === w$1 || a.$$typeof === x$1 || a.$$typeof === y$1 || a.$$typeof === v$1);
};
var typeOf$1 = z$1;
var reactIs_production_min$1 = {
  AsyncMode: AsyncMode$1,
  ConcurrentMode: ConcurrentMode$1,
  ContextConsumer: ContextConsumer$1,
  ContextProvider: ContextProvider$1,
  Element: Element$1,
  ForwardRef: ForwardRef$1,
  Fragment: Fragment$1,
  Lazy: Lazy$1,
  Memo: Memo$1,
  Portal: Portal$1,
  Profiler: Profiler$1,
  StrictMode: StrictMode$1,
  Suspense: Suspense$1,
  isAsyncMode: isAsyncMode$1,
  isConcurrentMode: isConcurrentMode$1,
  isContextConsumer: isContextConsumer$1,
  isContextProvider: isContextProvider$1,
  isElement: isElement$1,
  isForwardRef: isForwardRef$1,
  isFragment: isFragment$1,
  isLazy: isLazy$1,
  isMemo: isMemo$1,
  isPortal: isPortal$1,
  isProfiler: isProfiler$1,
  isStrictMode: isStrictMode$1,
  isSuspense: isSuspense$1,
  isValidElementType: isValidElementType$1,
  typeOf: typeOf$1
};
var reactIs_development$1 = createCommonjsModule$1(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs$1 = createCommonjsModule$1(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min$1;
  } else {
    module.exports = reactIs_development$1;
  }
});
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable$1 = Object.prototype.propertyIsEnumerable;
function toObject$1(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative$1() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String('abc');
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
var objectAssign$1 = shouldUseNative$1() ? Object.assign : function (target, source) {
  var from;
  var to = toObject$1(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty$1.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols$1) {
      symbols = getOwnPropertySymbols$1(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable$1.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};
var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1$1 = ReactPropTypesSecret$2;
var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$2 = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1$1 = ReactPropTypesSecret_1$1;
  var loggedTypeFailures$1 = {};
  var has$1$1 = has$2;
  printWarning$2 = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1$1(typeSpecs, typeSpecName)) {
        var error;
        try {
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$2((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures$1)) {
          loggedTypeFailures$1[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$2('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
checkPropTypes$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures$1 = {};
  }
};
var checkPropTypes_1$1 = checkPropTypes$1;
var printWarning$1$1 = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  printWarning$1$1 = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull$1() {
  return null;
}
var factoryWithTypeCheckers$1 = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  var ANONYMOUS = '<<anonymous>>';
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  function is(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  }
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1$1) {
        if (throwOnDirectAccess) {
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
            printWarning$1$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull$1);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull$1;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$2(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull$1;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull$1;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$2(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      var allKeys = objectAssign$1({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$2(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    if (propType === 'symbol') {
      return true;
    }
    if (!propValue) {
      return false;
    }
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1$1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1$1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
function emptyFunction$1() {}
function emptyFunctionWithReset$1() {}
emptyFunctionWithReset$1.resetWarningCache = emptyFunction$1;
var factoryWithThrowingShims$1 = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1$1) {
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset$1,
    resetWarningCache: emptyFunction$1
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
var propTypes$1 = createCommonjsModule$1(function (module) {
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs$1;
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers$1(ReactIs.isElement, throwOnDirectAccess);
  } else {
    module.exports = factoryWithThrowingShims$1();
  }
});
var moment$1 = createCommonjsModule$1(function (module, exports) {
  (function (global, factory) {
    module.exports = factory();
  })(commonjsGlobal$1, function () {
    var hookCallback;
    function hooks() {
      return hookCallback.apply(null, arguments);
    }
    function setHookCallback(callback) {
      hookCallback = callback;
    }
    function isArray(input) {
      return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
      return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
      if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
      } else {
        var k;
        for (k in obj) {
          if (hasOwnProp(obj, k)) {
            return false;
          }
        }
        return true;
      }
    }
    function isUndefined(input) {
      return input === void 0;
    }
    function isNumber(input) {
      return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
      return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
      var res = [],
        i,
        arrLen = arr.length;
      for (i = 0; i < arrLen; ++i) {
        res.push(fn(arr[i], i));
      }
      return res;
    }
    function extend(a, b) {
      for (var i in b) {
        if (hasOwnProp(b, i)) {
          a[i] = b[i];
        }
      }
      if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
      }
      if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
      }
      return a;
    }
    function createUTC(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
      return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false
      };
    }
    function getParsingFlags(m) {
      if (m._pf == null) {
        m._pf = defaultParsingFlags();
      }
      return m._pf;
    }
    var some;
    if (Array.prototype.some) {
      some = Array.prototype.some;
    } else {
      some = function some(fun) {
        var t = Object(this),
          len = t.length >>> 0,
          i;
        for (i = 0; i < len; i++) {
          if (i in t && fun.call(this, t[i], i, t)) {
            return true;
          }
        }
        return false;
      };
    }
    function isValid(m) {
      if (m._isValid == null) {
        var flags = getParsingFlags(m),
          parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
          }),
          isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
        if (m._strict) {
          isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
          m._isValid = isNowValid;
        } else {
          return isNowValid;
        }
      }
      return m._isValid;
    }
    function createInvalid(flags) {
      var m = createUTC(NaN);
      if (flags != null) {
        extend(getParsingFlags(m), flags);
      } else {
        getParsingFlags(m).userInvalidated = true;
      }
      return m;
    }
    var momentProperties = hooks.momentProperties = [],
      updateInProgress = false;
    function copyConfig(to, from) {
      var i,
        prop,
        val,
        momentPropertiesLen = momentProperties.length;
      if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
      }
      if (!isUndefined(from._i)) {
        to._i = from._i;
      }
      if (!isUndefined(from._f)) {
        to._f = from._f;
      }
      if (!isUndefined(from._l)) {
        to._l = from._l;
      }
      if (!isUndefined(from._strict)) {
        to._strict = from._strict;
      }
      if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
      }
      if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
      }
      if (!isUndefined(from._offset)) {
        to._offset = from._offset;
      }
      if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
      }
      if (!isUndefined(from._locale)) {
        to._locale = from._locale;
      }
      if (momentPropertiesLen > 0) {
        for (i = 0; i < momentPropertiesLen; i++) {
          prop = momentProperties[i];
          val = from[prop];
          if (!isUndefined(val)) {
            to[prop] = val;
          }
        }
      }
      return to;
    }
    function Moment(config) {
      copyConfig(this, config);
      this._d = new Date(config._d != null ? config._d.getTime() : NaN);
      if (!this.isValid()) {
        this._d = new Date(NaN);
      }
      if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
      }
    }
    function isMoment(obj) {
      return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
      if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
        console.warn('Deprecation warning: ' + msg);
      }
    }
    function deprecate(msg, fn) {
      var firstTime = true;
      return extend(function () {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
          var args = [],
            arg,
            i,
            key,
            argLen = arguments.length;
          for (i = 0; i < argLen; i++) {
            arg = '';
            if (typeof arguments[i] === 'object') {
              arg += '\n[' + i + '] ';
              for (key in arguments[0]) {
                if (hasOwnProp(arguments[0], key)) {
                  arg += key + ': ' + arguments[0][key] + ', ';
                }
              }
              arg = arg.slice(0, -2);
            } else {
              arg = arguments[i];
            }
            args.push(arg);
          }
          warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
          firstTime = false;
        }
        return fn.apply(this, arguments);
      }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
      }
      if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
      }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
      return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
      var prop, i;
      for (i in config) {
        if (hasOwnProp(config, i)) {
          prop = config[i];
          if (isFunction(prop)) {
            this[i] = prop;
          } else {
            this['_' + i] = prop;
          }
        }
      }
      this._config = config;
      this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
      var res = extend({}, parentConfig),
        prop;
      for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
          if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
            res[prop] = {};
            extend(res[prop], parentConfig[prop]);
            extend(res[prop], childConfig[prop]);
          } else if (childConfig[prop] != null) {
            res[prop] = childConfig[prop];
          } else {
            delete res[prop];
          }
        }
      }
      for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
          res[prop] = extend({}, res[prop]);
        }
      }
      return res;
    }
    function Locale(config) {
      if (config != null) {
        this.set(config);
      }
    }
    var keys;
    if (Object.keys) {
      keys = Object.keys;
    } else {
      keys = function keys(obj) {
        var i,
          res = [];
        for (i in obj) {
          if (hasOwnProp(obj, i)) {
            res.push(i);
          }
        }
        return res;
      };
    }
    var defaultCalendar = {
      sameDay: '[Today at] LT',
      nextDay: '[Tomorrow at] LT',
      nextWeek: 'dddd [at] LT',
      lastDay: '[Yesterday at] LT',
      lastWeek: '[Last] dddd [at] LT',
      sameElse: 'L'
    };
    function calendar(key, mom, now) {
      var output = this._calendar[key] || this._calendar['sameElse'];
      return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
      var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
      return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
      localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
      formatFunctions = {},
      formatTokenFunctions = {};
    function addFormatToken(token, padded, ordinal, callback) {
      var func = callback;
      if (typeof callback === 'string') {
        func = function func() {
          return this[callback]();
        };
      }
      if (token) {
        formatTokenFunctions[token] = func;
      }
      if (padded) {
        formatTokenFunctions[padded[0]] = function () {
          return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
      }
      if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
          return this.localeData().ordinal(func.apply(this, arguments), token);
        };
      }
    }
    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
      }
      return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
      var array = format.match(formattingTokens),
        i,
        length;
      for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
          array[i] = formatTokenFunctions[array[i]];
        } else {
          array[i] = removeFormattingTokens(array[i]);
        }
      }
      return function (mom) {
        var output = '',
          i;
        for (i = 0; i < length; i++) {
          output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
      };
    }
    function formatMoment(m, format) {
      if (!m.isValid()) {
        return m.localeData().invalidDate();
      }
      format = expandFormat(format, m.localeData());
      formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
      return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
      var i = 5;
      function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
      }
      localFormattingTokens.lastIndex = 0;
      while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
      }
      return format;
    }
    var defaultLongDateFormat = {
      LTS: 'h:mm:ss A',
      LT: 'h:mm A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
      var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];
      if (format || !formatUpper) {
        return format;
      }
      this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function (tok) {
        if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') {
          return tok.slice(1);
        }
        return tok;
      }).join('');
      return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
      return this._invalidDate;
    }
    var defaultOrdinal = '%d',
      defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
      return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      ss: '%d seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      w: 'a week',
      ww: '%d weeks',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
      var output = this._relativeTime[string];
      return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
      var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
      return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
      var lowerCase = unit.toLowerCase();
      aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
      return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
      var normalizedInput = {},
        normalizedProp,
        prop;
      for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
          normalizedProp = normalizeUnits(prop);
          if (normalizedProp) {
            normalizedInput[normalizedProp] = inputObject[prop];
          }
        }
      }
      return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
      priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
      var units = [],
        u;
      for (u in unitsObj) {
        if (hasOwnProp(unitsObj, u)) {
          units.push({
            unit: u,
            priority: priorities[u]
          });
        }
      }
      units.sort(function (a, b) {
        return a.priority - b.priority;
      });
      return units;
    }
    function isLeapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
      if (number < 0) {
        return Math.ceil(number) || 0;
      } else {
        return Math.floor(number);
      }
    }
    function toInt(argumentForCoercion) {
      var coercedNumber = +argumentForCoercion,
        value = 0;
      if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
      }
      return value;
    }
    function makeGetSet(unit, keepTime) {
      return function (value) {
        if (value != null) {
          set$1(this, unit, value);
          hooks.updateOffset(this, keepTime);
          return this;
        } else {
          return get(this, unit);
        }
      };
    }
    function get(mom, unit) {
      return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
      if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
          value = toInt(value);
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        } else {
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
      }
    }
    function stringGet(units) {
      units = normalizeUnits(units);
      if (isFunction(this[units])) {
        return this[units]();
      }
      return this;
    }
    function stringSet(units, value) {
      if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units),
          i,
          prioritizedLen = prioritized.length;
        for (i = 0; i < prioritizedLen; i++) {
          this[prioritized[i].unit](units[prioritized[i].unit]);
        }
      } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
          return this[units](value);
        }
      }
      return this;
    }
    var match1 = /\d/,
      match2 = /\d\d/,
      match3 = /\d{3}/,
      match4 = /\d{4}/,
      match6 = /[+-]?\d{6}/,
      match1to2 = /\d\d?/,
      match3to4 = /\d\d\d\d?/,
      match5to6 = /\d\d\d\d\d\d?/,
      match1to3 = /\d{1,3}/,
      match1to4 = /\d{1,4}/,
      match1to6 = /[+-]?\d{1,6}/,
      matchUnsigned = /\d+/,
      matchSigned = /[+-]?\d+/,
      matchOffset = /Z|[+-]\d\d:?\d\d/gi,
      matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
      matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
      matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
      regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
      regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return isStrict && strictRegex ? strictRegex : regex;
      };
    }
    function getParseRegexForToken(token, config) {
      if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
      }
      return regexes[token](config._strict, config._locale);
    }
    function unescapeFormat(s) {
      return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
      }));
    }
    function regexEscape(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    var tokens = {};
    function addParseToken(token, callback) {
      var i,
        func = callback,
        tokenLen;
      if (typeof token === 'string') {
        token = [token];
      }
      if (isNumber(callback)) {
        func = function func(input, array) {
          array[callback] = toInt(input);
        };
      }
      tokenLen = token.length;
      for (i = 0; i < tokenLen; i++) {
        tokens[token[i]] = func;
      }
    }
    function addWeekParseToken(token, callback) {
      addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
      });
    }
    function addTimeToArrayFromToken(token, input, config) {
      if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
      }
    }
    var YEAR = 0,
      MONTH = 1,
      DATE = 2,
      HOUR = 3,
      MINUTE = 4,
      SECOND = 5,
      MILLISECOND = 6,
      WEEK = 7,
      WEEKDAY = 8;
    function mod(n, x) {
      return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) {
      indexOf = Array.prototype.indexOf;
    } else {
      indexOf = function indexOf(o) {
        var i;
        for (i = 0; i < this.length; ++i) {
          if (this[i] === o) {
            return i;
          }
        }
        return -1;
      };
    }
    function daysInMonth(year, month) {
      if (isNaN(year) || isNaN(month)) {
        return NaN;
      }
      var modMonth = mod(month, 12);
      year += (month - modMonth) / 12;
      return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    addFormatToken('M', ['MM', 2], 'Mo', function () {
      return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function (format) {
      return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function (format) {
      return this.localeData().months(this, format);
    });
    addUnitAlias('month', 'M');
    addUnitPriority('month', 8);
    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
      return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
      return locale.monthsRegex(isStrict);
    });
    addParseToken(['M', 'MM'], function (input, array) {
      array[MONTH] = toInt(input) - 1;
    });
    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
      var month = config._locale.monthsParse(input, token, config._strict);
      if (month != null) {
        array[MONTH] = month;
      } else {
        getParsingFlags(config).invalidMonth = input;
      }
    });
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
      defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
      defaultMonthsShortRegex = matchWord,
      defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
      if (!m) {
        return isArray(this._months) ? this._months : this._months['standalone'];
      }
      return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
      if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
      }
      return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
      var i,
        ii,
        mom,
        llc = monthName.toLocaleLowerCase();
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
          mom = createUTC([2000, i]);
          this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
          this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeMonthsParse(monthName, format, strict) {
      var i, mom, regex;
      if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
      }
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
      }
      for (i = 0; i < 12; i++) {
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
          this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
          this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
          regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
          this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
          return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
          return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
          return i;
        }
      }
    }
    function setMonth(mom, value) {
      var dayOfMonth;
      if (!mom.isValid()) {
        return mom;
      }
      if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
          value = toInt(value);
        } else {
          value = mom.localeData().monthsParse(value);
          if (!isNumber(value)) {
            return mom;
          }
        }
      }
      dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
      mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
      return mom;
    }
    function getSetMonth(value) {
      if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
      } else {
        return get(this, 'Month');
      }
    }
    function getDaysInMonth() {
      return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsShortStrictRegex;
        } else {
          return this._monthsShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
          this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
      }
    }
    function monthsRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsStrictRegex;
        } else {
          return this._monthsRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
          this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
      }
    }
    function computeMonthsParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom;
      for (i = 0; i < 12; i++) {
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
      }
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
      }
      for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
      }
      this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._monthsShortRegex = this._monthsRegex;
      this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    addFormatToken('Y', 0, 0, function () {
      var y = this.year();
      return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, ['YY', 2], 0, function () {
      return this.year() % 100;
    });
    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
    addUnitAlias('year', 'y');
    addUnitPriority('year', 1);
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
      array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
      array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
      array[YEAR] = parseInt(input, 10);
    });
    function daysInYear(year) {
      return isLeapYear(year) ? 366 : 365;
    }
    hooks.parseTwoDigitYear = function (input) {
      return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
      return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
      var date;
      if (y < 100 && y >= 0) {
        date = new Date(y + 400, m, d, h, M, s, ms);
        if (isFinite(date.getFullYear())) {
          date.setFullYear(y);
        }
      } else {
        date = new Date(y, m, d, h, M, s, ms);
      }
      return date;
    }
    function createUTCDate(y) {
      var date, args;
      if (y < 100 && y >= 0) {
        args = Array.prototype.slice.call(arguments);
        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));
        if (isFinite(date.getUTCFullYear())) {
          date.setUTCFullYear(y);
        }
      } else {
        date = new Date(Date.UTC.apply(null, arguments));
      }
      return date;
    }
    function firstWeekOffset(year, dow, doy) {
      var fwd = 7 + dow - doy,
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
      return -fwdlw + fwd - 1;
    }
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
      var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear,
        resDayOfYear;
      if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
      } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
      } else {
        resYear = year;
        resDayOfYear = dayOfYear;
      }
      return {
        year: resYear,
        dayOfYear: resDayOfYear
      };
    }
    function weekOfYear(mom, dow, doy) {
      var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek,
        resYear;
      if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
      } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
      } else {
        resYear = mom.year();
        resWeek = week;
      }
      return {
        week: resWeek,
        year: resYear
      };
    }
    function weeksInYear(year, dow, doy) {
      var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
      return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');
    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);
    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
      week[token.substr(0, 1)] = toInt(input);
    });
    function localeWeek(mom) {
      return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
      dow: 0,
      doy: 6
    };
    function localeFirstDayOfWeek() {
      return this._week.dow;
    }
    function localeFirstDayOfYear() {
      return this._week.doy;
    }
    function getSetWeek(input) {
      var week = this.localeData().week(this);
      return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
      var week = weekOfYear(this, 1, 4).week;
      return input == null ? week : this.add((input - week) * 7, 'd');
    }
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function (format) {
      return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function (format) {
      return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function (format) {
      return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
      return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
      return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
      return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
      var weekday = config._locale.weekdaysParse(input, token, config._strict);
      if (weekday != null) {
        week.d = weekday;
      } else {
        getParsingFlags(config).invalidWeekday = input;
      }
    });
    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
      week[token] = toInt(input);
    });
    function parseWeekday(input, locale) {
      if (typeof input !== 'string') {
        return input;
      }
      if (!isNaN(input)) {
        return parseInt(input, 10);
      }
      input = locale.weekdaysParse(input);
      if (typeof input === 'number') {
        return input;
      }
      return null;
    }
    function parseIsoWeekday(input, locale) {
      if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
      }
      return isNaN(input) ? null : input;
    }
    function shiftWeekdays(ws, n) {
      return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      defaultWeekdaysRegex = matchWord,
      defaultWeekdaysShortRegex = matchWord,
      defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
      var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
      return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
      return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
      return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
      var i,
        ii,
        mom,
        llc = weekdayName.toLocaleLowerCase();
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];
        for (i = 0; i < 7; ++i) {
          mom = createUTC([2000, 1]).day(i);
          this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
          this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
          this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
      var i, mom, regex;
      if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
      }
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
      }
      for (i = 0; i < 7; i++) {
        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
          this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
          this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
          this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
          regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
          this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
          return i;
        }
      }
    }
    function getSetDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
      if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
      } else {
        return day;
      }
    }
    function getSetLocaleDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
      } else {
        return this.day() || 7;
      }
    }
    function weekdaysRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysStrictRegex;
        } else {
          return this._weekdaysRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
      }
    }
    function weekdaysShortRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysShortStrictRegex;
        } else {
          return this._weekdaysShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
          this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
      }
    }
    function weekdaysMinRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysMinStrictRegex;
        } else {
          return this._weekdaysMinRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
          this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
      }
    }
    function computeWeekdaysParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var minPieces = [],
        shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        minp,
        shortp,
        longp;
      for (i = 0; i < 7; i++) {
        mom = createUTC([2000, 1]).day(i);
        minp = regexEscape(this.weekdaysMin(mom, ''));
        shortp = regexEscape(this.weekdaysShort(mom, ''));
        longp = regexEscape(this.weekdays(mom, ''));
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
      }
      minPieces.sort(cmpLenRev);
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._weekdaysShortRegex = this._weekdaysRegex;
      this._weekdaysMinRegex = this._weekdaysRegex;
      this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
      this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    function hFormat() {
      return this.hours() % 12 || 12;
    }
    function kFormat() {
      return this.hours() || 24;
    }
    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);
    addFormatToken('hmm', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
      addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
      });
    }
    meridiem('a', true);
    meridiem('A', false);
    addUnitAlias('hour', 'h');
    addUnitPriority('hour', 13);
    function matchMeridiem(isStrict, locale) {
      return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
      var kInput = toInt(input);
      array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
      config._isPm = config._locale.isPM(input);
      config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
      array[HOUR] = toInt(input);
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
    });
    function localeIsPM(input) {
      return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
      getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? 'pm' : 'PM';
      } else {
        return isLower ? 'am' : 'AM';
      }
    }
    var baseConfig = {
      calendar: defaultCalendar,
      longDateFormat: defaultLongDateFormat,
      invalidDate: defaultInvalidDate,
      ordinal: defaultOrdinal,
      dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
      relativeTime: defaultRelativeTime,
      months: defaultLocaleMonths,
      monthsShort: defaultLocaleMonthsShort,
      week: defaultLocaleWeek,
      weekdays: defaultLocaleWeekdays,
      weekdaysMin: defaultLocaleWeekdaysMin,
      weekdaysShort: defaultLocaleWeekdaysShort,
      meridiemParse: defaultLocaleMeridiemParse
    };
    var locales = {},
      localeFamilies = {},
      globalLocale;
    function commonPrefix(arr1, arr2) {
      var i,
        minl = Math.min(arr1.length, arr2.length);
      for (i = 0; i < minl; i += 1) {
        if (arr1[i] !== arr2[i]) {
          return i;
        }
      }
      return minl;
    }
    function normalizeLocale(key) {
      return key ? key.toLowerCase().replace('_', '-') : key;
    }
    function chooseLocale(names) {
      var i = 0,
        j,
        next,
        locale,
        split;
      while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
          locale = loadLocale(split.slice(0, j).join('-'));
          if (locale) {
            return locale;
          }
          if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
            break;
          }
          j--;
        }
        i++;
      }
      return globalLocale;
    }
    function isLocaleNameSane(name) {
      return name.match('^[^/\\\\]*$') != null;
    }
    function loadLocale(name) {
      var oldLocale = null,
        aliasedRequire;
      if (locales[name] === undefined && 'object' !== 'undefined' && module && module.exports && isLocaleNameSane(name)) {
        try {
          oldLocale = globalLocale._abbr;
          aliasedRequire = commonjsRequire$1;
          aliasedRequire('./locale/' + name);
          getSetGlobalLocale(oldLocale);
        } catch (e) {
          locales[name] = null;
        }
      }
      return locales[name];
    }
    function getSetGlobalLocale(key, values) {
      var data;
      if (key) {
        if (isUndefined(values)) {
          data = getLocale(key);
        } else {
          data = defineLocale(key, values);
        }
        if (data) {
          globalLocale = data;
        } else {
          if (typeof console !== 'undefined' && console.warn) {
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
          }
        }
      }
      return globalLocale._abbr;
    }
    function defineLocale(name, config) {
      if (config !== null) {
        var locale,
          parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
          deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
          parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
          if (locales[config.parentLocale] != null) {
            parentConfig = locales[config.parentLocale]._config;
          } else {
            locale = loadLocale(config.parentLocale);
            if (locale != null) {
              parentConfig = locale._config;
            } else {
              if (!localeFamilies[config.parentLocale]) {
                localeFamilies[config.parentLocale] = [];
              }
              localeFamilies[config.parentLocale].push({
                name: name,
                config: config
              });
              return null;
            }
          }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));
        if (localeFamilies[name]) {
          localeFamilies[name].forEach(function (x) {
            defineLocale(x.name, x.config);
          });
        }
        getSetGlobalLocale(name);
        return locales[name];
      } else {
        delete locales[name];
        return null;
      }
    }
    function updateLocale(name, config) {
      if (config != null) {
        var locale,
          tmpLocale,
          parentConfig = baseConfig;
        if (locales[name] != null && locales[name].parentLocale != null) {
          locales[name].set(mergeConfigs(locales[name]._config, config));
        } else {
          tmpLocale = loadLocale(name);
          if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
          }
          config = mergeConfigs(parentConfig, config);
          if (tmpLocale == null) {
            config.abbr = name;
          }
          locale = new Locale(config);
          locale.parentLocale = locales[name];
          locales[name] = locale;
        }
        getSetGlobalLocale(name);
      } else {
        if (locales[name] != null) {
          if (locales[name].parentLocale != null) {
            locales[name] = locales[name].parentLocale;
            if (name === getSetGlobalLocale()) {
              getSetGlobalLocale(name);
            }
          } else if (locales[name] != null) {
            delete locales[name];
          }
        }
      }
      return locales[name];
    }
    function getLocale(key) {
      var locale;
      if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
      }
      if (!key) {
        return globalLocale;
      }
      if (!isArray(key)) {
        locale = loadLocale(key);
        if (locale) {
          return locale;
        }
        key = [key];
      }
      return chooseLocale(key);
    }
    function listLocales() {
      return keys(locales);
    }
    function checkOverflow(m) {
      var overflow,
        a = m._a;
      if (a && getParsingFlags(m).overflow === -2) {
        overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
          overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
          overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
          overflow = WEEKDAY;
        }
        getParsingFlags(m).overflow = overflow;
      }
      return m;
    }
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
      isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/], ['YYYYMM', /\d{6}/, false], ['YYYY', /\d{4}/, false]],
      isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]],
      aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
      rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
      obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
      };
    function configFromISO(config) {
      var i,
        l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime,
        dateFormat,
        timeFormat,
        tzFormat,
        isoDatesLen = isoDates.length,
        isoTimesLen = isoTimes.length;
      if (match) {
        getParsingFlags(config).iso = true;
        for (i = 0, l = isoDatesLen; i < l; i++) {
          if (isoDates[i][1].exec(match[1])) {
            dateFormat = isoDates[i][0];
            allowTime = isoDates[i][2] !== false;
            break;
          }
        }
        if (dateFormat == null) {
          config._isValid = false;
          return;
        }
        if (match[3]) {
          for (i = 0, l = isoTimesLen; i < l; i++) {
            if (isoTimes[i][1].exec(match[3])) {
              timeFormat = (match[2] || ' ') + isoTimes[i][0];
              break;
            }
          }
          if (timeFormat == null) {
            config._isValid = false;
            return;
          }
        }
        if (!allowTime && timeFormat != null) {
          config._isValid = false;
          return;
        }
        if (match[4]) {
          if (tzRegex.exec(match[4])) {
            tzFormat = 'Z';
          } else {
            config._isValid = false;
            return;
          }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
      } else {
        config._isValid = false;
      }
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
      var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];
      if (secondStr) {
        result.push(parseInt(secondStr, 10));
      }
      return result;
    }
    function untruncateYear(yearStr) {
      var year = parseInt(yearStr, 10);
      if (year <= 49) {
        return 2000 + year;
      } else if (year <= 999) {
        return 1900 + year;
      }
      return year;
    }
    function preprocessRFC2822(s) {
      return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
      if (weekdayStr) {
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
          weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
          getParsingFlags(config).weekdayMismatch = true;
          config._isValid = false;
          return false;
        }
      }
      return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
      if (obsOffset) {
        return obsOffsets[obsOffset];
      } else if (militaryOffset) {
        return 0;
      } else {
        var hm = parseInt(numOffset, 10),
          m = hm % 100,
          h = (hm - m) / 100;
        return h * 60 + m;
      }
    }
    function configFromRFC2822(config) {
      var match = rfc2822.exec(preprocessRFC2822(config._i)),
        parsedArray;
      if (match) {
        parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
          return;
        }
        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);
        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        getParsingFlags(config).rfc2822 = true;
      } else {
        config._isValid = false;
      }
    }
    function configFromString(config) {
      var matched = aspNetJsonRegex.exec(config._i);
      if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
      }
      configFromISO(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      configFromRFC2822(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      if (config._strict) {
        config._isValid = false;
      } else {
        hooks.createFromInputFallback(config);
      }
    }
    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
      config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    function defaults(a, b, c) {
      if (a != null) {
        return a;
      }
      if (b != null) {
        return b;
      }
      return c;
    }
    function currentDateArray(config) {
      var nowValue = new Date(hooks.now());
      if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
      }
      return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }
    function configFromArray(config) {
      var i,
        date,
        input = [],
        currentDate,
        expectedWeekday,
        yearToUse;
      if (config._d) {
        return;
      }
      currentDate = currentDateArray(config);
      if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
      }
      if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
          getParsingFlags(config)._overflowDayOfYear = true;
        }
        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
      }
      for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
      }
      for (; i < 7; i++) {
        config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
      }
      if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
      }
      config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
      expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
      if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
      }
      if (config._nextDay) {
        config._a[HOUR] = 24;
      }
      if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
      }
    }
    function dayOfYearFromWeekInfo(config) {
      var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
      w = config._w;
      if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
          weekdayOverflow = true;
        }
      } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;
        curWeek = weekOfYear(createLocal(), dow, doy);
        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
        week = defaults(w.w, curWeek.week);
        if (w.d != null) {
          weekday = w.d;
          if (weekday < 0 || weekday > 6) {
            weekdayOverflow = true;
          }
        } else if (w.e != null) {
          weekday = w.e + dow;
          if (w.e < 0 || w.e > 6) {
            weekdayOverflow = true;
          }
        } else {
          weekday = dow;
        }
      }
      if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
      } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
      } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
      }
    }
    hooks.ISO_8601 = function () {};
    hooks.RFC_2822 = function () {};
    function configFromStringAndFormat(config) {
      if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
      }
      if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
      }
      config._a = [];
      getParsingFlags(config).empty = true;
      var string = '' + config._i,
        i,
        parsedInput,
        tokens,
        token,
        skipped,
        stringLength = string.length,
        totalParsedInputLength = 0,
        era,
        tokenLen;
      tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
      tokenLen = tokens.length;
      for (i = 0; i < tokenLen; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        if (parsedInput) {
          skipped = string.substr(0, string.indexOf(parsedInput));
          if (skipped.length > 0) {
            getParsingFlags(config).unusedInput.push(skipped);
          }
          string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
          totalParsedInputLength += parsedInput.length;
        }
        if (formatTokenFunctions[token]) {
          if (parsedInput) {
            getParsingFlags(config).empty = false;
          } else {
            getParsingFlags(config).unusedTokens.push(token);
          }
          addTimeToArrayFromToken(token, parsedInput, config);
        } else if (config._strict && !parsedInput) {
          getParsingFlags(config).unusedTokens.push(token);
        }
      }
      getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
      if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
      }
      if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
      }
      getParsingFlags(config).parsedDateParts = config._a.slice(0);
      getParsingFlags(config).meridiem = config._meridiem;
      config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
      era = getParsingFlags(config).era;
      if (era !== null) {
        config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
      }
      configFromArray(config);
      checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
      var isPm;
      if (meridiem == null) {
        return hour;
      }
      if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
      } else if (locale.isPM != null) {
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
          hour += 12;
        }
        if (!isPm && hour === 12) {
          hour = 0;
        }
        return hour;
      } else {
        return hour;
      }
    }
    function configFromStringAndArray(config) {
      var tempConfig,
        bestMoment,
        scoreToBeat,
        i,
        currentScore,
        validFormatFound,
        bestFormatIsValid = false,
        configfLen = config._f.length;
      if (configfLen === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
      }
      for (i = 0; i < configfLen; i++) {
        currentScore = 0;
        validFormatFound = false;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
          tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);
        if (isValid(tempConfig)) {
          validFormatFound = true;
        }
        currentScore += getParsingFlags(tempConfig).charsLeftOver;
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
        getParsingFlags(tempConfig).score = currentScore;
        if (!bestFormatIsValid) {
          if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
            if (validFormatFound) {
              bestFormatIsValid = true;
            }
          }
        } else {
          if (currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
          }
        }
      }
      extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
      if (config._d) {
        return;
      }
      var i = normalizeObjectUnits(config._i),
        dayOrDate = i.day === undefined ? i.date : i.day;
      config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
      });
      configFromArray(config);
    }
    function createFromConfig(config) {
      var res = new Moment(checkOverflow(prepareConfig(config)));
      if (res._nextDay) {
        res.add(1, 'd');
        res._nextDay = undefined;
      }
      return res;
    }
    function prepareConfig(config) {
      var input = config._i,
        format = config._f;
      config._locale = config._locale || getLocale(config._l);
      if (input === null || format === undefined && input === '') {
        return createInvalid({
          nullInput: true
        });
      }
      if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
      }
      if (isMoment(input)) {
        return new Moment(checkOverflow(input));
      } else if (isDate(input)) {
        config._d = input;
      } else if (isArray(format)) {
        configFromStringAndArray(config);
      } else if (format) {
        configFromStringAndFormat(config);
      } else {
        configFromInput(config);
      }
      if (!isValid(config)) {
        config._d = null;
      }
      return config;
    }
    function configFromInput(config) {
      var input = config._i;
      if (isUndefined(input)) {
        config._d = new Date(hooks.now());
      } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
      } else if (typeof input === 'string') {
        configFromString(config);
      } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
          return parseInt(obj, 10);
        });
        configFromArray(config);
      } else if (isObject(input)) {
        configFromObject(config);
      } else if (isNumber(input)) {
        config._d = new Date(input);
      } else {
        hooks.createFromInputFallback(config);
      }
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
      var c = {};
      if (format === true || format === false) {
        strict = format;
        format = undefined;
      }
      if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
      }
      if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
        input = undefined;
      }
      c._isAMomentObject = true;
      c._useUTC = c._isUTC = isUTC;
      c._l = locale;
      c._i = input;
      c._f = format;
      c._strict = strict;
      return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other < this ? this : other;
        } else {
          return createInvalid();
        }
      }),
      prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other > this ? this : other;
        } else {
          return createInvalid();
        }
      });
    function pickBy(fn, moments) {
      var res, i;
      if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
      }
      if (!moments.length) {
        return createLocal();
      }
      res = moments[0];
      for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
          res = moments[i];
        }
      }
      return res;
    }
    function min() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isBefore', args);
    }
    function max() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isAfter', args);
    }
    var now = function now() {
      return Date.now ? Date.now() : +new Date();
    };
    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
    function isDurationValid(m) {
      var key,
        unitHasDecimal = false,
        i,
        orderLen = ordering.length;
      for (key in m) {
        if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
          return false;
        }
      }
      for (i = 0; i < orderLen; ++i) {
        if (m[ordering[i]]) {
          if (unitHasDecimal) {
            return false;
          }
          if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
            unitHasDecimal = true;
          }
        }
      }
      return true;
    }
    function isValid$1() {
      return this._isValid;
    }
    function createInvalid$1() {
      return createDuration(NaN);
    }
    function Duration(duration) {
      var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;
      this._isValid = isDurationValid(normalizedInput);
      this._milliseconds = +milliseconds + seconds * 1e3 + minutes * 6e4 + hours * 1000 * 60 * 60;
      this._days = +days + weeks * 7;
      this._months = +months + quarters * 3 + years * 12;
      this._data = {};
      this._locale = getLocale();
      this._bubble();
    }
    function isDuration(obj) {
      return obj instanceof Duration;
    }
    function absRound(number) {
      if (number < 0) {
        return Math.round(-1 * number) * -1;
      } else {
        return Math.round(number);
      }
    }
    function compareArrays(array1, array2, dontConvert) {
      var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
      for (i = 0; i < len; i++) {
        if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
          diffs++;
        }
      }
      return diffs + lengthDiff;
    }
    function offset(token, separator) {
      addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset(),
          sign = '+';
        if (offset < 0) {
          offset = -offset;
          sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
      });
    }
    offset('Z', ':');
    offset('ZZ', '');
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
      config._useUTC = true;
      config._tzm = offsetFromString(matchShortOffset, input);
    });
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
      var matches = (string || '').match(matcher),
        chunk,
        parts,
        minutes;
      if (matches === null) {
        return null;
      }
      chunk = matches[matches.length - 1] || [];
      parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
      minutes = +(parts[1] * 60) + toInt(parts[2]);
      return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    function cloneWithOffset(input, model) {
      var res, diff;
      if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
      } else {
        return createLocal(input).local();
      }
    }
    function getDateOffset(m) {
      return -Math.round(m._d.getTimezoneOffset());
    }
    hooks.updateOffset = function () {};
    function getSetOffset(input, keepLocalTime, keepMinutes) {
      var offset = this._offset || 0,
        localAdjust;
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        if (typeof input === 'string') {
          input = offsetFromString(matchShortOffset, input);
          if (input === null) {
            return this;
          }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
          input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
          localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
          this.add(localAdjust, 'm');
        }
        if (offset !== input) {
          if (!keepLocalTime || this._changeInProgress) {
            addSubtract(this, createDuration(input - offset, 'm'), 1, false);
          } else if (!this._changeInProgress) {
            this._changeInProgress = true;
            hooks.updateOffset(this, true);
            this._changeInProgress = null;
          }
        }
        return this;
      } else {
        return this._isUTC ? offset : getDateOffset(this);
      }
    }
    function getSetZone(input, keepLocalTime) {
      if (input != null) {
        if (typeof input !== 'string') {
          input = -input;
        }
        this.utcOffset(input, keepLocalTime);
        return this;
      } else {
        return -this.utcOffset();
      }
    }
    function setOffsetToUTC(keepLocalTime) {
      return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
      if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;
        if (keepLocalTime) {
          this.subtract(getDateOffset(this), 'm');
        }
      }
      return this;
    }
    function setOffsetToParsedOffset() {
      if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
      } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
          this.utcOffset(tZone);
        } else {
          this.utcOffset(0, true);
        }
      }
      return this;
    }
    function hasAlignedHourOffset(input) {
      if (!this.isValid()) {
        return false;
      }
      input = input ? createLocal(input).utcOffset() : 0;
      return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
      return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
      if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
      }
      var c = {},
        other;
      copyConfig(c, this);
      c = prepareConfig(c);
      if (c._a) {
        other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
      } else {
        this._isDSTShifted = false;
      }
      return this._isDSTShifted;
    }
    function isLocal() {
      return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
      return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
      isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
      var duration = input,
        match = null,
        sign,
        ret,
        diffRes;
      if (isDuration(input)) {
        duration = {
          ms: input._milliseconds,
          d: input._days,
          M: input._months
        };
      } else if (isNumber(input) || !isNaN(+input)) {
        duration = {};
        if (key) {
          duration[key] = +input;
        } else {
          duration.milliseconds = +input;
        }
      } else if (match = aspNetRegex.exec(input)) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: 0,
          d: toInt(match[DATE]) * sign,
          h: toInt(match[HOUR]) * sign,
          m: toInt(match[MINUTE]) * sign,
          s: toInt(match[SECOND]) * sign,
          ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
        };
      } else if (match = isoRegex.exec(input)) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: parseIso(match[2], sign),
          M: parseIso(match[3], sign),
          w: parseIso(match[4], sign),
          d: parseIso(match[5], sign),
          h: parseIso(match[6], sign),
          m: parseIso(match[7], sign),
          s: parseIso(match[8], sign)
        };
      } else if (duration == null) {
        duration = {};
      } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
      }
      ret = new Duration(duration);
      if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
      }
      if (isDuration(input) && hasOwnProp(input, '_isValid')) {
        ret._isValid = input._isValid;
      }
      return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
      var res = inp && parseFloat(inp.replace(',', '.'));
      return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
      var res = {};
      res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
      if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
      }
      res.milliseconds = +other - +base.clone().add(res.months, 'M');
      return res;
    }
    function momentsDifference(base, other) {
      var res;
      if (!(base.isValid() && other.isValid())) {
        return {
          milliseconds: 0,
          months: 0
        };
      }
      other = cloneWithOffset(other, base);
      if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
      } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
      }
      return res;
    }
    function createAdder(direction, name) {
      return function (val, period) {
        var dur, tmp;
        if (period !== null && !isNaN(+period)) {
          deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
          tmp = val;
          val = period;
          period = tmp;
        }
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
      };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
      var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);
      if (!mom.isValid()) {
        return;
      }
      updateOffset = updateOffset == null ? true : updateOffset;
      if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
      }
      if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
      }
      if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
      }
      if (updateOffset) {
        hooks.updateOffset(mom, days || months);
      }
    }
    var add = createAdder(1, 'add'),
      subtract = createAdder(-1, 'subtract');
    function isString(input) {
      return typeof input === 'string' || input instanceof String;
    }
    function isMomentInput(input) {
      return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['years', 'year', 'y', 'months', 'month', 'M', 'days', 'day', 'd', 'dates', 'date', 'D', 'hours', 'hour', 'h', 'minutes', 'minute', 'm', 'seconds', 'second', 's', 'milliseconds', 'millisecond', 'ms'],
        i,
        property,
        propertyLen = properties.length;
      for (i = 0; i < propertyLen; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
      var arrayTest = isArray(input),
        dataTypeTest = false;
      if (arrayTest) {
        dataTypeTest = input.filter(function (item) {
          return !isNumber(item) && isString(input);
        }).length === 0;
      }
      return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'],
        i,
        property;
      for (i = 0; i < properties.length; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
      var diff = myMoment.diff(now, 'days', true);
      return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
      if (arguments.length === 1) {
        if (!arguments[0]) {
          time = undefined;
          formats = undefined;
        } else if (isMomentInput(arguments[0])) {
          time = arguments[0];
          formats = undefined;
        } else if (isCalendarSpec(arguments[0])) {
          formats = arguments[0];
          time = undefined;
        }
      }
      var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse',
        output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
      return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
      return new Moment(this);
    }
    function isAfter(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
      } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
      }
    }
    function isBefore(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
      } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
      }
    }
    function isBetween(from, to, units, inclusivity) {
      var localFrom = isMoment(from) ? from : createLocal(from),
        localTo = isMoment(to) ? to : createLocal(to);
      if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
      }
      inclusivity = inclusivity || '()';
      return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
      } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
      }
    }
    function isSameOrAfter(input, units) {
      return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
      return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
      var that, zoneDelta, output;
      if (!this.isValid()) {
        return NaN;
      }
      that = cloneWithOffset(input, this);
      if (!that.isValid()) {
        return NaN;
      }
      zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
      units = normalizeUnits(units);
      switch (units) {
        case 'year':
          output = monthDiff(this, that) / 12;
          break;
        case 'month':
          output = monthDiff(this, that);
          break;
        case 'quarter':
          output = monthDiff(this, that) / 3;
          break;
        case 'second':
          output = (this - that) / 1e3;
          break;
        case 'minute':
          output = (this - that) / 6e4;
          break;
        case 'hour':
          output = (this - that) / 36e5;
          break;
        case 'day':
          output = (this - that - zoneDelta) / 864e5;
          break;
        case 'week':
          output = (this - that - zoneDelta) / 6048e5;
          break;
        default:
          output = this - that;
      }
      return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
      if (a.date() < b.date()) {
        return -monthDiff(b, a);
      }
      var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2,
        adjust;
      if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        adjust = (b - anchor) / (anchor - anchor2);
      } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        adjust = (b - anchor) / (anchor2 - anchor);
      }
      return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
      return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
      if (!this.isValid()) {
        return null;
      }
      var utc = keepOffset !== true,
        m = utc ? this.clone().utc() : this;
      if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
      }
      if (isFunction(Date.prototype.toISOString)) {
        if (utc) {
          return this.toDate().toISOString();
        } else {
          return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
      }
      return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    function inspect() {
      if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
      }
      var func = 'moment',
        zone = '',
        prefix,
        year,
        datetime,
        suffix;
      if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
      }
      prefix = '[' + func + '("]';
      year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
      datetime = '-MM-DD[T]HH:mm:ss.SSS';
      suffix = zone + '[")]';
      return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
      if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
      }
      var output = formatMoment(this, inputString);
      return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          to: this,
          from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function fromNow(withoutSuffix) {
      return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          from: this,
          to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function toNow(withoutSuffix) {
      return this.to(createLocal(), withoutSuffix);
    }
    function locale(key) {
      var newLocaleData;
      if (key === undefined) {
        return this._locale._abbr;
      } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
          this._locale = newLocaleData;
        }
        return this;
      }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
      if (key === undefined) {
        return this.localeData();
      } else {
        return this.locale(key);
      }
    });
    function localeData() {
      return this._locale;
    }
    var MS_PER_SECOND = 1000,
      MS_PER_MINUTE = 60 * MS_PER_SECOND,
      MS_PER_HOUR = 60 * MS_PER_MINUTE,
      MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
    function mod$1(dividend, divisor) {
      return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return new Date(y, m, d).valueOf();
      }
    }
    function utcStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return Date.UTC(y, m, d);
      }
    }
    function startOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case 'year':
          time = startOfDate(this.year(), 0, 1);
          break;
        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
          break;
        case 'month':
          time = startOfDate(this.year(), this.month(), 1);
          break;
        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
          break;
        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
          break;
        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date());
          break;
        case 'hour':
          time = this._d.valueOf();
          time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
          break;
        case 'minute':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_MINUTE);
          break;
        case 'second':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_SECOND);
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function endOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case 'year':
          time = startOfDate(this.year() + 1, 0, 1) - 1;
          break;
        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
          break;
        case 'month':
          time = startOfDate(this.year(), this.month() + 1, 1) - 1;
          break;
        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
          break;
        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
          break;
        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
          break;
        case 'hour':
          time = this._d.valueOf();
          time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
          break;
        case 'minute':
          time = this._d.valueOf();
          time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
          break;
        case 'second':
          time = this._d.valueOf();
          time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function valueOf() {
      return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
      return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
      return new Date(this.valueOf());
    }
    function toArray() {
      var m = this;
      return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }
    function toObject() {
      var m = this;
      return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
      };
    }
    function toJSON() {
      return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
      return isValid(this);
    }
    function parsingFlags() {
      return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
      return getParsingFlags(this).overflow;
    }
    function creationData() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (input, array, config, token) {
      var era = config._locale.erasParse(input, token, config._strict);
      if (era) {
        getParsingFlags(config).era = era;
      } else {
        getParsingFlags(config).invalidEra = input;
      }
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
      var match;
      if (config._locale._eraYearOrdinalRegex) {
        match = input.match(config._locale._eraYearOrdinalRegex);
      }
      if (config._locale.eraYearOrdinalParse) {
        array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
      } else {
        array[YEAR] = parseInt(input, 10);
      }
    });
    function localeEras(m, format) {
      var i,
        l,
        date,
        eras = this._eras || getLocale('en')._eras;
      for (i = 0, l = eras.length; i < l; ++i) {
        switch (typeof eras[i].since) {
          case 'string':
            date = hooks(eras[i].since).startOf('day');
            eras[i].since = date.valueOf();
            break;
        }
        switch (typeof eras[i].until) {
          case 'undefined':
            eras[i].until = +Infinity;
            break;
          case 'string':
            date = hooks(eras[i].until).startOf('day').valueOf();
            eras[i].until = date.valueOf();
            break;
        }
      }
      return eras;
    }
    function localeErasParse(eraName, format, strict) {
      var i,
        l,
        eras = this.eras(),
        name,
        abbr,
        narrow;
      eraName = eraName.toUpperCase();
      for (i = 0, l = eras.length; i < l; ++i) {
        name = eras[i].name.toUpperCase();
        abbr = eras[i].abbr.toUpperCase();
        narrow = eras[i].narrow.toUpperCase();
        if (strict) {
          switch (format) {
            case 'N':
            case 'NN':
            case 'NNN':
              if (abbr === eraName) {
                return eras[i];
              }
              break;
            case 'NNNN':
              if (name === eraName) {
                return eras[i];
              }
              break;
            case 'NNNNN':
              if (narrow === eraName) {
                return eras[i];
              }
              break;
          }
        } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
          return eras[i];
        }
      }
    }
    function localeErasConvertYear(era, year) {
      var dir = era.since <= era.until ? +1 : -1;
      if (year === undefined) {
        return hooks(era.since).year();
      } else {
        return hooks(era.since).year() + (year - era.offset) * dir;
      }
    }
    function getEraName() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].name;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].name;
        }
      }
      return '';
    }
    function getEraNarrow() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].narrow;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].narrow;
        }
      }
      return '';
    }
    function getEraAbbr() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].abbr;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].abbr;
        }
      }
      return '';
    }
    function getEraYear() {
      var i,
        l,
        dir,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        dir = eras[i].since <= eras[i].until ? +1 : -1;
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
          return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
      }
      return this.year();
    }
    function erasNameRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNameRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
      if (!hasOwnProp(this, '_erasAbbrRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNarrowRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
      return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
      return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
      return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
      return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
      var abbrPieces = [],
        namePieces = [],
        narrowPieces = [],
        mixedPieces = [],
        i,
        l,
        eras = this.eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        namePieces.push(regexEscape(eras[i].name));
        abbrPieces.push(regexEscape(eras[i].abbr));
        narrowPieces.push(regexEscape(eras[i].narrow));
        mixedPieces.push(regexEscape(eras[i].name));
        mixedPieces.push(regexEscape(eras[i].abbr));
        mixedPieces.push(regexEscape(eras[i].narrow));
      }
      this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
      this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
      this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    addFormatToken(0, ['gg', 2], 0, function () {
      return this.weekYear() % 100;
    });
    addFormatToken(0, ['GG', 2], 0, function () {
      return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
      addFormatToken(0, [token, token.length], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');
    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
      week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
      week[token] = hooks.parseTwoDigitYear(input);
    });
    function getSetWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
      return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
      return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
      var weeksTarget;
      if (input == null) {
        return weekOfYear(this, dow, doy).year;
      } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
          week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
      }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
      var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
      this.year(date.getUTCFullYear());
      this.month(date.getUTCMonth());
      this.date(date.getUTCDate());
      return this;
    }
    addFormatToken('Q', 0, 'Qo', 'quarter');
    addUnitAlias('quarter', 'Q');
    addUnitPriority('quarter', 7);
    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
      array[MONTH] = (toInt(input) - 1) * 3;
    });
    function getSetQuarter(input) {
      return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    addFormatToken('D', ['DD', 2], 'Do', 'date');
    addUnitAlias('date', 'D');
    addUnitPriority('date', 9);
    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
      return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
      array[DATE] = toInt(input.match(match1to2)[0]);
    });
    var getSetDayOfMonth = makeGetSet('Date', true);
    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
    addUnitAlias('dayOfYear', 'DDD');
    addUnitPriority('dayOfYear', 4);
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
      config._dayOfYear = toInt(input);
    });
    function getSetDayOfYear(input) {
      var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
      return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    addFormatToken('m', ['mm', 2], 0, 'minute');
    addUnitAlias('minute', 'm');
    addUnitPriority('minute', 14);
    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);
    var getSetMinute = makeGetSet('Minutes', false);
    addFormatToken('s', ['ss', 2], 0, 'second');
    addUnitAlias('second', 's');
    addUnitPriority('second', 15);
    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);
    var getSetSecond = makeGetSet('Seconds', false);
    addFormatToken('S', 0, 0, function () {
      return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, ['SS', 2], 0, function () {
      return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
      return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
      return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
      return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
      return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
      return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
      return this.millisecond() * 1000000;
    });
    addUnitAlias('millisecond', 'ms');
    addUnitPriority('millisecond', 16);
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
      addRegexToken(token, matchUnsigned);
    }
    function parseMs(input, array) {
      array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for (token = 'S'; token.length <= 9; token += 'S') {
      addParseToken(token, parseMs);
    }
    getSetMillisecond = makeGetSet('Milliseconds', false);
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    function getZoneAbbr() {
      return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
      return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol["for"] != null) {
      proto[Symbol["for"]('nodejs.util.inspect.custom')] = function () {
        return 'Moment<' + this.format() + '>';
      };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
      return createLocal(input * 1000);
    }
    function createInZone() {
      return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
      return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
      var locale = getLocale(),
        utc = createUTC().set(setter, index);
      return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }
      format = format || '';
      if (index != null) {
        return get$1(format, index, field, 'month');
      }
      var i,
        out = [];
      for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
      }
      return out;
    }
    function listWeekdaysImpl(localeSorted, format, index, field) {
      if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }
        format = format || '';
      } else {
        format = localeSorted;
        index = format;
        localeSorted = false;
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }
        format = format || '';
      }
      var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0,
        i,
        out = [];
      if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
      }
      for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
      }
      return out;
    }
    function listMonths(format, index) {
      return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
      return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
      eras: [{
        since: '0001-01-01',
        until: +Infinity,
        offset: 1,
        name: 'Anno Domini',
        narrow: 'AD',
        abbr: 'AD'
      }, {
        since: '0000-12-31',
        until: -Infinity,
        offset: 1,
        name: 'Before Christ',
        narrow: 'BC',
        abbr: 'BC'
      }],
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function ordinal(number) {
        var b = number % 10,
          output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        return number + output;
      }
    });
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
      var data = this._data;
      this._milliseconds = mathAbs(this._milliseconds);
      this._days = mathAbs(this._days);
      this._months = mathAbs(this._months);
      data.milliseconds = mathAbs(data.milliseconds);
      data.seconds = mathAbs(data.seconds);
      data.minutes = mathAbs(data.minutes);
      data.hours = mathAbs(data.hours);
      data.months = mathAbs(data.months);
      data.years = mathAbs(data.years);
      return this;
    }
    function addSubtract$1(duration, input, value, direction) {
      var other = createDuration(input, value);
      duration._milliseconds += direction * other._milliseconds;
      duration._days += direction * other._days;
      duration._months += direction * other._months;
      return duration._bubble();
    }
    function add$1(input, value) {
      return addSubtract$1(this, input, value, 1);
    }
    function subtract$1(input, value) {
      return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
      if (number < 0) {
        return Math.floor(number);
      } else {
        return Math.ceil(number);
      }
    }
    function bubble() {
      var milliseconds = this._milliseconds,
        days = this._days,
        months = this._months,
        data = this._data,
        seconds,
        minutes,
        hours,
        years,
        monthsFromDays;
      if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
      }
      data.milliseconds = milliseconds % 1000;
      seconds = absFloor(milliseconds / 1000);
      data.seconds = seconds % 60;
      minutes = absFloor(seconds / 60);
      data.minutes = minutes % 60;
      hours = absFloor(minutes / 60);
      data.hours = hours % 24;
      days += absFloor(hours / 24);
      monthsFromDays = absFloor(daysToMonths(days));
      months += monthsFromDays;
      days -= absCeil(monthsToDays(monthsFromDays));
      years = absFloor(months / 12);
      months %= 12;
      data.days = days;
      data.months = months;
      data.years = years;
      return this;
    }
    function daysToMonths(days) {
      return days * 4800 / 146097;
    }
    function monthsToDays(months) {
      return months * 146097 / 4800;
    }
    function as(units) {
      if (!this.isValid()) {
        return NaN;
      }
      var days,
        months,
        milliseconds = this._milliseconds;
      units = normalizeUnits(units);
      if (units === 'month' || units === 'quarter' || units === 'year') {
        days = this._days + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        switch (units) {
          case 'month':
            return months;
          case 'quarter':
            return months / 3;
          case 'year':
            return months / 12;
        }
      } else {
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
          case 'week':
            return days / 7 + milliseconds / 6048e5;
          case 'day':
            return days + milliseconds / 864e5;
          case 'hour':
            return days * 24 + milliseconds / 36e5;
          case 'minute':
            return days * 1440 + milliseconds / 6e4;
          case 'second':
            return days * 86400 + milliseconds / 1000;
          case 'millisecond':
            return Math.floor(days * 864e5) + milliseconds;
          default:
            throw new Error('Unknown unit ' + units);
        }
      }
    }
    function valueOf$1() {
      if (!this.isValid()) {
        return NaN;
      }
      return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
      return function () {
        return this.as(alias);
      };
    }
    var asMilliseconds = makeAs('ms'),
      asSeconds = makeAs('s'),
      asMinutes = makeAs('m'),
      asHours = makeAs('h'),
      asDays = makeAs('d'),
      asWeeks = makeAs('w'),
      asMonths = makeAs('M'),
      asQuarters = makeAs('Q'),
      asYears = makeAs('y');
    function clone$1() {
      return createDuration(this);
    }
    function get$2(units) {
      units = normalizeUnits(units);
      return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
      return function () {
        return this.isValid() ? this._data[name] : NaN;
      };
    }
    var milliseconds = makeGetter('milliseconds'),
      seconds = makeGetter('seconds'),
      minutes = makeGetter('minutes'),
      hours = makeGetter('hours'),
      days = makeGetter('days'),
      months = makeGetter('months'),
      years = makeGetter('years');
    function weeks() {
      return absFloor(this.days() / 7);
    }
    var round = Math.round,
      thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
      };
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
      return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
      var duration = createDuration(posNegDuration).abs(),
        seconds = round(duration.as('s')),
        minutes = round(duration.as('m')),
        hours = round(duration.as('h')),
        days = round(duration.as('d')),
        months = round(duration.as('M')),
        weeks = round(duration.as('w')),
        years = round(duration.as('y')),
        a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days];
      if (thresholds.w != null) {
        a = a || weeks <= 1 && ['w'] || weeks < thresholds.w && ['ww', weeks];
      }
      a = a || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
      a[2] = withoutSuffix;
      a[3] = +posNegDuration > 0;
      a[4] = locale;
      return substituteTimeAgo.apply(null, a);
    }
    function getSetRelativeTimeRounding(roundingFunction) {
      if (roundingFunction === undefined) {
        return round;
      }
      if (typeof roundingFunction === 'function') {
        round = roundingFunction;
        return true;
      }
      return false;
    }
    function getSetRelativeTimeThreshold(threshold, limit) {
      if (thresholds[threshold] === undefined) {
        return false;
      }
      if (limit === undefined) {
        return thresholds[threshold];
      }
      thresholds[threshold] = limit;
      if (threshold === 's') {
        thresholds.ss = limit - 1;
      }
      return true;
    }
    function humanize(argWithSuffix, argThresholds) {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var withSuffix = false,
        th = thresholds,
        locale,
        output;
      if (typeof argWithSuffix === 'object') {
        argThresholds = argWithSuffix;
        argWithSuffix = false;
      }
      if (typeof argWithSuffix === 'boolean') {
        withSuffix = argWithSuffix;
      }
      if (typeof argThresholds === 'object') {
        th = Object.assign({}, thresholds, argThresholds);
        if (argThresholds.s != null && argThresholds.ss == null) {
          th.ss = argThresholds.s - 1;
        }
      }
      locale = this.localeData();
      output = relativeTime$1(this, !withSuffix, th, locale);
      if (withSuffix) {
        output = locale.pastFuture(+this, output);
      }
      return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
      return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var seconds = abs$1(this._milliseconds) / 1000,
        days = abs$1(this._days),
        months = abs$1(this._months),
        minutes,
        hours,
        years,
        s,
        total = this.asSeconds(),
        totalSign,
        ymSign,
        daysSign,
        hmsSign;
      if (!total) {
        return 'P0D';
      }
      minutes = absFloor(seconds / 60);
      hours = absFloor(minutes / 60);
      seconds %= 60;
      minutes %= 60;
      years = absFloor(months / 12);
      months %= 12;
      s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
      totalSign = total < 0 ? '-' : '';
      ymSign = sign(this._months) !== sign(total) ? '-' : '';
      daysSign = sign(this._days) !== sign(total) ? '-' : '';
      hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
      return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
      config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
      config._d = new Date(toInt(input));
    });
    hooks.version = '2.29.4';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    hooks.HTML5_FMT = {
      DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
      DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
      DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
      DATE: 'YYYY-MM-DD',
      TIME: 'HH:mm',
      TIME_SECONDS: 'HH:mm:ss',
      TIME_MS: 'HH:mm:ss.SSS',
      WEEK: 'GGGG-[W]WW',
      MONTH: 'YYYY-MM'
    };
    return hooks;
  });
});
var Chart$1 = createCommonjsModule$1(function (module, exports) {
  (function (global, factory) {
    module.exports = factory(function () {
      try {
        return moment$1;
      } catch (e) {}
    }());
  })(commonjsGlobal$1, function (moment) {
    moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
    function createCommonjsModule(fn, module) {
      return module = {
        exports: {}
      }, fn(module, module.exports), module.exports;
    }
    function getCjsExportFromNamespace(n) {
      return n && n['default'] || n;
    }
    var colorName = {
      "aliceblue": [240, 248, 255],
      "antiquewhite": [250, 235, 215],
      "aqua": [0, 255, 255],
      "aquamarine": [127, 255, 212],
      "azure": [240, 255, 255],
      "beige": [245, 245, 220],
      "bisque": [255, 228, 196],
      "black": [0, 0, 0],
      "blanchedalmond": [255, 235, 205],
      "blue": [0, 0, 255],
      "blueviolet": [138, 43, 226],
      "brown": [165, 42, 42],
      "burlywood": [222, 184, 135],
      "cadetblue": [95, 158, 160],
      "chartreuse": [127, 255, 0],
      "chocolate": [210, 105, 30],
      "coral": [255, 127, 80],
      "cornflowerblue": [100, 149, 237],
      "cornsilk": [255, 248, 220],
      "crimson": [220, 20, 60],
      "cyan": [0, 255, 255],
      "darkblue": [0, 0, 139],
      "darkcyan": [0, 139, 139],
      "darkgoldenrod": [184, 134, 11],
      "darkgray": [169, 169, 169],
      "darkgreen": [0, 100, 0],
      "darkgrey": [169, 169, 169],
      "darkkhaki": [189, 183, 107],
      "darkmagenta": [139, 0, 139],
      "darkolivegreen": [85, 107, 47],
      "darkorange": [255, 140, 0],
      "darkorchid": [153, 50, 204],
      "darkred": [139, 0, 0],
      "darksalmon": [233, 150, 122],
      "darkseagreen": [143, 188, 143],
      "darkslateblue": [72, 61, 139],
      "darkslategray": [47, 79, 79],
      "darkslategrey": [47, 79, 79],
      "darkturquoise": [0, 206, 209],
      "darkviolet": [148, 0, 211],
      "deeppink": [255, 20, 147],
      "deepskyblue": [0, 191, 255],
      "dimgray": [105, 105, 105],
      "dimgrey": [105, 105, 105],
      "dodgerblue": [30, 144, 255],
      "firebrick": [178, 34, 34],
      "floralwhite": [255, 250, 240],
      "forestgreen": [34, 139, 34],
      "fuchsia": [255, 0, 255],
      "gainsboro": [220, 220, 220],
      "ghostwhite": [248, 248, 255],
      "gold": [255, 215, 0],
      "goldenrod": [218, 165, 32],
      "gray": [128, 128, 128],
      "green": [0, 128, 0],
      "greenyellow": [173, 255, 47],
      "grey": [128, 128, 128],
      "honeydew": [240, 255, 240],
      "hotpink": [255, 105, 180],
      "indianred": [205, 92, 92],
      "indigo": [75, 0, 130],
      "ivory": [255, 255, 240],
      "khaki": [240, 230, 140],
      "lavender": [230, 230, 250],
      "lavenderblush": [255, 240, 245],
      "lawngreen": [124, 252, 0],
      "lemonchiffon": [255, 250, 205],
      "lightblue": [173, 216, 230],
      "lightcoral": [240, 128, 128],
      "lightcyan": [224, 255, 255],
      "lightgoldenrodyellow": [250, 250, 210],
      "lightgray": [211, 211, 211],
      "lightgreen": [144, 238, 144],
      "lightgrey": [211, 211, 211],
      "lightpink": [255, 182, 193],
      "lightsalmon": [255, 160, 122],
      "lightseagreen": [32, 178, 170],
      "lightskyblue": [135, 206, 250],
      "lightslategray": [119, 136, 153],
      "lightslategrey": [119, 136, 153],
      "lightsteelblue": [176, 196, 222],
      "lightyellow": [255, 255, 224],
      "lime": [0, 255, 0],
      "limegreen": [50, 205, 50],
      "linen": [250, 240, 230],
      "magenta": [255, 0, 255],
      "maroon": [128, 0, 0],
      "mediumaquamarine": [102, 205, 170],
      "mediumblue": [0, 0, 205],
      "mediumorchid": [186, 85, 211],
      "mediumpurple": [147, 112, 219],
      "mediumseagreen": [60, 179, 113],
      "mediumslateblue": [123, 104, 238],
      "mediumspringgreen": [0, 250, 154],
      "mediumturquoise": [72, 209, 204],
      "mediumvioletred": [199, 21, 133],
      "midnightblue": [25, 25, 112],
      "mintcream": [245, 255, 250],
      "mistyrose": [255, 228, 225],
      "moccasin": [255, 228, 181],
      "navajowhite": [255, 222, 173],
      "navy": [0, 0, 128],
      "oldlace": [253, 245, 230],
      "olive": [128, 128, 0],
      "olivedrab": [107, 142, 35],
      "orange": [255, 165, 0],
      "orangered": [255, 69, 0],
      "orchid": [218, 112, 214],
      "palegoldenrod": [238, 232, 170],
      "palegreen": [152, 251, 152],
      "paleturquoise": [175, 238, 238],
      "palevioletred": [219, 112, 147],
      "papayawhip": [255, 239, 213],
      "peachpuff": [255, 218, 185],
      "peru": [205, 133, 63],
      "pink": [255, 192, 203],
      "plum": [221, 160, 221],
      "powderblue": [176, 224, 230],
      "purple": [128, 0, 128],
      "rebeccapurple": [102, 51, 153],
      "red": [255, 0, 0],
      "rosybrown": [188, 143, 143],
      "royalblue": [65, 105, 225],
      "saddlebrown": [139, 69, 19],
      "salmon": [250, 128, 114],
      "sandybrown": [244, 164, 96],
      "seagreen": [46, 139, 87],
      "seashell": [255, 245, 238],
      "sienna": [160, 82, 45],
      "silver": [192, 192, 192],
      "skyblue": [135, 206, 235],
      "slateblue": [106, 90, 205],
      "slategray": [112, 128, 144],
      "slategrey": [112, 128, 144],
      "snow": [255, 250, 250],
      "springgreen": [0, 255, 127],
      "steelblue": [70, 130, 180],
      "tan": [210, 180, 140],
      "teal": [0, 128, 128],
      "thistle": [216, 191, 216],
      "tomato": [255, 99, 71],
      "turquoise": [64, 224, 208],
      "violet": [238, 130, 238],
      "wheat": [245, 222, 179],
      "white": [255, 255, 255],
      "whitesmoke": [245, 245, 245],
      "yellow": [255, 255, 0],
      "yellowgreen": [154, 205, 50]
    };
    var conversions = createCommonjsModule(function (module) {
      var reverseKeywords = {};
      for (var key in colorName) {
        if (colorName.hasOwnProperty(key)) {
          reverseKeywords[colorName[key]] = key;
        }
      }
      var convert = module.exports = {
        rgb: {
          channels: 3,
          labels: 'rgb'
        },
        hsl: {
          channels: 3,
          labels: 'hsl'
        },
        hsv: {
          channels: 3,
          labels: 'hsv'
        },
        hwb: {
          channels: 3,
          labels: 'hwb'
        },
        cmyk: {
          channels: 4,
          labels: 'cmyk'
        },
        xyz: {
          channels: 3,
          labels: 'xyz'
        },
        lab: {
          channels: 3,
          labels: 'lab'
        },
        lch: {
          channels: 3,
          labels: 'lch'
        },
        hex: {
          channels: 1,
          labels: ['hex']
        },
        keyword: {
          channels: 1,
          labels: ['keyword']
        },
        ansi16: {
          channels: 1,
          labels: ['ansi16']
        },
        ansi256: {
          channels: 1,
          labels: ['ansi256']
        },
        hcg: {
          channels: 3,
          labels: ['h', 'c', 'g']
        },
        apple: {
          channels: 3,
          labels: ['r16', 'g16', 'b16']
        },
        gray: {
          channels: 1,
          labels: ['gray']
        }
      };
      for (var model in convert) {
        if (convert.hasOwnProperty(model)) {
          if (!('channels' in convert[model])) {
            throw new Error('missing channels property: ' + model);
          }
          if (!('labels' in convert[model])) {
            throw new Error('missing channel labels property: ' + model);
          }
          if (convert[model].labels.length !== convert[model].channels) {
            throw new Error('channel and label counts mismatch: ' + model);
          }
          var channels = convert[model].channels;
          var labels = convert[model].labels;
          delete convert[model].channels;
          delete convert[model].labels;
          Object.defineProperty(convert[model], 'channels', {
            value: channels
          });
          Object.defineProperty(convert[model], 'labels', {
            value: labels
          });
        }
      }
      convert.rgb.hsl = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var delta = max - min;
        var h;
        var s;
        var l;
        if (max === min) {
          h = 0;
        } else if (r === max) {
          h = (g - b) / delta;
        } else if (g === max) {
          h = 2 + (b - r) / delta;
        } else if (b === max) {
          h = 4 + (r - g) / delta;
        }
        h = Math.min(h * 60, 360);
        if (h < 0) {
          h += 360;
        }
        l = (min + max) / 2;
        if (max === min) {
          s = 0;
        } else if (l <= 0.5) {
          s = delta / (max + min);
        } else {
          s = delta / (2 - max - min);
        }
        return [h, s * 100, l * 100];
      };
      convert.rgb.hsv = function (rgb) {
        var rdif;
        var gdif;
        var bdif;
        var h;
        var s;
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var v = Math.max(r, g, b);
        var diff = v - Math.min(r, g, b);
        var diffc = function diffc(c) {
          return (v - c) / 6 / diff + 1 / 2;
        };
        if (diff === 0) {
          h = s = 0;
        } else {
          s = diff / v;
          rdif = diffc(r);
          gdif = diffc(g);
          bdif = diffc(b);
          if (r === v) {
            h = bdif - gdif;
          } else if (g === v) {
            h = 1 / 3 + rdif - bdif;
          } else if (b === v) {
            h = 2 / 3 + gdif - rdif;
          }
          if (h < 0) {
            h += 1;
          } else if (h > 1) {
            h -= 1;
          }
        }
        return [h * 360, s * 100, v * 100];
      };
      convert.rgb.hwb = function (rgb) {
        var r = rgb[0];
        var g = rgb[1];
        var b = rgb[2];
        var h = convert.rgb.hsl(rgb)[0];
        var w = 1 / 255 * Math.min(r, Math.min(g, b));
        b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
        return [h, w * 100, b * 100];
      };
      convert.rgb.cmyk = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var c;
        var m;
        var y;
        var k;
        k = Math.min(1 - r, 1 - g, 1 - b);
        c = (1 - r - k) / (1 - k) || 0;
        m = (1 - g - k) / (1 - k) || 0;
        y = (1 - b - k) / (1 - k) || 0;
        return [c * 100, m * 100, y * 100, k * 100];
      };
      function comparativeDistance(x, y) {
        return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
      }
      convert.rgb.keyword = function (rgb) {
        var reversed = reverseKeywords[rgb];
        if (reversed) {
          return reversed;
        }
        var currentClosestDistance = Infinity;
        var currentClosestKeyword;
        for (var keyword in colorName) {
          if (colorName.hasOwnProperty(keyword)) {
            var value = colorName[keyword];
            var distance = comparativeDistance(rgb, value);
            if (distance < currentClosestDistance) {
              currentClosestDistance = distance;
              currentClosestKeyword = keyword;
            }
          }
        }
        return currentClosestKeyword;
      };
      convert.keyword.rgb = function (keyword) {
        return colorName[keyword];
      };
      convert.rgb.xyz = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
        g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
        b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
        var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
        var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
        var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
        return [x * 100, y * 100, z * 100];
      };
      convert.rgb.lab = function (rgb) {
        var xyz = convert.rgb.xyz(rgb);
        var x = xyz[0];
        var y = xyz[1];
        var z = xyz[2];
        var l;
        var a;
        var b;
        x /= 95.047;
        y /= 100;
        z /= 108.883;
        x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
        l = 116 * y - 16;
        a = 500 * (x - y);
        b = 200 * (y - z);
        return [l, a, b];
      };
      convert.hsl.rgb = function (hsl) {
        var h = hsl[0] / 360;
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var t1;
        var t2;
        var t3;
        var rgb;
        var val;
        if (s === 0) {
          val = l * 255;
          return [val, val, val];
        }
        if (l < 0.5) {
          t2 = l * (1 + s);
        } else {
          t2 = l + s - l * s;
        }
        t1 = 2 * l - t2;
        rgb = [0, 0, 0];
        for (var i = 0; i < 3; i++) {
          t3 = h + 1 / 3 * -(i - 1);
          if (t3 < 0) {
            t3++;
          }
          if (t3 > 1) {
            t3--;
          }
          if (6 * t3 < 1) {
            val = t1 + (t2 - t1) * 6 * t3;
          } else if (2 * t3 < 1) {
            val = t2;
          } else if (3 * t3 < 2) {
            val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
          } else {
            val = t1;
          }
          rgb[i] = val * 255;
        }
        return rgb;
      };
      convert.hsl.hsv = function (hsl) {
        var h = hsl[0];
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var smin = s;
        var lmin = Math.max(l, 0.01);
        var sv;
        var v;
        l *= 2;
        s *= l <= 1 ? l : 2 - l;
        smin *= lmin <= 1 ? lmin : 2 - lmin;
        v = (l + s) / 2;
        sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
        return [h, sv * 100, v * 100];
      };
      convert.hsv.rgb = function (hsv) {
        var h = hsv[0] / 60;
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var hi = Math.floor(h) % 6;
        var f = h - Math.floor(h);
        var p = 255 * v * (1 - s);
        var q = 255 * v * (1 - s * f);
        var t = 255 * v * (1 - s * (1 - f));
        v *= 255;
        switch (hi) {
          case 0:
            return [v, t, p];
          case 1:
            return [q, v, p];
          case 2:
            return [p, v, t];
          case 3:
            return [p, q, v];
          case 4:
            return [t, p, v];
          case 5:
            return [v, p, q];
        }
      };
      convert.hsv.hsl = function (hsv) {
        var h = hsv[0];
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var vmin = Math.max(v, 0.01);
        var lmin;
        var sl;
        var l;
        l = (2 - s) * v;
        lmin = (2 - s) * vmin;
        sl = s * vmin;
        sl /= lmin <= 1 ? lmin : 2 - lmin;
        sl = sl || 0;
        l /= 2;
        return [h, sl * 100, l * 100];
      };
      convert.hwb.rgb = function (hwb) {
        var h = hwb[0] / 360;
        var wh = hwb[1] / 100;
        var bl = hwb[2] / 100;
        var ratio = wh + bl;
        var i;
        var v;
        var f;
        var n;
        if (ratio > 1) {
          wh /= ratio;
          bl /= ratio;
        }
        i = Math.floor(6 * h);
        v = 1 - bl;
        f = 6 * h - i;
        if ((i & 0x01) !== 0) {
          f = 1 - f;
        }
        n = wh + f * (v - wh);
        var r;
        var g;
        var b;
        switch (i) {
          default:
          case 6:
          case 0:
            r = v;
            g = n;
            b = wh;
            break;
          case 1:
            r = n;
            g = v;
            b = wh;
            break;
          case 2:
            r = wh;
            g = v;
            b = n;
            break;
          case 3:
            r = wh;
            g = n;
            b = v;
            break;
          case 4:
            r = n;
            g = wh;
            b = v;
            break;
          case 5:
            r = v;
            g = wh;
            b = n;
            break;
        }
        return [r * 255, g * 255, b * 255];
      };
      convert.cmyk.rgb = function (cmyk) {
        var c = cmyk[0] / 100;
        var m = cmyk[1] / 100;
        var y = cmyk[2] / 100;
        var k = cmyk[3] / 100;
        var r;
        var g;
        var b;
        r = 1 - Math.min(1, c * (1 - k) + k);
        g = 1 - Math.min(1, m * (1 - k) + k);
        b = 1 - Math.min(1, y * (1 - k) + k);
        return [r * 255, g * 255, b * 255];
      };
      convert.xyz.rgb = function (xyz) {
        var x = xyz[0] / 100;
        var y = xyz[1] / 100;
        var z = xyz[2] / 100;
        var r;
        var g;
        var b;
        r = x * 3.2406 + y * -1.5372 + z * -0.4986;
        g = x * -0.9689 + y * 1.8758 + z * 0.0415;
        b = x * 0.0557 + y * -0.2040 + z * 1.0570;
        r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
        g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
        b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
        r = Math.min(Math.max(0, r), 1);
        g = Math.min(Math.max(0, g), 1);
        b = Math.min(Math.max(0, b), 1);
        return [r * 255, g * 255, b * 255];
      };
      convert.xyz.lab = function (xyz) {
        var x = xyz[0];
        var y = xyz[1];
        var z = xyz[2];
        var l;
        var a;
        var b;
        x /= 95.047;
        y /= 100;
        z /= 108.883;
        x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
        l = 116 * y - 16;
        a = 500 * (x - y);
        b = 200 * (y - z);
        return [l, a, b];
      };
      convert.lab.xyz = function (lab) {
        var l = lab[0];
        var a = lab[1];
        var b = lab[2];
        var x;
        var y;
        var z;
        y = (l + 16) / 116;
        x = a / 500 + y;
        z = y - b / 200;
        var y2 = Math.pow(y, 3);
        var x2 = Math.pow(x, 3);
        var z2 = Math.pow(z, 3);
        y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
        x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
        z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
        x *= 95.047;
        y *= 100;
        z *= 108.883;
        return [x, y, z];
      };
      convert.lab.lch = function (lab) {
        var l = lab[0];
        var a = lab[1];
        var b = lab[2];
        var hr;
        var h;
        var c;
        hr = Math.atan2(b, a);
        h = hr * 360 / 2 / Math.PI;
        if (h < 0) {
          h += 360;
        }
        c = Math.sqrt(a * a + b * b);
        return [l, c, h];
      };
      convert.lch.lab = function (lch) {
        var l = lch[0];
        var c = lch[1];
        var h = lch[2];
        var a;
        var b;
        var hr;
        hr = h / 360 * 2 * Math.PI;
        a = c * Math.cos(hr);
        b = c * Math.sin(hr);
        return [l, a, b];
      };
      convert.rgb.ansi16 = function (args) {
        var r = args[0];
        var g = args[1];
        var b = args[2];
        var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2];
        value = Math.round(value / 50);
        if (value === 0) {
          return 30;
        }
        var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
        if (value === 2) {
          ansi += 60;
        }
        return ansi;
      };
      convert.hsv.ansi16 = function (args) {
        return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
      };
      convert.rgb.ansi256 = function (args) {
        var r = args[0];
        var g = args[1];
        var b = args[2];
        if (r === g && g === b) {
          if (r < 8) {
            return 16;
          }
          if (r > 248) {
            return 231;
          }
          return Math.round((r - 8) / 247 * 24) + 232;
        }
        var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
        return ansi;
      };
      convert.ansi16.rgb = function (args) {
        var color = args % 10;
        if (color === 0 || color === 7) {
          if (args > 50) {
            color += 3.5;
          }
          color = color / 10.5 * 255;
          return [color, color, color];
        }
        var mult = (~~(args > 50) + 1) * 0.5;
        var r = (color & 1) * mult * 255;
        var g = (color >> 1 & 1) * mult * 255;
        var b = (color >> 2 & 1) * mult * 255;
        return [r, g, b];
      };
      convert.ansi256.rgb = function (args) {
        if (args >= 232) {
          var c = (args - 232) * 10 + 8;
          return [c, c, c];
        }
        args -= 16;
        var rem;
        var r = Math.floor(args / 36) / 5 * 255;
        var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
        var b = rem % 6 / 5 * 255;
        return [r, g, b];
      };
      convert.rgb.hex = function (args) {
        var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
        var string = integer.toString(16).toUpperCase();
        return '000000'.substring(string.length) + string;
      };
      convert.hex.rgb = function (args) {
        var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
        if (!match) {
          return [0, 0, 0];
        }
        var colorString = match[0];
        if (match[0].length === 3) {
          colorString = colorString.split('').map(function (_char) {
            return _char + _char;
          }).join('');
        }
        var integer = parseInt(colorString, 16);
        var r = integer >> 16 & 0xFF;
        var g = integer >> 8 & 0xFF;
        var b = integer & 0xFF;
        return [r, g, b];
      };
      convert.rgb.hcg = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var max = Math.max(Math.max(r, g), b);
        var min = Math.min(Math.min(r, g), b);
        var chroma = max - min;
        var grayscale;
        var hue;
        if (chroma < 1) {
          grayscale = min / (1 - chroma);
        } else {
          grayscale = 0;
        }
        if (chroma <= 0) {
          hue = 0;
        } else if (max === r) {
          hue = (g - b) / chroma % 6;
        } else if (max === g) {
          hue = 2 + (b - r) / chroma;
        } else {
          hue = 4 + (r - g) / chroma + 4;
        }
        hue /= 6;
        hue %= 1;
        return [hue * 360, chroma * 100, grayscale * 100];
      };
      convert.hsl.hcg = function (hsl) {
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var c = 1;
        var f = 0;
        if (l < 0.5) {
          c = 2.0 * s * l;
        } else {
          c = 2.0 * s * (1.0 - l);
        }
        if (c < 1.0) {
          f = (l - 0.5 * c) / (1.0 - c);
        }
        return [hsl[0], c * 100, f * 100];
      };
      convert.hsv.hcg = function (hsv) {
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var c = s * v;
        var f = 0;
        if (c < 1.0) {
          f = (v - c) / (1 - c);
        }
        return [hsv[0], c * 100, f * 100];
      };
      convert.hcg.rgb = function (hcg) {
        var h = hcg[0] / 360;
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        if (c === 0.0) {
          return [g * 255, g * 255, g * 255];
        }
        var pure = [0, 0, 0];
        var hi = h % 1 * 6;
        var v = hi % 1;
        var w = 1 - v;
        var mg = 0;
        switch (Math.floor(hi)) {
          case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
          case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
          case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
          case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
          case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
          default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
        }
        mg = (1.0 - c) * g;
        return [(c * pure[0] + mg) * 255, (c * pure[1] + mg) * 255, (c * pure[2] + mg) * 255];
      };
      convert.hcg.hsv = function (hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var v = c + g * (1.0 - c);
        var f = 0;
        if (v > 0.0) {
          f = c / v;
        }
        return [hcg[0], f * 100, v * 100];
      };
      convert.hcg.hsl = function (hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var l = g * (1.0 - c) + 0.5 * c;
        var s = 0;
        if (l > 0.0 && l < 0.5) {
          s = c / (2 * l);
        } else if (l >= 0.5 && l < 1.0) {
          s = c / (2 * (1 - l));
        }
        return [hcg[0], s * 100, l * 100];
      };
      convert.hcg.hwb = function (hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var v = c + g * (1.0 - c);
        return [hcg[0], (v - c) * 100, (1 - v) * 100];
      };
      convert.hwb.hcg = function (hwb) {
        var w = hwb[1] / 100;
        var b = hwb[2] / 100;
        var v = 1 - b;
        var c = v - w;
        var g = 0;
        if (c < 1) {
          g = (v - c) / (1 - c);
        }
        return [hwb[0], c * 100, g * 100];
      };
      convert.apple.rgb = function (apple) {
        return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
      };
      convert.rgb.apple = function (rgb) {
        return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
      };
      convert.gray.rgb = function (args) {
        return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
      };
      convert.gray.hsl = convert.gray.hsv = function (args) {
        return [0, 0, args[0]];
      };
      convert.gray.hwb = function (gray) {
        return [0, 100, gray[0]];
      };
      convert.gray.cmyk = function (gray) {
        return [0, 0, 0, gray[0]];
      };
      convert.gray.lab = function (gray) {
        return [gray[0], 0, 0];
      };
      convert.gray.hex = function (gray) {
        var val = Math.round(gray[0] / 100 * 255) & 0xFF;
        var integer = (val << 16) + (val << 8) + val;
        var string = integer.toString(16).toUpperCase();
        return '000000'.substring(string.length) + string;
      };
      convert.rgb.gray = function (rgb) {
        var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
        return [val / 255 * 100];
      };
    });
    function buildGraph() {
      var graph = {};
      var models = Object.keys(conversions);
      for (var len = models.length, i = 0; i < len; i++) {
        graph[models[i]] = {
          distance: -1,
          parent: null
        };
      }
      return graph;
    }
    function deriveBFS(fromModel) {
      var graph = buildGraph();
      var queue = [fromModel];
      graph[fromModel].distance = 0;
      while (queue.length) {
        var current = queue.pop();
        var adjacents = Object.keys(conversions[current]);
        for (var len = adjacents.length, i = 0; i < len; i++) {
          var adjacent = adjacents[i];
          var node = graph[adjacent];
          if (node.distance === -1) {
            node.distance = graph[current].distance + 1;
            node.parent = current;
            queue.unshift(adjacent);
          }
        }
      }
      return graph;
    }
    function link(from, to) {
      return function (args) {
        return to(from(args));
      };
    }
    function wrapConversion(toModel, graph) {
      var path = [graph[toModel].parent, toModel];
      var fn = conversions[graph[toModel].parent][toModel];
      var cur = graph[toModel].parent;
      while (graph[cur].parent) {
        path.unshift(graph[cur].parent);
        fn = link(conversions[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
      }
      fn.conversion = path;
      return fn;
    }
    var route = function route(fromModel) {
      var graph = deriveBFS(fromModel);
      var conversion = {};
      var models = Object.keys(graph);
      for (var len = models.length, i = 0; i < len; i++) {
        var toModel = models[i];
        var node = graph[toModel];
        if (node.parent === null) {
          continue;
        }
        conversion[toModel] = wrapConversion(toModel, graph);
      }
      return conversion;
    };
    var convert = {};
    var models = Object.keys(conversions);
    function wrapRaw(fn) {
      var wrappedFn = function wrappedFn(args) {
        if (args === undefined || args === null) {
          return args;
        }
        if (arguments.length > 1) {
          args = Array.prototype.slice.call(arguments);
        }
        return fn(args);
      };
      if ('conversion' in fn) {
        wrappedFn.conversion = fn.conversion;
      }
      return wrappedFn;
    }
    function wrapRounded(fn) {
      var wrappedFn = function wrappedFn(args) {
        if (args === undefined || args === null) {
          return args;
        }
        if (arguments.length > 1) {
          args = Array.prototype.slice.call(arguments);
        }
        var result = fn(args);
        if (typeof result === 'object') {
          for (var len = result.length, i = 0; i < len; i++) {
            result[i] = Math.round(result[i]);
          }
        }
        return result;
      };
      if ('conversion' in fn) {
        wrappedFn.conversion = fn.conversion;
      }
      return wrappedFn;
    }
    models.forEach(function (fromModel) {
      convert[fromModel] = {};
      Object.defineProperty(convert[fromModel], 'channels', {
        value: conversions[fromModel].channels
      });
      Object.defineProperty(convert[fromModel], 'labels', {
        value: conversions[fromModel].labels
      });
      var routes = route(fromModel);
      var routeModels = Object.keys(routes);
      routeModels.forEach(function (toModel) {
        var fn = routes[toModel];
        convert[fromModel][toModel] = wrapRounded(fn);
        convert[fromModel][toModel].raw = wrapRaw(fn);
      });
    });
    var colorConvert = convert;
    var colorName$1 = {
      "aliceblue": [240, 248, 255],
      "antiquewhite": [250, 235, 215],
      "aqua": [0, 255, 255],
      "aquamarine": [127, 255, 212],
      "azure": [240, 255, 255],
      "beige": [245, 245, 220],
      "bisque": [255, 228, 196],
      "black": [0, 0, 0],
      "blanchedalmond": [255, 235, 205],
      "blue": [0, 0, 255],
      "blueviolet": [138, 43, 226],
      "brown": [165, 42, 42],
      "burlywood": [222, 184, 135],
      "cadetblue": [95, 158, 160],
      "chartreuse": [127, 255, 0],
      "chocolate": [210, 105, 30],
      "coral": [255, 127, 80],
      "cornflowerblue": [100, 149, 237],
      "cornsilk": [255, 248, 220],
      "crimson": [220, 20, 60],
      "cyan": [0, 255, 255],
      "darkblue": [0, 0, 139],
      "darkcyan": [0, 139, 139],
      "darkgoldenrod": [184, 134, 11],
      "darkgray": [169, 169, 169],
      "darkgreen": [0, 100, 0],
      "darkgrey": [169, 169, 169],
      "darkkhaki": [189, 183, 107],
      "darkmagenta": [139, 0, 139],
      "darkolivegreen": [85, 107, 47],
      "darkorange": [255, 140, 0],
      "darkorchid": [153, 50, 204],
      "darkred": [139, 0, 0],
      "darksalmon": [233, 150, 122],
      "darkseagreen": [143, 188, 143],
      "darkslateblue": [72, 61, 139],
      "darkslategray": [47, 79, 79],
      "darkslategrey": [47, 79, 79],
      "darkturquoise": [0, 206, 209],
      "darkviolet": [148, 0, 211],
      "deeppink": [255, 20, 147],
      "deepskyblue": [0, 191, 255],
      "dimgray": [105, 105, 105],
      "dimgrey": [105, 105, 105],
      "dodgerblue": [30, 144, 255],
      "firebrick": [178, 34, 34],
      "floralwhite": [255, 250, 240],
      "forestgreen": [34, 139, 34],
      "fuchsia": [255, 0, 255],
      "gainsboro": [220, 220, 220],
      "ghostwhite": [248, 248, 255],
      "gold": [255, 215, 0],
      "goldenrod": [218, 165, 32],
      "gray": [128, 128, 128],
      "green": [0, 128, 0],
      "greenyellow": [173, 255, 47],
      "grey": [128, 128, 128],
      "honeydew": [240, 255, 240],
      "hotpink": [255, 105, 180],
      "indianred": [205, 92, 92],
      "indigo": [75, 0, 130],
      "ivory": [255, 255, 240],
      "khaki": [240, 230, 140],
      "lavender": [230, 230, 250],
      "lavenderblush": [255, 240, 245],
      "lawngreen": [124, 252, 0],
      "lemonchiffon": [255, 250, 205],
      "lightblue": [173, 216, 230],
      "lightcoral": [240, 128, 128],
      "lightcyan": [224, 255, 255],
      "lightgoldenrodyellow": [250, 250, 210],
      "lightgray": [211, 211, 211],
      "lightgreen": [144, 238, 144],
      "lightgrey": [211, 211, 211],
      "lightpink": [255, 182, 193],
      "lightsalmon": [255, 160, 122],
      "lightseagreen": [32, 178, 170],
      "lightskyblue": [135, 206, 250],
      "lightslategray": [119, 136, 153],
      "lightslategrey": [119, 136, 153],
      "lightsteelblue": [176, 196, 222],
      "lightyellow": [255, 255, 224],
      "lime": [0, 255, 0],
      "limegreen": [50, 205, 50],
      "linen": [250, 240, 230],
      "magenta": [255, 0, 255],
      "maroon": [128, 0, 0],
      "mediumaquamarine": [102, 205, 170],
      "mediumblue": [0, 0, 205],
      "mediumorchid": [186, 85, 211],
      "mediumpurple": [147, 112, 219],
      "mediumseagreen": [60, 179, 113],
      "mediumslateblue": [123, 104, 238],
      "mediumspringgreen": [0, 250, 154],
      "mediumturquoise": [72, 209, 204],
      "mediumvioletred": [199, 21, 133],
      "midnightblue": [25, 25, 112],
      "mintcream": [245, 255, 250],
      "mistyrose": [255, 228, 225],
      "moccasin": [255, 228, 181],
      "navajowhite": [255, 222, 173],
      "navy": [0, 0, 128],
      "oldlace": [253, 245, 230],
      "olive": [128, 128, 0],
      "olivedrab": [107, 142, 35],
      "orange": [255, 165, 0],
      "orangered": [255, 69, 0],
      "orchid": [218, 112, 214],
      "palegoldenrod": [238, 232, 170],
      "palegreen": [152, 251, 152],
      "paleturquoise": [175, 238, 238],
      "palevioletred": [219, 112, 147],
      "papayawhip": [255, 239, 213],
      "peachpuff": [255, 218, 185],
      "peru": [205, 133, 63],
      "pink": [255, 192, 203],
      "plum": [221, 160, 221],
      "powderblue": [176, 224, 230],
      "purple": [128, 0, 128],
      "rebeccapurple": [102, 51, 153],
      "red": [255, 0, 0],
      "rosybrown": [188, 143, 143],
      "royalblue": [65, 105, 225],
      "saddlebrown": [139, 69, 19],
      "salmon": [250, 128, 114],
      "sandybrown": [244, 164, 96],
      "seagreen": [46, 139, 87],
      "seashell": [255, 245, 238],
      "sienna": [160, 82, 45],
      "silver": [192, 192, 192],
      "skyblue": [135, 206, 235],
      "slateblue": [106, 90, 205],
      "slategray": [112, 128, 144],
      "slategrey": [112, 128, 144],
      "snow": [255, 250, 250],
      "springgreen": [0, 255, 127],
      "steelblue": [70, 130, 180],
      "tan": [210, 180, 140],
      "teal": [0, 128, 128],
      "thistle": [216, 191, 216],
      "tomato": [255, 99, 71],
      "turquoise": [64, 224, 208],
      "violet": [238, 130, 238],
      "wheat": [245, 222, 179],
      "white": [255, 255, 255],
      "whitesmoke": [245, 245, 245],
      "yellow": [255, 255, 0],
      "yellowgreen": [154, 205, 50]
    };
    var colorString = {
      getRgba: getRgba,
      getHsla: getHsla,
      getRgb: getRgb,
      getHsl: getHsl,
      getHwb: getHwb,
      getAlpha: getAlpha,
      hexString: hexString,
      rgbString: rgbString,
      rgbaString: rgbaString,
      percentString: percentString,
      percentaString: percentaString,
      hslString: hslString,
      hslaString: hslaString,
      hwbString: hwbString,
      keyword: keyword
    };
    function getRgba(string) {
      if (!string) {
        return;
      }
      var abbr = /^#([a-fA-F0-9]{3,4})$/i,
        hex = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
        rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
        per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
        keyword = /(\w+)/;
      var rgb = [0, 0, 0],
        a = 1,
        match = string.match(abbr),
        hexAlpha = "";
      if (match) {
        match = match[1];
        hexAlpha = match[3];
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = parseInt(match[i] + match[i], 16);
        }
        if (hexAlpha) {
          a = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
        }
      } else if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
        }
        if (hexAlpha) {
          a = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
        }
      } else if (match = string.match(rgba)) {
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = parseInt(match[i + 1]);
        }
        a = parseFloat(match[4]);
      } else if (match = string.match(per)) {
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        }
        a = parseFloat(match[4]);
      } else if (match = string.match(keyword)) {
        if (match[1] == "transparent") {
          return [0, 0, 0, 0];
        }
        rgb = colorName$1[match[1]];
        if (!rgb) {
          return;
        }
      }
      for (var i = 0; i < rgb.length; i++) {
        rgb[i] = scale(rgb[i], 0, 255);
      }
      if (!a && a != 0) {
        a = 1;
      } else {
        a = scale(a, 0, 1);
      }
      rgb[3] = a;
      return rgb;
    }
    function getHsla(string) {
      if (!string) {
        return;
      }
      var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
      var match = string.match(hsl);
      if (match) {
        var alpha = parseFloat(match[4]);
        var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [h, s, l, a];
      }
    }
    function getHwb(string) {
      if (!string) {
        return;
      }
      var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
      var match = string.match(hwb);
      if (match) {
        var alpha = parseFloat(match[4]);
        var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [h, w, b, a];
      }
    }
    function getRgb(string) {
      var rgba = getRgba(string);
      return rgba && rgba.slice(0, 3);
    }
    function getHsl(string) {
      var hsla = getHsla(string);
      return hsla && hsla.slice(0, 3);
    }
    function getAlpha(string) {
      var vals = getRgba(string);
      if (vals) {
        return vals[3];
      } else if (vals = getHsla(string)) {
        return vals[3];
      } else if (vals = getHwb(string)) {
        return vals[3];
      }
    }
    function hexString(rgba, a) {
      var a = a !== undefined && rgba.length === 3 ? a : rgba[3];
      return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (a >= 0 && a < 1 ? hexDouble(Math.round(a * 255)) : "");
    }
    function rgbString(rgba, alpha) {
      if (alpha < 1 || rgba[3] && rgba[3] < 1) {
        return rgbaString(rgba, alpha);
      }
      return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
    }
    function rgbaString(rgba, alpha) {
      if (alpha === undefined) {
        alpha = rgba[3] !== undefined ? rgba[3] : 1;
      }
      return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
    }
    function percentString(rgba, alpha) {
      if (alpha < 1 || rgba[3] && rgba[3] < 1) {
        return percentaString(rgba, alpha);
      }
      var r = Math.round(rgba[0] / 255 * 100),
        g = Math.round(rgba[1] / 255 * 100),
        b = Math.round(rgba[2] / 255 * 100);
      return "rgb(" + r + "%, " + g + "%, " + b + "%)";
    }
    function percentaString(rgba, alpha) {
      var r = Math.round(rgba[0] / 255 * 100),
        g = Math.round(rgba[1] / 255 * 100),
        b = Math.round(rgba[2] / 255 * 100);
      return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
    }
    function hslString(hsla, alpha) {
      if (alpha < 1 || hsla[3] && hsla[3] < 1) {
        return hslaString(hsla, alpha);
      }
      return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
    }
    function hslaString(hsla, alpha) {
      if (alpha === undefined) {
        alpha = hsla[3] !== undefined ? hsla[3] : 1;
      }
      return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
    }
    function hwbString(hwb, alpha) {
      if (alpha === undefined) {
        alpha = hwb[3] !== undefined ? hwb[3] : 1;
      }
      return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
    }
    function keyword(rgb) {
      return reverseNames[rgb.slice(0, 3)];
    }
    function scale(num, min, max) {
      return Math.min(Math.max(min, num), max);
    }
    function hexDouble(num) {
      var str = num.toString(16).toUpperCase();
      return str.length < 2 ? "0" + str : str;
    }
    var reverseNames = {};
    for (var name in colorName$1) {
      reverseNames[colorName$1[name]] = name;
    }
    var Color = function Color(obj) {
      if (obj instanceof Color) {
        return obj;
      }
      if (!(this instanceof Color)) {
        return new Color(obj);
      }
      this.valid = false;
      this.values = {
        rgb: [0, 0, 0],
        hsl: [0, 0, 0],
        hsv: [0, 0, 0],
        hwb: [0, 0, 0],
        cmyk: [0, 0, 0, 0],
        alpha: 1
      };
      var vals;
      if (typeof obj === 'string') {
        vals = colorString.getRgba(obj);
        if (vals) {
          this.setValues('rgb', vals);
        } else if (vals = colorString.getHsla(obj)) {
          this.setValues('hsl', vals);
        } else if (vals = colorString.getHwb(obj)) {
          this.setValues('hwb', vals);
        }
      } else if (typeof obj === 'object') {
        vals = obj;
        if (vals.r !== undefined || vals.red !== undefined) {
          this.setValues('rgb', vals);
        } else if (vals.l !== undefined || vals.lightness !== undefined) {
          this.setValues('hsl', vals);
        } else if (vals.v !== undefined || vals.value !== undefined) {
          this.setValues('hsv', vals);
        } else if (vals.w !== undefined || vals.whiteness !== undefined) {
          this.setValues('hwb', vals);
        } else if (vals.c !== undefined || vals.cyan !== undefined) {
          this.setValues('cmyk', vals);
        }
      }
    };
    Color.prototype = {
      isValid: function isValid() {
        return this.valid;
      },
      rgb: function rgb() {
        return this.setSpace('rgb', arguments);
      },
      hsl: function hsl() {
        return this.setSpace('hsl', arguments);
      },
      hsv: function hsv() {
        return this.setSpace('hsv', arguments);
      },
      hwb: function hwb() {
        return this.setSpace('hwb', arguments);
      },
      cmyk: function cmyk() {
        return this.setSpace('cmyk', arguments);
      },
      rgbArray: function rgbArray() {
        return this.values.rgb;
      },
      hslArray: function hslArray() {
        return this.values.hsl;
      },
      hsvArray: function hsvArray() {
        return this.values.hsv;
      },
      hwbArray: function hwbArray() {
        var values = this.values;
        if (values.alpha !== 1) {
          return values.hwb.concat([values.alpha]);
        }
        return values.hwb;
      },
      cmykArray: function cmykArray() {
        return this.values.cmyk;
      },
      rgbaArray: function rgbaArray() {
        var values = this.values;
        return values.rgb.concat([values.alpha]);
      },
      hslaArray: function hslaArray() {
        var values = this.values;
        return values.hsl.concat([values.alpha]);
      },
      alpha: function alpha(val) {
        if (val === undefined) {
          return this.values.alpha;
        }
        this.setValues('alpha', val);
        return this;
      },
      red: function red(val) {
        return this.setChannel('rgb', 0, val);
      },
      green: function green(val) {
        return this.setChannel('rgb', 1, val);
      },
      blue: function blue(val) {
        return this.setChannel('rgb', 2, val);
      },
      hue: function hue(val) {
        if (val) {
          val %= 360;
          val = val < 0 ? 360 + val : val;
        }
        return this.setChannel('hsl', 0, val);
      },
      saturation: function saturation(val) {
        return this.setChannel('hsl', 1, val);
      },
      lightness: function lightness(val) {
        return this.setChannel('hsl', 2, val);
      },
      saturationv: function saturationv(val) {
        return this.setChannel('hsv', 1, val);
      },
      whiteness: function whiteness(val) {
        return this.setChannel('hwb', 1, val);
      },
      blackness: function blackness(val) {
        return this.setChannel('hwb', 2, val);
      },
      value: function value(val) {
        return this.setChannel('hsv', 2, val);
      },
      cyan: function cyan(val) {
        return this.setChannel('cmyk', 0, val);
      },
      magenta: function magenta(val) {
        return this.setChannel('cmyk', 1, val);
      },
      yellow: function yellow(val) {
        return this.setChannel('cmyk', 2, val);
      },
      black: function black(val) {
        return this.setChannel('cmyk', 3, val);
      },
      hexString: function hexString() {
        return colorString.hexString(this.values.rgb);
      },
      rgbString: function rgbString() {
        return colorString.rgbString(this.values.rgb, this.values.alpha);
      },
      rgbaString: function rgbaString() {
        return colorString.rgbaString(this.values.rgb, this.values.alpha);
      },
      percentString: function percentString() {
        return colorString.percentString(this.values.rgb, this.values.alpha);
      },
      hslString: function hslString() {
        return colorString.hslString(this.values.hsl, this.values.alpha);
      },
      hslaString: function hslaString() {
        return colorString.hslaString(this.values.hsl, this.values.alpha);
      },
      hwbString: function hwbString() {
        return colorString.hwbString(this.values.hwb, this.values.alpha);
      },
      keyword: function keyword() {
        return colorString.keyword(this.values.rgb, this.values.alpha);
      },
      rgbNumber: function rgbNumber() {
        var rgb = this.values.rgb;
        return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
      },
      luminosity: function luminosity() {
        var rgb = this.values.rgb;
        var lum = [];
        for (var i = 0; i < rgb.length; i++) {
          var chan = rgb[i] / 255;
          lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
      },
      contrast: function contrast(color2) {
        var lum1 = this.luminosity();
        var lum2 = color2.luminosity();
        if (lum1 > lum2) {
          return (lum1 + 0.05) / (lum2 + 0.05);
        }
        return (lum2 + 0.05) / (lum1 + 0.05);
      },
      level: function level(color2) {
        var contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7.1) {
          return 'AAA';
        }
        return contrastRatio >= 4.5 ? 'AA' : '';
      },
      dark: function dark() {
        var rgb = this.values.rgb;
        var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return yiq < 128;
      },
      light: function light() {
        return !this.dark();
      },
      negate: function negate() {
        var rgb = [];
        for (var i = 0; i < 3; i++) {
          rgb[i] = 255 - this.values.rgb[i];
        }
        this.setValues('rgb', rgb);
        return this;
      },
      lighten: function lighten(ratio) {
        var hsl = this.values.hsl;
        hsl[2] += hsl[2] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      darken: function darken(ratio) {
        var hsl = this.values.hsl;
        hsl[2] -= hsl[2] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      saturate: function saturate(ratio) {
        var hsl = this.values.hsl;
        hsl[1] += hsl[1] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      desaturate: function desaturate(ratio) {
        var hsl = this.values.hsl;
        hsl[1] -= hsl[1] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      whiten: function whiten(ratio) {
        var hwb = this.values.hwb;
        hwb[1] += hwb[1] * ratio;
        this.setValues('hwb', hwb);
        return this;
      },
      blacken: function blacken(ratio) {
        var hwb = this.values.hwb;
        hwb[2] += hwb[2] * ratio;
        this.setValues('hwb', hwb);
        return this;
      },
      greyscale: function greyscale() {
        var rgb = this.values.rgb;
        var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        this.setValues('rgb', [val, val, val]);
        return this;
      },
      clearer: function clearer(ratio) {
        var alpha = this.values.alpha;
        this.setValues('alpha', alpha - alpha * ratio);
        return this;
      },
      opaquer: function opaquer(ratio) {
        var alpha = this.values.alpha;
        this.setValues('alpha', alpha + alpha * ratio);
        return this;
      },
      rotate: function rotate(degrees) {
        var hsl = this.values.hsl;
        var hue = (hsl[0] + degrees) % 360;
        hsl[0] = hue < 0 ? 360 + hue : hue;
        this.setValues('hsl', hsl);
        return this;
      },
      mix: function mix(mixinColor, weight) {
        var color1 = this;
        var color2 = mixinColor;
        var p = weight === undefined ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = color1.alpha() - color2.alpha();
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
        var w2 = 1 - w1;
        return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
      },
      toJSON: function toJSON() {
        return this.rgb();
      },
      clone: function clone() {
        var result = new Color();
        var source = this.values;
        var target = result.values;
        var value, type;
        for (var prop in source) {
          if (source.hasOwnProperty(prop)) {
            value = source[prop];
            type = {}.toString.call(value);
            if (type === '[object Array]') {
              target[prop] = value.slice(0);
            } else if (type === '[object Number]') {
              target[prop] = value;
            } else {
              console.error('unexpected color value:', value);
            }
          }
        }
        return result;
      }
    };
    Color.prototype.spaces = {
      rgb: ['red', 'green', 'blue'],
      hsl: ['hue', 'saturation', 'lightness'],
      hsv: ['hue', 'saturation', 'value'],
      hwb: ['hue', 'whiteness', 'blackness'],
      cmyk: ['cyan', 'magenta', 'yellow', 'black']
    };
    Color.prototype.maxes = {
      rgb: [255, 255, 255],
      hsl: [360, 100, 100],
      hsv: [360, 100, 100],
      hwb: [360, 100, 100],
      cmyk: [100, 100, 100, 100]
    };
    Color.prototype.getValues = function (space) {
      var values = this.values;
      var vals = {};
      for (var i = 0; i < space.length; i++) {
        vals[space.charAt(i)] = values[space][i];
      }
      if (values.alpha !== 1) {
        vals.a = values.alpha;
      }
      return vals;
    };
    Color.prototype.setValues = function (space, vals) {
      var values = this.values;
      var spaces = this.spaces;
      var maxes = this.maxes;
      var alpha = 1;
      var i;
      this.valid = true;
      if (space === 'alpha') {
        alpha = vals;
      } else if (vals.length) {
        values[space] = vals.slice(0, space.length);
        alpha = vals[space.length];
      } else if (vals[space.charAt(0)] !== undefined) {
        for (i = 0; i < space.length; i++) {
          values[space][i] = vals[space.charAt(i)];
        }
        alpha = vals.a;
      } else if (vals[spaces[space][0]] !== undefined) {
        var chans = spaces[space];
        for (i = 0; i < space.length; i++) {
          values[space][i] = vals[chans[i]];
        }
        alpha = vals.alpha;
      }
      values.alpha = Math.max(0, Math.min(1, alpha === undefined ? values.alpha : alpha));
      if (space === 'alpha') {
        return false;
      }
      var capped;
      for (i = 0; i < space.length; i++) {
        capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
        values[space][i] = Math.round(capped);
      }
      for (var sname in spaces) {
        if (sname !== space) {
          values[sname] = colorConvert[space][sname](values[space]);
        }
      }
      return true;
    };
    Color.prototype.setSpace = function (space, args) {
      var vals = args[0];
      if (vals === undefined) {
        return this.getValues(space);
      }
      if (typeof vals === 'number') {
        vals = Array.prototype.slice.call(args);
      }
      this.setValues(space, vals);
      return this;
    };
    Color.prototype.setChannel = function (space, index, val) {
      var svalues = this.values[space];
      if (val === undefined) {
        return svalues[index];
      } else if (val === svalues[index]) {
        return this;
      }
      svalues[index] = val;
      this.setValues(space, svalues);
      return this;
    };
    if (typeof window !== 'undefined') {
      window.Color = Color;
    }
    var chartjsColor = Color;
    function isValidKey(key) {
      return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
    }
    var helpers = {
      noop: function noop() {},
      uid: function () {
        var id = 0;
        return function () {
          return id++;
        };
      }(),
      isNullOrUndef: function isNullOrUndef(value) {
        return value === null || typeof value === 'undefined';
      },
      isArray: function isArray(value) {
        if (Array.isArray && Array.isArray(value)) {
          return true;
        }
        var type = Object.prototype.toString.call(value);
        if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
          return true;
        }
        return false;
      },
      isObject: function isObject(value) {
        return value !== null && Object.prototype.toString.call(value) === '[object Object]';
      },
      isFinite: function (_isFinite) {
        function isFinite(_x) {
          return _isFinite.apply(this, arguments);
        }
        isFinite.toString = function () {
          return _isFinite.toString();
        };
        return isFinite;
      }(function (value) {
        return (typeof value === 'number' || value instanceof Number) && isFinite(value);
      }),
      valueOrDefault: function valueOrDefault(value, defaultValue) {
        return typeof value === 'undefined' ? defaultValue : value;
      },
      valueAtIndexOrDefault: function valueAtIndexOrDefault(value, index, defaultValue) {
        return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
      },
      callback: function callback(fn, args, thisArg) {
        if (fn && typeof fn.call === 'function') {
          return fn.apply(thisArg, args);
        }
      },
      each: function each(loopable, fn, thisArg, reverse) {
        var i, len, keys;
        if (helpers.isArray(loopable)) {
          len = loopable.length;
          if (reverse) {
            for (i = len - 1; i >= 0; i--) {
              fn.call(thisArg, loopable[i], i);
            }
          } else {
            for (i = 0; i < len; i++) {
              fn.call(thisArg, loopable[i], i);
            }
          }
        } else if (helpers.isObject(loopable)) {
          keys = Object.keys(loopable);
          len = keys.length;
          for (i = 0; i < len; i++) {
            fn.call(thisArg, loopable[keys[i]], keys[i]);
          }
        }
      },
      arrayEquals: function arrayEquals(a0, a1) {
        var i, ilen, v0, v1;
        if (!a0 || !a1 || a0.length !== a1.length) {
          return false;
        }
        for (i = 0, ilen = a0.length; i < ilen; ++i) {
          v0 = a0[i];
          v1 = a1[i];
          if (v0 instanceof Array && v1 instanceof Array) {
            if (!helpers.arrayEquals(v0, v1)) {
              return false;
            }
          } else if (v0 !== v1) {
            return false;
          }
        }
        return true;
      },
      clone: function clone(source) {
        if (helpers.isArray(source)) {
          return source.map(helpers.clone);
        }
        if (helpers.isObject(source)) {
          var target = Object.create(source);
          var keys = Object.keys(source);
          var klen = keys.length;
          var k = 0;
          for (; k < klen; ++k) {
            target[keys[k]] = helpers.clone(source[keys[k]]);
          }
          return target;
        }
        return source;
      },
      _merger: function _merger(key, target, source, options) {
        if (!isValidKey(key)) {
          return;
        }
        var tval = target[key];
        var sval = source[key];
        if (helpers.isObject(tval) && helpers.isObject(sval)) {
          helpers.merge(tval, sval, options);
        } else {
          target[key] = helpers.clone(sval);
        }
      },
      _mergerIf: function _mergerIf(key, target, source) {
        if (!isValidKey(key)) {
          return;
        }
        var tval = target[key];
        var sval = source[key];
        if (helpers.isObject(tval) && helpers.isObject(sval)) {
          helpers.mergeIf(tval, sval);
        } else if (!target.hasOwnProperty(key)) {
          target[key] = helpers.clone(sval);
        }
      },
      merge: function merge(target, source, options) {
        var sources = helpers.isArray(source) ? source : [source];
        var ilen = sources.length;
        var merge, i, keys, klen, k;
        if (!helpers.isObject(target)) {
          return target;
        }
        options = options || {};
        merge = options.merger || helpers._merger;
        for (i = 0; i < ilen; ++i) {
          source = sources[i];
          if (!helpers.isObject(source)) {
            continue;
          }
          keys = Object.keys(source);
          for (k = 0, klen = keys.length; k < klen; ++k) {
            merge(keys[k], target, source, options);
          }
        }
        return target;
      },
      mergeIf: function mergeIf(target, source) {
        return helpers.merge(target, source, {
          merger: helpers._mergerIf
        });
      },
      extend: Object.assign || function (target) {
        return helpers.merge(target, [].slice.call(arguments, 1), {
          merger: function merger(key, dst, src) {
            dst[key] = src[key];
          }
        });
      },
      inherits: function inherits(extensions) {
        var me = this;
        var ChartElement = extensions && extensions.hasOwnProperty('constructor') ? extensions.constructor : function () {
          return me.apply(this, arguments);
        };
        var Surrogate = function Surrogate() {
          this.constructor = ChartElement;
        };
        Surrogate.prototype = me.prototype;
        ChartElement.prototype = new Surrogate();
        ChartElement.extend = helpers.inherits;
        if (extensions) {
          helpers.extend(ChartElement.prototype, extensions);
        }
        ChartElement.__super__ = me.prototype;
        return ChartElement;
      },
      _deprecated: function _deprecated(scope, value, previous, current) {
        if (value !== undefined) {
          console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
        }
      }
    };
    var helpers_core = helpers;
    helpers.callCallback = helpers.callback;
    helpers.indexOf = function (array, item, fromIndex) {
      return Array.prototype.indexOf.call(array, item, fromIndex);
    };
    helpers.getValueOrDefault = helpers.valueOrDefault;
    helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
    var effects = {
      linear: function linear(t) {
        return t;
      },
      easeInQuad: function easeInQuad(t) {
        return t * t;
      },
      easeOutQuad: function easeOutQuad(t) {
        return -t * (t - 2);
      },
      easeInOutQuad: function easeInOutQuad(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t;
        }
        return -0.5 * (--t * (t - 2) - 1);
      },
      easeInCubic: function easeInCubic(t) {
        return t * t * t;
      },
      easeOutCubic: function easeOutCubic(t) {
        return (t = t - 1) * t * t + 1;
      },
      easeInOutCubic: function easeInOutCubic(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t * t;
        }
        return 0.5 * ((t -= 2) * t * t + 2);
      },
      easeInQuart: function easeInQuart(t) {
        return t * t * t * t;
      },
      easeOutQuart: function easeOutQuart(t) {
        return -((t = t - 1) * t * t * t - 1);
      },
      easeInOutQuart: function easeInOutQuart(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t * t * t;
        }
        return -0.5 * ((t -= 2) * t * t * t - 2);
      },
      easeInQuint: function easeInQuint(t) {
        return t * t * t * t * t;
      },
      easeOutQuint: function easeOutQuint(t) {
        return (t = t - 1) * t * t * t * t + 1;
      },
      easeInOutQuint: function easeInOutQuint(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t * t * t * t;
        }
        return 0.5 * ((t -= 2) * t * t * t * t + 2);
      },
      easeInSine: function easeInSine(t) {
        return -Math.cos(t * (Math.PI / 2)) + 1;
      },
      easeOutSine: function easeOutSine(t) {
        return Math.sin(t * (Math.PI / 2));
      },
      easeInOutSine: function easeInOutSine(t) {
        return -0.5 * (Math.cos(Math.PI * t) - 1);
      },
      easeInExpo: function easeInExpo(t) {
        return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
      },
      easeOutExpo: function easeOutExpo(t) {
        return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
      },
      easeInOutExpo: function easeInOutExpo(t) {
        if (t === 0) {
          return 0;
        }
        if (t === 1) {
          return 1;
        }
        if ((t /= 0.5) < 1) {
          return 0.5 * Math.pow(2, 10 * (t - 1));
        }
        return 0.5 * (-Math.pow(2, -10 * --t) + 2);
      },
      easeInCirc: function easeInCirc(t) {
        if (t >= 1) {
          return t;
        }
        return -(Math.sqrt(1 - t * t) - 1);
      },
      easeOutCirc: function easeOutCirc(t) {
        return Math.sqrt(1 - (t = t - 1) * t);
      },
      easeInOutCirc: function easeInOutCirc(t) {
        if ((t /= 0.5) < 1) {
          return -0.5 * (Math.sqrt(1 - t * t) - 1);
        }
        return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
      },
      easeInElastic: function easeInElastic(t) {
        var s = 1.70158;
        var p = 0;
        var a = 1;
        if (t === 0) {
          return 0;
        }
        if (t === 1) {
          return 1;
        }
        if (!p) {
          p = 0.3;
        }
        {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
      },
      easeOutElastic: function easeOutElastic(t) {
        var s = 1.70158;
        var p = 0;
        var a = 1;
        if (t === 0) {
          return 0;
        }
        if (t === 1) {
          return 1;
        }
        if (!p) {
          p = 0.3;
        }
        {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
      },
      easeInOutElastic: function easeInOutElastic(t) {
        var s = 1.70158;
        var p = 0;
        var a = 1;
        if (t === 0) {
          return 0;
        }
        if ((t /= 0.5) === 2) {
          return 1;
        }
        if (!p) {
          p = 0.45;
        }
        {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        if (t < 1) {
          return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
        }
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
      },
      easeInBack: function easeInBack(t) {
        var s = 1.70158;
        return t * t * ((s + 1) * t - s);
      },
      easeOutBack: function easeOutBack(t) {
        var s = 1.70158;
        return (t = t - 1) * t * ((s + 1) * t + s) + 1;
      },
      easeInOutBack: function easeInOutBack(t) {
        var s = 1.70158;
        if ((t /= 0.5) < 1) {
          return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        }
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
      },
      easeInBounce: function easeInBounce(t) {
        return 1 - effects.easeOutBounce(1 - t);
      },
      easeOutBounce: function easeOutBounce(t) {
        if (t < 1 / 2.75) {
          return 7.5625 * t * t;
        }
        if (t < 2 / 2.75) {
          return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
        }
        if (t < 2.5 / 2.75) {
          return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
        }
        return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
      },
      easeInOutBounce: function easeInOutBounce(t) {
        if (t < 0.5) {
          return effects.easeInBounce(t * 2) * 0.5;
        }
        return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
      }
    };
    var helpers_easing = {
      effects: effects
    };
    helpers_core.easingEffects = effects;
    var PI = Math.PI;
    var RAD_PER_DEG = PI / 180;
    var DOUBLE_PI = PI * 2;
    var HALF_PI = PI / 2;
    var QUARTER_PI = PI / 4;
    var TWO_THIRDS_PI = PI * 2 / 3;
    var exports$1 = {
      clear: function clear(chart) {
        chart.ctx.clearRect(0, 0, chart.width, chart.height);
      },
      roundedRect: function roundedRect(ctx, x, y, width, height, radius) {
        if (radius) {
          var r = Math.min(radius, height / 2, width / 2);
          var left = x + r;
          var top = y + r;
          var right = x + width - r;
          var bottom = y + height - r;
          ctx.moveTo(x, top);
          if (left < right && top < bottom) {
            ctx.arc(left, top, r, -PI, -HALF_PI);
            ctx.arc(right, top, r, -HALF_PI, 0);
            ctx.arc(right, bottom, r, 0, HALF_PI);
            ctx.arc(left, bottom, r, HALF_PI, PI);
          } else if (left < right) {
            ctx.moveTo(left, y);
            ctx.arc(right, top, r, -HALF_PI, HALF_PI);
            ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
          } else if (top < bottom) {
            ctx.arc(left, top, r, -PI, 0);
            ctx.arc(left, bottom, r, 0, PI);
          } else {
            ctx.arc(left, top, r, -PI, PI);
          }
          ctx.closePath();
          ctx.moveTo(x, y);
        } else {
          ctx.rect(x, y, width, height);
        }
      },
      drawPoint: function drawPoint(ctx, style, radius, x, y, rotation) {
        var type, xOffset, yOffset, size, cornerRadius;
        var rad = (rotation || 0) * RAD_PER_DEG;
        if (style && typeof style === 'object') {
          type = style.toString();
          if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
          }
        }
        if (isNaN(radius) || radius <= 0) {
          return;
        }
        ctx.beginPath();
        switch (style) {
          default:
            ctx.arc(x, y, radius, 0, DOUBLE_PI);
            ctx.closePath();
            break;
          case 'triangle':
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
          case 'rectRounded':
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + QUARTER_PI) * size;
            yOffset = Math.sin(rad + QUARTER_PI) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
            ctx.closePath();
            break;
          case 'rect':
            if (!rotation) {
              size = Math.SQRT1_2 * radius;
              ctx.rect(x - size, y - size, 2 * size, 2 * size);
              break;
            }
            rad += QUARTER_PI;
          case 'rectRot':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
          case 'crossRot':
            rad += QUARTER_PI;
          case 'cross':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
          case 'star':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += QUARTER_PI;
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
          case 'line':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
          case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
        }
        ctx.fill();
        ctx.stroke();
      },
      _isPointInArea: function _isPointInArea(point, area) {
        var epsilon = 1e-6;
        return point.x > area.left - epsilon && point.x < area.right + epsilon && point.y > area.top - epsilon && point.y < area.bottom + epsilon;
      },
      clipArea: function clipArea(ctx, area) {
        ctx.save();
        ctx.beginPath();
        ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
        ctx.clip();
      },
      unclipArea: function unclipArea(ctx) {
        ctx.restore();
      },
      lineTo: function lineTo(ctx, previous, target, flip) {
        var stepped = target.steppedLine;
        if (stepped) {
          if (stepped === 'middle') {
            var midpoint = (previous.x + target.x) / 2.0;
            ctx.lineTo(midpoint, flip ? target.y : previous.y);
            ctx.lineTo(midpoint, flip ? previous.y : target.y);
          } else if (stepped === 'after' && !flip || stepped !== 'after' && flip) {
            ctx.lineTo(previous.x, target.y);
          } else {
            ctx.lineTo(target.x, previous.y);
          }
          ctx.lineTo(target.x, target.y);
          return;
        }
        if (!target.tension) {
          ctx.lineTo(target.x, target.y);
          return;
        }
        ctx.bezierCurveTo(flip ? previous.controlPointPreviousX : previous.controlPointNextX, flip ? previous.controlPointPreviousY : previous.controlPointNextY, flip ? target.controlPointNextX : target.controlPointPreviousX, flip ? target.controlPointNextY : target.controlPointPreviousY, target.x, target.y);
      }
    };
    var helpers_canvas = exports$1;
    helpers_core.clear = exports$1.clear;
    helpers_core.drawRoundedRectangle = function (ctx) {
      ctx.beginPath();
      exports$1.roundedRect.apply(exports$1, arguments);
    };
    var defaults = {
      _set: function _set(scope, values) {
        return helpers_core.merge(this[scope] || (this[scope] = {}), values);
      }
    };
    defaults._set('global', {
      defaultColor: 'rgba(0,0,0,0.1)',
      defaultFontColor: '#666',
      defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      defaultFontSize: 12,
      defaultFontStyle: 'normal',
      defaultLineHeight: 1.2,
      showLines: true
    });
    var core_defaults = defaults;
    var valueOrDefault = helpers_core.valueOrDefault;
    function toFontString(font) {
      if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
        return null;
      }
      return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
    }
    var helpers_options = {
      toLineHeight: function toLineHeight(value, size) {
        var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
        if (!matches || matches[1] === 'normal') {
          return size * 1.2;
        }
        value = +matches[2];
        switch (matches[3]) {
          case 'px':
            return value;
          case '%':
            value /= 100;
            break;
        }
        return size * value;
      },
      toPadding: function toPadding(value) {
        var t, r, b, l;
        if (helpers_core.isObject(value)) {
          t = +value.top || 0;
          r = +value.right || 0;
          b = +value.bottom || 0;
          l = +value.left || 0;
        } else {
          t = r = b = l = +value || 0;
        }
        return {
          top: t,
          right: r,
          bottom: b,
          left: l,
          height: t + b,
          width: l + r
        };
      },
      _parseFont: function _parseFont(options) {
        var globalDefaults = core_defaults.global;
        var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
        var font = {
          family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
          lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
          size: size,
          style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
          weight: null,
          string: ''
        };
        font.string = toFontString(font);
        return font;
      },
      resolve: function resolve(inputs, context, index, info) {
        var cacheable = true;
        var i, ilen, value;
        for (i = 0, ilen = inputs.length; i < ilen; ++i) {
          value = inputs[i];
          if (value === undefined) {
            continue;
          }
          if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
          }
          if (index !== undefined && helpers_core.isArray(value)) {
            value = value[index];
            cacheable = false;
          }
          if (value !== undefined) {
            if (info && !cacheable) {
              info.cacheable = false;
            }
            return value;
          }
        }
      }
    };
    var exports$2 = {
      _factorize: function _factorize(value) {
        var result = [];
        var sqrt = Math.sqrt(value);
        var i;
        for (i = 1; i < sqrt; i++) {
          if (value % i === 0) {
            result.push(i);
            result.push(value / i);
          }
        }
        if (sqrt === (sqrt | 0)) {
          result.push(sqrt);
        }
        result.sort(function (a, b) {
          return a - b;
        }).pop();
        return result;
      },
      log10: Math.log10 || function (x) {
        var exponent = Math.log(x) * Math.LOG10E;
        var powerOf10 = Math.round(exponent);
        var isPowerOf10 = x === Math.pow(10, powerOf10);
        return isPowerOf10 ? powerOf10 : exponent;
      }
    };
    var helpers_math = exports$2;
    helpers_core.log10 = exports$2.log10;
    var getRtlAdapter = function getRtlAdapter(rectX, width) {
      return {
        x: function x(_x2) {
          return rectX + rectX + width - _x2;
        },
        setWidth: function setWidth(w) {
          width = w;
        },
        textAlign: function textAlign(align) {
          if (align === 'center') {
            return align;
          }
          return align === 'right' ? 'left' : 'right';
        },
        xPlus: function xPlus(x, value) {
          return x - value;
        },
        leftForLtr: function leftForLtr(x, itemWidth) {
          return x - itemWidth;
        }
      };
    };
    var getLtrAdapter = function getLtrAdapter() {
      return {
        x: function x(_x3) {
          return _x3;
        },
        setWidth: function setWidth(w) {},
        textAlign: function textAlign(align) {
          return align;
        },
        xPlus: function xPlus(x, value) {
          return x + value;
        },
        leftForLtr: function leftForLtr(x, _itemWidth) {
          return x;
        }
      };
    };
    var getAdapter = function getAdapter(rtl, rectX, width) {
      return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
    };
    var overrideTextDirection = function overrideTextDirection(ctx, direction) {
      var style, original;
      if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [style.getPropertyValue('direction'), style.getPropertyPriority('direction')];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
      }
    };
    var restoreTextDirection = function restoreTextDirection(ctx) {
      var original = ctx.prevTextDirection;
      if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
      }
    };
    var helpers_rtl = {
      getRtlAdapter: getAdapter,
      overrideTextDirection: overrideTextDirection,
      restoreTextDirection: restoreTextDirection
    };
    var helpers$1 = helpers_core;
    var easing = helpers_easing;
    var canvas = helpers_canvas;
    var options = helpers_options;
    var math = helpers_math;
    var rtl = helpers_rtl;
    helpers$1.easing = easing;
    helpers$1.canvas = canvas;
    helpers$1.options = options;
    helpers$1.math = math;
    helpers$1.rtl = rtl;
    function interpolate(start, view, model, ease) {
      var keys = Object.keys(model);
      var i, ilen, key, actual, origin, target, type, c0, c1;
      for (i = 0, ilen = keys.length; i < ilen; ++i) {
        key = keys[i];
        target = model[key];
        if (!view.hasOwnProperty(key)) {
          view[key] = target;
        }
        actual = view[key];
        if (actual === target || key[0] === '_') {
          continue;
        }
        if (!start.hasOwnProperty(key)) {
          start[key] = actual;
        }
        origin = start[key];
        type = typeof target;
        if (type === typeof origin) {
          if (type === 'string') {
            c0 = chartjsColor(origin);
            if (c0.valid) {
              c1 = chartjsColor(target);
              if (c1.valid) {
                view[key] = c1.mix(c0, ease).rgbString();
                continue;
              }
            }
          } else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
            view[key] = origin + (target - origin) * ease;
            continue;
          }
        }
        view[key] = target;
      }
    }
    var Element = function Element(configuration) {
      helpers$1.extend(this, configuration);
      this.initialize.apply(this, arguments);
    };
    helpers$1.extend(Element.prototype, {
      _type: undefined,
      initialize: function initialize() {
        this.hidden = false;
      },
      pivot: function pivot() {
        var me = this;
        if (!me._view) {
          me._view = helpers$1.extend({}, me._model);
        }
        me._start = {};
        return me;
      },
      transition: function transition(ease) {
        var me = this;
        var model = me._model;
        var start = me._start;
        var view = me._view;
        if (!model || ease === 1) {
          me._view = helpers$1.extend({}, model);
          me._start = null;
          return me;
        }
        if (!view) {
          view = me._view = {};
        }
        if (!start) {
          start = me._start = {};
        }
        interpolate(start, view, model, ease);
        return me;
      },
      tooltipPosition: function tooltipPosition() {
        return {
          x: this._model.x,
          y: this._model.y
        };
      },
      hasValue: function hasValue() {
        return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
      }
    });
    Element.extend = helpers$1.inherits;
    var core_element = Element;
    var exports$3 = core_element.extend({
      chart: null,
      currentStep: 0,
      numSteps: 60,
      easing: '',
      render: null,
      onAnimationProgress: null,
      onAnimationComplete: null
    });
    var core_animation = exports$3;
    Object.defineProperty(exports$3.prototype, 'animationObject', {
      get: function get() {
        return this;
      }
    });
    Object.defineProperty(exports$3.prototype, 'chartInstance', {
      get: function get() {
        return this.chart;
      },
      set: function set(value) {
        this.chart = value;
      }
    });
    core_defaults._set('global', {
      animation: {
        duration: 1000,
        easing: 'easeOutQuart',
        onProgress: helpers$1.noop,
        onComplete: helpers$1.noop
      }
    });
    var core_animations = {
      animations: [],
      request: null,
      addAnimation: function addAnimation(chart, animation, duration, lazy) {
        var animations = this.animations;
        var i, ilen;
        animation.chart = chart;
        animation.startTime = Date.now();
        animation.duration = duration;
        if (!lazy) {
          chart.animating = true;
        }
        for (i = 0, ilen = animations.length; i < ilen; ++i) {
          if (animations[i].chart === chart) {
            animations[i] = animation;
            return;
          }
        }
        animations.push(animation);
        if (animations.length === 1) {
          this.requestAnimationFrame();
        }
      },
      cancelAnimation: function cancelAnimation(chart) {
        var index = helpers$1.findIndex(this.animations, function (animation) {
          return animation.chart === chart;
        });
        if (index !== -1) {
          this.animations.splice(index, 1);
          chart.animating = false;
        }
      },
      requestAnimationFrame: function requestAnimationFrame() {
        var me = this;
        if (me.request === null) {
          me.request = helpers$1.requestAnimFrame.call(window, function () {
            me.request = null;
            me.startDigest();
          });
        }
      },
      startDigest: function startDigest() {
        var me = this;
        me.advance();
        if (me.animations.length > 0) {
          me.requestAnimationFrame();
        }
      },
      advance: function advance() {
        var animations = this.animations;
        var animation, chart, numSteps, nextStep;
        var i = 0;
        while (i < animations.length) {
          animation = animations[i];
          chart = animation.chart;
          numSteps = animation.numSteps;
          nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
          animation.currentStep = Math.min(nextStep, numSteps);
          helpers$1.callback(animation.render, [chart, animation], chart);
          helpers$1.callback(animation.onAnimationProgress, [animation], chart);
          if (animation.currentStep >= numSteps) {
            helpers$1.callback(animation.onAnimationComplete, [animation], chart);
            chart.animating = false;
            animations.splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    };
    var resolve = helpers$1.options.resolve;
    var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
    function listenArrayEvents(array, listener) {
      if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
      }
      Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
          listeners: [listener]
        }
      });
      arrayEvents.forEach(function (key) {
        var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
        var base = array[key];
        Object.defineProperty(array, key, {
          configurable: true,
          enumerable: false,
          value: function value() {
            var args = Array.prototype.slice.call(arguments);
            var res = base.apply(this, args);
            helpers$1.each(array._chartjs.listeners, function (object) {
              if (typeof object[method] === 'function') {
                object[method].apply(object, args);
              }
            });
            return res;
          }
        });
      });
    }
    function unlistenArrayEvents(array, listener) {
      var stub = array._chartjs;
      if (!stub) {
        return;
      }
      var listeners = stub.listeners;
      var index = listeners.indexOf(listener);
      if (index !== -1) {
        listeners.splice(index, 1);
      }
      if (listeners.length > 0) {
        return;
      }
      arrayEvents.forEach(function (key) {
        delete array[key];
      });
      delete array._chartjs;
    }
    var DatasetController = function DatasetController(chart, datasetIndex) {
      this.initialize(chart, datasetIndex);
    };
    helpers$1.extend(DatasetController.prototype, {
      datasetElementType: null,
      dataElementType: null,
      _datasetElementOptions: ['backgroundColor', 'borderCapStyle', 'borderColor', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'borderWidth'],
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'pointStyle'],
      initialize: function initialize(chart, datasetIndex) {
        var me = this;
        me.chart = chart;
        me.index = datasetIndex;
        me.linkScales();
        me.addElements();
        me._type = me.getMeta().type;
      },
      updateIndex: function updateIndex(datasetIndex) {
        this.index = datasetIndex;
      },
      linkScales: function linkScales() {
        var me = this;
        var meta = me.getMeta();
        var chart = me.chart;
        var scales = chart.scales;
        var dataset = me.getDataset();
        var scalesOpts = chart.options.scales;
        if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
          meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
        }
        if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
          meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
        }
      },
      getDataset: function getDataset() {
        return this.chart.data.datasets[this.index];
      },
      getMeta: function getMeta() {
        return this.chart.getDatasetMeta(this.index);
      },
      getScaleForId: function getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
      },
      _getValueScaleId: function _getValueScaleId() {
        return this.getMeta().yAxisID;
      },
      _getIndexScaleId: function _getIndexScaleId() {
        return this.getMeta().xAxisID;
      },
      _getValueScale: function _getValueScale() {
        return this.getScaleForId(this._getValueScaleId());
      },
      _getIndexScale: function _getIndexScale() {
        return this.getScaleForId(this._getIndexScaleId());
      },
      reset: function reset() {
        this._update(true);
      },
      destroy: function destroy() {
        if (this._data) {
          unlistenArrayEvents(this._data, this);
        }
      },
      createMetaDataset: function createMetaDataset() {
        var me = this;
        var type = me.datasetElementType;
        return type && new type({
          _chart: me.chart,
          _datasetIndex: me.index
        });
      },
      createMetaData: function createMetaData(index) {
        var me = this;
        var type = me.dataElementType;
        return type && new type({
          _chart: me.chart,
          _datasetIndex: me.index,
          _index: index
        });
      },
      addElements: function addElements() {
        var me = this;
        var meta = me.getMeta();
        var data = me.getDataset().data || [];
        var metaData = meta.data;
        var i, ilen;
        for (i = 0, ilen = data.length; i < ilen; ++i) {
          metaData[i] = metaData[i] || me.createMetaData(i);
        }
        meta.dataset = meta.dataset || me.createMetaDataset();
      },
      addElementAndReset: function addElementAndReset(index) {
        var element = this.createMetaData(index);
        this.getMeta().data.splice(index, 0, element);
        this.updateElement(element, index, true);
      },
      buildOrUpdateElements: function buildOrUpdateElements() {
        var me = this;
        var dataset = me.getDataset();
        var data = dataset.data || (dataset.data = []);
        if (me._data !== data) {
          if (me._data) {
            unlistenArrayEvents(me._data, me);
          }
          if (data && Object.isExtensible(data)) {
            listenArrayEvents(data, me);
          }
          me._data = data;
        }
        me.resyncElements();
      },
      _configure: function _configure() {
        var me = this;
        me._config = helpers$1.merge(Object.create(null), [me.chart.options.datasets[me._type], me.getDataset()], {
          merger: function merger(key, target, source) {
            if (key !== '_meta' && key !== 'data') {
              helpers$1._merger(key, target, source);
            }
          }
        });
      },
      _update: function _update(reset) {
        var me = this;
        me._configure();
        me._cachedDataOpts = null;
        me.update(reset);
      },
      update: helpers$1.noop,
      transition: function transition(easingValue) {
        var meta = this.getMeta();
        var elements = meta.data || [];
        var ilen = elements.length;
        var i = 0;
        for (; i < ilen; ++i) {
          elements[i].transition(easingValue);
        }
        if (meta.dataset) {
          meta.dataset.transition(easingValue);
        }
      },
      draw: function draw() {
        var meta = this.getMeta();
        var elements = meta.data || [];
        var ilen = elements.length;
        var i = 0;
        if (meta.dataset) {
          meta.dataset.draw();
        }
        for (; i < ilen; ++i) {
          elements[i].draw();
        }
      },
      getStyle: function getStyle(index) {
        var me = this;
        var meta = me.getMeta();
        var dataset = meta.dataset;
        var style;
        me._configure();
        if (dataset && index === undefined) {
          style = me._resolveDatasetElementOptions(dataset || {});
        } else {
          index = index || 0;
          style = me._resolveDataElementOptions(meta.data[index] || {}, index);
        }
        if (style.fill === false || style.fill === null) {
          style.backgroundColor = style.borderColor;
        }
        return style;
      },
      _resolveDatasetElementOptions: function _resolveDatasetElementOptions(element, hover) {
        var me = this;
        var chart = me.chart;
        var datasetOpts = me._config;
        var custom = element.custom || {};
        var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
        var elementOptions = me._datasetElementOptions;
        var values = {};
        var i, ilen, key, readKey;
        var context = {
          chart: chart,
          dataset: me.getDataset(),
          datasetIndex: me.index,
          hover: hover
        };
        for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
          key = elementOptions[i];
          readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
          values[key] = resolve([custom[readKey], datasetOpts[readKey], options[readKey]], context);
        }
        return values;
      },
      _resolveDataElementOptions: function _resolveDataElementOptions(element, index) {
        var me = this;
        var custom = element && element.custom;
        var cached = me._cachedDataOpts;
        if (cached && !custom) {
          return cached;
        }
        var chart = me.chart;
        var datasetOpts = me._config;
        var options = chart.options.elements[me.dataElementType.prototype._type] || {};
        var elementOptions = me._dataElementOptions;
        var values = {};
        var context = {
          chart: chart,
          dataIndex: index,
          dataset: me.getDataset(),
          datasetIndex: me.index
        };
        var info = {
          cacheable: !custom
        };
        var keys, i, ilen, key;
        custom = custom || {};
        if (helpers$1.isArray(elementOptions)) {
          for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
            key = elementOptions[i];
            values[key] = resolve([custom[key], datasetOpts[key], options[key]], context, index, info);
          }
        } else {
          keys = Object.keys(elementOptions);
          for (i = 0, ilen = keys.length; i < ilen; ++i) {
            key = keys[i];
            values[key] = resolve([custom[key], datasetOpts[elementOptions[key]], datasetOpts[key], options[key]], context, index, info);
          }
        }
        if (info.cacheable) {
          me._cachedDataOpts = Object.freeze(values);
        }
        return values;
      },
      removeHoverStyle: function removeHoverStyle(element) {
        helpers$1.merge(element._model, element.$previousStyle || {});
        delete element.$previousStyle;
      },
      setHoverStyle: function setHoverStyle(element) {
        var dataset = this.chart.data.datasets[element._datasetIndex];
        var index = element._index;
        var custom = element.custom || {};
        var model = element._model;
        var getHoverColor = helpers$1.getHoverColor;
        element.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth
        };
        model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
        model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
        model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
      },
      _removeDatasetHoverStyle: function _removeDatasetHoverStyle() {
        var element = this.getMeta().dataset;
        if (element) {
          this.removeHoverStyle(element);
        }
      },
      _setDatasetHoverStyle: function _setDatasetHoverStyle() {
        var element = this.getMeta().dataset;
        var prev = {};
        var i, ilen, key, keys, hoverOptions, model;
        if (!element) {
          return;
        }
        model = element._model;
        hoverOptions = this._resolveDatasetElementOptions(element, true);
        keys = Object.keys(hoverOptions);
        for (i = 0, ilen = keys.length; i < ilen; ++i) {
          key = keys[i];
          prev[key] = model[key];
          model[key] = hoverOptions[key];
        }
        element.$previousStyle = prev;
      },
      resyncElements: function resyncElements() {
        var me = this;
        var meta = me.getMeta();
        var data = me.getDataset().data;
        var numMeta = meta.data.length;
        var numData = data.length;
        if (numData < numMeta) {
          meta.data.splice(numData, numMeta - numData);
        } else if (numData > numMeta) {
          me.insertElements(numMeta, numData - numMeta);
        }
      },
      insertElements: function insertElements(start, count) {
        for (var i = 0; i < count; ++i) {
          this.addElementAndReset(start + i);
        }
      },
      onDataPush: function onDataPush() {
        var count = arguments.length;
        this.insertElements(this.getDataset().data.length - count, count);
      },
      onDataPop: function onDataPop() {
        this.getMeta().data.pop();
      },
      onDataShift: function onDataShift() {
        this.getMeta().data.shift();
      },
      onDataSplice: function onDataSplice(start, count) {
        this.getMeta().data.splice(start, count);
        this.insertElements(start, arguments.length - 2);
      },
      onDataUnshift: function onDataUnshift() {
        this.insertElements(0, arguments.length);
      }
    });
    DatasetController.extend = helpers$1.inherits;
    var core_datasetController = DatasetController;
    var TAU = Math.PI * 2;
    core_defaults._set('global', {
      elements: {
        arc: {
          backgroundColor: core_defaults.global.defaultColor,
          borderColor: '#fff',
          borderWidth: 2,
          borderAlign: 'center'
        }
      }
    });
    function clipArc(ctx, arc) {
      var startAngle = arc.startAngle;
      var endAngle = arc.endAngle;
      var pixelMargin = arc.pixelMargin;
      var angleMargin = pixelMargin / arc.outerRadius;
      var x = arc.x;
      var y = arc.y;
      ctx.beginPath();
      ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
      if (arc.innerRadius > pixelMargin) {
        angleMargin = pixelMargin / arc.innerRadius;
        ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
      } else {
        ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
      }
      ctx.closePath();
      ctx.clip();
    }
    function drawFullCircleBorders(ctx, vm, arc, inner) {
      var endAngle = arc.endAngle;
      var i;
      if (inner) {
        arc.endAngle = arc.startAngle + TAU;
        clipArc(ctx, arc);
        arc.endAngle = endAngle;
        if (arc.endAngle === arc.startAngle && arc.fullCircles) {
          arc.endAngle += TAU;
          arc.fullCircles--;
        }
      }
      ctx.beginPath();
      ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
      for (i = 0; i < arc.fullCircles; ++i) {
        ctx.stroke();
      }
      ctx.beginPath();
      ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
      for (i = 0; i < arc.fullCircles; ++i) {
        ctx.stroke();
      }
    }
    function drawBorder(ctx, vm, arc) {
      var inner = vm.borderAlign === 'inner';
      if (inner) {
        ctx.lineWidth = vm.borderWidth * 2;
        ctx.lineJoin = 'round';
      } else {
        ctx.lineWidth = vm.borderWidth;
        ctx.lineJoin = 'bevel';
      }
      if (arc.fullCircles) {
        drawFullCircleBorders(ctx, vm, arc, inner);
      }
      if (inner) {
        clipArc(ctx, arc);
      }
      ctx.beginPath();
      ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
      ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
      ctx.closePath();
      ctx.stroke();
    }
    var element_arc = core_element.extend({
      _type: 'arc',
      inLabelRange: function inLabelRange(mouseX) {
        var vm = this._view;
        if (vm) {
          return Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2);
        }
        return false;
      },
      inRange: function inRange(chartX, chartY) {
        var vm = this._view;
        if (vm) {
          var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {
            x: chartX,
            y: chartY
          });
          var angle = pointRelativePosition.angle;
          var distance = pointRelativePosition.distance;
          var startAngle = vm.startAngle;
          var endAngle = vm.endAngle;
          while (endAngle < startAngle) {
            endAngle += TAU;
          }
          while (angle > endAngle) {
            angle -= TAU;
          }
          while (angle < startAngle) {
            angle += TAU;
          }
          var betweenAngles = angle >= startAngle && angle <= endAngle;
          var withinRadius = distance >= vm.innerRadius && distance <= vm.outerRadius;
          return betweenAngles && withinRadius;
        }
        return false;
      },
      getCenterPoint: function getCenterPoint() {
        var vm = this._view;
        var halfAngle = (vm.startAngle + vm.endAngle) / 2;
        var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
        return {
          x: vm.x + Math.cos(halfAngle) * halfRadius,
          y: vm.y + Math.sin(halfAngle) * halfRadius
        };
      },
      getArea: function getArea() {
        var vm = this._view;
        return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
      },
      tooltipPosition: function tooltipPosition() {
        var vm = this._view;
        var centreAngle = vm.startAngle + (vm.endAngle - vm.startAngle) / 2;
        var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
        return {
          x: vm.x + Math.cos(centreAngle) * rangeFromCentre,
          y: vm.y + Math.sin(centreAngle) * rangeFromCentre
        };
      },
      draw: function draw() {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var pixelMargin = vm.borderAlign === 'inner' ? 0.33 : 0;
        var arc = {
          x: vm.x,
          y: vm.y,
          innerRadius: vm.innerRadius,
          outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
          pixelMargin: pixelMargin,
          startAngle: vm.startAngle,
          endAngle: vm.endAngle,
          fullCircles: Math.floor(vm.circumference / TAU)
        };
        var i;
        ctx.save();
        ctx.fillStyle = vm.backgroundColor;
        ctx.strokeStyle = vm.borderColor;
        if (arc.fullCircles) {
          arc.endAngle = arc.startAngle + TAU;
          ctx.beginPath();
          ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
          ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
          ctx.closePath();
          for (i = 0; i < arc.fullCircles; ++i) {
            ctx.fill();
          }
          arc.endAngle = arc.startAngle + vm.circumference % TAU;
        }
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
        ctx.closePath();
        ctx.fill();
        if (vm.borderWidth) {
          drawBorder(ctx, vm, arc);
        }
        ctx.restore();
      }
    });
    var valueOrDefault$1 = helpers$1.valueOrDefault;
    var defaultColor = core_defaults.global.defaultColor;
    core_defaults._set('global', {
      elements: {
        line: {
          tension: 0.4,
          backgroundColor: defaultColor,
          borderWidth: 3,
          borderColor: defaultColor,
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          capBezierPoints: true,
          fill: true
        }
      }
    });
    var element_line = core_element.extend({
      _type: 'line',
      draw: function draw() {
        var me = this;
        var vm = me._view;
        var ctx = me._chart.ctx;
        var spanGaps = vm.spanGaps;
        var points = me._children.slice();
        var globalDefaults = core_defaults.global;
        var globalOptionLineElements = globalDefaults.elements.line;
        var lastDrawnIndex = -1;
        var closePath = me._loop;
        var index, previous, currentVM;
        if (!points.length) {
          return;
        }
        if (me._loop) {
          for (index = 0; index < points.length; ++index) {
            previous = helpers$1.previousItem(points, index);
            if (!points[index]._view.skip && previous._view.skip) {
              points = points.slice(index).concat(points.slice(0, index));
              closePath = spanGaps;
              break;
            }
          }
          if (closePath) {
            points.push(points[0]);
          }
        }
        ctx.save();
        ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
        if (ctx.setLineDash) {
          ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
        }
        ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
        ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
        ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
        ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
        ctx.beginPath();
        currentVM = points[0]._view;
        if (!currentVM.skip) {
          ctx.moveTo(currentVM.x, currentVM.y);
          lastDrawnIndex = 0;
        }
        for (index = 1; index < points.length; ++index) {
          currentVM = points[index]._view;
          previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
          if (!currentVM.skip) {
            if (lastDrawnIndex !== index - 1 && !spanGaps || lastDrawnIndex === -1) {
              ctx.moveTo(currentVM.x, currentVM.y);
            } else {
              helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
            }
            lastDrawnIndex = index;
          }
        }
        if (closePath) {
          ctx.closePath();
        }
        ctx.stroke();
        ctx.restore();
      }
    });
    var valueOrDefault$2 = helpers$1.valueOrDefault;
    var defaultColor$1 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
      elements: {
        point: {
          radius: 3,
          pointStyle: 'circle',
          backgroundColor: defaultColor$1,
          borderColor: defaultColor$1,
          borderWidth: 1,
          hitRadius: 1,
          hoverRadius: 4,
          hoverBorderWidth: 1
        }
      }
    });
    function xRange(mouseX) {
      var vm = this._view;
      return vm ? Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius : false;
    }
    function yRange(mouseY) {
      var vm = this._view;
      return vm ? Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius : false;
    }
    var element_point = core_element.extend({
      _type: 'point',
      inRange: function inRange(mouseX, mouseY) {
        var vm = this._view;
        return vm ? Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2) < Math.pow(vm.hitRadius + vm.radius, 2) : false;
      },
      inLabelRange: xRange,
      inXRange: xRange,
      inYRange: yRange,
      getCenterPoint: function getCenterPoint() {
        var vm = this._view;
        return {
          x: vm.x,
          y: vm.y
        };
      },
      getArea: function getArea() {
        return Math.PI * Math.pow(this._view.radius, 2);
      },
      tooltipPosition: function tooltipPosition() {
        var vm = this._view;
        return {
          x: vm.x,
          y: vm.y,
          padding: vm.radius + vm.borderWidth
        };
      },
      draw: function draw(chartArea) {
        var vm = this._view;
        var ctx = this._chart.ctx;
        var pointStyle = vm.pointStyle;
        var rotation = vm.rotation;
        var radius = vm.radius;
        var x = vm.x;
        var y = vm.y;
        var globalDefaults = core_defaults.global;
        var defaultColor = globalDefaults.defaultColor;
        if (vm.skip) {
          return;
        }
        if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
          ctx.strokeStyle = vm.borderColor || defaultColor;
          ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
          ctx.fillStyle = vm.backgroundColor || defaultColor;
          helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
        }
      }
    });
    var defaultColor$2 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
      elements: {
        rectangle: {
          backgroundColor: defaultColor$2,
          borderColor: defaultColor$2,
          borderSkipped: 'bottom',
          borderWidth: 0
        }
      }
    });
    function isVertical(vm) {
      return vm && vm.width !== undefined;
    }
    function getBarBounds(vm) {
      var x1, x2, y1, y2, half;
      if (isVertical(vm)) {
        half = vm.width / 2;
        x1 = vm.x - half;
        x2 = vm.x + half;
        y1 = Math.min(vm.y, vm.base);
        y2 = Math.max(vm.y, vm.base);
      } else {
        half = vm.height / 2;
        x1 = Math.min(vm.x, vm.base);
        x2 = Math.max(vm.x, vm.base);
        y1 = vm.y - half;
        y2 = vm.y + half;
      }
      return {
        left: x1,
        top: y1,
        right: x2,
        bottom: y2
      };
    }
    function swap(orig, v1, v2) {
      return orig === v1 ? v2 : orig === v2 ? v1 : orig;
    }
    function parseBorderSkipped(vm) {
      var edge = vm.borderSkipped;
      var res = {};
      if (!edge) {
        return res;
      }
      if (vm.horizontal) {
        if (vm.base > vm.x) {
          edge = swap(edge, 'left', 'right');
        }
      } else if (vm.base < vm.y) {
        edge = swap(edge, 'bottom', 'top');
      }
      res[edge] = true;
      return res;
    }
    function parseBorderWidth(vm, maxW, maxH) {
      var value = vm.borderWidth;
      var skip = parseBorderSkipped(vm);
      var t, r, b, l;
      if (helpers$1.isObject(value)) {
        t = +value.top || 0;
        r = +value.right || 0;
        b = +value.bottom || 0;
        l = +value.left || 0;
      } else {
        t = r = b = l = +value || 0;
      }
      return {
        t: skip.top || t < 0 ? 0 : t > maxH ? maxH : t,
        r: skip.right || r < 0 ? 0 : r > maxW ? maxW : r,
        b: skip.bottom || b < 0 ? 0 : b > maxH ? maxH : b,
        l: skip.left || l < 0 ? 0 : l > maxW ? maxW : l
      };
    }
    function boundingRects(vm) {
      var bounds = getBarBounds(vm);
      var width = bounds.right - bounds.left;
      var height = bounds.bottom - bounds.top;
      var border = parseBorderWidth(vm, width / 2, height / 2);
      return {
        outer: {
          x: bounds.left,
          y: bounds.top,
          w: width,
          h: height
        },
        inner: {
          x: bounds.left + border.l,
          y: bounds.top + border.t,
          w: width - border.l - border.r,
          h: height - border.t - border.b
        }
      };
    }
    function _inRange(vm, x, y) {
      var skipX = x === null;
      var skipY = y === null;
      var bounds = !vm || skipX && skipY ? false : getBarBounds(vm);
      return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
    }
    var element_rectangle = core_element.extend({
      _type: 'rectangle',
      draw: function draw() {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var rects = boundingRects(vm);
        var outer = rects.outer;
        var inner = rects.inner;
        ctx.fillStyle = vm.backgroundColor;
        ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
        if (outer.w === inner.w && outer.h === inner.h) {
          return;
        }
        ctx.save();
        ctx.beginPath();
        ctx.rect(outer.x, outer.y, outer.w, outer.h);
        ctx.clip();
        ctx.fillStyle = vm.borderColor;
        ctx.rect(inner.x, inner.y, inner.w, inner.h);
        ctx.fill('evenodd');
        ctx.restore();
      },
      height: function height() {
        var vm = this._view;
        return vm.base - vm.y;
      },
      inRange: function inRange(mouseX, mouseY) {
        return _inRange(this._view, mouseX, mouseY);
      },
      inLabelRange: function inLabelRange(mouseX, mouseY) {
        var vm = this._view;
        return isVertical(vm) ? _inRange(vm, mouseX, null) : _inRange(vm, null, mouseY);
      },
      inXRange: function inXRange(mouseX) {
        return _inRange(this._view, mouseX, null);
      },
      inYRange: function inYRange(mouseY) {
        return _inRange(this._view, null, mouseY);
      },
      getCenterPoint: function getCenterPoint() {
        var vm = this._view;
        var x, y;
        if (isVertical(vm)) {
          x = vm.x;
          y = (vm.y + vm.base) / 2;
        } else {
          x = (vm.x + vm.base) / 2;
          y = vm.y;
        }
        return {
          x: x,
          y: y
        };
      },
      getArea: function getArea() {
        var vm = this._view;
        return isVertical(vm) ? vm.width * Math.abs(vm.y - vm.base) : vm.height * Math.abs(vm.x - vm.base);
      },
      tooltipPosition: function tooltipPosition() {
        var vm = this._view;
        return {
          x: vm.x,
          y: vm.y
        };
      }
    });
    var elements = {};
    var Arc = element_arc;
    var Line = element_line;
    var Point = element_point;
    var Rectangle = element_rectangle;
    elements.Arc = Arc;
    elements.Line = Line;
    elements.Point = Point;
    elements.Rectangle = Rectangle;
    var deprecated = helpers$1._deprecated;
    var valueOrDefault$3 = helpers$1.valueOrDefault;
    core_defaults._set('bar', {
      hover: {
        mode: 'label'
      },
      scales: {
        xAxes: [{
          type: 'category',
          offset: true,
          gridLines: {
            offsetGridLines: true
          }
        }],
        yAxes: [{
          type: 'linear'
        }]
      }
    });
    core_defaults._set('global', {
      datasets: {
        bar: {
          categoryPercentage: 0.8,
          barPercentage: 0.9
        }
      }
    });
    function computeMinSampleSize(scale, pixels) {
      var min = scale._length;
      var prev, curr, i, ilen;
      for (i = 1, ilen = pixels.length; i < ilen; ++i) {
        min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
      }
      for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
        curr = scale.getPixelForTick(i);
        min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
        prev = curr;
      }
      return min;
    }
    function computeFitCategoryTraits(index, ruler, options) {
      var thickness = options.barThickness;
      var count = ruler.stackCount;
      var curr = ruler.pixels[index];
      var min = helpers$1.isNullOrUndef(thickness) ? computeMinSampleSize(ruler.scale, ruler.pixels) : -1;
      var size, ratio;
      if (helpers$1.isNullOrUndef(thickness)) {
        size = min * options.categoryPercentage;
        ratio = options.barPercentage;
      } else {
        size = thickness * count;
        ratio = 1;
      }
      return {
        chunk: size / count,
        ratio: ratio,
        start: curr - size / 2
      };
    }
    function computeFlexCategoryTraits(index, ruler, options) {
      var pixels = ruler.pixels;
      var curr = pixels[index];
      var prev = index > 0 ? pixels[index - 1] : null;
      var next = index < pixels.length - 1 ? pixels[index + 1] : null;
      var percent = options.categoryPercentage;
      var start, size;
      if (prev === null) {
        prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
      }
      if (next === null) {
        next = curr + curr - prev;
      }
      start = curr - (curr - Math.min(prev, next)) / 2 * percent;
      size = Math.abs(next - prev) / 2 * percent;
      return {
        chunk: size / ruler.stackCount,
        ratio: options.barPercentage,
        start: start
      };
    }
    var controller_bar = core_datasetController.extend({
      dataElementType: elements.Rectangle,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderSkipped', 'borderWidth', 'barPercentage', 'barThickness', 'categoryPercentage', 'maxBarThickness', 'minBarLength'],
      initialize: function initialize() {
        var me = this;
        var meta, scaleOpts;
        core_datasetController.prototype.initialize.apply(me, arguments);
        meta = me.getMeta();
        meta.stack = me.getDataset().stack;
        meta.bar = true;
        scaleOpts = me._getIndexScale().options;
        deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
        deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
        deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
        deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
        deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
      },
      update: function update(reset) {
        var me = this;
        var rects = me.getMeta().data;
        var i, ilen;
        me._ruler = me.getRuler();
        for (i = 0, ilen = rects.length; i < ilen; ++i) {
          me.updateElement(rects[i], i, reset);
        }
      },
      updateElement: function updateElement(rectangle, index, reset) {
        var me = this;
        var meta = me.getMeta();
        var dataset = me.getDataset();
        var options = me._resolveDataElementOptions(rectangle, index);
        rectangle._xScale = me.getScaleForId(meta.xAxisID);
        rectangle._yScale = me.getScaleForId(meta.yAxisID);
        rectangle._datasetIndex = me.index;
        rectangle._index = index;
        rectangle._model = {
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderSkipped: options.borderSkipped,
          borderWidth: options.borderWidth,
          datasetLabel: dataset.label,
          label: me.chart.data.labels[index]
        };
        if (helpers$1.isArray(dataset.data[index])) {
          rectangle._model.borderSkipped = null;
        }
        me._updateElementGeometry(rectangle, index, reset, options);
        rectangle.pivot();
      },
      _updateElementGeometry: function _updateElementGeometry(rectangle, index, reset, options) {
        var me = this;
        var model = rectangle._model;
        var vscale = me._getValueScale();
        var base = vscale.getBasePixel();
        var horizontal = vscale.isHorizontal();
        var ruler = me._ruler || me.getRuler();
        var vpixels = me.calculateBarValuePixels(me.index, index, options);
        var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
        model.horizontal = horizontal;
        model.base = reset ? base : vpixels.base;
        model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
        model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
        model.height = horizontal ? ipixels.size : undefined;
        model.width = horizontal ? undefined : ipixels.size;
      },
      _getStacks: function _getStacks(last) {
        var me = this;
        var scale = me._getIndexScale();
        var metasets = scale._getMatchingVisibleMetas(me._type);
        var stacked = scale.options.stacked;
        var ilen = metasets.length;
        var stacks = [];
        var i, meta;
        for (i = 0; i < ilen; ++i) {
          meta = metasets[i];
          if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) {
            stacks.push(meta.stack);
          }
          if (meta.index === last) {
            break;
          }
        }
        return stacks;
      },
      getStackCount: function getStackCount() {
        return this._getStacks().length;
      },
      getStackIndex: function getStackIndex(datasetIndex, name) {
        var stacks = this._getStacks(datasetIndex);
        var index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
      },
      getRuler: function getRuler() {
        var me = this;
        var scale = me._getIndexScale();
        var pixels = [];
        var i, ilen;
        for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
          pixels.push(scale.getPixelForValue(null, i, me.index));
        }
        return {
          pixels: pixels,
          start: scale._startPixel,
          end: scale._endPixel,
          stackCount: me.getStackCount(),
          scale: scale
        };
      },
      calculateBarValuePixels: function calculateBarValuePixels(datasetIndex, index, options) {
        var me = this;
        var chart = me.chart;
        var scale = me._getValueScale();
        var isHorizontal = scale.isHorizontal();
        var datasets = chart.data.datasets;
        var metasets = scale._getMatchingVisibleMetas(me._type);
        var value = scale._parseValue(datasets[datasetIndex].data[index]);
        var minBarLength = options.minBarLength;
        var stacked = scale.options.stacked;
        var stack = me.getMeta().stack;
        var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
        var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
        var ilen = metasets.length;
        var i, imeta, ivalue, base, head, size, stackLength;
        if (stacked || stacked === undefined && stack !== undefined) {
          for (i = 0; i < ilen; ++i) {
            imeta = metasets[i];
            if (imeta.index === datasetIndex) {
              break;
            }
            if (imeta.stack === stack) {
              stackLength = scale._parseValue(datasets[imeta.index].data[index]);
              ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
              if (value.min < 0 && ivalue < 0 || value.max >= 0 && ivalue > 0) {
                start += ivalue;
              }
            }
          }
        }
        base = scale.getPixelForValue(start);
        head = scale.getPixelForValue(start + length);
        size = head - base;
        if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
          size = minBarLength;
          if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
            head = base - minBarLength;
          } else {
            head = base + minBarLength;
          }
        }
        return {
          size: size,
          base: base,
          head: head,
          center: head + size / 2
        };
      },
      calculateBarIndexPixels: function calculateBarIndexPixels(datasetIndex, index, ruler, options) {
        var me = this;
        var range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options) : computeFitCategoryTraits(index, ruler, options);
        var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
        var center = range.start + range.chunk * stackIndex + range.chunk / 2;
        var size = Math.min(valueOrDefault$3(options.maxBarThickness, Infinity), range.chunk * range.ratio);
        return {
          base: center - size / 2,
          head: center + size / 2,
          center: center,
          size: size
        };
      },
      draw: function draw() {
        var me = this;
        var chart = me.chart;
        var scale = me._getValueScale();
        var rects = me.getMeta().data;
        var dataset = me.getDataset();
        var ilen = rects.length;
        var i = 0;
        helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
        for (; i < ilen; ++i) {
          var val = scale._parseValue(dataset.data[i]);
          if (!isNaN(val.min) && !isNaN(val.max)) {
            rects[i].draw();
          }
        }
        helpers$1.canvas.unclipArea(chart.ctx);
      },
      _resolveDataElementOptions: function _resolveDataElementOptions() {
        var me = this;
        var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
        var indexOpts = me._getIndexScale().options;
        var valueOpts = me._getValueScale().options;
        values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
        values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
        values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
        values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
        values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
        return values;
      }
    });
    var valueOrDefault$4 = helpers$1.valueOrDefault;
    var resolve$1 = helpers$1.options.resolve;
    core_defaults._set('bubble', {
      hover: {
        mode: 'single'
      },
      scales: {
        xAxes: [{
          type: 'linear',
          position: 'bottom',
          id: 'x-axis-0'
        }],
        yAxes: [{
          type: 'linear',
          position: 'left',
          id: 'y-axis-0'
        }]
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(item, data) {
            var datasetLabel = data.datasets[item.datasetIndex].label || '';
            var dataPoint = data.datasets[item.datasetIndex].data[item.index];
            return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
          }
        }
      }
    });
    var controller_bubble = core_datasetController.extend({
      dataElementType: elements.Point,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth', 'hoverRadius', 'hitRadius', 'pointStyle', 'rotation'],
      update: function update(reset) {
        var me = this;
        var meta = me.getMeta();
        var points = meta.data;
        helpers$1.each(points, function (point, index) {
          me.updateElement(point, index, reset);
        });
      },
      updateElement: function updateElement(point, index, reset) {
        var me = this;
        var meta = me.getMeta();
        var custom = point.custom || {};
        var xScale = me.getScaleForId(meta.xAxisID);
        var yScale = me.getScaleForId(meta.yAxisID);
        var options = me._resolveDataElementOptions(point, index);
        var data = me.getDataset().data[index];
        var dsIndex = me.index;
        var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
        var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
        point._xScale = xScale;
        point._yScale = yScale;
        point._options = options;
        point._datasetIndex = dsIndex;
        point._index = index;
        point._model = {
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderWidth: options.borderWidth,
          hitRadius: options.hitRadius,
          pointStyle: options.pointStyle,
          rotation: options.rotation,
          radius: reset ? 0 : options.radius,
          skip: custom.skip || isNaN(x) || isNaN(y),
          x: x,
          y: y
        };
        point.pivot();
      },
      setHoverStyle: function setHoverStyle(point) {
        var model = point._model;
        var options = point._options;
        var getHoverColor = helpers$1.getHoverColor;
        point.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth,
          radius: model.radius
        };
        model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
        model.radius = options.radius + options.hoverRadius;
      },
      _resolveDataElementOptions: function _resolveDataElementOptions(point, index) {
        var me = this;
        var chart = me.chart;
        var dataset = me.getDataset();
        var custom = point.custom || {};
        var data = dataset.data[index] || {};
        var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
        var context = {
          chart: chart,
          dataIndex: index,
          dataset: dataset,
          datasetIndex: me.index
        };
        if (me._cachedDataOpts === values) {
          values = helpers$1.extend({}, values);
        }
        values.radius = resolve$1([custom.radius, data.r, me._config.radius, chart.options.elements.point.radius], context, index);
        return values;
      }
    });
    var valueOrDefault$5 = helpers$1.valueOrDefault;
    var PI$1 = Math.PI;
    var DOUBLE_PI$1 = PI$1 * 2;
    var HALF_PI$1 = PI$1 / 2;
    core_defaults._set('doughnut', {
      animation: {
        animateRotate: true,
        animateScale: false
      },
      hover: {
        mode: 'single'
      },
      legendCallback: function legendCallback(chart) {
        var list = document.createElement('ul');
        var data = chart.data;
        var datasets = data.datasets;
        var labels = data.labels;
        var i, ilen, listItem, listItemSpan;
        list.setAttribute('class', chart.id + '-legend');
        if (datasets.length) {
          for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
            listItem = list.appendChild(document.createElement('li'));
            listItemSpan = listItem.appendChild(document.createElement('span'));
            listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
            if (labels[i]) {
              listItem.appendChild(document.createTextNode(labels[i]));
            }
          }
        }
        return list.outerHTML;
      },
      legend: {
        labels: {
          generateLabels: function generateLabels(chart) {
            var data = chart.data;
            if (data.labels.length && data.datasets.length) {
              return data.labels.map(function (label, i) {
                var meta = chart.getDatasetMeta(0);
                var style = meta.controller.getStyle(i);
                return {
                  text: label,
                  fillStyle: style.backgroundColor,
                  strokeStyle: style.borderColor,
                  lineWidth: style.borderWidth,
                  hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                  index: i
                };
              });
            }
            return [];
          }
        },
        onClick: function onClick(e, legendItem) {
          var index = legendItem.index;
          var chart = this.chart;
          var i, ilen, meta;
          for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
            meta = chart.getDatasetMeta(i);
            if (meta.data[index]) {
              meta.data[index].hidden = !meta.data[index].hidden;
            }
          }
          chart.update();
        }
      },
      cutoutPercentage: 50,
      rotation: -HALF_PI$1,
      circumference: DOUBLE_PI$1,
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(tooltipItem, data) {
            var dataLabel = data.labels[tooltipItem.index];
            var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            if (helpers$1.isArray(dataLabel)) {
              dataLabel = dataLabel.slice();
              dataLabel[0] += value;
            } else {
              dataLabel += value;
            }
            return dataLabel;
          }
        }
      }
    });
    var controller_doughnut = core_datasetController.extend({
      dataElementType: elements.Arc,
      linkScales: helpers$1.noop,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'borderAlign', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth'],
      getRingIndex: function getRingIndex(datasetIndex) {
        var ringIndex = 0;
        for (var j = 0; j < datasetIndex; ++j) {
          if (this.chart.isDatasetVisible(j)) {
            ++ringIndex;
          }
        }
        return ringIndex;
      },
      update: function update(reset) {
        var me = this;
        var chart = me.chart;
        var chartArea = chart.chartArea;
        var opts = chart.options;
        var ratioX = 1;
        var ratioY = 1;
        var offsetX = 0;
        var offsetY = 0;
        var meta = me.getMeta();
        var arcs = meta.data;
        var cutout = opts.cutoutPercentage / 100 || 0;
        var circumference = opts.circumference;
        var chartWeight = me._getRingWeight(me.index);
        var maxWidth, maxHeight, i, ilen;
        if (circumference < DOUBLE_PI$1) {
          var startAngle = opts.rotation % DOUBLE_PI$1;
          startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
          var endAngle = startAngle + circumference;
          var startX = Math.cos(startAngle);
          var startY = Math.sin(startAngle);
          var endX = Math.cos(endAngle);
          var endY = Math.sin(endAngle);
          var contains0 = startAngle <= 0 && endAngle >= 0 || endAngle >= DOUBLE_PI$1;
          var contains90 = startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1 || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
          var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
          var contains270 = startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1 || endAngle >= PI$1 + HALF_PI$1;
          var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
          var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
          var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
          var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
          ratioX = (maxX - minX) / 2;
          ratioY = (maxY - minY) / 2;
          offsetX = -(maxX + minX) / 2;
          offsetY = -(maxY + minY) / 2;
        }
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
        }
        chart.borderWidth = me.getMaxBorderWidth();
        maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
        maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
        chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
        chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
        chart.offsetX = offsetX * chart.outerRadius;
        chart.offsetY = offsetY * chart.outerRadius;
        meta.total = me.calculateTotal();
        me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
        me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          me.updateElement(arcs[i], i, reset);
        }
      },
      updateElement: function updateElement(arc, index, reset) {
        var me = this;
        var chart = me.chart;
        var chartArea = chart.chartArea;
        var opts = chart.options;
        var animationOpts = opts.animation;
        var centerX = (chartArea.left + chartArea.right) / 2;
        var centerY = (chartArea.top + chartArea.bottom) / 2;
        var startAngle = opts.rotation;
        var endAngle = opts.rotation;
        var dataset = me.getDataset();
        var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
        var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
        var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
        var options = arc._options || {};
        helpers$1.extend(arc, {
          _datasetIndex: me.index,
          _index: index,
          _model: {
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: options.borderWidth,
            borderAlign: options.borderAlign,
            x: centerX + chart.offsetX,
            y: centerY + chart.offsetY,
            startAngle: startAngle,
            endAngle: endAngle,
            circumference: circumference,
            outerRadius: outerRadius,
            innerRadius: innerRadius,
            label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
          }
        });
        var model = arc._model;
        if (!reset || !animationOpts.animateRotate) {
          if (index === 0) {
            model.startAngle = opts.rotation;
          } else {
            model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
          }
          model.endAngle = model.startAngle + model.circumference;
        }
        arc.pivot();
      },
      calculateTotal: function calculateTotal() {
        var dataset = this.getDataset();
        var meta = this.getMeta();
        var total = 0;
        var value;
        helpers$1.each(meta.data, function (element, index) {
          value = dataset.data[index];
          if (!isNaN(value) && !element.hidden) {
            total += Math.abs(value);
          }
        });
        return total;
      },
      calculateCircumference: function calculateCircumference(value) {
        var total = this.getMeta().total;
        if (total > 0 && !isNaN(value)) {
          return DOUBLE_PI$1 * (Math.abs(value) / total);
        }
        return 0;
      },
      getMaxBorderWidth: function getMaxBorderWidth(arcs) {
        var me = this;
        var max = 0;
        var chart = me.chart;
        var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
        if (!arcs) {
          for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
            if (chart.isDatasetVisible(i)) {
              meta = chart.getDatasetMeta(i);
              arcs = meta.data;
              if (i !== me.index) {
                controller = meta.controller;
              }
              break;
            }
          }
        }
        if (!arcs) {
          return 0;
        }
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          arc = arcs[i];
          if (controller) {
            controller._configure();
            options = controller._resolveDataElementOptions(arc, i);
          } else {
            options = arc._options;
          }
          if (options.borderAlign !== 'inner') {
            borderWidth = options.borderWidth;
            hoverWidth = options.hoverBorderWidth;
            max = borderWidth > max ? borderWidth : max;
            max = hoverWidth > max ? hoverWidth : max;
          }
        }
        return max;
      },
      setHoverStyle: function setHoverStyle(arc) {
        var model = arc._model;
        var options = arc._options;
        var getHoverColor = helpers$1.getHoverColor;
        arc.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth
        };
        model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
      },
      _getRingWeightOffset: function _getRingWeightOffset(datasetIndex) {
        var ringWeightOffset = 0;
        for (var i = 0; i < datasetIndex; ++i) {
          if (this.chart.isDatasetVisible(i)) {
            ringWeightOffset += this._getRingWeight(i);
          }
        }
        return ringWeightOffset;
      },
      _getRingWeight: function _getRingWeight(dataSetIndex) {
        return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
      },
      _getVisibleDatasetWeightTotal: function _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length);
      }
    });
    core_defaults._set('horizontalBar', {
      hover: {
        mode: 'index',
        axis: 'y'
      },
      scales: {
        xAxes: [{
          type: 'linear',
          position: 'bottom'
        }],
        yAxes: [{
          type: 'category',
          position: 'left',
          offset: true,
          gridLines: {
            offsetGridLines: true
          }
        }]
      },
      elements: {
        rectangle: {
          borderSkipped: 'left'
        }
      },
      tooltips: {
        mode: 'index',
        axis: 'y'
      }
    });
    core_defaults._set('global', {
      datasets: {
        horizontalBar: {
          categoryPercentage: 0.8,
          barPercentage: 0.9
        }
      }
    });
    var controller_horizontalBar = controller_bar.extend({
      _getValueScaleId: function _getValueScaleId() {
        return this.getMeta().xAxisID;
      },
      _getIndexScaleId: function _getIndexScaleId() {
        return this.getMeta().yAxisID;
      }
    });
    var valueOrDefault$6 = helpers$1.valueOrDefault;
    var resolve$2 = helpers$1.options.resolve;
    var isPointInArea = helpers$1.canvas._isPointInArea;
    core_defaults._set('line', {
      showLines: true,
      spanGaps: false,
      hover: {
        mode: 'label'
      },
      scales: {
        xAxes: [{
          type: 'category',
          id: 'x-axis-0'
        }],
        yAxes: [{
          type: 'linear',
          id: 'y-axis-0'
        }]
      }
    });
    function scaleClip(scale, halfBorderWidth) {
      var tickOpts = scale && scale.options.ticks || {};
      var reverse = tickOpts.reverse;
      var min = tickOpts.min === undefined ? halfBorderWidth : 0;
      var max = tickOpts.max === undefined ? halfBorderWidth : 0;
      return {
        start: reverse ? max : min,
        end: reverse ? min : max
      };
    }
    function defaultClip(xScale, yScale, borderWidth) {
      var halfBorderWidth = borderWidth / 2;
      var x = scaleClip(xScale, halfBorderWidth);
      var y = scaleClip(yScale, halfBorderWidth);
      return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
      };
    }
    function toClip(value) {
      var t, r, b, l;
      if (helpers$1.isObject(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
      } else {
        t = r = b = l = value;
      }
      return {
        top: t,
        right: r,
        bottom: b,
        left: l
      };
    }
    var controller_line = core_datasetController.extend({
      datasetElementType: elements.Line,
      dataElementType: elements.Point,
      _datasetElementOptions: ['backgroundColor', 'borderCapStyle', 'borderColor', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'borderWidth', 'cubicInterpolationMode', 'fill'],
      _dataElementOptions: {
        backgroundColor: 'pointBackgroundColor',
        borderColor: 'pointBorderColor',
        borderWidth: 'pointBorderWidth',
        hitRadius: 'pointHitRadius',
        hoverBackgroundColor: 'pointHoverBackgroundColor',
        hoverBorderColor: 'pointHoverBorderColor',
        hoverBorderWidth: 'pointHoverBorderWidth',
        hoverRadius: 'pointHoverRadius',
        pointStyle: 'pointStyle',
        radius: 'pointRadius',
        rotation: 'pointRotation'
      },
      update: function update(reset) {
        var me = this;
        var meta = me.getMeta();
        var line = meta.dataset;
        var points = meta.data || [];
        var options = me.chart.options;
        var config = me._config;
        var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
        var i, ilen;
        me._xScale = me.getScaleForId(meta.xAxisID);
        me._yScale = me.getScaleForId(meta.yAxisID);
        if (showLine) {
          if (config.tension !== undefined && config.lineTension === undefined) {
            config.lineTension = config.tension;
          }
          line._scale = me._yScale;
          line._datasetIndex = me.index;
          line._children = points;
          line._model = me._resolveDatasetElementOptions(line);
          line.pivot();
        }
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          me.updateElement(points[i], i, reset);
        }
        if (showLine && line._model.tension !== 0) {
          me.updateBezierControlPoints();
        }
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          points[i].pivot();
        }
      },
      updateElement: function updateElement(point, index, reset) {
        var me = this;
        var meta = me.getMeta();
        var custom = point.custom || {};
        var dataset = me.getDataset();
        var datasetIndex = me.index;
        var value = dataset.data[index];
        var xScale = me._xScale;
        var yScale = me._yScale;
        var lineModel = meta.dataset._model;
        var x, y;
        var options = me._resolveDataElementOptions(point, index);
        x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
        y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
        point._xScale = xScale;
        point._yScale = yScale;
        point._options = options;
        point._datasetIndex = datasetIndex;
        point._index = index;
        point._model = {
          x: x,
          y: y,
          skip: custom.skip || isNaN(x) || isNaN(y),
          radius: options.radius,
          pointStyle: options.pointStyle,
          rotation: options.rotation,
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderWidth: options.borderWidth,
          tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
          steppedLine: lineModel ? lineModel.steppedLine : false,
          hitRadius: options.hitRadius
        };
      },
      _resolveDatasetElementOptions: function _resolveDatasetElementOptions(element) {
        var me = this;
        var config = me._config;
        var custom = element.custom || {};
        var options = me.chart.options;
        var lineOptions = options.elements.line;
        var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
        values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
        values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
        values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
        values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
        return values;
      },
      calculatePointY: function calculatePointY(value, index, datasetIndex) {
        var me = this;
        var chart = me.chart;
        var yScale = me._yScale;
        var sumPos = 0;
        var sumNeg = 0;
        var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
        if (yScale.options.stacked) {
          rightValue = +yScale.getRightValue(value);
          metasets = chart._getSortedVisibleDatasetMetas();
          ilen = metasets.length;
          for (i = 0; i < ilen; ++i) {
            dsMeta = metasets[i];
            if (dsMeta.index === datasetIndex) {
              break;
            }
            ds = chart.data.datasets[dsMeta.index];
            if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
              stackedRightValue = +yScale.getRightValue(ds.data[index]);
              if (stackedRightValue < 0) {
                sumNeg += stackedRightValue || 0;
              } else {
                sumPos += stackedRightValue || 0;
              }
            }
          }
          if (rightValue < 0) {
            return yScale.getPixelForValue(sumNeg + rightValue);
          }
          return yScale.getPixelForValue(sumPos + rightValue);
        }
        return yScale.getPixelForValue(value);
      },
      updateBezierControlPoints: function updateBezierControlPoints() {
        var me = this;
        var chart = me.chart;
        var meta = me.getMeta();
        var lineModel = meta.dataset._model;
        var area = chart.chartArea;
        var points = meta.data || [];
        var i, ilen, model, controlPoints;
        if (lineModel.spanGaps) {
          points = points.filter(function (pt) {
            return !pt._model.skip;
          });
        }
        function capControlPoint(pt, min, max) {
          return Math.max(Math.min(pt, max), min);
        }
        if (lineModel.cubicInterpolationMode === 'monotone') {
          helpers$1.splineCurveMonotone(points);
        } else {
          for (i = 0, ilen = points.length; i < ilen; ++i) {
            model = points[i]._model;
            controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i)._model, model, helpers$1.nextItem(points, i)._model, lineModel.tension);
            model.controlPointPreviousX = controlPoints.previous.x;
            model.controlPointPreviousY = controlPoints.previous.y;
            model.controlPointNextX = controlPoints.next.x;
            model.controlPointNextY = controlPoints.next.y;
          }
        }
        if (chart.options.elements.line.capBezierPoints) {
          for (i = 0, ilen = points.length; i < ilen; ++i) {
            model = points[i]._model;
            if (isPointInArea(model, area)) {
              if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
                model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
                model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
              }
              if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
                model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
                model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
              }
            }
          }
        }
      },
      draw: function draw() {
        var me = this;
        var chart = me.chart;
        var meta = me.getMeta();
        var points = meta.data || [];
        var area = chart.chartArea;
        var canvas = chart.canvas;
        var i = 0;
        var ilen = points.length;
        var clip;
        if (me._showLine) {
          clip = meta.dataset._model.clip;
          helpers$1.canvas.clipArea(chart.ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? canvas.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
          });
          meta.dataset.draw();
          helpers$1.canvas.unclipArea(chart.ctx);
        }
        for (; i < ilen; ++i) {
          points[i].draw(area);
        }
      },
      setHoverStyle: function setHoverStyle(point) {
        var model = point._model;
        var options = point._options;
        var getHoverColor = helpers$1.getHoverColor;
        point.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth,
          radius: model.radius
        };
        model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
        model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
      }
    });
    var resolve$3 = helpers$1.options.resolve;
    core_defaults._set('polarArea', {
      scale: {
        type: 'radialLinear',
        angleLines: {
          display: false
        },
        gridLines: {
          circular: true
        },
        pointLabels: {
          display: false
        },
        ticks: {
          beginAtZero: true
        }
      },
      animation: {
        animateRotate: true,
        animateScale: true
      },
      startAngle: -0.5 * Math.PI,
      legendCallback: function legendCallback(chart) {
        var list = document.createElement('ul');
        var data = chart.data;
        var datasets = data.datasets;
        var labels = data.labels;
        var i, ilen, listItem, listItemSpan;
        list.setAttribute('class', chart.id + '-legend');
        if (datasets.length) {
          for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
            listItem = list.appendChild(document.createElement('li'));
            listItemSpan = listItem.appendChild(document.createElement('span'));
            listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
            if (labels[i]) {
              listItem.appendChild(document.createTextNode(labels[i]));
            }
          }
        }
        return list.outerHTML;
      },
      legend: {
        labels: {
          generateLabels: function generateLabels(chart) {
            var data = chart.data;
            if (data.labels.length && data.datasets.length) {
              return data.labels.map(function (label, i) {
                var meta = chart.getDatasetMeta(0);
                var style = meta.controller.getStyle(i);
                return {
                  text: label,
                  fillStyle: style.backgroundColor,
                  strokeStyle: style.borderColor,
                  lineWidth: style.borderWidth,
                  hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                  index: i
                };
              });
            }
            return [];
          }
        },
        onClick: function onClick(e, legendItem) {
          var index = legendItem.index;
          var chart = this.chart;
          var i, ilen, meta;
          for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
            meta = chart.getDatasetMeta(i);
            meta.data[index].hidden = !meta.data[index].hidden;
          }
          chart.update();
        }
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(item, data) {
            return data.labels[item.index] + ': ' + item.yLabel;
          }
        }
      }
    });
    var controller_polarArea = core_datasetController.extend({
      dataElementType: elements.Arc,
      linkScales: helpers$1.noop,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'borderAlign', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth'],
      _getIndexScaleId: function _getIndexScaleId() {
        return this.chart.scale.id;
      },
      _getValueScaleId: function _getValueScaleId() {
        return this.chart.scale.id;
      },
      update: function update(reset) {
        var me = this;
        var dataset = me.getDataset();
        var meta = me.getMeta();
        var start = me.chart.options.startAngle || 0;
        var starts = me._starts = [];
        var angles = me._angles = [];
        var arcs = meta.data;
        var i, ilen, angle;
        me._updateRadius();
        meta.count = me.countVisibleElements();
        for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
          starts[i] = start;
          angle = me._computeAngle(i);
          angles[i] = angle;
          start += angle;
        }
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
          me.updateElement(arcs[i], i, reset);
        }
      },
      _updateRadius: function _updateRadius() {
        var me = this;
        var chart = me.chart;
        var chartArea = chart.chartArea;
        var opts = chart.options;
        var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        chart.outerRadius = Math.max(minSize / 2, 0);
        chart.innerRadius = Math.max(opts.cutoutPercentage ? chart.outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
        me.outerRadius = chart.outerRadius - chart.radiusLength * me.index;
        me.innerRadius = me.outerRadius - chart.radiusLength;
      },
      updateElement: function updateElement(arc, index, reset) {
        var me = this;
        var chart = me.chart;
        var dataset = me.getDataset();
        var opts = chart.options;
        var animationOpts = opts.animation;
        var scale = chart.scale;
        var labels = chart.data.labels;
        var centerX = scale.xCenter;
        var centerY = scale.yCenter;
        var datasetStartAngle = opts.startAngle;
        var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
        var startAngle = me._starts[index];
        var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
        var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
        var options = arc._options || {};
        helpers$1.extend(arc, {
          _datasetIndex: me.index,
          _index: index,
          _scale: scale,
          _model: {
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: options.borderWidth,
            borderAlign: options.borderAlign,
            x: centerX,
            y: centerY,
            innerRadius: 0,
            outerRadius: reset ? resetRadius : distance,
            startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
            endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
            label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
          }
        });
        arc.pivot();
      },
      countVisibleElements: function countVisibleElements() {
        var dataset = this.getDataset();
        var meta = this.getMeta();
        var count = 0;
        helpers$1.each(meta.data, function (element, index) {
          if (!isNaN(dataset.data[index]) && !element.hidden) {
            count++;
          }
        });
        return count;
      },
      setHoverStyle: function setHoverStyle(arc) {
        var model = arc._model;
        var options = arc._options;
        var getHoverColor = helpers$1.getHoverColor;
        var valueOrDefault = helpers$1.valueOrDefault;
        arc.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth
        };
        model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
      },
      _computeAngle: function _computeAngle(index) {
        var me = this;
        var count = this.getMeta().count;
        var dataset = me.getDataset();
        var meta = me.getMeta();
        if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
          return 0;
        }
        var context = {
          chart: me.chart,
          dataIndex: index,
          dataset: dataset,
          datasetIndex: me.index
        };
        return resolve$3([me.chart.options.elements.arc.angle, 2 * Math.PI / count], context, index);
      }
    });
    core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
    core_defaults._set('pie', {
      cutoutPercentage: 0
    });
    var controller_pie = controller_doughnut;
    var valueOrDefault$7 = helpers$1.valueOrDefault;
    core_defaults._set('radar', {
      spanGaps: false,
      scale: {
        type: 'radialLinear'
      },
      elements: {
        line: {
          fill: 'start',
          tension: 0
        }
      }
    });
    var controller_radar = core_datasetController.extend({
      datasetElementType: elements.Line,
      dataElementType: elements.Point,
      linkScales: helpers$1.noop,
      _datasetElementOptions: ['backgroundColor', 'borderWidth', 'borderColor', 'borderCapStyle', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'fill'],
      _dataElementOptions: {
        backgroundColor: 'pointBackgroundColor',
        borderColor: 'pointBorderColor',
        borderWidth: 'pointBorderWidth',
        hitRadius: 'pointHitRadius',
        hoverBackgroundColor: 'pointHoverBackgroundColor',
        hoverBorderColor: 'pointHoverBorderColor',
        hoverBorderWidth: 'pointHoverBorderWidth',
        hoverRadius: 'pointHoverRadius',
        pointStyle: 'pointStyle',
        radius: 'pointRadius',
        rotation: 'pointRotation'
      },
      _getIndexScaleId: function _getIndexScaleId() {
        return this.chart.scale.id;
      },
      _getValueScaleId: function _getValueScaleId() {
        return this.chart.scale.id;
      },
      update: function update(reset) {
        var me = this;
        var meta = me.getMeta();
        var line = meta.dataset;
        var points = meta.data || [];
        var scale = me.chart.scale;
        var config = me._config;
        var i, ilen;
        if (config.tension !== undefined && config.lineTension === undefined) {
          config.lineTension = config.tension;
        }
        line._scale = scale;
        line._datasetIndex = me.index;
        line._children = points;
        line._loop = true;
        line._model = me._resolveDatasetElementOptions(line);
        line.pivot();
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          me.updateElement(points[i], i, reset);
        }
        me.updateBezierControlPoints();
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          points[i].pivot();
        }
      },
      updateElement: function updateElement(point, index, reset) {
        var me = this;
        var custom = point.custom || {};
        var dataset = me.getDataset();
        var scale = me.chart.scale;
        var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
        var options = me._resolveDataElementOptions(point, index);
        var lineModel = me.getMeta().dataset._model;
        var x = reset ? scale.xCenter : pointPosition.x;
        var y = reset ? scale.yCenter : pointPosition.y;
        point._scale = scale;
        point._options = options;
        point._datasetIndex = me.index;
        point._index = index;
        point._model = {
          x: x,
          y: y,
          skip: custom.skip || isNaN(x) || isNaN(y),
          radius: options.radius,
          pointStyle: options.pointStyle,
          rotation: options.rotation,
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderWidth: options.borderWidth,
          tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
          hitRadius: options.hitRadius
        };
      },
      _resolveDatasetElementOptions: function _resolveDatasetElementOptions() {
        var me = this;
        var config = me._config;
        var options = me.chart.options;
        var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
        values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
        values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
        return values;
      },
      updateBezierControlPoints: function updateBezierControlPoints() {
        var me = this;
        var meta = me.getMeta();
        var area = me.chart.chartArea;
        var points = meta.data || [];
        var i, ilen, model, controlPoints;
        if (meta.dataset._model.spanGaps) {
          points = points.filter(function (pt) {
            return !pt._model.skip;
          });
        }
        function capControlPoint(pt, min, max) {
          return Math.max(Math.min(pt, max), min);
        }
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          model = points[i]._model;
          controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i, true)._model, model, helpers$1.nextItem(points, i, true)._model, model.tension);
          model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
          model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
          model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
          model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
        }
      },
      setHoverStyle: function setHoverStyle(point) {
        var model = point._model;
        var options = point._options;
        var getHoverColor = helpers$1.getHoverColor;
        point.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth,
          radius: model.radius
        };
        model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
        model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
      }
    });
    core_defaults._set('scatter', {
      hover: {
        mode: 'single'
      },
      scales: {
        xAxes: [{
          id: 'x-axis-1',
          type: 'linear',
          position: 'bottom'
        }],
        yAxes: [{
          id: 'y-axis-1',
          type: 'linear',
          position: 'left'
        }]
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(item) {
            return '(' + item.xLabel + ', ' + item.yLabel + ')';
          }
        }
      }
    });
    core_defaults._set('global', {
      datasets: {
        scatter: {
          showLine: false
        }
      }
    });
    var controller_scatter = controller_line;
    var controllers = {
      bar: controller_bar,
      bubble: controller_bubble,
      doughnut: controller_doughnut,
      horizontalBar: controller_horizontalBar,
      line: controller_line,
      polarArea: controller_polarArea,
      pie: controller_pie,
      radar: controller_radar,
      scatter: controller_scatter
    };
    function getRelativePosition(e, chart) {
      if (e["native"]) {
        return {
          x: e.x,
          y: e.y
        };
      }
      return helpers$1.getRelativePosition(e, chart);
    }
    function parseVisibleItems(chart, handler) {
      var metasets = chart._getSortedVisibleDatasetMetas();
      var metadata, i, j, ilen, jlen, element;
      for (i = 0, ilen = metasets.length; i < ilen; ++i) {
        metadata = metasets[i].data;
        for (j = 0, jlen = metadata.length; j < jlen; ++j) {
          element = metadata[j];
          if (!element._view.skip) {
            handler(element);
          }
        }
      }
    }
    function getIntersectItems(chart, position) {
      var elements = [];
      parseVisibleItems(chart, function (element) {
        if (element.inRange(position.x, position.y)) {
          elements.push(element);
        }
      });
      return elements;
    }
    function getNearestItems(chart, position, intersect, distanceMetric) {
      var minDistance = Number.POSITIVE_INFINITY;
      var nearestItems = [];
      parseVisibleItems(chart, function (element) {
        if (intersect && !element.inRange(position.x, position.y)) {
          return;
        }
        var center = element.getCenterPoint();
        var distance = distanceMetric(position, center);
        if (distance < minDistance) {
          nearestItems = [element];
          minDistance = distance;
        } else if (distance === minDistance) {
          nearestItems.push(element);
        }
      });
      return nearestItems;
    }
    function getDistanceMetricForAxis(axis) {
      var useX = axis.indexOf('x') !== -1;
      var useY = axis.indexOf('y') !== -1;
      return function (pt1, pt2) {
        var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
      };
    }
    function indexMode(chart, e, options) {
      var position = getRelativePosition(e, chart);
      options.axis = options.axis || 'x';
      var distanceMetric = getDistanceMetricForAxis(options.axis);
      var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
      var elements = [];
      if (!items.length) {
        return [];
      }
      chart._getSortedVisibleDatasetMetas().forEach(function (meta) {
        var element = meta.data[items[0]._index];
        if (element && !element._view.skip) {
          elements.push(element);
        }
      });
      return elements;
    }
    var core_interaction = {
      modes: {
        single: function single(chart, e) {
          var position = getRelativePosition(e, chart);
          var elements = [];
          parseVisibleItems(chart, function (element) {
            if (element.inRange(position.x, position.y)) {
              elements.push(element);
              return elements;
            }
          });
          return elements.slice(0, 1);
        },
        label: indexMode,
        index: indexMode,
        dataset: function dataset(chart, e, options) {
          var position = getRelativePosition(e, chart);
          options.axis = options.axis || 'xy';
          var distanceMetric = getDistanceMetricForAxis(options.axis);
          var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
          if (items.length > 0) {
            items = chart.getDatasetMeta(items[0]._datasetIndex).data;
          }
          return items;
        },
        'x-axis': function xAxis(chart, e) {
          return indexMode(chart, e, {
            intersect: false
          });
        },
        point: function point(chart, e) {
          var position = getRelativePosition(e, chart);
          return getIntersectItems(chart, position);
        },
        nearest: function nearest(chart, e, options) {
          var position = getRelativePosition(e, chart);
          options.axis = options.axis || 'xy';
          var distanceMetric = getDistanceMetricForAxis(options.axis);
          return getNearestItems(chart, position, options.intersect, distanceMetric);
        },
        x: function x(chart, e, options) {
          var position = getRelativePosition(e, chart);
          var items = [];
          var intersectsItem = false;
          parseVisibleItems(chart, function (element) {
            if (element.inXRange(position.x)) {
              items.push(element);
            }
            if (element.inRange(position.x, position.y)) {
              intersectsItem = true;
            }
          });
          if (options.intersect && !intersectsItem) {
            items = [];
          }
          return items;
        },
        y: function y(chart, e, options) {
          var position = getRelativePosition(e, chart);
          var items = [];
          var intersectsItem = false;
          parseVisibleItems(chart, function (element) {
            if (element.inYRange(position.y)) {
              items.push(element);
            }
            if (element.inRange(position.x, position.y)) {
              intersectsItem = true;
            }
          });
          if (options.intersect && !intersectsItem) {
            items = [];
          }
          return items;
        }
      }
    };
    var extend = helpers$1.extend;
    function filterByPosition(array, position) {
      return helpers$1.where(array, function (v) {
        return v.pos === position;
      });
    }
    function sortByWeight(array, reverse) {
      return array.sort(function (a, b) {
        var v0 = reverse ? b : a;
        var v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
      });
    }
    function wrapBoxes(boxes) {
      var layoutBoxes = [];
      var i, ilen, box;
      for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
        box = boxes[i];
        layoutBoxes.push({
          index: i,
          box: box,
          pos: box.position,
          horizontal: box.isHorizontal(),
          weight: box.weight
        });
      }
      return layoutBoxes;
    }
    function setLayoutDims(layouts, params) {
      var i, ilen, layout;
      for (i = 0, ilen = layouts.length; i < ilen; ++i) {
        layout = layouts[i];
        layout.width = layout.horizontal ? layout.box.fullWidth && params.availableWidth : params.vBoxMaxWidth;
        layout.height = layout.horizontal && params.hBoxMaxHeight;
      }
    }
    function buildLayoutBoxes(boxes) {
      var layoutBoxes = wrapBoxes(boxes);
      var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
      var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
      var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
      var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
      return {
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(bottom),
        chartArea: filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right),
        horizontal: top.concat(bottom)
      };
    }
    function getCombinedMax(maxPadding, chartArea, a, b) {
      return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
    }
    function updateDims(chartArea, params, layout) {
      var box = layout.box;
      var maxPadding = chartArea.maxPadding;
      var newWidth, newHeight;
      if (layout.size) {
        chartArea[layout.pos] -= layout.size;
      }
      layout.size = layout.horizontal ? box.height : box.width;
      chartArea[layout.pos] += layout.size;
      if (box.getPadding) {
        var boxPadding = box.getPadding();
        maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
        maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
        maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
        maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
      }
      newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
      newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
      if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
        chartArea.w = newWidth;
        chartArea.h = newHeight;
        var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
        return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
      }
    }
    function handleMaxPadding(chartArea) {
      var maxPadding = chartArea.maxPadding;
      function updatePos(pos) {
        var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
      }
      chartArea.y += updatePos('top');
      chartArea.x += updatePos('left');
      updatePos('right');
      updatePos('bottom');
    }
    function getMargins(horizontal, chartArea) {
      var maxPadding = chartArea.maxPadding;
      function marginForPositions(positions) {
        var margin = {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        };
        positions.forEach(function (pos) {
          margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
      }
      return horizontal ? marginForPositions(['left', 'right']) : marginForPositions(['top', 'bottom']);
    }
    function fitBoxes(boxes, chartArea, params) {
      var refitBoxes = [];
      var i, ilen, layout, box, refit, changed;
      for (i = 0, ilen = boxes.length; i < ilen; ++i) {
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
        if (updateDims(chartArea, params, layout)) {
          changed = true;
          if (refitBoxes.length) {
            refit = true;
          }
        }
        if (!box.fullWidth) {
          refitBoxes.push(layout);
        }
      }
      return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
    }
    function placeBoxes(boxes, chartArea, params) {
      var userPadding = params.padding;
      var x = chartArea.x;
      var y = chartArea.y;
      var i, ilen, layout, box;
      for (i = 0, ilen = boxes.length; i < ilen; ++i) {
        layout = boxes[i];
        box = layout.box;
        if (layout.horizontal) {
          box.left = box.fullWidth ? userPadding.left : chartArea.left;
          box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
          box.top = y;
          box.bottom = y + box.height;
          box.width = box.right - box.left;
          y = box.bottom;
        } else {
          box.left = x;
          box.right = x + box.width;
          box.top = chartArea.top;
          box.bottom = chartArea.top + chartArea.h;
          box.height = box.bottom - box.top;
          x = box.right;
        }
      }
      chartArea.x = x;
      chartArea.y = y;
    }
    core_defaults._set('global', {
      layout: {
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      }
    });
    var core_layouts = {
      defaults: {},
      addBox: function addBox(chart, item) {
        if (!chart.boxes) {
          chart.boxes = [];
        }
        item.fullWidth = item.fullWidth || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function () {
          return [{
            z: 0,
            draw: function draw() {
              item.draw.apply(item, arguments);
            }
          }];
        };
        chart.boxes.push(item);
      },
      removeBox: function removeBox(chart, layoutItem) {
        var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) {
          chart.boxes.splice(index, 1);
        }
      },
      configure: function configure(chart, item, options) {
        var props = ['fullWidth', 'position', 'weight'];
        var ilen = props.length;
        var i = 0;
        var prop;
        for (; i < ilen; ++i) {
          prop = props[i];
          if (options.hasOwnProperty(prop)) {
            item[prop] = options[prop];
          }
        }
      },
      update: function update(chart, width, height) {
        if (!chart) {
          return;
        }
        var layoutOptions = chart.options.layout || {};
        var padding = helpers$1.options.toPadding(layoutOptions.padding);
        var availableWidth = width - padding.width;
        var availableHeight = height - padding.height;
        var boxes = buildLayoutBoxes(chart.boxes);
        var verticalBoxes = boxes.vertical;
        var horizontalBoxes = boxes.horizontal;
        var params = Object.freeze({
          outerWidth: width,
          outerHeight: height,
          padding: padding,
          availableWidth: availableWidth,
          vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
          hBoxMaxHeight: availableHeight / 2
        });
        var chartArea = extend({
          maxPadding: extend({}, padding),
          w: availableWidth,
          h: availableHeight,
          x: padding.left,
          y: padding.top
        }, padding);
        setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        fitBoxes(verticalBoxes, chartArea, params);
        if (fitBoxes(horizontalBoxes, chartArea, params)) {
          fitBoxes(verticalBoxes, chartArea, params);
        }
        handleMaxPadding(chartArea);
        placeBoxes(boxes.leftAndTop, chartArea, params);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        placeBoxes(boxes.rightAndBottom, chartArea, params);
        chart.chartArea = {
          left: chartArea.left,
          top: chartArea.top,
          right: chartArea.left + chartArea.w,
          bottom: chartArea.top + chartArea.h
        };
        helpers$1.each(boxes.chartArea, function (layout) {
          var box = layout.box;
          extend(box, chart.chartArea);
          box.update(chartArea.w, chartArea.h);
        });
      }
    };
    var platform_basic = {
      acquireContext: function acquireContext(item) {
        if (item && item.canvas) {
          item = item.canvas;
        }
        return item && item.getContext('2d') || null;
      }
    };
    var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";
    var platform_dom$1 = /*#__PURE__*/Object.freeze({
      __proto__: null,
      'default': platform_dom
    });
    var stylesheet = getCjsExportFromNamespace(platform_dom$1);
    var EXPANDO_KEY = '$chartjs';
    var CSS_PREFIX = 'chartjs-';
    var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
    var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
    var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
    var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];
    var EVENT_TYPES = {
      touchstart: 'mousedown',
      touchmove: 'mousemove',
      touchend: 'mouseup',
      pointerenter: 'mouseenter',
      pointerdown: 'mousedown',
      pointermove: 'mousemove',
      pointerup: 'mouseup',
      pointerleave: 'mouseout',
      pointerout: 'mouseout'
    };
    function readUsedSize(element, property) {
      var value = helpers$1.getStyle(element, property);
      var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
      return matches ? Number(matches[1]) : undefined;
    }
    function initCanvas(canvas, config) {
      var style = canvas.style;
      var renderHeight = canvas.getAttribute('height');
      var renderWidth = canvas.getAttribute('width');
      canvas[EXPANDO_KEY] = {
        initial: {
          height: renderHeight,
          width: renderWidth,
          style: {
            display: style.display,
            height: style.height,
            width: style.width
          }
        }
      };
      style.display = style.display || 'block';
      if (renderWidth === null || renderWidth === '') {
        var displayWidth = readUsedSize(canvas, 'width');
        if (displayWidth !== undefined) {
          canvas.width = displayWidth;
        }
      }
      if (renderHeight === null || renderHeight === '') {
        if (canvas.style.height === '') {
          canvas.height = canvas.width / (config.options.aspectRatio || 2);
        } else {
          var displayHeight = readUsedSize(canvas, 'height');
          if (displayWidth !== undefined) {
            canvas.height = displayHeight;
          }
        }
      }
      return canvas;
    }
    var supportsEventListenerOptions = function () {
      var supports = false;
      try {
        var options = Object.defineProperty({}, 'passive', {
          get: function get() {
            supports = true;
          }
        });
        window.addEventListener('e', null, options);
      } catch (e) {}
      return supports;
    }();
    var eventListenerOptions = supportsEventListenerOptions ? {
      passive: true
    } : false;
    function addListener(node, type, listener) {
      node.addEventListener(type, listener, eventListenerOptions);
    }
    function removeListener(node, type, listener) {
      node.removeEventListener(type, listener, eventListenerOptions);
    }
    function createEvent(type, chart, x, y, nativeEvent) {
      return {
        type: type,
        chart: chart,
        "native": nativeEvent || null,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
      };
    }
    function fromNativeEvent(event, chart) {
      var type = EVENT_TYPES[event.type] || event.type;
      var pos = helpers$1.getRelativePosition(event, chart);
      return createEvent(type, chart, pos.x, pos.y, event);
    }
    function throttled(fn, thisArg) {
      var ticking = false;
      var args = [];
      return function () {
        args = Array.prototype.slice.call(arguments);
        thisArg = thisArg || this;
        if (!ticking) {
          ticking = true;
          helpers$1.requestAnimFrame.call(window, function () {
            ticking = false;
            fn.apply(thisArg, args);
          });
        }
      };
    }
    function createDiv(cls) {
      var el = document.createElement('div');
      el.className = cls || '';
      return el;
    }
    function createResizer(handler) {
      var maxSize = 1000000;
      var resizer = createDiv(CSS_SIZE_MONITOR);
      var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
      var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
      expand.appendChild(createDiv());
      shrink.appendChild(createDiv());
      resizer.appendChild(expand);
      resizer.appendChild(shrink);
      resizer._reset = function () {
        expand.scrollLeft = maxSize;
        expand.scrollTop = maxSize;
        shrink.scrollLeft = maxSize;
        shrink.scrollTop = maxSize;
      };
      var onScroll = function onScroll() {
        resizer._reset();
        handler();
      };
      addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
      addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
      return resizer;
    }
    function watchForRender(node, handler) {
      var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
      var proxy = expando.renderProxy = function (e) {
        if (e.animationName === CSS_RENDER_ANIMATION) {
          handler();
        }
      };
      helpers$1.each(ANIMATION_START_EVENTS, function (type) {
        addListener(node, type, proxy);
      });
      expando.reflow = !!node.offsetParent;
      node.classList.add(CSS_RENDER_MONITOR);
    }
    function unwatchForRender(node) {
      var expando = node[EXPANDO_KEY] || {};
      var proxy = expando.renderProxy;
      if (proxy) {
        helpers$1.each(ANIMATION_START_EVENTS, function (type) {
          removeListener(node, type, proxy);
        });
        delete expando.renderProxy;
      }
      node.classList.remove(CSS_RENDER_MONITOR);
    }
    function addResizeListener(node, listener, chart) {
      var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
      var resizer = expando.resizer = createResizer(throttled(function () {
        if (expando.resizer) {
          var container = chart.options.maintainAspectRatio && node.parentNode;
          var w = container ? container.clientWidth : 0;
          listener(createEvent('resize', chart));
          if (container && container.clientWidth < w && chart.canvas) {
            listener(createEvent('resize', chart));
          }
        }
      }));
      watchForRender(node, function () {
        if (expando.resizer) {
          var container = node.parentNode;
          if (container && container !== resizer.parentNode) {
            container.insertBefore(resizer, container.firstChild);
          }
          resizer._reset();
        }
      });
    }
    function removeResizeListener(node) {
      var expando = node[EXPANDO_KEY] || {};
      var resizer = expando.resizer;
      delete expando.resizer;
      unwatchForRender(node);
      if (resizer && resizer.parentNode) {
        resizer.parentNode.removeChild(resizer);
      }
    }
    function injectCSS(rootNode, css) {
      var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
      if (!expando.containsStyles) {
        expando.containsStyles = true;
        css = '/* Chart.js */\n' + css;
        var style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        style.appendChild(document.createTextNode(css));
        rootNode.appendChild(style);
      }
    }
    var platform_dom$2 = {
      disableCSSInjection: false,
      _enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
      _ensureLoaded: function _ensureLoaded(canvas) {
        if (!this.disableCSSInjection) {
          var root = canvas.getRootNode ? canvas.getRootNode() : document;
          var targetNode = root.host ? root : document.head;
          injectCSS(targetNode, stylesheet);
        }
      },
      acquireContext: function acquireContext(item, config) {
        if (typeof item === 'string') {
          item = document.getElementById(item);
        } else if (item.length) {
          item = item[0];
        }
        if (item && item.canvas) {
          item = item.canvas;
        }
        var context = item && item.getContext && item.getContext('2d');
        if (context && context.canvas === item) {
          this._ensureLoaded(item);
          initCanvas(item, config);
          return context;
        }
        return null;
      },
      releaseContext: function releaseContext(context) {
        var canvas = context.canvas;
        if (!canvas[EXPANDO_KEY]) {
          return;
        }
        var initial = canvas[EXPANDO_KEY].initial;
        ['height', 'width'].forEach(function (prop) {
          var value = initial[prop];
          if (helpers$1.isNullOrUndef(value)) {
            canvas.removeAttribute(prop);
          } else {
            canvas.setAttribute(prop, value);
          }
        });
        helpers$1.each(initial.style || {}, function (value, key) {
          canvas.style[key] = value;
        });
        canvas.width = canvas.width;
        delete canvas[EXPANDO_KEY];
      },
      addEventListener: function addEventListener(chart, type, listener) {
        var canvas = chart.canvas;
        if (type === 'resize') {
          addResizeListener(canvas, listener, chart);
          return;
        }
        var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
        var proxies = expando.proxies || (expando.proxies = {});
        var proxy = proxies[chart.id + '_' + type] = function (event) {
          listener(fromNativeEvent(event, chart));
        };
        addListener(canvas, type, proxy);
      },
      removeEventListener: function removeEventListener(chart, type, listener) {
        var canvas = chart.canvas;
        if (type === 'resize') {
          removeResizeListener(canvas);
          return;
        }
        var expando = listener[EXPANDO_KEY] || {};
        var proxies = expando.proxies || {};
        var proxy = proxies[chart.id + '_' + type];
        if (!proxy) {
          return;
        }
        removeListener(canvas, type, proxy);
      }
    };
    helpers$1.addEvent = addListener;
    helpers$1.removeEvent = removeListener;
    var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
    var platform = helpers$1.extend({
      initialize: function initialize() {},
      acquireContext: function acquireContext() {},
      releaseContext: function releaseContext() {},
      addEventListener: function addEventListener() {},
      removeEventListener: function removeEventListener() {}
    }, implementation);
    core_defaults._set('global', {
      plugins: {}
    });
    var core_plugins = {
      _plugins: [],
      _cacheId: 0,
      register: function register(plugins) {
        var p = this._plugins;
        [].concat(plugins).forEach(function (plugin) {
          if (p.indexOf(plugin) === -1) {
            p.push(plugin);
          }
        });
        this._cacheId++;
      },
      unregister: function unregister(plugins) {
        var p = this._plugins;
        [].concat(plugins).forEach(function (plugin) {
          var idx = p.indexOf(plugin);
          if (idx !== -1) {
            p.splice(idx, 1);
          }
        });
        this._cacheId++;
      },
      clear: function clear() {
        this._plugins = [];
        this._cacheId++;
      },
      count: function count() {
        return this._plugins.length;
      },
      getAll: function getAll() {
        return this._plugins;
      },
      notify: function notify(chart, hook, args) {
        var descriptors = this.descriptors(chart);
        var ilen = descriptors.length;
        var i, descriptor, plugin, params, method;
        for (i = 0; i < ilen; ++i) {
          descriptor = descriptors[i];
          plugin = descriptor.plugin;
          method = plugin[hook];
          if (typeof method === 'function') {
            params = [chart].concat(args || []);
            params.push(descriptor.options);
            if (method.apply(plugin, params) === false) {
              return false;
            }
          }
        }
        return true;
      },
      descriptors: function descriptors(chart) {
        var cache = chart.$plugins || (chart.$plugins = {});
        if (cache.id === this._cacheId) {
          return cache.descriptors;
        }
        var plugins = [];
        var descriptors = [];
        var config = chart && chart.config || {};
        var options = config.options && config.options.plugins || {};
        this._plugins.concat(config.plugins || []).forEach(function (plugin) {
          var idx = plugins.indexOf(plugin);
          if (idx !== -1) {
            return;
          }
          var id = plugin.id;
          var opts = options[id];
          if (opts === false) {
            return;
          }
          if (opts === true) {
            opts = helpers$1.clone(core_defaults.global.plugins[id]);
          }
          plugins.push(plugin);
          descriptors.push({
            plugin: plugin,
            options: opts || {}
          });
        });
        cache.descriptors = descriptors;
        cache.id = this._cacheId;
        return descriptors;
      },
      _invalidate: function _invalidate(chart) {
        delete chart.$plugins;
      }
    };
    var core_scaleService = {
      constructors: {},
      defaults: {},
      registerScaleType: function registerScaleType(type, scaleConstructor, scaleDefaults) {
        this.constructors[type] = scaleConstructor;
        this.defaults[type] = helpers$1.clone(scaleDefaults);
      },
      getScaleConstructor: function getScaleConstructor(type) {
        return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
      },
      getScaleDefaults: function getScaleDefaults(type) {
        return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
      },
      updateScaleDefaults: function updateScaleDefaults(type, additions) {
        var me = this;
        if (me.defaults.hasOwnProperty(type)) {
          me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
        }
      },
      addScalesToLayout: function addScalesToLayout(chart) {
        helpers$1.each(chart.scales, function (scale) {
          scale.fullWidth = scale.options.fullWidth;
          scale.position = scale.options.position;
          scale.weight = scale.options.weight;
          core_layouts.addBox(chart, scale);
        });
      }
    };
    var valueOrDefault$8 = helpers$1.valueOrDefault;
    var getRtlHelper = helpers$1.rtl.getRtlAdapter;
    core_defaults._set('global', {
      tooltips: {
        enabled: true,
        custom: null,
        mode: 'nearest',
        position: 'average',
        intersect: true,
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleFontStyle: 'bold',
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleFontColor: '#fff',
        titleAlign: 'left',
        bodySpacing: 2,
        bodyFontColor: '#fff',
        bodyAlign: 'left',
        footerFontStyle: 'bold',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFontColor: '#fff',
        footerAlign: 'left',
        yPadding: 6,
        xPadding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        multiKeyBackground: '#fff',
        displayColors: true,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        callbacks: {
          beforeTitle: helpers$1.noop,
          title: function title(tooltipItems, data) {
            var title = '';
            var labels = data.labels;
            var labelCount = labels ? labels.length : 0;
            if (tooltipItems.length > 0) {
              var item = tooltipItems[0];
              if (item.label) {
                title = item.label;
              } else if (item.xLabel) {
                title = item.xLabel;
              } else if (labelCount > 0 && item.index < labelCount) {
                title = labels[item.index];
              }
            }
            return title;
          },
          afterTitle: helpers$1.noop,
          beforeBody: helpers$1.noop,
          beforeLabel: helpers$1.noop,
          label: function label(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label || '';
            if (label) {
              label += ': ';
            }
            if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
              label += tooltipItem.value;
            } else {
              label += tooltipItem.yLabel;
            }
            return label;
          },
          labelColor: function labelColor(tooltipItem, chart) {
            var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
            var activeElement = meta.data[tooltipItem.index];
            var view = activeElement._view;
            return {
              borderColor: view.borderColor,
              backgroundColor: view.backgroundColor
            };
          },
          labelTextColor: function labelTextColor() {
            return this._options.bodyFontColor;
          },
          afterLabel: helpers$1.noop,
          afterBody: helpers$1.noop,
          beforeFooter: helpers$1.noop,
          footer: helpers$1.noop,
          afterFooter: helpers$1.noop
        }
      }
    });
    var positioners = {
      average: function average(elements) {
        if (!elements.length) {
          return false;
        }
        var i, len;
        var x = 0;
        var y = 0;
        var count = 0;
        for (i = 0, len = elements.length; i < len; ++i) {
          var el = elements[i];
          if (el && el.hasValue()) {
            var pos = el.tooltipPosition();
            x += pos.x;
            y += pos.y;
            ++count;
          }
        }
        return {
          x: x / count,
          y: y / count
        };
      },
      nearest: function nearest(elements, eventPosition) {
        var x = eventPosition.x;
        var y = eventPosition.y;
        var minDistance = Number.POSITIVE_INFINITY;
        var i, len, nearestElement;
        for (i = 0, len = elements.length; i < len; ++i) {
          var el = elements[i];
          if (el && el.hasValue()) {
            var center = el.getCenterPoint();
            var d = helpers$1.distanceBetweenPoints(eventPosition, center);
            if (d < minDistance) {
              minDistance = d;
              nearestElement = el;
            }
          }
        }
        if (nearestElement) {
          var tp = nearestElement.tooltipPosition();
          x = tp.x;
          y = tp.y;
        }
        return {
          x: x,
          y: y
        };
      }
    };
    function pushOrConcat(base, toPush) {
      if (toPush) {
        if (helpers$1.isArray(toPush)) {
          Array.prototype.push.apply(base, toPush);
        } else {
          base.push(toPush);
        }
      }
      return base;
    }
    function splitNewlines(str) {
      if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
        return str.split('\n');
      }
      return str;
    }
    function createTooltipItem(element) {
      var xScale = element._xScale;
      var yScale = element._yScale || element._scale;
      var index = element._index;
      var datasetIndex = element._datasetIndex;
      var controller = element._chart.getDatasetMeta(datasetIndex).controller;
      var indexScale = controller._getIndexScale();
      var valueScale = controller._getValueScale();
      return {
        xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
        yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
        label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
        value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
        index: index,
        datasetIndex: datasetIndex,
        x: element._model.x,
        y: element._model.y
      };
    }
    function getBaseModel(tooltipOpts) {
      var globalDefaults = core_defaults.global;
      return {
        xPadding: tooltipOpts.xPadding,
        yPadding: tooltipOpts.yPadding,
        xAlign: tooltipOpts.xAlign,
        yAlign: tooltipOpts.yAlign,
        rtl: tooltipOpts.rtl,
        textDirection: tooltipOpts.textDirection,
        bodyFontColor: tooltipOpts.bodyFontColor,
        _bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
        _bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
        _bodyAlign: tooltipOpts.bodyAlign,
        bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
        bodySpacing: tooltipOpts.bodySpacing,
        titleFontColor: tooltipOpts.titleFontColor,
        _titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
        _titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
        titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
        _titleAlign: tooltipOpts.titleAlign,
        titleSpacing: tooltipOpts.titleSpacing,
        titleMarginBottom: tooltipOpts.titleMarginBottom,
        footerFontColor: tooltipOpts.footerFontColor,
        _footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
        _footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
        footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
        _footerAlign: tooltipOpts.footerAlign,
        footerSpacing: tooltipOpts.footerSpacing,
        footerMarginTop: tooltipOpts.footerMarginTop,
        caretSize: tooltipOpts.caretSize,
        cornerRadius: tooltipOpts.cornerRadius,
        backgroundColor: tooltipOpts.backgroundColor,
        opacity: 0,
        legendColorBackground: tooltipOpts.multiKeyBackground,
        displayColors: tooltipOpts.displayColors,
        borderColor: tooltipOpts.borderColor,
        borderWidth: tooltipOpts.borderWidth
      };
    }
    function getTooltipSize(tooltip, model) {
      var ctx = tooltip._chart.ctx;
      var height = model.yPadding * 2;
      var width = 0;
      var body = model.body;
      var combinedBodyLength = body.reduce(function (count, bodyItem) {
        return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
      }, 0);
      combinedBodyLength += model.beforeBody.length + model.afterBody.length;
      var titleLineCount = model.title.length;
      var footerLineCount = model.footer.length;
      var titleFontSize = model.titleFontSize;
      var bodyFontSize = model.bodyFontSize;
      var footerFontSize = model.footerFontSize;
      height += titleLineCount * titleFontSize;
      height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0;
      height += titleLineCount ? model.titleMarginBottom : 0;
      height += combinedBodyLength * bodyFontSize;
      height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0;
      height += footerLineCount ? model.footerMarginTop : 0;
      height += footerLineCount * footerFontSize;
      height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0;
      var widthPadding = 0;
      var maxLineWidth = function maxLineWidth(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
      };
      ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
      helpers$1.each(model.title, maxLineWidth);
      ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
      helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
      widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
      helpers$1.each(body, function (bodyItem) {
        helpers$1.each(bodyItem.before, maxLineWidth);
        helpers$1.each(bodyItem.lines, maxLineWidth);
        helpers$1.each(bodyItem.after, maxLineWidth);
      });
      widthPadding = 0;
      ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
      helpers$1.each(model.footer, maxLineWidth);
      width += 2 * model.xPadding;
      return {
        width: width,
        height: height
      };
    }
    function determineAlignment(tooltip, size) {
      var model = tooltip._model;
      var chart = tooltip._chart;
      var chartArea = tooltip._chart.chartArea;
      var xAlign = 'center';
      var yAlign = 'center';
      if (model.y < size.height) {
        yAlign = 'top';
      } else if (model.y > chart.height - size.height) {
        yAlign = 'bottom';
      }
      var lf, rf;
      var olf, orf;
      var yf;
      var midX = (chartArea.left + chartArea.right) / 2;
      var midY = (chartArea.top + chartArea.bottom) / 2;
      if (yAlign === 'center') {
        lf = function lf(x) {
          return x <= midX;
        };
        rf = function rf(x) {
          return x > midX;
        };
      } else {
        lf = function lf(x) {
          return x <= size.width / 2;
        };
        rf = function rf(x) {
          return x >= chart.width - size.width / 2;
        };
      }
      olf = function olf(x) {
        return x + size.width + model.caretSize + model.caretPadding > chart.width;
      };
      orf = function orf(x) {
        return x - size.width - model.caretSize - model.caretPadding < 0;
      };
      yf = function yf(y) {
        return y <= midY ? 'top' : 'bottom';
      };
      if (lf(model.x)) {
        xAlign = 'left';
        if (olf(model.x)) {
          xAlign = 'center';
          yAlign = yf(model.y);
        }
      } else if (rf(model.x)) {
        xAlign = 'right';
        if (orf(model.x)) {
          xAlign = 'center';
          yAlign = yf(model.y);
        }
      }
      var opts = tooltip._options;
      return {
        xAlign: opts.xAlign ? opts.xAlign : xAlign,
        yAlign: opts.yAlign ? opts.yAlign : yAlign
      };
    }
    function getBackgroundPoint(vm, size, alignment, chart) {
      var x = vm.x;
      var y = vm.y;
      var caretSize = vm.caretSize;
      var caretPadding = vm.caretPadding;
      var cornerRadius = vm.cornerRadius;
      var xAlign = alignment.xAlign;
      var yAlign = alignment.yAlign;
      var paddingAndSize = caretSize + caretPadding;
      var radiusAndPadding = cornerRadius + caretPadding;
      if (xAlign === 'right') {
        x -= size.width;
      } else if (xAlign === 'center') {
        x -= size.width / 2;
        if (x + size.width > chart.width) {
          x = chart.width - size.width;
        }
        if (x < 0) {
          x = 0;
        }
      }
      if (yAlign === 'top') {
        y += paddingAndSize;
      } else if (yAlign === 'bottom') {
        y -= size.height + paddingAndSize;
      } else {
        y -= size.height / 2;
      }
      if (yAlign === 'center') {
        if (xAlign === 'left') {
          x += paddingAndSize;
        } else if (xAlign === 'right') {
          x -= paddingAndSize;
        }
      } else if (xAlign === 'left') {
        x -= radiusAndPadding;
      } else if (xAlign === 'right') {
        x += radiusAndPadding;
      }
      return {
        x: x,
        y: y
      };
    }
    function getAlignedX(vm, align) {
      return align === 'center' ? vm.x + vm.width / 2 : align === 'right' ? vm.x + vm.width - vm.xPadding : vm.x + vm.xPadding;
    }
    function getBeforeAfterBodyLines(callback) {
      return pushOrConcat([], splitNewlines(callback));
    }
    var exports$4 = core_element.extend({
      initialize: function initialize() {
        this._model = getBaseModel(this._options);
        this._lastActive = [];
      },
      getTitle: function getTitle() {
        var me = this;
        var opts = me._options;
        var callbacks = opts.callbacks;
        var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
        var title = callbacks.title.apply(me, arguments);
        var afterTitle = callbacks.afterTitle.apply(me, arguments);
        var lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeTitle));
        lines = pushOrConcat(lines, splitNewlines(title));
        lines = pushOrConcat(lines, splitNewlines(afterTitle));
        return lines;
      },
      getBeforeBody: function getBeforeBody() {
        return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
      },
      getBody: function getBody(tooltipItems, data) {
        var me = this;
        var callbacks = me._options.callbacks;
        var bodyItems = [];
        helpers$1.each(tooltipItems, function (tooltipItem) {
          var bodyItem = {
            before: [],
            lines: [],
            after: []
          };
          pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
          pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
          pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
          bodyItems.push(bodyItem);
        });
        return bodyItems;
      },
      getAfterBody: function getAfterBody() {
        return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
      },
      getFooter: function getFooter() {
        var me = this;
        var callbacks = me._options.callbacks;
        var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
        var footer = callbacks.footer.apply(me, arguments);
        var afterFooter = callbacks.afterFooter.apply(me, arguments);
        var lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeFooter));
        lines = pushOrConcat(lines, splitNewlines(footer));
        lines = pushOrConcat(lines, splitNewlines(afterFooter));
        return lines;
      },
      update: function update(changed) {
        var me = this;
        var opts = me._options;
        var existingModel = me._model;
        var model = me._model = getBaseModel(opts);
        var active = me._active;
        var data = me._data;
        var alignment = {
          xAlign: existingModel.xAlign,
          yAlign: existingModel.yAlign
        };
        var backgroundPoint = {
          x: existingModel.x,
          y: existingModel.y
        };
        var tooltipSize = {
          width: existingModel.width,
          height: existingModel.height
        };
        var tooltipPosition = {
          x: existingModel.caretX,
          y: existingModel.caretY
        };
        var i, len;
        if (active.length) {
          model.opacity = 1;
          var labelColors = [];
          var labelTextColors = [];
          tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
          var tooltipItems = [];
          for (i = 0, len = active.length; i < len; ++i) {
            tooltipItems.push(createTooltipItem(active[i]));
          }
          if (opts.filter) {
            tooltipItems = tooltipItems.filter(function (a) {
              return opts.filter(a, data);
            });
          }
          if (opts.itemSort) {
            tooltipItems = tooltipItems.sort(function (a, b) {
              return opts.itemSort(a, b, data);
            });
          }
          helpers$1.each(tooltipItems, function (tooltipItem) {
            labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
            labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
          });
          model.title = me.getTitle(tooltipItems, data);
          model.beforeBody = me.getBeforeBody(tooltipItems, data);
          model.body = me.getBody(tooltipItems, data);
          model.afterBody = me.getAfterBody(tooltipItems, data);
          model.footer = me.getFooter(tooltipItems, data);
          model.x = tooltipPosition.x;
          model.y = tooltipPosition.y;
          model.caretPadding = opts.caretPadding;
          model.labelColors = labelColors;
          model.labelTextColors = labelTextColors;
          model.dataPoints = tooltipItems;
          tooltipSize = getTooltipSize(this, model);
          alignment = determineAlignment(this, tooltipSize);
          backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
        } else {
          model.opacity = 0;
        }
        model.xAlign = alignment.xAlign;
        model.yAlign = alignment.yAlign;
        model.x = backgroundPoint.x;
        model.y = backgroundPoint.y;
        model.width = tooltipSize.width;
        model.height = tooltipSize.height;
        model.caretX = tooltipPosition.x;
        model.caretY = tooltipPosition.y;
        me._model = model;
        if (changed && opts.custom) {
          opts.custom.call(me, model);
        }
        return me;
      },
      drawCaret: function drawCaret(tooltipPoint, size) {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
      },
      getCaretPosition: function getCaretPosition(tooltipPoint, size, vm) {
        var x1, x2, x3, y1, y2, y3;
        var caretSize = vm.caretSize;
        var cornerRadius = vm.cornerRadius;
        var xAlign = vm.xAlign;
        var yAlign = vm.yAlign;
        var ptX = tooltipPoint.x;
        var ptY = tooltipPoint.y;
        var width = size.width;
        var height = size.height;
        if (yAlign === 'center') {
          y2 = ptY + height / 2;
          if (xAlign === 'left') {
            x1 = ptX;
            x2 = x1 - caretSize;
            x3 = x1;
            y1 = y2 + caretSize;
            y3 = y2 - caretSize;
          } else {
            x1 = ptX + width;
            x2 = x1 + caretSize;
            x3 = x1;
            y1 = y2 - caretSize;
            y3 = y2 + caretSize;
          }
        } else {
          if (xAlign === 'left') {
            x2 = ptX + cornerRadius + caretSize;
            x1 = x2 - caretSize;
            x3 = x2 + caretSize;
          } else if (xAlign === 'right') {
            x2 = ptX + width - cornerRadius - caretSize;
            x1 = x2 - caretSize;
            x3 = x2 + caretSize;
          } else {
            x2 = vm.caretX;
            x1 = x2 - caretSize;
            x3 = x2 + caretSize;
          }
          if (yAlign === 'top') {
            y1 = ptY;
            y2 = y1 - caretSize;
            y3 = y1;
          } else {
            y1 = ptY + height;
            y2 = y1 + caretSize;
            y3 = y1;
            var tmp = x3;
            x3 = x1;
            x1 = tmp;
          }
        }
        return {
          x1: x1,
          x2: x2,
          x3: x3,
          y1: y1,
          y2: y2,
          y3: y3
        };
      },
      drawTitle: function drawTitle(pt, vm, ctx) {
        var title = vm.title;
        var length = title.length;
        var titleFontSize, titleSpacing, i;
        if (length) {
          var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
          pt.x = getAlignedX(vm, vm._titleAlign);
          ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
          ctx.textBaseline = 'middle';
          titleFontSize = vm.titleFontSize;
          titleSpacing = vm.titleSpacing;
          ctx.fillStyle = vm.titleFontColor;
          ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
          for (i = 0; i < length; ++i) {
            ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
            pt.y += titleFontSize + titleSpacing;
            if (i + 1 === length) {
              pt.y += vm.titleMarginBottom - titleSpacing;
            }
          }
        }
      },
      drawBody: function drawBody(pt, vm, ctx) {
        var bodyFontSize = vm.bodyFontSize;
        var bodySpacing = vm.bodySpacing;
        var bodyAlign = vm._bodyAlign;
        var body = vm.body;
        var drawColorBoxes = vm.displayColors;
        var xLinePadding = 0;
        var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
        var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
        var fillLineOfText = function fillLineOfText(line) {
          ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
          pt.y += bodyFontSize + bodySpacing;
        };
        var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
        var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
        pt.x = getAlignedX(vm, bodyAlignForCalculation);
        ctx.fillStyle = vm.bodyFontColor;
        helpers$1.each(vm.beforeBody, fillLineOfText);
        xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? bodyFontSize / 2 + 1 : bodyFontSize + 2 : 0;
        for (i = 0, ilen = body.length; i < ilen; ++i) {
          bodyItem = body[i];
          textColor = vm.labelTextColors[i];
          labelColors = vm.labelColors[i];
          ctx.fillStyle = textColor;
          helpers$1.each(bodyItem.before, fillLineOfText);
          lines = bodyItem.lines;
          for (j = 0, jlen = lines.length; j < jlen; ++j) {
            if (drawColorBoxes) {
              var rtlColorX = rtlHelper.x(colorX);
              ctx.fillStyle = vm.legendColorBackground;
              ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
              ctx.lineWidth = 1;
              ctx.strokeStyle = labelColors.borderColor;
              ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
              ctx.fillStyle = labelColors.backgroundColor;
              ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
              ctx.fillStyle = textColor;
            }
            fillLineOfText(lines[j]);
          }
          helpers$1.each(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        helpers$1.each(vm.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
      },
      drawFooter: function drawFooter(pt, vm, ctx) {
        var footer = vm.footer;
        var length = footer.length;
        var footerFontSize, i;
        if (length) {
          var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
          pt.x = getAlignedX(vm, vm._footerAlign);
          pt.y += vm.footerMarginTop;
          ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
          ctx.textBaseline = 'middle';
          footerFontSize = vm.footerFontSize;
          ctx.fillStyle = vm.footerFontColor;
          ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
          for (i = 0; i < length; ++i) {
            ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
            pt.y += footerFontSize + vm.footerSpacing;
          }
        }
      },
      drawBackground: function drawBackground(pt, vm, ctx, tooltipSize) {
        ctx.fillStyle = vm.backgroundColor;
        ctx.strokeStyle = vm.borderColor;
        ctx.lineWidth = vm.borderWidth;
        var xAlign = vm.xAlign;
        var yAlign = vm.yAlign;
        var x = pt.x;
        var y = pt.y;
        var width = tooltipSize.width;
        var height = tooltipSize.height;
        var radius = vm.cornerRadius;
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        if (yAlign === 'top') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        if (yAlign === 'center' && xAlign === 'right') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        if (yAlign === 'bottom') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        if (yAlign === 'center' && xAlign === 'left') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
        ctx.fill();
        if (vm.borderWidth > 0) {
          ctx.stroke();
        }
      },
      draw: function draw() {
        var ctx = this._chart.ctx;
        var vm = this._view;
        if (vm.opacity === 0) {
          return;
        }
        var tooltipSize = {
          width: vm.width,
          height: vm.height
        };
        var pt = {
          x: vm.x,
          y: vm.y
        };
        var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
        var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
        if (this._options.enabled && hasTooltipContent) {
          ctx.save();
          ctx.globalAlpha = opacity;
          this.drawBackground(pt, vm, ctx, tooltipSize);
          pt.y += vm.yPadding;
          helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
          this.drawTitle(pt, vm, ctx);
          this.drawBody(pt, vm, ctx);
          this.drawFooter(pt, vm, ctx);
          helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
          ctx.restore();
        }
      },
      handleEvent: function handleEvent(e) {
        var me = this;
        var options = me._options;
        var changed = false;
        me._lastActive = me._lastActive || [];
        if (e.type === 'mouseout') {
          me._active = [];
        } else {
          me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
          if (options.reverse) {
            me._active.reverse();
          }
        }
        changed = !helpers$1.arrayEquals(me._active, me._lastActive);
        if (changed) {
          me._lastActive = me._active;
          if (options.enabled || options.custom) {
            me._eventPosition = {
              x: e.x,
              y: e.y
            };
            me.update(true);
            me.pivot();
          }
        }
        return changed;
      }
    });
    var positioners_1 = positioners;
    var core_tooltip = exports$4;
    core_tooltip.positioners = positioners_1;
    var valueOrDefault$9 = helpers$1.valueOrDefault;
    core_defaults._set('global', {
      elements: {},
      events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
      hover: {
        onHover: null,
        mode: 'nearest',
        intersect: true,
        animationDuration: 400
      },
      onClick: null,
      maintainAspectRatio: true,
      responsive: true,
      responsiveAnimationDuration: 0
    });
    function mergeScaleConfig() {
      return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
        merger: function merger(key, target, source, options) {
          if (key === 'xAxes' || key === 'yAxes') {
            var slen = source[key].length;
            var i, type, scale;
            if (!target[key]) {
              target[key] = [];
            }
            for (i = 0; i < slen; ++i) {
              scale = source[key][i];
              type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
              if (i >= target[key].length) {
                target[key].push({});
              }
              if (!target[key][i].type || scale.type && scale.type !== target[key][i].type) {
                helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
              } else {
                helpers$1.merge(target[key][i], scale);
              }
            }
          } else {
            helpers$1._merger(key, target, source, options);
          }
        }
      });
    }
    function mergeConfig() {
      return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
        merger: function merger(key, target, source, options) {
          var tval = target[key] || Object.create(null);
          var sval = source[key];
          if (key === 'scales') {
            target[key] = mergeScaleConfig(tval, sval);
          } else if (key === 'scale') {
            target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
          } else {
            helpers$1._merger(key, target, source, options);
          }
        }
      });
    }
    function initConfig(config) {
      config = config || Object.create(null);
      var data = config.data = config.data || {};
      data.datasets = data.datasets || [];
      data.labels = data.labels || [];
      config.options = mergeConfig(core_defaults.global, core_defaults[config.type], config.options || {});
      return config;
    }
    function updateConfig(chart) {
      var newOptions = chart.options;
      helpers$1.each(chart.scales, function (scale) {
        core_layouts.removeBox(chart, scale);
      });
      newOptions = mergeConfig(core_defaults.global, core_defaults[chart.config.type], newOptions);
      chart.options = chart.config.options = newOptions;
      chart.ensureScalesHaveIDs();
      chart.buildOrUpdateScales();
      chart.tooltip._options = newOptions.tooltips;
      chart.tooltip.initialize();
    }
    function nextAvailableScaleId(axesOpts, prefix, index) {
      var id;
      var hasId = function hasId(obj) {
        return obj.id === id;
      };
      do {
        id = prefix + index++;
      } while (helpers$1.findIndex(axesOpts, hasId) >= 0);
      return id;
    }
    function positionIsHorizontal(position) {
      return position === 'top' || position === 'bottom';
    }
    function compare2Level(l1, l2) {
      return function (a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
      };
    }
    var Chart = function Chart(item, config) {
      this.construct(item, config);
      return this;
    };
    helpers$1.extend(Chart.prototype, {
      construct: function construct(item, config) {
        var me = this;
        config = initConfig(config);
        var context = platform.acquireContext(item, config);
        var canvas = context && context.canvas;
        var height = canvas && canvas.height;
        var width = canvas && canvas.width;
        me.id = helpers$1.uid();
        me.ctx = context;
        me.canvas = canvas;
        me.config = config;
        me.width = width;
        me.height = height;
        me.aspectRatio = height ? width / height : null;
        me.options = config.options;
        me._bufferedRender = false;
        me._layers = [];
        me.chart = me;
        me.controller = me;
        Chart.instances[me.id] = me;
        Object.defineProperty(me, 'data', {
          get: function get() {
            return me.config.data;
          },
          set: function set(value) {
            me.config.data = value;
          }
        });
        if (!context || !canvas) {
          console.error("Failed to create chart: can't acquire context from the given item");
          return;
        }
        me.initialize();
        me.update();
      },
      initialize: function initialize() {
        var me = this;
        core_plugins.notify(me, 'beforeInit');
        helpers$1.retinaScale(me, me.options.devicePixelRatio);
        me.bindEvents();
        if (me.options.responsive) {
          me.resize(true);
        }
        me.initToolTip();
        core_plugins.notify(me, 'afterInit');
        return me;
      },
      clear: function clear() {
        helpers$1.canvas.clear(this);
        return this;
      },
      stop: function stop() {
        core_animations.cancelAnimation(this);
        return this;
      },
      resize: function resize(silent) {
        var me = this;
        var options = me.options;
        var canvas = me.canvas;
        var aspectRatio = options.maintainAspectRatio && me.aspectRatio || null;
        var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
        var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
        if (me.width === newWidth && me.height === newHeight) {
          return;
        }
        canvas.width = me.width = newWidth;
        canvas.height = me.height = newHeight;
        canvas.style.width = newWidth + 'px';
        canvas.style.height = newHeight + 'px';
        helpers$1.retinaScale(me, options.devicePixelRatio);
        if (!silent) {
          var newSize = {
            width: newWidth,
            height: newHeight
          };
          core_plugins.notify(me, 'resize', [newSize]);
          if (options.onResize) {
            options.onResize(me, newSize);
          }
          me.stop();
          me.update({
            duration: options.responsiveAnimationDuration
          });
        }
      },
      ensureScalesHaveIDs: function ensureScalesHaveIDs() {
        var options = this.options;
        var scalesOptions = options.scales || {};
        var scaleOptions = options.scale;
        helpers$1.each(scalesOptions.xAxes, function (xAxisOptions, index) {
          if (!xAxisOptions.id) {
            xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
          }
        });
        helpers$1.each(scalesOptions.yAxes, function (yAxisOptions, index) {
          if (!yAxisOptions.id) {
            yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
          }
        });
        if (scaleOptions) {
          scaleOptions.id = scaleOptions.id || 'scale';
        }
      },
      buildOrUpdateScales: function buildOrUpdateScales() {
        var me = this;
        var options = me.options;
        var scales = me.scales || {};
        var items = [];
        var updated = Object.keys(scales).reduce(function (obj, id) {
          obj[id] = false;
          return obj;
        }, {});
        if (options.scales) {
          items = items.concat((options.scales.xAxes || []).map(function (xAxisOptions) {
            return {
              options: xAxisOptions,
              dtype: 'category',
              dposition: 'bottom'
            };
          }), (options.scales.yAxes || []).map(function (yAxisOptions) {
            return {
              options: yAxisOptions,
              dtype: 'linear',
              dposition: 'left'
            };
          }));
        }
        if (options.scale) {
          items.push({
            options: options.scale,
            dtype: 'radialLinear',
            isDefault: true,
            dposition: 'chartArea'
          });
        }
        helpers$1.each(items, function (item) {
          var scaleOptions = item.options;
          var id = scaleOptions.id;
          var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
          if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
            scaleOptions.position = item.dposition;
          }
          updated[id] = true;
          var scale = null;
          if (id in scales && scales[id].type === scaleType) {
            scale = scales[id];
            scale.options = scaleOptions;
            scale.ctx = me.ctx;
            scale.chart = me;
          } else {
            var scaleClass = core_scaleService.getScaleConstructor(scaleType);
            if (!scaleClass) {
              return;
            }
            scale = new scaleClass({
              id: id,
              type: scaleType,
              options: scaleOptions,
              ctx: me.ctx,
              chart: me
            });
            scales[scale.id] = scale;
          }
          scale.mergeTicksOptions();
          if (item.isDefault) {
            me.scale = scale;
          }
        });
        helpers$1.each(updated, function (hasUpdated, id) {
          if (!hasUpdated) {
            delete scales[id];
          }
        });
        me.scales = scales;
        core_scaleService.addScalesToLayout(this);
      },
      buildOrUpdateControllers: function buildOrUpdateControllers() {
        var me = this;
        var newControllers = [];
        var datasets = me.data.datasets;
        var i, ilen;
        for (i = 0, ilen = datasets.length; i < ilen; i++) {
          var dataset = datasets[i];
          var meta = me.getDatasetMeta(i);
          var type = dataset.type || me.config.type;
          if (meta.type && meta.type !== type) {
            me.destroyDatasetMeta(i);
            meta = me.getDatasetMeta(i);
          }
          meta.type = type;
          meta.order = dataset.order || 0;
          meta.index = i;
          if (meta.controller) {
            meta.controller.updateIndex(i);
            meta.controller.linkScales();
          } else {
            var ControllerClass = controllers[meta.type];
            if (ControllerClass === undefined) {
              throw new Error('"' + meta.type + '" is not a chart type.');
            }
            meta.controller = new ControllerClass(me, i);
            newControllers.push(meta.controller);
          }
        }
        return newControllers;
      },
      resetElements: function resetElements() {
        var me = this;
        helpers$1.each(me.data.datasets, function (dataset, datasetIndex) {
          me.getDatasetMeta(datasetIndex).controller.reset();
        }, me);
      },
      reset: function reset() {
        this.resetElements();
        this.tooltip.initialize();
      },
      update: function update(config) {
        var me = this;
        var i, ilen;
        if (!config || typeof config !== 'object') {
          config = {
            duration: config,
            lazy: arguments[1]
          };
        }
        updateConfig(me);
        core_plugins._invalidate(me);
        if (core_plugins.notify(me, 'beforeUpdate') === false) {
          return;
        }
        me.tooltip._data = me.data;
        var newControllers = me.buildOrUpdateControllers();
        for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
          me.getDatasetMeta(i).controller.buildOrUpdateElements();
        }
        me.updateLayout();
        if (me.options.animation && me.options.animation.duration) {
          helpers$1.each(newControllers, function (controller) {
            controller.reset();
          });
        }
        me.updateDatasets();
        me.tooltip.initialize();
        me.lastActive = [];
        core_plugins.notify(me, 'afterUpdate');
        me._layers.sort(compare2Level('z', '_idx'));
        if (me._bufferedRender) {
          me._bufferedRequest = {
            duration: config.duration,
            easing: config.easing,
            lazy: config.lazy
          };
        } else {
          me.render(config);
        }
      },
      updateLayout: function updateLayout() {
        var me = this;
        if (core_plugins.notify(me, 'beforeLayout') === false) {
          return;
        }
        core_layouts.update(this, this.width, this.height);
        me._layers = [];
        helpers$1.each(me.boxes, function (box) {
          if (box._configure) {
            box._configure();
          }
          me._layers.push.apply(me._layers, box._layers());
        }, me);
        me._layers.forEach(function (item, index) {
          item._idx = index;
        });
        core_plugins.notify(me, 'afterScaleUpdate');
        core_plugins.notify(me, 'afterLayout');
      },
      updateDatasets: function updateDatasets() {
        var me = this;
        if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
          return;
        }
        for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
          me.updateDataset(i);
        }
        core_plugins.notify(me, 'afterDatasetsUpdate');
      },
      updateDataset: function updateDataset(index) {
        var me = this;
        var meta = me.getDatasetMeta(index);
        var args = {
          meta: meta,
          index: index
        };
        if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
          return;
        }
        meta.controller._update();
        core_plugins.notify(me, 'afterDatasetUpdate', [args]);
      },
      render: function render(config) {
        var me = this;
        if (!config || typeof config !== 'object') {
          config = {
            duration: config,
            lazy: arguments[1]
          };
        }
        var animationOptions = me.options.animation;
        var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
        var lazy = config.lazy;
        if (core_plugins.notify(me, 'beforeRender') === false) {
          return;
        }
        var onComplete = function onComplete(animation) {
          core_plugins.notify(me, 'afterRender');
          helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
        };
        if (animationOptions && duration) {
          var animation = new core_animation({
            numSteps: duration / 16.66,
            easing: config.easing || animationOptions.easing,
            render: function render(chart, animationObject) {
              var easingFunction = helpers$1.easing.effects[animationObject.easing];
              var currentStep = animationObject.currentStep;
              var stepDecimal = currentStep / animationObject.numSteps;
              chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
            },
            onAnimationProgress: animationOptions.onProgress,
            onAnimationComplete: onComplete
          });
          core_animations.addAnimation(me, animation, duration, lazy);
        } else {
          me.draw();
          onComplete(new core_animation({
            numSteps: 0,
            chart: me
          }));
        }
        return me;
      },
      draw: function draw(easingValue) {
        var me = this;
        var i, layers;
        me.clear();
        if (helpers$1.isNullOrUndef(easingValue)) {
          easingValue = 1;
        }
        me.transition(easingValue);
        if (me.width <= 0 || me.height <= 0) {
          return;
        }
        if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
          return;
        }
        layers = me._layers;
        for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
          layers[i].draw(me.chartArea);
        }
        me.drawDatasets(easingValue);
        for (; i < layers.length; ++i) {
          layers[i].draw(me.chartArea);
        }
        me._drawTooltip(easingValue);
        core_plugins.notify(me, 'afterDraw', [easingValue]);
      },
      transition: function transition(easingValue) {
        var me = this;
        for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
          if (me.isDatasetVisible(i)) {
            me.getDatasetMeta(i).controller.transition(easingValue);
          }
        }
        me.tooltip.transition(easingValue);
      },
      _getSortedDatasetMetas: function _getSortedDatasetMetas(filterVisible) {
        var me = this;
        var datasets = me.data.datasets || [];
        var result = [];
        var i, ilen;
        for (i = 0, ilen = datasets.length; i < ilen; ++i) {
          if (!filterVisible || me.isDatasetVisible(i)) {
            result.push(me.getDatasetMeta(i));
          }
        }
        result.sort(compare2Level('order', 'index'));
        return result;
      },
      _getSortedVisibleDatasetMetas: function _getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
      },
      drawDatasets: function drawDatasets(easingValue) {
        var me = this;
        var metasets, i;
        if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
          return;
        }
        metasets = me._getSortedVisibleDatasetMetas();
        for (i = metasets.length - 1; i >= 0; --i) {
          me.drawDataset(metasets[i], easingValue);
        }
        core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
      },
      drawDataset: function drawDataset(meta, easingValue) {
        var me = this;
        var args = {
          meta: meta,
          index: meta.index,
          easingValue: easingValue
        };
        if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
          return;
        }
        meta.controller.draw(easingValue);
        core_plugins.notify(me, 'afterDatasetDraw', [args]);
      },
      _drawTooltip: function _drawTooltip(easingValue) {
        var me = this;
        var tooltip = me.tooltip;
        var args = {
          tooltip: tooltip,
          easingValue: easingValue
        };
        if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
          return;
        }
        tooltip.draw();
        core_plugins.notify(me, 'afterTooltipDraw', [args]);
      },
      getElementAtEvent: function getElementAtEvent(e) {
        return core_interaction.modes.single(this, e);
      },
      getElementsAtEvent: function getElementsAtEvent(e) {
        return core_interaction.modes.label(this, e, {
          intersect: true
        });
      },
      getElementsAtXAxis: function getElementsAtXAxis(e) {
        return core_interaction.modes['x-axis'](this, e, {
          intersect: true
        });
      },
      getElementsAtEventForMode: function getElementsAtEventForMode(e, mode, options) {
        var method = core_interaction.modes[mode];
        if (typeof method === 'function') {
          return method(this, e, options);
        }
        return [];
      },
      getDatasetAtEvent: function getDatasetAtEvent(e) {
        return core_interaction.modes.dataset(this, e, {
          intersect: true
        });
      },
      getDatasetMeta: function getDatasetMeta(datasetIndex) {
        var me = this;
        var dataset = me.data.datasets[datasetIndex];
        if (!dataset._meta) {
          dataset._meta = {};
        }
        var meta = dataset._meta[me.id];
        if (!meta) {
          meta = dataset._meta[me.id] = {
            type: null,
            data: [],
            dataset: null,
            controller: null,
            hidden: null,
            xAxisID: null,
            yAxisID: null,
            order: dataset.order || 0,
            index: datasetIndex
          };
        }
        return meta;
      },
      getVisibleDatasetCount: function getVisibleDatasetCount() {
        var count = 0;
        for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
          if (this.isDatasetVisible(i)) {
            count++;
          }
        }
        return count;
      },
      isDatasetVisible: function isDatasetVisible(datasetIndex) {
        var meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
      },
      generateLegend: function generateLegend() {
        return this.options.legendCallback(this);
      },
      destroyDatasetMeta: function destroyDatasetMeta(datasetIndex) {
        var id = this.id;
        var dataset = this.data.datasets[datasetIndex];
        var meta = dataset._meta && dataset._meta[id];
        if (meta) {
          meta.controller.destroy();
          delete dataset._meta[id];
        }
      },
      destroy: function destroy() {
        var me = this;
        var canvas = me.canvas;
        var i, ilen;
        me.stop();
        for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
          me.destroyDatasetMeta(i);
        }
        if (canvas) {
          me.unbindEvents();
          helpers$1.canvas.clear(me);
          platform.releaseContext(me.ctx);
          me.canvas = null;
          me.ctx = null;
        }
        core_plugins.notify(me, 'destroy');
        delete Chart.instances[me.id];
      },
      toBase64Image: function toBase64Image() {
        return this.canvas.toDataURL.apply(this.canvas, arguments);
      },
      initToolTip: function initToolTip() {
        var me = this;
        me.tooltip = new core_tooltip({
          _chart: me,
          _chartInstance: me,
          _data: me.data,
          _options: me.options.tooltips
        }, me);
      },
      bindEvents: function bindEvents() {
        var me = this;
        var listeners = me._listeners = {};
        var listener = function listener() {
          me.eventHandler.apply(me, arguments);
        };
        helpers$1.each(me.options.events, function (type) {
          platform.addEventListener(me, type, listener);
          listeners[type] = listener;
        });
        if (me.options.responsive) {
          listener = function listener() {
            me.resize();
          };
          platform.addEventListener(me, 'resize', listener);
          listeners.resize = listener;
        }
      },
      unbindEvents: function unbindEvents() {
        var me = this;
        var listeners = me._listeners;
        if (!listeners) {
          return;
        }
        delete me._listeners;
        helpers$1.each(listeners, function (listener, type) {
          platform.removeEventListener(me, type, listener);
        });
      },
      updateHoverStyle: function updateHoverStyle(elements, mode, enabled) {
        var prefix = enabled ? 'set' : 'remove';
        var element, i, ilen;
        for (i = 0, ilen = elements.length; i < ilen; ++i) {
          element = elements[i];
          if (element) {
            this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
          }
        }
        if (mode === 'dataset') {
          this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
        }
      },
      eventHandler: function eventHandler(e) {
        var me = this;
        var tooltip = me.tooltip;
        if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
          return;
        }
        me._bufferedRender = true;
        me._bufferedRequest = null;
        var changed = me.handleEvent(e);
        if (tooltip) {
          changed = tooltip._start ? tooltip.handleEvent(e) : changed | tooltip.handleEvent(e);
        }
        core_plugins.notify(me, 'afterEvent', [e]);
        var bufferedRequest = me._bufferedRequest;
        if (bufferedRequest) {
          me.render(bufferedRequest);
        } else if (changed && !me.animating) {
          me.stop();
          me.render({
            duration: me.options.hover.animationDuration,
            lazy: true
          });
        }
        me._bufferedRender = false;
        me._bufferedRequest = null;
        return me;
      },
      handleEvent: function handleEvent(e) {
        var me = this;
        var options = me.options || {};
        var hoverOptions = options.hover;
        var changed = false;
        me.lastActive = me.lastActive || [];
        if (e.type === 'mouseout') {
          me.active = [];
        } else {
          me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
        }
        helpers$1.callback(options.onHover || options.hover.onHover, [e["native"], me.active], me);
        if (e.type === 'mouseup' || e.type === 'click') {
          if (options.onClick) {
            options.onClick.call(me, e["native"], me.active);
          }
        }
        if (me.lastActive.length) {
          me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
        }
        if (me.active.length && hoverOptions.mode) {
          me.updateHoverStyle(me.active, hoverOptions.mode, true);
        }
        changed = !helpers$1.arrayEquals(me.active, me.lastActive);
        me.lastActive = me.active;
        return changed;
      }
    });
    Chart.instances = {};
    var core_controller = Chart;
    Chart.Controller = Chart;
    Chart.types = {};
    helpers$1.configMerge = mergeConfig;
    helpers$1.scaleMerge = mergeScaleConfig;
    var core_helpers = function core_helpers() {
      helpers$1.where = function (collection, filterCallback) {
        if (helpers$1.isArray(collection) && Array.prototype.filter) {
          return collection.filter(filterCallback);
        }
        var filtered = [];
        helpers$1.each(collection, function (item) {
          if (filterCallback(item)) {
            filtered.push(item);
          }
        });
        return filtered;
      };
      helpers$1.findIndex = Array.prototype.findIndex ? function (array, callback, scope) {
        return array.findIndex(callback, scope);
      } : function (array, callback, scope) {
        scope = scope === undefined ? array : scope;
        for (var i = 0, ilen = array.length; i < ilen; ++i) {
          if (callback.call(scope, array[i], i, array)) {
            return i;
          }
        }
        return -1;
      };
      helpers$1.findNextWhere = function (arrayToSearch, filterCallback, startIndex) {
        if (helpers$1.isNullOrUndef(startIndex)) {
          startIndex = -1;
        }
        for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
          var currentItem = arrayToSearch[i];
          if (filterCallback(currentItem)) {
            return currentItem;
          }
        }
      };
      helpers$1.findPreviousWhere = function (arrayToSearch, filterCallback, startIndex) {
        if (helpers$1.isNullOrUndef(startIndex)) {
          startIndex = arrayToSearch.length;
        }
        for (var i = startIndex - 1; i >= 0; i--) {
          var currentItem = arrayToSearch[i];
          if (filterCallback(currentItem)) {
            return currentItem;
          }
        }
      };
      helpers$1.isNumber = function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
      };
      helpers$1.almostEquals = function (x, y, epsilon) {
        return Math.abs(x - y) < epsilon;
      };
      helpers$1.almostWhole = function (x, epsilon) {
        var rounded = Math.round(x);
        return rounded - epsilon <= x && rounded + epsilon >= x;
      };
      helpers$1.max = function (array) {
        return array.reduce(function (max, value) {
          if (!isNaN(value)) {
            return Math.max(max, value);
          }
          return max;
        }, Number.NEGATIVE_INFINITY);
      };
      helpers$1.min = function (array) {
        return array.reduce(function (min, value) {
          if (!isNaN(value)) {
            return Math.min(min, value);
          }
          return min;
        }, Number.POSITIVE_INFINITY);
      };
      helpers$1.sign = Math.sign ? function (x) {
        return Math.sign(x);
      } : function (x) {
        x = +x;
        if (x === 0 || isNaN(x)) {
          return x;
        }
        return x > 0 ? 1 : -1;
      };
      helpers$1.toRadians = function (degrees) {
        return degrees * (Math.PI / 180);
      };
      helpers$1.toDegrees = function (radians) {
        return radians * (180 / Math.PI);
      };
      helpers$1._decimalPlaces = function (x) {
        if (!helpers$1.isFinite(x)) {
          return;
        }
        var e = 1;
        var p = 0;
        while (Math.round(x * e) / e !== x) {
          e *= 10;
          p++;
        }
        return p;
      };
      helpers$1.getAngleFromPoint = function (centrePoint, anglePoint) {
        var distanceFromXCenter = anglePoint.x - centrePoint.x;
        var distanceFromYCenter = anglePoint.y - centrePoint.y;
        var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
        var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
        if (angle < -0.5 * Math.PI) {
          angle += 2.0 * Math.PI;
        }
        return {
          angle: angle,
          distance: radialDistanceFromCenter
        };
      };
      helpers$1.distanceBetweenPoints = function (pt1, pt2) {
        return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
      };
      helpers$1.aliasPixel = function (pixelWidth) {
        return pixelWidth % 2 === 0 ? 0 : 0.5;
      };
      helpers$1._alignPixel = function (chart, pixel, width) {
        var devicePixelRatio = chart.currentDevicePixelRatio;
        var halfWidth = width / 2;
        return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
      };
      helpers$1.splineCurve = function (firstPoint, middlePoint, afterPoint, t) {
        var previous = firstPoint.skip ? middlePoint : firstPoint;
        var current = middlePoint;
        var next = afterPoint.skip ? middlePoint : afterPoint;
        var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
        var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
        var s01 = d01 / (d01 + d12);
        var s12 = d12 / (d01 + d12);
        s01 = isNaN(s01) ? 0 : s01;
        s12 = isNaN(s12) ? 0 : s12;
        var fa = t * s01;
        var fb = t * s12;
        return {
          previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
          },
          next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
          }
        };
      };
      helpers$1.EPSILON = Number.EPSILON || 1e-14;
      helpers$1.splineCurveMonotone = function (points) {
        var pointsWithTangents = (points || []).map(function (point) {
          return {
            model: point._model,
            deltaK: 0,
            mK: 0
          };
        });
        var pointsLen = pointsWithTangents.length;
        var i, pointBefore, pointCurrent, pointAfter;
        for (i = 0; i < pointsLen; ++i) {
          pointCurrent = pointsWithTangents[i];
          if (pointCurrent.model.skip) {
            continue;
          }
          pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
          pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
          if (pointAfter && !pointAfter.model.skip) {
            var slopeDeltaX = pointAfter.model.x - pointCurrent.model.x;
            pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
          }
          if (!pointBefore || pointBefore.model.skip) {
            pointCurrent.mK = pointCurrent.deltaK;
          } else if (!pointAfter || pointAfter.model.skip) {
            pointCurrent.mK = pointBefore.deltaK;
          } else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
            pointCurrent.mK = 0;
          } else {
            pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
          }
        }
        var alphaK, betaK, tauK, squaredMagnitude;
        for (i = 0; i < pointsLen - 1; ++i) {
          pointCurrent = pointsWithTangents[i];
          pointAfter = pointsWithTangents[i + 1];
          if (pointCurrent.model.skip || pointAfter.model.skip) {
            continue;
          }
          if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
            pointCurrent.mK = pointAfter.mK = 0;
            continue;
          }
          alphaK = pointCurrent.mK / pointCurrent.deltaK;
          betaK = pointAfter.mK / pointCurrent.deltaK;
          squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
          if (squaredMagnitude <= 9) {
            continue;
          }
          tauK = 3 / Math.sqrt(squaredMagnitude);
          pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
          pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
        }
        var deltaX;
        for (i = 0; i < pointsLen; ++i) {
          pointCurrent = pointsWithTangents[i];
          if (pointCurrent.model.skip) {
            continue;
          }
          pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
          pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
          if (pointBefore && !pointBefore.model.skip) {
            deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
            pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
            pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
          }
          if (pointAfter && !pointAfter.model.skip) {
            deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
            pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
            pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
          }
        }
      };
      helpers$1.nextItem = function (collection, index, loop) {
        if (loop) {
          return index >= collection.length - 1 ? collection[0] : collection[index + 1];
        }
        return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
      };
      helpers$1.previousItem = function (collection, index, loop) {
        if (loop) {
          return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
        }
        return index <= 0 ? collection[0] : collection[index - 1];
      };
      helpers$1.niceNum = function (range, round) {
        var exponent = Math.floor(helpers$1.log10(range));
        var fraction = range / Math.pow(10, exponent);
        var niceFraction;
        if (round) {
          if (fraction < 1.5) {
            niceFraction = 1;
          } else if (fraction < 3) {
            niceFraction = 2;
          } else if (fraction < 7) {
            niceFraction = 5;
          } else {
            niceFraction = 10;
          }
        } else if (fraction <= 1.0) {
          niceFraction = 1;
        } else if (fraction <= 2) {
          niceFraction = 2;
        } else if (fraction <= 5) {
          niceFraction = 5;
        } else {
          niceFraction = 10;
        }
        return niceFraction * Math.pow(10, exponent);
      };
      helpers$1.requestAnimFrame = function () {
        if (typeof window === 'undefined') {
          return function (callback) {
            callback();
          };
        }
        return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
          return window.setTimeout(callback, 1000 / 60);
        };
      }();
      helpers$1.getRelativePosition = function (evt, chart) {
        var mouseX, mouseY;
        var e = evt.originalEvent || evt;
        var canvas = evt.target || evt.srcElement;
        var boundingRect = canvas.getBoundingClientRect();
        var touches = e.touches;
        if (touches && touches.length > 0) {
          mouseX = touches[0].clientX;
          mouseY = touches[0].clientY;
        } else {
          mouseX = e.clientX;
          mouseY = e.clientY;
        }
        var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
        var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
        var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
        var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
        var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
        var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
        mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / width * canvas.width / chart.currentDevicePixelRatio);
        mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / height * canvas.height / chart.currentDevicePixelRatio);
        return {
          x: mouseX,
          y: mouseY
        };
      };
      function parseMaxStyle(styleValue, node, parentProperty) {
        var valueInPixels;
        if (typeof styleValue === 'string') {
          valueInPixels = parseInt(styleValue, 10);
          if (styleValue.indexOf('%') !== -1) {
            valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
          }
        } else {
          valueInPixels = styleValue;
        }
        return valueInPixels;
      }
      function isConstrainedValue(value) {
        return value !== undefined && value !== null && value !== 'none';
      }
      function getConstraintDimension(domNode, maxStyle, percentageProperty) {
        var view = document.defaultView;
        var parentNode = helpers$1._getParentNode(domNode);
        var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
        var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
        var hasCNode = isConstrainedValue(constrainedNode);
        var hasCContainer = isConstrainedValue(constrainedContainer);
        var infinity = Number.POSITIVE_INFINITY;
        if (hasCNode || hasCContainer) {
          return Math.min(hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity, hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
        }
        return 'none';
      }
      helpers$1.getConstraintWidth = function (domNode) {
        return getConstraintDimension(domNode, 'max-width', 'clientWidth');
      };
      helpers$1.getConstraintHeight = function (domNode) {
        return getConstraintDimension(domNode, 'max-height', 'clientHeight');
      };
      helpers$1._calculatePadding = function (container, padding, parentDimension) {
        padding = helpers$1.getStyle(container, padding);
        return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
      };
      helpers$1._getParentNode = function (domNode) {
        var parent = domNode.parentNode;
        if (parent && parent.toString() === '[object ShadowRoot]') {
          parent = parent.host;
        }
        return parent;
      };
      helpers$1.getMaximumWidth = function (domNode) {
        var container = helpers$1._getParentNode(domNode);
        if (!container) {
          return domNode.clientWidth;
        }
        var clientWidth = container.clientWidth;
        var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
        var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
        var w = clientWidth - paddingLeft - paddingRight;
        var cw = helpers$1.getConstraintWidth(domNode);
        return isNaN(cw) ? w : Math.min(w, cw);
      };
      helpers$1.getMaximumHeight = function (domNode) {
        var container = helpers$1._getParentNode(domNode);
        if (!container) {
          return domNode.clientHeight;
        }
        var clientHeight = container.clientHeight;
        var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
        var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
        var h = clientHeight - paddingTop - paddingBottom;
        var ch = helpers$1.getConstraintHeight(domNode);
        return isNaN(ch) ? h : Math.min(h, ch);
      };
      helpers$1.getStyle = function (el, property) {
        return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
      };
      helpers$1.retinaScale = function (chart, forceRatio) {
        var pixelRatio = chart.currentDevicePixelRatio = forceRatio || typeof window !== 'undefined' && window.devicePixelRatio || 1;
        if (pixelRatio === 1) {
          return;
        }
        var canvas = chart.canvas;
        var height = chart.height;
        var width = chart.width;
        canvas.height = height * pixelRatio;
        canvas.width = width * pixelRatio;
        chart.ctx.scale(pixelRatio, pixelRatio);
        if (!canvas.style.height && !canvas.style.width) {
          canvas.style.height = height + 'px';
          canvas.style.width = width + 'px';
        }
      };
      helpers$1.fontString = function (pixelSize, fontStyle, fontFamily) {
        return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
      };
      helpers$1.longestText = function (ctx, font, arrayOfThings, cache) {
        cache = cache || {};
        var data = cache.data = cache.data || {};
        var gc = cache.garbageCollect = cache.garbageCollect || [];
        if (cache.font !== font) {
          data = cache.data = {};
          gc = cache.garbageCollect = [];
          cache.font = font;
        }
        ctx.font = font;
        var longest = 0;
        var ilen = arrayOfThings.length;
        var i, j, jlen, thing, nestedThing;
        for (i = 0; i < ilen; i++) {
          thing = arrayOfThings[i];
          if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
            longest = helpers$1.measureText(ctx, data, gc, longest, thing);
          } else if (helpers$1.isArray(thing)) {
            for (j = 0, jlen = thing.length; j < jlen; j++) {
              nestedThing = thing[j];
              if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
                longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
              }
            }
          }
        }
        var gcLen = gc.length / 2;
        if (gcLen > arrayOfThings.length) {
          for (i = 0; i < gcLen; i++) {
            delete data[gc[i]];
          }
          gc.splice(0, gcLen);
        }
        return longest;
      };
      helpers$1.measureText = function (ctx, data, gc, longest, string) {
        var textWidth = data[string];
        if (!textWidth) {
          textWidth = data[string] = ctx.measureText(string).width;
          gc.push(string);
        }
        if (textWidth > longest) {
          longest = textWidth;
        }
        return longest;
      };
      helpers$1.numberOfLabelLines = function (arrayOfThings) {
        var numberOfLines = 1;
        helpers$1.each(arrayOfThings, function (thing) {
          if (helpers$1.isArray(thing)) {
            if (thing.length > numberOfLines) {
              numberOfLines = thing.length;
            }
          }
        });
        return numberOfLines;
      };
      helpers$1.color = !chartjsColor ? function (value) {
        console.error('Color.js not found!');
        return value;
      } : function (value) {
        if (value instanceof CanvasGradient) {
          value = core_defaults.global.defaultColor;
        }
        return chartjsColor(value);
      };
      helpers$1.getHoverColor = function (colorValue) {
        return colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient ? colorValue : helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
      };
    };
    function _abstract() {
      throw new Error('This method is not implemented: either no adapter can ' + 'be found or an incomplete integration was provided.');
    }
    function DateAdapter(options) {
      this.options = options || {};
    }
    helpers$1.extend(DateAdapter.prototype, {
      formats: _abstract,
      parse: _abstract,
      format: _abstract,
      add: _abstract,
      diff: _abstract,
      startOf: _abstract,
      endOf: _abstract,
      _create: function _create(value) {
        return value;
      }
    });
    DateAdapter.override = function (members) {
      helpers$1.extend(DateAdapter.prototype, members);
    };
    var _date = DateAdapter;
    var core_adapters = {
      _date: _date
    };
    var core_ticks = {
      formatters: {
        values: function values(value) {
          return helpers$1.isArray(value) ? value : '' + value;
        },
        linear: function linear(tickValue, index, ticks) {
          var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
          if (Math.abs(delta) > 1) {
            if (tickValue !== Math.floor(tickValue)) {
              delta = tickValue - Math.floor(tickValue);
            }
          }
          var logDelta = helpers$1.log10(Math.abs(delta));
          var tickString = '';
          if (tickValue !== 0) {
            var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
            if (maxTick < 1e-4) {
              var logTick = helpers$1.log10(Math.abs(tickValue));
              var numExponential = Math.floor(logTick) - Math.floor(logDelta);
              numExponential = Math.max(Math.min(numExponential, 20), 0);
              tickString = tickValue.toExponential(numExponential);
            } else {
              var numDecimal = -1 * Math.floor(logDelta);
              numDecimal = Math.max(Math.min(numDecimal, 20), 0);
              tickString = tickValue.toFixed(numDecimal);
            }
          } else {
            tickString = '0';
          }
          return tickString;
        },
        logarithmic: function logarithmic(tickValue, index, ticks) {
          var remain = tickValue / Math.pow(10, Math.floor(helpers$1.log10(tickValue)));
          if (tickValue === 0) {
            return '0';
          } else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
            return tickValue.toExponential();
          }
          return '';
        }
      }
    };
    var isArray = helpers$1.isArray;
    var isNullOrUndef = helpers$1.isNullOrUndef;
    var valueOrDefault$a = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
    core_defaults._set('scale', {
      display: true,
      position: 'left',
      offset: false,
      gridLines: {
        display: true,
        color: 'rgba(0,0,0,0.1)',
        lineWidth: 1,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true,
        tickMarkLength: 10,
        zeroLineWidth: 1,
        zeroLineColor: 'rgba(0,0,0,0.25)',
        zeroLineBorderDash: [],
        zeroLineBorderDashOffset: 0.0,
        offsetGridLines: false,
        borderDash: [],
        borderDashOffset: 0.0
      },
      scaleLabel: {
        display: false,
        labelString: '',
        padding: {
          top: 4,
          bottom: 4
        }
      },
      ticks: {
        beginAtZero: false,
        minRotation: 0,
        maxRotation: 50,
        mirror: false,
        padding: 0,
        reverse: false,
        display: true,
        autoSkip: true,
        autoSkipPadding: 0,
        labelOffset: 0,
        callback: core_ticks.formatters.values,
        minor: {},
        major: {}
      }
    });
    function sample(arr, numItems) {
      var result = [];
      var increment = arr.length / numItems;
      var i = 0;
      var len = arr.length;
      for (; i < len; i += increment) {
        result.push(arr[Math.floor(i)]);
      }
      return result;
    }
    function getPixelForGridLine(scale, index, offsetGridLines) {
      var length = scale.getTicks().length;
      var validIndex = Math.min(index, length - 1);
      var lineValue = scale.getPixelForTick(validIndex);
      var start = scale._startPixel;
      var end = scale._endPixel;
      var epsilon = 1e-6;
      var offset;
      if (offsetGridLines) {
        if (length === 1) {
          offset = Math.max(lineValue - start, end - lineValue);
        } else if (index === 0) {
          offset = (scale.getPixelForTick(1) - lineValue) / 2;
        } else {
          offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        }
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) {
          return;
        }
      }
      return lineValue;
    }
    function garbageCollect(caches, length) {
      helpers$1.each(caches, function (cache) {
        var gc = cache.gc;
        var gcLen = gc.length / 2;
        var i;
        if (gcLen > length) {
          for (i = 0; i < gcLen; ++i) {
            delete cache.data[gc[i]];
          }
          gc.splice(0, gcLen);
        }
      });
    }
    function computeLabelSizes(ctx, tickFonts, ticks, caches) {
      var length = ticks.length;
      var widths = [];
      var heights = [];
      var offsets = [];
      var widestLabelSize = 0;
      var highestLabelSize = 0;
      var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
      for (i = 0; i < length; ++i) {
        label = ticks[i].label;
        tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
        ctx.font = fontString = tickFont.string;
        cache = caches[fontString] = caches[fontString] || {
          data: {},
          gc: []
        };
        lineHeight = tickFont.lineHeight;
        width = height = 0;
        if (!isNullOrUndef(label) && !isArray(label)) {
          width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
          height = lineHeight;
        } else if (isArray(label)) {
          for (j = 0, jlen = label.length; j < jlen; ++j) {
            nestedLabel = label[j];
            if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
              width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
              height += lineHeight;
            }
          }
        }
        widths.push(width);
        heights.push(height);
        offsets.push(lineHeight / 2);
        widestLabelSize = Math.max(width, widestLabelSize);
        highestLabelSize = Math.max(height, highestLabelSize);
      }
      garbageCollect(caches, length);
      widest = widths.indexOf(widestLabelSize);
      highest = heights.indexOf(highestLabelSize);
      function valueAt(idx) {
        return {
          width: widths[idx] || 0,
          height: heights[idx] || 0,
          offset: offsets[idx] || 0
        };
      }
      return {
        first: valueAt(0),
        last: valueAt(length - 1),
        widest: valueAt(widest),
        highest: valueAt(highest)
      };
    }
    function getTickMarkLength(options) {
      return options.drawTicks ? options.tickMarkLength : 0;
    }
    function getScaleLabelHeight(options) {
      var font, padding;
      if (!options.display) {
        return 0;
      }
      font = helpers$1.options._parseFont(options);
      padding = helpers$1.options.toPadding(options.padding);
      return font.lineHeight + padding.height;
    }
    function parseFontOptions(options, nestedOpts) {
      return helpers$1.extend(helpers$1.options._parseFont({
        fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
        fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
        fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
        lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
      }), {
        color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
      });
    }
    function parseTickFontOptions(options) {
      var minor = parseFontOptions(options, options.minor);
      var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
      return {
        minor: minor,
        major: major
      };
    }
    function nonSkipped(ticksToFilter) {
      var filtered = [];
      var item, index, len;
      for (index = 0, len = ticksToFilter.length; index < len; ++index) {
        item = ticksToFilter[index];
        if (typeof item._index !== 'undefined') {
          filtered.push(item);
        }
      }
      return filtered;
    }
    function getEvenSpacing(arr) {
      var len = arr.length;
      var i, diff;
      if (len < 2) {
        return false;
      }
      for (diff = arr[0], i = 1; i < len; ++i) {
        if (arr[i] - arr[i - 1] !== diff) {
          return false;
        }
      }
      return diff;
    }
    function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
      var evenMajorSpacing = getEvenSpacing(majorIndices);
      var spacing = (ticks.length - 1) / ticksLimit;
      var factors, factor, i, ilen;
      if (!evenMajorSpacing) {
        return Math.max(spacing, 1);
      }
      factors = helpers$1.math._factorize(evenMajorSpacing);
      for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
        factor = factors[i];
        if (factor > spacing) {
          return factor;
        }
      }
      return Math.max(spacing, 1);
    }
    function getMajorIndices(ticks) {
      var result = [];
      var i, ilen;
      for (i = 0, ilen = ticks.length; i < ilen; i++) {
        if (ticks[i].major) {
          result.push(i);
        }
      }
      return result;
    }
    function skipMajors(ticks, majorIndices, spacing) {
      var count = 0;
      var next = majorIndices[0];
      var i, tick;
      spacing = Math.ceil(spacing);
      for (i = 0; i < ticks.length; i++) {
        tick = ticks[i];
        if (i === next) {
          tick._index = i;
          count++;
          next = majorIndices[count * spacing];
        } else {
          delete tick.label;
        }
      }
    }
    function skip(ticks, spacing, majorStart, majorEnd) {
      var start = valueOrDefault$a(majorStart, 0);
      var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
      var count = 0;
      var length, i, tick, next;
      spacing = Math.ceil(spacing);
      if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
      }
      next = start;
      while (next < 0) {
        count++;
        next = Math.round(start + count * spacing);
      }
      for (i = Math.max(start, 0); i < end; i++) {
        tick = ticks[i];
        if (i === next) {
          tick._index = i;
          count++;
          next = Math.round(start + count * spacing);
        } else {
          delete tick.label;
        }
      }
    }
    var Scale = core_element.extend({
      zeroLineIndex: 0,
      getPadding: function getPadding() {
        var me = this;
        return {
          left: me.paddingLeft || 0,
          top: me.paddingTop || 0,
          right: me.paddingRight || 0,
          bottom: me.paddingBottom || 0
        };
      },
      getTicks: function getTicks() {
        return this._ticks;
      },
      _getLabels: function _getLabels() {
        var data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
      },
      mergeTicksOptions: function mergeTicksOptions() {},
      beforeUpdate: function beforeUpdate() {
        helpers$1.callback(this.options.beforeUpdate, [this]);
      },
      update: function update(maxWidth, maxHeight, margins) {
        var me = this;
        var tickOpts = me.options.ticks;
        var sampleSize = tickOpts.sampleSize;
        var i, ilen, labels, ticks, samplingEnabled;
        me.beforeUpdate();
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me.margins = helpers$1.extend({
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }, margins);
        me._ticks = null;
        me.ticks = null;
        me._labelSizes = null;
        me._maxLabelLines = 0;
        me.longestLabelWidth = 0;
        me.longestTextCache = me.longestTextCache || {};
        me._gridLineItems = null;
        me._labelItems = null;
        me.beforeSetDimensions();
        me.setDimensions();
        me.afterSetDimensions();
        me.beforeDataLimits();
        me.determineDataLimits();
        me.afterDataLimits();
        me.beforeBuildTicks();
        ticks = me.buildTicks() || [];
        ticks = me.afterBuildTicks(ticks) || ticks;
        if ((!ticks || !ticks.length) && me.ticks) {
          ticks = [];
          for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
            ticks.push({
              value: me.ticks[i],
              major: false
            });
          }
        }
        me._ticks = ticks;
        samplingEnabled = sampleSize < ticks.length;
        labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
        me._configure();
        me.beforeCalculateTickRotation();
        me.calculateTickRotation();
        me.afterCalculateTickRotation();
        me.beforeFit();
        me.fit();
        me.afterFit();
        me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
        if (samplingEnabled) {
          labels = me._convertTicksToLabels(me._ticksToDraw);
        }
        me.ticks = labels;
        me.afterUpdate();
        return me.minSize;
      },
      _configure: function _configure() {
        var me = this;
        var reversePixels = me.options.ticks.reverse;
        var startPixel, endPixel;
        if (me.isHorizontal()) {
          startPixel = me.left;
          endPixel = me.right;
        } else {
          startPixel = me.top;
          endPixel = me.bottom;
          reversePixels = !reversePixels;
        }
        me._startPixel = startPixel;
        me._endPixel = endPixel;
        me._reversePixels = reversePixels;
        me._length = endPixel - startPixel;
      },
      afterUpdate: function afterUpdate() {
        helpers$1.callback(this.options.afterUpdate, [this]);
      },
      beforeSetDimensions: function beforeSetDimensions() {
        helpers$1.callback(this.options.beforeSetDimensions, [this]);
      },
      setDimensions: function setDimensions() {
        var me = this;
        if (me.isHorizontal()) {
          me.width = me.maxWidth;
          me.left = 0;
          me.right = me.width;
        } else {
          me.height = me.maxHeight;
          me.top = 0;
          me.bottom = me.height;
        }
        me.paddingLeft = 0;
        me.paddingTop = 0;
        me.paddingRight = 0;
        me.paddingBottom = 0;
      },
      afterSetDimensions: function afterSetDimensions() {
        helpers$1.callback(this.options.afterSetDimensions, [this]);
      },
      beforeDataLimits: function beforeDataLimits() {
        helpers$1.callback(this.options.beforeDataLimits, [this]);
      },
      determineDataLimits: helpers$1.noop,
      afterDataLimits: function afterDataLimits() {
        helpers$1.callback(this.options.afterDataLimits, [this]);
      },
      beforeBuildTicks: function beforeBuildTicks() {
        helpers$1.callback(this.options.beforeBuildTicks, [this]);
      },
      buildTicks: helpers$1.noop,
      afterBuildTicks: function afterBuildTicks(ticks) {
        var me = this;
        if (isArray(ticks) && ticks.length) {
          return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
        }
        me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
        return ticks;
      },
      beforeTickToLabelConversion: function beforeTickToLabelConversion() {
        helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
      },
      convertTicksToLabels: function convertTicksToLabels() {
        var me = this;
        var tickOpts = me.options.ticks;
        me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
      },
      afterTickToLabelConversion: function afterTickToLabelConversion() {
        helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
      },
      beforeCalculateTickRotation: function beforeCalculateTickRotation() {
        helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
      },
      calculateTickRotation: function calculateTickRotation() {
        var me = this;
        var options = me.options;
        var tickOpts = options.ticks;
        var numTicks = me.getTicks().length;
        var minRotation = tickOpts.minRotation || 0;
        var maxRotation = tickOpts.maxRotation;
        var labelRotation = minRotation;
        var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
        if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
          me.labelRotation = minRotation;
          return;
        }
        labelSizes = me._getLabelSizes();
        maxLabelWidth = labelSizes.widest.width;
        maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
        maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
        tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
          tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
          maxHeight = me.maxHeight - getTickMarkLength(options.gridLines) - tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
          maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
          labelRotation = helpers$1.toDegrees(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
          labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        me.labelRotation = labelRotation;
      },
      afterCalculateTickRotation: function afterCalculateTickRotation() {
        helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
      },
      beforeFit: function beforeFit() {
        helpers$1.callback(this.options.beforeFit, [this]);
      },
      fit: function fit() {
        var me = this;
        var minSize = me.minSize = {
          width: 0,
          height: 0
        };
        var chart = me.chart;
        var opts = me.options;
        var tickOpts = opts.ticks;
        var scaleLabelOpts = opts.scaleLabel;
        var gridLineOpts = opts.gridLines;
        var display = me._isVisible();
        var isBottom = opts.position === 'bottom';
        var isHorizontal = me.isHorizontal();
        if (isHorizontal) {
          minSize.width = me.maxWidth;
        } else if (display) {
          minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
        }
        if (!isHorizontal) {
          minSize.height = me.maxHeight;
        } else if (display) {
          minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
        }
        if (tickOpts.display && display) {
          var tickFonts = parseTickFontOptions(tickOpts);
          var labelSizes = me._getLabelSizes();
          var firstLabelSize = labelSizes.first;
          var lastLabelSize = labelSizes.last;
          var widestLabelSize = labelSizes.widest;
          var highestLabelSize = labelSizes.highest;
          var lineSpace = tickFonts.minor.lineHeight * 0.4;
          var tickPadding = tickOpts.padding;
          if (isHorizontal) {
            var isRotated = me.labelRotation !== 0;
            var angleRadians = helpers$1.toRadians(me.labelRotation);
            var cosRotation = Math.cos(angleRadians);
            var sinRotation = Math.sin(angleRadians);
            var labelHeight = sinRotation * widestLabelSize.width + cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0)) + (isRotated ? 0 : lineSpace);
            minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
            var offsetLeft = me.getPixelForTick(0) - me.left;
            var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
            var paddingLeft, paddingRight;
            if (isRotated) {
              paddingLeft = isBottom ? cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset : sinRotation * (firstLabelSize.height - firstLabelSize.offset);
              paddingRight = isBottom ? sinRotation * (lastLabelSize.height - lastLabelSize.offset) : cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
            } else {
              paddingLeft = firstLabelSize.width / 2;
              paddingRight = lastLabelSize.width / 2;
            }
            me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
            me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
          } else {
            var labelWidth = tickOpts.mirror ? 0 : widestLabelSize.width + tickPadding + lineSpace;
            minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
            me.paddingTop = firstLabelSize.height / 2;
            me.paddingBottom = lastLabelSize.height / 2;
          }
        }
        me.handleMargins();
        if (isHorizontal) {
          me.width = me._length = chart.width - me.margins.left - me.margins.right;
          me.height = minSize.height;
        } else {
          me.width = minSize.width;
          me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
        }
      },
      handleMargins: function handleMargins() {
        var me = this;
        if (me.margins) {
          me.margins.left = Math.max(me.paddingLeft, me.margins.left);
          me.margins.top = Math.max(me.paddingTop, me.margins.top);
          me.margins.right = Math.max(me.paddingRight, me.margins.right);
          me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
        }
      },
      afterFit: function afterFit() {
        helpers$1.callback(this.options.afterFit, [this]);
      },
      isHorizontal: function isHorizontal() {
        var pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
      },
      isFullWidth: function isFullWidth() {
        return this.options.fullWidth;
      },
      getRightValue: function getRightValue(rawValue) {
        if (isNullOrUndef(rawValue)) {
          return NaN;
        }
        if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
          return NaN;
        }
        if (rawValue) {
          if (this.isHorizontal()) {
            if (rawValue.x !== undefined) {
              return this.getRightValue(rawValue.x);
            }
          } else if (rawValue.y !== undefined) {
            return this.getRightValue(rawValue.y);
          }
        }
        return rawValue;
      },
      _convertTicksToLabels: function _convertTicksToLabels(ticks) {
        var me = this;
        var labels, i, ilen;
        me.ticks = ticks.map(function (tick) {
          return tick.value;
        });
        me.beforeTickToLabelConversion();
        labels = me.convertTicksToLabels(ticks) || me.ticks;
        me.afterTickToLabelConversion();
        for (i = 0, ilen = ticks.length; i < ilen; ++i) {
          ticks[i].label = labels[i];
        }
        return labels;
      },
      _getLabelSizes: function _getLabelSizes() {
        var me = this;
        var labelSizes = me._labelSizes;
        if (!labelSizes) {
          me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
          me.longestLabelWidth = labelSizes.widest.width;
        }
        return labelSizes;
      },
      _parseValue: function _parseValue(value) {
        var start, end, min, max;
        if (isArray(value)) {
          start = +this.getRightValue(value[0]);
          end = +this.getRightValue(value[1]);
          min = Math.min(start, end);
          max = Math.max(start, end);
        } else {
          value = +this.getRightValue(value);
          start = undefined;
          end = value;
          min = value;
          max = value;
        }
        return {
          min: min,
          max: max,
          start: start,
          end: end
        };
      },
      _getScaleLabel: function _getScaleLabel(rawValue) {
        var v = this._parseValue(rawValue);
        if (v.start !== undefined) {
          return '[' + v.start + ', ' + v.end + ']';
        }
        return +this.getRightValue(rawValue);
      },
      getLabelForIndex: helpers$1.noop,
      getPixelForValue: helpers$1.noop,
      getValueForPixel: helpers$1.noop,
      getPixelForTick: function getPixelForTick(index) {
        var me = this;
        var offset = me.options.offset;
        var numTicks = me._ticks.length;
        var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
        return index < 0 || index > numTicks - 1 ? null : me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
      },
      getPixelForDecimal: function getPixelForDecimal(decimal) {
        var me = this;
        if (me._reversePixels) {
          decimal = 1 - decimal;
        }
        return me._startPixel + decimal * me._length;
      },
      getDecimalForPixel: function getDecimalForPixel(pixel) {
        var decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
      },
      getBasePixel: function getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
      },
      getBaseValue: function getBaseValue() {
        var me = this;
        var min = me.min;
        var max = me.max;
        return me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
      },
      _autoSkip: function _autoSkip(ticks) {
        var me = this;
        var tickOpts = me.options.ticks;
        var axisLength = me._length;
        var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
        var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
        var numMajorIndices = majorIndices.length;
        var first = majorIndices[0];
        var last = majorIndices[numMajorIndices - 1];
        var i, ilen, spacing, avgMajorSpacing;
        if (numMajorIndices > ticksLimit) {
          skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
          return nonSkipped(ticks);
        }
        spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
        if (numMajorIndices > 0) {
          for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
            skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
          }
          avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
          skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
          skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
          return nonSkipped(ticks);
        }
        skip(ticks, spacing);
        return nonSkipped(ticks);
      },
      _tickSize: function _tickSize() {
        var me = this;
        var optionTicks = me.options.ticks;
        var rot = helpers$1.toRadians(me.labelRotation);
        var cos = Math.abs(Math.cos(rot));
        var sin = Math.abs(Math.sin(rot));
        var labelSizes = me._getLabelSizes();
        var padding = optionTicks.autoSkipPadding || 0;
        var w = labelSizes ? labelSizes.widest.width + padding : 0;
        var h = labelSizes ? labelSizes.highest.height + padding : 0;
        return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
      },
      _isVisible: function _isVisible() {
        var me = this;
        var chart = me.chart;
        var display = me.options.display;
        var i, ilen, meta;
        if (display !== 'auto') {
          return !!display;
        }
        for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
          if (chart.isDatasetVisible(i)) {
            meta = chart.getDatasetMeta(i);
            if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
              return true;
            }
          }
        }
        return false;
      },
      _computeGridLineItems: function _computeGridLineItems(chartArea) {
        var me = this;
        var chart = me.chart;
        var options = me.options;
        var gridLines = options.gridLines;
        var position = options.position;
        var offsetGridLines = gridLines.offsetGridLines;
        var isHorizontal = me.isHorizontal();
        var ticks = me._ticksToDraw;
        var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
        var tl = getTickMarkLength(gridLines);
        var items = [];
        var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
        var axisHalfWidth = axisWidth / 2;
        var alignPixel = helpers$1._alignPixel;
        var alignBorderValue = function alignBorderValue(pixel) {
          return alignPixel(chart, pixel, axisWidth);
        };
        var borderValue, i, tick, lineValue, alignedLineValue;
        var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
        if (position === 'top') {
          borderValue = alignBorderValue(me.bottom);
          ty1 = me.bottom - tl;
          ty2 = borderValue - axisHalfWidth;
          y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
          y2 = chartArea.bottom;
        } else if (position === 'bottom') {
          borderValue = alignBorderValue(me.top);
          y1 = chartArea.top;
          y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
          ty1 = borderValue + axisHalfWidth;
          ty2 = me.top + tl;
        } else if (position === 'left') {
          borderValue = alignBorderValue(me.right);
          tx1 = me.right - tl;
          tx2 = borderValue - axisHalfWidth;
          x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
          x2 = chartArea.right;
        } else {
          borderValue = alignBorderValue(me.left);
          x1 = chartArea.left;
          x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
          tx1 = borderValue + axisHalfWidth;
          tx2 = me.left + tl;
        }
        for (i = 0; i < ticksLength; ++i) {
          tick = ticks[i] || {};
          if (isNullOrUndef(tick.label) && i < ticks.length) {
            continue;
          }
          if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
            lineWidth = gridLines.zeroLineWidth;
            lineColor = gridLines.zeroLineColor;
            borderDash = gridLines.zeroLineBorderDash || [];
            borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
          } else {
            lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
            lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
            borderDash = gridLines.borderDash || [];
            borderDashOffset = gridLines.borderDashOffset || 0.0;
          }
          lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
          if (lineValue === undefined) {
            continue;
          }
          alignedLineValue = alignPixel(chart, lineValue, lineWidth);
          if (isHorizontal) {
            tx1 = tx2 = x1 = x2 = alignedLineValue;
          } else {
            ty1 = ty2 = y1 = y2 = alignedLineValue;
          }
          items.push({
            tx1: tx1,
            ty1: ty1,
            tx2: tx2,
            ty2: ty2,
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            width: lineWidth,
            color: lineColor,
            borderDash: borderDash,
            borderDashOffset: borderDashOffset
          });
        }
        items.ticksLength = ticksLength;
        items.borderValue = borderValue;
        return items;
      },
      _computeLabelItems: function _computeLabelItems() {
        var me = this;
        var options = me.options;
        var optionTicks = options.ticks;
        var position = options.position;
        var isMirrored = optionTicks.mirror;
        var isHorizontal = me.isHorizontal();
        var ticks = me._ticksToDraw;
        var fonts = parseTickFontOptions(optionTicks);
        var tickPadding = optionTicks.padding;
        var tl = getTickMarkLength(options.gridLines);
        var rotation = -helpers$1.toRadians(me.labelRotation);
        var items = [];
        var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        if (position === 'top') {
          y = me.bottom - tl - tickPadding;
          textAlign = !rotation ? 'center' : 'left';
        } else if (position === 'bottom') {
          y = me.top + tl + tickPadding;
          textAlign = !rotation ? 'center' : 'right';
        } else if (position === 'left') {
          x = me.right - (isMirrored ? 0 : tl) - tickPadding;
          textAlign = isMirrored ? 'left' : 'right';
        } else {
          x = me.left + (isMirrored ? 0 : tl) + tickPadding;
          textAlign = isMirrored ? 'right' : 'left';
        }
        for (i = 0, ilen = ticks.length; i < ilen; ++i) {
          tick = ticks[i];
          label = tick.label;
          if (isNullOrUndef(label)) {
            continue;
          }
          pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
          font = tick.major ? fonts.major : fonts.minor;
          lineHeight = font.lineHeight;
          lineCount = isArray(label) ? label.length : 1;
          if (isHorizontal) {
            x = pixel;
            textOffset = position === 'top' ? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight : (!rotation ? 0.5 : 0) * lineHeight;
          } else {
            y = pixel;
            textOffset = (1 - lineCount) * lineHeight / 2;
          }
          items.push({
            x: x,
            y: y,
            rotation: rotation,
            label: label,
            font: font,
            textOffset: textOffset,
            textAlign: textAlign
          });
        }
        return items;
      },
      _drawGrid: function _drawGrid(chartArea) {
        var me = this;
        var gridLines = me.options.gridLines;
        if (!gridLines.display) {
          return;
        }
        var ctx = me.ctx;
        var chart = me.chart;
        var alignPixel = helpers$1._alignPixel;
        var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
        var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
        var width, color, i, ilen, item;
        for (i = 0, ilen = items.length; i < ilen; ++i) {
          item = items[i];
          width = item.width;
          color = item.color;
          if (width && color) {
            ctx.save();
            ctx.lineWidth = width;
            ctx.strokeStyle = color;
            if (ctx.setLineDash) {
              ctx.setLineDash(item.borderDash);
              ctx.lineDashOffset = item.borderDashOffset;
            }
            ctx.beginPath();
            if (gridLines.drawTicks) {
              ctx.moveTo(item.tx1, item.ty1);
              ctx.lineTo(item.tx2, item.ty2);
            }
            if (gridLines.drawOnChartArea) {
              ctx.moveTo(item.x1, item.y1);
              ctx.lineTo(item.x2, item.y2);
            }
            ctx.stroke();
            ctx.restore();
          }
        }
        if (axisWidth) {
          var firstLineWidth = axisWidth;
          var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
          var borderValue = items.borderValue;
          var x1, x2, y1, y2;
          if (me.isHorizontal()) {
            x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
            x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
          } else {
            y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
            y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
          }
          ctx.lineWidth = axisWidth;
          ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
          ctx.beginPath();
          ctx.moveTo(x1, y1);
          ctx.lineTo(x2, y2);
          ctx.stroke();
        }
      },
      _drawLabels: function _drawLabels() {
        var me = this;
        var optionTicks = me.options.ticks;
        if (!optionTicks.display) {
          return;
        }
        var ctx = me.ctx;
        var items = me._labelItems || (me._labelItems = me._computeLabelItems());
        var i, j, ilen, jlen, item, tickFont, label, y;
        for (i = 0, ilen = items.length; i < ilen; ++i) {
          item = items[i];
          tickFont = item.font;
          ctx.save();
          ctx.translate(item.x, item.y);
          ctx.rotate(item.rotation);
          ctx.font = tickFont.string;
          ctx.fillStyle = tickFont.color;
          ctx.textBaseline = 'middle';
          ctx.textAlign = item.textAlign;
          label = item.label;
          y = item.textOffset;
          if (isArray(label)) {
            for (j = 0, jlen = label.length; j < jlen; ++j) {
              ctx.fillText('' + label[j], 0, y);
              y += tickFont.lineHeight;
            }
          } else {
            ctx.fillText(label, 0, y);
          }
          ctx.restore();
        }
      },
      _drawTitle: function _drawTitle() {
        var me = this;
        var ctx = me.ctx;
        var options = me.options;
        var scaleLabel = options.scaleLabel;
        if (!scaleLabel.display) {
          return;
        }
        var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
        var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
        var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
        var halfLineHeight = scaleLabelFont.lineHeight / 2;
        var position = options.position;
        var rotation = 0;
        var scaleLabelX, scaleLabelY;
        if (me.isHorizontal()) {
          scaleLabelX = me.left + me.width / 2;
          scaleLabelY = position === 'bottom' ? me.bottom - halfLineHeight - scaleLabelPadding.bottom : me.top + halfLineHeight + scaleLabelPadding.top;
        } else {
          var isLeft = position === 'left';
          scaleLabelX = isLeft ? me.left + halfLineHeight + scaleLabelPadding.top : me.right - halfLineHeight - scaleLabelPadding.top;
          scaleLabelY = me.top + me.height / 2;
          rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
        }
        ctx.save();
        ctx.translate(scaleLabelX, scaleLabelY);
        ctx.rotate(rotation);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = scaleLabelFontColor;
        ctx.font = scaleLabelFont.string;
        ctx.fillText(scaleLabel.labelString, 0, 0);
        ctx.restore();
      },
      draw: function draw(chartArea) {
        var me = this;
        if (!me._isVisible()) {
          return;
        }
        me._drawGrid(chartArea);
        me._drawTitle();
        me._drawLabels();
      },
      _layers: function _layers() {
        var me = this;
        var opts = me.options;
        var tz = opts.ticks && opts.ticks.z || 0;
        var gz = opts.gridLines && opts.gridLines.z || 0;
        if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
          return [{
            z: tz,
            draw: function draw() {
              me.draw.apply(me, arguments);
            }
          }];
        }
        return [{
          z: gz,
          draw: function draw() {
            me._drawGrid.apply(me, arguments);
            me._drawTitle.apply(me, arguments);
          }
        }, {
          z: tz,
          draw: function draw() {
            me._drawLabels.apply(me, arguments);
          }
        }];
      },
      _getMatchingVisibleMetas: function _getMatchingVisibleMetas(type) {
        var me = this;
        var isHorizontal = me.isHorizontal();
        return me.chart._getSortedVisibleDatasetMetas().filter(function (meta) {
          return (!type || meta.type === type) && (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
        });
      }
    });
    Scale.prototype._draw = Scale.prototype.draw;
    var core_scale = Scale;
    var isNullOrUndef$1 = helpers$1.isNullOrUndef;
    var defaultConfig = {
      position: 'bottom'
    };
    var scale_category = core_scale.extend({
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var labels = me._getLabels();
        var ticksOpts = me.options.ticks;
        var min = ticksOpts.min;
        var max = ticksOpts.max;
        var minIndex = 0;
        var maxIndex = labels.length - 1;
        var findIndex;
        if (min !== undefined) {
          findIndex = labels.indexOf(min);
          if (findIndex >= 0) {
            minIndex = findIndex;
          }
        }
        if (max !== undefined) {
          findIndex = labels.indexOf(max);
          if (findIndex >= 0) {
            maxIndex = findIndex;
          }
        }
        me.minIndex = minIndex;
        me.maxIndex = maxIndex;
        me.min = labels[minIndex];
        me.max = labels[maxIndex];
      },
      buildTicks: function buildTicks() {
        var me = this;
        var labels = me._getLabels();
        var minIndex = me.minIndex;
        var maxIndex = me.maxIndex;
        me.ticks = minIndex === 0 && maxIndex === labels.length - 1 ? labels : labels.slice(minIndex, maxIndex + 1);
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        var me = this;
        var chart = me.chart;
        if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
          return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
        }
        return me._getLabels()[index];
      },
      _configure: function _configure() {
        var me = this;
        var offset = me.options.offset;
        var ticks = me.ticks;
        core_scale.prototype._configure.call(me);
        if (!me.isHorizontal()) {
          me._reversePixels = !me._reversePixels;
        }
        if (!ticks) {
          return;
        }
        me._startValue = me.minIndex - (offset ? 0.5 : 0);
        me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
      },
      getPixelForValue: function getPixelForValue(value, index, datasetIndex) {
        var me = this;
        var valueCategory, labels, idx;
        if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
          value = me.chart.data.datasets[datasetIndex].data[index];
        }
        if (!isNullOrUndef$1(value)) {
          valueCategory = me.isHorizontal() ? value.x : value.y;
        }
        if (valueCategory !== undefined || value !== undefined && isNaN(index)) {
          labels = me._getLabels();
          value = helpers$1.valueOrDefault(valueCategory, value);
          idx = labels.indexOf(value);
          index = idx !== -1 ? idx : index;
          if (isNaN(index)) {
            index = value;
          }
        }
        return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.ticks;
        return index < 0 || index > ticks.length - 1 ? null : this.getPixelForValue(ticks[index], index + this.minIndex);
      },
      getValueForPixel: function getValueForPixel(pixel) {
        var me = this;
        var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
        return Math.min(Math.max(value, 0), me.ticks.length - 1);
      },
      getBasePixel: function getBasePixel() {
        return this.bottom;
      }
    });
    var _defaults = defaultConfig;
    scale_category._defaults = _defaults;
    var noop = helpers$1.noop;
    var isNullOrUndef$2 = helpers$1.isNullOrUndef;
    function generateTicks(generationOptions, dataRange) {
      var ticks = [];
      var MIN_SPACING = 1e-14;
      var stepSize = generationOptions.stepSize;
      var unit = stepSize || 1;
      var maxNumSpaces = generationOptions.maxTicks - 1;
      var min = generationOptions.min;
      var max = generationOptions.max;
      var precision = generationOptions.precision;
      var rmin = dataRange.min;
      var rmax = dataRange.max;
      var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
      var factor, niceMin, niceMax, numSpaces;
      if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
        return [rmin, rmax];
      }
      numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
      if (numSpaces > maxNumSpaces) {
        spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
      }
      if (stepSize || isNullOrUndef$2(precision)) {
        factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
      } else {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
      }
      niceMin = Math.floor(rmin / spacing) * spacing;
      niceMax = Math.ceil(rmax / spacing) * spacing;
      if (stepSize) {
        if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
          niceMin = min;
        }
        if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
          niceMax = max;
        }
      }
      numSpaces = (niceMax - niceMin) / spacing;
      if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
        numSpaces = Math.round(numSpaces);
      } else {
        numSpaces = Math.ceil(numSpaces);
      }
      niceMin = Math.round(niceMin * factor) / factor;
      niceMax = Math.round(niceMax * factor) / factor;
      ticks.push(isNullOrUndef$2(min) ? niceMin : min);
      for (var j = 1; j < numSpaces; ++j) {
        ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
      }
      ticks.push(isNullOrUndef$2(max) ? niceMax : max);
      return ticks;
    }
    var scale_linearbase = core_scale.extend({
      getRightValue: function getRightValue(value) {
        if (typeof value === 'string') {
          return +value;
        }
        return core_scale.prototype.getRightValue.call(this, value);
      },
      handleTickRangeOptions: function handleTickRangeOptions() {
        var me = this;
        var opts = me.options;
        var tickOpts = opts.ticks;
        if (tickOpts.beginAtZero) {
          var minSign = helpers$1.sign(me.min);
          var maxSign = helpers$1.sign(me.max);
          if (minSign < 0 && maxSign < 0) {
            me.max = 0;
          } else if (minSign > 0 && maxSign > 0) {
            me.min = 0;
          }
        }
        var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
        var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
        if (tickOpts.min !== undefined) {
          me.min = tickOpts.min;
        } else if (tickOpts.suggestedMin !== undefined) {
          if (me.min === null) {
            me.min = tickOpts.suggestedMin;
          } else {
            me.min = Math.min(me.min, tickOpts.suggestedMin);
          }
        }
        if (tickOpts.max !== undefined) {
          me.max = tickOpts.max;
        } else if (tickOpts.suggestedMax !== undefined) {
          if (me.max === null) {
            me.max = tickOpts.suggestedMax;
          } else {
            me.max = Math.max(me.max, tickOpts.suggestedMax);
          }
        }
        if (setMin !== setMax) {
          if (me.min >= me.max) {
            if (setMin) {
              me.max = me.min + 1;
            } else {
              me.min = me.max - 1;
            }
          }
        }
        if (me.min === me.max) {
          me.max++;
          if (!tickOpts.beginAtZero) {
            me.min--;
          }
        }
      },
      getTickLimit: function getTickLimit() {
        var me = this;
        var tickOpts = me.options.ticks;
        var stepSize = tickOpts.stepSize;
        var maxTicksLimit = tickOpts.maxTicksLimit;
        var maxTicks;
        if (stepSize) {
          maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
        } else {
          maxTicks = me._computeTickLimit();
          maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) {
          maxTicks = Math.min(maxTicksLimit, maxTicks);
        }
        return maxTicks;
      },
      _computeTickLimit: function _computeTickLimit() {
        return Number.POSITIVE_INFINITY;
      },
      handleDirectionalChanges: noop,
      buildTicks: function buildTicks() {
        var me = this;
        var opts = me.options;
        var tickOpts = opts.ticks;
        var maxTicks = me.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        var numericGeneratorOptions = {
          maxTicks: maxTicks,
          min: tickOpts.min,
          max: tickOpts.max,
          precision: tickOpts.precision,
          stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
        };
        var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
        me.handleDirectionalChanges();
        me.max = helpers$1.max(ticks);
        me.min = helpers$1.min(ticks);
        if (tickOpts.reverse) {
          ticks.reverse();
          me.start = me.max;
          me.end = me.min;
        } else {
          me.start = me.min;
          me.end = me.max;
        }
      },
      convertTicksToLabels: function convertTicksToLabels() {
        var me = this;
        me.ticksAsNumbers = me.ticks.slice();
        me.zeroLineIndex = me.ticks.indexOf(0);
        core_scale.prototype.convertTicksToLabels.call(me);
      },
      _configure: function _configure() {
        var me = this;
        var ticks = me.getTicks();
        var start = me.min;
        var end = me.max;
        var offset;
        core_scale.prototype._configure.call(me);
        if (me.options.offset && ticks.length) {
          offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
          start -= offset;
          end += offset;
        }
        me._startValue = start;
        me._endValue = end;
        me._valueRange = end - start;
      }
    });
    var defaultConfig$1 = {
      position: 'left',
      ticks: {
        callback: core_ticks.formatters.linear
      }
    };
    var DEFAULT_MIN = 0;
    var DEFAULT_MAX = 1;
    function getOrCreateStack(stacks, stacked, meta) {
      var key = [meta.type, stacked === undefined && meta.stack === undefined ? meta.index : '', meta.stack].join('.');
      if (stacks[key] === undefined) {
        stacks[key] = {
          pos: [],
          neg: []
        };
      }
      return stacks[key];
    }
    function stackData(scale, stacks, meta, data) {
      var opts = scale.options;
      var stacked = opts.stacked;
      var stack = getOrCreateStack(stacks, stacked, meta);
      var pos = stack.pos;
      var neg = stack.neg;
      var ilen = data.length;
      var i, value;
      for (i = 0; i < ilen; ++i) {
        value = scale._parseValue(data[i]);
        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
          continue;
        }
        pos[i] = pos[i] || 0;
        neg[i] = neg[i] || 0;
        if (opts.relativePoints) {
          pos[i] = 100;
        } else if (value.min < 0 || value.max < 0) {
          neg[i] += value.min;
        } else {
          pos[i] += value.max;
        }
      }
    }
    function updateMinMax(scale, meta, data) {
      var ilen = data.length;
      var i, value;
      for (i = 0; i < ilen; ++i) {
        value = scale._parseValue(data[i]);
        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
          continue;
        }
        scale.min = Math.min(scale.min, value.min);
        scale.max = Math.max(scale.max, value.max);
      }
    }
    var scale_linear = scale_linearbase.extend({
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var opts = me.options;
        var chart = me.chart;
        var datasets = chart.data.datasets;
        var metasets = me._getMatchingVisibleMetas();
        var hasStacks = opts.stacked;
        var stacks = {};
        var ilen = metasets.length;
        var i, meta, data, values;
        me.min = Number.POSITIVE_INFINITY;
        me.max = Number.NEGATIVE_INFINITY;
        if (hasStacks === undefined) {
          for (i = 0; !hasStacks && i < ilen; ++i) {
            meta = metasets[i];
            hasStacks = meta.stack !== undefined;
          }
        }
        for (i = 0; i < ilen; ++i) {
          meta = metasets[i];
          data = datasets[meta.index].data;
          if (hasStacks) {
            stackData(me, stacks, meta, data);
          } else {
            updateMinMax(me, meta, data);
          }
        }
        helpers$1.each(stacks, function (stackValues) {
          values = stackValues.pos.concat(stackValues.neg);
          me.min = Math.min(me.min, helpers$1.min(values));
          me.max = Math.max(me.max, helpers$1.max(values));
        });
        me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
        me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
        me.handleTickRangeOptions();
      },
      _computeTickLimit: function _computeTickLimit() {
        var me = this;
        var tickFont;
        if (me.isHorizontal()) {
          return Math.ceil(me.width / 40);
        }
        tickFont = helpers$1.options._parseFont(me.options.ticks);
        return Math.ceil(me.height / tickFont.lineHeight);
      },
      handleDirectionalChanges: function handleDirectionalChanges() {
        if (!this.isHorizontal()) {
          this.ticks.reverse();
        }
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
      },
      getPixelForValue: function getPixelForValue(value) {
        var me = this;
        return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
      },
      getValueForPixel: function getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.ticksAsNumbers;
        if (index < 0 || index > ticks.length - 1) {
          return null;
        }
        return this.getPixelForValue(ticks[index]);
      }
    });
    var _defaults$1 = defaultConfig$1;
    scale_linear._defaults = _defaults$1;
    var valueOrDefault$b = helpers$1.valueOrDefault;
    var log10 = helpers$1.math.log10;
    function generateTicks$1(generationOptions, dataRange) {
      var ticks = [];
      var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
      var endExp = Math.floor(log10(dataRange.max));
      var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
      var exp, significand;
      if (tickVal === 0) {
        exp = Math.floor(log10(dataRange.minNotZero));
        significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
        ticks.push(tickVal);
        tickVal = significand * Math.pow(10, exp);
      } else {
        exp = Math.floor(log10(tickVal));
        significand = Math.floor(tickVal / Math.pow(10, exp));
      }
      var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
      do {
        ticks.push(tickVal);
        ++significand;
        if (significand === 10) {
          significand = 1;
          ++exp;
          precision = exp >= 0 ? 1 : precision;
        }
        tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
      } while (exp < endExp || exp === endExp && significand < endSignificand);
      var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
      ticks.push(lastTick);
      return ticks;
    }
    var defaultConfig$2 = {
      position: 'left',
      ticks: {
        callback: core_ticks.formatters.logarithmic
      }
    };
    function nonNegativeOrDefault(value, defaultValue) {
      return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
    }
    var scale_logarithmic = core_scale.extend({
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var opts = me.options;
        var chart = me.chart;
        var datasets = chart.data.datasets;
        var isHorizontal = me.isHorizontal();
        function IDMatches(meta) {
          return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
        }
        var datasetIndex, meta, value, data, i, ilen;
        me.min = Number.POSITIVE_INFINITY;
        me.max = Number.NEGATIVE_INFINITY;
        me.minNotZero = Number.POSITIVE_INFINITY;
        var hasStacks = opts.stacked;
        if (hasStacks === undefined) {
          for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
            meta = chart.getDatasetMeta(datasetIndex);
            if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
              hasStacks = true;
              break;
            }
          }
        }
        if (opts.stacked || hasStacks) {
          var valuesPerStack = {};
          for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
            meta = chart.getDatasetMeta(datasetIndex);
            var key = [meta.type, opts.stacked === undefined && meta.stack === undefined ? datasetIndex : '', meta.stack].join('.');
            if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
              if (valuesPerStack[key] === undefined) {
                valuesPerStack[key] = [];
              }
              data = datasets[datasetIndex].data;
              for (i = 0, ilen = data.length; i < ilen; i++) {
                var values = valuesPerStack[key];
                value = me._parseValue(data[i]);
                if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
                  continue;
                }
                values[i] = values[i] || 0;
                values[i] += value.max;
              }
            }
          }
          helpers$1.each(valuesPerStack, function (valuesForType) {
            if (valuesForType.length > 0) {
              var minVal = helpers$1.min(valuesForType);
              var maxVal = helpers$1.max(valuesForType);
              me.min = Math.min(me.min, minVal);
              me.max = Math.max(me.max, maxVal);
            }
          });
        } else {
          for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
            meta = chart.getDatasetMeta(datasetIndex);
            if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
              data = datasets[datasetIndex].data;
              for (i = 0, ilen = data.length; i < ilen; i++) {
                value = me._parseValue(data[i]);
                if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
                  continue;
                }
                me.min = Math.min(value.min, me.min);
                me.max = Math.max(value.max, me.max);
                if (value.min !== 0) {
                  me.minNotZero = Math.min(value.min, me.minNotZero);
                }
              }
            }
          }
        }
        me.min = helpers$1.isFinite(me.min) ? me.min : null;
        me.max = helpers$1.isFinite(me.max) ? me.max : null;
        me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
        this.handleTickRangeOptions();
      },
      handleTickRangeOptions: function handleTickRangeOptions() {
        var me = this;
        var tickOpts = me.options.ticks;
        var DEFAULT_MIN = 1;
        var DEFAULT_MAX = 10;
        me.min = nonNegativeOrDefault(tickOpts.min, me.min);
        me.max = nonNegativeOrDefault(tickOpts.max, me.max);
        if (me.min === me.max) {
          if (me.min !== 0 && me.min !== null) {
            me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
            me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
          } else {
            me.min = DEFAULT_MIN;
            me.max = DEFAULT_MAX;
          }
        }
        if (me.min === null) {
          me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
        }
        if (me.max === null) {
          me.max = me.min !== 0 ? Math.pow(10, Math.floor(log10(me.min)) + 1) : DEFAULT_MAX;
        }
        if (me.minNotZero === null) {
          if (me.min > 0) {
            me.minNotZero = me.min;
          } else if (me.max < 1) {
            me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
          } else {
            me.minNotZero = DEFAULT_MIN;
          }
        }
      },
      buildTicks: function buildTicks() {
        var me = this;
        var tickOpts = me.options.ticks;
        var reverse = !me.isHorizontal();
        var generationOptions = {
          min: nonNegativeOrDefault(tickOpts.min),
          max: nonNegativeOrDefault(tickOpts.max)
        };
        var ticks = me.ticks = generateTicks$1(generationOptions, me);
        me.max = helpers$1.max(ticks);
        me.min = helpers$1.min(ticks);
        if (tickOpts.reverse) {
          reverse = !reverse;
          me.start = me.max;
          me.end = me.min;
        } else {
          me.start = me.min;
          me.end = me.max;
        }
        if (reverse) {
          ticks.reverse();
        }
      },
      convertTicksToLabels: function convertTicksToLabels() {
        this.tickValues = this.ticks.slice();
        core_scale.prototype.convertTicksToLabels.call(this);
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.tickValues;
        if (index < 0 || index > ticks.length - 1) {
          return null;
        }
        return this.getPixelForValue(ticks[index]);
      },
      _getFirstTickValue: function _getFirstTickValue(value) {
        var exp = Math.floor(log10(value));
        var significand = Math.floor(value / Math.pow(10, exp));
        return significand * Math.pow(10, exp);
      },
      _configure: function _configure() {
        var me = this;
        var start = me.min;
        var offset = 0;
        core_scale.prototype._configure.call(me);
        if (start === 0) {
          start = me._getFirstTickValue(me.minNotZero);
          offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
        }
        me._startValue = log10(start);
        me._valueOffset = offset;
        me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
      },
      getPixelForValue: function getPixelForValue(value) {
        var me = this;
        var decimal = 0;
        value = +me.getRightValue(value);
        if (value > me.min && value > 0) {
          decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
        }
        return me.getPixelForDecimal(decimal);
      },
      getValueForPixel: function getValueForPixel(pixel) {
        var me = this;
        var decimal = me.getDecimalForPixel(pixel);
        return decimal === 0 && me.min === 0 ? 0 : Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
      }
    });
    var _defaults$2 = defaultConfig$2;
    scale_logarithmic._defaults = _defaults$2;
    var valueOrDefault$c = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
    var resolve$4 = helpers$1.options.resolve;
    var defaultConfig$3 = {
      display: true,
      animate: true,
      position: 'chartArea',
      angleLines: {
        display: true,
        color: 'rgba(0,0,0,0.1)',
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
      },
      gridLines: {
        circular: false
      },
      ticks: {
        showLabelBackdrop: true,
        backdropColor: 'rgba(255,255,255,0.75)',
        backdropPaddingY: 2,
        backdropPaddingX: 2,
        callback: core_ticks.formatters.linear
      },
      pointLabels: {
        display: true,
        fontSize: 10,
        callback: function callback(label) {
          return label;
        }
      }
    };
    function getTickBackdropHeight(opts) {
      var tickOpts = opts.ticks;
      if (tickOpts.display && opts.display) {
        return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
      }
      return 0;
    }
    function measureLabelSize(ctx, lineHeight, label) {
      if (helpers$1.isArray(label)) {
        return {
          w: helpers$1.longestText(ctx, ctx.font, label),
          h: label.length * lineHeight
        };
      }
      return {
        w: ctx.measureText(label).width,
        h: lineHeight
      };
    }
    function determineLimits(angle, pos, size, min, max) {
      if (angle === min || angle === max) {
        return {
          start: pos - size / 2,
          end: pos + size / 2
        };
      } else if (angle < min || angle > max) {
        return {
          start: pos - size,
          end: pos
        };
      }
      return {
        start: pos,
        end: pos + size
      };
    }
    function fitWithPointLabels(scale) {
      var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
      var furthestLimits = {
        l: 0,
        r: scale.width,
        t: 0,
        b: scale.height - scale.paddingTop
      };
      var furthestAngles = {};
      var i, textSize, pointPosition;
      scale.ctx.font = plFont.string;
      scale._pointLabelSizes = [];
      var valueCount = scale.chart.data.labels.length;
      for (i = 0; i < valueCount; i++) {
        pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
        textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
        scale._pointLabelSizes[i] = textSize;
        var angleRadians = scale.getIndexAngle(i);
        var angle = helpers$1.toDegrees(angleRadians) % 360;
        var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        if (hLimits.start < furthestLimits.l) {
          furthestLimits.l = hLimits.start;
          furthestAngles.l = angleRadians;
        }
        if (hLimits.end > furthestLimits.r) {
          furthestLimits.r = hLimits.end;
          furthestAngles.r = angleRadians;
        }
        if (vLimits.start < furthestLimits.t) {
          furthestLimits.t = vLimits.start;
          furthestAngles.t = angleRadians;
        }
        if (vLimits.end > furthestLimits.b) {
          furthestLimits.b = vLimits.end;
          furthestAngles.b = angleRadians;
        }
      }
      scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
    }
    function getTextAlignForAngle(angle) {
      if (angle === 0 || angle === 180) {
        return 'center';
      } else if (angle < 180) {
        return 'left';
      }
      return 'right';
    }
    function fillText(ctx, text, position, lineHeight) {
      var y = position.y + lineHeight / 2;
      var i, ilen;
      if (helpers$1.isArray(text)) {
        for (i = 0, ilen = text.length; i < ilen; ++i) {
          ctx.fillText(text[i], position.x, y);
          y += lineHeight;
        }
      } else {
        ctx.fillText(text, position.x, y);
      }
    }
    function adjustPointPositionForLabelHeight(angle, textSize, position) {
      if (angle === 90 || angle === 270) {
        position.y -= textSize.h / 2;
      } else if (angle > 270 || angle < 90) {
        position.y -= textSize.h;
      }
    }
    function drawPointLabels(scale) {
      var ctx = scale.ctx;
      var opts = scale.options;
      var pointLabelOpts = opts.pointLabels;
      var tickBackdropHeight = getTickBackdropHeight(opts);
      var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
      var plFont = helpers$1.options._parseFont(pointLabelOpts);
      ctx.save();
      ctx.font = plFont.string;
      ctx.textBaseline = 'middle';
      for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
        var extra = i === 0 ? tickBackdropHeight / 2 : 0;
        var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
        var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
        ctx.fillStyle = pointLabelFontColor;
        var angleRadians = scale.getIndexAngle(i);
        var angle = helpers$1.toDegrees(angleRadians);
        ctx.textAlign = getTextAlignForAngle(angle);
        adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
        fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
      }
      ctx.restore();
    }
    function drawRadiusLine(scale, gridLineOpts, radius, index) {
      var ctx = scale.ctx;
      var circular = gridLineOpts.circular;
      var valueCount = scale.chart.data.labels.length;
      var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
      var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
      var pointPosition;
      if (!circular && !valueCount || !lineColor || !lineWidth) {
        return;
      }
      ctx.save();
      ctx.strokeStyle = lineColor;
      ctx.lineWidth = lineWidth;
      if (ctx.setLineDash) {
        ctx.setLineDash(gridLineOpts.borderDash || []);
        ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
      }
      ctx.beginPath();
      if (circular) {
        ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
      } else {
        pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for (var i = 1; i < valueCount; i++) {
          pointPosition = scale.getPointPosition(i, radius);
          ctx.lineTo(pointPosition.x, pointPosition.y);
        }
      }
      ctx.closePath();
      ctx.stroke();
      ctx.restore();
    }
    function numberOrZero(param) {
      return helpers$1.isNumber(param) ? param : 0;
    }
    var scale_radialLinear = scale_linearbase.extend({
      setDimensions: function setDimensions() {
        var me = this;
        me.width = me.maxWidth;
        me.height = me.maxHeight;
        me.paddingTop = getTickBackdropHeight(me.options) / 2;
        me.xCenter = Math.floor(me.width / 2);
        me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
        me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
      },
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var chart = me.chart;
        var min = Number.POSITIVE_INFINITY;
        var max = Number.NEGATIVE_INFINITY;
        helpers$1.each(chart.data.datasets, function (dataset, datasetIndex) {
          if (chart.isDatasetVisible(datasetIndex)) {
            var meta = chart.getDatasetMeta(datasetIndex);
            helpers$1.each(dataset.data, function (rawValue, index) {
              var value = +me.getRightValue(rawValue);
              if (isNaN(value) || meta.data[index].hidden) {
                return;
              }
              min = Math.min(value, min);
              max = Math.max(value, max);
            });
          }
        });
        me.min = min === Number.POSITIVE_INFINITY ? 0 : min;
        me.max = max === Number.NEGATIVE_INFINITY ? 0 : max;
        me.handleTickRangeOptions();
      },
      _computeTickLimit: function _computeTickLimit() {
        return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
      },
      convertTicksToLabels: function convertTicksToLabels() {
        var me = this;
        scale_linearbase.prototype.convertTicksToLabels.call(me);
        me.pointLabels = me.chart.data.labels.map(function () {
          var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
          return label || label === 0 ? label : '';
        });
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
      },
      fit: function fit() {
        var me = this;
        var opts = me.options;
        if (opts.display && opts.pointLabels.display) {
          fitWithPointLabels(me);
        } else {
          me.setCenterPoint(0, 0, 0, 0);
        }
      },
      setReductions: function setReductions(largestPossibleRadius, furthestLimits, furthestAngles) {
        var me = this;
        var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
        var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
        var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
        var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
        radiusReductionLeft = numberOrZero(radiusReductionLeft);
        radiusReductionRight = numberOrZero(radiusReductionRight);
        radiusReductionTop = numberOrZero(radiusReductionTop);
        radiusReductionBottom = numberOrZero(radiusReductionBottom);
        me.drawingArea = Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
        me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
      },
      setCenterPoint: function setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        var me = this;
        var maxRight = me.width - rightMovement - me.drawingArea;
        var maxLeft = leftMovement + me.drawingArea;
        var maxTop = topMovement + me.drawingArea;
        var maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;
        me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
        me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
      },
      getIndexAngle: function getIndexAngle(index) {
        var chart = this.chart;
        var angleMultiplier = 360 / chart.data.labels.length;
        var options = chart.options || {};
        var startAngle = options.startAngle || 0;
        var angle = (index * angleMultiplier + startAngle) % 360;
        return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
      },
      getDistanceFromCenterForValue: function getDistanceFromCenterForValue(value) {
        var me = this;
        if (helpers$1.isNullOrUndef(value)) {
          return NaN;
        }
        var scalingFactor = me.drawingArea / (me.max - me.min);
        if (me.options.ticks.reverse) {
          return (me.max - value) * scalingFactor;
        }
        return (value - me.min) * scalingFactor;
      },
      getPointPosition: function getPointPosition(index, distanceFromCenter) {
        var me = this;
        var thisAngle = me.getIndexAngle(index) - Math.PI / 2;
        return {
          x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
          y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
        };
      },
      getPointPositionForValue: function getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
      },
      getBasePosition: function getBasePosition(index) {
        var me = this;
        var min = me.min;
        var max = me.max;
        return me.getPointPositionForValue(index || 0, me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0);
      },
      _drawGrid: function _drawGrid() {
        var me = this;
        var ctx = me.ctx;
        var opts = me.options;
        var gridLineOpts = opts.gridLines;
        var angleLineOpts = opts.angleLines;
        var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
        var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
        var i, offset, position;
        if (opts.pointLabels.display) {
          drawPointLabels(me);
        }
        if (gridLineOpts.display) {
          helpers$1.each(me.ticks, function (label, index) {
            if (index !== 0) {
              offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
              drawRadiusLine(me, gridLineOpts, offset, index);
            }
          });
        }
        if (angleLineOpts.display && lineWidth && lineColor) {
          ctx.save();
          ctx.lineWidth = lineWidth;
          ctx.strokeStyle = lineColor;
          if (ctx.setLineDash) {
            ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
            ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
          }
          for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
            offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
            position = me.getPointPosition(i, offset);
            ctx.beginPath();
            ctx.moveTo(me.xCenter, me.yCenter);
            ctx.lineTo(position.x, position.y);
            ctx.stroke();
          }
          ctx.restore();
        }
      },
      _drawLabels: function _drawLabels() {
        var me = this;
        var ctx = me.ctx;
        var opts = me.options;
        var tickOpts = opts.ticks;
        if (!tickOpts.display) {
          return;
        }
        var startAngle = me.getIndexAngle(0);
        var tickFont = helpers$1.options._parseFont(tickOpts);
        var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
        var offset, width;
        ctx.save();
        ctx.font = tickFont.string;
        ctx.translate(me.xCenter, me.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        helpers$1.each(me.ticks, function (label, index) {
          if (index === 0 && !tickOpts.reverse) {
            return;
          }
          offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
          if (tickOpts.showLabelBackdrop) {
            width = ctx.measureText(label).width;
            ctx.fillStyle = tickOpts.backdropColor;
            ctx.fillRect(-width / 2 - tickOpts.backdropPaddingX, -offset - tickFont.size / 2 - tickOpts.backdropPaddingY, width + tickOpts.backdropPaddingX * 2, tickFont.size + tickOpts.backdropPaddingY * 2);
          }
          ctx.fillStyle = tickFontColor;
          ctx.fillText(label, 0, -offset);
        });
        ctx.restore();
      },
      _drawTitle: helpers$1.noop
    });
    var _defaults$3 = defaultConfig$3;
    scale_radialLinear._defaults = _defaults$3;
    var deprecated$1 = helpers$1._deprecated;
    var resolve$5 = helpers$1.options.resolve;
    var valueOrDefault$d = helpers$1.valueOrDefault;
    var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
    var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
    var INTERVALS = {
      millisecond: {
        common: true,
        size: 1,
        steps: 1000
      },
      second: {
        common: true,
        size: 1000,
        steps: 60
      },
      minute: {
        common: true,
        size: 60000,
        steps: 60
      },
      hour: {
        common: true,
        size: 3600000,
        steps: 24
      },
      day: {
        common: true,
        size: 86400000,
        steps: 30
      },
      week: {
        common: false,
        size: 604800000,
        steps: 4
      },
      month: {
        common: true,
        size: 2.628e9,
        steps: 12
      },
      quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
      },
      year: {
        common: true,
        size: 3.154e10
      }
    };
    var UNITS = Object.keys(INTERVALS);
    function sorter(a, b) {
      return a - b;
    }
    function arrayUnique(items) {
      var hash = {};
      var out = [];
      var i, ilen, item;
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        item = items[i];
        if (!hash[item]) {
          hash[item] = true;
          out.push(item);
        }
      }
      return out;
    }
    function getMin(options) {
      return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
    }
    function getMax(options) {
      return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
    }
    function buildLookupTable(timestamps, min, max, distribution) {
      if (distribution === 'linear' || !timestamps.length) {
        return [{
          time: min,
          pos: 0
        }, {
          time: max,
          pos: 1
        }];
      }
      var table = [];
      var items = [min];
      var i, ilen, prev, curr, next;
      for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
        curr = timestamps[i];
        if (curr > min && curr < max) {
          items.push(curr);
        }
      }
      items.push(max);
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        next = items[i + 1];
        prev = items[i - 1];
        curr = items[i];
        if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
          table.push({
            time: curr,
            pos: i / (ilen - 1)
          });
        }
      }
      return table;
    }
    function lookup(table, key, value) {
      var lo = 0;
      var hi = table.length - 1;
      var mid, i0, i1;
      while (lo >= 0 && lo <= hi) {
        mid = lo + hi >> 1;
        i0 = table[mid - 1] || null;
        i1 = table[mid];
        if (!i0) {
          return {
            lo: null,
            hi: i1
          };
        } else if (i1[key] < value) {
          lo = mid + 1;
        } else if (i0[key] > value) {
          hi = mid - 1;
        } else {
          return {
            lo: i0,
            hi: i1
          };
        }
      }
      return {
        lo: i1,
        hi: null
      };
    }
    function interpolate$1(table, skey, sval, tkey) {
      var range = lookup(table, skey, sval);
      var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
      var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
      var span = next[skey] - prev[skey];
      var ratio = span ? (sval - prev[skey]) / span : 0;
      var offset = (next[tkey] - prev[tkey]) * ratio;
      return prev[tkey] + offset;
    }
    function toTimestamp(scale, input) {
      var adapter = scale._adapter;
      var options = scale.options.time;
      var parser = options.parser;
      var format = parser || options.format;
      var value = input;
      if (typeof parser === 'function') {
        value = parser(value);
      }
      if (!helpers$1.isFinite(value)) {
        value = typeof format === 'string' ? adapter.parse(value, format) : adapter.parse(value);
      }
      if (value !== null) {
        return +value;
      }
      if (!parser && typeof format === 'function') {
        value = format(input);
        if (!helpers$1.isFinite(value)) {
          value = adapter.parse(value);
        }
      }
      return value;
    }
    function parse(scale, input) {
      if (helpers$1.isNullOrUndef(input)) {
        return null;
      }
      var options = scale.options.time;
      var value = toTimestamp(scale, scale.getRightValue(input));
      if (value === null) {
        return value;
      }
      if (options.round) {
        value = +scale._adapter.startOf(value, options.round);
      }
      return value;
    }
    function determineUnitForAutoTicks(minUnit, min, max, capacity) {
      var ilen = UNITS.length;
      var i, interval, factor;
      for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
        interval = INTERVALS[UNITS[i]];
        factor = interval.steps ? interval.steps : MAX_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
          return UNITS[i];
        }
      }
      return UNITS[ilen - 1];
    }
    function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
      var i, unit;
      for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
        unit = UNITS[i];
        if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
          return unit;
        }
      }
      return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
    }
    function determineMajorUnit(unit) {
      for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
        if (INTERVALS[UNITS[i]].common) {
          return UNITS[i];
        }
      }
    }
    function generate(scale, min, max, capacity) {
      var adapter = scale._adapter;
      var options = scale.options;
      var timeOpts = options.time;
      var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
      var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
      var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
      var first = min;
      var ticks = [];
      var time;
      if (weekday) {
        first = +adapter.startOf(first, 'isoWeek', weekday);
      }
      first = +adapter.startOf(first, weekday ? 'day' : minor);
      if (adapter.diff(max, min, minor) > 100000 * stepSize) {
        throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
      }
      for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
        ticks.push(time);
      }
      if (time === max || options.bounds === 'ticks') {
        ticks.push(time);
      }
      return ticks;
    }
    function computeOffsets(table, ticks, min, max, options) {
      var start = 0;
      var end = 0;
      var first, last;
      if (options.offset && ticks.length) {
        first = interpolate$1(table, 'time', ticks[0], 'pos');
        if (ticks.length === 1) {
          start = 1 - first;
        } else {
          start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
        }
        last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
        if (ticks.length === 1) {
          end = last;
        } else {
          end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
        }
      }
      return {
        start: start,
        end: end,
        factor: 1 / (start + 1 + end)
      };
    }
    function setMajorTicks(scale, ticks, map, majorUnit) {
      var adapter = scale._adapter;
      var first = +adapter.startOf(ticks[0].value, majorUnit);
      var last = ticks[ticks.length - 1].value;
      var major, index;
      for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
        index = map[major];
        if (index >= 0) {
          ticks[index].major = true;
        }
      }
      return ticks;
    }
    function ticksFromTimestamps(scale, values, majorUnit) {
      var ticks = [];
      var map = {};
      var ilen = values.length;
      var i, value;
      for (i = 0; i < ilen; ++i) {
        value = values[i];
        map[value] = i;
        ticks.push({
          value: value,
          major: false
        });
      }
      return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
    }
    var defaultConfig$4 = {
      position: 'bottom',
      distribution: 'linear',
      bounds: 'data',
      adapters: {},
      time: {
        parser: false,
        unit: false,
        round: false,
        displayFormat: false,
        isoWeekday: false,
        minUnit: 'millisecond',
        displayFormats: {}
      },
      ticks: {
        autoSkip: false,
        source: 'auto',
        major: {
          enabled: false
        }
      }
    };
    var scale_time = core_scale.extend({
      initialize: function initialize() {
        this.mergeTicksOptions();
        core_scale.prototype.initialize.call(this);
      },
      update: function update() {
        var me = this;
        var options = me.options;
        var time = options.time || (options.time = {});
        var adapter = me._adapter = new core_adapters._date(options.adapters.date);
        deprecated$1('time scale', time.format, 'time.format', 'time.parser');
        deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
        deprecated$1('time scale', time.max, 'time.max', 'ticks.max');
        helpers$1.mergeIf(time.displayFormats, adapter.formats());
        return core_scale.prototype.update.apply(me, arguments);
      },
      getRightValue: function getRightValue(rawValue) {
        if (rawValue && rawValue.t !== undefined) {
          rawValue = rawValue.t;
        }
        return core_scale.prototype.getRightValue.call(this, rawValue);
      },
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var chart = me.chart;
        var adapter = me._adapter;
        var options = me.options;
        var unit = options.time.unit || 'day';
        var min = MAX_INTEGER;
        var max = MIN_INTEGER;
        var timestamps = [];
        var datasets = [];
        var labels = [];
        var i, j, ilen, jlen, data, timestamp, labelsAdded;
        var dataLabels = me._getLabels();
        for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
          labels.push(parse(me, dataLabels[i]));
        }
        for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
          if (chart.isDatasetVisible(i)) {
            data = chart.data.datasets[i].data;
            if (helpers$1.isObject(data[0])) {
              datasets[i] = [];
              for (j = 0, jlen = data.length; j < jlen; ++j) {
                timestamp = parse(me, data[j]);
                timestamps.push(timestamp);
                datasets[i][j] = timestamp;
              }
            } else {
              datasets[i] = labels.slice(0);
              if (!labelsAdded) {
                timestamps = timestamps.concat(labels);
                labelsAdded = true;
              }
            }
          } else {
            datasets[i] = [];
          }
        }
        if (labels.length) {
          min = Math.min(min, labels[0]);
          max = Math.max(max, labels[labels.length - 1]);
        }
        if (timestamps.length) {
          timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
          min = Math.min(min, timestamps[0]);
          max = Math.max(max, timestamps[timestamps.length - 1]);
        }
        min = parse(me, getMin(options)) || min;
        max = parse(me, getMax(options)) || max;
        min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
        max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
        me.min = Math.min(min, max);
        me.max = Math.max(min + 1, max);
        me._table = [];
        me._timestamps = {
          data: timestamps,
          datasets: datasets,
          labels: labels
        };
      },
      buildTicks: function buildTicks() {
        var me = this;
        var min = me.min;
        var max = me.max;
        var options = me.options;
        var tickOpts = options.ticks;
        var timeOpts = options.time;
        var timestamps = me._timestamps;
        var ticks = [];
        var capacity = me.getLabelCapacity(min);
        var source = tickOpts.source;
        var distribution = options.distribution;
        var i, ilen, timestamp;
        if (source === 'data' || source === 'auto' && distribution === 'series') {
          timestamps = timestamps.data;
        } else if (source === 'labels') {
          timestamps = timestamps.labels;
        } else {
          timestamps = generate(me, min, max, capacity);
        }
        if (options.bounds === 'ticks' && timestamps.length) {
          min = timestamps[0];
          max = timestamps[timestamps.length - 1];
        }
        min = parse(me, getMin(options)) || min;
        max = parse(me, getMax(options)) || max;
        for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
          timestamp = timestamps[i];
          if (timestamp >= min && timestamp <= max) {
            ticks.push(timestamp);
          }
        }
        me.min = min;
        me.max = max;
        me._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity) : determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
        me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined : determineMajorUnit(me._unit);
        me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
        me._offsets = computeOffsets(me._table, ticks, min, max, options);
        if (tickOpts.reverse) {
          ticks.reverse();
        }
        return ticksFromTimestamps(me, ticks, me._majorUnit);
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        var me = this;
        var adapter = me._adapter;
        var data = me.chart.data;
        var timeOpts = me.options.time;
        var label = data.labels && index < data.labels.length ? data.labels[index] : '';
        var value = data.datasets[datasetIndex].data[index];
        if (helpers$1.isObject(value)) {
          label = me.getRightValue(value);
        }
        if (timeOpts.tooltipFormat) {
          return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
        }
        if (typeof label === 'string') {
          return label;
        }
        return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
      },
      tickFormatFunction: function tickFormatFunction(time, index, ticks, format) {
        var me = this;
        var adapter = me._adapter;
        var options = me.options;
        var formats = options.time.displayFormats;
        var minorFormat = formats[me._unit];
        var majorUnit = me._majorUnit;
        var majorFormat = formats[majorUnit];
        var tick = ticks[index];
        var tickOpts = options.ticks;
        var major = majorUnit && majorFormat && tick && tick.major;
        var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
        var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
        var formatter = resolve$5([nestedTickOpts.callback, nestedTickOpts.userCallback, tickOpts.callback, tickOpts.userCallback]);
        return formatter ? formatter(label, index, ticks) : label;
      },
      convertTicksToLabels: function convertTicksToLabels(ticks) {
        var labels = [];
        var i, ilen;
        for (i = 0, ilen = ticks.length; i < ilen; ++i) {
          labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
        }
        return labels;
      },
      getPixelForOffset: function getPixelForOffset(time) {
        var me = this;
        var offsets = me._offsets;
        var pos = interpolate$1(me._table, 'time', time, 'pos');
        return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
      },
      getPixelForValue: function getPixelForValue(value, index, datasetIndex) {
        var me = this;
        var time = null;
        if (index !== undefined && datasetIndex !== undefined) {
          time = me._timestamps.datasets[datasetIndex][index];
        }
        if (time === null) {
          time = parse(me, value);
        }
        if (time !== null) {
          return me.getPixelForOffset(time);
        }
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.getTicks();
        return index >= 0 && index < ticks.length ? this.getPixelForOffset(ticks[index].value) : null;
      },
      getValueForPixel: function getValueForPixel(pixel) {
        var me = this;
        var offsets = me._offsets;
        var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        var time = interpolate$1(me._table, 'pos', pos, 'time');
        return me._adapter._create(time);
      },
      _getLabelSize: function _getLabelSize(label) {
        var me = this;
        var ticksOpts = me.options.ticks;
        var tickLabelWidth = me.ctx.measureText(label).width;
        var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        var cosRotation = Math.cos(angle);
        var sinRotation = Math.sin(angle);
        var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
        return {
          w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
          h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
      },
      getLabelWidth: function getLabelWidth(label) {
        return this._getLabelSize(label).w;
      },
      getLabelCapacity: function getLabelCapacity(exampleTime) {
        var me = this;
        var timeOpts = me.options.time;
        var displayFormats = timeOpts.displayFormats;
        var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
        var size = me._getLabelSize(exampleLabel);
        var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
        if (me.options.offset) {
          capacity--;
        }
        return capacity > 0 ? capacity : 1;
      }
    });
    var _defaults$4 = defaultConfig$4;
    scale_time._defaults = _defaults$4;
    var scales = {
      category: scale_category,
      linear: scale_linear,
      logarithmic: scale_logarithmic,
      radialLinear: scale_radialLinear,
      time: scale_time
    };
    var FORMATS = {
      datetime: 'MMM D, YYYY, h:mm:ss a',
      millisecond: 'h:mm:ss.SSS a',
      second: 'h:mm:ss a',
      minute: 'h:mm a',
      hour: 'hA',
      day: 'MMM D',
      week: 'll',
      month: 'MMM YYYY',
      quarter: '[Q]Q - YYYY',
      year: 'YYYY'
    };
    core_adapters._date.override(typeof moment === 'function' ? {
      _id: 'moment',
      formats: function formats() {
        return FORMATS;
      },
      parse: function parse(value, format) {
        if (typeof value === 'string' && typeof format === 'string') {
          value = moment(value, format);
        } else if (!(value instanceof moment)) {
          value = moment(value);
        }
        return value.isValid() ? value.valueOf() : null;
      },
      format: function format(time, _format) {
        return moment(time).format(_format);
      },
      add: function add(time, amount, unit) {
        return moment(time).add(amount, unit).valueOf();
      },
      diff: function diff(max, min, unit) {
        return moment(max).diff(moment(min), unit);
      },
      startOf: function startOf(time, unit, weekday) {
        time = moment(time);
        if (unit === 'isoWeek') {
          return time.isoWeekday(weekday).valueOf();
        }
        return time.startOf(unit).valueOf();
      },
      endOf: function endOf(time, unit) {
        return moment(time).endOf(unit).valueOf();
      },
      _create: function _create(time) {
        return moment(time);
      }
    } : {});
    core_defaults._set('global', {
      plugins: {
        filler: {
          propagate: true
        }
      }
    });
    var mappers = {
      dataset: function dataset(source) {
        var index = source.fill;
        var chart = source.chart;
        var meta = chart.getDatasetMeta(index);
        var visible = meta && chart.isDatasetVisible(index);
        var points = visible && meta.dataset._children || [];
        var length = points.length || 0;
        return !length ? null : function (point, i) {
          return i < length && points[i]._view || null;
        };
      },
      boundary: function boundary(source) {
        var boundary = source.boundary;
        var x = boundary ? boundary.x : null;
        var y = boundary ? boundary.y : null;
        if (helpers$1.isArray(boundary)) {
          return function (point, i) {
            return boundary[i];
          };
        }
        return function (point) {
          return {
            x: x === null ? point.x : x,
            y: y === null ? point.y : y
          };
        };
      }
    };
    function decodeFill(el, index, count) {
      var model = el._model || {};
      var fill = model.fill;
      var target;
      if (fill === undefined) {
        fill = !!model.backgroundColor;
      }
      if (fill === false || fill === null) {
        return false;
      }
      if (fill === true) {
        return 'origin';
      }
      target = parseFloat(fill, 10);
      if (isFinite(target) && Math.floor(target) === target) {
        if (fill[0] === '-' || fill[0] === '+') {
          target = index + target;
        }
        if (target === index || target < 0 || target >= count) {
          return false;
        }
        return target;
      }
      switch (fill) {
        case 'bottom':
          return 'start';
        case 'top':
          return 'end';
        case 'zero':
          return 'origin';
        case 'origin':
        case 'start':
        case 'end':
          return fill;
        default:
          return false;
      }
    }
    function computeLinearBoundary(source) {
      var model = source.el._model || {};
      var scale = source.el._scale || {};
      var fill = source.fill;
      var target = null;
      var horizontal;
      if (isFinite(fill)) {
        return null;
      }
      if (fill === 'start') {
        target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
      } else if (fill === 'end') {
        target = model.scaleTop === undefined ? scale.top : model.scaleTop;
      } else if (model.scaleZero !== undefined) {
        target = model.scaleZero;
      } else if (scale.getBasePixel) {
        target = scale.getBasePixel();
      }
      if (target !== undefined && target !== null) {
        if (target.x !== undefined && target.y !== undefined) {
          return target;
        }
        if (helpers$1.isFinite(target)) {
          horizontal = scale.isHorizontal();
          return {
            x: horizontal ? target : null,
            y: horizontal ? null : target
          };
        }
      }
      return null;
    }
    function computeCircularBoundary(source) {
      var scale = source.el._scale;
      var options = scale.options;
      var length = scale.chart.data.labels.length;
      var fill = source.fill;
      var target = [];
      var start, end, center, i, point;
      if (!length) {
        return null;
      }
      start = options.ticks.reverse ? scale.max : scale.min;
      end = options.ticks.reverse ? scale.min : scale.max;
      center = scale.getPointPositionForValue(0, start);
      for (i = 0; i < length; ++i) {
        point = fill === 'start' || fill === 'end' ? scale.getPointPositionForValue(i, fill === 'start' ? start : end) : scale.getBasePosition(i);
        if (options.gridLines.circular) {
          point.cx = center.x;
          point.cy = center.y;
          point.angle = scale.getIndexAngle(i) - Math.PI / 2;
        }
        target.push(point);
      }
      return target;
    }
    function computeBoundary(source) {
      var scale = source.el._scale || {};
      if (scale.getPointPositionForValue) {
        return computeCircularBoundary(source);
      }
      return computeLinearBoundary(source);
    }
    function resolveTarget(sources, index, propagate) {
      var source = sources[index];
      var fill = source.fill;
      var visited = [index];
      var target;
      if (!propagate) {
        return fill;
      }
      while (fill !== false && visited.indexOf(fill) === -1) {
        if (!isFinite(fill)) {
          return fill;
        }
        target = sources[fill];
        if (!target) {
          return false;
        }
        if (target.visible) {
          return fill;
        }
        visited.push(fill);
        fill = target.fill;
      }
      return false;
    }
    function createMapper(source) {
      var fill = source.fill;
      var type = 'dataset';
      if (fill === false) {
        return null;
      }
      if (!isFinite(fill)) {
        type = 'boundary';
      }
      return mappers[type](source);
    }
    function isDrawable(point) {
      return point && !point.skip;
    }
    function drawArea(ctx, curve0, curve1, len0, len1) {
      var i, cx, cy, r;
      if (!len0 || !len1) {
        return;
      }
      ctx.moveTo(curve0[0].x, curve0[0].y);
      for (i = 1; i < len0; ++i) {
        helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
      }
      if (curve1[0].angle !== undefined) {
        cx = curve1[0].cx;
        cy = curve1[0].cy;
        r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
        for (i = len1 - 1; i > 0; --i) {
          ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
        }
        return;
      }
      ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
      for (i = len1 - 1; i > 0; --i) {
        helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
      }
    }
    function doFill(ctx, points, mapper, view, color, loop) {
      var count = points.length;
      var span = view.spanGaps;
      var curve0 = [];
      var curve1 = [];
      var len0 = 0;
      var len1 = 0;
      var i, ilen, index, p0, p1, d0, d1, loopOffset;
      ctx.beginPath();
      for (i = 0, ilen = count; i < ilen; ++i) {
        index = i % count;
        p0 = points[index]._view;
        p1 = mapper(p0, index, view);
        d0 = isDrawable(p0);
        d1 = isDrawable(p1);
        if (loop && loopOffset === undefined && d0) {
          loopOffset = i + 1;
          ilen = count + loopOffset;
        }
        if (d0 && d1) {
          len0 = curve0.push(p0);
          len1 = curve1.push(p1);
        } else if (len0 && len1) {
          if (!span) {
            drawArea(ctx, curve0, curve1, len0, len1);
            len0 = len1 = 0;
            curve0 = [];
            curve1 = [];
          } else {
            if (d0) {
              curve0.push(p0);
            }
            if (d1) {
              curve1.push(p1);
            }
          }
        }
      }
      drawArea(ctx, curve0, curve1, len0, len1);
      ctx.closePath();
      ctx.fillStyle = color;
      ctx.fill();
    }
    var plugin_filler = {
      id: 'filler',
      afterDatasetsUpdate: function afterDatasetsUpdate(chart, options) {
        var count = (chart.data.datasets || []).length;
        var propagate = options.propagate;
        var sources = [];
        var meta, i, el, source;
        for (i = 0; i < count; ++i) {
          meta = chart.getDatasetMeta(i);
          el = meta.dataset;
          source = null;
          if (el && el._model && el instanceof elements.Line) {
            source = {
              visible: chart.isDatasetVisible(i),
              fill: decodeFill(el, i, count),
              chart: chart,
              el: el
            };
          }
          meta.$filler = source;
          sources.push(source);
        }
        for (i = 0; i < count; ++i) {
          source = sources[i];
          if (!source) {
            continue;
          }
          source.fill = resolveTarget(sources, i, propagate);
          source.boundary = computeBoundary(source);
          source.mapper = createMapper(source);
        }
      },
      beforeDatasetsDraw: function beforeDatasetsDraw(chart) {
        var metasets = chart._getSortedVisibleDatasetMetas();
        var ctx = chart.ctx;
        var meta, i, el, view, points, mapper, color;
        for (i = metasets.length - 1; i >= 0; --i) {
          meta = metasets[i].$filler;
          if (!meta || !meta.visible) {
            continue;
          }
          el = meta.el;
          view = el._view;
          points = el._children || [];
          mapper = meta.mapper;
          color = view.backgroundColor || core_defaults.global.defaultColor;
          if (mapper && color && points.length) {
            helpers$1.canvas.clipArea(ctx, chart.chartArea);
            doFill(ctx, points, mapper, view, color, el._loop);
            helpers$1.canvas.unclipArea(ctx);
          }
        }
      }
    };
    var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
    var noop$1 = helpers$1.noop;
    var valueOrDefault$e = helpers$1.valueOrDefault;
    core_defaults._set('global', {
      legend: {
        display: true,
        position: 'top',
        align: 'center',
        fullWidth: true,
        reverse: false,
        weight: 1000,
        onClick: function onClick(e, legendItem) {
          var index = legendItem.datasetIndex;
          var ci = this.chart;
          var meta = ci.getDatasetMeta(index);
          meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
          ci.update();
        },
        onHover: null,
        onLeave: null,
        labels: {
          boxWidth: 40,
          padding: 10,
          generateLabels: function generateLabels(chart) {
            var datasets = chart.data.datasets;
            var options = chart.options.legend || {};
            var usePointStyle = options.labels && options.labels.usePointStyle;
            return chart._getSortedDatasetMetas().map(function (meta) {
              var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
              return {
                text: datasets[meta.index].label,
                fillStyle: style.backgroundColor,
                hidden: !chart.isDatasetVisible(meta.index),
                lineCap: style.borderCapStyle,
                lineDash: style.borderDash,
                lineDashOffset: style.borderDashOffset,
                lineJoin: style.borderJoinStyle,
                lineWidth: style.borderWidth,
                strokeStyle: style.borderColor,
                pointStyle: style.pointStyle,
                rotation: style.rotation,
                datasetIndex: meta.index
              };
            }, this);
          }
        }
      },
      legendCallback: function legendCallback(chart) {
        var list = document.createElement('ul');
        var datasets = chart.data.datasets;
        var i, ilen, listItem, listItemSpan;
        list.setAttribute('class', chart.id + '-legend');
        for (i = 0, ilen = datasets.length; i < ilen; i++) {
          listItem = list.appendChild(document.createElement('li'));
          listItemSpan = listItem.appendChild(document.createElement('span'));
          listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
          if (datasets[i].label) {
            listItem.appendChild(document.createTextNode(datasets[i].label));
          }
        }
        return list.outerHTML;
      }
    });
    function getBoxWidth(labelOpts, fontSize) {
      return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ? fontSize : labelOpts.boxWidth;
    }
    var Legend = core_element.extend({
      initialize: function initialize(config) {
        var me = this;
        helpers$1.extend(me, config);
        me.legendHitBoxes = [];
        me._hoveredItem = null;
        me.doughnutMode = false;
      },
      beforeUpdate: noop$1,
      update: function update(maxWidth, maxHeight, margins) {
        var me = this;
        me.beforeUpdate();
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me.margins = margins;
        me.beforeSetDimensions();
        me.setDimensions();
        me.afterSetDimensions();
        me.beforeBuildLabels();
        me.buildLabels();
        me.afterBuildLabels();
        me.beforeFit();
        me.fit();
        me.afterFit();
        me.afterUpdate();
        return me.minSize;
      },
      afterUpdate: noop$1,
      beforeSetDimensions: noop$1,
      setDimensions: function setDimensions() {
        var me = this;
        if (me.isHorizontal()) {
          me.width = me.maxWidth;
          me.left = 0;
          me.right = me.width;
        } else {
          me.height = me.maxHeight;
          me.top = 0;
          me.bottom = me.height;
        }
        me.paddingLeft = 0;
        me.paddingTop = 0;
        me.paddingRight = 0;
        me.paddingBottom = 0;
        me.minSize = {
          width: 0,
          height: 0
        };
      },
      afterSetDimensions: noop$1,
      beforeBuildLabels: noop$1,
      buildLabels: function buildLabels() {
        var me = this;
        var labelOpts = me.options.labels || {};
        var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];
        if (labelOpts.filter) {
          legendItems = legendItems.filter(function (item) {
            return labelOpts.filter(item, me.chart.data);
          });
        }
        if (me.options.reverse) {
          legendItems.reverse();
        }
        me.legendItems = legendItems;
      },
      afterBuildLabels: noop$1,
      beforeFit: noop$1,
      fit: function fit() {
        var me = this;
        var opts = me.options;
        var labelOpts = opts.labels;
        var display = opts.display;
        var ctx = me.ctx;
        var labelFont = helpers$1.options._parseFont(labelOpts);
        var fontSize = labelFont.size;
        var hitboxes = me.legendHitBoxes = [];
        var minSize = me.minSize;
        var isHorizontal = me.isHorizontal();
        if (isHorizontal) {
          minSize.width = me.maxWidth;
          minSize.height = display ? 10 : 0;
        } else {
          minSize.width = display ? 10 : 0;
          minSize.height = me.maxHeight;
        }
        if (!display) {
          me.width = minSize.width = me.height = minSize.height = 0;
          return;
        }
        ctx.font = labelFont.string;
        if (isHorizontal) {
          var lineWidths = me.lineWidths = [0];
          var totalHeight = 0;
          ctx.textAlign = 'left';
          ctx.textBaseline = 'middle';
          helpers$1.each(me.legendItems, function (legendItem, i) {
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var width = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
              totalHeight += fontSize + labelOpts.padding;
              lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
            }
            hitboxes[i] = {
              left: 0,
              top: 0,
              width: width,
              height: fontSize
            };
            lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
          });
          minSize.height += totalHeight;
        } else {
          var vPadding = labelOpts.padding;
          var columnWidths = me.columnWidths = [];
          var columnHeights = me.columnHeights = [];
          var totalWidth = labelOpts.padding;
          var currentColWidth = 0;
          var currentColHeight = 0;
          helpers$1.each(me.legendItems, function (legendItem, i) {
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
              totalWidth += currentColWidth + labelOpts.padding;
              columnWidths.push(currentColWidth);
              columnHeights.push(currentColHeight);
              currentColWidth = 0;
              currentColHeight = 0;
            }
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += fontSize + vPadding;
            hitboxes[i] = {
              left: 0,
              top: 0,
              width: itemWidth,
              height: fontSize
            };
          });
          totalWidth += currentColWidth;
          columnWidths.push(currentColWidth);
          columnHeights.push(currentColHeight);
          minSize.width += totalWidth;
        }
        me.width = minSize.width;
        me.height = minSize.height;
      },
      afterFit: noop$1,
      isHorizontal: function isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
      },
      draw: function draw() {
        var me = this;
        var opts = me.options;
        var labelOpts = opts.labels;
        var globalDefaults = core_defaults.global;
        var defaultColor = globalDefaults.defaultColor;
        var lineDefault = globalDefaults.elements.line;
        var legendHeight = me.height;
        var columnHeights = me.columnHeights;
        var legendWidth = me.width;
        var lineWidths = me.lineWidths;
        if (!opts.display) {
          return;
        }
        var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
        var ctx = me.ctx;
        var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
        var labelFont = helpers$1.options._parseFont(labelOpts);
        var fontSize = labelFont.size;
        var cursor;
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.strokeStyle = fontColor;
        ctx.fillStyle = fontColor;
        ctx.font = labelFont.string;
        var boxWidth = getBoxWidth(labelOpts, fontSize);
        var hitboxes = me.legendHitBoxes;
        var drawLegendBox = function drawLegendBox(x, y, legendItem) {
          if (isNaN(boxWidth) || boxWidth <= 0) {
            return;
          }
          ctx.save();
          var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
          ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
          ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
          ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
          ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
          ctx.lineWidth = lineWidth;
          ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
          if (ctx.setLineDash) {
            ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
          }
          if (labelOpts && labelOpts.usePointStyle) {
            var radius = boxWidth * Math.SQRT2 / 2;
            var centerX = rtlHelper.xPlus(x, boxWidth / 2);
            var centerY = y + fontSize / 2;
            helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
          } else {
            ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
            if (lineWidth !== 0) {
              ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
            }
          }
          ctx.restore();
        };
        var fillText = function fillText(x, y, legendItem, textWidth) {
          var halfFontSize = fontSize / 2;
          var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
          var yMiddle = y + halfFontSize;
          ctx.fillText(legendItem.text, xLeft, yMiddle);
          if (legendItem.hidden) {
            ctx.beginPath();
            ctx.lineWidth = 2;
            ctx.moveTo(xLeft, yMiddle);
            ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
            ctx.stroke();
          }
        };
        var alignmentOffset = function alignmentOffset(dimension, blockSize) {
          switch (opts.align) {
            case 'start':
              return labelOpts.padding;
            case 'end':
              return dimension - blockSize;
            default:
              return (dimension - blockSize + labelOpts.padding) / 2;
          }
        };
        var isHorizontal = me.isHorizontal();
        if (isHorizontal) {
          cursor = {
            x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
            y: me.top + labelOpts.padding,
            line: 0
          };
        } else {
          cursor = {
            x: me.left + labelOpts.padding,
            y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
            line: 0
          };
        }
        helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
        var itemHeight = fontSize + labelOpts.padding;
        helpers$1.each(me.legendItems, function (legendItem, i) {
          var textWidth = ctx.measureText(legendItem.text).width;
          var width = boxWidth + fontSize / 2 + textWidth;
          var x = cursor.x;
          var y = cursor.y;
          rtlHelper.setWidth(me.minSize.width);
          if (isHorizontal) {
            if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
              y = cursor.y += itemHeight;
              cursor.line++;
              x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
            }
          } else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
            x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
            cursor.line++;
            y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
          }
          var realX = rtlHelper.x(x);
          drawLegendBox(realX, y, legendItem);
          hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
          hitboxes[i].top = y;
          fillText(realX, y, legendItem, textWidth);
          if (isHorizontal) {
            cursor.x += width + labelOpts.padding;
          } else {
            cursor.y += itemHeight;
          }
        });
        helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
      },
      _getLegendItemAt: function _getLegendItemAt(x, y) {
        var me = this;
        var i, hitBox, lh;
        if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
          lh = me.legendHitBoxes;
          for (i = 0; i < lh.length; ++i) {
            hitBox = lh[i];
            if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
              return me.legendItems[i];
            }
          }
        }
        return null;
      },
      handleEvent: function handleEvent(e) {
        var me = this;
        var opts = me.options;
        var type = e.type === 'mouseup' ? 'click' : e.type;
        var hoveredItem;
        if (type === 'mousemove') {
          if (!opts.onHover && !opts.onLeave) {
            return;
          }
        } else if (type === 'click') {
          if (!opts.onClick) {
            return;
          }
        } else {
          return;
        }
        hoveredItem = me._getLegendItemAt(e.x, e.y);
        if (type === 'click') {
          if (hoveredItem && opts.onClick) {
            opts.onClick.call(me, e["native"], hoveredItem);
          }
        } else {
          if (opts.onLeave && hoveredItem !== me._hoveredItem) {
            if (me._hoveredItem) {
              opts.onLeave.call(me, e["native"], me._hoveredItem);
            }
            me._hoveredItem = hoveredItem;
          }
          if (opts.onHover && hoveredItem) {
            opts.onHover.call(me, e["native"], hoveredItem);
          }
        }
      }
    });
    function createNewLegendAndAttach(chart, legendOpts) {
      var legend = new Legend({
        ctx: chart.ctx,
        options: legendOpts,
        chart: chart
      });
      core_layouts.configure(chart, legend, legendOpts);
      core_layouts.addBox(chart, legend);
      chart.legend = legend;
    }
    var plugin_legend = {
      id: 'legend',
      _element: Legend,
      beforeInit: function beforeInit(chart) {
        var legendOpts = chart.options.legend;
        if (legendOpts) {
          createNewLegendAndAttach(chart, legendOpts);
        }
      },
      beforeUpdate: function beforeUpdate(chart) {
        var legendOpts = chart.options.legend;
        var legend = chart.legend;
        if (legendOpts) {
          helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
          if (legend) {
            core_layouts.configure(chart, legend, legendOpts);
            legend.options = legendOpts;
          } else {
            createNewLegendAndAttach(chart, legendOpts);
          }
        } else if (legend) {
          core_layouts.removeBox(chart, legend);
          delete chart.legend;
        }
      },
      afterEvent: function afterEvent(chart, e) {
        var legend = chart.legend;
        if (legend) {
          legend.handleEvent(e);
        }
      }
    };
    var noop$2 = helpers$1.noop;
    core_defaults._set('global', {
      title: {
        display: false,
        fontStyle: 'bold',
        fullWidth: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
      }
    });
    var Title = core_element.extend({
      initialize: function initialize(config) {
        var me = this;
        helpers$1.extend(me, config);
        me.legendHitBoxes = [];
      },
      beforeUpdate: noop$2,
      update: function update(maxWidth, maxHeight, margins) {
        var me = this;
        me.beforeUpdate();
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me.margins = margins;
        me.beforeSetDimensions();
        me.setDimensions();
        me.afterSetDimensions();
        me.beforeBuildLabels();
        me.buildLabels();
        me.afterBuildLabels();
        me.beforeFit();
        me.fit();
        me.afterFit();
        me.afterUpdate();
        return me.minSize;
      },
      afterUpdate: noop$2,
      beforeSetDimensions: noop$2,
      setDimensions: function setDimensions() {
        var me = this;
        if (me.isHorizontal()) {
          me.width = me.maxWidth;
          me.left = 0;
          me.right = me.width;
        } else {
          me.height = me.maxHeight;
          me.top = 0;
          me.bottom = me.height;
        }
        me.paddingLeft = 0;
        me.paddingTop = 0;
        me.paddingRight = 0;
        me.paddingBottom = 0;
        me.minSize = {
          width: 0,
          height: 0
        };
      },
      afterSetDimensions: noop$2,
      beforeBuildLabels: noop$2,
      buildLabels: noop$2,
      afterBuildLabels: noop$2,
      beforeFit: noop$2,
      fit: function fit() {
        var me = this;
        var opts = me.options;
        var minSize = me.minSize = {};
        var isHorizontal = me.isHorizontal();
        var lineCount, textSize;
        if (!opts.display) {
          me.width = minSize.width = me.height = minSize.height = 0;
          return;
        }
        lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
        textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
        me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
        me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
      },
      afterFit: noop$2,
      isHorizontal: function isHorizontal() {
        var pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
      },
      draw: function draw() {
        var me = this;
        var ctx = me.ctx;
        var opts = me.options;
        if (!opts.display) {
          return;
        }
        var fontOpts = helpers$1.options._parseFont(opts);
        var lineHeight = fontOpts.lineHeight;
        var offset = lineHeight / 2 + opts.padding;
        var rotation = 0;
        var top = me.top;
        var left = me.left;
        var bottom = me.bottom;
        var right = me.right;
        var maxWidth, titleX, titleY;
        ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor);
        ctx.font = fontOpts.string;
        if (me.isHorizontal()) {
          titleX = left + (right - left) / 2;
          titleY = top + offset;
          maxWidth = right - left;
        } else {
          titleX = opts.position === 'left' ? left + offset : right - offset;
          titleY = top + (bottom - top) / 2;
          maxWidth = bottom - top;
          rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
        }
        ctx.save();
        ctx.translate(titleX, titleY);
        ctx.rotate(rotation);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        var text = opts.text;
        if (helpers$1.isArray(text)) {
          var y = 0;
          for (var i = 0; i < text.length; ++i) {
            ctx.fillText(text[i], 0, y, maxWidth);
            y += lineHeight;
          }
        } else {
          ctx.fillText(text, 0, 0, maxWidth);
        }
        ctx.restore();
      }
    });
    function createNewTitleBlockAndAttach(chart, titleOpts) {
      var title = new Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
      });
      core_layouts.configure(chart, title, titleOpts);
      core_layouts.addBox(chart, title);
      chart.titleBlock = title;
    }
    var plugin_title = {
      id: 'title',
      _element: Title,
      beforeInit: function beforeInit(chart) {
        var titleOpts = chart.options.title;
        if (titleOpts) {
          createNewTitleBlockAndAttach(chart, titleOpts);
        }
      },
      beforeUpdate: function beforeUpdate(chart) {
        var titleOpts = chart.options.title;
        var titleBlock = chart.titleBlock;
        if (titleOpts) {
          helpers$1.mergeIf(titleOpts, core_defaults.global.title);
          if (titleBlock) {
            core_layouts.configure(chart, titleBlock, titleOpts);
            titleBlock.options = titleOpts;
          } else {
            createNewTitleBlockAndAttach(chart, titleOpts);
          }
        } else if (titleBlock) {
          core_layouts.removeBox(chart, titleBlock);
          delete chart.titleBlock;
        }
      }
    };
    var plugins = {};
    var filler = plugin_filler;
    var legend = plugin_legend;
    var title = plugin_title;
    plugins.filler = filler;
    plugins.legend = legend;
    plugins.title = title;
    core_controller.helpers = helpers$1;
    core_helpers();
    core_controller._adapters = core_adapters;
    core_controller.Animation = core_animation;
    core_controller.animationService = core_animations;
    core_controller.controllers = controllers;
    core_controller.DatasetController = core_datasetController;
    core_controller.defaults = core_defaults;
    core_controller.Element = core_element;
    core_controller.elements = elements;
    core_controller.Interaction = core_interaction;
    core_controller.layouts = core_layouts;
    core_controller.platform = platform;
    core_controller.plugins = core_plugins;
    core_controller.Scale = core_scale;
    core_controller.scaleService = core_scaleService;
    core_controller.Ticks = core_ticks;
    core_controller.Tooltip = core_tooltip;
    core_controller.helpers.each(scales, function (scale, type) {
      core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
    });
    for (var k in plugins) {
      if (plugins.hasOwnProperty(k)) {
        core_controller.plugins.register(plugins[k]);
      }
    }
    core_controller.platform.initialize();
    var src = core_controller;
    if (typeof window !== 'undefined') {
      window.Chart = core_controller;
    }
    core_controller.Chart = core_controller;
    core_controller.Legend = plugins.legend._element;
    core_controller.Title = plugins.title._element;
    core_controller.pluginService = core_controller.plugins;
    core_controller.PluginBase = core_controller.Element.extend({});
    core_controller.canvasHelpers = core_controller.helpers.canvas;
    core_controller.layoutService = core_controller.layouts;
    core_controller.LinearScaleBase = scale_linearbase;
    core_controller.helpers.each(['Bar', 'Bubble', 'Doughnut', 'Line', 'PolarArea', 'Radar', 'Scatter'], function (klass) {
      core_controller[klass] = function (ctx, cfg) {
        return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
          type: klass.charAt(0).toLowerCase() + klass.slice(1)
        }));
      };
    });
    return src;
  });
});
var es$1$1 = createCommonjsModule$1(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "Chart", {
    enumerable: true,
    get: function get() {
      return _chart["default"];
    }
  });
  exports.defaults = exports.Scatter = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = exports["default"] = void 0;
  var _react = _interopRequireDefault(React__default__default__default__default);
  var _propTypes = _interopRequireDefault(propTypes$1);
  var _chart = _interopRequireDefault(Chart$1);
  var _isEqual = _interopRequireDefault(isEqual);
  var _keyBy = _interopRequireDefault(keyBy);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }
    return _typeof(obj);
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var NODE_ENV = typeof process !== 'undefined' && process.env && process.env.NODE_ENV;
  var ChartComponent = /*#__PURE__*/function (_React$Component) {
    _inherits(ChartComponent, _React$Component);
    var _super = _createSuper(ChartComponent);
    function ChartComponent() {
      var _this;
      _classCallCheck(this, ChartComponent);
      _this = _super.call(this);
      _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
        var instance = _this.chartInstance;
        var _this$props = _this.props,
          getDatasetAtEvent = _this$props.getDatasetAtEvent,
          getElementAtEvent = _this$props.getElementAtEvent,
          getElementsAtEvent = _this$props.getElementsAtEvent,
          onElementsClick = _this$props.onElementsClick;
        getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
        getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
        getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
        onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event);
      });
      _defineProperty(_assertThisInitialized(_this), "ref", function (element) {
        _this.element = element;
      });
      _this.chartInstance = undefined;
      return _this;
    }
    _createClass(ChartComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.renderChart();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        if (this.props.redraw) {
          this.destroyChart();
          this.renderChart();
          return;
        }
        this.updateChart();
      }
    }, {
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps) {
        var _this$props2 = this.props,
          type = _this$props2.type,
          options = _this$props2.options,
          plugins = _this$props2.plugins,
          legend = _this$props2.legend,
          height = _this$props2.height,
          width = _this$props2.width;
        if (nextProps.redraw === true) {
          return true;
        }
        if (height !== nextProps.height || width !== nextProps.width) {
          return true;
        }
        if (type !== nextProps.type) {
          return true;
        }
        if (!(0, _isEqual["default"])(legend, nextProps.legend)) {
          return true;
        }
        if (!(0, _isEqual["default"])(options, nextProps.options)) {
          return true;
        }
        var nextData = this.transformDataProp(nextProps);
        if (!(0, _isEqual["default"])(this.shadowDataProp, nextData)) {
          return true;
        }
        return !(0, _isEqual["default"])(plugins, nextProps.plugins);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.destroyChart();
      }
    }, {
      key: "transformDataProp",
      value: function transformDataProp(props) {
        var data = props.data;
        if (typeof data == 'function') {
          var node = this.element;
          return data(node);
        } else {
          return data;
        }
      }
    }, {
      key: "memoizeDataProps",
      value: function memoizeDataProps() {
        if (!this.props.data) {
          return;
        }
        var data = this.transformDataProp(this.props);
        this.shadowDataProp = _objectSpread(_objectSpread({}, data), {}, {
          datasets: data.datasets && data.datasets.map(function (set) {
            return _objectSpread({}, set);
          })
        });
        this.saveCurrentDatasets();
        return data;
      }
    }, {
      key: "checkDatasets",
      value: function checkDatasets(datasets) {
        var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
        var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
        var multipleDatasets = datasets.length > 1;
        if (isDev && multipleDatasets && !usingCustomKeyProvider) {
          var shouldWarn = false;
          datasets.forEach(function (dataset) {
            if (!dataset.label) {
              shouldWarn = true;
            }
          });
          if (shouldWarn) {
            console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
          }
        }
      }
    }, {
      key: "getCurrentDatasets",
      value: function getCurrentDatasets() {
        return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
      }
    }, {
      key: "saveCurrentDatasets",
      value: function saveCurrentDatasets() {
        var _this2 = this;
        this.datasets = this.datasets || {};
        var currentDatasets = this.getCurrentDatasets();
        currentDatasets.forEach(function (d) {
          _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
        });
      }
    }, {
      key: "updateChart",
      value: function updateChart() {
        var _this3 = this;
        var options = this.props.options;
        var data = this.memoizeDataProps(this.props);
        if (!this.chartInstance) return;
        if (options) {
          this.chartInstance.options = _chart["default"].helpers.configMerge(this.chartInstance.options, options);
        }
        var currentDatasets = this.getCurrentDatasets();
        var nextDatasets = data.datasets || [];
        this.checkDatasets(currentDatasets);
        var currentDatasetsIndexed = (0, _keyBy["default"])(currentDatasets, this.props.datasetKeyProvider);
        this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
          var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];
          if (current && current.type === next.type && next.data) {
            current.data.splice(next.data.length);
            next.data.forEach(function (point, pid) {
              current.data[pid] = next.data[pid];
            });
            var otherProps = _objectWithoutProperties(next, ["data"]);
            return _objectSpread(_objectSpread({}, current), otherProps);
          } else {
            return next;
          }
        });
        var rest = _objectWithoutProperties(data, ["datasets"]);
        this.chartInstance.config.data = _objectSpread(_objectSpread({}, this.chartInstance.config.data), rest);
        this.chartInstance.update();
      }
    }, {
      key: "renderChart",
      value: function renderChart() {
        var _this$props3 = this.props,
          options = _this$props3.options,
          legend = _this$props3.legend,
          type = _this$props3.type,
          plugins = _this$props3.plugins;
        var node = this.element;
        var data = this.memoizeDataProps();
        if (typeof legend !== 'undefined' && !(0, _isEqual["default"])(ChartComponent.defaultProps.legend, legend)) {
          options.legend = legend;
        }
        this.chartInstance = new _chart["default"](node, {
          type: type,
          data: data,
          options: options,
          plugins: plugins
        });
      }
    }, {
      key: "destroyChart",
      value: function destroyChart() {
        if (!this.chartInstance) {
          return;
        }
        this.saveCurrentDatasets();
        var datasets = Object.values(this.datasets);
        this.chartInstance.config.data.datasets = datasets;
        this.chartInstance.destroy();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props4 = this.props,
          height = _this$props4.height,
          width = _this$props4.width,
          id = _this$props4.id;
        return /*#__PURE__*/_react["default"].createElement("canvas", {
          ref: this.ref,
          height: height,
          width: width,
          id: id,
          onClick: this.handleOnClick
        });
      }
    }]);
    return ChartComponent;
  }(_react["default"].Component);
  _defineProperty(ChartComponent, "getLabelAsKey", function (d) {
    return d.label;
  });
  _defineProperty(ChartComponent, "propTypes", {
    data: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]).isRequired,
    getDatasetAtEvent: _propTypes["default"].func,
    getElementAtEvent: _propTypes["default"].func,
    getElementsAtEvent: _propTypes["default"].func,
    height: _propTypes["default"].number,
    legend: _propTypes["default"].object,
    onElementsClick: _propTypes["default"].func,
    options: _propTypes["default"].object,
    plugins: _propTypes["default"].arrayOf(_propTypes["default"].object),
    redraw: _propTypes["default"].bool,
    type: function type(props, propName, componentName) {
      if (!_chart["default"].controllers[props[propName]]) {
        return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
      }
    },
    width: _propTypes["default"].number,
    datasetKeyProvider: _propTypes["default"].func
  });
  _defineProperty(ChartComponent, "defaultProps", {
    legend: {
      display: true,
      position: 'bottom'
    },
    type: 'doughnut',
    height: 150,
    width: 300,
    redraw: false,
    options: {},
    datasetKeyProvider: ChartComponent.getLabelAsKey
  });
  var _default = ChartComponent;
  exports["default"] = _default;
  var Doughnut = /*#__PURE__*/function (_React$Component2) {
    _inherits(Doughnut, _React$Component2);
    var _super2 = _createSuper(Doughnut);
    function Doughnut() {
      _classCallCheck(this, Doughnut);
      return _super2.apply(this, arguments);
    }
    _createClass(Doughnut, [{
      key: "render",
      value: function render() {
        var _this4 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref) {
            return _this4.chartInstance = _ref && _ref.chartInstance;
          },
          type: "doughnut"
        }));
      }
    }]);
    return Doughnut;
  }(_react["default"].Component);
  exports.Doughnut = Doughnut;
  var Pie = /*#__PURE__*/function (_React$Component3) {
    _inherits(Pie, _React$Component3);
    var _super3 = _createSuper(Pie);
    function Pie() {
      _classCallCheck(this, Pie);
      return _super3.apply(this, arguments);
    }
    _createClass(Pie, [{
      key: "render",
      value: function render() {
        var _this5 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref2) {
            return _this5.chartInstance = _ref2 && _ref2.chartInstance;
          },
          type: "pie"
        }));
      }
    }]);
    return Pie;
  }(_react["default"].Component);
  exports.Pie = Pie;
  var Line = /*#__PURE__*/function (_React$Component4) {
    _inherits(Line, _React$Component4);
    var _super4 = _createSuper(Line);
    function Line() {
      _classCallCheck(this, Line);
      return _super4.apply(this, arguments);
    }
    _createClass(Line, [{
      key: "render",
      value: function render() {
        var _this6 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref3) {
            return _this6.chartInstance = _ref3 && _ref3.chartInstance;
          },
          type: "line"
        }));
      }
    }]);
    return Line;
  }(_react["default"].Component);
  exports.Line = Line;
  var Bar = /*#__PURE__*/function (_React$Component5) {
    _inherits(Bar, _React$Component5);
    var _super5 = _createSuper(Bar);
    function Bar() {
      _classCallCheck(this, Bar);
      return _super5.apply(this, arguments);
    }
    _createClass(Bar, [{
      key: "render",
      value: function render() {
        var _this7 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref4) {
            return _this7.chartInstance = _ref4 && _ref4.chartInstance;
          },
          type: "bar"
        }));
      }
    }]);
    return Bar;
  }(_react["default"].Component);
  exports.Bar = Bar;
  var HorizontalBar = /*#__PURE__*/function (_React$Component6) {
    _inherits(HorizontalBar, _React$Component6);
    var _super6 = _createSuper(HorizontalBar);
    function HorizontalBar() {
      _classCallCheck(this, HorizontalBar);
      return _super6.apply(this, arguments);
    }
    _createClass(HorizontalBar, [{
      key: "render",
      value: function render() {
        var _this8 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref5) {
            return _this8.chartInstance = _ref5 && _ref5.chartInstance;
          },
          type: "horizontalBar"
        }));
      }
    }]);
    return HorizontalBar;
  }(_react["default"].Component);
  exports.HorizontalBar = HorizontalBar;
  var Radar = /*#__PURE__*/function (_React$Component7) {
    _inherits(Radar, _React$Component7);
    var _super7 = _createSuper(Radar);
    function Radar() {
      _classCallCheck(this, Radar);
      return _super7.apply(this, arguments);
    }
    _createClass(Radar, [{
      key: "render",
      value: function render() {
        var _this9 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref6) {
            return _this9.chartInstance = _ref6 && _ref6.chartInstance;
          },
          type: "radar"
        }));
      }
    }]);
    return Radar;
  }(_react["default"].Component);
  exports.Radar = Radar;
  var Polar = /*#__PURE__*/function (_React$Component8) {
    _inherits(Polar, _React$Component8);
    var _super8 = _createSuper(Polar);
    function Polar() {
      _classCallCheck(this, Polar);
      return _super8.apply(this, arguments);
    }
    _createClass(Polar, [{
      key: "render",
      value: function render() {
        var _this10 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref7) {
            return _this10.chartInstance = _ref7 && _ref7.chartInstance;
          },
          type: "polarArea"
        }));
      }
    }]);
    return Polar;
  }(_react["default"].Component);
  exports.Polar = Polar;
  var Bubble = /*#__PURE__*/function (_React$Component9) {
    _inherits(Bubble, _React$Component9);
    var _super9 = _createSuper(Bubble);
    function Bubble() {
      _classCallCheck(this, Bubble);
      return _super9.apply(this, arguments);
    }
    _createClass(Bubble, [{
      key: "render",
      value: function render() {
        var _this11 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref8) {
            return _this11.chartInstance = _ref8 && _ref8.chartInstance;
          },
          type: "bubble"
        }));
      }
    }]);
    return Bubble;
  }(_react["default"].Component);
  exports.Bubble = Bubble;
  var Scatter = /*#__PURE__*/function (_React$Component10) {
    _inherits(Scatter, _React$Component10);
    var _super10 = _createSuper(Scatter);
    function Scatter() {
      _classCallCheck(this, Scatter);
      return _super10.apply(this, arguments);
    }
    _createClass(Scatter, [{
      key: "render",
      value: function render() {
        var _this12 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref9) {
            return _this12.chartInstance = _ref9 && _ref9.chartInstance;
          },
          type: "scatter"
        }));
      }
    }]);
    return Scatter;
  }(_react["default"].Component);
  exports.Scatter = Scatter;
  var defaults = _chart["default"].defaults;
  exports.defaults = defaults;
});
unwrapExports$1(es$1$1);
function r$1$1(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r$1$1(e[t])) && (n && (n += " "), n += f);else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx$1() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) (e = arguments[f++]) && (t = r$1$1(e)) && (n && (n += " "), n += t);
  return n;
}
var clsx_m$1 = {
  __proto__: null,
  clsx: clsx$1,
  'default': clsx$1
};
var require$$1$1 = getCjsExportFromNamespace$1(clsx_m$1);
var dist$1 = createCommonjsModule$1(function (module) {
  module.exports = function (n) {
    var e = {};
    function t(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return n[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }
    return t.m = n, t.c = e, t.d = function (n, e, r) {
      t.o(n, e) || Object.defineProperty(n, e, {
        enumerable: !0,
        get: r
      });
    }, t.r = function (n) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(n, "__esModule", {
        value: !0
      });
    }, t.t = function (n, e) {
      if (1 & e && (n = t(n)), 8 & e) return n;
      if (4 & e && "object" == typeof n && n && n.__esModule) return n;
      var r = Object.create(null);
      if (t.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: n
      }), 2 & e && "string" != typeof n) for (var o in n) t.d(r, o, function (e) {
        return n[e];
      }.bind(null, o));
      return r;
    }, t.n = function (n) {
      var e = n && n.__esModule ? function () {
        return n["default"];
      } : function () {
        return n;
      };
      return t.d(e, "a", e), e;
    }, t.o = function (n, e) {
      return Object.prototype.hasOwnProperty.call(n, e);
    }, t.p = "", t(t.s = 182);
  }([function (n, e, t) {
    n.exports = t(174)();
  }, function (n, e) {
    n.exports = React__default__default__default__default;
  }, function (n, e) {
    var t = Array.isArray;
    n.exports = t;
  }, function (n, e, t) {
    var r = t(40),
      o = "object" == typeof self && self && self.Object === Object && self,
      a = r || o || Function("return this")();
    n.exports = a;
  }, function (n, e, t) {
    var r = t(78),
      o = t(25),
      a = t(27),
      i = t(28);
    n.exports = function (n, e, t) {
      return n = i(n), t = null == t ? 0 : r(a(t), 0, n.length), e = o(e), n.slice(t, t + e.length) == e;
    };
  }, function (n, e, t) {
    var r = t(171)(t(23));
    n.exports = r;
  }, function (n, e, t) {
    var r = t(14),
      o = t(76),
      a = t(77),
      i = "[object Null]",
      u = "[object Undefined]",
      c = r ? r.toStringTag : void 0;
    n.exports = function (n) {
      return null == n ? void 0 === n ? u : i : c && c in Object(n) ? o(n) : a(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return null != n && "object" == typeof n;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = typeof n;
      return null != n && ("object" == e || "function" == e);
    };
  }, function (n, e, t) {
    var r = t(92),
      o = t(95);
    n.exports = function (n, e) {
      var t = o(n, e);
      return r(t) ? t : void 0;
    };
  }, function (n, e, t) {
    var r = t(111),
      o = t(150),
      a = t(157),
      i = t(2),
      u = t(158);
    n.exports = function (n) {
      return "function" == typeof n ? n : null == n ? a : "object" == typeof n ? i(n) ? o(n[0], n[1]) : r(n) : u(n);
    };
  }, function (n, e, t) {
    var r = t(44),
      o = t(34);
    n.exports = function (n) {
      return null != n && o(n.length) && !r(n);
    };
  }, function (n, e, t) {
    var r = t(133),
      o = t(140),
      a = t(11);
    n.exports = function (n) {
      return a(n) ? r(n) : o(n);
    };
  }, function (n, e, t) {
    var r = t(26),
      o = t(10),
      a = t(168),
      i = t(2);
    n.exports = function (n, e) {
      return (i(n) ? r : a)(n, o(e, 3));
    };
  }, function (n, e, t) {
    var r = t(3).Symbol;
    n.exports = r;
  }, function (n, e, t) {
    var r = t(6),
      o = t(7),
      a = "[object Symbol]";
    n.exports = function (n) {
      return "symbol" == typeof n || o(n) && r(n) == a;
    };
  }, function (n, e, t) {
    var r = t(9)(Object, "create");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(100),
      o = t(101),
      a = t(102),
      i = t(103),
      u = t(104);
    function c(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }
    c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e, t) {
    var r = t(31);
    n.exports = function (n, e) {
      for (var t = n.length; t--;) if (r(n[t][0], e)) return t;
      return -1;
    };
  }, function (n, e, t) {
    var r = t(106);
    n.exports = function (n, e) {
      var t = n.__data__;
      return r(e) ? t["string" == typeof e ? "string" : "hash"] : t.map;
    };
  }, function (n, e, t) {
    var r = t(15),
      o = 1 / 0;
    n.exports = function (n) {
      if ("string" == typeof n || r(n)) return n;
      var e = n + "";
      return "0" == e && 1 / n == -o ? "-0" : e;
    };
  }, function (n, e, t) {
    var r = t(164),
      o = t(167)(r);
    n.exports = o;
  }, function (n, e, t) {
    var r = t(30),
      o = "Expected a function";
    function a(n, e) {
      if ("function" != typeof n || null != e && "function" != typeof e) throw new TypeError(o);
      var t = function t() {
        var r = arguments,
          o = e ? e.apply(this, r) : r[0],
          a = t.cache;
        if (a.has(o)) return a.get(o);
        var i = n.apply(this, r);
        return t.cache = a.set(o, i) || a, i;
      };
      return t.cache = new (a.Cache || r)(), t;
    }
    a.Cache = r, n.exports = a;
  }, function (n, e, t) {
    var r = t(43),
      o = t(10),
      a = t(27),
      i = Math.max;
    n.exports = function (n, e, t) {
      var u = null == n ? 0 : n.length;
      if (!u) return -1;
      var c = null == t ? 0 : a(t);
      return c < 0 && (c = i(u + c, 0)), r(n, o(e, 3), c);
    };
  }, function (n, e, t) {
    var r = t(50),
      o = t(163),
      a = t(10),
      i = t(2);
    n.exports = function (n, e) {
      return (i(n) ? r : o)(n, a(e, 3));
    };
  }, function (n, e, t) {
    var r = t(14),
      o = t(26),
      a = t(2),
      i = t(15),
      u = 1 / 0,
      c = r ? r.prototype : void 0,
      s = c ? c.toString : void 0;
    n.exports = function n(e) {
      if ("string" == typeof e) return e;
      if (a(e)) return o(e, n) + "";
      if (i(e)) return s ? s.call(e) : "";
      var t = e + "";
      return "0" == t && 1 / e == -u ? "-0" : t;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length, o = Array(r); ++t < r;) o[t] = e(n[t], t, n);
      return o;
    };
  }, function (n, e, t) {
    var r = t(79);
    n.exports = function (n) {
      var e = r(n),
        t = e % 1;
      return e == e ? t ? e - t : e : 0;
    };
  }, function (n, e, t) {
    var r = t(25);
    n.exports = function (n) {
      return null == n ? "" : r(n);
    };
  }, function (n, e, t) {
    var r = t(43),
      o = t(82),
      a = t(83);
    n.exports = function (n, e, t) {
      return e == e ? a(n, e, t) : r(n, o, t);
    };
  }, function (n, e, t) {
    var r = t(89),
      o = t(105),
      a = t(107),
      i = t(108),
      u = t(109);
    function c(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }
    c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e) {
    n.exports = function (n, e) {
      return n === e || n != n && e != e;
    };
  }, function (n, e, t) {
    var r = t(9)(t(3), "Map");
    n.exports = r;
  }, function (n, e) {
    var t = 9007199254740991,
      r = /^(?:0|[1-9]\d*)$/;
    n.exports = function (n, e) {
      var o = typeof n;
      return !!(e = null == e ? t : e) && ("number" == o || "symbol" != o && r.test(n)) && n > -1 && n % 1 == 0 && n < e;
    };
  }, function (n, e) {
    var t = 9007199254740991;
    n.exports = function (n) {
      return "number" == typeof n && n > -1 && n % 1 == 0 && n <= t;
    };
  }, function (n, e, t) {
    var r = t(2),
      o = t(15),
      a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      i = /^\w*$/;
    n.exports = function (n, e) {
      if (r(n)) return !1;
      var t = typeof n;
      return !("number" != t && "symbol" != t && "boolean" != t && null != n && !o(n)) || i.test(n) || !a.test(n) || null != e && n in Object(e);
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(2),
      a = t(7),
      i = "[object String]";
    n.exports = function (n) {
      return "string" == typeof n || !o(n) && a(n) && r(n) == i;
    };
  }, function (n, e, t) {
    var r = t(169),
      o = t(21),
      a = t(10),
      i = t(170),
      u = t(2);
    n.exports = function (n, e, t) {
      var c = u(n) ? r : i,
        s = arguments.length < 3;
      return c(n, a(e, 4), t, s, o);
    };
  }, function (n, e, t) {
    var r = t(49),
      o = t(10),
      a = t(172),
      i = t(2),
      u = t(173);
    n.exports = function (n, e, t) {
      var c = i(n) ? r : a;
      return t && u(n, e, t) && (e = void 0), c(n, o(e, 3));
    };
  }, function (n, e) {
    var t;
    function r(n, e) {
      var t = Object.keys(n);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(n);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        })), t.push.apply(t, r);
      }
      return t;
    }
    function o(n, e, t) {
      return e in n ? Object.defineProperty(n, e, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[e] = t, n;
    }
    function a(n, e) {
      return function (n) {
        if (Array.isArray(n)) return n;
      }(n) || function (n, e) {
        if (!(Symbol.iterator in Object(n) || "[object Arguments]" === Object.prototype.toString.call(n))) return;
        var t = [],
          r = !0,
          o = !1,
          a = void 0;
        try {
          for (var i, u = n[Symbol.iterator](); !(r = (i = u.next()).done) && (t.push(i.value), !e || t.length !== e); r = !0);
        } catch (n) {
          o = !0, a = n;
        } finally {
          try {
            r || null == u["return"] || u["return"]();
          } finally {
            if (o) throw a;
          }
        }
        return t;
      }(n, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }
    var i = {};
    function u(n, e, t) {
      e in i || (i[e] = []);
      var r = t || 0;
      i[e][r] = n;
    }
    var c,
      s = (t = []).concat.apply(t, function (n) {
        if (Array.isArray(n)) {
          for (var e = 0, t = new Array(n.length); e < n.length; e++) t[e] = n[e];
          return t;
        }
      }(c = [["Afghanistan", ["asia"], "af", "93"], ["Albania", ["europe"], "al", "355"], ["Algeria", ["africa", "north-africa"], "dz", "213"], ["American Samoa", ["oceania"], "as", "1684"], ["Andorra", ["europe"], "ad", "376"], ["Angola", ["africa"], "ao", "244"], ["Anguilla", ["america", "carribean"], "ai", "1264"], ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"], ["Argentina", ["america", "south-america"], "ar", "54", "+.. (..) ........"], ["Armenia", ["asia", "ex-ussr"], "am", "374"], ["Aruba", ["america", "carribean"], "aw", "297"], ["Australia", ["oceania"], "au", "61", "+.. ... ... ..."], ["Austria", ["europe", "european-union"], "at", "43"], ["Azerbaijan", ["asia", "ex-ussr"], "az", "994"], ["Bahamas", ["america", "carribean"], "bs", "1242"], ["Bahrain", ["middle-east"], "bh", "973"], ["Bangladesh", ["asia"], "bd", "880"], ["Barbados", ["america", "carribean"], "bb", "1246"], ["Belarus", ["europe", "ex-ussr"], "by", "375", "+... (..) ... .. .."], ["Belgium", ["europe", "european-union"], "be", "32", "+.. ... .. .. .."], ["Belize", ["america", "central-america"], "bz", "501"], ["Benin", ["africa"], "bj", "229"], ["Bermuda", ["america", "north-america"], "bm", "1441"], ["Bhutan", ["asia"], "bt", "975"], ["Bolivia", ["america", "south-america"], "bo", "591"], ["Bosnia and Herzegovina", ["europe"], "ba", "387"], ["Botswana", ["africa"], "bw", "267"], ["Brazil", ["america", "south-america"], "br", "55", "+.. (..) ........."], ["British Indian Ocean Territory", ["asia"], "io", "246"], ["British Virgin Islands", ["america", "carribean"], "vg", "1284"], ["Brunei", ["asia"], "bn", "673"], ["Bulgaria", ["europe", "european-union"], "bg", "359"], ["Burkina Faso", ["africa"], "bf", "226"], ["Burundi", ["africa"], "bi", "257"], ["Cambodia", ["asia"], "kh", "855"], ["Cameroon", ["africa"], "cm", "237"], ["Canada", ["america", "north-america"], "ca", "1", "+. (...) ...-....", 1, ["204", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde", ["africa"], "cv", "238"], ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1], ["Cayman Islands", ["america", "carribean"], "ky", "1345"], ["Central African Republic", ["africa"], "cf", "236"], ["Chad", ["africa"], "td", "235"], ["Chile", ["america", "south-america"], "cl", "56"], ["China", ["asia"], "cn", "86", "+.. ..-........."], ["Colombia", ["america", "south-america"], "co", "57"], ["Comoros", ["africa"], "km", "269"], ["Congo", ["africa"], "cd", "243"], ["Congo", ["africa"], "cg", "242"], ["Cook Islands", ["oceania"], "ck", "682"], ["Costa Rica", ["america", "central-america"], "cr", "506", "+... ....-...."], ["Côte d’Ivoire", ["africa"], "ci", "225"], ["Croatia", ["europe", "european-union"], "hr", "385"], ["Cuba", ["america", "carribean"], "cu", "53"], ["Curaçao", ["america", "carribean"], "cw", "599", "", 0], ["Cyprus", ["europe", "european-union"], "cy", "357", "+... .. ......"], ["Czech Republic", ["europe", "european-union"], "cz", "420"], ["Denmark", ["europe", "european-union"], "dk", "45", "+.. .. .. .. .."], ["Djibouti", ["africa"], "dj", "253"], ["Dominica", ["america", "carribean"], "dm", "1767"], ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2, ["809", "829", "849"]], ["Ecuador", ["america", "south-america"], "ec", "593"], ["Egypt", ["africa", "north-africa"], "eg", "20"], ["El Salvador", ["america", "central-america"], "sv", "503", "+... ....-...."], ["Equatorial Guinea", ["africa"], "gq", "240"], ["Eritrea", ["africa"], "er", "291"], ["Estonia", ["europe", "european-union", "ex-ussr"], "ee", "372", "+... .... ......"], ["Ethiopia", ["africa"], "et", "251"], ["Falkland Islands", ["america", "south-america"], "fk", "500"], ["Faroe Islands", ["europe"], "fo", "298"], ["Fiji", ["oceania"], "fj", "679"], ["Finland", ["europe", "european-union"], "fi", "358", "+... .. ... .. .."], ["France", ["europe", "european-union"], "fr", "33", "+.. . .. .. .. .."], ["French Guiana", ["america", "south-america"], "gf", "594"], ["French Polynesia", ["oceania"], "pf", "689"], ["Gabon", ["africa"], "ga", "241"], ["Gambia", ["africa"], "gm", "220"], ["Georgia", ["asia", "ex-ussr"], "ge", "995"], ["Germany", ["europe", "european-union"], "de", "49", "+.. .... ........"], ["Ghana", ["africa"], "gh", "233"], ["Gibraltar", ["europe"], "gi", "350"], ["Greece", ["europe", "european-union"], "gr", "30"], ["Greenland", ["america"], "gl", "299"], ["Grenada", ["america", "carribean"], "gd", "1473"], ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0], ["Guam", ["oceania"], "gu", "1671"], ["Guatemala", ["america", "central-america"], "gt", "502", "+... ....-...."], ["Guinea", ["africa"], "gn", "224"], ["Guinea-Bissau", ["africa"], "gw", "245"], ["Guyana", ["america", "south-america"], "gy", "592"], ["Haiti", ["america", "carribean"], "ht", "509", "+... ....-...."], ["Honduras", ["america", "central-america"], "hn", "504"], ["Hong Kong", ["asia"], "hk", "852", "+... .... ...."], ["Hungary", ["europe", "european-union"], "hu", "36"], ["Iceland", ["europe"], "is", "354", "+... ... ...."], ["India", ["asia"], "in", "91", "+.. .....-....."], ["Indonesia", ["asia"], "id", "62"], ["Iran", ["middle-east"], "ir", "98"], ["Iraq", ["middle-east"], "iq", "964"], ["Ireland", ["europe", "european-union"], "ie", "353", "+... .. ......."], ["Israel", ["middle-east"], "il", "972", "+... ... ... ...."], ["Italy", ["europe", "european-union"], "it", "39", "+.. ... .......", 0], ["Jamaica", ["america", "carribean"], "jm", "1876"], ["Japan", ["asia"], "jp", "81", "+.. .. .... ...."], ["Jordan", ["middle-east"], "jo", "962"], ["Kazakhstan", ["asia", "ex-ussr"], "kz", "7", "+. ... ...-..-..", 1, ["313", "327", "7172", "312", "73622", "321", "324", "336", "318", "315", "325", "311", "326", "310"]], ["Kenya", ["africa"], "ke", "254"], ["Kiribati", ["oceania"], "ki", "686"], ["Kuwait", ["middle-east"], "kw", "965"], ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996"], ["Laos", ["asia"], "la", "856"], ["Latvia", ["europe", "european-union", "ex-ussr"], "lv", "371"], ["Lebanon", ["middle-east"], "lb", "961"], ["Lesotho", ["africa"], "ls", "266"], ["Liberia", ["africa"], "lr", "231"], ["Libya", ["africa", "north-africa"], "ly", "218"], ["Liechtenstein", ["europe"], "li", "423"], ["Lithuania", ["europe", "european-union", "ex-ussr"], "lt", "370"], ["Luxembourg", ["europe", "european-union"], "lu", "352"], ["Macau", ["asia"], "mo", "853"], ["Macedonia", ["europe"], "mk", "389"], ["Madagascar", ["africa"], "mg", "261"], ["Malawi", ["africa"], "mw", "265"], ["Malaysia", ["asia"], "my", "60", "+.. ..-....-...."], ["Maldives", ["asia"], "mv", "960"], ["Mali", ["africa"], "ml", "223"], ["Malta", ["europe", "european-union"], "mt", "356"], ["Marshall Islands", ["oceania"], "mh", "692"], ["Martinique", ["america", "carribean"], "mq", "596"], ["Mauritania", ["africa"], "mr", "222"], ["Mauritius", ["africa"], "mu", "230"], ["Mexico", ["america", "central-america"], "mx", "52"], ["Micronesia", ["oceania"], "fm", "691"], ["Moldova", ["europe"], "md", "373", "+... (..) ..-..-.."], ["Monaco", ["europe"], "mc", "377"], ["Mongolia", ["asia"], "mn", "976"], ["Montenegro", ["europe"], "me", "382"], ["Montserrat", ["america", "carribean"], "ms", "1664"], ["Morocco", ["africa", "north-africa"], "ma", "212"], ["Mozambique", ["africa"], "mz", "258"], ["Myanmar", ["asia"], "mm", "95"], ["Namibia", ["africa"], "na", "264"], ["Nauru", ["africa"], "nr", "674"], ["Nepal", ["asia"], "np", "977"], ["Netherlands", ["europe", "european-union"], "nl", "31", "+.. .. ........"], ["New Caledonia", ["oceania"], "nc", "687"], ["New Zealand", ["oceania"], "nz", "64", "+.. ...-...-...."], ["Nicaragua", ["america", "central-america"], "ni", "505"], ["Niger", ["africa"], "ne", "227"], ["Nigeria", ["africa"], "ng", "234"], ["Niue", ["asia"], "nu", "683"], ["Norfolk Island", ["oceania"], "nf", "672"], ["North Korea", ["asia"], "kp", "850"], ["Northern Mariana Islands", ["oceania"], "mp", "1670"], ["Norway", ["europe"], "no", "47", "+.. ... .. ..."], ["Oman", ["middle-east"], "om", "968"], ["Pakistan", ["asia"], "pk", "92", "+.. ...-......."], ["Palau", ["oceania"], "pw", "680"], ["Palestine", ["middle-east"], "ps", "970"], ["Panama", ["america", "central-america"], "pa", "507"], ["Papua New Guinea", ["oceania"], "pg", "675"], ["Paraguay", ["america", "south-america"], "py", "595"], ["Peru", ["america", "south-america"], "pe", "51"], ["Philippines", ["asia"], "ph", "63", "+.. .... ......."], ["Poland", ["europe", "european-union"], "pl", "48", "+.. ...-...-..."], ["Portugal", ["europe", "european-union"], "pt", "351"], ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3, ["787", "939"]], ["Qatar", ["middle-east"], "qa", "974"], ["Réunion", ["africa"], "re", "262"], ["Romania", ["europe", "european-union"], "ro", "40"], ["Russia", ["europe", "asia", "ex-ussr"], "ru", "7", "+. (...) ...-..-..", 0], ["Rwanda", ["africa"], "rw", "250"], ["Saint Barthélemy", ["america", "carribean"], "bl", "590", "", 1], ["Saint Helena", ["africa"], "sh", "290"], ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"], ["Saint Lucia", ["america", "carribean"], "lc", "1758"], ["Saint Martin", ["america", "carribean"], "mf", "590", "", 2], ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"], ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"], ["Samoa", ["oceania"], "ws", "685"], ["San Marino", ["europe"], "sm", "378"], ["São Tomé and Príncipe", ["africa"], "st", "239"], ["Saudi Arabia", ["middle-east"], "sa", "966"], ["Senegal", ["africa"], "sn", "221"], ["Serbia", ["europe"], "rs", "381"], ["Seychelles", ["africa"], "sc", "248"], ["Sierra Leone", ["africa"], "sl", "232"], ["Singapore", ["asia"], "sg", "65", "+.. ....-...."], ["Sint Maarten", ["america", "carribean"], "sx", "1721"], ["Slovakia", ["europe", "european-union"], "sk", "421"], ["Slovenia", ["europe", "european-union"], "si", "386"], ["Solomon Islands", ["oceania"], "sb", "677"], ["Somalia", ["africa"], "so", "252"], ["South Africa", ["africa"], "za", "27"], ["South Korea", ["asia"], "kr", "82", "+.. ... .... ...."], ["South Sudan", ["africa", "north-africa"], "ss", "211"], ["Spain", ["europe", "european-union"], "es", "34", "+.. ... ... ..."], ["Sri Lanka", ["asia"], "lk", "94"], ["Sudan", ["africa"], "sd", "249"], ["Suriname", ["america", "south-america"], "sr", "597"], ["Swaziland", ["africa"], "sz", "268"], ["Sweden", ["europe", "european-union"], "se", "46", "+.. (..) ...-..-.."], ["Switzerland", ["europe"], "ch", "41", "+.. .. ... .. .."], ["Syria", ["middle-east"], "sy", "963"], ["Taiwan", ["asia"], "tw", "886"], ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"], ["Tanzania", ["africa"], "tz", "255"], ["Thailand", ["asia"], "th", "66"], ["Timor-Leste", ["asia"], "tl", "670"], ["Togo", ["africa"], "tg", "228"], ["Tokelau", ["oceania"], "tk", "690"], ["Tonga", ["oceania"], "to", "676"], ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"], ["Tunisia", ["africa", "north-africa"], "tn", "216"], ["Turkey", ["europe"], "tr", "90", "+.. ... ... .. .."], ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"], ["Turks and Caicos Islands", ["america", "carribean"], "tc", "1649"], ["Tuvalu", ["asia"], "tv", "688"], ["U.S. Virgin Islands", ["america", "carribean"], "vi", "1340"], ["Uganda", ["africa"], "ug", "256"], ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "+... (..) ... .. .."], ["United Arab Emirates", ["middle-east"], "ae", "971"], ["United Kingdom", ["europe", "european-union"], "gb", "44", "+.. .... ......"], ["United States", ["america", "north-america"], "us", "1", "+. (...) ...-....", 0, ["907", "205", "251", "256", "334", "479", "501", "870", "480", "520", "602", "623", "928", "209", "213", "310", "323", "408", "415", "510", "530", "559", "562", "619", "626", "650", "661", "707", "714", "760", "805", "818", "831", "858", "909", "916", "925", "949", "951", "303", "719", "970", "203", "860", "202", "302", "239", "305", "321", "352", "386", "407", "561", "727", "772", "813", "850", "863", "904", "941", "954", "229", "404", "478", "706", "770", "912", "808", "319", "515", "563", "641", "712", "208", "217", "309", "312", "618", "630", "708", "773", "815", "847", "219", "260", "317", "574", "765", "812", "316", "620", "785", "913", "270", "502", "606", "859", "225", "318", "337", "504", "985", "413", "508", "617", "781", "978", "301", "410", "207", "231", "248", "269", "313", "517", "586", "616", "734", "810", "906", "989", "218", "320", "507", "612", "651", "763", "952", "314", "417", "573", "636", "660", "816", "228", "601", "662", "406", "252", "336", "704", "828", "910", "919", "701", "308", "402", "603", "201", "609", "732", "856", "908", "973", "505", "575", "702", "775", "212", "315", "516", "518", "585", "607", "631", "716", "718", "845", "914", "216", "330", "419", "440", "513", "614", "740", "937", "405", "580", "918", "503", "541", "215", "412", "570", "610", "717", "724", "814", "401", "803", "843", "864", "605", "423", "615", "731", "865", "901", "931", "210", "214", "254", "281", "325", "361", "409", "432", "512", "713", "806", "817", "830", "903", "915", "936", "940", "956", "972", "979", "435", "801", "276", "434", "540", "703", "757", "804", "802", "206", "253", "360", "425", "509", "262", "414", "608", "715", "920", "304", "307"]], ["Uruguay", ["america", "south-america"], "uy", "598"], ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998"], ["Vanuatu", ["oceania"], "vu", "678"], ["Vatican City", ["europe"], "va", "39", "+.. .. .... ....", 1], ["Venezuela", ["america", "south-america"], "ve", "58"], ["Vietnam", ["asia"], "vn", "84"], ["Wallis and Futuna", ["oceania"], "wf", "681"], ["Yemen", ["middle-east"], "ye", "967"], ["Zambia", ["africa"], "zm", "260"], ["Zimbabwe", ["africa"], "zw", "263"]].map(function (n) {
        var e = a(n, 7),
          t = e[0],
          i = e[1],
          c = e[2],
          s = e[3],
          p = e[4],
          f = e[5],
          l = e[6],
          g = {
            name: t,
            regions: i,
            iso2: c,
            dialCode: s,
            priority: f,
            format: p || void 0,
            hasAreaCodes: l
          },
          d = [];
        return g.hasAreaCodes && l.forEach(function (n) {
          var e = function (n) {
            for (var e = 1; e < arguments.length; e++) {
              var t = null != arguments[e] ? arguments[e] : {};
              e % 2 ? r(t, !0).forEach(function (e) {
                o(n, e, t[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : r(t).forEach(function (e) {
                Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(t, e));
              });
            }
            return n;
          }({}, g, {
            regions: i,
            dialCode: "".concat(s).concat(n),
            isAreaCode: !0
          });
          d.push(e), u(c, e.dialCode);
        }), u(g.iso2, g.dialCode, g.hasAreaCodes), d.length > 0 ? [g].concat(d) : [g];
      })) || function (n) {
        if (Symbol.iterator in Object(n) || "[object Arguments]" === Object.prototype.toString.call(n)) return Array.from(n);
      }(c) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }());
    n.exports = {
      allCountries: s,
      allCountryCodes: i
    };
  }, function (n, e, t) {
    (function (e) {
      var t = "object" == typeof e && e && e.Object === Object && e;
      n.exports = t;
    }).call(this, t(75));
  }, function (n, e, t) {
    var r = t(8),
      o = t(15),
      a = NaN,
      i = /^\s+|\s+$/g,
      u = /^[-+]0x[0-9a-f]+$/i,
      c = /^0b[01]+$/i,
      s = /^0o[0-7]+$/i,
      p = parseInt;
    n.exports = function (n) {
      if ("number" == typeof n) return n;
      if (o(n)) return a;
      if (r(n)) {
        var e = "function" == typeof n.valueOf ? n.valueOf() : n;
        n = r(e) ? e + "" : e;
      }
      if ("string" != typeof n) return 0 === n ? n : +n;
      n = n.replace(i, "");
      var t = c.test(n);
      return t || s.test(n) ? p(n.slice(2), t ? 2 : 8) : u.test(n) ? a : +n;
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      var r = -1,
        o = n.length;
      e < 0 && (e = -e > o ? 0 : o + e), (t = t > o ? o : t) < 0 && (t += o), o = e > t ? 0 : t - e >>> 0, e >>>= 0;
      for (var a = Array(o); ++r < o;) a[r] = n[r + e];
      return a;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r) {
      for (var o = n.length, a = t + (r ? 1 : -1); r ? a-- : ++a < o;) if (e(n[a], a, n)) return a;
      return -1;
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(8),
      a = "[object AsyncFunction]",
      i = "[object Function]",
      u = "[object GeneratorFunction]",
      c = "[object Proxy]";
    n.exports = function (n) {
      if (!o(n)) return !1;
      var e = r(n);
      return e == i || e == u || e == a || e == c;
    };
  }, function (n, e) {
    var t = Function.prototype.toString;
    n.exports = function (n) {
      if (null != n) {
        try {
          return t.call(n);
        } catch (n) {}
        try {
          return n + "";
        } catch (n) {}
      }
      return "";
    };
  }, function (n, e, t) {
    var r = t(17),
      o = t(113),
      a = t(114),
      i = t(115),
      u = t(116),
      c = t(117);
    function s(n) {
      var e = this.__data__ = new r(n);
      this.size = e.size;
    }
    s.prototype.clear = o, s.prototype["delete"] = a, s.prototype.get = i, s.prototype.has = u, s.prototype.set = c, n.exports = s;
  }, function (n, e, t) {
    var r = t(118),
      o = t(7);
    n.exports = function n(e, t, a, i, u) {
      return e === t || (null == e || null == t || !o(e) && !o(t) ? e != e && t != t : r(e, t, a, i, n, u));
    };
  }, function (n, e, t) {
    var r = t(119),
      o = t(49),
      a = t(122),
      i = 1,
      u = 2;
    n.exports = function (n, e, t, c, s, p) {
      var f = t & i,
        l = n.length,
        g = e.length;
      if (l != g && !(f && g > l)) return !1;
      var d = p.get(n);
      if (d && p.get(e)) return d == e;
      var b = -1,
        x = !0,
        A = t & u ? new r() : void 0;
      for (p.set(n, e), p.set(e, n); ++b < l;) {
        var v = n[b],
          h = e[b];
        if (c) var m = f ? c(h, v, b, e, n, p) : c(v, h, b, n, e, p);
        if (void 0 !== m) {
          if (m) continue;
          x = !1;
          break;
        }
        if (A) {
          if (!o(e, function (n, e) {
            if (!a(A, e) && (v === n || s(v, n, t, c, p))) return A.push(e);
          })) {
            x = !1;
            break;
          }
        } else if (v !== h && !s(v, h, t, c, p)) {
          x = !1;
          break;
        }
      }
      return p["delete"](n), p["delete"](e), x;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length; ++t < r;) if (e(n[t], t, n)) return !0;
      return !1;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length, o = 0, a = []; ++t < r;) {
        var i = n[t];
        e(i, t, n) && (a[o++] = i);
      }
      return a;
    };
  }, function (n, e, t) {
    var r = t(135),
      o = t(7),
      a = Object.prototype,
      i = a.hasOwnProperty,
      u = a.propertyIsEnumerable,
      c = r(function () {
        return arguments;
      }()) ? r : function (n) {
        return o(n) && i.call(n, "callee") && !u.call(n, "callee");
      };
    n.exports = c;
  }, function (n, e, t) {
    (function (n) {
      var r = t(3),
        o = t(136),
        a = e && !e.nodeType && e,
        i = a && "object" == typeof n && n && !n.nodeType && n,
        u = i && i.exports === a ? r.Buffer : void 0,
        c = (u ? u.isBuffer : void 0) || o;
      n.exports = c;
    }).call(this, t(53)(n));
  }, function (n, e) {
    n.exports = function (n) {
      return n.webpackPolyfill || (n.deprecate = function () {}, n.paths = [], n.children || (n.children = []), Object.defineProperty(n, "loaded", {
        enumerable: !0,
        get: function get() {
          return n.l;
        }
      }), Object.defineProperty(n, "id", {
        enumerable: !0,
        get: function get() {
          return n.i;
        }
      }), n.webpackPolyfill = 1), n;
    };
  }, function (n, e, t) {
    var r = t(137),
      o = t(138),
      a = t(139),
      i = a && a.isTypedArray,
      u = i ? o(i) : r;
    n.exports = u;
  }, function (n, e, t) {
    var r = t(8);
    n.exports = function (n) {
      return n == n && !r(n);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return function (t) {
        return null != t && t[n] === e && (void 0 !== e || n in Object(t));
      };
    };
  }, function (n, e, t) {
    var r = t(58),
      o = t(20);
    n.exports = function (n, e) {
      for (var t = 0, a = (e = r(e, n)).length; null != n && t < a;) n = n[o(e[t++])];
      return t && t == a ? n : void 0;
    };
  }, function (n, e, t) {
    var r = t(2),
      o = t(35),
      a = t(152),
      i = t(28);
    n.exports = function (n, e) {
      return r(n) ? n : o(n, e) ? [n] : a(i(n));
    };
  }, function (n, e) {
    n.exports = "data:image/png;base64,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";
  }, function (n, e, t) {
    var r = t(25),
      o = t(80),
      a = t(81),
      i = t(84),
      u = t(85),
      c = t(28),
      s = /^\s+|\s+$/g;
    n.exports = function (n, e, t) {
      if ((n = c(n)) && (t || void 0 === e)) return n.replace(s, "");
      if (!n || !(e = r(e))) return n;
      var p = u(n),
        f = u(e),
        l = i(p, f),
        g = a(p, f) + 1;
      return o(p, l, g).join("");
    };
  }, function (n, e, t) {
    var r = t(8),
      o = t(110),
      a = t(41),
      i = "Expected a function",
      u = Math.max,
      c = Math.min;
    n.exports = function (n, e, t) {
      var s,
        p,
        f,
        l,
        g,
        d,
        b = 0,
        x = !1,
        A = !1,
        v = !0;
      if ("function" != typeof n) throw new TypeError(i);
      function h(e) {
        var t = s,
          r = p;
        return s = p = void 0, b = e, l = n.apply(r, t);
      }
      function m(n) {
        var t = n - d;
        return void 0 === d || t >= e || t < 0 || A && n - b >= f;
      }
      function y() {
        var n = o();
        if (m(n)) return C(n);
        g = setTimeout(y, function (n) {
          var t = e - (n - d);
          return A ? c(t, f - (n - b)) : t;
        }(n));
      }
      function C(n) {
        return g = void 0, v && s ? h(n) : (s = p = void 0, l);
      }
      function k() {
        var n = o(),
          t = m(n);
        if (s = arguments, p = this, d = n, t) {
          if (void 0 === g) return function (n) {
            return b = n, g = setTimeout(y, e), x ? h(n) : l;
          }(d);
          if (A) return clearTimeout(g), g = setTimeout(y, e), h(d);
        }
        return void 0 === g && (g = setTimeout(y, e)), l;
      }
      return e = a(e) || 0, r(t) && (x = !!t.leading, f = (A = "maxWait" in t) ? u(a(t.maxWait) || 0, e) : f, v = "trailing" in t ? !!t.trailing : v), k.cancel = function () {
        void 0 !== g && clearTimeout(g), b = 0, s = d = p = g = void 0;
      }, k.flush = function () {
        return void 0 === g ? l : C(o());
      }, k;
    };
  }, function (n, e, t) {
    var r = t(42);
    n.exports = function (n) {
      var e = null == n ? 0 : n.length;
      return e ? r(n, 1, e) : [];
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n && n.length ? n[0] : void 0;
    };
  }, function (n, e, t) {
    var r = t(29),
      o = t(11),
      a = t(36),
      i = t(27),
      u = t(161),
      c = Math.max;
    n.exports = function (n, e, t, s) {
      n = o(n) ? n : u(n), t = t && !s ? i(t) : 0;
      var p = n.length;
      return t < 0 && (t = c(p + t, 0)), a(n) ? t <= p && n.indexOf(e, t) > -1 : !!p && r(n, e, t) > -1;
    };
  }, function (n, e) {
    n.exports = require$$1$1;
  }, function (n, e) {
    n.exports = TextField;
  }, function (n, e) {
    n.exports = InputAdornment;
  }, function (n, e) {
    n.exports = Button$2;
  }, function (n, e) {
    n.exports = Menu;
  }, function (n, e) {
    n.exports = Divider;
  }, function (n, e) {
    n.exports = NativeSelect;
  }, function (n, e) {
    n.exports = withStyles$1;
  }, function (n, e) {
    n.exports = MenuItem;
  }, function (n, e) {
    n.exports = RootRef;
  }, function (n, e) {
    var t;
    t = function () {
      return this;
    }();
    try {
      t = t || new Function("return this")();
    } catch (n) {
      "object" == typeof window && (t = window);
    }
    n.exports = t;
  }, function (n, e, t) {
    var r = t(14),
      o = Object.prototype,
      a = o.hasOwnProperty,
      i = o.toString,
      u = r ? r.toStringTag : void 0;
    n.exports = function (n) {
      var e = a.call(n, u),
        t = n[u];
      try {
        n[u] = void 0;
        var r = !0;
      } catch (n) {}
      var o = i.call(n);
      return r && (e ? n[u] = t : delete n[u]), o;
    };
  }, function (n, e) {
    var t = Object.prototype.toString;
    n.exports = function (n) {
      return t.call(n);
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      return n == n && (void 0 !== t && (n = n <= t ? n : t), void 0 !== e && (n = n >= e ? n : e)), n;
    };
  }, function (n, e, t) {
    var r = t(41),
      o = 1 / 0,
      a = 17976931348623157e292;
    n.exports = function (n) {
      return n ? (n = r(n)) === o || n === -o ? (n < 0 ? -1 : 1) * a : n == n ? n : 0 : 0 === n ? n : 0;
    };
  }, function (n, e, t) {
    var r = t(42);
    n.exports = function (n, e, t) {
      var o = n.length;
      return t = void 0 === t ? o : t, !e && t >= o ? n : r(n, e, t);
    };
  }, function (n, e, t) {
    var r = t(29);
    n.exports = function (n, e) {
      for (var t = n.length; t-- && r(e, n[t], 0) > -1;);
      return t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n != n;
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      for (var r = t - 1, o = n.length; ++r < o;) if (n[r] === e) return r;
      return -1;
    };
  }, function (n, e, t) {
    var r = t(29);
    n.exports = function (n, e) {
      for (var t = -1, o = n.length; ++t < o && r(e, n[t], 0) > -1;);
      return t;
    };
  }, function (n, e, t) {
    var r = t(86),
      o = t(87),
      a = t(88);
    n.exports = function (n) {
      return o(n) ? a(n) : r(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n.split("");
    };
  }, function (n, e) {
    var t = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
    n.exports = function (n) {
      return t.test(n);
    };
  }, function (n, e) {
    var t = "[\\ud800-\\udfff]",
      r = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
      o = "\\ud83c[\\udffb-\\udfff]",
      a = "[^\\ud800-\\udfff]",
      i = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      u = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      c = "(?:" + r + "|" + o + ")" + "?",
      s = "[\\ufe0e\\ufe0f]?" + c + ("(?:\\u200d(?:" + [a, i, u].join("|") + ")[\\ufe0e\\ufe0f]?" + c + ")*"),
      p = "(?:" + [a + r + "?", r, i, u, t].join("|") + ")",
      f = RegExp(o + "(?=" + o + ")|" + p + s, "g");
    n.exports = function (n) {
      return n.match(f) || [];
    };
  }, function (n, e, t) {
    var r = t(90),
      o = t(17),
      a = t(32);
    n.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new r(),
        map: new (a || o)(),
        string: new r()
      };
    };
  }, function (n, e, t) {
    var r = t(91),
      o = t(96),
      a = t(97),
      i = t(98),
      u = t(99);
    function c(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }
    c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e, t) {
    var r = t(16);
    n.exports = function () {
      this.__data__ = r ? r(null) : {}, this.size = 0;
    };
  }, function (n, e, t) {
    var r = t(44),
      o = t(93),
      a = t(8),
      i = t(45),
      u = /^\[object .+?Constructor\]$/,
      c = Function.prototype,
      s = Object.prototype,
      p = c.toString,
      f = s.hasOwnProperty,
      l = RegExp("^" + p.call(f).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    n.exports = function (n) {
      return !(!a(n) || o(n)) && (r(n) ? l : u).test(i(n));
    };
  }, function (n, e, t) {
    var r,
      o = t(94),
      a = (r = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";
    n.exports = function (n) {
      return !!a && a in n;
    };
  }, function (n, e, t) {
    var r = t(3)["__core-js_shared__"];
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n, e) {
      return null == n ? void 0 : n[e];
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = this.has(n) && delete this.__data__[n];
      return this.size -= e ? 1 : 0, e;
    };
  }, function (n, e, t) {
    var r = t(16),
      o = "__lodash_hash_undefined__",
      a = Object.prototype.hasOwnProperty;
    n.exports = function (n) {
      var e = this.__data__;
      if (r) {
        var t = e[n];
        return t === o ? void 0 : t;
      }
      return a.call(e, n) ? e[n] : void 0;
    };
  }, function (n, e, t) {
    var r = t(16),
      o = Object.prototype.hasOwnProperty;
    n.exports = function (n) {
      var e = this.__data__;
      return r ? void 0 !== e[n] : o.call(e, n);
    };
  }, function (n, e, t) {
    var r = t(16),
      o = "__lodash_hash_undefined__";
    n.exports = function (n, e) {
      var t = this.__data__;
      return this.size += this.has(n) ? 0 : 1, t[n] = r && void 0 === e ? o : e, this;
    };
  }, function (n, e) {
    n.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (n, e, t) {
    var r = t(18),
      o = Array.prototype.splice;
    n.exports = function (n) {
      var e = this.__data__,
        t = r(e, n);
      return !(t < 0) && (t == e.length - 1 ? e.pop() : o.call(e, t, 1), --this.size, !0);
    };
  }, function (n, e, t) {
    var r = t(18);
    n.exports = function (n) {
      var e = this.__data__,
        t = r(e, n);
      return t < 0 ? void 0 : e[t][1];
    };
  }, function (n, e, t) {
    var r = t(18);
    n.exports = function (n) {
      return r(this.__data__, n) > -1;
    };
  }, function (n, e, t) {
    var r = t(18);
    n.exports = function (n, e) {
      var t = this.__data__,
        o = r(t, n);
      return o < 0 ? (++this.size, t.push([n, e])) : t[o][1] = e, this;
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n) {
      var e = r(this, n)["delete"](n);
      return this.size -= e ? 1 : 0, e;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = typeof n;
      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== n : null === n;
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n) {
      return r(this, n).get(n);
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n) {
      return r(this, n).has(n);
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n, e) {
      var t = r(this, n),
        o = t.size;
      return t.set(n, e), this.size += t.size == o ? 0 : 1, this;
    };
  }, function (n, e, t) {
    var r = t(3);
    n.exports = function () {
      return r.Date.now();
    };
  }, function (n, e, t) {
    var r = t(112),
      o = t(149),
      a = t(56);
    n.exports = function (n) {
      var e = o(n);
      return 1 == e.length && e[0][2] ? a(e[0][0], e[0][1]) : function (t) {
        return t === n || r(t, n, e);
      };
    };
  }, function (n, e, t) {
    var r = t(46),
      o = t(47),
      a = 1,
      i = 2;
    n.exports = function (n, e, t, u) {
      var c = t.length,
        s = c,
        p = !u;
      if (null == n) return !s;
      for (n = Object(n); c--;) {
        var f = t[c];
        if (p && f[2] ? f[1] !== n[f[0]] : !(f[0] in n)) return !1;
      }
      for (; ++c < s;) {
        var l = (f = t[c])[0],
          g = n[l],
          d = f[1];
        if (p && f[2]) {
          if (void 0 === g && !(l in n)) return !1;
        } else {
          var b = new r();
          if (u) var x = u(g, d, l, n, e, b);
          if (!(void 0 === x ? o(d, g, a | i, u, b) : x)) return !1;
        }
      }
      return !0;
    };
  }, function (n, e, t) {
    var r = t(17);
    n.exports = function () {
      this.__data__ = new r(), this.size = 0;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = this.__data__,
        t = e["delete"](n);
      return this.size = e.size, t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.get(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.has(n);
    };
  }, function (n, e, t) {
    var r = t(17),
      o = t(32),
      a = t(30),
      i = 200;
    n.exports = function (n, e) {
      var t = this.__data__;
      if (t instanceof r) {
        var u = t.__data__;
        if (!o || u.length < i - 1) return u.push([n, e]), this.size = ++t.size, this;
        t = this.__data__ = new a(u);
      }
      return t.set(n, e), this.size = t.size, this;
    };
  }, function (n, e, t) {
    var r = t(46),
      o = t(48),
      a = t(123),
      i = t(127),
      u = t(144),
      c = t(2),
      s = t(52),
      p = t(54),
      f = 1,
      l = "[object Arguments]",
      g = "[object Array]",
      d = "[object Object]",
      b = Object.prototype.hasOwnProperty;
    n.exports = function (n, e, t, x, A, v) {
      var h = c(n),
        m = c(e),
        y = h ? g : u(n),
        C = m ? g : u(e),
        k = (y = y == l ? d : y) == d,
        w = (C = C == l ? d : C) == d,
        B = y == C;
      if (B && s(n)) {
        if (!s(e)) return !1;
        h = !0, k = !1;
      }
      if (B && !k) return v || (v = new r()), h || p(n) ? o(n, e, t, x, A, v) : a(n, e, y, t, x, A, v);
      if (!(t & f)) {
        var j = k && b.call(n, "__wrapped__"),
          P = w && b.call(e, "__wrapped__");
        if (j || P) {
          var O = j ? n.value() : n,
            E = P ? e.value() : e;
          return v || (v = new r()), A(O, E, t, x, v);
        }
      }
      return !!B && (v || (v = new r()), i(n, e, t, x, A, v));
    };
  }, function (n, e, t) {
    var r = t(30),
      o = t(120),
      a = t(121);
    function i(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.__data__ = new r(); ++e < t;) this.add(n[e]);
    }
    i.prototype.add = i.prototype.push = o, i.prototype.has = a, n.exports = i;
  }, function (n, e) {
    var t = "__lodash_hash_undefined__";
    n.exports = function (n) {
      return this.__data__.set(n, t), this;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.has(n);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return n.has(e);
    };
  }, function (n, e, t) {
    var r = t(14),
      o = t(124),
      a = t(31),
      i = t(48),
      u = t(125),
      c = t(126),
      s = 1,
      p = 2,
      f = "[object Boolean]",
      l = "[object Date]",
      g = "[object Error]",
      d = "[object Map]",
      b = "[object Number]",
      x = "[object RegExp]",
      A = "[object Set]",
      v = "[object String]",
      h = "[object Symbol]",
      m = "[object ArrayBuffer]",
      y = "[object DataView]",
      C = r ? r.prototype : void 0,
      k = C ? C.valueOf : void 0;
    n.exports = function (n, e, t, r, C, w, B) {
      switch (t) {
        case y:
          if (n.byteLength != e.byteLength || n.byteOffset != e.byteOffset) return !1;
          n = n.buffer, e = e.buffer;
        case m:
          return !(n.byteLength != e.byteLength || !w(new o(n), new o(e)));
        case f:
        case l:
        case b:
          return a(+n, +e);
        case g:
          return n.name == e.name && n.message == e.message;
        case x:
        case v:
          return n == e + "";
        case d:
          var j = u;
        case A:
          var P = r & s;
          if (j || (j = c), n.size != e.size && !P) return !1;
          var O = B.get(n);
          if (O) return O == e;
          r |= p, B.set(n, e);
          var E = i(j(n), j(e), r, C, w, B);
          return B["delete"](n), E;
        case h:
          if (k) return k.call(n) == k.call(e);
      }
      return !1;
    };
  }, function (n, e, t) {
    var r = t(3).Uint8Array;
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n) {
      var e = -1,
        t = Array(n.size);
      return n.forEach(function (n, r) {
        t[++e] = [r, n];
      }), t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = -1,
        t = Array(n.size);
      return n.forEach(function (n) {
        t[++e] = n;
      }), t;
    };
  }, function (n, e, t) {
    var r = t(128),
      o = 1,
      a = Object.prototype.hasOwnProperty;
    n.exports = function (n, e, t, i, u, c) {
      var s = t & o,
        p = r(n),
        f = p.length;
      if (f != r(e).length && !s) return !1;
      for (var l = f; l--;) {
        var g = p[l];
        if (!(s ? g in e : a.call(e, g))) return !1;
      }
      var d = c.get(n);
      if (d && c.get(e)) return d == e;
      var b = !0;
      c.set(n, e), c.set(e, n);
      for (var x = s; ++l < f;) {
        var A = n[g = p[l]],
          v = e[g];
        if (i) var h = s ? i(v, A, g, e, n, c) : i(A, v, g, n, e, c);
        if (!(void 0 === h ? A === v || u(A, v, t, i, c) : h)) {
          b = !1;
          break;
        }
        x || (x = "constructor" == g);
      }
      if (b && !x) {
        var m = n.constructor,
          y = e.constructor;
        m != y && "constructor" in n && "constructor" in e && !("function" == typeof m && m instanceof m && "function" == typeof y && y instanceof y) && (b = !1);
      }
      return c["delete"](n), c["delete"](e), b;
    };
  }, function (n, e, t) {
    var r = t(129),
      o = t(131),
      a = t(12);
    n.exports = function (n) {
      return r(n, a, o);
    };
  }, function (n, e, t) {
    var r = t(130),
      o = t(2);
    n.exports = function (n, e, t) {
      var a = e(n);
      return o(n) ? a : r(a, t(n));
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = e.length, o = n.length; ++t < r;) n[o + t] = e[t];
      return n;
    };
  }, function (n, e, t) {
    var r = t(50),
      o = t(132),
      a = Object.prototype.propertyIsEnumerable,
      i = Object.getOwnPropertySymbols,
      u = i ? function (n) {
        return null == n ? [] : (n = Object(n), r(i(n), function (e) {
          return a.call(n, e);
        }));
      } : o;
    n.exports = u;
  }, function (n, e) {
    n.exports = function () {
      return [];
    };
  }, function (n, e, t) {
    var r = t(134),
      o = t(51),
      a = t(2),
      i = t(52),
      u = t(33),
      c = t(54),
      s = Object.prototype.hasOwnProperty;
    n.exports = function (n, e) {
      var t = a(n),
        p = !t && o(n),
        f = !t && !p && i(n),
        l = !t && !p && !f && c(n),
        g = t || p || f || l,
        d = g ? r(n.length, String) : [],
        b = d.length;
      for (var x in n) !e && !s.call(n, x) || g && ("length" == x || f && ("offset" == x || "parent" == x) || l && ("buffer" == x || "byteLength" == x || "byteOffset" == x) || u(x, b)) || d.push(x);
      return d;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = Array(n); ++t < n;) r[t] = e(t);
      return r;
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(7),
      a = "[object Arguments]";
    n.exports = function (n) {
      return o(n) && r(n) == a;
    };
  }, function (n, e) {
    n.exports = function () {
      return !1;
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(34),
      a = t(7),
      i = {};
    i["[object Float32Array]"] = i["[object Float64Array]"] = i["[object Int8Array]"] = i["[object Int16Array]"] = i["[object Int32Array]"] = i["[object Uint8Array]"] = i["[object Uint8ClampedArray]"] = i["[object Uint16Array]"] = i["[object Uint32Array]"] = !0, i["[object Arguments]"] = i["[object Array]"] = i["[object ArrayBuffer]"] = i["[object Boolean]"] = i["[object DataView]"] = i["[object Date]"] = i["[object Error]"] = i["[object Function]"] = i["[object Map]"] = i["[object Number]"] = i["[object Object]"] = i["[object RegExp]"] = i["[object Set]"] = i["[object String]"] = i["[object WeakMap]"] = !1, n.exports = function (n) {
      return a(n) && o(n.length) && !!i[r(n)];
    };
  }, function (n, e) {
    n.exports = function (n) {
      return function (e) {
        return n(e);
      };
    };
  }, function (n, e, t) {
    (function (n) {
      var r = t(40),
        o = e && !e.nodeType && e,
        a = o && "object" == typeof n && n && !n.nodeType && n,
        i = a && a.exports === o && r.process,
        u = function () {
          try {
            var n = a && a.require && a.require("util").types;
            return n || i && i.binding && i.binding("util");
          } catch (n) {}
        }();
      n.exports = u;
    }).call(this, t(53)(n));
  }, function (n, e, t) {
    var r = t(141),
      o = t(142),
      a = Object.prototype.hasOwnProperty;
    n.exports = function (n) {
      if (!r(n)) return o(n);
      var e = [];
      for (var t in Object(n)) a.call(n, t) && "constructor" != t && e.push(t);
      return e;
    };
  }, function (n, e) {
    var t = Object.prototype;
    n.exports = function (n) {
      var e = n && n.constructor;
      return n === ("function" == typeof e && e.prototype || t);
    };
  }, function (n, e, t) {
    var r = t(143)(Object.keys, Object);
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n, e) {
      return function (t) {
        return n(e(t));
      };
    };
  }, function (n, e, t) {
    var r = t(145),
      o = t(32),
      a = t(146),
      i = t(147),
      u = t(148),
      c = t(6),
      s = t(45),
      p = s(r),
      f = s(o),
      l = s(a),
      g = s(i),
      d = s(u),
      b = c;
    (r && "[object DataView]" != b(new r(new ArrayBuffer(1))) || o && "[object Map]" != b(new o()) || a && "[object Promise]" != b(a.resolve()) || i && "[object Set]" != b(new i()) || u && "[object WeakMap]" != b(new u())) && (b = function b(n) {
      var e = c(n),
        t = "[object Object]" == e ? n.constructor : void 0,
        r = t ? s(t) : "";
      if (r) switch (r) {
        case p:
          return "[object DataView]";
        case f:
          return "[object Map]";
        case l:
          return "[object Promise]";
        case g:
          return "[object Set]";
        case d:
          return "[object WeakMap]";
      }
      return e;
    }), n.exports = b;
  }, function (n, e, t) {
    var r = t(9)(t(3), "DataView");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "Promise");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "Set");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "WeakMap");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(55),
      o = t(12);
    n.exports = function (n) {
      for (var e = o(n), t = e.length; t--;) {
        var a = e[t],
          i = n[a];
        e[t] = [a, i, r(i)];
      }
      return e;
    };
  }, function (n, e, t) {
    var r = t(47),
      o = t(151),
      a = t(154),
      i = t(35),
      u = t(55),
      c = t(56),
      s = t(20),
      p = 1,
      f = 2;
    n.exports = function (n, e) {
      return i(n) && u(e) ? c(s(n), e) : function (t) {
        var i = o(t, n);
        return void 0 === i && i === e ? a(t, n) : r(e, i, p | f);
      };
    };
  }, function (n, e, t) {
    var r = t(57);
    n.exports = function (n, e, t) {
      var o = null == n ? void 0 : r(n, e);
      return void 0 === o ? t : o;
    };
  }, function (n, e, t) {
    var r = t(153),
      o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      a = /\\(\\)?/g,
      i = r(function (n) {
        var e = [];
        return 46 === n.charCodeAt(0) && e.push(""), n.replace(o, function (n, t, r, o) {
          e.push(r ? o.replace(a, "$1") : t || n);
        }), e;
      });
    n.exports = i;
  }, function (n, e, t) {
    var r = t(22),
      o = 500;
    n.exports = function (n) {
      var e = r(n, function (n) {
          return t.size === o && t.clear(), n;
        }),
        t = e.cache;
      return e;
    };
  }, function (n, e, t) {
    var r = t(155),
      o = t(156);
    n.exports = function (n, e) {
      return null != n && o(n, e, r);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return null != n && e in Object(n);
    };
  }, function (n, e, t) {
    var r = t(58),
      o = t(51),
      a = t(2),
      i = t(33),
      u = t(34),
      c = t(20);
    n.exports = function (n, e, t) {
      for (var s = -1, p = (e = r(e, n)).length, f = !1; ++s < p;) {
        var l = c(e[s]);
        if (!(f = null != n && t(n, l))) break;
        n = n[l];
      }
      return f || ++s != p ? f : !!(p = null == n ? 0 : n.length) && u(p) && i(l, p) && (a(n) || o(n));
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n;
    };
  }, function (n, e, t) {
    var r = t(159),
      o = t(160),
      a = t(35),
      i = t(20);
    n.exports = function (n) {
      return a(n) ? r(i(n)) : o(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return function (e) {
        return null == e ? void 0 : e[n];
      };
    };
  }, function (n, e, t) {
    var r = t(57);
    n.exports = function (n) {
      return function (e) {
        return r(e, n);
      };
    };
  }, function (n, e, t) {
    var r = t(162),
      o = t(12);
    n.exports = function (n) {
      return null == n ? [] : r(n, o(n));
    };
  }, function (n, e, t) {
    var r = t(26);
    n.exports = function (n, e) {
      return r(e, function (e) {
        return n[e];
      });
    };
  }, function (n, e, t) {
    var r = t(21);
    n.exports = function (n, e) {
      var t = [];
      return r(n, function (n, r, o) {
        e(n, r, o) && t.push(n);
      }), t;
    };
  }, function (n, e, t) {
    var r = t(165),
      o = t(12);
    n.exports = function (n, e) {
      return n && r(n, e, o);
    };
  }, function (n, e, t) {
    var r = t(166)();
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n) {
      return function (e, t, r) {
        for (var o = -1, a = Object(e), i = r(e), u = i.length; u--;) {
          var c = i[n ? u : ++o];
          if (!1 === t(a[c], c, a)) break;
        }
        return e;
      };
    };
  }, function (n, e, t) {
    var r = t(11);
    n.exports = function (n, e) {
      return function (t, o) {
        if (null == t) return t;
        if (!r(t)) return n(t, o);
        for (var a = t.length, i = e ? a : -1, u = Object(t); (e ? i-- : ++i < a) && !1 !== o(u[i], i, u););
        return t;
      };
    };
  }, function (n, e, t) {
    var r = t(21),
      o = t(11);
    n.exports = function (n, e) {
      var t = -1,
        a = o(n) ? Array(n.length) : [];
      return r(n, function (n, r, o) {
        a[++t] = e(n, r, o);
      }), a;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r) {
      var o = -1,
        a = null == n ? 0 : n.length;
      for (r && a && (t = n[++o]); ++o < a;) t = e(t, n[o], o, n);
      return t;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r, o) {
      return o(n, function (n, o, a) {
        t = r ? (r = !1, n) : e(t, n, o, a);
      }), t;
    };
  }, function (n, e, t) {
    var r = t(10),
      o = t(11),
      a = t(12);
    n.exports = function (n) {
      return function (e, t, i) {
        var u = Object(e);
        if (!o(e)) {
          var c = r(t, 3);
          e = a(e), t = function t(n) {
            return c(u[n], n, u);
          };
        }
        var s = n(e, t, i);
        return s > -1 ? u[c ? e[s] : s] : void 0;
      };
    };
  }, function (n, e, t) {
    var r = t(21);
    n.exports = function (n, e) {
      var t;
      return r(n, function (n, r, o) {
        return !(t = e(n, r, o));
      }), !!t;
    };
  }, function (n, e, t) {
    var r = t(31),
      o = t(11),
      a = t(33),
      i = t(8);
    n.exports = function (n, e, t) {
      if (!i(t)) return !1;
      var u = typeof e;
      return !!("number" == u ? o(t) && a(e, t.length) : "string" == u && e in t) && r(t[e], n);
    };
  }, function (n, e, t) {
    var r = t(175);
    function o() {}
    function a() {}
    a.resetWarningCache = o, n.exports = function () {
      function n(n, e, t, o, a, i) {
        if (i !== r) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }
      function e() {
        return n;
      }
      n.isRequired = n;
      var t = {
        array: n,
        bool: n,
        func: n,
        number: n,
        object: n,
        string: n,
        symbol: n,
        any: n,
        arrayOf: e,
        element: n,
        elementType: n,
        instanceOf: e,
        node: n,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: a,
        resetWarningCache: o
      };
      return t.PropTypes = t, t;
    };
  }, function (n, e, t) {
    n.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (n, e, t) {
    var r = t(177);
    "string" == typeof r && (r = [[n.i, r, ""]]);
    var o = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    t(180)(r, o);
    r.locals && (n.exports = r.locals);
  }, function (n, e, t) {
    e = n.exports = t(178)(!1);
    var r = t(179)(t(59));
    e.push([n.i, ".flag {\n  width: 16px;\n  height: 11px;\n  background-image: url(" + r + ") !important;\n}\n.flag.margin {\n  margin-right: 8px;\n}\n.flag.ad {\n  background-position: -16px 0;\n}\n.flag.ae {\n  background-position: -32px 0;\n}\n.flag.af {\n  background-position: -48px 0;\n}\n.flag.ag {\n  background-position: -64px 0;\n}\n.flag.ai {\n  background-position: -80px 0;\n}\n.flag.al {\n  background-position: -96px 0;\n}\n.flag.am {\n  background-position: -112px 0;\n}\n.flag.ao {\n  background-position: -128px 0;\n}\n.flag.ar {\n  background-position: -144px 0;\n}\n.flag.as {\n  background-position: -160px 0;\n}\n.flag.at {\n  background-position: -176px 0;\n}\n.flag.au {\n  background-position: -192px 0;\n}\n.flag.aw {\n  background-position: -208px 0;\n}\n.flag.az {\n  background-position: -224px 0;\n}\n.flag.ba {\n  background-position: -240px 0;\n}\n.flag.bb {\n  background-position: 0 -11px;\n}\n.flag.bd {\n  background-position: -16px -11px;\n}\n.flag.be {\n  background-position: -32px -11px;\n}\n.flag.bf {\n  background-position: -48px -11px;\n}\n.flag.bg {\n  background-position: -64px -11px;\n}\n.flag.bh {\n  background-position: -80px -11px;\n}\n.flag.bi {\n  background-position: -96px -11px;\n}\n.flag.bj {\n  background-position: -112px -11px;\n}\n.flag.bm {\n  background-position: -128px -11px;\n}\n.flag.bn {\n  background-position: -144px -11px;\n}\n.flag.bo {\n  background-position: -160px -11px;\n}\n.flag.br {\n  background-position: -176px -11px;\n}\n.flag.bs {\n  background-position: -192px -11px;\n}\n.flag.bt {\n  background-position: -208px -11px;\n}\n.flag.bw {\n  background-position: -224px -11px;\n}\n.flag.by {\n  background-position: -240px -11px;\n}\n.flag.bz {\n  background-position: 0 -22px;\n}\n.flag.ca {\n  background-position: -16px -22px;\n}\n.flag.cd {\n  background-position: -32px -22px;\n}\n.flag.cf {\n  background-position: -48px -22px;\n}\n.flag.cg {\n  background-position: -64px -22px;\n}\n.flag.ch {\n  background-position: -80px -22px;\n}\n.flag.ci {\n  background-position: -96px -22px;\n}\n.flag.ck {\n  background-position: -112px -22px;\n}\n.flag.cl {\n  background-position: -128px -22px;\n}\n.flag.cm {\n  background-position: -144px -22px;\n}\n.flag.cn {\n  background-position: -160px -22px;\n}\n.flag.co {\n  background-position: -176px -22px;\n}\n.flag.cr {\n  background-position: -192px -22px;\n}\n.flag.cu {\n  background-position: -208px -22px;\n}\n.flag.cv {\n  background-position: -224px -22px;\n}\n.flag.cw {\n  background-position: -240px -22px;\n}\n.flag.cy {\n  background-position: 0 -33px;\n}\n.flag.cz {\n  background-position: -16px -33px;\n}\n.flag.de {\n  background-position: -32px -33px;\n}\n.flag.dj {\n  background-position: -48px -33px;\n}\n.flag.dk {\n  background-position: -64px -33px;\n}\n.flag.dm {\n  background-position: -80px -33px;\n}\n.flag.do {\n  background-position: -96px -33px;\n}\n.flag.dz {\n  background-position: -112px -33px;\n}\n.flag.ec {\n  background-position: -128px -33px;\n}\n.flag.ee {\n  background-position: -144px -33px;\n}\n.flag.eg {\n  background-position: -160px -33px;\n}\n.flag.er {\n  background-position: -176px -33px;\n}\n.flag.es {\n  background-position: -192px -33px;\n}\n.flag.et {\n  background-position: -208px -33px;\n}\n.flag.fi {\n  background-position: -224px -33px;\n}\n.flag.fj {\n  background-position: -240px -33px;\n}\n.flag.fk {\n  background-position: 0 -44px;\n}\n.flag.fm {\n  background-position: -16px -44px;\n}\n.flag.fo {\n  background-position: -32px -44px;\n}\n.flag.fr,\n.flag.bl,\n.flag.mf {\n  background-position: -48px -44px;\n}\n.flag.ga {\n  background-position: -64px -44px;\n}\n.flag.gb {\n  background-position: -80px -44px;\n}\n.flag.gd {\n  background-position: -96px -44px;\n}\n.flag.ge {\n  background-position: -112px -44px;\n}\n.flag.gf {\n  background-position: -128px -44px;\n}\n.flag.gh {\n  background-position: -144px -44px;\n}\n.flag.gi {\n  background-position: -160px -44px;\n}\n.flag.gl {\n  background-position: -176px -44px;\n}\n.flag.gm {\n  background-position: -192px -44px;\n}\n.flag.gn {\n  background-position: -208px -44px;\n}\n.flag.gp {\n  background-position: -224px -44px;\n}\n.flag.gq {\n  background-position: -240px -44px;\n}\n.flag.gr {\n  background-position: 0 -55px;\n}\n.flag.gt {\n  background-position: -16px -55px;\n}\n.flag.gu {\n  background-position: -32px -55px;\n}\n.flag.gw {\n  background-position: -48px -55px;\n}\n.flag.gy {\n  background-position: -64px -55px;\n}\n.flag.hk {\n  background-position: -80px -55px;\n}\n.flag.hn {\n  background-position: -96px -55px;\n}\n.flag.hr {\n  background-position: -112px -55px;\n}\n.flag.ht {\n  background-position: -128px -55px;\n}\n.flag.hu {\n  background-position: -144px -55px;\n}\n.flag.id {\n  background-position: -160px -55px;\n}\n.flag.ie {\n  background-position: -176px -55px;\n}\n.flag.il {\n  background-position: -192px -55px;\n}\n.flag.in {\n  background-position: -208px -55px;\n}\n.flag.io {\n  background-position: -224px -55px;\n}\n.flag.iq {\n  background-position: -240px -55px;\n}\n.flag.ir {\n  background-position: 0 -66px;\n}\n.flag.is {\n  background-position: -16px -66px;\n}\n.flag.it {\n  background-position: -32px -66px;\n}\n.flag.jm {\n  background-position: -48px -66px;\n}\n.flag.jo {\n  background-position: -64px -66px;\n}\n.flag.jp {\n  background-position: -80px -66px;\n}\n.flag.ke {\n  background-position: -96px -66px;\n}\n.flag.kg {\n  background-position: -112px -66px;\n}\n.flag.kh {\n  background-position: -128px -66px;\n}\n.flag.ki {\n  background-position: -144px -66px;\n}\n.flag.km {\n  background-position: -160px -66px;\n}\n.flag.kn {\n  background-position: -176px -66px;\n}\n.flag.kp {\n  background-position: -192px -66px;\n}\n.flag.kr {\n  background-position: -208px -66px;\n}\n.flag.kw {\n  background-position: -224px -66px;\n}\n.flag.ky {\n  background-position: -240px -66px;\n}\n.flag.kz {\n  background-position: 0 -77px;\n}\n.flag.la {\n  background-position: -16px -77px;\n}\n.flag.lb {\n  background-position: -32px -77px;\n}\n.flag.lc {\n  background-position: -48px -77px;\n}\n.flag.li {\n  background-position: -64px -77px;\n}\n.flag.lk {\n  background-position: -80px -77px;\n}\n.flag.lr {\n  background-position: -96px -77px;\n}\n.flag.ls {\n  background-position: -112px -77px;\n}\n.flag.lt {\n  background-position: -128px -77px;\n}\n.flag.lu {\n  background-position: -144px -77px;\n}\n.flag.lv {\n  background-position: -160px -77px;\n}\n.flag.ly {\n  background-position: -176px -77px;\n}\n.flag.ma {\n  background-position: -192px -77px;\n}\n.flag.mc {\n  background-position: -208px -77px;\n}\n.flag.md {\n  background-position: -224px -77px;\n}\n.flag.me {\n  background-position: -112px -154px;\n  height: 12px;\n}\n.flag.mg {\n  background-position: 0 -88px;\n}\n.flag.mh {\n  background-position: -16px -88px;\n}\n.flag.mk {\n  background-position: -32px -88px;\n}\n.flag.ml {\n  background-position: -48px -88px;\n}\n.flag.mm {\n  background-position: -64px -88px;\n}\n.flag.mn {\n  background-position: -80px -88px;\n}\n.flag.mo {\n  background-position: -96px -88px;\n}\n.flag.mp {\n  background-position: -112px -88px;\n}\n.flag.mq {\n  background-position: -128px -88px;\n}\n.flag.mr {\n  background-position: -144px -88px;\n}\n.flag.ms {\n  background-position: -160px -88px;\n}\n.flag.mt {\n  background-position: -176px -88px;\n}\n.flag.mu {\n  background-position: -192px -88px;\n}\n.flag.mv {\n  background-position: -208px -88px;\n}\n.flag.mw {\n  background-position: -224px -88px;\n}\n.flag.mx {\n  background-position: -240px -88px;\n}\n.flag.my {\n  background-position: 0 -99px;\n}\n.flag.mz {\n  background-position: -16px -99px;\n}\n.flag.na {\n  background-position: -32px -99px;\n}\n.flag.nc {\n  background-position: -48px -99px;\n}\n.flag.ne {\n  background-position: -64px -99px;\n}\n.flag.nf {\n  background-position: -80px -99px;\n}\n.flag.ng {\n  background-position: -96px -99px;\n}\n.flag.ni {\n  background-position: -112px -99px;\n}\n.flag.nl,\n.flag.bq {\n  background-position: -128px -99px;\n}\n.flag.no {\n  background-position: -144px -99px;\n}\n.flag.np {\n  background-position: -160px -99px;\n}\n.flag.nr {\n  background-position: -176px -99px;\n}\n.flag.nu {\n  background-position: -192px -99px;\n}\n.flag.nz {\n  background-position: -208px -99px;\n}\n.flag.om {\n  background-position: -224px -99px;\n}\n.flag.pa {\n  background-position: -240px -99px;\n}\n.flag.pe {\n  background-position: 0 -110px;\n}\n.flag.pf {\n  background-position: -16px -110px;\n}\n.flag.pg {\n  background-position: -32px -110px;\n}\n.flag.ph {\n  background-position: -48px -110px;\n}\n.flag.pk {\n  background-position: -64px -110px;\n}\n.flag.pl {\n  background-position: -80px -110px;\n}\n.flag.pm {\n  background-position: -96px -110px;\n}\n.flag.pr {\n  background-position: -112px -110px;\n}\n.flag.ps {\n  background-position: -128px -110px;\n}\n.flag.pt {\n  background-position: -144px -110px;\n}\n.flag.pw {\n  background-position: -160px -110px;\n}\n.flag.py {\n  background-position: -176px -110px;\n}\n.flag.qa {\n  background-position: -192px -110px;\n}\n.flag.re {\n  background-position: -208px -110px;\n}\n.flag.ro {\n  background-position: -224px -110px;\n}\n.flag.rs {\n  background-position: -240px -110px;\n}\n.flag.ru {\n  background-position: 0 -121px;\n}\n.flag.rw {\n  background-position: -16px -121px;\n}\n.flag.sa {\n  background-position: -32px -121px;\n}\n.flag.sb {\n  background-position: -48px -121px;\n}\n.flag.sc {\n  background-position: -64px -121px;\n}\n.flag.sd {\n  background-position: -80px -121px;\n}\n.flag.se {\n  background-position: -96px -121px;\n}\n.flag.sg {\n  background-position: -112px -121px;\n}\n.flag.sh {\n  background-position: -128px -121px;\n}\n.flag.si {\n  background-position: -144px -121px;\n}\n.flag.sk {\n  background-position: -160px -121px;\n}\n.flag.sl {\n  background-position: -176px -121px;\n}\n.flag.sm {\n  background-position: -192px -121px;\n}\n.flag.sn {\n  background-position: -208px -121px;\n}\n.flag.so {\n  background-position: -224px -121px;\n}\n.flag.sr {\n  background-position: -240px -121px;\n}\n.flag.ss {\n  background-position: 0 -132px;\n}\n.flag.st {\n  background-position: -16px -132px;\n}\n.flag.sv {\n  background-position: -32px -132px;\n}\n.flag.sx {\n  background-position: -48px -132px;\n}\n.flag.sy {\n  background-position: -64px -132px;\n}\n.flag.sz {\n  background-position: -80px -132px;\n}\n.flag.tc {\n  background-position: -96px -132px;\n}\n.flag.td {\n  background-position: -112px -132px;\n}\n.flag.tg {\n  background-position: -128px -132px;\n}\n.flag.th {\n  background-position: -144px -132px;\n}\n.flag.tj {\n  background-position: -160px -132px;\n}\n.flag.tk {\n  background-position: -176px -132px;\n}\n.flag.tl {\n  background-position: -192px -132px;\n}\n.flag.tm {\n  background-position: -208px -132px;\n}\n.flag.tn {\n  background-position: -224px -132px;\n}\n.flag.to {\n  background-position: -240px -132px;\n}\n.flag.tr {\n  background-position: 0 -143px;\n}\n.flag.tt {\n  background-position: -16px -143px;\n}\n.flag.tv {\n  background-position: -32px -143px;\n}\n.flag.tw {\n  background-position: -48px -143px;\n}\n.flag.tz {\n  background-position: -64px -143px;\n}\n.flag.ua {\n  background-position: -80px -143px;\n}\n.flag.ug {\n  background-position: -96px -143px;\n}\n.flag.us {\n  background-position: -112px -143px;\n}\n.flag.uy {\n  background-position: -128px -143px;\n}\n.flag.uz {\n  background-position: -144px -143px;\n}\n.flag.va {\n  background-position: -160px -143px;\n}\n.flag.vc {\n  background-position: -176px -143px;\n}\n.flag.ve {\n  background-position: -192px -143px;\n}\n.flag.vg {\n  background-position: -208px -143px;\n}\n.flag.vi {\n  background-position: -224px -143px;\n}\n.flag.vn {\n  background-position: -240px -143px;\n}\n.flag.vu {\n  background-position: 0 -154px;\n}\n.flag.wf {\n  background-position: -16px -154px;\n}\n.flag.ws {\n  background-position: -32px -154px;\n}\n.flag.ye {\n  background-position: -48px -154px;\n}\n.flag.za {\n  background-position: -64px -154px;\n}\n.flag.zm {\n  background-position: -80px -154px;\n}\n.flag.zw {\n  background-position: -96px -154px;\n}\n", ""]);
  }, function (n, e, t) {
    n.exports = function (n) {
      var e = [];
      return e.toString = function () {
        return this.map(function (e) {
          var t = function (n, e) {
            var t = n[1] || "",
              r = n[3];
            if (!r) return t;
            if (e && "function" == typeof btoa) {
              var o = (i = r, u = btoa(unescape(encodeURIComponent(JSON.stringify(i)))), c = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(u), "/*# ".concat(c, " */")),
                a = r.sources.map(function (n) {
                  return "/*# sourceURL=".concat(r.sourceRoot).concat(n, " */");
                });
              return [t].concat(a).concat([o]).join("\n");
            }
            var i, u, c;
            return [t].join("\n");
          }(e, n);
          return e[2] ? "@media ".concat(e[2], "{").concat(t, "}") : t;
        }).join("");
      }, e.i = function (n, t) {
        "string" == typeof n && (n = [[null, n, ""]]);
        for (var r = {}, o = 0; o < this.length; o++) {
          var a = this[o][0];
          null != a && (r[a] = !0);
        }
        for (var i = 0; i < n.length; i++) {
          var u = n[i];
          null != u[0] && r[u[0]] || (t && !u[2] ? u[2] = t : t && (u[2] = "(".concat(u[2], ") and (").concat(t, ")")), e.push(u));
        }
      }, e;
    };
  }, function (n, e, t) {
    n.exports = function (n, e) {
      return "string" != typeof (n = n.__esModule ? n["default"] : n) ? n : (/^['"].*['"]$/.test(n) && (n = n.slice(1, -1)), /["'() \t\n]/.test(n) || e ? '"'.concat(n.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : n);
    };
  }, function (n, e, t) {
    var r,
      o,
      a = {},
      i = (r = function r() {
        return window && document && document.all && !window.atob;
      }, function () {
        return void 0 === o && (o = r.apply(this, arguments)), o;
      }),
      u = function u(n, e) {
        return e ? e.querySelector(n) : document.querySelector(n);
      },
      c = function (n) {
        var e = {};
        return function (n, t) {
          if ("function" == typeof n) return n();
          if (void 0 === e[n]) {
            var r = u.call(this, n, t);
            if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
              r = r.contentDocument.head;
            } catch (n) {
              r = null;
            }
            e[n] = r;
          }
          return e[n];
        };
      }(),
      s = null,
      p = 0,
      f = [],
      l = t(181);
    function g(n, e) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t],
          o = a[r.id];
        if (o) {
          o.refs++;
          for (var i = 0; i < o.parts.length; i++) o.parts[i](r.parts[i]);
          for (; i < r.parts.length; i++) o.parts.push(h(r.parts[i], e));
        } else {
          var u = [];
          for (i = 0; i < r.parts.length; i++) u.push(h(r.parts[i], e));
          a[r.id] = {
            id: r.id,
            refs: 1,
            parts: u
          };
        }
      }
    }
    function d(n, e) {
      for (var t = [], r = {}, o = 0; o < n.length; o++) {
        var a = n[o],
          i = e.base ? a[0] + e.base : a[0],
          u = {
            css: a[1],
            media: a[2],
            sourceMap: a[3]
          };
        r[i] ? r[i].parts.push(u) : t.push(r[i] = {
          id: i,
          parts: [u]
        });
      }
      return t;
    }
    function b(n, e) {
      var t = c(n.insertInto);
      if (!t) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = f[f.length - 1];
      if ("top" === n.insertAt) r ? r.nextSibling ? t.insertBefore(e, r.nextSibling) : t.appendChild(e) : t.insertBefore(e, t.firstChild), f.push(e);else if ("bottom" === n.insertAt) t.appendChild(e);else {
        if ("object" != typeof n.insertAt || !n.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o = c(n.insertAt.before, t);
        t.insertBefore(e, o);
      }
    }
    function x(n) {
      if (null === n.parentNode) return !1;
      n.parentNode.removeChild(n);
      var e = f.indexOf(n);
      e >= 0 && f.splice(e, 1);
    }
    function A(n) {
      var e = document.createElement("style");
      if (void 0 === n.attrs.type && (n.attrs.type = "text/css"), void 0 === n.attrs.nonce) {
        var r = function () {
          return t.nc;
        }();
        r && (n.attrs.nonce = r);
      }
      return v(e, n.attrs), b(n, e), e;
    }
    function v(n, e) {
      Object.keys(e).forEach(function (t) {
        n.setAttribute(t, e[t]);
      });
    }
    function h(n, e) {
      var t, r, o, a;
      if (e.transform && n.css) {
        if (!(a = "function" == typeof e.transform ? e.transform(n.css) : e.transform["default"](n.css))) return function () {};
        n.css = a;
      }
      if (e.singleton) {
        var i = p++;
        t = s || (s = A(e)), r = C.bind(null, t, i, !1), o = C.bind(null, t, i, !0);
      } else n.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (t = function (n) {
        var e = document.createElement("link");
        return void 0 === n.attrs.type && (n.attrs.type = "text/css"), n.attrs.rel = "stylesheet", v(e, n.attrs), b(n, e), e;
      }(e), r = w.bind(null, t, e), o = function o() {
        x(t), t.href && URL.revokeObjectURL(t.href);
      }) : (t = A(e), r = k.bind(null, t), o = function o() {
        x(t);
      });
      return r(n), function (e) {
        if (e) {
          if (e.css === n.css && e.media === n.media && e.sourceMap === n.sourceMap) return;
          r(n = e);
        } else o();
      };
    }
    n.exports = function (n, e) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (e = e || {}).attrs = "object" == typeof e.attrs ? e.attrs : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = i()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
      var t = d(n, e);
      return g(t, e), function (n) {
        for (var r = [], o = 0; o < t.length; o++) {
          var i = t[o];
          (u = a[i.id]).refs--, r.push(u);
        }
        n && g(d(n, e), e);
        for (o = 0; o < r.length; o++) {
          var u;
          if (0 === (u = r[o]).refs) {
            for (var c = 0; c < u.parts.length; c++) u.parts[c]();
            delete a[u.id];
          }
        }
      };
    };
    var m,
      y = (m = [], function (n, e) {
        return m[n] = e, m.filter(Boolean).join("\n");
      });
    function C(n, e, t, r) {
      var o = t ? "" : r.css;
      if (n.styleSheet) n.styleSheet.cssText = y(e, o);else {
        var a = document.createTextNode(o),
          i = n.childNodes;
        i[e] && n.removeChild(i[e]), i.length ? n.insertBefore(a, i[e]) : n.appendChild(a);
      }
    }
    function k(n, e) {
      var t = e.css,
        r = e.media;
      if (r && n.setAttribute("media", r), n.styleSheet) n.styleSheet.cssText = t;else {
        for (; n.firstChild;) n.removeChild(n.firstChild);
        n.appendChild(document.createTextNode(t));
      }
    }
    function w(n, e, t) {
      var r = t.css,
        o = t.sourceMap,
        a = void 0 === e.convertToAbsoluteUrls && o;
      (e.convertToAbsoluteUrls || a) && (r = l(r)), o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
      var i = new Blob([r], {
          type: "text/css"
        }),
        u = n.href;
      n.href = URL.createObjectURL(i), u && URL.revokeObjectURL(u);
    }
  }, function (n, e) {
    n.exports = function (n) {
      var e = "undefined" != typeof window && window.location;
      if (!e) throw new Error("fixUrls requires window.location");
      if (!n || "string" != typeof n) return n;
      var t = e.protocol + "//" + e.host,
        r = t + e.pathname.replace(/\/[^\/]*$/, "/");
      return n.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (n, e) {
        var o,
          a = e.trim().replace(/^"(.*)"$/, function (n, e) {
            return e;
          }).replace(/^'(.*)'$/, function (n, e) {
            return e;
          });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(a) ? n : (o = 0 === a.indexOf("//") ? a : 0 === a.indexOf("/") ? t + a : r + a.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
      });
    };
  }, function (n, e, t) {
    t.r(e);
    var r = t(36),
      o = t.n(r),
      a = t(4),
      i = t.n(a),
      u = t(60),
      c = t.n(u),
      s = t(22),
      p = t.n(s),
      f = t(61),
      l = t.n(f),
      g = t(62),
      d = t.n(g),
      b = t(63),
      x = t.n(b),
      A = t(23),
      v = t.n(A),
      h = t(64),
      m = t.n(h),
      y = t(24),
      C = t.n(y),
      k = t(13),
      w = t.n(k),
      B = t(37),
      j = t.n(B),
      P = t(5),
      O = t.n(P),
      E = t(38),
      I = t.n(E),
      D = t(1),
      Q = t.n(D),
      S = t(0),
      T = t.n(S),
      M = t(65),
      R = t.n(M),
      F = t(66),
      U = t.n(F),
      L = t(67),
      N = t.n(L),
      z = t(68),
      K = t.n(z),
      G = t(69),
      H = t.n(G),
      q = t(70),
      Y = t.n(q),
      V = t(71),
      J = t.n(V),
      X = t(72),
      Z = t.n(X),
      W = t(39),
      _ = t.n(W),
      $ = t(73),
      nn = t.n($),
      en = t(74),
      tn = t.n(en);
    function rn(n) {
      return (rn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
        return typeof n;
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      })(n);
    }
    function on() {
      return (on = Object.assign || function (n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
      }).apply(this, arguments);
    }
    function an(n, e) {
      if (null == n) return {};
      var t,
        r,
        o = function (n, e) {
          if (null == n) return {};
          var t,
            r,
            o = {},
            a = Object.keys(n);
          for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || (o[t] = n[t]);
          return o;
        }(n, e);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(n);
        for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]);
      }
      return o;
    }
    function un(n, e) {
      for (var t = 0; t < e.length; t++) {
        var r = e[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
      }
    }
    function cn(n, e) {
      return !e || "object" !== rn(e) && "function" != typeof e ? function (n) {
        if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return n;
      }(n) : e;
    }
    function sn(n) {
      return (sn = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      })(n);
    }
    function pn(n, e) {
      return (pn = Object.setPrototypeOf || function (n, e) {
        return n.__proto__ = e, n;
      })(n, e);
    }
    var fn = function (n) {
      function e() {
        return function (n, e) {
          if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), cn(this, sn(e).apply(this, arguments));
      }
      var t, r;
      return function (n, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        n.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: n,
            writable: !0,
            configurable: !0
          }
        }), e && pn(n, e);
      }(e, n), t = e, (r = [{
        key: "render",
        value: function value() {
          var n = this.props,
            e = n.name,
            t = n.iso2,
            r = n.dialCode,
            o = n.localization,
            a = n.itemRef,
            i = n["native"],
            u = an(n, ["name", "iso2", "dialCode", "localization", "itemRef", "native"]);
          return i ? Q.a.createElement("option", on({
            className: "country",
            "data-dial-code": "1",
            "data-country-code": t,
            value: t
          }, u), o || e, " ", "+".concat(r)) : Q.a.createElement(tn.a, {
            rootRef: function rootRef(n) {
              return a(n);
            }
          }, Q.a.createElement(nn.a, on({
            className: "country",
            "data-dial-code": "1",
            "data-country-code": t
          }, u), Q.a.createElement("div", {
            className: "flag ".concat(t, " margin")
          }), Q.a.createElement("span", {
            className: "country-name"
          }, o || e), Q.a.createElement("span", {
            className: "dial-code"
          }, "+".concat(r))));
        }
      }]) && un(t.prototype, r), e;
    }(Q.a.PureComponent);
    fn.propTypes = {
      name: T.a.string.isRequired,
      iso2: T.a.string.isRequired,
      dialCode: T.a.string.isRequired,
      itemRef: T.a.func.isRequired,
      localization: T.a.string,
      "native": T.a.bool
    }, fn.defaultProps = {
      localization: null,
      "native": !1
    };
    var ln = fn;
    t(176), t(59);
    function gn(n) {
      return (gn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
        return typeof n;
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      })(n);
    }
    function dn() {
      return (dn = Object.assign || function (n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
      }).apply(this, arguments);
    }
    function bn(n, e) {
      var t = Object.keys(n);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(n);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        })), t.push.apply(t, r);
      }
      return t;
    }
    function xn(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = null != arguments[e] ? arguments[e] : {};
        e % 2 ? bn(t, !0).forEach(function (e) {
          Cn(n, e, t[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : bn(t).forEach(function (e) {
          Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(t, e));
        });
      }
      return n;
    }
    function An(n, e) {
      if (null == n) return {};
      var t,
        r,
        o = function (n, e) {
          if (null == n) return {};
          var t,
            r,
            o = {},
            a = Object.keys(n);
          for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || (o[t] = n[t]);
          return o;
        }(n, e);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(n);
        for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]);
      }
      return o;
    }
    function vn(n, e) {
      for (var t = 0; t < e.length; t++) {
        var r = e[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
      }
    }
    function hn(n) {
      return (hn = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      })(n);
    }
    function mn(n) {
      if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return n;
    }
    function yn(n, e) {
      return (yn = Object.setPrototypeOf || function (n, e) {
        return n.__proto__ = e, n;
      })(n, e);
    }
    function Cn(n, e, t) {
      return e in n ? Object.defineProperty(n, e, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[e] = t, n;
    }
    var kn = function (n) {
      function e(n) {
        var t;
        !function (n, e) {
          if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), t = function (n, e) {
          return !e || "object" !== gn(e) && "function" != typeof e ? mn(n) : e;
        }(this, hn(e).call(this, n)), Cn(mn(t), "flags", {}), Cn(mn(t), "guessSelectedCountry", p()(function (n, e, r) {
          var o = O()(e, {
            iso2: r
          }) || {};
          if ("" === c()(n)) return o;
          var a = j()(e, function (e, t) {
            if (i()(n, t.dialCode)) {
              if (t.dialCode.length > e.dialCode.length) return t;
              if (t.dialCode.length === e.dialCode.length && t.priority < e.priority) return t;
            }
            return e;
          }, {
            dialCode: "",
            priority: 10001
          }, mn(t));
          return a.name ? a : o;
        })), Cn(mn(t), "getProbableCandidate", p()(function (n) {
          if (!n || 0 === n.length) return null;
          var e = t.state.onlyCountries;
          return C()(e, function (e) {
            return i()(e.name.toLowerCase(), n.toLowerCase());
          }, mn(t))[0];
        })), Cn(mn(t), "getOnlyCountries", function (n, e) {
          return 0 === n.length ? e : e.filter(function (e) {
            return n.some(function (n) {
              return n === e.iso2;
            });
          });
        }), Cn(mn(t), "excludeCountries", function (n, e) {
          return 0 === e.length ? n : C()(n, function (n) {
            return !m()(e, n.iso2);
          });
        }), Cn(mn(t), "filterRegions", function (n, e) {
          if ("string" == typeof n) {
            var t = n;
            return e.filter(function (n) {
              return n.regions.some(function (n) {
                return n === t;
              });
            });
          }
          return e.filter(function (e) {
            return n.map(function (n) {
              return e.regions.some(function (e) {
                return e === n;
              });
            }).some(function (n) {
              return n;
            });
          });
        }), Cn(mn(t), "deleteAreaCodes", function (n) {
          return n.filter(function (n) {
            return !0 !== n.isAreaCode;
          });
        }), Cn(mn(t), "updateDefaultCountry", function (n) {
          var e = t.state.onlyCountries,
            r = t.props.disableCountryCode,
            o = O()(e, {
              iso2: n
            });
          t.setState({
            defaultCountry: n,
            selectedCountry: o,
            formattedNumber: r ? "" : "+".concat(o.dialCode)
          });
        }), Cn(mn(t), "scrollTo", function (n) {
          if (n) {
            var e = t.dropdownContainerRef;
            e && document.body && (e.scrollTop = n.offsetTop);
          }
        }), Cn(mn(t), "formatNumber", function (n, e) {
          var r,
            o = t.props,
            a = o.disableCountryCode,
            i = o.enableLongNumbers,
            u = o.autoFormat;
          if (a && e ? ((r = e.split(" ")).shift(), r = r.join(" ")) : r = e, !n || 0 === n.length) return a ? "" : "+";
          if (n && n.length < 2 || !r || !u) return a ? n : "+".concat(n);
          var c,
            s = j()(r, function (n, e) {
              return 0 === n.remainingText.length ? n : "." !== e ? {
                formattedText: n.formattedText + e,
                remainingText: n.remainingText
              } : {
                formattedText: n.formattedText + x()(n.remainingText),
                remainingText: d()(n.remainingText)
              };
            }, {
              formattedText: "",
              remainingText: n.split("")
            });
          return (c = i ? s.formattedText + s.remainingText.join("") : s.formattedText).includes("(") && !c.includes(")") && (c += ")"), c;
        }), Cn(mn(t), "cursorToEnd", function () {
          var n = t.props.isModernBrowser,
            e = t.inputRef;
          if (e.focus(), n) {
            var r = e.value.length;
            e.setSelectionRange(r, r);
          }
        }), Cn(mn(t), "getElement", function (n) {
          return t.flags["flag_no_".concat(n)];
        }), Cn(mn(t), "getCountryData", function () {
          var n = t.state.selectedCountry;
          return n ? {
            name: n.name || "",
            dialCode: n.dialCode || "",
            countryCode: n.iso2 || ""
          } : {};
        }), Cn(mn(t), "handleInput", function (n) {
          var e = t.state,
            r = e.selectedCountry,
            o = e.freezeSelection,
            a = t.state,
            i = a.selectedCountry,
            u = a.formattedNumber,
            c = a.onlyCountries,
            s = a.defaultCountry,
            p = t.props,
            f = p.disableCountryCode,
            l = p.countryCodeEditable,
            g = p.isModernBrowser,
            d = p.onChange,
            b = f ? "" : "+";
          if (!l) {
            var x = "+".concat(r.dialCode);
            if (n.target.value.length < x.length) return;
          }
          if (!(n.target.value.replace(/\D/g, "").length > 15) && n.target.value !== u) {
            if (n.preventDefault ? n.preventDefault() : n.returnValue = !1, n.target.value.length > 0) {
              var A = n.target.value.replace(/\D/g, "");
              (!o || i.dialCode.length > A.length) && (r = t.guessSelectedCountry(A.substring(0, 6), c, s), o = !1), b = t.formatNumber(A, r.format);
            }
            var v = n.target.selectionStart,
              h = b.length - u.length;
            t.setState({
              formattedNumber: b,
              freezeSelection: o,
              selectedCountry: r.dialCode ? r : i
            }, function () {
              g && (h > 0 && (v -= h), ")" === b.charAt(b.length - 1) ? t.inputRef.setSelectionRange(b.length - 1, b.length - 1) : v > 0 && u.length >= b.length && t.inputRef.setSelectionRange(v, v));
              d && d(b, t.getCountryData());
            });
          }
        }), Cn(mn(t), "handleRefInput", function (n) {
          var e,
            r = t.props,
            o = r.inputRef,
            a = r.InputProps;
          t.inputRef = n, o ? e = o : a && a.ref && (e = a.ref), e && ("function" == typeof e ? e(n) : e.current = n);
        }), Cn(mn(t), "handleInputClick", function (n) {
          var e = t.props.onClick;
          e && e(n, t.getCountryData());
        }), Cn(mn(t), "handleFlagItemClick", function (n) {
          var e = t.state,
            r = e.formattedNumber,
            a = e.selectedCountry,
            i = e.onlyCountries,
            u = t.props.onChange,
            c = a,
            s = o()(n) ? O()(i, function (e) {
              return e.iso2 === n;
            }) : O()(i, n),
            p = r.replace(" ", "").replace("(", "").replace(")", "").replace("-", ""),
            f = p.length > 1 ? p.replace(c.dialCode, s.dialCode) : s.dialCode,
            l = t.formatNumber(f.replace(/\D/g, ""), s.format);
          t.setState({
            anchorEl: null,
            selectedCountry: s,
            freezeSelection: !0,
            formattedNumber: l
          }, function () {
            t.cursorToEnd(), u && u(l, t.getCountryData());
          });
        }), Cn(mn(t), "handleInputFocus", function (n) {
          var e = t.state.selectedCountry,
            r = t.props,
            o = r.disableCountryCode,
            a = r.onFocus;
          t.inputRef && "+" === t.inputRef.value && e && !o && t.setState({
            formattedNumber: "+".concat(e.dialCode)
          }, function () {
            return setTimeout(t.cursorToEnd, 10);
          }), t.setState({
            placeholder: ""
          }), a && a(n, t.getCountryData()), setTimeout(t.cursorToEnd, 10);
        }), Cn(mn(t), "handleInputBlur", function (n) {
          var e = t.props,
            r = e.placeholder,
            o = e.onBlur;
          n.target.value || t.setState({
            placeholder: r
          }), o && o(n, t.getCountryData());
        }), Cn(mn(t), "getHighlightCountryIndex", function (n) {
          var e = t.state,
            r = e.highlightCountryIndex,
            o = e.onlyCountries,
            a = e.preferredCountries,
            i = r + n;
          return i < 0 || i >= o.length + a.length ? i - n : i;
        }), Cn(mn(t), "searchCountry", function () {
          var n = t.state,
            e = n.queryString,
            r = n.onlyCountries,
            o = n.preferredCountries,
            a = t.getProbableCandidate(e) || r[0],
            i = v()(r, a) + o.length;
          t.scrollTo(t.getElement(i), !0), t.setState({
            queryString: "",
            highlightCountryIndex: i
          });
        }), Cn(mn(t), "handleKeydown", function (n) {
          var e = t.state,
            r = e.anchorEl,
            o = e.highlightCountryIndex,
            a = e.preferredCountries,
            i = e.onlyCountries,
            u = e.queryString,
            c = e.debouncedQueryStingSearcher,
            s = t.props,
            p = s.keys,
            f = s.disabled;
          if (r && !f) {
            n.preventDefault ? n.preventDefault() : n.returnValue = !1;
            var l = function l(n) {
              t.setState({
                highlightCountryIndex: t.getHighlightCountryIndex(n)
              }, function () {
                t.scrollTo(t.getElement(o + a.length), !0);
              });
            };
            switch (n.which) {
              case p.DOWN:
                l(1);
                break;
              case p.UP:
                l(-1);
                break;
              case p.ENTER:
                t.handleFlagItemClick(i[o], n);
                break;
              case p.ESC:
                t.setState({
                  anchorEl: null
                }, t.cursorToEnd);
                break;
              default:
                (n.which >= p.A && n.which <= p.Z || n.which === p.SPACE) && t.setState({
                  queryString: u + String.fromCharCode(n.which)
                }, c);
            }
          }
        }), Cn(mn(t), "handleInputKeyDown", function (n) {
          var e = t.props,
            r = e.keys,
            o = e.onEnterKeyPress,
            a = e.onKeyDown;
          n.which === r.ENTER && o && o(n), a && a(n);
        }), Cn(mn(t), "checkIfValid", function () {
          var n = t.state.formattedNumber;
          return (0, t.props.isValid)(n.replace(/\D/g, ""));
        }), Cn(mn(t), "updateFormattedNumber", function (n) {
          var e,
            r = t.state,
            o = r.onlyCountries,
            a = r.defaultCountry,
            u = t.props.disableCountryCode,
            c = n,
            s = n;
          if (c.startsWith("+")) c = c.replace(/\D/g, ""), e = t.guessSelectedCountry(c.substring(0, 6), o, a), s = t.formatNumber(c, e.format);else {
            var p = (e = O()(o, {
              iso2: a
            })) && !i()(c.replace(/\D/g, ""), e.dialCode) ? e.dialCode : "";
            s = t.formatNumber((u ? "" : p) + c.replace(/\D/g, ""), e ? e.format : void 0);
          }
          t.setState({
            selectedCountry: e,
            formattedNumber: s
          });
        }), Cn(mn(t), "getDropdownProps", function () {
          var n = t.state,
            e = n.selectedCountry,
            r = n.anchorEl,
            o = n.preferredCountries,
            a = n.onlyCountries,
            i = t.props,
            u = i.classes,
            c = i.dropdownClass,
            s = i.localization,
            p = i.disableDropdown,
            f = i["native"],
            l = "flag ".concat(e.iso2),
            g = function g(n) {
              return Boolean(e && e.dialCode === n.dialCode);
            };
          return p ? {} : {
            startAdornment: Q.a.createElement(N.a, {
              className: u.positionStart,
              position: "start"
            }, f ? Q.a.createElement(Q.a.Fragment, null, Q.a.createElement(J.a, {
              id: "country-menu",
              open: Boolean(r),
              onClose: function onClose() {
                return t.setState({
                  anchorEl: null
                });
              },
              className: u["native"],
              classes: {
                root: R()(u.nativeRoot, "native", l),
                select: u.nativeSelect
              },
              onChange: function onChange(n) {
                return t.handleFlagItemClick(n.target.value);
              },
              disableUnderline: !0
            }, !!o.length && w()(o, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name],
                "native": !0
              });
            }), w()(a, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name],
                "native": !0
              });
            }))) : Q.a.createElement(Q.a.Fragment, null, Q.a.createElement(K.a, {
              className: u.flagButton,
              "aria-owns": r ? "country-menu" : null,
              "aria-label": "Select country",
              onClick: function onClick(n) {
                return t.setState({
                  anchorEl: n.currentTarget
                });
              },
              "aria-haspopup": !0
            }, Q.a.createElement("div", {
              className: l
            })), Q.a.createElement(H.a, {
              className: c,
              id: "country-menu",
              anchorEl: r,
              open: Boolean(r),
              onClose: function onClose() {
                return t.setState({
                  anchorEl: null
                });
              }
            }, !!o.length && w()(o, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                selected: g(n),
                onClick: function onClick() {
                  return t.handleFlagItemClick(n);
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name]
              });
            }), !!o.length && Q.a.createElement(Y.a, null), w()(a, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                selected: g(n),
                onClick: function onClick() {
                  return t.handleFlagItemClick(n);
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name]
              });
            }))))
          };
        });
        var r = _.a.allCountries;
        n.disableAreaCodes && (r = t.deleteAreaCodes(r)), n.regions && (r = t.filterRegions(n.regions, r));
        var a,
          u = t.excludeCountries(t.getOnlyCountries(n.onlyCountries, r), n.excludeCountries),
          s = C()(r, function (e) {
            return I()(n.preferredCountries, function (n) {
              return n === e.iso2;
            });
          }),
          f = n.value || "";
        a = f.length > 1 ? t.guessSelectedCountry(f.replace(/\D/g, "").substring(0, 6), u, n.defaultCountry) || 0 : n.defaultCountry && O()(u, {
          iso2: n.defaultCountry
        }) || 0;
        var g = v()(t.allCountries, a),
          b = f.length < 2 && a && !i()(f.replace(/\D/g, ""), a.dialCode) ? a.dialCode : "",
          A = "" === f && 0 === a ? "" : t.formatNumber((n.disableCountryCode ? "" : b) + f.replace(/\D/g, ""), a.name ? a.format : void 0);
        return t.state = {
          formattedNumber: A,
          placeholder: n.placeholder,
          onlyCountries: u,
          preferredCountries: s,
          defaultCountry: n.defaultCountry,
          selectedCountry: a,
          highlightCountryIndex: g,
          queryString: "",
          freezeSelection: !1,
          debouncedQueryStingSearcher: l()(t.searchCountry, 100),
          anchorEl: null
        }, t;
      }
      var t, r;
      return function (n, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        n.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: n,
            writable: !0,
            configurable: !0
          }
        }), e && yn(n, e);
      }(e, n), t = e, (r = [{
        key: "componentDidMount",
        value: function value() {
          document.addEventListener && document.addEventListener("keydown", this.handleKeydown);
        }
      }, {
        key: "componentDidUpdate",
        value: function value(n) {
          var e = n.value,
            t = this.state,
            r = t.defaultCountry,
            o = t.formattedNumber,
            a = this.props,
            i = a.defaultCountry,
            u = a.value;
          i && i !== r && this.updateDefaultCountry(i), "string" == typeof u && u !== e && u !== o && this.updateFormattedNumber(u);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          document.removeEventListener && document.removeEventListener("keydown", this.handleKeydown);
        }
      }, {
        key: "render",
        value: function value() {
          var n = this.state,
            e = n.formattedNumber,
            t = n.placeholder,
            r = this.props,
            o = r.inputClass,
            a = r.error,
            i = r.InputProps,
            u = An(r, ["native", "defaultCountry", "excludeCountries", "onlyCountries", "preferredCountries", "dropdownClass", "autoFormat", "disableAreaCodes", "isValid", "disableCountryCode", "disableDropdown", "enableLongNumbers", "countryCodeEditable", "onEnterKeyPress", "isModernBrowser", "classes", "keys", "localization", "placeholder", "regions", "onChange", "value", "inputClass", "error", "InputProps"]),
            c = this.getDropdownProps();
          return Q.a.createElement(U.a, dn({
            placeholder: t,
            value: e,
            className: o,
            inputRef: this.handleRefInput,
            error: a || !this.checkIfValid(),
            onChange: this.handleInput,
            onClick: this.handleInputClick,
            onFocus: this.handleInputFocus,
            onBlur: this.handleInputBlur,
            onKeyDown: this.handleInputKeyDown,
            type: "tel",
            InputProps: xn({}, c, {}, i)
          }, u));
        }
      }]) && vn(t.prototype, r), e;
    }(Q.a.Component);
    kn.propTypes = {
      classes: T.a.object,
      excludeCountries: T.a.arrayOf(T.a.string),
      onlyCountries: T.a.arrayOf(T.a.string),
      preferredCountries: T.a.arrayOf(T.a.string),
      defaultCountry: T.a.string,
      value: T.a.string,
      placeholder: T.a.string,
      disabled: T.a.bool,
      error: T.a.bool,
      variant: T.a.string,
      "native": T.a.bool,
      inputClass: T.a.string,
      dropdownClass: T.a.string,
      InputProps: T.a.object,
      inputProps: T.a.object,
      inputRef: T.a.func,
      autoFormat: T.a.bool,
      disableAreaCodes: T.a.bool,
      disableCountryCode: T.a.bool,
      disableDropdown: T.a.bool,
      enableLongNumbers: T.a.bool,
      countryCodeEditable: T.a.bool,
      regions: T.a.oneOfType([T.a.string, T.a.arrayOf(T.a.string)]),
      localization: T.a.object,
      onChange: T.a.func,
      onFocus: T.a.func,
      onBlur: T.a.func,
      onClick: T.a.func,
      onKeyDown: T.a.func,
      isValid: T.a.func,
      isModernBrowser: T.a.func,
      onEnterKeyPress: T.a.func,
      keys: T.a.object
    }, kn.defaultProps = {
      excludeCountries: [],
      onlyCountries: [],
      preferredCountries: [],
      defaultCountry: "",
      placeholder: "+1 (702) 123-4567",
      disabled: !1,
      error: !1,
      variant: "standard",
      "native": !1,
      inputClass: "",
      dropdownClass: "",
      autoFormat: !0,
      disableAreaCodes: !1,
      isValid: function isValid(n) {
        return I()(_.a.allCountries, function (e) {
          return i()(n, e.dialCode) || i()(e.dialCode, n);
        });
      },
      disableCountryCode: !1,
      disableDropdown: !1,
      enableLongNumbers: !1,
      countryCodeEditable: !0,
      regions: "",
      localization: {},
      onEnterKeyPress: function onEnterKeyPress() {},
      onChange: function onChange() {},
      isModernBrowser: function isModernBrowser() {
        return !!document.createElement && Boolean(document.createElement("input").setSelectionRange);
      },
      keys: {
        UP: 38,
        DOWN: 40,
        RIGHT: 39,
        LEFT: 37,
        ENTER: 13,
        ESC: 27,
        PLUS: 43,
        A: 65,
        Z: 90,
        SPACE: 32
      }
    }, kn.displayName = "MuiPhoneNumber";
    var wn = Z()(function () {
      return {
        flagButton: {
          minWidth: 30,
          padding: 0,
          height: 30
        },
        "native": {
          width: 30,
          height: 30,
          padding: 8
        },
        nativeRoot: {
          padding: 0,
          "& + svg": {
            display: "none"
          }
        },
        nativeSelect: {
          padding: 0,
          lineHeight: 0,
          height: 11
        },
        positionStart: {
          position: "relative"
        }
      };
    })(kn);
    e["default"] = wn;
  }]);
});
var MuiPhoneNumber$1 = unwrapExports$1(dist$1);
var IRPF$1$1 = "IRPF";
var IVA$1$1 = "IVA";
var NIF$1$1 = "NIF";
var betweenMinAndMaxKilometers$1$1 = "Entre {{min}} y {{max}} kilómetros";
var metricUnits$1$1 = {
  u: "km",
  up: "kms",
  U: "Km",
  Up: "Kms",
  unit: "kilómetro",
  units: "kilómetros",
  Unit: "Kilómetro",
  Units: "Kilómetros",
  unitSpecialCase1: "Kms",
  unitSpecialCase2: "KM",
  ad: "el",
  adp: "los",
  uFranquise: "km franquicia",
  UpFranquise: "Kms franquicia",
  maxUnits: "Kilómetros max.",
  betweenMinAndMaxunits: "Entre {{min}} y {{max}} kilómetros",
  km: "km",
  kms: "kms",
  kilometer: "Kilómetro",
  maxKilometers: "Kilómetros max.",
  "rates-concepts": {
    km: "Tarifa por km"
  },
  searchTools: "nothing"
};
var imperialUnits$1$1 = {
  u: "mi",
  up: "mi",
  U: "Mi",
  Up: "Mi",
  unit: "milla",
  units: "millas",
  Unit: "Milla",
  Units: "Millas",
  unitSpecialCase1: "Millas",
  unitSpecialCase2: "MILLA",
  ad: "la",
  adp: "las",
  uFranquise: "mi franquicia",
  UpFranquise: "Mi franquicia",
  maxUnits: "Millas max.",
  betweenMinAndMaxunits: "Entre {{min}} y {{max}} millas",
  "rates-concepts": {
    km: "Tarifa por milla"
  },
  searchTools: "nothing",
  providerEditRateHeaderText: "Completa la información de las millas de la franquicia, las geocercas y las tarifas por medio, de cada depósito."
};
var A$2$1 = "A";
var accept$1$1 = "Aceptar";
var accepted$1$1 = "Aceptado";
var acceptUpdate$1$1 = "Aceptar actualización";
var accessToTheViews$1$1 = "Acceso a las vistas";
var accessWithMicrosoft$1$1 = "Acceder con Microsoft";
var activateGuardMode$1$1 = "Activar modo guardia";
var activateGuardModeWarningText$1$1 = "¿Seguro que deseas activar el modo guardia?";
var activateGuardModeWarningAditionalText$1$1 = "Al hacerlo, pasarás a operar como un proveedor automático y las compañías enviarán los servicios directamente a los recursos.";
var active$1$1 = "Activo";
var activity$1$1 = "Actividad";
var accumulateNightAndHolidaySurcharge$1$1 = "Acumular recargo nocturno y festivo";
var add$1$1 = "Añadir";
var addAuxService$1$1 = "Añadir servicio auxiliar";
var addCapability$1$1 = "Añadir prestación";
var addCollective$1$1 = "Añadir colectivo";
var addCost$1$1 = "Añadir costo";
var addCostType$1$1 = "Añadir tipo de costo";
var addedCollective$1$1 = "Colectivo añadido";
var addFault$1$1 = "Añadir avería";
var addedFault$1$1 = "Avería añadida";
var additionalInformation$1$1 = "Información adicional";
var additionalPrice$1$1 = "Precio adicionales";
var additionalPriceAbbrev$1$1 = "Precio resto";
var addNote$1$1 = "Añadir nota";
var address$1$1 = "Dirección";
var addressNotLocated$1$1 = "Dirección no localizada";
var addUserProfile$1$1 = "Añadir perfil de usuario";
var admin$1$1 = "Administrador";
var advancedConfiguration$1$1 = "Configuración avanzada";
var aheadServices$1$1 = "Servicios por delante";
var alert$1$1 = "Alerta";
var alerts$1$1 = "Alertas";
var alertStart$1$1 = "Inicio alerta";
var all_f$1$1 = "Todas";
var all_m$1$1 = "Todos";
var allowAccess$1$1 = "Permitir acceso";
var allowCalls$1$1 = "Permite llamadas";
var allowCalls_addService$1$1 = "Permitir llamadas";
var allowGuardErrorTitle$1$1 = "No se puede activar el Modo guardia";
var allowGuardErrorText$1$1 = "No se puede si hay servicios pendientes de aceptación o asignación.";
var allowSMS$1$1 = "Permite SMS";
var allProvidersAutomatic$1$1 = "Todos los proveedores (Automático)";
var anErrorHasOccurred$1$1 = "Ha ocurrido un error";
var applyCosts$1$1 = "Aplicar gastos";
var approve$1$1 = "Aprobar";
var assign$1$1 = "Asignar";
var assignTechnician$1$1 = "Asignar técnico";
var assistance$1$1 = "Asistencia";
var assistanceWithoutTransfer$1$1 = "Asistencia sin traslado";
var assistanceWithoutTransferWarning$1$1 = "No has seleccionado ningún traslado.";
var assistanceWithoutTransferWarningQuestion$1$1 = "¿Deseas continuar con el servicio de asistencia, sin traslado a personas?";
var assisted$1$1 = "Asistido";
var assistedInsuredAbbrev$1$1 = "Asistido/Aseg.";
var assistedDestinationAddress$1$1 = "Dirección de destino del asistido";
var associatedDocuments$1$1 = "Documentos asociados";
var at_time$1$1 = "a las {{time}} h";
var assigned$1$1 = "Agendado";
var ASSIGNED$1$1 = "Agendado";
var attachADocument$1$1 = "Adjuntar un documento";
var attachment$1$1 = "Adjuntar";
var attachments$1$1 = "Adjuntos";
var auction$1$1 = "Subastar";
var auctionConfiguration$1$1 = "Configuración subastas";
var auctioned$1$1 = "En subasta";
var AUCTIONED$1$1 = "En subasta";
var auctioning$1$1 = "En subasta";
var AUCTIONING$1$1 = "En subasta";
var auctionInPriority$1$1 = "En subasta";
var auctionInPriority1$1$1 = "Subasta en prioridad 1";
var auctionInPriority2$1$1 = "Subasta en prioridad 2";
var auctionInPriority3$1$1 = "Subasta en prioridad 3";
var auctionInPriority4$1$1 = "Subasta en prioridad Global";
var auctions$1$1 = "Subastas";
var auctionService$1$1 = "Subastar servicio";
var auto$1$1 = "Vehículo";
var automatic$1$1 = "Automático";
var automaticProvider$1$1 = "Proveedor automático";
var auxiliary$1$1 = "Auxiliar";
var auxiliarySettings$1$1 = "Ajustes de auxiliares";
var auxiliaries$1$1 = "Auxiliares";
var auxiliariesRates$1$1 = "Tarifas auxiliares";
var auxServiceList$1$1 = {
  auxServiceWithCount: "{{count}} Servicio auxiliar",
  auxServiceWithCount_plural: "{{count}} Servicios auxiliares"
};
var auxService$1$1 = "Servicio auxiliar";
var auxServices$1$1 = "Servicios auxiliares";
var available$1$1 = "Disponible";
var available_plural$1$1 = "Disponibles";
var availableProvidersAbbrev$1$1 = "Prov. disponibles";
var availableResources$1$1 = "Recursos disponibles";
var availableResourcesWithCount$1$1 = "{{count}} Recurso disponible";
var availableResourcesWithCount_plural$1$1 = "{{count}} Recursos disponibles";
var average$1$1 = "Tipo medio";
var averageRating$1$1 = "Valoración media";
var B$1$1 = "B";
var base$1$1 = "Base";
var baseAmount$1$1 = "Importe base";
var billed$1$1 = "Facturada";
var billing$1$1 = "Facturación";
var brand$1$1 = "Marca";
var browse$1$1 = "Examinar";
var budgetWarningNoBaseFound$1$1 = "Este proveedor no tiene configurada una base. Se ha utilizado la ubicación del recurso para calcular la tarifa.";
var businessIntelligence$1$1 = "Business Intelligence";
var byAmount$1$1 = "Por precio";
var byBrand$1$1 = "Por marca";
var byPositionOnQueue$1$1 = "Por posición en espera";
var byScore$1$1 = "por puntuación";
var byTime$1$1 = "Por tiempo";
var C$1$1 = "C";
var calculateAllServicesAsSuburban$1$1 = "Calcular todos los servicios como carreteros";
var calendar$1$1 = {
  today: "Hoy",
  yesterday: "Ayer",
  thisWeek: "Esta semana",
  last7Days: "Últimos 7 días",
  pastWeek: "Semana pasada",
  thisMonth: "Este mes",
  last30Days: "Últimos 30 días",
  pastMonth: "Mes pasado",
  thisYear: "Este año",
  lastYear: "Último año"
};
var cancel$1$1 = "Cancelar";
var cancel_2$1$1 = "Anular";
var outputCancellationPercentageAbbrev$1$1 = "% Salida anulado";
var cancelAmount$1$1 = "Importe anulación";
var cancelRatePercentage$1$1 = "% Salida anulación";
var cancelRateAmount$1$1 = "Importe anulación";
var cancelReason$1$1 = "Motivo de anulación";
var cancelService$1$1 = "Anular servicio";
var cancelTransferPeople$1$1 = "Anular traslado";
var cancelTransferPeopleWarning$1$1 = "En función del estado de ejecución, anular el traslado podría conllevar gastos. ¿Desea continuar?";
var capabilityList$1$1 = {
  capabilityWithCount: "{{count}} Prestación",
  capabilityWithCount_plural: "{{count}} Prestaciones"
};
var capability$1$1 = "Prestación";
var capabilityCollectiveAbbrev$1$1 = "Prestación/Colec.";
var capabilities$1$1 = "Prestaciones";
var center$1$1 = "Centro";
var centerName$1$1 = "Nombre del centro";
var centerNotFound$1$1 = "No se ha encontrado el centro";
var change$1$1 = "Cambiar";
var changePassword$1$1 = "Cambiar contraseña";
var charge$1$1 = "Cargo";
var chargeWithCount$1$1 = "{{count}} Cargo";
var chargeWithCount_plural$1$1 = "{{count}} Cargos";
var check$1$1 = "Revisar";
var childProfile$1$1 = "Perfil hijo";
var chosenDriver$1$1 = "Conductor elegido";
var cif$1$1 = "CIF";
var city$1$1 = "Ciudad";
var clone$1$1 = "Clonar";
var cloneService$1$1 = "Clonar servicio";
var close$1$1 = "Cerrar";
var closeDispute$1$1 = "Cerrar disputa";
var code$1$1 = "Código";
var collectDate$1$1 = "Fecha de cobro";
var collected$1$1 = "Cobrada";
var collectInvoice$1$1 = "Cobrar factura";
var collective$1$1 = "Colectivo";
var collectives$1$1 = "Colectivos";
var collectiveWithCount$1$1 = "{{count}} Colectivo";
var collectiveWithCount_plural$1$1 = "{{count}} Colectivos";
var collectiveProviderAbbrev$1$1 = "Colectivo/Prov.";
var comment$1$1 = "Comentario";
var commentAboutCapability$1$1 = "Comentario sobre prestación";
var companies$1$1 = "Compañías";
var company$1$1 = "Compañía";
var companyName$1$1 = "Nombre de la compañía";
var companyProfile$1$1 = "Perfil de compañía";
var completed$1$1 = "Completado";
var configuration$1$1 = "Configuración";
var consultList$1$1 = "Consultar lista";
var costName$1$1 = "Nombre del costo";
var costs$1$1 = "Costos";
var costSearch$1$1 = "Búsqueda de costo";
var costsWithCount$1$1 = "{{count}} Costo";
var costsWithCount_plural$1$1 = "{{count}} Costos";
var costSheets$1$1 = "Hojas de costos";
var costSheetStatus$1$1 = {
  PENDING: "P.imputación",
  IMPUTED: "P. aprobación",
  APPROVED: "Aprobado",
  REJECTED: "Rechazado"
};
var costType$1$1 = "Tipo de costo";
var costTypeName$1$1 = "Nombre del tipo de costo";
var costTypes$1$1 = "Tipos de costo";
var costTypesWithCount$1$1 = "{{count}} Tipo de costo";
var costTypesWithCount_plural$1$1 = "{{count}} Tipos de costo";
var craneService$1$1 = "Servicio de grúa";
var create$1$1 = "Crear";
var currentPassword$1$1 = "Contraseña actual";
var custodyDays$1$1 = "Días custodia";
var customer$1$1 = "Cliente";
var D$1$1 = "D";
var dashboard$1$1 = "Dashboard";
var date$1$1 = "Fecha";
var dateRangeExceeded$1$1 = "Excedido el rango de fechas";
var dayAndTime$1$1 = "Día y hora";
var deadLine$1$1 = "Fecha límite";
var concessionaire$1$1 = "Concesionaria";
var deferred$1$1 = "Programado";
var deferredService$1$1 = "Servicio programado";
var deferredShort$1$1 = "Programad";
var deferredShorter$1$1 = "Progra.";
var deleteCost$1$1 = "Eliminar costo";
var deletePath$1$1 = "Borrar trazado";
var deleteRequest$1$1 = "Eliminar solicitud";
var deposits$1$1 = "Depósitos";
var description$1$1 = "Descripción";
var detail$1$1 = "Detalle";
var disconnect$1$1 = "Desconectar";
var disputeReason$1$1 = "Motivo de la disputa";
var documentation$1$1 = "Documentación";
var documentationProfile$1$1 = "Perfil documentación";
var documentNumberAbbrev$1$1 = "Nº del documento";
var documentProfile$1$1 = "Perfil de documento";
var documentProfiles$1$1 = "Perfil de documentos";
var documentAdded$1$1 = "Documento añadido";
var documentType$1$1 = "Tipo de documento";
var documentTypes$1$1 = "Tipo de documentos";
var doNotAssociate$1$1 = "No asociar";
var dragData$1$1 = "Arrastrar datos";
var driver$1$1 = "Conductor";
var drivers$1$1 = "Conductores";
var duplicate$1$1 = "Duplicar";
var duplicateService$1$1 = "Duplicar servicio";
var E$1$1 = "E";
var edit$1$1 = "Editar";
var editAuxService$1$1 = "Editar servicio auxiliar";
var editCapability$1$1 = "Editar prestación";
var editCollective$1$1 = "Editar colectivo";
var editCost$1$1 = "Editar costo";
var editCostType$1$1 = "Editar tipo de costo";
var editFault$1$1 = "Editar avería";
var editSupportTeam$1$1 = "Editar equipo de soporte";
var editUserProfile$1$1 = "Editar perfil de usuario";
var email$1$1 = "Email";
var endService$1$1 = "Finalizar servicio";
var entry$1$1 = "Entrada";
var entryDateAbbrev$1$1 = "F. de entrada";
var error$1$1 = "Error";
var errorAddingDocument$1$1 = "Error al añadir documento";
var estimatedTime$1$1 = "Hora estimada";
var execution$1$1 = "Ejecución";
var executionProfile$1$1 = "Perfil de ejecución";
var expense$1$1 = "Gastos";
var expiredCode$1$1 = "Código caducado";
var expires$1$1 = "Caduca";
var events$1$1 = "Eventos";
var excessOfTimeForOutService$1$1 = "Exceso de tiempo para realizar servicio carretero";
var excessOfTimeForUrbanService$1$1 = "Exceso de tiempo para realizar servicio local";
var excessOfTimeInCurrentStatus$1$1 = "Exceso de tiempo en el estado actual";
var excessOfTimeToCompleteService$1$1 = "Exceso de tiempo para realizar el servicio";
var excessOfTimeToStartScheduledService$1$1 = "Exceso de tiempo para iniciar un servicio programado";
var F$1$1 = "F";
var fault$1$1 = "Avería";
var faults$1$1 = "Averías";
var faultCollectiveAbbrev$1$1 = "Avería/Colec.";
var faultWithCount$1$1 = "{{count}} Avería";
var faultWithCount_plural$1$1 = "{{count}} Averías";
var fee$1$1 = "Salida";
var fieldRequired$1$1 = "Requerido";
var file$1$1 = "Archivo";
var filterByDriverStatus$1$1 = "Filtrar por estado conductor";
var filterByVehicleType$1$1 = "Filtrar por tipo vehículo";
var financial$1$1 = "Financiero";
var financialBreakdown$1$1 = "Desglose financiero";
var finish$1$1 = "Finalizar";
var finishedServices$1$1 = "Servicios finalizados";
var firstPrice$1$1 = "Precio primera";
var firstUnitPriceAbbrev$1$1 = "Precio 1ª ud.";
var fixed$1$1 = "Fijo";
var formError$1$1 = "Error en formulario";
var franchise$1$1 = "Franquicia";
var franchises$1$1 = "Franquicias";
var freeCranesBefore1Hour$1$1 = "Grúas libres antes de 1h";
var fromUntil$1$1 = "Desde - Hasta";
var fullAddress$1$1 = "Dirección completa";
var fullScreenAbbrev$1$1 = "P. completa";
var G$1$1 = "G";
var generalInformationAbbrev$1$1 = "Inf. General";
var generate$1$1 = "Generar";
var generated$1$1 = "Generada";
var geofence$1$1 = "Geocerca";
var geofence_plural$1$1 = "Geocercas";
var geofenceWithCount$1$1 = "{{count}} Geocerca";
var geofenceWithCount_plural$1$1 = "{{count}} Geocercas";
var geoJson$1$1 = "GeoJson";
var globalAuction$1$1 = "Subasta global";
var graceDays$1$1 = "Días de gracia";
var grecaptchaNote$1$1 = "Sitio protegido por reCAPTCHA. Se aplica la <a href=\"https://policies.google.com/privacy\">Política de privacidad</a> y <a href=\"https://policies.google.com/terms\">Términos de servicio</a> de Google.";
var guardMode$1$1 = "Modo guardia";
var H$1$1 = "H";
var help$1$1 = "Ayuda";
var hide$1$1 = "Ocultar";
var holder$1$1 = "Titular";
var holidays$1$1 = "Festivos";
var home$1$1 = "Hogar";
var hour$1$1 = "Hora";
var hours$1$1 = "Horas";
var I$1$1 = "I";
var IBAN$1$1 = "IBAN";
var icon$1$1 = "Icono";
var iconUrl$1$1 = "URL del icono";
var identificationIcon$1$1 = "Icono identificativo";
var image$1$1 = "Imagen";
var immediate$1$1 = "Inmediato";
var immediate_plural$1$1 = "Inmediatos";
var immediateService$1$1 = "Servicio inmediato";
var incorrectLocationFormat$1$1 = "Localización en formato incorrecto";
var infoWindowIcon$1$1 = "Icono del InfoWindow";
var inParking$1$1 = "En parking";
var inRis$1$1 = "En reparación";
var inris$1$1 = "En reparación";
var inServiceResourcesWithCount$1$1 = "{{count}} Recurso en servicio";
var inServiceResourcesWithCount_plural$1$1 = "{{count}} Recursos en servicio";
var instant$1$1 = "Inmediato";
var insurancePolicyInfo$1$1 = "Información de la póliza";
var insured$1$1 = "Asegurado";
var insured_autoType$1$1 = "Vehículo";
var insured_homeType$1$1 = "Inmueble";
var insuredAutoType$1$1 = "Vehículo";
var insuredHomeType$1$1 = "Inmueble";
var insuredObjectAbbrev$1$1 = "Bien aseg.";
var insuredProperty$1$1 = "Bien asegurado";
var integrationProfile$1$1 = "Perfil de integración";
var integrationProfileAbbrev$1$1 = "Perfil integración";
var internalCode$1$1 = "Código interno";
var internalNote$1$1 = "Nota interna";
var internalNotes$1$1 = "Notas internas";
var interrupted$1$1 = "Interrumpida";
var intervention$1$1 = "Intervención";
var interventionAbbrev$1$1 = "Int.";
var interventions$1$1 = "Intervenciones";
var inUrbanArea$1$1 = "En zona local";
var invalidNexusFilecase$1$1 = "Expediente de Nexus no válido";
var invalidText$1$1 = "Texto no válido";
var invoice$1$1 = "Factura";
var invoiceNumberAbbrev$1$1 = "Nº de factura";
var forTheDay$1$1 = "Para el día";
var isNotValid$1$1 = "Es inválido";
var issuedInvoices$1$1 = "Facturas emitidas";
var itAlreadyExists$1$1 = "Ya existe";
var J$1$1 = "J";
var K$1$1 = "K";
var L$1$1 = "L";
var label$1$1 = "Rotulación";
var labeled$1$1 = "Rotulaciones";
var labels$1$1 = "Rotulaciones";
var lastActivity$1$1 = "Ult. actividad";
var lastActivity2$1$1 = "Última actividad";
var legal$1$1 = "Legal";
var legalId$1$1 = "NIF/CIF";
var list$1$1 = "Listado";
var listEntryMax24H$1$1 = "Entrada en lista (max. 24h)";
var loaded$1$1 = "Cargado";
var loadTimeInMinutes$1$1 = "Tiempo de carga (min)";
var located$1$1 = "Localizado";
var location$1$1 = "Ubicación";
var locked$1$1 = "Bloqueado";
var lockedByNexus$1$1 = "Bloqueado";
var login$1$1 = "Iniciar sesión";
var logo$1$1 = "Logotipo";
var logout$1$1 = "Cerrar sesión";
var M$1$1 = "M";
var managed$1$1 = "Gestionado";
var managedProvider$1$1 = "Proveedor gestionado";
var manual$1$1 = "Manual";
var manualProvider$1$1 = "Proveedor manual";
var map$1$1 = "Mapa";
var mapIcon$1$1 = "Icono del mapa";
var mapOfGoingServices$1$1 = "Mapa de servicios en curso";
var mapOfResources$1$1 = "Mapa de recursos";
var mapOfTracking$1$1 = "Mapa de seguimiento";
var mapView$1$1 = "Vista mapa";
var max$1$1 = "Max.";
var maxAllowedTimeInMinutes$1$1 = "Tiempo máx. permitido: {{minutes}} min";
var maxDistance$1$1 = "Distancia máxima";
var maxDistanceToCrane$1$1 = "Distancia de la grúa";
var maxHours$1$1 = "Horas máximo";
var maxRadius$1$1 = "Radio máximo";
var maxTime$1$1 = "Tiempo máximo";
var maxTimeOnList$1$1 = "Permanencia en lista";
var medium$1$1 = "Medio";
var mediumNotFound$1$1 = "No se ha encontrado el medio";
var mediumType$1$1 = "Tipo de medio";
var mediumTypes$1$1 = "Tipo de medios";
var mediumTypes2$1$1 = "Tipos de medio";
var minute$1$1 = "Minuto";
var minutes$1$1 = "Minutos";
var modeAndName$1$1 = "Modo y nombre";
var model$1$1 = "Modelo";
var modifiedCollective$1$1 = "Colectivo modificado";
var modifiedFault$1$1 = "Avería modificada";
var myTickets$1$1 = "Mis tickets";
var N$1$1 = "N";
var name$1$1 = "Nombre";
var nameSurname$1$1 = "Nombre y apellidos";
var new_female$1$1 = "Nueva";
var new_plural$1$1 = "Nuevos";
var newAuxService$1$1 = "Nuevo servicio";
var newAuxiliaryService$1$1 = "Nuevo servicio auxiliar";
var newDayAndTime$1$1 = "Nuevo día y hora";
var newPassword$1$1 = "Nueva contraseña";
var newService$1$1 = "Nuevo servicio";
var newSupportTeam$1$1 = "Nuevo equipo de soporte";
var newVehicleAssistance$1$1 = "Nueva asistencia de vehículos";
var newVialService$1$1 = "Nuevo servicio vial";
var nexusMapServiceError$1$1 = "Error en el servicio de mapas de Nexus";
var nick$1$1 = "Nick";
var no$1$1 = "No";
var noProvidersAvailable$1$1 = "No hay proveedores disponibles";
var notApplyCosts$1$1 = "No aplicar gastos";
var notParticipating$1$1 = "No participa";
var noCovered$1$1 = "No cubierto";
var noDocumentsAssociatedToService$1$1 = "No hay documentos asociados";
var noResourcesAvailableMsg$1$1 = "No hay recursos disponibles, pero puedes enviar el servicio a una lista de espera para que Nexus lo gestione.";
var noSubscribe$1$1 = "No suscribirme";
var note$1$1 = "Nota";
var notes$1$1 = "Notas";
var notesAssociatedWithTheService$1$1 = "Notas asociadas al servicio";
var noTicketsAssociatedToService$1$1 = "No hay tickets asociados al servicio";
var noTicketsAssociatedToTransfer$1$1 = "No hay tickets asociados al traslado";
var noNotesAssociatedToService$1$1 = "No hay notas asociadas al servicio";
var notifications$1$1 = "Notificaciones";
var noTransfersAvailable$1$1 = "No hay traslados disponibles";
var noValid$1$1 = "No válido";
var numberAbbrev$1$1 = "Nº";
var numberOfPeopleAbbrev$1$1 = "Nº de personas";
var numberOfReviewsAbbrev$1$1 = "Nº Reseñas";
var O$1$1 = "O";
var office$1$1 = "Oficina";
var ongoing$1$1 = "En curso";
var onQueue$1$1 = "En espera";
var openDispute$1$1 = "Abrir disputa";
var operational$1$1 = "Operativos";
var operationTypes$1$1 = "Tipo de intervención";
var origin$1$1 = "Origen";
var originalServiceData$1$1 = "Datos del servicio original";
var originDeposit$1$1 = "Origen depósito";
var otherSettings$1$1 = "Otros ajustes";
var orYouCan$1$1 = "O puedes";
var outlay$1$1 = "Suplidos";
var outlays$1$1 = "Gastos adicionales";
var P$1$1 = "P";
var paid$1$1 = "Pagada";
var passengers$1$1 = "Pasajeros";
var passengersWithCount$1$1 = "{{count}} Pasajero";
var passengersWithCount_plural$1$1 = "{{count}} Pasajeros";
var password$1$1 = "Contraseña";
var passwordsNotMatch$1$1 = "Las contraseñas no coinciden";
var paymentsToProviders$1$1 = "Pagos a proveedores";
var pdf$1$1 = "Pdf";
var pending$1$1 = "Pendiente";
var pendings$1$1 = "Pendientes";
var PENDING$1$1 = "Pendiente";
var pending_assign$1$1 = "Pendiente asignación";
var PENDING_ASSIGN$1$1 = "Pendiente asignación";
var PENDINGASSIGN$1$1 = "Pendiente asignación";
var pendingDocumentation$1$1 = "Documentación pendiente";
var pendingDocuments$1$1 = "Documentos pendientes";
var pendingPassword$1$1 = "Pendiente registro";
var pendingProfile$1$1 = "Pendiente perfil";
var peopleTransferActivity$1$1 = "Traslados";
var pleaseTryAgainLater$1$1 = "Por favor inténtalo de nuevo mas tarde";
var phone$1$1 = "Teléfono";
var phoneNumberAbbrev$1$1 = "Nº de teléfono";
var photoWithCount$1$1 = "{{count}} foto";
var photoWithCount_plural$1$1 = "{{count}} fotos";
var photos$1$1 = "Fotos";
var planned$1$1 = "Planificado";
var PLANNED$1$1 = "Planificado";
var plannedService$1$1 = "Servicio planificado";
var plate$1$1 = "Matrícula";
var plateDoesNotCorrespondToTheFilecase$1$1 = "Matrícula no corresponde al expediente";
var policy$1$1 = "Póliza";
var policyCoverageLimit$1$1 = "Excedida la cobertura de la póliza";
var policyCoverageLimit2$1$1 = "Posible exceso de la cobertura de la póliza";
var policyInformation$1$1 = "Información de póliza";
var policyLimitExceeded$1$1 = {
  number1: "Se ha solicitado 1 servicio, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al proveedor.",
  number2: "Se han solicitado {{previousServices}} servicios, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al proveedor.",
  number3: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza es 1. El asistido deberá abonar el coste total del servicio al proveedor.",
  number4: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza son {{policyServicesLimit}}. El asistido deberá abonar el coste total del servicio al proveedor.",
  amount1: "El importe del servicio es de {{serviceTotalAmount}}, y el importe máximo que incluye la póliza es {{policyAmountLimit}}. El asistido deberá abonar la diferencia de {{amountDifference}} al proveedor.",
  amount2: "El importe del servicio es de {{serviceTotalAmount}}, y quedan {{availableAmount}} del importe máximo que incluye la póliza. El asistido deberá abonar la diferencia de {{amountDifference}} al proveedor.",
  amount3: "El importe del servicio es de {{serviceTotalAmount}}, y ya se ha gastado el importe máximo que incluye la póliza. El asistido deberá abonar la totalidad del servicio al proveedor.",
  amount4: "El importe de alguno de los recursos seleccionados supera el límite de la póliza de {{policyAmountLimit}}. El asistido deberá abonar la diferencia al proveedor en el caso de que estos recursos acepten el servicio.",
  amount5: "El importe de alguno de los recursos seleccionados supera el límite de la póliza de {{policyAmountLimit}}, y quedan {{availableAmount}} del importe máximo de cobertura. El asistido deberá abonar la diferencia al proveedor en el caso de que estos recursos acepten el servicio.",
  amount6: "El importe de todos los recursos seleccionados supera el límite de la póliza de {{policyAmountLimit}}, y ya se ha gastado el importe máximo de cobertura. El asistido deberá abonar la totalidad del servicio al proveedor en el caso de que estos recursos acepten el servicio.",
  amount4b: "El importe del recurso seleccionado supera el límite de la póliza de {{policyAmountLimit}}. El asistido deberá abonar la diferencia al proveedor en el caso de que este recurso acepte el servicio.",
  amount5b: "El importe del recurso seleccionado supera el límite de la póliza de {{policyAmountLimit}}, y quedan {{availableAmount}} del importe máximo de cobertura. El asistido deberá abonar la diferencia al proveedor en el caso de que este recurso acepte el servicio.",
  amount6b: "El importe del recurso seleccionado supera el límite de la póliza de {{policyAmountLimit}}, y ya se ha gastado el importe máximo de cobertura. El asistido deberá abonar la totalidad del servicio al proveedor en el caso de que este recurso acepte el servicio.",
  amount7: "El importe estimado del servicio es de {{serviceTotalAmount}}, y el importe máximo que incluye la póliza es {{policyAmountLimit}}. El asistido deberá abonar la diferencia aproximada de {{amountDifference}} al proveedor.",
  amount8: "El importe estimado del servicio es de {{serviceTotalAmount}}, y quedan {{availableAmount}} del importe máximo que incluye la póliza. El asistido deberá abonar la diferencia aproximada de {{amountDifference}} al proveedor.",
  amount9: "El importe estimado del servicio es de {{serviceTotalAmount}}, y ya se ha gastado el importe máximo que incluye la póliza. El asistido deberá abonar la totalidad del servicio al proveedor."
};
var policyLimitExceededAux$1$1 = {
  number1: "Se ha solicitado 1 servicio, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al técnico.",
  number2: "Se han solicitado {{previousServices}} servicios, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al técnico.",
  number3: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza es 1. El asistido deberá abonar el coste total del servicio al técnico.",
  number4: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza son {{policyServicesLimit}}. El asistido deberá abonar el coste total del servicio al técnico.",
  amount1: "El importe del servicio es de {{serviceTotalAmount}}, y el importe máximo que incluye la póliza es {{policyAmountLimit}}. El asistido deberá abonar la diferencia de {{amountDifference}} al técnico.",
  amount2: "El importe del servicio supera el límite de la póliza de {{serviceTotalAmount}}, y quedan {{availableAmount}} del importe máximo de cobertura. El asistido deberá abonar la diferencia de {{amountDifference}} al técnico.",
  amount3: "El importe del servicio supera el límite de la póliza de {{serviceTotalAmount}}, y ya se ha gastado el importe máximo de cobertura. El asistido deberá abonar la totalidad del servicio al técnico."
};
var policyNumberAbbrev$1$1 = "Nº de póliza";
var policySearch$1$1 = "Búsqueda de póliza";
var positionAbbrev$1$1 = "P.";
var priority$1$1 = "Prioritario";
var priority1Providers$1$1 = "Proveedores de prioridad 1";
var priority2Providers$1$1 = "Proveedores de prioridad 2";
var priority3Providers$1$1 = "Proveedores de prioridad 3";
var priorityAllProviders$1$1 = "Todos los proveedores";
var priorityProvider$1$1 = "Proveedor prioritario";
var process$1$1$1 = "Procesar";
var profile$1$1 = "Perfil";
var profileNotFound$1$1 = "No se ha encontrado el perfil";
var profiles$1$1 = "Perfiles";
var proposals$1$1 = "Propuestas";
var provider$1$1 = "Proveedor";
var providersInZone$1$1 = "Proveedores en la zona";
var providersOutZone$1$1 = "Resto de proveedores";
var providerTechnician$1$1 = "Proveedor / técnico";
var providerVialSettings$1$1 = "Ajustes de viales de {{providerName}}";
var providerEditVialSettingsHeaderText$1$1 = "Completa la información necesaria correspondiente a los servicios viales.";
var providerAuxiliariesSettings$1$1 = "Ajustes de auxiliares de {{providerName}}";
var providerEditAuxiliariesSettingsHeaderText$1$1 = "Completa la información necesaria correspondiente a los servicios auxiliares.";
var providers$1$1 = "Proveedores";
var provider_pending$1$1 = "Pendiente proveedor";
var PROVIDER_PENDING$1$1 = "Pendiente proveedor";
var PROVIDERPENDING$1$1 = "Pendiente proveedor";
var provider_accepted$1$1 = "Aceptado proveedor";
var PROVIDER_ACCEPTED$1$1 = "Aceptado proveedor";
var PROVIDERACCEPTED$1$1 = "Aceptado proveedor";
var provider_accept$1$1 = "Aceptado proveedor";
var PROVIDER_ACCEPT$1$1 = "Aceptado proveedor";
var PROVIDERACCEPT$1$1 = "Aceptado proveedor";
var providersSelection$1$1 = "Selección de proveedores";
var providerList$1$1 = {
  providerWithCount: "{{count}} Proveedor",
  providerWithCount_plural: "{{count}} Proveedores"
};
var providersMap$1$1 = "Mapa de proveedores";
var providerType$1$1 = "Tipo de proveedor";
var providerTypeVial$1$1 = "Tipo de vial";
var providerTypeAux$1$1 = "Tipo de auxiliar";
var providerWithoutDefinedDeposit$1$1 = "Proveedor sin depósito configurado";
var province$1$1 = "Provincia";
var Q$1$1 = "Q";
var queueEntryDate$1$1 = "Fecha de entrada en la lista";
var queued$1$1 = "En espera";
var QUEUED$1$1 = "En espera";
var queuedService$1$1 = "Servicio en espera";
var R$1$1 = "R";
var rates$1$1 = "Tarifas";
var rating$1$1 = "Valoración";
var ratings$1$1 = "Valoraciones";
var ratingsUserName$1$1 = "Valoraciones de {{userName}}";
var ratingsWithCount$1$1 = "{{count}} Valoración";
var ratingsWithCount_plural$1$1 = "{{count}} Valoraciones";
var ready$1$1 = "Disponible";
var reAssign$1$1 = "Reasignar";
var reAssignProvider$1$1 = "Reasignar proveedor";
var reAskForResetEmail$1$1 = "Vuelve a pedir email de restablecer";
var received$1$1 = "Recibido";
var receivedInvoices$1$1 = "Facturas recibidas";
var recoverRequest$1$1 = "Recuperar solicitud";
var recoverYourPassword$1$1 = "Recupera tu contraseña";
var region$1$1 = "Región";
var registrationInformationOnInvoices$1$1 = "Información registral en facturas";
var reject$1$1 = "Rechazar";
var rejectCosts$1$1 = "Rechazar costos";
var rejectionReason$1$1 = "Motivo de rechazo";
var rejectionReasons$1$1 = "Motivos de rechazo";
var rejectionType$1$1 = "Tipo de rechazo";
var release$1$1 = "Liberar";
var removeFromDashboard$1$1 = "Eliminar del Dashboard";
var repeated$1$1 = "Repetido";
var repeatPassword$1$1 = "Repetir contraseña";
var requestCapability$1$1 = "Prestación solicitada";
var requestInfo$1$1 = "Inf. solicitud";
var requestLocationByWhatsApp$1$1 = "Solicitar ubicación por WhatsApp";
var requestMediumAbbrev$1$1 = "M.Solicitado";
var requestProcessedCorrectly$1$1 = "Solicitud procesada de forma correcta";
var requestWithoutIAssociatedPolicy$1$1 = "Solicitud sin póliza asociada";
var required$1$1 = "Obligatorio";
var reschedule$1$1 = "Reprogramar";
var RESCHEDULED$1$1 = "Reprogramado";
var rescheduleComment$1$1 = "Comentario de la reprogramación";
var rescheduleReason$1$1 = "Motivo de reprogramación";
var rescheduleService$1$1 = "Reprogramar servicio";
var rescheduleServiceDeferredTextModal$1$1 = "Introduce un nuevo día y hora para cambiar la programación del servicio actual";
var rescheduleServicePlannedText1Modal$1$1 = "Los servicios planificados tienen un recurso asignado. Al cambiar la fecha y hora, el servicio volverá al estado programado, y estará pendiente de planificación";
var rescheduleServicePlannedText2Modal$1$1 = "Introduce la nueva fecha del servicio programado";
var resetPassword$1$1 = "Contraseña restablecida";
var resetYourPassword$1$1 = "Restablece tu contraseña";
var resources$1$1 = "Recursos";
var resourcesMap$1$1 = "Mapa de recursos";
var restore$1$1 = "Restablecer";
var result$1$1 = "Resultado";
var ris$1$1 = "RIS";
var risService$1$1 = "Servicio de RIS";
var S$1$1 = "S";
var save$1$1 = "Guardar";
var saveChanges$1$1 = "Guardar cambios";
var savedRequests$1$1 = "Solicitudes guardadas";
var saveRequest$1$1 = "Guardar solicitud";
var schedule$1$1 = "Agendar";
var scheduled$1$1 = "Programado";
var SCHEDULED$1$1 = "Programado";
var scheduled_plural$1$1 = "Programados";
var scheduledAbbrev$1$1 = "Program.";
var scheduledDateInvalidErrorText$1$1 = "La fecha y hora programada no es válida";
var scheduleDriver$1$1 = "Agendar conductor";
var scheduledServiceNotFound$1$1 = "El servicio programado no ha sido localizado";
var scheduledFor$1$1 = "Programado para";
var searchResourceOrTechnician$1$1 = "Busca recurso o técnico";
var searchResources$1$1 = "Busca recursos";
var searchAResource$1$1 = "Buscar un recurso";
var searchAService$1$1 = "Buscar un servicio";
var searchByAssistedOrFilecase$1$1 = "Asistido o Exp";
var searchByAssistedFilecaseOrPlate$1$1 = "Asistido, Aseg, Exp. o Matrícula";
var searchByAssistedFilecaseOrProvider$1$1 = "Asistido, Exp. o Proveedor";
var searchByCodeOrName$1$1 = "Busca por Código o Nombre";
var searchByCodeNameOrCostType$1$1 = "Busca por Código, Nombre o Tipo de costo";
var searchByCodeNameOrMediumType$1$1 = "Busca por Código, Nombre o Tipo de medio";
var searchByCustomer$1$1 = "Busca por Cliente";
var searchByCustomerOrFilecase$1$1 = "Cliente o Exp";
var searchByCustomerFilecaseOrPlate$1$1 = "Cliente, Exp. o Matrícula";
var searchByFileCase$1$1 = "Busca por Expediente";
var searchByIdForOrFilecaseNumber$1$1 = "Busca por ID, Para o Nº Expediente";
var searchByInvoiceNumber$1$1 = "Busca por Nº Factura";
var searchByName$1$1 = "Busca por Nombre";
var searchByNameCIFOrAddress$1$1 = "Busca por Nombre, CIF o Dirección";
var searchByNameOrAddress$1$1 = "Busca por Nombre o Dirección";
var searchByNameOrCode$1$1 = "Busca por Nombre o Código";
var searchByNamePlateOrCode$1$1 = "Busca por Nombre, Matrícula o Código";
var searchByNameSurnameUserOrNick$1$1 = "Busca por Nombre, Apellidos, Usuario o Nick";
var searchByProviderOrName$1$1 = "Busca por Proveedor o Nombre";
var searchByTerm$1$1 = "Busca por término";
var searchInsurancePolicy$1$1 = "Buscar póliza";
var seeAverages$1$1 = "Ver medias";
var breakdown$1$1 = "Desglose";
var seeCapabilityComment$1$1 = "Ver comentario de prestación";
var seeComment$1$1 = "Ver comentario";
var seeContactAndComment$1$1 = "Ver contacto y comentario";
var seeDescription$1$1 = "Ver descripción";
var seeService$1$1 = "Ver servicio";
var selfValidated$1$1 = "Autovalidado";
var send$1$1 = "Enviar";
var sendComments$1$1 = "Enviar comentarios";
var sended$1$1 = "Enviado";
var sendEmail$1$1 = "Enviar correo";
var sendForReview$1$1 = "Enviar a revisión";
var sendTo$1$1 = "Enviar a";
var sendToList$1$1 = "Enviar a la lista";
var serverConnectionError$1$1 = "¡Error de conexión con el servidor!";
var service$1$1 = "servicio";
var serviceExecution$1$1 = "Ejecución del servicio";
var serviceInAuction$1$1 = "Servicio en subasta";
var serviceLevels$1$1 = "Niveles de servicio";
var serviceMap$1$1 = "Mapa de viales";
var serviceNotFound$1$1 = "No se ha encontrado el servicio";
var serviceRequestAndTracking$1$1 = "Solicitud y seguimiento del servicio";
var services$1$1 = "Servicios";
var serviceSentToAuction$1$1 = "Servicio enviado a subasta";
var serviceStatus$1$1 = {
  auctioning: "En subasta",
  auctioningAvatar: "S",
  pending_assign: "Pendiente asignación",
  pendingAssign: "Pendiente asignación",
  pending_assignAvatar: "PA",
  provider_pending: "Pendiente proveedor",
  providerPending: "Pendiente proveedor",
  provider_pendingAvatar: "PP",
  provider_accepted: "Aceptado proveedor",
  providerAccepted: "Aceptado proveedor",
  providerAccept: "Aceptado proveedor",
  provider_acceptedAvatar: "AP",
  queued: "En espera",
  queuedAvatar: "E",
  scheduled: "Programado",
  scheduledAvatar: "PR",
  pending: "Pendiente",
  pendingAvatar: "PE",
  assigned: "Agendado",
  assignedAvatar: "AG",
  planned: "Planificado",
  plannedAvatar: "PL",
  accepted: "Aceptado",
  acceptedAvatar: "AC",
  started: "Iniciado",
  startedAvatar: "I",
  located: "Localizado",
  locatedAvatar: "L",
  inris: "En reparación",
  inrisAvatar: "RP",
  loaded: "Cargado",
  loadedAvatar: "CA",
  completed: "Completado",
  completedAvatar: "CO",
  finished: "Finalizado",
  finishedAvatar: "F",
  rejected: "Rechazado",
  rejectedAvatar: "RC",
  canceled: "Anulado",
  canceledAvatar: "AN"
};
var settings$1$1 = "Ajustes";
var settingsUpdated$1$1 = "Ajustes actualizados";
var sharedCode$1$1 = "Código compartido";
var sharedNote$1$1 = "Nota compartida";
var sharedNotes$1$1 = "Notas compartidas";
var shipments$1$1 = "Remesas";
var shipmentStatusValues$1$1 = {
  collecting: "Interrumpida",
  pending: "Generada",
  billed: "Facturada",
  collected: "Cobrada",
  payed: "Pagada"
};
var showAllMediums$1$1 = "Mostrar todos los medios";
var showSolicitedMedium$1$1 = "Mostrar medio solicitado";
var situation$1$1 = "Situación";
var solicitedMedium$1$1 = "Medio solicitado";
var sortCriteria$1$1 = "Criterio ordenación";
var soundActivated$1$1 = "Sonido activado";
var soundOff$1$1 = "Sonido desactivado";
var start$1$1 = "Inicio";
var started$1$1 = "Iniciado";
var status$1$1 = "Estado";
var statuses$1$1 = "Estados";
var subject$1$1 = "Asunto";
var subscribe$1$1 = "Suscribirme";
var subtotal$1$1 = "Subtotal";
var suburb$1$1 = "Carretero";
var suburbService$1$1 = "Servicio carretero";
var summary$1$1 = "Resumen";
var supportCenter$1$1 = "Centro de soporte";
var supportTeam$1$1 = "Equipo de soporte";
var survey$1$1 = "Encuesta";
var surveys$1$1 = "Encuestas";
var T$1$1 = "T";
var taxes$1$1 = "Impuestos";
var team$1$1 = "Equipo";
var teamName$1$1 = "Nombre del equipo";
var technician$1$1 = "Técnico";
var technicians$1$1 = "Técnicos";
var theField$1$1 = "El campo";
var ticket$1$1 = "Ticket";
var tickets$1$1 = "Tickets";
var ticketStatus$1$1 = {
  "new": "Nuevo",
  newAvatar: "N",
  open: "Abierto",
  openAvatar: "A",
  closed: "Cerrado",
  closedAvatar: "C"
};
var time$1$1 = "Tiempo";
var timeInAlert$1$1 = "Tiempo en alerta";
var timeline$1$1 = "Línea de tiempo";
var title$1$1 = "Título";
var toastErrorDuplicateAddressPickupDeliveryTitle$1$1 = "Error en las direcciones";
var toastErrorDuplicateAddressPickupDeliveryText$1$1 = "La dirección de recogida y entrega deben ser diferentes.";
var toastErrorDuplicateAddressPickupDestinationTitle$1$1 = "Error en las direcciones";
var toastErrorDuplicateAddressPickupDestinationText$1$1 = "La dirección de recogida y destino del asistido deben ser diferentes.";
var toastErrorTextDefault$1$1 = "No ha sido posible realizar la operación.";
var toastErrorTitleDefault$1$1 = "Error en la operación";
var toastErrorTransferPeopleBudget$1$1 = {
  expiredEstimate: {
    title: "Error",
    text: "La estimación de tarifa seleccionada ha expirado."
  },
  invalidEstimate: {
    title: "Error",
    text: ""
  },
  productNotFound: {
    title: "Error",
    text: "El recurso seleccionado no ha sido localizado."
  },
  cabifyIntegrationProblem: {
    title: "Error",
    text: "No se ha podido solicitar el traslado."
  },
  profileWithoutResources: {
    title: "Error",
    text: "Perfil sin recursos"
  }
};
var toastErrorTitle_downloadFile$1$1 = "Error";
var toastErrorText_downloadFile$1$1 = "No ha sido posible descargar el fichero.";
var toastSuccessTextDefault$1$1 = "La operación se ha realizado correctamente.";
var toastSuccessTitleDefault$1$1 = "Operación realizada con éxito";
var today$1$1 = "Hoy";
var toDefine$1$1 = "Por definir";
var total$1$1 = "Total";
var totals$1$1 = "Totales";
var toTheClient$1$1 = "Al cliente";
var toTheProvider$1$1 = "Al proveedor";
var town$1$1 = "Localidad";
var tracking$1$1 = "Seguimiento";
var trackingMessage$1$1 = "Mensaje de seguimiento";
var transfer$1$1 = "Traslado";
var transferHasBeenCancelled$1$1 = "El traslado ha sido anulado.";
var transferPeople$1$1 = "Traslado de personas";
var transferPeopleBudget$1$1 = "Propuesta de traslado";
var transferPeopleRequest$1$1 = "Solicitud de traslado";
var transferPeopleRequestType$1$1 = {
  immediate: "Servicio inmediato",
  deferred: "Servicio programado"
};
var transferPeopleRequiredValidPhoneNumber$1$1 = "Para los traslados es necesario facilitar un teléfono de contacto.";
var transfers$1$1 = "Traslados";
var transfersAvailable$1$1 = "Traslados disponibles";
var transferTheAssisted$1$1 = "Trasladar al asistido";
var type$1$1 = "Tipo";
var typeAndName$1$1 = "Tipo y nombre";
var typeless$1$1 = "Sin tipo";
var typeOfService$1$1 = "Tipo de servicio";
var types$1$1 = "Tipos";
var U$1$1 = "U";
var udWithCount$1$1 = "{{count}} ud.";
var udWithCount_plural$1$1 = "{{count}} uds.";
var unAssign$1$1 = "Liberar";
var unAssignTechnician$1$1 = "Liberar técnico";
var unAssignTechnicianModalText$1$1 = "¿Estás seguro que deseas liberar el técnico?";
var unAssignTechnicianModalAditionalText$1$1 = "Al hacerlo, el servicio pasará a estado Aceptado proveedor y podrás asignar un técnico nuevo.";
var unAssignDriver$1$1 = "Liberar conductor";
var unAssignDriverModalText$1$1 = "¿Estás seguro que deseas liberar el conductor?";
var unAssignDriverModalAditionalText$1$1 = "Al hacerlo, el servicio pasará a estado Aceptado proveedor y podrás asignar un conductor nuevo.";
var unavailable$1$1 = "No disponible";
var units$1$1 = "Unidades";
var unitAbbrev$1$1 = "ud.";
var unitsAbbrev$1$1 = "uds.";
var unselected$1$1 = "Sin selección";
var unsubscribe$1$1 = "Anular suscripción";
var urban$1$1 = "Local";
var urbanFee$1$1 = "Local";
var urbanService$1$1 = "Servicio local";
var user$1$1 = "Usuario";
var userProfiles$1$1 = "Perfiles de usuario";
var userProfilesWithCount$1$1 = "{{count}} Perfil de usuario";
var userProfilesWithCount_plural$1$1 = "{{count}} Perfiles de usuario";
var users$1$1 = "Usuarios";
var userType$1$1 = "Tipo de usuario";
var V$1$1 = "V";
var validFrom$1$1 = "Válido desde";
var validUntil$1$1 = "Válido hasta";
var variable$1$1 = "Variable";
var vehicleAssistance$1$1 = "Asistencia de vehículos";
var vehicleTypes$1$1 = "Tipo de vehículos";
var version$1$1 = "Versión";
var vial$1$1 = "Vial";
var vials$1$1 = "Viales";
var vialRates$1$1 = "Tarifas viales";
var vialServices$1$1 = "Servicios viales";
var vialSettings$1$1 = "Ajustes de viales";
var view$1$1 = "Vista";
var viewAssistedRating$1$1 = "Ver valoración del asistido";
var viewContact$1$1 = "Ver contacto";
var viewContactandComment$1$1 = "Ver contacto y comentario";
var viewRoute$1$1 = "Ver ruta";
var views$1$1 = "Vistas";
var vin$1$1 = "VIN";
var virtualSwitchboard$1$1 = "Centralita virtual";
var W$1$1 = "W";
var waitingList$1$1 = "Lista de espera";
var web$1$1 = "Web";
var webAddress$1$1 = "Dirección web";
var wholeWordSearch$1$1 = "Búsqueda de palabras completas";
var wholeWordSearch3Charts$1$1 = "Busca palabras completas (min 3 carac.)";
var withAlert$1$1 = "Con alerta";
var withholdings$1$1 = "Retenciones";
var withPriority1$1$1 = "Con prioridad 1";
var withPriority2$1$1 = "Con prioridad 2";
var withPriority3$1$1 = "Con prioridad 3";
var writeANote$1$1 = "Escribir una nota";
var wrongUser$1$1 = "Usuario incorrecto";
var wrongUsernameOrPassword$1$1 = "Usuario o contraseña incorrectos";
var X$1$1 = "X";
var Y$1$1 = "Y";
var year$1$1 = "Año";
var yes$1$1 = "Sí";
var yesterday$1$1 = "Ayer";
var youHaveExceededTheNumberOfAtempsts$1$1 = "Has excedido el número de intentos";
var Z$1$1 = "Z";
var maxMinutes$1$1 = "Minutos max.";
var maxPhotos$1$1 = "Fotos max.";
var between0And5Minutes$1$1 = "Entre 0 y 5 minutos";
var between0And10Minutes$1$1 = "Entre 0 y 10 minutos";
var between0And240Minutes$1$1 = "Entre 0 y 240 minutos";
var between1And7Minutes$1$1 = "Entre 1 y 7 minutos";
var between2And5Minutes$1$1 = "Entre 2 y 5 minutos";
var between2And10Minutes$1$1 = "Entre 2 y 10 minutos";
var between0And10Photos$1$1 = "Entre 0 y 10 fotos";
var between1And10Characters$1$1 = "Entre 1 y 10 caracteres";
var between0And120Minutes$1$1 = "Entre 0 y 120 minutos";
var ACCEPTED$1$1 = "Aceptado";
var add_company_description$1$1 = "Completa los datos de la compañía a dar de alta, indicando si se trata de un cliente o de un proveedor.";
var add_company$1$1 = "Añadir compañía";
var addChartText$1$1 = "Pulsa el botón de añadir para incorporar gráficos al Business Intelligence.";
var addChartTitle$1$1 = "Añadir gráfico";
var all_female$1$1 = "Todas";
var all_male$1$1 = "Todos";
var amount$1$1 = "Importe";
var apply$1$1 = "Aplicar";
var assignProvider$1$1 = "Asignar proveedor";
var assignedToMe$1$1 = "Asignados a mí";
var assignItToMe$1$1 = "Asignármelo";
var AVAILABLE$1$1 = "Disponible";
var blocked$1$1 = "Bloqueado";
var budgetToastSuccessText$1$1 = "El servicio se ha añadido al listado.";
var budgetToastSuccessTitle$1$1 = "Presupuesto aceptado";
var scheduledBudgetToastSuccessText$1$1 = "El servicio programado se ha añadido al listado.";
var scheduledBudgetToastSuccessTitle$1$1 = "Presupuesto aceptado";
var transferPeopleBudgetToastSuccessText$1$1 = "El traslado se ha añadido al listado.";
var transferPeopleBudgetToastSuccessTitle$1$1 = "Presupuesto aceptado";
var budgetToastSuccessQueueText$1$1 = "El servicio ha sido añadido a la lista de espera.";
var budgetToastSuccessQueueTitle$1$1 = "Operación realizada con éxito";
var bussy$1$1 = "ocupado";
var CANCELED$1$1 = "Anulado";
var centerNum$1$1 = "Nº Centros";
var centers$1$1 = "Centros";
var closed$1$1 = "Cerrado";
var codeAlreadyAssigned$1$1 = "Código ya asignado";
var color$1$1 = "Color";
var companyPendingDocumentation$1$1 = "Pendiente documentación compañía";
var companyProviderCode$1$1 = "Nuevo ID";
var COMPLETED$1$1 = "Completado";
var custodyRate$1$1 = "Precio día extra";
var damageReport$1$1 = "Parte de daños";
var damageRequired$1$1 = "Parte obligatorio";
var day$1$1 = "Día";
var days$1$1 = "Días";
var del$1$1 = "Eliminar";
var delivery$1$1 = "Entrega";
var deliveryAddressRequired$1$1 = "Dirección de entrega obligatoria";
var destination$1$1 = "Destino";
var documents$1$1 = "Documentos";
var exit$1$1 = "Salir";
var expired$1$1 = "Caducado";
var EXTRA_CHARGES$1$1 = "GASTOS EXTRA";
var extraCharges$1$1 = "Gastos";
var festive$1$1 = "Festivo";
var fieldsRequired$1$1 = "Los campos con (*) son obligatorios.";
var files$1$1 = "Archivos";
var filters$1$1 = "Filtros";
var FINISHED$1$1 = "Finalizado";
var free$1$1 = "libre";
var from$1$1 = "De";
var fromDate$1$1 = "Desde";
var generalInfo$1$1 = "Inf. General";
var groupName$1$1 = "Nombre de la compañía";
var id$1$1 = "Id";
var IN_SERVICE$1$1 = "En servicio";
var information$1$1 = "Información";
var INRIS$1$1 = "En reparación";
var integrated$1$1 = "Integrado";
var invite$1$1 = "Invitar";
var invoiceDate$1$1 = "Fecha fact.";
var lastAct$1$1 = "Última act.";
var left$1$1 = "Quedan";
var LOADED$1$1 = "Cargado";
var LOCATED$1$1 = "Localizado";
var locations$1$1 = "Localizaciones";
var mediums$1$1 = "Medios";
var MEDIUMS$1$1 = "MEDIOS";
var modify$1$1 = "Modificar";
var newRates$1$1 = "Nuevas tarifas";
var nexus$1$1 = "Nexus";
var nexusFee$1$1 = "Fee Nexus";
var nFilecase$1$1 = "Nº Expediente";
var nFilecaseAbbrev$1$1 = "Nº Exp.";
var nickName$1$1 = "Nick";
var nightlyEnd$1$1 = "Fin horario noct.";
var nightlyStart$1$1 = "Inicio horario noct.";
var nightly$1$1 = "Nocturno";
var nigthly$1$1 = "Nocturno";
var nightlyFestive$1$1 = "Festivo nocturno";
var nInvoice$1$1 = "Nº Factura";
var nInvoices$1$1 = "Nº Facturas";
var none$1$1 = "Ninguno";
var NOT_IN_NEXUS$1$1 = "Fuera de Nexus";
var not$1$1 = "No";
var nNexus$1$1 = "Nº Nexus";
var nPayments$1$1 = "Nº Pagos";
var nServices$1$1 = "Nº Servicios";
var numberOfInvoices$1$1 = "Número de facturas";
var of$1$1 = "de";
var open$1$1 = "Abierto";
var outOfService$1$1 = "fuera de servicio";
var ownFilecaseNumber$1$1 = "Nº expediente propio";
var ownFilecaseNumberAbbrev$1$1 = "Nº expediente";
var partialPrice$1$1 = "Precio parcial";
var participants$1$1 = "Participantes";
var participation$1$1 = "Participación";
var payed$1$1 = "Pagada";
var payments$1$1 = "Pagos";
var pendingAbbrev$1$1 = "Pdte.";
var photosNumber$1$1 = "Nº de fotos";
var pickup$1$1 = "Recogida";
var pickupAddress$1$1 = "Lugar recogida";
var pictures$1$1 = "Fotos";
var processDate$1$1 = "Fecha de procesamiento";
var processed$1$1 = "Procesado";
var providerAlreadyMapped$1$1 = "Proveedor ya mapeado";
var REJECTED$1$1 = "Rechazado";
var rejection$1$1 = "Rechazados";
var request$1$1 = "Solicitar";
var requester$1$1 = "Solicitante";
var resource$1$1 = "Recurso";
var resourceActivity$1$1 = "Recursos";
var resourceDistance$1$1 = "Está a";
var resourceRoute$1$1 = "Recorrido";
var resourceTime$1$1 = "Llega en";
var responsable$1$1 = "Responsable";
var responseNumberAbbrev$1$1 = "Nº respuestas";
var RISEND$1$1 = "Fin RIS";
var RISSTART$1$1 = "Inicio RIS";
var rowsPerPage$1$1 = "Filas por página";
var saveView$1$1 = "Guardar vista";
var sendSMSTracking$1$1 = "Enviar SMS seguimiento";
var sendSurvey$1$1 = "Enviar encuesta";
var serviceActivity$1$1 = "Servicios";
var serviceBudget$1$1 = "Propuesta de servicio";
var serviceRequest$1$1 = "Solicitud de servicio";
var serviceType$1$1 = "Tipo servicio";
var shared$1$1 = "Compartido";
var shipmentDate$1$1 = "Fecha remesa";
var sign$1$1 = "Firmas";
var sta$1$1 = "Es.";
var STARTED$1$1 = "Iniciado";
var supportTeamAbbrev$1$1 = "Equipo Sop.";
var surchargeRate$1$1 = "% Recargo noct.";
var surname$1$1 = "Apellidos";
var teamMembers$1$1 = "Miembros del equipo";
var teamTickets$1$1 = "Los del equipo";
var totalPrice$1$1 = "Precio total";
var UNAVAILABLE$1$1 = "No disponible";
var userProfile$1$1 = "Perfil";
var validate$1$1 = "Validar";
var validated$1$1 = "validado";
var vehicle$1$1 = "Vehículo";
var weekend$1$1 = "Fin de semana";
var category$1$1 = {
  car: "Coche",
  ind: "Industrial",
  moto: "Moto",
  ptf: "Plataforma"
};
var collective2$1$1 = {
  toastColectiveDeactivateErrorTitle: "ERROR",
  toastColectiveDeactivateErrorTextDefault: "En estos momentos no es posible desactivar el colectivo. Por favor, vuelve a intentarlo en unos minutos."
};
var companyList$1$1 = {
  companyWithCount: "{{count}} Companía",
  companyWithCount_plural: "{{count}} Companías"
};
var depositList$1$1 = {
  depositWithCount: "{{count}} Depósito",
  depositWithCount_plural: "{{count}} Depósitos"
};
var format$1$1 = {
  currency: "€ ",
  decimalSeparator: ",",
  thousandSeparator: "."
};
var invoiceList$1$1 = {
  invoiceWithCount: "{{count}} Factura",
  invoiceWithCount_plural: "{{count}} Facturas"
};
var mediumList$1$1 = {
  mediumWithCount: "{{count}} Medio",
  mediumWithCount_plural: "{{count}} Medios"
};
var mediumTypesList$1$1 = {
  mediumTypesWithCount: "{{count}} Tipo de medio",
  mediumTypesWithCount_plural: "{{count}} Tipos de medios"
};
var modals$1$1 = {
  addService: {
    linkServices: "Vincular servicios",
    linkServicesInfo: "El último servicio Nexus de este vehículo indica que está en un depósito.",
    linkServicesQuestion: "¿Deseas asociar el expediente Nexus y vincular los servicios?"
  },
  budget: {
    timeOut: "Tiempo agotado",
    timeOutInfo: "Se ha agotado el tiempo máximo para aceptar la propuesta. Inténtalo de nuevo."
  },
  ticketDetail: {
    closeTicket: "Cerrar ticket",
    closeTicketQuestion: "¿Estás seguro que deseas cerrar el ticket? Si lo cierras, se dará por resuelto y no podrás enviar más mensajes."
  }
};
var operationTypesList$1$1 = {
  operationTypesWithCount: "{{count}} Tipo de intervención",
  operationTypesWithCount_plural: "{{count}} Tipos de intervención"
};
var paymentList$1$1 = {
  paymentWithCount: "{{count}} Pago a proveedores",
  paymentWithCount_plural: "{{count}} Pagos a proveedores",
  processPaymentTitle: "Procesar pagos",
  processPaymentText: "Indica la fecha en la que el fichero ha sido procesado por el banco.",
  generatePaymentsTitle: "Generar pagos",
  generatePaymentsText: "Se van a generar todos los pagos hasta la fecha indicada. El fichero N34-14 se enviará por email.",
  toastGeneratePaymentsSuccessTitle: "Pago generado correctamente",
  toastGeneratePaymentsSuccessText: "El pago se ha generado y se ha enviado el fichero.",
  toastProcessPaymentSuccessTitle: "Pago procesado correctamente",
  toastProcessPaymentSuccessText: "El pago se ha procesado con la fecha indicada.",
  toastGeneratePaymentsWarningTitle: "No ha podido generarse",
  toastGeneratePaymentsWarningText: "No hay facturas pendientes hasta esa fecha."
};
var searchTools$1$1 = {
  title: "Herramientas de búsqueda",
  byRoadKmTitle: "Busca por carretera y kilómetro",
  byRoadKm_1: "1. Introduce el nombre de la carretera y el punto kilométrico. Ejemplo: E-15/15",
  byRoadKm_2: "2. Pulsa \"Validar\" para validar la ubicación",
  roadKilometer: "Carretera / Kilómetro",
  byCoordsTitle: "Busca por coordenadas",
  byCoords_1: "Pulsa el botón del mapa y localiza la ubicación que necesitas.",
  byCoords_2: "Pulsa el botón derecho y copia las coordenadas que te ofrece Google.",
  byCoords_3: "Pégalas debajo y pulsa \"Validar\" para validar la ubicación.",
  coordsLatitudeLongitude: "Coordenadas (latitud, longitud)"
};
var serviceList$1$1 = {
  serviceWithCount: "{{count}} Servicio",
  serviceWithCount_plural: "{{count}} Servicios"
};
var servicesError$1$1 = {
  cancelServiceErrorTitle: "Error al solicitar la anulación",
  notCancelableService: "El servicio no se puede anular en su estado actual.",
  invalidService: "No ha sido posible solicitar la anulación del servicio.",
  cancelServiceUnknownError: "En estos momentos no es posible solicitar la anulación del servicio. Vuelva a intentarlo en unos minutos.",
  openDisputeErrorTitle: "Error al solicitar apertura de disputa",
  openDisputeUnknownError: "En estos momentos no es posible abrir una disputa para el servicio. Vuelva a intentarlo en unos minutos.",
  closeDisputeErrorTitle: "Error al solicitar cierre de disputa",
  closeDisputeUnknownError: "En estos momentos no es posible cerrar la disputa del servicio. Vuelva a intentarlo en unos minutos."
};
var transferPeopleError$1$1 = {
  cancelTransferPeopleErrorTitle: "Error al solicitar la anulación",
  notCancelableService: "El traslado no se puede anular en su estado actual.",
  invalidTransferPeople: "No ha sido posible solicitar la anulación del traslado.",
  cancelServiceUnknownError: "En estos momentos no es posible solicitar la anulación del traslado. Vuelva a intentarlo en unos minutos."
};
var transferPeopleList$1$1 = {
  transferPeopleWithCount: "{{count}} Traslado",
  transferPeopleWithCount_plural: "{{count}} Traslados"
};
var shipment$1$1 = {
  collecting: "Interrumpida",
  pending: "Generada",
  billed: "Facturada",
  collected: "Cobrada",
  payed: "Pagada"
};
var ticketDetail$1$1 = {
  toastSendMessageSuccessTitle: "Mensaje enviado correctamente",
  toastSendMessageSuccessText: "El mensaje ha sido enviado y añadido a la lista.",
  toastSendMessageErrorTitle: "Error al enviar mensaje",
  toastSendMessageErrorText: "Ha ocurrido un error en el envío del mensaje.",
  toastCloseMessageSuccessTitle: "Ticket cerrado correctamente",
  toastCloseMessageSuccessText: "El ticket ha sido cerrado y actualizado en la lista.",
  toastCloseMessageErrorTitle: "Error al cerrar ticket",
  toastCloseMessageErrorText: "Ha ocurrido un error al cerrar el ticket."
};
var ticketList$1$1 = {
  ticketWithCount: "{{count}} Ticket",
  ticketWithCount_plural: "{{count}} Tickets"
};
var user2$1$1 = {
  toastUserDeactivateErrorTitle: "ERROR",
  toastUserDeactivateErrorTextDefault: "En estos momentos no es posible desactivar al usuario. Por favor, vuelve a intentarlo en unos minutos.",
  toastUserDeactivateErrorText: "El usuario activo no puede desactivarse a sí mismo.",
  toastUserInServiceDeactivateErrorText: "No es posible desactivar a un usuario que se encuentra actualmente realizando un servicio.",
  toastUserNotificationSuccessTitle: "Notificación enviada",
  toastUserNotificationSuccessText: "Hemos enviado una notificación al usuario con las instrucciones.",
  toastUserNotificationErrorTitle: "Ha ocurrido un error",
  toastUserNotificationErrorText: "No hemos podido enviar la notificación al usuario."
};
var userList$1$1 = {
  userWithCount: "{{count}} Usuario",
  userWithCount_plural: "{{count}} Usuarios"
};
var validation$1$1 = {
  fieldRequired: "Campo obligatorio",
  invalidCurrencyAmount: "No válido",
  invalidTimeFormat: "Formato de hora no válido"
};
var loginYourAccount$1$1 = "Accede a tu cuenta";
var checkYourEmail$1$1 = "Comprueba tu correo";
var updatedUser$1$1 = "Usuario actualizado";
var errorCreatingCompany$1$1 = "Error al crear compañía";
var min$1$1 = "min";
var distance$1$1 = "Distancia";
var es$2$1 = {
  "********** BEGIN CHECKED WORDS **********": "**********",
  "% IRPF": "% IRPF",
  "% IVA": "% IVA",
  IRPF: IRPF$1$1,
  IVA: IVA$1$1,
  NIF: NIF$1$1,
  "NIF/CIF": "NIF/CIF",
  "NIF/SS": "NIF/SS",
  "NIF/CIF/SS": "NIF/CIF/SS",
  "#": "#",
  "1st": "1º",
  "2nd": "2º",
  "3rd": "3º",
  "4th": "4º",
  "5th": "5º",
  "6th": "6º",
  "7th": "7º",
  "8th": "8º",
  "9th": "9º",
  "10th": "10º",
  betweenMinAndMaxKilometers: betweenMinAndMaxKilometers$1$1,
  metricUnits: metricUnits$1$1,
  imperialUnits: imperialUnits$1$1,
  A: A$2$1,
  accept: accept$1$1,
  accepted: accepted$1$1,
  acceptUpdate: acceptUpdate$1$1,
  accessToTheViews: accessToTheViews$1$1,
  accessWithMicrosoft: accessWithMicrosoft$1$1,
  activateGuardMode: activateGuardMode$1$1,
  activateGuardModeWarningText: activateGuardModeWarningText$1$1,
  activateGuardModeWarningAditionalText: activateGuardModeWarningAditionalText$1$1,
  active: active$1$1,
  activity: activity$1$1,
  accumulateNightAndHolidaySurcharge: accumulateNightAndHolidaySurcharge$1$1,
  add: add$1$1,
  addAuxService: addAuxService$1$1,
  addCapability: addCapability$1$1,
  addCollective: addCollective$1$1,
  addCost: addCost$1$1,
  addCostType: addCostType$1$1,
  addedCollective: addedCollective$1$1,
  addFault: addFault$1$1,
  addedFault: addedFault$1$1,
  additionalInformation: additionalInformation$1$1,
  additionalPrice: additionalPrice$1$1,
  additionalPriceAbbrev: additionalPriceAbbrev$1$1,
  addNote: addNote$1$1,
  address: address$1$1,
  addressNotLocated: addressNotLocated$1$1,
  addUserProfile: addUserProfile$1$1,
  admin: admin$1$1,
  advancedConfiguration: advancedConfiguration$1$1,
  aheadServices: aheadServices$1$1,
  alert: alert$1$1,
  alerts: alerts$1$1,
  alertStart: alertStart$1$1,
  all_f: all_f$1$1,
  all_m: all_m$1$1,
  allowAccess: allowAccess$1$1,
  allowCalls: allowCalls$1$1,
  allowCalls_addService: allowCalls_addService$1$1,
  allowGuardErrorTitle: allowGuardErrorTitle$1$1,
  allowGuardErrorText: allowGuardErrorText$1$1,
  allowSMS: allowSMS$1$1,
  allProvidersAutomatic: allProvidersAutomatic$1$1,
  anErrorHasOccurred: anErrorHasOccurred$1$1,
  applyCosts: applyCosts$1$1,
  approve: approve$1$1,
  assign: assign$1$1,
  "assignment/lastActivityAbbrev": "Asig / ult. ac",
  assignTechnician: assignTechnician$1$1,
  assistance: assistance$1$1,
  assistanceWithoutTransfer: assistanceWithoutTransfer$1$1,
  assistanceWithoutTransferWarning: assistanceWithoutTransferWarning$1$1,
  assistanceWithoutTransferWarningQuestion: assistanceWithoutTransferWarningQuestion$1$1,
  assisted: assisted$1$1,
  assistedInsuredAbbrev: assistedInsuredAbbrev$1$1,
  assistedDestinationAddress: assistedDestinationAddress$1$1,
  associatedDocuments: associatedDocuments$1$1,
  at_time: at_time$1$1,
  assigned: assigned$1$1,
  ASSIGNED: ASSIGNED$1$1,
  attachADocument: attachADocument$1$1,
  "attach the following documents": "Adjunta los siguientes documentos",
  attachment: attachment$1$1,
  attachments: attachments$1$1,
  auction: auction$1$1,
  auctionConfiguration: auctionConfiguration$1$1,
  auctioned: auctioned$1$1,
  AUCTIONED: AUCTIONED$1$1,
  auctioning: auctioning$1$1,
  AUCTIONING: AUCTIONING$1$1,
  auctionInPriority: auctionInPriority$1$1,
  auctionInPriority1: auctionInPriority1$1$1,
  auctionInPriority2: auctionInPriority2$1$1,
  auctionInPriority3: auctionInPriority3$1$1,
  auctionInPriority4: auctionInPriority4$1$1,
  auctions: auctions$1$1,
  auctionService: auctionService$1$1,
  auto: auto$1$1,
  automatic: automatic$1$1,
  automaticProvider: automaticProvider$1$1,
  auxiliary: auxiliary$1$1,
  auxiliarySettings: auxiliarySettings$1$1,
  auxiliaries: auxiliaries$1$1,
  auxiliariesRates: auxiliariesRates$1$1,
  auxServiceList: auxServiceList$1$1,
  auxService: auxService$1$1,
  auxServices: auxServices$1$1,
  available: available$1$1,
  available_plural: available_plural$1$1,
  availableProvidersAbbrev: availableProvidersAbbrev$1$1,
  availableResources: availableResources$1$1,
  availableResourcesWithCount: availableResourcesWithCount$1$1,
  availableResourcesWithCount_plural: availableResourcesWithCount_plural$1$1,
  average: average$1$1,
  averageRating: averageRating$1$1,
  B: B$1$1,
  base: base$1$1,
  baseAmount: baseAmount$1$1,
  billed: billed$1$1,
  billing: billing$1$1,
  brand: brand$1$1,
  browse: browse$1$1,
  budgetWarningNoBaseFound: budgetWarningNoBaseFound$1$1,
  businessIntelligence: businessIntelligence$1$1,
  byAmount: byAmount$1$1,
  byBrand: byBrand$1$1,
  byPositionOnQueue: byPositionOnQueue$1$1,
  byScore: byScore$1$1,
  byTime: byTime$1$1,
  C: C$1$1,
  calculateAllServicesAsSuburban: calculateAllServicesAsSuburban$1$1,
  calendar: calendar$1$1,
  cancel: cancel$1$1,
  cancel_2: cancel_2$1$1,
  outputCancellationPercentageAbbrev: outputCancellationPercentageAbbrev$1$1,
  cancelAmount: cancelAmount$1$1,
  cancelRatePercentage: cancelRatePercentage$1$1,
  cancelRateAmount: cancelRateAmount$1$1,
  cancelReason: cancelReason$1$1,
  cancelService: cancelService$1$1,
  cancelTransferPeople: cancelTransferPeople$1$1,
  cancelTransferPeopleWarning: cancelTransferPeopleWarning$1$1,
  "Cannot send service to this provider because it has not defined any deposit (base)": "No se puede enviar el servicio a este proveedor porque no ha definido ningún depósito (base)",
  capabilityList: capabilityList$1$1,
  capability: capability$1$1,
  capabilityCollectiveAbbrev: capabilityCollectiveAbbrev$1$1,
  capabilities: capabilities$1$1,
  center: center$1$1,
  centerName: centerName$1$1,
  centerNotFound: centerNotFound$1$1,
  change: change$1$1,
  changePassword: changePassword$1$1,
  charge: charge$1$1,
  chargeWithCount: chargeWithCount$1$1,
  chargeWithCount_plural: chargeWithCount_plural$1$1,
  check: check$1$1,
  childProfile: childProfile$1$1,
  chosenDriver: chosenDriver$1$1,
  cif: cif$1$1,
  city: city$1$1,
  "class": "Clase",
  clone: clone$1$1,
  cloneService: cloneService$1$1,
  close: close$1$1,
  closeDispute: closeDispute$1$1,
  code: code$1$1,
  collectDate: collectDate$1$1,
  collected: collected$1$1,
  collectInvoice: collectInvoice$1$1,
  collective: collective$1$1,
  collectives: collectives$1$1,
  collectiveWithCount: collectiveWithCount$1$1,
  collectiveWithCount_plural: collectiveWithCount_plural$1$1,
  collectiveProviderAbbrev: collectiveProviderAbbrev$1$1,
  comment: comment$1$1,
  commentAboutCapability: commentAboutCapability$1$1,
  companies: companies$1$1,
  "companies-opt": {
    listWithCount: "{{count}} Compañía",
    listWithCount_plural: "{{count}} Compañías"
  },
  company: company$1$1,
  companyName: companyName$1$1,
  companyProfile: companyProfile$1$1,
  completed: completed$1$1,
  configuration: configuration$1$1,
  consultList: consultList$1$1,
  "continue": "Continuar",
  costName: costName$1$1,
  costs: costs$1$1,
  costSearch: costSearch$1$1,
  costsWithCount: costsWithCount$1$1,
  costsWithCount_plural: costsWithCount_plural$1$1,
  costSheets: costSheets$1$1,
  costSheetStatus: costSheetStatus$1$1,
  costType: costType$1$1,
  costTypeName: costTypeName$1$1,
  costTypes: costTypes$1$1,
  costTypesWithCount: costTypesWithCount$1$1,
  costTypesWithCount_plural: costTypesWithCount_plural$1$1,
  craneService: craneService$1$1,
  create: create$1$1,
  currentPassword: currentPassword$1$1,
  custodyDays: custodyDays$1$1,
  customer: customer$1$1,
  "customer/capability": "Cliente / prestación",
  "customer/exp": "Cliente / Exp.",
  D: D$1$1,
  dashboard: dashboard$1$1,
  date: date$1$1,
  "Date scheduled service": "Fecha servicio programado",
  dateRangeExceeded: dateRangeExceeded$1$1,
  dayAndTime: dayAndTime$1$1,
  deadLine: deadLine$1$1,
  concessionaire: concessionaire$1$1,
  deferred: deferred$1$1,
  deferredService: deferredService$1$1,
  deferredShort: deferredShort$1$1,
  deferredShorter: deferredShorter$1$1,
  deleteCost: deleteCost$1$1,
  deletePath: deletePath$1$1,
  deleteRequest: deleteRequest$1$1,
  deposits: deposits$1$1,
  description: description$1$1,
  detail: detail$1$1,
  disconnect: disconnect$1$1,
  disputeReason: disputeReason$1$1,
  documentation: documentation$1$1,
  documentationProfile: documentationProfile$1$1,
  documentNumberAbbrev: documentNumberAbbrev$1$1,
  documentProfile: documentProfile$1$1,
  documentProfiles: documentProfiles$1$1,
  "documentProfiles-opt": {
    listWithCount: "{{count}} Perfil de documento",
    listWithCount_plural: "{{count}} Perfiles de documentos"
  },
  "documents-status": {
    pending: "Pendiente de verificación",
    validated: "Válido",
    rejected: "Rechazado el",
    rejectReason: "Motivo de rechazo",
    expired: "Caducó el",
    current: "Vigente hasta el"
  },
  documentAdded: documentAdded$1$1,
  documentType: documentType$1$1,
  documentTypes: documentTypes$1$1,
  "documentTypes-opt": {
    listWithCount: "{{count}} Tipo de documento",
    listWithCount_plural: "{{count}} Tipos de documentos"
  },
  doNotAssociate: doNotAssociate$1$1,
  dragData: dragData$1$1,
  driver: driver$1$1,
  drivers: drivers$1$1,
  "driver/medium": "Conductor / Medio",
  duplicate: duplicate$1$1,
  duplicateService: duplicateService$1$1,
  E: E$1$1,
  edit: edit$1$1,
  editAuxService: editAuxService$1$1,
  editCapability: editCapability$1$1,
  editCollective: editCollective$1$1,
  editCost: editCost$1$1,
  editCostType: editCostType$1$1,
  editFault: editFault$1$1,
  editSupportTeam: editSupportTeam$1$1,
  editUserProfile: editUserProfile$1$1,
  email: email$1$1,
  endService: endService$1$1,
  entry: entry$1$1,
  entryDateAbbrev: entryDateAbbrev$1$1,
  error: error$1$1,
  errorAddingDocument: errorAddingDocument$1$1,
  estimatedTime: estimatedTime$1$1,
  execution: execution$1$1,
  executionProfile: executionProfile$1$1,
  expense: expense$1$1,
  expiredCode: expiredCode$1$1,
  expires: expires$1$1,
  events: events$1$1,
  excessOfTimeForOutService: excessOfTimeForOutService$1$1,
  excessOfTimeForUrbanService: excessOfTimeForUrbanService$1$1,
  excessOfTimeInCurrentStatus: excessOfTimeInCurrentStatus$1$1,
  excessOfTimeToCompleteService: excessOfTimeToCompleteService$1$1,
  excessOfTimeToStartScheduledService: excessOfTimeToStartScheduledService$1$1,
  F: F$1$1,
  fault: fault$1$1,
  faults: faults$1$1,
  faultCollectiveAbbrev: faultCollectiveAbbrev$1$1,
  faultWithCount: faultWithCount$1$1,
  faultWithCount_plural: faultWithCount_plural$1$1,
  fee: fee$1$1,
  fieldRequired: fieldRequired$1$1,
  "fields with an asterisk are required": "Los campos con (*) son obligatorios.",
  file: file$1$1,
  "filecase/assistedAbbrev": "Exp. / asistido",
  "filecase/interventionAbbrev": "Exp./Int.",
  filterByDriverStatus: filterByDriverStatus$1$1,
  filterByVehicleType: filterByVehicleType$1$1,
  financial: financial$1$1,
  financialBreakdown: financialBreakdown$1$1,
  finish: finish$1$1,
  finishedServices: finishedServices$1$1,
  firstPrice: firstPrice$1$1,
  firstUnitPriceAbbrev: firstUnitPriceAbbrev$1$1,
  fixed: fixed$1$1,
  "for": "Para",
  "forgotPassword?": "¿Olvidaste la contraseña?",
  formError: formError$1$1,
  franchise: franchise$1$1,
  franchises: franchises$1$1,
  freeCranesBefore1Hour: freeCranesBefore1Hour$1$1,
  fromUntil: fromUntil$1$1,
  fullAddress: fullAddress$1$1,
  fullScreenAbbrev: fullScreenAbbrev$1$1,
  G: G$1$1,
  generalInformationAbbrev: generalInformationAbbrev$1$1,
  generate: generate$1$1,
  generated: generated$1$1,
  geofence: geofence$1$1,
  geofence_plural: geofence_plural$1$1,
  geofenceWithCount: geofenceWithCount$1$1,
  geofenceWithCount_plural: geofenceWithCount_plural$1$1,
  geoJson: geoJson$1$1,
  globalAuction: globalAuction$1$1,
  graceDays: graceDays$1$1,
  grecaptchaNote: grecaptchaNote$1$1,
  guardMode: guardMode$1$1,
  H: H$1$1,
  help: help$1$1,
  hide: hide$1$1,
  holder: holder$1$1,
  holidays: holidays$1$1,
  home: home$1$1,
  hour: hour$1$1,
  hours: hours$1$1,
  I: I$1$1,
  IBAN: IBAN$1$1,
  icon: icon$1$1,
  iconUrl: iconUrl$1$1,
  identificationIcon: identificationIcon$1$1,
  "If you finish the service you will no longer be able to edit or reschedule it Do you wish to continue?": "Si finalizas el servicio, ya no podrás editarlo o reprogramarlo. ¿Deseas continuar?",
  "If you recover the saved request you will lose the data you have entered in the form do you wish to continue?": "Si recuperas la solicitud guardada, perderás los datos que has introducido en el formulario, ¿deseas continuar?",
  "If you delete the request the saved data will be deleted Do you wish to continue?": "Si eliminas la solicitud, se borrarán los datos guardados, ¿deseas continuar?",
  "If you prefer, you can send the service to a waiting list": "Si lo prefieres, puedes enviar el servicio a una lista de espera",
  image: image$1$1,
  immediate: immediate$1$1,
  immediate_plural: immediate_plural$1$1,
  immediateService: immediateService$1$1,
  "import": "Importar",
  incorrectLocationFormat: incorrectLocationFormat$1$1,
  infoWindowIcon: infoWindowIcon$1$1,
  inParking: inParking$1$1,
  inRis: inRis$1$1,
  inris: inris$1$1,
  inServiceResourcesWithCount: inServiceResourcesWithCount$1$1,
  inServiceResourcesWithCount_plural: inServiceResourcesWithCount_plural$1$1,
  instant: instant$1$1,
  insurancePolicyInfo: insurancePolicyInfo$1$1,
  insured: insured$1$1,
  insured_autoType: insured_autoType$1$1,
  insured_homeType: insured_homeType$1$1,
  insuredAutoType: insuredAutoType$1$1,
  insuredHomeType: insuredHomeType$1$1,
  insuredObjectAbbrev: insuredObjectAbbrev$1$1,
  insuredProperty: insuredProperty$1$1,
  integrationProfile: integrationProfile$1$1,
  integrationProfileAbbrev: integrationProfileAbbrev$1$1,
  internalCode: internalCode$1$1,
  internalNote: internalNote$1$1,
  internalNotes: internalNotes$1$1,
  interrupted: interrupted$1$1,
  intervention: intervention$1$1,
  interventionAbbrev: interventionAbbrev$1$1,
  interventions: interventions$1$1,
  inUrbanArea: inUrbanArea$1$1,
  invalidNexusFilecase: invalidNexusFilecase$1$1,
  invalidText: invalidText$1$1,
  invoice: invoice$1$1,
  "invoice (services - base)": "Factura (servicios - base)",
  "invoice-status": {
    pending: "Pendiente",
    billed: "Facturada",
    collected: "Cobrada",
    payed: "Pagada"
  },
  invoiceNumberAbbrev: invoiceNumberAbbrev$1$1,
  forTheDay: forTheDay$1$1,
  isNotValid: isNotValid$1$1,
  issuedInvoices: issuedInvoices$1$1,
  itAlreadyExists: itAlreadyExists$1$1,
  J: J$1$1,
  K: K$1$1,
  L: L$1$1,
  label: label$1$1,
  labeled: labeled$1$1,
  "labeled-opt": {
    listWithCount: "{{count}} Rotulación",
    listWithCount_plural: "{{count}} Rotulaciones"
  },
  labels: labels$1$1,
  lastActivity: lastActivity$1$1,
  lastActivity2: lastActivity2$1$1,
  legal: legal$1$1,
  legalId: legalId$1$1,
  list: list$1$1,
  listEntryMax24H: listEntryMax24H$1$1,
  loaded: loaded$1$1,
  loadTimeInMinutes: loadTimeInMinutes$1$1,
  located: located$1$1,
  location: location$1$1,
  locked: locked$1$1,
  lockedByNexus: lockedByNexus$1$1,
  login: login$1$1,
  logo: logo$1$1,
  logout: logout$1$1,
  M: M$1$1,
  managed: managed$1$1,
  managedProvider: managedProvider$1$1,
  manual: manual$1$1,
  manualProvider: manualProvider$1$1,
  map: map$1$1,
  mapIcon: mapIcon$1$1,
  mapOfGoingServices: mapOfGoingServices$1$1,
  mapOfResources: mapOfResources$1$1,
  mapOfTracking: mapOfTracking$1$1,
  mapView: mapView$1$1,
  max: max$1$1,
  maxAllowedTimeInMinutes: maxAllowedTimeInMinutes$1$1,
  maxDistance: maxDistance$1$1,
  maxDistanceToCrane: maxDistanceToCrane$1$1,
  maxHours: maxHours$1$1,
  maxRadius: maxRadius$1$1,
  maxTime: maxTime$1$1,
  maxTimeOnList: maxTimeOnList$1$1,
  medium: medium$1$1,
  mediumNotFound: mediumNotFound$1$1,
  mediumType: mediumType$1$1,
  mediumTypes: mediumTypes$1$1,
  mediumTypes2: mediumTypes2$1$1,
  "mediumTypes-opt": {
    listWithCount: "{{count}} Tipo de medio",
    listWithCount_plural: "{{count}} Tipos de medios"
  },
  minute: minute$1$1,
  minutes: minutes$1$1,
  modeAndName: modeAndName$1$1,
  model: model$1$1,
  modifiedCollective: modifiedCollective$1$1,
  modifiedFault: modifiedFault$1$1,
  myTickets: myTickets$1$1,
  N: N$1$1,
  name: name$1$1,
  nameSurname: nameSurname$1$1,
  "new": "Nuevo",
  new_female: new_female$1$1,
  new_plural: new_plural$1$1,
  newAuxService: newAuxService$1$1,
  newAuxiliaryService: newAuxiliaryService$1$1,
  newDayAndTime: newDayAndTime$1$1,
  newPassword: newPassword$1$1,
  newService: newService$1$1,
  newSupportTeam: newSupportTeam$1$1,
  newVehicleAssistance: newVehicleAssistance$1$1,
  newVialService: newVialService$1$1,
  nexusMapServiceError: nexusMapServiceError$1$1,
  nick: nick$1$1,
  no: no$1$1,
  noProvidersAvailable: noProvidersAvailable$1$1,
  notApplyCosts: notApplyCosts$1$1,
  notParticipating: notParticipating$1$1,
  noCovered: noCovered$1$1,
  noDocumentsAssociatedToService: noDocumentsAssociatedToService$1$1,
  noResourcesAvailableMsg: noResourcesAvailableMsg$1$1,
  noSubscribe: noSubscribe$1$1,
  note: note$1$1,
  notes: notes$1$1,
  notesAssociatedWithTheService: notesAssociatedWithTheService$1$1,
  noTicketsAssociatedToService: noTicketsAssociatedToService$1$1,
  noTicketsAssociatedToTransfer: noTicketsAssociatedToTransfer$1$1,
  noNotesAssociatedToService: noNotesAssociatedToService$1$1,
  notifications: notifications$1$1,
  noTransfersAvailable: noTransfersAvailable$1$1,
  noValid: noValid$1$1,
  numberAbbrev: numberAbbrev$1$1,
  numberOfPeopleAbbrev: numberOfPeopleAbbrev$1$1,
  numberOfReviewsAbbrev: numberOfReviewsAbbrev$1$1,
  O: O$1$1,
  office: office$1$1,
  ongoing: ongoing$1$1,
  onQueue: onQueue$1$1,
  openDispute: openDispute$1$1,
  operational: operational$1$1,
  operationTypes: operationTypes$1$1,
  "operationTypes-opt": {
    listWithCount: "{{count}} Tipo de intervención",
    listWithCount_plural: "{{count}} Tipos de intervención"
  },
  origin: origin$1$1,
  originalServiceData: originalServiceData$1$1,
  originDeposit: originDeposit$1$1,
  otherSettings: otherSettings$1$1,
  orYouCan: orYouCan$1$1,
  outlay: outlay$1$1,
  outlays: outlays$1$1,
  "outlays-opt": {
    listWithCount: "{{count}} Gasto adicional",
    listWithCount_plural: "{{count}} Gastos adicionales"
  },
  P: P$1$1,
  paid: paid$1$1,
  passengers: passengers$1$1,
  passengersWithCount: passengersWithCount$1$1,
  passengersWithCount_plural: passengersWithCount_plural$1$1,
  password: password$1$1,
  passwordsNotMatch: passwordsNotMatch$1$1,
  paymentsToProviders: paymentsToProviders$1$1,
  "paymentsToProviders-opt": {
    listWithCount: "{{count}} Pago a proveedor",
    listWithCount_plural: "{{count}} Pagos a proveedores"
  },
  pdf: pdf$1$1,
  pending: pending$1$1,
  pendings: pendings$1$1,
  PENDING: PENDING$1$1,
  pending_assign: pending_assign$1$1,
  PENDING_ASSIGN: PENDING_ASSIGN$1$1,
  PENDINGASSIGN: PENDINGASSIGN$1$1,
  pendingDocumentation: pendingDocumentation$1$1,
  pendingDocuments: pendingDocuments$1$1,
  "pendingDocuments-opt": {
    listWithCount: "{{count}} Documento pendiente",
    listWithCount_plural: "{{count}} Documentos pendientes"
  },
  pendingPassword: pendingPassword$1$1,
  pendingProfile: pendingProfile$1$1,
  peopleTransferActivity: peopleTransferActivity$1$1,
  pleaseTryAgainLater: pleaseTryAgainLater$1$1,
  "Please indicate the reason for cancelling the service and enter the charges if necessary": "Por favor, indica el motivo por el que anulas el servicio, e introduce los gastos si es necesario.",
  phone: phone$1$1,
  phoneNumberAbbrev: phoneNumberAbbrev$1$1,
  photoWithCount: photoWithCount$1$1,
  photoWithCount_plural: photoWithCount_plural$1$1,
  photos: photos$1$1,
  planned: planned$1$1,
  PLANNED: PLANNED$1$1,
  plannedService: plannedService$1$1,
  plate: plate$1$1,
  plateDoesNotCorrespondToTheFilecase: plateDoesNotCorrespondToTheFilecase$1$1,
  policy: policy$1$1,
  policyCoverageLimit: policyCoverageLimit$1$1,
  policyCoverageLimit2: policyCoverageLimit2$1$1,
  policyInformation: policyInformation$1$1,
  policyLimitExceeded: policyLimitExceeded$1$1,
  policyLimitExceededAux: policyLimitExceededAux$1$1,
  policyNumberAbbrev: policyNumberAbbrev$1$1,
  policySearch: policySearch$1$1,
  positionAbbrev: positionAbbrev$1$1,
  "price(approx)": "Precio (aprox.)",
  priority: priority$1$1,
  priority1Providers: priority1Providers$1$1,
  priority2Providers: priority2Providers$1$1,
  priority3Providers: priority3Providers$1$1,
  priorityAllProviders: priorityAllProviders$1$1,
  priorityProvider: priorityProvider$1$1,
  process: process$1$1$1,
  profile: profile$1$1,
  profileNotFound: profileNotFound$1$1,
  profiles: profiles$1$1,
  "profiles-opt": {
    listWithCount: "{{count}} Perfil",
    listWithCount_plural: "{{count}} Perfiles",
    addTitle: "Añadir perfil",
    addText: "Completa los datos del perfil para añadirlo.",
    toastAddSuccessTitle: "Perfil creado correctamente",
    toastAddSuccessText: "El perfil ha sido creado y añadido a la lista."
  },
  proposals: proposals$1$1,
  provider: provider$1$1,
  providersInZone: providersInZone$1$1,
  providersOutZone: providersOutZone$1$1,
  providerTechnician: providerTechnician$1$1,
  providerVialSettings: providerVialSettings$1$1,
  providerEditVialSettingsHeaderText: providerEditVialSettingsHeaderText$1$1,
  providerAuxiliariesSettings: providerAuxiliariesSettings$1$1,
  providerEditAuxiliariesSettingsHeaderText: providerEditAuxiliariesSettingsHeaderText$1$1,
  "provider/driverAbbrev": "Prov / conductor",
  providers: providers$1$1,
  provider_pending: provider_pending$1$1,
  PROVIDER_PENDING: PROVIDER_PENDING$1$1,
  PROVIDERPENDING: PROVIDERPENDING$1$1,
  provider_accepted: provider_accepted$1$1,
  PROVIDER_ACCEPTED: PROVIDER_ACCEPTED$1$1,
  PROVIDERACCEPTED: PROVIDERACCEPTED$1$1,
  provider_accept: provider_accept$1$1,
  PROVIDER_ACCEPT: PROVIDER_ACCEPT$1$1,
  PROVIDERACCEPT: PROVIDERACCEPT$1$1,
  providersSelection: providersSelection$1$1,
  providerList: providerList$1$1,
  providersMap: providersMap$1$1,
  providerType: providerType$1$1,
  providerTypeVial: providerTypeVial$1$1,
  providerTypeAux: providerTypeAux$1$1,
  providerWithoutDefinedDeposit: providerWithoutDefinedDeposit$1$1,
  province: province$1$1,
  Q: Q$1$1,
  queueEntryDate: queueEntryDate$1$1,
  queued: queued$1$1,
  QUEUED: QUEUED$1$1,
  queuedService: queuedService$1$1,
  R: R$1$1,
  rates: rates$1$1,
  rating: rating$1$1,
  ratings: ratings$1$1,
  ratingsUserName: ratingsUserName$1$1,
  ratingsWithCount: ratingsWithCount$1$1,
  ratingsWithCount_plural: ratingsWithCount_plural$1$1,
  ready: ready$1$1,
  reAssign: reAssign$1$1,
  reAssignProvider: reAssignProvider$1$1,
  reAskForResetEmail: reAskForResetEmail$1$1,
  received: received$1$1,
  receivedInvoices: receivedInvoices$1$1,
  recoverRequest: recoverRequest$1$1,
  recoverYourPassword: recoverYourPassword$1$1,
  region: region$1$1,
  registrationInformationOnInvoices: registrationInformationOnInvoices$1$1,
  reject: reject$1$1,
  rejectCosts: rejectCosts$1$1,
  rejectionReason: rejectionReason$1$1,
  rejectionReasons: rejectionReasons$1$1,
  "rejectionReasons-opt": {
    listWithCount: "{{count}} Motivo de rechazo",
    listWithCount_plural: "{{count}} Motivos de rechazo"
  },
  rejectionType: rejectionType$1$1,
  release: release$1$1,
  removeFromDashboard: removeFromDashboard$1$1,
  repeated: repeated$1$1,
  repeatPassword: repeatPassword$1$1,
  requestCapability: requestCapability$1$1,
  requestInfo: requestInfo$1$1,
  requestLocationByWhatsApp: requestLocationByWhatsApp$1$1,
  requestMediumAbbrev: requestMediumAbbrev$1$1,
  requestProcessedCorrectly: requestProcessedCorrectly$1$1,
  requestWithoutIAssociatedPolicy: requestWithoutIAssociatedPolicy$1$1,
  required: required$1$1,
  reschedule: reschedule$1$1,
  RESCHEDULED: RESCHEDULED$1$1,
  rescheduleComment: rescheduleComment$1$1,
  rescheduleReason: rescheduleReason$1$1,
  rescheduleService: rescheduleService$1$1,
  rescheduleServiceDeferredTextModal: rescheduleServiceDeferredTextModal$1$1,
  rescheduleServicePlannedText1Modal: rescheduleServicePlannedText1Modal$1$1,
  rescheduleServicePlannedText2Modal: rescheduleServicePlannedText2Modal$1$1,
  resetPassword: resetPassword$1$1,
  resetYourPassword: resetYourPassword$1$1,
  resources: resources$1$1,
  resourcesMap: resourcesMap$1$1,
  restore: restore$1$1,
  result: result$1$1,
  "return": "Volver",
  ris: ris$1$1,
  risService: risService$1$1,
  S: S$1$1,
  save: save$1$1,
  saveChanges: saveChanges$1$1,
  savedRequests: savedRequests$1$1,
  saveRequest: saveRequest$1$1,
  "Saving your request for later retrieval will delete the form data Do you wish to continue?": "Guardando la solicitud para recuperarla más tarde, se borrarán los datos del formulario, ¿deseas continuar?",
  schedule: schedule$1$1,
  scheduled: scheduled$1$1,
  SCHEDULED: SCHEDULED$1$1,
  scheduled_plural: scheduled_plural$1$1,
  scheduledAbbrev: scheduledAbbrev$1$1,
  scheduledDateInvalidErrorText: scheduledDateInvalidErrorText$1$1,
  scheduleDriver: scheduleDriver$1$1,
  scheduledServiceNotFound: scheduledServiceNotFound$1$1,
  scheduledFor: scheduledFor$1$1,
  searchResourceOrTechnician: searchResourceOrTechnician$1$1,
  searchResources: searchResources$1$1,
  searchAResource: searchAResource$1$1,
  searchAService: searchAService$1$1,
  searchByAssistedOrFilecase: searchByAssistedOrFilecase$1$1,
  searchByAssistedFilecaseOrPlate: searchByAssistedFilecaseOrPlate$1$1,
  searchByAssistedFilecaseOrProvider: searchByAssistedFilecaseOrProvider$1$1,
  searchByCodeOrName: searchByCodeOrName$1$1,
  searchByCodeNameOrCostType: searchByCodeNameOrCostType$1$1,
  searchByCodeNameOrMediumType: searchByCodeNameOrMediumType$1$1,
  searchByCustomer: searchByCustomer$1$1,
  searchByCustomerOrFilecase: searchByCustomerOrFilecase$1$1,
  searchByCustomerFilecaseOrPlate: searchByCustomerFilecaseOrPlate$1$1,
  searchByFileCase: searchByFileCase$1$1,
  searchByIdForOrFilecaseNumber: searchByIdForOrFilecaseNumber$1$1,
  searchByInvoiceNumber: searchByInvoiceNumber$1$1,
  searchByName: searchByName$1$1,
  searchByNameCIFOrAddress: searchByNameCIFOrAddress$1$1,
  searchByNameOrAddress: searchByNameOrAddress$1$1,
  searchByNameOrCode: searchByNameOrCode$1$1,
  searchByNamePlateOrCode: searchByNamePlateOrCode$1$1,
  searchByNameSurnameUserOrNick: searchByNameSurnameUserOrNick$1$1,
  searchByProviderOrName: searchByProviderOrName$1$1,
  searchByTerm: searchByTerm$1$1,
  searchInsurancePolicy: searchInsurancePolicy$1$1,
  seeAverages: seeAverages$1$1,
  breakdown: breakdown$1$1,
  seeCapabilityComment: seeCapabilityComment$1$1,
  seeComment: seeComment$1$1,
  seeContactAndComment: seeContactAndComment$1$1,
  seeDescription: seeDescription$1$1,
  seeService: seeService$1$1,
  "Select a transfer associated with the service": "Selecciona un traslado asociado al servicio",
  selfValidated: selfValidated$1$1,
  send: send$1$1,
  sendComments: sendComments$1$1,
  sended: sended$1$1,
  sendEmail: sendEmail$1$1,
  sendForReview: sendForReview$1$1,
  sendTo: sendTo$1$1,
  sendToList: sendToList$1$1,
  serverConnectionError: serverConnectionError$1$1,
  service: service$1$1,
  serviceExecution: serviceExecution$1$1,
  serviceInAuction: serviceInAuction$1$1,
  serviceLevels: serviceLevels$1$1,
  serviceMap: serviceMap$1$1,
  serviceNotFound: serviceNotFound$1$1,
  serviceRequestAndTracking: serviceRequestAndTracking$1$1,
  services: services$1$1,
  serviceSentToAuction: serviceSentToAuction$1$1,
  serviceStatus: serviceStatus$1$1,
  settings: settings$1$1,
  settingsUpdated: settingsUpdated$1$1,
  sharedCode: sharedCode$1$1,
  sharedNote: sharedNote$1$1,
  sharedNotes: sharedNotes$1$1,
  "shipment (services - base)": "Remesa (servicios - base)",
  shipments: shipments$1$1,
  shipmentStatusValues: shipmentStatusValues$1$1,
  showAllMediums: showAllMediums$1$1,
  showSolicitedMedium: showSolicitedMedium$1$1,
  situation: situation$1$1,
  solicitedMedium: solicitedMedium$1$1,
  sortCriteria: sortCriteria$1$1,
  soundActivated: soundActivated$1$1,
  soundOff: soundOff$1$1,
  start: start$1$1,
  started: started$1$1,
  status: status$1$1,
  statuses: statuses$1$1,
  subject: subject$1$1,
  subscribe: subscribe$1$1,
  subtotal: subtotal$1$1,
  suburb: suburb$1$1,
  suburbService: suburbService$1$1,
  summary: summary$1$1,
  supportCenter: supportCenter$1$1,
  supportTeam: supportTeam$1$1,
  survey: survey$1$1,
  surveys: surveys$1$1,
  T: T$1$1,
  taxes: taxes$1$1,
  team: team$1$1,
  teamName: teamName$1$1,
  technician: technician$1$1,
  technicians: technicians$1$1,
  "The maximum date range allowed is 45 days": "El rango de fechas máximo permitido es de 45 días",
  "The request could not be made Try again": "No se ha podido realizar la solicitud. Inténtalo de nuevo.",
  "The proposal could not be retrieved because the collective does not exist": "No se ha podido recuperar la solicitud porque el colectivo no existe",
  "The service has been sent successfully": "El servicio se ha enviado correctamente.",
  "The service rejection could not be completed": "El rechazo del servicio no ha podido completarse.",
  "The service will be sent after completing the request process": "El servicio se enviará tras completar el proceso de solicitud",
  theField: theField$1$1,
  ticket: ticket$1$1,
  tickets: tickets$1$1,
  ticketStatus: ticketStatus$1$1,
  time: time$1$1,
  "time(approx)": "Tiempo (aprox.)",
  timeInAlert: timeInAlert$1$1,
  timeline: timeline$1$1,
  title: title$1$1,
  toastErrorDuplicateAddressPickupDeliveryTitle: toastErrorDuplicateAddressPickupDeliveryTitle$1$1,
  toastErrorDuplicateAddressPickupDeliveryText: toastErrorDuplicateAddressPickupDeliveryText$1$1,
  toastErrorDuplicateAddressPickupDestinationTitle: toastErrorDuplicateAddressPickupDestinationTitle$1$1,
  toastErrorDuplicateAddressPickupDestinationText: toastErrorDuplicateAddressPickupDestinationText$1$1,
  toastErrorTextDefault: toastErrorTextDefault$1$1,
  toastErrorTitleDefault: toastErrorTitleDefault$1$1,
  toastErrorTransferPeopleBudget: toastErrorTransferPeopleBudget$1$1,
  toastErrorTitle_downloadFile: toastErrorTitle_downloadFile$1$1,
  toastErrorText_downloadFile: toastErrorText_downloadFile$1$1,
  toastSuccessTextDefault: toastSuccessTextDefault$1$1,
  toastSuccessTitleDefault: toastSuccessTitleDefault$1$1,
  today: today$1$1,
  toDefine: toDefine$1$1,
  total: total$1$1,
  totals: totals$1$1,
  toTheClient: toTheClient$1$1,
  toTheProvider: toTheProvider$1$1,
  town: town$1$1,
  tracking: tracking$1$1,
  trackingMessage: trackingMessage$1$1,
  transfer: transfer$1$1,
  transferHasBeenCancelled: transferHasBeenCancelled$1$1,
  transferPeople: transferPeople$1$1,
  transferPeopleBudget: transferPeopleBudget$1$1,
  transferPeopleRequest: transferPeopleRequest$1$1,
  transferPeopleRequestType: transferPeopleRequestType$1$1,
  transferPeopleRequiredValidPhoneNumber: transferPeopleRequiredValidPhoneNumber$1$1,
  transfers: transfers$1$1,
  transfersAvailable: transfersAvailable$1$1,
  transferTheAssisted: transferTheAssisted$1$1,
  type: type$1$1,
  typeAndName: typeAndName$1$1,
  "type/capability": "Tipo/prestación",
  typeless: typeless$1$1,
  typeOfService: typeOfService$1$1,
  types: types$1$1,
  U: U$1$1,
  "undefined": "Sin definir",
  udWithCount: udWithCount$1$1,
  udWithCount_plural: udWithCount_plural$1$1,
  unAssign: unAssign$1$1,
  unAssignTechnician: unAssignTechnician$1$1,
  unAssignTechnicianModalText: unAssignTechnicianModalText$1$1,
  unAssignTechnicianModalAditionalText: unAssignTechnicianModalAditionalText$1$1,
  unAssignDriver: unAssignDriver$1$1,
  unAssignDriverModalText: unAssignDriverModalText$1$1,
  unAssignDriverModalAditionalText: unAssignDriverModalAditionalText$1$1,
  unavailable: unavailable$1$1,
  units: units$1$1,
  unitAbbrev: unitAbbrev$1$1,
  unitsAbbrev: unitsAbbrev$1$1,
  unselected: unselected$1$1,
  unsubscribe: unsubscribe$1$1,
  urban: urban$1$1,
  urbanFee: urbanFee$1$1,
  urbanService: urbanService$1$1,
  user: user$1$1,
  userProfiles: userProfiles$1$1,
  userProfilesWithCount: userProfilesWithCount$1$1,
  userProfilesWithCount_plural: userProfilesWithCount_plural$1$1,
  users: users$1$1,
  "users-opt": {
    listWithCount: "{{count}} Usuario",
    listWithCount_plural: "{{count}} Usuarios"
  },
  userType: userType$1$1,
  V: V$1$1,
  validFrom: validFrom$1$1,
  validUntil: validUntil$1$1,
  variable: variable$1$1,
  vehicleAssistance: vehicleAssistance$1$1,
  vehicleTypes: vehicleTypes$1$1,
  "vehicleTypes-opt": {
    listWithCount: "{{count}} Tipo de vehículo",
    listWithCount_plural: "{{count}} Tipos de vehículos"
  },
  "vehicle/fault": "Vehículo / Avería",
  version: version$1$1,
  vial: vial$1$1,
  vials: vials$1$1,
  vialRates: vialRates$1$1,
  vialServices: vialServices$1$1,
  vialSettings: vialSettings$1$1,
  view: view$1$1,
  viewAssistedRating: viewAssistedRating$1$1,
  viewContact: viewContact$1$1,
  viewContactandComment: viewContactandComment$1$1,
  viewRoute: viewRoute$1$1,
  views: views$1$1,
  vin: vin$1$1,
  virtualSwitchboard: virtualSwitchboard$1$1,
  W: W$1$1,
  waitingList: waitingList$1$1,
  web: web$1$1,
  webAddress: webAddress$1$1,
  wholeWordSearch: wholeWordSearch$1$1,
  wholeWordSearch3Charts: wholeWordSearch3Charts$1$1,
  withAlert: withAlert$1$1,
  withholdings: withholdings$1$1,
  withPriority1: withPriority1$1$1,
  withPriority2: withPriority2$1$1,
  withPriority3: withPriority3$1$1,
  writeANote: writeANote$1$1,
  wrongUser: wrongUser$1$1,
  wrongUsernameOrPassword: wrongUsernameOrPassword$1$1,
  X: X$1$1,
  Y: Y$1$1,
  year: year$1$1,
  yes: yes$1$1,
  yesterday: yesterday$1$1,
  youHaveExceededTheNumberOfAtempsts: youHaveExceededTheNumberOfAtempsts$1$1,
  Z: Z$1$1,
  "A dispute has been opened for this service": "Se ha abierto una disputa para este servicio.",
  "Add the following cost data": "Añade los siguientes datos del costo.",
  "Add the following cost type data": "Añade los siguientes datos del tipo de costo.",
  "Allow assigning rate in service request": "Asignar la tarifa en la solicitud de servicio",
  "Allow opening internal tickets": "Permitir abrir tickets internos",
  "An error has occurred in the creation of the collective": "Ha ocurrido un error en la creación del colectivo.",
  "An error has occurred in the creation of the fault": "Ha ocurrido un error en la creación de la avería.",
  "An error occurred while trying to upload the file": "Ha ocurrido un error al intentar subir el archivo.",
  "Approve costs": "Aprobar costos",
  "Are you sure you want to approve the cost sheet? Once approved you will not be able to request changes": "¿Seguro que deseas aprobar la hoja de costos? Una vez aprobada, no podrás solicitar cambios.",
  "Are you sure you want to send the cost sheet for review? Once it has been sent you will not be able to edit it again": "¿Seguro que deseas enviar la hoja de costos a revisión? Una vez enviada, no podrás editarla de nuevo.",
  "Assistance has arrived at pickup": "La asistencia ha llegado a la recogida",
  "Assistance is on the way": "La asistencia está en camino",
  "Assistance reached its destination": "La asistencia llegó a su destino",
  "At this time it is not possible to access the service": "En estos momentos no es posible acceder al servicio",
  "Attention a new service will be requested without any associated policy": "Atención, se va a solicitar un nuevo servicio sin ninguna póliza asociada.",
  "Capability created successfully": "Prestación creada correctamente",
  "Capability has been created and added to the list": "La prestación ha sido creada y añadida a la lista.",
  "Capability has been updated successfully": "La prestación ha sido actualizada correctamente.",
  "Capability updated": "Prestación actualizada",
  "Complete the data of the auxiliar service to add it": "Completa los datos del servicio auxiliar para añadirlo.",
  "Complete the data of the auxiliar service to edit it": "Completa los datos del servicio auxiliar para editarlo.",
  "Complete the data of the capability to add it": "Completa los datos de la prestación para añadirla.",
  "Complete the data of the capability to edit it": "Completa los datos de la prestación para editarla.",
  "Complete the data of the collective to add it": "Completa los datos del colectivo para añadirlo.",
  "Complete the data of the fault to add it": "Completa los datos de la avería para añadirla.",
  "Contact your insurer for more information": "Contacta con tu aseguradora para más información",
  "Costs approved successfully": "Costos aprobados correctamente",
  "Costs could not be approved": "No ha sido posible aprobar los costos",
  "Costs could not be rejected": "No ha sido posible rechazar los costos",
  "Cost created successfully": "Costo creado correctamente",
  "Costs rejected successfully": "Costos rechazados correctamente",
  "Costs sheet approved": "Hoja de costos aprobada",
  "Cost sheet could not be saved": "No ha sido posible guardar la hoja de costos",
  "Cost sheet could not be sent for review": "No ha sido posible enviar a revisión la hoja de costos",
  "Cost sheet rejected": "Hoja de costos rechazada",
  "Costs sheet saved successfully": "Hoja de costos guardada con éxito",
  "Costs sheet sent for review": "Hoja de costos enviada a revisión",
  "CostType created successfully": "Tipo de costo creado correctamente",
  "Cost has been created and added to the list": "El costo ha sido creado y añadido a la lista",
  "CostType has been created and added to the list": "El tipo de costo ha sido creado y añadido a la lista",
  "Cost has been updated successfully": "El costo ha sido actualizado correctamente.",
  "CostType has been updated successfully": "El tipo de costo ha sido actualizado correctamente.",
  "Cost updated": "Costo actualizado",
  "CostType updated": "Tipo de costo actualizado",
  "Data has been saved successfully": "Los datos se han guardado correctamente",
  "Do not allow the assistant to call the driver from the tracking widget": "No permitir al asistido llamar al chofer desde el widget de seguimiento",
  "Do not allow technician to create notes": "No permitir al técnico crear notas",
  "Do not allow the operator to select providers": "No permitir al operador seleccionar proveedores",
  "Do not allow the technician to reschedule the service": "No permitir al técnico reprogramar el servicio",
  "Do not show the technician the assisted person phone number": "No mostrar al técnico el teléfono del asistido",
  "Do not take into account the first section for the calculation of the rate": "No tener en cuenta el primer tramo para el cálculo de la tarifa",
  "Do you want to send the request": "¿Deseas enviar la solicitud?",
  "Edit the data you need for the following cost": "Edita los datos que necesites del siguiente costo.",
  "Edit the data you need for the following type cost": "Edita los datos que necesites del siguiente tipo de costo.",
  "Edit the data you need from the following collective": "Edita los datos que necesites del siguiente colectivo.",
  "Edit the data you need from the following fault": "Edita los datos que necesites de la siguiente avería.",
  "Edit the details you need for the following user profile": "Edita los datos que necesites del siguiente perfil de usuario.",
  "Error creating capability": "Error al crear prestación",
  "Error creating cost": "Error al crear costo",
  "Error creating costType": "Error al crear tipo de costo",
  "Error creating user profile": "Error al crear perfil de usuario",
  "Error has ocurred while creating the capability": "Ha ocurrido un error en la creación de la prestación.",
  "Error has ocurred while creating the cost": "Ha ocurrido un error durante la creación del costo.",
  "Error has ocurred while creating the costType": "Ha ocurrido un error durante la creación del tipo de costo.",
  "Error has ocurred while creating the user profile": "Ha ocurrido un error durante la creación del perfil de usuario.",
  "Error has ocurred while updating the capability": "Ha ocurrido un error durante la actualización de la prestación.",
  "Error has ocurred while updating the cost": "Ha ocurrido un error durante la actualización del costo.",
  "Error has ocurred while updating the costType": "Ha ocurrido un error durante la actualización del tipo de costo.",
  "Error has ocurred while updating the user profile": "Ha ocurrido un error durante la actualización del perfil de usuario.",
  "Error updating capability": "Error al actualizar prestación",
  "Error updating cost": "Error al actualizar costo",
  "Error updating costType": "Error al actualizar tipo de costo",
  "Error updating user profile": "Error al actualizar perfil de usuario",
  "Fill in the details of the user profile to add it": "Completa los datos del perfil del usuario para añadirlo.",
  "Follow your roadside assistance service in real time by clicking on the continue button": "Sigue en tiempo real tu servicio de asistencia en carretera, pulsando en el botón de continuar",
  "Follow your assistance service in real time by clicking on the continue button": "Sigue en tiempo real tu servicio de asistencia, pulsando en el botón de continuar",
  "Hide middle phone in tracking widget": "Ocultar el teléfono del medio en el widget de seguimiento",
  "It is not possible to access": "No es posible acceder",
  "It has not been possible to add the new note to the service": "No ha sido posible añadir al servicio la nueva nota.",
  "It has not been possible to consult the events associated with the service": "No ha sido posible consultar los eventos asociados al servicio.",
  "It has not been possible to modify the collective data": "No ha sido posible modificar los datos del colectivo.",
  "It has not been possible to modify the fault data": "No ha sido posible modificar los datos de la avería.",
  "It has not been possible to update the information": "No ha sido posible actualizar la información",
  "It was not possible to finish the service": "No ha sido posible finalizar el servicio.",
  "It was not possible to obtain the survey data": "No ha sido posible obtener los datos de la encuesta.",
  "It was not possible to recover the integration profiles": "No ha sido posible recuperar los perfiles de integración.",
  "Manage the documents necessary to work with Nexus": "Gestiona los documentos necesarios para trabajar con Nexus",
  "No auction providers found at the service location": "No se han encontrado proveedores de subasta en la ubicación del servicio",
  "No changes have been made to the service": "No se han realizado cambios en el servicio.",
  "Please indicate the reason why you wish to reject the costs associated with the service": "Por favor, indica el motivo por el que deseas rechazar los costos que están asociados al servicio.",
  "Please retry in a few minutes": "Vuelve a intentarlo en unos minutos.",
  "Plot the geofence on the map, complete the information and press the save button": "Define la geocerca en el mapa, completa la información y pulsa el botón guardar",
  "__providerName settings have been updated": "Los ajustes de {{providerName}} han sido actualizados",
  "Reload the page or contact your company": "Recarga la página o contacta con tu compañía",
  "Request processed correctly": "Solicitud procesada de forma correcta",
  "Select a provider to assign to the service": "Selecciona un proveedor para asignar al servicio.",
  "Select the providers that will participate in the auction": "Selecciona los proveedores que participarán en la subasta",
  "Send costs for review": "Enviar costos a revisión",
  "Service acceptance could not be completed": "La aceptación del servicio no ha podido completarse.",
  "Service assignment could not be completed": "La asignación del servicio no ha podido completarse.",
  "Service requested from the widget": "Servicio solicitado desde el widget",
  "Sorry attendance has been canceled": "Lo sentimos, la asistencia ha sido cancelada",
  "Spoofing the assisted phone number": "Suplantación del nº de teléfono del asistido",
  "Successfully sent, under review": "Enviada correctamente, está en revisión",
  "Support has ended": "La asistencia ha finalizado",
  "Thank you very much for your confidence": "Muchas gracias por tu confianza",
  "The collective has been created and added to the list": "El colectivo ha sido creado y añadido a la lista.",
  "The cost could not be modified": "El costo no ha podido ser modificado",
  "The dispute for this service has been closed": "Se ha cerrado la disputa para este servicio.",
  "The document has been attached to the service": "El documento se ha adjuntado al servicio.",
  "The fault has been created and added to the list": "La avería ha sido creada y añadida a la lista.",
  "The file must be pdf jpg or png": "El archivo tiene que ser: pdf, jpg o png.",
  "The service has been canceled": "El servicio ha sido anulado.",
  "The service has been created and added to the list": "El servicio ha sido creado y añadido a la lista.",
  "The service has been rescheduled": "El servicio ha sido reprogramado.",
  "The service has been scheduled for the day": "El servicio ha sido programado para el día",
  "There is no assigned provider": "No hay proveedor asignado",
  "There are no documents associated": "No hay documentos asociados",
  "There are no events associated with the service": "No hay eventos asociados al servicio.",
  "User profile created successfully": "Perfil de usuario creado correctamente",
  "User profile has been created and added to the list": "El perfil de usuario ha sido creado y añadido a la lista.",
  "User profile has been updated successfully": "El perfil de usuario ha sido actualizado correctamente.",
  "User profile updated": "Perfil de usuario actualizado",
  "We are at your disposal whenever you need it": "Estamos a tu disposición siempre que lo necesites",
  "We are sorry It has not been possible to show the tracking of your service": "Lo sentimos. No ha sido posible mostrar el seguimiento de tu servicio.",
  "We are trying to repair your vehicle": "Estamos tratando de reparar tu vehículo",
  "We have not been able to connect you to our network": "No hemos podido conectarte a nuestra red",
  "We have updated the information of the collective": "La información del colectivo se ha actualizado correctamente.",
  "We have updated the information of the fault": "La información de la avería se ha actualizado correctamente.",
  "Welcome to the __companyName tracking platform": "Bienvenido a la plataforma de seguimiento de {{companyName}}",
  "Your company does not have integration defined with Azure": "",
  "Your user is blocked by Nexus": "Tu usuario está bloquedado por Nexus",
  "Your vehicle is being moved": "Tu vehículo está siendo trasladado",
  "********** END CHECKED WORDS **********": "",
  "********** BEGIN PHRASES **********": "**********",
  "No services performed since the renewal date": "No hay servicios realizados desde la fecha de renovación",
  "********** BEGIN COMPANY PROFILE SETTINGS **********": "**********",
  "Assignment algorithm": "Algoritmo de asignación",
  "Service request": "Solicitud del servicio",
  "SMS messages": "Mensajes SMS",
  "Maximum time given to a resource to accept or reject a service": "Tiempo máximo que se le otorga a un recurso para aceptar o rechazar un servicio",
  "Maximum time given to a provider to accept or reject a service": "Tiempo máximo que se le otorga a un proveedor para aceptar o rechazar un servicio",
  "Maximum time in which a service request can be accepted": "Tiempo máximo en el que se puede aceptar una solicitud de servicio",
  "Maximum time for all providers": "Tiempo máximo para todos los proveedores",
  "Maximum time for providers with priority": "Tiempo máximo para proveedores con prioridad {{priority}}",
  "Maximum radial distance to search for resources in a service request": "Distancia máxima radial para buscar recursos en una solicitud de servicio",
  "Default distance when sending a to assign a waiting service to a resource": "Distancia por defecto al enviar un servicio a la lista de espera",
  "Maximum total distance of a service route": "Distancia máxima total de la ruta de un servicio",
  "Origin location for calculating the rate in automatic services": "Ubicación de origen para el cálculo de la tarifa en servicios automáticos",
  "From deposit": "Desde depósito",
  "From resource": "Desde recurso",
  "Show option to cancel services at no cost": "Mostrar opción de anular servicios sin coste",
  "Show policy information in the service file": "Mostrar datos de póliza en la ficha del servicio",
  "Block editing of the fault": "Bloquear la edición de la avería",
  "Show the clone services button": "Mostrar el botón de clonar servicios",
  "Show the mandatory damage report by default": "Mostrar el parte de daños obligatorio por defecto",
  "Maximum number of photos that can be requested in a service": "Máximo nº de fotos que se pueden solicitar en un servicio",
  "Number of mandatory photos by default": "Número de fotos obligatorias por defecto",
  "Message sender": "Remitente de los mensajes",
  maxMinutes: maxMinutes$1$1,
  maxPhotos: maxPhotos$1$1,
  between0And5Minutes: between0And5Minutes$1$1,
  between0And10Minutes: between0And10Minutes$1$1,
  between0And240Minutes: between0And240Minutes$1$1,
  between1And7Minutes: between1And7Minutes$1$1,
  between2And5Minutes: between2And5Minutes$1$1,
  between2And10Minutes: between2And10Minutes$1$1,
  between0And10Photos: between0And10Photos$1$1,
  between1And10Characters: between1And10Characters$1$1,
  "Fault by medium type": "Avería por tipo de medio",
  "********** END COMPANY PROFILE SETTINGS **********": "**********",
  "********** BEGIN COMPANY PROFILE SERVICE LEVELS **********": "**********",
  between0And120Minutes: between0And120Minutes$1$1,
  "Maximum times in vial services": "Tiempos máximos en servicios viales",
  "Time for the provider to accept the service": "Tiempo para que el proveedor acepte el servicio",
  "Time for the provider to assign the service to a resource": "Tiempo para que el proveedor asigne el servicio a un recurso",
  "Time to start the service after the resource accepts it": "Tiempo para iniciar el servicio después de que el recurso lo acepte",
  "Time to locate the pick-up location in urban services": "Tiempo para localizar el lugar de recogida en servicios locales",
  "Time to locate the pick-up location in suburban services": "Tiempo para localizar el lugar de recogida en servicios carreteros",
  "Time to carry out an on-site repair": "Tiempo de realización de una reparación in situ",
  "Time to reach the delivery location": "Tiempo para llegar al lugar de entrega",
  "Time to carry out an urban service": "Tiempo de realización de un servicio local",
  "Time to carry out an suburban service": "Tiempo de realización de un servicio carretero",
  "Maximum times in auxiliary services": "Tiempos máximos en servicios auxiliares",
  "Time that the service can be in completed status": "Tiempo que puede estar el servicio en estado completado",
  "Time to assign an urban service to a technician": "Tiempo de asignación de un servicio local a un técnico",
  "Time to assign an suburban service to a technician": "Tiempo de asignación de un servicio carretero a un técnico",
  "Time to locate the location from the start of the service": "Tiempo para localizar la ubicación desde que se inicia el servicio",
  "Waiting time before starting a scheduled service": "Tiempo de espera antes de iniciar un servicio programado",
  "********** END COMPANY PROFILE SERVICE LEVELS **********": "**********",
  "*** ERRORS ***": "",
  "Date not in valid range": "La fecha está fuera de rango",
  "Hours not in valid range": "La hora está fuera de rango",
  "Distance not in valid range": "La distancia está fuera de rango",
  "Mandatory request body not found": "La información obligatoria de la petición es incorrecta",
  "Selected budget already confirmed": "El presupuesto seleccionado ha sido confirmado previamente",
  "Selected budget expired": "El presupuesto seleccionado ha expirado",
  "Selected budget not found": "El presupuesto seleccionado no ha podido ser localizado",
  "The token is invalid": "El token no es válido",
  "*** ERRORS - END ***": "",
  "An error occurred while approving this document": "Ha ocurrido un error al aprobar este documento",
  "An error occurred while rejecting this document": "Ha ocurrido un error al rechazar este documento",
  "Are you sure you want to accept the update? By doing so, you allow Nexus to send you services under the terms of this rate": "",
  "Are you sure you want to delete the cost?": "¿Seguro que deseas eliminar el costo?",
  "Are you sure you want finish the service?": "¿Seguro que deseas finalizar el servicio?",
  "Complete the fields to change your access password": "Completa los campos para cambiar tu contraseña de acceso",
  "Error approving the document": "Error al aprobar el documento",
  "Error rejecting the document": "Error al rechazar el documento",
  "It's necessary to change the access password to continue with the registration": "Es necesario cambiar la contraseña de acceso, para continuar con el registro",
  "Manage subscriptions to rates": "Gestiona las suscripciones a las tarifas",
  "Now you can use it when you login": "Ya puedes utilizarla al iniciar sesión",
  "There are unsaved changes": "Hay cambios sin guardar",
  "********** BEGIN PENDING WORDS **********": "",
  ACCEPTED: ACCEPTED$1$1,
  add_company_description: add_company_description$1$1,
  add_company: add_company$1$1,
  addChartText: addChartText$1$1,
  addChartTitle: addChartTitle$1$1,
  all_female: all_female$1$1,
  all_male: all_male$1$1,
  amount: amount$1$1,
  "Amount outside of policy coverage Payment of the assisted to the provider": "Importe fuera de cobertura de póliza (pago del asistido al proveedor)",
  apply: apply$1$1,
  assignProvider: assignProvider$1$1,
  assignedToMe: assignedToMe$1$1,
  assignItToMe: assignItToMe$1$1,
  AVAILABLE: AVAILABLE$1$1,
  blocked: blocked$1$1,
  budgetToastSuccessText: budgetToastSuccessText$1$1,
  budgetToastSuccessTitle: budgetToastSuccessTitle$1$1,
  scheduledBudgetToastSuccessText: scheduledBudgetToastSuccessText$1$1,
  scheduledBudgetToastSuccessTitle: scheduledBudgetToastSuccessTitle$1$1,
  transferPeopleBudgetToastSuccessText: transferPeopleBudgetToastSuccessText$1$1,
  transferPeopleBudgetToastSuccessTitle: transferPeopleBudgetToastSuccessTitle$1$1,
  budgetToastSuccessQueueText: budgetToastSuccessQueueText$1$1,
  budgetToastSuccessQueueTitle: budgetToastSuccessQueueTitle$1$1,
  bussy: bussy$1$1,
  CANCELED: CANCELED$1$1,
  centerNum: centerNum$1$1,
  centers: centers$1$1,
  closed: closed$1$1,
  codeAlreadyAssigned: codeAlreadyAssigned$1$1,
  color: color$1$1,
  companyPendingDocumentation: companyPendingDocumentation$1$1,
  companyProviderCode: companyProviderCode$1$1,
  COMPLETED: COMPLETED$1$1,
  custodyRate: custodyRate$1$1,
  damageReport: damageReport$1$1,
  damageRequired: damageRequired$1$1,
  day: day$1$1,
  days: days$1$1,
  del: del$1$1,
  delivery: delivery$1$1,
  deliveryAddressRequired: deliveryAddressRequired$1$1,
  destination: destination$1$1,
  documents: documents$1$1,
  exit: exit$1$1,
  expired: expired$1$1,
  EXTRA_CHARGES: EXTRA_CHARGES$1$1,
  extraCharges: extraCharges$1$1,
  festive: festive$1$1,
  fieldsRequired: fieldsRequired$1$1,
  files: files$1$1,
  filters: filters$1$1,
  FINISHED: FINISHED$1$1,
  free: free$1$1,
  from: from$1$1,
  fromDate: fromDate$1$1,
  generalInfo: generalInfo$1$1,
  groupName: groupName$1$1,
  id: id$1$1,
  IN_SERVICE: IN_SERVICE$1$1,
  information: information$1$1,
  INRIS: INRIS$1$1,
  integrated: integrated$1$1,
  invite: invite$1$1,
  invoiceDate: invoiceDate$1$1,
  lastAct: lastAct$1$1,
  left: left$1$1,
  LOADED: LOADED$1$1,
  LOCATED: LOCATED$1$1,
  locations: locations$1$1,
  mediums: mediums$1$1,
  MEDIUMS: MEDIUMS$1$1,
  modify: modify$1$1,
  newRates: newRates$1$1,
  nexus: nexus$1$1,
  nexusFee: nexusFee$1$1,
  nFilecase: nFilecase$1$1,
  nFilecaseAbbrev: nFilecaseAbbrev$1$1,
  nickName: nickName$1$1,
  nightlyEnd: nightlyEnd$1$1,
  nightlyStart: nightlyStart$1$1,
  nightly: nightly$1$1,
  nigthly: nigthly$1$1,
  nightlyFestive: nightlyFestive$1$1,
  nInvoice: nInvoice$1$1,
  nInvoices: nInvoices$1$1,
  none: none$1$1,
  NOT_IN_NEXUS: NOT_IN_NEXUS$1$1,
  not: not$1$1,
  nNexus: nNexus$1$1,
  nPayments: nPayments$1$1,
  nServices: nServices$1$1,
  numberOfInvoices: numberOfInvoices$1$1,
  of: of$1$1,
  open: open$1$1,
  outOfService: outOfService$1$1,
  ownFilecaseNumber: ownFilecaseNumber$1$1,
  ownFilecaseNumberAbbrev: ownFilecaseNumberAbbrev$1$1,
  partialPrice: partialPrice$1$1,
  participants: participants$1$1,
  participation: participation$1$1,
  payed: payed$1$1,
  payments: payments$1$1,
  pendingAbbrev: pendingAbbrev$1$1,
  photosNumber: photosNumber$1$1,
  pickup: pickup$1$1,
  "pickup/delivery": "Recogida / entrega",
  pickupAddress: pickupAddress$1$1,
  pictures: pictures$1$1,
  "private": "Privado",
  processDate: processDate$1$1,
  processed: processed$1$1,
  providerAlreadyMapped: providerAlreadyMapped$1$1,
  "public": "Público",
  REJECTED: REJECTED$1$1,
  rejection: rejection$1$1,
  request: request$1$1,
  requester: requester$1$1,
  resource: resource$1$1,
  resourceActivity: resourceActivity$1$1,
  resourceDistance: resourceDistance$1$1,
  resourceRoute: resourceRoute$1$1,
  resourceTime: resourceTime$1$1,
  responsable: responsable$1$1,
  responseNumberAbbrev: responseNumberAbbrev$1$1,
  RISEND: RISEND$1$1,
  RISSTART: RISSTART$1$1,
  rowsPerPage: rowsPerPage$1$1,
  saveView: saveView$1$1,
  sendSMSTracking: sendSMSTracking$1$1,
  sendSurvey: sendSurvey$1$1,
  serviceActivity: serviceActivity$1$1,
  serviceBudget: serviceBudget$1$1,
  serviceRequest: serviceRequest$1$1,
  serviceType: serviceType$1$1,
  shared: shared$1$1,
  shipmentDate: shipmentDate$1$1,
  sign: sign$1$1,
  sta: sta$1$1,
  STARTED: STARTED$1$1,
  supportTeamAbbrev: supportTeamAbbrev$1$1,
  surchargeRate: surchargeRate$1$1,
  surname: surname$1$1,
  teamMembers: teamMembers$1$1,
  teamTickets: teamTickets$1$1,
  totalPrice: totalPrice$1$1,
  UNAVAILABLE: UNAVAILABLE$1$1,
  userProfile: userProfile$1$1,
  validate: validate$1$1,
  validated: validated$1$1,
  vehicle: vehicle$1$1,
  weekend: weekend$1$1,
  "***** STRUCTURES *****": "*****",
  category: category$1$1,
  collective2: collective2$1$1,
  companyList: companyList$1$1,
  depositList: depositList$1$1,
  format: format$1$1,
  invoiceList: invoiceList$1$1,
  mediumList: mediumList$1$1,
  "mediums-toast": {
    toastErrorDeactivateMediumTitle: "ERROR",
    toastErrorDeactivateMediumText: "En estos momentos no es posible desactivar el medio. Por favor, vuelve a intentarlo en unos minutos.",
    toastErrorDeactivateMediumInServideTitle: "ERROR",
    toastErrorDeactivateMediumInServiceText: "No es posible desactivar un medio que se encuentra actualmente realizando un servicio."
  },
  mediumTypesList: mediumTypesList$1$1,
  modals: modals$1$1,
  operationTypesList: operationTypesList$1$1,
  paymentList: paymentList$1$1,
  "rates-concepts": {
    startupFee: "Tarifa de salida",
    scheduledFee: "Tarifa programado",
    nexusFee: "Tarifa de Nexus",
    km: "Tarifa por km",
    mi: "Tarifa por mi",
    minute: "Tarifa por minuto",
    loadTime: "Tiempo de carga",
    surchargeRate: "Recargo",
    cancelRate: "Anulación",
    cancelAmount: "Importe anulación",
    surchargeType: "Tipo de recargo",
    freeCustodyDays: "Custodia gratuita",
    custodyRate: "Custodia",
    urban: "Local",
    urbanFee: "Tarifa local",
    franchise: "Franquicia"
  },
  searchTools: searchTools$1$1,
  serviceList: serviceList$1$1,
  servicesError: servicesError$1$1,
  transferPeopleError: transferPeopleError$1$1,
  transferPeopleList: transferPeopleList$1$1,
  shipment: shipment$1$1,
  "shipments-opt": {
    listWithCount: "{{count}} Remesa",
    listWithCount_plural: "{{count}} Remesas",
    collectInvoiceErrorTitle: "Error al solicitar el cobro de la factura",
    collectInvoiceUnknownError: "En estos momentos no es posible realizar la operación. Vuelva a intentarlo en unos minutos."
  },
  "shipments-opt2": {
    collectInvoiceErrorTitle: "Error al solicitar el cobro de la factura",
    collectInvoiceUnknownError: "En estos momentos no es posible realizar la operación. Vuelva a intentarlo en unos minutos."
  },
  ticketDetail: ticketDetail$1$1,
  ticketList: ticketList$1$1,
  user2: user2$1$1,
  userList: userList$1$1,
  validation: validation$1$1,
  loginYourAccount: loginYourAccount$1$1,
  checkYourEmail: checkYourEmail$1$1,
  updatedUser: updatedUser$1$1,
  errorCreatingCompany: errorCreatingCompany$1$1,
  min: min$1$1,
  distance: distance$1$1,
  "---": "---"
};
function _extends$1$1() {
  _extends$1$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1$1.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$1$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var CustomCheckbox$1$1 = withStyles({
  root: {
    "&$checked": {
      color: "#ec754a"
    }
  },
  checked: {}
})(function (props) {
  return /*#__PURE__*/React__default__default__default__default.createElement(Checkbox, _extends$1$1({
    color: "default"
  }, props));
});
var commonjsGlobal$1$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function unwrapExports$1$1(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function createCommonjsModule$1$1(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
function getCjsExportFromNamespace$1$1(n) {
  return n && n['default'] || n;
}
function commonjsRequire$1$1() {
  throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}
var b$1$1 = "function" === typeof Symbol && Symbol["for"],
  c$1$1 = b$1$1 ? Symbol["for"]("react.element") : 60103,
  d$1$1 = b$1$1 ? Symbol["for"]("react.portal") : 60106,
  e$1$1 = b$1$1 ? Symbol["for"]("react.fragment") : 60107,
  f$1$1 = b$1$1 ? Symbol["for"]("react.strict_mode") : 60108,
  g$1$1 = b$1$1 ? Symbol["for"]("react.profiler") : 60114,
  h$1$1 = b$1$1 ? Symbol["for"]("react.provider") : 60109,
  k$1$1 = b$1$1 ? Symbol["for"]("react.context") : 60110,
  l$1$1 = b$1$1 ? Symbol["for"]("react.async_mode") : 60111,
  m$1$1 = b$1$1 ? Symbol["for"]("react.concurrent_mode") : 60111,
  n$1$1 = b$1$1 ? Symbol["for"]("react.forward_ref") : 60112,
  p$1$1 = b$1$1 ? Symbol["for"]("react.suspense") : 60113,
  q$1$1 = b$1$1 ? Symbol["for"]("react.suspense_list") : 60120,
  r$2$1 = b$1$1 ? Symbol["for"]("react.memo") : 60115,
  t$1$1 = b$1$1 ? Symbol["for"]("react.lazy") : 60116,
  v$1$1 = b$1$1 ? Symbol["for"]("react.block") : 60121,
  w$1$1 = b$1$1 ? Symbol["for"]("react.fundamental") : 60117,
  x$1$1 = b$1$1 ? Symbol["for"]("react.responder") : 60118,
  y$1$1 = b$1$1 ? Symbol["for"]("react.scope") : 60119;
function z$1$1(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c$1$1:
        switch (a = a.type, a) {
          case l$1$1:
          case m$1$1:
          case e$1$1:
          case g$1$1:
          case f$1$1:
          case p$1$1:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k$1$1:
              case n$1$1:
              case t$1$1:
              case r$2$1:
              case h$1$1:
                return a;
              default:
                return u;
            }
        }
      case d$1$1:
        return u;
    }
  }
}
function A$1$1$1(a) {
  return z$1$1(a) === m$1$1;
}
var AsyncMode$1$1 = l$1$1;
var ConcurrentMode$1$1 = m$1$1;
var ContextConsumer$1$1 = k$1$1;
var ContextProvider$1$1 = h$1$1;
var Element$1$1 = c$1$1;
var ForwardRef$1$1 = n$1$1;
var Fragment$1$1 = e$1$1;
var Lazy$1$1 = t$1$1;
var Memo$1$1 = r$2$1;
var Portal$1$1 = d$1$1;
var Profiler$1$1 = g$1$1;
var StrictMode$1$1 = f$1$1;
var Suspense$1$1 = p$1$1;
var isAsyncMode$1$1 = function isAsyncMode(a) {
  return A$1$1$1(a) || z$1$1(a) === l$1$1;
};
var isConcurrentMode$1$1 = A$1$1$1;
var isContextConsumer$1$1 = function isContextConsumer(a) {
  return z$1$1(a) === k$1$1;
};
var isContextProvider$1$1 = function isContextProvider(a) {
  return z$1$1(a) === h$1$1;
};
var isElement$1$1 = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c$1$1;
};
var isForwardRef$1$1 = function isForwardRef(a) {
  return z$1$1(a) === n$1$1;
};
var isFragment$1$1 = function isFragment(a) {
  return z$1$1(a) === e$1$1;
};
var isLazy$1$1 = function isLazy(a) {
  return z$1$1(a) === t$1$1;
};
var isMemo$1$1 = function isMemo(a) {
  return z$1$1(a) === r$2$1;
};
var isPortal$1$1 = function isPortal(a) {
  return z$1$1(a) === d$1$1;
};
var isProfiler$1$1 = function isProfiler(a) {
  return z$1$1(a) === g$1$1;
};
var isStrictMode$1$1 = function isStrictMode(a) {
  return z$1$1(a) === f$1$1;
};
var isSuspense$1$1 = function isSuspense(a) {
  return z$1$1(a) === p$1$1;
};
var isValidElementType$1$1 = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e$1$1 || a === m$1$1 || a === g$1$1 || a === f$1$1 || a === p$1$1 || a === q$1$1 || "object" === typeof a && null !== a && (a.$$typeof === t$1$1 || a.$$typeof === r$2$1 || a.$$typeof === h$1$1 || a.$$typeof === k$1$1 || a.$$typeof === n$1$1 || a.$$typeof === w$1$1 || a.$$typeof === x$1$1 || a.$$typeof === y$1$1 || a.$$typeof === v$1$1);
};
var typeOf$1$1 = z$1$1;
var reactIs_production_min$1$1 = {
  AsyncMode: AsyncMode$1$1,
  ConcurrentMode: ConcurrentMode$1$1,
  ContextConsumer: ContextConsumer$1$1,
  ContextProvider: ContextProvider$1$1,
  Element: Element$1$1,
  ForwardRef: ForwardRef$1$1,
  Fragment: Fragment$1$1,
  Lazy: Lazy$1$1,
  Memo: Memo$1$1,
  Portal: Portal$1$1,
  Profiler: Profiler$1$1,
  StrictMode: StrictMode$1$1,
  Suspense: Suspense$1$1,
  isAsyncMode: isAsyncMode$1$1,
  isConcurrentMode: isConcurrentMode$1$1,
  isContextConsumer: isContextConsumer$1$1,
  isContextProvider: isContextProvider$1$1,
  isElement: isElement$1$1,
  isForwardRef: isForwardRef$1$1,
  isFragment: isFragment$1$1,
  isLazy: isLazy$1$1,
  isMemo: isMemo$1$1,
  isPortal: isPortal$1$1,
  isProfiler: isProfiler$1$1,
  isStrictMode: isStrictMode$1$1,
  isSuspense: isSuspense$1$1,
  isValidElementType: isValidElementType$1$1,
  typeOf: typeOf$1$1
};
var reactIs_development$1$1 = createCommonjsModule$1$1(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs$1$1 = createCommonjsModule$1$1(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min$1$1;
  } else {
    module.exports = reactIs_development$1$1;
  }
});
var getOwnPropertySymbols$1$1 = Object.getOwnPropertySymbols;
var hasOwnProperty$1$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable$1$1 = Object.prototype.propertyIsEnumerable;
function toObject$1$1(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative$1$1() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String('abc');
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
var objectAssign$1$1 = shouldUseNative$1$1() ? Object.assign : function (target, source) {
  var from;
  var to = toObject$1$1(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty$1$1.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols$1$1) {
      symbols = getOwnPropertySymbols$1$1(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable$1$1.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};
var ReactPropTypesSecret$2$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1$1$1 = ReactPropTypesSecret$2$1;
var has$2$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$2$1 = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1$1$1 = ReactPropTypesSecret_1$1$1;
  var loggedTypeFailures$1$1 = {};
  var has$1$1$1 = has$2$1;
  printWarning$2$1 = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function checkPropTypes$1$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1$1$1(typeSpecs, typeSpecName)) {
        var error;
        try {
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1$1$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$2$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures$1$1)) {
          loggedTypeFailures$1$1[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$2$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
checkPropTypes$1$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures$1$1 = {};
  }
};
var checkPropTypes_1$1$1 = checkPropTypes$1$1;
var printWarning$1$1$1 = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  printWarning$1$1$1 = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull$1$1() {
  return null;
}
var factoryWithTypeCheckers$1$1 = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  var ANONYMOUS = '<<anonymous>>';
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  function is(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  }
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1$1$1) {
        if (throwOnDirectAccess) {
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
            printWarning$1$1$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull$1$1);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1$1$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs$1$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1$1$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1$1$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull$1$1;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$2$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1$1$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull$1$1;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1$1$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull$1$1;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1$1$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$2$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      var allKeys = objectAssign$1$1({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$2$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    if (propType === 'symbol') {
      return true;
    }
    if (!propValue) {
      return false;
    }
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1$1$1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1$1$1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
function emptyFunction$1$1() {}
function emptyFunctionWithReset$1$1() {}
emptyFunctionWithReset$1$1.resetWarningCache = emptyFunction$1$1;
var factoryWithThrowingShims$1$1 = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1$1$1) {
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset$1$1,
    resetWarningCache: emptyFunction$1$1
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
var propTypes$1$1 = createCommonjsModule$1$1(function (module) {
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs$1$1;
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers$1$1(ReactIs.isElement, throwOnDirectAccess);
  } else {
    module.exports = factoryWithThrowingShims$1$1();
  }
});
var moment$1$1 = createCommonjsModule$1$1(function (module, exports) {
  (function (global, factory) {
    module.exports = factory();
  })(commonjsGlobal$1$1, function () {
    var hookCallback;
    function hooks() {
      return hookCallback.apply(null, arguments);
    }
    function setHookCallback(callback) {
      hookCallback = callback;
    }
    function isArray(input) {
      return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
      return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
      if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
      } else {
        var k;
        for (k in obj) {
          if (hasOwnProp(obj, k)) {
            return false;
          }
        }
        return true;
      }
    }
    function isUndefined(input) {
      return input === void 0;
    }
    function isNumber(input) {
      return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
      return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
      var res = [],
        i,
        arrLen = arr.length;
      for (i = 0; i < arrLen; ++i) {
        res.push(fn(arr[i], i));
      }
      return res;
    }
    function extend(a, b) {
      for (var i in b) {
        if (hasOwnProp(b, i)) {
          a[i] = b[i];
        }
      }
      if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
      }
      if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
      }
      return a;
    }
    function createUTC(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
      return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false
      };
    }
    function getParsingFlags(m) {
      if (m._pf == null) {
        m._pf = defaultParsingFlags();
      }
      return m._pf;
    }
    var some;
    if (Array.prototype.some) {
      some = Array.prototype.some;
    } else {
      some = function some(fun) {
        var t = Object(this),
          len = t.length >>> 0,
          i;
        for (i = 0; i < len; i++) {
          if (i in t && fun.call(this, t[i], i, t)) {
            return true;
          }
        }
        return false;
      };
    }
    function isValid(m) {
      if (m._isValid == null) {
        var flags = getParsingFlags(m),
          parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
          }),
          isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
        if (m._strict) {
          isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
          m._isValid = isNowValid;
        } else {
          return isNowValid;
        }
      }
      return m._isValid;
    }
    function createInvalid(flags) {
      var m = createUTC(NaN);
      if (flags != null) {
        extend(getParsingFlags(m), flags);
      } else {
        getParsingFlags(m).userInvalidated = true;
      }
      return m;
    }
    var momentProperties = hooks.momentProperties = [],
      updateInProgress = false;
    function copyConfig(to, from) {
      var i,
        prop,
        val,
        momentPropertiesLen = momentProperties.length;
      if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
      }
      if (!isUndefined(from._i)) {
        to._i = from._i;
      }
      if (!isUndefined(from._f)) {
        to._f = from._f;
      }
      if (!isUndefined(from._l)) {
        to._l = from._l;
      }
      if (!isUndefined(from._strict)) {
        to._strict = from._strict;
      }
      if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
      }
      if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
      }
      if (!isUndefined(from._offset)) {
        to._offset = from._offset;
      }
      if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
      }
      if (!isUndefined(from._locale)) {
        to._locale = from._locale;
      }
      if (momentPropertiesLen > 0) {
        for (i = 0; i < momentPropertiesLen; i++) {
          prop = momentProperties[i];
          val = from[prop];
          if (!isUndefined(val)) {
            to[prop] = val;
          }
        }
      }
      return to;
    }
    function Moment(config) {
      copyConfig(this, config);
      this._d = new Date(config._d != null ? config._d.getTime() : NaN);
      if (!this.isValid()) {
        this._d = new Date(NaN);
      }
      if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
      }
    }
    function isMoment(obj) {
      return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
      if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
        console.warn('Deprecation warning: ' + msg);
      }
    }
    function deprecate(msg, fn) {
      var firstTime = true;
      return extend(function () {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
          var args = [],
            arg,
            i,
            key,
            argLen = arguments.length;
          for (i = 0; i < argLen; i++) {
            arg = '';
            if (typeof arguments[i] === 'object') {
              arg += '\n[' + i + '] ';
              for (key in arguments[0]) {
                if (hasOwnProp(arguments[0], key)) {
                  arg += key + ': ' + arguments[0][key] + ', ';
                }
              }
              arg = arg.slice(0, -2);
            } else {
              arg = arguments[i];
            }
            args.push(arg);
          }
          warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
          firstTime = false;
        }
        return fn.apply(this, arguments);
      }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
      }
      if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
      }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
      return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
      var prop, i;
      for (i in config) {
        if (hasOwnProp(config, i)) {
          prop = config[i];
          if (isFunction(prop)) {
            this[i] = prop;
          } else {
            this['_' + i] = prop;
          }
        }
      }
      this._config = config;
      this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
      var res = extend({}, parentConfig),
        prop;
      for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
          if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
            res[prop] = {};
            extend(res[prop], parentConfig[prop]);
            extend(res[prop], childConfig[prop]);
          } else if (childConfig[prop] != null) {
            res[prop] = childConfig[prop];
          } else {
            delete res[prop];
          }
        }
      }
      for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
          res[prop] = extend({}, res[prop]);
        }
      }
      return res;
    }
    function Locale(config) {
      if (config != null) {
        this.set(config);
      }
    }
    var keys;
    if (Object.keys) {
      keys = Object.keys;
    } else {
      keys = function keys(obj) {
        var i,
          res = [];
        for (i in obj) {
          if (hasOwnProp(obj, i)) {
            res.push(i);
          }
        }
        return res;
      };
    }
    var defaultCalendar = {
      sameDay: '[Today at] LT',
      nextDay: '[Tomorrow at] LT',
      nextWeek: 'dddd [at] LT',
      lastDay: '[Yesterday at] LT',
      lastWeek: '[Last] dddd [at] LT',
      sameElse: 'L'
    };
    function calendar(key, mom, now) {
      var output = this._calendar[key] || this._calendar['sameElse'];
      return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
      var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
      return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
      localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
      formatFunctions = {},
      formatTokenFunctions = {};
    function addFormatToken(token, padded, ordinal, callback) {
      var func = callback;
      if (typeof callback === 'string') {
        func = function func() {
          return this[callback]();
        };
      }
      if (token) {
        formatTokenFunctions[token] = func;
      }
      if (padded) {
        formatTokenFunctions[padded[0]] = function () {
          return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
      }
      if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
          return this.localeData().ordinal(func.apply(this, arguments), token);
        };
      }
    }
    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
      }
      return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
      var array = format.match(formattingTokens),
        i,
        length;
      for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
          array[i] = formatTokenFunctions[array[i]];
        } else {
          array[i] = removeFormattingTokens(array[i]);
        }
      }
      return function (mom) {
        var output = '',
          i;
        for (i = 0; i < length; i++) {
          output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
      };
    }
    function formatMoment(m, format) {
      if (!m.isValid()) {
        return m.localeData().invalidDate();
      }
      format = expandFormat(format, m.localeData());
      formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
      return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
      var i = 5;
      function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
      }
      localFormattingTokens.lastIndex = 0;
      while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
      }
      return format;
    }
    var defaultLongDateFormat = {
      LTS: 'h:mm:ss A',
      LT: 'h:mm A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
      var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];
      if (format || !formatUpper) {
        return format;
      }
      this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function (tok) {
        if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') {
          return tok.slice(1);
        }
        return tok;
      }).join('');
      return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
      return this._invalidDate;
    }
    var defaultOrdinal = '%d',
      defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
      return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      ss: '%d seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      w: 'a week',
      ww: '%d weeks',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
      var output = this._relativeTime[string];
      return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
      var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
      return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
      var lowerCase = unit.toLowerCase();
      aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
      return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
      var normalizedInput = {},
        normalizedProp,
        prop;
      for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
          normalizedProp = normalizeUnits(prop);
          if (normalizedProp) {
            normalizedInput[normalizedProp] = inputObject[prop];
          }
        }
      }
      return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
      priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
      var units = [],
        u;
      for (u in unitsObj) {
        if (hasOwnProp(unitsObj, u)) {
          units.push({
            unit: u,
            priority: priorities[u]
          });
        }
      }
      units.sort(function (a, b) {
        return a.priority - b.priority;
      });
      return units;
    }
    function isLeapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
      if (number < 0) {
        return Math.ceil(number) || 0;
      } else {
        return Math.floor(number);
      }
    }
    function toInt(argumentForCoercion) {
      var coercedNumber = +argumentForCoercion,
        value = 0;
      if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
      }
      return value;
    }
    function makeGetSet(unit, keepTime) {
      return function (value) {
        if (value != null) {
          set$1(this, unit, value);
          hooks.updateOffset(this, keepTime);
          return this;
        } else {
          return get(this, unit);
        }
      };
    }
    function get(mom, unit) {
      return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
      if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
          value = toInt(value);
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        } else {
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
      }
    }
    function stringGet(units) {
      units = normalizeUnits(units);
      if (isFunction(this[units])) {
        return this[units]();
      }
      return this;
    }
    function stringSet(units, value) {
      if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units),
          i,
          prioritizedLen = prioritized.length;
        for (i = 0; i < prioritizedLen; i++) {
          this[prioritized[i].unit](units[prioritized[i].unit]);
        }
      } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
          return this[units](value);
        }
      }
      return this;
    }
    var match1 = /\d/,
      match2 = /\d\d/,
      match3 = /\d{3}/,
      match4 = /\d{4}/,
      match6 = /[+-]?\d{6}/,
      match1to2 = /\d\d?/,
      match3to4 = /\d\d\d\d?/,
      match5to6 = /\d\d\d\d\d\d?/,
      match1to3 = /\d{1,3}/,
      match1to4 = /\d{1,4}/,
      match1to6 = /[+-]?\d{1,6}/,
      matchUnsigned = /\d+/,
      matchSigned = /[+-]?\d+/,
      matchOffset = /Z|[+-]\d\d:?\d\d/gi,
      matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
      matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
      matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
      regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
      regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return isStrict && strictRegex ? strictRegex : regex;
      };
    }
    function getParseRegexForToken(token, config) {
      if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
      }
      return regexes[token](config._strict, config._locale);
    }
    function unescapeFormat(s) {
      return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
      }));
    }
    function regexEscape(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    var tokens = {};
    function addParseToken(token, callback) {
      var i,
        func = callback,
        tokenLen;
      if (typeof token === 'string') {
        token = [token];
      }
      if (isNumber(callback)) {
        func = function func(input, array) {
          array[callback] = toInt(input);
        };
      }
      tokenLen = token.length;
      for (i = 0; i < tokenLen; i++) {
        tokens[token[i]] = func;
      }
    }
    function addWeekParseToken(token, callback) {
      addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
      });
    }
    function addTimeToArrayFromToken(token, input, config) {
      if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
      }
    }
    var YEAR = 0,
      MONTH = 1,
      DATE = 2,
      HOUR = 3,
      MINUTE = 4,
      SECOND = 5,
      MILLISECOND = 6,
      WEEK = 7,
      WEEKDAY = 8;
    function mod(n, x) {
      return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) {
      indexOf = Array.prototype.indexOf;
    } else {
      indexOf = function indexOf(o) {
        var i;
        for (i = 0; i < this.length; ++i) {
          if (this[i] === o) {
            return i;
          }
        }
        return -1;
      };
    }
    function daysInMonth(year, month) {
      if (isNaN(year) || isNaN(month)) {
        return NaN;
      }
      var modMonth = mod(month, 12);
      year += (month - modMonth) / 12;
      return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    addFormatToken('M', ['MM', 2], 'Mo', function () {
      return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function (format) {
      return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function (format) {
      return this.localeData().months(this, format);
    });
    addUnitAlias('month', 'M');
    addUnitPriority('month', 8);
    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
      return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
      return locale.monthsRegex(isStrict);
    });
    addParseToken(['M', 'MM'], function (input, array) {
      array[MONTH] = toInt(input) - 1;
    });
    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
      var month = config._locale.monthsParse(input, token, config._strict);
      if (month != null) {
        array[MONTH] = month;
      } else {
        getParsingFlags(config).invalidMonth = input;
      }
    });
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
      defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
      defaultMonthsShortRegex = matchWord,
      defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
      if (!m) {
        return isArray(this._months) ? this._months : this._months['standalone'];
      }
      return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
      if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
      }
      return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
      var i,
        ii,
        mom,
        llc = monthName.toLocaleLowerCase();
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
          mom = createUTC([2000, i]);
          this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
          this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeMonthsParse(monthName, format, strict) {
      var i, mom, regex;
      if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
      }
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
      }
      for (i = 0; i < 12; i++) {
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
          this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
          this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
          regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
          this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
          return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
          return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
          return i;
        }
      }
    }
    function setMonth(mom, value) {
      var dayOfMonth;
      if (!mom.isValid()) {
        return mom;
      }
      if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
          value = toInt(value);
        } else {
          value = mom.localeData().monthsParse(value);
          if (!isNumber(value)) {
            return mom;
          }
        }
      }
      dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
      mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
      return mom;
    }
    function getSetMonth(value) {
      if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
      } else {
        return get(this, 'Month');
      }
    }
    function getDaysInMonth() {
      return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsShortStrictRegex;
        } else {
          return this._monthsShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
          this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
      }
    }
    function monthsRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsStrictRegex;
        } else {
          return this._monthsRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
          this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
      }
    }
    function computeMonthsParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom;
      for (i = 0; i < 12; i++) {
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
      }
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
      }
      for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
      }
      this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._monthsShortRegex = this._monthsRegex;
      this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    addFormatToken('Y', 0, 0, function () {
      var y = this.year();
      return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, ['YY', 2], 0, function () {
      return this.year() % 100;
    });
    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
    addUnitAlias('year', 'y');
    addUnitPriority('year', 1);
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
      array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
      array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
      array[YEAR] = parseInt(input, 10);
    });
    function daysInYear(year) {
      return isLeapYear(year) ? 366 : 365;
    }
    hooks.parseTwoDigitYear = function (input) {
      return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
      return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
      var date;
      if (y < 100 && y >= 0) {
        date = new Date(y + 400, m, d, h, M, s, ms);
        if (isFinite(date.getFullYear())) {
          date.setFullYear(y);
        }
      } else {
        date = new Date(y, m, d, h, M, s, ms);
      }
      return date;
    }
    function createUTCDate(y) {
      var date, args;
      if (y < 100 && y >= 0) {
        args = Array.prototype.slice.call(arguments);
        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));
        if (isFinite(date.getUTCFullYear())) {
          date.setUTCFullYear(y);
        }
      } else {
        date = new Date(Date.UTC.apply(null, arguments));
      }
      return date;
    }
    function firstWeekOffset(year, dow, doy) {
      var fwd = 7 + dow - doy,
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
      return -fwdlw + fwd - 1;
    }
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
      var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear,
        resDayOfYear;
      if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
      } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
      } else {
        resYear = year;
        resDayOfYear = dayOfYear;
      }
      return {
        year: resYear,
        dayOfYear: resDayOfYear
      };
    }
    function weekOfYear(mom, dow, doy) {
      var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek,
        resYear;
      if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
      } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
      } else {
        resYear = mom.year();
        resWeek = week;
      }
      return {
        week: resWeek,
        year: resYear
      };
    }
    function weeksInYear(year, dow, doy) {
      var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
      return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');
    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);
    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
      week[token.substr(0, 1)] = toInt(input);
    });
    function localeWeek(mom) {
      return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
      dow: 0,
      doy: 6
    };
    function localeFirstDayOfWeek() {
      return this._week.dow;
    }
    function localeFirstDayOfYear() {
      return this._week.doy;
    }
    function getSetWeek(input) {
      var week = this.localeData().week(this);
      return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
      var week = weekOfYear(this, 1, 4).week;
      return input == null ? week : this.add((input - week) * 7, 'd');
    }
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function (format) {
      return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function (format) {
      return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function (format) {
      return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
      return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
      return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
      return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
      var weekday = config._locale.weekdaysParse(input, token, config._strict);
      if (weekday != null) {
        week.d = weekday;
      } else {
        getParsingFlags(config).invalidWeekday = input;
      }
    });
    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
      week[token] = toInt(input);
    });
    function parseWeekday(input, locale) {
      if (typeof input !== 'string') {
        return input;
      }
      if (!isNaN(input)) {
        return parseInt(input, 10);
      }
      input = locale.weekdaysParse(input);
      if (typeof input === 'number') {
        return input;
      }
      return null;
    }
    function parseIsoWeekday(input, locale) {
      if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
      }
      return isNaN(input) ? null : input;
    }
    function shiftWeekdays(ws, n) {
      return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      defaultWeekdaysRegex = matchWord,
      defaultWeekdaysShortRegex = matchWord,
      defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
      var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
      return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
      return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
      return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
      var i,
        ii,
        mom,
        llc = weekdayName.toLocaleLowerCase();
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];
        for (i = 0; i < 7; ++i) {
          mom = createUTC([2000, 1]).day(i);
          this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
          this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
          this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
      var i, mom, regex;
      if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
      }
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
      }
      for (i = 0; i < 7; i++) {
        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
          this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
          this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
          this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
          regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
          this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
          return i;
        }
      }
    }
    function getSetDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
      if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
      } else {
        return day;
      }
    }
    function getSetLocaleDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
      } else {
        return this.day() || 7;
      }
    }
    function weekdaysRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysStrictRegex;
        } else {
          return this._weekdaysRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
      }
    }
    function weekdaysShortRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysShortStrictRegex;
        } else {
          return this._weekdaysShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
          this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
      }
    }
    function weekdaysMinRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysMinStrictRegex;
        } else {
          return this._weekdaysMinRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
          this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
      }
    }
    function computeWeekdaysParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var minPieces = [],
        shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        minp,
        shortp,
        longp;
      for (i = 0; i < 7; i++) {
        mom = createUTC([2000, 1]).day(i);
        minp = regexEscape(this.weekdaysMin(mom, ''));
        shortp = regexEscape(this.weekdaysShort(mom, ''));
        longp = regexEscape(this.weekdays(mom, ''));
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
      }
      minPieces.sort(cmpLenRev);
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._weekdaysShortRegex = this._weekdaysRegex;
      this._weekdaysMinRegex = this._weekdaysRegex;
      this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
      this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    function hFormat() {
      return this.hours() % 12 || 12;
    }
    function kFormat() {
      return this.hours() || 24;
    }
    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);
    addFormatToken('hmm', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
      addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
      });
    }
    meridiem('a', true);
    meridiem('A', false);
    addUnitAlias('hour', 'h');
    addUnitPriority('hour', 13);
    function matchMeridiem(isStrict, locale) {
      return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
      var kInput = toInt(input);
      array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
      config._isPm = config._locale.isPM(input);
      config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
      array[HOUR] = toInt(input);
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
    });
    function localeIsPM(input) {
      return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
      getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? 'pm' : 'PM';
      } else {
        return isLower ? 'am' : 'AM';
      }
    }
    var baseConfig = {
      calendar: defaultCalendar,
      longDateFormat: defaultLongDateFormat,
      invalidDate: defaultInvalidDate,
      ordinal: defaultOrdinal,
      dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
      relativeTime: defaultRelativeTime,
      months: defaultLocaleMonths,
      monthsShort: defaultLocaleMonthsShort,
      week: defaultLocaleWeek,
      weekdays: defaultLocaleWeekdays,
      weekdaysMin: defaultLocaleWeekdaysMin,
      weekdaysShort: defaultLocaleWeekdaysShort,
      meridiemParse: defaultLocaleMeridiemParse
    };
    var locales = {},
      localeFamilies = {},
      globalLocale;
    function commonPrefix(arr1, arr2) {
      var i,
        minl = Math.min(arr1.length, arr2.length);
      for (i = 0; i < minl; i += 1) {
        if (arr1[i] !== arr2[i]) {
          return i;
        }
      }
      return minl;
    }
    function normalizeLocale(key) {
      return key ? key.toLowerCase().replace('_', '-') : key;
    }
    function chooseLocale(names) {
      var i = 0,
        j,
        next,
        locale,
        split;
      while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
          locale = loadLocale(split.slice(0, j).join('-'));
          if (locale) {
            return locale;
          }
          if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
            break;
          }
          j--;
        }
        i++;
      }
      return globalLocale;
    }
    function isLocaleNameSane(name) {
      return name.match('^[^/\\\\]*$') != null;
    }
    function loadLocale(name) {
      var oldLocale = null,
        aliasedRequire;
      if (locales[name] === undefined && 'object' !== 'undefined' && module && module.exports && isLocaleNameSane(name)) {
        try {
          oldLocale = globalLocale._abbr;
          aliasedRequire = commonjsRequire$1$1;
          aliasedRequire('./locale/' + name);
          getSetGlobalLocale(oldLocale);
        } catch (e) {
          locales[name] = null;
        }
      }
      return locales[name];
    }
    function getSetGlobalLocale(key, values) {
      var data;
      if (key) {
        if (isUndefined(values)) {
          data = getLocale(key);
        } else {
          data = defineLocale(key, values);
        }
        if (data) {
          globalLocale = data;
        } else {
          if (typeof console !== 'undefined' && console.warn) {
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
          }
        }
      }
      return globalLocale._abbr;
    }
    function defineLocale(name, config) {
      if (config !== null) {
        var locale,
          parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
          deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
          parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
          if (locales[config.parentLocale] != null) {
            parentConfig = locales[config.parentLocale]._config;
          } else {
            locale = loadLocale(config.parentLocale);
            if (locale != null) {
              parentConfig = locale._config;
            } else {
              if (!localeFamilies[config.parentLocale]) {
                localeFamilies[config.parentLocale] = [];
              }
              localeFamilies[config.parentLocale].push({
                name: name,
                config: config
              });
              return null;
            }
          }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));
        if (localeFamilies[name]) {
          localeFamilies[name].forEach(function (x) {
            defineLocale(x.name, x.config);
          });
        }
        getSetGlobalLocale(name);
        return locales[name];
      } else {
        delete locales[name];
        return null;
      }
    }
    function updateLocale(name, config) {
      if (config != null) {
        var locale,
          tmpLocale,
          parentConfig = baseConfig;
        if (locales[name] != null && locales[name].parentLocale != null) {
          locales[name].set(mergeConfigs(locales[name]._config, config));
        } else {
          tmpLocale = loadLocale(name);
          if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
          }
          config = mergeConfigs(parentConfig, config);
          if (tmpLocale == null) {
            config.abbr = name;
          }
          locale = new Locale(config);
          locale.parentLocale = locales[name];
          locales[name] = locale;
        }
        getSetGlobalLocale(name);
      } else {
        if (locales[name] != null) {
          if (locales[name].parentLocale != null) {
            locales[name] = locales[name].parentLocale;
            if (name === getSetGlobalLocale()) {
              getSetGlobalLocale(name);
            }
          } else if (locales[name] != null) {
            delete locales[name];
          }
        }
      }
      return locales[name];
    }
    function getLocale(key) {
      var locale;
      if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
      }
      if (!key) {
        return globalLocale;
      }
      if (!isArray(key)) {
        locale = loadLocale(key);
        if (locale) {
          return locale;
        }
        key = [key];
      }
      return chooseLocale(key);
    }
    function listLocales() {
      return keys(locales);
    }
    function checkOverflow(m) {
      var overflow,
        a = m._a;
      if (a && getParsingFlags(m).overflow === -2) {
        overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
          overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
          overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
          overflow = WEEKDAY;
        }
        getParsingFlags(m).overflow = overflow;
      }
      return m;
    }
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
      isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/], ['YYYYMM', /\d{6}/, false], ['YYYY', /\d{4}/, false]],
      isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]],
      aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
      rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
      obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
      };
    function configFromISO(config) {
      var i,
        l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime,
        dateFormat,
        timeFormat,
        tzFormat,
        isoDatesLen = isoDates.length,
        isoTimesLen = isoTimes.length;
      if (match) {
        getParsingFlags(config).iso = true;
        for (i = 0, l = isoDatesLen; i < l; i++) {
          if (isoDates[i][1].exec(match[1])) {
            dateFormat = isoDates[i][0];
            allowTime = isoDates[i][2] !== false;
            break;
          }
        }
        if (dateFormat == null) {
          config._isValid = false;
          return;
        }
        if (match[3]) {
          for (i = 0, l = isoTimesLen; i < l; i++) {
            if (isoTimes[i][1].exec(match[3])) {
              timeFormat = (match[2] || ' ') + isoTimes[i][0];
              break;
            }
          }
          if (timeFormat == null) {
            config._isValid = false;
            return;
          }
        }
        if (!allowTime && timeFormat != null) {
          config._isValid = false;
          return;
        }
        if (match[4]) {
          if (tzRegex.exec(match[4])) {
            tzFormat = 'Z';
          } else {
            config._isValid = false;
            return;
          }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
      } else {
        config._isValid = false;
      }
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
      var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];
      if (secondStr) {
        result.push(parseInt(secondStr, 10));
      }
      return result;
    }
    function untruncateYear(yearStr) {
      var year = parseInt(yearStr, 10);
      if (year <= 49) {
        return 2000 + year;
      } else if (year <= 999) {
        return 1900 + year;
      }
      return year;
    }
    function preprocessRFC2822(s) {
      return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
      if (weekdayStr) {
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
          weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
          getParsingFlags(config).weekdayMismatch = true;
          config._isValid = false;
          return false;
        }
      }
      return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
      if (obsOffset) {
        return obsOffsets[obsOffset];
      } else if (militaryOffset) {
        return 0;
      } else {
        var hm = parseInt(numOffset, 10),
          m = hm % 100,
          h = (hm - m) / 100;
        return h * 60 + m;
      }
    }
    function configFromRFC2822(config) {
      var match = rfc2822.exec(preprocessRFC2822(config._i)),
        parsedArray;
      if (match) {
        parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
          return;
        }
        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);
        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        getParsingFlags(config).rfc2822 = true;
      } else {
        config._isValid = false;
      }
    }
    function configFromString(config) {
      var matched = aspNetJsonRegex.exec(config._i);
      if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
      }
      configFromISO(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      configFromRFC2822(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      if (config._strict) {
        config._isValid = false;
      } else {
        hooks.createFromInputFallback(config);
      }
    }
    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
      config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    function defaults(a, b, c) {
      if (a != null) {
        return a;
      }
      if (b != null) {
        return b;
      }
      return c;
    }
    function currentDateArray(config) {
      var nowValue = new Date(hooks.now());
      if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
      }
      return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }
    function configFromArray(config) {
      var i,
        date,
        input = [],
        currentDate,
        expectedWeekday,
        yearToUse;
      if (config._d) {
        return;
      }
      currentDate = currentDateArray(config);
      if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
      }
      if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
          getParsingFlags(config)._overflowDayOfYear = true;
        }
        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
      }
      for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
      }
      for (; i < 7; i++) {
        config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
      }
      if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
      }
      config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
      expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
      if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
      }
      if (config._nextDay) {
        config._a[HOUR] = 24;
      }
      if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
      }
    }
    function dayOfYearFromWeekInfo(config) {
      var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
      w = config._w;
      if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
          weekdayOverflow = true;
        }
      } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;
        curWeek = weekOfYear(createLocal(), dow, doy);
        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
        week = defaults(w.w, curWeek.week);
        if (w.d != null) {
          weekday = w.d;
          if (weekday < 0 || weekday > 6) {
            weekdayOverflow = true;
          }
        } else if (w.e != null) {
          weekday = w.e + dow;
          if (w.e < 0 || w.e > 6) {
            weekdayOverflow = true;
          }
        } else {
          weekday = dow;
        }
      }
      if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
      } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
      } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
      }
    }
    hooks.ISO_8601 = function () {};
    hooks.RFC_2822 = function () {};
    function configFromStringAndFormat(config) {
      if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
      }
      if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
      }
      config._a = [];
      getParsingFlags(config).empty = true;
      var string = '' + config._i,
        i,
        parsedInput,
        tokens,
        token,
        skipped,
        stringLength = string.length,
        totalParsedInputLength = 0,
        era,
        tokenLen;
      tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
      tokenLen = tokens.length;
      for (i = 0; i < tokenLen; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        if (parsedInput) {
          skipped = string.substr(0, string.indexOf(parsedInput));
          if (skipped.length > 0) {
            getParsingFlags(config).unusedInput.push(skipped);
          }
          string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
          totalParsedInputLength += parsedInput.length;
        }
        if (formatTokenFunctions[token]) {
          if (parsedInput) {
            getParsingFlags(config).empty = false;
          } else {
            getParsingFlags(config).unusedTokens.push(token);
          }
          addTimeToArrayFromToken(token, parsedInput, config);
        } else if (config._strict && !parsedInput) {
          getParsingFlags(config).unusedTokens.push(token);
        }
      }
      getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
      if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
      }
      if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
      }
      getParsingFlags(config).parsedDateParts = config._a.slice(0);
      getParsingFlags(config).meridiem = config._meridiem;
      config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
      era = getParsingFlags(config).era;
      if (era !== null) {
        config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
      }
      configFromArray(config);
      checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
      var isPm;
      if (meridiem == null) {
        return hour;
      }
      if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
      } else if (locale.isPM != null) {
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
          hour += 12;
        }
        if (!isPm && hour === 12) {
          hour = 0;
        }
        return hour;
      } else {
        return hour;
      }
    }
    function configFromStringAndArray(config) {
      var tempConfig,
        bestMoment,
        scoreToBeat,
        i,
        currentScore,
        validFormatFound,
        bestFormatIsValid = false,
        configfLen = config._f.length;
      if (configfLen === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
      }
      for (i = 0; i < configfLen; i++) {
        currentScore = 0;
        validFormatFound = false;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
          tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);
        if (isValid(tempConfig)) {
          validFormatFound = true;
        }
        currentScore += getParsingFlags(tempConfig).charsLeftOver;
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
        getParsingFlags(tempConfig).score = currentScore;
        if (!bestFormatIsValid) {
          if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
            if (validFormatFound) {
              bestFormatIsValid = true;
            }
          }
        } else {
          if (currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
          }
        }
      }
      extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
      if (config._d) {
        return;
      }
      var i = normalizeObjectUnits(config._i),
        dayOrDate = i.day === undefined ? i.date : i.day;
      config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
      });
      configFromArray(config);
    }
    function createFromConfig(config) {
      var res = new Moment(checkOverflow(prepareConfig(config)));
      if (res._nextDay) {
        res.add(1, 'd');
        res._nextDay = undefined;
      }
      return res;
    }
    function prepareConfig(config) {
      var input = config._i,
        format = config._f;
      config._locale = config._locale || getLocale(config._l);
      if (input === null || format === undefined && input === '') {
        return createInvalid({
          nullInput: true
        });
      }
      if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
      }
      if (isMoment(input)) {
        return new Moment(checkOverflow(input));
      } else if (isDate(input)) {
        config._d = input;
      } else if (isArray(format)) {
        configFromStringAndArray(config);
      } else if (format) {
        configFromStringAndFormat(config);
      } else {
        configFromInput(config);
      }
      if (!isValid(config)) {
        config._d = null;
      }
      return config;
    }
    function configFromInput(config) {
      var input = config._i;
      if (isUndefined(input)) {
        config._d = new Date(hooks.now());
      } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
      } else if (typeof input === 'string') {
        configFromString(config);
      } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
          return parseInt(obj, 10);
        });
        configFromArray(config);
      } else if (isObject(input)) {
        configFromObject(config);
      } else if (isNumber(input)) {
        config._d = new Date(input);
      } else {
        hooks.createFromInputFallback(config);
      }
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
      var c = {};
      if (format === true || format === false) {
        strict = format;
        format = undefined;
      }
      if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
      }
      if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
        input = undefined;
      }
      c._isAMomentObject = true;
      c._useUTC = c._isUTC = isUTC;
      c._l = locale;
      c._i = input;
      c._f = format;
      c._strict = strict;
      return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other < this ? this : other;
        } else {
          return createInvalid();
        }
      }),
      prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other > this ? this : other;
        } else {
          return createInvalid();
        }
      });
    function pickBy(fn, moments) {
      var res, i;
      if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
      }
      if (!moments.length) {
        return createLocal();
      }
      res = moments[0];
      for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
          res = moments[i];
        }
      }
      return res;
    }
    function min() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isBefore', args);
    }
    function max() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isAfter', args);
    }
    var now = function now() {
      return Date.now ? Date.now() : +new Date();
    };
    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
    function isDurationValid(m) {
      var key,
        unitHasDecimal = false,
        i,
        orderLen = ordering.length;
      for (key in m) {
        if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
          return false;
        }
      }
      for (i = 0; i < orderLen; ++i) {
        if (m[ordering[i]]) {
          if (unitHasDecimal) {
            return false;
          }
          if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
            unitHasDecimal = true;
          }
        }
      }
      return true;
    }
    function isValid$1() {
      return this._isValid;
    }
    function createInvalid$1() {
      return createDuration(NaN);
    }
    function Duration(duration) {
      var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;
      this._isValid = isDurationValid(normalizedInput);
      this._milliseconds = +milliseconds + seconds * 1e3 + minutes * 6e4 + hours * 1000 * 60 * 60;
      this._days = +days + weeks * 7;
      this._months = +months + quarters * 3 + years * 12;
      this._data = {};
      this._locale = getLocale();
      this._bubble();
    }
    function isDuration(obj) {
      return obj instanceof Duration;
    }
    function absRound(number) {
      if (number < 0) {
        return Math.round(-1 * number) * -1;
      } else {
        return Math.round(number);
      }
    }
    function compareArrays(array1, array2, dontConvert) {
      var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
      for (i = 0; i < len; i++) {
        if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
          diffs++;
        }
      }
      return diffs + lengthDiff;
    }
    function offset(token, separator) {
      addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset(),
          sign = '+';
        if (offset < 0) {
          offset = -offset;
          sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
      });
    }
    offset('Z', ':');
    offset('ZZ', '');
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
      config._useUTC = true;
      config._tzm = offsetFromString(matchShortOffset, input);
    });
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
      var matches = (string || '').match(matcher),
        chunk,
        parts,
        minutes;
      if (matches === null) {
        return null;
      }
      chunk = matches[matches.length - 1] || [];
      parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
      minutes = +(parts[1] * 60) + toInt(parts[2]);
      return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    function cloneWithOffset(input, model) {
      var res, diff;
      if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
      } else {
        return createLocal(input).local();
      }
    }
    function getDateOffset(m) {
      return -Math.round(m._d.getTimezoneOffset());
    }
    hooks.updateOffset = function () {};
    function getSetOffset(input, keepLocalTime, keepMinutes) {
      var offset = this._offset || 0,
        localAdjust;
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        if (typeof input === 'string') {
          input = offsetFromString(matchShortOffset, input);
          if (input === null) {
            return this;
          }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
          input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
          localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
          this.add(localAdjust, 'm');
        }
        if (offset !== input) {
          if (!keepLocalTime || this._changeInProgress) {
            addSubtract(this, createDuration(input - offset, 'm'), 1, false);
          } else if (!this._changeInProgress) {
            this._changeInProgress = true;
            hooks.updateOffset(this, true);
            this._changeInProgress = null;
          }
        }
        return this;
      } else {
        return this._isUTC ? offset : getDateOffset(this);
      }
    }
    function getSetZone(input, keepLocalTime) {
      if (input != null) {
        if (typeof input !== 'string') {
          input = -input;
        }
        this.utcOffset(input, keepLocalTime);
        return this;
      } else {
        return -this.utcOffset();
      }
    }
    function setOffsetToUTC(keepLocalTime) {
      return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
      if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;
        if (keepLocalTime) {
          this.subtract(getDateOffset(this), 'm');
        }
      }
      return this;
    }
    function setOffsetToParsedOffset() {
      if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
      } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
          this.utcOffset(tZone);
        } else {
          this.utcOffset(0, true);
        }
      }
      return this;
    }
    function hasAlignedHourOffset(input) {
      if (!this.isValid()) {
        return false;
      }
      input = input ? createLocal(input).utcOffset() : 0;
      return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
      return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
      if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
      }
      var c = {},
        other;
      copyConfig(c, this);
      c = prepareConfig(c);
      if (c._a) {
        other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
      } else {
        this._isDSTShifted = false;
      }
      return this._isDSTShifted;
    }
    function isLocal() {
      return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
      return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
      isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
      var duration = input,
        match = null,
        sign,
        ret,
        diffRes;
      if (isDuration(input)) {
        duration = {
          ms: input._milliseconds,
          d: input._days,
          M: input._months
        };
      } else if (isNumber(input) || !isNaN(+input)) {
        duration = {};
        if (key) {
          duration[key] = +input;
        } else {
          duration.milliseconds = +input;
        }
      } else if (match = aspNetRegex.exec(input)) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: 0,
          d: toInt(match[DATE]) * sign,
          h: toInt(match[HOUR]) * sign,
          m: toInt(match[MINUTE]) * sign,
          s: toInt(match[SECOND]) * sign,
          ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
        };
      } else if (match = isoRegex.exec(input)) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: parseIso(match[2], sign),
          M: parseIso(match[3], sign),
          w: parseIso(match[4], sign),
          d: parseIso(match[5], sign),
          h: parseIso(match[6], sign),
          m: parseIso(match[7], sign),
          s: parseIso(match[8], sign)
        };
      } else if (duration == null) {
        duration = {};
      } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
      }
      ret = new Duration(duration);
      if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
      }
      if (isDuration(input) && hasOwnProp(input, '_isValid')) {
        ret._isValid = input._isValid;
      }
      return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
      var res = inp && parseFloat(inp.replace(',', '.'));
      return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
      var res = {};
      res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
      if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
      }
      res.milliseconds = +other - +base.clone().add(res.months, 'M');
      return res;
    }
    function momentsDifference(base, other) {
      var res;
      if (!(base.isValid() && other.isValid())) {
        return {
          milliseconds: 0,
          months: 0
        };
      }
      other = cloneWithOffset(other, base);
      if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
      } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
      }
      return res;
    }
    function createAdder(direction, name) {
      return function (val, period) {
        var dur, tmp;
        if (period !== null && !isNaN(+period)) {
          deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
          tmp = val;
          val = period;
          period = tmp;
        }
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
      };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
      var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);
      if (!mom.isValid()) {
        return;
      }
      updateOffset = updateOffset == null ? true : updateOffset;
      if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
      }
      if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
      }
      if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
      }
      if (updateOffset) {
        hooks.updateOffset(mom, days || months);
      }
    }
    var add = createAdder(1, 'add'),
      subtract = createAdder(-1, 'subtract');
    function isString(input) {
      return typeof input === 'string' || input instanceof String;
    }
    function isMomentInput(input) {
      return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['years', 'year', 'y', 'months', 'month', 'M', 'days', 'day', 'd', 'dates', 'date', 'D', 'hours', 'hour', 'h', 'minutes', 'minute', 'm', 'seconds', 'second', 's', 'milliseconds', 'millisecond', 'ms'],
        i,
        property,
        propertyLen = properties.length;
      for (i = 0; i < propertyLen; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
      var arrayTest = isArray(input),
        dataTypeTest = false;
      if (arrayTest) {
        dataTypeTest = input.filter(function (item) {
          return !isNumber(item) && isString(input);
        }).length === 0;
      }
      return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'],
        i,
        property;
      for (i = 0; i < properties.length; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
      var diff = myMoment.diff(now, 'days', true);
      return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
      if (arguments.length === 1) {
        if (!arguments[0]) {
          time = undefined;
          formats = undefined;
        } else if (isMomentInput(arguments[0])) {
          time = arguments[0];
          formats = undefined;
        } else if (isCalendarSpec(arguments[0])) {
          formats = arguments[0];
          time = undefined;
        }
      }
      var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse',
        output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
      return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
      return new Moment(this);
    }
    function isAfter(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
      } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
      }
    }
    function isBefore(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
      } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
      }
    }
    function isBetween(from, to, units, inclusivity) {
      var localFrom = isMoment(from) ? from : createLocal(from),
        localTo = isMoment(to) ? to : createLocal(to);
      if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
      }
      inclusivity = inclusivity || '()';
      return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
      } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
      }
    }
    function isSameOrAfter(input, units) {
      return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
      return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
      var that, zoneDelta, output;
      if (!this.isValid()) {
        return NaN;
      }
      that = cloneWithOffset(input, this);
      if (!that.isValid()) {
        return NaN;
      }
      zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
      units = normalizeUnits(units);
      switch (units) {
        case 'year':
          output = monthDiff(this, that) / 12;
          break;
        case 'month':
          output = monthDiff(this, that);
          break;
        case 'quarter':
          output = monthDiff(this, that) / 3;
          break;
        case 'second':
          output = (this - that) / 1e3;
          break;
        case 'minute':
          output = (this - that) / 6e4;
          break;
        case 'hour':
          output = (this - that) / 36e5;
          break;
        case 'day':
          output = (this - that - zoneDelta) / 864e5;
          break;
        case 'week':
          output = (this - that - zoneDelta) / 6048e5;
          break;
        default:
          output = this - that;
      }
      return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
      if (a.date() < b.date()) {
        return -monthDiff(b, a);
      }
      var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2,
        adjust;
      if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        adjust = (b - anchor) / (anchor - anchor2);
      } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        adjust = (b - anchor) / (anchor2 - anchor);
      }
      return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
      return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
      if (!this.isValid()) {
        return null;
      }
      var utc = keepOffset !== true,
        m = utc ? this.clone().utc() : this;
      if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
      }
      if (isFunction(Date.prototype.toISOString)) {
        if (utc) {
          return this.toDate().toISOString();
        } else {
          return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
      }
      return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    function inspect() {
      if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
      }
      var func = 'moment',
        zone = '',
        prefix,
        year,
        datetime,
        suffix;
      if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
      }
      prefix = '[' + func + '("]';
      year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
      datetime = '-MM-DD[T]HH:mm:ss.SSS';
      suffix = zone + '[")]';
      return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
      if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
      }
      var output = formatMoment(this, inputString);
      return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          to: this,
          from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function fromNow(withoutSuffix) {
      return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          from: this,
          to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function toNow(withoutSuffix) {
      return this.to(createLocal(), withoutSuffix);
    }
    function locale(key) {
      var newLocaleData;
      if (key === undefined) {
        return this._locale._abbr;
      } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
          this._locale = newLocaleData;
        }
        return this;
      }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
      if (key === undefined) {
        return this.localeData();
      } else {
        return this.locale(key);
      }
    });
    function localeData() {
      return this._locale;
    }
    var MS_PER_SECOND = 1000,
      MS_PER_MINUTE = 60 * MS_PER_SECOND,
      MS_PER_HOUR = 60 * MS_PER_MINUTE,
      MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
    function mod$1(dividend, divisor) {
      return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return new Date(y, m, d).valueOf();
      }
    }
    function utcStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return Date.UTC(y, m, d);
      }
    }
    function startOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case 'year':
          time = startOfDate(this.year(), 0, 1);
          break;
        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
          break;
        case 'month':
          time = startOfDate(this.year(), this.month(), 1);
          break;
        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
          break;
        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
          break;
        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date());
          break;
        case 'hour':
          time = this._d.valueOf();
          time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
          break;
        case 'minute':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_MINUTE);
          break;
        case 'second':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_SECOND);
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function endOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case 'year':
          time = startOfDate(this.year() + 1, 0, 1) - 1;
          break;
        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
          break;
        case 'month':
          time = startOfDate(this.year(), this.month() + 1, 1) - 1;
          break;
        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
          break;
        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
          break;
        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
          break;
        case 'hour':
          time = this._d.valueOf();
          time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
          break;
        case 'minute':
          time = this._d.valueOf();
          time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
          break;
        case 'second':
          time = this._d.valueOf();
          time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function valueOf() {
      return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
      return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
      return new Date(this.valueOf());
    }
    function toArray() {
      var m = this;
      return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }
    function toObject() {
      var m = this;
      return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
      };
    }
    function toJSON() {
      return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
      return isValid(this);
    }
    function parsingFlags() {
      return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
      return getParsingFlags(this).overflow;
    }
    function creationData() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (input, array, config, token) {
      var era = config._locale.erasParse(input, token, config._strict);
      if (era) {
        getParsingFlags(config).era = era;
      } else {
        getParsingFlags(config).invalidEra = input;
      }
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
      var match;
      if (config._locale._eraYearOrdinalRegex) {
        match = input.match(config._locale._eraYearOrdinalRegex);
      }
      if (config._locale.eraYearOrdinalParse) {
        array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
      } else {
        array[YEAR] = parseInt(input, 10);
      }
    });
    function localeEras(m, format) {
      var i,
        l,
        date,
        eras = this._eras || getLocale('en')._eras;
      for (i = 0, l = eras.length; i < l; ++i) {
        switch (typeof eras[i].since) {
          case 'string':
            date = hooks(eras[i].since).startOf('day');
            eras[i].since = date.valueOf();
            break;
        }
        switch (typeof eras[i].until) {
          case 'undefined':
            eras[i].until = +Infinity;
            break;
          case 'string':
            date = hooks(eras[i].until).startOf('day').valueOf();
            eras[i].until = date.valueOf();
            break;
        }
      }
      return eras;
    }
    function localeErasParse(eraName, format, strict) {
      var i,
        l,
        eras = this.eras(),
        name,
        abbr,
        narrow;
      eraName = eraName.toUpperCase();
      for (i = 0, l = eras.length; i < l; ++i) {
        name = eras[i].name.toUpperCase();
        abbr = eras[i].abbr.toUpperCase();
        narrow = eras[i].narrow.toUpperCase();
        if (strict) {
          switch (format) {
            case 'N':
            case 'NN':
            case 'NNN':
              if (abbr === eraName) {
                return eras[i];
              }
              break;
            case 'NNNN':
              if (name === eraName) {
                return eras[i];
              }
              break;
            case 'NNNNN':
              if (narrow === eraName) {
                return eras[i];
              }
              break;
          }
        } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
          return eras[i];
        }
      }
    }
    function localeErasConvertYear(era, year) {
      var dir = era.since <= era.until ? +1 : -1;
      if (year === undefined) {
        return hooks(era.since).year();
      } else {
        return hooks(era.since).year() + (year - era.offset) * dir;
      }
    }
    function getEraName() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].name;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].name;
        }
      }
      return '';
    }
    function getEraNarrow() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].narrow;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].narrow;
        }
      }
      return '';
    }
    function getEraAbbr() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].abbr;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].abbr;
        }
      }
      return '';
    }
    function getEraYear() {
      var i,
        l,
        dir,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        dir = eras[i].since <= eras[i].until ? +1 : -1;
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
          return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
      }
      return this.year();
    }
    function erasNameRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNameRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
      if (!hasOwnProp(this, '_erasAbbrRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNarrowRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
      return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
      return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
      return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
      return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
      var abbrPieces = [],
        namePieces = [],
        narrowPieces = [],
        mixedPieces = [],
        i,
        l,
        eras = this.eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        namePieces.push(regexEscape(eras[i].name));
        abbrPieces.push(regexEscape(eras[i].abbr));
        narrowPieces.push(regexEscape(eras[i].narrow));
        mixedPieces.push(regexEscape(eras[i].name));
        mixedPieces.push(regexEscape(eras[i].abbr));
        mixedPieces.push(regexEscape(eras[i].narrow));
      }
      this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
      this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
      this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    addFormatToken(0, ['gg', 2], 0, function () {
      return this.weekYear() % 100;
    });
    addFormatToken(0, ['GG', 2], 0, function () {
      return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
      addFormatToken(0, [token, token.length], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');
    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
      week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
      week[token] = hooks.parseTwoDigitYear(input);
    });
    function getSetWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
      return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
      return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
      var weeksTarget;
      if (input == null) {
        return weekOfYear(this, dow, doy).year;
      } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
          week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
      }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
      var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
      this.year(date.getUTCFullYear());
      this.month(date.getUTCMonth());
      this.date(date.getUTCDate());
      return this;
    }
    addFormatToken('Q', 0, 'Qo', 'quarter');
    addUnitAlias('quarter', 'Q');
    addUnitPriority('quarter', 7);
    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
      array[MONTH] = (toInt(input) - 1) * 3;
    });
    function getSetQuarter(input) {
      return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    addFormatToken('D', ['DD', 2], 'Do', 'date');
    addUnitAlias('date', 'D');
    addUnitPriority('date', 9);
    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
      return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
      array[DATE] = toInt(input.match(match1to2)[0]);
    });
    var getSetDayOfMonth = makeGetSet('Date', true);
    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
    addUnitAlias('dayOfYear', 'DDD');
    addUnitPriority('dayOfYear', 4);
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
      config._dayOfYear = toInt(input);
    });
    function getSetDayOfYear(input) {
      var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
      return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    addFormatToken('m', ['mm', 2], 0, 'minute');
    addUnitAlias('minute', 'm');
    addUnitPriority('minute', 14);
    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);
    var getSetMinute = makeGetSet('Minutes', false);
    addFormatToken('s', ['ss', 2], 0, 'second');
    addUnitAlias('second', 's');
    addUnitPriority('second', 15);
    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);
    var getSetSecond = makeGetSet('Seconds', false);
    addFormatToken('S', 0, 0, function () {
      return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, ['SS', 2], 0, function () {
      return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
      return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
      return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
      return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
      return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
      return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
      return this.millisecond() * 1000000;
    });
    addUnitAlias('millisecond', 'ms');
    addUnitPriority('millisecond', 16);
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
      addRegexToken(token, matchUnsigned);
    }
    function parseMs(input, array) {
      array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for (token = 'S'; token.length <= 9; token += 'S') {
      addParseToken(token, parseMs);
    }
    getSetMillisecond = makeGetSet('Milliseconds', false);
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    function getZoneAbbr() {
      return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
      return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol["for"] != null) {
      proto[Symbol["for"]('nodejs.util.inspect.custom')] = function () {
        return 'Moment<' + this.format() + '>';
      };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
      return createLocal(input * 1000);
    }
    function createInZone() {
      return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
      return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
      var locale = getLocale(),
        utc = createUTC().set(setter, index);
      return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }
      format = format || '';
      if (index != null) {
        return get$1(format, index, field, 'month');
      }
      var i,
        out = [];
      for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
      }
      return out;
    }
    function listWeekdaysImpl(localeSorted, format, index, field) {
      if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }
        format = format || '';
      } else {
        format = localeSorted;
        index = format;
        localeSorted = false;
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }
        format = format || '';
      }
      var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0,
        i,
        out = [];
      if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
      }
      for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
      }
      return out;
    }
    function listMonths(format, index) {
      return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
      return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
      eras: [{
        since: '0001-01-01',
        until: +Infinity,
        offset: 1,
        name: 'Anno Domini',
        narrow: 'AD',
        abbr: 'AD'
      }, {
        since: '0000-12-31',
        until: -Infinity,
        offset: 1,
        name: 'Before Christ',
        narrow: 'BC',
        abbr: 'BC'
      }],
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function ordinal(number) {
        var b = number % 10,
          output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        return number + output;
      }
    });
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
      var data = this._data;
      this._milliseconds = mathAbs(this._milliseconds);
      this._days = mathAbs(this._days);
      this._months = mathAbs(this._months);
      data.milliseconds = mathAbs(data.milliseconds);
      data.seconds = mathAbs(data.seconds);
      data.minutes = mathAbs(data.minutes);
      data.hours = mathAbs(data.hours);
      data.months = mathAbs(data.months);
      data.years = mathAbs(data.years);
      return this;
    }
    function addSubtract$1(duration, input, value, direction) {
      var other = createDuration(input, value);
      duration._milliseconds += direction * other._milliseconds;
      duration._days += direction * other._days;
      duration._months += direction * other._months;
      return duration._bubble();
    }
    function add$1(input, value) {
      return addSubtract$1(this, input, value, 1);
    }
    function subtract$1(input, value) {
      return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
      if (number < 0) {
        return Math.floor(number);
      } else {
        return Math.ceil(number);
      }
    }
    function bubble() {
      var milliseconds = this._milliseconds,
        days = this._days,
        months = this._months,
        data = this._data,
        seconds,
        minutes,
        hours,
        years,
        monthsFromDays;
      if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
      }
      data.milliseconds = milliseconds % 1000;
      seconds = absFloor(milliseconds / 1000);
      data.seconds = seconds % 60;
      minutes = absFloor(seconds / 60);
      data.minutes = minutes % 60;
      hours = absFloor(minutes / 60);
      data.hours = hours % 24;
      days += absFloor(hours / 24);
      monthsFromDays = absFloor(daysToMonths(days));
      months += monthsFromDays;
      days -= absCeil(monthsToDays(monthsFromDays));
      years = absFloor(months / 12);
      months %= 12;
      data.days = days;
      data.months = months;
      data.years = years;
      return this;
    }
    function daysToMonths(days) {
      return days * 4800 / 146097;
    }
    function monthsToDays(months) {
      return months * 146097 / 4800;
    }
    function as(units) {
      if (!this.isValid()) {
        return NaN;
      }
      var days,
        months,
        milliseconds = this._milliseconds;
      units = normalizeUnits(units);
      if (units === 'month' || units === 'quarter' || units === 'year') {
        days = this._days + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        switch (units) {
          case 'month':
            return months;
          case 'quarter':
            return months / 3;
          case 'year':
            return months / 12;
        }
      } else {
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
          case 'week':
            return days / 7 + milliseconds / 6048e5;
          case 'day':
            return days + milliseconds / 864e5;
          case 'hour':
            return days * 24 + milliseconds / 36e5;
          case 'minute':
            return days * 1440 + milliseconds / 6e4;
          case 'second':
            return days * 86400 + milliseconds / 1000;
          case 'millisecond':
            return Math.floor(days * 864e5) + milliseconds;
          default:
            throw new Error('Unknown unit ' + units);
        }
      }
    }
    function valueOf$1() {
      if (!this.isValid()) {
        return NaN;
      }
      return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
      return function () {
        return this.as(alias);
      };
    }
    var asMilliseconds = makeAs('ms'),
      asSeconds = makeAs('s'),
      asMinutes = makeAs('m'),
      asHours = makeAs('h'),
      asDays = makeAs('d'),
      asWeeks = makeAs('w'),
      asMonths = makeAs('M'),
      asQuarters = makeAs('Q'),
      asYears = makeAs('y');
    function clone$1() {
      return createDuration(this);
    }
    function get$2(units) {
      units = normalizeUnits(units);
      return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
      return function () {
        return this.isValid() ? this._data[name] : NaN;
      };
    }
    var milliseconds = makeGetter('milliseconds'),
      seconds = makeGetter('seconds'),
      minutes = makeGetter('minutes'),
      hours = makeGetter('hours'),
      days = makeGetter('days'),
      months = makeGetter('months'),
      years = makeGetter('years');
    function weeks() {
      return absFloor(this.days() / 7);
    }
    var round = Math.round,
      thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
      };
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
      return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
      var duration = createDuration(posNegDuration).abs(),
        seconds = round(duration.as('s')),
        minutes = round(duration.as('m')),
        hours = round(duration.as('h')),
        days = round(duration.as('d')),
        months = round(duration.as('M')),
        weeks = round(duration.as('w')),
        years = round(duration.as('y')),
        a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days];
      if (thresholds.w != null) {
        a = a || weeks <= 1 && ['w'] || weeks < thresholds.w && ['ww', weeks];
      }
      a = a || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
      a[2] = withoutSuffix;
      a[3] = +posNegDuration > 0;
      a[4] = locale;
      return substituteTimeAgo.apply(null, a);
    }
    function getSetRelativeTimeRounding(roundingFunction) {
      if (roundingFunction === undefined) {
        return round;
      }
      if (typeof roundingFunction === 'function') {
        round = roundingFunction;
        return true;
      }
      return false;
    }
    function getSetRelativeTimeThreshold(threshold, limit) {
      if (thresholds[threshold] === undefined) {
        return false;
      }
      if (limit === undefined) {
        return thresholds[threshold];
      }
      thresholds[threshold] = limit;
      if (threshold === 's') {
        thresholds.ss = limit - 1;
      }
      return true;
    }
    function humanize(argWithSuffix, argThresholds) {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var withSuffix = false,
        th = thresholds,
        locale,
        output;
      if (typeof argWithSuffix === 'object') {
        argThresholds = argWithSuffix;
        argWithSuffix = false;
      }
      if (typeof argWithSuffix === 'boolean') {
        withSuffix = argWithSuffix;
      }
      if (typeof argThresholds === 'object') {
        th = Object.assign({}, thresholds, argThresholds);
        if (argThresholds.s != null && argThresholds.ss == null) {
          th.ss = argThresholds.s - 1;
        }
      }
      locale = this.localeData();
      output = relativeTime$1(this, !withSuffix, th, locale);
      if (withSuffix) {
        output = locale.pastFuture(+this, output);
      }
      return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
      return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var seconds = abs$1(this._milliseconds) / 1000,
        days = abs$1(this._days),
        months = abs$1(this._months),
        minutes,
        hours,
        years,
        s,
        total = this.asSeconds(),
        totalSign,
        ymSign,
        daysSign,
        hmsSign;
      if (!total) {
        return 'P0D';
      }
      minutes = absFloor(seconds / 60);
      hours = absFloor(minutes / 60);
      seconds %= 60;
      minutes %= 60;
      years = absFloor(months / 12);
      months %= 12;
      s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
      totalSign = total < 0 ? '-' : '';
      ymSign = sign(this._months) !== sign(total) ? '-' : '';
      daysSign = sign(this._days) !== sign(total) ? '-' : '';
      hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
      return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
      config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
      config._d = new Date(toInt(input));
    });
    hooks.version = '2.29.4';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    hooks.HTML5_FMT = {
      DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
      DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
      DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
      DATE: 'YYYY-MM-DD',
      TIME: 'HH:mm',
      TIME_SECONDS: 'HH:mm:ss',
      TIME_MS: 'HH:mm:ss.SSS',
      WEEK: 'GGGG-[W]WW',
      MONTH: 'YYYY-MM'
    };
    return hooks;
  });
});
var Chart$1$1 = createCommonjsModule$1$1(function (module, exports) {
  (function (global, factory) {
    module.exports = factory(function () {
      try {
        return moment$1$1;
      } catch (e) {}
    }());
  })(commonjsGlobal$1$1, function (moment) {
    moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
    function createCommonjsModule(fn, module) {
      return module = {
        exports: {}
      }, fn(module, module.exports), module.exports;
    }
    function getCjsExportFromNamespace(n) {
      return n && n['default'] || n;
    }
    var colorName = {
      "aliceblue": [240, 248, 255],
      "antiquewhite": [250, 235, 215],
      "aqua": [0, 255, 255],
      "aquamarine": [127, 255, 212],
      "azure": [240, 255, 255],
      "beige": [245, 245, 220],
      "bisque": [255, 228, 196],
      "black": [0, 0, 0],
      "blanchedalmond": [255, 235, 205],
      "blue": [0, 0, 255],
      "blueviolet": [138, 43, 226],
      "brown": [165, 42, 42],
      "burlywood": [222, 184, 135],
      "cadetblue": [95, 158, 160],
      "chartreuse": [127, 255, 0],
      "chocolate": [210, 105, 30],
      "coral": [255, 127, 80],
      "cornflowerblue": [100, 149, 237],
      "cornsilk": [255, 248, 220],
      "crimson": [220, 20, 60],
      "cyan": [0, 255, 255],
      "darkblue": [0, 0, 139],
      "darkcyan": [0, 139, 139],
      "darkgoldenrod": [184, 134, 11],
      "darkgray": [169, 169, 169],
      "darkgreen": [0, 100, 0],
      "darkgrey": [169, 169, 169],
      "darkkhaki": [189, 183, 107],
      "darkmagenta": [139, 0, 139],
      "darkolivegreen": [85, 107, 47],
      "darkorange": [255, 140, 0],
      "darkorchid": [153, 50, 204],
      "darkred": [139, 0, 0],
      "darksalmon": [233, 150, 122],
      "darkseagreen": [143, 188, 143],
      "darkslateblue": [72, 61, 139],
      "darkslategray": [47, 79, 79],
      "darkslategrey": [47, 79, 79],
      "darkturquoise": [0, 206, 209],
      "darkviolet": [148, 0, 211],
      "deeppink": [255, 20, 147],
      "deepskyblue": [0, 191, 255],
      "dimgray": [105, 105, 105],
      "dimgrey": [105, 105, 105],
      "dodgerblue": [30, 144, 255],
      "firebrick": [178, 34, 34],
      "floralwhite": [255, 250, 240],
      "forestgreen": [34, 139, 34],
      "fuchsia": [255, 0, 255],
      "gainsboro": [220, 220, 220],
      "ghostwhite": [248, 248, 255],
      "gold": [255, 215, 0],
      "goldenrod": [218, 165, 32],
      "gray": [128, 128, 128],
      "green": [0, 128, 0],
      "greenyellow": [173, 255, 47],
      "grey": [128, 128, 128],
      "honeydew": [240, 255, 240],
      "hotpink": [255, 105, 180],
      "indianred": [205, 92, 92],
      "indigo": [75, 0, 130],
      "ivory": [255, 255, 240],
      "khaki": [240, 230, 140],
      "lavender": [230, 230, 250],
      "lavenderblush": [255, 240, 245],
      "lawngreen": [124, 252, 0],
      "lemonchiffon": [255, 250, 205],
      "lightblue": [173, 216, 230],
      "lightcoral": [240, 128, 128],
      "lightcyan": [224, 255, 255],
      "lightgoldenrodyellow": [250, 250, 210],
      "lightgray": [211, 211, 211],
      "lightgreen": [144, 238, 144],
      "lightgrey": [211, 211, 211],
      "lightpink": [255, 182, 193],
      "lightsalmon": [255, 160, 122],
      "lightseagreen": [32, 178, 170],
      "lightskyblue": [135, 206, 250],
      "lightslategray": [119, 136, 153],
      "lightslategrey": [119, 136, 153],
      "lightsteelblue": [176, 196, 222],
      "lightyellow": [255, 255, 224],
      "lime": [0, 255, 0],
      "limegreen": [50, 205, 50],
      "linen": [250, 240, 230],
      "magenta": [255, 0, 255],
      "maroon": [128, 0, 0],
      "mediumaquamarine": [102, 205, 170],
      "mediumblue": [0, 0, 205],
      "mediumorchid": [186, 85, 211],
      "mediumpurple": [147, 112, 219],
      "mediumseagreen": [60, 179, 113],
      "mediumslateblue": [123, 104, 238],
      "mediumspringgreen": [0, 250, 154],
      "mediumturquoise": [72, 209, 204],
      "mediumvioletred": [199, 21, 133],
      "midnightblue": [25, 25, 112],
      "mintcream": [245, 255, 250],
      "mistyrose": [255, 228, 225],
      "moccasin": [255, 228, 181],
      "navajowhite": [255, 222, 173],
      "navy": [0, 0, 128],
      "oldlace": [253, 245, 230],
      "olive": [128, 128, 0],
      "olivedrab": [107, 142, 35],
      "orange": [255, 165, 0],
      "orangered": [255, 69, 0],
      "orchid": [218, 112, 214],
      "palegoldenrod": [238, 232, 170],
      "palegreen": [152, 251, 152],
      "paleturquoise": [175, 238, 238],
      "palevioletred": [219, 112, 147],
      "papayawhip": [255, 239, 213],
      "peachpuff": [255, 218, 185],
      "peru": [205, 133, 63],
      "pink": [255, 192, 203],
      "plum": [221, 160, 221],
      "powderblue": [176, 224, 230],
      "purple": [128, 0, 128],
      "rebeccapurple": [102, 51, 153],
      "red": [255, 0, 0],
      "rosybrown": [188, 143, 143],
      "royalblue": [65, 105, 225],
      "saddlebrown": [139, 69, 19],
      "salmon": [250, 128, 114],
      "sandybrown": [244, 164, 96],
      "seagreen": [46, 139, 87],
      "seashell": [255, 245, 238],
      "sienna": [160, 82, 45],
      "silver": [192, 192, 192],
      "skyblue": [135, 206, 235],
      "slateblue": [106, 90, 205],
      "slategray": [112, 128, 144],
      "slategrey": [112, 128, 144],
      "snow": [255, 250, 250],
      "springgreen": [0, 255, 127],
      "steelblue": [70, 130, 180],
      "tan": [210, 180, 140],
      "teal": [0, 128, 128],
      "thistle": [216, 191, 216],
      "tomato": [255, 99, 71],
      "turquoise": [64, 224, 208],
      "violet": [238, 130, 238],
      "wheat": [245, 222, 179],
      "white": [255, 255, 255],
      "whitesmoke": [245, 245, 245],
      "yellow": [255, 255, 0],
      "yellowgreen": [154, 205, 50]
    };
    var conversions = createCommonjsModule(function (module) {
      var reverseKeywords = {};
      for (var key in colorName) {
        if (colorName.hasOwnProperty(key)) {
          reverseKeywords[colorName[key]] = key;
        }
      }
      var convert = module.exports = {
        rgb: {
          channels: 3,
          labels: 'rgb'
        },
        hsl: {
          channels: 3,
          labels: 'hsl'
        },
        hsv: {
          channels: 3,
          labels: 'hsv'
        },
        hwb: {
          channels: 3,
          labels: 'hwb'
        },
        cmyk: {
          channels: 4,
          labels: 'cmyk'
        },
        xyz: {
          channels: 3,
          labels: 'xyz'
        },
        lab: {
          channels: 3,
          labels: 'lab'
        },
        lch: {
          channels: 3,
          labels: 'lch'
        },
        hex: {
          channels: 1,
          labels: ['hex']
        },
        keyword: {
          channels: 1,
          labels: ['keyword']
        },
        ansi16: {
          channels: 1,
          labels: ['ansi16']
        },
        ansi256: {
          channels: 1,
          labels: ['ansi256']
        },
        hcg: {
          channels: 3,
          labels: ['h', 'c', 'g']
        },
        apple: {
          channels: 3,
          labels: ['r16', 'g16', 'b16']
        },
        gray: {
          channels: 1,
          labels: ['gray']
        }
      };
      for (var model in convert) {
        if (convert.hasOwnProperty(model)) {
          if (!('channels' in convert[model])) {
            throw new Error('missing channels property: ' + model);
          }
          if (!('labels' in convert[model])) {
            throw new Error('missing channel labels property: ' + model);
          }
          if (convert[model].labels.length !== convert[model].channels) {
            throw new Error('channel and label counts mismatch: ' + model);
          }
          var channels = convert[model].channels;
          var labels = convert[model].labels;
          delete convert[model].channels;
          delete convert[model].labels;
          Object.defineProperty(convert[model], 'channels', {
            value: channels
          });
          Object.defineProperty(convert[model], 'labels', {
            value: labels
          });
        }
      }
      convert.rgb.hsl = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var delta = max - min;
        var h;
        var s;
        var l;
        if (max === min) {
          h = 0;
        } else if (r === max) {
          h = (g - b) / delta;
        } else if (g === max) {
          h = 2 + (b - r) / delta;
        } else if (b === max) {
          h = 4 + (r - g) / delta;
        }
        h = Math.min(h * 60, 360);
        if (h < 0) {
          h += 360;
        }
        l = (min + max) / 2;
        if (max === min) {
          s = 0;
        } else if (l <= 0.5) {
          s = delta / (max + min);
        } else {
          s = delta / (2 - max - min);
        }
        return [h, s * 100, l * 100];
      };
      convert.rgb.hsv = function (rgb) {
        var rdif;
        var gdif;
        var bdif;
        var h;
        var s;
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var v = Math.max(r, g, b);
        var diff = v - Math.min(r, g, b);
        var diffc = function diffc(c) {
          return (v - c) / 6 / diff + 1 / 2;
        };
        if (diff === 0) {
          h = s = 0;
        } else {
          s = diff / v;
          rdif = diffc(r);
          gdif = diffc(g);
          bdif = diffc(b);
          if (r === v) {
            h = bdif - gdif;
          } else if (g === v) {
            h = 1 / 3 + rdif - bdif;
          } else if (b === v) {
            h = 2 / 3 + gdif - rdif;
          }
          if (h < 0) {
            h += 1;
          } else if (h > 1) {
            h -= 1;
          }
        }
        return [h * 360, s * 100, v * 100];
      };
      convert.rgb.hwb = function (rgb) {
        var r = rgb[0];
        var g = rgb[1];
        var b = rgb[2];
        var h = convert.rgb.hsl(rgb)[0];
        var w = 1 / 255 * Math.min(r, Math.min(g, b));
        b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
        return [h, w * 100, b * 100];
      };
      convert.rgb.cmyk = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var c;
        var m;
        var y;
        var k;
        k = Math.min(1 - r, 1 - g, 1 - b);
        c = (1 - r - k) / (1 - k) || 0;
        m = (1 - g - k) / (1 - k) || 0;
        y = (1 - b - k) / (1 - k) || 0;
        return [c * 100, m * 100, y * 100, k * 100];
      };
      function comparativeDistance(x, y) {
        return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
      }
      convert.rgb.keyword = function (rgb) {
        var reversed = reverseKeywords[rgb];
        if (reversed) {
          return reversed;
        }
        var currentClosestDistance = Infinity;
        var currentClosestKeyword;
        for (var keyword in colorName) {
          if (colorName.hasOwnProperty(keyword)) {
            var value = colorName[keyword];
            var distance = comparativeDistance(rgb, value);
            if (distance < currentClosestDistance) {
              currentClosestDistance = distance;
              currentClosestKeyword = keyword;
            }
          }
        }
        return currentClosestKeyword;
      };
      convert.keyword.rgb = function (keyword) {
        return colorName[keyword];
      };
      convert.rgb.xyz = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
        g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
        b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
        var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
        var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
        var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
        return [x * 100, y * 100, z * 100];
      };
      convert.rgb.lab = function (rgb) {
        var xyz = convert.rgb.xyz(rgb);
        var x = xyz[0];
        var y = xyz[1];
        var z = xyz[2];
        var l;
        var a;
        var b;
        x /= 95.047;
        y /= 100;
        z /= 108.883;
        x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
        l = 116 * y - 16;
        a = 500 * (x - y);
        b = 200 * (y - z);
        return [l, a, b];
      };
      convert.hsl.rgb = function (hsl) {
        var h = hsl[0] / 360;
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var t1;
        var t2;
        var t3;
        var rgb;
        var val;
        if (s === 0) {
          val = l * 255;
          return [val, val, val];
        }
        if (l < 0.5) {
          t2 = l * (1 + s);
        } else {
          t2 = l + s - l * s;
        }
        t1 = 2 * l - t2;
        rgb = [0, 0, 0];
        for (var i = 0; i < 3; i++) {
          t3 = h + 1 / 3 * -(i - 1);
          if (t3 < 0) {
            t3++;
          }
          if (t3 > 1) {
            t3--;
          }
          if (6 * t3 < 1) {
            val = t1 + (t2 - t1) * 6 * t3;
          } else if (2 * t3 < 1) {
            val = t2;
          } else if (3 * t3 < 2) {
            val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
          } else {
            val = t1;
          }
          rgb[i] = val * 255;
        }
        return rgb;
      };
      convert.hsl.hsv = function (hsl) {
        var h = hsl[0];
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var smin = s;
        var lmin = Math.max(l, 0.01);
        var sv;
        var v;
        l *= 2;
        s *= l <= 1 ? l : 2 - l;
        smin *= lmin <= 1 ? lmin : 2 - lmin;
        v = (l + s) / 2;
        sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
        return [h, sv * 100, v * 100];
      };
      convert.hsv.rgb = function (hsv) {
        var h = hsv[0] / 60;
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var hi = Math.floor(h) % 6;
        var f = h - Math.floor(h);
        var p = 255 * v * (1 - s);
        var q = 255 * v * (1 - s * f);
        var t = 255 * v * (1 - s * (1 - f));
        v *= 255;
        switch (hi) {
          case 0:
            return [v, t, p];
          case 1:
            return [q, v, p];
          case 2:
            return [p, v, t];
          case 3:
            return [p, q, v];
          case 4:
            return [t, p, v];
          case 5:
            return [v, p, q];
        }
      };
      convert.hsv.hsl = function (hsv) {
        var h = hsv[0];
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var vmin = Math.max(v, 0.01);
        var lmin;
        var sl;
        var l;
        l = (2 - s) * v;
        lmin = (2 - s) * vmin;
        sl = s * vmin;
        sl /= lmin <= 1 ? lmin : 2 - lmin;
        sl = sl || 0;
        l /= 2;
        return [h, sl * 100, l * 100];
      };
      convert.hwb.rgb = function (hwb) {
        var h = hwb[0] / 360;
        var wh = hwb[1] / 100;
        var bl = hwb[2] / 100;
        var ratio = wh + bl;
        var i;
        var v;
        var f;
        var n;
        if (ratio > 1) {
          wh /= ratio;
          bl /= ratio;
        }
        i = Math.floor(6 * h);
        v = 1 - bl;
        f = 6 * h - i;
        if ((i & 0x01) !== 0) {
          f = 1 - f;
        }
        n = wh + f * (v - wh);
        var r;
        var g;
        var b;
        switch (i) {
          default:
          case 6:
          case 0:
            r = v;
            g = n;
            b = wh;
            break;
          case 1:
            r = n;
            g = v;
            b = wh;
            break;
          case 2:
            r = wh;
            g = v;
            b = n;
            break;
          case 3:
            r = wh;
            g = n;
            b = v;
            break;
          case 4:
            r = n;
            g = wh;
            b = v;
            break;
          case 5:
            r = v;
            g = wh;
            b = n;
            break;
        }
        return [r * 255, g * 255, b * 255];
      };
      convert.cmyk.rgb = function (cmyk) {
        var c = cmyk[0] / 100;
        var m = cmyk[1] / 100;
        var y = cmyk[2] / 100;
        var k = cmyk[3] / 100;
        var r;
        var g;
        var b;
        r = 1 - Math.min(1, c * (1 - k) + k);
        g = 1 - Math.min(1, m * (1 - k) + k);
        b = 1 - Math.min(1, y * (1 - k) + k);
        return [r * 255, g * 255, b * 255];
      };
      convert.xyz.rgb = function (xyz) {
        var x = xyz[0] / 100;
        var y = xyz[1] / 100;
        var z = xyz[2] / 100;
        var r;
        var g;
        var b;
        r = x * 3.2406 + y * -1.5372 + z * -0.4986;
        g = x * -0.9689 + y * 1.8758 + z * 0.0415;
        b = x * 0.0557 + y * -0.2040 + z * 1.0570;
        r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
        g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
        b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
        r = Math.min(Math.max(0, r), 1);
        g = Math.min(Math.max(0, g), 1);
        b = Math.min(Math.max(0, b), 1);
        return [r * 255, g * 255, b * 255];
      };
      convert.xyz.lab = function (xyz) {
        var x = xyz[0];
        var y = xyz[1];
        var z = xyz[2];
        var l;
        var a;
        var b;
        x /= 95.047;
        y /= 100;
        z /= 108.883;
        x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
        l = 116 * y - 16;
        a = 500 * (x - y);
        b = 200 * (y - z);
        return [l, a, b];
      };
      convert.lab.xyz = function (lab) {
        var l = lab[0];
        var a = lab[1];
        var b = lab[2];
        var x;
        var y;
        var z;
        y = (l + 16) / 116;
        x = a / 500 + y;
        z = y - b / 200;
        var y2 = Math.pow(y, 3);
        var x2 = Math.pow(x, 3);
        var z2 = Math.pow(z, 3);
        y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
        x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
        z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
        x *= 95.047;
        y *= 100;
        z *= 108.883;
        return [x, y, z];
      };
      convert.lab.lch = function (lab) {
        var l = lab[0];
        var a = lab[1];
        var b = lab[2];
        var hr;
        var h;
        var c;
        hr = Math.atan2(b, a);
        h = hr * 360 / 2 / Math.PI;
        if (h < 0) {
          h += 360;
        }
        c = Math.sqrt(a * a + b * b);
        return [l, c, h];
      };
      convert.lch.lab = function (lch) {
        var l = lch[0];
        var c = lch[1];
        var h = lch[2];
        var a;
        var b;
        var hr;
        hr = h / 360 * 2 * Math.PI;
        a = c * Math.cos(hr);
        b = c * Math.sin(hr);
        return [l, a, b];
      };
      convert.rgb.ansi16 = function (args) {
        var r = args[0];
        var g = args[1];
        var b = args[2];
        var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2];
        value = Math.round(value / 50);
        if (value === 0) {
          return 30;
        }
        var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
        if (value === 2) {
          ansi += 60;
        }
        return ansi;
      };
      convert.hsv.ansi16 = function (args) {
        return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
      };
      convert.rgb.ansi256 = function (args) {
        var r = args[0];
        var g = args[1];
        var b = args[2];
        if (r === g && g === b) {
          if (r < 8) {
            return 16;
          }
          if (r > 248) {
            return 231;
          }
          return Math.round((r - 8) / 247 * 24) + 232;
        }
        var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
        return ansi;
      };
      convert.ansi16.rgb = function (args) {
        var color = args % 10;
        if (color === 0 || color === 7) {
          if (args > 50) {
            color += 3.5;
          }
          color = color / 10.5 * 255;
          return [color, color, color];
        }
        var mult = (~~(args > 50) + 1) * 0.5;
        var r = (color & 1) * mult * 255;
        var g = (color >> 1 & 1) * mult * 255;
        var b = (color >> 2 & 1) * mult * 255;
        return [r, g, b];
      };
      convert.ansi256.rgb = function (args) {
        if (args >= 232) {
          var c = (args - 232) * 10 + 8;
          return [c, c, c];
        }
        args -= 16;
        var rem;
        var r = Math.floor(args / 36) / 5 * 255;
        var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
        var b = rem % 6 / 5 * 255;
        return [r, g, b];
      };
      convert.rgb.hex = function (args) {
        var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
        var string = integer.toString(16).toUpperCase();
        return '000000'.substring(string.length) + string;
      };
      convert.hex.rgb = function (args) {
        var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
        if (!match) {
          return [0, 0, 0];
        }
        var colorString = match[0];
        if (match[0].length === 3) {
          colorString = colorString.split('').map(function (_char) {
            return _char + _char;
          }).join('');
        }
        var integer = parseInt(colorString, 16);
        var r = integer >> 16 & 0xFF;
        var g = integer >> 8 & 0xFF;
        var b = integer & 0xFF;
        return [r, g, b];
      };
      convert.rgb.hcg = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var max = Math.max(Math.max(r, g), b);
        var min = Math.min(Math.min(r, g), b);
        var chroma = max - min;
        var grayscale;
        var hue;
        if (chroma < 1) {
          grayscale = min / (1 - chroma);
        } else {
          grayscale = 0;
        }
        if (chroma <= 0) {
          hue = 0;
        } else if (max === r) {
          hue = (g - b) / chroma % 6;
        } else if (max === g) {
          hue = 2 + (b - r) / chroma;
        } else {
          hue = 4 + (r - g) / chroma + 4;
        }
        hue /= 6;
        hue %= 1;
        return [hue * 360, chroma * 100, grayscale * 100];
      };
      convert.hsl.hcg = function (hsl) {
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var c = 1;
        var f = 0;
        if (l < 0.5) {
          c = 2.0 * s * l;
        } else {
          c = 2.0 * s * (1.0 - l);
        }
        if (c < 1.0) {
          f = (l - 0.5 * c) / (1.0 - c);
        }
        return [hsl[0], c * 100, f * 100];
      };
      convert.hsv.hcg = function (hsv) {
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var c = s * v;
        var f = 0;
        if (c < 1.0) {
          f = (v - c) / (1 - c);
        }
        return [hsv[0], c * 100, f * 100];
      };
      convert.hcg.rgb = function (hcg) {
        var h = hcg[0] / 360;
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        if (c === 0.0) {
          return [g * 255, g * 255, g * 255];
        }
        var pure = [0, 0, 0];
        var hi = h % 1 * 6;
        var v = hi % 1;
        var w = 1 - v;
        var mg = 0;
        switch (Math.floor(hi)) {
          case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
          case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
          case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
          case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
          case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
          default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
        }
        mg = (1.0 - c) * g;
        return [(c * pure[0] + mg) * 255, (c * pure[1] + mg) * 255, (c * pure[2] + mg) * 255];
      };
      convert.hcg.hsv = function (hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var v = c + g * (1.0 - c);
        var f = 0;
        if (v > 0.0) {
          f = c / v;
        }
        return [hcg[0], f * 100, v * 100];
      };
      convert.hcg.hsl = function (hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var l = g * (1.0 - c) + 0.5 * c;
        var s = 0;
        if (l > 0.0 && l < 0.5) {
          s = c / (2 * l);
        } else if (l >= 0.5 && l < 1.0) {
          s = c / (2 * (1 - l));
        }
        return [hcg[0], s * 100, l * 100];
      };
      convert.hcg.hwb = function (hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var v = c + g * (1.0 - c);
        return [hcg[0], (v - c) * 100, (1 - v) * 100];
      };
      convert.hwb.hcg = function (hwb) {
        var w = hwb[1] / 100;
        var b = hwb[2] / 100;
        var v = 1 - b;
        var c = v - w;
        var g = 0;
        if (c < 1) {
          g = (v - c) / (1 - c);
        }
        return [hwb[0], c * 100, g * 100];
      };
      convert.apple.rgb = function (apple) {
        return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
      };
      convert.rgb.apple = function (rgb) {
        return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
      };
      convert.gray.rgb = function (args) {
        return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
      };
      convert.gray.hsl = convert.gray.hsv = function (args) {
        return [0, 0, args[0]];
      };
      convert.gray.hwb = function (gray) {
        return [0, 100, gray[0]];
      };
      convert.gray.cmyk = function (gray) {
        return [0, 0, 0, gray[0]];
      };
      convert.gray.lab = function (gray) {
        return [gray[0], 0, 0];
      };
      convert.gray.hex = function (gray) {
        var val = Math.round(gray[0] / 100 * 255) & 0xFF;
        var integer = (val << 16) + (val << 8) + val;
        var string = integer.toString(16).toUpperCase();
        return '000000'.substring(string.length) + string;
      };
      convert.rgb.gray = function (rgb) {
        var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
        return [val / 255 * 100];
      };
    });
    function buildGraph() {
      var graph = {};
      var models = Object.keys(conversions);
      for (var len = models.length, i = 0; i < len; i++) {
        graph[models[i]] = {
          distance: -1,
          parent: null
        };
      }
      return graph;
    }
    function deriveBFS(fromModel) {
      var graph = buildGraph();
      var queue = [fromModel];
      graph[fromModel].distance = 0;
      while (queue.length) {
        var current = queue.pop();
        var adjacents = Object.keys(conversions[current]);
        for (var len = adjacents.length, i = 0; i < len; i++) {
          var adjacent = adjacents[i];
          var node = graph[adjacent];
          if (node.distance === -1) {
            node.distance = graph[current].distance + 1;
            node.parent = current;
            queue.unshift(adjacent);
          }
        }
      }
      return graph;
    }
    function link(from, to) {
      return function (args) {
        return to(from(args));
      };
    }
    function wrapConversion(toModel, graph) {
      var path = [graph[toModel].parent, toModel];
      var fn = conversions[graph[toModel].parent][toModel];
      var cur = graph[toModel].parent;
      while (graph[cur].parent) {
        path.unshift(graph[cur].parent);
        fn = link(conversions[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
      }
      fn.conversion = path;
      return fn;
    }
    var route = function route(fromModel) {
      var graph = deriveBFS(fromModel);
      var conversion = {};
      var models = Object.keys(graph);
      for (var len = models.length, i = 0; i < len; i++) {
        var toModel = models[i];
        var node = graph[toModel];
        if (node.parent === null) {
          continue;
        }
        conversion[toModel] = wrapConversion(toModel, graph);
      }
      return conversion;
    };
    var convert = {};
    var models = Object.keys(conversions);
    function wrapRaw(fn) {
      var wrappedFn = function wrappedFn(args) {
        if (args === undefined || args === null) {
          return args;
        }
        if (arguments.length > 1) {
          args = Array.prototype.slice.call(arguments);
        }
        return fn(args);
      };
      if ('conversion' in fn) {
        wrappedFn.conversion = fn.conversion;
      }
      return wrappedFn;
    }
    function wrapRounded(fn) {
      var wrappedFn = function wrappedFn(args) {
        if (args === undefined || args === null) {
          return args;
        }
        if (arguments.length > 1) {
          args = Array.prototype.slice.call(arguments);
        }
        var result = fn(args);
        if (typeof result === 'object') {
          for (var len = result.length, i = 0; i < len; i++) {
            result[i] = Math.round(result[i]);
          }
        }
        return result;
      };
      if ('conversion' in fn) {
        wrappedFn.conversion = fn.conversion;
      }
      return wrappedFn;
    }
    models.forEach(function (fromModel) {
      convert[fromModel] = {};
      Object.defineProperty(convert[fromModel], 'channels', {
        value: conversions[fromModel].channels
      });
      Object.defineProperty(convert[fromModel], 'labels', {
        value: conversions[fromModel].labels
      });
      var routes = route(fromModel);
      var routeModels = Object.keys(routes);
      routeModels.forEach(function (toModel) {
        var fn = routes[toModel];
        convert[fromModel][toModel] = wrapRounded(fn);
        convert[fromModel][toModel].raw = wrapRaw(fn);
      });
    });
    var colorConvert = convert;
    var colorName$1 = {
      "aliceblue": [240, 248, 255],
      "antiquewhite": [250, 235, 215],
      "aqua": [0, 255, 255],
      "aquamarine": [127, 255, 212],
      "azure": [240, 255, 255],
      "beige": [245, 245, 220],
      "bisque": [255, 228, 196],
      "black": [0, 0, 0],
      "blanchedalmond": [255, 235, 205],
      "blue": [0, 0, 255],
      "blueviolet": [138, 43, 226],
      "brown": [165, 42, 42],
      "burlywood": [222, 184, 135],
      "cadetblue": [95, 158, 160],
      "chartreuse": [127, 255, 0],
      "chocolate": [210, 105, 30],
      "coral": [255, 127, 80],
      "cornflowerblue": [100, 149, 237],
      "cornsilk": [255, 248, 220],
      "crimson": [220, 20, 60],
      "cyan": [0, 255, 255],
      "darkblue": [0, 0, 139],
      "darkcyan": [0, 139, 139],
      "darkgoldenrod": [184, 134, 11],
      "darkgray": [169, 169, 169],
      "darkgreen": [0, 100, 0],
      "darkgrey": [169, 169, 169],
      "darkkhaki": [189, 183, 107],
      "darkmagenta": [139, 0, 139],
      "darkolivegreen": [85, 107, 47],
      "darkorange": [255, 140, 0],
      "darkorchid": [153, 50, 204],
      "darkred": [139, 0, 0],
      "darksalmon": [233, 150, 122],
      "darkseagreen": [143, 188, 143],
      "darkslateblue": [72, 61, 139],
      "darkslategray": [47, 79, 79],
      "darkslategrey": [47, 79, 79],
      "darkturquoise": [0, 206, 209],
      "darkviolet": [148, 0, 211],
      "deeppink": [255, 20, 147],
      "deepskyblue": [0, 191, 255],
      "dimgray": [105, 105, 105],
      "dimgrey": [105, 105, 105],
      "dodgerblue": [30, 144, 255],
      "firebrick": [178, 34, 34],
      "floralwhite": [255, 250, 240],
      "forestgreen": [34, 139, 34],
      "fuchsia": [255, 0, 255],
      "gainsboro": [220, 220, 220],
      "ghostwhite": [248, 248, 255],
      "gold": [255, 215, 0],
      "goldenrod": [218, 165, 32],
      "gray": [128, 128, 128],
      "green": [0, 128, 0],
      "greenyellow": [173, 255, 47],
      "grey": [128, 128, 128],
      "honeydew": [240, 255, 240],
      "hotpink": [255, 105, 180],
      "indianred": [205, 92, 92],
      "indigo": [75, 0, 130],
      "ivory": [255, 255, 240],
      "khaki": [240, 230, 140],
      "lavender": [230, 230, 250],
      "lavenderblush": [255, 240, 245],
      "lawngreen": [124, 252, 0],
      "lemonchiffon": [255, 250, 205],
      "lightblue": [173, 216, 230],
      "lightcoral": [240, 128, 128],
      "lightcyan": [224, 255, 255],
      "lightgoldenrodyellow": [250, 250, 210],
      "lightgray": [211, 211, 211],
      "lightgreen": [144, 238, 144],
      "lightgrey": [211, 211, 211],
      "lightpink": [255, 182, 193],
      "lightsalmon": [255, 160, 122],
      "lightseagreen": [32, 178, 170],
      "lightskyblue": [135, 206, 250],
      "lightslategray": [119, 136, 153],
      "lightslategrey": [119, 136, 153],
      "lightsteelblue": [176, 196, 222],
      "lightyellow": [255, 255, 224],
      "lime": [0, 255, 0],
      "limegreen": [50, 205, 50],
      "linen": [250, 240, 230],
      "magenta": [255, 0, 255],
      "maroon": [128, 0, 0],
      "mediumaquamarine": [102, 205, 170],
      "mediumblue": [0, 0, 205],
      "mediumorchid": [186, 85, 211],
      "mediumpurple": [147, 112, 219],
      "mediumseagreen": [60, 179, 113],
      "mediumslateblue": [123, 104, 238],
      "mediumspringgreen": [0, 250, 154],
      "mediumturquoise": [72, 209, 204],
      "mediumvioletred": [199, 21, 133],
      "midnightblue": [25, 25, 112],
      "mintcream": [245, 255, 250],
      "mistyrose": [255, 228, 225],
      "moccasin": [255, 228, 181],
      "navajowhite": [255, 222, 173],
      "navy": [0, 0, 128],
      "oldlace": [253, 245, 230],
      "olive": [128, 128, 0],
      "olivedrab": [107, 142, 35],
      "orange": [255, 165, 0],
      "orangered": [255, 69, 0],
      "orchid": [218, 112, 214],
      "palegoldenrod": [238, 232, 170],
      "palegreen": [152, 251, 152],
      "paleturquoise": [175, 238, 238],
      "palevioletred": [219, 112, 147],
      "papayawhip": [255, 239, 213],
      "peachpuff": [255, 218, 185],
      "peru": [205, 133, 63],
      "pink": [255, 192, 203],
      "plum": [221, 160, 221],
      "powderblue": [176, 224, 230],
      "purple": [128, 0, 128],
      "rebeccapurple": [102, 51, 153],
      "red": [255, 0, 0],
      "rosybrown": [188, 143, 143],
      "royalblue": [65, 105, 225],
      "saddlebrown": [139, 69, 19],
      "salmon": [250, 128, 114],
      "sandybrown": [244, 164, 96],
      "seagreen": [46, 139, 87],
      "seashell": [255, 245, 238],
      "sienna": [160, 82, 45],
      "silver": [192, 192, 192],
      "skyblue": [135, 206, 235],
      "slateblue": [106, 90, 205],
      "slategray": [112, 128, 144],
      "slategrey": [112, 128, 144],
      "snow": [255, 250, 250],
      "springgreen": [0, 255, 127],
      "steelblue": [70, 130, 180],
      "tan": [210, 180, 140],
      "teal": [0, 128, 128],
      "thistle": [216, 191, 216],
      "tomato": [255, 99, 71],
      "turquoise": [64, 224, 208],
      "violet": [238, 130, 238],
      "wheat": [245, 222, 179],
      "white": [255, 255, 255],
      "whitesmoke": [245, 245, 245],
      "yellow": [255, 255, 0],
      "yellowgreen": [154, 205, 50]
    };
    var colorString = {
      getRgba: getRgba,
      getHsla: getHsla,
      getRgb: getRgb,
      getHsl: getHsl,
      getHwb: getHwb,
      getAlpha: getAlpha,
      hexString: hexString,
      rgbString: rgbString,
      rgbaString: rgbaString,
      percentString: percentString,
      percentaString: percentaString,
      hslString: hslString,
      hslaString: hslaString,
      hwbString: hwbString,
      keyword: keyword
    };
    function getRgba(string) {
      if (!string) {
        return;
      }
      var abbr = /^#([a-fA-F0-9]{3,4})$/i,
        hex = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
        rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
        per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
        keyword = /(\w+)/;
      var rgb = [0, 0, 0],
        a = 1,
        match = string.match(abbr),
        hexAlpha = "";
      if (match) {
        match = match[1];
        hexAlpha = match[3];
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = parseInt(match[i] + match[i], 16);
        }
        if (hexAlpha) {
          a = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
        }
      } else if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
        }
        if (hexAlpha) {
          a = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
        }
      } else if (match = string.match(rgba)) {
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = parseInt(match[i + 1]);
        }
        a = parseFloat(match[4]);
      } else if (match = string.match(per)) {
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        }
        a = parseFloat(match[4]);
      } else if (match = string.match(keyword)) {
        if (match[1] == "transparent") {
          return [0, 0, 0, 0];
        }
        rgb = colorName$1[match[1]];
        if (!rgb) {
          return;
        }
      }
      for (var i = 0; i < rgb.length; i++) {
        rgb[i] = scale(rgb[i], 0, 255);
      }
      if (!a && a != 0) {
        a = 1;
      } else {
        a = scale(a, 0, 1);
      }
      rgb[3] = a;
      return rgb;
    }
    function getHsla(string) {
      if (!string) {
        return;
      }
      var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
      var match = string.match(hsl);
      if (match) {
        var alpha = parseFloat(match[4]);
        var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [h, s, l, a];
      }
    }
    function getHwb(string) {
      if (!string) {
        return;
      }
      var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
      var match = string.match(hwb);
      if (match) {
        var alpha = parseFloat(match[4]);
        var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [h, w, b, a];
      }
    }
    function getRgb(string) {
      var rgba = getRgba(string);
      return rgba && rgba.slice(0, 3);
    }
    function getHsl(string) {
      var hsla = getHsla(string);
      return hsla && hsla.slice(0, 3);
    }
    function getAlpha(string) {
      var vals = getRgba(string);
      if (vals) {
        return vals[3];
      } else if (vals = getHsla(string)) {
        return vals[3];
      } else if (vals = getHwb(string)) {
        return vals[3];
      }
    }
    function hexString(rgba, a) {
      var a = a !== undefined && rgba.length === 3 ? a : rgba[3];
      return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (a >= 0 && a < 1 ? hexDouble(Math.round(a * 255)) : "");
    }
    function rgbString(rgba, alpha) {
      if (alpha < 1 || rgba[3] && rgba[3] < 1) {
        return rgbaString(rgba, alpha);
      }
      return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
    }
    function rgbaString(rgba, alpha) {
      if (alpha === undefined) {
        alpha = rgba[3] !== undefined ? rgba[3] : 1;
      }
      return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
    }
    function percentString(rgba, alpha) {
      if (alpha < 1 || rgba[3] && rgba[3] < 1) {
        return percentaString(rgba, alpha);
      }
      var r = Math.round(rgba[0] / 255 * 100),
        g = Math.round(rgba[1] / 255 * 100),
        b = Math.round(rgba[2] / 255 * 100);
      return "rgb(" + r + "%, " + g + "%, " + b + "%)";
    }
    function percentaString(rgba, alpha) {
      var r = Math.round(rgba[0] / 255 * 100),
        g = Math.round(rgba[1] / 255 * 100),
        b = Math.round(rgba[2] / 255 * 100);
      return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
    }
    function hslString(hsla, alpha) {
      if (alpha < 1 || hsla[3] && hsla[3] < 1) {
        return hslaString(hsla, alpha);
      }
      return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
    }
    function hslaString(hsla, alpha) {
      if (alpha === undefined) {
        alpha = hsla[3] !== undefined ? hsla[3] : 1;
      }
      return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
    }
    function hwbString(hwb, alpha) {
      if (alpha === undefined) {
        alpha = hwb[3] !== undefined ? hwb[3] : 1;
      }
      return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
    }
    function keyword(rgb) {
      return reverseNames[rgb.slice(0, 3)];
    }
    function scale(num, min, max) {
      return Math.min(Math.max(min, num), max);
    }
    function hexDouble(num) {
      var str = num.toString(16).toUpperCase();
      return str.length < 2 ? "0" + str : str;
    }
    var reverseNames = {};
    for (var name in colorName$1) {
      reverseNames[colorName$1[name]] = name;
    }
    var Color = function Color(obj) {
      if (obj instanceof Color) {
        return obj;
      }
      if (!(this instanceof Color)) {
        return new Color(obj);
      }
      this.valid = false;
      this.values = {
        rgb: [0, 0, 0],
        hsl: [0, 0, 0],
        hsv: [0, 0, 0],
        hwb: [0, 0, 0],
        cmyk: [0, 0, 0, 0],
        alpha: 1
      };
      var vals;
      if (typeof obj === 'string') {
        vals = colorString.getRgba(obj);
        if (vals) {
          this.setValues('rgb', vals);
        } else if (vals = colorString.getHsla(obj)) {
          this.setValues('hsl', vals);
        } else if (vals = colorString.getHwb(obj)) {
          this.setValues('hwb', vals);
        }
      } else if (typeof obj === 'object') {
        vals = obj;
        if (vals.r !== undefined || vals.red !== undefined) {
          this.setValues('rgb', vals);
        } else if (vals.l !== undefined || vals.lightness !== undefined) {
          this.setValues('hsl', vals);
        } else if (vals.v !== undefined || vals.value !== undefined) {
          this.setValues('hsv', vals);
        } else if (vals.w !== undefined || vals.whiteness !== undefined) {
          this.setValues('hwb', vals);
        } else if (vals.c !== undefined || vals.cyan !== undefined) {
          this.setValues('cmyk', vals);
        }
      }
    };
    Color.prototype = {
      isValid: function isValid() {
        return this.valid;
      },
      rgb: function rgb() {
        return this.setSpace('rgb', arguments);
      },
      hsl: function hsl() {
        return this.setSpace('hsl', arguments);
      },
      hsv: function hsv() {
        return this.setSpace('hsv', arguments);
      },
      hwb: function hwb() {
        return this.setSpace('hwb', arguments);
      },
      cmyk: function cmyk() {
        return this.setSpace('cmyk', arguments);
      },
      rgbArray: function rgbArray() {
        return this.values.rgb;
      },
      hslArray: function hslArray() {
        return this.values.hsl;
      },
      hsvArray: function hsvArray() {
        return this.values.hsv;
      },
      hwbArray: function hwbArray() {
        var values = this.values;
        if (values.alpha !== 1) {
          return values.hwb.concat([values.alpha]);
        }
        return values.hwb;
      },
      cmykArray: function cmykArray() {
        return this.values.cmyk;
      },
      rgbaArray: function rgbaArray() {
        var values = this.values;
        return values.rgb.concat([values.alpha]);
      },
      hslaArray: function hslaArray() {
        var values = this.values;
        return values.hsl.concat([values.alpha]);
      },
      alpha: function alpha(val) {
        if (val === undefined) {
          return this.values.alpha;
        }
        this.setValues('alpha', val);
        return this;
      },
      red: function red(val) {
        return this.setChannel('rgb', 0, val);
      },
      green: function green(val) {
        return this.setChannel('rgb', 1, val);
      },
      blue: function blue(val) {
        return this.setChannel('rgb', 2, val);
      },
      hue: function hue(val) {
        if (val) {
          val %= 360;
          val = val < 0 ? 360 + val : val;
        }
        return this.setChannel('hsl', 0, val);
      },
      saturation: function saturation(val) {
        return this.setChannel('hsl', 1, val);
      },
      lightness: function lightness(val) {
        return this.setChannel('hsl', 2, val);
      },
      saturationv: function saturationv(val) {
        return this.setChannel('hsv', 1, val);
      },
      whiteness: function whiteness(val) {
        return this.setChannel('hwb', 1, val);
      },
      blackness: function blackness(val) {
        return this.setChannel('hwb', 2, val);
      },
      value: function value(val) {
        return this.setChannel('hsv', 2, val);
      },
      cyan: function cyan(val) {
        return this.setChannel('cmyk', 0, val);
      },
      magenta: function magenta(val) {
        return this.setChannel('cmyk', 1, val);
      },
      yellow: function yellow(val) {
        return this.setChannel('cmyk', 2, val);
      },
      black: function black(val) {
        return this.setChannel('cmyk', 3, val);
      },
      hexString: function hexString() {
        return colorString.hexString(this.values.rgb);
      },
      rgbString: function rgbString() {
        return colorString.rgbString(this.values.rgb, this.values.alpha);
      },
      rgbaString: function rgbaString() {
        return colorString.rgbaString(this.values.rgb, this.values.alpha);
      },
      percentString: function percentString() {
        return colorString.percentString(this.values.rgb, this.values.alpha);
      },
      hslString: function hslString() {
        return colorString.hslString(this.values.hsl, this.values.alpha);
      },
      hslaString: function hslaString() {
        return colorString.hslaString(this.values.hsl, this.values.alpha);
      },
      hwbString: function hwbString() {
        return colorString.hwbString(this.values.hwb, this.values.alpha);
      },
      keyword: function keyword() {
        return colorString.keyword(this.values.rgb, this.values.alpha);
      },
      rgbNumber: function rgbNumber() {
        var rgb = this.values.rgb;
        return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
      },
      luminosity: function luminosity() {
        var rgb = this.values.rgb;
        var lum = [];
        for (var i = 0; i < rgb.length; i++) {
          var chan = rgb[i] / 255;
          lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
      },
      contrast: function contrast(color2) {
        var lum1 = this.luminosity();
        var lum2 = color2.luminosity();
        if (lum1 > lum2) {
          return (lum1 + 0.05) / (lum2 + 0.05);
        }
        return (lum2 + 0.05) / (lum1 + 0.05);
      },
      level: function level(color2) {
        var contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7.1) {
          return 'AAA';
        }
        return contrastRatio >= 4.5 ? 'AA' : '';
      },
      dark: function dark() {
        var rgb = this.values.rgb;
        var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return yiq < 128;
      },
      light: function light() {
        return !this.dark();
      },
      negate: function negate() {
        var rgb = [];
        for (var i = 0; i < 3; i++) {
          rgb[i] = 255 - this.values.rgb[i];
        }
        this.setValues('rgb', rgb);
        return this;
      },
      lighten: function lighten(ratio) {
        var hsl = this.values.hsl;
        hsl[2] += hsl[2] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      darken: function darken(ratio) {
        var hsl = this.values.hsl;
        hsl[2] -= hsl[2] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      saturate: function saturate(ratio) {
        var hsl = this.values.hsl;
        hsl[1] += hsl[1] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      desaturate: function desaturate(ratio) {
        var hsl = this.values.hsl;
        hsl[1] -= hsl[1] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      whiten: function whiten(ratio) {
        var hwb = this.values.hwb;
        hwb[1] += hwb[1] * ratio;
        this.setValues('hwb', hwb);
        return this;
      },
      blacken: function blacken(ratio) {
        var hwb = this.values.hwb;
        hwb[2] += hwb[2] * ratio;
        this.setValues('hwb', hwb);
        return this;
      },
      greyscale: function greyscale() {
        var rgb = this.values.rgb;
        var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        this.setValues('rgb', [val, val, val]);
        return this;
      },
      clearer: function clearer(ratio) {
        var alpha = this.values.alpha;
        this.setValues('alpha', alpha - alpha * ratio);
        return this;
      },
      opaquer: function opaquer(ratio) {
        var alpha = this.values.alpha;
        this.setValues('alpha', alpha + alpha * ratio);
        return this;
      },
      rotate: function rotate(degrees) {
        var hsl = this.values.hsl;
        var hue = (hsl[0] + degrees) % 360;
        hsl[0] = hue < 0 ? 360 + hue : hue;
        this.setValues('hsl', hsl);
        return this;
      },
      mix: function mix(mixinColor, weight) {
        var color1 = this;
        var color2 = mixinColor;
        var p = weight === undefined ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = color1.alpha() - color2.alpha();
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
        var w2 = 1 - w1;
        return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
      },
      toJSON: function toJSON() {
        return this.rgb();
      },
      clone: function clone() {
        var result = new Color();
        var source = this.values;
        var target = result.values;
        var value, type;
        for (var prop in source) {
          if (source.hasOwnProperty(prop)) {
            value = source[prop];
            type = {}.toString.call(value);
            if (type === '[object Array]') {
              target[prop] = value.slice(0);
            } else if (type === '[object Number]') {
              target[prop] = value;
            } else {
              console.error('unexpected color value:', value);
            }
          }
        }
        return result;
      }
    };
    Color.prototype.spaces = {
      rgb: ['red', 'green', 'blue'],
      hsl: ['hue', 'saturation', 'lightness'],
      hsv: ['hue', 'saturation', 'value'],
      hwb: ['hue', 'whiteness', 'blackness'],
      cmyk: ['cyan', 'magenta', 'yellow', 'black']
    };
    Color.prototype.maxes = {
      rgb: [255, 255, 255],
      hsl: [360, 100, 100],
      hsv: [360, 100, 100],
      hwb: [360, 100, 100],
      cmyk: [100, 100, 100, 100]
    };
    Color.prototype.getValues = function (space) {
      var values = this.values;
      var vals = {};
      for (var i = 0; i < space.length; i++) {
        vals[space.charAt(i)] = values[space][i];
      }
      if (values.alpha !== 1) {
        vals.a = values.alpha;
      }
      return vals;
    };
    Color.prototype.setValues = function (space, vals) {
      var values = this.values;
      var spaces = this.spaces;
      var maxes = this.maxes;
      var alpha = 1;
      var i;
      this.valid = true;
      if (space === 'alpha') {
        alpha = vals;
      } else if (vals.length) {
        values[space] = vals.slice(0, space.length);
        alpha = vals[space.length];
      } else if (vals[space.charAt(0)] !== undefined) {
        for (i = 0; i < space.length; i++) {
          values[space][i] = vals[space.charAt(i)];
        }
        alpha = vals.a;
      } else if (vals[spaces[space][0]] !== undefined) {
        var chans = spaces[space];
        for (i = 0; i < space.length; i++) {
          values[space][i] = vals[chans[i]];
        }
        alpha = vals.alpha;
      }
      values.alpha = Math.max(0, Math.min(1, alpha === undefined ? values.alpha : alpha));
      if (space === 'alpha') {
        return false;
      }
      var capped;
      for (i = 0; i < space.length; i++) {
        capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
        values[space][i] = Math.round(capped);
      }
      for (var sname in spaces) {
        if (sname !== space) {
          values[sname] = colorConvert[space][sname](values[space]);
        }
      }
      return true;
    };
    Color.prototype.setSpace = function (space, args) {
      var vals = args[0];
      if (vals === undefined) {
        return this.getValues(space);
      }
      if (typeof vals === 'number') {
        vals = Array.prototype.slice.call(args);
      }
      this.setValues(space, vals);
      return this;
    };
    Color.prototype.setChannel = function (space, index, val) {
      var svalues = this.values[space];
      if (val === undefined) {
        return svalues[index];
      } else if (val === svalues[index]) {
        return this;
      }
      svalues[index] = val;
      this.setValues(space, svalues);
      return this;
    };
    if (typeof window !== 'undefined') {
      window.Color = Color;
    }
    var chartjsColor = Color;
    function isValidKey(key) {
      return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
    }
    var helpers = {
      noop: function noop() {},
      uid: function () {
        var id = 0;
        return function () {
          return id++;
        };
      }(),
      isNullOrUndef: function isNullOrUndef(value) {
        return value === null || typeof value === 'undefined';
      },
      isArray: function isArray(value) {
        if (Array.isArray && Array.isArray(value)) {
          return true;
        }
        var type = Object.prototype.toString.call(value);
        if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
          return true;
        }
        return false;
      },
      isObject: function isObject(value) {
        return value !== null && Object.prototype.toString.call(value) === '[object Object]';
      },
      isFinite: function (_isFinite) {
        function isFinite(_x) {
          return _isFinite.apply(this, arguments);
        }
        isFinite.toString = function () {
          return _isFinite.toString();
        };
        return isFinite;
      }(function (value) {
        return (typeof value === 'number' || value instanceof Number) && isFinite(value);
      }),
      valueOrDefault: function valueOrDefault(value, defaultValue) {
        return typeof value === 'undefined' ? defaultValue : value;
      },
      valueAtIndexOrDefault: function valueAtIndexOrDefault(value, index, defaultValue) {
        return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
      },
      callback: function callback(fn, args, thisArg) {
        if (fn && typeof fn.call === 'function') {
          return fn.apply(thisArg, args);
        }
      },
      each: function each(loopable, fn, thisArg, reverse) {
        var i, len, keys;
        if (helpers.isArray(loopable)) {
          len = loopable.length;
          if (reverse) {
            for (i = len - 1; i >= 0; i--) {
              fn.call(thisArg, loopable[i], i);
            }
          } else {
            for (i = 0; i < len; i++) {
              fn.call(thisArg, loopable[i], i);
            }
          }
        } else if (helpers.isObject(loopable)) {
          keys = Object.keys(loopable);
          len = keys.length;
          for (i = 0; i < len; i++) {
            fn.call(thisArg, loopable[keys[i]], keys[i]);
          }
        }
      },
      arrayEquals: function arrayEquals(a0, a1) {
        var i, ilen, v0, v1;
        if (!a0 || !a1 || a0.length !== a1.length) {
          return false;
        }
        for (i = 0, ilen = a0.length; i < ilen; ++i) {
          v0 = a0[i];
          v1 = a1[i];
          if (v0 instanceof Array && v1 instanceof Array) {
            if (!helpers.arrayEquals(v0, v1)) {
              return false;
            }
          } else if (v0 !== v1) {
            return false;
          }
        }
        return true;
      },
      clone: function clone(source) {
        if (helpers.isArray(source)) {
          return source.map(helpers.clone);
        }
        if (helpers.isObject(source)) {
          var target = Object.create(source);
          var keys = Object.keys(source);
          var klen = keys.length;
          var k = 0;
          for (; k < klen; ++k) {
            target[keys[k]] = helpers.clone(source[keys[k]]);
          }
          return target;
        }
        return source;
      },
      _merger: function _merger(key, target, source, options) {
        if (!isValidKey(key)) {
          return;
        }
        var tval = target[key];
        var sval = source[key];
        if (helpers.isObject(tval) && helpers.isObject(sval)) {
          helpers.merge(tval, sval, options);
        } else {
          target[key] = helpers.clone(sval);
        }
      },
      _mergerIf: function _mergerIf(key, target, source) {
        if (!isValidKey(key)) {
          return;
        }
        var tval = target[key];
        var sval = source[key];
        if (helpers.isObject(tval) && helpers.isObject(sval)) {
          helpers.mergeIf(tval, sval);
        } else if (!target.hasOwnProperty(key)) {
          target[key] = helpers.clone(sval);
        }
      },
      merge: function merge(target, source, options) {
        var sources = helpers.isArray(source) ? source : [source];
        var ilen = sources.length;
        var merge, i, keys, klen, k;
        if (!helpers.isObject(target)) {
          return target;
        }
        options = options || {};
        merge = options.merger || helpers._merger;
        for (i = 0; i < ilen; ++i) {
          source = sources[i];
          if (!helpers.isObject(source)) {
            continue;
          }
          keys = Object.keys(source);
          for (k = 0, klen = keys.length; k < klen; ++k) {
            merge(keys[k], target, source, options);
          }
        }
        return target;
      },
      mergeIf: function mergeIf(target, source) {
        return helpers.merge(target, source, {
          merger: helpers._mergerIf
        });
      },
      extend: Object.assign || function (target) {
        return helpers.merge(target, [].slice.call(arguments, 1), {
          merger: function merger(key, dst, src) {
            dst[key] = src[key];
          }
        });
      },
      inherits: function inherits(extensions) {
        var me = this;
        var ChartElement = extensions && extensions.hasOwnProperty('constructor') ? extensions.constructor : function () {
          return me.apply(this, arguments);
        };
        var Surrogate = function Surrogate() {
          this.constructor = ChartElement;
        };
        Surrogate.prototype = me.prototype;
        ChartElement.prototype = new Surrogate();
        ChartElement.extend = helpers.inherits;
        if (extensions) {
          helpers.extend(ChartElement.prototype, extensions);
        }
        ChartElement.__super__ = me.prototype;
        return ChartElement;
      },
      _deprecated: function _deprecated(scope, value, previous, current) {
        if (value !== undefined) {
          console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
        }
      }
    };
    var helpers_core = helpers;
    helpers.callCallback = helpers.callback;
    helpers.indexOf = function (array, item, fromIndex) {
      return Array.prototype.indexOf.call(array, item, fromIndex);
    };
    helpers.getValueOrDefault = helpers.valueOrDefault;
    helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
    var effects = {
      linear: function linear(t) {
        return t;
      },
      easeInQuad: function easeInQuad(t) {
        return t * t;
      },
      easeOutQuad: function easeOutQuad(t) {
        return -t * (t - 2);
      },
      easeInOutQuad: function easeInOutQuad(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t;
        }
        return -0.5 * (--t * (t - 2) - 1);
      },
      easeInCubic: function easeInCubic(t) {
        return t * t * t;
      },
      easeOutCubic: function easeOutCubic(t) {
        return (t = t - 1) * t * t + 1;
      },
      easeInOutCubic: function easeInOutCubic(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t * t;
        }
        return 0.5 * ((t -= 2) * t * t + 2);
      },
      easeInQuart: function easeInQuart(t) {
        return t * t * t * t;
      },
      easeOutQuart: function easeOutQuart(t) {
        return -((t = t - 1) * t * t * t - 1);
      },
      easeInOutQuart: function easeInOutQuart(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t * t * t;
        }
        return -0.5 * ((t -= 2) * t * t * t - 2);
      },
      easeInQuint: function easeInQuint(t) {
        return t * t * t * t * t;
      },
      easeOutQuint: function easeOutQuint(t) {
        return (t = t - 1) * t * t * t * t + 1;
      },
      easeInOutQuint: function easeInOutQuint(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t * t * t * t;
        }
        return 0.5 * ((t -= 2) * t * t * t * t + 2);
      },
      easeInSine: function easeInSine(t) {
        return -Math.cos(t * (Math.PI / 2)) + 1;
      },
      easeOutSine: function easeOutSine(t) {
        return Math.sin(t * (Math.PI / 2));
      },
      easeInOutSine: function easeInOutSine(t) {
        return -0.5 * (Math.cos(Math.PI * t) - 1);
      },
      easeInExpo: function easeInExpo(t) {
        return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
      },
      easeOutExpo: function easeOutExpo(t) {
        return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
      },
      easeInOutExpo: function easeInOutExpo(t) {
        if (t === 0) {
          return 0;
        }
        if (t === 1) {
          return 1;
        }
        if ((t /= 0.5) < 1) {
          return 0.5 * Math.pow(2, 10 * (t - 1));
        }
        return 0.5 * (-Math.pow(2, -10 * --t) + 2);
      },
      easeInCirc: function easeInCirc(t) {
        if (t >= 1) {
          return t;
        }
        return -(Math.sqrt(1 - t * t) - 1);
      },
      easeOutCirc: function easeOutCirc(t) {
        return Math.sqrt(1 - (t = t - 1) * t);
      },
      easeInOutCirc: function easeInOutCirc(t) {
        if ((t /= 0.5) < 1) {
          return -0.5 * (Math.sqrt(1 - t * t) - 1);
        }
        return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
      },
      easeInElastic: function easeInElastic(t) {
        var s = 1.70158;
        var p = 0;
        var a = 1;
        if (t === 0) {
          return 0;
        }
        if (t === 1) {
          return 1;
        }
        if (!p) {
          p = 0.3;
        }
        {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
      },
      easeOutElastic: function easeOutElastic(t) {
        var s = 1.70158;
        var p = 0;
        var a = 1;
        if (t === 0) {
          return 0;
        }
        if (t === 1) {
          return 1;
        }
        if (!p) {
          p = 0.3;
        }
        {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
      },
      easeInOutElastic: function easeInOutElastic(t) {
        var s = 1.70158;
        var p = 0;
        var a = 1;
        if (t === 0) {
          return 0;
        }
        if ((t /= 0.5) === 2) {
          return 1;
        }
        if (!p) {
          p = 0.45;
        }
        {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        if (t < 1) {
          return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
        }
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
      },
      easeInBack: function easeInBack(t) {
        var s = 1.70158;
        return t * t * ((s + 1) * t - s);
      },
      easeOutBack: function easeOutBack(t) {
        var s = 1.70158;
        return (t = t - 1) * t * ((s + 1) * t + s) + 1;
      },
      easeInOutBack: function easeInOutBack(t) {
        var s = 1.70158;
        if ((t /= 0.5) < 1) {
          return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        }
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
      },
      easeInBounce: function easeInBounce(t) {
        return 1 - effects.easeOutBounce(1 - t);
      },
      easeOutBounce: function easeOutBounce(t) {
        if (t < 1 / 2.75) {
          return 7.5625 * t * t;
        }
        if (t < 2 / 2.75) {
          return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
        }
        if (t < 2.5 / 2.75) {
          return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
        }
        return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
      },
      easeInOutBounce: function easeInOutBounce(t) {
        if (t < 0.5) {
          return effects.easeInBounce(t * 2) * 0.5;
        }
        return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
      }
    };
    var helpers_easing = {
      effects: effects
    };
    helpers_core.easingEffects = effects;
    var PI = Math.PI;
    var RAD_PER_DEG = PI / 180;
    var DOUBLE_PI = PI * 2;
    var HALF_PI = PI / 2;
    var QUARTER_PI = PI / 4;
    var TWO_THIRDS_PI = PI * 2 / 3;
    var exports$1 = {
      clear: function clear(chart) {
        chart.ctx.clearRect(0, 0, chart.width, chart.height);
      },
      roundedRect: function roundedRect(ctx, x, y, width, height, radius) {
        if (radius) {
          var r = Math.min(radius, height / 2, width / 2);
          var left = x + r;
          var top = y + r;
          var right = x + width - r;
          var bottom = y + height - r;
          ctx.moveTo(x, top);
          if (left < right && top < bottom) {
            ctx.arc(left, top, r, -PI, -HALF_PI);
            ctx.arc(right, top, r, -HALF_PI, 0);
            ctx.arc(right, bottom, r, 0, HALF_PI);
            ctx.arc(left, bottom, r, HALF_PI, PI);
          } else if (left < right) {
            ctx.moveTo(left, y);
            ctx.arc(right, top, r, -HALF_PI, HALF_PI);
            ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
          } else if (top < bottom) {
            ctx.arc(left, top, r, -PI, 0);
            ctx.arc(left, bottom, r, 0, PI);
          } else {
            ctx.arc(left, top, r, -PI, PI);
          }
          ctx.closePath();
          ctx.moveTo(x, y);
        } else {
          ctx.rect(x, y, width, height);
        }
      },
      drawPoint: function drawPoint(ctx, style, radius, x, y, rotation) {
        var type, xOffset, yOffset, size, cornerRadius;
        var rad = (rotation || 0) * RAD_PER_DEG;
        if (style && typeof style === 'object') {
          type = style.toString();
          if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
          }
        }
        if (isNaN(radius) || radius <= 0) {
          return;
        }
        ctx.beginPath();
        switch (style) {
          default:
            ctx.arc(x, y, radius, 0, DOUBLE_PI);
            ctx.closePath();
            break;
          case 'triangle':
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
          case 'rectRounded':
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + QUARTER_PI) * size;
            yOffset = Math.sin(rad + QUARTER_PI) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
            ctx.closePath();
            break;
          case 'rect':
            if (!rotation) {
              size = Math.SQRT1_2 * radius;
              ctx.rect(x - size, y - size, 2 * size, 2 * size);
              break;
            }
            rad += QUARTER_PI;
          case 'rectRot':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
          case 'crossRot':
            rad += QUARTER_PI;
          case 'cross':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
          case 'star':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += QUARTER_PI;
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
          case 'line':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
          case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
        }
        ctx.fill();
        ctx.stroke();
      },
      _isPointInArea: function _isPointInArea(point, area) {
        var epsilon = 1e-6;
        return point.x > area.left - epsilon && point.x < area.right + epsilon && point.y > area.top - epsilon && point.y < area.bottom + epsilon;
      },
      clipArea: function clipArea(ctx, area) {
        ctx.save();
        ctx.beginPath();
        ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
        ctx.clip();
      },
      unclipArea: function unclipArea(ctx) {
        ctx.restore();
      },
      lineTo: function lineTo(ctx, previous, target, flip) {
        var stepped = target.steppedLine;
        if (stepped) {
          if (stepped === 'middle') {
            var midpoint = (previous.x + target.x) / 2.0;
            ctx.lineTo(midpoint, flip ? target.y : previous.y);
            ctx.lineTo(midpoint, flip ? previous.y : target.y);
          } else if (stepped === 'after' && !flip || stepped !== 'after' && flip) {
            ctx.lineTo(previous.x, target.y);
          } else {
            ctx.lineTo(target.x, previous.y);
          }
          ctx.lineTo(target.x, target.y);
          return;
        }
        if (!target.tension) {
          ctx.lineTo(target.x, target.y);
          return;
        }
        ctx.bezierCurveTo(flip ? previous.controlPointPreviousX : previous.controlPointNextX, flip ? previous.controlPointPreviousY : previous.controlPointNextY, flip ? target.controlPointNextX : target.controlPointPreviousX, flip ? target.controlPointNextY : target.controlPointPreviousY, target.x, target.y);
      }
    };
    var helpers_canvas = exports$1;
    helpers_core.clear = exports$1.clear;
    helpers_core.drawRoundedRectangle = function (ctx) {
      ctx.beginPath();
      exports$1.roundedRect.apply(exports$1, arguments);
    };
    var defaults = {
      _set: function _set(scope, values) {
        return helpers_core.merge(this[scope] || (this[scope] = {}), values);
      }
    };
    defaults._set('global', {
      defaultColor: 'rgba(0,0,0,0.1)',
      defaultFontColor: '#666',
      defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      defaultFontSize: 12,
      defaultFontStyle: 'normal',
      defaultLineHeight: 1.2,
      showLines: true
    });
    var core_defaults = defaults;
    var valueOrDefault = helpers_core.valueOrDefault;
    function toFontString(font) {
      if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
        return null;
      }
      return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
    }
    var helpers_options = {
      toLineHeight: function toLineHeight(value, size) {
        var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
        if (!matches || matches[1] === 'normal') {
          return size * 1.2;
        }
        value = +matches[2];
        switch (matches[3]) {
          case 'px':
            return value;
          case '%':
            value /= 100;
            break;
        }
        return size * value;
      },
      toPadding: function toPadding(value) {
        var t, r, b, l;
        if (helpers_core.isObject(value)) {
          t = +value.top || 0;
          r = +value.right || 0;
          b = +value.bottom || 0;
          l = +value.left || 0;
        } else {
          t = r = b = l = +value || 0;
        }
        return {
          top: t,
          right: r,
          bottom: b,
          left: l,
          height: t + b,
          width: l + r
        };
      },
      _parseFont: function _parseFont(options) {
        var globalDefaults = core_defaults.global;
        var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
        var font = {
          family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
          lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
          size: size,
          style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
          weight: null,
          string: ''
        };
        font.string = toFontString(font);
        return font;
      },
      resolve: function resolve(inputs, context, index, info) {
        var cacheable = true;
        var i, ilen, value;
        for (i = 0, ilen = inputs.length; i < ilen; ++i) {
          value = inputs[i];
          if (value === undefined) {
            continue;
          }
          if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
          }
          if (index !== undefined && helpers_core.isArray(value)) {
            value = value[index];
            cacheable = false;
          }
          if (value !== undefined) {
            if (info && !cacheable) {
              info.cacheable = false;
            }
            return value;
          }
        }
      }
    };
    var exports$2 = {
      _factorize: function _factorize(value) {
        var result = [];
        var sqrt = Math.sqrt(value);
        var i;
        for (i = 1; i < sqrt; i++) {
          if (value % i === 0) {
            result.push(i);
            result.push(value / i);
          }
        }
        if (sqrt === (sqrt | 0)) {
          result.push(sqrt);
        }
        result.sort(function (a, b) {
          return a - b;
        }).pop();
        return result;
      },
      log10: Math.log10 || function (x) {
        var exponent = Math.log(x) * Math.LOG10E;
        var powerOf10 = Math.round(exponent);
        var isPowerOf10 = x === Math.pow(10, powerOf10);
        return isPowerOf10 ? powerOf10 : exponent;
      }
    };
    var helpers_math = exports$2;
    helpers_core.log10 = exports$2.log10;
    var getRtlAdapter = function getRtlAdapter(rectX, width) {
      return {
        x: function x(_x2) {
          return rectX + rectX + width - _x2;
        },
        setWidth: function setWidth(w) {
          width = w;
        },
        textAlign: function textAlign(align) {
          if (align === 'center') {
            return align;
          }
          return align === 'right' ? 'left' : 'right';
        },
        xPlus: function xPlus(x, value) {
          return x - value;
        },
        leftForLtr: function leftForLtr(x, itemWidth) {
          return x - itemWidth;
        }
      };
    };
    var getLtrAdapter = function getLtrAdapter() {
      return {
        x: function x(_x3) {
          return _x3;
        },
        setWidth: function setWidth(w) {},
        textAlign: function textAlign(align) {
          return align;
        },
        xPlus: function xPlus(x, value) {
          return x + value;
        },
        leftForLtr: function leftForLtr(x, _itemWidth) {
          return x;
        }
      };
    };
    var getAdapter = function getAdapter(rtl, rectX, width) {
      return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
    };
    var overrideTextDirection = function overrideTextDirection(ctx, direction) {
      var style, original;
      if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [style.getPropertyValue('direction'), style.getPropertyPriority('direction')];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
      }
    };
    var restoreTextDirection = function restoreTextDirection(ctx) {
      var original = ctx.prevTextDirection;
      if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
      }
    };
    var helpers_rtl = {
      getRtlAdapter: getAdapter,
      overrideTextDirection: overrideTextDirection,
      restoreTextDirection: restoreTextDirection
    };
    var helpers$1 = helpers_core;
    var easing = helpers_easing;
    var canvas = helpers_canvas;
    var options = helpers_options;
    var math = helpers_math;
    var rtl = helpers_rtl;
    helpers$1.easing = easing;
    helpers$1.canvas = canvas;
    helpers$1.options = options;
    helpers$1.math = math;
    helpers$1.rtl = rtl;
    function interpolate(start, view, model, ease) {
      var keys = Object.keys(model);
      var i, ilen, key, actual, origin, target, type, c0, c1;
      for (i = 0, ilen = keys.length; i < ilen; ++i) {
        key = keys[i];
        target = model[key];
        if (!view.hasOwnProperty(key)) {
          view[key] = target;
        }
        actual = view[key];
        if (actual === target || key[0] === '_') {
          continue;
        }
        if (!start.hasOwnProperty(key)) {
          start[key] = actual;
        }
        origin = start[key];
        type = typeof target;
        if (type === typeof origin) {
          if (type === 'string') {
            c0 = chartjsColor(origin);
            if (c0.valid) {
              c1 = chartjsColor(target);
              if (c1.valid) {
                view[key] = c1.mix(c0, ease).rgbString();
                continue;
              }
            }
          } else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
            view[key] = origin + (target - origin) * ease;
            continue;
          }
        }
        view[key] = target;
      }
    }
    var Element = function Element(configuration) {
      helpers$1.extend(this, configuration);
      this.initialize.apply(this, arguments);
    };
    helpers$1.extend(Element.prototype, {
      _type: undefined,
      initialize: function initialize() {
        this.hidden = false;
      },
      pivot: function pivot() {
        var me = this;
        if (!me._view) {
          me._view = helpers$1.extend({}, me._model);
        }
        me._start = {};
        return me;
      },
      transition: function transition(ease) {
        var me = this;
        var model = me._model;
        var start = me._start;
        var view = me._view;
        if (!model || ease === 1) {
          me._view = helpers$1.extend({}, model);
          me._start = null;
          return me;
        }
        if (!view) {
          view = me._view = {};
        }
        if (!start) {
          start = me._start = {};
        }
        interpolate(start, view, model, ease);
        return me;
      },
      tooltipPosition: function tooltipPosition() {
        return {
          x: this._model.x,
          y: this._model.y
        };
      },
      hasValue: function hasValue() {
        return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
      }
    });
    Element.extend = helpers$1.inherits;
    var core_element = Element;
    var exports$3 = core_element.extend({
      chart: null,
      currentStep: 0,
      numSteps: 60,
      easing: '',
      render: null,
      onAnimationProgress: null,
      onAnimationComplete: null
    });
    var core_animation = exports$3;
    Object.defineProperty(exports$3.prototype, 'animationObject', {
      get: function get() {
        return this;
      }
    });
    Object.defineProperty(exports$3.prototype, 'chartInstance', {
      get: function get() {
        return this.chart;
      },
      set: function set(value) {
        this.chart = value;
      }
    });
    core_defaults._set('global', {
      animation: {
        duration: 1000,
        easing: 'easeOutQuart',
        onProgress: helpers$1.noop,
        onComplete: helpers$1.noop
      }
    });
    var core_animations = {
      animations: [],
      request: null,
      addAnimation: function addAnimation(chart, animation, duration, lazy) {
        var animations = this.animations;
        var i, ilen;
        animation.chart = chart;
        animation.startTime = Date.now();
        animation.duration = duration;
        if (!lazy) {
          chart.animating = true;
        }
        for (i = 0, ilen = animations.length; i < ilen; ++i) {
          if (animations[i].chart === chart) {
            animations[i] = animation;
            return;
          }
        }
        animations.push(animation);
        if (animations.length === 1) {
          this.requestAnimationFrame();
        }
      },
      cancelAnimation: function cancelAnimation(chart) {
        var index = helpers$1.findIndex(this.animations, function (animation) {
          return animation.chart === chart;
        });
        if (index !== -1) {
          this.animations.splice(index, 1);
          chart.animating = false;
        }
      },
      requestAnimationFrame: function requestAnimationFrame() {
        var me = this;
        if (me.request === null) {
          me.request = helpers$1.requestAnimFrame.call(window, function () {
            me.request = null;
            me.startDigest();
          });
        }
      },
      startDigest: function startDigest() {
        var me = this;
        me.advance();
        if (me.animations.length > 0) {
          me.requestAnimationFrame();
        }
      },
      advance: function advance() {
        var animations = this.animations;
        var animation, chart, numSteps, nextStep;
        var i = 0;
        while (i < animations.length) {
          animation = animations[i];
          chart = animation.chart;
          numSteps = animation.numSteps;
          nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
          animation.currentStep = Math.min(nextStep, numSteps);
          helpers$1.callback(animation.render, [chart, animation], chart);
          helpers$1.callback(animation.onAnimationProgress, [animation], chart);
          if (animation.currentStep >= numSteps) {
            helpers$1.callback(animation.onAnimationComplete, [animation], chart);
            chart.animating = false;
            animations.splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    };
    var resolve = helpers$1.options.resolve;
    var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
    function listenArrayEvents(array, listener) {
      if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
      }
      Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
          listeners: [listener]
        }
      });
      arrayEvents.forEach(function (key) {
        var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
        var base = array[key];
        Object.defineProperty(array, key, {
          configurable: true,
          enumerable: false,
          value: function value() {
            var args = Array.prototype.slice.call(arguments);
            var res = base.apply(this, args);
            helpers$1.each(array._chartjs.listeners, function (object) {
              if (typeof object[method] === 'function') {
                object[method].apply(object, args);
              }
            });
            return res;
          }
        });
      });
    }
    function unlistenArrayEvents(array, listener) {
      var stub = array._chartjs;
      if (!stub) {
        return;
      }
      var listeners = stub.listeners;
      var index = listeners.indexOf(listener);
      if (index !== -1) {
        listeners.splice(index, 1);
      }
      if (listeners.length > 0) {
        return;
      }
      arrayEvents.forEach(function (key) {
        delete array[key];
      });
      delete array._chartjs;
    }
    var DatasetController = function DatasetController(chart, datasetIndex) {
      this.initialize(chart, datasetIndex);
    };
    helpers$1.extend(DatasetController.prototype, {
      datasetElementType: null,
      dataElementType: null,
      _datasetElementOptions: ['backgroundColor', 'borderCapStyle', 'borderColor', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'borderWidth'],
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'pointStyle'],
      initialize: function initialize(chart, datasetIndex) {
        var me = this;
        me.chart = chart;
        me.index = datasetIndex;
        me.linkScales();
        me.addElements();
        me._type = me.getMeta().type;
      },
      updateIndex: function updateIndex(datasetIndex) {
        this.index = datasetIndex;
      },
      linkScales: function linkScales() {
        var me = this;
        var meta = me.getMeta();
        var chart = me.chart;
        var scales = chart.scales;
        var dataset = me.getDataset();
        var scalesOpts = chart.options.scales;
        if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
          meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
        }
        if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
          meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
        }
      },
      getDataset: function getDataset() {
        return this.chart.data.datasets[this.index];
      },
      getMeta: function getMeta() {
        return this.chart.getDatasetMeta(this.index);
      },
      getScaleForId: function getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
      },
      _getValueScaleId: function _getValueScaleId() {
        return this.getMeta().yAxisID;
      },
      _getIndexScaleId: function _getIndexScaleId() {
        return this.getMeta().xAxisID;
      },
      _getValueScale: function _getValueScale() {
        return this.getScaleForId(this._getValueScaleId());
      },
      _getIndexScale: function _getIndexScale() {
        return this.getScaleForId(this._getIndexScaleId());
      },
      reset: function reset() {
        this._update(true);
      },
      destroy: function destroy() {
        if (this._data) {
          unlistenArrayEvents(this._data, this);
        }
      },
      createMetaDataset: function createMetaDataset() {
        var me = this;
        var type = me.datasetElementType;
        return type && new type({
          _chart: me.chart,
          _datasetIndex: me.index
        });
      },
      createMetaData: function createMetaData(index) {
        var me = this;
        var type = me.dataElementType;
        return type && new type({
          _chart: me.chart,
          _datasetIndex: me.index,
          _index: index
        });
      },
      addElements: function addElements() {
        var me = this;
        var meta = me.getMeta();
        var data = me.getDataset().data || [];
        var metaData = meta.data;
        var i, ilen;
        for (i = 0, ilen = data.length; i < ilen; ++i) {
          metaData[i] = metaData[i] || me.createMetaData(i);
        }
        meta.dataset = meta.dataset || me.createMetaDataset();
      },
      addElementAndReset: function addElementAndReset(index) {
        var element = this.createMetaData(index);
        this.getMeta().data.splice(index, 0, element);
        this.updateElement(element, index, true);
      },
      buildOrUpdateElements: function buildOrUpdateElements() {
        var me = this;
        var dataset = me.getDataset();
        var data = dataset.data || (dataset.data = []);
        if (me._data !== data) {
          if (me._data) {
            unlistenArrayEvents(me._data, me);
          }
          if (data && Object.isExtensible(data)) {
            listenArrayEvents(data, me);
          }
          me._data = data;
        }
        me.resyncElements();
      },
      _configure: function _configure() {
        var me = this;
        me._config = helpers$1.merge(Object.create(null), [me.chart.options.datasets[me._type], me.getDataset()], {
          merger: function merger(key, target, source) {
            if (key !== '_meta' && key !== 'data') {
              helpers$1._merger(key, target, source);
            }
          }
        });
      },
      _update: function _update(reset) {
        var me = this;
        me._configure();
        me._cachedDataOpts = null;
        me.update(reset);
      },
      update: helpers$1.noop,
      transition: function transition(easingValue) {
        var meta = this.getMeta();
        var elements = meta.data || [];
        var ilen = elements.length;
        var i = 0;
        for (; i < ilen; ++i) {
          elements[i].transition(easingValue);
        }
        if (meta.dataset) {
          meta.dataset.transition(easingValue);
        }
      },
      draw: function draw() {
        var meta = this.getMeta();
        var elements = meta.data || [];
        var ilen = elements.length;
        var i = 0;
        if (meta.dataset) {
          meta.dataset.draw();
        }
        for (; i < ilen; ++i) {
          elements[i].draw();
        }
      },
      getStyle: function getStyle(index) {
        var me = this;
        var meta = me.getMeta();
        var dataset = meta.dataset;
        var style;
        me._configure();
        if (dataset && index === undefined) {
          style = me._resolveDatasetElementOptions(dataset || {});
        } else {
          index = index || 0;
          style = me._resolveDataElementOptions(meta.data[index] || {}, index);
        }
        if (style.fill === false || style.fill === null) {
          style.backgroundColor = style.borderColor;
        }
        return style;
      },
      _resolveDatasetElementOptions: function _resolveDatasetElementOptions(element, hover) {
        var me = this;
        var chart = me.chart;
        var datasetOpts = me._config;
        var custom = element.custom || {};
        var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
        var elementOptions = me._datasetElementOptions;
        var values = {};
        var i, ilen, key, readKey;
        var context = {
          chart: chart,
          dataset: me.getDataset(),
          datasetIndex: me.index,
          hover: hover
        };
        for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
          key = elementOptions[i];
          readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
          values[key] = resolve([custom[readKey], datasetOpts[readKey], options[readKey]], context);
        }
        return values;
      },
      _resolveDataElementOptions: function _resolveDataElementOptions(element, index) {
        var me = this;
        var custom = element && element.custom;
        var cached = me._cachedDataOpts;
        if (cached && !custom) {
          return cached;
        }
        var chart = me.chart;
        var datasetOpts = me._config;
        var options = chart.options.elements[me.dataElementType.prototype._type] || {};
        var elementOptions = me._dataElementOptions;
        var values = {};
        var context = {
          chart: chart,
          dataIndex: index,
          dataset: me.getDataset(),
          datasetIndex: me.index
        };
        var info = {
          cacheable: !custom
        };
        var keys, i, ilen, key;
        custom = custom || {};
        if (helpers$1.isArray(elementOptions)) {
          for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
            key = elementOptions[i];
            values[key] = resolve([custom[key], datasetOpts[key], options[key]], context, index, info);
          }
        } else {
          keys = Object.keys(elementOptions);
          for (i = 0, ilen = keys.length; i < ilen; ++i) {
            key = keys[i];
            values[key] = resolve([custom[key], datasetOpts[elementOptions[key]], datasetOpts[key], options[key]], context, index, info);
          }
        }
        if (info.cacheable) {
          me._cachedDataOpts = Object.freeze(values);
        }
        return values;
      },
      removeHoverStyle: function removeHoverStyle(element) {
        helpers$1.merge(element._model, element.$previousStyle || {});
        delete element.$previousStyle;
      },
      setHoverStyle: function setHoverStyle(element) {
        var dataset = this.chart.data.datasets[element._datasetIndex];
        var index = element._index;
        var custom = element.custom || {};
        var model = element._model;
        var getHoverColor = helpers$1.getHoverColor;
        element.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth
        };
        model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
        model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
        model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
      },
      _removeDatasetHoverStyle: function _removeDatasetHoverStyle() {
        var element = this.getMeta().dataset;
        if (element) {
          this.removeHoverStyle(element);
        }
      },
      _setDatasetHoverStyle: function _setDatasetHoverStyle() {
        var element = this.getMeta().dataset;
        var prev = {};
        var i, ilen, key, keys, hoverOptions, model;
        if (!element) {
          return;
        }
        model = element._model;
        hoverOptions = this._resolveDatasetElementOptions(element, true);
        keys = Object.keys(hoverOptions);
        for (i = 0, ilen = keys.length; i < ilen; ++i) {
          key = keys[i];
          prev[key] = model[key];
          model[key] = hoverOptions[key];
        }
        element.$previousStyle = prev;
      },
      resyncElements: function resyncElements() {
        var me = this;
        var meta = me.getMeta();
        var data = me.getDataset().data;
        var numMeta = meta.data.length;
        var numData = data.length;
        if (numData < numMeta) {
          meta.data.splice(numData, numMeta - numData);
        } else if (numData > numMeta) {
          me.insertElements(numMeta, numData - numMeta);
        }
      },
      insertElements: function insertElements(start, count) {
        for (var i = 0; i < count; ++i) {
          this.addElementAndReset(start + i);
        }
      },
      onDataPush: function onDataPush() {
        var count = arguments.length;
        this.insertElements(this.getDataset().data.length - count, count);
      },
      onDataPop: function onDataPop() {
        this.getMeta().data.pop();
      },
      onDataShift: function onDataShift() {
        this.getMeta().data.shift();
      },
      onDataSplice: function onDataSplice(start, count) {
        this.getMeta().data.splice(start, count);
        this.insertElements(start, arguments.length - 2);
      },
      onDataUnshift: function onDataUnshift() {
        this.insertElements(0, arguments.length);
      }
    });
    DatasetController.extend = helpers$1.inherits;
    var core_datasetController = DatasetController;
    var TAU = Math.PI * 2;
    core_defaults._set('global', {
      elements: {
        arc: {
          backgroundColor: core_defaults.global.defaultColor,
          borderColor: '#fff',
          borderWidth: 2,
          borderAlign: 'center'
        }
      }
    });
    function clipArc(ctx, arc) {
      var startAngle = arc.startAngle;
      var endAngle = arc.endAngle;
      var pixelMargin = arc.pixelMargin;
      var angleMargin = pixelMargin / arc.outerRadius;
      var x = arc.x;
      var y = arc.y;
      ctx.beginPath();
      ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
      if (arc.innerRadius > pixelMargin) {
        angleMargin = pixelMargin / arc.innerRadius;
        ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
      } else {
        ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
      }
      ctx.closePath();
      ctx.clip();
    }
    function drawFullCircleBorders(ctx, vm, arc, inner) {
      var endAngle = arc.endAngle;
      var i;
      if (inner) {
        arc.endAngle = arc.startAngle + TAU;
        clipArc(ctx, arc);
        arc.endAngle = endAngle;
        if (arc.endAngle === arc.startAngle && arc.fullCircles) {
          arc.endAngle += TAU;
          arc.fullCircles--;
        }
      }
      ctx.beginPath();
      ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
      for (i = 0; i < arc.fullCircles; ++i) {
        ctx.stroke();
      }
      ctx.beginPath();
      ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
      for (i = 0; i < arc.fullCircles; ++i) {
        ctx.stroke();
      }
    }
    function drawBorder(ctx, vm, arc) {
      var inner = vm.borderAlign === 'inner';
      if (inner) {
        ctx.lineWidth = vm.borderWidth * 2;
        ctx.lineJoin = 'round';
      } else {
        ctx.lineWidth = vm.borderWidth;
        ctx.lineJoin = 'bevel';
      }
      if (arc.fullCircles) {
        drawFullCircleBorders(ctx, vm, arc, inner);
      }
      if (inner) {
        clipArc(ctx, arc);
      }
      ctx.beginPath();
      ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
      ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
      ctx.closePath();
      ctx.stroke();
    }
    var element_arc = core_element.extend({
      _type: 'arc',
      inLabelRange: function inLabelRange(mouseX) {
        var vm = this._view;
        if (vm) {
          return Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2);
        }
        return false;
      },
      inRange: function inRange(chartX, chartY) {
        var vm = this._view;
        if (vm) {
          var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {
            x: chartX,
            y: chartY
          });
          var angle = pointRelativePosition.angle;
          var distance = pointRelativePosition.distance;
          var startAngle = vm.startAngle;
          var endAngle = vm.endAngle;
          while (endAngle < startAngle) {
            endAngle += TAU;
          }
          while (angle > endAngle) {
            angle -= TAU;
          }
          while (angle < startAngle) {
            angle += TAU;
          }
          var betweenAngles = angle >= startAngle && angle <= endAngle;
          var withinRadius = distance >= vm.innerRadius && distance <= vm.outerRadius;
          return betweenAngles && withinRadius;
        }
        return false;
      },
      getCenterPoint: function getCenterPoint() {
        var vm = this._view;
        var halfAngle = (vm.startAngle + vm.endAngle) / 2;
        var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
        return {
          x: vm.x + Math.cos(halfAngle) * halfRadius,
          y: vm.y + Math.sin(halfAngle) * halfRadius
        };
      },
      getArea: function getArea() {
        var vm = this._view;
        return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
      },
      tooltipPosition: function tooltipPosition() {
        var vm = this._view;
        var centreAngle = vm.startAngle + (vm.endAngle - vm.startAngle) / 2;
        var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
        return {
          x: vm.x + Math.cos(centreAngle) * rangeFromCentre,
          y: vm.y + Math.sin(centreAngle) * rangeFromCentre
        };
      },
      draw: function draw() {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var pixelMargin = vm.borderAlign === 'inner' ? 0.33 : 0;
        var arc = {
          x: vm.x,
          y: vm.y,
          innerRadius: vm.innerRadius,
          outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
          pixelMargin: pixelMargin,
          startAngle: vm.startAngle,
          endAngle: vm.endAngle,
          fullCircles: Math.floor(vm.circumference / TAU)
        };
        var i;
        ctx.save();
        ctx.fillStyle = vm.backgroundColor;
        ctx.strokeStyle = vm.borderColor;
        if (arc.fullCircles) {
          arc.endAngle = arc.startAngle + TAU;
          ctx.beginPath();
          ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
          ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
          ctx.closePath();
          for (i = 0; i < arc.fullCircles; ++i) {
            ctx.fill();
          }
          arc.endAngle = arc.startAngle + vm.circumference % TAU;
        }
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
        ctx.closePath();
        ctx.fill();
        if (vm.borderWidth) {
          drawBorder(ctx, vm, arc);
        }
        ctx.restore();
      }
    });
    var valueOrDefault$1 = helpers$1.valueOrDefault;
    var defaultColor = core_defaults.global.defaultColor;
    core_defaults._set('global', {
      elements: {
        line: {
          tension: 0.4,
          backgroundColor: defaultColor,
          borderWidth: 3,
          borderColor: defaultColor,
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          capBezierPoints: true,
          fill: true
        }
      }
    });
    var element_line = core_element.extend({
      _type: 'line',
      draw: function draw() {
        var me = this;
        var vm = me._view;
        var ctx = me._chart.ctx;
        var spanGaps = vm.spanGaps;
        var points = me._children.slice();
        var globalDefaults = core_defaults.global;
        var globalOptionLineElements = globalDefaults.elements.line;
        var lastDrawnIndex = -1;
        var closePath = me._loop;
        var index, previous, currentVM;
        if (!points.length) {
          return;
        }
        if (me._loop) {
          for (index = 0; index < points.length; ++index) {
            previous = helpers$1.previousItem(points, index);
            if (!points[index]._view.skip && previous._view.skip) {
              points = points.slice(index).concat(points.slice(0, index));
              closePath = spanGaps;
              break;
            }
          }
          if (closePath) {
            points.push(points[0]);
          }
        }
        ctx.save();
        ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
        if (ctx.setLineDash) {
          ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
        }
        ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
        ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
        ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
        ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
        ctx.beginPath();
        currentVM = points[0]._view;
        if (!currentVM.skip) {
          ctx.moveTo(currentVM.x, currentVM.y);
          lastDrawnIndex = 0;
        }
        for (index = 1; index < points.length; ++index) {
          currentVM = points[index]._view;
          previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
          if (!currentVM.skip) {
            if (lastDrawnIndex !== index - 1 && !spanGaps || lastDrawnIndex === -1) {
              ctx.moveTo(currentVM.x, currentVM.y);
            } else {
              helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
            }
            lastDrawnIndex = index;
          }
        }
        if (closePath) {
          ctx.closePath();
        }
        ctx.stroke();
        ctx.restore();
      }
    });
    var valueOrDefault$2 = helpers$1.valueOrDefault;
    var defaultColor$1 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
      elements: {
        point: {
          radius: 3,
          pointStyle: 'circle',
          backgroundColor: defaultColor$1,
          borderColor: defaultColor$1,
          borderWidth: 1,
          hitRadius: 1,
          hoverRadius: 4,
          hoverBorderWidth: 1
        }
      }
    });
    function xRange(mouseX) {
      var vm = this._view;
      return vm ? Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius : false;
    }
    function yRange(mouseY) {
      var vm = this._view;
      return vm ? Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius : false;
    }
    var element_point = core_element.extend({
      _type: 'point',
      inRange: function inRange(mouseX, mouseY) {
        var vm = this._view;
        return vm ? Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2) < Math.pow(vm.hitRadius + vm.radius, 2) : false;
      },
      inLabelRange: xRange,
      inXRange: xRange,
      inYRange: yRange,
      getCenterPoint: function getCenterPoint() {
        var vm = this._view;
        return {
          x: vm.x,
          y: vm.y
        };
      },
      getArea: function getArea() {
        return Math.PI * Math.pow(this._view.radius, 2);
      },
      tooltipPosition: function tooltipPosition() {
        var vm = this._view;
        return {
          x: vm.x,
          y: vm.y,
          padding: vm.radius + vm.borderWidth
        };
      },
      draw: function draw(chartArea) {
        var vm = this._view;
        var ctx = this._chart.ctx;
        var pointStyle = vm.pointStyle;
        var rotation = vm.rotation;
        var radius = vm.radius;
        var x = vm.x;
        var y = vm.y;
        var globalDefaults = core_defaults.global;
        var defaultColor = globalDefaults.defaultColor;
        if (vm.skip) {
          return;
        }
        if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
          ctx.strokeStyle = vm.borderColor || defaultColor;
          ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
          ctx.fillStyle = vm.backgroundColor || defaultColor;
          helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
        }
      }
    });
    var defaultColor$2 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
      elements: {
        rectangle: {
          backgroundColor: defaultColor$2,
          borderColor: defaultColor$2,
          borderSkipped: 'bottom',
          borderWidth: 0
        }
      }
    });
    function isVertical(vm) {
      return vm && vm.width !== undefined;
    }
    function getBarBounds(vm) {
      var x1, x2, y1, y2, half;
      if (isVertical(vm)) {
        half = vm.width / 2;
        x1 = vm.x - half;
        x2 = vm.x + half;
        y1 = Math.min(vm.y, vm.base);
        y2 = Math.max(vm.y, vm.base);
      } else {
        half = vm.height / 2;
        x1 = Math.min(vm.x, vm.base);
        x2 = Math.max(vm.x, vm.base);
        y1 = vm.y - half;
        y2 = vm.y + half;
      }
      return {
        left: x1,
        top: y1,
        right: x2,
        bottom: y2
      };
    }
    function swap(orig, v1, v2) {
      return orig === v1 ? v2 : orig === v2 ? v1 : orig;
    }
    function parseBorderSkipped(vm) {
      var edge = vm.borderSkipped;
      var res = {};
      if (!edge) {
        return res;
      }
      if (vm.horizontal) {
        if (vm.base > vm.x) {
          edge = swap(edge, 'left', 'right');
        }
      } else if (vm.base < vm.y) {
        edge = swap(edge, 'bottom', 'top');
      }
      res[edge] = true;
      return res;
    }
    function parseBorderWidth(vm, maxW, maxH) {
      var value = vm.borderWidth;
      var skip = parseBorderSkipped(vm);
      var t, r, b, l;
      if (helpers$1.isObject(value)) {
        t = +value.top || 0;
        r = +value.right || 0;
        b = +value.bottom || 0;
        l = +value.left || 0;
      } else {
        t = r = b = l = +value || 0;
      }
      return {
        t: skip.top || t < 0 ? 0 : t > maxH ? maxH : t,
        r: skip.right || r < 0 ? 0 : r > maxW ? maxW : r,
        b: skip.bottom || b < 0 ? 0 : b > maxH ? maxH : b,
        l: skip.left || l < 0 ? 0 : l > maxW ? maxW : l
      };
    }
    function boundingRects(vm) {
      var bounds = getBarBounds(vm);
      var width = bounds.right - bounds.left;
      var height = bounds.bottom - bounds.top;
      var border = parseBorderWidth(vm, width / 2, height / 2);
      return {
        outer: {
          x: bounds.left,
          y: bounds.top,
          w: width,
          h: height
        },
        inner: {
          x: bounds.left + border.l,
          y: bounds.top + border.t,
          w: width - border.l - border.r,
          h: height - border.t - border.b
        }
      };
    }
    function _inRange(vm, x, y) {
      var skipX = x === null;
      var skipY = y === null;
      var bounds = !vm || skipX && skipY ? false : getBarBounds(vm);
      return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
    }
    var element_rectangle = core_element.extend({
      _type: 'rectangle',
      draw: function draw() {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var rects = boundingRects(vm);
        var outer = rects.outer;
        var inner = rects.inner;
        ctx.fillStyle = vm.backgroundColor;
        ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
        if (outer.w === inner.w && outer.h === inner.h) {
          return;
        }
        ctx.save();
        ctx.beginPath();
        ctx.rect(outer.x, outer.y, outer.w, outer.h);
        ctx.clip();
        ctx.fillStyle = vm.borderColor;
        ctx.rect(inner.x, inner.y, inner.w, inner.h);
        ctx.fill('evenodd');
        ctx.restore();
      },
      height: function height() {
        var vm = this._view;
        return vm.base - vm.y;
      },
      inRange: function inRange(mouseX, mouseY) {
        return _inRange(this._view, mouseX, mouseY);
      },
      inLabelRange: function inLabelRange(mouseX, mouseY) {
        var vm = this._view;
        return isVertical(vm) ? _inRange(vm, mouseX, null) : _inRange(vm, null, mouseY);
      },
      inXRange: function inXRange(mouseX) {
        return _inRange(this._view, mouseX, null);
      },
      inYRange: function inYRange(mouseY) {
        return _inRange(this._view, null, mouseY);
      },
      getCenterPoint: function getCenterPoint() {
        var vm = this._view;
        var x, y;
        if (isVertical(vm)) {
          x = vm.x;
          y = (vm.y + vm.base) / 2;
        } else {
          x = (vm.x + vm.base) / 2;
          y = vm.y;
        }
        return {
          x: x,
          y: y
        };
      },
      getArea: function getArea() {
        var vm = this._view;
        return isVertical(vm) ? vm.width * Math.abs(vm.y - vm.base) : vm.height * Math.abs(vm.x - vm.base);
      },
      tooltipPosition: function tooltipPosition() {
        var vm = this._view;
        return {
          x: vm.x,
          y: vm.y
        };
      }
    });
    var elements = {};
    var Arc = element_arc;
    var Line = element_line;
    var Point = element_point;
    var Rectangle = element_rectangle;
    elements.Arc = Arc;
    elements.Line = Line;
    elements.Point = Point;
    elements.Rectangle = Rectangle;
    var deprecated = helpers$1._deprecated;
    var valueOrDefault$3 = helpers$1.valueOrDefault;
    core_defaults._set('bar', {
      hover: {
        mode: 'label'
      },
      scales: {
        xAxes: [{
          type: 'category',
          offset: true,
          gridLines: {
            offsetGridLines: true
          }
        }],
        yAxes: [{
          type: 'linear'
        }]
      }
    });
    core_defaults._set('global', {
      datasets: {
        bar: {
          categoryPercentage: 0.8,
          barPercentage: 0.9
        }
      }
    });
    function computeMinSampleSize(scale, pixels) {
      var min = scale._length;
      var prev, curr, i, ilen;
      for (i = 1, ilen = pixels.length; i < ilen; ++i) {
        min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
      }
      for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
        curr = scale.getPixelForTick(i);
        min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
        prev = curr;
      }
      return min;
    }
    function computeFitCategoryTraits(index, ruler, options) {
      var thickness = options.barThickness;
      var count = ruler.stackCount;
      var curr = ruler.pixels[index];
      var min = helpers$1.isNullOrUndef(thickness) ? computeMinSampleSize(ruler.scale, ruler.pixels) : -1;
      var size, ratio;
      if (helpers$1.isNullOrUndef(thickness)) {
        size = min * options.categoryPercentage;
        ratio = options.barPercentage;
      } else {
        size = thickness * count;
        ratio = 1;
      }
      return {
        chunk: size / count,
        ratio: ratio,
        start: curr - size / 2
      };
    }
    function computeFlexCategoryTraits(index, ruler, options) {
      var pixels = ruler.pixels;
      var curr = pixels[index];
      var prev = index > 0 ? pixels[index - 1] : null;
      var next = index < pixels.length - 1 ? pixels[index + 1] : null;
      var percent = options.categoryPercentage;
      var start, size;
      if (prev === null) {
        prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
      }
      if (next === null) {
        next = curr + curr - prev;
      }
      start = curr - (curr - Math.min(prev, next)) / 2 * percent;
      size = Math.abs(next - prev) / 2 * percent;
      return {
        chunk: size / ruler.stackCount,
        ratio: options.barPercentage,
        start: start
      };
    }
    var controller_bar = core_datasetController.extend({
      dataElementType: elements.Rectangle,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderSkipped', 'borderWidth', 'barPercentage', 'barThickness', 'categoryPercentage', 'maxBarThickness', 'minBarLength'],
      initialize: function initialize() {
        var me = this;
        var meta, scaleOpts;
        core_datasetController.prototype.initialize.apply(me, arguments);
        meta = me.getMeta();
        meta.stack = me.getDataset().stack;
        meta.bar = true;
        scaleOpts = me._getIndexScale().options;
        deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
        deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
        deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
        deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
        deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
      },
      update: function update(reset) {
        var me = this;
        var rects = me.getMeta().data;
        var i, ilen;
        me._ruler = me.getRuler();
        for (i = 0, ilen = rects.length; i < ilen; ++i) {
          me.updateElement(rects[i], i, reset);
        }
      },
      updateElement: function updateElement(rectangle, index, reset) {
        var me = this;
        var meta = me.getMeta();
        var dataset = me.getDataset();
        var options = me._resolveDataElementOptions(rectangle, index);
        rectangle._xScale = me.getScaleForId(meta.xAxisID);
        rectangle._yScale = me.getScaleForId(meta.yAxisID);
        rectangle._datasetIndex = me.index;
        rectangle._index = index;
        rectangle._model = {
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderSkipped: options.borderSkipped,
          borderWidth: options.borderWidth,
          datasetLabel: dataset.label,
          label: me.chart.data.labels[index]
        };
        if (helpers$1.isArray(dataset.data[index])) {
          rectangle._model.borderSkipped = null;
        }
        me._updateElementGeometry(rectangle, index, reset, options);
        rectangle.pivot();
      },
      _updateElementGeometry: function _updateElementGeometry(rectangle, index, reset, options) {
        var me = this;
        var model = rectangle._model;
        var vscale = me._getValueScale();
        var base = vscale.getBasePixel();
        var horizontal = vscale.isHorizontal();
        var ruler = me._ruler || me.getRuler();
        var vpixels = me.calculateBarValuePixels(me.index, index, options);
        var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
        model.horizontal = horizontal;
        model.base = reset ? base : vpixels.base;
        model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
        model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
        model.height = horizontal ? ipixels.size : undefined;
        model.width = horizontal ? undefined : ipixels.size;
      },
      _getStacks: function _getStacks(last) {
        var me = this;
        var scale = me._getIndexScale();
        var metasets = scale._getMatchingVisibleMetas(me._type);
        var stacked = scale.options.stacked;
        var ilen = metasets.length;
        var stacks = [];
        var i, meta;
        for (i = 0; i < ilen; ++i) {
          meta = metasets[i];
          if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) {
            stacks.push(meta.stack);
          }
          if (meta.index === last) {
            break;
          }
        }
        return stacks;
      },
      getStackCount: function getStackCount() {
        return this._getStacks().length;
      },
      getStackIndex: function getStackIndex(datasetIndex, name) {
        var stacks = this._getStacks(datasetIndex);
        var index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
      },
      getRuler: function getRuler() {
        var me = this;
        var scale = me._getIndexScale();
        var pixels = [];
        var i, ilen;
        for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
          pixels.push(scale.getPixelForValue(null, i, me.index));
        }
        return {
          pixels: pixels,
          start: scale._startPixel,
          end: scale._endPixel,
          stackCount: me.getStackCount(),
          scale: scale
        };
      },
      calculateBarValuePixels: function calculateBarValuePixels(datasetIndex, index, options) {
        var me = this;
        var chart = me.chart;
        var scale = me._getValueScale();
        var isHorizontal = scale.isHorizontal();
        var datasets = chart.data.datasets;
        var metasets = scale._getMatchingVisibleMetas(me._type);
        var value = scale._parseValue(datasets[datasetIndex].data[index]);
        var minBarLength = options.minBarLength;
        var stacked = scale.options.stacked;
        var stack = me.getMeta().stack;
        var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
        var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
        var ilen = metasets.length;
        var i, imeta, ivalue, base, head, size, stackLength;
        if (stacked || stacked === undefined && stack !== undefined) {
          for (i = 0; i < ilen; ++i) {
            imeta = metasets[i];
            if (imeta.index === datasetIndex) {
              break;
            }
            if (imeta.stack === stack) {
              stackLength = scale._parseValue(datasets[imeta.index].data[index]);
              ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
              if (value.min < 0 && ivalue < 0 || value.max >= 0 && ivalue > 0) {
                start += ivalue;
              }
            }
          }
        }
        base = scale.getPixelForValue(start);
        head = scale.getPixelForValue(start + length);
        size = head - base;
        if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
          size = minBarLength;
          if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
            head = base - minBarLength;
          } else {
            head = base + minBarLength;
          }
        }
        return {
          size: size,
          base: base,
          head: head,
          center: head + size / 2
        };
      },
      calculateBarIndexPixels: function calculateBarIndexPixels(datasetIndex, index, ruler, options) {
        var me = this;
        var range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options) : computeFitCategoryTraits(index, ruler, options);
        var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
        var center = range.start + range.chunk * stackIndex + range.chunk / 2;
        var size = Math.min(valueOrDefault$3(options.maxBarThickness, Infinity), range.chunk * range.ratio);
        return {
          base: center - size / 2,
          head: center + size / 2,
          center: center,
          size: size
        };
      },
      draw: function draw() {
        var me = this;
        var chart = me.chart;
        var scale = me._getValueScale();
        var rects = me.getMeta().data;
        var dataset = me.getDataset();
        var ilen = rects.length;
        var i = 0;
        helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
        for (; i < ilen; ++i) {
          var val = scale._parseValue(dataset.data[i]);
          if (!isNaN(val.min) && !isNaN(val.max)) {
            rects[i].draw();
          }
        }
        helpers$1.canvas.unclipArea(chart.ctx);
      },
      _resolveDataElementOptions: function _resolveDataElementOptions() {
        var me = this;
        var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
        var indexOpts = me._getIndexScale().options;
        var valueOpts = me._getValueScale().options;
        values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
        values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
        values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
        values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
        values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
        return values;
      }
    });
    var valueOrDefault$4 = helpers$1.valueOrDefault;
    var resolve$1 = helpers$1.options.resolve;
    core_defaults._set('bubble', {
      hover: {
        mode: 'single'
      },
      scales: {
        xAxes: [{
          type: 'linear',
          position: 'bottom',
          id: 'x-axis-0'
        }],
        yAxes: [{
          type: 'linear',
          position: 'left',
          id: 'y-axis-0'
        }]
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(item, data) {
            var datasetLabel = data.datasets[item.datasetIndex].label || '';
            var dataPoint = data.datasets[item.datasetIndex].data[item.index];
            return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
          }
        }
      }
    });
    var controller_bubble = core_datasetController.extend({
      dataElementType: elements.Point,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth', 'hoverRadius', 'hitRadius', 'pointStyle', 'rotation'],
      update: function update(reset) {
        var me = this;
        var meta = me.getMeta();
        var points = meta.data;
        helpers$1.each(points, function (point, index) {
          me.updateElement(point, index, reset);
        });
      },
      updateElement: function updateElement(point, index, reset) {
        var me = this;
        var meta = me.getMeta();
        var custom = point.custom || {};
        var xScale = me.getScaleForId(meta.xAxisID);
        var yScale = me.getScaleForId(meta.yAxisID);
        var options = me._resolveDataElementOptions(point, index);
        var data = me.getDataset().data[index];
        var dsIndex = me.index;
        var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
        var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
        point._xScale = xScale;
        point._yScale = yScale;
        point._options = options;
        point._datasetIndex = dsIndex;
        point._index = index;
        point._model = {
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderWidth: options.borderWidth,
          hitRadius: options.hitRadius,
          pointStyle: options.pointStyle,
          rotation: options.rotation,
          radius: reset ? 0 : options.radius,
          skip: custom.skip || isNaN(x) || isNaN(y),
          x: x,
          y: y
        };
        point.pivot();
      },
      setHoverStyle: function setHoverStyle(point) {
        var model = point._model;
        var options = point._options;
        var getHoverColor = helpers$1.getHoverColor;
        point.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth,
          radius: model.radius
        };
        model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
        model.radius = options.radius + options.hoverRadius;
      },
      _resolveDataElementOptions: function _resolveDataElementOptions(point, index) {
        var me = this;
        var chart = me.chart;
        var dataset = me.getDataset();
        var custom = point.custom || {};
        var data = dataset.data[index] || {};
        var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
        var context = {
          chart: chart,
          dataIndex: index,
          dataset: dataset,
          datasetIndex: me.index
        };
        if (me._cachedDataOpts === values) {
          values = helpers$1.extend({}, values);
        }
        values.radius = resolve$1([custom.radius, data.r, me._config.radius, chart.options.elements.point.radius], context, index);
        return values;
      }
    });
    var valueOrDefault$5 = helpers$1.valueOrDefault;
    var PI$1 = Math.PI;
    var DOUBLE_PI$1 = PI$1 * 2;
    var HALF_PI$1 = PI$1 / 2;
    core_defaults._set('doughnut', {
      animation: {
        animateRotate: true,
        animateScale: false
      },
      hover: {
        mode: 'single'
      },
      legendCallback: function legendCallback(chart) {
        var list = document.createElement('ul');
        var data = chart.data;
        var datasets = data.datasets;
        var labels = data.labels;
        var i, ilen, listItem, listItemSpan;
        list.setAttribute('class', chart.id + '-legend');
        if (datasets.length) {
          for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
            listItem = list.appendChild(document.createElement('li'));
            listItemSpan = listItem.appendChild(document.createElement('span'));
            listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
            if (labels[i]) {
              listItem.appendChild(document.createTextNode(labels[i]));
            }
          }
        }
        return list.outerHTML;
      },
      legend: {
        labels: {
          generateLabels: function generateLabels(chart) {
            var data = chart.data;
            if (data.labels.length && data.datasets.length) {
              return data.labels.map(function (label, i) {
                var meta = chart.getDatasetMeta(0);
                var style = meta.controller.getStyle(i);
                return {
                  text: label,
                  fillStyle: style.backgroundColor,
                  strokeStyle: style.borderColor,
                  lineWidth: style.borderWidth,
                  hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                  index: i
                };
              });
            }
            return [];
          }
        },
        onClick: function onClick(e, legendItem) {
          var index = legendItem.index;
          var chart = this.chart;
          var i, ilen, meta;
          for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
            meta = chart.getDatasetMeta(i);
            if (meta.data[index]) {
              meta.data[index].hidden = !meta.data[index].hidden;
            }
          }
          chart.update();
        }
      },
      cutoutPercentage: 50,
      rotation: -HALF_PI$1,
      circumference: DOUBLE_PI$1,
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(tooltipItem, data) {
            var dataLabel = data.labels[tooltipItem.index];
            var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            if (helpers$1.isArray(dataLabel)) {
              dataLabel = dataLabel.slice();
              dataLabel[0] += value;
            } else {
              dataLabel += value;
            }
            return dataLabel;
          }
        }
      }
    });
    var controller_doughnut = core_datasetController.extend({
      dataElementType: elements.Arc,
      linkScales: helpers$1.noop,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'borderAlign', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth'],
      getRingIndex: function getRingIndex(datasetIndex) {
        var ringIndex = 0;
        for (var j = 0; j < datasetIndex; ++j) {
          if (this.chart.isDatasetVisible(j)) {
            ++ringIndex;
          }
        }
        return ringIndex;
      },
      update: function update(reset) {
        var me = this;
        var chart = me.chart;
        var chartArea = chart.chartArea;
        var opts = chart.options;
        var ratioX = 1;
        var ratioY = 1;
        var offsetX = 0;
        var offsetY = 0;
        var meta = me.getMeta();
        var arcs = meta.data;
        var cutout = opts.cutoutPercentage / 100 || 0;
        var circumference = opts.circumference;
        var chartWeight = me._getRingWeight(me.index);
        var maxWidth, maxHeight, i, ilen;
        if (circumference < DOUBLE_PI$1) {
          var startAngle = opts.rotation % DOUBLE_PI$1;
          startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
          var endAngle = startAngle + circumference;
          var startX = Math.cos(startAngle);
          var startY = Math.sin(startAngle);
          var endX = Math.cos(endAngle);
          var endY = Math.sin(endAngle);
          var contains0 = startAngle <= 0 && endAngle >= 0 || endAngle >= DOUBLE_PI$1;
          var contains90 = startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1 || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
          var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
          var contains270 = startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1 || endAngle >= PI$1 + HALF_PI$1;
          var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
          var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
          var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
          var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
          ratioX = (maxX - minX) / 2;
          ratioY = (maxY - minY) / 2;
          offsetX = -(maxX + minX) / 2;
          offsetY = -(maxY + minY) / 2;
        }
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
        }
        chart.borderWidth = me.getMaxBorderWidth();
        maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
        maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
        chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
        chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
        chart.offsetX = offsetX * chart.outerRadius;
        chart.offsetY = offsetY * chart.outerRadius;
        meta.total = me.calculateTotal();
        me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
        me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          me.updateElement(arcs[i], i, reset);
        }
      },
      updateElement: function updateElement(arc, index, reset) {
        var me = this;
        var chart = me.chart;
        var chartArea = chart.chartArea;
        var opts = chart.options;
        var animationOpts = opts.animation;
        var centerX = (chartArea.left + chartArea.right) / 2;
        var centerY = (chartArea.top + chartArea.bottom) / 2;
        var startAngle = opts.rotation;
        var endAngle = opts.rotation;
        var dataset = me.getDataset();
        var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
        var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
        var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
        var options = arc._options || {};
        helpers$1.extend(arc, {
          _datasetIndex: me.index,
          _index: index,
          _model: {
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: options.borderWidth,
            borderAlign: options.borderAlign,
            x: centerX + chart.offsetX,
            y: centerY + chart.offsetY,
            startAngle: startAngle,
            endAngle: endAngle,
            circumference: circumference,
            outerRadius: outerRadius,
            innerRadius: innerRadius,
            label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
          }
        });
        var model = arc._model;
        if (!reset || !animationOpts.animateRotate) {
          if (index === 0) {
            model.startAngle = opts.rotation;
          } else {
            model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
          }
          model.endAngle = model.startAngle + model.circumference;
        }
        arc.pivot();
      },
      calculateTotal: function calculateTotal() {
        var dataset = this.getDataset();
        var meta = this.getMeta();
        var total = 0;
        var value;
        helpers$1.each(meta.data, function (element, index) {
          value = dataset.data[index];
          if (!isNaN(value) && !element.hidden) {
            total += Math.abs(value);
          }
        });
        return total;
      },
      calculateCircumference: function calculateCircumference(value) {
        var total = this.getMeta().total;
        if (total > 0 && !isNaN(value)) {
          return DOUBLE_PI$1 * (Math.abs(value) / total);
        }
        return 0;
      },
      getMaxBorderWidth: function getMaxBorderWidth(arcs) {
        var me = this;
        var max = 0;
        var chart = me.chart;
        var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
        if (!arcs) {
          for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
            if (chart.isDatasetVisible(i)) {
              meta = chart.getDatasetMeta(i);
              arcs = meta.data;
              if (i !== me.index) {
                controller = meta.controller;
              }
              break;
            }
          }
        }
        if (!arcs) {
          return 0;
        }
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          arc = arcs[i];
          if (controller) {
            controller._configure();
            options = controller._resolveDataElementOptions(arc, i);
          } else {
            options = arc._options;
          }
          if (options.borderAlign !== 'inner') {
            borderWidth = options.borderWidth;
            hoverWidth = options.hoverBorderWidth;
            max = borderWidth > max ? borderWidth : max;
            max = hoverWidth > max ? hoverWidth : max;
          }
        }
        return max;
      },
      setHoverStyle: function setHoverStyle(arc) {
        var model = arc._model;
        var options = arc._options;
        var getHoverColor = helpers$1.getHoverColor;
        arc.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth
        };
        model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
      },
      _getRingWeightOffset: function _getRingWeightOffset(datasetIndex) {
        var ringWeightOffset = 0;
        for (var i = 0; i < datasetIndex; ++i) {
          if (this.chart.isDatasetVisible(i)) {
            ringWeightOffset += this._getRingWeight(i);
          }
        }
        return ringWeightOffset;
      },
      _getRingWeight: function _getRingWeight(dataSetIndex) {
        return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
      },
      _getVisibleDatasetWeightTotal: function _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length);
      }
    });
    core_defaults._set('horizontalBar', {
      hover: {
        mode: 'index',
        axis: 'y'
      },
      scales: {
        xAxes: [{
          type: 'linear',
          position: 'bottom'
        }],
        yAxes: [{
          type: 'category',
          position: 'left',
          offset: true,
          gridLines: {
            offsetGridLines: true
          }
        }]
      },
      elements: {
        rectangle: {
          borderSkipped: 'left'
        }
      },
      tooltips: {
        mode: 'index',
        axis: 'y'
      }
    });
    core_defaults._set('global', {
      datasets: {
        horizontalBar: {
          categoryPercentage: 0.8,
          barPercentage: 0.9
        }
      }
    });
    var controller_horizontalBar = controller_bar.extend({
      _getValueScaleId: function _getValueScaleId() {
        return this.getMeta().xAxisID;
      },
      _getIndexScaleId: function _getIndexScaleId() {
        return this.getMeta().yAxisID;
      }
    });
    var valueOrDefault$6 = helpers$1.valueOrDefault;
    var resolve$2 = helpers$1.options.resolve;
    var isPointInArea = helpers$1.canvas._isPointInArea;
    core_defaults._set('line', {
      showLines: true,
      spanGaps: false,
      hover: {
        mode: 'label'
      },
      scales: {
        xAxes: [{
          type: 'category',
          id: 'x-axis-0'
        }],
        yAxes: [{
          type: 'linear',
          id: 'y-axis-0'
        }]
      }
    });
    function scaleClip(scale, halfBorderWidth) {
      var tickOpts = scale && scale.options.ticks || {};
      var reverse = tickOpts.reverse;
      var min = tickOpts.min === undefined ? halfBorderWidth : 0;
      var max = tickOpts.max === undefined ? halfBorderWidth : 0;
      return {
        start: reverse ? max : min,
        end: reverse ? min : max
      };
    }
    function defaultClip(xScale, yScale, borderWidth) {
      var halfBorderWidth = borderWidth / 2;
      var x = scaleClip(xScale, halfBorderWidth);
      var y = scaleClip(yScale, halfBorderWidth);
      return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
      };
    }
    function toClip(value) {
      var t, r, b, l;
      if (helpers$1.isObject(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
      } else {
        t = r = b = l = value;
      }
      return {
        top: t,
        right: r,
        bottom: b,
        left: l
      };
    }
    var controller_line = core_datasetController.extend({
      datasetElementType: elements.Line,
      dataElementType: elements.Point,
      _datasetElementOptions: ['backgroundColor', 'borderCapStyle', 'borderColor', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'borderWidth', 'cubicInterpolationMode', 'fill'],
      _dataElementOptions: {
        backgroundColor: 'pointBackgroundColor',
        borderColor: 'pointBorderColor',
        borderWidth: 'pointBorderWidth',
        hitRadius: 'pointHitRadius',
        hoverBackgroundColor: 'pointHoverBackgroundColor',
        hoverBorderColor: 'pointHoverBorderColor',
        hoverBorderWidth: 'pointHoverBorderWidth',
        hoverRadius: 'pointHoverRadius',
        pointStyle: 'pointStyle',
        radius: 'pointRadius',
        rotation: 'pointRotation'
      },
      update: function update(reset) {
        var me = this;
        var meta = me.getMeta();
        var line = meta.dataset;
        var points = meta.data || [];
        var options = me.chart.options;
        var config = me._config;
        var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
        var i, ilen;
        me._xScale = me.getScaleForId(meta.xAxisID);
        me._yScale = me.getScaleForId(meta.yAxisID);
        if (showLine) {
          if (config.tension !== undefined && config.lineTension === undefined) {
            config.lineTension = config.tension;
          }
          line._scale = me._yScale;
          line._datasetIndex = me.index;
          line._children = points;
          line._model = me._resolveDatasetElementOptions(line);
          line.pivot();
        }
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          me.updateElement(points[i], i, reset);
        }
        if (showLine && line._model.tension !== 0) {
          me.updateBezierControlPoints();
        }
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          points[i].pivot();
        }
      },
      updateElement: function updateElement(point, index, reset) {
        var me = this;
        var meta = me.getMeta();
        var custom = point.custom || {};
        var dataset = me.getDataset();
        var datasetIndex = me.index;
        var value = dataset.data[index];
        var xScale = me._xScale;
        var yScale = me._yScale;
        var lineModel = meta.dataset._model;
        var x, y;
        var options = me._resolveDataElementOptions(point, index);
        x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
        y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
        point._xScale = xScale;
        point._yScale = yScale;
        point._options = options;
        point._datasetIndex = datasetIndex;
        point._index = index;
        point._model = {
          x: x,
          y: y,
          skip: custom.skip || isNaN(x) || isNaN(y),
          radius: options.radius,
          pointStyle: options.pointStyle,
          rotation: options.rotation,
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderWidth: options.borderWidth,
          tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
          steppedLine: lineModel ? lineModel.steppedLine : false,
          hitRadius: options.hitRadius
        };
      },
      _resolveDatasetElementOptions: function _resolveDatasetElementOptions(element) {
        var me = this;
        var config = me._config;
        var custom = element.custom || {};
        var options = me.chart.options;
        var lineOptions = options.elements.line;
        var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
        values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
        values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
        values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
        values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
        return values;
      },
      calculatePointY: function calculatePointY(value, index, datasetIndex) {
        var me = this;
        var chart = me.chart;
        var yScale = me._yScale;
        var sumPos = 0;
        var sumNeg = 0;
        var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
        if (yScale.options.stacked) {
          rightValue = +yScale.getRightValue(value);
          metasets = chart._getSortedVisibleDatasetMetas();
          ilen = metasets.length;
          for (i = 0; i < ilen; ++i) {
            dsMeta = metasets[i];
            if (dsMeta.index === datasetIndex) {
              break;
            }
            ds = chart.data.datasets[dsMeta.index];
            if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
              stackedRightValue = +yScale.getRightValue(ds.data[index]);
              if (stackedRightValue < 0) {
                sumNeg += stackedRightValue || 0;
              } else {
                sumPos += stackedRightValue || 0;
              }
            }
          }
          if (rightValue < 0) {
            return yScale.getPixelForValue(sumNeg + rightValue);
          }
          return yScale.getPixelForValue(sumPos + rightValue);
        }
        return yScale.getPixelForValue(value);
      },
      updateBezierControlPoints: function updateBezierControlPoints() {
        var me = this;
        var chart = me.chart;
        var meta = me.getMeta();
        var lineModel = meta.dataset._model;
        var area = chart.chartArea;
        var points = meta.data || [];
        var i, ilen, model, controlPoints;
        if (lineModel.spanGaps) {
          points = points.filter(function (pt) {
            return !pt._model.skip;
          });
        }
        function capControlPoint(pt, min, max) {
          return Math.max(Math.min(pt, max), min);
        }
        if (lineModel.cubicInterpolationMode === 'monotone') {
          helpers$1.splineCurveMonotone(points);
        } else {
          for (i = 0, ilen = points.length; i < ilen; ++i) {
            model = points[i]._model;
            controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i)._model, model, helpers$1.nextItem(points, i)._model, lineModel.tension);
            model.controlPointPreviousX = controlPoints.previous.x;
            model.controlPointPreviousY = controlPoints.previous.y;
            model.controlPointNextX = controlPoints.next.x;
            model.controlPointNextY = controlPoints.next.y;
          }
        }
        if (chart.options.elements.line.capBezierPoints) {
          for (i = 0, ilen = points.length; i < ilen; ++i) {
            model = points[i]._model;
            if (isPointInArea(model, area)) {
              if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
                model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
                model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
              }
              if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
                model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
                model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
              }
            }
          }
        }
      },
      draw: function draw() {
        var me = this;
        var chart = me.chart;
        var meta = me.getMeta();
        var points = meta.data || [];
        var area = chart.chartArea;
        var canvas = chart.canvas;
        var i = 0;
        var ilen = points.length;
        var clip;
        if (me._showLine) {
          clip = meta.dataset._model.clip;
          helpers$1.canvas.clipArea(chart.ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? canvas.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
          });
          meta.dataset.draw();
          helpers$1.canvas.unclipArea(chart.ctx);
        }
        for (; i < ilen; ++i) {
          points[i].draw(area);
        }
      },
      setHoverStyle: function setHoverStyle(point) {
        var model = point._model;
        var options = point._options;
        var getHoverColor = helpers$1.getHoverColor;
        point.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth,
          radius: model.radius
        };
        model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
        model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
      }
    });
    var resolve$3 = helpers$1.options.resolve;
    core_defaults._set('polarArea', {
      scale: {
        type: 'radialLinear',
        angleLines: {
          display: false
        },
        gridLines: {
          circular: true
        },
        pointLabels: {
          display: false
        },
        ticks: {
          beginAtZero: true
        }
      },
      animation: {
        animateRotate: true,
        animateScale: true
      },
      startAngle: -0.5 * Math.PI,
      legendCallback: function legendCallback(chart) {
        var list = document.createElement('ul');
        var data = chart.data;
        var datasets = data.datasets;
        var labels = data.labels;
        var i, ilen, listItem, listItemSpan;
        list.setAttribute('class', chart.id + '-legend');
        if (datasets.length) {
          for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
            listItem = list.appendChild(document.createElement('li'));
            listItemSpan = listItem.appendChild(document.createElement('span'));
            listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
            if (labels[i]) {
              listItem.appendChild(document.createTextNode(labels[i]));
            }
          }
        }
        return list.outerHTML;
      },
      legend: {
        labels: {
          generateLabels: function generateLabels(chart) {
            var data = chart.data;
            if (data.labels.length && data.datasets.length) {
              return data.labels.map(function (label, i) {
                var meta = chart.getDatasetMeta(0);
                var style = meta.controller.getStyle(i);
                return {
                  text: label,
                  fillStyle: style.backgroundColor,
                  strokeStyle: style.borderColor,
                  lineWidth: style.borderWidth,
                  hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                  index: i
                };
              });
            }
            return [];
          }
        },
        onClick: function onClick(e, legendItem) {
          var index = legendItem.index;
          var chart = this.chart;
          var i, ilen, meta;
          for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
            meta = chart.getDatasetMeta(i);
            meta.data[index].hidden = !meta.data[index].hidden;
          }
          chart.update();
        }
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(item, data) {
            return data.labels[item.index] + ': ' + item.yLabel;
          }
        }
      }
    });
    var controller_polarArea = core_datasetController.extend({
      dataElementType: elements.Arc,
      linkScales: helpers$1.noop,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'borderAlign', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth'],
      _getIndexScaleId: function _getIndexScaleId() {
        return this.chart.scale.id;
      },
      _getValueScaleId: function _getValueScaleId() {
        return this.chart.scale.id;
      },
      update: function update(reset) {
        var me = this;
        var dataset = me.getDataset();
        var meta = me.getMeta();
        var start = me.chart.options.startAngle || 0;
        var starts = me._starts = [];
        var angles = me._angles = [];
        var arcs = meta.data;
        var i, ilen, angle;
        me._updateRadius();
        meta.count = me.countVisibleElements();
        for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
          starts[i] = start;
          angle = me._computeAngle(i);
          angles[i] = angle;
          start += angle;
        }
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
          me.updateElement(arcs[i], i, reset);
        }
      },
      _updateRadius: function _updateRadius() {
        var me = this;
        var chart = me.chart;
        var chartArea = chart.chartArea;
        var opts = chart.options;
        var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        chart.outerRadius = Math.max(minSize / 2, 0);
        chart.innerRadius = Math.max(opts.cutoutPercentage ? chart.outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
        me.outerRadius = chart.outerRadius - chart.radiusLength * me.index;
        me.innerRadius = me.outerRadius - chart.radiusLength;
      },
      updateElement: function updateElement(arc, index, reset) {
        var me = this;
        var chart = me.chart;
        var dataset = me.getDataset();
        var opts = chart.options;
        var animationOpts = opts.animation;
        var scale = chart.scale;
        var labels = chart.data.labels;
        var centerX = scale.xCenter;
        var centerY = scale.yCenter;
        var datasetStartAngle = opts.startAngle;
        var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
        var startAngle = me._starts[index];
        var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
        var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
        var options = arc._options || {};
        helpers$1.extend(arc, {
          _datasetIndex: me.index,
          _index: index,
          _scale: scale,
          _model: {
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: options.borderWidth,
            borderAlign: options.borderAlign,
            x: centerX,
            y: centerY,
            innerRadius: 0,
            outerRadius: reset ? resetRadius : distance,
            startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
            endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
            label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
          }
        });
        arc.pivot();
      },
      countVisibleElements: function countVisibleElements() {
        var dataset = this.getDataset();
        var meta = this.getMeta();
        var count = 0;
        helpers$1.each(meta.data, function (element, index) {
          if (!isNaN(dataset.data[index]) && !element.hidden) {
            count++;
          }
        });
        return count;
      },
      setHoverStyle: function setHoverStyle(arc) {
        var model = arc._model;
        var options = arc._options;
        var getHoverColor = helpers$1.getHoverColor;
        var valueOrDefault = helpers$1.valueOrDefault;
        arc.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth
        };
        model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
      },
      _computeAngle: function _computeAngle(index) {
        var me = this;
        var count = this.getMeta().count;
        var dataset = me.getDataset();
        var meta = me.getMeta();
        if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
          return 0;
        }
        var context = {
          chart: me.chart,
          dataIndex: index,
          dataset: dataset,
          datasetIndex: me.index
        };
        return resolve$3([me.chart.options.elements.arc.angle, 2 * Math.PI / count], context, index);
      }
    });
    core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
    core_defaults._set('pie', {
      cutoutPercentage: 0
    });
    var controller_pie = controller_doughnut;
    var valueOrDefault$7 = helpers$1.valueOrDefault;
    core_defaults._set('radar', {
      spanGaps: false,
      scale: {
        type: 'radialLinear'
      },
      elements: {
        line: {
          fill: 'start',
          tension: 0
        }
      }
    });
    var controller_radar = core_datasetController.extend({
      datasetElementType: elements.Line,
      dataElementType: elements.Point,
      linkScales: helpers$1.noop,
      _datasetElementOptions: ['backgroundColor', 'borderWidth', 'borderColor', 'borderCapStyle', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'fill'],
      _dataElementOptions: {
        backgroundColor: 'pointBackgroundColor',
        borderColor: 'pointBorderColor',
        borderWidth: 'pointBorderWidth',
        hitRadius: 'pointHitRadius',
        hoverBackgroundColor: 'pointHoverBackgroundColor',
        hoverBorderColor: 'pointHoverBorderColor',
        hoverBorderWidth: 'pointHoverBorderWidth',
        hoverRadius: 'pointHoverRadius',
        pointStyle: 'pointStyle',
        radius: 'pointRadius',
        rotation: 'pointRotation'
      },
      _getIndexScaleId: function _getIndexScaleId() {
        return this.chart.scale.id;
      },
      _getValueScaleId: function _getValueScaleId() {
        return this.chart.scale.id;
      },
      update: function update(reset) {
        var me = this;
        var meta = me.getMeta();
        var line = meta.dataset;
        var points = meta.data || [];
        var scale = me.chart.scale;
        var config = me._config;
        var i, ilen;
        if (config.tension !== undefined && config.lineTension === undefined) {
          config.lineTension = config.tension;
        }
        line._scale = scale;
        line._datasetIndex = me.index;
        line._children = points;
        line._loop = true;
        line._model = me._resolveDatasetElementOptions(line);
        line.pivot();
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          me.updateElement(points[i], i, reset);
        }
        me.updateBezierControlPoints();
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          points[i].pivot();
        }
      },
      updateElement: function updateElement(point, index, reset) {
        var me = this;
        var custom = point.custom || {};
        var dataset = me.getDataset();
        var scale = me.chart.scale;
        var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
        var options = me._resolveDataElementOptions(point, index);
        var lineModel = me.getMeta().dataset._model;
        var x = reset ? scale.xCenter : pointPosition.x;
        var y = reset ? scale.yCenter : pointPosition.y;
        point._scale = scale;
        point._options = options;
        point._datasetIndex = me.index;
        point._index = index;
        point._model = {
          x: x,
          y: y,
          skip: custom.skip || isNaN(x) || isNaN(y),
          radius: options.radius,
          pointStyle: options.pointStyle,
          rotation: options.rotation,
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderWidth: options.borderWidth,
          tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
          hitRadius: options.hitRadius
        };
      },
      _resolveDatasetElementOptions: function _resolveDatasetElementOptions() {
        var me = this;
        var config = me._config;
        var options = me.chart.options;
        var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
        values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
        values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
        return values;
      },
      updateBezierControlPoints: function updateBezierControlPoints() {
        var me = this;
        var meta = me.getMeta();
        var area = me.chart.chartArea;
        var points = meta.data || [];
        var i, ilen, model, controlPoints;
        if (meta.dataset._model.spanGaps) {
          points = points.filter(function (pt) {
            return !pt._model.skip;
          });
        }
        function capControlPoint(pt, min, max) {
          return Math.max(Math.min(pt, max), min);
        }
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          model = points[i]._model;
          controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i, true)._model, model, helpers$1.nextItem(points, i, true)._model, model.tension);
          model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
          model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
          model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
          model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
        }
      },
      setHoverStyle: function setHoverStyle(point) {
        var model = point._model;
        var options = point._options;
        var getHoverColor = helpers$1.getHoverColor;
        point.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth,
          radius: model.radius
        };
        model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
        model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
      }
    });
    core_defaults._set('scatter', {
      hover: {
        mode: 'single'
      },
      scales: {
        xAxes: [{
          id: 'x-axis-1',
          type: 'linear',
          position: 'bottom'
        }],
        yAxes: [{
          id: 'y-axis-1',
          type: 'linear',
          position: 'left'
        }]
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(item) {
            return '(' + item.xLabel + ', ' + item.yLabel + ')';
          }
        }
      }
    });
    core_defaults._set('global', {
      datasets: {
        scatter: {
          showLine: false
        }
      }
    });
    var controller_scatter = controller_line;
    var controllers = {
      bar: controller_bar,
      bubble: controller_bubble,
      doughnut: controller_doughnut,
      horizontalBar: controller_horizontalBar,
      line: controller_line,
      polarArea: controller_polarArea,
      pie: controller_pie,
      radar: controller_radar,
      scatter: controller_scatter
    };
    function getRelativePosition(e, chart) {
      if (e["native"]) {
        return {
          x: e.x,
          y: e.y
        };
      }
      return helpers$1.getRelativePosition(e, chart);
    }
    function parseVisibleItems(chart, handler) {
      var metasets = chart._getSortedVisibleDatasetMetas();
      var metadata, i, j, ilen, jlen, element;
      for (i = 0, ilen = metasets.length; i < ilen; ++i) {
        metadata = metasets[i].data;
        for (j = 0, jlen = metadata.length; j < jlen; ++j) {
          element = metadata[j];
          if (!element._view.skip) {
            handler(element);
          }
        }
      }
    }
    function getIntersectItems(chart, position) {
      var elements = [];
      parseVisibleItems(chart, function (element) {
        if (element.inRange(position.x, position.y)) {
          elements.push(element);
        }
      });
      return elements;
    }
    function getNearestItems(chart, position, intersect, distanceMetric) {
      var minDistance = Number.POSITIVE_INFINITY;
      var nearestItems = [];
      parseVisibleItems(chart, function (element) {
        if (intersect && !element.inRange(position.x, position.y)) {
          return;
        }
        var center = element.getCenterPoint();
        var distance = distanceMetric(position, center);
        if (distance < minDistance) {
          nearestItems = [element];
          minDistance = distance;
        } else if (distance === minDistance) {
          nearestItems.push(element);
        }
      });
      return nearestItems;
    }
    function getDistanceMetricForAxis(axis) {
      var useX = axis.indexOf('x') !== -1;
      var useY = axis.indexOf('y') !== -1;
      return function (pt1, pt2) {
        var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
      };
    }
    function indexMode(chart, e, options) {
      var position = getRelativePosition(e, chart);
      options.axis = options.axis || 'x';
      var distanceMetric = getDistanceMetricForAxis(options.axis);
      var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
      var elements = [];
      if (!items.length) {
        return [];
      }
      chart._getSortedVisibleDatasetMetas().forEach(function (meta) {
        var element = meta.data[items[0]._index];
        if (element && !element._view.skip) {
          elements.push(element);
        }
      });
      return elements;
    }
    var core_interaction = {
      modes: {
        single: function single(chart, e) {
          var position = getRelativePosition(e, chart);
          var elements = [];
          parseVisibleItems(chart, function (element) {
            if (element.inRange(position.x, position.y)) {
              elements.push(element);
              return elements;
            }
          });
          return elements.slice(0, 1);
        },
        label: indexMode,
        index: indexMode,
        dataset: function dataset(chart, e, options) {
          var position = getRelativePosition(e, chart);
          options.axis = options.axis || 'xy';
          var distanceMetric = getDistanceMetricForAxis(options.axis);
          var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
          if (items.length > 0) {
            items = chart.getDatasetMeta(items[0]._datasetIndex).data;
          }
          return items;
        },
        'x-axis': function xAxis(chart, e) {
          return indexMode(chart, e, {
            intersect: false
          });
        },
        point: function point(chart, e) {
          var position = getRelativePosition(e, chart);
          return getIntersectItems(chart, position);
        },
        nearest: function nearest(chart, e, options) {
          var position = getRelativePosition(e, chart);
          options.axis = options.axis || 'xy';
          var distanceMetric = getDistanceMetricForAxis(options.axis);
          return getNearestItems(chart, position, options.intersect, distanceMetric);
        },
        x: function x(chart, e, options) {
          var position = getRelativePosition(e, chart);
          var items = [];
          var intersectsItem = false;
          parseVisibleItems(chart, function (element) {
            if (element.inXRange(position.x)) {
              items.push(element);
            }
            if (element.inRange(position.x, position.y)) {
              intersectsItem = true;
            }
          });
          if (options.intersect && !intersectsItem) {
            items = [];
          }
          return items;
        },
        y: function y(chart, e, options) {
          var position = getRelativePosition(e, chart);
          var items = [];
          var intersectsItem = false;
          parseVisibleItems(chart, function (element) {
            if (element.inYRange(position.y)) {
              items.push(element);
            }
            if (element.inRange(position.x, position.y)) {
              intersectsItem = true;
            }
          });
          if (options.intersect && !intersectsItem) {
            items = [];
          }
          return items;
        }
      }
    };
    var extend = helpers$1.extend;
    function filterByPosition(array, position) {
      return helpers$1.where(array, function (v) {
        return v.pos === position;
      });
    }
    function sortByWeight(array, reverse) {
      return array.sort(function (a, b) {
        var v0 = reverse ? b : a;
        var v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
      });
    }
    function wrapBoxes(boxes) {
      var layoutBoxes = [];
      var i, ilen, box;
      for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
        box = boxes[i];
        layoutBoxes.push({
          index: i,
          box: box,
          pos: box.position,
          horizontal: box.isHorizontal(),
          weight: box.weight
        });
      }
      return layoutBoxes;
    }
    function setLayoutDims(layouts, params) {
      var i, ilen, layout;
      for (i = 0, ilen = layouts.length; i < ilen; ++i) {
        layout = layouts[i];
        layout.width = layout.horizontal ? layout.box.fullWidth && params.availableWidth : params.vBoxMaxWidth;
        layout.height = layout.horizontal && params.hBoxMaxHeight;
      }
    }
    function buildLayoutBoxes(boxes) {
      var layoutBoxes = wrapBoxes(boxes);
      var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
      var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
      var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
      var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
      return {
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(bottom),
        chartArea: filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right),
        horizontal: top.concat(bottom)
      };
    }
    function getCombinedMax(maxPadding, chartArea, a, b) {
      return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
    }
    function updateDims(chartArea, params, layout) {
      var box = layout.box;
      var maxPadding = chartArea.maxPadding;
      var newWidth, newHeight;
      if (layout.size) {
        chartArea[layout.pos] -= layout.size;
      }
      layout.size = layout.horizontal ? box.height : box.width;
      chartArea[layout.pos] += layout.size;
      if (box.getPadding) {
        var boxPadding = box.getPadding();
        maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
        maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
        maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
        maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
      }
      newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
      newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
      if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
        chartArea.w = newWidth;
        chartArea.h = newHeight;
        var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
        return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
      }
    }
    function handleMaxPadding(chartArea) {
      var maxPadding = chartArea.maxPadding;
      function updatePos(pos) {
        var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
      }
      chartArea.y += updatePos('top');
      chartArea.x += updatePos('left');
      updatePos('right');
      updatePos('bottom');
    }
    function getMargins(horizontal, chartArea) {
      var maxPadding = chartArea.maxPadding;
      function marginForPositions(positions) {
        var margin = {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        };
        positions.forEach(function (pos) {
          margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
      }
      return horizontal ? marginForPositions(['left', 'right']) : marginForPositions(['top', 'bottom']);
    }
    function fitBoxes(boxes, chartArea, params) {
      var refitBoxes = [];
      var i, ilen, layout, box, refit, changed;
      for (i = 0, ilen = boxes.length; i < ilen; ++i) {
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
        if (updateDims(chartArea, params, layout)) {
          changed = true;
          if (refitBoxes.length) {
            refit = true;
          }
        }
        if (!box.fullWidth) {
          refitBoxes.push(layout);
        }
      }
      return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
    }
    function placeBoxes(boxes, chartArea, params) {
      var userPadding = params.padding;
      var x = chartArea.x;
      var y = chartArea.y;
      var i, ilen, layout, box;
      for (i = 0, ilen = boxes.length; i < ilen; ++i) {
        layout = boxes[i];
        box = layout.box;
        if (layout.horizontal) {
          box.left = box.fullWidth ? userPadding.left : chartArea.left;
          box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
          box.top = y;
          box.bottom = y + box.height;
          box.width = box.right - box.left;
          y = box.bottom;
        } else {
          box.left = x;
          box.right = x + box.width;
          box.top = chartArea.top;
          box.bottom = chartArea.top + chartArea.h;
          box.height = box.bottom - box.top;
          x = box.right;
        }
      }
      chartArea.x = x;
      chartArea.y = y;
    }
    core_defaults._set('global', {
      layout: {
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      }
    });
    var core_layouts = {
      defaults: {},
      addBox: function addBox(chart, item) {
        if (!chart.boxes) {
          chart.boxes = [];
        }
        item.fullWidth = item.fullWidth || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function () {
          return [{
            z: 0,
            draw: function draw() {
              item.draw.apply(item, arguments);
            }
          }];
        };
        chart.boxes.push(item);
      },
      removeBox: function removeBox(chart, layoutItem) {
        var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) {
          chart.boxes.splice(index, 1);
        }
      },
      configure: function configure(chart, item, options) {
        var props = ['fullWidth', 'position', 'weight'];
        var ilen = props.length;
        var i = 0;
        var prop;
        for (; i < ilen; ++i) {
          prop = props[i];
          if (options.hasOwnProperty(prop)) {
            item[prop] = options[prop];
          }
        }
      },
      update: function update(chart, width, height) {
        if (!chart) {
          return;
        }
        var layoutOptions = chart.options.layout || {};
        var padding = helpers$1.options.toPadding(layoutOptions.padding);
        var availableWidth = width - padding.width;
        var availableHeight = height - padding.height;
        var boxes = buildLayoutBoxes(chart.boxes);
        var verticalBoxes = boxes.vertical;
        var horizontalBoxes = boxes.horizontal;
        var params = Object.freeze({
          outerWidth: width,
          outerHeight: height,
          padding: padding,
          availableWidth: availableWidth,
          vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
          hBoxMaxHeight: availableHeight / 2
        });
        var chartArea = extend({
          maxPadding: extend({}, padding),
          w: availableWidth,
          h: availableHeight,
          x: padding.left,
          y: padding.top
        }, padding);
        setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        fitBoxes(verticalBoxes, chartArea, params);
        if (fitBoxes(horizontalBoxes, chartArea, params)) {
          fitBoxes(verticalBoxes, chartArea, params);
        }
        handleMaxPadding(chartArea);
        placeBoxes(boxes.leftAndTop, chartArea, params);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        placeBoxes(boxes.rightAndBottom, chartArea, params);
        chart.chartArea = {
          left: chartArea.left,
          top: chartArea.top,
          right: chartArea.left + chartArea.w,
          bottom: chartArea.top + chartArea.h
        };
        helpers$1.each(boxes.chartArea, function (layout) {
          var box = layout.box;
          extend(box, chart.chartArea);
          box.update(chartArea.w, chartArea.h);
        });
      }
    };
    var platform_basic = {
      acquireContext: function acquireContext(item) {
        if (item && item.canvas) {
          item = item.canvas;
        }
        return item && item.getContext('2d') || null;
      }
    };
    var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";
    var platform_dom$1 = /*#__PURE__*/Object.freeze({
      __proto__: null,
      'default': platform_dom
    });
    var stylesheet = getCjsExportFromNamespace(platform_dom$1);
    var EXPANDO_KEY = '$chartjs';
    var CSS_PREFIX = 'chartjs-';
    var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
    var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
    var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
    var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];
    var EVENT_TYPES = {
      touchstart: 'mousedown',
      touchmove: 'mousemove',
      touchend: 'mouseup',
      pointerenter: 'mouseenter',
      pointerdown: 'mousedown',
      pointermove: 'mousemove',
      pointerup: 'mouseup',
      pointerleave: 'mouseout',
      pointerout: 'mouseout'
    };
    function readUsedSize(element, property) {
      var value = helpers$1.getStyle(element, property);
      var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
      return matches ? Number(matches[1]) : undefined;
    }
    function initCanvas(canvas, config) {
      var style = canvas.style;
      var renderHeight = canvas.getAttribute('height');
      var renderWidth = canvas.getAttribute('width');
      canvas[EXPANDO_KEY] = {
        initial: {
          height: renderHeight,
          width: renderWidth,
          style: {
            display: style.display,
            height: style.height,
            width: style.width
          }
        }
      };
      style.display = style.display || 'block';
      if (renderWidth === null || renderWidth === '') {
        var displayWidth = readUsedSize(canvas, 'width');
        if (displayWidth !== undefined) {
          canvas.width = displayWidth;
        }
      }
      if (renderHeight === null || renderHeight === '') {
        if (canvas.style.height === '') {
          canvas.height = canvas.width / (config.options.aspectRatio || 2);
        } else {
          var displayHeight = readUsedSize(canvas, 'height');
          if (displayWidth !== undefined) {
            canvas.height = displayHeight;
          }
        }
      }
      return canvas;
    }
    var supportsEventListenerOptions = function () {
      var supports = false;
      try {
        var options = Object.defineProperty({}, 'passive', {
          get: function get() {
            supports = true;
          }
        });
        window.addEventListener('e', null, options);
      } catch (e) {}
      return supports;
    }();
    var eventListenerOptions = supportsEventListenerOptions ? {
      passive: true
    } : false;
    function addListener(node, type, listener) {
      node.addEventListener(type, listener, eventListenerOptions);
    }
    function removeListener(node, type, listener) {
      node.removeEventListener(type, listener, eventListenerOptions);
    }
    function createEvent(type, chart, x, y, nativeEvent) {
      return {
        type: type,
        chart: chart,
        "native": nativeEvent || null,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
      };
    }
    function fromNativeEvent(event, chart) {
      var type = EVENT_TYPES[event.type] || event.type;
      var pos = helpers$1.getRelativePosition(event, chart);
      return createEvent(type, chart, pos.x, pos.y, event);
    }
    function throttled(fn, thisArg) {
      var ticking = false;
      var args = [];
      return function () {
        args = Array.prototype.slice.call(arguments);
        thisArg = thisArg || this;
        if (!ticking) {
          ticking = true;
          helpers$1.requestAnimFrame.call(window, function () {
            ticking = false;
            fn.apply(thisArg, args);
          });
        }
      };
    }
    function createDiv(cls) {
      var el = document.createElement('div');
      el.className = cls || '';
      return el;
    }
    function createResizer(handler) {
      var maxSize = 1000000;
      var resizer = createDiv(CSS_SIZE_MONITOR);
      var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
      var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
      expand.appendChild(createDiv());
      shrink.appendChild(createDiv());
      resizer.appendChild(expand);
      resizer.appendChild(shrink);
      resizer._reset = function () {
        expand.scrollLeft = maxSize;
        expand.scrollTop = maxSize;
        shrink.scrollLeft = maxSize;
        shrink.scrollTop = maxSize;
      };
      var onScroll = function onScroll() {
        resizer._reset();
        handler();
      };
      addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
      addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
      return resizer;
    }
    function watchForRender(node, handler) {
      var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
      var proxy = expando.renderProxy = function (e) {
        if (e.animationName === CSS_RENDER_ANIMATION) {
          handler();
        }
      };
      helpers$1.each(ANIMATION_START_EVENTS, function (type) {
        addListener(node, type, proxy);
      });
      expando.reflow = !!node.offsetParent;
      node.classList.add(CSS_RENDER_MONITOR);
    }
    function unwatchForRender(node) {
      var expando = node[EXPANDO_KEY] || {};
      var proxy = expando.renderProxy;
      if (proxy) {
        helpers$1.each(ANIMATION_START_EVENTS, function (type) {
          removeListener(node, type, proxy);
        });
        delete expando.renderProxy;
      }
      node.classList.remove(CSS_RENDER_MONITOR);
    }
    function addResizeListener(node, listener, chart) {
      var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
      var resizer = expando.resizer = createResizer(throttled(function () {
        if (expando.resizer) {
          var container = chart.options.maintainAspectRatio && node.parentNode;
          var w = container ? container.clientWidth : 0;
          listener(createEvent('resize', chart));
          if (container && container.clientWidth < w && chart.canvas) {
            listener(createEvent('resize', chart));
          }
        }
      }));
      watchForRender(node, function () {
        if (expando.resizer) {
          var container = node.parentNode;
          if (container && container !== resizer.parentNode) {
            container.insertBefore(resizer, container.firstChild);
          }
          resizer._reset();
        }
      });
    }
    function removeResizeListener(node) {
      var expando = node[EXPANDO_KEY] || {};
      var resizer = expando.resizer;
      delete expando.resizer;
      unwatchForRender(node);
      if (resizer && resizer.parentNode) {
        resizer.parentNode.removeChild(resizer);
      }
    }
    function injectCSS(rootNode, css) {
      var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
      if (!expando.containsStyles) {
        expando.containsStyles = true;
        css = '/* Chart.js */\n' + css;
        var style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        style.appendChild(document.createTextNode(css));
        rootNode.appendChild(style);
      }
    }
    var platform_dom$2 = {
      disableCSSInjection: false,
      _enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
      _ensureLoaded: function _ensureLoaded(canvas) {
        if (!this.disableCSSInjection) {
          var root = canvas.getRootNode ? canvas.getRootNode() : document;
          var targetNode = root.host ? root : document.head;
          injectCSS(targetNode, stylesheet);
        }
      },
      acquireContext: function acquireContext(item, config) {
        if (typeof item === 'string') {
          item = document.getElementById(item);
        } else if (item.length) {
          item = item[0];
        }
        if (item && item.canvas) {
          item = item.canvas;
        }
        var context = item && item.getContext && item.getContext('2d');
        if (context && context.canvas === item) {
          this._ensureLoaded(item);
          initCanvas(item, config);
          return context;
        }
        return null;
      },
      releaseContext: function releaseContext(context) {
        var canvas = context.canvas;
        if (!canvas[EXPANDO_KEY]) {
          return;
        }
        var initial = canvas[EXPANDO_KEY].initial;
        ['height', 'width'].forEach(function (prop) {
          var value = initial[prop];
          if (helpers$1.isNullOrUndef(value)) {
            canvas.removeAttribute(prop);
          } else {
            canvas.setAttribute(prop, value);
          }
        });
        helpers$1.each(initial.style || {}, function (value, key) {
          canvas.style[key] = value;
        });
        canvas.width = canvas.width;
        delete canvas[EXPANDO_KEY];
      },
      addEventListener: function addEventListener(chart, type, listener) {
        var canvas = chart.canvas;
        if (type === 'resize') {
          addResizeListener(canvas, listener, chart);
          return;
        }
        var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
        var proxies = expando.proxies || (expando.proxies = {});
        var proxy = proxies[chart.id + '_' + type] = function (event) {
          listener(fromNativeEvent(event, chart));
        };
        addListener(canvas, type, proxy);
      },
      removeEventListener: function removeEventListener(chart, type, listener) {
        var canvas = chart.canvas;
        if (type === 'resize') {
          removeResizeListener(canvas);
          return;
        }
        var expando = listener[EXPANDO_KEY] || {};
        var proxies = expando.proxies || {};
        var proxy = proxies[chart.id + '_' + type];
        if (!proxy) {
          return;
        }
        removeListener(canvas, type, proxy);
      }
    };
    helpers$1.addEvent = addListener;
    helpers$1.removeEvent = removeListener;
    var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
    var platform = helpers$1.extend({
      initialize: function initialize() {},
      acquireContext: function acquireContext() {},
      releaseContext: function releaseContext() {},
      addEventListener: function addEventListener() {},
      removeEventListener: function removeEventListener() {}
    }, implementation);
    core_defaults._set('global', {
      plugins: {}
    });
    var core_plugins = {
      _plugins: [],
      _cacheId: 0,
      register: function register(plugins) {
        var p = this._plugins;
        [].concat(plugins).forEach(function (plugin) {
          if (p.indexOf(plugin) === -1) {
            p.push(plugin);
          }
        });
        this._cacheId++;
      },
      unregister: function unregister(plugins) {
        var p = this._plugins;
        [].concat(plugins).forEach(function (plugin) {
          var idx = p.indexOf(plugin);
          if (idx !== -1) {
            p.splice(idx, 1);
          }
        });
        this._cacheId++;
      },
      clear: function clear() {
        this._plugins = [];
        this._cacheId++;
      },
      count: function count() {
        return this._plugins.length;
      },
      getAll: function getAll() {
        return this._plugins;
      },
      notify: function notify(chart, hook, args) {
        var descriptors = this.descriptors(chart);
        var ilen = descriptors.length;
        var i, descriptor, plugin, params, method;
        for (i = 0; i < ilen; ++i) {
          descriptor = descriptors[i];
          plugin = descriptor.plugin;
          method = plugin[hook];
          if (typeof method === 'function') {
            params = [chart].concat(args || []);
            params.push(descriptor.options);
            if (method.apply(plugin, params) === false) {
              return false;
            }
          }
        }
        return true;
      },
      descriptors: function descriptors(chart) {
        var cache = chart.$plugins || (chart.$plugins = {});
        if (cache.id === this._cacheId) {
          return cache.descriptors;
        }
        var plugins = [];
        var descriptors = [];
        var config = chart && chart.config || {};
        var options = config.options && config.options.plugins || {};
        this._plugins.concat(config.plugins || []).forEach(function (plugin) {
          var idx = plugins.indexOf(plugin);
          if (idx !== -1) {
            return;
          }
          var id = plugin.id;
          var opts = options[id];
          if (opts === false) {
            return;
          }
          if (opts === true) {
            opts = helpers$1.clone(core_defaults.global.plugins[id]);
          }
          plugins.push(plugin);
          descriptors.push({
            plugin: plugin,
            options: opts || {}
          });
        });
        cache.descriptors = descriptors;
        cache.id = this._cacheId;
        return descriptors;
      },
      _invalidate: function _invalidate(chart) {
        delete chart.$plugins;
      }
    };
    var core_scaleService = {
      constructors: {},
      defaults: {},
      registerScaleType: function registerScaleType(type, scaleConstructor, scaleDefaults) {
        this.constructors[type] = scaleConstructor;
        this.defaults[type] = helpers$1.clone(scaleDefaults);
      },
      getScaleConstructor: function getScaleConstructor(type) {
        return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
      },
      getScaleDefaults: function getScaleDefaults(type) {
        return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
      },
      updateScaleDefaults: function updateScaleDefaults(type, additions) {
        var me = this;
        if (me.defaults.hasOwnProperty(type)) {
          me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
        }
      },
      addScalesToLayout: function addScalesToLayout(chart) {
        helpers$1.each(chart.scales, function (scale) {
          scale.fullWidth = scale.options.fullWidth;
          scale.position = scale.options.position;
          scale.weight = scale.options.weight;
          core_layouts.addBox(chart, scale);
        });
      }
    };
    var valueOrDefault$8 = helpers$1.valueOrDefault;
    var getRtlHelper = helpers$1.rtl.getRtlAdapter;
    core_defaults._set('global', {
      tooltips: {
        enabled: true,
        custom: null,
        mode: 'nearest',
        position: 'average',
        intersect: true,
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleFontStyle: 'bold',
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleFontColor: '#fff',
        titleAlign: 'left',
        bodySpacing: 2,
        bodyFontColor: '#fff',
        bodyAlign: 'left',
        footerFontStyle: 'bold',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFontColor: '#fff',
        footerAlign: 'left',
        yPadding: 6,
        xPadding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        multiKeyBackground: '#fff',
        displayColors: true,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        callbacks: {
          beforeTitle: helpers$1.noop,
          title: function title(tooltipItems, data) {
            var title = '';
            var labels = data.labels;
            var labelCount = labels ? labels.length : 0;
            if (tooltipItems.length > 0) {
              var item = tooltipItems[0];
              if (item.label) {
                title = item.label;
              } else if (item.xLabel) {
                title = item.xLabel;
              } else if (labelCount > 0 && item.index < labelCount) {
                title = labels[item.index];
              }
            }
            return title;
          },
          afterTitle: helpers$1.noop,
          beforeBody: helpers$1.noop,
          beforeLabel: helpers$1.noop,
          label: function label(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label || '';
            if (label) {
              label += ': ';
            }
            if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
              label += tooltipItem.value;
            } else {
              label += tooltipItem.yLabel;
            }
            return label;
          },
          labelColor: function labelColor(tooltipItem, chart) {
            var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
            var activeElement = meta.data[tooltipItem.index];
            var view = activeElement._view;
            return {
              borderColor: view.borderColor,
              backgroundColor: view.backgroundColor
            };
          },
          labelTextColor: function labelTextColor() {
            return this._options.bodyFontColor;
          },
          afterLabel: helpers$1.noop,
          afterBody: helpers$1.noop,
          beforeFooter: helpers$1.noop,
          footer: helpers$1.noop,
          afterFooter: helpers$1.noop
        }
      }
    });
    var positioners = {
      average: function average(elements) {
        if (!elements.length) {
          return false;
        }
        var i, len;
        var x = 0;
        var y = 0;
        var count = 0;
        for (i = 0, len = elements.length; i < len; ++i) {
          var el = elements[i];
          if (el && el.hasValue()) {
            var pos = el.tooltipPosition();
            x += pos.x;
            y += pos.y;
            ++count;
          }
        }
        return {
          x: x / count,
          y: y / count
        };
      },
      nearest: function nearest(elements, eventPosition) {
        var x = eventPosition.x;
        var y = eventPosition.y;
        var minDistance = Number.POSITIVE_INFINITY;
        var i, len, nearestElement;
        for (i = 0, len = elements.length; i < len; ++i) {
          var el = elements[i];
          if (el && el.hasValue()) {
            var center = el.getCenterPoint();
            var d = helpers$1.distanceBetweenPoints(eventPosition, center);
            if (d < minDistance) {
              minDistance = d;
              nearestElement = el;
            }
          }
        }
        if (nearestElement) {
          var tp = nearestElement.tooltipPosition();
          x = tp.x;
          y = tp.y;
        }
        return {
          x: x,
          y: y
        };
      }
    };
    function pushOrConcat(base, toPush) {
      if (toPush) {
        if (helpers$1.isArray(toPush)) {
          Array.prototype.push.apply(base, toPush);
        } else {
          base.push(toPush);
        }
      }
      return base;
    }
    function splitNewlines(str) {
      if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
        return str.split('\n');
      }
      return str;
    }
    function createTooltipItem(element) {
      var xScale = element._xScale;
      var yScale = element._yScale || element._scale;
      var index = element._index;
      var datasetIndex = element._datasetIndex;
      var controller = element._chart.getDatasetMeta(datasetIndex).controller;
      var indexScale = controller._getIndexScale();
      var valueScale = controller._getValueScale();
      return {
        xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
        yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
        label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
        value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
        index: index,
        datasetIndex: datasetIndex,
        x: element._model.x,
        y: element._model.y
      };
    }
    function getBaseModel(tooltipOpts) {
      var globalDefaults = core_defaults.global;
      return {
        xPadding: tooltipOpts.xPadding,
        yPadding: tooltipOpts.yPadding,
        xAlign: tooltipOpts.xAlign,
        yAlign: tooltipOpts.yAlign,
        rtl: tooltipOpts.rtl,
        textDirection: tooltipOpts.textDirection,
        bodyFontColor: tooltipOpts.bodyFontColor,
        _bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
        _bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
        _bodyAlign: tooltipOpts.bodyAlign,
        bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
        bodySpacing: tooltipOpts.bodySpacing,
        titleFontColor: tooltipOpts.titleFontColor,
        _titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
        _titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
        titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
        _titleAlign: tooltipOpts.titleAlign,
        titleSpacing: tooltipOpts.titleSpacing,
        titleMarginBottom: tooltipOpts.titleMarginBottom,
        footerFontColor: tooltipOpts.footerFontColor,
        _footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
        _footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
        footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
        _footerAlign: tooltipOpts.footerAlign,
        footerSpacing: tooltipOpts.footerSpacing,
        footerMarginTop: tooltipOpts.footerMarginTop,
        caretSize: tooltipOpts.caretSize,
        cornerRadius: tooltipOpts.cornerRadius,
        backgroundColor: tooltipOpts.backgroundColor,
        opacity: 0,
        legendColorBackground: tooltipOpts.multiKeyBackground,
        displayColors: tooltipOpts.displayColors,
        borderColor: tooltipOpts.borderColor,
        borderWidth: tooltipOpts.borderWidth
      };
    }
    function getTooltipSize(tooltip, model) {
      var ctx = tooltip._chart.ctx;
      var height = model.yPadding * 2;
      var width = 0;
      var body = model.body;
      var combinedBodyLength = body.reduce(function (count, bodyItem) {
        return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
      }, 0);
      combinedBodyLength += model.beforeBody.length + model.afterBody.length;
      var titleLineCount = model.title.length;
      var footerLineCount = model.footer.length;
      var titleFontSize = model.titleFontSize;
      var bodyFontSize = model.bodyFontSize;
      var footerFontSize = model.footerFontSize;
      height += titleLineCount * titleFontSize;
      height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0;
      height += titleLineCount ? model.titleMarginBottom : 0;
      height += combinedBodyLength * bodyFontSize;
      height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0;
      height += footerLineCount ? model.footerMarginTop : 0;
      height += footerLineCount * footerFontSize;
      height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0;
      var widthPadding = 0;
      var maxLineWidth = function maxLineWidth(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
      };
      ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
      helpers$1.each(model.title, maxLineWidth);
      ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
      helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
      widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
      helpers$1.each(body, function (bodyItem) {
        helpers$1.each(bodyItem.before, maxLineWidth);
        helpers$1.each(bodyItem.lines, maxLineWidth);
        helpers$1.each(bodyItem.after, maxLineWidth);
      });
      widthPadding = 0;
      ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
      helpers$1.each(model.footer, maxLineWidth);
      width += 2 * model.xPadding;
      return {
        width: width,
        height: height
      };
    }
    function determineAlignment(tooltip, size) {
      var model = tooltip._model;
      var chart = tooltip._chart;
      var chartArea = tooltip._chart.chartArea;
      var xAlign = 'center';
      var yAlign = 'center';
      if (model.y < size.height) {
        yAlign = 'top';
      } else if (model.y > chart.height - size.height) {
        yAlign = 'bottom';
      }
      var lf, rf;
      var olf, orf;
      var yf;
      var midX = (chartArea.left + chartArea.right) / 2;
      var midY = (chartArea.top + chartArea.bottom) / 2;
      if (yAlign === 'center') {
        lf = function lf(x) {
          return x <= midX;
        };
        rf = function rf(x) {
          return x > midX;
        };
      } else {
        lf = function lf(x) {
          return x <= size.width / 2;
        };
        rf = function rf(x) {
          return x >= chart.width - size.width / 2;
        };
      }
      olf = function olf(x) {
        return x + size.width + model.caretSize + model.caretPadding > chart.width;
      };
      orf = function orf(x) {
        return x - size.width - model.caretSize - model.caretPadding < 0;
      };
      yf = function yf(y) {
        return y <= midY ? 'top' : 'bottom';
      };
      if (lf(model.x)) {
        xAlign = 'left';
        if (olf(model.x)) {
          xAlign = 'center';
          yAlign = yf(model.y);
        }
      } else if (rf(model.x)) {
        xAlign = 'right';
        if (orf(model.x)) {
          xAlign = 'center';
          yAlign = yf(model.y);
        }
      }
      var opts = tooltip._options;
      return {
        xAlign: opts.xAlign ? opts.xAlign : xAlign,
        yAlign: opts.yAlign ? opts.yAlign : yAlign
      };
    }
    function getBackgroundPoint(vm, size, alignment, chart) {
      var x = vm.x;
      var y = vm.y;
      var caretSize = vm.caretSize;
      var caretPadding = vm.caretPadding;
      var cornerRadius = vm.cornerRadius;
      var xAlign = alignment.xAlign;
      var yAlign = alignment.yAlign;
      var paddingAndSize = caretSize + caretPadding;
      var radiusAndPadding = cornerRadius + caretPadding;
      if (xAlign === 'right') {
        x -= size.width;
      } else if (xAlign === 'center') {
        x -= size.width / 2;
        if (x + size.width > chart.width) {
          x = chart.width - size.width;
        }
        if (x < 0) {
          x = 0;
        }
      }
      if (yAlign === 'top') {
        y += paddingAndSize;
      } else if (yAlign === 'bottom') {
        y -= size.height + paddingAndSize;
      } else {
        y -= size.height / 2;
      }
      if (yAlign === 'center') {
        if (xAlign === 'left') {
          x += paddingAndSize;
        } else if (xAlign === 'right') {
          x -= paddingAndSize;
        }
      } else if (xAlign === 'left') {
        x -= radiusAndPadding;
      } else if (xAlign === 'right') {
        x += radiusAndPadding;
      }
      return {
        x: x,
        y: y
      };
    }
    function getAlignedX(vm, align) {
      return align === 'center' ? vm.x + vm.width / 2 : align === 'right' ? vm.x + vm.width - vm.xPadding : vm.x + vm.xPadding;
    }
    function getBeforeAfterBodyLines(callback) {
      return pushOrConcat([], splitNewlines(callback));
    }
    var exports$4 = core_element.extend({
      initialize: function initialize() {
        this._model = getBaseModel(this._options);
        this._lastActive = [];
      },
      getTitle: function getTitle() {
        var me = this;
        var opts = me._options;
        var callbacks = opts.callbacks;
        var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
        var title = callbacks.title.apply(me, arguments);
        var afterTitle = callbacks.afterTitle.apply(me, arguments);
        var lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeTitle));
        lines = pushOrConcat(lines, splitNewlines(title));
        lines = pushOrConcat(lines, splitNewlines(afterTitle));
        return lines;
      },
      getBeforeBody: function getBeforeBody() {
        return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
      },
      getBody: function getBody(tooltipItems, data) {
        var me = this;
        var callbacks = me._options.callbacks;
        var bodyItems = [];
        helpers$1.each(tooltipItems, function (tooltipItem) {
          var bodyItem = {
            before: [],
            lines: [],
            after: []
          };
          pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
          pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
          pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
          bodyItems.push(bodyItem);
        });
        return bodyItems;
      },
      getAfterBody: function getAfterBody() {
        return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
      },
      getFooter: function getFooter() {
        var me = this;
        var callbacks = me._options.callbacks;
        var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
        var footer = callbacks.footer.apply(me, arguments);
        var afterFooter = callbacks.afterFooter.apply(me, arguments);
        var lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeFooter));
        lines = pushOrConcat(lines, splitNewlines(footer));
        lines = pushOrConcat(lines, splitNewlines(afterFooter));
        return lines;
      },
      update: function update(changed) {
        var me = this;
        var opts = me._options;
        var existingModel = me._model;
        var model = me._model = getBaseModel(opts);
        var active = me._active;
        var data = me._data;
        var alignment = {
          xAlign: existingModel.xAlign,
          yAlign: existingModel.yAlign
        };
        var backgroundPoint = {
          x: existingModel.x,
          y: existingModel.y
        };
        var tooltipSize = {
          width: existingModel.width,
          height: existingModel.height
        };
        var tooltipPosition = {
          x: existingModel.caretX,
          y: existingModel.caretY
        };
        var i, len;
        if (active.length) {
          model.opacity = 1;
          var labelColors = [];
          var labelTextColors = [];
          tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
          var tooltipItems = [];
          for (i = 0, len = active.length; i < len; ++i) {
            tooltipItems.push(createTooltipItem(active[i]));
          }
          if (opts.filter) {
            tooltipItems = tooltipItems.filter(function (a) {
              return opts.filter(a, data);
            });
          }
          if (opts.itemSort) {
            tooltipItems = tooltipItems.sort(function (a, b) {
              return opts.itemSort(a, b, data);
            });
          }
          helpers$1.each(tooltipItems, function (tooltipItem) {
            labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
            labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
          });
          model.title = me.getTitle(tooltipItems, data);
          model.beforeBody = me.getBeforeBody(tooltipItems, data);
          model.body = me.getBody(tooltipItems, data);
          model.afterBody = me.getAfterBody(tooltipItems, data);
          model.footer = me.getFooter(tooltipItems, data);
          model.x = tooltipPosition.x;
          model.y = tooltipPosition.y;
          model.caretPadding = opts.caretPadding;
          model.labelColors = labelColors;
          model.labelTextColors = labelTextColors;
          model.dataPoints = tooltipItems;
          tooltipSize = getTooltipSize(this, model);
          alignment = determineAlignment(this, tooltipSize);
          backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
        } else {
          model.opacity = 0;
        }
        model.xAlign = alignment.xAlign;
        model.yAlign = alignment.yAlign;
        model.x = backgroundPoint.x;
        model.y = backgroundPoint.y;
        model.width = tooltipSize.width;
        model.height = tooltipSize.height;
        model.caretX = tooltipPosition.x;
        model.caretY = tooltipPosition.y;
        me._model = model;
        if (changed && opts.custom) {
          opts.custom.call(me, model);
        }
        return me;
      },
      drawCaret: function drawCaret(tooltipPoint, size) {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
      },
      getCaretPosition: function getCaretPosition(tooltipPoint, size, vm) {
        var x1, x2, x3, y1, y2, y3;
        var caretSize = vm.caretSize;
        var cornerRadius = vm.cornerRadius;
        var xAlign = vm.xAlign;
        var yAlign = vm.yAlign;
        var ptX = tooltipPoint.x;
        var ptY = tooltipPoint.y;
        var width = size.width;
        var height = size.height;
        if (yAlign === 'center') {
          y2 = ptY + height / 2;
          if (xAlign === 'left') {
            x1 = ptX;
            x2 = x1 - caretSize;
            x3 = x1;
            y1 = y2 + caretSize;
            y3 = y2 - caretSize;
          } else {
            x1 = ptX + width;
            x2 = x1 + caretSize;
            x3 = x1;
            y1 = y2 - caretSize;
            y3 = y2 + caretSize;
          }
        } else {
          if (xAlign === 'left') {
            x2 = ptX + cornerRadius + caretSize;
            x1 = x2 - caretSize;
            x3 = x2 + caretSize;
          } else if (xAlign === 'right') {
            x2 = ptX + width - cornerRadius - caretSize;
            x1 = x2 - caretSize;
            x3 = x2 + caretSize;
          } else {
            x2 = vm.caretX;
            x1 = x2 - caretSize;
            x3 = x2 + caretSize;
          }
          if (yAlign === 'top') {
            y1 = ptY;
            y2 = y1 - caretSize;
            y3 = y1;
          } else {
            y1 = ptY + height;
            y2 = y1 + caretSize;
            y3 = y1;
            var tmp = x3;
            x3 = x1;
            x1 = tmp;
          }
        }
        return {
          x1: x1,
          x2: x2,
          x3: x3,
          y1: y1,
          y2: y2,
          y3: y3
        };
      },
      drawTitle: function drawTitle(pt, vm, ctx) {
        var title = vm.title;
        var length = title.length;
        var titleFontSize, titleSpacing, i;
        if (length) {
          var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
          pt.x = getAlignedX(vm, vm._titleAlign);
          ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
          ctx.textBaseline = 'middle';
          titleFontSize = vm.titleFontSize;
          titleSpacing = vm.titleSpacing;
          ctx.fillStyle = vm.titleFontColor;
          ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
          for (i = 0; i < length; ++i) {
            ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
            pt.y += titleFontSize + titleSpacing;
            if (i + 1 === length) {
              pt.y += vm.titleMarginBottom - titleSpacing;
            }
          }
        }
      },
      drawBody: function drawBody(pt, vm, ctx) {
        var bodyFontSize = vm.bodyFontSize;
        var bodySpacing = vm.bodySpacing;
        var bodyAlign = vm._bodyAlign;
        var body = vm.body;
        var drawColorBoxes = vm.displayColors;
        var xLinePadding = 0;
        var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
        var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
        var fillLineOfText = function fillLineOfText(line) {
          ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
          pt.y += bodyFontSize + bodySpacing;
        };
        var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
        var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
        pt.x = getAlignedX(vm, bodyAlignForCalculation);
        ctx.fillStyle = vm.bodyFontColor;
        helpers$1.each(vm.beforeBody, fillLineOfText);
        xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? bodyFontSize / 2 + 1 : bodyFontSize + 2 : 0;
        for (i = 0, ilen = body.length; i < ilen; ++i) {
          bodyItem = body[i];
          textColor = vm.labelTextColors[i];
          labelColors = vm.labelColors[i];
          ctx.fillStyle = textColor;
          helpers$1.each(bodyItem.before, fillLineOfText);
          lines = bodyItem.lines;
          for (j = 0, jlen = lines.length; j < jlen; ++j) {
            if (drawColorBoxes) {
              var rtlColorX = rtlHelper.x(colorX);
              ctx.fillStyle = vm.legendColorBackground;
              ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
              ctx.lineWidth = 1;
              ctx.strokeStyle = labelColors.borderColor;
              ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
              ctx.fillStyle = labelColors.backgroundColor;
              ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
              ctx.fillStyle = textColor;
            }
            fillLineOfText(lines[j]);
          }
          helpers$1.each(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        helpers$1.each(vm.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
      },
      drawFooter: function drawFooter(pt, vm, ctx) {
        var footer = vm.footer;
        var length = footer.length;
        var footerFontSize, i;
        if (length) {
          var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
          pt.x = getAlignedX(vm, vm._footerAlign);
          pt.y += vm.footerMarginTop;
          ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
          ctx.textBaseline = 'middle';
          footerFontSize = vm.footerFontSize;
          ctx.fillStyle = vm.footerFontColor;
          ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
          for (i = 0; i < length; ++i) {
            ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
            pt.y += footerFontSize + vm.footerSpacing;
          }
        }
      },
      drawBackground: function drawBackground(pt, vm, ctx, tooltipSize) {
        ctx.fillStyle = vm.backgroundColor;
        ctx.strokeStyle = vm.borderColor;
        ctx.lineWidth = vm.borderWidth;
        var xAlign = vm.xAlign;
        var yAlign = vm.yAlign;
        var x = pt.x;
        var y = pt.y;
        var width = tooltipSize.width;
        var height = tooltipSize.height;
        var radius = vm.cornerRadius;
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        if (yAlign === 'top') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        if (yAlign === 'center' && xAlign === 'right') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        if (yAlign === 'bottom') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        if (yAlign === 'center' && xAlign === 'left') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
        ctx.fill();
        if (vm.borderWidth > 0) {
          ctx.stroke();
        }
      },
      draw: function draw() {
        var ctx = this._chart.ctx;
        var vm = this._view;
        if (vm.opacity === 0) {
          return;
        }
        var tooltipSize = {
          width: vm.width,
          height: vm.height
        };
        var pt = {
          x: vm.x,
          y: vm.y
        };
        var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
        var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
        if (this._options.enabled && hasTooltipContent) {
          ctx.save();
          ctx.globalAlpha = opacity;
          this.drawBackground(pt, vm, ctx, tooltipSize);
          pt.y += vm.yPadding;
          helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
          this.drawTitle(pt, vm, ctx);
          this.drawBody(pt, vm, ctx);
          this.drawFooter(pt, vm, ctx);
          helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
          ctx.restore();
        }
      },
      handleEvent: function handleEvent(e) {
        var me = this;
        var options = me._options;
        var changed = false;
        me._lastActive = me._lastActive || [];
        if (e.type === 'mouseout') {
          me._active = [];
        } else {
          me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
          if (options.reverse) {
            me._active.reverse();
          }
        }
        changed = !helpers$1.arrayEquals(me._active, me._lastActive);
        if (changed) {
          me._lastActive = me._active;
          if (options.enabled || options.custom) {
            me._eventPosition = {
              x: e.x,
              y: e.y
            };
            me.update(true);
            me.pivot();
          }
        }
        return changed;
      }
    });
    var positioners_1 = positioners;
    var core_tooltip = exports$4;
    core_tooltip.positioners = positioners_1;
    var valueOrDefault$9 = helpers$1.valueOrDefault;
    core_defaults._set('global', {
      elements: {},
      events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
      hover: {
        onHover: null,
        mode: 'nearest',
        intersect: true,
        animationDuration: 400
      },
      onClick: null,
      maintainAspectRatio: true,
      responsive: true,
      responsiveAnimationDuration: 0
    });
    function mergeScaleConfig() {
      return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
        merger: function merger(key, target, source, options) {
          if (key === 'xAxes' || key === 'yAxes') {
            var slen = source[key].length;
            var i, type, scale;
            if (!target[key]) {
              target[key] = [];
            }
            for (i = 0; i < slen; ++i) {
              scale = source[key][i];
              type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
              if (i >= target[key].length) {
                target[key].push({});
              }
              if (!target[key][i].type || scale.type && scale.type !== target[key][i].type) {
                helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
              } else {
                helpers$1.merge(target[key][i], scale);
              }
            }
          } else {
            helpers$1._merger(key, target, source, options);
          }
        }
      });
    }
    function mergeConfig() {
      return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
        merger: function merger(key, target, source, options) {
          var tval = target[key] || Object.create(null);
          var sval = source[key];
          if (key === 'scales') {
            target[key] = mergeScaleConfig(tval, sval);
          } else if (key === 'scale') {
            target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
          } else {
            helpers$1._merger(key, target, source, options);
          }
        }
      });
    }
    function initConfig(config) {
      config = config || Object.create(null);
      var data = config.data = config.data || {};
      data.datasets = data.datasets || [];
      data.labels = data.labels || [];
      config.options = mergeConfig(core_defaults.global, core_defaults[config.type], config.options || {});
      return config;
    }
    function updateConfig(chart) {
      var newOptions = chart.options;
      helpers$1.each(chart.scales, function (scale) {
        core_layouts.removeBox(chart, scale);
      });
      newOptions = mergeConfig(core_defaults.global, core_defaults[chart.config.type], newOptions);
      chart.options = chart.config.options = newOptions;
      chart.ensureScalesHaveIDs();
      chart.buildOrUpdateScales();
      chart.tooltip._options = newOptions.tooltips;
      chart.tooltip.initialize();
    }
    function nextAvailableScaleId(axesOpts, prefix, index) {
      var id;
      var hasId = function hasId(obj) {
        return obj.id === id;
      };
      do {
        id = prefix + index++;
      } while (helpers$1.findIndex(axesOpts, hasId) >= 0);
      return id;
    }
    function positionIsHorizontal(position) {
      return position === 'top' || position === 'bottom';
    }
    function compare2Level(l1, l2) {
      return function (a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
      };
    }
    var Chart = function Chart(item, config) {
      this.construct(item, config);
      return this;
    };
    helpers$1.extend(Chart.prototype, {
      construct: function construct(item, config) {
        var me = this;
        config = initConfig(config);
        var context = platform.acquireContext(item, config);
        var canvas = context && context.canvas;
        var height = canvas && canvas.height;
        var width = canvas && canvas.width;
        me.id = helpers$1.uid();
        me.ctx = context;
        me.canvas = canvas;
        me.config = config;
        me.width = width;
        me.height = height;
        me.aspectRatio = height ? width / height : null;
        me.options = config.options;
        me._bufferedRender = false;
        me._layers = [];
        me.chart = me;
        me.controller = me;
        Chart.instances[me.id] = me;
        Object.defineProperty(me, 'data', {
          get: function get() {
            return me.config.data;
          },
          set: function set(value) {
            me.config.data = value;
          }
        });
        if (!context || !canvas) {
          console.error("Failed to create chart: can't acquire context from the given item");
          return;
        }
        me.initialize();
        me.update();
      },
      initialize: function initialize() {
        var me = this;
        core_plugins.notify(me, 'beforeInit');
        helpers$1.retinaScale(me, me.options.devicePixelRatio);
        me.bindEvents();
        if (me.options.responsive) {
          me.resize(true);
        }
        me.initToolTip();
        core_plugins.notify(me, 'afterInit');
        return me;
      },
      clear: function clear() {
        helpers$1.canvas.clear(this);
        return this;
      },
      stop: function stop() {
        core_animations.cancelAnimation(this);
        return this;
      },
      resize: function resize(silent) {
        var me = this;
        var options = me.options;
        var canvas = me.canvas;
        var aspectRatio = options.maintainAspectRatio && me.aspectRatio || null;
        var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
        var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
        if (me.width === newWidth && me.height === newHeight) {
          return;
        }
        canvas.width = me.width = newWidth;
        canvas.height = me.height = newHeight;
        canvas.style.width = newWidth + 'px';
        canvas.style.height = newHeight + 'px';
        helpers$1.retinaScale(me, options.devicePixelRatio);
        if (!silent) {
          var newSize = {
            width: newWidth,
            height: newHeight
          };
          core_plugins.notify(me, 'resize', [newSize]);
          if (options.onResize) {
            options.onResize(me, newSize);
          }
          me.stop();
          me.update({
            duration: options.responsiveAnimationDuration
          });
        }
      },
      ensureScalesHaveIDs: function ensureScalesHaveIDs() {
        var options = this.options;
        var scalesOptions = options.scales || {};
        var scaleOptions = options.scale;
        helpers$1.each(scalesOptions.xAxes, function (xAxisOptions, index) {
          if (!xAxisOptions.id) {
            xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
          }
        });
        helpers$1.each(scalesOptions.yAxes, function (yAxisOptions, index) {
          if (!yAxisOptions.id) {
            yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
          }
        });
        if (scaleOptions) {
          scaleOptions.id = scaleOptions.id || 'scale';
        }
      },
      buildOrUpdateScales: function buildOrUpdateScales() {
        var me = this;
        var options = me.options;
        var scales = me.scales || {};
        var items = [];
        var updated = Object.keys(scales).reduce(function (obj, id) {
          obj[id] = false;
          return obj;
        }, {});
        if (options.scales) {
          items = items.concat((options.scales.xAxes || []).map(function (xAxisOptions) {
            return {
              options: xAxisOptions,
              dtype: 'category',
              dposition: 'bottom'
            };
          }), (options.scales.yAxes || []).map(function (yAxisOptions) {
            return {
              options: yAxisOptions,
              dtype: 'linear',
              dposition: 'left'
            };
          }));
        }
        if (options.scale) {
          items.push({
            options: options.scale,
            dtype: 'radialLinear',
            isDefault: true,
            dposition: 'chartArea'
          });
        }
        helpers$1.each(items, function (item) {
          var scaleOptions = item.options;
          var id = scaleOptions.id;
          var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
          if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
            scaleOptions.position = item.dposition;
          }
          updated[id] = true;
          var scale = null;
          if (id in scales && scales[id].type === scaleType) {
            scale = scales[id];
            scale.options = scaleOptions;
            scale.ctx = me.ctx;
            scale.chart = me;
          } else {
            var scaleClass = core_scaleService.getScaleConstructor(scaleType);
            if (!scaleClass) {
              return;
            }
            scale = new scaleClass({
              id: id,
              type: scaleType,
              options: scaleOptions,
              ctx: me.ctx,
              chart: me
            });
            scales[scale.id] = scale;
          }
          scale.mergeTicksOptions();
          if (item.isDefault) {
            me.scale = scale;
          }
        });
        helpers$1.each(updated, function (hasUpdated, id) {
          if (!hasUpdated) {
            delete scales[id];
          }
        });
        me.scales = scales;
        core_scaleService.addScalesToLayout(this);
      },
      buildOrUpdateControllers: function buildOrUpdateControllers() {
        var me = this;
        var newControllers = [];
        var datasets = me.data.datasets;
        var i, ilen;
        for (i = 0, ilen = datasets.length; i < ilen; i++) {
          var dataset = datasets[i];
          var meta = me.getDatasetMeta(i);
          var type = dataset.type || me.config.type;
          if (meta.type && meta.type !== type) {
            me.destroyDatasetMeta(i);
            meta = me.getDatasetMeta(i);
          }
          meta.type = type;
          meta.order = dataset.order || 0;
          meta.index = i;
          if (meta.controller) {
            meta.controller.updateIndex(i);
            meta.controller.linkScales();
          } else {
            var ControllerClass = controllers[meta.type];
            if (ControllerClass === undefined) {
              throw new Error('"' + meta.type + '" is not a chart type.');
            }
            meta.controller = new ControllerClass(me, i);
            newControllers.push(meta.controller);
          }
        }
        return newControllers;
      },
      resetElements: function resetElements() {
        var me = this;
        helpers$1.each(me.data.datasets, function (dataset, datasetIndex) {
          me.getDatasetMeta(datasetIndex).controller.reset();
        }, me);
      },
      reset: function reset() {
        this.resetElements();
        this.tooltip.initialize();
      },
      update: function update(config) {
        var me = this;
        var i, ilen;
        if (!config || typeof config !== 'object') {
          config = {
            duration: config,
            lazy: arguments[1]
          };
        }
        updateConfig(me);
        core_plugins._invalidate(me);
        if (core_plugins.notify(me, 'beforeUpdate') === false) {
          return;
        }
        me.tooltip._data = me.data;
        var newControllers = me.buildOrUpdateControllers();
        for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
          me.getDatasetMeta(i).controller.buildOrUpdateElements();
        }
        me.updateLayout();
        if (me.options.animation && me.options.animation.duration) {
          helpers$1.each(newControllers, function (controller) {
            controller.reset();
          });
        }
        me.updateDatasets();
        me.tooltip.initialize();
        me.lastActive = [];
        core_plugins.notify(me, 'afterUpdate');
        me._layers.sort(compare2Level('z', '_idx'));
        if (me._bufferedRender) {
          me._bufferedRequest = {
            duration: config.duration,
            easing: config.easing,
            lazy: config.lazy
          };
        } else {
          me.render(config);
        }
      },
      updateLayout: function updateLayout() {
        var me = this;
        if (core_plugins.notify(me, 'beforeLayout') === false) {
          return;
        }
        core_layouts.update(this, this.width, this.height);
        me._layers = [];
        helpers$1.each(me.boxes, function (box) {
          if (box._configure) {
            box._configure();
          }
          me._layers.push.apply(me._layers, box._layers());
        }, me);
        me._layers.forEach(function (item, index) {
          item._idx = index;
        });
        core_plugins.notify(me, 'afterScaleUpdate');
        core_plugins.notify(me, 'afterLayout');
      },
      updateDatasets: function updateDatasets() {
        var me = this;
        if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
          return;
        }
        for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
          me.updateDataset(i);
        }
        core_plugins.notify(me, 'afterDatasetsUpdate');
      },
      updateDataset: function updateDataset(index) {
        var me = this;
        var meta = me.getDatasetMeta(index);
        var args = {
          meta: meta,
          index: index
        };
        if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
          return;
        }
        meta.controller._update();
        core_plugins.notify(me, 'afterDatasetUpdate', [args]);
      },
      render: function render(config) {
        var me = this;
        if (!config || typeof config !== 'object') {
          config = {
            duration: config,
            lazy: arguments[1]
          };
        }
        var animationOptions = me.options.animation;
        var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
        var lazy = config.lazy;
        if (core_plugins.notify(me, 'beforeRender') === false) {
          return;
        }
        var onComplete = function onComplete(animation) {
          core_plugins.notify(me, 'afterRender');
          helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
        };
        if (animationOptions && duration) {
          var animation = new core_animation({
            numSteps: duration / 16.66,
            easing: config.easing || animationOptions.easing,
            render: function render(chart, animationObject) {
              var easingFunction = helpers$1.easing.effects[animationObject.easing];
              var currentStep = animationObject.currentStep;
              var stepDecimal = currentStep / animationObject.numSteps;
              chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
            },
            onAnimationProgress: animationOptions.onProgress,
            onAnimationComplete: onComplete
          });
          core_animations.addAnimation(me, animation, duration, lazy);
        } else {
          me.draw();
          onComplete(new core_animation({
            numSteps: 0,
            chart: me
          }));
        }
        return me;
      },
      draw: function draw(easingValue) {
        var me = this;
        var i, layers;
        me.clear();
        if (helpers$1.isNullOrUndef(easingValue)) {
          easingValue = 1;
        }
        me.transition(easingValue);
        if (me.width <= 0 || me.height <= 0) {
          return;
        }
        if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
          return;
        }
        layers = me._layers;
        for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
          layers[i].draw(me.chartArea);
        }
        me.drawDatasets(easingValue);
        for (; i < layers.length; ++i) {
          layers[i].draw(me.chartArea);
        }
        me._drawTooltip(easingValue);
        core_plugins.notify(me, 'afterDraw', [easingValue]);
      },
      transition: function transition(easingValue) {
        var me = this;
        for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
          if (me.isDatasetVisible(i)) {
            me.getDatasetMeta(i).controller.transition(easingValue);
          }
        }
        me.tooltip.transition(easingValue);
      },
      _getSortedDatasetMetas: function _getSortedDatasetMetas(filterVisible) {
        var me = this;
        var datasets = me.data.datasets || [];
        var result = [];
        var i, ilen;
        for (i = 0, ilen = datasets.length; i < ilen; ++i) {
          if (!filterVisible || me.isDatasetVisible(i)) {
            result.push(me.getDatasetMeta(i));
          }
        }
        result.sort(compare2Level('order', 'index'));
        return result;
      },
      _getSortedVisibleDatasetMetas: function _getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
      },
      drawDatasets: function drawDatasets(easingValue) {
        var me = this;
        var metasets, i;
        if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
          return;
        }
        metasets = me._getSortedVisibleDatasetMetas();
        for (i = metasets.length - 1; i >= 0; --i) {
          me.drawDataset(metasets[i], easingValue);
        }
        core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
      },
      drawDataset: function drawDataset(meta, easingValue) {
        var me = this;
        var args = {
          meta: meta,
          index: meta.index,
          easingValue: easingValue
        };
        if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
          return;
        }
        meta.controller.draw(easingValue);
        core_plugins.notify(me, 'afterDatasetDraw', [args]);
      },
      _drawTooltip: function _drawTooltip(easingValue) {
        var me = this;
        var tooltip = me.tooltip;
        var args = {
          tooltip: tooltip,
          easingValue: easingValue
        };
        if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
          return;
        }
        tooltip.draw();
        core_plugins.notify(me, 'afterTooltipDraw', [args]);
      },
      getElementAtEvent: function getElementAtEvent(e) {
        return core_interaction.modes.single(this, e);
      },
      getElementsAtEvent: function getElementsAtEvent(e) {
        return core_interaction.modes.label(this, e, {
          intersect: true
        });
      },
      getElementsAtXAxis: function getElementsAtXAxis(e) {
        return core_interaction.modes['x-axis'](this, e, {
          intersect: true
        });
      },
      getElementsAtEventForMode: function getElementsAtEventForMode(e, mode, options) {
        var method = core_interaction.modes[mode];
        if (typeof method === 'function') {
          return method(this, e, options);
        }
        return [];
      },
      getDatasetAtEvent: function getDatasetAtEvent(e) {
        return core_interaction.modes.dataset(this, e, {
          intersect: true
        });
      },
      getDatasetMeta: function getDatasetMeta(datasetIndex) {
        var me = this;
        var dataset = me.data.datasets[datasetIndex];
        if (!dataset._meta) {
          dataset._meta = {};
        }
        var meta = dataset._meta[me.id];
        if (!meta) {
          meta = dataset._meta[me.id] = {
            type: null,
            data: [],
            dataset: null,
            controller: null,
            hidden: null,
            xAxisID: null,
            yAxisID: null,
            order: dataset.order || 0,
            index: datasetIndex
          };
        }
        return meta;
      },
      getVisibleDatasetCount: function getVisibleDatasetCount() {
        var count = 0;
        for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
          if (this.isDatasetVisible(i)) {
            count++;
          }
        }
        return count;
      },
      isDatasetVisible: function isDatasetVisible(datasetIndex) {
        var meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
      },
      generateLegend: function generateLegend() {
        return this.options.legendCallback(this);
      },
      destroyDatasetMeta: function destroyDatasetMeta(datasetIndex) {
        var id = this.id;
        var dataset = this.data.datasets[datasetIndex];
        var meta = dataset._meta && dataset._meta[id];
        if (meta) {
          meta.controller.destroy();
          delete dataset._meta[id];
        }
      },
      destroy: function destroy() {
        var me = this;
        var canvas = me.canvas;
        var i, ilen;
        me.stop();
        for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
          me.destroyDatasetMeta(i);
        }
        if (canvas) {
          me.unbindEvents();
          helpers$1.canvas.clear(me);
          platform.releaseContext(me.ctx);
          me.canvas = null;
          me.ctx = null;
        }
        core_plugins.notify(me, 'destroy');
        delete Chart.instances[me.id];
      },
      toBase64Image: function toBase64Image() {
        return this.canvas.toDataURL.apply(this.canvas, arguments);
      },
      initToolTip: function initToolTip() {
        var me = this;
        me.tooltip = new core_tooltip({
          _chart: me,
          _chartInstance: me,
          _data: me.data,
          _options: me.options.tooltips
        }, me);
      },
      bindEvents: function bindEvents() {
        var me = this;
        var listeners = me._listeners = {};
        var listener = function listener() {
          me.eventHandler.apply(me, arguments);
        };
        helpers$1.each(me.options.events, function (type) {
          platform.addEventListener(me, type, listener);
          listeners[type] = listener;
        });
        if (me.options.responsive) {
          listener = function listener() {
            me.resize();
          };
          platform.addEventListener(me, 'resize', listener);
          listeners.resize = listener;
        }
      },
      unbindEvents: function unbindEvents() {
        var me = this;
        var listeners = me._listeners;
        if (!listeners) {
          return;
        }
        delete me._listeners;
        helpers$1.each(listeners, function (listener, type) {
          platform.removeEventListener(me, type, listener);
        });
      },
      updateHoverStyle: function updateHoverStyle(elements, mode, enabled) {
        var prefix = enabled ? 'set' : 'remove';
        var element, i, ilen;
        for (i = 0, ilen = elements.length; i < ilen; ++i) {
          element = elements[i];
          if (element) {
            this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
          }
        }
        if (mode === 'dataset') {
          this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
        }
      },
      eventHandler: function eventHandler(e) {
        var me = this;
        var tooltip = me.tooltip;
        if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
          return;
        }
        me._bufferedRender = true;
        me._bufferedRequest = null;
        var changed = me.handleEvent(e);
        if (tooltip) {
          changed = tooltip._start ? tooltip.handleEvent(e) : changed | tooltip.handleEvent(e);
        }
        core_plugins.notify(me, 'afterEvent', [e]);
        var bufferedRequest = me._bufferedRequest;
        if (bufferedRequest) {
          me.render(bufferedRequest);
        } else if (changed && !me.animating) {
          me.stop();
          me.render({
            duration: me.options.hover.animationDuration,
            lazy: true
          });
        }
        me._bufferedRender = false;
        me._bufferedRequest = null;
        return me;
      },
      handleEvent: function handleEvent(e) {
        var me = this;
        var options = me.options || {};
        var hoverOptions = options.hover;
        var changed = false;
        me.lastActive = me.lastActive || [];
        if (e.type === 'mouseout') {
          me.active = [];
        } else {
          me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
        }
        helpers$1.callback(options.onHover || options.hover.onHover, [e["native"], me.active], me);
        if (e.type === 'mouseup' || e.type === 'click') {
          if (options.onClick) {
            options.onClick.call(me, e["native"], me.active);
          }
        }
        if (me.lastActive.length) {
          me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
        }
        if (me.active.length && hoverOptions.mode) {
          me.updateHoverStyle(me.active, hoverOptions.mode, true);
        }
        changed = !helpers$1.arrayEquals(me.active, me.lastActive);
        me.lastActive = me.active;
        return changed;
      }
    });
    Chart.instances = {};
    var core_controller = Chart;
    Chart.Controller = Chart;
    Chart.types = {};
    helpers$1.configMerge = mergeConfig;
    helpers$1.scaleMerge = mergeScaleConfig;
    var core_helpers = function core_helpers() {
      helpers$1.where = function (collection, filterCallback) {
        if (helpers$1.isArray(collection) && Array.prototype.filter) {
          return collection.filter(filterCallback);
        }
        var filtered = [];
        helpers$1.each(collection, function (item) {
          if (filterCallback(item)) {
            filtered.push(item);
          }
        });
        return filtered;
      };
      helpers$1.findIndex = Array.prototype.findIndex ? function (array, callback, scope) {
        return array.findIndex(callback, scope);
      } : function (array, callback, scope) {
        scope = scope === undefined ? array : scope;
        for (var i = 0, ilen = array.length; i < ilen; ++i) {
          if (callback.call(scope, array[i], i, array)) {
            return i;
          }
        }
        return -1;
      };
      helpers$1.findNextWhere = function (arrayToSearch, filterCallback, startIndex) {
        if (helpers$1.isNullOrUndef(startIndex)) {
          startIndex = -1;
        }
        for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
          var currentItem = arrayToSearch[i];
          if (filterCallback(currentItem)) {
            return currentItem;
          }
        }
      };
      helpers$1.findPreviousWhere = function (arrayToSearch, filterCallback, startIndex) {
        if (helpers$1.isNullOrUndef(startIndex)) {
          startIndex = arrayToSearch.length;
        }
        for (var i = startIndex - 1; i >= 0; i--) {
          var currentItem = arrayToSearch[i];
          if (filterCallback(currentItem)) {
            return currentItem;
          }
        }
      };
      helpers$1.isNumber = function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
      };
      helpers$1.almostEquals = function (x, y, epsilon) {
        return Math.abs(x - y) < epsilon;
      };
      helpers$1.almostWhole = function (x, epsilon) {
        var rounded = Math.round(x);
        return rounded - epsilon <= x && rounded + epsilon >= x;
      };
      helpers$1.max = function (array) {
        return array.reduce(function (max, value) {
          if (!isNaN(value)) {
            return Math.max(max, value);
          }
          return max;
        }, Number.NEGATIVE_INFINITY);
      };
      helpers$1.min = function (array) {
        return array.reduce(function (min, value) {
          if (!isNaN(value)) {
            return Math.min(min, value);
          }
          return min;
        }, Number.POSITIVE_INFINITY);
      };
      helpers$1.sign = Math.sign ? function (x) {
        return Math.sign(x);
      } : function (x) {
        x = +x;
        if (x === 0 || isNaN(x)) {
          return x;
        }
        return x > 0 ? 1 : -1;
      };
      helpers$1.toRadians = function (degrees) {
        return degrees * (Math.PI / 180);
      };
      helpers$1.toDegrees = function (radians) {
        return radians * (180 / Math.PI);
      };
      helpers$1._decimalPlaces = function (x) {
        if (!helpers$1.isFinite(x)) {
          return;
        }
        var e = 1;
        var p = 0;
        while (Math.round(x * e) / e !== x) {
          e *= 10;
          p++;
        }
        return p;
      };
      helpers$1.getAngleFromPoint = function (centrePoint, anglePoint) {
        var distanceFromXCenter = anglePoint.x - centrePoint.x;
        var distanceFromYCenter = anglePoint.y - centrePoint.y;
        var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
        var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
        if (angle < -0.5 * Math.PI) {
          angle += 2.0 * Math.PI;
        }
        return {
          angle: angle,
          distance: radialDistanceFromCenter
        };
      };
      helpers$1.distanceBetweenPoints = function (pt1, pt2) {
        return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
      };
      helpers$1.aliasPixel = function (pixelWidth) {
        return pixelWidth % 2 === 0 ? 0 : 0.5;
      };
      helpers$1._alignPixel = function (chart, pixel, width) {
        var devicePixelRatio = chart.currentDevicePixelRatio;
        var halfWidth = width / 2;
        return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
      };
      helpers$1.splineCurve = function (firstPoint, middlePoint, afterPoint, t) {
        var previous = firstPoint.skip ? middlePoint : firstPoint;
        var current = middlePoint;
        var next = afterPoint.skip ? middlePoint : afterPoint;
        var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
        var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
        var s01 = d01 / (d01 + d12);
        var s12 = d12 / (d01 + d12);
        s01 = isNaN(s01) ? 0 : s01;
        s12 = isNaN(s12) ? 0 : s12;
        var fa = t * s01;
        var fb = t * s12;
        return {
          previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
          },
          next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
          }
        };
      };
      helpers$1.EPSILON = Number.EPSILON || 1e-14;
      helpers$1.splineCurveMonotone = function (points) {
        var pointsWithTangents = (points || []).map(function (point) {
          return {
            model: point._model,
            deltaK: 0,
            mK: 0
          };
        });
        var pointsLen = pointsWithTangents.length;
        var i, pointBefore, pointCurrent, pointAfter;
        for (i = 0; i < pointsLen; ++i) {
          pointCurrent = pointsWithTangents[i];
          if (pointCurrent.model.skip) {
            continue;
          }
          pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
          pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
          if (pointAfter && !pointAfter.model.skip) {
            var slopeDeltaX = pointAfter.model.x - pointCurrent.model.x;
            pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
          }
          if (!pointBefore || pointBefore.model.skip) {
            pointCurrent.mK = pointCurrent.deltaK;
          } else if (!pointAfter || pointAfter.model.skip) {
            pointCurrent.mK = pointBefore.deltaK;
          } else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
            pointCurrent.mK = 0;
          } else {
            pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
          }
        }
        var alphaK, betaK, tauK, squaredMagnitude;
        for (i = 0; i < pointsLen - 1; ++i) {
          pointCurrent = pointsWithTangents[i];
          pointAfter = pointsWithTangents[i + 1];
          if (pointCurrent.model.skip || pointAfter.model.skip) {
            continue;
          }
          if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
            pointCurrent.mK = pointAfter.mK = 0;
            continue;
          }
          alphaK = pointCurrent.mK / pointCurrent.deltaK;
          betaK = pointAfter.mK / pointCurrent.deltaK;
          squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
          if (squaredMagnitude <= 9) {
            continue;
          }
          tauK = 3 / Math.sqrt(squaredMagnitude);
          pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
          pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
        }
        var deltaX;
        for (i = 0; i < pointsLen; ++i) {
          pointCurrent = pointsWithTangents[i];
          if (pointCurrent.model.skip) {
            continue;
          }
          pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
          pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
          if (pointBefore && !pointBefore.model.skip) {
            deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
            pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
            pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
          }
          if (pointAfter && !pointAfter.model.skip) {
            deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
            pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
            pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
          }
        }
      };
      helpers$1.nextItem = function (collection, index, loop) {
        if (loop) {
          return index >= collection.length - 1 ? collection[0] : collection[index + 1];
        }
        return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
      };
      helpers$1.previousItem = function (collection, index, loop) {
        if (loop) {
          return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
        }
        return index <= 0 ? collection[0] : collection[index - 1];
      };
      helpers$1.niceNum = function (range, round) {
        var exponent = Math.floor(helpers$1.log10(range));
        var fraction = range / Math.pow(10, exponent);
        var niceFraction;
        if (round) {
          if (fraction < 1.5) {
            niceFraction = 1;
          } else if (fraction < 3) {
            niceFraction = 2;
          } else if (fraction < 7) {
            niceFraction = 5;
          } else {
            niceFraction = 10;
          }
        } else if (fraction <= 1.0) {
          niceFraction = 1;
        } else if (fraction <= 2) {
          niceFraction = 2;
        } else if (fraction <= 5) {
          niceFraction = 5;
        } else {
          niceFraction = 10;
        }
        return niceFraction * Math.pow(10, exponent);
      };
      helpers$1.requestAnimFrame = function () {
        if (typeof window === 'undefined') {
          return function (callback) {
            callback();
          };
        }
        return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
          return window.setTimeout(callback, 1000 / 60);
        };
      }();
      helpers$1.getRelativePosition = function (evt, chart) {
        var mouseX, mouseY;
        var e = evt.originalEvent || evt;
        var canvas = evt.target || evt.srcElement;
        var boundingRect = canvas.getBoundingClientRect();
        var touches = e.touches;
        if (touches && touches.length > 0) {
          mouseX = touches[0].clientX;
          mouseY = touches[0].clientY;
        } else {
          mouseX = e.clientX;
          mouseY = e.clientY;
        }
        var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
        var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
        var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
        var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
        var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
        var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
        mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / width * canvas.width / chart.currentDevicePixelRatio);
        mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / height * canvas.height / chart.currentDevicePixelRatio);
        return {
          x: mouseX,
          y: mouseY
        };
      };
      function parseMaxStyle(styleValue, node, parentProperty) {
        var valueInPixels;
        if (typeof styleValue === 'string') {
          valueInPixels = parseInt(styleValue, 10);
          if (styleValue.indexOf('%') !== -1) {
            valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
          }
        } else {
          valueInPixels = styleValue;
        }
        return valueInPixels;
      }
      function isConstrainedValue(value) {
        return value !== undefined && value !== null && value !== 'none';
      }
      function getConstraintDimension(domNode, maxStyle, percentageProperty) {
        var view = document.defaultView;
        var parentNode = helpers$1._getParentNode(domNode);
        var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
        var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
        var hasCNode = isConstrainedValue(constrainedNode);
        var hasCContainer = isConstrainedValue(constrainedContainer);
        var infinity = Number.POSITIVE_INFINITY;
        if (hasCNode || hasCContainer) {
          return Math.min(hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity, hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
        }
        return 'none';
      }
      helpers$1.getConstraintWidth = function (domNode) {
        return getConstraintDimension(domNode, 'max-width', 'clientWidth');
      };
      helpers$1.getConstraintHeight = function (domNode) {
        return getConstraintDimension(domNode, 'max-height', 'clientHeight');
      };
      helpers$1._calculatePadding = function (container, padding, parentDimension) {
        padding = helpers$1.getStyle(container, padding);
        return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
      };
      helpers$1._getParentNode = function (domNode) {
        var parent = domNode.parentNode;
        if (parent && parent.toString() === '[object ShadowRoot]') {
          parent = parent.host;
        }
        return parent;
      };
      helpers$1.getMaximumWidth = function (domNode) {
        var container = helpers$1._getParentNode(domNode);
        if (!container) {
          return domNode.clientWidth;
        }
        var clientWidth = container.clientWidth;
        var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
        var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
        var w = clientWidth - paddingLeft - paddingRight;
        var cw = helpers$1.getConstraintWidth(domNode);
        return isNaN(cw) ? w : Math.min(w, cw);
      };
      helpers$1.getMaximumHeight = function (domNode) {
        var container = helpers$1._getParentNode(domNode);
        if (!container) {
          return domNode.clientHeight;
        }
        var clientHeight = container.clientHeight;
        var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
        var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
        var h = clientHeight - paddingTop - paddingBottom;
        var ch = helpers$1.getConstraintHeight(domNode);
        return isNaN(ch) ? h : Math.min(h, ch);
      };
      helpers$1.getStyle = function (el, property) {
        return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
      };
      helpers$1.retinaScale = function (chart, forceRatio) {
        var pixelRatio = chart.currentDevicePixelRatio = forceRatio || typeof window !== 'undefined' && window.devicePixelRatio || 1;
        if (pixelRatio === 1) {
          return;
        }
        var canvas = chart.canvas;
        var height = chart.height;
        var width = chart.width;
        canvas.height = height * pixelRatio;
        canvas.width = width * pixelRatio;
        chart.ctx.scale(pixelRatio, pixelRatio);
        if (!canvas.style.height && !canvas.style.width) {
          canvas.style.height = height + 'px';
          canvas.style.width = width + 'px';
        }
      };
      helpers$1.fontString = function (pixelSize, fontStyle, fontFamily) {
        return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
      };
      helpers$1.longestText = function (ctx, font, arrayOfThings, cache) {
        cache = cache || {};
        var data = cache.data = cache.data || {};
        var gc = cache.garbageCollect = cache.garbageCollect || [];
        if (cache.font !== font) {
          data = cache.data = {};
          gc = cache.garbageCollect = [];
          cache.font = font;
        }
        ctx.font = font;
        var longest = 0;
        var ilen = arrayOfThings.length;
        var i, j, jlen, thing, nestedThing;
        for (i = 0; i < ilen; i++) {
          thing = arrayOfThings[i];
          if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
            longest = helpers$1.measureText(ctx, data, gc, longest, thing);
          } else if (helpers$1.isArray(thing)) {
            for (j = 0, jlen = thing.length; j < jlen; j++) {
              nestedThing = thing[j];
              if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
                longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
              }
            }
          }
        }
        var gcLen = gc.length / 2;
        if (gcLen > arrayOfThings.length) {
          for (i = 0; i < gcLen; i++) {
            delete data[gc[i]];
          }
          gc.splice(0, gcLen);
        }
        return longest;
      };
      helpers$1.measureText = function (ctx, data, gc, longest, string) {
        var textWidth = data[string];
        if (!textWidth) {
          textWidth = data[string] = ctx.measureText(string).width;
          gc.push(string);
        }
        if (textWidth > longest) {
          longest = textWidth;
        }
        return longest;
      };
      helpers$1.numberOfLabelLines = function (arrayOfThings) {
        var numberOfLines = 1;
        helpers$1.each(arrayOfThings, function (thing) {
          if (helpers$1.isArray(thing)) {
            if (thing.length > numberOfLines) {
              numberOfLines = thing.length;
            }
          }
        });
        return numberOfLines;
      };
      helpers$1.color = !chartjsColor ? function (value) {
        console.error('Color.js not found!');
        return value;
      } : function (value) {
        if (value instanceof CanvasGradient) {
          value = core_defaults.global.defaultColor;
        }
        return chartjsColor(value);
      };
      helpers$1.getHoverColor = function (colorValue) {
        return colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient ? colorValue : helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
      };
    };
    function _abstract() {
      throw new Error('This method is not implemented: either no adapter can ' + 'be found or an incomplete integration was provided.');
    }
    function DateAdapter(options) {
      this.options = options || {};
    }
    helpers$1.extend(DateAdapter.prototype, {
      formats: _abstract,
      parse: _abstract,
      format: _abstract,
      add: _abstract,
      diff: _abstract,
      startOf: _abstract,
      endOf: _abstract,
      _create: function _create(value) {
        return value;
      }
    });
    DateAdapter.override = function (members) {
      helpers$1.extend(DateAdapter.prototype, members);
    };
    var _date = DateAdapter;
    var core_adapters = {
      _date: _date
    };
    var core_ticks = {
      formatters: {
        values: function values(value) {
          return helpers$1.isArray(value) ? value : '' + value;
        },
        linear: function linear(tickValue, index, ticks) {
          var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
          if (Math.abs(delta) > 1) {
            if (tickValue !== Math.floor(tickValue)) {
              delta = tickValue - Math.floor(tickValue);
            }
          }
          var logDelta = helpers$1.log10(Math.abs(delta));
          var tickString = '';
          if (tickValue !== 0) {
            var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
            if (maxTick < 1e-4) {
              var logTick = helpers$1.log10(Math.abs(tickValue));
              var numExponential = Math.floor(logTick) - Math.floor(logDelta);
              numExponential = Math.max(Math.min(numExponential, 20), 0);
              tickString = tickValue.toExponential(numExponential);
            } else {
              var numDecimal = -1 * Math.floor(logDelta);
              numDecimal = Math.max(Math.min(numDecimal, 20), 0);
              tickString = tickValue.toFixed(numDecimal);
            }
          } else {
            tickString = '0';
          }
          return tickString;
        },
        logarithmic: function logarithmic(tickValue, index, ticks) {
          var remain = tickValue / Math.pow(10, Math.floor(helpers$1.log10(tickValue)));
          if (tickValue === 0) {
            return '0';
          } else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
            return tickValue.toExponential();
          }
          return '';
        }
      }
    };
    var isArray = helpers$1.isArray;
    var isNullOrUndef = helpers$1.isNullOrUndef;
    var valueOrDefault$a = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
    core_defaults._set('scale', {
      display: true,
      position: 'left',
      offset: false,
      gridLines: {
        display: true,
        color: 'rgba(0,0,0,0.1)',
        lineWidth: 1,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true,
        tickMarkLength: 10,
        zeroLineWidth: 1,
        zeroLineColor: 'rgba(0,0,0,0.25)',
        zeroLineBorderDash: [],
        zeroLineBorderDashOffset: 0.0,
        offsetGridLines: false,
        borderDash: [],
        borderDashOffset: 0.0
      },
      scaleLabel: {
        display: false,
        labelString: '',
        padding: {
          top: 4,
          bottom: 4
        }
      },
      ticks: {
        beginAtZero: false,
        minRotation: 0,
        maxRotation: 50,
        mirror: false,
        padding: 0,
        reverse: false,
        display: true,
        autoSkip: true,
        autoSkipPadding: 0,
        labelOffset: 0,
        callback: core_ticks.formatters.values,
        minor: {},
        major: {}
      }
    });
    function sample(arr, numItems) {
      var result = [];
      var increment = arr.length / numItems;
      var i = 0;
      var len = arr.length;
      for (; i < len; i += increment) {
        result.push(arr[Math.floor(i)]);
      }
      return result;
    }
    function getPixelForGridLine(scale, index, offsetGridLines) {
      var length = scale.getTicks().length;
      var validIndex = Math.min(index, length - 1);
      var lineValue = scale.getPixelForTick(validIndex);
      var start = scale._startPixel;
      var end = scale._endPixel;
      var epsilon = 1e-6;
      var offset;
      if (offsetGridLines) {
        if (length === 1) {
          offset = Math.max(lineValue - start, end - lineValue);
        } else if (index === 0) {
          offset = (scale.getPixelForTick(1) - lineValue) / 2;
        } else {
          offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        }
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) {
          return;
        }
      }
      return lineValue;
    }
    function garbageCollect(caches, length) {
      helpers$1.each(caches, function (cache) {
        var gc = cache.gc;
        var gcLen = gc.length / 2;
        var i;
        if (gcLen > length) {
          for (i = 0; i < gcLen; ++i) {
            delete cache.data[gc[i]];
          }
          gc.splice(0, gcLen);
        }
      });
    }
    function computeLabelSizes(ctx, tickFonts, ticks, caches) {
      var length = ticks.length;
      var widths = [];
      var heights = [];
      var offsets = [];
      var widestLabelSize = 0;
      var highestLabelSize = 0;
      var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
      for (i = 0; i < length; ++i) {
        label = ticks[i].label;
        tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
        ctx.font = fontString = tickFont.string;
        cache = caches[fontString] = caches[fontString] || {
          data: {},
          gc: []
        };
        lineHeight = tickFont.lineHeight;
        width = height = 0;
        if (!isNullOrUndef(label) && !isArray(label)) {
          width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
          height = lineHeight;
        } else if (isArray(label)) {
          for (j = 0, jlen = label.length; j < jlen; ++j) {
            nestedLabel = label[j];
            if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
              width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
              height += lineHeight;
            }
          }
        }
        widths.push(width);
        heights.push(height);
        offsets.push(lineHeight / 2);
        widestLabelSize = Math.max(width, widestLabelSize);
        highestLabelSize = Math.max(height, highestLabelSize);
      }
      garbageCollect(caches, length);
      widest = widths.indexOf(widestLabelSize);
      highest = heights.indexOf(highestLabelSize);
      function valueAt(idx) {
        return {
          width: widths[idx] || 0,
          height: heights[idx] || 0,
          offset: offsets[idx] || 0
        };
      }
      return {
        first: valueAt(0),
        last: valueAt(length - 1),
        widest: valueAt(widest),
        highest: valueAt(highest)
      };
    }
    function getTickMarkLength(options) {
      return options.drawTicks ? options.tickMarkLength : 0;
    }
    function getScaleLabelHeight(options) {
      var font, padding;
      if (!options.display) {
        return 0;
      }
      font = helpers$1.options._parseFont(options);
      padding = helpers$1.options.toPadding(options.padding);
      return font.lineHeight + padding.height;
    }
    function parseFontOptions(options, nestedOpts) {
      return helpers$1.extend(helpers$1.options._parseFont({
        fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
        fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
        fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
        lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
      }), {
        color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
      });
    }
    function parseTickFontOptions(options) {
      var minor = parseFontOptions(options, options.minor);
      var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
      return {
        minor: minor,
        major: major
      };
    }
    function nonSkipped(ticksToFilter) {
      var filtered = [];
      var item, index, len;
      for (index = 0, len = ticksToFilter.length; index < len; ++index) {
        item = ticksToFilter[index];
        if (typeof item._index !== 'undefined') {
          filtered.push(item);
        }
      }
      return filtered;
    }
    function getEvenSpacing(arr) {
      var len = arr.length;
      var i, diff;
      if (len < 2) {
        return false;
      }
      for (diff = arr[0], i = 1; i < len; ++i) {
        if (arr[i] - arr[i - 1] !== diff) {
          return false;
        }
      }
      return diff;
    }
    function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
      var evenMajorSpacing = getEvenSpacing(majorIndices);
      var spacing = (ticks.length - 1) / ticksLimit;
      var factors, factor, i, ilen;
      if (!evenMajorSpacing) {
        return Math.max(spacing, 1);
      }
      factors = helpers$1.math._factorize(evenMajorSpacing);
      for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
        factor = factors[i];
        if (factor > spacing) {
          return factor;
        }
      }
      return Math.max(spacing, 1);
    }
    function getMajorIndices(ticks) {
      var result = [];
      var i, ilen;
      for (i = 0, ilen = ticks.length; i < ilen; i++) {
        if (ticks[i].major) {
          result.push(i);
        }
      }
      return result;
    }
    function skipMajors(ticks, majorIndices, spacing) {
      var count = 0;
      var next = majorIndices[0];
      var i, tick;
      spacing = Math.ceil(spacing);
      for (i = 0; i < ticks.length; i++) {
        tick = ticks[i];
        if (i === next) {
          tick._index = i;
          count++;
          next = majorIndices[count * spacing];
        } else {
          delete tick.label;
        }
      }
    }
    function skip(ticks, spacing, majorStart, majorEnd) {
      var start = valueOrDefault$a(majorStart, 0);
      var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
      var count = 0;
      var length, i, tick, next;
      spacing = Math.ceil(spacing);
      if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
      }
      next = start;
      while (next < 0) {
        count++;
        next = Math.round(start + count * spacing);
      }
      for (i = Math.max(start, 0); i < end; i++) {
        tick = ticks[i];
        if (i === next) {
          tick._index = i;
          count++;
          next = Math.round(start + count * spacing);
        } else {
          delete tick.label;
        }
      }
    }
    var Scale = core_element.extend({
      zeroLineIndex: 0,
      getPadding: function getPadding() {
        var me = this;
        return {
          left: me.paddingLeft || 0,
          top: me.paddingTop || 0,
          right: me.paddingRight || 0,
          bottom: me.paddingBottom || 0
        };
      },
      getTicks: function getTicks() {
        return this._ticks;
      },
      _getLabels: function _getLabels() {
        var data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
      },
      mergeTicksOptions: function mergeTicksOptions() {},
      beforeUpdate: function beforeUpdate() {
        helpers$1.callback(this.options.beforeUpdate, [this]);
      },
      update: function update(maxWidth, maxHeight, margins) {
        var me = this;
        var tickOpts = me.options.ticks;
        var sampleSize = tickOpts.sampleSize;
        var i, ilen, labels, ticks, samplingEnabled;
        me.beforeUpdate();
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me.margins = helpers$1.extend({
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }, margins);
        me._ticks = null;
        me.ticks = null;
        me._labelSizes = null;
        me._maxLabelLines = 0;
        me.longestLabelWidth = 0;
        me.longestTextCache = me.longestTextCache || {};
        me._gridLineItems = null;
        me._labelItems = null;
        me.beforeSetDimensions();
        me.setDimensions();
        me.afterSetDimensions();
        me.beforeDataLimits();
        me.determineDataLimits();
        me.afterDataLimits();
        me.beforeBuildTicks();
        ticks = me.buildTicks() || [];
        ticks = me.afterBuildTicks(ticks) || ticks;
        if ((!ticks || !ticks.length) && me.ticks) {
          ticks = [];
          for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
            ticks.push({
              value: me.ticks[i],
              major: false
            });
          }
        }
        me._ticks = ticks;
        samplingEnabled = sampleSize < ticks.length;
        labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
        me._configure();
        me.beforeCalculateTickRotation();
        me.calculateTickRotation();
        me.afterCalculateTickRotation();
        me.beforeFit();
        me.fit();
        me.afterFit();
        me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
        if (samplingEnabled) {
          labels = me._convertTicksToLabels(me._ticksToDraw);
        }
        me.ticks = labels;
        me.afterUpdate();
        return me.minSize;
      },
      _configure: function _configure() {
        var me = this;
        var reversePixels = me.options.ticks.reverse;
        var startPixel, endPixel;
        if (me.isHorizontal()) {
          startPixel = me.left;
          endPixel = me.right;
        } else {
          startPixel = me.top;
          endPixel = me.bottom;
          reversePixels = !reversePixels;
        }
        me._startPixel = startPixel;
        me._endPixel = endPixel;
        me._reversePixels = reversePixels;
        me._length = endPixel - startPixel;
      },
      afterUpdate: function afterUpdate() {
        helpers$1.callback(this.options.afterUpdate, [this]);
      },
      beforeSetDimensions: function beforeSetDimensions() {
        helpers$1.callback(this.options.beforeSetDimensions, [this]);
      },
      setDimensions: function setDimensions() {
        var me = this;
        if (me.isHorizontal()) {
          me.width = me.maxWidth;
          me.left = 0;
          me.right = me.width;
        } else {
          me.height = me.maxHeight;
          me.top = 0;
          me.bottom = me.height;
        }
        me.paddingLeft = 0;
        me.paddingTop = 0;
        me.paddingRight = 0;
        me.paddingBottom = 0;
      },
      afterSetDimensions: function afterSetDimensions() {
        helpers$1.callback(this.options.afterSetDimensions, [this]);
      },
      beforeDataLimits: function beforeDataLimits() {
        helpers$1.callback(this.options.beforeDataLimits, [this]);
      },
      determineDataLimits: helpers$1.noop,
      afterDataLimits: function afterDataLimits() {
        helpers$1.callback(this.options.afterDataLimits, [this]);
      },
      beforeBuildTicks: function beforeBuildTicks() {
        helpers$1.callback(this.options.beforeBuildTicks, [this]);
      },
      buildTicks: helpers$1.noop,
      afterBuildTicks: function afterBuildTicks(ticks) {
        var me = this;
        if (isArray(ticks) && ticks.length) {
          return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
        }
        me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
        return ticks;
      },
      beforeTickToLabelConversion: function beforeTickToLabelConversion() {
        helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
      },
      convertTicksToLabels: function convertTicksToLabels() {
        var me = this;
        var tickOpts = me.options.ticks;
        me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
      },
      afterTickToLabelConversion: function afterTickToLabelConversion() {
        helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
      },
      beforeCalculateTickRotation: function beforeCalculateTickRotation() {
        helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
      },
      calculateTickRotation: function calculateTickRotation() {
        var me = this;
        var options = me.options;
        var tickOpts = options.ticks;
        var numTicks = me.getTicks().length;
        var minRotation = tickOpts.minRotation || 0;
        var maxRotation = tickOpts.maxRotation;
        var labelRotation = minRotation;
        var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
        if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
          me.labelRotation = minRotation;
          return;
        }
        labelSizes = me._getLabelSizes();
        maxLabelWidth = labelSizes.widest.width;
        maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
        maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
        tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
          tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
          maxHeight = me.maxHeight - getTickMarkLength(options.gridLines) - tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
          maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
          labelRotation = helpers$1.toDegrees(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
          labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        me.labelRotation = labelRotation;
      },
      afterCalculateTickRotation: function afterCalculateTickRotation() {
        helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
      },
      beforeFit: function beforeFit() {
        helpers$1.callback(this.options.beforeFit, [this]);
      },
      fit: function fit() {
        var me = this;
        var minSize = me.minSize = {
          width: 0,
          height: 0
        };
        var chart = me.chart;
        var opts = me.options;
        var tickOpts = opts.ticks;
        var scaleLabelOpts = opts.scaleLabel;
        var gridLineOpts = opts.gridLines;
        var display = me._isVisible();
        var isBottom = opts.position === 'bottom';
        var isHorizontal = me.isHorizontal();
        if (isHorizontal) {
          minSize.width = me.maxWidth;
        } else if (display) {
          minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
        }
        if (!isHorizontal) {
          minSize.height = me.maxHeight;
        } else if (display) {
          minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
        }
        if (tickOpts.display && display) {
          var tickFonts = parseTickFontOptions(tickOpts);
          var labelSizes = me._getLabelSizes();
          var firstLabelSize = labelSizes.first;
          var lastLabelSize = labelSizes.last;
          var widestLabelSize = labelSizes.widest;
          var highestLabelSize = labelSizes.highest;
          var lineSpace = tickFonts.minor.lineHeight * 0.4;
          var tickPadding = tickOpts.padding;
          if (isHorizontal) {
            var isRotated = me.labelRotation !== 0;
            var angleRadians = helpers$1.toRadians(me.labelRotation);
            var cosRotation = Math.cos(angleRadians);
            var sinRotation = Math.sin(angleRadians);
            var labelHeight = sinRotation * widestLabelSize.width + cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0)) + (isRotated ? 0 : lineSpace);
            minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
            var offsetLeft = me.getPixelForTick(0) - me.left;
            var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
            var paddingLeft, paddingRight;
            if (isRotated) {
              paddingLeft = isBottom ? cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset : sinRotation * (firstLabelSize.height - firstLabelSize.offset);
              paddingRight = isBottom ? sinRotation * (lastLabelSize.height - lastLabelSize.offset) : cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
            } else {
              paddingLeft = firstLabelSize.width / 2;
              paddingRight = lastLabelSize.width / 2;
            }
            me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
            me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
          } else {
            var labelWidth = tickOpts.mirror ? 0 : widestLabelSize.width + tickPadding + lineSpace;
            minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
            me.paddingTop = firstLabelSize.height / 2;
            me.paddingBottom = lastLabelSize.height / 2;
          }
        }
        me.handleMargins();
        if (isHorizontal) {
          me.width = me._length = chart.width - me.margins.left - me.margins.right;
          me.height = minSize.height;
        } else {
          me.width = minSize.width;
          me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
        }
      },
      handleMargins: function handleMargins() {
        var me = this;
        if (me.margins) {
          me.margins.left = Math.max(me.paddingLeft, me.margins.left);
          me.margins.top = Math.max(me.paddingTop, me.margins.top);
          me.margins.right = Math.max(me.paddingRight, me.margins.right);
          me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
        }
      },
      afterFit: function afterFit() {
        helpers$1.callback(this.options.afterFit, [this]);
      },
      isHorizontal: function isHorizontal() {
        var pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
      },
      isFullWidth: function isFullWidth() {
        return this.options.fullWidth;
      },
      getRightValue: function getRightValue(rawValue) {
        if (isNullOrUndef(rawValue)) {
          return NaN;
        }
        if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
          return NaN;
        }
        if (rawValue) {
          if (this.isHorizontal()) {
            if (rawValue.x !== undefined) {
              return this.getRightValue(rawValue.x);
            }
          } else if (rawValue.y !== undefined) {
            return this.getRightValue(rawValue.y);
          }
        }
        return rawValue;
      },
      _convertTicksToLabels: function _convertTicksToLabels(ticks) {
        var me = this;
        var labels, i, ilen;
        me.ticks = ticks.map(function (tick) {
          return tick.value;
        });
        me.beforeTickToLabelConversion();
        labels = me.convertTicksToLabels(ticks) || me.ticks;
        me.afterTickToLabelConversion();
        for (i = 0, ilen = ticks.length; i < ilen; ++i) {
          ticks[i].label = labels[i];
        }
        return labels;
      },
      _getLabelSizes: function _getLabelSizes() {
        var me = this;
        var labelSizes = me._labelSizes;
        if (!labelSizes) {
          me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
          me.longestLabelWidth = labelSizes.widest.width;
        }
        return labelSizes;
      },
      _parseValue: function _parseValue(value) {
        var start, end, min, max;
        if (isArray(value)) {
          start = +this.getRightValue(value[0]);
          end = +this.getRightValue(value[1]);
          min = Math.min(start, end);
          max = Math.max(start, end);
        } else {
          value = +this.getRightValue(value);
          start = undefined;
          end = value;
          min = value;
          max = value;
        }
        return {
          min: min,
          max: max,
          start: start,
          end: end
        };
      },
      _getScaleLabel: function _getScaleLabel(rawValue) {
        var v = this._parseValue(rawValue);
        if (v.start !== undefined) {
          return '[' + v.start + ', ' + v.end + ']';
        }
        return +this.getRightValue(rawValue);
      },
      getLabelForIndex: helpers$1.noop,
      getPixelForValue: helpers$1.noop,
      getValueForPixel: helpers$1.noop,
      getPixelForTick: function getPixelForTick(index) {
        var me = this;
        var offset = me.options.offset;
        var numTicks = me._ticks.length;
        var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
        return index < 0 || index > numTicks - 1 ? null : me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
      },
      getPixelForDecimal: function getPixelForDecimal(decimal) {
        var me = this;
        if (me._reversePixels) {
          decimal = 1 - decimal;
        }
        return me._startPixel + decimal * me._length;
      },
      getDecimalForPixel: function getDecimalForPixel(pixel) {
        var decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
      },
      getBasePixel: function getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
      },
      getBaseValue: function getBaseValue() {
        var me = this;
        var min = me.min;
        var max = me.max;
        return me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
      },
      _autoSkip: function _autoSkip(ticks) {
        var me = this;
        var tickOpts = me.options.ticks;
        var axisLength = me._length;
        var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
        var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
        var numMajorIndices = majorIndices.length;
        var first = majorIndices[0];
        var last = majorIndices[numMajorIndices - 1];
        var i, ilen, spacing, avgMajorSpacing;
        if (numMajorIndices > ticksLimit) {
          skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
          return nonSkipped(ticks);
        }
        spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
        if (numMajorIndices > 0) {
          for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
            skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
          }
          avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
          skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
          skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
          return nonSkipped(ticks);
        }
        skip(ticks, spacing);
        return nonSkipped(ticks);
      },
      _tickSize: function _tickSize() {
        var me = this;
        var optionTicks = me.options.ticks;
        var rot = helpers$1.toRadians(me.labelRotation);
        var cos = Math.abs(Math.cos(rot));
        var sin = Math.abs(Math.sin(rot));
        var labelSizes = me._getLabelSizes();
        var padding = optionTicks.autoSkipPadding || 0;
        var w = labelSizes ? labelSizes.widest.width + padding : 0;
        var h = labelSizes ? labelSizes.highest.height + padding : 0;
        return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
      },
      _isVisible: function _isVisible() {
        var me = this;
        var chart = me.chart;
        var display = me.options.display;
        var i, ilen, meta;
        if (display !== 'auto') {
          return !!display;
        }
        for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
          if (chart.isDatasetVisible(i)) {
            meta = chart.getDatasetMeta(i);
            if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
              return true;
            }
          }
        }
        return false;
      },
      _computeGridLineItems: function _computeGridLineItems(chartArea) {
        var me = this;
        var chart = me.chart;
        var options = me.options;
        var gridLines = options.gridLines;
        var position = options.position;
        var offsetGridLines = gridLines.offsetGridLines;
        var isHorizontal = me.isHorizontal();
        var ticks = me._ticksToDraw;
        var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
        var tl = getTickMarkLength(gridLines);
        var items = [];
        var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
        var axisHalfWidth = axisWidth / 2;
        var alignPixel = helpers$1._alignPixel;
        var alignBorderValue = function alignBorderValue(pixel) {
          return alignPixel(chart, pixel, axisWidth);
        };
        var borderValue, i, tick, lineValue, alignedLineValue;
        var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
        if (position === 'top') {
          borderValue = alignBorderValue(me.bottom);
          ty1 = me.bottom - tl;
          ty2 = borderValue - axisHalfWidth;
          y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
          y2 = chartArea.bottom;
        } else if (position === 'bottom') {
          borderValue = alignBorderValue(me.top);
          y1 = chartArea.top;
          y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
          ty1 = borderValue + axisHalfWidth;
          ty2 = me.top + tl;
        } else if (position === 'left') {
          borderValue = alignBorderValue(me.right);
          tx1 = me.right - tl;
          tx2 = borderValue - axisHalfWidth;
          x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
          x2 = chartArea.right;
        } else {
          borderValue = alignBorderValue(me.left);
          x1 = chartArea.left;
          x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
          tx1 = borderValue + axisHalfWidth;
          tx2 = me.left + tl;
        }
        for (i = 0; i < ticksLength; ++i) {
          tick = ticks[i] || {};
          if (isNullOrUndef(tick.label) && i < ticks.length) {
            continue;
          }
          if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
            lineWidth = gridLines.zeroLineWidth;
            lineColor = gridLines.zeroLineColor;
            borderDash = gridLines.zeroLineBorderDash || [];
            borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
          } else {
            lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
            lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
            borderDash = gridLines.borderDash || [];
            borderDashOffset = gridLines.borderDashOffset || 0.0;
          }
          lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
          if (lineValue === undefined) {
            continue;
          }
          alignedLineValue = alignPixel(chart, lineValue, lineWidth);
          if (isHorizontal) {
            tx1 = tx2 = x1 = x2 = alignedLineValue;
          } else {
            ty1 = ty2 = y1 = y2 = alignedLineValue;
          }
          items.push({
            tx1: tx1,
            ty1: ty1,
            tx2: tx2,
            ty2: ty2,
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            width: lineWidth,
            color: lineColor,
            borderDash: borderDash,
            borderDashOffset: borderDashOffset
          });
        }
        items.ticksLength = ticksLength;
        items.borderValue = borderValue;
        return items;
      },
      _computeLabelItems: function _computeLabelItems() {
        var me = this;
        var options = me.options;
        var optionTicks = options.ticks;
        var position = options.position;
        var isMirrored = optionTicks.mirror;
        var isHorizontal = me.isHorizontal();
        var ticks = me._ticksToDraw;
        var fonts = parseTickFontOptions(optionTicks);
        var tickPadding = optionTicks.padding;
        var tl = getTickMarkLength(options.gridLines);
        var rotation = -helpers$1.toRadians(me.labelRotation);
        var items = [];
        var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        if (position === 'top') {
          y = me.bottom - tl - tickPadding;
          textAlign = !rotation ? 'center' : 'left';
        } else if (position === 'bottom') {
          y = me.top + tl + tickPadding;
          textAlign = !rotation ? 'center' : 'right';
        } else if (position === 'left') {
          x = me.right - (isMirrored ? 0 : tl) - tickPadding;
          textAlign = isMirrored ? 'left' : 'right';
        } else {
          x = me.left + (isMirrored ? 0 : tl) + tickPadding;
          textAlign = isMirrored ? 'right' : 'left';
        }
        for (i = 0, ilen = ticks.length; i < ilen; ++i) {
          tick = ticks[i];
          label = tick.label;
          if (isNullOrUndef(label)) {
            continue;
          }
          pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
          font = tick.major ? fonts.major : fonts.minor;
          lineHeight = font.lineHeight;
          lineCount = isArray(label) ? label.length : 1;
          if (isHorizontal) {
            x = pixel;
            textOffset = position === 'top' ? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight : (!rotation ? 0.5 : 0) * lineHeight;
          } else {
            y = pixel;
            textOffset = (1 - lineCount) * lineHeight / 2;
          }
          items.push({
            x: x,
            y: y,
            rotation: rotation,
            label: label,
            font: font,
            textOffset: textOffset,
            textAlign: textAlign
          });
        }
        return items;
      },
      _drawGrid: function _drawGrid(chartArea) {
        var me = this;
        var gridLines = me.options.gridLines;
        if (!gridLines.display) {
          return;
        }
        var ctx = me.ctx;
        var chart = me.chart;
        var alignPixel = helpers$1._alignPixel;
        var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
        var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
        var width, color, i, ilen, item;
        for (i = 0, ilen = items.length; i < ilen; ++i) {
          item = items[i];
          width = item.width;
          color = item.color;
          if (width && color) {
            ctx.save();
            ctx.lineWidth = width;
            ctx.strokeStyle = color;
            if (ctx.setLineDash) {
              ctx.setLineDash(item.borderDash);
              ctx.lineDashOffset = item.borderDashOffset;
            }
            ctx.beginPath();
            if (gridLines.drawTicks) {
              ctx.moveTo(item.tx1, item.ty1);
              ctx.lineTo(item.tx2, item.ty2);
            }
            if (gridLines.drawOnChartArea) {
              ctx.moveTo(item.x1, item.y1);
              ctx.lineTo(item.x2, item.y2);
            }
            ctx.stroke();
            ctx.restore();
          }
        }
        if (axisWidth) {
          var firstLineWidth = axisWidth;
          var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
          var borderValue = items.borderValue;
          var x1, x2, y1, y2;
          if (me.isHorizontal()) {
            x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
            x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
          } else {
            y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
            y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
          }
          ctx.lineWidth = axisWidth;
          ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
          ctx.beginPath();
          ctx.moveTo(x1, y1);
          ctx.lineTo(x2, y2);
          ctx.stroke();
        }
      },
      _drawLabels: function _drawLabels() {
        var me = this;
        var optionTicks = me.options.ticks;
        if (!optionTicks.display) {
          return;
        }
        var ctx = me.ctx;
        var items = me._labelItems || (me._labelItems = me._computeLabelItems());
        var i, j, ilen, jlen, item, tickFont, label, y;
        for (i = 0, ilen = items.length; i < ilen; ++i) {
          item = items[i];
          tickFont = item.font;
          ctx.save();
          ctx.translate(item.x, item.y);
          ctx.rotate(item.rotation);
          ctx.font = tickFont.string;
          ctx.fillStyle = tickFont.color;
          ctx.textBaseline = 'middle';
          ctx.textAlign = item.textAlign;
          label = item.label;
          y = item.textOffset;
          if (isArray(label)) {
            for (j = 0, jlen = label.length; j < jlen; ++j) {
              ctx.fillText('' + label[j], 0, y);
              y += tickFont.lineHeight;
            }
          } else {
            ctx.fillText(label, 0, y);
          }
          ctx.restore();
        }
      },
      _drawTitle: function _drawTitle() {
        var me = this;
        var ctx = me.ctx;
        var options = me.options;
        var scaleLabel = options.scaleLabel;
        if (!scaleLabel.display) {
          return;
        }
        var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
        var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
        var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
        var halfLineHeight = scaleLabelFont.lineHeight / 2;
        var position = options.position;
        var rotation = 0;
        var scaleLabelX, scaleLabelY;
        if (me.isHorizontal()) {
          scaleLabelX = me.left + me.width / 2;
          scaleLabelY = position === 'bottom' ? me.bottom - halfLineHeight - scaleLabelPadding.bottom : me.top + halfLineHeight + scaleLabelPadding.top;
        } else {
          var isLeft = position === 'left';
          scaleLabelX = isLeft ? me.left + halfLineHeight + scaleLabelPadding.top : me.right - halfLineHeight - scaleLabelPadding.top;
          scaleLabelY = me.top + me.height / 2;
          rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
        }
        ctx.save();
        ctx.translate(scaleLabelX, scaleLabelY);
        ctx.rotate(rotation);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = scaleLabelFontColor;
        ctx.font = scaleLabelFont.string;
        ctx.fillText(scaleLabel.labelString, 0, 0);
        ctx.restore();
      },
      draw: function draw(chartArea) {
        var me = this;
        if (!me._isVisible()) {
          return;
        }
        me._drawGrid(chartArea);
        me._drawTitle();
        me._drawLabels();
      },
      _layers: function _layers() {
        var me = this;
        var opts = me.options;
        var tz = opts.ticks && opts.ticks.z || 0;
        var gz = opts.gridLines && opts.gridLines.z || 0;
        if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
          return [{
            z: tz,
            draw: function draw() {
              me.draw.apply(me, arguments);
            }
          }];
        }
        return [{
          z: gz,
          draw: function draw() {
            me._drawGrid.apply(me, arguments);
            me._drawTitle.apply(me, arguments);
          }
        }, {
          z: tz,
          draw: function draw() {
            me._drawLabels.apply(me, arguments);
          }
        }];
      },
      _getMatchingVisibleMetas: function _getMatchingVisibleMetas(type) {
        var me = this;
        var isHorizontal = me.isHorizontal();
        return me.chart._getSortedVisibleDatasetMetas().filter(function (meta) {
          return (!type || meta.type === type) && (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
        });
      }
    });
    Scale.prototype._draw = Scale.prototype.draw;
    var core_scale = Scale;
    var isNullOrUndef$1 = helpers$1.isNullOrUndef;
    var defaultConfig = {
      position: 'bottom'
    };
    var scale_category = core_scale.extend({
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var labels = me._getLabels();
        var ticksOpts = me.options.ticks;
        var min = ticksOpts.min;
        var max = ticksOpts.max;
        var minIndex = 0;
        var maxIndex = labels.length - 1;
        var findIndex;
        if (min !== undefined) {
          findIndex = labels.indexOf(min);
          if (findIndex >= 0) {
            minIndex = findIndex;
          }
        }
        if (max !== undefined) {
          findIndex = labels.indexOf(max);
          if (findIndex >= 0) {
            maxIndex = findIndex;
          }
        }
        me.minIndex = minIndex;
        me.maxIndex = maxIndex;
        me.min = labels[minIndex];
        me.max = labels[maxIndex];
      },
      buildTicks: function buildTicks() {
        var me = this;
        var labels = me._getLabels();
        var minIndex = me.minIndex;
        var maxIndex = me.maxIndex;
        me.ticks = minIndex === 0 && maxIndex === labels.length - 1 ? labels : labels.slice(minIndex, maxIndex + 1);
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        var me = this;
        var chart = me.chart;
        if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
          return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
        }
        return me._getLabels()[index];
      },
      _configure: function _configure() {
        var me = this;
        var offset = me.options.offset;
        var ticks = me.ticks;
        core_scale.prototype._configure.call(me);
        if (!me.isHorizontal()) {
          me._reversePixels = !me._reversePixels;
        }
        if (!ticks) {
          return;
        }
        me._startValue = me.minIndex - (offset ? 0.5 : 0);
        me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
      },
      getPixelForValue: function getPixelForValue(value, index, datasetIndex) {
        var me = this;
        var valueCategory, labels, idx;
        if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
          value = me.chart.data.datasets[datasetIndex].data[index];
        }
        if (!isNullOrUndef$1(value)) {
          valueCategory = me.isHorizontal() ? value.x : value.y;
        }
        if (valueCategory !== undefined || value !== undefined && isNaN(index)) {
          labels = me._getLabels();
          value = helpers$1.valueOrDefault(valueCategory, value);
          idx = labels.indexOf(value);
          index = idx !== -1 ? idx : index;
          if (isNaN(index)) {
            index = value;
          }
        }
        return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.ticks;
        return index < 0 || index > ticks.length - 1 ? null : this.getPixelForValue(ticks[index], index + this.minIndex);
      },
      getValueForPixel: function getValueForPixel(pixel) {
        var me = this;
        var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
        return Math.min(Math.max(value, 0), me.ticks.length - 1);
      },
      getBasePixel: function getBasePixel() {
        return this.bottom;
      }
    });
    var _defaults = defaultConfig;
    scale_category._defaults = _defaults;
    var noop = helpers$1.noop;
    var isNullOrUndef$2 = helpers$1.isNullOrUndef;
    function generateTicks(generationOptions, dataRange) {
      var ticks = [];
      var MIN_SPACING = 1e-14;
      var stepSize = generationOptions.stepSize;
      var unit = stepSize || 1;
      var maxNumSpaces = generationOptions.maxTicks - 1;
      var min = generationOptions.min;
      var max = generationOptions.max;
      var precision = generationOptions.precision;
      var rmin = dataRange.min;
      var rmax = dataRange.max;
      var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
      var factor, niceMin, niceMax, numSpaces;
      if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
        return [rmin, rmax];
      }
      numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
      if (numSpaces > maxNumSpaces) {
        spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
      }
      if (stepSize || isNullOrUndef$2(precision)) {
        factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
      } else {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
      }
      niceMin = Math.floor(rmin / spacing) * spacing;
      niceMax = Math.ceil(rmax / spacing) * spacing;
      if (stepSize) {
        if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
          niceMin = min;
        }
        if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
          niceMax = max;
        }
      }
      numSpaces = (niceMax - niceMin) / spacing;
      if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
        numSpaces = Math.round(numSpaces);
      } else {
        numSpaces = Math.ceil(numSpaces);
      }
      niceMin = Math.round(niceMin * factor) / factor;
      niceMax = Math.round(niceMax * factor) / factor;
      ticks.push(isNullOrUndef$2(min) ? niceMin : min);
      for (var j = 1; j < numSpaces; ++j) {
        ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
      }
      ticks.push(isNullOrUndef$2(max) ? niceMax : max);
      return ticks;
    }
    var scale_linearbase = core_scale.extend({
      getRightValue: function getRightValue(value) {
        if (typeof value === 'string') {
          return +value;
        }
        return core_scale.prototype.getRightValue.call(this, value);
      },
      handleTickRangeOptions: function handleTickRangeOptions() {
        var me = this;
        var opts = me.options;
        var tickOpts = opts.ticks;
        if (tickOpts.beginAtZero) {
          var minSign = helpers$1.sign(me.min);
          var maxSign = helpers$1.sign(me.max);
          if (minSign < 0 && maxSign < 0) {
            me.max = 0;
          } else if (minSign > 0 && maxSign > 0) {
            me.min = 0;
          }
        }
        var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
        var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
        if (tickOpts.min !== undefined) {
          me.min = tickOpts.min;
        } else if (tickOpts.suggestedMin !== undefined) {
          if (me.min === null) {
            me.min = tickOpts.suggestedMin;
          } else {
            me.min = Math.min(me.min, tickOpts.suggestedMin);
          }
        }
        if (tickOpts.max !== undefined) {
          me.max = tickOpts.max;
        } else if (tickOpts.suggestedMax !== undefined) {
          if (me.max === null) {
            me.max = tickOpts.suggestedMax;
          } else {
            me.max = Math.max(me.max, tickOpts.suggestedMax);
          }
        }
        if (setMin !== setMax) {
          if (me.min >= me.max) {
            if (setMin) {
              me.max = me.min + 1;
            } else {
              me.min = me.max - 1;
            }
          }
        }
        if (me.min === me.max) {
          me.max++;
          if (!tickOpts.beginAtZero) {
            me.min--;
          }
        }
      },
      getTickLimit: function getTickLimit() {
        var me = this;
        var tickOpts = me.options.ticks;
        var stepSize = tickOpts.stepSize;
        var maxTicksLimit = tickOpts.maxTicksLimit;
        var maxTicks;
        if (stepSize) {
          maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
        } else {
          maxTicks = me._computeTickLimit();
          maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) {
          maxTicks = Math.min(maxTicksLimit, maxTicks);
        }
        return maxTicks;
      },
      _computeTickLimit: function _computeTickLimit() {
        return Number.POSITIVE_INFINITY;
      },
      handleDirectionalChanges: noop,
      buildTicks: function buildTicks() {
        var me = this;
        var opts = me.options;
        var tickOpts = opts.ticks;
        var maxTicks = me.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        var numericGeneratorOptions = {
          maxTicks: maxTicks,
          min: tickOpts.min,
          max: tickOpts.max,
          precision: tickOpts.precision,
          stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
        };
        var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
        me.handleDirectionalChanges();
        me.max = helpers$1.max(ticks);
        me.min = helpers$1.min(ticks);
        if (tickOpts.reverse) {
          ticks.reverse();
          me.start = me.max;
          me.end = me.min;
        } else {
          me.start = me.min;
          me.end = me.max;
        }
      },
      convertTicksToLabels: function convertTicksToLabels() {
        var me = this;
        me.ticksAsNumbers = me.ticks.slice();
        me.zeroLineIndex = me.ticks.indexOf(0);
        core_scale.prototype.convertTicksToLabels.call(me);
      },
      _configure: function _configure() {
        var me = this;
        var ticks = me.getTicks();
        var start = me.min;
        var end = me.max;
        var offset;
        core_scale.prototype._configure.call(me);
        if (me.options.offset && ticks.length) {
          offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
          start -= offset;
          end += offset;
        }
        me._startValue = start;
        me._endValue = end;
        me._valueRange = end - start;
      }
    });
    var defaultConfig$1 = {
      position: 'left',
      ticks: {
        callback: core_ticks.formatters.linear
      }
    };
    var DEFAULT_MIN = 0;
    var DEFAULT_MAX = 1;
    function getOrCreateStack(stacks, stacked, meta) {
      var key = [meta.type, stacked === undefined && meta.stack === undefined ? meta.index : '', meta.stack].join('.');
      if (stacks[key] === undefined) {
        stacks[key] = {
          pos: [],
          neg: []
        };
      }
      return stacks[key];
    }
    function stackData(scale, stacks, meta, data) {
      var opts = scale.options;
      var stacked = opts.stacked;
      var stack = getOrCreateStack(stacks, stacked, meta);
      var pos = stack.pos;
      var neg = stack.neg;
      var ilen = data.length;
      var i, value;
      for (i = 0; i < ilen; ++i) {
        value = scale._parseValue(data[i]);
        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
          continue;
        }
        pos[i] = pos[i] || 0;
        neg[i] = neg[i] || 0;
        if (opts.relativePoints) {
          pos[i] = 100;
        } else if (value.min < 0 || value.max < 0) {
          neg[i] += value.min;
        } else {
          pos[i] += value.max;
        }
      }
    }
    function updateMinMax(scale, meta, data) {
      var ilen = data.length;
      var i, value;
      for (i = 0; i < ilen; ++i) {
        value = scale._parseValue(data[i]);
        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
          continue;
        }
        scale.min = Math.min(scale.min, value.min);
        scale.max = Math.max(scale.max, value.max);
      }
    }
    var scale_linear = scale_linearbase.extend({
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var opts = me.options;
        var chart = me.chart;
        var datasets = chart.data.datasets;
        var metasets = me._getMatchingVisibleMetas();
        var hasStacks = opts.stacked;
        var stacks = {};
        var ilen = metasets.length;
        var i, meta, data, values;
        me.min = Number.POSITIVE_INFINITY;
        me.max = Number.NEGATIVE_INFINITY;
        if (hasStacks === undefined) {
          for (i = 0; !hasStacks && i < ilen; ++i) {
            meta = metasets[i];
            hasStacks = meta.stack !== undefined;
          }
        }
        for (i = 0; i < ilen; ++i) {
          meta = metasets[i];
          data = datasets[meta.index].data;
          if (hasStacks) {
            stackData(me, stacks, meta, data);
          } else {
            updateMinMax(me, meta, data);
          }
        }
        helpers$1.each(stacks, function (stackValues) {
          values = stackValues.pos.concat(stackValues.neg);
          me.min = Math.min(me.min, helpers$1.min(values));
          me.max = Math.max(me.max, helpers$1.max(values));
        });
        me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
        me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
        me.handleTickRangeOptions();
      },
      _computeTickLimit: function _computeTickLimit() {
        var me = this;
        var tickFont;
        if (me.isHorizontal()) {
          return Math.ceil(me.width / 40);
        }
        tickFont = helpers$1.options._parseFont(me.options.ticks);
        return Math.ceil(me.height / tickFont.lineHeight);
      },
      handleDirectionalChanges: function handleDirectionalChanges() {
        if (!this.isHorizontal()) {
          this.ticks.reverse();
        }
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
      },
      getPixelForValue: function getPixelForValue(value) {
        var me = this;
        return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
      },
      getValueForPixel: function getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.ticksAsNumbers;
        if (index < 0 || index > ticks.length - 1) {
          return null;
        }
        return this.getPixelForValue(ticks[index]);
      }
    });
    var _defaults$1 = defaultConfig$1;
    scale_linear._defaults = _defaults$1;
    var valueOrDefault$b = helpers$1.valueOrDefault;
    var log10 = helpers$1.math.log10;
    function generateTicks$1(generationOptions, dataRange) {
      var ticks = [];
      var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
      var endExp = Math.floor(log10(dataRange.max));
      var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
      var exp, significand;
      if (tickVal === 0) {
        exp = Math.floor(log10(dataRange.minNotZero));
        significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
        ticks.push(tickVal);
        tickVal = significand * Math.pow(10, exp);
      } else {
        exp = Math.floor(log10(tickVal));
        significand = Math.floor(tickVal / Math.pow(10, exp));
      }
      var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
      do {
        ticks.push(tickVal);
        ++significand;
        if (significand === 10) {
          significand = 1;
          ++exp;
          precision = exp >= 0 ? 1 : precision;
        }
        tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
      } while (exp < endExp || exp === endExp && significand < endSignificand);
      var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
      ticks.push(lastTick);
      return ticks;
    }
    var defaultConfig$2 = {
      position: 'left',
      ticks: {
        callback: core_ticks.formatters.logarithmic
      }
    };
    function nonNegativeOrDefault(value, defaultValue) {
      return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
    }
    var scale_logarithmic = core_scale.extend({
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var opts = me.options;
        var chart = me.chart;
        var datasets = chart.data.datasets;
        var isHorizontal = me.isHorizontal();
        function IDMatches(meta) {
          return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
        }
        var datasetIndex, meta, value, data, i, ilen;
        me.min = Number.POSITIVE_INFINITY;
        me.max = Number.NEGATIVE_INFINITY;
        me.minNotZero = Number.POSITIVE_INFINITY;
        var hasStacks = opts.stacked;
        if (hasStacks === undefined) {
          for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
            meta = chart.getDatasetMeta(datasetIndex);
            if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
              hasStacks = true;
              break;
            }
          }
        }
        if (opts.stacked || hasStacks) {
          var valuesPerStack = {};
          for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
            meta = chart.getDatasetMeta(datasetIndex);
            var key = [meta.type, opts.stacked === undefined && meta.stack === undefined ? datasetIndex : '', meta.stack].join('.');
            if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
              if (valuesPerStack[key] === undefined) {
                valuesPerStack[key] = [];
              }
              data = datasets[datasetIndex].data;
              for (i = 0, ilen = data.length; i < ilen; i++) {
                var values = valuesPerStack[key];
                value = me._parseValue(data[i]);
                if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
                  continue;
                }
                values[i] = values[i] || 0;
                values[i] += value.max;
              }
            }
          }
          helpers$1.each(valuesPerStack, function (valuesForType) {
            if (valuesForType.length > 0) {
              var minVal = helpers$1.min(valuesForType);
              var maxVal = helpers$1.max(valuesForType);
              me.min = Math.min(me.min, minVal);
              me.max = Math.max(me.max, maxVal);
            }
          });
        } else {
          for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
            meta = chart.getDatasetMeta(datasetIndex);
            if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
              data = datasets[datasetIndex].data;
              for (i = 0, ilen = data.length; i < ilen; i++) {
                value = me._parseValue(data[i]);
                if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
                  continue;
                }
                me.min = Math.min(value.min, me.min);
                me.max = Math.max(value.max, me.max);
                if (value.min !== 0) {
                  me.minNotZero = Math.min(value.min, me.minNotZero);
                }
              }
            }
          }
        }
        me.min = helpers$1.isFinite(me.min) ? me.min : null;
        me.max = helpers$1.isFinite(me.max) ? me.max : null;
        me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
        this.handleTickRangeOptions();
      },
      handleTickRangeOptions: function handleTickRangeOptions() {
        var me = this;
        var tickOpts = me.options.ticks;
        var DEFAULT_MIN = 1;
        var DEFAULT_MAX = 10;
        me.min = nonNegativeOrDefault(tickOpts.min, me.min);
        me.max = nonNegativeOrDefault(tickOpts.max, me.max);
        if (me.min === me.max) {
          if (me.min !== 0 && me.min !== null) {
            me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
            me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
          } else {
            me.min = DEFAULT_MIN;
            me.max = DEFAULT_MAX;
          }
        }
        if (me.min === null) {
          me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
        }
        if (me.max === null) {
          me.max = me.min !== 0 ? Math.pow(10, Math.floor(log10(me.min)) + 1) : DEFAULT_MAX;
        }
        if (me.minNotZero === null) {
          if (me.min > 0) {
            me.minNotZero = me.min;
          } else if (me.max < 1) {
            me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
          } else {
            me.minNotZero = DEFAULT_MIN;
          }
        }
      },
      buildTicks: function buildTicks() {
        var me = this;
        var tickOpts = me.options.ticks;
        var reverse = !me.isHorizontal();
        var generationOptions = {
          min: nonNegativeOrDefault(tickOpts.min),
          max: nonNegativeOrDefault(tickOpts.max)
        };
        var ticks = me.ticks = generateTicks$1(generationOptions, me);
        me.max = helpers$1.max(ticks);
        me.min = helpers$1.min(ticks);
        if (tickOpts.reverse) {
          reverse = !reverse;
          me.start = me.max;
          me.end = me.min;
        } else {
          me.start = me.min;
          me.end = me.max;
        }
        if (reverse) {
          ticks.reverse();
        }
      },
      convertTicksToLabels: function convertTicksToLabels() {
        this.tickValues = this.ticks.slice();
        core_scale.prototype.convertTicksToLabels.call(this);
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.tickValues;
        if (index < 0 || index > ticks.length - 1) {
          return null;
        }
        return this.getPixelForValue(ticks[index]);
      },
      _getFirstTickValue: function _getFirstTickValue(value) {
        var exp = Math.floor(log10(value));
        var significand = Math.floor(value / Math.pow(10, exp));
        return significand * Math.pow(10, exp);
      },
      _configure: function _configure() {
        var me = this;
        var start = me.min;
        var offset = 0;
        core_scale.prototype._configure.call(me);
        if (start === 0) {
          start = me._getFirstTickValue(me.minNotZero);
          offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
        }
        me._startValue = log10(start);
        me._valueOffset = offset;
        me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
      },
      getPixelForValue: function getPixelForValue(value) {
        var me = this;
        var decimal = 0;
        value = +me.getRightValue(value);
        if (value > me.min && value > 0) {
          decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
        }
        return me.getPixelForDecimal(decimal);
      },
      getValueForPixel: function getValueForPixel(pixel) {
        var me = this;
        var decimal = me.getDecimalForPixel(pixel);
        return decimal === 0 && me.min === 0 ? 0 : Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
      }
    });
    var _defaults$2 = defaultConfig$2;
    scale_logarithmic._defaults = _defaults$2;
    var valueOrDefault$c = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
    var resolve$4 = helpers$1.options.resolve;
    var defaultConfig$3 = {
      display: true,
      animate: true,
      position: 'chartArea',
      angleLines: {
        display: true,
        color: 'rgba(0,0,0,0.1)',
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
      },
      gridLines: {
        circular: false
      },
      ticks: {
        showLabelBackdrop: true,
        backdropColor: 'rgba(255,255,255,0.75)',
        backdropPaddingY: 2,
        backdropPaddingX: 2,
        callback: core_ticks.formatters.linear
      },
      pointLabels: {
        display: true,
        fontSize: 10,
        callback: function callback(label) {
          return label;
        }
      }
    };
    function getTickBackdropHeight(opts) {
      var tickOpts = opts.ticks;
      if (tickOpts.display && opts.display) {
        return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
      }
      return 0;
    }
    function measureLabelSize(ctx, lineHeight, label) {
      if (helpers$1.isArray(label)) {
        return {
          w: helpers$1.longestText(ctx, ctx.font, label),
          h: label.length * lineHeight
        };
      }
      return {
        w: ctx.measureText(label).width,
        h: lineHeight
      };
    }
    function determineLimits(angle, pos, size, min, max) {
      if (angle === min || angle === max) {
        return {
          start: pos - size / 2,
          end: pos + size / 2
        };
      } else if (angle < min || angle > max) {
        return {
          start: pos - size,
          end: pos
        };
      }
      return {
        start: pos,
        end: pos + size
      };
    }
    function fitWithPointLabels(scale) {
      var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
      var furthestLimits = {
        l: 0,
        r: scale.width,
        t: 0,
        b: scale.height - scale.paddingTop
      };
      var furthestAngles = {};
      var i, textSize, pointPosition;
      scale.ctx.font = plFont.string;
      scale._pointLabelSizes = [];
      var valueCount = scale.chart.data.labels.length;
      for (i = 0; i < valueCount; i++) {
        pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
        textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
        scale._pointLabelSizes[i] = textSize;
        var angleRadians = scale.getIndexAngle(i);
        var angle = helpers$1.toDegrees(angleRadians) % 360;
        var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        if (hLimits.start < furthestLimits.l) {
          furthestLimits.l = hLimits.start;
          furthestAngles.l = angleRadians;
        }
        if (hLimits.end > furthestLimits.r) {
          furthestLimits.r = hLimits.end;
          furthestAngles.r = angleRadians;
        }
        if (vLimits.start < furthestLimits.t) {
          furthestLimits.t = vLimits.start;
          furthestAngles.t = angleRadians;
        }
        if (vLimits.end > furthestLimits.b) {
          furthestLimits.b = vLimits.end;
          furthestAngles.b = angleRadians;
        }
      }
      scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
    }
    function getTextAlignForAngle(angle) {
      if (angle === 0 || angle === 180) {
        return 'center';
      } else if (angle < 180) {
        return 'left';
      }
      return 'right';
    }
    function fillText(ctx, text, position, lineHeight) {
      var y = position.y + lineHeight / 2;
      var i, ilen;
      if (helpers$1.isArray(text)) {
        for (i = 0, ilen = text.length; i < ilen; ++i) {
          ctx.fillText(text[i], position.x, y);
          y += lineHeight;
        }
      } else {
        ctx.fillText(text, position.x, y);
      }
    }
    function adjustPointPositionForLabelHeight(angle, textSize, position) {
      if (angle === 90 || angle === 270) {
        position.y -= textSize.h / 2;
      } else if (angle > 270 || angle < 90) {
        position.y -= textSize.h;
      }
    }
    function drawPointLabels(scale) {
      var ctx = scale.ctx;
      var opts = scale.options;
      var pointLabelOpts = opts.pointLabels;
      var tickBackdropHeight = getTickBackdropHeight(opts);
      var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
      var plFont = helpers$1.options._parseFont(pointLabelOpts);
      ctx.save();
      ctx.font = plFont.string;
      ctx.textBaseline = 'middle';
      for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
        var extra = i === 0 ? tickBackdropHeight / 2 : 0;
        var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
        var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
        ctx.fillStyle = pointLabelFontColor;
        var angleRadians = scale.getIndexAngle(i);
        var angle = helpers$1.toDegrees(angleRadians);
        ctx.textAlign = getTextAlignForAngle(angle);
        adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
        fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
      }
      ctx.restore();
    }
    function drawRadiusLine(scale, gridLineOpts, radius, index) {
      var ctx = scale.ctx;
      var circular = gridLineOpts.circular;
      var valueCount = scale.chart.data.labels.length;
      var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
      var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
      var pointPosition;
      if (!circular && !valueCount || !lineColor || !lineWidth) {
        return;
      }
      ctx.save();
      ctx.strokeStyle = lineColor;
      ctx.lineWidth = lineWidth;
      if (ctx.setLineDash) {
        ctx.setLineDash(gridLineOpts.borderDash || []);
        ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
      }
      ctx.beginPath();
      if (circular) {
        ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
      } else {
        pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for (var i = 1; i < valueCount; i++) {
          pointPosition = scale.getPointPosition(i, radius);
          ctx.lineTo(pointPosition.x, pointPosition.y);
        }
      }
      ctx.closePath();
      ctx.stroke();
      ctx.restore();
    }
    function numberOrZero(param) {
      return helpers$1.isNumber(param) ? param : 0;
    }
    var scale_radialLinear = scale_linearbase.extend({
      setDimensions: function setDimensions() {
        var me = this;
        me.width = me.maxWidth;
        me.height = me.maxHeight;
        me.paddingTop = getTickBackdropHeight(me.options) / 2;
        me.xCenter = Math.floor(me.width / 2);
        me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
        me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
      },
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var chart = me.chart;
        var min = Number.POSITIVE_INFINITY;
        var max = Number.NEGATIVE_INFINITY;
        helpers$1.each(chart.data.datasets, function (dataset, datasetIndex) {
          if (chart.isDatasetVisible(datasetIndex)) {
            var meta = chart.getDatasetMeta(datasetIndex);
            helpers$1.each(dataset.data, function (rawValue, index) {
              var value = +me.getRightValue(rawValue);
              if (isNaN(value) || meta.data[index].hidden) {
                return;
              }
              min = Math.min(value, min);
              max = Math.max(value, max);
            });
          }
        });
        me.min = min === Number.POSITIVE_INFINITY ? 0 : min;
        me.max = max === Number.NEGATIVE_INFINITY ? 0 : max;
        me.handleTickRangeOptions();
      },
      _computeTickLimit: function _computeTickLimit() {
        return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
      },
      convertTicksToLabels: function convertTicksToLabels() {
        var me = this;
        scale_linearbase.prototype.convertTicksToLabels.call(me);
        me.pointLabels = me.chart.data.labels.map(function () {
          var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
          return label || label === 0 ? label : '';
        });
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
      },
      fit: function fit() {
        var me = this;
        var opts = me.options;
        if (opts.display && opts.pointLabels.display) {
          fitWithPointLabels(me);
        } else {
          me.setCenterPoint(0, 0, 0, 0);
        }
      },
      setReductions: function setReductions(largestPossibleRadius, furthestLimits, furthestAngles) {
        var me = this;
        var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
        var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
        var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
        var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
        radiusReductionLeft = numberOrZero(radiusReductionLeft);
        radiusReductionRight = numberOrZero(radiusReductionRight);
        radiusReductionTop = numberOrZero(radiusReductionTop);
        radiusReductionBottom = numberOrZero(radiusReductionBottom);
        me.drawingArea = Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
        me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
      },
      setCenterPoint: function setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        var me = this;
        var maxRight = me.width - rightMovement - me.drawingArea;
        var maxLeft = leftMovement + me.drawingArea;
        var maxTop = topMovement + me.drawingArea;
        var maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;
        me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
        me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
      },
      getIndexAngle: function getIndexAngle(index) {
        var chart = this.chart;
        var angleMultiplier = 360 / chart.data.labels.length;
        var options = chart.options || {};
        var startAngle = options.startAngle || 0;
        var angle = (index * angleMultiplier + startAngle) % 360;
        return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
      },
      getDistanceFromCenterForValue: function getDistanceFromCenterForValue(value) {
        var me = this;
        if (helpers$1.isNullOrUndef(value)) {
          return NaN;
        }
        var scalingFactor = me.drawingArea / (me.max - me.min);
        if (me.options.ticks.reverse) {
          return (me.max - value) * scalingFactor;
        }
        return (value - me.min) * scalingFactor;
      },
      getPointPosition: function getPointPosition(index, distanceFromCenter) {
        var me = this;
        var thisAngle = me.getIndexAngle(index) - Math.PI / 2;
        return {
          x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
          y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
        };
      },
      getPointPositionForValue: function getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
      },
      getBasePosition: function getBasePosition(index) {
        var me = this;
        var min = me.min;
        var max = me.max;
        return me.getPointPositionForValue(index || 0, me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0);
      },
      _drawGrid: function _drawGrid() {
        var me = this;
        var ctx = me.ctx;
        var opts = me.options;
        var gridLineOpts = opts.gridLines;
        var angleLineOpts = opts.angleLines;
        var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
        var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
        var i, offset, position;
        if (opts.pointLabels.display) {
          drawPointLabels(me);
        }
        if (gridLineOpts.display) {
          helpers$1.each(me.ticks, function (label, index) {
            if (index !== 0) {
              offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
              drawRadiusLine(me, gridLineOpts, offset, index);
            }
          });
        }
        if (angleLineOpts.display && lineWidth && lineColor) {
          ctx.save();
          ctx.lineWidth = lineWidth;
          ctx.strokeStyle = lineColor;
          if (ctx.setLineDash) {
            ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
            ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
          }
          for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
            offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
            position = me.getPointPosition(i, offset);
            ctx.beginPath();
            ctx.moveTo(me.xCenter, me.yCenter);
            ctx.lineTo(position.x, position.y);
            ctx.stroke();
          }
          ctx.restore();
        }
      },
      _drawLabels: function _drawLabels() {
        var me = this;
        var ctx = me.ctx;
        var opts = me.options;
        var tickOpts = opts.ticks;
        if (!tickOpts.display) {
          return;
        }
        var startAngle = me.getIndexAngle(0);
        var tickFont = helpers$1.options._parseFont(tickOpts);
        var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
        var offset, width;
        ctx.save();
        ctx.font = tickFont.string;
        ctx.translate(me.xCenter, me.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        helpers$1.each(me.ticks, function (label, index) {
          if (index === 0 && !tickOpts.reverse) {
            return;
          }
          offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
          if (tickOpts.showLabelBackdrop) {
            width = ctx.measureText(label).width;
            ctx.fillStyle = tickOpts.backdropColor;
            ctx.fillRect(-width / 2 - tickOpts.backdropPaddingX, -offset - tickFont.size / 2 - tickOpts.backdropPaddingY, width + tickOpts.backdropPaddingX * 2, tickFont.size + tickOpts.backdropPaddingY * 2);
          }
          ctx.fillStyle = tickFontColor;
          ctx.fillText(label, 0, -offset);
        });
        ctx.restore();
      },
      _drawTitle: helpers$1.noop
    });
    var _defaults$3 = defaultConfig$3;
    scale_radialLinear._defaults = _defaults$3;
    var deprecated$1 = helpers$1._deprecated;
    var resolve$5 = helpers$1.options.resolve;
    var valueOrDefault$d = helpers$1.valueOrDefault;
    var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
    var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
    var INTERVALS = {
      millisecond: {
        common: true,
        size: 1,
        steps: 1000
      },
      second: {
        common: true,
        size: 1000,
        steps: 60
      },
      minute: {
        common: true,
        size: 60000,
        steps: 60
      },
      hour: {
        common: true,
        size: 3600000,
        steps: 24
      },
      day: {
        common: true,
        size: 86400000,
        steps: 30
      },
      week: {
        common: false,
        size: 604800000,
        steps: 4
      },
      month: {
        common: true,
        size: 2.628e9,
        steps: 12
      },
      quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
      },
      year: {
        common: true,
        size: 3.154e10
      }
    };
    var UNITS = Object.keys(INTERVALS);
    function sorter(a, b) {
      return a - b;
    }
    function arrayUnique(items) {
      var hash = {};
      var out = [];
      var i, ilen, item;
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        item = items[i];
        if (!hash[item]) {
          hash[item] = true;
          out.push(item);
        }
      }
      return out;
    }
    function getMin(options) {
      return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
    }
    function getMax(options) {
      return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
    }
    function buildLookupTable(timestamps, min, max, distribution) {
      if (distribution === 'linear' || !timestamps.length) {
        return [{
          time: min,
          pos: 0
        }, {
          time: max,
          pos: 1
        }];
      }
      var table = [];
      var items = [min];
      var i, ilen, prev, curr, next;
      for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
        curr = timestamps[i];
        if (curr > min && curr < max) {
          items.push(curr);
        }
      }
      items.push(max);
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        next = items[i + 1];
        prev = items[i - 1];
        curr = items[i];
        if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
          table.push({
            time: curr,
            pos: i / (ilen - 1)
          });
        }
      }
      return table;
    }
    function lookup(table, key, value) {
      var lo = 0;
      var hi = table.length - 1;
      var mid, i0, i1;
      while (lo >= 0 && lo <= hi) {
        mid = lo + hi >> 1;
        i0 = table[mid - 1] || null;
        i1 = table[mid];
        if (!i0) {
          return {
            lo: null,
            hi: i1
          };
        } else if (i1[key] < value) {
          lo = mid + 1;
        } else if (i0[key] > value) {
          hi = mid - 1;
        } else {
          return {
            lo: i0,
            hi: i1
          };
        }
      }
      return {
        lo: i1,
        hi: null
      };
    }
    function interpolate$1(table, skey, sval, tkey) {
      var range = lookup(table, skey, sval);
      var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
      var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
      var span = next[skey] - prev[skey];
      var ratio = span ? (sval - prev[skey]) / span : 0;
      var offset = (next[tkey] - prev[tkey]) * ratio;
      return prev[tkey] + offset;
    }
    function toTimestamp(scale, input) {
      var adapter = scale._adapter;
      var options = scale.options.time;
      var parser = options.parser;
      var format = parser || options.format;
      var value = input;
      if (typeof parser === 'function') {
        value = parser(value);
      }
      if (!helpers$1.isFinite(value)) {
        value = typeof format === 'string' ? adapter.parse(value, format) : adapter.parse(value);
      }
      if (value !== null) {
        return +value;
      }
      if (!parser && typeof format === 'function') {
        value = format(input);
        if (!helpers$1.isFinite(value)) {
          value = adapter.parse(value);
        }
      }
      return value;
    }
    function parse(scale, input) {
      if (helpers$1.isNullOrUndef(input)) {
        return null;
      }
      var options = scale.options.time;
      var value = toTimestamp(scale, scale.getRightValue(input));
      if (value === null) {
        return value;
      }
      if (options.round) {
        value = +scale._adapter.startOf(value, options.round);
      }
      return value;
    }
    function determineUnitForAutoTicks(minUnit, min, max, capacity) {
      var ilen = UNITS.length;
      var i, interval, factor;
      for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
        interval = INTERVALS[UNITS[i]];
        factor = interval.steps ? interval.steps : MAX_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
          return UNITS[i];
        }
      }
      return UNITS[ilen - 1];
    }
    function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
      var i, unit;
      for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
        unit = UNITS[i];
        if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
          return unit;
        }
      }
      return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
    }
    function determineMajorUnit(unit) {
      for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
        if (INTERVALS[UNITS[i]].common) {
          return UNITS[i];
        }
      }
    }
    function generate(scale, min, max, capacity) {
      var adapter = scale._adapter;
      var options = scale.options;
      var timeOpts = options.time;
      var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
      var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
      var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
      var first = min;
      var ticks = [];
      var time;
      if (weekday) {
        first = +adapter.startOf(first, 'isoWeek', weekday);
      }
      first = +adapter.startOf(first, weekday ? 'day' : minor);
      if (adapter.diff(max, min, minor) > 100000 * stepSize) {
        throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
      }
      for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
        ticks.push(time);
      }
      if (time === max || options.bounds === 'ticks') {
        ticks.push(time);
      }
      return ticks;
    }
    function computeOffsets(table, ticks, min, max, options) {
      var start = 0;
      var end = 0;
      var first, last;
      if (options.offset && ticks.length) {
        first = interpolate$1(table, 'time', ticks[0], 'pos');
        if (ticks.length === 1) {
          start = 1 - first;
        } else {
          start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
        }
        last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
        if (ticks.length === 1) {
          end = last;
        } else {
          end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
        }
      }
      return {
        start: start,
        end: end,
        factor: 1 / (start + 1 + end)
      };
    }
    function setMajorTicks(scale, ticks, map, majorUnit) {
      var adapter = scale._adapter;
      var first = +adapter.startOf(ticks[0].value, majorUnit);
      var last = ticks[ticks.length - 1].value;
      var major, index;
      for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
        index = map[major];
        if (index >= 0) {
          ticks[index].major = true;
        }
      }
      return ticks;
    }
    function ticksFromTimestamps(scale, values, majorUnit) {
      var ticks = [];
      var map = {};
      var ilen = values.length;
      var i, value;
      for (i = 0; i < ilen; ++i) {
        value = values[i];
        map[value] = i;
        ticks.push({
          value: value,
          major: false
        });
      }
      return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
    }
    var defaultConfig$4 = {
      position: 'bottom',
      distribution: 'linear',
      bounds: 'data',
      adapters: {},
      time: {
        parser: false,
        unit: false,
        round: false,
        displayFormat: false,
        isoWeekday: false,
        minUnit: 'millisecond',
        displayFormats: {}
      },
      ticks: {
        autoSkip: false,
        source: 'auto',
        major: {
          enabled: false
        }
      }
    };
    var scale_time = core_scale.extend({
      initialize: function initialize() {
        this.mergeTicksOptions();
        core_scale.prototype.initialize.call(this);
      },
      update: function update() {
        var me = this;
        var options = me.options;
        var time = options.time || (options.time = {});
        var adapter = me._adapter = new core_adapters._date(options.adapters.date);
        deprecated$1('time scale', time.format, 'time.format', 'time.parser');
        deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
        deprecated$1('time scale', time.max, 'time.max', 'ticks.max');
        helpers$1.mergeIf(time.displayFormats, adapter.formats());
        return core_scale.prototype.update.apply(me, arguments);
      },
      getRightValue: function getRightValue(rawValue) {
        if (rawValue && rawValue.t !== undefined) {
          rawValue = rawValue.t;
        }
        return core_scale.prototype.getRightValue.call(this, rawValue);
      },
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var chart = me.chart;
        var adapter = me._adapter;
        var options = me.options;
        var unit = options.time.unit || 'day';
        var min = MAX_INTEGER;
        var max = MIN_INTEGER;
        var timestamps = [];
        var datasets = [];
        var labels = [];
        var i, j, ilen, jlen, data, timestamp, labelsAdded;
        var dataLabels = me._getLabels();
        for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
          labels.push(parse(me, dataLabels[i]));
        }
        for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
          if (chart.isDatasetVisible(i)) {
            data = chart.data.datasets[i].data;
            if (helpers$1.isObject(data[0])) {
              datasets[i] = [];
              for (j = 0, jlen = data.length; j < jlen; ++j) {
                timestamp = parse(me, data[j]);
                timestamps.push(timestamp);
                datasets[i][j] = timestamp;
              }
            } else {
              datasets[i] = labels.slice(0);
              if (!labelsAdded) {
                timestamps = timestamps.concat(labels);
                labelsAdded = true;
              }
            }
          } else {
            datasets[i] = [];
          }
        }
        if (labels.length) {
          min = Math.min(min, labels[0]);
          max = Math.max(max, labels[labels.length - 1]);
        }
        if (timestamps.length) {
          timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
          min = Math.min(min, timestamps[0]);
          max = Math.max(max, timestamps[timestamps.length - 1]);
        }
        min = parse(me, getMin(options)) || min;
        max = parse(me, getMax(options)) || max;
        min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
        max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
        me.min = Math.min(min, max);
        me.max = Math.max(min + 1, max);
        me._table = [];
        me._timestamps = {
          data: timestamps,
          datasets: datasets,
          labels: labels
        };
      },
      buildTicks: function buildTicks() {
        var me = this;
        var min = me.min;
        var max = me.max;
        var options = me.options;
        var tickOpts = options.ticks;
        var timeOpts = options.time;
        var timestamps = me._timestamps;
        var ticks = [];
        var capacity = me.getLabelCapacity(min);
        var source = tickOpts.source;
        var distribution = options.distribution;
        var i, ilen, timestamp;
        if (source === 'data' || source === 'auto' && distribution === 'series') {
          timestamps = timestamps.data;
        } else if (source === 'labels') {
          timestamps = timestamps.labels;
        } else {
          timestamps = generate(me, min, max, capacity);
        }
        if (options.bounds === 'ticks' && timestamps.length) {
          min = timestamps[0];
          max = timestamps[timestamps.length - 1];
        }
        min = parse(me, getMin(options)) || min;
        max = parse(me, getMax(options)) || max;
        for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
          timestamp = timestamps[i];
          if (timestamp >= min && timestamp <= max) {
            ticks.push(timestamp);
          }
        }
        me.min = min;
        me.max = max;
        me._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity) : determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
        me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined : determineMajorUnit(me._unit);
        me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
        me._offsets = computeOffsets(me._table, ticks, min, max, options);
        if (tickOpts.reverse) {
          ticks.reverse();
        }
        return ticksFromTimestamps(me, ticks, me._majorUnit);
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        var me = this;
        var adapter = me._adapter;
        var data = me.chart.data;
        var timeOpts = me.options.time;
        var label = data.labels && index < data.labels.length ? data.labels[index] : '';
        var value = data.datasets[datasetIndex].data[index];
        if (helpers$1.isObject(value)) {
          label = me.getRightValue(value);
        }
        if (timeOpts.tooltipFormat) {
          return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
        }
        if (typeof label === 'string') {
          return label;
        }
        return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
      },
      tickFormatFunction: function tickFormatFunction(time, index, ticks, format) {
        var me = this;
        var adapter = me._adapter;
        var options = me.options;
        var formats = options.time.displayFormats;
        var minorFormat = formats[me._unit];
        var majorUnit = me._majorUnit;
        var majorFormat = formats[majorUnit];
        var tick = ticks[index];
        var tickOpts = options.ticks;
        var major = majorUnit && majorFormat && tick && tick.major;
        var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
        var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
        var formatter = resolve$5([nestedTickOpts.callback, nestedTickOpts.userCallback, tickOpts.callback, tickOpts.userCallback]);
        return formatter ? formatter(label, index, ticks) : label;
      },
      convertTicksToLabels: function convertTicksToLabels(ticks) {
        var labels = [];
        var i, ilen;
        for (i = 0, ilen = ticks.length; i < ilen; ++i) {
          labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
        }
        return labels;
      },
      getPixelForOffset: function getPixelForOffset(time) {
        var me = this;
        var offsets = me._offsets;
        var pos = interpolate$1(me._table, 'time', time, 'pos');
        return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
      },
      getPixelForValue: function getPixelForValue(value, index, datasetIndex) {
        var me = this;
        var time = null;
        if (index !== undefined && datasetIndex !== undefined) {
          time = me._timestamps.datasets[datasetIndex][index];
        }
        if (time === null) {
          time = parse(me, value);
        }
        if (time !== null) {
          return me.getPixelForOffset(time);
        }
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.getTicks();
        return index >= 0 && index < ticks.length ? this.getPixelForOffset(ticks[index].value) : null;
      },
      getValueForPixel: function getValueForPixel(pixel) {
        var me = this;
        var offsets = me._offsets;
        var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        var time = interpolate$1(me._table, 'pos', pos, 'time');
        return me._adapter._create(time);
      },
      _getLabelSize: function _getLabelSize(label) {
        var me = this;
        var ticksOpts = me.options.ticks;
        var tickLabelWidth = me.ctx.measureText(label).width;
        var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        var cosRotation = Math.cos(angle);
        var sinRotation = Math.sin(angle);
        var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
        return {
          w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
          h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
      },
      getLabelWidth: function getLabelWidth(label) {
        return this._getLabelSize(label).w;
      },
      getLabelCapacity: function getLabelCapacity(exampleTime) {
        var me = this;
        var timeOpts = me.options.time;
        var displayFormats = timeOpts.displayFormats;
        var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
        var size = me._getLabelSize(exampleLabel);
        var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
        if (me.options.offset) {
          capacity--;
        }
        return capacity > 0 ? capacity : 1;
      }
    });
    var _defaults$4 = defaultConfig$4;
    scale_time._defaults = _defaults$4;
    var scales = {
      category: scale_category,
      linear: scale_linear,
      logarithmic: scale_logarithmic,
      radialLinear: scale_radialLinear,
      time: scale_time
    };
    var FORMATS = {
      datetime: 'MMM D, YYYY, h:mm:ss a',
      millisecond: 'h:mm:ss.SSS a',
      second: 'h:mm:ss a',
      minute: 'h:mm a',
      hour: 'hA',
      day: 'MMM D',
      week: 'll',
      month: 'MMM YYYY',
      quarter: '[Q]Q - YYYY',
      year: 'YYYY'
    };
    core_adapters._date.override(typeof moment === 'function' ? {
      _id: 'moment',
      formats: function formats() {
        return FORMATS;
      },
      parse: function parse(value, format) {
        if (typeof value === 'string' && typeof format === 'string') {
          value = moment(value, format);
        } else if (!(value instanceof moment)) {
          value = moment(value);
        }
        return value.isValid() ? value.valueOf() : null;
      },
      format: function format(time, _format) {
        return moment(time).format(_format);
      },
      add: function add(time, amount, unit) {
        return moment(time).add(amount, unit).valueOf();
      },
      diff: function diff(max, min, unit) {
        return moment(max).diff(moment(min), unit);
      },
      startOf: function startOf(time, unit, weekday) {
        time = moment(time);
        if (unit === 'isoWeek') {
          return time.isoWeekday(weekday).valueOf();
        }
        return time.startOf(unit).valueOf();
      },
      endOf: function endOf(time, unit) {
        return moment(time).endOf(unit).valueOf();
      },
      _create: function _create(time) {
        return moment(time);
      }
    } : {});
    core_defaults._set('global', {
      plugins: {
        filler: {
          propagate: true
        }
      }
    });
    var mappers = {
      dataset: function dataset(source) {
        var index = source.fill;
        var chart = source.chart;
        var meta = chart.getDatasetMeta(index);
        var visible = meta && chart.isDatasetVisible(index);
        var points = visible && meta.dataset._children || [];
        var length = points.length || 0;
        return !length ? null : function (point, i) {
          return i < length && points[i]._view || null;
        };
      },
      boundary: function boundary(source) {
        var boundary = source.boundary;
        var x = boundary ? boundary.x : null;
        var y = boundary ? boundary.y : null;
        if (helpers$1.isArray(boundary)) {
          return function (point, i) {
            return boundary[i];
          };
        }
        return function (point) {
          return {
            x: x === null ? point.x : x,
            y: y === null ? point.y : y
          };
        };
      }
    };
    function decodeFill(el, index, count) {
      var model = el._model || {};
      var fill = model.fill;
      var target;
      if (fill === undefined) {
        fill = !!model.backgroundColor;
      }
      if (fill === false || fill === null) {
        return false;
      }
      if (fill === true) {
        return 'origin';
      }
      target = parseFloat(fill, 10);
      if (isFinite(target) && Math.floor(target) === target) {
        if (fill[0] === '-' || fill[0] === '+') {
          target = index + target;
        }
        if (target === index || target < 0 || target >= count) {
          return false;
        }
        return target;
      }
      switch (fill) {
        case 'bottom':
          return 'start';
        case 'top':
          return 'end';
        case 'zero':
          return 'origin';
        case 'origin':
        case 'start':
        case 'end':
          return fill;
        default:
          return false;
      }
    }
    function computeLinearBoundary(source) {
      var model = source.el._model || {};
      var scale = source.el._scale || {};
      var fill = source.fill;
      var target = null;
      var horizontal;
      if (isFinite(fill)) {
        return null;
      }
      if (fill === 'start') {
        target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
      } else if (fill === 'end') {
        target = model.scaleTop === undefined ? scale.top : model.scaleTop;
      } else if (model.scaleZero !== undefined) {
        target = model.scaleZero;
      } else if (scale.getBasePixel) {
        target = scale.getBasePixel();
      }
      if (target !== undefined && target !== null) {
        if (target.x !== undefined && target.y !== undefined) {
          return target;
        }
        if (helpers$1.isFinite(target)) {
          horizontal = scale.isHorizontal();
          return {
            x: horizontal ? target : null,
            y: horizontal ? null : target
          };
        }
      }
      return null;
    }
    function computeCircularBoundary(source) {
      var scale = source.el._scale;
      var options = scale.options;
      var length = scale.chart.data.labels.length;
      var fill = source.fill;
      var target = [];
      var start, end, center, i, point;
      if (!length) {
        return null;
      }
      start = options.ticks.reverse ? scale.max : scale.min;
      end = options.ticks.reverse ? scale.min : scale.max;
      center = scale.getPointPositionForValue(0, start);
      for (i = 0; i < length; ++i) {
        point = fill === 'start' || fill === 'end' ? scale.getPointPositionForValue(i, fill === 'start' ? start : end) : scale.getBasePosition(i);
        if (options.gridLines.circular) {
          point.cx = center.x;
          point.cy = center.y;
          point.angle = scale.getIndexAngle(i) - Math.PI / 2;
        }
        target.push(point);
      }
      return target;
    }
    function computeBoundary(source) {
      var scale = source.el._scale || {};
      if (scale.getPointPositionForValue) {
        return computeCircularBoundary(source);
      }
      return computeLinearBoundary(source);
    }
    function resolveTarget(sources, index, propagate) {
      var source = sources[index];
      var fill = source.fill;
      var visited = [index];
      var target;
      if (!propagate) {
        return fill;
      }
      while (fill !== false && visited.indexOf(fill) === -1) {
        if (!isFinite(fill)) {
          return fill;
        }
        target = sources[fill];
        if (!target) {
          return false;
        }
        if (target.visible) {
          return fill;
        }
        visited.push(fill);
        fill = target.fill;
      }
      return false;
    }
    function createMapper(source) {
      var fill = source.fill;
      var type = 'dataset';
      if (fill === false) {
        return null;
      }
      if (!isFinite(fill)) {
        type = 'boundary';
      }
      return mappers[type](source);
    }
    function isDrawable(point) {
      return point && !point.skip;
    }
    function drawArea(ctx, curve0, curve1, len0, len1) {
      var i, cx, cy, r;
      if (!len0 || !len1) {
        return;
      }
      ctx.moveTo(curve0[0].x, curve0[0].y);
      for (i = 1; i < len0; ++i) {
        helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
      }
      if (curve1[0].angle !== undefined) {
        cx = curve1[0].cx;
        cy = curve1[0].cy;
        r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
        for (i = len1 - 1; i > 0; --i) {
          ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
        }
        return;
      }
      ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
      for (i = len1 - 1; i > 0; --i) {
        helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
      }
    }
    function doFill(ctx, points, mapper, view, color, loop) {
      var count = points.length;
      var span = view.spanGaps;
      var curve0 = [];
      var curve1 = [];
      var len0 = 0;
      var len1 = 0;
      var i, ilen, index, p0, p1, d0, d1, loopOffset;
      ctx.beginPath();
      for (i = 0, ilen = count; i < ilen; ++i) {
        index = i % count;
        p0 = points[index]._view;
        p1 = mapper(p0, index, view);
        d0 = isDrawable(p0);
        d1 = isDrawable(p1);
        if (loop && loopOffset === undefined && d0) {
          loopOffset = i + 1;
          ilen = count + loopOffset;
        }
        if (d0 && d1) {
          len0 = curve0.push(p0);
          len1 = curve1.push(p1);
        } else if (len0 && len1) {
          if (!span) {
            drawArea(ctx, curve0, curve1, len0, len1);
            len0 = len1 = 0;
            curve0 = [];
            curve1 = [];
          } else {
            if (d0) {
              curve0.push(p0);
            }
            if (d1) {
              curve1.push(p1);
            }
          }
        }
      }
      drawArea(ctx, curve0, curve1, len0, len1);
      ctx.closePath();
      ctx.fillStyle = color;
      ctx.fill();
    }
    var plugin_filler = {
      id: 'filler',
      afterDatasetsUpdate: function afterDatasetsUpdate(chart, options) {
        var count = (chart.data.datasets || []).length;
        var propagate = options.propagate;
        var sources = [];
        var meta, i, el, source;
        for (i = 0; i < count; ++i) {
          meta = chart.getDatasetMeta(i);
          el = meta.dataset;
          source = null;
          if (el && el._model && el instanceof elements.Line) {
            source = {
              visible: chart.isDatasetVisible(i),
              fill: decodeFill(el, i, count),
              chart: chart,
              el: el
            };
          }
          meta.$filler = source;
          sources.push(source);
        }
        for (i = 0; i < count; ++i) {
          source = sources[i];
          if (!source) {
            continue;
          }
          source.fill = resolveTarget(sources, i, propagate);
          source.boundary = computeBoundary(source);
          source.mapper = createMapper(source);
        }
      },
      beforeDatasetsDraw: function beforeDatasetsDraw(chart) {
        var metasets = chart._getSortedVisibleDatasetMetas();
        var ctx = chart.ctx;
        var meta, i, el, view, points, mapper, color;
        for (i = metasets.length - 1; i >= 0; --i) {
          meta = metasets[i].$filler;
          if (!meta || !meta.visible) {
            continue;
          }
          el = meta.el;
          view = el._view;
          points = el._children || [];
          mapper = meta.mapper;
          color = view.backgroundColor || core_defaults.global.defaultColor;
          if (mapper && color && points.length) {
            helpers$1.canvas.clipArea(ctx, chart.chartArea);
            doFill(ctx, points, mapper, view, color, el._loop);
            helpers$1.canvas.unclipArea(ctx);
          }
        }
      }
    };
    var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
    var noop$1 = helpers$1.noop;
    var valueOrDefault$e = helpers$1.valueOrDefault;
    core_defaults._set('global', {
      legend: {
        display: true,
        position: 'top',
        align: 'center',
        fullWidth: true,
        reverse: false,
        weight: 1000,
        onClick: function onClick(e, legendItem) {
          var index = legendItem.datasetIndex;
          var ci = this.chart;
          var meta = ci.getDatasetMeta(index);
          meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
          ci.update();
        },
        onHover: null,
        onLeave: null,
        labels: {
          boxWidth: 40,
          padding: 10,
          generateLabels: function generateLabels(chart) {
            var datasets = chart.data.datasets;
            var options = chart.options.legend || {};
            var usePointStyle = options.labels && options.labels.usePointStyle;
            return chart._getSortedDatasetMetas().map(function (meta) {
              var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
              return {
                text: datasets[meta.index].label,
                fillStyle: style.backgroundColor,
                hidden: !chart.isDatasetVisible(meta.index),
                lineCap: style.borderCapStyle,
                lineDash: style.borderDash,
                lineDashOffset: style.borderDashOffset,
                lineJoin: style.borderJoinStyle,
                lineWidth: style.borderWidth,
                strokeStyle: style.borderColor,
                pointStyle: style.pointStyle,
                rotation: style.rotation,
                datasetIndex: meta.index
              };
            }, this);
          }
        }
      },
      legendCallback: function legendCallback(chart) {
        var list = document.createElement('ul');
        var datasets = chart.data.datasets;
        var i, ilen, listItem, listItemSpan;
        list.setAttribute('class', chart.id + '-legend');
        for (i = 0, ilen = datasets.length; i < ilen; i++) {
          listItem = list.appendChild(document.createElement('li'));
          listItemSpan = listItem.appendChild(document.createElement('span'));
          listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
          if (datasets[i].label) {
            listItem.appendChild(document.createTextNode(datasets[i].label));
          }
        }
        return list.outerHTML;
      }
    });
    function getBoxWidth(labelOpts, fontSize) {
      return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ? fontSize : labelOpts.boxWidth;
    }
    var Legend = core_element.extend({
      initialize: function initialize(config) {
        var me = this;
        helpers$1.extend(me, config);
        me.legendHitBoxes = [];
        me._hoveredItem = null;
        me.doughnutMode = false;
      },
      beforeUpdate: noop$1,
      update: function update(maxWidth, maxHeight, margins) {
        var me = this;
        me.beforeUpdate();
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me.margins = margins;
        me.beforeSetDimensions();
        me.setDimensions();
        me.afterSetDimensions();
        me.beforeBuildLabels();
        me.buildLabels();
        me.afterBuildLabels();
        me.beforeFit();
        me.fit();
        me.afterFit();
        me.afterUpdate();
        return me.minSize;
      },
      afterUpdate: noop$1,
      beforeSetDimensions: noop$1,
      setDimensions: function setDimensions() {
        var me = this;
        if (me.isHorizontal()) {
          me.width = me.maxWidth;
          me.left = 0;
          me.right = me.width;
        } else {
          me.height = me.maxHeight;
          me.top = 0;
          me.bottom = me.height;
        }
        me.paddingLeft = 0;
        me.paddingTop = 0;
        me.paddingRight = 0;
        me.paddingBottom = 0;
        me.minSize = {
          width: 0,
          height: 0
        };
      },
      afterSetDimensions: noop$1,
      beforeBuildLabels: noop$1,
      buildLabels: function buildLabels() {
        var me = this;
        var labelOpts = me.options.labels || {};
        var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];
        if (labelOpts.filter) {
          legendItems = legendItems.filter(function (item) {
            return labelOpts.filter(item, me.chart.data);
          });
        }
        if (me.options.reverse) {
          legendItems.reverse();
        }
        me.legendItems = legendItems;
      },
      afterBuildLabels: noop$1,
      beforeFit: noop$1,
      fit: function fit() {
        var me = this;
        var opts = me.options;
        var labelOpts = opts.labels;
        var display = opts.display;
        var ctx = me.ctx;
        var labelFont = helpers$1.options._parseFont(labelOpts);
        var fontSize = labelFont.size;
        var hitboxes = me.legendHitBoxes = [];
        var minSize = me.minSize;
        var isHorizontal = me.isHorizontal();
        if (isHorizontal) {
          minSize.width = me.maxWidth;
          minSize.height = display ? 10 : 0;
        } else {
          minSize.width = display ? 10 : 0;
          minSize.height = me.maxHeight;
        }
        if (!display) {
          me.width = minSize.width = me.height = minSize.height = 0;
          return;
        }
        ctx.font = labelFont.string;
        if (isHorizontal) {
          var lineWidths = me.lineWidths = [0];
          var totalHeight = 0;
          ctx.textAlign = 'left';
          ctx.textBaseline = 'middle';
          helpers$1.each(me.legendItems, function (legendItem, i) {
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var width = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
              totalHeight += fontSize + labelOpts.padding;
              lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
            }
            hitboxes[i] = {
              left: 0,
              top: 0,
              width: width,
              height: fontSize
            };
            lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
          });
          minSize.height += totalHeight;
        } else {
          var vPadding = labelOpts.padding;
          var columnWidths = me.columnWidths = [];
          var columnHeights = me.columnHeights = [];
          var totalWidth = labelOpts.padding;
          var currentColWidth = 0;
          var currentColHeight = 0;
          helpers$1.each(me.legendItems, function (legendItem, i) {
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
              totalWidth += currentColWidth + labelOpts.padding;
              columnWidths.push(currentColWidth);
              columnHeights.push(currentColHeight);
              currentColWidth = 0;
              currentColHeight = 0;
            }
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += fontSize + vPadding;
            hitboxes[i] = {
              left: 0,
              top: 0,
              width: itemWidth,
              height: fontSize
            };
          });
          totalWidth += currentColWidth;
          columnWidths.push(currentColWidth);
          columnHeights.push(currentColHeight);
          minSize.width += totalWidth;
        }
        me.width = minSize.width;
        me.height = minSize.height;
      },
      afterFit: noop$1,
      isHorizontal: function isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
      },
      draw: function draw() {
        var me = this;
        var opts = me.options;
        var labelOpts = opts.labels;
        var globalDefaults = core_defaults.global;
        var defaultColor = globalDefaults.defaultColor;
        var lineDefault = globalDefaults.elements.line;
        var legendHeight = me.height;
        var columnHeights = me.columnHeights;
        var legendWidth = me.width;
        var lineWidths = me.lineWidths;
        if (!opts.display) {
          return;
        }
        var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
        var ctx = me.ctx;
        var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
        var labelFont = helpers$1.options._parseFont(labelOpts);
        var fontSize = labelFont.size;
        var cursor;
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.strokeStyle = fontColor;
        ctx.fillStyle = fontColor;
        ctx.font = labelFont.string;
        var boxWidth = getBoxWidth(labelOpts, fontSize);
        var hitboxes = me.legendHitBoxes;
        var drawLegendBox = function drawLegendBox(x, y, legendItem) {
          if (isNaN(boxWidth) || boxWidth <= 0) {
            return;
          }
          ctx.save();
          var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
          ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
          ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
          ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
          ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
          ctx.lineWidth = lineWidth;
          ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
          if (ctx.setLineDash) {
            ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
          }
          if (labelOpts && labelOpts.usePointStyle) {
            var radius = boxWidth * Math.SQRT2 / 2;
            var centerX = rtlHelper.xPlus(x, boxWidth / 2);
            var centerY = y + fontSize / 2;
            helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
          } else {
            ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
            if (lineWidth !== 0) {
              ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
            }
          }
          ctx.restore();
        };
        var fillText = function fillText(x, y, legendItem, textWidth) {
          var halfFontSize = fontSize / 2;
          var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
          var yMiddle = y + halfFontSize;
          ctx.fillText(legendItem.text, xLeft, yMiddle);
          if (legendItem.hidden) {
            ctx.beginPath();
            ctx.lineWidth = 2;
            ctx.moveTo(xLeft, yMiddle);
            ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
            ctx.stroke();
          }
        };
        var alignmentOffset = function alignmentOffset(dimension, blockSize) {
          switch (opts.align) {
            case 'start':
              return labelOpts.padding;
            case 'end':
              return dimension - blockSize;
            default:
              return (dimension - blockSize + labelOpts.padding) / 2;
          }
        };
        var isHorizontal = me.isHorizontal();
        if (isHorizontal) {
          cursor = {
            x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
            y: me.top + labelOpts.padding,
            line: 0
          };
        } else {
          cursor = {
            x: me.left + labelOpts.padding,
            y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
            line: 0
          };
        }
        helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
        var itemHeight = fontSize + labelOpts.padding;
        helpers$1.each(me.legendItems, function (legendItem, i) {
          var textWidth = ctx.measureText(legendItem.text).width;
          var width = boxWidth + fontSize / 2 + textWidth;
          var x = cursor.x;
          var y = cursor.y;
          rtlHelper.setWidth(me.minSize.width);
          if (isHorizontal) {
            if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
              y = cursor.y += itemHeight;
              cursor.line++;
              x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
            }
          } else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
            x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
            cursor.line++;
            y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
          }
          var realX = rtlHelper.x(x);
          drawLegendBox(realX, y, legendItem);
          hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
          hitboxes[i].top = y;
          fillText(realX, y, legendItem, textWidth);
          if (isHorizontal) {
            cursor.x += width + labelOpts.padding;
          } else {
            cursor.y += itemHeight;
          }
        });
        helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
      },
      _getLegendItemAt: function _getLegendItemAt(x, y) {
        var me = this;
        var i, hitBox, lh;
        if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
          lh = me.legendHitBoxes;
          for (i = 0; i < lh.length; ++i) {
            hitBox = lh[i];
            if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
              return me.legendItems[i];
            }
          }
        }
        return null;
      },
      handleEvent: function handleEvent(e) {
        var me = this;
        var opts = me.options;
        var type = e.type === 'mouseup' ? 'click' : e.type;
        var hoveredItem;
        if (type === 'mousemove') {
          if (!opts.onHover && !opts.onLeave) {
            return;
          }
        } else if (type === 'click') {
          if (!opts.onClick) {
            return;
          }
        } else {
          return;
        }
        hoveredItem = me._getLegendItemAt(e.x, e.y);
        if (type === 'click') {
          if (hoveredItem && opts.onClick) {
            opts.onClick.call(me, e["native"], hoveredItem);
          }
        } else {
          if (opts.onLeave && hoveredItem !== me._hoveredItem) {
            if (me._hoveredItem) {
              opts.onLeave.call(me, e["native"], me._hoveredItem);
            }
            me._hoveredItem = hoveredItem;
          }
          if (opts.onHover && hoveredItem) {
            opts.onHover.call(me, e["native"], hoveredItem);
          }
        }
      }
    });
    function createNewLegendAndAttach(chart, legendOpts) {
      var legend = new Legend({
        ctx: chart.ctx,
        options: legendOpts,
        chart: chart
      });
      core_layouts.configure(chart, legend, legendOpts);
      core_layouts.addBox(chart, legend);
      chart.legend = legend;
    }
    var plugin_legend = {
      id: 'legend',
      _element: Legend,
      beforeInit: function beforeInit(chart) {
        var legendOpts = chart.options.legend;
        if (legendOpts) {
          createNewLegendAndAttach(chart, legendOpts);
        }
      },
      beforeUpdate: function beforeUpdate(chart) {
        var legendOpts = chart.options.legend;
        var legend = chart.legend;
        if (legendOpts) {
          helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
          if (legend) {
            core_layouts.configure(chart, legend, legendOpts);
            legend.options = legendOpts;
          } else {
            createNewLegendAndAttach(chart, legendOpts);
          }
        } else if (legend) {
          core_layouts.removeBox(chart, legend);
          delete chart.legend;
        }
      },
      afterEvent: function afterEvent(chart, e) {
        var legend = chart.legend;
        if (legend) {
          legend.handleEvent(e);
        }
      }
    };
    var noop$2 = helpers$1.noop;
    core_defaults._set('global', {
      title: {
        display: false,
        fontStyle: 'bold',
        fullWidth: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
      }
    });
    var Title = core_element.extend({
      initialize: function initialize(config) {
        var me = this;
        helpers$1.extend(me, config);
        me.legendHitBoxes = [];
      },
      beforeUpdate: noop$2,
      update: function update(maxWidth, maxHeight, margins) {
        var me = this;
        me.beforeUpdate();
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me.margins = margins;
        me.beforeSetDimensions();
        me.setDimensions();
        me.afterSetDimensions();
        me.beforeBuildLabels();
        me.buildLabels();
        me.afterBuildLabels();
        me.beforeFit();
        me.fit();
        me.afterFit();
        me.afterUpdate();
        return me.minSize;
      },
      afterUpdate: noop$2,
      beforeSetDimensions: noop$2,
      setDimensions: function setDimensions() {
        var me = this;
        if (me.isHorizontal()) {
          me.width = me.maxWidth;
          me.left = 0;
          me.right = me.width;
        } else {
          me.height = me.maxHeight;
          me.top = 0;
          me.bottom = me.height;
        }
        me.paddingLeft = 0;
        me.paddingTop = 0;
        me.paddingRight = 0;
        me.paddingBottom = 0;
        me.minSize = {
          width: 0,
          height: 0
        };
      },
      afterSetDimensions: noop$2,
      beforeBuildLabels: noop$2,
      buildLabels: noop$2,
      afterBuildLabels: noop$2,
      beforeFit: noop$2,
      fit: function fit() {
        var me = this;
        var opts = me.options;
        var minSize = me.minSize = {};
        var isHorizontal = me.isHorizontal();
        var lineCount, textSize;
        if (!opts.display) {
          me.width = minSize.width = me.height = minSize.height = 0;
          return;
        }
        lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
        textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
        me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
        me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
      },
      afterFit: noop$2,
      isHorizontal: function isHorizontal() {
        var pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
      },
      draw: function draw() {
        var me = this;
        var ctx = me.ctx;
        var opts = me.options;
        if (!opts.display) {
          return;
        }
        var fontOpts = helpers$1.options._parseFont(opts);
        var lineHeight = fontOpts.lineHeight;
        var offset = lineHeight / 2 + opts.padding;
        var rotation = 0;
        var top = me.top;
        var left = me.left;
        var bottom = me.bottom;
        var right = me.right;
        var maxWidth, titleX, titleY;
        ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor);
        ctx.font = fontOpts.string;
        if (me.isHorizontal()) {
          titleX = left + (right - left) / 2;
          titleY = top + offset;
          maxWidth = right - left;
        } else {
          titleX = opts.position === 'left' ? left + offset : right - offset;
          titleY = top + (bottom - top) / 2;
          maxWidth = bottom - top;
          rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
        }
        ctx.save();
        ctx.translate(titleX, titleY);
        ctx.rotate(rotation);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        var text = opts.text;
        if (helpers$1.isArray(text)) {
          var y = 0;
          for (var i = 0; i < text.length; ++i) {
            ctx.fillText(text[i], 0, y, maxWidth);
            y += lineHeight;
          }
        } else {
          ctx.fillText(text, 0, 0, maxWidth);
        }
        ctx.restore();
      }
    });
    function createNewTitleBlockAndAttach(chart, titleOpts) {
      var title = new Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
      });
      core_layouts.configure(chart, title, titleOpts);
      core_layouts.addBox(chart, title);
      chart.titleBlock = title;
    }
    var plugin_title = {
      id: 'title',
      _element: Title,
      beforeInit: function beforeInit(chart) {
        var titleOpts = chart.options.title;
        if (titleOpts) {
          createNewTitleBlockAndAttach(chart, titleOpts);
        }
      },
      beforeUpdate: function beforeUpdate(chart) {
        var titleOpts = chart.options.title;
        var titleBlock = chart.titleBlock;
        if (titleOpts) {
          helpers$1.mergeIf(titleOpts, core_defaults.global.title);
          if (titleBlock) {
            core_layouts.configure(chart, titleBlock, titleOpts);
            titleBlock.options = titleOpts;
          } else {
            createNewTitleBlockAndAttach(chart, titleOpts);
          }
        } else if (titleBlock) {
          core_layouts.removeBox(chart, titleBlock);
          delete chart.titleBlock;
        }
      }
    };
    var plugins = {};
    var filler = plugin_filler;
    var legend = plugin_legend;
    var title = plugin_title;
    plugins.filler = filler;
    plugins.legend = legend;
    plugins.title = title;
    core_controller.helpers = helpers$1;
    core_helpers();
    core_controller._adapters = core_adapters;
    core_controller.Animation = core_animation;
    core_controller.animationService = core_animations;
    core_controller.controllers = controllers;
    core_controller.DatasetController = core_datasetController;
    core_controller.defaults = core_defaults;
    core_controller.Element = core_element;
    core_controller.elements = elements;
    core_controller.Interaction = core_interaction;
    core_controller.layouts = core_layouts;
    core_controller.platform = platform;
    core_controller.plugins = core_plugins;
    core_controller.Scale = core_scale;
    core_controller.scaleService = core_scaleService;
    core_controller.Ticks = core_ticks;
    core_controller.Tooltip = core_tooltip;
    core_controller.helpers.each(scales, function (scale, type) {
      core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
    });
    for (var k in plugins) {
      if (plugins.hasOwnProperty(k)) {
        core_controller.plugins.register(plugins[k]);
      }
    }
    core_controller.platform.initialize();
    var src = core_controller;
    if (typeof window !== 'undefined') {
      window.Chart = core_controller;
    }
    core_controller.Chart = core_controller;
    core_controller.Legend = plugins.legend._element;
    core_controller.Title = plugins.title._element;
    core_controller.pluginService = core_controller.plugins;
    core_controller.PluginBase = core_controller.Element.extend({});
    core_controller.canvasHelpers = core_controller.helpers.canvas;
    core_controller.layoutService = core_controller.layouts;
    core_controller.LinearScaleBase = scale_linearbase;
    core_controller.helpers.each(['Bar', 'Bubble', 'Doughnut', 'Line', 'PolarArea', 'Radar', 'Scatter'], function (klass) {
      core_controller[klass] = function (ctx, cfg) {
        return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
          type: klass.charAt(0).toLowerCase() + klass.slice(1)
        }));
      };
    });
    return src;
  });
});
var es$1$1$1 = createCommonjsModule$1$1(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "Chart", {
    enumerable: true,
    get: function get() {
      return _chart["default"];
    }
  });
  exports.defaults = exports.Scatter = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = exports["default"] = void 0;
  var _react = _interopRequireDefault(React__default__default__default__default);
  var _propTypes = _interopRequireDefault(propTypes$1$1);
  var _chart = _interopRequireDefault(Chart$1$1);
  var _isEqual = _interopRequireDefault(isEqual);
  var _keyBy = _interopRequireDefault(keyBy);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }
    return _typeof(obj);
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var NODE_ENV = typeof process !== 'undefined' && process.env && process.env.NODE_ENV;
  var ChartComponent = /*#__PURE__*/function (_React$Component) {
    _inherits(ChartComponent, _React$Component);
    var _super = _createSuper(ChartComponent);
    function ChartComponent() {
      var _this;
      _classCallCheck(this, ChartComponent);
      _this = _super.call(this);
      _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
        var instance = _this.chartInstance;
        var _this$props = _this.props,
          getDatasetAtEvent = _this$props.getDatasetAtEvent,
          getElementAtEvent = _this$props.getElementAtEvent,
          getElementsAtEvent = _this$props.getElementsAtEvent,
          onElementsClick = _this$props.onElementsClick;
        getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
        getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
        getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
        onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event);
      });
      _defineProperty(_assertThisInitialized(_this), "ref", function (element) {
        _this.element = element;
      });
      _this.chartInstance = undefined;
      return _this;
    }
    _createClass(ChartComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.renderChart();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        if (this.props.redraw) {
          this.destroyChart();
          this.renderChart();
          return;
        }
        this.updateChart();
      }
    }, {
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps) {
        var _this$props2 = this.props,
          type = _this$props2.type,
          options = _this$props2.options,
          plugins = _this$props2.plugins,
          legend = _this$props2.legend,
          height = _this$props2.height,
          width = _this$props2.width;
        if (nextProps.redraw === true) {
          return true;
        }
        if (height !== nextProps.height || width !== nextProps.width) {
          return true;
        }
        if (type !== nextProps.type) {
          return true;
        }
        if (!(0, _isEqual["default"])(legend, nextProps.legend)) {
          return true;
        }
        if (!(0, _isEqual["default"])(options, nextProps.options)) {
          return true;
        }
        var nextData = this.transformDataProp(nextProps);
        if (!(0, _isEqual["default"])(this.shadowDataProp, nextData)) {
          return true;
        }
        return !(0, _isEqual["default"])(plugins, nextProps.plugins);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.destroyChart();
      }
    }, {
      key: "transformDataProp",
      value: function transformDataProp(props) {
        var data = props.data;
        if (typeof data == 'function') {
          var node = this.element;
          return data(node);
        } else {
          return data;
        }
      }
    }, {
      key: "memoizeDataProps",
      value: function memoizeDataProps() {
        if (!this.props.data) {
          return;
        }
        var data = this.transformDataProp(this.props);
        this.shadowDataProp = _objectSpread(_objectSpread({}, data), {}, {
          datasets: data.datasets && data.datasets.map(function (set) {
            return _objectSpread({}, set);
          })
        });
        this.saveCurrentDatasets();
        return data;
      }
    }, {
      key: "checkDatasets",
      value: function checkDatasets(datasets) {
        var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
        var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
        var multipleDatasets = datasets.length > 1;
        if (isDev && multipleDatasets && !usingCustomKeyProvider) {
          var shouldWarn = false;
          datasets.forEach(function (dataset) {
            if (!dataset.label) {
              shouldWarn = true;
            }
          });
          if (shouldWarn) {
            console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
          }
        }
      }
    }, {
      key: "getCurrentDatasets",
      value: function getCurrentDatasets() {
        return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
      }
    }, {
      key: "saveCurrentDatasets",
      value: function saveCurrentDatasets() {
        var _this2 = this;
        this.datasets = this.datasets || {};
        var currentDatasets = this.getCurrentDatasets();
        currentDatasets.forEach(function (d) {
          _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
        });
      }
    }, {
      key: "updateChart",
      value: function updateChart() {
        var _this3 = this;
        var options = this.props.options;
        var data = this.memoizeDataProps(this.props);
        if (!this.chartInstance) return;
        if (options) {
          this.chartInstance.options = _chart["default"].helpers.configMerge(this.chartInstance.options, options);
        }
        var currentDatasets = this.getCurrentDatasets();
        var nextDatasets = data.datasets || [];
        this.checkDatasets(currentDatasets);
        var currentDatasetsIndexed = (0, _keyBy["default"])(currentDatasets, this.props.datasetKeyProvider);
        this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
          var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];
          if (current && current.type === next.type && next.data) {
            current.data.splice(next.data.length);
            next.data.forEach(function (point, pid) {
              current.data[pid] = next.data[pid];
            });
            var otherProps = _objectWithoutProperties(next, ["data"]);
            return _objectSpread(_objectSpread({}, current), otherProps);
          } else {
            return next;
          }
        });
        var rest = _objectWithoutProperties(data, ["datasets"]);
        this.chartInstance.config.data = _objectSpread(_objectSpread({}, this.chartInstance.config.data), rest);
        this.chartInstance.update();
      }
    }, {
      key: "renderChart",
      value: function renderChart() {
        var _this$props3 = this.props,
          options = _this$props3.options,
          legend = _this$props3.legend,
          type = _this$props3.type,
          plugins = _this$props3.plugins;
        var node = this.element;
        var data = this.memoizeDataProps();
        if (typeof legend !== 'undefined' && !(0, _isEqual["default"])(ChartComponent.defaultProps.legend, legend)) {
          options.legend = legend;
        }
        this.chartInstance = new _chart["default"](node, {
          type: type,
          data: data,
          options: options,
          plugins: plugins
        });
      }
    }, {
      key: "destroyChart",
      value: function destroyChart() {
        if (!this.chartInstance) {
          return;
        }
        this.saveCurrentDatasets();
        var datasets = Object.values(this.datasets);
        this.chartInstance.config.data.datasets = datasets;
        this.chartInstance.destroy();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props4 = this.props,
          height = _this$props4.height,
          width = _this$props4.width,
          id = _this$props4.id;
        return /*#__PURE__*/_react["default"].createElement("canvas", {
          ref: this.ref,
          height: height,
          width: width,
          id: id,
          onClick: this.handleOnClick
        });
      }
    }]);
    return ChartComponent;
  }(_react["default"].Component);
  _defineProperty(ChartComponent, "getLabelAsKey", function (d) {
    return d.label;
  });
  _defineProperty(ChartComponent, "propTypes", {
    data: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]).isRequired,
    getDatasetAtEvent: _propTypes["default"].func,
    getElementAtEvent: _propTypes["default"].func,
    getElementsAtEvent: _propTypes["default"].func,
    height: _propTypes["default"].number,
    legend: _propTypes["default"].object,
    onElementsClick: _propTypes["default"].func,
    options: _propTypes["default"].object,
    plugins: _propTypes["default"].arrayOf(_propTypes["default"].object),
    redraw: _propTypes["default"].bool,
    type: function type(props, propName, componentName) {
      if (!_chart["default"].controllers[props[propName]]) {
        return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
      }
    },
    width: _propTypes["default"].number,
    datasetKeyProvider: _propTypes["default"].func
  });
  _defineProperty(ChartComponent, "defaultProps", {
    legend: {
      display: true,
      position: 'bottom'
    },
    type: 'doughnut',
    height: 150,
    width: 300,
    redraw: false,
    options: {},
    datasetKeyProvider: ChartComponent.getLabelAsKey
  });
  var _default = ChartComponent;
  exports["default"] = _default;
  var Doughnut = /*#__PURE__*/function (_React$Component2) {
    _inherits(Doughnut, _React$Component2);
    var _super2 = _createSuper(Doughnut);
    function Doughnut() {
      _classCallCheck(this, Doughnut);
      return _super2.apply(this, arguments);
    }
    _createClass(Doughnut, [{
      key: "render",
      value: function render() {
        var _this4 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref) {
            return _this4.chartInstance = _ref && _ref.chartInstance;
          },
          type: "doughnut"
        }));
      }
    }]);
    return Doughnut;
  }(_react["default"].Component);
  exports.Doughnut = Doughnut;
  var Pie = /*#__PURE__*/function (_React$Component3) {
    _inherits(Pie, _React$Component3);
    var _super3 = _createSuper(Pie);
    function Pie() {
      _classCallCheck(this, Pie);
      return _super3.apply(this, arguments);
    }
    _createClass(Pie, [{
      key: "render",
      value: function render() {
        var _this5 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref2) {
            return _this5.chartInstance = _ref2 && _ref2.chartInstance;
          },
          type: "pie"
        }));
      }
    }]);
    return Pie;
  }(_react["default"].Component);
  exports.Pie = Pie;
  var Line = /*#__PURE__*/function (_React$Component4) {
    _inherits(Line, _React$Component4);
    var _super4 = _createSuper(Line);
    function Line() {
      _classCallCheck(this, Line);
      return _super4.apply(this, arguments);
    }
    _createClass(Line, [{
      key: "render",
      value: function render() {
        var _this6 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref3) {
            return _this6.chartInstance = _ref3 && _ref3.chartInstance;
          },
          type: "line"
        }));
      }
    }]);
    return Line;
  }(_react["default"].Component);
  exports.Line = Line;
  var Bar = /*#__PURE__*/function (_React$Component5) {
    _inherits(Bar, _React$Component5);
    var _super5 = _createSuper(Bar);
    function Bar() {
      _classCallCheck(this, Bar);
      return _super5.apply(this, arguments);
    }
    _createClass(Bar, [{
      key: "render",
      value: function render() {
        var _this7 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref4) {
            return _this7.chartInstance = _ref4 && _ref4.chartInstance;
          },
          type: "bar"
        }));
      }
    }]);
    return Bar;
  }(_react["default"].Component);
  exports.Bar = Bar;
  var HorizontalBar = /*#__PURE__*/function (_React$Component6) {
    _inherits(HorizontalBar, _React$Component6);
    var _super6 = _createSuper(HorizontalBar);
    function HorizontalBar() {
      _classCallCheck(this, HorizontalBar);
      return _super6.apply(this, arguments);
    }
    _createClass(HorizontalBar, [{
      key: "render",
      value: function render() {
        var _this8 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref5) {
            return _this8.chartInstance = _ref5 && _ref5.chartInstance;
          },
          type: "horizontalBar"
        }));
      }
    }]);
    return HorizontalBar;
  }(_react["default"].Component);
  exports.HorizontalBar = HorizontalBar;
  var Radar = /*#__PURE__*/function (_React$Component7) {
    _inherits(Radar, _React$Component7);
    var _super7 = _createSuper(Radar);
    function Radar() {
      _classCallCheck(this, Radar);
      return _super7.apply(this, arguments);
    }
    _createClass(Radar, [{
      key: "render",
      value: function render() {
        var _this9 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref6) {
            return _this9.chartInstance = _ref6 && _ref6.chartInstance;
          },
          type: "radar"
        }));
      }
    }]);
    return Radar;
  }(_react["default"].Component);
  exports.Radar = Radar;
  var Polar = /*#__PURE__*/function (_React$Component8) {
    _inherits(Polar, _React$Component8);
    var _super8 = _createSuper(Polar);
    function Polar() {
      _classCallCheck(this, Polar);
      return _super8.apply(this, arguments);
    }
    _createClass(Polar, [{
      key: "render",
      value: function render() {
        var _this10 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref7) {
            return _this10.chartInstance = _ref7 && _ref7.chartInstance;
          },
          type: "polarArea"
        }));
      }
    }]);
    return Polar;
  }(_react["default"].Component);
  exports.Polar = Polar;
  var Bubble = /*#__PURE__*/function (_React$Component9) {
    _inherits(Bubble, _React$Component9);
    var _super9 = _createSuper(Bubble);
    function Bubble() {
      _classCallCheck(this, Bubble);
      return _super9.apply(this, arguments);
    }
    _createClass(Bubble, [{
      key: "render",
      value: function render() {
        var _this11 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref8) {
            return _this11.chartInstance = _ref8 && _ref8.chartInstance;
          },
          type: "bubble"
        }));
      }
    }]);
    return Bubble;
  }(_react["default"].Component);
  exports.Bubble = Bubble;
  var Scatter = /*#__PURE__*/function (_React$Component10) {
    _inherits(Scatter, _React$Component10);
    var _super10 = _createSuper(Scatter);
    function Scatter() {
      _classCallCheck(this, Scatter);
      return _super10.apply(this, arguments);
    }
    _createClass(Scatter, [{
      key: "render",
      value: function render() {
        var _this12 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref9) {
            return _this12.chartInstance = _ref9 && _ref9.chartInstance;
          },
          type: "scatter"
        }));
      }
    }]);
    return Scatter;
  }(_react["default"].Component);
  exports.Scatter = Scatter;
  var defaults = _chart["default"].defaults;
  exports.defaults = defaults;
});
unwrapExports$1$1(es$1$1$1);
function r$1$1$1(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r$1$1$1(e[t])) && (n && (n += " "), n += f);else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx$1$1() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) (e = arguments[f++]) && (t = r$1$1$1(e)) && (n && (n += " "), n += t);
  return n;
}
var clsx_m$1$1 = {
  __proto__: null,
  clsx: clsx$1$1,
  'default': clsx$1$1
};
var require$$1$1$1 = getCjsExportFromNamespace$1$1(clsx_m$1$1);
var dist$1$1 = createCommonjsModule$1$1(function (module) {
  module.exports = function (n) {
    var e = {};
    function t(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return n[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }
    return t.m = n, t.c = e, t.d = function (n, e, r) {
      t.o(n, e) || Object.defineProperty(n, e, {
        enumerable: !0,
        get: r
      });
    }, t.r = function (n) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(n, "__esModule", {
        value: !0
      });
    }, t.t = function (n, e) {
      if (1 & e && (n = t(n)), 8 & e) return n;
      if (4 & e && "object" == typeof n && n && n.__esModule) return n;
      var r = Object.create(null);
      if (t.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: n
      }), 2 & e && "string" != typeof n) for (var o in n) t.d(r, o, function (e) {
        return n[e];
      }.bind(null, o));
      return r;
    }, t.n = function (n) {
      var e = n && n.__esModule ? function () {
        return n["default"];
      } : function () {
        return n;
      };
      return t.d(e, "a", e), e;
    }, t.o = function (n, e) {
      return Object.prototype.hasOwnProperty.call(n, e);
    }, t.p = "", t(t.s = 182);
  }([function (n, e, t) {
    n.exports = t(174)();
  }, function (n, e) {
    n.exports = React__default__default__default__default;
  }, function (n, e) {
    var t = Array.isArray;
    n.exports = t;
  }, function (n, e, t) {
    var r = t(40),
      o = "object" == typeof self && self && self.Object === Object && self,
      a = r || o || Function("return this")();
    n.exports = a;
  }, function (n, e, t) {
    var r = t(78),
      o = t(25),
      a = t(27),
      i = t(28);
    n.exports = function (n, e, t) {
      return n = i(n), t = null == t ? 0 : r(a(t), 0, n.length), e = o(e), n.slice(t, t + e.length) == e;
    };
  }, function (n, e, t) {
    var r = t(171)(t(23));
    n.exports = r;
  }, function (n, e, t) {
    var r = t(14),
      o = t(76),
      a = t(77),
      i = "[object Null]",
      u = "[object Undefined]",
      c = r ? r.toStringTag : void 0;
    n.exports = function (n) {
      return null == n ? void 0 === n ? u : i : c && c in Object(n) ? o(n) : a(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return null != n && "object" == typeof n;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = typeof n;
      return null != n && ("object" == e || "function" == e);
    };
  }, function (n, e, t) {
    var r = t(92),
      o = t(95);
    n.exports = function (n, e) {
      var t = o(n, e);
      return r(t) ? t : void 0;
    };
  }, function (n, e, t) {
    var r = t(111),
      o = t(150),
      a = t(157),
      i = t(2),
      u = t(158);
    n.exports = function (n) {
      return "function" == typeof n ? n : null == n ? a : "object" == typeof n ? i(n) ? o(n[0], n[1]) : r(n) : u(n);
    };
  }, function (n, e, t) {
    var r = t(44),
      o = t(34);
    n.exports = function (n) {
      return null != n && o(n.length) && !r(n);
    };
  }, function (n, e, t) {
    var r = t(133),
      o = t(140),
      a = t(11);
    n.exports = function (n) {
      return a(n) ? r(n) : o(n);
    };
  }, function (n, e, t) {
    var r = t(26),
      o = t(10),
      a = t(168),
      i = t(2);
    n.exports = function (n, e) {
      return (i(n) ? r : a)(n, o(e, 3));
    };
  }, function (n, e, t) {
    var r = t(3).Symbol;
    n.exports = r;
  }, function (n, e, t) {
    var r = t(6),
      o = t(7),
      a = "[object Symbol]";
    n.exports = function (n) {
      return "symbol" == typeof n || o(n) && r(n) == a;
    };
  }, function (n, e, t) {
    var r = t(9)(Object, "create");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(100),
      o = t(101),
      a = t(102),
      i = t(103),
      u = t(104);
    function c(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }
    c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e, t) {
    var r = t(31);
    n.exports = function (n, e) {
      for (var t = n.length; t--;) if (r(n[t][0], e)) return t;
      return -1;
    };
  }, function (n, e, t) {
    var r = t(106);
    n.exports = function (n, e) {
      var t = n.__data__;
      return r(e) ? t["string" == typeof e ? "string" : "hash"] : t.map;
    };
  }, function (n, e, t) {
    var r = t(15),
      o = 1 / 0;
    n.exports = function (n) {
      if ("string" == typeof n || r(n)) return n;
      var e = n + "";
      return "0" == e && 1 / n == -o ? "-0" : e;
    };
  }, function (n, e, t) {
    var r = t(164),
      o = t(167)(r);
    n.exports = o;
  }, function (n, e, t) {
    var r = t(30),
      o = "Expected a function";
    function a(n, e) {
      if ("function" != typeof n || null != e && "function" != typeof e) throw new TypeError(o);
      var t = function t() {
        var r = arguments,
          o = e ? e.apply(this, r) : r[0],
          a = t.cache;
        if (a.has(o)) return a.get(o);
        var i = n.apply(this, r);
        return t.cache = a.set(o, i) || a, i;
      };
      return t.cache = new (a.Cache || r)(), t;
    }
    a.Cache = r, n.exports = a;
  }, function (n, e, t) {
    var r = t(43),
      o = t(10),
      a = t(27),
      i = Math.max;
    n.exports = function (n, e, t) {
      var u = null == n ? 0 : n.length;
      if (!u) return -1;
      var c = null == t ? 0 : a(t);
      return c < 0 && (c = i(u + c, 0)), r(n, o(e, 3), c);
    };
  }, function (n, e, t) {
    var r = t(50),
      o = t(163),
      a = t(10),
      i = t(2);
    n.exports = function (n, e) {
      return (i(n) ? r : o)(n, a(e, 3));
    };
  }, function (n, e, t) {
    var r = t(14),
      o = t(26),
      a = t(2),
      i = t(15),
      u = 1 / 0,
      c = r ? r.prototype : void 0,
      s = c ? c.toString : void 0;
    n.exports = function n(e) {
      if ("string" == typeof e) return e;
      if (a(e)) return o(e, n) + "";
      if (i(e)) return s ? s.call(e) : "";
      var t = e + "";
      return "0" == t && 1 / e == -u ? "-0" : t;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length, o = Array(r); ++t < r;) o[t] = e(n[t], t, n);
      return o;
    };
  }, function (n, e, t) {
    var r = t(79);
    n.exports = function (n) {
      var e = r(n),
        t = e % 1;
      return e == e ? t ? e - t : e : 0;
    };
  }, function (n, e, t) {
    var r = t(25);
    n.exports = function (n) {
      return null == n ? "" : r(n);
    };
  }, function (n, e, t) {
    var r = t(43),
      o = t(82),
      a = t(83);
    n.exports = function (n, e, t) {
      return e == e ? a(n, e, t) : r(n, o, t);
    };
  }, function (n, e, t) {
    var r = t(89),
      o = t(105),
      a = t(107),
      i = t(108),
      u = t(109);
    function c(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }
    c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e) {
    n.exports = function (n, e) {
      return n === e || n != n && e != e;
    };
  }, function (n, e, t) {
    var r = t(9)(t(3), "Map");
    n.exports = r;
  }, function (n, e) {
    var t = 9007199254740991,
      r = /^(?:0|[1-9]\d*)$/;
    n.exports = function (n, e) {
      var o = typeof n;
      return !!(e = null == e ? t : e) && ("number" == o || "symbol" != o && r.test(n)) && n > -1 && n % 1 == 0 && n < e;
    };
  }, function (n, e) {
    var t = 9007199254740991;
    n.exports = function (n) {
      return "number" == typeof n && n > -1 && n % 1 == 0 && n <= t;
    };
  }, function (n, e, t) {
    var r = t(2),
      o = t(15),
      a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      i = /^\w*$/;
    n.exports = function (n, e) {
      if (r(n)) return !1;
      var t = typeof n;
      return !("number" != t && "symbol" != t && "boolean" != t && null != n && !o(n)) || i.test(n) || !a.test(n) || null != e && n in Object(e);
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(2),
      a = t(7),
      i = "[object String]";
    n.exports = function (n) {
      return "string" == typeof n || !o(n) && a(n) && r(n) == i;
    };
  }, function (n, e, t) {
    var r = t(169),
      o = t(21),
      a = t(10),
      i = t(170),
      u = t(2);
    n.exports = function (n, e, t) {
      var c = u(n) ? r : i,
        s = arguments.length < 3;
      return c(n, a(e, 4), t, s, o);
    };
  }, function (n, e, t) {
    var r = t(49),
      o = t(10),
      a = t(172),
      i = t(2),
      u = t(173);
    n.exports = function (n, e, t) {
      var c = i(n) ? r : a;
      return t && u(n, e, t) && (e = void 0), c(n, o(e, 3));
    };
  }, function (n, e) {
    var t;
    function r(n, e) {
      var t = Object.keys(n);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(n);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        })), t.push.apply(t, r);
      }
      return t;
    }
    function o(n, e, t) {
      return e in n ? Object.defineProperty(n, e, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[e] = t, n;
    }
    function a(n, e) {
      return function (n) {
        if (Array.isArray(n)) return n;
      }(n) || function (n, e) {
        if (!(Symbol.iterator in Object(n) || "[object Arguments]" === Object.prototype.toString.call(n))) return;
        var t = [],
          r = !0,
          o = !1,
          a = void 0;
        try {
          for (var i, u = n[Symbol.iterator](); !(r = (i = u.next()).done) && (t.push(i.value), !e || t.length !== e); r = !0);
        } catch (n) {
          o = !0, a = n;
        } finally {
          try {
            r || null == u["return"] || u["return"]();
          } finally {
            if (o) throw a;
          }
        }
        return t;
      }(n, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }
    var i = {};
    function u(n, e, t) {
      e in i || (i[e] = []);
      var r = t || 0;
      i[e][r] = n;
    }
    var c,
      s = (t = []).concat.apply(t, function (n) {
        if (Array.isArray(n)) {
          for (var e = 0, t = new Array(n.length); e < n.length; e++) t[e] = n[e];
          return t;
        }
      }(c = [["Afghanistan", ["asia"], "af", "93"], ["Albania", ["europe"], "al", "355"], ["Algeria", ["africa", "north-africa"], "dz", "213"], ["American Samoa", ["oceania"], "as", "1684"], ["Andorra", ["europe"], "ad", "376"], ["Angola", ["africa"], "ao", "244"], ["Anguilla", ["america", "carribean"], "ai", "1264"], ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"], ["Argentina", ["america", "south-america"], "ar", "54", "+.. (..) ........"], ["Armenia", ["asia", "ex-ussr"], "am", "374"], ["Aruba", ["america", "carribean"], "aw", "297"], ["Australia", ["oceania"], "au", "61", "+.. ... ... ..."], ["Austria", ["europe", "european-union"], "at", "43"], ["Azerbaijan", ["asia", "ex-ussr"], "az", "994"], ["Bahamas", ["america", "carribean"], "bs", "1242"], ["Bahrain", ["middle-east"], "bh", "973"], ["Bangladesh", ["asia"], "bd", "880"], ["Barbados", ["america", "carribean"], "bb", "1246"], ["Belarus", ["europe", "ex-ussr"], "by", "375", "+... (..) ... .. .."], ["Belgium", ["europe", "european-union"], "be", "32", "+.. ... .. .. .."], ["Belize", ["america", "central-america"], "bz", "501"], ["Benin", ["africa"], "bj", "229"], ["Bermuda", ["america", "north-america"], "bm", "1441"], ["Bhutan", ["asia"], "bt", "975"], ["Bolivia", ["america", "south-america"], "bo", "591"], ["Bosnia and Herzegovina", ["europe"], "ba", "387"], ["Botswana", ["africa"], "bw", "267"], ["Brazil", ["america", "south-america"], "br", "55", "+.. (..) ........."], ["British Indian Ocean Territory", ["asia"], "io", "246"], ["British Virgin Islands", ["america", "carribean"], "vg", "1284"], ["Brunei", ["asia"], "bn", "673"], ["Bulgaria", ["europe", "european-union"], "bg", "359"], ["Burkina Faso", ["africa"], "bf", "226"], ["Burundi", ["africa"], "bi", "257"], ["Cambodia", ["asia"], "kh", "855"], ["Cameroon", ["africa"], "cm", "237"], ["Canada", ["america", "north-america"], "ca", "1", "+. (...) ...-....", 1, ["204", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde", ["africa"], "cv", "238"], ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1], ["Cayman Islands", ["america", "carribean"], "ky", "1345"], ["Central African Republic", ["africa"], "cf", "236"], ["Chad", ["africa"], "td", "235"], ["Chile", ["america", "south-america"], "cl", "56"], ["China", ["asia"], "cn", "86", "+.. ..-........."], ["Colombia", ["america", "south-america"], "co", "57"], ["Comoros", ["africa"], "km", "269"], ["Congo", ["africa"], "cd", "243"], ["Congo", ["africa"], "cg", "242"], ["Cook Islands", ["oceania"], "ck", "682"], ["Costa Rica", ["america", "central-america"], "cr", "506", "+... ....-...."], ["Côte d’Ivoire", ["africa"], "ci", "225"], ["Croatia", ["europe", "european-union"], "hr", "385"], ["Cuba", ["america", "carribean"], "cu", "53"], ["Curaçao", ["america", "carribean"], "cw", "599", "", 0], ["Cyprus", ["europe", "european-union"], "cy", "357", "+... .. ......"], ["Czech Republic", ["europe", "european-union"], "cz", "420"], ["Denmark", ["europe", "european-union"], "dk", "45", "+.. .. .. .. .."], ["Djibouti", ["africa"], "dj", "253"], ["Dominica", ["america", "carribean"], "dm", "1767"], ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2, ["809", "829", "849"]], ["Ecuador", ["america", "south-america"], "ec", "593"], ["Egypt", ["africa", "north-africa"], "eg", "20"], ["El Salvador", ["america", "central-america"], "sv", "503", "+... ....-...."], ["Equatorial Guinea", ["africa"], "gq", "240"], ["Eritrea", ["africa"], "er", "291"], ["Estonia", ["europe", "european-union", "ex-ussr"], "ee", "372", "+... .... ......"], ["Ethiopia", ["africa"], "et", "251"], ["Falkland Islands", ["america", "south-america"], "fk", "500"], ["Faroe Islands", ["europe"], "fo", "298"], ["Fiji", ["oceania"], "fj", "679"], ["Finland", ["europe", "european-union"], "fi", "358", "+... .. ... .. .."], ["France", ["europe", "european-union"], "fr", "33", "+.. . .. .. .. .."], ["French Guiana", ["america", "south-america"], "gf", "594"], ["French Polynesia", ["oceania"], "pf", "689"], ["Gabon", ["africa"], "ga", "241"], ["Gambia", ["africa"], "gm", "220"], ["Georgia", ["asia", "ex-ussr"], "ge", "995"], ["Germany", ["europe", "european-union"], "de", "49", "+.. .... ........"], ["Ghana", ["africa"], "gh", "233"], ["Gibraltar", ["europe"], "gi", "350"], ["Greece", ["europe", "european-union"], "gr", "30"], ["Greenland", ["america"], "gl", "299"], ["Grenada", ["america", "carribean"], "gd", "1473"], ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0], ["Guam", ["oceania"], "gu", "1671"], ["Guatemala", ["america", "central-america"], "gt", "502", "+... ....-...."], ["Guinea", ["africa"], "gn", "224"], ["Guinea-Bissau", ["africa"], "gw", "245"], ["Guyana", ["america", "south-america"], "gy", "592"], ["Haiti", ["america", "carribean"], "ht", "509", "+... ....-...."], ["Honduras", ["america", "central-america"], "hn", "504"], ["Hong Kong", ["asia"], "hk", "852", "+... .... ...."], ["Hungary", ["europe", "european-union"], "hu", "36"], ["Iceland", ["europe"], "is", "354", "+... ... ...."], ["India", ["asia"], "in", "91", "+.. .....-....."], ["Indonesia", ["asia"], "id", "62"], ["Iran", ["middle-east"], "ir", "98"], ["Iraq", ["middle-east"], "iq", "964"], ["Ireland", ["europe", "european-union"], "ie", "353", "+... .. ......."], ["Israel", ["middle-east"], "il", "972", "+... ... ... ...."], ["Italy", ["europe", "european-union"], "it", "39", "+.. ... .......", 0], ["Jamaica", ["america", "carribean"], "jm", "1876"], ["Japan", ["asia"], "jp", "81", "+.. .. .... ...."], ["Jordan", ["middle-east"], "jo", "962"], ["Kazakhstan", ["asia", "ex-ussr"], "kz", "7", "+. ... ...-..-..", 1, ["313", "327", "7172", "312", "73622", "321", "324", "336", "318", "315", "325", "311", "326", "310"]], ["Kenya", ["africa"], "ke", "254"], ["Kiribati", ["oceania"], "ki", "686"], ["Kuwait", ["middle-east"], "kw", "965"], ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996"], ["Laos", ["asia"], "la", "856"], ["Latvia", ["europe", "european-union", "ex-ussr"], "lv", "371"], ["Lebanon", ["middle-east"], "lb", "961"], ["Lesotho", ["africa"], "ls", "266"], ["Liberia", ["africa"], "lr", "231"], ["Libya", ["africa", "north-africa"], "ly", "218"], ["Liechtenstein", ["europe"], "li", "423"], ["Lithuania", ["europe", "european-union", "ex-ussr"], "lt", "370"], ["Luxembourg", ["europe", "european-union"], "lu", "352"], ["Macau", ["asia"], "mo", "853"], ["Macedonia", ["europe"], "mk", "389"], ["Madagascar", ["africa"], "mg", "261"], ["Malawi", ["africa"], "mw", "265"], ["Malaysia", ["asia"], "my", "60", "+.. ..-....-...."], ["Maldives", ["asia"], "mv", "960"], ["Mali", ["africa"], "ml", "223"], ["Malta", ["europe", "european-union"], "mt", "356"], ["Marshall Islands", ["oceania"], "mh", "692"], ["Martinique", ["america", "carribean"], "mq", "596"], ["Mauritania", ["africa"], "mr", "222"], ["Mauritius", ["africa"], "mu", "230"], ["Mexico", ["america", "central-america"], "mx", "52"], ["Micronesia", ["oceania"], "fm", "691"], ["Moldova", ["europe"], "md", "373", "+... (..) ..-..-.."], ["Monaco", ["europe"], "mc", "377"], ["Mongolia", ["asia"], "mn", "976"], ["Montenegro", ["europe"], "me", "382"], ["Montserrat", ["america", "carribean"], "ms", "1664"], ["Morocco", ["africa", "north-africa"], "ma", "212"], ["Mozambique", ["africa"], "mz", "258"], ["Myanmar", ["asia"], "mm", "95"], ["Namibia", ["africa"], "na", "264"], ["Nauru", ["africa"], "nr", "674"], ["Nepal", ["asia"], "np", "977"], ["Netherlands", ["europe", "european-union"], "nl", "31", "+.. .. ........"], ["New Caledonia", ["oceania"], "nc", "687"], ["New Zealand", ["oceania"], "nz", "64", "+.. ...-...-...."], ["Nicaragua", ["america", "central-america"], "ni", "505"], ["Niger", ["africa"], "ne", "227"], ["Nigeria", ["africa"], "ng", "234"], ["Niue", ["asia"], "nu", "683"], ["Norfolk Island", ["oceania"], "nf", "672"], ["North Korea", ["asia"], "kp", "850"], ["Northern Mariana Islands", ["oceania"], "mp", "1670"], ["Norway", ["europe"], "no", "47", "+.. ... .. ..."], ["Oman", ["middle-east"], "om", "968"], ["Pakistan", ["asia"], "pk", "92", "+.. ...-......."], ["Palau", ["oceania"], "pw", "680"], ["Palestine", ["middle-east"], "ps", "970"], ["Panama", ["america", "central-america"], "pa", "507"], ["Papua New Guinea", ["oceania"], "pg", "675"], ["Paraguay", ["america", "south-america"], "py", "595"], ["Peru", ["america", "south-america"], "pe", "51"], ["Philippines", ["asia"], "ph", "63", "+.. .... ......."], ["Poland", ["europe", "european-union"], "pl", "48", "+.. ...-...-..."], ["Portugal", ["europe", "european-union"], "pt", "351"], ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3, ["787", "939"]], ["Qatar", ["middle-east"], "qa", "974"], ["Réunion", ["africa"], "re", "262"], ["Romania", ["europe", "european-union"], "ro", "40"], ["Russia", ["europe", "asia", "ex-ussr"], "ru", "7", "+. (...) ...-..-..", 0], ["Rwanda", ["africa"], "rw", "250"], ["Saint Barthélemy", ["america", "carribean"], "bl", "590", "", 1], ["Saint Helena", ["africa"], "sh", "290"], ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"], ["Saint Lucia", ["america", "carribean"], "lc", "1758"], ["Saint Martin", ["america", "carribean"], "mf", "590", "", 2], ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"], ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"], ["Samoa", ["oceania"], "ws", "685"], ["San Marino", ["europe"], "sm", "378"], ["São Tomé and Príncipe", ["africa"], "st", "239"], ["Saudi Arabia", ["middle-east"], "sa", "966"], ["Senegal", ["africa"], "sn", "221"], ["Serbia", ["europe"], "rs", "381"], ["Seychelles", ["africa"], "sc", "248"], ["Sierra Leone", ["africa"], "sl", "232"], ["Singapore", ["asia"], "sg", "65", "+.. ....-...."], ["Sint Maarten", ["america", "carribean"], "sx", "1721"], ["Slovakia", ["europe", "european-union"], "sk", "421"], ["Slovenia", ["europe", "european-union"], "si", "386"], ["Solomon Islands", ["oceania"], "sb", "677"], ["Somalia", ["africa"], "so", "252"], ["South Africa", ["africa"], "za", "27"], ["South Korea", ["asia"], "kr", "82", "+.. ... .... ...."], ["South Sudan", ["africa", "north-africa"], "ss", "211"], ["Spain", ["europe", "european-union"], "es", "34", "+.. ... ... ..."], ["Sri Lanka", ["asia"], "lk", "94"], ["Sudan", ["africa"], "sd", "249"], ["Suriname", ["america", "south-america"], "sr", "597"], ["Swaziland", ["africa"], "sz", "268"], ["Sweden", ["europe", "european-union"], "se", "46", "+.. (..) ...-..-.."], ["Switzerland", ["europe"], "ch", "41", "+.. .. ... .. .."], ["Syria", ["middle-east"], "sy", "963"], ["Taiwan", ["asia"], "tw", "886"], ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"], ["Tanzania", ["africa"], "tz", "255"], ["Thailand", ["asia"], "th", "66"], ["Timor-Leste", ["asia"], "tl", "670"], ["Togo", ["africa"], "tg", "228"], ["Tokelau", ["oceania"], "tk", "690"], ["Tonga", ["oceania"], "to", "676"], ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"], ["Tunisia", ["africa", "north-africa"], "tn", "216"], ["Turkey", ["europe"], "tr", "90", "+.. ... ... .. .."], ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"], ["Turks and Caicos Islands", ["america", "carribean"], "tc", "1649"], ["Tuvalu", ["asia"], "tv", "688"], ["U.S. Virgin Islands", ["america", "carribean"], "vi", "1340"], ["Uganda", ["africa"], "ug", "256"], ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "+... (..) ... .. .."], ["United Arab Emirates", ["middle-east"], "ae", "971"], ["United Kingdom", ["europe", "european-union"], "gb", "44", "+.. .... ......"], ["United States", ["america", "north-america"], "us", "1", "+. (...) ...-....", 0, ["907", "205", "251", "256", "334", "479", "501", "870", "480", "520", "602", "623", "928", "209", "213", "310", "323", "408", "415", "510", "530", "559", "562", "619", "626", "650", "661", "707", "714", "760", "805", "818", "831", "858", "909", "916", "925", "949", "951", "303", "719", "970", "203", "860", "202", "302", "239", "305", "321", "352", "386", "407", "561", "727", "772", "813", "850", "863", "904", "941", "954", "229", "404", "478", "706", "770", "912", "808", "319", "515", "563", "641", "712", "208", "217", "309", "312", "618", "630", "708", "773", "815", "847", "219", "260", "317", "574", "765", "812", "316", "620", "785", "913", "270", "502", "606", "859", "225", "318", "337", "504", "985", "413", "508", "617", "781", "978", "301", "410", "207", "231", "248", "269", "313", "517", "586", "616", "734", "810", "906", "989", "218", "320", "507", "612", "651", "763", "952", "314", "417", "573", "636", "660", "816", "228", "601", "662", "406", "252", "336", "704", "828", "910", "919", "701", "308", "402", "603", "201", "609", "732", "856", "908", "973", "505", "575", "702", "775", "212", "315", "516", "518", "585", "607", "631", "716", "718", "845", "914", "216", "330", "419", "440", "513", "614", "740", "937", "405", "580", "918", "503", "541", "215", "412", "570", "610", "717", "724", "814", "401", "803", "843", "864", "605", "423", "615", "731", "865", "901", "931", "210", "214", "254", "281", "325", "361", "409", "432", "512", "713", "806", "817", "830", "903", "915", "936", "940", "956", "972", "979", "435", "801", "276", "434", "540", "703", "757", "804", "802", "206", "253", "360", "425", "509", "262", "414", "608", "715", "920", "304", "307"]], ["Uruguay", ["america", "south-america"], "uy", "598"], ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998"], ["Vanuatu", ["oceania"], "vu", "678"], ["Vatican City", ["europe"], "va", "39", "+.. .. .... ....", 1], ["Venezuela", ["america", "south-america"], "ve", "58"], ["Vietnam", ["asia"], "vn", "84"], ["Wallis and Futuna", ["oceania"], "wf", "681"], ["Yemen", ["middle-east"], "ye", "967"], ["Zambia", ["africa"], "zm", "260"], ["Zimbabwe", ["africa"], "zw", "263"]].map(function (n) {
        var e = a(n, 7),
          t = e[0],
          i = e[1],
          c = e[2],
          s = e[3],
          p = e[4],
          f = e[5],
          l = e[6],
          g = {
            name: t,
            regions: i,
            iso2: c,
            dialCode: s,
            priority: f,
            format: p || void 0,
            hasAreaCodes: l
          },
          d = [];
        return g.hasAreaCodes && l.forEach(function (n) {
          var e = function (n) {
            for (var e = 1; e < arguments.length; e++) {
              var t = null != arguments[e] ? arguments[e] : {};
              e % 2 ? r(t, !0).forEach(function (e) {
                o(n, e, t[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : r(t).forEach(function (e) {
                Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(t, e));
              });
            }
            return n;
          }({}, g, {
            regions: i,
            dialCode: "".concat(s).concat(n),
            isAreaCode: !0
          });
          d.push(e), u(c, e.dialCode);
        }), u(g.iso2, g.dialCode, g.hasAreaCodes), d.length > 0 ? [g].concat(d) : [g];
      })) || function (n) {
        if (Symbol.iterator in Object(n) || "[object Arguments]" === Object.prototype.toString.call(n)) return Array.from(n);
      }(c) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }());
    n.exports = {
      allCountries: s,
      allCountryCodes: i
    };
  }, function (n, e, t) {
    (function (e) {
      var t = "object" == typeof e && e && e.Object === Object && e;
      n.exports = t;
    }).call(this, t(75));
  }, function (n, e, t) {
    var r = t(8),
      o = t(15),
      a = NaN,
      i = /^\s+|\s+$/g,
      u = /^[-+]0x[0-9a-f]+$/i,
      c = /^0b[01]+$/i,
      s = /^0o[0-7]+$/i,
      p = parseInt;
    n.exports = function (n) {
      if ("number" == typeof n) return n;
      if (o(n)) return a;
      if (r(n)) {
        var e = "function" == typeof n.valueOf ? n.valueOf() : n;
        n = r(e) ? e + "" : e;
      }
      if ("string" != typeof n) return 0 === n ? n : +n;
      n = n.replace(i, "");
      var t = c.test(n);
      return t || s.test(n) ? p(n.slice(2), t ? 2 : 8) : u.test(n) ? a : +n;
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      var r = -1,
        o = n.length;
      e < 0 && (e = -e > o ? 0 : o + e), (t = t > o ? o : t) < 0 && (t += o), o = e > t ? 0 : t - e >>> 0, e >>>= 0;
      for (var a = Array(o); ++r < o;) a[r] = n[r + e];
      return a;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r) {
      for (var o = n.length, a = t + (r ? 1 : -1); r ? a-- : ++a < o;) if (e(n[a], a, n)) return a;
      return -1;
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(8),
      a = "[object AsyncFunction]",
      i = "[object Function]",
      u = "[object GeneratorFunction]",
      c = "[object Proxy]";
    n.exports = function (n) {
      if (!o(n)) return !1;
      var e = r(n);
      return e == i || e == u || e == a || e == c;
    };
  }, function (n, e) {
    var t = Function.prototype.toString;
    n.exports = function (n) {
      if (null != n) {
        try {
          return t.call(n);
        } catch (n) {}
        try {
          return n + "";
        } catch (n) {}
      }
      return "";
    };
  }, function (n, e, t) {
    var r = t(17),
      o = t(113),
      a = t(114),
      i = t(115),
      u = t(116),
      c = t(117);
    function s(n) {
      var e = this.__data__ = new r(n);
      this.size = e.size;
    }
    s.prototype.clear = o, s.prototype["delete"] = a, s.prototype.get = i, s.prototype.has = u, s.prototype.set = c, n.exports = s;
  }, function (n, e, t) {
    var r = t(118),
      o = t(7);
    n.exports = function n(e, t, a, i, u) {
      return e === t || (null == e || null == t || !o(e) && !o(t) ? e != e && t != t : r(e, t, a, i, n, u));
    };
  }, function (n, e, t) {
    var r = t(119),
      o = t(49),
      a = t(122),
      i = 1,
      u = 2;
    n.exports = function (n, e, t, c, s, p) {
      var f = t & i,
        l = n.length,
        g = e.length;
      if (l != g && !(f && g > l)) return !1;
      var d = p.get(n);
      if (d && p.get(e)) return d == e;
      var b = -1,
        x = !0,
        A = t & u ? new r() : void 0;
      for (p.set(n, e), p.set(e, n); ++b < l;) {
        var v = n[b],
          h = e[b];
        if (c) var m = f ? c(h, v, b, e, n, p) : c(v, h, b, n, e, p);
        if (void 0 !== m) {
          if (m) continue;
          x = !1;
          break;
        }
        if (A) {
          if (!o(e, function (n, e) {
            if (!a(A, e) && (v === n || s(v, n, t, c, p))) return A.push(e);
          })) {
            x = !1;
            break;
          }
        } else if (v !== h && !s(v, h, t, c, p)) {
          x = !1;
          break;
        }
      }
      return p["delete"](n), p["delete"](e), x;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length; ++t < r;) if (e(n[t], t, n)) return !0;
      return !1;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length, o = 0, a = []; ++t < r;) {
        var i = n[t];
        e(i, t, n) && (a[o++] = i);
      }
      return a;
    };
  }, function (n, e, t) {
    var r = t(135),
      o = t(7),
      a = Object.prototype,
      i = a.hasOwnProperty,
      u = a.propertyIsEnumerable,
      c = r(function () {
        return arguments;
      }()) ? r : function (n) {
        return o(n) && i.call(n, "callee") && !u.call(n, "callee");
      };
    n.exports = c;
  }, function (n, e, t) {
    (function (n) {
      var r = t(3),
        o = t(136),
        a = e && !e.nodeType && e,
        i = a && "object" == typeof n && n && !n.nodeType && n,
        u = i && i.exports === a ? r.Buffer : void 0,
        c = (u ? u.isBuffer : void 0) || o;
      n.exports = c;
    }).call(this, t(53)(n));
  }, function (n, e) {
    n.exports = function (n) {
      return n.webpackPolyfill || (n.deprecate = function () {}, n.paths = [], n.children || (n.children = []), Object.defineProperty(n, "loaded", {
        enumerable: !0,
        get: function get() {
          return n.l;
        }
      }), Object.defineProperty(n, "id", {
        enumerable: !0,
        get: function get() {
          return n.i;
        }
      }), n.webpackPolyfill = 1), n;
    };
  }, function (n, e, t) {
    var r = t(137),
      o = t(138),
      a = t(139),
      i = a && a.isTypedArray,
      u = i ? o(i) : r;
    n.exports = u;
  }, function (n, e, t) {
    var r = t(8);
    n.exports = function (n) {
      return n == n && !r(n);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return function (t) {
        return null != t && t[n] === e && (void 0 !== e || n in Object(t));
      };
    };
  }, function (n, e, t) {
    var r = t(58),
      o = t(20);
    n.exports = function (n, e) {
      for (var t = 0, a = (e = r(e, n)).length; null != n && t < a;) n = n[o(e[t++])];
      return t && t == a ? n : void 0;
    };
  }, function (n, e, t) {
    var r = t(2),
      o = t(35),
      a = t(152),
      i = t(28);
    n.exports = function (n, e) {
      return r(n) ? n : o(n, e) ? [n] : a(i(n));
    };
  }, function (n, e) {
    n.exports = "data:image/png;base64,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";
  }, function (n, e, t) {
    var r = t(25),
      o = t(80),
      a = t(81),
      i = t(84),
      u = t(85),
      c = t(28),
      s = /^\s+|\s+$/g;
    n.exports = function (n, e, t) {
      if ((n = c(n)) && (t || void 0 === e)) return n.replace(s, "");
      if (!n || !(e = r(e))) return n;
      var p = u(n),
        f = u(e),
        l = i(p, f),
        g = a(p, f) + 1;
      return o(p, l, g).join("");
    };
  }, function (n, e, t) {
    var r = t(8),
      o = t(110),
      a = t(41),
      i = "Expected a function",
      u = Math.max,
      c = Math.min;
    n.exports = function (n, e, t) {
      var s,
        p,
        f,
        l,
        g,
        d,
        b = 0,
        x = !1,
        A = !1,
        v = !0;
      if ("function" != typeof n) throw new TypeError(i);
      function h(e) {
        var t = s,
          r = p;
        return s = p = void 0, b = e, l = n.apply(r, t);
      }
      function m(n) {
        var t = n - d;
        return void 0 === d || t >= e || t < 0 || A && n - b >= f;
      }
      function y() {
        var n = o();
        if (m(n)) return C(n);
        g = setTimeout(y, function (n) {
          var t = e - (n - d);
          return A ? c(t, f - (n - b)) : t;
        }(n));
      }
      function C(n) {
        return g = void 0, v && s ? h(n) : (s = p = void 0, l);
      }
      function k() {
        var n = o(),
          t = m(n);
        if (s = arguments, p = this, d = n, t) {
          if (void 0 === g) return function (n) {
            return b = n, g = setTimeout(y, e), x ? h(n) : l;
          }(d);
          if (A) return clearTimeout(g), g = setTimeout(y, e), h(d);
        }
        return void 0 === g && (g = setTimeout(y, e)), l;
      }
      return e = a(e) || 0, r(t) && (x = !!t.leading, f = (A = "maxWait" in t) ? u(a(t.maxWait) || 0, e) : f, v = "trailing" in t ? !!t.trailing : v), k.cancel = function () {
        void 0 !== g && clearTimeout(g), b = 0, s = d = p = g = void 0;
      }, k.flush = function () {
        return void 0 === g ? l : C(o());
      }, k;
    };
  }, function (n, e, t) {
    var r = t(42);
    n.exports = function (n) {
      var e = null == n ? 0 : n.length;
      return e ? r(n, 1, e) : [];
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n && n.length ? n[0] : void 0;
    };
  }, function (n, e, t) {
    var r = t(29),
      o = t(11),
      a = t(36),
      i = t(27),
      u = t(161),
      c = Math.max;
    n.exports = function (n, e, t, s) {
      n = o(n) ? n : u(n), t = t && !s ? i(t) : 0;
      var p = n.length;
      return t < 0 && (t = c(p + t, 0)), a(n) ? t <= p && n.indexOf(e, t) > -1 : !!p && r(n, e, t) > -1;
    };
  }, function (n, e) {
    n.exports = require$$1$1$1;
  }, function (n, e) {
    n.exports = TextField;
  }, function (n, e) {
    n.exports = InputAdornment;
  }, function (n, e) {
    n.exports = Button$2;
  }, function (n, e) {
    n.exports = Menu;
  }, function (n, e) {
    n.exports = Divider;
  }, function (n, e) {
    n.exports = NativeSelect;
  }, function (n, e) {
    n.exports = withStyles$1;
  }, function (n, e) {
    n.exports = MenuItem;
  }, function (n, e) {
    n.exports = RootRef;
  }, function (n, e) {
    var t;
    t = function () {
      return this;
    }();
    try {
      t = t || new Function("return this")();
    } catch (n) {
      "object" == typeof window && (t = window);
    }
    n.exports = t;
  }, function (n, e, t) {
    var r = t(14),
      o = Object.prototype,
      a = o.hasOwnProperty,
      i = o.toString,
      u = r ? r.toStringTag : void 0;
    n.exports = function (n) {
      var e = a.call(n, u),
        t = n[u];
      try {
        n[u] = void 0;
        var r = !0;
      } catch (n) {}
      var o = i.call(n);
      return r && (e ? n[u] = t : delete n[u]), o;
    };
  }, function (n, e) {
    var t = Object.prototype.toString;
    n.exports = function (n) {
      return t.call(n);
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      return n == n && (void 0 !== t && (n = n <= t ? n : t), void 0 !== e && (n = n >= e ? n : e)), n;
    };
  }, function (n, e, t) {
    var r = t(41),
      o = 1 / 0,
      a = 17976931348623157e292;
    n.exports = function (n) {
      return n ? (n = r(n)) === o || n === -o ? (n < 0 ? -1 : 1) * a : n == n ? n : 0 : 0 === n ? n : 0;
    };
  }, function (n, e, t) {
    var r = t(42);
    n.exports = function (n, e, t) {
      var o = n.length;
      return t = void 0 === t ? o : t, !e && t >= o ? n : r(n, e, t);
    };
  }, function (n, e, t) {
    var r = t(29);
    n.exports = function (n, e) {
      for (var t = n.length; t-- && r(e, n[t], 0) > -1;);
      return t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n != n;
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      for (var r = t - 1, o = n.length; ++r < o;) if (n[r] === e) return r;
      return -1;
    };
  }, function (n, e, t) {
    var r = t(29);
    n.exports = function (n, e) {
      for (var t = -1, o = n.length; ++t < o && r(e, n[t], 0) > -1;);
      return t;
    };
  }, function (n, e, t) {
    var r = t(86),
      o = t(87),
      a = t(88);
    n.exports = function (n) {
      return o(n) ? a(n) : r(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n.split("");
    };
  }, function (n, e) {
    var t = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
    n.exports = function (n) {
      return t.test(n);
    };
  }, function (n, e) {
    var t = "[\\ud800-\\udfff]",
      r = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
      o = "\\ud83c[\\udffb-\\udfff]",
      a = "[^\\ud800-\\udfff]",
      i = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      u = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      c = "(?:" + r + "|" + o + ")" + "?",
      s = "[\\ufe0e\\ufe0f]?" + c + ("(?:\\u200d(?:" + [a, i, u].join("|") + ")[\\ufe0e\\ufe0f]?" + c + ")*"),
      p = "(?:" + [a + r + "?", r, i, u, t].join("|") + ")",
      f = RegExp(o + "(?=" + o + ")|" + p + s, "g");
    n.exports = function (n) {
      return n.match(f) || [];
    };
  }, function (n, e, t) {
    var r = t(90),
      o = t(17),
      a = t(32);
    n.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new r(),
        map: new (a || o)(),
        string: new r()
      };
    };
  }, function (n, e, t) {
    var r = t(91),
      o = t(96),
      a = t(97),
      i = t(98),
      u = t(99);
    function c(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }
    c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e, t) {
    var r = t(16);
    n.exports = function () {
      this.__data__ = r ? r(null) : {}, this.size = 0;
    };
  }, function (n, e, t) {
    var r = t(44),
      o = t(93),
      a = t(8),
      i = t(45),
      u = /^\[object .+?Constructor\]$/,
      c = Function.prototype,
      s = Object.prototype,
      p = c.toString,
      f = s.hasOwnProperty,
      l = RegExp("^" + p.call(f).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    n.exports = function (n) {
      return !(!a(n) || o(n)) && (r(n) ? l : u).test(i(n));
    };
  }, function (n, e, t) {
    var r,
      o = t(94),
      a = (r = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";
    n.exports = function (n) {
      return !!a && a in n;
    };
  }, function (n, e, t) {
    var r = t(3)["__core-js_shared__"];
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n, e) {
      return null == n ? void 0 : n[e];
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = this.has(n) && delete this.__data__[n];
      return this.size -= e ? 1 : 0, e;
    };
  }, function (n, e, t) {
    var r = t(16),
      o = "__lodash_hash_undefined__",
      a = Object.prototype.hasOwnProperty;
    n.exports = function (n) {
      var e = this.__data__;
      if (r) {
        var t = e[n];
        return t === o ? void 0 : t;
      }
      return a.call(e, n) ? e[n] : void 0;
    };
  }, function (n, e, t) {
    var r = t(16),
      o = Object.prototype.hasOwnProperty;
    n.exports = function (n) {
      var e = this.__data__;
      return r ? void 0 !== e[n] : o.call(e, n);
    };
  }, function (n, e, t) {
    var r = t(16),
      o = "__lodash_hash_undefined__";
    n.exports = function (n, e) {
      var t = this.__data__;
      return this.size += this.has(n) ? 0 : 1, t[n] = r && void 0 === e ? o : e, this;
    };
  }, function (n, e) {
    n.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (n, e, t) {
    var r = t(18),
      o = Array.prototype.splice;
    n.exports = function (n) {
      var e = this.__data__,
        t = r(e, n);
      return !(t < 0) && (t == e.length - 1 ? e.pop() : o.call(e, t, 1), --this.size, !0);
    };
  }, function (n, e, t) {
    var r = t(18);
    n.exports = function (n) {
      var e = this.__data__,
        t = r(e, n);
      return t < 0 ? void 0 : e[t][1];
    };
  }, function (n, e, t) {
    var r = t(18);
    n.exports = function (n) {
      return r(this.__data__, n) > -1;
    };
  }, function (n, e, t) {
    var r = t(18);
    n.exports = function (n, e) {
      var t = this.__data__,
        o = r(t, n);
      return o < 0 ? (++this.size, t.push([n, e])) : t[o][1] = e, this;
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n) {
      var e = r(this, n)["delete"](n);
      return this.size -= e ? 1 : 0, e;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = typeof n;
      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== n : null === n;
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n) {
      return r(this, n).get(n);
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n) {
      return r(this, n).has(n);
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n, e) {
      var t = r(this, n),
        o = t.size;
      return t.set(n, e), this.size += t.size == o ? 0 : 1, this;
    };
  }, function (n, e, t) {
    var r = t(3);
    n.exports = function () {
      return r.Date.now();
    };
  }, function (n, e, t) {
    var r = t(112),
      o = t(149),
      a = t(56);
    n.exports = function (n) {
      var e = o(n);
      return 1 == e.length && e[0][2] ? a(e[0][0], e[0][1]) : function (t) {
        return t === n || r(t, n, e);
      };
    };
  }, function (n, e, t) {
    var r = t(46),
      o = t(47),
      a = 1,
      i = 2;
    n.exports = function (n, e, t, u) {
      var c = t.length,
        s = c,
        p = !u;
      if (null == n) return !s;
      for (n = Object(n); c--;) {
        var f = t[c];
        if (p && f[2] ? f[1] !== n[f[0]] : !(f[0] in n)) return !1;
      }
      for (; ++c < s;) {
        var l = (f = t[c])[0],
          g = n[l],
          d = f[1];
        if (p && f[2]) {
          if (void 0 === g && !(l in n)) return !1;
        } else {
          var b = new r();
          if (u) var x = u(g, d, l, n, e, b);
          if (!(void 0 === x ? o(d, g, a | i, u, b) : x)) return !1;
        }
      }
      return !0;
    };
  }, function (n, e, t) {
    var r = t(17);
    n.exports = function () {
      this.__data__ = new r(), this.size = 0;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = this.__data__,
        t = e["delete"](n);
      return this.size = e.size, t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.get(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.has(n);
    };
  }, function (n, e, t) {
    var r = t(17),
      o = t(32),
      a = t(30),
      i = 200;
    n.exports = function (n, e) {
      var t = this.__data__;
      if (t instanceof r) {
        var u = t.__data__;
        if (!o || u.length < i - 1) return u.push([n, e]), this.size = ++t.size, this;
        t = this.__data__ = new a(u);
      }
      return t.set(n, e), this.size = t.size, this;
    };
  }, function (n, e, t) {
    var r = t(46),
      o = t(48),
      a = t(123),
      i = t(127),
      u = t(144),
      c = t(2),
      s = t(52),
      p = t(54),
      f = 1,
      l = "[object Arguments]",
      g = "[object Array]",
      d = "[object Object]",
      b = Object.prototype.hasOwnProperty;
    n.exports = function (n, e, t, x, A, v) {
      var h = c(n),
        m = c(e),
        y = h ? g : u(n),
        C = m ? g : u(e),
        k = (y = y == l ? d : y) == d,
        w = (C = C == l ? d : C) == d,
        B = y == C;
      if (B && s(n)) {
        if (!s(e)) return !1;
        h = !0, k = !1;
      }
      if (B && !k) return v || (v = new r()), h || p(n) ? o(n, e, t, x, A, v) : a(n, e, y, t, x, A, v);
      if (!(t & f)) {
        var j = k && b.call(n, "__wrapped__"),
          P = w && b.call(e, "__wrapped__");
        if (j || P) {
          var O = j ? n.value() : n,
            E = P ? e.value() : e;
          return v || (v = new r()), A(O, E, t, x, v);
        }
      }
      return !!B && (v || (v = new r()), i(n, e, t, x, A, v));
    };
  }, function (n, e, t) {
    var r = t(30),
      o = t(120),
      a = t(121);
    function i(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.__data__ = new r(); ++e < t;) this.add(n[e]);
    }
    i.prototype.add = i.prototype.push = o, i.prototype.has = a, n.exports = i;
  }, function (n, e) {
    var t = "__lodash_hash_undefined__";
    n.exports = function (n) {
      return this.__data__.set(n, t), this;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.has(n);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return n.has(e);
    };
  }, function (n, e, t) {
    var r = t(14),
      o = t(124),
      a = t(31),
      i = t(48),
      u = t(125),
      c = t(126),
      s = 1,
      p = 2,
      f = "[object Boolean]",
      l = "[object Date]",
      g = "[object Error]",
      d = "[object Map]",
      b = "[object Number]",
      x = "[object RegExp]",
      A = "[object Set]",
      v = "[object String]",
      h = "[object Symbol]",
      m = "[object ArrayBuffer]",
      y = "[object DataView]",
      C = r ? r.prototype : void 0,
      k = C ? C.valueOf : void 0;
    n.exports = function (n, e, t, r, C, w, B) {
      switch (t) {
        case y:
          if (n.byteLength != e.byteLength || n.byteOffset != e.byteOffset) return !1;
          n = n.buffer, e = e.buffer;
        case m:
          return !(n.byteLength != e.byteLength || !w(new o(n), new o(e)));
        case f:
        case l:
        case b:
          return a(+n, +e);
        case g:
          return n.name == e.name && n.message == e.message;
        case x:
        case v:
          return n == e + "";
        case d:
          var j = u;
        case A:
          var P = r & s;
          if (j || (j = c), n.size != e.size && !P) return !1;
          var O = B.get(n);
          if (O) return O == e;
          r |= p, B.set(n, e);
          var E = i(j(n), j(e), r, C, w, B);
          return B["delete"](n), E;
        case h:
          if (k) return k.call(n) == k.call(e);
      }
      return !1;
    };
  }, function (n, e, t) {
    var r = t(3).Uint8Array;
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n) {
      var e = -1,
        t = Array(n.size);
      return n.forEach(function (n, r) {
        t[++e] = [r, n];
      }), t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = -1,
        t = Array(n.size);
      return n.forEach(function (n) {
        t[++e] = n;
      }), t;
    };
  }, function (n, e, t) {
    var r = t(128),
      o = 1,
      a = Object.prototype.hasOwnProperty;
    n.exports = function (n, e, t, i, u, c) {
      var s = t & o,
        p = r(n),
        f = p.length;
      if (f != r(e).length && !s) return !1;
      for (var l = f; l--;) {
        var g = p[l];
        if (!(s ? g in e : a.call(e, g))) return !1;
      }
      var d = c.get(n);
      if (d && c.get(e)) return d == e;
      var b = !0;
      c.set(n, e), c.set(e, n);
      for (var x = s; ++l < f;) {
        var A = n[g = p[l]],
          v = e[g];
        if (i) var h = s ? i(v, A, g, e, n, c) : i(A, v, g, n, e, c);
        if (!(void 0 === h ? A === v || u(A, v, t, i, c) : h)) {
          b = !1;
          break;
        }
        x || (x = "constructor" == g);
      }
      if (b && !x) {
        var m = n.constructor,
          y = e.constructor;
        m != y && "constructor" in n && "constructor" in e && !("function" == typeof m && m instanceof m && "function" == typeof y && y instanceof y) && (b = !1);
      }
      return c["delete"](n), c["delete"](e), b;
    };
  }, function (n, e, t) {
    var r = t(129),
      o = t(131),
      a = t(12);
    n.exports = function (n) {
      return r(n, a, o);
    };
  }, function (n, e, t) {
    var r = t(130),
      o = t(2);
    n.exports = function (n, e, t) {
      var a = e(n);
      return o(n) ? a : r(a, t(n));
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = e.length, o = n.length; ++t < r;) n[o + t] = e[t];
      return n;
    };
  }, function (n, e, t) {
    var r = t(50),
      o = t(132),
      a = Object.prototype.propertyIsEnumerable,
      i = Object.getOwnPropertySymbols,
      u = i ? function (n) {
        return null == n ? [] : (n = Object(n), r(i(n), function (e) {
          return a.call(n, e);
        }));
      } : o;
    n.exports = u;
  }, function (n, e) {
    n.exports = function () {
      return [];
    };
  }, function (n, e, t) {
    var r = t(134),
      o = t(51),
      a = t(2),
      i = t(52),
      u = t(33),
      c = t(54),
      s = Object.prototype.hasOwnProperty;
    n.exports = function (n, e) {
      var t = a(n),
        p = !t && o(n),
        f = !t && !p && i(n),
        l = !t && !p && !f && c(n),
        g = t || p || f || l,
        d = g ? r(n.length, String) : [],
        b = d.length;
      for (var x in n) !e && !s.call(n, x) || g && ("length" == x || f && ("offset" == x || "parent" == x) || l && ("buffer" == x || "byteLength" == x || "byteOffset" == x) || u(x, b)) || d.push(x);
      return d;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = Array(n); ++t < n;) r[t] = e(t);
      return r;
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(7),
      a = "[object Arguments]";
    n.exports = function (n) {
      return o(n) && r(n) == a;
    };
  }, function (n, e) {
    n.exports = function () {
      return !1;
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(34),
      a = t(7),
      i = {};
    i["[object Float32Array]"] = i["[object Float64Array]"] = i["[object Int8Array]"] = i["[object Int16Array]"] = i["[object Int32Array]"] = i["[object Uint8Array]"] = i["[object Uint8ClampedArray]"] = i["[object Uint16Array]"] = i["[object Uint32Array]"] = !0, i["[object Arguments]"] = i["[object Array]"] = i["[object ArrayBuffer]"] = i["[object Boolean]"] = i["[object DataView]"] = i["[object Date]"] = i["[object Error]"] = i["[object Function]"] = i["[object Map]"] = i["[object Number]"] = i["[object Object]"] = i["[object RegExp]"] = i["[object Set]"] = i["[object String]"] = i["[object WeakMap]"] = !1, n.exports = function (n) {
      return a(n) && o(n.length) && !!i[r(n)];
    };
  }, function (n, e) {
    n.exports = function (n) {
      return function (e) {
        return n(e);
      };
    };
  }, function (n, e, t) {
    (function (n) {
      var r = t(40),
        o = e && !e.nodeType && e,
        a = o && "object" == typeof n && n && !n.nodeType && n,
        i = a && a.exports === o && r.process,
        u = function () {
          try {
            var n = a && a.require && a.require("util").types;
            return n || i && i.binding && i.binding("util");
          } catch (n) {}
        }();
      n.exports = u;
    }).call(this, t(53)(n));
  }, function (n, e, t) {
    var r = t(141),
      o = t(142),
      a = Object.prototype.hasOwnProperty;
    n.exports = function (n) {
      if (!r(n)) return o(n);
      var e = [];
      for (var t in Object(n)) a.call(n, t) && "constructor" != t && e.push(t);
      return e;
    };
  }, function (n, e) {
    var t = Object.prototype;
    n.exports = function (n) {
      var e = n && n.constructor;
      return n === ("function" == typeof e && e.prototype || t);
    };
  }, function (n, e, t) {
    var r = t(143)(Object.keys, Object);
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n, e) {
      return function (t) {
        return n(e(t));
      };
    };
  }, function (n, e, t) {
    var r = t(145),
      o = t(32),
      a = t(146),
      i = t(147),
      u = t(148),
      c = t(6),
      s = t(45),
      p = s(r),
      f = s(o),
      l = s(a),
      g = s(i),
      d = s(u),
      b = c;
    (r && "[object DataView]" != b(new r(new ArrayBuffer(1))) || o && "[object Map]" != b(new o()) || a && "[object Promise]" != b(a.resolve()) || i && "[object Set]" != b(new i()) || u && "[object WeakMap]" != b(new u())) && (b = function b(n) {
      var e = c(n),
        t = "[object Object]" == e ? n.constructor : void 0,
        r = t ? s(t) : "";
      if (r) switch (r) {
        case p:
          return "[object DataView]";
        case f:
          return "[object Map]";
        case l:
          return "[object Promise]";
        case g:
          return "[object Set]";
        case d:
          return "[object WeakMap]";
      }
      return e;
    }), n.exports = b;
  }, function (n, e, t) {
    var r = t(9)(t(3), "DataView");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "Promise");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "Set");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "WeakMap");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(55),
      o = t(12);
    n.exports = function (n) {
      for (var e = o(n), t = e.length; t--;) {
        var a = e[t],
          i = n[a];
        e[t] = [a, i, r(i)];
      }
      return e;
    };
  }, function (n, e, t) {
    var r = t(47),
      o = t(151),
      a = t(154),
      i = t(35),
      u = t(55),
      c = t(56),
      s = t(20),
      p = 1,
      f = 2;
    n.exports = function (n, e) {
      return i(n) && u(e) ? c(s(n), e) : function (t) {
        var i = o(t, n);
        return void 0 === i && i === e ? a(t, n) : r(e, i, p | f);
      };
    };
  }, function (n, e, t) {
    var r = t(57);
    n.exports = function (n, e, t) {
      var o = null == n ? void 0 : r(n, e);
      return void 0 === o ? t : o;
    };
  }, function (n, e, t) {
    var r = t(153),
      o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      a = /\\(\\)?/g,
      i = r(function (n) {
        var e = [];
        return 46 === n.charCodeAt(0) && e.push(""), n.replace(o, function (n, t, r, o) {
          e.push(r ? o.replace(a, "$1") : t || n);
        }), e;
      });
    n.exports = i;
  }, function (n, e, t) {
    var r = t(22),
      o = 500;
    n.exports = function (n) {
      var e = r(n, function (n) {
          return t.size === o && t.clear(), n;
        }),
        t = e.cache;
      return e;
    };
  }, function (n, e, t) {
    var r = t(155),
      o = t(156);
    n.exports = function (n, e) {
      return null != n && o(n, e, r);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return null != n && e in Object(n);
    };
  }, function (n, e, t) {
    var r = t(58),
      o = t(51),
      a = t(2),
      i = t(33),
      u = t(34),
      c = t(20);
    n.exports = function (n, e, t) {
      for (var s = -1, p = (e = r(e, n)).length, f = !1; ++s < p;) {
        var l = c(e[s]);
        if (!(f = null != n && t(n, l))) break;
        n = n[l];
      }
      return f || ++s != p ? f : !!(p = null == n ? 0 : n.length) && u(p) && i(l, p) && (a(n) || o(n));
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n;
    };
  }, function (n, e, t) {
    var r = t(159),
      o = t(160),
      a = t(35),
      i = t(20);
    n.exports = function (n) {
      return a(n) ? r(i(n)) : o(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return function (e) {
        return null == e ? void 0 : e[n];
      };
    };
  }, function (n, e, t) {
    var r = t(57);
    n.exports = function (n) {
      return function (e) {
        return r(e, n);
      };
    };
  }, function (n, e, t) {
    var r = t(162),
      o = t(12);
    n.exports = function (n) {
      return null == n ? [] : r(n, o(n));
    };
  }, function (n, e, t) {
    var r = t(26);
    n.exports = function (n, e) {
      return r(e, function (e) {
        return n[e];
      });
    };
  }, function (n, e, t) {
    var r = t(21);
    n.exports = function (n, e) {
      var t = [];
      return r(n, function (n, r, o) {
        e(n, r, o) && t.push(n);
      }), t;
    };
  }, function (n, e, t) {
    var r = t(165),
      o = t(12);
    n.exports = function (n, e) {
      return n && r(n, e, o);
    };
  }, function (n, e, t) {
    var r = t(166)();
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n) {
      return function (e, t, r) {
        for (var o = -1, a = Object(e), i = r(e), u = i.length; u--;) {
          var c = i[n ? u : ++o];
          if (!1 === t(a[c], c, a)) break;
        }
        return e;
      };
    };
  }, function (n, e, t) {
    var r = t(11);
    n.exports = function (n, e) {
      return function (t, o) {
        if (null == t) return t;
        if (!r(t)) return n(t, o);
        for (var a = t.length, i = e ? a : -1, u = Object(t); (e ? i-- : ++i < a) && !1 !== o(u[i], i, u););
        return t;
      };
    };
  }, function (n, e, t) {
    var r = t(21),
      o = t(11);
    n.exports = function (n, e) {
      var t = -1,
        a = o(n) ? Array(n.length) : [];
      return r(n, function (n, r, o) {
        a[++t] = e(n, r, o);
      }), a;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r) {
      var o = -1,
        a = null == n ? 0 : n.length;
      for (r && a && (t = n[++o]); ++o < a;) t = e(t, n[o], o, n);
      return t;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r, o) {
      return o(n, function (n, o, a) {
        t = r ? (r = !1, n) : e(t, n, o, a);
      }), t;
    };
  }, function (n, e, t) {
    var r = t(10),
      o = t(11),
      a = t(12);
    n.exports = function (n) {
      return function (e, t, i) {
        var u = Object(e);
        if (!o(e)) {
          var c = r(t, 3);
          e = a(e), t = function t(n) {
            return c(u[n], n, u);
          };
        }
        var s = n(e, t, i);
        return s > -1 ? u[c ? e[s] : s] : void 0;
      };
    };
  }, function (n, e, t) {
    var r = t(21);
    n.exports = function (n, e) {
      var t;
      return r(n, function (n, r, o) {
        return !(t = e(n, r, o));
      }), !!t;
    };
  }, function (n, e, t) {
    var r = t(31),
      o = t(11),
      a = t(33),
      i = t(8);
    n.exports = function (n, e, t) {
      if (!i(t)) return !1;
      var u = typeof e;
      return !!("number" == u ? o(t) && a(e, t.length) : "string" == u && e in t) && r(t[e], n);
    };
  }, function (n, e, t) {
    var r = t(175);
    function o() {}
    function a() {}
    a.resetWarningCache = o, n.exports = function () {
      function n(n, e, t, o, a, i) {
        if (i !== r) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }
      function e() {
        return n;
      }
      n.isRequired = n;
      var t = {
        array: n,
        bool: n,
        func: n,
        number: n,
        object: n,
        string: n,
        symbol: n,
        any: n,
        arrayOf: e,
        element: n,
        elementType: n,
        instanceOf: e,
        node: n,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: a,
        resetWarningCache: o
      };
      return t.PropTypes = t, t;
    };
  }, function (n, e, t) {
    n.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (n, e, t) {
    var r = t(177);
    "string" == typeof r && (r = [[n.i, r, ""]]);
    var o = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    t(180)(r, o);
    r.locals && (n.exports = r.locals);
  }, function (n, e, t) {
    e = n.exports = t(178)(!1);
    var r = t(179)(t(59));
    e.push([n.i, ".flag {\n  width: 16px;\n  height: 11px;\n  background-image: url(" + r + ") !important;\n}\n.flag.margin {\n  margin-right: 8px;\n}\n.flag.ad {\n  background-position: -16px 0;\n}\n.flag.ae {\n  background-position: -32px 0;\n}\n.flag.af {\n  background-position: -48px 0;\n}\n.flag.ag {\n  background-position: -64px 0;\n}\n.flag.ai {\n  background-position: -80px 0;\n}\n.flag.al {\n  background-position: -96px 0;\n}\n.flag.am {\n  background-position: -112px 0;\n}\n.flag.ao {\n  background-position: -128px 0;\n}\n.flag.ar {\n  background-position: -144px 0;\n}\n.flag.as {\n  background-position: -160px 0;\n}\n.flag.at {\n  background-position: -176px 0;\n}\n.flag.au {\n  background-position: -192px 0;\n}\n.flag.aw {\n  background-position: -208px 0;\n}\n.flag.az {\n  background-position: -224px 0;\n}\n.flag.ba {\n  background-position: -240px 0;\n}\n.flag.bb {\n  background-position: 0 -11px;\n}\n.flag.bd {\n  background-position: -16px -11px;\n}\n.flag.be {\n  background-position: -32px -11px;\n}\n.flag.bf {\n  background-position: -48px -11px;\n}\n.flag.bg {\n  background-position: -64px -11px;\n}\n.flag.bh {\n  background-position: -80px -11px;\n}\n.flag.bi {\n  background-position: -96px -11px;\n}\n.flag.bj {\n  background-position: -112px -11px;\n}\n.flag.bm {\n  background-position: -128px -11px;\n}\n.flag.bn {\n  background-position: -144px -11px;\n}\n.flag.bo {\n  background-position: -160px -11px;\n}\n.flag.br {\n  background-position: -176px -11px;\n}\n.flag.bs {\n  background-position: -192px -11px;\n}\n.flag.bt {\n  background-position: -208px -11px;\n}\n.flag.bw {\n  background-position: -224px -11px;\n}\n.flag.by {\n  background-position: -240px -11px;\n}\n.flag.bz {\n  background-position: 0 -22px;\n}\n.flag.ca {\n  background-position: -16px -22px;\n}\n.flag.cd {\n  background-position: -32px -22px;\n}\n.flag.cf {\n  background-position: -48px -22px;\n}\n.flag.cg {\n  background-position: -64px -22px;\n}\n.flag.ch {\n  background-position: -80px -22px;\n}\n.flag.ci {\n  background-position: -96px -22px;\n}\n.flag.ck {\n  background-position: -112px -22px;\n}\n.flag.cl {\n  background-position: -128px -22px;\n}\n.flag.cm {\n  background-position: -144px -22px;\n}\n.flag.cn {\n  background-position: -160px -22px;\n}\n.flag.co {\n  background-position: -176px -22px;\n}\n.flag.cr {\n  background-position: -192px -22px;\n}\n.flag.cu {\n  background-position: -208px -22px;\n}\n.flag.cv {\n  background-position: -224px -22px;\n}\n.flag.cw {\n  background-position: -240px -22px;\n}\n.flag.cy {\n  background-position: 0 -33px;\n}\n.flag.cz {\n  background-position: -16px -33px;\n}\n.flag.de {\n  background-position: -32px -33px;\n}\n.flag.dj {\n  background-position: -48px -33px;\n}\n.flag.dk {\n  background-position: -64px -33px;\n}\n.flag.dm {\n  background-position: -80px -33px;\n}\n.flag.do {\n  background-position: -96px -33px;\n}\n.flag.dz {\n  background-position: -112px -33px;\n}\n.flag.ec {\n  background-position: -128px -33px;\n}\n.flag.ee {\n  background-position: -144px -33px;\n}\n.flag.eg {\n  background-position: -160px -33px;\n}\n.flag.er {\n  background-position: -176px -33px;\n}\n.flag.es {\n  background-position: -192px -33px;\n}\n.flag.et {\n  background-position: -208px -33px;\n}\n.flag.fi {\n  background-position: -224px -33px;\n}\n.flag.fj {\n  background-position: -240px -33px;\n}\n.flag.fk {\n  background-position: 0 -44px;\n}\n.flag.fm {\n  background-position: -16px -44px;\n}\n.flag.fo {\n  background-position: -32px -44px;\n}\n.flag.fr,\n.flag.bl,\n.flag.mf {\n  background-position: -48px -44px;\n}\n.flag.ga {\n  background-position: -64px -44px;\n}\n.flag.gb {\n  background-position: -80px -44px;\n}\n.flag.gd {\n  background-position: -96px -44px;\n}\n.flag.ge {\n  background-position: -112px -44px;\n}\n.flag.gf {\n  background-position: -128px -44px;\n}\n.flag.gh {\n  background-position: -144px -44px;\n}\n.flag.gi {\n  background-position: -160px -44px;\n}\n.flag.gl {\n  background-position: -176px -44px;\n}\n.flag.gm {\n  background-position: -192px -44px;\n}\n.flag.gn {\n  background-position: -208px -44px;\n}\n.flag.gp {\n  background-position: -224px -44px;\n}\n.flag.gq {\n  background-position: -240px -44px;\n}\n.flag.gr {\n  background-position: 0 -55px;\n}\n.flag.gt {\n  background-position: -16px -55px;\n}\n.flag.gu {\n  background-position: -32px -55px;\n}\n.flag.gw {\n  background-position: -48px -55px;\n}\n.flag.gy {\n  background-position: -64px -55px;\n}\n.flag.hk {\n  background-position: -80px -55px;\n}\n.flag.hn {\n  background-position: -96px -55px;\n}\n.flag.hr {\n  background-position: -112px -55px;\n}\n.flag.ht {\n  background-position: -128px -55px;\n}\n.flag.hu {\n  background-position: -144px -55px;\n}\n.flag.id {\n  background-position: -160px -55px;\n}\n.flag.ie {\n  background-position: -176px -55px;\n}\n.flag.il {\n  background-position: -192px -55px;\n}\n.flag.in {\n  background-position: -208px -55px;\n}\n.flag.io {\n  background-position: -224px -55px;\n}\n.flag.iq {\n  background-position: -240px -55px;\n}\n.flag.ir {\n  background-position: 0 -66px;\n}\n.flag.is {\n  background-position: -16px -66px;\n}\n.flag.it {\n  background-position: -32px -66px;\n}\n.flag.jm {\n  background-position: -48px -66px;\n}\n.flag.jo {\n  background-position: -64px -66px;\n}\n.flag.jp {\n  background-position: -80px -66px;\n}\n.flag.ke {\n  background-position: -96px -66px;\n}\n.flag.kg {\n  background-position: -112px -66px;\n}\n.flag.kh {\n  background-position: -128px -66px;\n}\n.flag.ki {\n  background-position: -144px -66px;\n}\n.flag.km {\n  background-position: -160px -66px;\n}\n.flag.kn {\n  background-position: -176px -66px;\n}\n.flag.kp {\n  background-position: -192px -66px;\n}\n.flag.kr {\n  background-position: -208px -66px;\n}\n.flag.kw {\n  background-position: -224px -66px;\n}\n.flag.ky {\n  background-position: -240px -66px;\n}\n.flag.kz {\n  background-position: 0 -77px;\n}\n.flag.la {\n  background-position: -16px -77px;\n}\n.flag.lb {\n  background-position: -32px -77px;\n}\n.flag.lc {\n  background-position: -48px -77px;\n}\n.flag.li {\n  background-position: -64px -77px;\n}\n.flag.lk {\n  background-position: -80px -77px;\n}\n.flag.lr {\n  background-position: -96px -77px;\n}\n.flag.ls {\n  background-position: -112px -77px;\n}\n.flag.lt {\n  background-position: -128px -77px;\n}\n.flag.lu {\n  background-position: -144px -77px;\n}\n.flag.lv {\n  background-position: -160px -77px;\n}\n.flag.ly {\n  background-position: -176px -77px;\n}\n.flag.ma {\n  background-position: -192px -77px;\n}\n.flag.mc {\n  background-position: -208px -77px;\n}\n.flag.md {\n  background-position: -224px -77px;\n}\n.flag.me {\n  background-position: -112px -154px;\n  height: 12px;\n}\n.flag.mg {\n  background-position: 0 -88px;\n}\n.flag.mh {\n  background-position: -16px -88px;\n}\n.flag.mk {\n  background-position: -32px -88px;\n}\n.flag.ml {\n  background-position: -48px -88px;\n}\n.flag.mm {\n  background-position: -64px -88px;\n}\n.flag.mn {\n  background-position: -80px -88px;\n}\n.flag.mo {\n  background-position: -96px -88px;\n}\n.flag.mp {\n  background-position: -112px -88px;\n}\n.flag.mq {\n  background-position: -128px -88px;\n}\n.flag.mr {\n  background-position: -144px -88px;\n}\n.flag.ms {\n  background-position: -160px -88px;\n}\n.flag.mt {\n  background-position: -176px -88px;\n}\n.flag.mu {\n  background-position: -192px -88px;\n}\n.flag.mv {\n  background-position: -208px -88px;\n}\n.flag.mw {\n  background-position: -224px -88px;\n}\n.flag.mx {\n  background-position: -240px -88px;\n}\n.flag.my {\n  background-position: 0 -99px;\n}\n.flag.mz {\n  background-position: -16px -99px;\n}\n.flag.na {\n  background-position: -32px -99px;\n}\n.flag.nc {\n  background-position: -48px -99px;\n}\n.flag.ne {\n  background-position: -64px -99px;\n}\n.flag.nf {\n  background-position: -80px -99px;\n}\n.flag.ng {\n  background-position: -96px -99px;\n}\n.flag.ni {\n  background-position: -112px -99px;\n}\n.flag.nl,\n.flag.bq {\n  background-position: -128px -99px;\n}\n.flag.no {\n  background-position: -144px -99px;\n}\n.flag.np {\n  background-position: -160px -99px;\n}\n.flag.nr {\n  background-position: -176px -99px;\n}\n.flag.nu {\n  background-position: -192px -99px;\n}\n.flag.nz {\n  background-position: -208px -99px;\n}\n.flag.om {\n  background-position: -224px -99px;\n}\n.flag.pa {\n  background-position: -240px -99px;\n}\n.flag.pe {\n  background-position: 0 -110px;\n}\n.flag.pf {\n  background-position: -16px -110px;\n}\n.flag.pg {\n  background-position: -32px -110px;\n}\n.flag.ph {\n  background-position: -48px -110px;\n}\n.flag.pk {\n  background-position: -64px -110px;\n}\n.flag.pl {\n  background-position: -80px -110px;\n}\n.flag.pm {\n  background-position: -96px -110px;\n}\n.flag.pr {\n  background-position: -112px -110px;\n}\n.flag.ps {\n  background-position: -128px -110px;\n}\n.flag.pt {\n  background-position: -144px -110px;\n}\n.flag.pw {\n  background-position: -160px -110px;\n}\n.flag.py {\n  background-position: -176px -110px;\n}\n.flag.qa {\n  background-position: -192px -110px;\n}\n.flag.re {\n  background-position: -208px -110px;\n}\n.flag.ro {\n  background-position: -224px -110px;\n}\n.flag.rs {\n  background-position: -240px -110px;\n}\n.flag.ru {\n  background-position: 0 -121px;\n}\n.flag.rw {\n  background-position: -16px -121px;\n}\n.flag.sa {\n  background-position: -32px -121px;\n}\n.flag.sb {\n  background-position: -48px -121px;\n}\n.flag.sc {\n  background-position: -64px -121px;\n}\n.flag.sd {\n  background-position: -80px -121px;\n}\n.flag.se {\n  background-position: -96px -121px;\n}\n.flag.sg {\n  background-position: -112px -121px;\n}\n.flag.sh {\n  background-position: -128px -121px;\n}\n.flag.si {\n  background-position: -144px -121px;\n}\n.flag.sk {\n  background-position: -160px -121px;\n}\n.flag.sl {\n  background-position: -176px -121px;\n}\n.flag.sm {\n  background-position: -192px -121px;\n}\n.flag.sn {\n  background-position: -208px -121px;\n}\n.flag.so {\n  background-position: -224px -121px;\n}\n.flag.sr {\n  background-position: -240px -121px;\n}\n.flag.ss {\n  background-position: 0 -132px;\n}\n.flag.st {\n  background-position: -16px -132px;\n}\n.flag.sv {\n  background-position: -32px -132px;\n}\n.flag.sx {\n  background-position: -48px -132px;\n}\n.flag.sy {\n  background-position: -64px -132px;\n}\n.flag.sz {\n  background-position: -80px -132px;\n}\n.flag.tc {\n  background-position: -96px -132px;\n}\n.flag.td {\n  background-position: -112px -132px;\n}\n.flag.tg {\n  background-position: -128px -132px;\n}\n.flag.th {\n  background-position: -144px -132px;\n}\n.flag.tj {\n  background-position: -160px -132px;\n}\n.flag.tk {\n  background-position: -176px -132px;\n}\n.flag.tl {\n  background-position: -192px -132px;\n}\n.flag.tm {\n  background-position: -208px -132px;\n}\n.flag.tn {\n  background-position: -224px -132px;\n}\n.flag.to {\n  background-position: -240px -132px;\n}\n.flag.tr {\n  background-position: 0 -143px;\n}\n.flag.tt {\n  background-position: -16px -143px;\n}\n.flag.tv {\n  background-position: -32px -143px;\n}\n.flag.tw {\n  background-position: -48px -143px;\n}\n.flag.tz {\n  background-position: -64px -143px;\n}\n.flag.ua {\n  background-position: -80px -143px;\n}\n.flag.ug {\n  background-position: -96px -143px;\n}\n.flag.us {\n  background-position: -112px -143px;\n}\n.flag.uy {\n  background-position: -128px -143px;\n}\n.flag.uz {\n  background-position: -144px -143px;\n}\n.flag.va {\n  background-position: -160px -143px;\n}\n.flag.vc {\n  background-position: -176px -143px;\n}\n.flag.ve {\n  background-position: -192px -143px;\n}\n.flag.vg {\n  background-position: -208px -143px;\n}\n.flag.vi {\n  background-position: -224px -143px;\n}\n.flag.vn {\n  background-position: -240px -143px;\n}\n.flag.vu {\n  background-position: 0 -154px;\n}\n.flag.wf {\n  background-position: -16px -154px;\n}\n.flag.ws {\n  background-position: -32px -154px;\n}\n.flag.ye {\n  background-position: -48px -154px;\n}\n.flag.za {\n  background-position: -64px -154px;\n}\n.flag.zm {\n  background-position: -80px -154px;\n}\n.flag.zw {\n  background-position: -96px -154px;\n}\n", ""]);
  }, function (n, e, t) {
    n.exports = function (n) {
      var e = [];
      return e.toString = function () {
        return this.map(function (e) {
          var t = function (n, e) {
            var t = n[1] || "",
              r = n[3];
            if (!r) return t;
            if (e && "function" == typeof btoa) {
              var o = (i = r, u = btoa(unescape(encodeURIComponent(JSON.stringify(i)))), c = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(u), "/*# ".concat(c, " */")),
                a = r.sources.map(function (n) {
                  return "/*# sourceURL=".concat(r.sourceRoot).concat(n, " */");
                });
              return [t].concat(a).concat([o]).join("\n");
            }
            var i, u, c;
            return [t].join("\n");
          }(e, n);
          return e[2] ? "@media ".concat(e[2], "{").concat(t, "}") : t;
        }).join("");
      }, e.i = function (n, t) {
        "string" == typeof n && (n = [[null, n, ""]]);
        for (var r = {}, o = 0; o < this.length; o++) {
          var a = this[o][0];
          null != a && (r[a] = !0);
        }
        for (var i = 0; i < n.length; i++) {
          var u = n[i];
          null != u[0] && r[u[0]] || (t && !u[2] ? u[2] = t : t && (u[2] = "(".concat(u[2], ") and (").concat(t, ")")), e.push(u));
        }
      }, e;
    };
  }, function (n, e, t) {
    n.exports = function (n, e) {
      return "string" != typeof (n = n.__esModule ? n["default"] : n) ? n : (/^['"].*['"]$/.test(n) && (n = n.slice(1, -1)), /["'() \t\n]/.test(n) || e ? '"'.concat(n.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : n);
    };
  }, function (n, e, t) {
    var r,
      o,
      a = {},
      i = (r = function r() {
        return window && document && document.all && !window.atob;
      }, function () {
        return void 0 === o && (o = r.apply(this, arguments)), o;
      }),
      u = function u(n, e) {
        return e ? e.querySelector(n) : document.querySelector(n);
      },
      c = function (n) {
        var e = {};
        return function (n, t) {
          if ("function" == typeof n) return n();
          if (void 0 === e[n]) {
            var r = u.call(this, n, t);
            if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
              r = r.contentDocument.head;
            } catch (n) {
              r = null;
            }
            e[n] = r;
          }
          return e[n];
        };
      }(),
      s = null,
      p = 0,
      f = [],
      l = t(181);
    function g(n, e) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t],
          o = a[r.id];
        if (o) {
          o.refs++;
          for (var i = 0; i < o.parts.length; i++) o.parts[i](r.parts[i]);
          for (; i < r.parts.length; i++) o.parts.push(h(r.parts[i], e));
        } else {
          var u = [];
          for (i = 0; i < r.parts.length; i++) u.push(h(r.parts[i], e));
          a[r.id] = {
            id: r.id,
            refs: 1,
            parts: u
          };
        }
      }
    }
    function d(n, e) {
      for (var t = [], r = {}, o = 0; o < n.length; o++) {
        var a = n[o],
          i = e.base ? a[0] + e.base : a[0],
          u = {
            css: a[1],
            media: a[2],
            sourceMap: a[3]
          };
        r[i] ? r[i].parts.push(u) : t.push(r[i] = {
          id: i,
          parts: [u]
        });
      }
      return t;
    }
    function b(n, e) {
      var t = c(n.insertInto);
      if (!t) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = f[f.length - 1];
      if ("top" === n.insertAt) r ? r.nextSibling ? t.insertBefore(e, r.nextSibling) : t.appendChild(e) : t.insertBefore(e, t.firstChild), f.push(e);else if ("bottom" === n.insertAt) t.appendChild(e);else {
        if ("object" != typeof n.insertAt || !n.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o = c(n.insertAt.before, t);
        t.insertBefore(e, o);
      }
    }
    function x(n) {
      if (null === n.parentNode) return !1;
      n.parentNode.removeChild(n);
      var e = f.indexOf(n);
      e >= 0 && f.splice(e, 1);
    }
    function A(n) {
      var e = document.createElement("style");
      if (void 0 === n.attrs.type && (n.attrs.type = "text/css"), void 0 === n.attrs.nonce) {
        var r = function () {
          return t.nc;
        }();
        r && (n.attrs.nonce = r);
      }
      return v(e, n.attrs), b(n, e), e;
    }
    function v(n, e) {
      Object.keys(e).forEach(function (t) {
        n.setAttribute(t, e[t]);
      });
    }
    function h(n, e) {
      var t, r, o, a;
      if (e.transform && n.css) {
        if (!(a = "function" == typeof e.transform ? e.transform(n.css) : e.transform["default"](n.css))) return function () {};
        n.css = a;
      }
      if (e.singleton) {
        var i = p++;
        t = s || (s = A(e)), r = C.bind(null, t, i, !1), o = C.bind(null, t, i, !0);
      } else n.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (t = function (n) {
        var e = document.createElement("link");
        return void 0 === n.attrs.type && (n.attrs.type = "text/css"), n.attrs.rel = "stylesheet", v(e, n.attrs), b(n, e), e;
      }(e), r = w.bind(null, t, e), o = function o() {
        x(t), t.href && URL.revokeObjectURL(t.href);
      }) : (t = A(e), r = k.bind(null, t), o = function o() {
        x(t);
      });
      return r(n), function (e) {
        if (e) {
          if (e.css === n.css && e.media === n.media && e.sourceMap === n.sourceMap) return;
          r(n = e);
        } else o();
      };
    }
    n.exports = function (n, e) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (e = e || {}).attrs = "object" == typeof e.attrs ? e.attrs : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = i()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
      var t = d(n, e);
      return g(t, e), function (n) {
        for (var r = [], o = 0; o < t.length; o++) {
          var i = t[o];
          (u = a[i.id]).refs--, r.push(u);
        }
        n && g(d(n, e), e);
        for (o = 0; o < r.length; o++) {
          var u;
          if (0 === (u = r[o]).refs) {
            for (var c = 0; c < u.parts.length; c++) u.parts[c]();
            delete a[u.id];
          }
        }
      };
    };
    var m,
      y = (m = [], function (n, e) {
        return m[n] = e, m.filter(Boolean).join("\n");
      });
    function C(n, e, t, r) {
      var o = t ? "" : r.css;
      if (n.styleSheet) n.styleSheet.cssText = y(e, o);else {
        var a = document.createTextNode(o),
          i = n.childNodes;
        i[e] && n.removeChild(i[e]), i.length ? n.insertBefore(a, i[e]) : n.appendChild(a);
      }
    }
    function k(n, e) {
      var t = e.css,
        r = e.media;
      if (r && n.setAttribute("media", r), n.styleSheet) n.styleSheet.cssText = t;else {
        for (; n.firstChild;) n.removeChild(n.firstChild);
        n.appendChild(document.createTextNode(t));
      }
    }
    function w(n, e, t) {
      var r = t.css,
        o = t.sourceMap,
        a = void 0 === e.convertToAbsoluteUrls && o;
      (e.convertToAbsoluteUrls || a) && (r = l(r)), o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
      var i = new Blob([r], {
          type: "text/css"
        }),
        u = n.href;
      n.href = URL.createObjectURL(i), u && URL.revokeObjectURL(u);
    }
  }, function (n, e) {
    n.exports = function (n) {
      var e = "undefined" != typeof window && window.location;
      if (!e) throw new Error("fixUrls requires window.location");
      if (!n || "string" != typeof n) return n;
      var t = e.protocol + "//" + e.host,
        r = t + e.pathname.replace(/\/[^\/]*$/, "/");
      return n.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (n, e) {
        var o,
          a = e.trim().replace(/^"(.*)"$/, function (n, e) {
            return e;
          }).replace(/^'(.*)'$/, function (n, e) {
            return e;
          });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(a) ? n : (o = 0 === a.indexOf("//") ? a : 0 === a.indexOf("/") ? t + a : r + a.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
      });
    };
  }, function (n, e, t) {
    t.r(e);
    var r = t(36),
      o = t.n(r),
      a = t(4),
      i = t.n(a),
      u = t(60),
      c = t.n(u),
      s = t(22),
      p = t.n(s),
      f = t(61),
      l = t.n(f),
      g = t(62),
      d = t.n(g),
      b = t(63),
      x = t.n(b),
      A = t(23),
      v = t.n(A),
      h = t(64),
      m = t.n(h),
      y = t(24),
      C = t.n(y),
      k = t(13),
      w = t.n(k),
      B = t(37),
      j = t.n(B),
      P = t(5),
      O = t.n(P),
      E = t(38),
      I = t.n(E),
      D = t(1),
      Q = t.n(D),
      S = t(0),
      T = t.n(S),
      M = t(65),
      R = t.n(M),
      F = t(66),
      U = t.n(F),
      L = t(67),
      N = t.n(L),
      z = t(68),
      K = t.n(z),
      G = t(69),
      H = t.n(G),
      q = t(70),
      Y = t.n(q),
      V = t(71),
      J = t.n(V),
      X = t(72),
      Z = t.n(X),
      W = t(39),
      _ = t.n(W),
      $ = t(73),
      nn = t.n($),
      en = t(74),
      tn = t.n(en);
    function rn(n) {
      return (rn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
        return typeof n;
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      })(n);
    }
    function on() {
      return (on = Object.assign || function (n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
      }).apply(this, arguments);
    }
    function an(n, e) {
      if (null == n) return {};
      var t,
        r,
        o = function (n, e) {
          if (null == n) return {};
          var t,
            r,
            o = {},
            a = Object.keys(n);
          for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || (o[t] = n[t]);
          return o;
        }(n, e);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(n);
        for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]);
      }
      return o;
    }
    function un(n, e) {
      for (var t = 0; t < e.length; t++) {
        var r = e[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
      }
    }
    function cn(n, e) {
      return !e || "object" !== rn(e) && "function" != typeof e ? function (n) {
        if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return n;
      }(n) : e;
    }
    function sn(n) {
      return (sn = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      })(n);
    }
    function pn(n, e) {
      return (pn = Object.setPrototypeOf || function (n, e) {
        return n.__proto__ = e, n;
      })(n, e);
    }
    var fn = function (n) {
      function e() {
        return function (n, e) {
          if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), cn(this, sn(e).apply(this, arguments));
      }
      var t, r;
      return function (n, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        n.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: n,
            writable: !0,
            configurable: !0
          }
        }), e && pn(n, e);
      }(e, n), t = e, (r = [{
        key: "render",
        value: function value() {
          var n = this.props,
            e = n.name,
            t = n.iso2,
            r = n.dialCode,
            o = n.localization,
            a = n.itemRef,
            i = n["native"],
            u = an(n, ["name", "iso2", "dialCode", "localization", "itemRef", "native"]);
          return i ? Q.a.createElement("option", on({
            className: "country",
            "data-dial-code": "1",
            "data-country-code": t,
            value: t
          }, u), o || e, " ", "+".concat(r)) : Q.a.createElement(tn.a, {
            rootRef: function rootRef(n) {
              return a(n);
            }
          }, Q.a.createElement(nn.a, on({
            className: "country",
            "data-dial-code": "1",
            "data-country-code": t
          }, u), Q.a.createElement("div", {
            className: "flag ".concat(t, " margin")
          }), Q.a.createElement("span", {
            className: "country-name"
          }, o || e), Q.a.createElement("span", {
            className: "dial-code"
          }, "+".concat(r))));
        }
      }]) && un(t.prototype, r), e;
    }(Q.a.PureComponent);
    fn.propTypes = {
      name: T.a.string.isRequired,
      iso2: T.a.string.isRequired,
      dialCode: T.a.string.isRequired,
      itemRef: T.a.func.isRequired,
      localization: T.a.string,
      "native": T.a.bool
    }, fn.defaultProps = {
      localization: null,
      "native": !1
    };
    var ln = fn;
    t(176), t(59);
    function gn(n) {
      return (gn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
        return typeof n;
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      })(n);
    }
    function dn() {
      return (dn = Object.assign || function (n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
      }).apply(this, arguments);
    }
    function bn(n, e) {
      var t = Object.keys(n);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(n);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        })), t.push.apply(t, r);
      }
      return t;
    }
    function xn(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = null != arguments[e] ? arguments[e] : {};
        e % 2 ? bn(t, !0).forEach(function (e) {
          Cn(n, e, t[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : bn(t).forEach(function (e) {
          Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(t, e));
        });
      }
      return n;
    }
    function An(n, e) {
      if (null == n) return {};
      var t,
        r,
        o = function (n, e) {
          if (null == n) return {};
          var t,
            r,
            o = {},
            a = Object.keys(n);
          for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || (o[t] = n[t]);
          return o;
        }(n, e);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(n);
        for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]);
      }
      return o;
    }
    function vn(n, e) {
      for (var t = 0; t < e.length; t++) {
        var r = e[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
      }
    }
    function hn(n) {
      return (hn = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      })(n);
    }
    function mn(n) {
      if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return n;
    }
    function yn(n, e) {
      return (yn = Object.setPrototypeOf || function (n, e) {
        return n.__proto__ = e, n;
      })(n, e);
    }
    function Cn(n, e, t) {
      return e in n ? Object.defineProperty(n, e, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[e] = t, n;
    }
    var kn = function (n) {
      function e(n) {
        var t;
        !function (n, e) {
          if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), t = function (n, e) {
          return !e || "object" !== gn(e) && "function" != typeof e ? mn(n) : e;
        }(this, hn(e).call(this, n)), Cn(mn(t), "flags", {}), Cn(mn(t), "guessSelectedCountry", p()(function (n, e, r) {
          var o = O()(e, {
            iso2: r
          }) || {};
          if ("" === c()(n)) return o;
          var a = j()(e, function (e, t) {
            if (i()(n, t.dialCode)) {
              if (t.dialCode.length > e.dialCode.length) return t;
              if (t.dialCode.length === e.dialCode.length && t.priority < e.priority) return t;
            }
            return e;
          }, {
            dialCode: "",
            priority: 10001
          }, mn(t));
          return a.name ? a : o;
        })), Cn(mn(t), "getProbableCandidate", p()(function (n) {
          if (!n || 0 === n.length) return null;
          var e = t.state.onlyCountries;
          return C()(e, function (e) {
            return i()(e.name.toLowerCase(), n.toLowerCase());
          }, mn(t))[0];
        })), Cn(mn(t), "getOnlyCountries", function (n, e) {
          return 0 === n.length ? e : e.filter(function (e) {
            return n.some(function (n) {
              return n === e.iso2;
            });
          });
        }), Cn(mn(t), "excludeCountries", function (n, e) {
          return 0 === e.length ? n : C()(n, function (n) {
            return !m()(e, n.iso2);
          });
        }), Cn(mn(t), "filterRegions", function (n, e) {
          if ("string" == typeof n) {
            var t = n;
            return e.filter(function (n) {
              return n.regions.some(function (n) {
                return n === t;
              });
            });
          }
          return e.filter(function (e) {
            return n.map(function (n) {
              return e.regions.some(function (e) {
                return e === n;
              });
            }).some(function (n) {
              return n;
            });
          });
        }), Cn(mn(t), "deleteAreaCodes", function (n) {
          return n.filter(function (n) {
            return !0 !== n.isAreaCode;
          });
        }), Cn(mn(t), "updateDefaultCountry", function (n) {
          var e = t.state.onlyCountries,
            r = t.props.disableCountryCode,
            o = O()(e, {
              iso2: n
            });
          t.setState({
            defaultCountry: n,
            selectedCountry: o,
            formattedNumber: r ? "" : "+".concat(o.dialCode)
          });
        }), Cn(mn(t), "scrollTo", function (n) {
          if (n) {
            var e = t.dropdownContainerRef;
            e && document.body && (e.scrollTop = n.offsetTop);
          }
        }), Cn(mn(t), "formatNumber", function (n, e) {
          var r,
            o = t.props,
            a = o.disableCountryCode,
            i = o.enableLongNumbers,
            u = o.autoFormat;
          if (a && e ? ((r = e.split(" ")).shift(), r = r.join(" ")) : r = e, !n || 0 === n.length) return a ? "" : "+";
          if (n && n.length < 2 || !r || !u) return a ? n : "+".concat(n);
          var c,
            s = j()(r, function (n, e) {
              return 0 === n.remainingText.length ? n : "." !== e ? {
                formattedText: n.formattedText + e,
                remainingText: n.remainingText
              } : {
                formattedText: n.formattedText + x()(n.remainingText),
                remainingText: d()(n.remainingText)
              };
            }, {
              formattedText: "",
              remainingText: n.split("")
            });
          return (c = i ? s.formattedText + s.remainingText.join("") : s.formattedText).includes("(") && !c.includes(")") && (c += ")"), c;
        }), Cn(mn(t), "cursorToEnd", function () {
          var n = t.props.isModernBrowser,
            e = t.inputRef;
          if (e.focus(), n) {
            var r = e.value.length;
            e.setSelectionRange(r, r);
          }
        }), Cn(mn(t), "getElement", function (n) {
          return t.flags["flag_no_".concat(n)];
        }), Cn(mn(t), "getCountryData", function () {
          var n = t.state.selectedCountry;
          return n ? {
            name: n.name || "",
            dialCode: n.dialCode || "",
            countryCode: n.iso2 || ""
          } : {};
        }), Cn(mn(t), "handleInput", function (n) {
          var e = t.state,
            r = e.selectedCountry,
            o = e.freezeSelection,
            a = t.state,
            i = a.selectedCountry,
            u = a.formattedNumber,
            c = a.onlyCountries,
            s = a.defaultCountry,
            p = t.props,
            f = p.disableCountryCode,
            l = p.countryCodeEditable,
            g = p.isModernBrowser,
            d = p.onChange,
            b = f ? "" : "+";
          if (!l) {
            var x = "+".concat(r.dialCode);
            if (n.target.value.length < x.length) return;
          }
          if (!(n.target.value.replace(/\D/g, "").length > 15) && n.target.value !== u) {
            if (n.preventDefault ? n.preventDefault() : n.returnValue = !1, n.target.value.length > 0) {
              var A = n.target.value.replace(/\D/g, "");
              (!o || i.dialCode.length > A.length) && (r = t.guessSelectedCountry(A.substring(0, 6), c, s), o = !1), b = t.formatNumber(A, r.format);
            }
            var v = n.target.selectionStart,
              h = b.length - u.length;
            t.setState({
              formattedNumber: b,
              freezeSelection: o,
              selectedCountry: r.dialCode ? r : i
            }, function () {
              g && (h > 0 && (v -= h), ")" === b.charAt(b.length - 1) ? t.inputRef.setSelectionRange(b.length - 1, b.length - 1) : v > 0 && u.length >= b.length && t.inputRef.setSelectionRange(v, v));
              d && d(b, t.getCountryData());
            });
          }
        }), Cn(mn(t), "handleRefInput", function (n) {
          var e,
            r = t.props,
            o = r.inputRef,
            a = r.InputProps;
          t.inputRef = n, o ? e = o : a && a.ref && (e = a.ref), e && ("function" == typeof e ? e(n) : e.current = n);
        }), Cn(mn(t), "handleInputClick", function (n) {
          var e = t.props.onClick;
          e && e(n, t.getCountryData());
        }), Cn(mn(t), "handleFlagItemClick", function (n) {
          var e = t.state,
            r = e.formattedNumber,
            a = e.selectedCountry,
            i = e.onlyCountries,
            u = t.props.onChange,
            c = a,
            s = o()(n) ? O()(i, function (e) {
              return e.iso2 === n;
            }) : O()(i, n),
            p = r.replace(" ", "").replace("(", "").replace(")", "").replace("-", ""),
            f = p.length > 1 ? p.replace(c.dialCode, s.dialCode) : s.dialCode,
            l = t.formatNumber(f.replace(/\D/g, ""), s.format);
          t.setState({
            anchorEl: null,
            selectedCountry: s,
            freezeSelection: !0,
            formattedNumber: l
          }, function () {
            t.cursorToEnd(), u && u(l, t.getCountryData());
          });
        }), Cn(mn(t), "handleInputFocus", function (n) {
          var e = t.state.selectedCountry,
            r = t.props,
            o = r.disableCountryCode,
            a = r.onFocus;
          t.inputRef && "+" === t.inputRef.value && e && !o && t.setState({
            formattedNumber: "+".concat(e.dialCode)
          }, function () {
            return setTimeout(t.cursorToEnd, 10);
          }), t.setState({
            placeholder: ""
          }), a && a(n, t.getCountryData()), setTimeout(t.cursorToEnd, 10);
        }), Cn(mn(t), "handleInputBlur", function (n) {
          var e = t.props,
            r = e.placeholder,
            o = e.onBlur;
          n.target.value || t.setState({
            placeholder: r
          }), o && o(n, t.getCountryData());
        }), Cn(mn(t), "getHighlightCountryIndex", function (n) {
          var e = t.state,
            r = e.highlightCountryIndex,
            o = e.onlyCountries,
            a = e.preferredCountries,
            i = r + n;
          return i < 0 || i >= o.length + a.length ? i - n : i;
        }), Cn(mn(t), "searchCountry", function () {
          var n = t.state,
            e = n.queryString,
            r = n.onlyCountries,
            o = n.preferredCountries,
            a = t.getProbableCandidate(e) || r[0],
            i = v()(r, a) + o.length;
          t.scrollTo(t.getElement(i), !0), t.setState({
            queryString: "",
            highlightCountryIndex: i
          });
        }), Cn(mn(t), "handleKeydown", function (n) {
          var e = t.state,
            r = e.anchorEl,
            o = e.highlightCountryIndex,
            a = e.preferredCountries,
            i = e.onlyCountries,
            u = e.queryString,
            c = e.debouncedQueryStingSearcher,
            s = t.props,
            p = s.keys,
            f = s.disabled;
          if (r && !f) {
            n.preventDefault ? n.preventDefault() : n.returnValue = !1;
            var l = function l(n) {
              t.setState({
                highlightCountryIndex: t.getHighlightCountryIndex(n)
              }, function () {
                t.scrollTo(t.getElement(o + a.length), !0);
              });
            };
            switch (n.which) {
              case p.DOWN:
                l(1);
                break;
              case p.UP:
                l(-1);
                break;
              case p.ENTER:
                t.handleFlagItemClick(i[o], n);
                break;
              case p.ESC:
                t.setState({
                  anchorEl: null
                }, t.cursorToEnd);
                break;
              default:
                (n.which >= p.A && n.which <= p.Z || n.which === p.SPACE) && t.setState({
                  queryString: u + String.fromCharCode(n.which)
                }, c);
            }
          }
        }), Cn(mn(t), "handleInputKeyDown", function (n) {
          var e = t.props,
            r = e.keys,
            o = e.onEnterKeyPress,
            a = e.onKeyDown;
          n.which === r.ENTER && o && o(n), a && a(n);
        }), Cn(mn(t), "checkIfValid", function () {
          var n = t.state.formattedNumber;
          return (0, t.props.isValid)(n.replace(/\D/g, ""));
        }), Cn(mn(t), "updateFormattedNumber", function (n) {
          var e,
            r = t.state,
            o = r.onlyCountries,
            a = r.defaultCountry,
            u = t.props.disableCountryCode,
            c = n,
            s = n;
          if (c.startsWith("+")) c = c.replace(/\D/g, ""), e = t.guessSelectedCountry(c.substring(0, 6), o, a), s = t.formatNumber(c, e.format);else {
            var p = (e = O()(o, {
              iso2: a
            })) && !i()(c.replace(/\D/g, ""), e.dialCode) ? e.dialCode : "";
            s = t.formatNumber((u ? "" : p) + c.replace(/\D/g, ""), e ? e.format : void 0);
          }
          t.setState({
            selectedCountry: e,
            formattedNumber: s
          });
        }), Cn(mn(t), "getDropdownProps", function () {
          var n = t.state,
            e = n.selectedCountry,
            r = n.anchorEl,
            o = n.preferredCountries,
            a = n.onlyCountries,
            i = t.props,
            u = i.classes,
            c = i.dropdownClass,
            s = i.localization,
            p = i.disableDropdown,
            f = i["native"],
            l = "flag ".concat(e.iso2),
            g = function g(n) {
              return Boolean(e && e.dialCode === n.dialCode);
            };
          return p ? {} : {
            startAdornment: Q.a.createElement(N.a, {
              className: u.positionStart,
              position: "start"
            }, f ? Q.a.createElement(Q.a.Fragment, null, Q.a.createElement(J.a, {
              id: "country-menu",
              open: Boolean(r),
              onClose: function onClose() {
                return t.setState({
                  anchorEl: null
                });
              },
              className: u["native"],
              classes: {
                root: R()(u.nativeRoot, "native", l),
                select: u.nativeSelect
              },
              onChange: function onChange(n) {
                return t.handleFlagItemClick(n.target.value);
              },
              disableUnderline: !0
            }, !!o.length && w()(o, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name],
                "native": !0
              });
            }), w()(a, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name],
                "native": !0
              });
            }))) : Q.a.createElement(Q.a.Fragment, null, Q.a.createElement(K.a, {
              className: u.flagButton,
              "aria-owns": r ? "country-menu" : null,
              "aria-label": "Select country",
              onClick: function onClick(n) {
                return t.setState({
                  anchorEl: n.currentTarget
                });
              },
              "aria-haspopup": !0
            }, Q.a.createElement("div", {
              className: l
            })), Q.a.createElement(H.a, {
              className: c,
              id: "country-menu",
              anchorEl: r,
              open: Boolean(r),
              onClose: function onClose() {
                return t.setState({
                  anchorEl: null
                });
              }
            }, !!o.length && w()(o, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                selected: g(n),
                onClick: function onClick() {
                  return t.handleFlagItemClick(n);
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name]
              });
            }), !!o.length && Q.a.createElement(Y.a, null), w()(a, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                selected: g(n),
                onClick: function onClick() {
                  return t.handleFlagItemClick(n);
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name]
              });
            }))))
          };
        });
        var r = _.a.allCountries;
        n.disableAreaCodes && (r = t.deleteAreaCodes(r)), n.regions && (r = t.filterRegions(n.regions, r));
        var a,
          u = t.excludeCountries(t.getOnlyCountries(n.onlyCountries, r), n.excludeCountries),
          s = C()(r, function (e) {
            return I()(n.preferredCountries, function (n) {
              return n === e.iso2;
            });
          }),
          f = n.value || "";
        a = f.length > 1 ? t.guessSelectedCountry(f.replace(/\D/g, "").substring(0, 6), u, n.defaultCountry) || 0 : n.defaultCountry && O()(u, {
          iso2: n.defaultCountry
        }) || 0;
        var g = v()(t.allCountries, a),
          b = f.length < 2 && a && !i()(f.replace(/\D/g, ""), a.dialCode) ? a.dialCode : "",
          A = "" === f && 0 === a ? "" : t.formatNumber((n.disableCountryCode ? "" : b) + f.replace(/\D/g, ""), a.name ? a.format : void 0);
        return t.state = {
          formattedNumber: A,
          placeholder: n.placeholder,
          onlyCountries: u,
          preferredCountries: s,
          defaultCountry: n.defaultCountry,
          selectedCountry: a,
          highlightCountryIndex: g,
          queryString: "",
          freezeSelection: !1,
          debouncedQueryStingSearcher: l()(t.searchCountry, 100),
          anchorEl: null
        }, t;
      }
      var t, r;
      return function (n, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        n.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: n,
            writable: !0,
            configurable: !0
          }
        }), e && yn(n, e);
      }(e, n), t = e, (r = [{
        key: "componentDidMount",
        value: function value() {
          document.addEventListener && document.addEventListener("keydown", this.handleKeydown);
        }
      }, {
        key: "componentDidUpdate",
        value: function value(n) {
          var e = n.value,
            t = this.state,
            r = t.defaultCountry,
            o = t.formattedNumber,
            a = this.props,
            i = a.defaultCountry,
            u = a.value;
          i && i !== r && this.updateDefaultCountry(i), "string" == typeof u && u !== e && u !== o && this.updateFormattedNumber(u);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          document.removeEventListener && document.removeEventListener("keydown", this.handleKeydown);
        }
      }, {
        key: "render",
        value: function value() {
          var n = this.state,
            e = n.formattedNumber,
            t = n.placeholder,
            r = this.props,
            o = r.inputClass,
            a = r.error,
            i = r.InputProps,
            u = An(r, ["native", "defaultCountry", "excludeCountries", "onlyCountries", "preferredCountries", "dropdownClass", "autoFormat", "disableAreaCodes", "isValid", "disableCountryCode", "disableDropdown", "enableLongNumbers", "countryCodeEditable", "onEnterKeyPress", "isModernBrowser", "classes", "keys", "localization", "placeholder", "regions", "onChange", "value", "inputClass", "error", "InputProps"]),
            c = this.getDropdownProps();
          return Q.a.createElement(U.a, dn({
            placeholder: t,
            value: e,
            className: o,
            inputRef: this.handleRefInput,
            error: a || !this.checkIfValid(),
            onChange: this.handleInput,
            onClick: this.handleInputClick,
            onFocus: this.handleInputFocus,
            onBlur: this.handleInputBlur,
            onKeyDown: this.handleInputKeyDown,
            type: "tel",
            InputProps: xn({}, c, {}, i)
          }, u));
        }
      }]) && vn(t.prototype, r), e;
    }(Q.a.Component);
    kn.propTypes = {
      classes: T.a.object,
      excludeCountries: T.a.arrayOf(T.a.string),
      onlyCountries: T.a.arrayOf(T.a.string),
      preferredCountries: T.a.arrayOf(T.a.string),
      defaultCountry: T.a.string,
      value: T.a.string,
      placeholder: T.a.string,
      disabled: T.a.bool,
      error: T.a.bool,
      variant: T.a.string,
      "native": T.a.bool,
      inputClass: T.a.string,
      dropdownClass: T.a.string,
      InputProps: T.a.object,
      inputProps: T.a.object,
      inputRef: T.a.func,
      autoFormat: T.a.bool,
      disableAreaCodes: T.a.bool,
      disableCountryCode: T.a.bool,
      disableDropdown: T.a.bool,
      enableLongNumbers: T.a.bool,
      countryCodeEditable: T.a.bool,
      regions: T.a.oneOfType([T.a.string, T.a.arrayOf(T.a.string)]),
      localization: T.a.object,
      onChange: T.a.func,
      onFocus: T.a.func,
      onBlur: T.a.func,
      onClick: T.a.func,
      onKeyDown: T.a.func,
      isValid: T.a.func,
      isModernBrowser: T.a.func,
      onEnterKeyPress: T.a.func,
      keys: T.a.object
    }, kn.defaultProps = {
      excludeCountries: [],
      onlyCountries: [],
      preferredCountries: [],
      defaultCountry: "",
      placeholder: "+1 (702) 123-4567",
      disabled: !1,
      error: !1,
      variant: "standard",
      "native": !1,
      inputClass: "",
      dropdownClass: "",
      autoFormat: !0,
      disableAreaCodes: !1,
      isValid: function isValid(n) {
        return I()(_.a.allCountries, function (e) {
          return i()(n, e.dialCode) || i()(e.dialCode, n);
        });
      },
      disableCountryCode: !1,
      disableDropdown: !1,
      enableLongNumbers: !1,
      countryCodeEditable: !0,
      regions: "",
      localization: {},
      onEnterKeyPress: function onEnterKeyPress() {},
      onChange: function onChange() {},
      isModernBrowser: function isModernBrowser() {
        return !!document.createElement && Boolean(document.createElement("input").setSelectionRange);
      },
      keys: {
        UP: 38,
        DOWN: 40,
        RIGHT: 39,
        LEFT: 37,
        ENTER: 13,
        ESC: 27,
        PLUS: 43,
        A: 65,
        Z: 90,
        SPACE: 32
      }
    }, kn.displayName = "MuiPhoneNumber";
    var wn = Z()(function () {
      return {
        flagButton: {
          minWidth: 30,
          padding: 0,
          height: 30
        },
        "native": {
          width: 30,
          height: 30,
          padding: 8
        },
        nativeRoot: {
          padding: 0,
          "& + svg": {
            display: "none"
          }
        },
        nativeSelect: {
          padding: 0,
          lineHeight: 0,
          height: 11
        },
        positionStart: {
          position: "relative"
        }
      };
    })(kn);
    e["default"] = wn;
  }]);
});
var MuiPhoneNumber$1$1 = unwrapExports$1$1(dist$1$1);
var IRPF$1$1$1 = "IRPF";
var IVA$1$1$1 = "IVA";
var NIF$1$1$1 = "NIF";
var betweenMinAndMaxKilometers$1$1$1 = "Entre {{min}} y {{max}} kilómetros";
var metricUnits$1$1$1 = {
  u: "km",
  up: "kms",
  U: "Km",
  Up: "Kms",
  unit: "kilómetro",
  units: "kilómetros",
  Unit: "Kilómetro",
  Units: "Kilómetros",
  unitSpecialCase1: "Kms",
  unitSpecialCase2: "KM",
  ad: "el",
  adp: "los",
  uFranquise: "km franquicia",
  UpFranquise: "Kms franquicia",
  maxUnits: "Kilómetros max.",
  betweenMinAndMaxunits: "Entre {{min}} y {{max}} kilómetros",
  km: "km",
  kms: "kms",
  kilometer: "Kilómetro",
  maxKilometers: "Kilómetros max.",
  "rates-concepts": {
    km: "Tarifa por km"
  },
  searchTools: "nothing"
};
var imperialUnits$1$1$1 = {
  u: "mi",
  up: "mi",
  U: "Mi",
  Up: "Mi",
  unit: "milla",
  units: "millas",
  Unit: "Milla",
  Units: "Millas",
  unitSpecialCase1: "Millas",
  unitSpecialCase2: "MILLA",
  ad: "la",
  adp: "las",
  uFranquise: "mi franquicia",
  UpFranquise: "Mi franquicia",
  maxUnits: "Millas max.",
  betweenMinAndMaxunits: "Entre {{min}} y {{max}} millas",
  "rates-concepts": {
    km: "Tarifa por milla"
  },
  searchTools: "nothing",
  providerEditRateHeaderText: "Completa la información de las millas de la franquicia, las geocercas y las tarifas por medio, de cada depósito."
};
var A$2$1$1 = "A";
var accept$1$1$1 = "Aceptar";
var accepted$1$1$1 = "Aceptado";
var acceptUpdate$1$1$1 = "Aceptar actualización";
var accessToTheViews$1$1$1 = "Acceso a las vistas";
var accessWithMicrosoft$1$1$1 = "Acceder con Microsoft";
var activateGuardMode$1$1$1 = "Activar modo guardia";
var activateGuardModeWarningText$1$1$1 = "¿Seguro que deseas activar el modo guardia?";
var activateGuardModeWarningAditionalText$1$1$1 = "Al hacerlo, pasarás a operar como un proveedor automático y las compañías enviarán los servicios directamente a los recursos.";
var active$1$1$1 = "Activo";
var activity$1$1$1 = "Actividad";
var accumulateNightAndHolidaySurcharge$1$1$1 = "Acumular recargo nocturno y festivo";
var add$1$1$1 = "Añadir";
var addAuxService$1$1$1 = "Añadir servicio auxiliar";
var addCapability$1$1$1 = "Añadir prestación";
var addCollective$1$1$1 = "Añadir colectivo";
var addCost$1$1$1 = "Añadir costo";
var addCostType$1$1$1 = "Añadir tipo de costo";
var addedCollective$1$1$1 = "Colectivo añadido";
var addFault$1$1$1 = "Añadir avería";
var addedFault$1$1$1 = "Avería añadida";
var additionalInformation$1$1$1 = "Información adicional";
var additionalPrice$1$1$1 = "Precio adicionales";
var additionalPriceAbbrev$1$1$1 = "Precio resto";
var addNote$1$1$1 = "Añadir nota";
var address$1$1$1 = "Dirección";
var addressNotLocated$1$1$1 = "Dirección no localizada";
var addUserProfile$1$1$1 = "Añadir perfil de usuario";
var admin$1$1$1 = "Administrador";
var advancedConfiguration$1$1$1 = "Configuración avanzada";
var aheadServices$1$1$1 = "Servicios por delante";
var alert$1$1$1 = "Alerta";
var alerts$1$1$1 = "Alertas";
var alertStart$1$1$1 = "Inicio alerta";
var all_f$1$1$1 = "Todas";
var all_m$1$1$1 = "Todos";
var allowAccess$1$1$1 = "Permitir acceso";
var allowCalls$1$1$1 = "Permite llamadas";
var allowCalls_addService$1$1$1 = "Permitir llamadas";
var allowGuardErrorTitle$1$1$1 = "No se puede activar el Modo guardia";
var allowGuardErrorText$1$1$1 = "No se puede si hay servicios pendientes de aceptación o asignación.";
var allowSMS$1$1$1 = "Permite SMS";
var allProvidersAutomatic$1$1$1 = "Todos los proveedores (Automático)";
var anErrorHasOccurred$1$1$1 = "Ha ocurrido un error";
var applyCosts$1$1$1 = "Aplicar gastos";
var approve$1$1$1 = "Aprobar";
var assign$1$1$1 = "Asignar";
var assignTechnician$1$1$1 = "Asignar técnico";
var assistance$1$1$1 = "Asistencia";
var assistanceWithoutTransfer$1$1$1 = "Asistencia sin traslado";
var assistanceWithoutTransferWarning$1$1$1 = "No has seleccionado ningún traslado.";
var assistanceWithoutTransferWarningQuestion$1$1$1 = "¿Deseas continuar con el servicio de asistencia, sin traslado a personas?";
var assisted$1$1$1 = "Asistido";
var assistedInsuredAbbrev$1$1$1 = "Asistido/Aseg.";
var assistedDestinationAddress$1$1$1 = "Dirección de destino del asistido";
var associatedDocuments$1$1$1 = "Documentos asociados";
var at_time$1$1$1 = "a las {{time}} h";
var assigned$1$1$1 = "Agendado";
var ASSIGNED$1$1$1 = "Agendado";
var attachADocument$1$1$1 = "Adjuntar un documento";
var attachment$1$1$1 = "Adjuntar";
var attachments$1$1$1 = "Adjuntos";
var auction$1$1$1 = "Subastar";
var auctionConfiguration$1$1$1 = "Configuración subastas";
var auctioned$1$1$1 = "En subasta";
var AUCTIONED$1$1$1 = "En subasta";
var auctioning$1$1$1 = "En subasta";
var AUCTIONING$1$1$1 = "En subasta";
var auctionInPriority$1$1$1 = "En subasta";
var auctionInPriority1$1$1$1 = "Subasta en prioridad 1";
var auctionInPriority2$1$1$1 = "Subasta en prioridad 2";
var auctionInPriority3$1$1$1 = "Subasta en prioridad 3";
var auctionInPriority4$1$1$1 = "Subasta en prioridad Global";
var auctions$1$1$1 = "Subastas";
var auctionService$1$1$1 = "Subastar servicio";
var auto$1$1$1 = "Vehículo";
var automatic$1$1$1 = "Automático";
var automaticProvider$1$1$1 = "Proveedor automático";
var auxiliary$1$1$1 = "Auxiliar";
var auxiliarySettings$1$1$1 = "Ajustes de auxiliares";
var auxiliaries$1$1$1 = "Auxiliares";
var auxiliariesRates$1$1$1 = "Tarifas auxiliares";
var auxServiceList$1$1$1 = {
  auxServiceWithCount: "{{count}} Servicio auxiliar",
  auxServiceWithCount_plural: "{{count}} Servicios auxiliares"
};
var auxService$1$1$1 = "Servicio auxiliar";
var auxServices$1$1$1 = "Servicios auxiliares";
var available$1$1$1 = "Disponible";
var available_plural$1$1$1 = "Disponibles";
var availableProvidersAbbrev$1$1$1 = "Prov. disponibles";
var availableResources$1$1$1 = "Recursos disponibles";
var availableResourcesWithCount$1$1$1 = "{{count}} Recurso disponible";
var availableResourcesWithCount_plural$1$1$1 = "{{count}} Recursos disponibles";
var average$1$1$1 = "Tipo medio";
var averageRating$1$1$1 = "Valoración media";
var B$1$1$1 = "B";
var base$1$1$1 = "Base";
var baseAmount$1$1$1 = "Importe base";
var billed$1$1$1 = "Facturada";
var billing$1$1$1 = "Facturación";
var brand$1$1$1 = "Marca";
var browse$1$1$1 = "Examinar";
var budgetWarningNoBaseFound$1$1$1 = "Este proveedor no tiene configurada una base. Se ha utilizado la ubicación del recurso para calcular la tarifa.";
var businessIntelligence$1$1$1 = "Business Intelligence";
var byAmount$1$1$1 = "Por precio";
var byBrand$1$1$1 = "Por marca";
var byPositionOnQueue$1$1$1 = "Por posición en espera";
var byScore$1$1$1 = "por puntuación";
var byTime$1$1$1 = "Por tiempo";
var C$1$1$1 = "C";
var calculateAllServicesAsSuburban$1$1$1 = "Calcular todos los servicios como carreteros";
var calendar$1$1$1 = {
  today: "Hoy",
  yesterday: "Ayer",
  thisWeek: "Esta semana",
  last7Days: "Últimos 7 días",
  pastWeek: "Semana pasada",
  thisMonth: "Este mes",
  last30Days: "Últimos 30 días",
  pastMonth: "Mes pasado",
  thisYear: "Este año",
  lastYear: "Último año"
};
var cancel$1$1$1 = "Cancelar";
var cancel_2$1$1$1 = "Anular";
var outputCancellationPercentageAbbrev$1$1$1 = "% Salida anulado";
var cancelAmount$1$1$1 = "Importe anulación";
var cancelRatePercentage$1$1$1 = "% Salida anulación";
var cancelRateAmount$1$1$1 = "Importe anulación";
var cancelReason$1$1$1 = "Motivo de anulación";
var cancelService$1$1$1 = "Anular servicio";
var cancelTransferPeople$1$1$1 = "Anular traslado";
var cancelTransferPeopleWarning$1$1$1 = "En función del estado de ejecución, anular el traslado podría conllevar gastos. ¿Desea continuar?";
var capabilityList$1$1$1 = {
  capabilityWithCount: "{{count}} Prestación",
  capabilityWithCount_plural: "{{count}} Prestaciones"
};
var capability$1$1$1 = "Prestación";
var capabilityCollectiveAbbrev$1$1$1 = "Prestación/Colec.";
var capabilities$1$1$1 = "Prestaciones";
var center$1$1$1 = "Centro";
var centerName$1$1$1 = "Nombre del centro";
var centerNotFound$1$1$1 = "No se ha encontrado el centro";
var change$1$1$1 = "Cambiar";
var changePassword$1$1$1 = "Cambiar contraseña";
var charge$1$1$1 = "Cargo";
var chargeWithCount$1$1$1 = "{{count}} Cargo";
var chargeWithCount_plural$1$1$1 = "{{count}} Cargos";
var check$1$1$1 = "Revisar";
var childProfile$1$1$1 = "Perfil hijo";
var chosenDriver$1$1$1 = "Conductor elegido";
var cif$1$1$1 = "CIF";
var city$1$1$1 = "Ciudad";
var clone$1$1$1 = "Clonar";
var cloneService$1$1$1 = "Clonar servicio";
var close$1$1$1 = "Cerrar";
var closeDispute$1$1$1 = "Cerrar disputa";
var code$1$1$1 = "Código";
var collectDate$1$1$1 = "Fecha de cobro";
var collected$1$1$1 = "Cobrada";
var collectInvoice$1$1$1 = "Cobrar factura";
var collective$1$1$1 = "Colectivo";
var collectives$1$1$1 = "Colectivos";
var collectiveWithCount$1$1$1 = "{{count}} Colectivo";
var collectiveWithCount_plural$1$1$1 = "{{count}} Colectivos";
var collectiveProviderAbbrev$1$1$1 = "Colectivo/Prov.";
var comment$1$1$1 = "Comentario";
var commentAboutCapability$1$1$1 = "Comentario sobre prestación";
var companies$1$1$1 = "Compañías";
var company$1$1$1 = "Compañía";
var companyName$1$1$1 = "Nombre de la compañía";
var companyProfile$1$1$1 = "Perfil de compañía";
var completed$1$1$1 = "Completado";
var configuration$1$1$1 = "Configuración";
var consultList$1$1$1 = "Consultar lista";
var costName$1$1$1 = "Nombre del costo";
var costs$1$1$1 = "Costos";
var costSearch$1$1$1 = "Búsqueda de costo";
var costsWithCount$1$1$1 = "{{count}} Costo";
var costsWithCount_plural$1$1$1 = "{{count}} Costos";
var costSheets$1$1$1 = "Hojas de costos";
var costSheetStatus$1$1$1 = {
  PENDING: "P.imputación",
  IMPUTED: "P. aprobación",
  APPROVED: "Aprobado",
  REJECTED: "Rechazado"
};
var costType$1$1$1 = "Tipo de costo";
var costTypeName$1$1$1 = "Nombre del tipo de costo";
var costTypes$1$1$1 = "Tipos de costo";
var costTypesWithCount$1$1$1 = "{{count}} Tipo de costo";
var costTypesWithCount_plural$1$1$1 = "{{count}} Tipos de costo";
var craneService$1$1$1 = "Servicio de grúa";
var create$1$1$1 = "Crear";
var currentPassword$1$1$1 = "Contraseña actual";
var custodyDays$1$1$1 = "Días custodia";
var customer$1$1$1 = "Cliente";
var D$1$1$1 = "D";
var dashboard$1$1$1 = "Dashboard";
var date$1$1$1 = "Fecha";
var dateRangeExceeded$1$1$1 = "Excedido el rango de fechas";
var dayAndTime$1$1$1 = "Día y hora";
var deadLine$1$1$1 = "Fecha límite";
var concessionaire$1$1$1 = "Concesionaria";
var deferred$1$1$1 = "Programado";
var deferredService$1$1$1 = "Servicio programado";
var deferredShort$1$1$1 = "Programad";
var deferredShorter$1$1$1 = "Progra.";
var deleteCost$1$1$1 = "Eliminar costo";
var deletePath$1$1$1 = "Borrar trazado";
var deleteRequest$1$1$1 = "Eliminar solicitud";
var deposits$1$1$1 = "Depósitos";
var description$1$1$1 = "Descripción";
var detail$1$1$1 = "Detalle";
var disconnect$1$1$1 = "Desconectar";
var disputeReason$1$1$1 = "Motivo de la disputa";
var documentation$1$1$1 = "Documentación";
var documentationProfile$1$1$1 = "Perfil documentación";
var documentNumberAbbrev$1$1$1 = "Nº del documento";
var documentProfile$1$1$1 = "Perfil de documento";
var documentProfiles$1$1$1 = "Perfil de documentos";
var documentAdded$1$1$1 = "Documento añadido";
var documentType$1$1$1 = "Tipo de documento";
var documentTypes$1$1$1 = "Tipo de documentos";
var doNotAssociate$1$1$1 = "No asociar";
var dragData$1$1$1 = "Arrastrar datos";
var driver$1$1$1 = "Conductor";
var drivers$1$1$1 = "Conductores";
var duplicate$1$1$1 = "Duplicar";
var duplicateService$1$1$1 = "Duplicar servicio";
var E$1$1$1 = "E";
var edit$1$1$1 = "Editar";
var editAuxService$1$1$1 = "Editar servicio auxiliar";
var editCapability$1$1$1 = "Editar prestación";
var editCollective$1$1$1 = "Editar colectivo";
var editCost$1$1$1 = "Editar costo";
var editCostType$1$1$1 = "Editar tipo de costo";
var editFault$1$1$1 = "Editar avería";
var editSupportTeam$1$1$1 = "Editar equipo de soporte";
var editUserProfile$1$1$1 = "Editar perfil de usuario";
var email$1$1$1 = "Email";
var endService$1$1$1 = "Finalizar servicio";
var entry$1$1$1 = "Entrada";
var entryDateAbbrev$1$1$1 = "F. de entrada";
var error$1$1$1 = "Error";
var errorAddingDocument$1$1$1 = "Error al añadir documento";
var estimatedTime$1$1$1 = "Hora estimada";
var execution$1$1$1 = "Ejecución";
var executionProfile$1$1$1 = "Perfil de ejecución";
var expense$1$1$1 = "Gastos";
var expiredCode$1$1$1 = "Código caducado";
var expires$1$1$1 = "Caduca";
var events$1$1$1 = "Eventos";
var excessOfTimeForOutService$1$1$1 = "Exceso de tiempo para realizar servicio carretero";
var excessOfTimeForUrbanService$1$1$1 = "Exceso de tiempo para realizar servicio local";
var excessOfTimeInCurrentStatus$1$1$1 = "Exceso de tiempo en el estado actual";
var excessOfTimeToCompleteService$1$1$1 = "Exceso de tiempo para realizar el servicio";
var excessOfTimeToStartScheduledService$1$1$1 = "Exceso de tiempo para iniciar un servicio programado";
var F$1$1$1 = "F";
var fault$1$1$1 = "Avería";
var faults$1$1$1 = "Averías";
var faultCollectiveAbbrev$1$1$1 = "Avería/Colec.";
var faultWithCount$1$1$1 = "{{count}} Avería";
var faultWithCount_plural$1$1$1 = "{{count}} Averías";
var fee$1$1$1 = "Salida";
var fieldRequired$1$1$1 = "Requerido";
var file$1$1$1 = "Archivo";
var filterByDriverStatus$1$1$1 = "Filtrar por estado conductor";
var filterByVehicleType$1$1$1 = "Filtrar por tipo vehículo";
var financial$1$1$1 = "Financiero";
var financialBreakdown$1$1$1 = "Desglose financiero";
var finish$1$1$1 = "Finalizar";
var finishedServices$1$1$1 = "Servicios finalizados";
var firstPrice$1$1$1 = "Precio primera";
var firstUnitPriceAbbrev$1$1$1 = "Precio 1ª ud.";
var fixed$1$1$1 = "Fijo";
var formError$1$1$1 = "Error en formulario";
var franchise$1$1$1 = "Franquicia";
var franchises$1$1$1 = "Franquicias";
var freeCranesBefore1Hour$1$1$1 = "Grúas libres antes de 1h";
var fromUntil$1$1$1 = "Desde - Hasta";
var fullAddress$1$1$1 = "Dirección completa";
var fullScreenAbbrev$1$1$1 = "P. completa";
var G$1$1$1 = "G";
var generalInformationAbbrev$1$1$1 = "Inf. General";
var generate$1$1$1 = "Generar";
var generated$1$1$1 = "Generada";
var geofence$1$1$1 = "Geocerca";
var geofence_plural$1$1$1 = "Geocercas";
var geofenceWithCount$1$1$1 = "{{count}} Geocerca";
var geofenceWithCount_plural$1$1$1 = "{{count}} Geocercas";
var geoJson$1$1$1 = "GeoJson";
var globalAuction$1$1$1 = "Subasta global";
var graceDays$1$1$1 = "Días de gracia";
var grecaptchaNote$1$1$1 = "Sitio protegido por reCAPTCHA. Se aplica la <a href=\"https://policies.google.com/privacy\">Política de privacidad</a> y <a href=\"https://policies.google.com/terms\">Términos de servicio</a> de Google.";
var guardMode$1$1$1 = "Modo guardia";
var H$1$1$1 = "H";
var help$1$1$1 = "Ayuda";
var hide$1$1$1 = "Ocultar";
var holder$1$1$1 = "Titular";
var holidays$1$1$1 = "Festivos";
var home$1$1$1 = "Hogar";
var hour$1$1$1 = "Hora";
var hours$1$1$1 = "Horas";
var I$1$1$1 = "I";
var IBAN$1$1$1 = "IBAN";
var icon$1$1$1 = "Icono";
var iconUrl$1$1$1 = "URL del icono";
var identificationIcon$1$1$1 = "Icono identificativo";
var image$1$1$1 = "Imagen";
var immediate$1$1$1 = "Inmediato";
var immediate_plural$1$1$1 = "Inmediatos";
var immediateService$1$1$1 = "Servicio inmediato";
var incorrectLocationFormat$1$1$1 = "Localización en formato incorrecto";
var infoWindowIcon$1$1$1 = "Icono del InfoWindow";
var inParking$1$1$1 = "En parking";
var inRis$1$1$1 = "En reparación";
var inris$1$1$1 = "En reparación";
var inServiceResourcesWithCount$1$1$1 = "{{count}} Recurso en servicio";
var inServiceResourcesWithCount_plural$1$1$1 = "{{count}} Recursos en servicio";
var instant$1$1$1 = "Inmediato";
var insurancePolicyInfo$1$1$1 = "Información de la póliza";
var insured$1$1$1 = "Asegurado";
var insured_autoType$1$1$1 = "Vehículo";
var insured_homeType$1$1$1 = "Inmueble";
var insuredAutoType$1$1$1 = "Vehículo";
var insuredHomeType$1$1$1 = "Inmueble";
var insuredObjectAbbrev$1$1$1 = "Bien aseg.";
var insuredProperty$1$1$1 = "Bien asegurado";
var integrationProfile$1$1$1 = "Perfil de integración";
var integrationProfileAbbrev$1$1$1 = "Perfil integración";
var internalCode$1$1$1 = "Código interno";
var internalNote$1$1$1 = "Nota interna";
var internalNotes$1$1$1 = "Notas internas";
var interrupted$1$1$1 = "Interrumpida";
var intervention$1$1$1 = "Intervención";
var interventionAbbrev$1$1$1 = "Int.";
var interventions$1$1$1 = "Intervenciones";
var inUrbanArea$1$1$1 = "En zona local";
var invalidNexusFilecase$1$1$1 = "Expediente de Nexus no válido";
var invalidText$1$1$1 = "Texto no válido";
var invoice$1$1$1 = "Factura";
var invoiceNumberAbbrev$1$1$1 = "Nº de factura";
var forTheDay$1$1$1 = "Para el día";
var isNotValid$1$1$1 = "Es inválido";
var issuedInvoices$1$1$1 = "Facturas emitidas";
var itAlreadyExists$1$1$1 = "Ya existe";
var J$1$1$1 = "J";
var K$1$1$1 = "K";
var L$1$1$1 = "L";
var label$1$1$1 = "Rotulación";
var labeled$1$1$1 = "Rotulaciones";
var labels$1$1$1 = "Rotulaciones";
var lastActivity$1$1$1 = "Ult. actividad";
var lastActivity2$1$1$1 = "Última actividad";
var legal$1$1$1 = "Legal";
var legalId$1$1$1 = "NIF/CIF";
var list$1$1$1 = "Listado";
var listEntryMax24H$1$1$1 = "Entrada en lista (max. 24h)";
var loaded$1$1$1 = "Cargado";
var loadTimeInMinutes$1$1$1 = "Tiempo de carga (min)";
var located$1$1$1 = "Localizado";
var location$1$1$1 = "Ubicación";
var locked$1$1$1 = "Bloqueado";
var lockedByNexus$1$1$1 = "Bloqueado";
var login$1$1$1 = "Iniciar sesión";
var logo$1$1$1 = "Logotipo";
var logout$1$1$1 = "Cerrar sesión";
var M$1$1$1 = "M";
var managed$1$1$1 = "Gestionado";
var managedProvider$1$1$1 = "Proveedor gestionado";
var manual$1$1$1 = "Manual";
var manualProvider$1$1$1 = "Proveedor manual";
var map$1$1$1 = "Mapa";
var mapIcon$1$1$1 = "Icono del mapa";
var mapOfGoingServices$1$1$1 = "Mapa de servicios en curso";
var mapOfResources$1$1$1 = "Mapa de recursos";
var mapOfTracking$1$1$1 = "Mapa de seguimiento";
var mapView$1$1$1 = "Vista mapa";
var max$1$1$1 = "Max.";
var maxAllowedTimeInMinutes$1$1$1 = "Tiempo máx. permitido: {{minutes}} min";
var maxDistance$1$1$1 = "Distancia máxima";
var maxDistanceToCrane$1$1$1 = "Distancia de la grúa";
var maxHours$1$1$1 = "Horas máximo";
var maxRadius$1$1$1 = "Radio máximo";
var maxTime$1$1$1 = "Tiempo máximo";
var maxTimeOnList$1$1$1 = "Permanencia en lista";
var medium$1$1$1 = "Medio";
var mediumNotFound$1$1$1 = "No se ha encontrado el medio";
var mediumType$1$1$1 = "Tipo de medio";
var mediumTypes$1$1$1 = "Tipo de medios";
var mediumTypes2$1$1$1 = "Tipos de medio";
var minute$1$1$1 = "Minuto";
var minutes$1$1$1 = "Minutos";
var modeAndName$1$1$1 = "Modo y nombre";
var model$1$1$1 = "Modelo";
var modifiedCollective$1$1$1 = "Colectivo modificado";
var modifiedFault$1$1$1 = "Avería modificada";
var myTickets$1$1$1 = "Mis tickets";
var N$1$1$1 = "N";
var name$1$1$1 = "Nombre";
var nameSurname$1$1$1 = "Nombre y apellidos";
var new_female$1$1$1 = "Nueva";
var new_plural$1$1$1 = "Nuevos";
var newAuxService$1$1$1 = "Nuevo servicio";
var newAuxiliaryService$1$1$1 = "Nuevo servicio auxiliar";
var newDayAndTime$1$1$1 = "Nuevo día y hora";
var newPassword$1$1$1 = "Nueva contraseña";
var newService$1$1$1 = "Nuevo servicio";
var newSupportTeam$1$1$1 = "Nuevo equipo de soporte";
var newVehicleAssistance$1$1$1 = "Nueva asistencia de vehículos";
var newVialService$1$1$1 = "Nuevo servicio vial";
var nexusMapServiceError$1$1$1 = "Error en el servicio de mapas de Nexus";
var nick$1$1$1 = "Nick";
var no$1$1$1 = "No";
var noProvidersAvailable$1$1$1 = "No hay proveedores disponibles";
var notApplyCosts$1$1$1 = "No aplicar gastos";
var notParticipating$1$1$1 = "No participa";
var noCovered$1$1$1 = "No cubierto";
var noDocumentsAssociatedToService$1$1$1 = "No hay documentos asociados";
var noResourcesAvailableMsg$1$1$1 = "No hay recursos disponibles, pero puedes enviar el servicio a una lista de espera para que Nexus lo gestione.";
var noSubscribe$1$1$1 = "No suscribirme";
var note$1$1$1 = "Nota";
var notes$1$1$1 = "Notas";
var notesAssociatedWithTheService$1$1$1 = "Notas asociadas al servicio";
var noTicketsAssociatedToService$1$1$1 = "No hay tickets asociados al servicio";
var noTicketsAssociatedToTransfer$1$1$1 = "No hay tickets asociados al traslado";
var noNotesAssociatedToService$1$1$1 = "No hay notas asociadas al servicio";
var notifications$1$1$1 = "Notificaciones";
var noTransfersAvailable$1$1$1 = "No hay traslados disponibles";
var noValid$1$1$1 = "No válido";
var numberAbbrev$1$1$1 = "Nº";
var numberOfPeopleAbbrev$1$1$1 = "Nº de personas";
var numberOfReviewsAbbrev$1$1$1 = "Nº Reseñas";
var O$1$1$1 = "O";
var office$1$1$1 = "Oficina";
var ongoing$1$1$1 = "En curso";
var onQueue$1$1$1 = "En espera";
var openDispute$1$1$1 = "Abrir disputa";
var operational$1$1$1 = "Operativos";
var operationTypes$1$1$1 = "Tipo de intervención";
var origin$1$1$1 = "Origen";
var originalServiceData$1$1$1 = "Datos del servicio original";
var originDeposit$1$1$1 = "Origen depósito";
var otherSettings$1$1$1 = "Otros ajustes";
var orYouCan$1$1$1 = "O puedes";
var outlay$1$1$1 = "Suplidos";
var outlays$1$1$1 = "Gastos adicionales";
var P$1$1$1 = "P";
var paid$1$1$1 = "Pagada";
var passengers$1$1$1 = "Pasajeros";
var passengersWithCount$1$1$1 = "{{count}} Pasajero";
var passengersWithCount_plural$1$1$1 = "{{count}} Pasajeros";
var password$1$1$1 = "Contraseña";
var passwordsNotMatch$1$1$1 = "Las contraseñas no coinciden";
var paymentsToProviders$1$1$1 = "Pagos a proveedores";
var pdf$1$1$1 = "Pdf";
var pending$1$1$1 = "Pendiente";
var pendings$1$1$1 = "Pendientes";
var PENDING$1$1$1 = "Pendiente";
var pending_assign$1$1$1 = "Pendiente asignación";
var PENDING_ASSIGN$1$1$1 = "Pendiente asignación";
var PENDINGASSIGN$1$1$1 = "Pendiente asignación";
var pendingDocumentation$1$1$1 = "Documentación pendiente";
var pendingDocuments$1$1$1 = "Documentos pendientes";
var pendingPassword$1$1$1 = "Pendiente registro";
var pendingProfile$1$1$1 = "Pendiente perfil";
var peopleTransferActivity$1$1$1 = "Traslados";
var pleaseTryAgainLater$1$1$1 = "Por favor inténtalo de nuevo mas tarde";
var phone$1$1$1 = "Teléfono";
var phoneNumberAbbrev$1$1$1 = "Nº de teléfono";
var photoWithCount$1$1$1 = "{{count}} foto";
var photoWithCount_plural$1$1$1 = "{{count}} fotos";
var photos$1$1$1 = "Fotos";
var planned$1$1$1 = "Planificado";
var PLANNED$1$1$1 = "Planificado";
var plannedService$1$1$1 = "Servicio planificado";
var plate$1$1$1 = "Matrícula";
var plateDoesNotCorrespondToTheFilecase$1$1$1 = "Matrícula no corresponde al expediente";
var policy$1$1$1 = "Póliza";
var policyCoverageLimit$1$1$1 = "Excedida la cobertura de la póliza";
var policyCoverageLimit2$1$1$1 = "Posible exceso de la cobertura de la póliza";
var policyInformation$1$1$1 = "Información de póliza";
var policyLimitExceeded$1$1$1 = {
  number1: "Se ha solicitado 1 servicio, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al proveedor.",
  number2: "Se han solicitado {{previousServices}} servicios, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al proveedor.",
  number3: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza es 1. El asistido deberá abonar el coste total del servicio al proveedor.",
  number4: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza son {{policyServicesLimit}}. El asistido deberá abonar el coste total del servicio al proveedor.",
  amount1: "El importe del servicio es de {{serviceTotalAmount}}, y el importe máximo que incluye la póliza es {{policyAmountLimit}}. El asistido deberá abonar la diferencia de {{amountDifference}} al proveedor.",
  amount2: "El importe del servicio es de {{serviceTotalAmount}}, y quedan {{availableAmount}} del importe máximo que incluye la póliza. El asistido deberá abonar la diferencia de {{amountDifference}} al proveedor.",
  amount3: "El importe del servicio es de {{serviceTotalAmount}}, y ya se ha gastado el importe máximo que incluye la póliza. El asistido deberá abonar la totalidad del servicio al proveedor.",
  amount4: "El importe de alguno de los recursos seleccionados supera el límite de la póliza de {{policyAmountLimit}}. El asistido deberá abonar la diferencia al proveedor en el caso de que estos recursos acepten el servicio.",
  amount5: "El importe de alguno de los recursos seleccionados supera el límite de la póliza de {{policyAmountLimit}}, y quedan {{availableAmount}} del importe máximo de cobertura. El asistido deberá abonar la diferencia al proveedor en el caso de que estos recursos acepten el servicio.",
  amount6: "El importe de todos los recursos seleccionados supera el límite de la póliza de {{policyAmountLimit}}, y ya se ha gastado el importe máximo de cobertura. El asistido deberá abonar la totalidad del servicio al proveedor en el caso de que estos recursos acepten el servicio.",
  amount4b: "El importe del recurso seleccionado supera el límite de la póliza de {{policyAmountLimit}}. El asistido deberá abonar la diferencia al proveedor en el caso de que este recurso acepte el servicio.",
  amount5b: "El importe del recurso seleccionado supera el límite de la póliza de {{policyAmountLimit}}, y quedan {{availableAmount}} del importe máximo de cobertura. El asistido deberá abonar la diferencia al proveedor en el caso de que este recurso acepte el servicio.",
  amount6b: "El importe del recurso seleccionado supera el límite de la póliza de {{policyAmountLimit}}, y ya se ha gastado el importe máximo de cobertura. El asistido deberá abonar la totalidad del servicio al proveedor en el caso de que este recurso acepte el servicio.",
  amount7: "El importe estimado del servicio es de {{serviceTotalAmount}}, y el importe máximo que incluye la póliza es {{policyAmountLimit}}. El asistido deberá abonar la diferencia aproximada de {{amountDifference}} al proveedor.",
  amount8: "El importe estimado del servicio es de {{serviceTotalAmount}}, y quedan {{availableAmount}} del importe máximo que incluye la póliza. El asistido deberá abonar la diferencia aproximada de {{amountDifference}} al proveedor.",
  amount9: "El importe estimado del servicio es de {{serviceTotalAmount}}, y ya se ha gastado el importe máximo que incluye la póliza. El asistido deberá abonar la totalidad del servicio al proveedor."
};
var policyLimitExceededAux$1$1$1 = {
  number1: "Se ha solicitado 1 servicio, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al técnico.",
  number2: "Se han solicitado {{previousServices}} servicios, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al técnico.",
  number3: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza es 1. El asistido deberá abonar el coste total del servicio al técnico.",
  number4: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza son {{policyServicesLimit}}. El asistido deberá abonar el coste total del servicio al técnico.",
  amount1: "El importe del servicio es de {{serviceTotalAmount}}, y el importe máximo que incluye la póliza es {{policyAmountLimit}}. El asistido deberá abonar la diferencia de {{amountDifference}} al técnico.",
  amount2: "El importe del servicio supera el límite de la póliza de {{serviceTotalAmount}}, y quedan {{availableAmount}} del importe máximo de cobertura. El asistido deberá abonar la diferencia de {{amountDifference}} al técnico.",
  amount3: "El importe del servicio supera el límite de la póliza de {{serviceTotalAmount}}, y ya se ha gastado el importe máximo de cobertura. El asistido deberá abonar la totalidad del servicio al técnico."
};
var policyNumberAbbrev$1$1$1 = "Nº de póliza";
var policySearch$1$1$1 = "Búsqueda de póliza";
var positionAbbrev$1$1$1 = "P.";
var priority$1$1$1 = "Prioritario";
var priority1Providers$1$1$1 = "Proveedores de prioridad 1";
var priority2Providers$1$1$1 = "Proveedores de prioridad 2";
var priority3Providers$1$1$1 = "Proveedores de prioridad 3";
var priorityAllProviders$1$1$1 = "Todos los proveedores";
var priorityProvider$1$1$1 = "Proveedor prioritario";
var process$1$1$1$1 = "Procesar";
var profile$1$1$1 = "Perfil";
var profileNotFound$1$1$1 = "No se ha encontrado el perfil";
var profiles$1$1$1 = "Perfiles";
var proposals$1$1$1 = "Propuestas";
var provider$1$1$1 = "Proveedor";
var providersInZone$1$1$1 = "Proveedores en la zona";
var providersOutZone$1$1$1 = "Resto de proveedores";
var providerTechnician$1$1$1 = "Proveedor / técnico";
var providerVialSettings$1$1$1 = "Ajustes de viales de {{providerName}}";
var providerEditVialSettingsHeaderText$1$1$1 = "Completa la información necesaria correspondiente a los servicios viales.";
var providerAuxiliariesSettings$1$1$1 = "Ajustes de auxiliares de {{providerName}}";
var providerEditAuxiliariesSettingsHeaderText$1$1$1 = "Completa la información necesaria correspondiente a los servicios auxiliares.";
var providers$1$1$1 = "Proveedores";
var provider_pending$1$1$1 = "Pendiente proveedor";
var PROVIDER_PENDING$1$1$1 = "Pendiente proveedor";
var PROVIDERPENDING$1$1$1 = "Pendiente proveedor";
var provider_accepted$1$1$1 = "Aceptado proveedor";
var PROVIDER_ACCEPTED$1$1$1 = "Aceptado proveedor";
var PROVIDERACCEPTED$1$1$1 = "Aceptado proveedor";
var provider_accept$1$1$1 = "Aceptado proveedor";
var PROVIDER_ACCEPT$1$1$1 = "Aceptado proveedor";
var PROVIDERACCEPT$1$1$1 = "Aceptado proveedor";
var providersSelection$1$1$1 = "Selección de proveedores";
var providerList$1$1$1 = {
  providerWithCount: "{{count}} Proveedor",
  providerWithCount_plural: "{{count}} Proveedores"
};
var providersMap$1$1$1 = "Mapa de proveedores";
var providerType$1$1$1 = "Tipo de proveedor";
var providerTypeVial$1$1$1 = "Tipo de vial";
var providerTypeAux$1$1$1 = "Tipo de auxiliar";
var providerWithoutDefinedDeposit$1$1$1 = "Proveedor sin depósito configurado";
var province$1$1$1 = "Provincia";
var Q$1$1$1 = "Q";
var queueEntryDate$1$1$1 = "Fecha de entrada en la lista";
var queued$1$1$1 = "En espera";
var QUEUED$1$1$1 = "En espera";
var queuedService$1$1$1 = "Servicio en espera";
var R$1$1$1 = "R";
var rates$1$1$1 = "Tarifas";
var rating$1$1$1 = "Valoración";
var ratings$1$1$1 = "Valoraciones";
var ratingsUserName$1$1$1 = "Valoraciones de {{userName}}";
var ratingsWithCount$1$1$1 = "{{count}} Valoración";
var ratingsWithCount_plural$1$1$1 = "{{count}} Valoraciones";
var ready$1$1$1 = "Disponible";
var reAssign$1$1$1 = "Reasignar";
var reAssignProvider$1$1$1 = "Reasignar proveedor";
var reAskForResetEmail$1$1$1 = "Vuelve a pedir email de restablecer";
var received$1$1$1 = "Recibido";
var receivedInvoices$1$1$1 = "Facturas recibidas";
var recoverRequest$1$1$1 = "Recuperar solicitud";
var recoverYourPassword$1$1$1 = "Recupera tu contraseña";
var region$1$1$1 = "Región";
var registrationInformationOnInvoices$1$1$1 = "Información registral en facturas";
var reject$1$1$1 = "Rechazar";
var rejectCosts$1$1$1 = "Rechazar costos";
var rejectionReason$1$1$1 = "Motivo de rechazo";
var rejectionReasons$1$1$1 = "Motivos de rechazo";
var rejectionType$1$1$1 = "Tipo de rechazo";
var release$1$1$1 = "Liberar";
var removeFromDashboard$1$1$1 = "Eliminar del Dashboard";
var repeated$1$1$1 = "Repetido";
var repeatPassword$1$1$1 = "Repetir contraseña";
var requestCapability$1$1$1 = "Prestación solicitada";
var requestInfo$1$1$1 = "Inf. solicitud";
var requestLocationByWhatsApp$1$1$1 = "Solicitar ubicación por WhatsApp";
var requestMediumAbbrev$1$1$1 = "M.Solicitado";
var requestProcessedCorrectly$1$1$1 = "Solicitud procesada de forma correcta";
var requestWithoutIAssociatedPolicy$1$1$1 = "Solicitud sin póliza asociada";
var required$1$1$1 = "Obligatorio";
var reschedule$1$1$1 = "Reprogramar";
var RESCHEDULED$1$1$1 = "Reprogramado";
var rescheduleComment$1$1$1 = "Comentario de la reprogramación";
var rescheduleReason$1$1$1 = "Motivo de reprogramación";
var rescheduleService$1$1$1 = "Reprogramar servicio";
var rescheduleServiceDeferredTextModal$1$1$1 = "Introduce un nuevo día y hora para cambiar la programación del servicio actual";
var rescheduleServicePlannedText1Modal$1$1$1 = "Los servicios planificados tienen un recurso asignado. Al cambiar la fecha y hora, el servicio volverá al estado programado, y estará pendiente de planificación";
var rescheduleServicePlannedText2Modal$1$1$1 = "Introduce la nueva fecha del servicio programado";
var resetPassword$1$1$1 = "Contraseña restablecida";
var resetYourPassword$1$1$1 = "Restablece tu contraseña";
var resources$1$1$1 = "Recursos";
var resourcesMap$1$1$1 = "Mapa de recursos";
var restore$1$1$1 = "Restablecer";
var result$1$1$1 = "Resultado";
var ris$1$1$1 = "RIS";
var risService$1$1$1 = "Servicio de RIS";
var S$1$1$1 = "S";
var save$1$1$1 = "Guardar";
var saveChanges$1$1$1 = "Guardar cambios";
var savedRequests$1$1$1 = "Solicitudes guardadas";
var saveRequest$1$1$1 = "Guardar solicitud";
var schedule$1$1$1 = "Agendar";
var scheduled$1$1$1 = "Programado";
var SCHEDULED$1$1$1 = "Programado";
var scheduled_plural$1$1$1 = "Programados";
var scheduledAbbrev$1$1$1 = "Program.";
var scheduledDateInvalidErrorText$1$1$1 = "La fecha y hora programada no es válida";
var scheduleDriver$1$1$1 = "Agendar conductor";
var scheduledServiceNotFound$1$1$1 = "El servicio programado no ha sido localizado";
var scheduledFor$1$1$1 = "Programado para";
var searchResourceOrTechnician$1$1$1 = "Busca recurso o técnico";
var searchResources$1$1$1 = "Busca recursos";
var searchAResource$1$1$1 = "Buscar un recurso";
var searchAService$1$1$1 = "Buscar un servicio";
var searchByAssistedOrFilecase$1$1$1 = "Asistido o Exp";
var searchByAssistedFilecaseOrPlate$1$1$1 = "Asistido, Aseg, Exp. o Matrícula";
var searchByAssistedFilecaseOrProvider$1$1$1 = "Asistido, Exp. o Proveedor";
var searchByCodeOrName$1$1$1 = "Busca por Código o Nombre";
var searchByCodeNameOrCostType$1$1$1 = "Busca por Código, Nombre o Tipo de costo";
var searchByCodeNameOrMediumType$1$1$1 = "Busca por Código, Nombre o Tipo de medio";
var searchByCustomer$1$1$1 = "Busca por Cliente";
var searchByCustomerOrFilecase$1$1$1 = "Cliente o Exp";
var searchByCustomerFilecaseOrPlate$1$1$1 = "Cliente, Exp. o Matrícula";
var searchByFileCase$1$1$1 = "Busca por Expediente";
var searchByIdForOrFilecaseNumber$1$1$1 = "Busca por ID, Para o Nº Expediente";
var searchByInvoiceNumber$1$1$1 = "Busca por Nº Factura";
var searchByName$1$1$1 = "Busca por Nombre";
var searchByNameCIFOrAddress$1$1$1 = "Busca por Nombre, CIF o Dirección";
var searchByNameOrAddress$1$1$1 = "Busca por Nombre o Dirección";
var searchByNameOrCode$1$1$1 = "Busca por Nombre o Código";
var searchByNamePlateOrCode$1$1$1 = "Busca por Nombre, Matrícula o Código";
var searchByNameSurnameUserOrNick$1$1$1 = "Busca por Nombre, Apellidos, Usuario o Nick";
var searchByProviderOrName$1$1$1 = "Busca por Proveedor o Nombre";
var searchByTerm$1$1$1 = "Busca por término";
var searchInsurancePolicy$1$1$1 = "Buscar póliza";
var seeAverages$1$1$1 = "Ver medias";
var breakdown$1$1$1 = "Desglose";
var seeCapabilityComment$1$1$1 = "Ver comentario de prestación";
var seeComment$1$1$1 = "Ver comentario";
var seeContactAndComment$1$1$1 = "Ver contacto y comentario";
var seeDescription$1$1$1 = "Ver descripción";
var seeService$1$1$1 = "Ver servicio";
var selfValidated$1$1$1 = "Autovalidado";
var send$1$1$1 = "Enviar";
var sendComments$1$1$1 = "Enviar comentarios";
var sended$1$1$1 = "Enviado";
var sendEmail$1$1$1 = "Enviar correo";
var sendForReview$1$1$1 = "Enviar a revisión";
var sendTo$1$1$1 = "Enviar a";
var sendToList$1$1$1 = "Enviar a la lista";
var serverConnectionError$1$1$1 = "¡Error de conexión con el servidor!";
var service$1$1$1 = "servicio";
var serviceExecution$1$1$1 = "Ejecución del servicio";
var serviceInAuction$1$1$1 = "Servicio en subasta";
var serviceLevels$1$1$1 = "Niveles de servicio";
var serviceMap$1$1$1 = "Mapa de viales";
var serviceNotFound$1$1$1 = "No se ha encontrado el servicio";
var serviceRequestAndTracking$1$1$1 = "Solicitud y seguimiento del servicio";
var services$1$1$1 = "Servicios";
var serviceSentToAuction$1$1$1 = "Servicio enviado a subasta";
var serviceStatus$1$1$1 = {
  auctioning: "En subasta",
  auctioningAvatar: "S",
  pending_assign: "Pendiente asignación",
  pendingAssign: "Pendiente asignación",
  pending_assignAvatar: "PA",
  provider_pending: "Pendiente proveedor",
  providerPending: "Pendiente proveedor",
  provider_pendingAvatar: "PP",
  provider_accepted: "Aceptado proveedor",
  providerAccepted: "Aceptado proveedor",
  providerAccept: "Aceptado proveedor",
  provider_acceptedAvatar: "AP",
  queued: "En espera",
  queuedAvatar: "E",
  scheduled: "Programado",
  scheduledAvatar: "PR",
  pending: "Pendiente",
  pendingAvatar: "PE",
  assigned: "Agendado",
  assignedAvatar: "AG",
  planned: "Planificado",
  plannedAvatar: "PL",
  accepted: "Aceptado",
  acceptedAvatar: "AC",
  started: "Iniciado",
  startedAvatar: "I",
  located: "Localizado",
  locatedAvatar: "L",
  inris: "En reparación",
  inrisAvatar: "RP",
  loaded: "Cargado",
  loadedAvatar: "CA",
  completed: "Completado",
  completedAvatar: "CO",
  finished: "Finalizado",
  finishedAvatar: "F",
  rejected: "Rechazado",
  rejectedAvatar: "RC",
  canceled: "Anulado",
  canceledAvatar: "AN"
};
var settings$1$1$1 = "Ajustes";
var settingsUpdated$1$1$1 = "Ajustes actualizados";
var sharedCode$1$1$1 = "Código compartido";
var sharedNote$1$1$1 = "Nota compartida";
var sharedNotes$1$1$1 = "Notas compartidas";
var shipments$1$1$1 = "Remesas";
var shipmentStatusValues$1$1$1 = {
  collecting: "Interrumpida",
  pending: "Generada",
  billed: "Facturada",
  collected: "Cobrada",
  payed: "Pagada"
};
var showAllMediums$1$1$1 = "Mostrar todos los medios";
var showSolicitedMedium$1$1$1 = "Mostrar medio solicitado";
var situation$1$1$1 = "Situación";
var solicitedMedium$1$1$1 = "Medio solicitado";
var sortCriteria$1$1$1 = "Criterio ordenación";
var soundActivated$1$1$1 = "Sonido activado";
var soundOff$1$1$1 = "Sonido desactivado";
var start$1$1$1 = "Inicio";
var started$1$1$1 = "Iniciado";
var status$1$1$1 = "Estado";
var statuses$1$1$1 = "Estados";
var subject$1$1$1 = "Asunto";
var subscribe$1$1$1 = "Suscribirme";
var subtotal$1$1$1 = "Subtotal";
var suburb$1$1$1 = "Carretero";
var suburbService$1$1$1 = "Servicio carretero";
var summary$1$1$1 = "Resumen";
var supportCenter$1$1$1 = "Centro de soporte";
var supportTeam$1$1$1 = "Equipo de soporte";
var survey$1$1$1 = "Encuesta";
var surveys$1$1$1 = "Encuestas";
var T$1$1$1 = "T";
var taxes$1$1$1 = "Impuestos";
var team$1$1$1 = "Equipo";
var teamName$1$1$1 = "Nombre del equipo";
var technician$1$1$1 = "Técnico";
var technicians$1$1$1 = "Técnicos";
var theField$1$1$1 = "El campo";
var ticket$1$1$1 = "Ticket";
var tickets$1$1$1 = "Tickets";
var ticketStatus$1$1$1 = {
  "new": "Nuevo",
  newAvatar: "N",
  open: "Abierto",
  openAvatar: "A",
  closed: "Cerrado",
  closedAvatar: "C"
};
var time$1$1$1 = "Tiempo";
var timeInAlert$1$1$1 = "Tiempo en alerta";
var timeline$1$1$1 = "Línea de tiempo";
var title$1$1$1 = "Título";
var toastErrorDuplicateAddressPickupDeliveryTitle$1$1$1 = "Error en las direcciones";
var toastErrorDuplicateAddressPickupDeliveryText$1$1$1 = "La dirección de recogida y entrega deben ser diferentes.";
var toastErrorDuplicateAddressPickupDestinationTitle$1$1$1 = "Error en las direcciones";
var toastErrorDuplicateAddressPickupDestinationText$1$1$1 = "La dirección de recogida y destino del asistido deben ser diferentes.";
var toastErrorTextDefault$1$1$1 = "No ha sido posible realizar la operación.";
var toastErrorTitleDefault$1$1$1 = "Error en la operación";
var toastErrorTransferPeopleBudget$1$1$1 = {
  expiredEstimate: {
    title: "Error",
    text: "La estimación de tarifa seleccionada ha expirado."
  },
  invalidEstimate: {
    title: "Error",
    text: ""
  },
  productNotFound: {
    title: "Error",
    text: "El recurso seleccionado no ha sido localizado."
  },
  cabifyIntegrationProblem: {
    title: "Error",
    text: "No se ha podido solicitar el traslado."
  },
  profileWithoutResources: {
    title: "Error",
    text: "Perfil sin recursos"
  }
};
var toastErrorTitle_downloadFile$1$1$1 = "Error";
var toastErrorText_downloadFile$1$1$1 = "No ha sido posible descargar el fichero.";
var toastSuccessTextDefault$1$1$1 = "La operación se ha realizado correctamente.";
var toastSuccessTitleDefault$1$1$1 = "Operación realizada con éxito";
var today$1$1$1 = "Hoy";
var toDefine$1$1$1 = "Por definir";
var total$1$1$1 = "Total";
var totals$1$1$1 = "Totales";
var toTheClient$1$1$1 = "Al cliente";
var toTheProvider$1$1$1 = "Al proveedor";
var town$1$1$1 = "Localidad";
var tracking$1$1$1 = "Seguimiento";
var trackingMessage$1$1$1 = "Mensaje de seguimiento";
var transfer$1$1$1 = "Traslado";
var transferHasBeenCancelled$1$1$1 = "El traslado ha sido anulado.";
var transferPeople$1$1$1 = "Traslado de personas";
var transferPeopleBudget$1$1$1 = "Propuesta de traslado";
var transferPeopleRequest$1$1$1 = "Solicitud de traslado";
var transferPeopleRequestType$1$1$1 = {
  immediate: "Servicio inmediato",
  deferred: "Servicio programado"
};
var transferPeopleRequiredValidPhoneNumber$1$1$1 = "Para los traslados es necesario facilitar un teléfono de contacto.";
var transfers$1$1$1 = "Traslados";
var transfersAvailable$1$1$1 = "Traslados disponibles";
var transferTheAssisted$1$1$1 = "Trasladar al asistido";
var type$1$1$1 = "Tipo";
var typeAndName$1$1$1 = "Tipo y nombre";
var typeless$1$1$1 = "Sin tipo";
var typeOfService$1$1$1 = "Tipo de servicio";
var types$1$1$1 = "Tipos";
var U$1$1$1 = "U";
var udWithCount$1$1$1 = "{{count}} ud.";
var udWithCount_plural$1$1$1 = "{{count}} uds.";
var unAssign$1$1$1 = "Liberar";
var unAssignTechnician$1$1$1 = "Liberar técnico";
var unAssignTechnicianModalText$1$1$1 = "¿Estás seguro que deseas liberar el técnico?";
var unAssignTechnicianModalAditionalText$1$1$1 = "Al hacerlo, el servicio pasará a estado Aceptado proveedor y podrás asignar un técnico nuevo.";
var unAssignDriver$1$1$1 = "Liberar conductor";
var unAssignDriverModalText$1$1$1 = "¿Estás seguro que deseas liberar el conductor?";
var unAssignDriverModalAditionalText$1$1$1 = "Al hacerlo, el servicio pasará a estado Aceptado proveedor y podrás asignar un conductor nuevo.";
var unavailable$1$1$1 = "No disponible";
var units$1$1$1 = "Unidades";
var unitAbbrev$1$1$1 = "ud.";
var unitsAbbrev$1$1$1 = "uds.";
var unselected$1$1$1 = "Sin selección";
var unsubscribe$1$1$1 = "Anular suscripción";
var urban$1$1$1 = "Local";
var urbanFee$1$1$1 = "Local";
var urbanService$1$1$1 = "Servicio local";
var user$1$1$1 = "Usuario";
var userProfiles$1$1$1 = "Perfiles de usuario";
var userProfilesWithCount$1$1$1 = "{{count}} Perfil de usuario";
var userProfilesWithCount_plural$1$1$1 = "{{count}} Perfiles de usuario";
var users$1$1$1 = "Usuarios";
var userType$1$1$1 = "Tipo de usuario";
var V$1$1$1 = "V";
var validFrom$1$1$1 = "Válido desde";
var validUntil$1$1$1 = "Válido hasta";
var variable$1$1$1 = "Variable";
var vehicleAssistance$1$1$1 = "Asistencia de vehículos";
var vehicleTypes$1$1$1 = "Tipo de vehículos";
var version$1$1$1 = "Versión";
var vial$1$1$1 = "Vial";
var vials$1$1$1 = "Viales";
var vialRates$1$1$1 = "Tarifas viales";
var vialServices$1$1$1 = "Servicios viales";
var vialSettings$1$1$1 = "Ajustes de viales";
var view$1$1$1 = "Vista";
var viewAssistedRating$1$1$1 = "Ver valoración del asistido";
var viewContact$1$1$1 = "Ver contacto";
var viewContactandComment$1$1$1 = "Ver contacto y comentario";
var viewRoute$1$1$1 = "Ver ruta";
var views$1$1$1 = "Vistas";
var vin$1$1$1 = "VIN";
var virtualSwitchboard$1$1$1 = "Centralita virtual";
var W$1$1$1 = "W";
var waitingList$1$1$1 = "Lista de espera";
var web$1$1$1 = "Web";
var webAddress$1$1$1 = "Dirección web";
var wholeWordSearch$1$1$1 = "Búsqueda de palabras completas";
var wholeWordSearch3Charts$1$1$1 = "Busca palabras completas (min 3 carac.)";
var withAlert$1$1$1 = "Con alerta";
var withholdings$1$1$1 = "Retenciones";
var withPriority1$1$1$1 = "Con prioridad 1";
var withPriority2$1$1$1 = "Con prioridad 2";
var withPriority3$1$1$1 = "Con prioridad 3";
var writeANote$1$1$1 = "Escribir una nota";
var wrongUser$1$1$1 = "Usuario incorrecto";
var wrongUsernameOrPassword$1$1$1 = "Usuario o contraseña incorrectos";
var X$1$1$1 = "X";
var Y$1$1$1 = "Y";
var year$1$1$1 = "Año";
var yes$1$1$1 = "Sí";
var yesterday$1$1$1 = "Ayer";
var youHaveExceededTheNumberOfAtempsts$1$1$1 = "Has excedido el número de intentos";
var Z$1$1$1 = "Z";
var maxMinutes$1$1$1 = "Minutos max.";
var maxPhotos$1$1$1 = "Fotos max.";
var between0And5Minutes$1$1$1 = "Entre 0 y 5 minutos";
var between0And10Minutes$1$1$1 = "Entre 0 y 10 minutos";
var between0And240Minutes$1$1$1 = "Entre 0 y 240 minutos";
var between1And7Minutes$1$1$1 = "Entre 1 y 7 minutos";
var between2And5Minutes$1$1$1 = "Entre 2 y 5 minutos";
var between2And10Minutes$1$1$1 = "Entre 2 y 10 minutos";
var between0And10Photos$1$1$1 = "Entre 0 y 10 fotos";
var between1And10Characters$1$1$1 = "Entre 1 y 10 caracteres";
var between0And120Minutes$1$1$1 = "Entre 0 y 120 minutos";
var ACCEPTED$1$1$1 = "Aceptado";
var add_company_description$1$1$1 = "Completa los datos de la compañía a dar de alta, indicando si se trata de un cliente o de un proveedor.";
var add_company$1$1$1 = "Añadir compañía";
var addChartText$1$1$1 = "Pulsa el botón de añadir para incorporar gráficos al Business Intelligence.";
var addChartTitle$1$1$1 = "Añadir gráfico";
var all_female$1$1$1 = "Todas";
var all_male$1$1$1 = "Todos";
var amount$1$1$1 = "Importe";
var apply$1$1$1 = "Aplicar";
var assignProvider$1$1$1 = "Asignar proveedor";
var assignedToMe$1$1$1 = "Asignados a mí";
var assignItToMe$1$1$1 = "Asignármelo";
var AVAILABLE$1$1$1 = "Disponible";
var blocked$1$1$1 = "Bloqueado";
var budgetToastSuccessText$1$1$1 = "El servicio se ha añadido al listado.";
var budgetToastSuccessTitle$1$1$1 = "Presupuesto aceptado";
var scheduledBudgetToastSuccessText$1$1$1 = "El servicio programado se ha añadido al listado.";
var scheduledBudgetToastSuccessTitle$1$1$1 = "Presupuesto aceptado";
var transferPeopleBudgetToastSuccessText$1$1$1 = "El traslado se ha añadido al listado.";
var transferPeopleBudgetToastSuccessTitle$1$1$1 = "Presupuesto aceptado";
var budgetToastSuccessQueueText$1$1$1 = "El servicio ha sido añadido a la lista de espera.";
var budgetToastSuccessQueueTitle$1$1$1 = "Operación realizada con éxito";
var bussy$1$1$1 = "ocupado";
var CANCELED$1$1$1 = "Anulado";
var centerNum$1$1$1 = "Nº Centros";
var centers$1$1$1 = "Centros";
var closed$1$1$1 = "Cerrado";
var codeAlreadyAssigned$1$1$1 = "Código ya asignado";
var color$1$1$1 = "Color";
var companyPendingDocumentation$1$1$1 = "Pendiente documentación compañía";
var companyProviderCode$1$1$1 = "Nuevo ID";
var COMPLETED$1$1$1 = "Completado";
var custodyRate$1$1$1 = "Precio día extra";
var damageReport$1$1$1 = "Parte de daños";
var damageRequired$1$1$1 = "Parte obligatorio";
var day$1$1$1 = "Día";
var days$1$1$1 = "Días";
var del$1$1$1 = "Eliminar";
var delivery$1$1$1 = "Entrega";
var deliveryAddressRequired$1$1$1 = "Dirección de entrega obligatoria";
var destination$1$1$1 = "Destino";
var documents$1$1$1 = "Documentos";
var exit$1$1$1 = "Salir";
var expired$1$1$1 = "Caducado";
var EXTRA_CHARGES$1$1$1 = "GASTOS EXTRA";
var extraCharges$1$1$1 = "Gastos";
var festive$1$1$1 = "Festivo";
var fieldsRequired$1$1$1 = "Los campos con (*) son obligatorios.";
var files$1$1$1 = "Archivos";
var filters$1$1$1 = "Filtros";
var FINISHED$1$1$1 = "Finalizado";
var free$1$1$1 = "libre";
var from$1$1$1 = "De";
var fromDate$1$1$1 = "Desde";
var generalInfo$1$1$1 = "Inf. General";
var groupName$1$1$1 = "Nombre de la compañía";
var id$1$1$1 = "Id";
var IN_SERVICE$1$1$1 = "En servicio";
var information$1$1$1 = "Información";
var INRIS$1$1$1 = "En reparación";
var integrated$1$1$1 = "Integrado";
var invite$1$1$1 = "Invitar";
var invoiceDate$1$1$1 = "Fecha fact.";
var lastAct$1$1$1 = "Última act.";
var left$1$1$1 = "Quedan";
var LOADED$1$1$1 = "Cargado";
var LOCATED$1$1$1 = "Localizado";
var locations$1$1$1 = "Localizaciones";
var mediums$1$1$1 = "Medios";
var MEDIUMS$1$1$1 = "MEDIOS";
var modify$1$1$1 = "Modificar";
var newRates$1$1$1 = "Nuevas tarifas";
var nexus$1$1$1 = "Nexus";
var nexusFee$1$1$1 = "Fee Nexus";
var nFilecase$1$1$1 = "Nº Expediente";
var nFilecaseAbbrev$1$1$1 = "Nº Exp.";
var nickName$1$1$1 = "Nick";
var nightlyEnd$1$1$1 = "Fin horario noct.";
var nightlyStart$1$1$1 = "Inicio horario noct.";
var nightly$1$1$1 = "Nocturno";
var nigthly$1$1$1 = "Nocturno";
var nightlyFestive$1$1$1 = "Festivo nocturno";
var nInvoice$1$1$1 = "Nº Factura";
var nInvoices$1$1$1 = "Nº Facturas";
var none$1$1$1 = "Ninguno";
var NOT_IN_NEXUS$1$1$1 = "Fuera de Nexus";
var not$1$1$1 = "No";
var nNexus$1$1$1 = "Nº Nexus";
var nPayments$1$1$1 = "Nº Pagos";
var nServices$1$1$1 = "Nº Servicios";
var numberOfInvoices$1$1$1 = "Número de facturas";
var of$1$1$1 = "de";
var open$1$1$1 = "Abierto";
var outOfService$1$1$1 = "fuera de servicio";
var ownFilecaseNumber$1$1$1 = "Nº expediente propio";
var ownFilecaseNumberAbbrev$1$1$1 = "Nº expediente";
var partialPrice$1$1$1 = "Precio parcial";
var participants$1$1$1 = "Participantes";
var participation$1$1$1 = "Participación";
var payed$1$1$1 = "Pagada";
var payments$1$1$1 = "Pagos";
var pendingAbbrev$1$1$1 = "Pdte.";
var photosNumber$1$1$1 = "Nº de fotos";
var pickup$1$1$1 = "Recogida";
var pickupAddress$1$1$1 = "Lugar recogida";
var pictures$1$1$1 = "Fotos";
var processDate$1$1$1 = "Fecha de procesamiento";
var processed$1$1$1 = "Procesado";
var providerAlreadyMapped$1$1$1 = "Proveedor ya mapeado";
var REJECTED$1$1$1 = "Rechazado";
var rejection$1$1$1 = "Rechazados";
var request$1$1$1 = "Solicitar";
var requester$1$1$1 = "Solicitante";
var resource$1$1$1 = "Recurso";
var resourceActivity$1$1$1 = "Recursos";
var resourceDistance$1$1$1 = "Está a";
var resourceRoute$1$1$1 = "Recorrido";
var resourceTime$1$1$1 = "Llega en";
var responsable$1$1$1 = "Responsable";
var responseNumberAbbrev$1$1$1 = "Nº respuestas";
var RISEND$1$1$1 = "Fin RIS";
var RISSTART$1$1$1 = "Inicio RIS";
var rowsPerPage$1$1$1 = "Filas por página";
var saveView$1$1$1 = "Guardar vista";
var sendSMSTracking$1$1$1 = "Enviar SMS seguimiento";
var sendSurvey$1$1$1 = "Enviar encuesta";
var serviceActivity$1$1$1 = "Servicios";
var serviceBudget$1$1$1 = "Propuesta de servicio";
var serviceRequest$1$1$1 = "Solicitud de servicio";
var serviceType$1$1$1 = "Tipo servicio";
var shared$1$1$1 = "Compartido";
var shipmentDate$1$1$1 = "Fecha remesa";
var sign$1$1$1 = "Firmas";
var sta$1$1$1 = "Es.";
var STARTED$1$1$1 = "Iniciado";
var supportTeamAbbrev$1$1$1 = "Equipo Sop.";
var surchargeRate$1$1$1 = "% Recargo noct.";
var surname$1$1$1 = "Apellidos";
var teamMembers$1$1$1 = "Miembros del equipo";
var teamTickets$1$1$1 = "Los del equipo";
var totalPrice$1$1$1 = "Precio total";
var UNAVAILABLE$1$1$1 = "No disponible";
var userProfile$1$1$1 = "Perfil";
var validate$1$1$1 = "Validar";
var validated$1$1$1 = "validado";
var vehicle$1$1$1 = "Vehículo";
var weekend$1$1$1 = "Fin de semana";
var category$1$1$1 = {
  car: "Coche",
  ind: "Industrial",
  moto: "Moto",
  ptf: "Plataforma"
};
var collective2$1$1$1 = {
  toastColectiveDeactivateErrorTitle: "ERROR",
  toastColectiveDeactivateErrorTextDefault: "En estos momentos no es posible desactivar el colectivo. Por favor, vuelve a intentarlo en unos minutos."
};
var companyList$1$1$1 = {
  companyWithCount: "{{count}} Companía",
  companyWithCount_plural: "{{count}} Companías"
};
var depositList$1$1$1 = {
  depositWithCount: "{{count}} Depósito",
  depositWithCount_plural: "{{count}} Depósitos"
};
var format$1$1$1 = {
  currency: "€ ",
  decimalSeparator: ",",
  thousandSeparator: "."
};
var invoiceList$1$1$1 = {
  invoiceWithCount: "{{count}} Factura",
  invoiceWithCount_plural: "{{count}} Facturas"
};
var mediumList$1$1$1 = {
  mediumWithCount: "{{count}} Medio",
  mediumWithCount_plural: "{{count}} Medios"
};
var mediumTypesList$1$1$1 = {
  mediumTypesWithCount: "{{count}} Tipo de medio",
  mediumTypesWithCount_plural: "{{count}} Tipos de medios"
};
var modals$1$1$1 = {
  addService: {
    linkServices: "Vincular servicios",
    linkServicesInfo: "El último servicio Nexus de este vehículo indica que está en un depósito.",
    linkServicesQuestion: "¿Deseas asociar el expediente Nexus y vincular los servicios?"
  },
  budget: {
    timeOut: "Tiempo agotado",
    timeOutInfo: "Se ha agotado el tiempo máximo para aceptar la propuesta. Inténtalo de nuevo."
  },
  ticketDetail: {
    closeTicket: "Cerrar ticket",
    closeTicketQuestion: "¿Estás seguro que deseas cerrar el ticket? Si lo cierras, se dará por resuelto y no podrás enviar más mensajes."
  }
};
var operationTypesList$1$1$1 = {
  operationTypesWithCount: "{{count}} Tipo de intervención",
  operationTypesWithCount_plural: "{{count}} Tipos de intervención"
};
var paymentList$1$1$1 = {
  paymentWithCount: "{{count}} Pago a proveedores",
  paymentWithCount_plural: "{{count}} Pagos a proveedores",
  processPaymentTitle: "Procesar pagos",
  processPaymentText: "Indica la fecha en la que el fichero ha sido procesado por el banco.",
  generatePaymentsTitle: "Generar pagos",
  generatePaymentsText: "Se van a generar todos los pagos hasta la fecha indicada. El fichero N34-14 se enviará por email.",
  toastGeneratePaymentsSuccessTitle: "Pago generado correctamente",
  toastGeneratePaymentsSuccessText: "El pago se ha generado y se ha enviado el fichero.",
  toastProcessPaymentSuccessTitle: "Pago procesado correctamente",
  toastProcessPaymentSuccessText: "El pago se ha procesado con la fecha indicada.",
  toastGeneratePaymentsWarningTitle: "No ha podido generarse",
  toastGeneratePaymentsWarningText: "No hay facturas pendientes hasta esa fecha."
};
var searchTools$1$1$1 = {
  title: "Herramientas de búsqueda",
  byRoadKmTitle: "Busca por carretera y kilómetro",
  byRoadKm_1: "1. Introduce el nombre de la carretera y el punto kilométrico. Ejemplo: E-15/15",
  byRoadKm_2: "2. Pulsa \"Validar\" para validar la ubicación",
  roadKilometer: "Carretera / Kilómetro",
  byCoordsTitle: "Busca por coordenadas",
  byCoords_1: "Pulsa el botón del mapa y localiza la ubicación que necesitas.",
  byCoords_2: "Pulsa el botón derecho y copia las coordenadas que te ofrece Google.",
  byCoords_3: "Pégalas debajo y pulsa \"Validar\" para validar la ubicación.",
  coordsLatitudeLongitude: "Coordenadas (latitud, longitud)"
};
var serviceList$1$1$1 = {
  serviceWithCount: "{{count}} Servicio",
  serviceWithCount_plural: "{{count}} Servicios"
};
var servicesError$1$1$1 = {
  cancelServiceErrorTitle: "Error al solicitar la anulación",
  notCancelableService: "El servicio no se puede anular en su estado actual.",
  invalidService: "No ha sido posible solicitar la anulación del servicio.",
  cancelServiceUnknownError: "En estos momentos no es posible solicitar la anulación del servicio. Vuelva a intentarlo en unos minutos.",
  openDisputeErrorTitle: "Error al solicitar apertura de disputa",
  openDisputeUnknownError: "En estos momentos no es posible abrir una disputa para el servicio. Vuelva a intentarlo en unos minutos.",
  closeDisputeErrorTitle: "Error al solicitar cierre de disputa",
  closeDisputeUnknownError: "En estos momentos no es posible cerrar la disputa del servicio. Vuelva a intentarlo en unos minutos."
};
var transferPeopleError$1$1$1 = {
  cancelTransferPeopleErrorTitle: "Error al solicitar la anulación",
  notCancelableService: "El traslado no se puede anular en su estado actual.",
  invalidTransferPeople: "No ha sido posible solicitar la anulación del traslado.",
  cancelServiceUnknownError: "En estos momentos no es posible solicitar la anulación del traslado. Vuelva a intentarlo en unos minutos."
};
var transferPeopleList$1$1$1 = {
  transferPeopleWithCount: "{{count}} Traslado",
  transferPeopleWithCount_plural: "{{count}} Traslados"
};
var shipment$1$1$1 = {
  collecting: "Interrumpida",
  pending: "Generada",
  billed: "Facturada",
  collected: "Cobrada",
  payed: "Pagada"
};
var ticketDetail$1$1$1 = {
  toastSendMessageSuccessTitle: "Mensaje enviado correctamente",
  toastSendMessageSuccessText: "El mensaje ha sido enviado y añadido a la lista.",
  toastSendMessageErrorTitle: "Error al enviar mensaje",
  toastSendMessageErrorText: "Ha ocurrido un error en el envío del mensaje.",
  toastCloseMessageSuccessTitle: "Ticket cerrado correctamente",
  toastCloseMessageSuccessText: "El ticket ha sido cerrado y actualizado en la lista.",
  toastCloseMessageErrorTitle: "Error al cerrar ticket",
  toastCloseMessageErrorText: "Ha ocurrido un error al cerrar el ticket."
};
var ticketList$1$1$1 = {
  ticketWithCount: "{{count}} Ticket",
  ticketWithCount_plural: "{{count}} Tickets"
};
var user2$1$1$1 = {
  toastUserDeactivateErrorTitle: "ERROR",
  toastUserDeactivateErrorTextDefault: "En estos momentos no es posible desactivar al usuario. Por favor, vuelve a intentarlo en unos minutos.",
  toastUserDeactivateErrorText: "El usuario activo no puede desactivarse a sí mismo.",
  toastUserInServiceDeactivateErrorText: "No es posible desactivar a un usuario que se encuentra actualmente realizando un servicio.",
  toastUserNotificationSuccessTitle: "Notificación enviada",
  toastUserNotificationSuccessText: "Hemos enviado una notificación al usuario con las instrucciones.",
  toastUserNotificationErrorTitle: "Ha ocurrido un error",
  toastUserNotificationErrorText: "No hemos podido enviar la notificación al usuario."
};
var userList$1$1$1 = {
  userWithCount: "{{count}} Usuario",
  userWithCount_plural: "{{count}} Usuarios"
};
var validation$1$1$1 = {
  fieldRequired: "Campo obligatorio",
  invalidCurrencyAmount: "No válido",
  invalidTimeFormat: "Formato de hora no válido"
};
var loginYourAccount$1$1$1 = "Accede a tu cuenta";
var checkYourEmail$1$1$1 = "Comprueba tu correo";
var updatedUser$1$1$1 = "Usuario actualizado";
var errorCreatingCompany$1$1$1 = "Error al crear compañía";
var min$1$1$1 = "min";
var distance$1$1$1 = "Distancia";
var es$2$1$1 = {
  "********** BEGIN CHECKED WORDS **********": "**********",
  "% IRPF": "% IRPF",
  "% IVA": "% IVA",
  IRPF: IRPF$1$1$1,
  IVA: IVA$1$1$1,
  NIF: NIF$1$1$1,
  "NIF/CIF": "NIF/CIF",
  "NIF/SS": "NIF/SS",
  "NIF/CIF/SS": "NIF/CIF/SS",
  "#": "#",
  "1st": "1º",
  "2nd": "2º",
  "3rd": "3º",
  "4th": "4º",
  "5th": "5º",
  "6th": "6º",
  "7th": "7º",
  "8th": "8º",
  "9th": "9º",
  "10th": "10º",
  betweenMinAndMaxKilometers: betweenMinAndMaxKilometers$1$1$1,
  metricUnits: metricUnits$1$1$1,
  imperialUnits: imperialUnits$1$1$1,
  A: A$2$1$1,
  accept: accept$1$1$1,
  accepted: accepted$1$1$1,
  acceptUpdate: acceptUpdate$1$1$1,
  accessToTheViews: accessToTheViews$1$1$1,
  accessWithMicrosoft: accessWithMicrosoft$1$1$1,
  activateGuardMode: activateGuardMode$1$1$1,
  activateGuardModeWarningText: activateGuardModeWarningText$1$1$1,
  activateGuardModeWarningAditionalText: activateGuardModeWarningAditionalText$1$1$1,
  active: active$1$1$1,
  activity: activity$1$1$1,
  accumulateNightAndHolidaySurcharge: accumulateNightAndHolidaySurcharge$1$1$1,
  add: add$1$1$1,
  addAuxService: addAuxService$1$1$1,
  addCapability: addCapability$1$1$1,
  addCollective: addCollective$1$1$1,
  addCost: addCost$1$1$1,
  addCostType: addCostType$1$1$1,
  addedCollective: addedCollective$1$1$1,
  addFault: addFault$1$1$1,
  addedFault: addedFault$1$1$1,
  additionalInformation: additionalInformation$1$1$1,
  additionalPrice: additionalPrice$1$1$1,
  additionalPriceAbbrev: additionalPriceAbbrev$1$1$1,
  addNote: addNote$1$1$1,
  address: address$1$1$1,
  addressNotLocated: addressNotLocated$1$1$1,
  addUserProfile: addUserProfile$1$1$1,
  admin: admin$1$1$1,
  advancedConfiguration: advancedConfiguration$1$1$1,
  aheadServices: aheadServices$1$1$1,
  alert: alert$1$1$1,
  alerts: alerts$1$1$1,
  alertStart: alertStart$1$1$1,
  all_f: all_f$1$1$1,
  all_m: all_m$1$1$1,
  allowAccess: allowAccess$1$1$1,
  allowCalls: allowCalls$1$1$1,
  allowCalls_addService: allowCalls_addService$1$1$1,
  allowGuardErrorTitle: allowGuardErrorTitle$1$1$1,
  allowGuardErrorText: allowGuardErrorText$1$1$1,
  allowSMS: allowSMS$1$1$1,
  allProvidersAutomatic: allProvidersAutomatic$1$1$1,
  anErrorHasOccurred: anErrorHasOccurred$1$1$1,
  applyCosts: applyCosts$1$1$1,
  approve: approve$1$1$1,
  assign: assign$1$1$1,
  "assignment/lastActivityAbbrev": "Asig / ult. ac",
  assignTechnician: assignTechnician$1$1$1,
  assistance: assistance$1$1$1,
  assistanceWithoutTransfer: assistanceWithoutTransfer$1$1$1,
  assistanceWithoutTransferWarning: assistanceWithoutTransferWarning$1$1$1,
  assistanceWithoutTransferWarningQuestion: assistanceWithoutTransferWarningQuestion$1$1$1,
  assisted: assisted$1$1$1,
  assistedInsuredAbbrev: assistedInsuredAbbrev$1$1$1,
  assistedDestinationAddress: assistedDestinationAddress$1$1$1,
  associatedDocuments: associatedDocuments$1$1$1,
  at_time: at_time$1$1$1,
  assigned: assigned$1$1$1,
  ASSIGNED: ASSIGNED$1$1$1,
  attachADocument: attachADocument$1$1$1,
  "attach the following documents": "Adjunta los siguientes documentos",
  attachment: attachment$1$1$1,
  attachments: attachments$1$1$1,
  auction: auction$1$1$1,
  auctionConfiguration: auctionConfiguration$1$1$1,
  auctioned: auctioned$1$1$1,
  AUCTIONED: AUCTIONED$1$1$1,
  auctioning: auctioning$1$1$1,
  AUCTIONING: AUCTIONING$1$1$1,
  auctionInPriority: auctionInPriority$1$1$1,
  auctionInPriority1: auctionInPriority1$1$1$1,
  auctionInPriority2: auctionInPriority2$1$1$1,
  auctionInPriority3: auctionInPriority3$1$1$1,
  auctionInPriority4: auctionInPriority4$1$1$1,
  auctions: auctions$1$1$1,
  auctionService: auctionService$1$1$1,
  auto: auto$1$1$1,
  automatic: automatic$1$1$1,
  automaticProvider: automaticProvider$1$1$1,
  auxiliary: auxiliary$1$1$1,
  auxiliarySettings: auxiliarySettings$1$1$1,
  auxiliaries: auxiliaries$1$1$1,
  auxiliariesRates: auxiliariesRates$1$1$1,
  auxServiceList: auxServiceList$1$1$1,
  auxService: auxService$1$1$1,
  auxServices: auxServices$1$1$1,
  available: available$1$1$1,
  available_plural: available_plural$1$1$1,
  availableProvidersAbbrev: availableProvidersAbbrev$1$1$1,
  availableResources: availableResources$1$1$1,
  availableResourcesWithCount: availableResourcesWithCount$1$1$1,
  availableResourcesWithCount_plural: availableResourcesWithCount_plural$1$1$1,
  average: average$1$1$1,
  averageRating: averageRating$1$1$1,
  B: B$1$1$1,
  base: base$1$1$1,
  baseAmount: baseAmount$1$1$1,
  billed: billed$1$1$1,
  billing: billing$1$1$1,
  brand: brand$1$1$1,
  browse: browse$1$1$1,
  budgetWarningNoBaseFound: budgetWarningNoBaseFound$1$1$1,
  businessIntelligence: businessIntelligence$1$1$1,
  byAmount: byAmount$1$1$1,
  byBrand: byBrand$1$1$1,
  byPositionOnQueue: byPositionOnQueue$1$1$1,
  byScore: byScore$1$1$1,
  byTime: byTime$1$1$1,
  C: C$1$1$1,
  calculateAllServicesAsSuburban: calculateAllServicesAsSuburban$1$1$1,
  calendar: calendar$1$1$1,
  cancel: cancel$1$1$1,
  cancel_2: cancel_2$1$1$1,
  outputCancellationPercentageAbbrev: outputCancellationPercentageAbbrev$1$1$1,
  cancelAmount: cancelAmount$1$1$1,
  cancelRatePercentage: cancelRatePercentage$1$1$1,
  cancelRateAmount: cancelRateAmount$1$1$1,
  cancelReason: cancelReason$1$1$1,
  cancelService: cancelService$1$1$1,
  cancelTransferPeople: cancelTransferPeople$1$1$1,
  cancelTransferPeopleWarning: cancelTransferPeopleWarning$1$1$1,
  "Cannot send service to this provider because it has not defined any deposit (base)": "No se puede enviar el servicio a este proveedor porque no ha definido ningún depósito (base)",
  capabilityList: capabilityList$1$1$1,
  capability: capability$1$1$1,
  capabilityCollectiveAbbrev: capabilityCollectiveAbbrev$1$1$1,
  capabilities: capabilities$1$1$1,
  center: center$1$1$1,
  centerName: centerName$1$1$1,
  centerNotFound: centerNotFound$1$1$1,
  change: change$1$1$1,
  changePassword: changePassword$1$1$1,
  charge: charge$1$1$1,
  chargeWithCount: chargeWithCount$1$1$1,
  chargeWithCount_plural: chargeWithCount_plural$1$1$1,
  check: check$1$1$1,
  childProfile: childProfile$1$1$1,
  chosenDriver: chosenDriver$1$1$1,
  cif: cif$1$1$1,
  city: city$1$1$1,
  "class": "Clase",
  clone: clone$1$1$1,
  cloneService: cloneService$1$1$1,
  close: close$1$1$1,
  closeDispute: closeDispute$1$1$1,
  code: code$1$1$1,
  collectDate: collectDate$1$1$1,
  collected: collected$1$1$1,
  collectInvoice: collectInvoice$1$1$1,
  collective: collective$1$1$1,
  collectives: collectives$1$1$1,
  collectiveWithCount: collectiveWithCount$1$1$1,
  collectiveWithCount_plural: collectiveWithCount_plural$1$1$1,
  collectiveProviderAbbrev: collectiveProviderAbbrev$1$1$1,
  comment: comment$1$1$1,
  commentAboutCapability: commentAboutCapability$1$1$1,
  companies: companies$1$1$1,
  "companies-opt": {
    listWithCount: "{{count}} Compañía",
    listWithCount_plural: "{{count}} Compañías"
  },
  company: company$1$1$1,
  companyName: companyName$1$1$1,
  companyProfile: companyProfile$1$1$1,
  completed: completed$1$1$1,
  configuration: configuration$1$1$1,
  consultList: consultList$1$1$1,
  "continue": "Continuar",
  costName: costName$1$1$1,
  costs: costs$1$1$1,
  costSearch: costSearch$1$1$1,
  costsWithCount: costsWithCount$1$1$1,
  costsWithCount_plural: costsWithCount_plural$1$1$1,
  costSheets: costSheets$1$1$1,
  costSheetStatus: costSheetStatus$1$1$1,
  costType: costType$1$1$1,
  costTypeName: costTypeName$1$1$1,
  costTypes: costTypes$1$1$1,
  costTypesWithCount: costTypesWithCount$1$1$1,
  costTypesWithCount_plural: costTypesWithCount_plural$1$1$1,
  craneService: craneService$1$1$1,
  create: create$1$1$1,
  currentPassword: currentPassword$1$1$1,
  custodyDays: custodyDays$1$1$1,
  customer: customer$1$1$1,
  "customer/capability": "Cliente / prestación",
  "customer/exp": "Cliente / Exp.",
  D: D$1$1$1,
  dashboard: dashboard$1$1$1,
  date: date$1$1$1,
  "Date scheduled service": "Fecha servicio programado",
  dateRangeExceeded: dateRangeExceeded$1$1$1,
  dayAndTime: dayAndTime$1$1$1,
  deadLine: deadLine$1$1$1,
  concessionaire: concessionaire$1$1$1,
  deferred: deferred$1$1$1,
  deferredService: deferredService$1$1$1,
  deferredShort: deferredShort$1$1$1,
  deferredShorter: deferredShorter$1$1$1,
  deleteCost: deleteCost$1$1$1,
  deletePath: deletePath$1$1$1,
  deleteRequest: deleteRequest$1$1$1,
  deposits: deposits$1$1$1,
  description: description$1$1$1,
  detail: detail$1$1$1,
  disconnect: disconnect$1$1$1,
  disputeReason: disputeReason$1$1$1,
  documentation: documentation$1$1$1,
  documentationProfile: documentationProfile$1$1$1,
  documentNumberAbbrev: documentNumberAbbrev$1$1$1,
  documentProfile: documentProfile$1$1$1,
  documentProfiles: documentProfiles$1$1$1,
  "documentProfiles-opt": {
    listWithCount: "{{count}} Perfil de documento",
    listWithCount_plural: "{{count}} Perfiles de documentos"
  },
  "documents-status": {
    pending: "Pendiente de verificación",
    validated: "Válido",
    rejected: "Rechazado el",
    rejectReason: "Motivo de rechazo",
    expired: "Caducó el",
    current: "Vigente hasta el"
  },
  documentAdded: documentAdded$1$1$1,
  documentType: documentType$1$1$1,
  documentTypes: documentTypes$1$1$1,
  "documentTypes-opt": {
    listWithCount: "{{count}} Tipo de documento",
    listWithCount_plural: "{{count}} Tipos de documentos"
  },
  doNotAssociate: doNotAssociate$1$1$1,
  dragData: dragData$1$1$1,
  driver: driver$1$1$1,
  drivers: drivers$1$1$1,
  "driver/medium": "Conductor / Medio",
  duplicate: duplicate$1$1$1,
  duplicateService: duplicateService$1$1$1,
  E: E$1$1$1,
  edit: edit$1$1$1,
  editAuxService: editAuxService$1$1$1,
  editCapability: editCapability$1$1$1,
  editCollective: editCollective$1$1$1,
  editCost: editCost$1$1$1,
  editCostType: editCostType$1$1$1,
  editFault: editFault$1$1$1,
  editSupportTeam: editSupportTeam$1$1$1,
  editUserProfile: editUserProfile$1$1$1,
  email: email$1$1$1,
  endService: endService$1$1$1,
  entry: entry$1$1$1,
  entryDateAbbrev: entryDateAbbrev$1$1$1,
  error: error$1$1$1,
  errorAddingDocument: errorAddingDocument$1$1$1,
  estimatedTime: estimatedTime$1$1$1,
  execution: execution$1$1$1,
  executionProfile: executionProfile$1$1$1,
  expense: expense$1$1$1,
  expiredCode: expiredCode$1$1$1,
  expires: expires$1$1$1,
  events: events$1$1$1,
  excessOfTimeForOutService: excessOfTimeForOutService$1$1$1,
  excessOfTimeForUrbanService: excessOfTimeForUrbanService$1$1$1,
  excessOfTimeInCurrentStatus: excessOfTimeInCurrentStatus$1$1$1,
  excessOfTimeToCompleteService: excessOfTimeToCompleteService$1$1$1,
  excessOfTimeToStartScheduledService: excessOfTimeToStartScheduledService$1$1$1,
  F: F$1$1$1,
  fault: fault$1$1$1,
  faults: faults$1$1$1,
  faultCollectiveAbbrev: faultCollectiveAbbrev$1$1$1,
  faultWithCount: faultWithCount$1$1$1,
  faultWithCount_plural: faultWithCount_plural$1$1$1,
  fee: fee$1$1$1,
  fieldRequired: fieldRequired$1$1$1,
  "fields with an asterisk are required": "Los campos con (*) son obligatorios.",
  file: file$1$1$1,
  "filecase/assistedAbbrev": "Exp. / asistido",
  "filecase/interventionAbbrev": "Exp./Int.",
  filterByDriverStatus: filterByDriverStatus$1$1$1,
  filterByVehicleType: filterByVehicleType$1$1$1,
  financial: financial$1$1$1,
  financialBreakdown: financialBreakdown$1$1$1,
  finish: finish$1$1$1,
  finishedServices: finishedServices$1$1$1,
  firstPrice: firstPrice$1$1$1,
  firstUnitPriceAbbrev: firstUnitPriceAbbrev$1$1$1,
  fixed: fixed$1$1$1,
  "for": "Para",
  "forgotPassword?": "¿Olvidaste la contraseña?",
  formError: formError$1$1$1,
  franchise: franchise$1$1$1,
  franchises: franchises$1$1$1,
  freeCranesBefore1Hour: freeCranesBefore1Hour$1$1$1,
  fromUntil: fromUntil$1$1$1,
  fullAddress: fullAddress$1$1$1,
  fullScreenAbbrev: fullScreenAbbrev$1$1$1,
  G: G$1$1$1,
  generalInformationAbbrev: generalInformationAbbrev$1$1$1,
  generate: generate$1$1$1,
  generated: generated$1$1$1,
  geofence: geofence$1$1$1,
  geofence_plural: geofence_plural$1$1$1,
  geofenceWithCount: geofenceWithCount$1$1$1,
  geofenceWithCount_plural: geofenceWithCount_plural$1$1$1,
  geoJson: geoJson$1$1$1,
  globalAuction: globalAuction$1$1$1,
  graceDays: graceDays$1$1$1,
  grecaptchaNote: grecaptchaNote$1$1$1,
  guardMode: guardMode$1$1$1,
  H: H$1$1$1,
  help: help$1$1$1,
  hide: hide$1$1$1,
  holder: holder$1$1$1,
  holidays: holidays$1$1$1,
  home: home$1$1$1,
  hour: hour$1$1$1,
  hours: hours$1$1$1,
  I: I$1$1$1,
  IBAN: IBAN$1$1$1,
  icon: icon$1$1$1,
  iconUrl: iconUrl$1$1$1,
  identificationIcon: identificationIcon$1$1$1,
  "If you finish the service you will no longer be able to edit or reschedule it Do you wish to continue?": "Si finalizas el servicio, ya no podrás editarlo o reprogramarlo. ¿Deseas continuar?",
  "If you recover the saved request you will lose the data you have entered in the form do you wish to continue?": "Si recuperas la solicitud guardada, perderás los datos que has introducido en el formulario, ¿deseas continuar?",
  "If you delete the request the saved data will be deleted Do you wish to continue?": "Si eliminas la solicitud, se borrarán los datos guardados, ¿deseas continuar?",
  "If you prefer, you can send the service to a waiting list": "Si lo prefieres, puedes enviar el servicio a una lista de espera",
  image: image$1$1$1,
  immediate: immediate$1$1$1,
  immediate_plural: immediate_plural$1$1$1,
  immediateService: immediateService$1$1$1,
  "import": "Importar",
  incorrectLocationFormat: incorrectLocationFormat$1$1$1,
  infoWindowIcon: infoWindowIcon$1$1$1,
  inParking: inParking$1$1$1,
  inRis: inRis$1$1$1,
  inris: inris$1$1$1,
  inServiceResourcesWithCount: inServiceResourcesWithCount$1$1$1,
  inServiceResourcesWithCount_plural: inServiceResourcesWithCount_plural$1$1$1,
  instant: instant$1$1$1,
  insurancePolicyInfo: insurancePolicyInfo$1$1$1,
  insured: insured$1$1$1,
  insured_autoType: insured_autoType$1$1$1,
  insured_homeType: insured_homeType$1$1$1,
  insuredAutoType: insuredAutoType$1$1$1,
  insuredHomeType: insuredHomeType$1$1$1,
  insuredObjectAbbrev: insuredObjectAbbrev$1$1$1,
  insuredProperty: insuredProperty$1$1$1,
  integrationProfile: integrationProfile$1$1$1,
  integrationProfileAbbrev: integrationProfileAbbrev$1$1$1,
  internalCode: internalCode$1$1$1,
  internalNote: internalNote$1$1$1,
  internalNotes: internalNotes$1$1$1,
  interrupted: interrupted$1$1$1,
  intervention: intervention$1$1$1,
  interventionAbbrev: interventionAbbrev$1$1$1,
  interventions: interventions$1$1$1,
  inUrbanArea: inUrbanArea$1$1$1,
  invalidNexusFilecase: invalidNexusFilecase$1$1$1,
  invalidText: invalidText$1$1$1,
  invoice: invoice$1$1$1,
  "invoice (services - base)": "Factura (servicios - base)",
  "invoice-status": {
    pending: "Pendiente",
    billed: "Facturada",
    collected: "Cobrada",
    payed: "Pagada"
  },
  invoiceNumberAbbrev: invoiceNumberAbbrev$1$1$1,
  forTheDay: forTheDay$1$1$1,
  isNotValid: isNotValid$1$1$1,
  issuedInvoices: issuedInvoices$1$1$1,
  itAlreadyExists: itAlreadyExists$1$1$1,
  J: J$1$1$1,
  K: K$1$1$1,
  L: L$1$1$1,
  label: label$1$1$1,
  labeled: labeled$1$1$1,
  "labeled-opt": {
    listWithCount: "{{count}} Rotulación",
    listWithCount_plural: "{{count}} Rotulaciones"
  },
  labels: labels$1$1$1,
  lastActivity: lastActivity$1$1$1,
  lastActivity2: lastActivity2$1$1$1,
  legal: legal$1$1$1,
  legalId: legalId$1$1$1,
  list: list$1$1$1,
  listEntryMax24H: listEntryMax24H$1$1$1,
  loaded: loaded$1$1$1,
  loadTimeInMinutes: loadTimeInMinutes$1$1$1,
  located: located$1$1$1,
  location: location$1$1$1,
  locked: locked$1$1$1,
  lockedByNexus: lockedByNexus$1$1$1,
  login: login$1$1$1,
  logo: logo$1$1$1,
  logout: logout$1$1$1,
  M: M$1$1$1,
  managed: managed$1$1$1,
  managedProvider: managedProvider$1$1$1,
  manual: manual$1$1$1,
  manualProvider: manualProvider$1$1$1,
  map: map$1$1$1,
  mapIcon: mapIcon$1$1$1,
  mapOfGoingServices: mapOfGoingServices$1$1$1,
  mapOfResources: mapOfResources$1$1$1,
  mapOfTracking: mapOfTracking$1$1$1,
  mapView: mapView$1$1$1,
  max: max$1$1$1,
  maxAllowedTimeInMinutes: maxAllowedTimeInMinutes$1$1$1,
  maxDistance: maxDistance$1$1$1,
  maxDistanceToCrane: maxDistanceToCrane$1$1$1,
  maxHours: maxHours$1$1$1,
  maxRadius: maxRadius$1$1$1,
  maxTime: maxTime$1$1$1,
  maxTimeOnList: maxTimeOnList$1$1$1,
  medium: medium$1$1$1,
  mediumNotFound: mediumNotFound$1$1$1,
  mediumType: mediumType$1$1$1,
  mediumTypes: mediumTypes$1$1$1,
  mediumTypes2: mediumTypes2$1$1$1,
  "mediumTypes-opt": {
    listWithCount: "{{count}} Tipo de medio",
    listWithCount_plural: "{{count}} Tipos de medios"
  },
  minute: minute$1$1$1,
  minutes: minutes$1$1$1,
  modeAndName: modeAndName$1$1$1,
  model: model$1$1$1,
  modifiedCollective: modifiedCollective$1$1$1,
  modifiedFault: modifiedFault$1$1$1,
  myTickets: myTickets$1$1$1,
  N: N$1$1$1,
  name: name$1$1$1,
  nameSurname: nameSurname$1$1$1,
  "new": "Nuevo",
  new_female: new_female$1$1$1,
  new_plural: new_plural$1$1$1,
  newAuxService: newAuxService$1$1$1,
  newAuxiliaryService: newAuxiliaryService$1$1$1,
  newDayAndTime: newDayAndTime$1$1$1,
  newPassword: newPassword$1$1$1,
  newService: newService$1$1$1,
  newSupportTeam: newSupportTeam$1$1$1,
  newVehicleAssistance: newVehicleAssistance$1$1$1,
  newVialService: newVialService$1$1$1,
  nexusMapServiceError: nexusMapServiceError$1$1$1,
  nick: nick$1$1$1,
  no: no$1$1$1,
  noProvidersAvailable: noProvidersAvailable$1$1$1,
  notApplyCosts: notApplyCosts$1$1$1,
  notParticipating: notParticipating$1$1$1,
  noCovered: noCovered$1$1$1,
  noDocumentsAssociatedToService: noDocumentsAssociatedToService$1$1$1,
  noResourcesAvailableMsg: noResourcesAvailableMsg$1$1$1,
  noSubscribe: noSubscribe$1$1$1,
  note: note$1$1$1,
  notes: notes$1$1$1,
  notesAssociatedWithTheService: notesAssociatedWithTheService$1$1$1,
  noTicketsAssociatedToService: noTicketsAssociatedToService$1$1$1,
  noTicketsAssociatedToTransfer: noTicketsAssociatedToTransfer$1$1$1,
  noNotesAssociatedToService: noNotesAssociatedToService$1$1$1,
  notifications: notifications$1$1$1,
  noTransfersAvailable: noTransfersAvailable$1$1$1,
  noValid: noValid$1$1$1,
  numberAbbrev: numberAbbrev$1$1$1,
  numberOfPeopleAbbrev: numberOfPeopleAbbrev$1$1$1,
  numberOfReviewsAbbrev: numberOfReviewsAbbrev$1$1$1,
  O: O$1$1$1,
  office: office$1$1$1,
  ongoing: ongoing$1$1$1,
  onQueue: onQueue$1$1$1,
  openDispute: openDispute$1$1$1,
  operational: operational$1$1$1,
  operationTypes: operationTypes$1$1$1,
  "operationTypes-opt": {
    listWithCount: "{{count}} Tipo de intervención",
    listWithCount_plural: "{{count}} Tipos de intervención"
  },
  origin: origin$1$1$1,
  originalServiceData: originalServiceData$1$1$1,
  originDeposit: originDeposit$1$1$1,
  otherSettings: otherSettings$1$1$1,
  orYouCan: orYouCan$1$1$1,
  outlay: outlay$1$1$1,
  outlays: outlays$1$1$1,
  "outlays-opt": {
    listWithCount: "{{count}} Gasto adicional",
    listWithCount_plural: "{{count}} Gastos adicionales"
  },
  P: P$1$1$1,
  paid: paid$1$1$1,
  passengers: passengers$1$1$1,
  passengersWithCount: passengersWithCount$1$1$1,
  passengersWithCount_plural: passengersWithCount_plural$1$1$1,
  password: password$1$1$1,
  passwordsNotMatch: passwordsNotMatch$1$1$1,
  paymentsToProviders: paymentsToProviders$1$1$1,
  "paymentsToProviders-opt": {
    listWithCount: "{{count}} Pago a proveedor",
    listWithCount_plural: "{{count}} Pagos a proveedores"
  },
  pdf: pdf$1$1$1,
  pending: pending$1$1$1,
  pendings: pendings$1$1$1,
  PENDING: PENDING$1$1$1,
  pending_assign: pending_assign$1$1$1,
  PENDING_ASSIGN: PENDING_ASSIGN$1$1$1,
  PENDINGASSIGN: PENDINGASSIGN$1$1$1,
  pendingDocumentation: pendingDocumentation$1$1$1,
  pendingDocuments: pendingDocuments$1$1$1,
  "pendingDocuments-opt": {
    listWithCount: "{{count}} Documento pendiente",
    listWithCount_plural: "{{count}} Documentos pendientes"
  },
  pendingPassword: pendingPassword$1$1$1,
  pendingProfile: pendingProfile$1$1$1,
  peopleTransferActivity: peopleTransferActivity$1$1$1,
  pleaseTryAgainLater: pleaseTryAgainLater$1$1$1,
  "Please indicate the reason for cancelling the service and enter the charges if necessary": "Por favor, indica el motivo por el que anulas el servicio, e introduce los gastos si es necesario.",
  phone: phone$1$1$1,
  phoneNumberAbbrev: phoneNumberAbbrev$1$1$1,
  photoWithCount: photoWithCount$1$1$1,
  photoWithCount_plural: photoWithCount_plural$1$1$1,
  photos: photos$1$1$1,
  planned: planned$1$1$1,
  PLANNED: PLANNED$1$1$1,
  plannedService: plannedService$1$1$1,
  plate: plate$1$1$1,
  plateDoesNotCorrespondToTheFilecase: plateDoesNotCorrespondToTheFilecase$1$1$1,
  policy: policy$1$1$1,
  policyCoverageLimit: policyCoverageLimit$1$1$1,
  policyCoverageLimit2: policyCoverageLimit2$1$1$1,
  policyInformation: policyInformation$1$1$1,
  policyLimitExceeded: policyLimitExceeded$1$1$1,
  policyLimitExceededAux: policyLimitExceededAux$1$1$1,
  policyNumberAbbrev: policyNumberAbbrev$1$1$1,
  policySearch: policySearch$1$1$1,
  positionAbbrev: positionAbbrev$1$1$1,
  "price(approx)": "Precio (aprox.)",
  priority: priority$1$1$1,
  priority1Providers: priority1Providers$1$1$1,
  priority2Providers: priority2Providers$1$1$1,
  priority3Providers: priority3Providers$1$1$1,
  priorityAllProviders: priorityAllProviders$1$1$1,
  priorityProvider: priorityProvider$1$1$1,
  process: process$1$1$1$1,
  profile: profile$1$1$1,
  profileNotFound: profileNotFound$1$1$1,
  profiles: profiles$1$1$1,
  "profiles-opt": {
    listWithCount: "{{count}} Perfil",
    listWithCount_plural: "{{count}} Perfiles",
    addTitle: "Añadir perfil",
    addText: "Completa los datos del perfil para añadirlo.",
    toastAddSuccessTitle: "Perfil creado correctamente",
    toastAddSuccessText: "El perfil ha sido creado y añadido a la lista."
  },
  proposals: proposals$1$1$1,
  provider: provider$1$1$1,
  providersInZone: providersInZone$1$1$1,
  providersOutZone: providersOutZone$1$1$1,
  providerTechnician: providerTechnician$1$1$1,
  providerVialSettings: providerVialSettings$1$1$1,
  providerEditVialSettingsHeaderText: providerEditVialSettingsHeaderText$1$1$1,
  providerAuxiliariesSettings: providerAuxiliariesSettings$1$1$1,
  providerEditAuxiliariesSettingsHeaderText: providerEditAuxiliariesSettingsHeaderText$1$1$1,
  "provider/driverAbbrev": "Prov / conductor",
  providers: providers$1$1$1,
  provider_pending: provider_pending$1$1$1,
  PROVIDER_PENDING: PROVIDER_PENDING$1$1$1,
  PROVIDERPENDING: PROVIDERPENDING$1$1$1,
  provider_accepted: provider_accepted$1$1$1,
  PROVIDER_ACCEPTED: PROVIDER_ACCEPTED$1$1$1,
  PROVIDERACCEPTED: PROVIDERACCEPTED$1$1$1,
  provider_accept: provider_accept$1$1$1,
  PROVIDER_ACCEPT: PROVIDER_ACCEPT$1$1$1,
  PROVIDERACCEPT: PROVIDERACCEPT$1$1$1,
  providersSelection: providersSelection$1$1$1,
  providerList: providerList$1$1$1,
  providersMap: providersMap$1$1$1,
  providerType: providerType$1$1$1,
  providerTypeVial: providerTypeVial$1$1$1,
  providerTypeAux: providerTypeAux$1$1$1,
  providerWithoutDefinedDeposit: providerWithoutDefinedDeposit$1$1$1,
  province: province$1$1$1,
  Q: Q$1$1$1,
  queueEntryDate: queueEntryDate$1$1$1,
  queued: queued$1$1$1,
  QUEUED: QUEUED$1$1$1,
  queuedService: queuedService$1$1$1,
  R: R$1$1$1,
  rates: rates$1$1$1,
  rating: rating$1$1$1,
  ratings: ratings$1$1$1,
  ratingsUserName: ratingsUserName$1$1$1,
  ratingsWithCount: ratingsWithCount$1$1$1,
  ratingsWithCount_plural: ratingsWithCount_plural$1$1$1,
  ready: ready$1$1$1,
  reAssign: reAssign$1$1$1,
  reAssignProvider: reAssignProvider$1$1$1,
  reAskForResetEmail: reAskForResetEmail$1$1$1,
  received: received$1$1$1,
  receivedInvoices: receivedInvoices$1$1$1,
  recoverRequest: recoverRequest$1$1$1,
  recoverYourPassword: recoverYourPassword$1$1$1,
  region: region$1$1$1,
  registrationInformationOnInvoices: registrationInformationOnInvoices$1$1$1,
  reject: reject$1$1$1,
  rejectCosts: rejectCosts$1$1$1,
  rejectionReason: rejectionReason$1$1$1,
  rejectionReasons: rejectionReasons$1$1$1,
  "rejectionReasons-opt": {
    listWithCount: "{{count}} Motivo de rechazo",
    listWithCount_plural: "{{count}} Motivos de rechazo"
  },
  rejectionType: rejectionType$1$1$1,
  release: release$1$1$1,
  removeFromDashboard: removeFromDashboard$1$1$1,
  repeated: repeated$1$1$1,
  repeatPassword: repeatPassword$1$1$1,
  requestCapability: requestCapability$1$1$1,
  requestInfo: requestInfo$1$1$1,
  requestLocationByWhatsApp: requestLocationByWhatsApp$1$1$1,
  requestMediumAbbrev: requestMediumAbbrev$1$1$1,
  requestProcessedCorrectly: requestProcessedCorrectly$1$1$1,
  requestWithoutIAssociatedPolicy: requestWithoutIAssociatedPolicy$1$1$1,
  required: required$1$1$1,
  reschedule: reschedule$1$1$1,
  RESCHEDULED: RESCHEDULED$1$1$1,
  rescheduleComment: rescheduleComment$1$1$1,
  rescheduleReason: rescheduleReason$1$1$1,
  rescheduleService: rescheduleService$1$1$1,
  rescheduleServiceDeferredTextModal: rescheduleServiceDeferredTextModal$1$1$1,
  rescheduleServicePlannedText1Modal: rescheduleServicePlannedText1Modal$1$1$1,
  rescheduleServicePlannedText2Modal: rescheduleServicePlannedText2Modal$1$1$1,
  resetPassword: resetPassword$1$1$1,
  resetYourPassword: resetYourPassword$1$1$1,
  resources: resources$1$1$1,
  resourcesMap: resourcesMap$1$1$1,
  restore: restore$1$1$1,
  result: result$1$1$1,
  "return": "Volver",
  ris: ris$1$1$1,
  risService: risService$1$1$1,
  S: S$1$1$1,
  save: save$1$1$1,
  saveChanges: saveChanges$1$1$1,
  savedRequests: savedRequests$1$1$1,
  saveRequest: saveRequest$1$1$1,
  "Saving your request for later retrieval will delete the form data Do you wish to continue?": "Guardando la solicitud para recuperarla más tarde, se borrarán los datos del formulario, ¿deseas continuar?",
  schedule: schedule$1$1$1,
  scheduled: scheduled$1$1$1,
  SCHEDULED: SCHEDULED$1$1$1,
  scheduled_plural: scheduled_plural$1$1$1,
  scheduledAbbrev: scheduledAbbrev$1$1$1,
  scheduledDateInvalidErrorText: scheduledDateInvalidErrorText$1$1$1,
  scheduleDriver: scheduleDriver$1$1$1,
  scheduledServiceNotFound: scheduledServiceNotFound$1$1$1,
  scheduledFor: scheduledFor$1$1$1,
  searchResourceOrTechnician: searchResourceOrTechnician$1$1$1,
  searchResources: searchResources$1$1$1,
  searchAResource: searchAResource$1$1$1,
  searchAService: searchAService$1$1$1,
  searchByAssistedOrFilecase: searchByAssistedOrFilecase$1$1$1,
  searchByAssistedFilecaseOrPlate: searchByAssistedFilecaseOrPlate$1$1$1,
  searchByAssistedFilecaseOrProvider: searchByAssistedFilecaseOrProvider$1$1$1,
  searchByCodeOrName: searchByCodeOrName$1$1$1,
  searchByCodeNameOrCostType: searchByCodeNameOrCostType$1$1$1,
  searchByCodeNameOrMediumType: searchByCodeNameOrMediumType$1$1$1,
  searchByCustomer: searchByCustomer$1$1$1,
  searchByCustomerOrFilecase: searchByCustomerOrFilecase$1$1$1,
  searchByCustomerFilecaseOrPlate: searchByCustomerFilecaseOrPlate$1$1$1,
  searchByFileCase: searchByFileCase$1$1$1,
  searchByIdForOrFilecaseNumber: searchByIdForOrFilecaseNumber$1$1$1,
  searchByInvoiceNumber: searchByInvoiceNumber$1$1$1,
  searchByName: searchByName$1$1$1,
  searchByNameCIFOrAddress: searchByNameCIFOrAddress$1$1$1,
  searchByNameOrAddress: searchByNameOrAddress$1$1$1,
  searchByNameOrCode: searchByNameOrCode$1$1$1,
  searchByNamePlateOrCode: searchByNamePlateOrCode$1$1$1,
  searchByNameSurnameUserOrNick: searchByNameSurnameUserOrNick$1$1$1,
  searchByProviderOrName: searchByProviderOrName$1$1$1,
  searchByTerm: searchByTerm$1$1$1,
  searchInsurancePolicy: searchInsurancePolicy$1$1$1,
  seeAverages: seeAverages$1$1$1,
  breakdown: breakdown$1$1$1,
  seeCapabilityComment: seeCapabilityComment$1$1$1,
  seeComment: seeComment$1$1$1,
  seeContactAndComment: seeContactAndComment$1$1$1,
  seeDescription: seeDescription$1$1$1,
  seeService: seeService$1$1$1,
  "Select a transfer associated with the service": "Selecciona un traslado asociado al servicio",
  selfValidated: selfValidated$1$1$1,
  send: send$1$1$1,
  sendComments: sendComments$1$1$1,
  sended: sended$1$1$1,
  sendEmail: sendEmail$1$1$1,
  sendForReview: sendForReview$1$1$1,
  sendTo: sendTo$1$1$1,
  sendToList: sendToList$1$1$1,
  serverConnectionError: serverConnectionError$1$1$1,
  service: service$1$1$1,
  serviceExecution: serviceExecution$1$1$1,
  serviceInAuction: serviceInAuction$1$1$1,
  serviceLevels: serviceLevels$1$1$1,
  serviceMap: serviceMap$1$1$1,
  serviceNotFound: serviceNotFound$1$1$1,
  serviceRequestAndTracking: serviceRequestAndTracking$1$1$1,
  services: services$1$1$1,
  serviceSentToAuction: serviceSentToAuction$1$1$1,
  serviceStatus: serviceStatus$1$1$1,
  settings: settings$1$1$1,
  settingsUpdated: settingsUpdated$1$1$1,
  sharedCode: sharedCode$1$1$1,
  sharedNote: sharedNote$1$1$1,
  sharedNotes: sharedNotes$1$1$1,
  "shipment (services - base)": "Remesa (servicios - base)",
  shipments: shipments$1$1$1,
  shipmentStatusValues: shipmentStatusValues$1$1$1,
  showAllMediums: showAllMediums$1$1$1,
  showSolicitedMedium: showSolicitedMedium$1$1$1,
  situation: situation$1$1$1,
  solicitedMedium: solicitedMedium$1$1$1,
  sortCriteria: sortCriteria$1$1$1,
  soundActivated: soundActivated$1$1$1,
  soundOff: soundOff$1$1$1,
  start: start$1$1$1,
  started: started$1$1$1,
  status: status$1$1$1,
  statuses: statuses$1$1$1,
  subject: subject$1$1$1,
  subscribe: subscribe$1$1$1,
  subtotal: subtotal$1$1$1,
  suburb: suburb$1$1$1,
  suburbService: suburbService$1$1$1,
  summary: summary$1$1$1,
  supportCenter: supportCenter$1$1$1,
  supportTeam: supportTeam$1$1$1,
  survey: survey$1$1$1,
  surveys: surveys$1$1$1,
  T: T$1$1$1,
  taxes: taxes$1$1$1,
  team: team$1$1$1,
  teamName: teamName$1$1$1,
  technician: technician$1$1$1,
  technicians: technicians$1$1$1,
  "The maximum date range allowed is 45 days": "El rango de fechas máximo permitido es de 45 días",
  "The request could not be made Try again": "No se ha podido realizar la solicitud. Inténtalo de nuevo.",
  "The proposal could not be retrieved because the collective does not exist": "No se ha podido recuperar la solicitud porque el colectivo no existe",
  "The service has been sent successfully": "El servicio se ha enviado correctamente.",
  "The service rejection could not be completed": "El rechazo del servicio no ha podido completarse.",
  "The service will be sent after completing the request process": "El servicio se enviará tras completar el proceso de solicitud",
  theField: theField$1$1$1,
  ticket: ticket$1$1$1,
  tickets: tickets$1$1$1,
  ticketStatus: ticketStatus$1$1$1,
  time: time$1$1$1,
  "time(approx)": "Tiempo (aprox.)",
  timeInAlert: timeInAlert$1$1$1,
  timeline: timeline$1$1$1,
  title: title$1$1$1,
  toastErrorDuplicateAddressPickupDeliveryTitle: toastErrorDuplicateAddressPickupDeliveryTitle$1$1$1,
  toastErrorDuplicateAddressPickupDeliveryText: toastErrorDuplicateAddressPickupDeliveryText$1$1$1,
  toastErrorDuplicateAddressPickupDestinationTitle: toastErrorDuplicateAddressPickupDestinationTitle$1$1$1,
  toastErrorDuplicateAddressPickupDestinationText: toastErrorDuplicateAddressPickupDestinationText$1$1$1,
  toastErrorTextDefault: toastErrorTextDefault$1$1$1,
  toastErrorTitleDefault: toastErrorTitleDefault$1$1$1,
  toastErrorTransferPeopleBudget: toastErrorTransferPeopleBudget$1$1$1,
  toastErrorTitle_downloadFile: toastErrorTitle_downloadFile$1$1$1,
  toastErrorText_downloadFile: toastErrorText_downloadFile$1$1$1,
  toastSuccessTextDefault: toastSuccessTextDefault$1$1$1,
  toastSuccessTitleDefault: toastSuccessTitleDefault$1$1$1,
  today: today$1$1$1,
  toDefine: toDefine$1$1$1,
  total: total$1$1$1,
  totals: totals$1$1$1,
  toTheClient: toTheClient$1$1$1,
  toTheProvider: toTheProvider$1$1$1,
  town: town$1$1$1,
  tracking: tracking$1$1$1,
  trackingMessage: trackingMessage$1$1$1,
  transfer: transfer$1$1$1,
  transferHasBeenCancelled: transferHasBeenCancelled$1$1$1,
  transferPeople: transferPeople$1$1$1,
  transferPeopleBudget: transferPeopleBudget$1$1$1,
  transferPeopleRequest: transferPeopleRequest$1$1$1,
  transferPeopleRequestType: transferPeopleRequestType$1$1$1,
  transferPeopleRequiredValidPhoneNumber: transferPeopleRequiredValidPhoneNumber$1$1$1,
  transfers: transfers$1$1$1,
  transfersAvailable: transfersAvailable$1$1$1,
  transferTheAssisted: transferTheAssisted$1$1$1,
  type: type$1$1$1,
  typeAndName: typeAndName$1$1$1,
  "type/capability": "Tipo/prestación",
  typeless: typeless$1$1$1,
  typeOfService: typeOfService$1$1$1,
  types: types$1$1$1,
  U: U$1$1$1,
  "undefined": "Sin definir",
  udWithCount: udWithCount$1$1$1,
  udWithCount_plural: udWithCount_plural$1$1$1,
  unAssign: unAssign$1$1$1,
  unAssignTechnician: unAssignTechnician$1$1$1,
  unAssignTechnicianModalText: unAssignTechnicianModalText$1$1$1,
  unAssignTechnicianModalAditionalText: unAssignTechnicianModalAditionalText$1$1$1,
  unAssignDriver: unAssignDriver$1$1$1,
  unAssignDriverModalText: unAssignDriverModalText$1$1$1,
  unAssignDriverModalAditionalText: unAssignDriverModalAditionalText$1$1$1,
  unavailable: unavailable$1$1$1,
  units: units$1$1$1,
  unitAbbrev: unitAbbrev$1$1$1,
  unitsAbbrev: unitsAbbrev$1$1$1,
  unselected: unselected$1$1$1,
  unsubscribe: unsubscribe$1$1$1,
  urban: urban$1$1$1,
  urbanFee: urbanFee$1$1$1,
  urbanService: urbanService$1$1$1,
  user: user$1$1$1,
  userProfiles: userProfiles$1$1$1,
  userProfilesWithCount: userProfilesWithCount$1$1$1,
  userProfilesWithCount_plural: userProfilesWithCount_plural$1$1$1,
  users: users$1$1$1,
  "users-opt": {
    listWithCount: "{{count}} Usuario",
    listWithCount_plural: "{{count}} Usuarios"
  },
  userType: userType$1$1$1,
  V: V$1$1$1,
  validFrom: validFrom$1$1$1,
  validUntil: validUntil$1$1$1,
  variable: variable$1$1$1,
  vehicleAssistance: vehicleAssistance$1$1$1,
  vehicleTypes: vehicleTypes$1$1$1,
  "vehicleTypes-opt": {
    listWithCount: "{{count}} Tipo de vehículo",
    listWithCount_plural: "{{count}} Tipos de vehículos"
  },
  "vehicle/fault": "Vehículo / Avería",
  version: version$1$1$1,
  vial: vial$1$1$1,
  vials: vials$1$1$1,
  vialRates: vialRates$1$1$1,
  vialServices: vialServices$1$1$1,
  vialSettings: vialSettings$1$1$1,
  view: view$1$1$1,
  viewAssistedRating: viewAssistedRating$1$1$1,
  viewContact: viewContact$1$1$1,
  viewContactandComment: viewContactandComment$1$1$1,
  viewRoute: viewRoute$1$1$1,
  views: views$1$1$1,
  vin: vin$1$1$1,
  virtualSwitchboard: virtualSwitchboard$1$1$1,
  W: W$1$1$1,
  waitingList: waitingList$1$1$1,
  web: web$1$1$1,
  webAddress: webAddress$1$1$1,
  wholeWordSearch: wholeWordSearch$1$1$1,
  wholeWordSearch3Charts: wholeWordSearch3Charts$1$1$1,
  withAlert: withAlert$1$1$1,
  withholdings: withholdings$1$1$1,
  withPriority1: withPriority1$1$1$1,
  withPriority2: withPriority2$1$1$1,
  withPriority3: withPriority3$1$1$1,
  writeANote: writeANote$1$1$1,
  wrongUser: wrongUser$1$1$1,
  wrongUsernameOrPassword: wrongUsernameOrPassword$1$1$1,
  X: X$1$1$1,
  Y: Y$1$1$1,
  year: year$1$1$1,
  yes: yes$1$1$1,
  yesterday: yesterday$1$1$1,
  youHaveExceededTheNumberOfAtempsts: youHaveExceededTheNumberOfAtempsts$1$1$1,
  Z: Z$1$1$1,
  "A dispute has been opened for this service": "Se ha abierto una disputa para este servicio.",
  "Add the following cost data": "Añade los siguientes datos del costo.",
  "Add the following cost type data": "Añade los siguientes datos del tipo de costo.",
  "Allow assigning rate in service request": "Asignar la tarifa en la solicitud de servicio",
  "Allow opening internal tickets": "Permitir abrir tickets internos",
  "An error has occurred in the creation of the collective": "Ha ocurrido un error en la creación del colectivo.",
  "An error has occurred in the creation of the fault": "Ha ocurrido un error en la creación de la avería.",
  "An error occurred while trying to upload the file": "Ha ocurrido un error al intentar subir el archivo.",
  "Approve costs": "Aprobar costos",
  "Are you sure you want to approve the cost sheet? Once approved you will not be able to request changes": "¿Seguro que deseas aprobar la hoja de costos? Una vez aprobada, no podrás solicitar cambios.",
  "Are you sure you want to send the cost sheet for review? Once it has been sent you will not be able to edit it again": "¿Seguro que deseas enviar la hoja de costos a revisión? Una vez enviada, no podrás editarla de nuevo.",
  "Assistance has arrived at pickup": "La asistencia ha llegado a la recogida",
  "Assistance is on the way": "La asistencia está en camino",
  "Assistance reached its destination": "La asistencia llegó a su destino",
  "At this time it is not possible to access the service": "En estos momentos no es posible acceder al servicio",
  "Attention a new service will be requested without any associated policy": "Atención, se va a solicitar un nuevo servicio sin ninguna póliza asociada.",
  "Capability created successfully": "Prestación creada correctamente",
  "Capability has been created and added to the list": "La prestación ha sido creada y añadida a la lista.",
  "Capability has been updated successfully": "La prestación ha sido actualizada correctamente.",
  "Capability updated": "Prestación actualizada",
  "Complete the data of the auxiliar service to add it": "Completa los datos del servicio auxiliar para añadirlo.",
  "Complete the data of the auxiliar service to edit it": "Completa los datos del servicio auxiliar para editarlo.",
  "Complete the data of the capability to add it": "Completa los datos de la prestación para añadirla.",
  "Complete the data of the capability to edit it": "Completa los datos de la prestación para editarla.",
  "Complete the data of the collective to add it": "Completa los datos del colectivo para añadirlo.",
  "Complete the data of the fault to add it": "Completa los datos de la avería para añadirla.",
  "Contact your insurer for more information": "Contacta con tu aseguradora para más información",
  "Costs approved successfully": "Costos aprobados correctamente",
  "Costs could not be approved": "No ha sido posible aprobar los costos",
  "Costs could not be rejected": "No ha sido posible rechazar los costos",
  "Cost created successfully": "Costo creado correctamente",
  "Costs rejected successfully": "Costos rechazados correctamente",
  "Costs sheet approved": "Hoja de costos aprobada",
  "Cost sheet could not be saved": "No ha sido posible guardar la hoja de costos",
  "Cost sheet could not be sent for review": "No ha sido posible enviar a revisión la hoja de costos",
  "Cost sheet rejected": "Hoja de costos rechazada",
  "Costs sheet saved successfully": "Hoja de costos guardada con éxito",
  "Costs sheet sent for review": "Hoja de costos enviada a revisión",
  "CostType created successfully": "Tipo de costo creado correctamente",
  "Cost has been created and added to the list": "El costo ha sido creado y añadido a la lista",
  "CostType has been created and added to the list": "El tipo de costo ha sido creado y añadido a la lista",
  "Cost has been updated successfully": "El costo ha sido actualizado correctamente.",
  "CostType has been updated successfully": "El tipo de costo ha sido actualizado correctamente.",
  "Cost updated": "Costo actualizado",
  "CostType updated": "Tipo de costo actualizado",
  "Data has been saved successfully": "Los datos se han guardado correctamente",
  "Do not allow the assistant to call the driver from the tracking widget": "No permitir al asistido llamar al chofer desde el widget de seguimiento",
  "Do not allow technician to create notes": "No permitir al técnico crear notas",
  "Do not allow the technician to reschedule the service": "No permitir al técnico reprogramar el servicio",
  "Do not show the technician the assisted person phone number": "No mostrar al técnico el teléfono del asistido",
  "Do not take into account the first section for the calculation of the rate": "No tener en cuenta el primer tramo para el cálculo de la tarifa",
  "Do you want to send the request": "¿Deseas enviar la solicitud?",
  "Edit the data you need for the following cost": "Edita los datos que necesites del siguiente costo.",
  "Edit the data you need for the following type cost": "Edita los datos que necesites del siguiente tipo de costo.",
  "Edit the data you need from the following collective": "Edita los datos que necesites del siguiente colectivo.",
  "Edit the data you need from the following fault": "Edita los datos que necesites de la siguiente avería.",
  "Edit the details you need for the following user profile": "Edita los datos que necesites del siguiente perfil de usuario.",
  "Error creating capability": "Error al crear prestación",
  "Error creating cost": "Error al crear costo",
  "Error creating costType": "Error al crear tipo de costo",
  "Error creating user profile": "Error al crear perfil de usuario",
  "Error has ocurred while creating the capability": "Ha ocurrido un error en la creación de la prestación.",
  "Error has ocurred while creating the cost": "Ha ocurrido un error durante la creación del costo.",
  "Error has ocurred while creating the costType": "Ha ocurrido un error durante la creación del tipo de costo.",
  "Error has ocurred while creating the user profile": "Ha ocurrido un error durante la creación del perfil de usuario.",
  "Error has ocurred while updating the capability": "Ha ocurrido un error durante la actualización de la prestación.",
  "Error has ocurred while updating the cost": "Ha ocurrido un error durante la actualización del costo.",
  "Error has ocurred while updating the costType": "Ha ocurrido un error durante la actualización del tipo de costo.",
  "Error has ocurred while updating the user profile": "Ha ocurrido un error durante la actualización del perfil de usuario.",
  "Error updating capability": "Error al actualizar prestación",
  "Error updating cost": "Error al actualizar costo",
  "Error updating costType": "Error al actualizar tipo de costo",
  "Error updating user profile": "Error al actualizar perfil de usuario",
  "Fill in the details of the user profile to add it": "Completa los datos del perfil del usuario para añadirlo.",
  "Follow your roadside assistance service in real time by clicking on the continue button": "Sigue en tiempo real tu servicio de asistencia en carretera, pulsando en el botón de continuar",
  "Follow your assistance service in real time by clicking on the continue button": "Sigue en tiempo real tu servicio de asistencia, pulsando en el botón de continuar",
  "Hide middle phone in tracking widget": "Ocultar el teléfono del medio en el widget de seguimiento",
  "It is not possible to access": "No es posible acceder",
  "It has not been possible to add the new note to the service": "No ha sido posible añadir al servicio la nueva nota.",
  "It has not been possible to consult the events associated with the service": "No ha sido posible consultar los eventos asociados al servicio.",
  "It has not been possible to modify the collective data": "No ha sido posible modificar los datos del colectivo.",
  "It has not been possible to modify the fault data": "No ha sido posible modificar los datos de la avería.",
  "It has not been possible to update the information": "No ha sido posible actualizar la información",
  "It was not possible to finish the service": "No ha sido posible finalizar el servicio.",
  "It was not possible to obtain the survey data": "No ha sido posible obtener los datos de la encuesta.",
  "It was not possible to recover the integration profiles": "No ha sido posible recuperar los perfiles de integración.",
  "Manage the documents necessary to work with Nexus": "Gestiona los documentos necesarios para trabajar con Nexus",
  "No auction providers found at the service location": "No se han encontrado proveedores de subasta en la ubicación del servicio",
  "No changes have been made to the service": "No se han realizado cambios en el servicio.",
  "Please indicate the reason why you wish to reject the costs associated with the service": "Por favor, indica el motivo por el que deseas rechazar los costos que están asociados al servicio.",
  "Please retry in a few minutes": "Vuelve a intentarlo en unos minutos.",
  "Plot the geofence on the map, complete the information and press the save button": "Define la geocerca en el mapa, completa la información y pulsa el botón guardar",
  "__providerName settings have been updated": "Los ajustes de {{providerName}} han sido actualizados",
  "Reload the page or contact your company": "Recarga la página o contacta con tu compañía",
  "Request processed correctly": "Solicitud procesada de forma correcta",
  "Select a provider to assign to the service": "Selecciona un proveedor para asignar al servicio.",
  "Select the providers that will participate in the auction": "Selecciona los proveedores que participarán en la subasta",
  "Send costs for review": "Enviar costos a revisión",
  "Service acceptance could not be completed": "La aceptación del servicio no ha podido completarse.",
  "Service assignment could not be completed": "La asignación del servicio no ha podido completarse.",
  "Service requested from the widget": "Servicio solicitado desde el widget",
  "Sorry attendance has been canceled": "Lo sentimos, la asistencia ha sido cancelada",
  "Spoofing the assisted phone number": "Suplantación del nº de teléfono del asistido",
  "Successfully sent, under review": "Enviada correctamente, está en revisión",
  "Support has ended": "La asistencia ha finalizado",
  "Thank you very much for your confidence": "Muchas gracias por tu confianza",
  "The collective has been created and added to the list": "El colectivo ha sido creado y añadido a la lista.",
  "The cost could not be modified": "El costo no ha podido ser modificado",
  "The dispute for this service has been closed": "Se ha cerrado la disputa para este servicio.",
  "The document has been attached to the service": "El documento se ha adjuntado al servicio.",
  "The fault has been created and added to the list": "La avería ha sido creada y añadida a la lista.",
  "The file must be pdf jpg or png": "El archivo tiene que ser: pdf, jpg o png.",
  "The service has been canceled": "El servicio ha sido anulado.",
  "The service has been created and added to the list": "El servicio ha sido creado y añadido a la lista.",
  "The service has been rescheduled": "El servicio ha sido reprogramado.",
  "The service has been scheduled for the day": "El servicio ha sido programado para el día",
  "There is no assigned provider": "No hay proveedor asignado",
  "There are no documents associated": "No hay documentos asociados",
  "There are no events associated with the service": "No hay eventos asociados al servicio.",
  "User profile created successfully": "Perfil de usuario creado correctamente",
  "User profile has been created and added to the list": "El perfil de usuario ha sido creado y añadido a la lista.",
  "User profile has been updated successfully": "El perfil de usuario ha sido actualizado correctamente.",
  "User profile updated": "Perfil de usuario actualizado",
  "We are at your disposal whenever you need it": "Estamos a tu disposición siempre que lo necesites",
  "We are sorry It has not been possible to show the tracking of your service": "Lo sentimos. No ha sido posible mostrar el seguimiento de tu servicio.",
  "We are trying to repair your vehicle": "Estamos tratando de reparar tu vehículo",
  "We have not been able to connect you to our network": "No hemos podido conectarte a nuestra red",
  "We have updated the information of the collective": "La información del colectivo se ha actualizado correctamente.",
  "We have updated the information of the fault": "La información de la avería se ha actualizado correctamente.",
  "Welcome to the __companyName tracking platform": "Bienvenido a la plataforma de seguimiento de {{companyName}}",
  "Your company does not have integration defined with Azure": "",
  "Your user is blocked by Nexus": "Tu usuario está bloquedado por Nexus",
  "Your vehicle is being moved": "Tu vehículo está siendo trasladado",
  "********** END CHECKED WORDS **********": "",
  "********** BEGIN PHRASES **********": "**********",
  "No services performed since the renewal date": "No hay servicios realizados desde la fecha de renovación",
  "********** BEGIN COMPANY PROFILE SETTINGS **********": "**********",
  "Assignment algorithm": "Algoritmo de asignación",
  "Service request": "Solicitud del servicio",
  "SMS messages": "Mensajes SMS",
  "Maximum time given to a resource to accept or reject a service": "Tiempo máximo que se le otorga a un recurso para aceptar o rechazar un servicio",
  "Maximum time given to a provider to accept or reject a service": "Tiempo máximo que se le otorga a un proveedor para aceptar o rechazar un servicio",
  "Maximum time in which a service request can be accepted": "Tiempo máximo en el que se puede aceptar una solicitud de servicio",
  "Maximum time for all providers": "Tiempo máximo para todos los proveedores",
  "Maximum time for providers with priority": "Tiempo máximo para proveedores con prioridad {{priority}}",
  "Maximum radial distance to search for resources in a service request": "Distancia máxima radial para buscar recursos en una solicitud de servicio",
  "Default distance when sending a to assign a waiting service to a resource": "Distancia por defecto al enviar un servicio a la lista de espera",
  "Maximum total distance of a service route": "Distancia máxima total de la ruta de un servicio",
  "Origin location for calculating the rate in automatic services": "Ubicación de origen para el cálculo de la tarifa en servicios automáticos",
  "From deposit": "Desde depósito",
  "From resource": "Desde recurso",
  "Show option to cancel services at no cost": "Mostrar opción de anular servicios sin coste",
  "Show policy information in the service file": "Mostrar datos de póliza en la ficha del servicio",
  "Block editing of the fault": "Bloquear la edición de la avería",
  "Show the clone services button": "Mostrar el botón de clonar servicios",
  "Show the mandatory damage report by default": "Mostrar el parte de daños obligatorio por defecto",
  "Maximum number of photos that can be requested in a service": "Máximo nº de fotos que se pueden solicitar en un servicio",
  "Number of mandatory photos by default": "Número de fotos obligatorias por defecto",
  "Message sender": "Remitente de los mensajes",
  maxMinutes: maxMinutes$1$1$1,
  maxPhotos: maxPhotos$1$1$1,
  between0And5Minutes: between0And5Minutes$1$1$1,
  between0And10Minutes: between0And10Minutes$1$1$1,
  between0And240Minutes: between0And240Minutes$1$1$1,
  between1And7Minutes: between1And7Minutes$1$1$1,
  between2And5Minutes: between2And5Minutes$1$1$1,
  between2And10Minutes: between2And10Minutes$1$1$1,
  between0And10Photos: between0And10Photos$1$1$1,
  between1And10Characters: between1And10Characters$1$1$1,
  "Fault by medium type": "Avería por tipo de medio",
  "********** END COMPANY PROFILE SETTINGS **********": "**********",
  "********** BEGIN COMPANY PROFILE SERVICE LEVELS **********": "**********",
  between0And120Minutes: between0And120Minutes$1$1$1,
  "Maximum times in vial services": "Tiempos máximos en servicios viales",
  "Time for the provider to accept the service": "Tiempo para que el proveedor acepte el servicio",
  "Time for the provider to assign the service to a resource": "Tiempo para que el proveedor asigne el servicio a un recurso",
  "Time to start the service after the resource accepts it": "Tiempo para iniciar el servicio después de que el recurso lo acepte",
  "Time to locate the pick-up location in urban services": "Tiempo para localizar el lugar de recogida en servicios locales",
  "Time to locate the pick-up location in suburban services": "Tiempo para localizar el lugar de recogida en servicios carreteros",
  "Time to carry out an on-site repair": "Tiempo de realización de una reparación in situ",
  "Time to reach the delivery location": "Tiempo para llegar al lugar de entrega",
  "Time to carry out an urban service": "Tiempo de realización de un servicio local",
  "Time to carry out an suburban service": "Tiempo de realización de un servicio carretero",
  "Maximum times in auxiliary services": "Tiempos máximos en servicios auxiliares",
  "Time that the service can be in completed status": "Tiempo que puede estar el servicio en estado completado",
  "Time to assign an urban service to a technician": "Tiempo de asignación de un servicio local a un técnico",
  "Time to assign an suburban service to a technician": "Tiempo de asignación de un servicio carretero a un técnico",
  "Time to locate the location from the start of the service": "Tiempo para localizar la ubicación desde que se inicia el servicio",
  "Waiting time before starting a scheduled service": "Tiempo de espera antes de iniciar un servicio programado",
  "********** END COMPANY PROFILE SERVICE LEVELS **********": "**********",
  "*** ERRORS ***": "",
  "Date not in valid range": "La fecha está fuera de rango",
  "Hours not in valid range": "La hora está fuera de rango",
  "Distance not in valid range": "La distancia está fuera de rango",
  "Mandatory request body not found": "La información obligatoria de la petición es incorrecta",
  "Selected budget already confirmed": "El presupuesto seleccionado ha sido confirmado previamente",
  "Selected budget expired": "El presupuesto seleccionado ha expirado",
  "Selected budget not found": "El presupuesto seleccionado no ha podido ser localizado",
  "The token is invalid": "El token no es válido",
  "*** ERRORS - END ***": "",
  "An error occurred while approving this document": "Ha ocurrido un error al aprobar este documento",
  "An error occurred while rejecting this document": "Ha ocurrido un error al rechazar este documento",
  "Are you sure you want to accept the update? By doing so, you allow Nexus to send you services under the terms of this rate": "",
  "Are you sure you want to delete the cost?": "¿Seguro que deseas eliminar el costo?",
  "Are you sure you want finish the service?": "¿Seguro que deseas finalizar el servicio?",
  "Complete the fields to change your access password": "Completa los campos para cambiar tu contraseña de acceso",
  "Error approving the document": "Error al aprobar el documento",
  "Error rejecting the document": "Error al rechazar el documento",
  "It's necessary to change the access password to continue with the registration": "Es necesario cambiar la contraseña de acceso, para continuar con el registro",
  "Manage subscriptions to rates": "Gestiona las suscripciones a las tarifas",
  "Now you can use it when you login": "Ya puedes utilizarla al iniciar sesión",
  "There are unsaved changes": "Hay cambios sin guardar",
  "********** BEGIN PENDING WORDS **********": "",
  ACCEPTED: ACCEPTED$1$1$1,
  add_company_description: add_company_description$1$1$1,
  add_company: add_company$1$1$1,
  addChartText: addChartText$1$1$1,
  addChartTitle: addChartTitle$1$1$1,
  all_female: all_female$1$1$1,
  all_male: all_male$1$1$1,
  amount: amount$1$1$1,
  "Amount outside of policy coverage Payment of the assisted to the provider": "Importe fuera de cobertura de póliza (pago del asistido al proveedor)",
  apply: apply$1$1$1,
  assignProvider: assignProvider$1$1$1,
  assignedToMe: assignedToMe$1$1$1,
  assignItToMe: assignItToMe$1$1$1,
  AVAILABLE: AVAILABLE$1$1$1,
  blocked: blocked$1$1$1,
  budgetToastSuccessText: budgetToastSuccessText$1$1$1,
  budgetToastSuccessTitle: budgetToastSuccessTitle$1$1$1,
  scheduledBudgetToastSuccessText: scheduledBudgetToastSuccessText$1$1$1,
  scheduledBudgetToastSuccessTitle: scheduledBudgetToastSuccessTitle$1$1$1,
  transferPeopleBudgetToastSuccessText: transferPeopleBudgetToastSuccessText$1$1$1,
  transferPeopleBudgetToastSuccessTitle: transferPeopleBudgetToastSuccessTitle$1$1$1,
  budgetToastSuccessQueueText: budgetToastSuccessQueueText$1$1$1,
  budgetToastSuccessQueueTitle: budgetToastSuccessQueueTitle$1$1$1,
  bussy: bussy$1$1$1,
  CANCELED: CANCELED$1$1$1,
  centerNum: centerNum$1$1$1,
  centers: centers$1$1$1,
  closed: closed$1$1$1,
  codeAlreadyAssigned: codeAlreadyAssigned$1$1$1,
  color: color$1$1$1,
  companyPendingDocumentation: companyPendingDocumentation$1$1$1,
  companyProviderCode: companyProviderCode$1$1$1,
  COMPLETED: COMPLETED$1$1$1,
  custodyRate: custodyRate$1$1$1,
  damageReport: damageReport$1$1$1,
  damageRequired: damageRequired$1$1$1,
  day: day$1$1$1,
  days: days$1$1$1,
  del: del$1$1$1,
  delivery: delivery$1$1$1,
  deliveryAddressRequired: deliveryAddressRequired$1$1$1,
  destination: destination$1$1$1,
  documents: documents$1$1$1,
  exit: exit$1$1$1,
  expired: expired$1$1$1,
  EXTRA_CHARGES: EXTRA_CHARGES$1$1$1,
  extraCharges: extraCharges$1$1$1,
  festive: festive$1$1$1,
  fieldsRequired: fieldsRequired$1$1$1,
  files: files$1$1$1,
  filters: filters$1$1$1,
  FINISHED: FINISHED$1$1$1,
  free: free$1$1$1,
  from: from$1$1$1,
  fromDate: fromDate$1$1$1,
  generalInfo: generalInfo$1$1$1,
  groupName: groupName$1$1$1,
  id: id$1$1$1,
  IN_SERVICE: IN_SERVICE$1$1$1,
  information: information$1$1$1,
  INRIS: INRIS$1$1$1,
  integrated: integrated$1$1$1,
  invite: invite$1$1$1,
  invoiceDate: invoiceDate$1$1$1,
  lastAct: lastAct$1$1$1,
  left: left$1$1$1,
  LOADED: LOADED$1$1$1,
  LOCATED: LOCATED$1$1$1,
  locations: locations$1$1$1,
  mediums: mediums$1$1$1,
  MEDIUMS: MEDIUMS$1$1$1,
  modify: modify$1$1$1,
  newRates: newRates$1$1$1,
  nexus: nexus$1$1$1,
  nexusFee: nexusFee$1$1$1,
  nFilecase: nFilecase$1$1$1,
  nFilecaseAbbrev: nFilecaseAbbrev$1$1$1,
  nickName: nickName$1$1$1,
  nightlyEnd: nightlyEnd$1$1$1,
  nightlyStart: nightlyStart$1$1$1,
  nightly: nightly$1$1$1,
  nigthly: nigthly$1$1$1,
  nightlyFestive: nightlyFestive$1$1$1,
  nInvoice: nInvoice$1$1$1,
  nInvoices: nInvoices$1$1$1,
  none: none$1$1$1,
  NOT_IN_NEXUS: NOT_IN_NEXUS$1$1$1,
  not: not$1$1$1,
  nNexus: nNexus$1$1$1,
  nPayments: nPayments$1$1$1,
  nServices: nServices$1$1$1,
  numberOfInvoices: numberOfInvoices$1$1$1,
  of: of$1$1$1,
  open: open$1$1$1,
  outOfService: outOfService$1$1$1,
  ownFilecaseNumber: ownFilecaseNumber$1$1$1,
  ownFilecaseNumberAbbrev: ownFilecaseNumberAbbrev$1$1$1,
  partialPrice: partialPrice$1$1$1,
  participants: participants$1$1$1,
  participation: participation$1$1$1,
  payed: payed$1$1$1,
  payments: payments$1$1$1,
  pendingAbbrev: pendingAbbrev$1$1$1,
  photosNumber: photosNumber$1$1$1,
  pickup: pickup$1$1$1,
  "pickup/delivery": "Recogida / entrega",
  pickupAddress: pickupAddress$1$1$1,
  pictures: pictures$1$1$1,
  "private": "Privado",
  processDate: processDate$1$1$1,
  processed: processed$1$1$1,
  providerAlreadyMapped: providerAlreadyMapped$1$1$1,
  "public": "Público",
  REJECTED: REJECTED$1$1$1,
  rejection: rejection$1$1$1,
  request: request$1$1$1,
  requester: requester$1$1$1,
  resource: resource$1$1$1,
  resourceActivity: resourceActivity$1$1$1,
  resourceDistance: resourceDistance$1$1$1,
  resourceRoute: resourceRoute$1$1$1,
  resourceTime: resourceTime$1$1$1,
  responsable: responsable$1$1$1,
  responseNumberAbbrev: responseNumberAbbrev$1$1$1,
  RISEND: RISEND$1$1$1,
  RISSTART: RISSTART$1$1$1,
  rowsPerPage: rowsPerPage$1$1$1,
  saveView: saveView$1$1$1,
  sendSMSTracking: sendSMSTracking$1$1$1,
  sendSurvey: sendSurvey$1$1$1,
  serviceActivity: serviceActivity$1$1$1,
  serviceBudget: serviceBudget$1$1$1,
  serviceRequest: serviceRequest$1$1$1,
  serviceType: serviceType$1$1$1,
  shared: shared$1$1$1,
  shipmentDate: shipmentDate$1$1$1,
  sign: sign$1$1$1,
  sta: sta$1$1$1,
  STARTED: STARTED$1$1$1,
  supportTeamAbbrev: supportTeamAbbrev$1$1$1,
  surchargeRate: surchargeRate$1$1$1,
  surname: surname$1$1$1,
  teamMembers: teamMembers$1$1$1,
  teamTickets: teamTickets$1$1$1,
  totalPrice: totalPrice$1$1$1,
  UNAVAILABLE: UNAVAILABLE$1$1$1,
  userProfile: userProfile$1$1$1,
  validate: validate$1$1$1,
  validated: validated$1$1$1,
  vehicle: vehicle$1$1$1,
  weekend: weekend$1$1$1,
  "***** STRUCTURES *****": "*****",
  category: category$1$1$1,
  collective2: collective2$1$1$1,
  companyList: companyList$1$1$1,
  depositList: depositList$1$1$1,
  format: format$1$1$1,
  invoiceList: invoiceList$1$1$1,
  mediumList: mediumList$1$1$1,
  "mediums-toast": {
    toastErrorDeactivateMediumTitle: "ERROR",
    toastErrorDeactivateMediumText: "En estos momentos no es posible desactivar el medio. Por favor, vuelve a intentarlo en unos minutos.",
    toastErrorDeactivateMediumInServideTitle: "ERROR",
    toastErrorDeactivateMediumInServiceText: "No es posible desactivar un medio que se encuentra actualmente realizando un servicio."
  },
  mediumTypesList: mediumTypesList$1$1$1,
  modals: modals$1$1$1,
  operationTypesList: operationTypesList$1$1$1,
  paymentList: paymentList$1$1$1,
  "rates-concepts": {
    startupFee: "Tarifa de salida",
    scheduledFee: "Tarifa programado",
    nexusFee: "Tarifa de Nexus",
    km: "Tarifa por km",
    mi: "Tarifa por mi",
    minute: "Tarifa por minuto",
    loadTime: "Tiempo de carga",
    surchargeRate: "Recargo",
    cancelRate: "Anulación",
    cancelAmount: "Importe anulación",
    surchargeType: "Tipo de recargo",
    freeCustodyDays: "Custodia gratuita",
    custodyRate: "Custodia",
    urban: "Local",
    urbanFee: "Tarifa local",
    franchise: "Franquicia"
  },
  searchTools: searchTools$1$1$1,
  serviceList: serviceList$1$1$1,
  servicesError: servicesError$1$1$1,
  transferPeopleError: transferPeopleError$1$1$1,
  transferPeopleList: transferPeopleList$1$1$1,
  shipment: shipment$1$1$1,
  "shipments-opt": {
    listWithCount: "{{count}} Remesa",
    listWithCount_plural: "{{count}} Remesas",
    collectInvoiceErrorTitle: "Error al solicitar el cobro de la factura",
    collectInvoiceUnknownError: "En estos momentos no es posible realizar la operación. Vuelva a intentarlo en unos minutos."
  },
  "shipments-opt2": {
    collectInvoiceErrorTitle: "Error al solicitar el cobro de la factura",
    collectInvoiceUnknownError: "En estos momentos no es posible realizar la operación. Vuelva a intentarlo en unos minutos."
  },
  ticketDetail: ticketDetail$1$1$1,
  ticketList: ticketList$1$1$1,
  user2: user2$1$1$1,
  userList: userList$1$1$1,
  validation: validation$1$1$1,
  loginYourAccount: loginYourAccount$1$1$1,
  checkYourEmail: checkYourEmail$1$1$1,
  updatedUser: updatedUser$1$1$1,
  errorCreatingCompany: errorCreatingCompany$1$1$1,
  min: min$1$1$1,
  distance: distance$1$1$1,
  "---": "---"
};
function _extends$1$1$1() {
  _extends$1$1$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1$1$1.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$1$1$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var CustomCheckbox$1$1$1 = withStyles({
  root: {
    "&$checked": {
      color: "#ec754a"
    }
  },
  checked: {}
})(function (props) {
  return /*#__PURE__*/React__default__default__default__default.createElement(Checkbox, _extends$1$1$1({
    color: "default"
  }, props));
});
var commonjsGlobal$1$1$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function unwrapExports$1$1$1(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function createCommonjsModule$1$1$1(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
function getCjsExportFromNamespace$1$1$1(n) {
  return n && n['default'] || n;
}
function commonjsRequire$1$1$1() {
  throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}
var b$1$1$1 = "function" === typeof Symbol && Symbol["for"],
  c$1$1$1 = b$1$1$1 ? Symbol["for"]("react.element") : 60103,
  d$1$1$1 = b$1$1$1 ? Symbol["for"]("react.portal") : 60106,
  e$1$1$1 = b$1$1$1 ? Symbol["for"]("react.fragment") : 60107,
  f$1$1$1 = b$1$1$1 ? Symbol["for"]("react.strict_mode") : 60108,
  g$1$1$1 = b$1$1$1 ? Symbol["for"]("react.profiler") : 60114,
  h$1$1$1 = b$1$1$1 ? Symbol["for"]("react.provider") : 60109,
  k$1$1$1 = b$1$1$1 ? Symbol["for"]("react.context") : 60110,
  l$1$1$1 = b$1$1$1 ? Symbol["for"]("react.async_mode") : 60111,
  m$1$1$1 = b$1$1$1 ? Symbol["for"]("react.concurrent_mode") : 60111,
  n$1$1$1 = b$1$1$1 ? Symbol["for"]("react.forward_ref") : 60112,
  p$1$1$1 = b$1$1$1 ? Symbol["for"]("react.suspense") : 60113,
  q$1$1$1 = b$1$1$1 ? Symbol["for"]("react.suspense_list") : 60120,
  r$2$1$1 = b$1$1$1 ? Symbol["for"]("react.memo") : 60115,
  t$1$1$1 = b$1$1$1 ? Symbol["for"]("react.lazy") : 60116,
  v$1$1$1 = b$1$1$1 ? Symbol["for"]("react.block") : 60121,
  w$1$1$1 = b$1$1$1 ? Symbol["for"]("react.fundamental") : 60117,
  x$1$1$1 = b$1$1$1 ? Symbol["for"]("react.responder") : 60118,
  y$1$1$1 = b$1$1$1 ? Symbol["for"]("react.scope") : 60119;
function z$1$1$1(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c$1$1$1:
        switch (a = a.type, a) {
          case l$1$1$1:
          case m$1$1$1:
          case e$1$1$1:
          case g$1$1$1:
          case f$1$1$1:
          case p$1$1$1:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k$1$1$1:
              case n$1$1$1:
              case t$1$1$1:
              case r$2$1$1:
              case h$1$1$1:
                return a;
              default:
                return u;
            }
        }
      case d$1$1$1:
        return u;
    }
  }
}
function A$1$1$1$1(a) {
  return z$1$1$1(a) === m$1$1$1;
}
var AsyncMode$1$1$1 = l$1$1$1;
var ConcurrentMode$1$1$1 = m$1$1$1;
var ContextConsumer$1$1$1 = k$1$1$1;
var ContextProvider$1$1$1 = h$1$1$1;
var Element$1$1$1 = c$1$1$1;
var ForwardRef$1$1$1 = n$1$1$1;
var Fragment$1$1$1 = e$1$1$1;
var Lazy$1$1$1 = t$1$1$1;
var Memo$1$1$1 = r$2$1$1;
var Portal$1$1$1 = d$1$1$1;
var Profiler$1$1$1 = g$1$1$1;
var StrictMode$1$1$1 = f$1$1$1;
var Suspense$1$1$1 = p$1$1$1;
var isAsyncMode$1$1$1 = function isAsyncMode(a) {
  return A$1$1$1$1(a) || z$1$1$1(a) === l$1$1$1;
};
var isConcurrentMode$1$1$1 = A$1$1$1$1;
var isContextConsumer$1$1$1 = function isContextConsumer(a) {
  return z$1$1$1(a) === k$1$1$1;
};
var isContextProvider$1$1$1 = function isContextProvider(a) {
  return z$1$1$1(a) === h$1$1$1;
};
var isElement$1$1$1 = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c$1$1$1;
};
var isForwardRef$1$1$1 = function isForwardRef(a) {
  return z$1$1$1(a) === n$1$1$1;
};
var isFragment$1$1$1 = function isFragment(a) {
  return z$1$1$1(a) === e$1$1$1;
};
var isLazy$1$1$1 = function isLazy(a) {
  return z$1$1$1(a) === t$1$1$1;
};
var isMemo$1$1$1 = function isMemo(a) {
  return z$1$1$1(a) === r$2$1$1;
};
var isPortal$1$1$1 = function isPortal(a) {
  return z$1$1$1(a) === d$1$1$1;
};
var isProfiler$1$1$1 = function isProfiler(a) {
  return z$1$1$1(a) === g$1$1$1;
};
var isStrictMode$1$1$1 = function isStrictMode(a) {
  return z$1$1$1(a) === f$1$1$1;
};
var isSuspense$1$1$1 = function isSuspense(a) {
  return z$1$1$1(a) === p$1$1$1;
};
var isValidElementType$1$1$1 = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e$1$1$1 || a === m$1$1$1 || a === g$1$1$1 || a === f$1$1$1 || a === p$1$1$1 || a === q$1$1$1 || "object" === typeof a && null !== a && (a.$$typeof === t$1$1$1 || a.$$typeof === r$2$1$1 || a.$$typeof === h$1$1$1 || a.$$typeof === k$1$1$1 || a.$$typeof === n$1$1$1 || a.$$typeof === w$1$1$1 || a.$$typeof === x$1$1$1 || a.$$typeof === y$1$1$1 || a.$$typeof === v$1$1$1);
};
var typeOf$1$1$1 = z$1$1$1;
var reactIs_production_min$1$1$1 = {
  AsyncMode: AsyncMode$1$1$1,
  ConcurrentMode: ConcurrentMode$1$1$1,
  ContextConsumer: ContextConsumer$1$1$1,
  ContextProvider: ContextProvider$1$1$1,
  Element: Element$1$1$1,
  ForwardRef: ForwardRef$1$1$1,
  Fragment: Fragment$1$1$1,
  Lazy: Lazy$1$1$1,
  Memo: Memo$1$1$1,
  Portal: Portal$1$1$1,
  Profiler: Profiler$1$1$1,
  StrictMode: StrictMode$1$1$1,
  Suspense: Suspense$1$1$1,
  isAsyncMode: isAsyncMode$1$1$1,
  isConcurrentMode: isConcurrentMode$1$1$1,
  isContextConsumer: isContextConsumer$1$1$1,
  isContextProvider: isContextProvider$1$1$1,
  isElement: isElement$1$1$1,
  isForwardRef: isForwardRef$1$1$1,
  isFragment: isFragment$1$1$1,
  isLazy: isLazy$1$1$1,
  isMemo: isMemo$1$1$1,
  isPortal: isPortal$1$1$1,
  isProfiler: isProfiler$1$1$1,
  isStrictMode: isStrictMode$1$1$1,
  isSuspense: isSuspense$1$1$1,
  isValidElementType: isValidElementType$1$1$1,
  typeOf: typeOf$1$1$1
};
var reactIs_development$1$1$1 = createCommonjsModule$1$1$1(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs$1$1$1 = createCommonjsModule$1$1$1(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min$1$1$1;
  } else {
    module.exports = reactIs_development$1$1$1;
  }
});
var getOwnPropertySymbols$1$1$1 = Object.getOwnPropertySymbols;
var hasOwnProperty$1$1$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable$1$1$1 = Object.prototype.propertyIsEnumerable;
function toObject$1$1$1(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative$1$1$1() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String('abc');
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
var objectAssign$1$1$1 = shouldUseNative$1$1$1() ? Object.assign : function (target, source) {
  var from;
  var to = toObject$1$1$1(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty$1$1$1.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols$1$1$1) {
      symbols = getOwnPropertySymbols$1$1$1(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable$1$1$1.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};
var ReactPropTypesSecret$2$1$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1$1$1$1 = ReactPropTypesSecret$2$1$1;
var has$2$1$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$2$1$1 = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1$1$1$1 = ReactPropTypesSecret_1$1$1$1;
  var loggedTypeFailures$1$1$1 = {};
  var has$1$1$1$1 = has$2$1$1;
  printWarning$2$1$1 = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function checkPropTypes$1$1$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1$1$1$1(typeSpecs, typeSpecName)) {
        var error;
        try {
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1$1$1$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$2$1$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures$1$1$1)) {
          loggedTypeFailures$1$1$1[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$2$1$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
checkPropTypes$1$1$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures$1$1$1 = {};
  }
};
var checkPropTypes_1$1$1$1 = checkPropTypes$1$1$1;
var printWarning$1$1$1$1 = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  printWarning$1$1$1$1 = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull$1$1$1() {
  return null;
}
var factoryWithTypeCheckers$1$1$1 = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  var ANONYMOUS = '<<anonymous>>';
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  function is(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  }
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1$1$1$1) {
        if (throwOnDirectAccess) {
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
            printWarning$1$1$1$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull$1$1$1);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1$1$1$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs$1$1$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1$1$1$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1$1$1$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull$1$1$1;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$2$1$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1$1$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1$1$1$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull$1$1$1;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1$1$1$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull$1$1$1;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1$1$1$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$2$1$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1$1$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      var allKeys = objectAssign$1$1$1({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$2$1$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1$1$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    if (propType === 'symbol') {
      return true;
    }
    if (!propValue) {
      return false;
    }
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1$1$1$1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1$1$1$1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
function emptyFunction$1$1$1() {}
function emptyFunctionWithReset$1$1$1() {}
emptyFunctionWithReset$1$1$1.resetWarningCache = emptyFunction$1$1$1;
var factoryWithThrowingShims$1$1$1 = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1$1$1$1) {
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset$1$1$1,
    resetWarningCache: emptyFunction$1$1$1
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
var propTypes$1$1$1 = createCommonjsModule$1$1$1(function (module) {
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs$1$1$1;
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers$1$1$1(ReactIs.isElement, throwOnDirectAccess);
  } else {
    module.exports = factoryWithThrowingShims$1$1$1();
  }
});
var moment$1$1$1 = createCommonjsModule$1$1$1(function (module, exports) {
  (function (global, factory) {
    module.exports = factory();
  })(commonjsGlobal$1$1$1, function () {
    var hookCallback;
    function hooks() {
      return hookCallback.apply(null, arguments);
    }
    function setHookCallback(callback) {
      hookCallback = callback;
    }
    function isArray(input) {
      return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
      return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
      if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
      } else {
        var k;
        for (k in obj) {
          if (hasOwnProp(obj, k)) {
            return false;
          }
        }
        return true;
      }
    }
    function isUndefined(input) {
      return input === void 0;
    }
    function isNumber(input) {
      return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
      return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
      var res = [],
        i,
        arrLen = arr.length;
      for (i = 0; i < arrLen; ++i) {
        res.push(fn(arr[i], i));
      }
      return res;
    }
    function extend(a, b) {
      for (var i in b) {
        if (hasOwnProp(b, i)) {
          a[i] = b[i];
        }
      }
      if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
      }
      if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
      }
      return a;
    }
    function createUTC(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
      return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false
      };
    }
    function getParsingFlags(m) {
      if (m._pf == null) {
        m._pf = defaultParsingFlags();
      }
      return m._pf;
    }
    var some;
    if (Array.prototype.some) {
      some = Array.prototype.some;
    } else {
      some = function some(fun) {
        var t = Object(this),
          len = t.length >>> 0,
          i;
        for (i = 0; i < len; i++) {
          if (i in t && fun.call(this, t[i], i, t)) {
            return true;
          }
        }
        return false;
      };
    }
    function isValid(m) {
      if (m._isValid == null) {
        var flags = getParsingFlags(m),
          parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
          }),
          isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
        if (m._strict) {
          isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
          m._isValid = isNowValid;
        } else {
          return isNowValid;
        }
      }
      return m._isValid;
    }
    function createInvalid(flags) {
      var m = createUTC(NaN);
      if (flags != null) {
        extend(getParsingFlags(m), flags);
      } else {
        getParsingFlags(m).userInvalidated = true;
      }
      return m;
    }
    var momentProperties = hooks.momentProperties = [],
      updateInProgress = false;
    function copyConfig(to, from) {
      var i,
        prop,
        val,
        momentPropertiesLen = momentProperties.length;
      if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
      }
      if (!isUndefined(from._i)) {
        to._i = from._i;
      }
      if (!isUndefined(from._f)) {
        to._f = from._f;
      }
      if (!isUndefined(from._l)) {
        to._l = from._l;
      }
      if (!isUndefined(from._strict)) {
        to._strict = from._strict;
      }
      if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
      }
      if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
      }
      if (!isUndefined(from._offset)) {
        to._offset = from._offset;
      }
      if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
      }
      if (!isUndefined(from._locale)) {
        to._locale = from._locale;
      }
      if (momentPropertiesLen > 0) {
        for (i = 0; i < momentPropertiesLen; i++) {
          prop = momentProperties[i];
          val = from[prop];
          if (!isUndefined(val)) {
            to[prop] = val;
          }
        }
      }
      return to;
    }
    function Moment(config) {
      copyConfig(this, config);
      this._d = new Date(config._d != null ? config._d.getTime() : NaN);
      if (!this.isValid()) {
        this._d = new Date(NaN);
      }
      if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
      }
    }
    function isMoment(obj) {
      return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
      if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
        console.warn('Deprecation warning: ' + msg);
      }
    }
    function deprecate(msg, fn) {
      var firstTime = true;
      return extend(function () {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
          var args = [],
            arg,
            i,
            key,
            argLen = arguments.length;
          for (i = 0; i < argLen; i++) {
            arg = '';
            if (typeof arguments[i] === 'object') {
              arg += '\n[' + i + '] ';
              for (key in arguments[0]) {
                if (hasOwnProp(arguments[0], key)) {
                  arg += key + ': ' + arguments[0][key] + ', ';
                }
              }
              arg = arg.slice(0, -2);
            } else {
              arg = arguments[i];
            }
            args.push(arg);
          }
          warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
          firstTime = false;
        }
        return fn.apply(this, arguments);
      }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
      }
      if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
      }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
      return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
      var prop, i;
      for (i in config) {
        if (hasOwnProp(config, i)) {
          prop = config[i];
          if (isFunction(prop)) {
            this[i] = prop;
          } else {
            this['_' + i] = prop;
          }
        }
      }
      this._config = config;
      this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
      var res = extend({}, parentConfig),
        prop;
      for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
          if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
            res[prop] = {};
            extend(res[prop], parentConfig[prop]);
            extend(res[prop], childConfig[prop]);
          } else if (childConfig[prop] != null) {
            res[prop] = childConfig[prop];
          } else {
            delete res[prop];
          }
        }
      }
      for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
          res[prop] = extend({}, res[prop]);
        }
      }
      return res;
    }
    function Locale(config) {
      if (config != null) {
        this.set(config);
      }
    }
    var keys;
    if (Object.keys) {
      keys = Object.keys;
    } else {
      keys = function keys(obj) {
        var i,
          res = [];
        for (i in obj) {
          if (hasOwnProp(obj, i)) {
            res.push(i);
          }
        }
        return res;
      };
    }
    var defaultCalendar = {
      sameDay: '[Today at] LT',
      nextDay: '[Tomorrow at] LT',
      nextWeek: 'dddd [at] LT',
      lastDay: '[Yesterday at] LT',
      lastWeek: '[Last] dddd [at] LT',
      sameElse: 'L'
    };
    function calendar(key, mom, now) {
      var output = this._calendar[key] || this._calendar['sameElse'];
      return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
      var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
      return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
      localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
      formatFunctions = {},
      formatTokenFunctions = {};
    function addFormatToken(token, padded, ordinal, callback) {
      var func = callback;
      if (typeof callback === 'string') {
        func = function func() {
          return this[callback]();
        };
      }
      if (token) {
        formatTokenFunctions[token] = func;
      }
      if (padded) {
        formatTokenFunctions[padded[0]] = function () {
          return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
      }
      if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
          return this.localeData().ordinal(func.apply(this, arguments), token);
        };
      }
    }
    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
      }
      return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
      var array = format.match(formattingTokens),
        i,
        length;
      for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
          array[i] = formatTokenFunctions[array[i]];
        } else {
          array[i] = removeFormattingTokens(array[i]);
        }
      }
      return function (mom) {
        var output = '',
          i;
        for (i = 0; i < length; i++) {
          output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
      };
    }
    function formatMoment(m, format) {
      if (!m.isValid()) {
        return m.localeData().invalidDate();
      }
      format = expandFormat(format, m.localeData());
      formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
      return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
      var i = 5;
      function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
      }
      localFormattingTokens.lastIndex = 0;
      while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
      }
      return format;
    }
    var defaultLongDateFormat = {
      LTS: 'h:mm:ss A',
      LT: 'h:mm A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
      var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];
      if (format || !formatUpper) {
        return format;
      }
      this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function (tok) {
        if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') {
          return tok.slice(1);
        }
        return tok;
      }).join('');
      return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
      return this._invalidDate;
    }
    var defaultOrdinal = '%d',
      defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
      return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      ss: '%d seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      w: 'a week',
      ww: '%d weeks',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
      var output = this._relativeTime[string];
      return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
      var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
      return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
      var lowerCase = unit.toLowerCase();
      aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
      return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
      var normalizedInput = {},
        normalizedProp,
        prop;
      for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
          normalizedProp = normalizeUnits(prop);
          if (normalizedProp) {
            normalizedInput[normalizedProp] = inputObject[prop];
          }
        }
      }
      return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
      priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
      var units = [],
        u;
      for (u in unitsObj) {
        if (hasOwnProp(unitsObj, u)) {
          units.push({
            unit: u,
            priority: priorities[u]
          });
        }
      }
      units.sort(function (a, b) {
        return a.priority - b.priority;
      });
      return units;
    }
    function isLeapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
      if (number < 0) {
        return Math.ceil(number) || 0;
      } else {
        return Math.floor(number);
      }
    }
    function toInt(argumentForCoercion) {
      var coercedNumber = +argumentForCoercion,
        value = 0;
      if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
      }
      return value;
    }
    function makeGetSet(unit, keepTime) {
      return function (value) {
        if (value != null) {
          set$1(this, unit, value);
          hooks.updateOffset(this, keepTime);
          return this;
        } else {
          return get(this, unit);
        }
      };
    }
    function get(mom, unit) {
      return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
      if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
          value = toInt(value);
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        } else {
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
      }
    }
    function stringGet(units) {
      units = normalizeUnits(units);
      if (isFunction(this[units])) {
        return this[units]();
      }
      return this;
    }
    function stringSet(units, value) {
      if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units),
          i,
          prioritizedLen = prioritized.length;
        for (i = 0; i < prioritizedLen; i++) {
          this[prioritized[i].unit](units[prioritized[i].unit]);
        }
      } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
          return this[units](value);
        }
      }
      return this;
    }
    var match1 = /\d/,
      match2 = /\d\d/,
      match3 = /\d{3}/,
      match4 = /\d{4}/,
      match6 = /[+-]?\d{6}/,
      match1to2 = /\d\d?/,
      match3to4 = /\d\d\d\d?/,
      match5to6 = /\d\d\d\d\d\d?/,
      match1to3 = /\d{1,3}/,
      match1to4 = /\d{1,4}/,
      match1to6 = /[+-]?\d{1,6}/,
      matchUnsigned = /\d+/,
      matchSigned = /[+-]?\d+/,
      matchOffset = /Z|[+-]\d\d:?\d\d/gi,
      matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
      matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
      matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
      regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
      regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return isStrict && strictRegex ? strictRegex : regex;
      };
    }
    function getParseRegexForToken(token, config) {
      if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
      }
      return regexes[token](config._strict, config._locale);
    }
    function unescapeFormat(s) {
      return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
      }));
    }
    function regexEscape(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    var tokens = {};
    function addParseToken(token, callback) {
      var i,
        func = callback,
        tokenLen;
      if (typeof token === 'string') {
        token = [token];
      }
      if (isNumber(callback)) {
        func = function func(input, array) {
          array[callback] = toInt(input);
        };
      }
      tokenLen = token.length;
      for (i = 0; i < tokenLen; i++) {
        tokens[token[i]] = func;
      }
    }
    function addWeekParseToken(token, callback) {
      addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
      });
    }
    function addTimeToArrayFromToken(token, input, config) {
      if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
      }
    }
    var YEAR = 0,
      MONTH = 1,
      DATE = 2,
      HOUR = 3,
      MINUTE = 4,
      SECOND = 5,
      MILLISECOND = 6,
      WEEK = 7,
      WEEKDAY = 8;
    function mod(n, x) {
      return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) {
      indexOf = Array.prototype.indexOf;
    } else {
      indexOf = function indexOf(o) {
        var i;
        for (i = 0; i < this.length; ++i) {
          if (this[i] === o) {
            return i;
          }
        }
        return -1;
      };
    }
    function daysInMonth(year, month) {
      if (isNaN(year) || isNaN(month)) {
        return NaN;
      }
      var modMonth = mod(month, 12);
      year += (month - modMonth) / 12;
      return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    addFormatToken('M', ['MM', 2], 'Mo', function () {
      return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function (format) {
      return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function (format) {
      return this.localeData().months(this, format);
    });
    addUnitAlias('month', 'M');
    addUnitPriority('month', 8);
    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
      return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
      return locale.monthsRegex(isStrict);
    });
    addParseToken(['M', 'MM'], function (input, array) {
      array[MONTH] = toInt(input) - 1;
    });
    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
      var month = config._locale.monthsParse(input, token, config._strict);
      if (month != null) {
        array[MONTH] = month;
      } else {
        getParsingFlags(config).invalidMonth = input;
      }
    });
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
      defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
      defaultMonthsShortRegex = matchWord,
      defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
      if (!m) {
        return isArray(this._months) ? this._months : this._months['standalone'];
      }
      return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
      if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
      }
      return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
      var i,
        ii,
        mom,
        llc = monthName.toLocaleLowerCase();
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
          mom = createUTC([2000, i]);
          this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
          this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeMonthsParse(monthName, format, strict) {
      var i, mom, regex;
      if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
      }
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
      }
      for (i = 0; i < 12; i++) {
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
          this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
          this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
          regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
          this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
          return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
          return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
          return i;
        }
      }
    }
    function setMonth(mom, value) {
      var dayOfMonth;
      if (!mom.isValid()) {
        return mom;
      }
      if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
          value = toInt(value);
        } else {
          value = mom.localeData().monthsParse(value);
          if (!isNumber(value)) {
            return mom;
          }
        }
      }
      dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
      mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
      return mom;
    }
    function getSetMonth(value) {
      if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
      } else {
        return get(this, 'Month');
      }
    }
    function getDaysInMonth() {
      return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsShortStrictRegex;
        } else {
          return this._monthsShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
          this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
      }
    }
    function monthsRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsStrictRegex;
        } else {
          return this._monthsRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
          this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
      }
    }
    function computeMonthsParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom;
      for (i = 0; i < 12; i++) {
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
      }
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
      }
      for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
      }
      this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._monthsShortRegex = this._monthsRegex;
      this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    addFormatToken('Y', 0, 0, function () {
      var y = this.year();
      return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, ['YY', 2], 0, function () {
      return this.year() % 100;
    });
    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
    addUnitAlias('year', 'y');
    addUnitPriority('year', 1);
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
      array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
      array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
      array[YEAR] = parseInt(input, 10);
    });
    function daysInYear(year) {
      return isLeapYear(year) ? 366 : 365;
    }
    hooks.parseTwoDigitYear = function (input) {
      return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
      return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
      var date;
      if (y < 100 && y >= 0) {
        date = new Date(y + 400, m, d, h, M, s, ms);
        if (isFinite(date.getFullYear())) {
          date.setFullYear(y);
        }
      } else {
        date = new Date(y, m, d, h, M, s, ms);
      }
      return date;
    }
    function createUTCDate(y) {
      var date, args;
      if (y < 100 && y >= 0) {
        args = Array.prototype.slice.call(arguments);
        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));
        if (isFinite(date.getUTCFullYear())) {
          date.setUTCFullYear(y);
        }
      } else {
        date = new Date(Date.UTC.apply(null, arguments));
      }
      return date;
    }
    function firstWeekOffset(year, dow, doy) {
      var fwd = 7 + dow - doy,
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
      return -fwdlw + fwd - 1;
    }
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
      var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear,
        resDayOfYear;
      if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
      } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
      } else {
        resYear = year;
        resDayOfYear = dayOfYear;
      }
      return {
        year: resYear,
        dayOfYear: resDayOfYear
      };
    }
    function weekOfYear(mom, dow, doy) {
      var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek,
        resYear;
      if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
      } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
      } else {
        resYear = mom.year();
        resWeek = week;
      }
      return {
        week: resWeek,
        year: resYear
      };
    }
    function weeksInYear(year, dow, doy) {
      var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
      return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');
    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);
    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
      week[token.substr(0, 1)] = toInt(input);
    });
    function localeWeek(mom) {
      return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
      dow: 0,
      doy: 6
    };
    function localeFirstDayOfWeek() {
      return this._week.dow;
    }
    function localeFirstDayOfYear() {
      return this._week.doy;
    }
    function getSetWeek(input) {
      var week = this.localeData().week(this);
      return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
      var week = weekOfYear(this, 1, 4).week;
      return input == null ? week : this.add((input - week) * 7, 'd');
    }
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function (format) {
      return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function (format) {
      return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function (format) {
      return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
      return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
      return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
      return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
      var weekday = config._locale.weekdaysParse(input, token, config._strict);
      if (weekday != null) {
        week.d = weekday;
      } else {
        getParsingFlags(config).invalidWeekday = input;
      }
    });
    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
      week[token] = toInt(input);
    });
    function parseWeekday(input, locale) {
      if (typeof input !== 'string') {
        return input;
      }
      if (!isNaN(input)) {
        return parseInt(input, 10);
      }
      input = locale.weekdaysParse(input);
      if (typeof input === 'number') {
        return input;
      }
      return null;
    }
    function parseIsoWeekday(input, locale) {
      if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
      }
      return isNaN(input) ? null : input;
    }
    function shiftWeekdays(ws, n) {
      return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      defaultWeekdaysRegex = matchWord,
      defaultWeekdaysShortRegex = matchWord,
      defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
      var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
      return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
      return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
      return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
      var i,
        ii,
        mom,
        llc = weekdayName.toLocaleLowerCase();
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];
        for (i = 0; i < 7; ++i) {
          mom = createUTC([2000, 1]).day(i);
          this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
          this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
          this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
      var i, mom, regex;
      if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
      }
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
      }
      for (i = 0; i < 7; i++) {
        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
          this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
          this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
          this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
          regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
          this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
          return i;
        }
      }
    }
    function getSetDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
      if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
      } else {
        return day;
      }
    }
    function getSetLocaleDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
      } else {
        return this.day() || 7;
      }
    }
    function weekdaysRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysStrictRegex;
        } else {
          return this._weekdaysRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
      }
    }
    function weekdaysShortRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysShortStrictRegex;
        } else {
          return this._weekdaysShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
          this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
      }
    }
    function weekdaysMinRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysMinStrictRegex;
        } else {
          return this._weekdaysMinRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
          this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
      }
    }
    function computeWeekdaysParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var minPieces = [],
        shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        minp,
        shortp,
        longp;
      for (i = 0; i < 7; i++) {
        mom = createUTC([2000, 1]).day(i);
        minp = regexEscape(this.weekdaysMin(mom, ''));
        shortp = regexEscape(this.weekdaysShort(mom, ''));
        longp = regexEscape(this.weekdays(mom, ''));
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
      }
      minPieces.sort(cmpLenRev);
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._weekdaysShortRegex = this._weekdaysRegex;
      this._weekdaysMinRegex = this._weekdaysRegex;
      this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
      this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    function hFormat() {
      return this.hours() % 12 || 12;
    }
    function kFormat() {
      return this.hours() || 24;
    }
    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);
    addFormatToken('hmm', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
      addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
      });
    }
    meridiem('a', true);
    meridiem('A', false);
    addUnitAlias('hour', 'h');
    addUnitPriority('hour', 13);
    function matchMeridiem(isStrict, locale) {
      return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
      var kInput = toInt(input);
      array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
      config._isPm = config._locale.isPM(input);
      config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
      array[HOUR] = toInt(input);
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
    });
    function localeIsPM(input) {
      return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
      getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? 'pm' : 'PM';
      } else {
        return isLower ? 'am' : 'AM';
      }
    }
    var baseConfig = {
      calendar: defaultCalendar,
      longDateFormat: defaultLongDateFormat,
      invalidDate: defaultInvalidDate,
      ordinal: defaultOrdinal,
      dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
      relativeTime: defaultRelativeTime,
      months: defaultLocaleMonths,
      monthsShort: defaultLocaleMonthsShort,
      week: defaultLocaleWeek,
      weekdays: defaultLocaleWeekdays,
      weekdaysMin: defaultLocaleWeekdaysMin,
      weekdaysShort: defaultLocaleWeekdaysShort,
      meridiemParse: defaultLocaleMeridiemParse
    };
    var locales = {},
      localeFamilies = {},
      globalLocale;
    function commonPrefix(arr1, arr2) {
      var i,
        minl = Math.min(arr1.length, arr2.length);
      for (i = 0; i < minl; i += 1) {
        if (arr1[i] !== arr2[i]) {
          return i;
        }
      }
      return minl;
    }
    function normalizeLocale(key) {
      return key ? key.toLowerCase().replace('_', '-') : key;
    }
    function chooseLocale(names) {
      var i = 0,
        j,
        next,
        locale,
        split;
      while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
          locale = loadLocale(split.slice(0, j).join('-'));
          if (locale) {
            return locale;
          }
          if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
            break;
          }
          j--;
        }
        i++;
      }
      return globalLocale;
    }
    function isLocaleNameSane(name) {
      return name.match('^[^/\\\\]*$') != null;
    }
    function loadLocale(name) {
      var oldLocale = null,
        aliasedRequire;
      if (locales[name] === undefined && 'object' !== 'undefined' && module && module.exports && isLocaleNameSane(name)) {
        try {
          oldLocale = globalLocale._abbr;
          aliasedRequire = commonjsRequire$1$1$1;
          aliasedRequire('./locale/' + name);
          getSetGlobalLocale(oldLocale);
        } catch (e) {
          locales[name] = null;
        }
      }
      return locales[name];
    }
    function getSetGlobalLocale(key, values) {
      var data;
      if (key) {
        if (isUndefined(values)) {
          data = getLocale(key);
        } else {
          data = defineLocale(key, values);
        }
        if (data) {
          globalLocale = data;
        } else {
          if (typeof console !== 'undefined' && console.warn) {
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
          }
        }
      }
      return globalLocale._abbr;
    }
    function defineLocale(name, config) {
      if (config !== null) {
        var locale,
          parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
          deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
          parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
          if (locales[config.parentLocale] != null) {
            parentConfig = locales[config.parentLocale]._config;
          } else {
            locale = loadLocale(config.parentLocale);
            if (locale != null) {
              parentConfig = locale._config;
            } else {
              if (!localeFamilies[config.parentLocale]) {
                localeFamilies[config.parentLocale] = [];
              }
              localeFamilies[config.parentLocale].push({
                name: name,
                config: config
              });
              return null;
            }
          }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));
        if (localeFamilies[name]) {
          localeFamilies[name].forEach(function (x) {
            defineLocale(x.name, x.config);
          });
        }
        getSetGlobalLocale(name);
        return locales[name];
      } else {
        delete locales[name];
        return null;
      }
    }
    function updateLocale(name, config) {
      if (config != null) {
        var locale,
          tmpLocale,
          parentConfig = baseConfig;
        if (locales[name] != null && locales[name].parentLocale != null) {
          locales[name].set(mergeConfigs(locales[name]._config, config));
        } else {
          tmpLocale = loadLocale(name);
          if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
          }
          config = mergeConfigs(parentConfig, config);
          if (tmpLocale == null) {
            config.abbr = name;
          }
          locale = new Locale(config);
          locale.parentLocale = locales[name];
          locales[name] = locale;
        }
        getSetGlobalLocale(name);
      } else {
        if (locales[name] != null) {
          if (locales[name].parentLocale != null) {
            locales[name] = locales[name].parentLocale;
            if (name === getSetGlobalLocale()) {
              getSetGlobalLocale(name);
            }
          } else if (locales[name] != null) {
            delete locales[name];
          }
        }
      }
      return locales[name];
    }
    function getLocale(key) {
      var locale;
      if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
      }
      if (!key) {
        return globalLocale;
      }
      if (!isArray(key)) {
        locale = loadLocale(key);
        if (locale) {
          return locale;
        }
        key = [key];
      }
      return chooseLocale(key);
    }
    function listLocales() {
      return keys(locales);
    }
    function checkOverflow(m) {
      var overflow,
        a = m._a;
      if (a && getParsingFlags(m).overflow === -2) {
        overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
          overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
          overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
          overflow = WEEKDAY;
        }
        getParsingFlags(m).overflow = overflow;
      }
      return m;
    }
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
      isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/], ['YYYYMM', /\d{6}/, false], ['YYYY', /\d{4}/, false]],
      isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]],
      aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
      rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
      obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
      };
    function configFromISO(config) {
      var i,
        l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime,
        dateFormat,
        timeFormat,
        tzFormat,
        isoDatesLen = isoDates.length,
        isoTimesLen = isoTimes.length;
      if (match) {
        getParsingFlags(config).iso = true;
        for (i = 0, l = isoDatesLen; i < l; i++) {
          if (isoDates[i][1].exec(match[1])) {
            dateFormat = isoDates[i][0];
            allowTime = isoDates[i][2] !== false;
            break;
          }
        }
        if (dateFormat == null) {
          config._isValid = false;
          return;
        }
        if (match[3]) {
          for (i = 0, l = isoTimesLen; i < l; i++) {
            if (isoTimes[i][1].exec(match[3])) {
              timeFormat = (match[2] || ' ') + isoTimes[i][0];
              break;
            }
          }
          if (timeFormat == null) {
            config._isValid = false;
            return;
          }
        }
        if (!allowTime && timeFormat != null) {
          config._isValid = false;
          return;
        }
        if (match[4]) {
          if (tzRegex.exec(match[4])) {
            tzFormat = 'Z';
          } else {
            config._isValid = false;
            return;
          }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
      } else {
        config._isValid = false;
      }
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
      var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];
      if (secondStr) {
        result.push(parseInt(secondStr, 10));
      }
      return result;
    }
    function untruncateYear(yearStr) {
      var year = parseInt(yearStr, 10);
      if (year <= 49) {
        return 2000 + year;
      } else if (year <= 999) {
        return 1900 + year;
      }
      return year;
    }
    function preprocessRFC2822(s) {
      return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
      if (weekdayStr) {
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
          weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
          getParsingFlags(config).weekdayMismatch = true;
          config._isValid = false;
          return false;
        }
      }
      return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
      if (obsOffset) {
        return obsOffsets[obsOffset];
      } else if (militaryOffset) {
        return 0;
      } else {
        var hm = parseInt(numOffset, 10),
          m = hm % 100,
          h = (hm - m) / 100;
        return h * 60 + m;
      }
    }
    function configFromRFC2822(config) {
      var match = rfc2822.exec(preprocessRFC2822(config._i)),
        parsedArray;
      if (match) {
        parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
          return;
        }
        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);
        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        getParsingFlags(config).rfc2822 = true;
      } else {
        config._isValid = false;
      }
    }
    function configFromString(config) {
      var matched = aspNetJsonRegex.exec(config._i);
      if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
      }
      configFromISO(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      configFromRFC2822(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      if (config._strict) {
        config._isValid = false;
      } else {
        hooks.createFromInputFallback(config);
      }
    }
    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
      config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    function defaults(a, b, c) {
      if (a != null) {
        return a;
      }
      if (b != null) {
        return b;
      }
      return c;
    }
    function currentDateArray(config) {
      var nowValue = new Date(hooks.now());
      if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
      }
      return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }
    function configFromArray(config) {
      var i,
        date,
        input = [],
        currentDate,
        expectedWeekday,
        yearToUse;
      if (config._d) {
        return;
      }
      currentDate = currentDateArray(config);
      if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
      }
      if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
          getParsingFlags(config)._overflowDayOfYear = true;
        }
        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
      }
      for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
      }
      for (; i < 7; i++) {
        config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
      }
      if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
      }
      config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
      expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
      if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
      }
      if (config._nextDay) {
        config._a[HOUR] = 24;
      }
      if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
      }
    }
    function dayOfYearFromWeekInfo(config) {
      var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
      w = config._w;
      if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
          weekdayOverflow = true;
        }
      } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;
        curWeek = weekOfYear(createLocal(), dow, doy);
        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
        week = defaults(w.w, curWeek.week);
        if (w.d != null) {
          weekday = w.d;
          if (weekday < 0 || weekday > 6) {
            weekdayOverflow = true;
          }
        } else if (w.e != null) {
          weekday = w.e + dow;
          if (w.e < 0 || w.e > 6) {
            weekdayOverflow = true;
          }
        } else {
          weekday = dow;
        }
      }
      if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
      } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
      } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
      }
    }
    hooks.ISO_8601 = function () {};
    hooks.RFC_2822 = function () {};
    function configFromStringAndFormat(config) {
      if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
      }
      if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
      }
      config._a = [];
      getParsingFlags(config).empty = true;
      var string = '' + config._i,
        i,
        parsedInput,
        tokens,
        token,
        skipped,
        stringLength = string.length,
        totalParsedInputLength = 0,
        era,
        tokenLen;
      tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
      tokenLen = tokens.length;
      for (i = 0; i < tokenLen; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        if (parsedInput) {
          skipped = string.substr(0, string.indexOf(parsedInput));
          if (skipped.length > 0) {
            getParsingFlags(config).unusedInput.push(skipped);
          }
          string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
          totalParsedInputLength += parsedInput.length;
        }
        if (formatTokenFunctions[token]) {
          if (parsedInput) {
            getParsingFlags(config).empty = false;
          } else {
            getParsingFlags(config).unusedTokens.push(token);
          }
          addTimeToArrayFromToken(token, parsedInput, config);
        } else if (config._strict && !parsedInput) {
          getParsingFlags(config).unusedTokens.push(token);
        }
      }
      getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
      if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
      }
      if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
      }
      getParsingFlags(config).parsedDateParts = config._a.slice(0);
      getParsingFlags(config).meridiem = config._meridiem;
      config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
      era = getParsingFlags(config).era;
      if (era !== null) {
        config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
      }
      configFromArray(config);
      checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
      var isPm;
      if (meridiem == null) {
        return hour;
      }
      if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
      } else if (locale.isPM != null) {
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
          hour += 12;
        }
        if (!isPm && hour === 12) {
          hour = 0;
        }
        return hour;
      } else {
        return hour;
      }
    }
    function configFromStringAndArray(config) {
      var tempConfig,
        bestMoment,
        scoreToBeat,
        i,
        currentScore,
        validFormatFound,
        bestFormatIsValid = false,
        configfLen = config._f.length;
      if (configfLen === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
      }
      for (i = 0; i < configfLen; i++) {
        currentScore = 0;
        validFormatFound = false;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
          tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);
        if (isValid(tempConfig)) {
          validFormatFound = true;
        }
        currentScore += getParsingFlags(tempConfig).charsLeftOver;
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
        getParsingFlags(tempConfig).score = currentScore;
        if (!bestFormatIsValid) {
          if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
            if (validFormatFound) {
              bestFormatIsValid = true;
            }
          }
        } else {
          if (currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
          }
        }
      }
      extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
      if (config._d) {
        return;
      }
      var i = normalizeObjectUnits(config._i),
        dayOrDate = i.day === undefined ? i.date : i.day;
      config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
      });
      configFromArray(config);
    }
    function createFromConfig(config) {
      var res = new Moment(checkOverflow(prepareConfig(config)));
      if (res._nextDay) {
        res.add(1, 'd');
        res._nextDay = undefined;
      }
      return res;
    }
    function prepareConfig(config) {
      var input = config._i,
        format = config._f;
      config._locale = config._locale || getLocale(config._l);
      if (input === null || format === undefined && input === '') {
        return createInvalid({
          nullInput: true
        });
      }
      if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
      }
      if (isMoment(input)) {
        return new Moment(checkOverflow(input));
      } else if (isDate(input)) {
        config._d = input;
      } else if (isArray(format)) {
        configFromStringAndArray(config);
      } else if (format) {
        configFromStringAndFormat(config);
      } else {
        configFromInput(config);
      }
      if (!isValid(config)) {
        config._d = null;
      }
      return config;
    }
    function configFromInput(config) {
      var input = config._i;
      if (isUndefined(input)) {
        config._d = new Date(hooks.now());
      } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
      } else if (typeof input === 'string') {
        configFromString(config);
      } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
          return parseInt(obj, 10);
        });
        configFromArray(config);
      } else if (isObject(input)) {
        configFromObject(config);
      } else if (isNumber(input)) {
        config._d = new Date(input);
      } else {
        hooks.createFromInputFallback(config);
      }
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
      var c = {};
      if (format === true || format === false) {
        strict = format;
        format = undefined;
      }
      if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
      }
      if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
        input = undefined;
      }
      c._isAMomentObject = true;
      c._useUTC = c._isUTC = isUTC;
      c._l = locale;
      c._i = input;
      c._f = format;
      c._strict = strict;
      return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other < this ? this : other;
        } else {
          return createInvalid();
        }
      }),
      prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other > this ? this : other;
        } else {
          return createInvalid();
        }
      });
    function pickBy(fn, moments) {
      var res, i;
      if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
      }
      if (!moments.length) {
        return createLocal();
      }
      res = moments[0];
      for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
          res = moments[i];
        }
      }
      return res;
    }
    function min() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isBefore', args);
    }
    function max() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isAfter', args);
    }
    var now = function now() {
      return Date.now ? Date.now() : +new Date();
    };
    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
    function isDurationValid(m) {
      var key,
        unitHasDecimal = false,
        i,
        orderLen = ordering.length;
      for (key in m) {
        if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
          return false;
        }
      }
      for (i = 0; i < orderLen; ++i) {
        if (m[ordering[i]]) {
          if (unitHasDecimal) {
            return false;
          }
          if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
            unitHasDecimal = true;
          }
        }
      }
      return true;
    }
    function isValid$1() {
      return this._isValid;
    }
    function createInvalid$1() {
      return createDuration(NaN);
    }
    function Duration(duration) {
      var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;
      this._isValid = isDurationValid(normalizedInput);
      this._milliseconds = +milliseconds + seconds * 1e3 + minutes * 6e4 + hours * 1000 * 60 * 60;
      this._days = +days + weeks * 7;
      this._months = +months + quarters * 3 + years * 12;
      this._data = {};
      this._locale = getLocale();
      this._bubble();
    }
    function isDuration(obj) {
      return obj instanceof Duration;
    }
    function absRound(number) {
      if (number < 0) {
        return Math.round(-1 * number) * -1;
      } else {
        return Math.round(number);
      }
    }
    function compareArrays(array1, array2, dontConvert) {
      var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
      for (i = 0; i < len; i++) {
        if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
          diffs++;
        }
      }
      return diffs + lengthDiff;
    }
    function offset(token, separator) {
      addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset(),
          sign = '+';
        if (offset < 0) {
          offset = -offset;
          sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
      });
    }
    offset('Z', ':');
    offset('ZZ', '');
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
      config._useUTC = true;
      config._tzm = offsetFromString(matchShortOffset, input);
    });
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
      var matches = (string || '').match(matcher),
        chunk,
        parts,
        minutes;
      if (matches === null) {
        return null;
      }
      chunk = matches[matches.length - 1] || [];
      parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
      minutes = +(parts[1] * 60) + toInt(parts[2]);
      return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    function cloneWithOffset(input, model) {
      var res, diff;
      if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
      } else {
        return createLocal(input).local();
      }
    }
    function getDateOffset(m) {
      return -Math.round(m._d.getTimezoneOffset());
    }
    hooks.updateOffset = function () {};
    function getSetOffset(input, keepLocalTime, keepMinutes) {
      var offset = this._offset || 0,
        localAdjust;
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        if (typeof input === 'string') {
          input = offsetFromString(matchShortOffset, input);
          if (input === null) {
            return this;
          }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
          input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
          localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
          this.add(localAdjust, 'm');
        }
        if (offset !== input) {
          if (!keepLocalTime || this._changeInProgress) {
            addSubtract(this, createDuration(input - offset, 'm'), 1, false);
          } else if (!this._changeInProgress) {
            this._changeInProgress = true;
            hooks.updateOffset(this, true);
            this._changeInProgress = null;
          }
        }
        return this;
      } else {
        return this._isUTC ? offset : getDateOffset(this);
      }
    }
    function getSetZone(input, keepLocalTime) {
      if (input != null) {
        if (typeof input !== 'string') {
          input = -input;
        }
        this.utcOffset(input, keepLocalTime);
        return this;
      } else {
        return -this.utcOffset();
      }
    }
    function setOffsetToUTC(keepLocalTime) {
      return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
      if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;
        if (keepLocalTime) {
          this.subtract(getDateOffset(this), 'm');
        }
      }
      return this;
    }
    function setOffsetToParsedOffset() {
      if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
      } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
          this.utcOffset(tZone);
        } else {
          this.utcOffset(0, true);
        }
      }
      return this;
    }
    function hasAlignedHourOffset(input) {
      if (!this.isValid()) {
        return false;
      }
      input = input ? createLocal(input).utcOffset() : 0;
      return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
      return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
      if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
      }
      var c = {},
        other;
      copyConfig(c, this);
      c = prepareConfig(c);
      if (c._a) {
        other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
      } else {
        this._isDSTShifted = false;
      }
      return this._isDSTShifted;
    }
    function isLocal() {
      return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
      return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
      isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
      var duration = input,
        match = null,
        sign,
        ret,
        diffRes;
      if (isDuration(input)) {
        duration = {
          ms: input._milliseconds,
          d: input._days,
          M: input._months
        };
      } else if (isNumber(input) || !isNaN(+input)) {
        duration = {};
        if (key) {
          duration[key] = +input;
        } else {
          duration.milliseconds = +input;
        }
      } else if (match = aspNetRegex.exec(input)) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: 0,
          d: toInt(match[DATE]) * sign,
          h: toInt(match[HOUR]) * sign,
          m: toInt(match[MINUTE]) * sign,
          s: toInt(match[SECOND]) * sign,
          ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
        };
      } else if (match = isoRegex.exec(input)) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: parseIso(match[2], sign),
          M: parseIso(match[3], sign),
          w: parseIso(match[4], sign),
          d: parseIso(match[5], sign),
          h: parseIso(match[6], sign),
          m: parseIso(match[7], sign),
          s: parseIso(match[8], sign)
        };
      } else if (duration == null) {
        duration = {};
      } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
      }
      ret = new Duration(duration);
      if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
      }
      if (isDuration(input) && hasOwnProp(input, '_isValid')) {
        ret._isValid = input._isValid;
      }
      return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
      var res = inp && parseFloat(inp.replace(',', '.'));
      return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
      var res = {};
      res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
      if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
      }
      res.milliseconds = +other - +base.clone().add(res.months, 'M');
      return res;
    }
    function momentsDifference(base, other) {
      var res;
      if (!(base.isValid() && other.isValid())) {
        return {
          milliseconds: 0,
          months: 0
        };
      }
      other = cloneWithOffset(other, base);
      if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
      } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
      }
      return res;
    }
    function createAdder(direction, name) {
      return function (val, period) {
        var dur, tmp;
        if (period !== null && !isNaN(+period)) {
          deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
          tmp = val;
          val = period;
          period = tmp;
        }
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
      };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
      var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);
      if (!mom.isValid()) {
        return;
      }
      updateOffset = updateOffset == null ? true : updateOffset;
      if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
      }
      if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
      }
      if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
      }
      if (updateOffset) {
        hooks.updateOffset(mom, days || months);
      }
    }
    var add = createAdder(1, 'add'),
      subtract = createAdder(-1, 'subtract');
    function isString(input) {
      return typeof input === 'string' || input instanceof String;
    }
    function isMomentInput(input) {
      return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['years', 'year', 'y', 'months', 'month', 'M', 'days', 'day', 'd', 'dates', 'date', 'D', 'hours', 'hour', 'h', 'minutes', 'minute', 'm', 'seconds', 'second', 's', 'milliseconds', 'millisecond', 'ms'],
        i,
        property,
        propertyLen = properties.length;
      for (i = 0; i < propertyLen; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
      var arrayTest = isArray(input),
        dataTypeTest = false;
      if (arrayTest) {
        dataTypeTest = input.filter(function (item) {
          return !isNumber(item) && isString(input);
        }).length === 0;
      }
      return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'],
        i,
        property;
      for (i = 0; i < properties.length; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
      var diff = myMoment.diff(now, 'days', true);
      return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
      if (arguments.length === 1) {
        if (!arguments[0]) {
          time = undefined;
          formats = undefined;
        } else if (isMomentInput(arguments[0])) {
          time = arguments[0];
          formats = undefined;
        } else if (isCalendarSpec(arguments[0])) {
          formats = arguments[0];
          time = undefined;
        }
      }
      var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse',
        output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
      return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
      return new Moment(this);
    }
    function isAfter(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
      } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
      }
    }
    function isBefore(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
      } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
      }
    }
    function isBetween(from, to, units, inclusivity) {
      var localFrom = isMoment(from) ? from : createLocal(from),
        localTo = isMoment(to) ? to : createLocal(to);
      if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
      }
      inclusivity = inclusivity || '()';
      return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
      } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
      }
    }
    function isSameOrAfter(input, units) {
      return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
      return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
      var that, zoneDelta, output;
      if (!this.isValid()) {
        return NaN;
      }
      that = cloneWithOffset(input, this);
      if (!that.isValid()) {
        return NaN;
      }
      zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
      units = normalizeUnits(units);
      switch (units) {
        case 'year':
          output = monthDiff(this, that) / 12;
          break;
        case 'month':
          output = monthDiff(this, that);
          break;
        case 'quarter':
          output = monthDiff(this, that) / 3;
          break;
        case 'second':
          output = (this - that) / 1e3;
          break;
        case 'minute':
          output = (this - that) / 6e4;
          break;
        case 'hour':
          output = (this - that) / 36e5;
          break;
        case 'day':
          output = (this - that - zoneDelta) / 864e5;
          break;
        case 'week':
          output = (this - that - zoneDelta) / 6048e5;
          break;
        default:
          output = this - that;
      }
      return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
      if (a.date() < b.date()) {
        return -monthDiff(b, a);
      }
      var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2,
        adjust;
      if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        adjust = (b - anchor) / (anchor - anchor2);
      } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        adjust = (b - anchor) / (anchor2 - anchor);
      }
      return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
      return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
      if (!this.isValid()) {
        return null;
      }
      var utc = keepOffset !== true,
        m = utc ? this.clone().utc() : this;
      if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
      }
      if (isFunction(Date.prototype.toISOString)) {
        if (utc) {
          return this.toDate().toISOString();
        } else {
          return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
      }
      return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    function inspect() {
      if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
      }
      var func = 'moment',
        zone = '',
        prefix,
        year,
        datetime,
        suffix;
      if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
      }
      prefix = '[' + func + '("]';
      year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
      datetime = '-MM-DD[T]HH:mm:ss.SSS';
      suffix = zone + '[")]';
      return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
      if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
      }
      var output = formatMoment(this, inputString);
      return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          to: this,
          from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function fromNow(withoutSuffix) {
      return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          from: this,
          to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function toNow(withoutSuffix) {
      return this.to(createLocal(), withoutSuffix);
    }
    function locale(key) {
      var newLocaleData;
      if (key === undefined) {
        return this._locale._abbr;
      } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
          this._locale = newLocaleData;
        }
        return this;
      }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
      if (key === undefined) {
        return this.localeData();
      } else {
        return this.locale(key);
      }
    });
    function localeData() {
      return this._locale;
    }
    var MS_PER_SECOND = 1000,
      MS_PER_MINUTE = 60 * MS_PER_SECOND,
      MS_PER_HOUR = 60 * MS_PER_MINUTE,
      MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
    function mod$1(dividend, divisor) {
      return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return new Date(y, m, d).valueOf();
      }
    }
    function utcStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return Date.UTC(y, m, d);
      }
    }
    function startOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case 'year':
          time = startOfDate(this.year(), 0, 1);
          break;
        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
          break;
        case 'month':
          time = startOfDate(this.year(), this.month(), 1);
          break;
        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
          break;
        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
          break;
        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date());
          break;
        case 'hour':
          time = this._d.valueOf();
          time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
          break;
        case 'minute':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_MINUTE);
          break;
        case 'second':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_SECOND);
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function endOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case 'year':
          time = startOfDate(this.year() + 1, 0, 1) - 1;
          break;
        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
          break;
        case 'month':
          time = startOfDate(this.year(), this.month() + 1, 1) - 1;
          break;
        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
          break;
        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
          break;
        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
          break;
        case 'hour':
          time = this._d.valueOf();
          time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
          break;
        case 'minute':
          time = this._d.valueOf();
          time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
          break;
        case 'second':
          time = this._d.valueOf();
          time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function valueOf() {
      return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
      return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
      return new Date(this.valueOf());
    }
    function toArray() {
      var m = this;
      return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }
    function toObject() {
      var m = this;
      return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
      };
    }
    function toJSON() {
      return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
      return isValid(this);
    }
    function parsingFlags() {
      return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
      return getParsingFlags(this).overflow;
    }
    function creationData() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (input, array, config, token) {
      var era = config._locale.erasParse(input, token, config._strict);
      if (era) {
        getParsingFlags(config).era = era;
      } else {
        getParsingFlags(config).invalidEra = input;
      }
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
      var match;
      if (config._locale._eraYearOrdinalRegex) {
        match = input.match(config._locale._eraYearOrdinalRegex);
      }
      if (config._locale.eraYearOrdinalParse) {
        array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
      } else {
        array[YEAR] = parseInt(input, 10);
      }
    });
    function localeEras(m, format) {
      var i,
        l,
        date,
        eras = this._eras || getLocale('en')._eras;
      for (i = 0, l = eras.length; i < l; ++i) {
        switch (typeof eras[i].since) {
          case 'string':
            date = hooks(eras[i].since).startOf('day');
            eras[i].since = date.valueOf();
            break;
        }
        switch (typeof eras[i].until) {
          case 'undefined':
            eras[i].until = +Infinity;
            break;
          case 'string':
            date = hooks(eras[i].until).startOf('day').valueOf();
            eras[i].until = date.valueOf();
            break;
        }
      }
      return eras;
    }
    function localeErasParse(eraName, format, strict) {
      var i,
        l,
        eras = this.eras(),
        name,
        abbr,
        narrow;
      eraName = eraName.toUpperCase();
      for (i = 0, l = eras.length; i < l; ++i) {
        name = eras[i].name.toUpperCase();
        abbr = eras[i].abbr.toUpperCase();
        narrow = eras[i].narrow.toUpperCase();
        if (strict) {
          switch (format) {
            case 'N':
            case 'NN':
            case 'NNN':
              if (abbr === eraName) {
                return eras[i];
              }
              break;
            case 'NNNN':
              if (name === eraName) {
                return eras[i];
              }
              break;
            case 'NNNNN':
              if (narrow === eraName) {
                return eras[i];
              }
              break;
          }
        } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
          return eras[i];
        }
      }
    }
    function localeErasConvertYear(era, year) {
      var dir = era.since <= era.until ? +1 : -1;
      if (year === undefined) {
        return hooks(era.since).year();
      } else {
        return hooks(era.since).year() + (year - era.offset) * dir;
      }
    }
    function getEraName() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].name;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].name;
        }
      }
      return '';
    }
    function getEraNarrow() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].narrow;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].narrow;
        }
      }
      return '';
    }
    function getEraAbbr() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].abbr;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].abbr;
        }
      }
      return '';
    }
    function getEraYear() {
      var i,
        l,
        dir,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        dir = eras[i].since <= eras[i].until ? +1 : -1;
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
          return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
      }
      return this.year();
    }
    function erasNameRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNameRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
      if (!hasOwnProp(this, '_erasAbbrRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNarrowRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
      return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
      return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
      return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
      return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
      var abbrPieces = [],
        namePieces = [],
        narrowPieces = [],
        mixedPieces = [],
        i,
        l,
        eras = this.eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        namePieces.push(regexEscape(eras[i].name));
        abbrPieces.push(regexEscape(eras[i].abbr));
        narrowPieces.push(regexEscape(eras[i].narrow));
        mixedPieces.push(regexEscape(eras[i].name));
        mixedPieces.push(regexEscape(eras[i].abbr));
        mixedPieces.push(regexEscape(eras[i].narrow));
      }
      this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
      this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
      this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    addFormatToken(0, ['gg', 2], 0, function () {
      return this.weekYear() % 100;
    });
    addFormatToken(0, ['GG', 2], 0, function () {
      return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
      addFormatToken(0, [token, token.length], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');
    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
      week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
      week[token] = hooks.parseTwoDigitYear(input);
    });
    function getSetWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
      return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
      return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
      var weeksTarget;
      if (input == null) {
        return weekOfYear(this, dow, doy).year;
      } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
          week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
      }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
      var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
      this.year(date.getUTCFullYear());
      this.month(date.getUTCMonth());
      this.date(date.getUTCDate());
      return this;
    }
    addFormatToken('Q', 0, 'Qo', 'quarter');
    addUnitAlias('quarter', 'Q');
    addUnitPriority('quarter', 7);
    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
      array[MONTH] = (toInt(input) - 1) * 3;
    });
    function getSetQuarter(input) {
      return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    addFormatToken('D', ['DD', 2], 'Do', 'date');
    addUnitAlias('date', 'D');
    addUnitPriority('date', 9);
    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
      return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
      array[DATE] = toInt(input.match(match1to2)[0]);
    });
    var getSetDayOfMonth = makeGetSet('Date', true);
    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
    addUnitAlias('dayOfYear', 'DDD');
    addUnitPriority('dayOfYear', 4);
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
      config._dayOfYear = toInt(input);
    });
    function getSetDayOfYear(input) {
      var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
      return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    addFormatToken('m', ['mm', 2], 0, 'minute');
    addUnitAlias('minute', 'm');
    addUnitPriority('minute', 14);
    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);
    var getSetMinute = makeGetSet('Minutes', false);
    addFormatToken('s', ['ss', 2], 0, 'second');
    addUnitAlias('second', 's');
    addUnitPriority('second', 15);
    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);
    var getSetSecond = makeGetSet('Seconds', false);
    addFormatToken('S', 0, 0, function () {
      return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, ['SS', 2], 0, function () {
      return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
      return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
      return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
      return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
      return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
      return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
      return this.millisecond() * 1000000;
    });
    addUnitAlias('millisecond', 'ms');
    addUnitPriority('millisecond', 16);
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
      addRegexToken(token, matchUnsigned);
    }
    function parseMs(input, array) {
      array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for (token = 'S'; token.length <= 9; token += 'S') {
      addParseToken(token, parseMs);
    }
    getSetMillisecond = makeGetSet('Milliseconds', false);
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    function getZoneAbbr() {
      return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
      return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol["for"] != null) {
      proto[Symbol["for"]('nodejs.util.inspect.custom')] = function () {
        return 'Moment<' + this.format() + '>';
      };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
      return createLocal(input * 1000);
    }
    function createInZone() {
      return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
      return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
      var locale = getLocale(),
        utc = createUTC().set(setter, index);
      return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }
      format = format || '';
      if (index != null) {
        return get$1(format, index, field, 'month');
      }
      var i,
        out = [];
      for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
      }
      return out;
    }
    function listWeekdaysImpl(localeSorted, format, index, field) {
      if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }
        format = format || '';
      } else {
        format = localeSorted;
        index = format;
        localeSorted = false;
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }
        format = format || '';
      }
      var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0,
        i,
        out = [];
      if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
      }
      for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
      }
      return out;
    }
    function listMonths(format, index) {
      return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
      return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
      eras: [{
        since: '0001-01-01',
        until: +Infinity,
        offset: 1,
        name: 'Anno Domini',
        narrow: 'AD',
        abbr: 'AD'
      }, {
        since: '0000-12-31',
        until: -Infinity,
        offset: 1,
        name: 'Before Christ',
        narrow: 'BC',
        abbr: 'BC'
      }],
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function ordinal(number) {
        var b = number % 10,
          output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        return number + output;
      }
    });
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
      var data = this._data;
      this._milliseconds = mathAbs(this._milliseconds);
      this._days = mathAbs(this._days);
      this._months = mathAbs(this._months);
      data.milliseconds = mathAbs(data.milliseconds);
      data.seconds = mathAbs(data.seconds);
      data.minutes = mathAbs(data.minutes);
      data.hours = mathAbs(data.hours);
      data.months = mathAbs(data.months);
      data.years = mathAbs(data.years);
      return this;
    }
    function addSubtract$1(duration, input, value, direction) {
      var other = createDuration(input, value);
      duration._milliseconds += direction * other._milliseconds;
      duration._days += direction * other._days;
      duration._months += direction * other._months;
      return duration._bubble();
    }
    function add$1(input, value) {
      return addSubtract$1(this, input, value, 1);
    }
    function subtract$1(input, value) {
      return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
      if (number < 0) {
        return Math.floor(number);
      } else {
        return Math.ceil(number);
      }
    }
    function bubble() {
      var milliseconds = this._milliseconds,
        days = this._days,
        months = this._months,
        data = this._data,
        seconds,
        minutes,
        hours,
        years,
        monthsFromDays;
      if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
      }
      data.milliseconds = milliseconds % 1000;
      seconds = absFloor(milliseconds / 1000);
      data.seconds = seconds % 60;
      minutes = absFloor(seconds / 60);
      data.minutes = minutes % 60;
      hours = absFloor(minutes / 60);
      data.hours = hours % 24;
      days += absFloor(hours / 24);
      monthsFromDays = absFloor(daysToMonths(days));
      months += monthsFromDays;
      days -= absCeil(monthsToDays(monthsFromDays));
      years = absFloor(months / 12);
      months %= 12;
      data.days = days;
      data.months = months;
      data.years = years;
      return this;
    }
    function daysToMonths(days) {
      return days * 4800 / 146097;
    }
    function monthsToDays(months) {
      return months * 146097 / 4800;
    }
    function as(units) {
      if (!this.isValid()) {
        return NaN;
      }
      var days,
        months,
        milliseconds = this._milliseconds;
      units = normalizeUnits(units);
      if (units === 'month' || units === 'quarter' || units === 'year') {
        days = this._days + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        switch (units) {
          case 'month':
            return months;
          case 'quarter':
            return months / 3;
          case 'year':
            return months / 12;
        }
      } else {
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
          case 'week':
            return days / 7 + milliseconds / 6048e5;
          case 'day':
            return days + milliseconds / 864e5;
          case 'hour':
            return days * 24 + milliseconds / 36e5;
          case 'minute':
            return days * 1440 + milliseconds / 6e4;
          case 'second':
            return days * 86400 + milliseconds / 1000;
          case 'millisecond':
            return Math.floor(days * 864e5) + milliseconds;
          default:
            throw new Error('Unknown unit ' + units);
        }
      }
    }
    function valueOf$1() {
      if (!this.isValid()) {
        return NaN;
      }
      return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
      return function () {
        return this.as(alias);
      };
    }
    var asMilliseconds = makeAs('ms'),
      asSeconds = makeAs('s'),
      asMinutes = makeAs('m'),
      asHours = makeAs('h'),
      asDays = makeAs('d'),
      asWeeks = makeAs('w'),
      asMonths = makeAs('M'),
      asQuarters = makeAs('Q'),
      asYears = makeAs('y');
    function clone$1() {
      return createDuration(this);
    }
    function get$2(units) {
      units = normalizeUnits(units);
      return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
      return function () {
        return this.isValid() ? this._data[name] : NaN;
      };
    }
    var milliseconds = makeGetter('milliseconds'),
      seconds = makeGetter('seconds'),
      minutes = makeGetter('minutes'),
      hours = makeGetter('hours'),
      days = makeGetter('days'),
      months = makeGetter('months'),
      years = makeGetter('years');
    function weeks() {
      return absFloor(this.days() / 7);
    }
    var round = Math.round,
      thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
      };
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
      return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
      var duration = createDuration(posNegDuration).abs(),
        seconds = round(duration.as('s')),
        minutes = round(duration.as('m')),
        hours = round(duration.as('h')),
        days = round(duration.as('d')),
        months = round(duration.as('M')),
        weeks = round(duration.as('w')),
        years = round(duration.as('y')),
        a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days];
      if (thresholds.w != null) {
        a = a || weeks <= 1 && ['w'] || weeks < thresholds.w && ['ww', weeks];
      }
      a = a || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
      a[2] = withoutSuffix;
      a[3] = +posNegDuration > 0;
      a[4] = locale;
      return substituteTimeAgo.apply(null, a);
    }
    function getSetRelativeTimeRounding(roundingFunction) {
      if (roundingFunction === undefined) {
        return round;
      }
      if (typeof roundingFunction === 'function') {
        round = roundingFunction;
        return true;
      }
      return false;
    }
    function getSetRelativeTimeThreshold(threshold, limit) {
      if (thresholds[threshold] === undefined) {
        return false;
      }
      if (limit === undefined) {
        return thresholds[threshold];
      }
      thresholds[threshold] = limit;
      if (threshold === 's') {
        thresholds.ss = limit - 1;
      }
      return true;
    }
    function humanize(argWithSuffix, argThresholds) {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var withSuffix = false,
        th = thresholds,
        locale,
        output;
      if (typeof argWithSuffix === 'object') {
        argThresholds = argWithSuffix;
        argWithSuffix = false;
      }
      if (typeof argWithSuffix === 'boolean') {
        withSuffix = argWithSuffix;
      }
      if (typeof argThresholds === 'object') {
        th = Object.assign({}, thresholds, argThresholds);
        if (argThresholds.s != null && argThresholds.ss == null) {
          th.ss = argThresholds.s - 1;
        }
      }
      locale = this.localeData();
      output = relativeTime$1(this, !withSuffix, th, locale);
      if (withSuffix) {
        output = locale.pastFuture(+this, output);
      }
      return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
      return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var seconds = abs$1(this._milliseconds) / 1000,
        days = abs$1(this._days),
        months = abs$1(this._months),
        minutes,
        hours,
        years,
        s,
        total = this.asSeconds(),
        totalSign,
        ymSign,
        daysSign,
        hmsSign;
      if (!total) {
        return 'P0D';
      }
      minutes = absFloor(seconds / 60);
      hours = absFloor(minutes / 60);
      seconds %= 60;
      minutes %= 60;
      years = absFloor(months / 12);
      months %= 12;
      s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
      totalSign = total < 0 ? '-' : '';
      ymSign = sign(this._months) !== sign(total) ? '-' : '';
      daysSign = sign(this._days) !== sign(total) ? '-' : '';
      hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
      return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
      config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
      config._d = new Date(toInt(input));
    });
    hooks.version = '2.29.4';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    hooks.HTML5_FMT = {
      DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
      DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
      DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
      DATE: 'YYYY-MM-DD',
      TIME: 'HH:mm',
      TIME_SECONDS: 'HH:mm:ss',
      TIME_MS: 'HH:mm:ss.SSS',
      WEEK: 'GGGG-[W]WW',
      MONTH: 'YYYY-MM'
    };
    return hooks;
  });
});
var Chart$1$1$1 = createCommonjsModule$1$1$1(function (module, exports) {
  (function (global, factory) {
    module.exports = factory(function () {
      try {
        return moment$1$1$1;
      } catch (e) {}
    }());
  })(commonjsGlobal$1$1$1, function (moment) {
    moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
    function createCommonjsModule(fn, module) {
      return module = {
        exports: {}
      }, fn(module, module.exports), module.exports;
    }
    function getCjsExportFromNamespace(n) {
      return n && n['default'] || n;
    }
    var colorName = {
      "aliceblue": [240, 248, 255],
      "antiquewhite": [250, 235, 215],
      "aqua": [0, 255, 255],
      "aquamarine": [127, 255, 212],
      "azure": [240, 255, 255],
      "beige": [245, 245, 220],
      "bisque": [255, 228, 196],
      "black": [0, 0, 0],
      "blanchedalmond": [255, 235, 205],
      "blue": [0, 0, 255],
      "blueviolet": [138, 43, 226],
      "brown": [165, 42, 42],
      "burlywood": [222, 184, 135],
      "cadetblue": [95, 158, 160],
      "chartreuse": [127, 255, 0],
      "chocolate": [210, 105, 30],
      "coral": [255, 127, 80],
      "cornflowerblue": [100, 149, 237],
      "cornsilk": [255, 248, 220],
      "crimson": [220, 20, 60],
      "cyan": [0, 255, 255],
      "darkblue": [0, 0, 139],
      "darkcyan": [0, 139, 139],
      "darkgoldenrod": [184, 134, 11],
      "darkgray": [169, 169, 169],
      "darkgreen": [0, 100, 0],
      "darkgrey": [169, 169, 169],
      "darkkhaki": [189, 183, 107],
      "darkmagenta": [139, 0, 139],
      "darkolivegreen": [85, 107, 47],
      "darkorange": [255, 140, 0],
      "darkorchid": [153, 50, 204],
      "darkred": [139, 0, 0],
      "darksalmon": [233, 150, 122],
      "darkseagreen": [143, 188, 143],
      "darkslateblue": [72, 61, 139],
      "darkslategray": [47, 79, 79],
      "darkslategrey": [47, 79, 79],
      "darkturquoise": [0, 206, 209],
      "darkviolet": [148, 0, 211],
      "deeppink": [255, 20, 147],
      "deepskyblue": [0, 191, 255],
      "dimgray": [105, 105, 105],
      "dimgrey": [105, 105, 105],
      "dodgerblue": [30, 144, 255],
      "firebrick": [178, 34, 34],
      "floralwhite": [255, 250, 240],
      "forestgreen": [34, 139, 34],
      "fuchsia": [255, 0, 255],
      "gainsboro": [220, 220, 220],
      "ghostwhite": [248, 248, 255],
      "gold": [255, 215, 0],
      "goldenrod": [218, 165, 32],
      "gray": [128, 128, 128],
      "green": [0, 128, 0],
      "greenyellow": [173, 255, 47],
      "grey": [128, 128, 128],
      "honeydew": [240, 255, 240],
      "hotpink": [255, 105, 180],
      "indianred": [205, 92, 92],
      "indigo": [75, 0, 130],
      "ivory": [255, 255, 240],
      "khaki": [240, 230, 140],
      "lavender": [230, 230, 250],
      "lavenderblush": [255, 240, 245],
      "lawngreen": [124, 252, 0],
      "lemonchiffon": [255, 250, 205],
      "lightblue": [173, 216, 230],
      "lightcoral": [240, 128, 128],
      "lightcyan": [224, 255, 255],
      "lightgoldenrodyellow": [250, 250, 210],
      "lightgray": [211, 211, 211],
      "lightgreen": [144, 238, 144],
      "lightgrey": [211, 211, 211],
      "lightpink": [255, 182, 193],
      "lightsalmon": [255, 160, 122],
      "lightseagreen": [32, 178, 170],
      "lightskyblue": [135, 206, 250],
      "lightslategray": [119, 136, 153],
      "lightslategrey": [119, 136, 153],
      "lightsteelblue": [176, 196, 222],
      "lightyellow": [255, 255, 224],
      "lime": [0, 255, 0],
      "limegreen": [50, 205, 50],
      "linen": [250, 240, 230],
      "magenta": [255, 0, 255],
      "maroon": [128, 0, 0],
      "mediumaquamarine": [102, 205, 170],
      "mediumblue": [0, 0, 205],
      "mediumorchid": [186, 85, 211],
      "mediumpurple": [147, 112, 219],
      "mediumseagreen": [60, 179, 113],
      "mediumslateblue": [123, 104, 238],
      "mediumspringgreen": [0, 250, 154],
      "mediumturquoise": [72, 209, 204],
      "mediumvioletred": [199, 21, 133],
      "midnightblue": [25, 25, 112],
      "mintcream": [245, 255, 250],
      "mistyrose": [255, 228, 225],
      "moccasin": [255, 228, 181],
      "navajowhite": [255, 222, 173],
      "navy": [0, 0, 128],
      "oldlace": [253, 245, 230],
      "olive": [128, 128, 0],
      "olivedrab": [107, 142, 35],
      "orange": [255, 165, 0],
      "orangered": [255, 69, 0],
      "orchid": [218, 112, 214],
      "palegoldenrod": [238, 232, 170],
      "palegreen": [152, 251, 152],
      "paleturquoise": [175, 238, 238],
      "palevioletred": [219, 112, 147],
      "papayawhip": [255, 239, 213],
      "peachpuff": [255, 218, 185],
      "peru": [205, 133, 63],
      "pink": [255, 192, 203],
      "plum": [221, 160, 221],
      "powderblue": [176, 224, 230],
      "purple": [128, 0, 128],
      "rebeccapurple": [102, 51, 153],
      "red": [255, 0, 0],
      "rosybrown": [188, 143, 143],
      "royalblue": [65, 105, 225],
      "saddlebrown": [139, 69, 19],
      "salmon": [250, 128, 114],
      "sandybrown": [244, 164, 96],
      "seagreen": [46, 139, 87],
      "seashell": [255, 245, 238],
      "sienna": [160, 82, 45],
      "silver": [192, 192, 192],
      "skyblue": [135, 206, 235],
      "slateblue": [106, 90, 205],
      "slategray": [112, 128, 144],
      "slategrey": [112, 128, 144],
      "snow": [255, 250, 250],
      "springgreen": [0, 255, 127],
      "steelblue": [70, 130, 180],
      "tan": [210, 180, 140],
      "teal": [0, 128, 128],
      "thistle": [216, 191, 216],
      "tomato": [255, 99, 71],
      "turquoise": [64, 224, 208],
      "violet": [238, 130, 238],
      "wheat": [245, 222, 179],
      "white": [255, 255, 255],
      "whitesmoke": [245, 245, 245],
      "yellow": [255, 255, 0],
      "yellowgreen": [154, 205, 50]
    };
    var conversions = createCommonjsModule(function (module) {
      var reverseKeywords = {};
      for (var key in colorName) {
        if (colorName.hasOwnProperty(key)) {
          reverseKeywords[colorName[key]] = key;
        }
      }
      var convert = module.exports = {
        rgb: {
          channels: 3,
          labels: 'rgb'
        },
        hsl: {
          channels: 3,
          labels: 'hsl'
        },
        hsv: {
          channels: 3,
          labels: 'hsv'
        },
        hwb: {
          channels: 3,
          labels: 'hwb'
        },
        cmyk: {
          channels: 4,
          labels: 'cmyk'
        },
        xyz: {
          channels: 3,
          labels: 'xyz'
        },
        lab: {
          channels: 3,
          labels: 'lab'
        },
        lch: {
          channels: 3,
          labels: 'lch'
        },
        hex: {
          channels: 1,
          labels: ['hex']
        },
        keyword: {
          channels: 1,
          labels: ['keyword']
        },
        ansi16: {
          channels: 1,
          labels: ['ansi16']
        },
        ansi256: {
          channels: 1,
          labels: ['ansi256']
        },
        hcg: {
          channels: 3,
          labels: ['h', 'c', 'g']
        },
        apple: {
          channels: 3,
          labels: ['r16', 'g16', 'b16']
        },
        gray: {
          channels: 1,
          labels: ['gray']
        }
      };
      for (var model in convert) {
        if (convert.hasOwnProperty(model)) {
          if (!('channels' in convert[model])) {
            throw new Error('missing channels property: ' + model);
          }
          if (!('labels' in convert[model])) {
            throw new Error('missing channel labels property: ' + model);
          }
          if (convert[model].labels.length !== convert[model].channels) {
            throw new Error('channel and label counts mismatch: ' + model);
          }
          var channels = convert[model].channels;
          var labels = convert[model].labels;
          delete convert[model].channels;
          delete convert[model].labels;
          Object.defineProperty(convert[model], 'channels', {
            value: channels
          });
          Object.defineProperty(convert[model], 'labels', {
            value: labels
          });
        }
      }
      convert.rgb.hsl = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var delta = max - min;
        var h;
        var s;
        var l;
        if (max === min) {
          h = 0;
        } else if (r === max) {
          h = (g - b) / delta;
        } else if (g === max) {
          h = 2 + (b - r) / delta;
        } else if (b === max) {
          h = 4 + (r - g) / delta;
        }
        h = Math.min(h * 60, 360);
        if (h < 0) {
          h += 360;
        }
        l = (min + max) / 2;
        if (max === min) {
          s = 0;
        } else if (l <= 0.5) {
          s = delta / (max + min);
        } else {
          s = delta / (2 - max - min);
        }
        return [h, s * 100, l * 100];
      };
      convert.rgb.hsv = function (rgb) {
        var rdif;
        var gdif;
        var bdif;
        var h;
        var s;
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var v = Math.max(r, g, b);
        var diff = v - Math.min(r, g, b);
        var diffc = function diffc(c) {
          return (v - c) / 6 / diff + 1 / 2;
        };
        if (diff === 0) {
          h = s = 0;
        } else {
          s = diff / v;
          rdif = diffc(r);
          gdif = diffc(g);
          bdif = diffc(b);
          if (r === v) {
            h = bdif - gdif;
          } else if (g === v) {
            h = 1 / 3 + rdif - bdif;
          } else if (b === v) {
            h = 2 / 3 + gdif - rdif;
          }
          if (h < 0) {
            h += 1;
          } else if (h > 1) {
            h -= 1;
          }
        }
        return [h * 360, s * 100, v * 100];
      };
      convert.rgb.hwb = function (rgb) {
        var r = rgb[0];
        var g = rgb[1];
        var b = rgb[2];
        var h = convert.rgb.hsl(rgb)[0];
        var w = 1 / 255 * Math.min(r, Math.min(g, b));
        b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
        return [h, w * 100, b * 100];
      };
      convert.rgb.cmyk = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var c;
        var m;
        var y;
        var k;
        k = Math.min(1 - r, 1 - g, 1 - b);
        c = (1 - r - k) / (1 - k) || 0;
        m = (1 - g - k) / (1 - k) || 0;
        y = (1 - b - k) / (1 - k) || 0;
        return [c * 100, m * 100, y * 100, k * 100];
      };
      function comparativeDistance(x, y) {
        return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
      }
      convert.rgb.keyword = function (rgb) {
        var reversed = reverseKeywords[rgb];
        if (reversed) {
          return reversed;
        }
        var currentClosestDistance = Infinity;
        var currentClosestKeyword;
        for (var keyword in colorName) {
          if (colorName.hasOwnProperty(keyword)) {
            var value = colorName[keyword];
            var distance = comparativeDistance(rgb, value);
            if (distance < currentClosestDistance) {
              currentClosestDistance = distance;
              currentClosestKeyword = keyword;
            }
          }
        }
        return currentClosestKeyword;
      };
      convert.keyword.rgb = function (keyword) {
        return colorName[keyword];
      };
      convert.rgb.xyz = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
        g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
        b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
        var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
        var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
        var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
        return [x * 100, y * 100, z * 100];
      };
      convert.rgb.lab = function (rgb) {
        var xyz = convert.rgb.xyz(rgb);
        var x = xyz[0];
        var y = xyz[1];
        var z = xyz[2];
        var l;
        var a;
        var b;
        x /= 95.047;
        y /= 100;
        z /= 108.883;
        x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
        l = 116 * y - 16;
        a = 500 * (x - y);
        b = 200 * (y - z);
        return [l, a, b];
      };
      convert.hsl.rgb = function (hsl) {
        var h = hsl[0] / 360;
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var t1;
        var t2;
        var t3;
        var rgb;
        var val;
        if (s === 0) {
          val = l * 255;
          return [val, val, val];
        }
        if (l < 0.5) {
          t2 = l * (1 + s);
        } else {
          t2 = l + s - l * s;
        }
        t1 = 2 * l - t2;
        rgb = [0, 0, 0];
        for (var i = 0; i < 3; i++) {
          t3 = h + 1 / 3 * -(i - 1);
          if (t3 < 0) {
            t3++;
          }
          if (t3 > 1) {
            t3--;
          }
          if (6 * t3 < 1) {
            val = t1 + (t2 - t1) * 6 * t3;
          } else if (2 * t3 < 1) {
            val = t2;
          } else if (3 * t3 < 2) {
            val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
          } else {
            val = t1;
          }
          rgb[i] = val * 255;
        }
        return rgb;
      };
      convert.hsl.hsv = function (hsl) {
        var h = hsl[0];
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var smin = s;
        var lmin = Math.max(l, 0.01);
        var sv;
        var v;
        l *= 2;
        s *= l <= 1 ? l : 2 - l;
        smin *= lmin <= 1 ? lmin : 2 - lmin;
        v = (l + s) / 2;
        sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
        return [h, sv * 100, v * 100];
      };
      convert.hsv.rgb = function (hsv) {
        var h = hsv[0] / 60;
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var hi = Math.floor(h) % 6;
        var f = h - Math.floor(h);
        var p = 255 * v * (1 - s);
        var q = 255 * v * (1 - s * f);
        var t = 255 * v * (1 - s * (1 - f));
        v *= 255;
        switch (hi) {
          case 0:
            return [v, t, p];
          case 1:
            return [q, v, p];
          case 2:
            return [p, v, t];
          case 3:
            return [p, q, v];
          case 4:
            return [t, p, v];
          case 5:
            return [v, p, q];
        }
      };
      convert.hsv.hsl = function (hsv) {
        var h = hsv[0];
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var vmin = Math.max(v, 0.01);
        var lmin;
        var sl;
        var l;
        l = (2 - s) * v;
        lmin = (2 - s) * vmin;
        sl = s * vmin;
        sl /= lmin <= 1 ? lmin : 2 - lmin;
        sl = sl || 0;
        l /= 2;
        return [h, sl * 100, l * 100];
      };
      convert.hwb.rgb = function (hwb) {
        var h = hwb[0] / 360;
        var wh = hwb[1] / 100;
        var bl = hwb[2] / 100;
        var ratio = wh + bl;
        var i;
        var v;
        var f;
        var n;
        if (ratio > 1) {
          wh /= ratio;
          bl /= ratio;
        }
        i = Math.floor(6 * h);
        v = 1 - bl;
        f = 6 * h - i;
        if ((i & 0x01) !== 0) {
          f = 1 - f;
        }
        n = wh + f * (v - wh);
        var r;
        var g;
        var b;
        switch (i) {
          default:
          case 6:
          case 0:
            r = v;
            g = n;
            b = wh;
            break;
          case 1:
            r = n;
            g = v;
            b = wh;
            break;
          case 2:
            r = wh;
            g = v;
            b = n;
            break;
          case 3:
            r = wh;
            g = n;
            b = v;
            break;
          case 4:
            r = n;
            g = wh;
            b = v;
            break;
          case 5:
            r = v;
            g = wh;
            b = n;
            break;
        }
        return [r * 255, g * 255, b * 255];
      };
      convert.cmyk.rgb = function (cmyk) {
        var c = cmyk[0] / 100;
        var m = cmyk[1] / 100;
        var y = cmyk[2] / 100;
        var k = cmyk[3] / 100;
        var r;
        var g;
        var b;
        r = 1 - Math.min(1, c * (1 - k) + k);
        g = 1 - Math.min(1, m * (1 - k) + k);
        b = 1 - Math.min(1, y * (1 - k) + k);
        return [r * 255, g * 255, b * 255];
      };
      convert.xyz.rgb = function (xyz) {
        var x = xyz[0] / 100;
        var y = xyz[1] / 100;
        var z = xyz[2] / 100;
        var r;
        var g;
        var b;
        r = x * 3.2406 + y * -1.5372 + z * -0.4986;
        g = x * -0.9689 + y * 1.8758 + z * 0.0415;
        b = x * 0.0557 + y * -0.2040 + z * 1.0570;
        r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
        g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
        b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
        r = Math.min(Math.max(0, r), 1);
        g = Math.min(Math.max(0, g), 1);
        b = Math.min(Math.max(0, b), 1);
        return [r * 255, g * 255, b * 255];
      };
      convert.xyz.lab = function (xyz) {
        var x = xyz[0];
        var y = xyz[1];
        var z = xyz[2];
        var l;
        var a;
        var b;
        x /= 95.047;
        y /= 100;
        z /= 108.883;
        x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
        l = 116 * y - 16;
        a = 500 * (x - y);
        b = 200 * (y - z);
        return [l, a, b];
      };
      convert.lab.xyz = function (lab) {
        var l = lab[0];
        var a = lab[1];
        var b = lab[2];
        var x;
        var y;
        var z;
        y = (l + 16) / 116;
        x = a / 500 + y;
        z = y - b / 200;
        var y2 = Math.pow(y, 3);
        var x2 = Math.pow(x, 3);
        var z2 = Math.pow(z, 3);
        y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
        x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
        z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
        x *= 95.047;
        y *= 100;
        z *= 108.883;
        return [x, y, z];
      };
      convert.lab.lch = function (lab) {
        var l = lab[0];
        var a = lab[1];
        var b = lab[2];
        var hr;
        var h;
        var c;
        hr = Math.atan2(b, a);
        h = hr * 360 / 2 / Math.PI;
        if (h < 0) {
          h += 360;
        }
        c = Math.sqrt(a * a + b * b);
        return [l, c, h];
      };
      convert.lch.lab = function (lch) {
        var l = lch[0];
        var c = lch[1];
        var h = lch[2];
        var a;
        var b;
        var hr;
        hr = h / 360 * 2 * Math.PI;
        a = c * Math.cos(hr);
        b = c * Math.sin(hr);
        return [l, a, b];
      };
      convert.rgb.ansi16 = function (args) {
        var r = args[0];
        var g = args[1];
        var b = args[2];
        var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2];
        value = Math.round(value / 50);
        if (value === 0) {
          return 30;
        }
        var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
        if (value === 2) {
          ansi += 60;
        }
        return ansi;
      };
      convert.hsv.ansi16 = function (args) {
        return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
      };
      convert.rgb.ansi256 = function (args) {
        var r = args[0];
        var g = args[1];
        var b = args[2];
        if (r === g && g === b) {
          if (r < 8) {
            return 16;
          }
          if (r > 248) {
            return 231;
          }
          return Math.round((r - 8) / 247 * 24) + 232;
        }
        var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
        return ansi;
      };
      convert.ansi16.rgb = function (args) {
        var color = args % 10;
        if (color === 0 || color === 7) {
          if (args > 50) {
            color += 3.5;
          }
          color = color / 10.5 * 255;
          return [color, color, color];
        }
        var mult = (~~(args > 50) + 1) * 0.5;
        var r = (color & 1) * mult * 255;
        var g = (color >> 1 & 1) * mult * 255;
        var b = (color >> 2 & 1) * mult * 255;
        return [r, g, b];
      };
      convert.ansi256.rgb = function (args) {
        if (args >= 232) {
          var c = (args - 232) * 10 + 8;
          return [c, c, c];
        }
        args -= 16;
        var rem;
        var r = Math.floor(args / 36) / 5 * 255;
        var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
        var b = rem % 6 / 5 * 255;
        return [r, g, b];
      };
      convert.rgb.hex = function (args) {
        var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
        var string = integer.toString(16).toUpperCase();
        return '000000'.substring(string.length) + string;
      };
      convert.hex.rgb = function (args) {
        var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
        if (!match) {
          return [0, 0, 0];
        }
        var colorString = match[0];
        if (match[0].length === 3) {
          colorString = colorString.split('').map(function (_char) {
            return _char + _char;
          }).join('');
        }
        var integer = parseInt(colorString, 16);
        var r = integer >> 16 & 0xFF;
        var g = integer >> 8 & 0xFF;
        var b = integer & 0xFF;
        return [r, g, b];
      };
      convert.rgb.hcg = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var max = Math.max(Math.max(r, g), b);
        var min = Math.min(Math.min(r, g), b);
        var chroma = max - min;
        var grayscale;
        var hue;
        if (chroma < 1) {
          grayscale = min / (1 - chroma);
        } else {
          grayscale = 0;
        }
        if (chroma <= 0) {
          hue = 0;
        } else if (max === r) {
          hue = (g - b) / chroma % 6;
        } else if (max === g) {
          hue = 2 + (b - r) / chroma;
        } else {
          hue = 4 + (r - g) / chroma + 4;
        }
        hue /= 6;
        hue %= 1;
        return [hue * 360, chroma * 100, grayscale * 100];
      };
      convert.hsl.hcg = function (hsl) {
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var c = 1;
        var f = 0;
        if (l < 0.5) {
          c = 2.0 * s * l;
        } else {
          c = 2.0 * s * (1.0 - l);
        }
        if (c < 1.0) {
          f = (l - 0.5 * c) / (1.0 - c);
        }
        return [hsl[0], c * 100, f * 100];
      };
      convert.hsv.hcg = function (hsv) {
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var c = s * v;
        var f = 0;
        if (c < 1.0) {
          f = (v - c) / (1 - c);
        }
        return [hsv[0], c * 100, f * 100];
      };
      convert.hcg.rgb = function (hcg) {
        var h = hcg[0] / 360;
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        if (c === 0.0) {
          return [g * 255, g * 255, g * 255];
        }
        var pure = [0, 0, 0];
        var hi = h % 1 * 6;
        var v = hi % 1;
        var w = 1 - v;
        var mg = 0;
        switch (Math.floor(hi)) {
          case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
          case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
          case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
          case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
          case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
          default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
        }
        mg = (1.0 - c) * g;
        return [(c * pure[0] + mg) * 255, (c * pure[1] + mg) * 255, (c * pure[2] + mg) * 255];
      };
      convert.hcg.hsv = function (hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var v = c + g * (1.0 - c);
        var f = 0;
        if (v > 0.0) {
          f = c / v;
        }
        return [hcg[0], f * 100, v * 100];
      };
      convert.hcg.hsl = function (hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var l = g * (1.0 - c) + 0.5 * c;
        var s = 0;
        if (l > 0.0 && l < 0.5) {
          s = c / (2 * l);
        } else if (l >= 0.5 && l < 1.0) {
          s = c / (2 * (1 - l));
        }
        return [hcg[0], s * 100, l * 100];
      };
      convert.hcg.hwb = function (hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var v = c + g * (1.0 - c);
        return [hcg[0], (v - c) * 100, (1 - v) * 100];
      };
      convert.hwb.hcg = function (hwb) {
        var w = hwb[1] / 100;
        var b = hwb[2] / 100;
        var v = 1 - b;
        var c = v - w;
        var g = 0;
        if (c < 1) {
          g = (v - c) / (1 - c);
        }
        return [hwb[0], c * 100, g * 100];
      };
      convert.apple.rgb = function (apple) {
        return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
      };
      convert.rgb.apple = function (rgb) {
        return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
      };
      convert.gray.rgb = function (args) {
        return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
      };
      convert.gray.hsl = convert.gray.hsv = function (args) {
        return [0, 0, args[0]];
      };
      convert.gray.hwb = function (gray) {
        return [0, 100, gray[0]];
      };
      convert.gray.cmyk = function (gray) {
        return [0, 0, 0, gray[0]];
      };
      convert.gray.lab = function (gray) {
        return [gray[0], 0, 0];
      };
      convert.gray.hex = function (gray) {
        var val = Math.round(gray[0] / 100 * 255) & 0xFF;
        var integer = (val << 16) + (val << 8) + val;
        var string = integer.toString(16).toUpperCase();
        return '000000'.substring(string.length) + string;
      };
      convert.rgb.gray = function (rgb) {
        var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
        return [val / 255 * 100];
      };
    });
    function buildGraph() {
      var graph = {};
      var models = Object.keys(conversions);
      for (var len = models.length, i = 0; i < len; i++) {
        graph[models[i]] = {
          distance: -1,
          parent: null
        };
      }
      return graph;
    }
    function deriveBFS(fromModel) {
      var graph = buildGraph();
      var queue = [fromModel];
      graph[fromModel].distance = 0;
      while (queue.length) {
        var current = queue.pop();
        var adjacents = Object.keys(conversions[current]);
        for (var len = adjacents.length, i = 0; i < len; i++) {
          var adjacent = adjacents[i];
          var node = graph[adjacent];
          if (node.distance === -1) {
            node.distance = graph[current].distance + 1;
            node.parent = current;
            queue.unshift(adjacent);
          }
        }
      }
      return graph;
    }
    function link(from, to) {
      return function (args) {
        return to(from(args));
      };
    }
    function wrapConversion(toModel, graph) {
      var path = [graph[toModel].parent, toModel];
      var fn = conversions[graph[toModel].parent][toModel];
      var cur = graph[toModel].parent;
      while (graph[cur].parent) {
        path.unshift(graph[cur].parent);
        fn = link(conversions[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
      }
      fn.conversion = path;
      return fn;
    }
    var route = function route(fromModel) {
      var graph = deriveBFS(fromModel);
      var conversion = {};
      var models = Object.keys(graph);
      for (var len = models.length, i = 0; i < len; i++) {
        var toModel = models[i];
        var node = graph[toModel];
        if (node.parent === null) {
          continue;
        }
        conversion[toModel] = wrapConversion(toModel, graph);
      }
      return conversion;
    };
    var convert = {};
    var models = Object.keys(conversions);
    function wrapRaw(fn) {
      var wrappedFn = function wrappedFn(args) {
        if (args === undefined || args === null) {
          return args;
        }
        if (arguments.length > 1) {
          args = Array.prototype.slice.call(arguments);
        }
        return fn(args);
      };
      if ('conversion' in fn) {
        wrappedFn.conversion = fn.conversion;
      }
      return wrappedFn;
    }
    function wrapRounded(fn) {
      var wrappedFn = function wrappedFn(args) {
        if (args === undefined || args === null) {
          return args;
        }
        if (arguments.length > 1) {
          args = Array.prototype.slice.call(arguments);
        }
        var result = fn(args);
        if (typeof result === 'object') {
          for (var len = result.length, i = 0; i < len; i++) {
            result[i] = Math.round(result[i]);
          }
        }
        return result;
      };
      if ('conversion' in fn) {
        wrappedFn.conversion = fn.conversion;
      }
      return wrappedFn;
    }
    models.forEach(function (fromModel) {
      convert[fromModel] = {};
      Object.defineProperty(convert[fromModel], 'channels', {
        value: conversions[fromModel].channels
      });
      Object.defineProperty(convert[fromModel], 'labels', {
        value: conversions[fromModel].labels
      });
      var routes = route(fromModel);
      var routeModels = Object.keys(routes);
      routeModels.forEach(function (toModel) {
        var fn = routes[toModel];
        convert[fromModel][toModel] = wrapRounded(fn);
        convert[fromModel][toModel].raw = wrapRaw(fn);
      });
    });
    var colorConvert = convert;
    var colorName$1 = {
      "aliceblue": [240, 248, 255],
      "antiquewhite": [250, 235, 215],
      "aqua": [0, 255, 255],
      "aquamarine": [127, 255, 212],
      "azure": [240, 255, 255],
      "beige": [245, 245, 220],
      "bisque": [255, 228, 196],
      "black": [0, 0, 0],
      "blanchedalmond": [255, 235, 205],
      "blue": [0, 0, 255],
      "blueviolet": [138, 43, 226],
      "brown": [165, 42, 42],
      "burlywood": [222, 184, 135],
      "cadetblue": [95, 158, 160],
      "chartreuse": [127, 255, 0],
      "chocolate": [210, 105, 30],
      "coral": [255, 127, 80],
      "cornflowerblue": [100, 149, 237],
      "cornsilk": [255, 248, 220],
      "crimson": [220, 20, 60],
      "cyan": [0, 255, 255],
      "darkblue": [0, 0, 139],
      "darkcyan": [0, 139, 139],
      "darkgoldenrod": [184, 134, 11],
      "darkgray": [169, 169, 169],
      "darkgreen": [0, 100, 0],
      "darkgrey": [169, 169, 169],
      "darkkhaki": [189, 183, 107],
      "darkmagenta": [139, 0, 139],
      "darkolivegreen": [85, 107, 47],
      "darkorange": [255, 140, 0],
      "darkorchid": [153, 50, 204],
      "darkred": [139, 0, 0],
      "darksalmon": [233, 150, 122],
      "darkseagreen": [143, 188, 143],
      "darkslateblue": [72, 61, 139],
      "darkslategray": [47, 79, 79],
      "darkslategrey": [47, 79, 79],
      "darkturquoise": [0, 206, 209],
      "darkviolet": [148, 0, 211],
      "deeppink": [255, 20, 147],
      "deepskyblue": [0, 191, 255],
      "dimgray": [105, 105, 105],
      "dimgrey": [105, 105, 105],
      "dodgerblue": [30, 144, 255],
      "firebrick": [178, 34, 34],
      "floralwhite": [255, 250, 240],
      "forestgreen": [34, 139, 34],
      "fuchsia": [255, 0, 255],
      "gainsboro": [220, 220, 220],
      "ghostwhite": [248, 248, 255],
      "gold": [255, 215, 0],
      "goldenrod": [218, 165, 32],
      "gray": [128, 128, 128],
      "green": [0, 128, 0],
      "greenyellow": [173, 255, 47],
      "grey": [128, 128, 128],
      "honeydew": [240, 255, 240],
      "hotpink": [255, 105, 180],
      "indianred": [205, 92, 92],
      "indigo": [75, 0, 130],
      "ivory": [255, 255, 240],
      "khaki": [240, 230, 140],
      "lavender": [230, 230, 250],
      "lavenderblush": [255, 240, 245],
      "lawngreen": [124, 252, 0],
      "lemonchiffon": [255, 250, 205],
      "lightblue": [173, 216, 230],
      "lightcoral": [240, 128, 128],
      "lightcyan": [224, 255, 255],
      "lightgoldenrodyellow": [250, 250, 210],
      "lightgray": [211, 211, 211],
      "lightgreen": [144, 238, 144],
      "lightgrey": [211, 211, 211],
      "lightpink": [255, 182, 193],
      "lightsalmon": [255, 160, 122],
      "lightseagreen": [32, 178, 170],
      "lightskyblue": [135, 206, 250],
      "lightslategray": [119, 136, 153],
      "lightslategrey": [119, 136, 153],
      "lightsteelblue": [176, 196, 222],
      "lightyellow": [255, 255, 224],
      "lime": [0, 255, 0],
      "limegreen": [50, 205, 50],
      "linen": [250, 240, 230],
      "magenta": [255, 0, 255],
      "maroon": [128, 0, 0],
      "mediumaquamarine": [102, 205, 170],
      "mediumblue": [0, 0, 205],
      "mediumorchid": [186, 85, 211],
      "mediumpurple": [147, 112, 219],
      "mediumseagreen": [60, 179, 113],
      "mediumslateblue": [123, 104, 238],
      "mediumspringgreen": [0, 250, 154],
      "mediumturquoise": [72, 209, 204],
      "mediumvioletred": [199, 21, 133],
      "midnightblue": [25, 25, 112],
      "mintcream": [245, 255, 250],
      "mistyrose": [255, 228, 225],
      "moccasin": [255, 228, 181],
      "navajowhite": [255, 222, 173],
      "navy": [0, 0, 128],
      "oldlace": [253, 245, 230],
      "olive": [128, 128, 0],
      "olivedrab": [107, 142, 35],
      "orange": [255, 165, 0],
      "orangered": [255, 69, 0],
      "orchid": [218, 112, 214],
      "palegoldenrod": [238, 232, 170],
      "palegreen": [152, 251, 152],
      "paleturquoise": [175, 238, 238],
      "palevioletred": [219, 112, 147],
      "papayawhip": [255, 239, 213],
      "peachpuff": [255, 218, 185],
      "peru": [205, 133, 63],
      "pink": [255, 192, 203],
      "plum": [221, 160, 221],
      "powderblue": [176, 224, 230],
      "purple": [128, 0, 128],
      "rebeccapurple": [102, 51, 153],
      "red": [255, 0, 0],
      "rosybrown": [188, 143, 143],
      "royalblue": [65, 105, 225],
      "saddlebrown": [139, 69, 19],
      "salmon": [250, 128, 114],
      "sandybrown": [244, 164, 96],
      "seagreen": [46, 139, 87],
      "seashell": [255, 245, 238],
      "sienna": [160, 82, 45],
      "silver": [192, 192, 192],
      "skyblue": [135, 206, 235],
      "slateblue": [106, 90, 205],
      "slategray": [112, 128, 144],
      "slategrey": [112, 128, 144],
      "snow": [255, 250, 250],
      "springgreen": [0, 255, 127],
      "steelblue": [70, 130, 180],
      "tan": [210, 180, 140],
      "teal": [0, 128, 128],
      "thistle": [216, 191, 216],
      "tomato": [255, 99, 71],
      "turquoise": [64, 224, 208],
      "violet": [238, 130, 238],
      "wheat": [245, 222, 179],
      "white": [255, 255, 255],
      "whitesmoke": [245, 245, 245],
      "yellow": [255, 255, 0],
      "yellowgreen": [154, 205, 50]
    };
    var colorString = {
      getRgba: getRgba,
      getHsla: getHsla,
      getRgb: getRgb,
      getHsl: getHsl,
      getHwb: getHwb,
      getAlpha: getAlpha,
      hexString: hexString,
      rgbString: rgbString,
      rgbaString: rgbaString,
      percentString: percentString,
      percentaString: percentaString,
      hslString: hslString,
      hslaString: hslaString,
      hwbString: hwbString,
      keyword: keyword
    };
    function getRgba(string) {
      if (!string) {
        return;
      }
      var abbr = /^#([a-fA-F0-9]{3,4})$/i,
        hex = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
        rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
        per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
        keyword = /(\w+)/;
      var rgb = [0, 0, 0],
        a = 1,
        match = string.match(abbr),
        hexAlpha = "";
      if (match) {
        match = match[1];
        hexAlpha = match[3];
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = parseInt(match[i] + match[i], 16);
        }
        if (hexAlpha) {
          a = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
        }
      } else if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
        }
        if (hexAlpha) {
          a = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
        }
      } else if (match = string.match(rgba)) {
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = parseInt(match[i + 1]);
        }
        a = parseFloat(match[4]);
      } else if (match = string.match(per)) {
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        }
        a = parseFloat(match[4]);
      } else if (match = string.match(keyword)) {
        if (match[1] == "transparent") {
          return [0, 0, 0, 0];
        }
        rgb = colorName$1[match[1]];
        if (!rgb) {
          return;
        }
      }
      for (var i = 0; i < rgb.length; i++) {
        rgb[i] = scale(rgb[i], 0, 255);
      }
      if (!a && a != 0) {
        a = 1;
      } else {
        a = scale(a, 0, 1);
      }
      rgb[3] = a;
      return rgb;
    }
    function getHsla(string) {
      if (!string) {
        return;
      }
      var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
      var match = string.match(hsl);
      if (match) {
        var alpha = parseFloat(match[4]);
        var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [h, s, l, a];
      }
    }
    function getHwb(string) {
      if (!string) {
        return;
      }
      var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
      var match = string.match(hwb);
      if (match) {
        var alpha = parseFloat(match[4]);
        var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [h, w, b, a];
      }
    }
    function getRgb(string) {
      var rgba = getRgba(string);
      return rgba && rgba.slice(0, 3);
    }
    function getHsl(string) {
      var hsla = getHsla(string);
      return hsla && hsla.slice(0, 3);
    }
    function getAlpha(string) {
      var vals = getRgba(string);
      if (vals) {
        return vals[3];
      } else if (vals = getHsla(string)) {
        return vals[3];
      } else if (vals = getHwb(string)) {
        return vals[3];
      }
    }
    function hexString(rgba, a) {
      var a = a !== undefined && rgba.length === 3 ? a : rgba[3];
      return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (a >= 0 && a < 1 ? hexDouble(Math.round(a * 255)) : "");
    }
    function rgbString(rgba, alpha) {
      if (alpha < 1 || rgba[3] && rgba[3] < 1) {
        return rgbaString(rgba, alpha);
      }
      return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
    }
    function rgbaString(rgba, alpha) {
      if (alpha === undefined) {
        alpha = rgba[3] !== undefined ? rgba[3] : 1;
      }
      return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
    }
    function percentString(rgba, alpha) {
      if (alpha < 1 || rgba[3] && rgba[3] < 1) {
        return percentaString(rgba, alpha);
      }
      var r = Math.round(rgba[0] / 255 * 100),
        g = Math.round(rgba[1] / 255 * 100),
        b = Math.round(rgba[2] / 255 * 100);
      return "rgb(" + r + "%, " + g + "%, " + b + "%)";
    }
    function percentaString(rgba, alpha) {
      var r = Math.round(rgba[0] / 255 * 100),
        g = Math.round(rgba[1] / 255 * 100),
        b = Math.round(rgba[2] / 255 * 100);
      return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
    }
    function hslString(hsla, alpha) {
      if (alpha < 1 || hsla[3] && hsla[3] < 1) {
        return hslaString(hsla, alpha);
      }
      return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
    }
    function hslaString(hsla, alpha) {
      if (alpha === undefined) {
        alpha = hsla[3] !== undefined ? hsla[3] : 1;
      }
      return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
    }
    function hwbString(hwb, alpha) {
      if (alpha === undefined) {
        alpha = hwb[3] !== undefined ? hwb[3] : 1;
      }
      return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
    }
    function keyword(rgb) {
      return reverseNames[rgb.slice(0, 3)];
    }
    function scale(num, min, max) {
      return Math.min(Math.max(min, num), max);
    }
    function hexDouble(num) {
      var str = num.toString(16).toUpperCase();
      return str.length < 2 ? "0" + str : str;
    }
    var reverseNames = {};
    for (var name in colorName$1) {
      reverseNames[colorName$1[name]] = name;
    }
    var Color = function Color(obj) {
      if (obj instanceof Color) {
        return obj;
      }
      if (!(this instanceof Color)) {
        return new Color(obj);
      }
      this.valid = false;
      this.values = {
        rgb: [0, 0, 0],
        hsl: [0, 0, 0],
        hsv: [0, 0, 0],
        hwb: [0, 0, 0],
        cmyk: [0, 0, 0, 0],
        alpha: 1
      };
      var vals;
      if (typeof obj === 'string') {
        vals = colorString.getRgba(obj);
        if (vals) {
          this.setValues('rgb', vals);
        } else if (vals = colorString.getHsla(obj)) {
          this.setValues('hsl', vals);
        } else if (vals = colorString.getHwb(obj)) {
          this.setValues('hwb', vals);
        }
      } else if (typeof obj === 'object') {
        vals = obj;
        if (vals.r !== undefined || vals.red !== undefined) {
          this.setValues('rgb', vals);
        } else if (vals.l !== undefined || vals.lightness !== undefined) {
          this.setValues('hsl', vals);
        } else if (vals.v !== undefined || vals.value !== undefined) {
          this.setValues('hsv', vals);
        } else if (vals.w !== undefined || vals.whiteness !== undefined) {
          this.setValues('hwb', vals);
        } else if (vals.c !== undefined || vals.cyan !== undefined) {
          this.setValues('cmyk', vals);
        }
      }
    };
    Color.prototype = {
      isValid: function isValid() {
        return this.valid;
      },
      rgb: function rgb() {
        return this.setSpace('rgb', arguments);
      },
      hsl: function hsl() {
        return this.setSpace('hsl', arguments);
      },
      hsv: function hsv() {
        return this.setSpace('hsv', arguments);
      },
      hwb: function hwb() {
        return this.setSpace('hwb', arguments);
      },
      cmyk: function cmyk() {
        return this.setSpace('cmyk', arguments);
      },
      rgbArray: function rgbArray() {
        return this.values.rgb;
      },
      hslArray: function hslArray() {
        return this.values.hsl;
      },
      hsvArray: function hsvArray() {
        return this.values.hsv;
      },
      hwbArray: function hwbArray() {
        var values = this.values;
        if (values.alpha !== 1) {
          return values.hwb.concat([values.alpha]);
        }
        return values.hwb;
      },
      cmykArray: function cmykArray() {
        return this.values.cmyk;
      },
      rgbaArray: function rgbaArray() {
        var values = this.values;
        return values.rgb.concat([values.alpha]);
      },
      hslaArray: function hslaArray() {
        var values = this.values;
        return values.hsl.concat([values.alpha]);
      },
      alpha: function alpha(val) {
        if (val === undefined) {
          return this.values.alpha;
        }
        this.setValues('alpha', val);
        return this;
      },
      red: function red(val) {
        return this.setChannel('rgb', 0, val);
      },
      green: function green(val) {
        return this.setChannel('rgb', 1, val);
      },
      blue: function blue(val) {
        return this.setChannel('rgb', 2, val);
      },
      hue: function hue(val) {
        if (val) {
          val %= 360;
          val = val < 0 ? 360 + val : val;
        }
        return this.setChannel('hsl', 0, val);
      },
      saturation: function saturation(val) {
        return this.setChannel('hsl', 1, val);
      },
      lightness: function lightness(val) {
        return this.setChannel('hsl', 2, val);
      },
      saturationv: function saturationv(val) {
        return this.setChannel('hsv', 1, val);
      },
      whiteness: function whiteness(val) {
        return this.setChannel('hwb', 1, val);
      },
      blackness: function blackness(val) {
        return this.setChannel('hwb', 2, val);
      },
      value: function value(val) {
        return this.setChannel('hsv', 2, val);
      },
      cyan: function cyan(val) {
        return this.setChannel('cmyk', 0, val);
      },
      magenta: function magenta(val) {
        return this.setChannel('cmyk', 1, val);
      },
      yellow: function yellow(val) {
        return this.setChannel('cmyk', 2, val);
      },
      black: function black(val) {
        return this.setChannel('cmyk', 3, val);
      },
      hexString: function hexString() {
        return colorString.hexString(this.values.rgb);
      },
      rgbString: function rgbString() {
        return colorString.rgbString(this.values.rgb, this.values.alpha);
      },
      rgbaString: function rgbaString() {
        return colorString.rgbaString(this.values.rgb, this.values.alpha);
      },
      percentString: function percentString() {
        return colorString.percentString(this.values.rgb, this.values.alpha);
      },
      hslString: function hslString() {
        return colorString.hslString(this.values.hsl, this.values.alpha);
      },
      hslaString: function hslaString() {
        return colorString.hslaString(this.values.hsl, this.values.alpha);
      },
      hwbString: function hwbString() {
        return colorString.hwbString(this.values.hwb, this.values.alpha);
      },
      keyword: function keyword() {
        return colorString.keyword(this.values.rgb, this.values.alpha);
      },
      rgbNumber: function rgbNumber() {
        var rgb = this.values.rgb;
        return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
      },
      luminosity: function luminosity() {
        var rgb = this.values.rgb;
        var lum = [];
        for (var i = 0; i < rgb.length; i++) {
          var chan = rgb[i] / 255;
          lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
      },
      contrast: function contrast(color2) {
        var lum1 = this.luminosity();
        var lum2 = color2.luminosity();
        if (lum1 > lum2) {
          return (lum1 + 0.05) / (lum2 + 0.05);
        }
        return (lum2 + 0.05) / (lum1 + 0.05);
      },
      level: function level(color2) {
        var contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7.1) {
          return 'AAA';
        }
        return contrastRatio >= 4.5 ? 'AA' : '';
      },
      dark: function dark() {
        var rgb = this.values.rgb;
        var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return yiq < 128;
      },
      light: function light() {
        return !this.dark();
      },
      negate: function negate() {
        var rgb = [];
        for (var i = 0; i < 3; i++) {
          rgb[i] = 255 - this.values.rgb[i];
        }
        this.setValues('rgb', rgb);
        return this;
      },
      lighten: function lighten(ratio) {
        var hsl = this.values.hsl;
        hsl[2] += hsl[2] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      darken: function darken(ratio) {
        var hsl = this.values.hsl;
        hsl[2] -= hsl[2] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      saturate: function saturate(ratio) {
        var hsl = this.values.hsl;
        hsl[1] += hsl[1] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      desaturate: function desaturate(ratio) {
        var hsl = this.values.hsl;
        hsl[1] -= hsl[1] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      whiten: function whiten(ratio) {
        var hwb = this.values.hwb;
        hwb[1] += hwb[1] * ratio;
        this.setValues('hwb', hwb);
        return this;
      },
      blacken: function blacken(ratio) {
        var hwb = this.values.hwb;
        hwb[2] += hwb[2] * ratio;
        this.setValues('hwb', hwb);
        return this;
      },
      greyscale: function greyscale() {
        var rgb = this.values.rgb;
        var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        this.setValues('rgb', [val, val, val]);
        return this;
      },
      clearer: function clearer(ratio) {
        var alpha = this.values.alpha;
        this.setValues('alpha', alpha - alpha * ratio);
        return this;
      },
      opaquer: function opaquer(ratio) {
        var alpha = this.values.alpha;
        this.setValues('alpha', alpha + alpha * ratio);
        return this;
      },
      rotate: function rotate(degrees) {
        var hsl = this.values.hsl;
        var hue = (hsl[0] + degrees) % 360;
        hsl[0] = hue < 0 ? 360 + hue : hue;
        this.setValues('hsl', hsl);
        return this;
      },
      mix: function mix(mixinColor, weight) {
        var color1 = this;
        var color2 = mixinColor;
        var p = weight === undefined ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = color1.alpha() - color2.alpha();
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
        var w2 = 1 - w1;
        return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
      },
      toJSON: function toJSON() {
        return this.rgb();
      },
      clone: function clone() {
        var result = new Color();
        var source = this.values;
        var target = result.values;
        var value, type;
        for (var prop in source) {
          if (source.hasOwnProperty(prop)) {
            value = source[prop];
            type = {}.toString.call(value);
            if (type === '[object Array]') {
              target[prop] = value.slice(0);
            } else if (type === '[object Number]') {
              target[prop] = value;
            } else {
              console.error('unexpected color value:', value);
            }
          }
        }
        return result;
      }
    };
    Color.prototype.spaces = {
      rgb: ['red', 'green', 'blue'],
      hsl: ['hue', 'saturation', 'lightness'],
      hsv: ['hue', 'saturation', 'value'],
      hwb: ['hue', 'whiteness', 'blackness'],
      cmyk: ['cyan', 'magenta', 'yellow', 'black']
    };
    Color.prototype.maxes = {
      rgb: [255, 255, 255],
      hsl: [360, 100, 100],
      hsv: [360, 100, 100],
      hwb: [360, 100, 100],
      cmyk: [100, 100, 100, 100]
    };
    Color.prototype.getValues = function (space) {
      var values = this.values;
      var vals = {};
      for (var i = 0; i < space.length; i++) {
        vals[space.charAt(i)] = values[space][i];
      }
      if (values.alpha !== 1) {
        vals.a = values.alpha;
      }
      return vals;
    };
    Color.prototype.setValues = function (space, vals) {
      var values = this.values;
      var spaces = this.spaces;
      var maxes = this.maxes;
      var alpha = 1;
      var i;
      this.valid = true;
      if (space === 'alpha') {
        alpha = vals;
      } else if (vals.length) {
        values[space] = vals.slice(0, space.length);
        alpha = vals[space.length];
      } else if (vals[space.charAt(0)] !== undefined) {
        for (i = 0; i < space.length; i++) {
          values[space][i] = vals[space.charAt(i)];
        }
        alpha = vals.a;
      } else if (vals[spaces[space][0]] !== undefined) {
        var chans = spaces[space];
        for (i = 0; i < space.length; i++) {
          values[space][i] = vals[chans[i]];
        }
        alpha = vals.alpha;
      }
      values.alpha = Math.max(0, Math.min(1, alpha === undefined ? values.alpha : alpha));
      if (space === 'alpha') {
        return false;
      }
      var capped;
      for (i = 0; i < space.length; i++) {
        capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
        values[space][i] = Math.round(capped);
      }
      for (var sname in spaces) {
        if (sname !== space) {
          values[sname] = colorConvert[space][sname](values[space]);
        }
      }
      return true;
    };
    Color.prototype.setSpace = function (space, args) {
      var vals = args[0];
      if (vals === undefined) {
        return this.getValues(space);
      }
      if (typeof vals === 'number') {
        vals = Array.prototype.slice.call(args);
      }
      this.setValues(space, vals);
      return this;
    };
    Color.prototype.setChannel = function (space, index, val) {
      var svalues = this.values[space];
      if (val === undefined) {
        return svalues[index];
      } else if (val === svalues[index]) {
        return this;
      }
      svalues[index] = val;
      this.setValues(space, svalues);
      return this;
    };
    if (typeof window !== 'undefined') {
      window.Color = Color;
    }
    var chartjsColor = Color;
    function isValidKey(key) {
      return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
    }
    var helpers = {
      noop: function noop() {},
      uid: function () {
        var id = 0;
        return function () {
          return id++;
        };
      }(),
      isNullOrUndef: function isNullOrUndef(value) {
        return value === null || typeof value === 'undefined';
      },
      isArray: function isArray(value) {
        if (Array.isArray && Array.isArray(value)) {
          return true;
        }
        var type = Object.prototype.toString.call(value);
        if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
          return true;
        }
        return false;
      },
      isObject: function isObject(value) {
        return value !== null && Object.prototype.toString.call(value) === '[object Object]';
      },
      isFinite: function (_isFinite) {
        function isFinite(_x) {
          return _isFinite.apply(this, arguments);
        }
        isFinite.toString = function () {
          return _isFinite.toString();
        };
        return isFinite;
      }(function (value) {
        return (typeof value === 'number' || value instanceof Number) && isFinite(value);
      }),
      valueOrDefault: function valueOrDefault(value, defaultValue) {
        return typeof value === 'undefined' ? defaultValue : value;
      },
      valueAtIndexOrDefault: function valueAtIndexOrDefault(value, index, defaultValue) {
        return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
      },
      callback: function callback(fn, args, thisArg) {
        if (fn && typeof fn.call === 'function') {
          return fn.apply(thisArg, args);
        }
      },
      each: function each(loopable, fn, thisArg, reverse) {
        var i, len, keys;
        if (helpers.isArray(loopable)) {
          len = loopable.length;
          if (reverse) {
            for (i = len - 1; i >= 0; i--) {
              fn.call(thisArg, loopable[i], i);
            }
          } else {
            for (i = 0; i < len; i++) {
              fn.call(thisArg, loopable[i], i);
            }
          }
        } else if (helpers.isObject(loopable)) {
          keys = Object.keys(loopable);
          len = keys.length;
          for (i = 0; i < len; i++) {
            fn.call(thisArg, loopable[keys[i]], keys[i]);
          }
        }
      },
      arrayEquals: function arrayEquals(a0, a1) {
        var i, ilen, v0, v1;
        if (!a0 || !a1 || a0.length !== a1.length) {
          return false;
        }
        for (i = 0, ilen = a0.length; i < ilen; ++i) {
          v0 = a0[i];
          v1 = a1[i];
          if (v0 instanceof Array && v1 instanceof Array) {
            if (!helpers.arrayEquals(v0, v1)) {
              return false;
            }
          } else if (v0 !== v1) {
            return false;
          }
        }
        return true;
      },
      clone: function clone(source) {
        if (helpers.isArray(source)) {
          return source.map(helpers.clone);
        }
        if (helpers.isObject(source)) {
          var target = Object.create(source);
          var keys = Object.keys(source);
          var klen = keys.length;
          var k = 0;
          for (; k < klen; ++k) {
            target[keys[k]] = helpers.clone(source[keys[k]]);
          }
          return target;
        }
        return source;
      },
      _merger: function _merger(key, target, source, options) {
        if (!isValidKey(key)) {
          return;
        }
        var tval = target[key];
        var sval = source[key];
        if (helpers.isObject(tval) && helpers.isObject(sval)) {
          helpers.merge(tval, sval, options);
        } else {
          target[key] = helpers.clone(sval);
        }
      },
      _mergerIf: function _mergerIf(key, target, source) {
        if (!isValidKey(key)) {
          return;
        }
        var tval = target[key];
        var sval = source[key];
        if (helpers.isObject(tval) && helpers.isObject(sval)) {
          helpers.mergeIf(tval, sval);
        } else if (!target.hasOwnProperty(key)) {
          target[key] = helpers.clone(sval);
        }
      },
      merge: function merge(target, source, options) {
        var sources = helpers.isArray(source) ? source : [source];
        var ilen = sources.length;
        var merge, i, keys, klen, k;
        if (!helpers.isObject(target)) {
          return target;
        }
        options = options || {};
        merge = options.merger || helpers._merger;
        for (i = 0; i < ilen; ++i) {
          source = sources[i];
          if (!helpers.isObject(source)) {
            continue;
          }
          keys = Object.keys(source);
          for (k = 0, klen = keys.length; k < klen; ++k) {
            merge(keys[k], target, source, options);
          }
        }
        return target;
      },
      mergeIf: function mergeIf(target, source) {
        return helpers.merge(target, source, {
          merger: helpers._mergerIf
        });
      },
      extend: Object.assign || function (target) {
        return helpers.merge(target, [].slice.call(arguments, 1), {
          merger: function merger(key, dst, src) {
            dst[key] = src[key];
          }
        });
      },
      inherits: function inherits(extensions) {
        var me = this;
        var ChartElement = extensions && extensions.hasOwnProperty('constructor') ? extensions.constructor : function () {
          return me.apply(this, arguments);
        };
        var Surrogate = function Surrogate() {
          this.constructor = ChartElement;
        };
        Surrogate.prototype = me.prototype;
        ChartElement.prototype = new Surrogate();
        ChartElement.extend = helpers.inherits;
        if (extensions) {
          helpers.extend(ChartElement.prototype, extensions);
        }
        ChartElement.__super__ = me.prototype;
        return ChartElement;
      },
      _deprecated: function _deprecated(scope, value, previous, current) {
        if (value !== undefined) {
          console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
        }
      }
    };
    var helpers_core = helpers;
    helpers.callCallback = helpers.callback;
    helpers.indexOf = function (array, item, fromIndex) {
      return Array.prototype.indexOf.call(array, item, fromIndex);
    };
    helpers.getValueOrDefault = helpers.valueOrDefault;
    helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
    var effects = {
      linear: function linear(t) {
        return t;
      },
      easeInQuad: function easeInQuad(t) {
        return t * t;
      },
      easeOutQuad: function easeOutQuad(t) {
        return -t * (t - 2);
      },
      easeInOutQuad: function easeInOutQuad(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t;
        }
        return -0.5 * (--t * (t - 2) - 1);
      },
      easeInCubic: function easeInCubic(t) {
        return t * t * t;
      },
      easeOutCubic: function easeOutCubic(t) {
        return (t = t - 1) * t * t + 1;
      },
      easeInOutCubic: function easeInOutCubic(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t * t;
        }
        return 0.5 * ((t -= 2) * t * t + 2);
      },
      easeInQuart: function easeInQuart(t) {
        return t * t * t * t;
      },
      easeOutQuart: function easeOutQuart(t) {
        return -((t = t - 1) * t * t * t - 1);
      },
      easeInOutQuart: function easeInOutQuart(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t * t * t;
        }
        return -0.5 * ((t -= 2) * t * t * t - 2);
      },
      easeInQuint: function easeInQuint(t) {
        return t * t * t * t * t;
      },
      easeOutQuint: function easeOutQuint(t) {
        return (t = t - 1) * t * t * t * t + 1;
      },
      easeInOutQuint: function easeInOutQuint(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t * t * t * t;
        }
        return 0.5 * ((t -= 2) * t * t * t * t + 2);
      },
      easeInSine: function easeInSine(t) {
        return -Math.cos(t * (Math.PI / 2)) + 1;
      },
      easeOutSine: function easeOutSine(t) {
        return Math.sin(t * (Math.PI / 2));
      },
      easeInOutSine: function easeInOutSine(t) {
        return -0.5 * (Math.cos(Math.PI * t) - 1);
      },
      easeInExpo: function easeInExpo(t) {
        return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
      },
      easeOutExpo: function easeOutExpo(t) {
        return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
      },
      easeInOutExpo: function easeInOutExpo(t) {
        if (t === 0) {
          return 0;
        }
        if (t === 1) {
          return 1;
        }
        if ((t /= 0.5) < 1) {
          return 0.5 * Math.pow(2, 10 * (t - 1));
        }
        return 0.5 * (-Math.pow(2, -10 * --t) + 2);
      },
      easeInCirc: function easeInCirc(t) {
        if (t >= 1) {
          return t;
        }
        return -(Math.sqrt(1 - t * t) - 1);
      },
      easeOutCirc: function easeOutCirc(t) {
        return Math.sqrt(1 - (t = t - 1) * t);
      },
      easeInOutCirc: function easeInOutCirc(t) {
        if ((t /= 0.5) < 1) {
          return -0.5 * (Math.sqrt(1 - t * t) - 1);
        }
        return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
      },
      easeInElastic: function easeInElastic(t) {
        var s = 1.70158;
        var p = 0;
        var a = 1;
        if (t === 0) {
          return 0;
        }
        if (t === 1) {
          return 1;
        }
        if (!p) {
          p = 0.3;
        }
        {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
      },
      easeOutElastic: function easeOutElastic(t) {
        var s = 1.70158;
        var p = 0;
        var a = 1;
        if (t === 0) {
          return 0;
        }
        if (t === 1) {
          return 1;
        }
        if (!p) {
          p = 0.3;
        }
        {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
      },
      easeInOutElastic: function easeInOutElastic(t) {
        var s = 1.70158;
        var p = 0;
        var a = 1;
        if (t === 0) {
          return 0;
        }
        if ((t /= 0.5) === 2) {
          return 1;
        }
        if (!p) {
          p = 0.45;
        }
        {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        if (t < 1) {
          return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
        }
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
      },
      easeInBack: function easeInBack(t) {
        var s = 1.70158;
        return t * t * ((s + 1) * t - s);
      },
      easeOutBack: function easeOutBack(t) {
        var s = 1.70158;
        return (t = t - 1) * t * ((s + 1) * t + s) + 1;
      },
      easeInOutBack: function easeInOutBack(t) {
        var s = 1.70158;
        if ((t /= 0.5) < 1) {
          return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        }
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
      },
      easeInBounce: function easeInBounce(t) {
        return 1 - effects.easeOutBounce(1 - t);
      },
      easeOutBounce: function easeOutBounce(t) {
        if (t < 1 / 2.75) {
          return 7.5625 * t * t;
        }
        if (t < 2 / 2.75) {
          return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
        }
        if (t < 2.5 / 2.75) {
          return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
        }
        return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
      },
      easeInOutBounce: function easeInOutBounce(t) {
        if (t < 0.5) {
          return effects.easeInBounce(t * 2) * 0.5;
        }
        return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
      }
    };
    var helpers_easing = {
      effects: effects
    };
    helpers_core.easingEffects = effects;
    var PI = Math.PI;
    var RAD_PER_DEG = PI / 180;
    var DOUBLE_PI = PI * 2;
    var HALF_PI = PI / 2;
    var QUARTER_PI = PI / 4;
    var TWO_THIRDS_PI = PI * 2 / 3;
    var exports$1 = {
      clear: function clear(chart) {
        chart.ctx.clearRect(0, 0, chart.width, chart.height);
      },
      roundedRect: function roundedRect(ctx, x, y, width, height, radius) {
        if (radius) {
          var r = Math.min(radius, height / 2, width / 2);
          var left = x + r;
          var top = y + r;
          var right = x + width - r;
          var bottom = y + height - r;
          ctx.moveTo(x, top);
          if (left < right && top < bottom) {
            ctx.arc(left, top, r, -PI, -HALF_PI);
            ctx.arc(right, top, r, -HALF_PI, 0);
            ctx.arc(right, bottom, r, 0, HALF_PI);
            ctx.arc(left, bottom, r, HALF_PI, PI);
          } else if (left < right) {
            ctx.moveTo(left, y);
            ctx.arc(right, top, r, -HALF_PI, HALF_PI);
            ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
          } else if (top < bottom) {
            ctx.arc(left, top, r, -PI, 0);
            ctx.arc(left, bottom, r, 0, PI);
          } else {
            ctx.arc(left, top, r, -PI, PI);
          }
          ctx.closePath();
          ctx.moveTo(x, y);
        } else {
          ctx.rect(x, y, width, height);
        }
      },
      drawPoint: function drawPoint(ctx, style, radius, x, y, rotation) {
        var type, xOffset, yOffset, size, cornerRadius;
        var rad = (rotation || 0) * RAD_PER_DEG;
        if (style && typeof style === 'object') {
          type = style.toString();
          if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
          }
        }
        if (isNaN(radius) || radius <= 0) {
          return;
        }
        ctx.beginPath();
        switch (style) {
          default:
            ctx.arc(x, y, radius, 0, DOUBLE_PI);
            ctx.closePath();
            break;
          case 'triangle':
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
          case 'rectRounded':
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + QUARTER_PI) * size;
            yOffset = Math.sin(rad + QUARTER_PI) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
            ctx.closePath();
            break;
          case 'rect':
            if (!rotation) {
              size = Math.SQRT1_2 * radius;
              ctx.rect(x - size, y - size, 2 * size, 2 * size);
              break;
            }
            rad += QUARTER_PI;
          case 'rectRot':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
          case 'crossRot':
            rad += QUARTER_PI;
          case 'cross':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
          case 'star':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += QUARTER_PI;
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
          case 'line':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
          case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
        }
        ctx.fill();
        ctx.stroke();
      },
      _isPointInArea: function _isPointInArea(point, area) {
        var epsilon = 1e-6;
        return point.x > area.left - epsilon && point.x < area.right + epsilon && point.y > area.top - epsilon && point.y < area.bottom + epsilon;
      },
      clipArea: function clipArea(ctx, area) {
        ctx.save();
        ctx.beginPath();
        ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
        ctx.clip();
      },
      unclipArea: function unclipArea(ctx) {
        ctx.restore();
      },
      lineTo: function lineTo(ctx, previous, target, flip) {
        var stepped = target.steppedLine;
        if (stepped) {
          if (stepped === 'middle') {
            var midpoint = (previous.x + target.x) / 2.0;
            ctx.lineTo(midpoint, flip ? target.y : previous.y);
            ctx.lineTo(midpoint, flip ? previous.y : target.y);
          } else if (stepped === 'after' && !flip || stepped !== 'after' && flip) {
            ctx.lineTo(previous.x, target.y);
          } else {
            ctx.lineTo(target.x, previous.y);
          }
          ctx.lineTo(target.x, target.y);
          return;
        }
        if (!target.tension) {
          ctx.lineTo(target.x, target.y);
          return;
        }
        ctx.bezierCurveTo(flip ? previous.controlPointPreviousX : previous.controlPointNextX, flip ? previous.controlPointPreviousY : previous.controlPointNextY, flip ? target.controlPointNextX : target.controlPointPreviousX, flip ? target.controlPointNextY : target.controlPointPreviousY, target.x, target.y);
      }
    };
    var helpers_canvas = exports$1;
    helpers_core.clear = exports$1.clear;
    helpers_core.drawRoundedRectangle = function (ctx) {
      ctx.beginPath();
      exports$1.roundedRect.apply(exports$1, arguments);
    };
    var defaults = {
      _set: function _set(scope, values) {
        return helpers_core.merge(this[scope] || (this[scope] = {}), values);
      }
    };
    defaults._set('global', {
      defaultColor: 'rgba(0,0,0,0.1)',
      defaultFontColor: '#666',
      defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      defaultFontSize: 12,
      defaultFontStyle: 'normal',
      defaultLineHeight: 1.2,
      showLines: true
    });
    var core_defaults = defaults;
    var valueOrDefault = helpers_core.valueOrDefault;
    function toFontString(font) {
      if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
        return null;
      }
      return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
    }
    var helpers_options = {
      toLineHeight: function toLineHeight(value, size) {
        var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
        if (!matches || matches[1] === 'normal') {
          return size * 1.2;
        }
        value = +matches[2];
        switch (matches[3]) {
          case 'px':
            return value;
          case '%':
            value /= 100;
            break;
        }
        return size * value;
      },
      toPadding: function toPadding(value) {
        var t, r, b, l;
        if (helpers_core.isObject(value)) {
          t = +value.top || 0;
          r = +value.right || 0;
          b = +value.bottom || 0;
          l = +value.left || 0;
        } else {
          t = r = b = l = +value || 0;
        }
        return {
          top: t,
          right: r,
          bottom: b,
          left: l,
          height: t + b,
          width: l + r
        };
      },
      _parseFont: function _parseFont(options) {
        var globalDefaults = core_defaults.global;
        var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
        var font = {
          family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
          lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
          size: size,
          style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
          weight: null,
          string: ''
        };
        font.string = toFontString(font);
        return font;
      },
      resolve: function resolve(inputs, context, index, info) {
        var cacheable = true;
        var i, ilen, value;
        for (i = 0, ilen = inputs.length; i < ilen; ++i) {
          value = inputs[i];
          if (value === undefined) {
            continue;
          }
          if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
          }
          if (index !== undefined && helpers_core.isArray(value)) {
            value = value[index];
            cacheable = false;
          }
          if (value !== undefined) {
            if (info && !cacheable) {
              info.cacheable = false;
            }
            return value;
          }
        }
      }
    };
    var exports$2 = {
      _factorize: function _factorize(value) {
        var result = [];
        var sqrt = Math.sqrt(value);
        var i;
        for (i = 1; i < sqrt; i++) {
          if (value % i === 0) {
            result.push(i);
            result.push(value / i);
          }
        }
        if (sqrt === (sqrt | 0)) {
          result.push(sqrt);
        }
        result.sort(function (a, b) {
          return a - b;
        }).pop();
        return result;
      },
      log10: Math.log10 || function (x) {
        var exponent = Math.log(x) * Math.LOG10E;
        var powerOf10 = Math.round(exponent);
        var isPowerOf10 = x === Math.pow(10, powerOf10);
        return isPowerOf10 ? powerOf10 : exponent;
      }
    };
    var helpers_math = exports$2;
    helpers_core.log10 = exports$2.log10;
    var getRtlAdapter = function getRtlAdapter(rectX, width) {
      return {
        x: function x(_x2) {
          return rectX + rectX + width - _x2;
        },
        setWidth: function setWidth(w) {
          width = w;
        },
        textAlign: function textAlign(align) {
          if (align === 'center') {
            return align;
          }
          return align === 'right' ? 'left' : 'right';
        },
        xPlus: function xPlus(x, value) {
          return x - value;
        },
        leftForLtr: function leftForLtr(x, itemWidth) {
          return x - itemWidth;
        }
      };
    };
    var getLtrAdapter = function getLtrAdapter() {
      return {
        x: function x(_x3) {
          return _x3;
        },
        setWidth: function setWidth(w) {},
        textAlign: function textAlign(align) {
          return align;
        },
        xPlus: function xPlus(x, value) {
          return x + value;
        },
        leftForLtr: function leftForLtr(x, _itemWidth) {
          return x;
        }
      };
    };
    var getAdapter = function getAdapter(rtl, rectX, width) {
      return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
    };
    var overrideTextDirection = function overrideTextDirection(ctx, direction) {
      var style, original;
      if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [style.getPropertyValue('direction'), style.getPropertyPriority('direction')];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
      }
    };
    var restoreTextDirection = function restoreTextDirection(ctx) {
      var original = ctx.prevTextDirection;
      if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
      }
    };
    var helpers_rtl = {
      getRtlAdapter: getAdapter,
      overrideTextDirection: overrideTextDirection,
      restoreTextDirection: restoreTextDirection
    };
    var helpers$1 = helpers_core;
    var easing = helpers_easing;
    var canvas = helpers_canvas;
    var options = helpers_options;
    var math = helpers_math;
    var rtl = helpers_rtl;
    helpers$1.easing = easing;
    helpers$1.canvas = canvas;
    helpers$1.options = options;
    helpers$1.math = math;
    helpers$1.rtl = rtl;
    function interpolate(start, view, model, ease) {
      var keys = Object.keys(model);
      var i, ilen, key, actual, origin, target, type, c0, c1;
      for (i = 0, ilen = keys.length; i < ilen; ++i) {
        key = keys[i];
        target = model[key];
        if (!view.hasOwnProperty(key)) {
          view[key] = target;
        }
        actual = view[key];
        if (actual === target || key[0] === '_') {
          continue;
        }
        if (!start.hasOwnProperty(key)) {
          start[key] = actual;
        }
        origin = start[key];
        type = typeof target;
        if (type === typeof origin) {
          if (type === 'string') {
            c0 = chartjsColor(origin);
            if (c0.valid) {
              c1 = chartjsColor(target);
              if (c1.valid) {
                view[key] = c1.mix(c0, ease).rgbString();
                continue;
              }
            }
          } else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
            view[key] = origin + (target - origin) * ease;
            continue;
          }
        }
        view[key] = target;
      }
    }
    var Element = function Element(configuration) {
      helpers$1.extend(this, configuration);
      this.initialize.apply(this, arguments);
    };
    helpers$1.extend(Element.prototype, {
      _type: undefined,
      initialize: function initialize() {
        this.hidden = false;
      },
      pivot: function pivot() {
        var me = this;
        if (!me._view) {
          me._view = helpers$1.extend({}, me._model);
        }
        me._start = {};
        return me;
      },
      transition: function transition(ease) {
        var me = this;
        var model = me._model;
        var start = me._start;
        var view = me._view;
        if (!model || ease === 1) {
          me._view = helpers$1.extend({}, model);
          me._start = null;
          return me;
        }
        if (!view) {
          view = me._view = {};
        }
        if (!start) {
          start = me._start = {};
        }
        interpolate(start, view, model, ease);
        return me;
      },
      tooltipPosition: function tooltipPosition() {
        return {
          x: this._model.x,
          y: this._model.y
        };
      },
      hasValue: function hasValue() {
        return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
      }
    });
    Element.extend = helpers$1.inherits;
    var core_element = Element;
    var exports$3 = core_element.extend({
      chart: null,
      currentStep: 0,
      numSteps: 60,
      easing: '',
      render: null,
      onAnimationProgress: null,
      onAnimationComplete: null
    });
    var core_animation = exports$3;
    Object.defineProperty(exports$3.prototype, 'animationObject', {
      get: function get() {
        return this;
      }
    });
    Object.defineProperty(exports$3.prototype, 'chartInstance', {
      get: function get() {
        return this.chart;
      },
      set: function set(value) {
        this.chart = value;
      }
    });
    core_defaults._set('global', {
      animation: {
        duration: 1000,
        easing: 'easeOutQuart',
        onProgress: helpers$1.noop,
        onComplete: helpers$1.noop
      }
    });
    var core_animations = {
      animations: [],
      request: null,
      addAnimation: function addAnimation(chart, animation, duration, lazy) {
        var animations = this.animations;
        var i, ilen;
        animation.chart = chart;
        animation.startTime = Date.now();
        animation.duration = duration;
        if (!lazy) {
          chart.animating = true;
        }
        for (i = 0, ilen = animations.length; i < ilen; ++i) {
          if (animations[i].chart === chart) {
            animations[i] = animation;
            return;
          }
        }
        animations.push(animation);
        if (animations.length === 1) {
          this.requestAnimationFrame();
        }
      },
      cancelAnimation: function cancelAnimation(chart) {
        var index = helpers$1.findIndex(this.animations, function (animation) {
          return animation.chart === chart;
        });
        if (index !== -1) {
          this.animations.splice(index, 1);
          chart.animating = false;
        }
      },
      requestAnimationFrame: function requestAnimationFrame() {
        var me = this;
        if (me.request === null) {
          me.request = helpers$1.requestAnimFrame.call(window, function () {
            me.request = null;
            me.startDigest();
          });
        }
      },
      startDigest: function startDigest() {
        var me = this;
        me.advance();
        if (me.animations.length > 0) {
          me.requestAnimationFrame();
        }
      },
      advance: function advance() {
        var animations = this.animations;
        var animation, chart, numSteps, nextStep;
        var i = 0;
        while (i < animations.length) {
          animation = animations[i];
          chart = animation.chart;
          numSteps = animation.numSteps;
          nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
          animation.currentStep = Math.min(nextStep, numSteps);
          helpers$1.callback(animation.render, [chart, animation], chart);
          helpers$1.callback(animation.onAnimationProgress, [animation], chart);
          if (animation.currentStep >= numSteps) {
            helpers$1.callback(animation.onAnimationComplete, [animation], chart);
            chart.animating = false;
            animations.splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    };
    var resolve = helpers$1.options.resolve;
    var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
    function listenArrayEvents(array, listener) {
      if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
      }
      Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
          listeners: [listener]
        }
      });
      arrayEvents.forEach(function (key) {
        var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
        var base = array[key];
        Object.defineProperty(array, key, {
          configurable: true,
          enumerable: false,
          value: function value() {
            var args = Array.prototype.slice.call(arguments);
            var res = base.apply(this, args);
            helpers$1.each(array._chartjs.listeners, function (object) {
              if (typeof object[method] === 'function') {
                object[method].apply(object, args);
              }
            });
            return res;
          }
        });
      });
    }
    function unlistenArrayEvents(array, listener) {
      var stub = array._chartjs;
      if (!stub) {
        return;
      }
      var listeners = stub.listeners;
      var index = listeners.indexOf(listener);
      if (index !== -1) {
        listeners.splice(index, 1);
      }
      if (listeners.length > 0) {
        return;
      }
      arrayEvents.forEach(function (key) {
        delete array[key];
      });
      delete array._chartjs;
    }
    var DatasetController = function DatasetController(chart, datasetIndex) {
      this.initialize(chart, datasetIndex);
    };
    helpers$1.extend(DatasetController.prototype, {
      datasetElementType: null,
      dataElementType: null,
      _datasetElementOptions: ['backgroundColor', 'borderCapStyle', 'borderColor', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'borderWidth'],
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'pointStyle'],
      initialize: function initialize(chart, datasetIndex) {
        var me = this;
        me.chart = chart;
        me.index = datasetIndex;
        me.linkScales();
        me.addElements();
        me._type = me.getMeta().type;
      },
      updateIndex: function updateIndex(datasetIndex) {
        this.index = datasetIndex;
      },
      linkScales: function linkScales() {
        var me = this;
        var meta = me.getMeta();
        var chart = me.chart;
        var scales = chart.scales;
        var dataset = me.getDataset();
        var scalesOpts = chart.options.scales;
        if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
          meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
        }
        if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
          meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
        }
      },
      getDataset: function getDataset() {
        return this.chart.data.datasets[this.index];
      },
      getMeta: function getMeta() {
        return this.chart.getDatasetMeta(this.index);
      },
      getScaleForId: function getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
      },
      _getValueScaleId: function _getValueScaleId() {
        return this.getMeta().yAxisID;
      },
      _getIndexScaleId: function _getIndexScaleId() {
        return this.getMeta().xAxisID;
      },
      _getValueScale: function _getValueScale() {
        return this.getScaleForId(this._getValueScaleId());
      },
      _getIndexScale: function _getIndexScale() {
        return this.getScaleForId(this._getIndexScaleId());
      },
      reset: function reset() {
        this._update(true);
      },
      destroy: function destroy() {
        if (this._data) {
          unlistenArrayEvents(this._data, this);
        }
      },
      createMetaDataset: function createMetaDataset() {
        var me = this;
        var type = me.datasetElementType;
        return type && new type({
          _chart: me.chart,
          _datasetIndex: me.index
        });
      },
      createMetaData: function createMetaData(index) {
        var me = this;
        var type = me.dataElementType;
        return type && new type({
          _chart: me.chart,
          _datasetIndex: me.index,
          _index: index
        });
      },
      addElements: function addElements() {
        var me = this;
        var meta = me.getMeta();
        var data = me.getDataset().data || [];
        var metaData = meta.data;
        var i, ilen;
        for (i = 0, ilen = data.length; i < ilen; ++i) {
          metaData[i] = metaData[i] || me.createMetaData(i);
        }
        meta.dataset = meta.dataset || me.createMetaDataset();
      },
      addElementAndReset: function addElementAndReset(index) {
        var element = this.createMetaData(index);
        this.getMeta().data.splice(index, 0, element);
        this.updateElement(element, index, true);
      },
      buildOrUpdateElements: function buildOrUpdateElements() {
        var me = this;
        var dataset = me.getDataset();
        var data = dataset.data || (dataset.data = []);
        if (me._data !== data) {
          if (me._data) {
            unlistenArrayEvents(me._data, me);
          }
          if (data && Object.isExtensible(data)) {
            listenArrayEvents(data, me);
          }
          me._data = data;
        }
        me.resyncElements();
      },
      _configure: function _configure() {
        var me = this;
        me._config = helpers$1.merge(Object.create(null), [me.chart.options.datasets[me._type], me.getDataset()], {
          merger: function merger(key, target, source) {
            if (key !== '_meta' && key !== 'data') {
              helpers$1._merger(key, target, source);
            }
          }
        });
      },
      _update: function _update(reset) {
        var me = this;
        me._configure();
        me._cachedDataOpts = null;
        me.update(reset);
      },
      update: helpers$1.noop,
      transition: function transition(easingValue) {
        var meta = this.getMeta();
        var elements = meta.data || [];
        var ilen = elements.length;
        var i = 0;
        for (; i < ilen; ++i) {
          elements[i].transition(easingValue);
        }
        if (meta.dataset) {
          meta.dataset.transition(easingValue);
        }
      },
      draw: function draw() {
        var meta = this.getMeta();
        var elements = meta.data || [];
        var ilen = elements.length;
        var i = 0;
        if (meta.dataset) {
          meta.dataset.draw();
        }
        for (; i < ilen; ++i) {
          elements[i].draw();
        }
      },
      getStyle: function getStyle(index) {
        var me = this;
        var meta = me.getMeta();
        var dataset = meta.dataset;
        var style;
        me._configure();
        if (dataset && index === undefined) {
          style = me._resolveDatasetElementOptions(dataset || {});
        } else {
          index = index || 0;
          style = me._resolveDataElementOptions(meta.data[index] || {}, index);
        }
        if (style.fill === false || style.fill === null) {
          style.backgroundColor = style.borderColor;
        }
        return style;
      },
      _resolveDatasetElementOptions: function _resolveDatasetElementOptions(element, hover) {
        var me = this;
        var chart = me.chart;
        var datasetOpts = me._config;
        var custom = element.custom || {};
        var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
        var elementOptions = me._datasetElementOptions;
        var values = {};
        var i, ilen, key, readKey;
        var context = {
          chart: chart,
          dataset: me.getDataset(),
          datasetIndex: me.index,
          hover: hover
        };
        for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
          key = elementOptions[i];
          readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
          values[key] = resolve([custom[readKey], datasetOpts[readKey], options[readKey]], context);
        }
        return values;
      },
      _resolveDataElementOptions: function _resolveDataElementOptions(element, index) {
        var me = this;
        var custom = element && element.custom;
        var cached = me._cachedDataOpts;
        if (cached && !custom) {
          return cached;
        }
        var chart = me.chart;
        var datasetOpts = me._config;
        var options = chart.options.elements[me.dataElementType.prototype._type] || {};
        var elementOptions = me._dataElementOptions;
        var values = {};
        var context = {
          chart: chart,
          dataIndex: index,
          dataset: me.getDataset(),
          datasetIndex: me.index
        };
        var info = {
          cacheable: !custom
        };
        var keys, i, ilen, key;
        custom = custom || {};
        if (helpers$1.isArray(elementOptions)) {
          for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
            key = elementOptions[i];
            values[key] = resolve([custom[key], datasetOpts[key], options[key]], context, index, info);
          }
        } else {
          keys = Object.keys(elementOptions);
          for (i = 0, ilen = keys.length; i < ilen; ++i) {
            key = keys[i];
            values[key] = resolve([custom[key], datasetOpts[elementOptions[key]], datasetOpts[key], options[key]], context, index, info);
          }
        }
        if (info.cacheable) {
          me._cachedDataOpts = Object.freeze(values);
        }
        return values;
      },
      removeHoverStyle: function removeHoverStyle(element) {
        helpers$1.merge(element._model, element.$previousStyle || {});
        delete element.$previousStyle;
      },
      setHoverStyle: function setHoverStyle(element) {
        var dataset = this.chart.data.datasets[element._datasetIndex];
        var index = element._index;
        var custom = element.custom || {};
        var model = element._model;
        var getHoverColor = helpers$1.getHoverColor;
        element.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth
        };
        model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
        model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
        model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
      },
      _removeDatasetHoverStyle: function _removeDatasetHoverStyle() {
        var element = this.getMeta().dataset;
        if (element) {
          this.removeHoverStyle(element);
        }
      },
      _setDatasetHoverStyle: function _setDatasetHoverStyle() {
        var element = this.getMeta().dataset;
        var prev = {};
        var i, ilen, key, keys, hoverOptions, model;
        if (!element) {
          return;
        }
        model = element._model;
        hoverOptions = this._resolveDatasetElementOptions(element, true);
        keys = Object.keys(hoverOptions);
        for (i = 0, ilen = keys.length; i < ilen; ++i) {
          key = keys[i];
          prev[key] = model[key];
          model[key] = hoverOptions[key];
        }
        element.$previousStyle = prev;
      },
      resyncElements: function resyncElements() {
        var me = this;
        var meta = me.getMeta();
        var data = me.getDataset().data;
        var numMeta = meta.data.length;
        var numData = data.length;
        if (numData < numMeta) {
          meta.data.splice(numData, numMeta - numData);
        } else if (numData > numMeta) {
          me.insertElements(numMeta, numData - numMeta);
        }
      },
      insertElements: function insertElements(start, count) {
        for (var i = 0; i < count; ++i) {
          this.addElementAndReset(start + i);
        }
      },
      onDataPush: function onDataPush() {
        var count = arguments.length;
        this.insertElements(this.getDataset().data.length - count, count);
      },
      onDataPop: function onDataPop() {
        this.getMeta().data.pop();
      },
      onDataShift: function onDataShift() {
        this.getMeta().data.shift();
      },
      onDataSplice: function onDataSplice(start, count) {
        this.getMeta().data.splice(start, count);
        this.insertElements(start, arguments.length - 2);
      },
      onDataUnshift: function onDataUnshift() {
        this.insertElements(0, arguments.length);
      }
    });
    DatasetController.extend = helpers$1.inherits;
    var core_datasetController = DatasetController;
    var TAU = Math.PI * 2;
    core_defaults._set('global', {
      elements: {
        arc: {
          backgroundColor: core_defaults.global.defaultColor,
          borderColor: '#fff',
          borderWidth: 2,
          borderAlign: 'center'
        }
      }
    });
    function clipArc(ctx, arc) {
      var startAngle = arc.startAngle;
      var endAngle = arc.endAngle;
      var pixelMargin = arc.pixelMargin;
      var angleMargin = pixelMargin / arc.outerRadius;
      var x = arc.x;
      var y = arc.y;
      ctx.beginPath();
      ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
      if (arc.innerRadius > pixelMargin) {
        angleMargin = pixelMargin / arc.innerRadius;
        ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
      } else {
        ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
      }
      ctx.closePath();
      ctx.clip();
    }
    function drawFullCircleBorders(ctx, vm, arc, inner) {
      var endAngle = arc.endAngle;
      var i;
      if (inner) {
        arc.endAngle = arc.startAngle + TAU;
        clipArc(ctx, arc);
        arc.endAngle = endAngle;
        if (arc.endAngle === arc.startAngle && arc.fullCircles) {
          arc.endAngle += TAU;
          arc.fullCircles--;
        }
      }
      ctx.beginPath();
      ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
      for (i = 0; i < arc.fullCircles; ++i) {
        ctx.stroke();
      }
      ctx.beginPath();
      ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
      for (i = 0; i < arc.fullCircles; ++i) {
        ctx.stroke();
      }
    }
    function drawBorder(ctx, vm, arc) {
      var inner = vm.borderAlign === 'inner';
      if (inner) {
        ctx.lineWidth = vm.borderWidth * 2;
        ctx.lineJoin = 'round';
      } else {
        ctx.lineWidth = vm.borderWidth;
        ctx.lineJoin = 'bevel';
      }
      if (arc.fullCircles) {
        drawFullCircleBorders(ctx, vm, arc, inner);
      }
      if (inner) {
        clipArc(ctx, arc);
      }
      ctx.beginPath();
      ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
      ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
      ctx.closePath();
      ctx.stroke();
    }
    var element_arc = core_element.extend({
      _type: 'arc',
      inLabelRange: function inLabelRange(mouseX) {
        var vm = this._view;
        if (vm) {
          return Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2);
        }
        return false;
      },
      inRange: function inRange(chartX, chartY) {
        var vm = this._view;
        if (vm) {
          var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {
            x: chartX,
            y: chartY
          });
          var angle = pointRelativePosition.angle;
          var distance = pointRelativePosition.distance;
          var startAngle = vm.startAngle;
          var endAngle = vm.endAngle;
          while (endAngle < startAngle) {
            endAngle += TAU;
          }
          while (angle > endAngle) {
            angle -= TAU;
          }
          while (angle < startAngle) {
            angle += TAU;
          }
          var betweenAngles = angle >= startAngle && angle <= endAngle;
          var withinRadius = distance >= vm.innerRadius && distance <= vm.outerRadius;
          return betweenAngles && withinRadius;
        }
        return false;
      },
      getCenterPoint: function getCenterPoint() {
        var vm = this._view;
        var halfAngle = (vm.startAngle + vm.endAngle) / 2;
        var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
        return {
          x: vm.x + Math.cos(halfAngle) * halfRadius,
          y: vm.y + Math.sin(halfAngle) * halfRadius
        };
      },
      getArea: function getArea() {
        var vm = this._view;
        return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
      },
      tooltipPosition: function tooltipPosition() {
        var vm = this._view;
        var centreAngle = vm.startAngle + (vm.endAngle - vm.startAngle) / 2;
        var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
        return {
          x: vm.x + Math.cos(centreAngle) * rangeFromCentre,
          y: vm.y + Math.sin(centreAngle) * rangeFromCentre
        };
      },
      draw: function draw() {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var pixelMargin = vm.borderAlign === 'inner' ? 0.33 : 0;
        var arc = {
          x: vm.x,
          y: vm.y,
          innerRadius: vm.innerRadius,
          outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
          pixelMargin: pixelMargin,
          startAngle: vm.startAngle,
          endAngle: vm.endAngle,
          fullCircles: Math.floor(vm.circumference / TAU)
        };
        var i;
        ctx.save();
        ctx.fillStyle = vm.backgroundColor;
        ctx.strokeStyle = vm.borderColor;
        if (arc.fullCircles) {
          arc.endAngle = arc.startAngle + TAU;
          ctx.beginPath();
          ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
          ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
          ctx.closePath();
          for (i = 0; i < arc.fullCircles; ++i) {
            ctx.fill();
          }
          arc.endAngle = arc.startAngle + vm.circumference % TAU;
        }
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
        ctx.closePath();
        ctx.fill();
        if (vm.borderWidth) {
          drawBorder(ctx, vm, arc);
        }
        ctx.restore();
      }
    });
    var valueOrDefault$1 = helpers$1.valueOrDefault;
    var defaultColor = core_defaults.global.defaultColor;
    core_defaults._set('global', {
      elements: {
        line: {
          tension: 0.4,
          backgroundColor: defaultColor,
          borderWidth: 3,
          borderColor: defaultColor,
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          capBezierPoints: true,
          fill: true
        }
      }
    });
    var element_line = core_element.extend({
      _type: 'line',
      draw: function draw() {
        var me = this;
        var vm = me._view;
        var ctx = me._chart.ctx;
        var spanGaps = vm.spanGaps;
        var points = me._children.slice();
        var globalDefaults = core_defaults.global;
        var globalOptionLineElements = globalDefaults.elements.line;
        var lastDrawnIndex = -1;
        var closePath = me._loop;
        var index, previous, currentVM;
        if (!points.length) {
          return;
        }
        if (me._loop) {
          for (index = 0; index < points.length; ++index) {
            previous = helpers$1.previousItem(points, index);
            if (!points[index]._view.skip && previous._view.skip) {
              points = points.slice(index).concat(points.slice(0, index));
              closePath = spanGaps;
              break;
            }
          }
          if (closePath) {
            points.push(points[0]);
          }
        }
        ctx.save();
        ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
        if (ctx.setLineDash) {
          ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
        }
        ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
        ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
        ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
        ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
        ctx.beginPath();
        currentVM = points[0]._view;
        if (!currentVM.skip) {
          ctx.moveTo(currentVM.x, currentVM.y);
          lastDrawnIndex = 0;
        }
        for (index = 1; index < points.length; ++index) {
          currentVM = points[index]._view;
          previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
          if (!currentVM.skip) {
            if (lastDrawnIndex !== index - 1 && !spanGaps || lastDrawnIndex === -1) {
              ctx.moveTo(currentVM.x, currentVM.y);
            } else {
              helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
            }
            lastDrawnIndex = index;
          }
        }
        if (closePath) {
          ctx.closePath();
        }
        ctx.stroke();
        ctx.restore();
      }
    });
    var valueOrDefault$2 = helpers$1.valueOrDefault;
    var defaultColor$1 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
      elements: {
        point: {
          radius: 3,
          pointStyle: 'circle',
          backgroundColor: defaultColor$1,
          borderColor: defaultColor$1,
          borderWidth: 1,
          hitRadius: 1,
          hoverRadius: 4,
          hoverBorderWidth: 1
        }
      }
    });
    function xRange(mouseX) {
      var vm = this._view;
      return vm ? Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius : false;
    }
    function yRange(mouseY) {
      var vm = this._view;
      return vm ? Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius : false;
    }
    var element_point = core_element.extend({
      _type: 'point',
      inRange: function inRange(mouseX, mouseY) {
        var vm = this._view;
        return vm ? Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2) < Math.pow(vm.hitRadius + vm.radius, 2) : false;
      },
      inLabelRange: xRange,
      inXRange: xRange,
      inYRange: yRange,
      getCenterPoint: function getCenterPoint() {
        var vm = this._view;
        return {
          x: vm.x,
          y: vm.y
        };
      },
      getArea: function getArea() {
        return Math.PI * Math.pow(this._view.radius, 2);
      },
      tooltipPosition: function tooltipPosition() {
        var vm = this._view;
        return {
          x: vm.x,
          y: vm.y,
          padding: vm.radius + vm.borderWidth
        };
      },
      draw: function draw(chartArea) {
        var vm = this._view;
        var ctx = this._chart.ctx;
        var pointStyle = vm.pointStyle;
        var rotation = vm.rotation;
        var radius = vm.radius;
        var x = vm.x;
        var y = vm.y;
        var globalDefaults = core_defaults.global;
        var defaultColor = globalDefaults.defaultColor;
        if (vm.skip) {
          return;
        }
        if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
          ctx.strokeStyle = vm.borderColor || defaultColor;
          ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
          ctx.fillStyle = vm.backgroundColor || defaultColor;
          helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
        }
      }
    });
    var defaultColor$2 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
      elements: {
        rectangle: {
          backgroundColor: defaultColor$2,
          borderColor: defaultColor$2,
          borderSkipped: 'bottom',
          borderWidth: 0
        }
      }
    });
    function isVertical(vm) {
      return vm && vm.width !== undefined;
    }
    function getBarBounds(vm) {
      var x1, x2, y1, y2, half;
      if (isVertical(vm)) {
        half = vm.width / 2;
        x1 = vm.x - half;
        x2 = vm.x + half;
        y1 = Math.min(vm.y, vm.base);
        y2 = Math.max(vm.y, vm.base);
      } else {
        half = vm.height / 2;
        x1 = Math.min(vm.x, vm.base);
        x2 = Math.max(vm.x, vm.base);
        y1 = vm.y - half;
        y2 = vm.y + half;
      }
      return {
        left: x1,
        top: y1,
        right: x2,
        bottom: y2
      };
    }
    function swap(orig, v1, v2) {
      return orig === v1 ? v2 : orig === v2 ? v1 : orig;
    }
    function parseBorderSkipped(vm) {
      var edge = vm.borderSkipped;
      var res = {};
      if (!edge) {
        return res;
      }
      if (vm.horizontal) {
        if (vm.base > vm.x) {
          edge = swap(edge, 'left', 'right');
        }
      } else if (vm.base < vm.y) {
        edge = swap(edge, 'bottom', 'top');
      }
      res[edge] = true;
      return res;
    }
    function parseBorderWidth(vm, maxW, maxH) {
      var value = vm.borderWidth;
      var skip = parseBorderSkipped(vm);
      var t, r, b, l;
      if (helpers$1.isObject(value)) {
        t = +value.top || 0;
        r = +value.right || 0;
        b = +value.bottom || 0;
        l = +value.left || 0;
      } else {
        t = r = b = l = +value || 0;
      }
      return {
        t: skip.top || t < 0 ? 0 : t > maxH ? maxH : t,
        r: skip.right || r < 0 ? 0 : r > maxW ? maxW : r,
        b: skip.bottom || b < 0 ? 0 : b > maxH ? maxH : b,
        l: skip.left || l < 0 ? 0 : l > maxW ? maxW : l
      };
    }
    function boundingRects(vm) {
      var bounds = getBarBounds(vm);
      var width = bounds.right - bounds.left;
      var height = bounds.bottom - bounds.top;
      var border = parseBorderWidth(vm, width / 2, height / 2);
      return {
        outer: {
          x: bounds.left,
          y: bounds.top,
          w: width,
          h: height
        },
        inner: {
          x: bounds.left + border.l,
          y: bounds.top + border.t,
          w: width - border.l - border.r,
          h: height - border.t - border.b
        }
      };
    }
    function _inRange(vm, x, y) {
      var skipX = x === null;
      var skipY = y === null;
      var bounds = !vm || skipX && skipY ? false : getBarBounds(vm);
      return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
    }
    var element_rectangle = core_element.extend({
      _type: 'rectangle',
      draw: function draw() {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var rects = boundingRects(vm);
        var outer = rects.outer;
        var inner = rects.inner;
        ctx.fillStyle = vm.backgroundColor;
        ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
        if (outer.w === inner.w && outer.h === inner.h) {
          return;
        }
        ctx.save();
        ctx.beginPath();
        ctx.rect(outer.x, outer.y, outer.w, outer.h);
        ctx.clip();
        ctx.fillStyle = vm.borderColor;
        ctx.rect(inner.x, inner.y, inner.w, inner.h);
        ctx.fill('evenodd');
        ctx.restore();
      },
      height: function height() {
        var vm = this._view;
        return vm.base - vm.y;
      },
      inRange: function inRange(mouseX, mouseY) {
        return _inRange(this._view, mouseX, mouseY);
      },
      inLabelRange: function inLabelRange(mouseX, mouseY) {
        var vm = this._view;
        return isVertical(vm) ? _inRange(vm, mouseX, null) : _inRange(vm, null, mouseY);
      },
      inXRange: function inXRange(mouseX) {
        return _inRange(this._view, mouseX, null);
      },
      inYRange: function inYRange(mouseY) {
        return _inRange(this._view, null, mouseY);
      },
      getCenterPoint: function getCenterPoint() {
        var vm = this._view;
        var x, y;
        if (isVertical(vm)) {
          x = vm.x;
          y = (vm.y + vm.base) / 2;
        } else {
          x = (vm.x + vm.base) / 2;
          y = vm.y;
        }
        return {
          x: x,
          y: y
        };
      },
      getArea: function getArea() {
        var vm = this._view;
        return isVertical(vm) ? vm.width * Math.abs(vm.y - vm.base) : vm.height * Math.abs(vm.x - vm.base);
      },
      tooltipPosition: function tooltipPosition() {
        var vm = this._view;
        return {
          x: vm.x,
          y: vm.y
        };
      }
    });
    var elements = {};
    var Arc = element_arc;
    var Line = element_line;
    var Point = element_point;
    var Rectangle = element_rectangle;
    elements.Arc = Arc;
    elements.Line = Line;
    elements.Point = Point;
    elements.Rectangle = Rectangle;
    var deprecated = helpers$1._deprecated;
    var valueOrDefault$3 = helpers$1.valueOrDefault;
    core_defaults._set('bar', {
      hover: {
        mode: 'label'
      },
      scales: {
        xAxes: [{
          type: 'category',
          offset: true,
          gridLines: {
            offsetGridLines: true
          }
        }],
        yAxes: [{
          type: 'linear'
        }]
      }
    });
    core_defaults._set('global', {
      datasets: {
        bar: {
          categoryPercentage: 0.8,
          barPercentage: 0.9
        }
      }
    });
    function computeMinSampleSize(scale, pixels) {
      var min = scale._length;
      var prev, curr, i, ilen;
      for (i = 1, ilen = pixels.length; i < ilen; ++i) {
        min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
      }
      for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
        curr = scale.getPixelForTick(i);
        min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
        prev = curr;
      }
      return min;
    }
    function computeFitCategoryTraits(index, ruler, options) {
      var thickness = options.barThickness;
      var count = ruler.stackCount;
      var curr = ruler.pixels[index];
      var min = helpers$1.isNullOrUndef(thickness) ? computeMinSampleSize(ruler.scale, ruler.pixels) : -1;
      var size, ratio;
      if (helpers$1.isNullOrUndef(thickness)) {
        size = min * options.categoryPercentage;
        ratio = options.barPercentage;
      } else {
        size = thickness * count;
        ratio = 1;
      }
      return {
        chunk: size / count,
        ratio: ratio,
        start: curr - size / 2
      };
    }
    function computeFlexCategoryTraits(index, ruler, options) {
      var pixels = ruler.pixels;
      var curr = pixels[index];
      var prev = index > 0 ? pixels[index - 1] : null;
      var next = index < pixels.length - 1 ? pixels[index + 1] : null;
      var percent = options.categoryPercentage;
      var start, size;
      if (prev === null) {
        prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
      }
      if (next === null) {
        next = curr + curr - prev;
      }
      start = curr - (curr - Math.min(prev, next)) / 2 * percent;
      size = Math.abs(next - prev) / 2 * percent;
      return {
        chunk: size / ruler.stackCount,
        ratio: options.barPercentage,
        start: start
      };
    }
    var controller_bar = core_datasetController.extend({
      dataElementType: elements.Rectangle,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderSkipped', 'borderWidth', 'barPercentage', 'barThickness', 'categoryPercentage', 'maxBarThickness', 'minBarLength'],
      initialize: function initialize() {
        var me = this;
        var meta, scaleOpts;
        core_datasetController.prototype.initialize.apply(me, arguments);
        meta = me.getMeta();
        meta.stack = me.getDataset().stack;
        meta.bar = true;
        scaleOpts = me._getIndexScale().options;
        deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
        deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
        deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
        deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
        deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
      },
      update: function update(reset) {
        var me = this;
        var rects = me.getMeta().data;
        var i, ilen;
        me._ruler = me.getRuler();
        for (i = 0, ilen = rects.length; i < ilen; ++i) {
          me.updateElement(rects[i], i, reset);
        }
      },
      updateElement: function updateElement(rectangle, index, reset) {
        var me = this;
        var meta = me.getMeta();
        var dataset = me.getDataset();
        var options = me._resolveDataElementOptions(rectangle, index);
        rectangle._xScale = me.getScaleForId(meta.xAxisID);
        rectangle._yScale = me.getScaleForId(meta.yAxisID);
        rectangle._datasetIndex = me.index;
        rectangle._index = index;
        rectangle._model = {
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderSkipped: options.borderSkipped,
          borderWidth: options.borderWidth,
          datasetLabel: dataset.label,
          label: me.chart.data.labels[index]
        };
        if (helpers$1.isArray(dataset.data[index])) {
          rectangle._model.borderSkipped = null;
        }
        me._updateElementGeometry(rectangle, index, reset, options);
        rectangle.pivot();
      },
      _updateElementGeometry: function _updateElementGeometry(rectangle, index, reset, options) {
        var me = this;
        var model = rectangle._model;
        var vscale = me._getValueScale();
        var base = vscale.getBasePixel();
        var horizontal = vscale.isHorizontal();
        var ruler = me._ruler || me.getRuler();
        var vpixels = me.calculateBarValuePixels(me.index, index, options);
        var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
        model.horizontal = horizontal;
        model.base = reset ? base : vpixels.base;
        model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
        model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
        model.height = horizontal ? ipixels.size : undefined;
        model.width = horizontal ? undefined : ipixels.size;
      },
      _getStacks: function _getStacks(last) {
        var me = this;
        var scale = me._getIndexScale();
        var metasets = scale._getMatchingVisibleMetas(me._type);
        var stacked = scale.options.stacked;
        var ilen = metasets.length;
        var stacks = [];
        var i, meta;
        for (i = 0; i < ilen; ++i) {
          meta = metasets[i];
          if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) {
            stacks.push(meta.stack);
          }
          if (meta.index === last) {
            break;
          }
        }
        return stacks;
      },
      getStackCount: function getStackCount() {
        return this._getStacks().length;
      },
      getStackIndex: function getStackIndex(datasetIndex, name) {
        var stacks = this._getStacks(datasetIndex);
        var index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
      },
      getRuler: function getRuler() {
        var me = this;
        var scale = me._getIndexScale();
        var pixels = [];
        var i, ilen;
        for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
          pixels.push(scale.getPixelForValue(null, i, me.index));
        }
        return {
          pixels: pixels,
          start: scale._startPixel,
          end: scale._endPixel,
          stackCount: me.getStackCount(),
          scale: scale
        };
      },
      calculateBarValuePixels: function calculateBarValuePixels(datasetIndex, index, options) {
        var me = this;
        var chart = me.chart;
        var scale = me._getValueScale();
        var isHorizontal = scale.isHorizontal();
        var datasets = chart.data.datasets;
        var metasets = scale._getMatchingVisibleMetas(me._type);
        var value = scale._parseValue(datasets[datasetIndex].data[index]);
        var minBarLength = options.minBarLength;
        var stacked = scale.options.stacked;
        var stack = me.getMeta().stack;
        var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
        var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
        var ilen = metasets.length;
        var i, imeta, ivalue, base, head, size, stackLength;
        if (stacked || stacked === undefined && stack !== undefined) {
          for (i = 0; i < ilen; ++i) {
            imeta = metasets[i];
            if (imeta.index === datasetIndex) {
              break;
            }
            if (imeta.stack === stack) {
              stackLength = scale._parseValue(datasets[imeta.index].data[index]);
              ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
              if (value.min < 0 && ivalue < 0 || value.max >= 0 && ivalue > 0) {
                start += ivalue;
              }
            }
          }
        }
        base = scale.getPixelForValue(start);
        head = scale.getPixelForValue(start + length);
        size = head - base;
        if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
          size = minBarLength;
          if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
            head = base - minBarLength;
          } else {
            head = base + minBarLength;
          }
        }
        return {
          size: size,
          base: base,
          head: head,
          center: head + size / 2
        };
      },
      calculateBarIndexPixels: function calculateBarIndexPixels(datasetIndex, index, ruler, options) {
        var me = this;
        var range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options) : computeFitCategoryTraits(index, ruler, options);
        var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
        var center = range.start + range.chunk * stackIndex + range.chunk / 2;
        var size = Math.min(valueOrDefault$3(options.maxBarThickness, Infinity), range.chunk * range.ratio);
        return {
          base: center - size / 2,
          head: center + size / 2,
          center: center,
          size: size
        };
      },
      draw: function draw() {
        var me = this;
        var chart = me.chart;
        var scale = me._getValueScale();
        var rects = me.getMeta().data;
        var dataset = me.getDataset();
        var ilen = rects.length;
        var i = 0;
        helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
        for (; i < ilen; ++i) {
          var val = scale._parseValue(dataset.data[i]);
          if (!isNaN(val.min) && !isNaN(val.max)) {
            rects[i].draw();
          }
        }
        helpers$1.canvas.unclipArea(chart.ctx);
      },
      _resolveDataElementOptions: function _resolveDataElementOptions() {
        var me = this;
        var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
        var indexOpts = me._getIndexScale().options;
        var valueOpts = me._getValueScale().options;
        values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
        values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
        values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
        values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
        values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
        return values;
      }
    });
    var valueOrDefault$4 = helpers$1.valueOrDefault;
    var resolve$1 = helpers$1.options.resolve;
    core_defaults._set('bubble', {
      hover: {
        mode: 'single'
      },
      scales: {
        xAxes: [{
          type: 'linear',
          position: 'bottom',
          id: 'x-axis-0'
        }],
        yAxes: [{
          type: 'linear',
          position: 'left',
          id: 'y-axis-0'
        }]
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(item, data) {
            var datasetLabel = data.datasets[item.datasetIndex].label || '';
            var dataPoint = data.datasets[item.datasetIndex].data[item.index];
            return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
          }
        }
      }
    });
    var controller_bubble = core_datasetController.extend({
      dataElementType: elements.Point,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth', 'hoverRadius', 'hitRadius', 'pointStyle', 'rotation'],
      update: function update(reset) {
        var me = this;
        var meta = me.getMeta();
        var points = meta.data;
        helpers$1.each(points, function (point, index) {
          me.updateElement(point, index, reset);
        });
      },
      updateElement: function updateElement(point, index, reset) {
        var me = this;
        var meta = me.getMeta();
        var custom = point.custom || {};
        var xScale = me.getScaleForId(meta.xAxisID);
        var yScale = me.getScaleForId(meta.yAxisID);
        var options = me._resolveDataElementOptions(point, index);
        var data = me.getDataset().data[index];
        var dsIndex = me.index;
        var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
        var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
        point._xScale = xScale;
        point._yScale = yScale;
        point._options = options;
        point._datasetIndex = dsIndex;
        point._index = index;
        point._model = {
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderWidth: options.borderWidth,
          hitRadius: options.hitRadius,
          pointStyle: options.pointStyle,
          rotation: options.rotation,
          radius: reset ? 0 : options.radius,
          skip: custom.skip || isNaN(x) || isNaN(y),
          x: x,
          y: y
        };
        point.pivot();
      },
      setHoverStyle: function setHoverStyle(point) {
        var model = point._model;
        var options = point._options;
        var getHoverColor = helpers$1.getHoverColor;
        point.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth,
          radius: model.radius
        };
        model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
        model.radius = options.radius + options.hoverRadius;
      },
      _resolveDataElementOptions: function _resolveDataElementOptions(point, index) {
        var me = this;
        var chart = me.chart;
        var dataset = me.getDataset();
        var custom = point.custom || {};
        var data = dataset.data[index] || {};
        var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
        var context = {
          chart: chart,
          dataIndex: index,
          dataset: dataset,
          datasetIndex: me.index
        };
        if (me._cachedDataOpts === values) {
          values = helpers$1.extend({}, values);
        }
        values.radius = resolve$1([custom.radius, data.r, me._config.radius, chart.options.elements.point.radius], context, index);
        return values;
      }
    });
    var valueOrDefault$5 = helpers$1.valueOrDefault;
    var PI$1 = Math.PI;
    var DOUBLE_PI$1 = PI$1 * 2;
    var HALF_PI$1 = PI$1 / 2;
    core_defaults._set('doughnut', {
      animation: {
        animateRotate: true,
        animateScale: false
      },
      hover: {
        mode: 'single'
      },
      legendCallback: function legendCallback(chart) {
        var list = document.createElement('ul');
        var data = chart.data;
        var datasets = data.datasets;
        var labels = data.labels;
        var i, ilen, listItem, listItemSpan;
        list.setAttribute('class', chart.id + '-legend');
        if (datasets.length) {
          for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
            listItem = list.appendChild(document.createElement('li'));
            listItemSpan = listItem.appendChild(document.createElement('span'));
            listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
            if (labels[i]) {
              listItem.appendChild(document.createTextNode(labels[i]));
            }
          }
        }
        return list.outerHTML;
      },
      legend: {
        labels: {
          generateLabels: function generateLabels(chart) {
            var data = chart.data;
            if (data.labels.length && data.datasets.length) {
              return data.labels.map(function (label, i) {
                var meta = chart.getDatasetMeta(0);
                var style = meta.controller.getStyle(i);
                return {
                  text: label,
                  fillStyle: style.backgroundColor,
                  strokeStyle: style.borderColor,
                  lineWidth: style.borderWidth,
                  hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                  index: i
                };
              });
            }
            return [];
          }
        },
        onClick: function onClick(e, legendItem) {
          var index = legendItem.index;
          var chart = this.chart;
          var i, ilen, meta;
          for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
            meta = chart.getDatasetMeta(i);
            if (meta.data[index]) {
              meta.data[index].hidden = !meta.data[index].hidden;
            }
          }
          chart.update();
        }
      },
      cutoutPercentage: 50,
      rotation: -HALF_PI$1,
      circumference: DOUBLE_PI$1,
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(tooltipItem, data) {
            var dataLabel = data.labels[tooltipItem.index];
            var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            if (helpers$1.isArray(dataLabel)) {
              dataLabel = dataLabel.slice();
              dataLabel[0] += value;
            } else {
              dataLabel += value;
            }
            return dataLabel;
          }
        }
      }
    });
    var controller_doughnut = core_datasetController.extend({
      dataElementType: elements.Arc,
      linkScales: helpers$1.noop,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'borderAlign', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth'],
      getRingIndex: function getRingIndex(datasetIndex) {
        var ringIndex = 0;
        for (var j = 0; j < datasetIndex; ++j) {
          if (this.chart.isDatasetVisible(j)) {
            ++ringIndex;
          }
        }
        return ringIndex;
      },
      update: function update(reset) {
        var me = this;
        var chart = me.chart;
        var chartArea = chart.chartArea;
        var opts = chart.options;
        var ratioX = 1;
        var ratioY = 1;
        var offsetX = 0;
        var offsetY = 0;
        var meta = me.getMeta();
        var arcs = meta.data;
        var cutout = opts.cutoutPercentage / 100 || 0;
        var circumference = opts.circumference;
        var chartWeight = me._getRingWeight(me.index);
        var maxWidth, maxHeight, i, ilen;
        if (circumference < DOUBLE_PI$1) {
          var startAngle = opts.rotation % DOUBLE_PI$1;
          startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
          var endAngle = startAngle + circumference;
          var startX = Math.cos(startAngle);
          var startY = Math.sin(startAngle);
          var endX = Math.cos(endAngle);
          var endY = Math.sin(endAngle);
          var contains0 = startAngle <= 0 && endAngle >= 0 || endAngle >= DOUBLE_PI$1;
          var contains90 = startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1 || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
          var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
          var contains270 = startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1 || endAngle >= PI$1 + HALF_PI$1;
          var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
          var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
          var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
          var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
          ratioX = (maxX - minX) / 2;
          ratioY = (maxY - minY) / 2;
          offsetX = -(maxX + minX) / 2;
          offsetY = -(maxY + minY) / 2;
        }
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
        }
        chart.borderWidth = me.getMaxBorderWidth();
        maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
        maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
        chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
        chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
        chart.offsetX = offsetX * chart.outerRadius;
        chart.offsetY = offsetY * chart.outerRadius;
        meta.total = me.calculateTotal();
        me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
        me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          me.updateElement(arcs[i], i, reset);
        }
      },
      updateElement: function updateElement(arc, index, reset) {
        var me = this;
        var chart = me.chart;
        var chartArea = chart.chartArea;
        var opts = chart.options;
        var animationOpts = opts.animation;
        var centerX = (chartArea.left + chartArea.right) / 2;
        var centerY = (chartArea.top + chartArea.bottom) / 2;
        var startAngle = opts.rotation;
        var endAngle = opts.rotation;
        var dataset = me.getDataset();
        var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
        var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
        var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
        var options = arc._options || {};
        helpers$1.extend(arc, {
          _datasetIndex: me.index,
          _index: index,
          _model: {
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: options.borderWidth,
            borderAlign: options.borderAlign,
            x: centerX + chart.offsetX,
            y: centerY + chart.offsetY,
            startAngle: startAngle,
            endAngle: endAngle,
            circumference: circumference,
            outerRadius: outerRadius,
            innerRadius: innerRadius,
            label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
          }
        });
        var model = arc._model;
        if (!reset || !animationOpts.animateRotate) {
          if (index === 0) {
            model.startAngle = opts.rotation;
          } else {
            model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
          }
          model.endAngle = model.startAngle + model.circumference;
        }
        arc.pivot();
      },
      calculateTotal: function calculateTotal() {
        var dataset = this.getDataset();
        var meta = this.getMeta();
        var total = 0;
        var value;
        helpers$1.each(meta.data, function (element, index) {
          value = dataset.data[index];
          if (!isNaN(value) && !element.hidden) {
            total += Math.abs(value);
          }
        });
        return total;
      },
      calculateCircumference: function calculateCircumference(value) {
        var total = this.getMeta().total;
        if (total > 0 && !isNaN(value)) {
          return DOUBLE_PI$1 * (Math.abs(value) / total);
        }
        return 0;
      },
      getMaxBorderWidth: function getMaxBorderWidth(arcs) {
        var me = this;
        var max = 0;
        var chart = me.chart;
        var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
        if (!arcs) {
          for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
            if (chart.isDatasetVisible(i)) {
              meta = chart.getDatasetMeta(i);
              arcs = meta.data;
              if (i !== me.index) {
                controller = meta.controller;
              }
              break;
            }
          }
        }
        if (!arcs) {
          return 0;
        }
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          arc = arcs[i];
          if (controller) {
            controller._configure();
            options = controller._resolveDataElementOptions(arc, i);
          } else {
            options = arc._options;
          }
          if (options.borderAlign !== 'inner') {
            borderWidth = options.borderWidth;
            hoverWidth = options.hoverBorderWidth;
            max = borderWidth > max ? borderWidth : max;
            max = hoverWidth > max ? hoverWidth : max;
          }
        }
        return max;
      },
      setHoverStyle: function setHoverStyle(arc) {
        var model = arc._model;
        var options = arc._options;
        var getHoverColor = helpers$1.getHoverColor;
        arc.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth
        };
        model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
      },
      _getRingWeightOffset: function _getRingWeightOffset(datasetIndex) {
        var ringWeightOffset = 0;
        for (var i = 0; i < datasetIndex; ++i) {
          if (this.chart.isDatasetVisible(i)) {
            ringWeightOffset += this._getRingWeight(i);
          }
        }
        return ringWeightOffset;
      },
      _getRingWeight: function _getRingWeight(dataSetIndex) {
        return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
      },
      _getVisibleDatasetWeightTotal: function _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length);
      }
    });
    core_defaults._set('horizontalBar', {
      hover: {
        mode: 'index',
        axis: 'y'
      },
      scales: {
        xAxes: [{
          type: 'linear',
          position: 'bottom'
        }],
        yAxes: [{
          type: 'category',
          position: 'left',
          offset: true,
          gridLines: {
            offsetGridLines: true
          }
        }]
      },
      elements: {
        rectangle: {
          borderSkipped: 'left'
        }
      },
      tooltips: {
        mode: 'index',
        axis: 'y'
      }
    });
    core_defaults._set('global', {
      datasets: {
        horizontalBar: {
          categoryPercentage: 0.8,
          barPercentage: 0.9
        }
      }
    });
    var controller_horizontalBar = controller_bar.extend({
      _getValueScaleId: function _getValueScaleId() {
        return this.getMeta().xAxisID;
      },
      _getIndexScaleId: function _getIndexScaleId() {
        return this.getMeta().yAxisID;
      }
    });
    var valueOrDefault$6 = helpers$1.valueOrDefault;
    var resolve$2 = helpers$1.options.resolve;
    var isPointInArea = helpers$1.canvas._isPointInArea;
    core_defaults._set('line', {
      showLines: true,
      spanGaps: false,
      hover: {
        mode: 'label'
      },
      scales: {
        xAxes: [{
          type: 'category',
          id: 'x-axis-0'
        }],
        yAxes: [{
          type: 'linear',
          id: 'y-axis-0'
        }]
      }
    });
    function scaleClip(scale, halfBorderWidth) {
      var tickOpts = scale && scale.options.ticks || {};
      var reverse = tickOpts.reverse;
      var min = tickOpts.min === undefined ? halfBorderWidth : 0;
      var max = tickOpts.max === undefined ? halfBorderWidth : 0;
      return {
        start: reverse ? max : min,
        end: reverse ? min : max
      };
    }
    function defaultClip(xScale, yScale, borderWidth) {
      var halfBorderWidth = borderWidth / 2;
      var x = scaleClip(xScale, halfBorderWidth);
      var y = scaleClip(yScale, halfBorderWidth);
      return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
      };
    }
    function toClip(value) {
      var t, r, b, l;
      if (helpers$1.isObject(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
      } else {
        t = r = b = l = value;
      }
      return {
        top: t,
        right: r,
        bottom: b,
        left: l
      };
    }
    var controller_line = core_datasetController.extend({
      datasetElementType: elements.Line,
      dataElementType: elements.Point,
      _datasetElementOptions: ['backgroundColor', 'borderCapStyle', 'borderColor', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'borderWidth', 'cubicInterpolationMode', 'fill'],
      _dataElementOptions: {
        backgroundColor: 'pointBackgroundColor',
        borderColor: 'pointBorderColor',
        borderWidth: 'pointBorderWidth',
        hitRadius: 'pointHitRadius',
        hoverBackgroundColor: 'pointHoverBackgroundColor',
        hoverBorderColor: 'pointHoverBorderColor',
        hoverBorderWidth: 'pointHoverBorderWidth',
        hoverRadius: 'pointHoverRadius',
        pointStyle: 'pointStyle',
        radius: 'pointRadius',
        rotation: 'pointRotation'
      },
      update: function update(reset) {
        var me = this;
        var meta = me.getMeta();
        var line = meta.dataset;
        var points = meta.data || [];
        var options = me.chart.options;
        var config = me._config;
        var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
        var i, ilen;
        me._xScale = me.getScaleForId(meta.xAxisID);
        me._yScale = me.getScaleForId(meta.yAxisID);
        if (showLine) {
          if (config.tension !== undefined && config.lineTension === undefined) {
            config.lineTension = config.tension;
          }
          line._scale = me._yScale;
          line._datasetIndex = me.index;
          line._children = points;
          line._model = me._resolveDatasetElementOptions(line);
          line.pivot();
        }
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          me.updateElement(points[i], i, reset);
        }
        if (showLine && line._model.tension !== 0) {
          me.updateBezierControlPoints();
        }
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          points[i].pivot();
        }
      },
      updateElement: function updateElement(point, index, reset) {
        var me = this;
        var meta = me.getMeta();
        var custom = point.custom || {};
        var dataset = me.getDataset();
        var datasetIndex = me.index;
        var value = dataset.data[index];
        var xScale = me._xScale;
        var yScale = me._yScale;
        var lineModel = meta.dataset._model;
        var x, y;
        var options = me._resolveDataElementOptions(point, index);
        x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
        y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
        point._xScale = xScale;
        point._yScale = yScale;
        point._options = options;
        point._datasetIndex = datasetIndex;
        point._index = index;
        point._model = {
          x: x,
          y: y,
          skip: custom.skip || isNaN(x) || isNaN(y),
          radius: options.radius,
          pointStyle: options.pointStyle,
          rotation: options.rotation,
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderWidth: options.borderWidth,
          tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
          steppedLine: lineModel ? lineModel.steppedLine : false,
          hitRadius: options.hitRadius
        };
      },
      _resolveDatasetElementOptions: function _resolveDatasetElementOptions(element) {
        var me = this;
        var config = me._config;
        var custom = element.custom || {};
        var options = me.chart.options;
        var lineOptions = options.elements.line;
        var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
        values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
        values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
        values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
        values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
        return values;
      },
      calculatePointY: function calculatePointY(value, index, datasetIndex) {
        var me = this;
        var chart = me.chart;
        var yScale = me._yScale;
        var sumPos = 0;
        var sumNeg = 0;
        var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
        if (yScale.options.stacked) {
          rightValue = +yScale.getRightValue(value);
          metasets = chart._getSortedVisibleDatasetMetas();
          ilen = metasets.length;
          for (i = 0; i < ilen; ++i) {
            dsMeta = metasets[i];
            if (dsMeta.index === datasetIndex) {
              break;
            }
            ds = chart.data.datasets[dsMeta.index];
            if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
              stackedRightValue = +yScale.getRightValue(ds.data[index]);
              if (stackedRightValue < 0) {
                sumNeg += stackedRightValue || 0;
              } else {
                sumPos += stackedRightValue || 0;
              }
            }
          }
          if (rightValue < 0) {
            return yScale.getPixelForValue(sumNeg + rightValue);
          }
          return yScale.getPixelForValue(sumPos + rightValue);
        }
        return yScale.getPixelForValue(value);
      },
      updateBezierControlPoints: function updateBezierControlPoints() {
        var me = this;
        var chart = me.chart;
        var meta = me.getMeta();
        var lineModel = meta.dataset._model;
        var area = chart.chartArea;
        var points = meta.data || [];
        var i, ilen, model, controlPoints;
        if (lineModel.spanGaps) {
          points = points.filter(function (pt) {
            return !pt._model.skip;
          });
        }
        function capControlPoint(pt, min, max) {
          return Math.max(Math.min(pt, max), min);
        }
        if (lineModel.cubicInterpolationMode === 'monotone') {
          helpers$1.splineCurveMonotone(points);
        } else {
          for (i = 0, ilen = points.length; i < ilen; ++i) {
            model = points[i]._model;
            controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i)._model, model, helpers$1.nextItem(points, i)._model, lineModel.tension);
            model.controlPointPreviousX = controlPoints.previous.x;
            model.controlPointPreviousY = controlPoints.previous.y;
            model.controlPointNextX = controlPoints.next.x;
            model.controlPointNextY = controlPoints.next.y;
          }
        }
        if (chart.options.elements.line.capBezierPoints) {
          for (i = 0, ilen = points.length; i < ilen; ++i) {
            model = points[i]._model;
            if (isPointInArea(model, area)) {
              if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
                model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
                model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
              }
              if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
                model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
                model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
              }
            }
          }
        }
      },
      draw: function draw() {
        var me = this;
        var chart = me.chart;
        var meta = me.getMeta();
        var points = meta.data || [];
        var area = chart.chartArea;
        var canvas = chart.canvas;
        var i = 0;
        var ilen = points.length;
        var clip;
        if (me._showLine) {
          clip = meta.dataset._model.clip;
          helpers$1.canvas.clipArea(chart.ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? canvas.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
          });
          meta.dataset.draw();
          helpers$1.canvas.unclipArea(chart.ctx);
        }
        for (; i < ilen; ++i) {
          points[i].draw(area);
        }
      },
      setHoverStyle: function setHoverStyle(point) {
        var model = point._model;
        var options = point._options;
        var getHoverColor = helpers$1.getHoverColor;
        point.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth,
          radius: model.radius
        };
        model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
        model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
      }
    });
    var resolve$3 = helpers$1.options.resolve;
    core_defaults._set('polarArea', {
      scale: {
        type: 'radialLinear',
        angleLines: {
          display: false
        },
        gridLines: {
          circular: true
        },
        pointLabels: {
          display: false
        },
        ticks: {
          beginAtZero: true
        }
      },
      animation: {
        animateRotate: true,
        animateScale: true
      },
      startAngle: -0.5 * Math.PI,
      legendCallback: function legendCallback(chart) {
        var list = document.createElement('ul');
        var data = chart.data;
        var datasets = data.datasets;
        var labels = data.labels;
        var i, ilen, listItem, listItemSpan;
        list.setAttribute('class', chart.id + '-legend');
        if (datasets.length) {
          for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
            listItem = list.appendChild(document.createElement('li'));
            listItemSpan = listItem.appendChild(document.createElement('span'));
            listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
            if (labels[i]) {
              listItem.appendChild(document.createTextNode(labels[i]));
            }
          }
        }
        return list.outerHTML;
      },
      legend: {
        labels: {
          generateLabels: function generateLabels(chart) {
            var data = chart.data;
            if (data.labels.length && data.datasets.length) {
              return data.labels.map(function (label, i) {
                var meta = chart.getDatasetMeta(0);
                var style = meta.controller.getStyle(i);
                return {
                  text: label,
                  fillStyle: style.backgroundColor,
                  strokeStyle: style.borderColor,
                  lineWidth: style.borderWidth,
                  hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                  index: i
                };
              });
            }
            return [];
          }
        },
        onClick: function onClick(e, legendItem) {
          var index = legendItem.index;
          var chart = this.chart;
          var i, ilen, meta;
          for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
            meta = chart.getDatasetMeta(i);
            meta.data[index].hidden = !meta.data[index].hidden;
          }
          chart.update();
        }
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(item, data) {
            return data.labels[item.index] + ': ' + item.yLabel;
          }
        }
      }
    });
    var controller_polarArea = core_datasetController.extend({
      dataElementType: elements.Arc,
      linkScales: helpers$1.noop,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'borderAlign', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth'],
      _getIndexScaleId: function _getIndexScaleId() {
        return this.chart.scale.id;
      },
      _getValueScaleId: function _getValueScaleId() {
        return this.chart.scale.id;
      },
      update: function update(reset) {
        var me = this;
        var dataset = me.getDataset();
        var meta = me.getMeta();
        var start = me.chart.options.startAngle || 0;
        var starts = me._starts = [];
        var angles = me._angles = [];
        var arcs = meta.data;
        var i, ilen, angle;
        me._updateRadius();
        meta.count = me.countVisibleElements();
        for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
          starts[i] = start;
          angle = me._computeAngle(i);
          angles[i] = angle;
          start += angle;
        }
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
          me.updateElement(arcs[i], i, reset);
        }
      },
      _updateRadius: function _updateRadius() {
        var me = this;
        var chart = me.chart;
        var chartArea = chart.chartArea;
        var opts = chart.options;
        var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        chart.outerRadius = Math.max(minSize / 2, 0);
        chart.innerRadius = Math.max(opts.cutoutPercentage ? chart.outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
        me.outerRadius = chart.outerRadius - chart.radiusLength * me.index;
        me.innerRadius = me.outerRadius - chart.radiusLength;
      },
      updateElement: function updateElement(arc, index, reset) {
        var me = this;
        var chart = me.chart;
        var dataset = me.getDataset();
        var opts = chart.options;
        var animationOpts = opts.animation;
        var scale = chart.scale;
        var labels = chart.data.labels;
        var centerX = scale.xCenter;
        var centerY = scale.yCenter;
        var datasetStartAngle = opts.startAngle;
        var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
        var startAngle = me._starts[index];
        var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
        var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
        var options = arc._options || {};
        helpers$1.extend(arc, {
          _datasetIndex: me.index,
          _index: index,
          _scale: scale,
          _model: {
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: options.borderWidth,
            borderAlign: options.borderAlign,
            x: centerX,
            y: centerY,
            innerRadius: 0,
            outerRadius: reset ? resetRadius : distance,
            startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
            endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
            label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
          }
        });
        arc.pivot();
      },
      countVisibleElements: function countVisibleElements() {
        var dataset = this.getDataset();
        var meta = this.getMeta();
        var count = 0;
        helpers$1.each(meta.data, function (element, index) {
          if (!isNaN(dataset.data[index]) && !element.hidden) {
            count++;
          }
        });
        return count;
      },
      setHoverStyle: function setHoverStyle(arc) {
        var model = arc._model;
        var options = arc._options;
        var getHoverColor = helpers$1.getHoverColor;
        var valueOrDefault = helpers$1.valueOrDefault;
        arc.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth
        };
        model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
      },
      _computeAngle: function _computeAngle(index) {
        var me = this;
        var count = this.getMeta().count;
        var dataset = me.getDataset();
        var meta = me.getMeta();
        if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
          return 0;
        }
        var context = {
          chart: me.chart,
          dataIndex: index,
          dataset: dataset,
          datasetIndex: me.index
        };
        return resolve$3([me.chart.options.elements.arc.angle, 2 * Math.PI / count], context, index);
      }
    });
    core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
    core_defaults._set('pie', {
      cutoutPercentage: 0
    });
    var controller_pie = controller_doughnut;
    var valueOrDefault$7 = helpers$1.valueOrDefault;
    core_defaults._set('radar', {
      spanGaps: false,
      scale: {
        type: 'radialLinear'
      },
      elements: {
        line: {
          fill: 'start',
          tension: 0
        }
      }
    });
    var controller_radar = core_datasetController.extend({
      datasetElementType: elements.Line,
      dataElementType: elements.Point,
      linkScales: helpers$1.noop,
      _datasetElementOptions: ['backgroundColor', 'borderWidth', 'borderColor', 'borderCapStyle', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'fill'],
      _dataElementOptions: {
        backgroundColor: 'pointBackgroundColor',
        borderColor: 'pointBorderColor',
        borderWidth: 'pointBorderWidth',
        hitRadius: 'pointHitRadius',
        hoverBackgroundColor: 'pointHoverBackgroundColor',
        hoverBorderColor: 'pointHoverBorderColor',
        hoverBorderWidth: 'pointHoverBorderWidth',
        hoverRadius: 'pointHoverRadius',
        pointStyle: 'pointStyle',
        radius: 'pointRadius',
        rotation: 'pointRotation'
      },
      _getIndexScaleId: function _getIndexScaleId() {
        return this.chart.scale.id;
      },
      _getValueScaleId: function _getValueScaleId() {
        return this.chart.scale.id;
      },
      update: function update(reset) {
        var me = this;
        var meta = me.getMeta();
        var line = meta.dataset;
        var points = meta.data || [];
        var scale = me.chart.scale;
        var config = me._config;
        var i, ilen;
        if (config.tension !== undefined && config.lineTension === undefined) {
          config.lineTension = config.tension;
        }
        line._scale = scale;
        line._datasetIndex = me.index;
        line._children = points;
        line._loop = true;
        line._model = me._resolveDatasetElementOptions(line);
        line.pivot();
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          me.updateElement(points[i], i, reset);
        }
        me.updateBezierControlPoints();
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          points[i].pivot();
        }
      },
      updateElement: function updateElement(point, index, reset) {
        var me = this;
        var custom = point.custom || {};
        var dataset = me.getDataset();
        var scale = me.chart.scale;
        var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
        var options = me._resolveDataElementOptions(point, index);
        var lineModel = me.getMeta().dataset._model;
        var x = reset ? scale.xCenter : pointPosition.x;
        var y = reset ? scale.yCenter : pointPosition.y;
        point._scale = scale;
        point._options = options;
        point._datasetIndex = me.index;
        point._index = index;
        point._model = {
          x: x,
          y: y,
          skip: custom.skip || isNaN(x) || isNaN(y),
          radius: options.radius,
          pointStyle: options.pointStyle,
          rotation: options.rotation,
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderWidth: options.borderWidth,
          tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
          hitRadius: options.hitRadius
        };
      },
      _resolveDatasetElementOptions: function _resolveDatasetElementOptions() {
        var me = this;
        var config = me._config;
        var options = me.chart.options;
        var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
        values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
        values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
        return values;
      },
      updateBezierControlPoints: function updateBezierControlPoints() {
        var me = this;
        var meta = me.getMeta();
        var area = me.chart.chartArea;
        var points = meta.data || [];
        var i, ilen, model, controlPoints;
        if (meta.dataset._model.spanGaps) {
          points = points.filter(function (pt) {
            return !pt._model.skip;
          });
        }
        function capControlPoint(pt, min, max) {
          return Math.max(Math.min(pt, max), min);
        }
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          model = points[i]._model;
          controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i, true)._model, model, helpers$1.nextItem(points, i, true)._model, model.tension);
          model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
          model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
          model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
          model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
        }
      },
      setHoverStyle: function setHoverStyle(point) {
        var model = point._model;
        var options = point._options;
        var getHoverColor = helpers$1.getHoverColor;
        point.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth,
          radius: model.radius
        };
        model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
        model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
      }
    });
    core_defaults._set('scatter', {
      hover: {
        mode: 'single'
      },
      scales: {
        xAxes: [{
          id: 'x-axis-1',
          type: 'linear',
          position: 'bottom'
        }],
        yAxes: [{
          id: 'y-axis-1',
          type: 'linear',
          position: 'left'
        }]
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(item) {
            return '(' + item.xLabel + ', ' + item.yLabel + ')';
          }
        }
      }
    });
    core_defaults._set('global', {
      datasets: {
        scatter: {
          showLine: false
        }
      }
    });
    var controller_scatter = controller_line;
    var controllers = {
      bar: controller_bar,
      bubble: controller_bubble,
      doughnut: controller_doughnut,
      horizontalBar: controller_horizontalBar,
      line: controller_line,
      polarArea: controller_polarArea,
      pie: controller_pie,
      radar: controller_radar,
      scatter: controller_scatter
    };
    function getRelativePosition(e, chart) {
      if (e["native"]) {
        return {
          x: e.x,
          y: e.y
        };
      }
      return helpers$1.getRelativePosition(e, chart);
    }
    function parseVisibleItems(chart, handler) {
      var metasets = chart._getSortedVisibleDatasetMetas();
      var metadata, i, j, ilen, jlen, element;
      for (i = 0, ilen = metasets.length; i < ilen; ++i) {
        metadata = metasets[i].data;
        for (j = 0, jlen = metadata.length; j < jlen; ++j) {
          element = metadata[j];
          if (!element._view.skip) {
            handler(element);
          }
        }
      }
    }
    function getIntersectItems(chart, position) {
      var elements = [];
      parseVisibleItems(chart, function (element) {
        if (element.inRange(position.x, position.y)) {
          elements.push(element);
        }
      });
      return elements;
    }
    function getNearestItems(chart, position, intersect, distanceMetric) {
      var minDistance = Number.POSITIVE_INFINITY;
      var nearestItems = [];
      parseVisibleItems(chart, function (element) {
        if (intersect && !element.inRange(position.x, position.y)) {
          return;
        }
        var center = element.getCenterPoint();
        var distance = distanceMetric(position, center);
        if (distance < minDistance) {
          nearestItems = [element];
          minDistance = distance;
        } else if (distance === minDistance) {
          nearestItems.push(element);
        }
      });
      return nearestItems;
    }
    function getDistanceMetricForAxis(axis) {
      var useX = axis.indexOf('x') !== -1;
      var useY = axis.indexOf('y') !== -1;
      return function (pt1, pt2) {
        var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
      };
    }
    function indexMode(chart, e, options) {
      var position = getRelativePosition(e, chart);
      options.axis = options.axis || 'x';
      var distanceMetric = getDistanceMetricForAxis(options.axis);
      var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
      var elements = [];
      if (!items.length) {
        return [];
      }
      chart._getSortedVisibleDatasetMetas().forEach(function (meta) {
        var element = meta.data[items[0]._index];
        if (element && !element._view.skip) {
          elements.push(element);
        }
      });
      return elements;
    }
    var core_interaction = {
      modes: {
        single: function single(chart, e) {
          var position = getRelativePosition(e, chart);
          var elements = [];
          parseVisibleItems(chart, function (element) {
            if (element.inRange(position.x, position.y)) {
              elements.push(element);
              return elements;
            }
          });
          return elements.slice(0, 1);
        },
        label: indexMode,
        index: indexMode,
        dataset: function dataset(chart, e, options) {
          var position = getRelativePosition(e, chart);
          options.axis = options.axis || 'xy';
          var distanceMetric = getDistanceMetricForAxis(options.axis);
          var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
          if (items.length > 0) {
            items = chart.getDatasetMeta(items[0]._datasetIndex).data;
          }
          return items;
        },
        'x-axis': function xAxis(chart, e) {
          return indexMode(chart, e, {
            intersect: false
          });
        },
        point: function point(chart, e) {
          var position = getRelativePosition(e, chart);
          return getIntersectItems(chart, position);
        },
        nearest: function nearest(chart, e, options) {
          var position = getRelativePosition(e, chart);
          options.axis = options.axis || 'xy';
          var distanceMetric = getDistanceMetricForAxis(options.axis);
          return getNearestItems(chart, position, options.intersect, distanceMetric);
        },
        x: function x(chart, e, options) {
          var position = getRelativePosition(e, chart);
          var items = [];
          var intersectsItem = false;
          parseVisibleItems(chart, function (element) {
            if (element.inXRange(position.x)) {
              items.push(element);
            }
            if (element.inRange(position.x, position.y)) {
              intersectsItem = true;
            }
          });
          if (options.intersect && !intersectsItem) {
            items = [];
          }
          return items;
        },
        y: function y(chart, e, options) {
          var position = getRelativePosition(e, chart);
          var items = [];
          var intersectsItem = false;
          parseVisibleItems(chart, function (element) {
            if (element.inYRange(position.y)) {
              items.push(element);
            }
            if (element.inRange(position.x, position.y)) {
              intersectsItem = true;
            }
          });
          if (options.intersect && !intersectsItem) {
            items = [];
          }
          return items;
        }
      }
    };
    var extend = helpers$1.extend;
    function filterByPosition(array, position) {
      return helpers$1.where(array, function (v) {
        return v.pos === position;
      });
    }
    function sortByWeight(array, reverse) {
      return array.sort(function (a, b) {
        var v0 = reverse ? b : a;
        var v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
      });
    }
    function wrapBoxes(boxes) {
      var layoutBoxes = [];
      var i, ilen, box;
      for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
        box = boxes[i];
        layoutBoxes.push({
          index: i,
          box: box,
          pos: box.position,
          horizontal: box.isHorizontal(),
          weight: box.weight
        });
      }
      return layoutBoxes;
    }
    function setLayoutDims(layouts, params) {
      var i, ilen, layout;
      for (i = 0, ilen = layouts.length; i < ilen; ++i) {
        layout = layouts[i];
        layout.width = layout.horizontal ? layout.box.fullWidth && params.availableWidth : params.vBoxMaxWidth;
        layout.height = layout.horizontal && params.hBoxMaxHeight;
      }
    }
    function buildLayoutBoxes(boxes) {
      var layoutBoxes = wrapBoxes(boxes);
      var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
      var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
      var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
      var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
      return {
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(bottom),
        chartArea: filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right),
        horizontal: top.concat(bottom)
      };
    }
    function getCombinedMax(maxPadding, chartArea, a, b) {
      return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
    }
    function updateDims(chartArea, params, layout) {
      var box = layout.box;
      var maxPadding = chartArea.maxPadding;
      var newWidth, newHeight;
      if (layout.size) {
        chartArea[layout.pos] -= layout.size;
      }
      layout.size = layout.horizontal ? box.height : box.width;
      chartArea[layout.pos] += layout.size;
      if (box.getPadding) {
        var boxPadding = box.getPadding();
        maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
        maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
        maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
        maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
      }
      newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
      newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
      if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
        chartArea.w = newWidth;
        chartArea.h = newHeight;
        var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
        return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
      }
    }
    function handleMaxPadding(chartArea) {
      var maxPadding = chartArea.maxPadding;
      function updatePos(pos) {
        var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
      }
      chartArea.y += updatePos('top');
      chartArea.x += updatePos('left');
      updatePos('right');
      updatePos('bottom');
    }
    function getMargins(horizontal, chartArea) {
      var maxPadding = chartArea.maxPadding;
      function marginForPositions(positions) {
        var margin = {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        };
        positions.forEach(function (pos) {
          margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
      }
      return horizontal ? marginForPositions(['left', 'right']) : marginForPositions(['top', 'bottom']);
    }
    function fitBoxes(boxes, chartArea, params) {
      var refitBoxes = [];
      var i, ilen, layout, box, refit, changed;
      for (i = 0, ilen = boxes.length; i < ilen; ++i) {
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
        if (updateDims(chartArea, params, layout)) {
          changed = true;
          if (refitBoxes.length) {
            refit = true;
          }
        }
        if (!box.fullWidth) {
          refitBoxes.push(layout);
        }
      }
      return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
    }
    function placeBoxes(boxes, chartArea, params) {
      var userPadding = params.padding;
      var x = chartArea.x;
      var y = chartArea.y;
      var i, ilen, layout, box;
      for (i = 0, ilen = boxes.length; i < ilen; ++i) {
        layout = boxes[i];
        box = layout.box;
        if (layout.horizontal) {
          box.left = box.fullWidth ? userPadding.left : chartArea.left;
          box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
          box.top = y;
          box.bottom = y + box.height;
          box.width = box.right - box.left;
          y = box.bottom;
        } else {
          box.left = x;
          box.right = x + box.width;
          box.top = chartArea.top;
          box.bottom = chartArea.top + chartArea.h;
          box.height = box.bottom - box.top;
          x = box.right;
        }
      }
      chartArea.x = x;
      chartArea.y = y;
    }
    core_defaults._set('global', {
      layout: {
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      }
    });
    var core_layouts = {
      defaults: {},
      addBox: function addBox(chart, item) {
        if (!chart.boxes) {
          chart.boxes = [];
        }
        item.fullWidth = item.fullWidth || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function () {
          return [{
            z: 0,
            draw: function draw() {
              item.draw.apply(item, arguments);
            }
          }];
        };
        chart.boxes.push(item);
      },
      removeBox: function removeBox(chart, layoutItem) {
        var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) {
          chart.boxes.splice(index, 1);
        }
      },
      configure: function configure(chart, item, options) {
        var props = ['fullWidth', 'position', 'weight'];
        var ilen = props.length;
        var i = 0;
        var prop;
        for (; i < ilen; ++i) {
          prop = props[i];
          if (options.hasOwnProperty(prop)) {
            item[prop] = options[prop];
          }
        }
      },
      update: function update(chart, width, height) {
        if (!chart) {
          return;
        }
        var layoutOptions = chart.options.layout || {};
        var padding = helpers$1.options.toPadding(layoutOptions.padding);
        var availableWidth = width - padding.width;
        var availableHeight = height - padding.height;
        var boxes = buildLayoutBoxes(chart.boxes);
        var verticalBoxes = boxes.vertical;
        var horizontalBoxes = boxes.horizontal;
        var params = Object.freeze({
          outerWidth: width,
          outerHeight: height,
          padding: padding,
          availableWidth: availableWidth,
          vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
          hBoxMaxHeight: availableHeight / 2
        });
        var chartArea = extend({
          maxPadding: extend({}, padding),
          w: availableWidth,
          h: availableHeight,
          x: padding.left,
          y: padding.top
        }, padding);
        setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        fitBoxes(verticalBoxes, chartArea, params);
        if (fitBoxes(horizontalBoxes, chartArea, params)) {
          fitBoxes(verticalBoxes, chartArea, params);
        }
        handleMaxPadding(chartArea);
        placeBoxes(boxes.leftAndTop, chartArea, params);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        placeBoxes(boxes.rightAndBottom, chartArea, params);
        chart.chartArea = {
          left: chartArea.left,
          top: chartArea.top,
          right: chartArea.left + chartArea.w,
          bottom: chartArea.top + chartArea.h
        };
        helpers$1.each(boxes.chartArea, function (layout) {
          var box = layout.box;
          extend(box, chart.chartArea);
          box.update(chartArea.w, chartArea.h);
        });
      }
    };
    var platform_basic = {
      acquireContext: function acquireContext(item) {
        if (item && item.canvas) {
          item = item.canvas;
        }
        return item && item.getContext('2d') || null;
      }
    };
    var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";
    var platform_dom$1 = /*#__PURE__*/Object.freeze({
      __proto__: null,
      'default': platform_dom
    });
    var stylesheet = getCjsExportFromNamespace(platform_dom$1);
    var EXPANDO_KEY = '$chartjs';
    var CSS_PREFIX = 'chartjs-';
    var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
    var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
    var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
    var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];
    var EVENT_TYPES = {
      touchstart: 'mousedown',
      touchmove: 'mousemove',
      touchend: 'mouseup',
      pointerenter: 'mouseenter',
      pointerdown: 'mousedown',
      pointermove: 'mousemove',
      pointerup: 'mouseup',
      pointerleave: 'mouseout',
      pointerout: 'mouseout'
    };
    function readUsedSize(element, property) {
      var value = helpers$1.getStyle(element, property);
      var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
      return matches ? Number(matches[1]) : undefined;
    }
    function initCanvas(canvas, config) {
      var style = canvas.style;
      var renderHeight = canvas.getAttribute('height');
      var renderWidth = canvas.getAttribute('width');
      canvas[EXPANDO_KEY] = {
        initial: {
          height: renderHeight,
          width: renderWidth,
          style: {
            display: style.display,
            height: style.height,
            width: style.width
          }
        }
      };
      style.display = style.display || 'block';
      if (renderWidth === null || renderWidth === '') {
        var displayWidth = readUsedSize(canvas, 'width');
        if (displayWidth !== undefined) {
          canvas.width = displayWidth;
        }
      }
      if (renderHeight === null || renderHeight === '') {
        if (canvas.style.height === '') {
          canvas.height = canvas.width / (config.options.aspectRatio || 2);
        } else {
          var displayHeight = readUsedSize(canvas, 'height');
          if (displayWidth !== undefined) {
            canvas.height = displayHeight;
          }
        }
      }
      return canvas;
    }
    var supportsEventListenerOptions = function () {
      var supports = false;
      try {
        var options = Object.defineProperty({}, 'passive', {
          get: function get() {
            supports = true;
          }
        });
        window.addEventListener('e', null, options);
      } catch (e) {}
      return supports;
    }();
    var eventListenerOptions = supportsEventListenerOptions ? {
      passive: true
    } : false;
    function addListener(node, type, listener) {
      node.addEventListener(type, listener, eventListenerOptions);
    }
    function removeListener(node, type, listener) {
      node.removeEventListener(type, listener, eventListenerOptions);
    }
    function createEvent(type, chart, x, y, nativeEvent) {
      return {
        type: type,
        chart: chart,
        "native": nativeEvent || null,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
      };
    }
    function fromNativeEvent(event, chart) {
      var type = EVENT_TYPES[event.type] || event.type;
      var pos = helpers$1.getRelativePosition(event, chart);
      return createEvent(type, chart, pos.x, pos.y, event);
    }
    function throttled(fn, thisArg) {
      var ticking = false;
      var args = [];
      return function () {
        args = Array.prototype.slice.call(arguments);
        thisArg = thisArg || this;
        if (!ticking) {
          ticking = true;
          helpers$1.requestAnimFrame.call(window, function () {
            ticking = false;
            fn.apply(thisArg, args);
          });
        }
      };
    }
    function createDiv(cls) {
      var el = document.createElement('div');
      el.className = cls || '';
      return el;
    }
    function createResizer(handler) {
      var maxSize = 1000000;
      var resizer = createDiv(CSS_SIZE_MONITOR);
      var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
      var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
      expand.appendChild(createDiv());
      shrink.appendChild(createDiv());
      resizer.appendChild(expand);
      resizer.appendChild(shrink);
      resizer._reset = function () {
        expand.scrollLeft = maxSize;
        expand.scrollTop = maxSize;
        shrink.scrollLeft = maxSize;
        shrink.scrollTop = maxSize;
      };
      var onScroll = function onScroll() {
        resizer._reset();
        handler();
      };
      addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
      addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
      return resizer;
    }
    function watchForRender(node, handler) {
      var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
      var proxy = expando.renderProxy = function (e) {
        if (e.animationName === CSS_RENDER_ANIMATION) {
          handler();
        }
      };
      helpers$1.each(ANIMATION_START_EVENTS, function (type) {
        addListener(node, type, proxy);
      });
      expando.reflow = !!node.offsetParent;
      node.classList.add(CSS_RENDER_MONITOR);
    }
    function unwatchForRender(node) {
      var expando = node[EXPANDO_KEY] || {};
      var proxy = expando.renderProxy;
      if (proxy) {
        helpers$1.each(ANIMATION_START_EVENTS, function (type) {
          removeListener(node, type, proxy);
        });
        delete expando.renderProxy;
      }
      node.classList.remove(CSS_RENDER_MONITOR);
    }
    function addResizeListener(node, listener, chart) {
      var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
      var resizer = expando.resizer = createResizer(throttled(function () {
        if (expando.resizer) {
          var container = chart.options.maintainAspectRatio && node.parentNode;
          var w = container ? container.clientWidth : 0;
          listener(createEvent('resize', chart));
          if (container && container.clientWidth < w && chart.canvas) {
            listener(createEvent('resize', chart));
          }
        }
      }));
      watchForRender(node, function () {
        if (expando.resizer) {
          var container = node.parentNode;
          if (container && container !== resizer.parentNode) {
            container.insertBefore(resizer, container.firstChild);
          }
          resizer._reset();
        }
      });
    }
    function removeResizeListener(node) {
      var expando = node[EXPANDO_KEY] || {};
      var resizer = expando.resizer;
      delete expando.resizer;
      unwatchForRender(node);
      if (resizer && resizer.parentNode) {
        resizer.parentNode.removeChild(resizer);
      }
    }
    function injectCSS(rootNode, css) {
      var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
      if (!expando.containsStyles) {
        expando.containsStyles = true;
        css = '/* Chart.js */\n' + css;
        var style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        style.appendChild(document.createTextNode(css));
        rootNode.appendChild(style);
      }
    }
    var platform_dom$2 = {
      disableCSSInjection: false,
      _enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
      _ensureLoaded: function _ensureLoaded(canvas) {
        if (!this.disableCSSInjection) {
          var root = canvas.getRootNode ? canvas.getRootNode() : document;
          var targetNode = root.host ? root : document.head;
          injectCSS(targetNode, stylesheet);
        }
      },
      acquireContext: function acquireContext(item, config) {
        if (typeof item === 'string') {
          item = document.getElementById(item);
        } else if (item.length) {
          item = item[0];
        }
        if (item && item.canvas) {
          item = item.canvas;
        }
        var context = item && item.getContext && item.getContext('2d');
        if (context && context.canvas === item) {
          this._ensureLoaded(item);
          initCanvas(item, config);
          return context;
        }
        return null;
      },
      releaseContext: function releaseContext(context) {
        var canvas = context.canvas;
        if (!canvas[EXPANDO_KEY]) {
          return;
        }
        var initial = canvas[EXPANDO_KEY].initial;
        ['height', 'width'].forEach(function (prop) {
          var value = initial[prop];
          if (helpers$1.isNullOrUndef(value)) {
            canvas.removeAttribute(prop);
          } else {
            canvas.setAttribute(prop, value);
          }
        });
        helpers$1.each(initial.style || {}, function (value, key) {
          canvas.style[key] = value;
        });
        canvas.width = canvas.width;
        delete canvas[EXPANDO_KEY];
      },
      addEventListener: function addEventListener(chart, type, listener) {
        var canvas = chart.canvas;
        if (type === 'resize') {
          addResizeListener(canvas, listener, chart);
          return;
        }
        var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
        var proxies = expando.proxies || (expando.proxies = {});
        var proxy = proxies[chart.id + '_' + type] = function (event) {
          listener(fromNativeEvent(event, chart));
        };
        addListener(canvas, type, proxy);
      },
      removeEventListener: function removeEventListener(chart, type, listener) {
        var canvas = chart.canvas;
        if (type === 'resize') {
          removeResizeListener(canvas);
          return;
        }
        var expando = listener[EXPANDO_KEY] || {};
        var proxies = expando.proxies || {};
        var proxy = proxies[chart.id + '_' + type];
        if (!proxy) {
          return;
        }
        removeListener(canvas, type, proxy);
      }
    };
    helpers$1.addEvent = addListener;
    helpers$1.removeEvent = removeListener;
    var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
    var platform = helpers$1.extend({
      initialize: function initialize() {},
      acquireContext: function acquireContext() {},
      releaseContext: function releaseContext() {},
      addEventListener: function addEventListener() {},
      removeEventListener: function removeEventListener() {}
    }, implementation);
    core_defaults._set('global', {
      plugins: {}
    });
    var core_plugins = {
      _plugins: [],
      _cacheId: 0,
      register: function register(plugins) {
        var p = this._plugins;
        [].concat(plugins).forEach(function (plugin) {
          if (p.indexOf(plugin) === -1) {
            p.push(plugin);
          }
        });
        this._cacheId++;
      },
      unregister: function unregister(plugins) {
        var p = this._plugins;
        [].concat(plugins).forEach(function (plugin) {
          var idx = p.indexOf(plugin);
          if (idx !== -1) {
            p.splice(idx, 1);
          }
        });
        this._cacheId++;
      },
      clear: function clear() {
        this._plugins = [];
        this._cacheId++;
      },
      count: function count() {
        return this._plugins.length;
      },
      getAll: function getAll() {
        return this._plugins;
      },
      notify: function notify(chart, hook, args) {
        var descriptors = this.descriptors(chart);
        var ilen = descriptors.length;
        var i, descriptor, plugin, params, method;
        for (i = 0; i < ilen; ++i) {
          descriptor = descriptors[i];
          plugin = descriptor.plugin;
          method = plugin[hook];
          if (typeof method === 'function') {
            params = [chart].concat(args || []);
            params.push(descriptor.options);
            if (method.apply(plugin, params) === false) {
              return false;
            }
          }
        }
        return true;
      },
      descriptors: function descriptors(chart) {
        var cache = chart.$plugins || (chart.$plugins = {});
        if (cache.id === this._cacheId) {
          return cache.descriptors;
        }
        var plugins = [];
        var descriptors = [];
        var config = chart && chart.config || {};
        var options = config.options && config.options.plugins || {};
        this._plugins.concat(config.plugins || []).forEach(function (plugin) {
          var idx = plugins.indexOf(plugin);
          if (idx !== -1) {
            return;
          }
          var id = plugin.id;
          var opts = options[id];
          if (opts === false) {
            return;
          }
          if (opts === true) {
            opts = helpers$1.clone(core_defaults.global.plugins[id]);
          }
          plugins.push(plugin);
          descriptors.push({
            plugin: plugin,
            options: opts || {}
          });
        });
        cache.descriptors = descriptors;
        cache.id = this._cacheId;
        return descriptors;
      },
      _invalidate: function _invalidate(chart) {
        delete chart.$plugins;
      }
    };
    var core_scaleService = {
      constructors: {},
      defaults: {},
      registerScaleType: function registerScaleType(type, scaleConstructor, scaleDefaults) {
        this.constructors[type] = scaleConstructor;
        this.defaults[type] = helpers$1.clone(scaleDefaults);
      },
      getScaleConstructor: function getScaleConstructor(type) {
        return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
      },
      getScaleDefaults: function getScaleDefaults(type) {
        return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
      },
      updateScaleDefaults: function updateScaleDefaults(type, additions) {
        var me = this;
        if (me.defaults.hasOwnProperty(type)) {
          me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
        }
      },
      addScalesToLayout: function addScalesToLayout(chart) {
        helpers$1.each(chart.scales, function (scale) {
          scale.fullWidth = scale.options.fullWidth;
          scale.position = scale.options.position;
          scale.weight = scale.options.weight;
          core_layouts.addBox(chart, scale);
        });
      }
    };
    var valueOrDefault$8 = helpers$1.valueOrDefault;
    var getRtlHelper = helpers$1.rtl.getRtlAdapter;
    core_defaults._set('global', {
      tooltips: {
        enabled: true,
        custom: null,
        mode: 'nearest',
        position: 'average',
        intersect: true,
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleFontStyle: 'bold',
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleFontColor: '#fff',
        titleAlign: 'left',
        bodySpacing: 2,
        bodyFontColor: '#fff',
        bodyAlign: 'left',
        footerFontStyle: 'bold',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFontColor: '#fff',
        footerAlign: 'left',
        yPadding: 6,
        xPadding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        multiKeyBackground: '#fff',
        displayColors: true,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        callbacks: {
          beforeTitle: helpers$1.noop,
          title: function title(tooltipItems, data) {
            var title = '';
            var labels = data.labels;
            var labelCount = labels ? labels.length : 0;
            if (tooltipItems.length > 0) {
              var item = tooltipItems[0];
              if (item.label) {
                title = item.label;
              } else if (item.xLabel) {
                title = item.xLabel;
              } else if (labelCount > 0 && item.index < labelCount) {
                title = labels[item.index];
              }
            }
            return title;
          },
          afterTitle: helpers$1.noop,
          beforeBody: helpers$1.noop,
          beforeLabel: helpers$1.noop,
          label: function label(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label || '';
            if (label) {
              label += ': ';
            }
            if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
              label += tooltipItem.value;
            } else {
              label += tooltipItem.yLabel;
            }
            return label;
          },
          labelColor: function labelColor(tooltipItem, chart) {
            var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
            var activeElement = meta.data[tooltipItem.index];
            var view = activeElement._view;
            return {
              borderColor: view.borderColor,
              backgroundColor: view.backgroundColor
            };
          },
          labelTextColor: function labelTextColor() {
            return this._options.bodyFontColor;
          },
          afterLabel: helpers$1.noop,
          afterBody: helpers$1.noop,
          beforeFooter: helpers$1.noop,
          footer: helpers$1.noop,
          afterFooter: helpers$1.noop
        }
      }
    });
    var positioners = {
      average: function average(elements) {
        if (!elements.length) {
          return false;
        }
        var i, len;
        var x = 0;
        var y = 0;
        var count = 0;
        for (i = 0, len = elements.length; i < len; ++i) {
          var el = elements[i];
          if (el && el.hasValue()) {
            var pos = el.tooltipPosition();
            x += pos.x;
            y += pos.y;
            ++count;
          }
        }
        return {
          x: x / count,
          y: y / count
        };
      },
      nearest: function nearest(elements, eventPosition) {
        var x = eventPosition.x;
        var y = eventPosition.y;
        var minDistance = Number.POSITIVE_INFINITY;
        var i, len, nearestElement;
        for (i = 0, len = elements.length; i < len; ++i) {
          var el = elements[i];
          if (el && el.hasValue()) {
            var center = el.getCenterPoint();
            var d = helpers$1.distanceBetweenPoints(eventPosition, center);
            if (d < minDistance) {
              minDistance = d;
              nearestElement = el;
            }
          }
        }
        if (nearestElement) {
          var tp = nearestElement.tooltipPosition();
          x = tp.x;
          y = tp.y;
        }
        return {
          x: x,
          y: y
        };
      }
    };
    function pushOrConcat(base, toPush) {
      if (toPush) {
        if (helpers$1.isArray(toPush)) {
          Array.prototype.push.apply(base, toPush);
        } else {
          base.push(toPush);
        }
      }
      return base;
    }
    function splitNewlines(str) {
      if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
        return str.split('\n');
      }
      return str;
    }
    function createTooltipItem(element) {
      var xScale = element._xScale;
      var yScale = element._yScale || element._scale;
      var index = element._index;
      var datasetIndex = element._datasetIndex;
      var controller = element._chart.getDatasetMeta(datasetIndex).controller;
      var indexScale = controller._getIndexScale();
      var valueScale = controller._getValueScale();
      return {
        xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
        yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
        label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
        value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
        index: index,
        datasetIndex: datasetIndex,
        x: element._model.x,
        y: element._model.y
      };
    }
    function getBaseModel(tooltipOpts) {
      var globalDefaults = core_defaults.global;
      return {
        xPadding: tooltipOpts.xPadding,
        yPadding: tooltipOpts.yPadding,
        xAlign: tooltipOpts.xAlign,
        yAlign: tooltipOpts.yAlign,
        rtl: tooltipOpts.rtl,
        textDirection: tooltipOpts.textDirection,
        bodyFontColor: tooltipOpts.bodyFontColor,
        _bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
        _bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
        _bodyAlign: tooltipOpts.bodyAlign,
        bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
        bodySpacing: tooltipOpts.bodySpacing,
        titleFontColor: tooltipOpts.titleFontColor,
        _titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
        _titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
        titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
        _titleAlign: tooltipOpts.titleAlign,
        titleSpacing: tooltipOpts.titleSpacing,
        titleMarginBottom: tooltipOpts.titleMarginBottom,
        footerFontColor: tooltipOpts.footerFontColor,
        _footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
        _footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
        footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
        _footerAlign: tooltipOpts.footerAlign,
        footerSpacing: tooltipOpts.footerSpacing,
        footerMarginTop: tooltipOpts.footerMarginTop,
        caretSize: tooltipOpts.caretSize,
        cornerRadius: tooltipOpts.cornerRadius,
        backgroundColor: tooltipOpts.backgroundColor,
        opacity: 0,
        legendColorBackground: tooltipOpts.multiKeyBackground,
        displayColors: tooltipOpts.displayColors,
        borderColor: tooltipOpts.borderColor,
        borderWidth: tooltipOpts.borderWidth
      };
    }
    function getTooltipSize(tooltip, model) {
      var ctx = tooltip._chart.ctx;
      var height = model.yPadding * 2;
      var width = 0;
      var body = model.body;
      var combinedBodyLength = body.reduce(function (count, bodyItem) {
        return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
      }, 0);
      combinedBodyLength += model.beforeBody.length + model.afterBody.length;
      var titleLineCount = model.title.length;
      var footerLineCount = model.footer.length;
      var titleFontSize = model.titleFontSize;
      var bodyFontSize = model.bodyFontSize;
      var footerFontSize = model.footerFontSize;
      height += titleLineCount * titleFontSize;
      height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0;
      height += titleLineCount ? model.titleMarginBottom : 0;
      height += combinedBodyLength * bodyFontSize;
      height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0;
      height += footerLineCount ? model.footerMarginTop : 0;
      height += footerLineCount * footerFontSize;
      height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0;
      var widthPadding = 0;
      var maxLineWidth = function maxLineWidth(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
      };
      ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
      helpers$1.each(model.title, maxLineWidth);
      ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
      helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
      widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
      helpers$1.each(body, function (bodyItem) {
        helpers$1.each(bodyItem.before, maxLineWidth);
        helpers$1.each(bodyItem.lines, maxLineWidth);
        helpers$1.each(bodyItem.after, maxLineWidth);
      });
      widthPadding = 0;
      ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
      helpers$1.each(model.footer, maxLineWidth);
      width += 2 * model.xPadding;
      return {
        width: width,
        height: height
      };
    }
    function determineAlignment(tooltip, size) {
      var model = tooltip._model;
      var chart = tooltip._chart;
      var chartArea = tooltip._chart.chartArea;
      var xAlign = 'center';
      var yAlign = 'center';
      if (model.y < size.height) {
        yAlign = 'top';
      } else if (model.y > chart.height - size.height) {
        yAlign = 'bottom';
      }
      var lf, rf;
      var olf, orf;
      var yf;
      var midX = (chartArea.left + chartArea.right) / 2;
      var midY = (chartArea.top + chartArea.bottom) / 2;
      if (yAlign === 'center') {
        lf = function lf(x) {
          return x <= midX;
        };
        rf = function rf(x) {
          return x > midX;
        };
      } else {
        lf = function lf(x) {
          return x <= size.width / 2;
        };
        rf = function rf(x) {
          return x >= chart.width - size.width / 2;
        };
      }
      olf = function olf(x) {
        return x + size.width + model.caretSize + model.caretPadding > chart.width;
      };
      orf = function orf(x) {
        return x - size.width - model.caretSize - model.caretPadding < 0;
      };
      yf = function yf(y) {
        return y <= midY ? 'top' : 'bottom';
      };
      if (lf(model.x)) {
        xAlign = 'left';
        if (olf(model.x)) {
          xAlign = 'center';
          yAlign = yf(model.y);
        }
      } else if (rf(model.x)) {
        xAlign = 'right';
        if (orf(model.x)) {
          xAlign = 'center';
          yAlign = yf(model.y);
        }
      }
      var opts = tooltip._options;
      return {
        xAlign: opts.xAlign ? opts.xAlign : xAlign,
        yAlign: opts.yAlign ? opts.yAlign : yAlign
      };
    }
    function getBackgroundPoint(vm, size, alignment, chart) {
      var x = vm.x;
      var y = vm.y;
      var caretSize = vm.caretSize;
      var caretPadding = vm.caretPadding;
      var cornerRadius = vm.cornerRadius;
      var xAlign = alignment.xAlign;
      var yAlign = alignment.yAlign;
      var paddingAndSize = caretSize + caretPadding;
      var radiusAndPadding = cornerRadius + caretPadding;
      if (xAlign === 'right') {
        x -= size.width;
      } else if (xAlign === 'center') {
        x -= size.width / 2;
        if (x + size.width > chart.width) {
          x = chart.width - size.width;
        }
        if (x < 0) {
          x = 0;
        }
      }
      if (yAlign === 'top') {
        y += paddingAndSize;
      } else if (yAlign === 'bottom') {
        y -= size.height + paddingAndSize;
      } else {
        y -= size.height / 2;
      }
      if (yAlign === 'center') {
        if (xAlign === 'left') {
          x += paddingAndSize;
        } else if (xAlign === 'right') {
          x -= paddingAndSize;
        }
      } else if (xAlign === 'left') {
        x -= radiusAndPadding;
      } else if (xAlign === 'right') {
        x += radiusAndPadding;
      }
      return {
        x: x,
        y: y
      };
    }
    function getAlignedX(vm, align) {
      return align === 'center' ? vm.x + vm.width / 2 : align === 'right' ? vm.x + vm.width - vm.xPadding : vm.x + vm.xPadding;
    }
    function getBeforeAfterBodyLines(callback) {
      return pushOrConcat([], splitNewlines(callback));
    }
    var exports$4 = core_element.extend({
      initialize: function initialize() {
        this._model = getBaseModel(this._options);
        this._lastActive = [];
      },
      getTitle: function getTitle() {
        var me = this;
        var opts = me._options;
        var callbacks = opts.callbacks;
        var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
        var title = callbacks.title.apply(me, arguments);
        var afterTitle = callbacks.afterTitle.apply(me, arguments);
        var lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeTitle));
        lines = pushOrConcat(lines, splitNewlines(title));
        lines = pushOrConcat(lines, splitNewlines(afterTitle));
        return lines;
      },
      getBeforeBody: function getBeforeBody() {
        return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
      },
      getBody: function getBody(tooltipItems, data) {
        var me = this;
        var callbacks = me._options.callbacks;
        var bodyItems = [];
        helpers$1.each(tooltipItems, function (tooltipItem) {
          var bodyItem = {
            before: [],
            lines: [],
            after: []
          };
          pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
          pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
          pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
          bodyItems.push(bodyItem);
        });
        return bodyItems;
      },
      getAfterBody: function getAfterBody() {
        return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
      },
      getFooter: function getFooter() {
        var me = this;
        var callbacks = me._options.callbacks;
        var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
        var footer = callbacks.footer.apply(me, arguments);
        var afterFooter = callbacks.afterFooter.apply(me, arguments);
        var lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeFooter));
        lines = pushOrConcat(lines, splitNewlines(footer));
        lines = pushOrConcat(lines, splitNewlines(afterFooter));
        return lines;
      },
      update: function update(changed) {
        var me = this;
        var opts = me._options;
        var existingModel = me._model;
        var model = me._model = getBaseModel(opts);
        var active = me._active;
        var data = me._data;
        var alignment = {
          xAlign: existingModel.xAlign,
          yAlign: existingModel.yAlign
        };
        var backgroundPoint = {
          x: existingModel.x,
          y: existingModel.y
        };
        var tooltipSize = {
          width: existingModel.width,
          height: existingModel.height
        };
        var tooltipPosition = {
          x: existingModel.caretX,
          y: existingModel.caretY
        };
        var i, len;
        if (active.length) {
          model.opacity = 1;
          var labelColors = [];
          var labelTextColors = [];
          tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
          var tooltipItems = [];
          for (i = 0, len = active.length; i < len; ++i) {
            tooltipItems.push(createTooltipItem(active[i]));
          }
          if (opts.filter) {
            tooltipItems = tooltipItems.filter(function (a) {
              return opts.filter(a, data);
            });
          }
          if (opts.itemSort) {
            tooltipItems = tooltipItems.sort(function (a, b) {
              return opts.itemSort(a, b, data);
            });
          }
          helpers$1.each(tooltipItems, function (tooltipItem) {
            labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
            labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
          });
          model.title = me.getTitle(tooltipItems, data);
          model.beforeBody = me.getBeforeBody(tooltipItems, data);
          model.body = me.getBody(tooltipItems, data);
          model.afterBody = me.getAfterBody(tooltipItems, data);
          model.footer = me.getFooter(tooltipItems, data);
          model.x = tooltipPosition.x;
          model.y = tooltipPosition.y;
          model.caretPadding = opts.caretPadding;
          model.labelColors = labelColors;
          model.labelTextColors = labelTextColors;
          model.dataPoints = tooltipItems;
          tooltipSize = getTooltipSize(this, model);
          alignment = determineAlignment(this, tooltipSize);
          backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
        } else {
          model.opacity = 0;
        }
        model.xAlign = alignment.xAlign;
        model.yAlign = alignment.yAlign;
        model.x = backgroundPoint.x;
        model.y = backgroundPoint.y;
        model.width = tooltipSize.width;
        model.height = tooltipSize.height;
        model.caretX = tooltipPosition.x;
        model.caretY = tooltipPosition.y;
        me._model = model;
        if (changed && opts.custom) {
          opts.custom.call(me, model);
        }
        return me;
      },
      drawCaret: function drawCaret(tooltipPoint, size) {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
      },
      getCaretPosition: function getCaretPosition(tooltipPoint, size, vm) {
        var x1, x2, x3, y1, y2, y3;
        var caretSize = vm.caretSize;
        var cornerRadius = vm.cornerRadius;
        var xAlign = vm.xAlign;
        var yAlign = vm.yAlign;
        var ptX = tooltipPoint.x;
        var ptY = tooltipPoint.y;
        var width = size.width;
        var height = size.height;
        if (yAlign === 'center') {
          y2 = ptY + height / 2;
          if (xAlign === 'left') {
            x1 = ptX;
            x2 = x1 - caretSize;
            x3 = x1;
            y1 = y2 + caretSize;
            y3 = y2 - caretSize;
          } else {
            x1 = ptX + width;
            x2 = x1 + caretSize;
            x3 = x1;
            y1 = y2 - caretSize;
            y3 = y2 + caretSize;
          }
        } else {
          if (xAlign === 'left') {
            x2 = ptX + cornerRadius + caretSize;
            x1 = x2 - caretSize;
            x3 = x2 + caretSize;
          } else if (xAlign === 'right') {
            x2 = ptX + width - cornerRadius - caretSize;
            x1 = x2 - caretSize;
            x3 = x2 + caretSize;
          } else {
            x2 = vm.caretX;
            x1 = x2 - caretSize;
            x3 = x2 + caretSize;
          }
          if (yAlign === 'top') {
            y1 = ptY;
            y2 = y1 - caretSize;
            y3 = y1;
          } else {
            y1 = ptY + height;
            y2 = y1 + caretSize;
            y3 = y1;
            var tmp = x3;
            x3 = x1;
            x1 = tmp;
          }
        }
        return {
          x1: x1,
          x2: x2,
          x3: x3,
          y1: y1,
          y2: y2,
          y3: y3
        };
      },
      drawTitle: function drawTitle(pt, vm, ctx) {
        var title = vm.title;
        var length = title.length;
        var titleFontSize, titleSpacing, i;
        if (length) {
          var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
          pt.x = getAlignedX(vm, vm._titleAlign);
          ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
          ctx.textBaseline = 'middle';
          titleFontSize = vm.titleFontSize;
          titleSpacing = vm.titleSpacing;
          ctx.fillStyle = vm.titleFontColor;
          ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
          for (i = 0; i < length; ++i) {
            ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
            pt.y += titleFontSize + titleSpacing;
            if (i + 1 === length) {
              pt.y += vm.titleMarginBottom - titleSpacing;
            }
          }
        }
      },
      drawBody: function drawBody(pt, vm, ctx) {
        var bodyFontSize = vm.bodyFontSize;
        var bodySpacing = vm.bodySpacing;
        var bodyAlign = vm._bodyAlign;
        var body = vm.body;
        var drawColorBoxes = vm.displayColors;
        var xLinePadding = 0;
        var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
        var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
        var fillLineOfText = function fillLineOfText(line) {
          ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
          pt.y += bodyFontSize + bodySpacing;
        };
        var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
        var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
        pt.x = getAlignedX(vm, bodyAlignForCalculation);
        ctx.fillStyle = vm.bodyFontColor;
        helpers$1.each(vm.beforeBody, fillLineOfText);
        xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? bodyFontSize / 2 + 1 : bodyFontSize + 2 : 0;
        for (i = 0, ilen = body.length; i < ilen; ++i) {
          bodyItem = body[i];
          textColor = vm.labelTextColors[i];
          labelColors = vm.labelColors[i];
          ctx.fillStyle = textColor;
          helpers$1.each(bodyItem.before, fillLineOfText);
          lines = bodyItem.lines;
          for (j = 0, jlen = lines.length; j < jlen; ++j) {
            if (drawColorBoxes) {
              var rtlColorX = rtlHelper.x(colorX);
              ctx.fillStyle = vm.legendColorBackground;
              ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
              ctx.lineWidth = 1;
              ctx.strokeStyle = labelColors.borderColor;
              ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
              ctx.fillStyle = labelColors.backgroundColor;
              ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
              ctx.fillStyle = textColor;
            }
            fillLineOfText(lines[j]);
          }
          helpers$1.each(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        helpers$1.each(vm.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
      },
      drawFooter: function drawFooter(pt, vm, ctx) {
        var footer = vm.footer;
        var length = footer.length;
        var footerFontSize, i;
        if (length) {
          var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
          pt.x = getAlignedX(vm, vm._footerAlign);
          pt.y += vm.footerMarginTop;
          ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
          ctx.textBaseline = 'middle';
          footerFontSize = vm.footerFontSize;
          ctx.fillStyle = vm.footerFontColor;
          ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
          for (i = 0; i < length; ++i) {
            ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
            pt.y += footerFontSize + vm.footerSpacing;
          }
        }
      },
      drawBackground: function drawBackground(pt, vm, ctx, tooltipSize) {
        ctx.fillStyle = vm.backgroundColor;
        ctx.strokeStyle = vm.borderColor;
        ctx.lineWidth = vm.borderWidth;
        var xAlign = vm.xAlign;
        var yAlign = vm.yAlign;
        var x = pt.x;
        var y = pt.y;
        var width = tooltipSize.width;
        var height = tooltipSize.height;
        var radius = vm.cornerRadius;
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        if (yAlign === 'top') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        if (yAlign === 'center' && xAlign === 'right') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        if (yAlign === 'bottom') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        if (yAlign === 'center' && xAlign === 'left') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
        ctx.fill();
        if (vm.borderWidth > 0) {
          ctx.stroke();
        }
      },
      draw: function draw() {
        var ctx = this._chart.ctx;
        var vm = this._view;
        if (vm.opacity === 0) {
          return;
        }
        var tooltipSize = {
          width: vm.width,
          height: vm.height
        };
        var pt = {
          x: vm.x,
          y: vm.y
        };
        var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
        var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
        if (this._options.enabled && hasTooltipContent) {
          ctx.save();
          ctx.globalAlpha = opacity;
          this.drawBackground(pt, vm, ctx, tooltipSize);
          pt.y += vm.yPadding;
          helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
          this.drawTitle(pt, vm, ctx);
          this.drawBody(pt, vm, ctx);
          this.drawFooter(pt, vm, ctx);
          helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
          ctx.restore();
        }
      },
      handleEvent: function handleEvent(e) {
        var me = this;
        var options = me._options;
        var changed = false;
        me._lastActive = me._lastActive || [];
        if (e.type === 'mouseout') {
          me._active = [];
        } else {
          me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
          if (options.reverse) {
            me._active.reverse();
          }
        }
        changed = !helpers$1.arrayEquals(me._active, me._lastActive);
        if (changed) {
          me._lastActive = me._active;
          if (options.enabled || options.custom) {
            me._eventPosition = {
              x: e.x,
              y: e.y
            };
            me.update(true);
            me.pivot();
          }
        }
        return changed;
      }
    });
    var positioners_1 = positioners;
    var core_tooltip = exports$4;
    core_tooltip.positioners = positioners_1;
    var valueOrDefault$9 = helpers$1.valueOrDefault;
    core_defaults._set('global', {
      elements: {},
      events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
      hover: {
        onHover: null,
        mode: 'nearest',
        intersect: true,
        animationDuration: 400
      },
      onClick: null,
      maintainAspectRatio: true,
      responsive: true,
      responsiveAnimationDuration: 0
    });
    function mergeScaleConfig() {
      return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
        merger: function merger(key, target, source, options) {
          if (key === 'xAxes' || key === 'yAxes') {
            var slen = source[key].length;
            var i, type, scale;
            if (!target[key]) {
              target[key] = [];
            }
            for (i = 0; i < slen; ++i) {
              scale = source[key][i];
              type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
              if (i >= target[key].length) {
                target[key].push({});
              }
              if (!target[key][i].type || scale.type && scale.type !== target[key][i].type) {
                helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
              } else {
                helpers$1.merge(target[key][i], scale);
              }
            }
          } else {
            helpers$1._merger(key, target, source, options);
          }
        }
      });
    }
    function mergeConfig() {
      return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
        merger: function merger(key, target, source, options) {
          var tval = target[key] || Object.create(null);
          var sval = source[key];
          if (key === 'scales') {
            target[key] = mergeScaleConfig(tval, sval);
          } else if (key === 'scale') {
            target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
          } else {
            helpers$1._merger(key, target, source, options);
          }
        }
      });
    }
    function initConfig(config) {
      config = config || Object.create(null);
      var data = config.data = config.data || {};
      data.datasets = data.datasets || [];
      data.labels = data.labels || [];
      config.options = mergeConfig(core_defaults.global, core_defaults[config.type], config.options || {});
      return config;
    }
    function updateConfig(chart) {
      var newOptions = chart.options;
      helpers$1.each(chart.scales, function (scale) {
        core_layouts.removeBox(chart, scale);
      });
      newOptions = mergeConfig(core_defaults.global, core_defaults[chart.config.type], newOptions);
      chart.options = chart.config.options = newOptions;
      chart.ensureScalesHaveIDs();
      chart.buildOrUpdateScales();
      chart.tooltip._options = newOptions.tooltips;
      chart.tooltip.initialize();
    }
    function nextAvailableScaleId(axesOpts, prefix, index) {
      var id;
      var hasId = function hasId(obj) {
        return obj.id === id;
      };
      do {
        id = prefix + index++;
      } while (helpers$1.findIndex(axesOpts, hasId) >= 0);
      return id;
    }
    function positionIsHorizontal(position) {
      return position === 'top' || position === 'bottom';
    }
    function compare2Level(l1, l2) {
      return function (a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
      };
    }
    var Chart = function Chart(item, config) {
      this.construct(item, config);
      return this;
    };
    helpers$1.extend(Chart.prototype, {
      construct: function construct(item, config) {
        var me = this;
        config = initConfig(config);
        var context = platform.acquireContext(item, config);
        var canvas = context && context.canvas;
        var height = canvas && canvas.height;
        var width = canvas && canvas.width;
        me.id = helpers$1.uid();
        me.ctx = context;
        me.canvas = canvas;
        me.config = config;
        me.width = width;
        me.height = height;
        me.aspectRatio = height ? width / height : null;
        me.options = config.options;
        me._bufferedRender = false;
        me._layers = [];
        me.chart = me;
        me.controller = me;
        Chart.instances[me.id] = me;
        Object.defineProperty(me, 'data', {
          get: function get() {
            return me.config.data;
          },
          set: function set(value) {
            me.config.data = value;
          }
        });
        if (!context || !canvas) {
          console.error("Failed to create chart: can't acquire context from the given item");
          return;
        }
        me.initialize();
        me.update();
      },
      initialize: function initialize() {
        var me = this;
        core_plugins.notify(me, 'beforeInit');
        helpers$1.retinaScale(me, me.options.devicePixelRatio);
        me.bindEvents();
        if (me.options.responsive) {
          me.resize(true);
        }
        me.initToolTip();
        core_plugins.notify(me, 'afterInit');
        return me;
      },
      clear: function clear() {
        helpers$1.canvas.clear(this);
        return this;
      },
      stop: function stop() {
        core_animations.cancelAnimation(this);
        return this;
      },
      resize: function resize(silent) {
        var me = this;
        var options = me.options;
        var canvas = me.canvas;
        var aspectRatio = options.maintainAspectRatio && me.aspectRatio || null;
        var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
        var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
        if (me.width === newWidth && me.height === newHeight) {
          return;
        }
        canvas.width = me.width = newWidth;
        canvas.height = me.height = newHeight;
        canvas.style.width = newWidth + 'px';
        canvas.style.height = newHeight + 'px';
        helpers$1.retinaScale(me, options.devicePixelRatio);
        if (!silent) {
          var newSize = {
            width: newWidth,
            height: newHeight
          };
          core_plugins.notify(me, 'resize', [newSize]);
          if (options.onResize) {
            options.onResize(me, newSize);
          }
          me.stop();
          me.update({
            duration: options.responsiveAnimationDuration
          });
        }
      },
      ensureScalesHaveIDs: function ensureScalesHaveIDs() {
        var options = this.options;
        var scalesOptions = options.scales || {};
        var scaleOptions = options.scale;
        helpers$1.each(scalesOptions.xAxes, function (xAxisOptions, index) {
          if (!xAxisOptions.id) {
            xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
          }
        });
        helpers$1.each(scalesOptions.yAxes, function (yAxisOptions, index) {
          if (!yAxisOptions.id) {
            yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
          }
        });
        if (scaleOptions) {
          scaleOptions.id = scaleOptions.id || 'scale';
        }
      },
      buildOrUpdateScales: function buildOrUpdateScales() {
        var me = this;
        var options = me.options;
        var scales = me.scales || {};
        var items = [];
        var updated = Object.keys(scales).reduce(function (obj, id) {
          obj[id] = false;
          return obj;
        }, {});
        if (options.scales) {
          items = items.concat((options.scales.xAxes || []).map(function (xAxisOptions) {
            return {
              options: xAxisOptions,
              dtype: 'category',
              dposition: 'bottom'
            };
          }), (options.scales.yAxes || []).map(function (yAxisOptions) {
            return {
              options: yAxisOptions,
              dtype: 'linear',
              dposition: 'left'
            };
          }));
        }
        if (options.scale) {
          items.push({
            options: options.scale,
            dtype: 'radialLinear',
            isDefault: true,
            dposition: 'chartArea'
          });
        }
        helpers$1.each(items, function (item) {
          var scaleOptions = item.options;
          var id = scaleOptions.id;
          var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
          if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
            scaleOptions.position = item.dposition;
          }
          updated[id] = true;
          var scale = null;
          if (id in scales && scales[id].type === scaleType) {
            scale = scales[id];
            scale.options = scaleOptions;
            scale.ctx = me.ctx;
            scale.chart = me;
          } else {
            var scaleClass = core_scaleService.getScaleConstructor(scaleType);
            if (!scaleClass) {
              return;
            }
            scale = new scaleClass({
              id: id,
              type: scaleType,
              options: scaleOptions,
              ctx: me.ctx,
              chart: me
            });
            scales[scale.id] = scale;
          }
          scale.mergeTicksOptions();
          if (item.isDefault) {
            me.scale = scale;
          }
        });
        helpers$1.each(updated, function (hasUpdated, id) {
          if (!hasUpdated) {
            delete scales[id];
          }
        });
        me.scales = scales;
        core_scaleService.addScalesToLayout(this);
      },
      buildOrUpdateControllers: function buildOrUpdateControllers() {
        var me = this;
        var newControllers = [];
        var datasets = me.data.datasets;
        var i, ilen;
        for (i = 0, ilen = datasets.length; i < ilen; i++) {
          var dataset = datasets[i];
          var meta = me.getDatasetMeta(i);
          var type = dataset.type || me.config.type;
          if (meta.type && meta.type !== type) {
            me.destroyDatasetMeta(i);
            meta = me.getDatasetMeta(i);
          }
          meta.type = type;
          meta.order = dataset.order || 0;
          meta.index = i;
          if (meta.controller) {
            meta.controller.updateIndex(i);
            meta.controller.linkScales();
          } else {
            var ControllerClass = controllers[meta.type];
            if (ControllerClass === undefined) {
              throw new Error('"' + meta.type + '" is not a chart type.');
            }
            meta.controller = new ControllerClass(me, i);
            newControllers.push(meta.controller);
          }
        }
        return newControllers;
      },
      resetElements: function resetElements() {
        var me = this;
        helpers$1.each(me.data.datasets, function (dataset, datasetIndex) {
          me.getDatasetMeta(datasetIndex).controller.reset();
        }, me);
      },
      reset: function reset() {
        this.resetElements();
        this.tooltip.initialize();
      },
      update: function update(config) {
        var me = this;
        var i, ilen;
        if (!config || typeof config !== 'object') {
          config = {
            duration: config,
            lazy: arguments[1]
          };
        }
        updateConfig(me);
        core_plugins._invalidate(me);
        if (core_plugins.notify(me, 'beforeUpdate') === false) {
          return;
        }
        me.tooltip._data = me.data;
        var newControllers = me.buildOrUpdateControllers();
        for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
          me.getDatasetMeta(i).controller.buildOrUpdateElements();
        }
        me.updateLayout();
        if (me.options.animation && me.options.animation.duration) {
          helpers$1.each(newControllers, function (controller) {
            controller.reset();
          });
        }
        me.updateDatasets();
        me.tooltip.initialize();
        me.lastActive = [];
        core_plugins.notify(me, 'afterUpdate');
        me._layers.sort(compare2Level('z', '_idx'));
        if (me._bufferedRender) {
          me._bufferedRequest = {
            duration: config.duration,
            easing: config.easing,
            lazy: config.lazy
          };
        } else {
          me.render(config);
        }
      },
      updateLayout: function updateLayout() {
        var me = this;
        if (core_plugins.notify(me, 'beforeLayout') === false) {
          return;
        }
        core_layouts.update(this, this.width, this.height);
        me._layers = [];
        helpers$1.each(me.boxes, function (box) {
          if (box._configure) {
            box._configure();
          }
          me._layers.push.apply(me._layers, box._layers());
        }, me);
        me._layers.forEach(function (item, index) {
          item._idx = index;
        });
        core_plugins.notify(me, 'afterScaleUpdate');
        core_plugins.notify(me, 'afterLayout');
      },
      updateDatasets: function updateDatasets() {
        var me = this;
        if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
          return;
        }
        for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
          me.updateDataset(i);
        }
        core_plugins.notify(me, 'afterDatasetsUpdate');
      },
      updateDataset: function updateDataset(index) {
        var me = this;
        var meta = me.getDatasetMeta(index);
        var args = {
          meta: meta,
          index: index
        };
        if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
          return;
        }
        meta.controller._update();
        core_plugins.notify(me, 'afterDatasetUpdate', [args]);
      },
      render: function render(config) {
        var me = this;
        if (!config || typeof config !== 'object') {
          config = {
            duration: config,
            lazy: arguments[1]
          };
        }
        var animationOptions = me.options.animation;
        var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
        var lazy = config.lazy;
        if (core_plugins.notify(me, 'beforeRender') === false) {
          return;
        }
        var onComplete = function onComplete(animation) {
          core_plugins.notify(me, 'afterRender');
          helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
        };
        if (animationOptions && duration) {
          var animation = new core_animation({
            numSteps: duration / 16.66,
            easing: config.easing || animationOptions.easing,
            render: function render(chart, animationObject) {
              var easingFunction = helpers$1.easing.effects[animationObject.easing];
              var currentStep = animationObject.currentStep;
              var stepDecimal = currentStep / animationObject.numSteps;
              chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
            },
            onAnimationProgress: animationOptions.onProgress,
            onAnimationComplete: onComplete
          });
          core_animations.addAnimation(me, animation, duration, lazy);
        } else {
          me.draw();
          onComplete(new core_animation({
            numSteps: 0,
            chart: me
          }));
        }
        return me;
      },
      draw: function draw(easingValue) {
        var me = this;
        var i, layers;
        me.clear();
        if (helpers$1.isNullOrUndef(easingValue)) {
          easingValue = 1;
        }
        me.transition(easingValue);
        if (me.width <= 0 || me.height <= 0) {
          return;
        }
        if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
          return;
        }
        layers = me._layers;
        for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
          layers[i].draw(me.chartArea);
        }
        me.drawDatasets(easingValue);
        for (; i < layers.length; ++i) {
          layers[i].draw(me.chartArea);
        }
        me._drawTooltip(easingValue);
        core_plugins.notify(me, 'afterDraw', [easingValue]);
      },
      transition: function transition(easingValue) {
        var me = this;
        for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
          if (me.isDatasetVisible(i)) {
            me.getDatasetMeta(i).controller.transition(easingValue);
          }
        }
        me.tooltip.transition(easingValue);
      },
      _getSortedDatasetMetas: function _getSortedDatasetMetas(filterVisible) {
        var me = this;
        var datasets = me.data.datasets || [];
        var result = [];
        var i, ilen;
        for (i = 0, ilen = datasets.length; i < ilen; ++i) {
          if (!filterVisible || me.isDatasetVisible(i)) {
            result.push(me.getDatasetMeta(i));
          }
        }
        result.sort(compare2Level('order', 'index'));
        return result;
      },
      _getSortedVisibleDatasetMetas: function _getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
      },
      drawDatasets: function drawDatasets(easingValue) {
        var me = this;
        var metasets, i;
        if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
          return;
        }
        metasets = me._getSortedVisibleDatasetMetas();
        for (i = metasets.length - 1; i >= 0; --i) {
          me.drawDataset(metasets[i], easingValue);
        }
        core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
      },
      drawDataset: function drawDataset(meta, easingValue) {
        var me = this;
        var args = {
          meta: meta,
          index: meta.index,
          easingValue: easingValue
        };
        if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
          return;
        }
        meta.controller.draw(easingValue);
        core_plugins.notify(me, 'afterDatasetDraw', [args]);
      },
      _drawTooltip: function _drawTooltip(easingValue) {
        var me = this;
        var tooltip = me.tooltip;
        var args = {
          tooltip: tooltip,
          easingValue: easingValue
        };
        if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
          return;
        }
        tooltip.draw();
        core_plugins.notify(me, 'afterTooltipDraw', [args]);
      },
      getElementAtEvent: function getElementAtEvent(e) {
        return core_interaction.modes.single(this, e);
      },
      getElementsAtEvent: function getElementsAtEvent(e) {
        return core_interaction.modes.label(this, e, {
          intersect: true
        });
      },
      getElementsAtXAxis: function getElementsAtXAxis(e) {
        return core_interaction.modes['x-axis'](this, e, {
          intersect: true
        });
      },
      getElementsAtEventForMode: function getElementsAtEventForMode(e, mode, options) {
        var method = core_interaction.modes[mode];
        if (typeof method === 'function') {
          return method(this, e, options);
        }
        return [];
      },
      getDatasetAtEvent: function getDatasetAtEvent(e) {
        return core_interaction.modes.dataset(this, e, {
          intersect: true
        });
      },
      getDatasetMeta: function getDatasetMeta(datasetIndex) {
        var me = this;
        var dataset = me.data.datasets[datasetIndex];
        if (!dataset._meta) {
          dataset._meta = {};
        }
        var meta = dataset._meta[me.id];
        if (!meta) {
          meta = dataset._meta[me.id] = {
            type: null,
            data: [],
            dataset: null,
            controller: null,
            hidden: null,
            xAxisID: null,
            yAxisID: null,
            order: dataset.order || 0,
            index: datasetIndex
          };
        }
        return meta;
      },
      getVisibleDatasetCount: function getVisibleDatasetCount() {
        var count = 0;
        for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
          if (this.isDatasetVisible(i)) {
            count++;
          }
        }
        return count;
      },
      isDatasetVisible: function isDatasetVisible(datasetIndex) {
        var meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
      },
      generateLegend: function generateLegend() {
        return this.options.legendCallback(this);
      },
      destroyDatasetMeta: function destroyDatasetMeta(datasetIndex) {
        var id = this.id;
        var dataset = this.data.datasets[datasetIndex];
        var meta = dataset._meta && dataset._meta[id];
        if (meta) {
          meta.controller.destroy();
          delete dataset._meta[id];
        }
      },
      destroy: function destroy() {
        var me = this;
        var canvas = me.canvas;
        var i, ilen;
        me.stop();
        for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
          me.destroyDatasetMeta(i);
        }
        if (canvas) {
          me.unbindEvents();
          helpers$1.canvas.clear(me);
          platform.releaseContext(me.ctx);
          me.canvas = null;
          me.ctx = null;
        }
        core_plugins.notify(me, 'destroy');
        delete Chart.instances[me.id];
      },
      toBase64Image: function toBase64Image() {
        return this.canvas.toDataURL.apply(this.canvas, arguments);
      },
      initToolTip: function initToolTip() {
        var me = this;
        me.tooltip = new core_tooltip({
          _chart: me,
          _chartInstance: me,
          _data: me.data,
          _options: me.options.tooltips
        }, me);
      },
      bindEvents: function bindEvents() {
        var me = this;
        var listeners = me._listeners = {};
        var listener = function listener() {
          me.eventHandler.apply(me, arguments);
        };
        helpers$1.each(me.options.events, function (type) {
          platform.addEventListener(me, type, listener);
          listeners[type] = listener;
        });
        if (me.options.responsive) {
          listener = function listener() {
            me.resize();
          };
          platform.addEventListener(me, 'resize', listener);
          listeners.resize = listener;
        }
      },
      unbindEvents: function unbindEvents() {
        var me = this;
        var listeners = me._listeners;
        if (!listeners) {
          return;
        }
        delete me._listeners;
        helpers$1.each(listeners, function (listener, type) {
          platform.removeEventListener(me, type, listener);
        });
      },
      updateHoverStyle: function updateHoverStyle(elements, mode, enabled) {
        var prefix = enabled ? 'set' : 'remove';
        var element, i, ilen;
        for (i = 0, ilen = elements.length; i < ilen; ++i) {
          element = elements[i];
          if (element) {
            this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
          }
        }
        if (mode === 'dataset') {
          this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
        }
      },
      eventHandler: function eventHandler(e) {
        var me = this;
        var tooltip = me.tooltip;
        if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
          return;
        }
        me._bufferedRender = true;
        me._bufferedRequest = null;
        var changed = me.handleEvent(e);
        if (tooltip) {
          changed = tooltip._start ? tooltip.handleEvent(e) : changed | tooltip.handleEvent(e);
        }
        core_plugins.notify(me, 'afterEvent', [e]);
        var bufferedRequest = me._bufferedRequest;
        if (bufferedRequest) {
          me.render(bufferedRequest);
        } else if (changed && !me.animating) {
          me.stop();
          me.render({
            duration: me.options.hover.animationDuration,
            lazy: true
          });
        }
        me._bufferedRender = false;
        me._bufferedRequest = null;
        return me;
      },
      handleEvent: function handleEvent(e) {
        var me = this;
        var options = me.options || {};
        var hoverOptions = options.hover;
        var changed = false;
        me.lastActive = me.lastActive || [];
        if (e.type === 'mouseout') {
          me.active = [];
        } else {
          me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
        }
        helpers$1.callback(options.onHover || options.hover.onHover, [e["native"], me.active], me);
        if (e.type === 'mouseup' || e.type === 'click') {
          if (options.onClick) {
            options.onClick.call(me, e["native"], me.active);
          }
        }
        if (me.lastActive.length) {
          me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
        }
        if (me.active.length && hoverOptions.mode) {
          me.updateHoverStyle(me.active, hoverOptions.mode, true);
        }
        changed = !helpers$1.arrayEquals(me.active, me.lastActive);
        me.lastActive = me.active;
        return changed;
      }
    });
    Chart.instances = {};
    var core_controller = Chart;
    Chart.Controller = Chart;
    Chart.types = {};
    helpers$1.configMerge = mergeConfig;
    helpers$1.scaleMerge = mergeScaleConfig;
    var core_helpers = function core_helpers() {
      helpers$1.where = function (collection, filterCallback) {
        if (helpers$1.isArray(collection) && Array.prototype.filter) {
          return collection.filter(filterCallback);
        }
        var filtered = [];
        helpers$1.each(collection, function (item) {
          if (filterCallback(item)) {
            filtered.push(item);
          }
        });
        return filtered;
      };
      helpers$1.findIndex = Array.prototype.findIndex ? function (array, callback, scope) {
        return array.findIndex(callback, scope);
      } : function (array, callback, scope) {
        scope = scope === undefined ? array : scope;
        for (var i = 0, ilen = array.length; i < ilen; ++i) {
          if (callback.call(scope, array[i], i, array)) {
            return i;
          }
        }
        return -1;
      };
      helpers$1.findNextWhere = function (arrayToSearch, filterCallback, startIndex) {
        if (helpers$1.isNullOrUndef(startIndex)) {
          startIndex = -1;
        }
        for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
          var currentItem = arrayToSearch[i];
          if (filterCallback(currentItem)) {
            return currentItem;
          }
        }
      };
      helpers$1.findPreviousWhere = function (arrayToSearch, filterCallback, startIndex) {
        if (helpers$1.isNullOrUndef(startIndex)) {
          startIndex = arrayToSearch.length;
        }
        for (var i = startIndex - 1; i >= 0; i--) {
          var currentItem = arrayToSearch[i];
          if (filterCallback(currentItem)) {
            return currentItem;
          }
        }
      };
      helpers$1.isNumber = function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
      };
      helpers$1.almostEquals = function (x, y, epsilon) {
        return Math.abs(x - y) < epsilon;
      };
      helpers$1.almostWhole = function (x, epsilon) {
        var rounded = Math.round(x);
        return rounded - epsilon <= x && rounded + epsilon >= x;
      };
      helpers$1.max = function (array) {
        return array.reduce(function (max, value) {
          if (!isNaN(value)) {
            return Math.max(max, value);
          }
          return max;
        }, Number.NEGATIVE_INFINITY);
      };
      helpers$1.min = function (array) {
        return array.reduce(function (min, value) {
          if (!isNaN(value)) {
            return Math.min(min, value);
          }
          return min;
        }, Number.POSITIVE_INFINITY);
      };
      helpers$1.sign = Math.sign ? function (x) {
        return Math.sign(x);
      } : function (x) {
        x = +x;
        if (x === 0 || isNaN(x)) {
          return x;
        }
        return x > 0 ? 1 : -1;
      };
      helpers$1.toRadians = function (degrees) {
        return degrees * (Math.PI / 180);
      };
      helpers$1.toDegrees = function (radians) {
        return radians * (180 / Math.PI);
      };
      helpers$1._decimalPlaces = function (x) {
        if (!helpers$1.isFinite(x)) {
          return;
        }
        var e = 1;
        var p = 0;
        while (Math.round(x * e) / e !== x) {
          e *= 10;
          p++;
        }
        return p;
      };
      helpers$1.getAngleFromPoint = function (centrePoint, anglePoint) {
        var distanceFromXCenter = anglePoint.x - centrePoint.x;
        var distanceFromYCenter = anglePoint.y - centrePoint.y;
        var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
        var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
        if (angle < -0.5 * Math.PI) {
          angle += 2.0 * Math.PI;
        }
        return {
          angle: angle,
          distance: radialDistanceFromCenter
        };
      };
      helpers$1.distanceBetweenPoints = function (pt1, pt2) {
        return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
      };
      helpers$1.aliasPixel = function (pixelWidth) {
        return pixelWidth % 2 === 0 ? 0 : 0.5;
      };
      helpers$1._alignPixel = function (chart, pixel, width) {
        var devicePixelRatio = chart.currentDevicePixelRatio;
        var halfWidth = width / 2;
        return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
      };
      helpers$1.splineCurve = function (firstPoint, middlePoint, afterPoint, t) {
        var previous = firstPoint.skip ? middlePoint : firstPoint;
        var current = middlePoint;
        var next = afterPoint.skip ? middlePoint : afterPoint;
        var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
        var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
        var s01 = d01 / (d01 + d12);
        var s12 = d12 / (d01 + d12);
        s01 = isNaN(s01) ? 0 : s01;
        s12 = isNaN(s12) ? 0 : s12;
        var fa = t * s01;
        var fb = t * s12;
        return {
          previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
          },
          next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
          }
        };
      };
      helpers$1.EPSILON = Number.EPSILON || 1e-14;
      helpers$1.splineCurveMonotone = function (points) {
        var pointsWithTangents = (points || []).map(function (point) {
          return {
            model: point._model,
            deltaK: 0,
            mK: 0
          };
        });
        var pointsLen = pointsWithTangents.length;
        var i, pointBefore, pointCurrent, pointAfter;
        for (i = 0; i < pointsLen; ++i) {
          pointCurrent = pointsWithTangents[i];
          if (pointCurrent.model.skip) {
            continue;
          }
          pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
          pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
          if (pointAfter && !pointAfter.model.skip) {
            var slopeDeltaX = pointAfter.model.x - pointCurrent.model.x;
            pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
          }
          if (!pointBefore || pointBefore.model.skip) {
            pointCurrent.mK = pointCurrent.deltaK;
          } else if (!pointAfter || pointAfter.model.skip) {
            pointCurrent.mK = pointBefore.deltaK;
          } else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
            pointCurrent.mK = 0;
          } else {
            pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
          }
        }
        var alphaK, betaK, tauK, squaredMagnitude;
        for (i = 0; i < pointsLen - 1; ++i) {
          pointCurrent = pointsWithTangents[i];
          pointAfter = pointsWithTangents[i + 1];
          if (pointCurrent.model.skip || pointAfter.model.skip) {
            continue;
          }
          if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
            pointCurrent.mK = pointAfter.mK = 0;
            continue;
          }
          alphaK = pointCurrent.mK / pointCurrent.deltaK;
          betaK = pointAfter.mK / pointCurrent.deltaK;
          squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
          if (squaredMagnitude <= 9) {
            continue;
          }
          tauK = 3 / Math.sqrt(squaredMagnitude);
          pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
          pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
        }
        var deltaX;
        for (i = 0; i < pointsLen; ++i) {
          pointCurrent = pointsWithTangents[i];
          if (pointCurrent.model.skip) {
            continue;
          }
          pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
          pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
          if (pointBefore && !pointBefore.model.skip) {
            deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
            pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
            pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
          }
          if (pointAfter && !pointAfter.model.skip) {
            deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
            pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
            pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
          }
        }
      };
      helpers$1.nextItem = function (collection, index, loop) {
        if (loop) {
          return index >= collection.length - 1 ? collection[0] : collection[index + 1];
        }
        return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
      };
      helpers$1.previousItem = function (collection, index, loop) {
        if (loop) {
          return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
        }
        return index <= 0 ? collection[0] : collection[index - 1];
      };
      helpers$1.niceNum = function (range, round) {
        var exponent = Math.floor(helpers$1.log10(range));
        var fraction = range / Math.pow(10, exponent);
        var niceFraction;
        if (round) {
          if (fraction < 1.5) {
            niceFraction = 1;
          } else if (fraction < 3) {
            niceFraction = 2;
          } else if (fraction < 7) {
            niceFraction = 5;
          } else {
            niceFraction = 10;
          }
        } else if (fraction <= 1.0) {
          niceFraction = 1;
        } else if (fraction <= 2) {
          niceFraction = 2;
        } else if (fraction <= 5) {
          niceFraction = 5;
        } else {
          niceFraction = 10;
        }
        return niceFraction * Math.pow(10, exponent);
      };
      helpers$1.requestAnimFrame = function () {
        if (typeof window === 'undefined') {
          return function (callback) {
            callback();
          };
        }
        return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
          return window.setTimeout(callback, 1000 / 60);
        };
      }();
      helpers$1.getRelativePosition = function (evt, chart) {
        var mouseX, mouseY;
        var e = evt.originalEvent || evt;
        var canvas = evt.target || evt.srcElement;
        var boundingRect = canvas.getBoundingClientRect();
        var touches = e.touches;
        if (touches && touches.length > 0) {
          mouseX = touches[0].clientX;
          mouseY = touches[0].clientY;
        } else {
          mouseX = e.clientX;
          mouseY = e.clientY;
        }
        var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
        var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
        var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
        var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
        var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
        var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
        mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / width * canvas.width / chart.currentDevicePixelRatio);
        mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / height * canvas.height / chart.currentDevicePixelRatio);
        return {
          x: mouseX,
          y: mouseY
        };
      };
      function parseMaxStyle(styleValue, node, parentProperty) {
        var valueInPixels;
        if (typeof styleValue === 'string') {
          valueInPixels = parseInt(styleValue, 10);
          if (styleValue.indexOf('%') !== -1) {
            valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
          }
        } else {
          valueInPixels = styleValue;
        }
        return valueInPixels;
      }
      function isConstrainedValue(value) {
        return value !== undefined && value !== null && value !== 'none';
      }
      function getConstraintDimension(domNode, maxStyle, percentageProperty) {
        var view = document.defaultView;
        var parentNode = helpers$1._getParentNode(domNode);
        var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
        var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
        var hasCNode = isConstrainedValue(constrainedNode);
        var hasCContainer = isConstrainedValue(constrainedContainer);
        var infinity = Number.POSITIVE_INFINITY;
        if (hasCNode || hasCContainer) {
          return Math.min(hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity, hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
        }
        return 'none';
      }
      helpers$1.getConstraintWidth = function (domNode) {
        return getConstraintDimension(domNode, 'max-width', 'clientWidth');
      };
      helpers$1.getConstraintHeight = function (domNode) {
        return getConstraintDimension(domNode, 'max-height', 'clientHeight');
      };
      helpers$1._calculatePadding = function (container, padding, parentDimension) {
        padding = helpers$1.getStyle(container, padding);
        return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
      };
      helpers$1._getParentNode = function (domNode) {
        var parent = domNode.parentNode;
        if (parent && parent.toString() === '[object ShadowRoot]') {
          parent = parent.host;
        }
        return parent;
      };
      helpers$1.getMaximumWidth = function (domNode) {
        var container = helpers$1._getParentNode(domNode);
        if (!container) {
          return domNode.clientWidth;
        }
        var clientWidth = container.clientWidth;
        var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
        var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
        var w = clientWidth - paddingLeft - paddingRight;
        var cw = helpers$1.getConstraintWidth(domNode);
        return isNaN(cw) ? w : Math.min(w, cw);
      };
      helpers$1.getMaximumHeight = function (domNode) {
        var container = helpers$1._getParentNode(domNode);
        if (!container) {
          return domNode.clientHeight;
        }
        var clientHeight = container.clientHeight;
        var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
        var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
        var h = clientHeight - paddingTop - paddingBottom;
        var ch = helpers$1.getConstraintHeight(domNode);
        return isNaN(ch) ? h : Math.min(h, ch);
      };
      helpers$1.getStyle = function (el, property) {
        return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
      };
      helpers$1.retinaScale = function (chart, forceRatio) {
        var pixelRatio = chart.currentDevicePixelRatio = forceRatio || typeof window !== 'undefined' && window.devicePixelRatio || 1;
        if (pixelRatio === 1) {
          return;
        }
        var canvas = chart.canvas;
        var height = chart.height;
        var width = chart.width;
        canvas.height = height * pixelRatio;
        canvas.width = width * pixelRatio;
        chart.ctx.scale(pixelRatio, pixelRatio);
        if (!canvas.style.height && !canvas.style.width) {
          canvas.style.height = height + 'px';
          canvas.style.width = width + 'px';
        }
      };
      helpers$1.fontString = function (pixelSize, fontStyle, fontFamily) {
        return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
      };
      helpers$1.longestText = function (ctx, font, arrayOfThings, cache) {
        cache = cache || {};
        var data = cache.data = cache.data || {};
        var gc = cache.garbageCollect = cache.garbageCollect || [];
        if (cache.font !== font) {
          data = cache.data = {};
          gc = cache.garbageCollect = [];
          cache.font = font;
        }
        ctx.font = font;
        var longest = 0;
        var ilen = arrayOfThings.length;
        var i, j, jlen, thing, nestedThing;
        for (i = 0; i < ilen; i++) {
          thing = arrayOfThings[i];
          if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
            longest = helpers$1.measureText(ctx, data, gc, longest, thing);
          } else if (helpers$1.isArray(thing)) {
            for (j = 0, jlen = thing.length; j < jlen; j++) {
              nestedThing = thing[j];
              if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
                longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
              }
            }
          }
        }
        var gcLen = gc.length / 2;
        if (gcLen > arrayOfThings.length) {
          for (i = 0; i < gcLen; i++) {
            delete data[gc[i]];
          }
          gc.splice(0, gcLen);
        }
        return longest;
      };
      helpers$1.measureText = function (ctx, data, gc, longest, string) {
        var textWidth = data[string];
        if (!textWidth) {
          textWidth = data[string] = ctx.measureText(string).width;
          gc.push(string);
        }
        if (textWidth > longest) {
          longest = textWidth;
        }
        return longest;
      };
      helpers$1.numberOfLabelLines = function (arrayOfThings) {
        var numberOfLines = 1;
        helpers$1.each(arrayOfThings, function (thing) {
          if (helpers$1.isArray(thing)) {
            if (thing.length > numberOfLines) {
              numberOfLines = thing.length;
            }
          }
        });
        return numberOfLines;
      };
      helpers$1.color = !chartjsColor ? function (value) {
        console.error('Color.js not found!');
        return value;
      } : function (value) {
        if (value instanceof CanvasGradient) {
          value = core_defaults.global.defaultColor;
        }
        return chartjsColor(value);
      };
      helpers$1.getHoverColor = function (colorValue) {
        return colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient ? colorValue : helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
      };
    };
    function _abstract() {
      throw new Error('This method is not implemented: either no adapter can ' + 'be found or an incomplete integration was provided.');
    }
    function DateAdapter(options) {
      this.options = options || {};
    }
    helpers$1.extend(DateAdapter.prototype, {
      formats: _abstract,
      parse: _abstract,
      format: _abstract,
      add: _abstract,
      diff: _abstract,
      startOf: _abstract,
      endOf: _abstract,
      _create: function _create(value) {
        return value;
      }
    });
    DateAdapter.override = function (members) {
      helpers$1.extend(DateAdapter.prototype, members);
    };
    var _date = DateAdapter;
    var core_adapters = {
      _date: _date
    };
    var core_ticks = {
      formatters: {
        values: function values(value) {
          return helpers$1.isArray(value) ? value : '' + value;
        },
        linear: function linear(tickValue, index, ticks) {
          var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
          if (Math.abs(delta) > 1) {
            if (tickValue !== Math.floor(tickValue)) {
              delta = tickValue - Math.floor(tickValue);
            }
          }
          var logDelta = helpers$1.log10(Math.abs(delta));
          var tickString = '';
          if (tickValue !== 0) {
            var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
            if (maxTick < 1e-4) {
              var logTick = helpers$1.log10(Math.abs(tickValue));
              var numExponential = Math.floor(logTick) - Math.floor(logDelta);
              numExponential = Math.max(Math.min(numExponential, 20), 0);
              tickString = tickValue.toExponential(numExponential);
            } else {
              var numDecimal = -1 * Math.floor(logDelta);
              numDecimal = Math.max(Math.min(numDecimal, 20), 0);
              tickString = tickValue.toFixed(numDecimal);
            }
          } else {
            tickString = '0';
          }
          return tickString;
        },
        logarithmic: function logarithmic(tickValue, index, ticks) {
          var remain = tickValue / Math.pow(10, Math.floor(helpers$1.log10(tickValue)));
          if (tickValue === 0) {
            return '0';
          } else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
            return tickValue.toExponential();
          }
          return '';
        }
      }
    };
    var isArray = helpers$1.isArray;
    var isNullOrUndef = helpers$1.isNullOrUndef;
    var valueOrDefault$a = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
    core_defaults._set('scale', {
      display: true,
      position: 'left',
      offset: false,
      gridLines: {
        display: true,
        color: 'rgba(0,0,0,0.1)',
        lineWidth: 1,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true,
        tickMarkLength: 10,
        zeroLineWidth: 1,
        zeroLineColor: 'rgba(0,0,0,0.25)',
        zeroLineBorderDash: [],
        zeroLineBorderDashOffset: 0.0,
        offsetGridLines: false,
        borderDash: [],
        borderDashOffset: 0.0
      },
      scaleLabel: {
        display: false,
        labelString: '',
        padding: {
          top: 4,
          bottom: 4
        }
      },
      ticks: {
        beginAtZero: false,
        minRotation: 0,
        maxRotation: 50,
        mirror: false,
        padding: 0,
        reverse: false,
        display: true,
        autoSkip: true,
        autoSkipPadding: 0,
        labelOffset: 0,
        callback: core_ticks.formatters.values,
        minor: {},
        major: {}
      }
    });
    function sample(arr, numItems) {
      var result = [];
      var increment = arr.length / numItems;
      var i = 0;
      var len = arr.length;
      for (; i < len; i += increment) {
        result.push(arr[Math.floor(i)]);
      }
      return result;
    }
    function getPixelForGridLine(scale, index, offsetGridLines) {
      var length = scale.getTicks().length;
      var validIndex = Math.min(index, length - 1);
      var lineValue = scale.getPixelForTick(validIndex);
      var start = scale._startPixel;
      var end = scale._endPixel;
      var epsilon = 1e-6;
      var offset;
      if (offsetGridLines) {
        if (length === 1) {
          offset = Math.max(lineValue - start, end - lineValue);
        } else if (index === 0) {
          offset = (scale.getPixelForTick(1) - lineValue) / 2;
        } else {
          offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        }
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) {
          return;
        }
      }
      return lineValue;
    }
    function garbageCollect(caches, length) {
      helpers$1.each(caches, function (cache) {
        var gc = cache.gc;
        var gcLen = gc.length / 2;
        var i;
        if (gcLen > length) {
          for (i = 0; i < gcLen; ++i) {
            delete cache.data[gc[i]];
          }
          gc.splice(0, gcLen);
        }
      });
    }
    function computeLabelSizes(ctx, tickFonts, ticks, caches) {
      var length = ticks.length;
      var widths = [];
      var heights = [];
      var offsets = [];
      var widestLabelSize = 0;
      var highestLabelSize = 0;
      var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
      for (i = 0; i < length; ++i) {
        label = ticks[i].label;
        tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
        ctx.font = fontString = tickFont.string;
        cache = caches[fontString] = caches[fontString] || {
          data: {},
          gc: []
        };
        lineHeight = tickFont.lineHeight;
        width = height = 0;
        if (!isNullOrUndef(label) && !isArray(label)) {
          width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
          height = lineHeight;
        } else if (isArray(label)) {
          for (j = 0, jlen = label.length; j < jlen; ++j) {
            nestedLabel = label[j];
            if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
              width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
              height += lineHeight;
            }
          }
        }
        widths.push(width);
        heights.push(height);
        offsets.push(lineHeight / 2);
        widestLabelSize = Math.max(width, widestLabelSize);
        highestLabelSize = Math.max(height, highestLabelSize);
      }
      garbageCollect(caches, length);
      widest = widths.indexOf(widestLabelSize);
      highest = heights.indexOf(highestLabelSize);
      function valueAt(idx) {
        return {
          width: widths[idx] || 0,
          height: heights[idx] || 0,
          offset: offsets[idx] || 0
        };
      }
      return {
        first: valueAt(0),
        last: valueAt(length - 1),
        widest: valueAt(widest),
        highest: valueAt(highest)
      };
    }
    function getTickMarkLength(options) {
      return options.drawTicks ? options.tickMarkLength : 0;
    }
    function getScaleLabelHeight(options) {
      var font, padding;
      if (!options.display) {
        return 0;
      }
      font = helpers$1.options._parseFont(options);
      padding = helpers$1.options.toPadding(options.padding);
      return font.lineHeight + padding.height;
    }
    function parseFontOptions(options, nestedOpts) {
      return helpers$1.extend(helpers$1.options._parseFont({
        fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
        fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
        fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
        lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
      }), {
        color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
      });
    }
    function parseTickFontOptions(options) {
      var minor = parseFontOptions(options, options.minor);
      var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
      return {
        minor: minor,
        major: major
      };
    }
    function nonSkipped(ticksToFilter) {
      var filtered = [];
      var item, index, len;
      for (index = 0, len = ticksToFilter.length; index < len; ++index) {
        item = ticksToFilter[index];
        if (typeof item._index !== 'undefined') {
          filtered.push(item);
        }
      }
      return filtered;
    }
    function getEvenSpacing(arr) {
      var len = arr.length;
      var i, diff;
      if (len < 2) {
        return false;
      }
      for (diff = arr[0], i = 1; i < len; ++i) {
        if (arr[i] - arr[i - 1] !== diff) {
          return false;
        }
      }
      return diff;
    }
    function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
      var evenMajorSpacing = getEvenSpacing(majorIndices);
      var spacing = (ticks.length - 1) / ticksLimit;
      var factors, factor, i, ilen;
      if (!evenMajorSpacing) {
        return Math.max(spacing, 1);
      }
      factors = helpers$1.math._factorize(evenMajorSpacing);
      for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
        factor = factors[i];
        if (factor > spacing) {
          return factor;
        }
      }
      return Math.max(spacing, 1);
    }
    function getMajorIndices(ticks) {
      var result = [];
      var i, ilen;
      for (i = 0, ilen = ticks.length; i < ilen; i++) {
        if (ticks[i].major) {
          result.push(i);
        }
      }
      return result;
    }
    function skipMajors(ticks, majorIndices, spacing) {
      var count = 0;
      var next = majorIndices[0];
      var i, tick;
      spacing = Math.ceil(spacing);
      for (i = 0; i < ticks.length; i++) {
        tick = ticks[i];
        if (i === next) {
          tick._index = i;
          count++;
          next = majorIndices[count * spacing];
        } else {
          delete tick.label;
        }
      }
    }
    function skip(ticks, spacing, majorStart, majorEnd) {
      var start = valueOrDefault$a(majorStart, 0);
      var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
      var count = 0;
      var length, i, tick, next;
      spacing = Math.ceil(spacing);
      if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
      }
      next = start;
      while (next < 0) {
        count++;
        next = Math.round(start + count * spacing);
      }
      for (i = Math.max(start, 0); i < end; i++) {
        tick = ticks[i];
        if (i === next) {
          tick._index = i;
          count++;
          next = Math.round(start + count * spacing);
        } else {
          delete tick.label;
        }
      }
    }
    var Scale = core_element.extend({
      zeroLineIndex: 0,
      getPadding: function getPadding() {
        var me = this;
        return {
          left: me.paddingLeft || 0,
          top: me.paddingTop || 0,
          right: me.paddingRight || 0,
          bottom: me.paddingBottom || 0
        };
      },
      getTicks: function getTicks() {
        return this._ticks;
      },
      _getLabels: function _getLabels() {
        var data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
      },
      mergeTicksOptions: function mergeTicksOptions() {},
      beforeUpdate: function beforeUpdate() {
        helpers$1.callback(this.options.beforeUpdate, [this]);
      },
      update: function update(maxWidth, maxHeight, margins) {
        var me = this;
        var tickOpts = me.options.ticks;
        var sampleSize = tickOpts.sampleSize;
        var i, ilen, labels, ticks, samplingEnabled;
        me.beforeUpdate();
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me.margins = helpers$1.extend({
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }, margins);
        me._ticks = null;
        me.ticks = null;
        me._labelSizes = null;
        me._maxLabelLines = 0;
        me.longestLabelWidth = 0;
        me.longestTextCache = me.longestTextCache || {};
        me._gridLineItems = null;
        me._labelItems = null;
        me.beforeSetDimensions();
        me.setDimensions();
        me.afterSetDimensions();
        me.beforeDataLimits();
        me.determineDataLimits();
        me.afterDataLimits();
        me.beforeBuildTicks();
        ticks = me.buildTicks() || [];
        ticks = me.afterBuildTicks(ticks) || ticks;
        if ((!ticks || !ticks.length) && me.ticks) {
          ticks = [];
          for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
            ticks.push({
              value: me.ticks[i],
              major: false
            });
          }
        }
        me._ticks = ticks;
        samplingEnabled = sampleSize < ticks.length;
        labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
        me._configure();
        me.beforeCalculateTickRotation();
        me.calculateTickRotation();
        me.afterCalculateTickRotation();
        me.beforeFit();
        me.fit();
        me.afterFit();
        me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
        if (samplingEnabled) {
          labels = me._convertTicksToLabels(me._ticksToDraw);
        }
        me.ticks = labels;
        me.afterUpdate();
        return me.minSize;
      },
      _configure: function _configure() {
        var me = this;
        var reversePixels = me.options.ticks.reverse;
        var startPixel, endPixel;
        if (me.isHorizontal()) {
          startPixel = me.left;
          endPixel = me.right;
        } else {
          startPixel = me.top;
          endPixel = me.bottom;
          reversePixels = !reversePixels;
        }
        me._startPixel = startPixel;
        me._endPixel = endPixel;
        me._reversePixels = reversePixels;
        me._length = endPixel - startPixel;
      },
      afterUpdate: function afterUpdate() {
        helpers$1.callback(this.options.afterUpdate, [this]);
      },
      beforeSetDimensions: function beforeSetDimensions() {
        helpers$1.callback(this.options.beforeSetDimensions, [this]);
      },
      setDimensions: function setDimensions() {
        var me = this;
        if (me.isHorizontal()) {
          me.width = me.maxWidth;
          me.left = 0;
          me.right = me.width;
        } else {
          me.height = me.maxHeight;
          me.top = 0;
          me.bottom = me.height;
        }
        me.paddingLeft = 0;
        me.paddingTop = 0;
        me.paddingRight = 0;
        me.paddingBottom = 0;
      },
      afterSetDimensions: function afterSetDimensions() {
        helpers$1.callback(this.options.afterSetDimensions, [this]);
      },
      beforeDataLimits: function beforeDataLimits() {
        helpers$1.callback(this.options.beforeDataLimits, [this]);
      },
      determineDataLimits: helpers$1.noop,
      afterDataLimits: function afterDataLimits() {
        helpers$1.callback(this.options.afterDataLimits, [this]);
      },
      beforeBuildTicks: function beforeBuildTicks() {
        helpers$1.callback(this.options.beforeBuildTicks, [this]);
      },
      buildTicks: helpers$1.noop,
      afterBuildTicks: function afterBuildTicks(ticks) {
        var me = this;
        if (isArray(ticks) && ticks.length) {
          return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
        }
        me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
        return ticks;
      },
      beforeTickToLabelConversion: function beforeTickToLabelConversion() {
        helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
      },
      convertTicksToLabels: function convertTicksToLabels() {
        var me = this;
        var tickOpts = me.options.ticks;
        me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
      },
      afterTickToLabelConversion: function afterTickToLabelConversion() {
        helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
      },
      beforeCalculateTickRotation: function beforeCalculateTickRotation() {
        helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
      },
      calculateTickRotation: function calculateTickRotation() {
        var me = this;
        var options = me.options;
        var tickOpts = options.ticks;
        var numTicks = me.getTicks().length;
        var minRotation = tickOpts.minRotation || 0;
        var maxRotation = tickOpts.maxRotation;
        var labelRotation = minRotation;
        var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
        if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
          me.labelRotation = minRotation;
          return;
        }
        labelSizes = me._getLabelSizes();
        maxLabelWidth = labelSizes.widest.width;
        maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
        maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
        tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
          tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
          maxHeight = me.maxHeight - getTickMarkLength(options.gridLines) - tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
          maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
          labelRotation = helpers$1.toDegrees(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
          labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        me.labelRotation = labelRotation;
      },
      afterCalculateTickRotation: function afterCalculateTickRotation() {
        helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
      },
      beforeFit: function beforeFit() {
        helpers$1.callback(this.options.beforeFit, [this]);
      },
      fit: function fit() {
        var me = this;
        var minSize = me.minSize = {
          width: 0,
          height: 0
        };
        var chart = me.chart;
        var opts = me.options;
        var tickOpts = opts.ticks;
        var scaleLabelOpts = opts.scaleLabel;
        var gridLineOpts = opts.gridLines;
        var display = me._isVisible();
        var isBottom = opts.position === 'bottom';
        var isHorizontal = me.isHorizontal();
        if (isHorizontal) {
          minSize.width = me.maxWidth;
        } else if (display) {
          minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
        }
        if (!isHorizontal) {
          minSize.height = me.maxHeight;
        } else if (display) {
          minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
        }
        if (tickOpts.display && display) {
          var tickFonts = parseTickFontOptions(tickOpts);
          var labelSizes = me._getLabelSizes();
          var firstLabelSize = labelSizes.first;
          var lastLabelSize = labelSizes.last;
          var widestLabelSize = labelSizes.widest;
          var highestLabelSize = labelSizes.highest;
          var lineSpace = tickFonts.minor.lineHeight * 0.4;
          var tickPadding = tickOpts.padding;
          if (isHorizontal) {
            var isRotated = me.labelRotation !== 0;
            var angleRadians = helpers$1.toRadians(me.labelRotation);
            var cosRotation = Math.cos(angleRadians);
            var sinRotation = Math.sin(angleRadians);
            var labelHeight = sinRotation * widestLabelSize.width + cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0)) + (isRotated ? 0 : lineSpace);
            minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
            var offsetLeft = me.getPixelForTick(0) - me.left;
            var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
            var paddingLeft, paddingRight;
            if (isRotated) {
              paddingLeft = isBottom ? cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset : sinRotation * (firstLabelSize.height - firstLabelSize.offset);
              paddingRight = isBottom ? sinRotation * (lastLabelSize.height - lastLabelSize.offset) : cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
            } else {
              paddingLeft = firstLabelSize.width / 2;
              paddingRight = lastLabelSize.width / 2;
            }
            me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
            me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
          } else {
            var labelWidth = tickOpts.mirror ? 0 : widestLabelSize.width + tickPadding + lineSpace;
            minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
            me.paddingTop = firstLabelSize.height / 2;
            me.paddingBottom = lastLabelSize.height / 2;
          }
        }
        me.handleMargins();
        if (isHorizontal) {
          me.width = me._length = chart.width - me.margins.left - me.margins.right;
          me.height = minSize.height;
        } else {
          me.width = minSize.width;
          me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
        }
      },
      handleMargins: function handleMargins() {
        var me = this;
        if (me.margins) {
          me.margins.left = Math.max(me.paddingLeft, me.margins.left);
          me.margins.top = Math.max(me.paddingTop, me.margins.top);
          me.margins.right = Math.max(me.paddingRight, me.margins.right);
          me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
        }
      },
      afterFit: function afterFit() {
        helpers$1.callback(this.options.afterFit, [this]);
      },
      isHorizontal: function isHorizontal() {
        var pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
      },
      isFullWidth: function isFullWidth() {
        return this.options.fullWidth;
      },
      getRightValue: function getRightValue(rawValue) {
        if (isNullOrUndef(rawValue)) {
          return NaN;
        }
        if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
          return NaN;
        }
        if (rawValue) {
          if (this.isHorizontal()) {
            if (rawValue.x !== undefined) {
              return this.getRightValue(rawValue.x);
            }
          } else if (rawValue.y !== undefined) {
            return this.getRightValue(rawValue.y);
          }
        }
        return rawValue;
      },
      _convertTicksToLabels: function _convertTicksToLabels(ticks) {
        var me = this;
        var labels, i, ilen;
        me.ticks = ticks.map(function (tick) {
          return tick.value;
        });
        me.beforeTickToLabelConversion();
        labels = me.convertTicksToLabels(ticks) || me.ticks;
        me.afterTickToLabelConversion();
        for (i = 0, ilen = ticks.length; i < ilen; ++i) {
          ticks[i].label = labels[i];
        }
        return labels;
      },
      _getLabelSizes: function _getLabelSizes() {
        var me = this;
        var labelSizes = me._labelSizes;
        if (!labelSizes) {
          me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
          me.longestLabelWidth = labelSizes.widest.width;
        }
        return labelSizes;
      },
      _parseValue: function _parseValue(value) {
        var start, end, min, max;
        if (isArray(value)) {
          start = +this.getRightValue(value[0]);
          end = +this.getRightValue(value[1]);
          min = Math.min(start, end);
          max = Math.max(start, end);
        } else {
          value = +this.getRightValue(value);
          start = undefined;
          end = value;
          min = value;
          max = value;
        }
        return {
          min: min,
          max: max,
          start: start,
          end: end
        };
      },
      _getScaleLabel: function _getScaleLabel(rawValue) {
        var v = this._parseValue(rawValue);
        if (v.start !== undefined) {
          return '[' + v.start + ', ' + v.end + ']';
        }
        return +this.getRightValue(rawValue);
      },
      getLabelForIndex: helpers$1.noop,
      getPixelForValue: helpers$1.noop,
      getValueForPixel: helpers$1.noop,
      getPixelForTick: function getPixelForTick(index) {
        var me = this;
        var offset = me.options.offset;
        var numTicks = me._ticks.length;
        var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
        return index < 0 || index > numTicks - 1 ? null : me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
      },
      getPixelForDecimal: function getPixelForDecimal(decimal) {
        var me = this;
        if (me._reversePixels) {
          decimal = 1 - decimal;
        }
        return me._startPixel + decimal * me._length;
      },
      getDecimalForPixel: function getDecimalForPixel(pixel) {
        var decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
      },
      getBasePixel: function getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
      },
      getBaseValue: function getBaseValue() {
        var me = this;
        var min = me.min;
        var max = me.max;
        return me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
      },
      _autoSkip: function _autoSkip(ticks) {
        var me = this;
        var tickOpts = me.options.ticks;
        var axisLength = me._length;
        var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
        var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
        var numMajorIndices = majorIndices.length;
        var first = majorIndices[0];
        var last = majorIndices[numMajorIndices - 1];
        var i, ilen, spacing, avgMajorSpacing;
        if (numMajorIndices > ticksLimit) {
          skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
          return nonSkipped(ticks);
        }
        spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
        if (numMajorIndices > 0) {
          for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
            skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
          }
          avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
          skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
          skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
          return nonSkipped(ticks);
        }
        skip(ticks, spacing);
        return nonSkipped(ticks);
      },
      _tickSize: function _tickSize() {
        var me = this;
        var optionTicks = me.options.ticks;
        var rot = helpers$1.toRadians(me.labelRotation);
        var cos = Math.abs(Math.cos(rot));
        var sin = Math.abs(Math.sin(rot));
        var labelSizes = me._getLabelSizes();
        var padding = optionTicks.autoSkipPadding || 0;
        var w = labelSizes ? labelSizes.widest.width + padding : 0;
        var h = labelSizes ? labelSizes.highest.height + padding : 0;
        return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
      },
      _isVisible: function _isVisible() {
        var me = this;
        var chart = me.chart;
        var display = me.options.display;
        var i, ilen, meta;
        if (display !== 'auto') {
          return !!display;
        }
        for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
          if (chart.isDatasetVisible(i)) {
            meta = chart.getDatasetMeta(i);
            if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
              return true;
            }
          }
        }
        return false;
      },
      _computeGridLineItems: function _computeGridLineItems(chartArea) {
        var me = this;
        var chart = me.chart;
        var options = me.options;
        var gridLines = options.gridLines;
        var position = options.position;
        var offsetGridLines = gridLines.offsetGridLines;
        var isHorizontal = me.isHorizontal();
        var ticks = me._ticksToDraw;
        var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
        var tl = getTickMarkLength(gridLines);
        var items = [];
        var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
        var axisHalfWidth = axisWidth / 2;
        var alignPixel = helpers$1._alignPixel;
        var alignBorderValue = function alignBorderValue(pixel) {
          return alignPixel(chart, pixel, axisWidth);
        };
        var borderValue, i, tick, lineValue, alignedLineValue;
        var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
        if (position === 'top') {
          borderValue = alignBorderValue(me.bottom);
          ty1 = me.bottom - tl;
          ty2 = borderValue - axisHalfWidth;
          y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
          y2 = chartArea.bottom;
        } else if (position === 'bottom') {
          borderValue = alignBorderValue(me.top);
          y1 = chartArea.top;
          y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
          ty1 = borderValue + axisHalfWidth;
          ty2 = me.top + tl;
        } else if (position === 'left') {
          borderValue = alignBorderValue(me.right);
          tx1 = me.right - tl;
          tx2 = borderValue - axisHalfWidth;
          x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
          x2 = chartArea.right;
        } else {
          borderValue = alignBorderValue(me.left);
          x1 = chartArea.left;
          x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
          tx1 = borderValue + axisHalfWidth;
          tx2 = me.left + tl;
        }
        for (i = 0; i < ticksLength; ++i) {
          tick = ticks[i] || {};
          if (isNullOrUndef(tick.label) && i < ticks.length) {
            continue;
          }
          if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
            lineWidth = gridLines.zeroLineWidth;
            lineColor = gridLines.zeroLineColor;
            borderDash = gridLines.zeroLineBorderDash || [];
            borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
          } else {
            lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
            lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
            borderDash = gridLines.borderDash || [];
            borderDashOffset = gridLines.borderDashOffset || 0.0;
          }
          lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
          if (lineValue === undefined) {
            continue;
          }
          alignedLineValue = alignPixel(chart, lineValue, lineWidth);
          if (isHorizontal) {
            tx1 = tx2 = x1 = x2 = alignedLineValue;
          } else {
            ty1 = ty2 = y1 = y2 = alignedLineValue;
          }
          items.push({
            tx1: tx1,
            ty1: ty1,
            tx2: tx2,
            ty2: ty2,
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            width: lineWidth,
            color: lineColor,
            borderDash: borderDash,
            borderDashOffset: borderDashOffset
          });
        }
        items.ticksLength = ticksLength;
        items.borderValue = borderValue;
        return items;
      },
      _computeLabelItems: function _computeLabelItems() {
        var me = this;
        var options = me.options;
        var optionTicks = options.ticks;
        var position = options.position;
        var isMirrored = optionTicks.mirror;
        var isHorizontal = me.isHorizontal();
        var ticks = me._ticksToDraw;
        var fonts = parseTickFontOptions(optionTicks);
        var tickPadding = optionTicks.padding;
        var tl = getTickMarkLength(options.gridLines);
        var rotation = -helpers$1.toRadians(me.labelRotation);
        var items = [];
        var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        if (position === 'top') {
          y = me.bottom - tl - tickPadding;
          textAlign = !rotation ? 'center' : 'left';
        } else if (position === 'bottom') {
          y = me.top + tl + tickPadding;
          textAlign = !rotation ? 'center' : 'right';
        } else if (position === 'left') {
          x = me.right - (isMirrored ? 0 : tl) - tickPadding;
          textAlign = isMirrored ? 'left' : 'right';
        } else {
          x = me.left + (isMirrored ? 0 : tl) + tickPadding;
          textAlign = isMirrored ? 'right' : 'left';
        }
        for (i = 0, ilen = ticks.length; i < ilen; ++i) {
          tick = ticks[i];
          label = tick.label;
          if (isNullOrUndef(label)) {
            continue;
          }
          pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
          font = tick.major ? fonts.major : fonts.minor;
          lineHeight = font.lineHeight;
          lineCount = isArray(label) ? label.length : 1;
          if (isHorizontal) {
            x = pixel;
            textOffset = position === 'top' ? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight : (!rotation ? 0.5 : 0) * lineHeight;
          } else {
            y = pixel;
            textOffset = (1 - lineCount) * lineHeight / 2;
          }
          items.push({
            x: x,
            y: y,
            rotation: rotation,
            label: label,
            font: font,
            textOffset: textOffset,
            textAlign: textAlign
          });
        }
        return items;
      },
      _drawGrid: function _drawGrid(chartArea) {
        var me = this;
        var gridLines = me.options.gridLines;
        if (!gridLines.display) {
          return;
        }
        var ctx = me.ctx;
        var chart = me.chart;
        var alignPixel = helpers$1._alignPixel;
        var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
        var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
        var width, color, i, ilen, item;
        for (i = 0, ilen = items.length; i < ilen; ++i) {
          item = items[i];
          width = item.width;
          color = item.color;
          if (width && color) {
            ctx.save();
            ctx.lineWidth = width;
            ctx.strokeStyle = color;
            if (ctx.setLineDash) {
              ctx.setLineDash(item.borderDash);
              ctx.lineDashOffset = item.borderDashOffset;
            }
            ctx.beginPath();
            if (gridLines.drawTicks) {
              ctx.moveTo(item.tx1, item.ty1);
              ctx.lineTo(item.tx2, item.ty2);
            }
            if (gridLines.drawOnChartArea) {
              ctx.moveTo(item.x1, item.y1);
              ctx.lineTo(item.x2, item.y2);
            }
            ctx.stroke();
            ctx.restore();
          }
        }
        if (axisWidth) {
          var firstLineWidth = axisWidth;
          var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
          var borderValue = items.borderValue;
          var x1, x2, y1, y2;
          if (me.isHorizontal()) {
            x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
            x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
          } else {
            y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
            y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
          }
          ctx.lineWidth = axisWidth;
          ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
          ctx.beginPath();
          ctx.moveTo(x1, y1);
          ctx.lineTo(x2, y2);
          ctx.stroke();
        }
      },
      _drawLabels: function _drawLabels() {
        var me = this;
        var optionTicks = me.options.ticks;
        if (!optionTicks.display) {
          return;
        }
        var ctx = me.ctx;
        var items = me._labelItems || (me._labelItems = me._computeLabelItems());
        var i, j, ilen, jlen, item, tickFont, label, y;
        for (i = 0, ilen = items.length; i < ilen; ++i) {
          item = items[i];
          tickFont = item.font;
          ctx.save();
          ctx.translate(item.x, item.y);
          ctx.rotate(item.rotation);
          ctx.font = tickFont.string;
          ctx.fillStyle = tickFont.color;
          ctx.textBaseline = 'middle';
          ctx.textAlign = item.textAlign;
          label = item.label;
          y = item.textOffset;
          if (isArray(label)) {
            for (j = 0, jlen = label.length; j < jlen; ++j) {
              ctx.fillText('' + label[j], 0, y);
              y += tickFont.lineHeight;
            }
          } else {
            ctx.fillText(label, 0, y);
          }
          ctx.restore();
        }
      },
      _drawTitle: function _drawTitle() {
        var me = this;
        var ctx = me.ctx;
        var options = me.options;
        var scaleLabel = options.scaleLabel;
        if (!scaleLabel.display) {
          return;
        }
        var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
        var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
        var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
        var halfLineHeight = scaleLabelFont.lineHeight / 2;
        var position = options.position;
        var rotation = 0;
        var scaleLabelX, scaleLabelY;
        if (me.isHorizontal()) {
          scaleLabelX = me.left + me.width / 2;
          scaleLabelY = position === 'bottom' ? me.bottom - halfLineHeight - scaleLabelPadding.bottom : me.top + halfLineHeight + scaleLabelPadding.top;
        } else {
          var isLeft = position === 'left';
          scaleLabelX = isLeft ? me.left + halfLineHeight + scaleLabelPadding.top : me.right - halfLineHeight - scaleLabelPadding.top;
          scaleLabelY = me.top + me.height / 2;
          rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
        }
        ctx.save();
        ctx.translate(scaleLabelX, scaleLabelY);
        ctx.rotate(rotation);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = scaleLabelFontColor;
        ctx.font = scaleLabelFont.string;
        ctx.fillText(scaleLabel.labelString, 0, 0);
        ctx.restore();
      },
      draw: function draw(chartArea) {
        var me = this;
        if (!me._isVisible()) {
          return;
        }
        me._drawGrid(chartArea);
        me._drawTitle();
        me._drawLabels();
      },
      _layers: function _layers() {
        var me = this;
        var opts = me.options;
        var tz = opts.ticks && opts.ticks.z || 0;
        var gz = opts.gridLines && opts.gridLines.z || 0;
        if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
          return [{
            z: tz,
            draw: function draw() {
              me.draw.apply(me, arguments);
            }
          }];
        }
        return [{
          z: gz,
          draw: function draw() {
            me._drawGrid.apply(me, arguments);
            me._drawTitle.apply(me, arguments);
          }
        }, {
          z: tz,
          draw: function draw() {
            me._drawLabels.apply(me, arguments);
          }
        }];
      },
      _getMatchingVisibleMetas: function _getMatchingVisibleMetas(type) {
        var me = this;
        var isHorizontal = me.isHorizontal();
        return me.chart._getSortedVisibleDatasetMetas().filter(function (meta) {
          return (!type || meta.type === type) && (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
        });
      }
    });
    Scale.prototype._draw = Scale.prototype.draw;
    var core_scale = Scale;
    var isNullOrUndef$1 = helpers$1.isNullOrUndef;
    var defaultConfig = {
      position: 'bottom'
    };
    var scale_category = core_scale.extend({
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var labels = me._getLabels();
        var ticksOpts = me.options.ticks;
        var min = ticksOpts.min;
        var max = ticksOpts.max;
        var minIndex = 0;
        var maxIndex = labels.length - 1;
        var findIndex;
        if (min !== undefined) {
          findIndex = labels.indexOf(min);
          if (findIndex >= 0) {
            minIndex = findIndex;
          }
        }
        if (max !== undefined) {
          findIndex = labels.indexOf(max);
          if (findIndex >= 0) {
            maxIndex = findIndex;
          }
        }
        me.minIndex = minIndex;
        me.maxIndex = maxIndex;
        me.min = labels[minIndex];
        me.max = labels[maxIndex];
      },
      buildTicks: function buildTicks() {
        var me = this;
        var labels = me._getLabels();
        var minIndex = me.minIndex;
        var maxIndex = me.maxIndex;
        me.ticks = minIndex === 0 && maxIndex === labels.length - 1 ? labels : labels.slice(minIndex, maxIndex + 1);
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        var me = this;
        var chart = me.chart;
        if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
          return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
        }
        return me._getLabels()[index];
      },
      _configure: function _configure() {
        var me = this;
        var offset = me.options.offset;
        var ticks = me.ticks;
        core_scale.prototype._configure.call(me);
        if (!me.isHorizontal()) {
          me._reversePixels = !me._reversePixels;
        }
        if (!ticks) {
          return;
        }
        me._startValue = me.minIndex - (offset ? 0.5 : 0);
        me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
      },
      getPixelForValue: function getPixelForValue(value, index, datasetIndex) {
        var me = this;
        var valueCategory, labels, idx;
        if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
          value = me.chart.data.datasets[datasetIndex].data[index];
        }
        if (!isNullOrUndef$1(value)) {
          valueCategory = me.isHorizontal() ? value.x : value.y;
        }
        if (valueCategory !== undefined || value !== undefined && isNaN(index)) {
          labels = me._getLabels();
          value = helpers$1.valueOrDefault(valueCategory, value);
          idx = labels.indexOf(value);
          index = idx !== -1 ? idx : index;
          if (isNaN(index)) {
            index = value;
          }
        }
        return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.ticks;
        return index < 0 || index > ticks.length - 1 ? null : this.getPixelForValue(ticks[index], index + this.minIndex);
      },
      getValueForPixel: function getValueForPixel(pixel) {
        var me = this;
        var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
        return Math.min(Math.max(value, 0), me.ticks.length - 1);
      },
      getBasePixel: function getBasePixel() {
        return this.bottom;
      }
    });
    var _defaults = defaultConfig;
    scale_category._defaults = _defaults;
    var noop = helpers$1.noop;
    var isNullOrUndef$2 = helpers$1.isNullOrUndef;
    function generateTicks(generationOptions, dataRange) {
      var ticks = [];
      var MIN_SPACING = 1e-14;
      var stepSize = generationOptions.stepSize;
      var unit = stepSize || 1;
      var maxNumSpaces = generationOptions.maxTicks - 1;
      var min = generationOptions.min;
      var max = generationOptions.max;
      var precision = generationOptions.precision;
      var rmin = dataRange.min;
      var rmax = dataRange.max;
      var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
      var factor, niceMin, niceMax, numSpaces;
      if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
        return [rmin, rmax];
      }
      numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
      if (numSpaces > maxNumSpaces) {
        spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
      }
      if (stepSize || isNullOrUndef$2(precision)) {
        factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
      } else {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
      }
      niceMin = Math.floor(rmin / spacing) * spacing;
      niceMax = Math.ceil(rmax / spacing) * spacing;
      if (stepSize) {
        if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
          niceMin = min;
        }
        if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
          niceMax = max;
        }
      }
      numSpaces = (niceMax - niceMin) / spacing;
      if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
        numSpaces = Math.round(numSpaces);
      } else {
        numSpaces = Math.ceil(numSpaces);
      }
      niceMin = Math.round(niceMin * factor) / factor;
      niceMax = Math.round(niceMax * factor) / factor;
      ticks.push(isNullOrUndef$2(min) ? niceMin : min);
      for (var j = 1; j < numSpaces; ++j) {
        ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
      }
      ticks.push(isNullOrUndef$2(max) ? niceMax : max);
      return ticks;
    }
    var scale_linearbase = core_scale.extend({
      getRightValue: function getRightValue(value) {
        if (typeof value === 'string') {
          return +value;
        }
        return core_scale.prototype.getRightValue.call(this, value);
      },
      handleTickRangeOptions: function handleTickRangeOptions() {
        var me = this;
        var opts = me.options;
        var tickOpts = opts.ticks;
        if (tickOpts.beginAtZero) {
          var minSign = helpers$1.sign(me.min);
          var maxSign = helpers$1.sign(me.max);
          if (minSign < 0 && maxSign < 0) {
            me.max = 0;
          } else if (minSign > 0 && maxSign > 0) {
            me.min = 0;
          }
        }
        var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
        var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
        if (tickOpts.min !== undefined) {
          me.min = tickOpts.min;
        } else if (tickOpts.suggestedMin !== undefined) {
          if (me.min === null) {
            me.min = tickOpts.suggestedMin;
          } else {
            me.min = Math.min(me.min, tickOpts.suggestedMin);
          }
        }
        if (tickOpts.max !== undefined) {
          me.max = tickOpts.max;
        } else if (tickOpts.suggestedMax !== undefined) {
          if (me.max === null) {
            me.max = tickOpts.suggestedMax;
          } else {
            me.max = Math.max(me.max, tickOpts.suggestedMax);
          }
        }
        if (setMin !== setMax) {
          if (me.min >= me.max) {
            if (setMin) {
              me.max = me.min + 1;
            } else {
              me.min = me.max - 1;
            }
          }
        }
        if (me.min === me.max) {
          me.max++;
          if (!tickOpts.beginAtZero) {
            me.min--;
          }
        }
      },
      getTickLimit: function getTickLimit() {
        var me = this;
        var tickOpts = me.options.ticks;
        var stepSize = tickOpts.stepSize;
        var maxTicksLimit = tickOpts.maxTicksLimit;
        var maxTicks;
        if (stepSize) {
          maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
        } else {
          maxTicks = me._computeTickLimit();
          maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) {
          maxTicks = Math.min(maxTicksLimit, maxTicks);
        }
        return maxTicks;
      },
      _computeTickLimit: function _computeTickLimit() {
        return Number.POSITIVE_INFINITY;
      },
      handleDirectionalChanges: noop,
      buildTicks: function buildTicks() {
        var me = this;
        var opts = me.options;
        var tickOpts = opts.ticks;
        var maxTicks = me.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        var numericGeneratorOptions = {
          maxTicks: maxTicks,
          min: tickOpts.min,
          max: tickOpts.max,
          precision: tickOpts.precision,
          stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
        };
        var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
        me.handleDirectionalChanges();
        me.max = helpers$1.max(ticks);
        me.min = helpers$1.min(ticks);
        if (tickOpts.reverse) {
          ticks.reverse();
          me.start = me.max;
          me.end = me.min;
        } else {
          me.start = me.min;
          me.end = me.max;
        }
      },
      convertTicksToLabels: function convertTicksToLabels() {
        var me = this;
        me.ticksAsNumbers = me.ticks.slice();
        me.zeroLineIndex = me.ticks.indexOf(0);
        core_scale.prototype.convertTicksToLabels.call(me);
      },
      _configure: function _configure() {
        var me = this;
        var ticks = me.getTicks();
        var start = me.min;
        var end = me.max;
        var offset;
        core_scale.prototype._configure.call(me);
        if (me.options.offset && ticks.length) {
          offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
          start -= offset;
          end += offset;
        }
        me._startValue = start;
        me._endValue = end;
        me._valueRange = end - start;
      }
    });
    var defaultConfig$1 = {
      position: 'left',
      ticks: {
        callback: core_ticks.formatters.linear
      }
    };
    var DEFAULT_MIN = 0;
    var DEFAULT_MAX = 1;
    function getOrCreateStack(stacks, stacked, meta) {
      var key = [meta.type, stacked === undefined && meta.stack === undefined ? meta.index : '', meta.stack].join('.');
      if (stacks[key] === undefined) {
        stacks[key] = {
          pos: [],
          neg: []
        };
      }
      return stacks[key];
    }
    function stackData(scale, stacks, meta, data) {
      var opts = scale.options;
      var stacked = opts.stacked;
      var stack = getOrCreateStack(stacks, stacked, meta);
      var pos = stack.pos;
      var neg = stack.neg;
      var ilen = data.length;
      var i, value;
      for (i = 0; i < ilen; ++i) {
        value = scale._parseValue(data[i]);
        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
          continue;
        }
        pos[i] = pos[i] || 0;
        neg[i] = neg[i] || 0;
        if (opts.relativePoints) {
          pos[i] = 100;
        } else if (value.min < 0 || value.max < 0) {
          neg[i] += value.min;
        } else {
          pos[i] += value.max;
        }
      }
    }
    function updateMinMax(scale, meta, data) {
      var ilen = data.length;
      var i, value;
      for (i = 0; i < ilen; ++i) {
        value = scale._parseValue(data[i]);
        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
          continue;
        }
        scale.min = Math.min(scale.min, value.min);
        scale.max = Math.max(scale.max, value.max);
      }
    }
    var scale_linear = scale_linearbase.extend({
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var opts = me.options;
        var chart = me.chart;
        var datasets = chart.data.datasets;
        var metasets = me._getMatchingVisibleMetas();
        var hasStacks = opts.stacked;
        var stacks = {};
        var ilen = metasets.length;
        var i, meta, data, values;
        me.min = Number.POSITIVE_INFINITY;
        me.max = Number.NEGATIVE_INFINITY;
        if (hasStacks === undefined) {
          for (i = 0; !hasStacks && i < ilen; ++i) {
            meta = metasets[i];
            hasStacks = meta.stack !== undefined;
          }
        }
        for (i = 0; i < ilen; ++i) {
          meta = metasets[i];
          data = datasets[meta.index].data;
          if (hasStacks) {
            stackData(me, stacks, meta, data);
          } else {
            updateMinMax(me, meta, data);
          }
        }
        helpers$1.each(stacks, function (stackValues) {
          values = stackValues.pos.concat(stackValues.neg);
          me.min = Math.min(me.min, helpers$1.min(values));
          me.max = Math.max(me.max, helpers$1.max(values));
        });
        me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
        me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
        me.handleTickRangeOptions();
      },
      _computeTickLimit: function _computeTickLimit() {
        var me = this;
        var tickFont;
        if (me.isHorizontal()) {
          return Math.ceil(me.width / 40);
        }
        tickFont = helpers$1.options._parseFont(me.options.ticks);
        return Math.ceil(me.height / tickFont.lineHeight);
      },
      handleDirectionalChanges: function handleDirectionalChanges() {
        if (!this.isHorizontal()) {
          this.ticks.reverse();
        }
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
      },
      getPixelForValue: function getPixelForValue(value) {
        var me = this;
        return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
      },
      getValueForPixel: function getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.ticksAsNumbers;
        if (index < 0 || index > ticks.length - 1) {
          return null;
        }
        return this.getPixelForValue(ticks[index]);
      }
    });
    var _defaults$1 = defaultConfig$1;
    scale_linear._defaults = _defaults$1;
    var valueOrDefault$b = helpers$1.valueOrDefault;
    var log10 = helpers$1.math.log10;
    function generateTicks$1(generationOptions, dataRange) {
      var ticks = [];
      var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
      var endExp = Math.floor(log10(dataRange.max));
      var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
      var exp, significand;
      if (tickVal === 0) {
        exp = Math.floor(log10(dataRange.minNotZero));
        significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
        ticks.push(tickVal);
        tickVal = significand * Math.pow(10, exp);
      } else {
        exp = Math.floor(log10(tickVal));
        significand = Math.floor(tickVal / Math.pow(10, exp));
      }
      var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
      do {
        ticks.push(tickVal);
        ++significand;
        if (significand === 10) {
          significand = 1;
          ++exp;
          precision = exp >= 0 ? 1 : precision;
        }
        tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
      } while (exp < endExp || exp === endExp && significand < endSignificand);
      var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
      ticks.push(lastTick);
      return ticks;
    }
    var defaultConfig$2 = {
      position: 'left',
      ticks: {
        callback: core_ticks.formatters.logarithmic
      }
    };
    function nonNegativeOrDefault(value, defaultValue) {
      return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
    }
    var scale_logarithmic = core_scale.extend({
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var opts = me.options;
        var chart = me.chart;
        var datasets = chart.data.datasets;
        var isHorizontal = me.isHorizontal();
        function IDMatches(meta) {
          return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
        }
        var datasetIndex, meta, value, data, i, ilen;
        me.min = Number.POSITIVE_INFINITY;
        me.max = Number.NEGATIVE_INFINITY;
        me.minNotZero = Number.POSITIVE_INFINITY;
        var hasStacks = opts.stacked;
        if (hasStacks === undefined) {
          for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
            meta = chart.getDatasetMeta(datasetIndex);
            if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
              hasStacks = true;
              break;
            }
          }
        }
        if (opts.stacked || hasStacks) {
          var valuesPerStack = {};
          for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
            meta = chart.getDatasetMeta(datasetIndex);
            var key = [meta.type, opts.stacked === undefined && meta.stack === undefined ? datasetIndex : '', meta.stack].join('.');
            if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
              if (valuesPerStack[key] === undefined) {
                valuesPerStack[key] = [];
              }
              data = datasets[datasetIndex].data;
              for (i = 0, ilen = data.length; i < ilen; i++) {
                var values = valuesPerStack[key];
                value = me._parseValue(data[i]);
                if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
                  continue;
                }
                values[i] = values[i] || 0;
                values[i] += value.max;
              }
            }
          }
          helpers$1.each(valuesPerStack, function (valuesForType) {
            if (valuesForType.length > 0) {
              var minVal = helpers$1.min(valuesForType);
              var maxVal = helpers$1.max(valuesForType);
              me.min = Math.min(me.min, minVal);
              me.max = Math.max(me.max, maxVal);
            }
          });
        } else {
          for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
            meta = chart.getDatasetMeta(datasetIndex);
            if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
              data = datasets[datasetIndex].data;
              for (i = 0, ilen = data.length; i < ilen; i++) {
                value = me._parseValue(data[i]);
                if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
                  continue;
                }
                me.min = Math.min(value.min, me.min);
                me.max = Math.max(value.max, me.max);
                if (value.min !== 0) {
                  me.minNotZero = Math.min(value.min, me.minNotZero);
                }
              }
            }
          }
        }
        me.min = helpers$1.isFinite(me.min) ? me.min : null;
        me.max = helpers$1.isFinite(me.max) ? me.max : null;
        me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
        this.handleTickRangeOptions();
      },
      handleTickRangeOptions: function handleTickRangeOptions() {
        var me = this;
        var tickOpts = me.options.ticks;
        var DEFAULT_MIN = 1;
        var DEFAULT_MAX = 10;
        me.min = nonNegativeOrDefault(tickOpts.min, me.min);
        me.max = nonNegativeOrDefault(tickOpts.max, me.max);
        if (me.min === me.max) {
          if (me.min !== 0 && me.min !== null) {
            me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
            me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
          } else {
            me.min = DEFAULT_MIN;
            me.max = DEFAULT_MAX;
          }
        }
        if (me.min === null) {
          me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
        }
        if (me.max === null) {
          me.max = me.min !== 0 ? Math.pow(10, Math.floor(log10(me.min)) + 1) : DEFAULT_MAX;
        }
        if (me.minNotZero === null) {
          if (me.min > 0) {
            me.minNotZero = me.min;
          } else if (me.max < 1) {
            me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
          } else {
            me.minNotZero = DEFAULT_MIN;
          }
        }
      },
      buildTicks: function buildTicks() {
        var me = this;
        var tickOpts = me.options.ticks;
        var reverse = !me.isHorizontal();
        var generationOptions = {
          min: nonNegativeOrDefault(tickOpts.min),
          max: nonNegativeOrDefault(tickOpts.max)
        };
        var ticks = me.ticks = generateTicks$1(generationOptions, me);
        me.max = helpers$1.max(ticks);
        me.min = helpers$1.min(ticks);
        if (tickOpts.reverse) {
          reverse = !reverse;
          me.start = me.max;
          me.end = me.min;
        } else {
          me.start = me.min;
          me.end = me.max;
        }
        if (reverse) {
          ticks.reverse();
        }
      },
      convertTicksToLabels: function convertTicksToLabels() {
        this.tickValues = this.ticks.slice();
        core_scale.prototype.convertTicksToLabels.call(this);
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.tickValues;
        if (index < 0 || index > ticks.length - 1) {
          return null;
        }
        return this.getPixelForValue(ticks[index]);
      },
      _getFirstTickValue: function _getFirstTickValue(value) {
        var exp = Math.floor(log10(value));
        var significand = Math.floor(value / Math.pow(10, exp));
        return significand * Math.pow(10, exp);
      },
      _configure: function _configure() {
        var me = this;
        var start = me.min;
        var offset = 0;
        core_scale.prototype._configure.call(me);
        if (start === 0) {
          start = me._getFirstTickValue(me.minNotZero);
          offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
        }
        me._startValue = log10(start);
        me._valueOffset = offset;
        me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
      },
      getPixelForValue: function getPixelForValue(value) {
        var me = this;
        var decimal = 0;
        value = +me.getRightValue(value);
        if (value > me.min && value > 0) {
          decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
        }
        return me.getPixelForDecimal(decimal);
      },
      getValueForPixel: function getValueForPixel(pixel) {
        var me = this;
        var decimal = me.getDecimalForPixel(pixel);
        return decimal === 0 && me.min === 0 ? 0 : Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
      }
    });
    var _defaults$2 = defaultConfig$2;
    scale_logarithmic._defaults = _defaults$2;
    var valueOrDefault$c = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
    var resolve$4 = helpers$1.options.resolve;
    var defaultConfig$3 = {
      display: true,
      animate: true,
      position: 'chartArea',
      angleLines: {
        display: true,
        color: 'rgba(0,0,0,0.1)',
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
      },
      gridLines: {
        circular: false
      },
      ticks: {
        showLabelBackdrop: true,
        backdropColor: 'rgba(255,255,255,0.75)',
        backdropPaddingY: 2,
        backdropPaddingX: 2,
        callback: core_ticks.formatters.linear
      },
      pointLabels: {
        display: true,
        fontSize: 10,
        callback: function callback(label) {
          return label;
        }
      }
    };
    function getTickBackdropHeight(opts) {
      var tickOpts = opts.ticks;
      if (tickOpts.display && opts.display) {
        return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
      }
      return 0;
    }
    function measureLabelSize(ctx, lineHeight, label) {
      if (helpers$1.isArray(label)) {
        return {
          w: helpers$1.longestText(ctx, ctx.font, label),
          h: label.length * lineHeight
        };
      }
      return {
        w: ctx.measureText(label).width,
        h: lineHeight
      };
    }
    function determineLimits(angle, pos, size, min, max) {
      if (angle === min || angle === max) {
        return {
          start: pos - size / 2,
          end: pos + size / 2
        };
      } else if (angle < min || angle > max) {
        return {
          start: pos - size,
          end: pos
        };
      }
      return {
        start: pos,
        end: pos + size
      };
    }
    function fitWithPointLabels(scale) {
      var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
      var furthestLimits = {
        l: 0,
        r: scale.width,
        t: 0,
        b: scale.height - scale.paddingTop
      };
      var furthestAngles = {};
      var i, textSize, pointPosition;
      scale.ctx.font = plFont.string;
      scale._pointLabelSizes = [];
      var valueCount = scale.chart.data.labels.length;
      for (i = 0; i < valueCount; i++) {
        pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
        textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
        scale._pointLabelSizes[i] = textSize;
        var angleRadians = scale.getIndexAngle(i);
        var angle = helpers$1.toDegrees(angleRadians) % 360;
        var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        if (hLimits.start < furthestLimits.l) {
          furthestLimits.l = hLimits.start;
          furthestAngles.l = angleRadians;
        }
        if (hLimits.end > furthestLimits.r) {
          furthestLimits.r = hLimits.end;
          furthestAngles.r = angleRadians;
        }
        if (vLimits.start < furthestLimits.t) {
          furthestLimits.t = vLimits.start;
          furthestAngles.t = angleRadians;
        }
        if (vLimits.end > furthestLimits.b) {
          furthestLimits.b = vLimits.end;
          furthestAngles.b = angleRadians;
        }
      }
      scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
    }
    function getTextAlignForAngle(angle) {
      if (angle === 0 || angle === 180) {
        return 'center';
      } else if (angle < 180) {
        return 'left';
      }
      return 'right';
    }
    function fillText(ctx, text, position, lineHeight) {
      var y = position.y + lineHeight / 2;
      var i, ilen;
      if (helpers$1.isArray(text)) {
        for (i = 0, ilen = text.length; i < ilen; ++i) {
          ctx.fillText(text[i], position.x, y);
          y += lineHeight;
        }
      } else {
        ctx.fillText(text, position.x, y);
      }
    }
    function adjustPointPositionForLabelHeight(angle, textSize, position) {
      if (angle === 90 || angle === 270) {
        position.y -= textSize.h / 2;
      } else if (angle > 270 || angle < 90) {
        position.y -= textSize.h;
      }
    }
    function drawPointLabels(scale) {
      var ctx = scale.ctx;
      var opts = scale.options;
      var pointLabelOpts = opts.pointLabels;
      var tickBackdropHeight = getTickBackdropHeight(opts);
      var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
      var plFont = helpers$1.options._parseFont(pointLabelOpts);
      ctx.save();
      ctx.font = plFont.string;
      ctx.textBaseline = 'middle';
      for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
        var extra = i === 0 ? tickBackdropHeight / 2 : 0;
        var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
        var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
        ctx.fillStyle = pointLabelFontColor;
        var angleRadians = scale.getIndexAngle(i);
        var angle = helpers$1.toDegrees(angleRadians);
        ctx.textAlign = getTextAlignForAngle(angle);
        adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
        fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
      }
      ctx.restore();
    }
    function drawRadiusLine(scale, gridLineOpts, radius, index) {
      var ctx = scale.ctx;
      var circular = gridLineOpts.circular;
      var valueCount = scale.chart.data.labels.length;
      var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
      var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
      var pointPosition;
      if (!circular && !valueCount || !lineColor || !lineWidth) {
        return;
      }
      ctx.save();
      ctx.strokeStyle = lineColor;
      ctx.lineWidth = lineWidth;
      if (ctx.setLineDash) {
        ctx.setLineDash(gridLineOpts.borderDash || []);
        ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
      }
      ctx.beginPath();
      if (circular) {
        ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
      } else {
        pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for (var i = 1; i < valueCount; i++) {
          pointPosition = scale.getPointPosition(i, radius);
          ctx.lineTo(pointPosition.x, pointPosition.y);
        }
      }
      ctx.closePath();
      ctx.stroke();
      ctx.restore();
    }
    function numberOrZero(param) {
      return helpers$1.isNumber(param) ? param : 0;
    }
    var scale_radialLinear = scale_linearbase.extend({
      setDimensions: function setDimensions() {
        var me = this;
        me.width = me.maxWidth;
        me.height = me.maxHeight;
        me.paddingTop = getTickBackdropHeight(me.options) / 2;
        me.xCenter = Math.floor(me.width / 2);
        me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
        me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
      },
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var chart = me.chart;
        var min = Number.POSITIVE_INFINITY;
        var max = Number.NEGATIVE_INFINITY;
        helpers$1.each(chart.data.datasets, function (dataset, datasetIndex) {
          if (chart.isDatasetVisible(datasetIndex)) {
            var meta = chart.getDatasetMeta(datasetIndex);
            helpers$1.each(dataset.data, function (rawValue, index) {
              var value = +me.getRightValue(rawValue);
              if (isNaN(value) || meta.data[index].hidden) {
                return;
              }
              min = Math.min(value, min);
              max = Math.max(value, max);
            });
          }
        });
        me.min = min === Number.POSITIVE_INFINITY ? 0 : min;
        me.max = max === Number.NEGATIVE_INFINITY ? 0 : max;
        me.handleTickRangeOptions();
      },
      _computeTickLimit: function _computeTickLimit() {
        return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
      },
      convertTicksToLabels: function convertTicksToLabels() {
        var me = this;
        scale_linearbase.prototype.convertTicksToLabels.call(me);
        me.pointLabels = me.chart.data.labels.map(function () {
          var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
          return label || label === 0 ? label : '';
        });
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
      },
      fit: function fit() {
        var me = this;
        var opts = me.options;
        if (opts.display && opts.pointLabels.display) {
          fitWithPointLabels(me);
        } else {
          me.setCenterPoint(0, 0, 0, 0);
        }
      },
      setReductions: function setReductions(largestPossibleRadius, furthestLimits, furthestAngles) {
        var me = this;
        var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
        var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
        var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
        var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
        radiusReductionLeft = numberOrZero(radiusReductionLeft);
        radiusReductionRight = numberOrZero(radiusReductionRight);
        radiusReductionTop = numberOrZero(radiusReductionTop);
        radiusReductionBottom = numberOrZero(radiusReductionBottom);
        me.drawingArea = Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
        me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
      },
      setCenterPoint: function setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        var me = this;
        var maxRight = me.width - rightMovement - me.drawingArea;
        var maxLeft = leftMovement + me.drawingArea;
        var maxTop = topMovement + me.drawingArea;
        var maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;
        me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
        me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
      },
      getIndexAngle: function getIndexAngle(index) {
        var chart = this.chart;
        var angleMultiplier = 360 / chart.data.labels.length;
        var options = chart.options || {};
        var startAngle = options.startAngle || 0;
        var angle = (index * angleMultiplier + startAngle) % 360;
        return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
      },
      getDistanceFromCenterForValue: function getDistanceFromCenterForValue(value) {
        var me = this;
        if (helpers$1.isNullOrUndef(value)) {
          return NaN;
        }
        var scalingFactor = me.drawingArea / (me.max - me.min);
        if (me.options.ticks.reverse) {
          return (me.max - value) * scalingFactor;
        }
        return (value - me.min) * scalingFactor;
      },
      getPointPosition: function getPointPosition(index, distanceFromCenter) {
        var me = this;
        var thisAngle = me.getIndexAngle(index) - Math.PI / 2;
        return {
          x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
          y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
        };
      },
      getPointPositionForValue: function getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
      },
      getBasePosition: function getBasePosition(index) {
        var me = this;
        var min = me.min;
        var max = me.max;
        return me.getPointPositionForValue(index || 0, me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0);
      },
      _drawGrid: function _drawGrid() {
        var me = this;
        var ctx = me.ctx;
        var opts = me.options;
        var gridLineOpts = opts.gridLines;
        var angleLineOpts = opts.angleLines;
        var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
        var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
        var i, offset, position;
        if (opts.pointLabels.display) {
          drawPointLabels(me);
        }
        if (gridLineOpts.display) {
          helpers$1.each(me.ticks, function (label, index) {
            if (index !== 0) {
              offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
              drawRadiusLine(me, gridLineOpts, offset, index);
            }
          });
        }
        if (angleLineOpts.display && lineWidth && lineColor) {
          ctx.save();
          ctx.lineWidth = lineWidth;
          ctx.strokeStyle = lineColor;
          if (ctx.setLineDash) {
            ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
            ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
          }
          for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
            offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
            position = me.getPointPosition(i, offset);
            ctx.beginPath();
            ctx.moveTo(me.xCenter, me.yCenter);
            ctx.lineTo(position.x, position.y);
            ctx.stroke();
          }
          ctx.restore();
        }
      },
      _drawLabels: function _drawLabels() {
        var me = this;
        var ctx = me.ctx;
        var opts = me.options;
        var tickOpts = opts.ticks;
        if (!tickOpts.display) {
          return;
        }
        var startAngle = me.getIndexAngle(0);
        var tickFont = helpers$1.options._parseFont(tickOpts);
        var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
        var offset, width;
        ctx.save();
        ctx.font = tickFont.string;
        ctx.translate(me.xCenter, me.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        helpers$1.each(me.ticks, function (label, index) {
          if (index === 0 && !tickOpts.reverse) {
            return;
          }
          offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
          if (tickOpts.showLabelBackdrop) {
            width = ctx.measureText(label).width;
            ctx.fillStyle = tickOpts.backdropColor;
            ctx.fillRect(-width / 2 - tickOpts.backdropPaddingX, -offset - tickFont.size / 2 - tickOpts.backdropPaddingY, width + tickOpts.backdropPaddingX * 2, tickFont.size + tickOpts.backdropPaddingY * 2);
          }
          ctx.fillStyle = tickFontColor;
          ctx.fillText(label, 0, -offset);
        });
        ctx.restore();
      },
      _drawTitle: helpers$1.noop
    });
    var _defaults$3 = defaultConfig$3;
    scale_radialLinear._defaults = _defaults$3;
    var deprecated$1 = helpers$1._deprecated;
    var resolve$5 = helpers$1.options.resolve;
    var valueOrDefault$d = helpers$1.valueOrDefault;
    var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
    var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
    var INTERVALS = {
      millisecond: {
        common: true,
        size: 1,
        steps: 1000
      },
      second: {
        common: true,
        size: 1000,
        steps: 60
      },
      minute: {
        common: true,
        size: 60000,
        steps: 60
      },
      hour: {
        common: true,
        size: 3600000,
        steps: 24
      },
      day: {
        common: true,
        size: 86400000,
        steps: 30
      },
      week: {
        common: false,
        size: 604800000,
        steps: 4
      },
      month: {
        common: true,
        size: 2.628e9,
        steps: 12
      },
      quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
      },
      year: {
        common: true,
        size: 3.154e10
      }
    };
    var UNITS = Object.keys(INTERVALS);
    function sorter(a, b) {
      return a - b;
    }
    function arrayUnique(items) {
      var hash = {};
      var out = [];
      var i, ilen, item;
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        item = items[i];
        if (!hash[item]) {
          hash[item] = true;
          out.push(item);
        }
      }
      return out;
    }
    function getMin(options) {
      return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
    }
    function getMax(options) {
      return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
    }
    function buildLookupTable(timestamps, min, max, distribution) {
      if (distribution === 'linear' || !timestamps.length) {
        return [{
          time: min,
          pos: 0
        }, {
          time: max,
          pos: 1
        }];
      }
      var table = [];
      var items = [min];
      var i, ilen, prev, curr, next;
      for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
        curr = timestamps[i];
        if (curr > min && curr < max) {
          items.push(curr);
        }
      }
      items.push(max);
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        next = items[i + 1];
        prev = items[i - 1];
        curr = items[i];
        if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
          table.push({
            time: curr,
            pos: i / (ilen - 1)
          });
        }
      }
      return table;
    }
    function lookup(table, key, value) {
      var lo = 0;
      var hi = table.length - 1;
      var mid, i0, i1;
      while (lo >= 0 && lo <= hi) {
        mid = lo + hi >> 1;
        i0 = table[mid - 1] || null;
        i1 = table[mid];
        if (!i0) {
          return {
            lo: null,
            hi: i1
          };
        } else if (i1[key] < value) {
          lo = mid + 1;
        } else if (i0[key] > value) {
          hi = mid - 1;
        } else {
          return {
            lo: i0,
            hi: i1
          };
        }
      }
      return {
        lo: i1,
        hi: null
      };
    }
    function interpolate$1(table, skey, sval, tkey) {
      var range = lookup(table, skey, sval);
      var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
      var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
      var span = next[skey] - prev[skey];
      var ratio = span ? (sval - prev[skey]) / span : 0;
      var offset = (next[tkey] - prev[tkey]) * ratio;
      return prev[tkey] + offset;
    }
    function toTimestamp(scale, input) {
      var adapter = scale._adapter;
      var options = scale.options.time;
      var parser = options.parser;
      var format = parser || options.format;
      var value = input;
      if (typeof parser === 'function') {
        value = parser(value);
      }
      if (!helpers$1.isFinite(value)) {
        value = typeof format === 'string' ? adapter.parse(value, format) : adapter.parse(value);
      }
      if (value !== null) {
        return +value;
      }
      if (!parser && typeof format === 'function') {
        value = format(input);
        if (!helpers$1.isFinite(value)) {
          value = adapter.parse(value);
        }
      }
      return value;
    }
    function parse(scale, input) {
      if (helpers$1.isNullOrUndef(input)) {
        return null;
      }
      var options = scale.options.time;
      var value = toTimestamp(scale, scale.getRightValue(input));
      if (value === null) {
        return value;
      }
      if (options.round) {
        value = +scale._adapter.startOf(value, options.round);
      }
      return value;
    }
    function determineUnitForAutoTicks(minUnit, min, max, capacity) {
      var ilen = UNITS.length;
      var i, interval, factor;
      for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
        interval = INTERVALS[UNITS[i]];
        factor = interval.steps ? interval.steps : MAX_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
          return UNITS[i];
        }
      }
      return UNITS[ilen - 1];
    }
    function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
      var i, unit;
      for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
        unit = UNITS[i];
        if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
          return unit;
        }
      }
      return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
    }
    function determineMajorUnit(unit) {
      for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
        if (INTERVALS[UNITS[i]].common) {
          return UNITS[i];
        }
      }
    }
    function generate(scale, min, max, capacity) {
      var adapter = scale._adapter;
      var options = scale.options;
      var timeOpts = options.time;
      var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
      var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
      var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
      var first = min;
      var ticks = [];
      var time;
      if (weekday) {
        first = +adapter.startOf(first, 'isoWeek', weekday);
      }
      first = +adapter.startOf(first, weekday ? 'day' : minor);
      if (adapter.diff(max, min, minor) > 100000 * stepSize) {
        throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
      }
      for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
        ticks.push(time);
      }
      if (time === max || options.bounds === 'ticks') {
        ticks.push(time);
      }
      return ticks;
    }
    function computeOffsets(table, ticks, min, max, options) {
      var start = 0;
      var end = 0;
      var first, last;
      if (options.offset && ticks.length) {
        first = interpolate$1(table, 'time', ticks[0], 'pos');
        if (ticks.length === 1) {
          start = 1 - first;
        } else {
          start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
        }
        last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
        if (ticks.length === 1) {
          end = last;
        } else {
          end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
        }
      }
      return {
        start: start,
        end: end,
        factor: 1 / (start + 1 + end)
      };
    }
    function setMajorTicks(scale, ticks, map, majorUnit) {
      var adapter = scale._adapter;
      var first = +adapter.startOf(ticks[0].value, majorUnit);
      var last = ticks[ticks.length - 1].value;
      var major, index;
      for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
        index = map[major];
        if (index >= 0) {
          ticks[index].major = true;
        }
      }
      return ticks;
    }
    function ticksFromTimestamps(scale, values, majorUnit) {
      var ticks = [];
      var map = {};
      var ilen = values.length;
      var i, value;
      for (i = 0; i < ilen; ++i) {
        value = values[i];
        map[value] = i;
        ticks.push({
          value: value,
          major: false
        });
      }
      return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
    }
    var defaultConfig$4 = {
      position: 'bottom',
      distribution: 'linear',
      bounds: 'data',
      adapters: {},
      time: {
        parser: false,
        unit: false,
        round: false,
        displayFormat: false,
        isoWeekday: false,
        minUnit: 'millisecond',
        displayFormats: {}
      },
      ticks: {
        autoSkip: false,
        source: 'auto',
        major: {
          enabled: false
        }
      }
    };
    var scale_time = core_scale.extend({
      initialize: function initialize() {
        this.mergeTicksOptions();
        core_scale.prototype.initialize.call(this);
      },
      update: function update() {
        var me = this;
        var options = me.options;
        var time = options.time || (options.time = {});
        var adapter = me._adapter = new core_adapters._date(options.adapters.date);
        deprecated$1('time scale', time.format, 'time.format', 'time.parser');
        deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
        deprecated$1('time scale', time.max, 'time.max', 'ticks.max');
        helpers$1.mergeIf(time.displayFormats, adapter.formats());
        return core_scale.prototype.update.apply(me, arguments);
      },
      getRightValue: function getRightValue(rawValue) {
        if (rawValue && rawValue.t !== undefined) {
          rawValue = rawValue.t;
        }
        return core_scale.prototype.getRightValue.call(this, rawValue);
      },
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var chart = me.chart;
        var adapter = me._adapter;
        var options = me.options;
        var unit = options.time.unit || 'day';
        var min = MAX_INTEGER;
        var max = MIN_INTEGER;
        var timestamps = [];
        var datasets = [];
        var labels = [];
        var i, j, ilen, jlen, data, timestamp, labelsAdded;
        var dataLabels = me._getLabels();
        for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
          labels.push(parse(me, dataLabels[i]));
        }
        for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
          if (chart.isDatasetVisible(i)) {
            data = chart.data.datasets[i].data;
            if (helpers$1.isObject(data[0])) {
              datasets[i] = [];
              for (j = 0, jlen = data.length; j < jlen; ++j) {
                timestamp = parse(me, data[j]);
                timestamps.push(timestamp);
                datasets[i][j] = timestamp;
              }
            } else {
              datasets[i] = labels.slice(0);
              if (!labelsAdded) {
                timestamps = timestamps.concat(labels);
                labelsAdded = true;
              }
            }
          } else {
            datasets[i] = [];
          }
        }
        if (labels.length) {
          min = Math.min(min, labels[0]);
          max = Math.max(max, labels[labels.length - 1]);
        }
        if (timestamps.length) {
          timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
          min = Math.min(min, timestamps[0]);
          max = Math.max(max, timestamps[timestamps.length - 1]);
        }
        min = parse(me, getMin(options)) || min;
        max = parse(me, getMax(options)) || max;
        min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
        max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
        me.min = Math.min(min, max);
        me.max = Math.max(min + 1, max);
        me._table = [];
        me._timestamps = {
          data: timestamps,
          datasets: datasets,
          labels: labels
        };
      },
      buildTicks: function buildTicks() {
        var me = this;
        var min = me.min;
        var max = me.max;
        var options = me.options;
        var tickOpts = options.ticks;
        var timeOpts = options.time;
        var timestamps = me._timestamps;
        var ticks = [];
        var capacity = me.getLabelCapacity(min);
        var source = tickOpts.source;
        var distribution = options.distribution;
        var i, ilen, timestamp;
        if (source === 'data' || source === 'auto' && distribution === 'series') {
          timestamps = timestamps.data;
        } else if (source === 'labels') {
          timestamps = timestamps.labels;
        } else {
          timestamps = generate(me, min, max, capacity);
        }
        if (options.bounds === 'ticks' && timestamps.length) {
          min = timestamps[0];
          max = timestamps[timestamps.length - 1];
        }
        min = parse(me, getMin(options)) || min;
        max = parse(me, getMax(options)) || max;
        for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
          timestamp = timestamps[i];
          if (timestamp >= min && timestamp <= max) {
            ticks.push(timestamp);
          }
        }
        me.min = min;
        me.max = max;
        me._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity) : determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
        me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined : determineMajorUnit(me._unit);
        me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
        me._offsets = computeOffsets(me._table, ticks, min, max, options);
        if (tickOpts.reverse) {
          ticks.reverse();
        }
        return ticksFromTimestamps(me, ticks, me._majorUnit);
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        var me = this;
        var adapter = me._adapter;
        var data = me.chart.data;
        var timeOpts = me.options.time;
        var label = data.labels && index < data.labels.length ? data.labels[index] : '';
        var value = data.datasets[datasetIndex].data[index];
        if (helpers$1.isObject(value)) {
          label = me.getRightValue(value);
        }
        if (timeOpts.tooltipFormat) {
          return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
        }
        if (typeof label === 'string') {
          return label;
        }
        return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
      },
      tickFormatFunction: function tickFormatFunction(time, index, ticks, format) {
        var me = this;
        var adapter = me._adapter;
        var options = me.options;
        var formats = options.time.displayFormats;
        var minorFormat = formats[me._unit];
        var majorUnit = me._majorUnit;
        var majorFormat = formats[majorUnit];
        var tick = ticks[index];
        var tickOpts = options.ticks;
        var major = majorUnit && majorFormat && tick && tick.major;
        var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
        var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
        var formatter = resolve$5([nestedTickOpts.callback, nestedTickOpts.userCallback, tickOpts.callback, tickOpts.userCallback]);
        return formatter ? formatter(label, index, ticks) : label;
      },
      convertTicksToLabels: function convertTicksToLabels(ticks) {
        var labels = [];
        var i, ilen;
        for (i = 0, ilen = ticks.length; i < ilen; ++i) {
          labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
        }
        return labels;
      },
      getPixelForOffset: function getPixelForOffset(time) {
        var me = this;
        var offsets = me._offsets;
        var pos = interpolate$1(me._table, 'time', time, 'pos');
        return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
      },
      getPixelForValue: function getPixelForValue(value, index, datasetIndex) {
        var me = this;
        var time = null;
        if (index !== undefined && datasetIndex !== undefined) {
          time = me._timestamps.datasets[datasetIndex][index];
        }
        if (time === null) {
          time = parse(me, value);
        }
        if (time !== null) {
          return me.getPixelForOffset(time);
        }
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.getTicks();
        return index >= 0 && index < ticks.length ? this.getPixelForOffset(ticks[index].value) : null;
      },
      getValueForPixel: function getValueForPixel(pixel) {
        var me = this;
        var offsets = me._offsets;
        var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        var time = interpolate$1(me._table, 'pos', pos, 'time');
        return me._adapter._create(time);
      },
      _getLabelSize: function _getLabelSize(label) {
        var me = this;
        var ticksOpts = me.options.ticks;
        var tickLabelWidth = me.ctx.measureText(label).width;
        var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        var cosRotation = Math.cos(angle);
        var sinRotation = Math.sin(angle);
        var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
        return {
          w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
          h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
      },
      getLabelWidth: function getLabelWidth(label) {
        return this._getLabelSize(label).w;
      },
      getLabelCapacity: function getLabelCapacity(exampleTime) {
        var me = this;
        var timeOpts = me.options.time;
        var displayFormats = timeOpts.displayFormats;
        var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
        var size = me._getLabelSize(exampleLabel);
        var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
        if (me.options.offset) {
          capacity--;
        }
        return capacity > 0 ? capacity : 1;
      }
    });
    var _defaults$4 = defaultConfig$4;
    scale_time._defaults = _defaults$4;
    var scales = {
      category: scale_category,
      linear: scale_linear,
      logarithmic: scale_logarithmic,
      radialLinear: scale_radialLinear,
      time: scale_time
    };
    var FORMATS = {
      datetime: 'MMM D, YYYY, h:mm:ss a',
      millisecond: 'h:mm:ss.SSS a',
      second: 'h:mm:ss a',
      minute: 'h:mm a',
      hour: 'hA',
      day: 'MMM D',
      week: 'll',
      month: 'MMM YYYY',
      quarter: '[Q]Q - YYYY',
      year: 'YYYY'
    };
    core_adapters._date.override(typeof moment === 'function' ? {
      _id: 'moment',
      formats: function formats() {
        return FORMATS;
      },
      parse: function parse(value, format) {
        if (typeof value === 'string' && typeof format === 'string') {
          value = moment(value, format);
        } else if (!(value instanceof moment)) {
          value = moment(value);
        }
        return value.isValid() ? value.valueOf() : null;
      },
      format: function format(time, _format) {
        return moment(time).format(_format);
      },
      add: function add(time, amount, unit) {
        return moment(time).add(amount, unit).valueOf();
      },
      diff: function diff(max, min, unit) {
        return moment(max).diff(moment(min), unit);
      },
      startOf: function startOf(time, unit, weekday) {
        time = moment(time);
        if (unit === 'isoWeek') {
          return time.isoWeekday(weekday).valueOf();
        }
        return time.startOf(unit).valueOf();
      },
      endOf: function endOf(time, unit) {
        return moment(time).endOf(unit).valueOf();
      },
      _create: function _create(time) {
        return moment(time);
      }
    } : {});
    core_defaults._set('global', {
      plugins: {
        filler: {
          propagate: true
        }
      }
    });
    var mappers = {
      dataset: function dataset(source) {
        var index = source.fill;
        var chart = source.chart;
        var meta = chart.getDatasetMeta(index);
        var visible = meta && chart.isDatasetVisible(index);
        var points = visible && meta.dataset._children || [];
        var length = points.length || 0;
        return !length ? null : function (point, i) {
          return i < length && points[i]._view || null;
        };
      },
      boundary: function boundary(source) {
        var boundary = source.boundary;
        var x = boundary ? boundary.x : null;
        var y = boundary ? boundary.y : null;
        if (helpers$1.isArray(boundary)) {
          return function (point, i) {
            return boundary[i];
          };
        }
        return function (point) {
          return {
            x: x === null ? point.x : x,
            y: y === null ? point.y : y
          };
        };
      }
    };
    function decodeFill(el, index, count) {
      var model = el._model || {};
      var fill = model.fill;
      var target;
      if (fill === undefined) {
        fill = !!model.backgroundColor;
      }
      if (fill === false || fill === null) {
        return false;
      }
      if (fill === true) {
        return 'origin';
      }
      target = parseFloat(fill, 10);
      if (isFinite(target) && Math.floor(target) === target) {
        if (fill[0] === '-' || fill[0] === '+') {
          target = index + target;
        }
        if (target === index || target < 0 || target >= count) {
          return false;
        }
        return target;
      }
      switch (fill) {
        case 'bottom':
          return 'start';
        case 'top':
          return 'end';
        case 'zero':
          return 'origin';
        case 'origin':
        case 'start':
        case 'end':
          return fill;
        default:
          return false;
      }
    }
    function computeLinearBoundary(source) {
      var model = source.el._model || {};
      var scale = source.el._scale || {};
      var fill = source.fill;
      var target = null;
      var horizontal;
      if (isFinite(fill)) {
        return null;
      }
      if (fill === 'start') {
        target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
      } else if (fill === 'end') {
        target = model.scaleTop === undefined ? scale.top : model.scaleTop;
      } else if (model.scaleZero !== undefined) {
        target = model.scaleZero;
      } else if (scale.getBasePixel) {
        target = scale.getBasePixel();
      }
      if (target !== undefined && target !== null) {
        if (target.x !== undefined && target.y !== undefined) {
          return target;
        }
        if (helpers$1.isFinite(target)) {
          horizontal = scale.isHorizontal();
          return {
            x: horizontal ? target : null,
            y: horizontal ? null : target
          };
        }
      }
      return null;
    }
    function computeCircularBoundary(source) {
      var scale = source.el._scale;
      var options = scale.options;
      var length = scale.chart.data.labels.length;
      var fill = source.fill;
      var target = [];
      var start, end, center, i, point;
      if (!length) {
        return null;
      }
      start = options.ticks.reverse ? scale.max : scale.min;
      end = options.ticks.reverse ? scale.min : scale.max;
      center = scale.getPointPositionForValue(0, start);
      for (i = 0; i < length; ++i) {
        point = fill === 'start' || fill === 'end' ? scale.getPointPositionForValue(i, fill === 'start' ? start : end) : scale.getBasePosition(i);
        if (options.gridLines.circular) {
          point.cx = center.x;
          point.cy = center.y;
          point.angle = scale.getIndexAngle(i) - Math.PI / 2;
        }
        target.push(point);
      }
      return target;
    }
    function computeBoundary(source) {
      var scale = source.el._scale || {};
      if (scale.getPointPositionForValue) {
        return computeCircularBoundary(source);
      }
      return computeLinearBoundary(source);
    }
    function resolveTarget(sources, index, propagate) {
      var source = sources[index];
      var fill = source.fill;
      var visited = [index];
      var target;
      if (!propagate) {
        return fill;
      }
      while (fill !== false && visited.indexOf(fill) === -1) {
        if (!isFinite(fill)) {
          return fill;
        }
        target = sources[fill];
        if (!target) {
          return false;
        }
        if (target.visible) {
          return fill;
        }
        visited.push(fill);
        fill = target.fill;
      }
      return false;
    }
    function createMapper(source) {
      var fill = source.fill;
      var type = 'dataset';
      if (fill === false) {
        return null;
      }
      if (!isFinite(fill)) {
        type = 'boundary';
      }
      return mappers[type](source);
    }
    function isDrawable(point) {
      return point && !point.skip;
    }
    function drawArea(ctx, curve0, curve1, len0, len1) {
      var i, cx, cy, r;
      if (!len0 || !len1) {
        return;
      }
      ctx.moveTo(curve0[0].x, curve0[0].y);
      for (i = 1; i < len0; ++i) {
        helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
      }
      if (curve1[0].angle !== undefined) {
        cx = curve1[0].cx;
        cy = curve1[0].cy;
        r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
        for (i = len1 - 1; i > 0; --i) {
          ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
        }
        return;
      }
      ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
      for (i = len1 - 1; i > 0; --i) {
        helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
      }
    }
    function doFill(ctx, points, mapper, view, color, loop) {
      var count = points.length;
      var span = view.spanGaps;
      var curve0 = [];
      var curve1 = [];
      var len0 = 0;
      var len1 = 0;
      var i, ilen, index, p0, p1, d0, d1, loopOffset;
      ctx.beginPath();
      for (i = 0, ilen = count; i < ilen; ++i) {
        index = i % count;
        p0 = points[index]._view;
        p1 = mapper(p0, index, view);
        d0 = isDrawable(p0);
        d1 = isDrawable(p1);
        if (loop && loopOffset === undefined && d0) {
          loopOffset = i + 1;
          ilen = count + loopOffset;
        }
        if (d0 && d1) {
          len0 = curve0.push(p0);
          len1 = curve1.push(p1);
        } else if (len0 && len1) {
          if (!span) {
            drawArea(ctx, curve0, curve1, len0, len1);
            len0 = len1 = 0;
            curve0 = [];
            curve1 = [];
          } else {
            if (d0) {
              curve0.push(p0);
            }
            if (d1) {
              curve1.push(p1);
            }
          }
        }
      }
      drawArea(ctx, curve0, curve1, len0, len1);
      ctx.closePath();
      ctx.fillStyle = color;
      ctx.fill();
    }
    var plugin_filler = {
      id: 'filler',
      afterDatasetsUpdate: function afterDatasetsUpdate(chart, options) {
        var count = (chart.data.datasets || []).length;
        var propagate = options.propagate;
        var sources = [];
        var meta, i, el, source;
        for (i = 0; i < count; ++i) {
          meta = chart.getDatasetMeta(i);
          el = meta.dataset;
          source = null;
          if (el && el._model && el instanceof elements.Line) {
            source = {
              visible: chart.isDatasetVisible(i),
              fill: decodeFill(el, i, count),
              chart: chart,
              el: el
            };
          }
          meta.$filler = source;
          sources.push(source);
        }
        for (i = 0; i < count; ++i) {
          source = sources[i];
          if (!source) {
            continue;
          }
          source.fill = resolveTarget(sources, i, propagate);
          source.boundary = computeBoundary(source);
          source.mapper = createMapper(source);
        }
      },
      beforeDatasetsDraw: function beforeDatasetsDraw(chart) {
        var metasets = chart._getSortedVisibleDatasetMetas();
        var ctx = chart.ctx;
        var meta, i, el, view, points, mapper, color;
        for (i = metasets.length - 1; i >= 0; --i) {
          meta = metasets[i].$filler;
          if (!meta || !meta.visible) {
            continue;
          }
          el = meta.el;
          view = el._view;
          points = el._children || [];
          mapper = meta.mapper;
          color = view.backgroundColor || core_defaults.global.defaultColor;
          if (mapper && color && points.length) {
            helpers$1.canvas.clipArea(ctx, chart.chartArea);
            doFill(ctx, points, mapper, view, color, el._loop);
            helpers$1.canvas.unclipArea(ctx);
          }
        }
      }
    };
    var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
    var noop$1 = helpers$1.noop;
    var valueOrDefault$e = helpers$1.valueOrDefault;
    core_defaults._set('global', {
      legend: {
        display: true,
        position: 'top',
        align: 'center',
        fullWidth: true,
        reverse: false,
        weight: 1000,
        onClick: function onClick(e, legendItem) {
          var index = legendItem.datasetIndex;
          var ci = this.chart;
          var meta = ci.getDatasetMeta(index);
          meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
          ci.update();
        },
        onHover: null,
        onLeave: null,
        labels: {
          boxWidth: 40,
          padding: 10,
          generateLabels: function generateLabels(chart) {
            var datasets = chart.data.datasets;
            var options = chart.options.legend || {};
            var usePointStyle = options.labels && options.labels.usePointStyle;
            return chart._getSortedDatasetMetas().map(function (meta) {
              var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
              return {
                text: datasets[meta.index].label,
                fillStyle: style.backgroundColor,
                hidden: !chart.isDatasetVisible(meta.index),
                lineCap: style.borderCapStyle,
                lineDash: style.borderDash,
                lineDashOffset: style.borderDashOffset,
                lineJoin: style.borderJoinStyle,
                lineWidth: style.borderWidth,
                strokeStyle: style.borderColor,
                pointStyle: style.pointStyle,
                rotation: style.rotation,
                datasetIndex: meta.index
              };
            }, this);
          }
        }
      },
      legendCallback: function legendCallback(chart) {
        var list = document.createElement('ul');
        var datasets = chart.data.datasets;
        var i, ilen, listItem, listItemSpan;
        list.setAttribute('class', chart.id + '-legend');
        for (i = 0, ilen = datasets.length; i < ilen; i++) {
          listItem = list.appendChild(document.createElement('li'));
          listItemSpan = listItem.appendChild(document.createElement('span'));
          listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
          if (datasets[i].label) {
            listItem.appendChild(document.createTextNode(datasets[i].label));
          }
        }
        return list.outerHTML;
      }
    });
    function getBoxWidth(labelOpts, fontSize) {
      return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ? fontSize : labelOpts.boxWidth;
    }
    var Legend = core_element.extend({
      initialize: function initialize(config) {
        var me = this;
        helpers$1.extend(me, config);
        me.legendHitBoxes = [];
        me._hoveredItem = null;
        me.doughnutMode = false;
      },
      beforeUpdate: noop$1,
      update: function update(maxWidth, maxHeight, margins) {
        var me = this;
        me.beforeUpdate();
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me.margins = margins;
        me.beforeSetDimensions();
        me.setDimensions();
        me.afterSetDimensions();
        me.beforeBuildLabels();
        me.buildLabels();
        me.afterBuildLabels();
        me.beforeFit();
        me.fit();
        me.afterFit();
        me.afterUpdate();
        return me.minSize;
      },
      afterUpdate: noop$1,
      beforeSetDimensions: noop$1,
      setDimensions: function setDimensions() {
        var me = this;
        if (me.isHorizontal()) {
          me.width = me.maxWidth;
          me.left = 0;
          me.right = me.width;
        } else {
          me.height = me.maxHeight;
          me.top = 0;
          me.bottom = me.height;
        }
        me.paddingLeft = 0;
        me.paddingTop = 0;
        me.paddingRight = 0;
        me.paddingBottom = 0;
        me.minSize = {
          width: 0,
          height: 0
        };
      },
      afterSetDimensions: noop$1,
      beforeBuildLabels: noop$1,
      buildLabels: function buildLabels() {
        var me = this;
        var labelOpts = me.options.labels || {};
        var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];
        if (labelOpts.filter) {
          legendItems = legendItems.filter(function (item) {
            return labelOpts.filter(item, me.chart.data);
          });
        }
        if (me.options.reverse) {
          legendItems.reverse();
        }
        me.legendItems = legendItems;
      },
      afterBuildLabels: noop$1,
      beforeFit: noop$1,
      fit: function fit() {
        var me = this;
        var opts = me.options;
        var labelOpts = opts.labels;
        var display = opts.display;
        var ctx = me.ctx;
        var labelFont = helpers$1.options._parseFont(labelOpts);
        var fontSize = labelFont.size;
        var hitboxes = me.legendHitBoxes = [];
        var minSize = me.minSize;
        var isHorizontal = me.isHorizontal();
        if (isHorizontal) {
          minSize.width = me.maxWidth;
          minSize.height = display ? 10 : 0;
        } else {
          minSize.width = display ? 10 : 0;
          minSize.height = me.maxHeight;
        }
        if (!display) {
          me.width = minSize.width = me.height = minSize.height = 0;
          return;
        }
        ctx.font = labelFont.string;
        if (isHorizontal) {
          var lineWidths = me.lineWidths = [0];
          var totalHeight = 0;
          ctx.textAlign = 'left';
          ctx.textBaseline = 'middle';
          helpers$1.each(me.legendItems, function (legendItem, i) {
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var width = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
              totalHeight += fontSize + labelOpts.padding;
              lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
            }
            hitboxes[i] = {
              left: 0,
              top: 0,
              width: width,
              height: fontSize
            };
            lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
          });
          minSize.height += totalHeight;
        } else {
          var vPadding = labelOpts.padding;
          var columnWidths = me.columnWidths = [];
          var columnHeights = me.columnHeights = [];
          var totalWidth = labelOpts.padding;
          var currentColWidth = 0;
          var currentColHeight = 0;
          helpers$1.each(me.legendItems, function (legendItem, i) {
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
              totalWidth += currentColWidth + labelOpts.padding;
              columnWidths.push(currentColWidth);
              columnHeights.push(currentColHeight);
              currentColWidth = 0;
              currentColHeight = 0;
            }
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += fontSize + vPadding;
            hitboxes[i] = {
              left: 0,
              top: 0,
              width: itemWidth,
              height: fontSize
            };
          });
          totalWidth += currentColWidth;
          columnWidths.push(currentColWidth);
          columnHeights.push(currentColHeight);
          minSize.width += totalWidth;
        }
        me.width = minSize.width;
        me.height = minSize.height;
      },
      afterFit: noop$1,
      isHorizontal: function isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
      },
      draw: function draw() {
        var me = this;
        var opts = me.options;
        var labelOpts = opts.labels;
        var globalDefaults = core_defaults.global;
        var defaultColor = globalDefaults.defaultColor;
        var lineDefault = globalDefaults.elements.line;
        var legendHeight = me.height;
        var columnHeights = me.columnHeights;
        var legendWidth = me.width;
        var lineWidths = me.lineWidths;
        if (!opts.display) {
          return;
        }
        var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
        var ctx = me.ctx;
        var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
        var labelFont = helpers$1.options._parseFont(labelOpts);
        var fontSize = labelFont.size;
        var cursor;
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.strokeStyle = fontColor;
        ctx.fillStyle = fontColor;
        ctx.font = labelFont.string;
        var boxWidth = getBoxWidth(labelOpts, fontSize);
        var hitboxes = me.legendHitBoxes;
        var drawLegendBox = function drawLegendBox(x, y, legendItem) {
          if (isNaN(boxWidth) || boxWidth <= 0) {
            return;
          }
          ctx.save();
          var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
          ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
          ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
          ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
          ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
          ctx.lineWidth = lineWidth;
          ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
          if (ctx.setLineDash) {
            ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
          }
          if (labelOpts && labelOpts.usePointStyle) {
            var radius = boxWidth * Math.SQRT2 / 2;
            var centerX = rtlHelper.xPlus(x, boxWidth / 2);
            var centerY = y + fontSize / 2;
            helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
          } else {
            ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
            if (lineWidth !== 0) {
              ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
            }
          }
          ctx.restore();
        };
        var fillText = function fillText(x, y, legendItem, textWidth) {
          var halfFontSize = fontSize / 2;
          var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
          var yMiddle = y + halfFontSize;
          ctx.fillText(legendItem.text, xLeft, yMiddle);
          if (legendItem.hidden) {
            ctx.beginPath();
            ctx.lineWidth = 2;
            ctx.moveTo(xLeft, yMiddle);
            ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
            ctx.stroke();
          }
        };
        var alignmentOffset = function alignmentOffset(dimension, blockSize) {
          switch (opts.align) {
            case 'start':
              return labelOpts.padding;
            case 'end':
              return dimension - blockSize;
            default:
              return (dimension - blockSize + labelOpts.padding) / 2;
          }
        };
        var isHorizontal = me.isHorizontal();
        if (isHorizontal) {
          cursor = {
            x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
            y: me.top + labelOpts.padding,
            line: 0
          };
        } else {
          cursor = {
            x: me.left + labelOpts.padding,
            y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
            line: 0
          };
        }
        helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
        var itemHeight = fontSize + labelOpts.padding;
        helpers$1.each(me.legendItems, function (legendItem, i) {
          var textWidth = ctx.measureText(legendItem.text).width;
          var width = boxWidth + fontSize / 2 + textWidth;
          var x = cursor.x;
          var y = cursor.y;
          rtlHelper.setWidth(me.minSize.width);
          if (isHorizontal) {
            if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
              y = cursor.y += itemHeight;
              cursor.line++;
              x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
            }
          } else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
            x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
            cursor.line++;
            y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
          }
          var realX = rtlHelper.x(x);
          drawLegendBox(realX, y, legendItem);
          hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
          hitboxes[i].top = y;
          fillText(realX, y, legendItem, textWidth);
          if (isHorizontal) {
            cursor.x += width + labelOpts.padding;
          } else {
            cursor.y += itemHeight;
          }
        });
        helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
      },
      _getLegendItemAt: function _getLegendItemAt(x, y) {
        var me = this;
        var i, hitBox, lh;
        if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
          lh = me.legendHitBoxes;
          for (i = 0; i < lh.length; ++i) {
            hitBox = lh[i];
            if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
              return me.legendItems[i];
            }
          }
        }
        return null;
      },
      handleEvent: function handleEvent(e) {
        var me = this;
        var opts = me.options;
        var type = e.type === 'mouseup' ? 'click' : e.type;
        var hoveredItem;
        if (type === 'mousemove') {
          if (!opts.onHover && !opts.onLeave) {
            return;
          }
        } else if (type === 'click') {
          if (!opts.onClick) {
            return;
          }
        } else {
          return;
        }
        hoveredItem = me._getLegendItemAt(e.x, e.y);
        if (type === 'click') {
          if (hoveredItem && opts.onClick) {
            opts.onClick.call(me, e["native"], hoveredItem);
          }
        } else {
          if (opts.onLeave && hoveredItem !== me._hoveredItem) {
            if (me._hoveredItem) {
              opts.onLeave.call(me, e["native"], me._hoveredItem);
            }
            me._hoveredItem = hoveredItem;
          }
          if (opts.onHover && hoveredItem) {
            opts.onHover.call(me, e["native"], hoveredItem);
          }
        }
      }
    });
    function createNewLegendAndAttach(chart, legendOpts) {
      var legend = new Legend({
        ctx: chart.ctx,
        options: legendOpts,
        chart: chart
      });
      core_layouts.configure(chart, legend, legendOpts);
      core_layouts.addBox(chart, legend);
      chart.legend = legend;
    }
    var plugin_legend = {
      id: 'legend',
      _element: Legend,
      beforeInit: function beforeInit(chart) {
        var legendOpts = chart.options.legend;
        if (legendOpts) {
          createNewLegendAndAttach(chart, legendOpts);
        }
      },
      beforeUpdate: function beforeUpdate(chart) {
        var legendOpts = chart.options.legend;
        var legend = chart.legend;
        if (legendOpts) {
          helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
          if (legend) {
            core_layouts.configure(chart, legend, legendOpts);
            legend.options = legendOpts;
          } else {
            createNewLegendAndAttach(chart, legendOpts);
          }
        } else if (legend) {
          core_layouts.removeBox(chart, legend);
          delete chart.legend;
        }
      },
      afterEvent: function afterEvent(chart, e) {
        var legend = chart.legend;
        if (legend) {
          legend.handleEvent(e);
        }
      }
    };
    var noop$2 = helpers$1.noop;
    core_defaults._set('global', {
      title: {
        display: false,
        fontStyle: 'bold',
        fullWidth: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
      }
    });
    var Title = core_element.extend({
      initialize: function initialize(config) {
        var me = this;
        helpers$1.extend(me, config);
        me.legendHitBoxes = [];
      },
      beforeUpdate: noop$2,
      update: function update(maxWidth, maxHeight, margins) {
        var me = this;
        me.beforeUpdate();
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me.margins = margins;
        me.beforeSetDimensions();
        me.setDimensions();
        me.afterSetDimensions();
        me.beforeBuildLabels();
        me.buildLabels();
        me.afterBuildLabels();
        me.beforeFit();
        me.fit();
        me.afterFit();
        me.afterUpdate();
        return me.minSize;
      },
      afterUpdate: noop$2,
      beforeSetDimensions: noop$2,
      setDimensions: function setDimensions() {
        var me = this;
        if (me.isHorizontal()) {
          me.width = me.maxWidth;
          me.left = 0;
          me.right = me.width;
        } else {
          me.height = me.maxHeight;
          me.top = 0;
          me.bottom = me.height;
        }
        me.paddingLeft = 0;
        me.paddingTop = 0;
        me.paddingRight = 0;
        me.paddingBottom = 0;
        me.minSize = {
          width: 0,
          height: 0
        };
      },
      afterSetDimensions: noop$2,
      beforeBuildLabels: noop$2,
      buildLabels: noop$2,
      afterBuildLabels: noop$2,
      beforeFit: noop$2,
      fit: function fit() {
        var me = this;
        var opts = me.options;
        var minSize = me.minSize = {};
        var isHorizontal = me.isHorizontal();
        var lineCount, textSize;
        if (!opts.display) {
          me.width = minSize.width = me.height = minSize.height = 0;
          return;
        }
        lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
        textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
        me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
        me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
      },
      afterFit: noop$2,
      isHorizontal: function isHorizontal() {
        var pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
      },
      draw: function draw() {
        var me = this;
        var ctx = me.ctx;
        var opts = me.options;
        if (!opts.display) {
          return;
        }
        var fontOpts = helpers$1.options._parseFont(opts);
        var lineHeight = fontOpts.lineHeight;
        var offset = lineHeight / 2 + opts.padding;
        var rotation = 0;
        var top = me.top;
        var left = me.left;
        var bottom = me.bottom;
        var right = me.right;
        var maxWidth, titleX, titleY;
        ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor);
        ctx.font = fontOpts.string;
        if (me.isHorizontal()) {
          titleX = left + (right - left) / 2;
          titleY = top + offset;
          maxWidth = right - left;
        } else {
          titleX = opts.position === 'left' ? left + offset : right - offset;
          titleY = top + (bottom - top) / 2;
          maxWidth = bottom - top;
          rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
        }
        ctx.save();
        ctx.translate(titleX, titleY);
        ctx.rotate(rotation);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        var text = opts.text;
        if (helpers$1.isArray(text)) {
          var y = 0;
          for (var i = 0; i < text.length; ++i) {
            ctx.fillText(text[i], 0, y, maxWidth);
            y += lineHeight;
          }
        } else {
          ctx.fillText(text, 0, 0, maxWidth);
        }
        ctx.restore();
      }
    });
    function createNewTitleBlockAndAttach(chart, titleOpts) {
      var title = new Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
      });
      core_layouts.configure(chart, title, titleOpts);
      core_layouts.addBox(chart, title);
      chart.titleBlock = title;
    }
    var plugin_title = {
      id: 'title',
      _element: Title,
      beforeInit: function beforeInit(chart) {
        var titleOpts = chart.options.title;
        if (titleOpts) {
          createNewTitleBlockAndAttach(chart, titleOpts);
        }
      },
      beforeUpdate: function beforeUpdate(chart) {
        var titleOpts = chart.options.title;
        var titleBlock = chart.titleBlock;
        if (titleOpts) {
          helpers$1.mergeIf(titleOpts, core_defaults.global.title);
          if (titleBlock) {
            core_layouts.configure(chart, titleBlock, titleOpts);
            titleBlock.options = titleOpts;
          } else {
            createNewTitleBlockAndAttach(chart, titleOpts);
          }
        } else if (titleBlock) {
          core_layouts.removeBox(chart, titleBlock);
          delete chart.titleBlock;
        }
      }
    };
    var plugins = {};
    var filler = plugin_filler;
    var legend = plugin_legend;
    var title = plugin_title;
    plugins.filler = filler;
    plugins.legend = legend;
    plugins.title = title;
    core_controller.helpers = helpers$1;
    core_helpers();
    core_controller._adapters = core_adapters;
    core_controller.Animation = core_animation;
    core_controller.animationService = core_animations;
    core_controller.controllers = controllers;
    core_controller.DatasetController = core_datasetController;
    core_controller.defaults = core_defaults;
    core_controller.Element = core_element;
    core_controller.elements = elements;
    core_controller.Interaction = core_interaction;
    core_controller.layouts = core_layouts;
    core_controller.platform = platform;
    core_controller.plugins = core_plugins;
    core_controller.Scale = core_scale;
    core_controller.scaleService = core_scaleService;
    core_controller.Ticks = core_ticks;
    core_controller.Tooltip = core_tooltip;
    core_controller.helpers.each(scales, function (scale, type) {
      core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
    });
    for (var k in plugins) {
      if (plugins.hasOwnProperty(k)) {
        core_controller.plugins.register(plugins[k]);
      }
    }
    core_controller.platform.initialize();
    var src = core_controller;
    if (typeof window !== 'undefined') {
      window.Chart = core_controller;
    }
    core_controller.Chart = core_controller;
    core_controller.Legend = plugins.legend._element;
    core_controller.Title = plugins.title._element;
    core_controller.pluginService = core_controller.plugins;
    core_controller.PluginBase = core_controller.Element.extend({});
    core_controller.canvasHelpers = core_controller.helpers.canvas;
    core_controller.layoutService = core_controller.layouts;
    core_controller.LinearScaleBase = scale_linearbase;
    core_controller.helpers.each(['Bar', 'Bubble', 'Doughnut', 'Line', 'PolarArea', 'Radar', 'Scatter'], function (klass) {
      core_controller[klass] = function (ctx, cfg) {
        return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
          type: klass.charAt(0).toLowerCase() + klass.slice(1)
        }));
      };
    });
    return src;
  });
});
var es$1$1$1$1 = createCommonjsModule$1$1$1(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "Chart", {
    enumerable: true,
    get: function get() {
      return _chart["default"];
    }
  });
  exports.defaults = exports.Scatter = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = exports["default"] = void 0;
  var _react = _interopRequireDefault(React__default__default__default__default);
  var _propTypes = _interopRequireDefault(propTypes$1$1$1);
  var _chart = _interopRequireDefault(Chart$1$1$1);
  var _isEqual = _interopRequireDefault(isEqual);
  var _keyBy = _interopRequireDefault(keyBy);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }
    return _typeof(obj);
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var NODE_ENV = typeof process !== 'undefined' && process.env && process.env.NODE_ENV;
  var ChartComponent = /*#__PURE__*/function (_React$Component) {
    _inherits(ChartComponent, _React$Component);
    var _super = _createSuper(ChartComponent);
    function ChartComponent() {
      var _this;
      _classCallCheck(this, ChartComponent);
      _this = _super.call(this);
      _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
        var instance = _this.chartInstance;
        var _this$props = _this.props,
          getDatasetAtEvent = _this$props.getDatasetAtEvent,
          getElementAtEvent = _this$props.getElementAtEvent,
          getElementsAtEvent = _this$props.getElementsAtEvent,
          onElementsClick = _this$props.onElementsClick;
        getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
        getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
        getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
        onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event);
      });
      _defineProperty(_assertThisInitialized(_this), "ref", function (element) {
        _this.element = element;
      });
      _this.chartInstance = undefined;
      return _this;
    }
    _createClass(ChartComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.renderChart();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        if (this.props.redraw) {
          this.destroyChart();
          this.renderChart();
          return;
        }
        this.updateChart();
      }
    }, {
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps) {
        var _this$props2 = this.props,
          type = _this$props2.type,
          options = _this$props2.options,
          plugins = _this$props2.plugins,
          legend = _this$props2.legend,
          height = _this$props2.height,
          width = _this$props2.width;
        if (nextProps.redraw === true) {
          return true;
        }
        if (height !== nextProps.height || width !== nextProps.width) {
          return true;
        }
        if (type !== nextProps.type) {
          return true;
        }
        if (!(0, _isEqual["default"])(legend, nextProps.legend)) {
          return true;
        }
        if (!(0, _isEqual["default"])(options, nextProps.options)) {
          return true;
        }
        var nextData = this.transformDataProp(nextProps);
        if (!(0, _isEqual["default"])(this.shadowDataProp, nextData)) {
          return true;
        }
        return !(0, _isEqual["default"])(plugins, nextProps.plugins);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.destroyChart();
      }
    }, {
      key: "transformDataProp",
      value: function transformDataProp(props) {
        var data = props.data;
        if (typeof data == 'function') {
          var node = this.element;
          return data(node);
        } else {
          return data;
        }
      }
    }, {
      key: "memoizeDataProps",
      value: function memoizeDataProps() {
        if (!this.props.data) {
          return;
        }
        var data = this.transformDataProp(this.props);
        this.shadowDataProp = _objectSpread(_objectSpread({}, data), {}, {
          datasets: data.datasets && data.datasets.map(function (set) {
            return _objectSpread({}, set);
          })
        });
        this.saveCurrentDatasets();
        return data;
      }
    }, {
      key: "checkDatasets",
      value: function checkDatasets(datasets) {
        var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
        var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
        var multipleDatasets = datasets.length > 1;
        if (isDev && multipleDatasets && !usingCustomKeyProvider) {
          var shouldWarn = false;
          datasets.forEach(function (dataset) {
            if (!dataset.label) {
              shouldWarn = true;
            }
          });
          if (shouldWarn) {
            console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
          }
        }
      }
    }, {
      key: "getCurrentDatasets",
      value: function getCurrentDatasets() {
        return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
      }
    }, {
      key: "saveCurrentDatasets",
      value: function saveCurrentDatasets() {
        var _this2 = this;
        this.datasets = this.datasets || {};
        var currentDatasets = this.getCurrentDatasets();
        currentDatasets.forEach(function (d) {
          _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
        });
      }
    }, {
      key: "updateChart",
      value: function updateChart() {
        var _this3 = this;
        var options = this.props.options;
        var data = this.memoizeDataProps(this.props);
        if (!this.chartInstance) return;
        if (options) {
          this.chartInstance.options = _chart["default"].helpers.configMerge(this.chartInstance.options, options);
        }
        var currentDatasets = this.getCurrentDatasets();
        var nextDatasets = data.datasets || [];
        this.checkDatasets(currentDatasets);
        var currentDatasetsIndexed = (0, _keyBy["default"])(currentDatasets, this.props.datasetKeyProvider);
        this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
          var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];
          if (current && current.type === next.type && next.data) {
            current.data.splice(next.data.length);
            next.data.forEach(function (point, pid) {
              current.data[pid] = next.data[pid];
            });
            var otherProps = _objectWithoutProperties(next, ["data"]);
            return _objectSpread(_objectSpread({}, current), otherProps);
          } else {
            return next;
          }
        });
        var rest = _objectWithoutProperties(data, ["datasets"]);
        this.chartInstance.config.data = _objectSpread(_objectSpread({}, this.chartInstance.config.data), rest);
        this.chartInstance.update();
      }
    }, {
      key: "renderChart",
      value: function renderChart() {
        var _this$props3 = this.props,
          options = _this$props3.options,
          legend = _this$props3.legend,
          type = _this$props3.type,
          plugins = _this$props3.plugins;
        var node = this.element;
        var data = this.memoizeDataProps();
        if (typeof legend !== 'undefined' && !(0, _isEqual["default"])(ChartComponent.defaultProps.legend, legend)) {
          options.legend = legend;
        }
        this.chartInstance = new _chart["default"](node, {
          type: type,
          data: data,
          options: options,
          plugins: plugins
        });
      }
    }, {
      key: "destroyChart",
      value: function destroyChart() {
        if (!this.chartInstance) {
          return;
        }
        this.saveCurrentDatasets();
        var datasets = Object.values(this.datasets);
        this.chartInstance.config.data.datasets = datasets;
        this.chartInstance.destroy();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props4 = this.props,
          height = _this$props4.height,
          width = _this$props4.width,
          id = _this$props4.id;
        return /*#__PURE__*/_react["default"].createElement("canvas", {
          ref: this.ref,
          height: height,
          width: width,
          id: id,
          onClick: this.handleOnClick
        });
      }
    }]);
    return ChartComponent;
  }(_react["default"].Component);
  _defineProperty(ChartComponent, "getLabelAsKey", function (d) {
    return d.label;
  });
  _defineProperty(ChartComponent, "propTypes", {
    data: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]).isRequired,
    getDatasetAtEvent: _propTypes["default"].func,
    getElementAtEvent: _propTypes["default"].func,
    getElementsAtEvent: _propTypes["default"].func,
    height: _propTypes["default"].number,
    legend: _propTypes["default"].object,
    onElementsClick: _propTypes["default"].func,
    options: _propTypes["default"].object,
    plugins: _propTypes["default"].arrayOf(_propTypes["default"].object),
    redraw: _propTypes["default"].bool,
    type: function type(props, propName, componentName) {
      if (!_chart["default"].controllers[props[propName]]) {
        return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
      }
    },
    width: _propTypes["default"].number,
    datasetKeyProvider: _propTypes["default"].func
  });
  _defineProperty(ChartComponent, "defaultProps", {
    legend: {
      display: true,
      position: 'bottom'
    },
    type: 'doughnut',
    height: 150,
    width: 300,
    redraw: false,
    options: {},
    datasetKeyProvider: ChartComponent.getLabelAsKey
  });
  var _default = ChartComponent;
  exports["default"] = _default;
  var Doughnut = /*#__PURE__*/function (_React$Component2) {
    _inherits(Doughnut, _React$Component2);
    var _super2 = _createSuper(Doughnut);
    function Doughnut() {
      _classCallCheck(this, Doughnut);
      return _super2.apply(this, arguments);
    }
    _createClass(Doughnut, [{
      key: "render",
      value: function render() {
        var _this4 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref) {
            return _this4.chartInstance = _ref && _ref.chartInstance;
          },
          type: "doughnut"
        }));
      }
    }]);
    return Doughnut;
  }(_react["default"].Component);
  exports.Doughnut = Doughnut;
  var Pie = /*#__PURE__*/function (_React$Component3) {
    _inherits(Pie, _React$Component3);
    var _super3 = _createSuper(Pie);
    function Pie() {
      _classCallCheck(this, Pie);
      return _super3.apply(this, arguments);
    }
    _createClass(Pie, [{
      key: "render",
      value: function render() {
        var _this5 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref2) {
            return _this5.chartInstance = _ref2 && _ref2.chartInstance;
          },
          type: "pie"
        }));
      }
    }]);
    return Pie;
  }(_react["default"].Component);
  exports.Pie = Pie;
  var Line = /*#__PURE__*/function (_React$Component4) {
    _inherits(Line, _React$Component4);
    var _super4 = _createSuper(Line);
    function Line() {
      _classCallCheck(this, Line);
      return _super4.apply(this, arguments);
    }
    _createClass(Line, [{
      key: "render",
      value: function render() {
        var _this6 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref3) {
            return _this6.chartInstance = _ref3 && _ref3.chartInstance;
          },
          type: "line"
        }));
      }
    }]);
    return Line;
  }(_react["default"].Component);
  exports.Line = Line;
  var Bar = /*#__PURE__*/function (_React$Component5) {
    _inherits(Bar, _React$Component5);
    var _super5 = _createSuper(Bar);
    function Bar() {
      _classCallCheck(this, Bar);
      return _super5.apply(this, arguments);
    }
    _createClass(Bar, [{
      key: "render",
      value: function render() {
        var _this7 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref4) {
            return _this7.chartInstance = _ref4 && _ref4.chartInstance;
          },
          type: "bar"
        }));
      }
    }]);
    return Bar;
  }(_react["default"].Component);
  exports.Bar = Bar;
  var HorizontalBar = /*#__PURE__*/function (_React$Component6) {
    _inherits(HorizontalBar, _React$Component6);
    var _super6 = _createSuper(HorizontalBar);
    function HorizontalBar() {
      _classCallCheck(this, HorizontalBar);
      return _super6.apply(this, arguments);
    }
    _createClass(HorizontalBar, [{
      key: "render",
      value: function render() {
        var _this8 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref5) {
            return _this8.chartInstance = _ref5 && _ref5.chartInstance;
          },
          type: "horizontalBar"
        }));
      }
    }]);
    return HorizontalBar;
  }(_react["default"].Component);
  exports.HorizontalBar = HorizontalBar;
  var Radar = /*#__PURE__*/function (_React$Component7) {
    _inherits(Radar, _React$Component7);
    var _super7 = _createSuper(Radar);
    function Radar() {
      _classCallCheck(this, Radar);
      return _super7.apply(this, arguments);
    }
    _createClass(Radar, [{
      key: "render",
      value: function render() {
        var _this9 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref6) {
            return _this9.chartInstance = _ref6 && _ref6.chartInstance;
          },
          type: "radar"
        }));
      }
    }]);
    return Radar;
  }(_react["default"].Component);
  exports.Radar = Radar;
  var Polar = /*#__PURE__*/function (_React$Component8) {
    _inherits(Polar, _React$Component8);
    var _super8 = _createSuper(Polar);
    function Polar() {
      _classCallCheck(this, Polar);
      return _super8.apply(this, arguments);
    }
    _createClass(Polar, [{
      key: "render",
      value: function render() {
        var _this10 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref7) {
            return _this10.chartInstance = _ref7 && _ref7.chartInstance;
          },
          type: "polarArea"
        }));
      }
    }]);
    return Polar;
  }(_react["default"].Component);
  exports.Polar = Polar;
  var Bubble = /*#__PURE__*/function (_React$Component9) {
    _inherits(Bubble, _React$Component9);
    var _super9 = _createSuper(Bubble);
    function Bubble() {
      _classCallCheck(this, Bubble);
      return _super9.apply(this, arguments);
    }
    _createClass(Bubble, [{
      key: "render",
      value: function render() {
        var _this11 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref8) {
            return _this11.chartInstance = _ref8 && _ref8.chartInstance;
          },
          type: "bubble"
        }));
      }
    }]);
    return Bubble;
  }(_react["default"].Component);
  exports.Bubble = Bubble;
  var Scatter = /*#__PURE__*/function (_React$Component10) {
    _inherits(Scatter, _React$Component10);
    var _super10 = _createSuper(Scatter);
    function Scatter() {
      _classCallCheck(this, Scatter);
      return _super10.apply(this, arguments);
    }
    _createClass(Scatter, [{
      key: "render",
      value: function render() {
        var _this12 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref9) {
            return _this12.chartInstance = _ref9 && _ref9.chartInstance;
          },
          type: "scatter"
        }));
      }
    }]);
    return Scatter;
  }(_react["default"].Component);
  exports.Scatter = Scatter;
  var defaults = _chart["default"].defaults;
  exports.defaults = defaults;
});
unwrapExports$1$1$1(es$1$1$1$1);
function r$1$1$1$1(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r$1$1$1$1(e[t])) && (n && (n += " "), n += f);else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx$1$1$1() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) (e = arguments[f++]) && (t = r$1$1$1$1(e)) && (n && (n += " "), n += t);
  return n;
}
var clsx_m$1$1$1 = {
  __proto__: null,
  clsx: clsx$1$1$1,
  'default': clsx$1$1$1
};
var require$$1$1$1$1 = getCjsExportFromNamespace$1$1$1(clsx_m$1$1$1);
var dist$1$1$1 = createCommonjsModule$1$1$1(function (module) {
  module.exports = function (n) {
    var e = {};
    function t(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return n[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }
    return t.m = n, t.c = e, t.d = function (n, e, r) {
      t.o(n, e) || Object.defineProperty(n, e, {
        enumerable: !0,
        get: r
      });
    }, t.r = function (n) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(n, "__esModule", {
        value: !0
      });
    }, t.t = function (n, e) {
      if (1 & e && (n = t(n)), 8 & e) return n;
      if (4 & e && "object" == typeof n && n && n.__esModule) return n;
      var r = Object.create(null);
      if (t.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: n
      }), 2 & e && "string" != typeof n) for (var o in n) t.d(r, o, function (e) {
        return n[e];
      }.bind(null, o));
      return r;
    }, t.n = function (n) {
      var e = n && n.__esModule ? function () {
        return n["default"];
      } : function () {
        return n;
      };
      return t.d(e, "a", e), e;
    }, t.o = function (n, e) {
      return Object.prototype.hasOwnProperty.call(n, e);
    }, t.p = "", t(t.s = 182);
  }([function (n, e, t) {
    n.exports = t(174)();
  }, function (n, e) {
    n.exports = React__default__default__default__default;
  }, function (n, e) {
    var t = Array.isArray;
    n.exports = t;
  }, function (n, e, t) {
    var r = t(40),
      o = "object" == typeof self && self && self.Object === Object && self,
      a = r || o || Function("return this")();
    n.exports = a;
  }, function (n, e, t) {
    var r = t(78),
      o = t(25),
      a = t(27),
      i = t(28);
    n.exports = function (n, e, t) {
      return n = i(n), t = null == t ? 0 : r(a(t), 0, n.length), e = o(e), n.slice(t, t + e.length) == e;
    };
  }, function (n, e, t) {
    var r = t(171)(t(23));
    n.exports = r;
  }, function (n, e, t) {
    var r = t(14),
      o = t(76),
      a = t(77),
      i = "[object Null]",
      u = "[object Undefined]",
      c = r ? r.toStringTag : void 0;
    n.exports = function (n) {
      return null == n ? void 0 === n ? u : i : c && c in Object(n) ? o(n) : a(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return null != n && "object" == typeof n;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = typeof n;
      return null != n && ("object" == e || "function" == e);
    };
  }, function (n, e, t) {
    var r = t(92),
      o = t(95);
    n.exports = function (n, e) {
      var t = o(n, e);
      return r(t) ? t : void 0;
    };
  }, function (n, e, t) {
    var r = t(111),
      o = t(150),
      a = t(157),
      i = t(2),
      u = t(158);
    n.exports = function (n) {
      return "function" == typeof n ? n : null == n ? a : "object" == typeof n ? i(n) ? o(n[0], n[1]) : r(n) : u(n);
    };
  }, function (n, e, t) {
    var r = t(44),
      o = t(34);
    n.exports = function (n) {
      return null != n && o(n.length) && !r(n);
    };
  }, function (n, e, t) {
    var r = t(133),
      o = t(140),
      a = t(11);
    n.exports = function (n) {
      return a(n) ? r(n) : o(n);
    };
  }, function (n, e, t) {
    var r = t(26),
      o = t(10),
      a = t(168),
      i = t(2);
    n.exports = function (n, e) {
      return (i(n) ? r : a)(n, o(e, 3));
    };
  }, function (n, e, t) {
    var r = t(3).Symbol;
    n.exports = r;
  }, function (n, e, t) {
    var r = t(6),
      o = t(7),
      a = "[object Symbol]";
    n.exports = function (n) {
      return "symbol" == typeof n || o(n) && r(n) == a;
    };
  }, function (n, e, t) {
    var r = t(9)(Object, "create");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(100),
      o = t(101),
      a = t(102),
      i = t(103),
      u = t(104);
    function c(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }
    c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e, t) {
    var r = t(31);
    n.exports = function (n, e) {
      for (var t = n.length; t--;) if (r(n[t][0], e)) return t;
      return -1;
    };
  }, function (n, e, t) {
    var r = t(106);
    n.exports = function (n, e) {
      var t = n.__data__;
      return r(e) ? t["string" == typeof e ? "string" : "hash"] : t.map;
    };
  }, function (n, e, t) {
    var r = t(15),
      o = 1 / 0;
    n.exports = function (n) {
      if ("string" == typeof n || r(n)) return n;
      var e = n + "";
      return "0" == e && 1 / n == -o ? "-0" : e;
    };
  }, function (n, e, t) {
    var r = t(164),
      o = t(167)(r);
    n.exports = o;
  }, function (n, e, t) {
    var r = t(30),
      o = "Expected a function";
    function a(n, e) {
      if ("function" != typeof n || null != e && "function" != typeof e) throw new TypeError(o);
      var t = function t() {
        var r = arguments,
          o = e ? e.apply(this, r) : r[0],
          a = t.cache;
        if (a.has(o)) return a.get(o);
        var i = n.apply(this, r);
        return t.cache = a.set(o, i) || a, i;
      };
      return t.cache = new (a.Cache || r)(), t;
    }
    a.Cache = r, n.exports = a;
  }, function (n, e, t) {
    var r = t(43),
      o = t(10),
      a = t(27),
      i = Math.max;
    n.exports = function (n, e, t) {
      var u = null == n ? 0 : n.length;
      if (!u) return -1;
      var c = null == t ? 0 : a(t);
      return c < 0 && (c = i(u + c, 0)), r(n, o(e, 3), c);
    };
  }, function (n, e, t) {
    var r = t(50),
      o = t(163),
      a = t(10),
      i = t(2);
    n.exports = function (n, e) {
      return (i(n) ? r : o)(n, a(e, 3));
    };
  }, function (n, e, t) {
    var r = t(14),
      o = t(26),
      a = t(2),
      i = t(15),
      u = 1 / 0,
      c = r ? r.prototype : void 0,
      s = c ? c.toString : void 0;
    n.exports = function n(e) {
      if ("string" == typeof e) return e;
      if (a(e)) return o(e, n) + "";
      if (i(e)) return s ? s.call(e) : "";
      var t = e + "";
      return "0" == t && 1 / e == -u ? "-0" : t;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length, o = Array(r); ++t < r;) o[t] = e(n[t], t, n);
      return o;
    };
  }, function (n, e, t) {
    var r = t(79);
    n.exports = function (n) {
      var e = r(n),
        t = e % 1;
      return e == e ? t ? e - t : e : 0;
    };
  }, function (n, e, t) {
    var r = t(25);
    n.exports = function (n) {
      return null == n ? "" : r(n);
    };
  }, function (n, e, t) {
    var r = t(43),
      o = t(82),
      a = t(83);
    n.exports = function (n, e, t) {
      return e == e ? a(n, e, t) : r(n, o, t);
    };
  }, function (n, e, t) {
    var r = t(89),
      o = t(105),
      a = t(107),
      i = t(108),
      u = t(109);
    function c(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }
    c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e) {
    n.exports = function (n, e) {
      return n === e || n != n && e != e;
    };
  }, function (n, e, t) {
    var r = t(9)(t(3), "Map");
    n.exports = r;
  }, function (n, e) {
    var t = 9007199254740991,
      r = /^(?:0|[1-9]\d*)$/;
    n.exports = function (n, e) {
      var o = typeof n;
      return !!(e = null == e ? t : e) && ("number" == o || "symbol" != o && r.test(n)) && n > -1 && n % 1 == 0 && n < e;
    };
  }, function (n, e) {
    var t = 9007199254740991;
    n.exports = function (n) {
      return "number" == typeof n && n > -1 && n % 1 == 0 && n <= t;
    };
  }, function (n, e, t) {
    var r = t(2),
      o = t(15),
      a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      i = /^\w*$/;
    n.exports = function (n, e) {
      if (r(n)) return !1;
      var t = typeof n;
      return !("number" != t && "symbol" != t && "boolean" != t && null != n && !o(n)) || i.test(n) || !a.test(n) || null != e && n in Object(e);
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(2),
      a = t(7),
      i = "[object String]";
    n.exports = function (n) {
      return "string" == typeof n || !o(n) && a(n) && r(n) == i;
    };
  }, function (n, e, t) {
    var r = t(169),
      o = t(21),
      a = t(10),
      i = t(170),
      u = t(2);
    n.exports = function (n, e, t) {
      var c = u(n) ? r : i,
        s = arguments.length < 3;
      return c(n, a(e, 4), t, s, o);
    };
  }, function (n, e, t) {
    var r = t(49),
      o = t(10),
      a = t(172),
      i = t(2),
      u = t(173);
    n.exports = function (n, e, t) {
      var c = i(n) ? r : a;
      return t && u(n, e, t) && (e = void 0), c(n, o(e, 3));
    };
  }, function (n, e) {
    var t;
    function r(n, e) {
      var t = Object.keys(n);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(n);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        })), t.push.apply(t, r);
      }
      return t;
    }
    function o(n, e, t) {
      return e in n ? Object.defineProperty(n, e, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[e] = t, n;
    }
    function a(n, e) {
      return function (n) {
        if (Array.isArray(n)) return n;
      }(n) || function (n, e) {
        if (!(Symbol.iterator in Object(n) || "[object Arguments]" === Object.prototype.toString.call(n))) return;
        var t = [],
          r = !0,
          o = !1,
          a = void 0;
        try {
          for (var i, u = n[Symbol.iterator](); !(r = (i = u.next()).done) && (t.push(i.value), !e || t.length !== e); r = !0);
        } catch (n) {
          o = !0, a = n;
        } finally {
          try {
            r || null == u["return"] || u["return"]();
          } finally {
            if (o) throw a;
          }
        }
        return t;
      }(n, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }
    var i = {};
    function u(n, e, t) {
      e in i || (i[e] = []);
      var r = t || 0;
      i[e][r] = n;
    }
    var c,
      s = (t = []).concat.apply(t, function (n) {
        if (Array.isArray(n)) {
          for (var e = 0, t = new Array(n.length); e < n.length; e++) t[e] = n[e];
          return t;
        }
      }(c = [["Afghanistan", ["asia"], "af", "93"], ["Albania", ["europe"], "al", "355"], ["Algeria", ["africa", "north-africa"], "dz", "213"], ["American Samoa", ["oceania"], "as", "1684"], ["Andorra", ["europe"], "ad", "376"], ["Angola", ["africa"], "ao", "244"], ["Anguilla", ["america", "carribean"], "ai", "1264"], ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"], ["Argentina", ["america", "south-america"], "ar", "54", "+.. (..) ........"], ["Armenia", ["asia", "ex-ussr"], "am", "374"], ["Aruba", ["america", "carribean"], "aw", "297"], ["Australia", ["oceania"], "au", "61", "+.. ... ... ..."], ["Austria", ["europe", "european-union"], "at", "43"], ["Azerbaijan", ["asia", "ex-ussr"], "az", "994"], ["Bahamas", ["america", "carribean"], "bs", "1242"], ["Bahrain", ["middle-east"], "bh", "973"], ["Bangladesh", ["asia"], "bd", "880"], ["Barbados", ["america", "carribean"], "bb", "1246"], ["Belarus", ["europe", "ex-ussr"], "by", "375", "+... (..) ... .. .."], ["Belgium", ["europe", "european-union"], "be", "32", "+.. ... .. .. .."], ["Belize", ["america", "central-america"], "bz", "501"], ["Benin", ["africa"], "bj", "229"], ["Bermuda", ["america", "north-america"], "bm", "1441"], ["Bhutan", ["asia"], "bt", "975"], ["Bolivia", ["america", "south-america"], "bo", "591"], ["Bosnia and Herzegovina", ["europe"], "ba", "387"], ["Botswana", ["africa"], "bw", "267"], ["Brazil", ["america", "south-america"], "br", "55", "+.. (..) ........."], ["British Indian Ocean Territory", ["asia"], "io", "246"], ["British Virgin Islands", ["america", "carribean"], "vg", "1284"], ["Brunei", ["asia"], "bn", "673"], ["Bulgaria", ["europe", "european-union"], "bg", "359"], ["Burkina Faso", ["africa"], "bf", "226"], ["Burundi", ["africa"], "bi", "257"], ["Cambodia", ["asia"], "kh", "855"], ["Cameroon", ["africa"], "cm", "237"], ["Canada", ["america", "north-america"], "ca", "1", "+. (...) ...-....", 1, ["204", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde", ["africa"], "cv", "238"], ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1], ["Cayman Islands", ["america", "carribean"], "ky", "1345"], ["Central African Republic", ["africa"], "cf", "236"], ["Chad", ["africa"], "td", "235"], ["Chile", ["america", "south-america"], "cl", "56"], ["China", ["asia"], "cn", "86", "+.. ..-........."], ["Colombia", ["america", "south-america"], "co", "57"], ["Comoros", ["africa"], "km", "269"], ["Congo", ["africa"], "cd", "243"], ["Congo", ["africa"], "cg", "242"], ["Cook Islands", ["oceania"], "ck", "682"], ["Costa Rica", ["america", "central-america"], "cr", "506", "+... ....-...."], ["Côte d’Ivoire", ["africa"], "ci", "225"], ["Croatia", ["europe", "european-union"], "hr", "385"], ["Cuba", ["america", "carribean"], "cu", "53"], ["Curaçao", ["america", "carribean"], "cw", "599", "", 0], ["Cyprus", ["europe", "european-union"], "cy", "357", "+... .. ......"], ["Czech Republic", ["europe", "european-union"], "cz", "420"], ["Denmark", ["europe", "european-union"], "dk", "45", "+.. .. .. .. .."], ["Djibouti", ["africa"], "dj", "253"], ["Dominica", ["america", "carribean"], "dm", "1767"], ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2, ["809", "829", "849"]], ["Ecuador", ["america", "south-america"], "ec", "593"], ["Egypt", ["africa", "north-africa"], "eg", "20"], ["El Salvador", ["america", "central-america"], "sv", "503", "+... ....-...."], ["Equatorial Guinea", ["africa"], "gq", "240"], ["Eritrea", ["africa"], "er", "291"], ["Estonia", ["europe", "european-union", "ex-ussr"], "ee", "372", "+... .... ......"], ["Ethiopia", ["africa"], "et", "251"], ["Falkland Islands", ["america", "south-america"], "fk", "500"], ["Faroe Islands", ["europe"], "fo", "298"], ["Fiji", ["oceania"], "fj", "679"], ["Finland", ["europe", "european-union"], "fi", "358", "+... .. ... .. .."], ["France", ["europe", "european-union"], "fr", "33", "+.. . .. .. .. .."], ["French Guiana", ["america", "south-america"], "gf", "594"], ["French Polynesia", ["oceania"], "pf", "689"], ["Gabon", ["africa"], "ga", "241"], ["Gambia", ["africa"], "gm", "220"], ["Georgia", ["asia", "ex-ussr"], "ge", "995"], ["Germany", ["europe", "european-union"], "de", "49", "+.. .... ........"], ["Ghana", ["africa"], "gh", "233"], ["Gibraltar", ["europe"], "gi", "350"], ["Greece", ["europe", "european-union"], "gr", "30"], ["Greenland", ["america"], "gl", "299"], ["Grenada", ["america", "carribean"], "gd", "1473"], ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0], ["Guam", ["oceania"], "gu", "1671"], ["Guatemala", ["america", "central-america"], "gt", "502", "+... ....-...."], ["Guinea", ["africa"], "gn", "224"], ["Guinea-Bissau", ["africa"], "gw", "245"], ["Guyana", ["america", "south-america"], "gy", "592"], ["Haiti", ["america", "carribean"], "ht", "509", "+... ....-...."], ["Honduras", ["america", "central-america"], "hn", "504"], ["Hong Kong", ["asia"], "hk", "852", "+... .... ...."], ["Hungary", ["europe", "european-union"], "hu", "36"], ["Iceland", ["europe"], "is", "354", "+... ... ...."], ["India", ["asia"], "in", "91", "+.. .....-....."], ["Indonesia", ["asia"], "id", "62"], ["Iran", ["middle-east"], "ir", "98"], ["Iraq", ["middle-east"], "iq", "964"], ["Ireland", ["europe", "european-union"], "ie", "353", "+... .. ......."], ["Israel", ["middle-east"], "il", "972", "+... ... ... ...."], ["Italy", ["europe", "european-union"], "it", "39", "+.. ... .......", 0], ["Jamaica", ["america", "carribean"], "jm", "1876"], ["Japan", ["asia"], "jp", "81", "+.. .. .... ...."], ["Jordan", ["middle-east"], "jo", "962"], ["Kazakhstan", ["asia", "ex-ussr"], "kz", "7", "+. ... ...-..-..", 1, ["313", "327", "7172", "312", "73622", "321", "324", "336", "318", "315", "325", "311", "326", "310"]], ["Kenya", ["africa"], "ke", "254"], ["Kiribati", ["oceania"], "ki", "686"], ["Kuwait", ["middle-east"], "kw", "965"], ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996"], ["Laos", ["asia"], "la", "856"], ["Latvia", ["europe", "european-union", "ex-ussr"], "lv", "371"], ["Lebanon", ["middle-east"], "lb", "961"], ["Lesotho", ["africa"], "ls", "266"], ["Liberia", ["africa"], "lr", "231"], ["Libya", ["africa", "north-africa"], "ly", "218"], ["Liechtenstein", ["europe"], "li", "423"], ["Lithuania", ["europe", "european-union", "ex-ussr"], "lt", "370"], ["Luxembourg", ["europe", "european-union"], "lu", "352"], ["Macau", ["asia"], "mo", "853"], ["Macedonia", ["europe"], "mk", "389"], ["Madagascar", ["africa"], "mg", "261"], ["Malawi", ["africa"], "mw", "265"], ["Malaysia", ["asia"], "my", "60", "+.. ..-....-...."], ["Maldives", ["asia"], "mv", "960"], ["Mali", ["africa"], "ml", "223"], ["Malta", ["europe", "european-union"], "mt", "356"], ["Marshall Islands", ["oceania"], "mh", "692"], ["Martinique", ["america", "carribean"], "mq", "596"], ["Mauritania", ["africa"], "mr", "222"], ["Mauritius", ["africa"], "mu", "230"], ["Mexico", ["america", "central-america"], "mx", "52"], ["Micronesia", ["oceania"], "fm", "691"], ["Moldova", ["europe"], "md", "373", "+... (..) ..-..-.."], ["Monaco", ["europe"], "mc", "377"], ["Mongolia", ["asia"], "mn", "976"], ["Montenegro", ["europe"], "me", "382"], ["Montserrat", ["america", "carribean"], "ms", "1664"], ["Morocco", ["africa", "north-africa"], "ma", "212"], ["Mozambique", ["africa"], "mz", "258"], ["Myanmar", ["asia"], "mm", "95"], ["Namibia", ["africa"], "na", "264"], ["Nauru", ["africa"], "nr", "674"], ["Nepal", ["asia"], "np", "977"], ["Netherlands", ["europe", "european-union"], "nl", "31", "+.. .. ........"], ["New Caledonia", ["oceania"], "nc", "687"], ["New Zealand", ["oceania"], "nz", "64", "+.. ...-...-...."], ["Nicaragua", ["america", "central-america"], "ni", "505"], ["Niger", ["africa"], "ne", "227"], ["Nigeria", ["africa"], "ng", "234"], ["Niue", ["asia"], "nu", "683"], ["Norfolk Island", ["oceania"], "nf", "672"], ["North Korea", ["asia"], "kp", "850"], ["Northern Mariana Islands", ["oceania"], "mp", "1670"], ["Norway", ["europe"], "no", "47", "+.. ... .. ..."], ["Oman", ["middle-east"], "om", "968"], ["Pakistan", ["asia"], "pk", "92", "+.. ...-......."], ["Palau", ["oceania"], "pw", "680"], ["Palestine", ["middle-east"], "ps", "970"], ["Panama", ["america", "central-america"], "pa", "507"], ["Papua New Guinea", ["oceania"], "pg", "675"], ["Paraguay", ["america", "south-america"], "py", "595"], ["Peru", ["america", "south-america"], "pe", "51"], ["Philippines", ["asia"], "ph", "63", "+.. .... ......."], ["Poland", ["europe", "european-union"], "pl", "48", "+.. ...-...-..."], ["Portugal", ["europe", "european-union"], "pt", "351"], ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3, ["787", "939"]], ["Qatar", ["middle-east"], "qa", "974"], ["Réunion", ["africa"], "re", "262"], ["Romania", ["europe", "european-union"], "ro", "40"], ["Russia", ["europe", "asia", "ex-ussr"], "ru", "7", "+. (...) ...-..-..", 0], ["Rwanda", ["africa"], "rw", "250"], ["Saint Barthélemy", ["america", "carribean"], "bl", "590", "", 1], ["Saint Helena", ["africa"], "sh", "290"], ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"], ["Saint Lucia", ["america", "carribean"], "lc", "1758"], ["Saint Martin", ["america", "carribean"], "mf", "590", "", 2], ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"], ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"], ["Samoa", ["oceania"], "ws", "685"], ["San Marino", ["europe"], "sm", "378"], ["São Tomé and Príncipe", ["africa"], "st", "239"], ["Saudi Arabia", ["middle-east"], "sa", "966"], ["Senegal", ["africa"], "sn", "221"], ["Serbia", ["europe"], "rs", "381"], ["Seychelles", ["africa"], "sc", "248"], ["Sierra Leone", ["africa"], "sl", "232"], ["Singapore", ["asia"], "sg", "65", "+.. ....-...."], ["Sint Maarten", ["america", "carribean"], "sx", "1721"], ["Slovakia", ["europe", "european-union"], "sk", "421"], ["Slovenia", ["europe", "european-union"], "si", "386"], ["Solomon Islands", ["oceania"], "sb", "677"], ["Somalia", ["africa"], "so", "252"], ["South Africa", ["africa"], "za", "27"], ["South Korea", ["asia"], "kr", "82", "+.. ... .... ...."], ["South Sudan", ["africa", "north-africa"], "ss", "211"], ["Spain", ["europe", "european-union"], "es", "34", "+.. ... ... ..."], ["Sri Lanka", ["asia"], "lk", "94"], ["Sudan", ["africa"], "sd", "249"], ["Suriname", ["america", "south-america"], "sr", "597"], ["Swaziland", ["africa"], "sz", "268"], ["Sweden", ["europe", "european-union"], "se", "46", "+.. (..) ...-..-.."], ["Switzerland", ["europe"], "ch", "41", "+.. .. ... .. .."], ["Syria", ["middle-east"], "sy", "963"], ["Taiwan", ["asia"], "tw", "886"], ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"], ["Tanzania", ["africa"], "tz", "255"], ["Thailand", ["asia"], "th", "66"], ["Timor-Leste", ["asia"], "tl", "670"], ["Togo", ["africa"], "tg", "228"], ["Tokelau", ["oceania"], "tk", "690"], ["Tonga", ["oceania"], "to", "676"], ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"], ["Tunisia", ["africa", "north-africa"], "tn", "216"], ["Turkey", ["europe"], "tr", "90", "+.. ... ... .. .."], ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"], ["Turks and Caicos Islands", ["america", "carribean"], "tc", "1649"], ["Tuvalu", ["asia"], "tv", "688"], ["U.S. Virgin Islands", ["america", "carribean"], "vi", "1340"], ["Uganda", ["africa"], "ug", "256"], ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "+... (..) ... .. .."], ["United Arab Emirates", ["middle-east"], "ae", "971"], ["United Kingdom", ["europe", "european-union"], "gb", "44", "+.. .... ......"], ["United States", ["america", "north-america"], "us", "1", "+. (...) ...-....", 0, ["907", "205", "251", "256", "334", "479", "501", "870", "480", "520", "602", "623", "928", "209", "213", "310", "323", "408", "415", "510", "530", "559", "562", "619", "626", "650", "661", "707", "714", "760", "805", "818", "831", "858", "909", "916", "925", "949", "951", "303", "719", "970", "203", "860", "202", "302", "239", "305", "321", "352", "386", "407", "561", "727", "772", "813", "850", "863", "904", "941", "954", "229", "404", "478", "706", "770", "912", "808", "319", "515", "563", "641", "712", "208", "217", "309", "312", "618", "630", "708", "773", "815", "847", "219", "260", "317", "574", "765", "812", "316", "620", "785", "913", "270", "502", "606", "859", "225", "318", "337", "504", "985", "413", "508", "617", "781", "978", "301", "410", "207", "231", "248", "269", "313", "517", "586", "616", "734", "810", "906", "989", "218", "320", "507", "612", "651", "763", "952", "314", "417", "573", "636", "660", "816", "228", "601", "662", "406", "252", "336", "704", "828", "910", "919", "701", "308", "402", "603", "201", "609", "732", "856", "908", "973", "505", "575", "702", "775", "212", "315", "516", "518", "585", "607", "631", "716", "718", "845", "914", "216", "330", "419", "440", "513", "614", "740", "937", "405", "580", "918", "503", "541", "215", "412", "570", "610", "717", "724", "814", "401", "803", "843", "864", "605", "423", "615", "731", "865", "901", "931", "210", "214", "254", "281", "325", "361", "409", "432", "512", "713", "806", "817", "830", "903", "915", "936", "940", "956", "972", "979", "435", "801", "276", "434", "540", "703", "757", "804", "802", "206", "253", "360", "425", "509", "262", "414", "608", "715", "920", "304", "307"]], ["Uruguay", ["america", "south-america"], "uy", "598"], ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998"], ["Vanuatu", ["oceania"], "vu", "678"], ["Vatican City", ["europe"], "va", "39", "+.. .. .... ....", 1], ["Venezuela", ["america", "south-america"], "ve", "58"], ["Vietnam", ["asia"], "vn", "84"], ["Wallis and Futuna", ["oceania"], "wf", "681"], ["Yemen", ["middle-east"], "ye", "967"], ["Zambia", ["africa"], "zm", "260"], ["Zimbabwe", ["africa"], "zw", "263"]].map(function (n) {
        var e = a(n, 7),
          t = e[0],
          i = e[1],
          c = e[2],
          s = e[3],
          p = e[4],
          f = e[5],
          l = e[6],
          g = {
            name: t,
            regions: i,
            iso2: c,
            dialCode: s,
            priority: f,
            format: p || void 0,
            hasAreaCodes: l
          },
          d = [];
        return g.hasAreaCodes && l.forEach(function (n) {
          var e = function (n) {
            for (var e = 1; e < arguments.length; e++) {
              var t = null != arguments[e] ? arguments[e] : {};
              e % 2 ? r(t, !0).forEach(function (e) {
                o(n, e, t[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : r(t).forEach(function (e) {
                Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(t, e));
              });
            }
            return n;
          }({}, g, {
            regions: i,
            dialCode: "".concat(s).concat(n),
            isAreaCode: !0
          });
          d.push(e), u(c, e.dialCode);
        }), u(g.iso2, g.dialCode, g.hasAreaCodes), d.length > 0 ? [g].concat(d) : [g];
      })) || function (n) {
        if (Symbol.iterator in Object(n) || "[object Arguments]" === Object.prototype.toString.call(n)) return Array.from(n);
      }(c) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }());
    n.exports = {
      allCountries: s,
      allCountryCodes: i
    };
  }, function (n, e, t) {
    (function (e) {
      var t = "object" == typeof e && e && e.Object === Object && e;
      n.exports = t;
    }).call(this, t(75));
  }, function (n, e, t) {
    var r = t(8),
      o = t(15),
      a = NaN,
      i = /^\s+|\s+$/g,
      u = /^[-+]0x[0-9a-f]+$/i,
      c = /^0b[01]+$/i,
      s = /^0o[0-7]+$/i,
      p = parseInt;
    n.exports = function (n) {
      if ("number" == typeof n) return n;
      if (o(n)) return a;
      if (r(n)) {
        var e = "function" == typeof n.valueOf ? n.valueOf() : n;
        n = r(e) ? e + "" : e;
      }
      if ("string" != typeof n) return 0 === n ? n : +n;
      n = n.replace(i, "");
      var t = c.test(n);
      return t || s.test(n) ? p(n.slice(2), t ? 2 : 8) : u.test(n) ? a : +n;
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      var r = -1,
        o = n.length;
      e < 0 && (e = -e > o ? 0 : o + e), (t = t > o ? o : t) < 0 && (t += o), o = e > t ? 0 : t - e >>> 0, e >>>= 0;
      for (var a = Array(o); ++r < o;) a[r] = n[r + e];
      return a;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r) {
      for (var o = n.length, a = t + (r ? 1 : -1); r ? a-- : ++a < o;) if (e(n[a], a, n)) return a;
      return -1;
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(8),
      a = "[object AsyncFunction]",
      i = "[object Function]",
      u = "[object GeneratorFunction]",
      c = "[object Proxy]";
    n.exports = function (n) {
      if (!o(n)) return !1;
      var e = r(n);
      return e == i || e == u || e == a || e == c;
    };
  }, function (n, e) {
    var t = Function.prototype.toString;
    n.exports = function (n) {
      if (null != n) {
        try {
          return t.call(n);
        } catch (n) {}
        try {
          return n + "";
        } catch (n) {}
      }
      return "";
    };
  }, function (n, e, t) {
    var r = t(17),
      o = t(113),
      a = t(114),
      i = t(115),
      u = t(116),
      c = t(117);
    function s(n) {
      var e = this.__data__ = new r(n);
      this.size = e.size;
    }
    s.prototype.clear = o, s.prototype["delete"] = a, s.prototype.get = i, s.prototype.has = u, s.prototype.set = c, n.exports = s;
  }, function (n, e, t) {
    var r = t(118),
      o = t(7);
    n.exports = function n(e, t, a, i, u) {
      return e === t || (null == e || null == t || !o(e) && !o(t) ? e != e && t != t : r(e, t, a, i, n, u));
    };
  }, function (n, e, t) {
    var r = t(119),
      o = t(49),
      a = t(122),
      i = 1,
      u = 2;
    n.exports = function (n, e, t, c, s, p) {
      var f = t & i,
        l = n.length,
        g = e.length;
      if (l != g && !(f && g > l)) return !1;
      var d = p.get(n);
      if (d && p.get(e)) return d == e;
      var b = -1,
        x = !0,
        A = t & u ? new r() : void 0;
      for (p.set(n, e), p.set(e, n); ++b < l;) {
        var v = n[b],
          h = e[b];
        if (c) var m = f ? c(h, v, b, e, n, p) : c(v, h, b, n, e, p);
        if (void 0 !== m) {
          if (m) continue;
          x = !1;
          break;
        }
        if (A) {
          if (!o(e, function (n, e) {
            if (!a(A, e) && (v === n || s(v, n, t, c, p))) return A.push(e);
          })) {
            x = !1;
            break;
          }
        } else if (v !== h && !s(v, h, t, c, p)) {
          x = !1;
          break;
        }
      }
      return p["delete"](n), p["delete"](e), x;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length; ++t < r;) if (e(n[t], t, n)) return !0;
      return !1;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length, o = 0, a = []; ++t < r;) {
        var i = n[t];
        e(i, t, n) && (a[o++] = i);
      }
      return a;
    };
  }, function (n, e, t) {
    var r = t(135),
      o = t(7),
      a = Object.prototype,
      i = a.hasOwnProperty,
      u = a.propertyIsEnumerable,
      c = r(function () {
        return arguments;
      }()) ? r : function (n) {
        return o(n) && i.call(n, "callee") && !u.call(n, "callee");
      };
    n.exports = c;
  }, function (n, e, t) {
    (function (n) {
      var r = t(3),
        o = t(136),
        a = e && !e.nodeType && e,
        i = a && "object" == typeof n && n && !n.nodeType && n,
        u = i && i.exports === a ? r.Buffer : void 0,
        c = (u ? u.isBuffer : void 0) || o;
      n.exports = c;
    }).call(this, t(53)(n));
  }, function (n, e) {
    n.exports = function (n) {
      return n.webpackPolyfill || (n.deprecate = function () {}, n.paths = [], n.children || (n.children = []), Object.defineProperty(n, "loaded", {
        enumerable: !0,
        get: function get() {
          return n.l;
        }
      }), Object.defineProperty(n, "id", {
        enumerable: !0,
        get: function get() {
          return n.i;
        }
      }), n.webpackPolyfill = 1), n;
    };
  }, function (n, e, t) {
    var r = t(137),
      o = t(138),
      a = t(139),
      i = a && a.isTypedArray,
      u = i ? o(i) : r;
    n.exports = u;
  }, function (n, e, t) {
    var r = t(8);
    n.exports = function (n) {
      return n == n && !r(n);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return function (t) {
        return null != t && t[n] === e && (void 0 !== e || n in Object(t));
      };
    };
  }, function (n, e, t) {
    var r = t(58),
      o = t(20);
    n.exports = function (n, e) {
      for (var t = 0, a = (e = r(e, n)).length; null != n && t < a;) n = n[o(e[t++])];
      return t && t == a ? n : void 0;
    };
  }, function (n, e, t) {
    var r = t(2),
      o = t(35),
      a = t(152),
      i = t(28);
    n.exports = function (n, e) {
      return r(n) ? n : o(n, e) ? [n] : a(i(n));
    };
  }, function (n, e) {
    n.exports = "data:image/png;base64,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";
  }, function (n, e, t) {
    var r = t(25),
      o = t(80),
      a = t(81),
      i = t(84),
      u = t(85),
      c = t(28),
      s = /^\s+|\s+$/g;
    n.exports = function (n, e, t) {
      if ((n = c(n)) && (t || void 0 === e)) return n.replace(s, "");
      if (!n || !(e = r(e))) return n;
      var p = u(n),
        f = u(e),
        l = i(p, f),
        g = a(p, f) + 1;
      return o(p, l, g).join("");
    };
  }, function (n, e, t) {
    var r = t(8),
      o = t(110),
      a = t(41),
      i = "Expected a function",
      u = Math.max,
      c = Math.min;
    n.exports = function (n, e, t) {
      var s,
        p,
        f,
        l,
        g,
        d,
        b = 0,
        x = !1,
        A = !1,
        v = !0;
      if ("function" != typeof n) throw new TypeError(i);
      function h(e) {
        var t = s,
          r = p;
        return s = p = void 0, b = e, l = n.apply(r, t);
      }
      function m(n) {
        var t = n - d;
        return void 0 === d || t >= e || t < 0 || A && n - b >= f;
      }
      function y() {
        var n = o();
        if (m(n)) return C(n);
        g = setTimeout(y, function (n) {
          var t = e - (n - d);
          return A ? c(t, f - (n - b)) : t;
        }(n));
      }
      function C(n) {
        return g = void 0, v && s ? h(n) : (s = p = void 0, l);
      }
      function k() {
        var n = o(),
          t = m(n);
        if (s = arguments, p = this, d = n, t) {
          if (void 0 === g) return function (n) {
            return b = n, g = setTimeout(y, e), x ? h(n) : l;
          }(d);
          if (A) return clearTimeout(g), g = setTimeout(y, e), h(d);
        }
        return void 0 === g && (g = setTimeout(y, e)), l;
      }
      return e = a(e) || 0, r(t) && (x = !!t.leading, f = (A = "maxWait" in t) ? u(a(t.maxWait) || 0, e) : f, v = "trailing" in t ? !!t.trailing : v), k.cancel = function () {
        void 0 !== g && clearTimeout(g), b = 0, s = d = p = g = void 0;
      }, k.flush = function () {
        return void 0 === g ? l : C(o());
      }, k;
    };
  }, function (n, e, t) {
    var r = t(42);
    n.exports = function (n) {
      var e = null == n ? 0 : n.length;
      return e ? r(n, 1, e) : [];
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n && n.length ? n[0] : void 0;
    };
  }, function (n, e, t) {
    var r = t(29),
      o = t(11),
      a = t(36),
      i = t(27),
      u = t(161),
      c = Math.max;
    n.exports = function (n, e, t, s) {
      n = o(n) ? n : u(n), t = t && !s ? i(t) : 0;
      var p = n.length;
      return t < 0 && (t = c(p + t, 0)), a(n) ? t <= p && n.indexOf(e, t) > -1 : !!p && r(n, e, t) > -1;
    };
  }, function (n, e) {
    n.exports = require$$1$1$1$1;
  }, function (n, e) {
    n.exports = TextField;
  }, function (n, e) {
    n.exports = InputAdornment;
  }, function (n, e) {
    n.exports = Button$2;
  }, function (n, e) {
    n.exports = Menu;
  }, function (n, e) {
    n.exports = Divider;
  }, function (n, e) {
    n.exports = NativeSelect;
  }, function (n, e) {
    n.exports = withStyles$1;
  }, function (n, e) {
    n.exports = MenuItem;
  }, function (n, e) {
    n.exports = RootRef;
  }, function (n, e) {
    var t;
    t = function () {
      return this;
    }();
    try {
      t = t || new Function("return this")();
    } catch (n) {
      "object" == typeof window && (t = window);
    }
    n.exports = t;
  }, function (n, e, t) {
    var r = t(14),
      o = Object.prototype,
      a = o.hasOwnProperty,
      i = o.toString,
      u = r ? r.toStringTag : void 0;
    n.exports = function (n) {
      var e = a.call(n, u),
        t = n[u];
      try {
        n[u] = void 0;
        var r = !0;
      } catch (n) {}
      var o = i.call(n);
      return r && (e ? n[u] = t : delete n[u]), o;
    };
  }, function (n, e) {
    var t = Object.prototype.toString;
    n.exports = function (n) {
      return t.call(n);
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      return n == n && (void 0 !== t && (n = n <= t ? n : t), void 0 !== e && (n = n >= e ? n : e)), n;
    };
  }, function (n, e, t) {
    var r = t(41),
      o = 1 / 0,
      a = 17976931348623157e292;
    n.exports = function (n) {
      return n ? (n = r(n)) === o || n === -o ? (n < 0 ? -1 : 1) * a : n == n ? n : 0 : 0 === n ? n : 0;
    };
  }, function (n, e, t) {
    var r = t(42);
    n.exports = function (n, e, t) {
      var o = n.length;
      return t = void 0 === t ? o : t, !e && t >= o ? n : r(n, e, t);
    };
  }, function (n, e, t) {
    var r = t(29);
    n.exports = function (n, e) {
      for (var t = n.length; t-- && r(e, n[t], 0) > -1;);
      return t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n != n;
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      for (var r = t - 1, o = n.length; ++r < o;) if (n[r] === e) return r;
      return -1;
    };
  }, function (n, e, t) {
    var r = t(29);
    n.exports = function (n, e) {
      for (var t = -1, o = n.length; ++t < o && r(e, n[t], 0) > -1;);
      return t;
    };
  }, function (n, e, t) {
    var r = t(86),
      o = t(87),
      a = t(88);
    n.exports = function (n) {
      return o(n) ? a(n) : r(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n.split("");
    };
  }, function (n, e) {
    var t = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
    n.exports = function (n) {
      return t.test(n);
    };
  }, function (n, e) {
    var t = "[\\ud800-\\udfff]",
      r = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
      o = "\\ud83c[\\udffb-\\udfff]",
      a = "[^\\ud800-\\udfff]",
      i = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      u = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      c = "(?:" + r + "|" + o + ")" + "?",
      s = "[\\ufe0e\\ufe0f]?" + c + ("(?:\\u200d(?:" + [a, i, u].join("|") + ")[\\ufe0e\\ufe0f]?" + c + ")*"),
      p = "(?:" + [a + r + "?", r, i, u, t].join("|") + ")",
      f = RegExp(o + "(?=" + o + ")|" + p + s, "g");
    n.exports = function (n) {
      return n.match(f) || [];
    };
  }, function (n, e, t) {
    var r = t(90),
      o = t(17),
      a = t(32);
    n.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new r(),
        map: new (a || o)(),
        string: new r()
      };
    };
  }, function (n, e, t) {
    var r = t(91),
      o = t(96),
      a = t(97),
      i = t(98),
      u = t(99);
    function c(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }
    c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e, t) {
    var r = t(16);
    n.exports = function () {
      this.__data__ = r ? r(null) : {}, this.size = 0;
    };
  }, function (n, e, t) {
    var r = t(44),
      o = t(93),
      a = t(8),
      i = t(45),
      u = /^\[object .+?Constructor\]$/,
      c = Function.prototype,
      s = Object.prototype,
      p = c.toString,
      f = s.hasOwnProperty,
      l = RegExp("^" + p.call(f).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    n.exports = function (n) {
      return !(!a(n) || o(n)) && (r(n) ? l : u).test(i(n));
    };
  }, function (n, e, t) {
    var r,
      o = t(94),
      a = (r = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";
    n.exports = function (n) {
      return !!a && a in n;
    };
  }, function (n, e, t) {
    var r = t(3)["__core-js_shared__"];
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n, e) {
      return null == n ? void 0 : n[e];
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = this.has(n) && delete this.__data__[n];
      return this.size -= e ? 1 : 0, e;
    };
  }, function (n, e, t) {
    var r = t(16),
      o = "__lodash_hash_undefined__",
      a = Object.prototype.hasOwnProperty;
    n.exports = function (n) {
      var e = this.__data__;
      if (r) {
        var t = e[n];
        return t === o ? void 0 : t;
      }
      return a.call(e, n) ? e[n] : void 0;
    };
  }, function (n, e, t) {
    var r = t(16),
      o = Object.prototype.hasOwnProperty;
    n.exports = function (n) {
      var e = this.__data__;
      return r ? void 0 !== e[n] : o.call(e, n);
    };
  }, function (n, e, t) {
    var r = t(16),
      o = "__lodash_hash_undefined__";
    n.exports = function (n, e) {
      var t = this.__data__;
      return this.size += this.has(n) ? 0 : 1, t[n] = r && void 0 === e ? o : e, this;
    };
  }, function (n, e) {
    n.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (n, e, t) {
    var r = t(18),
      o = Array.prototype.splice;
    n.exports = function (n) {
      var e = this.__data__,
        t = r(e, n);
      return !(t < 0) && (t == e.length - 1 ? e.pop() : o.call(e, t, 1), --this.size, !0);
    };
  }, function (n, e, t) {
    var r = t(18);
    n.exports = function (n) {
      var e = this.__data__,
        t = r(e, n);
      return t < 0 ? void 0 : e[t][1];
    };
  }, function (n, e, t) {
    var r = t(18);
    n.exports = function (n) {
      return r(this.__data__, n) > -1;
    };
  }, function (n, e, t) {
    var r = t(18);
    n.exports = function (n, e) {
      var t = this.__data__,
        o = r(t, n);
      return o < 0 ? (++this.size, t.push([n, e])) : t[o][1] = e, this;
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n) {
      var e = r(this, n)["delete"](n);
      return this.size -= e ? 1 : 0, e;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = typeof n;
      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== n : null === n;
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n) {
      return r(this, n).get(n);
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n) {
      return r(this, n).has(n);
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n, e) {
      var t = r(this, n),
        o = t.size;
      return t.set(n, e), this.size += t.size == o ? 0 : 1, this;
    };
  }, function (n, e, t) {
    var r = t(3);
    n.exports = function () {
      return r.Date.now();
    };
  }, function (n, e, t) {
    var r = t(112),
      o = t(149),
      a = t(56);
    n.exports = function (n) {
      var e = o(n);
      return 1 == e.length && e[0][2] ? a(e[0][0], e[0][1]) : function (t) {
        return t === n || r(t, n, e);
      };
    };
  }, function (n, e, t) {
    var r = t(46),
      o = t(47),
      a = 1,
      i = 2;
    n.exports = function (n, e, t, u) {
      var c = t.length,
        s = c,
        p = !u;
      if (null == n) return !s;
      for (n = Object(n); c--;) {
        var f = t[c];
        if (p && f[2] ? f[1] !== n[f[0]] : !(f[0] in n)) return !1;
      }
      for (; ++c < s;) {
        var l = (f = t[c])[0],
          g = n[l],
          d = f[1];
        if (p && f[2]) {
          if (void 0 === g && !(l in n)) return !1;
        } else {
          var b = new r();
          if (u) var x = u(g, d, l, n, e, b);
          if (!(void 0 === x ? o(d, g, a | i, u, b) : x)) return !1;
        }
      }
      return !0;
    };
  }, function (n, e, t) {
    var r = t(17);
    n.exports = function () {
      this.__data__ = new r(), this.size = 0;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = this.__data__,
        t = e["delete"](n);
      return this.size = e.size, t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.get(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.has(n);
    };
  }, function (n, e, t) {
    var r = t(17),
      o = t(32),
      a = t(30),
      i = 200;
    n.exports = function (n, e) {
      var t = this.__data__;
      if (t instanceof r) {
        var u = t.__data__;
        if (!o || u.length < i - 1) return u.push([n, e]), this.size = ++t.size, this;
        t = this.__data__ = new a(u);
      }
      return t.set(n, e), this.size = t.size, this;
    };
  }, function (n, e, t) {
    var r = t(46),
      o = t(48),
      a = t(123),
      i = t(127),
      u = t(144),
      c = t(2),
      s = t(52),
      p = t(54),
      f = 1,
      l = "[object Arguments]",
      g = "[object Array]",
      d = "[object Object]",
      b = Object.prototype.hasOwnProperty;
    n.exports = function (n, e, t, x, A, v) {
      var h = c(n),
        m = c(e),
        y = h ? g : u(n),
        C = m ? g : u(e),
        k = (y = y == l ? d : y) == d,
        w = (C = C == l ? d : C) == d,
        B = y == C;
      if (B && s(n)) {
        if (!s(e)) return !1;
        h = !0, k = !1;
      }
      if (B && !k) return v || (v = new r()), h || p(n) ? o(n, e, t, x, A, v) : a(n, e, y, t, x, A, v);
      if (!(t & f)) {
        var j = k && b.call(n, "__wrapped__"),
          P = w && b.call(e, "__wrapped__");
        if (j || P) {
          var O = j ? n.value() : n,
            E = P ? e.value() : e;
          return v || (v = new r()), A(O, E, t, x, v);
        }
      }
      return !!B && (v || (v = new r()), i(n, e, t, x, A, v));
    };
  }, function (n, e, t) {
    var r = t(30),
      o = t(120),
      a = t(121);
    function i(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.__data__ = new r(); ++e < t;) this.add(n[e]);
    }
    i.prototype.add = i.prototype.push = o, i.prototype.has = a, n.exports = i;
  }, function (n, e) {
    var t = "__lodash_hash_undefined__";
    n.exports = function (n) {
      return this.__data__.set(n, t), this;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.has(n);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return n.has(e);
    };
  }, function (n, e, t) {
    var r = t(14),
      o = t(124),
      a = t(31),
      i = t(48),
      u = t(125),
      c = t(126),
      s = 1,
      p = 2,
      f = "[object Boolean]",
      l = "[object Date]",
      g = "[object Error]",
      d = "[object Map]",
      b = "[object Number]",
      x = "[object RegExp]",
      A = "[object Set]",
      v = "[object String]",
      h = "[object Symbol]",
      m = "[object ArrayBuffer]",
      y = "[object DataView]",
      C = r ? r.prototype : void 0,
      k = C ? C.valueOf : void 0;
    n.exports = function (n, e, t, r, C, w, B) {
      switch (t) {
        case y:
          if (n.byteLength != e.byteLength || n.byteOffset != e.byteOffset) return !1;
          n = n.buffer, e = e.buffer;
        case m:
          return !(n.byteLength != e.byteLength || !w(new o(n), new o(e)));
        case f:
        case l:
        case b:
          return a(+n, +e);
        case g:
          return n.name == e.name && n.message == e.message;
        case x:
        case v:
          return n == e + "";
        case d:
          var j = u;
        case A:
          var P = r & s;
          if (j || (j = c), n.size != e.size && !P) return !1;
          var O = B.get(n);
          if (O) return O == e;
          r |= p, B.set(n, e);
          var E = i(j(n), j(e), r, C, w, B);
          return B["delete"](n), E;
        case h:
          if (k) return k.call(n) == k.call(e);
      }
      return !1;
    };
  }, function (n, e, t) {
    var r = t(3).Uint8Array;
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n) {
      var e = -1,
        t = Array(n.size);
      return n.forEach(function (n, r) {
        t[++e] = [r, n];
      }), t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = -1,
        t = Array(n.size);
      return n.forEach(function (n) {
        t[++e] = n;
      }), t;
    };
  }, function (n, e, t) {
    var r = t(128),
      o = 1,
      a = Object.prototype.hasOwnProperty;
    n.exports = function (n, e, t, i, u, c) {
      var s = t & o,
        p = r(n),
        f = p.length;
      if (f != r(e).length && !s) return !1;
      for (var l = f; l--;) {
        var g = p[l];
        if (!(s ? g in e : a.call(e, g))) return !1;
      }
      var d = c.get(n);
      if (d && c.get(e)) return d == e;
      var b = !0;
      c.set(n, e), c.set(e, n);
      for (var x = s; ++l < f;) {
        var A = n[g = p[l]],
          v = e[g];
        if (i) var h = s ? i(v, A, g, e, n, c) : i(A, v, g, n, e, c);
        if (!(void 0 === h ? A === v || u(A, v, t, i, c) : h)) {
          b = !1;
          break;
        }
        x || (x = "constructor" == g);
      }
      if (b && !x) {
        var m = n.constructor,
          y = e.constructor;
        m != y && "constructor" in n && "constructor" in e && !("function" == typeof m && m instanceof m && "function" == typeof y && y instanceof y) && (b = !1);
      }
      return c["delete"](n), c["delete"](e), b;
    };
  }, function (n, e, t) {
    var r = t(129),
      o = t(131),
      a = t(12);
    n.exports = function (n) {
      return r(n, a, o);
    };
  }, function (n, e, t) {
    var r = t(130),
      o = t(2);
    n.exports = function (n, e, t) {
      var a = e(n);
      return o(n) ? a : r(a, t(n));
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = e.length, o = n.length; ++t < r;) n[o + t] = e[t];
      return n;
    };
  }, function (n, e, t) {
    var r = t(50),
      o = t(132),
      a = Object.prototype.propertyIsEnumerable,
      i = Object.getOwnPropertySymbols,
      u = i ? function (n) {
        return null == n ? [] : (n = Object(n), r(i(n), function (e) {
          return a.call(n, e);
        }));
      } : o;
    n.exports = u;
  }, function (n, e) {
    n.exports = function () {
      return [];
    };
  }, function (n, e, t) {
    var r = t(134),
      o = t(51),
      a = t(2),
      i = t(52),
      u = t(33),
      c = t(54),
      s = Object.prototype.hasOwnProperty;
    n.exports = function (n, e) {
      var t = a(n),
        p = !t && o(n),
        f = !t && !p && i(n),
        l = !t && !p && !f && c(n),
        g = t || p || f || l,
        d = g ? r(n.length, String) : [],
        b = d.length;
      for (var x in n) !e && !s.call(n, x) || g && ("length" == x || f && ("offset" == x || "parent" == x) || l && ("buffer" == x || "byteLength" == x || "byteOffset" == x) || u(x, b)) || d.push(x);
      return d;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = Array(n); ++t < n;) r[t] = e(t);
      return r;
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(7),
      a = "[object Arguments]";
    n.exports = function (n) {
      return o(n) && r(n) == a;
    };
  }, function (n, e) {
    n.exports = function () {
      return !1;
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(34),
      a = t(7),
      i = {};
    i["[object Float32Array]"] = i["[object Float64Array]"] = i["[object Int8Array]"] = i["[object Int16Array]"] = i["[object Int32Array]"] = i["[object Uint8Array]"] = i["[object Uint8ClampedArray]"] = i["[object Uint16Array]"] = i["[object Uint32Array]"] = !0, i["[object Arguments]"] = i["[object Array]"] = i["[object ArrayBuffer]"] = i["[object Boolean]"] = i["[object DataView]"] = i["[object Date]"] = i["[object Error]"] = i["[object Function]"] = i["[object Map]"] = i["[object Number]"] = i["[object Object]"] = i["[object RegExp]"] = i["[object Set]"] = i["[object String]"] = i["[object WeakMap]"] = !1, n.exports = function (n) {
      return a(n) && o(n.length) && !!i[r(n)];
    };
  }, function (n, e) {
    n.exports = function (n) {
      return function (e) {
        return n(e);
      };
    };
  }, function (n, e, t) {
    (function (n) {
      var r = t(40),
        o = e && !e.nodeType && e,
        a = o && "object" == typeof n && n && !n.nodeType && n,
        i = a && a.exports === o && r.process,
        u = function () {
          try {
            var n = a && a.require && a.require("util").types;
            return n || i && i.binding && i.binding("util");
          } catch (n) {}
        }();
      n.exports = u;
    }).call(this, t(53)(n));
  }, function (n, e, t) {
    var r = t(141),
      o = t(142),
      a = Object.prototype.hasOwnProperty;
    n.exports = function (n) {
      if (!r(n)) return o(n);
      var e = [];
      for (var t in Object(n)) a.call(n, t) && "constructor" != t && e.push(t);
      return e;
    };
  }, function (n, e) {
    var t = Object.prototype;
    n.exports = function (n) {
      var e = n && n.constructor;
      return n === ("function" == typeof e && e.prototype || t);
    };
  }, function (n, e, t) {
    var r = t(143)(Object.keys, Object);
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n, e) {
      return function (t) {
        return n(e(t));
      };
    };
  }, function (n, e, t) {
    var r = t(145),
      o = t(32),
      a = t(146),
      i = t(147),
      u = t(148),
      c = t(6),
      s = t(45),
      p = s(r),
      f = s(o),
      l = s(a),
      g = s(i),
      d = s(u),
      b = c;
    (r && "[object DataView]" != b(new r(new ArrayBuffer(1))) || o && "[object Map]" != b(new o()) || a && "[object Promise]" != b(a.resolve()) || i && "[object Set]" != b(new i()) || u && "[object WeakMap]" != b(new u())) && (b = function b(n) {
      var e = c(n),
        t = "[object Object]" == e ? n.constructor : void 0,
        r = t ? s(t) : "";
      if (r) switch (r) {
        case p:
          return "[object DataView]";
        case f:
          return "[object Map]";
        case l:
          return "[object Promise]";
        case g:
          return "[object Set]";
        case d:
          return "[object WeakMap]";
      }
      return e;
    }), n.exports = b;
  }, function (n, e, t) {
    var r = t(9)(t(3), "DataView");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "Promise");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "Set");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "WeakMap");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(55),
      o = t(12);
    n.exports = function (n) {
      for (var e = o(n), t = e.length; t--;) {
        var a = e[t],
          i = n[a];
        e[t] = [a, i, r(i)];
      }
      return e;
    };
  }, function (n, e, t) {
    var r = t(47),
      o = t(151),
      a = t(154),
      i = t(35),
      u = t(55),
      c = t(56),
      s = t(20),
      p = 1,
      f = 2;
    n.exports = function (n, e) {
      return i(n) && u(e) ? c(s(n), e) : function (t) {
        var i = o(t, n);
        return void 0 === i && i === e ? a(t, n) : r(e, i, p | f);
      };
    };
  }, function (n, e, t) {
    var r = t(57);
    n.exports = function (n, e, t) {
      var o = null == n ? void 0 : r(n, e);
      return void 0 === o ? t : o;
    };
  }, function (n, e, t) {
    var r = t(153),
      o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      a = /\\(\\)?/g,
      i = r(function (n) {
        var e = [];
        return 46 === n.charCodeAt(0) && e.push(""), n.replace(o, function (n, t, r, o) {
          e.push(r ? o.replace(a, "$1") : t || n);
        }), e;
      });
    n.exports = i;
  }, function (n, e, t) {
    var r = t(22),
      o = 500;
    n.exports = function (n) {
      var e = r(n, function (n) {
          return t.size === o && t.clear(), n;
        }),
        t = e.cache;
      return e;
    };
  }, function (n, e, t) {
    var r = t(155),
      o = t(156);
    n.exports = function (n, e) {
      return null != n && o(n, e, r);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return null != n && e in Object(n);
    };
  }, function (n, e, t) {
    var r = t(58),
      o = t(51),
      a = t(2),
      i = t(33),
      u = t(34),
      c = t(20);
    n.exports = function (n, e, t) {
      for (var s = -1, p = (e = r(e, n)).length, f = !1; ++s < p;) {
        var l = c(e[s]);
        if (!(f = null != n && t(n, l))) break;
        n = n[l];
      }
      return f || ++s != p ? f : !!(p = null == n ? 0 : n.length) && u(p) && i(l, p) && (a(n) || o(n));
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n;
    };
  }, function (n, e, t) {
    var r = t(159),
      o = t(160),
      a = t(35),
      i = t(20);
    n.exports = function (n) {
      return a(n) ? r(i(n)) : o(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return function (e) {
        return null == e ? void 0 : e[n];
      };
    };
  }, function (n, e, t) {
    var r = t(57);
    n.exports = function (n) {
      return function (e) {
        return r(e, n);
      };
    };
  }, function (n, e, t) {
    var r = t(162),
      o = t(12);
    n.exports = function (n) {
      return null == n ? [] : r(n, o(n));
    };
  }, function (n, e, t) {
    var r = t(26);
    n.exports = function (n, e) {
      return r(e, function (e) {
        return n[e];
      });
    };
  }, function (n, e, t) {
    var r = t(21);
    n.exports = function (n, e) {
      var t = [];
      return r(n, function (n, r, o) {
        e(n, r, o) && t.push(n);
      }), t;
    };
  }, function (n, e, t) {
    var r = t(165),
      o = t(12);
    n.exports = function (n, e) {
      return n && r(n, e, o);
    };
  }, function (n, e, t) {
    var r = t(166)();
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n) {
      return function (e, t, r) {
        for (var o = -1, a = Object(e), i = r(e), u = i.length; u--;) {
          var c = i[n ? u : ++o];
          if (!1 === t(a[c], c, a)) break;
        }
        return e;
      };
    };
  }, function (n, e, t) {
    var r = t(11);
    n.exports = function (n, e) {
      return function (t, o) {
        if (null == t) return t;
        if (!r(t)) return n(t, o);
        for (var a = t.length, i = e ? a : -1, u = Object(t); (e ? i-- : ++i < a) && !1 !== o(u[i], i, u););
        return t;
      };
    };
  }, function (n, e, t) {
    var r = t(21),
      o = t(11);
    n.exports = function (n, e) {
      var t = -1,
        a = o(n) ? Array(n.length) : [];
      return r(n, function (n, r, o) {
        a[++t] = e(n, r, o);
      }), a;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r) {
      var o = -1,
        a = null == n ? 0 : n.length;
      for (r && a && (t = n[++o]); ++o < a;) t = e(t, n[o], o, n);
      return t;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r, o) {
      return o(n, function (n, o, a) {
        t = r ? (r = !1, n) : e(t, n, o, a);
      }), t;
    };
  }, function (n, e, t) {
    var r = t(10),
      o = t(11),
      a = t(12);
    n.exports = function (n) {
      return function (e, t, i) {
        var u = Object(e);
        if (!o(e)) {
          var c = r(t, 3);
          e = a(e), t = function t(n) {
            return c(u[n], n, u);
          };
        }
        var s = n(e, t, i);
        return s > -1 ? u[c ? e[s] : s] : void 0;
      };
    };
  }, function (n, e, t) {
    var r = t(21);
    n.exports = function (n, e) {
      var t;
      return r(n, function (n, r, o) {
        return !(t = e(n, r, o));
      }), !!t;
    };
  }, function (n, e, t) {
    var r = t(31),
      o = t(11),
      a = t(33),
      i = t(8);
    n.exports = function (n, e, t) {
      if (!i(t)) return !1;
      var u = typeof e;
      return !!("number" == u ? o(t) && a(e, t.length) : "string" == u && e in t) && r(t[e], n);
    };
  }, function (n, e, t) {
    var r = t(175);
    function o() {}
    function a() {}
    a.resetWarningCache = o, n.exports = function () {
      function n(n, e, t, o, a, i) {
        if (i !== r) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }
      function e() {
        return n;
      }
      n.isRequired = n;
      var t = {
        array: n,
        bool: n,
        func: n,
        number: n,
        object: n,
        string: n,
        symbol: n,
        any: n,
        arrayOf: e,
        element: n,
        elementType: n,
        instanceOf: e,
        node: n,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: a,
        resetWarningCache: o
      };
      return t.PropTypes = t, t;
    };
  }, function (n, e, t) {
    n.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (n, e, t) {
    var r = t(177);
    "string" == typeof r && (r = [[n.i, r, ""]]);
    var o = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    t(180)(r, o);
    r.locals && (n.exports = r.locals);
  }, function (n, e, t) {
    e = n.exports = t(178)(!1);
    var r = t(179)(t(59));
    e.push([n.i, ".flag {\n  width: 16px;\n  height: 11px;\n  background-image: url(" + r + ") !important;\n}\n.flag.margin {\n  margin-right: 8px;\n}\n.flag.ad {\n  background-position: -16px 0;\n}\n.flag.ae {\n  background-position: -32px 0;\n}\n.flag.af {\n  background-position: -48px 0;\n}\n.flag.ag {\n  background-position: -64px 0;\n}\n.flag.ai {\n  background-position: -80px 0;\n}\n.flag.al {\n  background-position: -96px 0;\n}\n.flag.am {\n  background-position: -112px 0;\n}\n.flag.ao {\n  background-position: -128px 0;\n}\n.flag.ar {\n  background-position: -144px 0;\n}\n.flag.as {\n  background-position: -160px 0;\n}\n.flag.at {\n  background-position: -176px 0;\n}\n.flag.au {\n  background-position: -192px 0;\n}\n.flag.aw {\n  background-position: -208px 0;\n}\n.flag.az {\n  background-position: -224px 0;\n}\n.flag.ba {\n  background-position: -240px 0;\n}\n.flag.bb {\n  background-position: 0 -11px;\n}\n.flag.bd {\n  background-position: -16px -11px;\n}\n.flag.be {\n  background-position: -32px -11px;\n}\n.flag.bf {\n  background-position: -48px -11px;\n}\n.flag.bg {\n  background-position: -64px -11px;\n}\n.flag.bh {\n  background-position: -80px -11px;\n}\n.flag.bi {\n  background-position: -96px -11px;\n}\n.flag.bj {\n  background-position: -112px -11px;\n}\n.flag.bm {\n  background-position: -128px -11px;\n}\n.flag.bn {\n  background-position: -144px -11px;\n}\n.flag.bo {\n  background-position: -160px -11px;\n}\n.flag.br {\n  background-position: -176px -11px;\n}\n.flag.bs {\n  background-position: -192px -11px;\n}\n.flag.bt {\n  background-position: -208px -11px;\n}\n.flag.bw {\n  background-position: -224px -11px;\n}\n.flag.by {\n  background-position: -240px -11px;\n}\n.flag.bz {\n  background-position: 0 -22px;\n}\n.flag.ca {\n  background-position: -16px -22px;\n}\n.flag.cd {\n  background-position: -32px -22px;\n}\n.flag.cf {\n  background-position: -48px -22px;\n}\n.flag.cg {\n  background-position: -64px -22px;\n}\n.flag.ch {\n  background-position: -80px -22px;\n}\n.flag.ci {\n  background-position: -96px -22px;\n}\n.flag.ck {\n  background-position: -112px -22px;\n}\n.flag.cl {\n  background-position: -128px -22px;\n}\n.flag.cm {\n  background-position: -144px -22px;\n}\n.flag.cn {\n  background-position: -160px -22px;\n}\n.flag.co {\n  background-position: -176px -22px;\n}\n.flag.cr {\n  background-position: -192px -22px;\n}\n.flag.cu {\n  background-position: -208px -22px;\n}\n.flag.cv {\n  background-position: -224px -22px;\n}\n.flag.cw {\n  background-position: -240px -22px;\n}\n.flag.cy {\n  background-position: 0 -33px;\n}\n.flag.cz {\n  background-position: -16px -33px;\n}\n.flag.de {\n  background-position: -32px -33px;\n}\n.flag.dj {\n  background-position: -48px -33px;\n}\n.flag.dk {\n  background-position: -64px -33px;\n}\n.flag.dm {\n  background-position: -80px -33px;\n}\n.flag.do {\n  background-position: -96px -33px;\n}\n.flag.dz {\n  background-position: -112px -33px;\n}\n.flag.ec {\n  background-position: -128px -33px;\n}\n.flag.ee {\n  background-position: -144px -33px;\n}\n.flag.eg {\n  background-position: -160px -33px;\n}\n.flag.er {\n  background-position: -176px -33px;\n}\n.flag.es {\n  background-position: -192px -33px;\n}\n.flag.et {\n  background-position: -208px -33px;\n}\n.flag.fi {\n  background-position: -224px -33px;\n}\n.flag.fj {\n  background-position: -240px -33px;\n}\n.flag.fk {\n  background-position: 0 -44px;\n}\n.flag.fm {\n  background-position: -16px -44px;\n}\n.flag.fo {\n  background-position: -32px -44px;\n}\n.flag.fr,\n.flag.bl,\n.flag.mf {\n  background-position: -48px -44px;\n}\n.flag.ga {\n  background-position: -64px -44px;\n}\n.flag.gb {\n  background-position: -80px -44px;\n}\n.flag.gd {\n  background-position: -96px -44px;\n}\n.flag.ge {\n  background-position: -112px -44px;\n}\n.flag.gf {\n  background-position: -128px -44px;\n}\n.flag.gh {\n  background-position: -144px -44px;\n}\n.flag.gi {\n  background-position: -160px -44px;\n}\n.flag.gl {\n  background-position: -176px -44px;\n}\n.flag.gm {\n  background-position: -192px -44px;\n}\n.flag.gn {\n  background-position: -208px -44px;\n}\n.flag.gp {\n  background-position: -224px -44px;\n}\n.flag.gq {\n  background-position: -240px -44px;\n}\n.flag.gr {\n  background-position: 0 -55px;\n}\n.flag.gt {\n  background-position: -16px -55px;\n}\n.flag.gu {\n  background-position: -32px -55px;\n}\n.flag.gw {\n  background-position: -48px -55px;\n}\n.flag.gy {\n  background-position: -64px -55px;\n}\n.flag.hk {\n  background-position: -80px -55px;\n}\n.flag.hn {\n  background-position: -96px -55px;\n}\n.flag.hr {\n  background-position: -112px -55px;\n}\n.flag.ht {\n  background-position: -128px -55px;\n}\n.flag.hu {\n  background-position: -144px -55px;\n}\n.flag.id {\n  background-position: -160px -55px;\n}\n.flag.ie {\n  background-position: -176px -55px;\n}\n.flag.il {\n  background-position: -192px -55px;\n}\n.flag.in {\n  background-position: -208px -55px;\n}\n.flag.io {\n  background-position: -224px -55px;\n}\n.flag.iq {\n  background-position: -240px -55px;\n}\n.flag.ir {\n  background-position: 0 -66px;\n}\n.flag.is {\n  background-position: -16px -66px;\n}\n.flag.it {\n  background-position: -32px -66px;\n}\n.flag.jm {\n  background-position: -48px -66px;\n}\n.flag.jo {\n  background-position: -64px -66px;\n}\n.flag.jp {\n  background-position: -80px -66px;\n}\n.flag.ke {\n  background-position: -96px -66px;\n}\n.flag.kg {\n  background-position: -112px -66px;\n}\n.flag.kh {\n  background-position: -128px -66px;\n}\n.flag.ki {\n  background-position: -144px -66px;\n}\n.flag.km {\n  background-position: -160px -66px;\n}\n.flag.kn {\n  background-position: -176px -66px;\n}\n.flag.kp {\n  background-position: -192px -66px;\n}\n.flag.kr {\n  background-position: -208px -66px;\n}\n.flag.kw {\n  background-position: -224px -66px;\n}\n.flag.ky {\n  background-position: -240px -66px;\n}\n.flag.kz {\n  background-position: 0 -77px;\n}\n.flag.la {\n  background-position: -16px -77px;\n}\n.flag.lb {\n  background-position: -32px -77px;\n}\n.flag.lc {\n  background-position: -48px -77px;\n}\n.flag.li {\n  background-position: -64px -77px;\n}\n.flag.lk {\n  background-position: -80px -77px;\n}\n.flag.lr {\n  background-position: -96px -77px;\n}\n.flag.ls {\n  background-position: -112px -77px;\n}\n.flag.lt {\n  background-position: -128px -77px;\n}\n.flag.lu {\n  background-position: -144px -77px;\n}\n.flag.lv {\n  background-position: -160px -77px;\n}\n.flag.ly {\n  background-position: -176px -77px;\n}\n.flag.ma {\n  background-position: -192px -77px;\n}\n.flag.mc {\n  background-position: -208px -77px;\n}\n.flag.md {\n  background-position: -224px -77px;\n}\n.flag.me {\n  background-position: -112px -154px;\n  height: 12px;\n}\n.flag.mg {\n  background-position: 0 -88px;\n}\n.flag.mh {\n  background-position: -16px -88px;\n}\n.flag.mk {\n  background-position: -32px -88px;\n}\n.flag.ml {\n  background-position: -48px -88px;\n}\n.flag.mm {\n  background-position: -64px -88px;\n}\n.flag.mn {\n  background-position: -80px -88px;\n}\n.flag.mo {\n  background-position: -96px -88px;\n}\n.flag.mp {\n  background-position: -112px -88px;\n}\n.flag.mq {\n  background-position: -128px -88px;\n}\n.flag.mr {\n  background-position: -144px -88px;\n}\n.flag.ms {\n  background-position: -160px -88px;\n}\n.flag.mt {\n  background-position: -176px -88px;\n}\n.flag.mu {\n  background-position: -192px -88px;\n}\n.flag.mv {\n  background-position: -208px -88px;\n}\n.flag.mw {\n  background-position: -224px -88px;\n}\n.flag.mx {\n  background-position: -240px -88px;\n}\n.flag.my {\n  background-position: 0 -99px;\n}\n.flag.mz {\n  background-position: -16px -99px;\n}\n.flag.na {\n  background-position: -32px -99px;\n}\n.flag.nc {\n  background-position: -48px -99px;\n}\n.flag.ne {\n  background-position: -64px -99px;\n}\n.flag.nf {\n  background-position: -80px -99px;\n}\n.flag.ng {\n  background-position: -96px -99px;\n}\n.flag.ni {\n  background-position: -112px -99px;\n}\n.flag.nl,\n.flag.bq {\n  background-position: -128px -99px;\n}\n.flag.no {\n  background-position: -144px -99px;\n}\n.flag.np {\n  background-position: -160px -99px;\n}\n.flag.nr {\n  background-position: -176px -99px;\n}\n.flag.nu {\n  background-position: -192px -99px;\n}\n.flag.nz {\n  background-position: -208px -99px;\n}\n.flag.om {\n  background-position: -224px -99px;\n}\n.flag.pa {\n  background-position: -240px -99px;\n}\n.flag.pe {\n  background-position: 0 -110px;\n}\n.flag.pf {\n  background-position: -16px -110px;\n}\n.flag.pg {\n  background-position: -32px -110px;\n}\n.flag.ph {\n  background-position: -48px -110px;\n}\n.flag.pk {\n  background-position: -64px -110px;\n}\n.flag.pl {\n  background-position: -80px -110px;\n}\n.flag.pm {\n  background-position: -96px -110px;\n}\n.flag.pr {\n  background-position: -112px -110px;\n}\n.flag.ps {\n  background-position: -128px -110px;\n}\n.flag.pt {\n  background-position: -144px -110px;\n}\n.flag.pw {\n  background-position: -160px -110px;\n}\n.flag.py {\n  background-position: -176px -110px;\n}\n.flag.qa {\n  background-position: -192px -110px;\n}\n.flag.re {\n  background-position: -208px -110px;\n}\n.flag.ro {\n  background-position: -224px -110px;\n}\n.flag.rs {\n  background-position: -240px -110px;\n}\n.flag.ru {\n  background-position: 0 -121px;\n}\n.flag.rw {\n  background-position: -16px -121px;\n}\n.flag.sa {\n  background-position: -32px -121px;\n}\n.flag.sb {\n  background-position: -48px -121px;\n}\n.flag.sc {\n  background-position: -64px -121px;\n}\n.flag.sd {\n  background-position: -80px -121px;\n}\n.flag.se {\n  background-position: -96px -121px;\n}\n.flag.sg {\n  background-position: -112px -121px;\n}\n.flag.sh {\n  background-position: -128px -121px;\n}\n.flag.si {\n  background-position: -144px -121px;\n}\n.flag.sk {\n  background-position: -160px -121px;\n}\n.flag.sl {\n  background-position: -176px -121px;\n}\n.flag.sm {\n  background-position: -192px -121px;\n}\n.flag.sn {\n  background-position: -208px -121px;\n}\n.flag.so {\n  background-position: -224px -121px;\n}\n.flag.sr {\n  background-position: -240px -121px;\n}\n.flag.ss {\n  background-position: 0 -132px;\n}\n.flag.st {\n  background-position: -16px -132px;\n}\n.flag.sv {\n  background-position: -32px -132px;\n}\n.flag.sx {\n  background-position: -48px -132px;\n}\n.flag.sy {\n  background-position: -64px -132px;\n}\n.flag.sz {\n  background-position: -80px -132px;\n}\n.flag.tc {\n  background-position: -96px -132px;\n}\n.flag.td {\n  background-position: -112px -132px;\n}\n.flag.tg {\n  background-position: -128px -132px;\n}\n.flag.th {\n  background-position: -144px -132px;\n}\n.flag.tj {\n  background-position: -160px -132px;\n}\n.flag.tk {\n  background-position: -176px -132px;\n}\n.flag.tl {\n  background-position: -192px -132px;\n}\n.flag.tm {\n  background-position: -208px -132px;\n}\n.flag.tn {\n  background-position: -224px -132px;\n}\n.flag.to {\n  background-position: -240px -132px;\n}\n.flag.tr {\n  background-position: 0 -143px;\n}\n.flag.tt {\n  background-position: -16px -143px;\n}\n.flag.tv {\n  background-position: -32px -143px;\n}\n.flag.tw {\n  background-position: -48px -143px;\n}\n.flag.tz {\n  background-position: -64px -143px;\n}\n.flag.ua {\n  background-position: -80px -143px;\n}\n.flag.ug {\n  background-position: -96px -143px;\n}\n.flag.us {\n  background-position: -112px -143px;\n}\n.flag.uy {\n  background-position: -128px -143px;\n}\n.flag.uz {\n  background-position: -144px -143px;\n}\n.flag.va {\n  background-position: -160px -143px;\n}\n.flag.vc {\n  background-position: -176px -143px;\n}\n.flag.ve {\n  background-position: -192px -143px;\n}\n.flag.vg {\n  background-position: -208px -143px;\n}\n.flag.vi {\n  background-position: -224px -143px;\n}\n.flag.vn {\n  background-position: -240px -143px;\n}\n.flag.vu {\n  background-position: 0 -154px;\n}\n.flag.wf {\n  background-position: -16px -154px;\n}\n.flag.ws {\n  background-position: -32px -154px;\n}\n.flag.ye {\n  background-position: -48px -154px;\n}\n.flag.za {\n  background-position: -64px -154px;\n}\n.flag.zm {\n  background-position: -80px -154px;\n}\n.flag.zw {\n  background-position: -96px -154px;\n}\n", ""]);
  }, function (n, e, t) {
    n.exports = function (n) {
      var e = [];
      return e.toString = function () {
        return this.map(function (e) {
          var t = function (n, e) {
            var t = n[1] || "",
              r = n[3];
            if (!r) return t;
            if (e && "function" == typeof btoa) {
              var o = (i = r, u = btoa(unescape(encodeURIComponent(JSON.stringify(i)))), c = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(u), "/*# ".concat(c, " */")),
                a = r.sources.map(function (n) {
                  return "/*# sourceURL=".concat(r.sourceRoot).concat(n, " */");
                });
              return [t].concat(a).concat([o]).join("\n");
            }
            var i, u, c;
            return [t].join("\n");
          }(e, n);
          return e[2] ? "@media ".concat(e[2], "{").concat(t, "}") : t;
        }).join("");
      }, e.i = function (n, t) {
        "string" == typeof n && (n = [[null, n, ""]]);
        for (var r = {}, o = 0; o < this.length; o++) {
          var a = this[o][0];
          null != a && (r[a] = !0);
        }
        for (var i = 0; i < n.length; i++) {
          var u = n[i];
          null != u[0] && r[u[0]] || (t && !u[2] ? u[2] = t : t && (u[2] = "(".concat(u[2], ") and (").concat(t, ")")), e.push(u));
        }
      }, e;
    };
  }, function (n, e, t) {
    n.exports = function (n, e) {
      return "string" != typeof (n = n.__esModule ? n["default"] : n) ? n : (/^['"].*['"]$/.test(n) && (n = n.slice(1, -1)), /["'() \t\n]/.test(n) || e ? '"'.concat(n.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : n);
    };
  }, function (n, e, t) {
    var r,
      o,
      a = {},
      i = (r = function r() {
        return window && document && document.all && !window.atob;
      }, function () {
        return void 0 === o && (o = r.apply(this, arguments)), o;
      }),
      u = function u(n, e) {
        return e ? e.querySelector(n) : document.querySelector(n);
      },
      c = function (n) {
        var e = {};
        return function (n, t) {
          if ("function" == typeof n) return n();
          if (void 0 === e[n]) {
            var r = u.call(this, n, t);
            if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
              r = r.contentDocument.head;
            } catch (n) {
              r = null;
            }
            e[n] = r;
          }
          return e[n];
        };
      }(),
      s = null,
      p = 0,
      f = [],
      l = t(181);
    function g(n, e) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t],
          o = a[r.id];
        if (o) {
          o.refs++;
          for (var i = 0; i < o.parts.length; i++) o.parts[i](r.parts[i]);
          for (; i < r.parts.length; i++) o.parts.push(h(r.parts[i], e));
        } else {
          var u = [];
          for (i = 0; i < r.parts.length; i++) u.push(h(r.parts[i], e));
          a[r.id] = {
            id: r.id,
            refs: 1,
            parts: u
          };
        }
      }
    }
    function d(n, e) {
      for (var t = [], r = {}, o = 0; o < n.length; o++) {
        var a = n[o],
          i = e.base ? a[0] + e.base : a[0],
          u = {
            css: a[1],
            media: a[2],
            sourceMap: a[3]
          };
        r[i] ? r[i].parts.push(u) : t.push(r[i] = {
          id: i,
          parts: [u]
        });
      }
      return t;
    }
    function b(n, e) {
      var t = c(n.insertInto);
      if (!t) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = f[f.length - 1];
      if ("top" === n.insertAt) r ? r.nextSibling ? t.insertBefore(e, r.nextSibling) : t.appendChild(e) : t.insertBefore(e, t.firstChild), f.push(e);else if ("bottom" === n.insertAt) t.appendChild(e);else {
        if ("object" != typeof n.insertAt || !n.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o = c(n.insertAt.before, t);
        t.insertBefore(e, o);
      }
    }
    function x(n) {
      if (null === n.parentNode) return !1;
      n.parentNode.removeChild(n);
      var e = f.indexOf(n);
      e >= 0 && f.splice(e, 1);
    }
    function A(n) {
      var e = document.createElement("style");
      if (void 0 === n.attrs.type && (n.attrs.type = "text/css"), void 0 === n.attrs.nonce) {
        var r = function () {
          return t.nc;
        }();
        r && (n.attrs.nonce = r);
      }
      return v(e, n.attrs), b(n, e), e;
    }
    function v(n, e) {
      Object.keys(e).forEach(function (t) {
        n.setAttribute(t, e[t]);
      });
    }
    function h(n, e) {
      var t, r, o, a;
      if (e.transform && n.css) {
        if (!(a = "function" == typeof e.transform ? e.transform(n.css) : e.transform["default"](n.css))) return function () {};
        n.css = a;
      }
      if (e.singleton) {
        var i = p++;
        t = s || (s = A(e)), r = C.bind(null, t, i, !1), o = C.bind(null, t, i, !0);
      } else n.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (t = function (n) {
        var e = document.createElement("link");
        return void 0 === n.attrs.type && (n.attrs.type = "text/css"), n.attrs.rel = "stylesheet", v(e, n.attrs), b(n, e), e;
      }(e), r = w.bind(null, t, e), o = function o() {
        x(t), t.href && URL.revokeObjectURL(t.href);
      }) : (t = A(e), r = k.bind(null, t), o = function o() {
        x(t);
      });
      return r(n), function (e) {
        if (e) {
          if (e.css === n.css && e.media === n.media && e.sourceMap === n.sourceMap) return;
          r(n = e);
        } else o();
      };
    }
    n.exports = function (n, e) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (e = e || {}).attrs = "object" == typeof e.attrs ? e.attrs : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = i()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
      var t = d(n, e);
      return g(t, e), function (n) {
        for (var r = [], o = 0; o < t.length; o++) {
          var i = t[o];
          (u = a[i.id]).refs--, r.push(u);
        }
        n && g(d(n, e), e);
        for (o = 0; o < r.length; o++) {
          var u;
          if (0 === (u = r[o]).refs) {
            for (var c = 0; c < u.parts.length; c++) u.parts[c]();
            delete a[u.id];
          }
        }
      };
    };
    var m,
      y = (m = [], function (n, e) {
        return m[n] = e, m.filter(Boolean).join("\n");
      });
    function C(n, e, t, r) {
      var o = t ? "" : r.css;
      if (n.styleSheet) n.styleSheet.cssText = y(e, o);else {
        var a = document.createTextNode(o),
          i = n.childNodes;
        i[e] && n.removeChild(i[e]), i.length ? n.insertBefore(a, i[e]) : n.appendChild(a);
      }
    }
    function k(n, e) {
      var t = e.css,
        r = e.media;
      if (r && n.setAttribute("media", r), n.styleSheet) n.styleSheet.cssText = t;else {
        for (; n.firstChild;) n.removeChild(n.firstChild);
        n.appendChild(document.createTextNode(t));
      }
    }
    function w(n, e, t) {
      var r = t.css,
        o = t.sourceMap,
        a = void 0 === e.convertToAbsoluteUrls && o;
      (e.convertToAbsoluteUrls || a) && (r = l(r)), o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
      var i = new Blob([r], {
          type: "text/css"
        }),
        u = n.href;
      n.href = URL.createObjectURL(i), u && URL.revokeObjectURL(u);
    }
  }, function (n, e) {
    n.exports = function (n) {
      var e = "undefined" != typeof window && window.location;
      if (!e) throw new Error("fixUrls requires window.location");
      if (!n || "string" != typeof n) return n;
      var t = e.protocol + "//" + e.host,
        r = t + e.pathname.replace(/\/[^\/]*$/, "/");
      return n.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (n, e) {
        var o,
          a = e.trim().replace(/^"(.*)"$/, function (n, e) {
            return e;
          }).replace(/^'(.*)'$/, function (n, e) {
            return e;
          });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(a) ? n : (o = 0 === a.indexOf("//") ? a : 0 === a.indexOf("/") ? t + a : r + a.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
      });
    };
  }, function (n, e, t) {
    t.r(e);
    var r = t(36),
      o = t.n(r),
      a = t(4),
      i = t.n(a),
      u = t(60),
      c = t.n(u),
      s = t(22),
      p = t.n(s),
      f = t(61),
      l = t.n(f),
      g = t(62),
      d = t.n(g),
      b = t(63),
      x = t.n(b),
      A = t(23),
      v = t.n(A),
      h = t(64),
      m = t.n(h),
      y = t(24),
      C = t.n(y),
      k = t(13),
      w = t.n(k),
      B = t(37),
      j = t.n(B),
      P = t(5),
      O = t.n(P),
      E = t(38),
      I = t.n(E),
      D = t(1),
      Q = t.n(D),
      S = t(0),
      T = t.n(S),
      M = t(65),
      R = t.n(M),
      F = t(66),
      U = t.n(F),
      L = t(67),
      N = t.n(L),
      z = t(68),
      K = t.n(z),
      G = t(69),
      H = t.n(G),
      q = t(70),
      Y = t.n(q),
      V = t(71),
      J = t.n(V),
      X = t(72),
      Z = t.n(X),
      W = t(39),
      _ = t.n(W),
      $ = t(73),
      nn = t.n($),
      en = t(74),
      tn = t.n(en);
    function rn(n) {
      return (rn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
        return typeof n;
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      })(n);
    }
    function on() {
      return (on = Object.assign || function (n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
      }).apply(this, arguments);
    }
    function an(n, e) {
      if (null == n) return {};
      var t,
        r,
        o = function (n, e) {
          if (null == n) return {};
          var t,
            r,
            o = {},
            a = Object.keys(n);
          for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || (o[t] = n[t]);
          return o;
        }(n, e);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(n);
        for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]);
      }
      return o;
    }
    function un(n, e) {
      for (var t = 0; t < e.length; t++) {
        var r = e[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
      }
    }
    function cn(n, e) {
      return !e || "object" !== rn(e) && "function" != typeof e ? function (n) {
        if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return n;
      }(n) : e;
    }
    function sn(n) {
      return (sn = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      })(n);
    }
    function pn(n, e) {
      return (pn = Object.setPrototypeOf || function (n, e) {
        return n.__proto__ = e, n;
      })(n, e);
    }
    var fn = function (n) {
      function e() {
        return function (n, e) {
          if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), cn(this, sn(e).apply(this, arguments));
      }
      var t, r;
      return function (n, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        n.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: n,
            writable: !0,
            configurable: !0
          }
        }), e && pn(n, e);
      }(e, n), t = e, (r = [{
        key: "render",
        value: function value() {
          var n = this.props,
            e = n.name,
            t = n.iso2,
            r = n.dialCode,
            o = n.localization,
            a = n.itemRef,
            i = n["native"],
            u = an(n, ["name", "iso2", "dialCode", "localization", "itemRef", "native"]);
          return i ? Q.a.createElement("option", on({
            className: "country",
            "data-dial-code": "1",
            "data-country-code": t,
            value: t
          }, u), o || e, " ", "+".concat(r)) : Q.a.createElement(tn.a, {
            rootRef: function rootRef(n) {
              return a(n);
            }
          }, Q.a.createElement(nn.a, on({
            className: "country",
            "data-dial-code": "1",
            "data-country-code": t
          }, u), Q.a.createElement("div", {
            className: "flag ".concat(t, " margin")
          }), Q.a.createElement("span", {
            className: "country-name"
          }, o || e), Q.a.createElement("span", {
            className: "dial-code"
          }, "+".concat(r))));
        }
      }]) && un(t.prototype, r), e;
    }(Q.a.PureComponent);
    fn.propTypes = {
      name: T.a.string.isRequired,
      iso2: T.a.string.isRequired,
      dialCode: T.a.string.isRequired,
      itemRef: T.a.func.isRequired,
      localization: T.a.string,
      "native": T.a.bool
    }, fn.defaultProps = {
      localization: null,
      "native": !1
    };
    var ln = fn;
    t(176), t(59);
    function gn(n) {
      return (gn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
        return typeof n;
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      })(n);
    }
    function dn() {
      return (dn = Object.assign || function (n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
      }).apply(this, arguments);
    }
    function bn(n, e) {
      var t = Object.keys(n);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(n);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        })), t.push.apply(t, r);
      }
      return t;
    }
    function xn(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = null != arguments[e] ? arguments[e] : {};
        e % 2 ? bn(t, !0).forEach(function (e) {
          Cn(n, e, t[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : bn(t).forEach(function (e) {
          Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(t, e));
        });
      }
      return n;
    }
    function An(n, e) {
      if (null == n) return {};
      var t,
        r,
        o = function (n, e) {
          if (null == n) return {};
          var t,
            r,
            o = {},
            a = Object.keys(n);
          for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || (o[t] = n[t]);
          return o;
        }(n, e);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(n);
        for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]);
      }
      return o;
    }
    function vn(n, e) {
      for (var t = 0; t < e.length; t++) {
        var r = e[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
      }
    }
    function hn(n) {
      return (hn = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      })(n);
    }
    function mn(n) {
      if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return n;
    }
    function yn(n, e) {
      return (yn = Object.setPrototypeOf || function (n, e) {
        return n.__proto__ = e, n;
      })(n, e);
    }
    function Cn(n, e, t) {
      return e in n ? Object.defineProperty(n, e, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[e] = t, n;
    }
    var kn = function (n) {
      function e(n) {
        var t;
        !function (n, e) {
          if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), t = function (n, e) {
          return !e || "object" !== gn(e) && "function" != typeof e ? mn(n) : e;
        }(this, hn(e).call(this, n)), Cn(mn(t), "flags", {}), Cn(mn(t), "guessSelectedCountry", p()(function (n, e, r) {
          var o = O()(e, {
            iso2: r
          }) || {};
          if ("" === c()(n)) return o;
          var a = j()(e, function (e, t) {
            if (i()(n, t.dialCode)) {
              if (t.dialCode.length > e.dialCode.length) return t;
              if (t.dialCode.length === e.dialCode.length && t.priority < e.priority) return t;
            }
            return e;
          }, {
            dialCode: "",
            priority: 10001
          }, mn(t));
          return a.name ? a : o;
        })), Cn(mn(t), "getProbableCandidate", p()(function (n) {
          if (!n || 0 === n.length) return null;
          var e = t.state.onlyCountries;
          return C()(e, function (e) {
            return i()(e.name.toLowerCase(), n.toLowerCase());
          }, mn(t))[0];
        })), Cn(mn(t), "getOnlyCountries", function (n, e) {
          return 0 === n.length ? e : e.filter(function (e) {
            return n.some(function (n) {
              return n === e.iso2;
            });
          });
        }), Cn(mn(t), "excludeCountries", function (n, e) {
          return 0 === e.length ? n : C()(n, function (n) {
            return !m()(e, n.iso2);
          });
        }), Cn(mn(t), "filterRegions", function (n, e) {
          if ("string" == typeof n) {
            var t = n;
            return e.filter(function (n) {
              return n.regions.some(function (n) {
                return n === t;
              });
            });
          }
          return e.filter(function (e) {
            return n.map(function (n) {
              return e.regions.some(function (e) {
                return e === n;
              });
            }).some(function (n) {
              return n;
            });
          });
        }), Cn(mn(t), "deleteAreaCodes", function (n) {
          return n.filter(function (n) {
            return !0 !== n.isAreaCode;
          });
        }), Cn(mn(t), "updateDefaultCountry", function (n) {
          var e = t.state.onlyCountries,
            r = t.props.disableCountryCode,
            o = O()(e, {
              iso2: n
            });
          t.setState({
            defaultCountry: n,
            selectedCountry: o,
            formattedNumber: r ? "" : "+".concat(o.dialCode)
          });
        }), Cn(mn(t), "scrollTo", function (n) {
          if (n) {
            var e = t.dropdownContainerRef;
            e && document.body && (e.scrollTop = n.offsetTop);
          }
        }), Cn(mn(t), "formatNumber", function (n, e) {
          var r,
            o = t.props,
            a = o.disableCountryCode,
            i = o.enableLongNumbers,
            u = o.autoFormat;
          if (a && e ? ((r = e.split(" ")).shift(), r = r.join(" ")) : r = e, !n || 0 === n.length) return a ? "" : "+";
          if (n && n.length < 2 || !r || !u) return a ? n : "+".concat(n);
          var c,
            s = j()(r, function (n, e) {
              return 0 === n.remainingText.length ? n : "." !== e ? {
                formattedText: n.formattedText + e,
                remainingText: n.remainingText
              } : {
                formattedText: n.formattedText + x()(n.remainingText),
                remainingText: d()(n.remainingText)
              };
            }, {
              formattedText: "",
              remainingText: n.split("")
            });
          return (c = i ? s.formattedText + s.remainingText.join("") : s.formattedText).includes("(") && !c.includes(")") && (c += ")"), c;
        }), Cn(mn(t), "cursorToEnd", function () {
          var n = t.props.isModernBrowser,
            e = t.inputRef;
          if (e.focus(), n) {
            var r = e.value.length;
            e.setSelectionRange(r, r);
          }
        }), Cn(mn(t), "getElement", function (n) {
          return t.flags["flag_no_".concat(n)];
        }), Cn(mn(t), "getCountryData", function () {
          var n = t.state.selectedCountry;
          return n ? {
            name: n.name || "",
            dialCode: n.dialCode || "",
            countryCode: n.iso2 || ""
          } : {};
        }), Cn(mn(t), "handleInput", function (n) {
          var e = t.state,
            r = e.selectedCountry,
            o = e.freezeSelection,
            a = t.state,
            i = a.selectedCountry,
            u = a.formattedNumber,
            c = a.onlyCountries,
            s = a.defaultCountry,
            p = t.props,
            f = p.disableCountryCode,
            l = p.countryCodeEditable,
            g = p.isModernBrowser,
            d = p.onChange,
            b = f ? "" : "+";
          if (!l) {
            var x = "+".concat(r.dialCode);
            if (n.target.value.length < x.length) return;
          }
          if (!(n.target.value.replace(/\D/g, "").length > 15) && n.target.value !== u) {
            if (n.preventDefault ? n.preventDefault() : n.returnValue = !1, n.target.value.length > 0) {
              var A = n.target.value.replace(/\D/g, "");
              (!o || i.dialCode.length > A.length) && (r = t.guessSelectedCountry(A.substring(0, 6), c, s), o = !1), b = t.formatNumber(A, r.format);
            }
            var v = n.target.selectionStart,
              h = b.length - u.length;
            t.setState({
              formattedNumber: b,
              freezeSelection: o,
              selectedCountry: r.dialCode ? r : i
            }, function () {
              g && (h > 0 && (v -= h), ")" === b.charAt(b.length - 1) ? t.inputRef.setSelectionRange(b.length - 1, b.length - 1) : v > 0 && u.length >= b.length && t.inputRef.setSelectionRange(v, v));
              d && d(b, t.getCountryData());
            });
          }
        }), Cn(mn(t), "handleRefInput", function (n) {
          var e,
            r = t.props,
            o = r.inputRef,
            a = r.InputProps;
          t.inputRef = n, o ? e = o : a && a.ref && (e = a.ref), e && ("function" == typeof e ? e(n) : e.current = n);
        }), Cn(mn(t), "handleInputClick", function (n) {
          var e = t.props.onClick;
          e && e(n, t.getCountryData());
        }), Cn(mn(t), "handleFlagItemClick", function (n) {
          var e = t.state,
            r = e.formattedNumber,
            a = e.selectedCountry,
            i = e.onlyCountries,
            u = t.props.onChange,
            c = a,
            s = o()(n) ? O()(i, function (e) {
              return e.iso2 === n;
            }) : O()(i, n),
            p = r.replace(" ", "").replace("(", "").replace(")", "").replace("-", ""),
            f = p.length > 1 ? p.replace(c.dialCode, s.dialCode) : s.dialCode,
            l = t.formatNumber(f.replace(/\D/g, ""), s.format);
          t.setState({
            anchorEl: null,
            selectedCountry: s,
            freezeSelection: !0,
            formattedNumber: l
          }, function () {
            t.cursorToEnd(), u && u(l, t.getCountryData());
          });
        }), Cn(mn(t), "handleInputFocus", function (n) {
          var e = t.state.selectedCountry,
            r = t.props,
            o = r.disableCountryCode,
            a = r.onFocus;
          t.inputRef && "+" === t.inputRef.value && e && !o && t.setState({
            formattedNumber: "+".concat(e.dialCode)
          }, function () {
            return setTimeout(t.cursorToEnd, 10);
          }), t.setState({
            placeholder: ""
          }), a && a(n, t.getCountryData()), setTimeout(t.cursorToEnd, 10);
        }), Cn(mn(t), "handleInputBlur", function (n) {
          var e = t.props,
            r = e.placeholder,
            o = e.onBlur;
          n.target.value || t.setState({
            placeholder: r
          }), o && o(n, t.getCountryData());
        }), Cn(mn(t), "getHighlightCountryIndex", function (n) {
          var e = t.state,
            r = e.highlightCountryIndex,
            o = e.onlyCountries,
            a = e.preferredCountries,
            i = r + n;
          return i < 0 || i >= o.length + a.length ? i - n : i;
        }), Cn(mn(t), "searchCountry", function () {
          var n = t.state,
            e = n.queryString,
            r = n.onlyCountries,
            o = n.preferredCountries,
            a = t.getProbableCandidate(e) || r[0],
            i = v()(r, a) + o.length;
          t.scrollTo(t.getElement(i), !0), t.setState({
            queryString: "",
            highlightCountryIndex: i
          });
        }), Cn(mn(t), "handleKeydown", function (n) {
          var e = t.state,
            r = e.anchorEl,
            o = e.highlightCountryIndex,
            a = e.preferredCountries,
            i = e.onlyCountries,
            u = e.queryString,
            c = e.debouncedQueryStingSearcher,
            s = t.props,
            p = s.keys,
            f = s.disabled;
          if (r && !f) {
            n.preventDefault ? n.preventDefault() : n.returnValue = !1;
            var l = function l(n) {
              t.setState({
                highlightCountryIndex: t.getHighlightCountryIndex(n)
              }, function () {
                t.scrollTo(t.getElement(o + a.length), !0);
              });
            };
            switch (n.which) {
              case p.DOWN:
                l(1);
                break;
              case p.UP:
                l(-1);
                break;
              case p.ENTER:
                t.handleFlagItemClick(i[o], n);
                break;
              case p.ESC:
                t.setState({
                  anchorEl: null
                }, t.cursorToEnd);
                break;
              default:
                (n.which >= p.A && n.which <= p.Z || n.which === p.SPACE) && t.setState({
                  queryString: u + String.fromCharCode(n.which)
                }, c);
            }
          }
        }), Cn(mn(t), "handleInputKeyDown", function (n) {
          var e = t.props,
            r = e.keys,
            o = e.onEnterKeyPress,
            a = e.onKeyDown;
          n.which === r.ENTER && o && o(n), a && a(n);
        }), Cn(mn(t), "checkIfValid", function () {
          var n = t.state.formattedNumber;
          return (0, t.props.isValid)(n.replace(/\D/g, ""));
        }), Cn(mn(t), "updateFormattedNumber", function (n) {
          var e,
            r = t.state,
            o = r.onlyCountries,
            a = r.defaultCountry,
            u = t.props.disableCountryCode,
            c = n,
            s = n;
          if (c.startsWith("+")) c = c.replace(/\D/g, ""), e = t.guessSelectedCountry(c.substring(0, 6), o, a), s = t.formatNumber(c, e.format);else {
            var p = (e = O()(o, {
              iso2: a
            })) && !i()(c.replace(/\D/g, ""), e.dialCode) ? e.dialCode : "";
            s = t.formatNumber((u ? "" : p) + c.replace(/\D/g, ""), e ? e.format : void 0);
          }
          t.setState({
            selectedCountry: e,
            formattedNumber: s
          });
        }), Cn(mn(t), "getDropdownProps", function () {
          var n = t.state,
            e = n.selectedCountry,
            r = n.anchorEl,
            o = n.preferredCountries,
            a = n.onlyCountries,
            i = t.props,
            u = i.classes,
            c = i.dropdownClass,
            s = i.localization,
            p = i.disableDropdown,
            f = i["native"],
            l = "flag ".concat(e.iso2),
            g = function g(n) {
              return Boolean(e && e.dialCode === n.dialCode);
            };
          return p ? {} : {
            startAdornment: Q.a.createElement(N.a, {
              className: u.positionStart,
              position: "start"
            }, f ? Q.a.createElement(Q.a.Fragment, null, Q.a.createElement(J.a, {
              id: "country-menu",
              open: Boolean(r),
              onClose: function onClose() {
                return t.setState({
                  anchorEl: null
                });
              },
              className: u["native"],
              classes: {
                root: R()(u.nativeRoot, "native", l),
                select: u.nativeSelect
              },
              onChange: function onChange(n) {
                return t.handleFlagItemClick(n.target.value);
              },
              disableUnderline: !0
            }, !!o.length && w()(o, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name],
                "native": !0
              });
            }), w()(a, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name],
                "native": !0
              });
            }))) : Q.a.createElement(Q.a.Fragment, null, Q.a.createElement(K.a, {
              className: u.flagButton,
              "aria-owns": r ? "country-menu" : null,
              "aria-label": "Select country",
              onClick: function onClick(n) {
                return t.setState({
                  anchorEl: n.currentTarget
                });
              },
              "aria-haspopup": !0
            }, Q.a.createElement("div", {
              className: l
            })), Q.a.createElement(H.a, {
              className: c,
              id: "country-menu",
              anchorEl: r,
              open: Boolean(r),
              onClose: function onClose() {
                return t.setState({
                  anchorEl: null
                });
              }
            }, !!o.length && w()(o, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                selected: g(n),
                onClick: function onClick() {
                  return t.handleFlagItemClick(n);
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name]
              });
            }), !!o.length && Q.a.createElement(Y.a, null), w()(a, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                selected: g(n),
                onClick: function onClick() {
                  return t.handleFlagItemClick(n);
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name]
              });
            }))))
          };
        });
        var r = _.a.allCountries;
        n.disableAreaCodes && (r = t.deleteAreaCodes(r)), n.regions && (r = t.filterRegions(n.regions, r));
        var a,
          u = t.excludeCountries(t.getOnlyCountries(n.onlyCountries, r), n.excludeCountries),
          s = C()(r, function (e) {
            return I()(n.preferredCountries, function (n) {
              return n === e.iso2;
            });
          }),
          f = n.value || "";
        a = f.length > 1 ? t.guessSelectedCountry(f.replace(/\D/g, "").substring(0, 6), u, n.defaultCountry) || 0 : n.defaultCountry && O()(u, {
          iso2: n.defaultCountry
        }) || 0;
        var g = v()(t.allCountries, a),
          b = f.length < 2 && a && !i()(f.replace(/\D/g, ""), a.dialCode) ? a.dialCode : "",
          A = "" === f && 0 === a ? "" : t.formatNumber((n.disableCountryCode ? "" : b) + f.replace(/\D/g, ""), a.name ? a.format : void 0);
        return t.state = {
          formattedNumber: A,
          placeholder: n.placeholder,
          onlyCountries: u,
          preferredCountries: s,
          defaultCountry: n.defaultCountry,
          selectedCountry: a,
          highlightCountryIndex: g,
          queryString: "",
          freezeSelection: !1,
          debouncedQueryStingSearcher: l()(t.searchCountry, 100),
          anchorEl: null
        }, t;
      }
      var t, r;
      return function (n, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        n.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: n,
            writable: !0,
            configurable: !0
          }
        }), e && yn(n, e);
      }(e, n), t = e, (r = [{
        key: "componentDidMount",
        value: function value() {
          document.addEventListener && document.addEventListener("keydown", this.handleKeydown);
        }
      }, {
        key: "componentDidUpdate",
        value: function value(n) {
          var e = n.value,
            t = this.state,
            r = t.defaultCountry,
            o = t.formattedNumber,
            a = this.props,
            i = a.defaultCountry,
            u = a.value;
          i && i !== r && this.updateDefaultCountry(i), "string" == typeof u && u !== e && u !== o && this.updateFormattedNumber(u);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          document.removeEventListener && document.removeEventListener("keydown", this.handleKeydown);
        }
      }, {
        key: "render",
        value: function value() {
          var n = this.state,
            e = n.formattedNumber,
            t = n.placeholder,
            r = this.props,
            o = r.inputClass,
            a = r.error,
            i = r.InputProps,
            u = An(r, ["native", "defaultCountry", "excludeCountries", "onlyCountries", "preferredCountries", "dropdownClass", "autoFormat", "disableAreaCodes", "isValid", "disableCountryCode", "disableDropdown", "enableLongNumbers", "countryCodeEditable", "onEnterKeyPress", "isModernBrowser", "classes", "keys", "localization", "placeholder", "regions", "onChange", "value", "inputClass", "error", "InputProps"]),
            c = this.getDropdownProps();
          return Q.a.createElement(U.a, dn({
            placeholder: t,
            value: e,
            className: o,
            inputRef: this.handleRefInput,
            error: a || !this.checkIfValid(),
            onChange: this.handleInput,
            onClick: this.handleInputClick,
            onFocus: this.handleInputFocus,
            onBlur: this.handleInputBlur,
            onKeyDown: this.handleInputKeyDown,
            type: "tel",
            InputProps: xn({}, c, {}, i)
          }, u));
        }
      }]) && vn(t.prototype, r), e;
    }(Q.a.Component);
    kn.propTypes = {
      classes: T.a.object,
      excludeCountries: T.a.arrayOf(T.a.string),
      onlyCountries: T.a.arrayOf(T.a.string),
      preferredCountries: T.a.arrayOf(T.a.string),
      defaultCountry: T.a.string,
      value: T.a.string,
      placeholder: T.a.string,
      disabled: T.a.bool,
      error: T.a.bool,
      variant: T.a.string,
      "native": T.a.bool,
      inputClass: T.a.string,
      dropdownClass: T.a.string,
      InputProps: T.a.object,
      inputProps: T.a.object,
      inputRef: T.a.func,
      autoFormat: T.a.bool,
      disableAreaCodes: T.a.bool,
      disableCountryCode: T.a.bool,
      disableDropdown: T.a.bool,
      enableLongNumbers: T.a.bool,
      countryCodeEditable: T.a.bool,
      regions: T.a.oneOfType([T.a.string, T.a.arrayOf(T.a.string)]),
      localization: T.a.object,
      onChange: T.a.func,
      onFocus: T.a.func,
      onBlur: T.a.func,
      onClick: T.a.func,
      onKeyDown: T.a.func,
      isValid: T.a.func,
      isModernBrowser: T.a.func,
      onEnterKeyPress: T.a.func,
      keys: T.a.object
    }, kn.defaultProps = {
      excludeCountries: [],
      onlyCountries: [],
      preferredCountries: [],
      defaultCountry: "",
      placeholder: "+1 (702) 123-4567",
      disabled: !1,
      error: !1,
      variant: "standard",
      "native": !1,
      inputClass: "",
      dropdownClass: "",
      autoFormat: !0,
      disableAreaCodes: !1,
      isValid: function isValid(n) {
        return I()(_.a.allCountries, function (e) {
          return i()(n, e.dialCode) || i()(e.dialCode, n);
        });
      },
      disableCountryCode: !1,
      disableDropdown: !1,
      enableLongNumbers: !1,
      countryCodeEditable: !0,
      regions: "",
      localization: {},
      onEnterKeyPress: function onEnterKeyPress() {},
      onChange: function onChange() {},
      isModernBrowser: function isModernBrowser() {
        return !!document.createElement && Boolean(document.createElement("input").setSelectionRange);
      },
      keys: {
        UP: 38,
        DOWN: 40,
        RIGHT: 39,
        LEFT: 37,
        ENTER: 13,
        ESC: 27,
        PLUS: 43,
        A: 65,
        Z: 90,
        SPACE: 32
      }
    }, kn.displayName = "MuiPhoneNumber";
    var wn = Z()(function () {
      return {
        flagButton: {
          minWidth: 30,
          padding: 0,
          height: 30
        },
        "native": {
          width: 30,
          height: 30,
          padding: 8
        },
        nativeRoot: {
          padding: 0,
          "& + svg": {
            display: "none"
          }
        },
        nativeSelect: {
          padding: 0,
          lineHeight: 0,
          height: 11
        },
        positionStart: {
          position: "relative"
        }
      };
    })(kn);
    e["default"] = wn;
  }]);
});
var MuiPhoneNumber$1$1$1 = unwrapExports$1$1$1(dist$1$1$1);
var IRPF$1$1$1$1 = "IRPF";
var IVA$1$1$1$1 = "IVA";
var NIF$1$1$1$1 = "NIF";
var betweenMinAndMaxKilometers$1$1$1$1 = "Entre {{min}} y {{max}} kilómetros";
var metricUnits$1$1$1$1 = {
  u: "km",
  up: "kms",
  U: "Km",
  Up: "Kms",
  unit: "kilómetro",
  units: "kilómetros",
  Unit: "Kilómetro",
  Units: "Kilómetros",
  unitSpecialCase1: "Kms",
  unitSpecialCase2: "KM",
  ad: "el",
  adp: "los",
  uFranquise: "km franquicia",
  UpFranquise: "Kms franquicia",
  maxUnits: "Kilómetros max.",
  betweenMinAndMaxunits: "Entre {{min}} y {{max}} kilómetros",
  km: "km",
  kms: "kms",
  kilometer: "Kilómetro",
  maxKilometers: "Kilómetros max.",
  "rates-concepts": {
    km: "Tarifa por km"
  },
  searchTools: "nothing"
};
var imperialUnits$1$1$1$1 = {
  u: "mi",
  up: "mi",
  U: "Mi",
  Up: "Mi",
  unit: "milla",
  units: "millas",
  Unit: "Milla",
  Units: "Millas",
  unitSpecialCase1: "Millas",
  unitSpecialCase2: "MILLA",
  ad: "la",
  adp: "las",
  uFranquise: "mi franquicia",
  UpFranquise: "Mi franquicia",
  maxUnits: "Millas max.",
  betweenMinAndMaxunits: "Entre {{min}} y {{max}} millas",
  "rates-concepts": {
    km: "Tarifa por milla"
  },
  searchTools: "nothing",
  providerEditRateHeaderText: "Completa la información de las millas de la franquicia, las geocercas y las tarifas por medio, de cada depósito."
};
var A$2$1$1$1 = "A";
var accept$1$1$1$1 = "Aceptar";
var accepted$1$1$1$1 = "Aceptado";
var acceptUpdate$1$1$1$1 = "Aceptar actualización";
var accessToTheViews$1$1$1$1 = "Acceso a las vistas";
var accessWithMicrosoft$1$1$1$1 = "Acceder con Microsoft";
var activateGuardMode$1$1$1$1 = "Activar modo guardia";
var activateGuardModeWarningText$1$1$1$1 = "¿Seguro que deseas activar el modo guardia?";
var activateGuardModeWarningAditionalText$1$1$1$1 = "Al hacerlo, pasarás a operar como un proveedor automático y las compañías enviarán los servicios directamente a los recursos.";
var active$1$1$1$1 = "Activo";
var activity$1$1$1$1 = "Actividad";
var accumulateNightAndHolidaySurcharge$1$1$1$1 = "Acumular recargo nocturno y festivo";
var add$1$1$1$1 = "Añadir";
var addAuxService$1$1$1$1 = "Añadir servicio auxiliar";
var addCapability$1$1$1$1 = "Añadir prestación";
var addCollective$1$1$1$1 = "Añadir colectivo";
var addCost$1$1$1$1 = "Añadir costo";
var addCostType$1$1$1$1 = "Añadir tipo de costo";
var addedCollective$1$1$1$1 = "Colectivo añadido";
var addFault$1$1$1$1 = "Añadir avería";
var addedFault$1$1$1$1 = "Avería añadida";
var additionalInformation$1$1$1$1 = "Información adicional";
var additionalPrice$1$1$1$1 = "Precio adicionales";
var additionalPriceAbbrev$1$1$1$1 = "Precio resto";
var addNote$1$1$1$1 = "Añadir nota";
var address$1$1$1$1 = "Dirección";
var addressNotLocated$1$1$1$1 = "Dirección no localizada";
var addUserProfile$1$1$1$1 = "Añadir perfil de usuario";
var admin$1$1$1$1 = "Administrador";
var advancedConfiguration$1$1$1$1 = "Configuración avanzada";
var aheadServices$1$1$1$1 = "Servicios por delante";
var alert$1$1$1$1 = "Alerta";
var alerts$1$1$1$1 = "Alertas";
var alertStart$1$1$1$1 = "Inicio alerta";
var all_f$1$1$1$1 = "Todas";
var all_m$1$1$1$1 = "Todos";
var allowAccess$1$1$1$1 = "Permitir acceso";
var allowCalls$1$1$1$1 = "Permite llamadas";
var allowCalls_addService$1$1$1$1 = "Permitir llamadas";
var allowGuardErrorTitle$1$1$1$1 = "No se puede activar el Modo guardia";
var allowGuardErrorText$1$1$1$1 = "No se puede si hay servicios pendientes de aceptación o asignación.";
var allowSMS$1$1$1$1 = "Permite SMS";
var allProvidersAutomatic$1$1$1$1 = "Todos los proveedores (Automático)";
var anErrorHasOccurred$1$1$1$1 = "Ha ocurrido un error";
var applyCosts$1$1$1$1 = "Aplicar gastos";
var approve$1$1$1$1 = "Aprobar";
var assign$1$1$1$1 = "Asignar";
var assignTechnician$1$1$1$1 = "Asignar técnico";
var assistance$1$1$1$1 = "Asistencia";
var assistanceWithoutTransfer$1$1$1$1 = "Asistencia sin traslado";
var assistanceWithoutTransferWarning$1$1$1$1 = "No has seleccionado ningún traslado.";
var assistanceWithoutTransferWarningQuestion$1$1$1$1 = "¿Deseas continuar con el servicio de asistencia, sin traslado a personas?";
var assisted$1$1$1$1 = "Asistido";
var assistedInsuredAbbrev$1$1$1$1 = "Asistido/Aseg.";
var assistedDestinationAddress$1$1$1$1 = "Dirección de destino del asistido";
var associatedDocuments$1$1$1$1 = "Documentos asociados";
var at_time$1$1$1$1 = "a las {{time}} h";
var assigned$1$1$1$1 = "Agendado";
var ASSIGNED$1$1$1$1 = "Agendado";
var attachADocument$1$1$1$1 = "Adjuntar un documento";
var attachment$1$1$1$1 = "Adjuntar";
var attachments$1$1$1$1 = "Adjuntos";
var auction$1$1$1$1 = "Subastar";
var auctionConfiguration$1$1$1$1 = "Configuración subastas";
var auctioned$1$1$1$1 = "En subasta";
var AUCTIONED$1$1$1$1 = "En subasta";
var auctioning$1$1$1$1 = "En subasta";
var AUCTIONING$1$1$1$1 = "En subasta";
var auctionInPriority$1$1$1$1 = "En subasta";
var auctionInPriority1$1$1$1$1 = "Subasta en prioridad 1";
var auctionInPriority2$1$1$1$1 = "Subasta en prioridad 2";
var auctionInPriority3$1$1$1$1 = "Subasta en prioridad 3";
var auctionInPriority4$1$1$1$1 = "Subasta en prioridad Global";
var auctions$1$1$1$1 = "Subastas";
var auctionService$1$1$1$1 = "Subastar servicio";
var auto$1$1$1$1 = "Vehículo";
var automatic$1$1$1$1 = "Automático";
var automaticProvider$1$1$1$1 = "Proveedor automático";
var auxiliary$1$1$1$1 = "Auxiliar";
var auxiliarySettings$1$1$1$1 = "Ajustes de auxiliares";
var auxiliaries$1$1$1$1 = "Auxiliares";
var auxiliariesRates$1$1$1$1 = "Tarifas auxiliares";
var auxServiceList$1$1$1$1 = {
  auxServiceWithCount: "{{count}} Servicio auxiliar",
  auxServiceWithCount_plural: "{{count}} Servicios auxiliares"
};
var auxService$1$1$1$1 = "Servicio auxiliar";
var auxServices$1$1$1$1 = "Servicios auxiliares";
var available$1$1$1$1 = "Disponible";
var available_plural$1$1$1$1 = "Disponibles";
var availableProvidersAbbrev$1$1$1$1 = "Prov. disponibles";
var availableResources$1$1$1$1 = "Recursos disponibles";
var availableResourcesWithCount$1$1$1$1 = "{{count}} Recurso disponible";
var availableResourcesWithCount_plural$1$1$1$1 = "{{count}} Recursos disponibles";
var average$1$1$1$1 = "Tipo medio";
var averageRating$1$1$1$1 = "Valoración media";
var B$1$1$1$1 = "B";
var base$1$1$1$1 = "Base";
var baseAmount$1$1$1$1 = "Importe base";
var billed$1$1$1$1 = "Facturada";
var billing$1$1$1$1 = "Facturación";
var brand$1$1$1$1 = "Marca";
var browse$1$1$1$1 = "Examinar";
var budgetWarningNoBaseFound$1$1$1$1 = "Este proveedor no tiene configurada una base. Se ha utilizado la ubicación del recurso para calcular la tarifa.";
var businessIntelligence$1$1$1$1 = "Business Intelligence";
var byAmount$1$1$1$1 = "Por precio";
var byBrand$1$1$1$1 = "Por marca";
var byPositionOnQueue$1$1$1$1 = "Por posición en espera";
var byScore$1$1$1$1 = "por puntuación";
var byTime$1$1$1$1 = "Por tiempo";
var C$1$1$1$1 = "C";
var calculateAllServicesAsSuburban$1$1$1$1 = "Calcular todos los servicios como carreteros";
var calendar$1$1$1$1 = {
  today: "Hoy",
  yesterday: "Ayer",
  thisWeek: "Esta semana",
  last7Days: "Últimos 7 días",
  pastWeek: "Semana pasada",
  thisMonth: "Este mes",
  last30Days: "Últimos 30 días",
  pastMonth: "Mes pasado",
  thisYear: "Este año",
  lastYear: "Último año"
};
var cancel$1$1$1$1 = "Cancelar";
var cancel_2$1$1$1$1 = "Anular";
var outputCancellationPercentageAbbrev$1$1$1$1 = "% Salida anulado";
var cancelAmount$1$1$1$1 = "Importe anulación";
var cancelRatePercentage$1$1$1$1 = "% Salida anulación";
var cancelRateAmount$1$1$1$1 = "Importe anulación";
var cancelReason$1$1$1$1 = "Motivo de anulación";
var cancelService$1$1$1$1 = "Anular servicio";
var cancelTransferPeople$1$1$1$1 = "Anular traslado";
var cancelTransferPeopleWarning$1$1$1$1 = "En función del estado de ejecución, anular el traslado podría conllevar gastos. ¿Desea continuar?";
var capabilityList$1$1$1$1 = {
  capabilityWithCount: "{{count}} Prestación",
  capabilityWithCount_plural: "{{count}} Prestaciones"
};
var capability$1$1$1$1 = "Prestación";
var capabilityCollectiveAbbrev$1$1$1$1 = "Prestación/Colec.";
var capabilities$1$1$1$1 = "Prestaciones";
var center$1$1$1$1 = "Centro";
var centerName$1$1$1$1 = "Nombre del centro";
var centerNotFound$1$1$1$1 = "No se ha encontrado el centro";
var change$1$1$1$1 = "Cambiar";
var changePassword$1$1$1$1 = "Cambiar contraseña";
var charge$1$1$1$1 = "Cargo";
var chargeWithCount$1$1$1$1 = "{{count}} Cargo";
var chargeWithCount_plural$1$1$1$1 = "{{count}} Cargos";
var check$1$1$1$1 = "Revisar";
var childProfile$1$1$1$1 = "Perfil hijo";
var chosenDriver$1$1$1$1 = "Conductor elegido";
var cif$1$1$1$1 = "CIF";
var city$1$1$1$1 = "Ciudad";
var clone$1$1$1$1 = "Clonar";
var cloneService$1$1$1$1 = "Clonar servicio";
var close$1$1$1$1 = "Cerrar";
var closeDispute$1$1$1$1 = "Cerrar disputa";
var code$1$1$1$1 = "Código";
var collectDate$1$1$1$1 = "Fecha de cobro";
var collected$1$1$1$1 = "Cobrada";
var collectInvoice$1$1$1$1 = "Cobrar factura";
var collective$1$1$1$1 = "Colectivo";
var collectives$1$1$1$1 = "Colectivos";
var collectiveWithCount$1$1$1$1 = "{{count}} Colectivo";
var collectiveWithCount_plural$1$1$1$1 = "{{count}} Colectivos";
var collectiveProviderAbbrev$1$1$1$1 = "Colectivo/Prov.";
var comment$1$1$1$1 = "Comentario";
var commentAboutCapability$1$1$1$1 = "Comentario sobre prestación";
var companies$1$1$1$1 = "Compañías";
var company$1$1$1$1 = "Compañía";
var companyName$1$1$1$1 = "Nombre de la compañía";
var companyProfile$1$1$1$1 = "Perfil de compañía";
var completed$1$1$1$1 = "Completado";
var configuration$1$1$1$1 = "Configuración";
var consultList$1$1$1$1 = "Consultar lista";
var costName$1$1$1$1 = "Nombre del costo";
var costs$1$1$1$1 = "Costos";
var costSearch$1$1$1$1 = "Búsqueda de costo";
var costsWithCount$1$1$1$1 = "{{count}} Costo";
var costsWithCount_plural$1$1$1$1 = "{{count}} Costos";
var costSheets$1$1$1$1 = "Hojas de costos";
var costSheetStatus$1$1$1$1 = {
  PENDING: "P.imputación",
  IMPUTED: "P. aprobación",
  APPROVED: "Aprobado",
  REJECTED: "Rechazado"
};
var costType$1$1$1$1 = "Tipo de costo";
var costTypeName$1$1$1$1 = "Nombre del tipo de costo";
var costTypes$1$1$1$1 = "Tipos de costo";
var costTypesWithCount$1$1$1$1 = "{{count}} Tipo de costo";
var costTypesWithCount_plural$1$1$1$1 = "{{count}} Tipos de costo";
var craneService$1$1$1$1 = "Servicio de grúa";
var create$1$1$1$1 = "Crear";
var currentPassword$1$1$1$1 = "Contraseña actual";
var custodyDays$1$1$1$1 = "Días custodia";
var customer$1$1$1$1 = "Cliente";
var D$1$1$1$1 = "D";
var dashboard$1$1$1$1 = "Dashboard";
var date$1$1$1$1 = "Fecha";
var dateRangeExceeded$1$1$1$1 = "Excedido el rango de fechas";
var dayAndTime$1$1$1$1 = "Día y hora";
var deadLine$1$1$1$1 = "Fecha límite";
var concessionaire$1$1$1$1 = "Concesionaria";
var deferred$1$1$1$1 = "Programado";
var deferredService$1$1$1$1 = "Servicio programado";
var deferredShort$1$1$1$1 = "Programad";
var deferredShorter$1$1$1$1 = "Progra.";
var deleteCost$1$1$1$1 = "Eliminar costo";
var deletePath$1$1$1$1 = "Borrar trazado";
var deleteRequest$1$1$1$1 = "Eliminar solicitud";
var deposits$1$1$1$1 = "Depósitos";
var description$1$1$1$1 = "Descripción";
var detail$1$1$1$1 = "Detalle";
var disconnect$1$1$1$1 = "Desconectar";
var disputeReason$1$1$1$1 = "Motivo de la disputa";
var documentation$1$1$1$1 = "Documentación";
var documentationProfile$1$1$1$1 = "Perfil documentación";
var documentNumberAbbrev$1$1$1$1 = "Nº del documento";
var documentProfile$1$1$1$1 = "Perfil de documento";
var documentProfiles$1$1$1$1 = "Perfil de documentos";
var documentAdded$1$1$1$1 = "Documento añadido";
var documentType$1$1$1$1 = "Tipo de documento";
var documentTypes$1$1$1$1 = "Tipo de documentos";
var doNotAssociate$1$1$1$1 = "No asociar";
var dragData$1$1$1$1 = "Arrastrar datos";
var driver$1$1$1$1 = "Conductor";
var drivers$1$1$1$1 = "Conductores";
var duplicate$1$1$1$1 = "Duplicar";
var duplicateService$1$1$1$1 = "Duplicar servicio";
var E$1$1$1$1 = "E";
var edit$1$1$1$1 = "Editar";
var editAuxService$1$1$1$1 = "Editar servicio auxiliar";
var editCapability$1$1$1$1 = "Editar prestación";
var editCollective$1$1$1$1 = "Editar colectivo";
var editCost$1$1$1$1 = "Editar costo";
var editCostType$1$1$1$1 = "Editar tipo de costo";
var editFault$1$1$1$1 = "Editar avería";
var editSupportTeam$1$1$1$1 = "Editar equipo de soporte";
var editUserProfile$1$1$1$1 = "Editar perfil de usuario";
var email$1$1$1$1 = "Email";
var endService$1$1$1$1 = "Finalizar servicio";
var entry$1$1$1$1 = "Entrada";
var entryDateAbbrev$1$1$1$1 = "F. de entrada";
var error$1$1$1$1 = "Error";
var errorAddingDocument$1$1$1$1 = "Error al añadir documento";
var estimatedTime$1$1$1$1 = "Hora estimada";
var execution$1$1$1$1 = "Ejecución";
var executionProfile$1$1$1$1 = "Perfil de ejecución";
var expense$1$1$1$1 = "Gastos";
var expiredCode$1$1$1$1 = "Código caducado";
var expires$1$1$1$1 = "Caduca";
var events$1$1$1$1 = "Eventos";
var excessOfTimeForOutService$1$1$1$1 = "Exceso de tiempo para realizar servicio carretero";
var excessOfTimeForUrbanService$1$1$1$1 = "Exceso de tiempo para realizar servicio local";
var excessOfTimeInCurrentStatus$1$1$1$1 = "Exceso de tiempo en el estado actual";
var excessOfTimeToCompleteService$1$1$1$1 = "Exceso de tiempo para realizar el servicio";
var excessOfTimeToStartScheduledService$1$1$1$1 = "Exceso de tiempo para iniciar un servicio programado";
var F$1$1$1$1 = "F";
var fault$1$1$1$1 = "Avería";
var faults$1$1$1$1 = "Averías";
var faultCollectiveAbbrev$1$1$1$1 = "Avería/Colec.";
var faultWithCount$1$1$1$1 = "{{count}} Avería";
var faultWithCount_plural$1$1$1$1 = "{{count}} Averías";
var fee$1$1$1$1 = "Salida";
var fieldRequired$1$1$1$1 = "Requerido";
var file$1$1$1$1 = "Archivo";
var filterByDriverStatus$1$1$1$1 = "Filtrar por estado conductor";
var filterByVehicleType$1$1$1$1 = "Filtrar por tipo vehículo";
var financial$1$1$1$1 = "Financiero";
var financialBreakdown$1$1$1$1 = "Desglose financiero";
var finish$1$1$1$1 = "Finalizar";
var finishedServices$1$1$1$1 = "Servicios finalizados";
var firstPrice$1$1$1$1 = "Precio primera";
var firstUnitPriceAbbrev$1$1$1$1 = "Precio 1ª ud.";
var fixed$1$1$1$1 = "Fijo";
var formError$1$1$1$1 = "Error en formulario";
var franchise$1$1$1$1 = "Franquicia";
var franchises$1$1$1$1 = "Franquicias";
var freeCranesBefore1Hour$1$1$1$1 = "Grúas libres antes de 1h";
var fromUntil$1$1$1$1 = "Desde - Hasta";
var fullAddress$1$1$1$1 = "Dirección completa";
var fullScreenAbbrev$1$1$1$1 = "P. completa";
var G$1$1$1$1 = "G";
var generalInformationAbbrev$1$1$1$1 = "Inf. General";
var generate$1$1$1$1 = "Generar";
var generated$1$1$1$1 = "Generada";
var geofence$1$1$1$1 = "Geocerca";
var geofence_plural$1$1$1$1 = "Geocercas";
var geofenceWithCount$1$1$1$1 = "{{count}} Geocerca";
var geofenceWithCount_plural$1$1$1$1 = "{{count}} Geocercas";
var geoJson$1$1$1$1 = "GeoJson";
var globalAuction$1$1$1$1 = "Subasta global";
var graceDays$1$1$1$1 = "Días de gracia";
var grecaptchaNote$1$1$1$1 = "Sitio protegido por reCAPTCHA. Se aplica la <a href=\"https://policies.google.com/privacy\">Política de privacidad</a> y <a href=\"https://policies.google.com/terms\">Términos de servicio</a> de Google.";
var guardMode$1$1$1$1 = "Modo guardia";
var H$1$1$1$1 = "H";
var help$1$1$1$1 = "Ayuda";
var hide$1$1$1$1 = "Ocultar";
var holder$1$1$1$1 = "Titular";
var holidays$1$1$1$1 = "Festivos";
var home$1$1$1$1 = "Hogar";
var hour$1$1$1$1 = "Hora";
var hours$1$1$1$1 = "Horas";
var I$1$1$1$1 = "I";
var IBAN$1$1$1$1 = "IBAN";
var icon$1$1$1$1 = "Icono";
var iconUrl$1$1$1$1 = "URL del icono";
var identificationIcon$1$1$1$1 = "Icono identificativo";
var image$1$1$1$1 = "Imagen";
var immediate$1$1$1$1 = "Inmediato";
var immediate_plural$1$1$1$1 = "Inmediatos";
var immediateService$1$1$1$1 = "Servicio inmediato";
var incorrectLocationFormat$1$1$1$1 = "Localización en formato incorrecto";
var infoWindowIcon$1$1$1$1 = "Icono del InfoWindow";
var inParking$1$1$1$1 = "En parking";
var inRis$1$1$1$1 = "En reparación";
var inris$1$1$1$1 = "En reparación";
var inServiceResourcesWithCount$1$1$1$1 = "{{count}} Recurso en servicio";
var inServiceResourcesWithCount_plural$1$1$1$1 = "{{count}} Recursos en servicio";
var instant$1$1$1$1 = "Inmediato";
var insurancePolicyInfo$1$1$1$1 = "Información de la póliza";
var insured$1$1$1$1 = "Asegurado";
var insured_autoType$1$1$1$1 = "Vehículo";
var insured_homeType$1$1$1$1 = "Inmueble";
var insuredAutoType$1$1$1$1 = "Vehículo";
var insuredHomeType$1$1$1$1 = "Inmueble";
var insuredObjectAbbrev$1$1$1$1 = "Bien aseg.";
var insuredProperty$1$1$1$1 = "Bien asegurado";
var integrationProfile$1$1$1$1 = "Perfil de integración";
var integrationProfileAbbrev$1$1$1$1 = "Perfil integración";
var internalCode$1$1$1$1 = "Código interno";
var internalNote$1$1$1$1 = "Nota interna";
var internalNotes$1$1$1$1 = "Notas internas";
var interrupted$1$1$1$1 = "Interrumpida";
var intervention$1$1$1$1 = "Intervención";
var interventionAbbrev$1$1$1$1 = "Int.";
var interventions$1$1$1$1 = "Intervenciones";
var inUrbanArea$1$1$1$1 = "En zona local";
var invalidNexusFilecase$1$1$1$1 = "Expediente de Nexus no válido";
var invalidText$1$1$1$1 = "Texto no válido";
var invoice$1$1$1$1 = "Factura";
var invoiceNumberAbbrev$1$1$1$1 = "Nº de factura";
var forTheDay$1$1$1$1 = "Para el día";
var isNotValid$1$1$1$1 = "Es inválido";
var issuedInvoices$1$1$1$1 = "Facturas emitidas";
var itAlreadyExists$1$1$1$1 = "Ya existe";
var J$1$1$1$1 = "J";
var K$1$1$1$1 = "K";
var L$1$1$1$1 = "L";
var label$1$1$1$1 = "Rotulación";
var labeled$1$1$1$1 = "Rotulaciones";
var labels$1$1$1$1 = "Rotulaciones";
var lastActivity$1$1$1$1 = "Ult. actividad";
var lastActivity2$1$1$1$1 = "Última actividad";
var legal$1$1$1$1 = "Legal";
var legalId$1$1$1$1 = "NIF/CIF";
var list$1$1$1$1 = "Listado";
var listEntryMax24H$1$1$1$1 = "Entrada en lista (max. 24h)";
var loaded$1$1$1$1 = "Cargado";
var loadTimeInMinutes$1$1$1$1 = "Tiempo de carga (min)";
var located$1$1$1$1 = "Localizado";
var location$1$1$1$1 = "Ubicación";
var locked$1$1$1$1 = "Bloqueado";
var lockedByNexus$1$1$1$1 = "Bloqueado";
var login$1$1$1$1 = "Iniciar sesión";
var logo$1$1$1$1 = "Logotipo";
var logout$1$1$1$1 = "Cerrar sesión";
var M$1$1$1$1 = "M";
var managed$1$1$1$1 = "Gestionado";
var managedProvider$1$1$1$1 = "Proveedor gestionado";
var manual$1$1$1$1 = "Manual";
var manualProvider$1$1$1$1 = "Proveedor manual";
var map$1$1$1$1 = "Mapa";
var mapIcon$1$1$1$1 = "Icono del mapa";
var mapOfGoingServices$1$1$1$1 = "Mapa de servicios en curso";
var mapOfResources$1$1$1$1 = "Mapa de recursos";
var mapOfTracking$1$1$1$1 = "Mapa de seguimiento";
var mapView$1$1$1$1 = "Vista mapa";
var max$1$1$1$1 = "Max.";
var maxAllowedTimeInMinutes$1$1$1$1 = "Tiempo máx. permitido: {{minutes}} min";
var maxDistance$1$1$1$1 = "Distancia máxima";
var maxDistanceToCrane$1$1$1$1 = "Distancia de la grúa";
var maxHours$1$1$1$1 = "Horas máximo";
var maxRadius$1$1$1$1 = "Radio máximo";
var maxTime$1$1$1$1 = "Tiempo máximo";
var maxTimeOnList$1$1$1$1 = "Permanencia en lista";
var medium$1$1$1$1 = "Medio";
var mediumNotFound$1$1$1$1 = "No se ha encontrado el medio";
var mediumType$1$1$1$1 = "Tipo de medio";
var mediumTypes$1$1$1$1 = "Tipo de medios";
var mediumTypes2$1$1$1$1 = "Tipos de medio";
var minute$1$1$1$1 = "Minuto";
var minutes$1$1$1$1 = "Minutos";
var modeAndName$1$1$1$1 = "Modo y nombre";
var model$1$1$1$1 = "Modelo";
var modifiedCollective$1$1$1$1 = "Colectivo modificado";
var modifiedFault$1$1$1$1 = "Avería modificada";
var myTickets$1$1$1$1 = "Mis tickets";
var N$1$1$1$1 = "N";
var name$1$1$1$1 = "Nombre";
var nameSurname$1$1$1$1 = "Nombre y apellidos";
var new_female$1$1$1$1 = "Nueva";
var new_plural$1$1$1$1 = "Nuevos";
var newAuxService$1$1$1$1 = "Nuevo servicio";
var newAuxiliaryService$1$1$1$1 = "Nuevo servicio auxiliar";
var newDayAndTime$1$1$1$1 = "Nuevo día y hora";
var newPassword$1$1$1$1 = "Nueva contraseña";
var newService$1$1$1$1 = "Nuevo servicio";
var newSupportTeam$1$1$1$1 = "Nuevo equipo de soporte";
var newVehicleAssistance$1$1$1$1 = "Nueva asistencia de vehículos";
var newVialService$1$1$1$1 = "Nuevo servicio vial";
var nexusMapServiceError$1$1$1$1 = "Error en el servicio de mapas de Nexus";
var nick$1$1$1$1 = "Nick";
var no$1$1$1$1 = "No";
var noProvidersAvailable$1$1$1$1 = "No hay proveedores disponibles";
var notApplyCosts$1$1$1$1 = "No aplicar gastos";
var notParticipating$1$1$1$1 = "No participa";
var noCovered$1$1$1$1 = "No cubierto";
var noDocumentsAssociatedToService$1$1$1$1 = "No hay documentos asociados";
var noResourcesAvailableMsg$1$1$1$1 = "No hay recursos disponibles, pero puedes enviar el servicio a una lista de espera para que Nexus lo gestione.";
var noSubscribe$1$1$1$1 = "No suscribirme";
var note$1$1$1$1 = "Nota";
var notes$1$1$1$1 = "Notas";
var notesAssociatedWithTheService$1$1$1$1 = "Notas asociadas al servicio";
var noTicketsAssociatedToService$1$1$1$1 = "No hay tickets asociados al servicio";
var noTicketsAssociatedToTransfer$1$1$1$1 = "No hay tickets asociados al traslado";
var noNotesAssociatedToService$1$1$1$1 = "No hay notas asociadas al servicio";
var notifications$1$1$1$1 = "Notificaciones";
var noTransfersAvailable$1$1$1$1 = "No hay traslados disponibles";
var noValid$1$1$1$1 = "No válido";
var numberAbbrev$1$1$1$1 = "Nº";
var numberOfPeopleAbbrev$1$1$1$1 = "Nº de personas";
var numberOfReviewsAbbrev$1$1$1$1 = "Nº Reseñas";
var O$1$1$1$1 = "O";
var office$1$1$1$1 = "Oficina";
var ongoing$1$1$1$1 = "En curso";
var onQueue$1$1$1$1 = "En espera";
var openDispute$1$1$1$1 = "Abrir disputa";
var operational$1$1$1$1 = "Operativos";
var operationTypes$1$1$1$1 = "Tipo de intervención";
var origin$1$1$1$1 = "Origen";
var originalServiceData$1$1$1$1 = "Datos del servicio original";
var originDeposit$1$1$1$1 = "Origen depósito";
var otherSettings$1$1$1$1 = "Otros ajustes";
var orYouCan$1$1$1$1 = "O puedes";
var outlay$1$1$1$1 = "Suplidos";
var outlays$1$1$1$1 = "Gastos adicionales";
var P$1$1$1$1 = "P";
var paid$1$1$1$1 = "Pagada";
var passengers$1$1$1$1 = "Pasajeros";
var passengersWithCount$1$1$1$1 = "{{count}} Pasajero";
var passengersWithCount_plural$1$1$1$1 = "{{count}} Pasajeros";
var password$1$1$1$1 = "Contraseña";
var passwordsNotMatch$1$1$1$1 = "Las contraseñas no coinciden";
var paymentsToProviders$1$1$1$1 = "Pagos a proveedores";
var pdf$1$1$1$1 = "Pdf";
var pending$1$1$1$1 = "Pendiente";
var pendings$1$1$1$1 = "Pendientes";
var PENDING$1$1$1$1 = "Pendiente";
var pending_assign$1$1$1$1 = "Pendiente asignación";
var PENDING_ASSIGN$1$1$1$1 = "Pendiente asignación";
var PENDINGASSIGN$1$1$1$1 = "Pendiente asignación";
var pendingDocumentation$1$1$1$1 = "Documentación pendiente";
var pendingDocuments$1$1$1$1 = "Documentos pendientes";
var pendingPassword$1$1$1$1 = "Pendiente registro";
var pendingProfile$1$1$1$1 = "Pendiente perfil";
var peopleTransferActivity$1$1$1$1 = "Traslados";
var pleaseTryAgainLater$1$1$1$1 = "Por favor inténtalo de nuevo mas tarde";
var phone$1$1$1$1 = "Teléfono";
var phoneNumberAbbrev$1$1$1$1 = "Nº de teléfono";
var photoWithCount$1$1$1$1 = "{{count}} foto";
var photoWithCount_plural$1$1$1$1 = "{{count}} fotos";
var photos$1$1$1$1 = "Fotos";
var planned$1$1$1$1 = "Planificado";
var PLANNED$1$1$1$1 = "Planificado";
var plannedService$1$1$1$1 = "Servicio planificado";
var plate$1$1$1$1 = "Matrícula";
var plateDoesNotCorrespondToTheFilecase$1$1$1$1 = "Matrícula no corresponde al expediente";
var policy$1$1$1$1 = "Póliza";
var policyCoverageLimit$1$1$1$1 = "Excedida la cobertura de la póliza";
var policyCoverageLimit2$1$1$1$1 = "Posible exceso de la cobertura de la póliza";
var policyInformation$1$1$1$1 = "Información de póliza";
var policyLimitExceeded$1$1$1$1 = {
  number1: "Se ha solicitado 1 servicio, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al proveedor.",
  number2: "Se han solicitado {{previousServices}} servicios, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al proveedor.",
  number3: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza es 1. El asistido deberá abonar el coste total del servicio al proveedor.",
  number4: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza son {{policyServicesLimit}}. El asistido deberá abonar el coste total del servicio al proveedor.",
  amount1: "El importe del servicio es de {{serviceTotalAmount}}, y el importe máximo que incluye la póliza es {{policyAmountLimit}}. El asistido deberá abonar la diferencia de {{amountDifference}} al proveedor.",
  amount2: "El importe del servicio es de {{serviceTotalAmount}}, y quedan {{availableAmount}} del importe máximo que incluye la póliza. El asistido deberá abonar la diferencia de {{amountDifference}} al proveedor.",
  amount3: "El importe del servicio es de {{serviceTotalAmount}}, y ya se ha gastado el importe máximo que incluye la póliza. El asistido deberá abonar la totalidad del servicio al proveedor.",
  amount4: "El importe de alguno de los recursos seleccionados supera el límite de la póliza de {{policyAmountLimit}}. El asistido deberá abonar la diferencia al proveedor en el caso de que estos recursos acepten el servicio.",
  amount5: "El importe de alguno de los recursos seleccionados supera el límite de la póliza de {{policyAmountLimit}}, y quedan {{availableAmount}} del importe máximo de cobertura. El asistido deberá abonar la diferencia al proveedor en el caso de que estos recursos acepten el servicio.",
  amount6: "El importe de todos los recursos seleccionados supera el límite de la póliza de {{policyAmountLimit}}, y ya se ha gastado el importe máximo de cobertura. El asistido deberá abonar la totalidad del servicio al proveedor en el caso de que estos recursos acepten el servicio.",
  amount4b: "El importe del recurso seleccionado supera el límite de la póliza de {{policyAmountLimit}}. El asistido deberá abonar la diferencia al proveedor en el caso de que este recurso acepte el servicio.",
  amount5b: "El importe del recurso seleccionado supera el límite de la póliza de {{policyAmountLimit}}, y quedan {{availableAmount}} del importe máximo de cobertura. El asistido deberá abonar la diferencia al proveedor en el caso de que este recurso acepte el servicio.",
  amount6b: "El importe del recurso seleccionado supera el límite de la póliza de {{policyAmountLimit}}, y ya se ha gastado el importe máximo de cobertura. El asistido deberá abonar la totalidad del servicio al proveedor en el caso de que este recurso acepte el servicio.",
  amount7: "El importe estimado del servicio es de {{serviceTotalAmount}}, y el importe máximo que incluye la póliza es {{policyAmountLimit}}. El asistido deberá abonar la diferencia aproximada de {{amountDifference}} al proveedor.",
  amount8: "El importe estimado del servicio es de {{serviceTotalAmount}}, y quedan {{availableAmount}} del importe máximo que incluye la póliza. El asistido deberá abonar la diferencia aproximada de {{amountDifference}} al proveedor.",
  amount9: "El importe estimado del servicio es de {{serviceTotalAmount}}, y ya se ha gastado el importe máximo que incluye la póliza. El asistido deberá abonar la totalidad del servicio al proveedor."
};
var policyLimitExceededAux$1$1$1$1 = {
  number1: "Se ha solicitado 1 servicio, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al técnico.",
  number2: "Se han solicitado {{previousServices}} servicios, que es la cantidad máxima que incluye la póliza. El asistido deberá abonar el coste total del servicio al técnico.",
  number3: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza es 1. El asistido deberá abonar el coste total del servicio al técnico.",
  number4: "Se han solicitado {{previousServices}} servicios, y la cantidad máxima que incluye la póliza son {{policyServicesLimit}}. El asistido deberá abonar el coste total del servicio al técnico.",
  amount1: "El importe del servicio es de {{serviceTotalAmount}}, y el importe máximo que incluye la póliza es {{policyAmountLimit}}. El asistido deberá abonar la diferencia de {{amountDifference}} al técnico.",
  amount2: "El importe del servicio supera el límite de la póliza de {{serviceTotalAmount}}, y quedan {{availableAmount}} del importe máximo de cobertura. El asistido deberá abonar la diferencia de {{amountDifference}} al técnico.",
  amount3: "El importe del servicio supera el límite de la póliza de {{serviceTotalAmount}}, y ya se ha gastado el importe máximo de cobertura. El asistido deberá abonar la totalidad del servicio al técnico."
};
var policyNumberAbbrev$1$1$1$1 = "Nº de póliza";
var policySearch$1$1$1$1 = "Búsqueda de póliza";
var positionAbbrev$1$1$1$1 = "P.";
var priority$1$1$1$1 = "Prioritario";
var priority1Providers$1$1$1$1 = "Proveedores de prioridad 1";
var priority2Providers$1$1$1$1 = "Proveedores de prioridad 2";
var priority3Providers$1$1$1$1 = "Proveedores de prioridad 3";
var priorityAllProviders$1$1$1$1 = "Todos los proveedores";
var priorityProvider$1$1$1$1 = "Proveedor prioritario";
var process$1$1$1$1$1 = "Procesar";
var profile$1$1$1$1 = "Perfil";
var profileNotFound$1$1$1$1 = "No se ha encontrado el perfil";
var profiles$1$1$1$1 = "Perfiles";
var proposals$1$1$1$1 = "Propuestas";
var provider$1$1$1$1 = "Proveedor";
var providersInZone$1$1$1$1 = "Proveedores en la zona";
var providersOutZone$1$1$1$1 = "Resto de proveedores";
var providerTechnician$1$1$1$1 = "Proveedor / técnico";
var providerVialSettings$1$1$1$1 = "Ajustes de viales de {{providerName}}";
var providerEditVialSettingsHeaderText$1$1$1$1 = "Completa la información necesaria correspondiente a los servicios viales.";
var providerAuxiliariesSettings$1$1$1$1 = "Ajustes de auxiliares de {{providerName}}";
var providerEditAuxiliariesSettingsHeaderText$1$1$1$1 = "Completa la información necesaria correspondiente a los servicios auxiliares.";
var providers$1$1$1$1 = "Proveedores";
var provider_pending$1$1$1$1 = "Pendiente proveedor";
var PROVIDER_PENDING$1$1$1$1 = "Pendiente proveedor";
var PROVIDERPENDING$1$1$1$1 = "Pendiente proveedor";
var provider_accepted$1$1$1$1 = "Aceptado proveedor";
var PROVIDER_ACCEPTED$1$1$1$1 = "Aceptado proveedor";
var PROVIDERACCEPTED$1$1$1$1 = "Aceptado proveedor";
var provider_accept$1$1$1$1 = "Aceptado proveedor";
var PROVIDER_ACCEPT$1$1$1$1 = "Aceptado proveedor";
var PROVIDERACCEPT$1$1$1$1 = "Aceptado proveedor";
var providersSelection$1$1$1$1 = "Selección de proveedores";
var providerList$1$1$1$1 = {
  providerWithCount: "{{count}} Proveedor",
  providerWithCount_plural: "{{count}} Proveedores"
};
var providersMap$1$1$1$1 = "Mapa de proveedores";
var providerType$1$1$1$1 = "Tipo de proveedor";
var providerTypeVial$1$1$1$1 = "Tipo de vial";
var providerTypeAux$1$1$1$1 = "Tipo de auxiliar";
var providerWithoutDefinedDeposit$1$1$1$1 = "Proveedor sin depósito configurado";
var province$1$1$1$1 = "Provincia";
var Q$1$1$1$1 = "Q";
var queueEntryDate$1$1$1$1 = "Fecha de entrada en la lista";
var queued$1$1$1$1 = "En espera";
var QUEUED$1$1$1$1 = "En espera";
var queuedService$1$1$1$1 = "Servicio en espera";
var R$1$1$1$1 = "R";
var rates$1$1$1$1 = "Tarifas";
var rating$1$1$1$1 = "Valoración";
var ratings$1$1$1$1 = "Valoraciones";
var ratingsUserName$1$1$1$1 = "Valoraciones de {{userName}}";
var ratingsWithCount$1$1$1$1 = "{{count}} Valoración";
var ratingsWithCount_plural$1$1$1$1 = "{{count}} Valoraciones";
var ready$1$1$1$1 = "Disponible";
var reAssign$1$1$1$1 = "Reasignar";
var reAssignProvider$1$1$1$1 = "Reasignar proveedor";
var reAskForResetEmail$1$1$1$1 = "Vuelve a pedir email de restablecer";
var received$1$1$1$1 = "Recibido";
var receivedInvoices$1$1$1$1 = "Facturas recibidas";
var recoverRequest$1$1$1$1 = "Recuperar solicitud";
var recoverYourPassword$1$1$1$1 = "Recupera tu contraseña";
var region$1$1$1$1 = "Región";
var registrationInformationOnInvoices$1$1$1$1 = "Información registral en facturas";
var reject$1$1$1$1 = "Rechazar";
var rejectCosts$1$1$1$1 = "Rechazar costos";
var rejectionReason$1$1$1$1 = "Motivo de rechazo";
var rejectionReasons$1$1$1$1 = "Motivos de rechazo";
var rejectionType$1$1$1$1 = "Tipo de rechazo";
var release$1$1$1$1 = "Liberar";
var removeFromDashboard$1$1$1$1 = "Eliminar del Dashboard";
var repeated$1$1$1$1 = "Repetido";
var repeatPassword$1$1$1$1 = "Repetir contraseña";
var requestCapability$1$1$1$1 = "Prestación solicitada";
var requestInfo$1$1$1$1 = "Inf. solicitud";
var requestLocationByWhatsApp$1$1$1$1 = "Solicitar ubicación por WhatsApp";
var requestMediumAbbrev$1$1$1$1 = "M.Solicitado";
var requestProcessedCorrectly$1$1$1$1 = "Solicitud procesada de forma correcta";
var requestWithoutIAssociatedPolicy$1$1$1$1 = "Solicitud sin póliza asociada";
var required$1$1$1$1 = "Obligatorio";
var reschedule$1$1$1$1 = "Reprogramar";
var RESCHEDULED$1$1$1$1 = "Reprogramado";
var rescheduleComment$1$1$1$1 = "Comentario de la reprogramación";
var rescheduleReason$1$1$1$1 = "Motivo de reprogramación";
var rescheduleService$1$1$1$1 = "Reprogramar servicio";
var rescheduleServiceDeferredTextModal$1$1$1$1 = "Introduce un nuevo día y hora para cambiar la programación del servicio actual";
var rescheduleServicePlannedText1Modal$1$1$1$1 = "Los servicios planificados tienen un recurso asignado. Al cambiar la fecha y hora, el servicio volverá al estado programado, y estará pendiente de planificación";
var rescheduleServicePlannedText2Modal$1$1$1$1 = "Introduce la nueva fecha del servicio programado";
var resetPassword$1$1$1$1 = "Contraseña restablecida";
var resetYourPassword$1$1$1$1 = "Restablece tu contraseña";
var resources$1$1$1$1 = "Recursos";
var resourcesMap$1$1$1$1 = "Mapa de recursos";
var restore$1$1$1$1 = "Restablecer";
var result$1$1$1$1 = "Resultado";
var ris$1$1$1$1 = "RIS";
var risService$1$1$1$1 = "Servicio de RIS";
var S$1$1$1$1 = "S";
var save$1$1$1$1 = "Guardar";
var saveChanges$1$1$1$1 = "Guardar cambios";
var savedRequests$1$1$1$1 = "Solicitudes guardadas";
var saveRequest$1$1$1$1 = "Guardar solicitud";
var schedule$1$1$1$1 = "Agendar";
var scheduled$1$1$1$1 = "Programado";
var SCHEDULED$1$1$1$1 = "Programado";
var scheduled_plural$1$1$1$1 = "Programados";
var scheduledAbbrev$1$1$1$1 = "Program.";
var scheduledDateInvalidErrorText$1$1$1$1 = "La fecha y hora programada no es válida";
var scheduleDriver$1$1$1$1 = "Agendar conductor";
var scheduledServiceNotFound$1$1$1$1 = "El servicio programado no ha sido localizado";
var scheduledFor$1$1$1$1 = "Programado para";
var searchResourceOrTechnician$1$1$1$1 = "Busca recurso o técnico";
var searchResources$1$1$1$1 = "Busca recursos";
var searchAResource$1$1$1$1 = "Buscar un recurso";
var searchAService$1$1$1$1 = "Buscar un servicio";
var searchByAssistedOrFilecase$1$1$1$1 = "Asistido o Exp";
var searchByAssistedFilecaseOrPlate$1$1$1$1 = "Asistido, Aseg, Exp. o Matrícula";
var searchByAssistedFilecaseOrProvider$1$1$1$1 = "Asistido, Exp. o Proveedor";
var searchByCodeOrName$1$1$1$1 = "Busca por Código o Nombre";
var searchByCodeNameOrCostType$1$1$1$1 = "Busca por Código, Nombre o Tipo de costo";
var searchByCodeNameOrMediumType$1$1$1$1 = "Busca por Código, Nombre o Tipo de medio";
var searchByCustomer$1$1$1$1 = "Busca por Cliente";
var searchByCustomerOrFilecase$1$1$1$1 = "Cliente o Exp";
var searchByCustomerFilecaseOrPlate$1$1$1$1 = "Cliente, Exp. o Matrícula";
var searchByFileCase$1$1$1$1 = "Busca por Expediente";
var searchByIdForOrFilecaseNumber$1$1$1$1 = "Busca por ID, Para o Nº Expediente";
var searchByInvoiceNumber$1$1$1$1 = "Busca por Nº Factura";
var searchByName$1$1$1$1 = "Busca por Nombre";
var searchByNameCIFOrAddress$1$1$1$1 = "Busca por Nombre, CIF o Dirección";
var searchByNameOrAddress$1$1$1$1 = "Busca por Nombre o Dirección";
var searchByNameOrCode$1$1$1$1 = "Busca por Nombre o Código";
var searchByNamePlateOrCode$1$1$1$1 = "Busca por Nombre, Matrícula o Código";
var searchByNameSurnameUserOrNick$1$1$1$1 = "Busca por Nombre, Apellidos, Usuario o Nick";
var searchByProviderOrName$1$1$1$1 = "Busca por Proveedor o Nombre";
var searchByTerm$1$1$1$1 = "Busca por término";
var searchInsurancePolicy$1$1$1$1 = "Buscar póliza";
var seeAverages$1$1$1$1 = "Ver medias";
var breakdown$1$1$1$1 = "Desglose";
var seeCapabilityComment$1$1$1$1 = "Ver comentario de prestación";
var seeComment$1$1$1$1 = "Ver comentario";
var seeContactAndComment$1$1$1$1 = "Ver contacto y comentario";
var seeDescription$1$1$1$1 = "Ver descripción";
var seeService$1$1$1$1 = "Ver servicio";
var selfValidated$1$1$1$1 = "Autovalidado";
var send$1$1$1$1 = "Enviar";
var sendComments$1$1$1$1 = "Enviar comentarios";
var sended$1$1$1$1 = "Enviado";
var sendEmail$1$1$1$1 = "Enviar correo";
var sendForReview$1$1$1$1 = "Enviar a revisión";
var sendTo$1$1$1$1 = "Enviar a";
var sendToList$1$1$1$1 = "Enviar a la lista";
var serverConnectionError$1$1$1$1 = "¡Error de conexión con el servidor!";
var service$1$1$1$1 = "servicio";
var serviceExecution$1$1$1$1 = "Ejecución del servicio";
var serviceInAuction$1$1$1$1 = "Servicio en subasta";
var serviceLevels$1$1$1$1 = "Niveles de servicio";
var serviceMap$1$1$1$1 = "Mapa de viales";
var serviceNotFound$1$1$1$1 = "No se ha encontrado el servicio";
var serviceRequestAndTracking$1$1$1$1 = "Solicitud y seguimiento del servicio";
var services$1$1$1$1 = "Servicios";
var serviceSentToAuction$1$1$1$1 = "Servicio enviado a subasta";
var serviceStatus$1$1$1$1 = {
  auctioning: "En subasta",
  auctioningAvatar: "S",
  pending_assign: "Pendiente asignación",
  pendingAssign: "Pendiente asignación",
  pending_assignAvatar: "PA",
  provider_pending: "Pendiente proveedor",
  providerPending: "Pendiente proveedor",
  provider_pendingAvatar: "PP",
  provider_accepted: "Aceptado proveedor",
  providerAccepted: "Aceptado proveedor",
  providerAccept: "Aceptado proveedor",
  provider_acceptedAvatar: "AP",
  queued: "En espera",
  queuedAvatar: "E",
  scheduled: "Programado",
  scheduledAvatar: "PR",
  pending: "Pendiente",
  pendingAvatar: "PE",
  assigned: "Agendado",
  assignedAvatar: "AG",
  planned: "Planificado",
  plannedAvatar: "PL",
  accepted: "Aceptado",
  acceptedAvatar: "AC",
  started: "Iniciado",
  startedAvatar: "I",
  located: "Localizado",
  locatedAvatar: "L",
  inris: "En reparación",
  inrisAvatar: "RP",
  loaded: "Cargado",
  loadedAvatar: "CA",
  completed: "Completado",
  completedAvatar: "CO",
  finished: "Finalizado",
  finishedAvatar: "F",
  rejected: "Rechazado",
  rejectedAvatar: "RC",
  canceled: "Anulado",
  canceledAvatar: "AN"
};
var settings$1$1$1$1 = "Ajustes";
var settingsUpdated$1$1$1$1 = "Ajustes actualizados";
var sharedCode$1$1$1$1 = "Código compartido";
var sharedNote$1$1$1$1 = "Nota compartida";
var sharedNotes$1$1$1$1 = "Notas compartidas";
var shipments$1$1$1$1 = "Remesas";
var shipmentStatusValues$1$1$1$1 = {
  collecting: "Interrumpida",
  pending: "Generada",
  billed: "Facturada",
  collected: "Cobrada",
  payed: "Pagada"
};
var showAllMediums$1$1$1$1 = "Mostrar todos los medios";
var showSolicitedMedium$1$1$1$1 = "Mostrar medio solicitado";
var situation$1$1$1$1 = "Situación";
var solicitedMedium$1$1$1$1 = "Medio solicitado";
var sortCriteria$1$1$1$1 = "Criterio ordenación";
var soundActivated$1$1$1$1 = "Sonido activado";
var soundOff$1$1$1$1 = "Sonido desactivado";
var start$1$1$1$1 = "Inicio";
var started$1$1$1$1 = "Iniciado";
var status$1$1$1$1 = "Estado";
var statuses$1$1$1$1 = "Estados";
var subject$1$1$1$1 = "Asunto";
var subscribe$1$1$1$1 = "Suscribirme";
var subtotal$1$1$1$1 = "Subtotal";
var suburb$1$1$1$1 = "Carretero";
var suburbService$1$1$1$1 = "Servicio carretero";
var summary$1$1$1$1 = "Resumen";
var supportCenter$1$1$1$1 = "Centro de soporte";
var supportTeam$1$1$1$1 = "Equipo de soporte";
var survey$1$1$1$1 = "Encuesta";
var surveys$1$1$1$1 = "Encuestas";
var T$1$1$1$1 = "T";
var taxes$1$1$1$1 = "Impuestos";
var team$1$1$1$1 = "Equipo";
var teamName$1$1$1$1 = "Nombre del equipo";
var technician$1$1$1$1 = "Técnico";
var technicians$1$1$1$1 = "Técnicos";
var theField$1$1$1$1 = "El campo";
var ticket$1$1$1$1 = "Ticket";
var tickets$1$1$1$1 = "Tickets";
var ticketStatus$1$1$1$1 = {
  "new": "Nuevo",
  newAvatar: "N",
  open: "Abierto",
  openAvatar: "A",
  closed: "Cerrado",
  closedAvatar: "C"
};
var time$1$1$1$1 = "Tiempo";
var timeInAlert$1$1$1$1 = "Tiempo en alerta";
var timeline$1$1$1$1 = "Línea de tiempo";
var title$1$1$1$1 = "Título";
var toastErrorDuplicateAddressPickupDeliveryTitle$1$1$1$1 = "Error en las direcciones";
var toastErrorDuplicateAddressPickupDeliveryText$1$1$1$1 = "La dirección de recogida y entrega deben ser diferentes.";
var toastErrorDuplicateAddressPickupDestinationTitle$1$1$1$1 = "Error en las direcciones";
var toastErrorDuplicateAddressPickupDestinationText$1$1$1$1 = "La dirección de recogida y destino del asistido deben ser diferentes.";
var toastErrorTextDefault$1$1$1$1 = "No ha sido posible realizar la operación.";
var toastErrorTitleDefault$1$1$1$1 = "Error en la operación";
var toastErrorTransferPeopleBudget$1$1$1$1 = {
  expiredEstimate: {
    title: "Error",
    text: "La estimación de tarifa seleccionada ha expirado."
  },
  invalidEstimate: {
    title: "Error",
    text: ""
  },
  productNotFound: {
    title: "Error",
    text: "El recurso seleccionado no ha sido localizado."
  },
  cabifyIntegrationProblem: {
    title: "Error",
    text: "No se ha podido solicitar el traslado."
  },
  profileWithoutResources: {
    title: "Error",
    text: "Perfil sin recursos"
  }
};
var toastErrorTitle_downloadFile$1$1$1$1 = "Error";
var toastErrorText_downloadFile$1$1$1$1 = "No ha sido posible descargar el fichero.";
var toastSuccessTextDefault$1$1$1$1 = "La operación se ha realizado correctamente.";
var toastSuccessTitleDefault$1$1$1$1 = "Operación realizada con éxito";
var today$1$1$1$1 = "Hoy";
var toDefine$1$1$1$1 = "Por definir";
var total$1$1$1$1 = "Total";
var totals$1$1$1$1 = "Totales";
var toTheClient$1$1$1$1 = "Al cliente";
var toTheProvider$1$1$1$1 = "Al proveedor";
var town$1$1$1$1 = "Localidad";
var tracking$1$1$1$1 = "Seguimiento";
var trackingMessage$1$1$1$1 = "Mensaje de seguimiento";
var transfer$1$1$1$1 = "Traslado";
var transferHasBeenCancelled$1$1$1$1 = "El traslado ha sido anulado.";
var transferPeople$1$1$1$1 = "Traslado de personas";
var transferPeopleBudget$1$1$1$1 = "Propuesta de traslado";
var transferPeopleRequest$1$1$1$1 = "Solicitud de traslado";
var transferPeopleRequestType$1$1$1$1 = {
  immediate: "Servicio inmediato",
  deferred: "Servicio programado"
};
var transferPeopleRequiredValidPhoneNumber$1$1$1$1 = "Para los traslados es necesario facilitar un teléfono de contacto.";
var transfers$1$1$1$1 = "Traslados";
var transfersAvailable$1$1$1$1 = "Traslados disponibles";
var transferTheAssisted$1$1$1$1 = "Trasladar al asistido";
var type$1$1$1$1 = "Tipo";
var typeAndName$1$1$1$1 = "Tipo y nombre";
var typeless$1$1$1$1 = "Sin tipo";
var typeOfService$1$1$1$1 = "Tipo de servicio";
var types$1$1$1$1 = "Tipos";
var U$1$1$1$1 = "U";
var udWithCount$1$1$1$1 = "{{count}} ud.";
var udWithCount_plural$1$1$1$1 = "{{count}} uds.";
var unAssign$1$1$1$1 = "Liberar";
var unAssignTechnician$1$1$1$1 = "Liberar técnico";
var unAssignTechnicianModalText$1$1$1$1 = "¿Estás seguro que deseas liberar el técnico?";
var unAssignTechnicianModalAditionalText$1$1$1$1 = "Al hacerlo, el servicio pasará a estado Aceptado proveedor y podrás asignar un técnico nuevo.";
var unAssignDriver$1$1$1$1 = "Liberar conductor";
var unAssignDriverModalText$1$1$1$1 = "¿Estás seguro que deseas liberar el conductor?";
var unAssignDriverModalAditionalText$1$1$1$1 = "Al hacerlo, el servicio pasará a estado Aceptado proveedor y podrás asignar un conductor nuevo.";
var unavailable$1$1$1$1 = "No disponible";
var units$1$1$1$1 = "Unidades";
var unitAbbrev$1$1$1$1 = "ud.";
var unitsAbbrev$1$1$1$1 = "uds.";
var unselected$1$1$1$1 = "Sin selección";
var unsubscribe$1$1$1$1 = "Anular suscripción";
var urban$1$1$1$1 = "Local";
var urbanFee$1$1$1$1 = "Local";
var urbanService$1$1$1$1 = "Servicio local";
var user$1$1$1$1 = "Usuario";
var userProfiles$1$1$1$1 = "Perfiles de usuario";
var userProfilesWithCount$1$1$1$1 = "{{count}} Perfil de usuario";
var userProfilesWithCount_plural$1$1$1$1 = "{{count}} Perfiles de usuario";
var users$1$1$1$1 = "Usuarios";
var userType$1$1$1$1 = "Tipo de usuario";
var V$1$1$1$1 = "V";
var validFrom$1$1$1$1 = "Válido desde";
var validUntil$1$1$1$1 = "Válido hasta";
var variable$1$1$1$1 = "Variable";
var vehicleAssistance$1$1$1$1 = "Asistencia de vehículos";
var vehicleTypes$1$1$1$1 = "Tipo de vehículos";
var version$1$1$1$1 = "Versión";
var vial$1$1$1$1 = "Vial";
var vials$1$1$1$1 = "Viales";
var vialRates$1$1$1$1 = "Tarifas viales";
var vialServices$1$1$1$1 = "Servicios viales";
var vialSettings$1$1$1$1 = "Ajustes de viales";
var view$1$1$1$1 = "Vista";
var viewAssistedRating$1$1$1$1 = "Ver valoración del asistido";
var viewContact$1$1$1$1 = "Ver contacto";
var viewContactandComment$1$1$1$1 = "Ver contacto y comentario";
var viewRoute$1$1$1$1 = "Ver ruta";
var views$1$1$1$1 = "Vistas";
var vin$1$1$1$1 = "VIN";
var virtualSwitchboard$1$1$1$1 = "Centralita virtual";
var W$1$1$1$1 = "W";
var waitingList$1$1$1$1 = "Lista de espera";
var web$1$1$1$1 = "Web";
var webAddress$1$1$1$1 = "Dirección web";
var wholeWordSearch$1$1$1$1 = "Búsqueda de palabras completas";
var wholeWordSearch3Charts$1$1$1$1 = "Busca palabras completas (min 3 carac.)";
var withAlert$1$1$1$1 = "Con alerta";
var withholdings$1$1$1$1 = "Retenciones";
var withPriority1$1$1$1$1 = "Con prioridad 1";
var withPriority2$1$1$1$1 = "Con prioridad 2";
var withPriority3$1$1$1$1 = "Con prioridad 3";
var writeANote$1$1$1$1 = "Escribir una nota";
var wrongUser$1$1$1$1 = "Usuario incorrecto";
var wrongUsernameOrPassword$1$1$1$1 = "Usuario o contraseña incorrectos";
var X$1$1$1$1 = "X";
var Y$1$1$1$1 = "Y";
var year$1$1$1$1 = "Año";
var yes$1$1$1$1 = "Sí";
var yesterday$1$1$1$1 = "Ayer";
var youHaveExceededTheNumberOfAtempsts$1$1$1$1 = "Has excedido el número de intentos";
var Z$1$1$1$1 = "Z";
var maxMinutes$1$1$1$1 = "Minutos max.";
var maxPhotos$1$1$1$1 = "Fotos max.";
var between0And5Minutes$1$1$1$1 = "Entre 0 y 5 minutos";
var between0And10Minutes$1$1$1$1 = "Entre 0 y 10 minutos";
var between0And240Minutes$1$1$1$1 = "Entre 0 y 240 minutos";
var between1And7Minutes$1$1$1$1 = "Entre 1 y 7 minutos";
var between2And5Minutes$1$1$1$1 = "Entre 2 y 5 minutos";
var between2And10Minutes$1$1$1$1 = "Entre 2 y 10 minutos";
var between0And10Photos$1$1$1$1 = "Entre 0 y 10 fotos";
var between1And10Characters$1$1$1$1 = "Entre 1 y 10 caracteres";
var between0And120Minutes$1$1$1$1 = "Entre 0 y 120 minutos";
var ACCEPTED$1$1$1$1 = "Aceptado";
var add_company_description$1$1$1$1 = "Completa los datos de la compañía a dar de alta, indicando si se trata de un cliente o de un proveedor.";
var add_company$1$1$1$1 = "Añadir compañía";
var addChartText$1$1$1$1 = "Pulsa el botón de añadir para incorporar gráficos al Business Intelligence.";
var addChartTitle$1$1$1$1 = "Añadir gráfico";
var all_female$1$1$1$1 = "Todas";
var all_male$1$1$1$1 = "Todos";
var amount$1$1$1$1 = "Importe";
var apply$1$1$1$1 = "Aplicar";
var assignProvider$1$1$1$1 = "Asignar proveedor";
var assignedToMe$1$1$1$1 = "Asignados a mí";
var assignItToMe$1$1$1$1 = "Asignármelo";
var AVAILABLE$1$1$1$1 = "Disponible";
var blocked$1$1$1$1 = "Bloqueado";
var budgetToastSuccessText$1$1$1$1 = "El servicio se ha añadido al listado.";
var budgetToastSuccessTitle$1$1$1$1 = "Presupuesto aceptado";
var scheduledBudgetToastSuccessText$1$1$1$1 = "El servicio programado se ha añadido al listado.";
var scheduledBudgetToastSuccessTitle$1$1$1$1 = "Presupuesto aceptado";
var transferPeopleBudgetToastSuccessText$1$1$1$1 = "El traslado se ha añadido al listado.";
var transferPeopleBudgetToastSuccessTitle$1$1$1$1 = "Presupuesto aceptado";
var budgetToastSuccessQueueText$1$1$1$1 = "El servicio ha sido añadido a la lista de espera.";
var budgetToastSuccessQueueTitle$1$1$1$1 = "Operación realizada con éxito";
var bussy$1$1$1$1 = "ocupado";
var CANCELED$1$1$1$1 = "Anulado";
var centerNum$1$1$1$1 = "Nº Centros";
var centers$1$1$1$1 = "Centros";
var closed$1$1$1$1 = "Cerrado";
var codeAlreadyAssigned$1$1$1$1 = "Código ya asignado";
var color$1$1$1$1 = "Color";
var companyPendingDocumentation$1$1$1$1 = "Pendiente documentación compañía";
var companyProviderCode$1$1$1$1 = "Nuevo ID";
var COMPLETED$1$1$1$1 = "Completado";
var custodyRate$1$1$1$1 = "Precio día extra";
var damageReport$1$1$1$1 = "Parte de daños";
var damageRequired$1$1$1$1 = "Parte obligatorio";
var day$1$1$1$1 = "Día";
var days$1$1$1$1 = "Días";
var del$1$1$1$1 = "Eliminar";
var delivery$1$1$1$1 = "Entrega";
var deliveryAddressRequired$1$1$1$1 = "Dirección de entrega obligatoria";
var destination$1$1$1$1 = "Destino";
var documents$1$1$1$1 = "Documentos";
var exit$1$1$1$1 = "Salir";
var expired$1$1$1$1 = "Caducado";
var EXTRA_CHARGES$1$1$1$1 = "GASTOS EXTRA";
var extraCharges$1$1$1$1 = "Gastos";
var festive$1$1$1$1 = "Festivo";
var fieldsRequired$1$1$1$1 = "Los campos con (*) son obligatorios.";
var files$1$1$1$1 = "Archivos";
var filters$1$1$1$1 = "Filtros";
var FINISHED$1$1$1$1 = "Finalizado";
var free$1$1$1$1 = "libre";
var from$1$1$1$1 = "De";
var fromDate$1$1$1$1 = "Desde";
var generalInfo$1$1$1$1 = "Inf. General";
var groupName$1$1$1$1 = "Nombre de la compañía";
var id$1$1$1$1 = "Id";
var IN_SERVICE$1$1$1$1 = "En servicio";
var information$1$1$1$1 = "Información";
var INRIS$1$1$1$1 = "En reparación";
var integrated$1$1$1$1 = "Integrado";
var invite$1$1$1$1 = "Invitar";
var invoiceDate$1$1$1$1 = "Fecha fact.";
var lastAct$1$1$1$1 = "Última act.";
var left$1$1$1$1 = "Quedan";
var LOADED$1$1$1$1 = "Cargado";
var LOCATED$1$1$1$1 = "Localizado";
var locations$1$1$1$1 = "Localizaciones";
var mediums$1$1$1$1 = "Medios";
var MEDIUMS$1$1$1$1 = "MEDIOS";
var modify$1$1$1$1 = "Modificar";
var newRates$1$1$1$1 = "Nuevas tarifas";
var nexus$1$1$1$1 = "Nexus";
var nexusFee$1$1$1$1 = "Fee Nexus";
var nFilecase$1$1$1$1 = "Nº Expediente";
var nFilecaseAbbrev$1$1$1$1 = "Nº Exp.";
var nickName$1$1$1$1 = "Nick";
var nightlyEnd$1$1$1$1 = "Fin horario noct.";
var nightlyStart$1$1$1$1 = "Inicio horario noct.";
var nightly$1$1$1$1 = "Nocturno";
var nigthly$1$1$1$1 = "Nocturno";
var nightlyFestive$1$1$1$1 = "Festivo nocturno";
var nInvoice$1$1$1$1 = "Nº Factura";
var nInvoices$1$1$1$1 = "Nº Facturas";
var none$1$1$1$1 = "Ninguno";
var NOT_IN_NEXUS$1$1$1$1 = "Fuera de Nexus";
var not$1$1$1$1 = "No";
var nNexus$1$1$1$1 = "Nº Nexus";
var nPayments$1$1$1$1 = "Nº Pagos";
var nServices$1$1$1$1 = "Nº Servicios";
var numberOfInvoices$1$1$1$1 = "Número de facturas";
var of$1$1$1$1 = "de";
var open$1$1$1$1 = "Abierto";
var outOfService$1$1$1$1 = "fuera de servicio";
var ownFilecaseNumber$1$1$1$1 = "Nº expediente propio";
var ownFilecaseNumberAbbrev$1$1$1$1 = "Nº expediente";
var partialPrice$1$1$1$1 = "Precio parcial";
var participants$1$1$1$1 = "Participantes";
var participation$1$1$1$1 = "Participación";
var payed$1$1$1$1 = "Pagada";
var payments$1$1$1$1 = "Pagos";
var pendingAbbrev$1$1$1$1 = "Pdte.";
var photosNumber$1$1$1$1 = "Nº de fotos";
var pickup$1$1$1$1 = "Recogida";
var pickupAddress$1$1$1$1 = "Lugar recogida";
var pictures$1$1$1$1 = "Fotos";
var processDate$1$1$1$1 = "Fecha de procesamiento";
var processed$1$1$1$1 = "Procesado";
var providerAlreadyMapped$1$1$1$1 = "Proveedor ya mapeado";
var REJECTED$1$1$1$1 = "Rechazado";
var rejection$1$1$1$1 = "Rechazados";
var request$1$1$1$1 = "Solicitar";
var requester$1$1$1$1 = "Solicitante";
var resource$1$1$1$1 = "Recurso";
var resourceActivity$1$1$1$1 = "Recursos";
var resourceDistance$1$1$1$1 = "Está a";
var resourceRoute$1$1$1$1 = "Recorrido";
var resourceTime$1$1$1$1 = "Llega en";
var responsable$1$1$1$1 = "Responsable";
var responseNumberAbbrev$1$1$1$1 = "Nº respuestas";
var RISEND$1$1$1$1 = "Fin RIS";
var RISSTART$1$1$1$1 = "Inicio RIS";
var rowsPerPage$1$1$1$1 = "Filas por página";
var saveView$1$1$1$1 = "Guardar vista";
var sendSMSTracking$1$1$1$1 = "Enviar SMS seguimiento";
var sendSurvey$1$1$1$1 = "Enviar encuesta";
var serviceActivity$1$1$1$1 = "Servicios";
var serviceBudget$1$1$1$1 = "Propuesta de servicio";
var serviceRequest$1$1$1$1 = "Solicitud de servicio";
var serviceType$1$1$1$1 = "Tipo servicio";
var shared$1$1$1$1 = "Compartido";
var shipmentDate$1$1$1$1 = "Fecha remesa";
var sign$1$1$1$1 = "Firmas";
var sta$1$1$1$1 = "Es.";
var STARTED$1$1$1$1 = "Iniciado";
var supportTeamAbbrev$1$1$1$1 = "Equipo Sop.";
var surchargeRate$1$1$1$1 = "% Recargo noct.";
var surname$1$1$1$1 = "Apellidos";
var teamMembers$1$1$1$1 = "Miembros del equipo";
var teamTickets$1$1$1$1 = "Los del equipo";
var totalPrice$1$1$1$1 = "Precio total";
var UNAVAILABLE$1$1$1$1 = "No disponible";
var userProfile$1$1$1$1 = "Perfil";
var validate$1$1$1$1 = "Validar";
var validated$1$1$1$1 = "validado";
var vehicle$1$1$1$1 = "Vehículo";
var weekend$1$1$1$1 = "Fin de semana";
var category$1$1$1$1 = {
  car: "Coche",
  ind: "Industrial",
  moto: "Moto",
  ptf: "Plataforma"
};
var collective2$1$1$1$1 = {
  toastColectiveDeactivateErrorTitle: "ERROR",
  toastColectiveDeactivateErrorTextDefault: "En estos momentos no es posible desactivar el colectivo. Por favor, vuelve a intentarlo en unos minutos."
};
var companyList$1$1$1$1 = {
  companyWithCount: "{{count}} Companía",
  companyWithCount_plural: "{{count}} Companías"
};
var depositList$1$1$1$1 = {
  depositWithCount: "{{count}} Depósito",
  depositWithCount_plural: "{{count}} Depósitos"
};
var format$1$1$1$1 = {
  currency: "€ ",
  decimalSeparator: ",",
  thousandSeparator: "."
};
var invoiceList$1$1$1$1 = {
  invoiceWithCount: "{{count}} Factura",
  invoiceWithCount_plural: "{{count}} Facturas"
};
var mediumList$1$1$1$1 = {
  mediumWithCount: "{{count}} Medio",
  mediumWithCount_plural: "{{count}} Medios"
};
var mediumTypesList$1$1$1$1 = {
  mediumTypesWithCount: "{{count}} Tipo de medio",
  mediumTypesWithCount_plural: "{{count}} Tipos de medios"
};
var modals$1$1$1$1 = {
  addService: {
    linkServices: "Vincular servicios",
    linkServicesInfo: "El último servicio Nexus de este vehículo indica que está en un depósito.",
    linkServicesQuestion: "¿Deseas asociar el expediente Nexus y vincular los servicios?"
  },
  budget: {
    timeOut: "Tiempo agotado",
    timeOutInfo: "Se ha agotado el tiempo máximo para aceptar la propuesta. Inténtalo de nuevo."
  },
  ticketDetail: {
    closeTicket: "Cerrar ticket",
    closeTicketQuestion: "¿Estás seguro que deseas cerrar el ticket? Si lo cierras, se dará por resuelto y no podrás enviar más mensajes."
  }
};
var operationTypesList$1$1$1$1 = {
  operationTypesWithCount: "{{count}} Tipo de intervención",
  operationTypesWithCount_plural: "{{count}} Tipos de intervención"
};
var paymentList$1$1$1$1 = {
  paymentWithCount: "{{count}} Pago a proveedores",
  paymentWithCount_plural: "{{count}} Pagos a proveedores",
  processPaymentTitle: "Procesar pagos",
  processPaymentText: "Indica la fecha en la que el fichero ha sido procesado por el banco.",
  generatePaymentsTitle: "Generar pagos",
  generatePaymentsText: "Se van a generar todos los pagos hasta la fecha indicada. El fichero N34-14 se enviará por email.",
  toastGeneratePaymentsSuccessTitle: "Pago generado correctamente",
  toastGeneratePaymentsSuccessText: "El pago se ha generado y se ha enviado el fichero.",
  toastProcessPaymentSuccessTitle: "Pago procesado correctamente",
  toastProcessPaymentSuccessText: "El pago se ha procesado con la fecha indicada.",
  toastGeneratePaymentsWarningTitle: "No ha podido generarse",
  toastGeneratePaymentsWarningText: "No hay facturas pendientes hasta esa fecha."
};
var searchTools$1$1$1$1 = {
  title: "Herramientas de búsqueda",
  byRoadKmTitle: "Busca por carretera y kilómetro",
  byRoadKm_1: "1. Introduce el nombre de la carretera y el punto kilométrico. Ejemplo: E-15/15",
  byRoadKm_2: "2. Pulsa \"Validar\" para validar la ubicación",
  roadKilometer: "Carretera / Kilómetro",
  byCoordsTitle: "Busca por coordenadas",
  byCoords_1: "Pulsa el botón del mapa y localiza la ubicación que necesitas.",
  byCoords_2: "Pulsa el botón derecho y copia las coordenadas que te ofrece Google.",
  byCoords_3: "Pégalas debajo y pulsa \"Validar\" para validar la ubicación.",
  coordsLatitudeLongitude: "Coordenadas (latitud, longitud)"
};
var serviceList$1$1$1$1 = {
  serviceWithCount: "{{count}} Servicio",
  serviceWithCount_plural: "{{count}} Servicios"
};
var servicesError$1$1$1$1 = {
  cancelServiceErrorTitle: "Error al solicitar la anulación",
  notCancelableService: "El servicio no se puede anular en su estado actual.",
  invalidService: "No ha sido posible solicitar la anulación del servicio.",
  cancelServiceUnknownError: "En estos momentos no es posible solicitar la anulación del servicio. Vuelva a intentarlo en unos minutos.",
  openDisputeErrorTitle: "Error al solicitar apertura de disputa",
  openDisputeUnknownError: "En estos momentos no es posible abrir una disputa para el servicio. Vuelva a intentarlo en unos minutos.",
  closeDisputeErrorTitle: "Error al solicitar cierre de disputa",
  closeDisputeUnknownError: "En estos momentos no es posible cerrar la disputa del servicio. Vuelva a intentarlo en unos minutos."
};
var transferPeopleError$1$1$1$1 = {
  cancelTransferPeopleErrorTitle: "Error al solicitar la anulación",
  notCancelableService: "El traslado no se puede anular en su estado actual.",
  invalidTransferPeople: "No ha sido posible solicitar la anulación del traslado.",
  cancelServiceUnknownError: "En estos momentos no es posible solicitar la anulación del traslado. Vuelva a intentarlo en unos minutos."
};
var transferPeopleList$1$1$1$1 = {
  transferPeopleWithCount: "{{count}} Traslado",
  transferPeopleWithCount_plural: "{{count}} Traslados"
};
var shipment$1$1$1$1 = {
  collecting: "Interrumpida",
  pending: "Generada",
  billed: "Facturada",
  collected: "Cobrada",
  payed: "Pagada"
};
var ticketDetail$1$1$1$1 = {
  toastSendMessageSuccessTitle: "Mensaje enviado correctamente",
  toastSendMessageSuccessText: "El mensaje ha sido enviado y añadido a la lista.",
  toastSendMessageErrorTitle: "Error al enviar mensaje",
  toastSendMessageErrorText: "Ha ocurrido un error en el envío del mensaje.",
  toastCloseMessageSuccessTitle: "Ticket cerrado correctamente",
  toastCloseMessageSuccessText: "El ticket ha sido cerrado y actualizado en la lista.",
  toastCloseMessageErrorTitle: "Error al cerrar ticket",
  toastCloseMessageErrorText: "Ha ocurrido un error al cerrar el ticket."
};
var ticketList$1$1$1$1 = {
  ticketWithCount: "{{count}} Ticket",
  ticketWithCount_plural: "{{count}} Tickets"
};
var user2$1$1$1$1 = {
  toastUserDeactivateErrorTitle: "ERROR",
  toastUserDeactivateErrorTextDefault: "En estos momentos no es posible desactivar al usuario. Por favor, vuelve a intentarlo en unos minutos.",
  toastUserDeactivateErrorText: "El usuario activo no puede desactivarse a sí mismo.",
  toastUserInServiceDeactivateErrorText: "No es posible desactivar a un usuario que se encuentra actualmente realizando un servicio.",
  toastUserNotificationSuccessTitle: "Notificación enviada",
  toastUserNotificationSuccessText: "Hemos enviado una notificación al usuario con las instrucciones.",
  toastUserNotificationErrorTitle: "Ha ocurrido un error",
  toastUserNotificationErrorText: "No hemos podido enviar la notificación al usuario."
};
var userList$1$1$1$1 = {
  userWithCount: "{{count}} Usuario",
  userWithCount_plural: "{{count}} Usuarios"
};
var validation$1$1$1$1 = {
  fieldRequired: "Campo obligatorio",
  invalidCurrencyAmount: "No válido",
  invalidTimeFormat: "Formato de hora no válido"
};
var loginYourAccount$1$1$1$1 = "Accede a tu cuenta";
var checkYourEmail$1$1$1$1 = "Comprueba tu correo";
var updatedUser$1$1$1$1 = "Usuario actualizado";
var errorCreatingCompany$1$1$1$1 = "Error al crear compañía";
var min$1$1$1$1 = "min";
var distance$1$1$1$1 = "Distancia";
var es$2$1$1$1 = {
  "********** BEGIN CHECKED WORDS **********": "**********",
  "% IRPF": "% IRPF",
  "% IVA": "% IVA",
  IRPF: IRPF$1$1$1$1,
  IVA: IVA$1$1$1$1,
  NIF: NIF$1$1$1$1,
  "NIF/CIF": "NIF/CIF",
  "NIF/SS": "NIF/SS",
  "NIF/CIF/SS": "NIF/CIF/SS",
  "#": "#",
  "1st": "1º",
  "2nd": "2º",
  "3rd": "3º",
  "4th": "4º",
  "5th": "5º",
  "6th": "6º",
  "7th": "7º",
  "8th": "8º",
  "9th": "9º",
  "10th": "10º",
  betweenMinAndMaxKilometers: betweenMinAndMaxKilometers$1$1$1$1,
  metricUnits: metricUnits$1$1$1$1,
  imperialUnits: imperialUnits$1$1$1$1,
  A: A$2$1$1$1,
  accept: accept$1$1$1$1,
  accepted: accepted$1$1$1$1,
  acceptUpdate: acceptUpdate$1$1$1$1,
  accessToTheViews: accessToTheViews$1$1$1$1,
  accessWithMicrosoft: accessWithMicrosoft$1$1$1$1,
  activateGuardMode: activateGuardMode$1$1$1$1,
  activateGuardModeWarningText: activateGuardModeWarningText$1$1$1$1,
  activateGuardModeWarningAditionalText: activateGuardModeWarningAditionalText$1$1$1$1,
  active: active$1$1$1$1,
  activity: activity$1$1$1$1,
  accumulateNightAndHolidaySurcharge: accumulateNightAndHolidaySurcharge$1$1$1$1,
  add: add$1$1$1$1,
  addAuxService: addAuxService$1$1$1$1,
  addCapability: addCapability$1$1$1$1,
  addCollective: addCollective$1$1$1$1,
  addCost: addCost$1$1$1$1,
  addCostType: addCostType$1$1$1$1,
  addedCollective: addedCollective$1$1$1$1,
  addFault: addFault$1$1$1$1,
  addedFault: addedFault$1$1$1$1,
  additionalInformation: additionalInformation$1$1$1$1,
  additionalPrice: additionalPrice$1$1$1$1,
  additionalPriceAbbrev: additionalPriceAbbrev$1$1$1$1,
  addNote: addNote$1$1$1$1,
  address: address$1$1$1$1,
  addressNotLocated: addressNotLocated$1$1$1$1,
  addUserProfile: addUserProfile$1$1$1$1,
  admin: admin$1$1$1$1,
  advancedConfiguration: advancedConfiguration$1$1$1$1,
  aheadServices: aheadServices$1$1$1$1,
  alert: alert$1$1$1$1,
  alerts: alerts$1$1$1$1,
  alertStart: alertStart$1$1$1$1,
  all_f: all_f$1$1$1$1,
  all_m: all_m$1$1$1$1,
  allowAccess: allowAccess$1$1$1$1,
  allowCalls: allowCalls$1$1$1$1,
  allowCalls_addService: allowCalls_addService$1$1$1$1,
  allowGuardErrorTitle: allowGuardErrorTitle$1$1$1$1,
  allowGuardErrorText: allowGuardErrorText$1$1$1$1,
  allowSMS: allowSMS$1$1$1$1,
  allProvidersAutomatic: allProvidersAutomatic$1$1$1$1,
  anErrorHasOccurred: anErrorHasOccurred$1$1$1$1,
  applyCosts: applyCosts$1$1$1$1,
  approve: approve$1$1$1$1,
  assign: assign$1$1$1$1,
  "assignment/lastActivityAbbrev": "Asig / ult. ac",
  assignTechnician: assignTechnician$1$1$1$1,
  assistance: assistance$1$1$1$1,
  assistanceWithoutTransfer: assistanceWithoutTransfer$1$1$1$1,
  assistanceWithoutTransferWarning: assistanceWithoutTransferWarning$1$1$1$1,
  assistanceWithoutTransferWarningQuestion: assistanceWithoutTransferWarningQuestion$1$1$1$1,
  assisted: assisted$1$1$1$1,
  assistedInsuredAbbrev: assistedInsuredAbbrev$1$1$1$1,
  assistedDestinationAddress: assistedDestinationAddress$1$1$1$1,
  associatedDocuments: associatedDocuments$1$1$1$1,
  at_time: at_time$1$1$1$1,
  assigned: assigned$1$1$1$1,
  ASSIGNED: ASSIGNED$1$1$1$1,
  attachADocument: attachADocument$1$1$1$1,
  "attach the following documents": "Adjunta los siguientes documentos",
  attachment: attachment$1$1$1$1,
  attachments: attachments$1$1$1$1,
  auction: auction$1$1$1$1,
  auctionConfiguration: auctionConfiguration$1$1$1$1,
  auctioned: auctioned$1$1$1$1,
  AUCTIONED: AUCTIONED$1$1$1$1,
  auctioning: auctioning$1$1$1$1,
  AUCTIONING: AUCTIONING$1$1$1$1,
  auctionInPriority: auctionInPriority$1$1$1$1,
  auctionInPriority1: auctionInPriority1$1$1$1$1,
  auctionInPriority2: auctionInPriority2$1$1$1$1,
  auctionInPriority3: auctionInPriority3$1$1$1$1,
  auctionInPriority4: auctionInPriority4$1$1$1$1,
  auctions: auctions$1$1$1$1,
  auctionService: auctionService$1$1$1$1,
  auto: auto$1$1$1$1,
  automatic: automatic$1$1$1$1,
  automaticProvider: automaticProvider$1$1$1$1,
  auxiliary: auxiliary$1$1$1$1,
  auxiliarySettings: auxiliarySettings$1$1$1$1,
  auxiliaries: auxiliaries$1$1$1$1,
  auxiliariesRates: auxiliariesRates$1$1$1$1,
  auxServiceList: auxServiceList$1$1$1$1,
  auxService: auxService$1$1$1$1,
  auxServices: auxServices$1$1$1$1,
  available: available$1$1$1$1,
  available_plural: available_plural$1$1$1$1,
  availableProvidersAbbrev: availableProvidersAbbrev$1$1$1$1,
  availableResources: availableResources$1$1$1$1,
  availableResourcesWithCount: availableResourcesWithCount$1$1$1$1,
  availableResourcesWithCount_plural: availableResourcesWithCount_plural$1$1$1$1,
  average: average$1$1$1$1,
  averageRating: averageRating$1$1$1$1,
  B: B$1$1$1$1,
  base: base$1$1$1$1,
  baseAmount: baseAmount$1$1$1$1,
  billed: billed$1$1$1$1,
  billing: billing$1$1$1$1,
  brand: brand$1$1$1$1,
  browse: browse$1$1$1$1,
  budgetWarningNoBaseFound: budgetWarningNoBaseFound$1$1$1$1,
  businessIntelligence: businessIntelligence$1$1$1$1,
  byAmount: byAmount$1$1$1$1,
  byBrand: byBrand$1$1$1$1,
  byPositionOnQueue: byPositionOnQueue$1$1$1$1,
  byScore: byScore$1$1$1$1,
  byTime: byTime$1$1$1$1,
  C: C$1$1$1$1,
  calculateAllServicesAsSuburban: calculateAllServicesAsSuburban$1$1$1$1,
  calendar: calendar$1$1$1$1,
  cancel: cancel$1$1$1$1,
  cancel_2: cancel_2$1$1$1$1,
  outputCancellationPercentageAbbrev: outputCancellationPercentageAbbrev$1$1$1$1,
  cancelAmount: cancelAmount$1$1$1$1,
  cancelRatePercentage: cancelRatePercentage$1$1$1$1,
  cancelRateAmount: cancelRateAmount$1$1$1$1,
  cancelReason: cancelReason$1$1$1$1,
  cancelService: cancelService$1$1$1$1,
  cancelTransferPeople: cancelTransferPeople$1$1$1$1,
  cancelTransferPeopleWarning: cancelTransferPeopleWarning$1$1$1$1,
  "Cannot send service to this provider because it has not defined any deposit (base)": "No se puede enviar el servicio a este proveedor porque no ha definido ningún depósito (base)",
  capabilityList: capabilityList$1$1$1$1,
  capability: capability$1$1$1$1,
  capabilityCollectiveAbbrev: capabilityCollectiveAbbrev$1$1$1$1,
  capabilities: capabilities$1$1$1$1,
  center: center$1$1$1$1,
  centerName: centerName$1$1$1$1,
  centerNotFound: centerNotFound$1$1$1$1,
  change: change$1$1$1$1,
  changePassword: changePassword$1$1$1$1,
  charge: charge$1$1$1$1,
  chargeWithCount: chargeWithCount$1$1$1$1,
  chargeWithCount_plural: chargeWithCount_plural$1$1$1$1,
  check: check$1$1$1$1,
  childProfile: childProfile$1$1$1$1,
  chosenDriver: chosenDriver$1$1$1$1,
  cif: cif$1$1$1$1,
  city: city$1$1$1$1,
  "class": "Clase",
  clone: clone$1$1$1$1,
  cloneService: cloneService$1$1$1$1,
  close: close$1$1$1$1,
  closeDispute: closeDispute$1$1$1$1,
  code: code$1$1$1$1,
  collectDate: collectDate$1$1$1$1,
  collected: collected$1$1$1$1,
  collectInvoice: collectInvoice$1$1$1$1,
  collective: collective$1$1$1$1,
  collectives: collectives$1$1$1$1,
  collectiveWithCount: collectiveWithCount$1$1$1$1,
  collectiveWithCount_plural: collectiveWithCount_plural$1$1$1$1,
  collectiveProviderAbbrev: collectiveProviderAbbrev$1$1$1$1,
  comment: comment$1$1$1$1,
  commentAboutCapability: commentAboutCapability$1$1$1$1,
  companies: companies$1$1$1$1,
  "companies-opt": {
    listWithCount: "{{count}} Compañía",
    listWithCount_plural: "{{count}} Compañías"
  },
  company: company$1$1$1$1,
  companyName: companyName$1$1$1$1,
  companyProfile: companyProfile$1$1$1$1,
  completed: completed$1$1$1$1,
  configuration: configuration$1$1$1$1,
  consultList: consultList$1$1$1$1,
  "continue": "Continuar",
  costName: costName$1$1$1$1,
  costs: costs$1$1$1$1,
  costSearch: costSearch$1$1$1$1,
  costsWithCount: costsWithCount$1$1$1$1,
  costsWithCount_plural: costsWithCount_plural$1$1$1$1,
  costSheets: costSheets$1$1$1$1,
  costSheetStatus: costSheetStatus$1$1$1$1,
  costType: costType$1$1$1$1,
  costTypeName: costTypeName$1$1$1$1,
  costTypes: costTypes$1$1$1$1,
  costTypesWithCount: costTypesWithCount$1$1$1$1,
  costTypesWithCount_plural: costTypesWithCount_plural$1$1$1$1,
  craneService: craneService$1$1$1$1,
  create: create$1$1$1$1,
  currentPassword: currentPassword$1$1$1$1,
  custodyDays: custodyDays$1$1$1$1,
  customer: customer$1$1$1$1,
  "customer/capability": "Cliente / prestación",
  "customer/exp": "Cliente / Exp.",
  D: D$1$1$1$1,
  dashboard: dashboard$1$1$1$1,
  date: date$1$1$1$1,
  "Date scheduled service": "Fecha servicio programado",
  dateRangeExceeded: dateRangeExceeded$1$1$1$1,
  dayAndTime: dayAndTime$1$1$1$1,
  deadLine: deadLine$1$1$1$1,
  concessionaire: concessionaire$1$1$1$1,
  deferred: deferred$1$1$1$1,
  deferredService: deferredService$1$1$1$1,
  deferredShort: deferredShort$1$1$1$1,
  deferredShorter: deferredShorter$1$1$1$1,
  deleteCost: deleteCost$1$1$1$1,
  deletePath: deletePath$1$1$1$1,
  deleteRequest: deleteRequest$1$1$1$1,
  deposits: deposits$1$1$1$1,
  description: description$1$1$1$1,
  detail: detail$1$1$1$1,
  disconnect: disconnect$1$1$1$1,
  disputeReason: disputeReason$1$1$1$1,
  documentation: documentation$1$1$1$1,
  documentationProfile: documentationProfile$1$1$1$1,
  documentNumberAbbrev: documentNumberAbbrev$1$1$1$1,
  documentProfile: documentProfile$1$1$1$1,
  documentProfiles: documentProfiles$1$1$1$1,
  "documentProfiles-opt": {
    listWithCount: "{{count}} Perfil de documento",
    listWithCount_plural: "{{count}} Perfiles de documentos"
  },
  "documents-status": {
    pending: "Pendiente de verificación",
    validated: "Válido",
    rejected: "Rechazado el",
    rejectReason: "Motivo de rechazo",
    expired: "Caducó el",
    current: "Vigente hasta el"
  },
  documentAdded: documentAdded$1$1$1$1,
  documentType: documentType$1$1$1$1,
  documentTypes: documentTypes$1$1$1$1,
  "documentTypes-opt": {
    listWithCount: "{{count}} Tipo de documento",
    listWithCount_plural: "{{count}} Tipos de documentos"
  },
  doNotAssociate: doNotAssociate$1$1$1$1,
  dragData: dragData$1$1$1$1,
  driver: driver$1$1$1$1,
  drivers: drivers$1$1$1$1,
  "driver/medium": "Conductor / Medio",
  duplicate: duplicate$1$1$1$1,
  duplicateService: duplicateService$1$1$1$1,
  E: E$1$1$1$1,
  edit: edit$1$1$1$1,
  editAuxService: editAuxService$1$1$1$1,
  editCapability: editCapability$1$1$1$1,
  editCollective: editCollective$1$1$1$1,
  editCost: editCost$1$1$1$1,
  editCostType: editCostType$1$1$1$1,
  editFault: editFault$1$1$1$1,
  editSupportTeam: editSupportTeam$1$1$1$1,
  editUserProfile: editUserProfile$1$1$1$1,
  email: email$1$1$1$1,
  endService: endService$1$1$1$1,
  entry: entry$1$1$1$1,
  entryDateAbbrev: entryDateAbbrev$1$1$1$1,
  error: error$1$1$1$1,
  errorAddingDocument: errorAddingDocument$1$1$1$1,
  estimatedTime: estimatedTime$1$1$1$1,
  execution: execution$1$1$1$1,
  executionProfile: executionProfile$1$1$1$1,
  expense: expense$1$1$1$1,
  expiredCode: expiredCode$1$1$1$1,
  expires: expires$1$1$1$1,
  events: events$1$1$1$1,
  excessOfTimeForOutService: excessOfTimeForOutService$1$1$1$1,
  excessOfTimeForUrbanService: excessOfTimeForUrbanService$1$1$1$1,
  excessOfTimeInCurrentStatus: excessOfTimeInCurrentStatus$1$1$1$1,
  excessOfTimeToCompleteService: excessOfTimeToCompleteService$1$1$1$1,
  excessOfTimeToStartScheduledService: excessOfTimeToStartScheduledService$1$1$1$1,
  F: F$1$1$1$1,
  fault: fault$1$1$1$1,
  faults: faults$1$1$1$1,
  faultCollectiveAbbrev: faultCollectiveAbbrev$1$1$1$1,
  faultWithCount: faultWithCount$1$1$1$1,
  faultWithCount_plural: faultWithCount_plural$1$1$1$1,
  fee: fee$1$1$1$1,
  fieldRequired: fieldRequired$1$1$1$1,
  "fields with an asterisk are required": "Los campos con (*) son obligatorios.",
  file: file$1$1$1$1,
  "filecase/assistedAbbrev": "Exp. / asistido",
  "filecase/interventionAbbrev": "Exp./Int.",
  filterByDriverStatus: filterByDriverStatus$1$1$1$1,
  filterByVehicleType: filterByVehicleType$1$1$1$1,
  financial: financial$1$1$1$1,
  financialBreakdown: financialBreakdown$1$1$1$1,
  finish: finish$1$1$1$1,
  finishedServices: finishedServices$1$1$1$1,
  firstPrice: firstPrice$1$1$1$1,
  firstUnitPriceAbbrev: firstUnitPriceAbbrev$1$1$1$1,
  fixed: fixed$1$1$1$1,
  "for": "Para",
  "forgotPassword?": "¿Olvidaste la contraseña?",
  formError: formError$1$1$1$1,
  franchise: franchise$1$1$1$1,
  franchises: franchises$1$1$1$1,
  freeCranesBefore1Hour: freeCranesBefore1Hour$1$1$1$1,
  fromUntil: fromUntil$1$1$1$1,
  fullAddress: fullAddress$1$1$1$1,
  fullScreenAbbrev: fullScreenAbbrev$1$1$1$1,
  G: G$1$1$1$1,
  generalInformationAbbrev: generalInformationAbbrev$1$1$1$1,
  generate: generate$1$1$1$1,
  generated: generated$1$1$1$1,
  geofence: geofence$1$1$1$1,
  geofence_plural: geofence_plural$1$1$1$1,
  geofenceWithCount: geofenceWithCount$1$1$1$1,
  geofenceWithCount_plural: geofenceWithCount_plural$1$1$1$1,
  geoJson: geoJson$1$1$1$1,
  globalAuction: globalAuction$1$1$1$1,
  graceDays: graceDays$1$1$1$1,
  grecaptchaNote: grecaptchaNote$1$1$1$1,
  guardMode: guardMode$1$1$1$1,
  H: H$1$1$1$1,
  help: help$1$1$1$1,
  hide: hide$1$1$1$1,
  holder: holder$1$1$1$1,
  holidays: holidays$1$1$1$1,
  home: home$1$1$1$1,
  hour: hour$1$1$1$1,
  hours: hours$1$1$1$1,
  I: I$1$1$1$1,
  IBAN: IBAN$1$1$1$1,
  icon: icon$1$1$1$1,
  iconUrl: iconUrl$1$1$1$1,
  identificationIcon: identificationIcon$1$1$1$1,
  "If you finish the service you will no longer be able to edit or reschedule it Do you wish to continue?": "Si finalizas el servicio, ya no podrás editarlo o reprogramarlo. ¿Deseas continuar?",
  "If you recover the saved request you will lose the data you have entered in the form do you wish to continue?": "Si recuperas la solicitud guardada, perderás los datos que has introducido en el formulario, ¿deseas continuar?",
  "If you delete the request the saved data will be deleted Do you wish to continue?": "Si eliminas la solicitud, se borrarán los datos guardados, ¿deseas continuar?",
  "If you prefer, you can send the service to a waiting list": "Si lo prefieres, puedes enviar el servicio a una lista de espera",
  image: image$1$1$1$1,
  immediate: immediate$1$1$1$1,
  immediate_plural: immediate_plural$1$1$1$1,
  immediateService: immediateService$1$1$1$1,
  "import": "Importar",
  incorrectLocationFormat: incorrectLocationFormat$1$1$1$1,
  infoWindowIcon: infoWindowIcon$1$1$1$1,
  inParking: inParking$1$1$1$1,
  inRis: inRis$1$1$1$1,
  inris: inris$1$1$1$1,
  inServiceResourcesWithCount: inServiceResourcesWithCount$1$1$1$1,
  inServiceResourcesWithCount_plural: inServiceResourcesWithCount_plural$1$1$1$1,
  instant: instant$1$1$1$1,
  insurancePolicyInfo: insurancePolicyInfo$1$1$1$1,
  insured: insured$1$1$1$1,
  insured_autoType: insured_autoType$1$1$1$1,
  insured_homeType: insured_homeType$1$1$1$1,
  insuredAutoType: insuredAutoType$1$1$1$1,
  insuredHomeType: insuredHomeType$1$1$1$1,
  insuredObjectAbbrev: insuredObjectAbbrev$1$1$1$1,
  insuredProperty: insuredProperty$1$1$1$1,
  integrationProfile: integrationProfile$1$1$1$1,
  integrationProfileAbbrev: integrationProfileAbbrev$1$1$1$1,
  internalCode: internalCode$1$1$1$1,
  internalNote: internalNote$1$1$1$1,
  internalNotes: internalNotes$1$1$1$1,
  interrupted: interrupted$1$1$1$1,
  intervention: intervention$1$1$1$1,
  interventionAbbrev: interventionAbbrev$1$1$1$1,
  interventions: interventions$1$1$1$1,
  inUrbanArea: inUrbanArea$1$1$1$1,
  invalidNexusFilecase: invalidNexusFilecase$1$1$1$1,
  invalidText: invalidText$1$1$1$1,
  invoice: invoice$1$1$1$1,
  "invoice (services - base)": "Factura (servicios - base)",
  "invoice-status": {
    pending: "Pendiente",
    billed: "Facturada",
    collected: "Cobrada",
    payed: "Pagada"
  },
  invoiceNumberAbbrev: invoiceNumberAbbrev$1$1$1$1,
  forTheDay: forTheDay$1$1$1$1,
  isNotValid: isNotValid$1$1$1$1,
  issuedInvoices: issuedInvoices$1$1$1$1,
  itAlreadyExists: itAlreadyExists$1$1$1$1,
  J: J$1$1$1$1,
  K: K$1$1$1$1,
  L: L$1$1$1$1,
  label: label$1$1$1$1,
  labeled: labeled$1$1$1$1,
  "labeled-opt": {
    listWithCount: "{{count}} Rotulación",
    listWithCount_plural: "{{count}} Rotulaciones"
  },
  labels: labels$1$1$1$1,
  lastActivity: lastActivity$1$1$1$1,
  lastActivity2: lastActivity2$1$1$1$1,
  legal: legal$1$1$1$1,
  legalId: legalId$1$1$1$1,
  list: list$1$1$1$1,
  listEntryMax24H: listEntryMax24H$1$1$1$1,
  loaded: loaded$1$1$1$1,
  loadTimeInMinutes: loadTimeInMinutes$1$1$1$1,
  located: located$1$1$1$1,
  location: location$1$1$1$1,
  locked: locked$1$1$1$1,
  lockedByNexus: lockedByNexus$1$1$1$1,
  login: login$1$1$1$1,
  logo: logo$1$1$1$1,
  logout: logout$1$1$1$1,
  M: M$1$1$1$1,
  managed: managed$1$1$1$1,
  managedProvider: managedProvider$1$1$1$1,
  manual: manual$1$1$1$1,
  manualProvider: manualProvider$1$1$1$1,
  map: map$1$1$1$1,
  mapIcon: mapIcon$1$1$1$1,
  mapOfGoingServices: mapOfGoingServices$1$1$1$1,
  mapOfResources: mapOfResources$1$1$1$1,
  mapOfTracking: mapOfTracking$1$1$1$1,
  mapView: mapView$1$1$1$1,
  max: max$1$1$1$1,
  maxAllowedTimeInMinutes: maxAllowedTimeInMinutes$1$1$1$1,
  maxDistance: maxDistance$1$1$1$1,
  maxDistanceToCrane: maxDistanceToCrane$1$1$1$1,
  maxHours: maxHours$1$1$1$1,
  maxRadius: maxRadius$1$1$1$1,
  maxTime: maxTime$1$1$1$1,
  maxTimeOnList: maxTimeOnList$1$1$1$1,
  medium: medium$1$1$1$1,
  mediumNotFound: mediumNotFound$1$1$1$1,
  mediumType: mediumType$1$1$1$1,
  mediumTypes: mediumTypes$1$1$1$1,
  mediumTypes2: mediumTypes2$1$1$1$1,
  "mediumTypes-opt": {
    listWithCount: "{{count}} Tipo de medio",
    listWithCount_plural: "{{count}} Tipos de medios"
  },
  minute: minute$1$1$1$1,
  minutes: minutes$1$1$1$1,
  modeAndName: modeAndName$1$1$1$1,
  model: model$1$1$1$1,
  modifiedCollective: modifiedCollective$1$1$1$1,
  modifiedFault: modifiedFault$1$1$1$1,
  myTickets: myTickets$1$1$1$1,
  N: N$1$1$1$1,
  name: name$1$1$1$1,
  nameSurname: nameSurname$1$1$1$1,
  "new": "Nuevo",
  new_female: new_female$1$1$1$1,
  new_plural: new_plural$1$1$1$1,
  newAuxService: newAuxService$1$1$1$1,
  newAuxiliaryService: newAuxiliaryService$1$1$1$1,
  newDayAndTime: newDayAndTime$1$1$1$1,
  newPassword: newPassword$1$1$1$1,
  newService: newService$1$1$1$1,
  newSupportTeam: newSupportTeam$1$1$1$1,
  newVehicleAssistance: newVehicleAssistance$1$1$1$1,
  newVialService: newVialService$1$1$1$1,
  nexusMapServiceError: nexusMapServiceError$1$1$1$1,
  nick: nick$1$1$1$1,
  no: no$1$1$1$1,
  noProvidersAvailable: noProvidersAvailable$1$1$1$1,
  notApplyCosts: notApplyCosts$1$1$1$1,
  notParticipating: notParticipating$1$1$1$1,
  noCovered: noCovered$1$1$1$1,
  noDocumentsAssociatedToService: noDocumentsAssociatedToService$1$1$1$1,
  noResourcesAvailableMsg: noResourcesAvailableMsg$1$1$1$1,
  noSubscribe: noSubscribe$1$1$1$1,
  note: note$1$1$1$1,
  notes: notes$1$1$1$1,
  notesAssociatedWithTheService: notesAssociatedWithTheService$1$1$1$1,
  noTicketsAssociatedToService: noTicketsAssociatedToService$1$1$1$1,
  noTicketsAssociatedToTransfer: noTicketsAssociatedToTransfer$1$1$1$1,
  noNotesAssociatedToService: noNotesAssociatedToService$1$1$1$1,
  notifications: notifications$1$1$1$1,
  noTransfersAvailable: noTransfersAvailable$1$1$1$1,
  noValid: noValid$1$1$1$1,
  numberAbbrev: numberAbbrev$1$1$1$1,
  numberOfPeopleAbbrev: numberOfPeopleAbbrev$1$1$1$1,
  numberOfReviewsAbbrev: numberOfReviewsAbbrev$1$1$1$1,
  O: O$1$1$1$1,
  office: office$1$1$1$1,
  ongoing: ongoing$1$1$1$1,
  onQueue: onQueue$1$1$1$1,
  openDispute: openDispute$1$1$1$1,
  operational: operational$1$1$1$1,
  operationTypes: operationTypes$1$1$1$1,
  "operationTypes-opt": {
    listWithCount: "{{count}} Tipo de intervención",
    listWithCount_plural: "{{count}} Tipos de intervención"
  },
  origin: origin$1$1$1$1,
  originalServiceData: originalServiceData$1$1$1$1,
  originDeposit: originDeposit$1$1$1$1,
  otherSettings: otherSettings$1$1$1$1,
  orYouCan: orYouCan$1$1$1$1,
  outlay: outlay$1$1$1$1,
  outlays: outlays$1$1$1$1,
  "outlays-opt": {
    listWithCount: "{{count}} Gasto adicional",
    listWithCount_plural: "{{count}} Gastos adicionales"
  },
  P: P$1$1$1$1,
  paid: paid$1$1$1$1,
  passengers: passengers$1$1$1$1,
  passengersWithCount: passengersWithCount$1$1$1$1,
  passengersWithCount_plural: passengersWithCount_plural$1$1$1$1,
  password: password$1$1$1$1,
  passwordsNotMatch: passwordsNotMatch$1$1$1$1,
  paymentsToProviders: paymentsToProviders$1$1$1$1,
  "paymentsToProviders-opt": {
    listWithCount: "{{count}} Pago a proveedor",
    listWithCount_plural: "{{count}} Pagos a proveedores"
  },
  pdf: pdf$1$1$1$1,
  pending: pending$1$1$1$1,
  pendings: pendings$1$1$1$1,
  PENDING: PENDING$1$1$1$1,
  pending_assign: pending_assign$1$1$1$1,
  PENDING_ASSIGN: PENDING_ASSIGN$1$1$1$1,
  PENDINGASSIGN: PENDINGASSIGN$1$1$1$1,
  pendingDocumentation: pendingDocumentation$1$1$1$1,
  pendingDocuments: pendingDocuments$1$1$1$1,
  "pendingDocuments-opt": {
    listWithCount: "{{count}} Documento pendiente",
    listWithCount_plural: "{{count}} Documentos pendientes"
  },
  pendingPassword: pendingPassword$1$1$1$1,
  pendingProfile: pendingProfile$1$1$1$1,
  peopleTransferActivity: peopleTransferActivity$1$1$1$1,
  pleaseTryAgainLater: pleaseTryAgainLater$1$1$1$1,
  "Please indicate the reason for cancelling the service and enter the charges if necessary": "Por favor, indica el motivo por el que anulas el servicio, e introduce los gastos si es necesario.",
  phone: phone$1$1$1$1,
  phoneNumberAbbrev: phoneNumberAbbrev$1$1$1$1,
  photoWithCount: photoWithCount$1$1$1$1,
  photoWithCount_plural: photoWithCount_plural$1$1$1$1,
  photos: photos$1$1$1$1,
  planned: planned$1$1$1$1,
  PLANNED: PLANNED$1$1$1$1,
  plannedService: plannedService$1$1$1$1,
  plate: plate$1$1$1$1,
  plateDoesNotCorrespondToTheFilecase: plateDoesNotCorrespondToTheFilecase$1$1$1$1,
  policy: policy$1$1$1$1,
  policyCoverageLimit: policyCoverageLimit$1$1$1$1,
  policyCoverageLimit2: policyCoverageLimit2$1$1$1$1,
  policyInformation: policyInformation$1$1$1$1,
  policyLimitExceeded: policyLimitExceeded$1$1$1$1,
  policyLimitExceededAux: policyLimitExceededAux$1$1$1$1,
  policyNumberAbbrev: policyNumberAbbrev$1$1$1$1,
  policySearch: policySearch$1$1$1$1,
  positionAbbrev: positionAbbrev$1$1$1$1,
  "price(approx)": "Precio (aprox.)",
  priority: priority$1$1$1$1,
  priority1Providers: priority1Providers$1$1$1$1,
  priority2Providers: priority2Providers$1$1$1$1,
  priority3Providers: priority3Providers$1$1$1$1,
  priorityAllProviders: priorityAllProviders$1$1$1$1,
  priorityProvider: priorityProvider$1$1$1$1,
  process: process$1$1$1$1$1,
  profile: profile$1$1$1$1,
  profileNotFound: profileNotFound$1$1$1$1,
  profiles: profiles$1$1$1$1,
  "profiles-opt": {
    listWithCount: "{{count}} Perfil",
    listWithCount_plural: "{{count}} Perfiles",
    addTitle: "Añadir perfil",
    addText: "Completa los datos del perfil para añadirlo.",
    toastAddSuccessTitle: "Perfil creado correctamente",
    toastAddSuccessText: "El perfil ha sido creado y añadido a la lista."
  },
  proposals: proposals$1$1$1$1,
  provider: provider$1$1$1$1,
  providersInZone: providersInZone$1$1$1$1,
  providersOutZone: providersOutZone$1$1$1$1,
  providerTechnician: providerTechnician$1$1$1$1,
  providerVialSettings: providerVialSettings$1$1$1$1,
  providerEditVialSettingsHeaderText: providerEditVialSettingsHeaderText$1$1$1$1,
  providerAuxiliariesSettings: providerAuxiliariesSettings$1$1$1$1,
  providerEditAuxiliariesSettingsHeaderText: providerEditAuxiliariesSettingsHeaderText$1$1$1$1,
  "provider/driverAbbrev": "Prov / conductor",
  providers: providers$1$1$1$1,
  provider_pending: provider_pending$1$1$1$1,
  PROVIDER_PENDING: PROVIDER_PENDING$1$1$1$1,
  PROVIDERPENDING: PROVIDERPENDING$1$1$1$1,
  provider_accepted: provider_accepted$1$1$1$1,
  PROVIDER_ACCEPTED: PROVIDER_ACCEPTED$1$1$1$1,
  PROVIDERACCEPTED: PROVIDERACCEPTED$1$1$1$1,
  provider_accept: provider_accept$1$1$1$1,
  PROVIDER_ACCEPT: PROVIDER_ACCEPT$1$1$1$1,
  PROVIDERACCEPT: PROVIDERACCEPT$1$1$1$1,
  providersSelection: providersSelection$1$1$1$1,
  providerList: providerList$1$1$1$1,
  providersMap: providersMap$1$1$1$1,
  providerType: providerType$1$1$1$1,
  providerTypeVial: providerTypeVial$1$1$1$1,
  providerTypeAux: providerTypeAux$1$1$1$1,
  providerWithoutDefinedDeposit: providerWithoutDefinedDeposit$1$1$1$1,
  province: province$1$1$1$1,
  Q: Q$1$1$1$1,
  queueEntryDate: queueEntryDate$1$1$1$1,
  queued: queued$1$1$1$1,
  QUEUED: QUEUED$1$1$1$1,
  queuedService: queuedService$1$1$1$1,
  R: R$1$1$1$1,
  rates: rates$1$1$1$1,
  rating: rating$1$1$1$1,
  ratings: ratings$1$1$1$1,
  ratingsUserName: ratingsUserName$1$1$1$1,
  ratingsWithCount: ratingsWithCount$1$1$1$1,
  ratingsWithCount_plural: ratingsWithCount_plural$1$1$1$1,
  ready: ready$1$1$1$1,
  reAssign: reAssign$1$1$1$1,
  reAssignProvider: reAssignProvider$1$1$1$1,
  reAskForResetEmail: reAskForResetEmail$1$1$1$1,
  received: received$1$1$1$1,
  receivedInvoices: receivedInvoices$1$1$1$1,
  recoverRequest: recoverRequest$1$1$1$1,
  recoverYourPassword: recoverYourPassword$1$1$1$1,
  region: region$1$1$1$1,
  registrationInformationOnInvoices: registrationInformationOnInvoices$1$1$1$1,
  reject: reject$1$1$1$1,
  rejectCosts: rejectCosts$1$1$1$1,
  rejectionReason: rejectionReason$1$1$1$1,
  rejectionReasons: rejectionReasons$1$1$1$1,
  "rejectionReasons-opt": {
    listWithCount: "{{count}} Motivo de rechazo",
    listWithCount_plural: "{{count}} Motivos de rechazo"
  },
  rejectionType: rejectionType$1$1$1$1,
  release: release$1$1$1$1,
  removeFromDashboard: removeFromDashboard$1$1$1$1,
  repeated: repeated$1$1$1$1,
  repeatPassword: repeatPassword$1$1$1$1,
  requestCapability: requestCapability$1$1$1$1,
  requestInfo: requestInfo$1$1$1$1,
  requestLocationByWhatsApp: requestLocationByWhatsApp$1$1$1$1,
  requestMediumAbbrev: requestMediumAbbrev$1$1$1$1,
  requestProcessedCorrectly: requestProcessedCorrectly$1$1$1$1,
  requestWithoutIAssociatedPolicy: requestWithoutIAssociatedPolicy$1$1$1$1,
  required: required$1$1$1$1,
  reschedule: reschedule$1$1$1$1,
  RESCHEDULED: RESCHEDULED$1$1$1$1,
  rescheduleComment: rescheduleComment$1$1$1$1,
  rescheduleReason: rescheduleReason$1$1$1$1,
  rescheduleService: rescheduleService$1$1$1$1,
  rescheduleServiceDeferredTextModal: rescheduleServiceDeferredTextModal$1$1$1$1,
  rescheduleServicePlannedText1Modal: rescheduleServicePlannedText1Modal$1$1$1$1,
  rescheduleServicePlannedText2Modal: rescheduleServicePlannedText2Modal$1$1$1$1,
  resetPassword: resetPassword$1$1$1$1,
  resetYourPassword: resetYourPassword$1$1$1$1,
  resources: resources$1$1$1$1,
  resourcesMap: resourcesMap$1$1$1$1,
  restore: restore$1$1$1$1,
  result: result$1$1$1$1,
  "return": "Volver",
  ris: ris$1$1$1$1,
  risService: risService$1$1$1$1,
  S: S$1$1$1$1,
  save: save$1$1$1$1,
  saveChanges: saveChanges$1$1$1$1,
  savedRequests: savedRequests$1$1$1$1,
  saveRequest: saveRequest$1$1$1$1,
  "Saving your request for later retrieval will delete the form data Do you wish to continue?": "Guardando la solicitud para recuperarla más tarde, se borrarán los datos del formulario, ¿deseas continuar?",
  schedule: schedule$1$1$1$1,
  scheduled: scheduled$1$1$1$1,
  SCHEDULED: SCHEDULED$1$1$1$1,
  scheduled_plural: scheduled_plural$1$1$1$1,
  scheduledAbbrev: scheduledAbbrev$1$1$1$1,
  scheduledDateInvalidErrorText: scheduledDateInvalidErrorText$1$1$1$1,
  scheduleDriver: scheduleDriver$1$1$1$1,
  scheduledServiceNotFound: scheduledServiceNotFound$1$1$1$1,
  scheduledFor: scheduledFor$1$1$1$1,
  searchResourceOrTechnician: searchResourceOrTechnician$1$1$1$1,
  searchResources: searchResources$1$1$1$1,
  searchAResource: searchAResource$1$1$1$1,
  searchAService: searchAService$1$1$1$1,
  searchByAssistedOrFilecase: searchByAssistedOrFilecase$1$1$1$1,
  searchByAssistedFilecaseOrPlate: searchByAssistedFilecaseOrPlate$1$1$1$1,
  searchByAssistedFilecaseOrProvider: searchByAssistedFilecaseOrProvider$1$1$1$1,
  searchByCodeOrName: searchByCodeOrName$1$1$1$1,
  searchByCodeNameOrCostType: searchByCodeNameOrCostType$1$1$1$1,
  searchByCodeNameOrMediumType: searchByCodeNameOrMediumType$1$1$1$1,
  searchByCustomer: searchByCustomer$1$1$1$1,
  searchByCustomerOrFilecase: searchByCustomerOrFilecase$1$1$1$1,
  searchByCustomerFilecaseOrPlate: searchByCustomerFilecaseOrPlate$1$1$1$1,
  searchByFileCase: searchByFileCase$1$1$1$1,
  searchByIdForOrFilecaseNumber: searchByIdForOrFilecaseNumber$1$1$1$1,
  searchByInvoiceNumber: searchByInvoiceNumber$1$1$1$1,
  searchByName: searchByName$1$1$1$1,
  searchByNameCIFOrAddress: searchByNameCIFOrAddress$1$1$1$1,
  searchByNameOrAddress: searchByNameOrAddress$1$1$1$1,
  searchByNameOrCode: searchByNameOrCode$1$1$1$1,
  searchByNamePlateOrCode: searchByNamePlateOrCode$1$1$1$1,
  searchByNameSurnameUserOrNick: searchByNameSurnameUserOrNick$1$1$1$1,
  searchByProviderOrName: searchByProviderOrName$1$1$1$1,
  searchByTerm: searchByTerm$1$1$1$1,
  searchInsurancePolicy: searchInsurancePolicy$1$1$1$1,
  seeAverages: seeAverages$1$1$1$1,
  breakdown: breakdown$1$1$1$1,
  seeCapabilityComment: seeCapabilityComment$1$1$1$1,
  seeComment: seeComment$1$1$1$1,
  seeContactAndComment: seeContactAndComment$1$1$1$1,
  seeDescription: seeDescription$1$1$1$1,
  seeService: seeService$1$1$1$1,
  "Select a transfer associated with the service": "Selecciona un traslado asociado al servicio",
  selfValidated: selfValidated$1$1$1$1,
  send: send$1$1$1$1,
  sendComments: sendComments$1$1$1$1,
  sended: sended$1$1$1$1,
  sendEmail: sendEmail$1$1$1$1,
  sendForReview: sendForReview$1$1$1$1,
  sendTo: sendTo$1$1$1$1,
  sendToList: sendToList$1$1$1$1,
  serverConnectionError: serverConnectionError$1$1$1$1,
  service: service$1$1$1$1,
  serviceExecution: serviceExecution$1$1$1$1,
  serviceInAuction: serviceInAuction$1$1$1$1,
  serviceLevels: serviceLevels$1$1$1$1,
  serviceMap: serviceMap$1$1$1$1,
  serviceNotFound: serviceNotFound$1$1$1$1,
  serviceRequestAndTracking: serviceRequestAndTracking$1$1$1$1,
  services: services$1$1$1$1,
  serviceSentToAuction: serviceSentToAuction$1$1$1$1,
  serviceStatus: serviceStatus$1$1$1$1,
  settings: settings$1$1$1$1,
  settingsUpdated: settingsUpdated$1$1$1$1,
  sharedCode: sharedCode$1$1$1$1,
  sharedNote: sharedNote$1$1$1$1,
  sharedNotes: sharedNotes$1$1$1$1,
  "shipment (services - base)": "Remesa (servicios - base)",
  shipments: shipments$1$1$1$1,
  shipmentStatusValues: shipmentStatusValues$1$1$1$1,
  showAllMediums: showAllMediums$1$1$1$1,
  showSolicitedMedium: showSolicitedMedium$1$1$1$1,
  situation: situation$1$1$1$1,
  solicitedMedium: solicitedMedium$1$1$1$1,
  sortCriteria: sortCriteria$1$1$1$1,
  soundActivated: soundActivated$1$1$1$1,
  soundOff: soundOff$1$1$1$1,
  start: start$1$1$1$1,
  started: started$1$1$1$1,
  status: status$1$1$1$1,
  statuses: statuses$1$1$1$1,
  subject: subject$1$1$1$1,
  subscribe: subscribe$1$1$1$1,
  subtotal: subtotal$1$1$1$1,
  suburb: suburb$1$1$1$1,
  suburbService: suburbService$1$1$1$1,
  summary: summary$1$1$1$1,
  supportCenter: supportCenter$1$1$1$1,
  supportTeam: supportTeam$1$1$1$1,
  survey: survey$1$1$1$1,
  surveys: surveys$1$1$1$1,
  T: T$1$1$1$1,
  taxes: taxes$1$1$1$1,
  team: team$1$1$1$1,
  teamName: teamName$1$1$1$1,
  technician: technician$1$1$1$1,
  technicians: technicians$1$1$1$1,
  "The maximum date range allowed is 45 days": "El rango de fechas máximo permitido es de 45 días",
  "The request could not be made Try again": "No se ha podido realizar la solicitud. Inténtalo de nuevo.",
  "The proposal could not be retrieved because the collective does not exist": "No se ha podido recuperar la solicitud porque el colectivo no existe",
  "The service has been sent successfully": "El servicio se ha enviado correctamente.",
  "The service rejection could not be completed": "El rechazo del servicio no ha podido completarse.",
  "The service will be sent after completing the request process": "El servicio se enviará tras completar el proceso de solicitud",
  theField: theField$1$1$1$1,
  ticket: ticket$1$1$1$1,
  tickets: tickets$1$1$1$1,
  ticketStatus: ticketStatus$1$1$1$1,
  time: time$1$1$1$1,
  "time(approx)": "Tiempo (aprox.)",
  timeInAlert: timeInAlert$1$1$1$1,
  timeline: timeline$1$1$1$1,
  title: title$1$1$1$1,
  toastErrorDuplicateAddressPickupDeliveryTitle: toastErrorDuplicateAddressPickupDeliveryTitle$1$1$1$1,
  toastErrorDuplicateAddressPickupDeliveryText: toastErrorDuplicateAddressPickupDeliveryText$1$1$1$1,
  toastErrorDuplicateAddressPickupDestinationTitle: toastErrorDuplicateAddressPickupDestinationTitle$1$1$1$1,
  toastErrorDuplicateAddressPickupDestinationText: toastErrorDuplicateAddressPickupDestinationText$1$1$1$1,
  toastErrorTextDefault: toastErrorTextDefault$1$1$1$1,
  toastErrorTitleDefault: toastErrorTitleDefault$1$1$1$1,
  toastErrorTransferPeopleBudget: toastErrorTransferPeopleBudget$1$1$1$1,
  toastErrorTitle_downloadFile: toastErrorTitle_downloadFile$1$1$1$1,
  toastErrorText_downloadFile: toastErrorText_downloadFile$1$1$1$1,
  toastSuccessTextDefault: toastSuccessTextDefault$1$1$1$1,
  toastSuccessTitleDefault: toastSuccessTitleDefault$1$1$1$1,
  today: today$1$1$1$1,
  toDefine: toDefine$1$1$1$1,
  total: total$1$1$1$1,
  totals: totals$1$1$1$1,
  toTheClient: toTheClient$1$1$1$1,
  toTheProvider: toTheProvider$1$1$1$1,
  town: town$1$1$1$1,
  tracking: tracking$1$1$1$1,
  trackingMessage: trackingMessage$1$1$1$1,
  transfer: transfer$1$1$1$1,
  transferHasBeenCancelled: transferHasBeenCancelled$1$1$1$1,
  transferPeople: transferPeople$1$1$1$1,
  transferPeopleBudget: transferPeopleBudget$1$1$1$1,
  transferPeopleRequest: transferPeopleRequest$1$1$1$1,
  transferPeopleRequestType: transferPeopleRequestType$1$1$1$1,
  transferPeopleRequiredValidPhoneNumber: transferPeopleRequiredValidPhoneNumber$1$1$1$1,
  transfers: transfers$1$1$1$1,
  transfersAvailable: transfersAvailable$1$1$1$1,
  transferTheAssisted: transferTheAssisted$1$1$1$1,
  type: type$1$1$1$1,
  typeAndName: typeAndName$1$1$1$1,
  "type/capability": "Tipo/prestación",
  typeless: typeless$1$1$1$1,
  typeOfService: typeOfService$1$1$1$1,
  types: types$1$1$1$1,
  U: U$1$1$1$1,
  "undefined": "Sin definir",
  udWithCount: udWithCount$1$1$1$1,
  udWithCount_plural: udWithCount_plural$1$1$1$1,
  unAssign: unAssign$1$1$1$1,
  unAssignTechnician: unAssignTechnician$1$1$1$1,
  unAssignTechnicianModalText: unAssignTechnicianModalText$1$1$1$1,
  unAssignTechnicianModalAditionalText: unAssignTechnicianModalAditionalText$1$1$1$1,
  unAssignDriver: unAssignDriver$1$1$1$1,
  unAssignDriverModalText: unAssignDriverModalText$1$1$1$1,
  unAssignDriverModalAditionalText: unAssignDriverModalAditionalText$1$1$1$1,
  unavailable: unavailable$1$1$1$1,
  units: units$1$1$1$1,
  unitAbbrev: unitAbbrev$1$1$1$1,
  unitsAbbrev: unitsAbbrev$1$1$1$1,
  unselected: unselected$1$1$1$1,
  unsubscribe: unsubscribe$1$1$1$1,
  urban: urban$1$1$1$1,
  urbanFee: urbanFee$1$1$1$1,
  urbanService: urbanService$1$1$1$1,
  user: user$1$1$1$1,
  userProfiles: userProfiles$1$1$1$1,
  userProfilesWithCount: userProfilesWithCount$1$1$1$1,
  userProfilesWithCount_plural: userProfilesWithCount_plural$1$1$1$1,
  users: users$1$1$1$1,
  "users-opt": {
    listWithCount: "{{count}} Usuario",
    listWithCount_plural: "{{count}} Usuarios"
  },
  userType: userType$1$1$1$1,
  V: V$1$1$1$1,
  validFrom: validFrom$1$1$1$1,
  validUntil: validUntil$1$1$1$1,
  variable: variable$1$1$1$1,
  vehicleAssistance: vehicleAssistance$1$1$1$1,
  vehicleTypes: vehicleTypes$1$1$1$1,
  "vehicleTypes-opt": {
    listWithCount: "{{count}} Tipo de vehículo",
    listWithCount_plural: "{{count}} Tipos de vehículos"
  },
  "vehicle/fault": "Vehículo / Avería",
  version: version$1$1$1$1,
  vial: vial$1$1$1$1,
  vials: vials$1$1$1$1,
  vialRates: vialRates$1$1$1$1,
  vialServices: vialServices$1$1$1$1,
  vialSettings: vialSettings$1$1$1$1,
  view: view$1$1$1$1,
  viewAssistedRating: viewAssistedRating$1$1$1$1,
  viewContact: viewContact$1$1$1$1,
  viewContactandComment: viewContactandComment$1$1$1$1,
  viewRoute: viewRoute$1$1$1$1,
  views: views$1$1$1$1,
  vin: vin$1$1$1$1,
  virtualSwitchboard: virtualSwitchboard$1$1$1$1,
  W: W$1$1$1$1,
  waitingList: waitingList$1$1$1$1,
  web: web$1$1$1$1,
  webAddress: webAddress$1$1$1$1,
  wholeWordSearch: wholeWordSearch$1$1$1$1,
  wholeWordSearch3Charts: wholeWordSearch3Charts$1$1$1$1,
  withAlert: withAlert$1$1$1$1,
  withholdings: withholdings$1$1$1$1,
  withPriority1: withPriority1$1$1$1$1,
  withPriority2: withPriority2$1$1$1$1,
  withPriority3: withPriority3$1$1$1$1,
  writeANote: writeANote$1$1$1$1,
  wrongUser: wrongUser$1$1$1$1,
  wrongUsernameOrPassword: wrongUsernameOrPassword$1$1$1$1,
  X: X$1$1$1$1,
  Y: Y$1$1$1$1,
  year: year$1$1$1$1,
  yes: yes$1$1$1$1,
  yesterday: yesterday$1$1$1$1,
  youHaveExceededTheNumberOfAtempsts: youHaveExceededTheNumberOfAtempsts$1$1$1$1,
  Z: Z$1$1$1$1,
  "A dispute has been opened for this service": "Se ha abierto una disputa para este servicio.",
  "Add the following cost data": "Añade los siguientes datos del costo.",
  "Add the following cost type data": "Añade los siguientes datos del tipo de costo.",
  "Allow assigning rate in service request": "Asignar la tarifa en la solicitud de servicio",
  "An error has occurred in the creation of the collective": "Ha ocurrido un error en la creación del colectivo.",
  "An error has occurred in the creation of the fault": "Ha ocurrido un error en la creación de la avería.",
  "An error occurred while trying to upload the file": "Ha ocurrido un error al intentar subir el archivo.",
  "Approve costs": "Aprobar costos",
  "Are you sure you want to approve the cost sheet? Once approved you will not be able to request changes": "¿Seguro que deseas aprobar la hoja de costos? Una vez aprobada, no podrás solicitar cambios.",
  "Are you sure you want to send the cost sheet for review? Once it has been sent you will not be able to edit it again": "¿Seguro que deseas enviar la hoja de costos a revisión? Una vez enviada, no podrás editarla de nuevo.",
  "Assistance has arrived at pickup": "La asistencia ha llegado a la recogida",
  "Assistance is on the way": "La asistencia está en camino",
  "Assistance reached its destination": "La asistencia llegó a su destino",
  "At this time it is not possible to access the service": "En estos momentos no es posible acceder al servicio",
  "Attention a new service will be requested without any associated policy": "Atención, se va a solicitar un nuevo servicio sin ninguna póliza asociada.",
  "Capability created successfully": "Prestación creada correctamente",
  "Capability has been created and added to the list": "La prestación ha sido creada y añadida a la lista.",
  "Capability has been updated successfully": "La prestación ha sido actualizada correctamente.",
  "Capability updated": "Prestación actualizada",
  "Complete the data of the auxiliar service to add it": "Completa los datos del servicio auxiliar para añadirlo.",
  "Complete the data of the auxiliar service to edit it": "Completa los datos del servicio auxiliar para editarlo.",
  "Complete the data of the capability to add it": "Completa los datos de la prestación para añadirla.",
  "Complete the data of the capability to edit it": "Completa los datos de la prestación para editarla.",
  "Complete the data of the collective to add it": "Completa los datos del colectivo para añadirlo.",
  "Complete the data of the fault to add it": "Completa los datos de la avería para añadirla.",
  "Contact your insurer for more information": "Contacta con tu aseguradora para más información",
  "Costs approved successfully": "Costos aprobados correctamente",
  "Costs could not be approved": "No ha sido posible aprobar los costos",
  "Costs could not be rejected": "No ha sido posible rechazar los costos",
  "Cost created successfully": "Costo creado correctamente",
  "Costs rejected successfully": "Costos rechazados correctamente",
  "Costs sheet approved": "Hoja de costos aprobada",
  "Cost sheet could not be saved": "No ha sido posible guardar la hoja de costos",
  "Cost sheet could not be sent for review": "No ha sido posible enviar a revisión la hoja de costos",
  "Cost sheet rejected": "Hoja de costos rechazada",
  "Costs sheet saved successfully": "Hoja de costos guardada con éxito",
  "Costs sheet sent for review": "Hoja de costos enviada a revisión",
  "CostType created successfully": "Tipo de costo creado correctamente",
  "Cost has been created and added to the list": "El costo ha sido creado y añadido a la lista",
  "CostType has been created and added to the list": "El tipo de costo ha sido creado y añadido a la lista",
  "Cost has been updated successfully": "El costo ha sido actualizado correctamente.",
  "CostType has been updated successfully": "El tipo de costo ha sido actualizado correctamente.",
  "Cost updated": "Costo actualizado",
  "CostType updated": "Tipo de costo actualizado",
  "Data has been saved successfully": "Los datos se han guardado correctamente",
  "Do not allow the assistant to call the driver from the tracking widget": "No permitir al asistido llamar al chofer desde el widget de seguimiento",
  "Do not allow technician to create notes": "No permitir al técnico crear notas",
  "Do not allow the technician to reschedule the service": "No permitir al técnico reprogramar el servicio",
  "Do not show the technician the assisted person phone number": "No mostrar al técnico el teléfono del asistido",
  "Do not take into account the first section for the calculation of the rate": "No tener en cuenta el primer tramo para el cálculo de la tarifa",
  "Do you want to send the request": "¿Deseas enviar la solicitud?",
  "Edit the data you need for the following cost": "Edita los datos que necesites del siguiente costo.",
  "Edit the data you need for the following type cost": "Edita los datos que necesites del siguiente tipo de costo.",
  "Edit the data you need from the following collective": "Edita los datos que necesites del siguiente colectivo.",
  "Edit the data you need from the following fault": "Edita los datos que necesites de la siguiente avería.",
  "Edit the details you need for the following user profile": "Edita los datos que necesites del siguiente perfil de usuario.",
  "Error creating capability": "Error al crear prestación",
  "Error creating cost": "Error al crear costo",
  "Error creating costType": "Error al crear tipo de costo",
  "Error creating user profile": "Error al crear perfil de usuario",
  "Error has ocurred while creating the capability": "Ha ocurrido un error en la creación de la prestación.",
  "Error has ocurred while creating the cost": "Ha ocurrido un error durante la creación del costo.",
  "Error has ocurred while creating the costType": "Ha ocurrido un error durante la creación del tipo de costo.",
  "Error has ocurred while creating the user profile": "Ha ocurrido un error durante la creación del perfil de usuario.",
  "Error has ocurred while updating the capability": "Ha ocurrido un error durante la actualización de la prestación.",
  "Error has ocurred while updating the cost": "Ha ocurrido un error durante la actualización del costo.",
  "Error has ocurred while updating the costType": "Ha ocurrido un error durante la actualización del tipo de costo.",
  "Error has ocurred while updating the user profile": "Ha ocurrido un error durante la actualización del perfil de usuario.",
  "Error updating capability": "Error al actualizar prestación",
  "Error updating cost": "Error al actualizar costo",
  "Error updating costType": "Error al actualizar tipo de costo",
  "Error updating user profile": "Error al actualizar perfil de usuario",
  "Fill in the details of the user profile to add it": "Completa los datos del perfil del usuario para añadirlo.",
  "Follow your roadside assistance service in real time by clicking on the continue button": "Sigue en tiempo real tu servicio de asistencia en carretera, pulsando en el botón de continuar",
  "Follow your assistance service in real time by clicking on the continue button": "Sigue en tiempo real tu servicio de asistencia, pulsando en el botón de continuar",
  "Hide middle phone in tracking widget": "Ocultar el teléfono del medio en el widget de seguimiento",
  "It is not possible to access": "No es posible acceder",
  "It has not been possible to add the new note to the service": "No ha sido posible añadir al servicio la nueva nota.",
  "It has not been possible to consult the events associated with the service": "No ha sido posible consultar los eventos asociados al servicio.",
  "It has not been possible to modify the collective data": "No ha sido posible modificar los datos del colectivo.",
  "It has not been possible to modify the fault data": "No ha sido posible modificar los datos de la avería.",
  "It has not been possible to update the information": "No ha sido posible actualizar la información",
  "It was not possible to finish the service": "No ha sido posible finalizar el servicio.",
  "It was not possible to obtain the survey data": "No ha sido posible obtener los datos de la encuesta.",
  "It was not possible to recover the integration profiles": "No ha sido posible recuperar los perfiles de integración.",
  "Manage the documents necessary to work with Nexus": "Gestiona los documentos necesarios para trabajar con Nexus",
  "No auction providers found at the service location": "No se han encontrado proveedores de subasta en la ubicación del servicio",
  "No changes have been made to the service": "No se han realizado cambios en el servicio.",
  "Please indicate the reason why you wish to reject the costs associated with the service": "Por favor, indica el motivo por el que deseas rechazar los costos que están asociados al servicio.",
  "Please retry in a few minutes": "Vuelve a intentarlo en unos minutos.",
  "Plot the geofence on the map, complete the information and press the save button": "Define la geocerca en el mapa, completa la información y pulsa el botón guardar",
  "__providerName settings have been updated": "Los ajustes de {{providerName}} han sido actualizados",
  "Reload the page or contact your company": "Recarga la página o contacta con tu compañía",
  "Request processed correctly": "Solicitud procesada de forma correcta",
  "Select a provider to assign to the service": "Selecciona un proveedor para asignar al servicio.",
  "Select the providers that will participate in the auction": "Selecciona los proveedores que participarán en la subasta",
  "Send costs for review": "Enviar costos a revisión",
  "Service acceptance could not be completed": "La aceptación del servicio no ha podido completarse.",
  "Service assignment could not be completed": "La asignación del servicio no ha podido completarse.",
  "Service requested from the widget": "Servicio solicitado desde el widget",
  "Sorry attendance has been canceled": "Lo sentimos, la asistencia ha sido cancelada",
  "Spoofing the assisted phone number": "Suplantación del nº de teléfono del asistido",
  "Successfully sent, under review": "Enviada correctamente, está en revisión",
  "Support has ended": "La asistencia ha finalizado",
  "Thank you very much for your confidence": "Muchas gracias por tu confianza",
  "The collective has been created and added to the list": "El colectivo ha sido creado y añadido a la lista.",
  "The cost could not be modified": "El costo no ha podido ser modificado",
  "The dispute for this service has been closed": "Se ha cerrado la disputa para este servicio.",
  "The document has been attached to the service": "El documento se ha adjuntado al servicio.",
  "The fault has been created and added to the list": "La avería ha sido creada y añadida a la lista.",
  "The file must be pdf jpg or png": "El archivo tiene que ser: pdf, jpg o png.",
  "The service has been canceled": "El servicio ha sido anulado.",
  "The service has been created and added to the list": "El servicio ha sido creado y añadido a la lista.",
  "The service has been rescheduled": "El servicio ha sido reprogramado.",
  "The service has been scheduled for the day": "El servicio ha sido programado para el día",
  "There is no assigned provider": "No hay proveedor asignado",
  "There are no documents associated": "No hay documentos asociados",
  "There are no events associated with the service": "No hay eventos asociados al servicio.",
  "User profile created successfully": "Perfil de usuario creado correctamente",
  "User profile has been created and added to the list": "El perfil de usuario ha sido creado y añadido a la lista.",
  "User profile has been updated successfully": "El perfil de usuario ha sido actualizado correctamente.",
  "User profile updated": "Perfil de usuario actualizado",
  "We are at your disposal whenever you need it": "Estamos a tu disposición siempre que lo necesites",
  "We are sorry It has not been possible to show the tracking of your service": "Lo sentimos. No ha sido posible mostrar el seguimiento de tu servicio.",
  "We are trying to repair your vehicle": "Estamos tratando de reparar tu vehículo",
  "We have not been able to connect you to our network": "No hemos podido conectarte a nuestra red",
  "We have updated the information of the collective": "La información del colectivo se ha actualizado correctamente.",
  "We have updated the information of the fault": "La información de la avería se ha actualizado correctamente.",
  "Welcome to the __companyName tracking platform": "Bienvenido a la plataforma de seguimiento de {{companyName}}",
  "Your company does not have integration defined with Azure": "",
  "Your user is blocked by Nexus": "Tu usuario está bloquedado por Nexus",
  "Your vehicle is being moved": "Tu vehículo está siendo trasladado",
  "********** END CHECKED WORDS **********": "",
  "********** BEGIN PHRASES **********": "**********",
  "No services performed since the renewal date": "No hay servicios realizados desde la fecha de renovación",
  "********** BEGIN COMPANY PROFILE SETTINGS **********": "**********",
  "Assignment algorithm": "Algoritmo de asignación",
  "Service request": "Solicitud del servicio",
  "SMS messages": "Mensajes SMS",
  "Maximum time given to a resource to accept or reject a service": "Tiempo máximo que se le otorga a un recurso para aceptar o rechazar un servicio",
  "Maximum time given to a provider to accept or reject a service": "Tiempo máximo que se le otorga a un proveedor para aceptar o rechazar un servicio",
  "Maximum time in which a service request can be accepted": "Tiempo máximo en el que se puede aceptar una solicitud de servicio",
  "Maximum time for all providers": "Tiempo máximo para todos los proveedores",
  "Maximum time for providers with priority": "Tiempo máximo para proveedores con prioridad {{priority}}",
  "Maximum radial distance to search for resources in a service request": "Distancia máxima radial para buscar recursos en una solicitud de servicio",
  "Default distance when sending a to assign a waiting service to a resource": "Distancia por defecto al enviar un servicio a la lista de espera",
  "Maximum total distance of a service route": "Distancia máxima total de la ruta de un servicio",
  "Origin location for calculating the rate in automatic services": "Ubicación de origen para el cálculo de la tarifa en servicios automáticos",
  "From deposit": "Desde depósito",
  "From resource": "Desde recurso",
  "Show option to cancel services at no cost": "Mostrar opción de anular servicios sin coste",
  "Show policy information in the service file": "Mostrar datos de póliza en la ficha del servicio",
  "Block editing of the fault": "Bloquear la edición de la avería",
  "Show the clone services button": "Mostrar el botón de clonar servicios",
  "Show the mandatory damage report by default": "Mostrar el parte de daños obligatorio por defecto",
  "Maximum number of photos that can be requested in a service": "Máximo nº de fotos que se pueden solicitar en un servicio",
  "Number of mandatory photos by default": "Número de fotos obligatorias por defecto",
  "Message sender": "Remitente de los mensajes",
  maxMinutes: maxMinutes$1$1$1$1,
  maxPhotos: maxPhotos$1$1$1$1,
  between0And5Minutes: between0And5Minutes$1$1$1$1,
  between0And10Minutes: between0And10Minutes$1$1$1$1,
  between0And240Minutes: between0And240Minutes$1$1$1$1,
  between1And7Minutes: between1And7Minutes$1$1$1$1,
  between2And5Minutes: between2And5Minutes$1$1$1$1,
  between2And10Minutes: between2And10Minutes$1$1$1$1,
  between0And10Photos: between0And10Photos$1$1$1$1,
  between1And10Characters: between1And10Characters$1$1$1$1,
  "Fault by medium type": "Avería por tipo de medio",
  "********** END COMPANY PROFILE SETTINGS **********": "**********",
  "********** BEGIN COMPANY PROFILE SERVICE LEVELS **********": "**********",
  between0And120Minutes: between0And120Minutes$1$1$1$1,
  "Maximum times in vial services": "Tiempos máximos en servicios viales",
  "Time for the provider to accept the service": "Tiempo para que el proveedor acepte el servicio",
  "Time for the provider to assign the service to a resource": "Tiempo para que el proveedor asigne el servicio a un recurso",
  "Time to start the service after the resource accepts it": "Tiempo para iniciar el servicio después de que el recurso lo acepte",
  "Time to locate the pick-up location in urban services": "Tiempo para localizar el lugar de recogida en servicios locales",
  "Time to locate the pick-up location in suburban services": "Tiempo para localizar el lugar de recogida en servicios carreteros",
  "Time to carry out an on-site repair": "Tiempo de realización de una reparación in situ",
  "Time to reach the delivery location": "Tiempo para llegar al lugar de entrega",
  "Time to carry out an urban service": "Tiempo de realización de un servicio local",
  "Time to carry out an suburban service": "Tiempo de realización de un servicio carretero",
  "Maximum times in auxiliary services": "Tiempos máximos en servicios auxiliares",
  "Time that the service can be in completed status": "Tiempo que puede estar el servicio en estado completado",
  "Time to assign an urban service to a technician": "Tiempo de asignación de un servicio local a un técnico",
  "Time to assign an suburban service to a technician": "Tiempo de asignación de un servicio carretero a un técnico",
  "Time to locate the location from the start of the service": "Tiempo para localizar la ubicación desde que se inicia el servicio",
  "Waiting time before starting a scheduled service": "Tiempo de espera antes de iniciar un servicio programado",
  "********** END COMPANY PROFILE SERVICE LEVELS **********": "**********",
  "*** ERRORS ***": "",
  "Date not in valid range": "La fecha está fuera de rango",
  "Hours not in valid range": "La hora está fuera de rango",
  "Distance not in valid range": "La distancia está fuera de rango",
  "Mandatory request body not found": "La información obligatoria de la petición es incorrecta",
  "Selected budget already confirmed": "El presupuesto seleccionado ha sido confirmado previamente",
  "Selected budget expired": "El presupuesto seleccionado ha expirado",
  "Selected budget not found": "El presupuesto seleccionado no ha podido ser localizado",
  "The token is invalid": "El token no es válido",
  "*** ERRORS - END ***": "",
  "An error occurred while approving this document": "Ha ocurrido un error al aprobar este documento",
  "An error occurred while rejecting this document": "Ha ocurrido un error al rechazar este documento",
  "Are you sure you want to accept the update? By doing so, you allow Nexus to send you services under the terms of this rate": "",
  "Are you sure you want to delete the cost?": "¿Seguro que deseas eliminar el costo?",
  "Are you sure you want finish the service?": "¿Seguro que deseas finalizar el servicio?",
  "Complete the fields to change your access password": "Completa los campos para cambiar tu contraseña de acceso",
  "Error approving the document": "Error al aprobar el documento",
  "Error rejecting the document": "Error al rechazar el documento",
  "It's necessary to change the access password to continue with the registration": "Es necesario cambiar la contraseña de acceso, para continuar con el registro",
  "Manage subscriptions to rates": "Gestiona las suscripciones a las tarifas",
  "Now you can use it when you login": "Ya puedes utilizarla al iniciar sesión",
  "There are unsaved changes": "Hay cambios sin guardar",
  "********** BEGIN PENDING WORDS **********": "",
  ACCEPTED: ACCEPTED$1$1$1$1,
  add_company_description: add_company_description$1$1$1$1,
  add_company: add_company$1$1$1$1,
  addChartText: addChartText$1$1$1$1,
  addChartTitle: addChartTitle$1$1$1$1,
  all_female: all_female$1$1$1$1,
  all_male: all_male$1$1$1$1,
  amount: amount$1$1$1$1,
  "Amount outside of policy coverage Payment of the assisted to the provider": "Importe fuera de cobertura de póliza (pago del asistido al proveedor)",
  apply: apply$1$1$1$1,
  assignProvider: assignProvider$1$1$1$1,
  assignedToMe: assignedToMe$1$1$1$1,
  assignItToMe: assignItToMe$1$1$1$1,
  AVAILABLE: AVAILABLE$1$1$1$1,
  blocked: blocked$1$1$1$1,
  budgetToastSuccessText: budgetToastSuccessText$1$1$1$1,
  budgetToastSuccessTitle: budgetToastSuccessTitle$1$1$1$1,
  scheduledBudgetToastSuccessText: scheduledBudgetToastSuccessText$1$1$1$1,
  scheduledBudgetToastSuccessTitle: scheduledBudgetToastSuccessTitle$1$1$1$1,
  transferPeopleBudgetToastSuccessText: transferPeopleBudgetToastSuccessText$1$1$1$1,
  transferPeopleBudgetToastSuccessTitle: transferPeopleBudgetToastSuccessTitle$1$1$1$1,
  budgetToastSuccessQueueText: budgetToastSuccessQueueText$1$1$1$1,
  budgetToastSuccessQueueTitle: budgetToastSuccessQueueTitle$1$1$1$1,
  bussy: bussy$1$1$1$1,
  CANCELED: CANCELED$1$1$1$1,
  centerNum: centerNum$1$1$1$1,
  centers: centers$1$1$1$1,
  closed: closed$1$1$1$1,
  codeAlreadyAssigned: codeAlreadyAssigned$1$1$1$1,
  color: color$1$1$1$1,
  companyPendingDocumentation: companyPendingDocumentation$1$1$1$1,
  companyProviderCode: companyProviderCode$1$1$1$1,
  COMPLETED: COMPLETED$1$1$1$1,
  custodyRate: custodyRate$1$1$1$1,
  damageReport: damageReport$1$1$1$1,
  damageRequired: damageRequired$1$1$1$1,
  day: day$1$1$1$1,
  days: days$1$1$1$1,
  del: del$1$1$1$1,
  delivery: delivery$1$1$1$1,
  deliveryAddressRequired: deliveryAddressRequired$1$1$1$1,
  destination: destination$1$1$1$1,
  documents: documents$1$1$1$1,
  exit: exit$1$1$1$1,
  expired: expired$1$1$1$1,
  EXTRA_CHARGES: EXTRA_CHARGES$1$1$1$1,
  extraCharges: extraCharges$1$1$1$1,
  festive: festive$1$1$1$1,
  fieldsRequired: fieldsRequired$1$1$1$1,
  files: files$1$1$1$1,
  filters: filters$1$1$1$1,
  FINISHED: FINISHED$1$1$1$1,
  free: free$1$1$1$1,
  from: from$1$1$1$1,
  fromDate: fromDate$1$1$1$1,
  generalInfo: generalInfo$1$1$1$1,
  groupName: groupName$1$1$1$1,
  id: id$1$1$1$1,
  IN_SERVICE: IN_SERVICE$1$1$1$1,
  information: information$1$1$1$1,
  INRIS: INRIS$1$1$1$1,
  integrated: integrated$1$1$1$1,
  invite: invite$1$1$1$1,
  invoiceDate: invoiceDate$1$1$1$1,
  lastAct: lastAct$1$1$1$1,
  left: left$1$1$1$1,
  LOADED: LOADED$1$1$1$1,
  LOCATED: LOCATED$1$1$1$1,
  locations: locations$1$1$1$1,
  mediums: mediums$1$1$1$1,
  MEDIUMS: MEDIUMS$1$1$1$1,
  modify: modify$1$1$1$1,
  newRates: newRates$1$1$1$1,
  nexus: nexus$1$1$1$1,
  nexusFee: nexusFee$1$1$1$1,
  nFilecase: nFilecase$1$1$1$1,
  nFilecaseAbbrev: nFilecaseAbbrev$1$1$1$1,
  nickName: nickName$1$1$1$1,
  nightlyEnd: nightlyEnd$1$1$1$1,
  nightlyStart: nightlyStart$1$1$1$1,
  nightly: nightly$1$1$1$1,
  nigthly: nigthly$1$1$1$1,
  nightlyFestive: nightlyFestive$1$1$1$1,
  nInvoice: nInvoice$1$1$1$1,
  nInvoices: nInvoices$1$1$1$1,
  none: none$1$1$1$1,
  NOT_IN_NEXUS: NOT_IN_NEXUS$1$1$1$1,
  not: not$1$1$1$1,
  nNexus: nNexus$1$1$1$1,
  nPayments: nPayments$1$1$1$1,
  nServices: nServices$1$1$1$1,
  numberOfInvoices: numberOfInvoices$1$1$1$1,
  of: of$1$1$1$1,
  open: open$1$1$1$1,
  outOfService: outOfService$1$1$1$1,
  ownFilecaseNumber: ownFilecaseNumber$1$1$1$1,
  ownFilecaseNumberAbbrev: ownFilecaseNumberAbbrev$1$1$1$1,
  partialPrice: partialPrice$1$1$1$1,
  participants: participants$1$1$1$1,
  participation: participation$1$1$1$1,
  payed: payed$1$1$1$1,
  payments: payments$1$1$1$1,
  pendingAbbrev: pendingAbbrev$1$1$1$1,
  photosNumber: photosNumber$1$1$1$1,
  pickup: pickup$1$1$1$1,
  "pickup/delivery": "Recogida / entrega",
  pickupAddress: pickupAddress$1$1$1$1,
  pictures: pictures$1$1$1$1,
  "private": "Privado",
  processDate: processDate$1$1$1$1,
  processed: processed$1$1$1$1,
  providerAlreadyMapped: providerAlreadyMapped$1$1$1$1,
  "public": "Público",
  REJECTED: REJECTED$1$1$1$1,
  rejection: rejection$1$1$1$1,
  request: request$1$1$1$1,
  requester: requester$1$1$1$1,
  resource: resource$1$1$1$1,
  resourceActivity: resourceActivity$1$1$1$1,
  resourceDistance: resourceDistance$1$1$1$1,
  resourceRoute: resourceRoute$1$1$1$1,
  resourceTime: resourceTime$1$1$1$1,
  responsable: responsable$1$1$1$1,
  responseNumberAbbrev: responseNumberAbbrev$1$1$1$1,
  RISEND: RISEND$1$1$1$1,
  RISSTART: RISSTART$1$1$1$1,
  rowsPerPage: rowsPerPage$1$1$1$1,
  saveView: saveView$1$1$1$1,
  sendSMSTracking: sendSMSTracking$1$1$1$1,
  sendSurvey: sendSurvey$1$1$1$1,
  serviceActivity: serviceActivity$1$1$1$1,
  serviceBudget: serviceBudget$1$1$1$1,
  serviceRequest: serviceRequest$1$1$1$1,
  serviceType: serviceType$1$1$1$1,
  shared: shared$1$1$1$1,
  shipmentDate: shipmentDate$1$1$1$1,
  sign: sign$1$1$1$1,
  sta: sta$1$1$1$1,
  STARTED: STARTED$1$1$1$1,
  supportTeamAbbrev: supportTeamAbbrev$1$1$1$1,
  surchargeRate: surchargeRate$1$1$1$1,
  surname: surname$1$1$1$1,
  teamMembers: teamMembers$1$1$1$1,
  teamTickets: teamTickets$1$1$1$1,
  totalPrice: totalPrice$1$1$1$1,
  UNAVAILABLE: UNAVAILABLE$1$1$1$1,
  userProfile: userProfile$1$1$1$1,
  validate: validate$1$1$1$1,
  validated: validated$1$1$1$1,
  vehicle: vehicle$1$1$1$1,
  weekend: weekend$1$1$1$1,
  "***** STRUCTURES *****": "*****",
  category: category$1$1$1$1,
  collective2: collective2$1$1$1$1,
  companyList: companyList$1$1$1$1,
  depositList: depositList$1$1$1$1,
  format: format$1$1$1$1,
  invoiceList: invoiceList$1$1$1$1,
  mediumList: mediumList$1$1$1$1,
  "mediums-toast": {
    toastErrorDeactivateMediumTitle: "ERROR",
    toastErrorDeactivateMediumText: "En estos momentos no es posible desactivar el medio. Por favor, vuelve a intentarlo en unos minutos.",
    toastErrorDeactivateMediumInServideTitle: "ERROR",
    toastErrorDeactivateMediumInServiceText: "No es posible desactivar un medio que se encuentra actualmente realizando un servicio."
  },
  mediumTypesList: mediumTypesList$1$1$1$1,
  modals: modals$1$1$1$1,
  operationTypesList: operationTypesList$1$1$1$1,
  paymentList: paymentList$1$1$1$1,
  "rates-concepts": {
    startupFee: "Tarifa de salida",
    scheduledFee: "Tarifa programado",
    nexusFee: "Tarifa de Nexus",
    km: "Tarifa por km",
    mi: "Tarifa por mi",
    minute: "Tarifa por minuto",
    loadTime: "Tiempo de carga",
    surchargeRate: "Recargo",
    cancelRate: "Anulación",
    cancelAmount: "Importe anulación",
    surchargeType: "Tipo de recargo",
    freeCustodyDays: "Custodia gratuita",
    custodyRate: "Custodia",
    urban: "Local",
    urbanFee: "Tarifa local",
    franchise: "Franquicia"
  },
  searchTools: searchTools$1$1$1$1,
  serviceList: serviceList$1$1$1$1,
  servicesError: servicesError$1$1$1$1,
  transferPeopleError: transferPeopleError$1$1$1$1,
  transferPeopleList: transferPeopleList$1$1$1$1,
  shipment: shipment$1$1$1$1,
  "shipments-opt": {
    listWithCount: "{{count}} Remesa",
    listWithCount_plural: "{{count}} Remesas",
    collectInvoiceErrorTitle: "Error al solicitar el cobro de la factura",
    collectInvoiceUnknownError: "En estos momentos no es posible realizar la operación. Vuelva a intentarlo en unos minutos."
  },
  "shipments-opt2": {
    collectInvoiceErrorTitle: "Error al solicitar el cobro de la factura",
    collectInvoiceUnknownError: "En estos momentos no es posible realizar la operación. Vuelva a intentarlo en unos minutos."
  },
  ticketDetail: ticketDetail$1$1$1$1,
  ticketList: ticketList$1$1$1$1,
  user2: user2$1$1$1$1,
  userList: userList$1$1$1$1,
  validation: validation$1$1$1$1,
  loginYourAccount: loginYourAccount$1$1$1$1,
  checkYourEmail: checkYourEmail$1$1$1$1,
  updatedUser: updatedUser$1$1$1$1,
  errorCreatingCompany: errorCreatingCompany$1$1$1$1,
  min: min$1$1$1$1,
  distance: distance$1$1$1$1,
  "---": "---"
};
function _extends$1$1$1$1() {
  _extends$1$1$1$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1$1$1$1.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$1$1$1$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var CustomCheckbox$1$1$1$1 = withStyles({
  root: {
    "&$checked": {
      color: "#ec754a"
    }
  },
  checked: {}
})(function (props) {
  return /*#__PURE__*/React__default__default__default__default.createElement(Checkbox, _extends$1$1$1$1({
    color: "default"
  }, props));
});
var commonjsGlobal$1$1$1$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function unwrapExports$1$1$1$1(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function createCommonjsModule$1$1$1$1(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
function getCjsExportFromNamespace$1$1$1$1(n) {
  return n && n['default'] || n;
}
function commonjsRequire$1$1$1$1() {
  throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}
var b$1$1$1$1 = "function" === typeof Symbol && Symbol["for"],
  c$1$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.element") : 60103,
  d$1$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.portal") : 60106,
  e$1$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.fragment") : 60107,
  f$1$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.strict_mode") : 60108,
  g$1$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.profiler") : 60114,
  h$1$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.provider") : 60109,
  k$1$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.context") : 60110,
  l$1$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.async_mode") : 60111,
  m$1$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.concurrent_mode") : 60111,
  n$1$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.forward_ref") : 60112,
  p$1$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.suspense") : 60113,
  q$1$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.suspense_list") : 60120,
  r$2$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.memo") : 60115,
  t$1$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.lazy") : 60116,
  v$1$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.block") : 60121,
  w$1$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.fundamental") : 60117,
  x$1$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.responder") : 60118,
  y$1$1$1$1 = b$1$1$1$1 ? Symbol["for"]("react.scope") : 60119;
function z$1$1$1$1(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c$1$1$1$1:
        switch (a = a.type, a) {
          case l$1$1$1$1:
          case m$1$1$1$1:
          case e$1$1$1$1:
          case g$1$1$1$1:
          case f$1$1$1$1:
          case p$1$1$1$1:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k$1$1$1$1:
              case n$1$1$1$1:
              case t$1$1$1$1:
              case r$2$1$1$1:
              case h$1$1$1$1:
                return a;
              default:
                return u;
            }
        }
      case d$1$1$1$1:
        return u;
    }
  }
}
function A$1$1$1$1$1(a) {
  return z$1$1$1$1(a) === m$1$1$1$1;
}
var AsyncMode$1$1$1$1 = l$1$1$1$1;
var ConcurrentMode$1$1$1$1 = m$1$1$1$1;
var ContextConsumer$1$1$1$1 = k$1$1$1$1;
var ContextProvider$1$1$1$1 = h$1$1$1$1;
var Element$1$1$1$1 = c$1$1$1$1;
var ForwardRef$1$1$1$1 = n$1$1$1$1;
var Fragment$1$1$1$1 = e$1$1$1$1;
var Lazy$1$1$1$1 = t$1$1$1$1;
var Memo$1$1$1$1 = r$2$1$1$1;
var Portal$1$1$1$1 = d$1$1$1$1;
var Profiler$1$1$1$1 = g$1$1$1$1;
var StrictMode$1$1$1$1 = f$1$1$1$1;
var Suspense$1$1$1$1 = p$1$1$1$1;
var isAsyncMode$1$1$1$1 = function isAsyncMode(a) {
  return A$1$1$1$1$1(a) || z$1$1$1$1(a) === l$1$1$1$1;
};
var isConcurrentMode$1$1$1$1 = A$1$1$1$1$1;
var isContextConsumer$1$1$1$1 = function isContextConsumer(a) {
  return z$1$1$1$1(a) === k$1$1$1$1;
};
var isContextProvider$1$1$1$1 = function isContextProvider(a) {
  return z$1$1$1$1(a) === h$1$1$1$1;
};
var isElement$1$1$1$1 = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c$1$1$1$1;
};
var isForwardRef$1$1$1$1 = function isForwardRef(a) {
  return z$1$1$1$1(a) === n$1$1$1$1;
};
var isFragment$1$1$1$1 = function isFragment(a) {
  return z$1$1$1$1(a) === e$1$1$1$1;
};
var isLazy$1$1$1$1 = function isLazy(a) {
  return z$1$1$1$1(a) === t$1$1$1$1;
};
var isMemo$1$1$1$1 = function isMemo(a) {
  return z$1$1$1$1(a) === r$2$1$1$1;
};
var isPortal$1$1$1$1 = function isPortal(a) {
  return z$1$1$1$1(a) === d$1$1$1$1;
};
var isProfiler$1$1$1$1 = function isProfiler(a) {
  return z$1$1$1$1(a) === g$1$1$1$1;
};
var isStrictMode$1$1$1$1 = function isStrictMode(a) {
  return z$1$1$1$1(a) === f$1$1$1$1;
};
var isSuspense$1$1$1$1 = function isSuspense(a) {
  return z$1$1$1$1(a) === p$1$1$1$1;
};
var isValidElementType$1$1$1$1 = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e$1$1$1$1 || a === m$1$1$1$1 || a === g$1$1$1$1 || a === f$1$1$1$1 || a === p$1$1$1$1 || a === q$1$1$1$1 || "object" === typeof a && null !== a && (a.$$typeof === t$1$1$1$1 || a.$$typeof === r$2$1$1$1 || a.$$typeof === h$1$1$1$1 || a.$$typeof === k$1$1$1$1 || a.$$typeof === n$1$1$1$1 || a.$$typeof === w$1$1$1$1 || a.$$typeof === x$1$1$1$1 || a.$$typeof === y$1$1$1$1 || a.$$typeof === v$1$1$1$1);
};
var typeOf$1$1$1$1 = z$1$1$1$1;
var reactIs_production_min$1$1$1$1 = {
  AsyncMode: AsyncMode$1$1$1$1,
  ConcurrentMode: ConcurrentMode$1$1$1$1,
  ContextConsumer: ContextConsumer$1$1$1$1,
  ContextProvider: ContextProvider$1$1$1$1,
  Element: Element$1$1$1$1,
  ForwardRef: ForwardRef$1$1$1$1,
  Fragment: Fragment$1$1$1$1,
  Lazy: Lazy$1$1$1$1,
  Memo: Memo$1$1$1$1,
  Portal: Portal$1$1$1$1,
  Profiler: Profiler$1$1$1$1,
  StrictMode: StrictMode$1$1$1$1,
  Suspense: Suspense$1$1$1$1,
  isAsyncMode: isAsyncMode$1$1$1$1,
  isConcurrentMode: isConcurrentMode$1$1$1$1,
  isContextConsumer: isContextConsumer$1$1$1$1,
  isContextProvider: isContextProvider$1$1$1$1,
  isElement: isElement$1$1$1$1,
  isForwardRef: isForwardRef$1$1$1$1,
  isFragment: isFragment$1$1$1$1,
  isLazy: isLazy$1$1$1$1,
  isMemo: isMemo$1$1$1$1,
  isPortal: isPortal$1$1$1$1,
  isProfiler: isProfiler$1$1$1$1,
  isStrictMode: isStrictMode$1$1$1$1,
  isSuspense: isSuspense$1$1$1$1,
  isValidElementType: isValidElementType$1$1$1$1,
  typeOf: typeOf$1$1$1$1
};
var reactIs_development$1$1$1$1 = createCommonjsModule$1$1$1$1(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs$1$1$1$1 = createCommonjsModule$1$1$1$1(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min$1$1$1$1;
  } else {
    module.exports = reactIs_development$1$1$1$1;
  }
});
var getOwnPropertySymbols$1$1$1$1 = Object.getOwnPropertySymbols;
var hasOwnProperty$1$1$1$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable$1$1$1$1 = Object.prototype.propertyIsEnumerable;
function toObject$1$1$1$1(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative$1$1$1$1() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String('abc');
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
var objectAssign$1$1$1$1 = shouldUseNative$1$1$1$1() ? Object.assign : function (target, source) {
  var from;
  var to = toObject$1$1$1$1(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty$1$1$1$1.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols$1$1$1$1) {
      symbols = getOwnPropertySymbols$1$1$1$1(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable$1$1$1$1.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};
var ReactPropTypesSecret$2$1$1$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1$1$1$1$1 = ReactPropTypesSecret$2$1$1$1;
var has$2$1$1$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$2$1$1$1 = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1$1$1$1$1 = ReactPropTypesSecret_1$1$1$1$1;
  var loggedTypeFailures$1$1$1$1 = {};
  var has$1$1$1$1$1 = has$2$1$1$1;
  printWarning$2$1$1$1 = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function checkPropTypes$1$1$1$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1$1$1$1$1(typeSpecs, typeSpecName)) {
        var error;
        try {
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1$1$1$1$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$2$1$1$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures$1$1$1$1)) {
          loggedTypeFailures$1$1$1$1[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$2$1$1$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
checkPropTypes$1$1$1$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures$1$1$1$1 = {};
  }
};
var checkPropTypes_1$1$1$1$1 = checkPropTypes$1$1$1$1;
var printWarning$1$1$1$1$1 = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  printWarning$1$1$1$1$1 = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull$1$1$1$1() {
  return null;
}
var factoryWithTypeCheckers$1$1$1$1 = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  var ANONYMOUS = '<<anonymous>>';
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  function is(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  }
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1$1$1$1$1) {
        if (throwOnDirectAccess) {
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
            printWarning$1$1$1$1$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull$1$1$1$1);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1$1$1$1$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs$1$1$1$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1$1$1$1$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1$1$1$1$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull$1$1$1$1;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$2$1$1$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1$1$1$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1$1$1$1$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull$1$1$1$1;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1$1$1$1$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull$1$1$1$1;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1$1$1$1$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$2$1$1$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1$1$1$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      var allKeys = objectAssign$1$1$1$1({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$2$1$1$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1$1$1$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    if (propType === 'symbol') {
      return true;
    }
    if (!propValue) {
      return false;
    }
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1$1$1$1$1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1$1$1$1$1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
function emptyFunction$1$1$1$1() {}
function emptyFunctionWithReset$1$1$1$1() {}
emptyFunctionWithReset$1$1$1$1.resetWarningCache = emptyFunction$1$1$1$1;
var factoryWithThrowingShims$1$1$1$1 = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1$1$1$1$1) {
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset$1$1$1$1,
    resetWarningCache: emptyFunction$1$1$1$1
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
var propTypes$1$1$1$1 = createCommonjsModule$1$1$1$1(function (module) {
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs$1$1$1$1;
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers$1$1$1$1(ReactIs.isElement, throwOnDirectAccess);
  } else {
    module.exports = factoryWithThrowingShims$1$1$1$1();
  }
});
var moment$1$1$1$1 = createCommonjsModule$1$1$1$1(function (module, exports) {
  (function (global, factory) {
    module.exports = factory();
  })(commonjsGlobal$1$1$1$1, function () {
    var hookCallback;
    function hooks() {
      return hookCallback.apply(null, arguments);
    }
    function setHookCallback(callback) {
      hookCallback = callback;
    }
    function isArray(input) {
      return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
      return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
      if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
      } else {
        var k;
        for (k in obj) {
          if (hasOwnProp(obj, k)) {
            return false;
          }
        }
        return true;
      }
    }
    function isUndefined(input) {
      return input === void 0;
    }
    function isNumber(input) {
      return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
      return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
      var res = [],
        i,
        arrLen = arr.length;
      for (i = 0; i < arrLen; ++i) {
        res.push(fn(arr[i], i));
      }
      return res;
    }
    function extend(a, b) {
      for (var i in b) {
        if (hasOwnProp(b, i)) {
          a[i] = b[i];
        }
      }
      if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
      }
      if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
      }
      return a;
    }
    function createUTC(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
      return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false
      };
    }
    function getParsingFlags(m) {
      if (m._pf == null) {
        m._pf = defaultParsingFlags();
      }
      return m._pf;
    }
    var some;
    if (Array.prototype.some) {
      some = Array.prototype.some;
    } else {
      some = function some(fun) {
        var t = Object(this),
          len = t.length >>> 0,
          i;
        for (i = 0; i < len; i++) {
          if (i in t && fun.call(this, t[i], i, t)) {
            return true;
          }
        }
        return false;
      };
    }
    function isValid(m) {
      if (m._isValid == null) {
        var flags = getParsingFlags(m),
          parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
          }),
          isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
        if (m._strict) {
          isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
          m._isValid = isNowValid;
        } else {
          return isNowValid;
        }
      }
      return m._isValid;
    }
    function createInvalid(flags) {
      var m = createUTC(NaN);
      if (flags != null) {
        extend(getParsingFlags(m), flags);
      } else {
        getParsingFlags(m).userInvalidated = true;
      }
      return m;
    }
    var momentProperties = hooks.momentProperties = [],
      updateInProgress = false;
    function copyConfig(to, from) {
      var i,
        prop,
        val,
        momentPropertiesLen = momentProperties.length;
      if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
      }
      if (!isUndefined(from._i)) {
        to._i = from._i;
      }
      if (!isUndefined(from._f)) {
        to._f = from._f;
      }
      if (!isUndefined(from._l)) {
        to._l = from._l;
      }
      if (!isUndefined(from._strict)) {
        to._strict = from._strict;
      }
      if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
      }
      if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
      }
      if (!isUndefined(from._offset)) {
        to._offset = from._offset;
      }
      if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
      }
      if (!isUndefined(from._locale)) {
        to._locale = from._locale;
      }
      if (momentPropertiesLen > 0) {
        for (i = 0; i < momentPropertiesLen; i++) {
          prop = momentProperties[i];
          val = from[prop];
          if (!isUndefined(val)) {
            to[prop] = val;
          }
        }
      }
      return to;
    }
    function Moment(config) {
      copyConfig(this, config);
      this._d = new Date(config._d != null ? config._d.getTime() : NaN);
      if (!this.isValid()) {
        this._d = new Date(NaN);
      }
      if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
      }
    }
    function isMoment(obj) {
      return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
      if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
        console.warn('Deprecation warning: ' + msg);
      }
    }
    function deprecate(msg, fn) {
      var firstTime = true;
      return extend(function () {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
          var args = [],
            arg,
            i,
            key,
            argLen = arguments.length;
          for (i = 0; i < argLen; i++) {
            arg = '';
            if (typeof arguments[i] === 'object') {
              arg += '\n[' + i + '] ';
              for (key in arguments[0]) {
                if (hasOwnProp(arguments[0], key)) {
                  arg += key + ': ' + arguments[0][key] + ', ';
                }
              }
              arg = arg.slice(0, -2);
            } else {
              arg = arguments[i];
            }
            args.push(arg);
          }
          warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
          firstTime = false;
        }
        return fn.apply(this, arguments);
      }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
      }
      if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
      }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
      return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
      var prop, i;
      for (i in config) {
        if (hasOwnProp(config, i)) {
          prop = config[i];
          if (isFunction(prop)) {
            this[i] = prop;
          } else {
            this['_' + i] = prop;
          }
        }
      }
      this._config = config;
      this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
      var res = extend({}, parentConfig),
        prop;
      for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
          if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
            res[prop] = {};
            extend(res[prop], parentConfig[prop]);
            extend(res[prop], childConfig[prop]);
          } else if (childConfig[prop] != null) {
            res[prop] = childConfig[prop];
          } else {
            delete res[prop];
          }
        }
      }
      for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
          res[prop] = extend({}, res[prop]);
        }
      }
      return res;
    }
    function Locale(config) {
      if (config != null) {
        this.set(config);
      }
    }
    var keys;
    if (Object.keys) {
      keys = Object.keys;
    } else {
      keys = function keys(obj) {
        var i,
          res = [];
        for (i in obj) {
          if (hasOwnProp(obj, i)) {
            res.push(i);
          }
        }
        return res;
      };
    }
    var defaultCalendar = {
      sameDay: '[Today at] LT',
      nextDay: '[Tomorrow at] LT',
      nextWeek: 'dddd [at] LT',
      lastDay: '[Yesterday at] LT',
      lastWeek: '[Last] dddd [at] LT',
      sameElse: 'L'
    };
    function calendar(key, mom, now) {
      var output = this._calendar[key] || this._calendar['sameElse'];
      return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
      var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
      return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
      localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
      formatFunctions = {},
      formatTokenFunctions = {};
    function addFormatToken(token, padded, ordinal, callback) {
      var func = callback;
      if (typeof callback === 'string') {
        func = function func() {
          return this[callback]();
        };
      }
      if (token) {
        formatTokenFunctions[token] = func;
      }
      if (padded) {
        formatTokenFunctions[padded[0]] = function () {
          return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
      }
      if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
          return this.localeData().ordinal(func.apply(this, arguments), token);
        };
      }
    }
    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
      }
      return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
      var array = format.match(formattingTokens),
        i,
        length;
      for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
          array[i] = formatTokenFunctions[array[i]];
        } else {
          array[i] = removeFormattingTokens(array[i]);
        }
      }
      return function (mom) {
        var output = '',
          i;
        for (i = 0; i < length; i++) {
          output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
      };
    }
    function formatMoment(m, format) {
      if (!m.isValid()) {
        return m.localeData().invalidDate();
      }
      format = expandFormat(format, m.localeData());
      formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
      return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
      var i = 5;
      function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
      }
      localFormattingTokens.lastIndex = 0;
      while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
      }
      return format;
    }
    var defaultLongDateFormat = {
      LTS: 'h:mm:ss A',
      LT: 'h:mm A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
      var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];
      if (format || !formatUpper) {
        return format;
      }
      this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function (tok) {
        if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') {
          return tok.slice(1);
        }
        return tok;
      }).join('');
      return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
      return this._invalidDate;
    }
    var defaultOrdinal = '%d',
      defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
      return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      ss: '%d seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      w: 'a week',
      ww: '%d weeks',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
      var output = this._relativeTime[string];
      return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
      var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
      return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
      var lowerCase = unit.toLowerCase();
      aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
      return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
      var normalizedInput = {},
        normalizedProp,
        prop;
      for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
          normalizedProp = normalizeUnits(prop);
          if (normalizedProp) {
            normalizedInput[normalizedProp] = inputObject[prop];
          }
        }
      }
      return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
      priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
      var units = [],
        u;
      for (u in unitsObj) {
        if (hasOwnProp(unitsObj, u)) {
          units.push({
            unit: u,
            priority: priorities[u]
          });
        }
      }
      units.sort(function (a, b) {
        return a.priority - b.priority;
      });
      return units;
    }
    function isLeapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
      if (number < 0) {
        return Math.ceil(number) || 0;
      } else {
        return Math.floor(number);
      }
    }
    function toInt(argumentForCoercion) {
      var coercedNumber = +argumentForCoercion,
        value = 0;
      if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
      }
      return value;
    }
    function makeGetSet(unit, keepTime) {
      return function (value) {
        if (value != null) {
          set$1(this, unit, value);
          hooks.updateOffset(this, keepTime);
          return this;
        } else {
          return get(this, unit);
        }
      };
    }
    function get(mom, unit) {
      return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
      if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
          value = toInt(value);
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        } else {
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
      }
    }
    function stringGet(units) {
      units = normalizeUnits(units);
      if (isFunction(this[units])) {
        return this[units]();
      }
      return this;
    }
    function stringSet(units, value) {
      if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units),
          i,
          prioritizedLen = prioritized.length;
        for (i = 0; i < prioritizedLen; i++) {
          this[prioritized[i].unit](units[prioritized[i].unit]);
        }
      } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
          return this[units](value);
        }
      }
      return this;
    }
    var match1 = /\d/,
      match2 = /\d\d/,
      match3 = /\d{3}/,
      match4 = /\d{4}/,
      match6 = /[+-]?\d{6}/,
      match1to2 = /\d\d?/,
      match3to4 = /\d\d\d\d?/,
      match5to6 = /\d\d\d\d\d\d?/,
      match1to3 = /\d{1,3}/,
      match1to4 = /\d{1,4}/,
      match1to6 = /[+-]?\d{1,6}/,
      matchUnsigned = /\d+/,
      matchSigned = /[+-]?\d+/,
      matchOffset = /Z|[+-]\d\d:?\d\d/gi,
      matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
      matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
      matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
      regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
      regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return isStrict && strictRegex ? strictRegex : regex;
      };
    }
    function getParseRegexForToken(token, config) {
      if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
      }
      return regexes[token](config._strict, config._locale);
    }
    function unescapeFormat(s) {
      return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
      }));
    }
    function regexEscape(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    var tokens = {};
    function addParseToken(token, callback) {
      var i,
        func = callback,
        tokenLen;
      if (typeof token === 'string') {
        token = [token];
      }
      if (isNumber(callback)) {
        func = function func(input, array) {
          array[callback] = toInt(input);
        };
      }
      tokenLen = token.length;
      for (i = 0; i < tokenLen; i++) {
        tokens[token[i]] = func;
      }
    }
    function addWeekParseToken(token, callback) {
      addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
      });
    }
    function addTimeToArrayFromToken(token, input, config) {
      if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
      }
    }
    var YEAR = 0,
      MONTH = 1,
      DATE = 2,
      HOUR = 3,
      MINUTE = 4,
      SECOND = 5,
      MILLISECOND = 6,
      WEEK = 7,
      WEEKDAY = 8;
    function mod(n, x) {
      return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) {
      indexOf = Array.prototype.indexOf;
    } else {
      indexOf = function indexOf(o) {
        var i;
        for (i = 0; i < this.length; ++i) {
          if (this[i] === o) {
            return i;
          }
        }
        return -1;
      };
    }
    function daysInMonth(year, month) {
      if (isNaN(year) || isNaN(month)) {
        return NaN;
      }
      var modMonth = mod(month, 12);
      year += (month - modMonth) / 12;
      return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    addFormatToken('M', ['MM', 2], 'Mo', function () {
      return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function (format) {
      return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function (format) {
      return this.localeData().months(this, format);
    });
    addUnitAlias('month', 'M');
    addUnitPriority('month', 8);
    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
      return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
      return locale.monthsRegex(isStrict);
    });
    addParseToken(['M', 'MM'], function (input, array) {
      array[MONTH] = toInt(input) - 1;
    });
    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
      var month = config._locale.monthsParse(input, token, config._strict);
      if (month != null) {
        array[MONTH] = month;
      } else {
        getParsingFlags(config).invalidMonth = input;
      }
    });
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
      defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
      defaultMonthsShortRegex = matchWord,
      defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
      if (!m) {
        return isArray(this._months) ? this._months : this._months['standalone'];
      }
      return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
      if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
      }
      return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
      var i,
        ii,
        mom,
        llc = monthName.toLocaleLowerCase();
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
          mom = createUTC([2000, i]);
          this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
          this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeMonthsParse(monthName, format, strict) {
      var i, mom, regex;
      if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
      }
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
      }
      for (i = 0; i < 12; i++) {
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
          this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
          this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
          regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
          this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
          return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
          return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
          return i;
        }
      }
    }
    function setMonth(mom, value) {
      var dayOfMonth;
      if (!mom.isValid()) {
        return mom;
      }
      if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
          value = toInt(value);
        } else {
          value = mom.localeData().monthsParse(value);
          if (!isNumber(value)) {
            return mom;
          }
        }
      }
      dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
      mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
      return mom;
    }
    function getSetMonth(value) {
      if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
      } else {
        return get(this, 'Month');
      }
    }
    function getDaysInMonth() {
      return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsShortStrictRegex;
        } else {
          return this._monthsShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
          this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
      }
    }
    function monthsRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsStrictRegex;
        } else {
          return this._monthsRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
          this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
      }
    }
    function computeMonthsParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom;
      for (i = 0; i < 12; i++) {
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
      }
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
      }
      for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
      }
      this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._monthsShortRegex = this._monthsRegex;
      this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    addFormatToken('Y', 0, 0, function () {
      var y = this.year();
      return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, ['YY', 2], 0, function () {
      return this.year() % 100;
    });
    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
    addUnitAlias('year', 'y');
    addUnitPriority('year', 1);
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
      array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
      array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
      array[YEAR] = parseInt(input, 10);
    });
    function daysInYear(year) {
      return isLeapYear(year) ? 366 : 365;
    }
    hooks.parseTwoDigitYear = function (input) {
      return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
      return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
      var date;
      if (y < 100 && y >= 0) {
        date = new Date(y + 400, m, d, h, M, s, ms);
        if (isFinite(date.getFullYear())) {
          date.setFullYear(y);
        }
      } else {
        date = new Date(y, m, d, h, M, s, ms);
      }
      return date;
    }
    function createUTCDate(y) {
      var date, args;
      if (y < 100 && y >= 0) {
        args = Array.prototype.slice.call(arguments);
        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));
        if (isFinite(date.getUTCFullYear())) {
          date.setUTCFullYear(y);
        }
      } else {
        date = new Date(Date.UTC.apply(null, arguments));
      }
      return date;
    }
    function firstWeekOffset(year, dow, doy) {
      var fwd = 7 + dow - doy,
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
      return -fwdlw + fwd - 1;
    }
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
      var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear,
        resDayOfYear;
      if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
      } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
      } else {
        resYear = year;
        resDayOfYear = dayOfYear;
      }
      return {
        year: resYear,
        dayOfYear: resDayOfYear
      };
    }
    function weekOfYear(mom, dow, doy) {
      var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek,
        resYear;
      if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
      } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
      } else {
        resYear = mom.year();
        resWeek = week;
      }
      return {
        week: resWeek,
        year: resYear
      };
    }
    function weeksInYear(year, dow, doy) {
      var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
      return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');
    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);
    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
      week[token.substr(0, 1)] = toInt(input);
    });
    function localeWeek(mom) {
      return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
      dow: 0,
      doy: 6
    };
    function localeFirstDayOfWeek() {
      return this._week.dow;
    }
    function localeFirstDayOfYear() {
      return this._week.doy;
    }
    function getSetWeek(input) {
      var week = this.localeData().week(this);
      return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
      var week = weekOfYear(this, 1, 4).week;
      return input == null ? week : this.add((input - week) * 7, 'd');
    }
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function (format) {
      return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function (format) {
      return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function (format) {
      return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
      return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
      return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
      return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
      var weekday = config._locale.weekdaysParse(input, token, config._strict);
      if (weekday != null) {
        week.d = weekday;
      } else {
        getParsingFlags(config).invalidWeekday = input;
      }
    });
    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
      week[token] = toInt(input);
    });
    function parseWeekday(input, locale) {
      if (typeof input !== 'string') {
        return input;
      }
      if (!isNaN(input)) {
        return parseInt(input, 10);
      }
      input = locale.weekdaysParse(input);
      if (typeof input === 'number') {
        return input;
      }
      return null;
    }
    function parseIsoWeekday(input, locale) {
      if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
      }
      return isNaN(input) ? null : input;
    }
    function shiftWeekdays(ws, n) {
      return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      defaultWeekdaysRegex = matchWord,
      defaultWeekdaysShortRegex = matchWord,
      defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
      var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
      return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
      return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
      return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
      var i,
        ii,
        mom,
        llc = weekdayName.toLocaleLowerCase();
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];
        for (i = 0; i < 7; ++i) {
          mom = createUTC([2000, 1]).day(i);
          this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
          this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
          this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
      var i, mom, regex;
      if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
      }
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
      }
      for (i = 0; i < 7; i++) {
        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
          this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
          this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
          this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
          regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
          this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
          return i;
        }
      }
    }
    function getSetDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
      if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
      } else {
        return day;
      }
    }
    function getSetLocaleDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
      } else {
        return this.day() || 7;
      }
    }
    function weekdaysRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysStrictRegex;
        } else {
          return this._weekdaysRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
      }
    }
    function weekdaysShortRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysShortStrictRegex;
        } else {
          return this._weekdaysShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
          this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
      }
    }
    function weekdaysMinRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysMinStrictRegex;
        } else {
          return this._weekdaysMinRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
          this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
      }
    }
    function computeWeekdaysParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var minPieces = [],
        shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        minp,
        shortp,
        longp;
      for (i = 0; i < 7; i++) {
        mom = createUTC([2000, 1]).day(i);
        minp = regexEscape(this.weekdaysMin(mom, ''));
        shortp = regexEscape(this.weekdaysShort(mom, ''));
        longp = regexEscape(this.weekdays(mom, ''));
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
      }
      minPieces.sort(cmpLenRev);
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._weekdaysShortRegex = this._weekdaysRegex;
      this._weekdaysMinRegex = this._weekdaysRegex;
      this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
      this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    function hFormat() {
      return this.hours() % 12 || 12;
    }
    function kFormat() {
      return this.hours() || 24;
    }
    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);
    addFormatToken('hmm', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
      addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
      });
    }
    meridiem('a', true);
    meridiem('A', false);
    addUnitAlias('hour', 'h');
    addUnitPriority('hour', 13);
    function matchMeridiem(isStrict, locale) {
      return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
      var kInput = toInt(input);
      array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
      config._isPm = config._locale.isPM(input);
      config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
      array[HOUR] = toInt(input);
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
    });
    function localeIsPM(input) {
      return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
      getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? 'pm' : 'PM';
      } else {
        return isLower ? 'am' : 'AM';
      }
    }
    var baseConfig = {
      calendar: defaultCalendar,
      longDateFormat: defaultLongDateFormat,
      invalidDate: defaultInvalidDate,
      ordinal: defaultOrdinal,
      dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
      relativeTime: defaultRelativeTime,
      months: defaultLocaleMonths,
      monthsShort: defaultLocaleMonthsShort,
      week: defaultLocaleWeek,
      weekdays: defaultLocaleWeekdays,
      weekdaysMin: defaultLocaleWeekdaysMin,
      weekdaysShort: defaultLocaleWeekdaysShort,
      meridiemParse: defaultLocaleMeridiemParse
    };
    var locales = {},
      localeFamilies = {},
      globalLocale;
    function commonPrefix(arr1, arr2) {
      var i,
        minl = Math.min(arr1.length, arr2.length);
      for (i = 0; i < minl; i += 1) {
        if (arr1[i] !== arr2[i]) {
          return i;
        }
      }
      return minl;
    }
    function normalizeLocale(key) {
      return key ? key.toLowerCase().replace('_', '-') : key;
    }
    function chooseLocale(names) {
      var i = 0,
        j,
        next,
        locale,
        split;
      while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
          locale = loadLocale(split.slice(0, j).join('-'));
          if (locale) {
            return locale;
          }
          if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
            break;
          }
          j--;
        }
        i++;
      }
      return globalLocale;
    }
    function isLocaleNameSane(name) {
      return name.match('^[^/\\\\]*$') != null;
    }
    function loadLocale(name) {
      var oldLocale = null,
        aliasedRequire;
      if (locales[name] === undefined && 'object' !== 'undefined' && module && module.exports && isLocaleNameSane(name)) {
        try {
          oldLocale = globalLocale._abbr;
          aliasedRequire = commonjsRequire$1$1$1$1;
          aliasedRequire('./locale/' + name);
          getSetGlobalLocale(oldLocale);
        } catch (e) {
          locales[name] = null;
        }
      }
      return locales[name];
    }
    function getSetGlobalLocale(key, values) {
      var data;
      if (key) {
        if (isUndefined(values)) {
          data = getLocale(key);
        } else {
          data = defineLocale(key, values);
        }
        if (data) {
          globalLocale = data;
        } else {
          if (typeof console !== 'undefined' && console.warn) {
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
          }
        }
      }
      return globalLocale._abbr;
    }
    function defineLocale(name, config) {
      if (config !== null) {
        var locale,
          parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
          deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
          parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
          if (locales[config.parentLocale] != null) {
            parentConfig = locales[config.parentLocale]._config;
          } else {
            locale = loadLocale(config.parentLocale);
            if (locale != null) {
              parentConfig = locale._config;
            } else {
              if (!localeFamilies[config.parentLocale]) {
                localeFamilies[config.parentLocale] = [];
              }
              localeFamilies[config.parentLocale].push({
                name: name,
                config: config
              });
              return null;
            }
          }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));
        if (localeFamilies[name]) {
          localeFamilies[name].forEach(function (x) {
            defineLocale(x.name, x.config);
          });
        }
        getSetGlobalLocale(name);
        return locales[name];
      } else {
        delete locales[name];
        return null;
      }
    }
    function updateLocale(name, config) {
      if (config != null) {
        var locale,
          tmpLocale,
          parentConfig = baseConfig;
        if (locales[name] != null && locales[name].parentLocale != null) {
          locales[name].set(mergeConfigs(locales[name]._config, config));
        } else {
          tmpLocale = loadLocale(name);
          if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
          }
          config = mergeConfigs(parentConfig, config);
          if (tmpLocale == null) {
            config.abbr = name;
          }
          locale = new Locale(config);
          locale.parentLocale = locales[name];
          locales[name] = locale;
        }
        getSetGlobalLocale(name);
      } else {
        if (locales[name] != null) {
          if (locales[name].parentLocale != null) {
            locales[name] = locales[name].parentLocale;
            if (name === getSetGlobalLocale()) {
              getSetGlobalLocale(name);
            }
          } else if (locales[name] != null) {
            delete locales[name];
          }
        }
      }
      return locales[name];
    }
    function getLocale(key) {
      var locale;
      if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
      }
      if (!key) {
        return globalLocale;
      }
      if (!isArray(key)) {
        locale = loadLocale(key);
        if (locale) {
          return locale;
        }
        key = [key];
      }
      return chooseLocale(key);
    }
    function listLocales() {
      return keys(locales);
    }
    function checkOverflow(m) {
      var overflow,
        a = m._a;
      if (a && getParsingFlags(m).overflow === -2) {
        overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
          overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
          overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
          overflow = WEEKDAY;
        }
        getParsingFlags(m).overflow = overflow;
      }
      return m;
    }
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
      isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/], ['YYYYMM', /\d{6}/, false], ['YYYY', /\d{4}/, false]],
      isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]],
      aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
      rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
      obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
      };
    function configFromISO(config) {
      var i,
        l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime,
        dateFormat,
        timeFormat,
        tzFormat,
        isoDatesLen = isoDates.length,
        isoTimesLen = isoTimes.length;
      if (match) {
        getParsingFlags(config).iso = true;
        for (i = 0, l = isoDatesLen; i < l; i++) {
          if (isoDates[i][1].exec(match[1])) {
            dateFormat = isoDates[i][0];
            allowTime = isoDates[i][2] !== false;
            break;
          }
        }
        if (dateFormat == null) {
          config._isValid = false;
          return;
        }
        if (match[3]) {
          for (i = 0, l = isoTimesLen; i < l; i++) {
            if (isoTimes[i][1].exec(match[3])) {
              timeFormat = (match[2] || ' ') + isoTimes[i][0];
              break;
            }
          }
          if (timeFormat == null) {
            config._isValid = false;
            return;
          }
        }
        if (!allowTime && timeFormat != null) {
          config._isValid = false;
          return;
        }
        if (match[4]) {
          if (tzRegex.exec(match[4])) {
            tzFormat = 'Z';
          } else {
            config._isValid = false;
            return;
          }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
      } else {
        config._isValid = false;
      }
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
      var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];
      if (secondStr) {
        result.push(parseInt(secondStr, 10));
      }
      return result;
    }
    function untruncateYear(yearStr) {
      var year = parseInt(yearStr, 10);
      if (year <= 49) {
        return 2000 + year;
      } else if (year <= 999) {
        return 1900 + year;
      }
      return year;
    }
    function preprocessRFC2822(s) {
      return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
      if (weekdayStr) {
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
          weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
          getParsingFlags(config).weekdayMismatch = true;
          config._isValid = false;
          return false;
        }
      }
      return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
      if (obsOffset) {
        return obsOffsets[obsOffset];
      } else if (militaryOffset) {
        return 0;
      } else {
        var hm = parseInt(numOffset, 10),
          m = hm % 100,
          h = (hm - m) / 100;
        return h * 60 + m;
      }
    }
    function configFromRFC2822(config) {
      var match = rfc2822.exec(preprocessRFC2822(config._i)),
        parsedArray;
      if (match) {
        parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
          return;
        }
        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);
        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        getParsingFlags(config).rfc2822 = true;
      } else {
        config._isValid = false;
      }
    }
    function configFromString(config) {
      var matched = aspNetJsonRegex.exec(config._i);
      if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
      }
      configFromISO(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      configFromRFC2822(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      if (config._strict) {
        config._isValid = false;
      } else {
        hooks.createFromInputFallback(config);
      }
    }
    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
      config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    function defaults(a, b, c) {
      if (a != null) {
        return a;
      }
      if (b != null) {
        return b;
      }
      return c;
    }
    function currentDateArray(config) {
      var nowValue = new Date(hooks.now());
      if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
      }
      return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }
    function configFromArray(config) {
      var i,
        date,
        input = [],
        currentDate,
        expectedWeekday,
        yearToUse;
      if (config._d) {
        return;
      }
      currentDate = currentDateArray(config);
      if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
      }
      if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
          getParsingFlags(config)._overflowDayOfYear = true;
        }
        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
      }
      for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
      }
      for (; i < 7; i++) {
        config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
      }
      if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
      }
      config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
      expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
      if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
      }
      if (config._nextDay) {
        config._a[HOUR] = 24;
      }
      if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
      }
    }
    function dayOfYearFromWeekInfo(config) {
      var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
      w = config._w;
      if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
          weekdayOverflow = true;
        }
      } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;
        curWeek = weekOfYear(createLocal(), dow, doy);
        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
        week = defaults(w.w, curWeek.week);
        if (w.d != null) {
          weekday = w.d;
          if (weekday < 0 || weekday > 6) {
            weekdayOverflow = true;
          }
        } else if (w.e != null) {
          weekday = w.e + dow;
          if (w.e < 0 || w.e > 6) {
            weekdayOverflow = true;
          }
        } else {
          weekday = dow;
        }
      }
      if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
      } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
      } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
      }
    }
    hooks.ISO_8601 = function () {};
    hooks.RFC_2822 = function () {};
    function configFromStringAndFormat(config) {
      if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
      }
      if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
      }
      config._a = [];
      getParsingFlags(config).empty = true;
      var string = '' + config._i,
        i,
        parsedInput,
        tokens,
        token,
        skipped,
        stringLength = string.length,
        totalParsedInputLength = 0,
        era,
        tokenLen;
      tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
      tokenLen = tokens.length;
      for (i = 0; i < tokenLen; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        if (parsedInput) {
          skipped = string.substr(0, string.indexOf(parsedInput));
          if (skipped.length > 0) {
            getParsingFlags(config).unusedInput.push(skipped);
          }
          string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
          totalParsedInputLength += parsedInput.length;
        }
        if (formatTokenFunctions[token]) {
          if (parsedInput) {
            getParsingFlags(config).empty = false;
          } else {
            getParsingFlags(config).unusedTokens.push(token);
          }
          addTimeToArrayFromToken(token, parsedInput, config);
        } else if (config._strict && !parsedInput) {
          getParsingFlags(config).unusedTokens.push(token);
        }
      }
      getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
      if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
      }
      if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
      }
      getParsingFlags(config).parsedDateParts = config._a.slice(0);
      getParsingFlags(config).meridiem = config._meridiem;
      config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
      era = getParsingFlags(config).era;
      if (era !== null) {
        config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
      }
      configFromArray(config);
      checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
      var isPm;
      if (meridiem == null) {
        return hour;
      }
      if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
      } else if (locale.isPM != null) {
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
          hour += 12;
        }
        if (!isPm && hour === 12) {
          hour = 0;
        }
        return hour;
      } else {
        return hour;
      }
    }
    function configFromStringAndArray(config) {
      var tempConfig,
        bestMoment,
        scoreToBeat,
        i,
        currentScore,
        validFormatFound,
        bestFormatIsValid = false,
        configfLen = config._f.length;
      if (configfLen === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
      }
      for (i = 0; i < configfLen; i++) {
        currentScore = 0;
        validFormatFound = false;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
          tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);
        if (isValid(tempConfig)) {
          validFormatFound = true;
        }
        currentScore += getParsingFlags(tempConfig).charsLeftOver;
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
        getParsingFlags(tempConfig).score = currentScore;
        if (!bestFormatIsValid) {
          if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
            if (validFormatFound) {
              bestFormatIsValid = true;
            }
          }
        } else {
          if (currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
          }
        }
      }
      extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
      if (config._d) {
        return;
      }
      var i = normalizeObjectUnits(config._i),
        dayOrDate = i.day === undefined ? i.date : i.day;
      config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
      });
      configFromArray(config);
    }
    function createFromConfig(config) {
      var res = new Moment(checkOverflow(prepareConfig(config)));
      if (res._nextDay) {
        res.add(1, 'd');
        res._nextDay = undefined;
      }
      return res;
    }
    function prepareConfig(config) {
      var input = config._i,
        format = config._f;
      config._locale = config._locale || getLocale(config._l);
      if (input === null || format === undefined && input === '') {
        return createInvalid({
          nullInput: true
        });
      }
      if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
      }
      if (isMoment(input)) {
        return new Moment(checkOverflow(input));
      } else if (isDate(input)) {
        config._d = input;
      } else if (isArray(format)) {
        configFromStringAndArray(config);
      } else if (format) {
        configFromStringAndFormat(config);
      } else {
        configFromInput(config);
      }
      if (!isValid(config)) {
        config._d = null;
      }
      return config;
    }
    function configFromInput(config) {
      var input = config._i;
      if (isUndefined(input)) {
        config._d = new Date(hooks.now());
      } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
      } else if (typeof input === 'string') {
        configFromString(config);
      } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
          return parseInt(obj, 10);
        });
        configFromArray(config);
      } else if (isObject(input)) {
        configFromObject(config);
      } else if (isNumber(input)) {
        config._d = new Date(input);
      } else {
        hooks.createFromInputFallback(config);
      }
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
      var c = {};
      if (format === true || format === false) {
        strict = format;
        format = undefined;
      }
      if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
      }
      if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
        input = undefined;
      }
      c._isAMomentObject = true;
      c._useUTC = c._isUTC = isUTC;
      c._l = locale;
      c._i = input;
      c._f = format;
      c._strict = strict;
      return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other < this ? this : other;
        } else {
          return createInvalid();
        }
      }),
      prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other > this ? this : other;
        } else {
          return createInvalid();
        }
      });
    function pickBy(fn, moments) {
      var res, i;
      if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
      }
      if (!moments.length) {
        return createLocal();
      }
      res = moments[0];
      for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
          res = moments[i];
        }
      }
      return res;
    }
    function min() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isBefore', args);
    }
    function max() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isAfter', args);
    }
    var now = function now() {
      return Date.now ? Date.now() : +new Date();
    };
    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
    function isDurationValid(m) {
      var key,
        unitHasDecimal = false,
        i,
        orderLen = ordering.length;
      for (key in m) {
        if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
          return false;
        }
      }
      for (i = 0; i < orderLen; ++i) {
        if (m[ordering[i]]) {
          if (unitHasDecimal) {
            return false;
          }
          if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
            unitHasDecimal = true;
          }
        }
      }
      return true;
    }
    function isValid$1() {
      return this._isValid;
    }
    function createInvalid$1() {
      return createDuration(NaN);
    }
    function Duration(duration) {
      var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;
      this._isValid = isDurationValid(normalizedInput);
      this._milliseconds = +milliseconds + seconds * 1e3 + minutes * 6e4 + hours * 1000 * 60 * 60;
      this._days = +days + weeks * 7;
      this._months = +months + quarters * 3 + years * 12;
      this._data = {};
      this._locale = getLocale();
      this._bubble();
    }
    function isDuration(obj) {
      return obj instanceof Duration;
    }
    function absRound(number) {
      if (number < 0) {
        return Math.round(-1 * number) * -1;
      } else {
        return Math.round(number);
      }
    }
    function compareArrays(array1, array2, dontConvert) {
      var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
      for (i = 0; i < len; i++) {
        if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
          diffs++;
        }
      }
      return diffs + lengthDiff;
    }
    function offset(token, separator) {
      addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset(),
          sign = '+';
        if (offset < 0) {
          offset = -offset;
          sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
      });
    }
    offset('Z', ':');
    offset('ZZ', '');
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
      config._useUTC = true;
      config._tzm = offsetFromString(matchShortOffset, input);
    });
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
      var matches = (string || '').match(matcher),
        chunk,
        parts,
        minutes;
      if (matches === null) {
        return null;
      }
      chunk = matches[matches.length - 1] || [];
      parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
      minutes = +(parts[1] * 60) + toInt(parts[2]);
      return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    function cloneWithOffset(input, model) {
      var res, diff;
      if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
      } else {
        return createLocal(input).local();
      }
    }
    function getDateOffset(m) {
      return -Math.round(m._d.getTimezoneOffset());
    }
    hooks.updateOffset = function () {};
    function getSetOffset(input, keepLocalTime, keepMinutes) {
      var offset = this._offset || 0,
        localAdjust;
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        if (typeof input === 'string') {
          input = offsetFromString(matchShortOffset, input);
          if (input === null) {
            return this;
          }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
          input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
          localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
          this.add(localAdjust, 'm');
        }
        if (offset !== input) {
          if (!keepLocalTime || this._changeInProgress) {
            addSubtract(this, createDuration(input - offset, 'm'), 1, false);
          } else if (!this._changeInProgress) {
            this._changeInProgress = true;
            hooks.updateOffset(this, true);
            this._changeInProgress = null;
          }
        }
        return this;
      } else {
        return this._isUTC ? offset : getDateOffset(this);
      }
    }
    function getSetZone(input, keepLocalTime) {
      if (input != null) {
        if (typeof input !== 'string') {
          input = -input;
        }
        this.utcOffset(input, keepLocalTime);
        return this;
      } else {
        return -this.utcOffset();
      }
    }
    function setOffsetToUTC(keepLocalTime) {
      return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
      if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;
        if (keepLocalTime) {
          this.subtract(getDateOffset(this), 'm');
        }
      }
      return this;
    }
    function setOffsetToParsedOffset() {
      if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
      } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
          this.utcOffset(tZone);
        } else {
          this.utcOffset(0, true);
        }
      }
      return this;
    }
    function hasAlignedHourOffset(input) {
      if (!this.isValid()) {
        return false;
      }
      input = input ? createLocal(input).utcOffset() : 0;
      return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
      return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
      if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
      }
      var c = {},
        other;
      copyConfig(c, this);
      c = prepareConfig(c);
      if (c._a) {
        other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
      } else {
        this._isDSTShifted = false;
      }
      return this._isDSTShifted;
    }
    function isLocal() {
      return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
      return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
      isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
      var duration = input,
        match = null,
        sign,
        ret,
        diffRes;
      if (isDuration(input)) {
        duration = {
          ms: input._milliseconds,
          d: input._days,
          M: input._months
        };
      } else if (isNumber(input) || !isNaN(+input)) {
        duration = {};
        if (key) {
          duration[key] = +input;
        } else {
          duration.milliseconds = +input;
        }
      } else if (match = aspNetRegex.exec(input)) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: 0,
          d: toInt(match[DATE]) * sign,
          h: toInt(match[HOUR]) * sign,
          m: toInt(match[MINUTE]) * sign,
          s: toInt(match[SECOND]) * sign,
          ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
        };
      } else if (match = isoRegex.exec(input)) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: parseIso(match[2], sign),
          M: parseIso(match[3], sign),
          w: parseIso(match[4], sign),
          d: parseIso(match[5], sign),
          h: parseIso(match[6], sign),
          m: parseIso(match[7], sign),
          s: parseIso(match[8], sign)
        };
      } else if (duration == null) {
        duration = {};
      } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
      }
      ret = new Duration(duration);
      if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
      }
      if (isDuration(input) && hasOwnProp(input, '_isValid')) {
        ret._isValid = input._isValid;
      }
      return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
      var res = inp && parseFloat(inp.replace(',', '.'));
      return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
      var res = {};
      res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
      if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
      }
      res.milliseconds = +other - +base.clone().add(res.months, 'M');
      return res;
    }
    function momentsDifference(base, other) {
      var res;
      if (!(base.isValid() && other.isValid())) {
        return {
          milliseconds: 0,
          months: 0
        };
      }
      other = cloneWithOffset(other, base);
      if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
      } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
      }
      return res;
    }
    function createAdder(direction, name) {
      return function (val, period) {
        var dur, tmp;
        if (period !== null && !isNaN(+period)) {
          deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
          tmp = val;
          val = period;
          period = tmp;
        }
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
      };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
      var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);
      if (!mom.isValid()) {
        return;
      }
      updateOffset = updateOffset == null ? true : updateOffset;
      if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
      }
      if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
      }
      if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
      }
      if (updateOffset) {
        hooks.updateOffset(mom, days || months);
      }
    }
    var add = createAdder(1, 'add'),
      subtract = createAdder(-1, 'subtract');
    function isString(input) {
      return typeof input === 'string' || input instanceof String;
    }
    function isMomentInput(input) {
      return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['years', 'year', 'y', 'months', 'month', 'M', 'days', 'day', 'd', 'dates', 'date', 'D', 'hours', 'hour', 'h', 'minutes', 'minute', 'm', 'seconds', 'second', 's', 'milliseconds', 'millisecond', 'ms'],
        i,
        property,
        propertyLen = properties.length;
      for (i = 0; i < propertyLen; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
      var arrayTest = isArray(input),
        dataTypeTest = false;
      if (arrayTest) {
        dataTypeTest = input.filter(function (item) {
          return !isNumber(item) && isString(input);
        }).length === 0;
      }
      return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'],
        i,
        property;
      for (i = 0; i < properties.length; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
      var diff = myMoment.diff(now, 'days', true);
      return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
      if (arguments.length === 1) {
        if (!arguments[0]) {
          time = undefined;
          formats = undefined;
        } else if (isMomentInput(arguments[0])) {
          time = arguments[0];
          formats = undefined;
        } else if (isCalendarSpec(arguments[0])) {
          formats = arguments[0];
          time = undefined;
        }
      }
      var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse',
        output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
      return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
      return new Moment(this);
    }
    function isAfter(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
      } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
      }
    }
    function isBefore(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
      } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
      }
    }
    function isBetween(from, to, units, inclusivity) {
      var localFrom = isMoment(from) ? from : createLocal(from),
        localTo = isMoment(to) ? to : createLocal(to);
      if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
      }
      inclusivity = inclusivity || '()';
      return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
      } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
      }
    }
    function isSameOrAfter(input, units) {
      return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
      return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
      var that, zoneDelta, output;
      if (!this.isValid()) {
        return NaN;
      }
      that = cloneWithOffset(input, this);
      if (!that.isValid()) {
        return NaN;
      }
      zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
      units = normalizeUnits(units);
      switch (units) {
        case 'year':
          output = monthDiff(this, that) / 12;
          break;
        case 'month':
          output = monthDiff(this, that);
          break;
        case 'quarter':
          output = monthDiff(this, that) / 3;
          break;
        case 'second':
          output = (this - that) / 1e3;
          break;
        case 'minute':
          output = (this - that) / 6e4;
          break;
        case 'hour':
          output = (this - that) / 36e5;
          break;
        case 'day':
          output = (this - that - zoneDelta) / 864e5;
          break;
        case 'week':
          output = (this - that - zoneDelta) / 6048e5;
          break;
        default:
          output = this - that;
      }
      return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
      if (a.date() < b.date()) {
        return -monthDiff(b, a);
      }
      var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2,
        adjust;
      if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        adjust = (b - anchor) / (anchor - anchor2);
      } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        adjust = (b - anchor) / (anchor2 - anchor);
      }
      return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
      return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
      if (!this.isValid()) {
        return null;
      }
      var utc = keepOffset !== true,
        m = utc ? this.clone().utc() : this;
      if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
      }
      if (isFunction(Date.prototype.toISOString)) {
        if (utc) {
          return this.toDate().toISOString();
        } else {
          return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
      }
      return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    function inspect() {
      if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
      }
      var func = 'moment',
        zone = '',
        prefix,
        year,
        datetime,
        suffix;
      if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
      }
      prefix = '[' + func + '("]';
      year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
      datetime = '-MM-DD[T]HH:mm:ss.SSS';
      suffix = zone + '[")]';
      return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
      if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
      }
      var output = formatMoment(this, inputString);
      return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          to: this,
          from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function fromNow(withoutSuffix) {
      return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          from: this,
          to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function toNow(withoutSuffix) {
      return this.to(createLocal(), withoutSuffix);
    }
    function locale(key) {
      var newLocaleData;
      if (key === undefined) {
        return this._locale._abbr;
      } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
          this._locale = newLocaleData;
        }
        return this;
      }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
      if (key === undefined) {
        return this.localeData();
      } else {
        return this.locale(key);
      }
    });
    function localeData() {
      return this._locale;
    }
    var MS_PER_SECOND = 1000,
      MS_PER_MINUTE = 60 * MS_PER_SECOND,
      MS_PER_HOUR = 60 * MS_PER_MINUTE,
      MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
    function mod$1(dividend, divisor) {
      return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return new Date(y, m, d).valueOf();
      }
    }
    function utcStartOfDate(y, m, d) {
      if (y < 100 && y >= 0) {
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return Date.UTC(y, m, d);
      }
    }
    function startOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case 'year':
          time = startOfDate(this.year(), 0, 1);
          break;
        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
          break;
        case 'month':
          time = startOfDate(this.year(), this.month(), 1);
          break;
        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
          break;
        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
          break;
        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date());
          break;
        case 'hour':
          time = this._d.valueOf();
          time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
          break;
        case 'minute':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_MINUTE);
          break;
        case 'second':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_SECOND);
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function endOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case 'year':
          time = startOfDate(this.year() + 1, 0, 1) - 1;
          break;
        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
          break;
        case 'month':
          time = startOfDate(this.year(), this.month() + 1, 1) - 1;
          break;
        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
          break;
        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
          break;
        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
          break;
        case 'hour':
          time = this._d.valueOf();
          time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
          break;
        case 'minute':
          time = this._d.valueOf();
          time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
          break;
        case 'second':
          time = this._d.valueOf();
          time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function valueOf() {
      return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
      return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
      return new Date(this.valueOf());
    }
    function toArray() {
      var m = this;
      return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }
    function toObject() {
      var m = this;
      return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
      };
    }
    function toJSON() {
      return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
      return isValid(this);
    }
    function parsingFlags() {
      return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
      return getParsingFlags(this).overflow;
    }
    function creationData() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (input, array, config, token) {
      var era = config._locale.erasParse(input, token, config._strict);
      if (era) {
        getParsingFlags(config).era = era;
      } else {
        getParsingFlags(config).invalidEra = input;
      }
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
      var match;
      if (config._locale._eraYearOrdinalRegex) {
        match = input.match(config._locale._eraYearOrdinalRegex);
      }
      if (config._locale.eraYearOrdinalParse) {
        array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
      } else {
        array[YEAR] = parseInt(input, 10);
      }
    });
    function localeEras(m, format) {
      var i,
        l,
        date,
        eras = this._eras || getLocale('en')._eras;
      for (i = 0, l = eras.length; i < l; ++i) {
        switch (typeof eras[i].since) {
          case 'string':
            date = hooks(eras[i].since).startOf('day');
            eras[i].since = date.valueOf();
            break;
        }
        switch (typeof eras[i].until) {
          case 'undefined':
            eras[i].until = +Infinity;
            break;
          case 'string':
            date = hooks(eras[i].until).startOf('day').valueOf();
            eras[i].until = date.valueOf();
            break;
        }
      }
      return eras;
    }
    function localeErasParse(eraName, format, strict) {
      var i,
        l,
        eras = this.eras(),
        name,
        abbr,
        narrow;
      eraName = eraName.toUpperCase();
      for (i = 0, l = eras.length; i < l; ++i) {
        name = eras[i].name.toUpperCase();
        abbr = eras[i].abbr.toUpperCase();
        narrow = eras[i].narrow.toUpperCase();
        if (strict) {
          switch (format) {
            case 'N':
            case 'NN':
            case 'NNN':
              if (abbr === eraName) {
                return eras[i];
              }
              break;
            case 'NNNN':
              if (name === eraName) {
                return eras[i];
              }
              break;
            case 'NNNNN':
              if (narrow === eraName) {
                return eras[i];
              }
              break;
          }
        } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
          return eras[i];
        }
      }
    }
    function localeErasConvertYear(era, year) {
      var dir = era.since <= era.until ? +1 : -1;
      if (year === undefined) {
        return hooks(era.since).year();
      } else {
        return hooks(era.since).year() + (year - era.offset) * dir;
      }
    }
    function getEraName() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].name;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].name;
        }
      }
      return '';
    }
    function getEraNarrow() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].narrow;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].narrow;
        }
      }
      return '';
    }
    function getEraAbbr() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].abbr;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].abbr;
        }
      }
      return '';
    }
    function getEraYear() {
      var i,
        l,
        dir,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        dir = eras[i].since <= eras[i].until ? +1 : -1;
        val = this.clone().startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
          return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
      }
      return this.year();
    }
    function erasNameRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNameRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
      if (!hasOwnProp(this, '_erasAbbrRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNarrowRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
      return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
      return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
      return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
      return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
      var abbrPieces = [],
        namePieces = [],
        narrowPieces = [],
        mixedPieces = [],
        i,
        l,
        eras = this.eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        namePieces.push(regexEscape(eras[i].name));
        abbrPieces.push(regexEscape(eras[i].abbr));
        narrowPieces.push(regexEscape(eras[i].narrow));
        mixedPieces.push(regexEscape(eras[i].name));
        mixedPieces.push(regexEscape(eras[i].abbr));
        mixedPieces.push(regexEscape(eras[i].narrow));
      }
      this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
      this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
      this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    addFormatToken(0, ['gg', 2], 0, function () {
      return this.weekYear() % 100;
    });
    addFormatToken(0, ['GG', 2], 0, function () {
      return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
      addFormatToken(0, [token, token.length], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');
    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
      week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
      week[token] = hooks.parseTwoDigitYear(input);
    });
    function getSetWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
      return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
      return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
      var weeksTarget;
      if (input == null) {
        return weekOfYear(this, dow, doy).year;
      } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
          week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
      }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
      var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
      this.year(date.getUTCFullYear());
      this.month(date.getUTCMonth());
      this.date(date.getUTCDate());
      return this;
    }
    addFormatToken('Q', 0, 'Qo', 'quarter');
    addUnitAlias('quarter', 'Q');
    addUnitPriority('quarter', 7);
    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
      array[MONTH] = (toInt(input) - 1) * 3;
    });
    function getSetQuarter(input) {
      return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    addFormatToken('D', ['DD', 2], 'Do', 'date');
    addUnitAlias('date', 'D');
    addUnitPriority('date', 9);
    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
      return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
      array[DATE] = toInt(input.match(match1to2)[0]);
    });
    var getSetDayOfMonth = makeGetSet('Date', true);
    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
    addUnitAlias('dayOfYear', 'DDD');
    addUnitPriority('dayOfYear', 4);
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
      config._dayOfYear = toInt(input);
    });
    function getSetDayOfYear(input) {
      var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
      return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    addFormatToken('m', ['mm', 2], 0, 'minute');
    addUnitAlias('minute', 'm');
    addUnitPriority('minute', 14);
    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);
    var getSetMinute = makeGetSet('Minutes', false);
    addFormatToken('s', ['ss', 2], 0, 'second');
    addUnitAlias('second', 's');
    addUnitPriority('second', 15);
    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);
    var getSetSecond = makeGetSet('Seconds', false);
    addFormatToken('S', 0, 0, function () {
      return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, ['SS', 2], 0, function () {
      return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
      return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
      return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
      return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
      return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
      return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
      return this.millisecond() * 1000000;
    });
    addUnitAlias('millisecond', 'ms');
    addUnitPriority('millisecond', 16);
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
      addRegexToken(token, matchUnsigned);
    }
    function parseMs(input, array) {
      array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for (token = 'S'; token.length <= 9; token += 'S') {
      addParseToken(token, parseMs);
    }
    getSetMillisecond = makeGetSet('Milliseconds', false);
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    function getZoneAbbr() {
      return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
      return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol["for"] != null) {
      proto[Symbol["for"]('nodejs.util.inspect.custom')] = function () {
        return 'Moment<' + this.format() + '>';
      };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
      return createLocal(input * 1000);
    }
    function createInZone() {
      return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
      return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
      var locale = getLocale(),
        utc = createUTC().set(setter, index);
      return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }
      format = format || '';
      if (index != null) {
        return get$1(format, index, field, 'month');
      }
      var i,
        out = [];
      for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
      }
      return out;
    }
    function listWeekdaysImpl(localeSorted, format, index, field) {
      if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }
        format = format || '';
      } else {
        format = localeSorted;
        index = format;
        localeSorted = false;
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }
        format = format || '';
      }
      var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0,
        i,
        out = [];
      if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
      }
      for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
      }
      return out;
    }
    function listMonths(format, index) {
      return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
      return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
      eras: [{
        since: '0001-01-01',
        until: +Infinity,
        offset: 1,
        name: 'Anno Domini',
        narrow: 'AD',
        abbr: 'AD'
      }, {
        since: '0000-12-31',
        until: -Infinity,
        offset: 1,
        name: 'Before Christ',
        narrow: 'BC',
        abbr: 'BC'
      }],
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function ordinal(number) {
        var b = number % 10,
          output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        return number + output;
      }
    });
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
      var data = this._data;
      this._milliseconds = mathAbs(this._milliseconds);
      this._days = mathAbs(this._days);
      this._months = mathAbs(this._months);
      data.milliseconds = mathAbs(data.milliseconds);
      data.seconds = mathAbs(data.seconds);
      data.minutes = mathAbs(data.minutes);
      data.hours = mathAbs(data.hours);
      data.months = mathAbs(data.months);
      data.years = mathAbs(data.years);
      return this;
    }
    function addSubtract$1(duration, input, value, direction) {
      var other = createDuration(input, value);
      duration._milliseconds += direction * other._milliseconds;
      duration._days += direction * other._days;
      duration._months += direction * other._months;
      return duration._bubble();
    }
    function add$1(input, value) {
      return addSubtract$1(this, input, value, 1);
    }
    function subtract$1(input, value) {
      return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
      if (number < 0) {
        return Math.floor(number);
      } else {
        return Math.ceil(number);
      }
    }
    function bubble() {
      var milliseconds = this._milliseconds,
        days = this._days,
        months = this._months,
        data = this._data,
        seconds,
        minutes,
        hours,
        years,
        monthsFromDays;
      if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
      }
      data.milliseconds = milliseconds % 1000;
      seconds = absFloor(milliseconds / 1000);
      data.seconds = seconds % 60;
      minutes = absFloor(seconds / 60);
      data.minutes = minutes % 60;
      hours = absFloor(minutes / 60);
      data.hours = hours % 24;
      days += absFloor(hours / 24);
      monthsFromDays = absFloor(daysToMonths(days));
      months += monthsFromDays;
      days -= absCeil(monthsToDays(monthsFromDays));
      years = absFloor(months / 12);
      months %= 12;
      data.days = days;
      data.months = months;
      data.years = years;
      return this;
    }
    function daysToMonths(days) {
      return days * 4800 / 146097;
    }
    function monthsToDays(months) {
      return months * 146097 / 4800;
    }
    function as(units) {
      if (!this.isValid()) {
        return NaN;
      }
      var days,
        months,
        milliseconds = this._milliseconds;
      units = normalizeUnits(units);
      if (units === 'month' || units === 'quarter' || units === 'year') {
        days = this._days + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        switch (units) {
          case 'month':
            return months;
          case 'quarter':
            return months / 3;
          case 'year':
            return months / 12;
        }
      } else {
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
          case 'week':
            return days / 7 + milliseconds / 6048e5;
          case 'day':
            return days + milliseconds / 864e5;
          case 'hour':
            return days * 24 + milliseconds / 36e5;
          case 'minute':
            return days * 1440 + milliseconds / 6e4;
          case 'second':
            return days * 86400 + milliseconds / 1000;
          case 'millisecond':
            return Math.floor(days * 864e5) + milliseconds;
          default:
            throw new Error('Unknown unit ' + units);
        }
      }
    }
    function valueOf$1() {
      if (!this.isValid()) {
        return NaN;
      }
      return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
      return function () {
        return this.as(alias);
      };
    }
    var asMilliseconds = makeAs('ms'),
      asSeconds = makeAs('s'),
      asMinutes = makeAs('m'),
      asHours = makeAs('h'),
      asDays = makeAs('d'),
      asWeeks = makeAs('w'),
      asMonths = makeAs('M'),
      asQuarters = makeAs('Q'),
      asYears = makeAs('y');
    function clone$1() {
      return createDuration(this);
    }
    function get$2(units) {
      units = normalizeUnits(units);
      return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
      return function () {
        return this.isValid() ? this._data[name] : NaN;
      };
    }
    var milliseconds = makeGetter('milliseconds'),
      seconds = makeGetter('seconds'),
      minutes = makeGetter('minutes'),
      hours = makeGetter('hours'),
      days = makeGetter('days'),
      months = makeGetter('months'),
      years = makeGetter('years');
    function weeks() {
      return absFloor(this.days() / 7);
    }
    var round = Math.round,
      thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
      };
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
      return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
      var duration = createDuration(posNegDuration).abs(),
        seconds = round(duration.as('s')),
        minutes = round(duration.as('m')),
        hours = round(duration.as('h')),
        days = round(duration.as('d')),
        months = round(duration.as('M')),
        weeks = round(duration.as('w')),
        years = round(duration.as('y')),
        a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days];
      if (thresholds.w != null) {
        a = a || weeks <= 1 && ['w'] || weeks < thresholds.w && ['ww', weeks];
      }
      a = a || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
      a[2] = withoutSuffix;
      a[3] = +posNegDuration > 0;
      a[4] = locale;
      return substituteTimeAgo.apply(null, a);
    }
    function getSetRelativeTimeRounding(roundingFunction) {
      if (roundingFunction === undefined) {
        return round;
      }
      if (typeof roundingFunction === 'function') {
        round = roundingFunction;
        return true;
      }
      return false;
    }
    function getSetRelativeTimeThreshold(threshold, limit) {
      if (thresholds[threshold] === undefined) {
        return false;
      }
      if (limit === undefined) {
        return thresholds[threshold];
      }
      thresholds[threshold] = limit;
      if (threshold === 's') {
        thresholds.ss = limit - 1;
      }
      return true;
    }
    function humanize(argWithSuffix, argThresholds) {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var withSuffix = false,
        th = thresholds,
        locale,
        output;
      if (typeof argWithSuffix === 'object') {
        argThresholds = argWithSuffix;
        argWithSuffix = false;
      }
      if (typeof argWithSuffix === 'boolean') {
        withSuffix = argWithSuffix;
      }
      if (typeof argThresholds === 'object') {
        th = Object.assign({}, thresholds, argThresholds);
        if (argThresholds.s != null && argThresholds.ss == null) {
          th.ss = argThresholds.s - 1;
        }
      }
      locale = this.localeData();
      output = relativeTime$1(this, !withSuffix, th, locale);
      if (withSuffix) {
        output = locale.pastFuture(+this, output);
      }
      return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
      return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var seconds = abs$1(this._milliseconds) / 1000,
        days = abs$1(this._days),
        months = abs$1(this._months),
        minutes,
        hours,
        years,
        s,
        total = this.asSeconds(),
        totalSign,
        ymSign,
        daysSign,
        hmsSign;
      if (!total) {
        return 'P0D';
      }
      minutes = absFloor(seconds / 60);
      hours = absFloor(minutes / 60);
      seconds %= 60;
      minutes %= 60;
      years = absFloor(months / 12);
      months %= 12;
      s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
      totalSign = total < 0 ? '-' : '';
      ymSign = sign(this._months) !== sign(total) ? '-' : '';
      daysSign = sign(this._days) !== sign(total) ? '-' : '';
      hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
      return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
      config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
      config._d = new Date(toInt(input));
    });
    hooks.version = '2.29.4';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    hooks.HTML5_FMT = {
      DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
      DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
      DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
      DATE: 'YYYY-MM-DD',
      TIME: 'HH:mm',
      TIME_SECONDS: 'HH:mm:ss',
      TIME_MS: 'HH:mm:ss.SSS',
      WEEK: 'GGGG-[W]WW',
      MONTH: 'YYYY-MM'
    };
    return hooks;
  });
});
var Chart$1$1$1$1 = createCommonjsModule$1$1$1$1(function (module, exports) {
  (function (global, factory) {
    module.exports = factory(function () {
      try {
        return moment$1$1$1$1;
      } catch (e) {}
    }());
  })(commonjsGlobal$1$1$1$1, function (moment) {
    moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
    function createCommonjsModule(fn, module) {
      return module = {
        exports: {}
      }, fn(module, module.exports), module.exports;
    }
    function getCjsExportFromNamespace(n) {
      return n && n['default'] || n;
    }
    var colorName = {
      "aliceblue": [240, 248, 255],
      "antiquewhite": [250, 235, 215],
      "aqua": [0, 255, 255],
      "aquamarine": [127, 255, 212],
      "azure": [240, 255, 255],
      "beige": [245, 245, 220],
      "bisque": [255, 228, 196],
      "black": [0, 0, 0],
      "blanchedalmond": [255, 235, 205],
      "blue": [0, 0, 255],
      "blueviolet": [138, 43, 226],
      "brown": [165, 42, 42],
      "burlywood": [222, 184, 135],
      "cadetblue": [95, 158, 160],
      "chartreuse": [127, 255, 0],
      "chocolate": [210, 105, 30],
      "coral": [255, 127, 80],
      "cornflowerblue": [100, 149, 237],
      "cornsilk": [255, 248, 220],
      "crimson": [220, 20, 60],
      "cyan": [0, 255, 255],
      "darkblue": [0, 0, 139],
      "darkcyan": [0, 139, 139],
      "darkgoldenrod": [184, 134, 11],
      "darkgray": [169, 169, 169],
      "darkgreen": [0, 100, 0],
      "darkgrey": [169, 169, 169],
      "darkkhaki": [189, 183, 107],
      "darkmagenta": [139, 0, 139],
      "darkolivegreen": [85, 107, 47],
      "darkorange": [255, 140, 0],
      "darkorchid": [153, 50, 204],
      "darkred": [139, 0, 0],
      "darksalmon": [233, 150, 122],
      "darkseagreen": [143, 188, 143],
      "darkslateblue": [72, 61, 139],
      "darkslategray": [47, 79, 79],
      "darkslategrey": [47, 79, 79],
      "darkturquoise": [0, 206, 209],
      "darkviolet": [148, 0, 211],
      "deeppink": [255, 20, 147],
      "deepskyblue": [0, 191, 255],
      "dimgray": [105, 105, 105],
      "dimgrey": [105, 105, 105],
      "dodgerblue": [30, 144, 255],
      "firebrick": [178, 34, 34],
      "floralwhite": [255, 250, 240],
      "forestgreen": [34, 139, 34],
      "fuchsia": [255, 0, 255],
      "gainsboro": [220, 220, 220],
      "ghostwhite": [248, 248, 255],
      "gold": [255, 215, 0],
      "goldenrod": [218, 165, 32],
      "gray": [128, 128, 128],
      "green": [0, 128, 0],
      "greenyellow": [173, 255, 47],
      "grey": [128, 128, 128],
      "honeydew": [240, 255, 240],
      "hotpink": [255, 105, 180],
      "indianred": [205, 92, 92],
      "indigo": [75, 0, 130],
      "ivory": [255, 255, 240],
      "khaki": [240, 230, 140],
      "lavender": [230, 230, 250],
      "lavenderblush": [255, 240, 245],
      "lawngreen": [124, 252, 0],
      "lemonchiffon": [255, 250, 205],
      "lightblue": [173, 216, 230],
      "lightcoral": [240, 128, 128],
      "lightcyan": [224, 255, 255],
      "lightgoldenrodyellow": [250, 250, 210],
      "lightgray": [211, 211, 211],
      "lightgreen": [144, 238, 144],
      "lightgrey": [211, 211, 211],
      "lightpink": [255, 182, 193],
      "lightsalmon": [255, 160, 122],
      "lightseagreen": [32, 178, 170],
      "lightskyblue": [135, 206, 250],
      "lightslategray": [119, 136, 153],
      "lightslategrey": [119, 136, 153],
      "lightsteelblue": [176, 196, 222],
      "lightyellow": [255, 255, 224],
      "lime": [0, 255, 0],
      "limegreen": [50, 205, 50],
      "linen": [250, 240, 230],
      "magenta": [255, 0, 255],
      "maroon": [128, 0, 0],
      "mediumaquamarine": [102, 205, 170],
      "mediumblue": [0, 0, 205],
      "mediumorchid": [186, 85, 211],
      "mediumpurple": [147, 112, 219],
      "mediumseagreen": [60, 179, 113],
      "mediumslateblue": [123, 104, 238],
      "mediumspringgreen": [0, 250, 154],
      "mediumturquoise": [72, 209, 204],
      "mediumvioletred": [199, 21, 133],
      "midnightblue": [25, 25, 112],
      "mintcream": [245, 255, 250],
      "mistyrose": [255, 228, 225],
      "moccasin": [255, 228, 181],
      "navajowhite": [255, 222, 173],
      "navy": [0, 0, 128],
      "oldlace": [253, 245, 230],
      "olive": [128, 128, 0],
      "olivedrab": [107, 142, 35],
      "orange": [255, 165, 0],
      "orangered": [255, 69, 0],
      "orchid": [218, 112, 214],
      "palegoldenrod": [238, 232, 170],
      "palegreen": [152, 251, 152],
      "paleturquoise": [175, 238, 238],
      "palevioletred": [219, 112, 147],
      "papayawhip": [255, 239, 213],
      "peachpuff": [255, 218, 185],
      "peru": [205, 133, 63],
      "pink": [255, 192, 203],
      "plum": [221, 160, 221],
      "powderblue": [176, 224, 230],
      "purple": [128, 0, 128],
      "rebeccapurple": [102, 51, 153],
      "red": [255, 0, 0],
      "rosybrown": [188, 143, 143],
      "royalblue": [65, 105, 225],
      "saddlebrown": [139, 69, 19],
      "salmon": [250, 128, 114],
      "sandybrown": [244, 164, 96],
      "seagreen": [46, 139, 87],
      "seashell": [255, 245, 238],
      "sienna": [160, 82, 45],
      "silver": [192, 192, 192],
      "skyblue": [135, 206, 235],
      "slateblue": [106, 90, 205],
      "slategray": [112, 128, 144],
      "slategrey": [112, 128, 144],
      "snow": [255, 250, 250],
      "springgreen": [0, 255, 127],
      "steelblue": [70, 130, 180],
      "tan": [210, 180, 140],
      "teal": [0, 128, 128],
      "thistle": [216, 191, 216],
      "tomato": [255, 99, 71],
      "turquoise": [64, 224, 208],
      "violet": [238, 130, 238],
      "wheat": [245, 222, 179],
      "white": [255, 255, 255],
      "whitesmoke": [245, 245, 245],
      "yellow": [255, 255, 0],
      "yellowgreen": [154, 205, 50]
    };
    var conversions = createCommonjsModule(function (module) {
      var reverseKeywords = {};
      for (var key in colorName) {
        if (colorName.hasOwnProperty(key)) {
          reverseKeywords[colorName[key]] = key;
        }
      }
      var convert = module.exports = {
        rgb: {
          channels: 3,
          labels: 'rgb'
        },
        hsl: {
          channels: 3,
          labels: 'hsl'
        },
        hsv: {
          channels: 3,
          labels: 'hsv'
        },
        hwb: {
          channels: 3,
          labels: 'hwb'
        },
        cmyk: {
          channels: 4,
          labels: 'cmyk'
        },
        xyz: {
          channels: 3,
          labels: 'xyz'
        },
        lab: {
          channels: 3,
          labels: 'lab'
        },
        lch: {
          channels: 3,
          labels: 'lch'
        },
        hex: {
          channels: 1,
          labels: ['hex']
        },
        keyword: {
          channels: 1,
          labels: ['keyword']
        },
        ansi16: {
          channels: 1,
          labels: ['ansi16']
        },
        ansi256: {
          channels: 1,
          labels: ['ansi256']
        },
        hcg: {
          channels: 3,
          labels: ['h', 'c', 'g']
        },
        apple: {
          channels: 3,
          labels: ['r16', 'g16', 'b16']
        },
        gray: {
          channels: 1,
          labels: ['gray']
        }
      };
      for (var model in convert) {
        if (convert.hasOwnProperty(model)) {
          if (!('channels' in convert[model])) {
            throw new Error('missing channels property: ' + model);
          }
          if (!('labels' in convert[model])) {
            throw new Error('missing channel labels property: ' + model);
          }
          if (convert[model].labels.length !== convert[model].channels) {
            throw new Error('channel and label counts mismatch: ' + model);
          }
          var channels = convert[model].channels;
          var labels = convert[model].labels;
          delete convert[model].channels;
          delete convert[model].labels;
          Object.defineProperty(convert[model], 'channels', {
            value: channels
          });
          Object.defineProperty(convert[model], 'labels', {
            value: labels
          });
        }
      }
      convert.rgb.hsl = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var delta = max - min;
        var h;
        var s;
        var l;
        if (max === min) {
          h = 0;
        } else if (r === max) {
          h = (g - b) / delta;
        } else if (g === max) {
          h = 2 + (b - r) / delta;
        } else if (b === max) {
          h = 4 + (r - g) / delta;
        }
        h = Math.min(h * 60, 360);
        if (h < 0) {
          h += 360;
        }
        l = (min + max) / 2;
        if (max === min) {
          s = 0;
        } else if (l <= 0.5) {
          s = delta / (max + min);
        } else {
          s = delta / (2 - max - min);
        }
        return [h, s * 100, l * 100];
      };
      convert.rgb.hsv = function (rgb) {
        var rdif;
        var gdif;
        var bdif;
        var h;
        var s;
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var v = Math.max(r, g, b);
        var diff = v - Math.min(r, g, b);
        var diffc = function diffc(c) {
          return (v - c) / 6 / diff + 1 / 2;
        };
        if (diff === 0) {
          h = s = 0;
        } else {
          s = diff / v;
          rdif = diffc(r);
          gdif = diffc(g);
          bdif = diffc(b);
          if (r === v) {
            h = bdif - gdif;
          } else if (g === v) {
            h = 1 / 3 + rdif - bdif;
          } else if (b === v) {
            h = 2 / 3 + gdif - rdif;
          }
          if (h < 0) {
            h += 1;
          } else if (h > 1) {
            h -= 1;
          }
        }
        return [h * 360, s * 100, v * 100];
      };
      convert.rgb.hwb = function (rgb) {
        var r = rgb[0];
        var g = rgb[1];
        var b = rgb[2];
        var h = convert.rgb.hsl(rgb)[0];
        var w = 1 / 255 * Math.min(r, Math.min(g, b));
        b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
        return [h, w * 100, b * 100];
      };
      convert.rgb.cmyk = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var c;
        var m;
        var y;
        var k;
        k = Math.min(1 - r, 1 - g, 1 - b);
        c = (1 - r - k) / (1 - k) || 0;
        m = (1 - g - k) / (1 - k) || 0;
        y = (1 - b - k) / (1 - k) || 0;
        return [c * 100, m * 100, y * 100, k * 100];
      };
      function comparativeDistance(x, y) {
        return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
      }
      convert.rgb.keyword = function (rgb) {
        var reversed = reverseKeywords[rgb];
        if (reversed) {
          return reversed;
        }
        var currentClosestDistance = Infinity;
        var currentClosestKeyword;
        for (var keyword in colorName) {
          if (colorName.hasOwnProperty(keyword)) {
            var value = colorName[keyword];
            var distance = comparativeDistance(rgb, value);
            if (distance < currentClosestDistance) {
              currentClosestDistance = distance;
              currentClosestKeyword = keyword;
            }
          }
        }
        return currentClosestKeyword;
      };
      convert.keyword.rgb = function (keyword) {
        return colorName[keyword];
      };
      convert.rgb.xyz = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
        g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
        b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
        var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
        var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
        var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
        return [x * 100, y * 100, z * 100];
      };
      convert.rgb.lab = function (rgb) {
        var xyz = convert.rgb.xyz(rgb);
        var x = xyz[0];
        var y = xyz[1];
        var z = xyz[2];
        var l;
        var a;
        var b;
        x /= 95.047;
        y /= 100;
        z /= 108.883;
        x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
        l = 116 * y - 16;
        a = 500 * (x - y);
        b = 200 * (y - z);
        return [l, a, b];
      };
      convert.hsl.rgb = function (hsl) {
        var h = hsl[0] / 360;
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var t1;
        var t2;
        var t3;
        var rgb;
        var val;
        if (s === 0) {
          val = l * 255;
          return [val, val, val];
        }
        if (l < 0.5) {
          t2 = l * (1 + s);
        } else {
          t2 = l + s - l * s;
        }
        t1 = 2 * l - t2;
        rgb = [0, 0, 0];
        for (var i = 0; i < 3; i++) {
          t3 = h + 1 / 3 * -(i - 1);
          if (t3 < 0) {
            t3++;
          }
          if (t3 > 1) {
            t3--;
          }
          if (6 * t3 < 1) {
            val = t1 + (t2 - t1) * 6 * t3;
          } else if (2 * t3 < 1) {
            val = t2;
          } else if (3 * t3 < 2) {
            val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
          } else {
            val = t1;
          }
          rgb[i] = val * 255;
        }
        return rgb;
      };
      convert.hsl.hsv = function (hsl) {
        var h = hsl[0];
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var smin = s;
        var lmin = Math.max(l, 0.01);
        var sv;
        var v;
        l *= 2;
        s *= l <= 1 ? l : 2 - l;
        smin *= lmin <= 1 ? lmin : 2 - lmin;
        v = (l + s) / 2;
        sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
        return [h, sv * 100, v * 100];
      };
      convert.hsv.rgb = function (hsv) {
        var h = hsv[0] / 60;
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var hi = Math.floor(h) % 6;
        var f = h - Math.floor(h);
        var p = 255 * v * (1 - s);
        var q = 255 * v * (1 - s * f);
        var t = 255 * v * (1 - s * (1 - f));
        v *= 255;
        switch (hi) {
          case 0:
            return [v, t, p];
          case 1:
            return [q, v, p];
          case 2:
            return [p, v, t];
          case 3:
            return [p, q, v];
          case 4:
            return [t, p, v];
          case 5:
            return [v, p, q];
        }
      };
      convert.hsv.hsl = function (hsv) {
        var h = hsv[0];
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var vmin = Math.max(v, 0.01);
        var lmin;
        var sl;
        var l;
        l = (2 - s) * v;
        lmin = (2 - s) * vmin;
        sl = s * vmin;
        sl /= lmin <= 1 ? lmin : 2 - lmin;
        sl = sl || 0;
        l /= 2;
        return [h, sl * 100, l * 100];
      };
      convert.hwb.rgb = function (hwb) {
        var h = hwb[0] / 360;
        var wh = hwb[1] / 100;
        var bl = hwb[2] / 100;
        var ratio = wh + bl;
        var i;
        var v;
        var f;
        var n;
        if (ratio > 1) {
          wh /= ratio;
          bl /= ratio;
        }
        i = Math.floor(6 * h);
        v = 1 - bl;
        f = 6 * h - i;
        if ((i & 0x01) !== 0) {
          f = 1 - f;
        }
        n = wh + f * (v - wh);
        var r;
        var g;
        var b;
        switch (i) {
          default:
          case 6:
          case 0:
            r = v;
            g = n;
            b = wh;
            break;
          case 1:
            r = n;
            g = v;
            b = wh;
            break;
          case 2:
            r = wh;
            g = v;
            b = n;
            break;
          case 3:
            r = wh;
            g = n;
            b = v;
            break;
          case 4:
            r = n;
            g = wh;
            b = v;
            break;
          case 5:
            r = v;
            g = wh;
            b = n;
            break;
        }
        return [r * 255, g * 255, b * 255];
      };
      convert.cmyk.rgb = function (cmyk) {
        var c = cmyk[0] / 100;
        var m = cmyk[1] / 100;
        var y = cmyk[2] / 100;
        var k = cmyk[3] / 100;
        var r;
        var g;
        var b;
        r = 1 - Math.min(1, c * (1 - k) + k);
        g = 1 - Math.min(1, m * (1 - k) + k);
        b = 1 - Math.min(1, y * (1 - k) + k);
        return [r * 255, g * 255, b * 255];
      };
      convert.xyz.rgb = function (xyz) {
        var x = xyz[0] / 100;
        var y = xyz[1] / 100;
        var z = xyz[2] / 100;
        var r;
        var g;
        var b;
        r = x * 3.2406 + y * -1.5372 + z * -0.4986;
        g = x * -0.9689 + y * 1.8758 + z * 0.0415;
        b = x * 0.0557 + y * -0.2040 + z * 1.0570;
        r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
        g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
        b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
        r = Math.min(Math.max(0, r), 1);
        g = Math.min(Math.max(0, g), 1);
        b = Math.min(Math.max(0, b), 1);
        return [r * 255, g * 255, b * 255];
      };
      convert.xyz.lab = function (xyz) {
        var x = xyz[0];
        var y = xyz[1];
        var z = xyz[2];
        var l;
        var a;
        var b;
        x /= 95.047;
        y /= 100;
        z /= 108.883;
        x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
        l = 116 * y - 16;
        a = 500 * (x - y);
        b = 200 * (y - z);
        return [l, a, b];
      };
      convert.lab.xyz = function (lab) {
        var l = lab[0];
        var a = lab[1];
        var b = lab[2];
        var x;
        var y;
        var z;
        y = (l + 16) / 116;
        x = a / 500 + y;
        z = y - b / 200;
        var y2 = Math.pow(y, 3);
        var x2 = Math.pow(x, 3);
        var z2 = Math.pow(z, 3);
        y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
        x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
        z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
        x *= 95.047;
        y *= 100;
        z *= 108.883;
        return [x, y, z];
      };
      convert.lab.lch = function (lab) {
        var l = lab[0];
        var a = lab[1];
        var b = lab[2];
        var hr;
        var h;
        var c;
        hr = Math.atan2(b, a);
        h = hr * 360 / 2 / Math.PI;
        if (h < 0) {
          h += 360;
        }
        c = Math.sqrt(a * a + b * b);
        return [l, c, h];
      };
      convert.lch.lab = function (lch) {
        var l = lch[0];
        var c = lch[1];
        var h = lch[2];
        var a;
        var b;
        var hr;
        hr = h / 360 * 2 * Math.PI;
        a = c * Math.cos(hr);
        b = c * Math.sin(hr);
        return [l, a, b];
      };
      convert.rgb.ansi16 = function (args) {
        var r = args[0];
        var g = args[1];
        var b = args[2];
        var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2];
        value = Math.round(value / 50);
        if (value === 0) {
          return 30;
        }
        var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
        if (value === 2) {
          ansi += 60;
        }
        return ansi;
      };
      convert.hsv.ansi16 = function (args) {
        return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
      };
      convert.rgb.ansi256 = function (args) {
        var r = args[0];
        var g = args[1];
        var b = args[2];
        if (r === g && g === b) {
          if (r < 8) {
            return 16;
          }
          if (r > 248) {
            return 231;
          }
          return Math.round((r - 8) / 247 * 24) + 232;
        }
        var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
        return ansi;
      };
      convert.ansi16.rgb = function (args) {
        var color = args % 10;
        if (color === 0 || color === 7) {
          if (args > 50) {
            color += 3.5;
          }
          color = color / 10.5 * 255;
          return [color, color, color];
        }
        var mult = (~~(args > 50) + 1) * 0.5;
        var r = (color & 1) * mult * 255;
        var g = (color >> 1 & 1) * mult * 255;
        var b = (color >> 2 & 1) * mult * 255;
        return [r, g, b];
      };
      convert.ansi256.rgb = function (args) {
        if (args >= 232) {
          var c = (args - 232) * 10 + 8;
          return [c, c, c];
        }
        args -= 16;
        var rem;
        var r = Math.floor(args / 36) / 5 * 255;
        var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
        var b = rem % 6 / 5 * 255;
        return [r, g, b];
      };
      convert.rgb.hex = function (args) {
        var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
        var string = integer.toString(16).toUpperCase();
        return '000000'.substring(string.length) + string;
      };
      convert.hex.rgb = function (args) {
        var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
        if (!match) {
          return [0, 0, 0];
        }
        var colorString = match[0];
        if (match[0].length === 3) {
          colorString = colorString.split('').map(function (_char) {
            return _char + _char;
          }).join('');
        }
        var integer = parseInt(colorString, 16);
        var r = integer >> 16 & 0xFF;
        var g = integer >> 8 & 0xFF;
        var b = integer & 0xFF;
        return [r, g, b];
      };
      convert.rgb.hcg = function (rgb) {
        var r = rgb[0] / 255;
        var g = rgb[1] / 255;
        var b = rgb[2] / 255;
        var max = Math.max(Math.max(r, g), b);
        var min = Math.min(Math.min(r, g), b);
        var chroma = max - min;
        var grayscale;
        var hue;
        if (chroma < 1) {
          grayscale = min / (1 - chroma);
        } else {
          grayscale = 0;
        }
        if (chroma <= 0) {
          hue = 0;
        } else if (max === r) {
          hue = (g - b) / chroma % 6;
        } else if (max === g) {
          hue = 2 + (b - r) / chroma;
        } else {
          hue = 4 + (r - g) / chroma + 4;
        }
        hue /= 6;
        hue %= 1;
        return [hue * 360, chroma * 100, grayscale * 100];
      };
      convert.hsl.hcg = function (hsl) {
        var s = hsl[1] / 100;
        var l = hsl[2] / 100;
        var c = 1;
        var f = 0;
        if (l < 0.5) {
          c = 2.0 * s * l;
        } else {
          c = 2.0 * s * (1.0 - l);
        }
        if (c < 1.0) {
          f = (l - 0.5 * c) / (1.0 - c);
        }
        return [hsl[0], c * 100, f * 100];
      };
      convert.hsv.hcg = function (hsv) {
        var s = hsv[1] / 100;
        var v = hsv[2] / 100;
        var c = s * v;
        var f = 0;
        if (c < 1.0) {
          f = (v - c) / (1 - c);
        }
        return [hsv[0], c * 100, f * 100];
      };
      convert.hcg.rgb = function (hcg) {
        var h = hcg[0] / 360;
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        if (c === 0.0) {
          return [g * 255, g * 255, g * 255];
        }
        var pure = [0, 0, 0];
        var hi = h % 1 * 6;
        var v = hi % 1;
        var w = 1 - v;
        var mg = 0;
        switch (Math.floor(hi)) {
          case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
          case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
          case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
          case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
          case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
          default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
        }
        mg = (1.0 - c) * g;
        return [(c * pure[0] + mg) * 255, (c * pure[1] + mg) * 255, (c * pure[2] + mg) * 255];
      };
      convert.hcg.hsv = function (hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var v = c + g * (1.0 - c);
        var f = 0;
        if (v > 0.0) {
          f = c / v;
        }
        return [hcg[0], f * 100, v * 100];
      };
      convert.hcg.hsl = function (hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var l = g * (1.0 - c) + 0.5 * c;
        var s = 0;
        if (l > 0.0 && l < 0.5) {
          s = c / (2 * l);
        } else if (l >= 0.5 && l < 1.0) {
          s = c / (2 * (1 - l));
        }
        return [hcg[0], s * 100, l * 100];
      };
      convert.hcg.hwb = function (hcg) {
        var c = hcg[1] / 100;
        var g = hcg[2] / 100;
        var v = c + g * (1.0 - c);
        return [hcg[0], (v - c) * 100, (1 - v) * 100];
      };
      convert.hwb.hcg = function (hwb) {
        var w = hwb[1] / 100;
        var b = hwb[2] / 100;
        var v = 1 - b;
        var c = v - w;
        var g = 0;
        if (c < 1) {
          g = (v - c) / (1 - c);
        }
        return [hwb[0], c * 100, g * 100];
      };
      convert.apple.rgb = function (apple) {
        return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
      };
      convert.rgb.apple = function (rgb) {
        return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
      };
      convert.gray.rgb = function (args) {
        return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
      };
      convert.gray.hsl = convert.gray.hsv = function (args) {
        return [0, 0, args[0]];
      };
      convert.gray.hwb = function (gray) {
        return [0, 100, gray[0]];
      };
      convert.gray.cmyk = function (gray) {
        return [0, 0, 0, gray[0]];
      };
      convert.gray.lab = function (gray) {
        return [gray[0], 0, 0];
      };
      convert.gray.hex = function (gray) {
        var val = Math.round(gray[0] / 100 * 255) & 0xFF;
        var integer = (val << 16) + (val << 8) + val;
        var string = integer.toString(16).toUpperCase();
        return '000000'.substring(string.length) + string;
      };
      convert.rgb.gray = function (rgb) {
        var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
        return [val / 255 * 100];
      };
    });
    function buildGraph() {
      var graph = {};
      var models = Object.keys(conversions);
      for (var len = models.length, i = 0; i < len; i++) {
        graph[models[i]] = {
          distance: -1,
          parent: null
        };
      }
      return graph;
    }
    function deriveBFS(fromModel) {
      var graph = buildGraph();
      var queue = [fromModel];
      graph[fromModel].distance = 0;
      while (queue.length) {
        var current = queue.pop();
        var adjacents = Object.keys(conversions[current]);
        for (var len = adjacents.length, i = 0; i < len; i++) {
          var adjacent = adjacents[i];
          var node = graph[adjacent];
          if (node.distance === -1) {
            node.distance = graph[current].distance + 1;
            node.parent = current;
            queue.unshift(adjacent);
          }
        }
      }
      return graph;
    }
    function link(from, to) {
      return function (args) {
        return to(from(args));
      };
    }
    function wrapConversion(toModel, graph) {
      var path = [graph[toModel].parent, toModel];
      var fn = conversions[graph[toModel].parent][toModel];
      var cur = graph[toModel].parent;
      while (graph[cur].parent) {
        path.unshift(graph[cur].parent);
        fn = link(conversions[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
      }
      fn.conversion = path;
      return fn;
    }
    var route = function route(fromModel) {
      var graph = deriveBFS(fromModel);
      var conversion = {};
      var models = Object.keys(graph);
      for (var len = models.length, i = 0; i < len; i++) {
        var toModel = models[i];
        var node = graph[toModel];
        if (node.parent === null) {
          continue;
        }
        conversion[toModel] = wrapConversion(toModel, graph);
      }
      return conversion;
    };
    var convert = {};
    var models = Object.keys(conversions);
    function wrapRaw(fn) {
      var wrappedFn = function wrappedFn(args) {
        if (args === undefined || args === null) {
          return args;
        }
        if (arguments.length > 1) {
          args = Array.prototype.slice.call(arguments);
        }
        return fn(args);
      };
      if ('conversion' in fn) {
        wrappedFn.conversion = fn.conversion;
      }
      return wrappedFn;
    }
    function wrapRounded(fn) {
      var wrappedFn = function wrappedFn(args) {
        if (args === undefined || args === null) {
          return args;
        }
        if (arguments.length > 1) {
          args = Array.prototype.slice.call(arguments);
        }
        var result = fn(args);
        if (typeof result === 'object') {
          for (var len = result.length, i = 0; i < len; i++) {
            result[i] = Math.round(result[i]);
          }
        }
        return result;
      };
      if ('conversion' in fn) {
        wrappedFn.conversion = fn.conversion;
      }
      return wrappedFn;
    }
    models.forEach(function (fromModel) {
      convert[fromModel] = {};
      Object.defineProperty(convert[fromModel], 'channels', {
        value: conversions[fromModel].channels
      });
      Object.defineProperty(convert[fromModel], 'labels', {
        value: conversions[fromModel].labels
      });
      var routes = route(fromModel);
      var routeModels = Object.keys(routes);
      routeModels.forEach(function (toModel) {
        var fn = routes[toModel];
        convert[fromModel][toModel] = wrapRounded(fn);
        convert[fromModel][toModel].raw = wrapRaw(fn);
      });
    });
    var colorConvert = convert;
    var colorName$1 = {
      "aliceblue": [240, 248, 255],
      "antiquewhite": [250, 235, 215],
      "aqua": [0, 255, 255],
      "aquamarine": [127, 255, 212],
      "azure": [240, 255, 255],
      "beige": [245, 245, 220],
      "bisque": [255, 228, 196],
      "black": [0, 0, 0],
      "blanchedalmond": [255, 235, 205],
      "blue": [0, 0, 255],
      "blueviolet": [138, 43, 226],
      "brown": [165, 42, 42],
      "burlywood": [222, 184, 135],
      "cadetblue": [95, 158, 160],
      "chartreuse": [127, 255, 0],
      "chocolate": [210, 105, 30],
      "coral": [255, 127, 80],
      "cornflowerblue": [100, 149, 237],
      "cornsilk": [255, 248, 220],
      "crimson": [220, 20, 60],
      "cyan": [0, 255, 255],
      "darkblue": [0, 0, 139],
      "darkcyan": [0, 139, 139],
      "darkgoldenrod": [184, 134, 11],
      "darkgray": [169, 169, 169],
      "darkgreen": [0, 100, 0],
      "darkgrey": [169, 169, 169],
      "darkkhaki": [189, 183, 107],
      "darkmagenta": [139, 0, 139],
      "darkolivegreen": [85, 107, 47],
      "darkorange": [255, 140, 0],
      "darkorchid": [153, 50, 204],
      "darkred": [139, 0, 0],
      "darksalmon": [233, 150, 122],
      "darkseagreen": [143, 188, 143],
      "darkslateblue": [72, 61, 139],
      "darkslategray": [47, 79, 79],
      "darkslategrey": [47, 79, 79],
      "darkturquoise": [0, 206, 209],
      "darkviolet": [148, 0, 211],
      "deeppink": [255, 20, 147],
      "deepskyblue": [0, 191, 255],
      "dimgray": [105, 105, 105],
      "dimgrey": [105, 105, 105],
      "dodgerblue": [30, 144, 255],
      "firebrick": [178, 34, 34],
      "floralwhite": [255, 250, 240],
      "forestgreen": [34, 139, 34],
      "fuchsia": [255, 0, 255],
      "gainsboro": [220, 220, 220],
      "ghostwhite": [248, 248, 255],
      "gold": [255, 215, 0],
      "goldenrod": [218, 165, 32],
      "gray": [128, 128, 128],
      "green": [0, 128, 0],
      "greenyellow": [173, 255, 47],
      "grey": [128, 128, 128],
      "honeydew": [240, 255, 240],
      "hotpink": [255, 105, 180],
      "indianred": [205, 92, 92],
      "indigo": [75, 0, 130],
      "ivory": [255, 255, 240],
      "khaki": [240, 230, 140],
      "lavender": [230, 230, 250],
      "lavenderblush": [255, 240, 245],
      "lawngreen": [124, 252, 0],
      "lemonchiffon": [255, 250, 205],
      "lightblue": [173, 216, 230],
      "lightcoral": [240, 128, 128],
      "lightcyan": [224, 255, 255],
      "lightgoldenrodyellow": [250, 250, 210],
      "lightgray": [211, 211, 211],
      "lightgreen": [144, 238, 144],
      "lightgrey": [211, 211, 211],
      "lightpink": [255, 182, 193],
      "lightsalmon": [255, 160, 122],
      "lightseagreen": [32, 178, 170],
      "lightskyblue": [135, 206, 250],
      "lightslategray": [119, 136, 153],
      "lightslategrey": [119, 136, 153],
      "lightsteelblue": [176, 196, 222],
      "lightyellow": [255, 255, 224],
      "lime": [0, 255, 0],
      "limegreen": [50, 205, 50],
      "linen": [250, 240, 230],
      "magenta": [255, 0, 255],
      "maroon": [128, 0, 0],
      "mediumaquamarine": [102, 205, 170],
      "mediumblue": [0, 0, 205],
      "mediumorchid": [186, 85, 211],
      "mediumpurple": [147, 112, 219],
      "mediumseagreen": [60, 179, 113],
      "mediumslateblue": [123, 104, 238],
      "mediumspringgreen": [0, 250, 154],
      "mediumturquoise": [72, 209, 204],
      "mediumvioletred": [199, 21, 133],
      "midnightblue": [25, 25, 112],
      "mintcream": [245, 255, 250],
      "mistyrose": [255, 228, 225],
      "moccasin": [255, 228, 181],
      "navajowhite": [255, 222, 173],
      "navy": [0, 0, 128],
      "oldlace": [253, 245, 230],
      "olive": [128, 128, 0],
      "olivedrab": [107, 142, 35],
      "orange": [255, 165, 0],
      "orangered": [255, 69, 0],
      "orchid": [218, 112, 214],
      "palegoldenrod": [238, 232, 170],
      "palegreen": [152, 251, 152],
      "paleturquoise": [175, 238, 238],
      "palevioletred": [219, 112, 147],
      "papayawhip": [255, 239, 213],
      "peachpuff": [255, 218, 185],
      "peru": [205, 133, 63],
      "pink": [255, 192, 203],
      "plum": [221, 160, 221],
      "powderblue": [176, 224, 230],
      "purple": [128, 0, 128],
      "rebeccapurple": [102, 51, 153],
      "red": [255, 0, 0],
      "rosybrown": [188, 143, 143],
      "royalblue": [65, 105, 225],
      "saddlebrown": [139, 69, 19],
      "salmon": [250, 128, 114],
      "sandybrown": [244, 164, 96],
      "seagreen": [46, 139, 87],
      "seashell": [255, 245, 238],
      "sienna": [160, 82, 45],
      "silver": [192, 192, 192],
      "skyblue": [135, 206, 235],
      "slateblue": [106, 90, 205],
      "slategray": [112, 128, 144],
      "slategrey": [112, 128, 144],
      "snow": [255, 250, 250],
      "springgreen": [0, 255, 127],
      "steelblue": [70, 130, 180],
      "tan": [210, 180, 140],
      "teal": [0, 128, 128],
      "thistle": [216, 191, 216],
      "tomato": [255, 99, 71],
      "turquoise": [64, 224, 208],
      "violet": [238, 130, 238],
      "wheat": [245, 222, 179],
      "white": [255, 255, 255],
      "whitesmoke": [245, 245, 245],
      "yellow": [255, 255, 0],
      "yellowgreen": [154, 205, 50]
    };
    var colorString = {
      getRgba: getRgba,
      getHsla: getHsla,
      getRgb: getRgb,
      getHsl: getHsl,
      getHwb: getHwb,
      getAlpha: getAlpha,
      hexString: hexString,
      rgbString: rgbString,
      rgbaString: rgbaString,
      percentString: percentString,
      percentaString: percentaString,
      hslString: hslString,
      hslaString: hslaString,
      hwbString: hwbString,
      keyword: keyword
    };
    function getRgba(string) {
      if (!string) {
        return;
      }
      var abbr = /^#([a-fA-F0-9]{3,4})$/i,
        hex = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
        rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
        per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
        keyword = /(\w+)/;
      var rgb = [0, 0, 0],
        a = 1,
        match = string.match(abbr),
        hexAlpha = "";
      if (match) {
        match = match[1];
        hexAlpha = match[3];
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = parseInt(match[i] + match[i], 16);
        }
        if (hexAlpha) {
          a = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
        }
      } else if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
        }
        if (hexAlpha) {
          a = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
        }
      } else if (match = string.match(rgba)) {
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = parseInt(match[i + 1]);
        }
        a = parseFloat(match[4]);
      } else if (match = string.match(per)) {
        for (var i = 0; i < rgb.length; i++) {
          rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        }
        a = parseFloat(match[4]);
      } else if (match = string.match(keyword)) {
        if (match[1] == "transparent") {
          return [0, 0, 0, 0];
        }
        rgb = colorName$1[match[1]];
        if (!rgb) {
          return;
        }
      }
      for (var i = 0; i < rgb.length; i++) {
        rgb[i] = scale(rgb[i], 0, 255);
      }
      if (!a && a != 0) {
        a = 1;
      } else {
        a = scale(a, 0, 1);
      }
      rgb[3] = a;
      return rgb;
    }
    function getHsla(string) {
      if (!string) {
        return;
      }
      var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
      var match = string.match(hsl);
      if (match) {
        var alpha = parseFloat(match[4]);
        var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [h, s, l, a];
      }
    }
    function getHwb(string) {
      if (!string) {
        return;
      }
      var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
      var match = string.match(hwb);
      if (match) {
        var alpha = parseFloat(match[4]);
        var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [h, w, b, a];
      }
    }
    function getRgb(string) {
      var rgba = getRgba(string);
      return rgba && rgba.slice(0, 3);
    }
    function getHsl(string) {
      var hsla = getHsla(string);
      return hsla && hsla.slice(0, 3);
    }
    function getAlpha(string) {
      var vals = getRgba(string);
      if (vals) {
        return vals[3];
      } else if (vals = getHsla(string)) {
        return vals[3];
      } else if (vals = getHwb(string)) {
        return vals[3];
      }
    }
    function hexString(rgba, a) {
      var a = a !== undefined && rgba.length === 3 ? a : rgba[3];
      return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (a >= 0 && a < 1 ? hexDouble(Math.round(a * 255)) : "");
    }
    function rgbString(rgba, alpha) {
      if (alpha < 1 || rgba[3] && rgba[3] < 1) {
        return rgbaString(rgba, alpha);
      }
      return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
    }
    function rgbaString(rgba, alpha) {
      if (alpha === undefined) {
        alpha = rgba[3] !== undefined ? rgba[3] : 1;
      }
      return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
    }
    function percentString(rgba, alpha) {
      if (alpha < 1 || rgba[3] && rgba[3] < 1) {
        return percentaString(rgba, alpha);
      }
      var r = Math.round(rgba[0] / 255 * 100),
        g = Math.round(rgba[1] / 255 * 100),
        b = Math.round(rgba[2] / 255 * 100);
      return "rgb(" + r + "%, " + g + "%, " + b + "%)";
    }
    function percentaString(rgba, alpha) {
      var r = Math.round(rgba[0] / 255 * 100),
        g = Math.round(rgba[1] / 255 * 100),
        b = Math.round(rgba[2] / 255 * 100);
      return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
    }
    function hslString(hsla, alpha) {
      if (alpha < 1 || hsla[3] && hsla[3] < 1) {
        return hslaString(hsla, alpha);
      }
      return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
    }
    function hslaString(hsla, alpha) {
      if (alpha === undefined) {
        alpha = hsla[3] !== undefined ? hsla[3] : 1;
      }
      return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
    }
    function hwbString(hwb, alpha) {
      if (alpha === undefined) {
        alpha = hwb[3] !== undefined ? hwb[3] : 1;
      }
      return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
    }
    function keyword(rgb) {
      return reverseNames[rgb.slice(0, 3)];
    }
    function scale(num, min, max) {
      return Math.min(Math.max(min, num), max);
    }
    function hexDouble(num) {
      var str = num.toString(16).toUpperCase();
      return str.length < 2 ? "0" + str : str;
    }
    var reverseNames = {};
    for (var name in colorName$1) {
      reverseNames[colorName$1[name]] = name;
    }
    var Color = function Color(obj) {
      if (obj instanceof Color) {
        return obj;
      }
      if (!(this instanceof Color)) {
        return new Color(obj);
      }
      this.valid = false;
      this.values = {
        rgb: [0, 0, 0],
        hsl: [0, 0, 0],
        hsv: [0, 0, 0],
        hwb: [0, 0, 0],
        cmyk: [0, 0, 0, 0],
        alpha: 1
      };
      var vals;
      if (typeof obj === 'string') {
        vals = colorString.getRgba(obj);
        if (vals) {
          this.setValues('rgb', vals);
        } else if (vals = colorString.getHsla(obj)) {
          this.setValues('hsl', vals);
        } else if (vals = colorString.getHwb(obj)) {
          this.setValues('hwb', vals);
        }
      } else if (typeof obj === 'object') {
        vals = obj;
        if (vals.r !== undefined || vals.red !== undefined) {
          this.setValues('rgb', vals);
        } else if (vals.l !== undefined || vals.lightness !== undefined) {
          this.setValues('hsl', vals);
        } else if (vals.v !== undefined || vals.value !== undefined) {
          this.setValues('hsv', vals);
        } else if (vals.w !== undefined || vals.whiteness !== undefined) {
          this.setValues('hwb', vals);
        } else if (vals.c !== undefined || vals.cyan !== undefined) {
          this.setValues('cmyk', vals);
        }
      }
    };
    Color.prototype = {
      isValid: function isValid() {
        return this.valid;
      },
      rgb: function rgb() {
        return this.setSpace('rgb', arguments);
      },
      hsl: function hsl() {
        return this.setSpace('hsl', arguments);
      },
      hsv: function hsv() {
        return this.setSpace('hsv', arguments);
      },
      hwb: function hwb() {
        return this.setSpace('hwb', arguments);
      },
      cmyk: function cmyk() {
        return this.setSpace('cmyk', arguments);
      },
      rgbArray: function rgbArray() {
        return this.values.rgb;
      },
      hslArray: function hslArray() {
        return this.values.hsl;
      },
      hsvArray: function hsvArray() {
        return this.values.hsv;
      },
      hwbArray: function hwbArray() {
        var values = this.values;
        if (values.alpha !== 1) {
          return values.hwb.concat([values.alpha]);
        }
        return values.hwb;
      },
      cmykArray: function cmykArray() {
        return this.values.cmyk;
      },
      rgbaArray: function rgbaArray() {
        var values = this.values;
        return values.rgb.concat([values.alpha]);
      },
      hslaArray: function hslaArray() {
        var values = this.values;
        return values.hsl.concat([values.alpha]);
      },
      alpha: function alpha(val) {
        if (val === undefined) {
          return this.values.alpha;
        }
        this.setValues('alpha', val);
        return this;
      },
      red: function red(val) {
        return this.setChannel('rgb', 0, val);
      },
      green: function green(val) {
        return this.setChannel('rgb', 1, val);
      },
      blue: function blue(val) {
        return this.setChannel('rgb', 2, val);
      },
      hue: function hue(val) {
        if (val) {
          val %= 360;
          val = val < 0 ? 360 + val : val;
        }
        return this.setChannel('hsl', 0, val);
      },
      saturation: function saturation(val) {
        return this.setChannel('hsl', 1, val);
      },
      lightness: function lightness(val) {
        return this.setChannel('hsl', 2, val);
      },
      saturationv: function saturationv(val) {
        return this.setChannel('hsv', 1, val);
      },
      whiteness: function whiteness(val) {
        return this.setChannel('hwb', 1, val);
      },
      blackness: function blackness(val) {
        return this.setChannel('hwb', 2, val);
      },
      value: function value(val) {
        return this.setChannel('hsv', 2, val);
      },
      cyan: function cyan(val) {
        return this.setChannel('cmyk', 0, val);
      },
      magenta: function magenta(val) {
        return this.setChannel('cmyk', 1, val);
      },
      yellow: function yellow(val) {
        return this.setChannel('cmyk', 2, val);
      },
      black: function black(val) {
        return this.setChannel('cmyk', 3, val);
      },
      hexString: function hexString() {
        return colorString.hexString(this.values.rgb);
      },
      rgbString: function rgbString() {
        return colorString.rgbString(this.values.rgb, this.values.alpha);
      },
      rgbaString: function rgbaString() {
        return colorString.rgbaString(this.values.rgb, this.values.alpha);
      },
      percentString: function percentString() {
        return colorString.percentString(this.values.rgb, this.values.alpha);
      },
      hslString: function hslString() {
        return colorString.hslString(this.values.hsl, this.values.alpha);
      },
      hslaString: function hslaString() {
        return colorString.hslaString(this.values.hsl, this.values.alpha);
      },
      hwbString: function hwbString() {
        return colorString.hwbString(this.values.hwb, this.values.alpha);
      },
      keyword: function keyword() {
        return colorString.keyword(this.values.rgb, this.values.alpha);
      },
      rgbNumber: function rgbNumber() {
        var rgb = this.values.rgb;
        return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
      },
      luminosity: function luminosity() {
        var rgb = this.values.rgb;
        var lum = [];
        for (var i = 0; i < rgb.length; i++) {
          var chan = rgb[i] / 255;
          lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
      },
      contrast: function contrast(color2) {
        var lum1 = this.luminosity();
        var lum2 = color2.luminosity();
        if (lum1 > lum2) {
          return (lum1 + 0.05) / (lum2 + 0.05);
        }
        return (lum2 + 0.05) / (lum1 + 0.05);
      },
      level: function level(color2) {
        var contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7.1) {
          return 'AAA';
        }
        return contrastRatio >= 4.5 ? 'AA' : '';
      },
      dark: function dark() {
        var rgb = this.values.rgb;
        var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return yiq < 128;
      },
      light: function light() {
        return !this.dark();
      },
      negate: function negate() {
        var rgb = [];
        for (var i = 0; i < 3; i++) {
          rgb[i] = 255 - this.values.rgb[i];
        }
        this.setValues('rgb', rgb);
        return this;
      },
      lighten: function lighten(ratio) {
        var hsl = this.values.hsl;
        hsl[2] += hsl[2] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      darken: function darken(ratio) {
        var hsl = this.values.hsl;
        hsl[2] -= hsl[2] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      saturate: function saturate(ratio) {
        var hsl = this.values.hsl;
        hsl[1] += hsl[1] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      desaturate: function desaturate(ratio) {
        var hsl = this.values.hsl;
        hsl[1] -= hsl[1] * ratio;
        this.setValues('hsl', hsl);
        return this;
      },
      whiten: function whiten(ratio) {
        var hwb = this.values.hwb;
        hwb[1] += hwb[1] * ratio;
        this.setValues('hwb', hwb);
        return this;
      },
      blacken: function blacken(ratio) {
        var hwb = this.values.hwb;
        hwb[2] += hwb[2] * ratio;
        this.setValues('hwb', hwb);
        return this;
      },
      greyscale: function greyscale() {
        var rgb = this.values.rgb;
        var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        this.setValues('rgb', [val, val, val]);
        return this;
      },
      clearer: function clearer(ratio) {
        var alpha = this.values.alpha;
        this.setValues('alpha', alpha - alpha * ratio);
        return this;
      },
      opaquer: function opaquer(ratio) {
        var alpha = this.values.alpha;
        this.setValues('alpha', alpha + alpha * ratio);
        return this;
      },
      rotate: function rotate(degrees) {
        var hsl = this.values.hsl;
        var hue = (hsl[0] + degrees) % 360;
        hsl[0] = hue < 0 ? 360 + hue : hue;
        this.setValues('hsl', hsl);
        return this;
      },
      mix: function mix(mixinColor, weight) {
        var color1 = this;
        var color2 = mixinColor;
        var p = weight === undefined ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = color1.alpha() - color2.alpha();
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
        var w2 = 1 - w1;
        return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
      },
      toJSON: function toJSON() {
        return this.rgb();
      },
      clone: function clone() {
        var result = new Color();
        var source = this.values;
        var target = result.values;
        var value, type;
        for (var prop in source) {
          if (source.hasOwnProperty(prop)) {
            value = source[prop];
            type = {}.toString.call(value);
            if (type === '[object Array]') {
              target[prop] = value.slice(0);
            } else if (type === '[object Number]') {
              target[prop] = value;
            } else {
              console.error('unexpected color value:', value);
            }
          }
        }
        return result;
      }
    };
    Color.prototype.spaces = {
      rgb: ['red', 'green', 'blue'],
      hsl: ['hue', 'saturation', 'lightness'],
      hsv: ['hue', 'saturation', 'value'],
      hwb: ['hue', 'whiteness', 'blackness'],
      cmyk: ['cyan', 'magenta', 'yellow', 'black']
    };
    Color.prototype.maxes = {
      rgb: [255, 255, 255],
      hsl: [360, 100, 100],
      hsv: [360, 100, 100],
      hwb: [360, 100, 100],
      cmyk: [100, 100, 100, 100]
    };
    Color.prototype.getValues = function (space) {
      var values = this.values;
      var vals = {};
      for (var i = 0; i < space.length; i++) {
        vals[space.charAt(i)] = values[space][i];
      }
      if (values.alpha !== 1) {
        vals.a = values.alpha;
      }
      return vals;
    };
    Color.prototype.setValues = function (space, vals) {
      var values = this.values;
      var spaces = this.spaces;
      var maxes = this.maxes;
      var alpha = 1;
      var i;
      this.valid = true;
      if (space === 'alpha') {
        alpha = vals;
      } else if (vals.length) {
        values[space] = vals.slice(0, space.length);
        alpha = vals[space.length];
      } else if (vals[space.charAt(0)] !== undefined) {
        for (i = 0; i < space.length; i++) {
          values[space][i] = vals[space.charAt(i)];
        }
        alpha = vals.a;
      } else if (vals[spaces[space][0]] !== undefined) {
        var chans = spaces[space];
        for (i = 0; i < space.length; i++) {
          values[space][i] = vals[chans[i]];
        }
        alpha = vals.alpha;
      }
      values.alpha = Math.max(0, Math.min(1, alpha === undefined ? values.alpha : alpha));
      if (space === 'alpha') {
        return false;
      }
      var capped;
      for (i = 0; i < space.length; i++) {
        capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
        values[space][i] = Math.round(capped);
      }
      for (var sname in spaces) {
        if (sname !== space) {
          values[sname] = colorConvert[space][sname](values[space]);
        }
      }
      return true;
    };
    Color.prototype.setSpace = function (space, args) {
      var vals = args[0];
      if (vals === undefined) {
        return this.getValues(space);
      }
      if (typeof vals === 'number') {
        vals = Array.prototype.slice.call(args);
      }
      this.setValues(space, vals);
      return this;
    };
    Color.prototype.setChannel = function (space, index, val) {
      var svalues = this.values[space];
      if (val === undefined) {
        return svalues[index];
      } else if (val === svalues[index]) {
        return this;
      }
      svalues[index] = val;
      this.setValues(space, svalues);
      return this;
    };
    if (typeof window !== 'undefined') {
      window.Color = Color;
    }
    var chartjsColor = Color;
    function isValidKey(key) {
      return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
    }
    var helpers = {
      noop: function noop() {},
      uid: function () {
        var id = 0;
        return function () {
          return id++;
        };
      }(),
      isNullOrUndef: function isNullOrUndef(value) {
        return value === null || typeof value === 'undefined';
      },
      isArray: function isArray(value) {
        if (Array.isArray && Array.isArray(value)) {
          return true;
        }
        var type = Object.prototype.toString.call(value);
        if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
          return true;
        }
        return false;
      },
      isObject: function isObject(value) {
        return value !== null && Object.prototype.toString.call(value) === '[object Object]';
      },
      isFinite: function (_isFinite) {
        function isFinite(_x) {
          return _isFinite.apply(this, arguments);
        }
        isFinite.toString = function () {
          return _isFinite.toString();
        };
        return isFinite;
      }(function (value) {
        return (typeof value === 'number' || value instanceof Number) && isFinite(value);
      }),
      valueOrDefault: function valueOrDefault(value, defaultValue) {
        return typeof value === 'undefined' ? defaultValue : value;
      },
      valueAtIndexOrDefault: function valueAtIndexOrDefault(value, index, defaultValue) {
        return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
      },
      callback: function callback(fn, args, thisArg) {
        if (fn && typeof fn.call === 'function') {
          return fn.apply(thisArg, args);
        }
      },
      each: function each(loopable, fn, thisArg, reverse) {
        var i, len, keys;
        if (helpers.isArray(loopable)) {
          len = loopable.length;
          if (reverse) {
            for (i = len - 1; i >= 0; i--) {
              fn.call(thisArg, loopable[i], i);
            }
          } else {
            for (i = 0; i < len; i++) {
              fn.call(thisArg, loopable[i], i);
            }
          }
        } else if (helpers.isObject(loopable)) {
          keys = Object.keys(loopable);
          len = keys.length;
          for (i = 0; i < len; i++) {
            fn.call(thisArg, loopable[keys[i]], keys[i]);
          }
        }
      },
      arrayEquals: function arrayEquals(a0, a1) {
        var i, ilen, v0, v1;
        if (!a0 || !a1 || a0.length !== a1.length) {
          return false;
        }
        for (i = 0, ilen = a0.length; i < ilen; ++i) {
          v0 = a0[i];
          v1 = a1[i];
          if (v0 instanceof Array && v1 instanceof Array) {
            if (!helpers.arrayEquals(v0, v1)) {
              return false;
            }
          } else if (v0 !== v1) {
            return false;
          }
        }
        return true;
      },
      clone: function clone(source) {
        if (helpers.isArray(source)) {
          return source.map(helpers.clone);
        }
        if (helpers.isObject(source)) {
          var target = Object.create(source);
          var keys = Object.keys(source);
          var klen = keys.length;
          var k = 0;
          for (; k < klen; ++k) {
            target[keys[k]] = helpers.clone(source[keys[k]]);
          }
          return target;
        }
        return source;
      },
      _merger: function _merger(key, target, source, options) {
        if (!isValidKey(key)) {
          return;
        }
        var tval = target[key];
        var sval = source[key];
        if (helpers.isObject(tval) && helpers.isObject(sval)) {
          helpers.merge(tval, sval, options);
        } else {
          target[key] = helpers.clone(sval);
        }
      },
      _mergerIf: function _mergerIf(key, target, source) {
        if (!isValidKey(key)) {
          return;
        }
        var tval = target[key];
        var sval = source[key];
        if (helpers.isObject(tval) && helpers.isObject(sval)) {
          helpers.mergeIf(tval, sval);
        } else if (!target.hasOwnProperty(key)) {
          target[key] = helpers.clone(sval);
        }
      },
      merge: function merge(target, source, options) {
        var sources = helpers.isArray(source) ? source : [source];
        var ilen = sources.length;
        var merge, i, keys, klen, k;
        if (!helpers.isObject(target)) {
          return target;
        }
        options = options || {};
        merge = options.merger || helpers._merger;
        for (i = 0; i < ilen; ++i) {
          source = sources[i];
          if (!helpers.isObject(source)) {
            continue;
          }
          keys = Object.keys(source);
          for (k = 0, klen = keys.length; k < klen; ++k) {
            merge(keys[k], target, source, options);
          }
        }
        return target;
      },
      mergeIf: function mergeIf(target, source) {
        return helpers.merge(target, source, {
          merger: helpers._mergerIf
        });
      },
      extend: Object.assign || function (target) {
        return helpers.merge(target, [].slice.call(arguments, 1), {
          merger: function merger(key, dst, src) {
            dst[key] = src[key];
          }
        });
      },
      inherits: function inherits(extensions) {
        var me = this;
        var ChartElement = extensions && extensions.hasOwnProperty('constructor') ? extensions.constructor : function () {
          return me.apply(this, arguments);
        };
        var Surrogate = function Surrogate() {
          this.constructor = ChartElement;
        };
        Surrogate.prototype = me.prototype;
        ChartElement.prototype = new Surrogate();
        ChartElement.extend = helpers.inherits;
        if (extensions) {
          helpers.extend(ChartElement.prototype, extensions);
        }
        ChartElement.__super__ = me.prototype;
        return ChartElement;
      },
      _deprecated: function _deprecated(scope, value, previous, current) {
        if (value !== undefined) {
          console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
        }
      }
    };
    var helpers_core = helpers;
    helpers.callCallback = helpers.callback;
    helpers.indexOf = function (array, item, fromIndex) {
      return Array.prototype.indexOf.call(array, item, fromIndex);
    };
    helpers.getValueOrDefault = helpers.valueOrDefault;
    helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
    var effects = {
      linear: function linear(t) {
        return t;
      },
      easeInQuad: function easeInQuad(t) {
        return t * t;
      },
      easeOutQuad: function easeOutQuad(t) {
        return -t * (t - 2);
      },
      easeInOutQuad: function easeInOutQuad(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t;
        }
        return -0.5 * (--t * (t - 2) - 1);
      },
      easeInCubic: function easeInCubic(t) {
        return t * t * t;
      },
      easeOutCubic: function easeOutCubic(t) {
        return (t = t - 1) * t * t + 1;
      },
      easeInOutCubic: function easeInOutCubic(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t * t;
        }
        return 0.5 * ((t -= 2) * t * t + 2);
      },
      easeInQuart: function easeInQuart(t) {
        return t * t * t * t;
      },
      easeOutQuart: function easeOutQuart(t) {
        return -((t = t - 1) * t * t * t - 1);
      },
      easeInOutQuart: function easeInOutQuart(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t * t * t;
        }
        return -0.5 * ((t -= 2) * t * t * t - 2);
      },
      easeInQuint: function easeInQuint(t) {
        return t * t * t * t * t;
      },
      easeOutQuint: function easeOutQuint(t) {
        return (t = t - 1) * t * t * t * t + 1;
      },
      easeInOutQuint: function easeInOutQuint(t) {
        if ((t /= 0.5) < 1) {
          return 0.5 * t * t * t * t * t;
        }
        return 0.5 * ((t -= 2) * t * t * t * t + 2);
      },
      easeInSine: function easeInSine(t) {
        return -Math.cos(t * (Math.PI / 2)) + 1;
      },
      easeOutSine: function easeOutSine(t) {
        return Math.sin(t * (Math.PI / 2));
      },
      easeInOutSine: function easeInOutSine(t) {
        return -0.5 * (Math.cos(Math.PI * t) - 1);
      },
      easeInExpo: function easeInExpo(t) {
        return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
      },
      easeOutExpo: function easeOutExpo(t) {
        return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
      },
      easeInOutExpo: function easeInOutExpo(t) {
        if (t === 0) {
          return 0;
        }
        if (t === 1) {
          return 1;
        }
        if ((t /= 0.5) < 1) {
          return 0.5 * Math.pow(2, 10 * (t - 1));
        }
        return 0.5 * (-Math.pow(2, -10 * --t) + 2);
      },
      easeInCirc: function easeInCirc(t) {
        if (t >= 1) {
          return t;
        }
        return -(Math.sqrt(1 - t * t) - 1);
      },
      easeOutCirc: function easeOutCirc(t) {
        return Math.sqrt(1 - (t = t - 1) * t);
      },
      easeInOutCirc: function easeInOutCirc(t) {
        if ((t /= 0.5) < 1) {
          return -0.5 * (Math.sqrt(1 - t * t) - 1);
        }
        return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
      },
      easeInElastic: function easeInElastic(t) {
        var s = 1.70158;
        var p = 0;
        var a = 1;
        if (t === 0) {
          return 0;
        }
        if (t === 1) {
          return 1;
        }
        if (!p) {
          p = 0.3;
        }
        {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
      },
      easeOutElastic: function easeOutElastic(t) {
        var s = 1.70158;
        var p = 0;
        var a = 1;
        if (t === 0) {
          return 0;
        }
        if (t === 1) {
          return 1;
        }
        if (!p) {
          p = 0.3;
        }
        {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
      },
      easeInOutElastic: function easeInOutElastic(t) {
        var s = 1.70158;
        var p = 0;
        var a = 1;
        if (t === 0) {
          return 0;
        }
        if ((t /= 0.5) === 2) {
          return 1;
        }
        if (!p) {
          p = 0.45;
        }
        {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        if (t < 1) {
          return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
        }
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
      },
      easeInBack: function easeInBack(t) {
        var s = 1.70158;
        return t * t * ((s + 1) * t - s);
      },
      easeOutBack: function easeOutBack(t) {
        var s = 1.70158;
        return (t = t - 1) * t * ((s + 1) * t + s) + 1;
      },
      easeInOutBack: function easeInOutBack(t) {
        var s = 1.70158;
        if ((t /= 0.5) < 1) {
          return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        }
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
      },
      easeInBounce: function easeInBounce(t) {
        return 1 - effects.easeOutBounce(1 - t);
      },
      easeOutBounce: function easeOutBounce(t) {
        if (t < 1 / 2.75) {
          return 7.5625 * t * t;
        }
        if (t < 2 / 2.75) {
          return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
        }
        if (t < 2.5 / 2.75) {
          return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
        }
        return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
      },
      easeInOutBounce: function easeInOutBounce(t) {
        if (t < 0.5) {
          return effects.easeInBounce(t * 2) * 0.5;
        }
        return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
      }
    };
    var helpers_easing = {
      effects: effects
    };
    helpers_core.easingEffects = effects;
    var PI = Math.PI;
    var RAD_PER_DEG = PI / 180;
    var DOUBLE_PI = PI * 2;
    var HALF_PI = PI / 2;
    var QUARTER_PI = PI / 4;
    var TWO_THIRDS_PI = PI * 2 / 3;
    var exports$1 = {
      clear: function clear(chart) {
        chart.ctx.clearRect(0, 0, chart.width, chart.height);
      },
      roundedRect: function roundedRect(ctx, x, y, width, height, radius) {
        if (radius) {
          var r = Math.min(radius, height / 2, width / 2);
          var left = x + r;
          var top = y + r;
          var right = x + width - r;
          var bottom = y + height - r;
          ctx.moveTo(x, top);
          if (left < right && top < bottom) {
            ctx.arc(left, top, r, -PI, -HALF_PI);
            ctx.arc(right, top, r, -HALF_PI, 0);
            ctx.arc(right, bottom, r, 0, HALF_PI);
            ctx.arc(left, bottom, r, HALF_PI, PI);
          } else if (left < right) {
            ctx.moveTo(left, y);
            ctx.arc(right, top, r, -HALF_PI, HALF_PI);
            ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
          } else if (top < bottom) {
            ctx.arc(left, top, r, -PI, 0);
            ctx.arc(left, bottom, r, 0, PI);
          } else {
            ctx.arc(left, top, r, -PI, PI);
          }
          ctx.closePath();
          ctx.moveTo(x, y);
        } else {
          ctx.rect(x, y, width, height);
        }
      },
      drawPoint: function drawPoint(ctx, style, radius, x, y, rotation) {
        var type, xOffset, yOffset, size, cornerRadius;
        var rad = (rotation || 0) * RAD_PER_DEG;
        if (style && typeof style === 'object') {
          type = style.toString();
          if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
          }
        }
        if (isNaN(radius) || radius <= 0) {
          return;
        }
        ctx.beginPath();
        switch (style) {
          default:
            ctx.arc(x, y, radius, 0, DOUBLE_PI);
            ctx.closePath();
            break;
          case 'triangle':
            ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
          case 'rectRounded':
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + QUARTER_PI) * size;
            yOffset = Math.sin(rad + QUARTER_PI) * size;
            ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
            ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
            ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
            ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
            ctx.closePath();
            break;
          case 'rect':
            if (!rotation) {
              size = Math.SQRT1_2 * radius;
              ctx.rect(x - size, y - size, 2 * size, 2 * size);
              break;
            }
            rad += QUARTER_PI;
          case 'rectRot':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + yOffset, y - xOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            ctx.closePath();
            break;
          case 'crossRot':
            rad += QUARTER_PI;
          case 'cross':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
          case 'star':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            rad += QUARTER_PI;
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            ctx.moveTo(x + yOffset, y - xOffset);
            ctx.lineTo(x - yOffset, y + xOffset);
            break;
          case 'line':
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
          case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
            break;
        }
        ctx.fill();
        ctx.stroke();
      },
      _isPointInArea: function _isPointInArea(point, area) {
        var epsilon = 1e-6;
        return point.x > area.left - epsilon && point.x < area.right + epsilon && point.y > area.top - epsilon && point.y < area.bottom + epsilon;
      },
      clipArea: function clipArea(ctx, area) {
        ctx.save();
        ctx.beginPath();
        ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
        ctx.clip();
      },
      unclipArea: function unclipArea(ctx) {
        ctx.restore();
      },
      lineTo: function lineTo(ctx, previous, target, flip) {
        var stepped = target.steppedLine;
        if (stepped) {
          if (stepped === 'middle') {
            var midpoint = (previous.x + target.x) / 2.0;
            ctx.lineTo(midpoint, flip ? target.y : previous.y);
            ctx.lineTo(midpoint, flip ? previous.y : target.y);
          } else if (stepped === 'after' && !flip || stepped !== 'after' && flip) {
            ctx.lineTo(previous.x, target.y);
          } else {
            ctx.lineTo(target.x, previous.y);
          }
          ctx.lineTo(target.x, target.y);
          return;
        }
        if (!target.tension) {
          ctx.lineTo(target.x, target.y);
          return;
        }
        ctx.bezierCurveTo(flip ? previous.controlPointPreviousX : previous.controlPointNextX, flip ? previous.controlPointPreviousY : previous.controlPointNextY, flip ? target.controlPointNextX : target.controlPointPreviousX, flip ? target.controlPointNextY : target.controlPointPreviousY, target.x, target.y);
      }
    };
    var helpers_canvas = exports$1;
    helpers_core.clear = exports$1.clear;
    helpers_core.drawRoundedRectangle = function (ctx) {
      ctx.beginPath();
      exports$1.roundedRect.apply(exports$1, arguments);
    };
    var defaults = {
      _set: function _set(scope, values) {
        return helpers_core.merge(this[scope] || (this[scope] = {}), values);
      }
    };
    defaults._set('global', {
      defaultColor: 'rgba(0,0,0,0.1)',
      defaultFontColor: '#666',
      defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      defaultFontSize: 12,
      defaultFontStyle: 'normal',
      defaultLineHeight: 1.2,
      showLines: true
    });
    var core_defaults = defaults;
    var valueOrDefault = helpers_core.valueOrDefault;
    function toFontString(font) {
      if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
        return null;
      }
      return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
    }
    var helpers_options = {
      toLineHeight: function toLineHeight(value, size) {
        var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
        if (!matches || matches[1] === 'normal') {
          return size * 1.2;
        }
        value = +matches[2];
        switch (matches[3]) {
          case 'px':
            return value;
          case '%':
            value /= 100;
            break;
        }
        return size * value;
      },
      toPadding: function toPadding(value) {
        var t, r, b, l;
        if (helpers_core.isObject(value)) {
          t = +value.top || 0;
          r = +value.right || 0;
          b = +value.bottom || 0;
          l = +value.left || 0;
        } else {
          t = r = b = l = +value || 0;
        }
        return {
          top: t,
          right: r,
          bottom: b,
          left: l,
          height: t + b,
          width: l + r
        };
      },
      _parseFont: function _parseFont(options) {
        var globalDefaults = core_defaults.global;
        var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
        var font = {
          family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
          lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
          size: size,
          style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
          weight: null,
          string: ''
        };
        font.string = toFontString(font);
        return font;
      },
      resolve: function resolve(inputs, context, index, info) {
        var cacheable = true;
        var i, ilen, value;
        for (i = 0, ilen = inputs.length; i < ilen; ++i) {
          value = inputs[i];
          if (value === undefined) {
            continue;
          }
          if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
          }
          if (index !== undefined && helpers_core.isArray(value)) {
            value = value[index];
            cacheable = false;
          }
          if (value !== undefined) {
            if (info && !cacheable) {
              info.cacheable = false;
            }
            return value;
          }
        }
      }
    };
    var exports$2 = {
      _factorize: function _factorize(value) {
        var result = [];
        var sqrt = Math.sqrt(value);
        var i;
        for (i = 1; i < sqrt; i++) {
          if (value % i === 0) {
            result.push(i);
            result.push(value / i);
          }
        }
        if (sqrt === (sqrt | 0)) {
          result.push(sqrt);
        }
        result.sort(function (a, b) {
          return a - b;
        }).pop();
        return result;
      },
      log10: Math.log10 || function (x) {
        var exponent = Math.log(x) * Math.LOG10E;
        var powerOf10 = Math.round(exponent);
        var isPowerOf10 = x === Math.pow(10, powerOf10);
        return isPowerOf10 ? powerOf10 : exponent;
      }
    };
    var helpers_math = exports$2;
    helpers_core.log10 = exports$2.log10;
    var getRtlAdapter = function getRtlAdapter(rectX, width) {
      return {
        x: function x(_x2) {
          return rectX + rectX + width - _x2;
        },
        setWidth: function setWidth(w) {
          width = w;
        },
        textAlign: function textAlign(align) {
          if (align === 'center') {
            return align;
          }
          return align === 'right' ? 'left' : 'right';
        },
        xPlus: function xPlus(x, value) {
          return x - value;
        },
        leftForLtr: function leftForLtr(x, itemWidth) {
          return x - itemWidth;
        }
      };
    };
    var getLtrAdapter = function getLtrAdapter() {
      return {
        x: function x(_x3) {
          return _x3;
        },
        setWidth: function setWidth(w) {},
        textAlign: function textAlign(align) {
          return align;
        },
        xPlus: function xPlus(x, value) {
          return x + value;
        },
        leftForLtr: function leftForLtr(x, _itemWidth) {
          return x;
        }
      };
    };
    var getAdapter = function getAdapter(rtl, rectX, width) {
      return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
    };
    var overrideTextDirection = function overrideTextDirection(ctx, direction) {
      var style, original;
      if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [style.getPropertyValue('direction'), style.getPropertyPriority('direction')];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
      }
    };
    var restoreTextDirection = function restoreTextDirection(ctx) {
      var original = ctx.prevTextDirection;
      if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
      }
    };
    var helpers_rtl = {
      getRtlAdapter: getAdapter,
      overrideTextDirection: overrideTextDirection,
      restoreTextDirection: restoreTextDirection
    };
    var helpers$1 = helpers_core;
    var easing = helpers_easing;
    var canvas = helpers_canvas;
    var options = helpers_options;
    var math = helpers_math;
    var rtl = helpers_rtl;
    helpers$1.easing = easing;
    helpers$1.canvas = canvas;
    helpers$1.options = options;
    helpers$1.math = math;
    helpers$1.rtl = rtl;
    function interpolate(start, view, model, ease) {
      var keys = Object.keys(model);
      var i, ilen, key, actual, origin, target, type, c0, c1;
      for (i = 0, ilen = keys.length; i < ilen; ++i) {
        key = keys[i];
        target = model[key];
        if (!view.hasOwnProperty(key)) {
          view[key] = target;
        }
        actual = view[key];
        if (actual === target || key[0] === '_') {
          continue;
        }
        if (!start.hasOwnProperty(key)) {
          start[key] = actual;
        }
        origin = start[key];
        type = typeof target;
        if (type === typeof origin) {
          if (type === 'string') {
            c0 = chartjsColor(origin);
            if (c0.valid) {
              c1 = chartjsColor(target);
              if (c1.valid) {
                view[key] = c1.mix(c0, ease).rgbString();
                continue;
              }
            }
          } else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
            view[key] = origin + (target - origin) * ease;
            continue;
          }
        }
        view[key] = target;
      }
    }
    var Element = function Element(configuration) {
      helpers$1.extend(this, configuration);
      this.initialize.apply(this, arguments);
    };
    helpers$1.extend(Element.prototype, {
      _type: undefined,
      initialize: function initialize() {
        this.hidden = false;
      },
      pivot: function pivot() {
        var me = this;
        if (!me._view) {
          me._view = helpers$1.extend({}, me._model);
        }
        me._start = {};
        return me;
      },
      transition: function transition(ease) {
        var me = this;
        var model = me._model;
        var start = me._start;
        var view = me._view;
        if (!model || ease === 1) {
          me._view = helpers$1.extend({}, model);
          me._start = null;
          return me;
        }
        if (!view) {
          view = me._view = {};
        }
        if (!start) {
          start = me._start = {};
        }
        interpolate(start, view, model, ease);
        return me;
      },
      tooltipPosition: function tooltipPosition() {
        return {
          x: this._model.x,
          y: this._model.y
        };
      },
      hasValue: function hasValue() {
        return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
      }
    });
    Element.extend = helpers$1.inherits;
    var core_element = Element;
    var exports$3 = core_element.extend({
      chart: null,
      currentStep: 0,
      numSteps: 60,
      easing: '',
      render: null,
      onAnimationProgress: null,
      onAnimationComplete: null
    });
    var core_animation = exports$3;
    Object.defineProperty(exports$3.prototype, 'animationObject', {
      get: function get() {
        return this;
      }
    });
    Object.defineProperty(exports$3.prototype, 'chartInstance', {
      get: function get() {
        return this.chart;
      },
      set: function set(value) {
        this.chart = value;
      }
    });
    core_defaults._set('global', {
      animation: {
        duration: 1000,
        easing: 'easeOutQuart',
        onProgress: helpers$1.noop,
        onComplete: helpers$1.noop
      }
    });
    var core_animations = {
      animations: [],
      request: null,
      addAnimation: function addAnimation(chart, animation, duration, lazy) {
        var animations = this.animations;
        var i, ilen;
        animation.chart = chart;
        animation.startTime = Date.now();
        animation.duration = duration;
        if (!lazy) {
          chart.animating = true;
        }
        for (i = 0, ilen = animations.length; i < ilen; ++i) {
          if (animations[i].chart === chart) {
            animations[i] = animation;
            return;
          }
        }
        animations.push(animation);
        if (animations.length === 1) {
          this.requestAnimationFrame();
        }
      },
      cancelAnimation: function cancelAnimation(chart) {
        var index = helpers$1.findIndex(this.animations, function (animation) {
          return animation.chart === chart;
        });
        if (index !== -1) {
          this.animations.splice(index, 1);
          chart.animating = false;
        }
      },
      requestAnimationFrame: function requestAnimationFrame() {
        var me = this;
        if (me.request === null) {
          me.request = helpers$1.requestAnimFrame.call(window, function () {
            me.request = null;
            me.startDigest();
          });
        }
      },
      startDigest: function startDigest() {
        var me = this;
        me.advance();
        if (me.animations.length > 0) {
          me.requestAnimationFrame();
        }
      },
      advance: function advance() {
        var animations = this.animations;
        var animation, chart, numSteps, nextStep;
        var i = 0;
        while (i < animations.length) {
          animation = animations[i];
          chart = animation.chart;
          numSteps = animation.numSteps;
          nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
          animation.currentStep = Math.min(nextStep, numSteps);
          helpers$1.callback(animation.render, [chart, animation], chart);
          helpers$1.callback(animation.onAnimationProgress, [animation], chart);
          if (animation.currentStep >= numSteps) {
            helpers$1.callback(animation.onAnimationComplete, [animation], chart);
            chart.animating = false;
            animations.splice(i, 1);
          } else {
            ++i;
          }
        }
      }
    };
    var resolve = helpers$1.options.resolve;
    var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
    function listenArrayEvents(array, listener) {
      if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
      }
      Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
          listeners: [listener]
        }
      });
      arrayEvents.forEach(function (key) {
        var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
        var base = array[key];
        Object.defineProperty(array, key, {
          configurable: true,
          enumerable: false,
          value: function value() {
            var args = Array.prototype.slice.call(arguments);
            var res = base.apply(this, args);
            helpers$1.each(array._chartjs.listeners, function (object) {
              if (typeof object[method] === 'function') {
                object[method].apply(object, args);
              }
            });
            return res;
          }
        });
      });
    }
    function unlistenArrayEvents(array, listener) {
      var stub = array._chartjs;
      if (!stub) {
        return;
      }
      var listeners = stub.listeners;
      var index = listeners.indexOf(listener);
      if (index !== -1) {
        listeners.splice(index, 1);
      }
      if (listeners.length > 0) {
        return;
      }
      arrayEvents.forEach(function (key) {
        delete array[key];
      });
      delete array._chartjs;
    }
    var DatasetController = function DatasetController(chart, datasetIndex) {
      this.initialize(chart, datasetIndex);
    };
    helpers$1.extend(DatasetController.prototype, {
      datasetElementType: null,
      dataElementType: null,
      _datasetElementOptions: ['backgroundColor', 'borderCapStyle', 'borderColor', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'borderWidth'],
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'pointStyle'],
      initialize: function initialize(chart, datasetIndex) {
        var me = this;
        me.chart = chart;
        me.index = datasetIndex;
        me.linkScales();
        me.addElements();
        me._type = me.getMeta().type;
      },
      updateIndex: function updateIndex(datasetIndex) {
        this.index = datasetIndex;
      },
      linkScales: function linkScales() {
        var me = this;
        var meta = me.getMeta();
        var chart = me.chart;
        var scales = chart.scales;
        var dataset = me.getDataset();
        var scalesOpts = chart.options.scales;
        if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
          meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
        }
        if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
          meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
        }
      },
      getDataset: function getDataset() {
        return this.chart.data.datasets[this.index];
      },
      getMeta: function getMeta() {
        return this.chart.getDatasetMeta(this.index);
      },
      getScaleForId: function getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
      },
      _getValueScaleId: function _getValueScaleId() {
        return this.getMeta().yAxisID;
      },
      _getIndexScaleId: function _getIndexScaleId() {
        return this.getMeta().xAxisID;
      },
      _getValueScale: function _getValueScale() {
        return this.getScaleForId(this._getValueScaleId());
      },
      _getIndexScale: function _getIndexScale() {
        return this.getScaleForId(this._getIndexScaleId());
      },
      reset: function reset() {
        this._update(true);
      },
      destroy: function destroy() {
        if (this._data) {
          unlistenArrayEvents(this._data, this);
        }
      },
      createMetaDataset: function createMetaDataset() {
        var me = this;
        var type = me.datasetElementType;
        return type && new type({
          _chart: me.chart,
          _datasetIndex: me.index
        });
      },
      createMetaData: function createMetaData(index) {
        var me = this;
        var type = me.dataElementType;
        return type && new type({
          _chart: me.chart,
          _datasetIndex: me.index,
          _index: index
        });
      },
      addElements: function addElements() {
        var me = this;
        var meta = me.getMeta();
        var data = me.getDataset().data || [];
        var metaData = meta.data;
        var i, ilen;
        for (i = 0, ilen = data.length; i < ilen; ++i) {
          metaData[i] = metaData[i] || me.createMetaData(i);
        }
        meta.dataset = meta.dataset || me.createMetaDataset();
      },
      addElementAndReset: function addElementAndReset(index) {
        var element = this.createMetaData(index);
        this.getMeta().data.splice(index, 0, element);
        this.updateElement(element, index, true);
      },
      buildOrUpdateElements: function buildOrUpdateElements() {
        var me = this;
        var dataset = me.getDataset();
        var data = dataset.data || (dataset.data = []);
        if (me._data !== data) {
          if (me._data) {
            unlistenArrayEvents(me._data, me);
          }
          if (data && Object.isExtensible(data)) {
            listenArrayEvents(data, me);
          }
          me._data = data;
        }
        me.resyncElements();
      },
      _configure: function _configure() {
        var me = this;
        me._config = helpers$1.merge(Object.create(null), [me.chart.options.datasets[me._type], me.getDataset()], {
          merger: function merger(key, target, source) {
            if (key !== '_meta' && key !== 'data') {
              helpers$1._merger(key, target, source);
            }
          }
        });
      },
      _update: function _update(reset) {
        var me = this;
        me._configure();
        me._cachedDataOpts = null;
        me.update(reset);
      },
      update: helpers$1.noop,
      transition: function transition(easingValue) {
        var meta = this.getMeta();
        var elements = meta.data || [];
        var ilen = elements.length;
        var i = 0;
        for (; i < ilen; ++i) {
          elements[i].transition(easingValue);
        }
        if (meta.dataset) {
          meta.dataset.transition(easingValue);
        }
      },
      draw: function draw() {
        var meta = this.getMeta();
        var elements = meta.data || [];
        var ilen = elements.length;
        var i = 0;
        if (meta.dataset) {
          meta.dataset.draw();
        }
        for (; i < ilen; ++i) {
          elements[i].draw();
        }
      },
      getStyle: function getStyle(index) {
        var me = this;
        var meta = me.getMeta();
        var dataset = meta.dataset;
        var style;
        me._configure();
        if (dataset && index === undefined) {
          style = me._resolveDatasetElementOptions(dataset || {});
        } else {
          index = index || 0;
          style = me._resolveDataElementOptions(meta.data[index] || {}, index);
        }
        if (style.fill === false || style.fill === null) {
          style.backgroundColor = style.borderColor;
        }
        return style;
      },
      _resolveDatasetElementOptions: function _resolveDatasetElementOptions(element, hover) {
        var me = this;
        var chart = me.chart;
        var datasetOpts = me._config;
        var custom = element.custom || {};
        var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
        var elementOptions = me._datasetElementOptions;
        var values = {};
        var i, ilen, key, readKey;
        var context = {
          chart: chart,
          dataset: me.getDataset(),
          datasetIndex: me.index,
          hover: hover
        };
        for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
          key = elementOptions[i];
          readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
          values[key] = resolve([custom[readKey], datasetOpts[readKey], options[readKey]], context);
        }
        return values;
      },
      _resolveDataElementOptions: function _resolveDataElementOptions(element, index) {
        var me = this;
        var custom = element && element.custom;
        var cached = me._cachedDataOpts;
        if (cached && !custom) {
          return cached;
        }
        var chart = me.chart;
        var datasetOpts = me._config;
        var options = chart.options.elements[me.dataElementType.prototype._type] || {};
        var elementOptions = me._dataElementOptions;
        var values = {};
        var context = {
          chart: chart,
          dataIndex: index,
          dataset: me.getDataset(),
          datasetIndex: me.index
        };
        var info = {
          cacheable: !custom
        };
        var keys, i, ilen, key;
        custom = custom || {};
        if (helpers$1.isArray(elementOptions)) {
          for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
            key = elementOptions[i];
            values[key] = resolve([custom[key], datasetOpts[key], options[key]], context, index, info);
          }
        } else {
          keys = Object.keys(elementOptions);
          for (i = 0, ilen = keys.length; i < ilen; ++i) {
            key = keys[i];
            values[key] = resolve([custom[key], datasetOpts[elementOptions[key]], datasetOpts[key], options[key]], context, index, info);
          }
        }
        if (info.cacheable) {
          me._cachedDataOpts = Object.freeze(values);
        }
        return values;
      },
      removeHoverStyle: function removeHoverStyle(element) {
        helpers$1.merge(element._model, element.$previousStyle || {});
        delete element.$previousStyle;
      },
      setHoverStyle: function setHoverStyle(element) {
        var dataset = this.chart.data.datasets[element._datasetIndex];
        var index = element._index;
        var custom = element.custom || {};
        var model = element._model;
        var getHoverColor = helpers$1.getHoverColor;
        element.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth
        };
        model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
        model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
        model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
      },
      _removeDatasetHoverStyle: function _removeDatasetHoverStyle() {
        var element = this.getMeta().dataset;
        if (element) {
          this.removeHoverStyle(element);
        }
      },
      _setDatasetHoverStyle: function _setDatasetHoverStyle() {
        var element = this.getMeta().dataset;
        var prev = {};
        var i, ilen, key, keys, hoverOptions, model;
        if (!element) {
          return;
        }
        model = element._model;
        hoverOptions = this._resolveDatasetElementOptions(element, true);
        keys = Object.keys(hoverOptions);
        for (i = 0, ilen = keys.length; i < ilen; ++i) {
          key = keys[i];
          prev[key] = model[key];
          model[key] = hoverOptions[key];
        }
        element.$previousStyle = prev;
      },
      resyncElements: function resyncElements() {
        var me = this;
        var meta = me.getMeta();
        var data = me.getDataset().data;
        var numMeta = meta.data.length;
        var numData = data.length;
        if (numData < numMeta) {
          meta.data.splice(numData, numMeta - numData);
        } else if (numData > numMeta) {
          me.insertElements(numMeta, numData - numMeta);
        }
      },
      insertElements: function insertElements(start, count) {
        for (var i = 0; i < count; ++i) {
          this.addElementAndReset(start + i);
        }
      },
      onDataPush: function onDataPush() {
        var count = arguments.length;
        this.insertElements(this.getDataset().data.length - count, count);
      },
      onDataPop: function onDataPop() {
        this.getMeta().data.pop();
      },
      onDataShift: function onDataShift() {
        this.getMeta().data.shift();
      },
      onDataSplice: function onDataSplice(start, count) {
        this.getMeta().data.splice(start, count);
        this.insertElements(start, arguments.length - 2);
      },
      onDataUnshift: function onDataUnshift() {
        this.insertElements(0, arguments.length);
      }
    });
    DatasetController.extend = helpers$1.inherits;
    var core_datasetController = DatasetController;
    var TAU = Math.PI * 2;
    core_defaults._set('global', {
      elements: {
        arc: {
          backgroundColor: core_defaults.global.defaultColor,
          borderColor: '#fff',
          borderWidth: 2,
          borderAlign: 'center'
        }
      }
    });
    function clipArc(ctx, arc) {
      var startAngle = arc.startAngle;
      var endAngle = arc.endAngle;
      var pixelMargin = arc.pixelMargin;
      var angleMargin = pixelMargin / arc.outerRadius;
      var x = arc.x;
      var y = arc.y;
      ctx.beginPath();
      ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
      if (arc.innerRadius > pixelMargin) {
        angleMargin = pixelMargin / arc.innerRadius;
        ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
      } else {
        ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
      }
      ctx.closePath();
      ctx.clip();
    }
    function drawFullCircleBorders(ctx, vm, arc, inner) {
      var endAngle = arc.endAngle;
      var i;
      if (inner) {
        arc.endAngle = arc.startAngle + TAU;
        clipArc(ctx, arc);
        arc.endAngle = endAngle;
        if (arc.endAngle === arc.startAngle && arc.fullCircles) {
          arc.endAngle += TAU;
          arc.fullCircles--;
        }
      }
      ctx.beginPath();
      ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
      for (i = 0; i < arc.fullCircles; ++i) {
        ctx.stroke();
      }
      ctx.beginPath();
      ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
      for (i = 0; i < arc.fullCircles; ++i) {
        ctx.stroke();
      }
    }
    function drawBorder(ctx, vm, arc) {
      var inner = vm.borderAlign === 'inner';
      if (inner) {
        ctx.lineWidth = vm.borderWidth * 2;
        ctx.lineJoin = 'round';
      } else {
        ctx.lineWidth = vm.borderWidth;
        ctx.lineJoin = 'bevel';
      }
      if (arc.fullCircles) {
        drawFullCircleBorders(ctx, vm, arc, inner);
      }
      if (inner) {
        clipArc(ctx, arc);
      }
      ctx.beginPath();
      ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
      ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
      ctx.closePath();
      ctx.stroke();
    }
    var element_arc = core_element.extend({
      _type: 'arc',
      inLabelRange: function inLabelRange(mouseX) {
        var vm = this._view;
        if (vm) {
          return Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2);
        }
        return false;
      },
      inRange: function inRange(chartX, chartY) {
        var vm = this._view;
        if (vm) {
          var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {
            x: chartX,
            y: chartY
          });
          var angle = pointRelativePosition.angle;
          var distance = pointRelativePosition.distance;
          var startAngle = vm.startAngle;
          var endAngle = vm.endAngle;
          while (endAngle < startAngle) {
            endAngle += TAU;
          }
          while (angle > endAngle) {
            angle -= TAU;
          }
          while (angle < startAngle) {
            angle += TAU;
          }
          var betweenAngles = angle >= startAngle && angle <= endAngle;
          var withinRadius = distance >= vm.innerRadius && distance <= vm.outerRadius;
          return betweenAngles && withinRadius;
        }
        return false;
      },
      getCenterPoint: function getCenterPoint() {
        var vm = this._view;
        var halfAngle = (vm.startAngle + vm.endAngle) / 2;
        var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
        return {
          x: vm.x + Math.cos(halfAngle) * halfRadius,
          y: vm.y + Math.sin(halfAngle) * halfRadius
        };
      },
      getArea: function getArea() {
        var vm = this._view;
        return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
      },
      tooltipPosition: function tooltipPosition() {
        var vm = this._view;
        var centreAngle = vm.startAngle + (vm.endAngle - vm.startAngle) / 2;
        var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
        return {
          x: vm.x + Math.cos(centreAngle) * rangeFromCentre,
          y: vm.y + Math.sin(centreAngle) * rangeFromCentre
        };
      },
      draw: function draw() {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var pixelMargin = vm.borderAlign === 'inner' ? 0.33 : 0;
        var arc = {
          x: vm.x,
          y: vm.y,
          innerRadius: vm.innerRadius,
          outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
          pixelMargin: pixelMargin,
          startAngle: vm.startAngle,
          endAngle: vm.endAngle,
          fullCircles: Math.floor(vm.circumference / TAU)
        };
        var i;
        ctx.save();
        ctx.fillStyle = vm.backgroundColor;
        ctx.strokeStyle = vm.borderColor;
        if (arc.fullCircles) {
          arc.endAngle = arc.startAngle + TAU;
          ctx.beginPath();
          ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
          ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
          ctx.closePath();
          for (i = 0; i < arc.fullCircles; ++i) {
            ctx.fill();
          }
          arc.endAngle = arc.startAngle + vm.circumference % TAU;
        }
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
        ctx.closePath();
        ctx.fill();
        if (vm.borderWidth) {
          drawBorder(ctx, vm, arc);
        }
        ctx.restore();
      }
    });
    var valueOrDefault$1 = helpers$1.valueOrDefault;
    var defaultColor = core_defaults.global.defaultColor;
    core_defaults._set('global', {
      elements: {
        line: {
          tension: 0.4,
          backgroundColor: defaultColor,
          borderWidth: 3,
          borderColor: defaultColor,
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          capBezierPoints: true,
          fill: true
        }
      }
    });
    var element_line = core_element.extend({
      _type: 'line',
      draw: function draw() {
        var me = this;
        var vm = me._view;
        var ctx = me._chart.ctx;
        var spanGaps = vm.spanGaps;
        var points = me._children.slice();
        var globalDefaults = core_defaults.global;
        var globalOptionLineElements = globalDefaults.elements.line;
        var lastDrawnIndex = -1;
        var closePath = me._loop;
        var index, previous, currentVM;
        if (!points.length) {
          return;
        }
        if (me._loop) {
          for (index = 0; index < points.length; ++index) {
            previous = helpers$1.previousItem(points, index);
            if (!points[index]._view.skip && previous._view.skip) {
              points = points.slice(index).concat(points.slice(0, index));
              closePath = spanGaps;
              break;
            }
          }
          if (closePath) {
            points.push(points[0]);
          }
        }
        ctx.save();
        ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
        if (ctx.setLineDash) {
          ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
        }
        ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
        ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
        ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
        ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
        ctx.beginPath();
        currentVM = points[0]._view;
        if (!currentVM.skip) {
          ctx.moveTo(currentVM.x, currentVM.y);
          lastDrawnIndex = 0;
        }
        for (index = 1; index < points.length; ++index) {
          currentVM = points[index]._view;
          previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
          if (!currentVM.skip) {
            if (lastDrawnIndex !== index - 1 && !spanGaps || lastDrawnIndex === -1) {
              ctx.moveTo(currentVM.x, currentVM.y);
            } else {
              helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
            }
            lastDrawnIndex = index;
          }
        }
        if (closePath) {
          ctx.closePath();
        }
        ctx.stroke();
        ctx.restore();
      }
    });
    var valueOrDefault$2 = helpers$1.valueOrDefault;
    var defaultColor$1 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
      elements: {
        point: {
          radius: 3,
          pointStyle: 'circle',
          backgroundColor: defaultColor$1,
          borderColor: defaultColor$1,
          borderWidth: 1,
          hitRadius: 1,
          hoverRadius: 4,
          hoverBorderWidth: 1
        }
      }
    });
    function xRange(mouseX) {
      var vm = this._view;
      return vm ? Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius : false;
    }
    function yRange(mouseY) {
      var vm = this._view;
      return vm ? Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius : false;
    }
    var element_point = core_element.extend({
      _type: 'point',
      inRange: function inRange(mouseX, mouseY) {
        var vm = this._view;
        return vm ? Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2) < Math.pow(vm.hitRadius + vm.radius, 2) : false;
      },
      inLabelRange: xRange,
      inXRange: xRange,
      inYRange: yRange,
      getCenterPoint: function getCenterPoint() {
        var vm = this._view;
        return {
          x: vm.x,
          y: vm.y
        };
      },
      getArea: function getArea() {
        return Math.PI * Math.pow(this._view.radius, 2);
      },
      tooltipPosition: function tooltipPosition() {
        var vm = this._view;
        return {
          x: vm.x,
          y: vm.y,
          padding: vm.radius + vm.borderWidth
        };
      },
      draw: function draw(chartArea) {
        var vm = this._view;
        var ctx = this._chart.ctx;
        var pointStyle = vm.pointStyle;
        var rotation = vm.rotation;
        var radius = vm.radius;
        var x = vm.x;
        var y = vm.y;
        var globalDefaults = core_defaults.global;
        var defaultColor = globalDefaults.defaultColor;
        if (vm.skip) {
          return;
        }
        if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
          ctx.strokeStyle = vm.borderColor || defaultColor;
          ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
          ctx.fillStyle = vm.backgroundColor || defaultColor;
          helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
        }
      }
    });
    var defaultColor$2 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
      elements: {
        rectangle: {
          backgroundColor: defaultColor$2,
          borderColor: defaultColor$2,
          borderSkipped: 'bottom',
          borderWidth: 0
        }
      }
    });
    function isVertical(vm) {
      return vm && vm.width !== undefined;
    }
    function getBarBounds(vm) {
      var x1, x2, y1, y2, half;
      if (isVertical(vm)) {
        half = vm.width / 2;
        x1 = vm.x - half;
        x2 = vm.x + half;
        y1 = Math.min(vm.y, vm.base);
        y2 = Math.max(vm.y, vm.base);
      } else {
        half = vm.height / 2;
        x1 = Math.min(vm.x, vm.base);
        x2 = Math.max(vm.x, vm.base);
        y1 = vm.y - half;
        y2 = vm.y + half;
      }
      return {
        left: x1,
        top: y1,
        right: x2,
        bottom: y2
      };
    }
    function swap(orig, v1, v2) {
      return orig === v1 ? v2 : orig === v2 ? v1 : orig;
    }
    function parseBorderSkipped(vm) {
      var edge = vm.borderSkipped;
      var res = {};
      if (!edge) {
        return res;
      }
      if (vm.horizontal) {
        if (vm.base > vm.x) {
          edge = swap(edge, 'left', 'right');
        }
      } else if (vm.base < vm.y) {
        edge = swap(edge, 'bottom', 'top');
      }
      res[edge] = true;
      return res;
    }
    function parseBorderWidth(vm, maxW, maxH) {
      var value = vm.borderWidth;
      var skip = parseBorderSkipped(vm);
      var t, r, b, l;
      if (helpers$1.isObject(value)) {
        t = +value.top || 0;
        r = +value.right || 0;
        b = +value.bottom || 0;
        l = +value.left || 0;
      } else {
        t = r = b = l = +value || 0;
      }
      return {
        t: skip.top || t < 0 ? 0 : t > maxH ? maxH : t,
        r: skip.right || r < 0 ? 0 : r > maxW ? maxW : r,
        b: skip.bottom || b < 0 ? 0 : b > maxH ? maxH : b,
        l: skip.left || l < 0 ? 0 : l > maxW ? maxW : l
      };
    }
    function boundingRects(vm) {
      var bounds = getBarBounds(vm);
      var width = bounds.right - bounds.left;
      var height = bounds.bottom - bounds.top;
      var border = parseBorderWidth(vm, width / 2, height / 2);
      return {
        outer: {
          x: bounds.left,
          y: bounds.top,
          w: width,
          h: height
        },
        inner: {
          x: bounds.left + border.l,
          y: bounds.top + border.t,
          w: width - border.l - border.r,
          h: height - border.t - border.b
        }
      };
    }
    function _inRange(vm, x, y) {
      var skipX = x === null;
      var skipY = y === null;
      var bounds = !vm || skipX && skipY ? false : getBarBounds(vm);
      return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
    }
    var element_rectangle = core_element.extend({
      _type: 'rectangle',
      draw: function draw() {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var rects = boundingRects(vm);
        var outer = rects.outer;
        var inner = rects.inner;
        ctx.fillStyle = vm.backgroundColor;
        ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
        if (outer.w === inner.w && outer.h === inner.h) {
          return;
        }
        ctx.save();
        ctx.beginPath();
        ctx.rect(outer.x, outer.y, outer.w, outer.h);
        ctx.clip();
        ctx.fillStyle = vm.borderColor;
        ctx.rect(inner.x, inner.y, inner.w, inner.h);
        ctx.fill('evenodd');
        ctx.restore();
      },
      height: function height() {
        var vm = this._view;
        return vm.base - vm.y;
      },
      inRange: function inRange(mouseX, mouseY) {
        return _inRange(this._view, mouseX, mouseY);
      },
      inLabelRange: function inLabelRange(mouseX, mouseY) {
        var vm = this._view;
        return isVertical(vm) ? _inRange(vm, mouseX, null) : _inRange(vm, null, mouseY);
      },
      inXRange: function inXRange(mouseX) {
        return _inRange(this._view, mouseX, null);
      },
      inYRange: function inYRange(mouseY) {
        return _inRange(this._view, null, mouseY);
      },
      getCenterPoint: function getCenterPoint() {
        var vm = this._view;
        var x, y;
        if (isVertical(vm)) {
          x = vm.x;
          y = (vm.y + vm.base) / 2;
        } else {
          x = (vm.x + vm.base) / 2;
          y = vm.y;
        }
        return {
          x: x,
          y: y
        };
      },
      getArea: function getArea() {
        var vm = this._view;
        return isVertical(vm) ? vm.width * Math.abs(vm.y - vm.base) : vm.height * Math.abs(vm.x - vm.base);
      },
      tooltipPosition: function tooltipPosition() {
        var vm = this._view;
        return {
          x: vm.x,
          y: vm.y
        };
      }
    });
    var elements = {};
    var Arc = element_arc;
    var Line = element_line;
    var Point = element_point;
    var Rectangle = element_rectangle;
    elements.Arc = Arc;
    elements.Line = Line;
    elements.Point = Point;
    elements.Rectangle = Rectangle;
    var deprecated = helpers$1._deprecated;
    var valueOrDefault$3 = helpers$1.valueOrDefault;
    core_defaults._set('bar', {
      hover: {
        mode: 'label'
      },
      scales: {
        xAxes: [{
          type: 'category',
          offset: true,
          gridLines: {
            offsetGridLines: true
          }
        }],
        yAxes: [{
          type: 'linear'
        }]
      }
    });
    core_defaults._set('global', {
      datasets: {
        bar: {
          categoryPercentage: 0.8,
          barPercentage: 0.9
        }
      }
    });
    function computeMinSampleSize(scale, pixels) {
      var min = scale._length;
      var prev, curr, i, ilen;
      for (i = 1, ilen = pixels.length; i < ilen; ++i) {
        min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
      }
      for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
        curr = scale.getPixelForTick(i);
        min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
        prev = curr;
      }
      return min;
    }
    function computeFitCategoryTraits(index, ruler, options) {
      var thickness = options.barThickness;
      var count = ruler.stackCount;
      var curr = ruler.pixels[index];
      var min = helpers$1.isNullOrUndef(thickness) ? computeMinSampleSize(ruler.scale, ruler.pixels) : -1;
      var size, ratio;
      if (helpers$1.isNullOrUndef(thickness)) {
        size = min * options.categoryPercentage;
        ratio = options.barPercentage;
      } else {
        size = thickness * count;
        ratio = 1;
      }
      return {
        chunk: size / count,
        ratio: ratio,
        start: curr - size / 2
      };
    }
    function computeFlexCategoryTraits(index, ruler, options) {
      var pixels = ruler.pixels;
      var curr = pixels[index];
      var prev = index > 0 ? pixels[index - 1] : null;
      var next = index < pixels.length - 1 ? pixels[index + 1] : null;
      var percent = options.categoryPercentage;
      var start, size;
      if (prev === null) {
        prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
      }
      if (next === null) {
        next = curr + curr - prev;
      }
      start = curr - (curr - Math.min(prev, next)) / 2 * percent;
      size = Math.abs(next - prev) / 2 * percent;
      return {
        chunk: size / ruler.stackCount,
        ratio: options.barPercentage,
        start: start
      };
    }
    var controller_bar = core_datasetController.extend({
      dataElementType: elements.Rectangle,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderSkipped', 'borderWidth', 'barPercentage', 'barThickness', 'categoryPercentage', 'maxBarThickness', 'minBarLength'],
      initialize: function initialize() {
        var me = this;
        var meta, scaleOpts;
        core_datasetController.prototype.initialize.apply(me, arguments);
        meta = me.getMeta();
        meta.stack = me.getDataset().stack;
        meta.bar = true;
        scaleOpts = me._getIndexScale().options;
        deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
        deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
        deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
        deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
        deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
      },
      update: function update(reset) {
        var me = this;
        var rects = me.getMeta().data;
        var i, ilen;
        me._ruler = me.getRuler();
        for (i = 0, ilen = rects.length; i < ilen; ++i) {
          me.updateElement(rects[i], i, reset);
        }
      },
      updateElement: function updateElement(rectangle, index, reset) {
        var me = this;
        var meta = me.getMeta();
        var dataset = me.getDataset();
        var options = me._resolveDataElementOptions(rectangle, index);
        rectangle._xScale = me.getScaleForId(meta.xAxisID);
        rectangle._yScale = me.getScaleForId(meta.yAxisID);
        rectangle._datasetIndex = me.index;
        rectangle._index = index;
        rectangle._model = {
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderSkipped: options.borderSkipped,
          borderWidth: options.borderWidth,
          datasetLabel: dataset.label,
          label: me.chart.data.labels[index]
        };
        if (helpers$1.isArray(dataset.data[index])) {
          rectangle._model.borderSkipped = null;
        }
        me._updateElementGeometry(rectangle, index, reset, options);
        rectangle.pivot();
      },
      _updateElementGeometry: function _updateElementGeometry(rectangle, index, reset, options) {
        var me = this;
        var model = rectangle._model;
        var vscale = me._getValueScale();
        var base = vscale.getBasePixel();
        var horizontal = vscale.isHorizontal();
        var ruler = me._ruler || me.getRuler();
        var vpixels = me.calculateBarValuePixels(me.index, index, options);
        var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
        model.horizontal = horizontal;
        model.base = reset ? base : vpixels.base;
        model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
        model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
        model.height = horizontal ? ipixels.size : undefined;
        model.width = horizontal ? undefined : ipixels.size;
      },
      _getStacks: function _getStacks(last) {
        var me = this;
        var scale = me._getIndexScale();
        var metasets = scale._getMatchingVisibleMetas(me._type);
        var stacked = scale.options.stacked;
        var ilen = metasets.length;
        var stacks = [];
        var i, meta;
        for (i = 0; i < ilen; ++i) {
          meta = metasets[i];
          if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) {
            stacks.push(meta.stack);
          }
          if (meta.index === last) {
            break;
          }
        }
        return stacks;
      },
      getStackCount: function getStackCount() {
        return this._getStacks().length;
      },
      getStackIndex: function getStackIndex(datasetIndex, name) {
        var stacks = this._getStacks(datasetIndex);
        var index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
      },
      getRuler: function getRuler() {
        var me = this;
        var scale = me._getIndexScale();
        var pixels = [];
        var i, ilen;
        for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
          pixels.push(scale.getPixelForValue(null, i, me.index));
        }
        return {
          pixels: pixels,
          start: scale._startPixel,
          end: scale._endPixel,
          stackCount: me.getStackCount(),
          scale: scale
        };
      },
      calculateBarValuePixels: function calculateBarValuePixels(datasetIndex, index, options) {
        var me = this;
        var chart = me.chart;
        var scale = me._getValueScale();
        var isHorizontal = scale.isHorizontal();
        var datasets = chart.data.datasets;
        var metasets = scale._getMatchingVisibleMetas(me._type);
        var value = scale._parseValue(datasets[datasetIndex].data[index]);
        var minBarLength = options.minBarLength;
        var stacked = scale.options.stacked;
        var stack = me.getMeta().stack;
        var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
        var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
        var ilen = metasets.length;
        var i, imeta, ivalue, base, head, size, stackLength;
        if (stacked || stacked === undefined && stack !== undefined) {
          for (i = 0; i < ilen; ++i) {
            imeta = metasets[i];
            if (imeta.index === datasetIndex) {
              break;
            }
            if (imeta.stack === stack) {
              stackLength = scale._parseValue(datasets[imeta.index].data[index]);
              ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
              if (value.min < 0 && ivalue < 0 || value.max >= 0 && ivalue > 0) {
                start += ivalue;
              }
            }
          }
        }
        base = scale.getPixelForValue(start);
        head = scale.getPixelForValue(start + length);
        size = head - base;
        if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
          size = minBarLength;
          if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
            head = base - minBarLength;
          } else {
            head = base + minBarLength;
          }
        }
        return {
          size: size,
          base: base,
          head: head,
          center: head + size / 2
        };
      },
      calculateBarIndexPixels: function calculateBarIndexPixels(datasetIndex, index, ruler, options) {
        var me = this;
        var range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options) : computeFitCategoryTraits(index, ruler, options);
        var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
        var center = range.start + range.chunk * stackIndex + range.chunk / 2;
        var size = Math.min(valueOrDefault$3(options.maxBarThickness, Infinity), range.chunk * range.ratio);
        return {
          base: center - size / 2,
          head: center + size / 2,
          center: center,
          size: size
        };
      },
      draw: function draw() {
        var me = this;
        var chart = me.chart;
        var scale = me._getValueScale();
        var rects = me.getMeta().data;
        var dataset = me.getDataset();
        var ilen = rects.length;
        var i = 0;
        helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
        for (; i < ilen; ++i) {
          var val = scale._parseValue(dataset.data[i]);
          if (!isNaN(val.min) && !isNaN(val.max)) {
            rects[i].draw();
          }
        }
        helpers$1.canvas.unclipArea(chart.ctx);
      },
      _resolveDataElementOptions: function _resolveDataElementOptions() {
        var me = this;
        var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
        var indexOpts = me._getIndexScale().options;
        var valueOpts = me._getValueScale().options;
        values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
        values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
        values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
        values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
        values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
        return values;
      }
    });
    var valueOrDefault$4 = helpers$1.valueOrDefault;
    var resolve$1 = helpers$1.options.resolve;
    core_defaults._set('bubble', {
      hover: {
        mode: 'single'
      },
      scales: {
        xAxes: [{
          type: 'linear',
          position: 'bottom',
          id: 'x-axis-0'
        }],
        yAxes: [{
          type: 'linear',
          position: 'left',
          id: 'y-axis-0'
        }]
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(item, data) {
            var datasetLabel = data.datasets[item.datasetIndex].label || '';
            var dataPoint = data.datasets[item.datasetIndex].data[item.index];
            return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
          }
        }
      }
    });
    var controller_bubble = core_datasetController.extend({
      dataElementType: elements.Point,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth', 'hoverRadius', 'hitRadius', 'pointStyle', 'rotation'],
      update: function update(reset) {
        var me = this;
        var meta = me.getMeta();
        var points = meta.data;
        helpers$1.each(points, function (point, index) {
          me.updateElement(point, index, reset);
        });
      },
      updateElement: function updateElement(point, index, reset) {
        var me = this;
        var meta = me.getMeta();
        var custom = point.custom || {};
        var xScale = me.getScaleForId(meta.xAxisID);
        var yScale = me.getScaleForId(meta.yAxisID);
        var options = me._resolveDataElementOptions(point, index);
        var data = me.getDataset().data[index];
        var dsIndex = me.index;
        var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
        var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
        point._xScale = xScale;
        point._yScale = yScale;
        point._options = options;
        point._datasetIndex = dsIndex;
        point._index = index;
        point._model = {
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderWidth: options.borderWidth,
          hitRadius: options.hitRadius,
          pointStyle: options.pointStyle,
          rotation: options.rotation,
          radius: reset ? 0 : options.radius,
          skip: custom.skip || isNaN(x) || isNaN(y),
          x: x,
          y: y
        };
        point.pivot();
      },
      setHoverStyle: function setHoverStyle(point) {
        var model = point._model;
        var options = point._options;
        var getHoverColor = helpers$1.getHoverColor;
        point.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth,
          radius: model.radius
        };
        model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
        model.radius = options.radius + options.hoverRadius;
      },
      _resolveDataElementOptions: function _resolveDataElementOptions(point, index) {
        var me = this;
        var chart = me.chart;
        var dataset = me.getDataset();
        var custom = point.custom || {};
        var data = dataset.data[index] || {};
        var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
        var context = {
          chart: chart,
          dataIndex: index,
          dataset: dataset,
          datasetIndex: me.index
        };
        if (me._cachedDataOpts === values) {
          values = helpers$1.extend({}, values);
        }
        values.radius = resolve$1([custom.radius, data.r, me._config.radius, chart.options.elements.point.radius], context, index);
        return values;
      }
    });
    var valueOrDefault$5 = helpers$1.valueOrDefault;
    var PI$1 = Math.PI;
    var DOUBLE_PI$1 = PI$1 * 2;
    var HALF_PI$1 = PI$1 / 2;
    core_defaults._set('doughnut', {
      animation: {
        animateRotate: true,
        animateScale: false
      },
      hover: {
        mode: 'single'
      },
      legendCallback: function legendCallback(chart) {
        var list = document.createElement('ul');
        var data = chart.data;
        var datasets = data.datasets;
        var labels = data.labels;
        var i, ilen, listItem, listItemSpan;
        list.setAttribute('class', chart.id + '-legend');
        if (datasets.length) {
          for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
            listItem = list.appendChild(document.createElement('li'));
            listItemSpan = listItem.appendChild(document.createElement('span'));
            listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
            if (labels[i]) {
              listItem.appendChild(document.createTextNode(labels[i]));
            }
          }
        }
        return list.outerHTML;
      },
      legend: {
        labels: {
          generateLabels: function generateLabels(chart) {
            var data = chart.data;
            if (data.labels.length && data.datasets.length) {
              return data.labels.map(function (label, i) {
                var meta = chart.getDatasetMeta(0);
                var style = meta.controller.getStyle(i);
                return {
                  text: label,
                  fillStyle: style.backgroundColor,
                  strokeStyle: style.borderColor,
                  lineWidth: style.borderWidth,
                  hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                  index: i
                };
              });
            }
            return [];
          }
        },
        onClick: function onClick(e, legendItem) {
          var index = legendItem.index;
          var chart = this.chart;
          var i, ilen, meta;
          for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
            meta = chart.getDatasetMeta(i);
            if (meta.data[index]) {
              meta.data[index].hidden = !meta.data[index].hidden;
            }
          }
          chart.update();
        }
      },
      cutoutPercentage: 50,
      rotation: -HALF_PI$1,
      circumference: DOUBLE_PI$1,
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(tooltipItem, data) {
            var dataLabel = data.labels[tooltipItem.index];
            var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            if (helpers$1.isArray(dataLabel)) {
              dataLabel = dataLabel.slice();
              dataLabel[0] += value;
            } else {
              dataLabel += value;
            }
            return dataLabel;
          }
        }
      }
    });
    var controller_doughnut = core_datasetController.extend({
      dataElementType: elements.Arc,
      linkScales: helpers$1.noop,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'borderAlign', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth'],
      getRingIndex: function getRingIndex(datasetIndex) {
        var ringIndex = 0;
        for (var j = 0; j < datasetIndex; ++j) {
          if (this.chart.isDatasetVisible(j)) {
            ++ringIndex;
          }
        }
        return ringIndex;
      },
      update: function update(reset) {
        var me = this;
        var chart = me.chart;
        var chartArea = chart.chartArea;
        var opts = chart.options;
        var ratioX = 1;
        var ratioY = 1;
        var offsetX = 0;
        var offsetY = 0;
        var meta = me.getMeta();
        var arcs = meta.data;
        var cutout = opts.cutoutPercentage / 100 || 0;
        var circumference = opts.circumference;
        var chartWeight = me._getRingWeight(me.index);
        var maxWidth, maxHeight, i, ilen;
        if (circumference < DOUBLE_PI$1) {
          var startAngle = opts.rotation % DOUBLE_PI$1;
          startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
          var endAngle = startAngle + circumference;
          var startX = Math.cos(startAngle);
          var startY = Math.sin(startAngle);
          var endX = Math.cos(endAngle);
          var endY = Math.sin(endAngle);
          var contains0 = startAngle <= 0 && endAngle >= 0 || endAngle >= DOUBLE_PI$1;
          var contains90 = startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1 || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
          var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
          var contains270 = startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1 || endAngle >= PI$1 + HALF_PI$1;
          var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
          var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
          var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
          var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
          ratioX = (maxX - minX) / 2;
          ratioY = (maxY - minY) / 2;
          offsetX = -(maxX + minX) / 2;
          offsetY = -(maxY + minY) / 2;
        }
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
        }
        chart.borderWidth = me.getMaxBorderWidth();
        maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
        maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
        chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
        chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
        chart.offsetX = offsetX * chart.outerRadius;
        chart.offsetY = offsetY * chart.outerRadius;
        meta.total = me.calculateTotal();
        me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
        me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          me.updateElement(arcs[i], i, reset);
        }
      },
      updateElement: function updateElement(arc, index, reset) {
        var me = this;
        var chart = me.chart;
        var chartArea = chart.chartArea;
        var opts = chart.options;
        var animationOpts = opts.animation;
        var centerX = (chartArea.left + chartArea.right) / 2;
        var centerY = (chartArea.top + chartArea.bottom) / 2;
        var startAngle = opts.rotation;
        var endAngle = opts.rotation;
        var dataset = me.getDataset();
        var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
        var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
        var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
        var options = arc._options || {};
        helpers$1.extend(arc, {
          _datasetIndex: me.index,
          _index: index,
          _model: {
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: options.borderWidth,
            borderAlign: options.borderAlign,
            x: centerX + chart.offsetX,
            y: centerY + chart.offsetY,
            startAngle: startAngle,
            endAngle: endAngle,
            circumference: circumference,
            outerRadius: outerRadius,
            innerRadius: innerRadius,
            label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
          }
        });
        var model = arc._model;
        if (!reset || !animationOpts.animateRotate) {
          if (index === 0) {
            model.startAngle = opts.rotation;
          } else {
            model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
          }
          model.endAngle = model.startAngle + model.circumference;
        }
        arc.pivot();
      },
      calculateTotal: function calculateTotal() {
        var dataset = this.getDataset();
        var meta = this.getMeta();
        var total = 0;
        var value;
        helpers$1.each(meta.data, function (element, index) {
          value = dataset.data[index];
          if (!isNaN(value) && !element.hidden) {
            total += Math.abs(value);
          }
        });
        return total;
      },
      calculateCircumference: function calculateCircumference(value) {
        var total = this.getMeta().total;
        if (total > 0 && !isNaN(value)) {
          return DOUBLE_PI$1 * (Math.abs(value) / total);
        }
        return 0;
      },
      getMaxBorderWidth: function getMaxBorderWidth(arcs) {
        var me = this;
        var max = 0;
        var chart = me.chart;
        var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
        if (!arcs) {
          for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
            if (chart.isDatasetVisible(i)) {
              meta = chart.getDatasetMeta(i);
              arcs = meta.data;
              if (i !== me.index) {
                controller = meta.controller;
              }
              break;
            }
          }
        }
        if (!arcs) {
          return 0;
        }
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          arc = arcs[i];
          if (controller) {
            controller._configure();
            options = controller._resolveDataElementOptions(arc, i);
          } else {
            options = arc._options;
          }
          if (options.borderAlign !== 'inner') {
            borderWidth = options.borderWidth;
            hoverWidth = options.hoverBorderWidth;
            max = borderWidth > max ? borderWidth : max;
            max = hoverWidth > max ? hoverWidth : max;
          }
        }
        return max;
      },
      setHoverStyle: function setHoverStyle(arc) {
        var model = arc._model;
        var options = arc._options;
        var getHoverColor = helpers$1.getHoverColor;
        arc.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth
        };
        model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
      },
      _getRingWeightOffset: function _getRingWeightOffset(datasetIndex) {
        var ringWeightOffset = 0;
        for (var i = 0; i < datasetIndex; ++i) {
          if (this.chart.isDatasetVisible(i)) {
            ringWeightOffset += this._getRingWeight(i);
          }
        }
        return ringWeightOffset;
      },
      _getRingWeight: function _getRingWeight(dataSetIndex) {
        return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
      },
      _getVisibleDatasetWeightTotal: function _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length);
      }
    });
    core_defaults._set('horizontalBar', {
      hover: {
        mode: 'index',
        axis: 'y'
      },
      scales: {
        xAxes: [{
          type: 'linear',
          position: 'bottom'
        }],
        yAxes: [{
          type: 'category',
          position: 'left',
          offset: true,
          gridLines: {
            offsetGridLines: true
          }
        }]
      },
      elements: {
        rectangle: {
          borderSkipped: 'left'
        }
      },
      tooltips: {
        mode: 'index',
        axis: 'y'
      }
    });
    core_defaults._set('global', {
      datasets: {
        horizontalBar: {
          categoryPercentage: 0.8,
          barPercentage: 0.9
        }
      }
    });
    var controller_horizontalBar = controller_bar.extend({
      _getValueScaleId: function _getValueScaleId() {
        return this.getMeta().xAxisID;
      },
      _getIndexScaleId: function _getIndexScaleId() {
        return this.getMeta().yAxisID;
      }
    });
    var valueOrDefault$6 = helpers$1.valueOrDefault;
    var resolve$2 = helpers$1.options.resolve;
    var isPointInArea = helpers$1.canvas._isPointInArea;
    core_defaults._set('line', {
      showLines: true,
      spanGaps: false,
      hover: {
        mode: 'label'
      },
      scales: {
        xAxes: [{
          type: 'category',
          id: 'x-axis-0'
        }],
        yAxes: [{
          type: 'linear',
          id: 'y-axis-0'
        }]
      }
    });
    function scaleClip(scale, halfBorderWidth) {
      var tickOpts = scale && scale.options.ticks || {};
      var reverse = tickOpts.reverse;
      var min = tickOpts.min === undefined ? halfBorderWidth : 0;
      var max = tickOpts.max === undefined ? halfBorderWidth : 0;
      return {
        start: reverse ? max : min,
        end: reverse ? min : max
      };
    }
    function defaultClip(xScale, yScale, borderWidth) {
      var halfBorderWidth = borderWidth / 2;
      var x = scaleClip(xScale, halfBorderWidth);
      var y = scaleClip(yScale, halfBorderWidth);
      return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
      };
    }
    function toClip(value) {
      var t, r, b, l;
      if (helpers$1.isObject(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
      } else {
        t = r = b = l = value;
      }
      return {
        top: t,
        right: r,
        bottom: b,
        left: l
      };
    }
    var controller_line = core_datasetController.extend({
      datasetElementType: elements.Line,
      dataElementType: elements.Point,
      _datasetElementOptions: ['backgroundColor', 'borderCapStyle', 'borderColor', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'borderWidth', 'cubicInterpolationMode', 'fill'],
      _dataElementOptions: {
        backgroundColor: 'pointBackgroundColor',
        borderColor: 'pointBorderColor',
        borderWidth: 'pointBorderWidth',
        hitRadius: 'pointHitRadius',
        hoverBackgroundColor: 'pointHoverBackgroundColor',
        hoverBorderColor: 'pointHoverBorderColor',
        hoverBorderWidth: 'pointHoverBorderWidth',
        hoverRadius: 'pointHoverRadius',
        pointStyle: 'pointStyle',
        radius: 'pointRadius',
        rotation: 'pointRotation'
      },
      update: function update(reset) {
        var me = this;
        var meta = me.getMeta();
        var line = meta.dataset;
        var points = meta.data || [];
        var options = me.chart.options;
        var config = me._config;
        var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
        var i, ilen;
        me._xScale = me.getScaleForId(meta.xAxisID);
        me._yScale = me.getScaleForId(meta.yAxisID);
        if (showLine) {
          if (config.tension !== undefined && config.lineTension === undefined) {
            config.lineTension = config.tension;
          }
          line._scale = me._yScale;
          line._datasetIndex = me.index;
          line._children = points;
          line._model = me._resolveDatasetElementOptions(line);
          line.pivot();
        }
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          me.updateElement(points[i], i, reset);
        }
        if (showLine && line._model.tension !== 0) {
          me.updateBezierControlPoints();
        }
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          points[i].pivot();
        }
      },
      updateElement: function updateElement(point, index, reset) {
        var me = this;
        var meta = me.getMeta();
        var custom = point.custom || {};
        var dataset = me.getDataset();
        var datasetIndex = me.index;
        var value = dataset.data[index];
        var xScale = me._xScale;
        var yScale = me._yScale;
        var lineModel = meta.dataset._model;
        var x, y;
        var options = me._resolveDataElementOptions(point, index);
        x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
        y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
        point._xScale = xScale;
        point._yScale = yScale;
        point._options = options;
        point._datasetIndex = datasetIndex;
        point._index = index;
        point._model = {
          x: x,
          y: y,
          skip: custom.skip || isNaN(x) || isNaN(y),
          radius: options.radius,
          pointStyle: options.pointStyle,
          rotation: options.rotation,
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderWidth: options.borderWidth,
          tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
          steppedLine: lineModel ? lineModel.steppedLine : false,
          hitRadius: options.hitRadius
        };
      },
      _resolveDatasetElementOptions: function _resolveDatasetElementOptions(element) {
        var me = this;
        var config = me._config;
        var custom = element.custom || {};
        var options = me.chart.options;
        var lineOptions = options.elements.line;
        var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
        values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
        values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
        values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
        values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
        return values;
      },
      calculatePointY: function calculatePointY(value, index, datasetIndex) {
        var me = this;
        var chart = me.chart;
        var yScale = me._yScale;
        var sumPos = 0;
        var sumNeg = 0;
        var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
        if (yScale.options.stacked) {
          rightValue = +yScale.getRightValue(value);
          metasets = chart._getSortedVisibleDatasetMetas();
          ilen = metasets.length;
          for (i = 0; i < ilen; ++i) {
            dsMeta = metasets[i];
            if (dsMeta.index === datasetIndex) {
              break;
            }
            ds = chart.data.datasets[dsMeta.index];
            if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
              stackedRightValue = +yScale.getRightValue(ds.data[index]);
              if (stackedRightValue < 0) {
                sumNeg += stackedRightValue || 0;
              } else {
                sumPos += stackedRightValue || 0;
              }
            }
          }
          if (rightValue < 0) {
            return yScale.getPixelForValue(sumNeg + rightValue);
          }
          return yScale.getPixelForValue(sumPos + rightValue);
        }
        return yScale.getPixelForValue(value);
      },
      updateBezierControlPoints: function updateBezierControlPoints() {
        var me = this;
        var chart = me.chart;
        var meta = me.getMeta();
        var lineModel = meta.dataset._model;
        var area = chart.chartArea;
        var points = meta.data || [];
        var i, ilen, model, controlPoints;
        if (lineModel.spanGaps) {
          points = points.filter(function (pt) {
            return !pt._model.skip;
          });
        }
        function capControlPoint(pt, min, max) {
          return Math.max(Math.min(pt, max), min);
        }
        if (lineModel.cubicInterpolationMode === 'monotone') {
          helpers$1.splineCurveMonotone(points);
        } else {
          for (i = 0, ilen = points.length; i < ilen; ++i) {
            model = points[i]._model;
            controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i)._model, model, helpers$1.nextItem(points, i)._model, lineModel.tension);
            model.controlPointPreviousX = controlPoints.previous.x;
            model.controlPointPreviousY = controlPoints.previous.y;
            model.controlPointNextX = controlPoints.next.x;
            model.controlPointNextY = controlPoints.next.y;
          }
        }
        if (chart.options.elements.line.capBezierPoints) {
          for (i = 0, ilen = points.length; i < ilen; ++i) {
            model = points[i]._model;
            if (isPointInArea(model, area)) {
              if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
                model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
                model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
              }
              if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
                model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
                model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
              }
            }
          }
        }
      },
      draw: function draw() {
        var me = this;
        var chart = me.chart;
        var meta = me.getMeta();
        var points = meta.data || [];
        var area = chart.chartArea;
        var canvas = chart.canvas;
        var i = 0;
        var ilen = points.length;
        var clip;
        if (me._showLine) {
          clip = meta.dataset._model.clip;
          helpers$1.canvas.clipArea(chart.ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? canvas.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
          });
          meta.dataset.draw();
          helpers$1.canvas.unclipArea(chart.ctx);
        }
        for (; i < ilen; ++i) {
          points[i].draw(area);
        }
      },
      setHoverStyle: function setHoverStyle(point) {
        var model = point._model;
        var options = point._options;
        var getHoverColor = helpers$1.getHoverColor;
        point.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth,
          radius: model.radius
        };
        model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
        model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
      }
    });
    var resolve$3 = helpers$1.options.resolve;
    core_defaults._set('polarArea', {
      scale: {
        type: 'radialLinear',
        angleLines: {
          display: false
        },
        gridLines: {
          circular: true
        },
        pointLabels: {
          display: false
        },
        ticks: {
          beginAtZero: true
        }
      },
      animation: {
        animateRotate: true,
        animateScale: true
      },
      startAngle: -0.5 * Math.PI,
      legendCallback: function legendCallback(chart) {
        var list = document.createElement('ul');
        var data = chart.data;
        var datasets = data.datasets;
        var labels = data.labels;
        var i, ilen, listItem, listItemSpan;
        list.setAttribute('class', chart.id + '-legend');
        if (datasets.length) {
          for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
            listItem = list.appendChild(document.createElement('li'));
            listItemSpan = listItem.appendChild(document.createElement('span'));
            listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
            if (labels[i]) {
              listItem.appendChild(document.createTextNode(labels[i]));
            }
          }
        }
        return list.outerHTML;
      },
      legend: {
        labels: {
          generateLabels: function generateLabels(chart) {
            var data = chart.data;
            if (data.labels.length && data.datasets.length) {
              return data.labels.map(function (label, i) {
                var meta = chart.getDatasetMeta(0);
                var style = meta.controller.getStyle(i);
                return {
                  text: label,
                  fillStyle: style.backgroundColor,
                  strokeStyle: style.borderColor,
                  lineWidth: style.borderWidth,
                  hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                  index: i
                };
              });
            }
            return [];
          }
        },
        onClick: function onClick(e, legendItem) {
          var index = legendItem.index;
          var chart = this.chart;
          var i, ilen, meta;
          for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
            meta = chart.getDatasetMeta(i);
            meta.data[index].hidden = !meta.data[index].hidden;
          }
          chart.update();
        }
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(item, data) {
            return data.labels[item.index] + ': ' + item.yLabel;
          }
        }
      }
    });
    var controller_polarArea = core_datasetController.extend({
      dataElementType: elements.Arc,
      linkScales: helpers$1.noop,
      _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'borderAlign', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth'],
      _getIndexScaleId: function _getIndexScaleId() {
        return this.chart.scale.id;
      },
      _getValueScaleId: function _getValueScaleId() {
        return this.chart.scale.id;
      },
      update: function update(reset) {
        var me = this;
        var dataset = me.getDataset();
        var meta = me.getMeta();
        var start = me.chart.options.startAngle || 0;
        var starts = me._starts = [];
        var angles = me._angles = [];
        var arcs = meta.data;
        var i, ilen, angle;
        me._updateRadius();
        meta.count = me.countVisibleElements();
        for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
          starts[i] = start;
          angle = me._computeAngle(i);
          angles[i] = angle;
          start += angle;
        }
        for (i = 0, ilen = arcs.length; i < ilen; ++i) {
          arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
          me.updateElement(arcs[i], i, reset);
        }
      },
      _updateRadius: function _updateRadius() {
        var me = this;
        var chart = me.chart;
        var chartArea = chart.chartArea;
        var opts = chart.options;
        var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        chart.outerRadius = Math.max(minSize / 2, 0);
        chart.innerRadius = Math.max(opts.cutoutPercentage ? chart.outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
        me.outerRadius = chart.outerRadius - chart.radiusLength * me.index;
        me.innerRadius = me.outerRadius - chart.radiusLength;
      },
      updateElement: function updateElement(arc, index, reset) {
        var me = this;
        var chart = me.chart;
        var dataset = me.getDataset();
        var opts = chart.options;
        var animationOpts = opts.animation;
        var scale = chart.scale;
        var labels = chart.data.labels;
        var centerX = scale.xCenter;
        var centerY = scale.yCenter;
        var datasetStartAngle = opts.startAngle;
        var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
        var startAngle = me._starts[index];
        var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
        var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
        var options = arc._options || {};
        helpers$1.extend(arc, {
          _datasetIndex: me.index,
          _index: index,
          _scale: scale,
          _model: {
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: options.borderWidth,
            borderAlign: options.borderAlign,
            x: centerX,
            y: centerY,
            innerRadius: 0,
            outerRadius: reset ? resetRadius : distance,
            startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
            endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
            label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
          }
        });
        arc.pivot();
      },
      countVisibleElements: function countVisibleElements() {
        var dataset = this.getDataset();
        var meta = this.getMeta();
        var count = 0;
        helpers$1.each(meta.data, function (element, index) {
          if (!isNaN(dataset.data[index]) && !element.hidden) {
            count++;
          }
        });
        return count;
      },
      setHoverStyle: function setHoverStyle(arc) {
        var model = arc._model;
        var options = arc._options;
        var getHoverColor = helpers$1.getHoverColor;
        var valueOrDefault = helpers$1.valueOrDefault;
        arc.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth
        };
        model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
      },
      _computeAngle: function _computeAngle(index) {
        var me = this;
        var count = this.getMeta().count;
        var dataset = me.getDataset();
        var meta = me.getMeta();
        if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
          return 0;
        }
        var context = {
          chart: me.chart,
          dataIndex: index,
          dataset: dataset,
          datasetIndex: me.index
        };
        return resolve$3([me.chart.options.elements.arc.angle, 2 * Math.PI / count], context, index);
      }
    });
    core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
    core_defaults._set('pie', {
      cutoutPercentage: 0
    });
    var controller_pie = controller_doughnut;
    var valueOrDefault$7 = helpers$1.valueOrDefault;
    core_defaults._set('radar', {
      spanGaps: false,
      scale: {
        type: 'radialLinear'
      },
      elements: {
        line: {
          fill: 'start',
          tension: 0
        }
      }
    });
    var controller_radar = core_datasetController.extend({
      datasetElementType: elements.Line,
      dataElementType: elements.Point,
      linkScales: helpers$1.noop,
      _datasetElementOptions: ['backgroundColor', 'borderWidth', 'borderColor', 'borderCapStyle', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'fill'],
      _dataElementOptions: {
        backgroundColor: 'pointBackgroundColor',
        borderColor: 'pointBorderColor',
        borderWidth: 'pointBorderWidth',
        hitRadius: 'pointHitRadius',
        hoverBackgroundColor: 'pointHoverBackgroundColor',
        hoverBorderColor: 'pointHoverBorderColor',
        hoverBorderWidth: 'pointHoverBorderWidth',
        hoverRadius: 'pointHoverRadius',
        pointStyle: 'pointStyle',
        radius: 'pointRadius',
        rotation: 'pointRotation'
      },
      _getIndexScaleId: function _getIndexScaleId() {
        return this.chart.scale.id;
      },
      _getValueScaleId: function _getValueScaleId() {
        return this.chart.scale.id;
      },
      update: function update(reset) {
        var me = this;
        var meta = me.getMeta();
        var line = meta.dataset;
        var points = meta.data || [];
        var scale = me.chart.scale;
        var config = me._config;
        var i, ilen;
        if (config.tension !== undefined && config.lineTension === undefined) {
          config.lineTension = config.tension;
        }
        line._scale = scale;
        line._datasetIndex = me.index;
        line._children = points;
        line._loop = true;
        line._model = me._resolveDatasetElementOptions(line);
        line.pivot();
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          me.updateElement(points[i], i, reset);
        }
        me.updateBezierControlPoints();
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          points[i].pivot();
        }
      },
      updateElement: function updateElement(point, index, reset) {
        var me = this;
        var custom = point.custom || {};
        var dataset = me.getDataset();
        var scale = me.chart.scale;
        var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
        var options = me._resolveDataElementOptions(point, index);
        var lineModel = me.getMeta().dataset._model;
        var x = reset ? scale.xCenter : pointPosition.x;
        var y = reset ? scale.yCenter : pointPosition.y;
        point._scale = scale;
        point._options = options;
        point._datasetIndex = me.index;
        point._index = index;
        point._model = {
          x: x,
          y: y,
          skip: custom.skip || isNaN(x) || isNaN(y),
          radius: options.radius,
          pointStyle: options.pointStyle,
          rotation: options.rotation,
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderWidth: options.borderWidth,
          tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
          hitRadius: options.hitRadius
        };
      },
      _resolveDatasetElementOptions: function _resolveDatasetElementOptions() {
        var me = this;
        var config = me._config;
        var options = me.chart.options;
        var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
        values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
        values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
        return values;
      },
      updateBezierControlPoints: function updateBezierControlPoints() {
        var me = this;
        var meta = me.getMeta();
        var area = me.chart.chartArea;
        var points = meta.data || [];
        var i, ilen, model, controlPoints;
        if (meta.dataset._model.spanGaps) {
          points = points.filter(function (pt) {
            return !pt._model.skip;
          });
        }
        function capControlPoint(pt, min, max) {
          return Math.max(Math.min(pt, max), min);
        }
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          model = points[i]._model;
          controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i, true)._model, model, helpers$1.nextItem(points, i, true)._model, model.tension);
          model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
          model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
          model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
          model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
        }
      },
      setHoverStyle: function setHoverStyle(point) {
        var model = point._model;
        var options = point._options;
        var getHoverColor = helpers$1.getHoverColor;
        point.$previousStyle = {
          backgroundColor: model.backgroundColor,
          borderColor: model.borderColor,
          borderWidth: model.borderWidth,
          radius: model.radius
        };
        model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
        model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
        model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
        model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
      }
    });
    core_defaults._set('scatter', {
      hover: {
        mode: 'single'
      },
      scales: {
        xAxes: [{
          id: 'x-axis-1',
          type: 'linear',
          position: 'bottom'
        }],
        yAxes: [{
          id: 'y-axis-1',
          type: 'linear',
          position: 'left'
        }]
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return '';
          },
          label: function label(item) {
            return '(' + item.xLabel + ', ' + item.yLabel + ')';
          }
        }
      }
    });
    core_defaults._set('global', {
      datasets: {
        scatter: {
          showLine: false
        }
      }
    });
    var controller_scatter = controller_line;
    var controllers = {
      bar: controller_bar,
      bubble: controller_bubble,
      doughnut: controller_doughnut,
      horizontalBar: controller_horizontalBar,
      line: controller_line,
      polarArea: controller_polarArea,
      pie: controller_pie,
      radar: controller_radar,
      scatter: controller_scatter
    };
    function getRelativePosition(e, chart) {
      if (e["native"]) {
        return {
          x: e.x,
          y: e.y
        };
      }
      return helpers$1.getRelativePosition(e, chart);
    }
    function parseVisibleItems(chart, handler) {
      var metasets = chart._getSortedVisibleDatasetMetas();
      var metadata, i, j, ilen, jlen, element;
      for (i = 0, ilen = metasets.length; i < ilen; ++i) {
        metadata = metasets[i].data;
        for (j = 0, jlen = metadata.length; j < jlen; ++j) {
          element = metadata[j];
          if (!element._view.skip) {
            handler(element);
          }
        }
      }
    }
    function getIntersectItems(chart, position) {
      var elements = [];
      parseVisibleItems(chart, function (element) {
        if (element.inRange(position.x, position.y)) {
          elements.push(element);
        }
      });
      return elements;
    }
    function getNearestItems(chart, position, intersect, distanceMetric) {
      var minDistance = Number.POSITIVE_INFINITY;
      var nearestItems = [];
      parseVisibleItems(chart, function (element) {
        if (intersect && !element.inRange(position.x, position.y)) {
          return;
        }
        var center = element.getCenterPoint();
        var distance = distanceMetric(position, center);
        if (distance < minDistance) {
          nearestItems = [element];
          minDistance = distance;
        } else if (distance === minDistance) {
          nearestItems.push(element);
        }
      });
      return nearestItems;
    }
    function getDistanceMetricForAxis(axis) {
      var useX = axis.indexOf('x') !== -1;
      var useY = axis.indexOf('y') !== -1;
      return function (pt1, pt2) {
        var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
      };
    }
    function indexMode(chart, e, options) {
      var position = getRelativePosition(e, chart);
      options.axis = options.axis || 'x';
      var distanceMetric = getDistanceMetricForAxis(options.axis);
      var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
      var elements = [];
      if (!items.length) {
        return [];
      }
      chart._getSortedVisibleDatasetMetas().forEach(function (meta) {
        var element = meta.data[items[0]._index];
        if (element && !element._view.skip) {
          elements.push(element);
        }
      });
      return elements;
    }
    var core_interaction = {
      modes: {
        single: function single(chart, e) {
          var position = getRelativePosition(e, chart);
          var elements = [];
          parseVisibleItems(chart, function (element) {
            if (element.inRange(position.x, position.y)) {
              elements.push(element);
              return elements;
            }
          });
          return elements.slice(0, 1);
        },
        label: indexMode,
        index: indexMode,
        dataset: function dataset(chart, e, options) {
          var position = getRelativePosition(e, chart);
          options.axis = options.axis || 'xy';
          var distanceMetric = getDistanceMetricForAxis(options.axis);
          var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
          if (items.length > 0) {
            items = chart.getDatasetMeta(items[0]._datasetIndex).data;
          }
          return items;
        },
        'x-axis': function xAxis(chart, e) {
          return indexMode(chart, e, {
            intersect: false
          });
        },
        point: function point(chart, e) {
          var position = getRelativePosition(e, chart);
          return getIntersectItems(chart, position);
        },
        nearest: function nearest(chart, e, options) {
          var position = getRelativePosition(e, chart);
          options.axis = options.axis || 'xy';
          var distanceMetric = getDistanceMetricForAxis(options.axis);
          return getNearestItems(chart, position, options.intersect, distanceMetric);
        },
        x: function x(chart, e, options) {
          var position = getRelativePosition(e, chart);
          var items = [];
          var intersectsItem = false;
          parseVisibleItems(chart, function (element) {
            if (element.inXRange(position.x)) {
              items.push(element);
            }
            if (element.inRange(position.x, position.y)) {
              intersectsItem = true;
            }
          });
          if (options.intersect && !intersectsItem) {
            items = [];
          }
          return items;
        },
        y: function y(chart, e, options) {
          var position = getRelativePosition(e, chart);
          var items = [];
          var intersectsItem = false;
          parseVisibleItems(chart, function (element) {
            if (element.inYRange(position.y)) {
              items.push(element);
            }
            if (element.inRange(position.x, position.y)) {
              intersectsItem = true;
            }
          });
          if (options.intersect && !intersectsItem) {
            items = [];
          }
          return items;
        }
      }
    };
    var extend = helpers$1.extend;
    function filterByPosition(array, position) {
      return helpers$1.where(array, function (v) {
        return v.pos === position;
      });
    }
    function sortByWeight(array, reverse) {
      return array.sort(function (a, b) {
        var v0 = reverse ? b : a;
        var v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
      });
    }
    function wrapBoxes(boxes) {
      var layoutBoxes = [];
      var i, ilen, box;
      for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
        box = boxes[i];
        layoutBoxes.push({
          index: i,
          box: box,
          pos: box.position,
          horizontal: box.isHorizontal(),
          weight: box.weight
        });
      }
      return layoutBoxes;
    }
    function setLayoutDims(layouts, params) {
      var i, ilen, layout;
      for (i = 0, ilen = layouts.length; i < ilen; ++i) {
        layout = layouts[i];
        layout.width = layout.horizontal ? layout.box.fullWidth && params.availableWidth : params.vBoxMaxWidth;
        layout.height = layout.horizontal && params.hBoxMaxHeight;
      }
    }
    function buildLayoutBoxes(boxes) {
      var layoutBoxes = wrapBoxes(boxes);
      var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
      var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
      var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
      var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
      return {
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(bottom),
        chartArea: filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right),
        horizontal: top.concat(bottom)
      };
    }
    function getCombinedMax(maxPadding, chartArea, a, b) {
      return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
    }
    function updateDims(chartArea, params, layout) {
      var box = layout.box;
      var maxPadding = chartArea.maxPadding;
      var newWidth, newHeight;
      if (layout.size) {
        chartArea[layout.pos] -= layout.size;
      }
      layout.size = layout.horizontal ? box.height : box.width;
      chartArea[layout.pos] += layout.size;
      if (box.getPadding) {
        var boxPadding = box.getPadding();
        maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
        maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
        maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
        maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
      }
      newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
      newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
      if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
        chartArea.w = newWidth;
        chartArea.h = newHeight;
        var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
        return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
      }
    }
    function handleMaxPadding(chartArea) {
      var maxPadding = chartArea.maxPadding;
      function updatePos(pos) {
        var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
      }
      chartArea.y += updatePos('top');
      chartArea.x += updatePos('left');
      updatePos('right');
      updatePos('bottom');
    }
    function getMargins(horizontal, chartArea) {
      var maxPadding = chartArea.maxPadding;
      function marginForPositions(positions) {
        var margin = {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        };
        positions.forEach(function (pos) {
          margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
      }
      return horizontal ? marginForPositions(['left', 'right']) : marginForPositions(['top', 'bottom']);
    }
    function fitBoxes(boxes, chartArea, params) {
      var refitBoxes = [];
      var i, ilen, layout, box, refit, changed;
      for (i = 0, ilen = boxes.length; i < ilen; ++i) {
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
        if (updateDims(chartArea, params, layout)) {
          changed = true;
          if (refitBoxes.length) {
            refit = true;
          }
        }
        if (!box.fullWidth) {
          refitBoxes.push(layout);
        }
      }
      return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
    }
    function placeBoxes(boxes, chartArea, params) {
      var userPadding = params.padding;
      var x = chartArea.x;
      var y = chartArea.y;
      var i, ilen, layout, box;
      for (i = 0, ilen = boxes.length; i < ilen; ++i) {
        layout = boxes[i];
        box = layout.box;
        if (layout.horizontal) {
          box.left = box.fullWidth ? userPadding.left : chartArea.left;
          box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
          box.top = y;
          box.bottom = y + box.height;
          box.width = box.right - box.left;
          y = box.bottom;
        } else {
          box.left = x;
          box.right = x + box.width;
          box.top = chartArea.top;
          box.bottom = chartArea.top + chartArea.h;
          box.height = box.bottom - box.top;
          x = box.right;
        }
      }
      chartArea.x = x;
      chartArea.y = y;
    }
    core_defaults._set('global', {
      layout: {
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        }
      }
    });
    var core_layouts = {
      defaults: {},
      addBox: function addBox(chart, item) {
        if (!chart.boxes) {
          chart.boxes = [];
        }
        item.fullWidth = item.fullWidth || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function () {
          return [{
            z: 0,
            draw: function draw() {
              item.draw.apply(item, arguments);
            }
          }];
        };
        chart.boxes.push(item);
      },
      removeBox: function removeBox(chart, layoutItem) {
        var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) {
          chart.boxes.splice(index, 1);
        }
      },
      configure: function configure(chart, item, options) {
        var props = ['fullWidth', 'position', 'weight'];
        var ilen = props.length;
        var i = 0;
        var prop;
        for (; i < ilen; ++i) {
          prop = props[i];
          if (options.hasOwnProperty(prop)) {
            item[prop] = options[prop];
          }
        }
      },
      update: function update(chart, width, height) {
        if (!chart) {
          return;
        }
        var layoutOptions = chart.options.layout || {};
        var padding = helpers$1.options.toPadding(layoutOptions.padding);
        var availableWidth = width - padding.width;
        var availableHeight = height - padding.height;
        var boxes = buildLayoutBoxes(chart.boxes);
        var verticalBoxes = boxes.vertical;
        var horizontalBoxes = boxes.horizontal;
        var params = Object.freeze({
          outerWidth: width,
          outerHeight: height,
          padding: padding,
          availableWidth: availableWidth,
          vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
          hBoxMaxHeight: availableHeight / 2
        });
        var chartArea = extend({
          maxPadding: extend({}, padding),
          w: availableWidth,
          h: availableHeight,
          x: padding.left,
          y: padding.top
        }, padding);
        setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        fitBoxes(verticalBoxes, chartArea, params);
        if (fitBoxes(horizontalBoxes, chartArea, params)) {
          fitBoxes(verticalBoxes, chartArea, params);
        }
        handleMaxPadding(chartArea);
        placeBoxes(boxes.leftAndTop, chartArea, params);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        placeBoxes(boxes.rightAndBottom, chartArea, params);
        chart.chartArea = {
          left: chartArea.left,
          top: chartArea.top,
          right: chartArea.left + chartArea.w,
          bottom: chartArea.top + chartArea.h
        };
        helpers$1.each(boxes.chartArea, function (layout) {
          var box = layout.box;
          extend(box, chart.chartArea);
          box.update(chartArea.w, chartArea.h);
        });
      }
    };
    var platform_basic = {
      acquireContext: function acquireContext(item) {
        if (item && item.canvas) {
          item = item.canvas;
        }
        return item && item.getContext('2d') || null;
      }
    };
    var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";
    var platform_dom$1 = /*#__PURE__*/Object.freeze({
      __proto__: null,
      'default': platform_dom
    });
    var stylesheet = getCjsExportFromNamespace(platform_dom$1);
    var EXPANDO_KEY = '$chartjs';
    var CSS_PREFIX = 'chartjs-';
    var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
    var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
    var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
    var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];
    var EVENT_TYPES = {
      touchstart: 'mousedown',
      touchmove: 'mousemove',
      touchend: 'mouseup',
      pointerenter: 'mouseenter',
      pointerdown: 'mousedown',
      pointermove: 'mousemove',
      pointerup: 'mouseup',
      pointerleave: 'mouseout',
      pointerout: 'mouseout'
    };
    function readUsedSize(element, property) {
      var value = helpers$1.getStyle(element, property);
      var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
      return matches ? Number(matches[1]) : undefined;
    }
    function initCanvas(canvas, config) {
      var style = canvas.style;
      var renderHeight = canvas.getAttribute('height');
      var renderWidth = canvas.getAttribute('width');
      canvas[EXPANDO_KEY] = {
        initial: {
          height: renderHeight,
          width: renderWidth,
          style: {
            display: style.display,
            height: style.height,
            width: style.width
          }
        }
      };
      style.display = style.display || 'block';
      if (renderWidth === null || renderWidth === '') {
        var displayWidth = readUsedSize(canvas, 'width');
        if (displayWidth !== undefined) {
          canvas.width = displayWidth;
        }
      }
      if (renderHeight === null || renderHeight === '') {
        if (canvas.style.height === '') {
          canvas.height = canvas.width / (config.options.aspectRatio || 2);
        } else {
          var displayHeight = readUsedSize(canvas, 'height');
          if (displayWidth !== undefined) {
            canvas.height = displayHeight;
          }
        }
      }
      return canvas;
    }
    var supportsEventListenerOptions = function () {
      var supports = false;
      try {
        var options = Object.defineProperty({}, 'passive', {
          get: function get() {
            supports = true;
          }
        });
        window.addEventListener('e', null, options);
      } catch (e) {}
      return supports;
    }();
    var eventListenerOptions = supportsEventListenerOptions ? {
      passive: true
    } : false;
    function addListener(node, type, listener) {
      node.addEventListener(type, listener, eventListenerOptions);
    }
    function removeListener(node, type, listener) {
      node.removeEventListener(type, listener, eventListenerOptions);
    }
    function createEvent(type, chart, x, y, nativeEvent) {
      return {
        type: type,
        chart: chart,
        "native": nativeEvent || null,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
      };
    }
    function fromNativeEvent(event, chart) {
      var type = EVENT_TYPES[event.type] || event.type;
      var pos = helpers$1.getRelativePosition(event, chart);
      return createEvent(type, chart, pos.x, pos.y, event);
    }
    function throttled(fn, thisArg) {
      var ticking = false;
      var args = [];
      return function () {
        args = Array.prototype.slice.call(arguments);
        thisArg = thisArg || this;
        if (!ticking) {
          ticking = true;
          helpers$1.requestAnimFrame.call(window, function () {
            ticking = false;
            fn.apply(thisArg, args);
          });
        }
      };
    }
    function createDiv(cls) {
      var el = document.createElement('div');
      el.className = cls || '';
      return el;
    }
    function createResizer(handler) {
      var maxSize = 1000000;
      var resizer = createDiv(CSS_SIZE_MONITOR);
      var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
      var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
      expand.appendChild(createDiv());
      shrink.appendChild(createDiv());
      resizer.appendChild(expand);
      resizer.appendChild(shrink);
      resizer._reset = function () {
        expand.scrollLeft = maxSize;
        expand.scrollTop = maxSize;
        shrink.scrollLeft = maxSize;
        shrink.scrollTop = maxSize;
      };
      var onScroll = function onScroll() {
        resizer._reset();
        handler();
      };
      addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
      addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
      return resizer;
    }
    function watchForRender(node, handler) {
      var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
      var proxy = expando.renderProxy = function (e) {
        if (e.animationName === CSS_RENDER_ANIMATION) {
          handler();
        }
      };
      helpers$1.each(ANIMATION_START_EVENTS, function (type) {
        addListener(node, type, proxy);
      });
      expando.reflow = !!node.offsetParent;
      node.classList.add(CSS_RENDER_MONITOR);
    }
    function unwatchForRender(node) {
      var expando = node[EXPANDO_KEY] || {};
      var proxy = expando.renderProxy;
      if (proxy) {
        helpers$1.each(ANIMATION_START_EVENTS, function (type) {
          removeListener(node, type, proxy);
        });
        delete expando.renderProxy;
      }
      node.classList.remove(CSS_RENDER_MONITOR);
    }
    function addResizeListener(node, listener, chart) {
      var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
      var resizer = expando.resizer = createResizer(throttled(function () {
        if (expando.resizer) {
          var container = chart.options.maintainAspectRatio && node.parentNode;
          var w = container ? container.clientWidth : 0;
          listener(createEvent('resize', chart));
          if (container && container.clientWidth < w && chart.canvas) {
            listener(createEvent('resize', chart));
          }
        }
      }));
      watchForRender(node, function () {
        if (expando.resizer) {
          var container = node.parentNode;
          if (container && container !== resizer.parentNode) {
            container.insertBefore(resizer, container.firstChild);
          }
          resizer._reset();
        }
      });
    }
    function removeResizeListener(node) {
      var expando = node[EXPANDO_KEY] || {};
      var resizer = expando.resizer;
      delete expando.resizer;
      unwatchForRender(node);
      if (resizer && resizer.parentNode) {
        resizer.parentNode.removeChild(resizer);
      }
    }
    function injectCSS(rootNode, css) {
      var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
      if (!expando.containsStyles) {
        expando.containsStyles = true;
        css = '/* Chart.js */\n' + css;
        var style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        style.appendChild(document.createTextNode(css));
        rootNode.appendChild(style);
      }
    }
    var platform_dom$2 = {
      disableCSSInjection: false,
      _enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
      _ensureLoaded: function _ensureLoaded(canvas) {
        if (!this.disableCSSInjection) {
          var root = canvas.getRootNode ? canvas.getRootNode() : document;
          var targetNode = root.host ? root : document.head;
          injectCSS(targetNode, stylesheet);
        }
      },
      acquireContext: function acquireContext(item, config) {
        if (typeof item === 'string') {
          item = document.getElementById(item);
        } else if (item.length) {
          item = item[0];
        }
        if (item && item.canvas) {
          item = item.canvas;
        }
        var context = item && item.getContext && item.getContext('2d');
        if (context && context.canvas === item) {
          this._ensureLoaded(item);
          initCanvas(item, config);
          return context;
        }
        return null;
      },
      releaseContext: function releaseContext(context) {
        var canvas = context.canvas;
        if (!canvas[EXPANDO_KEY]) {
          return;
        }
        var initial = canvas[EXPANDO_KEY].initial;
        ['height', 'width'].forEach(function (prop) {
          var value = initial[prop];
          if (helpers$1.isNullOrUndef(value)) {
            canvas.removeAttribute(prop);
          } else {
            canvas.setAttribute(prop, value);
          }
        });
        helpers$1.each(initial.style || {}, function (value, key) {
          canvas.style[key] = value;
        });
        canvas.width = canvas.width;
        delete canvas[EXPANDO_KEY];
      },
      addEventListener: function addEventListener(chart, type, listener) {
        var canvas = chart.canvas;
        if (type === 'resize') {
          addResizeListener(canvas, listener, chart);
          return;
        }
        var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
        var proxies = expando.proxies || (expando.proxies = {});
        var proxy = proxies[chart.id + '_' + type] = function (event) {
          listener(fromNativeEvent(event, chart));
        };
        addListener(canvas, type, proxy);
      },
      removeEventListener: function removeEventListener(chart, type, listener) {
        var canvas = chart.canvas;
        if (type === 'resize') {
          removeResizeListener(canvas);
          return;
        }
        var expando = listener[EXPANDO_KEY] || {};
        var proxies = expando.proxies || {};
        var proxy = proxies[chart.id + '_' + type];
        if (!proxy) {
          return;
        }
        removeListener(canvas, type, proxy);
      }
    };
    helpers$1.addEvent = addListener;
    helpers$1.removeEvent = removeListener;
    var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
    var platform = helpers$1.extend({
      initialize: function initialize() {},
      acquireContext: function acquireContext() {},
      releaseContext: function releaseContext() {},
      addEventListener: function addEventListener() {},
      removeEventListener: function removeEventListener() {}
    }, implementation);
    core_defaults._set('global', {
      plugins: {}
    });
    var core_plugins = {
      _plugins: [],
      _cacheId: 0,
      register: function register(plugins) {
        var p = this._plugins;
        [].concat(plugins).forEach(function (plugin) {
          if (p.indexOf(plugin) === -1) {
            p.push(plugin);
          }
        });
        this._cacheId++;
      },
      unregister: function unregister(plugins) {
        var p = this._plugins;
        [].concat(plugins).forEach(function (plugin) {
          var idx = p.indexOf(plugin);
          if (idx !== -1) {
            p.splice(idx, 1);
          }
        });
        this._cacheId++;
      },
      clear: function clear() {
        this._plugins = [];
        this._cacheId++;
      },
      count: function count() {
        return this._plugins.length;
      },
      getAll: function getAll() {
        return this._plugins;
      },
      notify: function notify(chart, hook, args) {
        var descriptors = this.descriptors(chart);
        var ilen = descriptors.length;
        var i, descriptor, plugin, params, method;
        for (i = 0; i < ilen; ++i) {
          descriptor = descriptors[i];
          plugin = descriptor.plugin;
          method = plugin[hook];
          if (typeof method === 'function') {
            params = [chart].concat(args || []);
            params.push(descriptor.options);
            if (method.apply(plugin, params) === false) {
              return false;
            }
          }
        }
        return true;
      },
      descriptors: function descriptors(chart) {
        var cache = chart.$plugins || (chart.$plugins = {});
        if (cache.id === this._cacheId) {
          return cache.descriptors;
        }
        var plugins = [];
        var descriptors = [];
        var config = chart && chart.config || {};
        var options = config.options && config.options.plugins || {};
        this._plugins.concat(config.plugins || []).forEach(function (plugin) {
          var idx = plugins.indexOf(plugin);
          if (idx !== -1) {
            return;
          }
          var id = plugin.id;
          var opts = options[id];
          if (opts === false) {
            return;
          }
          if (opts === true) {
            opts = helpers$1.clone(core_defaults.global.plugins[id]);
          }
          plugins.push(plugin);
          descriptors.push({
            plugin: plugin,
            options: opts || {}
          });
        });
        cache.descriptors = descriptors;
        cache.id = this._cacheId;
        return descriptors;
      },
      _invalidate: function _invalidate(chart) {
        delete chart.$plugins;
      }
    };
    var core_scaleService = {
      constructors: {},
      defaults: {},
      registerScaleType: function registerScaleType(type, scaleConstructor, scaleDefaults) {
        this.constructors[type] = scaleConstructor;
        this.defaults[type] = helpers$1.clone(scaleDefaults);
      },
      getScaleConstructor: function getScaleConstructor(type) {
        return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
      },
      getScaleDefaults: function getScaleDefaults(type) {
        return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
      },
      updateScaleDefaults: function updateScaleDefaults(type, additions) {
        var me = this;
        if (me.defaults.hasOwnProperty(type)) {
          me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
        }
      },
      addScalesToLayout: function addScalesToLayout(chart) {
        helpers$1.each(chart.scales, function (scale) {
          scale.fullWidth = scale.options.fullWidth;
          scale.position = scale.options.position;
          scale.weight = scale.options.weight;
          core_layouts.addBox(chart, scale);
        });
      }
    };
    var valueOrDefault$8 = helpers$1.valueOrDefault;
    var getRtlHelper = helpers$1.rtl.getRtlAdapter;
    core_defaults._set('global', {
      tooltips: {
        enabled: true,
        custom: null,
        mode: 'nearest',
        position: 'average',
        intersect: true,
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleFontStyle: 'bold',
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleFontColor: '#fff',
        titleAlign: 'left',
        bodySpacing: 2,
        bodyFontColor: '#fff',
        bodyAlign: 'left',
        footerFontStyle: 'bold',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFontColor: '#fff',
        footerAlign: 'left',
        yPadding: 6,
        xPadding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        multiKeyBackground: '#fff',
        displayColors: true,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        callbacks: {
          beforeTitle: helpers$1.noop,
          title: function title(tooltipItems, data) {
            var title = '';
            var labels = data.labels;
            var labelCount = labels ? labels.length : 0;
            if (tooltipItems.length > 0) {
              var item = tooltipItems[0];
              if (item.label) {
                title = item.label;
              } else if (item.xLabel) {
                title = item.xLabel;
              } else if (labelCount > 0 && item.index < labelCount) {
                title = labels[item.index];
              }
            }
            return title;
          },
          afterTitle: helpers$1.noop,
          beforeBody: helpers$1.noop,
          beforeLabel: helpers$1.noop,
          label: function label(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label || '';
            if (label) {
              label += ': ';
            }
            if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
              label += tooltipItem.value;
            } else {
              label += tooltipItem.yLabel;
            }
            return label;
          },
          labelColor: function labelColor(tooltipItem, chart) {
            var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
            var activeElement = meta.data[tooltipItem.index];
            var view = activeElement._view;
            return {
              borderColor: view.borderColor,
              backgroundColor: view.backgroundColor
            };
          },
          labelTextColor: function labelTextColor() {
            return this._options.bodyFontColor;
          },
          afterLabel: helpers$1.noop,
          afterBody: helpers$1.noop,
          beforeFooter: helpers$1.noop,
          footer: helpers$1.noop,
          afterFooter: helpers$1.noop
        }
      }
    });
    var positioners = {
      average: function average(elements) {
        if (!elements.length) {
          return false;
        }
        var i, len;
        var x = 0;
        var y = 0;
        var count = 0;
        for (i = 0, len = elements.length; i < len; ++i) {
          var el = elements[i];
          if (el && el.hasValue()) {
            var pos = el.tooltipPosition();
            x += pos.x;
            y += pos.y;
            ++count;
          }
        }
        return {
          x: x / count,
          y: y / count
        };
      },
      nearest: function nearest(elements, eventPosition) {
        var x = eventPosition.x;
        var y = eventPosition.y;
        var minDistance = Number.POSITIVE_INFINITY;
        var i, len, nearestElement;
        for (i = 0, len = elements.length; i < len; ++i) {
          var el = elements[i];
          if (el && el.hasValue()) {
            var center = el.getCenterPoint();
            var d = helpers$1.distanceBetweenPoints(eventPosition, center);
            if (d < minDistance) {
              minDistance = d;
              nearestElement = el;
            }
          }
        }
        if (nearestElement) {
          var tp = nearestElement.tooltipPosition();
          x = tp.x;
          y = tp.y;
        }
        return {
          x: x,
          y: y
        };
      }
    };
    function pushOrConcat(base, toPush) {
      if (toPush) {
        if (helpers$1.isArray(toPush)) {
          Array.prototype.push.apply(base, toPush);
        } else {
          base.push(toPush);
        }
      }
      return base;
    }
    function splitNewlines(str) {
      if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
        return str.split('\n');
      }
      return str;
    }
    function createTooltipItem(element) {
      var xScale = element._xScale;
      var yScale = element._yScale || element._scale;
      var index = element._index;
      var datasetIndex = element._datasetIndex;
      var controller = element._chart.getDatasetMeta(datasetIndex).controller;
      var indexScale = controller._getIndexScale();
      var valueScale = controller._getValueScale();
      return {
        xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
        yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
        label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
        value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
        index: index,
        datasetIndex: datasetIndex,
        x: element._model.x,
        y: element._model.y
      };
    }
    function getBaseModel(tooltipOpts) {
      var globalDefaults = core_defaults.global;
      return {
        xPadding: tooltipOpts.xPadding,
        yPadding: tooltipOpts.yPadding,
        xAlign: tooltipOpts.xAlign,
        yAlign: tooltipOpts.yAlign,
        rtl: tooltipOpts.rtl,
        textDirection: tooltipOpts.textDirection,
        bodyFontColor: tooltipOpts.bodyFontColor,
        _bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
        _bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
        _bodyAlign: tooltipOpts.bodyAlign,
        bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
        bodySpacing: tooltipOpts.bodySpacing,
        titleFontColor: tooltipOpts.titleFontColor,
        _titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
        _titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
        titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
        _titleAlign: tooltipOpts.titleAlign,
        titleSpacing: tooltipOpts.titleSpacing,
        titleMarginBottom: tooltipOpts.titleMarginBottom,
        footerFontColor: tooltipOpts.footerFontColor,
        _footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
        _footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
        footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
        _footerAlign: tooltipOpts.footerAlign,
        footerSpacing: tooltipOpts.footerSpacing,
        footerMarginTop: tooltipOpts.footerMarginTop,
        caretSize: tooltipOpts.caretSize,
        cornerRadius: tooltipOpts.cornerRadius,
        backgroundColor: tooltipOpts.backgroundColor,
        opacity: 0,
        legendColorBackground: tooltipOpts.multiKeyBackground,
        displayColors: tooltipOpts.displayColors,
        borderColor: tooltipOpts.borderColor,
        borderWidth: tooltipOpts.borderWidth
      };
    }
    function getTooltipSize(tooltip, model) {
      var ctx = tooltip._chart.ctx;
      var height = model.yPadding * 2;
      var width = 0;
      var body = model.body;
      var combinedBodyLength = body.reduce(function (count, bodyItem) {
        return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
      }, 0);
      combinedBodyLength += model.beforeBody.length + model.afterBody.length;
      var titleLineCount = model.title.length;
      var footerLineCount = model.footer.length;
      var titleFontSize = model.titleFontSize;
      var bodyFontSize = model.bodyFontSize;
      var footerFontSize = model.footerFontSize;
      height += titleLineCount * titleFontSize;
      height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0;
      height += titleLineCount ? model.titleMarginBottom : 0;
      height += combinedBodyLength * bodyFontSize;
      height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0;
      height += footerLineCount ? model.footerMarginTop : 0;
      height += footerLineCount * footerFontSize;
      height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0;
      var widthPadding = 0;
      var maxLineWidth = function maxLineWidth(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
      };
      ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
      helpers$1.each(model.title, maxLineWidth);
      ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
      helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
      widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
      helpers$1.each(body, function (bodyItem) {
        helpers$1.each(bodyItem.before, maxLineWidth);
        helpers$1.each(bodyItem.lines, maxLineWidth);
        helpers$1.each(bodyItem.after, maxLineWidth);
      });
      widthPadding = 0;
      ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
      helpers$1.each(model.footer, maxLineWidth);
      width += 2 * model.xPadding;
      return {
        width: width,
        height: height
      };
    }
    function determineAlignment(tooltip, size) {
      var model = tooltip._model;
      var chart = tooltip._chart;
      var chartArea = tooltip._chart.chartArea;
      var xAlign = 'center';
      var yAlign = 'center';
      if (model.y < size.height) {
        yAlign = 'top';
      } else if (model.y > chart.height - size.height) {
        yAlign = 'bottom';
      }
      var lf, rf;
      var olf, orf;
      var yf;
      var midX = (chartArea.left + chartArea.right) / 2;
      var midY = (chartArea.top + chartArea.bottom) / 2;
      if (yAlign === 'center') {
        lf = function lf(x) {
          return x <= midX;
        };
        rf = function rf(x) {
          return x > midX;
        };
      } else {
        lf = function lf(x) {
          return x <= size.width / 2;
        };
        rf = function rf(x) {
          return x >= chart.width - size.width / 2;
        };
      }
      olf = function olf(x) {
        return x + size.width + model.caretSize + model.caretPadding > chart.width;
      };
      orf = function orf(x) {
        return x - size.width - model.caretSize - model.caretPadding < 0;
      };
      yf = function yf(y) {
        return y <= midY ? 'top' : 'bottom';
      };
      if (lf(model.x)) {
        xAlign = 'left';
        if (olf(model.x)) {
          xAlign = 'center';
          yAlign = yf(model.y);
        }
      } else if (rf(model.x)) {
        xAlign = 'right';
        if (orf(model.x)) {
          xAlign = 'center';
          yAlign = yf(model.y);
        }
      }
      var opts = tooltip._options;
      return {
        xAlign: opts.xAlign ? opts.xAlign : xAlign,
        yAlign: opts.yAlign ? opts.yAlign : yAlign
      };
    }
    function getBackgroundPoint(vm, size, alignment, chart) {
      var x = vm.x;
      var y = vm.y;
      var caretSize = vm.caretSize;
      var caretPadding = vm.caretPadding;
      var cornerRadius = vm.cornerRadius;
      var xAlign = alignment.xAlign;
      var yAlign = alignment.yAlign;
      var paddingAndSize = caretSize + caretPadding;
      var radiusAndPadding = cornerRadius + caretPadding;
      if (xAlign === 'right') {
        x -= size.width;
      } else if (xAlign === 'center') {
        x -= size.width / 2;
        if (x + size.width > chart.width) {
          x = chart.width - size.width;
        }
        if (x < 0) {
          x = 0;
        }
      }
      if (yAlign === 'top') {
        y += paddingAndSize;
      } else if (yAlign === 'bottom') {
        y -= size.height + paddingAndSize;
      } else {
        y -= size.height / 2;
      }
      if (yAlign === 'center') {
        if (xAlign === 'left') {
          x += paddingAndSize;
        } else if (xAlign === 'right') {
          x -= paddingAndSize;
        }
      } else if (xAlign === 'left') {
        x -= radiusAndPadding;
      } else if (xAlign === 'right') {
        x += radiusAndPadding;
      }
      return {
        x: x,
        y: y
      };
    }
    function getAlignedX(vm, align) {
      return align === 'center' ? vm.x + vm.width / 2 : align === 'right' ? vm.x + vm.width - vm.xPadding : vm.x + vm.xPadding;
    }
    function getBeforeAfterBodyLines(callback) {
      return pushOrConcat([], splitNewlines(callback));
    }
    var exports$4 = core_element.extend({
      initialize: function initialize() {
        this._model = getBaseModel(this._options);
        this._lastActive = [];
      },
      getTitle: function getTitle() {
        var me = this;
        var opts = me._options;
        var callbacks = opts.callbacks;
        var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
        var title = callbacks.title.apply(me, arguments);
        var afterTitle = callbacks.afterTitle.apply(me, arguments);
        var lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeTitle));
        lines = pushOrConcat(lines, splitNewlines(title));
        lines = pushOrConcat(lines, splitNewlines(afterTitle));
        return lines;
      },
      getBeforeBody: function getBeforeBody() {
        return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
      },
      getBody: function getBody(tooltipItems, data) {
        var me = this;
        var callbacks = me._options.callbacks;
        var bodyItems = [];
        helpers$1.each(tooltipItems, function (tooltipItem) {
          var bodyItem = {
            before: [],
            lines: [],
            after: []
          };
          pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
          pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
          pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
          bodyItems.push(bodyItem);
        });
        return bodyItems;
      },
      getAfterBody: function getAfterBody() {
        return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
      },
      getFooter: function getFooter() {
        var me = this;
        var callbacks = me._options.callbacks;
        var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
        var footer = callbacks.footer.apply(me, arguments);
        var afterFooter = callbacks.afterFooter.apply(me, arguments);
        var lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeFooter));
        lines = pushOrConcat(lines, splitNewlines(footer));
        lines = pushOrConcat(lines, splitNewlines(afterFooter));
        return lines;
      },
      update: function update(changed) {
        var me = this;
        var opts = me._options;
        var existingModel = me._model;
        var model = me._model = getBaseModel(opts);
        var active = me._active;
        var data = me._data;
        var alignment = {
          xAlign: existingModel.xAlign,
          yAlign: existingModel.yAlign
        };
        var backgroundPoint = {
          x: existingModel.x,
          y: existingModel.y
        };
        var tooltipSize = {
          width: existingModel.width,
          height: existingModel.height
        };
        var tooltipPosition = {
          x: existingModel.caretX,
          y: existingModel.caretY
        };
        var i, len;
        if (active.length) {
          model.opacity = 1;
          var labelColors = [];
          var labelTextColors = [];
          tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
          var tooltipItems = [];
          for (i = 0, len = active.length; i < len; ++i) {
            tooltipItems.push(createTooltipItem(active[i]));
          }
          if (opts.filter) {
            tooltipItems = tooltipItems.filter(function (a) {
              return opts.filter(a, data);
            });
          }
          if (opts.itemSort) {
            tooltipItems = tooltipItems.sort(function (a, b) {
              return opts.itemSort(a, b, data);
            });
          }
          helpers$1.each(tooltipItems, function (tooltipItem) {
            labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
            labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
          });
          model.title = me.getTitle(tooltipItems, data);
          model.beforeBody = me.getBeforeBody(tooltipItems, data);
          model.body = me.getBody(tooltipItems, data);
          model.afterBody = me.getAfterBody(tooltipItems, data);
          model.footer = me.getFooter(tooltipItems, data);
          model.x = tooltipPosition.x;
          model.y = tooltipPosition.y;
          model.caretPadding = opts.caretPadding;
          model.labelColors = labelColors;
          model.labelTextColors = labelTextColors;
          model.dataPoints = tooltipItems;
          tooltipSize = getTooltipSize(this, model);
          alignment = determineAlignment(this, tooltipSize);
          backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
        } else {
          model.opacity = 0;
        }
        model.xAlign = alignment.xAlign;
        model.yAlign = alignment.yAlign;
        model.x = backgroundPoint.x;
        model.y = backgroundPoint.y;
        model.width = tooltipSize.width;
        model.height = tooltipSize.height;
        model.caretX = tooltipPosition.x;
        model.caretY = tooltipPosition.y;
        me._model = model;
        if (changed && opts.custom) {
          opts.custom.call(me, model);
        }
        return me;
      },
      drawCaret: function drawCaret(tooltipPoint, size) {
        var ctx = this._chart.ctx;
        var vm = this._view;
        var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
      },
      getCaretPosition: function getCaretPosition(tooltipPoint, size, vm) {
        var x1, x2, x3, y1, y2, y3;
        var caretSize = vm.caretSize;
        var cornerRadius = vm.cornerRadius;
        var xAlign = vm.xAlign;
        var yAlign = vm.yAlign;
        var ptX = tooltipPoint.x;
        var ptY = tooltipPoint.y;
        var width = size.width;
        var height = size.height;
        if (yAlign === 'center') {
          y2 = ptY + height / 2;
          if (xAlign === 'left') {
            x1 = ptX;
            x2 = x1 - caretSize;
            x3 = x1;
            y1 = y2 + caretSize;
            y3 = y2 - caretSize;
          } else {
            x1 = ptX + width;
            x2 = x1 + caretSize;
            x3 = x1;
            y1 = y2 - caretSize;
            y3 = y2 + caretSize;
          }
        } else {
          if (xAlign === 'left') {
            x2 = ptX + cornerRadius + caretSize;
            x1 = x2 - caretSize;
            x3 = x2 + caretSize;
          } else if (xAlign === 'right') {
            x2 = ptX + width - cornerRadius - caretSize;
            x1 = x2 - caretSize;
            x3 = x2 + caretSize;
          } else {
            x2 = vm.caretX;
            x1 = x2 - caretSize;
            x3 = x2 + caretSize;
          }
          if (yAlign === 'top') {
            y1 = ptY;
            y2 = y1 - caretSize;
            y3 = y1;
          } else {
            y1 = ptY + height;
            y2 = y1 + caretSize;
            y3 = y1;
            var tmp = x3;
            x3 = x1;
            x1 = tmp;
          }
        }
        return {
          x1: x1,
          x2: x2,
          x3: x3,
          y1: y1,
          y2: y2,
          y3: y3
        };
      },
      drawTitle: function drawTitle(pt, vm, ctx) {
        var title = vm.title;
        var length = title.length;
        var titleFontSize, titleSpacing, i;
        if (length) {
          var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
          pt.x = getAlignedX(vm, vm._titleAlign);
          ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
          ctx.textBaseline = 'middle';
          titleFontSize = vm.titleFontSize;
          titleSpacing = vm.titleSpacing;
          ctx.fillStyle = vm.titleFontColor;
          ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
          for (i = 0; i < length; ++i) {
            ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
            pt.y += titleFontSize + titleSpacing;
            if (i + 1 === length) {
              pt.y += vm.titleMarginBottom - titleSpacing;
            }
          }
        }
      },
      drawBody: function drawBody(pt, vm, ctx) {
        var bodyFontSize = vm.bodyFontSize;
        var bodySpacing = vm.bodySpacing;
        var bodyAlign = vm._bodyAlign;
        var body = vm.body;
        var drawColorBoxes = vm.displayColors;
        var xLinePadding = 0;
        var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
        var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
        var fillLineOfText = function fillLineOfText(line) {
          ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
          pt.y += bodyFontSize + bodySpacing;
        };
        var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
        var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
        pt.x = getAlignedX(vm, bodyAlignForCalculation);
        ctx.fillStyle = vm.bodyFontColor;
        helpers$1.each(vm.beforeBody, fillLineOfText);
        xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? bodyFontSize / 2 + 1 : bodyFontSize + 2 : 0;
        for (i = 0, ilen = body.length; i < ilen; ++i) {
          bodyItem = body[i];
          textColor = vm.labelTextColors[i];
          labelColors = vm.labelColors[i];
          ctx.fillStyle = textColor;
          helpers$1.each(bodyItem.before, fillLineOfText);
          lines = bodyItem.lines;
          for (j = 0, jlen = lines.length; j < jlen; ++j) {
            if (drawColorBoxes) {
              var rtlColorX = rtlHelper.x(colorX);
              ctx.fillStyle = vm.legendColorBackground;
              ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
              ctx.lineWidth = 1;
              ctx.strokeStyle = labelColors.borderColor;
              ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
              ctx.fillStyle = labelColors.backgroundColor;
              ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
              ctx.fillStyle = textColor;
            }
            fillLineOfText(lines[j]);
          }
          helpers$1.each(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        helpers$1.each(vm.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
      },
      drawFooter: function drawFooter(pt, vm, ctx) {
        var footer = vm.footer;
        var length = footer.length;
        var footerFontSize, i;
        if (length) {
          var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
          pt.x = getAlignedX(vm, vm._footerAlign);
          pt.y += vm.footerMarginTop;
          ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
          ctx.textBaseline = 'middle';
          footerFontSize = vm.footerFontSize;
          ctx.fillStyle = vm.footerFontColor;
          ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
          for (i = 0; i < length; ++i) {
            ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
            pt.y += footerFontSize + vm.footerSpacing;
          }
        }
      },
      drawBackground: function drawBackground(pt, vm, ctx, tooltipSize) {
        ctx.fillStyle = vm.backgroundColor;
        ctx.strokeStyle = vm.borderColor;
        ctx.lineWidth = vm.borderWidth;
        var xAlign = vm.xAlign;
        var yAlign = vm.yAlign;
        var x = pt.x;
        var y = pt.y;
        var width = tooltipSize.width;
        var height = tooltipSize.height;
        var radius = vm.cornerRadius;
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        if (yAlign === 'top') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        if (yAlign === 'center' && xAlign === 'right') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        if (yAlign === 'bottom') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        if (yAlign === 'center' && xAlign === 'left') {
          this.drawCaret(pt, tooltipSize);
        }
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
        ctx.fill();
        if (vm.borderWidth > 0) {
          ctx.stroke();
        }
      },
      draw: function draw() {
        var ctx = this._chart.ctx;
        var vm = this._view;
        if (vm.opacity === 0) {
          return;
        }
        var tooltipSize = {
          width: vm.width,
          height: vm.height
        };
        var pt = {
          x: vm.x,
          y: vm.y
        };
        var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
        var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
        if (this._options.enabled && hasTooltipContent) {
          ctx.save();
          ctx.globalAlpha = opacity;
          this.drawBackground(pt, vm, ctx, tooltipSize);
          pt.y += vm.yPadding;
          helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
          this.drawTitle(pt, vm, ctx);
          this.drawBody(pt, vm, ctx);
          this.drawFooter(pt, vm, ctx);
          helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
          ctx.restore();
        }
      },
      handleEvent: function handleEvent(e) {
        var me = this;
        var options = me._options;
        var changed = false;
        me._lastActive = me._lastActive || [];
        if (e.type === 'mouseout') {
          me._active = [];
        } else {
          me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
          if (options.reverse) {
            me._active.reverse();
          }
        }
        changed = !helpers$1.arrayEquals(me._active, me._lastActive);
        if (changed) {
          me._lastActive = me._active;
          if (options.enabled || options.custom) {
            me._eventPosition = {
              x: e.x,
              y: e.y
            };
            me.update(true);
            me.pivot();
          }
        }
        return changed;
      }
    });
    var positioners_1 = positioners;
    var core_tooltip = exports$4;
    core_tooltip.positioners = positioners_1;
    var valueOrDefault$9 = helpers$1.valueOrDefault;
    core_defaults._set('global', {
      elements: {},
      events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
      hover: {
        onHover: null,
        mode: 'nearest',
        intersect: true,
        animationDuration: 400
      },
      onClick: null,
      maintainAspectRatio: true,
      responsive: true,
      responsiveAnimationDuration: 0
    });
    function mergeScaleConfig() {
      return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
        merger: function merger(key, target, source, options) {
          if (key === 'xAxes' || key === 'yAxes') {
            var slen = source[key].length;
            var i, type, scale;
            if (!target[key]) {
              target[key] = [];
            }
            for (i = 0; i < slen; ++i) {
              scale = source[key][i];
              type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
              if (i >= target[key].length) {
                target[key].push({});
              }
              if (!target[key][i].type || scale.type && scale.type !== target[key][i].type) {
                helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
              } else {
                helpers$1.merge(target[key][i], scale);
              }
            }
          } else {
            helpers$1._merger(key, target, source, options);
          }
        }
      });
    }
    function mergeConfig() {
      return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
        merger: function merger(key, target, source, options) {
          var tval = target[key] || Object.create(null);
          var sval = source[key];
          if (key === 'scales') {
            target[key] = mergeScaleConfig(tval, sval);
          } else if (key === 'scale') {
            target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
          } else {
            helpers$1._merger(key, target, source, options);
          }
        }
      });
    }
    function initConfig(config) {
      config = config || Object.create(null);
      var data = config.data = config.data || {};
      data.datasets = data.datasets || [];
      data.labels = data.labels || [];
      config.options = mergeConfig(core_defaults.global, core_defaults[config.type], config.options || {});
      return config;
    }
    function updateConfig(chart) {
      var newOptions = chart.options;
      helpers$1.each(chart.scales, function (scale) {
        core_layouts.removeBox(chart, scale);
      });
      newOptions = mergeConfig(core_defaults.global, core_defaults[chart.config.type], newOptions);
      chart.options = chart.config.options = newOptions;
      chart.ensureScalesHaveIDs();
      chart.buildOrUpdateScales();
      chart.tooltip._options = newOptions.tooltips;
      chart.tooltip.initialize();
    }
    function nextAvailableScaleId(axesOpts, prefix, index) {
      var id;
      var hasId = function hasId(obj) {
        return obj.id === id;
      };
      do {
        id = prefix + index++;
      } while (helpers$1.findIndex(axesOpts, hasId) >= 0);
      return id;
    }
    function positionIsHorizontal(position) {
      return position === 'top' || position === 'bottom';
    }
    function compare2Level(l1, l2) {
      return function (a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
      };
    }
    var Chart = function Chart(item, config) {
      this.construct(item, config);
      return this;
    };
    helpers$1.extend(Chart.prototype, {
      construct: function construct(item, config) {
        var me = this;
        config = initConfig(config);
        var context = platform.acquireContext(item, config);
        var canvas = context && context.canvas;
        var height = canvas && canvas.height;
        var width = canvas && canvas.width;
        me.id = helpers$1.uid();
        me.ctx = context;
        me.canvas = canvas;
        me.config = config;
        me.width = width;
        me.height = height;
        me.aspectRatio = height ? width / height : null;
        me.options = config.options;
        me._bufferedRender = false;
        me._layers = [];
        me.chart = me;
        me.controller = me;
        Chart.instances[me.id] = me;
        Object.defineProperty(me, 'data', {
          get: function get() {
            return me.config.data;
          },
          set: function set(value) {
            me.config.data = value;
          }
        });
        if (!context || !canvas) {
          console.error("Failed to create chart: can't acquire context from the given item");
          return;
        }
        me.initialize();
        me.update();
      },
      initialize: function initialize() {
        var me = this;
        core_plugins.notify(me, 'beforeInit');
        helpers$1.retinaScale(me, me.options.devicePixelRatio);
        me.bindEvents();
        if (me.options.responsive) {
          me.resize(true);
        }
        me.initToolTip();
        core_plugins.notify(me, 'afterInit');
        return me;
      },
      clear: function clear() {
        helpers$1.canvas.clear(this);
        return this;
      },
      stop: function stop() {
        core_animations.cancelAnimation(this);
        return this;
      },
      resize: function resize(silent) {
        var me = this;
        var options = me.options;
        var canvas = me.canvas;
        var aspectRatio = options.maintainAspectRatio && me.aspectRatio || null;
        var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
        var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
        if (me.width === newWidth && me.height === newHeight) {
          return;
        }
        canvas.width = me.width = newWidth;
        canvas.height = me.height = newHeight;
        canvas.style.width = newWidth + 'px';
        canvas.style.height = newHeight + 'px';
        helpers$1.retinaScale(me, options.devicePixelRatio);
        if (!silent) {
          var newSize = {
            width: newWidth,
            height: newHeight
          };
          core_plugins.notify(me, 'resize', [newSize]);
          if (options.onResize) {
            options.onResize(me, newSize);
          }
          me.stop();
          me.update({
            duration: options.responsiveAnimationDuration
          });
        }
      },
      ensureScalesHaveIDs: function ensureScalesHaveIDs() {
        var options = this.options;
        var scalesOptions = options.scales || {};
        var scaleOptions = options.scale;
        helpers$1.each(scalesOptions.xAxes, function (xAxisOptions, index) {
          if (!xAxisOptions.id) {
            xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
          }
        });
        helpers$1.each(scalesOptions.yAxes, function (yAxisOptions, index) {
          if (!yAxisOptions.id) {
            yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
          }
        });
        if (scaleOptions) {
          scaleOptions.id = scaleOptions.id || 'scale';
        }
      },
      buildOrUpdateScales: function buildOrUpdateScales() {
        var me = this;
        var options = me.options;
        var scales = me.scales || {};
        var items = [];
        var updated = Object.keys(scales).reduce(function (obj, id) {
          obj[id] = false;
          return obj;
        }, {});
        if (options.scales) {
          items = items.concat((options.scales.xAxes || []).map(function (xAxisOptions) {
            return {
              options: xAxisOptions,
              dtype: 'category',
              dposition: 'bottom'
            };
          }), (options.scales.yAxes || []).map(function (yAxisOptions) {
            return {
              options: yAxisOptions,
              dtype: 'linear',
              dposition: 'left'
            };
          }));
        }
        if (options.scale) {
          items.push({
            options: options.scale,
            dtype: 'radialLinear',
            isDefault: true,
            dposition: 'chartArea'
          });
        }
        helpers$1.each(items, function (item) {
          var scaleOptions = item.options;
          var id = scaleOptions.id;
          var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
          if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
            scaleOptions.position = item.dposition;
          }
          updated[id] = true;
          var scale = null;
          if (id in scales && scales[id].type === scaleType) {
            scale = scales[id];
            scale.options = scaleOptions;
            scale.ctx = me.ctx;
            scale.chart = me;
          } else {
            var scaleClass = core_scaleService.getScaleConstructor(scaleType);
            if (!scaleClass) {
              return;
            }
            scale = new scaleClass({
              id: id,
              type: scaleType,
              options: scaleOptions,
              ctx: me.ctx,
              chart: me
            });
            scales[scale.id] = scale;
          }
          scale.mergeTicksOptions();
          if (item.isDefault) {
            me.scale = scale;
          }
        });
        helpers$1.each(updated, function (hasUpdated, id) {
          if (!hasUpdated) {
            delete scales[id];
          }
        });
        me.scales = scales;
        core_scaleService.addScalesToLayout(this);
      },
      buildOrUpdateControllers: function buildOrUpdateControllers() {
        var me = this;
        var newControllers = [];
        var datasets = me.data.datasets;
        var i, ilen;
        for (i = 0, ilen = datasets.length; i < ilen; i++) {
          var dataset = datasets[i];
          var meta = me.getDatasetMeta(i);
          var type = dataset.type || me.config.type;
          if (meta.type && meta.type !== type) {
            me.destroyDatasetMeta(i);
            meta = me.getDatasetMeta(i);
          }
          meta.type = type;
          meta.order = dataset.order || 0;
          meta.index = i;
          if (meta.controller) {
            meta.controller.updateIndex(i);
            meta.controller.linkScales();
          } else {
            var ControllerClass = controllers[meta.type];
            if (ControllerClass === undefined) {
              throw new Error('"' + meta.type + '" is not a chart type.');
            }
            meta.controller = new ControllerClass(me, i);
            newControllers.push(meta.controller);
          }
        }
        return newControllers;
      },
      resetElements: function resetElements() {
        var me = this;
        helpers$1.each(me.data.datasets, function (dataset, datasetIndex) {
          me.getDatasetMeta(datasetIndex).controller.reset();
        }, me);
      },
      reset: function reset() {
        this.resetElements();
        this.tooltip.initialize();
      },
      update: function update(config) {
        var me = this;
        var i, ilen;
        if (!config || typeof config !== 'object') {
          config = {
            duration: config,
            lazy: arguments[1]
          };
        }
        updateConfig(me);
        core_plugins._invalidate(me);
        if (core_plugins.notify(me, 'beforeUpdate') === false) {
          return;
        }
        me.tooltip._data = me.data;
        var newControllers = me.buildOrUpdateControllers();
        for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
          me.getDatasetMeta(i).controller.buildOrUpdateElements();
        }
        me.updateLayout();
        if (me.options.animation && me.options.animation.duration) {
          helpers$1.each(newControllers, function (controller) {
            controller.reset();
          });
        }
        me.updateDatasets();
        me.tooltip.initialize();
        me.lastActive = [];
        core_plugins.notify(me, 'afterUpdate');
        me._layers.sort(compare2Level('z', '_idx'));
        if (me._bufferedRender) {
          me._bufferedRequest = {
            duration: config.duration,
            easing: config.easing,
            lazy: config.lazy
          };
        } else {
          me.render(config);
        }
      },
      updateLayout: function updateLayout() {
        var me = this;
        if (core_plugins.notify(me, 'beforeLayout') === false) {
          return;
        }
        core_layouts.update(this, this.width, this.height);
        me._layers = [];
        helpers$1.each(me.boxes, function (box) {
          if (box._configure) {
            box._configure();
          }
          me._layers.push.apply(me._layers, box._layers());
        }, me);
        me._layers.forEach(function (item, index) {
          item._idx = index;
        });
        core_plugins.notify(me, 'afterScaleUpdate');
        core_plugins.notify(me, 'afterLayout');
      },
      updateDatasets: function updateDatasets() {
        var me = this;
        if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
          return;
        }
        for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
          me.updateDataset(i);
        }
        core_plugins.notify(me, 'afterDatasetsUpdate');
      },
      updateDataset: function updateDataset(index) {
        var me = this;
        var meta = me.getDatasetMeta(index);
        var args = {
          meta: meta,
          index: index
        };
        if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
          return;
        }
        meta.controller._update();
        core_plugins.notify(me, 'afterDatasetUpdate', [args]);
      },
      render: function render(config) {
        var me = this;
        if (!config || typeof config !== 'object') {
          config = {
            duration: config,
            lazy: arguments[1]
          };
        }
        var animationOptions = me.options.animation;
        var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
        var lazy = config.lazy;
        if (core_plugins.notify(me, 'beforeRender') === false) {
          return;
        }
        var onComplete = function onComplete(animation) {
          core_plugins.notify(me, 'afterRender');
          helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
        };
        if (animationOptions && duration) {
          var animation = new core_animation({
            numSteps: duration / 16.66,
            easing: config.easing || animationOptions.easing,
            render: function render(chart, animationObject) {
              var easingFunction = helpers$1.easing.effects[animationObject.easing];
              var currentStep = animationObject.currentStep;
              var stepDecimal = currentStep / animationObject.numSteps;
              chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
            },
            onAnimationProgress: animationOptions.onProgress,
            onAnimationComplete: onComplete
          });
          core_animations.addAnimation(me, animation, duration, lazy);
        } else {
          me.draw();
          onComplete(new core_animation({
            numSteps: 0,
            chart: me
          }));
        }
        return me;
      },
      draw: function draw(easingValue) {
        var me = this;
        var i, layers;
        me.clear();
        if (helpers$1.isNullOrUndef(easingValue)) {
          easingValue = 1;
        }
        me.transition(easingValue);
        if (me.width <= 0 || me.height <= 0) {
          return;
        }
        if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
          return;
        }
        layers = me._layers;
        for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
          layers[i].draw(me.chartArea);
        }
        me.drawDatasets(easingValue);
        for (; i < layers.length; ++i) {
          layers[i].draw(me.chartArea);
        }
        me._drawTooltip(easingValue);
        core_plugins.notify(me, 'afterDraw', [easingValue]);
      },
      transition: function transition(easingValue) {
        var me = this;
        for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
          if (me.isDatasetVisible(i)) {
            me.getDatasetMeta(i).controller.transition(easingValue);
          }
        }
        me.tooltip.transition(easingValue);
      },
      _getSortedDatasetMetas: function _getSortedDatasetMetas(filterVisible) {
        var me = this;
        var datasets = me.data.datasets || [];
        var result = [];
        var i, ilen;
        for (i = 0, ilen = datasets.length; i < ilen; ++i) {
          if (!filterVisible || me.isDatasetVisible(i)) {
            result.push(me.getDatasetMeta(i));
          }
        }
        result.sort(compare2Level('order', 'index'));
        return result;
      },
      _getSortedVisibleDatasetMetas: function _getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
      },
      drawDatasets: function drawDatasets(easingValue) {
        var me = this;
        var metasets, i;
        if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
          return;
        }
        metasets = me._getSortedVisibleDatasetMetas();
        for (i = metasets.length - 1; i >= 0; --i) {
          me.drawDataset(metasets[i], easingValue);
        }
        core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
      },
      drawDataset: function drawDataset(meta, easingValue) {
        var me = this;
        var args = {
          meta: meta,
          index: meta.index,
          easingValue: easingValue
        };
        if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
          return;
        }
        meta.controller.draw(easingValue);
        core_plugins.notify(me, 'afterDatasetDraw', [args]);
      },
      _drawTooltip: function _drawTooltip(easingValue) {
        var me = this;
        var tooltip = me.tooltip;
        var args = {
          tooltip: tooltip,
          easingValue: easingValue
        };
        if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
          return;
        }
        tooltip.draw();
        core_plugins.notify(me, 'afterTooltipDraw', [args]);
      },
      getElementAtEvent: function getElementAtEvent(e) {
        return core_interaction.modes.single(this, e);
      },
      getElementsAtEvent: function getElementsAtEvent(e) {
        return core_interaction.modes.label(this, e, {
          intersect: true
        });
      },
      getElementsAtXAxis: function getElementsAtXAxis(e) {
        return core_interaction.modes['x-axis'](this, e, {
          intersect: true
        });
      },
      getElementsAtEventForMode: function getElementsAtEventForMode(e, mode, options) {
        var method = core_interaction.modes[mode];
        if (typeof method === 'function') {
          return method(this, e, options);
        }
        return [];
      },
      getDatasetAtEvent: function getDatasetAtEvent(e) {
        return core_interaction.modes.dataset(this, e, {
          intersect: true
        });
      },
      getDatasetMeta: function getDatasetMeta(datasetIndex) {
        var me = this;
        var dataset = me.data.datasets[datasetIndex];
        if (!dataset._meta) {
          dataset._meta = {};
        }
        var meta = dataset._meta[me.id];
        if (!meta) {
          meta = dataset._meta[me.id] = {
            type: null,
            data: [],
            dataset: null,
            controller: null,
            hidden: null,
            xAxisID: null,
            yAxisID: null,
            order: dataset.order || 0,
            index: datasetIndex
          };
        }
        return meta;
      },
      getVisibleDatasetCount: function getVisibleDatasetCount() {
        var count = 0;
        for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
          if (this.isDatasetVisible(i)) {
            count++;
          }
        }
        return count;
      },
      isDatasetVisible: function isDatasetVisible(datasetIndex) {
        var meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
      },
      generateLegend: function generateLegend() {
        return this.options.legendCallback(this);
      },
      destroyDatasetMeta: function destroyDatasetMeta(datasetIndex) {
        var id = this.id;
        var dataset = this.data.datasets[datasetIndex];
        var meta = dataset._meta && dataset._meta[id];
        if (meta) {
          meta.controller.destroy();
          delete dataset._meta[id];
        }
      },
      destroy: function destroy() {
        var me = this;
        var canvas = me.canvas;
        var i, ilen;
        me.stop();
        for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
          me.destroyDatasetMeta(i);
        }
        if (canvas) {
          me.unbindEvents();
          helpers$1.canvas.clear(me);
          platform.releaseContext(me.ctx);
          me.canvas = null;
          me.ctx = null;
        }
        core_plugins.notify(me, 'destroy');
        delete Chart.instances[me.id];
      },
      toBase64Image: function toBase64Image() {
        return this.canvas.toDataURL.apply(this.canvas, arguments);
      },
      initToolTip: function initToolTip() {
        var me = this;
        me.tooltip = new core_tooltip({
          _chart: me,
          _chartInstance: me,
          _data: me.data,
          _options: me.options.tooltips
        }, me);
      },
      bindEvents: function bindEvents() {
        var me = this;
        var listeners = me._listeners = {};
        var listener = function listener() {
          me.eventHandler.apply(me, arguments);
        };
        helpers$1.each(me.options.events, function (type) {
          platform.addEventListener(me, type, listener);
          listeners[type] = listener;
        });
        if (me.options.responsive) {
          listener = function listener() {
            me.resize();
          };
          platform.addEventListener(me, 'resize', listener);
          listeners.resize = listener;
        }
      },
      unbindEvents: function unbindEvents() {
        var me = this;
        var listeners = me._listeners;
        if (!listeners) {
          return;
        }
        delete me._listeners;
        helpers$1.each(listeners, function (listener, type) {
          platform.removeEventListener(me, type, listener);
        });
      },
      updateHoverStyle: function updateHoverStyle(elements, mode, enabled) {
        var prefix = enabled ? 'set' : 'remove';
        var element, i, ilen;
        for (i = 0, ilen = elements.length; i < ilen; ++i) {
          element = elements[i];
          if (element) {
            this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
          }
        }
        if (mode === 'dataset') {
          this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
        }
      },
      eventHandler: function eventHandler(e) {
        var me = this;
        var tooltip = me.tooltip;
        if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
          return;
        }
        me._bufferedRender = true;
        me._bufferedRequest = null;
        var changed = me.handleEvent(e);
        if (tooltip) {
          changed = tooltip._start ? tooltip.handleEvent(e) : changed | tooltip.handleEvent(e);
        }
        core_plugins.notify(me, 'afterEvent', [e]);
        var bufferedRequest = me._bufferedRequest;
        if (bufferedRequest) {
          me.render(bufferedRequest);
        } else if (changed && !me.animating) {
          me.stop();
          me.render({
            duration: me.options.hover.animationDuration,
            lazy: true
          });
        }
        me._bufferedRender = false;
        me._bufferedRequest = null;
        return me;
      },
      handleEvent: function handleEvent(e) {
        var me = this;
        var options = me.options || {};
        var hoverOptions = options.hover;
        var changed = false;
        me.lastActive = me.lastActive || [];
        if (e.type === 'mouseout') {
          me.active = [];
        } else {
          me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
        }
        helpers$1.callback(options.onHover || options.hover.onHover, [e["native"], me.active], me);
        if (e.type === 'mouseup' || e.type === 'click') {
          if (options.onClick) {
            options.onClick.call(me, e["native"], me.active);
          }
        }
        if (me.lastActive.length) {
          me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
        }
        if (me.active.length && hoverOptions.mode) {
          me.updateHoverStyle(me.active, hoverOptions.mode, true);
        }
        changed = !helpers$1.arrayEquals(me.active, me.lastActive);
        me.lastActive = me.active;
        return changed;
      }
    });
    Chart.instances = {};
    var core_controller = Chart;
    Chart.Controller = Chart;
    Chart.types = {};
    helpers$1.configMerge = mergeConfig;
    helpers$1.scaleMerge = mergeScaleConfig;
    var core_helpers = function core_helpers() {
      helpers$1.where = function (collection, filterCallback) {
        if (helpers$1.isArray(collection) && Array.prototype.filter) {
          return collection.filter(filterCallback);
        }
        var filtered = [];
        helpers$1.each(collection, function (item) {
          if (filterCallback(item)) {
            filtered.push(item);
          }
        });
        return filtered;
      };
      helpers$1.findIndex = Array.prototype.findIndex ? function (array, callback, scope) {
        return array.findIndex(callback, scope);
      } : function (array, callback, scope) {
        scope = scope === undefined ? array : scope;
        for (var i = 0, ilen = array.length; i < ilen; ++i) {
          if (callback.call(scope, array[i], i, array)) {
            return i;
          }
        }
        return -1;
      };
      helpers$1.findNextWhere = function (arrayToSearch, filterCallback, startIndex) {
        if (helpers$1.isNullOrUndef(startIndex)) {
          startIndex = -1;
        }
        for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
          var currentItem = arrayToSearch[i];
          if (filterCallback(currentItem)) {
            return currentItem;
          }
        }
      };
      helpers$1.findPreviousWhere = function (arrayToSearch, filterCallback, startIndex) {
        if (helpers$1.isNullOrUndef(startIndex)) {
          startIndex = arrayToSearch.length;
        }
        for (var i = startIndex - 1; i >= 0; i--) {
          var currentItem = arrayToSearch[i];
          if (filterCallback(currentItem)) {
            return currentItem;
          }
        }
      };
      helpers$1.isNumber = function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
      };
      helpers$1.almostEquals = function (x, y, epsilon) {
        return Math.abs(x - y) < epsilon;
      };
      helpers$1.almostWhole = function (x, epsilon) {
        var rounded = Math.round(x);
        return rounded - epsilon <= x && rounded + epsilon >= x;
      };
      helpers$1.max = function (array) {
        return array.reduce(function (max, value) {
          if (!isNaN(value)) {
            return Math.max(max, value);
          }
          return max;
        }, Number.NEGATIVE_INFINITY);
      };
      helpers$1.min = function (array) {
        return array.reduce(function (min, value) {
          if (!isNaN(value)) {
            return Math.min(min, value);
          }
          return min;
        }, Number.POSITIVE_INFINITY);
      };
      helpers$1.sign = Math.sign ? function (x) {
        return Math.sign(x);
      } : function (x) {
        x = +x;
        if (x === 0 || isNaN(x)) {
          return x;
        }
        return x > 0 ? 1 : -1;
      };
      helpers$1.toRadians = function (degrees) {
        return degrees * (Math.PI / 180);
      };
      helpers$1.toDegrees = function (radians) {
        return radians * (180 / Math.PI);
      };
      helpers$1._decimalPlaces = function (x) {
        if (!helpers$1.isFinite(x)) {
          return;
        }
        var e = 1;
        var p = 0;
        while (Math.round(x * e) / e !== x) {
          e *= 10;
          p++;
        }
        return p;
      };
      helpers$1.getAngleFromPoint = function (centrePoint, anglePoint) {
        var distanceFromXCenter = anglePoint.x - centrePoint.x;
        var distanceFromYCenter = anglePoint.y - centrePoint.y;
        var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
        var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
        if (angle < -0.5 * Math.PI) {
          angle += 2.0 * Math.PI;
        }
        return {
          angle: angle,
          distance: radialDistanceFromCenter
        };
      };
      helpers$1.distanceBetweenPoints = function (pt1, pt2) {
        return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
      };
      helpers$1.aliasPixel = function (pixelWidth) {
        return pixelWidth % 2 === 0 ? 0 : 0.5;
      };
      helpers$1._alignPixel = function (chart, pixel, width) {
        var devicePixelRatio = chart.currentDevicePixelRatio;
        var halfWidth = width / 2;
        return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
      };
      helpers$1.splineCurve = function (firstPoint, middlePoint, afterPoint, t) {
        var previous = firstPoint.skip ? middlePoint : firstPoint;
        var current = middlePoint;
        var next = afterPoint.skip ? middlePoint : afterPoint;
        var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
        var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
        var s01 = d01 / (d01 + d12);
        var s12 = d12 / (d01 + d12);
        s01 = isNaN(s01) ? 0 : s01;
        s12 = isNaN(s12) ? 0 : s12;
        var fa = t * s01;
        var fb = t * s12;
        return {
          previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
          },
          next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
          }
        };
      };
      helpers$1.EPSILON = Number.EPSILON || 1e-14;
      helpers$1.splineCurveMonotone = function (points) {
        var pointsWithTangents = (points || []).map(function (point) {
          return {
            model: point._model,
            deltaK: 0,
            mK: 0
          };
        });
        var pointsLen = pointsWithTangents.length;
        var i, pointBefore, pointCurrent, pointAfter;
        for (i = 0; i < pointsLen; ++i) {
          pointCurrent = pointsWithTangents[i];
          if (pointCurrent.model.skip) {
            continue;
          }
          pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
          pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
          if (pointAfter && !pointAfter.model.skip) {
            var slopeDeltaX = pointAfter.model.x - pointCurrent.model.x;
            pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
          }
          if (!pointBefore || pointBefore.model.skip) {
            pointCurrent.mK = pointCurrent.deltaK;
          } else if (!pointAfter || pointAfter.model.skip) {
            pointCurrent.mK = pointBefore.deltaK;
          } else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
            pointCurrent.mK = 0;
          } else {
            pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
          }
        }
        var alphaK, betaK, tauK, squaredMagnitude;
        for (i = 0; i < pointsLen - 1; ++i) {
          pointCurrent = pointsWithTangents[i];
          pointAfter = pointsWithTangents[i + 1];
          if (pointCurrent.model.skip || pointAfter.model.skip) {
            continue;
          }
          if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
            pointCurrent.mK = pointAfter.mK = 0;
            continue;
          }
          alphaK = pointCurrent.mK / pointCurrent.deltaK;
          betaK = pointAfter.mK / pointCurrent.deltaK;
          squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
          if (squaredMagnitude <= 9) {
            continue;
          }
          tauK = 3 / Math.sqrt(squaredMagnitude);
          pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
          pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
        }
        var deltaX;
        for (i = 0; i < pointsLen; ++i) {
          pointCurrent = pointsWithTangents[i];
          if (pointCurrent.model.skip) {
            continue;
          }
          pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
          pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
          if (pointBefore && !pointBefore.model.skip) {
            deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
            pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
            pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
          }
          if (pointAfter && !pointAfter.model.skip) {
            deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
            pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
            pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
          }
        }
      };
      helpers$1.nextItem = function (collection, index, loop) {
        if (loop) {
          return index >= collection.length - 1 ? collection[0] : collection[index + 1];
        }
        return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
      };
      helpers$1.previousItem = function (collection, index, loop) {
        if (loop) {
          return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
        }
        return index <= 0 ? collection[0] : collection[index - 1];
      };
      helpers$1.niceNum = function (range, round) {
        var exponent = Math.floor(helpers$1.log10(range));
        var fraction = range / Math.pow(10, exponent);
        var niceFraction;
        if (round) {
          if (fraction < 1.5) {
            niceFraction = 1;
          } else if (fraction < 3) {
            niceFraction = 2;
          } else if (fraction < 7) {
            niceFraction = 5;
          } else {
            niceFraction = 10;
          }
        } else if (fraction <= 1.0) {
          niceFraction = 1;
        } else if (fraction <= 2) {
          niceFraction = 2;
        } else if (fraction <= 5) {
          niceFraction = 5;
        } else {
          niceFraction = 10;
        }
        return niceFraction * Math.pow(10, exponent);
      };
      helpers$1.requestAnimFrame = function () {
        if (typeof window === 'undefined') {
          return function (callback) {
            callback();
          };
        }
        return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
          return window.setTimeout(callback, 1000 / 60);
        };
      }();
      helpers$1.getRelativePosition = function (evt, chart) {
        var mouseX, mouseY;
        var e = evt.originalEvent || evt;
        var canvas = evt.target || evt.srcElement;
        var boundingRect = canvas.getBoundingClientRect();
        var touches = e.touches;
        if (touches && touches.length > 0) {
          mouseX = touches[0].clientX;
          mouseY = touches[0].clientY;
        } else {
          mouseX = e.clientX;
          mouseY = e.clientY;
        }
        var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
        var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
        var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
        var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
        var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
        var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
        mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / width * canvas.width / chart.currentDevicePixelRatio);
        mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / height * canvas.height / chart.currentDevicePixelRatio);
        return {
          x: mouseX,
          y: mouseY
        };
      };
      function parseMaxStyle(styleValue, node, parentProperty) {
        var valueInPixels;
        if (typeof styleValue === 'string') {
          valueInPixels = parseInt(styleValue, 10);
          if (styleValue.indexOf('%') !== -1) {
            valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
          }
        } else {
          valueInPixels = styleValue;
        }
        return valueInPixels;
      }
      function isConstrainedValue(value) {
        return value !== undefined && value !== null && value !== 'none';
      }
      function getConstraintDimension(domNode, maxStyle, percentageProperty) {
        var view = document.defaultView;
        var parentNode = helpers$1._getParentNode(domNode);
        var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
        var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
        var hasCNode = isConstrainedValue(constrainedNode);
        var hasCContainer = isConstrainedValue(constrainedContainer);
        var infinity = Number.POSITIVE_INFINITY;
        if (hasCNode || hasCContainer) {
          return Math.min(hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity, hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
        }
        return 'none';
      }
      helpers$1.getConstraintWidth = function (domNode) {
        return getConstraintDimension(domNode, 'max-width', 'clientWidth');
      };
      helpers$1.getConstraintHeight = function (domNode) {
        return getConstraintDimension(domNode, 'max-height', 'clientHeight');
      };
      helpers$1._calculatePadding = function (container, padding, parentDimension) {
        padding = helpers$1.getStyle(container, padding);
        return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
      };
      helpers$1._getParentNode = function (domNode) {
        var parent = domNode.parentNode;
        if (parent && parent.toString() === '[object ShadowRoot]') {
          parent = parent.host;
        }
        return parent;
      };
      helpers$1.getMaximumWidth = function (domNode) {
        var container = helpers$1._getParentNode(domNode);
        if (!container) {
          return domNode.clientWidth;
        }
        var clientWidth = container.clientWidth;
        var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
        var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
        var w = clientWidth - paddingLeft - paddingRight;
        var cw = helpers$1.getConstraintWidth(domNode);
        return isNaN(cw) ? w : Math.min(w, cw);
      };
      helpers$1.getMaximumHeight = function (domNode) {
        var container = helpers$1._getParentNode(domNode);
        if (!container) {
          return domNode.clientHeight;
        }
        var clientHeight = container.clientHeight;
        var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
        var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
        var h = clientHeight - paddingTop - paddingBottom;
        var ch = helpers$1.getConstraintHeight(domNode);
        return isNaN(ch) ? h : Math.min(h, ch);
      };
      helpers$1.getStyle = function (el, property) {
        return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
      };
      helpers$1.retinaScale = function (chart, forceRatio) {
        var pixelRatio = chart.currentDevicePixelRatio = forceRatio || typeof window !== 'undefined' && window.devicePixelRatio || 1;
        if (pixelRatio === 1) {
          return;
        }
        var canvas = chart.canvas;
        var height = chart.height;
        var width = chart.width;
        canvas.height = height * pixelRatio;
        canvas.width = width * pixelRatio;
        chart.ctx.scale(pixelRatio, pixelRatio);
        if (!canvas.style.height && !canvas.style.width) {
          canvas.style.height = height + 'px';
          canvas.style.width = width + 'px';
        }
      };
      helpers$1.fontString = function (pixelSize, fontStyle, fontFamily) {
        return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
      };
      helpers$1.longestText = function (ctx, font, arrayOfThings, cache) {
        cache = cache || {};
        var data = cache.data = cache.data || {};
        var gc = cache.garbageCollect = cache.garbageCollect || [];
        if (cache.font !== font) {
          data = cache.data = {};
          gc = cache.garbageCollect = [];
          cache.font = font;
        }
        ctx.font = font;
        var longest = 0;
        var ilen = arrayOfThings.length;
        var i, j, jlen, thing, nestedThing;
        for (i = 0; i < ilen; i++) {
          thing = arrayOfThings[i];
          if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
            longest = helpers$1.measureText(ctx, data, gc, longest, thing);
          } else if (helpers$1.isArray(thing)) {
            for (j = 0, jlen = thing.length; j < jlen; j++) {
              nestedThing = thing[j];
              if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
                longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
              }
            }
          }
        }
        var gcLen = gc.length / 2;
        if (gcLen > arrayOfThings.length) {
          for (i = 0; i < gcLen; i++) {
            delete data[gc[i]];
          }
          gc.splice(0, gcLen);
        }
        return longest;
      };
      helpers$1.measureText = function (ctx, data, gc, longest, string) {
        var textWidth = data[string];
        if (!textWidth) {
          textWidth = data[string] = ctx.measureText(string).width;
          gc.push(string);
        }
        if (textWidth > longest) {
          longest = textWidth;
        }
        return longest;
      };
      helpers$1.numberOfLabelLines = function (arrayOfThings) {
        var numberOfLines = 1;
        helpers$1.each(arrayOfThings, function (thing) {
          if (helpers$1.isArray(thing)) {
            if (thing.length > numberOfLines) {
              numberOfLines = thing.length;
            }
          }
        });
        return numberOfLines;
      };
      helpers$1.color = !chartjsColor ? function (value) {
        console.error('Color.js not found!');
        return value;
      } : function (value) {
        if (value instanceof CanvasGradient) {
          value = core_defaults.global.defaultColor;
        }
        return chartjsColor(value);
      };
      helpers$1.getHoverColor = function (colorValue) {
        return colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient ? colorValue : helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
      };
    };
    function _abstract() {
      throw new Error('This method is not implemented: either no adapter can ' + 'be found or an incomplete integration was provided.');
    }
    function DateAdapter(options) {
      this.options = options || {};
    }
    helpers$1.extend(DateAdapter.prototype, {
      formats: _abstract,
      parse: _abstract,
      format: _abstract,
      add: _abstract,
      diff: _abstract,
      startOf: _abstract,
      endOf: _abstract,
      _create: function _create(value) {
        return value;
      }
    });
    DateAdapter.override = function (members) {
      helpers$1.extend(DateAdapter.prototype, members);
    };
    var _date = DateAdapter;
    var core_adapters = {
      _date: _date
    };
    var core_ticks = {
      formatters: {
        values: function values(value) {
          return helpers$1.isArray(value) ? value : '' + value;
        },
        linear: function linear(tickValue, index, ticks) {
          var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
          if (Math.abs(delta) > 1) {
            if (tickValue !== Math.floor(tickValue)) {
              delta = tickValue - Math.floor(tickValue);
            }
          }
          var logDelta = helpers$1.log10(Math.abs(delta));
          var tickString = '';
          if (tickValue !== 0) {
            var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
            if (maxTick < 1e-4) {
              var logTick = helpers$1.log10(Math.abs(tickValue));
              var numExponential = Math.floor(logTick) - Math.floor(logDelta);
              numExponential = Math.max(Math.min(numExponential, 20), 0);
              tickString = tickValue.toExponential(numExponential);
            } else {
              var numDecimal = -1 * Math.floor(logDelta);
              numDecimal = Math.max(Math.min(numDecimal, 20), 0);
              tickString = tickValue.toFixed(numDecimal);
            }
          } else {
            tickString = '0';
          }
          return tickString;
        },
        logarithmic: function logarithmic(tickValue, index, ticks) {
          var remain = tickValue / Math.pow(10, Math.floor(helpers$1.log10(tickValue)));
          if (tickValue === 0) {
            return '0';
          } else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
            return tickValue.toExponential();
          }
          return '';
        }
      }
    };
    var isArray = helpers$1.isArray;
    var isNullOrUndef = helpers$1.isNullOrUndef;
    var valueOrDefault$a = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
    core_defaults._set('scale', {
      display: true,
      position: 'left',
      offset: false,
      gridLines: {
        display: true,
        color: 'rgba(0,0,0,0.1)',
        lineWidth: 1,
        drawBorder: true,
        drawOnChartArea: true,
        drawTicks: true,
        tickMarkLength: 10,
        zeroLineWidth: 1,
        zeroLineColor: 'rgba(0,0,0,0.25)',
        zeroLineBorderDash: [],
        zeroLineBorderDashOffset: 0.0,
        offsetGridLines: false,
        borderDash: [],
        borderDashOffset: 0.0
      },
      scaleLabel: {
        display: false,
        labelString: '',
        padding: {
          top: 4,
          bottom: 4
        }
      },
      ticks: {
        beginAtZero: false,
        minRotation: 0,
        maxRotation: 50,
        mirror: false,
        padding: 0,
        reverse: false,
        display: true,
        autoSkip: true,
        autoSkipPadding: 0,
        labelOffset: 0,
        callback: core_ticks.formatters.values,
        minor: {},
        major: {}
      }
    });
    function sample(arr, numItems) {
      var result = [];
      var increment = arr.length / numItems;
      var i = 0;
      var len = arr.length;
      for (; i < len; i += increment) {
        result.push(arr[Math.floor(i)]);
      }
      return result;
    }
    function getPixelForGridLine(scale, index, offsetGridLines) {
      var length = scale.getTicks().length;
      var validIndex = Math.min(index, length - 1);
      var lineValue = scale.getPixelForTick(validIndex);
      var start = scale._startPixel;
      var end = scale._endPixel;
      var epsilon = 1e-6;
      var offset;
      if (offsetGridLines) {
        if (length === 1) {
          offset = Math.max(lineValue - start, end - lineValue);
        } else if (index === 0) {
          offset = (scale.getPixelForTick(1) - lineValue) / 2;
        } else {
          offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        }
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) {
          return;
        }
      }
      return lineValue;
    }
    function garbageCollect(caches, length) {
      helpers$1.each(caches, function (cache) {
        var gc = cache.gc;
        var gcLen = gc.length / 2;
        var i;
        if (gcLen > length) {
          for (i = 0; i < gcLen; ++i) {
            delete cache.data[gc[i]];
          }
          gc.splice(0, gcLen);
        }
      });
    }
    function computeLabelSizes(ctx, tickFonts, ticks, caches) {
      var length = ticks.length;
      var widths = [];
      var heights = [];
      var offsets = [];
      var widestLabelSize = 0;
      var highestLabelSize = 0;
      var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
      for (i = 0; i < length; ++i) {
        label = ticks[i].label;
        tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
        ctx.font = fontString = tickFont.string;
        cache = caches[fontString] = caches[fontString] || {
          data: {},
          gc: []
        };
        lineHeight = tickFont.lineHeight;
        width = height = 0;
        if (!isNullOrUndef(label) && !isArray(label)) {
          width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
          height = lineHeight;
        } else if (isArray(label)) {
          for (j = 0, jlen = label.length; j < jlen; ++j) {
            nestedLabel = label[j];
            if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
              width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
              height += lineHeight;
            }
          }
        }
        widths.push(width);
        heights.push(height);
        offsets.push(lineHeight / 2);
        widestLabelSize = Math.max(width, widestLabelSize);
        highestLabelSize = Math.max(height, highestLabelSize);
      }
      garbageCollect(caches, length);
      widest = widths.indexOf(widestLabelSize);
      highest = heights.indexOf(highestLabelSize);
      function valueAt(idx) {
        return {
          width: widths[idx] || 0,
          height: heights[idx] || 0,
          offset: offsets[idx] || 0
        };
      }
      return {
        first: valueAt(0),
        last: valueAt(length - 1),
        widest: valueAt(widest),
        highest: valueAt(highest)
      };
    }
    function getTickMarkLength(options) {
      return options.drawTicks ? options.tickMarkLength : 0;
    }
    function getScaleLabelHeight(options) {
      var font, padding;
      if (!options.display) {
        return 0;
      }
      font = helpers$1.options._parseFont(options);
      padding = helpers$1.options.toPadding(options.padding);
      return font.lineHeight + padding.height;
    }
    function parseFontOptions(options, nestedOpts) {
      return helpers$1.extend(helpers$1.options._parseFont({
        fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
        fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
        fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
        lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
      }), {
        color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
      });
    }
    function parseTickFontOptions(options) {
      var minor = parseFontOptions(options, options.minor);
      var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
      return {
        minor: minor,
        major: major
      };
    }
    function nonSkipped(ticksToFilter) {
      var filtered = [];
      var item, index, len;
      for (index = 0, len = ticksToFilter.length; index < len; ++index) {
        item = ticksToFilter[index];
        if (typeof item._index !== 'undefined') {
          filtered.push(item);
        }
      }
      return filtered;
    }
    function getEvenSpacing(arr) {
      var len = arr.length;
      var i, diff;
      if (len < 2) {
        return false;
      }
      for (diff = arr[0], i = 1; i < len; ++i) {
        if (arr[i] - arr[i - 1] !== diff) {
          return false;
        }
      }
      return diff;
    }
    function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
      var evenMajorSpacing = getEvenSpacing(majorIndices);
      var spacing = (ticks.length - 1) / ticksLimit;
      var factors, factor, i, ilen;
      if (!evenMajorSpacing) {
        return Math.max(spacing, 1);
      }
      factors = helpers$1.math._factorize(evenMajorSpacing);
      for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
        factor = factors[i];
        if (factor > spacing) {
          return factor;
        }
      }
      return Math.max(spacing, 1);
    }
    function getMajorIndices(ticks) {
      var result = [];
      var i, ilen;
      for (i = 0, ilen = ticks.length; i < ilen; i++) {
        if (ticks[i].major) {
          result.push(i);
        }
      }
      return result;
    }
    function skipMajors(ticks, majorIndices, spacing) {
      var count = 0;
      var next = majorIndices[0];
      var i, tick;
      spacing = Math.ceil(spacing);
      for (i = 0; i < ticks.length; i++) {
        tick = ticks[i];
        if (i === next) {
          tick._index = i;
          count++;
          next = majorIndices[count * spacing];
        } else {
          delete tick.label;
        }
      }
    }
    function skip(ticks, spacing, majorStart, majorEnd) {
      var start = valueOrDefault$a(majorStart, 0);
      var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
      var count = 0;
      var length, i, tick, next;
      spacing = Math.ceil(spacing);
      if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
      }
      next = start;
      while (next < 0) {
        count++;
        next = Math.round(start + count * spacing);
      }
      for (i = Math.max(start, 0); i < end; i++) {
        tick = ticks[i];
        if (i === next) {
          tick._index = i;
          count++;
          next = Math.round(start + count * spacing);
        } else {
          delete tick.label;
        }
      }
    }
    var Scale = core_element.extend({
      zeroLineIndex: 0,
      getPadding: function getPadding() {
        var me = this;
        return {
          left: me.paddingLeft || 0,
          top: me.paddingTop || 0,
          right: me.paddingRight || 0,
          bottom: me.paddingBottom || 0
        };
      },
      getTicks: function getTicks() {
        return this._ticks;
      },
      _getLabels: function _getLabels() {
        var data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
      },
      mergeTicksOptions: function mergeTicksOptions() {},
      beforeUpdate: function beforeUpdate() {
        helpers$1.callback(this.options.beforeUpdate, [this]);
      },
      update: function update(maxWidth, maxHeight, margins) {
        var me = this;
        var tickOpts = me.options.ticks;
        var sampleSize = tickOpts.sampleSize;
        var i, ilen, labels, ticks, samplingEnabled;
        me.beforeUpdate();
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me.margins = helpers$1.extend({
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }, margins);
        me._ticks = null;
        me.ticks = null;
        me._labelSizes = null;
        me._maxLabelLines = 0;
        me.longestLabelWidth = 0;
        me.longestTextCache = me.longestTextCache || {};
        me._gridLineItems = null;
        me._labelItems = null;
        me.beforeSetDimensions();
        me.setDimensions();
        me.afterSetDimensions();
        me.beforeDataLimits();
        me.determineDataLimits();
        me.afterDataLimits();
        me.beforeBuildTicks();
        ticks = me.buildTicks() || [];
        ticks = me.afterBuildTicks(ticks) || ticks;
        if ((!ticks || !ticks.length) && me.ticks) {
          ticks = [];
          for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
            ticks.push({
              value: me.ticks[i],
              major: false
            });
          }
        }
        me._ticks = ticks;
        samplingEnabled = sampleSize < ticks.length;
        labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
        me._configure();
        me.beforeCalculateTickRotation();
        me.calculateTickRotation();
        me.afterCalculateTickRotation();
        me.beforeFit();
        me.fit();
        me.afterFit();
        me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
        if (samplingEnabled) {
          labels = me._convertTicksToLabels(me._ticksToDraw);
        }
        me.ticks = labels;
        me.afterUpdate();
        return me.minSize;
      },
      _configure: function _configure() {
        var me = this;
        var reversePixels = me.options.ticks.reverse;
        var startPixel, endPixel;
        if (me.isHorizontal()) {
          startPixel = me.left;
          endPixel = me.right;
        } else {
          startPixel = me.top;
          endPixel = me.bottom;
          reversePixels = !reversePixels;
        }
        me._startPixel = startPixel;
        me._endPixel = endPixel;
        me._reversePixels = reversePixels;
        me._length = endPixel - startPixel;
      },
      afterUpdate: function afterUpdate() {
        helpers$1.callback(this.options.afterUpdate, [this]);
      },
      beforeSetDimensions: function beforeSetDimensions() {
        helpers$1.callback(this.options.beforeSetDimensions, [this]);
      },
      setDimensions: function setDimensions() {
        var me = this;
        if (me.isHorizontal()) {
          me.width = me.maxWidth;
          me.left = 0;
          me.right = me.width;
        } else {
          me.height = me.maxHeight;
          me.top = 0;
          me.bottom = me.height;
        }
        me.paddingLeft = 0;
        me.paddingTop = 0;
        me.paddingRight = 0;
        me.paddingBottom = 0;
      },
      afterSetDimensions: function afterSetDimensions() {
        helpers$1.callback(this.options.afterSetDimensions, [this]);
      },
      beforeDataLimits: function beforeDataLimits() {
        helpers$1.callback(this.options.beforeDataLimits, [this]);
      },
      determineDataLimits: helpers$1.noop,
      afterDataLimits: function afterDataLimits() {
        helpers$1.callback(this.options.afterDataLimits, [this]);
      },
      beforeBuildTicks: function beforeBuildTicks() {
        helpers$1.callback(this.options.beforeBuildTicks, [this]);
      },
      buildTicks: helpers$1.noop,
      afterBuildTicks: function afterBuildTicks(ticks) {
        var me = this;
        if (isArray(ticks) && ticks.length) {
          return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
        }
        me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
        return ticks;
      },
      beforeTickToLabelConversion: function beforeTickToLabelConversion() {
        helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
      },
      convertTicksToLabels: function convertTicksToLabels() {
        var me = this;
        var tickOpts = me.options.ticks;
        me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
      },
      afterTickToLabelConversion: function afterTickToLabelConversion() {
        helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
      },
      beforeCalculateTickRotation: function beforeCalculateTickRotation() {
        helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
      },
      calculateTickRotation: function calculateTickRotation() {
        var me = this;
        var options = me.options;
        var tickOpts = options.ticks;
        var numTicks = me.getTicks().length;
        var minRotation = tickOpts.minRotation || 0;
        var maxRotation = tickOpts.maxRotation;
        var labelRotation = minRotation;
        var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
        if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
          me.labelRotation = minRotation;
          return;
        }
        labelSizes = me._getLabelSizes();
        maxLabelWidth = labelSizes.widest.width;
        maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
        maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
        tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
          tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
          maxHeight = me.maxHeight - getTickMarkLength(options.gridLines) - tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
          maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
          labelRotation = helpers$1.toDegrees(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
          labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        me.labelRotation = labelRotation;
      },
      afterCalculateTickRotation: function afterCalculateTickRotation() {
        helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
      },
      beforeFit: function beforeFit() {
        helpers$1.callback(this.options.beforeFit, [this]);
      },
      fit: function fit() {
        var me = this;
        var minSize = me.minSize = {
          width: 0,
          height: 0
        };
        var chart = me.chart;
        var opts = me.options;
        var tickOpts = opts.ticks;
        var scaleLabelOpts = opts.scaleLabel;
        var gridLineOpts = opts.gridLines;
        var display = me._isVisible();
        var isBottom = opts.position === 'bottom';
        var isHorizontal = me.isHorizontal();
        if (isHorizontal) {
          minSize.width = me.maxWidth;
        } else if (display) {
          minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
        }
        if (!isHorizontal) {
          minSize.height = me.maxHeight;
        } else if (display) {
          minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
        }
        if (tickOpts.display && display) {
          var tickFonts = parseTickFontOptions(tickOpts);
          var labelSizes = me._getLabelSizes();
          var firstLabelSize = labelSizes.first;
          var lastLabelSize = labelSizes.last;
          var widestLabelSize = labelSizes.widest;
          var highestLabelSize = labelSizes.highest;
          var lineSpace = tickFonts.minor.lineHeight * 0.4;
          var tickPadding = tickOpts.padding;
          if (isHorizontal) {
            var isRotated = me.labelRotation !== 0;
            var angleRadians = helpers$1.toRadians(me.labelRotation);
            var cosRotation = Math.cos(angleRadians);
            var sinRotation = Math.sin(angleRadians);
            var labelHeight = sinRotation * widestLabelSize.width + cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0)) + (isRotated ? 0 : lineSpace);
            minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
            var offsetLeft = me.getPixelForTick(0) - me.left;
            var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
            var paddingLeft, paddingRight;
            if (isRotated) {
              paddingLeft = isBottom ? cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset : sinRotation * (firstLabelSize.height - firstLabelSize.offset);
              paddingRight = isBottom ? sinRotation * (lastLabelSize.height - lastLabelSize.offset) : cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
            } else {
              paddingLeft = firstLabelSize.width / 2;
              paddingRight = lastLabelSize.width / 2;
            }
            me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
            me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
          } else {
            var labelWidth = tickOpts.mirror ? 0 : widestLabelSize.width + tickPadding + lineSpace;
            minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
            me.paddingTop = firstLabelSize.height / 2;
            me.paddingBottom = lastLabelSize.height / 2;
          }
        }
        me.handleMargins();
        if (isHorizontal) {
          me.width = me._length = chart.width - me.margins.left - me.margins.right;
          me.height = minSize.height;
        } else {
          me.width = minSize.width;
          me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
        }
      },
      handleMargins: function handleMargins() {
        var me = this;
        if (me.margins) {
          me.margins.left = Math.max(me.paddingLeft, me.margins.left);
          me.margins.top = Math.max(me.paddingTop, me.margins.top);
          me.margins.right = Math.max(me.paddingRight, me.margins.right);
          me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
        }
      },
      afterFit: function afterFit() {
        helpers$1.callback(this.options.afterFit, [this]);
      },
      isHorizontal: function isHorizontal() {
        var pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
      },
      isFullWidth: function isFullWidth() {
        return this.options.fullWidth;
      },
      getRightValue: function getRightValue(rawValue) {
        if (isNullOrUndef(rawValue)) {
          return NaN;
        }
        if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
          return NaN;
        }
        if (rawValue) {
          if (this.isHorizontal()) {
            if (rawValue.x !== undefined) {
              return this.getRightValue(rawValue.x);
            }
          } else if (rawValue.y !== undefined) {
            return this.getRightValue(rawValue.y);
          }
        }
        return rawValue;
      },
      _convertTicksToLabels: function _convertTicksToLabels(ticks) {
        var me = this;
        var labels, i, ilen;
        me.ticks = ticks.map(function (tick) {
          return tick.value;
        });
        me.beforeTickToLabelConversion();
        labels = me.convertTicksToLabels(ticks) || me.ticks;
        me.afterTickToLabelConversion();
        for (i = 0, ilen = ticks.length; i < ilen; ++i) {
          ticks[i].label = labels[i];
        }
        return labels;
      },
      _getLabelSizes: function _getLabelSizes() {
        var me = this;
        var labelSizes = me._labelSizes;
        if (!labelSizes) {
          me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
          me.longestLabelWidth = labelSizes.widest.width;
        }
        return labelSizes;
      },
      _parseValue: function _parseValue(value) {
        var start, end, min, max;
        if (isArray(value)) {
          start = +this.getRightValue(value[0]);
          end = +this.getRightValue(value[1]);
          min = Math.min(start, end);
          max = Math.max(start, end);
        } else {
          value = +this.getRightValue(value);
          start = undefined;
          end = value;
          min = value;
          max = value;
        }
        return {
          min: min,
          max: max,
          start: start,
          end: end
        };
      },
      _getScaleLabel: function _getScaleLabel(rawValue) {
        var v = this._parseValue(rawValue);
        if (v.start !== undefined) {
          return '[' + v.start + ', ' + v.end + ']';
        }
        return +this.getRightValue(rawValue);
      },
      getLabelForIndex: helpers$1.noop,
      getPixelForValue: helpers$1.noop,
      getValueForPixel: helpers$1.noop,
      getPixelForTick: function getPixelForTick(index) {
        var me = this;
        var offset = me.options.offset;
        var numTicks = me._ticks.length;
        var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
        return index < 0 || index > numTicks - 1 ? null : me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
      },
      getPixelForDecimal: function getPixelForDecimal(decimal) {
        var me = this;
        if (me._reversePixels) {
          decimal = 1 - decimal;
        }
        return me._startPixel + decimal * me._length;
      },
      getDecimalForPixel: function getDecimalForPixel(pixel) {
        var decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
      },
      getBasePixel: function getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
      },
      getBaseValue: function getBaseValue() {
        var me = this;
        var min = me.min;
        var max = me.max;
        return me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
      },
      _autoSkip: function _autoSkip(ticks) {
        var me = this;
        var tickOpts = me.options.ticks;
        var axisLength = me._length;
        var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
        var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
        var numMajorIndices = majorIndices.length;
        var first = majorIndices[0];
        var last = majorIndices[numMajorIndices - 1];
        var i, ilen, spacing, avgMajorSpacing;
        if (numMajorIndices > ticksLimit) {
          skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
          return nonSkipped(ticks);
        }
        spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
        if (numMajorIndices > 0) {
          for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
            skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
          }
          avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
          skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
          skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
          return nonSkipped(ticks);
        }
        skip(ticks, spacing);
        return nonSkipped(ticks);
      },
      _tickSize: function _tickSize() {
        var me = this;
        var optionTicks = me.options.ticks;
        var rot = helpers$1.toRadians(me.labelRotation);
        var cos = Math.abs(Math.cos(rot));
        var sin = Math.abs(Math.sin(rot));
        var labelSizes = me._getLabelSizes();
        var padding = optionTicks.autoSkipPadding || 0;
        var w = labelSizes ? labelSizes.widest.width + padding : 0;
        var h = labelSizes ? labelSizes.highest.height + padding : 0;
        return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
      },
      _isVisible: function _isVisible() {
        var me = this;
        var chart = me.chart;
        var display = me.options.display;
        var i, ilen, meta;
        if (display !== 'auto') {
          return !!display;
        }
        for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
          if (chart.isDatasetVisible(i)) {
            meta = chart.getDatasetMeta(i);
            if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
              return true;
            }
          }
        }
        return false;
      },
      _computeGridLineItems: function _computeGridLineItems(chartArea) {
        var me = this;
        var chart = me.chart;
        var options = me.options;
        var gridLines = options.gridLines;
        var position = options.position;
        var offsetGridLines = gridLines.offsetGridLines;
        var isHorizontal = me.isHorizontal();
        var ticks = me._ticksToDraw;
        var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
        var tl = getTickMarkLength(gridLines);
        var items = [];
        var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
        var axisHalfWidth = axisWidth / 2;
        var alignPixel = helpers$1._alignPixel;
        var alignBorderValue = function alignBorderValue(pixel) {
          return alignPixel(chart, pixel, axisWidth);
        };
        var borderValue, i, tick, lineValue, alignedLineValue;
        var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
        if (position === 'top') {
          borderValue = alignBorderValue(me.bottom);
          ty1 = me.bottom - tl;
          ty2 = borderValue - axisHalfWidth;
          y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
          y2 = chartArea.bottom;
        } else if (position === 'bottom') {
          borderValue = alignBorderValue(me.top);
          y1 = chartArea.top;
          y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
          ty1 = borderValue + axisHalfWidth;
          ty2 = me.top + tl;
        } else if (position === 'left') {
          borderValue = alignBorderValue(me.right);
          tx1 = me.right - tl;
          tx2 = borderValue - axisHalfWidth;
          x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
          x2 = chartArea.right;
        } else {
          borderValue = alignBorderValue(me.left);
          x1 = chartArea.left;
          x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
          tx1 = borderValue + axisHalfWidth;
          tx2 = me.left + tl;
        }
        for (i = 0; i < ticksLength; ++i) {
          tick = ticks[i] || {};
          if (isNullOrUndef(tick.label) && i < ticks.length) {
            continue;
          }
          if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
            lineWidth = gridLines.zeroLineWidth;
            lineColor = gridLines.zeroLineColor;
            borderDash = gridLines.zeroLineBorderDash || [];
            borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
          } else {
            lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
            lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
            borderDash = gridLines.borderDash || [];
            borderDashOffset = gridLines.borderDashOffset || 0.0;
          }
          lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
          if (lineValue === undefined) {
            continue;
          }
          alignedLineValue = alignPixel(chart, lineValue, lineWidth);
          if (isHorizontal) {
            tx1 = tx2 = x1 = x2 = alignedLineValue;
          } else {
            ty1 = ty2 = y1 = y2 = alignedLineValue;
          }
          items.push({
            tx1: tx1,
            ty1: ty1,
            tx2: tx2,
            ty2: ty2,
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            width: lineWidth,
            color: lineColor,
            borderDash: borderDash,
            borderDashOffset: borderDashOffset
          });
        }
        items.ticksLength = ticksLength;
        items.borderValue = borderValue;
        return items;
      },
      _computeLabelItems: function _computeLabelItems() {
        var me = this;
        var options = me.options;
        var optionTicks = options.ticks;
        var position = options.position;
        var isMirrored = optionTicks.mirror;
        var isHorizontal = me.isHorizontal();
        var ticks = me._ticksToDraw;
        var fonts = parseTickFontOptions(optionTicks);
        var tickPadding = optionTicks.padding;
        var tl = getTickMarkLength(options.gridLines);
        var rotation = -helpers$1.toRadians(me.labelRotation);
        var items = [];
        var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        if (position === 'top') {
          y = me.bottom - tl - tickPadding;
          textAlign = !rotation ? 'center' : 'left';
        } else if (position === 'bottom') {
          y = me.top + tl + tickPadding;
          textAlign = !rotation ? 'center' : 'right';
        } else if (position === 'left') {
          x = me.right - (isMirrored ? 0 : tl) - tickPadding;
          textAlign = isMirrored ? 'left' : 'right';
        } else {
          x = me.left + (isMirrored ? 0 : tl) + tickPadding;
          textAlign = isMirrored ? 'right' : 'left';
        }
        for (i = 0, ilen = ticks.length; i < ilen; ++i) {
          tick = ticks[i];
          label = tick.label;
          if (isNullOrUndef(label)) {
            continue;
          }
          pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
          font = tick.major ? fonts.major : fonts.minor;
          lineHeight = font.lineHeight;
          lineCount = isArray(label) ? label.length : 1;
          if (isHorizontal) {
            x = pixel;
            textOffset = position === 'top' ? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight : (!rotation ? 0.5 : 0) * lineHeight;
          } else {
            y = pixel;
            textOffset = (1 - lineCount) * lineHeight / 2;
          }
          items.push({
            x: x,
            y: y,
            rotation: rotation,
            label: label,
            font: font,
            textOffset: textOffset,
            textAlign: textAlign
          });
        }
        return items;
      },
      _drawGrid: function _drawGrid(chartArea) {
        var me = this;
        var gridLines = me.options.gridLines;
        if (!gridLines.display) {
          return;
        }
        var ctx = me.ctx;
        var chart = me.chart;
        var alignPixel = helpers$1._alignPixel;
        var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
        var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
        var width, color, i, ilen, item;
        for (i = 0, ilen = items.length; i < ilen; ++i) {
          item = items[i];
          width = item.width;
          color = item.color;
          if (width && color) {
            ctx.save();
            ctx.lineWidth = width;
            ctx.strokeStyle = color;
            if (ctx.setLineDash) {
              ctx.setLineDash(item.borderDash);
              ctx.lineDashOffset = item.borderDashOffset;
            }
            ctx.beginPath();
            if (gridLines.drawTicks) {
              ctx.moveTo(item.tx1, item.ty1);
              ctx.lineTo(item.tx2, item.ty2);
            }
            if (gridLines.drawOnChartArea) {
              ctx.moveTo(item.x1, item.y1);
              ctx.lineTo(item.x2, item.y2);
            }
            ctx.stroke();
            ctx.restore();
          }
        }
        if (axisWidth) {
          var firstLineWidth = axisWidth;
          var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
          var borderValue = items.borderValue;
          var x1, x2, y1, y2;
          if (me.isHorizontal()) {
            x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
            x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
          } else {
            y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
            y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
          }
          ctx.lineWidth = axisWidth;
          ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
          ctx.beginPath();
          ctx.moveTo(x1, y1);
          ctx.lineTo(x2, y2);
          ctx.stroke();
        }
      },
      _drawLabels: function _drawLabels() {
        var me = this;
        var optionTicks = me.options.ticks;
        if (!optionTicks.display) {
          return;
        }
        var ctx = me.ctx;
        var items = me._labelItems || (me._labelItems = me._computeLabelItems());
        var i, j, ilen, jlen, item, tickFont, label, y;
        for (i = 0, ilen = items.length; i < ilen; ++i) {
          item = items[i];
          tickFont = item.font;
          ctx.save();
          ctx.translate(item.x, item.y);
          ctx.rotate(item.rotation);
          ctx.font = tickFont.string;
          ctx.fillStyle = tickFont.color;
          ctx.textBaseline = 'middle';
          ctx.textAlign = item.textAlign;
          label = item.label;
          y = item.textOffset;
          if (isArray(label)) {
            for (j = 0, jlen = label.length; j < jlen; ++j) {
              ctx.fillText('' + label[j], 0, y);
              y += tickFont.lineHeight;
            }
          } else {
            ctx.fillText(label, 0, y);
          }
          ctx.restore();
        }
      },
      _drawTitle: function _drawTitle() {
        var me = this;
        var ctx = me.ctx;
        var options = me.options;
        var scaleLabel = options.scaleLabel;
        if (!scaleLabel.display) {
          return;
        }
        var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
        var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
        var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
        var halfLineHeight = scaleLabelFont.lineHeight / 2;
        var position = options.position;
        var rotation = 0;
        var scaleLabelX, scaleLabelY;
        if (me.isHorizontal()) {
          scaleLabelX = me.left + me.width / 2;
          scaleLabelY = position === 'bottom' ? me.bottom - halfLineHeight - scaleLabelPadding.bottom : me.top + halfLineHeight + scaleLabelPadding.top;
        } else {
          var isLeft = position === 'left';
          scaleLabelX = isLeft ? me.left + halfLineHeight + scaleLabelPadding.top : me.right - halfLineHeight - scaleLabelPadding.top;
          scaleLabelY = me.top + me.height / 2;
          rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
        }
        ctx.save();
        ctx.translate(scaleLabelX, scaleLabelY);
        ctx.rotate(rotation);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = scaleLabelFontColor;
        ctx.font = scaleLabelFont.string;
        ctx.fillText(scaleLabel.labelString, 0, 0);
        ctx.restore();
      },
      draw: function draw(chartArea) {
        var me = this;
        if (!me._isVisible()) {
          return;
        }
        me._drawGrid(chartArea);
        me._drawTitle();
        me._drawLabels();
      },
      _layers: function _layers() {
        var me = this;
        var opts = me.options;
        var tz = opts.ticks && opts.ticks.z || 0;
        var gz = opts.gridLines && opts.gridLines.z || 0;
        if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
          return [{
            z: tz,
            draw: function draw() {
              me.draw.apply(me, arguments);
            }
          }];
        }
        return [{
          z: gz,
          draw: function draw() {
            me._drawGrid.apply(me, arguments);
            me._drawTitle.apply(me, arguments);
          }
        }, {
          z: tz,
          draw: function draw() {
            me._drawLabels.apply(me, arguments);
          }
        }];
      },
      _getMatchingVisibleMetas: function _getMatchingVisibleMetas(type) {
        var me = this;
        var isHorizontal = me.isHorizontal();
        return me.chart._getSortedVisibleDatasetMetas().filter(function (meta) {
          return (!type || meta.type === type) && (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
        });
      }
    });
    Scale.prototype._draw = Scale.prototype.draw;
    var core_scale = Scale;
    var isNullOrUndef$1 = helpers$1.isNullOrUndef;
    var defaultConfig = {
      position: 'bottom'
    };
    var scale_category = core_scale.extend({
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var labels = me._getLabels();
        var ticksOpts = me.options.ticks;
        var min = ticksOpts.min;
        var max = ticksOpts.max;
        var minIndex = 0;
        var maxIndex = labels.length - 1;
        var findIndex;
        if (min !== undefined) {
          findIndex = labels.indexOf(min);
          if (findIndex >= 0) {
            minIndex = findIndex;
          }
        }
        if (max !== undefined) {
          findIndex = labels.indexOf(max);
          if (findIndex >= 0) {
            maxIndex = findIndex;
          }
        }
        me.minIndex = minIndex;
        me.maxIndex = maxIndex;
        me.min = labels[minIndex];
        me.max = labels[maxIndex];
      },
      buildTicks: function buildTicks() {
        var me = this;
        var labels = me._getLabels();
        var minIndex = me.minIndex;
        var maxIndex = me.maxIndex;
        me.ticks = minIndex === 0 && maxIndex === labels.length - 1 ? labels : labels.slice(minIndex, maxIndex + 1);
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        var me = this;
        var chart = me.chart;
        if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
          return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
        }
        return me._getLabels()[index];
      },
      _configure: function _configure() {
        var me = this;
        var offset = me.options.offset;
        var ticks = me.ticks;
        core_scale.prototype._configure.call(me);
        if (!me.isHorizontal()) {
          me._reversePixels = !me._reversePixels;
        }
        if (!ticks) {
          return;
        }
        me._startValue = me.minIndex - (offset ? 0.5 : 0);
        me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
      },
      getPixelForValue: function getPixelForValue(value, index, datasetIndex) {
        var me = this;
        var valueCategory, labels, idx;
        if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
          value = me.chart.data.datasets[datasetIndex].data[index];
        }
        if (!isNullOrUndef$1(value)) {
          valueCategory = me.isHorizontal() ? value.x : value.y;
        }
        if (valueCategory !== undefined || value !== undefined && isNaN(index)) {
          labels = me._getLabels();
          value = helpers$1.valueOrDefault(valueCategory, value);
          idx = labels.indexOf(value);
          index = idx !== -1 ? idx : index;
          if (isNaN(index)) {
            index = value;
          }
        }
        return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.ticks;
        return index < 0 || index > ticks.length - 1 ? null : this.getPixelForValue(ticks[index], index + this.minIndex);
      },
      getValueForPixel: function getValueForPixel(pixel) {
        var me = this;
        var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
        return Math.min(Math.max(value, 0), me.ticks.length - 1);
      },
      getBasePixel: function getBasePixel() {
        return this.bottom;
      }
    });
    var _defaults = defaultConfig;
    scale_category._defaults = _defaults;
    var noop = helpers$1.noop;
    var isNullOrUndef$2 = helpers$1.isNullOrUndef;
    function generateTicks(generationOptions, dataRange) {
      var ticks = [];
      var MIN_SPACING = 1e-14;
      var stepSize = generationOptions.stepSize;
      var unit = stepSize || 1;
      var maxNumSpaces = generationOptions.maxTicks - 1;
      var min = generationOptions.min;
      var max = generationOptions.max;
      var precision = generationOptions.precision;
      var rmin = dataRange.min;
      var rmax = dataRange.max;
      var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
      var factor, niceMin, niceMax, numSpaces;
      if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
        return [rmin, rmax];
      }
      numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
      if (numSpaces > maxNumSpaces) {
        spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
      }
      if (stepSize || isNullOrUndef$2(precision)) {
        factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
      } else {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
      }
      niceMin = Math.floor(rmin / spacing) * spacing;
      niceMax = Math.ceil(rmax / spacing) * spacing;
      if (stepSize) {
        if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
          niceMin = min;
        }
        if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
          niceMax = max;
        }
      }
      numSpaces = (niceMax - niceMin) / spacing;
      if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
        numSpaces = Math.round(numSpaces);
      } else {
        numSpaces = Math.ceil(numSpaces);
      }
      niceMin = Math.round(niceMin * factor) / factor;
      niceMax = Math.round(niceMax * factor) / factor;
      ticks.push(isNullOrUndef$2(min) ? niceMin : min);
      for (var j = 1; j < numSpaces; ++j) {
        ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
      }
      ticks.push(isNullOrUndef$2(max) ? niceMax : max);
      return ticks;
    }
    var scale_linearbase = core_scale.extend({
      getRightValue: function getRightValue(value) {
        if (typeof value === 'string') {
          return +value;
        }
        return core_scale.prototype.getRightValue.call(this, value);
      },
      handleTickRangeOptions: function handleTickRangeOptions() {
        var me = this;
        var opts = me.options;
        var tickOpts = opts.ticks;
        if (tickOpts.beginAtZero) {
          var minSign = helpers$1.sign(me.min);
          var maxSign = helpers$1.sign(me.max);
          if (minSign < 0 && maxSign < 0) {
            me.max = 0;
          } else if (minSign > 0 && maxSign > 0) {
            me.min = 0;
          }
        }
        var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
        var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
        if (tickOpts.min !== undefined) {
          me.min = tickOpts.min;
        } else if (tickOpts.suggestedMin !== undefined) {
          if (me.min === null) {
            me.min = tickOpts.suggestedMin;
          } else {
            me.min = Math.min(me.min, tickOpts.suggestedMin);
          }
        }
        if (tickOpts.max !== undefined) {
          me.max = tickOpts.max;
        } else if (tickOpts.suggestedMax !== undefined) {
          if (me.max === null) {
            me.max = tickOpts.suggestedMax;
          } else {
            me.max = Math.max(me.max, tickOpts.suggestedMax);
          }
        }
        if (setMin !== setMax) {
          if (me.min >= me.max) {
            if (setMin) {
              me.max = me.min + 1;
            } else {
              me.min = me.max - 1;
            }
          }
        }
        if (me.min === me.max) {
          me.max++;
          if (!tickOpts.beginAtZero) {
            me.min--;
          }
        }
      },
      getTickLimit: function getTickLimit() {
        var me = this;
        var tickOpts = me.options.ticks;
        var stepSize = tickOpts.stepSize;
        var maxTicksLimit = tickOpts.maxTicksLimit;
        var maxTicks;
        if (stepSize) {
          maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
        } else {
          maxTicks = me._computeTickLimit();
          maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) {
          maxTicks = Math.min(maxTicksLimit, maxTicks);
        }
        return maxTicks;
      },
      _computeTickLimit: function _computeTickLimit() {
        return Number.POSITIVE_INFINITY;
      },
      handleDirectionalChanges: noop,
      buildTicks: function buildTicks() {
        var me = this;
        var opts = me.options;
        var tickOpts = opts.ticks;
        var maxTicks = me.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        var numericGeneratorOptions = {
          maxTicks: maxTicks,
          min: tickOpts.min,
          max: tickOpts.max,
          precision: tickOpts.precision,
          stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
        };
        var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
        me.handleDirectionalChanges();
        me.max = helpers$1.max(ticks);
        me.min = helpers$1.min(ticks);
        if (tickOpts.reverse) {
          ticks.reverse();
          me.start = me.max;
          me.end = me.min;
        } else {
          me.start = me.min;
          me.end = me.max;
        }
      },
      convertTicksToLabels: function convertTicksToLabels() {
        var me = this;
        me.ticksAsNumbers = me.ticks.slice();
        me.zeroLineIndex = me.ticks.indexOf(0);
        core_scale.prototype.convertTicksToLabels.call(me);
      },
      _configure: function _configure() {
        var me = this;
        var ticks = me.getTicks();
        var start = me.min;
        var end = me.max;
        var offset;
        core_scale.prototype._configure.call(me);
        if (me.options.offset && ticks.length) {
          offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
          start -= offset;
          end += offset;
        }
        me._startValue = start;
        me._endValue = end;
        me._valueRange = end - start;
      }
    });
    var defaultConfig$1 = {
      position: 'left',
      ticks: {
        callback: core_ticks.formatters.linear
      }
    };
    var DEFAULT_MIN = 0;
    var DEFAULT_MAX = 1;
    function getOrCreateStack(stacks, stacked, meta) {
      var key = [meta.type, stacked === undefined && meta.stack === undefined ? meta.index : '', meta.stack].join('.');
      if (stacks[key] === undefined) {
        stacks[key] = {
          pos: [],
          neg: []
        };
      }
      return stacks[key];
    }
    function stackData(scale, stacks, meta, data) {
      var opts = scale.options;
      var stacked = opts.stacked;
      var stack = getOrCreateStack(stacks, stacked, meta);
      var pos = stack.pos;
      var neg = stack.neg;
      var ilen = data.length;
      var i, value;
      for (i = 0; i < ilen; ++i) {
        value = scale._parseValue(data[i]);
        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
          continue;
        }
        pos[i] = pos[i] || 0;
        neg[i] = neg[i] || 0;
        if (opts.relativePoints) {
          pos[i] = 100;
        } else if (value.min < 0 || value.max < 0) {
          neg[i] += value.min;
        } else {
          pos[i] += value.max;
        }
      }
    }
    function updateMinMax(scale, meta, data) {
      var ilen = data.length;
      var i, value;
      for (i = 0; i < ilen; ++i) {
        value = scale._parseValue(data[i]);
        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
          continue;
        }
        scale.min = Math.min(scale.min, value.min);
        scale.max = Math.max(scale.max, value.max);
      }
    }
    var scale_linear = scale_linearbase.extend({
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var opts = me.options;
        var chart = me.chart;
        var datasets = chart.data.datasets;
        var metasets = me._getMatchingVisibleMetas();
        var hasStacks = opts.stacked;
        var stacks = {};
        var ilen = metasets.length;
        var i, meta, data, values;
        me.min = Number.POSITIVE_INFINITY;
        me.max = Number.NEGATIVE_INFINITY;
        if (hasStacks === undefined) {
          for (i = 0; !hasStacks && i < ilen; ++i) {
            meta = metasets[i];
            hasStacks = meta.stack !== undefined;
          }
        }
        for (i = 0; i < ilen; ++i) {
          meta = metasets[i];
          data = datasets[meta.index].data;
          if (hasStacks) {
            stackData(me, stacks, meta, data);
          } else {
            updateMinMax(me, meta, data);
          }
        }
        helpers$1.each(stacks, function (stackValues) {
          values = stackValues.pos.concat(stackValues.neg);
          me.min = Math.min(me.min, helpers$1.min(values));
          me.max = Math.max(me.max, helpers$1.max(values));
        });
        me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
        me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
        me.handleTickRangeOptions();
      },
      _computeTickLimit: function _computeTickLimit() {
        var me = this;
        var tickFont;
        if (me.isHorizontal()) {
          return Math.ceil(me.width / 40);
        }
        tickFont = helpers$1.options._parseFont(me.options.ticks);
        return Math.ceil(me.height / tickFont.lineHeight);
      },
      handleDirectionalChanges: function handleDirectionalChanges() {
        if (!this.isHorizontal()) {
          this.ticks.reverse();
        }
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
      },
      getPixelForValue: function getPixelForValue(value) {
        var me = this;
        return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
      },
      getValueForPixel: function getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.ticksAsNumbers;
        if (index < 0 || index > ticks.length - 1) {
          return null;
        }
        return this.getPixelForValue(ticks[index]);
      }
    });
    var _defaults$1 = defaultConfig$1;
    scale_linear._defaults = _defaults$1;
    var valueOrDefault$b = helpers$1.valueOrDefault;
    var log10 = helpers$1.math.log10;
    function generateTicks$1(generationOptions, dataRange) {
      var ticks = [];
      var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
      var endExp = Math.floor(log10(dataRange.max));
      var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
      var exp, significand;
      if (tickVal === 0) {
        exp = Math.floor(log10(dataRange.minNotZero));
        significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
        ticks.push(tickVal);
        tickVal = significand * Math.pow(10, exp);
      } else {
        exp = Math.floor(log10(tickVal));
        significand = Math.floor(tickVal / Math.pow(10, exp));
      }
      var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
      do {
        ticks.push(tickVal);
        ++significand;
        if (significand === 10) {
          significand = 1;
          ++exp;
          precision = exp >= 0 ? 1 : precision;
        }
        tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
      } while (exp < endExp || exp === endExp && significand < endSignificand);
      var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
      ticks.push(lastTick);
      return ticks;
    }
    var defaultConfig$2 = {
      position: 'left',
      ticks: {
        callback: core_ticks.formatters.logarithmic
      }
    };
    function nonNegativeOrDefault(value, defaultValue) {
      return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
    }
    var scale_logarithmic = core_scale.extend({
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var opts = me.options;
        var chart = me.chart;
        var datasets = chart.data.datasets;
        var isHorizontal = me.isHorizontal();
        function IDMatches(meta) {
          return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
        }
        var datasetIndex, meta, value, data, i, ilen;
        me.min = Number.POSITIVE_INFINITY;
        me.max = Number.NEGATIVE_INFINITY;
        me.minNotZero = Number.POSITIVE_INFINITY;
        var hasStacks = opts.stacked;
        if (hasStacks === undefined) {
          for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
            meta = chart.getDatasetMeta(datasetIndex);
            if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
              hasStacks = true;
              break;
            }
          }
        }
        if (opts.stacked || hasStacks) {
          var valuesPerStack = {};
          for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
            meta = chart.getDatasetMeta(datasetIndex);
            var key = [meta.type, opts.stacked === undefined && meta.stack === undefined ? datasetIndex : '', meta.stack].join('.');
            if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
              if (valuesPerStack[key] === undefined) {
                valuesPerStack[key] = [];
              }
              data = datasets[datasetIndex].data;
              for (i = 0, ilen = data.length; i < ilen; i++) {
                var values = valuesPerStack[key];
                value = me._parseValue(data[i]);
                if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
                  continue;
                }
                values[i] = values[i] || 0;
                values[i] += value.max;
              }
            }
          }
          helpers$1.each(valuesPerStack, function (valuesForType) {
            if (valuesForType.length > 0) {
              var minVal = helpers$1.min(valuesForType);
              var maxVal = helpers$1.max(valuesForType);
              me.min = Math.min(me.min, minVal);
              me.max = Math.max(me.max, maxVal);
            }
          });
        } else {
          for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
            meta = chart.getDatasetMeta(datasetIndex);
            if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
              data = datasets[datasetIndex].data;
              for (i = 0, ilen = data.length; i < ilen; i++) {
                value = me._parseValue(data[i]);
                if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
                  continue;
                }
                me.min = Math.min(value.min, me.min);
                me.max = Math.max(value.max, me.max);
                if (value.min !== 0) {
                  me.minNotZero = Math.min(value.min, me.minNotZero);
                }
              }
            }
          }
        }
        me.min = helpers$1.isFinite(me.min) ? me.min : null;
        me.max = helpers$1.isFinite(me.max) ? me.max : null;
        me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
        this.handleTickRangeOptions();
      },
      handleTickRangeOptions: function handleTickRangeOptions() {
        var me = this;
        var tickOpts = me.options.ticks;
        var DEFAULT_MIN = 1;
        var DEFAULT_MAX = 10;
        me.min = nonNegativeOrDefault(tickOpts.min, me.min);
        me.max = nonNegativeOrDefault(tickOpts.max, me.max);
        if (me.min === me.max) {
          if (me.min !== 0 && me.min !== null) {
            me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
            me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
          } else {
            me.min = DEFAULT_MIN;
            me.max = DEFAULT_MAX;
          }
        }
        if (me.min === null) {
          me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
        }
        if (me.max === null) {
          me.max = me.min !== 0 ? Math.pow(10, Math.floor(log10(me.min)) + 1) : DEFAULT_MAX;
        }
        if (me.minNotZero === null) {
          if (me.min > 0) {
            me.minNotZero = me.min;
          } else if (me.max < 1) {
            me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
          } else {
            me.minNotZero = DEFAULT_MIN;
          }
        }
      },
      buildTicks: function buildTicks() {
        var me = this;
        var tickOpts = me.options.ticks;
        var reverse = !me.isHorizontal();
        var generationOptions = {
          min: nonNegativeOrDefault(tickOpts.min),
          max: nonNegativeOrDefault(tickOpts.max)
        };
        var ticks = me.ticks = generateTicks$1(generationOptions, me);
        me.max = helpers$1.max(ticks);
        me.min = helpers$1.min(ticks);
        if (tickOpts.reverse) {
          reverse = !reverse;
          me.start = me.max;
          me.end = me.min;
        } else {
          me.start = me.min;
          me.end = me.max;
        }
        if (reverse) {
          ticks.reverse();
        }
      },
      convertTicksToLabels: function convertTicksToLabels() {
        this.tickValues = this.ticks.slice();
        core_scale.prototype.convertTicksToLabels.call(this);
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.tickValues;
        if (index < 0 || index > ticks.length - 1) {
          return null;
        }
        return this.getPixelForValue(ticks[index]);
      },
      _getFirstTickValue: function _getFirstTickValue(value) {
        var exp = Math.floor(log10(value));
        var significand = Math.floor(value / Math.pow(10, exp));
        return significand * Math.pow(10, exp);
      },
      _configure: function _configure() {
        var me = this;
        var start = me.min;
        var offset = 0;
        core_scale.prototype._configure.call(me);
        if (start === 0) {
          start = me._getFirstTickValue(me.minNotZero);
          offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
        }
        me._startValue = log10(start);
        me._valueOffset = offset;
        me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
      },
      getPixelForValue: function getPixelForValue(value) {
        var me = this;
        var decimal = 0;
        value = +me.getRightValue(value);
        if (value > me.min && value > 0) {
          decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
        }
        return me.getPixelForDecimal(decimal);
      },
      getValueForPixel: function getValueForPixel(pixel) {
        var me = this;
        var decimal = me.getDecimalForPixel(pixel);
        return decimal === 0 && me.min === 0 ? 0 : Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
      }
    });
    var _defaults$2 = defaultConfig$2;
    scale_logarithmic._defaults = _defaults$2;
    var valueOrDefault$c = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
    var resolve$4 = helpers$1.options.resolve;
    var defaultConfig$3 = {
      display: true,
      animate: true,
      position: 'chartArea',
      angleLines: {
        display: true,
        color: 'rgba(0,0,0,0.1)',
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
      },
      gridLines: {
        circular: false
      },
      ticks: {
        showLabelBackdrop: true,
        backdropColor: 'rgba(255,255,255,0.75)',
        backdropPaddingY: 2,
        backdropPaddingX: 2,
        callback: core_ticks.formatters.linear
      },
      pointLabels: {
        display: true,
        fontSize: 10,
        callback: function callback(label) {
          return label;
        }
      }
    };
    function getTickBackdropHeight(opts) {
      var tickOpts = opts.ticks;
      if (tickOpts.display && opts.display) {
        return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
      }
      return 0;
    }
    function measureLabelSize(ctx, lineHeight, label) {
      if (helpers$1.isArray(label)) {
        return {
          w: helpers$1.longestText(ctx, ctx.font, label),
          h: label.length * lineHeight
        };
      }
      return {
        w: ctx.measureText(label).width,
        h: lineHeight
      };
    }
    function determineLimits(angle, pos, size, min, max) {
      if (angle === min || angle === max) {
        return {
          start: pos - size / 2,
          end: pos + size / 2
        };
      } else if (angle < min || angle > max) {
        return {
          start: pos - size,
          end: pos
        };
      }
      return {
        start: pos,
        end: pos + size
      };
    }
    function fitWithPointLabels(scale) {
      var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
      var furthestLimits = {
        l: 0,
        r: scale.width,
        t: 0,
        b: scale.height - scale.paddingTop
      };
      var furthestAngles = {};
      var i, textSize, pointPosition;
      scale.ctx.font = plFont.string;
      scale._pointLabelSizes = [];
      var valueCount = scale.chart.data.labels.length;
      for (i = 0; i < valueCount; i++) {
        pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
        textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
        scale._pointLabelSizes[i] = textSize;
        var angleRadians = scale.getIndexAngle(i);
        var angle = helpers$1.toDegrees(angleRadians) % 360;
        var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        if (hLimits.start < furthestLimits.l) {
          furthestLimits.l = hLimits.start;
          furthestAngles.l = angleRadians;
        }
        if (hLimits.end > furthestLimits.r) {
          furthestLimits.r = hLimits.end;
          furthestAngles.r = angleRadians;
        }
        if (vLimits.start < furthestLimits.t) {
          furthestLimits.t = vLimits.start;
          furthestAngles.t = angleRadians;
        }
        if (vLimits.end > furthestLimits.b) {
          furthestLimits.b = vLimits.end;
          furthestAngles.b = angleRadians;
        }
      }
      scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
    }
    function getTextAlignForAngle(angle) {
      if (angle === 0 || angle === 180) {
        return 'center';
      } else if (angle < 180) {
        return 'left';
      }
      return 'right';
    }
    function fillText(ctx, text, position, lineHeight) {
      var y = position.y + lineHeight / 2;
      var i, ilen;
      if (helpers$1.isArray(text)) {
        for (i = 0, ilen = text.length; i < ilen; ++i) {
          ctx.fillText(text[i], position.x, y);
          y += lineHeight;
        }
      } else {
        ctx.fillText(text, position.x, y);
      }
    }
    function adjustPointPositionForLabelHeight(angle, textSize, position) {
      if (angle === 90 || angle === 270) {
        position.y -= textSize.h / 2;
      } else if (angle > 270 || angle < 90) {
        position.y -= textSize.h;
      }
    }
    function drawPointLabels(scale) {
      var ctx = scale.ctx;
      var opts = scale.options;
      var pointLabelOpts = opts.pointLabels;
      var tickBackdropHeight = getTickBackdropHeight(opts);
      var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
      var plFont = helpers$1.options._parseFont(pointLabelOpts);
      ctx.save();
      ctx.font = plFont.string;
      ctx.textBaseline = 'middle';
      for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
        var extra = i === 0 ? tickBackdropHeight / 2 : 0;
        var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
        var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
        ctx.fillStyle = pointLabelFontColor;
        var angleRadians = scale.getIndexAngle(i);
        var angle = helpers$1.toDegrees(angleRadians);
        ctx.textAlign = getTextAlignForAngle(angle);
        adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
        fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
      }
      ctx.restore();
    }
    function drawRadiusLine(scale, gridLineOpts, radius, index) {
      var ctx = scale.ctx;
      var circular = gridLineOpts.circular;
      var valueCount = scale.chart.data.labels.length;
      var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
      var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
      var pointPosition;
      if (!circular && !valueCount || !lineColor || !lineWidth) {
        return;
      }
      ctx.save();
      ctx.strokeStyle = lineColor;
      ctx.lineWidth = lineWidth;
      if (ctx.setLineDash) {
        ctx.setLineDash(gridLineOpts.borderDash || []);
        ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
      }
      ctx.beginPath();
      if (circular) {
        ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
      } else {
        pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for (var i = 1; i < valueCount; i++) {
          pointPosition = scale.getPointPosition(i, radius);
          ctx.lineTo(pointPosition.x, pointPosition.y);
        }
      }
      ctx.closePath();
      ctx.stroke();
      ctx.restore();
    }
    function numberOrZero(param) {
      return helpers$1.isNumber(param) ? param : 0;
    }
    var scale_radialLinear = scale_linearbase.extend({
      setDimensions: function setDimensions() {
        var me = this;
        me.width = me.maxWidth;
        me.height = me.maxHeight;
        me.paddingTop = getTickBackdropHeight(me.options) / 2;
        me.xCenter = Math.floor(me.width / 2);
        me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
        me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
      },
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var chart = me.chart;
        var min = Number.POSITIVE_INFINITY;
        var max = Number.NEGATIVE_INFINITY;
        helpers$1.each(chart.data.datasets, function (dataset, datasetIndex) {
          if (chart.isDatasetVisible(datasetIndex)) {
            var meta = chart.getDatasetMeta(datasetIndex);
            helpers$1.each(dataset.data, function (rawValue, index) {
              var value = +me.getRightValue(rawValue);
              if (isNaN(value) || meta.data[index].hidden) {
                return;
              }
              min = Math.min(value, min);
              max = Math.max(value, max);
            });
          }
        });
        me.min = min === Number.POSITIVE_INFINITY ? 0 : min;
        me.max = max === Number.NEGATIVE_INFINITY ? 0 : max;
        me.handleTickRangeOptions();
      },
      _computeTickLimit: function _computeTickLimit() {
        return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
      },
      convertTicksToLabels: function convertTicksToLabels() {
        var me = this;
        scale_linearbase.prototype.convertTicksToLabels.call(me);
        me.pointLabels = me.chart.data.labels.map(function () {
          var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
          return label || label === 0 ? label : '';
        });
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
      },
      fit: function fit() {
        var me = this;
        var opts = me.options;
        if (opts.display && opts.pointLabels.display) {
          fitWithPointLabels(me);
        } else {
          me.setCenterPoint(0, 0, 0, 0);
        }
      },
      setReductions: function setReductions(largestPossibleRadius, furthestLimits, furthestAngles) {
        var me = this;
        var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
        var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
        var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
        var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
        radiusReductionLeft = numberOrZero(radiusReductionLeft);
        radiusReductionRight = numberOrZero(radiusReductionRight);
        radiusReductionTop = numberOrZero(radiusReductionTop);
        radiusReductionBottom = numberOrZero(radiusReductionBottom);
        me.drawingArea = Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
        me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
      },
      setCenterPoint: function setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        var me = this;
        var maxRight = me.width - rightMovement - me.drawingArea;
        var maxLeft = leftMovement + me.drawingArea;
        var maxTop = topMovement + me.drawingArea;
        var maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;
        me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
        me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
      },
      getIndexAngle: function getIndexAngle(index) {
        var chart = this.chart;
        var angleMultiplier = 360 / chart.data.labels.length;
        var options = chart.options || {};
        var startAngle = options.startAngle || 0;
        var angle = (index * angleMultiplier + startAngle) % 360;
        return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
      },
      getDistanceFromCenterForValue: function getDistanceFromCenterForValue(value) {
        var me = this;
        if (helpers$1.isNullOrUndef(value)) {
          return NaN;
        }
        var scalingFactor = me.drawingArea / (me.max - me.min);
        if (me.options.ticks.reverse) {
          return (me.max - value) * scalingFactor;
        }
        return (value - me.min) * scalingFactor;
      },
      getPointPosition: function getPointPosition(index, distanceFromCenter) {
        var me = this;
        var thisAngle = me.getIndexAngle(index) - Math.PI / 2;
        return {
          x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
          y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
        };
      },
      getPointPositionForValue: function getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
      },
      getBasePosition: function getBasePosition(index) {
        var me = this;
        var min = me.min;
        var max = me.max;
        return me.getPointPositionForValue(index || 0, me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0);
      },
      _drawGrid: function _drawGrid() {
        var me = this;
        var ctx = me.ctx;
        var opts = me.options;
        var gridLineOpts = opts.gridLines;
        var angleLineOpts = opts.angleLines;
        var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
        var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
        var i, offset, position;
        if (opts.pointLabels.display) {
          drawPointLabels(me);
        }
        if (gridLineOpts.display) {
          helpers$1.each(me.ticks, function (label, index) {
            if (index !== 0) {
              offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
              drawRadiusLine(me, gridLineOpts, offset, index);
            }
          });
        }
        if (angleLineOpts.display && lineWidth && lineColor) {
          ctx.save();
          ctx.lineWidth = lineWidth;
          ctx.strokeStyle = lineColor;
          if (ctx.setLineDash) {
            ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
            ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
          }
          for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
            offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
            position = me.getPointPosition(i, offset);
            ctx.beginPath();
            ctx.moveTo(me.xCenter, me.yCenter);
            ctx.lineTo(position.x, position.y);
            ctx.stroke();
          }
          ctx.restore();
        }
      },
      _drawLabels: function _drawLabels() {
        var me = this;
        var ctx = me.ctx;
        var opts = me.options;
        var tickOpts = opts.ticks;
        if (!tickOpts.display) {
          return;
        }
        var startAngle = me.getIndexAngle(0);
        var tickFont = helpers$1.options._parseFont(tickOpts);
        var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
        var offset, width;
        ctx.save();
        ctx.font = tickFont.string;
        ctx.translate(me.xCenter, me.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        helpers$1.each(me.ticks, function (label, index) {
          if (index === 0 && !tickOpts.reverse) {
            return;
          }
          offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
          if (tickOpts.showLabelBackdrop) {
            width = ctx.measureText(label).width;
            ctx.fillStyle = tickOpts.backdropColor;
            ctx.fillRect(-width / 2 - tickOpts.backdropPaddingX, -offset - tickFont.size / 2 - tickOpts.backdropPaddingY, width + tickOpts.backdropPaddingX * 2, tickFont.size + tickOpts.backdropPaddingY * 2);
          }
          ctx.fillStyle = tickFontColor;
          ctx.fillText(label, 0, -offset);
        });
        ctx.restore();
      },
      _drawTitle: helpers$1.noop
    });
    var _defaults$3 = defaultConfig$3;
    scale_radialLinear._defaults = _defaults$3;
    var deprecated$1 = helpers$1._deprecated;
    var resolve$5 = helpers$1.options.resolve;
    var valueOrDefault$d = helpers$1.valueOrDefault;
    var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
    var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
    var INTERVALS = {
      millisecond: {
        common: true,
        size: 1,
        steps: 1000
      },
      second: {
        common: true,
        size: 1000,
        steps: 60
      },
      minute: {
        common: true,
        size: 60000,
        steps: 60
      },
      hour: {
        common: true,
        size: 3600000,
        steps: 24
      },
      day: {
        common: true,
        size: 86400000,
        steps: 30
      },
      week: {
        common: false,
        size: 604800000,
        steps: 4
      },
      month: {
        common: true,
        size: 2.628e9,
        steps: 12
      },
      quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
      },
      year: {
        common: true,
        size: 3.154e10
      }
    };
    var UNITS = Object.keys(INTERVALS);
    function sorter(a, b) {
      return a - b;
    }
    function arrayUnique(items) {
      var hash = {};
      var out = [];
      var i, ilen, item;
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        item = items[i];
        if (!hash[item]) {
          hash[item] = true;
          out.push(item);
        }
      }
      return out;
    }
    function getMin(options) {
      return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
    }
    function getMax(options) {
      return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
    }
    function buildLookupTable(timestamps, min, max, distribution) {
      if (distribution === 'linear' || !timestamps.length) {
        return [{
          time: min,
          pos: 0
        }, {
          time: max,
          pos: 1
        }];
      }
      var table = [];
      var items = [min];
      var i, ilen, prev, curr, next;
      for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
        curr = timestamps[i];
        if (curr > min && curr < max) {
          items.push(curr);
        }
      }
      items.push(max);
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        next = items[i + 1];
        prev = items[i - 1];
        curr = items[i];
        if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
          table.push({
            time: curr,
            pos: i / (ilen - 1)
          });
        }
      }
      return table;
    }
    function lookup(table, key, value) {
      var lo = 0;
      var hi = table.length - 1;
      var mid, i0, i1;
      while (lo >= 0 && lo <= hi) {
        mid = lo + hi >> 1;
        i0 = table[mid - 1] || null;
        i1 = table[mid];
        if (!i0) {
          return {
            lo: null,
            hi: i1
          };
        } else if (i1[key] < value) {
          lo = mid + 1;
        } else if (i0[key] > value) {
          hi = mid - 1;
        } else {
          return {
            lo: i0,
            hi: i1
          };
        }
      }
      return {
        lo: i1,
        hi: null
      };
    }
    function interpolate$1(table, skey, sval, tkey) {
      var range = lookup(table, skey, sval);
      var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
      var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
      var span = next[skey] - prev[skey];
      var ratio = span ? (sval - prev[skey]) / span : 0;
      var offset = (next[tkey] - prev[tkey]) * ratio;
      return prev[tkey] + offset;
    }
    function toTimestamp(scale, input) {
      var adapter = scale._adapter;
      var options = scale.options.time;
      var parser = options.parser;
      var format = parser || options.format;
      var value = input;
      if (typeof parser === 'function') {
        value = parser(value);
      }
      if (!helpers$1.isFinite(value)) {
        value = typeof format === 'string' ? adapter.parse(value, format) : adapter.parse(value);
      }
      if (value !== null) {
        return +value;
      }
      if (!parser && typeof format === 'function') {
        value = format(input);
        if (!helpers$1.isFinite(value)) {
          value = adapter.parse(value);
        }
      }
      return value;
    }
    function parse(scale, input) {
      if (helpers$1.isNullOrUndef(input)) {
        return null;
      }
      var options = scale.options.time;
      var value = toTimestamp(scale, scale.getRightValue(input));
      if (value === null) {
        return value;
      }
      if (options.round) {
        value = +scale._adapter.startOf(value, options.round);
      }
      return value;
    }
    function determineUnitForAutoTicks(minUnit, min, max, capacity) {
      var ilen = UNITS.length;
      var i, interval, factor;
      for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
        interval = INTERVALS[UNITS[i]];
        factor = interval.steps ? interval.steps : MAX_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
          return UNITS[i];
        }
      }
      return UNITS[ilen - 1];
    }
    function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
      var i, unit;
      for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
        unit = UNITS[i];
        if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
          return unit;
        }
      }
      return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
    }
    function determineMajorUnit(unit) {
      for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
        if (INTERVALS[UNITS[i]].common) {
          return UNITS[i];
        }
      }
    }
    function generate(scale, min, max, capacity) {
      var adapter = scale._adapter;
      var options = scale.options;
      var timeOpts = options.time;
      var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
      var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
      var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
      var first = min;
      var ticks = [];
      var time;
      if (weekday) {
        first = +adapter.startOf(first, 'isoWeek', weekday);
      }
      first = +adapter.startOf(first, weekday ? 'day' : minor);
      if (adapter.diff(max, min, minor) > 100000 * stepSize) {
        throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
      }
      for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
        ticks.push(time);
      }
      if (time === max || options.bounds === 'ticks') {
        ticks.push(time);
      }
      return ticks;
    }
    function computeOffsets(table, ticks, min, max, options) {
      var start = 0;
      var end = 0;
      var first, last;
      if (options.offset && ticks.length) {
        first = interpolate$1(table, 'time', ticks[0], 'pos');
        if (ticks.length === 1) {
          start = 1 - first;
        } else {
          start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
        }
        last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
        if (ticks.length === 1) {
          end = last;
        } else {
          end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
        }
      }
      return {
        start: start,
        end: end,
        factor: 1 / (start + 1 + end)
      };
    }
    function setMajorTicks(scale, ticks, map, majorUnit) {
      var adapter = scale._adapter;
      var first = +adapter.startOf(ticks[0].value, majorUnit);
      var last = ticks[ticks.length - 1].value;
      var major, index;
      for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
        index = map[major];
        if (index >= 0) {
          ticks[index].major = true;
        }
      }
      return ticks;
    }
    function ticksFromTimestamps(scale, values, majorUnit) {
      var ticks = [];
      var map = {};
      var ilen = values.length;
      var i, value;
      for (i = 0; i < ilen; ++i) {
        value = values[i];
        map[value] = i;
        ticks.push({
          value: value,
          major: false
        });
      }
      return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
    }
    var defaultConfig$4 = {
      position: 'bottom',
      distribution: 'linear',
      bounds: 'data',
      adapters: {},
      time: {
        parser: false,
        unit: false,
        round: false,
        displayFormat: false,
        isoWeekday: false,
        minUnit: 'millisecond',
        displayFormats: {}
      },
      ticks: {
        autoSkip: false,
        source: 'auto',
        major: {
          enabled: false
        }
      }
    };
    var scale_time = core_scale.extend({
      initialize: function initialize() {
        this.mergeTicksOptions();
        core_scale.prototype.initialize.call(this);
      },
      update: function update() {
        var me = this;
        var options = me.options;
        var time = options.time || (options.time = {});
        var adapter = me._adapter = new core_adapters._date(options.adapters.date);
        deprecated$1('time scale', time.format, 'time.format', 'time.parser');
        deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
        deprecated$1('time scale', time.max, 'time.max', 'ticks.max');
        helpers$1.mergeIf(time.displayFormats, adapter.formats());
        return core_scale.prototype.update.apply(me, arguments);
      },
      getRightValue: function getRightValue(rawValue) {
        if (rawValue && rawValue.t !== undefined) {
          rawValue = rawValue.t;
        }
        return core_scale.prototype.getRightValue.call(this, rawValue);
      },
      determineDataLimits: function determineDataLimits() {
        var me = this;
        var chart = me.chart;
        var adapter = me._adapter;
        var options = me.options;
        var unit = options.time.unit || 'day';
        var min = MAX_INTEGER;
        var max = MIN_INTEGER;
        var timestamps = [];
        var datasets = [];
        var labels = [];
        var i, j, ilen, jlen, data, timestamp, labelsAdded;
        var dataLabels = me._getLabels();
        for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
          labels.push(parse(me, dataLabels[i]));
        }
        for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
          if (chart.isDatasetVisible(i)) {
            data = chart.data.datasets[i].data;
            if (helpers$1.isObject(data[0])) {
              datasets[i] = [];
              for (j = 0, jlen = data.length; j < jlen; ++j) {
                timestamp = parse(me, data[j]);
                timestamps.push(timestamp);
                datasets[i][j] = timestamp;
              }
            } else {
              datasets[i] = labels.slice(0);
              if (!labelsAdded) {
                timestamps = timestamps.concat(labels);
                labelsAdded = true;
              }
            }
          } else {
            datasets[i] = [];
          }
        }
        if (labels.length) {
          min = Math.min(min, labels[0]);
          max = Math.max(max, labels[labels.length - 1]);
        }
        if (timestamps.length) {
          timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
          min = Math.min(min, timestamps[0]);
          max = Math.max(max, timestamps[timestamps.length - 1]);
        }
        min = parse(me, getMin(options)) || min;
        max = parse(me, getMax(options)) || max;
        min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
        max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
        me.min = Math.min(min, max);
        me.max = Math.max(min + 1, max);
        me._table = [];
        me._timestamps = {
          data: timestamps,
          datasets: datasets,
          labels: labels
        };
      },
      buildTicks: function buildTicks() {
        var me = this;
        var min = me.min;
        var max = me.max;
        var options = me.options;
        var tickOpts = options.ticks;
        var timeOpts = options.time;
        var timestamps = me._timestamps;
        var ticks = [];
        var capacity = me.getLabelCapacity(min);
        var source = tickOpts.source;
        var distribution = options.distribution;
        var i, ilen, timestamp;
        if (source === 'data' || source === 'auto' && distribution === 'series') {
          timestamps = timestamps.data;
        } else if (source === 'labels') {
          timestamps = timestamps.labels;
        } else {
          timestamps = generate(me, min, max, capacity);
        }
        if (options.bounds === 'ticks' && timestamps.length) {
          min = timestamps[0];
          max = timestamps[timestamps.length - 1];
        }
        min = parse(me, getMin(options)) || min;
        max = parse(me, getMax(options)) || max;
        for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
          timestamp = timestamps[i];
          if (timestamp >= min && timestamp <= max) {
            ticks.push(timestamp);
          }
        }
        me.min = min;
        me.max = max;
        me._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity) : determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
        me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined : determineMajorUnit(me._unit);
        me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
        me._offsets = computeOffsets(me._table, ticks, min, max, options);
        if (tickOpts.reverse) {
          ticks.reverse();
        }
        return ticksFromTimestamps(me, ticks, me._majorUnit);
      },
      getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
        var me = this;
        var adapter = me._adapter;
        var data = me.chart.data;
        var timeOpts = me.options.time;
        var label = data.labels && index < data.labels.length ? data.labels[index] : '';
        var value = data.datasets[datasetIndex].data[index];
        if (helpers$1.isObject(value)) {
          label = me.getRightValue(value);
        }
        if (timeOpts.tooltipFormat) {
          return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
        }
        if (typeof label === 'string') {
          return label;
        }
        return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
      },
      tickFormatFunction: function tickFormatFunction(time, index, ticks, format) {
        var me = this;
        var adapter = me._adapter;
        var options = me.options;
        var formats = options.time.displayFormats;
        var minorFormat = formats[me._unit];
        var majorUnit = me._majorUnit;
        var majorFormat = formats[majorUnit];
        var tick = ticks[index];
        var tickOpts = options.ticks;
        var major = majorUnit && majorFormat && tick && tick.major;
        var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
        var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
        var formatter = resolve$5([nestedTickOpts.callback, nestedTickOpts.userCallback, tickOpts.callback, tickOpts.userCallback]);
        return formatter ? formatter(label, index, ticks) : label;
      },
      convertTicksToLabels: function convertTicksToLabels(ticks) {
        var labels = [];
        var i, ilen;
        for (i = 0, ilen = ticks.length; i < ilen; ++i) {
          labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
        }
        return labels;
      },
      getPixelForOffset: function getPixelForOffset(time) {
        var me = this;
        var offsets = me._offsets;
        var pos = interpolate$1(me._table, 'time', time, 'pos');
        return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
      },
      getPixelForValue: function getPixelForValue(value, index, datasetIndex) {
        var me = this;
        var time = null;
        if (index !== undefined && datasetIndex !== undefined) {
          time = me._timestamps.datasets[datasetIndex][index];
        }
        if (time === null) {
          time = parse(me, value);
        }
        if (time !== null) {
          return me.getPixelForOffset(time);
        }
      },
      getPixelForTick: function getPixelForTick(index) {
        var ticks = this.getTicks();
        return index >= 0 && index < ticks.length ? this.getPixelForOffset(ticks[index].value) : null;
      },
      getValueForPixel: function getValueForPixel(pixel) {
        var me = this;
        var offsets = me._offsets;
        var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        var time = interpolate$1(me._table, 'pos', pos, 'time');
        return me._adapter._create(time);
      },
      _getLabelSize: function _getLabelSize(label) {
        var me = this;
        var ticksOpts = me.options.ticks;
        var tickLabelWidth = me.ctx.measureText(label).width;
        var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        var cosRotation = Math.cos(angle);
        var sinRotation = Math.sin(angle);
        var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
        return {
          w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
          h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
      },
      getLabelWidth: function getLabelWidth(label) {
        return this._getLabelSize(label).w;
      },
      getLabelCapacity: function getLabelCapacity(exampleTime) {
        var me = this;
        var timeOpts = me.options.time;
        var displayFormats = timeOpts.displayFormats;
        var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
        var size = me._getLabelSize(exampleLabel);
        var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
        if (me.options.offset) {
          capacity--;
        }
        return capacity > 0 ? capacity : 1;
      }
    });
    var _defaults$4 = defaultConfig$4;
    scale_time._defaults = _defaults$4;
    var scales = {
      category: scale_category,
      linear: scale_linear,
      logarithmic: scale_logarithmic,
      radialLinear: scale_radialLinear,
      time: scale_time
    };
    var FORMATS = {
      datetime: 'MMM D, YYYY, h:mm:ss a',
      millisecond: 'h:mm:ss.SSS a',
      second: 'h:mm:ss a',
      minute: 'h:mm a',
      hour: 'hA',
      day: 'MMM D',
      week: 'll',
      month: 'MMM YYYY',
      quarter: '[Q]Q - YYYY',
      year: 'YYYY'
    };
    core_adapters._date.override(typeof moment === 'function' ? {
      _id: 'moment',
      formats: function formats() {
        return FORMATS;
      },
      parse: function parse(value, format) {
        if (typeof value === 'string' && typeof format === 'string') {
          value = moment(value, format);
        } else if (!(value instanceof moment)) {
          value = moment(value);
        }
        return value.isValid() ? value.valueOf() : null;
      },
      format: function format(time, _format) {
        return moment(time).format(_format);
      },
      add: function add(time, amount, unit) {
        return moment(time).add(amount, unit).valueOf();
      },
      diff: function diff(max, min, unit) {
        return moment(max).diff(moment(min), unit);
      },
      startOf: function startOf(time, unit, weekday) {
        time = moment(time);
        if (unit === 'isoWeek') {
          return time.isoWeekday(weekday).valueOf();
        }
        return time.startOf(unit).valueOf();
      },
      endOf: function endOf(time, unit) {
        return moment(time).endOf(unit).valueOf();
      },
      _create: function _create(time) {
        return moment(time);
      }
    } : {});
    core_defaults._set('global', {
      plugins: {
        filler: {
          propagate: true
        }
      }
    });
    var mappers = {
      dataset: function dataset(source) {
        var index = source.fill;
        var chart = source.chart;
        var meta = chart.getDatasetMeta(index);
        var visible = meta && chart.isDatasetVisible(index);
        var points = visible && meta.dataset._children || [];
        var length = points.length || 0;
        return !length ? null : function (point, i) {
          return i < length && points[i]._view || null;
        };
      },
      boundary: function boundary(source) {
        var boundary = source.boundary;
        var x = boundary ? boundary.x : null;
        var y = boundary ? boundary.y : null;
        if (helpers$1.isArray(boundary)) {
          return function (point, i) {
            return boundary[i];
          };
        }
        return function (point) {
          return {
            x: x === null ? point.x : x,
            y: y === null ? point.y : y
          };
        };
      }
    };
    function decodeFill(el, index, count) {
      var model = el._model || {};
      var fill = model.fill;
      var target;
      if (fill === undefined) {
        fill = !!model.backgroundColor;
      }
      if (fill === false || fill === null) {
        return false;
      }
      if (fill === true) {
        return 'origin';
      }
      target = parseFloat(fill, 10);
      if (isFinite(target) && Math.floor(target) === target) {
        if (fill[0] === '-' || fill[0] === '+') {
          target = index + target;
        }
        if (target === index || target < 0 || target >= count) {
          return false;
        }
        return target;
      }
      switch (fill) {
        case 'bottom':
          return 'start';
        case 'top':
          return 'end';
        case 'zero':
          return 'origin';
        case 'origin':
        case 'start':
        case 'end':
          return fill;
        default:
          return false;
      }
    }
    function computeLinearBoundary(source) {
      var model = source.el._model || {};
      var scale = source.el._scale || {};
      var fill = source.fill;
      var target = null;
      var horizontal;
      if (isFinite(fill)) {
        return null;
      }
      if (fill === 'start') {
        target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
      } else if (fill === 'end') {
        target = model.scaleTop === undefined ? scale.top : model.scaleTop;
      } else if (model.scaleZero !== undefined) {
        target = model.scaleZero;
      } else if (scale.getBasePixel) {
        target = scale.getBasePixel();
      }
      if (target !== undefined && target !== null) {
        if (target.x !== undefined && target.y !== undefined) {
          return target;
        }
        if (helpers$1.isFinite(target)) {
          horizontal = scale.isHorizontal();
          return {
            x: horizontal ? target : null,
            y: horizontal ? null : target
          };
        }
      }
      return null;
    }
    function computeCircularBoundary(source) {
      var scale = source.el._scale;
      var options = scale.options;
      var length = scale.chart.data.labels.length;
      var fill = source.fill;
      var target = [];
      var start, end, center, i, point;
      if (!length) {
        return null;
      }
      start = options.ticks.reverse ? scale.max : scale.min;
      end = options.ticks.reverse ? scale.min : scale.max;
      center = scale.getPointPositionForValue(0, start);
      for (i = 0; i < length; ++i) {
        point = fill === 'start' || fill === 'end' ? scale.getPointPositionForValue(i, fill === 'start' ? start : end) : scale.getBasePosition(i);
        if (options.gridLines.circular) {
          point.cx = center.x;
          point.cy = center.y;
          point.angle = scale.getIndexAngle(i) - Math.PI / 2;
        }
        target.push(point);
      }
      return target;
    }
    function computeBoundary(source) {
      var scale = source.el._scale || {};
      if (scale.getPointPositionForValue) {
        return computeCircularBoundary(source);
      }
      return computeLinearBoundary(source);
    }
    function resolveTarget(sources, index, propagate) {
      var source = sources[index];
      var fill = source.fill;
      var visited = [index];
      var target;
      if (!propagate) {
        return fill;
      }
      while (fill !== false && visited.indexOf(fill) === -1) {
        if (!isFinite(fill)) {
          return fill;
        }
        target = sources[fill];
        if (!target) {
          return false;
        }
        if (target.visible) {
          return fill;
        }
        visited.push(fill);
        fill = target.fill;
      }
      return false;
    }
    function createMapper(source) {
      var fill = source.fill;
      var type = 'dataset';
      if (fill === false) {
        return null;
      }
      if (!isFinite(fill)) {
        type = 'boundary';
      }
      return mappers[type](source);
    }
    function isDrawable(point) {
      return point && !point.skip;
    }
    function drawArea(ctx, curve0, curve1, len0, len1) {
      var i, cx, cy, r;
      if (!len0 || !len1) {
        return;
      }
      ctx.moveTo(curve0[0].x, curve0[0].y);
      for (i = 1; i < len0; ++i) {
        helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
      }
      if (curve1[0].angle !== undefined) {
        cx = curve1[0].cx;
        cy = curve1[0].cy;
        r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
        for (i = len1 - 1; i > 0; --i) {
          ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
        }
        return;
      }
      ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
      for (i = len1 - 1; i > 0; --i) {
        helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
      }
    }
    function doFill(ctx, points, mapper, view, color, loop) {
      var count = points.length;
      var span = view.spanGaps;
      var curve0 = [];
      var curve1 = [];
      var len0 = 0;
      var len1 = 0;
      var i, ilen, index, p0, p1, d0, d1, loopOffset;
      ctx.beginPath();
      for (i = 0, ilen = count; i < ilen; ++i) {
        index = i % count;
        p0 = points[index]._view;
        p1 = mapper(p0, index, view);
        d0 = isDrawable(p0);
        d1 = isDrawable(p1);
        if (loop && loopOffset === undefined && d0) {
          loopOffset = i + 1;
          ilen = count + loopOffset;
        }
        if (d0 && d1) {
          len0 = curve0.push(p0);
          len1 = curve1.push(p1);
        } else if (len0 && len1) {
          if (!span) {
            drawArea(ctx, curve0, curve1, len0, len1);
            len0 = len1 = 0;
            curve0 = [];
            curve1 = [];
          } else {
            if (d0) {
              curve0.push(p0);
            }
            if (d1) {
              curve1.push(p1);
            }
          }
        }
      }
      drawArea(ctx, curve0, curve1, len0, len1);
      ctx.closePath();
      ctx.fillStyle = color;
      ctx.fill();
    }
    var plugin_filler = {
      id: 'filler',
      afterDatasetsUpdate: function afterDatasetsUpdate(chart, options) {
        var count = (chart.data.datasets || []).length;
        var propagate = options.propagate;
        var sources = [];
        var meta, i, el, source;
        for (i = 0; i < count; ++i) {
          meta = chart.getDatasetMeta(i);
          el = meta.dataset;
          source = null;
          if (el && el._model && el instanceof elements.Line) {
            source = {
              visible: chart.isDatasetVisible(i),
              fill: decodeFill(el, i, count),
              chart: chart,
              el: el
            };
          }
          meta.$filler = source;
          sources.push(source);
        }
        for (i = 0; i < count; ++i) {
          source = sources[i];
          if (!source) {
            continue;
          }
          source.fill = resolveTarget(sources, i, propagate);
          source.boundary = computeBoundary(source);
          source.mapper = createMapper(source);
        }
      },
      beforeDatasetsDraw: function beforeDatasetsDraw(chart) {
        var metasets = chart._getSortedVisibleDatasetMetas();
        var ctx = chart.ctx;
        var meta, i, el, view, points, mapper, color;
        for (i = metasets.length - 1; i >= 0; --i) {
          meta = metasets[i].$filler;
          if (!meta || !meta.visible) {
            continue;
          }
          el = meta.el;
          view = el._view;
          points = el._children || [];
          mapper = meta.mapper;
          color = view.backgroundColor || core_defaults.global.defaultColor;
          if (mapper && color && points.length) {
            helpers$1.canvas.clipArea(ctx, chart.chartArea);
            doFill(ctx, points, mapper, view, color, el._loop);
            helpers$1.canvas.unclipArea(ctx);
          }
        }
      }
    };
    var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
    var noop$1 = helpers$1.noop;
    var valueOrDefault$e = helpers$1.valueOrDefault;
    core_defaults._set('global', {
      legend: {
        display: true,
        position: 'top',
        align: 'center',
        fullWidth: true,
        reverse: false,
        weight: 1000,
        onClick: function onClick(e, legendItem) {
          var index = legendItem.datasetIndex;
          var ci = this.chart;
          var meta = ci.getDatasetMeta(index);
          meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
          ci.update();
        },
        onHover: null,
        onLeave: null,
        labels: {
          boxWidth: 40,
          padding: 10,
          generateLabels: function generateLabels(chart) {
            var datasets = chart.data.datasets;
            var options = chart.options.legend || {};
            var usePointStyle = options.labels && options.labels.usePointStyle;
            return chart._getSortedDatasetMetas().map(function (meta) {
              var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
              return {
                text: datasets[meta.index].label,
                fillStyle: style.backgroundColor,
                hidden: !chart.isDatasetVisible(meta.index),
                lineCap: style.borderCapStyle,
                lineDash: style.borderDash,
                lineDashOffset: style.borderDashOffset,
                lineJoin: style.borderJoinStyle,
                lineWidth: style.borderWidth,
                strokeStyle: style.borderColor,
                pointStyle: style.pointStyle,
                rotation: style.rotation,
                datasetIndex: meta.index
              };
            }, this);
          }
        }
      },
      legendCallback: function legendCallback(chart) {
        var list = document.createElement('ul');
        var datasets = chart.data.datasets;
        var i, ilen, listItem, listItemSpan;
        list.setAttribute('class', chart.id + '-legend');
        for (i = 0, ilen = datasets.length; i < ilen; i++) {
          listItem = list.appendChild(document.createElement('li'));
          listItemSpan = listItem.appendChild(document.createElement('span'));
          listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
          if (datasets[i].label) {
            listItem.appendChild(document.createTextNode(datasets[i].label));
          }
        }
        return list.outerHTML;
      }
    });
    function getBoxWidth(labelOpts, fontSize) {
      return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ? fontSize : labelOpts.boxWidth;
    }
    var Legend = core_element.extend({
      initialize: function initialize(config) {
        var me = this;
        helpers$1.extend(me, config);
        me.legendHitBoxes = [];
        me._hoveredItem = null;
        me.doughnutMode = false;
      },
      beforeUpdate: noop$1,
      update: function update(maxWidth, maxHeight, margins) {
        var me = this;
        me.beforeUpdate();
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me.margins = margins;
        me.beforeSetDimensions();
        me.setDimensions();
        me.afterSetDimensions();
        me.beforeBuildLabels();
        me.buildLabels();
        me.afterBuildLabels();
        me.beforeFit();
        me.fit();
        me.afterFit();
        me.afterUpdate();
        return me.minSize;
      },
      afterUpdate: noop$1,
      beforeSetDimensions: noop$1,
      setDimensions: function setDimensions() {
        var me = this;
        if (me.isHorizontal()) {
          me.width = me.maxWidth;
          me.left = 0;
          me.right = me.width;
        } else {
          me.height = me.maxHeight;
          me.top = 0;
          me.bottom = me.height;
        }
        me.paddingLeft = 0;
        me.paddingTop = 0;
        me.paddingRight = 0;
        me.paddingBottom = 0;
        me.minSize = {
          width: 0,
          height: 0
        };
      },
      afterSetDimensions: noop$1,
      beforeBuildLabels: noop$1,
      buildLabels: function buildLabels() {
        var me = this;
        var labelOpts = me.options.labels || {};
        var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];
        if (labelOpts.filter) {
          legendItems = legendItems.filter(function (item) {
            return labelOpts.filter(item, me.chart.data);
          });
        }
        if (me.options.reverse) {
          legendItems.reverse();
        }
        me.legendItems = legendItems;
      },
      afterBuildLabels: noop$1,
      beforeFit: noop$1,
      fit: function fit() {
        var me = this;
        var opts = me.options;
        var labelOpts = opts.labels;
        var display = opts.display;
        var ctx = me.ctx;
        var labelFont = helpers$1.options._parseFont(labelOpts);
        var fontSize = labelFont.size;
        var hitboxes = me.legendHitBoxes = [];
        var minSize = me.minSize;
        var isHorizontal = me.isHorizontal();
        if (isHorizontal) {
          minSize.width = me.maxWidth;
          minSize.height = display ? 10 : 0;
        } else {
          minSize.width = display ? 10 : 0;
          minSize.height = me.maxHeight;
        }
        if (!display) {
          me.width = minSize.width = me.height = minSize.height = 0;
          return;
        }
        ctx.font = labelFont.string;
        if (isHorizontal) {
          var lineWidths = me.lineWidths = [0];
          var totalHeight = 0;
          ctx.textAlign = 'left';
          ctx.textBaseline = 'middle';
          helpers$1.each(me.legendItems, function (legendItem, i) {
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var width = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
              totalHeight += fontSize + labelOpts.padding;
              lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
            }
            hitboxes[i] = {
              left: 0,
              top: 0,
              width: width,
              height: fontSize
            };
            lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
          });
          minSize.height += totalHeight;
        } else {
          var vPadding = labelOpts.padding;
          var columnWidths = me.columnWidths = [];
          var columnHeights = me.columnHeights = [];
          var totalWidth = labelOpts.padding;
          var currentColWidth = 0;
          var currentColHeight = 0;
          helpers$1.each(me.legendItems, function (legendItem, i) {
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
              totalWidth += currentColWidth + labelOpts.padding;
              columnWidths.push(currentColWidth);
              columnHeights.push(currentColHeight);
              currentColWidth = 0;
              currentColHeight = 0;
            }
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += fontSize + vPadding;
            hitboxes[i] = {
              left: 0,
              top: 0,
              width: itemWidth,
              height: fontSize
            };
          });
          totalWidth += currentColWidth;
          columnWidths.push(currentColWidth);
          columnHeights.push(currentColHeight);
          minSize.width += totalWidth;
        }
        me.width = minSize.width;
        me.height = minSize.height;
      },
      afterFit: noop$1,
      isHorizontal: function isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
      },
      draw: function draw() {
        var me = this;
        var opts = me.options;
        var labelOpts = opts.labels;
        var globalDefaults = core_defaults.global;
        var defaultColor = globalDefaults.defaultColor;
        var lineDefault = globalDefaults.elements.line;
        var legendHeight = me.height;
        var columnHeights = me.columnHeights;
        var legendWidth = me.width;
        var lineWidths = me.lineWidths;
        if (!opts.display) {
          return;
        }
        var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
        var ctx = me.ctx;
        var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
        var labelFont = helpers$1.options._parseFont(labelOpts);
        var fontSize = labelFont.size;
        var cursor;
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.strokeStyle = fontColor;
        ctx.fillStyle = fontColor;
        ctx.font = labelFont.string;
        var boxWidth = getBoxWidth(labelOpts, fontSize);
        var hitboxes = me.legendHitBoxes;
        var drawLegendBox = function drawLegendBox(x, y, legendItem) {
          if (isNaN(boxWidth) || boxWidth <= 0) {
            return;
          }
          ctx.save();
          var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
          ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
          ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
          ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
          ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
          ctx.lineWidth = lineWidth;
          ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
          if (ctx.setLineDash) {
            ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
          }
          if (labelOpts && labelOpts.usePointStyle) {
            var radius = boxWidth * Math.SQRT2 / 2;
            var centerX = rtlHelper.xPlus(x, boxWidth / 2);
            var centerY = y + fontSize / 2;
            helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
          } else {
            ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
            if (lineWidth !== 0) {
              ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
            }
          }
          ctx.restore();
        };
        var fillText = function fillText(x, y, legendItem, textWidth) {
          var halfFontSize = fontSize / 2;
          var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
          var yMiddle = y + halfFontSize;
          ctx.fillText(legendItem.text, xLeft, yMiddle);
          if (legendItem.hidden) {
            ctx.beginPath();
            ctx.lineWidth = 2;
            ctx.moveTo(xLeft, yMiddle);
            ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
            ctx.stroke();
          }
        };
        var alignmentOffset = function alignmentOffset(dimension, blockSize) {
          switch (opts.align) {
            case 'start':
              return labelOpts.padding;
            case 'end':
              return dimension - blockSize;
            default:
              return (dimension - blockSize + labelOpts.padding) / 2;
          }
        };
        var isHorizontal = me.isHorizontal();
        if (isHorizontal) {
          cursor = {
            x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
            y: me.top + labelOpts.padding,
            line: 0
          };
        } else {
          cursor = {
            x: me.left + labelOpts.padding,
            y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
            line: 0
          };
        }
        helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
        var itemHeight = fontSize + labelOpts.padding;
        helpers$1.each(me.legendItems, function (legendItem, i) {
          var textWidth = ctx.measureText(legendItem.text).width;
          var width = boxWidth + fontSize / 2 + textWidth;
          var x = cursor.x;
          var y = cursor.y;
          rtlHelper.setWidth(me.minSize.width);
          if (isHorizontal) {
            if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
              y = cursor.y += itemHeight;
              cursor.line++;
              x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
            }
          } else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
            x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
            cursor.line++;
            y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
          }
          var realX = rtlHelper.x(x);
          drawLegendBox(realX, y, legendItem);
          hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
          hitboxes[i].top = y;
          fillText(realX, y, legendItem, textWidth);
          if (isHorizontal) {
            cursor.x += width + labelOpts.padding;
          } else {
            cursor.y += itemHeight;
          }
        });
        helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
      },
      _getLegendItemAt: function _getLegendItemAt(x, y) {
        var me = this;
        var i, hitBox, lh;
        if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
          lh = me.legendHitBoxes;
          for (i = 0; i < lh.length; ++i) {
            hitBox = lh[i];
            if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
              return me.legendItems[i];
            }
          }
        }
        return null;
      },
      handleEvent: function handleEvent(e) {
        var me = this;
        var opts = me.options;
        var type = e.type === 'mouseup' ? 'click' : e.type;
        var hoveredItem;
        if (type === 'mousemove') {
          if (!opts.onHover && !opts.onLeave) {
            return;
          }
        } else if (type === 'click') {
          if (!opts.onClick) {
            return;
          }
        } else {
          return;
        }
        hoveredItem = me._getLegendItemAt(e.x, e.y);
        if (type === 'click') {
          if (hoveredItem && opts.onClick) {
            opts.onClick.call(me, e["native"], hoveredItem);
          }
        } else {
          if (opts.onLeave && hoveredItem !== me._hoveredItem) {
            if (me._hoveredItem) {
              opts.onLeave.call(me, e["native"], me._hoveredItem);
            }
            me._hoveredItem = hoveredItem;
          }
          if (opts.onHover && hoveredItem) {
            opts.onHover.call(me, e["native"], hoveredItem);
          }
        }
      }
    });
    function createNewLegendAndAttach(chart, legendOpts) {
      var legend = new Legend({
        ctx: chart.ctx,
        options: legendOpts,
        chart: chart
      });
      core_layouts.configure(chart, legend, legendOpts);
      core_layouts.addBox(chart, legend);
      chart.legend = legend;
    }
    var plugin_legend = {
      id: 'legend',
      _element: Legend,
      beforeInit: function beforeInit(chart) {
        var legendOpts = chart.options.legend;
        if (legendOpts) {
          createNewLegendAndAttach(chart, legendOpts);
        }
      },
      beforeUpdate: function beforeUpdate(chart) {
        var legendOpts = chart.options.legend;
        var legend = chart.legend;
        if (legendOpts) {
          helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
          if (legend) {
            core_layouts.configure(chart, legend, legendOpts);
            legend.options = legendOpts;
          } else {
            createNewLegendAndAttach(chart, legendOpts);
          }
        } else if (legend) {
          core_layouts.removeBox(chart, legend);
          delete chart.legend;
        }
      },
      afterEvent: function afterEvent(chart, e) {
        var legend = chart.legend;
        if (legend) {
          legend.handleEvent(e);
        }
      }
    };
    var noop$2 = helpers$1.noop;
    core_defaults._set('global', {
      title: {
        display: false,
        fontStyle: 'bold',
        fullWidth: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
      }
    });
    var Title = core_element.extend({
      initialize: function initialize(config) {
        var me = this;
        helpers$1.extend(me, config);
        me.legendHitBoxes = [];
      },
      beforeUpdate: noop$2,
      update: function update(maxWidth, maxHeight, margins) {
        var me = this;
        me.beforeUpdate();
        me.maxWidth = maxWidth;
        me.maxHeight = maxHeight;
        me.margins = margins;
        me.beforeSetDimensions();
        me.setDimensions();
        me.afterSetDimensions();
        me.beforeBuildLabels();
        me.buildLabels();
        me.afterBuildLabels();
        me.beforeFit();
        me.fit();
        me.afterFit();
        me.afterUpdate();
        return me.minSize;
      },
      afterUpdate: noop$2,
      beforeSetDimensions: noop$2,
      setDimensions: function setDimensions() {
        var me = this;
        if (me.isHorizontal()) {
          me.width = me.maxWidth;
          me.left = 0;
          me.right = me.width;
        } else {
          me.height = me.maxHeight;
          me.top = 0;
          me.bottom = me.height;
        }
        me.paddingLeft = 0;
        me.paddingTop = 0;
        me.paddingRight = 0;
        me.paddingBottom = 0;
        me.minSize = {
          width: 0,
          height: 0
        };
      },
      afterSetDimensions: noop$2,
      beforeBuildLabels: noop$2,
      buildLabels: noop$2,
      afterBuildLabels: noop$2,
      beforeFit: noop$2,
      fit: function fit() {
        var me = this;
        var opts = me.options;
        var minSize = me.minSize = {};
        var isHorizontal = me.isHorizontal();
        var lineCount, textSize;
        if (!opts.display) {
          me.width = minSize.width = me.height = minSize.height = 0;
          return;
        }
        lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
        textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
        me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
        me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
      },
      afterFit: noop$2,
      isHorizontal: function isHorizontal() {
        var pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
      },
      draw: function draw() {
        var me = this;
        var ctx = me.ctx;
        var opts = me.options;
        if (!opts.display) {
          return;
        }
        var fontOpts = helpers$1.options._parseFont(opts);
        var lineHeight = fontOpts.lineHeight;
        var offset = lineHeight / 2 + opts.padding;
        var rotation = 0;
        var top = me.top;
        var left = me.left;
        var bottom = me.bottom;
        var right = me.right;
        var maxWidth, titleX, titleY;
        ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor);
        ctx.font = fontOpts.string;
        if (me.isHorizontal()) {
          titleX = left + (right - left) / 2;
          titleY = top + offset;
          maxWidth = right - left;
        } else {
          titleX = opts.position === 'left' ? left + offset : right - offset;
          titleY = top + (bottom - top) / 2;
          maxWidth = bottom - top;
          rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
        }
        ctx.save();
        ctx.translate(titleX, titleY);
        ctx.rotate(rotation);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        var text = opts.text;
        if (helpers$1.isArray(text)) {
          var y = 0;
          for (var i = 0; i < text.length; ++i) {
            ctx.fillText(text[i], 0, y, maxWidth);
            y += lineHeight;
          }
        } else {
          ctx.fillText(text, 0, 0, maxWidth);
        }
        ctx.restore();
      }
    });
    function createNewTitleBlockAndAttach(chart, titleOpts) {
      var title = new Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
      });
      core_layouts.configure(chart, title, titleOpts);
      core_layouts.addBox(chart, title);
      chart.titleBlock = title;
    }
    var plugin_title = {
      id: 'title',
      _element: Title,
      beforeInit: function beforeInit(chart) {
        var titleOpts = chart.options.title;
        if (titleOpts) {
          createNewTitleBlockAndAttach(chart, titleOpts);
        }
      },
      beforeUpdate: function beforeUpdate(chart) {
        var titleOpts = chart.options.title;
        var titleBlock = chart.titleBlock;
        if (titleOpts) {
          helpers$1.mergeIf(titleOpts, core_defaults.global.title);
          if (titleBlock) {
            core_layouts.configure(chart, titleBlock, titleOpts);
            titleBlock.options = titleOpts;
          } else {
            createNewTitleBlockAndAttach(chart, titleOpts);
          }
        } else if (titleBlock) {
          core_layouts.removeBox(chart, titleBlock);
          delete chart.titleBlock;
        }
      }
    };
    var plugins = {};
    var filler = plugin_filler;
    var legend = plugin_legend;
    var title = plugin_title;
    plugins.filler = filler;
    plugins.legend = legend;
    plugins.title = title;
    core_controller.helpers = helpers$1;
    core_helpers();
    core_controller._adapters = core_adapters;
    core_controller.Animation = core_animation;
    core_controller.animationService = core_animations;
    core_controller.controllers = controllers;
    core_controller.DatasetController = core_datasetController;
    core_controller.defaults = core_defaults;
    core_controller.Element = core_element;
    core_controller.elements = elements;
    core_controller.Interaction = core_interaction;
    core_controller.layouts = core_layouts;
    core_controller.platform = platform;
    core_controller.plugins = core_plugins;
    core_controller.Scale = core_scale;
    core_controller.scaleService = core_scaleService;
    core_controller.Ticks = core_ticks;
    core_controller.Tooltip = core_tooltip;
    core_controller.helpers.each(scales, function (scale, type) {
      core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
    });
    for (var k in plugins) {
      if (plugins.hasOwnProperty(k)) {
        core_controller.plugins.register(plugins[k]);
      }
    }
    core_controller.platform.initialize();
    var src = core_controller;
    if (typeof window !== 'undefined') {
      window.Chart = core_controller;
    }
    core_controller.Chart = core_controller;
    core_controller.Legend = plugins.legend._element;
    core_controller.Title = plugins.title._element;
    core_controller.pluginService = core_controller.plugins;
    core_controller.PluginBase = core_controller.Element.extend({});
    core_controller.canvasHelpers = core_controller.helpers.canvas;
    core_controller.layoutService = core_controller.layouts;
    core_controller.LinearScaleBase = scale_linearbase;
    core_controller.helpers.each(['Bar', 'Bubble', 'Doughnut', 'Line', 'PolarArea', 'Radar', 'Scatter'], function (klass) {
      core_controller[klass] = function (ctx, cfg) {
        return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
          type: klass.charAt(0).toLowerCase() + klass.slice(1)
        }));
      };
    });
    return src;
  });
});
var es$1$1$1$1$1 = createCommonjsModule$1$1$1$1(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "Chart", {
    enumerable: true,
    get: function get() {
      return _chart["default"];
    }
  });
  exports.defaults = exports.Scatter = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = exports["default"] = void 0;
  var _react = _interopRequireDefault(React__default__default__default__default);
  var _propTypes = _interopRequireDefault(propTypes$1$1$1$1);
  var _chart = _interopRequireDefault(Chart$1$1$1$1);
  var _isEqual = _interopRequireDefault(isEqual);
  var _keyBy = _interopRequireDefault(keyBy);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }
    return _typeof(obj);
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }
    return _assertThisInitialized(self);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var NODE_ENV = typeof process !== 'undefined' && process.env && process.env.NODE_ENV;
  var ChartComponent = /*#__PURE__*/function (_React$Component) {
    _inherits(ChartComponent, _React$Component);
    var _super = _createSuper(ChartComponent);
    function ChartComponent() {
      var _this;
      _classCallCheck(this, ChartComponent);
      _this = _super.call(this);
      _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (event) {
        var instance = _this.chartInstance;
        var _this$props = _this.props,
          getDatasetAtEvent = _this$props.getDatasetAtEvent,
          getElementAtEvent = _this$props.getElementAtEvent,
          getElementsAtEvent = _this$props.getElementsAtEvent,
          onElementsClick = _this$props.onElementsClick;
        getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
        getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
        getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
        onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event);
      });
      _defineProperty(_assertThisInitialized(_this), "ref", function (element) {
        _this.element = element;
      });
      _this.chartInstance = undefined;
      return _this;
    }
    _createClass(ChartComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.renderChart();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        if (this.props.redraw) {
          this.destroyChart();
          this.renderChart();
          return;
        }
        this.updateChart();
      }
    }, {
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps) {
        var _this$props2 = this.props,
          type = _this$props2.type,
          options = _this$props2.options,
          plugins = _this$props2.plugins,
          legend = _this$props2.legend,
          height = _this$props2.height,
          width = _this$props2.width;
        if (nextProps.redraw === true) {
          return true;
        }
        if (height !== nextProps.height || width !== nextProps.width) {
          return true;
        }
        if (type !== nextProps.type) {
          return true;
        }
        if (!(0, _isEqual["default"])(legend, nextProps.legend)) {
          return true;
        }
        if (!(0, _isEqual["default"])(options, nextProps.options)) {
          return true;
        }
        var nextData = this.transformDataProp(nextProps);
        if (!(0, _isEqual["default"])(this.shadowDataProp, nextData)) {
          return true;
        }
        return !(0, _isEqual["default"])(plugins, nextProps.plugins);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.destroyChart();
      }
    }, {
      key: "transformDataProp",
      value: function transformDataProp(props) {
        var data = props.data;
        if (typeof data == 'function') {
          var node = this.element;
          return data(node);
        } else {
          return data;
        }
      }
    }, {
      key: "memoizeDataProps",
      value: function memoizeDataProps() {
        if (!this.props.data) {
          return;
        }
        var data = this.transformDataProp(this.props);
        this.shadowDataProp = _objectSpread(_objectSpread({}, data), {}, {
          datasets: data.datasets && data.datasets.map(function (set) {
            return _objectSpread({}, set);
          })
        });
        this.saveCurrentDatasets();
        return data;
      }
    }, {
      key: "checkDatasets",
      value: function checkDatasets(datasets) {
        var isDev = NODE_ENV !== 'production' && NODE_ENV !== 'prod';
        var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
        var multipleDatasets = datasets.length > 1;
        if (isDev && multipleDatasets && !usingCustomKeyProvider) {
          var shouldWarn = false;
          datasets.forEach(function (dataset) {
            if (!dataset.label) {
              shouldWarn = true;
            }
          });
          if (shouldWarn) {
            console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
          }
        }
      }
    }, {
      key: "getCurrentDatasets",
      value: function getCurrentDatasets() {
        return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
      }
    }, {
      key: "saveCurrentDatasets",
      value: function saveCurrentDatasets() {
        var _this2 = this;
        this.datasets = this.datasets || {};
        var currentDatasets = this.getCurrentDatasets();
        currentDatasets.forEach(function (d) {
          _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
        });
      }
    }, {
      key: "updateChart",
      value: function updateChart() {
        var _this3 = this;
        var options = this.props.options;
        var data = this.memoizeDataProps(this.props);
        if (!this.chartInstance) return;
        if (options) {
          this.chartInstance.options = _chart["default"].helpers.configMerge(this.chartInstance.options, options);
        }
        var currentDatasets = this.getCurrentDatasets();
        var nextDatasets = data.datasets || [];
        this.checkDatasets(currentDatasets);
        var currentDatasetsIndexed = (0, _keyBy["default"])(currentDatasets, this.props.datasetKeyProvider);
        this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
          var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];
          if (current && current.type === next.type && next.data) {
            current.data.splice(next.data.length);
            next.data.forEach(function (point, pid) {
              current.data[pid] = next.data[pid];
            });
            var otherProps = _objectWithoutProperties(next, ["data"]);
            return _objectSpread(_objectSpread({}, current), otherProps);
          } else {
            return next;
          }
        });
        var rest = _objectWithoutProperties(data, ["datasets"]);
        this.chartInstance.config.data = _objectSpread(_objectSpread({}, this.chartInstance.config.data), rest);
        this.chartInstance.update();
      }
    }, {
      key: "renderChart",
      value: function renderChart() {
        var _this$props3 = this.props,
          options = _this$props3.options,
          legend = _this$props3.legend,
          type = _this$props3.type,
          plugins = _this$props3.plugins;
        var node = this.element;
        var data = this.memoizeDataProps();
        if (typeof legend !== 'undefined' && !(0, _isEqual["default"])(ChartComponent.defaultProps.legend, legend)) {
          options.legend = legend;
        }
        this.chartInstance = new _chart["default"](node, {
          type: type,
          data: data,
          options: options,
          plugins: plugins
        });
      }
    }, {
      key: "destroyChart",
      value: function destroyChart() {
        if (!this.chartInstance) {
          return;
        }
        this.saveCurrentDatasets();
        var datasets = Object.values(this.datasets);
        this.chartInstance.config.data.datasets = datasets;
        this.chartInstance.destroy();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props4 = this.props,
          height = _this$props4.height,
          width = _this$props4.width,
          id = _this$props4.id;
        return /*#__PURE__*/_react["default"].createElement("canvas", {
          ref: this.ref,
          height: height,
          width: width,
          id: id,
          onClick: this.handleOnClick
        });
      }
    }]);
    return ChartComponent;
  }(_react["default"].Component);
  _defineProperty(ChartComponent, "getLabelAsKey", function (d) {
    return d.label;
  });
  _defineProperty(ChartComponent, "propTypes", {
    data: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]).isRequired,
    getDatasetAtEvent: _propTypes["default"].func,
    getElementAtEvent: _propTypes["default"].func,
    getElementsAtEvent: _propTypes["default"].func,
    height: _propTypes["default"].number,
    legend: _propTypes["default"].object,
    onElementsClick: _propTypes["default"].func,
    options: _propTypes["default"].object,
    plugins: _propTypes["default"].arrayOf(_propTypes["default"].object),
    redraw: _propTypes["default"].bool,
    type: function type(props, propName, componentName) {
      if (!_chart["default"].controllers[props[propName]]) {
        return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
      }
    },
    width: _propTypes["default"].number,
    datasetKeyProvider: _propTypes["default"].func
  });
  _defineProperty(ChartComponent, "defaultProps", {
    legend: {
      display: true,
      position: 'bottom'
    },
    type: 'doughnut',
    height: 150,
    width: 300,
    redraw: false,
    options: {},
    datasetKeyProvider: ChartComponent.getLabelAsKey
  });
  var _default = ChartComponent;
  exports["default"] = _default;
  var Doughnut = /*#__PURE__*/function (_React$Component2) {
    _inherits(Doughnut, _React$Component2);
    var _super2 = _createSuper(Doughnut);
    function Doughnut() {
      _classCallCheck(this, Doughnut);
      return _super2.apply(this, arguments);
    }
    _createClass(Doughnut, [{
      key: "render",
      value: function render() {
        var _this4 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref) {
            return _this4.chartInstance = _ref && _ref.chartInstance;
          },
          type: "doughnut"
        }));
      }
    }]);
    return Doughnut;
  }(_react["default"].Component);
  exports.Doughnut = Doughnut;
  var Pie = /*#__PURE__*/function (_React$Component3) {
    _inherits(Pie, _React$Component3);
    var _super3 = _createSuper(Pie);
    function Pie() {
      _classCallCheck(this, Pie);
      return _super3.apply(this, arguments);
    }
    _createClass(Pie, [{
      key: "render",
      value: function render() {
        var _this5 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref2) {
            return _this5.chartInstance = _ref2 && _ref2.chartInstance;
          },
          type: "pie"
        }));
      }
    }]);
    return Pie;
  }(_react["default"].Component);
  exports.Pie = Pie;
  var Line = /*#__PURE__*/function (_React$Component4) {
    _inherits(Line, _React$Component4);
    var _super4 = _createSuper(Line);
    function Line() {
      _classCallCheck(this, Line);
      return _super4.apply(this, arguments);
    }
    _createClass(Line, [{
      key: "render",
      value: function render() {
        var _this6 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref3) {
            return _this6.chartInstance = _ref3 && _ref3.chartInstance;
          },
          type: "line"
        }));
      }
    }]);
    return Line;
  }(_react["default"].Component);
  exports.Line = Line;
  var Bar = /*#__PURE__*/function (_React$Component5) {
    _inherits(Bar, _React$Component5);
    var _super5 = _createSuper(Bar);
    function Bar() {
      _classCallCheck(this, Bar);
      return _super5.apply(this, arguments);
    }
    _createClass(Bar, [{
      key: "render",
      value: function render() {
        var _this7 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref4) {
            return _this7.chartInstance = _ref4 && _ref4.chartInstance;
          },
          type: "bar"
        }));
      }
    }]);
    return Bar;
  }(_react["default"].Component);
  exports.Bar = Bar;
  var HorizontalBar = /*#__PURE__*/function (_React$Component6) {
    _inherits(HorizontalBar, _React$Component6);
    var _super6 = _createSuper(HorizontalBar);
    function HorizontalBar() {
      _classCallCheck(this, HorizontalBar);
      return _super6.apply(this, arguments);
    }
    _createClass(HorizontalBar, [{
      key: "render",
      value: function render() {
        var _this8 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref5) {
            return _this8.chartInstance = _ref5 && _ref5.chartInstance;
          },
          type: "horizontalBar"
        }));
      }
    }]);
    return HorizontalBar;
  }(_react["default"].Component);
  exports.HorizontalBar = HorizontalBar;
  var Radar = /*#__PURE__*/function (_React$Component7) {
    _inherits(Radar, _React$Component7);
    var _super7 = _createSuper(Radar);
    function Radar() {
      _classCallCheck(this, Radar);
      return _super7.apply(this, arguments);
    }
    _createClass(Radar, [{
      key: "render",
      value: function render() {
        var _this9 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref6) {
            return _this9.chartInstance = _ref6 && _ref6.chartInstance;
          },
          type: "radar"
        }));
      }
    }]);
    return Radar;
  }(_react["default"].Component);
  exports.Radar = Radar;
  var Polar = /*#__PURE__*/function (_React$Component8) {
    _inherits(Polar, _React$Component8);
    var _super8 = _createSuper(Polar);
    function Polar() {
      _classCallCheck(this, Polar);
      return _super8.apply(this, arguments);
    }
    _createClass(Polar, [{
      key: "render",
      value: function render() {
        var _this10 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref7) {
            return _this10.chartInstance = _ref7 && _ref7.chartInstance;
          },
          type: "polarArea"
        }));
      }
    }]);
    return Polar;
  }(_react["default"].Component);
  exports.Polar = Polar;
  var Bubble = /*#__PURE__*/function (_React$Component9) {
    _inherits(Bubble, _React$Component9);
    var _super9 = _createSuper(Bubble);
    function Bubble() {
      _classCallCheck(this, Bubble);
      return _super9.apply(this, arguments);
    }
    _createClass(Bubble, [{
      key: "render",
      value: function render() {
        var _this11 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref8) {
            return _this11.chartInstance = _ref8 && _ref8.chartInstance;
          },
          type: "bubble"
        }));
      }
    }]);
    return Bubble;
  }(_react["default"].Component);
  exports.Bubble = Bubble;
  var Scatter = /*#__PURE__*/function (_React$Component10) {
    _inherits(Scatter, _React$Component10);
    var _super10 = _createSuper(Scatter);
    function Scatter() {
      _classCallCheck(this, Scatter);
      return _super10.apply(this, arguments);
    }
    _createClass(Scatter, [{
      key: "render",
      value: function render() {
        var _this12 = this;
        return /*#__PURE__*/_react["default"].createElement(ChartComponent, _extends({}, this.props, {
          ref: function ref(_ref9) {
            return _this12.chartInstance = _ref9 && _ref9.chartInstance;
          },
          type: "scatter"
        }));
      }
    }]);
    return Scatter;
  }(_react["default"].Component);
  exports.Scatter = Scatter;
  var defaults = _chart["default"].defaults;
  exports.defaults = defaults;
});
unwrapExports$1$1$1$1(es$1$1$1$1$1);
function r$1$1$1$1$1(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r$1$1$1$1$1(e[t])) && (n && (n += " "), n += f);else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx$1$1$1$1() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) (e = arguments[f++]) && (t = r$1$1$1$1$1(e)) && (n && (n += " "), n += t);
  return n;
}
var clsx_m$1$1$1$1 = {
  __proto__: null,
  clsx: clsx$1$1$1$1,
  'default': clsx$1$1$1$1
};
var require$$1$1$1$1$1 = getCjsExportFromNamespace$1$1$1$1(clsx_m$1$1$1$1);
var dist$1$1$1$1 = createCommonjsModule$1$1$1$1(function (module) {
  module.exports = function (n) {
    var e = {};
    function t(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return n[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }
    return t.m = n, t.c = e, t.d = function (n, e, r) {
      t.o(n, e) || Object.defineProperty(n, e, {
        enumerable: !0,
        get: r
      });
    }, t.r = function (n) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(n, "__esModule", {
        value: !0
      });
    }, t.t = function (n, e) {
      if (1 & e && (n = t(n)), 8 & e) return n;
      if (4 & e && "object" == typeof n && n && n.__esModule) return n;
      var r = Object.create(null);
      if (t.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: n
      }), 2 & e && "string" != typeof n) for (var o in n) t.d(r, o, function (e) {
        return n[e];
      }.bind(null, o));
      return r;
    }, t.n = function (n) {
      var e = n && n.__esModule ? function () {
        return n["default"];
      } : function () {
        return n;
      };
      return t.d(e, "a", e), e;
    }, t.o = function (n, e) {
      return Object.prototype.hasOwnProperty.call(n, e);
    }, t.p = "", t(t.s = 182);
  }([function (n, e, t) {
    n.exports = t(174)();
  }, function (n, e) {
    n.exports = React__default__default__default__default;
  }, function (n, e) {
    var t = Array.isArray;
    n.exports = t;
  }, function (n, e, t) {
    var r = t(40),
      o = "object" == typeof self && self && self.Object === Object && self,
      a = r || o || Function("return this")();
    n.exports = a;
  }, function (n, e, t) {
    var r = t(78),
      o = t(25),
      a = t(27),
      i = t(28);
    n.exports = function (n, e, t) {
      return n = i(n), t = null == t ? 0 : r(a(t), 0, n.length), e = o(e), n.slice(t, t + e.length) == e;
    };
  }, function (n, e, t) {
    var r = t(171)(t(23));
    n.exports = r;
  }, function (n, e, t) {
    var r = t(14),
      o = t(76),
      a = t(77),
      i = "[object Null]",
      u = "[object Undefined]",
      c = r ? r.toStringTag : void 0;
    n.exports = function (n) {
      return null == n ? void 0 === n ? u : i : c && c in Object(n) ? o(n) : a(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return null != n && "object" == typeof n;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = typeof n;
      return null != n && ("object" == e || "function" == e);
    };
  }, function (n, e, t) {
    var r = t(92),
      o = t(95);
    n.exports = function (n, e) {
      var t = o(n, e);
      return r(t) ? t : void 0;
    };
  }, function (n, e, t) {
    var r = t(111),
      o = t(150),
      a = t(157),
      i = t(2),
      u = t(158);
    n.exports = function (n) {
      return "function" == typeof n ? n : null == n ? a : "object" == typeof n ? i(n) ? o(n[0], n[1]) : r(n) : u(n);
    };
  }, function (n, e, t) {
    var r = t(44),
      o = t(34);
    n.exports = function (n) {
      return null != n && o(n.length) && !r(n);
    };
  }, function (n, e, t) {
    var r = t(133),
      o = t(140),
      a = t(11);
    n.exports = function (n) {
      return a(n) ? r(n) : o(n);
    };
  }, function (n, e, t) {
    var r = t(26),
      o = t(10),
      a = t(168),
      i = t(2);
    n.exports = function (n, e) {
      return (i(n) ? r : a)(n, o(e, 3));
    };
  }, function (n, e, t) {
    var r = t(3).Symbol;
    n.exports = r;
  }, function (n, e, t) {
    var r = t(6),
      o = t(7),
      a = "[object Symbol]";
    n.exports = function (n) {
      return "symbol" == typeof n || o(n) && r(n) == a;
    };
  }, function (n, e, t) {
    var r = t(9)(Object, "create");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(100),
      o = t(101),
      a = t(102),
      i = t(103),
      u = t(104);
    function c(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }
    c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e, t) {
    var r = t(31);
    n.exports = function (n, e) {
      for (var t = n.length; t--;) if (r(n[t][0], e)) return t;
      return -1;
    };
  }, function (n, e, t) {
    var r = t(106);
    n.exports = function (n, e) {
      var t = n.__data__;
      return r(e) ? t["string" == typeof e ? "string" : "hash"] : t.map;
    };
  }, function (n, e, t) {
    var r = t(15),
      o = 1 / 0;
    n.exports = function (n) {
      if ("string" == typeof n || r(n)) return n;
      var e = n + "";
      return "0" == e && 1 / n == -o ? "-0" : e;
    };
  }, function (n, e, t) {
    var r = t(164),
      o = t(167)(r);
    n.exports = o;
  }, function (n, e, t) {
    var r = t(30),
      o = "Expected a function";
    function a(n, e) {
      if ("function" != typeof n || null != e && "function" != typeof e) throw new TypeError(o);
      var t = function t() {
        var r = arguments,
          o = e ? e.apply(this, r) : r[0],
          a = t.cache;
        if (a.has(o)) return a.get(o);
        var i = n.apply(this, r);
        return t.cache = a.set(o, i) || a, i;
      };
      return t.cache = new (a.Cache || r)(), t;
    }
    a.Cache = r, n.exports = a;
  }, function (n, e, t) {
    var r = t(43),
      o = t(10),
      a = t(27),
      i = Math.max;
    n.exports = function (n, e, t) {
      var u = null == n ? 0 : n.length;
      if (!u) return -1;
      var c = null == t ? 0 : a(t);
      return c < 0 && (c = i(u + c, 0)), r(n, o(e, 3), c);
    };
  }, function (n, e, t) {
    var r = t(50),
      o = t(163),
      a = t(10),
      i = t(2);
    n.exports = function (n, e) {
      return (i(n) ? r : o)(n, a(e, 3));
    };
  }, function (n, e, t) {
    var r = t(14),
      o = t(26),
      a = t(2),
      i = t(15),
      u = 1 / 0,
      c = r ? r.prototype : void 0,
      s = c ? c.toString : void 0;
    n.exports = function n(e) {
      if ("string" == typeof e) return e;
      if (a(e)) return o(e, n) + "";
      if (i(e)) return s ? s.call(e) : "";
      var t = e + "";
      return "0" == t && 1 / e == -u ? "-0" : t;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length, o = Array(r); ++t < r;) o[t] = e(n[t], t, n);
      return o;
    };
  }, function (n, e, t) {
    var r = t(79);
    n.exports = function (n) {
      var e = r(n),
        t = e % 1;
      return e == e ? t ? e - t : e : 0;
    };
  }, function (n, e, t) {
    var r = t(25);
    n.exports = function (n) {
      return null == n ? "" : r(n);
    };
  }, function (n, e, t) {
    var r = t(43),
      o = t(82),
      a = t(83);
    n.exports = function (n, e, t) {
      return e == e ? a(n, e, t) : r(n, o, t);
    };
  }, function (n, e, t) {
    var r = t(89),
      o = t(105),
      a = t(107),
      i = t(108),
      u = t(109);
    function c(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }
    c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e) {
    n.exports = function (n, e) {
      return n === e || n != n && e != e;
    };
  }, function (n, e, t) {
    var r = t(9)(t(3), "Map");
    n.exports = r;
  }, function (n, e) {
    var t = 9007199254740991,
      r = /^(?:0|[1-9]\d*)$/;
    n.exports = function (n, e) {
      var o = typeof n;
      return !!(e = null == e ? t : e) && ("number" == o || "symbol" != o && r.test(n)) && n > -1 && n % 1 == 0 && n < e;
    };
  }, function (n, e) {
    var t = 9007199254740991;
    n.exports = function (n) {
      return "number" == typeof n && n > -1 && n % 1 == 0 && n <= t;
    };
  }, function (n, e, t) {
    var r = t(2),
      o = t(15),
      a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      i = /^\w*$/;
    n.exports = function (n, e) {
      if (r(n)) return !1;
      var t = typeof n;
      return !("number" != t && "symbol" != t && "boolean" != t && null != n && !o(n)) || i.test(n) || !a.test(n) || null != e && n in Object(e);
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(2),
      a = t(7),
      i = "[object String]";
    n.exports = function (n) {
      return "string" == typeof n || !o(n) && a(n) && r(n) == i;
    };
  }, function (n, e, t) {
    var r = t(169),
      o = t(21),
      a = t(10),
      i = t(170),
      u = t(2);
    n.exports = function (n, e, t) {
      var c = u(n) ? r : i,
        s = arguments.length < 3;
      return c(n, a(e, 4), t, s, o);
    };
  }, function (n, e, t) {
    var r = t(49),
      o = t(10),
      a = t(172),
      i = t(2),
      u = t(173);
    n.exports = function (n, e, t) {
      var c = i(n) ? r : a;
      return t && u(n, e, t) && (e = void 0), c(n, o(e, 3));
    };
  }, function (n, e) {
    var t;
    function r(n, e) {
      var t = Object.keys(n);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(n);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        })), t.push.apply(t, r);
      }
      return t;
    }
    function o(n, e, t) {
      return e in n ? Object.defineProperty(n, e, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[e] = t, n;
    }
    function a(n, e) {
      return function (n) {
        if (Array.isArray(n)) return n;
      }(n) || function (n, e) {
        if (!(Symbol.iterator in Object(n) || "[object Arguments]" === Object.prototype.toString.call(n))) return;
        var t = [],
          r = !0,
          o = !1,
          a = void 0;
        try {
          for (var i, u = n[Symbol.iterator](); !(r = (i = u.next()).done) && (t.push(i.value), !e || t.length !== e); r = !0);
        } catch (n) {
          o = !0, a = n;
        } finally {
          try {
            r || null == u["return"] || u["return"]();
          } finally {
            if (o) throw a;
          }
        }
        return t;
      }(n, e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }
    var i = {};
    function u(n, e, t) {
      e in i || (i[e] = []);
      var r = t || 0;
      i[e][r] = n;
    }
    var c,
      s = (t = []).concat.apply(t, function (n) {
        if (Array.isArray(n)) {
          for (var e = 0, t = new Array(n.length); e < n.length; e++) t[e] = n[e];
          return t;
        }
      }(c = [["Afghanistan", ["asia"], "af", "93"], ["Albania", ["europe"], "al", "355"], ["Algeria", ["africa", "north-africa"], "dz", "213"], ["American Samoa", ["oceania"], "as", "1684"], ["Andorra", ["europe"], "ad", "376"], ["Angola", ["africa"], "ao", "244"], ["Anguilla", ["america", "carribean"], "ai", "1264"], ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"], ["Argentina", ["america", "south-america"], "ar", "54", "+.. (..) ........"], ["Armenia", ["asia", "ex-ussr"], "am", "374"], ["Aruba", ["america", "carribean"], "aw", "297"], ["Australia", ["oceania"], "au", "61", "+.. ... ... ..."], ["Austria", ["europe", "european-union"], "at", "43"], ["Azerbaijan", ["asia", "ex-ussr"], "az", "994"], ["Bahamas", ["america", "carribean"], "bs", "1242"], ["Bahrain", ["middle-east"], "bh", "973"], ["Bangladesh", ["asia"], "bd", "880"], ["Barbados", ["america", "carribean"], "bb", "1246"], ["Belarus", ["europe", "ex-ussr"], "by", "375", "+... (..) ... .. .."], ["Belgium", ["europe", "european-union"], "be", "32", "+.. ... .. .. .."], ["Belize", ["america", "central-america"], "bz", "501"], ["Benin", ["africa"], "bj", "229"], ["Bermuda", ["america", "north-america"], "bm", "1441"], ["Bhutan", ["asia"], "bt", "975"], ["Bolivia", ["america", "south-america"], "bo", "591"], ["Bosnia and Herzegovina", ["europe"], "ba", "387"], ["Botswana", ["africa"], "bw", "267"], ["Brazil", ["america", "south-america"], "br", "55", "+.. (..) ........."], ["British Indian Ocean Territory", ["asia"], "io", "246"], ["British Virgin Islands", ["america", "carribean"], "vg", "1284"], ["Brunei", ["asia"], "bn", "673"], ["Bulgaria", ["europe", "european-union"], "bg", "359"], ["Burkina Faso", ["africa"], "bf", "226"], ["Burundi", ["africa"], "bi", "257"], ["Cambodia", ["asia"], "kh", "855"], ["Cameroon", ["africa"], "cm", "237"], ["Canada", ["america", "north-america"], "ca", "1", "+. (...) ...-....", 1, ["204", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde", ["africa"], "cv", "238"], ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1], ["Cayman Islands", ["america", "carribean"], "ky", "1345"], ["Central African Republic", ["africa"], "cf", "236"], ["Chad", ["africa"], "td", "235"], ["Chile", ["america", "south-america"], "cl", "56"], ["China", ["asia"], "cn", "86", "+.. ..-........."], ["Colombia", ["america", "south-america"], "co", "57"], ["Comoros", ["africa"], "km", "269"], ["Congo", ["africa"], "cd", "243"], ["Congo", ["africa"], "cg", "242"], ["Cook Islands", ["oceania"], "ck", "682"], ["Costa Rica", ["america", "central-america"], "cr", "506", "+... ....-...."], ["Côte d’Ivoire", ["africa"], "ci", "225"], ["Croatia", ["europe", "european-union"], "hr", "385"], ["Cuba", ["america", "carribean"], "cu", "53"], ["Curaçao", ["america", "carribean"], "cw", "599", "", 0], ["Cyprus", ["europe", "european-union"], "cy", "357", "+... .. ......"], ["Czech Republic", ["europe", "european-union"], "cz", "420"], ["Denmark", ["europe", "european-union"], "dk", "45", "+.. .. .. .. .."], ["Djibouti", ["africa"], "dj", "253"], ["Dominica", ["america", "carribean"], "dm", "1767"], ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2, ["809", "829", "849"]], ["Ecuador", ["america", "south-america"], "ec", "593"], ["Egypt", ["africa", "north-africa"], "eg", "20"], ["El Salvador", ["america", "central-america"], "sv", "503", "+... ....-...."], ["Equatorial Guinea", ["africa"], "gq", "240"], ["Eritrea", ["africa"], "er", "291"], ["Estonia", ["europe", "european-union", "ex-ussr"], "ee", "372", "+... .... ......"], ["Ethiopia", ["africa"], "et", "251"], ["Falkland Islands", ["america", "south-america"], "fk", "500"], ["Faroe Islands", ["europe"], "fo", "298"], ["Fiji", ["oceania"], "fj", "679"], ["Finland", ["europe", "european-union"], "fi", "358", "+... .. ... .. .."], ["France", ["europe", "european-union"], "fr", "33", "+.. . .. .. .. .."], ["French Guiana", ["america", "south-america"], "gf", "594"], ["French Polynesia", ["oceania"], "pf", "689"], ["Gabon", ["africa"], "ga", "241"], ["Gambia", ["africa"], "gm", "220"], ["Georgia", ["asia", "ex-ussr"], "ge", "995"], ["Germany", ["europe", "european-union"], "de", "49", "+.. .... ........"], ["Ghana", ["africa"], "gh", "233"], ["Gibraltar", ["europe"], "gi", "350"], ["Greece", ["europe", "european-union"], "gr", "30"], ["Greenland", ["america"], "gl", "299"], ["Grenada", ["america", "carribean"], "gd", "1473"], ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0], ["Guam", ["oceania"], "gu", "1671"], ["Guatemala", ["america", "central-america"], "gt", "502", "+... ....-...."], ["Guinea", ["africa"], "gn", "224"], ["Guinea-Bissau", ["africa"], "gw", "245"], ["Guyana", ["america", "south-america"], "gy", "592"], ["Haiti", ["america", "carribean"], "ht", "509", "+... ....-...."], ["Honduras", ["america", "central-america"], "hn", "504"], ["Hong Kong", ["asia"], "hk", "852", "+... .... ...."], ["Hungary", ["europe", "european-union"], "hu", "36"], ["Iceland", ["europe"], "is", "354", "+... ... ...."], ["India", ["asia"], "in", "91", "+.. .....-....."], ["Indonesia", ["asia"], "id", "62"], ["Iran", ["middle-east"], "ir", "98"], ["Iraq", ["middle-east"], "iq", "964"], ["Ireland", ["europe", "european-union"], "ie", "353", "+... .. ......."], ["Israel", ["middle-east"], "il", "972", "+... ... ... ...."], ["Italy", ["europe", "european-union"], "it", "39", "+.. ... .......", 0], ["Jamaica", ["america", "carribean"], "jm", "1876"], ["Japan", ["asia"], "jp", "81", "+.. .. .... ...."], ["Jordan", ["middle-east"], "jo", "962"], ["Kazakhstan", ["asia", "ex-ussr"], "kz", "7", "+. ... ...-..-..", 1, ["313", "327", "7172", "312", "73622", "321", "324", "336", "318", "315", "325", "311", "326", "310"]], ["Kenya", ["africa"], "ke", "254"], ["Kiribati", ["oceania"], "ki", "686"], ["Kuwait", ["middle-east"], "kw", "965"], ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996"], ["Laos", ["asia"], "la", "856"], ["Latvia", ["europe", "european-union", "ex-ussr"], "lv", "371"], ["Lebanon", ["middle-east"], "lb", "961"], ["Lesotho", ["africa"], "ls", "266"], ["Liberia", ["africa"], "lr", "231"], ["Libya", ["africa", "north-africa"], "ly", "218"], ["Liechtenstein", ["europe"], "li", "423"], ["Lithuania", ["europe", "european-union", "ex-ussr"], "lt", "370"], ["Luxembourg", ["europe", "european-union"], "lu", "352"], ["Macau", ["asia"], "mo", "853"], ["Macedonia", ["europe"], "mk", "389"], ["Madagascar", ["africa"], "mg", "261"], ["Malawi", ["africa"], "mw", "265"], ["Malaysia", ["asia"], "my", "60", "+.. ..-....-...."], ["Maldives", ["asia"], "mv", "960"], ["Mali", ["africa"], "ml", "223"], ["Malta", ["europe", "european-union"], "mt", "356"], ["Marshall Islands", ["oceania"], "mh", "692"], ["Martinique", ["america", "carribean"], "mq", "596"], ["Mauritania", ["africa"], "mr", "222"], ["Mauritius", ["africa"], "mu", "230"], ["Mexico", ["america", "central-america"], "mx", "52"], ["Micronesia", ["oceania"], "fm", "691"], ["Moldova", ["europe"], "md", "373", "+... (..) ..-..-.."], ["Monaco", ["europe"], "mc", "377"], ["Mongolia", ["asia"], "mn", "976"], ["Montenegro", ["europe"], "me", "382"], ["Montserrat", ["america", "carribean"], "ms", "1664"], ["Morocco", ["africa", "north-africa"], "ma", "212"], ["Mozambique", ["africa"], "mz", "258"], ["Myanmar", ["asia"], "mm", "95"], ["Namibia", ["africa"], "na", "264"], ["Nauru", ["africa"], "nr", "674"], ["Nepal", ["asia"], "np", "977"], ["Netherlands", ["europe", "european-union"], "nl", "31", "+.. .. ........"], ["New Caledonia", ["oceania"], "nc", "687"], ["New Zealand", ["oceania"], "nz", "64", "+.. ...-...-...."], ["Nicaragua", ["america", "central-america"], "ni", "505"], ["Niger", ["africa"], "ne", "227"], ["Nigeria", ["africa"], "ng", "234"], ["Niue", ["asia"], "nu", "683"], ["Norfolk Island", ["oceania"], "nf", "672"], ["North Korea", ["asia"], "kp", "850"], ["Northern Mariana Islands", ["oceania"], "mp", "1670"], ["Norway", ["europe"], "no", "47", "+.. ... .. ..."], ["Oman", ["middle-east"], "om", "968"], ["Pakistan", ["asia"], "pk", "92", "+.. ...-......."], ["Palau", ["oceania"], "pw", "680"], ["Palestine", ["middle-east"], "ps", "970"], ["Panama", ["america", "central-america"], "pa", "507"], ["Papua New Guinea", ["oceania"], "pg", "675"], ["Paraguay", ["america", "south-america"], "py", "595"], ["Peru", ["america", "south-america"], "pe", "51"], ["Philippines", ["asia"], "ph", "63", "+.. .... ......."], ["Poland", ["europe", "european-union"], "pl", "48", "+.. ...-...-..."], ["Portugal", ["europe", "european-union"], "pt", "351"], ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3, ["787", "939"]], ["Qatar", ["middle-east"], "qa", "974"], ["Réunion", ["africa"], "re", "262"], ["Romania", ["europe", "european-union"], "ro", "40"], ["Russia", ["europe", "asia", "ex-ussr"], "ru", "7", "+. (...) ...-..-..", 0], ["Rwanda", ["africa"], "rw", "250"], ["Saint Barthélemy", ["america", "carribean"], "bl", "590", "", 1], ["Saint Helena", ["africa"], "sh", "290"], ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"], ["Saint Lucia", ["america", "carribean"], "lc", "1758"], ["Saint Martin", ["america", "carribean"], "mf", "590", "", 2], ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"], ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"], ["Samoa", ["oceania"], "ws", "685"], ["San Marino", ["europe"], "sm", "378"], ["São Tomé and Príncipe", ["africa"], "st", "239"], ["Saudi Arabia", ["middle-east"], "sa", "966"], ["Senegal", ["africa"], "sn", "221"], ["Serbia", ["europe"], "rs", "381"], ["Seychelles", ["africa"], "sc", "248"], ["Sierra Leone", ["africa"], "sl", "232"], ["Singapore", ["asia"], "sg", "65", "+.. ....-...."], ["Sint Maarten", ["america", "carribean"], "sx", "1721"], ["Slovakia", ["europe", "european-union"], "sk", "421"], ["Slovenia", ["europe", "european-union"], "si", "386"], ["Solomon Islands", ["oceania"], "sb", "677"], ["Somalia", ["africa"], "so", "252"], ["South Africa", ["africa"], "za", "27"], ["South Korea", ["asia"], "kr", "82", "+.. ... .... ...."], ["South Sudan", ["africa", "north-africa"], "ss", "211"], ["Spain", ["europe", "european-union"], "es", "34", "+.. ... ... ..."], ["Sri Lanka", ["asia"], "lk", "94"], ["Sudan", ["africa"], "sd", "249"], ["Suriname", ["america", "south-america"], "sr", "597"], ["Swaziland", ["africa"], "sz", "268"], ["Sweden", ["europe", "european-union"], "se", "46", "+.. (..) ...-..-.."], ["Switzerland", ["europe"], "ch", "41", "+.. .. ... .. .."], ["Syria", ["middle-east"], "sy", "963"], ["Taiwan", ["asia"], "tw", "886"], ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"], ["Tanzania", ["africa"], "tz", "255"], ["Thailand", ["asia"], "th", "66"], ["Timor-Leste", ["asia"], "tl", "670"], ["Togo", ["africa"], "tg", "228"], ["Tokelau", ["oceania"], "tk", "690"], ["Tonga", ["oceania"], "to", "676"], ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"], ["Tunisia", ["africa", "north-africa"], "tn", "216"], ["Turkey", ["europe"], "tr", "90", "+.. ... ... .. .."], ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"], ["Turks and Caicos Islands", ["america", "carribean"], "tc", "1649"], ["Tuvalu", ["asia"], "tv", "688"], ["U.S. Virgin Islands", ["america", "carribean"], "vi", "1340"], ["Uganda", ["africa"], "ug", "256"], ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "+... (..) ... .. .."], ["United Arab Emirates", ["middle-east"], "ae", "971"], ["United Kingdom", ["europe", "european-union"], "gb", "44", "+.. .... ......"], ["United States", ["america", "north-america"], "us", "1", "+. (...) ...-....", 0, ["907", "205", "251", "256", "334", "479", "501", "870", "480", "520", "602", "623", "928", "209", "213", "310", "323", "408", "415", "510", "530", "559", "562", "619", "626", "650", "661", "707", "714", "760", "805", "818", "831", "858", "909", "916", "925", "949", "951", "303", "719", "970", "203", "860", "202", "302", "239", "305", "321", "352", "386", "407", "561", "727", "772", "813", "850", "863", "904", "941", "954", "229", "404", "478", "706", "770", "912", "808", "319", "515", "563", "641", "712", "208", "217", "309", "312", "618", "630", "708", "773", "815", "847", "219", "260", "317", "574", "765", "812", "316", "620", "785", "913", "270", "502", "606", "859", "225", "318", "337", "504", "985", "413", "508", "617", "781", "978", "301", "410", "207", "231", "248", "269", "313", "517", "586", "616", "734", "810", "906", "989", "218", "320", "507", "612", "651", "763", "952", "314", "417", "573", "636", "660", "816", "228", "601", "662", "406", "252", "336", "704", "828", "910", "919", "701", "308", "402", "603", "201", "609", "732", "856", "908", "973", "505", "575", "702", "775", "212", "315", "516", "518", "585", "607", "631", "716", "718", "845", "914", "216", "330", "419", "440", "513", "614", "740", "937", "405", "580", "918", "503", "541", "215", "412", "570", "610", "717", "724", "814", "401", "803", "843", "864", "605", "423", "615", "731", "865", "901", "931", "210", "214", "254", "281", "325", "361", "409", "432", "512", "713", "806", "817", "830", "903", "915", "936", "940", "956", "972", "979", "435", "801", "276", "434", "540", "703", "757", "804", "802", "206", "253", "360", "425", "509", "262", "414", "608", "715", "920", "304", "307"]], ["Uruguay", ["america", "south-america"], "uy", "598"], ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998"], ["Vanuatu", ["oceania"], "vu", "678"], ["Vatican City", ["europe"], "va", "39", "+.. .. .... ....", 1], ["Venezuela", ["america", "south-america"], "ve", "58"], ["Vietnam", ["asia"], "vn", "84"], ["Wallis and Futuna", ["oceania"], "wf", "681"], ["Yemen", ["middle-east"], "ye", "967"], ["Zambia", ["africa"], "zm", "260"], ["Zimbabwe", ["africa"], "zw", "263"]].map(function (n) {
        var e = a(n, 7),
          t = e[0],
          i = e[1],
          c = e[2],
          s = e[3],
          p = e[4],
          f = e[5],
          l = e[6],
          g = {
            name: t,
            regions: i,
            iso2: c,
            dialCode: s,
            priority: f,
            format: p || void 0,
            hasAreaCodes: l
          },
          d = [];
        return g.hasAreaCodes && l.forEach(function (n) {
          var e = function (n) {
            for (var e = 1; e < arguments.length; e++) {
              var t = null != arguments[e] ? arguments[e] : {};
              e % 2 ? r(t, !0).forEach(function (e) {
                o(n, e, t[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : r(t).forEach(function (e) {
                Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(t, e));
              });
            }
            return n;
          }({}, g, {
            regions: i,
            dialCode: "".concat(s).concat(n),
            isAreaCode: !0
          });
          d.push(e), u(c, e.dialCode);
        }), u(g.iso2, g.dialCode, g.hasAreaCodes), d.length > 0 ? [g].concat(d) : [g];
      })) || function (n) {
        if (Symbol.iterator in Object(n) || "[object Arguments]" === Object.prototype.toString.call(n)) return Array.from(n);
      }(c) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }());
    n.exports = {
      allCountries: s,
      allCountryCodes: i
    };
  }, function (n, e, t) {
    (function (e) {
      var t = "object" == typeof e && e && e.Object === Object && e;
      n.exports = t;
    }).call(this, t(75));
  }, function (n, e, t) {
    var r = t(8),
      o = t(15),
      a = NaN,
      i = /^\s+|\s+$/g,
      u = /^[-+]0x[0-9a-f]+$/i,
      c = /^0b[01]+$/i,
      s = /^0o[0-7]+$/i,
      p = parseInt;
    n.exports = function (n) {
      if ("number" == typeof n) return n;
      if (o(n)) return a;
      if (r(n)) {
        var e = "function" == typeof n.valueOf ? n.valueOf() : n;
        n = r(e) ? e + "" : e;
      }
      if ("string" != typeof n) return 0 === n ? n : +n;
      n = n.replace(i, "");
      var t = c.test(n);
      return t || s.test(n) ? p(n.slice(2), t ? 2 : 8) : u.test(n) ? a : +n;
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      var r = -1,
        o = n.length;
      e < 0 && (e = -e > o ? 0 : o + e), (t = t > o ? o : t) < 0 && (t += o), o = e > t ? 0 : t - e >>> 0, e >>>= 0;
      for (var a = Array(o); ++r < o;) a[r] = n[r + e];
      return a;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r) {
      for (var o = n.length, a = t + (r ? 1 : -1); r ? a-- : ++a < o;) if (e(n[a], a, n)) return a;
      return -1;
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(8),
      a = "[object AsyncFunction]",
      i = "[object Function]",
      u = "[object GeneratorFunction]",
      c = "[object Proxy]";
    n.exports = function (n) {
      if (!o(n)) return !1;
      var e = r(n);
      return e == i || e == u || e == a || e == c;
    };
  }, function (n, e) {
    var t = Function.prototype.toString;
    n.exports = function (n) {
      if (null != n) {
        try {
          return t.call(n);
        } catch (n) {}
        try {
          return n + "";
        } catch (n) {}
      }
      return "";
    };
  }, function (n, e, t) {
    var r = t(17),
      o = t(113),
      a = t(114),
      i = t(115),
      u = t(116),
      c = t(117);
    function s(n) {
      var e = this.__data__ = new r(n);
      this.size = e.size;
    }
    s.prototype.clear = o, s.prototype["delete"] = a, s.prototype.get = i, s.prototype.has = u, s.prototype.set = c, n.exports = s;
  }, function (n, e, t) {
    var r = t(118),
      o = t(7);
    n.exports = function n(e, t, a, i, u) {
      return e === t || (null == e || null == t || !o(e) && !o(t) ? e != e && t != t : r(e, t, a, i, n, u));
    };
  }, function (n, e, t) {
    var r = t(119),
      o = t(49),
      a = t(122),
      i = 1,
      u = 2;
    n.exports = function (n, e, t, c, s, p) {
      var f = t & i,
        l = n.length,
        g = e.length;
      if (l != g && !(f && g > l)) return !1;
      var d = p.get(n);
      if (d && p.get(e)) return d == e;
      var b = -1,
        x = !0,
        A = t & u ? new r() : void 0;
      for (p.set(n, e), p.set(e, n); ++b < l;) {
        var v = n[b],
          h = e[b];
        if (c) var m = f ? c(h, v, b, e, n, p) : c(v, h, b, n, e, p);
        if (void 0 !== m) {
          if (m) continue;
          x = !1;
          break;
        }
        if (A) {
          if (!o(e, function (n, e) {
            if (!a(A, e) && (v === n || s(v, n, t, c, p))) return A.push(e);
          })) {
            x = !1;
            break;
          }
        } else if (v !== h && !s(v, h, t, c, p)) {
          x = !1;
          break;
        }
      }
      return p["delete"](n), p["delete"](e), x;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length; ++t < r;) if (e(n[t], t, n)) return !0;
      return !1;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = null == n ? 0 : n.length, o = 0, a = []; ++t < r;) {
        var i = n[t];
        e(i, t, n) && (a[o++] = i);
      }
      return a;
    };
  }, function (n, e, t) {
    var r = t(135),
      o = t(7),
      a = Object.prototype,
      i = a.hasOwnProperty,
      u = a.propertyIsEnumerable,
      c = r(function () {
        return arguments;
      }()) ? r : function (n) {
        return o(n) && i.call(n, "callee") && !u.call(n, "callee");
      };
    n.exports = c;
  }, function (n, e, t) {
    (function (n) {
      var r = t(3),
        o = t(136),
        a = e && !e.nodeType && e,
        i = a && "object" == typeof n && n && !n.nodeType && n,
        u = i && i.exports === a ? r.Buffer : void 0,
        c = (u ? u.isBuffer : void 0) || o;
      n.exports = c;
    }).call(this, t(53)(n));
  }, function (n, e) {
    n.exports = function (n) {
      return n.webpackPolyfill || (n.deprecate = function () {}, n.paths = [], n.children || (n.children = []), Object.defineProperty(n, "loaded", {
        enumerable: !0,
        get: function get() {
          return n.l;
        }
      }), Object.defineProperty(n, "id", {
        enumerable: !0,
        get: function get() {
          return n.i;
        }
      }), n.webpackPolyfill = 1), n;
    };
  }, function (n, e, t) {
    var r = t(137),
      o = t(138),
      a = t(139),
      i = a && a.isTypedArray,
      u = i ? o(i) : r;
    n.exports = u;
  }, function (n, e, t) {
    var r = t(8);
    n.exports = function (n) {
      return n == n && !r(n);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return function (t) {
        return null != t && t[n] === e && (void 0 !== e || n in Object(t));
      };
    };
  }, function (n, e, t) {
    var r = t(58),
      o = t(20);
    n.exports = function (n, e) {
      for (var t = 0, a = (e = r(e, n)).length; null != n && t < a;) n = n[o(e[t++])];
      return t && t == a ? n : void 0;
    };
  }, function (n, e, t) {
    var r = t(2),
      o = t(35),
      a = t(152),
      i = t(28);
    n.exports = function (n, e) {
      return r(n) ? n : o(n, e) ? [n] : a(i(n));
    };
  }, function (n, e) {
    n.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAACmCAMAAAACnqETAAACqVBMVEUAAADhHBsCLYH2xQIGJZ4mQoUMlT74+fn0NzbmAAD4W1no6usBAQH6c3L7AQL6SEj0GxrgMzFWuVdDsEIvpi7QAQEAKQDhXFf19S/BAAH20i76+UM1MzJ5xngAUwMAAn8BfQH46+na3dsAQAH55XNKSEQCZwPR0tIYmxcAA5j620kAA2ICjgGxwOOxAADhbm1Ma630lJPmgH354F73h4T6+lYBATlOls9rhd1LU6/Dx8ZOadYAACE0XNNylc02VqbhTj9efbQ3UpMBBMP3paTTSEqfAgIAAU5Yqdb3uLdMYZZdolvBzejT2u1esfpXftBxtvs8izZeZbwABa323dyMqs3y8hiHovh9keJgdNwCBut5qN/KOjoFKubx7E6HvftVovcdHBxnwGrktwOksNpukvc4cPP42AMEYfZWgPX8/HHn1NADRuturWv4y8qRn9+Wv9zxr0HJJiN01fhjYl91eMf1jErYwzmNlMFxcXA0N6dSVljs2FYIgPyBfHpzjrj5641Ggb7m2D70fDT9/QRsvdxQkk23trNAlPV5rYYmeyL5vmw2rPYJleoJT55DoUqr1a2FAgEwPMz1YD3hwMIszS1S0PDA6MIucbCiop72x0Nwc6MGvwfh4gFAP/hS2lHIXmAIJMCT1vvo14PAqz6jNS4bcj6yS008dsoHP75anHnbqavFdHWqXnGcdKFNTdhx5W8/g12o2Ef3cg4FvvuTzpPv5qUJIHCgvfvfzWL3omGRjop+djqUxiQJYLnplgKPvaSnZEp8T0fsSwZvNi9hCgWfNFOXmFLFgpn188oHib++yQzFvml9HEahhytta/rHo3vK4U83AQCMU4uwnWNwLm++4YaK7ofBdi0gxcvQnQ6x3fsd1VZfsSEF4wKdtXl4v0UCmZkJ7X689IfrAAAAB3RSTlMA/v3+/v75XeW/GAAASqVJREFUeNp8nItfFNcVgEGxs7uzCyyIC8jDRR4C4rLLKgYVeYqLbIy6GBRCVFYUV3lY5FEJoGjIo/ERaRAwDVatWpC2PqOgiY9ETKLRxlhrfkls/5Kec+6dx460n4k/Z4edueebO3PPnLlDgJYNwJIDhB4JRuYAycnJcUDMZiCY+Ao/+4fRn7W3bl24cGvfaFBQajyQHgHo4Q8SFRW1IBQJRvTEbjVnzpz5hPg956OP3tqokHo0KipYhR4YHQt6+HDaj6Px6enppSWLFn0jcQs5dEu7XPixe+/0mulEzbp1614VkAF0d+8ATCaDQR9sAmJjt2zZEobM3TwwMD5udzqdJtNj+CxuQWdnZ3t753fftTc3792bdPS45yeXK6O+sRJYuXJleoQdcHY6HO0Om81mWRBqJ5yACdDvdhImxGAwnPnkJ86fiI82fg68CTSM2O1F9ePYHsKAhOgL+sSRkT6Pt6srv6zMm7/om0ZHI+MgcuibgwrQnkOFFWVib2JiYhayZMlUArxe744diYkLF4aE6EAA7iksLByYOXNmOAiAiNn+b4eHh8XpRyHw608HW0+3xsTEnF0wXGR3IrnZK8EACnCYOm3DzXvPWu7k5aEApyoCFED/bIls0enydIYzv8fIid8CKOB7ZGzU5nD5Hj++E8wjh8YBIXrYvs0CaocyS/O9BZmLvgHPLFoEBPyWFoh//QsFbGgQB9KA6OjoZf9DQMOOx8Bs2AUXIMgkbB6HI24y1dc7Q26Hzwybq3fc3rt3YjAtbXAiJuaeOeq1FJfd7ioayM4WrFYhuwQFjGLfSEo6m2e2LAi2y/FzAfTPyMFIiB8ElAmCqKIRBeyZtDmKrMLI7TuPB3RFvPsQTv3XfUUOR5FjMrO8dHmBN3/pN40YP485e+WhKLsDlADDw5biYtsKELChAg1EAx8vSQ3QsiTD2wACTB2PZ6PiCBQQIsikgID2dlO901Qfcht7hN5pqqz8rhL4LjsbAjxv9Y7Y/+TKz86+mih0gwAI+PYdiD8m6Z4Z1qc27AHWIq+99tra9N1OFBFt0EXD3sy6M6KAPEhMvMr2t9E7CQF64J8jT5+eeTwuCipEQezytU1OevsGyjMyCtoyMkCAcvyzSQDG3+exuxzFxcXDJGBJhTgeTQKWTSWgoaFh4eMOw+NInS6UBISoBRjH29ubDfUuV70OBcwCAcO5sCtgXxUEmFm+b2zyeHYbCBCyroIApw0EDCfFnL13hgS0KfErApqij4EAs1l3jwWYWJ2WyPb3O7ujSEBOCQ/E248H1AJEEPBjW/7YWGbXWKk3s6C0rRQEKPGDgGlRdojf4bHVe0aYgMUblixBA/9XwPXHho6nrTpzIAoI0Qpobja46uuLQMA8EOCwGC6wC97XGGAQ/IvpwHaAADhFLZY7STH3qqrM5jwUoMT/u7XpMUlw6Tg9cXr/RAyymQV4NStL6gENkw6box4/O/XgsU8tQAQBCeld+ZmZmaXLlxcUFJQXoAAlfhJA196+eofLVlxchQIg/mXLFrvRwPkpBCyDM6Bi4eOnT59GmgO5AJ1aQCdc9EJMDodBd3vevJkowGKgY2Q3Q4AoIJsJ2Ldy5bnsRRGw3pJUHBNTFWM2785b8cWpD4km4sO7m1HARGvrxH4moEwQFdxwDXjz++/XXrBYHD7hesdgN1wDlCsAXkPSuzK9ZaWlGP+MGTNKl26D63t1NV7jkLQaFGCh8x/irxo+CgIgfjTQGT395NQCKipmR353OnJ9YGCgOSrYANdCbBlgNMYYQcDeJLoCh56ZN3/mLAgQgCNUv1sWQOHvO3fu3HEuIC/v3j0zxK8IaFIJ4EyQgN/j5Z94443XX//tRyDgj8BrZ815Dp/vwQC2BwkldCjALZYXYPyl5TMKlt5qlI8/9YA5sTB4Hz58+DfE4bkgAOP/+OMN7s4pBXzsxWtANRAJJyUKAJKAGAQEtOM1wGDQ6fAaAAJMJlBss1opThRQWak0AAXgeiQPMK/44kOFG01NdzfHKHABBPOAArZ+T/x1bNhic4EAIATQEfqSrvzysvxMoDRDbCswbpPG+Oo0pCZ5CxKGFpBZhZjosbNAHF/28RQCzp8MWvcp8i2lbpRuGTXo9ZjaGWcBUoYnQekfUFJSsgiBdWz1CsYXl4i7Eps1YPqnZqOKVOPRFdgeNWw3SxHjDGga5XtAEGcOS2DnArOQwnWM1NTUdbnwd0A8sm3bdICaPZeYxTBy1m/btu3Aetq3NhUVOCJHAIpU6z2eiIjAQLBEolyu+cicOQeQ9cDoD+kPH6Y/HAZFZGkbh+WqNTXa/SUjcQhr5p//JfNvZDohfXv63ct+fPSRYPD4bS8gPhdg3SY/Pz+zZO7777+/C1kFvPuu0Yip7g5kIaWe2lRU8CdBQKyU3tH6mXB1cNghG4Hx2CUIc+bEErg95NNrfQmQyvra2GlSvAKu9t2JjCygJthOSPmyPjmWePaMNXGWseu3xCeMf09PZHR3w7fTWvSXNadUsODXfhQAcWelIcuXL89cNPd92Ox9S0hI3sSaNR+AALzqL1w4G6DUU5OKTimg3kQ/QOvnX4FOYbN5PDaLVegPi5sfG4bg9iIjI2d/uhsTFYcDxihzlXk3CCASszroQl4NApyq3BkFYOCgbvbhw2vWHJ5l7Gw/yIOHToACMHDMIsSO68dQAAXOHf32I8FlVbWfC1ibhuNQtCzgPrvITHzwwRq66u+l+DExkgTQelpOEEQ1R1gPwOSBrZ93ZcsVOkPgr9jw2GRFQCQJeEip7ORYsdlqtXqKV4xzkXaIH4exSzhq3GC0tNwIBAGrLi5cXFu7IfImCsADdDpNHva+QAG4KALPe1q0ByglWFC3nwvITJsAQMAhELBr1bvDbH0VCWiHPJ4dLx0OO8Hs6DY16XS0TMMMv1WCxGgu9QDaAa0HAXArKQg+nyDAvVOs3AMo/vWzPx3qg1S2fGSsyuw5eNBTtcLY3pwD3cjhAGMPOjpeTO+mU6Gjo2M/0PEiOTZs4cJet5hROxQZueYwtQ8NRDNAAMbfcf2q+3FK36UWPbUfiKGhPMloLbLyQYTaRwIyM9NOT0w8il5+6NByEPDuu7Ca1jMB8H12vGjcZeP6/sjI/WZIlPIWgAAlfhSAWA30fUlAWD9+1h8eFrYljn4+LFwnNSBw8ofh4R8v2EBAzLin6ijtz+FIER0OARCnd2P4FD8JiPsVen9d7dbPf6qMXL/+JWtfUmu0IiANcLsToAdcutSDApT4N8cYoQeESPExAV2ZICAaOkD0IRCwdBYIKGbrd3+QjALg65EY//pQdsQp3v37IV7MBPnyTASWeQ/QqQVsCRPsPp9DmBketiWZ/zyupvULbBY4/fH8h5M7turotsTvYIe2mBhbTgoJSFSOPwmIhd7TVltb+/nA+vUzeftO8/CncwFX3T5fgq+FCZDjRwHYA+T4FQHR/gIm2Po7ybIAhAREzdkiH28SMPdXHCzWENhjaBz0GOQdzL8SdkXgbJkJAuD7JIBnclHs8meGelBsbBQKgES29bTNhg1OGki4+ewJchH59ubFn+N2HT58MfL72trv199kPTRprxw/E3A1ISWhr8eekHIXBIiaa4BOMLD28wMYkA5nwPJoArIHELAKopkww/GH+JM/MBqbwR/FzwQkb1Hix1RYm5qK2APoAsAFxEL/t1h8PkuxIBwJj+MCcDXvASx+ABKF3SggrToSDvZplnqf+NtnwB8YJ/4wHwUcnhlZXb3+AwAENO/91yeqXKAmK9HXdyyh5RLRQ6PAJxK//+Qjq0mU288F4ChAF5HlAAiAIwqwQ4oCYBSo5qOADgSEAUqvn6VNTXkP4B+AAPBhc1DVpnhEEOLg+whfDQIsCN6pALt3H51O4391R0d19f7W0yjgb6SAa5gzl2UoFy/CKAgYjX+hUVAWMD0LBouWIvi/BwAB8iBIYB6A7ecBoACkpuYLgDJKSv+0fEpAShuxQs4sZzE0qSkJcKqW+308CT6K9F5hqelceb2cJB9lUAZHvMC/Hp04cWL+vPkEpZDSjo2cWf/GDFDhi2B9qF4Fpn9qrPp+v9Q4gCeFMnD2mgWGiMXcy5f/c1nm26iot3Z+u3Pnzrf0+reIwhMy0dOBu8EKAQjl/oKIYCwnRn+49vDhtR8vLOUZ/C1CSagpTpZwU6ocgdylRJqokfkCeRFPKHcg+kPnpRuBVKxLb5fYCUCDZ6RfmzFNYUbAW28iFVAE2Lp48YYN63RFRXYctKzwl81kirjcH9nPO9GzyGOhC3Ze3dENZVqTib63tRC7KPFkIdCkSpWZgEsfAgLxGTB/Bkt9vUNdQ4jxVqVYWdkoSIiUKtP3TZQqRzgSHTcSP4Q7SmJBjZwnU8b3IrWckwt0dZUEO8srGblI/Pa3iTcAuL3e9Fa60FUyTQUI2Ao09vc31sHYUlcIRUccgGkUzjPYoi5HHjjw7BPg2YHQYL1uwc7PEzHwkBD4Vl0dCviMeIKpQhPLFOGrISEGvVYAnMKfzQ/kqW8pIBSUGm9B11hZqQigRIldVShTjEhcmGW5MdiSZ0byQAAGjlDm90LwR9SbDPXq5e1vQ+AQOfDee+9t2nitfHn6qwL6RaBfEmAS6n0GS1+fYNZZoi7vOLCDhw/0fCsKhFQmy+ECLlL8oVMLaFIJ+JqnvhB+aUGBYLzVKDZmr9QKoGsoE+DIumFpGmwxI4FmEsDjJwFFnnrCxbCBAIPLX8DrjY07GsshfhQwY9E1ITPdX0BdZb+1t9fXnwsGQIDThH3fZjELZjMI6P8E/rDwLx149o0kQCcQvSSAx89SZYGhCBiUBADzeeoLAqiIY7z1xkqAt1YRMDiIAtajAIuhRYqfBPD4GS8wYJZ30foovdNlMFzIhVrMaqhKZcMp8Hpjd+WmysRyJmDatWle+F8toK6uURR6BwTxy9rtIMAOAuy4UZuIRc7Lv1WFv/LgN4f7jwBXdLorQOyVZBLA459SAMTPBdA4/mPb0NgPpUNjMwQs4pXmnK+EtpIAK+KjVFk3GB3dpIPUI/LTCBOc+Tx+CJDK2quxokMsSUUBujz4w9Yv0NcLrhDdhXPHgVu3jqfjhgUFEQoh6akqAt6CM7n8gdDbJvaXb99ZW2i2Ow2C1WawWEQxEAWowl8JApKlVJZnUiiAx+8vIEQS0CQLOAECSrqGShFexDQGm+TUXEm1dWBAp1tPAmxQS2Px7w6MIAFU0eKAAOX4kwAnxr86ezUVJVfH6003ErGLtGT1YNk9YpoGElDXnyAm5PTX7gQBgXaTBUSNjIhMwIFjcvgkII6lwiBgHhcgx88F0OVBp3tVwAkmQIpfAAECCuDxcwG4fbbMBUjxY13JzMvajPNQ1nbys7+IUaw3heiKtAUa1fIBDQEbQUBt3REA4gcBervJIFW4AgOLV0Qo4ZOAn1lqrgv9Frn4wYm/UfzRUmqLqTEKCP0fAhZ1KcdfmFFglFNpjYBQSYBFOf4oIMKkA/ADQG9eoA1Qb5DiF5GEnW9sKk+sfG9l9Zfv1da+897GvRpAAA5niysWb6hFs+v0UICRvm0uBgE6CP+gzDffLkRmh4RA1MC3Jy7i8qCc2gbLBaNXRwFgzqIhBCWQB6M2lU4OU0YB4NMoXlE2M1boDYiOgOUF8SwBAPKRpcEGXKZrIJK+8w0cBRLLYRRANqZqCNATEZDlMvDfKSk5xAog6vmWb9TAYf8U0OuhbIz8YTqil1GSSiaAKsAJQEoKprLzKf0zKmhT6TnJQIQeYfk3wAumBDYWkarNlP6pSsMRGJUqN4T0D9goQ2mgOhNUuguRcKvB/5MkJEbhp011SC0BGaYeEax6CZ6ybzMKrHwbxICfYIL/TCT/me8uIVpTBj7POXnyJFWvNX4ior5Kxh0AyYS2ahynZPqECJw8ed4tuokcXoUe3f7OdiJAew7danT7LSf1EgPI+Ph4jCC4P1d4e6feBAgCpK5ExPxYortdoMcRcUENBAyLRNSfv2RI29/WLZMI1Jyv5LCHK3CVJ+Tt601Ox9NfccZGGBKnrVLHvc/4C4PqE7A1uR7Aq9DlPD3eOYWAyjJ/AVgXp+kf0BNQgCB+/vbn8P03ARRA8wf4WKQDAdi0py0W0yMYLFBALoLjAg5DIIDaN+6zYicjAUp23wECKHLkHIAC5JOehjFYhk+G77P72fA4bZV6rhT63wkSsHjxYlmAVIV+HdkkCXhg7cZH8lyA2kDCvd7xTlRwB7h3DwQgn2P4BBOARUDMRUgAxf/y92E9j2bCBAomYA8KMMsCxm02u0cEhJRt6vhJgBw/CeATIhwfmhBHhN75YcfgYFNI3u2JNTg/4QA8X6jumC1XmZOv7AIOAu8Cq2ZpBJRJVehNrw8PNxWPMgEPstIGB9O6pR6gNpBQ5eL9ixQ7zwiCS8DTwF+AwHMRXQQF1HKx+rPfv+xJi86qQQF79qAASlWZgFHbX3wOPwFZ7BYnq0ZbxRUY3YnSzU5iy41Bw+Ax3N+ZicMooLrFckquMqOQhY0Hnx05WE7L5xsWA6sRTIxSS/vGJifbRlAAjM8oAMmKjs7qZl2EBKyctBNOe0RVEYbP4w81nYGnHjjO9rOH8AenCf6I9BzB0rPys2PH8mIgAO16FPAX2/BfYGgTBBAwo7ytrYvIB7pKtFVcHv8p6p8kwAD3CYM92J9CQ4uNELDL4HPtZ1W7SBIwu/HZkS+fHaTlk5U8/nPAstXxXeWr29pWV3o3bXILxaL7LSbgyNUH/UdUAi5IuaUuCgTIp5g50MR7wJHPpBqdNkABMd3sif7552O4zFNVQVibmYkzQpK/hPNz2AI9QCABQZXZ0Dp8mo7p+750bRVXIBJPnZIF3IAzIPoYVC3NX/+wpxACftBisKZh/FzA7NmNByH+g+u5ACV+EPAOXvvo/vgCVOFGJQFXjsReYQLON1bmyvHrzVHPr9JzGV5j+/AMteJvFD5ldnoThmeVcvEoupl51HOz5+e7j+bhDBITXR2sAsa/fG16HF6k2i0WW72VbqeDKuX4SQAZVMiJGRjHi9D16+14Je406m8MNg02QQc4+8MSuH0HAbOPDDb1YvwUcLDpGFB58GCuDp49H9PjmAZ7kLf3jlwfcItV2ANEJhae4HEBDRi/mcUPAk5fZRUIqNPC3WfiI+z+/PAzAQYugP883cyAgbxjED8KMKBNEIDxL19bAgLwCt3sslIPyMG7PUrzqDJsXqEVQFVp1QQN2F5Pj64Yo69dsmxDoTaV5svFxaoqNRx/lQC5PvJ21dubSACHC6icVKWaIEA1SIOKR4L4T16hJeboDXwU4D+fzAborCQhHIAJFGwUswr5+TAxiJ4+/wWRGqQ3EDpOxKsCmvlVEUEBhtGxiq1b4czeABRqU2ntsmYUyNnOq2PMAgpAEpAU4vxXlGvK6eYjfyb+eWKeuko7n9Iz0Sd/gT+9rzGKLBfjn/vcfNZEHC/p5qSwhFsP8C8TUlNyOEYNCx6mFm4sVNCm0tplNwDJcUYOo5fqo8RbRIBtLOjrr+MfjvKUumQfcRyhmRYCsFG/UZTIRZitUMrdJfjEhbay3NX5+e4LF9zwwCX/Qi7dTF/C/+5eorI5Q6/n2rXb06a2ogJ9Q5u6ozT1/UIwsv4A8Cm15xcNH80HlAYnB8zoE11YpcXZEcCifRlEWVkjQQK2OrbKeUFuGSAQmKFAAQNR5hJ7iwTR6xXsTqG8vAz+Cv5VVcUdvA9d0oqnv9MJlRqY/5ii3Z42tRWnnIBhlZejHIAN4BMs6PtsQge155d/KkDt+pd3Gv3aGxcQajcRpcuzgdKl+zIocEEoJ0hAnaVOLSAjQyTgWyggDFDmEueXFbmECgGKCrlFTsEbFBwb+0QqY7b+HAYBuRwuvHeA8dRSBAI029OmtlyAk4ecQqZgpkS9LEB+tEQTLOj7NKEjktrjEfwYeedP/u0N+NpVZHIWOSdLC1aWlWUvlwRkNJaXV5bnlge9KiBDaTDM2JivFeCt8Dnx1kcwWd3L9wQFw/qLNN1j/01YjwFB21EQZRQp2u1pJ2CQAA986JEF2Gk9M5CgvWgyAbNlAcHSbJ1jiEH/zp/+RMnvA4EQA4bqca6ta2x5QXbXl8cLSAD0fzj4GRm5ueXTsGJUZ6gFqAi5Tt1gOBARkHigbzkVdQuENL/YHRz7JAwUHDt2EwUd1ptcRVi+MhjsRODU26u+f59vjwL0GS4YfJIAPsHBxJa3s6R8K4DPKTbSBA7Wnpk4kzX4w8QWE4RP6I6BgLcF4EqsJODHtsyxsdfyxwoKVmYM7GMC4J4BTmBBQAEwExT04RQ/ACZEYIO9gogYeIMpfikVveCUjiAS8jA4tqMlPPz54OBzrKIe1kNmyOB3d1Nv735S0iPaHhNg0sHmWMAG0AfwmVP2wJ0Uu1SjqAMBsHPWHtgfCOjekSUdfx0TgAZyeiUB6V2QotFE0+zxzsyCpcepB5TLPaBwK2w4r3YZsnPnsnWryzK8mgbL8WODeQ9g7QWTwbEvX4aH34QeAO0BAQYXtd5gcAIOe8T/2N5EEm2PC6jPqzL3SV3cJBAuluhADyAFJIF6QAgKwOZg0RZ7wIfS8ScBFL+Yk5MgCcjPhKfiEP/4eH5+e6cRBGD0jY25AAjABtTmLZMTpdX4QoVIQMewRByimhwOffn79mXmp79WvtZtNZAAXW9Q5rXg2PDwlzSDpfXnefPW6EV2M0GPj+wQkHZ72gkYooB4mjyiJCDExU4yJkAzeboXBUA1URFg4sc/RMcF0DVATOCTrUHAcj7RGOseBcbjFD8UMKjW+KqAfaoGwxsgUScr5ZtNqsMv98IQtxoF/E6wW3LTg3e9fBLN2PbtzJnQ4CJbETQfBDmKHUKOdnvaCRg0SsF8+mN02hgw1UUDHhNPdaecsMH6Iy37tKPA2zBksMwbqFoRUELjP803Rw8gAIH+X04iSECdZYlKQIbcYIsFBVRWoCuwgMSXC86yPXvw2eHa1zIEw1Dw/Q4aBZmDNZDqeuweNgp4HPUgQLO9VydgIDeapAkXtAxKpFR3yp9nEzpo+Rcc/onPkF+2e3nOAB6AFQGQAFJBlRdrl0L6R0zjiEBhVCHmagSeMIdyqEpI2StVLol4IvfrTKiBuh8+dF+7dm1a4wxM5+7exf8C7+oBnupGROQwtNvj8y+0EzAi/leqS+me9ue30VxnWv6FcUJiZ4ScNBIB58+npGARFliHbEdYlknZcrACawDC5+IiMYfnzVenwnoFSvKDSI4iSJvqnmQUArT/CIac3uol+OeUybL2wSmgDxVlmNnpCjSHwjGWCqn+jzOwSj4Lbke0+w84D717yRIl1dyO5VKBwNuljcFvSmxF9KpUE6mJmMwRxStKaqmt4qZWEFJdKp2+r/yE/mQDg//Uugg5tSXgWR8Cn8EX4LMoSr0FAqsU+p1UnJbbWDjdfwLFF6UewdPnsXoz3Dm/HvmyzKtNtfntcBmCtwB78Hn6JoGgx8nBLPDJyToEBVCqKc31rQk2DT/d8eBB/xaeCfJx3mln4zwIwLj587yPl4AAXF15sPIg5QkggOuhefyLU9kLGFKNoBgEmAD4wGDJw4skZZ4CYoUCTcsr0+Cm+0+g+IKG3aKiMbgXh+lVu0q0qTYXIB2EhiB4nj6FgNFfU0Yx1ajjAuQq7AtYttx+snDHg4TYcEkApE5Wl0FnRgFt7jJGBrGcvg+JbEg9prokQIl/yQYUoDwKgwIJCFDiN/9PAW++yVPh6KvdwKnegVPYDRJrLng8rqL6+jZvGcb/q1f72h2dAstolGM1OhCwSRZQ+x4XYPu11wbxk4BmS4iS+r6g1PPsBFx3r0I3CGM9oB5eqrLW00tXIvmlv0RsoEBg/GyPIECKnwS8MuUFhcipaN4CPwGXuIDPt0LvJwV8+97ysnL2/Tafd2Qko28PvKW16vaqtSVY0cL/8a8rsJ4JUIAesEkSUFsrCaiz+VIsED8K6Ny7NwRmbd5kzKfUM+TORCTyQJyDAnRF1qKiepMZi6oiE4vZnqqBunpdPWvguoaKPcRaZE+8VgDcOxB2xGHfTTVHkQm4JM8E3SqIdertl2e0cQGTbtHXW+bGHuC93barjQqg/QlXrvT34zx28ZWS2PY3oFqmEVBXZ/t+zAKL1AP2FoewQZdnWhj/IyhLyz0A+jZ0Og/ELwmooL/UPQAMMDV89rk8t1grQLuMNUcu4JIsAA7/1jp1Dyhry81gPx/fJr+lZxmsWrsIS8CiCD1AFFkPaHCXcTLoIrhTFiByAZhkDw+1XoDFP6IAaC2PnwsovnN69sIH/bHhuExVYIOn3u7RUZWYrgEZDK83o+BWIz77ytfpMrOzpUdfvABJr+nRVFg2S/WDOXPWGLWP7jBVVgvQXgPmxPK3XQ7jdlbNWuvOyHDDGFCe4T1V3JHRhlVm9qwLgCpzAN6MIA2ENwgEvOcvoA4ZttQidazq6pd6nr1TDaNAOF/WG+gdYF2ggVWJUxcvobfUzhMfl9yiZ38Ef/YnT/GhHjN3lxK/RoA4tQA/epNjVfGDgPg2Ov7AcnjD+7VF2ipzgJs2LePd+YZyEQSwBxB1BAoAVKlnxOg4HPwweVkzgSEqfjEfBs8tA14r4U9/uQUSoPpGXtRcufXIqz2AUl9+DQD0NNFTaWIhvVNE7zwh1APKRG+Z21vmzbgNlwZtlTlgHaHkapj+bUyhuuxGRD9V1XUuwefszvdLRpWcjcGnKiAlyHmA5rFy9IC6DK2ZCowC/HI9mmvci1XjXj3Cy9k5CGbU2lRa2fciwqghYL6mShoECHohSJpkQavZzlmaXTNPKQPPeVGzwuiP9jU6owat0ELGOgYIIRQhP3+6zQ9Ve+ffhO3VAu+8o0wHFiSk/avCQzmjYzBXOf3HpXxKiTFAU9WNC4J7QMEh5BJd+emq1JNSx68SE59JP38xq8MY7LjQ2Y40U996pcvia3fq9ZpUWV9YASi5UKqeJb6nEiH9obvD2Gc7GAuRbUp7n+BLvMafRD8+x33yoaA3hx7W+letYa5yH1TBYZ5S/tBIaakxABILgk84AAEwm8EgYHmDChws8SAodTSOX8/qeBkWTmWO081GGMaGITJ+UkkC4Jm6SxKAgafcuZOTROv5Od/TwydUrKugyPnkvyXxeif8gPymLQrYdXGHrGDHNqkI+/JJUkJSTPNzvZ3bZPWCCIh5vDNB8HiEhOb2BNr/KnXRtmrE7gBgglYplD9AAAyI/Qn9CUf62Z/DkgAMP/O4RgCkrrDBp2lpF6HKFR39CAIKxvYWaer2RTiy22k5RUB8DodPRAZYqtyUltbE7hVYWbvYYsGqNpS19U6M33D9OuV+eVFxsaIYm+A3lxi5OJE0Lna2DuqhR9VbPU6eSehAQMJ4rwDLJqG3OYcE7D3S399/hBH+Yx/+hosREFD1+HEVCBAYLpc68TBodsgFYKKCExgmWtNa4fAnbd6MAuyGEINsgOK1stkEHhTAjvgdi+4emyFCyy2DTS2Dx2hCRRTe9jksHk+xDQRUgQCKv6OjiaW+caIQ1n/4in974PBDb+qMvqsDAfVFkHTg/mh7FIML92/HslcCtlddNhvy4VzlPpih1zc6PFIgCbAXuezydHNVZmJmr8UJBGVq8mtqrfw1NLtgh905FQH0zhDiwmWW6CQV58WwGSK03DLY0xPdA8tcALzKZbV7qkDAUQdM/TR4rNXVPsgWfYazcWL/KvHw4V0ej8cHjGB7nrRi/KdhciYK8NRDHzBQ/CgA6dXp1i6ZpPZge9UCoAoO0xTzZxTMaO/qaiYBhNOp7gE6TerpJyApqfl0NPaAGBJgckJ/t/v3ACbAg8tMaJLZfI+lxpQq9wy2tDRdCuQCii2CVYD/SMCQ2OD2NFSI4urVvtVLfNfiRBF6wARmSvw9xZdPxjH+1p5QJqDeWe/0sPilHpCxdu25ZV7sASnY3gSVgJIhaaJqGQACnFaXxwV3b0X0x+VIhTdJQQCc/8fxVdoSyLy0Au4PRsNDHrgGTJAAeM3YLigCEDtNp6Fl+kD02Wwp0jUA3TTBK440uxsEFBdbmQDPbnhtrq3BnbHY7V69usy7uqxscWncLjHh3edwQdBxAU9ax8XxpKRoNrmargEe6ACwGBiqRwEpnQNC5blzi8WBvb1MwIhqLvGifB7/08fNzU8fGwMwAPUEA3iTdJ9gFij+qQWcTtv/ElPhn2umP0rCub63lbpsOC9j45MfJgS+j0xMUO5MqTLmyseOmeVUGYBkGfjd715LDxIrwICs4FrcrrBdbQpDNzuT9ibQ4ecC1Kcs3XwldLanCO4yIWVvew4IaE6qwpWhfAIHCMD4gfanT/EU0EwoAAHyMEhPiyn1FAha/4+OrCd8VIGBoNUYbLnPxiWC6vhqUmDChLJ6ilR5HQ3/JAGJz2woa2jIyKjIdWfkZnj3lMTtyqVMF27S64CNxmZgsEVuL88D3JxKEZ/6sBvNgV4BBVjU+4uAucqZbJoyeQABen/iATFKxNyR0kdKPVmmSeun18xRks24518cjfNPPrUTLpKT/ddrMr0IKQ+PlyiNLyiITx8qTU8vvVZSOi3uPKTmKiD5++quXmG7arIDrH5LVSAljMr+CKp+qwi4XOP/Gxa0VWBtVbaOUSsRBKjvJagWSQwi0emIqs4bpGEboirk6kIZUgOOynxFBGrQVnm1y4XINiIKCdByufuq329Y0FZNMTVVfRBVx+YI//TTmzRbdllQZXnvqV56PkYPRrJ27boBr7mNXkCGT79I9wreNkHG94qA7m6/3xgRKj/5pB3rj44yhoGzZ8/+I1iDtr3aZUq14XejATasMr8q4CoFDlML2W9YeDg5OTkG/ECM/UPv5NuiixcKwMDfcLu34qmJAk5By6+zR2PHUcCqGzeyRlHA2bO3zz7Hl3aG5DK3bUEqAzsNATNFsxBWxwUBfr9sDQVg5MgZ4Ow/5BkxUQxtlVe7XIip9sKFT59WV0NqOaWAZ/RSZFrHERJwkqaWVrjdcHXGqaV8Gt377/OHk3U0T/in8c4/beUCBqD5Axg/zfPLWrXqRkvWhQtNo02nn5/9+jn0gPIhVQ/wZhBdXbxI9O2pDmI/0Nq6/xGvAfJuUBQIAs7y+EmAkSPdMGsnVGiWUcCGDVkdrU/3V+eZpxTQTT2gIzr6ukoAxryaZlayuI+swmyUC4AChJgU8xMTsK5itTwR8/itc/Fpq1a1oIDB6MGzL55//bwE3xCVn8ZZVgiMgQGBof0NFJpRRPRZPQwfMWIkNg9sVgmAaJ8/57+QgZYBHVsGATDKVD+15N2PNE8t4BT2gCPPovdf+RLfrqanvVTEXLxMFpCANZoULgBnyZfFxGS8DjWYrcvS28bGhoAffigFhoxpq95FAWejn8NzCRBgFfzwCYyYGEWAEj/lEX4kvDIXmchpNgqdXADGa3n+vAriRQF29SXAQAKWVN9vanoUTfcWU18DGv/b3Lm/RVGFcZxIG5bZVcSIm0qLIAGh3GMJI27aAluBUKhENysThTAXVkQgKQk1W5QeQ7KwxaxEfbRHbAUKVCRqM/BSPnbB+kt63/ecueyB6rfqaxdwZmfn/cyZOe+85z3vcb81MvKWhwBUYAwLvwo75ocZAAhSlby7m7xsAvBzT19f4cc4UrQSHBHKPeDEgwhA0/ErVNTg2JVbQclqBhdUSlBaQLvR2K4AUO0nR0kEoLSA6r9sAXi5sQWI+QKkzDUwzQ4ArFzJAKya/Rnw1o8e97mGaQRATfrhjOLiJ1aCPo2IZOdRUuKkfKT2lzEj41kYBhharwDwPwiOKvfVQ+N2MwCjt27fun1sRgvoOkTqOHOmg/1EJTSodgCqsvNxLKZJehb05Tud/Xj/k2As95hYwlScdjcTAHqaVXFXr4YBgK2zAXBRbYG3pj0jVGFhEXYApJug68YgLWxNvjgBSAgDJSgAHmX2k28PAErq2+KOj165cuXYsVvHoAVo17+yMnjVPYIMdHT6MLmqlMtLaaw01fWZzl7VfgLwiSAhV3h2AHEhYWFPhS3AXOTZnwEkVmFBdI2DlE4QrAQtfxk7AXRzwsJeAiEA0qMomMZ2mFpA3fErqGOjt8UWIAIQp8Ht1Ca7ozaP8U6QU7j2iyDxfGcCwF6gCivswfnNBmDYu8KCQZDmxDG9jFqpSfVq+U7k/qFeZBJmvc1sAd4fX76TRzg3czEH8Joq8fOiK6/54ZkkcjhYLgNLiBAlo3SuY4R3HPvam1/Qpldeoe2XnqKg7JE3QXfT/ncLor3XkWi7GHX2JUH2CP8CX1/HhuwIGBKMiE90wF88qH2A9u/vif3++4ibJ5XYtsSzppTzFXOFxatnZBob4z/QWcgk4s7GBlM11zHCkVDsUGZi9vQbvtgUhVujUnDz4apLFJXdhErB/WcCMMH0ph9ItB33J/Gos285aEPmwEA1zZRZ7esol20OcJbhF1txzmoxSq1UnLDbKd0+XQk5KOcrJlSICRrGZtDJFeCWn6So9DKYstchkfBDHIBJcx0jNsDYKk+cOtlWf2le6t6UejD98Hy/g2F1B1lqLCVIxNH+d7O3mbg49gMAADA/fIii7UrUeYpFZQFAS4sj03PC2uqCDMWcdF9HS4LckiNJ8JUJtpx0Jeh5lu9P09zgnx4Lxs4BQEw7EfDn59v5Db0loK5cAU+Rnkkst5PyEzAqPVpw0c/vYuXlRYsQQIcyWQEizwoAzXUkABvI/u232i6U4ehtPbx+19f7tdUdDOAGURZWGO3/HWp4eGJieJh+nLc3Za//hxyAsv/ZwBcgXfAshqURQPvAiCOzxTWAACIcxTIBSEwsthUrAN4ND4edcX9lmpvFUlFenmFJ5wPAZvV8H8GGQdNRsiGgkg4AMC/sp0OYF8YAjAZfxJ72ciUDQLM1oD6GRO8GHAC3nyJCGxKoTusomA/XJSAVo7j1hw9TJP+gBiAkjPZHBybw3AtQJupc4APwyzzThXoOgLYzgxY6JbyiDzAAAz8mOhKyW1xQDDq93EbJ+ZKUgIO0CYm4/1nmGg3j/lRxYsMJAJBRPp1hyZJIBACPLwJYDQDQfvmQE/LiIEKkDr/z/WnKjlQ9ebELCmSoADAlhRc9jWih9t/cdmFCsjlysnBeHoQww0MgjhsGqavkulaxGfN4QGqohyTQIfpxXtSFuIMMAJsOjwYtdkZKh5z3DoNB5xFA5iPlkiOxtRAACMkAMu5/JxyHRp/6FYuz3XSUQi6z/VRhboZj+gkvAHT81Y4eUiETDrzAtT8kfwT2MwCa/RoAub05Ug8gUCuGFt+Cl7//Qo2U0JI7Nzvr0gUg2NZ2OKzti4CAS22swgMWV+MA2PQppyQ5YQoVaF5UHAPwzDNaRQgM0MPELHR1zztacroGElti3uhwFeYmZpXbZLmYtQAbNIZE3P/dqfDh4ZAje+h87KWJFry+jTf6xsctWTIHoFScEHOVEQC1gJ8UAJr9GoDuke5uLwBawgMCaL5QYytP3D93LgCAAxysgwdAW8AXX19SChyEgDiAUdDxY3JZjXzsOP48L+WwNwAKitLw+QMMQE6Ow+WCcVzXYC4AgBZnK05MlKTs3MTinOws2r/kTkjI8B52PnZuf2Pj+DicjwogQAGg2s8B+AEAeAZ8hAAWwMhSUZGWclFiRABnIF7YTS2gQAGgJTzE5/RMWosfyc7drwCoi4O7v64Orv/dX+sAPMUAEFt/6113Wf0D8Od5KXVhAAADdBqAe8855XMv4PEJQE7LANjfnssBlNtyCEC2I4EDoNPh52Pnt/fcxrlzfXNnAPiVCs0NK8JpfPoKE6H3C7nESwkAStYBUDO04QvbuzY8kojKRmVdSkuBewDL2oDCwiA3V+sFQIYFKMiGgZA0/UgBidMfombN5Y1n02QzM1lXmxXfAr2Ag/cCtsKsGfvn5NBDjjBAxQkFwF/lCouutbCdAPBusAAEANB1XKIlPOw4z7OHud68xIPBBtIRihIfQX1tQPFvon9RLBKp5VaIdX11BR9IzOVMl+V0Vl0M9teXa1sa77W30ciDvl0GLjU7g8vg7VuHit9P/2MJIMtRPnmxfX2xEDgN4h/svN/bdY2NUEPWtfitn5G07OJLqgIodxe/aUSm/IQODFvpcnvpeOTp67x9IYqLkr6StDA0jJf46IW89BDtpoqK+Rlr5zc2scqbVCFi9fcnlV2IgyQrUqfdqXU+YgcG2gcGHGt5JaPqecnTXq5ohN3hoDS+WrkGXc/PXnuttry8dj2pImPNJaqRTaLcXaxLHMm6tBisS6xLsKDjbdS/7cHMzXmpqXrnFYe6pNck1ZUNPWAweBGIx8nmpBxQYtarcpm8yVZT/FIVpE9ADUKlTjFsPJUDt1io2SolzxJhUhI0fIYG2iGp1HU6mO4bf+w3x3UJBUti7e6UnlJLaYJswvy/9s9e+9FVlVY1wpKfEQAZzidXI4CiIvBVO7aAy4Z1iXXD63g8AECv++r7PgtianWIoRuT1ktqxYjQRoO55qgeABkOptHoTmKWf1lrfkpSVH5wFWmXUiHCkn29//pcS1YoJEsHewGQn30Wrg7vG4MAgMMFk9NPy2ZSF55QtawqM9belNJjscs4Aj+/69CSm660tPGh8PDJU6T0GrOiMtQJDqCoCABAtyMCWPo2RnrUVvDsRiqXrzYBEwfA7CcAcFzzHAFAIrcfMjz8aqKS9ppSkhQAiusMT8zrudcLs0Ilq+QNQPr5Z/gP+wYAENsaZXe57KcL6AuDQ+f1Hw72772oprxE2Ht6LBvkVCwfEbkY5uHtTUsbGg8PP8yvGM/83LuXp8RgXeIYKXN3SYcIQGZ1h0mtICETVBtdBgCq5EZIHTAE+YoACkFUjO1Vm9WWlmCtXbsLza/a1cMrRGSfLJx7/eT1rNAV6rRKCrlJXEpChU+eAy7/6dMHlBZgcG1v8p9fqVRwAACWUrnMny7/wgcAQBQ0ACAQ4gUgH0oLMAOwLvEhqaOkZIvkRADkOnMAD2gA2ic5AIEA1i8AYdLUQ3SL+RoMjXMgfqAAeHHAhXJz3TqdX1sxv8IeXIr2A4CbpwqvX8/tOZXbe3Lu3Ju5BIDX7SUAO79krS+V1yTxCeI7kCDmZ2huSp5fGa0DUCvng62myHP3smloaeHjYD+8HutbwIULVmbAfQhgZEtJye4RJ9Yl1hIsZPLsOACXSwHwDy3gvCE1maznwvUEEnXF2FLSQLz5w58G8GQtyjQwX99cI6tbjMK6tZWrMBsepXyfD8TsdHcxPgMgmb9a1WSEbMannzUykLnK9/04RbMa73yCOmM8pPQvTCMMwG64+B1OrEuMnpgeAH8GrF9P/cCTm+c88oQ2Xz37jdXgykoVWHGFV4dbnVxW9mi8HkC5ZAPzyUKoRdak2Y9qiM8hj4nsv0kAwH5dHWHKhmfZwEnJCIBld2tfCFHWOqVOMRYqttXg5a92Kq7kfZ+fjQah/QRAP23tQdiOdYkPydADZkYCgD0MgMwBwPaNkItM2ol6e13EI4rx+0Hvp4MrK2VIapR4eToUpg9evlrfAuQEuv4KgCrNfgKgXv/jx28SgAWVujrCm59UAMB8Bpi15lNmBmnPcWgBe/lAJelrjLpa5XPcSgQAvrQmo+hqYl3iQ9ANdlA3uIdtZy2Atm9WOkESAniIlywgpQf5s16ATRkBAFBNDTy6dAVAOrxJ8IcgYuAtgEQAaBogvwuuwzRAqlusqyO8mVoe3QJl1RIAqKnpAp1QFfD1i1/rBe7Z5OJlzFXmMuoluJq0uQOispmRMUXq9sxI/BvaqqQzrOPS5RGno8D5k4/KWphTyfFVCCjLaShqQrGLT8L99btQOFpXCVlJplAyjFldYXb553nnUoSSrhm8XdXuWO+4MeXu6XJxJZSuSS0zmZbE0v5M61YFeUVxxVzjJSTt+3aq2kiadYkPCJsbucSKFEdRr5B0EXTNRkiSAkkkLcpq0qKsxuZkE9MF2h4+UWvXLZaFACR9Lq7krTKTLNfA7i67u6fHA/uv++EbfRh3lZhrvISW+NCi1DtfB+kGSmZf4uMkafTiRaNYkeJoBUi3RAgv2hLMhQDgV9U3QABqBUMaTcWgInmq9WGHD8J2swRZeBZUI8iSrjj5fNqcCKAaAFhLS91ui6fQ0pcLACBeLuu2i7nGS8CTnPYc5lNlEQCY/dqPP47sI22edYmPwYuky5cBgFCR4ihLkOC10REArBxRX887fhEAVWxATbhcE0ppLLg0BWA/FnqlL4RYoR3MR81RACw85Fy40LlwFgB7aqwdFktT0+CuvsKG7QRAT6BazDUGAO4m/4N1dRRpYQCcUNw5ZIQBmH1OEbMfAYgVKY5igoS2RAgBKNi0qdILwHwOQBtcjAquTzEzANt3tHdHX5l/8CAkt0JESJrYtEmS7Mz+OY0MwMLFcuC9gZHOB2YCwPxIi6WnGerlh/Vt71u97mkbrB11qpf5p8FU80Ofa7xkS5Gnvqzany/hQQBC3gRV4QpECoCypNQyCWVjdwCZTwDEihRHK56ABAltiZDzb+zfn19Qad1Pev+8j241OW10tbWpd7KplbeAzB3R7dGXKyHBFZOTzRNpaRPSpu6bTEYG4JwMN0DgQqzYkKTdoFheWkYAg4U3whDAEAAolmSIFl1XXFP6fso1Vl3phrYyeQUACCAAcO+/iQoB+1UANdP2Gg6ApAEQK1LkVcBof5W2RMj59/fvt8IBdADmCwBQ5acGy2XeArqjo7fDDXosIOCLAGoBQCZJjbLyFiA5uaclRmGpBXj6+prHt2/b3pebvu6HYhg3OqUkTa3C/SnXWAMw3hec3NCAnycAvAVM4QpU+57hLSDZxADE8BZA5o+NXTSKFSnyMmDCUhVVlFABJPf2rvAC4DcDgK28nLGNpOpu3fhmMLaVGTxhrvH3TkiA558TypI4AwGAmLAA6e+9lkLooPv6Gvq2NQIAuP42bbhcyDWml6m+hjoYhVIA7Nt3DhvAyDsaAJKMAgAoZj/8MYoVKagOMasooV6wyq6uSmXBRh9KMMCfOYDQYLWOMdXxhVzb9kG0H7SKGZw/X0hIwOf/uUj5hXtnWXLDMFlf0Ni4vQ91e1tjFgA4LWsGdIm5xrTERwl+XgOwb2RqCuwnAHkV6gQTqmojUwsg+0GXjWJFCkyQWEn2awCq+/ur6QwYAH03iABQBdwTRQDbBrcp08wuLzA8NZE0IyFBv2SFkLCAAFaUWkiNuY0I4BQv3lCJ6hRzjdkSH9rnNz5O2seEAPgMI8KAAFBKNwgAhIoUayBytVZdImTmzFSWKwyvfeAPG1Cql7aKyeitsXqDt/BF0LuCg6AgwyrdgnBZeZ3s0J1cQq4xST+3bKdQ/SyPaw2XODVtRoUL1IuUIMHOV5CPngZKdD29z85ozKvIy1DOIC/22G1yc7/DpeP4anCCq+oLgtdKTIkg11lMYFhgzzaEZtu3Ks7ybKvXae41rtOh14MPiOd/P0rn+or2UJRaX0xNbBI7KUGLyeV6cjOr06suP2eshbf1Dbz9dbvdQxHg53ZvAl3wB+Hiat6uKiZEQJ4uzsHDdShXY/n7VGu+msBgybclJRVbKQECtPqfJk9/8BNIK4vy4MzJ1SCd66u3B+sIU91jzXdfIgKw7fxYjVp73A0eAMAsL6Kld3Yb82ohifY0aXJXw26IGIGjC65m/Xw/nhCxReeqIoCHHoL3a/7C+0a6QbKarP6mVKUM7zzMRYYiDGzsJxEAwLuGFwBKmtUBIMtJuGKFeP6UeaqujocA9FH4J0VPMtLnwy91NUJ+eHodfEDZf73bU74Zorwjmc4OpxP+7dgDACrktWvR/FPuXeN7ShDAILdfSYjYYtbUhQAgvJBD9hOAMigFV0P2I4CgfHTZk/stlj7oKS2r82C+kPqgP702dmWCyb8s1Z8VGcmoXfOeU6mNh/rpA4nJ7dYD0Lm+zB7IPnwOwxDwMkXBQKjLwx01H/DNPyTRgO6H63aqC7KgHn8GATidI86Rji0jCOCAdFqqpcvft2cPA+BW7fe3VmMUeIvsVdMjTh9gMVjN+ZR5zqe4JOYnJCcnpDos2QzAmgyrZMUoLerogYijT+O8QH87m1TCK0yIAx3TLrfHtUUDEB5+9ixzfQEAWPMzzCv5+UsGwERDnXFhh8nVBgCq/Ril+HAdVXMDgsx3qDoCAJwxUAt4pGhLRwkYnJdwuhYvf8P4Hg5gEOz3Q/lbeYLDwiI9AM18AqCl39NAzKqE2v5++4aT2dnjDpvDkr4mA0YbFPsRQAW1ADvZPwsAumCv3RgZuTECYabHn6HvD5+ChBzm+sJ2JACjARiGQgB45dtCQtrAfhHAOgAgJhyAZ4ZSx9fzoP3bJ5sadqP9yxCAm9lvqlGn2QVqLSDTCwDEGMWXpQhKgMgGNTfvLspOB8+Nrr8GIMa+1t61VnF8ZgWwxTM9Pb77ORxpoih0OCZY6AA8/qwsP/s2bWeuOqx7EhbAACwHx7hXcUu2FnQKCQcEwEnKdHIA3Z6GPjJ/GQLoRvvn08uZHOm8H4KgRbKm9vMQ9ATT30dh0HMmACXBJ3H37uzs9M5vToKuKLoWmpwUszYmmZ9hQecBehgojlDGGqoT/Nh6T98jD9FQGwVh2flzAHg///zsk1+qQ3HcUeNldGYscbFYDXCyMPgW5fKPFOEVz2ufdDcU7UHRanQRrjo//3wzXAvn4oW4/uALRV4VGnQA8OUjyzwTANlPb9dzstNnqRNssiZrv69Zy5oHqz51AJbRwefVl4mFzzIDl6kJHCoAnnrMtsvebkbMjGlzM6K82AuyuwBljJ50e/Sr0aXvTbVCStbiQL7/si36Cg0IgHoBHvZVAMjqMyIC+3+eAQHK+qc6wWugb0AdYMKltLzqBNP5p2mur7AdWojmeeP5CtPmxISDmVHg27f3GPW6fPneB5fpEiyWGr2F7h8El9UUB3TnQNVMMTERWkyY9E91gtUZalyao8xEjvURkuBKs+33C8vl+cwVTjhUyO2lT2Fz4+pODjatUBW8QIzSgrdH+hQLE4P6e+Z8/70v5fqSlZRb0fAKiHzzIP7RB5XvE48XStJeT/JIgIFX/hgT9l+6dOvyVbAes3LhZl8oWtaKqc3dKExASF5MUhIk2Gp0apmHvPay4AWa7louRmkfSlDE6hLzXN9yPqyf/lktaKAVhZ8J4p9Xv09MmBDrBtPbIKU0dGPXGGuc3Ov1/Us7kpNPgPOeOULLTBhnRpHL8IGt/A4A9u3M8gKQGqyvKAEAvGp9rWmHDwcZ7uLaekyM0n7dulcTrC6vJCwkJvY0NxciACi+6IpCwf4AIDUJ12luiqPi7U0zVo8T6wbjHCC5xQMrnnimLQcAQPN4Sr3XEhv9yb0dn3eckWEA6xMAQKW9YPzLauJRZHr95/sjAHhNSiiTFe0AYhdwrCmEVDVcLINsqmrbzXsnkgxBKgCxX2bz/HZEm7uO4zS3sZs8YSExu6GpoS8xSwPQBN4gtoAycI791YWTLVTRyAGygxwREilqYCCKHR8AAIEnpqc9Hk/zgZUAYNt4Wp2/mut8X8cKWL8i80wmAPiEA7Ba4XXDmmTC7bgmLngsfH8E8HbmvsdrkhRFY3J0PTxC+8D8q0+FfycxuVz8irS3bxuUagKUuypUQjnxP1ShPwYAXJiM3hGdaa6ur758/FoOX10uMXFgoo4ByOAAwB9GAFazdb7/nTu/ou5AThKFT7SoM6p1YGDA7FIAdHc/LK9cOegZvHFgZYSxO3LHUFVcPc8FBgBwAc50wDg12K8AMOWbU1PL/HWlurSFl+e+9mbmxp0n53GN4QcOYmHfvpCri66GcADF0+PFHED3W44uSf6e67KM9uPq2ucCFzMAk5PR3d3RwKnr1o3j1246cmC+dg6krGBYMDtrDgB4woXzZAHAArwF6AZSp81F2Ml+LwCtuCI7XAQ8PniK7m5PKdRkujHY9xkAkGElHMhYAQIBDMAKAHDmDF5/DmC+1d8MtWjNBEDIHQYAzw08t/EbP0UAYH4btgCoa3zk6lMIgOR08hbQPfnNZGuxsrw/1Byli08DZLwFOMqvgBeQKbcfa245di2+RUm67LtzhwBAcpWL1pShJCiezf0r11ICwM2fE9vIk6NheqmL+Q0Q45vsdg+uPJANa6QjgO6Y6KFdcW1oD28BowhAGb5H19dqSjLnm8o4ANV+DuCdjRt/njArglvgYH2I4gkfCYFngI2rGATPgInWVkdEhC/XeTHDg01zW7Qo8wRNcyMAZH8uBEa3AQCclueinD5KgqJ3Bd3CybG12sgjrkkiqVIBDHo8bs+N7DPvnoF3BYhaD4XQKAoH8PlMAFDJG97U8gmAELXGbnDnH7/8oWrJvBW3FE+YXGF66OgWOIReoDTivK8KQCxO9rWLHv+KLiEANH///lzMPTYSADflNNLr8Its1jDoRVDDVfGhel9RCUhzvdesfbh0Gm7/GzfOvPsZAtg2FNaG9qgAknqTwXzSkk/YanZW6AXAftwuuNrYAn757RdNSw39ek8RAWgxWFBsu21uvK9m/3mxONn7rzGVM/nG54DU1ONcY+wjSi/gZgs5v+D9ffN0A0vYTakLQRMGAADnYe+GMjvuwc/RFTaOX9C5yggA5tqfYQIOxr93rREALHy2hGkpavn93lFaodRXbM/5+PN6GQWh+7efNIcQ6VN9cTtVUbtNCyuHokTXVHR9xXWgxYIT14T9jcbO5Z1GTf/kWvuIrqIZGvLzZn/19zFV10DHrh1FAQsDbtdPi1t2/6/fwReKUVgRUKkiuM7BIHHJjPgNttL4+ATHBp7qEXY3k8yFF+MVLgT31HffvaLT3TTNLvbmSSWBQzy+aK+P6Cr6Sd3N27slq/L72ORkP5fHPXrjGpTSTkiARD6+XVtiY/FU1TgkOOx8HaUlNBibmTAFAmQslb7kf0jd0MMNSNJrqPWgOfESBIhlm1zMqiBm3d3KpDwT8jIqKpTKYpiQUZK66Uf+O+ruCOZ616oJHANm80QrdqMDExMTrS7RXpYfAI9JtQKDVRrcsaPZnMR/F13To+trIXD7xBN+tF2bFnd2Vx88BoauUkKDNpSzmUJsWh3iI6Vf8gok2P35JQXLA2lp3DpadyjeJkMVTvjTCJqLAKJIGoC1a5XjYUJGScXaH3XHf1GZZqcmcAxERbUOSFFVkjmqaVeTh7vu9W10/hyAFTxlrQJDvtS8I3q7mQaACQCtKkYVIMNGfFUAWhSYinvtGoJH4NWpYQRA5nMAvNCx6uqWfim9LL0sv7wT22WalCm3Qo04SXl5SvhqjCJCPCT0/RUjA5ACAKo9nmozAngY8sLQXARw3yubVL4E4PsTfJpdY9GZM7st6bLUCgvZVzhaMlwhDbsmYhgAPgEkgAEwSab5Jj/IhuaeUr65OZoIkOsYlSLZ0HxUx2O+a9ZnVGC5FO5K8nmBVQ1U3Wrq3GcEYB8nAIOZzNGpgZuK7V/65cuonV+x1et64cJEmSU6PBVZlbyVqQKwgfffNwAAYLR76s7Zs3fOhuASGnkZp0Ey4KQocqwFXe/aE6caG3dvce5uTLdLXa6mKjvss2uXe2BDJp1P3GFIdqZpfwTAip6xWdJcxXzz9kWLtplTCYBzBA7OATSMRKxZz0pmkP0UQlMv/66px/Zt/vbjt0iPMe0f6z8Okrq3S/Bu1HnMWEoNYKP8FY8Zyt4jW5mzAcBGBD/fuCGTK3y66uzCqpB7h596QAEgbzhwoFbGIGrsTbvl+nVLKQIYcZ4BALYEeJeSVlQH7xqotREAvgQFO3/MD8iXTOAomWoCVFcxiQiUpcLvUORmwkbmT4e98e1DETMXSlYuf8g5HL5+xTuq/CJbPa5dKmhnq8dRC9j41WdH6Qim0YeKWfCAa/9sAFIQwID7xAmoJYpR6aqps7/+OvzdU+SorWX2I4GjECPUXGkI5pY0ZtVCztjuJgKQ4JABAJ0/hsW5I0S+MuTzoT2aq5hk3vb88zvKTJgRMqCUwf02rAMACK7kg/Dwj8a7f+qxdxgA1X4C8J17aqoB9B2pYUjWd0uRZYPCCpMRY0pE+HvUFeOLVGanKgUGR3ExaAYgPOTXhXB0BLDolFrugQo+RJQqrxKe8XFPI80y2zU+4Olzu8Js4Eqz8w856BfCAZBrmJoqrtaWat4B5RLLUg2iayq6kkfc4ARG902d2/eOBoDsZwDe9P79iKnGhI2QHWGeadTm3VG3L/GuKwwAqMpQihn3wXcBBACzCocRwCwJGfGlyqsUeMvjDIDslOEBUNuOLWqGKzyrq6jdBYZr/SdHSbcabsFdPMO1RFd4vKnqrX0kAKD1eigov0/TaQ5yGfS1/UCmz9Qyw6QIta4wYQAAUewhaFZehh6GojD8+LMlZMTzMsqNJAJAmoBbjQCIrvBfu4pdRlDXNSZj562xWV1L+KuhI79qUVelNNiLXOL+wVy9vYyrVvcsk6SWK+aig9y+fRtmupHQFVaOPpvrLE7LU1P5+VfMcIWv3Tau0ruGsdARLV9eoGaI4KHoaHy7KBgKilHiQ+Lqc0tAkfd5/x6nUxiU2/D5r2W84Wru17mGsXYsrXACwrC9vRCK7EzvgTHLBJiiPXtxtaDhxYudcr72+fvPMS1ePH0BBDNEpn9EnWV6MNzPS2E+/7Ugqtp0sVeNqhKA4IIkXtsHAST09DggOZ+2IwB1qSyK6t5uhVyLyHzeNyAApbh3YFF92xbMHPXoXeFwP32lvkfrfP5rQVQVCBznUVINQGVBtVRWiQB6Cjf05Bbm8u203r+65L/Vz+iJgvIgh2T+1ysIwJYXWErNuwBgU5I0GtyGT0Gos3NweZwf2V9XRwAW/A8AuJvcQ008ngF1ghFAQUFSZWVN5Qn405kO9pfjFBTu+s4onb39RtMLgSR4cr+wFADw6+/nt+j5ekOyKy01dRScwcpKCpMDAIOhLaCu7q56GBf6PwDwbGuKHsKgFOlWwQlcyiK5slI6sTVZIgBQnWEuAggQAfC6veNAAIy/F6r6vHsfAIDrj5d/QQAC6EpKS7NK2iy0OD8DAKj76qu6ekPQ/wLAjb6GoYZFygnSLKsCvP3LKpO3dlV2iq7vTADj7jtgPyKA/0ILoOtPAJ4HAFJq2l5p9FE65FZ4pnAAvxfVPRr0/wAAUdWG6JL3ULiOMAKgk608IXVBNrfo+jZnsuX4uRYZPXj9I2Vy6TcklGpLXCAAWgFCHn0UBRPMtz66nADgM6DvJgJo8PmvZdwG9t+rLaS8agXZj4Lx2K1jousIwJQHBrWYq1GB7wY6K9SEBW2Ji7sCnjcSgHG9KxxGAOraGh69jQBu+/zXMo67twVqKynfv6qXz2VAbQUAouvLJ/egMAo8DMGwyAo1YyFCXeICH4KL2gxg/1nSMGkZAtDK6v4fANw2LtUvpLwKpKtk2znD9RW0bNk95fqcBS2mHAp1vIIMsnEZ/50pDAbENP0PAPzbAu+3Qaf//BnwJ3hVZrDUwBceAAAAAElFTkSuQmCC";
  }, function (n, e, t) {
    var r = t(25),
      o = t(80),
      a = t(81),
      i = t(84),
      u = t(85),
      c = t(28),
      s = /^\s+|\s+$/g;
    n.exports = function (n, e, t) {
      if ((n = c(n)) && (t || void 0 === e)) return n.replace(s, "");
      if (!n || !(e = r(e))) return n;
      var p = u(n),
        f = u(e),
        l = i(p, f),
        g = a(p, f) + 1;
      return o(p, l, g).join("");
    };
  }, function (n, e, t) {
    var r = t(8),
      o = t(110),
      a = t(41),
      i = "Expected a function",
      u = Math.max,
      c = Math.min;
    n.exports = function (n, e, t) {
      var s,
        p,
        f,
        l,
        g,
        d,
        b = 0,
        x = !1,
        A = !1,
        v = !0;
      if ("function" != typeof n) throw new TypeError(i);
      function h(e) {
        var t = s,
          r = p;
        return s = p = void 0, b = e, l = n.apply(r, t);
      }
      function m(n) {
        var t = n - d;
        return void 0 === d || t >= e || t < 0 || A && n - b >= f;
      }
      function y() {
        var n = o();
        if (m(n)) return C(n);
        g = setTimeout(y, function (n) {
          var t = e - (n - d);
          return A ? c(t, f - (n - b)) : t;
        }(n));
      }
      function C(n) {
        return g = void 0, v && s ? h(n) : (s = p = void 0, l);
      }
      function k() {
        var n = o(),
          t = m(n);
        if (s = arguments, p = this, d = n, t) {
          if (void 0 === g) return function (n) {
            return b = n, g = setTimeout(y, e), x ? h(n) : l;
          }(d);
          if (A) return clearTimeout(g), g = setTimeout(y, e), h(d);
        }
        return void 0 === g && (g = setTimeout(y, e)), l;
      }
      return e = a(e) || 0, r(t) && (x = !!t.leading, f = (A = "maxWait" in t) ? u(a(t.maxWait) || 0, e) : f, v = "trailing" in t ? !!t.trailing : v), k.cancel = function () {
        void 0 !== g && clearTimeout(g), b = 0, s = d = p = g = void 0;
      }, k.flush = function () {
        return void 0 === g ? l : C(o());
      }, k;
    };
  }, function (n, e, t) {
    var r = t(42);
    n.exports = function (n) {
      var e = null == n ? 0 : n.length;
      return e ? r(n, 1, e) : [];
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n && n.length ? n[0] : void 0;
    };
  }, function (n, e, t) {
    var r = t(29),
      o = t(11),
      a = t(36),
      i = t(27),
      u = t(161),
      c = Math.max;
    n.exports = function (n, e, t, s) {
      n = o(n) ? n : u(n), t = t && !s ? i(t) : 0;
      var p = n.length;
      return t < 0 && (t = c(p + t, 0)), a(n) ? t <= p && n.indexOf(e, t) > -1 : !!p && r(n, e, t) > -1;
    };
  }, function (n, e) {
    n.exports = require$$1$1$1$1$1;
  }, function (n, e) {
    n.exports = TextField;
  }, function (n, e) {
    n.exports = InputAdornment;
  }, function (n, e) {
    n.exports = Button$2;
  }, function (n, e) {
    n.exports = Menu;
  }, function (n, e) {
    n.exports = Divider;
  }, function (n, e) {
    n.exports = NativeSelect;
  }, function (n, e) {
    n.exports = withStyles$1;
  }, function (n, e) {
    n.exports = MenuItem;
  }, function (n, e) {
    n.exports = RootRef;
  }, function (n, e) {
    var t;
    t = function () {
      return this;
    }();
    try {
      t = t || new Function("return this")();
    } catch (n) {
      "object" == typeof window && (t = window);
    }
    n.exports = t;
  }, function (n, e, t) {
    var r = t(14),
      o = Object.prototype,
      a = o.hasOwnProperty,
      i = o.toString,
      u = r ? r.toStringTag : void 0;
    n.exports = function (n) {
      var e = a.call(n, u),
        t = n[u];
      try {
        n[u] = void 0;
        var r = !0;
      } catch (n) {}
      var o = i.call(n);
      return r && (e ? n[u] = t : delete n[u]), o;
    };
  }, function (n, e) {
    var t = Object.prototype.toString;
    n.exports = function (n) {
      return t.call(n);
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      return n == n && (void 0 !== t && (n = n <= t ? n : t), void 0 !== e && (n = n >= e ? n : e)), n;
    };
  }, function (n, e, t) {
    var r = t(41),
      o = 1 / 0,
      a = 17976931348623157e292;
    n.exports = function (n) {
      return n ? (n = r(n)) === o || n === -o ? (n < 0 ? -1 : 1) * a : n == n ? n : 0 : 0 === n ? n : 0;
    };
  }, function (n, e, t) {
    var r = t(42);
    n.exports = function (n, e, t) {
      var o = n.length;
      return t = void 0 === t ? o : t, !e && t >= o ? n : r(n, e, t);
    };
  }, function (n, e, t) {
    var r = t(29);
    n.exports = function (n, e) {
      for (var t = n.length; t-- && r(e, n[t], 0) > -1;);
      return t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n != n;
    };
  }, function (n, e) {
    n.exports = function (n, e, t) {
      for (var r = t - 1, o = n.length; ++r < o;) if (n[r] === e) return r;
      return -1;
    };
  }, function (n, e, t) {
    var r = t(29);
    n.exports = function (n, e) {
      for (var t = -1, o = n.length; ++t < o && r(e, n[t], 0) > -1;);
      return t;
    };
  }, function (n, e, t) {
    var r = t(86),
      o = t(87),
      a = t(88);
    n.exports = function (n) {
      return o(n) ? a(n) : r(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n.split("");
    };
  }, function (n, e) {
    var t = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
    n.exports = function (n) {
      return t.test(n);
    };
  }, function (n, e) {
    var t = "[\\ud800-\\udfff]",
      r = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
      o = "\\ud83c[\\udffb-\\udfff]",
      a = "[^\\ud800-\\udfff]",
      i = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      u = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      c = "(?:" + r + "|" + o + ")" + "?",
      s = "[\\ufe0e\\ufe0f]?" + c + ("(?:\\u200d(?:" + [a, i, u].join("|") + ")[\\ufe0e\\ufe0f]?" + c + ")*"),
      p = "(?:" + [a + r + "?", r, i, u, t].join("|") + ")",
      f = RegExp(o + "(?=" + o + ")|" + p + s, "g");
    n.exports = function (n) {
      return n.match(f) || [];
    };
  }, function (n, e, t) {
    var r = t(90),
      o = t(17),
      a = t(32);
    n.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new r(),
        map: new (a || o)(),
        string: new r()
      };
    };
  }, function (n, e, t) {
    var r = t(91),
      o = t(96),
      a = t(97),
      i = t(98),
      u = t(99);
    function c(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.clear(); ++e < t;) {
        var r = n[e];
        this.set(r[0], r[1]);
      }
    }
    c.prototype.clear = r, c.prototype["delete"] = o, c.prototype.get = a, c.prototype.has = i, c.prototype.set = u, n.exports = c;
  }, function (n, e, t) {
    var r = t(16);
    n.exports = function () {
      this.__data__ = r ? r(null) : {}, this.size = 0;
    };
  }, function (n, e, t) {
    var r = t(44),
      o = t(93),
      a = t(8),
      i = t(45),
      u = /^\[object .+?Constructor\]$/,
      c = Function.prototype,
      s = Object.prototype,
      p = c.toString,
      f = s.hasOwnProperty,
      l = RegExp("^" + p.call(f).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    n.exports = function (n) {
      return !(!a(n) || o(n)) && (r(n) ? l : u).test(i(n));
    };
  }, function (n, e, t) {
    var r,
      o = t(94),
      a = (r = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";
    n.exports = function (n) {
      return !!a && a in n;
    };
  }, function (n, e, t) {
    var r = t(3)["__core-js_shared__"];
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n, e) {
      return null == n ? void 0 : n[e];
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = this.has(n) && delete this.__data__[n];
      return this.size -= e ? 1 : 0, e;
    };
  }, function (n, e, t) {
    var r = t(16),
      o = "__lodash_hash_undefined__",
      a = Object.prototype.hasOwnProperty;
    n.exports = function (n) {
      var e = this.__data__;
      if (r) {
        var t = e[n];
        return t === o ? void 0 : t;
      }
      return a.call(e, n) ? e[n] : void 0;
    };
  }, function (n, e, t) {
    var r = t(16),
      o = Object.prototype.hasOwnProperty;
    n.exports = function (n) {
      var e = this.__data__;
      return r ? void 0 !== e[n] : o.call(e, n);
    };
  }, function (n, e, t) {
    var r = t(16),
      o = "__lodash_hash_undefined__";
    n.exports = function (n, e) {
      var t = this.__data__;
      return this.size += this.has(n) ? 0 : 1, t[n] = r && void 0 === e ? o : e, this;
    };
  }, function (n, e) {
    n.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (n, e, t) {
    var r = t(18),
      o = Array.prototype.splice;
    n.exports = function (n) {
      var e = this.__data__,
        t = r(e, n);
      return !(t < 0) && (t == e.length - 1 ? e.pop() : o.call(e, t, 1), --this.size, !0);
    };
  }, function (n, e, t) {
    var r = t(18);
    n.exports = function (n) {
      var e = this.__data__,
        t = r(e, n);
      return t < 0 ? void 0 : e[t][1];
    };
  }, function (n, e, t) {
    var r = t(18);
    n.exports = function (n) {
      return r(this.__data__, n) > -1;
    };
  }, function (n, e, t) {
    var r = t(18);
    n.exports = function (n, e) {
      var t = this.__data__,
        o = r(t, n);
      return o < 0 ? (++this.size, t.push([n, e])) : t[o][1] = e, this;
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n) {
      var e = r(this, n)["delete"](n);
      return this.size -= e ? 1 : 0, e;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = typeof n;
      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== n : null === n;
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n) {
      return r(this, n).get(n);
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n) {
      return r(this, n).has(n);
    };
  }, function (n, e, t) {
    var r = t(19);
    n.exports = function (n, e) {
      var t = r(this, n),
        o = t.size;
      return t.set(n, e), this.size += t.size == o ? 0 : 1, this;
    };
  }, function (n, e, t) {
    var r = t(3);
    n.exports = function () {
      return r.Date.now();
    };
  }, function (n, e, t) {
    var r = t(112),
      o = t(149),
      a = t(56);
    n.exports = function (n) {
      var e = o(n);
      return 1 == e.length && e[0][2] ? a(e[0][0], e[0][1]) : function (t) {
        return t === n || r(t, n, e);
      };
    };
  }, function (n, e, t) {
    var r = t(46),
      o = t(47),
      a = 1,
      i = 2;
    n.exports = function (n, e, t, u) {
      var c = t.length,
        s = c,
        p = !u;
      if (null == n) return !s;
      for (n = Object(n); c--;) {
        var f = t[c];
        if (p && f[2] ? f[1] !== n[f[0]] : !(f[0] in n)) return !1;
      }
      for (; ++c < s;) {
        var l = (f = t[c])[0],
          g = n[l],
          d = f[1];
        if (p && f[2]) {
          if (void 0 === g && !(l in n)) return !1;
        } else {
          var b = new r();
          if (u) var x = u(g, d, l, n, e, b);
          if (!(void 0 === x ? o(d, g, a | i, u, b) : x)) return !1;
        }
      }
      return !0;
    };
  }, function (n, e, t) {
    var r = t(17);
    n.exports = function () {
      this.__data__ = new r(), this.size = 0;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = this.__data__,
        t = e["delete"](n);
      return this.size = e.size, t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.get(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.has(n);
    };
  }, function (n, e, t) {
    var r = t(17),
      o = t(32),
      a = t(30),
      i = 200;
    n.exports = function (n, e) {
      var t = this.__data__;
      if (t instanceof r) {
        var u = t.__data__;
        if (!o || u.length < i - 1) return u.push([n, e]), this.size = ++t.size, this;
        t = this.__data__ = new a(u);
      }
      return t.set(n, e), this.size = t.size, this;
    };
  }, function (n, e, t) {
    var r = t(46),
      o = t(48),
      a = t(123),
      i = t(127),
      u = t(144),
      c = t(2),
      s = t(52),
      p = t(54),
      f = 1,
      l = "[object Arguments]",
      g = "[object Array]",
      d = "[object Object]",
      b = Object.prototype.hasOwnProperty;
    n.exports = function (n, e, t, x, A, v) {
      var h = c(n),
        m = c(e),
        y = h ? g : u(n),
        C = m ? g : u(e),
        k = (y = y == l ? d : y) == d,
        w = (C = C == l ? d : C) == d,
        B = y == C;
      if (B && s(n)) {
        if (!s(e)) return !1;
        h = !0, k = !1;
      }
      if (B && !k) return v || (v = new r()), h || p(n) ? o(n, e, t, x, A, v) : a(n, e, y, t, x, A, v);
      if (!(t & f)) {
        var j = k && b.call(n, "__wrapped__"),
          P = w && b.call(e, "__wrapped__");
        if (j || P) {
          var O = j ? n.value() : n,
            E = P ? e.value() : e;
          return v || (v = new r()), A(O, E, t, x, v);
        }
      }
      return !!B && (v || (v = new r()), i(n, e, t, x, A, v));
    };
  }, function (n, e, t) {
    var r = t(30),
      o = t(120),
      a = t(121);
    function i(n) {
      var e = -1,
        t = null == n ? 0 : n.length;
      for (this.__data__ = new r(); ++e < t;) this.add(n[e]);
    }
    i.prototype.add = i.prototype.push = o, i.prototype.has = a, n.exports = i;
  }, function (n, e) {
    var t = "__lodash_hash_undefined__";
    n.exports = function (n) {
      return this.__data__.set(n, t), this;
    };
  }, function (n, e) {
    n.exports = function (n) {
      return this.__data__.has(n);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return n.has(e);
    };
  }, function (n, e, t) {
    var r = t(14),
      o = t(124),
      a = t(31),
      i = t(48),
      u = t(125),
      c = t(126),
      s = 1,
      p = 2,
      f = "[object Boolean]",
      l = "[object Date]",
      g = "[object Error]",
      d = "[object Map]",
      b = "[object Number]",
      x = "[object RegExp]",
      A = "[object Set]",
      v = "[object String]",
      h = "[object Symbol]",
      m = "[object ArrayBuffer]",
      y = "[object DataView]",
      C = r ? r.prototype : void 0,
      k = C ? C.valueOf : void 0;
    n.exports = function (n, e, t, r, C, w, B) {
      switch (t) {
        case y:
          if (n.byteLength != e.byteLength || n.byteOffset != e.byteOffset) return !1;
          n = n.buffer, e = e.buffer;
        case m:
          return !(n.byteLength != e.byteLength || !w(new o(n), new o(e)));
        case f:
        case l:
        case b:
          return a(+n, +e);
        case g:
          return n.name == e.name && n.message == e.message;
        case x:
        case v:
          return n == e + "";
        case d:
          var j = u;
        case A:
          var P = r & s;
          if (j || (j = c), n.size != e.size && !P) return !1;
          var O = B.get(n);
          if (O) return O == e;
          r |= p, B.set(n, e);
          var E = i(j(n), j(e), r, C, w, B);
          return B["delete"](n), E;
        case h:
          if (k) return k.call(n) == k.call(e);
      }
      return !1;
    };
  }, function (n, e, t) {
    var r = t(3).Uint8Array;
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n) {
      var e = -1,
        t = Array(n.size);
      return n.forEach(function (n, r) {
        t[++e] = [r, n];
      }), t;
    };
  }, function (n, e) {
    n.exports = function (n) {
      var e = -1,
        t = Array(n.size);
      return n.forEach(function (n) {
        t[++e] = n;
      }), t;
    };
  }, function (n, e, t) {
    var r = t(128),
      o = 1,
      a = Object.prototype.hasOwnProperty;
    n.exports = function (n, e, t, i, u, c) {
      var s = t & o,
        p = r(n),
        f = p.length;
      if (f != r(e).length && !s) return !1;
      for (var l = f; l--;) {
        var g = p[l];
        if (!(s ? g in e : a.call(e, g))) return !1;
      }
      var d = c.get(n);
      if (d && c.get(e)) return d == e;
      var b = !0;
      c.set(n, e), c.set(e, n);
      for (var x = s; ++l < f;) {
        var A = n[g = p[l]],
          v = e[g];
        if (i) var h = s ? i(v, A, g, e, n, c) : i(A, v, g, n, e, c);
        if (!(void 0 === h ? A === v || u(A, v, t, i, c) : h)) {
          b = !1;
          break;
        }
        x || (x = "constructor" == g);
      }
      if (b && !x) {
        var m = n.constructor,
          y = e.constructor;
        m != y && "constructor" in n && "constructor" in e && !("function" == typeof m && m instanceof m && "function" == typeof y && y instanceof y) && (b = !1);
      }
      return c["delete"](n), c["delete"](e), b;
    };
  }, function (n, e, t) {
    var r = t(129),
      o = t(131),
      a = t(12);
    n.exports = function (n) {
      return r(n, a, o);
    };
  }, function (n, e, t) {
    var r = t(130),
      o = t(2);
    n.exports = function (n, e, t) {
      var a = e(n);
      return o(n) ? a : r(a, t(n));
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = e.length, o = n.length; ++t < r;) n[o + t] = e[t];
      return n;
    };
  }, function (n, e, t) {
    var r = t(50),
      o = t(132),
      a = Object.prototype.propertyIsEnumerable,
      i = Object.getOwnPropertySymbols,
      u = i ? function (n) {
        return null == n ? [] : (n = Object(n), r(i(n), function (e) {
          return a.call(n, e);
        }));
      } : o;
    n.exports = u;
  }, function (n, e) {
    n.exports = function () {
      return [];
    };
  }, function (n, e, t) {
    var r = t(134),
      o = t(51),
      a = t(2),
      i = t(52),
      u = t(33),
      c = t(54),
      s = Object.prototype.hasOwnProperty;
    n.exports = function (n, e) {
      var t = a(n),
        p = !t && o(n),
        f = !t && !p && i(n),
        l = !t && !p && !f && c(n),
        g = t || p || f || l,
        d = g ? r(n.length, String) : [],
        b = d.length;
      for (var x in n) !e && !s.call(n, x) || g && ("length" == x || f && ("offset" == x || "parent" == x) || l && ("buffer" == x || "byteLength" == x || "byteOffset" == x) || u(x, b)) || d.push(x);
      return d;
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      for (var t = -1, r = Array(n); ++t < n;) r[t] = e(t);
      return r;
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(7),
      a = "[object Arguments]";
    n.exports = function (n) {
      return o(n) && r(n) == a;
    };
  }, function (n, e) {
    n.exports = function () {
      return !1;
    };
  }, function (n, e, t) {
    var r = t(6),
      o = t(34),
      a = t(7),
      i = {};
    i["[object Float32Array]"] = i["[object Float64Array]"] = i["[object Int8Array]"] = i["[object Int16Array]"] = i["[object Int32Array]"] = i["[object Uint8Array]"] = i["[object Uint8ClampedArray]"] = i["[object Uint16Array]"] = i["[object Uint32Array]"] = !0, i["[object Arguments]"] = i["[object Array]"] = i["[object ArrayBuffer]"] = i["[object Boolean]"] = i["[object DataView]"] = i["[object Date]"] = i["[object Error]"] = i["[object Function]"] = i["[object Map]"] = i["[object Number]"] = i["[object Object]"] = i["[object RegExp]"] = i["[object Set]"] = i["[object String]"] = i["[object WeakMap]"] = !1, n.exports = function (n) {
      return a(n) && o(n.length) && !!i[r(n)];
    };
  }, function (n, e) {
    n.exports = function (n) {
      return function (e) {
        return n(e);
      };
    };
  }, function (n, e, t) {
    (function (n) {
      var r = t(40),
        o = e && !e.nodeType && e,
        a = o && "object" == typeof n && n && !n.nodeType && n,
        i = a && a.exports === o && r.process,
        u = function () {
          try {
            var n = a && a.require && a.require("util").types;
            return n || i && i.binding && i.binding("util");
          } catch (n) {}
        }();
      n.exports = u;
    }).call(this, t(53)(n));
  }, function (n, e, t) {
    var r = t(141),
      o = t(142),
      a = Object.prototype.hasOwnProperty;
    n.exports = function (n) {
      if (!r(n)) return o(n);
      var e = [];
      for (var t in Object(n)) a.call(n, t) && "constructor" != t && e.push(t);
      return e;
    };
  }, function (n, e) {
    var t = Object.prototype;
    n.exports = function (n) {
      var e = n && n.constructor;
      return n === ("function" == typeof e && e.prototype || t);
    };
  }, function (n, e, t) {
    var r = t(143)(Object.keys, Object);
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n, e) {
      return function (t) {
        return n(e(t));
      };
    };
  }, function (n, e, t) {
    var r = t(145),
      o = t(32),
      a = t(146),
      i = t(147),
      u = t(148),
      c = t(6),
      s = t(45),
      p = s(r),
      f = s(o),
      l = s(a),
      g = s(i),
      d = s(u),
      b = c;
    (r && "[object DataView]" != b(new r(new ArrayBuffer(1))) || o && "[object Map]" != b(new o()) || a && "[object Promise]" != b(a.resolve()) || i && "[object Set]" != b(new i()) || u && "[object WeakMap]" != b(new u())) && (b = function b(n) {
      var e = c(n),
        t = "[object Object]" == e ? n.constructor : void 0,
        r = t ? s(t) : "";
      if (r) switch (r) {
        case p:
          return "[object DataView]";
        case f:
          return "[object Map]";
        case l:
          return "[object Promise]";
        case g:
          return "[object Set]";
        case d:
          return "[object WeakMap]";
      }
      return e;
    }), n.exports = b;
  }, function (n, e, t) {
    var r = t(9)(t(3), "DataView");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "Promise");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "Set");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(9)(t(3), "WeakMap");
    n.exports = r;
  }, function (n, e, t) {
    var r = t(55),
      o = t(12);
    n.exports = function (n) {
      for (var e = o(n), t = e.length; t--;) {
        var a = e[t],
          i = n[a];
        e[t] = [a, i, r(i)];
      }
      return e;
    };
  }, function (n, e, t) {
    var r = t(47),
      o = t(151),
      a = t(154),
      i = t(35),
      u = t(55),
      c = t(56),
      s = t(20),
      p = 1,
      f = 2;
    n.exports = function (n, e) {
      return i(n) && u(e) ? c(s(n), e) : function (t) {
        var i = o(t, n);
        return void 0 === i && i === e ? a(t, n) : r(e, i, p | f);
      };
    };
  }, function (n, e, t) {
    var r = t(57);
    n.exports = function (n, e, t) {
      var o = null == n ? void 0 : r(n, e);
      return void 0 === o ? t : o;
    };
  }, function (n, e, t) {
    var r = t(153),
      o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      a = /\\(\\)?/g,
      i = r(function (n) {
        var e = [];
        return 46 === n.charCodeAt(0) && e.push(""), n.replace(o, function (n, t, r, o) {
          e.push(r ? o.replace(a, "$1") : t || n);
        }), e;
      });
    n.exports = i;
  }, function (n, e, t) {
    var r = t(22),
      o = 500;
    n.exports = function (n) {
      var e = r(n, function (n) {
          return t.size === o && t.clear(), n;
        }),
        t = e.cache;
      return e;
    };
  }, function (n, e, t) {
    var r = t(155),
      o = t(156);
    n.exports = function (n, e) {
      return null != n && o(n, e, r);
    };
  }, function (n, e) {
    n.exports = function (n, e) {
      return null != n && e in Object(n);
    };
  }, function (n, e, t) {
    var r = t(58),
      o = t(51),
      a = t(2),
      i = t(33),
      u = t(34),
      c = t(20);
    n.exports = function (n, e, t) {
      for (var s = -1, p = (e = r(e, n)).length, f = !1; ++s < p;) {
        var l = c(e[s]);
        if (!(f = null != n && t(n, l))) break;
        n = n[l];
      }
      return f || ++s != p ? f : !!(p = null == n ? 0 : n.length) && u(p) && i(l, p) && (a(n) || o(n));
    };
  }, function (n, e) {
    n.exports = function (n) {
      return n;
    };
  }, function (n, e, t) {
    var r = t(159),
      o = t(160),
      a = t(35),
      i = t(20);
    n.exports = function (n) {
      return a(n) ? r(i(n)) : o(n);
    };
  }, function (n, e) {
    n.exports = function (n) {
      return function (e) {
        return null == e ? void 0 : e[n];
      };
    };
  }, function (n, e, t) {
    var r = t(57);
    n.exports = function (n) {
      return function (e) {
        return r(e, n);
      };
    };
  }, function (n, e, t) {
    var r = t(162),
      o = t(12);
    n.exports = function (n) {
      return null == n ? [] : r(n, o(n));
    };
  }, function (n, e, t) {
    var r = t(26);
    n.exports = function (n, e) {
      return r(e, function (e) {
        return n[e];
      });
    };
  }, function (n, e, t) {
    var r = t(21);
    n.exports = function (n, e) {
      var t = [];
      return r(n, function (n, r, o) {
        e(n, r, o) && t.push(n);
      }), t;
    };
  }, function (n, e, t) {
    var r = t(165),
      o = t(12);
    n.exports = function (n, e) {
      return n && r(n, e, o);
    };
  }, function (n, e, t) {
    var r = t(166)();
    n.exports = r;
  }, function (n, e) {
    n.exports = function (n) {
      return function (e, t, r) {
        for (var o = -1, a = Object(e), i = r(e), u = i.length; u--;) {
          var c = i[n ? u : ++o];
          if (!1 === t(a[c], c, a)) break;
        }
        return e;
      };
    };
  }, function (n, e, t) {
    var r = t(11);
    n.exports = function (n, e) {
      return function (t, o) {
        if (null == t) return t;
        if (!r(t)) return n(t, o);
        for (var a = t.length, i = e ? a : -1, u = Object(t); (e ? i-- : ++i < a) && !1 !== o(u[i], i, u););
        return t;
      };
    };
  }, function (n, e, t) {
    var r = t(21),
      o = t(11);
    n.exports = function (n, e) {
      var t = -1,
        a = o(n) ? Array(n.length) : [];
      return r(n, function (n, r, o) {
        a[++t] = e(n, r, o);
      }), a;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r) {
      var o = -1,
        a = null == n ? 0 : n.length;
      for (r && a && (t = n[++o]); ++o < a;) t = e(t, n[o], o, n);
      return t;
    };
  }, function (n, e) {
    n.exports = function (n, e, t, r, o) {
      return o(n, function (n, o, a) {
        t = r ? (r = !1, n) : e(t, n, o, a);
      }), t;
    };
  }, function (n, e, t) {
    var r = t(10),
      o = t(11),
      a = t(12);
    n.exports = function (n) {
      return function (e, t, i) {
        var u = Object(e);
        if (!o(e)) {
          var c = r(t, 3);
          e = a(e), t = function t(n) {
            return c(u[n], n, u);
          };
        }
        var s = n(e, t, i);
        return s > -1 ? u[c ? e[s] : s] : void 0;
      };
    };
  }, function (n, e, t) {
    var r = t(21);
    n.exports = function (n, e) {
      var t;
      return r(n, function (n, r, o) {
        return !(t = e(n, r, o));
      }), !!t;
    };
  }, function (n, e, t) {
    var r = t(31),
      o = t(11),
      a = t(33),
      i = t(8);
    n.exports = function (n, e, t) {
      if (!i(t)) return !1;
      var u = typeof e;
      return !!("number" == u ? o(t) && a(e, t.length) : "string" == u && e in t) && r(t[e], n);
    };
  }, function (n, e, t) {
    var r = t(175);
    function o() {}
    function a() {}
    a.resetWarningCache = o, n.exports = function () {
      function n(n, e, t, o, a, i) {
        if (i !== r) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }
      function e() {
        return n;
      }
      n.isRequired = n;
      var t = {
        array: n,
        bool: n,
        func: n,
        number: n,
        object: n,
        string: n,
        symbol: n,
        any: n,
        arrayOf: e,
        element: n,
        elementType: n,
        instanceOf: e,
        node: n,
        objectOf: e,
        oneOf: e,
        oneOfType: e,
        shape: e,
        exact: e,
        checkPropTypes: a,
        resetWarningCache: o
      };
      return t.PropTypes = t, t;
    };
  }, function (n, e, t) {
    n.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (n, e, t) {
    var r = t(177);
    "string" == typeof r && (r = [[n.i, r, ""]]);
    var o = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    t(180)(r, o);
    r.locals && (n.exports = r.locals);
  }, function (n, e, t) {
    e = n.exports = t(178)(!1);
    var r = t(179)(t(59));
    e.push([n.i, ".flag {\n  width: 16px;\n  height: 11px;\n  background-image: url(" + r + ") !important;\n}\n.flag.margin {\n  margin-right: 8px;\n}\n.flag.ad {\n  background-position: -16px 0;\n}\n.flag.ae {\n  background-position: -32px 0;\n}\n.flag.af {\n  background-position: -48px 0;\n}\n.flag.ag {\n  background-position: -64px 0;\n}\n.flag.ai {\n  background-position: -80px 0;\n}\n.flag.al {\n  background-position: -96px 0;\n}\n.flag.am {\n  background-position: -112px 0;\n}\n.flag.ao {\n  background-position: -128px 0;\n}\n.flag.ar {\n  background-position: -144px 0;\n}\n.flag.as {\n  background-position: -160px 0;\n}\n.flag.at {\n  background-position: -176px 0;\n}\n.flag.au {\n  background-position: -192px 0;\n}\n.flag.aw {\n  background-position: -208px 0;\n}\n.flag.az {\n  background-position: -224px 0;\n}\n.flag.ba {\n  background-position: -240px 0;\n}\n.flag.bb {\n  background-position: 0 -11px;\n}\n.flag.bd {\n  background-position: -16px -11px;\n}\n.flag.be {\n  background-position: -32px -11px;\n}\n.flag.bf {\n  background-position: -48px -11px;\n}\n.flag.bg {\n  background-position: -64px -11px;\n}\n.flag.bh {\n  background-position: -80px -11px;\n}\n.flag.bi {\n  background-position: -96px -11px;\n}\n.flag.bj {\n  background-position: -112px -11px;\n}\n.flag.bm {\n  background-position: -128px -11px;\n}\n.flag.bn {\n  background-position: -144px -11px;\n}\n.flag.bo {\n  background-position: -160px -11px;\n}\n.flag.br {\n  background-position: -176px -11px;\n}\n.flag.bs {\n  background-position: -192px -11px;\n}\n.flag.bt {\n  background-position: -208px -11px;\n}\n.flag.bw {\n  background-position: -224px -11px;\n}\n.flag.by {\n  background-position: -240px -11px;\n}\n.flag.bz {\n  background-position: 0 -22px;\n}\n.flag.ca {\n  background-position: -16px -22px;\n}\n.flag.cd {\n  background-position: -32px -22px;\n}\n.flag.cf {\n  background-position: -48px -22px;\n}\n.flag.cg {\n  background-position: -64px -22px;\n}\n.flag.ch {\n  background-position: -80px -22px;\n}\n.flag.ci {\n  background-position: -96px -22px;\n}\n.flag.ck {\n  background-position: -112px -22px;\n}\n.flag.cl {\n  background-position: -128px -22px;\n}\n.flag.cm {\n  background-position: -144px -22px;\n}\n.flag.cn {\n  background-position: -160px -22px;\n}\n.flag.co {\n  background-position: -176px -22px;\n}\n.flag.cr {\n  background-position: -192px -22px;\n}\n.flag.cu {\n  background-position: -208px -22px;\n}\n.flag.cv {\n  background-position: -224px -22px;\n}\n.flag.cw {\n  background-position: -240px -22px;\n}\n.flag.cy {\n  background-position: 0 -33px;\n}\n.flag.cz {\n  background-position: -16px -33px;\n}\n.flag.de {\n  background-position: -32px -33px;\n}\n.flag.dj {\n  background-position: -48px -33px;\n}\n.flag.dk {\n  background-position: -64px -33px;\n}\n.flag.dm {\n  background-position: -80px -33px;\n}\n.flag.do {\n  background-position: -96px -33px;\n}\n.flag.dz {\n  background-position: -112px -33px;\n}\n.flag.ec {\n  background-position: -128px -33px;\n}\n.flag.ee {\n  background-position: -144px -33px;\n}\n.flag.eg {\n  background-position: -160px -33px;\n}\n.flag.er {\n  background-position: -176px -33px;\n}\n.flag.es {\n  background-position: -192px -33px;\n}\n.flag.et {\n  background-position: -208px -33px;\n}\n.flag.fi {\n  background-position: -224px -33px;\n}\n.flag.fj {\n  background-position: -240px -33px;\n}\n.flag.fk {\n  background-position: 0 -44px;\n}\n.flag.fm {\n  background-position: -16px -44px;\n}\n.flag.fo {\n  background-position: -32px -44px;\n}\n.flag.fr,\n.flag.bl,\n.flag.mf {\n  background-position: -48px -44px;\n}\n.flag.ga {\n  background-position: -64px -44px;\n}\n.flag.gb {\n  background-position: -80px -44px;\n}\n.flag.gd {\n  background-position: -96px -44px;\n}\n.flag.ge {\n  background-position: -112px -44px;\n}\n.flag.gf {\n  background-position: -128px -44px;\n}\n.flag.gh {\n  background-position: -144px -44px;\n}\n.flag.gi {\n  background-position: -160px -44px;\n}\n.flag.gl {\n  background-position: -176px -44px;\n}\n.flag.gm {\n  background-position: -192px -44px;\n}\n.flag.gn {\n  background-position: -208px -44px;\n}\n.flag.gp {\n  background-position: -224px -44px;\n}\n.flag.gq {\n  background-position: -240px -44px;\n}\n.flag.gr {\n  background-position: 0 -55px;\n}\n.flag.gt {\n  background-position: -16px -55px;\n}\n.flag.gu {\n  background-position: -32px -55px;\n}\n.flag.gw {\n  background-position: -48px -55px;\n}\n.flag.gy {\n  background-position: -64px -55px;\n}\n.flag.hk {\n  background-position: -80px -55px;\n}\n.flag.hn {\n  background-position: -96px -55px;\n}\n.flag.hr {\n  background-position: -112px -55px;\n}\n.flag.ht {\n  background-position: -128px -55px;\n}\n.flag.hu {\n  background-position: -144px -55px;\n}\n.flag.id {\n  background-position: -160px -55px;\n}\n.flag.ie {\n  background-position: -176px -55px;\n}\n.flag.il {\n  background-position: -192px -55px;\n}\n.flag.in {\n  background-position: -208px -55px;\n}\n.flag.io {\n  background-position: -224px -55px;\n}\n.flag.iq {\n  background-position: -240px -55px;\n}\n.flag.ir {\n  background-position: 0 -66px;\n}\n.flag.is {\n  background-position: -16px -66px;\n}\n.flag.it {\n  background-position: -32px -66px;\n}\n.flag.jm {\n  background-position: -48px -66px;\n}\n.flag.jo {\n  background-position: -64px -66px;\n}\n.flag.jp {\n  background-position: -80px -66px;\n}\n.flag.ke {\n  background-position: -96px -66px;\n}\n.flag.kg {\n  background-position: -112px -66px;\n}\n.flag.kh {\n  background-position: -128px -66px;\n}\n.flag.ki {\n  background-position: -144px -66px;\n}\n.flag.km {\n  background-position: -160px -66px;\n}\n.flag.kn {\n  background-position: -176px -66px;\n}\n.flag.kp {\n  background-position: -192px -66px;\n}\n.flag.kr {\n  background-position: -208px -66px;\n}\n.flag.kw {\n  background-position: -224px -66px;\n}\n.flag.ky {\n  background-position: -240px -66px;\n}\n.flag.kz {\n  background-position: 0 -77px;\n}\n.flag.la {\n  background-position: -16px -77px;\n}\n.flag.lb {\n  background-position: -32px -77px;\n}\n.flag.lc {\n  background-position: -48px -77px;\n}\n.flag.li {\n  background-position: -64px -77px;\n}\n.flag.lk {\n  background-position: -80px -77px;\n}\n.flag.lr {\n  background-position: -96px -77px;\n}\n.flag.ls {\n  background-position: -112px -77px;\n}\n.flag.lt {\n  background-position: -128px -77px;\n}\n.flag.lu {\n  background-position: -144px -77px;\n}\n.flag.lv {\n  background-position: -160px -77px;\n}\n.flag.ly {\n  background-position: -176px -77px;\n}\n.flag.ma {\n  background-position: -192px -77px;\n}\n.flag.mc {\n  background-position: -208px -77px;\n}\n.flag.md {\n  background-position: -224px -77px;\n}\n.flag.me {\n  background-position: -112px -154px;\n  height: 12px;\n}\n.flag.mg {\n  background-position: 0 -88px;\n}\n.flag.mh {\n  background-position: -16px -88px;\n}\n.flag.mk {\n  background-position: -32px -88px;\n}\n.flag.ml {\n  background-position: -48px -88px;\n}\n.flag.mm {\n  background-position: -64px -88px;\n}\n.flag.mn {\n  background-position: -80px -88px;\n}\n.flag.mo {\n  background-position: -96px -88px;\n}\n.flag.mp {\n  background-position: -112px -88px;\n}\n.flag.mq {\n  background-position: -128px -88px;\n}\n.flag.mr {\n  background-position: -144px -88px;\n}\n.flag.ms {\n  background-position: -160px -88px;\n}\n.flag.mt {\n  background-position: -176px -88px;\n}\n.flag.mu {\n  background-position: -192px -88px;\n}\n.flag.mv {\n  background-position: -208px -88px;\n}\n.flag.mw {\n  background-position: -224px -88px;\n}\n.flag.mx {\n  background-position: -240px -88px;\n}\n.flag.my {\n  background-position: 0 -99px;\n}\n.flag.mz {\n  background-position: -16px -99px;\n}\n.flag.na {\n  background-position: -32px -99px;\n}\n.flag.nc {\n  background-position: -48px -99px;\n}\n.flag.ne {\n  background-position: -64px -99px;\n}\n.flag.nf {\n  background-position: -80px -99px;\n}\n.flag.ng {\n  background-position: -96px -99px;\n}\n.flag.ni {\n  background-position: -112px -99px;\n}\n.flag.nl,\n.flag.bq {\n  background-position: -128px -99px;\n}\n.flag.no {\n  background-position: -144px -99px;\n}\n.flag.np {\n  background-position: -160px -99px;\n}\n.flag.nr {\n  background-position: -176px -99px;\n}\n.flag.nu {\n  background-position: -192px -99px;\n}\n.flag.nz {\n  background-position: -208px -99px;\n}\n.flag.om {\n  background-position: -224px -99px;\n}\n.flag.pa {\n  background-position: -240px -99px;\n}\n.flag.pe {\n  background-position: 0 -110px;\n}\n.flag.pf {\n  background-position: -16px -110px;\n}\n.flag.pg {\n  background-position: -32px -110px;\n}\n.flag.ph {\n  background-position: -48px -110px;\n}\n.flag.pk {\n  background-position: -64px -110px;\n}\n.flag.pl {\n  background-position: -80px -110px;\n}\n.flag.pm {\n  background-position: -96px -110px;\n}\n.flag.pr {\n  background-position: -112px -110px;\n}\n.flag.ps {\n  background-position: -128px -110px;\n}\n.flag.pt {\n  background-position: -144px -110px;\n}\n.flag.pw {\n  background-position: -160px -110px;\n}\n.flag.py {\n  background-position: -176px -110px;\n}\n.flag.qa {\n  background-position: -192px -110px;\n}\n.flag.re {\n  background-position: -208px -110px;\n}\n.flag.ro {\n  background-position: -224px -110px;\n}\n.flag.rs {\n  background-position: -240px -110px;\n}\n.flag.ru {\n  background-position: 0 -121px;\n}\n.flag.rw {\n  background-position: -16px -121px;\n}\n.flag.sa {\n  background-position: -32px -121px;\n}\n.flag.sb {\n  background-position: -48px -121px;\n}\n.flag.sc {\n  background-position: -64px -121px;\n}\n.flag.sd {\n  background-position: -80px -121px;\n}\n.flag.se {\n  background-position: -96px -121px;\n}\n.flag.sg {\n  background-position: -112px -121px;\n}\n.flag.sh {\n  background-position: -128px -121px;\n}\n.flag.si {\n  background-position: -144px -121px;\n}\n.flag.sk {\n  background-position: -160px -121px;\n}\n.flag.sl {\n  background-position: -176px -121px;\n}\n.flag.sm {\n  background-position: -192px -121px;\n}\n.flag.sn {\n  background-position: -208px -121px;\n}\n.flag.so {\n  background-position: -224px -121px;\n}\n.flag.sr {\n  background-position: -240px -121px;\n}\n.flag.ss {\n  background-position: 0 -132px;\n}\n.flag.st {\n  background-position: -16px -132px;\n}\n.flag.sv {\n  background-position: -32px -132px;\n}\n.flag.sx {\n  background-position: -48px -132px;\n}\n.flag.sy {\n  background-position: -64px -132px;\n}\n.flag.sz {\n  background-position: -80px -132px;\n}\n.flag.tc {\n  background-position: -96px -132px;\n}\n.flag.td {\n  background-position: -112px -132px;\n}\n.flag.tg {\n  background-position: -128px -132px;\n}\n.flag.th {\n  background-position: -144px -132px;\n}\n.flag.tj {\n  background-position: -160px -132px;\n}\n.flag.tk {\n  background-position: -176px -132px;\n}\n.flag.tl {\n  background-position: -192px -132px;\n}\n.flag.tm {\n  background-position: -208px -132px;\n}\n.flag.tn {\n  background-position: -224px -132px;\n}\n.flag.to {\n  background-position: -240px -132px;\n}\n.flag.tr {\n  background-position: 0 -143px;\n}\n.flag.tt {\n  background-position: -16px -143px;\n}\n.flag.tv {\n  background-position: -32px -143px;\n}\n.flag.tw {\n  background-position: -48px -143px;\n}\n.flag.tz {\n  background-position: -64px -143px;\n}\n.flag.ua {\n  background-position: -80px -143px;\n}\n.flag.ug {\n  background-position: -96px -143px;\n}\n.flag.us {\n  background-position: -112px -143px;\n}\n.flag.uy {\n  background-position: -128px -143px;\n}\n.flag.uz {\n  background-position: -144px -143px;\n}\n.flag.va {\n  background-position: -160px -143px;\n}\n.flag.vc {\n  background-position: -176px -143px;\n}\n.flag.ve {\n  background-position: -192px -143px;\n}\n.flag.vg {\n  background-position: -208px -143px;\n}\n.flag.vi {\n  background-position: -224px -143px;\n}\n.flag.vn {\n  background-position: -240px -143px;\n}\n.flag.vu {\n  background-position: 0 -154px;\n}\n.flag.wf {\n  background-position: -16px -154px;\n}\n.flag.ws {\n  background-position: -32px -154px;\n}\n.flag.ye {\n  background-position: -48px -154px;\n}\n.flag.za {\n  background-position: -64px -154px;\n}\n.flag.zm {\n  background-position: -80px -154px;\n}\n.flag.zw {\n  background-position: -96px -154px;\n}\n", ""]);
  }, function (n, e, t) {
    n.exports = function (n) {
      var e = [];
      return e.toString = function () {
        return this.map(function (e) {
          var t = function (n, e) {
            var t = n[1] || "",
              r = n[3];
            if (!r) return t;
            if (e && "function" == typeof btoa) {
              var o = (i = r, u = btoa(unescape(encodeURIComponent(JSON.stringify(i)))), c = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(u), "/*# ".concat(c, " */")),
                a = r.sources.map(function (n) {
                  return "/*# sourceURL=".concat(r.sourceRoot).concat(n, " */");
                });
              return [t].concat(a).concat([o]).join("\n");
            }
            var i, u, c;
            return [t].join("\n");
          }(e, n);
          return e[2] ? "@media ".concat(e[2], "{").concat(t, "}") : t;
        }).join("");
      }, e.i = function (n, t) {
        "string" == typeof n && (n = [[null, n, ""]]);
        for (var r = {}, o = 0; o < this.length; o++) {
          var a = this[o][0];
          null != a && (r[a] = !0);
        }
        for (var i = 0; i < n.length; i++) {
          var u = n[i];
          null != u[0] && r[u[0]] || (t && !u[2] ? u[2] = t : t && (u[2] = "(".concat(u[2], ") and (").concat(t, ")")), e.push(u));
        }
      }, e;
    };
  }, function (n, e, t) {
    n.exports = function (n, e) {
      return "string" != typeof (n = n.__esModule ? n["default"] : n) ? n : (/^['"].*['"]$/.test(n) && (n = n.slice(1, -1)), /["'() \t\n]/.test(n) || e ? '"'.concat(n.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : n);
    };
  }, function (n, e, t) {
    var r,
      o,
      a = {},
      i = (r = function r() {
        return window && document && document.all && !window.atob;
      }, function () {
        return void 0 === o && (o = r.apply(this, arguments)), o;
      }),
      u = function u(n, e) {
        return e ? e.querySelector(n) : document.querySelector(n);
      },
      c = function (n) {
        var e = {};
        return function (n, t) {
          if ("function" == typeof n) return n();
          if (void 0 === e[n]) {
            var r = u.call(this, n, t);
            if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
              r = r.contentDocument.head;
            } catch (n) {
              r = null;
            }
            e[n] = r;
          }
          return e[n];
        };
      }(),
      s = null,
      p = 0,
      f = [],
      l = t(181);
    function g(n, e) {
      for (var t = 0; t < n.length; t++) {
        var r = n[t],
          o = a[r.id];
        if (o) {
          o.refs++;
          for (var i = 0; i < o.parts.length; i++) o.parts[i](r.parts[i]);
          for (; i < r.parts.length; i++) o.parts.push(h(r.parts[i], e));
        } else {
          var u = [];
          for (i = 0; i < r.parts.length; i++) u.push(h(r.parts[i], e));
          a[r.id] = {
            id: r.id,
            refs: 1,
            parts: u
          };
        }
      }
    }
    function d(n, e) {
      for (var t = [], r = {}, o = 0; o < n.length; o++) {
        var a = n[o],
          i = e.base ? a[0] + e.base : a[0],
          u = {
            css: a[1],
            media: a[2],
            sourceMap: a[3]
          };
        r[i] ? r[i].parts.push(u) : t.push(r[i] = {
          id: i,
          parts: [u]
        });
      }
      return t;
    }
    function b(n, e) {
      var t = c(n.insertInto);
      if (!t) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = f[f.length - 1];
      if ("top" === n.insertAt) r ? r.nextSibling ? t.insertBefore(e, r.nextSibling) : t.appendChild(e) : t.insertBefore(e, t.firstChild), f.push(e);else if ("bottom" === n.insertAt) t.appendChild(e);else {
        if ("object" != typeof n.insertAt || !n.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o = c(n.insertAt.before, t);
        t.insertBefore(e, o);
      }
    }
    function x(n) {
      if (null === n.parentNode) return !1;
      n.parentNode.removeChild(n);
      var e = f.indexOf(n);
      e >= 0 && f.splice(e, 1);
    }
    function A(n) {
      var e = document.createElement("style");
      if (void 0 === n.attrs.type && (n.attrs.type = "text/css"), void 0 === n.attrs.nonce) {
        var r = function () {
          return t.nc;
        }();
        r && (n.attrs.nonce = r);
      }
      return v(e, n.attrs), b(n, e), e;
    }
    function v(n, e) {
      Object.keys(e).forEach(function (t) {
        n.setAttribute(t, e[t]);
      });
    }
    function h(n, e) {
      var t, r, o, a;
      if (e.transform && n.css) {
        if (!(a = "function" == typeof e.transform ? e.transform(n.css) : e.transform["default"](n.css))) return function () {};
        n.css = a;
      }
      if (e.singleton) {
        var i = p++;
        t = s || (s = A(e)), r = C.bind(null, t, i, !1), o = C.bind(null, t, i, !0);
      } else n.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (t = function (n) {
        var e = document.createElement("link");
        return void 0 === n.attrs.type && (n.attrs.type = "text/css"), n.attrs.rel = "stylesheet", v(e, n.attrs), b(n, e), e;
      }(e), r = w.bind(null, t, e), o = function o() {
        x(t), t.href && URL.revokeObjectURL(t.href);
      }) : (t = A(e), r = k.bind(null, t), o = function o() {
        x(t);
      });
      return r(n), function (e) {
        if (e) {
          if (e.css === n.css && e.media === n.media && e.sourceMap === n.sourceMap) return;
          r(n = e);
        } else o();
      };
    }
    n.exports = function (n, e) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (e = e || {}).attrs = "object" == typeof e.attrs ? e.attrs : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = i()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
      var t = d(n, e);
      return g(t, e), function (n) {
        for (var r = [], o = 0; o < t.length; o++) {
          var i = t[o];
          (u = a[i.id]).refs--, r.push(u);
        }
        n && g(d(n, e), e);
        for (o = 0; o < r.length; o++) {
          var u;
          if (0 === (u = r[o]).refs) {
            for (var c = 0; c < u.parts.length; c++) u.parts[c]();
            delete a[u.id];
          }
        }
      };
    };
    var m,
      y = (m = [], function (n, e) {
        return m[n] = e, m.filter(Boolean).join("\n");
      });
    function C(n, e, t, r) {
      var o = t ? "" : r.css;
      if (n.styleSheet) n.styleSheet.cssText = y(e, o);else {
        var a = document.createTextNode(o),
          i = n.childNodes;
        i[e] && n.removeChild(i[e]), i.length ? n.insertBefore(a, i[e]) : n.appendChild(a);
      }
    }
    function k(n, e) {
      var t = e.css,
        r = e.media;
      if (r && n.setAttribute("media", r), n.styleSheet) n.styleSheet.cssText = t;else {
        for (; n.firstChild;) n.removeChild(n.firstChild);
        n.appendChild(document.createTextNode(t));
      }
    }
    function w(n, e, t) {
      var r = t.css,
        o = t.sourceMap,
        a = void 0 === e.convertToAbsoluteUrls && o;
      (e.convertToAbsoluteUrls || a) && (r = l(r)), o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
      var i = new Blob([r], {
          type: "text/css"
        }),
        u = n.href;
      n.href = URL.createObjectURL(i), u && URL.revokeObjectURL(u);
    }
  }, function (n, e) {
    n.exports = function (n) {
      var e = "undefined" != typeof window && window.location;
      if (!e) throw new Error("fixUrls requires window.location");
      if (!n || "string" != typeof n) return n;
      var t = e.protocol + "//" + e.host,
        r = t + e.pathname.replace(/\/[^\/]*$/, "/");
      return n.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (n, e) {
        var o,
          a = e.trim().replace(/^"(.*)"$/, function (n, e) {
            return e;
          }).replace(/^'(.*)'$/, function (n, e) {
            return e;
          });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(a) ? n : (o = 0 === a.indexOf("//") ? a : 0 === a.indexOf("/") ? t + a : r + a.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
      });
    };
  }, function (n, e, t) {
    t.r(e);
    var r = t(36),
      o = t.n(r),
      a = t(4),
      i = t.n(a),
      u = t(60),
      c = t.n(u),
      s = t(22),
      p = t.n(s),
      f = t(61),
      l = t.n(f),
      g = t(62),
      d = t.n(g),
      b = t(63),
      x = t.n(b),
      A = t(23),
      v = t.n(A),
      h = t(64),
      m = t.n(h),
      y = t(24),
      C = t.n(y),
      k = t(13),
      w = t.n(k),
      B = t(37),
      j = t.n(B),
      P = t(5),
      O = t.n(P),
      E = t(38),
      I = t.n(E),
      D = t(1),
      Q = t.n(D),
      S = t(0),
      T = t.n(S),
      M = t(65),
      R = t.n(M),
      F = t(66),
      U = t.n(F),
      L = t(67),
      N = t.n(L),
      z = t(68),
      K = t.n(z),
      G = t(69),
      H = t.n(G),
      q = t(70),
      Y = t.n(q),
      V = t(71),
      J = t.n(V),
      X = t(72),
      Z = t.n(X),
      W = t(39),
      _ = t.n(W),
      $ = t(73),
      nn = t.n($),
      en = t(74),
      tn = t.n(en);
    function rn(n) {
      return (rn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
        return typeof n;
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      })(n);
    }
    function on() {
      return (on = Object.assign || function (n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
      }).apply(this, arguments);
    }
    function an(n, e) {
      if (null == n) return {};
      var t,
        r,
        o = function (n, e) {
          if (null == n) return {};
          var t,
            r,
            o = {},
            a = Object.keys(n);
          for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || (o[t] = n[t]);
          return o;
        }(n, e);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(n);
        for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]);
      }
      return o;
    }
    function un(n, e) {
      for (var t = 0; t < e.length; t++) {
        var r = e[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
      }
    }
    function cn(n, e) {
      return !e || "object" !== rn(e) && "function" != typeof e ? function (n) {
        if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return n;
      }(n) : e;
    }
    function sn(n) {
      return (sn = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      })(n);
    }
    function pn(n, e) {
      return (pn = Object.setPrototypeOf || function (n, e) {
        return n.__proto__ = e, n;
      })(n, e);
    }
    var fn = function (n) {
      function e() {
        return function (n, e) {
          if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), cn(this, sn(e).apply(this, arguments));
      }
      var t, r;
      return function (n, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        n.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: n,
            writable: !0,
            configurable: !0
          }
        }), e && pn(n, e);
      }(e, n), t = e, (r = [{
        key: "render",
        value: function value() {
          var n = this.props,
            e = n.name,
            t = n.iso2,
            r = n.dialCode,
            o = n.localization,
            a = n.itemRef,
            i = n["native"],
            u = an(n, ["name", "iso2", "dialCode", "localization", "itemRef", "native"]);
          return i ? Q.a.createElement("option", on({
            className: "country",
            "data-dial-code": "1",
            "data-country-code": t,
            value: t
          }, u), o || e, " ", "+".concat(r)) : Q.a.createElement(tn.a, {
            rootRef: function rootRef(n) {
              return a(n);
            }
          }, Q.a.createElement(nn.a, on({
            className: "country",
            "data-dial-code": "1",
            "data-country-code": t
          }, u), Q.a.createElement("div", {
            className: "flag ".concat(t, " margin")
          }), Q.a.createElement("span", {
            className: "country-name"
          }, o || e), Q.a.createElement("span", {
            className: "dial-code"
          }, "+".concat(r))));
        }
      }]) && un(t.prototype, r), e;
    }(Q.a.PureComponent);
    fn.propTypes = {
      name: T.a.string.isRequired,
      iso2: T.a.string.isRequired,
      dialCode: T.a.string.isRequired,
      itemRef: T.a.func.isRequired,
      localization: T.a.string,
      "native": T.a.bool
    }, fn.defaultProps = {
      localization: null,
      "native": !1
    };
    var ln = fn;
    t(176), t(59);
    function gn(n) {
      return (gn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
        return typeof n;
      } : function (n) {
        return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      })(n);
    }
    function dn() {
      return (dn = Object.assign || function (n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
      }).apply(this, arguments);
    }
    function bn(n, e) {
      var t = Object.keys(n);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(n);
        e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        })), t.push.apply(t, r);
      }
      return t;
    }
    function xn(n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = null != arguments[e] ? arguments[e] : {};
        e % 2 ? bn(t, !0).forEach(function (e) {
          Cn(n, e, t[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : bn(t).forEach(function (e) {
          Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(t, e));
        });
      }
      return n;
    }
    function An(n, e) {
      if (null == n) return {};
      var t,
        r,
        o = function (n, e) {
          if (null == n) return {};
          var t,
            r,
            o = {},
            a = Object.keys(n);
          for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || (o[t] = n[t]);
          return o;
        }(n, e);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(n);
        for (r = 0; r < a.length; r++) t = a[r], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]);
      }
      return o;
    }
    function vn(n, e) {
      for (var t = 0; t < e.length; t++) {
        var r = e[t];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
      }
    }
    function hn(n) {
      return (hn = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      })(n);
    }
    function mn(n) {
      if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return n;
    }
    function yn(n, e) {
      return (yn = Object.setPrototypeOf || function (n, e) {
        return n.__proto__ = e, n;
      })(n, e);
    }
    function Cn(n, e, t) {
      return e in n ? Object.defineProperty(n, e, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[e] = t, n;
    }
    var kn = function (n) {
      function e(n) {
        var t;
        !function (n, e) {
          if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, e), t = function (n, e) {
          return !e || "object" !== gn(e) && "function" != typeof e ? mn(n) : e;
        }(this, hn(e).call(this, n)), Cn(mn(t), "flags", {}), Cn(mn(t), "guessSelectedCountry", p()(function (n, e, r) {
          var o = O()(e, {
            iso2: r
          }) || {};
          if ("" === c()(n)) return o;
          var a = j()(e, function (e, t) {
            if (i()(n, t.dialCode)) {
              if (t.dialCode.length > e.dialCode.length) return t;
              if (t.dialCode.length === e.dialCode.length && t.priority < e.priority) return t;
            }
            return e;
          }, {
            dialCode: "",
            priority: 10001
          }, mn(t));
          return a.name ? a : o;
        })), Cn(mn(t), "getProbableCandidate", p()(function (n) {
          if (!n || 0 === n.length) return null;
          var e = t.state.onlyCountries;
          return C()(e, function (e) {
            return i()(e.name.toLowerCase(), n.toLowerCase());
          }, mn(t))[0];
        })), Cn(mn(t), "getOnlyCountries", function (n, e) {
          return 0 === n.length ? e : e.filter(function (e) {
            return n.some(function (n) {
              return n === e.iso2;
            });
          });
        }), Cn(mn(t), "excludeCountries", function (n, e) {
          return 0 === e.length ? n : C()(n, function (n) {
            return !m()(e, n.iso2);
          });
        }), Cn(mn(t), "filterRegions", function (n, e) {
          if ("string" == typeof n) {
            var t = n;
            return e.filter(function (n) {
              return n.regions.some(function (n) {
                return n === t;
              });
            });
          }
          return e.filter(function (e) {
            return n.map(function (n) {
              return e.regions.some(function (e) {
                return e === n;
              });
            }).some(function (n) {
              return n;
            });
          });
        }), Cn(mn(t), "deleteAreaCodes", function (n) {
          return n.filter(function (n) {
            return !0 !== n.isAreaCode;
          });
        }), Cn(mn(t), "updateDefaultCountry", function (n) {
          var e = t.state.onlyCountries,
            r = t.props.disableCountryCode,
            o = O()(e, {
              iso2: n
            });
          t.setState({
            defaultCountry: n,
            selectedCountry: o,
            formattedNumber: r ? "" : "+".concat(o.dialCode)
          });
        }), Cn(mn(t), "scrollTo", function (n) {
          if (n) {
            var e = t.dropdownContainerRef;
            e && document.body && (e.scrollTop = n.offsetTop);
          }
        }), Cn(mn(t), "formatNumber", function (n, e) {
          var r,
            o = t.props,
            a = o.disableCountryCode,
            i = o.enableLongNumbers,
            u = o.autoFormat;
          if (a && e ? ((r = e.split(" ")).shift(), r = r.join(" ")) : r = e, !n || 0 === n.length) return a ? "" : "+";
          if (n && n.length < 2 || !r || !u) return a ? n : "+".concat(n);
          var c,
            s = j()(r, function (n, e) {
              return 0 === n.remainingText.length ? n : "." !== e ? {
                formattedText: n.formattedText + e,
                remainingText: n.remainingText
              } : {
                formattedText: n.formattedText + x()(n.remainingText),
                remainingText: d()(n.remainingText)
              };
            }, {
              formattedText: "",
              remainingText: n.split("")
            });
          return (c = i ? s.formattedText + s.remainingText.join("") : s.formattedText).includes("(") && !c.includes(")") && (c += ")"), c;
        }), Cn(mn(t), "cursorToEnd", function () {
          var n = t.props.isModernBrowser,
            e = t.inputRef;
          if (e.focus(), n) {
            var r = e.value.length;
            e.setSelectionRange(r, r);
          }
        }), Cn(mn(t), "getElement", function (n) {
          return t.flags["flag_no_".concat(n)];
        }), Cn(mn(t), "getCountryData", function () {
          var n = t.state.selectedCountry;
          return n ? {
            name: n.name || "",
            dialCode: n.dialCode || "",
            countryCode: n.iso2 || ""
          } : {};
        }), Cn(mn(t), "handleInput", function (n) {
          var e = t.state,
            r = e.selectedCountry,
            o = e.freezeSelection,
            a = t.state,
            i = a.selectedCountry,
            u = a.formattedNumber,
            c = a.onlyCountries,
            s = a.defaultCountry,
            p = t.props,
            f = p.disableCountryCode,
            l = p.countryCodeEditable,
            g = p.isModernBrowser,
            d = p.onChange,
            b = f ? "" : "+";
          if (!l) {
            var x = "+".concat(r.dialCode);
            if (n.target.value.length < x.length) return;
          }
          if (!(n.target.value.replace(/\D/g, "").length > 15) && n.target.value !== u) {
            if (n.preventDefault ? n.preventDefault() : n.returnValue = !1, n.target.value.length > 0) {
              var A = n.target.value.replace(/\D/g, "");
              (!o || i.dialCode.length > A.length) && (r = t.guessSelectedCountry(A.substring(0, 6), c, s), o = !1), b = t.formatNumber(A, r.format);
            }
            var v = n.target.selectionStart,
              h = b.length - u.length;
            t.setState({
              formattedNumber: b,
              freezeSelection: o,
              selectedCountry: r.dialCode ? r : i
            }, function () {
              g && (h > 0 && (v -= h), ")" === b.charAt(b.length - 1) ? t.inputRef.setSelectionRange(b.length - 1, b.length - 1) : v > 0 && u.length >= b.length && t.inputRef.setSelectionRange(v, v));
              d && d(b, t.getCountryData());
            });
          }
        }), Cn(mn(t), "handleRefInput", function (n) {
          var e,
            r = t.props,
            o = r.inputRef,
            a = r.InputProps;
          t.inputRef = n, o ? e = o : a && a.ref && (e = a.ref), e && ("function" == typeof e ? e(n) : e.current = n);
        }), Cn(mn(t), "handleInputClick", function (n) {
          var e = t.props.onClick;
          e && e(n, t.getCountryData());
        }), Cn(mn(t), "handleFlagItemClick", function (n) {
          var e = t.state,
            r = e.formattedNumber,
            a = e.selectedCountry,
            i = e.onlyCountries,
            u = t.props.onChange,
            c = a,
            s = o()(n) ? O()(i, function (e) {
              return e.iso2 === n;
            }) : O()(i, n),
            p = r.replace(" ", "").replace("(", "").replace(")", "").replace("-", ""),
            f = p.length > 1 ? p.replace(c.dialCode, s.dialCode) : s.dialCode,
            l = t.formatNumber(f.replace(/\D/g, ""), s.format);
          t.setState({
            anchorEl: null,
            selectedCountry: s,
            freezeSelection: !0,
            formattedNumber: l
          }, function () {
            t.cursorToEnd(), u && u(l, t.getCountryData());
          });
        }), Cn(mn(t), "handleInputFocus", function (n) {
          var e = t.state.selectedCountry,
            r = t.props,
            o = r.disableCountryCode,
            a = r.onFocus;
          t.inputRef && "+" === t.inputRef.value && e && !o && t.setState({
            formattedNumber: "+".concat(e.dialCode)
          }, function () {
            return setTimeout(t.cursorToEnd, 10);
          }), t.setState({
            placeholder: ""
          }), a && a(n, t.getCountryData()), setTimeout(t.cursorToEnd, 10);
        }), Cn(mn(t), "handleInputBlur", function (n) {
          var e = t.props,
            r = e.placeholder,
            o = e.onBlur;
          n.target.value || t.setState({
            placeholder: r
          }), o && o(n, t.getCountryData());
        }), Cn(mn(t), "getHighlightCountryIndex", function (n) {
          var e = t.state,
            r = e.highlightCountryIndex,
            o = e.onlyCountries,
            a = e.preferredCountries,
            i = r + n;
          return i < 0 || i >= o.length + a.length ? i - n : i;
        }), Cn(mn(t), "searchCountry", function () {
          var n = t.state,
            e = n.queryString,
            r = n.onlyCountries,
            o = n.preferredCountries,
            a = t.getProbableCandidate(e) || r[0],
            i = v()(r, a) + o.length;
          t.scrollTo(t.getElement(i), !0), t.setState({
            queryString: "",
            highlightCountryIndex: i
          });
        }), Cn(mn(t), "handleKeydown", function (n) {
          var e = t.state,
            r = e.anchorEl,
            o = e.highlightCountryIndex,
            a = e.preferredCountries,
            i = e.onlyCountries,
            u = e.queryString,
            c = e.debouncedQueryStingSearcher,
            s = t.props,
            p = s.keys,
            f = s.disabled;
          if (r && !f) {
            n.preventDefault ? n.preventDefault() : n.returnValue = !1;
            var l = function l(n) {
              t.setState({
                highlightCountryIndex: t.getHighlightCountryIndex(n)
              }, function () {
                t.scrollTo(t.getElement(o + a.length), !0);
              });
            };
            switch (n.which) {
              case p.DOWN:
                l(1);
                break;
              case p.UP:
                l(-1);
                break;
              case p.ENTER:
                t.handleFlagItemClick(i[o], n);
                break;
              case p.ESC:
                t.setState({
                  anchorEl: null
                }, t.cursorToEnd);
                break;
              default:
                (n.which >= p.A && n.which <= p.Z || n.which === p.SPACE) && t.setState({
                  queryString: u + String.fromCharCode(n.which)
                }, c);
            }
          }
        }), Cn(mn(t), "handleInputKeyDown", function (n) {
          var e = t.props,
            r = e.keys,
            o = e.onEnterKeyPress,
            a = e.onKeyDown;
          n.which === r.ENTER && o && o(n), a && a(n);
        }), Cn(mn(t), "checkIfValid", function () {
          var n = t.state.formattedNumber;
          return (0, t.props.isValid)(n.replace(/\D/g, ""));
        }), Cn(mn(t), "updateFormattedNumber", function (n) {
          var e,
            r = t.state,
            o = r.onlyCountries,
            a = r.defaultCountry,
            u = t.props.disableCountryCode,
            c = n,
            s = n;
          if (c.startsWith("+")) c = c.replace(/\D/g, ""), e = t.guessSelectedCountry(c.substring(0, 6), o, a), s = t.formatNumber(c, e.format);else {
            var p = (e = O()(o, {
              iso2: a
            })) && !i()(c.replace(/\D/g, ""), e.dialCode) ? e.dialCode : "";
            s = t.formatNumber((u ? "" : p) + c.replace(/\D/g, ""), e ? e.format : void 0);
          }
          t.setState({
            selectedCountry: e,
            formattedNumber: s
          });
        }), Cn(mn(t), "getDropdownProps", function () {
          var n = t.state,
            e = n.selectedCountry,
            r = n.anchorEl,
            o = n.preferredCountries,
            a = n.onlyCountries,
            i = t.props,
            u = i.classes,
            c = i.dropdownClass,
            s = i.localization,
            p = i.disableDropdown,
            f = i["native"],
            l = "flag ".concat(e.iso2),
            g = function g(n) {
              return Boolean(e && e.dialCode === n.dialCode);
            };
          return p ? {} : {
            startAdornment: Q.a.createElement(N.a, {
              className: u.positionStart,
              position: "start"
            }, f ? Q.a.createElement(Q.a.Fragment, null, Q.a.createElement(J.a, {
              id: "country-menu",
              open: Boolean(r),
              onClose: function onClose() {
                return t.setState({
                  anchorEl: null
                });
              },
              className: u["native"],
              classes: {
                root: R()(u.nativeRoot, "native", l),
                select: u.nativeSelect
              },
              onChange: function onChange(n) {
                return t.handleFlagItemClick(n.target.value);
              },
              disableUnderline: !0
            }, !!o.length && w()(o, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name],
                "native": !0
              });
            }), w()(a, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name],
                "native": !0
              });
            }))) : Q.a.createElement(Q.a.Fragment, null, Q.a.createElement(K.a, {
              className: u.flagButton,
              "aria-owns": r ? "country-menu" : null,
              "aria-label": "Select country",
              onClick: function onClick(n) {
                return t.setState({
                  anchorEl: n.currentTarget
                });
              },
              "aria-haspopup": !0
            }, Q.a.createElement("div", {
              className: l
            })), Q.a.createElement(H.a, {
              className: c,
              id: "country-menu",
              anchorEl: r,
              open: Boolean(r),
              onClose: function onClose() {
                return t.setState({
                  anchorEl: null
                });
              }
            }, !!o.length && w()(o, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                selected: g(n),
                onClick: function onClick() {
                  return t.handleFlagItemClick(n);
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name]
              });
            }), !!o.length && Q.a.createElement(Y.a, null), w()(a, function (n, e) {
              return Q.a.createElement(ln, {
                key: "preferred_".concat(n.iso2, "_").concat(e),
                itemRef: function itemRef(n) {
                  t.flags["flag_no_".concat(e)] = n;
                },
                selected: g(n),
                onClick: function onClick() {
                  return t.handleFlagItemClick(n);
                },
                name: n.name,
                iso2: n.iso2,
                dialCode: n.dialCode,
                localization: s && s[n.name]
              });
            }))))
          };
        });
        var r = _.a.allCountries;
        n.disableAreaCodes && (r = t.deleteAreaCodes(r)), n.regions && (r = t.filterRegions(n.regions, r));
        var a,
          u = t.excludeCountries(t.getOnlyCountries(n.onlyCountries, r), n.excludeCountries),
          s = C()(r, function (e) {
            return I()(n.preferredCountries, function (n) {
              return n === e.iso2;
            });
          }),
          f = n.value || "";
        a = f.length > 1 ? t.guessSelectedCountry(f.replace(/\D/g, "").substring(0, 6), u, n.defaultCountry) || 0 : n.defaultCountry && O()(u, {
          iso2: n.defaultCountry
        }) || 0;
        var g = v()(t.allCountries, a),
          b = f.length < 2 && a && !i()(f.replace(/\D/g, ""), a.dialCode) ? a.dialCode : "",
          A = "" === f && 0 === a ? "" : t.formatNumber((n.disableCountryCode ? "" : b) + f.replace(/\D/g, ""), a.name ? a.format : void 0);
        return t.state = {
          formattedNumber: A,
          placeholder: n.placeholder,
          onlyCountries: u,
          preferredCountries: s,
          defaultCountry: n.defaultCountry,
          selectedCountry: a,
          highlightCountryIndex: g,
          queryString: "",
          freezeSelection: !1,
          debouncedQueryStingSearcher: l()(t.searchCountry, 100),
          anchorEl: null
        }, t;
      }
      var t, r;
      return function (n, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        n.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: n,
            writable: !0,
            configurable: !0
          }
        }), e && yn(n, e);
      }(e, n), t = e, (r = [{
        key: "componentDidMount",
        value: function value() {
          document.addEventListener && document.addEventListener("keydown", this.handleKeydown);
        }
      }, {
        key: "componentDidUpdate",
        value: function value(n) {
          var e = n.value,
            t = this.state,
            r = t.defaultCountry,
            o = t.formattedNumber,
            a = this.props,
            i = a.defaultCountry,
            u = a.value;
          i && i !== r && this.updateDefaultCountry(i), "string" == typeof u && u !== e && u !== o && this.updateFormattedNumber(u);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          document.removeEventListener && document.removeEventListener("keydown", this.handleKeydown);
        }
      }, {
        key: "render",
        value: function value() {
          var n = this.state,
            e = n.formattedNumber,
            t = n.placeholder,
            r = this.props,
            o = r.inputClass,
            a = r.error,
            i = r.InputProps,
            u = An(r, ["native", "defaultCountry", "excludeCountries", "onlyCountries", "preferredCountries", "dropdownClass", "autoFormat", "disableAreaCodes", "isValid", "disableCountryCode", "disableDropdown", "enableLongNumbers", "countryCodeEditable", "onEnterKeyPress", "isModernBrowser", "classes", "keys", "localization", "placeholder", "regions", "onChange", "value", "inputClass", "error", "InputProps"]),
            c = this.getDropdownProps();
          return Q.a.createElement(U.a, dn({
            placeholder: t,
            value: e,
            className: o,
            inputRef: this.handleRefInput,
            error: a || !this.checkIfValid(),
            onChange: this.handleInput,
            onClick: this.handleInputClick,
            onFocus: this.handleInputFocus,
            onBlur: this.handleInputBlur,
            onKeyDown: this.handleInputKeyDown,
            type: "tel",
            InputProps: xn({}, c, {}, i)
          }, u));
        }
      }]) && vn(t.prototype, r), e;
    }(Q.a.Component);
    kn.propTypes = {
      classes: T.a.object,
      excludeCountries: T.a.arrayOf(T.a.string),
      onlyCountries: T.a.arrayOf(T.a.string),
      preferredCountries: T.a.arrayOf(T.a.string),
      defaultCountry: T.a.string,
      value: T.a.string,
      placeholder: T.a.string,
      disabled: T.a.bool,
      error: T.a.bool,
      variant: T.a.string,
      "native": T.a.bool,
      inputClass: T.a.string,
      dropdownClass: T.a.string,
      InputProps: T.a.object,
      inputProps: T.a.object,
      inputRef: T.a.func,
      autoFormat: T.a.bool,
      disableAreaCodes: T.a.bool,
      disableCountryCode: T.a.bool,
      disableDropdown: T.a.bool,
      enableLongNumbers: T.a.bool,
      countryCodeEditable: T.a.bool,
      regions: T.a.oneOfType([T.a.string, T.a.arrayOf(T.a.string)]),
      localization: T.a.object,
      onChange: T.a.func,
      onFocus: T.a.func,
      onBlur: T.a.func,
      onClick: T.a.func,
      onKeyDown: T.a.func,
      isValid: T.a.func,
      isModernBrowser: T.a.func,
      onEnterKeyPress: T.a.func,
      keys: T.a.object
    }, kn.defaultProps = {
      excludeCountries: [],
      onlyCountries: [],
      preferredCountries: [],
      defaultCountry: "",
      placeholder: "+1 (702) 123-4567",
      disabled: !1,
      error: !1,
      variant: "standard",
      "native": !1,
      inputClass: "",
      dropdownClass: "",
      autoFormat: !0,
      disableAreaCodes: !1,
      isValid: function isValid(n) {
        return I()(_.a.allCountries, function (e) {
          return i()(n, e.dialCode) || i()(e.dialCode, n);
        });
      },
      disableCountryCode: !1,
      disableDropdown: !1,
      enableLongNumbers: !1,
      countryCodeEditable: !0,
      regions: "",
      localization: {},
      onEnterKeyPress: function onEnterKeyPress() {},
      onChange: function onChange() {},
      isModernBrowser: function isModernBrowser() {
        return !!document.createElement && Boolean(document.createElement("input").setSelectionRange);
      },
      keys: {
        UP: 38,
        DOWN: 40,
        RIGHT: 39,
        LEFT: 37,
        ENTER: 13,
        ESC: 27,
        PLUS: 43,
        A: 65,
        Z: 90,
        SPACE: 32
      }
    }, kn.displayName = "MuiPhoneNumber";
    var wn = Z()(function () {
      return {
        flagButton: {
          minWidth: 30,
          padding: 0,
          height: 30
        },
        "native": {
          width: 30,
          height: 30,
          padding: 8
        },
        nativeRoot: {
          padding: 0,
          "& + svg": {
            display: "none"
          }
        },
        nativeSelect: {
          padding: 0,
          lineHeight: 0,
          height: 11
        },
        positionStart: {
          position: "relative"
        }
      };
    })(kn);
    e["default"] = wn;
  }]);
});
var MuiPhoneNumber$1$1$1$1 = unwrapExports$1$1$1$1(dist$1$1$1$1);
var google = window.google = window.google ? window.google : {};
var HTML_TAGS_MAINTAINED_BY_TRANS = ["br", "strong", "i", "p", "em", "span", "ul", "li"];
var i18nOptions = {
  fallbackLng: "es",
  resources: {
    es: es$2$1$1$1
  },
  interpolation: {
    escapeValue: false
  },
  react: {
    transKeepBasicHtmlNodesFor: HTML_TAGS_MAINTAINED_BY_TRANS
  }
};
i18n.use(LanguageDetector).use(initReactI18next).init(i18nOptions);
var t$1$1$1$1$1 = i18n.t.bind(i18n);
var _excluded$3 = ["classes"];
var IOSSwitch = withStyles(function (theme) {
  return {
    root: {
      width: 30,
      height: 16,
      padding: 0,
      margin: 0
    },
    switchBase: {
      padding: 1,
      "&$checked": {
        transform: "translateX(14px)",
        color: theme.palette.common.white,
        "& + $track": {
          backgroundColor: "#ec754a",
          opacity: 1,
          border: "none"
        }
      },
      "&$focusVisible $thumb": {
        color: "#52d869",
        border: "6px solid #fff"
      }
    },
    thumb: {
      width: 14,
      height: 14
    },
    track: {
      borderRadius: 26 / 2,
      border: "1px solid #c7c7c7",
      backgroundColor: "#c7c7c7",
      opacity: 1,
      transition: theme.transitions.create(["background-color", "border"])
    },
    checked: {},
    focusVisible: {}
  };
})(function (_ref) {
  var classes = _ref.classes,
    props = _objectWithoutPropertiesLoose$1$1$1$1(_ref, _excluded$3);
  var handleChange = function handleChange(e) {
    var value = e.target.checked;
    props.onChange(value);
  };
  return /*#__PURE__*/React__default__default__default__default.createElement(Switch, _extends$1$1$1$1({
    focusVisibleClassName: classes.focusVisible,
    disableRipple: true,
    classes: {
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked
    }
  }, props, {
    checked: !!props.value,
    onChange: handleChange
  }));
});
var useStyles = makeStyles({
  root: {
    width: "100%",
    height: "100%"
  },
  container: {
    height: "calc(100% - 48px)",
    scrollbarWidth: "thin"
  }
});
registerLocale("es", es$2$1$1$1$1);
var google$1 = window.google = window.google ? window.google : {};
var HTML_TAGS_MAINTAINED_BY_TRANS$1 = ["br", "strong", "i", "p", "em", "span", "ul", "li"];
var i18nOptions$1 = {
  fallbackLng: "es",
  resources: {
    es: es$2$1$1
  },
  interpolation: {
    escapeValue: false
  },
  react: {
    transKeepBasicHtmlNodesFor: HTML_TAGS_MAINTAINED_BY_TRANS$1
  }
};
i18n.use(LanguageDetector).use(initReactI18next).init(i18nOptions$1);
var t$2 = i18n.t.bind(i18n);
var _excluded$4 = ["classes"];
var IOSSwitch$1 = withStyles(function (theme) {
  return {
    root: {
      width: 30,
      height: 16,
      padding: 0,
      margin: 0
    },
    switchBase: {
      padding: 1,
      "&$checked": {
        transform: "translateX(14px)",
        color: theme.palette.common.white,
        "& + $track": {
          backgroundColor: "#ec754a",
          opacity: 1,
          border: "none"
        }
      },
      "&$focusVisible $thumb": {
        color: "#52d869",
        border: "6px solid #fff"
      }
    },
    thumb: {
      width: 14,
      height: 14
    },
    track: {
      borderRadius: 26 / 2,
      border: "1px solid #c7c7c7",
      backgroundColor: "#c7c7c7",
      opacity: 1,
      transition: theme.transitions.create(["background-color", "border"])
    },
    checked: {},
    focusVisible: {}
  };
})(function (_ref) {
  var classes = _ref.classes,
    props = _objectWithoutPropertiesLoose$1$1$1(_ref, _excluded$4);
  var handleChange = function handleChange(e) {
    var value = e.target.checked;
    props.onChange(value);
  };
  return /*#__PURE__*/React__default__default__default__default.createElement(Switch, _extends$1$1$1({
    focusVisibleClassName: classes.focusVisible,
    disableRipple: true,
    classes: {
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked
    }
  }, props, {
    checked: !!props.value,
    onChange: handleChange
  }));
});
var useStyles$1 = makeStyles({
  root: {
    width: "100%",
    height: "100%"
  },
  container: {
    height: "calc(100% - 48px)",
    scrollbarWidth: "thin"
  }
});
registerLocale("es", es$2$1$1$1$1);
var google$2 = window.google = window.google ? window.google : {};
var HTML_TAGS_MAINTAINED_BY_TRANS$2 = ["br", "strong", "i", "p", "em", "span", "ul", "li"];
var i18nOptions$2 = {
  fallbackLng: "es",
  resources: {
    es: es$2$1
  },
  interpolation: {
    escapeValue: false
  },
  react: {
    transKeepBasicHtmlNodesFor: HTML_TAGS_MAINTAINED_BY_TRANS$2
  }
};
i18n.use(LanguageDetector).use(initReactI18next).init(i18nOptions$2);
var t$3 = i18n.t.bind(i18n);
var _excluded$5 = ["classes"];
var IOSSwitch$2 = withStyles(function (theme) {
  return {
    root: {
      width: 30,
      height: 16,
      padding: 0,
      margin: 0
    },
    switchBase: {
      padding: 1,
      "&$checked": {
        transform: "translateX(14px)",
        color: theme.palette.common.white,
        "& + $track": {
          backgroundColor: "#ec754a",
          opacity: 1,
          border: "none"
        }
      },
      "&$focusVisible $thumb": {
        color: "#52d869",
        border: "6px solid #fff"
      }
    },
    thumb: {
      width: 14,
      height: 14
    },
    track: {
      borderRadius: 26 / 2,
      border: "1px solid #c7c7c7",
      backgroundColor: "#c7c7c7",
      opacity: 1,
      transition: theme.transitions.create(["background-color", "border"])
    },
    checked: {},
    focusVisible: {}
  };
})(function (_ref) {
  var classes = _ref.classes,
    props = _objectWithoutPropertiesLoose$1$1(_ref, _excluded$5);
  var handleChange = function handleChange(e) {
    var value = e.target.checked;
    props.onChange(value);
  };
  return /*#__PURE__*/React__default__default__default__default.createElement(Switch, _extends$1$1({
    focusVisibleClassName: classes.focusVisible,
    disableRipple: true,
    classes: {
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked
    }
  }, props, {
    checked: !!props.value,
    onChange: handleChange
  }));
});
var useStyles$2 = makeStyles({
  root: {
    width: "100%",
    height: "100%"
  },
  container: {
    height: "calc(100% - 48px)",
    scrollbarWidth: "thin"
  }
});
registerLocale("es", es$2$1$1$1$1);
var google$3 = window.google = window.google ? window.google : {};
var HTML_TAGS_MAINTAINED_BY_TRANS$3 = ["br", "strong", "i", "p", "em", "span", "ul", "li"];
var i18nOptions$3 = {
  fallbackLng: "es",
  resources: {
    es: es$2
  },
  interpolation: {
    escapeValue: false
  },
  react: {
    transKeepBasicHtmlNodesFor: HTML_TAGS_MAINTAINED_BY_TRANS$3
  }
};
i18n.use(LanguageDetector).use(initReactI18next).init(i18nOptions$3);
var t$4 = i18n.t.bind(i18n);
var _excluded$6 = ["classes"];
var IOSSwitch$3 = withStyles(function (theme) {
  return {
    root: {
      width: 30,
      height: 16,
      padding: 0,
      margin: 0
    },
    switchBase: {
      padding: 1,
      "&$checked": {
        transform: "translateX(14px)",
        color: theme.palette.common.white,
        "& + $track": {
          backgroundColor: "#ec754a",
          opacity: 1,
          border: "none"
        }
      },
      "&$focusVisible $thumb": {
        color: "#52d869",
        border: "6px solid #fff"
      }
    },
    thumb: {
      width: 14,
      height: 14
    },
    track: {
      borderRadius: 26 / 2,
      border: "1px solid #c7c7c7",
      backgroundColor: "#c7c7c7",
      opacity: 1,
      transition: theme.transitions.create(["background-color", "border"])
    },
    checked: {},
    focusVisible: {}
  };
})(function (_ref) {
  var classes = _ref.classes,
    props = _objectWithoutPropertiesLoose$1(_ref, _excluded$6);
  var handleChange = function handleChange(e) {
    var value = e.target.checked;
    props.onChange(value);
  };
  return /*#__PURE__*/React__default__default__default__default.createElement(Switch, _extends$1({
    focusVisibleClassName: classes.focusVisible,
    disableRipple: true,
    classes: {
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked
    }
  }, props, {
    checked: !!props.value,
    onChange: handleChange
  }));
});
var useStyles$3 = makeStyles({
  root: {
    width: "100%",
    height: "100%"
  },
  container: {
    height: "calc(100% - 48px)",
    scrollbarWidth: "thin"
  }
});
var StickyHeadTable$1 = function StickyHeadTable(_ref) {
  var totalDocs = _ref.totalDocs,
    rows = _ref.rows,
    columns = _ref.columns,
    page = _ref.page,
    pageSize = _ref.pageSize,
    sortable = _ref.sortable,
    orderBy = _ref.orderBy,
    onSort = _ref.onSort,
    onChangePage = _ref.onChangePage,
    onChangePageSize = _ref.onChangePageSize,
    _onDoubleClick = _ref.onDoubleClick,
    _ref$labelRowsPerPage = _ref.labelRowsPerPage,
    labelRowsPerPage = _ref$labelRowsPerPage === void 0 ? "Filas por página" : _ref$labelRowsPerPage,
    _ref$labelDisplayedRo = _ref.labelDisplayedRows,
    _labelDisplayedRows = _ref$labelDisplayedRo === void 0 ? "de" : _ref$labelDisplayedRo;
  var classes = useStyles$3();
  var totalPages = Math.floor(totalDocs / pageSize) + (totalDocs % pageSize > 0 ? 1 : 0);
  var TablePaginationActions = function TablePaginationActions() {
    var handleFirstPageButtonClick = function handleFirstPageButtonClick() {
      onChangePage(1);
    };
    var handleBackPageButtonClick = function handleBackPageButtonClick() {
      onChangePage(page - 1);
    };
    var handleNextPageButtonClick = function handleNextPageButtonClick() {
      onChangePage(page + 1);
    };
    var handleLastPageButtonClick = function handleLastPageButtonClick() {
      onChangePage(totalPages);
    };
    return /*#__PURE__*/React__default__default__default__default.createElement(Box, null, /*#__PURE__*/React__default__default__default__default.createElement(IconButton$1, {
      onClick: handleFirstPageButtonClick,
      disabled: page === 1
    }, /*#__PURE__*/React__default__default__default__default.createElement(FirstPage, null)), /*#__PURE__*/React__default__default__default__default.createElement(IconButton$1, {
      onClick: handleBackPageButtonClick,
      disabled: page === 1
    }, /*#__PURE__*/React__default__default__default__default.createElement(KeyboardArrowLeft, null)), /*#__PURE__*/React__default__default__default__default.createElement(IconButton$1, {
      onClick: handleNextPageButtonClick,
      disabled: page >= totalPages
    }, /*#__PURE__*/React__default__default__default__default.createElement(KeyboardArrowRight, null)), /*#__PURE__*/React__default__default__default__default.createElement(IconButton$1, {
      onClick: handleLastPageButtonClick,
      disabled: page >= totalPages
    }, /*#__PURE__*/React__default__default__default__default.createElement(LastPage, null)));
  };
  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    onChangePageSize(event.target.value);
  };
  return /*#__PURE__*/React__default__default__default__default.createElement(Paper, {
    className: classes.root + " cTable"
  }, /*#__PURE__*/React__default__default__default__default.createElement(TableContainer, {
    className: classes.container
  }, /*#__PURE__*/React__default__default__default__default.createElement(Table, {
    stickyHeader: true,
    "aria-label": "sticky table"
  }, /*#__PURE__*/React__default__default__default__default.createElement(TableHead, null, /*#__PURE__*/React__default__default__default__default.createElement(TableRow, null, columns.map(function (column, index) {
    return /*#__PURE__*/React__default__default__default__default.createElement(TableCell, {
      key: index,
      className: column.className || "",
      align: column.align,
      style: {
        minWidth: column.minWidth,
        width: column.width,
        maxWidth: column.maxWidth
      }
    }, sortable && column.orderId && /*#__PURE__*/React__default__default__default__default.createElement(TableSortLabel, {
      active: !!orderBy[column.orderId],
      direction: orderBy[column.orderId],
      onClick: function onClick() {
        return onSort(column.orderId);
      }
    }, column.label) || column.label);
  }))), /*#__PURE__*/React__default__default__default__default.createElement(TableBody, null, rows.map(function (row, _idx) {
    return /*#__PURE__*/React__default__default__default__default.createElement(TableRow, {
      hover: true,
      role: "checkbox",
      tabIndex: -1,
      key: _idx,
      onDoubleClick: function onDoubleClick() {
        return _onDoubleClick(row);
      }
    }, columns.map(function (column, colIdx) {
      var value = row[column.id];
      return /*#__PURE__*/React__default__default__default__default.createElement(TableCell, {
        key: colIdx,
        className: column.className || "",
        align: column.align
      }, column.renderCell ? column.renderCell(value, row) : value);
    }));
  })))), /*#__PURE__*/React__default__default__default__default.createElement(TablePagination, {
    component: "div",
    count: totalDocs,
    page: page - 1,
    rowsPerPageOptions: [10, 25, 100],
    rowsPerPage: pageSize,
    ActionsComponent: TablePaginationActions,
    onRowsPerPageChange: function onRowsPerPageChange(rows) {
      return handleChangeRowsPerPage(rows);
    },
    labelRowsPerPage: labelRowsPerPage,
    labelDisplayedRows: function labelDisplayedRows(_ref2) {
      var from = _ref2.from,
        to = _ref2.to,
        count = _ref2.count;
      return from + "-" + to + " " + _labelDisplayedRows + " " + count;
    }
  }));
};
var PageWrapper$1 = function PageWrapper(_ref) {
  var id = _ref.id,
    hide = _ref.hide,
    _ref$renderFromDashbo = _ref.renderFromDashboard,
    renderFromDashboard = _ref$renderFromDashbo === void 0 ? false : _ref$renderFromDashbo,
    children = _ref.children;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    id: id,
    className: "PageWrapper " + (hide === true ? "hide" : "")
  }, /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "FullPagePanel flex column " + (renderFromDashboard ? "renderFromDashboard" : "")
  }, children));
};
var _g$1;
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function SvgArrowBack$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g$1 || (_g$1 = /*#__PURE__*/createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#666",
    fillRule: "nonzero",
    d: "M10.5 4L3 12l7.5 8 1.5-1.6-4.878-5.2H21v-2.4H7.128L12 5.6z"
  }))));
}
var PageHeader$1 = function PageHeader(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    goBack = _ref.goBack,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? "" : _ref$title,
    _ref$filters = _ref.filters,
    filters = _ref$filters === void 0 ? "" : _ref$filters,
    _ref$actions = _ref.actions,
    actions = _ref$actions === void 0 ? "" : _ref$actions,
    _ref$info = _ref.info,
    info = _ref$info === void 0 ? "" : _ref$info,
    children = _ref.children;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "PageHeader " + className + " flex between v-center"
  }, /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "flex start v-center"
  }, goBack && /*#__PURE__*/React__default__default__default__default.createElement(SvgArrowBack$1, {
    className: "PageHeader__goBack",
    onClick: goBack
  }), title && /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "PageHeader__title"
  }, title), filters && /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "PageHeader__filters"
  }, filters)), children && children, actions && /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "PageHeader__actions flex end v-center"
  }, actions), info && /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "PageHeader__info flex end v-center"
  }, info));
};
var PageBody$1 = function PageBody(_ref) {
  var id = _ref.id,
    className = _ref.className,
    style = _ref.style,
    children = _ref.children;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    id: id || "",
    className: "PageBody " + (className || "") + " flex h-center\"",
    style: style || {}
  }, children);
};
registerLocale("es", es$2$1$1$1$1);

var _excluded$1 = ["id", "onChange", "label", "required", "value", "name", "countries"];
var google$4 = window.google = window.google ? window.google : {};
var PlacesInput = function PlacesInput(_ref) {
  var id = _ref.id,
    onChange = _ref.onChange,
    label = _ref.label,
    required = _ref.required,
    value = _ref.value,
    name = _ref.name,
    _ref$countries = _ref.countries,
    countries = _ref$countries === void 0 ? null : _ref$countries,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var placesRef = useRef();
  var isSelected = useRef(false);
  var _useState = useState(null),
    place = _useState[0],
    setPlace = _useState[1];
  var initPlaces = function initPlaces() {
    var input = placesRef.current.children[0].children[0].children[1].children[0];
    var placesInput = new google$4.maps.places.Autocomplete(input, {
      componentRestrictions: isNull(countries) ? null : {
        country: countries
      },
      language: "es",
      fields: ["address_components", "geometry.location", "formatted_address"]
    });
    placesInput.addListener("place_changed", function () {
      var _place = placesInput.getPlace();
      setPlace(_extends({}, _place));
    });
  };
  var handleFocus = function handleFocus() {
    isSelected.current = false;
  };
  var handleBlur = function handleBlur() {
    if (!isSelected.current) {
      var input = placesRef.current.children[0].children[0].children[1].children[0];
      onChange(null, null);
      input.value = "";
    }
  };
  useEffect(function () {
    if (place) {
      onChange(place.formatted_address, place);
      isSelected.current = true;
    }
  }, [place]);
  useEffect(function () {
    initPlaces();
  }, []);
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "PlacesInput",
    ref: placesRef
  }, /*#__PURE__*/React__default__default__default__default.createElement(Input$3, _extends({
    value: value,
    placeholder: "\xA0",
    name: name,
    label: label,
    required: required,
    id: id,
    handleFocus: handleFocus,
    handleBlur: handleBlur,
    onReset: function onReset() {
      return setPlace(null);
    }
  }, props)));
};

var timeoutSearch;
var SearchIcon = function SearchIcon() {
  return /*#__PURE__*/React__default__default__default__default.createElement("div", null, /*#__PURE__*/React__default__default__default__default.createElement("img", {
    style: {
      width: "16px",
      height: "16px"
    },
    src: icon$2
  }));
};
var ClearIcon = function ClearIcon() {
  return /*#__PURE__*/React__default__default__default__default.createElement("div", null, /*#__PURE__*/React__default__default__default__default.createElement("img", {
    style: {
      cursor: "pointer",
      width: "16px",
      height: "16px"
    },
    src: clearIcon
  }));
};
var SearchInput = function SearchInput(_ref) {
  var placeholder = _ref.placeholder,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? "" : _ref$defaultValue,
    onChange = _ref.onChange,
    clearable = _ref.clearable,
    tip = _ref.tip;
  var inputRef = useRef();
  var handleChange = function handleChange(v) {
    clearTimeout(timeoutSearch);
    timeoutSearch = setTimeout(function () {
      return onChange(v);
    }, 250);
  };
  var handleClear = function handleClear() {
    handleChange(null);
    inputRef.current.value = "";
  };
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "SearchInput"
  }, /*#__PURE__*/React__default__default__default__default.createElement(FormControl, {
    variant: "outlined",
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    }
  }, /*#__PURE__*/React__default__default__default__default.createElement(OutlinedInput, {
    placeholder: placeholder,
    defaultValue: defaultValue,
    startAdornment: /*#__PURE__*/React__default__default__default__default.createElement(InputAdornment, {
      position: "start"
    }, /*#__PURE__*/React__default__default__default__default.createElement(SearchIcon, null)),
    inputRef: inputRef,
    endAdornment: clearable && /*#__PURE__*/React__default__default__default__default.createElement(InputAdornment, {
      position: "end",
      onClick: handleClear
    }, /*#__PURE__*/React__default__default__default__default.createElement(ClearIcon, null)),
    inputProps: {
      style: {
        height: 40,
        padding: "0 14px"
      }
    }
  })), tip && /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "SearchInput__tip"
  }, tip));
};

var HTML_TAGS_MAINTAINED_BY_TRANS$4 = ["br", "strong", "i", "p", "em", "span", "ul", "li"];
var i18nOptions$4 = {
  fallbackLng: "es",
  resources: {
    es: es
  },
  interpolation: {
    escapeValue: false
  },
  react: {
    transKeepBasicHtmlNodesFor: HTML_TAGS_MAINTAINED_BY_TRANS$4
  }
};
i18n.use(LanguageDetector).use(initReactI18next).init(i18nOptions$4);
var t$5 = i18n.t.bind(i18n);

var MuiSelect = function MuiSelect(props) {
  var label = props.label,
    name = props.name,
    required = props.required,
    errorobj = props.errorobj,
    options = props.options,
    noBorder = props.noBorder,
    autoSelectFirst = props.autoSelectFirst,
    onSelectChange = props.onSelectChange,
    disabled = props.disabled,
    disableEmpty = props.disableEmpty;
  var _useState = useState(null),
    value = _useState[0],
    setValue = _useState[1];
  var isError = false;
  var errorMessage = "";
  if (errorobj && errorobj.hasOwnProperty(name)) {
    isError = true;
    errorMessage = errorobj[name].message || "Campo requerido";
  }
  var handleChange = function handleChange(a, b, c, d) {
    props.onChange(a, b, c, d);
    setValue(a.target.value);
    onSelectChange && onSelectChange(a.target.value);
  };
  useEffect(function () {
    if (autoSelectFirst) {
      setValue(options[0].value);
    }
  }, [options]);
  return /*#__PURE__*/React__default__default__default__default.createElement(FormControl, {
    error: isError,
    required: required,
    variant: noBorder ? "standard" : "outlined"
  }, /*#__PURE__*/React__default__default__default__default.createElement(InputLabel, {
    htmlFor: name
  }, label), /*#__PURE__*/React__default__default__default__default.createElement(Select, _extends({
    id: name,
    MenuProps: {
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      getContentAnchorEl: null
    },
    value: value
  }, props, {
    onChange: handleChange,
    disabled: disabled
  }), !disableEmpty && /*#__PURE__*/React__default__default__default__default.createElement(MenuItem, {
    value: ""
  }, "- ", t$5("unselected"), " -"), options.map(function (item) {
    return /*#__PURE__*/React__default__default__default__default.createElement(MenuItem, {
      key: item.value,
      disabled: item.disabled ? true : false,
      value: item.value
    }, item.label);
  })), errorMessage && /*#__PURE__*/React__default__default__default__default.createElement(FormHelperText$1, null, errorMessage));
};
function FormSelect(props) {
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var name = props.name,
    label = props.label,
    _props$autoSelectFirs = props.autoSelectFirst,
    autoSelectFirst = _props$autoSelectFirs === void 0 ? false : _props$autoSelectFirs,
    _props$required = props.required,
    required = _props$required === void 0 ? true : _props$required,
    _props$disableEmpty = props.disableEmpty,
    disableEmpty = _props$disableEmpty === void 0 ? false : _props$disableEmpty;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "Select"
  }, /*#__PURE__*/React__default__default__default__default.createElement(Controller, _extends({
    as: MuiSelect,
    control: control,
    name: name,
    label: label,
    autoSelectFirst: autoSelectFirst,
    required: required,
    rules: {
      required: required
    },
    InputLabelProps: {
      className: required ? "required-label" : "",
      required: required || false
    },
    defaultValue: "",
    disableEmpty: disableEmpty
  }, props)));
}

var _excluded$2 = ["label"];
var SelectBox = function SelectBox(_ref) {
  var label = _ref.label,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  var _useState = useState(false),
    focus = _useState[0],
    setFocus = _useState[1];
  var handleFocus = function handleFocus() {
    setFocus(true);
  };
  var handleBlur = function handleBlur() {
    setFocus(false);
  };
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "SelectBox " + (focus ? "SelectBox--focus" : "")
  }, /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "SelectBox__label"
  }, label), /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "SelectBox__select"
  }, /*#__PURE__*/React__default__default__default__default.createElement(MuiSelect, _extends({
    autoSelectFirst: true,
    onFocus: handleFocus,
    onBlur: handleBlur,
    noBorder: true
  }, props))));
};

var MuiSelect$1 = function MuiSelect(props) {
  var label = props.label,
    name = props.name,
    required = props.required,
    errorobj = props.errorobj,
    options = props.options,
    noBorder = props.noBorder,
    autoSelectFirst = props.autoSelectFirst,
    onSelectChange = props.onSelectChange,
    disabled = props.disabled,
    disableEmpty = props.disableEmpty;
  var _useState = useState(),
    value = _useState[0],
    setValue = _useState[1];
  var isError = false;
  var errorMessage = "";
  if (errorobj && errorobj.hasOwnProperty(name)) {
    isError = true;
    errorMessage = errorobj[name].message || "Campo requerido";
  }
  var handleChange = function handleChange(a, b, c, d) {
    props.onChange(a, b, c, d);
    setValue(a.target.value);
    onSelectChange && onSelectChange(a.target.value);
  };
  useEffect(function () {
    if (autoSelectFirst) {
      setValue(options[0].value);
    }
  }, [options]);
  return /*#__PURE__*/React__default__default__default__default.createElement(FormControl, {
    error: isError,
    required: required,
    variant: noBorder ? "standard" : "outlined"
  }, /*#__PURE__*/React__default__default__default__default.createElement(InputLabel, {
    htmlFor: name
  }, label), /*#__PURE__*/React__default__default__default__default.createElement(Select, _extends({
    id: name,
    MenuProps: {
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      getContentAnchorEl: null
    },
    value: value
  }, props, {
    onChange: handleChange,
    disabled: disabled
  }), !disableEmpty && /*#__PURE__*/React__default__default__default__default.createElement(MenuItem, {
    value: ""
  }, "- ", t$5("unselected"), " -"), options.map(function (item) {
    return /*#__PURE__*/React__default__default__default__default.createElement(MenuItem, {
      key: item.value,
      disabled: item.disabled ? true : false,
      value: item.value
    }, item.label);
  })), errorMessage && /*#__PURE__*/React__default__default__default__default.createElement(FormHelperText$1, null, errorMessage));
};
function MultiSelect(props) {
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var name = props.name,
    label = props.label,
    _props$autoSelectFirs = props.autoSelectFirst,
    autoSelectFirst = _props$autoSelectFirs === void 0 ? false : _props$autoSelectFirs,
    _props$required = props.required,
    required = _props$required === void 0 ? true : _props$required,
    _props$disableEmpty = props.disableEmpty,
    disableEmpty = _props$disableEmpty === void 0 ? false : _props$disableEmpty;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "Select"
  }, /*#__PURE__*/React__default__default__default__default.createElement(Controller, _extends({
    as: MuiSelect$1,
    control: control,
    name: name,
    label: label,
    autoSelectFirst: autoSelectFirst,
    required: required,
    rules: {
      required: required
    },
    InputLabelProps: {
      className: required ? "required-label" : "",
      required: required || false
    },
    defaultValue: [],
    multiple: true,
    disableEmpty: disableEmpty
  }, props)));
}

var _excluded$7 = ["classes"],
  _excluded2 = ["name", "className"];
var IOSSwitch$4 = withStyles(function (theme) {
  return {
    root: {
      width: 30,
      height: 16,
      padding: 0,
      margin: 0
    },
    switchBase: {
      padding: 1,
      "&$checked": {
        transform: "translateX(14px)",
        color: theme.palette.common.white,
        "& + $track": {
          backgroundColor: "#ec754a",
          opacity: 1,
          border: "none"
        }
      },
      "&$focusVisible $thumb": {
        color: "#52d869",
        border: "6px solid #fff"
      }
    },
    thumb: {
      width: 14,
      height: 14
    },
    track: {
      borderRadius: 26 / 2,
      border: "1px solid #c7c7c7",
      backgroundColor: "#c7c7c7",
      opacity: 1,
      transition: theme.transitions.create(["background-color", "border"])
    },
    checked: {},
    focusVisible: {}
  };
})(function (_ref) {
  var classes = _ref.classes,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  var handleChange = function handleChange(e) {
    var value = e.target.checked;
    props.onChange(value);
  };
  return /*#__PURE__*/React__default__default__default__default.createElement(Switch, _extends({
    focusVisibleClassName: classes.focusVisible,
    disableRipple: true,
    classes: {
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked
    }
  }, props, {
    checked: !!props.value,
    onChange: handleChange
  }));
});
var SwitchChip = function SwitchChip(_ref2) {
  var name = _ref2.name,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? "" : _ref2$className,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "SwitchInput SwitchChip " + className
  }, /*#__PURE__*/React__default__default__default__default.createElement(IOSSwitch$4, _extends({
    name: name
  }, props)));
};
var SwitchInput = function SwitchInput(props) {
  var name = props.name;
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "SwitchInput"
  }, /*#__PURE__*/React__default__default__default__default.createElement(Controller, _extends({
    as: IOSSwitch$4,
    name: name,
    control: control
  }, props)));
};

var useStyles$4 = makeStyles({
  root: {
    width: "100%",
    height: "100%"
  },
  container: {
    height: "calc(100% - 48px)",
    scrollbarWidth: "thin"
  }
});
var StickyHeadTable = function StickyHeadTable(_ref) {
  var totalDocs = _ref.totalDocs,
    rows = _ref.rows,
    columns = _ref.columns,
    page = _ref.page,
    pageSize = _ref.pageSize,
    sortable = _ref.sortable,
    orderBy = _ref.orderBy,
    onSort = _ref.onSort,
    onChangePage = _ref.onChangePage,
    onChangePageSize = _ref.onChangePageSize,
    _onDoubleClick = _ref.onDoubleClick,
    _ref$labelRowsPerPage = _ref.labelRowsPerPage,
    labelRowsPerPage = _ref$labelRowsPerPage === void 0 ? "Filas por página" : _ref$labelRowsPerPage,
    _ref$labelDisplayedRo = _ref.labelDisplayedRows,
    _labelDisplayedRows = _ref$labelDisplayedRo === void 0 ? "de" : _ref$labelDisplayedRo;
  var classes = useStyles$4();
  var totalPages = Math.floor(totalDocs / pageSize) + (totalDocs % pageSize > 0 ? 1 : 0);
  var TablePaginationActions = function TablePaginationActions() {
    var handleFirstPageButtonClick = function handleFirstPageButtonClick() {
      onChangePage(1);
    };
    var handleBackPageButtonClick = function handleBackPageButtonClick() {
      onChangePage(page - 1);
    };
    var handleNextPageButtonClick = function handleNextPageButtonClick() {
      onChangePage(page + 1);
    };
    var handleLastPageButtonClick = function handleLastPageButtonClick() {
      onChangePage(totalPages);
    };
    return /*#__PURE__*/React__default__default__default__default.createElement(Box, null, /*#__PURE__*/React__default__default__default__default.createElement(IconButton$1, {
      onClick: handleFirstPageButtonClick,
      disabled: page === 1
    }, /*#__PURE__*/React__default__default__default__default.createElement(FirstPage, null)), /*#__PURE__*/React__default__default__default__default.createElement(IconButton$1, {
      onClick: handleBackPageButtonClick,
      disabled: page === 1
    }, /*#__PURE__*/React__default__default__default__default.createElement(KeyboardArrowLeft, null)), /*#__PURE__*/React__default__default__default__default.createElement(IconButton$1, {
      onClick: handleNextPageButtonClick,
      disabled: page >= totalPages
    }, /*#__PURE__*/React__default__default__default__default.createElement(KeyboardArrowRight, null)), /*#__PURE__*/React__default__default__default__default.createElement(IconButton$1, {
      onClick: handleLastPageButtonClick,
      disabled: page >= totalPages
    }, /*#__PURE__*/React__default__default__default__default.createElement(LastPage, null)));
  };
  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    onChangePageSize(event.target.value);
  };
  return /*#__PURE__*/React__default__default__default__default.createElement(Paper, {
    className: classes.root + " cTable"
  }, /*#__PURE__*/React__default__default__default__default.createElement(TableContainer, {
    className: classes.container
  }, /*#__PURE__*/React__default__default__default__default.createElement(Table, {
    stickyHeader: true,
    "aria-label": "sticky table"
  }, /*#__PURE__*/React__default__default__default__default.createElement(TableHead, null, /*#__PURE__*/React__default__default__default__default.createElement(TableRow, null, columns.map(function (column, index) {
    return /*#__PURE__*/React__default__default__default__default.createElement(TableCell, {
      key: index,
      className: column.className || "",
      align: column.align,
      style: {
        minWidth: column.minWidth,
        width: column.width,
        maxWidth: column.maxWidth
      }
    }, sortable && column.orderId && /*#__PURE__*/React__default__default__default__default.createElement(TableSortLabel, {
      active: !!orderBy[column.orderId],
      direction: orderBy[column.orderId],
      onClick: function onClick() {
        return onSort(column.orderId);
      }
    }, column.label) || column.label);
  }))), /*#__PURE__*/React__default__default__default__default.createElement(TableBody, null, rows.map(function (row, _idx) {
    return /*#__PURE__*/React__default__default__default__default.createElement(TableRow, {
      hover: true,
      role: "checkbox",
      tabIndex: -1,
      key: _idx,
      onDoubleClick: function onDoubleClick() {
        return _onDoubleClick(row);
      }
    }, columns.map(function (column, colIdx) {
      var value = row[column.id];
      return /*#__PURE__*/React__default__default__default__default.createElement(TableCell, {
        key: colIdx,
        className: column.className || "",
        align: column.align
      }, column.renderCell ? column.renderCell(value, row) : value);
    }));
  })))), /*#__PURE__*/React__default__default__default__default.createElement(TablePagination, {
    component: "div",
    count: totalDocs,
    page: page - 1,
    rowsPerPageOptions: [10, 25, 100],
    rowsPerPage: pageSize,
    ActionsComponent: TablePaginationActions,
    onRowsPerPageChange: function onRowsPerPageChange(rows) {
      return handleChangeRowsPerPage(rows);
    },
    labelRowsPerPage: labelRowsPerPage,
    labelDisplayedRows: function labelDisplayedRows(_ref2) {
      var from = _ref2.from,
        to = _ref2.to,
        count = _ref2.count;
      return from + "-" + to + " " + _labelDisplayedRows + " " + count;
    }
  }));
};

var Chip = function Chip(_ref) {
  var color = _ref.color,
    background = _ref.background,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? "" : _ref$width,
    _ref$hasInactiveColor = _ref.hasInactiveColor,
    hasInactiveColor = _ref$hasInactiveColor === void 0 ? false : _ref$hasInactiveColor,
    label = _ref.label,
    isActive = _ref.isActive,
    onChange = _ref.onChange;
  var style = {
    color: hasInactiveColor ? "rgba(" + color + ", 1)" : "rgba(102, 102, 102, 1)",
    "border-color": "rgba(0, 0, 0, 0.12)"
  };
  if (width) style = _extends({}, style, {
    width: width
  });
  if (isActive) {
    style["background"] = "rgba(" + (background ? background : color) + ", " + (background ? "1" : "0.1") + ")";
    style["color"] = "rgba(" + color + ", 1)";
    style["border-color"] = "transparent";
  }
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "Chip flex v-center h-center",
    onClick: function onClick() {
      return onChange(!isActive);
    },
    style: style
  }, label);
};

var _excluded$8 = ["legend", "name", "items", "value", "required", "disabled", "onChange"];
var RadioGroupRow = function RadioGroupRow(_ref) {
  var legend = _ref.legend,
    name = _ref.name,
    items = _ref.items,
    value = _ref.value,
    required = _ref.required,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onChange = _ref.onChange,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  var _useState = useState(value || null),
    option = _useState[0],
    setOption = _useState[1];
  var getItemValue = function getItemValue(item) {
    var val = Object.keys(item)[0];
    return item[val];
  };
  var getItemLabel = function getItemLabel(item) {
    var lbl = Object.keys(item)[1];
    return item[lbl];
  };
  var handleChange = function handleChange(evnt) {
    setOption(evnt.target.value);
    onChange(evnt.target.value);
  };
  return /*#__PURE__*/React__default__default__default__default.createElement(FormControl$1, {
    component: "fieldset",
    className: "RadioGroupWrapper"
  }, /*#__PURE__*/React__default__default__default__default.createElement(FormLabel, {
    className: "RadioGroupLabel",
    component: "legend"
  }, legend), /*#__PURE__*/React__default__default__default__default.createElement(RadioGroup, {
    className: "RadioGroup",
    row: true,
    name: name,
    value: option,
    onChange: function onChange(evnt) {
      return handleChange(evnt);
    }
  }, items.map(function (item) {
    return /*#__PURE__*/React__default__default__default__default.createElement(FormControlLabel$1, {
      className: "RadioItemLabel",
      value: getItemValue(item),
      control: /*#__PURE__*/React__default__default__default__default.createElement(Radio, {
        className: "RadioItemButton",
        required: required
      }),
      label: getItemLabel(item),
      disabled: disabled
    });
  })));
};

var PageWrapper = function PageWrapper(_ref) {
  var id = _ref.id,
    hide = _ref.hide,
    _ref$renderFromDashbo = _ref.renderFromDashboard,
    renderFromDashboard = _ref$renderFromDashbo === void 0 ? false : _ref$renderFromDashbo,
    children = _ref.children;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    id: id,
    className: "PageWrapper " + (hide === true ? "hide" : "")
  }, /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "FullPagePanel flex column " + (renderFromDashboard ? "renderFromDashboard" : "")
  }, children));
};

var _g;
function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
function SvgArrowBack(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/createElement("path", {
    fill: "#666",
    fillRule: "nonzero",
    d: "M10.5 4L3 12l7.5 8 1.5-1.6-4.878-5.2H21v-2.4H7.128L12 5.6z"
  }))));
}

var PageHeader = function PageHeader(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    goBack = _ref.goBack,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? "" : _ref$title,
    _ref$filters = _ref.filters,
    filters = _ref$filters === void 0 ? "" : _ref$filters,
    _ref$actions = _ref.actions,
    actions = _ref$actions === void 0 ? "" : _ref$actions,
    _ref$info = _ref.info,
    info = _ref$info === void 0 ? "" : _ref$info,
    children = _ref.children;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "PageHeader " + className + " flex between v-center"
  }, /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "flex start v-center"
  }, goBack && /*#__PURE__*/React__default__default__default__default.createElement(SvgArrowBack, {
    className: "PageHeader__goBack",
    onClick: goBack
  }), title && /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "PageHeader__title"
  }, title), filters && /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "PageHeader__filters"
  }, filters)), children && children, actions && /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "PageHeader__actions flex end v-center"
  }, actions), info && /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "PageHeader__info flex end v-center"
  }, info));
};

var PageBody = function PageBody(_ref) {
  var id = _ref.id,
    className = _ref.className,
    style = _ref.style,
    children = _ref.children;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    id: id || "",
    className: "PageBody " + (className || "") + " flex h-center\"",
    style: style || {}
  }, children);
};

var CardRowWrapper = function CardRowWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "CardRowWrapper flex row"
  }, children);
};

var Card = function Card(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "Card flex"
  }, children);
};

var CardColumnIcon = function CardColumnIcon(_ref) {
  var title = _ref.title,
    titleClass = _ref.titleClass,
    icon = _ref.icon,
    iconLabel = _ref.iconLabel,
    info = _ref.info,
    justify = _ref.justify;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "CardColumnIcon flex column " + (justify ? justify : "between")
  }, /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "CardColumnIcon__title " + (titleClass ? titleClass : "")
  }, title), /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "CardColumnIcon__icon flex v-center h-center"
  }, /*#__PURE__*/React__default__default__default__default.createElement("div", null, /*#__PURE__*/React__default__default__default__default.createElement("img", {
    src: icon
  }), iconLabel && /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "CardColumnIcon__icon__label"
  }, iconLabel), info && /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "CardColumnIcon__info"
  }, info))));
};

var CardColumnTable = function CardColumnTable(_ref) {
  var tableData = _ref.tableData,
    getColumns = _ref.getColumns;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "CardColumnTable flex column"
  }, /*#__PURE__*/React__default__default__default__default.createElement(StickyHeadTable$1, {
    totalDocs: tableData.length,
    rows: tableData || [],
    columns: getColumns({
      t: t
    }),
    page: 1,
    pageSize: tableData.length
  }));
};

var CardColumnText = function CardColumnText(_ref) {
  var justify = _ref.justify,
    children = _ref.children;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "CardColumnText flex column " + (justify ? justify : "h-center")
  }, children);
};

var ModalWindow = function ModalWindow(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    title = _ref.title,
    text = _ref.text,
    _ref$textBold = _ref.textBold,
    textBold = _ref$textBold === void 0 ? false : _ref$textBold,
    _ref$aditionalText = _ref.aditionalText,
    aditionalText = _ref$aditionalText === void 0 ? null : _ref$aditionalText,
    _ref$onClickModal = _ref.onClickModal,
    onClickModal = _ref$onClickModal === void 0 ? function () {} : _ref$onClickModal,
    cancelLabel = _ref.cancelLabel,
    _ref$handleCancel = _ref.handleCancel,
    handleCancel = _ref$handleCancel === void 0 ? false : _ref$handleCancel,
    acceptLabel = _ref.acceptLabel,
    _ref$handleAccept = _ref.handleAccept,
    handleAccept = _ref$handleAccept === void 0 ? false : _ref$handleAccept,
    _ref$isAcceptDisabled = _ref.isAcceptDisabled,
    isAcceptDisabled = _ref$isAcceptDisabled === void 0 ? false : _ref$isAcceptDisabled,
    _ref$modalWidth = _ref.modalWidth,
    modalWidth = _ref$modalWidth === void 0 ? 347 : _ref$modalWidth,
    children = _ref.children;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "ModalWindow " + className + " " + (!cancelLabel ? "cancelBtnDisabled" : ""),
    onClick: function onClick(evnt) {
      onClickModal();
    }
  }, /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "ModalWindow__box ",
    style: {
      width: modalWidth + "px"
    },
    onClick: function onClick(evnt) {
      evnt.stopPropagation();
    }
  }, /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "ModalWindow__title"
  }, title), /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "ModalWindow__text" + (textBold ? " Bold" : "")
  }, text), aditionalText && /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "ModalWindow__text"
  }, aditionalText) || false, children, /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "ModalWindow__actions flex end v-center"
  }, handleCancel && /*#__PURE__*/React__default__default__default__default.createElement(Button$1, {
    variant: "secondary",
    onClick: handleCancel
  }, cancelLabel), /*#__PURE__*/React__default__default__default__default.createElement(Button$1, {
    onClick: handleAccept,
    disabled: isAcceptDisabled
  }, acceptLabel))));
};

var Panel = function Panel(_ref) {
  var t = _ref.t,
    entity = _ref.entity,
    action = _ref.action,
    btnLabel = _ref.btnLabel,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    children = _ref.children;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "Panel"
  }, /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "Panel__header"
  }, /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "Panel__header__title"
  }, t(entity + "." + action + "Title")), /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "Panel__header__actions"
  }, /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "Panel__header__description"
  }, t(entity + "." + action + "Text"), /*#__PURE__*/React__default__default__default__default.createElement("br", null), t("fieldsRequired")), /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "Panel__header__submit"
  }, /*#__PURE__*/React__default__default__default__default.createElement(Button$1, {
    onClick: onClick,
    disabled: disabled
  }, t("" + btnLabel))))), /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "Panel__body"
  }, children));
};

var List = function List(_ref) {
  var t = _ref.t,
    id = _ref.id,
    _ref$hide = _ref.hide,
    hide = _ref$hide === void 0 ? false : _ref$hide,
    totalDocs = _ref.totalDocs,
    title = _ref.title,
    headerFilters = _ref.headerFilters,
    headerActions = _ref.headerActions,
    list = _ref.list,
    columns = _ref.columns,
    pageData = _ref.pageData,
    pageActions = _ref.pageActions,
    params = _ref.params;
  var page = pageData.page,
    limit = pageData.limit;
  var onChangePage = pageActions.onChangePage,
    onChangePageSize = pageActions.onChangePageSize,
    onDoubleClick = pageActions.onDoubleClick;
  var orderBy = params.orderBy,
    onSort = params.onSort;
  return /*#__PURE__*/React__default__default__default__default.createElement(PageWrapper$1, {
    id: id,
    hide: hide
  }, /*#__PURE__*/React__default__default__default__default.createElement(PageHeader$1, {
    className: "ListHeader",
    title: title,
    filters: headerFilters || "",
    actions: headerActions || ""
  }), /*#__PURE__*/React__default__default__default__default.createElement(PageBody$1, {
    className: "ListBody"
  }, /*#__PURE__*/React__default__default__default__default.createElement(StickyHeadTable$1, {
    totalDocs: totalDocs || 0,
    rows: list || [],
    columns: columns,
    page: page,
    pageSize: limit,
    onChangePage: !!onChangePage ? onChangePage : function () {},
    onChangePageSize: !!onChangePageSize ? onChangePageSize : function () {},
    onDoubleClick: !!onDoubleClick ? onDoubleClick : function () {},
    sortable: !!orderBy,
    orderBy: !!orderBy ? orderBy : function () {},
    onSort: !!onSort ? onSort : function () {},
    labelRowsPerPage: t("rowsPerPage"),
    labelDisplayedRows: t("of")
  })));
};

var ChartMongoDB = function ChartMongoDB(_ref) {
  var token = _ref.token,
    baseUrl = _ref.baseUrl,
    chartId = _ref.chartId,
    filter = _ref.filter,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? "light" : _ref$theme,
    _ref$showAttribution = _ref.showAttribution,
    showAttribution = _ref$showAttribution === void 0 ? false : _ref$showAttribution,
    onChartLoaded = _ref.onChartLoaded,
    onChartRendered = _ref.onChartRendered;
  var sdk = new ChartsEmbedSDK({
    baseUrl: baseUrl
  });
  var chartDiv = useRef(null);
  var getUserToken = function getUserToken() {
    return token;
  };
  var _useState = useState(sdk.createChart({
      chartId: chartId,
      getUserToken: getUserToken,
      filter: filter,
      theme: theme,
      showAttribution: showAttribution
    })),
    chart = _useState[0];
  useEffect(function () {
    if (chart) onChartLoaded();
    chart.render(chartDiv.current).then(function () {
      return onChartRendered(chart);
    })["catch"](function (err) {
      return console.log("Error during Charts rendering.", err);
    });
  }, [chart]);
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "chartMongoDB",
    ref: chartDiv
  });
};

registerLocale("es", es$2$1$1$1$1);
var DateFilter = function DateFilter(_ref) {
  var t = _ref.t,
    defaultStartDate = _ref.defaultStartDate,
    defaultEndDate = _ref.defaultEndDate,
    defaultOption = _ref.defaultOption,
    onApply = _ref.onApply;
  var today = new Date();
  var _useState = useState(defaultStartDate),
    startDate = _useState[0],
    setStartDate = _useState[1];
  var _useState2 = useState(defaultEndDate),
    endDate = _useState2[0],
    setEndDate = _useState2[1];
  var _useState3 = useState([{
      id: "today",
      label: t("calendar.today"),
      selected: false
    }, {
      id: "yesterday",
      label: t("calendar.yesterday"),
      selected: false
    }, {
      id: "thisWeek",
      label: t("calendar.thisWeek"),
      selected: false
    }, {
      id: "last7Days",
      label: t("calendar.last7Days"),
      selected: false
    }, {
      id: "pastWeek",
      label: t("calendar.pastWeek"),
      selected: false
    }, {
      id: "thisMonth",
      label: t("calendar.thisMonth"),
      selected: false
    }, {
      id: "last30Days",
      label: t("calendar.last30Days"),
      selected: false
    }, {
      id: "pastMonth",
      label: t("calendar.pastMonth"),
      selected: false
    }, {
      id: "thisYear",
      label: t("calendar.thisYear"),
      selected: false
    }, {
      id: "lastYear",
      label: t("calendar.lastYear"),
      selected: false
    }]),
    dateOptionList = _useState3[0],
    setDateOptionList = _useState3[1];
  var _useState4 = useState(defaultOption),
    currentOption = _useState4[0],
    setCurrentOption = _useState4[1];
  var _useState5 = useState(defaultOption ? false : true),
    isOnCustomSelection = _useState5[0],
    setIsOnCustomSelection = _useState5[1];
  var _useState6 = useState(true),
    applyFilterBtnDisabled = _useState6[0],
    setApplyFilterBtnDisabled = _useState6[1];
  var resetOptionList = function resetOptionList() {
    setDateOptionList(dateOptionList.map(function (dateOption) {
      return _extends({}, dateOption, {
        selected: false
      });
    }));
    setCurrentOption(null);
  };
  var setDates = function setDates(start, end) {
    var d1 = start;
    var d2 = _.isNull(end) ? null : end;
    setStartDate(d1);
    setEndDate(d2);
    if (_.isEqual(startOfDay(d1), defaultStartDate) && _.isEqual(endOfDay(d2), defaultEndDate)) setApplyFilterBtnDisabled(true);else setApplyFilterBtnDisabled(false);
  };
  var handleChangeOption = function handleChangeOption(index) {
    setIsOnCustomSelection(false);
    var selectedOption = dateOptionList[index];
    setCurrentOption(selectedOption.id);
    setDateOptionList(dateOptionList.map(function (dateOption) {
      return _extends({}, dateOption, {
        selected: dateOption.id === selectedOption.id
      });
    }));
    switch (selectedOption.id) {
      case "today":
        setDates(today, today);
        break;
      case "yesterday":
        var yesterday = sub(today, {
          days: 1
        });
        setDates(yesterday, yesterday);
        break;
      case "thisWeek":
        var thisWeekStart = startOfISOWeek(today);
        setDates(thisWeekStart, today);
        break;
      case "last7Days":
        setDates(sub(today, {
          days: 6
        }), today);
        break;
      case "pastWeek":
        var pastWeek = sub(today, {
          days: 6
        });
        var pastWeekStart = startOfISOWeek(pastWeek);
        var pastWeekEnd = endOfISOWeek(pastWeek);
        setDates(pastWeekStart, pastWeekEnd);
        break;
      case "thisMonth":
        var thisMonthStart = startOfMonth(today);
        setDates(thisMonthStart, today);
        break;
      case "last30Days":
        setDates(sub(today, {
          days: 29
        }), today);
        break;
      case "pastMonth":
        var pastMonth = sub(today, {
          months: 1
        });
        var pastMonthStart = startOfMonth(pastMonth);
        var pastMonthEnd = endOfMonth(pastMonth);
        setDates(pastMonthStart, pastMonthEnd);
        break;
      case "thisYear":
        var thisYearStart = startOfYear(today);
        setDates(thisYearStart, today);
        break;
      case "lastYear":
        setDates(sub(today, {
          years: 1
        }), today);
        break;
    }
  };
  var onChange = function onChange(dates) {
    var start = dates[0],
      end = dates[1];
    if (_.isNull(end)) {
      resetOptionList();
      setIsOnCustomSelection(true);
      setApplyFilterBtnDisabled(false);
    }
    setDates(start, end);
  };
  useEffect(function () {
    if (currentOption === defaultOption) setApplyFilterBtnDisabled(true);
  }, [currentOption]);
  useEffect(function () {
    if (defaultOption) {
      setApplyFilterBtnDisabled(true);
      var optionIndex = dateOptionList.findIndex(function (dateOptionItem) {
        return dateOptionItem.id === defaultOption;
      });
      if (optionIndex >= 0) handleChangeOption(optionIndex);
    }
  }, []);
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    id: "DateFilter",
    className: "flex row between"
  }, /*#__PURE__*/React__default__default__default__default.createElement("ul", {
    className: "DateFilterOptions flex column between"
  }, dateOptionList && dateOptionList.map(function (option, index) {
    return /*#__PURE__*/React__default__default__default__default.createElement("li", {
      key: option.id,
      id: option.id,
      className: option.selected ? "selected" : "",
      onClick: function onClick() {
        return handleChangeOption(index);
      }
    }, option.label);
  })), /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "DateFilterCalendarAndButton flex column between"
  }, /*#__PURE__*/React__default__default__default__default.createElement(DatePicker, {
    isClearable: true,
    disabledKeyboardNavigation: true,
    selected: isOnCustomSelection ? startDate : endDate,
    startDate: startDate,
    endDate: endDate,
    maxDate: endOfDay(today),
    selectsRange: true,
    inline: true,
    locale: "es",
    onChange: onChange
  }), /*#__PURE__*/React__default__default__default__default.createElement(Button$1, {
    onClick: function onClick() {
      return onApply(startDate, endDate, currentOption);
    },
    disabled: applyFilterBtnDisabled
  }, /*#__PURE__*/React__default__default__default__default.createElement("span", null, t("apply")))));
};

var Spinner = function Spinner() {
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "Spinner flex h-center v-center"
  }, /*#__PURE__*/React__default__default__default__default.createElement("img", {
    className: "Spinner__image",
    src: loader,
    alt: ""
  }));
};

var options = {
  defaultFontSize: 9,
  scales: {
    yAxes: [{
      ticks: {
        beginAtZero: true,
        fontSize: 9,
        fontWeight: 600,
        fontFamily: "open Sans",
        fontColor: "#999999",
        padding: 6,
        precision: 0
      },
      gridLines: {
        tickMarkLength: 40,
        offsetGridLines: false,
        display: true,
        drawTicks: false,
        drawOnChartArea: true
      }
    }],
    xAxes: [{
      ticks: {
        fontSize: 9,
        fontWeight: 600,
        fontFamily: "open Sans",
        fontColor: "#999999",
        padding: 4
      },
      barThickness: 24,
      gridLines: false
    }]
  },
  showAllTooltips: true
};
var BarChart = function BarChart(_ref) {
  var dataset = _ref.dataset,
    labels = _ref.labels;
  var data = {
    datasets: [dataset],
    labels: labels
  };
  return /*#__PURE__*/React__default__default__default__default.createElement(es_8, {
    data: data,
    options: options,
    legend: false,
    height: 110,
    width: 600
  });
};

var SwitchBox = function SwitchBox(props) {
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "SwitchBox flex v-center between"
  }, /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "SwitchBox__label"
  }, props.label), /*#__PURE__*/React__default__default__default__default.createElement(SwitchChip, props));
};

var TimelineChart = function TimelineChart(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React__default__default__default__default.createElement(React__default__default__default__default.Fragment, null, /*#__PURE__*/React__default__default__default__default.createElement(Timeline, null, data.map(function (item, index) {
    return /*#__PURE__*/React__default__default__default__default.createElement(TimelineItem, {
      key: index
    }, /*#__PURE__*/React__default__default__default__default.createElement(TimelineOppositeContent, null, /*#__PURE__*/React__default__default__default__default.createElement(Typography, {
      color: "textSecondary"
    }, item.left)), /*#__PURE__*/React__default__default__default__default.createElement(TimelineSeparator, null, /*#__PURE__*/React__default__default__default__default.createElement(TimelineDot, {
      className: "TimelineChart__dot TimelineChart__dot--" + item.color
    }), index !== data.length - 1 && /*#__PURE__*/React__default__default__default__default.createElement(TimelineConnector, null)), /*#__PURE__*/React__default__default__default__default.createElement(TimelineContent, null, /*#__PURE__*/React__default__default__default__default.createElement(Typography, null, item.right, " ", item.coordinates && /*#__PURE__*/React__default__default__default__default.createElement("a", {
      href: "https://www.google.com/maps/place/" + item.coordinates[0] + "," + item.coordinates[1],
      target: "_blank"
    }, /*#__PURE__*/React__default__default__default__default.createElement("img", {
      src: "assets/icons/open-map.svg"
    })))));
  })));
};

var CardColumnForm = function CardColumnForm(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default__default__default__default.createElement("div", {
    className: "CardColumnForm flex column between v-center}"
  }, children);
};

var formatDatetime = function formatDatetime(dt, format) {
  if (format === void 0) {
    format = "medium";
  }
  var date = new Date(dt);
  switch (format) {
    case "short":
      if (isToday(date)) {
        return lightFormat(date, "HH:mm");
      }
      if (isYesterday(date)) {
        return t$5("yesterday") + " " + lightFormat(date, "HH:mm");
      }
      return lightFormat(date, "dd/MM/yy HH:mm");
    case "shortToday":
      if (isToday(date)) {
        return t$5("today") + " " + lightFormat(date, "HH:mm");
      }
      if (isYesterday(date)) {
        return t$5("yesterday") + " " + lightFormat(date, "HH:mm");
      }
      return lightFormat(date, "dd/MM/yy HH:mm");
    case "shortTodayNoYear":
      if (isToday(date)) {
        return t$5("today") + " " + lightFormat(date, "HH:mm");
      }
      if (isYesterday(date)) {
        return t$5("yesterday") + " " + lightFormat(date, "HH:mm");
      }
      return lightFormat(date, "dd/MM HH:mm");
    case "medium":
      return lightFormat(date, "dd/MM/yy HH:mm");
    case "long":
      return lightFormat(date, "dd/MM/yyyy HH:mm");
    case "api":
      return lightFormat(date, "yyyy-MM-dd HH:mm");
    default:
      return "";
  }
};

var parseIntAmount = function parseIntAmount(amount, currency) {
  var locale = currency.locale,
    code = currency.code;
  var options = {
    currency: code,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  };
  var formattedAmount = amount.toLocaleString(locale, options);
  return "" + formattedAmount;
};
var parseFloatAmount = function parseFloatAmount(amountToConvert, currency) {
  var amount = amountToConvert || 0;
  if (typeof amount === "string") {
    amount = Number(amount.replace(",", "."));
  }
  var locale = currency.locale,
    code = currency.code;
  var options = {
    currency: code,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  };
  var formattedAmount = amount.toLocaleString(locale, options);
  return "" + formattedAmount;
};
var parseStylishFloatAmount = function parseStylishFloatAmount(amount, currency, adicTxt) {
  if (adicTxt === void 0) {
    adicTxt = "";
  }
  var locale = currency.locale,
    code = currency.code;
  var options = {
    currency: code,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  };
  var formattedAmount = amount.toLocaleString(locale, options);
  var integer = formattedAmount.substring(0, formattedAmount.length - 3);
  var decimal = formattedAmount.slice(-3);
  return /*#__PURE__*/React__default__default__default__default.createElement(Fragment$2, null, integer, /*#__PURE__*/React__default__default__default__default.createElement("span", {
    className: "small-data"
  }, decimal, adicTxt));
};
var parseCurrency = function parseCurrency(amount, currency, nextToAmount) {
  if (nextToAmount === void 0) {
    nextToAmount = false;
  }
  var locale = currency.locale,
    code = currency.code,
    symbol = currency.symbol;
  var options = {
    currency: code,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  };
  var formattedAmount = amount ? amount.toLocaleString(locale, options) : Number(0).toLocaleString(locale, options);
  var amountStr = formattedAmount + " " + symbol;
  if (nextToAmount) amountStr = amountStr.replace(/\s/g, "");
  return amountStr;
};
var parseFloatRounded = function parseFloatRounded(amount, decimalSeparator) {
  var truncAmount = Math.trunc(amount);
  if (amount === truncAmount) return amount.toString();
  return amount.toFixed(2).replace(".", decimalSeparator);
};
var parseStylishCurrency = function parseStylishCurrency(amount, currency) {
  var locale = currency.locale,
    code = currency.code,
    symbol = currency.symbol;
  var options = {
    currency: code,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  };
  var formattedAmount = amount.toLocaleString(locale, options);
  var integer = formattedAmount.substring(0, formattedAmount.length - 3);
  var decimal = formattedAmount.slice(-3);
  return /*#__PURE__*/React__default__default__default__default.createElement(Fragment$2, null, integer, /*#__PURE__*/React__default__default__default__default.createElement("span", null, decimal, " ", symbol));
};
var roundFloat2Dec = function roundFloat2Dec(floatNumber) {
  var result = Math.round(Math.round(floatNumber * 10000) / 100) / 100;
  return result;
};

var getServiceStatusAvatar = function getServiceStatusAvatar(serviceStatus) {
  return t$5("serviceStatus." + serviceStatus.toLowerCase() + "Avatar");
};

var getTicketStatusAvatar = function getTicketStatusAvatar(ticketStatus) {
  return t$5("ticketStatus." + ticketStatus.toLowerCase() + "Avatar");
};

var validateStringAmount = function validateStringAmount(strAmount, strPrevAmount, decimals, maxNum, decimalSeparator) {
  if (decimals === void 0) {
    decimals = 2;
  }
  if (maxNum === void 0) {
    maxNum = null;
  }
  if (decimalSeparator === void 0) {
    decimalSeparator = ",";
  }
  var thousandSeparator = decimalSeparator === "," ? "." : ",";
  if (strAmount.length < strPrevAmount.length) return strAmount;
  if (strAmount.indexOf(thousandSeparator) !== -1) return strPrevAmount;
  if (decimals === 0 && strAmount.indexOf(decimalSeparator) !== -1) return strPrevAmount;
  if (decimals !== 0 && strAmount === decimalSeparator) return "0" + decimalSeparator;
  var strNum = strAmount.replace(decimalSeparator, ".").trim();
  var num = Number(strNum);
  if (isNaN$1(num)) return strPrevAmount;
  if (!isNull(maxNum) && num > maxNum) return strPrevAmount;
  if (decimals === 0) return strAmount.trim();
  var dpi = strNum.indexOf(".");
  if (dpi === -1) return strAmount;
  if (strNum.length - dpi - 1 > decimals) return strPrevAmount;
  return strAmount;
};

export { BarChart, Button, Card, CardColumnForm, CardColumnIcon, CardColumnTable, CardColumnText, CardRowWrapper, ChartMongoDB, CheckboxInput, Chip, CircleChart, DateFilter, FileInput, Input, List, ModalWindow, MultiSelect, NumberInput, PageBody, PageHeader, PageWrapper, Panel, Password, PhoneInput, PlacesInput, RadioGroupRow, SearchInput, FormSelect as Select, SelectBox, Spinner, SwitchBox, SwitchChip, SwitchInput, StickyHeadTable as Table, TimelineChart, es, formatDatetime, getServiceStatusAvatar, getTicketStatusAvatar, parseCurrency, parseFloatAmount, parseFloatRounded, parseIntAmount, parseStylishCurrency, parseStylishFloatAmount, roundFloat2Dec, validateStringAmount };
//# sourceMappingURL=index.modern.js.map
